/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(538);
	module.exports = __webpack_require__(485);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(40);
	var hide = __webpack_require__(33);
	var redefine = __webpack_require__(34);
	var ctx = __webpack_require__(51);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(171);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _alt = __webpack_require__(435);
	
	var _alt2 = _interopRequireDefault(_alt);
	
	// Stores
	
	var _storesAppStore = __webpack_require__(529);
	
	var _storesAppStore2 = _interopRequireDefault(_storesAppStore);
	
	var _storesTranslationsStore = __webpack_require__(536);
	
	var _storesTranslationsStore2 = _interopRequireDefault(_storesTranslationsStore);
	
	var _storesMediaStore = __webpack_require__(531);
	
	var _storesMediaStore2 = _interopRequireDefault(_storesMediaStore);
	
	var _storesModalStore = __webpack_require__(532);
	
	var _storesModalStore2 = _interopRequireDefault(_storesModalStore);
	
	var _storesBasketStore = __webpack_require__(530);
	
	var _storesBasketStore2 = _interopRequireDefault(_storesBasketStore);
	
	var _storesNotificationStore = __webpack_require__(533);
	
	var _storesNotificationStore2 = _interopRequireDefault(_storesNotificationStore);
	
	var _storesRequestStore = __webpack_require__(534);
	
	var _storesRequestStore2 = _interopRequireDefault(_storesRequestStore);
	
	var _storesShareStore = __webpack_require__(535);
	
	var _storesShareStore2 = _interopRequireDefault(_storesShareStore);
	
	// Actions
	
	var _actionsAppActions = __webpack_require__(440);
	
	var _actionsAppActions2 = _interopRequireDefault(_actionsAppActions);
	
	var _actionsTranslationsActions = __webpack_require__(447);
	
	var _actionsTranslationsActions2 = _interopRequireDefault(_actionsTranslationsActions);
	
	var _actionsMediaActions = __webpack_require__(442);
	
	var _actionsMediaActions2 = _interopRequireDefault(_actionsMediaActions);
	
	var _actionsModalActions = __webpack_require__(443);
	
	var _actionsModalActions2 = _interopRequireDefault(_actionsModalActions);
	
	var _actionsBasketActions = __webpack_require__(441);
	
	var _actionsBasketActions2 = _interopRequireDefault(_actionsBasketActions);
	
	var _actionsNotificationActions = __webpack_require__(444);
	
	var _actionsNotificationActions2 = _interopRequireDefault(_actionsNotificationActions);
	
	var _actionsRequestActions = __webpack_require__(445);
	
	var _actionsRequestActions2 = _interopRequireDefault(_actionsRequestActions);
	
	var _actionsShareActions = __webpack_require__(446);
	
	var _actionsShareActions2 = _interopRequireDefault(_actionsShareActions);
	
	var Flux = (function (_Alt) {
	    _inherits(Flux, _Alt);
	
	    function Flux() {
	        var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	        _classCallCheck(this, Flux);
	
	        _get(Object.getPrototypeOf(Flux.prototype), 'constructor', this).call(this, config);
	
	        // Register Actions
	        this.addActions('app', _actionsAppActions2['default']);
	        this.addActions('translations', _actionsTranslationsActions2['default']);
	        this.addActions('media', _actionsMediaActions2['default']);
	        this.addActions('modals', _actionsModalActions2['default']);
	        this.addActions('basket', _actionsBasketActions2['default']);
	        this.addActions('notifications', _actionsNotificationActions2['default']);
	        this.addActions('requests', _actionsRequestActions2['default']);
	        this.addActions('share', _actionsShareActions2['default']);
	
	        // Register Stores
	        this.addStore('app', _storesAppStore2['default']);
	        this.addStore('translations', _storesTranslationsStore2['default']);
	        this.addStore('media', _storesMediaStore2['default']);
	        this.addStore('modals', _storesModalStore2['default']);
	        this.addStore('basket', _storesBasketStore2['default']);
	        this.addStore('notifications', _storesNotificationStore2['default']);
	        this.addStore('requests', _storesRequestStore2['default']);
	        this.addStore('share', _storesShareStore2['default']);
	    }
	
	    // we export a new instance, we don't do this in the index because
	    // we don't really care about singletons and server-side-rendering
	    // when MSP decides to render js on the server, we have to revisit this
	
	    _createClass(Flux, [{
	        key: 't',
	        value: function t() {
	            var path = arguments.length <= 0 || arguments[0] === undefined ? false : arguments[0];
	
	            if (path) {
	                return this.stores.translations.getIntlMessage(path);
	            } else {
	                return this.stores.translations;
	            }
	        }
	    }, {
	        key: 'getAppConfig',
	        value: function getAppConfig() {
	            return this.stores.app.getState().config.toJS();
	        }
	    }]);
	
	    return Flux;
	})(_alt2['default']);
	
	exports['default'] = new Flux();
	module.exports = exports['default'];

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _guid = __webpack_require__(119);
	
	var Guid = _interopRequireWildcard(_guid);
	
	var _events = __webpack_require__(83);
	
	var Events = _interopRequireWildcard(_events);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _toTitleCase = __webpack_require__(120);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _mergeOptions = __webpack_require__(76);
	
	var _mergeOptions2 = _interopRequireDefault(_mergeOptions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * Player Component - Base class for all UI objects
	                                                                                                                                                           *
	                                                                                                                                                           * @file component.js
	                                                                                                                                                           */
	
	
	/**
	 * Base class for all UI Components.
	 * Components are UI objects which represent both a javascript object and an element
	 * in the DOM. They can be children of other components, and can have
	 * children themselves.
	 *
	 * Components can also use methods from {@link EventTarget}
	 */
	var Component = function () {
	
	  /**
	   * A callback that is called when a component is ready. Does not have any
	   * paramters and any callback value will be ignored.
	   *
	   * @callback Component~ReadyCallback
	   * @this Component
	   */
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   #
	   * @param {Object[]} [options.children]
	   *        An array of children objects to intialize this component with. Children objects have
	   *        a name property that will be used if more than one component of the same type needs to be
	   *        added.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        Function that gets called when the `Component` is ready.
	   */
	  function Component(player, options, ready) {
	    _classCallCheck(this, Component);
	
	    // The component might be the player itself and we can't pass `this` to super
	    if (!player && this.play) {
	      this.player_ = player = this; // eslint-disable-line
	    } else {
	      this.player_ = player;
	    }
	
	    // Make a copy of prototype.options_ to protect against overriding defaults
	    this.options_ = (0, _mergeOptions2['default'])({}, this.options_);
	
	    // Updated options with supplied options
	    options = this.options_ = (0, _mergeOptions2['default'])(this.options_, options);
	
	    // Get ID from options or options element if one is supplied
	    this.id_ = options.id || options.el && options.el.id;
	
	    // If there was no ID from the options, generate one
	    if (!this.id_) {
	      // Don't require the player ID function in the case of mock players
	      var id = player && player.id && player.id() || 'no_player';
	
	      this.id_ = id + '_component_' + Guid.newGUID();
	    }
	
	    this.name_ = options.name || null;
	
	    // Create element if one wasn't provided in options
	    if (options.el) {
	      this.el_ = options.el;
	    } else if (options.createEl !== false) {
	      this.el_ = this.createEl();
	    }
	
	    this.children_ = [];
	    this.childIndex_ = {};
	    this.childNameIndex_ = {};
	
	    // Add any child components in options
	    if (options.initChildren !== false) {
	      this.initChildren();
	    }
	
	    this.ready(ready);
	    // Don't want to trigger ready here or it will before init is actually
	    // finished for all children that run this constructor
	
	    if (options.reportTouchActivity !== false) {
	      this.enableTouchActivity();
	    }
	  }
	
	  /**
	   * Dispose of the `Component` and all child components.
	   *
	   * @fires Component#dispose
	   */
	
	
	  Component.prototype.dispose = function dispose() {
	
	    /**
	     * Triggered when a `Component` is disposed.
	     *
	     * @event Component#dispose
	     * @type {EventTarget~Event}
	     *
	     * @property {boolean} [bubbles=false]
	     *           set to false so that the close event does not
	     *           bubble up
	     */
	    this.trigger({ type: 'dispose', bubbles: false });
	
	    // Dispose all children.
	    if (this.children_) {
	      for (var i = this.children_.length - 1; i >= 0; i--) {
	        if (this.children_[i].dispose) {
	          this.children_[i].dispose();
	        }
	      }
	    }
	
	    // Delete child references
	    this.children_ = null;
	    this.childIndex_ = null;
	    this.childNameIndex_ = null;
	
	    // Remove all event listeners.
	    this.off();
	
	    // Remove element from DOM
	    if (this.el_.parentNode) {
	      this.el_.parentNode.removeChild(this.el_);
	    }
	
	    Dom.removeElData(this.el_);
	    this.el_ = null;
	  };
	
	  /**
	   * Return the {@link Player} that the `Component` has attached to.
	   *
	   * @return {Player}
	   *         The player that this `Component` has attached to.
	   */
	
	
	  Component.prototype.player = function player() {
	    return this.player_;
	  };
	
	  /**
	   * Deep merge of options objects with new options.
	   * > Note: When both `obj` and `options` contain properties whose values are objects.
	   *         The two properties get merged using {@link module:mergeOptions}
	   *
	   * @param {Object} obj
	   *        The object that contains new options.
	   *
	   * @return {Object}
	   *         A new object of `this.options_` and `obj` merged together.
	   *
	   * @deprecated since version 5
	   */
	
	
	  Component.prototype.options = function options(obj) {
	    _log2['default'].warn('this.options() has been deprecated and will be moved to the constructor in 6.0');
	
	    if (!obj) {
	      return this.options_;
	    }
	
	    this.options_ = (0, _mergeOptions2['default'])(this.options_, obj);
	    return this.options_;
	  };
	
	  /**
	   * Get the `Component`s DOM element
	   *
	   * @return {Element}
	   *         The DOM element for this `Component`.
	   */
	
	
	  Component.prototype.el = function el() {
	    return this.el_;
	  };
	
	  /**
	   * Create the `Component`s DOM element.
	   *
	   * @param {string} [tagName]
	   *        Element's DOM node type. e.g. 'div'
	   *
	   * @param {Object} [properties]
	   *        An object of properties that should be set.
	   *
	   * @param {Object} [attributes]
	   *        An object of attributes that should be set.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  Component.prototype.createEl = function createEl(tagName, properties, attributes) {
	    return Dom.createEl(tagName, properties, attributes);
	  };
	
	  /**
	   * Localize a string given the string in english.
	   *
	   * @param {string} string
	   *        The string to localize.
	   *
	   * @return {string}
	   *         The localized string or if no localization exists the english string.
	   */
	
	
	  Component.prototype.localize = function localize(string) {
	    var code = this.player_.language && this.player_.language();
	    var languages = this.player_.languages && this.player_.languages();
	
	    if (!code || !languages) {
	      return string;
	    }
	
	    var language = languages[code];
	
	    if (language && language[string]) {
	      return language[string];
	    }
	
	    var primaryCode = code.split('-')[0];
	    var primaryLang = languages[primaryCode];
	
	    if (primaryLang && primaryLang[string]) {
	      return primaryLang[string];
	    }
	
	    return string;
	  };
	
	  /**
	   * Return the `Component`s DOM element. This is where children get inserted.
	   * This will usually be the the same as the element returned in {@link Component#el}.
	   *
	   * @return {Element}
	   *         The content element for this `Component`.
	   */
	
	
	  Component.prototype.contentEl = function contentEl() {
	    return this.contentEl_ || this.el_;
	  };
	
	  /**
	   * Get this `Component`s ID
	   *
	   * @return {string}
	   *         The id of this `Component`
	   */
	
	
	  Component.prototype.id = function id() {
	    return this.id_;
	  };
	
	  /**
	   * Get the `Component`s name. The name gets used to reference the `Component`
	   * and is set during registration.
	   *
	   * @return {string}
	   *         The name of this `Component`.
	   */
	
	
	  Component.prototype.name = function name() {
	    return this.name_;
	  };
	
	  /**
	   * Get an array of all child components
	   *
	   * @return {Array}
	   *         The children
	   */
	
	
	  Component.prototype.children = function children() {
	    return this.children_;
	  };
	
	  /**
	   * Returns the child `Component` with the given `id`.
	   *
	   * @param {string} id
	   *        The id of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The child `Component` with the given `id` or undefined.
	   */
	
	
	  Component.prototype.getChildById = function getChildById(id) {
	    return this.childIndex_[id];
	  };
	
	  /**
	   * Returns the child `Component` with the given `name`.
	   *
	   * @param {string} name
	   *        The name of the child `Component` to get.
	   *
	   * @return {Component|undefined}
	   *         The child `Component` with the given `name` or undefined.
	   */
	
	
	  Component.prototype.getChild = function getChild(name) {
	    if (!name) {
	      return;
	    }
	
	    name = (0, _toTitleCase2['default'])(name);
	
	    return this.childNameIndex_[name];
	  };
	
	  /**
	   * Add a child `Component` inside the current `Component`.
	   *
	   *
	   * @param {string|Component} child
	   *        The name or instance of a child to add.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of options that will get passed to children of
	   *        the child.
	   *
	   * @param {number} [index=this.children_.length]
	   *        The index to attempt to add a child into.
	   *
	   * @return {Component}
	   *         The `Component` that gets added as a child. When using a string the
	   *         `Component` will get created by this process.
	   */
	
	
	  Component.prototype.addChild = function addChild(child) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.children_.length;
	
	    var component = void 0;
	    var componentName = void 0;
	
	    // If child is a string, create component with options
	    if (typeof child === 'string') {
	      componentName = (0, _toTitleCase2['default'])(child);
	
	      // Options can also be specified as a boolean,
	      // so convert to an empty object if false.
	      if (!options) {
	        options = {};
	      }
	
	      // Same as above, but true is deprecated so show a warning.
	      if (options === true) {
	        _log2['default'].warn('Initializing a child component with `true` is deprecated.' + 'Children should be defined in an array when possible, ' + 'but if necessary use an object instead of `true`.');
	        options = {};
	      }
	
	      var componentClassName = options.componentClass || componentName;
	
	      // Set name through options
	      options.name = componentName;
	
	      // Create a new object & element for this controls set
	      // If there's no .player_, this is a player
	      var ComponentClass = Component.getComponent(componentClassName);
	
	      if (!ComponentClass) {
	        throw new Error('Component ' + componentClassName + ' does not exist');
	      }
	
	      // data stored directly on the videojs object may be
	      // misidentified as a component to retain
	      // backwards-compatibility with 4.x. check to make sure the
	      // component class can be instantiated.
	      if (typeof ComponentClass !== 'function') {
	        return null;
	      }
	
	      component = new ComponentClass(this.player_ || this, options);
	
	      // child is a component instance
	    } else {
	      component = child;
	    }
	
	    this.children_.splice(index, 0, component);
	
	    if (typeof component.id === 'function') {
	      this.childIndex_[component.id()] = component;
	    }
	
	    // If a name wasn't used to create the component, check if we can use the
	    // name function of the component
	    componentName = componentName || component.name && (0, _toTitleCase2['default'])(component.name());
	
	    if (componentName) {
	      this.childNameIndex_[componentName] = component;
	    }
	
	    // Add the UI object's element to the container div (box)
	    // Having an element is not required
	    if (typeof component.el === 'function' && component.el()) {
	      var childNodes = this.contentEl().children;
	      var refNode = childNodes[index] || null;
	
	      this.contentEl().insertBefore(component.el(), refNode);
	    }
	
	    // Return so it can stored on parent object if desired.
	    return component;
	  };
	
	  /**
	   * Remove a child `Component` from this `Component`s list of children. Also removes
	   * the child `Component`s element from this `Component`s element.
	   *
	   * @param {Component} component
	   *        The child `Component` to remove.
	   */
	
	
	  Component.prototype.removeChild = function removeChild(component) {
	    if (typeof component === 'string') {
	      component = this.getChild(component);
	    }
	
	    if (!component || !this.children_) {
	      return;
	    }
	
	    var childFound = false;
	
	    for (var i = this.children_.length - 1; i >= 0; i--) {
	      if (this.children_[i] === component) {
	        childFound = true;
	        this.children_.splice(i, 1);
	        break;
	      }
	    }
	
	    if (!childFound) {
	      return;
	    }
	
	    this.childIndex_[component.id()] = null;
	    this.childNameIndex_[component.name()] = null;
	
	    var compEl = component.el();
	
	    if (compEl && compEl.parentNode === this.contentEl()) {
	      this.contentEl().removeChild(component.el());
	    }
	  };
	
	  /**
	   * Add and initialize default child `Component`s based upon options.
	   */
	
	
	  Component.prototype.initChildren = function initChildren() {
	    var _this = this;
	
	    var children = this.options_.children;
	
	    if (children) {
	      // `this` is `parent`
	      var parentOptions = this.options_;
	
	      var handleAdd = function handleAdd(child) {
	        var name = child.name;
	        var opts = child.opts;
	
	        // Allow options for children to be set at the parent options
	        // e.g. videojs(id, { controlBar: false });
	        // instead of videojs(id, { children: { controlBar: false });
	        if (parentOptions[name] !== undefined) {
	          opts = parentOptions[name];
	        }
	
	        // Allow for disabling default components
	        // e.g. options['children']['posterImage'] = false
	        if (opts === false) {
	          return;
	        }
	
	        // Allow options to be passed as a simple boolean if no configuration
	        // is necessary.
	        if (opts === true) {
	          opts = {};
	        }
	
	        // We also want to pass the original player options
	        // to each component as well so they don't need to
	        // reach back into the player for options later.
	        opts.playerOptions = _this.options_.playerOptions;
	
	        // Create and add the child component.
	        // Add a direct reference to the child by name on the parent instance.
	        // If two of the same component are used, different names should be supplied
	        // for each
	        var newChild = _this.addChild(name, opts);
	
	        if (newChild) {
	          _this[name] = newChild;
	        }
	      };
	
	      // Allow for an array of children details to passed in the options
	      var workingChildren = void 0;
	      var Tech = Component.getComponent('Tech');
	
	      if (Array.isArray(children)) {
	        workingChildren = children;
	      } else {
	        workingChildren = Object.keys(children);
	      }
	
	      workingChildren
	      // children that are in this.options_ but also in workingChildren  would
	      // give us extra children we do not want. So, we want to filter them out.
	      .concat(Object.keys(this.options_).filter(function (child) {
	        return !workingChildren.some(function (wchild) {
	          if (typeof wchild === 'string') {
	            return child === wchild;
	          }
	          return child === wchild.name;
	        });
	      })).map(function (child) {
	        var name = void 0;
	        var opts = void 0;
	
	        if (typeof child === 'string') {
	          name = child;
	          opts = children[name] || _this.options_[name] || {};
	        } else {
	          name = child.name;
	          opts = child;
	        }
	
	        return { name: name, opts: opts };
	      }).filter(function (child) {
	        // we have to make sure that child.name isn't in the techOrder since
	        // techs are registerd as Components but can't aren't compatible
	        // See https://github.com/videojs/video.js/issues/2772
	        var c = Component.getComponent(child.opts.componentClass || (0, _toTitleCase2['default'])(child.name));
	
	        return c && !Tech.isTech(c);
	      }).forEach(handleAdd);
	    }
	  };
	
	  /**
	   * Builds the default DOM class name. Should be overriden by sub-components.
	   *
	   * @return {string}
	   *         The DOM class name for this object.
	   *
	   * @abstract
	   */
	
	
	  Component.prototype.buildCSSClass = function buildCSSClass() {
	    // Child classes can include a function that does:
	    // return 'CLASS NAME' + this._super();
	    return '';
	  };
	
	  /**
	   * Add an `event listener` to this `Component`s element.
	   *
	   * The benefit of using this over the following:
	   * - `VjsEvents.on(otherElement, 'eventName', myFunc)`
	   * - `otherComponent.on('eventName', myFunc)`
	   *
	   * 1. Is that the listeners will get cleaned up when either component gets disposed.
	   * 1. It will also bind `myComponent` as the context of `myFunc`.
	   * > NOTE: If you remove the element from the DOM that has used `on` you need to
	   *         clean up references using: `myComponent.trigger(el, 'dispose')`
	   *         This will also allow the browser to garbage collect it. In special
	   *         cases such as with `window` and `document`, which are both permanent,
	   *         this is not necessary.
	   *
	   * @param {string|Component|string[]} [first]
	   *        The event name, and array of event names, or another `Component`.
	   *
	   * @param {EventTarget~EventListener|string|string[]} [second]
	   *        The listener function, an event name, or an Array of events names.
	   *
	   * @param {EventTarget~EventListener} [third]
	   *        The event handler if `first` is a `Component` and `second` is an event name
	   *        or an Array of event names.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   *
	   * @listens Component#dispose
	   */
	
	
	  Component.prototype.on = function on(first, second, third) {
	    var _this2 = this;
	
	    if (typeof first === 'string' || Array.isArray(first)) {
	      Events.on(this.el_, first, Fn.bind(this, second));
	
	      // Targeting another component or element
	    } else {
	      var target = first;
	      var type = second;
	      var fn = Fn.bind(this, third);
	
	      // When this component is disposed, remove the listener from the other component
	      var removeOnDispose = function removeOnDispose() {
	        return _this2.off(target, type, fn);
	      };
	
	      // Use the same function ID so we can remove it later it using the ID
	      // of the original listener
	      removeOnDispose.guid = fn.guid;
	      this.on('dispose', removeOnDispose);
	
	      // If the other component is disposed first we need to clean the reference
	      // to the other component in this component's removeOnDispose listener
	      // Otherwise we create a memory leak.
	      var cleanRemover = function cleanRemover() {
	        return _this2.off('dispose', removeOnDispose);
	      };
	
	      // Add the same function ID so we can easily remove it later
	      cleanRemover.guid = fn.guid;
	
	      // Check if this is a DOM node
	      if (first.nodeName) {
	        // Add the listener to the other element
	        Events.on(target, type, fn);
	        Events.on(target, 'dispose', cleanRemover);
	
	        // Should be a component
	        // Not using `instanceof Component` because it makes mock players difficult
	      } else if (typeof first.on === 'function') {
	        // Add the listener to the other component
	        target.on(type, fn);
	        target.on('dispose', cleanRemover);
	      }
	    }
	
	    return this;
	  };
	
	  /**
	   * Remove an event listener from this `Component`s element. If the second argument is
	   * exluded all listeners for the type passed in as the first argument will be removed.
	   *
	   * @param {string|Component|string[]} [first]
	   *        The event name, and array of event names, or another `Component`.
	   *
	   * @param {EventTarget~EventListener|string|string[]} [second]
	   *        The listener function, an event name, or an Array of events names.
	   *
	   * @param {EventTarget~EventListener} [third]
	   *        The event handler if `first` is a `Component` and `second` is an event name
	   *        or an Array of event names.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.off = function off(first, second, third) {
	    if (!first || typeof first === 'string' || Array.isArray(first)) {
	      Events.off(this.el_, first, second);
	    } else {
	      var target = first;
	      var type = second;
	      // Ensure there's at least a guid, even if the function hasn't been used
	      var fn = Fn.bind(this, third);
	
	      // Remove the dispose listener on this component,
	      // which was given the same guid as the event listener
	      this.off('dispose', fn);
	
	      if (first.nodeName) {
	        // Remove the listener
	        Events.off(target, type, fn);
	        // Remove the listener for cleaning the dispose listener
	        Events.off(target, 'dispose', fn);
	      } else {
	        target.off(type, fn);
	        target.off('dispose', fn);
	      }
	    }
	
	    return this;
	  };
	
	  /**
	   * Add an event listener that gets triggered only once and then gets removed.
	   *
	   * @param {string|Component|string[]} [first]
	   *        The event name, and array of event names, or another `Component`.
	   *
	   * @param {EventTarget~EventListener|string|string[]} [second]
	   *        The listener function, an event name, or an Array of events names.
	   *
	   * @param {EventTarget~EventListener} [third]
	   *        The event handler if `first` is a `Component` and `second` is an event name
	   *        or an Array of event names.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.one = function one(first, second, third) {
	    var _this3 = this,
	        _arguments = arguments;
	
	    if (typeof first === 'string' || Array.isArray(first)) {
	      Events.one(this.el_, first, Fn.bind(this, second));
	    } else {
	      var target = first;
	      var type = second;
	      var fn = Fn.bind(this, third);
	
	      var newFunc = function newFunc() {
	        _this3.off(target, type, newFunc);
	        fn.apply(null, _arguments);
	      };
	
	      // Keep the same function ID so we can remove it later
	      newFunc.guid = fn.guid;
	
	      this.on(target, type, newFunc);
	    }
	
	    return this;
	  };
	
	  /**
	   * Trigger an event on an element.
	   *
	   * @param {EventTarget~Event|Object|string} event
	   *        The event name, and Event, or an event-like object with a type attribute
	   *        set to the event name.
	   *
	   * @param {Object} [hash]
	   *        Data hash to pass along with the event
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.trigger = function trigger(event, hash) {
	    Events.trigger(this.el_, event, hash);
	    return this;
	  };
	
	  /**
	   * Bind a listener to the component's ready state. If the ready event has already
	   * happened it will trigger the function immediately.
	   *
	   * @param  {Component~ReadyCallback} fn
	   *         A function to call when ready is triggered.
	   *
	   * @param  {boolean} [sync=false]
	   *         Execute the listener synchronously if `Component` is ready.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.ready = function ready(fn) {
	    var sync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (fn) {
	      if (this.isReady_) {
	        if (sync) {
	          fn.call(this);
	        } else {
	          // Call the function asynchronously by default for consistency
	          this.setTimeout(fn, 1);
	        }
	      } else {
	        this.readyQueue_ = this.readyQueue_ || [];
	        this.readyQueue_.push(fn);
	      }
	    }
	    return this;
	  };
	
	  /**
	   * Trigger all the ready listeners for this `Component`.
	   *
	   * @fires Component#ready
	   */
	
	
	  Component.prototype.triggerReady = function triggerReady() {
	    this.isReady_ = true;
	
	    // Ensure ready is triggerd asynchronously
	    this.setTimeout(function () {
	      var readyQueue = this.readyQueue_;
	
	      // Reset Ready Queue
	      this.readyQueue_ = [];
	
	      if (readyQueue && readyQueue.length > 0) {
	        readyQueue.forEach(function (fn) {
	          fn.call(this);
	        }, this);
	      }
	
	      // Allow for using event listeners also
	      /**
	       * Triggered when a `Component` is ready.
	       *
	       * @event Component#ready
	       * @type {EventTarget~Event}
	       */
	      this.trigger('ready');
	    }, 1);
	  };
	
	  /**
	   * Find a single DOM element matching a `selector`. This can be within the `Component`s
	   * `contentEl()` or another custom context.
	   *
	   * @param {string} selector
	   *        A valid CSS selector, which will be passed to `querySelector`.
	   *
	   * @param {Element|string} [context=this.contentEl()]
	   *        A DOM element within which to query. Can also be a selector string in
	   *        which case the first matching element will get used as context. If
	   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
	   *        nothing it falls back to `document`.
	   *
	   * @return {Element|null}
	   *         the dom element that was found, or null
	   *
	   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
	   */
	
	
	  Component.prototype.$ = function $(selector, context) {
	    return Dom.$(selector, context || this.contentEl());
	  };
	
	  /**
	   * Finds all DOM element matching a `selector`. This can be within the `Component`s
	   * `contentEl()` or another custom context.
	   *
	   * @param {string} selector
	   *        A valid CSS selector, which will be passed to `querySelectorAll`.
	   *
	   * @param {Element|string} [context=this.contentEl()]
	   *        A DOM element within which to query. Can also be a selector string in
	   *        which case the first matching element will get used as context. If
	   *        missing `this.contentEl()` gets used. If  `this.contentEl()` returns
	   *        nothing it falls back to `document`.
	   *
	   * @return {NodeList}
	   *         a list of dom elements that were found
	   *
	   * @see [Information on CSS Selectors](https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Getting_Started/Selectors)
	   */
	
	
	  Component.prototype.$$ = function $$(selector, context) {
	    return Dom.$$(selector, context || this.contentEl());
	  };
	
	  /**
	   * Check if a component's element has a CSS class name.
	   *
	   * @param {string} classToCheck
	   *        CSS class name to check.
	   *
	   * @return {boolean}
	   *         - True if the `Component` has the class.
	   *         - False if the `Component` does not have the class`
	   */
	
	
	  Component.prototype.hasClass = function hasClass(classToCheck) {
	    return Dom.hasElClass(this.el_, classToCheck);
	  };
	
	  /**
	   * Add a CSS class name to the `Component`s element.
	   *
	   * @param {string} classToAdd
	   *        CSS class name to add
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.addClass = function addClass(classToAdd) {
	    Dom.addElClass(this.el_, classToAdd);
	    return this;
	  };
	
	  /**
	   * Remove a CSS class name from the `Component`s element.
	   *
	   * @param {string} classToRemove
	   *        CSS class name to remove
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.removeClass = function removeClass(classToRemove) {
	    Dom.removeElClass(this.el_, classToRemove);
	    return this;
	  };
	
	  /**
	   * Add or remove a CSS class name from the component's element.
	   * - `classToToggle` gets added when {@link Component#hasClass} would return false.
	   * - `classToToggle` gets removed when {@link Component#hasClass} would return true.
	   *
	   * @param  {string} classToToggle
	   *         The class to add or remove based on (@link Component#hasClass}
	   *
	   * @param  {boolean|Dom~predicate} [predicate]
	   *         An {@link Dom~predicate} function or a boolean
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.toggleClass = function toggleClass(classToToggle, predicate) {
	    Dom.toggleElClass(this.el_, classToToggle, predicate);
	    return this;
	  };
	
	  /**
	   * Show the `Component`s element if it is hidden by removing the
	   * 'vjs-hidden' class name from it.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.show = function show() {
	    this.removeClass('vjs-hidden');
	    return this;
	  };
	
	  /**
	   * Hide the `Component`s element if it is currently showing by adding the
	   * 'vjs-hidden` class name to it.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.hide = function hide() {
	    this.addClass('vjs-hidden');
	    return this;
	  };
	
	  /**
	   * Lock a `Component`s element in its visible state by adding the 'vjs-lock-showing'
	   * class name to it. Used during fadeIn/fadeOut.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   *
	   * @private
	   */
	
	
	  Component.prototype.lockShowing = function lockShowing() {
	    this.addClass('vjs-lock-showing');
	    return this;
	  };
	
	  /**
	   * Unlock a `Component`s element from its visible state by removing the 'vjs-lock-showing'
	   * class name from it. Used during fadeIn/fadeOut.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   *
	   * @private
	   */
	
	
	  Component.prototype.unlockShowing = function unlockShowing() {
	    this.removeClass('vjs-lock-showing');
	    return this;
	  };
	
	  /**
	   * Get the value of an attribute on the `Component`s element.
	   *
	   * @param {string} attribute
	   *        Name of the attribute to get the value from.
	   *
	   * @return {string|null}
	   *         - The value of the attribute that was asked for.
	   *         - Can be an empty string on some browsers if the attribute does not exist
	   *           or has no value
	   *         - Most browsers will return null if the attibute does not exist or has
	   *           no value.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/getAttribute}
	   */
	
	
	  Component.prototype.getAttribute = function getAttribute(attribute) {
	    return Dom.getAttribute(this.el_, attribute);
	  };
	
	  /**
	   * Set the value of an attribute on the `Component`'s element
	   *
	   * @param {string} attribute
	   *        Name of the attribute to set.
	   *
	   * @param {string} value
	   *        Value to set the attribute to.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/setAttribute}
	   */
	
	
	  Component.prototype.setAttribute = function setAttribute(attribute, value) {
	    Dom.setAttribute(this.el_, attribute, value);
	    return this;
	  };
	
	  /**
	   * Remove an attribute from the `Component`s element.
	   *
	   * @param {string} attribute
	   *        Name of the attribute to remove.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   *
	   * @see [DOM API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Element/removeAttribute}
	   */
	
	
	  Component.prototype.removeAttribute = function removeAttribute(attribute) {
	    Dom.removeAttribute(this.el_, attribute);
	    return this;
	  };
	
	  /**
	   * Get or set the width of the component based upon the CSS styles.
	   * See {@link Component#dimension} for more detailed information.
	   *
	   * @param {number|string} [num]
	   *        The width that you want to set postfixed with '%', 'px' or nothing.
	   *
	   * @param {boolean} [skipListeners]
	   *        Skip the resize event trigger
	   *
	   * @return {Component|number|string}
	   *         - The width when getting, zero if there is no width. Can be a string
	   *           postpixed with '%' or 'px'.
	   *         - Returns itself when setting; method can be chained.
	   */
	
	
	  Component.prototype.width = function width(num, skipListeners) {
	    return this.dimension('width', num, skipListeners);
	  };
	
	  /**
	   * Get or set the height of the component based upon the CSS styles.
	   * See {@link Component#dimension} for more detailed information.
	   *
	   * @param {number|string} [num]
	   *        The height that you want to set postfixed with '%', 'px' or nothing.
	   *
	   * @param {boolean} [skipListeners]
	   *        Skip the resize event trigger
	   *
	   * @return {Component|number|string}
	   *         - The width when getting, zero if there is no width. Can be a string
	   *           postpixed with '%' or 'px'.
	   *         - Returns itself when setting; method can be chained.
	   */
	
	
	  Component.prototype.height = function height(num, skipListeners) {
	    return this.dimension('height', num, skipListeners);
	  };
	
	  /**
	   * Set both the width and height of the `Component` element at the same time.
	   *
	   * @param  {number|string} width
	   *         Width to set the `Component`s element to.
	   *
	   * @param  {number|string} height
	   *         Height to set the `Component`s element to.
	   *
	   * @return {Component}
	   *         Returns itself; method can be chained.
	   */
	
	
	  Component.prototype.dimensions = function dimensions(width, height) {
	    // Skip resize listeners on width for optimization
	    return this.width(width, true).height(height);
	  };
	
	  /**
	   * Get or set width or height of the `Component` element. This is the shared code
	   * for the {@link Component#width} and {@link Component#height}.
	   *
	   * Things to know:
	   * - If the width or height in an number this will return the number postfixed with 'px'.
	   * - If the width/height is a percent this will return the percent postfixed with '%'
	   * - Hidden elements have a width of 0 with `window.getComputedStyle`. This function
	   *   defaults to the `Component`s `style.width` and falls back to `window.getComputedStyle`.
	   *   See [this]{@link http://www.foliotek.com/devblog/getting-the-width-of-a-hidden-element-with-jquery-using-width/}
	   *   for more information
	   * - If you want the computed style of the component, use {@link Component#currentWidth}
	   *   and {@link {Component#currentHeight}
	   *
	   * @fires Component#resize
	   *
	   * @param {string} widthOrHeight
	   8        'width' or 'height'
	   *
	   * @param  {number|string} [num]
	   8         New dimension
	   *
	   * @param  {boolean} [skipListeners]
	   *         Skip resize event trigger
	   *
	   * @return {Component}
	   *         - the dimension when getting or 0 if unset
	   *         - Returns itself when setting; method can be chained.
	   */
	
	
	  Component.prototype.dimension = function dimension(widthOrHeight, num, skipListeners) {
	    if (num !== undefined) {
	      // Set to zero if null or literally NaN (NaN !== NaN)
	      if (num === null || num !== num) {
	        num = 0;
	      }
	
	      // Check if using css width/height (% or px) and adjust
	      if (('' + num).indexOf('%') !== -1 || ('' + num).indexOf('px') !== -1) {
	        this.el_.style[widthOrHeight] = num;
	      } else if (num === 'auto') {
	        this.el_.style[widthOrHeight] = '';
	      } else {
	        this.el_.style[widthOrHeight] = num + 'px';
	      }
	
	      // skipListeners allows us to avoid triggering the resize event when setting both width and height
	      if (!skipListeners) {
	        /**
	         * Triggered when a component is resized.
	         *
	         * @event Component#resize
	         * @type {EventTarget~Event}
	         */
	        this.trigger('resize');
	      }
	
	      // Return component
	      return this;
	    }
	
	    // Not setting a value, so getting it
	    // Make sure element exists
	    if (!this.el_) {
	      return 0;
	    }
	
	    // Get dimension value from style
	    var val = this.el_.style[widthOrHeight];
	    var pxIndex = val.indexOf('px');
	
	    if (pxIndex !== -1) {
	      // Return the pixel value with no 'px'
	      return parseInt(val.slice(0, pxIndex), 10);
	    }
	
	    // No px so using % or no style was set, so falling back to offsetWidth/height
	    // If component has display:none, offset will return 0
	    // TODO: handle display:none and no dimension style using px
	    return parseInt(this.el_['offset' + (0, _toTitleCase2['default'])(widthOrHeight)], 10);
	  };
	
	  /**
	   * Get the width or the height of the `Component` elements computed style. Uses
	   * `window.getComputedStyle`.
	   *
	   * @param {string} widthOrHeight
	   *        A string containing 'width' or 'height'. Whichever one you want to get.
	   *
	   * @return {number}
	   *         The dimension that gets asked for or 0 if nothing was set
	   *         for that dimension.
	   */
	
	
	  Component.prototype.currentDimension = function currentDimension(widthOrHeight) {
	    var computedWidthOrHeight = 0;
	
	    if (widthOrHeight !== 'width' && widthOrHeight !== 'height') {
	      throw new Error('currentDimension only accepts width or height value');
	    }
	
	    if (typeof _window2['default'].getComputedStyle === 'function') {
	      var computedStyle = _window2['default'].getComputedStyle(this.el_);
	
	      computedWidthOrHeight = computedStyle.getPropertyValue(widthOrHeight) || computedStyle[widthOrHeight];
	    }
	
	    // remove 'px' from variable and parse as integer
	    computedWidthOrHeight = parseFloat(computedWidthOrHeight);
	
	    // if the computed value is still 0, it's possible that the browser is lying
	    // and we want to check the offset values.
	    // This code also runs on IE8 and wherever getComputedStyle doesn't exist.
	    if (computedWidthOrHeight === 0) {
	      var rule = 'offset' + (0, _toTitleCase2['default'])(widthOrHeight);
	
	      computedWidthOrHeight = this.el_[rule];
	    }
	
	    return computedWidthOrHeight;
	  };
	
	  /**
	   * An object that contains width and height values of the `Component`s
	   * computed style. Uses `window.getComputedStyle`.
	   *
	   * @typedef {Object} Component~DimensionObject
	   *
	   * @property {number} width
	   *           The width of the `Component`s computed style.
	   *
	   * @property {number} height
	   *           The height of the `Component`s computed style.
	   */
	
	  /**
	   * Get an object that contains width and height values of the `Component`s
	   * computed style.
	   *
	   * @return {Component~DimensionObject}
	   *         The dimensions of the components element
	   */
	
	
	  Component.prototype.currentDimensions = function currentDimensions() {
	    return {
	      width: this.currentDimension('width'),
	      height: this.currentDimension('height')
	    };
	  };
	
	  /**
	   * Get the width of the `Component`s computed style. Uses `window.getComputedStyle`.
	   *
	   * @return {number} width
	   *           The width of the `Component`s computed style.
	   */
	
	
	  Component.prototype.currentWidth = function currentWidth() {
	    return this.currentDimension('width');
	  };
	
	  /**
	   * Get the height of the `Component`s computed style. Uses `window.getComputedStyle`.
	   *
	   * @return {number} height
	   *           The height of the `Component`s computed style.
	   */
	
	
	  Component.prototype.currentHeight = function currentHeight() {
	    return this.currentDimension('height');
	  };
	
	  /**
	   * Set the focus to this component
	   */
	
	
	  Component.prototype.focus = function focus() {
	    this.el_.focus();
	  };
	
	  /**
	   * Remove the focus from this component
	   */
	
	
	  Component.prototype.blur = function blur() {
	    this.el_.blur();
	  };
	
	  /**
	   * Emit a 'tap' events when touch event support gets detected. This gets used to
	   * support toggling the controls through a tap on the video. They get enabled
	   * because every sub-component would have extra overhead otherwise.
	   *
	   * @private
	   * @fires Component#tap
	   * @listens Component#touchstart
	   * @listens Component#touchmove
	   * @listens Component#touchleave
	   * @listens Component#touchcancel
	   * @listens Component#touchend
	    */
	
	
	  Component.prototype.emitTapEvents = function emitTapEvents() {
	    // Track the start time so we can determine how long the touch lasted
	    var touchStart = 0;
	    var firstTouch = null;
	
	    // Maximum movement allowed during a touch event to still be considered a tap
	    // Other popular libs use anywhere from 2 (hammer.js) to 15,
	    // so 10 seems like a nice, round number.
	    var tapMovementThreshold = 10;
	
	    // The maximum length a touch can be while still being considered a tap
	    var touchTimeThreshold = 200;
	
	    var couldBeTap = void 0;
	
	    this.on('touchstart', function (event) {
	      // If more than one finger, don't consider treating this as a click
	      if (event.touches.length === 1) {
	        // Copy pageX/pageY from the object
	        firstTouch = {
	          pageX: event.touches[0].pageX,
	          pageY: event.touches[0].pageY
	        };
	        // Record start time so we can detect a tap vs. "touch and hold"
	        touchStart = new Date().getTime();
	        // Reset couldBeTap tracking
	        couldBeTap = true;
	      }
	    });
	
	    this.on('touchmove', function (event) {
	      // If more than one finger, don't consider treating this as a click
	      if (event.touches.length > 1) {
	        couldBeTap = false;
	      } else if (firstTouch) {
	        // Some devices will throw touchmoves for all but the slightest of taps.
	        // So, if we moved only a small distance, this could still be a tap
	        var xdiff = event.touches[0].pageX - firstTouch.pageX;
	        var ydiff = event.touches[0].pageY - firstTouch.pageY;
	        var touchDistance = Math.sqrt(xdiff * xdiff + ydiff * ydiff);
	
	        if (touchDistance > tapMovementThreshold) {
	          couldBeTap = false;
	        }
	      }
	    });
	
	    var noTap = function noTap() {
	      couldBeTap = false;
	    };
	
	    // TODO: Listen to the original target. http://youtu.be/DujfpXOKUp8?t=13m8s
	    this.on('touchleave', noTap);
	    this.on('touchcancel', noTap);
	
	    // When the touch ends, measure how long it took and trigger the appropriate
	    // event
	    this.on('touchend', function (event) {
	      firstTouch = null;
	      // Proceed only if the touchmove/leave/cancel event didn't happen
	      if (couldBeTap === true) {
	        // Measure how long the touch lasted
	        var touchTime = new Date().getTime() - touchStart;
	
	        // Make sure the touch was less than the threshold to be considered a tap
	        if (touchTime < touchTimeThreshold) {
	          // Don't let browser turn this into a click
	          event.preventDefault();
	          /**
	           * Triggered when a `Component` is tapped.
	           *
	           * @event Component#tap
	           * @type {EventTarget~Event}
	           */
	          this.trigger('tap');
	          // It may be good to copy the touchend event object and change the
	          // type to tap, if the other event properties aren't exact after
	          // Events.fixEvent runs (e.g. event.target)
	        }
	      }
	    });
	  };
	
	  /**
	   * This function reports user activity whenever touch events happen. This can get
	   * turned off by any sub-components that wants touch events to act another way.
	   *
	   * Report user touch activity when touch events occur. User activity gets used to
	   * determine when controls should show/hide. It is simple when it comes to mouse
	   * events, because any mouse event should show the controls. So we capture mouse
	   * events that bubble up to the player and report activity when that happens.
	   * With touch events it isn't as easy as `touchstart` and `touchend` toggle player
	   * controls. So touch events can't help us at the player level either.
	   *
	   * User activity gets checked asynchronously. So what could happen is a tap event
	   * on the video turns the controls off. Then the `touchend` event bubbles up to
	   * the player. Which, if it reported user activity, would turn the controls right
	   * back on. We also don't want to completely block touch events from bubbling up.
	   * Furthermore a `touchmove` event and anything other than a tap, should not turn
	   * controls back on.
	   *
	   * @listens Component#touchstart
	   * @listens Component#touchmove
	   * @listens Component#touchend
	   * @listens Component#touchcancel
	   */
	
	
	  Component.prototype.enableTouchActivity = function enableTouchActivity() {
	    // Don't continue if the root player doesn't support reporting user activity
	    if (!this.player() || !this.player().reportUserActivity) {
	      return;
	    }
	
	    // listener for reporting that the user is active
	    var report = Fn.bind(this.player(), this.player().reportUserActivity);
	
	    var touchHolding = void 0;
	
	    this.on('touchstart', function () {
	      report();
	      // For as long as the they are touching the device or have their mouse down,
	      // we consider them active even if they're not moving their finger or mouse.
	      // So we want to continue to update that they are active
	      this.clearInterval(touchHolding);
	      // report at the same interval as activityCheck
	      touchHolding = this.setInterval(report, 250);
	    });
	
	    var touchEnd = function touchEnd(event) {
	      report();
	      // stop the interval that maintains activity if the touch is holding
	      this.clearInterval(touchHolding);
	    };
	
	    this.on('touchmove', report);
	    this.on('touchend', touchEnd);
	    this.on('touchcancel', touchEnd);
	  };
	
	  /**
	   * A callback that has no parameters and is bound into `Component`s context.
	   *
	   * @callback Component~GenericCallback
	   * @this Component
	   */
	
	  /**
	   * Creates a function that runs after an `x` millisecond timeout. This function is a
	   * wrapper around `window.setTimeout`. There are a few reasons to use this one
	   * instead though:
	   * 1. It gets cleared via  {@link Component#clearTimeout} when
	   *    {@link Component#dispose} gets called.
	   * 2. The function callback will gets turned into a {@link Component~GenericCallback}
	   *
	   * > Note: You can use `window.clearTimeout` on the id returned by this function. This
	   *         will cause its dispose listener not to get cleaned up! Please use
	   *         {@link Component#clearTimeout} or {@link Component#dispose}.
	   *
	   * @param {Component~GenericCallback} fn
	   *        The function that will be run after `timeout`.
	   *
	   * @param {number} timeout
	   *        Timeout in milliseconds to delay before executing the specified function.
	   *
	   * @return {number}
	   *         Returns a timeout ID that gets used to identify the timeout. It can also
	   *         get used in {@link Component#clearTimeout} to clear the timeout that
	   *         was set.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setTimeout}
	   */
	
	
	  Component.prototype.setTimeout = function setTimeout(fn, timeout) {
	    fn = Fn.bind(this, fn);
	
	    var timeoutId = _window2['default'].setTimeout(fn, timeout);
	    var disposeFn = function disposeFn() {
	      this.clearTimeout(timeoutId);
	    };
	
	    disposeFn.guid = 'vjs-timeout-' + timeoutId;
	
	    this.on('dispose', disposeFn);
	
	    return timeoutId;
	  };
	
	  /**
	   * Clears a timeout that gets created via `window.setTimeout` or
	   * {@link Component#setTimeout}. If you set a timeout via {@link Component#setTimeout}
	   * use this function instead of `window.clearTimout`. If you don't your dispose
	   * listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} timeoutId
	   *        The id of the timeout to clear. The return value of
	   *        {@link Component#setTimeout} or `window.setTimeout`.
	   *
	   * @return {number}
	   *         Returns the timeout id that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearTimeout}
	   */
	
	
	  Component.prototype.clearTimeout = function clearTimeout(timeoutId) {
	    _window2['default'].clearTimeout(timeoutId);
	
	    var disposeFn = function disposeFn() {};
	
	    disposeFn.guid = 'vjs-timeout-' + timeoutId;
	
	    this.off('dispose', disposeFn);
	
	    return timeoutId;
	  };
	
	  /**
	   * Creates a function that gets run every `x` milliseconds. This function is a wrapper
	   * around `window.setInterval`. There are a few reasons to use this one instead though.
	   * 1. It gets cleared via  {@link Component#clearInterval} when
	   *    {@link Component#dispose} gets called.
	   * 2. The function callback will be a {@link Component~GenericCallback}
	   *
	   * @param {Component~GenericCallback} fn
	   *        The function to run every `x` seconds.
	   *
	   * @param {number} interval
	   *        Execute the specified function every `x` milliseconds.
	   *
	   * @return {number}
	   *         Returns an id that can be used to identify the interval. It can also be be used in
	   *         {@link Component#clearInterval} to clear the interval.
	   *
	   * @listens Component#dispose
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/setInterval}
	   */
	
	
	  Component.prototype.setInterval = function setInterval(fn, interval) {
	    fn = Fn.bind(this, fn);
	
	    var intervalId = _window2['default'].setInterval(fn, interval);
	
	    var disposeFn = function disposeFn() {
	      this.clearInterval(intervalId);
	    };
	
	    disposeFn.guid = 'vjs-interval-' + intervalId;
	
	    this.on('dispose', disposeFn);
	
	    return intervalId;
	  };
	
	  /**
	   * Clears an interval that gets created via `window.setInterval` or
	   * {@link Component#setInterval}. If you set an inteval via {@link Component#setInterval}
	   * use this function instead of `window.clearInterval`. If you don't your dispose
	   * listener will not get cleaned up until {@link Component#dispose}!
	   *
	   * @param {number} intervalId
	   *        The id of the interval to clear. The return value of
	   *        {@link Component#setInterval} or `window.setInterval`.
	   *
	   * @return {number}
	   *         Returns the interval id that was cleared.
	   *
	   * @see [Similar to]{@link https://developer.mozilla.org/en-US/docs/Web/API/WindowTimers/clearInterval}
	   */
	
	
	  Component.prototype.clearInterval = function clearInterval(intervalId) {
	    _window2['default'].clearInterval(intervalId);
	
	    var disposeFn = function disposeFn() {};
	
	    disposeFn.guid = 'vjs-interval-' + intervalId;
	
	    this.off('dispose', disposeFn);
	
	    return intervalId;
	  };
	
	  /**
	   * Register a `Component` with `videojs` given the name and the component.
	   *
	   * > NOTE: {@link Tech}s should not be registered as a `Component`. {@link Tech}s
	   *         should be registered using {@link Tech.registerTech} or
	   *         {@link videojs:videojs.registerTech}.
	   *
	   * > NOTE: This function can also be seen on videojs as
	   *         {@link videojs:videojs.registerComponent}.
	   *
	   * @param {string} name
	   *        The name of the `Component` to register.
	   *
	   * @param {Component} comp
	   *        The `Component` class to register.
	   *
	   * @return {Component}
	   *         The `Component` that was registered.
	   */
	
	
	  Component.registerComponent = function registerComponent(name, comp) {
	    if (!name) {
	      return;
	    }
	
	    name = (0, _toTitleCase2['default'])(name);
	
	    if (!Component.components_) {
	      Component.components_ = {};
	    }
	
	    if (name === 'Player' && Component.components_[name]) {
	      var Player = Component.components_[name];
	
	      // If we have players that were disposed, then their name will still be
	      // in Players.players. So, we must loop through and verify that the value
	      // for each item is not null. This allows registration of the Player component
	      // after all players have been disposed or before any were created.
	      if (Player.players && Object.keys(Player.players).length > 0 && Object.keys(Player.players).map(function (playerName) {
	        return Player.players[playerName];
	      }).every(Boolean)) {
	        throw new Error('Can not register Player component after player has been created');
	      }
	    }
	
	    Component.components_[name] = comp;
	
	    return comp;
	  };
	
	  /**
	   * Get a `Component` based on the name it was registered with.
	   *
	   * @param {string} name
	   *        The Name of the component to get.
	   *
	   * @return {Component}
	   *         The `Component` that got registered under the given name.
	   *
	   * @deprecated In `videojs` 6 this will not return `Component`s that were not
	   *             registered using {@link Component.registerComponent}. Currently we
	   *             check the global `videojs` object for a `Component` name and
	   *             return that if it exists.
	   */
	
	
	  Component.getComponent = function getComponent(name) {
	    if (!name) {
	      return;
	    }
	
	    name = (0, _toTitleCase2['default'])(name);
	
	    if (Component.components_ && Component.components_[name]) {
	      return Component.components_[name];
	    }
	
	    if (_window2['default'] && _window2['default'].videojs && _window2['default'].videojs[name]) {
	      _log2['default'].warn('The ' + name + ' component was added to the videojs object when it should be registered using videojs.registerComponent(name, component)');
	
	      return _window2['default'].videojs[name];
	    }
	  };
	
	  /**
	   * Sets up the constructor using the supplied init method or uses the init of the
	   * parent object.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties.
	   *
	   * @return {Object}
	   *         the extended object.
	   *
	   * @deprecated since version 5
	   */
	
	
	  Component.extend = function extend(props) {
	    props = props || {};
	
	    _log2['default'].warn('Component.extend({}) has been deprecated, ' + ' use videojs.extend(Component, {}) instead');
	
	    // Set up the constructor using the supplied init method
	    // or using the init of the parent object
	    // Make sure to check the unobfuscated version for external libs
	    var init = props.init || props.init || this.prototype.init || this.prototype.init || function () {};
	    // In Resig's simple class inheritance (previously used) the constructor
	    //  is a function that calls `this.init.apply(arguments)`
	    // However that would prevent us from using `ParentObject.call(this);`
	    //  in a Child constructor because the `this` in `this.init`
	    //  would still refer to the Child and cause an infinite loop.
	    // We would instead have to do
	    //    `ParentObject.prototype.init.apply(this, arguments);`
	    //  Bleh. We're not creating a _super() function, so it's good to keep
	    //  the parent constructor reference simple.
	    var subObj = function subObj() {
	      init.apply(this, arguments);
	    };
	
	    // Inherit from this object's prototype
	    subObj.prototype = Object.create(this.prototype);
	    // Reset the constructor property for subObj otherwise
	    // instances of subObj would have the constructor of the parent Object
	    subObj.prototype.constructor = subObj;
	
	    // Make the class extendable
	    subObj.extend = Component.extend;
	
	    // Extend subObj's prototype with functions and other properties from props
	    for (var name in props) {
	      if (props.hasOwnProperty(name)) {
	        subObj.prototype[name] = props[name];
	      }
	    }
	
	    return subObj;
	  };
	
	  return Component;
	}();
	
	Component.registerComponent('Component', Component);
	exports['default'] = Component;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        'Invariant Violation: ' +
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.DefaultRoute = __webpack_require__(369);
	exports.Link = __webpack_require__(836);
	exports.NotFoundRoute = __webpack_require__(370);
	exports.Redirect = __webpack_require__(371);
	exports.Route = __webpack_require__(168);
	exports.ActiveHandler = __webpack_require__(169);
	exports.RouteHandler = exports.ActiveHandler;
	
	exports.HashLocation = __webpack_require__(374);
	exports.HistoryLocation = __webpack_require__(237);
	exports.RefreshLocation = __webpack_require__(375);
	exports.StaticLocation = __webpack_require__(376);
	exports.TestLocation = __webpack_require__(839);
	
	exports.ImitateBrowserBehavior = __webpack_require__(368);
	exports.ScrollToTopBehavior = __webpack_require__(834);
	
	exports.History = __webpack_require__(112);
	exports.Navigation = __webpack_require__(830);
	exports.State = __webpack_require__(832);
	
	exports.createRoute = __webpack_require__(99).createRoute;
	exports.createDefaultRoute = __webpack_require__(99).createDefaultRoute;
	exports.createNotFoundRoute = __webpack_require__(99).createNotFoundRoute;
	exports.createRedirect = __webpack_require__(99).createRedirect;
	exports.createRoutesFromReactChildren = __webpack_require__(373);
	
	exports.create = __webpack_require__(372);
	exports.run = __webpack_require__(840);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Object.assign
	 */
	
	// https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign
	
	'use strict';
	
	function assign(target, sources) {
	  if (target == null) {
	    throw new TypeError('Object.assign target cannot be null or undefined');
	  }
	
	  var to = Object(target);
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	  for (var nextIndex = 1; nextIndex < arguments.length; nextIndex++) {
	    var nextSource = arguments[nextIndex];
	    if (nextSource == null) {
	      continue;
	    }
	
	    var from = Object(nextSource);
	
	    // We don't currently support accessors nor proxies. Therefore this
	    // copy cannot throw. If we ever supported this then we must handle
	    // exceptions and side-effects. We don't support symbols so they won't
	    // be transferred.
	
	    for (var key in from) {
	      if (hasOwnProperty.call(from, key)) {
	        to[key] = from[key];
	      }
	    }
	  }
	
	  return to;
	}
	
	module.exports = assign;


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.throttle = exports.bind = undefined;
	
	var _guid = __webpack_require__(119);
	
	/**
	 * Bind (a.k.a proxy or Context). A simple method for changing the context of a function
	 * It also stores a unique id on the function so it can be easily removed from events.
	 *
	 * @param {Mixed} context
	 *        The object to bind as scope.
	 *
	 * @param {Function} fn
	 *        The function to be bound to a scope.
	 *
	 * @param {number} [uid]
	 *        An optional unique ID for the function to be set
	 *
	 * @return {Function}
	 *         The new function that will be bound into the context given
	 */
	var bind = exports.bind = function bind(context, fn, uid) {
	  // Make sure the function has a unique ID
	  if (!fn.guid) {
	    fn.guid = (0, _guid.newGUID)();
	  }
	
	  // Create the new function that changes the context
	  var bound = function bound() {
	    return fn.apply(context, arguments);
	  };
	
	  // Allow for the ability to individualize this function
	  // Needed in the case where multiple objects might share the same prototype
	  // IF both items add an event listener with the same function, then you try to remove just one
	  // it will remove both because they both have the same guid.
	  // when using this, you need to use the bind method when you remove the listener as well.
	  // currently used in text tracks
	  bound.guid = uid ? uid + '_' + fn.guid : fn.guid;
	
	  return bound;
	};
	
	/**
	 * Wraps the given function, `fn`, with a new function that only invokes `fn`
	 * at most once per every `wait` milliseconds.
	 *
	 * @param  {Function} fn
	 *         The function to be throttled.
	 *
	 * @param  {Number}   wait
	 *         The number of milliseconds by which to throttle.
	 *
	 * @return {Function}
	 */
	/**
	 * @file fn.js
	 * @module fn
	 */
	var throttle = exports.throttle = function throttle(fn, wait) {
	  var last = Date.now();
	
	  var throttled = function throttled() {
	    var now = Date.now();
	
	    if (now - last >= wait) {
	      fn.apply(undefined, arguments);
	      last = now;
	    }
	  };
	
	  return throttled;
	};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(126)('wks');
	var uid = __webpack_require__(95);
	var Symbol = __webpack_require__(8).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(53);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var ReactContext = __webpack_require__(246);
	var ReactCurrentOwner = __webpack_require__(72);
	
	var assign = __webpack_require__(11);
	var warning = __webpack_require__(17);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true
	};
	
	/**
	 * Warn for mutations.
	 *
	 * @internal
	 * @param {object} object
	 * @param {string} key
	 */
	function defineWarningProperty(object, key) {
	  Object.defineProperty(object, key, {
	
	    configurable: false,
	    enumerable: true,
	
	    get: function() {
	      if (!this._store) {
	        return null;
	      }
	      return this._store[key];
	    },
	
	    set: function(value) {
	      ( false ? warning(
	        false,
	        'Don\'t set the %s property of the React element. Instead, ' +
	        'specify the correct value when initially creating the element.',
	        key
	      ) : null);
	      this._store[key] = value;
	    }
	
	  });
	}
	
	/**
	 * This is updated to true if the membrane is successfully created.
	 */
	var useMutationMembrane = false;
	
	/**
	 * Warn for mutations.
	 *
	 * @internal
	 * @param {object} element
	 */
	function defineMutationMembrane(prototype) {
	  try {
	    var pseudoFrozenProperties = {
	      props: true
	    };
	    for (var key in pseudoFrozenProperties) {
	      defineWarningProperty(prototype, key);
	    }
	    useMutationMembrane = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	/**
	 * Base constructor for all React elements. This is only used to make this
	 * work with a dynamic instanceof check. Nothing should live on this prototype.
	 *
	 * @param {*} type
	 * @param {string|object} ref
	 * @param {*} key
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function(type, key, ref, owner, context, props) {
	  // Built-in properties that belong on the element
	  this.type = type;
	  this.key = key;
	  this.ref = ref;
	
	  // Record the component responsible for creating this element.
	  this._owner = owner;
	
	  // TODO: Deprecate withContext, and then the context becomes accessible
	  // through the owner.
	  this._context = context;
	
	  if (false) {
	    // The validation flag and props are currently mutative. We put them on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    this._store = {props: props, originalProps: assign({}, props)};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    try {
	      Object.defineProperty(this._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true
	      });
	    } catch (x) {
	    }
	    this._store.validated = false;
	
	    // We're not allowed to set props directly on the object so we early
	    // return and rely on the prototype membrane to forward to the backing
	    // store.
	    if (useMutationMembrane) {
	      Object.freeze(this);
	      return;
	    }
	  }
	
	  this.props = props;
	};
	
	// We intentionally don't expose the function on the constructor property.
	// ReactElement should be indistinguishable from a plain object.
	ReactElement.prototype = {
	  _isReactElement: true
	};
	
	if (false) {
	  defineMutationMembrane(ReactElement.prototype);
	}
	
	ReactElement.createElement = function(type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	
	  if (config != null) {
	    ref = config.ref === undefined ? null : config.ref;
	    key = config.key === undefined ? null : '' + config.key;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) &&
	          !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (typeof props[propName] === 'undefined') {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	
	  return new ReactElement(
	    type,
	    key,
	    ref,
	    ReactCurrentOwner.current,
	    ReactContext.current,
	    props
	  );
	};
	
	ReactElement.createFactory = function(type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. <Foo />.type === Foo.type.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceProps = function(oldElement, newProps) {
	  var newElement = new ReactElement(
	    oldElement.type,
	    oldElement.key,
	    oldElement.ref,
	    oldElement._owner,
	    oldElement._context,
	    newProps
	  );
	
	  if (false) {
	    // If the key on the original is valid, then the clone is valid
	    newElement._store.validated = oldElement._store.validated;
	  }
	  return newElement;
	};
	
	ReactElement.cloneElement = function(element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (config.ref !== undefined) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (config.key !== undefined) {
	      key = '' + config.key;
	    }
	    // Remaining properties override existing props
	    for (propName in config) {
	      if (config.hasOwnProperty(propName) &&
	          !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return new ReactElement(
	    element.type,
	    key,
	    ref,
	    owner,
	    element._context,
	    props
	  );
	};
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function(object) {
	  // ReactTestUtils is often used outside of beforeEach where as React is
	  // within it. This leads to two different instances of React on the same
	  // page. To identify a element from a different React instance we use
	  // a flag instead of an instanceof check.
	  var isElement = !!(object && object._isReactElement);
	  // if (isElement && !(object instanceof ReactElement)) {
	  // This is an indicator that you're using multiple versions of React at the
	  // same time. This will screw with ownership and stuff. Fix it, please.
	  // TODO: We could possibly warn here.
	  // }
	  return isElement;
	};
	
	module.exports = ReactElement;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	"use strict";
	
	var emptyFunction = __webpack_require__(63);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function(condition, format ) {for (var args=[],$__0=2,$__1=arguments.length;$__0<$__1;$__0++) args.push(arguments[$__0]);
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || /^[s\W]*$/.test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function()  {return args[argIndex++];});
	      console.warn(message);
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.$$ = exports.$ = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['Setting attributes in the second argument of createEl()\n                has been deprecated. Use the third argument instead.\n                createEl(type, properties, attributes). Attempting to set ', ' to ', '.'], ['Setting attributes in the second argument of createEl()\n                has been deprecated. Use the third argument instead.\n                createEl(type, properties, attributes). Attempting to set ', ' to ', '.']);
	
	exports.isReal = isReal;
	exports.isEl = isEl;
	exports.getEl = getEl;
	exports.createEl = createEl;
	exports.textContent = textContent;
	exports.insertElFirst = insertElFirst;
	exports.getElData = getElData;
	exports.hasElData = hasElData;
	exports.removeElData = removeElData;
	exports.hasElClass = hasElClass;
	exports.addElClass = addElClass;
	exports.removeElClass = removeElClass;
	exports.toggleElClass = toggleElClass;
	exports.setElAttributes = setElAttributes;
	exports.getElAttributes = getElAttributes;
	exports.getAttribute = getAttribute;
	exports.setAttribute = setAttribute;
	exports.removeAttribute = removeAttribute;
	exports.blockTextSelection = blockTextSelection;
	exports.unblockTextSelection = unblockTextSelection;
	exports.findElPosition = findElPosition;
	exports.getPointerPosition = getPointerPosition;
	exports.isTextNode = isTextNode;
	exports.emptyEl = emptyEl;
	exports.normalizeContent = normalizeContent;
	exports.appendContent = appendContent;
	exports.insertContent = insertContent;
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _guid = __webpack_require__(119);
	
	var Guid = _interopRequireWildcard(_guid);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _tsml = __webpack_require__(416);
	
	var _tsml2 = _interopRequireDefault(_tsml);
	
	var _obj = __webpack_require__(31);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; } /**
	                                                                                           * @file dom.js
	                                                                                           * @module dom
	                                                                                           */
	
	
	/**
	 * Detect if a value is a string with any non-whitespace characters.
	 *
	 * @param {string} str
	 *        The string to check
	 *
	 * @return {boolean}
	 *         - True if the string is non-blank
	 *         - False otherwise
	 *
	 */
	function isNonBlankString(str) {
	  return typeof str === 'string' && /\S/.test(str);
	}
	
	/**
	 * Throws an error if the passed string has whitespace. This is used by
	 * class methods to be relatively consistent with the classList API.
	 *
	 * @param {string} str
	 *         The string to check for whitespace.
	 *
	 * @throws {Error}
	 *         Throws an error if there is whitespace in the string.
	 *
	 */
	function throwIfWhitespace(str) {
	  if (/\s/.test(str)) {
	    throw new Error('class has illegal whitespace characters');
	  }
	}
	
	/**
	 * Produce a regular expression for matching a className within an elements className.
	 *
	 * @param {string} className
	 *         The className to generate the RegExp for.
	 *
	 * @return {RegExp}
	 *         The RegExp that will check for a specific `className` in an elements
	 *         className.
	 */
	function classRegExp(className) {
	  return new RegExp('(^|\\s)' + className + '($|\\s)');
	}
	
	/**
	 * Whether the current DOM interface appears to be real.
	 *
	 * @return {Boolean}
	 */
	function isReal() {
	  return (
	
	    // Both document and window will never be undefined thanks to `global`.
	    _document2['default'] === _window2['default'].document &&
	
	    // In IE < 9, DOM methods return "object" as their type, so all we can
	    // confidently check is that it exists.
	    typeof _document2['default'].createElement !== 'undefined'
	  );
	}
	
	/**
	 * Determines, via duck typing, whether or not a value is a DOM element.
	 *
	 * @param {Mixed} value
	 *        The thing to check
	 *
	 * @return {boolean}
	 *         - True if it is a DOM element
	 *         - False otherwise
	 */
	function isEl(value) {
	  return (0, _obj.isObject)(value) && value.nodeType === 1;
	}
	
	/**
	 * Creates functions to query the DOM using a given method.
	 *
	 * @param {string} method
	 *         The method to create the query with.
	 *
	 * @return {Function}
	 *         The query method
	 */
	function createQuerier(method) {
	  return function (selector, context) {
	    if (!isNonBlankString(selector)) {
	      return _document2['default'][method](null);
	    }
	    if (isNonBlankString(context)) {
	      context = _document2['default'].querySelector(context);
	    }
	
	    var ctx = isEl(context) ? context : _document2['default'];
	
	    return ctx[method] && ctx[method](selector);
	  };
	}
	
	/**
	 * Shorthand for document.getElementById()
	 * Also allows for CSS (jQuery) ID syntax. But nothing other than IDs.
	 *
	 * @param {string} id
	 *         The id of the element to get
	 *
	 * @return {Element|null}
	 *         Element with supplied ID or null if there wasn't one.
	 */
	function getEl(id) {
	  if (id.indexOf('#') === 0) {
	    id = id.slice(1);
	  }
	
	  return _document2['default'].getElementById(id);
	}
	
	/**
	 * Creates an element and applies properties.
	 *
	 * @param {string} [tagName='div']
	 *         Name of tag to be created.
	 *
	 * @param {Object} [properties={}]
	 *         Element properties to be applied.
	 *
	 * @param {Object} [attributes={}]
	 *         Element attributes to be applied.
	 *
	 * @param {String|Element|TextNode|Array|Function} [content]
	 *         Contents for the element (see: {@link dom:normalizeContent})
	 *
	 * @return {Element}
	 *         The element that was created.
	 */
	function createEl() {
	  var tagName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
	  var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var content = arguments[3];
	
	  var el = _document2['default'].createElement(tagName);
	
	  Object.getOwnPropertyNames(properties).forEach(function (propName) {
	    var val = properties[propName];
	
	    // See #2176
	    // We originally were accepting both properties and attributes in the
	    // same object, but that doesn't work so well.
	    if (propName.indexOf('aria-') !== -1 || propName === 'role' || propName === 'type') {
	      _log2['default'].warn((0, _tsml2['default'])(_templateObject, propName, val));
	      el.setAttribute(propName, val);
	
	      // Handle textContent since it's not supported everywhere and we have a
	      // method for it.
	    } else if (propName === 'textContent') {
	      textContent(el, val);
	    } else {
	      el[propName] = val;
	    }
	  });
	
	  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
	    el.setAttribute(attrName, attributes[attrName]);
	  });
	
	  if (content) {
	    appendContent(el, content);
	  }
	
	  return el;
	}
	
	/**
	 * Injects text into an element, replacing any existing contents entirely.
	 *
	 * @param {Element} el
	 *        The element to add text content into
	 *
	 * @param {string} text
	 *        The text content to add.
	 *
	 * @return {Element}
	 *         The element with added text content.
	 */
	function textContent(el, text) {
	  if (typeof el.textContent === 'undefined') {
	    el.innerText = text;
	  } else {
	    el.textContent = text;
	  }
	  return el;
	}
	
	/**
	 * Insert an element as the first child node of another
	 *
	 * @param {Element} child
	 *        Element to insert
	 *
	 * @param {Element} parent
	 *        Element to insert child into
	 *
	 */
	function insertElFirst(child, parent) {
	  if (parent.firstChild) {
	    parent.insertBefore(child, parent.firstChild);
	  } else {
	    parent.appendChild(child);
	  }
	}
	
	/**
	 * Element Data Store. Allows for binding data to an element without putting it directly on the element.
	 * Ex. Event listeners are stored here.
	 * (also from jsninja.com, slightly modified and updated for closure compiler)
	 *
	 * @type {Object}
	 * @private
	 */
	var elData = {};
	
	/*
	 * Unique attribute name to store an element's guid in
	 *
	 * @type {string}
	 * @constant
	 * @private
	 */
	var elIdAttr = 'vdata' + new Date().getTime();
	
	/**
	 * Returns the cache object where data for an element is stored
	 *
	 * @param {Element} el
	 *        Element to store data for.
	 *
	 * @return {Object}
	 *         The cache object for that el that was passed in.
	 */
	function getElData(el) {
	  var id = el[elIdAttr];
	
	  if (!id) {
	    id = el[elIdAttr] = Guid.newGUID();
	  }
	
	  if (!elData[id]) {
	    elData[id] = {};
	  }
	
	  return elData[id];
	}
	
	/**
	 * Returns whether or not an element has cached data
	 *
	 * @param {Element} el
	 *        Check if this element has cached data.
	 *
	 * @return {boolean}
	 *         - True if the DOM element has cached data.
	 *         - False otherwise.
	 */
	function hasElData(el) {
	  var id = el[elIdAttr];
	
	  if (!id) {
	    return false;
	  }
	
	  return !!Object.getOwnPropertyNames(elData[id]).length;
	}
	
	/**
	 * Delete data for the element from the cache and the guid attr from getElementById
	 *
	 * @param {Element} el
	 *        Remove cached data for this element.
	 */
	function removeElData(el) {
	  var id = el[elIdAttr];
	
	  if (!id) {
	    return;
	  }
	
	  // Remove all stored data
	  delete elData[id];
	
	  // Remove the elIdAttr property from the DOM node
	  try {
	    delete el[elIdAttr];
	  } catch (e) {
	    if (el.removeAttribute) {
	      el.removeAttribute(elIdAttr);
	    } else {
	      // IE doesn't appear to support removeAttribute on the document element
	      el[elIdAttr] = null;
	    }
	  }
	}
	
	/**
	 * Check if an element has a CSS class
	 *
	 * @param {Element} element
	 *        Element to check
	 *
	 * @param {string} classToCheck
	 *        Class name to check for
	 *
	 * @return {boolean}
	 *         - True if the element had the class
	 *         - False otherwise.
	 *
	 * @throws {Error}
	 *         Throws an error if `classToCheck` has white space.
	 */
	function hasElClass(element, classToCheck) {
	  throwIfWhitespace(classToCheck);
	  if (element.classList) {
	    return element.classList.contains(classToCheck);
	  }
	  return classRegExp(classToCheck).test(element.className);
	}
	
	/**
	 * Add a CSS class name to an element
	 *
	 * @param {Element} element
	 *        Element to add class name to.
	 *
	 * @param {string} classToAdd
	 *        Class name to add.
	 *
	 * @return {Element}
	 *         The dom element with the added class name.
	 */
	function addElClass(element, classToAdd) {
	  if (element.classList) {
	    element.classList.add(classToAdd);
	
	    // Don't need to `throwIfWhitespace` here because `hasElClass` will do it
	    // in the case of classList not being supported.
	  } else if (!hasElClass(element, classToAdd)) {
	    element.className = (element.className + ' ' + classToAdd).trim();
	  }
	
	  return element;
	}
	
	/**
	 * Remove a CSS class name from an element
	 *
	 * @param {Element} element
	 *        Element to remove a class name from.
	 *
	 * @param {string} classToRemove
	 *        Class name to remove
	 *
	 * @return {Element}
	 *         The dom element with class name removed.
	 */
	function removeElClass(element, classToRemove) {
	  if (element.classList) {
	    element.classList.remove(classToRemove);
	  } else {
	    throwIfWhitespace(classToRemove);
	    element.className = element.className.split(/\s+/).filter(function (c) {
	      return c !== classToRemove;
	    }).join(' ');
	  }
	
	  return element;
	}
	
	/**
	 * The callback definition for toggleElClass.
	 *
	 * @callback Dom~PredicateCallback
	 * @param {Element} element
	 *        The DOM element of the Component.
	 *
	 * @param {string} classToToggle
	 *        The `className` that wants to be toggled
	 *
	 * @return {boolean|undefined}
	 *         - If true the `classToToggle` will get added to `element`.
	 *         - If false the `classToToggle` will get removed from `element`.
	 *         - If undefined this callback will be ignored
	 */
	
	/**
	 * Adds or removes a CSS class name on an element depending on an optional
	 * condition or the presence/absence of the class name.
	 *
	 * @param {Element} element
	 *        The element to toggle a class name on.
	 *
	 * @param {string} classToToggle
	 *        The class that should be toggled
	 *
	 * @param {boolean|PredicateCallback} [predicate]
	 *        See the return value for {@link Dom~PredicateCallback}
	 *
	 * @return {Element}
	 *         The element with a class that has been toggled.
	 */
	function toggleElClass(element, classToToggle, predicate) {
	
	  // This CANNOT use `classList` internally because IE does not support the
	  // second parameter to the `classList.toggle()` method! Which is fine because
	  // `classList` will be used by the add/remove functions.
	  var has = hasElClass(element, classToToggle);
	
	  if (typeof predicate === 'function') {
	    predicate = predicate(element, classToToggle);
	  }
	
	  if (typeof predicate !== 'boolean') {
	    predicate = !has;
	  }
	
	  // If the necessary class operation matches the current state of the
	  // element, no action is required.
	  if (predicate === has) {
	    return;
	  }
	
	  if (predicate) {
	    addElClass(element, classToToggle);
	  } else {
	    removeElClass(element, classToToggle);
	  }
	
	  return element;
	}
	
	/**
	 * Apply attributes to an HTML element.
	 *
	 * @param {Element} el
	 *        Element to add attributes to.
	 *
	 * @param {Object} [attributes]
	 *        Attributes to be applied.
	 */
	function setElAttributes(el, attributes) {
	  Object.getOwnPropertyNames(attributes).forEach(function (attrName) {
	    var attrValue = attributes[attrName];
	
	    if (attrValue === null || typeof attrValue === 'undefined' || attrValue === false) {
	      el.removeAttribute(attrName);
	    } else {
	      el.setAttribute(attrName, attrValue === true ? '' : attrValue);
	    }
	  });
	}
	
	/**
	 * Get an element's attribute values, as defined on the HTML tag
	 * Attributes are not the same as properties. They're defined on the tag
	 * or with setAttribute (which shouldn't be used with HTML)
	 * This will return true or false for boolean attributes.
	 *
	 * @param {Element} tag
	 *        Element from which to get tag attributes.
	 *
	 * @return {Object}
	 *         All attributes of the element.
	 */
	function getElAttributes(tag) {
	  var obj = {};
	
	  // known boolean attributes
	  // we can check for matching boolean properties, but older browsers
	  // won't know about HTML5 boolean attributes that we still read from
	  var knownBooleans = ',' + 'autoplay,controls,playsinline,loop,muted,default,defaultMuted' + ',';
	
	  if (tag && tag.attributes && tag.attributes.length > 0) {
	    var attrs = tag.attributes;
	
	    for (var i = attrs.length - 1; i >= 0; i--) {
	      var attrName = attrs[i].name;
	      var attrVal = attrs[i].value;
	
	      // check for known booleans
	      // the matching element property will return a value for typeof
	      if (typeof tag[attrName] === 'boolean' || knownBooleans.indexOf(',' + attrName + ',') !== -1) {
	        // the value of an included boolean attribute is typically an empty
	        // string ('') which would equal false if we just check for a false value.
	        // we also don't want support bad code like autoplay='false'
	        attrVal = attrVal !== null ? true : false;
	      }
	
	      obj[attrName] = attrVal;
	    }
	  }
	
	  return obj;
	}
	
	/**
	 * Get the value of an element's attribute
	 *
	 * @param {Element} el
	 *        A DOM element
	 *
	 * @param {string} attribute
	 *        Attribute to get the value of
	 *
	 * @return {string}
	 *         value of the attribute
	 */
	function getAttribute(el, attribute) {
	  return el.getAttribute(attribute);
	}
	
	/**
	 * Set the value of an element's attribute
	 *
	 * @param {Element} el
	 *        A DOM element
	 *
	 * @param {string} attribute
	 *        Attribute to set
	 *
	 * @param {string} value
	 *        Value to set the attribute to
	 */
	function setAttribute(el, attribute, value) {
	  el.setAttribute(attribute, value);
	}
	
	/**
	 * Remove an element's attribute
	 *
	 * @param {Element} el
	 *        A DOM element
	 *
	 * @param {string} attribute
	 *        Attribute to remove
	 */
	function removeAttribute(el, attribute) {
	  el.removeAttribute(attribute);
	}
	
	/**
	 * Attempt to block the ability to select text while dragging controls
	 */
	function blockTextSelection() {
	  _document2['default'].body.focus();
	  _document2['default'].onselectstart = function () {
	    return false;
	  };
	}
	
	/**
	 * Turn off text selection blocking
	 */
	function unblockTextSelection() {
	  _document2['default'].onselectstart = function () {
	    return true;
	  };
	}
	
	/**
	 * The postion of a DOM element on the page.
	 *
	 * @typedef {Object} Dom~Position
	 *
	 * @property {number} left
	 *           Pixels to the left
	 *
	 * @property {number} top
	 *           Pixels on top
	 */
	
	/**
	 * Offset Left.
	 * getBoundingClientRect technique from
	 * John Resig
	 *
	 * @see http://ejohn.org/blog/getboundingclientrect-is-awesome/
	 *
	 * @param {Element} el
	 *        Element from which to get offset
	 *
	 * @return {Dom~Position}
	 *         The position of the element that was passed in.
	 */
	function findElPosition(el) {
	  var box = void 0;
	
	  if (el.getBoundingClientRect && el.parentNode) {
	    box = el.getBoundingClientRect();
	  }
	
	  if (!box) {
	    return {
	      left: 0,
	      top: 0
	    };
	  }
	
	  var docEl = _document2['default'].documentElement;
	  var body = _document2['default'].body;
	
	  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
	  var scrollLeft = _window2['default'].pageXOffset || body.scrollLeft;
	  var left = box.left + scrollLeft - clientLeft;
	
	  var clientTop = docEl.clientTop || body.clientTop || 0;
	  var scrollTop = _window2['default'].pageYOffset || body.scrollTop;
	  var top = box.top + scrollTop - clientTop;
	
	  // Android sometimes returns slightly off decimal values, so need to round
	  return {
	    left: Math.round(left),
	    top: Math.round(top)
	  };
	}
	
	/**
	 * x and y coordinates for a dom element or mouse pointer
	 *
	 * @typedef {Object} Dom~Coordinates
	 *
	 * @property {number} x
	 *           x coordinate in pixels
	 *
	 * @property {number} y
	 *           y coordinate in pixels
	 */
	
	/**
	 * Get pointer position in element
	 * Returns an object with x and y coordinates.
	 * The base on the coordinates are the bottom left of the element.
	 *
	 * @param {Element} el
	 *        Element on which to get the pointer position on
	 *
	 * @param {EventTarget~Event} event
	 *        Event object
	 *
	 * @return {Dom~Coordinates}
	 *         A Coordinates object corresponding to the mouse position.
	 *
	 */
	function getPointerPosition(el, event) {
	  var position = {};
	  var box = findElPosition(el);
	  var boxW = el.offsetWidth;
	  var boxH = el.offsetHeight;
	
	  var boxY = box.top;
	  var boxX = box.left;
	  var pageY = event.pageY;
	  var pageX = event.pageX;
	
	  if (event.changedTouches) {
	    pageX = event.changedTouches[0].pageX;
	    pageY = event.changedTouches[0].pageY;
	  }
	
	  position.y = Math.max(0, Math.min(1, (boxY - pageY + boxH) / boxH));
	  position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));
	
	  return position;
	}
	
	/**
	 * Determines, via duck typing, whether or not a value is a text node.
	 *
	 * @param {Mixed} value
	 *        Check if this value is a text node.
	 *
	 * @return {boolean}
	 *         - True if it is a text node
	 *         - False otherwise
	 */
	function isTextNode(value) {
	  return (0, _obj.isObject)(value) && value.nodeType === 3;
	}
	
	/**
	 * Empties the contents of an element.
	 *
	 * @param {Element} el
	 *        The element to empty children from
	 *
	 * @return {Element}
	 *         The element with no children
	 */
	function emptyEl(el) {
	  while (el.firstChild) {
	    el.removeChild(el.firstChild);
	  }
	  return el;
	}
	
	/**
	 * Normalizes content for eventual insertion into the DOM.
	 *
	 * This allows a wide range of content definition methods, but protects
	 * from falling into the trap of simply writing to `innerHTML`, which is
	 * an XSS concern.
	 *
	 * The content for an element can be passed in multiple types and
	 * combinations, whose behavior is as follows:
	 *
	 * @param {String|Element|TextNode|Array|Function} content
	 *        - String: Normalized into a text node.
	 *        - Element/TextNode: Passed through.
	 *        - Array: A one-dimensional array of strings, elements, nodes, or functions
	 *          (which return single strings, elements, or nodes).
	 *        - Function: If the sole argument, is expected to produce a string, element,
	 *          node, or array as defined above.
	 *
	 * @return {Array}
	 *         All of the content that was passed in normalized.
	 */
	function normalizeContent(content) {
	
	  // First, invoke content if it is a function. If it produces an array,
	  // that needs to happen before normalization.
	  if (typeof content === 'function') {
	    content = content();
	  }
	
	  // Next up, normalize to an array, so one or many items can be normalized,
	  // filtered, and returned.
	  return (Array.isArray(content) ? content : [content]).map(function (value) {
	
	    // First, invoke value if it is a function to produce a new value,
	    // which will be subsequently normalized to a Node of some kind.
	    if (typeof value === 'function') {
	      value = value();
	    }
	
	    if (isEl(value) || isTextNode(value)) {
	      return value;
	    }
	
	    if (typeof value === 'string' && /\S/.test(value)) {
	      return _document2['default'].createTextNode(value);
	    }
	  }).filter(function (value) {
	    return value;
	  });
	}
	
	/**
	 * Normalizes and appends content to an element.
	 *
	 * @param {Element} el
	 *        Element to append normalized content to.
	 *
	 *
	 * @param {String|Element|TextNode|Array|Function} content
	 *        See the `content` argument of {@link dom:normalizeContent}
	 *
	 * @return {Element}
	 *         The element with appended normalized content.
	 */
	function appendContent(el, content) {
	  normalizeContent(content).forEach(function (node) {
	    return el.appendChild(node);
	  });
	  return el;
	}
	
	/**
	 * Normalizes and inserts content into an element; this is identical to
	 * `appendContent()`, except it empties the element first.
	 *
	 * @param {Element} el
	 *        Element to insert normalized content into.
	 *
	 * @param {String|Element|TextNode|Array|Function} content
	 *        See the `content` argument of {@link dom:normalizeContent}
	 *
	 * @return {Element}
	 *         The element with inserted normalized content.
	 *
	 */
	function insertContent(el, content) {
	  return appendContent(emptyEl(el), content);
	}
	
	/**
	 * Finds a single DOM element matching `selector` within the optional
	 * `context` of another DOM element (defaulting to `document`).
	 *
	 * @param {string} selector
	 *        A valid CSS selector, which will be passed to `querySelector`.
	 *
	 * @param {Element|String} [context=document]
	 *        A DOM element within which to query. Can also be a selector
	 *        string in which case the first matching element will be used
	 *        as context. If missing (or no element matches selector), falls
	 *        back to `document`.
	 *
	 * @return {Element|null}
	 *         The element that was found or null.
	 */
	var $ = exports.$ = createQuerier('querySelector');
	
	/**
	 * Finds a all DOM elements matching `selector` within the optional
	 * `context` of another DOM element (defaulting to `document`).
	 *
	 * @param {string} selector
	 *           A valid CSS selector, which will be passed to `querySelectorAll`.
	 *
	 * @param {Element|String} [context=document]
	 *           A DOM element within which to query. Can also be a selector
	 *           string in which case the first matching element will be used
	 *           as context. If missing (or no element matches selector), falls
	 *           back to `document`.
	 *
	 * @return {NodeList}
	 *         A element list of elements that were found. Will be empty if none were found.
	 *
	 */
	var $$ = exports.$$ = createQuerier('querySelectorAll');


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(9)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {"use strict"
	// Module export pattern from
	// https://github.com/umdjs/umd/blob/master/returnExports.js
	;(function (root, factory) {
	    if (true) {
	        // AMD. Register as an anonymous module.
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        // Node. Does not work with strict CommonJS, but
	        // only CommonJS-like environments that support module.exports,
	        // like Node.
	        module.exports = factory();
	    } else {
	        // Browser globals (root is window)
	        root.store = factory();
	  }
	}(this, function () {
		
		// Store.js
		var store = {},
			win = (typeof window != 'undefined' ? window : global),
			doc = win.document,
			localStorageName = 'localStorage',
			scriptTag = 'script',
			storage
	
		store.disabled = false
		store.version = '1.3.20'
		store.set = function(key, value) {}
		store.get = function(key, defaultVal) {}
		store.has = function(key) { return store.get(key) !== undefined }
		store.remove = function(key) {}
		store.clear = function() {}
		store.transact = function(key, defaultVal, transactionFn) {
			if (transactionFn == null) {
				transactionFn = defaultVal
				defaultVal = null
			}
			if (defaultVal == null) {
				defaultVal = {}
			}
			var val = store.get(key, defaultVal)
			transactionFn(val)
			store.set(key, val)
		}
		store.getAll = function() {}
		store.forEach = function() {}
	
		store.serialize = function(value) {
			return JSON.stringify(value)
		}
		store.deserialize = function(value) {
			if (typeof value != 'string') { return undefined }
			try { return JSON.parse(value) }
			catch(e) { return value || undefined }
		}
	
		// Functions to encapsulate questionable FireFox 3.6.13 behavior
		// when about.config::dom.storage.enabled === false
		// See https://github.com/marcuswestin/store.js/issues#issue/13
		function isLocalStorageNameSupported() {
			try { return (localStorageName in win && win[localStorageName]) }
			catch(err) { return false }
		}
	
		if (isLocalStorageNameSupported()) {
			storage = win[localStorageName]
			store.set = function(key, val) {
				if (val === undefined) { return store.remove(key) }
				storage.setItem(key, store.serialize(val))
				return val
			}
			store.get = function(key, defaultVal) {
				var val = store.deserialize(storage.getItem(key))
				return (val === undefined ? defaultVal : val)
			}
			store.remove = function(key) { storage.removeItem(key) }
			store.clear = function() { storage.clear() }
			store.getAll = function() {
				var ret = {}
				store.forEach(function(key, val) {
					ret[key] = val
				})
				return ret
			}
			store.forEach = function(callback) {
				for (var i=0; i<storage.length; i++) {
					var key = storage.key(i)
					callback(key, store.get(key))
				}
			}
		} else if (doc && doc.documentElement.addBehavior) {
			var storageOwner,
				storageContainer
			// Since #userData storage applies only to specific paths, we need to
			// somehow link our data to a specific path.  We choose /favicon.ico
			// as a pretty safe option, since all browsers already make a request to
			// this URL anyway and being a 404 will not hurt us here.  We wrap an
			// iframe pointing to the favicon in an ActiveXObject(htmlfile) object
			// (see: http://msdn.microsoft.com/en-us/library/aa752574(v=VS.85).aspx)
			// since the iframe access rules appear to allow direct access and
			// manipulation of the document element, even for a 404 page.  This
			// document can be used instead of the current document (which would
			// have been limited to the current path) to perform #userData storage.
			try {
				storageContainer = new ActiveXObject('htmlfile')
				storageContainer.open()
				storageContainer.write('<'+scriptTag+'>document.w=window</'+scriptTag+'><iframe src="/favicon.ico"></iframe>')
				storageContainer.close()
				storageOwner = storageContainer.w.frames[0].document
				storage = storageOwner.createElement('div')
			} catch(e) {
				// somehow ActiveXObject instantiation failed (perhaps some special
				// security settings or otherwse), fall back to per-path storage
				storage = doc.createElement('div')
				storageOwner = doc.body
			}
			var withIEStorage = function(storeFunction) {
				return function() {
					var args = Array.prototype.slice.call(arguments, 0)
					args.unshift(storage)
					// See http://msdn.microsoft.com/en-us/library/ms531081(v=VS.85).aspx
					// and http://msdn.microsoft.com/en-us/library/ms531424(v=VS.85).aspx
					storageOwner.appendChild(storage)
					storage.addBehavior('#default#userData')
					storage.load(localStorageName)
					var result = storeFunction.apply(store, args)
					storageOwner.removeChild(storage)
					return result
				}
			}
	
			// In IE7, keys cannot start with a digit or contain certain chars.
			// See https://github.com/marcuswestin/store.js/issues/40
			// See https://github.com/marcuswestin/store.js/issues/83
			var forbiddenCharsRegex = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g")
			var ieKeyFix = function(key) {
				return key.replace(/^d/, '___$&').replace(forbiddenCharsRegex, '___')
			}
			store.set = withIEStorage(function(storage, key, val) {
				key = ieKeyFix(key)
				if (val === undefined) { return store.remove(key) }
				storage.setAttribute(key, store.serialize(val))
				storage.save(localStorageName)
				return val
			})
			store.get = withIEStorage(function(storage, key, defaultVal) {
				key = ieKeyFix(key)
				var val = store.deserialize(storage.getAttribute(key))
				return (val === undefined ? defaultVal : val)
			})
			store.remove = withIEStorage(function(storage, key) {
				key = ieKeyFix(key)
				storage.removeAttribute(key)
				storage.save(localStorageName)
			})
			store.clear = withIEStorage(function(storage) {
				var attributes = storage.XMLDocument.documentElement.attributes
				storage.load(localStorageName)
				for (var i=attributes.length-1; i>=0; i--) {
					storage.removeAttribute(attributes[i].name)
				}
				storage.save(localStorageName)
			})
			store.getAll = function(storage) {
				var ret = {}
				store.forEach(function(key, val) {
					ret[key] = val
				})
				return ret
			}
			store.forEach = withIEStorage(function(storage, callback) {
				var attributes = storage.XMLDocument.documentElement.attributes
				for (var i=0, attr; attr=attributes[i]; ++i) {
					callback(attr.name, store.deserialize(storage.getAttribute(attr.name)))
				}
			})
		}
	
		try {
			var testKey = '__storejs__'
			store.set(testKey, testKey)
			if (store.get(testKey) != testKey) { store.disabled = true }
			store.remove(testKey)
		} catch(e) {
			store.disabled = true
		}
		store.enabled = !store.disabled
		
		return store
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/*eslint-disable*/
	/**
	 * AltContainer.
	 *
	 * There are many ways to use AltContainer.
	 *
	 * Using the `stores` prop.
	 *
	 * <AltContainer stores={{ FooStore: FooStore }}>
	 *   children get this.props.FooStore.storeData
	 * </AltContainer>
	 *
	 * You can also pass in functions.
	 *
	 * <AltContainer stores={{ FooStore: function () { return { storeData: true } } }}>
	 *   children get this.props.FooStore.storeData
	 * </AltContainer>
	 *
	 * Using the `store` prop.
	 *
	 * <AltContainer store={FooStore}>
	 *   children get this.props.storeData
	 * </AltContainer>
	 *
	 * Passing in `flux` because you're using alt instances
	 *
	 * <AltContainer flux={flux}>
	 *   children get this.props.flux
	 * </AltContainer>
	 *
	 * Using a custom render function.
	 *
	 * <AltContainer
	 *   render={function (props) {
	 *     return <div />;
	 *   }}
	 * />
	 *
	 * Using the `transform` prop.
	 *
	 * <AltContainer
	 *   stores={{ FooStore: FooStore, BarStore: BarStore }}
	 *   transform={function(stores) {
	 *     var FooStore = stores.FooStore;
	 *     var BarStore = stores.BarStore;
	 *     var products =
	 *       FooStore.products
	 *         .slice(0, 10)
	 *         .concat(BarStore.products);
	 *     return { products: products };
	 *   }}
	 * >
	 *   children get this.props.products
	 * </AltContainer>
	 *
	 * Full docs available at http://goatslacker.github.io/alt/
	 */
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; desc = parent = getter = undefined; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(363);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _objectAssign = __webpack_require__(811);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var id = function id(it) {
	  return it;
	};
	var getStateFromStore = function getStateFromStore(store, props) {
	  return typeof store === 'function' ? store(props).value : store.getState();
	};
	var getStateFromKey = function getStateFromKey(actions, props) {
	  return typeof actions === 'function' ? actions(props) : actions;
	};
	
	var getStateFromActions = function getStateFromActions(props) {
	  if (props.actions) {
	    return getStateFromKey(props.actions, props);
	  } else {
	    return {};
	  }
	};
	
	var getInjected = function getInjected(props) {
	  if (props.inject) {
	    return Object.keys(props.inject).reduce(function (obj, key) {
	      obj[key] = getStateFromKey(props.inject[key], props);
	      return obj;
	    }, {});
	  } else {
	    return {};
	  }
	};
	
	var reduceState = function reduceState(props) {
	  return (0, _objectAssign2['default'])({}, getStateFromStores(props), getStateFromActions(props), getInjected(props));
	};
	
	var getStateFromStores = function getStateFromStores(props) {
	  var stores = props.stores;
	  if (props.store) {
	    return getStateFromStore(props.store, props);
	  } else if (props.stores) {
	    // If you pass in an array of stores then we are just listening to them
	    // it should be an object then the state is added to the key specified
	    if (!Array.isArray(stores)) {
	      return Object.keys(stores).reduce(function (obj, key) {
	        obj[key] = getStateFromStore(stores[key], props);
	        return obj;
	      }, {});
	    }
	  } else {
	    return {};
	  }
	};
	
	// TODO need to copy some other contextTypes maybe?
	// what about propTypes?
	
	var AltContainer = (function (_React$Component) {
	  _inherits(AltContainer, _React$Component);
	
	  _createClass(AltContainer, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var flux = this.props.flux || this.context.flux;
	      return flux ? { flux: flux } : {};
	    }
	  }], [{
	    key: 'contextTypes',
	    value: {
	      flux: _propTypes2['default'].object
	    },
	    enumerable: true
	  }, {
	    key: 'childContextTypes',
	    value: {
	      flux: _propTypes2['default'].object
	    },
	    enumerable: true
	  }]);
	
	  function AltContainer(props) {
	    var _this = this;
	
	    _classCallCheck(this, AltContainer);
	
	    _get(Object.getPrototypeOf(AltContainer.prototype), 'constructor', this).call(this, props);
	
	    this.altSetState = function () {
	      _this.setState(reduceState(_this.props));
	    };
	
	    if (props.stores && props.store) {
	      throw new ReferenceError('Cannot define both store and stores');
	    }
	
	    this.storeListeners = [];
	
	    this.state = reduceState(props);
	  }
	
	  _createClass(AltContainer, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this._destroySubscriptions();
	      this.setState(reduceState(nextProps));
	      this._registerStores(nextProps);
	      if (this.props.onWillReceiveProps) {
	        this.props.onWillReceiveProps(nextProps, this.props, this.context);
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._registerStores(this.props);
	      if (this.props.onMount) this.props.onMount(this.props, this.context);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._destroySubscriptions();
	      if (this.props.onWillUnmount) {
	        this.props.onWillUnmount(this.props, this.context);
	      }
	    }
	  }, {
	    key: '_registerStores',
	    value: function _registerStores(props) {
	      var _this2 = this;
	
	      var stores = props.stores;
	
	      if (props.store) {
	        this._addSubscription(props.store);
	      } else if (props.stores) {
	        if (Array.isArray(stores)) {
	          stores.forEach(function (store) {
	            return _this2._addSubscription(store);
	          });
	        } else {
	          Object.keys(stores).forEach(function (formatter) {
	            _this2._addSubscription(stores[formatter]);
	          });
	        }
	      }
	    }
	  }, {
	    key: '_destroySubscriptions',
	    value: function _destroySubscriptions() {
	      this.storeListeners.forEach(function (storeListener) {
	        return storeListener();
	      });
	    }
	  }, {
	    key: '_addSubscription',
	    value: function _addSubscription(getStore) {
	      var store = typeof getStore === 'function' ? getStore(this.props).store : getStore;
	
	      this.storeListeners.push(store.listen(this.altSetState));
	    }
	  }, {
	    key: 'getProps',
	    value: function getProps() {
	      var flux = this.props.flux || this.context.flux;
	      var transform = typeof this.props.transform === 'function' ? this.props.transform : id;
	      return transform((0, _objectAssign2['default'])(flux ? { flux: flux } : {}, this.state));
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return this.props.shouldComponentUpdate ? this.props.shouldComponentUpdate(this.getProps(), nextProps, nextState) : true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var Node = 'div';
	      var children = this.props.children;
	
	      // Custom rendering function
	      if (typeof this.props.render === 'function') {
	        return this.props.render(this.getProps());
	      } else if (this.props.component) {
	        return _react2['default'].createElement(this.props.component, this.getProps());
	      }
	
	      // Does not wrap child in a div if we don't have to.
	      if (Array.isArray(children)) {
	        return _react2['default'].createElement(Node, null, children.map(function (child, i) {
	          return _react2['default'].cloneElement(child, (0, _objectAssign2['default'])({ key: i }, _this3.getProps()));
	        }));
	      } else if (children) {
	        return _react2['default'].cloneElement(children, this.getProps());
	      } else {
	        return _react2['default'].createElement(Node, this.getProps());
	      }
	    }
	  }]);
	
	  return AltContainer;
	})(_react2['default'].Component);
	
	exports['default'] = AltContainer;
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(5);
	var IE8_DOM_DEFINE = __webpack_require__(286);
	var toPrimitive = __webpack_require__(60);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(19) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(58);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var topLevel = typeof global !== 'undefined' ? global :
	    typeof window !== 'undefined' ? window : {}
	var minDoc = __webpack_require__(1036);
	
	if (typeof document !== 'undefined') {
	    module.exports = document;
	} else {
	    var doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'];
	
	    if (!doccy) {
	        doccy = topLevel['__GLOBAL_DOCUMENT_CACHE@4'] = minDoc;
	    }
	
	    module.exports = doccy;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(38);
	var isNil = __webpack_require__(82);
	var fail = __webpack_require__(938);
	var stringify = __webpack_require__(413);
	
	function assert(guard, message) {
	  if (guard !== true) {
	    if (isFunction(message)) { // handle lazy messages
	      message = message();
	    }
	    else if (isNil(message)) { // use a default message
	      message = 'Assert failed (turn on "Pause on exceptions" in your Source panel)';
	    }
	    assert.fail(message);
	  }
	}
	
	assert.fail = fail;
	assert.stringify = stringify;
	
	module.exports = assert;

/***/ }),
/* 26 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {if (typeof window !== "undefined") {
	    module.exports = window;
	} else if (typeof global !== "undefined") {
	    module.exports = global;
	} else if (typeof self !== "undefined"){
	    module.exports = self;
	} else {
	    module.exports = {};
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  (global.Immutable = factory());
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step !== 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      if (o !== o || o === Infinity) {
	        return 0;
	      }
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.of = function() {var keyValues = SLICE$0.call(arguments, 0);
	      return emptyMap().withMutations(function(map ) {
	        for (var i = 0; i < keyValues.length; i += 2) {
	          if (i + 1 >= keyValues.length) {
	            throw new Error('Missing value for key: ' + keyValues[i]);
	          }
	          map.set(keyValues[i], keyValues[i + 1]);
	        }
	      });
	    };
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      if (end === Infinity) {
	        end = originalSize;
	      } else {
	        end = end | 0;
	      }
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      if (this._map && !this._map.has(k)) {
	        var defaultVal = this._defaultValues[k];
	        if (v === defaultVal) {
	          return this;
	        }
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findEntry: function(predicate, context, notSetValue) {
	      var found = notSetValue;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    findLastEntry: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toKeyedSeq().reverse().findKey(predicate, context);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.toKeyedSeq().reverse().keyOf(searchValue);
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.lastKeyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var entry = this.findLastEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    keySeq: function() {
	      return Range(0, this.size);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	  SetIterable.prototype.contains = SetIterable.prototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : String(value);
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.BACKGROUND_SIZE_SUPPORTED = exports.TOUCH_ENABLED = exports.IS_ANY_SAFARI = exports.IS_SAFARI = exports.IE_VERSION = exports.IS_IE8 = exports.CHROME_VERSION = exports.IS_CHROME = exports.IS_EDGE = exports.IS_FIREFOX = exports.IS_NATIVE_ANDROID = exports.IS_OLD_ANDROID = exports.ANDROID_VERSION = exports.IS_ANDROID = exports.IOS_VERSION = exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = undefined;
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 * @file browser.js
	 * @module browser
	 */
	var USER_AGENT = _window2['default'].navigator && _window2['default'].navigator.userAgent || '';
	var webkitVersionMap = /AppleWebKit\/([\d.]+)/i.exec(USER_AGENT);
	var appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;
	
	/*
	 * Device is an iPhone
	 *
	 * @type {Boolean}
	 * @constant
	 * @private
	 */
	var IS_IPAD = exports.IS_IPAD = /iPad/i.test(USER_AGENT);
	
	// The Facebook app's UIWebView identifies as both an iPhone and iPad, so
	// to identify iPhones, we need to exclude iPads.
	// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/
	var IS_IPHONE = exports.IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
	var IS_IPOD = exports.IS_IPOD = /iPod/i.test(USER_AGENT);
	var IS_IOS = exports.IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
	
	var IOS_VERSION = exports.IOS_VERSION = function () {
	  var match = USER_AGENT.match(/OS (\d+)_/i);
	
	  if (match && match[1]) {
	    return match[1];
	  }
	  return null;
	}();
	
	var IS_ANDROID = exports.IS_ANDROID = /Android/i.test(USER_AGENT);
	var ANDROID_VERSION = exports.ANDROID_VERSION = function () {
	  // This matches Android Major.Minor.Patch versions
	  // ANDROID_VERSION is Major.Minor as a Number, if Minor isn't available, then only Major is returned
	  var match = USER_AGENT.match(/Android (\d+)(?:\.(\d+))?(?:\.(\d+))*/i);
	
	  if (!match) {
	    return null;
	  }
	
	  var major = match[1] && parseFloat(match[1]);
	  var minor = match[2] && parseFloat(match[2]);
	
	  if (major && minor) {
	    return parseFloat(match[1] + '.' + match[2]);
	  } else if (major) {
	    return major;
	  }
	  return null;
	}();
	
	// Old Android is defined as Version older than 2.3, and requiring a webkit version of the android browser
	var IS_OLD_ANDROID = exports.IS_OLD_ANDROID = IS_ANDROID && /webkit/i.test(USER_AGENT) && ANDROID_VERSION < 2.3;
	var IS_NATIVE_ANDROID = exports.IS_NATIVE_ANDROID = IS_ANDROID && ANDROID_VERSION < 5 && appleWebkitVersion < 537;
	
	var IS_FIREFOX = exports.IS_FIREFOX = /Firefox/i.test(USER_AGENT);
	var IS_EDGE = exports.IS_EDGE = /Edge/i.test(USER_AGENT);
	var IS_CHROME = exports.IS_CHROME = !IS_EDGE && /Chrome/i.test(USER_AGENT);
	var CHROME_VERSION = exports.CHROME_VERSION = function () {
	  var match = USER_AGENT.match(/Chrome\/(\d+)/);
	
	  if (match && match[1]) {
	    return parseFloat(match[1]);
	  }
	  return null;
	}();
	var IS_IE8 = exports.IS_IE8 = /MSIE\s8\.0/.test(USER_AGENT);
	var IE_VERSION = exports.IE_VERSION = function () {
	  var result = /MSIE\s(\d+)\.\d/.exec(USER_AGENT);
	  var version = result && parseFloat(result[1]);
	
	  if (!version && /Trident\/7.0/i.test(USER_AGENT) && /rv:11.0/.test(USER_AGENT)) {
	    // IE 11 has a different user agent string than other IE versions
	    version = 11.0;
	  }
	
	  return version;
	}();
	
	var IS_SAFARI = exports.IS_SAFARI = /Safari/i.test(USER_AGENT) && !IS_CHROME && !IS_ANDROID && !IS_EDGE;
	var IS_ANY_SAFARI = exports.IS_ANY_SAFARI = IS_SAFARI || IS_IOS;
	
	var TOUCH_ENABLED = exports.TOUCH_ENABLED = Dom.isReal() && ('ontouchstart' in _window2['default'] || _window2['default'].DocumentTouch && _window2['default'].document instanceof _window2['default'].DocumentTouch);
	
	var BACKGROUND_SIZE_SUPPORTED = exports.BACKGROUND_SIZE_SUPPORTED = Dom.isReal() && 'backgroundSize' in _window2['default'].document.createElement('video').style;


/***/ }),
/* 29 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ExecutionEnvironment
	 */
	
	/*jslint evil: true */
	
	"use strict";
	
	var canUseDOM = !!(
	  (typeof window !== 'undefined' &&
	  window.document && window.document.createElement)
	);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners:
	    canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;


/***/ }),
/* 31 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.each = each;
	exports.reduce = reduce;
	exports.assign = assign;
	exports.isObject = isObject;
	exports.isPlain = isPlain;
	/**
	 * @file obj.js
	 * @module obj
	 */
	
	/**
	 * @callback obj:EachCallback
	 *
	 * @param {Mixed} value
	 *        The current key for the object that is being iterated over.
	 *
	 * @param {string} key
	 *        The current key-value for object that is being iterated over
	 */
	
	/**
	 * @callback obj:ReduceCallback
	 *
	 * @param {Mixed} accum
	 *        The value that is accumulating over the reduce loop.
	 *
	 * @param {Mixed} value
	 *        The current key for the object that is being iterated over.
	 *
	 * @param {string} key
	 *        The current key-value for object that is being iterated over
	 *
	 * @return {Mixed}
	 *         The new accumulated value.
	 */
	var toString = Object.prototype.toString;
	
	/**
	 * Get the keys of an Object
	 *
	 * @param {Object}
	 *        The Object to get the keys from
	 *
	 * @return {string[]}
	 *         An array of the keys from the object. Returns an empty array if the
	 *         object passed in was invalid or had no keys.
	 *
	 * @private
	 */
	var keys = function keys(object) {
	  return isObject(object) ? Object.keys(object) : [];
	};
	
	/**
	 * Array-like iteration for objects.
	 *
	 * @param {Object} object
	 *        The object to iterate over
	 *
	 * @param {obj:EachCallback} fn
	 *        The callback function which is called for each key in the object.
	 */
	function each(object, fn) {
	  keys(object).forEach(function (key) {
	    return fn(object[key], key);
	  });
	}
	
	/**
	 * Array-like reduce for objects.
	 *
	 * @param {Object} object
	 *        The Object that you want to reduce.
	 *
	 * @param {Function} fn
	 *         A callback function which is called for each key in the object. It
	 *         receives the accumulated value and the per-iteration value and key
	 *         as arguments.
	 *
	 * @param {Mixed} [initial = 0]
	 *        Starting value
	 *
	 * @return {Mixed}
	 *         The final accumulated value.
	 */
	function reduce(object, fn) {
	  var initial = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	
	  return keys(object).reduce(function (accum, key) {
	    return fn(accum, object[key], key);
	  }, initial);
	}
	
	/**
	 * Object.assign-style object shallow merge/extend.
	 *
	 * @param  {Object} target
	 * @param  {Object} ...sources
	 * @return {Object}
	 */
	function assign(target) {
	  for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    sources[_key - 1] = arguments[_key];
	  }
	
	  if (Object.assign) {
	    return Object.assign.apply(Object, [target].concat(sources));
	  }
	
	  sources.forEach(function (source) {
	    if (!source) {
	      return;
	    }
	
	    each(source, function (value, key) {
	      target[key] = value;
	    });
	  });
	
	  return target;
	}
	
	/**
	 * Returns whether a value is an object of any kind - including DOM nodes,
	 * arrays, regular expressions, etc. Not functions, though.
	 *
	 * This avoids the gotcha where using `typeof` on a `null` value
	 * results in `'object'`.
	 *
	 * @param  {Object} value
	 * @return {Boolean}
	 */
	function isObject(value) {
	  return !!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
	}
	
	/**
	 * Returns whether an object appears to be a "plain" object - that is, a
	 * direct instance of `Object`.
	 *
	 * @param  {Object} value
	 * @return {Boolean}
	 */
	function isPlain(value) {
	  return isObject(value) && toString.call(value) === '[object Object]' && value.constructor === Object;
	}


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	
	    toggleClass: function toggleClass(el, className) {
	        if (el.classList) {
	            el.classList.toggle(className);
	        } else {
	            var classes = el.className.split(' ');
	            var existingIndex = classes.indexOf(className);
	
	            if (existingIndex >= 0) {
	                classes.splice(existingIndex, 1);
	            } else {
	                classes.push(className);
	            }
	            el.className = classes.join(' ');
	        }
	    },
	
	    removeClass: function removeClass(el, className) {
	        if (el.classList) {
	            el.classList.remove(className);
	        } else {
	            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	        }
	    },
	
	    addClass: function addClass(el, className) {
	        if (el.classList) {
	            el.classList.add(className);
	        } else {
	            el.className += ' ' + className;
	        }
	    },
	
	    hasClass: function hasClass(el, className) {
	        var truthy = false;
	        if (el.classList) {
	            truthy = el.classList.contains(className);
	        } else {
	            truthy = new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
	        }
	        return truthy;
	    },
	
	    setInnerHtml: function setInnerHtml(html) {
	        return { __html: html };
	    },
	
	    setAttributes: function setAttributes(el, attrs) {
	        for (var key in attrs) {
	            el.setAttribute(key, attrs[key]);
	        }
	    }
	};
	module.exports = exports['default'];

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(22);
	var createDesc = __webpack_require__(91);
	module.exports = __webpack_require__(19) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var hide = __webpack_require__(33);
	var has = __webpack_require__(41);
	var SRC = __webpack_require__(95)('src');
	var $toString = __webpack_require__(547);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(40).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var fails = __webpack_require__(9);
	var defined = __webpack_require__(58);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(55);
	var getFunctionName = __webpack_require__(178);
	
	module.exports = function getTypeName(constructor) {
	  if (isType(constructor)) {
	    return constructor.displayName;
	  }
	  return getFunctionName(constructor);
	};

/***/ }),
/* 38 */
/***/ (function(module, exports) {

	module.exports = function isFunction(x) {
	  return typeof x === 'function';
	};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.logByType = undefined;
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _browser = __webpack_require__(28);
	
	var _obj = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var log = void 0;
	
	/**
	 * Log messages to the console and history based on the type of message
	 *
	 * @param  {string} type
	 *         The name of the console method to use.
	 *
	 * @param  {Array} args
	 *         The arguments to be passed to the matching console method.
	 *
	 * @param  {boolean} [stringify]
	 *         By default, only old IEs should get console argument stringification,
	 *         but this is exposed as a parameter to facilitate testing.
	 */
	/**
	 * @file log.js
	 * @module log
	 */
	var logByType = exports.logByType = function logByType(type, args) {
	  var stringify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !!_browser.IE_VERSION && _browser.IE_VERSION < 11;
	
	
	  if (type !== 'log') {
	
	    // add the type to the front of the message when it's not "log"
	    args.unshift(type.toUpperCase() + ':');
	  }
	
	  // add to history
	  log.history.push(args);
	
	  // add console prefix after adding to history
	  args.unshift('VIDEOJS:');
	
	  // If there's no console then don't try to output messages, but they will
	  // still be stored in `log.history`.
	  //
	  // Was setting these once outside of this function, but containing them
	  // in the function makes it easier to test cases where console doesn't exist
	  // when the module is executed.
	  var fn = _window2['default'].console && _window2['default'].console[type];
	
	  // Bail out if there's no console.
	  if (!fn) {
	    return;
	  }
	
	  // IEs previous to 11 log objects uselessly as "[object Object]"; so, JSONify
	  // objects and arrays for those less-capable browsers.
	  if (stringify) {
	    args = args.map(function (a) {
	      if ((0, _obj.isObject)(a) || Array.isArray(a)) {
	        try {
	          return JSON.stringify(a);
	        } catch (x) {
	          return String(a);
	        }
	      }
	
	      // Cast to string before joining, so we get null and undefined explicitly
	      // included in output (as we would in a modern console).
	      return String(a);
	    }).join(' ');
	  }
	
	  // Old IE versions do not allow .apply() for console methods (they are
	  // reported as objects rather than functions).
	  if (!fn.apply) {
	    fn(args);
	  } else {
	    fn[Array.isArray(args) ? 'apply' : 'call'](_window2['default'].console, args);
	  }
	};
	
	/**
	 * Log plain debug messages
	 *
	 * @param {Mixed[]} args
	 *        One or more messages or objects that should be logged.
	 */
	log = function log() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  logByType('log', args);
	};
	
	/**
	 * Keep a history of log messages
	 *
	 * @type {Array}
	 */
	log.history = [];
	
	/**
	 * Log error messages
	 *
	 * @param {Mixed[]} args
	 *        One or more messages or objects that should be logged as an error
	 */
	log.error = function () {
	  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return logByType('error', args);
	};
	
	/**
	 * Log warning messages
	 *
	 * @param {Mixed[]} args
	 *        One or more messages or objects that should be logged as a warning.
	 */
	log.warn = function () {
	  for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	    args[_key3] = arguments[_key3];
	  }
	
	  return logByType('warn', args);
	};
	
	exports['default'] = log;


/***/ }),
/* 40 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 41 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(125);
	var createDesc = __webpack_require__(91);
	var toIObject = __webpack_require__(44);
	var toPrimitive = __webpack_require__(60);
	var has = __webpack_require__(41);
	var IE8_DOM_DEFINE = __webpack_require__(286);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(19) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(41);
	var toObject = __webpack_require__(23);
	var IE_PROTO = __webpack_require__(214)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(124);
	var defined = __webpack_require__(58);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(137);
	
	var PropagationPhases = keyMirror({bubbled: null, captured: null});
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topBlur: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topReset: null,
	  topScroll: null,
	  topSelectionChange: null,
	  topSubmit: null,
	  topTextInput: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var ReactComponent = __webpack_require__(381);
	var ReactCurrentOwner = __webpack_require__(72);
	var ReactElement = __webpack_require__(16);
	var ReactErrorUtils = __webpack_require__(872);
	var ReactInstanceMap = __webpack_require__(117);
	var ReactLifeCycle = __webpack_require__(249);
	var ReactPropTypeLocations = __webpack_require__(250);
	var ReactPropTypeLocationNames = __webpack_require__(173);
	var ReactUpdateQueue = __webpack_require__(251);
	
	var assign = __webpack_require__(11);
	var invariant = __webpack_require__(6);
	var keyMirror = __webpack_require__(137);
	var keyOf = __webpack_require__(74);
	var warning = __webpack_require__(17);
	
	var MIXINS_KEY = keyOf({mixins: null});
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or native components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function(Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function(Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function(Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(
	        Constructor,
	        childContextTypes,
	        ReactPropTypeLocations.childContext
	      );
	    }
	    Constructor.childContextTypes = assign(
	      {},
	      Constructor.childContextTypes,
	      childContextTypes
	    );
	  },
	  contextTypes: function(Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(
	        Constructor,
	        contextTypes,
	        ReactPropTypeLocations.context
	      );
	    }
	    Constructor.contextTypes = assign(
	      {},
	      Constructor.contextTypes,
	      contextTypes
	    );
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function(Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(
	        Constructor.getDefaultProps,
	        getDefaultProps
	      );
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function(Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(
	        Constructor,
	        propTypes,
	        ReactPropTypeLocations.prop
	      );
	    }
	    Constructor.propTypes = assign(
	      {},
	      Constructor.propTypes,
	      propTypes
	    );
	  },
	  statics: function(Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  }
	};
	
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but not in __DEV__
	      ( false ? warning(
	        typeof typeDef[propName] === 'function',
	        '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	        'React.PropTypes.',
	        Constructor.displayName || 'ReactClass',
	        ReactPropTypeLocationNames[location],
	        propName
	      ) : null);
	    }
	  }
	}
	
	function validateMethodOverride(proto, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ?
	    ReactClassInterface[name] :
	    null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    ( false ? invariant(
	      specPolicy === SpecPolicy.OVERRIDE_BASE,
	      'ReactClassInterface: You are attempting to override ' +
	      '`%s` from your class specification. Ensure that your method names ' +
	      'do not overlap with React methods.',
	      name
	    ) : invariant(specPolicy === SpecPolicy.OVERRIDE_BASE));
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (proto.hasOwnProperty(name)) {
	    ( false ? invariant(
	      specPolicy === SpecPolicy.DEFINE_MANY ||
	      specPolicy === SpecPolicy.DEFINE_MANY_MERGED,
	      'ReactClassInterface: You are attempting to define ' +
	      '`%s` on your component more than once. This conflict may be due ' +
	      'to a mixin.',
	      name
	    ) : invariant(specPolicy === SpecPolicy.DEFINE_MANY ||
	    specPolicy === SpecPolicy.DEFINE_MANY_MERGED));
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classses.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  ( false ? invariant(
	    typeof spec !== 'function',
	    'ReactClass: You\'re attempting to ' +
	    'use a component class as a mixin. Instead, just use a regular object.'
	  ) : invariant(typeof spec !== 'function'));
	  ( false ? invariant(
	    !ReactElement.isValidElement(spec),
	    'ReactClass: You\'re attempting to ' +
	    'use a component as a mixin. Instead, just use a regular object.'
	  ) : invariant(!ReactElement.isValidElement(spec)));
	
	  var proto = Constructor.prototype;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above
	      continue;
	    }
	
	    var property = spec[name];
	    validateMethodOverride(proto, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod =
	        ReactClassInterface.hasOwnProperty(name);
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      var markedDontBind = property && property.__reactDontBind;
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind =
	        isFunction &&
	        !isReactClassMethod &&
	        !isAlreadyDefined &&
	        !markedDontBind;
	
	      if (shouldAutoBind) {
	        if (!proto.__reactAutoBindMap) {
	          proto.__reactAutoBindMap = {};
	        }
	        proto.__reactAutoBindMap[name] = property;
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride
	          ( false ? invariant(
	            isReactClassMethod && (
	              (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)
	            ),
	            'ReactClass: Unexpected spec policy %s for key %s ' +
	            'when mixing in component specs.',
	            specPolicy,
	            name
	          ) : invariant(isReactClassMethod && (
	            (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)
	          )));
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    ( false ? invariant(
	      !isReserved,
	      'ReactClass: You are attempting to define a reserved ' +
	      'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	      'as an instance property instead; it will still be accessible on the ' +
	      'constructor.',
	      name
	    ) : invariant(!isReserved));
	
	    var isInherited = name in Constructor;
	    ( false ? invariant(
	      !isInherited,
	      'ReactClass: You are attempting to define ' +
	      '`%s` on your component more than once. This conflict may be ' +
	      'due to a mixin.',
	      name
	    ) : invariant(!isInherited));
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  ( false ? invariant(
	    one && two && typeof one === 'object' && typeof two === 'object',
	    'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	  ) : invariant(one && two && typeof one === 'object' && typeof two === 'object'));
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      ( false ? invariant(
	        one[key] === undefined,
	        'mergeIntoWithNoDuplicateKeys(): ' +
	        'Tried to merge two objects with the same key: `%s`. This conflict ' +
	        'may be due to a mixin; in particular, this may be caused by two ' +
	        'getInitialState() or getDefaultProps() methods returning objects ' +
	        'with clashing keys.',
	        key
	      ) : invariant(one[key] === undefined));
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    /* eslint-disable block-scoped-var, no-undef */
	    boundMethod.bind = function(newThis ) {for (var args=[],$__0=1,$__1=arguments.length;$__0<$__1;$__0++) args.push(arguments[$__0]);
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'bind(): React component methods may only be bound to the ' +
	          'component instance. See %s',
	          componentName
	        ) : null);
	      } else if (!args.length) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'bind(): You are binding a component method to the component. ' +
	          'React does this for you automatically in a high-performance ' +
	          'way, so you can safely remove this call. See %s',
	          componentName
	        ) : null);
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	      /* eslint-enable */
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  for (var autoBindKey in component.__reactAutoBindMap) {
	    if (component.__reactAutoBindMap.hasOwnProperty(autoBindKey)) {
	      var method = component.__reactAutoBindMap[autoBindKey];
	      component[autoBindKey] = bindAutoBindMethod(
	        component,
	        ReactErrorUtils.guard(
	          method,
	          component.constructor.displayName + '.' + autoBindKey
	        )
	      );
	    }
	  }
	}
	
	var typeDeprecationDescriptor = {
	  enumerable: false,
	  get: function() {
	    var displayName = this.displayName || this.name || 'Component';
	    ( false ? warning(
	      false,
	      '%s.type is deprecated. Use %s directly to access the class.',
	      displayName,
	      displayName
	    ) : null);
	    Object.defineProperty(this, 'type', {
	      value: this
	    });
	    return this;
	  }
	};
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function(newState, callback) {
	    ReactUpdateQueue.enqueueReplaceState(this, newState);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function() {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          owner._warnedAboutRefsInRender,
	          '%s is accessing isMounted inside its render() function. ' +
	          'render() should be a pure function of props and state. It should ' +
	          'never access something that requires stale data from the previous ' +
	          'render, such as refs. Move this logic to componentDidMount and ' +
	          'componentDidUpdate instead.',
	          owner.getName() || 'A component'
	        ) : null);
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(this);
	    return (
	      internalInstance &&
	      internalInstance !== ReactLifeCycle.currentlyMountingInstance
	    );
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  setProps: function(partialProps, callback) {
	    ReactUpdateQueue.enqueueSetProps(this, partialProps);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  },
	
	  /**
	   * Replace all the props.
	   *
	   * @param {object} newProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @public
	   * @deprecated
	   */
	  replaceProps: function(newProps, callback) {
	    ReactUpdateQueue.enqueueReplaceProps(this, newProps);
	    if (callback) {
	      ReactUpdateQueue.enqueueCallback(this, callback);
	    }
	  }
	};
	
	var ReactClassComponent = function() {};
	assign(
	  ReactClassComponent.prototype,
	  ReactComponent.prototype,
	  ReactClassMixin
	);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function(spec) {
	    var Constructor = function(props, context) {
	      // This constructor is overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	          'JSX instead. See: https://fb.me/react-legacyfactory'
	        ) : null);
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindMap) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (typeof initialState === 'undefined' &&
	            this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      ( false ? invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      ) : invariant(typeof initialState === 'object' && !Array.isArray(initialState)));
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	
	    injectedMixins.forEach(
	      mixSpecIntoComponent.bind(null, Constructor)
	    );
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    ( false ? invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    ) : invariant(Constructor.prototype.render));
	
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	        'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	        'The name is phrased as a question because the function is ' +
	        'expected to return a value.',
	        spec.displayName || 'A component'
	      ) : null);
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    // Legacy hook
	    Constructor.type = Constructor;
	    if (false) {
	      try {
	        Object.defineProperty(Constructor, 'type', typeDeprecationDescriptor);
	      } catch (x) {
	        // IE will fail on defineProperty (es5-shim/sham too)
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function(mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isString = __webpack_require__(179);
	var isFunction = __webpack_require__(38);
	var forbidNewOperator = __webpack_require__(139);
	
	module.exports = function irreducible(name, predicate) {
	
	  if (false) {
	    assert(isString(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to irreducible(name, predicate) (expected a string)'; });
	    assert(isFunction(predicate), 'Invalid argument predicate ' + assert.stringify(predicate) + ' supplied to irreducible(name, predicate) (expected a function)');
	  }
	
	  function Irreducible(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Irreducible);
	      path = path || [name];
	      assert(predicate(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return value;
	  }
	
	  Irreducible.meta = {
	    kind: 'irreducible',
	    name: name,
	    predicate: predicate,
	    identity: true
	  };
	
	  Irreducible.displayName = name;
	
	  Irreducible.is = predicate;
	
	  return Irreducible;
	};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _spinJs = __webpack_require__(924);
	
	var _spinJs2 = _interopRequireDefault(_spinJs);
	
	var LoadingSpinner = _react2['default'].createClass({
	    displayName: 'LoadingSpinner',
	    getDefaultProps: function getDefaultProps() {
	        return {
	            config: {
	                lines: 15,
	                radius: 31,
	                width: 4,
	                length: 0,
	                trail: 63,
	                color: '#aaaaaa'
	            }
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        this.spinner = new _spinJs2['default'](this.props.config);
	        this.spinner.spin(this.refs.container.getDOMNode());
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(newProps) {
	        if (newProps.stopped === true && !this.props.stopped) {
	            this.spinner.stop();
	        } else if (!newProps.stopped && this.props.stopped === true) {
	            this.spinner.spin(this.refs.container.getDOMNode());
	        }
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        this.spinner.stop();
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'spinner' },
	            _react2['default'].createElement('span', { ref: 'container' })
	        );
	    }
	});
	
	module.exports = LoadingSpinner;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _reqwest = __webpack_require__(921);
	
	var _reqwest2 = _interopRequireDefault(_reqwest);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var accessToken = null;
	var runningRequests = {}; // URL => Request
	
	exports['default'] = {
	    cachedImagePath: function cachedImagePath(imageUrl) {
	        var width = arguments.length <= 1 || arguments[1] === undefined ? 650 : arguments[1];
	
	        return imageUrl; //'https://images.msnode.de/display?url=' + imageUrl + '&w=' + width + '&h=0&op=resize&upscale=0';
	    },
	    removeToken: function removeToken() {
	        accessToken = null;
	    },
	    registerToken: function registerToken(token) {
	        accessToken = token;
	    },
	    getHtml: function getHtml(url) {
	        return (0, _reqwest2['default'])({
	            url: url,
	            method: 'get'
	        });
	    },
	    getLocale: function getLocale(locale) {
	        // loca the local from local
	        if (!!locale) {
	            return this.get('language/' + locale, {});
	        } else {
	            return this.get('language', {});
	        }
	    },
	    getNoAuth: function getNoAuth(url, params) {
	        return (0, _reqwest2['default'])({
	            url: window.config.baseUrl + '/' + url,
	            data: params,
	            type: 'json',
	            method: 'get'
	        });
	    },
	    get: function get(url, params) {
	        if (runningRequests[url] !== undefined) {
	            try {
	                runningRequests[url].abort();
	            } catch (ex) {
	                // Ignore Exceptions on Abort
	            }
	            console.log("Called abort");
	        }
	        var request = (0, _reqwest2['default'])({
	            url: window.config.baseUrl + '/' + url,
	            data: params,
	            type: 'json',
	            method: 'get',
	            headers: {
	                'Authorization': accessToken
	            },
	            complete: function complete(resp) {
	                console.log("Calling Complete");
	                delete runningRequests[url];
	            }
	        });
	        console.log("Created new Request");
	        runningRequests[url] = request;
	        return request;
	    },
	    post: function post(url, params, success, error) {
	        return (0, _reqwest2['default'])({
	            url: window.config.baseUrl + '/' + url,
	            data: JSON.stringify(params),
	            type: 'json',
	            method: 'post',
	            contentType: 'application/json',
	            headers: {
	                'Authorization': accessToken,
	                'X-CSRF-Token': _store2['default'].get('_CSRF')
	            },
	            success: success,
	            error: error
	        });
	    },
	    upload: function upload(url, formData, success, error) {
	        return (0, _reqwest2['default'])({
	            url: window.config.baseUrl + '/' + url,
	            data: formData,
	            type: 'json',
	            method: 'post',
	            processData: false,
	            contentType: 'multipart/form-data',
	            headers: {
	                'Authorization': accessToken,
	                'X-CSRF-Token': _store2['default'].get('_CSRF')
	            },
	            success: success,
	            error: error
	        });
	    }
	};
	module.exports = exports['default'];

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(29);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(9);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(164),
	    isLength = __webpack_require__(128),
	    isObjectLike = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	module.exports = isArray;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(38);
	var isObject = __webpack_require__(103);
	
	module.exports = function isType(x) {
	  return isFunction(x) && isObject(x.meta);
	};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	var isNil = __webpack_require__(82);
	var isString = __webpack_require__(179);
	
	module.exports = function isTypeName(name) {
	  return isNil(name) || isString(name);
	};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(51);
	var IObject = __webpack_require__(124);
	var toObject = __webpack_require__(23);
	var toLength = __webpack_require__(15);
	var asc = __webpack_require__(198);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(1);
	var core = __webpack_require__(40);
	var fails = __webpack_require__(9);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(10);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(240);
	var PooledClass = __webpack_require__(70);
	var ReactCurrentOwner = __webpack_require__(72);
	var ReactPerf = __webpack_require__(100);
	var ReactReconciler = __webpack_require__(118);
	var Transaction = __webpack_require__(175);
	
	var assign = __webpack_require__(11);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(17);
	
	var dirtyComponents = [];
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  ( false ? invariant(
	    ReactUpdates.ReactReconcileTransaction && batchingStrategy,
	    'ReactUpdates: must inject a reconcile transaction class and batching ' +
	    'strategy'
	  ) : invariant(ReactUpdates.ReactReconcileTransaction && batchingStrategy));
	}
	
	var NESTED_UPDATES = {
	  initialize: function() {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function() {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function() {
	    this.callbackQueue.reset();
	  },
	  close: function() {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction =
	    ReactUpdates.ReactReconcileTransaction.getPooled();
	}
	
	assign(
	  ReactUpdatesFlushTransaction.prototype,
	  Transaction.Mixin, {
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function() {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function(method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(
	      this,
	      this.reconcileTransaction.perform,
	      this.reconcileTransaction,
	      method,
	      scope,
	      a
	    );
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  ( false ? invariant(
	    len === dirtyComponents.length,
	    'Expected flush transaction\'s stored dirty-components length (%s) to ' +
	    'match dirty-components array length (%s).',
	    len,
	    dirtyComponents.length
	  ) : invariant(len === dirtyComponents.length));
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    ReactReconciler.performUpdateIfNecessary(
	      component,
	      transaction.reconcileTransaction
	    );
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(
	          callbacks[j],
	          component.getPublicInstance()
	        );
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function() {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	flushBatchedUpdates = ReactPerf.measure(
	  'ReactUpdates',
	  'flushBatchedUpdates',
	  flushBatchedUpdates
	);
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setProps, setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	  ( false ? warning(
	    ReactCurrentOwner.current == null,
	    'enqueueUpdate(): Render methods should be a pure function of props ' +
	    'and state; triggering nested component updates from render is not ' +
	    'allowed. If necessary, trigger nested updates in ' +
	    'componentDidUpdate.'
	  ) : null);
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  ( false ? invariant(
	    batchingStrategy.isBatchingUpdates,
	    'ReactUpdates.asap: Can\'t enqueue an asap callback in a context where' +
	    'updates are not being batched.'
	  ) : invariant(batchingStrategy.isBatchingUpdates));
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function(ReconcileTransaction) {
	    ( false ? invariant(
	      ReconcileTransaction,
	      'ReactUpdates: must provide a reconcile transaction class'
	    ) : invariant(ReconcileTransaction));
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function(_batchingStrategy) {
	    ( false ? invariant(
	      _batchingStrategy,
	      'ReactUpdates: must provide a batching strategy'
	    ) : invariant(_batchingStrategy));
	    ( false ? invariant(
	      typeof _batchingStrategy.batchedUpdates === 'function',
	      'ReactUpdates: must provide a batchedUpdates() function'
	    ) : invariant(typeof _batchingStrategy.batchedUpdates === 'function'));
	    ( false ? invariant(
	      typeof _batchingStrategy.isBatchingUpdates === 'boolean',
	      'ReactUpdates: must provide an isBatchingUpdates boolean attribute'
	    ) : invariant(typeof _batchingStrategy.isBatchingUpdates === 'boolean'));
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;


/***/ }),
/* 63 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyFunction
	 */
	
	function makeEmptyFunction(arg) {
	  return function() {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	function emptyFunction() {}
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function() { return this; };
	emptyFunction.thatReturnsArgument = function(arg) { return arg; };
	
	module.exports = emptyFunction;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	var t = __webpack_require__(404);
	var templates = __webpack_require__(927);
	var i18n = __webpack_require__(403);
	
	t.form.Form.templates = templates;
	t.form.Form.i18n = i18n;
	
	module.exports = t;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(328);
	var $export = __webpack_require__(1);
	var shared = __webpack_require__(126)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(333))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(19)) {
	  var LIBRARY = __webpack_require__(78);
	  var global = __webpack_require__(8);
	  var fails = __webpack_require__(9);
	  var $export = __webpack_require__(1);
	  var $typed = __webpack_require__(158);
	  var $buffer = __webpack_require__(219);
	  var ctx = __webpack_require__(51);
	  var anInstance = __webpack_require__(86);
	  var propertyDesc = __webpack_require__(91);
	  var hide = __webpack_require__(33);
	  var redefineAll = __webpack_require__(92);
	  var toInteger = __webpack_require__(53);
	  var toLength = __webpack_require__(15);
	  var toIndex = __webpack_require__(306);
	  var toAbsoluteIndex = __webpack_require__(94);
	  var toPrimitive = __webpack_require__(60);
	  var has = __webpack_require__(41);
	  var classof = __webpack_require__(105);
	  var isObject = __webpack_require__(10);
	  var toObject = __webpack_require__(23);
	  var isArrayIter = __webpack_require__(205);
	  var create = __webpack_require__(88);
	  var getPrototypeOf = __webpack_require__(43);
	  var gOPN = __webpack_require__(89).f;
	  var getIterFn = __webpack_require__(221);
	  var uid = __webpack_require__(95);
	  var wks = __webpack_require__(13);
	  var createArrayMethod = __webpack_require__(57);
	  var createArrayIncludes = __webpack_require__(146);
	  var speciesConstructor = __webpack_require__(127);
	  var ArrayIterators = __webpack_require__(160);
	  var Iterators = __webpack_require__(106);
	  var $iterDetect = __webpack_require__(151);
	  var setSpecies = __webpack_require__(93);
	  var arrayFill = __webpack_require__(197);
	  var arrayCopyWithin = __webpack_require__(278);
	  var $DP = __webpack_require__(22);
	  var $GOPD = __webpack_require__(42);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	var baseClone = __webpack_require__(769),
	    bindCallback = __webpack_require__(163);
	
	/**
	 * Creates a deep clone of `value`. If `customizer` is provided it's invoked
	 * to produce the cloned values. If `customizer` returns `undefined` cloning
	 * is handled by the method instead. The `customizer` is bound to `thisArg`
	 * and invoked with up to three argument; (value [, index|key, object]).
	 *
	 * **Note:** This method is loosely based on the
	 * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	 * The enumerable properties of `arguments` objects and objects created by
	 * constructors other than `Object` are cloned to plain `Object` objects. An
	 * empty object is returned for uncloneable values such as functions, DOM nodes,
	 * Maps, Sets, and WeakMaps.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {*} Returns the deep cloned value.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * var deep = _.cloneDeep(users);
	 * deep[0] === users[0];
	 * // => false
	 *
	 * // using a customizer callback
	 * var el = _.cloneDeep(document.body, function(value) {
	 *   if (_.isElement(value)) {
	 *     return value.cloneNode(true);
	 *   }
	 * });
	 *
	 * el === document.body
	 * // => false
	 * el.nodeName
	 * // => BODY
	 * el.childNodes.length;
	 * // => 20
	 */
	function cloneDeep(value, customizer, thisArg) {
	  return typeof customizer == 'function'
	    ? baseClone(value, true, bindCallback(customizer, thisArg, 3))
	    : baseClone(value, true);
	}
	
	module.exports = cloneDeep;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var assign = __webpack_require__(113);
	var ReactPropTypes = __webpack_require__(2).PropTypes;
	var Route = __webpack_require__(99);
	
	var PropTypes = assign({}, ReactPropTypes, {
	
	  /**
	   * Indicates that a prop should be falsy.
	   */
	  falsy: function falsy(props, propName, componentName) {
	    if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	  },
	
	  /**
	   * Indicates that a prop should be a Route object.
	   */
	  route: ReactPropTypes.instanceOf(Route),
	
	  /**
	   * Indicates that a prop should be a Router object.
	   */
	  //router: ReactPropTypes.instanceOf(Router) // TODO
	  router: ReactPropTypes.func
	
	});
	
	module.exports = PropTypes;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function(a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function(a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fiveArgumentPooler = function(a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function(instance) {
	  var Klass = this;
	  ( false ? invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  ) : invariant(instance instanceof Klass));
	  if (instance.destructor) {
	    instance.destructor();
	  }
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances (optional).
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function(CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserComponentMixin
	 */
	
	'use strict';
	
	var findDOMNode = __webpack_require__(391);
	
	var ReactBrowserComponentMixin = {
	  /**
	   * Returns the DOM node rendered by this component.
	   *
	   * @return {DOMElement} The root node of this component.
	   * @final
	   * @protected
	   */
	  getDOMNode: function() {
	    return findDOMNode(this);
	  }
	};
	
	module.exports = ReactBrowserComponentMixin;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 *
	 * The depth indicate how many composite components are above this render level.
	 */
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(114);
	var ReactBrowserEventEmitter = __webpack_require__(115);
	var ReactCurrentOwner = __webpack_require__(72);
	var ReactElement = __webpack_require__(16);
	var ReactElementValidator = __webpack_require__(134);
	var ReactEmptyComponent = __webpack_require__(248);
	var ReactInstanceHandles = __webpack_require__(116);
	var ReactInstanceMap = __webpack_require__(117);
	var ReactMarkupChecksum = __webpack_require__(385);
	var ReactPerf = __webpack_require__(100);
	var ReactReconciler = __webpack_require__(118);
	var ReactUpdateQueue = __webpack_require__(251);
	var ReactUpdates = __webpack_require__(62);
	
	var emptyObject = __webpack_require__(176);
	var containsNode = __webpack_require__(390);
	var getReactRootElementInContainer = __webpack_require__(909);
	var instantiateReactComponent = __webpack_require__(258);
	var invariant = __webpack_require__(6);
	var setInnerHTML = __webpack_require__(260);
	var shouldUpdateReactComponent = __webpack_require__(261);
	var warning = __webpack_require__(17);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var nodeCache = {};
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	
	/** Mapping from reactRootID to React component instance. */
	var instancesByReactRootID = {};
	
	/** Mapping from reactRootID to `container` nodes. */
	var containersByReactRootID = {};
	
	if (false) {
	  /** __DEV__-only mapping from reactRootID to root elements. */
	  var rootElementsByReactRootID = {};
	}
	
	// Used to store breadth-first search state in findComponentRoot.
	var findComponentRootReusableArray = [];
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement} container DOM element that may contain a React component.
	 * @return {?string} A "reactRoot" ID, if a React component is rendered.
	 */
	function getReactRootID(container) {
	  var rootElement = getReactRootElementInContainer(container);
	  return rootElement && ReactMount.getID(rootElement);
	}
	
	/**
	 * Accessing node[ATTR_NAME] or calling getAttribute(ATTR_NAME) on a form
	 * element can return its control whose name or ID equals ATTR_NAME. All
	 * DOM nodes support `getAttributeNode` but this can also get called on
	 * other objects so just return '' if we're given something other than a
	 * DOM node (such as window).
	 *
	 * @param {?DOMElement|DOMWindow|DOMDocument|DOMTextNode} node DOM node.
	 * @return {string} ID of the supplied `domNode`.
	 */
	function getID(node) {
	  var id = internalGetID(node);
	  if (id) {
	    if (nodeCache.hasOwnProperty(id)) {
	      var cached = nodeCache[id];
	      if (cached !== node) {
	        ( false ? invariant(
	          !isValid(cached, id),
	          'ReactMount: Two valid but unequal nodes with the same `%s`: %s',
	          ATTR_NAME, id
	        ) : invariant(!isValid(cached, id)));
	
	        nodeCache[id] = node;
	      }
	    } else {
	      nodeCache[id] = node;
	    }
	  }
	
	  return id;
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node && node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Sets the React-specific ID of the given node.
	 *
	 * @param {DOMElement} node The DOM node whose ID will be set.
	 * @param {string} id The value of the ID attribute.
	 */
	function setID(node, id) {
	  var oldID = internalGetID(node);
	  if (oldID !== id) {
	    delete nodeCache[oldID];
	  }
	  node.setAttribute(ATTR_NAME, id);
	  nodeCache[id] = node;
	}
	
	/**
	 * Finds the node with the supplied React-generated DOM ID.
	 *
	 * @param {string} id A React-generated DOM ID.
	 * @return {DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNode(id) {
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * Finds the node with the supplied public React instance.
	 *
	 * @param {*} instance A public React instance.
	 * @return {?DOMElement} DOM node with the suppled `id`.
	 * @internal
	 */
	function getNodeFromInstance(instance) {
	  var id = ReactInstanceMap.get(instance)._rootNodeID;
	  if (ReactEmptyComponent.isNullComponentID(id)) {
	    return null;
	  }
	  if (!nodeCache.hasOwnProperty(id) || !isValid(nodeCache[id], id)) {
	    nodeCache[id] = ReactMount.findReactNodeByID(id);
	  }
	  return nodeCache[id];
	}
	
	/**
	 * A node is "valid" if it is contained by a currently mounted container.
	 *
	 * This means that the node does not have to be contained by a document in
	 * order to be considered valid.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @param {string} id The expected ID of the node.
	 * @return {boolean} Whether the node is contained by a mounted container.
	 */
	function isValid(node, id) {
	  if (node) {
	    ( false ? invariant(
	      internalGetID(node) === id,
	      'ReactMount: Unexpected modification of `%s`',
	      ATTR_NAME
	    ) : invariant(internalGetID(node) === id));
	
	    var container = ReactMount.findReactContainerForID(id);
	    if (container && containsNode(container, node)) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Causes the cache to forget about one React-specific ID.
	 *
	 * @param {string} id The ID to forget.
	 */
	function purgeID(id) {
	  delete nodeCache[id];
	}
	
	var deepestNodeSoFar = null;
	function findDeepestCachedAncestorImpl(ancestorID) {
	  var ancestor = nodeCache[ancestorID];
	  if (ancestor && isValid(ancestor, ancestorID)) {
	    deepestNodeSoFar = ancestor;
	  } else {
	    // This node isn't populated in the cache, so presumably none of its
	    // descendants are. Break out of the loop.
	    return false;
	  }
	}
	
	/**
	 * Return the deepest cached node whose ID is a prefix of `targetID`.
	 */
	function findDeepestCachedAncestor(targetID) {
	  deepestNodeSoFar = null;
	  ReactInstanceHandles.traverseAncestors(
	    targetID,
	    findDeepestCachedAncestorImpl
	  );
	
	  var foundNode = deepestNodeSoFar;
	  deepestNodeSoFar = null;
	  return foundNode;
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(
	    componentInstance,
	    rootID,
	    container,
	    transaction,
	    shouldReuseMarkup) {
	  var markup = ReactReconciler.mountComponent(
	    componentInstance, rootID, transaction, emptyObject
	  );
	  componentInstance._isTopLevel = true;
	  ReactMount._mountImageIntoNode(markup, container, shouldReuseMarkup);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {string} rootID DOM ID of the root node.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(
	    componentInstance,
	    rootID,
	    container,
	    shouldReuseMarkup) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled();
	  transaction.perform(
	    mountComponentIntoNode,
	    null,
	    componentInstance,
	    rootID,
	    container,
	    transaction,
	    shouldReuseMarkup
	  );
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  /** Exposed for debugging purposes **/
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function(container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function(
	      prevComponent,
	      nextElement,
	      container,
	      callback) {
	    if (false) {
	      ReactElementValidator.checkAndWarnForMutatedProps(nextElement);
	    }
	
	    ReactMount.scrollMonitor(container, function() {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[getReactRootID(container)] =
	        getReactRootElementInContainer(container);
	    }
	
	    return prevComponent;
	  },
	
	  /**
	   * Register a component into the instance map and starts scroll value
	   * monitoring
	   * @param {ReactComponent} nextComponent component instance to render
	   * @param {DOMElement} container container to render into
	   * @return {string} reactRoot ID prefix
	   */
	  _registerComponent: function(nextComponent, container) {
	    ( false ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      '_registerComponent(...): Target container is not a DOM element.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	
	    var reactRootID = ReactMount.registerContainer(container);
	    instancesByReactRootID[reactRootID] = nextComponent;
	    return reactRootID;
	  },
	
	  /**
	   * Render a new component into the DOM.
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function(
	    nextElement,
	    container,
	    shouldReuseMarkup
	  ) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	    ( false ? warning(
	      ReactCurrentOwner.current == null,
	      '_renderNewRootComponent(): Render methods should be a pure function ' +
	      'of props and state; triggering nested component updates from ' +
	      'render is not allowed. If necessary, trigger nested updates in ' +
	      'componentDidUpdate.'
	    ) : null);
	
	    var componentInstance = instantiateReactComponent(nextElement, null);
	    var reactRootID = ReactMount._registerComponent(
	      componentInstance,
	      container
	    );
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(
	      batchedMountComponentIntoNode,
	      componentInstance,
	      reactRootID,
	      container,
	      shouldReuseMarkup
	    );
	
	    if (false) {
	      // Record the root element in case it later gets transplanted.
	      rootElementsByReactRootID[reactRootID] =
	        getReactRootElementInContainer(container);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function(nextElement, container, callback) {
	    ( false ? invariant(
	      ReactElement.isValidElement(nextElement),
	      'React.render(): Invalid component element.%s',
	      (
	        typeof nextElement === 'string' ?
	          ' Instead of passing an element string, make sure to instantiate ' +
	          'it by passing it to React.createElement.' :
	        typeof nextElement === 'function' ?
	          ' Instead of passing a component class, make sure to instantiate ' +
	          'it by passing it to React.createElement.' :
	        // Check if it quacks like an element
	        nextElement != null && nextElement.props !== undefined ?
	          ' This may be caused by unintentionally loading two independent ' +
	          'copies of React.' :
	          ''
	      )
	    ) : invariant(ReactElement.isValidElement(nextElement)));
	
	    var prevComponent = instancesByReactRootID[getReactRootID(container)];
	
	    if (prevComponent) {
	      var prevElement = prevComponent._currentElement;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        return ReactMount._updateRootComponent(
	          prevComponent,
	          nextElement,
	          container,
	          callback
	        ).getPublicInstance();
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup =
	      reactRootElement && ReactMount.isRenderedByReact(reactRootElement);
	
	    if (false) {
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (ReactMount.isRenderedByReact(rootElementSibling)) {
	            ("production" !== process.env.NODE_ENV ? warning(
	              false,
	              'render(): Target node has markup rendered by React, but there ' +
	              'are unrelated nodes as well. This is most commonly caused by ' +
	              'white-space inserted around server-rendered markup.'
	            ) : null);
	            break;
	          }
	
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent;
	
	    var component = ReactMount._renderNewRootComponent(
	      nextElement,
	      container,
	      shouldReuseMarkup
	    ).getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Constructs a component instance of `constructor` with `initialProps` and
	   * renders it into the supplied `container`.
	   *
	   * @param {function} constructor React component constructor.
	   * @param {?object} props Initial props of the component instance.
	   * @param {DOMElement} container DOM element to render into.
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  constructAndRenderComponent: function(constructor, props, container) {
	    var element = ReactElement.createElement(constructor, props);
	    return ReactMount.render(element, container);
	  },
	
	  /**
	   * Constructs a component instance of `constructor` with `initialProps` and
	   * renders it into a container node identified by supplied `id`.
	   *
	   * @param {function} componentConstructor React component constructor
	   * @param {?object} props Initial props of the component instance.
	   * @param {string} id ID of the DOM element to render into.
	   * @return {ReactComponent} Component instance rendered in the container node.
	   */
	  constructAndRenderComponentByID: function(constructor, props, id) {
	    var domNode = document.getElementById(id);
	    ( false ? invariant(
	      domNode,
	      'Tried to get element with id of "%s" but it is not present on the page.',
	      id
	    ) : invariant(domNode));
	    return ReactMount.constructAndRenderComponent(constructor, props, domNode);
	  },
	
	  /**
	   * Registers a container node into which React components will be rendered.
	   * This also creates the "reactRoot" ID that will be assigned to the element
	   * rendered within.
	   *
	   * @param {DOMElement} container DOM element to register as a container.
	   * @return {string} The "reactRoot" ID of elements rendered within.
	   */
	  registerContainer: function(container) {
	    var reactRootID = getReactRootID(container);
	    if (reactRootID) {
	      // If one exists, make sure it is a valid "reactRoot" ID.
	      reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(reactRootID);
	    }
	    if (!reactRootID) {
	      // No valid "reactRoot" ID found, create one.
	      reactRootID = ReactInstanceHandles.createReactRootID();
	    }
	    containersByReactRootID[reactRootID] = container;
	    return reactRootID;
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function(container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	    ( false ? warning(
	      ReactCurrentOwner.current == null,
	      'unmountComponentAtNode(): Render methods should be a pure function of ' +
	      'props and state; triggering nested component updates from render is ' +
	      'not allowed. If necessary, trigger nested updates in ' +
	      'componentDidUpdate.'
	    ) : null);
	
	    ( false ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      'unmountComponentAtNode(...): Target container is not a DOM element.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));
	
	    var reactRootID = getReactRootID(container);
	    var component = instancesByReactRootID[reactRootID];
	    if (!component) {
	      return false;
	    }
	    ReactMount.unmountComponentFromNode(component, container);
	    delete instancesByReactRootID[reactRootID];
	    delete containersByReactRootID[reactRootID];
	    if (false) {
	      delete rootElementsByReactRootID[reactRootID];
	    }
	    return true;
	  },
	
	  /**
	   * Unmounts a component and removes it from the DOM.
	   *
	   * @param {ReactComponent} instance React component instance.
	   * @param {DOMElement} container DOM element to unmount from.
	   * @final
	   * @internal
	   * @see {ReactMount.unmountComponentAtNode}
	   */
	  unmountComponentFromNode: function(instance, container) {
	    ReactReconciler.unmountComponent(instance);
	
	    if (container.nodeType === DOC_NODE_TYPE) {
	      container = container.documentElement;
	    }
	
	    // http://jsperf.com/emptying-a-node
	    while (container.lastChild) {
	      container.removeChild(container.lastChild);
	    }
	  },
	
	  /**
	   * Finds the container DOM element that contains React component to which the
	   * supplied DOM `id` belongs.
	   *
	   * @param {string} id The ID of an element rendered by a React component.
	   * @return {?DOMElement} DOM element that contains the `id`.
	   */
	  findReactContainerForID: function(id) {
	    var reactRootID = ReactInstanceHandles.getReactRootIDFromNodeID(id);
	    var container = containersByReactRootID[reactRootID];
	
	    if (false) {
	      var rootElement = rootElementsByReactRootID[reactRootID];
	      if (rootElement && rootElement.parentNode !== container) {
	        ("production" !== process.env.NODE_ENV ? invariant(
	          // Call internalGetID here because getID calls isValid which calls
	          // findReactContainerForID (this function).
	          internalGetID(rootElement) === reactRootID,
	          'ReactMount: Root element ID differed from reactRootID.'
	        ) : invariant(// Call internalGetID here because getID calls isValid which calls
	        // findReactContainerForID (this function).
	        internalGetID(rootElement) === reactRootID));
	
	        var containerChild = container.firstChild;
	        if (containerChild &&
	            reactRootID === internalGetID(containerChild)) {
	          // If the container has a new child with the same ID as the old
	          // root element, then rootElementsByReactRootID[reactRootID] is
	          // just stale and needs to be updated. The case that deserves a
	          // warning is when the container is empty.
	          rootElementsByReactRootID[reactRootID] = containerChild;
	        } else {
	          ("production" !== process.env.NODE_ENV ? warning(
	            false,
	            'ReactMount: Root element has been removed from its original ' +
	            'container. New container:', rootElement.parentNode
	          ) : null);
	        }
	      }
	    }
	
	    return container;
	  },
	
	  /**
	   * Finds an element rendered by React with the supplied ID.
	   *
	   * @param {string} id ID of a DOM node in the React component.
	   * @return {DOMElement} Root DOM node of the React component.
	   */
	  findReactNodeByID: function(id) {
	    var reactRoot = ReactMount.findReactContainerForID(id);
	    return ReactMount.findComponentRoot(reactRoot, id);
	  },
	
	  /**
	   * True if the supplied `node` is rendered by React.
	   *
	   * @param {*} node DOM Element to check.
	   * @return {boolean} True if the DOM Element appears to be rendered by React.
	   * @internal
	   */
	  isRenderedByReact: function(node) {
	    if (node.nodeType !== 1) {
	      // Not a DOMElement, therefore not a React component
	      return false;
	    }
	    var id = ReactMount.getID(node);
	    return id ? id.charAt(0) === SEPARATOR : false;
	  },
	
	  /**
	   * Traverses up the ancestors of the supplied node to find a node that is a
	   * DOM representation of a React component.
	   *
	   * @param {*} node
	   * @return {?DOMEventTarget}
	   * @internal
	   */
	  getFirstReactDOM: function(node) {
	    var current = node;
	    while (current && current.parentNode !== current) {
	      if (ReactMount.isRenderedByReact(current)) {
	        return current;
	      }
	      current = current.parentNode;
	    }
	    return null;
	  },
	
	  /**
	   * Finds a node with the supplied `targetID` inside of the supplied
	   * `ancestorNode`.  Exploits the ID naming scheme to perform the search
	   * quickly.
	   *
	   * @param {DOMEventTarget} ancestorNode Search from this root.
	   * @pararm {string} targetID ID of the DOM representation of the component.
	   * @return {DOMEventTarget} DOM node with the supplied `targetID`.
	   * @internal
	   */
	  findComponentRoot: function(ancestorNode, targetID) {
	    var firstChildren = findComponentRootReusableArray;
	    var childIndex = 0;
	
	    var deepestAncestor = findDeepestCachedAncestor(targetID) || ancestorNode;
	
	    firstChildren[0] = deepestAncestor.firstChild;
	    firstChildren.length = 1;
	
	    while (childIndex < firstChildren.length) {
	      var child = firstChildren[childIndex++];
	      var targetChild;
	
	      while (child) {
	        var childID = ReactMount.getID(child);
	        if (childID) {
	          // Even if we find the node we're looking for, we finish looping
	          // through its siblings to ensure they're cached so that we don't have
	          // to revisit this node again. Otherwise, we make n^2 calls to getID
	          // when visiting the many children of a single node in order.
	
	          if (targetID === childID) {
	            targetChild = child;
	          } else if (ReactInstanceHandles.isAncestorIDOf(childID, targetID)) {
	            // If we find a child whose ID is an ancestor of the given ID,
	            // then we can be sure that we only want to search the subtree
	            // rooted at this child, so we can throw out the rest of the
	            // search state.
	            firstChildren.length = childIndex = 0;
	            firstChildren.push(child.firstChild);
	          }
	
	        } else {
	          // If this child had no ID, then there's a chance that it was
	          // injected automatically by the browser, as when a `<table>`
	          // element sprouts an extra `<tbody>` child as a side effect of
	          // `.innerHTML` parsing. Optimistically continue down this
	          // branch, but not before examining the other siblings.
	          firstChildren.push(child.firstChild);
	        }
	
	        child = child.nextSibling;
	      }
	
	      if (targetChild) {
	        // Emptying firstChildren/findComponentRootReusableArray is
	        // not necessary for correctness, but it helps the GC reclaim
	        // any nodes that were left at the end of the search.
	        firstChildren.length = 0;
	
	        return targetChild;
	      }
	    }
	
	    firstChildren.length = 0;
	
	    ( false ? invariant(
	      false,
	      'findComponentRoot(..., %s): Unable to find element. This probably ' +
	      'means the DOM was unexpectedly mutated (e.g., by the browser), ' +
	      'usually due to forgetting a <tbody> when using tables, nesting tags ' +
	      'like <form>, <p>, or <a>, or using non-SVG elements in an <svg> ' +
	      'parent. ' +
	      'Try inspecting the child nodes of the element with React ID `%s`.',
	      targetID,
	      ReactMount.getID(ancestorNode)
	    ) : invariant(false));
	  },
	
	  _mountImageIntoNode: function(markup, container, shouldReuseMarkup) {
	    ( false ? invariant(
	      container && (
	        (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	      ),
	      'mountComponentIntoNode(...): Target container is not valid.'
	    ) : invariant(container && (
	      (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE)
	    )));
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(
	          ReactMarkupChecksum.CHECKSUM_ATTR_NAME
	        );
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(
	          ReactMarkupChecksum.CHECKSUM_ATTR_NAME,
	          checksum
	        );
	
	        var diffIndex = firstDifferenceIndex(markup, rootMarkup);
	        var difference = ' (client) ' +
	          markup.substring(diffIndex - 20, diffIndex + 20) +
	          '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        ( false ? invariant(
	          container.nodeType !== DOC_NODE_TYPE,
	          'You\'re trying to render a component to the document using ' +
	          'server rendering but the checksum was invalid. This usually ' +
	          'means you rendered a different component type or props on ' +
	          'the client from the one on the server, or your render() ' +
	          'methods are impure. React cannot handle this case due to ' +
	          'cross-browser quirks by rendering at the document root. You ' +
	          'should look for environment dependent code in your components ' +
	          'and ensure the props are the same client and server side:\n%s',
	          difference
	        ) : invariant(container.nodeType !== DOC_NODE_TYPE));
	
	        if (false) {
	          ("production" !== process.env.NODE_ENV ? warning(
	            false,
	            'React attempted to reuse markup in a container but the ' +
	            'checksum was invalid. This generally means that you are ' +
	            'using server rendering and the markup generated on the ' +
	            'server was not what the client was expecting. React injected ' +
	            'new markup to compensate which works but you have lost many ' +
	            'of the benefits of server rendering. Instead, figure out ' +
	            'why the markup being generated is different on the client ' +
	            'or server:\n%s',
	            difference
	          ) : null);
	        }
	      }
	    }
	
	    ( false ? invariant(
	      container.nodeType !== DOC_NODE_TYPE,
	      'You\'re trying to render a component to the document but ' +
	        'you didn\'t use server rendering. We can\'t do this ' +
	        'without using server rendering due to cross-browser quirks. ' +
	        'See React.renderToString() for server rendering.'
	    ) : invariant(container.nodeType !== DOC_NODE_TYPE));
	
	    setInnerHTML(container, markup);
	  },
	
	  /**
	   * React ID utilities.
	   */
	
	  getReactRootID: getReactRootID,
	
	  getID: getID,
	
	  setID: setID,
	
	  getNode: getNode,
	
	  getNodeFromInstance: getNodeFromInstance,
	
	  purgeID: purgeID
	};
	
	ReactPerf.measureMethods(ReactMount, 'ReactMount', {
	  _renderNewRootComponent: '_renderNewRootComponent',
	  _mountImageIntoNode: '_mountImageIntoNode'
	});
	
	module.exports = ReactMount;


/***/ }),
/* 74 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without loosing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	
	module.exports = keyOf;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	module.exports = function isArray(x) {
	  return x instanceof Array;
	};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = mergeOptions;
	
	var _obj = __webpack_require__(31);
	
	/**
	 * Deep-merge one or more options objects, recursively merging **only** plain
	 * object properties.
	 *
	 * @param   {Object[]} sources
	 *          One or more objects to merge into a new object.
	 *
	 * @returns {Object}
	 *          A new object that is the merged result of all sources.
	 */
	function mergeOptions() {
	  var result = {};
	
	  for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
	    sources[_key] = arguments[_key];
	  }
	
	  sources.forEach(function (source) {
	    if (!source) {
	      return;
	    }
	
	    (0, _obj.each)(source, function (value, key) {
	      if (!(0, _obj.isPlain)(value)) {
	        result[key] = value;
	        return;
	      }
	
	      if (!(0, _obj.isPlain)(result[key])) {
	        result[key] = {};
	      }
	
	      result[key] = mergeOptions(result[key], value);
	    });
	  });
	
	  return result;
	} /**
	   * @file merge-options.js
	   * @module merge-options
	   */


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(13)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(33)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(95)('meta');
	var isObject = __webpack_require__(10);
	var has = __webpack_require__(41);
	var setDesc = __webpack_require__(22).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(9)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(55);
	var isStruct = __webpack_require__(411);
	var getFunctionName = __webpack_require__(178);
	var assert = __webpack_require__(25);
	var stringify = __webpack_require__(413);
	
	// creates an instance of a type, handling the optional new operator
	module.exports = function create(type, value, path) {
	  if (isType(type)) {
	    // for structs the new operator is allowed
	    return isStruct(type) ? new type(value, path) : type(value, path);
	  }
	
	  if (false) {
	    // here type should be a class constructor and value some instance, just check membership and return the value
	    path = path || [getFunctionName(type)];
	    assert(value instanceof type, function () { return 'Invalid value ' + stringify(value) + ' supplied to ' + path.join('/'); });
	  }
	
	  return value;
	};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(55);
	
	// returns true if x is an instance of type
	module.exports = function is(x, type) {
	  if (isType(type)) {
	    return type.is(x);
	  }
	  return x instanceof type; // type should be a class constructor
	};


/***/ }),
/* 82 */
/***/ (function(module, exports) {

	module.exports = function isNil(x) {
	  return x === null || x === void 0;
	};

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.fixEvent = fixEvent;
	exports.on = on;
	exports.off = off;
	exports.trigger = trigger;
	exports.one = one;
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _guid = __webpack_require__(119);
	
	var Guid = _interopRequireWildcard(_guid);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 * Clean up the listener cache and dispatchers
	 *
	 * @param {Element|Object} elem
	 *        Element to clean up
	 *
	 * @param {string} type
	 *        Type of event to clean up
	 */
	function _cleanUpEvents(elem, type) {
	  var data = Dom.getElData(elem);
	
	  // Remove the events of a particular type if there are none left
	  if (data.handlers[type].length === 0) {
	    delete data.handlers[type];
	    // data.handlers[type] = null;
	    // Setting to null was causing an error with data.handlers
	
	    // Remove the meta-handler from the element
	    if (elem.removeEventListener) {
	      elem.removeEventListener(type, data.dispatcher, false);
	    } else if (elem.detachEvent) {
	      elem.detachEvent('on' + type, data.dispatcher);
	    }
	  }
	
	  // Remove the events object if there are no types left
	  if (Object.getOwnPropertyNames(data.handlers).length <= 0) {
	    delete data.handlers;
	    delete data.dispatcher;
	    delete data.disabled;
	  }
	
	  // Finally remove the element data if there is no data left
	  if (Object.getOwnPropertyNames(data).length === 0) {
	    Dom.removeElData(elem);
	  }
	}
	
	/**
	 * Loops through an array of event types and calls the requested method for each type.
	 *
	 * @param {Function} fn
	 *        The event method we want to use.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind listeners to
	 *
	 * @param {string} type
	 *        Type of event to bind to.
	 *
	 * @param {EventTarget~EventListener} callback
	 *        Event listener.
	 */
	/**
	 * @file events.js. An Event System (John Resig - Secrets of a JS Ninja http://jsninja.com/)
	 * (Original book version wasn't completely usable, so fixed some things and made Closure Compiler compatible)
	 * This should work very similarly to jQuery's events, however it's based off the book version which isn't as
	 * robust as jquery's, so there's probably some differences.
	 *
	 * @module events
	 */
	
	function _handleMultipleEvents(fn, elem, types, callback) {
	  types.forEach(function (type) {
	    // Call the event method for each one of the types
	    fn(elem, type, callback);
	  });
	}
	
	/**
	 * Fix a native event to have standard property values
	 *
	 * @param {Object} event
	 *        Event object to fix.
	 *
	 * @return {Object}
	 *         Fixed event object.
	 */
	function fixEvent(event) {
	
	  function returnTrue() {
	    return true;
	  }
	
	  function returnFalse() {
	    return false;
	  }
	
	  // Test if fixing up is needed
	  // Used to check if !event.stopPropagation instead of isPropagationStopped
	  // But native events return true for stopPropagation, but don't have
	  // other expected methods like isPropagationStopped. Seems to be a problem
	  // with the Javascript Ninja code. So we're just overriding all events now.
	  if (!event || !event.isPropagationStopped) {
	    var old = event || _window2['default'].event;
	
	    event = {};
	    // Clone the old object so that we can modify the values event = {};
	    // IE8 Doesn't like when you mess with native event properties
	    // Firefox returns false for event.hasOwnProperty('type') and other props
	    //  which makes copying more difficult.
	    // TODO: Probably best to create a whitelist of event props
	    for (var key in old) {
	      // Safari 6.0.3 warns you if you try to copy deprecated layerX/Y
	      // Chrome warns you if you try to copy deprecated keyboardEvent.keyLocation
	      // and webkitMovementX/Y
	      if (key !== 'layerX' && key !== 'layerY' && key !== 'keyLocation' && key !== 'webkitMovementX' && key !== 'webkitMovementY') {
	        // Chrome 32+ warns if you try to copy deprecated returnValue, but
	        // we still want to if preventDefault isn't supported (IE8).
	        if (!(key === 'returnValue' && old.preventDefault)) {
	          event[key] = old[key];
	        }
	      }
	    }
	
	    // The event occurred on this element
	    if (!event.target) {
	      event.target = event.srcElement || _document2['default'];
	    }
	
	    // Handle which other element the event is related to
	    if (!event.relatedTarget) {
	      event.relatedTarget = event.fromElement === event.target ? event.toElement : event.fromElement;
	    }
	
	    // Stop the default browser action
	    event.preventDefault = function () {
	      if (old.preventDefault) {
	        old.preventDefault();
	      }
	      event.returnValue = false;
	      old.returnValue = false;
	      event.defaultPrevented = true;
	    };
	
	    event.defaultPrevented = false;
	
	    // Stop the event from bubbling
	    event.stopPropagation = function () {
	      if (old.stopPropagation) {
	        old.stopPropagation();
	      }
	      event.cancelBubble = true;
	      old.cancelBubble = true;
	      event.isPropagationStopped = returnTrue;
	    };
	
	    event.isPropagationStopped = returnFalse;
	
	    // Stop the event from bubbling and executing other handlers
	    event.stopImmediatePropagation = function () {
	      if (old.stopImmediatePropagation) {
	        old.stopImmediatePropagation();
	      }
	      event.isImmediatePropagationStopped = returnTrue;
	      event.stopPropagation();
	    };
	
	    event.isImmediatePropagationStopped = returnFalse;
	
	    // Handle mouse position
	    if (event.clientX !== null && event.clientX !== undefined) {
	      var doc = _document2['default'].documentElement;
	      var body = _document2['default'].body;
	
	      event.pageX = event.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = event.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // Handle key presses
	    event.which = event.charCode || event.keyCode;
	
	    // Fix button for mouse clicks:
	    // 0 == left; 1 == middle; 2 == right
	    if (event.button !== null && event.button !== undefined) {
	
	      // The following is disabled because it does not pass videojs-standard
	      // and... yikes.
	      /* eslint-disable */
	      event.button = event.button & 1 ? 0 : event.button & 4 ? 1 : event.button & 2 ? 2 : 0;
	      /* eslint-enable */
	    }
	  }
	
	  // Returns fixed-up instance
	  return event;
	}
	
	/**
	 * Whether passive event listeners are supported
	 */
	var _supportsPassive = false;
	
	(function () {
	  try {
	    var opts = Object.defineProperty({}, 'passive', {
	      get: function get() {
	        _supportsPassive = true;
	      }
	    });
	
	    _window2['default'].addEventListener('test', null, opts);
	  } catch (e) {
	    // disregard
	  }
	})();
	
	/**
	 * Touch events Chrome expects to be passive
	 */
	var passiveEvents = ['touchstart', 'touchmove'];
	
	/**
	 * Add an event listener to element
	 * It stores the handler function in a separate cache object
	 * and adds a generic handler to the element's event,
	 * along with a unique id (guid) to the element.
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind listeners to
	 *
	 * @param {string|string[]} type
	 *        Type of event to bind to.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        Event listener.
	 */
	function on(elem, type, fn) {
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(on, elem, type, fn);
	  }
	
	  var data = Dom.getElData(elem);
	
	  // We need a place to store all our handler data
	  if (!data.handlers) {
	    data.handlers = {};
	  }
	
	  if (!data.handlers[type]) {
	    data.handlers[type] = [];
	  }
	
	  if (!fn.guid) {
	    fn.guid = Guid.newGUID();
	  }
	
	  data.handlers[type].push(fn);
	
	  if (!data.dispatcher) {
	    data.disabled = false;
	
	    data.dispatcher = function (event, hash) {
	
	      if (data.disabled) {
	        return;
	      }
	
	      event = fixEvent(event);
	
	      var handlers = data.handlers[event.type];
	
	      if (handlers) {
	        // Copy handlers so if handlers are added/removed during the process it doesn't throw everything off.
	        var handlersCopy = handlers.slice(0);
	
	        for (var m = 0, n = handlersCopy.length; m < n; m++) {
	          if (event.isImmediatePropagationStopped()) {
	            break;
	          } else {
	            try {
	              handlersCopy[m].call(elem, event, hash);
	            } catch (e) {
	              _log2['default'].error(e);
	            }
	          }
	        }
	      }
	    };
	  }
	
	  if (data.handlers[type].length === 1) {
	    if (elem.addEventListener) {
	      var options = false;
	
	      if (_supportsPassive && passiveEvents.indexOf(type) > -1) {
	        options = { passive: true };
	      }
	      elem.addEventListener(type, data.dispatcher, options);
	    } else if (elem.attachEvent) {
	      elem.attachEvent('on' + type, data.dispatcher);
	    }
	  }
	}
	
	/**
	 * Removes event listeners from an element
	 *
	 * @param {Element|Object} elem
	 *        Object to remove listeners from.
	 *
	 * @param {string|string[]} [type]
	 *        Type of listener to remove. Don't include to remove all events from element.
	 *
	 * @param {EventTarget~EventListener} [fn]
	 *        Specific listener to remove. Don't include to remove listeners for an event
	 *        type.
	 */
	function off(elem, type, fn) {
	  // Don't want to add a cache object through getElData if not needed
	  if (!Dom.hasElData(elem)) {
	    return;
	  }
	
	  var data = Dom.getElData(elem);
	
	  // If no events exist, nothing to unbind
	  if (!data.handlers) {
	    return;
	  }
	
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(off, elem, type, fn);
	  }
	
	  // Utility function
	  var removeType = function removeType(t) {
	    data.handlers[t] = [];
	    _cleanUpEvents(elem, t);
	  };
	
	  // Are we removing all bound events?
	  if (!type) {
	    for (var t in data.handlers) {
	      removeType(t);
	    }
	    return;
	  }
	
	  var handlers = data.handlers[type];
	
	  // If no handlers exist, nothing to unbind
	  if (!handlers) {
	    return;
	  }
	
	  // If no listener was provided, remove all listeners for type
	  if (!fn) {
	    removeType(type);
	    return;
	  }
	
	  // We're only removing a single handler
	  if (fn.guid) {
	    for (var n = 0; n < handlers.length; n++) {
	      if (handlers[n].guid === fn.guid) {
	        handlers.splice(n--, 1);
	      }
	    }
	  }
	
	  _cleanUpEvents(elem, type);
	}
	
	/**
	 * Trigger an event for an element
	 *
	 * @param {Element|Object} elem
	 *        Element to trigger an event on
	 *
	 * @param {EventTarget~Event|string} event
	 *        A string (the type) or an event object with a type attribute
	 *
	 * @param {Object} [hash]
	 *        data hash to pass along with the event
	 *
	 * @return {boolean|undefined}
	 *         - Returns the opposite of `defaultPrevented` if default was prevented
	 *         - Otherwise returns undefined
	 */
	function trigger(elem, event, hash) {
	  // Fetches element data and a reference to the parent (for bubbling).
	  // Don't want to add a data object to cache for every parent,
	  // so checking hasElData first.
	  var elemData = Dom.hasElData(elem) ? Dom.getElData(elem) : {};
	  var parent = elem.parentNode || elem.ownerDocument;
	  // type = event.type || event,
	  // handler;
	
	  // If an event name was passed as a string, creates an event out of it
	  if (typeof event === 'string') {
	    event = { type: event, target: elem };
	  }
	  // Normalizes the event properties.
	  event = fixEvent(event);
	
	  // If the passed element has a dispatcher, executes the established handlers.
	  if (elemData.dispatcher) {
	    elemData.dispatcher.call(elem, event, hash);
	  }
	
	  // Unless explicitly stopped or the event does not bubble (e.g. media events)
	  // recursively calls this function to bubble the event up the DOM.
	  if (parent && !event.isPropagationStopped() && event.bubbles === true) {
	    trigger.call(null, parent, event, hash);
	
	    // If at the top of the DOM, triggers the default action unless disabled.
	  } else if (!parent && !event.defaultPrevented) {
	    var targetData = Dom.getElData(event.target);
	
	    // Checks if the target has a default action for this event.
	    if (event.target[event.type]) {
	      // Temporarily disables event dispatching on the target as we have already executed the handler.
	      targetData.disabled = true;
	      // Executes the default action.
	      if (typeof event.target[event.type] === 'function') {
	        event.target[event.type]();
	      }
	      // Re-enables event dispatching.
	      targetData.disabled = false;
	    }
	  }
	
	  // Inform the triggerer if the default was prevented by returning false
	  return !event.defaultPrevented;
	}
	
	/**
	 * Trigger a listener only once for an event
	 *
	 * @param {Element|Object} elem
	 *        Element or object to bind to.
	 *
	 * @param {string|string[]} type
	 *        Name/type of event
	 *
	 * @param {Event~EventListener} fn
	 *        Event Listener function
	 */
	function one(elem, type, fn) {
	  if (Array.isArray(type)) {
	    return _handleMultipleEvents(one, elem, type, fn);
	  }
	  var func = function func() {
	    off(elem, type, func);
	    fn.apply(this, arguments);
	  };
	
	  // copy the guid to the new function so it can removed using the original function's ID
	  func.guid = fn.guid = fn.guid || Guid.newGUID();
	  on(elem, type, func);
	}


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * @file format-time.js
	 * @module Format-time
	 */
	
	/**
	 * Format seconds as a time string, H:MM:SS or M:SS. Supplying a guide (in seconds)
	 * will force a number of leading zeros to cover the length of the guide.
	 *
	 * @param {number} seconds
	 *        Number of seconds to be turned into a string
	 *
	 * @param {number} guide
	 *        Number (in seconds) to model the string after
	 *
	 * @return {string}
	 *         Time formatted as H:MM:SS or M:SS
	 */
	function formatTime(seconds) {
	  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
	
	  seconds = seconds < 0 ? 0 : seconds;
	  var s = Math.floor(seconds % 60);
	  var m = Math.floor(seconds / 60 % 60);
	  var h = Math.floor(seconds / 3600);
	  var gm = Math.floor(guide / 60 % 60);
	  var gh = Math.floor(guide / 3600);
	
	  // handle invalid times
	  if (isNaN(seconds) || seconds === Infinity) {
	    // '-' is false for all relational operators (e.g. <, >=) so this setting
	    // will add the minimum number of fields specified by the guide
	    h = m = s = '-';
	  }
	
	  // Check if we need to show hours
	  h = h > 0 || gh > 0 ? h + ':' : '';
	
	  // If hours are showing, we may need to add a leading zero.
	  // Always show at least one digit of minutes.
	  m = ((h || gm >= 10) && m < 10 ? '0' + m : m) + ':';
	
	  // Check if leading zero is need for seconds
	  s = s < 10 ? '0' + s : s;
	
	  return h + m + s;
	}
	
	exports['default'] = formatTime;


/***/ }),
/* 85 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isMutableObject = isMutableObject;
	exports.eachObject = eachObject;
	exports.assign = assign;
	var isFunction = exports.isFunction = function isFunction(x) {
	  return typeof x === 'function';
	};
	
	function isMutableObject(target) {
	  var Ctor = target.constructor;
	
	  return !!target && Object.prototype.toString.call(target) === '[object Object]' && isFunction(Ctor) && !Object.isFrozen(target) && (Ctor instanceof Ctor || target.type === 'AltStore');
	}
	
	function eachObject(f, o) {
	  o.forEach(function (from) {
	    Object.keys(Object(from)).forEach(function (key) {
	      f(key, from[key]);
	    });
	  });
	}
	
	function assign(target) {
	  for (var _len = arguments.length, source = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    source[_key - 1] = arguments[_key];
	  }
	
	  eachObject(function (key, value) {
	    return target[key] = value;
	  }, source);
	  return target;
	}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(51);
	var call = __webpack_require__(289);
	var isArrayIter = __webpack_require__(205);
	var anObject = __webpack_require__(5);
	var toLength = __webpack_require__(15);
	var getIterFn = __webpack_require__(221);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(5);
	var dPs = __webpack_require__(295);
	var enumBugKeys = __webpack_require__(201);
	var IE_PROTO = __webpack_require__(214)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(200)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(203).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(297);
	var hiddenKeys = __webpack_require__(201).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(297);
	var enumBugKeys = __webpack_require__(201);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(34);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var dP = __webpack_require__(22);
	var DESCRIPTORS = __webpack_require__(19);
	var SPECIES = __webpack_require__(13)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(53);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(792),
	    isLength = __webpack_require__(128);
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	
	/**
	 * Converts `value` to an object if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Object} Returns the object.
	 */
	function toObject(value) {
	  return isObject(value) ? value : Object(value);
	}
	
	module.exports = toObject;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var assign = __webpack_require__(113);
	var invariant = __webpack_require__(67);
	var warning = __webpack_require__(238);
	var PathUtils = __webpack_require__(236);
	
	var _currentRoute;
	
	var Route = (function () {
	  _createClass(Route, null, [{
	    key: 'createRoute',
	
	    /**
	     * Creates and returns a new route. Options may be a URL pathname string
	     * with placeholders for named params or an object with any of the following
	     * properties:
	     *
	     * - name                     The name of the route. This is used to lookup a
	     *                            route relative to its parent route and should be
	     *                            unique among all child routes of the same parent
	     * - path                     A URL pathname string with optional placeholders
	     *                            that specify the names of params to extract from
	     *                            the URL when the path matches. Defaults to `/${name}`
	     *                            when there is a name given, or the path of the parent
	     *                            route, or /
	     * - ignoreScrollBehavior     True to make this route (and all descendants) ignore
	     *                            the scroll behavior of the router
	     * - isDefault                True to make this route the default route among all
	     *                            its siblings
	     * - isNotFound               True to make this route the "not found" route among
	     *                            all its siblings
	     * - onEnter                  A transition hook that will be called when the
	     *                            router is going to enter this route
	     * - onLeave                  A transition hook that will be called when the
	     *                            router is going to leave this route
	     * - handler                  A React component that will be rendered when
	     *                            this route is active
	     * - parentRoute              The parent route to use for this route. This option
	     *                            is automatically supplied when creating routes inside
	     *                            the callback to another invocation of createRoute. You
	     *                            only ever need to use this when declaring routes
	     *                            independently of one another to manually piece together
	     *                            the route hierarchy
	     *
	     * The callback may be used to structure your route hierarchy. Any call to
	     * createRoute, createDefaultRoute, createNotFoundRoute, or createRedirect
	     * inside the callback automatically uses this route as its parent.
	     */
	    value: function createRoute(options, callback) {
	      options = options || {};
	
	      if (typeof options === 'string') options = { path: options };
	
	      var parentRoute = _currentRoute;
	
	      if (parentRoute) {
	        warning(options.parentRoute == null || options.parentRoute === parentRoute, 'You should not use parentRoute with createRoute inside another route\'s child callback; it is ignored');
	      } else {
	        parentRoute = options.parentRoute;
	      }
	
	      var name = options.name;
	      var path = options.path || name;
	
	      if (path && !(options.isDefault || options.isNotFound)) {
	        if (PathUtils.isAbsolute(path)) {
	          if (parentRoute) {
	            invariant(path === parentRoute.path || parentRoute.paramNames.length === 0, 'You cannot nest path "%s" inside "%s"; the parent requires URL parameters', path, parentRoute.path);
	          }
	        } else if (parentRoute) {
	          // Relative paths extend their parent.
	          path = PathUtils.join(parentRoute.path, path);
	        } else {
	          path = '/' + path;
	        }
	      } else {
	        path = parentRoute ? parentRoute.path : '/';
	      }
	
	      if (options.isNotFound && !/\*$/.test(path)) path += '*'; // Auto-append * to the path of not found routes.
	
	      var route = new Route(name, path, options.ignoreScrollBehavior, options.isDefault, options.isNotFound, options.onEnter, options.onLeave, options.handler);
	
	      if (parentRoute) {
	        if (route.isDefault) {
	          invariant(parentRoute.defaultRoute == null, '%s may not have more than one default route', parentRoute);
	
	          parentRoute.defaultRoute = route;
	        } else if (route.isNotFound) {
	          invariant(parentRoute.notFoundRoute == null, '%s may not have more than one not found route', parentRoute);
	
	          parentRoute.notFoundRoute = route;
	        }
	
	        parentRoute.appendChild(route);
	      }
	
	      // Any routes created in the callback
	      // use this route as their parent.
	      if (typeof callback === 'function') {
	        var currentRoute = _currentRoute;
	        _currentRoute = route;
	        callback.call(route, route);
	        _currentRoute = currentRoute;
	      }
	
	      return route;
	    }
	
	    /**
	     * Creates and returns a route that is rendered when its parent matches
	     * the current URL.
	     */
	  }, {
	    key: 'createDefaultRoute',
	    value: function createDefaultRoute(options) {
	      return Route.createRoute(assign({}, options, { isDefault: true }));
	    }
	
	    /**
	     * Creates and returns a route that is rendered when its parent matches
	     * the current URL but none of its siblings do.
	     */
	  }, {
	    key: 'createNotFoundRoute',
	    value: function createNotFoundRoute(options) {
	      return Route.createRoute(assign({}, options, { isNotFound: true }));
	    }
	
	    /**
	     * Creates and returns a route that automatically redirects the transition
	     * to another route. In addition to the normal options to createRoute, this
	     * function accepts the following options:
	     *
	     * - from         An alias for the `path` option. Defaults to *
	     * - to           The path/route/route name to redirect to
	     * - params       The params to use in the redirect URL. Defaults
	     *                to using the current params
	     * - query        The query to use in the redirect URL. Defaults
	     *                to using the current query
	     */
	  }, {
	    key: 'createRedirect',
	    value: function createRedirect(options) {
	      return Route.createRoute(assign({}, options, {
	        path: options.path || options.from || '*',
	        onEnter: function onEnter(transition, params, query) {
	          transition.redirect(options.to, options.params || params, options.query || query);
	        }
	      }));
	    }
	  }]);
	
	  function Route(name, path, ignoreScrollBehavior, isDefault, isNotFound, onEnter, onLeave, handler) {
	    _classCallCheck(this, Route);
	
	    this.name = name;
	    this.path = path;
	    this.paramNames = PathUtils.extractParamNames(this.path);
	    this.ignoreScrollBehavior = !!ignoreScrollBehavior;
	    this.isDefault = !!isDefault;
	    this.isNotFound = !!isNotFound;
	    this.onEnter = onEnter;
	    this.onLeave = onLeave;
	    this.handler = handler;
	  }
	
	  /**
	   * Appends the given route to this route's child routes.
	   */
	
	  _createClass(Route, [{
	    key: 'appendChild',
	    value: function appendChild(route) {
	      invariant(route instanceof Route, 'route.appendChild must use a valid Route');
	
	      if (!this.childRoutes) this.childRoutes = [];
	
	      this.childRoutes.push(route);
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var string = '<Route';
	
	      if (this.name) string += ' name="' + this.name + '"';
	
	      string += ' path="' + this.path + '">';
	
	      return string;
	    }
	  }]);
	
	  return Route;
	})();
	
	module.exports = Route;

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPerf
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * ReactPerf is a general AOP system designed to measure performance. This
	 * module only has the hooks: see ReactDefaultPerf for the analysis tool.
	 */
	var ReactPerf = {
	  /**
	   * Boolean to enable/disable measurement. Set to false by default to prevent
	   * accidental logging and perf loss.
	   */
	  enableMeasure: false,
	
	  /**
	   * Holds onto the measure function in use. By default, don't measure
	   * anything, but we'll override this if we inject a measure function.
	   */
	  storedMeasure: _noMeasure,
	
	  /**
	   * @param {object} object
	   * @param {string} objectName
	   * @param {object<string>} methodNames
	   */
	  measureMethods: function(object, objectName, methodNames) {
	    if (false) {
	      for (var key in methodNames) {
	        if (!methodNames.hasOwnProperty(key)) {
	          continue;
	        }
	        object[key] = ReactPerf.measure(
	          objectName,
	          methodNames[key],
	          object[key]
	        );
	      }
	    }
	  },
	
	  /**
	   * Use this to wrap methods you want to measure. Zero overhead in production.
	   *
	   * @param {string} objName
	   * @param {string} fnName
	   * @param {function} func
	   * @return {function}
	   */
	  measure: function(objName, fnName, func) {
	    if (false) {
	      var measuredFunc = null;
	      var wrapper = function() {
	        if (ReactPerf.enableMeasure) {
	          if (!measuredFunc) {
	            measuredFunc = ReactPerf.storedMeasure(objName, fnName, func);
	          }
	          return measuredFunc.apply(this, arguments);
	        }
	        return func.apply(this, arguments);
	      };
	      wrapper.displayName = objName + '_' + fnName;
	      return wrapper;
	    }
	    return func;
	  },
	
	  injection: {
	    /**
	     * @param {function} measure
	     */
	    injectMeasure: function(measure) {
	      ReactPerf.storedMeasure = measure;
	    }
	  }
	};
	
	/**
	 * Simply passes through the measured function, without measuring it.
	 *
	 * @param {string} objName
	 * @param {string} fnName
	 * @param {function} func
	 * @return {function}
	 */
	function _noMeasure(objName, fnName, func) {
	  return func;
	}
	
	module.exports = ReactPerf;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(70);
	
	var assign = __webpack_require__(11);
	var emptyFunction = __webpack_require__(63);
	var getEventTarget = __webpack_require__(257);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: getEventTarget,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function(event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 */
	function SyntheticEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  this.dispatchConfig = dispatchConfig;
	  this.dispatchMarker = dispatchMarker;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      this[propName] = nativeEvent[propName];
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ?
	    nativeEvent.defaultPrevented :
	    nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	}
	
	assign(SyntheticEvent.prototype, {
	
	  preventDefault: function() {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function() {
	    var event = this.nativeEvent;
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function() {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function() {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      this[propName] = null;
	    }
	    this.dispatchConfig = null;
	    this.dispatchMarker = null;
	    this.nativeEvent = null;
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function(Class, Interface) {
	  var Super = this;
	
	  var prototype = Object.create(Super.prototype);
	  assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.threeArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.threeArgumentPooler);
	
	module.exports = SyntheticEvent;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var Boolean = __webpack_require__(405);
	var isType = __webpack_require__(55);
	var getTypeName = __webpack_require__(37);
	
	// return true if the type constructor behaves like the identity function
	module.exports = function isIdentity(type) {
	  if (isType(type)) {
	    if (false) {
	      assert(Boolean.is(type.meta.identity), function () { return 'Invalid meta identity ' + assert.stringify(type.meta.identity) + ' supplied to type ' + getTypeName(type); });
	    }
	    return type.meta.identity;
	  }
	  // for tcomb the other constructors, like ES6 classes, are identity-like
	  return true;
	};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	var isNil = __webpack_require__(82);
	var isArray = __webpack_require__(75);
	
	module.exports = function isObject(x) {
	  return !isNil(x) && typeof x === 'object' && !isArray(x);
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _imgAsync = __webpack_require__(224);
	
	var _imgAsync2 = _interopRequireDefault(_imgAsync);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodashLangIsEqual = __webpack_require__(353);
	
	var _lodashLangIsEqual2 = _interopRequireDefault(_lodashLangIsEqual);
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _videoPreviewPlayer = __webpack_require__(482);
	
	var _videoPreviewPlayer2 = _interopRequireDefault(_videoPreviewPlayer);
	
	var _imagePreviewPlayer = __webpack_require__(481);
	
	var _imagePreviewPlayer2 = _interopRequireDefault(_imagePreviewPlayer);
	
	var _lodashLangCloneDeep = __webpack_require__(68);
	
	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);
	
	var _lodash = __webpack_require__(109);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var Thumb = _react2['default'].createClass({
	
	    displayName: 'Thumb',
	
	    propTypes: {
	        media: _react2['default'].PropTypes.object.isRequired,
	        className: _react2['default'].PropTypes.string,
	        isBasketItem: _react2['default'].PropTypes.bool,
	        isSharedItem: _react2['default'].PropTypes.bool
	    },
	
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            previewImages: false,
	            previewVideo: false
	        };
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        return _immutable2['default'].is(nextProps.media, this.props.media) === false || (0, _lodashLangIsEqual2['default'])(nextState, this.state) === false;
	    },
	
	    /**
	     * Opens the video modal on click
	     */
	    openMediaModal: function openMediaModal(e) {
	        var _this = this;
	
	        e.preventDefault();
	        this.prepareMediaForOpening(this.props.isBasketItem, this.props.isSharedItem);
	        setTimeout(function () {
	            _utilsFlux2['default'].getActions('media').openCurrentMedia(_this.props.media.get('id'));
	        }, 10);
	    },
	
	    prepareMediaForOpening: function prepareMediaForOpening(isBasketItem, isSharedItem) {
	        if (isBasketItem) {
	            _utilsFlux2['default'].getActions('media').cloneMediaAndMetaToModalDataFromBasket(_utilsFlux2['default'].getStore('basket').getState().basket);
	            _utilsFlux2['default'].getActions('media').cloneSlotDefinitionsToModalDataFromBasket(_utilsFlux2['default'].getStore('basket').getState().slotDefinitions);
	        } else if (isSharedItem) {
	            _utilsFlux2['default'].getActions('media').cloneMediaAndMetaToModalDataFromShared(_utilsFlux2['default'].getStore('share').getState().baskets);
	            _utilsFlux2['default'].getActions('media').cloneSlotDefinitionsToModalDataFromShared(_utilsFlux2['default'].getStore('share').getState().slotDefinitions);
	        } else {
	            _utilsFlux2['default'].getActions('media').cloneMediaAndMetaToModalData();
	        }
	    },
	
	    /**
	     * Decides wheter we should go for a preview slideshow or preview video
	     */
	    startPreview: function startPreview() {
	        // On touch devices do nothing
	        if (Modernizr && Modernizr.touchevents) {
	            return;
	        }
	
	        // On non-touch devices lets go for the best option
	        if (this.props.media.get('hoverImages').size !== 0) {
	            this.setState({
	                'previewImages': true
	            });
	        } else if (this.props.media.get('hoverVideos').size !== 0) {
	            this.setState({
	                'previewVideo': true
	            });
	        }
	    },
	
	    /**
	     * Fallback to the main preview image
	     */
	    stopPreview: function stopPreview() {
	        this.setState(this.getInitialState());
	    },
	
	    // Clear Timeout on unmount
	    componentWillUnmount: function componentWillUnmount() {
	        var image = _react2['default'].findDOMNode(this.refs.image);
	        if (image) {
	            image.removeEventListener('error', this._onImageError);
	        }
	    },
	
	    _onImageError: function _onImageError() {
	        var media = this.props.media.toJS();
	        var image = _react2['default'].findDOMNode(this.refs.image);
	        image.src = this.state.previewSlideUrl ? this.state.previewSlideUrl : media.overview ? media.overview.src : Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src;
	        _utilsDom2['default'].addClass(image, 'image--loaded');
	        _utilsDom2['default'].addClass(image, 'image--error');
	    },
	
	    componentDidMount: function componentDidMount() {
	        this.resolveImages();
	    },
	    componentWillReceiveProps: function componentWillReceiveProps() {
	        //this.resolveImages();
	    },
	
	    resolveImages: function resolveImages() {
	        var image = _react2['default'].findDOMNode(this.refs.image);
	        var media = this.props.media.toJS();
	        var imageSrc = _utilsApi2['default'].cachedImagePath(this.state.previewSlideUrl ? this.state.previewSlideUrl : media.overview ? media.overview.src : Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src);
	        (0, _imgAsync2['default'])(imageSrc).then(function () {
	            if (Modernizr && Modernizr.objectfit) {
	                _utilsDom2['default'].addClass(image, 'image--loaded');
	            } else {
	                // Polyfill for object-fill: contain
	                image.parentNode.style.backgroundImage = 'url(' + image.src + ')';
	            }
	        }, this._onImageError);
	    },
	
	    /**
	     * Render the video preview if we have hover videos
	     */
	    renderVideoPreviewPlayer: function renderVideoPreviewPlayer() {
	        if (this.props.media.get('hoverVideos').size === 0) {
	            return;
	        }
	
	        var media = this.props.media.toJS();
	        var imageSrc = _utilsApi2['default'].cachedImagePath(this.state.previewSlideUrl ? this.state.previewSlideUrl : Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src);
	
	        return _react2['default'].createElement(_videoPreviewPlayer2['default'], { show: this.state.previewVideo, poster: imageSrc, videos: this.props.media.get('hoverVideos') });
	    },
	
	    /**
	     * Render the image player preview if we have hover images
	     */
	    renderImagePreviewPlayer: function renderImagePreviewPlayer() {
	        if (this.props.media.get('hoverImages').size === 0) {
	            return;
	        }
	
	        var media = this.props.media.toJS();
	        var imageSrc = _utilsApi2['default'].cachedImagePath(this.state.previewSlideUrl ? this.state.previewSlideUrl : Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src);
	
	        return _react2['default'].createElement(_imagePreviewPlayer2['default'], { show: this.state.previewImages, poster: imageSrc, images: this.props.media.get('hoverImages') });
	    },
	
	    render: function render() {
	        var media = this.props.media.toJS();
	        var image = media.overview ? media.overview : Array.isArray(media.thumbnails) ? media.thumbnails[0].preview : media.thumbnails.preview;
	        var external = media.external;
	        if (external) {
	            external = _react2['default'].createElement(
	                'div',
	                { className: 'external' },
	                _react2['default'].createElement('img', { src: '/images/external.png' })
	            );
	        }
	        var imageSrc = _utilsApi2['default'].cachedImagePath(this.state.previewSlideUrl ? this.state.previewSlideUrl : image.src);
	
	        return _react2['default'].createElement(
	            'div',
	            {
	                className: (0, _classnames2['default'])('thumbnail--asset', this.props.className, { 'active': this.state.previewImages || this.state.previewVideo }),
	                onClick: this.props.onClickOpenModal ? this.openMediaModal : null,
	                onMouseEnter: this.startPreview,
	                onMouseLeave: this.stopPreview
	            },
	            _react2['default'].createElement(
	                'div',
	                { className: 'preview__image' },
	                _react2['default'].createElement('img', { className: 'image__static', ref: 'image', src: imageSrc, width: image.width, height: image.height }),
	                this.renderVideoPreviewPlayer(),
	                this.renderImagePreviewPlayer(),
	                external
	            ),
	            this.props.children
	        );
	    }
	});
	
	module.exports = Thumb;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(50);
	var TAG = __webpack_require__(13)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(22).f;
	var has = __webpack_require__(41);
	var TAG = __webpack_require__(13)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var defined = __webpack_require__(58);
	var fails = __webpack_require__(9);
	var spaces = __webpack_require__(217);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/**
	 * @license
	 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern -d -o ./index.js`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '3.10.1';
	
	  /** Used to compose bitmasks for wrapper metadata. */
	  var BIND_FLAG = 1,
	      BIND_KEY_FLAG = 2,
	      CURRY_BOUND_FLAG = 4,
	      CURRY_FLAG = 8,
	      CURRY_RIGHT_FLAG = 16,
	      PARTIAL_FLAG = 32,
	      PARTIAL_RIGHT_FLAG = 64,
	      ARY_FLAG = 128,
	      REARG_FLAG = 256;
	
	  /** Used as default options for `_.trunc`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect when a function becomes hot. */
	  var HOT_COUNT = 150,
	      HOT_SPAN = 16;
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2;
	
	  /** Used as the `TypeError` message for "Functions" methods. */
	  var FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      objectTag = '[object Object]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      weakMapTag = '[object WeakMap]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
	      reUnescapedHtml = /[&<>"'`]/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	  /**
	   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
	   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
	   */
	  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
	      reHasRegExpChars = RegExp(reRegExpChars.source);
	
	  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
	  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect hexadecimal string values. */
	  var reHasHexPrefix = /^0[xX]/;
	
	  /** Used to detect host constructors (Safari > 5). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^\d+$/;
	
	  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
	  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to match words to create compound words. */
	  var reWords = (function() {
	    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
	        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';
	
	    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
	  }());
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
	    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
	    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	  cloneableTags[dateTag] = cloneableTags[float32Tag] =
	  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[stringTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[mapTag] = cloneableTags[setTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map latin-1 supplementary letters to basic latin letters. */
	  var deburredLetters = {
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;',
	    '`': '&#96;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'",
	    '&#96;': '`'
	  };
	
	  /** Used to determine if values are of the language type `Object`. */
	  var objectTypes = {
	    'function': true,
	    'object': true
	  };
	
	  /** Used to escape characters for inclusion in compiled regexes. */
	  var regexpEscapes = {
	    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
	    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
	    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
	    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
	    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Detect free variable `exports`. */
	  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = objectTypes[typeof self] && self && self.Object && self;
	
	  /** Detect free variable `window`. */
	  var freeWindow = objectTypes[typeof window] && window && window.Object && window;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;
	
	  /**
	   * Used as a reference to the global object.
	   *
	   * The `this` value is used if it's the global object to avoid Greasemonkey's
	   * restricted `window` object, otherwise the `window` object is used.
	   */
	  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The base implementation of `compareAscending` which compares values and
	   * sorts them in ascending order without guaranteeing a stable sort.
	   *
	   * @private
	   * @param {*} value The value to compare.
	   * @param {*} other The other value to compare.
	   * @returns {number} Returns the sort order indicator for `value`.
	   */
	  function baseCompareAscending(value, other) {
	    if (value !== other) {
	      var valIsNull = value === null,
	          valIsUndef = value === undefined,
	          valIsReflexive = value === value;
	
	      var othIsNull = other === null,
	          othIsUndef = other === undefined,
	          othIsReflexive = other === other;
	
	      if ((value > other && !othIsNull) || !valIsReflexive ||
	          (valIsNull && !othIsUndef && othIsReflexive) ||
	          (valIsUndef && othIsReflexive)) {
	        return 1;
	      }
	      if ((value < other && !valIsNull) || !othIsReflexive ||
	          (othIsNull && !valIsUndef && valIsReflexive) ||
	          (othIsUndef && valIsReflexive)) {
	        return -1;
	      }
	    }
	    return 0;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromRight) {
	    var length = array.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without support for binary searches.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    if (value !== value) {
	      return indexOfNaN(array, fromIndex);
	    }
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isFunction` without support for environments
	   * with incorrect `typeof` results.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	   */
	  function baseIsFunction(value) {
	    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
	    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
	    return typeof value == 'function' || false;
	  }
	
	  /**
	   * Converts `value` to a string if it's not one. An empty string is returned
	   * for `null` or `undefined` values.
	   *
	   * @private
	   * @param {*} value The value to process.
	   * @returns {string} Returns the string.
	   */
	  function baseToString(value) {
	    return value == null ? '' : (value + '');
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the first character not found in `chars`.
	   */
	  function charsLeftIndex(string, chars) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last character
	   * of `string` that is not found in `chars`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @param {string} chars The characters to find.
	   * @returns {number} Returns the index of the last character not found in `chars`.
	   */
	  function charsRightIndex(string, chars) {
	    var index = string.length;
	
	    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.sortBy` to compare transformed elements of a collection and stable
	   * sort them in ascending order.
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareAscending(object, other) {
	    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
	  }
	
	  /**
	   * Used by `_.sortByOrder` to compare multiple properties of a value to another
	   * and stable sort them.
	   *
	   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
	   * a value is sorted in ascending order if its corresponding order is "asc", and
	   * descending if "desc".
	   *
	   * @private
	   * @param {Object} object The object to compare.
	   * @param {Object} other The other object to compare.
	   * @param {boolean[]} orders The order to sort by for each property.
	   * @returns {number} Returns the sort order indicator for `object`.
	   */
	  function compareMultiple(object, other, orders) {
	    var index = -1,
	        objCriteria = object.criteria,
	        othCriteria = other.criteria,
	        length = objCriteria.length,
	        ordersLength = orders.length;
	
	    while (++index < length) {
	      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
	      if (result) {
	        if (index >= ordersLength) {
	          return result;
	        }
	        var order = orders[index];
	        return result * ((order === 'asc' || order === true) ? 1 : -1);
	      }
	    }
	    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	    // that causes it, under certain circumstances, to provide the same value for
	    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	    // for more details.
	    //
	    // This also ensures a stable sort in V8 and other engines.
	    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
	    return object.index - other.index;
	  }
	
	  /**
	   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  function deburrLetter(letter) {
	    return deburredLetters[letter];
	  }
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeHtmlChar(chr) {
	    return htmlEscapes[chr];
	  }
	
	  /**
	   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @param {string} leadingChar The capture group for a leading character.
	   * @param {string} whitespaceChar The capture group for a whitespace character.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
	    if (leadingChar) {
	      chr = regexpEscapes[chr];
	    } else if (whitespaceChar) {
	      chr = stringEscapes[chr];
	    }
	    return '\\' + chr;
	  }
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `NaN` is found in `array`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	   */
	  function indexOfNaN(array, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 0 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var other = array[index];
	      if (other !== other) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Checks if `value` is object-like.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	   */
	  function isObjectLike(value) {
	    return !!value && typeof value == 'object';
	  }
	
	  /**
	   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
	   * character code is whitespace.
	   *
	   * @private
	   * @param {number} charCode The character code to inspect.
	   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
	   */
	  function isSpace(charCode) {
	    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
	      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      if (array[index] === placeholder) {
	        array[index] = PLACEHOLDER;
	        result[++resIndex] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * An implementation of `_.uniq` optimized for sorted arrays without support
	   * for callback shorthands and `this` binding.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} [iteratee] The function invoked per iteration.
	   * @returns {Array} Returns the new duplicate-value-free array.
	   */
	  function sortedUniq(array, iteratee) {
	    var seen,
	        index = -1,
	        length = array.length,
	        resIndex = -1,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index],
	          computed = iteratee ? iteratee(value, index, array) : value;
	
	      if (!index || seen !== computed) {
	        seen = computed;
	        result[++resIndex] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the first non-whitespace character.
	   */
	  function trimmedLeftIndex(string) {
	    var index = -1,
	        length = string.length;
	
	    while (++index < length && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
	   * character of `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the index of the last non-whitespace character.
	   */
	  function trimmedRightIndex(string) {
	    var index = string.length;
	
	    while (index-- && isSpace(string.charCodeAt(index))) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(chr) {
	    return htmlUnescapes[chr];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the given `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Utility
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // using `context` to mock `Date#getTime` use in `_.now`
	   * var mock = _.runInContext({
	   *   'Date': function() {
	   *     return { 'getTime': getTimeMock };
	   *   }
	   * });
	   *
	   * // or creating a suped-up `defer` in Node.js
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  function runInContext(context) {
	    // Avoid issues with some ES3 environments that attempt to use values, named
	    // after built-in constructors like `Object`, for the creation of literals.
	    // ES5 clears this up by stating that literals must use built-in constructors.
	    // See https://es5.github.io/#x11.1.5 for more details.
	    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;
	
	    /** Native constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Number = context.Number,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for native method references. */
	    var arrayProto = Array.prototype,
	        objectProto = Object.prototype,
	        stringProto = String.prototype;
	
	    /** Used to resolve the decompiled source of functions. */
	    var fnToString = Function.prototype.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /**
	     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var objToString = objectProto.toString;
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Native method references. */
	    var ArrayBuffer = context.ArrayBuffer,
	        clearTimeout = context.clearTimeout,
	        parseFloat = context.parseFloat,
	        pow = Math.pow,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        Set = getNative(context, 'Set'),
	        setTimeout = context.setTimeout,
	        splice = arrayProto.splice,
	        Uint8Array = context.Uint8Array,
	        WeakMap = getNative(context, 'WeakMap');
	
	    /* Native method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeCreate = getNative(Object, 'create'),
	        nativeFloor = Math.floor,
	        nativeIsArray = getNative(Array, 'isArray'),
	        nativeIsFinite = context.isFinite,
	        nativeKeys = getNative(Object, 'keys'),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = getNative(Date, 'now'),
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random;
	
	    /** Used as references for `-Infinity` and `Infinity`. */
	    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
	        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;
	
	    /** Used as references for the maximum length and index of an array. */
	    var MAX_ARRAY_LENGTH = 4294967295,
	        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	    /**
	     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	     * of an array-like value.
	     */
	    var MAX_SAFE_INTEGER = 9007199254740991;
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
	     * Methods that operate on and return arrays, collections, and functions can
	     * be chained together. Methods that retrieve a single value or may return a
	     * primitive value will automatically end the chain returning the unwrapped
	     * value. Explicit chaining may be enabled using `_.chain`. The execution of
	     * chained methods is lazy, that is, execution is deferred until `_#value`
	     * is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
	     * fusion is an optimization strategy which merge iteratee calls; this can help
	     * to avoid the creation of intermediate data structures and greatly reduce the
	     * number of iteratee executions.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
	     * `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
	     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
	     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
	     * and `where`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
	     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
	     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
	     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
	     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
	     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
	     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
	     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
	     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
	     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
	     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
	     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
	     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
	     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
	     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
	     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
	     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
	     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
	     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
	     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
	     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
	     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
	     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
	     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
	     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
	     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
	     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
	     * `unescape`, `uniqueId`, `value`, and `words`
	     *
	     * The wrapper method `sample` will return a wrapped value when `n` is provided,
	     * otherwise an unwrapped value is returned.
	     *
	     * @name _
	     * @constructor
	     * @category Chain
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // returns an unwrapped value
	     * wrapped.reduce(function(total, n) {
	     *   return total + n;
	     * });
	     * // => 6
	     *
	     * // returns a wrapped value
	     * var squares = wrapped.map(function(n) {
	     *   return n * n;
	     * });
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The function whose prototype all chaining wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
	     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
	     */
	    function LodashWrapper(value, chainAll, actions) {
	      this.__wrapped__ = value;
	      this.__actions__ = actions || [];
	      this.__chain__ = !!chainAll;
	    }
	
	    /**
	     * An object environment feature flags.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    var support = lodash.support = {};
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB). Change the following template settings to use
	     * alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type Object
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type RegExp
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type string
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type Object
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type Function
	         */
	        '_': lodash
	      }
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = POSITIVE_INFINITY;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = arrayCopy(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = arrayCopy(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = arrayCopy(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
	        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a cache object to store key/value pairs.
	     *
	     * @private
	     * @static
	     * @name Cache
	     * @memberOf _.memoize
	     */
	    function MapCache() {
	      this.__data__ = {};
	    }
	
	    /**
	     * Removes `key` and its value from the cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
	     */
	    function mapDelete(key) {
	      return this.has(key) && delete this.__data__[key];
	    }
	
	    /**
	     * Gets the cached value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the cached value.
	     */
	    function mapGet(key) {
	      return key == '__proto__' ? undefined : this.__data__[key];
	    }
	
	    /**
	     * Checks if a cached value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapHas(key) {
	      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
	    }
	
	    /**
	     * Sets `value` to `key` of the cache.
	     *
	     * @private
	     * @name set
	     * @memberOf _.memoize.Cache
	     * @param {string} key The key of the value to cache.
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache object.
	     */
	    function mapSet(key, value) {
	      if (key != '__proto__') {
	        this.__data__[key] = value;
	      }
	      return this;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates a cache object to store unique values.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var length = values ? values.length : 0;
	
	      this.data = { 'hash': nativeCreate(null), 'set': new Set };
	      while (length--) {
	        this.push(values[length]);
	      }
	    }
	
	    /**
	     * Checks if `value` is in `cache` mimicking the return signature of
	     * `_.indexOf` by returning `0` if the value is found, else `-1`.
	     *
	     * @private
	     * @param {Object} cache The cache to search.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `0` if `value` is found, else `-1`.
	     */
	    function cacheIndexOf(cache, value) {
	      var data = cache.data,
	          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	      return result ? 0 : -1;
	    }
	
	    /**
	     * Adds `value` to the cache.
	     *
	     * @private
	     * @name push
	     * @memberOf SetCache
	     * @param {*} value The value to cache.
	     */
	    function cachePush(value) {
	      var data = this.data;
	      if (typeof value == 'string' || isObject(value)) {
	        data.set.add(value);
	      } else {
	        data.hash[value] = true;
	      }
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a new array joining `array` with `other`.
	     *
	     * @private
	     * @param {Array} array The array to join.
	     * @param {Array} other The other array to join.
	     * @returns {Array} Returns the new concatenated array.
	     */
	    function arrayConcat(array, other) {
	      var index = -1,
	          length = array.length,
	          othIndex = -1,
	          othLength = other.length,
	          result = Array(length + othLength);
	
	      while (++index < length) {
	        result[index] = array[index];
	      }
	      while (++othIndex < othLength) {
	        result[index++] = other[othIndex];
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayCopy(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEach` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEach(array, iteratee) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (iteratee(array[index], index, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.forEachRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayEachRight(array, iteratee) {
	      var length = array.length;
	
	      while (length--) {
	        if (iteratee(array[length], length, array) === false) {
	          break;
	        }
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.every` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     */
	    function arrayEvery(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (!predicate(array[index], index, array)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
	     * with one argument: (value).
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function arrayExtremum(array, iteratee, comparator, exValue) {
	      var index = -1,
	          length = array.length,
	          computed = exValue,
	          result = computed;
	
	      while (++index < length) {
	        var value = array[index],
	            current = +iteratee(value);
	
	        if (comparator(current, computed)) {
	          computed = current;
	          result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.filter` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function arrayFilter(array, predicate) {
	      var index = -1,
	          length = array.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.map` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function arrayMap(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = iteratee(array[index], index, array);
	      }
	      return result;
	    }
	
	    /**
	     * Appends the elements of `values` to `array`.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to append.
	     * @returns {Array} Returns `array`.
	     */
	    function arrayPush(array, values) {
	      var index = -1,
	          length = values.length,
	          offset = array.length;
	
	      while (++index < length) {
	        array[offset + index] = values[index];
	      }
	      return array;
	    }
	
	    /**
	     * A specialized version of `_.reduce` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the first element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduce(array, iteratee, accumulator, initFromArray) {
	      var index = -1,
	          length = array.length;
	
	      if (initFromArray && length) {
	        accumulator = array[++index];
	      }
	      while (++index < length) {
	        accumulator = iteratee(accumulator, array[index], index, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.reduceRight` for arrays without support for
	     * callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {boolean} [initFromArray] Specify using the last element of `array`
	     *  as the initial value.
	     * @returns {*} Returns the accumulated value.
	     */
	    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
	      var length = array.length;
	      if (initFromArray && length) {
	        accumulator = array[--length];
	      }
	      while (length--) {
	        accumulator = iteratee(accumulator, array[length], length, array);
	      }
	      return accumulator;
	    }
	
	    /**
	     * A specialized version of `_.some` for arrays without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function arraySome(array, predicate) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        if (predicate(array[index], index, array)) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `_.sum` for arrays without support for callback
	     * shorthands and `this` binding..
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function arraySum(array, iteratee) {
	      var length = array.length,
	          result = 0;
	
	      while (length--) {
	        result += +iteratee(array[length]) || 0;
	      }
	      return result;
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assign` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : objectValue;
	    }
	
	    /**
	     * Used by `_.template` to customize its `_.assign` use.
	     *
	     * **Note:** This function is like `assignDefaults` except that it ignores
	     * inherited property values when checking if a property is `undefined`.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @param {string} key The key associated with the object and source values.
	     * @param {Object} object The destination object.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function assignOwnDefaults(objectValue, sourceValue, key, object) {
	      return (objectValue === undefined || !hasOwnProperty.call(object, key))
	        ? sourceValue
	        : objectValue;
	    }
	
	    /**
	     * A specialized version of `_.assign` for customizing assigned values without
	     * support for argument juggling, multiple sources, and `this` binding `customizer`
	     * functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     */
	    function assignWith(object, source, customizer) {
	      var index = -1,
	          props = keys(source),
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key],
	            result = customizer(value, source[key], key, object, source);
	
	        if ((result === result ? (result !== value) : (value === value)) ||
	            (value === undefined && !(key in object))) {
	          object[key] = result;
	        }
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for argument juggling,
	     * multiple sources, and `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return source == null
	        ? object
	        : baseCopy(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.at` without support for string collections
	     * and individual key arguments.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {number[]|string[]} props The property names or indexes of elements to pick.
	     * @returns {Array} Returns the new array of picked elements.
	     */
	    function baseAt(collection, props) {
	      var index = -1,
	          isNil = collection == null,
	          isArr = !isNil && isArrayLike(collection),
	          length = isArr ? collection.length : 0,
	          propsLength = props.length,
	          result = Array(propsLength);
	
	      while(++index < propsLength) {
	        var key = props[index];
	        if (isArr) {
	          result[index] = isIndex(key, length) ? collection[key] : undefined;
	        } else {
	          result[index] = isNil ? undefined : collection[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property names to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @returns {Object} Returns `object`.
	     */
	    function baseCopy(source, props, object) {
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	        object[key] = source[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `_.callback` which supports specifying the
	     * number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function baseCallback(func, thisArg, argCount) {
	      var type = typeof func;
	      if (type == 'function') {
	        return thisArg === undefined
	          ? func
	          : bindCallback(func, thisArg, argCount);
	      }
	      if (func == null) {
	        return identity;
	      }
	      if (type == 'object') {
	        return baseMatches(func);
	      }
	      return thisArg === undefined
	        ? property(func)
	        : baseMatchesProperty(func, thisArg);
	    }
	
	    /**
	     * The base implementation of `_.clone` without support for argument juggling
	     * and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The object `value` belongs to.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates clones with source counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	      var result;
	      if (customizer) {
	        result = object ? customizer(value, key, object) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return arrayCopy(value, result);
	        }
	      } else {
	        var tag = objToString.call(value),
	            isFunc = tag == funcTag;
	
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = initCloneObject(isFunc ? {} : value);
	          if (!isDeep) {
	            return baseAssign(result, value);
	          }
	        } else {
	          return cloneableTags[tag]
	            ? initCloneByTag(value, tag, isDeep)
	            : (object ? value : {});
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == value) {
	          return stackB[length];
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate it with its clone.
	      stackA.push(value);
	      stackB.push(result);
	
	      // Recursively populate clone (susceptible to call stack limits).
	      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} prototype The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(prototype) {
	        if (isObject(prototype)) {
	          object.prototype = prototype;
	          var result = new object;
	          object.prototype = undefined;
	        }
	        return result || {};
	      };
	    }());
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts an index
	     * of where to slice the arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Object} args The arguments provide to `func`.
	     * @returns {number} Returns the timer id.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of `_.difference` which accepts a single array
	     * of values to exclude.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values) {
	      var length = array ? array.length : 0,
	          result = [];
	
	      if (!length) {
	        return result;
	      }
	      var index = -1,
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
	          valuesLength = values.length;
	
	      if (cache) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	        values = cache;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index];
	
	        if (isCommon && value === value) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === value) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (indexOf(values, value, 0) < 0) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object|string} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * Gets the extremum value of `collection` invoking `iteratee` for each value
	     * in `collection` to generate the criterion by which the value is ranked.
	     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(collection, iteratee, comparator, exValue) {
	      var computed = exValue,
	          result = computed;
	
	      baseEach(collection, function(value, index, collection) {
	        var current = +iteratee(value, index, collection);
	        if (comparator(current, computed) || (current === exValue && current === result)) {
	          computed = current;
	          result = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : (end >>> 0);
	      start >>>= 0;
	
	      while (start < length) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
	     * without support for callback shorthands and `this` binding, which iterates
	     * over `collection` using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @param {boolean} [retKey] Specify returning the key of the found element
	     *  instead of the element itself.
	     * @returns {*} Returns the found element or its key, else `undefined`.
	     */
	    function baseFind(collection, predicate, eachFunc, retKey) {
	      var result;
	      eachFunc(collection, function(value, key, collection) {
	        if (predicate(value, key, collection)) {
	          result = retKey ? key : value;
	          return false;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with added support for restricting
	     * flattening and specifying the start index.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, isDeep, isStrict, result) {
	      result || (result = []);
	
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index];
	        if (isObjectLike(value) && isArrayLike(value) &&
	            (isStrict || isArray(value) || isArguments(value))) {
	          if (isDeep) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, isDeep, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForIn` and `baseForOwn` which iterates
	     * over `object` properties returned by `keysFunc` invoking `iteratee` for
	     * each property. Iteratee functions may exit iteration early by explicitly
	     * returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forIn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForIn(object, iteratee) {
	      return baseFor(object, iteratee, keysIn);
	    }
	
	    /**
	     * The base implementation of `_.forOwn` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from those provided.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the new array of filtered property names.
	     */
	    function baseFunctions(object, props) {
	      var index = -1,
	          length = props.length,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var key = props[index];
	        if (isFunction(object[key])) {
	          result[++resIndex] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `get` without support for string paths
	     * and default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path of the property to get.
	     * @param {string} [pathKey] The key representation of path.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path, pathKey) {
	      if (object == null) {
	        return;
	      }
	      if (pathKey !== undefined && pathKey in toObject(object)) {
	        path = [pathKey];
	      }
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[path[index++]];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` without support for `this` binding
	     * `customizer` functions.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = arrayTag,
	          othTag = arrayTag;
	
	      if (!objIsArr) {
	        objTag = objToString.call(object);
	        if (objTag == argsTag) {
	          objTag = objectTag;
	        } else if (objTag != objectTag) {
	          objIsArr = isTypedArray(object);
	        }
	      }
	      if (!othIsArr) {
	        othTag = objToString.call(other);
	        if (othTag == argsTag) {
	          othTag = objectTag;
	        } else if (othTag != objectTag) {
	          othIsArr = isTypedArray(other);
	        }
	      }
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && !(objIsArr || objIsObj)) {
	        return equalByTag(object, other, objTag);
	      }
	      if (!isLoose) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      // For more information on detecting circular references see https://es5.github.io/#JO.
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	
	      var length = stackA.length;
	      while (length--) {
	        if (stackA[length] == object) {
	          return stackB[length] == other;
	        }
	      }
	      // Add `object` and `other` to the stack of traversed objects.
	      stackA.push(object);
	      stackB.push(other);
	
	      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	      stackA.pop();
	      stackB.pop();
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for callback
	     * shorthands and `this` binding.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} matchData The propery names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparing objects.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = toObject(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which does not clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        var key = matchData[0][0],
	            value = matchData[0][1];
	
	        return function(object) {
	          if (object == null) {
	            return false;
	          }
	          return object[key] === value && (value !== undefined || (key in toObject(object)));
	        };
	      }
	      return function(object) {
	        return baseIsMatch(object, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to compare.
	     * @returns {Function} Returns the new function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      var isArr = isArray(path),
	          isCommon = isKey(path) && isStrictComparable(srcValue),
	          pathKey = (path + '');
	
	      path = toPath(path);
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        var key = pathKey;
	        object = toObject(object);
	        if ((isArr || !isCommon) && !(key in object)) {
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          if (object == null) {
	            return false;
	          }
	          key = last(path);
	          object = toObject(object);
	        }
	        return object[key] === srcValue
	          ? (srcValue !== undefined || (key in object))
	          : baseIsEqual(srcValue, object[key], undefined, true);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for argument juggling,
	     * multiple sources, and `this` binding `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {Object} Returns `object`.
	     */
	    function baseMerge(object, source, customizer, stackA, stackB) {
	      if (!isObject(object)) {
	        return object;
	      }
	      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	          props = isSrcArr ? undefined : keys(source);
	
	      arrayEach(props || source, function(srcValue, key) {
	        if (props) {
	          key = srcValue;
	          srcValue = source[key];
	        }
	        if (isObjectLike(srcValue)) {
	          stackA || (stackA = []);
	          stackB || (stackB = []);
	          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	        }
	        else {
	          var value = object[key],
	              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	              isCommon = result === undefined;
	
	          if (isCommon) {
	            result = srcValue;
	          }
	          if ((result !== undefined || (isSrcArr && !(key in object))) &&
	              (isCommon || (result === result ? (result !== value) : (value === value)))) {
	            object[key] = result;
	          }
	        }
	      });
	      return object;
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Array} [stackA=[]] Tracks traversed source objects.
	     * @param {Array} [stackB=[]] Associates values with source counterparts.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	      var length = stackA.length,
	          srcValue = source[key];
	
	      while (length--) {
	        if (stackA[length] == srcValue) {
	          object[key] = stackB[length];
	          return;
	        }
	      }
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	          result = isArray(value)
	            ? value
	            : (isArrayLike(value) ? arrayCopy(value) : []);
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          result = isArguments(value)
	            ? toPlainObject(value)
	            : (isPlainObject(value) ? value : {});
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      // Add the source value to the stack of traversed objects and associate
	      // it with its merged value.
	      stackA.push(srcValue);
	      stackB.push(result);
	
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	      } else if (result === result ? (result !== value) : (value === value)) {
	        object[key] = result;
	      }
	    }
	
	    /**
	     * The base implementation of `_.property` without support for deep paths.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function baseProperty(key) {
	      return function(object) {
	        return object == null ? undefined : object[key];
	      };
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     */
	    function basePropertyDeep(path) {
	      var pathKey = (path + '');
	      path = toPath(path);
	      return function(object) {
	        return baseGet(object, path, pathKey);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * index arguments and capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0;
	      while (length--) {
	        var index = indexes[length];
	        if (index != previous && isIndex(index)) {
	          var previous = index;
	          splice.call(array, index, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for argument juggling
	     * and returning floating-point numbers.
	     *
	     * @private
	     * @param {number} min The minimum possible value.
	     * @param {number} max The maximum possible value.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(min, max) {
	      return min + nativeFloor(nativeRandom() * (max - min + 1));
	    }
	
	    /**
	     * The base implementation of `_.reduce` and `_.reduceRight` without support
	     * for callback shorthands and `this` binding, which iterates over `collection`
	     * using the provided `eachFunc`.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {*} accumulator The initial value.
	     * @param {boolean} initFromCollection Specify using the first or last element
	     *  of `collection` as the initial value.
	     * @param {Function} eachFunc The function to iterate over `collection`.
	     * @returns {*} Returns the accumulated value.
	     */
	    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
	      eachFunc(collection, function(value, index, collection) {
	        accumulator = initFromCollection
	          ? (initFromCollection = false, value)
	          : iteratee(accumulator, value, index, collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop detection.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      start = start == null ? 0 : (+start || 0);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : (+end || 0);
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortBy` which uses `comparer` to define
	     * the sort order of `array` and replaces criteria objects with their
	     * corresponding values.
	     *
	     * @private
	     * @param {Array} array The array to sort.
	     * @param {Function} comparer The function to define sort order.
	     * @returns {Array} Returns `array`.
	     */
	    function baseSortBy(array, comparer) {
	      var length = array.length;
	
	      array.sort(comparer);
	      while (length--) {
	        array[length] = array[length].value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.sortByOrder` without param guards.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseSortByOrder(collection, iteratees, orders) {
	      var callback = getCallback(),
	          index = -1;
	
	      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });
	
	      var result = baseMap(collection, function(value) {
	        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.sum` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {number} Returns the sum.
	     */
	    function baseSum(collection, iteratee) {
	      var result = 0;
	      baseEach(collection, function(value, index, collection) {
	        result += +iteratee(value, index, collection) || 0;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.uniq` without support for callback shorthands
	     * and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The function invoked per iteration.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     */
	    function baseUniq(array, iteratee) {
	      var index = -1,
	          indexOf = getIndexOf(),
	          length = array.length,
	          isCommon = indexOf == baseIndexOf,
	          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	          seen = isLarge ? createCache() : null,
	          result = [];
	
	      if (seen) {
	        indexOf = cacheIndexOf;
	        isCommon = false;
	      } else {
	        isLarge = false;
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value, index, array) : value;
	
	        if (isCommon && value === value) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (indexOf(seen, computed, 0) < 0) {
	          if (iteratee || isLarge) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.values` and `_.valuesIn` which creates an
	     * array of `object` property values corresponding to the property names
	     * of `props`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} props The property names to get values for.
	     * @returns {Object} Returns the array of property values.
	     */
	    function baseValues(object, props) {
	      var index = -1,
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = object[props[index]];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
	     * and `_.takeWhile` without support for callback shorthands and `this` binding.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to peform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      var index = -1,
	          length = actions.length;
	
	      while (++index < length) {
	        var action = actions[index];
	        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }
	      return result;
	    }
	
	    /**
	     * Performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndex(array, value, retHighest) {
	      var low = 0,
	          high = array ? array.length : low;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return binaryIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * This function is like `binaryIndex` except that it invokes `iteratee` for
	     * `value` and each element of `array` to compute their sort ranking. The
	     * iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function binaryIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array ? array.length : 0,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsUndef = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            isDef = computed !== undefined,
	            isReflexive = computed === computed;
	
	        if (valIsNaN) {
	          var setLow = isReflexive || retHighest;
	        } else if (valIsNull) {
	          setLow = isReflexive && isDef && (retHighest || computed != null);
	        } else if (valIsUndef) {
	          setLow = isReflexive && (retHighest || isDef);
	        } else if (computed == null) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * A specialized version of `baseCallback` which only supports `this` binding
	     * and specifying the number of arguments to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {number} [argCount] The number of arguments to provide to `func`.
	     * @returns {Function} Returns the callback.
	     */
	    function bindCallback(func, thisArg, argCount) {
	      if (typeof func != 'function') {
	        return identity;
	      }
	      if (thisArg === undefined) {
	        return func;
	      }
	      switch (argCount) {
	        case 1: return function(value) {
	          return func.call(thisArg, value);
	        };
	        case 3: return function(value, index, collection) {
	          return func.call(thisArg, value, index, collection);
	        };
	        case 4: return function(accumulator, value, index, collection) {
	          return func.call(thisArg, accumulator, value, index, collection);
	        };
	        case 5: return function(value, other, key, object, source) {
	          return func.call(thisArg, value, other, key, object, source);
	        };
	      }
	      return function() {
	        return func.apply(thisArg, arguments);
	      };
	    }
	
	    /**
	     * Creates a clone of the given array buffer.
	     *
	     * @private
	     * @param {ArrayBuffer} buffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function bufferClone(buffer) {
	      var result = new ArrayBuffer(buffer.byteLength),
	          view = new Uint8Array(result);
	
	      view.set(new Uint8Array(buffer));
	      return result;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders) {
	      var holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          leftIndex = -1,
	          leftLength = partials.length,
	          result = Array(leftLength + argsLength);
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        result[holders[argsIndex]] = args[argsIndex];
	      }
	      while (argsLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array|Object} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders) {
	      var holdersIndex = -1,
	          holdersLength = holders.length,
	          argsIndex = -1,
	          argsLength = nativeMax(args.length - holdersLength, 0),
	          rightIndex = -1,
	          rightLength = partials.length,
	          result = Array(argsLength + rightLength);
	
	      while (++argsIndex < argsLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        result[offset + holders[holdersIndex]] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
	     *
	     * @private
	     * @param {Function} setter The function to set keys and values of the accumulator object.
	     * @param {Function} [initializer] The function to initialize the accumulator object.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee, thisArg) {
	        var result = initializer ? initializer() : {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        if (isArray(collection)) {
	          var index = -1,
	              length = collection.length;
	
	          while (++index < length) {
	            var value = collection[index];
	            setter(result, value, iteratee(value, index, collection), collection);
	          }
	        } else {
	          baseEach(collection, function(value, key, collection) {
	            setter(result, value, iteratee(value, key, collection), collection);
	          });
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return restParam(function(object, sources) {
	        var index = -1,
	            length = object == null ? 0 : sources.length,
	            customizer = length > 2 ? sources[length - 2] : undefined,
	            guard = length > 2 ? sources[2] : undefined,
	            thisArg = length > 1 ? sources[length - 1] : undefined;
	
	        if (typeof customizer == 'function') {
	          customizer = bindCallback(customizer, thisArg, 5);
	          length -= 2;
	        } else {
	          customizer = typeof thisArg == 'function' ? thisArg : undefined;
	          length -= (customizer ? 1 : 0);
	        }
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        var length = collection ? getLength(collection) : 0;
	        if (!isLength(length)) {
	          return eachFunc(collection, iteratee);
	        }
	        var index = fromRight ? length : -1,
	            iterable = toObject(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var iterable = toObject(object),
	            props = keysFunc(object),
	            length = props.length,
	            index = fromRight ? length : -1;
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var key = props[index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to bind.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createBindWrapper(func, thisArg) {
	      var Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(thisArg, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `Set` cache object to optimize linear searches of large arrays.
	     *
	     * @private
	     * @param {Array} [values] The values to cache.
	     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	     */
	    function createCache(values) {
	      return (nativeCreate && Set) ? new SetCache(values) : null;
	    }
	
	    /**
	     * Creates a function that produces compound words out of the words in a
	     * given string.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        var index = -1,
	            array = words(deburr(string)),
	            length = array.length,
	            result = '';
	
	        while (++index < length) {
	          result = callback(result, array[index], index);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtorWrapper(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors.
	        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a `_.curry` or `_.curryRight` function.
	     *
	     * @private
	     * @param {boolean} flag The curry bit flag.
	     * @returns {Function} Returns the new curry function.
	     */
	    function createCurry(flag) {
	      function curryFunc(func, arity, guard) {
	        if (guard && isIterateeCall(func, arity, guard)) {
	          arity = undefined;
	        }
	        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
	        result.placeholder = curryFunc.placeholder;
	        return result;
	      }
	      return curryFunc;
	    }
	
	    /**
	     * Creates a `_.defaults` or `_.defaultsDeep` function.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Function} Returns the new defaults function.
	     */
	    function createDefaults(assigner, customizer) {
	      return restParam(function(args) {
	        var object = args[0];
	        if (object == null) {
	          return object;
	        }
	        args.push(customizer);
	        return assigner.apply(undefined, args);
	      });
	    }
	
	    /**
	     * Creates a `_.max` or `_.min` function.
	     *
	     * @private
	     * @param {Function} comparator The function used to compare values.
	     * @param {*} exValue The initial extremum value.
	     * @returns {Function} Returns the new extremum function.
	     */
	    function createExtremum(comparator, exValue) {
	      return function(collection, iteratee, thisArg) {
	        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	          iteratee = undefined;
	        }
	        iteratee = getCallback(iteratee, thisArg, 3);
	        if (iteratee.length == 1) {
	          collection = isArray(collection) ? collection : toIterable(collection);
	          var result = arrayExtremum(collection, iteratee, comparator, exValue);
	          if (!(collection.length && result === exValue)) {
	            return result;
	          }
	        }
	        return baseExtremum(collection, iteratee, comparator, exValue);
	      };
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(eachFunc, fromRight) {
	      return function(collection, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        if (isArray(collection)) {
	          var index = baseFindIndex(collection, predicate, fromRight);
	          return index > -1 ? collection[index] : undefined;
	        }
	        return baseFind(collection, predicate, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a `_.findIndex` or `_.findLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindIndex(fromRight) {
	      return function(array, predicate, thisArg) {
	        if (!(array && array.length)) {
	          return -1;
	        }
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFindIndex(array, predicate, fromRight);
	      };
	    }
	
	    /**
	     * Creates a `_.findKey` or `_.findLastKey` function.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFindKey(objectFunc) {
	      return function(object, predicate, thisArg) {
	        predicate = getCallback(predicate, thisArg, 3);
	        return baseFind(object, predicate, objectFunc, true);
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return function() {
	        var wrapper,
	            length = arguments.length,
	            index = fromRight ? length : -1,
	            leftIndex = 0,
	            funcs = Array(length);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          var func = funcs[leftIndex++] = arguments[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
	            wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? -1 : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      };
	    }
	
	    /**
	     * Creates a function for `_.forEach` or `_.forEachRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForEach(arrayFunc, eachFunc) {
	      return function(collection, iteratee, thisArg) {
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee)
	          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
	      };
	    }
	
	    /**
	     * Creates a function for `_.forIn` or `_.forInRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForIn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee, keysIn);
	      };
	    }
	
	    /**
	     * Creates a function for `_.forOwn` or `_.forOwnRight`.
	     *
	     * @private
	     * @param {Function} objectFunc The function to iterate over an object.
	     * @returns {Function} Returns the new each function.
	     */
	    function createForOwn(objectFunc) {
	      return function(object, iteratee, thisArg) {
	        if (typeof iteratee != 'function' || thisArg !== undefined) {
	          iteratee = bindCallback(iteratee, thisArg, 3);
	        }
	        return objectFunc(object, iteratee);
	      };
	    }
	
	    /**
	     * Creates a function for `_.mapKeys` or `_.mapValues`.
	     *
	     * @private
	     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
	     * @returns {Function} Returns the new map function.
	     */
	    function createObjectMapper(isMapKeys) {
	      return function(object, iteratee, thisArg) {
	        var result = {};
	        iteratee = getCallback(iteratee, thisArg, 3);
	
	        baseForOwn(object, function(value, key, object) {
	          var mapped = iteratee(value, key, object);
	          key = isMapKeys ? mapped : key;
	          value = isMapKeys ? value : mapped;
	          result[key] = value;
	        });
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function for `_.padLeft` or `_.padRight`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify padding from the right.
	     * @returns {Function} Returns the new pad function.
	     */
	    function createPadDir(fromRight) {
	      return function(string, length, chars) {
	        string = baseToString(string);
	        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
	      };
	    }
	
	    /**
	     * Creates a `_.partial` or `_.partialRight` function.
	     *
	     * @private
	     * @param {boolean} flag The partial bit flag.
	     * @returns {Function} Returns the new partial function.
	     */
	    function createPartial(flag) {
	      var partialFunc = restParam(function(func, partials) {
	        var holders = replaceHolders(partials, partialFunc.placeholder);
	        return createWrapper(func, flag, undefined, partials, holders);
	      });
	      return partialFunc;
	    }
	
	    /**
	     * Creates a function for `_.reduce` or `_.reduceRight`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over an array.
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @returns {Function} Returns the new each function.
	     */
	    function createReduce(arrayFunc, eachFunc) {
	      return function(collection, iteratee, accumulator, thisArg) {
	        var initFromArray = arguments.length < 3;
	        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
	          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
	          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with optional `this`
	     * binding of, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & ARY_FLAG,
	          isBind = bitmask & BIND_FLAG,
	          isBindKey = bitmask & BIND_KEY_FLAG,
	          isCurry = bitmask & CURRY_FLAG,
	          isCurryBound = bitmask & CURRY_BOUND_FLAG,
	          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
	          Ctor = isBindKey ? undefined : createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it to other functions.
	        var length = arguments.length,
	            index = length,
	            args = Array(length);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight);
	        }
	        if (isCurry || isCurryRight) {
	          var placeholder = wrapper.placeholder,
	              argsHolders = replaceHolders(args, placeholder);
	
	          length -= argsHolders.length;
	          if (length < arity) {
	            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
	                newArity = nativeMax(arity - length, 0),
	                newsHolders = isCurry ? argsHolders : undefined,
	                newHoldersRight = isCurry ? undefined : argsHolders,
	                newPartials = isCurry ? args : undefined,
	                newPartialsRight = isCurry ? undefined : args;
	
	            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	            if (!isCurryBound) {
	              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	            }
	            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
	                result = createHybridWrapper.apply(undefined, newData);
	
	            if (isLaziable(func)) {
	              setData(result, newData);
	            }
	            result.placeholder = placeholder;
	            return result;
	          }
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        if (argPos) {
	          args = reorder(args, argPos);
	        }
	        if (isAry && ary < args.length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtorWrapper(func);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates the padding required for `string` based on the given `length`.
	     * The `chars` string is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {string} string The string to create padding for.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the pad for `string`.
	     */
	    function createPadding(string, length, chars) {
	      var strLength = string.length;
	      length = +length;
	
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return '';
	      }
	      var padLength = length - strLength;
	      chars = chars == null ? ' ' : (chars + '');
	      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
	    }
	
	    /**
	     * Creates a function that wraps `func` and invokes it with the optional `this`
	     * binding of `thisArg` and the `partials` prepended to those provided to
	     * the wrapper.
	     *
	     * @private
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to the new function.
	     * @returns {Function} Returns the new bound function.
	     */
	    function createPartialWrapper(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & BIND_FLAG,
	          Ctor = createCtorWrapper(func);
	
	      function wrapper() {
	        // Avoid `arguments` object use disqualifying optimizations by
	        // converting it to an array before providing it `func`.
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength);
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        precision = precision === undefined ? 0 : (+precision || 0);
	        if (precision) {
	          precision = pow(10, precision);
	          return func(number * precision) / precision;
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
	     *
	     * @private
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {Function} Returns the new index function.
	     */
	    function createSortedIndex(retHighest) {
	      return function(array, value, iteratee, thisArg) {
	        var callback = getCallback(iteratee);
	        return (iteratee == null && callback === baseCallback)
	          ? binaryIndex(array, value, retHighest)
	          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to reference.
	     * @param {number} bitmask The bitmask of flags.
	     *  The bitmask may be composed of the following flags:
	     *     1 - `_.bind`
	     *     2 - `_.bindKey`
	     *     4 - `_.curry` or `_.curryRight` of a bound function
	     *     8 - `_.curry`
	     *    16 - `_.curryRight`
	     *    32 - `_.partial`
	     *    64 - `_.partialRight`
	     *   128 - `_.rearg`
	     *   256 - `_.ary`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      length -= (holders ? holders.length : 0);
	      if (bitmask & PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func),
	          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
	
	      if (data) {
	        mergeData(newData, data);
	        bitmask = newData[1];
	        arity = newData[9];
	      }
	      newData[9] = arity == null
	        ? (isBindKey ? 0 : func.length)
	        : (nativeMax(arity - length, 0) || 0);
	
	      if (bitmask == BIND_FLAG) {
	        var result = createBindWrapper(newData[0], newData[2]);
	      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
	        result = createPartialWrapper.apply(undefined, newData);
	      } else {
	        result = createHybridWrapper.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setter(result, newData);
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing arrays.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var index = -1,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	        return false;
	      }
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index],
	            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	        if (result !== undefined) {
	          if (result) {
	            continue;
	          }
	          return false;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (isLoose) {
	          if (!arraySome(other, function(othValue) {
	                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	              })) {
	            return false;
	          }
	        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag) {
	      switch (tag) {
	        case boolTag:
	        case dateTag:
	          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	          return +object == +other;
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case numberTag:
	          // Treat `NaN` vs. `NaN` as equal.
	          return (object != +object)
	            ? other != +other
	            : object == +other;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings primitives and string
	          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	          return object == (other + '');
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Function} [customizer] The function to customize comparing values.
	     * @param {boolean} [isLoose] Specify performing partial comparisons.
	     * @param {Array} [stackA] Tracks traversed `value` objects.
	     * @param {Array} [stackB] Tracks traversed `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	      var objProps = keys(object),
	          objLength = objProps.length,
	          othProps = keys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isLoose) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      var skipCtor = isLoose;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key],
	            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	          return false;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (!skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Gets the appropriate "callback" function. If the `_.callback` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseCallback` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getCallback(func, thisArg, argCount) {
	      var result = lodash.callback || callback;
	      result = result === callback ? baseCallback : result;
	      return argCount ? result(func, thisArg, argCount) : result;
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = func.name,
	          array = realNames[result],
	          length = array ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
	     * customized this function returns the custom method, otherwise it returns
	     * the `baseIndexOf` function. If arguments are provided the chosen function
	     * is invoked with them and its result is returned.
	     *
	     * @private
	     * @returns {Function|number} Returns the chosen function or its result.
	     */
	    function getIndexOf(collection, target, fromIndex) {
	      var result = lodash.indexOf || indexOf;
	      result = result === indexOf ? baseIndexOf : result;
	      return collection ? result(collection, target, fromIndex) : result;
	    }
	
	    /**
	     * Gets the "length" property value of `object`.
	     *
	     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	     * that affects Safari on at least iOS 8.1-8.3 ARM64.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {*} Returns the "length" value.
	     */
	    var getLength = baseProperty('length');
	
	    /**
	     * Gets the propery names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = pairs(object),
	          length = result.length;
	
	      while (length--) {
	        result[length][2] = isStrictComparable(result[length][1]);
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = object == null ? undefined : object[key];
	      return isNative(value) ? value : undefined;
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = new array.constructor(length);
	
	      // Add array properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      var Ctor = object.constructor;
	      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	        Ctor = Object;
	      }
	      return new Ctor;
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return bufferClone(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          var buffer = object.buffer;
	          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          var result = new Ctor(object.source, reFlags.exec(object));
	          result.lastIndex = object.lastIndex;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the method at `path` on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function invokePath(object, path, args) {
	      if (object != null && !isKey(path, object)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        path = last(path);
	      }
	      var func = object == null ? object : object[path];
	      return func == null ? undefined : func.apply(object, args);
	    }
	
	    /**
	     * Checks if `value` is array-like.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(getLength(value));
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return value > -1 && value % 1 == 0 && value < length;
	    }
	
	    /**
	     * Checks if the provided arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	          ? (isArrayLike(object) && isIndex(index, object.length))
	          : (type == 'string' && index in object)) {
	        var other = object[index];
	        return value === value ? (value === other) : (other !== other);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      var type = typeof value;
	      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	        return true;
	      }
	      if (isArray(value)) {
	        return false;
	      }
	      var result = !reIsDeepProp.test(value);
	      return result || (object != null && value in toObject(object));
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func);
	      if (!(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      var other = lodash[funcName];
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     */
	    function isLength(value) {
	      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers required to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
	     * augment function arguments, making the order in which they are executed important,
	     * preventing the merging of metadata. However, we make an exception for a safe
	     * common case where curried functions have `_.ary` and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < ARY_FLAG;
	
	      var isCombo =
	        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
	        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
	        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = arrayCopy(value);
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use.
	     *
	     * @private
	     * @param {*} objectValue The destination object property value.
	     * @param {*} sourceValue The source object property value.
	     * @returns {*} Returns the value to assign to the destination object.
	     */
	    function mergeDefaults(objectValue, sourceValue) {
	      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties specified
	     * by `props`.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} props The property names to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByArray(object, props) {
	      object = toObject(object);
	
	      var index = -1,
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.pick` which picks `object` properties `predicate`
	     * returns truthy for.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Object} Returns the new object.
	     */
	    function pickByCallback(object, predicate) {
	      var result = {};
	      baseForIn(object, function(value, key, object) {
	        if (predicate(value, key, object)) {
	          result[key] = value;
	        }
	      });
	      return result;
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = arrayCopy(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity function
	     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = (function() {
	      var count = 0,
	          lastCalled = 0;
	
	      return function(key, value) {
	        var stamp = now(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return key;
	          }
	        } else {
	          count = 0;
	        }
	        return baseSetData(key, value);
	      };
	    }());
	
	    /**
	     * A fallback implementation of `Object.keys` which creates an array of the
	     * own enumerable property names of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function shimKeys(object) {
	      var props = keysIn(object),
	          propsLength = props.length,
	          length = propsLength && object.length;
	
	      var allowIndexes = !!length && isLength(length) &&
	        (isArray(object) || isArguments(object));
	
	      var index = -1,
	          result = [];
	
	      while (++index < propsLength) {
	        var key = props[index];
	        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to an array-like object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array|Object} Returns the array-like object.
	     */
	    function toIterable(value) {
	      if (value == null) {
	        return [];
	      }
	      if (!isArrayLike(value)) {
	        return values(value);
	      }
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to an object if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Object} Returns the object.
	     */
	    function toObject(value) {
	      return isObject(value) ? value : Object(value);
	    }
	
	    /**
	     * Converts `value` to property path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {Array} Returns the property path array.
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return value;
	      }
	      var result = [];
	      baseToString(value).replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      return wrapper instanceof LazyWrapper
	        ? wrapper.clone()
	        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `collection` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new array containing chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if (guard ? isIterateeCall(array, size, guard) : size == null) {
	        size = 1;
	      } else {
	        size = nativeMax(nativeFloor(size) || 1, 1);
	      }
	      var index = 0,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[++resIndex] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array ? array.length : 0,
	          resIndex = -1,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[++resIndex] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of unique `array` values not included in the other
	     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The arrays of values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.difference([1, 2, 3], [4, 2]);
	     * // => [1, 3]
	     */
	    var difference = restParam(function(array, values) {
	      return (isObjectLike(array) && isArrayLike(array))
	        ? baseDifference(array, baseFlatten(values, false, true))
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that match the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [1]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active', false), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.dropWhile(users, 'active'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8], '*', 1, 2);
	     * // => [4, '*', 8]
	     */
	    function fill(array, value, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(chr) {
	     *   return chr.user == 'barney';
	     * });
	     * // => 0
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findIndex(users, 'active', false);
	     * // => 0
	     *
	     * // using the `_.property` callback shorthand
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    var findIndex = createFindIndex();
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(chr) {
	     *   return chr.user == 'pebbles';
	     * });
	     * // => 2
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastIndex(users, 'active', false);
	     * // => 2
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    var findLastIndex = createFindIndex(true);
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias head
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.first([1, 2, 3]);
	     * // => 1
	     *
	     * _.first([]);
	     * // => undefined
	     */
	    function first(array) {
	      return array ? array[0] : undefined;
	    }
	
	    /**
	     * Flattens a nested array. If `isDeep` is `true` the array is recursively
	     * flattened, otherwise it is only flattened a single level.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {boolean} [isDeep] Specify a deep flatten.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, [4]]
	     *
	     * // using `isDeep`
	     * _.flatten([1, [2, 3, [4]]], true);
	     * // => [1, 2, 3, 4]
	     */
	    function flatten(array, isDeep, guard) {
	      var length = array ? array.length : 0;
	      if (guard && isIterateeCall(array, isDeep, guard)) {
	        isDeep = false;
	      }
	      return length ? baseFlatten(array, isDeep) : [];
	    }
	
	    /**
	     * Recursively flattens a nested array.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to recursively flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, 3, [4]]]);
	     * // => [1, 2, 3, 4]
	     */
	    function flattenDeep(array) {
	      var length = array ? array.length : 0;
	      return length ? baseFlatten(array, true) : [];
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
	     * performs a faster binary search.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
	     *  to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // using `fromIndex`
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     *
	     * // performing a binary search
	     * _.indexOf([1, 1, 2, 2], 2, true);
	     * // => 2
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      if (typeof fromIndex == 'number') {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
	      } else if (fromIndex) {
	        var index = binaryIndex(array, value);
	        if (index < length &&
	            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
	          return index;
	        }
	        return -1;
	      }
	      return baseIndexOf(array, value, fromIndex || 0);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      return dropRight(array, 1);
	    }
	
	    /**
	     * Creates an array of unique values that are included in all of the provided
	     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of shared values.
	     * @example
	     * _.intersection([1, 2], [4, 2], [2, 1]);
	     * // => [2]
	     */
	    var intersection = restParam(function(arrays) {
	      var othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(length),
	          indexOf = getIndexOf(),
	          isCommon = indexOf == baseIndexOf,
	          result = [];
	
	      while (othIndex--) {
	        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
	        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
	      }
	      var array = arrays[0],
	          index = -1,
	          length = array ? array.length : 0,
	          seen = caches[0];
	
	      outer:
	      while (++index < length) {
	        value = array[index];
	        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
	          var othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(value);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    });
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array ? array.length : 0;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to search.
	     * @param {*} value The value to search for.
	     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
	     *  or `true` to perform a binary search on a sorted array.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // using `fromIndex`
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     *
	     * // performing a binary search
	     * _.lastIndexOf([1, 1, 2, 2], 2, true);
	     * // => 3
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (typeof fromIndex == 'number') {
	        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
	      } else if (fromIndex) {
	        index = binaryIndex(array, value, true) - 1;
	        var other = array[index];
	        if (value === value ? (value === other) : (other !== other)) {
	          return index;
	        }
	        return -1;
	      }
	      if (value !== value) {
	        return indexOfNaN(array, index, true);
	      }
	      while (index--) {
	        if (array[index] === value) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Removes all provided values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3, 1, 2, 3];
	     *
	     * _.pull(array, 2, 3);
	     * console.log(array);
	     * // => [1, 1]
	     */
	    function pull() {
	      var args = arguments,
	          array = args[0];
	
	      if (!(array && array.length)) {
	        return array;
	      }
	      var index = 0,
	          indexOf = getIndexOf(),
	          length = args.length;
	
	      while (++index < length) {
	        var fromIndex = 0,
	            value = args[index];
	
	        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to the given indexes and returns
	     * an array of the removed elements. Indexes may be specified as an array of
	     * indexes or as individual arguments.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [5, 10, 15, 20];
	     * var evens = _.pullAt(array, 1, 3);
	     *
	     * console.log(array);
	     * // => [5, 15]
	     *
	     * console.log(evens);
	     * // => [10, 20]
	     */
	    var pullAt = restParam(function(array, indexes) {
	      indexes = baseFlatten(indexes);
	
	      var result = baseAt(array, indexes);
	      basePullAt(array, indexes.sort(baseCompareAscending));
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate, thisArg) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getCallback(predicate, thisArg, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @alias tail
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.rest([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function rest(array) {
	      return drop(array, 1);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of `Array#slice` to support node
	     * lists in IE < 9 and to ensure dense arrays are returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value` should
	     * be inserted into `array` in order to maintain its sort order. If an iteratee
	     * function is provided it is invoked for `value` and each element of `array`
	     * to compute their sort ranking. The iteratee is bound to `thisArg` and
	     * invoked with one argument; (value).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     *
	     * _.sortedIndex([4, 4, 5, 5], 5);
	     * // => 2
	     *
	     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
	     *
	     * // using an iteratee function
	     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
	     *   return this.data[word];
	     * }, dict);
	     * // => 1
	     *
	     * // using the `_.property` callback shorthand
	     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	     * // => 1
	     */
	    var sortedIndex = createSortedIndex();
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 4, 5, 5], 5);
	     * // => 4
	     */
	    var sortedLastIndex = createSortedIndex(true);
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (guard ? isIterateeCall(array, n, guard) : n == null) {
	        n = 1;
	      }
	      n = length - (+n || 0);
	      return baseSlice(array, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
	     * and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRightWhile([1, 2, 3], function(n) {
	     *   return n > 1;
	     * });
	     * // => [2, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
	     * // => ['pebbles']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
	     * // => ['fred', 'pebbles']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeRightWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is bound to
	     * `thisArg` and invoked with three arguments: (value, index, array).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeWhile([1, 2, 3], function(n) {
	     *   return n < 3;
	     * });
	     * // => [1, 2]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false},
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active', false), 'user');
	     * // => ['barney', 'fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.takeWhile(users, 'active'), 'user');
	     * // => []
	     */
	    function takeWhile(array, predicate, thisArg) {
	      return (array && array.length)
	        ? baseWhile(array, getCallback(predicate, thisArg, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all of the provided arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([1, 2], [4, 2], [2, 1]);
	     * // => [1, 2, 4]
	     */
	    var union = restParam(function(arrays) {
	      return baseUniq(baseFlatten(arrays, false, true));
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurence of each element
	     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	     * for sorted arrays. If an iteratee function is provided it is invoked for
	     * each element in the array to generate the criterion by which uniqueness
	     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, array).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias unique
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {boolean} [isSorted] Specify the array is sorted.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new duplicate-value-free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     *
	     * // using `isSorted`
	     * _.uniq([1, 1, 2], true);
	     * // => [1, 2]
	     *
	     * // using an iteratee function
	     * _.uniq([1, 2.5, 1.5, 2], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => [1, 2.5]
	     *
	     * // using the `_.property` callback shorthand
	     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniq(array, isSorted, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      if (isSorted != null && typeof isSorted != 'boolean') {
	        thisArg = iteratee;
	        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	        isSorted = false;
	      }
	      var callback = getCallback();
	      if (!(iteratee == null && callback === baseCallback)) {
	        iteratee = callback(iteratee, thisArg, 3);
	      }
	      return (isSorted && getIndexOf() == baseIndexOf)
	        ? sortedUniq(array, iteratee)
	        : baseUniq(array, iteratee);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['fred', 'barney'], [30, 40], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var index = -1,
	          length = 0;
	
	      array = arrayFilter(array, function(group) {
	        if (isArrayLike(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = arrayMap(array, baseProperty(index));
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts an iteratee to specify
	     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee] The function to combine regrouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee, thisArg) {
	      var length = array ? array.length : 0;
	      if (!length) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      iteratee = bindCallback(iteratee, thisArg, 4);
	      return arrayMap(result, function(group) {
	        return arrayReduce(group, iteratee, undefined, true);
	      });
	    }
	
	    /**
	     * Creates an array excluding all provided values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {Array} array The array to filter.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.without([1, 2, 1, 3], 1, 2);
	     * // => [3]
	     */
	    var without = restParam(function(array, values) {
	      return isArrayLike(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the provided arrays.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of values.
	     * @example
	     *
	     * _.xor([1, 2], [4, 2]);
	     * // => [1, 4]
	     */
	    function xor() {
	      var index = -1,
	          length = arguments.length;
	
	      while (++index < length) {
	        var array = arguments[index];
	        if (isArrayLike(array)) {
	          var result = result
	            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
	            : array;
	        }
	      }
	      return result ? baseUniq(result) : [];
	    }
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the first
	     * elements of the given arrays, the second of which contains the second elements
	     * of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
	     * // => [['fred', 30, true], ['barney', 40, false]]
	     */
	    var zip = restParam(unzip);
	
	    /**
	     * The inverse of `_.pairs`; this method returns an object composed from arrays
	     * of property names and values. Provide either a single two dimensional array,
	     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
	     * and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @alias object
	     * @category Array
	     * @param {Array} props The property names.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject([['fred', 30], ['barney', 40]]);
	     * // => { 'fred': 30, 'barney': 40 }
	     *
	     * _.zipObject(['fred', 'barney'], [30, 40]);
	     * // => { 'fred': 30, 'barney': 40 }
	     */
	    function zipObject(props, values) {
	      var index = -1,
	          length = props ? props.length : 0,
	          result = {};
	
	      if (length && !values && !isArray(props[0])) {
	        values = [];
	      }
	      while (++index < length) {
	        var key = props[index];
	        if (values) {
	          result[key] = values[index];
	        } else if (key) {
	          result[key[0]] = key[1];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an iteratee to specify
	     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
	     * and invoked with four arguments: (accumulator, value, index, group).
	     *
	     * @static
	     * @memberOf _
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee] The function to combine grouped values.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
	     * // => [111, 222]
	     */
	    var zipWith = restParam(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 2 ? arrays[length - 2] : undefined,
	          thisArg = length > 1 ? arrays[length - 1] : undefined;
	
	      if (length > 2 && typeof iteratee == 'function') {
	        length -= 2;
	      } else {
	        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
	        thisArg = undefined;
	      }
	      arrays.length = length;
	      return unzipWith(arrays, iteratee, thisArg);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object that wraps `value` with explicit method
	     * chaining enabled.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _.chain(users)
	     *   .sortBy('age')
	     *   .map(function(chr) {
	     *     return chr.user + ' is ' + chr.age;
	     *   })
	     *   .first()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor is
	     * bound to `thisArg` and invoked with one argument; (value). The purpose of
	     * this method is to "tap into" a method chain in order to perform operations
	     * on intermediate results within the chain.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor, thisArg) {
	      interceptor.call(thisArg, value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     *
	     * @static
	     * @memberOf _
	     * @category Chain
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @param {*} [thisArg] The `this` binding of `interceptor`.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor, thisArg) {
	      return interceptor.call(thisArg, value);
	    }
	
	    /**
	     * Enables explicit method chaining on the wrapper object.
	     *
	     * @name chain
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // without explicit chaining
	     * _(users).first();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // with explicit chaining
	     * _(users).chain()
	     *   .first()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chained sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Creates a new array joining a wrapped array with any additional arrays
	     * and/or values.
	     *
	     * @name concat
	     * @memberOf _
	     * @category Chain
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var wrapped = _(array).concat(2, [3], [[4]]);
	     *
	     * console.log(wrapped.value());
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    var wrapperConcat = restParam(function(values) {
	      values = baseFlatten(values);
	      return this.thru(function(array) {
	        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
	      });
	    });
	
	    /**
	     * Creates a clone of the chained sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).map(function(value) {
	     *   return Math.pow(value, 2);
	     * });
	     *
	     * var other = [3, 4];
	     * var otherWrapped = wrapped.plant(other);
	     *
	     * otherWrapped.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * Reverses the wrapped array so the first element becomes the last, the
	     * second element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @category Chain
	     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	
	      var interceptor = function(value) {
	        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
	      };
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(interceptor);
	    }
	
	    /**
	     * Produces the result of coercing the unwrapped value to a string.
	     *
	     * @name toString
	     * @memberOf _
	     * @category Chain
	     * @returns {string} Returns the coerced string value.
	     * @example
	     *
	     * _([1, 2, 3]).toString();
	     * // => '1,2,3'
	     */
	    function wrapperToString() {
	      return (this.value() + '');
	    }
	
	    /**
	     * Executes the chained sequence to extract the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @alias run, toJSON, valueOf
	     * @category Chain
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements corresponding to the given keys, or indexes,
	     * of `collection`. Keys may be specified as individual arguments or as arrays
	     * of keys.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(number|number[]|string|string[])} [props] The property names
	     *  or indexes of elements to pick, specified individually or in arrays.
	     * @returns {Array} Returns the new array of picked elements.
	     * @example
	     *
	     * _.at(['a', 'b', 'c'], [0, 2]);
	     * // => ['a', 'c']
	     *
	     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
	     * // => ['barney', 'pebbles']
	     */
	    var at = restParam(function(collection, props) {
	      return baseAt(collection, baseFlatten(props));
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the number of times the key was returned by `iteratee`.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy([4.3, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': 1, '6': 2 }
	     *
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * The predicate is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias all
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': false },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.every(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias select
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.filter([4, 5, 6], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 6]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.filter(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.filter(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function filter(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, predicate);
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias detect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.result(_.find(users, function(chr) {
	     *   return chr.age < 40;
	     * }), 'user');
	     * // => 'barney'
	     *
	     * // using the `_.matches` callback shorthand
	     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.result(_.find(users, 'active', false), 'user');
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.result(_.find(users, 'active'), 'user');
	     * // => 'barney'
	     */
	    var find = createFind(baseEach);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(baseEachRight, true);
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning the first element that has equivalent property
	     * values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
	     * // => 'barney'
	     *
	     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
	     * // => 'fred'
	     */
	    function findWhere(collection, source) {
	      return find(collection, baseMatches(source));
	    }
	
	    /**
	     * Iterates over elements of `collection` invoking `iteratee` for each element.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection). Iteratee functions may exit iteration early
	     * by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length" property
	     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
	     * may be used for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @alias each
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEach(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from left to right and returns the array
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
	     *   console.log(n, key);
	     * });
	     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
	     */
	    var forEach = createForEach(arrayEach, baseEach);
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array|Object|string} Returns `collection`.
	     * @example
	     *
	     * _([1, 2]).forEachRight(function(n) {
	     *   console.log(n);
	     * }).value();
	     * // => logs each value from right to left and returns the array
	     */
	    var forEachRight = createForEach(arrayEachRight, baseEachRight);
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is an array of the elements responsible for generating the key.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return Math.floor(n);
	     * });
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * _.groupBy([4.2, 6.1, 6.4], function(n) {
	     *   return this.floor(n);
	     * }, Math);
	     * // => { '4': [4.2], '6': [6.1, 6.4] }
	     *
	     * // using the `_.property` callback shorthand
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        result[key] = [value];
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
	     * from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @alias contains, include
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {*} target The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
	     * // => true
	     *
	     * _.includes('pebbles', 'eb');
	     * // => true
	     */
	    function includes(collection, target, fromIndex, guard) {
	      var length = collection ? getLength(collection) : 0;
	      if (!isLength(length)) {
	        collection = values(collection);
	        length = collection.length;
	      }
	      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
	        fromIndex = 0;
	      } else {
	        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
	      }
	      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
	        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
	        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` through `iteratee`. The corresponding value
	     * of each key is the last element responsible for generating the key. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var keyData = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.indexBy(keyData, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return String.fromCharCode(object.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.indexBy(keyData, function(object) {
	     *   return this.fromCharCode(object.code);
	     * }, String);
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     */
	    var indexBy = createAggregator(function(result, value, key) {
	      result[key] = value;
	    });
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `methodName` is a function it is
	     * invoked for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invoke([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invoke = restParam(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          isProp = isKey(path),
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
	        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` through
	     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
	     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
	     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
	     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
	     * `sum`, `uniq`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @alias collect
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function timesThree(n) {
	     *   return n * 3;
	     * }
	     *
	     * _.map([1, 2], timesThree);
	     * // => [3, 6]
	     *
	     * _.map({ 'a': 1, 'b': 2 }, timesThree);
	     * // => [3, 6] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee, thisArg) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return func(collection, iteratee);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, while the second of which
	     * contains elements `predicate` returns falsey for. The predicate is bound
	     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * _.partition([1, 2, 3], function(n) {
	     *   return n % 2;
	     * });
	     * // => [[1, 3], [2]]
	     *
	     * _.partition([1.2, 2.3, 3.4], function(n) {
	     *   return this.floor(n) % 2;
	     * }, Math);
	     * // => [[1.2, 3.4], [2.3]]
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * var mapper = function(array) {
	     *   return _.pluck(array, 'user');
	     * };
	     *
	     * // using the `_.matches` callback shorthand
	     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
	     * // => [['pebbles'], ['barney', 'fred']]
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.map(_.partition(users, 'active', false), mapper);
	     * // => [['barney', 'pebbles'], ['fred']]
	     *
	     * // using the `_.property` callback shorthand
	     * _.map(_.partition(users, 'active'), mapper);
	     * // => [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Gets the property value of `path` from all elements in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Array|string} path The path of the property to pluck.
	     * @returns {Array} Returns the property values.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.pluck(users, 'user');
	     * // => ['barney', 'fred']
	     *
	     * var userIndex = _.indexBy(users, 'user');
	     * _.pluck(userIndex, 'age');
	     * // => [36, 40] (iteration order is not guaranteed)
	     */
	    function pluck(collection, path) {
	      return map(collection, property(path));
	    }
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` through `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not provided the first element of `collection` is used as the initial
	     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
	     * and `sortByOrder`
	     *
	     * @static
	     * @memberOf _
	     * @alias foldl, inject
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.reduce([1, 2], function(total, n) {
	     *   return total + n;
	     * });
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     *   return result;
	     * }, {});
	     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
	     */
	    var reduce = createReduce(arrayReduce, baseEach);
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias foldr
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    var reduceRight = createReduce(arrayReduceRight, baseEachRight);
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * _.reject([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 0;
	     * });
	     * // => [1, 3]
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
	     * // => ['barney']
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.pluck(_.reject(users, 'active', false), 'user');
	     * // => ['fred']
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.reject(users, 'active'), 'user');
	     * // => ['barney']
	     */
	    function reject(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      predicate = getCallback(predicate, thisArg, 3);
	      return func(collection, function(value, index, collection) {
	        return !predicate(value, index, collection);
	      });
	    }
	
	    /**
	     * Gets a random element or `n` random elements from a collection.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to sample.
	     * @param {number} [n] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {*} Returns the random sample(s).
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     *
	     * _.sample([1, 2, 3, 4], 2);
	     * // => [3, 1]
	     */
	    function sample(collection, n, guard) {
	      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
	        collection = toIterable(collection);
	        var length = collection.length;
	        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
	      }
	      var index = -1,
	          result = toArray(collection),
	          length = result.length,
	          lastIndex = length - 1;
	
	      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
	      while (++index < n) {
	        var rand = baseRandom(index, lastIndex),
	            value = result[rand];
	
	        result[rand] = result[index];
	        result[index] = value;
	      }
	      result.length = n;
	      return result;
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      return sample(collection, POSITIVE_INFINITY);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the size of `collection`.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      var length = collection ? getLength(collection) : 0;
	      return isLength(length) ? length : keys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * The function returns as soon as it finds a passing value and does not iterate
	     * over the entire collection. The predicate is bound to `thisArg` and invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias any
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // using the `_.matches` callback shorthand
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.some(users, 'active', false);
	     * // => true
	     *
	     * // using the `_.property` callback shorthand
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, thisArg) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
	        predicate = undefined;
	      }
	      if (typeof predicate != 'function' || thisArg !== undefined) {
	        predicate = getCallback(predicate, thisArg, 3);
	      }
	      return func(collection, predicate);
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection through `iteratee`. This method performs
	     * a stable sort, that is, it preserves the original sort order of equal elements.
	     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return Math.sin(n);
	     * });
	     * // => [3, 1, 2]
	     *
	     * _.sortBy([1, 2, 3], function(n) {
	     *   return this.sin(n);
	     * }, Math);
	     * // => [3, 1, 2]
	     *
	     * var users = [
	     *   { 'user': 'fred' },
	     *   { 'user': 'pebbles' },
	     *   { 'user': 'barney' }
	     * ];
	     *
	     * // using the `_.property` callback shorthand
	     * _.pluck(_.sortBy(users, 'user'), 'user');
	     * // => ['barney', 'fred', 'pebbles']
	     */
	    function sortBy(collection, iteratee, thisArg) {
	      if (collection == null) {
	        return [];
	      }
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      var index = -1;
	      iteratee = getCallback(iteratee, thisArg, 3);
	
	      var result = baseMap(collection, function(value, key, collection) {
	        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
	      });
	      return baseSortBy(result, compareAscending);
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it can sort by multiple iteratees
	     * or property names.
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
	     *  The iteratees to sort by, specified as individual values or arrays of values.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
	     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
	     *
	     * _.map(_.sortByAll(users, 'user', function(chr) {
	     *   return Math.floor(chr.age / 10);
	     * }), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    var sortByAll = restParam(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var guard = iteratees[2];
	      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
	        iteratees.length = 1;
	      }
	      return baseSortByOrder(collection, baseFlatten(iteratees), []);
	    });
	
	    /**
	     * This method is like `_.sortByAll` except that it allows specifying the
	     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
	     * values are sorted in ascending order. Otherwise, a value is sorted in
	     * ascending order if its corresponding order is "asc", and descending if "desc".
	     *
	     * If a property name is provided for an iteratee the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If an object is provided for an iteratee the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {boolean[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 42 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // sort by `user` in ascending order and by `age` in descending order
	     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
	     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
	     */
	    function sortByOrder(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (guard && isIterateeCall(iteratees, orders, guard)) {
	        orders = undefined;
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseSortByOrder(collection, iteratees, orders);
	    }
	
	    /**
	     * Performs a deep comparison between each element in `collection` and the
	     * source object, returning an array of all elements that have equivalent
	     * property values.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to search.
	     * @param {Object} source The object of property values to match.
	     * @returns {Array} Returns the new filtered array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
	     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
	     * ];
	     *
	     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
	     * // => ['barney']
	     *
	     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
	     * // => ['fred']
	     */
	    function where(collection, source) {
	      return filter(collection, baseMatches(source));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the number of milliseconds that have elapsed since the Unix epoch
	     * (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @category Date
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => logs the number of milliseconds it took for the deferred function to be invoked
	     */
	    var now = nativeNow || function() {
	      return new Date().getTime();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it is called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => logs 'done saving!' after the two async saves have completed
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      n = nativeIsFinite(n = +n) ? n : 0;
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that accepts up to `n` arguments ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      if (guard && isIterateeCall(func, n, guard)) {
	        n = undefined;
	      }
	      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
	      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it is called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery('#add').on('click', _.before(5, addContactToList));
	     * // => allows adding up to 4 contacts to the list
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        if (typeof n == 'function') {
	          var temp = n;
	          n = func;
	          func = temp;
	        } else {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	      }
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and prepends any additional `_.bind` arguments to those provided to the
	     * bound function.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind` this method does not set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var greet = function(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * };
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // using placeholders
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = restParam(function(func, thisArg, partials) {
	      var bitmask = BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bind.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method. Method names may be specified as individual arguments or as arrays
	     * of method names. If no method names are provided all enumerable function
	     * properties, own and inherited, of `object` are bound.
	     *
	     * **Note:** This method does not set the "length" property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} [methodNames] The object method names to bind,
	     *  specified as individual method names or arrays of method names.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'onClick': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view);
	     * jQuery('#docs').on('click', view.onClick);
	     * // => logs 'clicked docs' when the element is clicked
	     */
	    var bindAll = restParam(function(object, methodNames) {
	      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);
	
	      var index = -1,
	          length = methodNames.length;
	
	      while (++index < length) {
	        var key = methodNames[index];
	        object[key] = createWrapper(object[key], BIND_FLAG, object);
	      }
	      return object;
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` and prepends
	     * any additional `_.bindKey` arguments to those provided to the bound function.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist.
	     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Object} object The object the method belongs to.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // using placeholders
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = restParam(function(object, key, partials) {
	      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, bindKey.placeholder);
	        bitmask |= PARTIAL_FLAG;
	      }
	      return createWrapper(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts one or more arguments of `func` that when
	     * called either invokes `func` returning its result, if all `func` arguments
	     * have been provided, or returns a function that accepts one or more of the
	     * remaining `func` arguments, and so on. The arity of `func` may be specified
	     * if `func.length` is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    var curry = createCurry(CURRY_FLAG);
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method does not set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // using placeholders
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    var curryRight = createCurry(CURRY_RIGHT_FLAG);
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed invocations. Provide an options object to indicate that `func`
	     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
	     * Subsequent calls to the debounced function return the result of the last
	     * `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the debounced function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=false] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
	     *  delayed before it is invoked.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // avoid costly calculations while the window size is in flux
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
	     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // ensure `batchLog` is invoked once after 1 second of debounced calls
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', _.debounce(batchLog, 250, {
	     *   'maxWait': 1000
	     * }));
	     *
	     * // cancel a debounced call
	     * var todoChanges = _.debounce(batchLog, 1000);
	     * Object.observe(models.todo, todoChanges);
	     *
	     * Object.observe(models, function(changes) {
	     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
	     *     todoChanges.cancel();
	     *   }
	     * }, ['delete']);
	     *
	     * // ...at some point `models.todo` is changed
	     * models.todo.completed = true;
	     *
	     * // ...before 1 second has passed `models.todo` is deleted
	     * // which cancels the debounced `todoChanges` call
	     * delete models.todo;
	     */
	    function debounce(func, wait, options) {
	      var args,
	          maxTimeoutId,
	          result,
	          stamp,
	          thisArg,
	          timeoutId,
	          trailingCall,
	          lastCalled = 0,
	          maxWait = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = wait < 0 ? 0 : (+wait || 0);
	      if (options === true) {
	        var leading = true;
	        trailing = false;
	      } else if (isObject(options)) {
	        leading = !!options.leading;
	        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function cancel() {
	        if (timeoutId) {
	          clearTimeout(timeoutId);
	        }
	        if (maxTimeoutId) {
	          clearTimeout(maxTimeoutId);
	        }
	        lastCalled = 0;
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	      }
	
	      function complete(isCalled, id) {
	        if (id) {
	          clearTimeout(id);
	        }
	        maxTimeoutId = timeoutId = trailingCall = undefined;
	        if (isCalled) {
	          lastCalled = now();
	          result = func.apply(thisArg, args);
	          if (!timeoutId && !maxTimeoutId) {
	            args = thisArg = undefined;
	          }
	        }
	      }
	
	      function delayed() {
	        var remaining = wait - (now() - stamp);
	        if (remaining <= 0 || remaining > wait) {
	          complete(trailingCall, maxTimeoutId);
	        } else {
	          timeoutId = setTimeout(delayed, remaining);
	        }
	      }
	
	      function maxDelayed() {
	        complete(trailing, timeoutId);
	      }
	
	      function debounced() {
	        args = arguments;
	        stamp = now();
	        thisArg = this;
	        trailingCall = trailing && (timeoutId || !leading);
	
	        if (maxWait === false) {
	          var leadingCall = leading && !timeoutId;
	        } else {
	          if (!maxTimeoutId && !leading) {
	            lastCalled = stamp;
	          }
	          var remaining = maxWait - (stamp - lastCalled),
	              isCalled = remaining <= 0 || remaining > maxWait;
	
	          if (isCalled) {
	            if (maxTimeoutId) {
	              maxTimeoutId = clearTimeout(maxTimeoutId);
	            }
	            lastCalled = stamp;
	            result = func.apply(thisArg, args);
	          }
	          else if (!maxTimeoutId) {
	            maxTimeoutId = setTimeout(maxDelayed, remaining);
	          }
	        }
	        if (isCalled && timeoutId) {
	          timeoutId = clearTimeout(timeoutId);
	        }
	        else if (!timeoutId && wait !== maxWait) {
	          timeoutId = setTimeout(delayed, wait);
	        }
	        if (leadingCall) {
	          isCalled = true;
	          result = func.apply(thisArg, args);
	        }
	        if (isCalled && !timeoutId && !maxTimeoutId) {
	          args = thisArg = undefined;
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // logs 'deferred' after one or more milliseconds
	     */
	    var defer = restParam(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke the function with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => logs 'later' after one second
	     */
	    var delay = restParam(function(func, wait, args) {
	      return baseDelay(func, wait, args);
	    });
	
	    /**
	     * Creates a function that returns the result of invoking the provided
	     * functions with the `this` binding of the created function, where each
	     * successive invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow(_.add, square);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the provided functions from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @alias backflow, compose
	     * @category Function
	     * @param {...Function} [funcs] Functions to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight(square, _.add);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is coerced to a string and used as the
	     * cache key. The `func` is invoked with the `this` binding of the memoized
	     * function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoizing function.
	     * @example
	     *
	     * var upperCase = _.memoize(function(string) {
	     *   return string.toUpperCase();
	     * });
	     *
	     * upperCase('fred');
	     * // => 'FRED'
	     *
	     * // modifying the result cache
	     * upperCase.cache.set('fred', 'BARNEY');
	     * upperCase('fred');
	     * // => 'BARNEY'
	     *
	     * // replacing `_.memoize.Cache`
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'barney' };
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'fred' }
	     *
	     * _.memoize.Cache = WeakMap;
	     * var identity = _.memoize(_.identity);
	     *
	     * identity(object);
	     * // => { 'user': 'fred' }
	     * identity(other);
	     * // => { 'user': 'barney' }
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result);
	        return result;
	      };
	      memoized.cache = new memoize.Cache;
	      return memoized;
	    }
	
	    /**
	     * Creates a function that runs each argument through a corresponding
	     * transform function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms] The functions to transform
	     * arguments, specified as individual functions or arrays of functions.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var modded = _.modArgs(function(x, y) {
	     *   return [x, y];
	     * }, square, doubled);
	     *
	     * modded(1, 2);
	     * // => [1, 4]
	     *
	     * modded(5, 10);
	     * // => [25, 20]
	     */
	    var modArgs = restParam(function(func, transforms) {
	      transforms = baseFlatten(transforms);
	      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = transforms.length;
	      return restParam(function(args) {
	        var index = nativeMin(args.length, length);
	        while (index--) {
	          args[index] = transforms[index](args[index]);
	        }
	        return func.apply(this, args);
	      });
	    });
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        return !predicate.apply(this, arguments);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first call. The `func` is invoked
	     * with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // `initialize` invokes `createApplication` once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with `partial` arguments prepended
	     * to those provided to the new function. This method is like `_.bind` except
	     * it does **not** alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // using placeholders
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = createPartial(PARTIAL_FLAG);
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to those provided to the new function.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method does not set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * var greet = function(greeting, name) {
	     *   return greeting + ' ' + name;
	     * };
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // using placeholders
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified indexes where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes,
	     *  specified as individual indexes or arrays of indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, 2, 0, 1);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     *
	     * var map = _.rearg(_.map, [1, 0]);
	     * map(function(n) {
	     *   return n * 3;
	     * }, [1, 2, 3]);
	     * // => [3, 6, 9]
	     */
	    var rearg = restParam(function(func, indexes) {
	      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as an array.
	     *
	     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.restParam(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function restParam(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            rest = Array(length);
	
	        while (++index < length) {
	          rest[index] = args[start + index];
	        }
	        switch (start) {
	          case 0: return func.call(this, rest);
	          case 1: return func.call(this, args[0], rest);
	          case 2: return func.call(this, args[0], args[1], rest);
	        }
	        var otherArgs = Array(start + 1);
	        index = -1;
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = rest;
	        return func.apply(this, otherArgs);
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the created
	     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
	     *
	     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * // with a Promise
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function(array) {
	        return func.apply(this, array);
	      };
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed invocations. Provide an options object to indicate
	     * that `func` should be invoked on the leading and/or trailing edge of the
	     * `wait` timeout. Subsequent calls to the throttled function return the
	     * result of the last `func` call.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	     * on the trailing edge of the timeout only if the the throttled function is
	     * invoked more than once during the `wait` timeout.
	     *
	     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.leading=true] Specify invoking on the leading
	     *  edge of the timeout.
	     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
	     *  edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // avoid excessively updating the position while scrolling
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
	     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
	     *   'trailing': false
	     * }));
	     *
	     * // cancel a trailing throttled call
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (options === false) {
	        leading = false;
	      } else if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
	    }
	
	    /**
	     * Creates a function that provides `value` to the wrapper function as its
	     * first argument. Any additional arguments provided to the function are
	     * appended to those provided to the wrapper function. The wrapper is invoked
	     * with the `this` binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} wrapper The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      wrapper = wrapper == null ? identity : wrapper;
	      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
	     * otherwise they are assigned by reference. If `customizer` is provided it is
	     * invoked to produce the cloned values. If `customizer` returns `undefined`
	     * cloning is handled by the method instead. The `customizer` is bound to
	     * `thisArg` and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var shallow = _.clone(users);
	     * shallow[0] === users[0];
	     * // => true
	     *
	     * var deep = _.clone(users, true);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.clone(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 0
	     */
	    function clone(value, isDeep, customizer, thisArg) {
	      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
	        isDeep = false;
	      }
	      else if (typeof isDeep == 'function') {
	        thisArg = customizer;
	        customizer = isDeep;
	        isDeep = false;
	      }
	      return typeof customizer == 'function'
	        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, isDeep);
	    }
	
	    /**
	     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
	     * to produce the cloned values. If `customizer` returns `undefined` cloning
	     * is handled by the method instead. The `customizer` is bound to `thisArg`
	     * and invoked with two argument; (value [, index|key, object]).
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
	     * The enumerable properties of `arguments` objects and objects created by
	     * constructors other than `Object` are cloned to plain `Object` objects. An
	     * empty object is returned for uncloneable values such as functions, DOM nodes,
	     * Maps, Sets, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to deep clone.
	     * @param {Function} [customizer] The function to customize cloning values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {*} Returns the deep cloned value.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * var deep = _.cloneDeep(users);
	     * deep[0] === users[0];
	     * // => false
	     *
	     * // using a customizer callback
	     * var el = _.cloneDeep(document.body, function(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * });
	     *
	     * el === document.body
	     * // => false
	     * el.nodeName
	     * // => BODY
	     * el.childNodes.length;
	     * // => 20
	     */
	    function cloneDeep(value, customizer, thisArg) {
	      return typeof customizer == 'function'
	        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
	        : baseClone(value, true);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    function gt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    function gte(value, other) {
	      return value >= other;
	    }
	
	    /**
	     * Checks if `value` is classified as an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    function isArguments(value) {
	      return isObjectLike(value) && isArrayLike(value) &&
	        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	    }
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(function() { return arguments; }());
	     * // => false
	     */
	    var isArray = nativeIsArray || function(value) {
	      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	    };
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    function isDate(value) {
	      return isObjectLike(value) && objToString.call(value) == dateTag;
	    }
	
	    /**
	     * Checks if `value` is a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is empty. A value is considered empty unless it is an
	     * `arguments` object, array, string, or jQuery-like collection with a length
	     * greater than `0` or an object with own enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Array|Object|string} value The value to inspect.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	          (isObjectLike(value) && isFunction(value.splice)))) {
	        return !value.length;
	      }
	      return !keys(value).length;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent. If `customizer` is provided it is invoked to compare values.
	     * If `customizer` returns `undefined` comparisons are handled by the method
	     * instead. The `customizer` is bound to `thisArg` and invoked with three
	     * arguments: (value, other [, index|key]).
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. Functions and DOM nodes
	     * are **not** supported. Provide a customizer function to extend support
	     * for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @alias eq
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var other = { 'user': 'fred' };
	     *
	     * object == other;
	     * // => false
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * // using a customizer callback
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqual(array, other, function(value, other) {
	     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	     *     return true;
	     *   }
	     * });
	     * // => true
	     */
	    function isEqual(value, other, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(10);
	     * // => true
	     *
	     * _.isFinite('10');
	     * // => false
	     *
	     * _.isFinite(true);
	     * // => false
	     *
	     * _.isFinite(Object(10));
	     * // => false
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in older versions of Chrome and Safari which return 'function' for regexes
	      // and Safari 8 equivalents which return 'object' for typed array constructors.
	      return isObject(value) && objToString.call(value) == funcTag;
	    }
	
	    /**
	     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(1);
	     * // => false
	     */
	    function isObject(value) {
	      // Avoid a V8 JIT bug in Chrome 19-20.
	      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	      var type = typeof value;
	      return !!value && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Performs a deep comparison between `object` and `source` to determine if
	     * `object` contains equivalent property values. If `customizer` is provided
	     * it is invoked to compare values. If `customizer` returns `undefined`
	     * comparisons are handled by the method instead. The `customizer` is bound
	     * to `thisArg` and invoked with three arguments: (value, other, index|key).
	     *
	     * **Note:** This method supports comparing properties of arrays, booleans,
	     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
	     * and DOM nodes are **not** supported. Provide a customizer function to extend
	     * support for comparing other values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize value comparisons.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.isMatch(object, { 'age': 40 });
	     * // => true
	     *
	     * _.isMatch(object, { 'age': 36 });
	     * // => false
	     *
	     * // using a customizer callback
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatch(object, source, function(value, other) {
	     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
	     * });
	     * // => true
	     */
	    function isMatch(object, source, customizer, thisArg) {
	      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	      return baseIsMatch(object, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
	     * which returns `true` for `undefined` and other non-numeric values.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a native function.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (value == null) {
	        return false;
	      }
	      if (isFunction(value)) {
	        return reIsNative.test(fnToString.call(value));
	      }
	      return isObjectLike(value) && reIsHostCtor.test(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
	     * as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isNumber(8.4);
	     * // => true
	     *
	     * _.isNumber(NaN);
	     * // => true
	     *
	     * _.isNumber('8.4');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * **Note:** This method assumes objects created by the `Object` constructor
	     * have no inherited enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      var Ctor;
	
	      // Exit early for non `Object` objects.
	      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	        return false;
	      }
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      var result;
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      baseForIn(value, function(subValue, key) {
	        result = key;
	      });
	      return result === undefined || hasOwnProperty.call(value, result);
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    function isRegExp(value) {
	      return isObject(value) && objToString.call(value) == regexpTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    function isTypedArray(value) {
	      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	    }
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    function lt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    function lte(value, other) {
	      return value <= other;
	    }
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * (function() {
	     *   return _.toArray(arguments).slice(1);
	     * }(1, 2, 3));
	     * // => [2, 3]
	     */
	    function toArray(value) {
	      var length = value ? getLength(value) : 0;
	      if (!isLength(length)) {
	        return values(value);
	      }
	      if (!length) {
	        return [];
	      }
	      return arrayCopy(value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable
	     * properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return baseCopy(value, keysIn(value));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Recursively merges own enumerable properties of the source object(s), that
	     * don't resolve to `undefined` into the destination object. Subsequent sources
	     * overwrite property assignments of previous sources. If `customizer` is
	     * provided it is invoked to produce the merged values of the destination and
	     * source properties. If `customizer` returns `undefined` merging is handled
	     * by the method instead. The `customizer` is bound to `thisArg` and invoked
	     * with five arguments: (objectValue, sourceValue, key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var users = {
	     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	     * };
	     *
	     * var ages = {
	     *   'data': [{ 'age': 36 }, { 'age': 40 }]
	     * };
	     *
	     * _.merge(users, ages);
	     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	     *
	     * // using a customizer callback
	     * var object = {
	     *   'fruits': ['apple'],
	     *   'vegetables': ['beet']
	     * };
	     *
	     * var other = {
	     *   'fruits': ['banana'],
	     *   'vegetables': ['carrot']
	     * };
	     *
	     * _.merge(object, other, function(a, b) {
	     *   if (_.isArray(a)) {
	     *     return a.concat(b);
	     *   }
	     * });
	     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	     */
	    var merge = createAssigner(baseMerge);
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object. Subsequent sources overwrite property assignments of previous sources.
	     * If `customizer` is provided it is invoked to produce the assigned values.
	     * The `customizer` is bound to `thisArg` and invoked with five arguments:
	     * (objectValue, sourceValue, key, object, source).
	     *
	     * **Note:** This method mutates `object` and is based on
	     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
	     *
	     * @static
	     * @memberOf _
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {*} [thisArg] The `this` binding of `customizer`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using a customizer callback
	     * var defaults = _.partialRight(_.assign, function(value, other) {
	     *   return _.isUndefined(value) ? other : value;
	     * });
	     *
	     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var assign = createAssigner(function(object, source, customizer) {
	      return customizer
	        ? assignWith(object, source, customizer)
	        : baseAssign(object, source);
	    });
	
	    /**
	     * Creates an object that inherits from the given `prototype` object. If a
	     * `properties` object is provided its own enumerable properties are assigned
	     * to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties, guard) {
	      var result = baseCreate(prototype);
	      if (guard && isIterateeCall(prototype, properties, guard)) {
	        properties = undefined;
	      }
	      return properties ? baseAssign(result, properties) : result;
	    }
	
	    /**
	     * Assigns own enumerable properties of source object(s) to the destination
	     * object for all destination properties that resolve to `undefined`. Once a
	     * property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var defaults = createDefaults(assign, assignDefaults);
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
	     * // => { 'user': { 'name': 'barney', 'age': 36 } }
	     *
	     */
	    var defaultsDeep = createDefaults(merge, mergeDefaults);
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    var findKey = createFindKey(baseForOwn);
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * If a property name is provided for `predicate` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `predicate` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to search.
	     * @param {Function|Object|string} [predicate=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(chr) {
	     *   return chr.age < 40;
	     * });
	     * // => returns `pebbles` assuming `_.findKey` returns `barney`
	     *
	     * // using the `_.matches` callback shorthand
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // using the `_.matchesProperty` callback shorthand
	     * _.findLastKey(users, 'active', false);
	     * // => 'fred'
	     *
	     * // using the `_.property` callback shorthand
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    var findLastKey = createFindKey(baseForOwnRight);
	
	    /**
	     * Iterates over own and inherited enumerable properties of an object invoking
	     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
	     */
	    var forIn = createForIn(baseFor);
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
	     */
	    var forInRight = createForIn(baseForRight);
	
	    /**
	     * Iterates over own enumerable properties of an object invoking `iteratee`
	     * for each property. The `iteratee` is bound to `thisArg` and invoked with
	     * three arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'a' and 'b' (iteration order is not guaranteed)
	     */
	    var forOwn = createForOwn(baseForOwn);
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
	     */
	    var forOwnRight = createForOwn(baseForOwnRight);
	
	    /**
	     * Creates an array of function property names from all enumerable properties,
	     * own and inherited, of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @alias methods
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the new array of property names.
	     * @example
	     *
	     * _.functions(_);
	     * // => ['after', 'ary', 'assign', ...]
	     */
	    function functions(object) {
	      return baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the property value at `path` of `object`. If the resolved value is
	     * `undefined` the `defaultValue` is used in its place.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': { 'c': 3 } } };
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b.c');
	     * // => true
	     *
	     * _.has(object, ['a', 'b', 'c']);
	     * // => true
	     */
	    function has(object, path) {
	      if (object == null) {
	        return false;
	      }
	      var result = hasOwnProperty.call(object, path);
	      if (!result && !isKey(path)) {
	        path = toPath(path);
	        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	        if (object == null) {
	          return false;
	        }
	        path = last(path);
	        result = hasOwnProperty.call(object, path);
	      }
	      return result || (isLength(object.length) && isIndex(path, object.length) &&
	        (isArray(object) || isArguments(object)));
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite property
	     * assignments of previous values unless `multiValue` is `true`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {boolean} [multiValue] Allow multiple values per key.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     *
	     * // with `multiValue`
	     * _.invert(object, true);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function invert(object, multiValue, guard) {
	      if (guard && isIterateeCall(object, multiValue, guard)) {
	        multiValue = undefined;
	      }
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = {};
	
	      while (++index < length) {
	        var key = props[index],
	            value = object[key];
	
	        if (multiValue) {
	          if (hasOwnProperty.call(result, value)) {
	            result[value].push(key);
	          } else {
	            result[value] = [key];
	          }
	        }
	        else {
	          result[value] = key;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    var keys = !nativeKeys ? shimKeys : function(object) {
	      var Ctor = object == null ? undefined : object.constructor;
	      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	          (typeof object != 'function' && isArrayLike(object))) {
	        return shimKeys(object);
	      }
	      return isObject(object) ? nativeKeys(object) : [];
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      if (object == null) {
	        return [];
	      }
	      if (!isObject(object)) {
	        object = Object(object);
	      }
	      var length = object.length;
	      length = (length && isLength(length) &&
	        (isArray(object) || isArguments(object)) && length) || 0;
	
	      var Ctor = object.constructor,
	          index = -1,
	          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	          result = Array(length),
	          skipIndexes = length > 0;
	
	      while (++index < length) {
	        result[index] = (index + '');
	      }
	      for (var key in object) {
	        if (!(skipIndexes && isIndex(key, length)) &&
	            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * property of `object` through `iteratee`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    var mapKeys = createObjectMapper(true);
	
	    /**
	     * Creates an object with the same keys as `object` and values generated by
	     * running each own enumerable property of `object` through `iteratee`. The
	     * iteratee function is bound to `thisArg` and invoked with three arguments:
	     * (value, key, object).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
	     *  per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Object} Returns the new mapped object.
	     * @example
	     *
	     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
	     *   return n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * // using the `_.property` callback shorthand
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    var mapValues = createObjectMapper();
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable properties of `object` that are not omitted.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to omit, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.omit(object, 'age');
	     * // => { 'user': 'fred' }
	     *
	     * _.omit(object, _.isNumber);
	     * // => { 'user': 'fred' }
	     */
	    var omit = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      if (typeof props[0] != 'function') {
	        var props = arrayMap(baseFlatten(props), String);
	        return pickByArray(object, baseDifference(keysIn(object), props));
	      }
	      var predicate = bindCallback(props[0], props[1], 3);
	      return pickByCallback(object, function(value, key, object) {
	        return !predicate(value, key, object);
	      });
	    });
	
	    /**
	     * Creates a two dimensional array of the key-value pairs for `object`,
	     * e.g. `[[key1, value1], [key2, value2]]`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the new array of key-value pairs.
	     * @example
	     *
	     * _.pairs({ 'barney': 36, 'fred': 40 });
	     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	     */
	    function pairs(object) {
	      object = toObject(object);
	
	      var index = -1,
	          props = keys(object),
	          length = props.length,
	          result = Array(length);
	
	      while (++index < length) {
	        var key = props[index];
	        result[index] = [key, object[key]];
	      }
	      return result;
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties. Property
	     * names may be specified as individual arguments or as arrays of property
	     * names. If `predicate` is provided it is invoked for each property of `object`
	     * picking the properties `predicate` returns truthy for. The predicate is
	     * bound to `thisArg` and invoked with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function|...(string|string[])} [predicate] The function invoked per
	     *  iteration or property names to pick, specified as individual property
	     *  names or arrays of property names.
	     * @param {*} [thisArg] The `this` binding of `predicate`.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'user': 'fred', 'age': 40 };
	     *
	     * _.pick(object, 'user');
	     * // => { 'user': 'fred' }
	     *
	     * _.pick(object, _.isString);
	     * // => { 'user': 'fred' }
	     */
	    var pick = restParam(function(object, props) {
	      if (object == null) {
	        return {};
	      }
	      return typeof props[0] == 'function'
	        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
	        : pickByArray(object, baseFlatten(props));
	    });
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a function
	     * it is invoked with the `this` binding of its parent object and its result
	     * is returned.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a.b.c', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a.b.c', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      var result = object == null ? undefined : object[path];
	      if (result === undefined) {
	        if (object != null && !isKey(path, object)) {
	          path = toPath(path);
	          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	          result = object == null ? undefined : object[last(path)];
	        }
	        result = result === undefined ? defaultValue : result;
	      }
	      return isFunction(result) ? result.call(object) : result;
	    }
	
	    /**
	     * Sets the property value of `path` on `object`. If a portion of `path`
	     * does not exist it is created.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to augment.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, 'x[0].y.z', 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      if (object == null) {
	        return object;
	      }
	      var pathKey = (path + '');
	      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = path[index];
	        if (isObject(nested)) {
	          if (index == lastIndex) {
	            nested[key] = value;
	          } else if (nested[key] == null) {
	            nested[key] = isIndex(path[index + 1]) ? [] : {};
	          }
	        }
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own enumerable
	     * properties through `iteratee`, with each invocation potentially mutating
	     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
	     * with four arguments: (accumulator, value, key, object). Iteratee functions
	     * may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Array|Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * });
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
	     *   result[key] = n * 3;
	     * });
	     * // => { 'a': 3, 'b': 6 }
	     */
	    function transform(object, iteratee, accumulator, thisArg) {
	      var isArr = isArray(object) || isTypedArray(object);
	      iteratee = getCallback(iteratee, thisArg, 4);
	
	      if (accumulator == null) {
	        if (isArr || isObject(object)) {
	          var Ctor = object.constructor;
	          if (isArr) {
	            accumulator = isArray(object) ? new Ctor : [];
	          } else {
	            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
	          }
	        } else {
	          accumulator = {};
	        }
	      }
	      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Creates an array of the own enumerable property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property values
	     * of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Checks if `n` is between `start` and up to but not including, `end`. If
	     * `end` is not specified it is set to `start` with `start` then set to `0`.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} n The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     */
	    function inRange(value, start, end) {
	      start = +start || 0;
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      return value >= nativeMin(start, end) && value < nativeMax(start, end);
	    }
	
	    /**
	     * Produces a random number between `min` and `max` (inclusive). If only one
	     * argument is provided a number between `0` and the given number is returned.
	     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
	     * number is returned instead of an integer.
	     *
	     * @static
	     * @memberOf _
	     * @category Number
	     * @param {number} [min=0] The minimum possible value.
	     * @param {number} [max=1] The maximum possible value.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(min, max, floating) {
	      if (floating && isIterateeCall(min, max, floating)) {
	        max = floating = undefined;
	      }
	      var noMin = min == null,
	          noMax = max == null;
	
	      if (floating == null) {
	        if (noMax && typeof min == 'boolean') {
	          floating = min;
	          min = 1;
	        }
	        else if (typeof max == 'boolean') {
	          floating = max;
	          noMax = true;
	        }
	      }
	      if (noMin && noMax) {
	        max = 1;
	        noMax = false;
	      }
	      min = +min || 0;
	      if (noMax) {
	        max = min;
	        min = 0;
	      } else {
	        max = +max || 0;
	      }
	      if (floating || min % 1 || max % 1) {
	        var rand = nativeRandom();
	        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
	      }
	      return baseRandom(min, max);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__foo_bar__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
	    });
	
	    /**
	     * Capitalizes the first character of `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('fred');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      string = baseToString(string);
	      return string && (string.charAt(0).toUpperCase() + string.slice(1));
	    }
	
	    /**
	     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = baseToString(string);
	      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search from.
	     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = baseToString(string);
	      target = (target + '');
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : nativeMin(position < 0 ? 0 : (+position || 0), length);
	
	      position -= target.length;
	      return position >= 0 && string.indexOf(target, position) == position;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
	     * their corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional characters
	     * use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value.
	     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * Backticks are escaped because in Internet Explorer < 9, they can break out
	     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
	     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
	     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
	     * for more details.
	     *
	     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
	     * to reduce XSS vectors.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
	      string = baseToString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
	     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
	     */
	    function escapeRegExp(string) {
	      string = baseToString(string);
	      return (string && reHasRegExpChars.test(string))
	        ? string.replace(reRegExpChars, escapeRegExpChar)
	        : (string || '(?:)');
	    }
	
	    /**
	     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__foo_bar__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = baseToString(string);
	      length = +length;
	
	      var strLength = string.length;
	      if (strLength >= length || !nativeIsFinite(length)) {
	        return string;
	      }
	      var mid = (length - strLength) / 2,
	          leftLength = nativeFloor(mid),
	          rightLength = nativeCeil(mid);
	
	      chars = createPadding('', rightLength, chars);
	      return chars.slice(0, leftLength) + string + chars;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padLeft('abc', 6);
	     * // => '   abc'
	     *
	     * _.padLeft('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padLeft('abc', 3);
	     * // => 'abc'
	     */
	    var padLeft = createPadDir();
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padRight('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padRight('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padRight('abc', 3);
	     * // => 'abc'
	     */
	    var padRight = createPadDir(true);
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
	     * in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
	     * of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
	      // Chrome fails to trim leading <BOM> whitespace characters.
	      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
	      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      string = trim(string);
	      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=0] The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n) {
	      var result = '';
	      string = baseToString(string);
	      n = +n;
	      if (n < 1 || !string || !nativeIsFinite(n)) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        string += string;
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--foo-bar');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__foo_bar__');
	     * // => 'Foo Bar'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to search.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = baseToString(string);
	      position = position == null
	        ? 0
	        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);
	
	      return string.lastIndexOf(target, position) == position;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is provided it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options] The options object.
	     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
	     * @param {Object} [options.imports] An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
	     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
	     * @param {string} [options.variable] The data object variable name.
	     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // using the "interpolate" delimiter to create a compiled template
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // using the HTML "escape" delimiter to escape data property values
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the internal `print` function in "evaluate" delimiters
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // using custom template delimiters
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // using backslashes to treat delimiters as plain text
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // using the `imports` option to import `jQuery` as `jq`
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // using the `sourceURL` option to specify a custom sourceURL for the template
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	     *
	     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // using the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and a stack trace
	     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, otherOptions) {
	      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
	        options = otherOptions = undefined;
	      }
	      string = baseToString(string);
	      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);
	
	      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products requires returning the `match`
	        // string in order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
	      }
	      chars = (chars + '');
	      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimLeft('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimLeft('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimLeft(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(trimmedLeftIndex(string));
	      }
	      return string.slice(charsLeftIndex(string, (chars + '')));
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimRight('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimRight('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimRight(string, chars, guard) {
	      var value = string;
	      string = baseToString(string);
	      if (!string) {
	        return string;
	      }
	      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
	        return string.slice(0, trimmedRightIndex(string) + 1);
	      }
	      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object|number} [options] The options object or maximum string length.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.trunc('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', 24);
	     * // => 'hi-diddly-ho there, n...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.trunc('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function trunc(string, options, guard) {
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (options != null) {
	        if (isObject(options)) {
	          var separator = 'separator' in options ? options.separator : separator;
	          length = 'length' in options ? (+options.length || 0) : length;
	          omission = 'omission' in options ? baseToString(options.omission) : omission;
	        } else {
	          length = +options || 0;
	        }
	      }
	      string = baseToString(string);
	      if (length >= string.length) {
	        return string;
	      }
	      var end = length - omission.length;
	      if (end < 1) {
	        return omission;
	      }
	      var result = string.slice(0, end);
	      if (separator == null) {
	        return result + omission;
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              newEnd,
	              substring = string.slice(0, end);
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            newEnd = match.index;
	          }
	          result = result.slice(0, newEnd == null ? end : newEnd);
	        }
	      } else if (string.indexOf(separator, end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
	     * corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
	     * entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = baseToString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      if (guard && isIterateeCall(string, pattern, guard)) {
	        pattern = undefined;
	      }
	      string = baseToString(string);
	      return string.match(pattern || reWords) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it is invoked.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function} func The function to attempt.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // avoid throwing errors for invalid selectors
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = restParam(function(func, args) {
	      try {
	        return func.apply(undefined, args);
	      } catch(e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and arguments of the created function. If `func` is a property name the
	     * created callback returns the property value for a given element. If `func`
	     * is an object the created callback returns `true` for elements that contain
	     * the equivalent object properties, otherwise it returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @alias iteratee
	     * @category Utility
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // wrap to create custom callback shorthands
	     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
	     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
	     *   if (!match) {
	     *     return callback(func, thisArg);
	     *   }
	     *   return function(object) {
	     *     return match[2] == 'gt'
	     *       ? object[match[1]] > match[3]
	     *       : object[match[1]] < match[3];
	     *   };
	     * });
	     *
	     * _.filter(users, 'age__gt36');
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     */
	    function callback(func, thisArg, guard) {
	      if (guard && isIterateeCall(func, thisArg, guard)) {
	        thisArg = undefined;
	      }
	      return isObjectLike(func)
	        ? matches(func)
	        : baseCallback(func, thisArg);
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     * var getter = _.constant(object);
	     *
	     * getter() === object;
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * This method returns the first argument provided to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.identity(object) === object;
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that performs a deep comparison between a given object
	     * and `source`, returning `true` if the given object has equivalent property
	     * values, else `false`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties. For comparing a single
	     * own or inherited property value see `_.matchesProperty`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
	     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, true));
	    }
	
	    /**
	     * Creates a function that compares the property value of `path` on a given
	     * object to `value`.
	     *
	     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	     * numbers, `Object` objects, regexes, and strings. Objects are compared by
	     * their own, not inherited, enumerable properties.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * _.find(users, _.matchesProperty('user', 'fred'));
	     * // => { 'user': 'fred' }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, true));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` on a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': _.constant(2) } } },
	     *   { 'a': { 'b': { 'c': _.constant(1) } } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    var method = restParam(function(path, args) {
	      return function(object) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path on `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = restParam(function(object, args) {
	      return function(path) {
	        return invokePath(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable function properties of a source object to the
	     * destination object. If `object` is a function then methods are added to
	     * its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options] The options object.
	     * @param {boolean} [options.chain=true] Specify whether the functions added
	     *  are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      if (options == null) {
	        var isObj = isObject(source),
	            props = isObj ? keys(source) : undefined,
	            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;
	
	        if (!(methodNames ? methodNames.length : isObj)) {
	          methodNames = false;
	          options = source;
	          source = object;
	          object = this;
	        }
	      }
	      if (!methodNames) {
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = true,
	          index = -1,
	          isFunc = isFunction(object),
	          length = methodNames.length;
	
	      if (options === false) {
	        chain = false;
	      } else if (isObject(options) && 'chain' in options) {
	        chain = options.chain;
	      }
	      while (++index < length) {
	        var methodName = methodNames[index],
	            func = source[methodName];
	
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = (function(func) {
	            return function() {
	              var chainAll = this.__chain__;
	              if (chain || chainAll) {
	                var result = object(this.__wrapped__),
	                    actions = result.__actions__ = arrayCopy(this.__actions__);
	
	                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	                result.__chain__ = chainAll;
	                return result;
	              }
	              return func.apply(object, arrayPush([this.value()], arguments));
	            };
	          }(func));
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      root._ = oldDash;
	      return this;
	    }
	
	    /**
	     * A no-operation function that returns `undefined` regardless of the
	     * arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @example
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * _.noop(object) === undefined;
	     * // => true
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that returns the property value at `path` on a
	     * given object.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': { 'c': 2 } } },
	     *   { 'a': { 'b': { 'c': 1 } } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b.c'));
	     * // => [2, 1]
	     *
	     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the property value at a given path on `object`.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return baseGet(object, toPath(path), path + '');
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. If `end` is not specified it is
	     * set to `start` with `start` then set to `0`. If `end` is less than `start`
	     * a zero-length range is created unless a negative `step` is specified.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the new array of numbers.
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    function range(start, end, step) {
	      if (step && isIterateeCall(start, end, step)) {
	        end = step = undefined;
	      }
	      start = +start || 0;
	      step = step == null ? 1 : (+step || 0);
	
	      if (end == null) {
	        end = start;
	        start = 0;
	      } else {
	        end = +end || 0;
	      }
	      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
	      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (++index < length) {
	        result[index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * Invokes the iteratee function `n` times, returning an array of the results
	     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
	     * one argument; (index).
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
	     * // => [3, 6, 4]
	     *
	     * _.times(3, function(n) {
	     *   mage.castSpell(n);
	     * });
	     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
	     *
	     * _.times(3, function(n) {
	     *   this.cast(n);
	     * }, mage);
	     * // => also invokes `mage.castSpell(n)` three times
	     */
	    function times(n, iteratee, thisArg) {
	      n = nativeFloor(n);
	
	      // Exit early to avoid a JSC JIT bug in Safari 8
	      // where `Array(0)` is treated as `Array(1)`.
	      if (n < 1 || !nativeIsFinite(n)) {
	        return [];
	      }
	      var index = -1,
	          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));
	
	      iteratee = bindCallback(iteratee, thisArg, 1);
	      while (++index < n) {
	        if (index < MAX_ARRAY_LENGTH) {
	          result[index] = iteratee(index);
	        } else {
	          iteratee(index);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	     *
	     * @static
	     * @memberOf _
	     * @category Utility
	     * @param {string} [prefix] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return baseToString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} augend The first number to add.
	     * @param {number} addend The second number to add.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    function add(augend, addend) {
	      return (+augend || 0) + (+addend || 0);
	    }
	
	    /**
	     * Calculates `n` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Calculates `n` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Gets the maximum value of `collection`. If `collection` is empty or falsey
	     * `-Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => -Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.max(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'fred', 'age': 40 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.max(users, 'age');
	     * // => { 'user': 'fred', 'age': 40 }
	     */
	    var max = createExtremum(gt, NEGATIVE_INFINITY);
	
	    /**
	     * Gets the minimum value of `collection`. If `collection` is empty or falsey
	     * `Infinity` is returned. If an iteratee function is provided it is invoked
	     * for each value in `collection` to generate the criterion by which the value
	     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
	     * arguments: (value, index, collection).
	     *
	     * If a property name is provided for `iteratee` the created `_.property`
	     * style callback returns the property value of the given element.
	     *
	     * If a value is also provided for `thisArg` the created `_.matchesProperty`
	     * style callback returns `true` for elements that have a matching property
	     * value, else `false`.
	     *
	     * If an object is provided for `iteratee` the created `_.matches` style
	     * callback returns `true` for elements that have the properties of the given
	     * object, else `false`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => Infinity
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * _.min(users, function(chr) {
	     *   return chr.age;
	     * });
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // using the `_.property` callback shorthand
	     * _.min(users, 'age');
	     * // => { 'user': 'barney', 'age': 36 }
	     */
	    var min = createExtremum(lt, POSITIVE_INFINITY);
	
	    /**
	     * Calculates `n` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {number} n The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Gets the sum of the values in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @category Math
	     * @param {Array|Object|string} collection The collection to iterate over.
	     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	     * @param {*} [thisArg] The `this` binding of `iteratee`.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 6]);
	     * // => 10
	     *
	     * _.sum({ 'a': 4, 'b': 6 });
	     * // => 10
	     *
	     * var objects = [
	     *   { 'n': 4 },
	     *   { 'n': 6 }
	     * ];
	     *
	     * _.sum(objects, function(object) {
	     *   return object.n;
	     * });
	     * // => 10
	     *
	     * // using the `_.property` callback shorthand
	     * _.sum(objects, 'n');
	     * // => 10
	     */
	    function sum(collection, iteratee, thisArg) {
	      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
	        iteratee = undefined;
	      }
	      iteratee = getCallback(iteratee, thisArg, 3);
	      return iteratee.length == 1
	        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
	        : baseSum(collection, iteratee);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    // Add functions to the `Map` cache.
	    MapCache.prototype['delete'] = mapDelete;
	    MapCache.prototype.get = mapGet;
	    MapCache.prototype.has = mapHas;
	    MapCache.prototype.set = mapSet;
	
	    // Add functions to the `Set` cache.
	    SetCache.prototype.push = cachePush;
	
	    // Assign cache to `_.memoize`.
	    memoize.Cache = MapCache;
	
	    // Add functions that return wrapped values when chaining.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.callback = callback;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.functions = functions;
	    lodash.groupBy = groupBy;
	    lodash.indexBy = indexBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.invert = invert;
	    lodash.invoke = invoke;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.modArgs = modArgs;
	    lodash.negate = negate;
	    lodash.omit = omit;
	    lodash.once = once;
	    lodash.pairs = pairs;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pluck = pluck;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.restParam = restParam;
	    lodash.set = set;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortByAll = sortByAll;
	    lodash.sortByOrder = sortByOrder;
	    lodash.spread = spread;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.times = times;
	    lodash.toArray = toArray;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.union = union;
	    lodash.uniq = uniq;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.where = where;
	    lodash.without = without;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.backflow = flowRight;
	    lodash.collect = map;
	    lodash.compose = flowRight;
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.extend = assign;
	    lodash.iteratee = callback;
	    lodash.methods = functions;
	    lodash.object = zipObject;
	    lodash.select = filter;
	    lodash.tail = rest;
	    lodash.unique = uniq;
	
	    // Add functions to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions that return unwrapped values when chaining.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.deburr = deburr;
	    lodash.endsWith = endsWith;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.findWhere = findWhere;
	    lodash.first = first;
	    lodash.floor = floor;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isBoolean = isBoolean;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isMatch = isMatch;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isString = isString;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.min = min;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padLeft = padLeft;
	    lodash.padRight = padRight;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.sum = sum;
	    lodash.template = template;
	    lodash.trim = trim;
	    lodash.trimLeft = trimLeft;
	    lodash.trimRight = trimRight;
	    lodash.trunc = trunc;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.words = words;
	
	    // Add aliases.
	    lodash.all = every;
	    lodash.any = some;
	    lodash.contains = includes;
	    lodash.eq = isEqual;
	    lodash.detect = find;
	    lodash.foldl = reduce;
	    lodash.foldr = reduceRight;
	    lodash.head = first;
	    lodash.include = includes;
	    lodash.inject = reduce;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!lodash.prototype[methodName]) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), false);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add functions capable of returning wrapped and unwrapped values when chaining.
	    lodash.sample = sample;
	
	    lodash.prototype.sample = function(n) {
	      if (!this.__chain__ && n == null) {
	        return sample(this.value());
	      }
	      return this.thru(function(value) {
	        return sample(value, n);
	      });
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type string
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        var filtered = this.__filtered__;
	        if (filtered && !index) {
	          return new LazyWrapper(this);
	        }
	        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);
	
	        var result = this.clone();
	        if (filtered) {
	          result.__takeCount__ = nativeMin(result.__takeCount__, n);
	        } else {
	          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type != LAZY_MAP_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
	        var result = this.clone();
	        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.first` and `_.last`.
	    arrayEach(['first', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
	    arrayEach(['initial', 'rest'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
	    arrayEach(['pluck', 'where'], function(methodName, index) {
	      var operationName = index ? 'filter' : 'map',
	          createCallback = index ? baseMatches : property;
	
	      LazyWrapper.prototype[methodName] = function(value) {
	        return this[operationName](createCallback(value));
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.reject = function(predicate, thisArg) {
	      predicate = getCallback(predicate, thisArg, 1);
	      return this.filter(function(value) {
	        return !predicate(value);
	      });
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = start == null ? 0 : (+start || 0);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = (+end || 0);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
	      return this.reverse().takeWhile(predicate, thisArg).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(POSITIVE_INFINITY);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
	          retUnwrapped = /^(?:first|last)$/.test(methodName),
	          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var args = retUnwrapped ? [1] : arguments,
	            chainAll = this.__chain__,
	            value = this.__wrapped__,
	            isHybrid = !!this.__actions__.length,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var interceptor = function(value) {
	          return (retUnwrapped && chainAll)
	            ? lodashFunc(value, 1)[0]
	            : lodashFunc.apply(undefined, arrayPush([value], args));
	        };
	
	        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
	            onlyLazy = isLazy && !isHybrid;
	
	        if (retUnwrapped && !chainAll) {
	          if (onlyLazy) {
	            value = value.clone();
	            value.__actions__.push(action);
	            return func.call(value);
	          }
	          return lodashFunc.call(undefined, this.value())[0];
	        }
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push(action);
	          return new LodashWrapper(result, chainAll);
	        }
	        return this.thru(interceptor);
	      };
	    });
	
	    // Add `Array` and `String` methods to `lodash.prototype`.
	    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
	      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          return func.apply(this.value(), args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(value, args);
	        });
	      };
	    });
	
	    // Map minified function names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = lodashFunc.name,
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];
	
	    // Add functions to the lazy wrapper.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chaining functions to the `lodash` wrapper.
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.concat = wrapperConcat;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toString = wrapperToString;
	    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add function aliases to the `lodash` wrapper.
	    lodash.prototype.collect = lodash.prototype.map;
	    lodash.prototype.head = lodash.prototype.first;
	    lodash.prototype.select = lodash.prototype.filter;
	    lodash.prototype.tail = lodash.prototype.rest;
	
	    return lodash;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers like r.js check for condition patterns like the following:
	  if (true) {
	    // Expose lodash to the global object when an AMD loader is present to avoid
	    // errors in cases where lodash is loaded by a script tag and not intended
	    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
	    // more details.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
	  else if (freeExports && freeModule) {
	    // Export for Node.js or RingoJS.
	    if (moduleExports) {
	      (freeModule.exports = _)._ = _;
	    }
	    // Export for Rhino with CommonJS support.
	    else {
	      freeExports._ = _;
	    }
	  }
	  else {
	    // Export for a browser or Rhino.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1032)(module), (function() { return this; }())))

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(97),
	    isObjectLike = __webpack_require__(61);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Native method references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is classified as an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  return isObjectLike(value) && isArrayLike(value) &&
	    hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
	}
	
	module.exports = isArguments;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(164),
	    isArrayLike = __webpack_require__(97),
	    isObject = __webpack_require__(36),
	    shimKeys = __webpack_require__(798);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	module.exports = keys;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(67);
	var canUseDOM = __webpack_require__(145);
	
	var History = {
	
	  /**
	   * The current number of entries in the history.
	   *
	   * Note: This property is read-only.
	   */
	  length: 1,
	
	  /**
	   * Sends the browser back one entry in the history.
	   */
	  back: function back() {
	    invariant(canUseDOM, 'Cannot use History.back without a DOM');
	
	    // Do this first so that History.length will
	    // be accurate in location change listeners.
	    History.length -= 1;
	
	    window.history.back();
	  }
	
	};
	
	module.exports = History;

/***/ }),
/* 113 */
/***/ (function(module, exports) {

	'use strict';
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = Object.keys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 * @typechecks static-only
	 */
	
	/*jslint bitwise: true */
	
	'use strict';
	
	var invariant = __webpack_require__(6);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_ATTRIBUTE: 0x1,
	  MUST_USE_PROPERTY: 0x2,
	  HAS_SIDE_EFFECTS: 0x4,
	  HAS_BOOLEAN_VALUE: 0x8,
	  HAS_NUMERIC_VALUE: 0x10,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x20 | 0x10,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x40,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function(domPropertyConfig) {
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(
	        domPropertyConfig.isCustomAttribute
	      );
	    }
	
	    for (var propName in Properties) {
	      ( false ? invariant(
	        !DOMProperty.isStandardName.hasOwnProperty(propName),
	        'injectDOMPropertyConfig(...): You\'re trying to inject DOM property ' +
	        '\'%s\' which has already been injected. You may be accidentally ' +
	        'injecting the same DOM property config twice, or you may be ' +
	        'injecting two configs that have conflicting property names.',
	        propName
	      ) : invariant(!DOMProperty.isStandardName.hasOwnProperty(propName)));
	
	      DOMProperty.isStandardName[propName] = true;
	
	      var lowerCased = propName.toLowerCase();
	      DOMProperty.getPossibleStandardName[lowerCased] = propName;
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        DOMProperty.getPossibleStandardName[attributeName] = propName;
	        DOMProperty.getAttributeName[propName] = attributeName;
	      } else {
	        DOMProperty.getAttributeName[propName] = lowerCased;
	      }
	
	      DOMProperty.getPropertyName[propName] =
	        DOMPropertyNames.hasOwnProperty(propName) ?
	          DOMPropertyNames[propName] :
	          propName;
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        DOMProperty.getMutationMethod[propName] = DOMMutationMethods[propName];
	      } else {
	        DOMProperty.getMutationMethod[propName] = null;
	      }
	
	      var propConfig = Properties[propName];
	      DOMProperty.mustUseAttribute[propName] =
	        checkMask(propConfig, DOMPropertyInjection.MUST_USE_ATTRIBUTE);
	      DOMProperty.mustUseProperty[propName] =
	        checkMask(propConfig, DOMPropertyInjection.MUST_USE_PROPERTY);
	      DOMProperty.hasSideEffects[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_SIDE_EFFECTS);
	      DOMProperty.hasBooleanValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_BOOLEAN_VALUE);
	      DOMProperty.hasNumericValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_NUMERIC_VALUE);
	      DOMProperty.hasPositiveNumericValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_POSITIVE_NUMERIC_VALUE);
	      DOMProperty.hasOverloadedBooleanValue[propName] =
	        checkMask(propConfig, DOMPropertyInjection.HAS_OVERLOADED_BOOLEAN_VALUE);
	
	      ( false ? invariant(
	        !DOMProperty.mustUseAttribute[propName] ||
	          !DOMProperty.mustUseProperty[propName],
	        'DOMProperty: Cannot require using both attribute and property: %s',
	        propName
	      ) : invariant(!DOMProperty.mustUseAttribute[propName] ||
	        !DOMProperty.mustUseProperty[propName]));
	      ( false ? invariant(
	        DOMProperty.mustUseProperty[propName] ||
	          !DOMProperty.hasSideEffects[propName],
	        'DOMProperty: Properties that have side effects must use property: %s',
	        propName
	      ) : invariant(DOMProperty.mustUseProperty[propName] ||
	        !DOMProperty.hasSideEffects[propName]));
	      ( false ? invariant(
	        !!DOMProperty.hasBooleanValue[propName] +
	          !!DOMProperty.hasNumericValue[propName] +
	          !!DOMProperty.hasOverloadedBooleanValue[propName] <= 1,
	        'DOMProperty: Value can be one of boolean, overloaded boolean, or ' +
	        'numeric value, but not a combination: %s',
	        propName
	      ) : invariant(!!DOMProperty.hasBooleanValue[propName] +
	        !!DOMProperty.hasNumericValue[propName] +
	        !!DOMProperty.hasOverloadedBooleanValue[propName] <= 1));
	    }
	  }
	};
	var defaultValueCache = {};
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	
	  /**
	   * Checks whether a property name is a standard property.
	   * @type {Object}
	   */
	  isStandardName: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties.
	   * @type {Object}
	   */
	  getPossibleStandardName: {},
	
	  /**
	   * Mapping from normalized names to attribute names that differ. Attribute
	   * names are used when rendering markup or with `*Attribute()`.
	   * @type {Object}
	   */
	  getAttributeName: {},
	
	  /**
	   * Mapping from normalized names to properties on DOM node instances.
	   * (This includes properties that mutate due to external factors.)
	   * @type {Object}
	   */
	  getPropertyName: {},
	
	  /**
	   * Mapping from normalized names to mutation methods. This will only exist if
	   * mutation cannot be set simply by the property or `setAttribute()`.
	   * @type {Object}
	   */
	  getMutationMethod: {},
	
	  /**
	   * Whether the property must be accessed and mutated as an object property.
	   * @type {Object}
	   */
	  mustUseAttribute: {},
	
	  /**
	   * Whether the property must be accessed and mutated using `*Attribute()`.
	   * (This includes anything that fails `<propName> in <element>`.)
	   * @type {Object}
	   */
	  mustUseProperty: {},
	
	  /**
	   * Whether or not setting a value causes side effects such as triggering
	   * resources to be loaded or text selection changes. We must ensure that
	   * the value is only set if it has changed.
	   * @type {Object}
	   */
	  hasSideEffects: {},
	
	  /**
	   * Whether the property should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasBooleanValue: {},
	
	  /**
	   * Whether the property must be numeric or parse as a
	   * numeric and should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasNumericValue: {},
	
	  /**
	   * Whether the property must be positive numeric or parse as a positive
	   * numeric and should be removed when set to a falsey value.
	   * @type {Object}
	   */
	  hasPositiveNumericValue: {},
	
	  /**
	   * Whether the property can be used as a flag as well as with a value. Removed
	   * when strictly equal to false; present without a value when strictly equal
	   * to true; present with a value otherwise.
	   * @type {Object}
	   */
	  hasOverloadedBooleanValue: {},
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function(attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  /**
	   * Returns the default property value for a DOM property (i.e., not an
	   * attribute). Most default values are '' or false, but not all. Worse yet,
	   * some (in particular, `type`) vary depending on the type of element.
	   *
	   * TODO: Is it better to grab all the possible properties when creating an
	   * element to avoid having to create the same element twice?
	   */
	  getDefaultValueForProperty: function(nodeName, prop) {
	    var nodeDefaults = defaultValueCache[nodeName];
	    var testElement;
	    if (!nodeDefaults) {
	      defaultValueCache[nodeName] = nodeDefaults = {};
	    }
	    if (!(prop in nodeDefaults)) {
	      testElement = document.createElement(nodeName);
	      nodeDefaults[prop] = testElement[prop];
	    }
	    return nodeDefaults[prop];
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	var EventPluginHub = __webpack_require__(132);
	var EventPluginRegistry = __webpack_require__(379);
	var ReactEventEmitterMixin = __webpack_require__(873);
	var ViewportMetrics = __webpack_require__(252);
	
	var assign = __webpack_require__(11);
	var isEventSupported = __webpack_require__(259);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topBlur: 'blur',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topScroll: 'scroll',
	  topSelectionChange: 'selectionchange',
	  topTextInput: 'textInput',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   ReactBrowserEventEmitter.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function(ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(
	        ReactBrowserEventEmitter.handleTopLevel
	      );
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function(enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function() {
	    return !!(
	      (ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled())
	    );
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function(registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.
	      registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0, l = dependencies.length; i < l; i++) {
	      var dependency = dependencies[i];
	      if (!(
	            (isListening.hasOwnProperty(dependency) && isListening[dependency])
	          )) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'wheel',
	              mountAt
	            );
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'mousewheel',
	              mountAt
	            );
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topWheel,
	              'DOMMouseScroll',
	              mountAt
	            );
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topScroll,
	              'scroll',
	              mountAt
	            );
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topScroll,
	              'scroll',
	              ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE
	            );
	          }
	        } else if (dependency === topLevelTypes.topFocus ||
	            dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topFocus,
	              'focus',
	              mountAt
	            );
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	              topLevelTypes.topBlur,
	              'blur',
	              mountAt
	            );
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topFocus,
	              'focusin',
	              mountAt
	            );
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	              topLevelTypes.topBlur,
	              'focusout',
	              mountAt
	            );
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	            dependency,
	            topEventMapping[dependency],
	            mountAt
	          );
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(
	      topLevelType,
	      handlerBaseName,
	      handle
	    );
	  },
	
	  trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(
	      topLevelType,
	      handlerBaseName,
	      handle
	    );
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function() {
	    if (!isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  },
	
	  eventNameDispatchConfigs: EventPluginHub.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginHub.registrationNameModules,
	
	  putListener: EventPluginHub.putListener,
	
	  getListener: EventPluginHub.getListener,
	
	  deleteListener: EventPluginHub.deleteListener,
	
	  deleteAllListeners: EventPluginHub.deleteAllListeners
	
	});
	
	module.exports = ReactBrowserEventEmitter;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceHandles
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactRootIndex = __webpack_require__(389);
	
	var invariant = __webpack_require__(6);
	
	var SEPARATOR = '.';
	var SEPARATOR_LENGTH = SEPARATOR.length;
	
	/**
	 * Maximum depth of traversals before we consider the possibility of a bad ID.
	 */
	var MAX_TREE_DEPTH = 100;
	
	/**
	 * Creates a DOM ID prefix to use when mounting React components.
	 *
	 * @param {number} index A unique integer
	 * @return {string} React root ID.
	 * @internal
	 */
	function getReactRootIDString(index) {
	  return SEPARATOR + index.toString(36);
	}
	
	/**
	 * Checks if a character in the supplied ID is a separator or the end.
	 *
	 * @param {string} id A React DOM ID.
	 * @param {number} index Index of the character to check.
	 * @return {boolean} True if the character is a separator or end of the ID.
	 * @private
	 */
	function isBoundary(id, index) {
	  return id.charAt(index) === SEPARATOR || index === id.length;
	}
	
	/**
	 * Checks if the supplied string is a valid React DOM ID.
	 *
	 * @param {string} id A React DOM ID, maybe.
	 * @return {boolean} True if the string is a valid React DOM ID.
	 * @private
	 */
	function isValidID(id) {
	  return id === '' || (
	    id.charAt(0) === SEPARATOR && id.charAt(id.length - 1) !== SEPARATOR
	  );
	}
	
	/**
	 * Checks if the first ID is an ancestor of or equal to the second ID.
	 *
	 * @param {string} ancestorID
	 * @param {string} descendantID
	 * @return {boolean} True if `ancestorID` is an ancestor of `descendantID`.
	 * @internal
	 */
	function isAncestorIDOf(ancestorID, descendantID) {
	  return (
	    descendantID.indexOf(ancestorID) === 0 &&
	    isBoundary(descendantID, ancestorID.length)
	  );
	}
	
	/**
	 * Gets the parent ID of the supplied React DOM ID, `id`.
	 *
	 * @param {string} id ID of a component.
	 * @return {string} ID of the parent, or an empty string.
	 * @private
	 */
	function getParentID(id) {
	  return id ? id.substr(0, id.lastIndexOf(SEPARATOR)) : '';
	}
	
	/**
	 * Gets the next DOM ID on the tree path from the supplied `ancestorID` to the
	 * supplied `destinationID`. If they are equal, the ID is returned.
	 *
	 * @param {string} ancestorID ID of an ancestor node of `destinationID`.
	 * @param {string} destinationID ID of the destination node.
	 * @return {string} Next ID on the path from `ancestorID` to `destinationID`.
	 * @private
	 */
	function getNextDescendantID(ancestorID, destinationID) {
	  ( false ? invariant(
	    isValidID(ancestorID) && isValidID(destinationID),
	    'getNextDescendantID(%s, %s): Received an invalid React DOM ID.',
	    ancestorID,
	    destinationID
	  ) : invariant(isValidID(ancestorID) && isValidID(destinationID)));
	  ( false ? invariant(
	    isAncestorIDOf(ancestorID, destinationID),
	    'getNextDescendantID(...): React has made an invalid assumption about ' +
	    'the DOM hierarchy. Expected `%s` to be an ancestor of `%s`.',
	    ancestorID,
	    destinationID
	  ) : invariant(isAncestorIDOf(ancestorID, destinationID)));
	  if (ancestorID === destinationID) {
	    return ancestorID;
	  }
	  // Skip over the ancestor and the immediate separator. Traverse until we hit
	  // another separator or we reach the end of `destinationID`.
	  var start = ancestorID.length + SEPARATOR_LENGTH;
	  var i;
	  for (i = start; i < destinationID.length; i++) {
	    if (isBoundary(destinationID, i)) {
	      break;
	    }
	  }
	  return destinationID.substr(0, i);
	}
	
	/**
	 * Gets the nearest common ancestor ID of two IDs.
	 *
	 * Using this ID scheme, the nearest common ancestor ID is the longest common
	 * prefix of the two IDs that immediately preceded a "marker" in both strings.
	 *
	 * @param {string} oneID
	 * @param {string} twoID
	 * @return {string} Nearest common ancestor ID, or the empty string if none.
	 * @private
	 */
	function getFirstCommonAncestorID(oneID, twoID) {
	  var minLength = Math.min(oneID.length, twoID.length);
	  if (minLength === 0) {
	    return '';
	  }
	  var lastCommonMarkerIndex = 0;
	  // Use `<=` to traverse until the "EOL" of the shorter string.
	  for (var i = 0; i <= minLength; i++) {
	    if (isBoundary(oneID, i) && isBoundary(twoID, i)) {
	      lastCommonMarkerIndex = i;
	    } else if (oneID.charAt(i) !== twoID.charAt(i)) {
	      break;
	    }
	  }
	  var longestCommonID = oneID.substr(0, lastCommonMarkerIndex);
	  ( false ? invariant(
	    isValidID(longestCommonID),
	    'getFirstCommonAncestorID(%s, %s): Expected a valid React DOM ID: %s',
	    oneID,
	    twoID,
	    longestCommonID
	  ) : invariant(isValidID(longestCommonID)));
	  return longestCommonID;
	}
	
	/**
	 * Traverses the parent path between two IDs (either up or down). The IDs must
	 * not be the same, and there must exist a parent path between them. If the
	 * callback returns `false`, traversal is stopped.
	 *
	 * @param {?string} start ID at which to start traversal.
	 * @param {?string} stop ID at which to end traversal.
	 * @param {function} cb Callback to invoke each ID with.
	 * @param {?boolean} skipFirst Whether or not to skip the first node.
	 * @param {?boolean} skipLast Whether or not to skip the last node.
	 * @private
	 */
	function traverseParentPath(start, stop, cb, arg, skipFirst, skipLast) {
	  start = start || '';
	  stop = stop || '';
	  ( false ? invariant(
	    start !== stop,
	    'traverseParentPath(...): Cannot traverse from and to the same ID, `%s`.',
	    start
	  ) : invariant(start !== stop));
	  var traverseUp = isAncestorIDOf(stop, start);
	  ( false ? invariant(
	    traverseUp || isAncestorIDOf(start, stop),
	    'traverseParentPath(%s, %s, ...): Cannot traverse from two IDs that do ' +
	    'not have a parent path.',
	    start,
	    stop
	  ) : invariant(traverseUp || isAncestorIDOf(start, stop)));
	  // Traverse from `start` to `stop` one depth at a time.
	  var depth = 0;
	  var traverse = traverseUp ? getParentID : getNextDescendantID;
	  for (var id = start; /* until break */; id = traverse(id, stop)) {
	    var ret;
	    if ((!skipFirst || id !== start) && (!skipLast || id !== stop)) {
	      ret = cb(id, traverseUp, arg);
	    }
	    if (ret === false || id === stop) {
	      // Only break //after// visiting `stop`.
	      break;
	    }
	    ( false ? invariant(
	      depth++ < MAX_TREE_DEPTH,
	      'traverseParentPath(%s, %s, ...): Detected an infinite loop while ' +
	      'traversing the React DOM ID tree. This may be due to malformed IDs: %s',
	      start, stop
	    ) : invariant(depth++ < MAX_TREE_DEPTH));
	  }
	}
	
	/**
	 * Manages the IDs assigned to DOM representations of React components. This
	 * uses a specific scheme in order to traverse the DOM efficiently (e.g. in
	 * order to simulate events).
	 *
	 * @internal
	 */
	var ReactInstanceHandles = {
	
	  /**
	   * Constructs a React root ID
	   * @return {string} A React root ID.
	   */
	  createReactRootID: function() {
	    return getReactRootIDString(ReactRootIndex.createReactRootIndex());
	  },
	
	  /**
	   * Constructs a React ID by joining a root ID with a name.
	   *
	   * @param {string} rootID Root ID of a parent component.
	   * @param {string} name A component's name (as flattened children).
	   * @return {string} A React ID.
	   * @internal
	   */
	  createReactID: function(rootID, name) {
	    return rootID + name;
	  },
	
	  /**
	   * Gets the DOM ID of the React component that is the root of the tree that
	   * contains the React component with the supplied DOM ID.
	   *
	   * @param {string} id DOM ID of a React component.
	   * @return {?string} DOM ID of the React component that is the root.
	   * @internal
	   */
	  getReactRootIDFromNodeID: function(id) {
	    if (id && id.charAt(0) === SEPARATOR && id.length > 1) {
	      var index = id.indexOf(SEPARATOR, 1);
	      return index > -1 ? id.substr(0, index) : id;
	    }
	    return null;
	  },
	
	  /**
	   * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	   * should would receive a `mouseEnter` or `mouseLeave` event.
	   *
	   * NOTE: Does not invoke the callback on the nearest common ancestor because
	   * nothing "entered" or "left" that element.
	   *
	   * @param {string} leaveID ID being left.
	   * @param {string} enterID ID being entered.
	   * @param {function} cb Callback to invoke on each entered/left ID.
	   * @param {*} upArg Argument to invoke the callback with on left IDs.
	   * @param {*} downArg Argument to invoke the callback with on entered IDs.
	   * @internal
	   */
	  traverseEnterLeave: function(leaveID, enterID, cb, upArg, downArg) {
	    var ancestorID = getFirstCommonAncestorID(leaveID, enterID);
	    if (ancestorID !== leaveID) {
	      traverseParentPath(leaveID, ancestorID, cb, upArg, false, true);
	    }
	    if (ancestorID !== enterID) {
	      traverseParentPath(ancestorID, enterID, cb, downArg, true, false);
	    }
	  },
	
	  /**
	   * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseTwoPhase: function(targetID, cb, arg) {
	    if (targetID) {
	      traverseParentPath('', targetID, cb, arg, true, false);
	      traverseParentPath(targetID, '', cb, arg, false, true);
	    }
	  },
	
	  /**
	   * Traverse a node ID, calling the supplied `cb` for each ancestor ID. For
	   * example, passing `.0.$row-0.1` would result in `cb` getting called
	   * with `.0`, `.0.$row-0`, and `.0.$row-0.1`.
	   *
	   * NOTE: This traversal happens on IDs without touching the DOM.
	   *
	   * @param {string} targetID ID of the target node.
	   * @param {function} cb Callback to invoke.
	   * @param {*} arg Argument to invoke the callback with.
	   * @internal
	   */
	  traverseAncestors: function(targetID, cb, arg) {
	    traverseParentPath('', targetID, cb, arg, true, false);
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getFirstCommonAncestorID: getFirstCommonAncestorID,
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _getNextDescendantID: getNextDescendantID,
	
	  isAncestorIDOf: isAncestorIDOf,
	
	  SEPARATOR: SEPARATOR
	
	};
	
	module.exports = ReactInstanceHandles;


/***/ }),
/* 117 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function(key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function(key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function(key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function(key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(880);
	var ReactElementValidator = __webpack_require__(134);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function(internalInstance, rootID, transaction, context) {
	    var markup = internalInstance.mountComponent(rootID, transaction, context);
	    if (false) {
	      ReactElementValidator.checkAndWarnForMutatedProps(
	        internalInstance._currentElement
	      );
	    }
	    transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function(internalInstance) {
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent();
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function(
	    internalInstance, nextElement, transaction, context
	  ) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && nextElement._owner != null) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	      return;
	    }
	
	    if (false) {
	      ReactElementValidator.checkAndWarnForMutatedProps(nextElement);
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(
	      prevElement,
	      nextElement
	    );
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function(
	    internalInstance,
	    transaction
	  ) {
	    internalInstance.performUpdateIfNecessary(transaction);
	  }
	
	};
	
	module.exports = ReactReconciler;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.newGUID = newGUID;
	/**
	 * @file guid.js
	 * @module guid
	 */
	
	/**
	 * Unique ID for an element or function
	 * @type {Number}
	 */
	var _guid = 1;
	
	/**
	 * Get a unique auto-incrementing ID by number that has not been returned before.
	 *
	 * @return {number}
	 *         A new unique ID.
	 */
	function newGUID() {
	  return _guid++;
	}


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * @file to-title-case.js
	 * @module to-title-case
	 */
	
	/**
	 * Uppercase the first letter of a string.
	 *
	 * @param {string} string
	 *        String to be uppercased
	 *
	 * @return {string}
	 *         The string with an uppercased first letter
	 */
	function toTitleCase(string) {
	  if (typeof string !== 'string') {
	    return string;
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}
	
	exports['default'] = toTitleCase;


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	"use strict";
	
	var fallbackConfig = {
	    amountResults: [10, 25, 50],
	    defaultPerPageResults: 25
	};
	
	module.exports = fallbackConfig;

/***/ }),
/* 122 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = {
	    capitalize: function capitalize(s) {
	        return s && s[0].toUpperCase() + s.slice(1);
	    },
	
	    nl2br: function nl2br(str) {
	        var regex = /(\r\n|\n\r|\r|\n)/g;
	        str = '' + str;
	
	        return str.split(regex).map(function (line, index) {
	            return line.match(regex) ? document.createElement('BR').outerHTML : line;
	        }).join('');
	    },
	
	    encodeBackendUrl: function encodeBackendUrl(str) {
	        return str ? str.replace(/ /g, '+').replace(/&/g, '%26') : '';
	    },
	    encodeUrl: function encodeUrl(str) {
	        return str ? str.replace(/&/g, '%26').replace(/ /g, '+').replace(/\//g, '%2F') : '';
	    },
	
	    decodeUrl: function decodeUrl(str) {
	        return str ? str.replace(/%26/g, '&').replace(/\+/g, ' ').replace(/%2F/g, '/') : '';
	    },
	
	    /**
	     * Removes a string in a query object’s value which
	     * might have pipez.
	     *
	     * @arg1 needle:Object
	     * @arg2 queryObject:Object
	     * @arg3 exactMatch:Boolean => false
	     *
	     * @returns queryObject:Object
	     *
	     * @example ( { foo: 'foo' }, { foo: 'foo|bar|baz', baz: 'bar' } ) => { foo: 'bar|baz', baz: 'bar' }
	     */
	    removeFromPipedQuery: function removeFromPipedQuery(needle, queryObject) {
	        var exactMatch = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	        var _query = _extends({}, queryObject);
	        var value = '';
	
	        Object.keys(needle).map(function (key) {
	            value = _query[key];
	
	            // only perform this on piped values
	            if (!/\|/.test(value)) {
	                return;
	            }
	
	            var newValue;
	            if (exactMatch) {
	                newValue = value.split('|').filter(function (component) {
	                    return component !== needle[key];
	                });
	            } else {
	                newValue = value.split('|').map(function (component) {
	                    return component.replace(needle[key], '');
	                });
	            }
	            _query[key] = newValue.filter(function (component) {
	                return component !== '';
	            }).join('|').replace(/\|{2,}/, '|').replace(/^\||\|$/, '');
	
	            if (_query[key].length === 0) {
	                delete _query[key];
	            }
	        });
	
	        return _query;
	    }
	};
	module.exports = exports['default'];

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(5);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(50);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(40);
	var global = __webpack_require__(8);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(78) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(5);
	var aFunction = __webpack_require__(29);
	var SPECIES = __webpack_require__(13)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _interopRequireWildcard = function (obj) { return obj && obj.__esModule ? obj : { 'default': obj }; };
	
	var _classCallCheck = function (instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(object, property, receiver) { var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _inherits = function (subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) subClass.__proto__ = superClass; };
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _React$findDOMNode = __webpack_require__(2);
	
	var _React$findDOMNode2 = _interopRequireWildcard(_React$findDOMNode);
	
	var _CSSPropertyOperations = __webpack_require__(239);
	
	var _CSSPropertyOperations2 = _interopRequireWildcard(_CSSPropertyOperations);
	
	var _shallowEqual = __webpack_require__(400);
	
	var _shallowEqual2 = _interopRequireWildcard(_shallowEqual);
	
	var Portal = (function (_React$Component) {
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    _get(Object.getPrototypeOf(Portal.prototype), 'constructor', this).call(this);
	    this.state = { active: false };
	    this.openPortal = this.openPortal.bind(this);
	    this.closePortal = this.closePortal.bind(this);
	    this.handleOutsideMouseClick = this.handleOutsideMouseClick.bind(this);
	    this.handleKeydown = this.handleKeydown.bind(this);
	    this.portal = null;
	    this.node = null;
	  }
	
	  _inherits(Portal, _React$Component);
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('mousedown', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.isOpened) {
	        this.openPortal();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps) {
	      // portal's 'is open' state is handled through the prop isOpened
	      if (typeof newProps.isOpened !== 'undefined') {
	        if (newProps.isOpened) {
	          if (this.state.active) {
	            this.renderPortal(newProps);
	          } else {
	            this.openPortal();
	          }
	        }
	        if (!newProps.isOpened && this.state.active) {
	          this.closePortal();
	        }
	      }
	
	      // portal handles its own 'is open' state
	      if (typeof newProps.isOpened === 'undefined' && this.state.active) {
	        this.renderPortal(newProps);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('mousedown', this.handleOutsideMouseClick);
	      }
	
	      this.closePortal();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !_shallowEqual2['default'](this.props, nextProps) || !_shallowEqual2['default'](this.state, nextState);
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.node) {
	        this.node = document.createElement('div');
	        if (this.props.className) {
	          this.node.className = this.props.className;
	        }
	        if (this.props.style) {
	          _CSSPropertyOperations2['default'].setValueForStyles(this.node, this.props.style);
	        }
	        document.body.appendChild(this.node);
	      }
	      this.portal = _React$findDOMNode2['default'].render(_React$findDOMNode2['default'].cloneElement(props.children, { closePortal: this.closePortal }), this.node);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.openByClickOn) {
	        return _React$findDOMNode2['default'].createElement(
	          'div',
	          { className: 'openByClickOn', onClick: this.openPortal },
	          this.props.openByClickOn
	        );
	      } else {
	        return null;
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (e) {
	        e.preventDefault();
	        e.stopPropagation();
	      }
	      this.setState({ active: true });
	      this.renderPortal(this.props);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (this.node) {
	        _React$findDOMNode2['default'].unmountComponentAtNode(this.node);
	        document.body.removeChild(this.node);
	      }
	      this.portal = null;
	      this.node = null;
	      this.setState({ active: false });
	
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      if (isNodeInRoot(e.target, _React$findDOMNode.findDOMNode(this.portal))) {
	        return;
	      }
	      e.stopPropagation();
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      // ESC
	      if (e.keyCode === 27 && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }]);
	
	  return Portal;
	})(_React$findDOMNode2['default'].Component);
	
	exports['default'] = Portal;
	
	Portal.propTypes = {
	  children: _React$findDOMNode2['default'].PropTypes.element.isRequired,
	  openByClickOn: _React$findDOMNode2['default'].PropTypes.element,
	  closeOnEsc: _React$findDOMNode2['default'].PropTypes.bool,
	  closeOnOutsideClick: _React$findDOMNode2['default'].PropTypes.bool,
	  isOpened: _React$findDOMNode2['default'].PropTypes.bool,
	  onClose: _React$findDOMNode2['default'].PropTypes.func
	};
	
	function isNodeInRoot(node, root) {
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	    node = node.parentNode;
	  }
	  return false;
	}
	module.exports = exports['default'];

/***/ }),
/* 130 */
/***/ (function(module, exports) {

	/**
	 * Actions that modify the URL.
	 */
	'use strict';
	
	var LocationActions = {
	
	  /**
	   * Indicates a new location is being pushed to the history stack.
	   */
	  PUSH: 'push',
	
	  /**
	   * Indicates the current location should be replaced.
	   */
	  REPLACE: 'replace',
	
	  /**
	   * Indicates the most recent entry should be removed from the history stack.
	   */
	  POP: 'pop'
	
	};
	
	module.exports = LocationActions;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(114);
	
	var quoteAttributeValueForBrowser = __webpack_require__(917);
	var warning = __webpack_require__(17);
	
	function shouldIgnoreValue(name, value) {
	  return value == null ||
	    (DOMProperty.hasBooleanValue[name] && !value) ||
	    (DOMProperty.hasNumericValue[name] && isNaN(value)) ||
	    (DOMProperty.hasPositiveNumericValue[name] && (value < 1)) ||
	    (DOMProperty.hasOverloadedBooleanValue[name] && value === false);
	}
	
	if (false) {
	  var reactProps = {
	    children: true,
	    dangerouslySetInnerHTML: true,
	    key: true,
	    ref: true
	  };
	  var warnedProperties = {};
	
	  var warnUnknownProperty = function(name) {
	    if (reactProps.hasOwnProperty(name) && reactProps[name] ||
	        warnedProperties.hasOwnProperty(name) && warnedProperties[name]) {
	      return;
	    }
	
	    warnedProperties[name] = true;
	    var lowerCasedName = name.toLowerCase();
	
	    // data-* attributes should be lowercase; suggest the lowercase version
	    var standardName = (
	      DOMProperty.isCustomAttribute(lowerCasedName) ?
	        lowerCasedName :
	      DOMProperty.getPossibleStandardName.hasOwnProperty(lowerCasedName) ?
	        DOMProperty.getPossibleStandardName[lowerCasedName] :
	        null
	    );
	
	    // For now, only warn when we have a suggested correction. This prevents
	    // logging too much when using transferPropsTo.
	    ("production" !== process.env.NODE_ENV ? warning(
	      standardName == null,
	      'Unknown DOM property %s. Did you mean %s?',
	      name,
	      standardName
	    ) : null);
	
	  };
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function(id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' +
	      quoteAttributeValueForBrowser(id);
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function(name, value) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      if (shouldIgnoreValue(name, value)) {
	        return '';
	      }
	      var attributeName = DOMProperty.getAttributeName[name];
	      if (DOMProperty.hasBooleanValue[name] ||
	          (DOMProperty.hasOverloadedBooleanValue[name] && value === true)) {
	        return attributeName;
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	    return null;
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function(node, name, value) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      var mutationMethod = DOMProperty.getMutationMethod[name];
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(name, value)) {
	        this.deleteValueForProperty(node, name);
	      } else if (DOMProperty.mustUseAttribute[name]) {
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        node.setAttribute(DOMProperty.getAttributeName[name], '' + value);
	      } else {
	        var propName = DOMProperty.getPropertyName[name];
	        // Must explicitly cast values for HAS_SIDE_EFFECTS-properties to the
	        // property type before comparing; only `value` does and is string.
	        if (!DOMProperty.hasSideEffects[name] ||
	            ('' + node[propName]) !== ('' + value)) {
	          // Contrary to `setAttribute`, object properties are properly
	          // `toString`ed by IE8/9.
	          node[propName] = value;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        node.removeAttribute(name);
	      } else {
	        node.setAttribute(name, '' + value);
	      }
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function(node, name) {
	    if (DOMProperty.isStandardName.hasOwnProperty(name) &&
	        DOMProperty.isStandardName[name]) {
	      var mutationMethod = DOMProperty.getMutationMethod[name];
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (DOMProperty.mustUseAttribute[name]) {
	        node.removeAttribute(DOMProperty.getAttributeName[name]);
	      } else {
	        var propName = DOMProperty.getPropertyName[name];
	        var defaultValue = DOMProperty.getDefaultValueForProperty(
	          node.nodeName,
	          propName
	        );
	        if (!DOMProperty.hasSideEffects[name] ||
	            ('' + node[propName]) !== defaultValue) {
	          node[propName] = defaultValue;
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    } else if (false) {
	      warnUnknownProperty(name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var EventPluginRegistry = __webpack_require__(379);
	var EventPluginUtils = __webpack_require__(241);
	
	var accumulateInto = __webpack_require__(253);
	var forEachAccumulated = __webpack_require__(254);
	var invariant = __webpack_require__(6);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @private
	 */
	var executeDispatchesAndRelease = function(event) {
	  if (event) {
	    var executeDispatch = EventPluginUtils.executeDispatch;
	    // Plugins can provide custom behavior when dispatching events.
	    var PluginModule = EventPluginRegistry.getPluginModuleForEvent(event);
	    if (PluginModule && PluginModule.executeDispatch) {
	      executeDispatch = PluginModule.executeDispatch;
	    }
	    EventPluginUtils.executeDispatchesInOrder(event, executeDispatch);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	
	/**
	 * - `InstanceHandle`: [required] Module that performs logical traversals of DOM
	 *   hierarchy given ids of the logical DOM elements involved.
	 */
	var InstanceHandle = null;
	
	function validateInstanceHandle() {
	  var valid =
	    InstanceHandle &&
	    InstanceHandle.traverseTwoPhase &&
	    InstanceHandle.traverseEnterLeave;
	  ( false ? invariant(
	    valid,
	    'InstanceHandle not injected before use!'
	  ) : invariant(valid));
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {object} InjectedMount
	     * @public
	     */
	    injectMount: EventPluginUtils.injection.injectMount,
	
	    /**
	     * @param {object} InjectedInstanceHandle
	     * @public
	     */
	    injectInstanceHandle: function(InjectedInstanceHandle) {
	      InstanceHandle = InjectedInstanceHandle;
	      if (false) {
	        validateInstanceHandle();
	      }
	    },
	
	    getInstanceHandle: function() {
	      if (false) {
	        validateInstanceHandle();
	      }
	      return InstanceHandle;
	    },
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  eventNameDispatchConfigs: EventPluginRegistry.eventNameDispatchConfigs,
	
	  registrationNameModules: EventPluginRegistry.registrationNameModules,
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {?function} listener The callback to store.
	   */
	  putListener: function(id, registrationName, listener) {
	    ( false ? invariant(
	      !listener || typeof listener === 'function',
	      'Expected %s listener to be a function, instead got type %s',
	      registrationName, typeof listener
	    ) : invariant(!listener || typeof listener === 'function'));
	
	    var bankForRegistrationName =
	      listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[id] = listener;
	  },
	
	  /**
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function(id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[id];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {string} id ID of the DOM element.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function(id, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[id];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {string} id ID of the DOM element.
	   */
	  deleteAllListeners: function(id) {
	    for (var registrationName in listenerBank) {
	      delete listenerBank[registrationName][id];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0, l = plugins.length; i < l; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(
	          topLevelType,
	          topLevelTarget,
	          topLevelTargetID,
	          nativeEvent
	        );
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function(events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function() {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    forEachAccumulated(processingEventQueue, executeDispatchesAndRelease);
	    ( false ? invariant(
	      !eventQueue,
	      'processEventQueue(): Additional events were enqueued while processing ' +
	      'an event queue. Support for this has not yet been implemented.'
	    ) : invariant(!eventQueue));
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function() {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function() {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	var EventPluginHub = __webpack_require__(132);
	
	var accumulateInto = __webpack_require__(253);
	var forEachAccumulated = __webpack_require__(254);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(id, event, propagationPhase) {
	  var registrationName =
	    event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(id, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(domID, upwards, event) {
	  if (false) {
	    if (!domID) {
	      throw new Error('Dispatching id must not be null');
	    }
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(domID, event, phase);
	  if (listener) {
	    event._dispatchListeners =
	      accumulateInto(event._dispatchListeners, listener);
	    event._dispatchIDs = accumulateInto(event._dispatchIDs, domID);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We can not perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginHub.injection.getInstanceHandle().traverseTwoPhase(
	      event.dispatchMarker,
	      accumulateDirectionalDispatches,
	      event
	    );
	  }
	}
	
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(id, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(id, registrationName);
	    if (listener) {
	      event._dispatchListeners =
	        accumulateInto(event._dispatchListeners, listener);
	      event._dispatchIDs = accumulateInto(event._dispatchIDs, id);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event.dispatchMarker, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, fromID, toID) {
	  EventPluginHub.injection.getInstanceHandle().traverseEnterLeave(
	    fromID,
	    toID,
	    accumulateDispatches,
	    leave,
	    enter
	  );
	}
	
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElementValidator
	 */
	
	/**
	 * ReactElementValidator provides a wrapper around a element factory
	 * which validates the props passed to the element. This is intended to be
	 * used only in DEV and could be replaced by a static type checker for languages
	 * that support it.
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	var ReactFragment = __webpack_require__(135);
	var ReactPropTypeLocations = __webpack_require__(250);
	var ReactPropTypeLocationNames = __webpack_require__(173);
	var ReactCurrentOwner = __webpack_require__(72);
	var ReactNativeComponent = __webpack_require__(172);
	
	var getIteratorFn = __webpack_require__(394);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(17);
	
	function getDeclarationErrorAddendum() {
	  if (ReactCurrentOwner.current) {
	    var name = ReactCurrentOwner.current.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Warn if there's no key explicitly set on dynamic arrays of children or
	 * object keys are not valid. This allows us to keep track of children between
	 * updates.
	 */
	var ownerHasKeyUseWarning = {};
	
	var loggedTypeFailures = {};
	
	var NUMERIC_PROPERTY_REGEX = /^\d+$/;
	
	/**
	 * Gets the instance's name for use in warnings.
	 *
	 * @internal
	 * @return {?string} Display name or undefined
	 */
	function getName(instance) {
	  var publicInstance = instance && instance.getPublicInstance();
	  if (!publicInstance) {
	    return undefined;
	  }
	  var constructor = publicInstance.constructor;
	  if (!constructor) {
	    return undefined;
	  }
	  return constructor.displayName || constructor.name || undefined;
	}
	
	/**
	 * Gets the current owner's displayName for use in warnings.
	 *
	 * @internal
	 * @return {?string} Display name or undefined
	 */
	function getCurrentOwnerDisplayName() {
	  var current = ReactCurrentOwner.current;
	  return (
	    current && getName(current) || undefined
	  );
	}
	
	/**
	 * Warn if the element doesn't have an explicit key assigned to it.
	 * This element is in an array. The array could grow and shrink or be
	 * reordered. All children that haven't already been validated are required to
	 * have a "key" property assigned to it.
	 *
	 * @internal
	 * @param {ReactElement} element Element that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validateExplicitKey(element, parentType) {
	  if (element._store.validated || element.key != null) {
	    return;
	  }
	  element._store.validated = true;
	
	  warnAndMonitorForKeyUse(
	    'Each child in an array or iterator should have a unique "key" prop.',
	    element,
	    parentType
	  );
	}
	
	/**
	 * Warn if the key is being defined as an object property but has an incorrect
	 * value.
	 *
	 * @internal
	 * @param {string} name Property name of the key.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function validatePropertyKey(name, element, parentType) {
	  if (!NUMERIC_PROPERTY_REGEX.test(name)) {
	    return;
	  }
	  warnAndMonitorForKeyUse(
	    'Child objects should have non-numeric keys so ordering is preserved.',
	    element,
	    parentType
	  );
	}
	
	/**
	 * Shared warning and monitoring code for the key warnings.
	 *
	 * @internal
	 * @param {string} message The base warning that gets output.
	 * @param {ReactElement} element Component that requires a key.
	 * @param {*} parentType element's parent's type.
	 */
	function warnAndMonitorForKeyUse(message, element, parentType) {
	  var ownerName = getCurrentOwnerDisplayName();
	  var parentName = typeof parentType === 'string' ?
	    parentType : parentType.displayName || parentType.name;
	
	  var useName = ownerName || parentName;
	  var memoizer = ownerHasKeyUseWarning[message] || (
	    (ownerHasKeyUseWarning[message] = {})
	  );
	  if (memoizer.hasOwnProperty(useName)) {
	    return;
	  }
	  memoizer[useName] = true;
	
	  var parentOrOwnerAddendum =
	    ownerName ? (" Check the render method of " + ownerName + ".") :
	    parentName ? (" Check the React.render call using <" + parentName + ">.") :
	    '';
	
	  // Usually the current owner is the offender, but if it accepts children as a
	  // property, it may be the creator of the child that's responsible for
	  // assigning it a key.
	  var childOwnerAddendum = '';
	  if (element &&
	      element._owner &&
	      element._owner !== ReactCurrentOwner.current) {
	    // Name of the component that originally created this child.
	    var childOwnerName = getName(element._owner);
	
	    childOwnerAddendum = (" It was passed a child from " + childOwnerName + ".");
	  }
	
	  ( false ? warning(
	    false,
	    message + '%s%s See https://fb.me/react-warning-keys for more information.',
	    parentOrOwnerAddendum,
	    childOwnerAddendum
	  ) : null);
	}
	
	/**
	 * Ensure that every element either is passed in a static location, in an
	 * array with an explicit keys property defined, or in an object literal
	 * with valid key property.
	 *
	 * @internal
	 * @param {ReactNode} node Statically passed child of any type.
	 * @param {*} parentType node's parent's type.
	 */
	function validateChildKeys(node, parentType) {
	  if (Array.isArray(node)) {
	    for (var i = 0; i < node.length; i++) {
	      var child = node[i];
	      if (ReactElement.isValidElement(child)) {
	        validateExplicitKey(child, parentType);
	      }
	    }
	  } else if (ReactElement.isValidElement(node)) {
	    // This element was passed in a valid location.
	    node._store.validated = true;
	  } else if (node) {
	    var iteratorFn = getIteratorFn(node);
	    // Entry iterators provide implicit keys.
	    if (iteratorFn) {
	      if (iteratorFn !== node.entries) {
	        var iterator = iteratorFn.call(node);
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (ReactElement.isValidElement(step.value)) {
	            validateExplicitKey(step.value, parentType);
	          }
	        }
	      }
	    } else if (typeof node === 'object') {
	      var fragment = ReactFragment.extractIfFragment(node);
	      for (var key in fragment) {
	        if (fragment.hasOwnProperty(key)) {
	          validatePropertyKey(key, fragment[key], parentType);
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Assert that the props are valid
	 *
	 * @param {string} componentName Name of the component for error messages.
	 * @param {object} propTypes Map of prop name to a ReactPropType
	 * @param {object} props
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @private
	 */
	function checkPropTypes(componentName, propTypes, props, location) {
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        ( false ? invariant(
	          typeof propTypes[propName] === 'function',
	          '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	          'React.PropTypes.',
	          componentName || 'React class',
	          ReactPropTypeLocationNames[location],
	          propName
	        ) : invariant(typeof propTypes[propName] === 'function'));
	        error = propTypes[propName](props, propName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(this);
	        ( false ? warning(false, 'Failed propType: %s%s', error.message, addendum) : null);
	      }
	    }
	  }
	}
	
	var warnedPropsMutations = {};
	
	/**
	 * Warn about mutating props when setting `propName` on `element`.
	 *
	 * @param {string} propName The string key within props that was set
	 * @param {ReactElement} element
	 */
	function warnForPropsMutation(propName, element) {
	  var type = element.type;
	  var elementName = typeof type === 'string' ? type : type.displayName;
	  var ownerName = element._owner ?
	    element._owner.getPublicInstance().constructor.displayName : null;
	
	  var warningKey = propName + '|' + elementName + '|' + ownerName;
	  if (warnedPropsMutations.hasOwnProperty(warningKey)) {
	    return;
	  }
	  warnedPropsMutations[warningKey] = true;
	
	  var elementInfo = '';
	  if (elementName) {
	    elementInfo = ' <' + elementName + ' />';
	  }
	  var ownerInfo = '';
	  if (ownerName) {
	    ownerInfo = ' The element was created by ' + ownerName + '.';
	  }
	
	  ( false ? warning(
	    false,
	    'Don\'t set .props.%s of the React component%s. Instead, specify the ' +
	    'correct value when initially creating the element or use ' +
	    'React.cloneElement to make a new element with updated props.%s',
	    propName,
	    elementInfo,
	    ownerInfo
	  ) : null);
	}
	
	// Inline Object.is polyfill
	function is(a, b) {
	  if (a !== a) {
	    // NaN
	    return b !== b;
	  }
	  if (a === 0 && b === 0) {
	    // +-0
	    return 1 / a === 1 / b;
	  }
	  return a === b;
	}
	
	/**
	 * Given an element, check if its props have been mutated since element
	 * creation (or the last call to this function). In particular, check if any
	 * new props have been added, which we can't directly catch by defining warning
	 * properties on the props object.
	 *
	 * @param {ReactElement} element
	 */
	function checkAndWarnForMutatedProps(element) {
	  if (!element._store) {
	    // Element was created using `new ReactElement` directly or with
	    // `ReactElement.createElement`; skip mutation checking
	    return;
	  }
	
	  var originalProps = element._store.originalProps;
	  var props = element.props;
	
	  for (var propName in props) {
	    if (props.hasOwnProperty(propName)) {
	      if (!originalProps.hasOwnProperty(propName) ||
	          !is(originalProps[propName], props[propName])) {
	        warnForPropsMutation(propName, element);
	
	        // Copy over the new value so that the two props objects match again
	        originalProps[propName] = props[propName];
	      }
	    }
	  }
	}
	
	/**
	 * Given an element, validate that its props follow the propTypes definition,
	 * provided by the type.
	 *
	 * @param {ReactElement} element
	 */
	function validatePropTypes(element) {
	  if (element.type == null) {
	    // This has already warned. Don't throw.
	    return;
	  }
	  // Extract the component class from the element. Converts string types
	  // to a composite class which may have propTypes.
	  // TODO: Validating a string's propTypes is not decoupled from the
	  // rendering target which is problematic.
	  var componentClass = ReactNativeComponent.getComponentClassForElement(
	    element
	  );
	  var name = componentClass.displayName || componentClass.name;
	  if (componentClass.propTypes) {
	    checkPropTypes(
	      name,
	      componentClass.propTypes,
	      element.props,
	      ReactPropTypeLocations.prop
	    );
	  }
	  if (typeof componentClass.getDefaultProps === 'function') {
	    ( false ? warning(
	      componentClass.getDefaultProps.isReactClassApproved,
	      'getDefaultProps is only used on classic React.createClass ' +
	      'definitions. Use a static property named `defaultProps` instead.'
	    ) : null);
	  }
	}
	
	var ReactElementValidator = {
	
	  checkAndWarnForMutatedProps: checkAndWarnForMutatedProps,
	
	  createElement: function(type, props, children) {
	    // We warn in this case but don't throw. We expect the element creation to
	    // succeed and there will likely be errors in render.
	    ( false ? warning(
	      type != null,
	      'React.createElement: type should not be null or undefined. It should ' +
	        'be a string (for DOM elements) or a ReactClass (for composite ' +
	        'components).'
	    ) : null);
	
	    var element = ReactElement.createElement.apply(this, arguments);
	
	    // The result can be nullish if a mock or a custom function is used.
	    // TODO: Drop this when these are no longer allowed as the type argument.
	    if (element == null) {
	      return element;
	    }
	
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], type);
	    }
	
	    validatePropTypes(element);
	
	    return element;
	  },
	
	  createFactory: function(type) {
	    var validatedFactory = ReactElementValidator.createElement.bind(
	      null,
	      type
	    );
	    // Legacy hook TODO: Warn if this is accessed
	    validatedFactory.type = type;
	
	    if (false) {
	      try {
	        Object.defineProperty(
	          validatedFactory,
	          'type',
	          {
	            enumerable: false,
	            get: function() {
	              ("production" !== process.env.NODE_ENV ? warning(
	                false,
	                'Factory.type is deprecated. Access the class directly ' +
	                'before passing it to createFactory.'
	              ) : null);
	              Object.defineProperty(this, 'type', {
	                value: type
	              });
	              return type;
	            }
	          }
	        );
	      } catch (x) {
	        // IE will fail on defineProperty (es5-shim/sham too)
	      }
	    }
	
	
	    return validatedFactory;
	  },
	
	  cloneElement: function(element, props, children) {
	    var newElement = ReactElement.cloneElement.apply(this, arguments);
	    for (var i = 2; i < arguments.length; i++) {
	      validateChildKeys(arguments[i], newElement.type);
	    }
	    validatePropTypes(newElement);
	    return newElement;
	  }
	
	};
	
	module.exports = ReactElementValidator;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule ReactFragment
	*/
	
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	
	var warning = __webpack_require__(17);
	
	/**
	 * We used to allow keyed objects to serve as a collection of ReactElements,
	 * or nested sets. This allowed us a way to explicitly key a set a fragment of
	 * components. This is now being replaced with an opaque data structure.
	 * The upgrade path is to call React.addons.createFragment({ key: value }) to
	 * create a keyed fragment. The resulting data structure is opaque, for now.
	 */
	
	if (false) {
	  var fragmentKey = '_reactFragment';
	  var didWarnKey = '_reactDidWarn';
	  var canWarnForReactFragment = false;
	
	  try {
	    // Feature test. Don't even try to issue this warning if we can't use
	    // enumerable: false.
	
	    var dummy = function() {
	      return 1;
	    };
	
	    Object.defineProperty(
	      {},
	      fragmentKey,
	      {enumerable: false, value: true}
	    );
	
	    Object.defineProperty(
	      {},
	      'key',
	      {enumerable: true, get: dummy}
	    );
	
	    canWarnForReactFragment = true;
	  } catch (x) { }
	
	  var proxyPropertyAccessWithWarning = function(obj, key) {
	    Object.defineProperty(obj, key, {
	      enumerable: true,
	      get: function() {
	        ("production" !== process.env.NODE_ENV ? warning(
	          this[didWarnKey],
	          'A ReactFragment is an opaque type. Accessing any of its ' +
	          'properties is deprecated. Pass it to one of the React.Children ' +
	          'helpers.'
	        ) : null);
	        this[didWarnKey] = true;
	        return this[fragmentKey][key];
	      },
	      set: function(value) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          this[didWarnKey],
	          'A ReactFragment is an immutable opaque type. Mutating its ' +
	          'properties is deprecated.'
	        ) : null);
	        this[didWarnKey] = true;
	        this[fragmentKey][key] = value;
	      }
	    });
	  };
	
	  var issuedWarnings = {};
	
	  var didWarnForFragment = function(fragment) {
	    // We use the keys and the type of the value as a heuristic to dedupe the
	    // warning to avoid spamming too much.
	    var fragmentCacheKey = '';
	    for (var key in fragment) {
	      fragmentCacheKey += key + ':' + (typeof fragment[key]) + ',';
	    }
	    var alreadyWarnedOnce = !!issuedWarnings[fragmentCacheKey];
	    issuedWarnings[fragmentCacheKey] = true;
	    return alreadyWarnedOnce;
	  };
	}
	
	var ReactFragment = {
	  // Wrap a keyed object in an opaque proxy that warns you if you access any
	  // of its properties.
	  create: function(object) {
	    if (false) {
	      if (typeof object !== 'object' || !object || Array.isArray(object)) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'React.addons.createFragment only accepts a single object.',
	          object
	        ) : null);
	        return object;
	      }
	      if (ReactElement.isValidElement(object)) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'React.addons.createFragment does not accept a ReactElement ' +
	          'without a wrapper object.'
	        ) : null);
	        return object;
	      }
	      if (canWarnForReactFragment) {
	        var proxy = {};
	        Object.defineProperty(proxy, fragmentKey, {
	          enumerable: false,
	          value: object
	        });
	        Object.defineProperty(proxy, didWarnKey, {
	          writable: true,
	          enumerable: false,
	          value: false
	        });
	        for (var key in object) {
	          proxyPropertyAccessWithWarning(proxy, key);
	        }
	        Object.preventExtensions(proxy);
	        return proxy;
	      }
	    }
	    return object;
	  },
	  // Extract the original keyed object from the fragment opaque type. Warn if
	  // a plain object is passed here.
	  extract: function(fragment) {
	    if (false) {
	      if (canWarnForReactFragment) {
	        if (!fragment[fragmentKey]) {
	          ("production" !== process.env.NODE_ENV ? warning(
	            didWarnForFragment(fragment),
	            'Any use of a keyed object should be wrapped in ' +
	            'React.addons.createFragment(object) before being passed as a ' +
	            'child.'
	          ) : null);
	          return fragment;
	        }
	        return fragment[fragmentKey];
	      }
	    }
	    return fragment;
	  },
	  // Check if this is a fragment and if so, extract the keyed object. If it
	  // is a fragment-like object, warn that it should be wrapped. Ignore if we
	  // can't determine what kind of object this is.
	  extractIfFragment: function(fragment) {
	    if (false) {
	      if (canWarnForReactFragment) {
	        // If it is the opaque type, return the keyed object.
	        if (fragment[fragmentKey]) {
	          return fragment[fragmentKey];
	        }
	        // Otherwise, check each property if it has an element, if it does
	        // it is probably meant as a fragment, so we can warn early. Defer,
	        // the warning to extract.
	        for (var key in fragment) {
	          if (fragment.hasOwnProperty(key) &&
	              ReactElement.isValidElement(fragment[key])) {
	            // This looks like a fragment object, we should provide an
	            // early warning.
	            return ReactFragment.extract(fragment);
	          }
	        }
	      }
	    }
	    return fragment;
	  }
	};
	
	module.exports = ReactFragment;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(101);
	
	var getEventTarget = __webpack_require__(257);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function(event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target != null && target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function(event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyMirror
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function(obj) {
	  var ret = {};
	  var key;
	  ( false ? invariant(
	    obj instanceof Object && !Array.isArray(obj),
	    'keyMirror(...): Argument must be an object.'
	  ) : invariant(obj instanceof Object && !Array.isArray(obj)));
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var t = __webpack_require__(929);
	var stringify = t.stringify;
	
	var ValidationError = t.struct({
	  message: t.Str,
	  actual: t.Any,
	  expected: t.Any,
	  path: t.list(t.union([t.Str, t.Num]))
	}, 'ValidationError');
	
	function getDefaultValidationErrorMessage(actual, expected, path) {
	  var expectedName = t.getTypeName(expected);
	  var to = path.length ? '/' + path.join('/') + ': ' + expectedName : expectedName;
	  return 'Invalid value ' + stringify(actual) + ' supplied to ' + to;
	}
	
	function getValidationErrorMessage(actual, expected, path, context) {
	  if (t.Function.is(expected.getValidationErrorMessage)) {
	    return expected.getValidationErrorMessage(actual, path, context);
	  }
	  else {
	    return getDefaultValidationErrorMessage(actual, expected, path);
	  }
	}
	
	ValidationError.of = function (actual, expected, path, context) {
	  return new ValidationError({
	    message: getValidationErrorMessage(actual, expected, path, context),
	    actual: actual,
	    expected: expected,
	    path: path
	  });
	};
	
	var ValidationResult = t.struct({
	  errors: t.list(ValidationError),
	  value: t.Any
	}, 'ValidationResult');
	
	ValidationResult.prototype.isValid = function () {
	  return !(this.errors.length);
	};
	
	ValidationResult.prototype.firstError = function () {
	  return this.isValid() ? null : this.errors[0];
	};
	
	ValidationResult.prototype.toString = function () {
	  if (this.isValid()) {
	    return '[ValidationResult, true, ' + stringify(this.value) + ']';
	  }
	  else {
	    return '[ValidationResult, false, (' + this.errors.map(function (err) {
	      return err.message;
	    }).join(', ') + ')]';
	  }
	};
	
	function validate(x, type, options) {
	  options = options || {};
	  var path = t.Array.is(options) ? options : options.path || [];
	  return new ValidationResult(recurse(x, type, path, options));
	}
	
	function recurse(x, type, path, options) {
	  if (t.isType(type)) {
	    return validators[type.meta.kind](x, type, path, options);
	  }
	  else {
	    return validators.es6classes(x, type, path, options);
	  }
	}
	
	var validators = validate.validators = {};
	
	validators.es6classes = function validateES6Classes(x, type, path, options) {
	  return {
	    value: x,
	    errors: x instanceof type ? [] : [ValidationError.of(x, type, path, options.context)]
	  };
	};
	
	// irreducibles and enums
	validators.irreducible =
	validators.enums = function validateIrreducible(x, type, path, options) {
	  return {
	    value: x,
	    errors: type.is(x) ? [] : [ValidationError.of(x, type, path, options.context)]
	  };
	};
	
	validators.list = function validateList(x, type, path, options) {
	
	  // x should be an array
	  if (!t.Arr.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	  }
	
	  var ret = {value: [], errors: []};
	  // every item should be of type `type.meta.type`
	  for (var i = 0, len = x.length; i < len; i++ ) {
	    var item = recurse(x[i], type.meta.type, path.concat(i), options);
	    ret.value[i] = item.value;
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	validators.subtype = function validateSubtype(x, type, path, options) {
	
	  // x should be a valid inner type
	  var ret = recurse(x, type.meta.type, path, options);
	  if (ret.errors.length) {
	    return ret;
	  }
	
	  // x should satisfy the predicate
	  if (!type.meta.predicate(ret.value)) {
	    ret.errors = [ValidationError.of(x, type, path, options.context)];
	  }
	
	  return ret;
	
	};
	
	validators.maybe = function validateMaybe(x, type, path, options) {
	  return t.Nil.is(x) ?
	    {value: null, errors: []} :
	    recurse(x, type.meta.type, path, options);
	};
	
	validators.struct = function validateStruct(x, type, path, options) {
	
	  // x should be an object
	  if (!t.Obj.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	  }
	
	  // [optimization]
	  if (type.is(x)) {
	    return {value: x, errors: []};
	  }
	
	  var ret = {value: {}, errors: []};
	  var props = type.meta.props;
	  // every item should be of type `props[name]`
	  for (var name in props) {
	    if (props.hasOwnProperty(name)) {
	      var prop = recurse(x[name], props[name], path.concat(name), options);
	      ret.value[name] = prop.value;
	      ret.errors = ret.errors.concat(prop.errors);
	    }
	  }
	  if (options.strict) {
	    for (var field in x) {
	      if (x.hasOwnProperty(field) && !props.hasOwnProperty(field) && !t.Nil.is(x[field])) {
	        ret.errors.push(ValidationError.of(x[field], t.Nil, path.concat(field), options.context));
	      }
	    }
	  }
	  if (!ret.errors.length) {
	    ret.value = new type(ret.value);
	  }
	  return ret;
	};
	
	validators.tuple = function validateTuple(x, type, path, options) {
	
	  var types = type.meta.types;
	  var len = types.length;
	
	  // x should be an array of at most `len` items
	  if (!t.Arr.is(x) || x.length > len) {
	    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	  }
	
	  var ret = {value: [], errors: []};
	  // every item should be of type `types[i]`
	  for (var i = 0; i < len; i++) {
	    var item = recurse(x[i], types[i], path.concat(i), options);
	    ret.value[i] = item.value;
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	validators.dict = function validateDict(x, type, path, options) {
	
	  // x should be an object
	  if (!t.Obj.is(x)) {
	    return {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	  }
	
	  var ret = {value: {}, errors: []};
	  // every key should be of type `domain`
	  // every value should be of type `codomain`
	  for (var k in x) {
	    if (x.hasOwnProperty(k)) {
	      var subpath = path.concat(k);
	      var key = recurse(k, type.meta.domain, subpath, options);
	      var item = recurse(x[k], type.meta.codomain, subpath, options);
	      ret.value[k] = item.value;
	      ret.errors = ret.errors.concat(key.errors, item.errors);
	    }
	  }
	  return ret;
	};
	
	validators.union = function validateUnion(x, type, path, options) {
	  var ctor = type.dispatch(x);
	  return t.Func.is(ctor) ?
	    recurse(x, ctor, path.concat(type.meta.types.indexOf(ctor)), options) :
	    {value: x, errors: [ValidationError.of(x, type, path, options.context)]};
	};
	
	validators.intersection = function validateIntersection(x, type, path, options) {
	
	  var types = type.meta.types;
	  var len = types.length;
	
	  var ret = {value: x, errors: []};
	  // x should be of type `types[i]` for all i
	  for (var i = 0; i < len; i++) {
	    var item = recurse(x, types[i], path, options);
	    ret.errors = ret.errors.concat(item.errors);
	  }
	  return ret;
	};
	
	t.mixin(t, {
	  ValidationError: ValidationError,
	  ValidationResult: ValidationResult,
	  validate: validate
	});
	
	module.exports = t;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var getTypeName = __webpack_require__(37);
	
	module.exports = function forbidNewOperator(x, type) {
	  assert(!(x instanceof type), function () { return 'Cannot use the new operator to instantiate the type ' + getTypeName(type); });
	};

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _clickableComponent = __webpack_require__(141);
	
	var _clickableComponent2 = _interopRequireDefault(_clickableComponent);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _obj = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Base class for all buttons.
	 *
	 * @extends ClickableComponent
	 */
	var Button = function (_ClickableComponent) {
	  _inherits(Button, _ClickableComponent);
	
	  function Button() {
	    _classCallCheck(this, Button);
	
	    return _possibleConstructorReturn(this, _ClickableComponent.apply(this, arguments));
	  }
	
	  /**
	   * Create the `Button`s DOM element.
	   *
	   * @param {string} [tag=button]
	   *        Element's node type. e.g. 'button'
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element.
	   *
	   * @param {Object} [attributes={}]
	   *        An object of attributes that should be set on the element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	  Button.prototype.createEl = function createEl() {
	    var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'button';
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    props = (0, _obj.assign)({
	      className: this.buildCSSClass()
	    }, props);
	
	    if (tag !== 'button') {
	      _log2['default'].warn('Creating a Button with an HTML element of ' + tag + ' is deprecated; use ClickableComponent instead.');
	
	      // Add properties for clickable element which is not a native HTML button
	      props = (0, _obj.assign)({
	        tabIndex: 0
	      }, props);
	
	      // Add ARIA attributes for clickable element which is not a native HTML button
	      attributes = (0, _obj.assign)({
	        role: 'button'
	      }, attributes);
	    }
	
	    // Add attributes for button element
	    attributes = (0, _obj.assign)({
	
	      // Necessary since the default button type is "submit"
	      'type': 'button',
	
	      // let the screen reader user know that the text of the button may change
	      'aria-live': 'polite'
	    }, attributes);
	
	    var el = _component2['default'].prototype.createEl.call(this, tag, props, attributes);
	
	    this.createControlTextEl(el);
	
	    return el;
	  };
	
	  /**
	   * Add a child `Component` inside of this `Button`.
	   *
	   * @param {string|Component} child
	   *        The name or instance of a child to add.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of options that will get passed to children of
	   *        the child.
	   *
	   * @return {Component}
	   *         The `Component` that gets added as a child. When using a string the
	   *         `Component` will get created by this process.
	   *
	   * @deprecated since version 5
	   */
	
	
	  Button.prototype.addChild = function addChild(child) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var className = this.constructor.name;
	
	    _log2['default'].warn('Adding an actionable (user controllable) child to a Button (' + className + ') is not supported; use a ClickableComponent instead.');
	
	    // Avoid the error message generated by ClickableComponent's addChild method
	    return _component2['default'].prototype.addChild.call(this, child, options);
	  };
	
	  /**
	   * Enable the `Button` element so that it can be activated or clicked. Use this with
	   * {@link Button#disable}.
	   */
	
	
	  Button.prototype.enable = function enable() {
	    _ClickableComponent.prototype.enable.call(this);
	    this.el_.removeAttribute('disabled');
	  };
	
	  /**
	   * Enable the `Button` element so that it cannot be activated or clicked. Use this with
	   * {@link Button#enable}.
	   */
	
	
	  Button.prototype.disable = function disable() {
	    _ClickableComponent.prototype.disable.call(this);
	    this.el_.setAttribute('disabled', 'disabled');
	  };
	
	  /**
	   * This gets called when a `Button` has focus and `keydown` is triggered via a key
	   * press.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to get called.
	   *
	   * @listens keydown
	   */
	
	
	  Button.prototype.handleKeyPress = function handleKeyPress(event) {
	
	    // Ignore Space (32) or Enter (13) key operation, which is handled by the browser for a button.
	    if (event.which === 32 || event.which === 13) {
	      return;
	    }
	
	    // Pass keypress handling up for unsupported keys
	    _ClickableComponent.prototype.handleKeyPress.call(this, event);
	  };
	
	  return Button;
	}(_clickableComponent2['default']);
	
	_component2['default'].registerComponent('Button', Button);
	exports['default'] = Button;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _events = __webpack_require__(83);
	
	var Events = _interopRequireWildcard(_events);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _obj = __webpack_require__(31);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Clickable Component which is clickable or keyboard actionable,
	 * but is not a native HTML button.
	 *
	 * @extends Component
	 */
	var ClickableComponent = function (_Component) {
	  _inherits(ClickableComponent, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of player options.
	   */
	  function ClickableComponent(player, options) {
	    _classCallCheck(this, ClickableComponent);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.emitTapEvents();
	
	    _this.enable();
	    return _this;
	  }
	
	  /**
	   * Create the `Component`s DOM element.
	   *
	   * @param {string} [tag=div]
	   *        The element's node type.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element.
	   *
	   * @param {Object} [attributes={}]
	   *        An object of attributes that should be set on the element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  ClickableComponent.prototype.createEl = function createEl() {
	    var tag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'div';
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    props = (0, _obj.assign)({
	      className: this.buildCSSClass(),
	      tabIndex: 0
	    }, props);
	
	    if (tag === 'button') {
	      _log2['default'].error('Creating a ClickableComponent with an HTML element of ' + tag + ' is not supported; use a Button instead.');
	    }
	
	    // Add ARIA attributes for clickable element which is not a native HTML button
	    attributes = (0, _obj.assign)({
	      'role': 'button',
	
	      // let the screen reader user know that the text of the element may change
	      'aria-live': 'polite'
	    }, attributes);
	
	    this.tabIndex_ = props.tabIndex;
	
	    var el = _Component.prototype.createEl.call(this, tag, props, attributes);
	
	    this.createControlTextEl(el);
	
	    return el;
	  };
	
	  /**
	   * Create a control text element on this `Component`
	   *
	   * @param {Element} [el]
	   *        Parent element for the control text.
	   *
	   * @return {Element}
	   *         The control text element that gets created.
	   */
	
	
	  ClickableComponent.prototype.createControlTextEl = function createControlTextEl(el) {
	    this.controlTextEl_ = Dom.createEl('span', {
	      className: 'vjs-control-text'
	    });
	
	    if (el) {
	      el.appendChild(this.controlTextEl_);
	    }
	
	    this.controlText(this.controlText_, el);
	
	    return this.controlTextEl_;
	  };
	
	  /**
	   * Get or set the localize text to use for the controls on the `Component`.
	   *
	   * @param {string} [text]
	   *        Control text for element.
	   *
	   * @param {Element} [el=this.el()]
	   *        Element to set the title on.
	   *
	   * @return {string|ClickableComponent}
	   *         - The control text when getting
	   *         - Returns itself when setting; method can be chained.
	   */
	
	
	  ClickableComponent.prototype.controlText = function controlText(text) {
	    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.el();
	
	    if (text === undefined) {
	      return this.controlText_ || 'Need Text';
	    }
	
	    var localizedText = this.localize(text);
	
	    this.controlText_ = text;
	    this.controlTextEl_.innerHTML = localizedText;
	
	    if (!this.nonIconControl) {
	      // Set title attribute if only an icon is shown
	      el.setAttribute('title', localizedText);
	    }
	
	    return this;
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  ClickableComponent.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-control vjs-button ' + _Component.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Enable this `Component`s element.
	   *
	   * @return {ClickableComponent}
	   *         Returns itself; method can be chained.
	   */
	
	
	  ClickableComponent.prototype.enable = function enable() {
	    this.removeClass('vjs-disabled');
	    this.el_.setAttribute('aria-disabled', 'false');
	    if (typeof this.tabIndex_ !== 'undefined') {
	      this.el_.setAttribute('tabIndex', this.tabIndex_);
	    }
	    this.off(['tap', 'click'], this.handleClick);
	    this.off('focus', this.handleFocus);
	    this.off('blur', this.handleBlur);
	    this.on(['tap', 'click'], this.handleClick);
	    this.on('focus', this.handleFocus);
	    this.on('blur', this.handleBlur);
	    return this;
	  };
	
	  /**
	   * Disable this `Component`s element.
	   *
	   * @return {ClickableComponent}
	   *         Returns itself; method can be chained.
	   */
	
	
	  ClickableComponent.prototype.disable = function disable() {
	    this.addClass('vjs-disabled');
	    this.el_.setAttribute('aria-disabled', 'true');
	    if (typeof this.tabIndex_ !== 'undefined') {
	      this.el_.removeAttribute('tabIndex');
	    }
	    this.off(['tap', 'click'], this.handleClick);
	    this.off('focus', this.handleFocus);
	    this.off('blur', this.handleBlur);
	    return this;
	  };
	
	  /**
	   * This gets called when a `ClickableComponent` gets:
	   * - Clicked (via the `click` event, listening starts in the constructor)
	   * - Tapped (via the `tap` event, listening starts in the constructor)
	   * - The following things happen in order:
	   *   1. {@link ClickableComponent#handleFocus} is called via a `focus` event on the
	   *      `ClickableComponent`.
	   *   2. {@link ClickableComponent#handleFocus} adds a listener for `keydown` on using
	   *      {@link ClickableComponent#handleKeyPress}.
	   *   3. `ClickableComponent` has not had a `blur` event (`blur` means that focus was lost). The user presses
	   *      the space or enter key.
	   *   4. {@link ClickableComponent#handleKeyPress} calls this function with the `keydown`
	   *      event as a parameter.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   * @abstract
	   */
	
	
	  ClickableComponent.prototype.handleClick = function handleClick(event) {};
	
	  /**
	   * This gets called when a `ClickableComponent` gains focus via a `focus` event.
	   * Turns on listening for `keydown` events. When they happen it
	   * calls `this.handleKeyPress`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `focus` event that caused this function to be called.
	   *
	   * @listens focus
	   */
	
	
	  ClickableComponent.prototype.handleFocus = function handleFocus(event) {
	    Events.on(_document2['default'], 'keydown', Fn.bind(this, this.handleKeyPress));
	  };
	
	  /**
	   * Called when this ClickableComponent has focus and a key gets pressed down. By
	   * default it will call `this.handleClick` when the key is space or enter.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	
	
	  ClickableComponent.prototype.handleKeyPress = function handleKeyPress(event) {
	
	    // Support Space (32) or Enter (13) key operation to fire a click event
	    if (event.which === 32 || event.which === 13) {
	      event.preventDefault();
	      this.handleClick(event);
	    } else if (_Component.prototype.handleKeyPress) {
	
	      // Pass keypress handling up for unsupported keys
	      _Component.prototype.handleKeyPress.call(this, event);
	    }
	  };
	
	  /**
	   * Called when a `ClickableComponent` loses focus. Turns off the listener for
	   * `keydown` events. Which Stops `this.handleKeyPress` from getting called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `blur` event that caused this function to be called.
	   *
	   * @listens blur
	   */
	
	
	  ClickableComponent.prototype.handleBlur = function handleBlur(event) {
	    Events.off(_document2['default'], 'keydown', Fn.bind(this, this.handleKeyPress));
	  };
	
	  return ClickableComponent;
	}(_component2['default']);
	
	_component2['default'].registerComponent('ClickableComponent', ClickableComponent);
	exports['default'] = ClickableComponent;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _htmlTrackElement = __webpack_require__(1019);
	
	var _htmlTrackElement2 = _interopRequireDefault(_htmlTrackElement);
	
	var _htmlTrackElementList = __webpack_require__(1018);
	
	var _htmlTrackElementList2 = _interopRequireDefault(_htmlTrackElementList);
	
	var _mergeOptions = __webpack_require__(76);
	
	var _mergeOptions2 = _interopRequireDefault(_mergeOptions);
	
	var _textTrack = __webpack_require__(265);
	
	var _textTrack2 = _interopRequireDefault(_textTrack);
	
	var _textTrackList = __webpack_require__(1023);
	
	var _textTrackList2 = _interopRequireDefault(_textTrackList);
	
	var _videoTrackList = __webpack_require__(429);
	
	var _videoTrackList2 = _interopRequireDefault(_videoTrackList);
	
	var _audioTrackList = __webpack_require__(428);
	
	var _audioTrackList2 = _interopRequireDefault(_audioTrackList);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _timeRanges = __webpack_require__(143);
	
	var _buffer = __webpack_require__(430);
	
	var _mediaError = __webpack_require__(422);
	
	var _mediaError2 = _interopRequireDefault(_mediaError);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _obj = __webpack_require__(31);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file tech.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * An Object containing a structure like: `{src: 'url', type: 'mimetype'}` or string
	 * that just contains the src url alone.
	 * * `var SourceObject = {src: 'http://ex.com/video.mp4', type: 'video/mp4'};`
	   * `var SourceString = 'http://example.com/some-video.mp4';`
	 *
	 * @typedef {Object|string} Tech~SourceObject
	 *
	 * @property {string} src
	 *           The url to the source
	 *
	 * @property {string} type
	 *           The mime type of the source
	 */
	
	/**
	 * A function used by {@link Tech} to create a new {@link TextTrack}.
	 *
	 * @param {Tech} self
	 *        An instance of the Tech class.
	 *
	 * @param {string} kind
	 *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	 *
	 * @param {string} [label]
	 *        Label to identify the text track
	 *
	 * @param {string} [language]
	 *        Two letter language abbreviation
	 *
	 * @param {Object} [options={}]
	 *        An object with additional text track options
	 *
	 * @return {TextTrack}
	 *          The text track that was created.
	 */
	function createTrackHelper(self, kind, label, language) {
	  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
	
	  var tracks = self.textTracks();
	
	  options.kind = kind;
	
	  if (label) {
	    options.label = label;
	  }
	  if (language) {
	    options.language = language;
	  }
	  options.tech = self;
	
	  var track = new _textTrack2['default'](options);
	
	  tracks.addTrack_(track);
	
	  return track;
	}
	
	/**
	 * This is the base class for media playback technology controllers, such as
	 * {@link Flash} and {@link HTML5}
	 *
	 * @extends Component
	 */
	
	var Tech = function (_Component) {
	  _inherits(Tech, _Component);
	
	  /**
	   * Create an instance of this Tech.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} ready
	   *        Callback function to call when the `HTML5` Tech is ready.
	   */
	  function Tech() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var ready = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	    _classCallCheck(this, Tech);
	
	    // we don't want the tech to report user activity automatically.
	    // This is done manually in addControlsListeners
	    options.reportTouchActivity = false;
	
	    // keep track of whether the current source has played at all to
	    // implement a very limited played()
	    var _this = _possibleConstructorReturn(this, _Component.call(this, null, options, ready));
	
	    _this.hasStarted_ = false;
	    _this.on('playing', function () {
	      this.hasStarted_ = true;
	    });
	    _this.on('loadstart', function () {
	      this.hasStarted_ = false;
	    });
	
	    _this.textTracks_ = options.textTracks;
	    _this.videoTracks_ = options.videoTracks;
	    _this.audioTracks_ = options.audioTracks;
	
	    // Manually track progress in cases where the browser/flash player doesn't report it.
	    if (!_this.featuresProgressEvents) {
	      _this.manualProgressOn();
	    }
	
	    // Manually track timeupdates in cases where the browser/flash player doesn't report it.
	    if (!_this.featuresTimeupdateEvents) {
	      _this.manualTimeUpdatesOn();
	    }
	
	    ['Text', 'Audio', 'Video'].forEach(function (track) {
	      if (options['native' + track + 'Tracks'] === false) {
	        _this['featuresNative' + track + 'Tracks'] = false;
	      }
	    });
	
	    if (options.nativeCaptions === false) {
	      _this.featuresNativeTextTracks = false;
	    }
	
	    if (!_this.featuresNativeTextTracks) {
	      _this.emulateTextTracks();
	    }
	
	    _this.autoRemoteTextTracks_ = new _textTrackList2['default']();
	
	    _this.initTextTrackListeners();
	    _this.initTrackListeners();
	
	    // Turn on component tap events only if not using native controls
	    if (!options.nativeControlsForTouch) {
	      _this.emitTapEvents();
	    }
	
	    if (_this.constructor) {
	      _this.name_ = _this.constructor.name || 'Unknown Tech';
	    }
	    return _this;
	  }
	
	  /* Fallbacks for unsupported event types
	  ================================================================================ */
	
	  /**
	   * Polyfill the `progress` event for browsers that don't support it natively.
	   *
	   * @see {@link Tech#trackProgress}
	   */
	
	
	  Tech.prototype.manualProgressOn = function manualProgressOn() {
	    this.on('durationchange', this.onDurationChange);
	
	    this.manualProgress = true;
	
	    // Trigger progress watching when a source begins loading
	    this.one('ready', this.trackProgress);
	  };
	
	  /**
	   * Turn off the polyfill for `progress` events that was created in
	   * {@link Tech#manualProgressOn}
	   */
	
	
	  Tech.prototype.manualProgressOff = function manualProgressOff() {
	    this.manualProgress = false;
	    this.stopTrackingProgress();
	
	    this.off('durationchange', this.onDurationChange);
	  };
	
	  /**
	   * This is used to trigger a `progress` event when the buffered percent changes. It
	   * sets an interval function that will be called every 500 milliseconds to check if the
	   * buffer end percent has changed.
	   *
	   * > This function is called by {@link Tech#manualProgressOn}
	   *
	   * @param {EventTarget~Event} event
	   *        The `ready` event that caused this to run.
	   *
	   * @listens Tech#ready
	   * @fires Tech#progress
	   */
	
	
	  Tech.prototype.trackProgress = function trackProgress(event) {
	    this.stopTrackingProgress();
	    this.progressInterval = this.setInterval(Fn.bind(this, function () {
	      // Don't trigger unless buffered amount is greater than last time
	
	      var numBufferedPercent = this.bufferedPercent();
	
	      if (this.bufferedPercent_ !== numBufferedPercent) {
	        /**
	         * See {@link Player#progress}
	         *
	         * @event Tech#progress
	         * @type {EventTarget~Event}
	         */
	        this.trigger('progress');
	      }
	
	      this.bufferedPercent_ = numBufferedPercent;
	
	      if (numBufferedPercent === 1) {
	        this.stopTrackingProgress();
	      }
	    }), 500);
	  };
	
	  /**
	   * Update our internal duration on a `durationchange` event by calling
	   * {@link Tech#duration}.
	   *
	   * @param {EventTarget~Event} event
	   *        The `durationchange` event that caused this to run.
	   *
	   * @listens Tech#durationchange
	   */
	
	
	  Tech.prototype.onDurationChange = function onDurationChange(event) {
	    this.duration_ = this.duration();
	  };
	
	  /**
	   * Get and create a `TimeRange` object for buffering.
	   *
	   * @return {TimeRange}
	   *         The time range object that was created.
	   */
	
	
	  Tech.prototype.buffered = function buffered() {
	    return (0, _timeRanges.createTimeRange)(0, 0);
	  };
	
	  /**
	   * Get the percentage of the current video that is currently buffered.
	   *
	   * @return {number}
	   *         A number from 0 to 1 that represents the decimal percentage of the
	   *         video that is buffered.
	   *
	   */
	
	
	  Tech.prototype.bufferedPercent = function bufferedPercent() {
	    return (0, _buffer.bufferedPercent)(this.buffered(), this.duration_);
	  };
	
	  /**
	   * Turn off the polyfill for `progress` events that was created in
	   * {@link Tech#manualProgressOn}
	   * Stop manually tracking progress events by clearing the interval that was set in
	   * {@link Tech#trackProgress}.
	   */
	
	
	  Tech.prototype.stopTrackingProgress = function stopTrackingProgress() {
	    this.clearInterval(this.progressInterval);
	  };
	
	  /**
	   * Polyfill the `timeupdate` event for browsers that don't support it.
	   *
	   * @see {@link Tech#trackCurrentTime}
	   */
	
	
	  Tech.prototype.manualTimeUpdatesOn = function manualTimeUpdatesOn() {
	    this.manualTimeUpdates = true;
	
	    this.on('play', this.trackCurrentTime);
	    this.on('pause', this.stopTrackingCurrentTime);
	  };
	
	  /**
	   * Turn off the polyfill for `timeupdate` events that was created in
	   * {@link Tech#manualTimeUpdatesOn}
	   */
	
	
	  Tech.prototype.manualTimeUpdatesOff = function manualTimeUpdatesOff() {
	    this.manualTimeUpdates = false;
	    this.stopTrackingCurrentTime();
	    this.off('play', this.trackCurrentTime);
	    this.off('pause', this.stopTrackingCurrentTime);
	  };
	
	  /**
	   * Sets up an interval function to track current time and trigger `timeupdate` every
	   * 250 milliseconds.
	   *
	   * @listens Tech#play
	   * @triggers Tech#timeupdate
	   */
	
	
	  Tech.prototype.trackCurrentTime = function trackCurrentTime() {
	    if (this.currentTimeInterval) {
	      this.stopTrackingCurrentTime();
	    }
	    this.currentTimeInterval = this.setInterval(function () {
	      /**
	       * Triggered at an interval of 250ms to indicated that time is passing in the video.
	       *
	       * @event Tech#timeupdate
	       * @type {EventTarget~Event}
	       */
	      this.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });
	
	      // 42 = 24 fps // 250 is what Webkit uses // FF uses 15
	    }, 250);
	  };
	
	  /**
	   * Stop the interval function created in {@link Tech#trackCurrentTime} so that the
	   * `timeupdate` event is no longer triggered.
	   *
	   * @listens {Tech#pause}
	   */
	
	
	  Tech.prototype.stopTrackingCurrentTime = function stopTrackingCurrentTime() {
	    this.clearInterval(this.currentTimeInterval);
	
	    // #1002 - if the video ends right before the next timeupdate would happen,
	    // the progress bar won't make it all the way to the end
	    this.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });
	  };
	
	  /**
	   * Turn off all event polyfills, clear the `Tech`s {@link AudioTrackList},
	   * {@link VideoTrackList}, and {@link TextTrackList}, and dispose of this Tech.
	   *
	   * @fires Component#dispose
	   */
	
	
	  Tech.prototype.dispose = function dispose() {
	
	    // clear out all tracks because we can't reuse them between techs
	    this.clearTracks(['audio', 'video', 'text']);
	
	    // Turn off any manual progress or timeupdate tracking
	    if (this.manualProgress) {
	      this.manualProgressOff();
	    }
	
	    if (this.manualTimeUpdates) {
	      this.manualTimeUpdatesOff();
	    }
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  /**
	   * Clear out a single `TrackList` or an array of `TrackLists` given their names.
	   *
	   * > Note: Techs without source handlers should call this between sources for `video`
	   *         & `audio` tracks. You don't want to use them between tracks!
	   *
	   * @param {string[]|string} types
	   *        TrackList names to clear, valid names are `video`, `audio`, and
	   *        `text`.
	   */
	
	
	  Tech.prototype.clearTracks = function clearTracks(types) {
	    var _this2 = this;
	
	    types = [].concat(types);
	    // clear out all tracks because we can't reuse them between techs
	    types.forEach(function (type) {
	      var list = _this2[type + 'Tracks']() || [];
	      var i = list.length;
	
	      while (i--) {
	        var track = list[i];
	
	        if (type === 'text') {
	          _this2.removeRemoteTextTrack(track);
	        }
	        list.removeTrack_(track);
	      }
	    });
	  };
	
	  /**
	   * Remove any TextTracks added via addRemoteTextTrack that are
	   * flagged for automatic garbage collection
	   */
	
	
	  Tech.prototype.cleanupAutoTextTracks = function cleanupAutoTextTracks() {
	    var list = this.autoRemoteTextTracks_ || [];
	    var i = list.length;
	
	    while (i--) {
	      var track = list[i];
	
	      this.removeRemoteTextTrack(track);
	    }
	  };
	
	  /**
	   * Reset the tech, which will removes all sources and reset the internal readyState.
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.reset = function reset() {};
	
	  /**
	   * Get or set an error on the Tech.
	   *
	   * @param {MediaError} [err]
	   *        Error to set on the Tech
	   *
	   * @return {MediaError|null}
	   *         The current error object on the tech, or null if there isn't one.
	   */
	
	
	  Tech.prototype.error = function error(err) {
	    if (err !== undefined) {
	      this.error_ = new _mediaError2['default'](err);
	      this.trigger('error');
	    }
	    return this.error_;
	  };
	
	  /**
	   * Returns the `TimeRange`s that have been played through for the current source.
	   *
	   * > NOTE: This implementation is incomplete. It does not track the played `TimeRange`.
	   *         It only checks wether the source has played at all or not.
	   *
	   * @return {TimeRange}
	   *         - A single time range if this video has played
	   *         - An empty set of ranges if not.
	   */
	
	
	  Tech.prototype.played = function played() {
	    if (this.hasStarted_) {
	      return (0, _timeRanges.createTimeRange)(0, 0);
	    }
	    return (0, _timeRanges.createTimeRange)();
	  };
	
	  /**
	   * Causes a manual time update to occur if {@link Tech#manualTimeUpdatesOn} was
	   * previously called.
	   *
	   * @fires Tech#timeupdate
	   */
	
	
	  Tech.prototype.setCurrentTime = function setCurrentTime() {
	    // improve the accuracy of manual timeupdates
	    if (this.manualTimeUpdates) {
	      /**
	       * A manual `timeupdate` event.
	       *
	       * @event Tech#timeupdate
	       * @type {EventTarget~Event}
	       */
	      this.trigger({ type: 'timeupdate', target: this, manuallyTriggered: true });
	    }
	  };
	
	  /**
	   * Turn on listeners for {@link TextTrackList} events. This adds
	   * {@link EventTarget~EventListeners} for `texttrackchange`, `addtrack` and
	   * `removetrack`.
	   *
	   * @fires Tech#texttrackchange
	   */
	
	
	  Tech.prototype.initTextTrackListeners = function initTextTrackListeners() {
	    var textTrackListChanges = Fn.bind(this, function () {
	      /**
	       * Triggered when tracks are added or removed on the Tech {@link TextTrackList}
	       *
	       * @event Tech#texttrackchange
	       * @type {EventTarget~Event}
	       */
	      this.trigger('texttrackchange');
	    });
	
	    var tracks = this.textTracks();
	
	    if (!tracks) {
	      return;
	    }
	
	    tracks.addEventListener('removetrack', textTrackListChanges);
	    tracks.addEventListener('addtrack', textTrackListChanges);
	
	    this.on('dispose', Fn.bind(this, function () {
	      tracks.removeEventListener('removetrack', textTrackListChanges);
	      tracks.removeEventListener('addtrack', textTrackListChanges);
	    }));
	  };
	
	  /**
	   * Turn on listeners for {@link VideoTrackList} and {@link {AudioTrackList} events.
	   * This adds {@link EventTarget~EventListeners} for `addtrack`, and  `removetrack`.
	   *
	   * @fires Tech#audiotrackchange
	   * @fires Tech#videotrackchange
	   */
	
	
	  Tech.prototype.initTrackListeners = function initTrackListeners() {
	    var _this3 = this;
	
	    var trackTypes = ['video', 'audio'];
	
	    trackTypes.forEach(function (type) {
	      /**
	       * Triggered when tracks are added or removed on the Tech {@link AudioTrackList}
	       *
	       * @event Tech#audiotrackchange
	       * @type {EventTarget~Event}
	       */
	
	      /**
	       * Triggered when tracks are added or removed on the Tech {@link VideoTrackList}
	       *
	       * @event Tech#videotrackchange
	       * @type {EventTarget~Event}
	       */
	      var trackListChanges = function trackListChanges() {
	        _this3.trigger(type + 'trackchange');
	      };
	
	      var tracks = _this3[type + 'Tracks']();
	
	      tracks.addEventListener('removetrack', trackListChanges);
	      tracks.addEventListener('addtrack', trackListChanges);
	
	      _this3.on('dispose', function () {
	        tracks.removeEventListener('removetrack', trackListChanges);
	        tracks.removeEventListener('addtrack', trackListChanges);
	      });
	    });
	  };
	
	  /**
	   * Emulate TextTracks using vtt.js if necessary
	   *
	   * @fires Tech#vttjsloaded
	   * @fires Tech#vttjserror
	   */
	
	
	  Tech.prototype.addWebVttScript_ = function addWebVttScript_() {
	    var _this4 = this;
	
	    if (_window2['default'].WebVTT) {
	      return;
	    }
	
	    // Initially, Tech.el_ is a child of a dummy-div wait until the Component system
	    // signals that the Tech is ready at which point Tech.el_ is part of the DOM
	    // before inserting the WebVTT script
	    if (_document2['default'].body.contains(this.el())) {
	      var vtt = __webpack_require__(1027);
	
	      // load via require if available and vtt.js script location was not passed in
	      // as an option. novtt builds will turn the above require call into an empty object
	      // which will cause this if check to always fail.
	      if (!this.options_['vtt.js'] && (0, _obj.isPlain)(vtt) && Object.keys(vtt).length > 0) {
	        this.trigger('vttjsloaded');
	        return;
	      }
	
	      // load vtt.js via the script location option or the cdn of no location was
	      // passed in
	      var script = _document2['default'].createElement('script');
	
	      script.src = this.options_['vtt.js'] || 'https://vjs.zencdn.net/vttjs/0.12.4/vtt.min.js';
	      script.onload = function () {
	        /**
	         * Fired when vtt.js is loaded.
	         *
	         * @event Tech#vttjsloaded
	         * @type {EventTarget~Event}
	         */
	        _this4.trigger('vttjsloaded');
	      };
	      script.onerror = function () {
	        /**
	         * Fired when vtt.js was not loaded due to an error
	         *
	         * @event Tech#vttjsloaded
	         * @type {EventTarget~Event}
	         */
	        _this4.trigger('vttjserror');
	      };
	      this.on('dispose', function () {
	        script.onload = null;
	        script.onerror = null;
	      });
	      // but have not loaded yet and we set it to true before the inject so that
	      // we don't overwrite the injected window.WebVTT if it loads right away
	      _window2['default'].WebVTT = true;
	      this.el().parentNode.appendChild(script);
	    } else {
	      this.ready(this.addWebVttScript_);
	    }
	  };
	
	  /**
	   * Emulate texttracks
	   *
	   * @method emulateTextTracks
	   */
	
	
	  Tech.prototype.emulateTextTracks = function emulateTextTracks() {
	    var _this5 = this;
	
	    var tracks = this.textTracks();
	
	    if (!tracks) {
	      return;
	    }
	
	    var remoteTracks = this.remoteTextTracks();
	    var handleAddTrack = function handleAddTrack(e) {
	      return tracks.addTrack_(e.track);
	    };
	    var handleRemoveTrack = function handleRemoveTrack(e) {
	      return tracks.removeTrack_(e.track);
	    };
	
	    remoteTracks.on('addtrack', handleAddTrack);
	    remoteTracks.on('removetrack', handleRemoveTrack);
	
	    this.addWebVttScript_();
	
	    var updateDisplay = function updateDisplay() {
	      return _this5.trigger('texttrackchange');
	    };
	
	    var textTracksChanges = function textTracksChanges() {
	      updateDisplay();
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i];
	
	        track.removeEventListener('cuechange', updateDisplay);
	        if (track.mode === 'showing') {
	          track.addEventListener('cuechange', updateDisplay);
	        }
	      }
	    };
	
	    textTracksChanges();
	    tracks.addEventListener('change', textTracksChanges);
	    tracks.addEventListener('addtrack', textTracksChanges);
	    tracks.addEventListener('removetrack', textTracksChanges);
	
	    this.on('dispose', function () {
	      remoteTracks.off('addtrack', handleAddTrack);
	      remoteTracks.off('removetrack', handleRemoveTrack);
	      tracks.removeEventListener('change', textTracksChanges);
	      tracks.removeEventListener('addtrack', textTracksChanges);
	      tracks.removeEventListener('removetrack', textTracksChanges);
	
	      for (var i = 0; i < tracks.length; i++) {
	        var track = tracks[i];
	
	        track.removeEventListener('cuechange', updateDisplay);
	      }
	    });
	  };
	
	  /**
	   * Get the `Tech`s {@link VideoTrackList}.
	   *
	   * @return {VideoTrackList}
	   *          The video track list that the Tech is currently using.
	   */
	
	
	  Tech.prototype.videoTracks = function videoTracks() {
	    this.videoTracks_ = this.videoTracks_ || new _videoTrackList2['default']();
	    return this.videoTracks_;
	  };
	
	  /**
	   * Get the `Tech`s {@link AudioTrackList}.
	   *
	   * @return {AudioTrackList}
	   *          The audio track list that the Tech is currently using.
	   */
	
	
	  Tech.prototype.audioTracks = function audioTracks() {
	    this.audioTracks_ = this.audioTracks_ || new _audioTrackList2['default']();
	    return this.audioTracks_;
	  };
	
	  /**
	   * Get the `Tech`s {@link TextTrackList}.
	   *
	   * @return {TextTrackList}
	   *          The text track list that the Tech is currently using.
	   */
	
	
	  Tech.prototype.textTracks = function textTracks() {
	    this.textTracks_ = this.textTracks_ || new _textTrackList2['default']();
	    return this.textTracks_;
	  };
	
	  /**
	   * Get the `Tech`s remote {@link TextTrackList}, which is created from elements
	   * that were added to the DOM.
	   *
	   * @return {TextTrackList}
	   *          The remote text track list that the Tech is currently using.
	   */
	
	
	  Tech.prototype.remoteTextTracks = function remoteTextTracks() {
	    this.remoteTextTracks_ = this.remoteTextTracks_ || new _textTrackList2['default']();
	    return this.remoteTextTracks_;
	  };
	
	  /**
	   * Get The `Tech`s  {HTMLTrackElementList}, which are the elements in the DOM that are
	   * being used as TextTracks.
	   *
	   * @return {HTMLTrackElementList}
	   *          The current HTML track elements that exist for the tech.
	   */
	
	
	  Tech.prototype.remoteTextTrackEls = function remoteTextTrackEls() {
	    this.remoteTextTrackEls_ = this.remoteTextTrackEls_ || new _htmlTrackElementList2['default']();
	    return this.remoteTextTrackEls_;
	  };
	
	  /**
	   * Create and returns a remote {@link TextTrack} object.
	   *
	   * @param {string} kind
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	   *
	   * @param {string} [label]
	   *        Label to identify the text track
	   *
	   * @param {string} [language]
	   *        Two letter language abbreviation
	   *
	   * @return {TextTrack}
	   *         The TextTrack that gets created.
	   */
	
	
	  Tech.prototype.addTextTrack = function addTextTrack(kind, label, language) {
	    if (!kind) {
	      throw new Error('TextTrack kind is required but was not provided');
	    }
	
	    return createTrackHelper(this, kind, label, language);
	  };
	
	  /**
	   * Create an emulated TextTrack for use by addRemoteTextTrack
	   *
	   * This is intended to be overridden by classes that inherit from
	   * Tech in order to create native or custom TextTracks.
	   *
	   * @param {Object} options
	   *        The object should contain the options to initialize the TextTrack with.
	   *
	   * @param {string} [options.kind]
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
	   *
	   * @param {string} [options.label].
	   *        Label to identify the text track
	   *
	   * @param {string} [options.language]
	   *        Two letter language abbreviation.
	   *
	   * @return {HTMLTrackElement}
	   *         The track element that gets created.
	   */
	
	
	  Tech.prototype.createRemoteTextTrack = function createRemoteTextTrack(options) {
	    var track = (0, _mergeOptions2['default'])(options, {
	      tech: this
	    });
	
	    return new _htmlTrackElement2['default'](track);
	  };
	
	  /**
	   * Creates a remote text track object and returns an html track element.
	   *
	   * > Note: This can be an emulated {@link HTMLTrackElement} or a native one.
	   *
	   * @param {Object} options
	   *        See {@link Tech#createRemoteTextTrack} for more detailed properties.
	   *
	   * @param {boolean} [manualCleanup=true]
	   *        - When false: the TextTrack will be automatically removed from the video
	   *          element whenever the source changes
	   *        - When True: The TextTrack will have to be cleaned up manually
	   *
	   * @return {HTMLTrackElement}
	   *         An Html Track Element.
	   *
	   * @deprecated The default functionality for this function will be equivalent
	   *             to "manualCleanup=false" in the future. The manualCleanup parameter will
	   *             also be removed.
	   */
	
	
	  Tech.prototype.addRemoteTextTrack = function addRemoteTextTrack() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var manualCleanup = arguments[1];
	
	    var htmlTrackElement = this.createRemoteTextTrack(options);
	
	    if (manualCleanup !== true && manualCleanup !== false) {
	      // deprecation warning
	      _log2['default'].warn('Calling addRemoteTextTrack without explicitly setting the "manualCleanup" parameter to `true` is deprecated and default to `false` in future version of video.js');
	      manualCleanup = true;
	    }
	
	    // store HTMLTrackElement and TextTrack to remote list
	    this.remoteTextTrackEls().addTrackElement_(htmlTrackElement);
	    this.remoteTextTracks().addTrack_(htmlTrackElement.track);
	
	    if (manualCleanup !== true) {
	      // create the TextTrackList if it doesn't exist
	      this.autoRemoteTextTracks_.addTrack_(htmlTrackElement.track);
	    }
	
	    return htmlTrackElement;
	  };
	
	  /**
	   * Remove a remote text track from the remote `TextTrackList`.
	   *
	   * @param {TextTrack} track
	   *        `TextTrack` to remove from the `TextTrackList`
	   */
	
	
	  Tech.prototype.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
	    var trackElement = this.remoteTextTrackEls().getTrackElementByTrack_(track);
	
	    // remove HTMLTrackElement and TextTrack from remote list
	    this.remoteTextTrackEls().removeTrackElement_(trackElement);
	    this.remoteTextTracks().removeTrack_(track);
	    this.autoRemoteTextTracks_.removeTrack_(track);
	  };
	
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    return {};
	  };
	
	  /**
	   * A method to set a poster from a `Tech`.
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.setPoster = function setPoster() {};
	
	  /**
	   * A method to check for the presence of the 'playsinine' <video> attribute.
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.playsinline = function playsinline() {};
	
	  /**
	   * A method to set or unset the 'playsinine' <video> attribute.
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.setPlaysinline = function setPlaysinline() {};
	
	  /*
	   * Check if the tech can support the given mime-type.
	   *
	   * The base tech does not support any type, but source handlers might
	   * overwrite this.
	   *
	   * @param  {string} type
	   *         The mimetype to check for support
	   *
	   * @return {string}
	   *         'probably', 'maybe', or empty string
	   *
	   * @see [Spec]{@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/canPlayType}
	   *
	   * @abstract
	   */
	
	
	  Tech.prototype.canPlayType = function canPlayType() {
	    return '';
	  };
	
	  /*
	   * Return whether the argument is a Tech or not.
	   * Can be passed either a Class like `Html5` or a instance like `player.tech_`
	   *
	   * @param {Object} component
	   *        The item to check
	   *
	   * @return {boolean}
	   *         Whether it is a tech or not
	   *         - True if it is a tech
	   *         - False if it is not
	   */
	
	
	  Tech.isTech = function isTech(component) {
	    return component.prototype instanceof Tech || component instanceof Tech || component === Tech;
	  };
	
	  /**
	   * Registers a `Tech` into a shared list for videojs.
	   *
	   * @param {string} name
	   *        Name of the `Tech` to register.
	   *
	   * @param {Object} tech
	   *        The `Tech` class to register.
	   */
	
	
	  Tech.registerTech = function registerTech(name, tech) {
	    if (!Tech.techs_) {
	      Tech.techs_ = {};
	    }
	
	    if (!Tech.isTech(tech)) {
	      throw new Error('Tech ' + name + ' must be a Tech');
	    }
	
	    Tech.techs_[name] = tech;
	    return tech;
	  };
	
	  /**
	   * Get a `Tech` from the shared list by name.
	   *
	   * @param {string} name
	   *        Name of the component to get
	   *
	   * @return {Tech|undefined}
	   *         The `Tech` or undefined if there was no tech with the name requsted.
	   */
	
	
	  Tech.getTech = function getTech(name) {
	    if (Tech.techs_ && Tech.techs_[name]) {
	      return Tech.techs_[name];
	    }
	
	    if (_window2['default'] && _window2['default'].videojs && _window2['default'].videojs[name]) {
	      _log2['default'].warn('The ' + name + ' tech was added to the videojs object when it should be registered using videojs.registerTech(name, tech)');
	      return _window2['default'].videojs[name];
	    }
	  };
	
	  return Tech;
	}(_component2['default']);
	
	/**
	 * List of associated text tracks.
	 *
	 * @type {TextTrackList}
	 * @private
	 */
	
	
	Tech.prototype.textTracks_; // eslint-disable-line
	
	/**
	 * List of associated audio tracks.
	 *
	 * @type {AudioTrackList}
	 * @private
	 */
	Tech.prototype.audioTracks_; // eslint-disable-line
	
	/**
	 * List of associated video tracks.
	 *
	 * @type {VideoTrackList}
	 * @private
	 */
	Tech.prototype.videoTracks_; // eslint-disable-line
	
	/**
	 * Boolean indicating wether the `Tech` supports volume control.
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresVolumeControl = true;
	
	/**
	 * Boolean indicating wether the `Tech` support fullscreen resize control.
	 * Resizing plugins using request fullscreen reloads the plugin
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresFullscreenResize = false;
	
	/**
	 * Boolean indicating wether the `Tech` supports changing the speed at which the video
	 * plays. Examples:
	 *   - Set player to play 2x (twice) as fast
	 *   - Set player to play 0.5x (half) as fast
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresPlaybackRate = false;
	
	/**
	 * Boolean indicating wether the `Tech` supports the `progress` event. This is currently
	 * not triggered by video-js-swf. This will be used to determine if
	 * {@link Tech#manualProgressOn} should be called.
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresProgressEvents = false;
	
	/**
	 * Boolean indicating wether the `Tech` supports the `timeupdate` event. This is currently
	 * not triggered by video-js-swf. This will be used to determine if
	 * {@link Tech#manualTimeUpdates} should be called.
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresTimeupdateEvents = false;
	
	/**
	 * Boolean indicating wether the `Tech` supports the native `TextTrack`s.
	 * This will help us integrate with native `TextTrack`s if the browser supports them.
	 *
	 * @type {boolean}
	 * @default
	 */
	Tech.prototype.featuresNativeTextTracks = false;
	
	/**
	 * A functional mixin for techs that want to use the Source Handler pattern.
	 * Source handlers are scripts for handling specific formats.
	 * The source handler pattern is used for adaptive formats (HLS, DASH) that
	 * manually load video data and feed it into a Source Buffer (Media Source Extensions)
	 * Example: `Tech.withSourceHandlers.call(MyTech);`
	 *
	 * @param {Tech} _Tech
	 *        The tech to add source handler functions to.
	 *
	 * @mixes Tech~SourceHandlerAdditions
	 */
	Tech.withSourceHandlers = function (_Tech) {
	
	  /**
	   * Register a source handler
	   *
	   * @param {Function} handler
	   *        The source handler class
	   *
	   * @param {number} [index]
	   *        Register it at the following index
	   */
	  _Tech.registerSourceHandler = function (handler, index) {
	    var handlers = _Tech.sourceHandlers;
	
	    if (!handlers) {
	      handlers = _Tech.sourceHandlers = [];
	    }
	
	    if (index === undefined) {
	      // add to the end of the list
	      index = handlers.length;
	    }
	
	    handlers.splice(index, 0, handler);
	  };
	
	  /**
	   * Check if the tech can support the given type. Also checks the
	   * Techs sourceHandlers.
	   *
	   * @param {string} type
	   *         The mimetype to check.
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	  _Tech.canPlayType = function (type) {
	    var handlers = _Tech.sourceHandlers || [];
	    var can = void 0;
	
	    for (var i = 0; i < handlers.length; i++) {
	      can = handlers[i].canPlayType(type);
	
	      if (can) {
	        return can;
	      }
	    }
	
	    return '';
	  };
	
	  /**
	   * Returns the first source handler that supports the source.
	   *
	   * TODO: Answer question: should 'probably' be prioritized over 'maybe'
	   *
	   * @param {Tech~SourceObject} source
	   *        The source object
	   *
	   * @param {Object} options
	   *        The options passed to the tech
	   *
	   * @return {SourceHandler|null}
	   *          The first source handler that supports the source or null if
	   *          no SourceHandler supports the source
	   */
	  _Tech.selectSourceHandler = function (source, options) {
	    var handlers = _Tech.sourceHandlers || [];
	    var can = void 0;
	
	    for (var i = 0; i < handlers.length; i++) {
	      can = handlers[i].canHandleSource(source, options);
	
	      if (can) {
	        return handlers[i];
	      }
	    }
	
	    return null;
	  };
	
	  /**
	   * Check if the tech can support the given source.
	   *
	   * @param {Tech~SourceObject} srcObj
	   *        The source object
	   *
	   * @param {Object} options
	   *        The options passed to the tech
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	  _Tech.canPlaySource = function (srcObj, options) {
	    var sh = _Tech.selectSourceHandler(srcObj, options);
	
	    if (sh) {
	      return sh.canHandleSource(srcObj, options);
	    }
	
	    return '';
	  };
	
	  /**
	   * When using a source handler, prefer its implementation of
	   * any function normally provided by the tech.
	   */
	  var deferrable = ['seekable', 'duration'];
	
	  /**
	   * A wrapper around {@link Tech#seekable} that will call a `SourceHandler`s seekable
	   * function if it exists, with a fallback to the Techs seekable function.
	   *
	   * @method _Tech.seekable
	   */
	
	  /**
	   * A wrapper around {@link Tech#duration} that will call a `SourceHandler`s duration
	   * function if it exists, otherwise it will fallback to the techs duration function.
	   *
	   * @method _Tech.duration
	   */
	
	  deferrable.forEach(function (fnName) {
	    var originalFn = this[fnName];
	
	    if (typeof originalFn !== 'function') {
	      return;
	    }
	
	    this[fnName] = function () {
	      if (this.sourceHandler_ && this.sourceHandler_[fnName]) {
	        return this.sourceHandler_[fnName].apply(this.sourceHandler_, arguments);
	      }
	      return originalFn.apply(this, arguments);
	    };
	  }, _Tech.prototype);
	
	  /**
	   * Create a function for setting the source using a source object
	   * and source handlers.
	   * Should never be called unless a source handler was found.
	   *
	   * @param {Tech~SourceObject} source
	   *        A source object with src and type keys
	   *
	   * @return {Tech}
	   *         Returns itself; this method is chainable
	   */
	  _Tech.prototype.setSource = function (source) {
	    var sh = _Tech.selectSourceHandler(source, this.options_);
	
	    if (!sh) {
	      // Fall back to a native source hander when unsupported sources are
	      // deliberately set
	      if (_Tech.nativeSourceHandler) {
	        sh = _Tech.nativeSourceHandler;
	      } else {
	        _log2['default'].error('No source hander found for the current source.');
	      }
	    }
	
	    // Dispose any existing source handler
	    this.disposeSourceHandler();
	    this.off('dispose', this.disposeSourceHandler);
	
	    if (sh !== _Tech.nativeSourceHandler) {
	      this.currentSource_ = source;
	
	      // Catch if someone replaced the src without calling setSource.
	      // If they do, set currentSource_ to null and dispose our source handler.
	      this.off(this.el_, 'loadstart', _Tech.prototype.firstLoadStartListener_);
	      this.off(this.el_, 'loadstart', _Tech.prototype.successiveLoadStartListener_);
	      this.one(this.el_, 'loadstart', _Tech.prototype.firstLoadStartListener_);
	    }
	
	    this.sourceHandler_ = sh.handleSource(source, this, this.options_);
	    this.on('dispose', this.disposeSourceHandler);
	
	    return this;
	  };
	
	  /**
	   * Called once for the first loadstart of a video.
	   *
	   * @listens Tech#loadstart
	   */
	  _Tech.prototype.firstLoadStartListener_ = function () {
	    this.one(this.el_, 'loadstart', _Tech.prototype.successiveLoadStartListener_);
	  };
	
	  // On successive loadstarts when setSource has not been called again
	  /**
	   * Called after the first loadstart for a video occurs.
	   *
	   * @listens Tech#loadstart
	   */
	  _Tech.prototype.successiveLoadStartListener_ = function () {
	    this.disposeSourceHandler();
	    this.one(this.el_, 'loadstart', _Tech.prototype.successiveLoadStartListener_);
	  };
	
	  /**
	   * Clean up any existing SourceHandlers and listeners when the Tech is disposed.
	   *
	   * @listens Tech#dispose
	   */
	  _Tech.prototype.disposeSourceHandler = function () {
	    // if we have a source and get another one
	    // then we are loading something new
	    // than clear all of our current tracks
	    if (this.currentSource_) {
	      this.clearTracks(['audio', 'video']);
	      this.currentSource_ = null;
	    }
	
	    // always clean up auto-text tracks
	    this.cleanupAutoTextTracks();
	
	    if (this.sourceHandler_) {
	      this.off(this.el_, 'loadstart', _Tech.prototype.firstLoadStartListener_);
	      this.off(this.el_, 'loadstart', _Tech.prototype.successiveLoadStartListener_);
	
	      if (this.sourceHandler_.dispose) {
	        this.sourceHandler_.dispose();
	      }
	
	      this.sourceHandler_ = null;
	    }
	  };
	};
	
	_component2['default'].registerComponent('Tech', Tech);
	// Old name for Tech
	// @deprecated
	_component2['default'].registerComponent('MediaTechController', Tech);
	Tech.registerTech('Tech', Tech);
	exports['default'] = Tech;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createTimeRange = undefined;
	exports.createTimeRanges = createTimeRanges;
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Returns the time for the specified index at the start or end
	 * of a TimeRange object.
	 *
	 * @function time-ranges:indexFunction
	 *
	 * @param {number} [index=0]
	 *        The range number to return the time for.
	 *
	 * @return {number}
	 *         The time that offset at the specified index.
	 *
	 * @depricated index must be set to a value, in the future this will throw an error.
	 */
	
	/**
	 * An object that contains ranges of time for various reasons.
	 *
	 * @typedef {Object} TimeRange
	 *
	 * @property {number} length
	 *           The number of time ranges represented by this Object
	 *
	 * @property {time-ranges:indexFunction} start
	 *           Returns the time offset at which a specified time range begins.
	 *
	 * @property {time-ranges:indexFunction} end
	 *           Returns the time offset at which a specified time range begins.
	 *
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TimeRanges
	 */
	
	/**
	 * Check if any of the time ranges are over the maximum index.
	 *
	 * @param {string} fnName
	 *        The function name to use for logging
	 *
	 * @param {number} index
	 *        The index to check
	 *
	 * @param {number} maxIndex
	 *        The maximum possible index
	 *
	 * @throws {Error} if the timeRanges provided are over the maxIndex
	 */
	function rangeCheck(fnName, index, maxIndex) {
	  if (index < 0 || index > maxIndex) {
	    throw new Error('Failed to execute \'' + fnName + '\' on \'TimeRanges\': The index provided (' + index + ') is greater than or equal to the maximum bound (' + maxIndex + ').');
	  }
	}
	
	/**
	 * Check if any of the time ranges are over the maximum index.
	 *
	 * @param {string} fnName
	 *        The function name to use for logging
	 *
	 * @param {string} valueIndex
	 *        The proprety that should be used to get the time. should be 'start' or 'end'
	 *
	 * @param {Array} ranges
	 *        An array of time ranges
	 *
	 * @param {Array} [rangeIndex=0]
	 *        The index to start the search at
	 *
	 * @return {number}
	 *         The time that offset at the specified index.
	 *
	 *
	 * @depricated rangeIndex must be set to a value, in the future this will throw an error.
	 * @throws {Error} if rangeIndex is more than the length of ranges
	 */
	/**
	 * @file time-ranges.js
	 * @module time-ranges
	 */
	function getRange(fnName, valueIndex, ranges, rangeIndex) {
	  if (rangeIndex === undefined) {
	    _log2['default'].warn('DEPRECATED: Function \'' + fnName + '\' on \'TimeRanges\' called without an index argument.');
	    rangeIndex = 0;
	  }
	  rangeCheck(fnName, rangeIndex, ranges.length - 1);
	  return ranges[rangeIndex][valueIndex];
	}
	
	/**
	 * Create a time range object givent ranges of time.
	 *
	 * @param {Array} [ranges]
	 *        An array of time ranges.
	 */
	function createTimeRangesObj(ranges) {
	  if (ranges === undefined || ranges.length === 0) {
	    return {
	      length: 0,
	      start: function start() {
	        throw new Error('This TimeRanges object is empty');
	      },
	      end: function end() {
	        throw new Error('This TimeRanges object is empty');
	      }
	    };
	  }
	  return {
	    length: ranges.length,
	    start: getRange.bind(null, 'start', 0, ranges),
	    end: getRange.bind(null, 'end', 1, ranges)
	  };
	}
	
	/**
	 * Should create a fake `TimeRange` object which mimics an HTML5 time range instance.
	 *
	 * @param {number|Array} start
	 *        The start of a single range or an array of ranges
	 *
	 * @param {number} end
	 *        The end of a single range.
	 *
	 * @private
	 */
	function createTimeRanges(start, end) {
	  if (Array.isArray(start)) {
	    return createTimeRangesObj(start);
	  } else if (start === undefined || end === undefined) {
	    return createTimeRangesObj();
	  }
	  return createTimeRangesObj([[start, end]]);
	}
	
	exports.createTimeRange = createTimeRanges;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _tcombForm = __webpack_require__(64);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _reactKeybinding = __webpack_require__(365);
	
	var _reactKeybinding2 = _interopRequireDefault(_reactKeybinding);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Form = _tcombForm2['default'].form.Form;
	var CreateBasket = _tcombForm2['default'].struct({
	    name: _tcombForm2['default'].maybe(_tcombForm2['default'].Str)
	});
	
	var BasketDropdown = _react2['default'].createClass({
	
	    displayName: 'BasketDropdown',
	
	    mixins: [_reactKeybinding2['default']],
	
	    propTypes: {
	        baskets: _react2['default'].PropTypes.object,
	        mediaId: _react2['default'].PropTypes.string,
	        mediaName: _react2['default'].PropTypes.string,
	        isFooter: _react2['default'].PropTypes.bool,
	        media: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.object, _react2['default'].PropTypes.array])
	    },
	
	    keybindings: {
	        'up': 'KEYUP',
	        'down': 'KEYDOWN',
	        'enter': 'ENTER',
	        'esc': 'ESC'
	    },
	
	    onSubmit: function onSubmit(e) {
	        e.preventDefault();
	        var basketData = this.refs.form.getValue();
	        var media = [];
	        var key = this.refs.filekey ? this.refs.filekey.getDOMNode().value : 'master';
	        if (this.props.mediaId && this.props.mediaName) {
	            media.push({
	                id: this.props.mediaId,
	                name: this.props.mediaName,
	                key: key
	            });
	        } else {
	            media = this.props.media;
	        }
	
	        var self = this;
	        _utilsFlux2['default'].getStore('basket').createBasket(media, basketData.name);
	
	        _utilsFlux2['default'].getActions('media').toggleBasket(this.props.mediaId);
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            selected: 0,
	            positionTop: 'auto'
	        };
	    },
	
	    addToBasket: function addToBasket(basket, e) {
	        e.preventDefault();
	        this._addToBasket(basket);
	    },
	
	    _addToBasket: function _addToBasket(basket) {
	        var _this = this;
	
	        var _media = [];
	        var key = 'master';
	
	        if (Array.isArray(this.props.media)) {
	            this.props.media.forEach(function (item) {
	                _media.push({
	                    id: item.id,
	                    title: item.title,
	                    key: key
	                });
	            });
	        } else {
	            _media.push({
	                id: this.props.media.get('id'),
	                title: this.props.media.get('title'),
	                key: this.refs.filekey ? this.refs.filekey.getDOMNode().value : key
	            });
	        }
	
	        _utilsFlux2['default'].getStore('basket').addToBasket({
	            basket: { id: basket.id, name: basket.name },
	            media: _media
	        }).then(function () {
	            if (_this.props.media) {
	                _utilsFlux2['default'].getActions('media').removeAllItemSelection();
	            }
	        });
	
	        _utilsFlux2['default'].getActions('media').closeBasket(this.props.mediaId);
	
	        if (_utilsFlux2['default'].getStore('modals').getState().openModal) {
	            (function () {
	                var id = _this.props.media.get('id');
	                var order = _utilsFlux2['default'].getStore('media').getState().media.findIndex(function (item) {
	                    return item.get('id') === id;
	                });
	                _utilsFlux2['default'].getActions('modals').openMediaModal(_utilsFlux2['default'].getStore('media').getState().media.get(order));
	
	                if (!_this.props.media.get('_basket')) {
	                    _utilsFlux2['default'].getActions('media').toggleBasket(id);
	                    _utilsFlux2['default'].getActions('modals').openMediaModal(_utilsFlux2['default'].getStore('media').getState().media.get(order));
	                }
	            })();
	        }
	    },
	
	    keybinding: function keybinding(event, action) {
	        event.preventDefault();
	        if (action === 'KEYDOWN') {
	            var selectedDown = this.state.selected <= this.props.baskets.size - 2 ? this.state.selected + 1 : 0;
	            this.setState({ selected: selectedDown });
	        }
	
	        if (action === 'KEYUP') {
	            var selectedUp = this.state.selected > 0 ? this.state.selected - 1 : this.props.baskets.size - 1;
	            this.setState({ selected: selectedUp });
	        }
	
	        if (action === 'ENTER' && this.props.mediaId) {
	            var basket = this.props.baskets.getIn([this.state.selected]).toJS();
	            this._addToBasket(basket);
	        }
	
	        if (action === 'ESC' && this.props.mediaId) {
	            _utilsFlux2['default'].getActions('media').toggleBasket(this.props.mediaId);
	        }
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (this.props.isFooter) {
	            var height = this.refs.basket.getDOMNode().offsetHeight;
	            this.setState({ positionTop: height * -1 });
	        }
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var baskets = this.props.baskets.toJS();
	        var media = this.props.media;
	        var mediaIsArray = Array.isArray(media);
	
	        var options = {
	            auto: 'placeholders',
	            fields: {
	                name: {
	                    attrs: {
	                        placeholder: _utilsFlux2['default'].t('lightbox_create'),
	                        autoFocus: this.props.baskets.size === 0
	                    }
	                }
	            }
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            { style: { top: this.state.positionTop }, ref: 'basket', className: 'basketdropdown' },
	            function () {
	                if (!mediaIsArray) {
	                    var firstFile = media.get('files').first();
	                    return _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'basketdropdown__header', style: { display: 'none' } },
	                            _utilsFlux2['default'].t('Select a file format')
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'basketdropdown__filetypes', style: { display: 'none' } },
	                            _react2['default'].createElement(
	                                'select',
	                                { onChange: _this2.selectFileType, value: firstFile && firstFile.get('key') || '', ref: 'filekey' },
	                                media.get('files').map(function (file, ix) {
	                                    return _react2['default'].createElement(
	                                        'option',
	                                        { key: 'file_' + ix, value: file.get('key') },
	                                        file.get('name'),
	                                        ' (',
	                                        file.get('mimeType'),
	                                        ')'
	                                    );
	                                })
	                            )
	                        )
	                    );
	                }
	            },
	            _react2['default'].createElement(
	                'div',
	                { className: 'basketdropdown__header' },
	                _utilsFlux2['default'].t('select_a_folder')
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'basketdropdown__baskets' },
	                baskets.map(function (basket, ix) {
	                    var isInBasket = false;
	                    if (media.get) {
	                        isInBasket = _utilsFlux2['default'].getStore('basket').isInBasket(basket, media.get('id'));
	                    }
	                    return _react2['default'].createElement(
	                        'button',
	                        { key: 'basket-' + basket.id, onClick: _this2.addToBasket.bind(null, basket), className: (0, _classnames2['default'])('btn btn-border', { 'active': ix === _this2.state.selected }) },
	                        basket.name,
	                        ' ',
	                        isInBasket ? _react2['default'].createElement('i', { className: 'checkmark' }) : ''
	                    );
	                })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'basketdropdown__create' },
	                _react2['default'].createElement(
	                    'form',
	                    { onSubmit: this.onSubmit },
	                    _react2['default'].createElement(Form, {
	                        ref: 'form',
	                        type: CreateBasket,
	                        options: options
	                    }),
	                    _react2['default'].createElement(
	                        'button',
	                        { className: 'btn btn-border btn-arrow', type: 'submit' },
	                        _utilsFlux2['default'].t('create'),
	                        _react2['default'].createElement('i', { className: 'plus-small' })
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = BasketDropdown;

/***/ }),
/* 145 */
/***/ (function(module, exports) {

	var canUseDOM = !!(
	  typeof window !== 'undefined' &&
	  window.document &&
	  window.document.createElement
	);
	
	module.exports = canUseDOM;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(44);
	var toLength = __webpack_require__(15);
	var toAbsoluteIndex = __webpack_require__(94);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(34);
	var redefineAll = __webpack_require__(92);
	var meta = __webpack_require__(79);
	var forOf = __webpack_require__(87);
	var anInstance = __webpack_require__(86);
	var isObject = __webpack_require__(10);
	var fails = __webpack_require__(9);
	var $iterDetect = __webpack_require__(151);
	var setToStringTag = __webpack_require__(107);
	var inheritIfRequired = __webpack_require__(204);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(329);
	var redefine = __webpack_require__(34);
	var hide = __webpack_require__(33);
	var fails = __webpack_require__(9);
	var defined = __webpack_require__(58);
	var wks = __webpack_require__(13);
	var regexpExec = __webpack_require__(212);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(50);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(10);
	var cof = __webpack_require__(50);
	var MATCH = __webpack_require__(13)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(13)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(78) || !__webpack_require__(9)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(8)[K];
	});


/***/ }),
/* 153 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(105);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(29);
	var ctx = __webpack_require__(51);
	var forOf = __webpack_require__(87);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(1);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(53);
	var defined = __webpack_require__(58);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var hide = __webpack_require__(33);
	var uid = __webpack_require__(95);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(77);
	var step = __webpack_require__(290);
	var Iterators = __webpack_require__(106);
	var toIObject = __webpack_require__(44);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(207)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.inherits = inherits;
	function inherits(parent, child) {
		var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
		var extended = Object.create(parent.prototype);
		for (var p in props) {
			extended[p] = props[p];
		}
		extended.constructor = child;
		child.prototype = extended;
		return child;
	}

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(357);
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	module.exports = bindCallback;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

	var isNative = __webpack_require__(800);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(97),
	    isIndex = __webpack_require__(230),
	    isObject = __webpack_require__(36);
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var numberIsNan = __webpack_require__(809);
	
	module.exports = function (num) {
		if (typeof num !== 'number' || numberIsNan(num)) {
			throw new TypeError('Expected a number, got ' + typeof num);
		}
	
		var exponent;
		var unit;
		var neg = num < 0;
		var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	
		if (neg) {
			num = -num;
		}
	
		if (num < 1) {
			return (neg ? '-' : '') + num + ' B';
		}
	
		exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
		num = Number((num / Math.pow(1000, exponent)).toFixed(2));
		unit = units[exponent];
	
		return (neg ? '-' : '') + num + ' ' + unit;
	};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(925);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (Array.isArray(val)) {
				return val.sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	var invariant = __webpack_require__(67);
	var PropTypes = __webpack_require__(69);
	var RouteHandler = __webpack_require__(169);
	
	/**
	 * <Route> components specify components that are rendered to the page when the
	 * URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is requested,
	 * the tree is searched depth-first to find a route whose path matches the URL.
	 * When one is found, all routes in the tree that lead to it are considered
	 * "active" and their components are rendered into the DOM, nested in the same
	 * order as they are in the tree.
	 *
	 * The preferred way to configure a router is using JSX. The XML-like syntax is
	 * a great way to visualize how routes are laid out in an application.
	 *
	 *   var routes = [
	 *     <Route handler={App}>
	 *       <Route name="login" handler={Login}/>
	 *       <Route name="logout" handler={Logout}/>
	 *       <Route name="about" handler={About}/>
	 *     </Route>
	 *   ];
	 *   
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 *
	 * Handlers for Route components that contain children can render their active
	 * child route using a <RouteHandler> element.
	 *
	 *   var App = React.createClass({
	 *     render: function () {
	 *       return (
	 *         <div className="application">
	 *           <RouteHandler/>
	 *         </div>
	 *       );
	 *     }
	 *   });
	 *
	 * If no handler is provided for the route, it will render a matched child route.
	 */
	
	var Route = (function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    _classCallCheck(this, Route);
	
	    _get(Object.getPrototypeOf(Route.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(Route, [{
	    key: 'render',
	    value: function render() {
	      invariant(false, '%s elements are for router configuration only and should not be rendered', this.constructor.name);
	    }
	  }]);
	
	  return Route;
	})(React.Component);
	
	Route.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.string,
	  handler: PropTypes.func,
	  ignoreScrollBehavior: PropTypes.bool
	};
	
	Route.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = Route;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	var ContextWrapper = __webpack_require__(835);
	var assign = __webpack_require__(113);
	var PropTypes = __webpack_require__(69);
	
	var REF_NAME = '__routeHandler__';
	
	/**
	 * A <RouteHandler> component renders the active child route handler
	 * when routes are nested.
	 */
	
	var RouteHandler = (function (_React$Component) {
	  _inherits(RouteHandler, _React$Component);
	
	  function RouteHandler() {
	    _classCallCheck(this, RouteHandler);
	
	    _get(Object.getPrototypeOf(RouteHandler.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(RouteHandler, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        routeDepth: this.context.routeDepth + 1
	      };
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._updateRouteComponent(this.refs[REF_NAME]);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this._updateRouteComponent(this.refs[REF_NAME]);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._updateRouteComponent(null);
	    }
	  }, {
	    key: '_updateRouteComponent',
	    value: function _updateRouteComponent(component) {
	      this.context.router.setRouteComponentAtDepth(this.getRouteDepth(), component);
	    }
	  }, {
	    key: 'getRouteDepth',
	    value: function getRouteDepth() {
	      return this.context.routeDepth;
	    }
	  }, {
	    key: 'createChildRouteHandler',
	    value: function createChildRouteHandler(props) {
	      var route = this.context.router.getRouteAtDepth(this.getRouteDepth());
	
	      if (route == null) return null;
	
	      var childProps = assign({}, props || this.props, {
	        ref: REF_NAME,
	        params: this.context.router.getCurrentParams(),
	        query: this.context.router.getCurrentQuery()
	      });
	
	      return React.createElement(route.handler, childProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var handler = this.createChildRouteHandler();
	      // <script/> for things like <CSSTransitionGroup/> that don't like null
	      return handler ? React.createElement(
	        ContextWrapper,
	        null,
	        handler
	      ) : React.createElement('script', null);
	    }
	  }]);
	
	  return RouteHandler;
	})(React.Component);
	
	RouteHandler.contextTypes = {
	  routeDepth: PropTypes.number.isRequired,
	  router: PropTypes.router.isRequired
	};
	
	RouteHandler.childContextTypes = {
	  routeDepth: PropTypes.number.isRequired
	};
	
	module.exports = RouteHandler;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusMixin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var focusNode = __webpack_require__(392);
	
	var AutoFocusMixin = {
	  componentDidMount: function() {
	    if (this.props.autoFocus) {
	      focusNode(this.getDOMNode());
	    }
	  }
	};
	
	module.exports = AutoFocusMixin;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var EventPluginUtils = __webpack_require__(241);
	var ReactChildren = __webpack_require__(380);
	var ReactComponent = __webpack_require__(381);
	var ReactClass = __webpack_require__(46);
	var ReactContext = __webpack_require__(246);
	var ReactCurrentOwner = __webpack_require__(72);
	var ReactElement = __webpack_require__(16);
	var ReactElementValidator = __webpack_require__(134);
	var ReactDOM = __webpack_require__(860);
	var ReactDOMTextComponent = __webpack_require__(383);
	var ReactDefaultInjection = __webpack_require__(871);
	var ReactInstanceHandles = __webpack_require__(116);
	var ReactMount = __webpack_require__(73);
	var ReactPerf = __webpack_require__(100);
	var ReactPropTypes = __webpack_require__(387);
	var ReactReconciler = __webpack_require__(118);
	var ReactServerRendering = __webpack_require__(881);
	
	var assign = __webpack_require__(11);
	var findDOMNode = __webpack_require__(391);
	var onlyChild = __webpack_require__(399);
	
	ReactDefaultInjection.inject();
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var render = ReactPerf.measure('React', 'render', ReactMount.render);
	
	var React = {
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    only: onlyChild
	  },
	  Component: ReactComponent,
	  DOM: ReactDOM,
	  PropTypes: ReactPropTypes,
	  initializeTouchEvents: function(shouldUseTouch) {
	    EventPluginUtils.useTouchEvents = shouldUseTouch;
	  },
	  createClass: ReactClass.createClass,
	  createElement: createElement,
	  cloneElement: cloneElement,
	  createFactory: createFactory,
	  createMixin: function(mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	  constructAndRenderComponent: ReactMount.constructAndRenderComponent,
	  constructAndRenderComponentByID: ReactMount.constructAndRenderComponentByID,
	  findDOMNode: findDOMNode,
	  render: render,
	  renderToString: ReactServerRendering.renderToString,
	  renderToStaticMarkup: ReactServerRendering.renderToStaticMarkup,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  isValidElement: ReactElement.isValidElement,
	  withContext: ReactContext.withContext,
	
	  // Hook for JSX spread, don't use this for anything else.
	  __spread: assign
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' &&
	  typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    CurrentOwner: ReactCurrentOwner,
	    InstanceHandles: ReactInstanceHandles,
	    Mount: ReactMount,
	    Reconciler: ReactReconciler,
	    TextComponent: ReactDOMTextComponent
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require("./ExecutionEnvironment");
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // If we're in Chrome, look for the devtools marker and provide a download
	    // link if not installed.
	    if (navigator.userAgent.indexOf('Chrome') > -1) {
	      if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	        console.debug(
	          'Download the React DevTools for a better development experience: ' +
	          'https://fb.me/react-devtools'
	        );
	      }
	    }
	
	    var expectedFeatures = [
	      // shims
	      Array.isArray,
	      Array.prototype.every,
	      Array.prototype.forEach,
	      Array.prototype.indexOf,
	      Array.prototype.map,
	      Date.now,
	      Function.prototype.bind,
	      Object.keys,
	      String.prototype.split,
	      String.prototype.trim,
	
	      // shams
	      Object.create,
	      Object.freeze
	    ];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        console.error(
	          'One or more ES5 shim/shams expected by React are not available: ' +
	          'https://fb.me/react-warning-polyfills'
	        );
	        break;
	      }
	    }
	  }
	}
	
	React.version = '0.13.3';
	
	module.exports = React;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNativeComponent
	 */
	
	'use strict';
	
	var assign = __webpack_require__(11);
	var invariant = __webpack_require__(6);
	
	var autoGenerateWrapperClass = null;
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around native tags
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactNativeComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function(componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function(componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function(componentClasses) {
	    assign(tagToComponentClass, componentClasses);
	  },
	  // Temporary hack since we expect DOM refs to behave like composites,
	  // for this release.
	  injectAutoWrapper: function(wrapperFactory) {
	    autoGenerateWrapperClass = wrapperFactory;
	  }
	};
	
	/**
	 * Get a composite component wrapper class for a specific tag.
	 *
	 * @param {ReactElement} element The tag for which to get the class.
	 * @return {function} The React class constructor function.
	 */
	function getComponentClassForElement(element) {
	  if (typeof element.type === 'function') {
	    return element.type;
	  }
	  var tag = element.type;
	  var componentClass = tagToComponentClass[tag];
	  if (componentClass == null) {
	    tagToComponentClass[tag] = componentClass = autoGenerateWrapperClass(tag);
	  }
	  return componentClass;
	}
	
	/**
	 * Get a native internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  ( false ? invariant(
	    genericComponentClass,
	    'There is no registered component for the tag %s',
	    element.type
	  ) : invariant(genericComponentClass));
	  return new genericComponentClass(element.type, element.props);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactNativeComponent = {
	  getComponentClassForElement: getComponentClassForElement,
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactNativeComponentInjection
	};
	
	module.exports = ReactNativeComponent;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(136);
	var ViewportMetrics = __webpack_require__(252);
	
	var getEventModifierState = __webpack_require__(256);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function(event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function(event) {
	    return event.relatedTarget || (
	      ((event.fromElement === event.srcElement ? event.toElement : event.fromElement))
	    );
	  },
	  // "Proprietary" Interface.
	  pageX: function(event) {
	    return 'pageX' in event ?
	      event.pageX :
	      event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function(event) {
	    return 'pageY' in event ?
	      event.pageY :
	      event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(6);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function() {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (!this.wrapperInitData) {
	      this.wrapperInitData = [];
	    } else {
	      this.wrapperInitData.length = 0;
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function() {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} args... Arguments to pass to the method (optional).
	   *                           Helps prevent need to bind in many cases.
	   * @return Return value from `method`.
	   */
	  perform: function(method, scope, a, b, c, d, e, f) {
	    ( false ? invariant(
	      !this.isInTransaction(),
	      'Transaction.perform(...): Cannot initialize a transaction when there ' +
	      'is already an outstanding transaction.'
	    ) : invariant(!this.isInTransaction()));
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {
	          }
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function(startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ?
	          wrapper.initialize.call(this) :
	          null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {
	          }
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function(startIndex) {
	    ( false ? invariant(
	      this.isInTransaction(),
	      'Transaction.closeAll(): Cannot close transaction when none are open.'
	    ) : invariant(this.isInTransaction()));
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {
	          }
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occured.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule emptyObject
	 */
	
	"use strict";
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;


/***/ }),
/* 177 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	var ESCAPE_LOOKUP = {
	  '&': '&amp;',
	  '>': '&gt;',
	  '<': '&lt;',
	  '"': '&quot;',
	  '\'': '&#x27;'
	};
	
	var ESCAPE_REGEX = /[&><"']/g;
	
	function escaper(match) {
	  return ESCAPE_LOOKUP[match];
	}
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  return ('' + text).replace(ESCAPE_REGEX, escaper);
	}
	
	module.exports = escapeTextContentForBrowser;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

	module.exports = function getFunctionName(f) {
	  return f.displayName || f.name || '<function' + f.length + '>';
	};

/***/ }),
/* 179 */
/***/ (function(module, exports) {

	module.exports = function isString(x) {
	  return typeof x === 'string';
	};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var isNil = __webpack_require__(82);
	var assert = __webpack_require__(25);
	
	// safe mixin, cannot override props unless specified
	module.exports = function mixin(target, source, overwrite) {
	  if (isNil(source)) { return target; }
	  for (var k in source) {
	    if (source.hasOwnProperty(k)) {
	      if (overwrite !== true) {
	        if (false) {
	          assert(!target.hasOwnProperty(k), function () { return 'Invalid call to mixin(target, source, [overwrite]): cannot overwrite property "' + k + '" of target object'; });
	        }
	      }
	      target[k] = source[k];
	    }
	  }
	  return target;
	};

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackButton = __webpack_require__(420);
	
	var _trackButton2 = _interopRequireDefault(_trackButton);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _textTrackMenuItem = __webpack_require__(264);
	
	var _textTrackMenuItem2 = _interopRequireDefault(_textTrackMenuItem);
	
	var _offTextTrackMenuItem = __webpack_require__(995);
	
	var _offTextTrackMenuItem2 = _interopRequireDefault(_offTextTrackMenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file text-track-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The base class for buttons that toggle specific text track types (e.g. subtitles)
	 *
	 * @extends MenuButton
	 */
	var TextTrackButton = function (_TrackButton) {
	  _inherits(TextTrackButton, _TrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function TextTrackButton(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, TextTrackButton);
	
	    options.tracks = player.textTracks();
	
	    return _possibleConstructorReturn(this, _TrackButton.call(this, player, options));
	  }
	
	  /**
	   * Create a menu item for each text track
	   *
	   * @param {TextTrackMenuItem[]} [items=[]]
	   *        Existing array of items to use during creation
	   *
	   * @return {TextTrackMenuItem[]}
	   *         Array of menu items that were created
	   */
	
	
	  TextTrackButton.prototype.createItems = function createItems() {
	    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    // Add an OFF menu item to turn all tracks off
	    items.push(new _offTextTrackMenuItem2['default'](this.player_, { kind: this.kind_ }));
	    this.hideThreshold_ += 1;
	
	    var tracks = this.player_.textTracks();
	
	    if (!tracks) {
	      return items;
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	
	      // only add tracks that are of the appropriate kind and have a label
	      if (track.kind === this.kind_) {
	        items.push(new _textTrackMenuItem2['default'](this.player_, {
	          track: track,
	          // MenuItem is selectable
	          selectable: true
	        }));
	      }
	    }
	
	    return items;
	  };
	
	  return TextTrackButton;
	}(_trackButton2['default']);
	
	_component2['default'].registerComponent('TextTrackButton', TextTrackButton);
	exports['default'] = TextTrackButton;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _events = __webpack_require__(83);
	
	var Events = _interopRequireWildcard(_events);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 * `EventTarget` is a class that can have the same API as the DOM `EventTarget`. It
	 * adds shorthand functions that wrap around lengthy functions. For example:
	 * the `on` function is a wrapper around `addEventListener`.
	 *
	 * @see [EventTarget Spec]{@link https://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget}
	 * @class EventTarget
	 */
	var EventTarget = function EventTarget() {};
	
	/**
	 * A Custom DOM event.
	 *
	 * @typedef {Object} EventTarget~Event
	 * @see [Properties]{@link https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent}
	 */
	
	/**
	 * All event listeners should follow the following format.
	 *
	 * @callback EventTarget~EventListener
	 * @this {EventTarget}
	 *
	 * @param {EventTarget~Event} event
	 *        the event that triggered this function
	 *
	 * @param {Object} [hash]
	 *        hash of data sent during the event
	 */
	
	/**
	 * An object containing event names as keys and booleans as values.
	 *
	 * > NOTE: If an event name is set to a true value here {@link EventTarget#trigger}
	 *         will have extra functionality. See that function for more information.
	 *
	 * @property EventTarget.prototype.allowedEvents_
	 * @private
	 */
	/**
	 * @file src/js/event-target.js
	 */
	EventTarget.prototype.allowedEvents_ = {};
	
	/**
	 * Adds an `event listener` to an instance of an `EventTarget`. An `event listener` is a
	 * function that will get called when an event with a certain name gets triggered.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to call with `EventTarget`s
	 */
	EventTarget.prototype.on = function (type, fn) {
	  // Remove the addEventListener alias before calling Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	  Events.on(this, type, fn);
	  this.addEventListener = ael;
	};
	
	/**
	 * An alias of {@link EventTarget#on}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#on}
	 */
	EventTarget.prototype.addEventListener = EventTarget.prototype.on;
	
	/**
	 * Removes an `event listener` for a specific event from an instance of `EventTarget`.
	 * This makes it so that the `event listener` will no longer get called when the
	 * named event happens.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to remove.
	 */
	EventTarget.prototype.off = function (type, fn) {
	  Events.off(this, type, fn);
	};
	
	/**
	 * An alias of {@link EventTarget#off}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#off}
	 */
	EventTarget.prototype.removeEventListener = EventTarget.prototype.off;
	
	/**
	 * This function will add an `event listener` that gets triggered only once. After the
	 * first trigger it will get removed. This is like adding an `event listener`
	 * with {@link EventTarget#on} that calls {@link EventTarget#off} on itself.
	 *
	 * @param {string|string[]} type
	 *        An event name or an array of event names.
	 *
	 * @param {EventTarget~EventListener} fn
	 *        The function to be called once for each event name.
	 */
	EventTarget.prototype.one = function (type, fn) {
	  // Remove the addEventListener alialing Events.on
	  // so we don't get into an infinite type loop
	  var ael = this.addEventListener;
	
	  this.addEventListener = function () {};
	  Events.one(this, type, fn);
	  this.addEventListener = ael;
	};
	
	/**
	 * This function causes an event to happen. This will then cause any `event listeners`
	 * that are waiting for that event, to get called. If there are no `event listeners`
	 * for an event then nothing will happen.
	 *
	 * If the name of the `Event` that is being triggered is in `EventTarget.allowedEvents_`.
	 * Trigger will also call the `on` + `uppercaseEventName` function.
	 *
	 * Example:
	 * 'click' is in `EventTarget.allowedEvents_`, so, trigger will attempt to call
	 * `onClick` if it exists.
	 *
	 * @param {string|EventTarget~Event|Object} event
	 *        The name of the event, an `Event`, or an object with a key of type set to
	 *        an event name.
	 */
	EventTarget.prototype.trigger = function (event) {
	  var type = event.type || event;
	
	  if (typeof event === 'string') {
	    event = { type: type };
	  }
	  event = Events.fixEvent(event);
	
	  if (this.allowedEvents_[type] && this['on' + type]) {
	    this['on' + type](event);
	  }
	
	  Events.trigger(this, event);
	};
	
	/**
	 * An alias of {@link EventTarget#trigger}. Allows `EventTarget` to mimic
	 * the standard DOM API.
	 *
	 * @function
	 * @see {@link EventTarget#trigger}
	 */
	EventTarget.prototype.dispatchEvent = EventTarget.prototype.trigger;
	
	exports['default'] = EventTarget;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _clickableComponent = __webpack_require__(141);
	
	var _clickableComponent2 = _interopRequireDefault(_clickableComponent);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _obj = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file menu-item.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The component for a menu item. `<li>`
	 *
	 * @extends ClickableComponent
	 */
	var MenuItem = function (_ClickableComponent) {
	  _inherits(MenuItem, _ClickableComponent);
	
	  /**
	   * Creates an instance of the this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   *
	   */
	  function MenuItem(player, options) {
	    _classCallCheck(this, MenuItem);
	
	    var _this = _possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));
	
	    _this.selectable = options.selectable;
	
	    _this.selected(options.selected);
	
	    if (_this.selectable) {
	      // TODO: May need to be either menuitemcheckbox or menuitemradio,
	      //       and may need logical grouping of menu items.
	      _this.el_.setAttribute('role', 'menuitemcheckbox');
	    } else {
	      _this.el_.setAttribute('role', 'menuitem');
	    }
	    return _this;
	  }
	
	  /**
	   * Create the `MenuItem's DOM element
	   *
	   * @param {string} [type=li]
	   *        Element's node type, not actually used, always set to `li`.
	   *
	   * @param {Object} [props={}]
	   *        An object of properties that should be set on the element
	   *
	   * @param {Object} [attrs={}]
	   *        An object of attributes that should be set on the element
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  MenuItem.prototype.createEl = function createEl(type, props, attrs) {
	    // The control is textual, not just an icon
	    this.nonIconControl = true;
	
	    return _ClickableComponent.prototype.createEl.call(this, 'li', (0, _obj.assign)({
	      className: 'vjs-menu-item',
	      innerHTML: this.localize(this.options_.label),
	      tabIndex: -1
	    }, props), attrs);
	  };
	
	  /**
	   * Any click on a `MenuItem` puts int into the selected state.
	   * See {@link ClickableComponent#handleClick} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  MenuItem.prototype.handleClick = function handleClick(event) {
	    this.selected(true);
	  };
	
	  /**
	   * Set the state for this menu item as selected or not.
	   *
	   * @param {boolean} selected
	   *        if the menu item is selected or not
	   */
	
	
	  MenuItem.prototype.selected = function selected(_selected) {
	    if (this.selectable) {
	      if (_selected) {
	        this.addClass('vjs-selected');
	        this.el_.setAttribute('aria-checked', 'true');
	        // aria-checked isn't fully supported by browsers/screen readers,
	        // so indicate selected state to screen reader in the control text.
	        this.controlText(', selected');
	      } else {
	        this.removeClass('vjs-selected');
	        this.el_.setAttribute('aria-checked', 'false');
	        // Indicate un-selected state to screen reader
	        this.controlText('');
	      }
	    }
	  };
	
	  return MenuItem;
	}(_clickableComponent2['default']);
	
	_component2['default'].registerComponent('MenuItem', MenuItem);
	exports['default'] = MenuItem;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.isCrossOrigin = exports.getFileExtension = exports.getAbsoluteURL = exports.parseUrl = undefined;
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * @typedef {Object} url:URLObject
	 *
	 * @property {string} protocol
	 *           The protocol of the url that was parsed.
	 *
	 * @property {string} hostname
	 *           The hostname of the url that was parsed.
	 *
	 * @property {string} port
	 *           The port of the url that was parsed.
	 *
	 * @property {string} pathname
	 *           The pathname of the url that was parsed.
	 *
	 * @property {string} search
	 *           The search query of the url that was parsed.
	 *
	 * @property {string} hash
	 *           The hash of the url that was parsed.
	 *
	 * @property {string} host
	 *           The host of the url that was parsed.
	 */
	
	/**
	 * Resolve and parse the elements of a URL.
	 *
	 * @param  {String} url
	 *         The url to parse
	 *
	 * @return {url:URLObject}
	 *         An object of url details
	 */
	/**
	 * @file url.js
	 * @module url
	 */
	var parseUrl = exports.parseUrl = function parseUrl(url) {
	  var props = ['protocol', 'hostname', 'port', 'pathname', 'search', 'hash', 'host'];
	
	  // add the url to an anchor and let the browser parse the URL
	  var a = _document2['default'].createElement('a');
	
	  a.href = url;
	
	  // IE8 (and 9?) Fix
	  // ie8 doesn't parse the URL correctly until the anchor is actually
	  // added to the body, and an innerHTML is needed to trigger the parsing
	  var addToBody = a.host === '' && a.protocol !== 'file:';
	  var div = void 0;
	
	  if (addToBody) {
	    div = _document2['default'].createElement('div');
	    div.innerHTML = '<a href="' + url + '"></a>';
	    a = div.firstChild;
	    // prevent the div from affecting layout
	    div.setAttribute('style', 'display:none; position:absolute;');
	    _document2['default'].body.appendChild(div);
	  }
	
	  // Copy the specific URL properties to a new object
	  // This is also needed for IE8 because the anchor loses its
	  // properties when it's removed from the dom
	  var details = {};
	
	  for (var i = 0; i < props.length; i++) {
	    details[props[i]] = a[props[i]];
	  }
	
	  // IE9 adds the port to the host property unlike everyone else. If
	  // a port identifier is added for standard ports, strip it.
	  if (details.protocol === 'http:') {
	    details.host = details.host.replace(/:80$/, '');
	  }
	
	  if (details.protocol === 'https:') {
	    details.host = details.host.replace(/:443$/, '');
	  }
	
	  if (addToBody) {
	    _document2['default'].body.removeChild(div);
	  }
	
	  return details;
	};
	
	/**
	 * Get absolute version of relative URL. Used to tell flash correct URL.
	 *
	 *
	 * @param  {string} url
	 *         URL to make absolute
	 *
	 * @return {string}
	 *         Absolute URL
	 *
	 * @see http://stackoverflow.com/questions/470832/getting-an-absolute-url-from-a-relative-one-ie6-issue
	 */
	var getAbsoluteURL = exports.getAbsoluteURL = function getAbsoluteURL(url) {
	  // Check if absolute URL
	  if (!url.match(/^https?:\/\//)) {
	    // Convert to absolute URL. Flash hosted off-site needs an absolute URL.
	    var div = _document2['default'].createElement('div');
	
	    div.innerHTML = '<a href="' + url + '">x</a>';
	    url = div.firstChild.href;
	  }
	
	  return url;
	};
	
	/**
	 * Returns the extension of the passed file name. It will return an empty string
	 * if passed an invalid path.
	 *
	 * @param {string} path
	 *        The fileName path like '/path/to/file.mp4'
	 *
	 * @returns {string}
	 *          The extension in lower case or an empty string if no
	 *          extension could be found.
	 */
	var getFileExtension = exports.getFileExtension = function getFileExtension(path) {
	  if (typeof path === 'string') {
	    var splitPathRe = /^(\/?)([\s\S]*?)((?:\.{1,2}|[^\/]+?)(\.([^\.\/\?]+)))(?:[\/]*|[\?].*)$/i;
	    var pathParts = splitPathRe.exec(path);
	
	    if (pathParts) {
	      return pathParts.pop().toLowerCase();
	    }
	  }
	
	  return '';
	};
	
	/**
	 * Returns whether the url passed is a cross domain request or not.
	 *
	 * @param {string} url
	 *        The url to check.
	 *
	 * @return {boolean}
	 *         Whether it is a cross domain request or not.
	 */
	var isCrossOrigin = exports.isCrossOrigin = function isCrossOrigin(url) {
	  var winLoc = _window2['default'].location;
	  var urlInfo = parseUrl(url);
	
	  // IE8 protocol relative urls will return ':' for protocol
	  var srcProtocol = urlInfo.protocol === ':' ? winLoc.protocol : urlInfo.protocol;
	
	  // Check if url is for another domain/origin
	  // IE8 doesn't know location.origin, so we won't rely on it here
	  var crossOrigin = srcProtocol + urlInfo.host !== winLoc.protocol + winLoc.host;
	
	  return crossOrigin;
	};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.getInternalMethods = getInternalMethods;
	exports.getPrototypeChain = getPrototypeChain;
	exports.warn = warn;
	exports.uid = uid;
	exports.formatAsConstant = formatAsConstant;
	exports.dispatchIdentity = dispatchIdentity;
	exports.fsa = fsa;
	exports.dispatch = dispatch;
	
	var _functions = __webpack_require__(85);
	
	var fn = _interopRequireWildcard(_functions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/*eslint-disable*/
	var builtIns = Object.getOwnPropertyNames(NoopClass);
	var builtInProto = Object.getOwnPropertyNames(NoopClass.prototype);
	/*eslint-enable*/
	
	function getInternalMethods(Obj, isProto) {
	  var excluded = isProto ? builtInProto : builtIns;
	  var obj = isProto ? Obj.prototype : Obj;
	  return Object.getOwnPropertyNames(obj).reduce(function (value, m) {
	    if (excluded.indexOf(m) !== -1) {
	      return value;
	    }
	
	    value[m] = obj[m];
	    return value;
	  }, {});
	}
	
	function getPrototypeChain(Obj) {
	  var methods = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  return Obj === Function.prototype ? methods : getPrototypeChain(Object.getPrototypeOf(Obj), fn.assign(getInternalMethods(Obj, true), methods));
	}
	
	function warn(msg) {
	  /* istanbul ignore else */
	  /*eslint-disable*/
	  if (typeof console !== 'undefined') {
	    console.warn(new ReferenceError(msg));
	  }
	  /*eslint-enable*/
	}
	
	function uid(container, name) {
	  var count = 0;
	  var key = name;
	  while (Object.hasOwnProperty.call(container, key)) {
	    key = name + String(++count);
	  }
	  return key;
	}
	
	function formatAsConstant(name) {
	  return name.replace(/[a-z]([A-Z])/g, function (i) {
	    return String(i[0]) + '_' + String(i[1].toLowerCase());
	  }).toUpperCase();
	}
	
	function dispatchIdentity(x) {
	  if (x === undefined) return null;
	
	  for (var _len = arguments.length, a = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    a[_key - 1] = arguments[_key];
	  }
	
	  return a.length ? [x].concat(a) : x;
	}
	
	function fsa(id, type, payload, details) {
	  return {
	    type: type,
	    payload: payload,
	    meta: _extends({
	      dispatchId: id
	    }, details),
	
	    id: id,
	    action: type,
	    data: payload,
	    details: details
	  };
	}
	
	function dispatch(id, actionObj, payload, alt) {
	  var data = actionObj.dispatch(payload);
	  if (data === undefined) return null;
	
	  var type = actionObj.id;
	  var namespace = type;
	  var name = type;
	  var details = { id: type, namespace: namespace, name: name };
	
	  var dispatchLater = function dispatchLater(x) {
	    return alt.dispatch(type, x, details);
	  };
	
	  if (fn.isFunction(data)) return data(dispatchLater, alt);
	
	  // XXX standardize this
	  return alt.dispatcher.dispatch(fsa(id, type, data, details));
	}
	
	/* istanbul ignore next */
	function NoopClass() {}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var BasketSidebar = _react2['default'].createClass({
	
	    displayName: 'BasketSidebar',
	
	    mixins: [_reactRouter.Navigation],
	
	    propTypes: {
	        name: _react2['default'].PropTypes.string.isRequired,
	        baskets: _react2['default'].PropTypes.object.isRequired,
	        basket: _react2['default'].PropTypes.object
	    },
	
	    _getSelectedBasketIds: function _getSelectedBasketIds() {
	        return this._getSelectedBaskets().map(function (basket) {
	            return basket.get('id');
	        });
	    },
	
	    _getSelectedBaskets: function _getSelectedBaskets() {
	        return this.props.baskets.filter(function (basket) {
	            return basket.get('isSelected');
	        });
	    },
	
	    deleteBaskets: function deleteBaskets(e) {
	        var _this = this;
	
	        e.preventDefault();
	        var basketsToDelete = this._getSelectedBaskets();
	        var basketIdsToDelete = basketsToDelete.map(function (basket) {
	            return basket.get('id');
	        });
	        var basketNamesToDelete = basketsToDelete.map(function (basket) {
	            return basket.get('name');
	        }).toJS();
	
	        _utilsFlux2['default'].getActions('modals').confirmModal({
	            title: _utilsFlux2['default'].t('delete_folder'),
	            basketNames: basketNamesToDelete,
	            onConfirm: function onConfirm() {
	                _utilsFlux2['default'].getActions('modals').activateLoading();
	                _utilsFlux2['default'].getStore('basket').deleteBaskets(basketIdsToDelete).then(function () {
	                    _utilsFlux2['default'].getActions('modals').disableLoading();
	
	                    var baskets = _this.props.baskets;
	                    basketIdsToDelete.forEach(function (basketId) {
	                        var idx = baskets.findIndex(function (item) {
	                            return item.get('id') === basketId;
	                        });
	                        baskets = baskets.removeIn([idx]);
	                    });
	                    var activeBasket = baskets.get(0);
	                    if (activeBasket) {
	                        _this.transitionTo('singleBasket', { id: activeBasket.get('id') });
	                    } else {
	                        _this.transitionTo('basket');
	                    }
	                    _utilsFlux2['default'].getActions('modals').closeModals();
	                });
	            }
	        });
	    },
	
	    shareBaskets: function shareBaskets() {
	        var basketIdsToShare = this._getSelectedBasketIds();
	
	        _utilsFlux2['default'].getActions('modals').openModal('Share');
	        _utilsFlux2['default'].getStore('basket').shareBaskets(basketIdsToShare);
	    },
	
	    toggleBasket: function toggleBasket(basketId, e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('basket').toggleBasketSelection(basketId);
	    },
	
	    renderShareButtons: function renderShareButtons() {
	        var selectedBaskets = this._getSelectedBaskets();
	
	        if (this.props.baskets.size !== 0) {
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    _utilsFlux2['default'].t('basket_selection')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'sidebar__buttons' },
	                    _react2['default'].createElement(
	                        'button',
	                        { onClick: this.deleteBaskets, type: 'button', disabled: selectedBaskets.size === 0, className: 'btn btn-border btn-remove' },
	                        _react2['default'].createElement('i', { className: 'close-small' }),
	                        _utilsFlux2['default'].t('remove_baskets')
	                    ),
	                    _react2['default'].createElement(
	                        'button',
	                        { type: 'button', onClick: this.shareBaskets, disabled: selectedBaskets.size === 0, className: 'btn btn-border btn-red btn-share' },
	                        _react2['default'].createElement('i', { className: 'share' }),
	                        _utilsFlux2['default'].t('share_baskets')
	                    )
	                )
	            );
	        }
	    },
	
	    linkClicked: function linkClicked(e) {
	        var modalStore = _utilsFlux2['default'].getStore('modals');
	
	        var _modalStore$getState = modalStore.getState();
	
	        var loading = _modalStore$getState.loading;
	
	        if (loading) {
	            e.preventDefault();
	        }
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var baskets = this.props.baskets.toJS();
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var licensing = _flux$getStore$getState$config$toJS.licensing;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'basket__sidebar' },
	            this.renderShareButtons(),
	            _react2['default'].createElement(
	                'ul',
	                { className: 'sidebar__menu' },
	                baskets.map(function (basket, ix) {
	                    return _react2['default'].createElement(
	                        'li',
	                        { key: 'basket_' + ix, className: 'menu__item' },
	                        _react2['default'].createElement(
	                            'form',
	                            { className: 'item__actions' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'field__checkbox' },
	                                _react2['default'].createElement('input', { readOnly: true, type: 'checkbox', id: basket.id, checked: basket.isSelected }),
	                                _react2['default'].createElement('label', { onClick: _this2.toggleBasket.bind(null, basket.id), htmlFor: basket.id })
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            _reactRouter.Link,
	                            { className: 'item__link', onClick: _this2.linkClicked, to: _this2.props.name, params: { id: basket.id } },
	                            basket.name,
	                            ' (',
	                            basket.items.length,
	                            ')'
	                        )
	                    );
	                })
	            ),
	            licensing && _react2['default'].createElement(
	                'div',
	                { className: 'sidebar__requests' },
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    _utilsFlux2['default'].t('my_requests')
	                ),
	                _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: 'requests' },
	                    _utilsFlux2['default'].t('all_requests')
	                )
	            ),
	            _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: 'landing-page', className: 'sidebar__back' },
	                _react2['default'].createElement('i', { className: 'chevron-left' }),
	                _utilsFlux2['default'].t('back_to_home')
	            )
	        );
	    }
	});
	
	module.exports = BasketSidebar;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLibViewportMetrics = __webpack_require__(252);
	
	var _reactLibViewportMetrics2 = _interopRequireDefault(_reactLibViewportMetrics);
	
	var win = typeof window !== 'undefined' ? window : false;
	var FooterBar = _react2['default'].createClass({
	    displayName: 'FooterBar',
	    propTypes: {
	        isHidden: _react2['default'].PropTypes.bool
	    },
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    getInitialState: function getInitialState() {
	        return {
	            scrollPostion: _reactLibViewportMetrics2['default'].currentScrollTop
	        };
	    },
	    componentDidMount: function componentDidMount() {
	        if (win) {
	            win.addEventListener('scroll', this._onPageScroll);
	        }
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        if (win) {
	            win.removeEventListener('scroll', this._onPageScroll);
	        }
	    },
	    _onPageScroll: function _onPageScroll() {
	        this.setState({ scrollPostion: _reactLibViewportMetrics2['default'].currentScrollTop });
	    },
	    render: function render() {
	        if (this.state.scrollPostion < 115 || this.props.isHidden) {
	            return false;
	        }
	        return _react2['default'].createElement(
	            'div',
	            { className: 'footerbar' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'container--centered' },
	                this.props.children
	            )
	        );
	    }
	});
	
	module.exports = FooterBar;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _headerDropdown = __webpack_require__(272);
	
	var _headerDropdown2 = _interopRequireDefault(_headerDropdown);
	
	var HeaderLanguageSelection = _react2['default'].createClass({
	
	    displayName: 'HeaderLanguageSelection',
	
	    switchLanguage: function switchLanguage(language, e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getStore('translations').switchLanguage(language);
	    },
	    render: function render() {
	        var _this = this;
	
	        var _flux$getStore$getState = _utilsFlux2['default'].getStore('app').getState();
	
	        var config = _flux$getStore$getState.config;
	
	        var _config$toJS = config.toJS();
	
	        var enableLanguageSelection = _config$toJS.enableLanguageSelection;
	
	        var availableLanguages = _utilsFlux2['default'].getStore('translations').getAvailableLanguages() || [];
	        var userLanguage = _utilsFlux2['default'].getStore('translations').getUserLocale() || 'EN';
	
	        if (!!enableLanguageSelection) {
	            return _react2['default'].createElement(
	                'span',
	                { className: 'header__language-selection' },
	                _react2['default'].createElement(
	                    _headerDropdown2['default'],
	                    {
	                        label: _utilsFlux2['default'].t('switch_languages') },
	                    _react2['default'].createElement(
	                        'ul',
	                        null,
	                        availableLanguages.map(function (langDef, ix) {
	                            return _react2['default'].createElement(
	                                'li',
	                                null,
	                                _react2['default'].createElement('i', { className: 'play ' }),
	                                _react2['default'].createElement(
	                                    'a',
	                                    { className: "" + (userLanguage === langDef.id ? 'active' : ''), href: '#', onClick: _this.switchLanguage.bind(null, langDef.id) },
	                                    langDef.name
	                                )
	                            );
	                        })
	                    )
	                )
	            );
	        } else {
	            return _react2['default'].createElement('span', null);
	        }
	    }
	});
	
	module.exports = HeaderLanguageSelection;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var SubmissionLink = _react2['default'].createClass({
	
	    displayName: 'SubmissionLink',
	
	    render: function render() {
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var allowSubmissions = _flux$getStore$getState$config$toJS.allowSubmissions;
	        var submissionLink = _flux$getStore$getState$config$toJS.submissionLink;
	
	        if (!allowSubmissions) {
	            return false;
	        }
	
	        return _react2['default'].createElement(
	            'a',
	            { className: 'awards-button btn btn-border', href: submissionLink, target: '_blank' },
	            _react2['default'].createElement(
	                'span',
	                { className: 'awards-button__label awards-button__label--full' },
	                _utilsFlux2['default'].t('submit_media')
	            ),
	            _react2['default'].createElement(
	                'span',
	                { className: 'awards-button__label awards-button__label--short' },
	                _utilsFlux2['default'].t('submit_media_short')
	            )
	        );
	    }
	});
	
	module.exports = SubmissionLink;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _lodashLangCloneDeep = __webpack_require__(68);
	
	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);
	
	var MediaHeaderSearch = _react2['default'].createClass({
	
	    displayName: 'MediaHeaderSearch',
	
	    mixins: [],
	
	    propTypes: {
	        query: _react2['default'].PropTypes.string,
	        mediaStore: _react2['default'].PropTypes.object
	    },
	
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            search: ''
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.setState({
	            search: nextProps.query
	        });
	    },
	
	    search: function search(e) {
	        e.preventDefault();
	        var query = (0, _lodashLangCloneDeep2['default'])(this.context.router.getCurrentQuery());
	        if (this.state.search !== '') {
	            query.search = this.state.search;
	        } else {
	            delete query.search;
	            _utilsFlux2['default'].getActions('media').clearSearch();
	        }
	        if (query.search && query.search !== '') {
	            var pagination_amount = _store2['default'].get('pagination_amount');
	            if (!query.page) {
	                query.page = 1;
	            }
	            if (!query.per_page) {
	                query.per_page = pagination_amount;
	            }
	        }
	        this.context.router.transitionTo('listing', null, query);
	    },
	
	    onChange: function onChange(e) {
	        e.preventDefault();
	        this.setState({ search: e.target.value });
	    },
	
	    render: function render() {
	        var router = this.context.router;
	
	        var route = router.getRouteAtDepth(1);
	        var isLanding = route && 'landing-page' === route.name;
	        var placeholder = isLanding ? _utilsFlux2['default'].t('searchterm_landing') : _utilsFlux2['default'].t('searchterm');
	        return _react2['default'].createElement(
	            'div',
	            { className: 'headerbar__search' },
	            _react2['default'].createElement(
	                'form',
	                { onSubmit: this.search },
	                _react2['default'].createElement('input', { onChange: this.onChange, value: this.state.search, type: 'text', name: 'search', placeholder: placeholder }),
	                _react2['default'].createElement(
	                    'button',
	                    { className: 'search__button', type: 'submit' },
	                    _react2['default'].createElement('i', { className: 'search' })
	                )
	            )
	        );
	    }
	});
	
	module.exports = MediaHeaderSearch;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var Modal = _react2['default'].createClass({
	    displayName: 'Modal',
	
	    closeModal: function closeModal(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').closeModals();
	    },
	
	    _isNodeInRoot: function _isNodeInRoot(node, root) {
	        while (node) {
	            if (node === root) {
	                return true;
	            }
	            node = node.parentNode;
	        }
	        return false;
	    },
	
	    componentDidMount: function componentDidMount() {
	        document.addEventListener('mousedown', this.handleMouseClickOutside);
	        document.addEventListener('keydown', this.handleKeydown);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener('mousedown', this.handleMouseClickOutside);
	        document.removeEventListener('keydown', this.handleKeydown);
	    },
	
	    handleMouseClickOutside: function handleMouseClickOutside(e) {
	        if (this._isNodeInRoot(e.target, (0, _react.findDOMNode)(this.refs.content))) {
	            return;
	        }
	        if (this.props.closeOnOutsideClick) {
	            e.stopPropagation();
	            this.closeModal(e);
	        }
	    },
	
	    handleKeydown: function handleKeydown(e) {
	        if (this._isNodeInRoot(e.target, (0, _react.findDOMNode)(this.refs.content))) {
	            return;
	        }
	        if (27 === e.keyCode) {
	            e.stopPropagation();
	            this.closeModal(e);
	        }
	    },
	
	    renderCloseButton: function renderCloseButton() {
	        if (!this.props.hideCloseButton) {
	            return _react2['default'].createElement(
	                'a',
	                { href: '#', onClick: this.closeModal, className: 'modal__close' },
	                _react2['default'].createElement('i', { className: 'close' })
	            );
	        }
	    },
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])('modal', this.props.className) },
	            _react2['default'].createElement('div', { className: 'modal__overlay' }),
	            _react2['default'].createElement(
	                'div',
	                { ref: 'content', className: 'modal__content' },
	                this.renderCloseButton(),
	                this.props.children
	            )
	        );
	    }
	});
	
	module.exports = Modal;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var QuotaWarning = _react2['default'].createClass({
	    displayName: 'QuotaWarning',
	    render: function render() {
	        var _flux$getStore$getState = _utilsFlux2['default'].getStore('media').getState();
	
	        var quotaExceeded = _flux$getStore$getState.quotaExceeded;
	
	        if (!quotaExceeded) {
	            return false;
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'quota-warning' },
	            _react2['default'].createElement('i', { className: 'info-sign-alt' }),
	            ' ',
	            _utilsFlux2['default'].t('download-limit-reached')
	        );
	    }
	});
	
	module.exports = QuotaWarning;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var LoginBackgroundVideo = _react2['default'].createClass({
	    displayName: 'LoginBackgroundVideo',
	    mixins: [],
	    propTypes: {
	        video: _react2['default'].PropTypes.string.isRequired,
	        poster: _react2['default'].PropTypes.string,
	        positionX: _react2['default'].PropTypes.string,
	        positionY: _react2['default'].PropTypes.string
	    },
	    getInitialState: function getInitialState() {
	        return {
	            videoWidth: 'auto',
	            videoHeight: 'auto',
	            videoVisibility: 'hidden',
	            // wrapperBackgroundImage: 'url(' + this.props.poster + ')',
	            wrapperBackgroundImage: 'none'
	        };
	    },
	    getDefaultProps: function getDefaultProps() {
	        return {
	            positionX: '50%',
	            positionY: '50%'
	        };
	    },
	    _resize: function _resize() {
	        if (this.refs.video) {
	            var video = this.refs.video.getDOMNode();
	            var wrapper = this.refs.wrapper.getDOMNode();
	
	            // Get a native video size
	            var videoHeight = video.videoHeight;
	            var videoWidth = video.videoWidth;
	
	            // Get a wrapper size
	            var wrapperHeight = wrapper.offsetHeight;
	            var wrapperWidth = wrapper.offsetWidth;
	
	            if (wrapperWidth / videoWidth > wrapperHeight / videoHeight) {
	                this.setState({ videoWidth: wrapperWidth + 2, videoHeight: 'auto' });
	            } else {
	                this.setState({ videoWidth: 'auto', videoHeight: wrapperHeight + 2 });
	            }
	        }
	    },
	    _isPlaying: function _isPlaying() {
	        this.setState({ wrapperBackgroundImage: 'none', videoVisibility: 'visible' });
	    },
	    componentWillUnmount: function componentWillUnmount() {
	        if (this.refs.video) {
	            var video = this.refs.video.getDOMNode();
	            video.removeEventListener('canplaythrough', this._resize);
	            video.removeEventListener('playing', this._isPlaying);
	            window.removeEventListener('resize', this._resize);
	        }
	    },
	    componentDidMount: function componentDidMount() {
	        this._resize();
	        if (this.refs.video) {
	            var video = this.refs.video.getDOMNode();
	            video.addEventListener('canplaythrough', this._resize);
	            video.addEventListener('playing', this._isPlaying);
	            window.addEventListener('resize', this._resize);
	        }
	    },
	    render: function render() {
	        var positionX = this.props.positionX;
	        var positionY = this.props.positionY;
	
	        var wrapperStyle = {
	            'backgroundPosition': positionX + ' ' + positionY,
	            'backgroundImage': this.state.wrapperBackgroundImage
	        };
	
	        var videoStyle = {
	            top: positionX,
	            left: positionY,
	            width: this.state.videoWidth,
	            height: this.state.videoHeight,
	            visibility: this.state.videoVisibility,
	            'WebkitTransform': 'translate(-' + positionX + ', -' + positionY + ')',
	            'MsTransform': 'translate(-' + positionX + ', -' + positionY + ')',
	            'MozTransform': 'translate(-' + positionX + ', -' + positionY + ')',
	            transform: 'translate(-' + positionX + ', -' + positionY + ')'
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            { ref: 'wrapper', className: 'login__video', style: wrapperStyle },
	            _react2['default'].createElement(
	                'video',
	                { ref: 'video', style: videoStyle, autoPlay: 'true', loop: 'true', volume: '0', muted: 'true' },
	                _react2['default'].createElement('source', { src: this.props.video, type: 'video/mp4' })
	            )
	        );
	    }
	});
	
	module.exports = LoginBackgroundVideo;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsEffects = __webpack_require__(537);
	
	var _utilsEffects2 = _interopRequireDefault(_utilsEffects);
	
	var LoginSlideshow = _react2['default'].createClass({
	
	    displayName: 'LoginSlideshow',
	
	    propTypes: {
	        show: _react2['default'].PropTypes.array,
	        speed: _react2['default'].PropTypes.number
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            activeSlideIdx: 0
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (this.props.show || this.props.show.length > 0) {
	            this.initFirstSlide();
	            if (this.props.show.length > 1) {
	                this.startAnimation();
	            }
	        }
	    },
	
	    initFirstSlide: function initFirstSlide() {
	        if (this.refs.slide_0) {
	            var curEl = this.refs.slide_0.getDOMNode();
	            _utilsEffects2['default'].fadeInOut(curEl, 'in');
	        }
	    },
	
	    startAnimation: function startAnimation() {
	        this.interval = window.setInterval((function () {
	            var curIdx = this.state.activeSlideIdx;
	            var nextIdx = this.state.activeSlideIdx === this.props.show.length - 1 ? 0 : this.state.activeSlideIdx + 1;
	
	            var curEl = this.refs['slide_' + curIdx].getDOMNode();
	            var nextEl = this.refs['slide_' + nextIdx].getDOMNode();
	
	            _utilsEffects2['default'].fadeInOut(curEl, 'out');
	            _utilsEffects2['default'].fadeInOut(nextEl, 'in');
	
	            this.setState({
	                activeSlideIdx: nextIdx
	            });
	        }).bind(this), this.props.speed ? parseInt(this.props.speed, 10) : 2000);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        window.clearInterval(this.interval);
	    },
	
	    renderSlides: function renderSlides() {
	        var _this = this;
	
	        var slides = [];
	
	        this.props.show.map(function (slideNode, index) {
	            slides.push(_react2['default'].createElement('div', {
	                className: (0, _classnames2['default'])('slideshow__item', { 'active': index === _this.state.activeSlideIdx }),
	                ref: 'slide_' + index,
	                key: index,
	                style: {
	                    'backgroundImage': 'url(' + slideNode + ')',
	                    'opacity': 0 } }));
	        });
	
	        return slides;
	    },
	
	    render: function render() {
	        if (!this.props.show || this.props.show.length === 0) {
	            return false;
	        }
	        return _react2['default'].createElement(
	            'div',
	            { className: 'login__slideshow' },
	            this.renderSlides()
	        );
	    }
	});
	
	module.exports = LoginSlideshow;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactLibReactCSSTransitionGroup = __webpack_require__(856);
	
	var _reactLibReactCSSTransitionGroup2 = _interopRequireDefault(_reactLibReactCSSTransitionGroup);
	
	var mediaListingItemNotification = _react2['default'].createClass({
	    displayName: 'mediaListingItemNotification',
	
	    propTypes: {
	        notifications: _react2['default'].PropTypes.array
	    },
	
	    render: function render() {
	        var notifications = this.props.notifications;
	
	        if (!notifications || 0 === notifications.length) {
	            return false;
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'notifications' },
	            _react2['default'].createElement(
	                _reactLibReactCSSTransitionGroup2['default'],
	                { transitionName: 'transition__notifications' },
	                notifications.map(function (notification) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { key: notification.id, className: (0, _classnames2['default'])('notifications--' + notification.type) },
	                        notification.text
	                    );
	                })
	            )
	        );
	    }
	
	});
	
	module.exports = mediaListingItemNotification;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(157)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(23);
	var toAbsoluteIndex = __webpack_require__(94);
	var toLength = __webpack_require__(15);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(543);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(22);
	var createDesc = __webpack_require__(91);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	var document = __webpack_require__(8).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 201 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(13)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(8).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	var setPrototypeOf = __webpack_require__(213).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(106);
	var ITERATOR = __webpack_require__(13)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(88);
	var descriptor = __webpack_require__(91);
	var setToStringTag = __webpack_require__(107);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(33)(IteratorPrototype, __webpack_require__(13)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(78);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(34);
	var hide = __webpack_require__(33);
	var Iterators = __webpack_require__(106);
	var $iterCreate = __webpack_require__(206);
	var setToStringTag = __webpack_require__(107);
	var getPrototypeOf = __webpack_require__(43);
	var ITERATOR = __webpack_require__(13)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 208 */
/***/ (function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ }),
/* 209 */
/***/ (function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var macrotask = __webpack_require__(218).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(50)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(29);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(123);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(10);
	var anObject = __webpack_require__(5);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(51)(Function.call, __webpack_require__(42).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(126)('keys');
	var uid = __webpack_require__(95);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(150);
	var defined = __webpack_require__(58);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(53);
	var defined = __webpack_require__(58);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(51);
	var invoke = __webpack_require__(287);
	var html = __webpack_require__(203);
	var cel = __webpack_require__(200);
	var global = __webpack_require__(8);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(50)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var DESCRIPTORS = __webpack_require__(19);
	var LIBRARY = __webpack_require__(78);
	var $typed = __webpack_require__(158);
	var hide = __webpack_require__(33);
	var redefineAll = __webpack_require__(92);
	var fails = __webpack_require__(9);
	var anInstance = __webpack_require__(86);
	var toInteger = __webpack_require__(53);
	var toLength = __webpack_require__(15);
	var toIndex = __webpack_require__(306);
	var gOPN = __webpack_require__(89).f;
	var dP = __webpack_require__(22).f;
	var arrayFill = __webpack_require__(197);
	var setToStringTag = __webpack_require__(107);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var core = __webpack_require__(40);
	var LIBRARY = __webpack_require__(78);
	var wksExt = __webpack_require__(307);
	var defineProperty = __webpack_require__(22).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(105);
	var ITERATOR = __webpack_require__(13)('iterator');
	var Iterators = __webpack_require__(106);
	module.exports = __webpack_require__(40).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(721);


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(725);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(728)(__webpack_require__(539))

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.AMPERSAND = exports.CLOSEPAREN = exports.CLOSEANGLEBRACKET = exports.CLOSEBRACKET = exports.CLOSEBRACE = exports.OPENPAREN = exports.OPENANGLEBRACKET = exports.OPENBRACKET = exports.OPENBRACE = exports.WS = exports.TLD = exports.SYM = exports.UNDERSCORE = exports.SLASH = exports.MAILTO = exports.PROTOCOL = exports.QUERY = exports.POUND = exports.PLUS = exports.NUM = exports.NL = exports.LOCALHOST = exports.PUNCTUATION = exports.DOT = exports.COLON = exports.AT = exports.DOMAIN = exports.Base = undefined;
	
	var _createTokenClass = __webpack_require__(341);
	
	var _class = __webpack_require__(162);
	
	/******************************************************************************
		Text Tokens
		Tokens composed of strings
	******************************************************************************/
	
	/**
		Abstract class used for manufacturing text tokens.
		Pass in the value this token represents
	
		@class TextToken
		@abstract
	*/
	var TextToken = (0, _createTokenClass.createTokenClass)();
	TextToken.prototype = {
		toString: function toString() {
			return this.v + '';
		}
	};
	
	function inheritsToken(value) {
		var props = value ? { v: value } : {};
		return (0, _class.inherits)(TextToken, (0, _createTokenClass.createTokenClass)(), props);
	}
	
	/**
		A valid domain token
		@class DOMAIN
		@extends TextToken
	*/
	var DOMAIN = inheritsToken();
	
	/**
		@class AT
		@extends TextToken
	*/
	var AT = inheritsToken('@');
	
	/**
		Represents a single colon `:` character
	
		@class COLON
		@extends TextToken
	*/
	var COLON = inheritsToken(':');
	
	/**
		@class DOT
		@extends TextToken
	*/
	var DOT = inheritsToken('.');
	
	/**
		A character class that can surround the URL, but which the URL cannot begin
		or end with. Does not include certain English punctuation like parentheses.
	
		@class PUNCTUATION
		@extends TextToken
	*/
	var PUNCTUATION = inheritsToken();
	
	/**
		The word localhost (by itself)
		@class LOCALHOST
		@extends TextToken
	*/
	var LOCALHOST = inheritsToken();
	
	/**
		Newline token
		@class NL
		@extends TextToken
	*/
	var NL = inheritsToken('\n');
	
	/**
		@class NUM
		@extends TextToken
	*/
	var NUM = inheritsToken();
	
	/**
		@class PLUS
		@extends TextToken
	*/
	var PLUS = inheritsToken('+');
	
	/**
		@class POUND
		@extends TextToken
	*/
	var POUND = inheritsToken('#');
	
	/**
		Represents a web URL protocol. Supported types include
	
		* `http:`
		* `https:`
		* `ftp:`
		* `ftps:`
	
		@class PROTOCOL
		@extends TextToken
	*/
	var PROTOCOL = inheritsToken();
	
	/**
		Represents the start of the email URI protocol
	
		@class MAILTO
		@extends TextToken
	*/
	var MAILTO = inheritsToken('mailto:');
	
	/**
		@class QUERY
		@extends TextToken
	*/
	var QUERY = inheritsToken('?');
	
	/**
		@class SLASH
		@extends TextToken
	*/
	var SLASH = inheritsToken('/');
	
	/**
		@class UNDERSCORE
		@extends TextToken
	*/
	var UNDERSCORE = inheritsToken('_');
	
	/**
		One ore more non-whitespace symbol.
		@class SYM
		@extends TextToken
	*/
	var SYM = inheritsToken();
	
	/**
		@class TLD
		@extends TextToken
	*/
	var TLD = inheritsToken();
	
	/**
		Represents a string of consecutive whitespace characters
	
		@class WS
		@extends TextToken
	*/
	var WS = inheritsToken();
	
	/**
		Opening/closing bracket classes
	*/
	
	var OPENBRACE = inheritsToken('{');
	var OPENBRACKET = inheritsToken('[');
	var OPENANGLEBRACKET = inheritsToken('<');
	var OPENPAREN = inheritsToken('(');
	var CLOSEBRACE = inheritsToken('}');
	var CLOSEBRACKET = inheritsToken(']');
	var CLOSEANGLEBRACKET = inheritsToken('>');
	var CLOSEPAREN = inheritsToken(')');
	
	var AMPERSAND = inheritsToken('&');
	
	exports.Base = TextToken;
	exports.DOMAIN = DOMAIN;
	exports.AT = AT;
	exports.COLON = COLON;
	exports.DOT = DOT;
	exports.PUNCTUATION = PUNCTUATION;
	exports.LOCALHOST = LOCALHOST;
	exports.NL = NL;
	exports.NUM = NUM;
	exports.PLUS = PLUS;
	exports.POUND = POUND;
	exports.QUERY = QUERY;
	exports.PROTOCOL = PROTOCOL;
	exports.MAILTO = MAILTO;
	exports.SLASH = SLASH;
	exports.UNDERSCORE = UNDERSCORE;
	exports.SYM = SYM;
	exports.TLD = TLD;
	exports.WS = WS;
	exports.OPENBRACE = OPENBRACE;
	exports.OPENBRACKET = OPENBRACKET;
	exports.OPENANGLEBRACKET = OPENANGLEBRACKET;
	exports.OPENPAREN = OPENPAREN;
	exports.CLOSEBRACE = CLOSEBRACE;
	exports.CLOSEBRACKET = CLOSEBRACKET;
	exports.CLOSEANGLEBRACKET = CLOSEANGLEBRACKET;
	exports.CLOSEPAREN = CLOSEPAREN;
	exports.AMPERSAND = AMPERSAND;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(770),
	    isIterateeCall = __webpack_require__(165);
	
	/**
	 * Flattens a nested array. If `isDeep` is `true` the array is recursively
	 * flattened, otherwise it's only flattened a single level.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, 3, [4]]]);
	 * // => [1, 2, 3, [4]]
	 *
	 * // using `isDeep`
	 * _.flatten([1, [2, 3, [4]]], true);
	 * // => [1, 2, 3, 4]
	 */
	function flatten(array, isDeep, guard) {
	  var length = array ? array.length : 0;
	  if (guard && isIterateeCall(array, isDeep, guard)) {
	    isDeep = false;
	  }
	  return length ? baseFlatten(array, isDeep) : [];
	}
	
	module.exports = flatten;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(98);
	
	/**
	 * The base implementation of `get` without support for string paths
	 * and default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path of the property to get.
	 * @param {string} [pathKey] The key representation of path.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path, pathKey) {
	  if (object == null) {
	    return;
	  }
	  if (pathKey !== undefined && pathKey in toObject(object)) {
	    path = [pathKey];
	  }
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[path[index++]];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(774),
	    isObject = __webpack_require__(36),
	    isObjectLike = __webpack_require__(61);
	
	/**
	 * The base implementation of `_.isEqual` without support for `this` binding
	 * `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
	}
	
	module.exports = baseIsEqual;


/***/ }),
/* 229 */
/***/ (function(module, exports) {

	/**
	 * Converts `value` to a string if it's not one. An empty string is returned
	 * for `null` or `undefined` values.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  return value == null ? '' : (value + '');
	}
	
	module.exports = baseToString;


/***/ }),
/* 230 */
/***/ (function(module, exports) {

	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	module.exports = isIndex;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(229),
	    isArray = __webpack_require__(54);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `value` to property path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {Array} Returns the property path array.
	 */
	function toPath(value) {
	  if (isArray(value)) {
	    return value;
	  }
	  var result = [];
	  baseToString(value).replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	}
	
	module.exports = toPath;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(110),
	    isArray = __webpack_require__(54),
	    isArrayLike = __webpack_require__(97),
	    isFunction = __webpack_require__(354),
	    isObjectLike = __webpack_require__(61),
	    isString = __webpack_require__(803),
	    keys = __webpack_require__(111);
	
	/**
	 * Checks if `value` is empty. A value is considered empty unless it's an
	 * `arguments` object, array, string, or jQuery-like collection with a length
	 * greater than `0` or an object with own enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {Array|Object|string} value The value to inspect.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */
	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }
	  if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
	      (isObjectLike(value) && isFunction(value.splice)))) {
	    return !value.length;
	  }
	  return !keys(value).length;
	}
	
	module.exports = isEmpty;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(128),
	    isObjectLike = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dateTag] = typedArrayTags[errorTag] =
	typedArrayTags[funcTag] = typedArrayTags[mapTag] =
	typedArrayTags[numberTag] = typedArrayTags[objectTag] =
	typedArrayTags[regexpTag] = typedArrayTags[setTag] =
	typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(110),
	    isArray = __webpack_require__(54),
	    isIndex = __webpack_require__(230),
	    isLength = __webpack_require__(128),
	    isObject = __webpack_require__(36);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * A mixin for handling (effectively) onClickOutside for React components.
	 * Note that we're not intercepting any events in this approach, and we're
	 * not using double events for capturing and discarding in layers or wrappers.
	 *
	 * The idea is that components define function
	 *
	 *   handleClickOutside: function() { ... }
	 *
	 * If no such function is defined, an error will be thrown, as this means
	 * either it still needs to be written, or the component should not be using
	 * this mixing since it will not exhibit onClickOutside behaviour.
	 *
	 */
	(function (root, factory) {
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Note that this does not work with strict
	    // CommonJS, but only CommonJS-like environments
	    // that support module.exports
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.OnClickOutside = factory();
	  }
	}(this, function () {
	  "use strict";
	
	  // Use a parallel array because we can't use
	  // objects as keys, they get toString-coerced
	  var registeredComponents = [];
	  var handlers = [];
	
	  var IGNORE_CLASS = 'ignore-react-onclickoutside';
	
	  return {
	    componentDidMount: function() {
	      if(!this.handleClickOutside)
	        throw new Error("Component lacks a handleClickOutside(event) function for processing outside click events.");
	
	      var fn = this.__outsideClickHandler = (function(localNode, eventHandler) {
	        return function(evt) {
	          var source = evt.target;
	          var found = false;
	          // If source=local then this event came from "somewhere"
	          // inside and should be ignored. We could handle this with
	          // a layered approach, too, but that requires going back to
	          // thinking in terms of Dom node nesting, running counter
	          // to React's "you shouldn't care about the DOM" philosophy.
	          while(source.parentNode) {
	            found = (source === localNode || source.classList.contains(IGNORE_CLASS));
	            if(found) return;
	            source = source.parentNode;
	          }
	          eventHandler(evt);
	        }
	      }(React.findDOMNode(this), this.handleClickOutside));
	
	      var pos = registeredComponents.length;
	      registeredComponents.push(this);
	      handlers[pos] = fn;
	
	      // If there is a truthy disableOnClickOutside property for this
	      // component, don't immediately start listening for outside events.
	      if (!this.props.disableOnClickOutside) {
	        this.enableOnClickOutside();
	      }
	    },
	
	    componentWillUnmount: function() {
	      this.disableOnClickOutside();
	      this.__outsideClickHandler = false;
	      var pos = registeredComponents.indexOf(this);
	      if( pos>-1) {
	        if (handlers[pos]) {
	          // clean up so we don't leak memory
	          handlers.splice(pos, 1);
	          registeredComponents.splice(pos, 1);
	        }
	      }
	    },
	
	    /**
	     * Can be called to explicitly enable event listening
	     * for clicks and touches outside of this element.
	     */
	    enableOnClickOutside: function() {
	      var fn = this.__outsideClickHandler;
	      document.addEventListener("mousedown", fn);
	      document.addEventListener("touchstart", fn);
	    },
	
	    /**
	     * Can be called to explicitly disable event listening
	     * for clicks and touches outside of this element.
	     */
	    disableOnClickOutside: function(fn) {
	      var fn = this.__outsideClickHandler;
	      document.removeEventListener("mousedown", fn);
	      document.removeEventListener("touchstart", fn);
	    }
	  };
	
	}));


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(67);
	var assign = __webpack_require__(113);
	var qs = __webpack_require__(816);
	
	var paramCompileMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|[*.()\[\]\\+|{}^$]/g;
	var paramInjectMatcher = /:([a-zA-Z_$][a-zA-Z0-9_$?]*[?]?)|[*]/g;
	var paramInjectTrailingSlashMatcher = /\/\/\?|\/\?\/|\/\?(?![^\/=]+=.*$)/g;
	var queryMatcher = /\?(.*)$/;
	
	var _compiledPatterns = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in _compiledPatterns)) {
	    var paramNames = [];
	    var source = pattern.replace(paramCompileMatcher, function (match, paramName) {
	      if (paramName) {
	        paramNames.push(paramName);
	        return '([^/?#]+)';
	      } else if (match === '*') {
	        paramNames.push('splat');
	        return '(.*?)';
	      } else {
	        return '\\' + match;
	      }
	    });
	
	    _compiledPatterns[pattern] = {
	      matcher: new RegExp('^' + source + '$', 'i'),
	      paramNames: paramNames
	    };
	  }
	
	  return _compiledPatterns[pattern];
	}
	
	var PathUtils = {
	
	  /**
	   * Returns true if the given path is absolute.
	   */
	  isAbsolute: function isAbsolute(path) {
	    return path.charAt(0) === '/';
	  },
	
	  /**
	   * Joins two URL paths together.
	   */
	  join: function join(a, b) {
	    return a.replace(/\/*$/, '/') + b;
	  },
	
	  /**
	   * Returns an array of the names of all parameters in the given pattern.
	   */
	  extractParamNames: function extractParamNames(pattern) {
	    return compilePattern(pattern).paramNames;
	  },
	
	  /**
	   * Extracts the portions of the given URL path that match the given pattern
	   * and returns an object of param name => value pairs. Returns null if the
	   * pattern does not match the given path.
	   */
	  extractParams: function extractParams(pattern, path) {
	    var _compilePattern = compilePattern(pattern);
	
	    var matcher = _compilePattern.matcher;
	    var paramNames = _compilePattern.paramNames;
	
	    var match = path.match(matcher);
	
	    if (!match) return null;
	
	    var params = {};
	
	    paramNames.forEach(function (paramName, index) {
	      params[paramName] = match[index + 1];
	    });
	
	    return params;
	  },
	
	  /**
	   * Returns a version of the given route path with params interpolated. Throws
	   * if there is a dynamic segment of the route path for which there is no param.
	   */
	  injectParams: function injectParams(pattern, params) {
	    params = params || {};
	
	    var splatIndex = 0;
	
	    return pattern.replace(paramInjectMatcher, function (match, paramName) {
	      paramName = paramName || 'splat';
	
	      // If param is optional don't check for existence
	      if (paramName.slice(-1) === '?') {
	        paramName = paramName.slice(0, -1);
	
	        if (params[paramName] == null) return '';
	      } else {
	        invariant(params[paramName] != null, 'Missing "%s" parameter for path "%s"', paramName, pattern);
	      }
	
	      var segment;
	      if (paramName === 'splat' && Array.isArray(params[paramName])) {
	        segment = params[paramName][splatIndex++];
	
	        invariant(segment != null, 'Missing splat # %s for path "%s"', splatIndex, pattern);
	      } else {
	        segment = params[paramName];
	      }
	
	      return segment;
	    }).replace(paramInjectTrailingSlashMatcher, '/');
	  },
	
	  /**
	   * Returns an object that is the result of parsing any query string contained
	   * in the given path, null if the path contains no query string.
	   */
	  extractQuery: function extractQuery(path) {
	    var match = path.match(queryMatcher);
	    return match && qs.parse(match[1]);
	  },
	
	  /**
	   * Returns a version of the given path without the query string.
	   */
	  withoutQuery: function withoutQuery(path) {
	    return path.replace(queryMatcher, '');
	  },
	
	  /**
	   * Returns a version of the given path with the parameters in the given
	   * query merged into the query string.
	   */
	  withQuery: function withQuery(path, query) {
	    var existingQuery = PathUtils.extractQuery(path);
	
	    if (existingQuery) query = query ? assign(existingQuery, query) : existingQuery;
	
	    var queryString = qs.stringify(query, { arrayFormat: 'brackets' });
	
	    if (queryString) return PathUtils.withoutQuery(path) + '?' + queryString;
	
	    return PathUtils.withoutQuery(path);
	  }
	
	};
	
	module.exports = PathUtils;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(130);
	var History = __webpack_require__(112);
	
	var _listeners = [];
	var _isListening = false;
	
	function notifyChange(type) {
	  var change = {
	    path: HistoryLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HistoryLocation, change);
	  });
	}
	
	function onPopState(event) {
	  if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	  notifyChange(LocationActions.POP);
	}
	
	/**
	 * A Location that uses HTML5 history.
	 */
	var HistoryLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener('popstate', onPopState, false);
	      } else {
	        window.attachEvent('onpopstate', onPopState);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.addEventListener) {
	        window.removeEventListener('popstate', onPopState, false);
	      } else {
	        window.removeEvent('onpopstate', onPopState);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    window.history.pushState({ path: path }, '', path);
	    History.length += 1;
	    notifyChange(LocationActions.PUSH);
	  },
	
	  replace: function replace(path) {
	    window.history.replaceState({ path: path }, '', path);
	    notifyChange(LocationActions.REPLACE);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(window.location.pathname + window.location.search);
	  },
	
	  toString: function toString() {
	    return '<HistoryLocation>';
	  }
	
	};
	
	module.exports = HistoryLocation;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of https://github.com/facebook/react/tree/0.13-stable.
	 * An additional grant of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	"use strict";
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function warning() {};
	
	if (__DEV__) {
	  warning = function (condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.length < 10 || /^[s\W]*$/.test(format)) {
	      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      console.warn(message);
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(378);
	var ExecutionEnvironment = __webpack_require__(30);
	
	var camelizeStyleName = __webpack_require__(900);
	var dangerousStyleValue = __webpack_require__(905);
	var hyphenateStyleName = __webpack_require__(912);
	var memoizeStringOnly = __webpack_require__(916);
	var warning = __webpack_require__(17);
	
	var processStyleName = memoizeStringOnly(function(styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	
	  var warnHyphenatedStyleName = function(name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'Unsupported style property %s. Did you mean %s?',
	      name,
	      camelizeStyleName(name)
	    ) : null);
	  };
	
	  var warnBadVendoredStyleName = function(name) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'Unsupported vendor-prefixed style property %s. Did you mean %s?',
	      name,
	      name.charAt(0).toUpperCase() + name.slice(1)
	    ) : null);
	  };
	
	  var warnStyleValueWithSemicolon = function(name, value) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'Style property values shouldn\'t contain a semicolon. ' +
	      'Try "%s: %s" instead.',
	      name,
	      value.replace(badStyleValueWithSemicolonPattern, '')
	    ) : null);
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   */
	  var warnValidStyle = function(name, value) {
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @return {?string}
	   */
	  createMarkupForStyles: function(styles) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   */
	  setValueForStyles: function(node, styles) {
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName]);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName]);
	      if (styleName === 'float') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(70);
	
	var assign = __webpack_require__(11);
	var invariant = __webpack_require__(6);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      ( false ? invariant(
	        callbacks.length === contexts.length,
	        'Mismatched list of contexts in callback queue'
	      ) : invariant(callbacks.length === contexts.length));
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0, l = callbacks.length; i < l; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function() {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function() {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `Mount`: [required] Module that can convert between React dom IDs and
	 *   actual node references.
	 */
	var injection = {
	  Mount: null,
	  injectMount: function(InjectedMount) {
	    injection.Mount = InjectedMount;
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? invariant(
	        InjectedMount && InjectedMount.getNode,
	        'EventPluginUtils.injection.injectMount(...): Injected Mount module ' +
	        'is missing getNode.'
	      ) : invariant(InjectedMount && InjectedMount.getNode));
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp ||
	         topLevelType === topLevelTypes.topTouchEnd ||
	         topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove ||
	         topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown ||
	         topLevelType === topLevelTypes.topTouchStart;
	}
	
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function(event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchIDs = event._dispatchIDs;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var idsIsArr = Array.isArray(dispatchIDs);
	    var IDsLen = idsIsArr ? dispatchIDs.length : dispatchIDs ? 1 : 0;
	    var listenersLen = listenersIsArr ?
	      dispatchListeners.length :
	      dispatchListeners ? 1 : 0;
	
	    ("production" !== process.env.NODE_ENV ? invariant(
	      idsIsArr === listenersIsArr && IDsLen === listenersLen,
	      'EventPluginUtils: Invalid `event`.'
	    ) : invariant(idsIsArr === listenersIsArr && IDsLen === listenersLen));
	  };
	}
	
	/**
	 * Invokes `cb(event, listener, id)`. Avoids using call if no scope is
	 * provided. The `(listener,id)` pair effectively forms the "dispatch" but are
	 * kept separate to conserve memory.
	 */
	function forEachEventDispatch(event, cb) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      cb(event, dispatchListeners[i], dispatchIDs[i]);
	    }
	  } else if (dispatchListeners) {
	    cb(event, dispatchListeners, dispatchIDs);
	  }
	}
	
	/**
	 * Default implementation of PluginModule.executeDispatch().
	 * @param {SyntheticEvent} SyntheticEvent to handle
	 * @param {function} Application-level callback
	 * @param {string} domID DOM id to pass to the callback.
	 */
	function executeDispatch(event, listener, domID) {
	  event.currentTarget = injection.Mount.getNode(domID);
	  var returnValue = listener(event, domID);
	  event.currentTarget = null;
	  return returnValue;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, cb) {
	  forEachEventDispatch(event, cb);
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return id of the first dispatch execution who's listener returns true, or
	 * null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchIDs = event._dispatchIDs;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and IDs are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchIDs[i])) {
	        return dispatchIDs[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchIDs)) {
	      return dispatchIDs;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchIDs = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchID = event._dispatchIDs;
	  ( false ? invariant(
	    !Array.isArray(dispatchListener),
	    'executeDirectDispatch(...): Invalid `event`.'
	  ) : invariant(!Array.isArray(dispatchListener)));
	  var res = dispatchListener ?
	    dispatchListener(event, dispatchID) :
	    null;
	  event._dispatchListeners = null;
	  event._dispatchIDs = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {bool} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatch: executeDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	  injection: injection,
	  useTouchEvents: false
	};
	
	module.exports = EventPluginUtils;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactPropTypes = __webpack_require__(387);
	
	var invariant = __webpack_require__(6);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(input) {
	  ( false ? invariant(
	    input.props.checkedLink == null || input.props.valueLink == null,
	    'Cannot provide a checkedLink and a valueLink. If you want to use ' +
	    'checkedLink, you probably don\'t want to use valueLink and vice versa.'
	  ) : invariant(input.props.checkedLink == null || input.props.valueLink == null));
	}
	function _assertValueLink(input) {
	  _assertSingleLink(input);
	  ( false ? invariant(
	    input.props.value == null && input.props.onChange == null,
	    'Cannot provide a valueLink and a value or onChange event. If you want ' +
	    'to use value or onChange, you probably don\'t want to use valueLink.'
	  ) : invariant(input.props.value == null && input.props.onChange == null));
	}
	
	function _assertCheckedLink(input) {
	  _assertSingleLink(input);
	  ( false ? invariant(
	    input.props.checked == null && input.props.onChange == null,
	    'Cannot provide a checkedLink and a checked property or onChange event. ' +
	    'If you want to use checked or onChange, you probably don\'t want to ' +
	    'use checkedLink'
	  ) : invariant(input.props.checked == null && input.props.onChange == null));
	}
	
	/**
	 * @param {SyntheticEvent} e change event to handle
	 */
	function _handleLinkedValueChange(e) {
	  /*jshint validthis:true */
	  this.props.valueLink.requestChange(e.target.value);
	}
	
	/**
	  * @param {SyntheticEvent} e change event to handle
	  */
	function _handleLinkedCheckChange(e) {
	  /*jshint validthis:true */
	  this.props.checkedLink.requestChange(e.target.checked);
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  Mixin: {
	    propTypes: {
	      value: function(props, propName, componentName) {
	        if (!props[propName] ||
	            hasReadOnlyValue[props.type] ||
	            props.onChange ||
	            props.readOnly ||
	            props.disabled) {
	          return null;
	        }
	        return new Error(
	          'You provided a `value` prop to a form field without an ' +
	          '`onChange` handler. This will render a read-only field. If ' +
	          'the field should be mutable use `defaultValue`. Otherwise, ' +
	          'set either `onChange` or `readOnly`.'
	        );
	      },
	      checked: function(props, propName, componentName) {
	        if (!props[propName] ||
	            props.onChange ||
	            props.readOnly ||
	            props.disabled) {
	          return null;
	        }
	        return new Error(
	          'You provided a `checked` prop to a form field without an ' +
	          '`onChange` handler. This will render a read-only field. If ' +
	          'the field should be mutable use `defaultChecked`. Otherwise, ' +
	          'set either `onChange` or `readOnly`.'
	        );
	      },
	      onChange: ReactPropTypes.func
	    }
	  },
	
	  /**
	   * @param {ReactComponent} input Form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function(input) {
	    if (input.props.valueLink) {
	      _assertValueLink(input);
	      return input.props.valueLink.value;
	    }
	    return input.props.value;
	  },
	
	  /**
	   * @param {ReactComponent} input Form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function(input) {
	    if (input.props.checkedLink) {
	      _assertCheckedLink(input);
	      return input.props.checkedLink.value;
	    }
	    return input.props.checked;
	  },
	
	  /**
	   * @param {ReactComponent} input Form component
	   * @return {function} change callback either from onChange prop or link.
	   */
	  getOnChange: function(input) {
	    if (input.props.valueLink) {
	      _assertValueLink(input);
	      return _handleLinkedValueChange;
	    } else if (input.props.checkedLink) {
	      _assertCheckedLink(input);
	      return _handleLinkedCheckChange;
	    }
	    return input.props.onChange;
	  }
	};
	
	module.exports = LinkedValueUtils;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LocalEventTrapMixin
	 */
	
	'use strict';
	
	var ReactBrowserEventEmitter = __webpack_require__(115);
	
	var accumulateInto = __webpack_require__(253);
	var forEachAccumulated = __webpack_require__(254);
	var invariant = __webpack_require__(6);
	
	function remove(event) {
	  event.remove();
	}
	
	var LocalEventTrapMixin = {
	  trapBubbledEvent:function(topLevelType, handlerBaseName) {
	    ( false ? invariant(this.isMounted(), 'Must be mounted to trap events') : invariant(this.isMounted()));
	    // If a component renders to null or if another component fatals and causes
	    // the state of the tree to be corrupted, `node` here can be null.
	    var node = this.getDOMNode();
	    ( false ? invariant(
	      node,
	      'LocalEventTrapMixin.trapBubbledEvent(...): Requires node to be rendered.'
	    ) : invariant(node));
	    var listener = ReactBrowserEventEmitter.trapBubbledEvent(
	      topLevelType,
	      handlerBaseName,
	      node
	    );
	    this._localEventListeners =
	      accumulateInto(this._localEventListeners, listener);
	  },
	
	  // trapCapturedEvent would look nearly identical. We don't implement that
	  // method because it isn't currently needed.
	
	  componentWillUnmount:function() {
	    if (this._localEventListeners) {
	      forEachAccumulated(this._localEventListeners, remove);
	    }
	  }
	};
	
	module.exports = LocalEventTrapMixin;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var ReactDOMIDOperations = __webpack_require__(382);
	var ReactMount = __webpack_require__(73);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates:
	    ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkupByID:
	    ReactDOMIDOperations.dangerouslyReplaceNodeWithMarkupByID,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function(rootNodeID) {
	    ReactMount.purgeID(rootNodeID);
	  }
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(6);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkupByID: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function(environment) {
	      ( false ? invariant(
	        !injected,
	        'ReactCompositeComponent: injectEnvironment() can only be called once.'
	      ) : invariant(!injected));
	      ReactComponentEnvironment.unmountIDFromEnvironment =
	        environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkupByID =
	        environment.replaceNodeWithMarkupByID;
	      ReactComponentEnvironment.processChildrenUpdates =
	        environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactContext
	 */
	
	'use strict';
	
	var assign = __webpack_require__(11);
	var emptyObject = __webpack_require__(176);
	var warning = __webpack_require__(17);
	
	var didWarn = false;
	
	/**
	 * Keeps track of the current context.
	 *
	 * The context is automatically passed down the component ownership hierarchy
	 * and is accessible via `this.context` on ReactCompositeComponents.
	 */
	var ReactContext = {
	
	  /**
	   * @internal
	   * @type {object}
	   */
	  current: emptyObject,
	
	  /**
	   * Temporarily extends the current context while executing scopedCallback.
	   *
	   * A typical use case might look like
	   *
	   *  render: function() {
	   *    var children = ReactContext.withContext({foo: 'foo'}, () => (
	   *
	   *    ));
	   *    return <div>{children}</div>;
	   *  }
	   *
	   * @param {object} newContext New context to merge into the existing context
	   * @param {function} scopedCallback Callback to run with the new context
	   * @return {ReactComponent|array<ReactComponent>}
	   */
	  withContext: function(newContext, scopedCallback) {
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        didWarn,
	        'withContext is deprecated and will be removed in a future version. ' +
	        'Use a wrapper component with getChildContext instead.'
	      ) : null);
	
	      didWarn = true;
	    }
	
	    var result;
	    var previousContext = ReactContext.current;
	    ReactContext.current = assign({}, previousContext, newContext);
	    try {
	      result = scopedCallback();
	    } finally {
	      ReactContext.current = previousContext;
	    }
	    return result;
	  }
	
	};
	
	module.exports = ReactContext;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 * @typechecks static-only
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var CSSPropertyOperations = __webpack_require__(239);
	var DOMProperty = __webpack_require__(114);
	var DOMPropertyOperations = __webpack_require__(131);
	var ReactBrowserEventEmitter = __webpack_require__(115);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(244);
	var ReactMount = __webpack_require__(73);
	var ReactMultiChild = __webpack_require__(876);
	var ReactPerf = __webpack_require__(100);
	
	var assign = __webpack_require__(11);
	var escapeTextContentForBrowser = __webpack_require__(177);
	var invariant = __webpack_require__(6);
	var isEventSupported = __webpack_require__(259);
	var keyOf = __webpack_require__(74);
	var warning = __webpack_require__(17);
	
	var deleteListener = ReactBrowserEventEmitter.deleteListener;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = ReactBrowserEventEmitter.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = {'string': true, 'number': true};
	
	var STYLE = keyOf({style: null});
	
	var ELEMENT_NODE_TYPE = 1;
	
	/**
	 * Optionally injectable operations for mutating the DOM
	 */
	var BackendIDOperations = null;
	
	/**
	 * @param {?object} props
	 */
	function assertValidProps(props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (props.dangerouslySetInnerHTML != null) {
	    ( false ? invariant(
	      props.children == null,
	      'Can only set one of `children` or `props.dangerouslySetInnerHTML`.'
	    ) : invariant(props.children == null));
	    ( false ? invariant(
	      typeof props.dangerouslySetInnerHTML === 'object' &&
	      '__html' in props.dangerouslySetInnerHTML,
	      '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. ' +
	      'Please visit https://fb.me/react-invariant-dangerously-set-inner-html ' +
	      'for more information.'
	    ) : invariant(typeof props.dangerouslySetInnerHTML === 'object' &&
	    '__html' in props.dangerouslySetInnerHTML));
	  }
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      props.innerHTML == null,
	      'Directly setting property `innerHTML` is not permitted. ' +
	      'For more information, lookup documentation on `dangerouslySetInnerHTML`.'
	    ) : null);
	    ("production" !== process.env.NODE_ENV ? warning(
	      !props.contentEditable || props.children == null,
	      'A component is `contentEditable` and contains `children` managed by ' +
	      'React. It is now your responsibility to guarantee that none of ' +
	      'those nodes are unexpectedly modified or duplicated. This is ' +
	      'probably not intentional.'
	    ) : null);
	  }
	  ( false ? invariant(
	    props.style == null || typeof props.style === 'object',
	    'The `style` prop expects a mapping from style properties to values, ' +
	    'not a string. For example, style={{marginRight: spacing + \'em\'}} when ' +
	    'using JSX.'
	  ) : invariant(props.style == null || typeof props.style === 'object'));
	}
	
	function putListener(id, registrationName, listener, transaction) {
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    ("production" !== process.env.NODE_ENV ? warning(
	      registrationName !== 'onScroll' || isEventSupported('scroll', true),
	      'This browser doesn\'t support the `onScroll` event'
	    ) : null);
	  }
	  var container = ReactMount.findReactContainerForID(id);
	  if (container) {
	    var doc = container.nodeType === ELEMENT_NODE_TYPE ?
	      container.ownerDocument :
	      container;
	    listenTo(registrationName, doc);
	  }
	  transaction.getPutListenerQueue().enqueuePutListener(
	    id,
	    registrationName,
	    listener
	  );
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special cased tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	// We accept any tag to be rendered but since this gets injected into abitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    ( false ? invariant(VALID_TAG_REGEX.test(tag), 'Invalid tag: %s', tag) : invariant(VALID_TAG_REGEX.test(tag)));
	    validatedTagCache[tag] = true;
	  }
	}
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(tag) {
	  validateDangerousTag(tag);
	  this._tag = tag;
	  this._renderedChildren = null;
	  this._previousStyleCopy = null;
	  this._rootNodeID = null;
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  construct: function(element) {
	    this._currentElement = element;
	  },
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {string} rootID The root DOM ID for this node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} The computed markup.
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._rootNodeID = rootID;
	    assertValidProps(this._currentElement.props);
	    var closeTag = omittedCloseTags[this._tag] ? '' : '</' + this._tag + '>';
	    return (
	      this._createOpenTagMarkupAndPutListeners(transaction) +
	      this._createContentMarkup(transaction, context) +
	      closeTag
	    );
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function(transaction) {
	    var props = this._currentElement.props;
	    var ret = '<' + this._tag;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        putListener(this._rootNodeID, propKey, propValue, transaction);
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            propValue = this._previousStyleCopy = assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue);
	        }
	        var markup =
	          DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret + '>';
	    }
	
	    var markupForID = DOMPropertyOperations.createMarkupForID(this._rootNodeID);
	    return ret + ' ' + markupForID + '>';
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function(transaction, context) {
	    var prefix = '';
	    if (this._tag === 'listing' ||
	        this._tag === 'pre' ||
	        this._tag === 'textarea') {
	      // Add an initial newline because browsers ignore the first newline in
	      // a <listing>, <pre>, or <textarea> as an "authoring convenience" -- see
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody.
	      prefix = '\n';
	    }
	
	    var props = this._currentElement.props;
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        return prefix + innerHTML.__html;
	      }
	    } else {
	      var contentToUse =
	        CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        return prefix + escapeTextContentForBrowser(contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(
	          childrenToUse,
	          transaction,
	          context
	        );
	        return prefix + mountImages.join('');
	      }
	    }
	    return prefix;
	  },
	
	  receiveComponent: function(nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a native DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function(transaction, prevElement, nextElement, context) {
	    assertValidProps(this._currentElement.props);
	    this._updateDOMProperties(prevElement.props, transaction);
	    this._updateDOMChildren(prevElement.props, transaction, context);
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {ReactReconcileTransaction} transaction
	   */
	  _updateDOMProperties: function(lastProps, transaction) {
	    var nextProps = this._currentElement.props;
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) ||
	         !lastProps.hasOwnProperty(propKey)) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        deleteListener(this._rootNodeID, propKey);
	      } else if (
	          DOMProperty.isStandardName[propKey] ||
	          DOMProperty.isCustomAttribute(propKey)) {
	        BackendIDOperations.deletePropertyByID(
	          this._rootNodeID,
	          propKey
	        );
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ?
	        this._previousStyleCopy :
	        lastProps[propKey];
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          nextProp = this._previousStyleCopy = assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) &&
	                (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) &&
	                lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        putListener(this._rootNodeID, propKey, nextProp, transaction);
	      } else if (
	          DOMProperty.isStandardName[propKey] ||
	          DOMProperty.isCustomAttribute(propKey)) {
	        BackendIDOperations.updatePropertyByID(
	          this._rootNodeID,
	          propKey,
	          nextProp
	        );
	      }
	    }
	    if (styleUpdates) {
	      BackendIDOperations.updateStylesByID(
	        this._rootNodeID,
	        styleUpdates
	      );
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {ReactReconcileTransaction} transaction
	   */
	  _updateDOMChildren: function(lastProps, transaction, context) {
	    var nextProps = this._currentElement.props;
	
	    var lastContent =
	      CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent =
	      CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml =
	      lastProps.dangerouslySetInnerHTML &&
	      lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml =
	      nextProps.dangerouslySetInnerHTML &&
	      nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        BackendIDOperations.updateInnerHTMLByID(
	          this._rootNodeID,
	          nextHtml
	        );
	      }
	    } else if (nextChildren != null) {
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function() {
	    this.unmountChildren();
	    ReactBrowserEventEmitter.deleteAllListeners(this._rootNodeID);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	  }
	
	};
	
	ReactPerf.measureMethods(ReactDOMComponent, 'ReactDOMComponent', {
	  mountComponent: 'mountComponent',
	  updateComponent: 'updateComponent'
	});
	
	assign(
	  ReactDOMComponent.prototype,
	  ReactDOMComponent.Mixin,
	  ReactMultiChild.Mixin
	);
	
	ReactDOMComponent.injection = {
	  injectIDOperations: function(IDOperations) {
	    ReactDOMComponent.BackendIDOperations = BackendIDOperations = IDOperations;
	  }
	};
	
	module.exports = ReactDOMComponent;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	var ReactInstanceMap = __webpack_require__(117);
	
	var invariant = __webpack_require__(6);
	
	var component;
	// This registry keeps track of the React IDs of the components that rendered to
	// `null` (in reality a placeholder such as `noscript`)
	var nullComponentIDsRegistry = {};
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponent: function(emptyComponent) {
	    component = ReactElement.createFactory(emptyComponent);
	  }
	};
	
	var ReactEmptyComponentType = function() {};
	ReactEmptyComponentType.prototype.componentDidMount = function() {
	  var internalInstance = ReactInstanceMap.get(this);
	  // TODO: Make sure we run these methods in the correct order, we shouldn't
	  // need this check. We're going to assume if we're here it means we ran
	  // componentWillUnmount already so there is no internal instance (it gets
	  // removed as part of the unmounting process).
	  if (!internalInstance) {
	    return;
	  }
	  registerNullComponentID(internalInstance._rootNodeID);
	};
	ReactEmptyComponentType.prototype.componentWillUnmount = function() {
	  var internalInstance = ReactInstanceMap.get(this);
	  // TODO: Get rid of this check. See TODO in componentDidMount.
	  if (!internalInstance) {
	    return;
	  }
	  deregisterNullComponentID(internalInstance._rootNodeID);
	};
	ReactEmptyComponentType.prototype.render = function() {
	  ( false ? invariant(
	    component,
	    'Trying to return null from a render, but no null placeholder component ' +
	    'was injected.'
	  ) : invariant(component));
	  return component();
	};
	
	var emptyElement = ReactElement.createElement(ReactEmptyComponentType);
	
	/**
	 * Mark the component as having rendered to null.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function registerNullComponentID(id) {
	  nullComponentIDsRegistry[id] = true;
	}
	
	/**
	 * Unmark the component as having rendered to null: it renders to something now.
	 * @param {string} id Component's `_rootNodeID`.
	 */
	function deregisterNullComponentID(id) {
	  delete nullComponentIDsRegistry[id];
	}
	
	/**
	 * @param {string} id Component's `_rootNodeID`.
	 * @return {boolean} True if the component is rendered to null.
	 */
	function isNullComponentID(id) {
	  return !!nullComponentIDsRegistry[id];
	}
	
	var ReactEmptyComponent = {
	  emptyElement: emptyElement,
	  injection: ReactEmptyComponentInjection,
	  isNullComponentID: isNullComponentID
	};
	
	module.exports = ReactEmptyComponent;


/***/ }),
/* 249 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactLifeCycle
	 */
	
	'use strict';
	
	/**
	 * This module manages the bookkeeping when a component is in the process
	 * of being mounted or being unmounted. This is used as a way to enforce
	 * invariants (or warnings) when it is not recommended to call
	 * setState/forceUpdate.
	 *
	 * currentlyMountingInstance: During the construction phase, it is not possible
	 * to trigger an update since the instance is not fully mounted yet. However, we
	 * currently allow this as a convenience for mutating the initial state.
	 *
	 * currentlyUnmountingInstance: During the unmounting phase, the instance is
	 * still mounted and can therefore schedule an update. However, this is not
	 * recommended and probably an error since it's about to be unmounted.
	 * Therefore we still want to trigger in an error for that case.
	 */
	
	var ReactLifeCycle = {
	  currentlyMountingInstance: null,
	  currentlyUnmountingInstance: null
	};
	
	module.exports = ReactLifeCycle;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(137);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var ReactLifeCycle = __webpack_require__(249);
	var ReactCurrentOwner = __webpack_require__(72);
	var ReactElement = __webpack_require__(16);
	var ReactInstanceMap = __webpack_require__(117);
	var ReactUpdates = __webpack_require__(62);
	
	var assign = __webpack_require__(11);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(17);
	
	function enqueueUpdate(internalInstance) {
	  if (internalInstance !== ReactLifeCycle.currentlyMountingInstance) {
	    // If we're in a componentWillMount handler, don't enqueue a rerender
	    // because ReactUpdates assumes we're in a browser context (which is
	    // wrong for server rendering) and we're about to do a render anyway.
	    // See bug in #1740.
	    ReactUpdates.enqueueUpdate(internalInstance);
	  }
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  ( false ? invariant(
	    ReactCurrentOwner.current == null,
	    '%s(...): Cannot update during an existing state transition ' +
	    '(such as within `render`). Render methods should be a pure function ' +
	    'of props and state.',
	    callerName
	  ) : invariant(ReactCurrentOwner.current == null));
	
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      ("production" !== process.env.NODE_ENV ? warning(
	        !callerName,
	        '%s(...): Can only update a mounted or mounting component. ' +
	        'This usually means you called %s() on an unmounted ' +
	        'component. This is a no-op.',
	        callerName,
	        callerName
	      ) : null);
	    }
	    return null;
	  }
	
	  if (internalInstance === ReactLifeCycle.currentlyUnmountingInstance) {
	    return null;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function(publicInstance, callback) {
	    ( false ? invariant(
	      typeof callback === 'function',
	      'enqueueCallback(...): You called `setProps`, `replaceProps`, ' +
	      '`setState`, `replaceState`, or `forceUpdate` with a callback that ' +
	      'isn\'t callable.'
	    ) : invariant(typeof callback === 'function'));
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance ||
	        internalInstance === ReactLifeCycle.currentlyMountingInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function(internalInstance, callback) {
	    ( false ? invariant(
	      typeof callback === 'function',
	      'enqueueCallback(...): You called `setProps`, `replaceProps`, ' +
	      '`setState`, `replaceState`, or `forceUpdate` with a callback that ' +
	      'isn\'t callable.'
	    ) : invariant(typeof callback === 'function'));
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldUpdateComponent`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function(publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'forceUpdate'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function(publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'replaceState'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function(publicInstance, partialState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'setState'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue =
	      internalInstance._pendingStateQueue ||
	      (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialProps Subset of the next props.
	   * @internal
	   */
	  enqueueSetProps: function(publicInstance, partialProps) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'setProps'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    ( false ? invariant(
	      internalInstance._isTopLevel,
	      'setProps(...): You called `setProps` on a ' +
	      'component with a parent. This is an anti-pattern since props will ' +
	      'get reactively updated when rendered. Instead, change the owner\'s ' +
	      '`render` method to pass the correct value as props to the component ' +
	      'where it is created.'
	    ) : invariant(internalInstance._isTopLevel));
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var element = internalInstance._pendingElement ||
	                  internalInstance._currentElement;
	    var props = assign({}, element.props, partialProps);
	    internalInstance._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      props
	    );
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the props.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} props New props.
	   * @internal
	   */
	  enqueueReplaceProps: function(publicInstance, props) {
	    var internalInstance = getInternalInstanceReadyForUpdate(
	      publicInstance,
	      'replaceProps'
	    );
	
	    if (!internalInstance) {
	      return;
	    }
	
	    ( false ? invariant(
	      internalInstance._isTopLevel,
	      'replaceProps(...): You called `replaceProps` on a ' +
	      'component with a parent. This is an anti-pattern since props will ' +
	      'get reactively updated when rendered. Instead, change the owner\'s ' +
	      '`render` method to pass the correct value as props to the component ' +
	      'where it is created.'
	    ) : invariant(internalInstance._isTopLevel));
	
	    // Merge with the pending element if it exists, otherwise with existing
	    // element props.
	    var element = internalInstance._pendingElement ||
	                  internalInstance._currentElement;
	    internalInstance._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      props
	    );
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function(internalInstance, newElement) {
	    internalInstance._pendingElement = newElement;
	    enqueueUpdate(internalInstance);
	  }
	
	};
	
	module.exports = ReactUpdateQueue;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function(scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(6);
	
	/**
	 *
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  ( false ? invariant(
	    next != null,
	    'accumulateInto(...): Accumulated items must not be null or undefined.'
	  ) : invariant(next != null));
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  var currentIsArray = Array.isArray(current);
	  var nextIsArray = Array.isArray(next);
	
	  if (currentIsArray && nextIsArray) {
	    current.push.apply(current, next);
	    return current;
	  }
	
	  if (currentIsArray) {
	    current.push(next);
	    return current;
	  }
	
	  if (nextIsArray) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;


/***/ }),
/* 254 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 */
	
	'use strict';
	
	/**
	 * @param {array} an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	var forEachAccumulated = function(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	};
	
	module.exports = forEachAccumulated;


/***/ }),
/* 255 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `charCode` property.
	 */
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;


/***/ }),
/* 256 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  /*jshint validthis:true */
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;


/***/ }),
/* 257 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCompositeComponent = __webpack_require__(859);
	var ReactEmptyComponent = __webpack_require__(248);
	var ReactNativeComponent = __webpack_require__(172);
	
	var assign = __webpack_require__(11);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(17);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function() { };
	assign(
	  ReactCompositeComponentWrapper.prototype,
	  ReactCompositeComponent.Mixin,
	  {
	    _instantiateReactComponent: instantiateReactComponent
	  }
	);
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return (
	    typeof type === 'function' &&
	    typeof type.prototype !== 'undefined' &&
	    typeof type.prototype.mountComponent === 'function' &&
	    typeof type.prototype.receiveComponent === 'function'
	  );
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {*} parentCompositeType The composite type that resolved this.
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, parentCompositeType) {
	  var instance;
	
	  if (node === null || node === false) {
	    node = ReactEmptyComponent.emptyElement;
	  }
	
	  if (typeof node === 'object') {
	    var element = node;
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        element && (typeof element.type === 'function' ||
	                    typeof element.type === 'string'),
	        'Only functions or strings can be mounted as React components.'
	      ) : null);
	    }
	
	    // Special case string values
	    if (parentCompositeType === element.type &&
	        typeof element.type === 'string') {
	      // Avoid recursion if the wrapper renders itself.
	      instance = ReactNativeComponent.createInternalComponent(element);
	      // All native components are currently wrapped in a composite so we're
	      // safe to assume that this is what we should instantiate.
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // represenations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	    } else {
	      instance = new ReactCompositeComponentWrapper();
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactNativeComponent.createInstanceForText(node);
	  } else {
	    ( false ? invariant(
	      false,
	      'Encountered invalid React node of type %s',
	      typeof node
	    ) : invariant(false));
	  }
	
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      typeof instance.construct === 'function' &&
	      typeof instance.mountComponent === 'function' &&
	      typeof instance.receiveComponent === 'function' &&
	      typeof instance.unmountComponent === 'function',
	      'Only React Components can be mounted.'
	    ) : null);
	  }
	
	  // Sets up the instance. This can probably just move into the constructor now.
	  instance.construct(node);
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._isOwnerNecessary = false;
	    instance._warnedAboutRefsInRender = false;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature =
	    document.implementation &&
	    document.implementation.hasFeature &&
	    // always returns true in newer browsers as per the standard.
	    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	    document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM ||
	      capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = function(node, html) {
	  node.innerHTML = html;
	};
	
	// Win8 apps: Allow all html to be inserted
	if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	  setInnerHTML = function(node, html) {
	    MSApp.execUnsafeLocalFunction(function() {
	      node.innerHTML = html;
	    });
	  };
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function(node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) ||
	          html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        node.innerHTML = '\uFEFF' + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	}
	
	module.exports = setInnerHTML;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var warning = __webpack_require__(17);
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  if (prevElement != null && nextElement != null) {
	    var prevType = typeof prevElement;
	    var nextType = typeof nextElement;
	    if (prevType === 'string' || prevType === 'number') {
	      return (nextType === 'string' || nextType === 'number');
	    } else {
	      if (nextType === 'object' &&
	          prevElement.type === nextElement.type &&
	          prevElement.key === nextElement.key) {
	        var ownersMatch = prevElement._owner === nextElement._owner;
	        var prevName = null;
	        var nextName = null;
	        var nextDisplayName = null;
	        if (false) {
	          if (!ownersMatch) {
	            if (prevElement._owner != null &&
	                prevElement._owner.getPublicInstance() != null &&
	                prevElement._owner.getPublicInstance().constructor != null) {
	              prevName =
	                prevElement._owner.getPublicInstance().constructor.displayName;
	            }
	            if (nextElement._owner != null &&
	                nextElement._owner.getPublicInstance() != null &&
	                nextElement._owner.getPublicInstance().constructor != null) {
	              nextName =
	                nextElement._owner.getPublicInstance().constructor.displayName;
	            }
	            if (nextElement.type != null &&
	                nextElement.type.displayName != null) {
	              nextDisplayName = nextElement.type.displayName;
	            }
	            if (nextElement.type != null && typeof nextElement.type === 'string') {
	              nextDisplayName = nextElement.type;
	            }
	            if (typeof nextElement.type !== 'string' ||
	                nextElement.type === 'input' ||
	                nextElement.type === 'textarea') {
	              if ((prevElement._owner != null &&
	                  prevElement._owner._isOwnerNecessary === false) ||
	                  (nextElement._owner != null &&
	                  nextElement._owner._isOwnerNecessary === false)) {
	                if (prevElement._owner != null) {
	                  prevElement._owner._isOwnerNecessary = true;
	                }
	                if (nextElement._owner != null) {
	                  nextElement._owner._isOwnerNecessary = true;
	                }
	                ("production" !== process.env.NODE_ENV ? warning(
	                  false,
	                  '<%s /> is being rendered by both %s and %s using the same ' +
	                  'key (%s) in the same place. Currently, this means that ' +
	                  'they don\'t preserve state. This behavior should be very ' +
	                  'rare so we\'re considering deprecating it. Please contact ' +
	                  'the React team and explain your use case so that we can ' +
	                  'take that into consideration.',
	                  nextDisplayName || 'Unknown Component',
	                  prevName || '[Unknown]',
	                  nextName || '[Unknown]',
	                  prevElement.key
	                ) : null);
	              }
	            }
	          }
	        }
	        return ownersMatch;
	      }
	    }
	  }
	  return false;
	}
	
	module.exports = shouldUpdateReactComponent;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	
	module.exports = irreducible('Any', function () { return true; });


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	var isFunction = __webpack_require__(38);
	
	module.exports = irreducible('Function', isFunction);


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _menuItem = __webpack_require__(183);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file text-track-menu-item.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The specific menu item type for selecting a language within a text track kind
	 *
	 * @extends MenuItem
	 */
	var TextTrackMenuItem = function (_MenuItem) {
	  _inherits(TextTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TextTrackMenuItem(player, options) {
	    _classCallCheck(this, TextTrackMenuItem);
	
	    var track = options.track;
	    var tracks = player.textTracks();
	
	    // Modify options for parent MenuItem class's init.
	    options.label = track.label || track.language || 'Unknown';
	    options.selected = track['default'] || track.mode === 'showing';
	
	    var _this = _possibleConstructorReturn(this, _MenuItem.call(this, player, options));
	
	    _this.track = track;
	
	    if (tracks) {
	      var changeHandler = Fn.bind(_this, _this.handleTracksChange);
	
	      player.on(['loadstart', 'texttrackchange'], changeHandler);
	      tracks.addEventListener('change', changeHandler);
	      _this.on('dispose', function () {
	        tracks.removeEventListener('change', changeHandler);
	      });
	    }
	
	    // iOS7 doesn't dispatch change events to TextTrackLists when an
	    // associated track's mode changes. Without something like
	    // Object.observe() (also not present on iOS7), it's not
	    // possible to detect changes to the mode attribute and polyfill
	    // the change event. As a poor substitute, we manually dispatch
	    // change events whenever the controls modify the mode.
	    if (tracks && tracks.onchange === undefined) {
	      var event = void 0;
	
	      _this.on(['tap', 'click'], function () {
	        if (_typeof(_window2['default'].Event) !== 'object') {
	          // Android 2.3 throws an Illegal Constructor error for window.Event
	          try {
	            event = new _window2['default'].Event('change');
	          } catch (err) {
	            // continue regardless of error
	          }
	        }
	
	        if (!event) {
	          event = _document2['default'].createEvent('Event');
	          event.initEvent('change', true, true);
	        }
	
	        tracks.dispatchEvent(event);
	      });
	    }
	    return _this;
	  }
	
	  /**
	   * This gets called when an `TextTrackMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  TextTrackMenuItem.prototype.handleClick = function handleClick(event) {
	    var kind = this.track.kind;
	    var tracks = this.player_.textTracks();
	
	    _MenuItem.prototype.handleClick.call(this, event);
	
	    if (!tracks) {
	      return;
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	
	      if (track.kind !== kind) {
	        continue;
	      }
	
	      if (track === this.track) {
	        if (track.mode !== 'showing') {
	          track.mode = 'showing';
	        }
	      } else if (track.mode !== 'disabled') {
	        track.mode = 'disabled';
	      }
	    }
	  };
	
	  /**
	   * Handle text track list change
	   *
	   * @param {EventTarget~Event} event
	   *        The `change` event that caused this function to be called.
	   *
	   * @listens TextTrackList#change
	   */
	
	
	  TextTrackMenuItem.prototype.handleTracksChange = function handleTracksChange(event) {
	    this.selected(this.track.mode === 'showing');
	  };
	
	  return TextTrackMenuItem;
	}(_menuItem2['default']);
	
	_component2['default'].registerComponent('TextTrackMenuItem', TextTrackMenuItem);
	exports['default'] = TextTrackMenuItem;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _textTrackCueList = __webpack_require__(1020);
	
	var _textTrackCueList2 = _interopRequireDefault(_textTrackCueList);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _trackEnums = __webpack_require__(266);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _track = __webpack_require__(268);
	
	var _track2 = _interopRequireDefault(_track);
	
	var _url = __webpack_require__(184);
	
	var _xhr = __webpack_require__(432);
	
	var _xhr2 = _interopRequireDefault(_xhr);
	
	var _mergeOptions = __webpack_require__(76);
	
	var _mergeOptions2 = _interopRequireDefault(_mergeOptions);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file text-track.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Takes a webvtt file contents and parses it into cues
	 *
	 * @param {string} srcContent
	 *        webVTT file contents
	 *
	 * @param {TextTrack} track
	 *        TextTrack to add cues to. Cues come from the srcContent.
	 *
	 * @private
	 */
	var parseCues = function parseCues(srcContent, track) {
	  var parser = new _window2['default'].WebVTT.Parser(_window2['default'], _window2['default'].vttjs, _window2['default'].WebVTT.StringDecoder());
	  var errors = [];
	
	  parser.oncue = function (cue) {
	    track.addCue(cue);
	  };
	
	  parser.onparsingerror = function (error) {
	    errors.push(error);
	  };
	
	  parser.onflush = function () {
	    track.trigger({
	      type: 'loadeddata',
	      target: track
	    });
	  };
	
	  parser.parse(srcContent);
	  if (errors.length > 0) {
	    if (_window2['default'].console && _window2['default'].console.groupCollapsed) {
	      _window2['default'].console.groupCollapsed('Text Track parsing errors for ' + track.src);
	    }
	    errors.forEach(function (error) {
	      return _log2['default'].error(error);
	    });
	    if (_window2['default'].console && _window2['default'].console.groupEnd) {
	      _window2['default'].console.groupEnd();
	    }
	  }
	
	  parser.flush();
	};
	
	/**
	 * Load a `TextTrack` from a specifed url.
	 *
	 * @param {string} src
	 *        Url to load track from.
	 *
	 * @param {TextTrack} track
	 *        Track to add cues to. Comes from the content at the end of `url`.
	 *
	 * @private
	 */
	var loadTrack = function loadTrack(src, track) {
	  var opts = {
	    uri: src
	  };
	  var crossOrigin = (0, _url.isCrossOrigin)(src);
	
	  if (crossOrigin) {
	    opts.cors = crossOrigin;
	  }
	
	  (0, _xhr2['default'])(opts, Fn.bind(this, function (err, response, responseBody) {
	    if (err) {
	      return _log2['default'].error(err, response);
	    }
	
	    track.loaded_ = true;
	
	    // Make sure that vttjs has loaded, otherwise, wait till it finished loading
	    // NOTE: this is only used for the alt/video.novtt.js build
	    if (typeof _window2['default'].WebVTT !== 'function') {
	      if (track.tech_) {
	        var loadHandler = function loadHandler() {
	          return parseCues(responseBody, track);
	        };
	
	        track.tech_.on('vttjsloaded', loadHandler);
	        track.tech_.on('vttjserror', function () {
	          _log2['default'].error('vttjs failed to load, stopping trying to process ' + track.src);
	          track.tech_.off('vttjsloaded', loadHandler);
	        });
	      }
	    } else {
	      parseCues(responseBody, track);
	    }
	  }));
	};
	
	/**
	 * A representation of a single `TextTrack`.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrack}
	 * @extends Track
	 */
	
	var TextTrack = function (_Track) {
	  _inherits(TextTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} options={}
	   *        Object of option names and values
	   *
	   * @param {Tech} options.tech
	   *        A reference to the tech that owns this TextTrack.
	   *
	   * @param {TextTrack~Kind} [options.kind='subtitles']
	   *        A valid text track kind.
	   *
	   * @param {TextTrack~Mode} [options.mode='disabled']
	   *        A valid text track mode.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this TextTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {string} [options.srclang='']
	   *        A valid two character language code. An alternative, but deprioritized
	   *        vesion of `options.language`
	   *
	   * @param {string} [options.src]
	   *        A url to TextTrack cues.
	   *
	   * @param {boolean} [options.default]
	   *        If this track should default to on or off.
	   */
	  function TextTrack() {
	    var _this, _ret;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, TextTrack);
	
	    if (!options.tech) {
	      throw new Error('A tech was not provided.');
	    }
	
	    var settings = (0, _mergeOptions2['default'])(options, {
	      kind: _trackEnums.TextTrackKind[options.kind] || 'subtitles',
	      language: options.language || options.srclang || ''
	    });
	    var mode = _trackEnums.TextTrackMode[settings.mode] || 'disabled';
	    var default_ = settings['default'];
	
	    if (settings.kind === 'metadata' || settings.kind === 'chapters') {
	      mode = 'hidden';
	    }
	    // on IE8 this will be a document element
	    // for every other browser this will be a normal object
	    var tt = (_this = _possibleConstructorReturn(this, _Track.call(this, settings)), _this);
	
	    tt.tech_ = settings.tech;
	
	    if (browser.IS_IE8) {
	      for (var prop in TextTrack.prototype) {
	        if (prop !== 'constructor') {
	          tt[prop] = TextTrack.prototype[prop];
	        }
	      }
	    }
	
	    tt.cues_ = [];
	    tt.activeCues_ = [];
	
	    var cues = new _textTrackCueList2['default'](tt.cues_);
	    var activeCues = new _textTrackCueList2['default'](tt.activeCues_);
	    var changed = false;
	    var timeupdateHandler = Fn.bind(tt, function () {
	
	      // Accessing this.activeCues for the side-effects of updating itself
	      // due to it's nature as a getter function. Do not remove or cues will
	      // stop updating!
	      /* eslint-disable no-unused-expressions */
	      this.activeCues;
	      /* eslint-enable no-unused-expressions */
	      if (changed) {
	        this.trigger('cuechange');
	        changed = false;
	      }
	    });
	
	    if (mode !== 'disabled') {
	      tt.tech_.ready(function () {
	        tt.tech_.on('timeupdate', timeupdateHandler);
	      }, true);
	    }
	
	    /**
	     * @member {boolean} default
	     *         If this track was set to be on or off by default. Cannot be changed after
	     *         creation.
	     *
	     * @readonly
	     */
	    Object.defineProperty(tt, 'default', {
	      get: function get() {
	        return default_;
	      },
	      set: function set() {}
	    });
	
	    /**
	     * @member {string} mode
	     *         Set the mode of this TextTrack to a valid {@link TextTrack~Mode}. Will
	     *         not be set if setting to an invalid mode.
	     *
	     * @fires TextTrack#modechange
	     */
	    Object.defineProperty(tt, 'mode', {
	      get: function get() {
	        return mode;
	      },
	      set: function set(newMode) {
	        var _this2 = this;
	
	        if (!_trackEnums.TextTrackMode[newMode]) {
	          return;
	        }
	        mode = newMode;
	        if (mode === 'showing') {
	          this.tech_.ready(function () {
	            _this2.tech_.on('timeupdate', timeupdateHandler);
	          }, true);
	        }
	        /**
	         * An event that fires when mode changes on this track. This allows
	         * the TextTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec!
	         *
	         * @event TextTrack#modechange
	         * @type {EventTarget~Event}
	         */
	        this.trigger('modechange');
	      }
	    });
	
	    /**
	     * @member {TextTrackCueList} cues
	     *         The text track cue list for this TextTrack.
	     */
	    Object.defineProperty(tt, 'cues', {
	      get: function get() {
	        if (!this.loaded_) {
	          return null;
	        }
	
	        return cues;
	      },
	      set: function set() {}
	    });
	
	    /**
	     * @member {TextTrackCueList} activeCues
	     *         The list text track cues that are currently active for this TextTrack.
	     */
	    Object.defineProperty(tt, 'activeCues', {
	      get: function get() {
	        if (!this.loaded_) {
	          return null;
	        }
	
	        // nothing to do
	        if (this.cues.length === 0) {
	          return activeCues;
	        }
	
	        var ct = this.tech_.currentTime();
	        var active = [];
	
	        for (var i = 0, l = this.cues.length; i < l; i++) {
	          var cue = this.cues[i];
	
	          if (cue.startTime <= ct && cue.endTime >= ct) {
	            active.push(cue);
	          } else if (cue.startTime === cue.endTime && cue.startTime <= ct && cue.startTime + 0.5 >= ct) {
	            active.push(cue);
	          }
	        }
	
	        changed = false;
	
	        if (active.length !== this.activeCues_.length) {
	          changed = true;
	        } else {
	          for (var _i = 0; _i < active.length; _i++) {
	            if (this.activeCues_.indexOf(active[_i]) === -1) {
	              changed = true;
	            }
	          }
	        }
	
	        this.activeCues_ = active;
	        activeCues.setCues_(this.activeCues_);
	
	        return activeCues;
	      },
	      set: function set() {}
	    });
	
	    if (settings.src) {
	      tt.src = settings.src;
	      loadTrack(settings.src, tt);
	    } else {
	      tt.loaded_ = true;
	    }
	
	    return _ret = tt, _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Add a cue to the internal list of cues.
	   *
	   * @param {TextTrack~Cue} cue
	   *        The cue to add to our internal list
	   */
	
	
	  TextTrack.prototype.addCue = function addCue(originalCue) {
	    var cue = originalCue;
	
	    if (_window2['default'].vttjs && !(originalCue instanceof _window2['default'].vttjs.VTTCue)) {
	      cue = new _window2['default'].vttjs.VTTCue(originalCue.startTime, originalCue.endTime, originalCue.text);
	
	      for (var prop in originalCue) {
	        if (!(prop in cue)) {
	          cue[prop] = originalCue[prop];
	        }
	      }
	
	      // make sure that `id` is copied over
	      cue.id = originalCue.id;
	      cue.originalCue_ = originalCue;
	    }
	
	    var tracks = this.tech_.textTracks();
	
	    if (tracks) {
	      for (var i = 0; i < tracks.length; i++) {
	        if (tracks[i] !== this) {
	          tracks[i].removeCue(cue);
	        }
	      }
	    }
	
	    this.cues_.push(cue);
	    this.cues.setCues_(this.cues_);
	  };
	
	  /**
	   * Remove a cue from our internal list
	   *
	   * @param {TextTrack~Cue} removeCue
	   *        The cue to remove from our internal list
	   */
	
	
	  TextTrack.prototype.removeCue = function removeCue(_removeCue) {
	    var i = this.cues_.length;
	
	    while (i--) {
	      var cue = this.cues_[i];
	
	      if (cue === _removeCue || cue.originalCue_ && cue.originalCue_ === _removeCue) {
	        this.cues_.splice(i, 1);
	        this.cues.setCues_(this.cues_);
	        break;
	      }
	    }
	  };
	
	  return TextTrack;
	}(_track2['default']);
	
	/**
	 * cuechange - One or more cues in the track have become active or stopped being active.
	 */
	
	
	TextTrack.prototype.allowedEvents_ = {
	  cuechange: 'cuechange'
	};
	
	exports['default'] = TextTrack;


/***/ }),
/* 266 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * @file track-kinds.js
	 */
	
	/**
	 * All possible `VideoTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-videotrack-kind
	 * @typedef VideoTrack~Kind
	 * @enum
	 */
	var VideoTrackKind = exports.VideoTrackKind = {
	  alternative: 'alternative',
	  captions: 'captions',
	  main: 'main',
	  sign: 'sign',
	  subtitles: 'subtitles',
	  commentary: 'commentary'
	};
	
	/**
	 * All possible `AudioTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-audiotrack-kind
	 * @typedef AudioTrack~Kind
	 * @enum
	 */
	var AudioTrackKind = exports.AudioTrackKind = {
	  'alternative': 'alternative',
	  'descriptions': 'descriptions',
	  'main': 'main',
	  'main-desc': 'main-desc',
	  'translation': 'translation',
	  'commentary': 'commentary'
	};
	
	/**
	 * All possible `TextTrackKind`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-texttrack-kind
	 * @typedef TextTrack~Kind
	 * @enum
	 */
	var TextTrackKind = exports.TextTrackKind = {
	  subtitles: 'subtitles',
	  captions: 'captions',
	  descriptions: 'descriptions',
	  chapters: 'chapters',
	  metadata: 'metadata'
	};
	
	/**
	 * All possible `TextTrackMode`s
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackmode
	 * @typedef TextTrack~Mode
	 * @enum
	 */
	var TextTrackMode = exports.TextTrackMode = {
	  disabled: 'disabled',
	  hidden: 'hidden',
	  showing: 'showing'
	};


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _eventTarget = __webpack_require__(182);
	
	var _eventTarget2 = _interopRequireDefault(_eventTarget);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file track-list.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Common functionaliy between {@link TextTrackList}, {@link AudioTrackList}, and
	 * {@link VideoTrackList}
	 *
	 * @extends EventTarget
	 */
	var TrackList = function (_EventTarget) {
	  _inherits(TrackList, _EventTarget);
	
	  /**
	   * Create an instance of this class
	   *
	   * @param {Track[]} tracks
	   *        A list of tracks to initialize the list with.
	   *
	   * @param {Object} [list]
	   *        The child object with inheritance done manually for ie8.
	   *
	   * @abstract
	   */
	  function TrackList() {
	    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    var _ret;
	
	    var list = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	    _classCallCheck(this, TrackList);
	
	    var _this = _possibleConstructorReturn(this, _EventTarget.call(this));
	
	    if (!list) {
	      list = _this; // eslint-disable-line
	      if (browser.IS_IE8) {
	        list = _document2['default'].createElement('custom');
	        for (var prop in TrackList.prototype) {
	          if (prop !== 'constructor') {
	            list[prop] = TrackList.prototype[prop];
	          }
	        }
	      }
	    }
	
	    list.tracks_ = [];
	
	    /**
	     * @member {number} length
	     *         The current number of `Track`s in the this Trackist.
	     */
	    Object.defineProperty(list, 'length', {
	      get: function get() {
	        return this.tracks_.length;
	      }
	    });
	
	    for (var i = 0; i < tracks.length; i++) {
	      list.addTrack_(tracks[i]);
	    }
	
	    // must return the object, as for ie8 it will not be this
	    // but a reference to a document object
	    return _ret = list, _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Add a {@link Track} to the `TrackList`
	   *
	   * @param {Track} track
	   *        The audio, video, or text track to add to the list.
	   *
	   * @fires TrackList#addtrack
	   * @private
	   */
	
	
	  TrackList.prototype.addTrack_ = function addTrack_(track) {
	    var index = this.tracks_.length;
	
	    if (!('' + index in this)) {
	      Object.defineProperty(this, index, {
	        get: function get() {
	          return this.tracks_[index];
	        }
	      });
	    }
	
	    // Do not add duplicate tracks
	    if (this.tracks_.indexOf(track) === -1) {
	      this.tracks_.push(track);
	      /**
	       * Triggered when a track is added to a track list.
	       *
	       * @event TrackList#addtrack
	       * @type {EventTarget~Event}
	       * @property {Track} track
	       *           A reference to track that was added.
	       */
	      this.trigger({
	        track: track,
	        type: 'addtrack'
	      });
	    }
	  };
	
	  /**
	   * Remove a {@link Track} from the `TrackList`
	   *
	   * @param {Track} track
	   *        The audio, video, or text track to remove from the list.
	   *
	   * @fires TrackList#removetrack
	   * @private
	   */
	
	
	  TrackList.prototype.removeTrack_ = function removeTrack_(rtrack) {
	    var track = void 0;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      if (this[i] === rtrack) {
	        track = this[i];
	        if (track.off) {
	          track.off();
	        }
	
	        this.tracks_.splice(i, 1);
	
	        break;
	      }
	    }
	
	    if (!track) {
	      return;
	    }
	
	    /**
	     * Triggered when a track is removed from track list.
	     *
	     * @event TrackList#removetrack
	     * @type {EventTarget~Event}
	     * @property {Track} track
	     *           A reference to track that was removed.
	     */
	    this.trigger({
	      track: track,
	      type: 'removetrack'
	    });
	  };
	
	  /**
	   * Get a Track from the TrackList by a tracks id
	   *
	   * @param {String} id - the id of the track to get
	   * @method getTrackById
	   * @return {Track}
	   * @private
	   */
	
	
	  TrackList.prototype.getTrackById = function getTrackById(id) {
	    var result = null;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      var track = this[i];
	
	      if (track.id === id) {
	        result = track;
	        break;
	      }
	    }
	
	    return result;
	  };
	
	  return TrackList;
	}(_eventTarget2['default']);
	
	/**
	 * Triggered when a different track is selected/enabled.
	 *
	 * @event TrackList#change
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Events that can be called with on + eventName. See {@link EventHandler}.
	 *
	 * @property {Object} TrackList#allowedEvents_
	 * @private
	 */
	
	
	TrackList.prototype.allowedEvents_ = {
	  change: 'change',
	  addtrack: 'addtrack',
	  removetrack: 'removetrack'
	};
	
	// emulate attribute EventHandler support to allow for feature detection
	for (var event in TrackList.prototype.allowedEvents_) {
	  TrackList.prototype['on' + event] = null;
	}
	
	exports['default'] = TrackList;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _guid = __webpack_require__(119);
	
	var Guid = _interopRequireWildcard(_guid);
	
	var _eventTarget = __webpack_require__(182);
	
	var _eventTarget2 = _interopRequireDefault(_eventTarget);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file track.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * A Track class that contains all of the common functionality for {@link AudioTrack},
	 * {@link VideoTrack}, and {@link TextTrack}.
	 *
	 * > Note: This class should not be used directly
	 *
	 * @see {@link https://html.spec.whatwg.org/multipage/embedded-content.html}
	 * @extends EventTarget
	 * @abstract
	 */
	var Track = function (_EventTarget) {
	  _inherits(Track, _EventTarget);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {string} [options.kind='']
	   *        A valid kind for the track type you are creating.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @abstract
	   */
	  function Track() {
	    var _ret;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, Track);
	
	    var _this = _possibleConstructorReturn(this, _EventTarget.call(this));
	
	    var track = _this; // eslint-disable-line
	
	    if (browser.IS_IE8) {
	      track = _document2['default'].createElement('custom');
	      for (var prop in Track.prototype) {
	        if (prop !== 'constructor') {
	          track[prop] = Track.prototype[prop];
	        }
	      }
	    }
	
	    var trackProps = {
	      id: options.id || 'vjs_track_' + Guid.newGUID(),
	      kind: options.kind || '',
	      label: options.label || '',
	      language: options.language || ''
	    };
	
	    /**
	     * @member {string} id
	     *         The id of this track. Cannot be changed after creation.
	     *
	     * @readonly
	     */
	
	    /**
	     * @member {string} kind
	     *         The kind of track that this is. Cannot be changed after creation.
	     *
	     * @readonly
	     */
	
	    /**
	     * @member {string} label
	     *         The label of this track. Cannot be changed after creation.
	     *
	     * @readonly
	     */
	
	    /**
	     * @member {string} language
	     *         The two letter language code for this track. Cannot be changed after
	     *         creation.
	     *
	     * @readonly
	     */
	
	    var _loop = function _loop(key) {
	      Object.defineProperty(track, key, {
	        get: function get() {
	          return trackProps[key];
	        },
	        set: function set() {}
	      });
	    };
	
	    for (var key in trackProps) {
	      _loop(key);
	    }
	
	    return _ret = track, _possibleConstructorReturn(_this, _ret);
	  }
	
	  return Track;
	}(_eventTarget2['default']);
	
	exports['default'] = Track;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = computedStyle;
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * A safe getComputedStyle with an IE8 fallback.
	 *
	 * This is needed because in Firefox, if the player is loaded in an iframe with
	 * `display:none`, then `getComputedStyle` returns `null`, so, we do a null-check to
	 * make sure  that the player doesn't break in these cases.
	 *
	 * @param {Element} el
	 *        The element you want the computed style of
	 *
	 * @param {string} prop
	 *        The property name you want
	 *
	 * @see https://bugzilla.mozilla.org/show_bug.cgi?id=548397
	 */
	function computedStyle(el, prop) {
	  if (!el || !prop) {
	    return '';
	  }
	
	  if (typeof _window2['default'].getComputedStyle === 'function') {
	    var cs = _window2['default'].getComputedStyle(el);
	
	    return cs ? cs[prop] : '';
	  }
	
	  return el.currentStyle[prop] || '';
	} /**
	   * @file computed-style.js
	   * @module computed-style
	   */


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * @file video.js
	                                                                                                                                                                                                                                                                               * @module videojs
	                                                                                                                                                                                                                                                                               */
	
	/* global define */
	
	// Include the built-in techs
	
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _setup = __webpack_require__(1012);
	
	var setup = _interopRequireWildcard(_setup);
	
	var _stylesheet = __webpack_require__(431);
	
	var stylesheet = _interopRequireWildcard(_stylesheet);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _eventTarget = __webpack_require__(182);
	
	var _eventTarget2 = _interopRequireDefault(_eventTarget);
	
	var _events = __webpack_require__(83);
	
	var Events = _interopRequireWildcard(_events);
	
	var _player = __webpack_require__(426);
	
	var _player2 = _interopRequireDefault(_player);
	
	var _plugins = __webpack_require__(1008);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _mergeOptions2 = __webpack_require__(76);
	
	var _mergeOptions3 = _interopRequireDefault(_mergeOptions2);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _textTrack = __webpack_require__(265);
	
	var _textTrack2 = _interopRequireDefault(_textTrack);
	
	var _audioTrack = __webpack_require__(1017);
	
	var _audioTrack2 = _interopRequireDefault(_audioTrack);
	
	var _videoTrack = __webpack_require__(1025);
	
	var _videoTrack2 = _interopRequireDefault(_videoTrack);
	
	var _timeRanges = __webpack_require__(143);
	
	var _formatTime = __webpack_require__(84);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _url = __webpack_require__(184);
	
	var Url = _interopRequireWildcard(_url);
	
	var _obj = __webpack_require__(31);
	
	var _computedStyle = __webpack_require__(269);
	
	var _computedStyle2 = _interopRequireDefault(_computedStyle);
	
	var _extend = __webpack_require__(1005);
	
	var _extend2 = _interopRequireDefault(_extend);
	
	var _xhr = __webpack_require__(432);
	
	var _xhr2 = _interopRequireDefault(_xhr);
	
	var _tech = __webpack_require__(142);
	
	var _tech2 = _interopRequireDefault(_tech);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// HTML5 Element Shim for IE8
	if (typeof HTMLVideoElement === 'undefined' && Dom.isReal()) {
	  _document2['default'].createElement('video');
	  _document2['default'].createElement('audio');
	  _document2['default'].createElement('track');
	}
	
	/**
	 * Doubles as the main function for users to create a player instance and also
	 * the main library object.
	 * The `videojs` function can be used to initialize or retrieve a player.
	  *
	 * @param {string|Element} id
	 *        Video element or video element ID
	 *
	 * @param {Object} [options]
	 *        Optional options object for config/settings
	 *
	 * @param {Component~ReadyCallback} [ready]
	 *        Optional ready callback
	 *
	 * @return {Player}
	 *         A player instance
	 *
	 * @mixes videojs
	 */
	function videojs(id, options, ready) {
	  var tag = void 0;
	
	  // Allow for element or ID to be passed in
	  // String ID
	  if (typeof id === 'string') {
	
	    // Adjust for jQuery ID syntax
	    if (id.indexOf('#') === 0) {
	      id = id.slice(1);
	    }
	
	    // If a player instance has already been created for this ID return it.
	    if (videojs.getPlayers()[id]) {
	
	      // If options or ready funtion are passed, warn
	      if (options) {
	        _log2['default'].warn('Player "' + id + '" is already initialised. Options will not be applied.');
	      }
	
	      if (ready) {
	        videojs.getPlayers()[id].ready(ready);
	      }
	
	      return videojs.getPlayers()[id];
	    }
	
	    // Otherwise get element for ID
	    tag = Dom.getEl(id);
	
	    // ID is a media element
	  } else {
	    tag = id;
	  }
	
	  // Check for a useable element
	  // re: nodeName, could be a box div also
	  if (!tag || !tag.nodeName) {
	    throw new TypeError('The element or ID supplied is not valid. (videojs)');
	  }
	
	  // Element may have a player attr referring to an already created player instance.
	  // If so return that otherwise set up a new player below
	  if (tag.player || _player2['default'].players[tag.playerId]) {
	    return tag.player || _player2['default'].players[tag.playerId];
	  }
	
	  options = options || {};
	
	  videojs.hooks('beforesetup').forEach(function (hookFunction) {
	    var opts = hookFunction(tag, (0, _mergeOptions3['default'])(options));
	
	    if (!(0, _obj.isObject)(opts) || Array.isArray(opts)) {
	      _log2['default'].error('please return an object in beforesetup hooks');
	      return;
	    }
	
	    options = (0, _mergeOptions3['default'])(options, opts);
	  });
	
	  var PlayerComponent = _component2['default'].getComponent('Player');
	  // If not, set up a new player
	  var player = new PlayerComponent(tag, options, ready);
	
	  videojs.hooks('setup').forEach(function (hookFunction) {
	    return hookFunction(player);
	  });
	
	  return player;
	}
	
	/**
	 * An Object that contains lifecycle hooks as keys which point to an array
	 * of functions that are run when a lifecycle is triggered
	 */
	videojs.hooks_ = {};
	
	/**
	 * Get a list of hooks for a specific lifecycle
	 *
	 * @param {string} type
	 *        the lifecyle to get hooks from
	 *
	 * @param {Function} [fn]
	 *        Optionally add a hook to the lifecycle that your are getting.
	 *
	 * @return {Array}
	 *         an array of hooks, or an empty array if there are none.
	 */
	videojs.hooks = function (type, fn) {
	  videojs.hooks_[type] = videojs.hooks_[type] || [];
	  if (fn) {
	    videojs.hooks_[type] = videojs.hooks_[type].concat(fn);
	  }
	  return videojs.hooks_[type];
	};
	
	/**
	 * Add a function hook to a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle to hook the function to.
	 *
	 * @param {Function|Function[]}
	 *        The function or array of functions to attach.
	 */
	videojs.hook = function (type, fn) {
	  videojs.hooks(type, fn);
	};
	
	/**
	 * Remove a hook from a specific videojs lifecycle.
	 *
	 * @param {string} type
	 *        the lifecycle that the function hooked to
	 *
	 * @param {Function} fn
	 *        The hooked function to remove
	 *
	 * @return {boolean}
	 *         The function that was removed or undef
	 */
	videojs.removeHook = function (type, fn) {
	  var index = videojs.hooks(type).indexOf(fn);
	
	  if (index <= -1) {
	    return false;
	  }
	
	  videojs.hooks_[type] = videojs.hooks_[type].slice();
	  videojs.hooks_[type].splice(index, 1);
	
	  return true;
	};
	
	// Add default styles
	if (_window2['default'].VIDEOJS_NO_DYNAMIC_STYLE !== true && Dom.isReal()) {
	  var style = Dom.$('.vjs-styles-defaults');
	
	  if (!style) {
	    style = stylesheet.createStyleElement('vjs-styles-defaults');
	    var head = Dom.$('head');
	
	    if (head) {
	      head.insertBefore(style, head.firstChild);
	    }
	    stylesheet.setTextContent(style, '\n      .video-js {\n        width: 300px;\n        height: 150px;\n      }\n\n      .vjs-fluid {\n        padding-top: 56.25%\n      }\n    ');
	  }
	}
	
	// Run Auto-load players
	// You have to wait at least once in case this script is loaded after your
	// video in the DOM (weird behavior only with minified version)
	setup.autoSetupTimeout(1, videojs);
	
	/**
	 * Current software version. Follows semver.
	 *
	 * @type {string}
	 */
	videojs.VERSION = '5.20.5';
	
	/**
	 * The global options object. These are the settings that take effect
	 * if no overrides are specified when the player is created.
	 *
	 * @type {Object}
	 */
	videojs.options = _player2['default'].prototype.options_;
	
	/**
	 * Get an object with the currently created players, keyed by player ID
	 *
	 * @return {Object}
	 *         The created players
	 */
	videojs.getPlayers = function () {
	  return _player2['default'].players;
	};
	
	/**
	 * Expose players object.
	 *
	 * @memberOf videojs
	 * @property {Object} players
	 */
	videojs.players = _player2['default'].players;
	
	/**
	 * Get a component class object by name
	 *
	 * @borrows Component.getComponent as videojs.getComponent
	 */
	videojs.getComponent = _component2['default'].getComponent;
	
	/**
	 * Register a component so it can referred to by name. Used when adding to other
	 * components, either through addChild `component.addChild('myComponent')` or through
	 * default children options  `{ children: ['myComponent'] }`.
	 *
	 * > NOTE: You could also just initialize the component before adding.
	 * `component.addChild(new MyComponent());`
	 *
	 * @param {string} name
	 *        The class name of the component
	 *
	 * @param {Component} comp
	 *        The component class
	 *
	 * @return {Component}
	 *         The newly registered component
	 */
	videojs.registerComponent = function (name, comp) {
	  if (_tech2['default'].isTech(comp)) {
	    _log2['default'].warn('The ' + name + ' tech was registered as a component. It should instead be registered using videojs.registerTech(name, tech)');
	  }
	
	  _component2['default'].registerComponent.call(_component2['default'], name, comp);
	};
	
	/**
	 * Get a Tech class object by name
	 *
	 * @borrows Tech.getTech as videojs.getTech
	 */
	videojs.getTech = _tech2['default'].getTech;
	
	/**
	 * Register a Tech so it can referred to by name.
	 * This is used in the tech order for the player.
	 *
	 * @borrows Tech.registerTech as videojs.registerTech
	 */
	videojs.registerTech = _tech2['default'].registerTech;
	
	/**
	 * A suite of browser and device tests from {@link browser}.
	 *
	 * @type {Object}
	 * @private
	 */
	videojs.browser = browser;
	
	/**
	 * Whether or not the browser supports touch events. Included for backward
	 * compatibility with 4.x, but deprecated. Use `videojs.browser.TOUCH_ENABLED`
	 * instead going forward.
	 *
	 * @deprecated since version 5.0
	 * @type {boolean}
	 */
	videojs.TOUCH_ENABLED = browser.TOUCH_ENABLED;
	
	/**
	 * Subclass an existing class
	 * Mimics ES6 subclassing with the `extend` keyword
	 *
	 * @borrows extend:extendFn as videojs.extend
	 */
	videojs.extend = _extend2['default'];
	
	/**
	 * Merge two options objects recursively
	 * Performs a deep merge like lodash.merge but **only merges plain objects**
	 * (not arrays, elements, anything else)
	 * Other values will be copied directly from the second object.
	 *
	 * @borrows merge-options:mergeOptions as videojs.mergeOptions
	 */
	videojs.mergeOptions = _mergeOptions3['default'];
	
	/**
	 * Change the context (this) of a function
	 *
	 * > NOTE: as of v5.0 we require an ES5 shim, so you should use the native
	 * `function() {}.bind(newContext);` instead of this.
	 *
	 * @borrows fn:bind as videojs.bind
	 */
	videojs.bind = Fn.bind;
	
	/**
	 * Create a Video.js player plugin.
	 * Plugins are only initialized when options for the plugin are included
	 * in the player options, or the plugin function on the player instance is
	 * called.
	 *
	 * @borrows plugin:plugin as videojs.plugin
	 */
	videojs.plugin = _plugins2['default'];
	
	/**
	 * Adding languages so that they're available to all players.
	 * Example: `videojs.addLanguage('es', { 'Hello': 'Hola' });`
	 *
	 * @param {string} code
	 *        The language code or dictionary property
	 *
	 * @param {Object} data
	 *        The data values to be translated
	 *
	 * @return {Object}
	 *         The resulting language dictionary object
	 */
	videojs.addLanguage = function (code, data) {
	  var _mergeOptions;
	
	  code = ('' + code).toLowerCase();
	
	  videojs.options.languages = (0, _mergeOptions3['default'])(videojs.options.languages, (_mergeOptions = {}, _mergeOptions[code] = data, _mergeOptions));
	
	  return videojs.options.languages[code];
	};
	
	/**
	 * Log messages
	 *
	 * @borrows log:log as videojs.log
	 */
	videojs.log = _log2['default'];
	
	/**
	 * Creates an emulated TimeRange object.
	 *
	 * @borrows time-ranges:createTimeRanges as videojs.createTimeRange
	 */
	/**
	 * @borrows time-ranges:createTimeRanges as videojs.createTimeRanges
	 */
	videojs.createTimeRange = videojs.createTimeRanges = _timeRanges.createTimeRanges;
	
	/**
	 * Format seconds as a time string, H:MM:SS or M:SS
	 * Supplying a guide (in seconds) will force a number of leading zeros
	 * to cover the length of the guide
	 *
	 * @borrows format-time:formatTime as videojs.formatTime
	 */
	videojs.formatTime = _formatTime2['default'];
	
	/**
	 * Resolve and parse the elements of a URL
	 *
	 * @borrows url:parseUrl as videojs.parseUrl
	 */
	videojs.parseUrl = Url.parseUrl;
	
	/**
	 * Returns whether the url passed is a cross domain request or not.
	 *
	 * @borrows url:isCrossOrigin as videojs.isCrossOrigin
	 */
	videojs.isCrossOrigin = Url.isCrossOrigin;
	
	/**
	 * Event target class.
	 *
	 * @borrows EventTarget as videojs.EventTarget
	 */
	videojs.EventTarget = _eventTarget2['default'];
	
	/**
	 * Add an event listener to element
	 * It stores the handler function in a separate cache object
	 * and adds a generic handler to the element's event,
	 * along with a unique id (guid) to the element.
	 *
	 * @borrows events:on as videojs.on
	 */
	videojs.on = Events.on;
	
	/**
	 * Trigger a listener only once for an event
	 *
	 * @borrows events:one as videojs.one
	 */
	videojs.one = Events.one;
	
	/**
	 * Removes event listeners from an element
	 *
	 * @borrows events:off as videojs.off
	 */
	videojs.off = Events.off;
	
	/**
	 * Trigger an event for an element
	 *
	 * @borrows events:trigger as videojs.trigger
	 */
	videojs.trigger = Events.trigger;
	
	/**
	 * A cross-browser XMLHttpRequest wrapper. Here's a simple example:
	 *
	 * @param {Object} options
	 *        settings for the request.
	 *
	 * @return {XMLHttpRequest|XDomainRequest}
	 *         The request object.
	 *
	 * @see https://github.com/Raynos/xhr
	 */
	videojs.xhr = _xhr2['default'];
	
	/**
	 * TextTrack class
	 *
	 * @borrows TextTrack as videojs.TextTrack
	 */
	videojs.TextTrack = _textTrack2['default'];
	
	/**
	 * export the AudioTrack class so that source handlers can create
	 * AudioTracks and then add them to the players AudioTrackList
	 *
	 * @borrows AudioTrack as videojs.AudioTrack
	 */
	videojs.AudioTrack = _audioTrack2['default'];
	
	/**
	 * export the VideoTrack class so that source handlers can create
	 * VideoTracks and then add them to the players VideoTrackList
	 *
	 * @borrows VideoTrack as videojs.VideoTrack
	 */
	videojs.VideoTrack = _videoTrack2['default'];
	
	/**
	 * Determines, via duck typing, whether or not a value is a DOM element.
	 *
	 * @borrows dom:isEl as videojs.isEl
	 */
	videojs.isEl = Dom.isEl;
	
	/**
	 * Determines, via duck typing, whether or not a value is a text node.
	 *
	 * @borrows dom:isTextNode as videojs.isTextNode
	 */
	videojs.isTextNode = Dom.isTextNode;
	
	/**
	 * Creates an element and applies properties.
	 *
	 * @borrows dom:createEl as videojs.createEl
	 */
	videojs.createEl = Dom.createEl;
	
	/**
	 * Check if an element has a CSS class
	 *
	 * @borrows dom:hasElClass as videojs.hasClass
	 */
	videojs.hasClass = Dom.hasElClass;
	
	/**
	 * Add a CSS class name to an element
	 *
	 * @borrows dom:addElClass as videojs.addClass
	 */
	videojs.addClass = Dom.addElClass;
	
	/**
	 * Remove a CSS class name from an element
	 *
	 * @borrows dom:removeElClass as videojs.removeClass
	 */
	videojs.removeClass = Dom.removeElClass;
	
	/**
	 * Adds or removes a CSS class name on an element depending on an optional
	 * condition or the presence/absence of the class name.
	 *
	 * @borrows dom:toggleElClass as videojs.toggleClass
	 */
	videojs.toggleClass = Dom.toggleElClass;
	
	/**
	 * Apply attributes to an HTML element.
	 *
	 * @borrows dom:setElAttributes as videojs.setAttribute
	 */
	videojs.setAttributes = Dom.setElAttributes;
	
	/**
	 * Get an element's attribute values, as defined on the HTML tag
	 * Attributes are not the same as properties. They're defined on the tag
	 * or with setAttribute (which shouldn't be used with HTML)
	 * This will return true or false for boolean attributes.
	 *
	 * @borrows dom:getElAttributes as videojs.getAttributes
	 */
	videojs.getAttributes = Dom.getElAttributes;
	
	/**
	 * Empties the contents of an element.
	 *
	 * @borrows dom:emptyEl as videojs.emptyEl
	 */
	videojs.emptyEl = Dom.emptyEl;
	
	/**
	 * Normalizes and appends content to an element.
	 *
	 * The content for an element can be passed in multiple types and
	 * combinations, whose behavior is as follows:
	 *
	 * - String
	 *   Normalized into a text node.
	 *
	 * - Element, TextNode
	 *   Passed through.
	 *
	 * - Array
	 *   A one-dimensional array of strings, elements, nodes, or functions (which
	 *   return single strings, elements, or nodes).
	 *
	 * - Function
	 *   If the sole argument, is expected to produce a string, element,
	 *   node, or array.
	 *
	 * @borrows dom:appendContents as videojs.appendContet
	 */
	videojs.appendContent = Dom.appendContent;
	
	/**
	 * Normalizes and inserts content into an element; this is identical to
	 * `appendContent()`, except it empties the element first.
	 *
	 * The content for an element can be passed in multiple types and
	 * combinations, whose behavior is as follows:
	 *
	 * - String
	 *   Normalized into a text node.
	 *
	 * - Element, TextNode
	 *   Passed through.
	 *
	 * - Array
	 *   A one-dimensional array of strings, elements, nodes, or functions (which
	 *   return single strings, elements, or nodes).
	 *
	 * - Function
	 *   If the sole argument, is expected to produce a string, element,
	 *   node, or array.
	 *
	 * @borrows dom:insertContent as videojs.insertContent
	 */
	videojs.insertContent = Dom.insertContent;
	
	/**
	 * A safe getComputedStyle with an IE8 fallback.
	 *
	 * This is because in Firefox, if the player is loaded in an iframe with `display:none`,
	 * then `getComputedStyle` returns `null`, so, we do a null-check to make sure
	 * that the player doesn't break in these cases.
	 * See https://bugzilla.mozilla.org/show_bug.cgi?id=548397 for more details.
	 *
	 * @borrows computed-style:computedStyle as videojs.computedStyle
	 */
	videojs.computedStyle = _computedStyle2['default'];
	
	/*
	 * Custom Universal Module Definition (UMD)
	 *
	 * Video.js will never be a non-browser lib so we can simplify UMD a bunch and
	 * still support requirejs and browserify. This also needs to be closure
	 * compiler compatible, so string keys are used.
	 */
	if (true) {
	  !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    return videojs;
	  }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // checking that module is an object too because of umdjs/umd#35
	} else if ((typeof exports === 'undefined' ? 'undefined' : _typeof(exports)) === 'object' && (typeof module === 'undefined' ? 'undefined' : _typeof(module)) === 'object') {
	  module.exports = videojs;
	}
	
	exports['default'] = videojs;


/***/ }),
/* 271 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactOnclickoutside = __webpack_require__(235);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var HeaderDropdown = _react2['default'].createClass({
	    displayName: 'HeaderDropdown',
	
	    propTypes: {
	        isOpen: _react2['default'].PropTypes.bool,
	        onClick: _react2['default'].PropTypes.func
	    },
	
	    mixins: [_reactOnclickoutside2['default']],
	
	    getInitialState: function getInitialState() {
	        return {
	            isActive: this.props.isOpen ? this.props.isOpen : false
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (typeof nextProps.isOpen !== 'undefined') {
	            this.setState({
	                isActive: nextProps.isOpen
	            });
	        }
	    },
	
	    toggle: function toggle(e) {
	        e.preventDefault();
	        this.setState({
	            isActive: !this.state.isActive
	        });
	        if (this.props.onClick) {
	            this.props.onClick();
	        }
	    },
	
	    handleClickOutside: function handleClickOutside() {
	        if (this.props.dropdownClass === 'accordion') {
	            return;
	        }
	        this.setState({
	            isActive: false
	        });
	    },
	
	    renderChildren: function renderChildren() {
	        if (!this.state.isActive) {
	            return null;
	        }
	        return _react2['default'].createElement(
	            'div',
	            { className: 'item__dropdown' },
	            this.props.children
	        );
	    },
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'li',
	            { className: 'menu__item' },
	            _react2['default'].createElement(
	                'a',
	                { href: true, onClick: this.toggle },
	                _react2['default'].createElement('i', { className: 'play ' + (this.state.isActive ? 'open' : '') }),
	                this.props.label
	            ),
	            this.renderChildren()
	        );
	    }
	});
	
	module.exports = HeaderDropdown;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var PartnerLinks = _react2['default'].createClass({
	    displayName: 'PartnerLinks',
	    onClickHandler: function onClickHandler(url, target) {
	        window.open(url, target);
	    },
	    render: function render() {
	        var _this = this;
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var partnerLinks = _flux$getStore$getState$config$toJS.partnerLinks;
	        var licensing = _flux$getStore$getState$config$toJS.licensing;
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            !licensing ? _react2['default'].createElement(
	                'ul',
	                { className: 'partner-links__list' },
	                (partnerLinks !== undefined ? partnerLinks : []).map(function (link, id) {
	                    var target = link.target ? link.target : '';
	                    return _react2['default'].createElement(
	                        'li',
	                        { key: id, className: 'partner-links__list__item' },
	                        _react2['default'].createElement(
	                            'button',
	                            { onClick: _this.onClickHandler.bind(_this, link.url, target), title: link.title },
	                            _react2['default'].createElement('span', { className: 'play-icon' }),
	                            link.title
	                        )
	                    );
	                })
	            ) : ''
	        );
	    }
	});
	
	module.exports = PartnerLinks;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _componentsThumb = __webpack_require__(104);
	
	var _componentsThumb2 = _interopRequireDefault(_componentsThumb);
	
	var _prettyBytes = __webpack_require__(166);
	
	var _prettyBytes2 = _interopRequireDefault(_prettyBytes);
	
	var _lodashLangIsEqual = __webpack_require__(353);
	
	var _lodashLangIsEqual2 = _interopRequireDefault(_lodashLangIsEqual);
	
	var InstantDownloadItem = _react2['default'].createClass({
	    displayName: 'InstantDownloadItem',
	
	    propTypes: {
	        media: _react2['default'].PropTypes.object.isRequired
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	        return _immutable2['default'].is(nextProps.media, this.props.media) === false || (0, _lodashLangIsEqual2['default'])(nextState, this.state) === false;
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var item = this.props.media.toJS();
	        var itemTitle = item.title && item.title.length ? item.title : item.name;
	        return _react2['default'].createElement(
	            'div',
	            { className: 'instantdownload__item' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__image' },
	                _react2['default'].createElement(_componentsThumb2['default'], { className: 'item__preview', media: this.props.media, onClickOpenModal: false })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__description' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'description__download' },
	                    _react2['default'].createElement(
	                        'table',
	                        null,
	                        _react2['default'].createElement(
	                            'colgroup',
	                            null,
	                            _react2['default'].createElement('col', { width: '66%' }),
	                            _react2['default'].createElement('col', { width: '17%' }),
	                            _react2['default'].createElement('col', { width: '17%' })
	                        ),
	                        _react2['default'].createElement(
	                            'thead',
	                            null,
	                            _react2['default'].createElement(
	                                'th',
	                                { className: 'item__title' },
	                                itemTitle
	                            ),
	                            _react2['default'].createElement(
	                                'th',
	                                null,
	                                _utilsFlux2['default'].t('download_file_mimetype')
	                            ),
	                            _react2['default'].createElement(
	                                'th',
	                                null,
	                                _utilsFlux2['default'].t('download_file_size')
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'tbody',
	                            null,
	                            item.files.map(function (file) {
	                                return _react2['default'].createElement(
	                                    'tr',
	                                    { key: 'i-' + item.id + '-' + file.key },
	                                    _react2['default'].createElement(
	                                        'td',
	                                        { className: 'download__body--checkbox' },
	                                        _react2['default'].createElement(
	                                            'div',
	                                            { className: 'field__checkbox download__checkbox' },
	                                            _react2['default'].createElement('input', { checked: file._selected, name: item.id, value: file.key, type: 'checkbox', readOnly: true }),
	                                            _react2['default'].createElement(
	                                                'label',
	                                                { onClick: _this.props.toggleCheck.bind(null, file.key, item), htmlFor: 'check__all' },
	                                                file.name
	                                            )
	                                        )
	                                    ),
	                                    _react2['default'].createElement(
	                                        'td',
	                                        null,
	                                        file.mimeType
	                                    ),
	                                    _react2['default'].createElement(
	                                        'td',
	                                        null,
	                                        (0, _prettyBytes2['default'])(file.size)
	                                    )
	                                );
	                            })
	                        )
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = InstantDownloadItem;

/***/ }),
/* 275 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	    STORE_LANGUAGE_KEY: 'mediabox_user_language'
	};
	module.exports = exports['default'];

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(223);
	var GetIntrinsic = __webpack_require__(335);
	
	var $apply = GetIntrinsic('%Function.prototype.apply%');
	var $call = GetIntrinsic('%Function.prototype.call%');
	var $reflectApply = GetIntrinsic('%Reflect.apply%', true) || bind.call($call, $apply);
	
	var $gOPD = GetIntrinsic('%Object.getOwnPropertyDescriptor%', true);
	var $defineProperty = GetIntrinsic('%Object.defineProperty%', true);
	var $max = GetIntrinsic('%Math.max%');
	
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = null;
		}
	}
	
	module.exports = function callBind(originalFunction) {
		var func = $reflectApply(bind, $call, arguments);
		if ($gOPD && $defineProperty) {
			var desc = $gOPD(func, 'length');
			if (desc.configurable) {
				// original length, plus the receiver, minus any additional arguments (after the receiver)
				$defineProperty(
					func,
					'length',
					{ value: 1 + $max(0, originalFunction.length - (arguments.length - 1)) }
				);
			}
		}
		return func;
	};
	
	var applyBind = function applyBind() {
		return $reflectApply(bind, $apply, arguments);
	};
	
	if ($defineProperty) {
		$defineProperty(module.exports, 'apply', { value: applyBind });
	} else {
		module.exports.apply = applyBind;
	}


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(50);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(23);
	var toAbsoluteIndex = __webpack_require__(94);
	var toLength = __webpack_require__(15);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(87);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(29);
	var toObject = __webpack_require__(23);
	var IObject = __webpack_require__(124);
	var toLength = __webpack_require__(15);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(29);
	var isObject = __webpack_require__(10);
	var invoke = __webpack_require__(287);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(22).f;
	var create = __webpack_require__(88);
	var redefineAll = __webpack_require__(92);
	var ctx = __webpack_require__(51);
	var anInstance = __webpack_require__(86);
	var forOf = __webpack_require__(87);
	var $iterDefine = __webpack_require__(207);
	var step = __webpack_require__(290);
	var setSpecies = __webpack_require__(93);
	var DESCRIPTORS = __webpack_require__(19);
	var fastKey = __webpack_require__(79).fastKey;
	var validate = __webpack_require__(96);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(105);
	var from = __webpack_require__(279);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(92);
	var getWeak = __webpack_require__(79).getWeak;
	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(10);
	var anInstance = __webpack_require__(86);
	var forOf = __webpack_require__(87);
	var createArrayMethod = __webpack_require__(57);
	var $has = __webpack_require__(41);
	var validate = __webpack_require__(96);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(149);
	var isObject = __webpack_require__(10);
	var toLength = __webpack_require__(15);
	var ctx = __webpack_require__(51);
	var IS_CONCAT_SPREADABLE = __webpack_require__(13)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(19) && !__webpack_require__(9)(function () {
	  return Object.defineProperty(__webpack_require__(200)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 287 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(10);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(5);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(209);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ }),
/* 292 */
/***/ (function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ }),
/* 293 */
/***/ (function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(19);
	var getKeys = __webpack_require__(90);
	var gOPS = __webpack_require__(153);
	var pIE = __webpack_require__(125);
	var toObject = __webpack_require__(23);
	var IObject = __webpack_require__(124);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(9)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(22);
	var anObject = __webpack_require__(5);
	var getKeys = __webpack_require__(90);
	
	module.exports = __webpack_require__(19) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(44);
	var gOPN = __webpack_require__(89).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(41);
	var toIObject = __webpack_require__(44);
	var arrayIndexOf = __webpack_require__(146)(false);
	var IE_PROTO = __webpack_require__(214)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(19);
	var getKeys = __webpack_require__(90);
	var toIObject = __webpack_require__(44);
	var isEnum = __webpack_require__(125).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(89);
	var gOPS = __webpack_require__(153);
	var anObject = __webpack_require__(5);
	var Reflect = __webpack_require__(8).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(8).parseFloat;
	var $trim = __webpack_require__(108).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(217) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(8).parseInt;
	var $trim = __webpack_require__(108).trim;
	var ws = __webpack_require__(217);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ }),
/* 302 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(10);
	var newPromiseCapability = __webpack_require__(211);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 304 */
/***/ (function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(15);
	var repeat = __webpack_require__(216);
	var defined = __webpack_require__(58);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(53);
	var toLength = __webpack_require__(15);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(13);


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(278) });
	
	__webpack_require__(77)('copyWithin');


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $every = __webpack_require__(57)(4);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Array', { fill: __webpack_require__(197) });
	
	__webpack_require__(77)('fill');


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $filter = __webpack_require__(57)(2);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(57)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(77)(KEY);


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(1);
	var $find = __webpack_require__(57)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(77)(KEY);


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $forEach = __webpack_require__(57)(0);
	var STRICT = __webpack_require__(52)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(51);
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(23);
	var call = __webpack_require__(289);
	var isArrayIter = __webpack_require__(205);
	var toLength = __webpack_require__(15);
	var createProperty = __webpack_require__(199);
	var getIterFn = __webpack_require__(221);
	
	$export($export.S + $export.F * !__webpack_require__(151)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $indexOf = __webpack_require__(146)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(52)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(149) });


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(44);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(124) != Object || !__webpack_require__(52)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(44);
	var toInteger = __webpack_require__(53);
	var toLength = __webpack_require__(15);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(52)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $map = __webpack_require__(57)(1);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var createProperty = __webpack_require__(199);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(9)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(280);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $reduce = __webpack_require__(280);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var html = __webpack_require__(203);
	var cof = __webpack_require__(50);
	var toAbsoluteIndex = __webpack_require__(94);
	var toLength = __webpack_require__(15);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(9)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $some = __webpack_require__(57)(3);
	
	$export($export.P + $export.F * !__webpack_require__(52)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(29);
	var toObject = __webpack_require__(23);
	var fails = __webpack_require__(9);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(52)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(93)('Array');


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(282);
	var validate = __webpack_require__(96);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(147)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(212);
	__webpack_require__(1)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(19) && /./g.flags != 'g') __webpack_require__(22).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(123)
	});


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(282);
	var validate = __webpack_require__(96);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(147)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(157)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(207)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var each = __webpack_require__(57)(0);
	var redefine = __webpack_require__(34);
	var meta = __webpack_require__(79);
	var assign = __webpack_require__(294);
	var weak = __webpack_require__(284);
	var isObject = __webpack_require__(10);
	var validate = __webpack_require__(96);
	var NATIVE_WEAK_MAP = __webpack_require__(96);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(147)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keys = __webpack_require__(359);
	var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
	
	var toStr = Object.prototype.toString;
	var concat = Array.prototype.concat;
	var origDefineProperty = Object.defineProperty;
	
	var isFunction = function (fn) {
		return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
	};
	
	var arePropertyDescriptorsSupported = function () {
		var obj = {};
		try {
			origDefineProperty(obj, 'x', { enumerable: false, value: obj });
			// eslint-disable-next-line no-unused-vars, no-restricted-syntax
			for (var _ in obj) { // jscs:ignore disallowUnusedVariables
				return false;
			}
			return obj.x === obj;
		} catch (e) { /* this is IE 8. */
			return false;
		}
	};
	var supportsDescriptors = origDefineProperty && arePropertyDescriptorsSupported();
	
	var defineProperty = function (object, name, value, predicate) {
		if (name in object && (!isFunction(predicate) || !predicate())) {
			return;
		}
		if (supportsDescriptors) {
			origDefineProperty(object, name, {
				configurable: true,
				enumerable: false,
				value: value,
				writable: true
			});
		} else {
			object[name] = value;
		}
	};
	
	var defineProperties = function (object, map) {
		var predicates = arguments.length > 2 ? arguments[2] : {};
		var props = keys(map);
		if (hasSymbols) {
			props = concat.call(props, Object.getOwnPropertySymbols(map));
		}
		for (var i = 0; i < props.length; i += 1) {
			defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
		}
	};
	
	defineProperties.supportsDescriptors = !!supportsDescriptors;
	
	module.exports = defineProperties;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $SyntaxError = SyntaxError;
	var $Function = Function;
	var $TypeError = TypeError;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = Object.getOwnPropertyDescriptor;
	if ($gOPD) {
		try {
			$gOPD({}, '');
		} catch (e) {
			$gOPD = null; // this is IE 8, which has a broken gOPD
		}
	}
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(726)();
	
	var getProto = Object.getPrototypeOf || function (x) { return x.__proto__; }; // eslint-disable-line no-proto
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': EvalError,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': Object,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': RangeError,
		'%ReferenceError%': ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet
	};
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(223);
	var hasOwn = __webpack_require__(727);
	var $concat = bind.call(Function.call, Array.prototype.concat);
	var $spliceApply = bind.call(Function.apply, Array.prototype.splice);
	var $replace = bind.call(Function.call, String.prototype.replace);
	var $strSlice = bind.call(Function.call, String.prototype.slice);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (sym in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlMessageFormat = __webpack_require__(738)['default'];
	
	// Add all locale data to `IntlMessageFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(1037);
	
	// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlMessageFormat;
	exports['default'] = exports;


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports.extend = extend;
	var hop = Object.prototype.hasOwnProperty;
	
	function extend(obj) {
	    var sources = Array.prototype.slice.call(arguments, 1),
	        i, len, source, key;
	
	    for (i = 0, len = sources.length; i < len; i += 1) {
	        source = sources[i];
	        if (!source) { continue; }
	
	        for (key in source) {
	            if (hop.call(source, key)) {
	                obj[key] = source[key];
	            }
	        }
	    }
	
	    return obj;
	}
	exports.hop = hop;
	
	//# sourceMappingURL=utils.js.map

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var m = __webpack_require__(746),
	    IntlPolyfill = m.default;
	
	// add locale data for all locales into runtime
	global.IntlPolyfill = IntlPolyfill;
	__webpack_require__(748);
	
	// hack to export the polyfill as global Intl if needed
	if (!global.Intl) {
	    global.Intl = IntlPolyfill;
	    IntlPolyfill.__applyLocaleSensitivePrototypes();
	}
	
	// providing an idiomatic api for the nodejs version of this module
	module.exports = exports = IntlPolyfill;
	// preserving the original api in case another module is relying on that
	exports.default = IntlPolyfill;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.stateify = exports.TokenState = exports.CharacterState = undefined;
	
	var _class = __webpack_require__(162);
	
	function createStateClass() {
		return function (tClass) {
			this.j = [];
			this.T = tClass || null;
		};
	}
	
	/**
		A simple state machine that can emit token classes
	
		The `j` property in this class refers to state jumps. It's a
		multidimensional array where for each element:
	
		* index [0] is a symbol or class of symbols to transition to.
		* index [1] is a State instance which matches
	
		The type of symbol will depend on the target implementation for this class.
		In Linkify, we have a two-stage scanner. Each stage uses this state machine
		but with a slighly different (polymorphic) implementation.
	
		The `T` property refers to the token class.
	
		TODO: Can the `on` and `next` methods be combined?
	
		@class BaseState
	*/
	var BaseState = createStateClass();
	BaseState.prototype = {
		defaultTransition: false,
	
		/**
	 	@method constructor
	 	@param {Class} tClass Pass in the kind of token to emit if there are
	 		no jumps after this state and the state is accepting.
	 */
	
		/**
	 	On the given symbol(s), this machine should go to the given state
	 		@method on
	 	@param {Array|Mixed} symbol
	 	@param {BaseState} state Note that the type of this state should be the
	 		same as the current instance (i.e., don't pass in a different
	 		subclass)
	 */
		on: function on(symbol, state) {
			if (symbol instanceof Array) {
				for (var i = 0; i < symbol.length; i++) {
					this.j.push([symbol[i], state]);
				}
				return this;
			}
			this.j.push([symbol, state]);
			return this;
		},
	
	
		/**
	 	Given the next item, returns next state for that item
	 	@method next
	 	@param {Mixed} item Should be an instance of the symbols handled by
	 		this particular machine.
	 	@return {State} state Returns false if no jumps are available
	 */
		next: function next(item) {
			for (var i = 0; i < this.j.length; i++) {
				var jump = this.j[i];
				var symbol = jump[0]; // Next item to check for
				var state = jump[1]; // State to jump to if items match
	
				// compare item with symbol
				if (this.test(item, symbol)) {
					return state;
				}
			}
	
			// Nowhere left to jump!
			return this.defaultTransition;
		},
	
	
		/**
	 	Does this state accept?
	 	`true` only of `this.T` exists
	 		@method accepts
	 	@return {Boolean}
	 */
		accepts: function accepts() {
			return !!this.T;
		},
	
	
		/**
	 	Determine whether a given item "symbolizes" the symbol, where symbol is
	 	a class of items handled by this state machine.
	 		This method should be overriden in extended classes.
	 		@method test
	 	@param {Mixed} item Does this item match the given symbol?
	 	@param {Mixed} symbol
	 	@return {Boolean}
	 */
		test: function test(item, symbol) {
			return item === symbol;
		},
	
	
		/**
	 	Emit the token for this State (just return it in this case)
	 	If this emits a token, this instance is an accepting state
	 	@method emit
	 	@return {Class} T
	 */
		emit: function emit() {
			return this.T;
		}
	};
	
	/**
		State machine for string-based input
	
		@class CharacterState
		@extends BaseState
	*/
	var CharacterState = (0, _class.inherits)(BaseState, createStateClass(), {
		/**
	 	Does the given character match the given character or regular
	 	expression?
	 		@method test
	 	@param {String} char
	 	@param {String|RegExp} charOrRegExp
	 	@return {Boolean}
	 */
		test: function test(character, charOrRegExp) {
			return character === charOrRegExp || charOrRegExp instanceof RegExp && charOrRegExp.test(character);
		}
	});
	
	/**
		State machine for input in the form of TextTokens
	
		@class TokenState
		@extends BaseState
	*/
	var TokenState = (0, _class.inherits)(BaseState, createStateClass(), {
	
		/**
	  * Similar to `on`, but returns the state the results in the transition from
	  * the given item
	  * @method jump
	  * @param {Mixed} item
	  * @param {Token} [token]
	  * @return state
	  */
		jump: function jump(token) {
			var tClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
			var state = this.next(new token('')); // dummy temp token
			if (state === this.defaultTransition) {
				// Make a new state!
				state = new this.constructor(tClass);
				this.on(token, state);
			} else if (tClass) {
				state.T = tClass;
			}
			return state;
		},
	
	
		/**
	 	Is the given token an instance of the given token class?
	 		@method test
	 	@param {TextToken} token
	 	@param {Class} tokenClass
	 	@return {Boolean}
	 */
		test: function test(token, tokenClass) {
			return token instanceof tokenClass;
		}
	});
	
	/**
		Given a non-empty target string, generates states (if required) for each
		consecutive substring of characters in str starting from the beginning of
		the string. The final state will have a special value, as specified in
		options. All other "in between" substrings will have a default end state.
	
		This turns the state machine into a Trie-like data structure (rather than a
		intelligently-designed DFA).
	
		Note that I haven't really tried these with any strings other than
		DOMAIN.
	
		@param {String} str
		@param {CharacterState} start State to jump from the first character
		@param {Class} endToken Token class to emit when the given string has been
			matched and no more jumps exist.
		@param {Class} defaultToken "Filler token", or which token type to emit when
			we don't have a full match
		@return {Array} list of newly-created states
	*/
	function stateify(str, start, endToken, defaultToken) {
		var i = 0,
		    len = str.length,
		    state = start,
		    newStates = [],
		    nextState = void 0;
	
		// Find the next state without a jump to the next character
		while (i < len && (nextState = state.next(str[i]))) {
			state = nextState;
			i++;
		}
	
		if (i >= len) {
			return [];
		} // no new tokens were added
	
		while (i < len - 1) {
			nextState = new CharacterState(defaultToken);
			newStates.push(nextState);
			state.on(str[i], nextState);
			state = nextState;
			i++;
		}
	
		nextState = new CharacterState(endToken);
		newStates.push(nextState);
		state.on(str[len - 1], nextState);
	
		return newStates;
	}
	
	exports.CharacterState = CharacterState;
	exports.TokenState = TokenState;
	exports.stateify = stateify;

/***/ }),
/* 341 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function createTokenClass() {
		return function (value) {
			if (value) {
				this.v = value;
			}
		};
	}
	
	exports.createTokenClass = createTokenClass;

/***/ }),
/* 342 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function EntityParser(named) {
	  this.named = named;
	}
	
	var HEXCHARCODE = /^#[xX]([A-Fa-f0-9]+)$/;
	var CHARCODE = /^#([0-9]+)$/;
	var NAMED = /^([A-Za-z0-9]+)$/;
	
	EntityParser.prototype.parse = function (entity) {
	  if (!entity) {
	    return;
	  }
	  var matches = entity.match(HEXCHARCODE);
	  if (matches) {
	    return "&#x" + matches[1] + ";";
	  }
	  matches = entity.match(CHARCODE);
	  if (matches) {
	    return "&#" + matches[1] + ";";
	  }
	  matches = entity.match(NAMED);
	  if (matches) {
	    return this.named[matches[1]] || "&" + matches[1] + ";";
	  }
	};
	
	exports.default = EntityParser;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _utils = __webpack_require__(760);
	
	function EventedTokenizer(delegate, entityParser) {
	  this.delegate = delegate;
	  this.entityParser = entityParser;
	
	  this.state = null;
	  this.input = null;
	
	  this.index = -1;
	  this.line = -1;
	  this.column = -1;
	  this.tagLine = -1;
	  this.tagColumn = -1;
	
	  this.reset();
	}
	
	EventedTokenizer.prototype = {
	  reset: function reset() {
	    this.state = 'beforeData';
	    this.input = '';
	
	    this.index = 0;
	    this.line = 1;
	    this.column = 0;
	
	    this.tagLine = -1;
	    this.tagColumn = -1;
	
	    this.delegate.reset();
	  },
	
	  tokenize: function tokenize(input) {
	    this.reset();
	    this.tokenizePart(input);
	    this.tokenizeEOF();
	  },
	
	  tokenizePart: function tokenizePart(input) {
	    this.input += (0, _utils.preprocessInput)(input);
	
	    while (this.index < this.input.length) {
	      this.states[this.state].call(this);
	    }
	  },
	
	  tokenizeEOF: function tokenizeEOF() {
	    this.flushData();
	  },
	
	  flushData: function flushData() {
	    if (this.state === 'data') {
	      this.delegate.finishData();
	      this.state = 'beforeData';
	    }
	  },
	
	  peek: function peek() {
	    return this.input.charAt(this.index);
	  },
	
	  consume: function consume() {
	    var char = this.peek();
	
	    this.index++;
	
	    if (char === "\n") {
	      this.line++;
	      this.column = 0;
	    } else {
	      this.column++;
	    }
	
	    return char;
	  },
	
	  consumeCharRef: function consumeCharRef() {
	    var endIndex = this.input.indexOf(';', this.index);
	    if (endIndex === -1) {
	      return;
	    }
	    var entity = this.input.slice(this.index, endIndex);
	    var chars = this.entityParser.parse(entity);
	    if (chars) {
	      var count = entity.length;
	      // consume the entity chars
	      while (count) {
	        this.consume();
	        count--;
	      }
	      // consume the `;`
	      this.consume();
	
	      return chars;
	    }
	  },
	
	  markTagStart: function markTagStart() {
	    // these properties to be removed in next major bump
	    this.tagLine = this.line;
	    this.tagColumn = this.column;
	
	    if (this.delegate.tagOpen) {
	      this.delegate.tagOpen();
	    }
	  },
	
	  states: {
	    beforeData: function beforeData() {
	      var char = this.peek();
	
	      if (char === "<") {
	        this.state = 'tagOpen';
	        this.markTagStart();
	        this.consume();
	      } else {
	        this.state = 'data';
	        this.delegate.beginData();
	      }
	    },
	
	    data: function data() {
	      var char = this.peek();
	
	      if (char === "<") {
	        this.delegate.finishData();
	        this.state = 'tagOpen';
	        this.markTagStart();
	        this.consume();
	      } else if (char === "&") {
	        this.consume();
	        this.delegate.appendToData(this.consumeCharRef() || "&");
	      } else {
	        this.consume();
	        this.delegate.appendToData(char);
	      }
	    },
	
	    tagOpen: function tagOpen() {
	      var char = this.consume();
	
	      if (char === "!") {
	        this.state = 'markupDeclaration';
	      } else if (char === "/") {
	        this.state = 'endTagOpen';
	      } else if ((0, _utils.isAlpha)(char)) {
	        this.state = 'tagName';
	        this.delegate.beginStartTag();
	        this.delegate.appendToTagName(char.toLowerCase());
	      }
	    },
	
	    markupDeclaration: function markupDeclaration() {
	      var char = this.consume();
	
	      if (char === "-" && this.input.charAt(this.index) === "-") {
	        this.consume();
	        this.state = 'commentStart';
	        this.delegate.beginComment();
	      }
	    },
	
	    commentStart: function commentStart() {
	      var char = this.consume();
	
	      if (char === "-") {
	        this.state = 'commentStartDash';
	      } else if (char === ">") {
	        this.delegate.finishComment();
	        this.state = 'beforeData';
	      } else {
	        this.delegate.appendToCommentData(char);
	        this.state = 'comment';
	      }
	    },
	
	    commentStartDash: function commentStartDash() {
	      var char = this.consume();
	
	      if (char === "-") {
	        this.state = 'commentEnd';
	      } else if (char === ">") {
	        this.delegate.finishComment();
	        this.state = 'beforeData';
	      } else {
	        this.delegate.appendToCommentData("-");
	        this.state = 'comment';
	      }
	    },
	
	    comment: function comment() {
	      var char = this.consume();
	
	      if (char === "-") {
	        this.state = 'commentEndDash';
	      } else {
	        this.delegate.appendToCommentData(char);
	      }
	    },
	
	    commentEndDash: function commentEndDash() {
	      var char = this.consume();
	
	      if (char === "-") {
	        this.state = 'commentEnd';
	      } else {
	        this.delegate.appendToCommentData("-" + char);
	        this.state = 'comment';
	      }
	    },
	
	    commentEnd: function commentEnd() {
	      var char = this.consume();
	
	      if (char === ">") {
	        this.delegate.finishComment();
	        this.state = 'beforeData';
	      } else {
	        this.delegate.appendToCommentData("--" + char);
	        this.state = 'comment';
	      }
	    },
	
	    tagName: function tagName() {
	      var char = this.consume();
	
	      if ((0, _utils.isSpace)(char)) {
	        this.state = 'beforeAttributeName';
	      } else if (char === "/") {
	        this.state = 'selfClosingStartTag';
	      } else if (char === ">") {
	        this.delegate.finishTag();
	        this.state = 'beforeData';
	      } else {
	        this.delegate.appendToTagName(char);
	      }
	    },
	
	    beforeAttributeName: function beforeAttributeName() {
	      var char = this.peek();
	
	      if ((0, _utils.isSpace)(char)) {
	        this.consume();
	        return;
	      } else if (char === "/") {
	        this.state = 'selfClosingStartTag';
	        this.consume();
	      } else if (char === ">") {
	        this.consume();
	        this.delegate.finishTag();
	        this.state = 'beforeData';
	      } else {
	        this.state = 'attributeName';
	        this.delegate.beginAttribute();
	        this.consume();
	        this.delegate.appendToAttributeName(char);
	      }
	    },
	
	    attributeName: function attributeName() {
	      var char = this.peek();
	
	      if ((0, _utils.isSpace)(char)) {
	        this.state = 'afterAttributeName';
	        this.consume();
	      } else if (char === "/") {
	        this.delegate.beginAttributeValue(false);
	        this.delegate.finishAttributeValue();
	        this.consume();
	        this.state = 'selfClosingStartTag';
	      } else if (char === "=") {
	        this.state = 'beforeAttributeValue';
	        this.consume();
	      } else if (char === ">") {
	        this.delegate.beginAttributeValue(false);
	        this.delegate.finishAttributeValue();
	        this.consume();
	        this.delegate.finishTag();
	        this.state = 'beforeData';
	      } else {
	        this.consume();
	        this.delegate.appendToAttributeName(char);
	      }
	    },
	
	    afterAttributeName: function afterAttributeName() {
	      var char = this.peek();
	
	      if ((0, _utils.isSpace)(char)) {
	        this.consume();
	        return;
	      } else if (char === "/") {
	        this.delegate.beginAttributeValue(false);
	        this.delegate.finishAttributeValue();
	        this.consume();
	        this.state = 'selfClosingStartTag';
	      } else if (char === "=") {
	        this.consume();
	        this.state = 'beforeAttributeValue';
	      } else if (char === ">") {
	        this.delegate.beginAttributeValue(false);
	        this.delegate.finishAttributeValue();
	        this.consume();
	        this.delegate.finishTag();
	        this.state = 'beforeData';
	      } else {
	        this.delegate.beginAttributeValue(false);
	        this.delegate.finishAttributeValue();
	        this.consume();
	        this.state = 'attributeName';
	        this.delegate.beginAttribute();
	        this.delegate.appendToAttributeName(char);
	      }
	    },
	
	    beforeAttributeValue: function beforeAttributeValue() {
	      var char = this.peek();
	
	      if ((0, _utils.isSpace)(char)) {
	        this.consume();
	      } else if (char === '"') {
	        this.state = 'attributeValueDoubleQuoted';
	        this.delegate.beginAttributeValue(true);
	        this.consume();
	      } else if (char === "'") {
	        this.state = 'attributeValueSingleQuoted';
	        this.delegate.beginAttributeValue(true);
	        this.consume();
	      } else if (char === ">") {
	        this.delegate.beginAttributeValue(false);
	        this.delegate.finishAttributeValue();
	        this.consume();
	        this.delegate.finishTag();
	        this.state = 'beforeData';
	      } else {
	        this.state = 'attributeValueUnquoted';
	        this.delegate.beginAttributeValue(false);
	        this.consume();
	        this.delegate.appendToAttributeValue(char);
	      }
	    },
	
	    attributeValueDoubleQuoted: function attributeValueDoubleQuoted() {
	      var char = this.consume();
	
	      if (char === '"') {
	        this.delegate.finishAttributeValue();
	        this.state = 'afterAttributeValueQuoted';
	      } else if (char === "&") {
	        this.delegate.appendToAttributeValue(this.consumeCharRef('"') || "&");
	      } else {
	        this.delegate.appendToAttributeValue(char);
	      }
	    },
	
	    attributeValueSingleQuoted: function attributeValueSingleQuoted() {
	      var char = this.consume();
	
	      if (char === "'") {
	        this.delegate.finishAttributeValue();
	        this.state = 'afterAttributeValueQuoted';
	      } else if (char === "&") {
	        this.delegate.appendToAttributeValue(this.consumeCharRef("'") || "&");
	      } else {
	        this.delegate.appendToAttributeValue(char);
	      }
	    },
	
	    attributeValueUnquoted: function attributeValueUnquoted() {
	      var char = this.peek();
	
	      if ((0, _utils.isSpace)(char)) {
	        this.delegate.finishAttributeValue();
	        this.consume();
	        this.state = 'beforeAttributeName';
	      } else if (char === "&") {
	        this.consume();
	        this.delegate.appendToAttributeValue(this.consumeCharRef(">") || "&");
	      } else if (char === ">") {
	        this.delegate.finishAttributeValue();
	        this.consume();
	        this.delegate.finishTag();
	        this.state = 'beforeData';
	      } else {
	        this.consume();
	        this.delegate.appendToAttributeValue(char);
	      }
	    },
	
	    afterAttributeValueQuoted: function afterAttributeValueQuoted() {
	      var char = this.peek();
	
	      if ((0, _utils.isSpace)(char)) {
	        this.consume();
	        this.state = 'beforeAttributeName';
	      } else if (char === "/") {
	        this.consume();
	        this.state = 'selfClosingStartTag';
	      } else if (char === ">") {
	        this.consume();
	        this.delegate.finishTag();
	        this.state = 'beforeData';
	      } else {
	        this.state = 'beforeAttributeName';
	      }
	    },
	
	    selfClosingStartTag: function selfClosingStartTag() {
	      var char = this.peek();
	
	      if (char === ">") {
	        this.consume();
	        this.delegate.markTagAsSelfClosing();
	        this.delegate.finishTag();
	        this.state = 'beforeData';
	      } else {
	        this.state = 'beforeAttributeName';
	      }
	    },
	
	    endTagOpen: function endTagOpen() {
	      var char = this.consume();
	
	      if ((0, _utils.isAlpha)(char)) {
	        this.state = 'tagName';
	        this.delegate.beginEndTag();
	        this.delegate.appendToTagName(char.toLowerCase());
	      }
	    }
	  }
	};
	
	exports.default = EventedTokenizer;

/***/ }),
/* 344 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var HTML5NamedCharRefs = {
	    // We don't need the complete named character reference because linkifyHtml
	    // does not modify the escape sequences. We do need &nbsp; so that
	    // whitespace is parsed properly. Other types of whitespace should already
	    // be accounted for
	    nbsp: "\xA0"
	};
	exports.default = HTML5NamedCharRefs;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _eventedTokenizer = __webpack_require__(343);
	
	var _eventedTokenizer2 = _interopRequireDefault(_eventedTokenizer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Tokenizer(entityParser, options) {
	  this.token = null;
	  this.startLine = 1;
	  this.startColumn = 0;
	  this.options = options || {};
	  this.tokenizer = new _eventedTokenizer2.default(this, entityParser);
	}
	
	Tokenizer.prototype = {
	  tokenize: function tokenize(input) {
	    this.tokens = [];
	    this.tokenizer.tokenize(input);
	    return this.tokens;
	  },
	
	  tokenizePart: function tokenizePart(input) {
	    this.tokens = [];
	    this.tokenizer.tokenizePart(input);
	    return this.tokens;
	  },
	
	  tokenizeEOF: function tokenizeEOF() {
	    this.tokens = [];
	    this.tokenizer.tokenizeEOF();
	    return this.tokens[0];
	  },
	
	  reset: function reset() {
	    this.token = null;
	    this.startLine = 1;
	    this.startColumn = 0;
	  },
	
	  addLocInfo: function addLocInfo() {
	    if (this.options.loc) {
	      this.token.loc = {
	        start: {
	          line: this.startLine,
	          column: this.startColumn
	        },
	        end: {
	          line: this.tokenizer.line,
	          column: this.tokenizer.column
	        }
	      };
	    }
	    this.startLine = this.tokenizer.line;
	    this.startColumn = this.tokenizer.column;
	  },
	
	  // Data
	
	  beginData: function beginData() {
	    this.token = {
	      type: 'Chars',
	      chars: ''
	    };
	    this.tokens.push(this.token);
	  },
	
	  appendToData: function appendToData(char) {
	    this.token.chars += char;
	  },
	
	  finishData: function finishData() {
	    this.addLocInfo();
	  },
	
	  // Comment
	
	  beginComment: function beginComment() {
	    this.token = {
	      type: 'Comment',
	      chars: ''
	    };
	    this.tokens.push(this.token);
	  },
	
	  appendToCommentData: function appendToCommentData(char) {
	    this.token.chars += char;
	  },
	
	  finishComment: function finishComment() {
	    this.addLocInfo();
	  },
	
	  // Tags - basic
	
	  beginStartTag: function beginStartTag() {
	    this.token = {
	      type: 'StartTag',
	      tagName: '',
	      attributes: [],
	      selfClosing: false
	    };
	    this.tokens.push(this.token);
	  },
	
	  beginEndTag: function beginEndTag() {
	    this.token = {
	      type: 'EndTag',
	      tagName: ''
	    };
	    this.tokens.push(this.token);
	  },
	
	  finishTag: function finishTag() {
	    this.addLocInfo();
	  },
	
	  markTagAsSelfClosing: function markTagAsSelfClosing() {
	    this.token.selfClosing = true;
	  },
	
	  // Tags - name
	
	  appendToTagName: function appendToTagName(char) {
	    this.token.tagName += char;
	  },
	
	  // Tags - attributes
	
	  beginAttribute: function beginAttribute() {
	    this._currentAttribute = ["", "", null];
	    this.token.attributes.push(this._currentAttribute);
	  },
	
	  appendToAttributeName: function appendToAttributeName(char) {
	    this._currentAttribute[0] += char;
	  },
	
	  beginAttributeValue: function beginAttributeValue(isQuoted) {
	    this._currentAttribute[2] = isQuoted;
	  },
	
	  appendToAttributeValue: function appendToAttributeValue(char) {
	    this._currentAttribute[1] = this._currentAttribute[1] || "";
	    this._currentAttribute[1] += char;
	  },
	
	  finishAttributeValue: function finishAttributeValue() {}
	};
	
	exports.default = Tokenizer;

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function arrayCopy(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = arrayCopy;


/***/ }),
/* 347 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 348 */
/***/ (function(module, exports) {

	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(787);
	
	/**
	 * The base implementation of `baseForIn` and `baseForOwn` which iterates
	 * over `object` properties returned by `keysFunc` invoking `iteratee` for
	 * each property. Iteratee functions may exit iteration early by explicitly
	 * returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ }),
/* 350 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(54),
	    toObject = __webpack_require__(98);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  var type = typeof value;
	  if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
	    return true;
	  }
	  if (isArray(value)) {
	    return false;
	  }
	  var result = !reIsDeepProp.test(value);
	  return result || (object != null && value in toObject(object));
	}
	
	module.exports = isKey;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(228),
	    bindCallback = __webpack_require__(163);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent. If `customizer` is provided it's invoked to compare values.
	 * If `customizer` returns `undefined` comparisons are handled by the method
	 * instead. The `customizer` is bound to `thisArg` and invoked with up to
	 * three arguments: (value, other [, index|key]).
	 *
	 * **Note:** This method supports comparing arrays, booleans, `Date` objects,
	 * numbers, `Object` objects, regexes, and strings. Objects are compared by
	 * their own, not inherited, enumerable properties. Functions and DOM nodes
	 * are **not** supported. Provide a customizer function to extend support
	 * for comparing other values.
	 *
	 * @static
	 * @memberOf _
	 * @alias eq
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize value comparisons.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * object == other;
	 * // => false
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * // using a customizer callback
	 * var array = ['hello', 'goodbye'];
	 * var other = ['hi', 'goodbye'];
	 *
	 * _.isEqual(array, other, function(value, other) {
	 *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
	 *     return true;
	 *   }
	 * });
	 * // => true
	 */
	function isEqual(value, other, customizer, thisArg) {
	  customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
	  var result = customizer ? customizer(value, other) : undefined;
	  return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
	}
	
	module.exports = isEqual;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 which returns 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(778),
	    createAssigner = __webpack_require__(786);
	
	/**
	 * Recursively merges own enumerable properties of the source object(s), that
	 * don't resolve to `undefined` into the destination object. Subsequent sources
	 * overwrite property assignments of previous sources. If `customizer` is
	 * provided it's invoked to produce the merged values of the destination and
	 * source properties. If `customizer` returns `undefined` merging is handled
	 * by the method instead. The `customizer` is bound to `thisArg` and invoked
	 * with five arguments: (objectValue, sourceValue, key, object, source).
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 *
	 * // using a customizer callback
	 * var object = {
	 *   'fruits': ['apple'],
	 *   'vegetables': ['beet']
	 * };
	 *
	 * var other = {
	 *   'fruits': ['banana'],
	 *   'vegetables': ['carrot']
	 * };
	 *
	 * _.merge(object, other, function(a, b) {
	 *   if (_.isArray(a)) {
	 *     return a.concat(b);
	 *   }
	 * });
	 * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
	 */
	var merge = createAssigner(baseMerge);
	
	module.exports = merge;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(229),
	    isIterateeCall = __webpack_require__(165),
	    isObject = __webpack_require__(36),
	    isRegExp = __webpack_require__(802);
	
	/** Used as default options for `_.trunc`. */
	var DEFAULT_TRUNC_LENGTH = 30,
	    DEFAULT_TRUNC_OMISSION = '...';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Truncates `string` if it's longer than the given maximum string length.
	 * The last characters of the truncated string are replaced with the omission
	 * string which defaults to "...".
	 *
	 * @static
	 * @memberOf _
	 * @category String
	 * @param {string} [string=''] The string to truncate.
	 * @param {Object|number} [options] The options object or maximum string length.
	 * @param {number} [options.length=30] The maximum string length.
	 * @param {string} [options.omission='...'] The string to indicate text is omitted.
	 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	 * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
	 * @returns {string} Returns the truncated string.
	 * @example
	 *
	 * _.trunc('hi-diddly-ho there, neighborino');
	 * // => 'hi-diddly-ho there, neighbo...'
	 *
	 * _.trunc('hi-diddly-ho there, neighborino', 24);
	 * // => 'hi-diddly-ho there, n...'
	 *
	 * _.trunc('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': ' '
	 * });
	 * // => 'hi-diddly-ho there,...'
	 *
	 * _.trunc('hi-diddly-ho there, neighborino', {
	 *   'length': 24,
	 *   'separator': /,? +/
	 * });
	 * // => 'hi-diddly-ho there...'
	 *
	 * _.trunc('hi-diddly-ho there, neighborino', {
	 *   'omission': ' [...]'
	 * });
	 * // => 'hi-diddly-ho there, neig [...]'
	 */
	function trunc(string, options, guard) {
	  if (guard && isIterateeCall(string, options, guard)) {
	    options = undefined;
	  }
	  var length = DEFAULT_TRUNC_LENGTH,
	      omission = DEFAULT_TRUNC_OMISSION;
	
	  if (options != null) {
	    if (isObject(options)) {
	      var separator = 'separator' in options ? options.separator : separator;
	      length = 'length' in options ? (+options.length || 0) : length;
	      omission = 'omission' in options ? baseToString(options.omission) : omission;
	    } else {
	      length = +options || 0;
	    }
	  }
	  string = baseToString(string);
	  if (length >= string.length) {
	    return string;
	  }
	  var end = length - omission.length;
	  if (end < 1) {
	    return omission;
	  }
	  var result = string.slice(0, end);
	  if (separator == null) {
	    return result + omission;
	  }
	  if (isRegExp(separator)) {
	    if (string.slice(end).search(separator)) {
	      var match,
	          newEnd,
	          substring = string.slice(0, end);
	
	      if (!separator.global) {
	        separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
	      }
	      separator.lastIndex = 0;
	      while ((match = separator.exec(substring))) {
	        newEnd = match.index;
	      }
	      result = result.slice(0, newEnd == null ? end : newEnd);
	    }
	  } else if (string.indexOf(separator, end) != end) {
	    var index = result.lastIndexOf(separator);
	    if (index > -1) {
	      result = result.slice(0, index);
	    }
	  }
	  return result + omission;
	}
	
	module.exports = trunc;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = diff;
	
	function diff(){
		var length = arguments.length;
		var ref = arguments[0];
		var diff = {};
		var c;
		var keys;
		var keysLength;
		var key;
		var u;
	
		for (var i = 1;i < length;i++) {
			c = arguments[i];
			keys = Object.keys(c);
			keysLength = keys.length;
	
			for (u = 0;u < keysLength;u++) {
				key = keys[u];
	
				if (c[key] !== ref[key])
					diff[key] = c[key];
			}
		}
	
		return diff;
	}


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var slice = Array.prototype.slice;
	var isArgs = __webpack_require__(360);
	
	var origKeys = Object.keys;
	var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(810);
	
	var originalKeys = Object.keys;
	
	keysShim.shim = function shimObjectKeys() {
		if (Object.keys) {
			var keysWorksWithArguments = (function () {
				// Safari 5.0 bug
				var args = Object.keys(arguments);
				return args && args.length === arguments.length;
			}(1, 2));
			if (!keysWorksWithArguments) {
				Object.keys = function keys(object) { // eslint-disable-line func-name-matching
					if (isArgs(object)) {
						return originalKeys(slice.call(object));
					}
					return originalKeys(object);
				};
			}
		} else {
			Object.keys = keysShim;
		}
		return Object.keys || keysShim;
	};
	
	module.exports = keysShim;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	'use strict';
	
	var toStr = Object.prototype.toString;
	
	module.exports = function isArguments(value) {
		var str = toStr.call(value);
		var isArgs = str === '[object Arguments]';
		if (!isArgs) {
			isArgs = str !== '[object Array]' &&
				value !== null &&
				typeof value === 'object' &&
				typeof value.length === 'number' &&
				value.length >= 0 &&
				toStr.call(value.callee) === '[object Function]';
		}
		return isArgs;
	};


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// modified from https://github.com/es-shims/es6-shim
	var keys = __webpack_require__(359);
	var canBeObject = function (obj) {
		return typeof obj !== 'undefined' && obj !== null;
	};
	var hasSymbols = __webpack_require__(336)();
	var callBound = __webpack_require__(540);
	var toObject = Object;
	var $push = callBound('Array.prototype.push');
	var $propIsEnumerable = callBound('Object.prototype.propertyIsEnumerable');
	var originalGetSymbols = hasSymbols ? Object.getOwnPropertySymbols : null;
	
	// eslint-disable-next-line no-unused-vars
	module.exports = function assign(target, source1) {
		if (!canBeObject(target)) { throw new TypeError('target must be an object'); }
		var objTarget = toObject(target);
		var s, source, i, props, syms, value, key;
		for (s = 1; s < arguments.length; ++s) {
			source = toObject(arguments[s]);
			props = keys(source);
			var getSymbols = hasSymbols && (Object.getOwnPropertySymbols || originalGetSymbols);
			if (getSymbols) {
				syms = getSymbols(source);
				for (i = 0; i < syms.length; ++i) {
					key = syms[i];
					if ($propIsEnumerable(source, key)) {
						$push(props, key);
					}
				}
			}
			for (i = 0; i < props.length; ++i) {
				key = props[i];
				value = source[key];
				if ($propIsEnumerable(source, key)) {
					objTarget[key] = value;
				}
			}
		}
		return objTarget;
	};


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(361);
	
	var lacksProperEnumerationOrder = function () {
		if (!Object.assign) {
			return false;
		}
		/*
		 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
		 * note: this does not detect the bug unless there's 20 characters
		 */
		var str = 'abcdefghijklmnopqrst';
		var letters = str.split('');
		var map = {};
		for (var i = 0; i < letters.length; ++i) {
			map[letters[i]] = letters[i];
		}
		var obj = Object.assign({}, map);
		var actual = '';
		for (var k in obj) {
			actual += k;
		}
		return str !== actual;
	};
	
	var assignHasPendingExceptions = function () {
		if (!Object.assign || !Object.preventExtensions) {
			return false;
		}
		/*
		 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
		 * which is 72% slower than our shim, and Firefox 40's native implementation.
		 */
		var thrower = Object.preventExtensions({ 1: 2 });
		try {
			Object.assign(thrower, 'xy');
		} catch (e) {
			return thrower[1] === 'y';
		}
		return false;
	};
	
	module.exports = function getPolyfill() {
		if (!Object.assign) {
			return implementation;
		}
		if (lacksProperEnumerationOrder()) {
			return implementation;
		}
		if (assignHasPendingExceptions()) {
			return implementation;
		}
		return Object.assign;
	};


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(814)();
	}


/***/ }),
/* 364 */
/***/ (function(module, exports) {

	// Load modules
	
	
	// Declare internals
	
	var internals = {};
	
	
	exports.arrayToObject = function (source) {
	
	    var obj = {};
	    for (var i = 0, il = source.length; i < il; ++i) {
	        if (typeof source[i] !== 'undefined') {
	
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	
	exports.merge = function (target, source) {
	
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object') {
	        if (Array.isArray(target)) {
	            target.push(source);
	        }
	        else {
	            target[source] = true;
	        }
	
	        return target;
	    }
	
	    if (typeof target !== 'object') {
	        target = [target].concat(source);
	        return target;
	    }
	
	    if (Array.isArray(target) &&
	        !Array.isArray(source)) {
	
	        target = exports.arrayToObject(target);
	    }
	
	    var keys = Object.keys(source);
	    for (var k = 0, kl = keys.length; k < kl; ++k) {
	        var key = keys[k];
	        var value = source[key];
	
	        if (!target[key]) {
	            target[key] = value;
	        }
	        else {
	            target[key] = exports.merge(target[key], value);
	        }
	    }
	
	    return target;
	};
	
	
	exports.decode = function (str) {
	
	    try {
	        return decodeURIComponent(str.replace(/\+/g, ' '));
	    } catch (e) {
	        return str;
	    }
	};
	
	
	exports.compact = function (obj, refs) {
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return obj;
	    }
	
	    refs = refs || [];
	    var lookup = refs.indexOf(obj);
	    if (lookup !== -1) {
	        return refs[lookup];
	    }
	
	    refs.push(obj);
	
	    if (Array.isArray(obj)) {
	        var compacted = [];
	
	        for (var i = 0, il = obj.length; i < il; ++i) {
	            if (typeof obj[i] !== 'undefined') {
	                compacted.push(obj[i]);
	            }
	        }
	
	        return compacted;
	    }
	
	    var keys = Object.keys(obj);
	    for (i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        obj[key] = exports.compact(obj[key], refs);
	    }
	
	    return obj;
	};
	
	
	exports.isRegExp = function (obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	
	exports.isBuffer = function (obj) {
	
	    if (obj === null ||
	        typeof obj === 'undefined') {
	
	        return false;
	    }
	
	    return !!(obj.constructor &&
	        obj.constructor.isBuffer &&
	        obj.constructor.isBuffer(obj));
	};


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

	var React = __webpack_require__(2),
	  parseEvents = __webpack_require__(828),
	  isInput = __webpack_require__(825),
	  match = __webpack_require__(826);
	
	/**
	 * A React mixin that provides keybinding support for components
	 */
	var Keybinding = {
	
	  /**
	   * Housekeeping to pass around a single array of all
	   * currently-active keybinding objects.
	   */
	  childContextTypes: {
	    __keybindings: React.PropTypes.array
	  },
	  contextTypes: {
	    __keybindings: React.PropTypes.array
	  },
	  getChildContext: function() {
	    return { __keybindings: this.__getKeybindings() };
	  },
	  __getKeybindings: function() {
	    this.__keybindings = this.__keybindings ||
	      (this.context && this.context.__keybindings) || [];
	    return this.__keybindings;
	  },
	
	  /**
	   * This is the only method meant to be exposed to the user: it
	   * returns the global keybinding index for the purposes of documentation
	   * generation.
	   */
	  getAllKeybindings: function() {
	    return this.__getKeybindings();
	  },
	
	  /**
	   * Internal method: avoids firing keybindings in textareas,
	   * figures out if they match any of the bindings from this component,
	   * and then either fires an inline method or the .keybinding() method.
	   */
	  __keybinding: function(event) {
	    if (isInput(event) && !this.keybindingsOnInputs) return;
	    for (var i = 0; i < this.matchers.length; i++) {
	      if (match(this.matchers[i].expectation, event)) {
	        if (typeof this.matchers[i].action === 'function') {
	          this.matchers[i].action.apply(this, event);
	        } else {
	          if (typeof this.keybinding !== 'function') {
	            throw new Error('non-function keybinding action given but no .keybinding method found on component');
	          }
	          this.keybinding(event, this.matchers[i].action);
	        }
	      }
	    }
	  },
	
	  /**
	   * When the component mounts, bind our event listener and
	   * add our keybindings to the global index.
	   */
	  componentDidMount: function() {
	    if (this.keybindings !== undefined) {
	      this.matchers = parseEvents(this.keybindings, !!this.keybindingsPlatformAgnostic);
	      document.addEventListener('keydown', this.__keybinding);
	      this.__getKeybindings().push(this.keybindings);
	    }
	  },
	
	  /**
	   * When the component unmounts, unbind our event listener and
	   * remove our keybindings from the global index.
	   */
	  componentWillUnmount: function() {
	    if (this.keybindings !== undefined) {
	      document.removeEventListener('keydown', this.__keybinding);
	      this.__getKeybindings()
	        .splice(this.__getKeybindings().indexOf(this.keybindings), 1);
	    }
	  }
	};
	
	module.exports = Keybinding;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

	/**
	 * Represents a cancellation caused by navigating away
	 * before the previous transition has fully resolved.
	 */
	"use strict";
	
	function Cancellation() {}
	
	module.exports = Cancellation;

/***/ }),
/* 367 */
/***/ (function(module, exports) {

	/**
	 * Encapsulates a redirect to the given route.
	 */
	"use strict";
	
	function Redirect(to, params, query) {
	  this.to = to;
	  this.params = params;
	  this.query = query;
	}
	
	module.exports = Redirect;

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(130);
	
	/**
	 * A scroll behavior that attempts to imitate the default behavior
	 * of modern browsers.
	 */
	var ImitateBrowserBehavior = {
	
	  updateScrollPosition: function updateScrollPosition(position, actionType) {
	    switch (actionType) {
	      case LocationActions.PUSH:
	      case LocationActions.REPLACE:
	        window.scrollTo(0, 0);
	        break;
	      case LocationActions.POP:
	        if (position) {
	          window.scrollTo(position.x, position.y);
	        } else {
	          window.scrollTo(0, 0);
	        }
	        break;
	    }
	  }
	
	};
	
	module.exports = ImitateBrowserBehavior;

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(69);
	var RouteHandler = __webpack_require__(169);
	var Route = __webpack_require__(168);
	
	/**
	 * A <DefaultRoute> component is a special kind of <Route> that
	 * renders when its parent matches but none of its siblings do.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var DefaultRoute = (function (_Route) {
	  _inherits(DefaultRoute, _Route);
	
	  function DefaultRoute() {
	    _classCallCheck(this, DefaultRoute);
	
	    _get(Object.getPrototypeOf(DefaultRoute.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  return DefaultRoute;
	})(Route);
	
	DefaultRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	DefaultRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = DefaultRoute;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(69);
	var RouteHandler = __webpack_require__(169);
	var Route = __webpack_require__(168);
	
	/**
	 * A <NotFoundRoute> is a special kind of <Route> that
	 * renders when the beginning of its parent's path matches
	 * but none of its siblings do, including any <DefaultRoute>.
	 * Only one such route may be used at any given level in the
	 * route hierarchy.
	 */
	
	var NotFoundRoute = (function (_Route) {
	  _inherits(NotFoundRoute, _Route);
	
	  function NotFoundRoute() {
	    _classCallCheck(this, NotFoundRoute);
	
	    _get(Object.getPrototypeOf(NotFoundRoute.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  return NotFoundRoute;
	})(Route);
	
	NotFoundRoute.propTypes = {
	  name: PropTypes.string,
	  path: PropTypes.falsy,
	  children: PropTypes.falsy,
	  handler: PropTypes.func.isRequired
	};
	
	NotFoundRoute.defaultProps = {
	  handler: RouteHandler
	};
	
	module.exports = NotFoundRoute;

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PropTypes = __webpack_require__(69);
	var Route = __webpack_require__(168);
	
	/**
	 * A <Redirect> component is a special kind of <Route> that always
	 * redirects to another route when it matches.
	 */
	
	var Redirect = (function (_Route) {
	  _inherits(Redirect, _Route);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    _get(Object.getPrototypeOf(Redirect.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  return Redirect;
	})(Route);
	
	Redirect.propTypes = {
	  path: PropTypes.string,
	  from: PropTypes.string, // Alias for path.
	  to: PropTypes.string,
	  handler: PropTypes.falsy
	};
	
	// Redirects should not have a default handler
	Redirect.defaultProps = {};
	
	module.exports = Redirect;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint -W058 */
	'use strict';
	
	var React = __webpack_require__(2);
	var warning = __webpack_require__(238);
	var invariant = __webpack_require__(67);
	var canUseDOM = __webpack_require__(145);
	var LocationActions = __webpack_require__(130);
	var ImitateBrowserBehavior = __webpack_require__(368);
	var HashLocation = __webpack_require__(374);
	var HistoryLocation = __webpack_require__(237);
	var RefreshLocation = __webpack_require__(375);
	var StaticLocation = __webpack_require__(376);
	var ScrollHistory = __webpack_require__(831);
	var createRoutesFromReactChildren = __webpack_require__(373);
	var isReactChildren = __webpack_require__(838);
	var Transition = __webpack_require__(833);
	var PropTypes = __webpack_require__(69);
	var Redirect = __webpack_require__(367);
	var History = __webpack_require__(112);
	var Cancellation = __webpack_require__(366);
	var Match = __webpack_require__(829);
	var Route = __webpack_require__(99);
	var supportsHistory = __webpack_require__(841);
	var PathUtils = __webpack_require__(236);
	
	/**
	 * The default location for new routers.
	 */
	var DEFAULT_LOCATION = canUseDOM ? HashLocation : '/';
	
	/**
	 * The default scroll behavior for new routers.
	 */
	var DEFAULT_SCROLL_BEHAVIOR = canUseDOM ? ImitateBrowserBehavior : null;
	
	function hasProperties(object, properties) {
	  for (var propertyName in properties) if (properties.hasOwnProperty(propertyName) && object[propertyName] !== properties[propertyName]) return false;
	
	  return true;
	}
	
	function hasMatch(routes, route, prevParams, nextParams, prevQuery, nextQuery) {
	  return routes.some(function (r) {
	    if (r !== route) return false;
	
	    var paramNames = route.paramNames;
	    var paramName;
	
	    // Ensure that all params the route cares about did not change.
	    for (var i = 0, len = paramNames.length; i < len; ++i) {
	      paramName = paramNames[i];
	
	      if (nextParams[paramName] !== prevParams[paramName]) return false;
	    }
	
	    // Ensure the query hasn't changed.
	    return hasProperties(prevQuery, nextQuery) && hasProperties(nextQuery, prevQuery);
	  });
	}
	
	function addRoutesToNamedRoutes(routes, namedRoutes) {
	  var route;
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    route = routes[i];
	
	    if (route.name) {
	      invariant(namedRoutes[route.name] == null, 'You may not have more than one route named "%s"', route.name);
	
	      namedRoutes[route.name] = route;
	    }
	
	    if (route.childRoutes) addRoutesToNamedRoutes(route.childRoutes, namedRoutes);
	  }
	}
	
	function routeIsActive(activeRoutes, routeName) {
	  return activeRoutes.some(function (route) {
	    return route.name === routeName;
	  });
	}
	
	function paramsAreActive(activeParams, params) {
	  for (var property in params) if (String(activeParams[property]) !== String(params[property])) return false;
	
	  return true;
	}
	
	function queryIsActive(activeQuery, query) {
	  for (var property in query) if (String(activeQuery[property]) !== String(query[property])) return false;
	
	  return true;
	}
	
	/**
	 * Creates and returns a new router using the given options. A router
	 * is a ReactComponent class that knows how to react to changes in the
	 * URL and keep the contents of the page in sync.
	 *
	 * Options may be any of the following:
	 *
	 * - routes           (required) The route config
	 * - location         The location to use. Defaults to HashLocation when
	 *                    the DOM is available, "/" otherwise
	 * - scrollBehavior   The scroll behavior to use. Defaults to ImitateBrowserBehavior
	 *                    when the DOM is available, null otherwise
	 * - onError          A function that is used to handle errors
	 * - onAbort          A function that is used to handle aborted transitions
	 *
	 * When rendering in a server-side environment, the location should simply
	 * be the URL path that was used in the request, including the query string.
	 */
	function createRouter(options) {
	  options = options || {};
	
	  if (isReactChildren(options)) options = { routes: options };
	
	  var mountedComponents = [];
	  var location = options.location || DEFAULT_LOCATION;
	  var scrollBehavior = options.scrollBehavior || DEFAULT_SCROLL_BEHAVIOR;
	  var state = {};
	  var nextState = {};
	  var pendingTransition = null;
	  var dispatchHandler = null;
	
	  if (typeof location === 'string') location = new StaticLocation(location);
	
	  if (location instanceof StaticLocation) {
	    warning(!canUseDOM || ("production") === 'test', 'You should not use a static location in a DOM environment because ' + 'the router will not be kept in sync with the current URL');
	  } else {
	    invariant(canUseDOM || location.needsDOM === false, 'You cannot use %s without a DOM', location);
	  }
	
	  // Automatically fall back to full page refreshes in
	  // browsers that don't support the HTML history API.
	  if (location === HistoryLocation && !supportsHistory()) location = RefreshLocation;
	
	  var Router = React.createClass({
	
	    displayName: 'Router',
	
	    statics: {
	
	      isRunning: false,
	
	      cancelPendingTransition: function cancelPendingTransition() {
	        if (pendingTransition) {
	          pendingTransition.cancel();
	          pendingTransition = null;
	        }
	      },
	
	      clearAllRoutes: function clearAllRoutes() {
	        Router.cancelPendingTransition();
	        Router.namedRoutes = {};
	        Router.routes = [];
	      },
	
	      /**
	       * Adds routes to this router from the given children object (see ReactChildren).
	       */
	      addRoutes: function addRoutes(routes) {
	        if (isReactChildren(routes)) routes = createRoutesFromReactChildren(routes);
	
	        addRoutesToNamedRoutes(routes, Router.namedRoutes);
	
	        Router.routes.push.apply(Router.routes, routes);
	      },
	
	      /**
	       * Replaces routes of this router from the given children object (see ReactChildren).
	       */
	      replaceRoutes: function replaceRoutes(routes) {
	        Router.clearAllRoutes();
	        Router.addRoutes(routes);
	        Router.refresh();
	      },
	
	      /**
	       * Performs a match of the given path against this router and returns an object
	       * with the { routes, params, pathname, query } that match. Returns null if no
	       * match can be made.
	       */
	      match: function match(path) {
	        return Match.findMatch(Router.routes, path);
	      },
	
	      /**
	       * Returns an absolute URL path created from the given route
	       * name, URL parameters, and query.
	       */
	      makePath: function makePath(to, params, query) {
	        var path;
	        if (PathUtils.isAbsolute(to)) {
	          path = to;
	        } else {
	          var route = to instanceof Route ? to : Router.namedRoutes[to];
	
	          invariant(route instanceof Route, 'Cannot find a route named "%s"', to);
	
	          path = route.path;
	        }
	
	        return PathUtils.withQuery(PathUtils.injectParams(path, params), query);
	      },
	
	      /**
	       * Returns a string that may safely be used as the href of a link
	       * to the route with the given name, URL parameters, and query.
	       */
	      makeHref: function makeHref(to, params, query) {
	        var path = Router.makePath(to, params, query);
	        return location === HashLocation ? '#' + path : path;
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by pushing
	       * a new URL onto the history stack.
	       */
	      transitionTo: function transitionTo(to, params, query) {
	        var path = Router.makePath(to, params, query);
	
	        if (pendingTransition) {
	          // Replace so pending location does not stay in history.
	          location.replace(path);
	        } else {
	          location.push(path);
	        }
	      },
	
	      /**
	       * Transitions to the URL specified in the arguments by replacing
	       * the current URL in the history stack.
	       */
	      replaceWith: function replaceWith(to, params, query) {
	        location.replace(Router.makePath(to, params, query));
	      },
	
	      /**
	       * Transitions to the previous URL if one is available. Returns true if the
	       * router was able to go back, false otherwise.
	       *
	       * Note: The router only tracks history entries in your application, not the
	       * current browser session, so you can safely call this function without guarding
	       * against sending the user back to some other site. However, when using
	       * RefreshLocation (which is the fallback for HistoryLocation in browsers that
	       * don't support HTML5 history) this method will *always* send the client back
	       * because we cannot reliably track history length.
	       */
	      goBack: function goBack() {
	        if (History.length > 1 || location === RefreshLocation) {
	          location.pop();
	          return true;
	        }
	
	        warning(false, 'goBack() was ignored because there is no router history');
	
	        return false;
	      },
	
	      handleAbort: options.onAbort || function (abortReason) {
	        if (location instanceof StaticLocation) throw new Error('Unhandled aborted transition! Reason: ' + abortReason);
	
	        if (abortReason instanceof Cancellation) {
	          return;
	        } else if (abortReason instanceof Redirect) {
	          location.replace(Router.makePath(abortReason.to, abortReason.params, abortReason.query));
	        } else {
	          location.pop();
	        }
	      },
	
	      handleError: options.onError || function (error) {
	        // Throw so we don't silently swallow async errors.
	        throw error; // This error probably originated in a transition hook.
	      },
	
	      handleLocationChange: function handleLocationChange(change) {
	        Router.dispatch(change.path, change.type);
	      },
	
	      /**
	       * Performs a transition to the given path and calls callback(error, abortReason)
	       * when the transition is finished. If both arguments are null the router's state
	       * was updated. Otherwise the transition did not complete.
	       *
	       * In a transition, a router first determines which routes are involved by beginning
	       * with the current route, up the route tree to the first parent route that is shared
	       * with the destination route, and back down the tree to the destination route. The
	       * willTransitionFrom hook is invoked on all route handlers we're transitioning away
	       * from, in reverse nesting order. Likewise, the willTransitionTo hook is invoked on
	       * all route handlers we're transitioning to.
	       *
	       * Both willTransitionFrom and willTransitionTo hooks may either abort or redirect the
	       * transition. To resolve asynchronously, they may use the callback argument. If no
	       * hooks wait, the transition is fully synchronous.
	       */
	      dispatch: function dispatch(path, action) {
	        Router.cancelPendingTransition();
	
	        var prevPath = state.path;
	        var isRefreshing = action == null;
	
	        if (prevPath === path && !isRefreshing) return; // Nothing to do!
	
	        // Record the scroll position as early as possible to
	        // get it before browsers try update it automatically.
	        if (prevPath && action === LocationActions.PUSH) Router.recordScrollPosition(prevPath);
	
	        var match = Router.match(path);
	
	        warning(match != null, 'No route matches path "%s". Make sure you have <Route path="%s"> somewhere in your routes', path, path);
	
	        if (match == null) match = {};
	
	        var prevRoutes = state.routes || [];
	        var prevParams = state.params || {};
	        var prevQuery = state.query || {};
	
	        var nextRoutes = match.routes || [];
	        var nextParams = match.params || {};
	        var nextQuery = match.query || {};
	
	        var fromRoutes, toRoutes;
	        if (prevRoutes.length) {
	          fromRoutes = prevRoutes.filter(function (route) {
	            return !hasMatch(nextRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	
	          toRoutes = nextRoutes.filter(function (route) {
	            return !hasMatch(prevRoutes, route, prevParams, nextParams, prevQuery, nextQuery);
	          });
	        } else {
	          fromRoutes = [];
	          toRoutes = nextRoutes;
	        }
	
	        var transition = new Transition(path, Router.replaceWith.bind(Router, path));
	        pendingTransition = transition;
	
	        var fromComponents = mountedComponents.slice(prevRoutes.length - fromRoutes.length);
	
	        Transition.from(transition, fromRoutes, fromComponents, function (error) {
	          if (error || transition.abortReason) return dispatchHandler.call(Router, error, transition); // No need to continue.
	
	          Transition.to(transition, toRoutes, nextParams, nextQuery, function (error) {
	            dispatchHandler.call(Router, error, transition, {
	              path: path,
	              action: action,
	              pathname: match.pathname,
	              routes: nextRoutes,
	              params: nextParams,
	              query: nextQuery
	            });
	          });
	        });
	      },
	
	      /**
	       * Starts this router and calls callback(router, state) when the route changes.
	       *
	       * If the router's location is static (i.e. a URL path in a server environment)
	       * the callback is called only once. Otherwise, the location should be one of the
	       * Router.*Location objects (e.g. Router.HashLocation or Router.HistoryLocation).
	       */
	      run: function run(callback) {
	        invariant(!Router.isRunning, 'Router is already running');
	
	        dispatchHandler = function (error, transition, newState) {
	          if (error) Router.handleError(error);
	
	          if (pendingTransition !== transition) return;
	
	          pendingTransition = null;
	
	          if (transition.abortReason) {
	            Router.handleAbort(transition.abortReason);
	          } else {
	            callback.call(Router, Router, nextState = newState);
	          }
	        };
	
	        if (!(location instanceof StaticLocation)) {
	          if (location.addChangeListener) location.addChangeListener(Router.handleLocationChange);
	
	          Router.isRunning = true;
	        }
	
	        // Bootstrap using the current path.
	        Router.refresh();
	      },
	
	      refresh: function refresh() {
	        Router.dispatch(location.getCurrentPath(), null);
	      },
	
	      stop: function stop() {
	        Router.cancelPendingTransition();
	
	        if (location.removeChangeListener) location.removeChangeListener(Router.handleLocationChange);
	
	        Router.isRunning = false;
	      },
	
	      getLocation: function getLocation() {
	        return location;
	      },
	
	      getScrollBehavior: function getScrollBehavior() {
	        return scrollBehavior;
	      },
	
	      getRouteAtDepth: function getRouteAtDepth(routeDepth) {
	        var routes = state.routes;
	        return routes && routes[routeDepth];
	      },
	
	      setRouteComponentAtDepth: function setRouteComponentAtDepth(routeDepth, component) {
	        mountedComponents[routeDepth] = component;
	      },
	
	      /**
	       * Returns the current URL path + query string.
	       */
	      getCurrentPath: function getCurrentPath() {
	        return state.path;
	      },
	
	      /**
	       * Returns the current URL path without the query string.
	       */
	      getCurrentPathname: function getCurrentPathname() {
	        return state.pathname;
	      },
	
	      /**
	       * Returns an object of the currently active URL parameters.
	       */
	      getCurrentParams: function getCurrentParams() {
	        return state.params;
	      },
	
	      /**
	       * Returns an object of the currently active query parameters.
	       */
	      getCurrentQuery: function getCurrentQuery() {
	        return state.query;
	      },
	
	      /**
	       * Returns an array of the currently active routes.
	       */
	      getCurrentRoutes: function getCurrentRoutes() {
	        return state.routes;
	      },
	
	      /**
	       * Returns true if the given route, params, and query are active.
	       */
	      isActive: function isActive(to, params, query) {
	        if (PathUtils.isAbsolute(to)) return to === state.path;
	
	        return routeIsActive(state.routes, to) && paramsAreActive(state.params, params) && (query == null || queryIsActive(state.query, query));
	      }
	
	    },
	
	    mixins: [ScrollHistory],
	
	    propTypes: {
	      children: PropTypes.falsy
	    },
	
	    childContextTypes: {
	      routeDepth: PropTypes.number.isRequired,
	      router: PropTypes.router.isRequired
	    },
	
	    getChildContext: function getChildContext() {
	      return {
	        routeDepth: 1,
	        router: Router
	      };
	    },
	
	    getInitialState: function getInitialState() {
	      return state = nextState;
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this.setState(state = nextState);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      Router.stop();
	    },
	
	    render: function render() {
	      var route = Router.getRouteAtDepth(0);
	      return route ? React.createElement(route.handler, this.props) : null;
	    }
	
	  });
	
	  Router.clearAllRoutes();
	
	  if (options.routes) Router.addRoutes(options.routes);
	
	  return Router;
	}
	
	module.exports = createRouter;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint -W084 */
	'use strict';
	
	var React = __webpack_require__(2);
	var assign = __webpack_require__(113);
	var warning = __webpack_require__(238);
	var DefaultRoute = __webpack_require__(369);
	var NotFoundRoute = __webpack_require__(370);
	var Redirect = __webpack_require__(371);
	var Route = __webpack_require__(99);
	
	function checkPropTypes(componentName, propTypes, props) {
	  componentName = componentName || 'UnknownComponent';
	
	  for (var propName in propTypes) {
	    if (propTypes.hasOwnProperty(propName)) {
	      var error = propTypes[propName](props, propName, componentName);
	
	      if (error instanceof Error) warning(false, error.message);
	    }
	  }
	}
	
	function createRouteOptions(props) {
	  var options = assign({}, props);
	  var handler = options.handler;
	
	  if (handler) {
	    options.onEnter = handler.willTransitionTo;
	    options.onLeave = handler.willTransitionFrom;
	  }
	
	  return options;
	}
	
	function createRouteFromReactElement(element) {
	  if (!React.isValidElement(element)) return;
	
	  var type = element.type;
	  var props = assign({}, type.defaultProps, element.props);
	
	  if (type.propTypes) checkPropTypes(type.displayName, type.propTypes, props);
	
	  if (type === DefaultRoute) return Route.createDefaultRoute(createRouteOptions(props));
	
	  if (type === NotFoundRoute) return Route.createNotFoundRoute(createRouteOptions(props));
	
	  if (type === Redirect) return Route.createRedirect(createRouteOptions(props));
	
	  return Route.createRoute(createRouteOptions(props), function () {
	    if (props.children) createRoutesFromReactChildren(props.children);
	  });
	}
	
	/**
	 * Creates and returns an array of routes created from the given
	 * ReactChildren, all of which should be one of <Route>, <DefaultRoute>,
	 * <NotFoundRoute>, or <Redirect>, e.g.:
	 *
	 *   var { createRoutesFromReactChildren, Route, Redirect } = require('react-router');
	 *
	 *   var routes = createRoutesFromReactChildren(
	 *     <Route path="/" handler={App}>
	 *       <Route name="user" path="/user/:userId" handler={User}>
	 *         <Route name="task" path="tasks/:taskId" handler={Task}/>
	 *         <Redirect from="todos/:taskId" to="task"/>
	 *       </Route>
	 *     </Route>
	 *   );
	 */
	function createRoutesFromReactChildren(children) {
	  var routes = [];
	
	  React.Children.forEach(children, function (child) {
	    if (child = createRouteFromReactElement(child)) routes.push(child);
	  });
	
	  return routes;
	}
	
	module.exports = createRoutesFromReactChildren;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var LocationActions = __webpack_require__(130);
	var History = __webpack_require__(112);
	
	var _listeners = [];
	var _isListening = false;
	var _actionType;
	
	function notifyChange(type) {
	  if (type === LocationActions.PUSH) History.length += 1;
	
	  var change = {
	    path: HashLocation.getCurrentPath(),
	    type: type
	  };
	
	  _listeners.forEach(function (listener) {
	    listener.call(HashLocation, change);
	  });
	}
	
	function ensureSlash() {
	  var path = HashLocation.getCurrentPath();
	
	  if (path.charAt(0) === '/') return true;
	
	  HashLocation.replace('/' + path);
	
	  return false;
	}
	
	function onHashChange() {
	  if (ensureSlash()) {
	    // If we don't have an _actionType then all we know is the hash
	    // changed. It was probably caused by the user clicking the Back
	    // button, but may have also been the Forward button or manual
	    // manipulation. So just guess 'pop'.
	    var curActionType = _actionType;
	    _actionType = null;
	    notifyChange(curActionType || LocationActions.POP);
	  }
	}
	
	/**
	 * A Location that uses `window.location.hash`.
	 */
	var HashLocation = {
	
	  addChangeListener: function addChangeListener(listener) {
	    _listeners.push(listener);
	
	    // Do this BEFORE listening for hashchange.
	    ensureSlash();
	
	    if (!_isListening) {
	      if (window.addEventListener) {
	        window.addEventListener('hashchange', onHashChange, false);
	      } else {
	        window.attachEvent('onhashchange', onHashChange);
	      }
	
	      _isListening = true;
	    }
	  },
	
	  removeChangeListener: function removeChangeListener(listener) {
	    _listeners = _listeners.filter(function (l) {
	      return l !== listener;
	    });
	
	    if (_listeners.length === 0) {
	      if (window.removeEventListener) {
	        window.removeEventListener('hashchange', onHashChange, false);
	      } else {
	        window.removeEvent('onhashchange', onHashChange);
	      }
	
	      _isListening = false;
	    }
	  },
	
	  push: function push(path) {
	    _actionType = LocationActions.PUSH;
	    window.location.hash = path;
	  },
	
	  replace: function replace(path) {
	    _actionType = LocationActions.REPLACE;
	    window.location.replace(window.location.pathname + window.location.search + '#' + path);
	  },
	
	  pop: function pop() {
	    _actionType = LocationActions.POP;
	    History.back();
	  },
	
	  getCurrentPath: function getCurrentPath() {
	    return decodeURI(
	    // We can't use window.location.hash here because it's not
	    // consistent across browsers - Firefox will pre-decode it!
	    window.location.href.split('#')[1] || '');
	  },
	
	  toString: function toString() {
	    return '<HashLocation>';
	  }
	
	};
	
	module.exports = HashLocation;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var HistoryLocation = __webpack_require__(237);
	var History = __webpack_require__(112);
	
	/**
	 * A Location that uses full page refreshes. This is used as
	 * the fallback for HistoryLocation in browsers that do not
	 * support the HTML5 history API.
	 */
	var RefreshLocation = {
	
	  push: function push(path) {
	    window.location = path;
	  },
	
	  replace: function replace(path) {
	    window.location.replace(path);
	  },
	
	  pop: History.back,
	
	  getCurrentPath: HistoryLocation.getCurrentPath,
	
	  toString: function toString() {
	    return '<RefreshLocation>';
	  }
	
	};
	
	module.exports = RefreshLocation;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(67);
	
	function throwCannotModify() {
	  invariant(false, 'You cannot modify a static location');
	}
	
	/**
	 * A location that only ever contains a single path. Useful in
	 * stateless environments like servers where there is no path history,
	 * only the path that was used in the request.
	 */
	
	var StaticLocation = (function () {
	  function StaticLocation(path) {
	    _classCallCheck(this, StaticLocation);
	
	    this.path = path;
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(StaticLocation, [{
	    key: 'getCurrentPath',
	    value: function getCurrentPath() {
	      return this.path;
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<StaticLocation path="' + this.path + '">';
	    }
	  }]);
	
	  return StaticLocation;
	})();
	
	StaticLocation.prototype.push = throwCannotModify;
	StaticLocation.prototype.replace = throwCannotModify;
	StaticLocation.prototype.pop = throwCannotModify;
	
	module.exports = StaticLocation;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	/* disable some rules until we refactor more completely; fixing them now would
	   cause conflicts with some open PRs unnecessarily. */
	/* eslint react/jsx-sort-prop-types: 0, react/sort-comp: 0, react/prop-types: 0 */
	
	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(2);
	var Input = __webpack_require__(823);
	var classes = __webpack_require__(14);
	var Value = __webpack_require__(842);
	
	var requestId = 0;
	
	var Select = React.createClass({
	
		displayName: 'Select',
	
		propTypes: {
			allowCreate: React.PropTypes.bool, // wether to allow creation of new entries
			asyncOptions: React.PropTypes.func, // function to call to get options
			autoload: React.PropTypes.bool, // whether to auto-load the default async options set
			className: React.PropTypes.string, // className for the outer element
			clearable: React.PropTypes.bool, // should it be possible to reset value
			clearAllText: React.PropTypes.string, // title for the "clear" control when multi: true
			clearValueText: React.PropTypes.string, // title for the "clear" control
			delimiter: React.PropTypes.string, // delimiter to use to join multiple values
			disabled: React.PropTypes.bool, // whether the Select is disabled or not
			filterOption: React.PropTypes.func, // method to filter a single option: function(option, filterString)
			filterOptions: React.PropTypes.func, // method to filter the options array: function([options], filterString, [values])
			ignoreCase: React.PropTypes.bool, // whether to perform case-insensitive filtering
			inputProps: React.PropTypes.object, // custom attributes for the Input (in the Select-control) e.g: {'data-foo': 'bar'}
			matchPos: React.PropTypes.string, // (any|start) match the start or entire string when filtering
			matchProp: React.PropTypes.string, // (any|label|value) which option property to filter on
			multi: React.PropTypes.bool, // multi-value input
			name: React.PropTypes.string, // field name, for hidden <input /> tag
			addLabelText: React.PropTypes.string, // placeholder displayed when you want to add a label on a multi-value input
			noResultsText: React.PropTypes.string, // placeholder displayed when there are no matching search results
			onBlur: React.PropTypes.func, // onBlur handler: function(event) {}
			onChange: React.PropTypes.func, // onChange handler: function(newValue) {}
			onFocus: React.PropTypes.func, // onFocus handler: function(event) {}
			onOptionLabelClick: React.PropTypes.func, // onCLick handler for value labels: function (value, event) {}
			optionRenderer: React.PropTypes.func, // optionRenderer: function(option) {}
			options: React.PropTypes.array, // array of options
			placeholder: React.PropTypes.string, // field placeholder, displayed when there's no value
			searchable: React.PropTypes.bool, // whether to enable searching feature or not
			searchPromptText: React.PropTypes.string, // label to prompt for search input
			value: React.PropTypes.any, // initial field value
			valueRenderer: React.PropTypes.func // valueRenderer: function(option) {}
		},
	
		getDefaultProps: function getDefaultProps() {
			return {
				allowCreate: false,
				asyncOptions: undefined,
				autoload: true,
				className: undefined,
				clearable: true,
				clearAllText: 'Clear all',
				clearValueText: 'Clear value',
				delimiter: ',',
				disabled: false,
				ignoreCase: true,
				inputProps: {},
				matchPos: 'any',
				matchProp: 'any',
				name: undefined,
				addLabelText: 'Add {label} ?',
				noResultsText: 'No results found',
				onChange: undefined,
				onOptionLabelClick: undefined,
				options: undefined,
				placeholder: 'Select...',
				searchable: true,
				searchPromptText: 'Type to search',
				value: undefined
			};
		},
	
		getInitialState: function getInitialState() {
			return {
				/*
	    * set by getStateFromValue on componentWillMount:
	    * - value
	    * - values
	    * - filteredOptions
	    * - inputValue
	    * - placeholder
	    * - focusedOption
	   */
				isFocused: false,
				isLoading: false,
				isOpen: false,
				options: this.props.options
			};
		},
	
		componentWillMount: function componentWillMount() {
			this._optionsCache = {};
			this._optionsFilterString = '';
	
			var self = this;
			this._closeMenuIfClickedOutside = function (event) {
				if (!self.state.isOpen) {
					return;
				}
				var menuElem = React.findDOMNode(self.refs.selectMenuContainer);
				var controlElem = React.findDOMNode(self.refs.control);
	
				var eventOccuredOutsideMenu = self.clickedOutsideElement(menuElem, event);
				var eventOccuredOutsideControl = self.clickedOutsideElement(controlElem, event);
	
				// Hide dropdown menu if click occurred outside of menu
				if (eventOccuredOutsideMenu && eventOccuredOutsideControl) {
					self.setState({
						isOpen: false
					}, self._unbindCloseMenuIfClickedOutside);
				}
			};
	
			this._bindCloseMenuIfClickedOutside = function () {
				if (!document.addEventListener && document.attachEvent) {
					document.attachEvent('onclick', this._closeMenuIfClickedOutside);
				} else {
					document.addEventListener('click', this._closeMenuIfClickedOutside);
				}
			};
	
			this._unbindCloseMenuIfClickedOutside = function () {
				if (!document.removeEventListener && document.detachEvent) {
					document.detachEvent('onclick', this._closeMenuIfClickedOutside);
				} else {
					document.removeEventListener('click', this._closeMenuIfClickedOutside);
				}
			};
	
			this.setState(this.getStateFromValue(this.props.value));
		},
	
		componentDidMount: function componentDidMount() {
			if (this.props.asyncOptions && this.props.autoload) {
				this.autoloadAsyncOptions();
			}
		},
	
		componentWillUnmount: function componentWillUnmount() {
			clearTimeout(this._blurTimeout);
			clearTimeout(this._focusTimeout);
	
			if (this.state.isOpen) {
				this._unbindCloseMenuIfClickedOutside();
			}
		},
	
		componentWillReceiveProps: function componentWillReceiveProps(newProps) {
			if (JSON.stringify(newProps.options) !== JSON.stringify(this.props.options)) {
				this.setState({
					options: newProps.options,
					filteredOptions: this.filterOptions(newProps.options)
				});
			}
			if (newProps.value !== this.state.value || newProps.placeholder !== this.state.placeholder) {
				this.setState(this.getStateFromValue(newProps.value, newProps.options, newProps.placeholder));
			}
		},
	
		componentDidUpdate: function componentDidUpdate() {
			var self = this;
	
			if (!this.props.disabled && this._focusAfterUpdate) {
				clearTimeout(this._blurTimeout);
				this._focusTimeout = setTimeout(function () {
					self.getInputNode().focus();
					self._focusAfterUpdate = false;
				}, 50);
			}
	
			if (this._focusedOptionReveal) {
				if (this.refs.focused && this.refs.menu) {
					var focusedDOM = React.findDOMNode(this.refs.focused);
					var menuDOM = React.findDOMNode(this.refs.menu);
					var focusedRect = focusedDOM.getBoundingClientRect();
					var menuRect = menuDOM.getBoundingClientRect();
	
					if (focusedRect.bottom > menuRect.bottom || focusedRect.top < menuRect.top) {
						menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.offsetHeight;
					}
				}
				this._focusedOptionReveal = false;
			}
		},
	
		focus: function focus() {
			this.getInputNode().focus();
		},
	
		clickedOutsideElement: function clickedOutsideElement(element, event) {
			var eventTarget = event.target ? event.target : event.srcElement;
			while (eventTarget != null) {
				if (eventTarget === element) return false;
				eventTarget = eventTarget.offsetParent;
			}
			return true;
		},
	
		getStateFromValue: function getStateFromValue(value, options, placeholder) {
			if (!options) {
				options = this.state.options;
			}
			if (!placeholder) {
				placeholder = this.props.placeholder;
			}
	
			// reset internal filter string
			this._optionsFilterString = '';
	
			var values = this.initValuesArray(value, options),
			    filteredOptions = this.filterOptions(options, values);
	
			return {
				value: values.map(function (v) {
					return v.value;
				}).join(this.props.delimiter),
				values: values,
				inputValue: '',
				filteredOptions: filteredOptions,
				placeholder: !this.props.multi && values.length ? values[0].label : placeholder,
				focusedOption: !this.props.multi && values.length ? values[0] : filteredOptions[0]
			};
		},
	
		initValuesArray: function initValuesArray(values, options) {
			if (!Array.isArray(values)) {
				if (typeof values === 'string') {
					values = values === '' ? [] : values.split(this.props.delimiter);
				} else {
					values = values ? [values] : [];
				}
			}
	
			return values.map(function (val) {
				if (typeof val === 'string') {
					for (var key in options) {
						if (options.hasOwnProperty(key) && options[key] && options[key].value === val) {
							return options[key];
						}
					}
					return { value: val, label: val };
				} else {
					return val;
				}
			});
		},
	
		setValue: function setValue(value, focusAfterUpdate) {
			if (focusAfterUpdate || focusAfterUpdate === undefined) {
				this._focusAfterUpdate = true;
			}
			var newState = this.getStateFromValue(value);
			newState.isOpen = false;
			this.fireChangeEvent(newState);
			this.setState(newState);
		},
	
		selectValue: function selectValue(value) {
			if (!this.props.multi) {
				this.setValue(value);
			} else if (value) {
				this.addValue(value);
			}
			this._unbindCloseMenuIfClickedOutside();
		},
	
		addValue: function addValue(value) {
			this.setValue(this.state.values.concat(value));
		},
	
		popValue: function popValue() {
			this.setValue(this.state.values.slice(0, this.state.values.length - 1));
		},
	
		removeValue: function removeValue(valueToRemove) {
			this.setValue(this.state.values.filter(function (value) {
				return value !== valueToRemove;
			}));
		},
	
		clearValue: function clearValue(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, ignore it.
			if (event && event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			event.stopPropagation();
			event.preventDefault();
			this.setValue(null);
		},
	
		resetValue: function resetValue() {
			this.setValue(this.state.value === '' ? null : this.state.value);
		},
	
		getInputNode: function getInputNode() {
			var input = this.refs.input;
			return this.props.searchable ? input : React.findDOMNode(input);
		},
	
		fireChangeEvent: function fireChangeEvent(newState) {
			if (newState.value !== this.state.value && this.props.onChange) {
				this.props.onChange(newState.value, newState.values);
			}
		},
	
		handleMouseDown: function handleMouseDown(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
	
			event.stopPropagation();
			event.preventDefault();
			if (this.state.isFocused) {
				this.setState({
					isOpen: true
				}, this._bindCloseMenuIfClickedOutside);
			} else {
				this._openAfterFocus = true;
				this.getInputNode().focus();
			}
		},
	
		handleMouseDownOnArrow: function handleMouseDownOnArrow(event) {
			// if the event was triggered by a mousedown and not the primary
			// button, or if the component is disabled, ignore it.
			if (this.props.disabled || event.type === 'mousedown' && event.button !== 0) {
				return;
			}
			// If not focused, handleMouseDown will handle it
			if (!this.state.isOpen) {
				return;
			}
	
			event.stopPropagation();
			event.preventDefault();
			this.setState({
				isOpen: false
			}, this._unbindCloseMenuIfClickedOutside);
		},
	
		handleInputFocus: function handleInputFocus(event) {
			var newIsOpen = this.state.isOpen || this._openAfterFocus;
			this.setState({
				isFocused: true,
				isOpen: newIsOpen
			}, function () {
				if (newIsOpen) {
					this._bindCloseMenuIfClickedOutside();
				} else {
					this._unbindCloseMenuIfClickedOutside();
				}
			});
			this._openAfterFocus = false;
	
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
		},
	
		handleInputBlur: function handleInputBlur(event) {
			var self = this;
	
			this._blurTimeout = setTimeout(function () {
				if (self._focusAfterUpdate) return;
	
				self.setState({
					isFocused: false
				});
			}, 50);
	
			if (this.props.onBlur) {
				this.props.onBlur(event);
			}
		},
	
		handleKeyDown: function handleKeyDown(event) {
			if (this.state.disabled) return;
	
			switch (event.keyCode) {
	
				case 8:
					// backspace
					if (!this.state.inputValue) {
						this.popValue();
					}
					return;
	
				case 9:
					// tab
					if (event.shiftKey || !this.state.isOpen || !this.state.focusedOption) {
						return;
					}
					this.selectFocusedOption();
					break;
	
				case 13:
					// enter
					if (!this.state.isOpen) return;
	
					this.selectFocusedOption();
					break;
	
				case 27:
					// escape
					if (this.state.isOpen) {
						this.resetValue();
					} else {
						this.clearValue(event);
					}
					break;
	
				case 38:
					// up
					this.focusPreviousOption();
					break;
	
				case 40:
					// down
					this.focusNextOption();
					break;
	
				case 188:
					// ,
					if (this.props.allowCreate && this.props.multi) {
						event.preventDefault();
						event.stopPropagation();
						this.selectFocusedOption();
					} else {
						return;
					}
					break;
	
				default:
					return;
			}
	
			event.preventDefault();
		},
	
		// Ensures that the currently focused option is available in filteredOptions.
		// If not, returns the first available option.
		_getNewFocusedOption: function _getNewFocusedOption(filteredOptions) {
			for (var key in filteredOptions) {
				if (filteredOptions.hasOwnProperty(key) && filteredOptions[key] === this.state.focusedOption) {
					return filteredOptions[key];
				}
			}
			return filteredOptions[0];
		},
	
		handleInputChange: function handleInputChange(event) {
			// assign an internal variable because we need to use
			// the latest value before setState() has completed.
			this._optionsFilterString = event.target.value;
	
			if (this.props.asyncOptions) {
				this.setState({
					isLoading: true,
					inputValue: event.target.value
				});
				this.loadAsyncOptions(event.target.value, {
					isLoading: false,
					isOpen: true
				}, this._bindCloseMenuIfClickedOutside);
			} else {
				var filteredOptions = this.filterOptions(this.state.options);
				this.setState({
					isOpen: true,
					inputValue: event.target.value,
					filteredOptions: filteredOptions,
					focusedOption: this._getNewFocusedOption(filteredOptions)
				}, this._bindCloseMenuIfClickedOutside);
			}
		},
	
		autoloadAsyncOptions: function autoloadAsyncOptions() {
			var self = this;
			this.loadAsyncOptions(this.props.value || '', {}, function () {
				// update with fetched but don't focus
				self.setValue(self.props.value, false);
			});
		},
	
		loadAsyncOptions: function loadAsyncOptions(input, state, callback) {
			var thisRequestId = this._currentRequestId = requestId++;
	
			for (var i = 0; i <= input.length; i++) {
				var cacheKey = input.slice(0, i);
				if (this._optionsCache[cacheKey] && (input === cacheKey || this._optionsCache[cacheKey].complete)) {
					var options = this._optionsCache[cacheKey].options;
					var filteredOptions = this.filterOptions(options);
	
					var newState = {
						options: options,
						filteredOptions: filteredOptions,
						focusedOption: this._getNewFocusedOption(filteredOptions)
					};
					for (var key in state) {
						if (state.hasOwnProperty(key)) {
							newState[key] = state[key];
						}
					}
					this.setState(newState);
					if (callback) callback.call(this, {});
					return;
				}
			}
	
			var self = this;
			this.props.asyncOptions(input, function (err, data) {
	
				if (err) throw err;
	
				self._optionsCache[input] = data;
	
				if (thisRequestId !== self._currentRequestId) {
					return;
				}
				var filteredOptions = self.filterOptions(data.options);
	
				var newState = {
					options: data.options,
					filteredOptions: filteredOptions,
					focusedOption: self._getNewFocusedOption(filteredOptions)
				};
				for (var key in state) {
					if (state.hasOwnProperty(key)) {
						newState[key] = state[key];
					}
				}
				self.setState(newState);
	
				if (callback) callback.call(self, {});
			});
		},
	
		filterOptions: function filterOptions(options, values) {
			if (!this.props.searchable) {
				return options;
			}
	
			var filterValue = this._optionsFilterString;
			var exclude = (values || this.state.values).map(function (i) {
				return i.value;
			});
			if (this.props.filterOptions) {
				return this.props.filterOptions.call(this, options, filterValue, exclude);
			} else {
				var filterOption = function filterOption(op) {
					if (this.props.multi && exclude.indexOf(op.value) > -1) return false;
					if (this.props.filterOption) return this.props.filterOption.call(this, op, filterValue);
					var valueTest = String(op.value),
					    labelTest = String(op.label);
					if (this.props.ignoreCase) {
						valueTest = valueTest.toLowerCase();
						labelTest = labelTest.toLowerCase();
						filterValue = filterValue.toLowerCase();
					}
					return !filterValue || this.props.matchPos === 'start' ? this.props.matchProp !== 'label' && valueTest.substr(0, filterValue.length) === filterValue || this.props.matchProp !== 'value' && labelTest.substr(0, filterValue.length) === filterValue : this.props.matchProp !== 'label' && valueTest.indexOf(filterValue) >= 0 || this.props.matchProp !== 'value' && labelTest.indexOf(filterValue) >= 0;
				};
				return (options || []).filter(filterOption, this);
			}
		},
	
		selectFocusedOption: function selectFocusedOption() {
			if (this.props.allowCreate && !this.state.focusedOption) {
				return this.selectValue(this.state.inputValue);
			}
			return this.selectValue(this.state.focusedOption);
		},
	
		focusOption: function focusOption(op) {
			this.setState({
				focusedOption: op
			});
		},
	
		focusNextOption: function focusNextOption() {
			this.focusAdjacentOption('next');
		},
	
		focusPreviousOption: function focusPreviousOption() {
			this.focusAdjacentOption('previous');
		},
	
		focusAdjacentOption: function focusAdjacentOption(dir) {
			this._focusedOptionReveal = true;
	
			var ops = this.state.filteredOptions;
	
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true,
					inputValue: '',
					focusedOption: this.state.focusedOption || ops[dir === 'next' ? 0 : ops.length - 1]
				}, this._bindCloseMenuIfClickedOutside);
				return;
			}
	
			if (!ops.length) {
				return;
			}
	
			var focusedIndex = -1;
	
			for (var i = 0; i < ops.length; i++) {
				if (this.state.focusedOption === ops[i]) {
					focusedIndex = i;
					break;
				}
			}
	
			var focusedOption = ops[0];
	
			if (dir === 'next' && focusedIndex > -1 && focusedIndex < ops.length - 1) {
				focusedOption = ops[focusedIndex + 1];
			} else if (dir === 'previous') {
				if (focusedIndex > 0) {
					focusedOption = ops[focusedIndex - 1];
				} else {
					focusedOption = ops[ops.length - 1];
				}
			}
	
			this.setState({
				focusedOption: focusedOption
			});
		},
	
		unfocusOption: function unfocusOption(op) {
			if (this.state.focusedOption === op) {
				this.setState({
					focusedOption: null
				});
			}
		},
	
		buildMenu: function buildMenu() {
			var focusedValue = this.state.focusedOption ? this.state.focusedOption.value : null;
			var renderLabel = this.props.optionRenderer || function (op) {
				return op.label;
			};
	
			if (this.state.filteredOptions.length > 0) {
				focusedValue = focusedValue == null ? this.state.filteredOptions[0] : focusedValue;
			}
			// Add the current value to the filtered options in last resort
			var options = this.state.filteredOptions;
			if (this.props.allowCreate && this.state.inputValue.trim()) {
				var inputValue = this.state.inputValue;
				options = options.slice();
				options.unshift({
					value: inputValue,
					label: inputValue,
					create: true
				});
			}
	
			var ops = Object.keys(options).map(function (key) {
				var op = options[key];
				var isSelected = this.state.value === op.value;
				var isFocused = focusedValue === op.value;
	
				var optionClass = classes({
					'Select-option': true,
					'is-selected': isSelected,
					'is-focused': isFocused,
					'is-disabled': op.disabled
				});
	
				var ref = isFocused ? 'focused' : null;
	
				var mouseEnter = this.focusOption.bind(this, op);
				var mouseLeave = this.unfocusOption.bind(this, op);
				var mouseDown = this.selectValue.bind(this, op);
				var renderedLabel = renderLabel(op);
	
				return op.disabled ? React.createElement(
					'div',
					{ ref: ref, key: 'option-' + op.value, className: optionClass },
					renderedLabel
				) : React.createElement(
					'div',
					{ ref: ref, key: 'option-' + op.value, className: optionClass, onMouseEnter: mouseEnter, onMouseLeave: mouseLeave, onMouseDown: mouseDown, onClick: mouseDown },
					op.create ? this.props.addLabelText.replace('{label}', op.label) : renderedLabel
				);
			}, this);
	
			return ops.length ? ops : React.createElement(
				'div',
				{ className: 'Select-noresults' },
				this.props.asyncOptions && !this.state.inputValue ? this.props.searchPromptText : this.props.noResultsText
			);
		},
	
		handleOptionLabelClick: function handleOptionLabelClick(value, event) {
			if (this.props.onOptionLabelClick) {
				this.props.onOptionLabelClick(value, event);
			}
		},
	
		render: function render() {
			var selectClass = classes('Select', this.props.className, {
				'is-multi': this.props.multi,
				'is-searchable': this.props.searchable,
				'is-open': this.state.isOpen,
				'is-focused': this.state.isFocused,
				'is-loading': this.state.isLoading,
				'is-disabled': this.props.disabled,
				'has-value': this.state.value
			});
	
			var value = [];
	
			if (this.props.multi) {
				this.state.values.forEach(function (val) {
					value.push(React.createElement(Value, {
						key: val.value,
						option: val,
						renderer: this.props.valueRenderer,
						optionLabelClick: !!this.props.onOptionLabelClick,
						onOptionLabelClick: this.handleOptionLabelClick.bind(this, val),
						onRemove: this.removeValue.bind(this, val),
						disabled: this.props.disabled }));
				}, this);
			}
	
			if (!this.state.inputValue && (!this.props.multi || !value.length)) {
				value.push(React.createElement(
					'div',
					{ className: 'Select-placeholder', key: 'placeholder' },
					this.state.placeholder
				));
			}
	
			var loading = this.state.isLoading ? React.createElement('span', { className: 'Select-loading', 'aria-hidden': 'true' }) : null;
			var clear = this.props.clearable && this.state.value && !this.props.disabled ? React.createElement('span', { className: 'Select-clear', title: this.props.multi ? this.props.clearAllText : this.props.clearValueText, 'aria-label': this.props.multi ? this.props.clearAllText : this.props.clearValueText, onMouseDown: this.clearValue, onClick: this.clearValue, dangerouslySetInnerHTML: { __html: '&times;' } }) : null;
	
			var menu;
			var menuProps;
			if (this.state.isOpen) {
				menuProps = {
					ref: 'menu',
					className: 'Select-menu'
				};
				if (this.props.multi) {
					menuProps.onMouseDown = this.handleMouseDown;
				}
				menu = React.createElement(
					'div',
					{ ref: 'selectMenuContainer', className: 'Select-menu-outer' },
					React.createElement(
						'div',
						menuProps,
						this.buildMenu()
					)
				);
			}
	
			var input;
			var inputProps = {
				ref: 'input',
				className: 'Select-input',
				tabIndex: this.props.tabIndex || 0,
				onFocus: this.handleInputFocus,
				onBlur: this.handleInputBlur
			};
			for (var key in this.props.inputProps) {
				if (this.props.inputProps.hasOwnProperty(key)) {
					inputProps[key] = this.props.inputProps[key];
				}
			}
	
			if (!this.props.disabled) {
				if (this.props.searchable) {
					input = React.createElement(Input, _extends({ value: this.state.inputValue, onChange: this.handleInputChange, minWidth: '5' }, inputProps));
				} else {
					input = React.createElement(
						'div',
						inputProps,
						' '
					);
				}
			} else if (!this.props.multi || !this.state.values.length) {
				input = React.createElement(
					'div',
					{ className: 'Select-input' },
					' '
				);
			}
	
			return React.createElement(
				'div',
				{ ref: 'wrapper', className: selectClass },
				React.createElement('input', { type: 'hidden', ref: 'value', name: this.props.name, value: this.state.value, disabled: this.props.disabled }),
				React.createElement(
					'div',
					{ className: 'Select-control', ref: 'control', onKeyDown: this.handleKeyDown, onMouseDown: this.handleMouseDown, onTouchEnd: this.handleMouseDown },
					value,
					input,
					React.createElement('span', { className: 'Select-arrow-zone', onMouseDown: this.handleMouseDownOnArrow }),
					React.createElement('span', { className: 'Select-arrow', onMouseDown: this.handleMouseDownOnArrow }),
					loading,
					clear
				),
				menu
			);
		}
	
	});
	
	module.exports = Select;

/***/ }),
/* 378 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	var isUnitlessNumber = {
	  boxFlex: true,
	  boxFlexGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  strokeDashoffset: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function(prop) {
	  prefixes.forEach(function(prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundImage: true,
	    backgroundPosition: true,
	    backgroundRepeat: true,
	    backgroundColor: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    ( false ? invariant(
	      pluginIndex > -1,
	      'EventPluginRegistry: Cannot inject event plugins that do not exist in ' +
	      'the plugin ordering, `%s`.',
	      pluginName
	    ) : invariant(pluginIndex > -1));
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    ( false ? invariant(
	      PluginModule.extractEvents,
	      'EventPluginRegistry: Event plugins must implement an `extractEvents` ' +
	      'method, but `%s` does not.',
	      pluginName
	    ) : invariant(PluginModule.extractEvents));
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      ( false ? invariant(
	        publishEventForPlugin(
	          publishedEvents[eventName],
	          PluginModule,
	          eventName
	        ),
	        'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.',
	        eventName,
	        pluginName
	      ) : invariant(publishEventForPlugin(
	        publishedEvents[eventName],
	        PluginModule,
	        eventName
	      )));
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  ( false ? invariant(
	    !EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName),
	    'EventPluginHub: More than one plugin attempted to publish the same ' +
	    'event name, `%s`.',
	    eventName
	  ) : invariant(!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName)));
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(
	          phasedRegistrationName,
	          PluginModule,
	          eventName
	        );
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(
	      dispatchConfig.registrationName,
	      PluginModule,
	      eventName
	    );
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  ( false ? invariant(
	    !EventPluginRegistry.registrationNameModules[registrationName],
	    'EventPluginHub: More than one plugin attempted to publish the same ' +
	    'registration name, `%s`.',
	    registrationName
	  ) : invariant(!EventPluginRegistry.registrationNameModules[registrationName]));
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] =
	    PluginModule.eventTypes[eventName].dependencies;
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function(InjectedEventPluginOrder) {
	    ( false ? invariant(
	      !EventPluginOrder,
	      'EventPluginRegistry: Cannot inject event plugin ordering more than ' +
	      'once. You are likely trying to load more than one copy of React.'
	    ) : invariant(!EventPluginOrder));
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function(injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) ||
	          namesToPlugins[pluginName] !== PluginModule) {
	        ( false ? invariant(
	          !namesToPlugins[pluginName],
	          'EventPluginRegistry: Cannot inject two different event plugins ' +
	          'using the same name, `%s`.',
	          pluginName
	        ) : invariant(!namesToPlugins[pluginName]));
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function(event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[
	        dispatchConfig.registrationName
	      ] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[
	        dispatchConfig.phasedRegistrationNames[phase]
	      ];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function() {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(70);
	var ReactFragment = __webpack_require__(135);
	
	var traverseAllChildren = __webpack_require__(401);
	var warning = __webpack_require__(17);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var threeArgumentPooler = PooledClass.threeArgumentPooler;
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.forEachFunction = forEachFunction;
	  this.forEachContext = forEachContext;
	}
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(traverseContext, child, name, i) {
	  var forEachBookKeeping = traverseContext;
	  forEachBookKeeping.forEachFunction.call(
	    forEachBookKeeping.forEachContext, child, i);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc.
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	
	  var traverseContext =
	    ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, mapFunction, mapContext) {
	  this.mapResult = mapResult;
	  this.mapFunction = mapFunction;
	  this.mapContext = mapContext;
	}
	PooledClass.addPoolingTo(MapBookKeeping, threeArgumentPooler);
	
	function mapSingleChildIntoContext(traverseContext, child, name, i) {
	  var mapBookKeeping = traverseContext;
	  var mapResult = mapBookKeeping.mapResult;
	
	  var keyUnique = !mapResult.hasOwnProperty(name);
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      keyUnique,
	      'ReactChildren.map(...): Encountered two children with the same key, ' +
	      '`%s`. Child keys must be unique; when two children share a key, only ' +
	      'the first child will be used.',
	      name
	    ) : null);
	  }
	
	  if (keyUnique) {
	    var mappedChild =
	      mapBookKeeping.mapFunction.call(mapBookKeeping.mapContext, child, i);
	    mapResult[name] = mappedChild;
	  }
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * TODO: This may likely break any calls to `ReactChildren.map` that were
	 * previously relying on the fact that we guarded against null children.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} mapFunction.
	 * @param {*} mapContext Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	
	  var mapResult = {};
	  var traverseContext = MapBookKeeping.getPooled(mapResult, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	  return ReactFragment.create(mapResult);
	}
	
	function forEachSingleChildDummy(traverseContext, child, name, i) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  count: countChildren
	};
	
	module.exports = ReactChildren;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var ReactUpdateQueue = __webpack_require__(251);
	
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(17);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context) {
	  this.props = props;
	  this.context = context;
	}
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function(partialState, callback) {
	  ( false ? invariant(
	    typeof partialState === 'object' ||
	    typeof partialState === 'function' ||
	    partialState == null,
	    'setState(...): takes an object of state variables to update or a ' +
	    'function which returns an object of state variables.'
	  ) : invariant(typeof partialState === 'object' ||
	  typeof partialState === 'function' ||
	  partialState == null));
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      partialState != null,
	      'setState(...): You passed an undefined or null state object; ' +
	      'instead, use forceUpdate().'
	    ) : null);
	  }
	  ReactUpdateQueue.enqueueSetState(this, partialState);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function(callback) {
	  ReactUpdateQueue.enqueueForceUpdate(this);
	  if (callback) {
	    ReactUpdateQueue.enqueueCallback(this, callback);
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    getDOMNode: [
	      'getDOMNode',
	      'Use React.findDOMNode(component) instead.'
	    ],
	    isMounted: [
	      'isMounted',
	      'Instead, make sure to clean up subscriptions and pending requests in ' +
	      'componentWillUnmount to prevent memory leaks.'
	    ],
	    replaceProps: [
	      'replaceProps',
	      'Instead, call React.render again at the top level.'
	    ],
	    replaceState: [
	      'replaceState',
	      'Refactor your code to use setState instead (see ' +
	      'https://github.com/facebook/react/issues/3236).'
	    ],
	    setProps: [
	      'setProps',
	      'Instead, call React.render again at the top level.'
	    ]
	  };
	  var defineDeprecationWarning = function(methodName, info) {
	    try {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function() {
	          ("production" !== process.env.NODE_ENV ? warning(
	            false,
	            '%s(...) is deprecated in plain JavaScript React classes. %s',
	            info[0],
	            info[1]
	          ) : null);
	          return undefined;
	        }
	      });
	    } catch (x) {
	      // IE will fail on defineProperty (es5-shim/sham too)
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 * @typechecks static-only
	 */
	
	/*jslint evil: true */
	
	'use strict';
	
	var CSSPropertyOperations = __webpack_require__(239);
	var DOMChildrenOperations = __webpack_require__(848);
	var DOMPropertyOperations = __webpack_require__(131);
	var ReactMount = __webpack_require__(73);
	var ReactPerf = __webpack_require__(100);
	
	var invariant = __webpack_require__(6);
	var setInnerHTML = __webpack_require__(260);
	
	/**
	 * Errors for properties that should not be updated with `updatePropertyById()`.
	 *
	 * @type {object}
	 * @private
	 */
	var INVALID_PROPERTY_ERRORS = {
	  dangerouslySetInnerHTML:
	    '`dangerouslySetInnerHTML` must be set using `updateInnerHTMLByID()`.',
	  style: '`style` must be set using `updateStylesByID()`.'
	};
	
	/**
	 * Operations used to process updates to DOM nodes. This is made injectable via
	 * `ReactDOMComponent.BackendIDOperations`.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a DOM node with new property values. This should only be used to
	   * update DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A valid property name, see `DOMProperty`.
	   * @param {*} value New value of the property.
	   * @internal
	   */
	  updatePropertyByID: function(id, name, value) {
	    var node = ReactMount.getNode(id);
	    ( false ? invariant(
	      !INVALID_PROPERTY_ERRORS.hasOwnProperty(name),
	      'updatePropertyByID(...): %s',
	      INVALID_PROPERTY_ERRORS[name]
	    ) : invariant(!INVALID_PROPERTY_ERRORS.hasOwnProperty(name)));
	
	    // If we're updating to null or undefined, we should remove the property
	    // from the DOM node instead of inadvertantly setting to a string. This
	    // brings us in line with the same behavior we have on initial render.
	    if (value != null) {
	      DOMPropertyOperations.setValueForProperty(node, name, value);
	    } else {
	      DOMPropertyOperations.deleteValueForProperty(node, name);
	    }
	  },
	
	  /**
	   * Updates a DOM node to remove a property. This should only be used to remove
	   * DOM properties in `DOMProperty`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} name A property name to remove, see `DOMProperty`.
	   * @internal
	   */
	  deletePropertyByID: function(id, name, value) {
	    var node = ReactMount.getNode(id);
	    ( false ? invariant(
	      !INVALID_PROPERTY_ERRORS.hasOwnProperty(name),
	      'updatePropertyByID(...): %s',
	      INVALID_PROPERTY_ERRORS[name]
	    ) : invariant(!INVALID_PROPERTY_ERRORS.hasOwnProperty(name)));
	    DOMPropertyOperations.deleteValueForProperty(node, name, value);
	  },
	
	  /**
	   * Updates a DOM node with new style values. If a value is specified as '',
	   * the corresponding style property will be unset.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {object} styles Mapping from styles to values.
	   * @internal
	   */
	  updateStylesByID: function(id, styles) {
	    var node = ReactMount.getNode(id);
	    CSSPropertyOperations.setValueForStyles(node, styles);
	  },
	
	  /**
	   * Updates a DOM node's innerHTML.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} html An HTML string.
	   * @internal
	   */
	  updateInnerHTMLByID: function(id, html) {
	    var node = ReactMount.getNode(id);
	    setInnerHTML(node, html);
	  },
	
	  /**
	   * Updates a DOM node's text content set by `props.content`.
	   *
	   * @param {string} id ID of the node to update.
	   * @param {string} content Text content.
	   * @internal
	   */
	  updateTextContentByID: function(id, content) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.updateTextContent(node, content);
	  },
	
	  /**
	   * Replaces a DOM node that exists in the document with markup.
	   *
	   * @param {string} id ID of child to be replaced.
	   * @param {string} markup Dangerous markup to inject in place of child.
	   * @internal
	   * @see {Danger.dangerouslyReplaceNodeWithMarkup}
	   */
	  dangerouslyReplaceNodeWithMarkupByID: function(id, markup) {
	    var node = ReactMount.getNode(id);
	    DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup(node, markup);
	  },
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markup List of markup strings.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function(updates, markup) {
	    for (var i = 0; i < updates.length; i++) {
	      updates[i].parentNode = ReactMount.getNode(updates[i].parentID);
	    }
	    DOMChildrenOperations.processUpdates(updates, markup);
	  }
	};
	
	ReactPerf.measureMethods(ReactDOMIDOperations, 'ReactDOMIDOperations', {
	  updatePropertyByID: 'updatePropertyByID',
	  deletePropertyByID: 'deletePropertyByID',
	  updateStylesByID: 'updateStylesByID',
	  updateInnerHTMLByID: 'updateInnerHTMLByID',
	  updateTextContentByID: 'updateTextContentByID',
	  dangerouslyReplaceNodeWithMarkupByID: 'dangerouslyReplaceNodeWithMarkupByID',
	  dangerouslyProcessChildrenUpdates: 'dangerouslyProcessChildrenUpdates'
	});
	
	module.exports = ReactDOMIDOperations;


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var DOMPropertyOperations = __webpack_require__(131);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(244);
	var ReactDOMComponent = __webpack_require__(247);
	
	var assign = __webpack_require__(11);
	var escapeTextContentForBrowser = __webpack_require__(177);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings in elements so that they can undergo
	 * the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function(props) {
	  // This constructor and its argument is currently used by mocks.
	};
	
	assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * @param {ReactText} text
	   * @internal
	   */
	  construct: function(text) {
	    // TODO: This is really a ReactText (ReactNode), not a ReactElement
	    this._currentElement = text;
	    this._stringText = '' + text;
	
	    // Properties
	    this._rootNodeID = null;
	    this._mountIndex = 0;
	  },
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._rootNodeID = rootID;
	    var escapedText = escapeTextContentForBrowser(this._stringText);
	
	    if (transaction.renderToStaticMarkup) {
	      // Normally we'd wrap this in a `span` for the reasons stated above, but
	      // since this is a situation where React won't take over (static pages),
	      // we can simply return the text as it is.
	      return escapedText;
	    }
	
	    return (
	      '<span ' + DOMPropertyOperations.createMarkupForID(rootID) + '>' +
	        escapedText +
	      '</span>'
	    );
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function(nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        ReactDOMComponent.BackendIDOperations.updateTextContentByID(
	          this._rootNodeID,
	          nextStringText
	        );
	      }
	    }
	  },
	
	  unmountComponent: function() {
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(868);
	
	var containsNode = __webpack_require__(390);
	var focusNode = __webpack_require__(392);
	var getActiveElement = __webpack_require__(393);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function(elem) {
	    return elem && (
	      ((elem.nodeName === 'INPUT' && elem.type === 'text') ||
	      elem.nodeName === 'TEXTAREA' || elem.contentEditable === 'true')
	    );
	  },
	
	  getSelectionInformation: function() {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange:
	          ReactInputSelection.hasSelectionCapabilities(focusedElem) ?
	          ReactInputSelection.getSelection(focusedElem) :
	          null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function(priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem &&
	        isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(
	          priorFocusedElem,
	          priorSelectionRange
	        );
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function(input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName === 'INPUT') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || {start: 0, end: 0};
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function(input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (typeof end === 'undefined') {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName === 'INPUT') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(898);
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function(markup) {
	    var checksum = adler32(markup);
	    return markup.replace(
	      '>',
	      ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '">'
	    );
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function(markup, element) {
	    var existingChecksum = element.getAttribute(
	      ReactMarkupChecksum.CHECKSUM_ATTR_NAME
	    );
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(137);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	var ReactFragment = __webpack_require__(135);
	var ReactPropTypeLocationNames = __webpack_require__(173);
	
	var emptyFunction = __webpack_require__(63);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var elementTypeChecker = createElementTypeChecker();
	var nodeTypeChecker = createNodeChecker();
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: elementTypeChecker,
	  instanceOf: createInstanceTypeChecker,
	  node: nodeTypeChecker,
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location) {
	    componentName = componentName || ANONYMOUS;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error(
	          ("Required " + locationName + " `" + propName + "` was not specified in ") +
	          ("`" + componentName + "`.")
	        );
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type `" + preciseType + "` ") +
	        ("supplied to `" + componentName + "`, expected `" + expectedType + "`.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type ") +
	        ("`" + propType + "` supplied to `" + componentName + "`, expected an array.")
	      );
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected a ReactElement.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected instance of `" + expectedClassName + "`.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (propValue === expectedValues[i]) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error(
	      ("Invalid " + locationName + " `" + propName + "` of value `" + propValue + "` ") +
	      ("supplied to `" + componentName + "`, expected one of " + valuesString + ".")
	    );
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type ") +
	        ("`" + propType + "` supplied to `" + componentName + "`, expected an object.")
	      );
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  function validate(props, propName, componentName, location) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error(
	      ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	      ("`" + componentName + "`.")
	    );
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` supplied to ") +
	        ("`" + componentName + "`, expected a ReactNode.")
	      );
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error(
	        ("Invalid " + locationName + " `" + propName + "` of type `" + propType + "` ") +
	        ("supplied to `" + componentName + "`, expected `object`.")
	      );
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	      propValue = ReactFragment.extractIfFragment(propValue);
	      for (var k in propValue) {
	        if (!isNode(propValue[k])) {
	          return false;
	        }
	      }
	      return true;
	    default:
	      return false;
	  }
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	module.exports = ReactPropTypes;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPutListenerQueue
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(70);
	var ReactBrowserEventEmitter = __webpack_require__(115);
	
	var assign = __webpack_require__(11);
	
	function ReactPutListenerQueue() {
	  this.listenersToPut = [];
	}
	
	assign(ReactPutListenerQueue.prototype, {
	  enqueuePutListener: function(rootNodeID, propKey, propValue) {
	    this.listenersToPut.push({
	      rootNodeID: rootNodeID,
	      propKey: propKey,
	      propValue: propValue
	    });
	  },
	
	  putListeners: function() {
	    for (var i = 0; i < this.listenersToPut.length; i++) {
	      var listenerToPut = this.listenersToPut[i];
	      ReactBrowserEventEmitter.putListener(
	        listenerToPut.rootNodeID,
	        listenerToPut.propKey,
	        listenerToPut.propValue
	      );
	    }
	  },
	
	  reset: function() {
	    this.listenersToPut.length = 0;
	  },
	
	  destructor: function() {
	    this.reset();
	  }
	});
	
	PooledClass.addPoolingTo(ReactPutListenerQueue);
	
	module.exports = ReactPutListenerQueue;


/***/ }),
/* 389 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var ReactRootIndexInjection = {
	  /**
	   * @param {function} _createReactRootIndex
	   */
	  injectCreateReactRootIndex: function(_createReactRootIndex) {
	    ReactRootIndex.createReactRootIndex = _createReactRootIndex;
	  }
	};
	
	var ReactRootIndex = {
	  createReactRootIndex: null,
	  injection: ReactRootIndexInjection
	};
	
	module.exports = ReactRootIndex;


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule containsNode
	 * @typechecks
	 */
	
	var isTextNode = __webpack_require__(913);
	
	/*jslint bitwise:true */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 *
	 * @param {?DOMNode} outerNode Outer DOM node.
	 * @param {?DOMNode} innerNode Inner DOM node.
	 * @return {boolean} True if `outerNode` contains or is `innerNode`.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if (outerNode.contains) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactCurrentOwner = __webpack_require__(72);
	var ReactInstanceMap = __webpack_require__(117);
	var ReactMount = __webpack_require__(73);
	
	var invariant = __webpack_require__(6);
	var isNode = __webpack_require__(397);
	var warning = __webpack_require__(17);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        owner._warnedAboutRefsInRender,
	        '%s is accessing getDOMNode or findDOMNode inside its render(). ' +
	        'render() should be a pure function of props and state. It should ' +
	        'never access something that requires stale data from the previous ' +
	        'render, such as refs. Move this logic to componentDidMount and ' +
	        'componentDidUpdate instead.',
	        owner.getName() || 'A component'
	      ) : null);
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (isNode(componentOrElement)) {
	    return componentOrElement;
	  }
	  if (ReactInstanceMap.has(componentOrElement)) {
	    return ReactMount.getNodeFromInstance(componentOrElement);
	  }
	  ( false ? invariant(
	    componentOrElement.render == null ||
	    typeof componentOrElement.render !== 'function',
	    'Component (with keys: %s) contains `render` method ' +
	    'but is not mounted in the DOM',
	    Object.keys(componentOrElement)
	  ) : invariant(componentOrElement.render == null ||
	  typeof componentOrElement.render !== 'function'));
	  ( false ? invariant(
	    false,
	    'Element appears to be neither ReactComponent nor DOMNode (keys: %s)',
	    Object.keys(componentOrElement)
	  ) : invariant(false));
	}
	
	module.exports = findDOMNode;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule focusNode
	 */
	
	"use strict";
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch(e) {
	  }
	}
	
	module.exports = focusNode;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getActiveElement
	 * @typechecks
	 */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document body is not yet defined.
	 */
	function getActiveElement() /*?DOMElement*/ {
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;


/***/ }),
/* 394 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/* global Symbol */
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (
	    (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL])
	  );
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getMarkupWrap
	 */
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode =
	  ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	var shouldWrap = {
	  // Force wrapping for SVG elements because if they get created inside a <div>,
	  // they will be initialized in the wrong namespace (and will not display).
	  'circle': true,
	  'clipPath': true,
	  'defs': true,
	  'ellipse': true,
	  'g': true,
	  'line': true,
	  'linearGradient': true,
	  'path': true,
	  'polygon': true,
	  'polyline': true,
	  'radialGradient': true,
	  'rect': true,
	  'stop': true,
	  'text': true
	};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg>', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap,
	
	  'circle': svgWrap,
	  'clipPath': svgWrap,
	  'defs': svgWrap,
	  'ellipse': svgWrap,
	  'g': svgWrap,
	  'line': svgWrap,
	  'linearGradient': svgWrap,
	  'path': svgWrap,
	  'polygon': svgWrap,
	  'polyline': svgWrap,
	  'radialGradient': svgWrap,
	  'rect': svgWrap,
	  'stop': svgWrap,
	  'text': svgWrap
	};
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  ( false ? invariant(!!dummyNode, 'Markup wrapping node not initialized') : invariant(!!dummyNode));
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	
	module.exports = getMarkupWrap;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ?
	      'textContent' :
	      'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isNode
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (
	    ((typeof Node === 'function' ? object instanceof Node : typeof object === 'object' &&
	    typeof object.nodeType === 'number' &&
	    typeof object.nodeName === 'string'))
	  ));
	}
	
	module.exports = isNode;


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  return elem && (
	    (elem.nodeName === 'INPUT' && supportedInputTypes[elem.type] || elem.nodeName === 'TEXTAREA')
	  );
	}
	
	module.exports = isTextInputElement;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection. The current implementation of this
	 * function assumes that a single child gets passed without a wrapper, but the
	 * purpose of this helper function is to abstract away the particular structure
	 * of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactComponent} The first and only `ReactComponent` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  ( false ? invariant(
	    ReactElement.isValidElement(children),
	    'onlyChild must be passed a children with exactly one child.'
	  ) : invariant(ReactElement.isValidElement(children)));
	  return children;
	}
	
	module.exports = onlyChild;


/***/ }),
/* 400 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 */
	
	'use strict';
	
	/**
	 * Performs equality by iterating through keys on an object and returning
	 * false when any key has values which are not strictly equal between
	 * objA and objB. Returns true when the values of all keys are strictly equal.
	 *
	 * @return {boolean}
	 */
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	  var key;
	  // Test for A's keys different from B.
	  for (key in objA) {
	    if (objA.hasOwnProperty(key) &&
	        (!objB.hasOwnProperty(key) || objA[key] !== objB[key])) {
	      return false;
	    }
	  }
	  // Test for B's keys missing from A.
	  for (key in objB) {
	    if (objB.hasOwnProperty(key) && !objA.hasOwnProperty(key)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = shallowEqual;


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	var ReactFragment = __webpack_require__(135);
	var ReactInstanceHandles = __webpack_require__(116);
	
	var getIteratorFn = __webpack_require__(394);
	var invariant = __webpack_require__(6);
	var warning = __webpack_require__(17);
	
	var SEPARATOR = ReactInstanceHandles.SEPARATOR;
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var userProvidedKeyEscaperLookup = {
	  '=': '=0',
	  '.': '=1',
	  ':': '=2'
	};
	
	var userProvidedKeyEscapeRegex = /[=.:]/g;
	
	var didWarnAboutMaps = false;
	
	function userProvidedKeyEscaper(match) {
	  return userProvidedKeyEscaperLookup[match];
	}
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  if (component && component.key != null) {
	    // Explicit key
	    return wrapUserProvidedKey(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * Escape a component key so that it is safe to use in a reactid.
	 *
	 * @param {*} key Component key to be escaped.
	 * @return {string} An escaped string.
	 */
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(
	    userProvidedKeyEscapeRegex,
	    userProvidedKeyEscaper
	  );
	}
	
	/**
	 * Wrap a `key` value explicitly provided by the user to distinguish it from
	 * implicitly-generated keys generated by a component's index in its parent.
	 *
	 * @param {string} key Value of a user-provided `key` attribute
	 * @return {string}
	 */
	function wrapUserProvidedKey(key) {
	  return '$' + escapeUserProvidedKey(key);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!number} indexSoFar Number of children encountered until this point.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  indexSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null ||
	      type === 'string' ||
	      type === 'number' ||
	      ReactElement.isValidElement(children)) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar,
	      indexSoFar
	    );
	    return 1;
	  }
	
	  var child, nextName, nextIndex;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = (
	        (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	        getComponentKey(child, i)
	      );
	      nextIndex = indexSoFar + subtreeCount;
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        nextIndex,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = (
	            (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	            getComponentKey(child, ii++)
	          );
	          nextIndex = indexSoFar + subtreeCount;
	          subtreeCount += traverseAllChildrenImpl(
	            child,
	            nextName,
	            nextIndex,
	            callback,
	            traverseContext
	          );
	        }
	      } else {
	        if (false) {
	          ("production" !== process.env.NODE_ENV ? warning(
	            didWarnAboutMaps,
	            'Using Maps as children is not yet fully supported. It is an ' +
	            'experimental feature that might be removed. Convert it to a ' +
	            'sequence / iterable of keyed ReactElements instead.'
	          ) : null);
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = (
	              (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	              wrapUserProvidedKey(entry[0]) + SUBSEPARATOR +
	              getComponentKey(child, 0)
	            );
	            nextIndex = indexSoFar + subtreeCount;
	            subtreeCount += traverseAllChildrenImpl(
	              child,
	              nextName,
	              nextIndex,
	              callback,
	              traverseContext
	            );
	          }
	        }
	      }
	    } else if (type === 'object') {
	      ( false ? invariant(
	        children.nodeType !== 1,
	        'traverseAllChildren(...): Encountered an invalid child; DOM ' +
	        'elements are not valid children of React components.'
	      ) : invariant(children.nodeType !== 1));
	      var fragment = ReactFragment.extract(children);
	      for (var key in fragment) {
	        if (fragment.hasOwnProperty(key)) {
	          child = fragment[key];
	          nextName = (
	            (nameSoFar !== '' ? nameSoFar + SUBSEPARATOR : SEPARATOR) +
	            wrapUserProvidedKey(key) + SUBSEPARATOR +
	            getComponentKey(child, 0)
	          );
	          nextIndex = indexSoFar + subtreeCount;
	          subtreeCount += traverseAllChildrenImpl(
	            child,
	            nextName,
	            nextIndex,
	            callback,
	            traverseContext
	          );
	        }
	      }
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', 0, callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;


/***/ }),
/* 402 */
/***/ (function(module, exports) {

	/*!
	* screenfull
	* v3.3.3 - 2018-09-04
	* (c) Sindre Sorhus; MIT License
	*/
	(function () {
		'use strict';
	
		var document = typeof window !== 'undefined' && typeof window.document !== 'undefined' ? window.document : {};
		var isCommonjs = typeof module !== 'undefined' && module.exports;
		var keyboardAllowed = typeof Element !== 'undefined' && 'ALLOW_KEYBOARD_INPUT' in Element;
	
		var fn = (function () {
			var val;
	
			var fnMap = [
				[
					'requestFullscreen',
					'exitFullscreen',
					'fullscreenElement',
					'fullscreenEnabled',
					'fullscreenchange',
					'fullscreenerror'
				],
				// New WebKit
				[
					'webkitRequestFullscreen',
					'webkitExitFullscreen',
					'webkitFullscreenElement',
					'webkitFullscreenEnabled',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				// Old WebKit (Safari 5.1)
				[
					'webkitRequestFullScreen',
					'webkitCancelFullScreen',
					'webkitCurrentFullScreenElement',
					'webkitCancelFullScreen',
					'webkitfullscreenchange',
					'webkitfullscreenerror'
	
				],
				[
					'mozRequestFullScreen',
					'mozCancelFullScreen',
					'mozFullScreenElement',
					'mozFullScreenEnabled',
					'mozfullscreenchange',
					'mozfullscreenerror'
				],
				[
					'msRequestFullscreen',
					'msExitFullscreen',
					'msFullscreenElement',
					'msFullscreenEnabled',
					'MSFullscreenChange',
					'MSFullscreenError'
				]
			];
	
			var i = 0;
			var l = fnMap.length;
			var ret = {};
	
			for (; i < l; i++) {
				val = fnMap[i];
				if (val && val[1] in document) {
					for (i = 0; i < val.length; i++) {
						ret[fnMap[0][i]] = val[i];
					}
					return ret;
				}
			}
	
			return false;
		})();
	
		var eventNameMap = {
			change: fn.fullscreenchange,
			error: fn.fullscreenerror
		};
	
		var screenfull = {
			request: function (elem) {
				var request = fn.requestFullscreen;
	
				elem = elem || document.documentElement;
	
				// Work around Safari 5.1 bug: reports support for
				// keyboard in fullscreen even though it doesn't.
				// Browser sniffing, since the alternative with
				// setTimeout is even worse.
				if (/ Version\/5\.1(?:\.\d+)? Safari\//.test(navigator.userAgent)) {
					elem[request]();
				} else {
					elem[request](keyboardAllowed ? Element.ALLOW_KEYBOARD_INPUT : {});
				}
			},
			exit: function () {
				document[fn.exitFullscreen]();
			},
			toggle: function (elem) {
				if (this.isFullscreen) {
					this.exit();
				} else {
					this.request(elem);
				}
			},
			onchange: function (callback) {
				this.on('change', callback);
			},
			onerror: function (callback) {
				this.on('error', callback);
			},
			on: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.addEventListener(eventName, callback, false);
				}
			},
			off: function (event, callback) {
				var eventName = eventNameMap[event];
				if (eventName) {
					document.removeEventListener(eventName, callback, false);
				}
			},
			raw: fn
		};
	
		if (!fn) {
			if (isCommonjs) {
				module.exports = false;
			} else {
				window.screenfull = false;
			}
	
			return;
		}
	
		Object.defineProperties(screenfull, {
			isFullscreen: {
				get: function () {
					return Boolean(document[fn.fullscreenElement]);
				}
			},
			element: {
				enumerable: true,
				get: function () {
					return document[fn.fullscreenElement];
				}
			},
			enabled: {
				enumerable: true,
				get: function () {
					// Coerce to boolean in case of old WebKit
					return Boolean(document[fn.fullscreenEnabled]);
				}
			}
		});
	
		if (isCommonjs) {
			module.exports = screenfull;
		} else {
			window.screenfull = screenfull;
		}
	})();


/***/ }),
/* 403 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  optional: ' (optional)',
	  required: '',
	  add: 'Add',
	  remove: 'Remove',
	  up: 'Up',
	  down: 'Down'
	};
	module.exports = exports['default'];

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcombValidation = __webpack_require__(138);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	var _components = __webpack_require__(926);
	
	var components = _interopRequireWildcard(_components);
	
	_tcombValidation2['default'].form = components;
	_tcombValidation2['default'].form.File = _tcombValidation2['default'].irreducible('File', function (x) {
	  return x instanceof File;
	});
	
	module.exports = _tcombValidation2['default'];

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	var isBoolean = __webpack_require__(409);
	
	module.exports = irreducible('Boolean', isBoolean);


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	var isNil = __webpack_require__(82);
	
	module.exports = irreducible('Nil', isNil);


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	var isString = __webpack_require__(179);
	
	module.exports = irreducible('String', isString);


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var isFunction = __webpack_require__(38);
	var getTypeName = __webpack_require__(37);
	var isIdentity = __webpack_require__(102);
	var isObject = __webpack_require__(103);
	var create = __webpack_require__(80);
	var is = __webpack_require__(81);
	
	function getDefaultName(domain, codomain) {
	  return '{[key: ' + getTypeName(domain) + ']: ' + getTypeName(codomain) + '}';
	}
	
	function dict(domain, codomain, name) {
	
	  if (false) {
	    assert(isFunction(domain), function () { return 'Invalid argument domain ' + assert.stringify(domain) + ' supplied to dict(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isFunction(codomain), function () { return 'Invalid argument codomain ' + assert.stringify(codomain) + ' supplied to dict(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to dict(domain, codomain, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(domain, codomain);
	  var domainNameCache = getTypeName(domain);
	  var codomainNameCache = getTypeName(codomain);
	  var identity = isIdentity(domain) && isIdentity(codomain);
	
	  function Dict(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value; // just trust the input if elements must not be hydrated
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isObject(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    var idempotent = true; // will remain true if I can reutilise the input
	    var ret = {}; // make a temporary copy, will be discarded if idempotent remains true
	    for (var k in value) {
	      if (value.hasOwnProperty(k)) {
	        k = create(domain, k, (  false ? path.concat(domainNameCache) : null ));
	        var actual = value[k];
	        var instance = create(codomain, actual, (  false ? path.concat(k + ': ' + codomainNameCache) : null ));
	        idempotent = idempotent && ( actual === instance );
	        ret[k] = instance;
	      }
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  Dict.meta = {
	    kind: 'dict',
	    domain: domain,
	    codomain: codomain,
	    name: name,
	    identity: identity
	  };
	
	  Dict.displayName = displayName;
	
	  Dict.is = function (x) {
	    if (!isObject(x)) {
	      return false;
	    }
	    for (var k in x) {
	      if (x.hasOwnProperty(k)) {
	        if (!is(k, domain) || !is(x[k], codomain)) {
	          return false;
	        }
	      }
	    }
	    return true;
	  };
	
	  Dict.update = function (instance, patch) {
	    return Dict(assert.update(instance, patch));
	  };
	
	  return Dict;
	}
	
	dict.getDefaultName = getDefaultName;
	module.exports = dict;


/***/ }),
/* 409 */
/***/ (function(module, exports) {

	module.exports = function isBoolean(x) {
	  return x === true || x === false;
	};

/***/ }),
/* 410 */
/***/ (function(module, exports) {

	module.exports = function isNumber(x) {
	  return typeof x === 'number' && isFinite(x) && !isNaN(x);
	};

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(55);
	
	module.exports = function isStruct(x) {
	  return isType(x) && ( x.meta.kind === 'struct' );
	};

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var isFunction = __webpack_require__(38);
	var getTypeName = __webpack_require__(37);
	var isIdentity = __webpack_require__(102);
	var create = __webpack_require__(80);
	var is = __webpack_require__(81);
	var isArray = __webpack_require__(75);
	
	function getDefaultName(type) {
	  return 'Array<' + getTypeName(type) + '>';
	}
	
	function list(type, name) {
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + assert.stringify(type) + ' supplied to list(type, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to list(type, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(type);
	  var typeNameCache = getTypeName(type);
	  var identity = isIdentity(type); // the list is identity iif type is identity
	
	  function List(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value; // just trust the input if elements must not be hydrated
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isArray(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an array of ' + typeNameCache + ')'; });
	    }
	
	    var idempotent = true; // will remain true if I can reutilise the input
	    var ret = []; // make a temporary copy, will be discarded if idempotent remains true
	    for (var i = 0, len = value.length; i < len; i++ ) {
	      var actual = value[i];
	      var instance = create(type, actual, (  false ? path.concat(i + ': ' + typeNameCache) : null ));
	      idempotent = idempotent && ( actual === instance );
	      ret.push(instance);
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  List.meta = {
	    kind: 'list',
	    type: type,
	    name: name,
	    identity: identity
	  };
	
	  List.displayName = displayName;
	
	  List.is = function (x) {
	    return isArray(x) && x.every(function (e) {
	      return is(e, type);
	    });
	  };
	
	  List.update = function (instance, patch) {
	    return List(assert.update(instance, patch));
	  };
	
	  return List;
	}
	
	list.getDefaultName = getDefaultName;
	module.exports = list;


/***/ }),
/* 413 */
/***/ (function(module, exports) {

	module.exports = function stringify(x) {
	  try { // handle "Converting circular structure to JSON" error
	    return JSON.stringify(x, null, 2);
	  }
	  catch (e) {
	    return String(x);
	  }
	};

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var isFunction = __webpack_require__(38);
	var getTypeName = __webpack_require__(37);
	var isIdentity = __webpack_require__(102);
	var isArray = __webpack_require__(75);
	var create = __webpack_require__(80);
	var is = __webpack_require__(81);
	
	function getDefaultName(types) {
	  return '[' + types.map(getTypeName).join(', ') + ']';
	}
	
	function tuple(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction), function () { return 'Invalid argument types ' + assert.stringify(types) + ' supplied to tuple(types, [name]) combinator (expected an array of types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to tuple(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(types);
	  var identity = types.every(isIdentity);
	
	  function Tuple(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value;
	      }
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isArray(value) && value.length === types.length, function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an array of length ' + types.length + ')'; });
	    }
	
	    var idempotent = true;
	    var ret = [];
	    for (var i = 0, len = types.length; i < len; i++) {
	      var expected = types[i];
	      var actual = value[i];
	      var instance = create(expected, actual, (  false ? path.concat(i + ': ' + getTypeName(expected)) : null ));
	      idempotent = idempotent && ( actual === instance );
	      ret.push(instance);
	    }
	
	    if (idempotent) { // implements idempotency
	      ret = value;
	    }
	
	    if (false) {
	      Object.freeze(ret);
	    }
	
	    return ret;
	  }
	
	  Tuple.meta = {
	    kind: 'tuple',
	    types: types,
	    name: name,
	    identity: identity
	  };
	
	  Tuple.displayName = displayName;
	
	  Tuple.is = function (x) {
	    return isArray(x) &&
	      x.length === types.length &&
	      types.every(function (type, i) {
	        return is(x[i], type);
	      });
	  };
	
	  Tuple.update = function (instance, patch) {
	    return Tuple(assert.update(instance, patch));
	  };
	
	  return Tuple;
	}
	
	tuple.getDefaultName = getDefaultName;
	module.exports = tuple;

/***/ }),
/* 415 */
/***/ (function(module, exports) {

	"use strict";
	
	function transmitter() {
	  var subscriptions = [];
	  var nowDispatching = false;
	  var toUnsubscribe = {};
	
	  var unsubscribe = function unsubscribe(onChange) {
	    var id = subscriptions.indexOf(onChange);
	    if (id < 0) return;
	    if (nowDispatching) {
	      toUnsubscribe[id] = onChange;
	      return;
	    }
	    subscriptions.splice(id, 1);
	  };
	
	  var subscribe = function subscribe(onChange) {
	    var id = subscriptions.push(onChange);
	    var dispose = function dispose() {
	      return unsubscribe(onChange);
	    };
	    return { dispose: dispose };
	  };
	
	  var publish = function publish() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    nowDispatching = true;
	    try {
	      subscriptions.forEach(function (subscription, id) {
	        return toUnsubscribe[id] || subscription.apply(undefined, args);
	      });
	    } finally {
	      nowDispatching = false;
	      Object.keys(toUnsubscribe).forEach(function (id) {
	        return unsubscribe(toUnsubscribe[id]);
	      });
	      toUnsubscribe = {};
	    }
	  };
	
	  return {
	    publish: publish,
	    subscribe: subscribe,
	    $subscriptions: subscriptions
	  };
	}
	
	module.exports = transmitter;

/***/ }),
/* 416 */
/***/ (function(module, exports) {

	function clean (s) {
	  return s.replace(/\n\r?\s*/g, '')
	}
	
	
	module.exports = function tsml (sa) {
	  var s = ''
	    , i = 0
	
	  for (; i < arguments.length; i++)
	    s += clean(sa[i]) + (arguments[i + 1] || '')
	
	  return s
	}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

	'use strict';
	
	function getBreakpoints(breakpoints) {
	  var className = {};
	  for (var size in breakpoints) {
	    if (breakpoints.hasOwnProperty(size)) {
	      className['col-' + size + '-' + breakpoints[size]] = true;
	    }
	  }
	  return className;
	}
	
	module.exports = getBreakpoints;

/***/ }),
/* 418 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	
	  Example:
	
	  {
	    value: '1',
	    text: 'option 1'
	  }
	
	*/
	
	function getOption(opts) {
	  return {
	    tag: 'option',
	    attrs: {
	      disabled: opts.disabled,
	      value: opts.value
	    },
	    children: opts.text,
	    key: opts.value
	  };
	}
	
	module.exports = getOption;
	


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _button = __webpack_require__(140);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file mute-toggle.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * A button component for muting the audio.
	 *
	 * @extends Button
	 */
	var MuteToggle = function (_Button) {
	  _inherits(MuteToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MuteToggle(player, options) {
	    _classCallCheck(this, MuteToggle);
	
	    var _this = _possibleConstructorReturn(this, _Button.call(this, player, options));
	
	    _this.on(player, 'volumechange', _this.update);
	
	    // hide mute toggle if the current tech doesn't support volume control
	    if (player.tech_ && player.tech_.featuresVolumeControl === false) {
	      _this.addClass('vjs-hidden');
	    }
	
	    _this.on(player, 'loadstart', function () {
	      // We need to update the button to account for a default muted state.
	      this.update();
	
	      if (player.tech_.featuresVolumeControl === false) {
	        this.addClass('vjs-hidden');
	      } else {
	        this.removeClass('vjs-hidden');
	      }
	    });
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  MuteToggle.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-mute-control ' + _Button.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * This gets called when an `MuteToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  MuteToggle.prototype.handleClick = function handleClick(event) {
	    this.player_.muted(this.player_.muted() ? false : true);
	  };
	
	  /**
	   * Update the state of volume.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#loadstart} event if this function was called through an
	   *        event.
	   *
	   * @listens Player#loadstart
	   */
	
	
	  MuteToggle.prototype.update = function update(event) {
	    var vol = this.player_.volume();
	    var level = 3;
	
	    if (this.player_.muted()) {
	      level = 0;
	    } else if (vol < 0.33) {
	      level = 1;
	    } else if (vol < 0.67) {
	      level = 2;
	    }
	
	    // Don't rewrite the button text if the actual text doesn't change.
	    // This causes unnecessary and confusing information for screen reader users.
	    // This check is needed because this function gets called every time the volume level is changed.
	    var toMute = this.player_.muted() ? 'Unmute' : 'Mute';
	
	    if (this.controlText() !== toMute) {
	      this.controlText(toMute);
	    }
	
	    // TODO improve muted icon classes
	    for (var i = 0; i < 4; i++) {
	      Dom.removeElClass(this.el_, 'vjs-vol-' + i);
	    }
	    Dom.addElClass(this.el_, 'vjs-vol-' + level);
	  };
	
	  return MuteToggle;
	}(_button2['default']);
	
	/**
	 * The text that should display over the `MuteToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	MuteToggle.prototype.controlText_ = 'Mute';
	
	_component2['default'].registerComponent('MuteToggle', MuteToggle);
	exports['default'] = MuteToggle;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _menuButton = __webpack_require__(423);
	
	var _menuButton2 = _interopRequireDefault(_menuButton);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file track-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The base class for buttons that toggle specific  track types (e.g. subtitles).
	 *
	 * @extends MenuButton
	 */
	var TrackButton = function (_MenuButton) {
	  _inherits(TrackButton, _MenuButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TrackButton(player, options) {
	    _classCallCheck(this, TrackButton);
	
	    var tracks = options.tracks;
	
	    var _this = _possibleConstructorReturn(this, _MenuButton.call(this, player, options));
	
	    if (_this.items.length <= 1) {
	      _this.hide();
	    }
	
	    if (!tracks) {
	      return _possibleConstructorReturn(_this);
	    }
	
	    var updateHandler = Fn.bind(_this, _this.update);
	
	    tracks.addEventListener('removetrack', updateHandler);
	    tracks.addEventListener('addtrack', updateHandler);
	
	    _this.player_.on('dispose', function () {
	      tracks.removeEventListener('removetrack', updateHandler);
	      tracks.removeEventListener('addtrack', updateHandler);
	    });
	    return _this;
	  }
	
	  return TrackButton;
	}(_menuButton2['default']);
	
	_component2['default'].registerComponent('TrackButton', TrackButton);
	exports['default'] = TrackButton;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(427);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	__webpack_require__(1002);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file volume-bar.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	// Required children
	
	
	/**
	 * The bar that contains the volume level and can be clicked on to adjust the level
	 *
	 * @extends Slider
	 */
	var VolumeBar = function (_Slider) {
	  _inherits(VolumeBar, _Slider);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function VolumeBar(player, options) {
	    _classCallCheck(this, VolumeBar);
	
	    var _this = _possibleConstructorReturn(this, _Slider.call(this, player, options));
	
	    _this.on(player, 'volumechange', _this.updateARIAAttributes);
	    player.ready(Fn.bind(_this, _this.updateARIAAttributes));
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  VolumeBar.prototype.createEl = function createEl() {
	    return _Slider.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-bar vjs-slider-bar'
	    }, {
	      'aria-label': 'volume level'
	    });
	  };
	
	  /**
	   * Handle movement events on the {@link VolumeMenuButton}.
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run.
	   *
	   * @listens mousemove
	   */
	
	
	  VolumeBar.prototype.handleMouseMove = function handleMouseMove(event) {
	    this.checkMuted();
	    this.player_.volume(this.calculateDistance(event));
	  };
	
	  /**
	   * If the player is muted unmute it.
	   */
	
	
	  VolumeBar.prototype.checkMuted = function checkMuted() {
	    if (this.player_.muted()) {
	      this.player_.muted(false);
	    }
	  };
	
	  /**
	   * Get percent of volume level
	   *
	   * @return {number}
	   *         Volume level percent as a decimal number.
	   */
	
	
	  VolumeBar.prototype.getPercent = function getPercent() {
	    if (this.player_.muted()) {
	      return 0;
	    }
	    return this.player_.volume();
	  };
	
	  /**
	   * Increase volume level for keyboard users
	   */
	
	
	  VolumeBar.prototype.stepForward = function stepForward() {
	    this.checkMuted();
	    this.player_.volume(this.player_.volume() + 0.1);
	  };
	
	  /**
	   * Decrease volume level for keyboard users
	   */
	
	
	  VolumeBar.prototype.stepBack = function stepBack() {
	    this.checkMuted();
	    this.player_.volume(this.player_.volume() - 0.1);
	  };
	
	  /**
	   * Update ARIA accessibility attributes
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `volumechange` event that caused this function to run.
	   *
	   * @listens Player#volumechange
	   */
	
	
	  VolumeBar.prototype.updateARIAAttributes = function updateARIAAttributes(event) {
	    // Current value of volume bar as a percentage
	    var volume = (this.player_.volume() * 100).toFixed(2);
	
	    this.el_.setAttribute('aria-valuenow', volume);
	    this.el_.setAttribute('aria-valuetext', volume + '%');
	  };
	
	  return VolumeBar;
	}(_slider2['default']);
	
	/**
	 * Default options for the `VolumeBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumeBar.prototype.options_ = {
	  children: ['volumeLevel'],
	  barName: 'volumeLevel'
	};
	
	/**
	 * Call the update event for this Slider when this event happens on the player.
	 *
	 * @type {string}
	 */
	VolumeBar.prototype.playerEvent = 'volumechange';
	
	_component2['default'].registerComponent('VolumeBar', VolumeBar);
	exports['default'] = VolumeBar;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _obj = __webpack_require__(31);
	
	/**
	 * A Custom `MediaError` class which mimics the standard HTML5 `MediaError` class.
	 *
	 * @param {number|string|Object|MediaError} value
	 *        This can be of multiple types:
	 *        - number: should be a standard error code
	 *        - string: an error message (the code will be 0)
	 *        - Object: arbitrary properties
	 *        - `MediaError` (native): used to populate a video.js `MediaError` object
	 *        - `MediaError` (video.js): will return itself if it's already a
	 *          video.js `MediaError` object.
	 *
	 * @see [MediaError Spec]{@link https://dev.w3.org/html5/spec-author-view/video.html#mediaerror}
	 * @see [Encrypted MediaError Spec]{@link https://www.w3.org/TR/2013/WD-encrypted-media-20130510/#error-codes}
	 *
	 * @class MediaError
	 */
	function MediaError(value) {
	
	  // Allow redundant calls to this constructor to avoid having `instanceof`
	  // checks peppered around the code.
	  if (value instanceof MediaError) {
	    return value;
	  }
	
	  if (typeof value === 'number') {
	    this.code = value;
	  } else if (typeof value === 'string') {
	    // default code is zero, so this is a custom error
	    this.message = value;
	  } else if ((0, _obj.isObject)(value)) {
	
	    // We assign the `code` property manually because native `MediaError` objects
	    // do not expose it as an own/enumerable property of the object.
	    if (typeof value.code === 'number') {
	      this.code = value.code;
	    }
	
	    (0, _obj.assign)(this, value);
	  }
	
	  if (!this.message) {
	    this.message = MediaError.defaultMessages[this.code] || '';
	  }
	}
	
	/**
	 * The error code that refers two one of the defined `MediaError` types
	 *
	 * @type {Number}
	 */
	/**
	 * @file media-error.js
	 */
	MediaError.prototype.code = 0;
	
	/**
	 * An optional message that to show with the error. Message is not part of the HTML5
	 * video spec but allows for more informative custom errors.
	 *
	 * @type {String}
	 */
	MediaError.prototype.message = '';
	
	/**
	 * An optional status code that can be set by plugins to allow even more detail about
	 * the error. For example a plugin might provide a specific HTTP status code and an
	 * error message for that code. Then when the plugin gets that error this class will
	 * know how to display an error message for it. This allows a custom message to show
	 * up on the `Player` error overlay.
	 *
	 * @type {Array}
	 */
	MediaError.prototype.status = null;
	
	/**
	 * Errors indexed by the W3C standard. The order **CANNOT CHANGE**! See the
	 * specification listed under {@link MediaError} for more information.
	 *
	 * @enum {array}
	 * @readonly
	 * @property {string} 0 - MEDIA_ERR_CUSTOM
	 * @property {string} 1 - MEDIA_ERR_CUSTOM
	 * @property {string} 2 - MEDIA_ERR_ABORTED
	 * @property {string} 3 - MEDIA_ERR_NETWORK
	 * @property {string} 4 - MEDIA_ERR_SRC_NOT_SUPPORTED
	 * @property {string} 5 - MEDIA_ERR_ENCRYPTED
	 */
	MediaError.errorTypes = ['MEDIA_ERR_CUSTOM', 'MEDIA_ERR_ABORTED', 'MEDIA_ERR_NETWORK', 'MEDIA_ERR_DECODE', 'MEDIA_ERR_SRC_NOT_SUPPORTED', 'MEDIA_ERR_ENCRYPTED'];
	
	/**
	 * The default `MediaError` messages based on the {@link MediaError.errorTypes}.
	 *
	 * @type {Array}
	 * @constant
	 */
	MediaError.defaultMessages = {
	  1: 'You aborted the media playback',
	  2: 'A network error caused the media download to fail part-way.',
	  3: 'The media playback was aborted due to a corruption problem or because the media used features your browser did not support.',
	  4: 'The media could not be loaded, either because the server or network failed or because the format is not supported.',
	  5: 'The media is encrypted and we do not have the keys to decrypt it.'
	};
	
	// Add types as properties on MediaError
	// e.g. MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED = 4;
	for (var errNum = 0; errNum < MediaError.errorTypes.length; errNum++) {
	  MediaError[MediaError.errorTypes[errNum]] = errNum;
	  // values should be accessible on both the class and instance
	  MediaError.prototype[MediaError.errorTypes[errNum]] = errNum;
	}
	
	// jsdocs for instance/static members added above
	// instance methods use `#` and static methods use `.`
	/**
	 * W3C error code for any custom error.
	 *
	 * @member MediaError#MEDIA_ERR_CUSTOM
	 * @constant {number}
	 * @default 0
	 */
	/**
	 * W3C error code for any custom error.
	 *
	 * @member MediaError.MEDIA_ERR_CUSTOM
	 * @constant {number}
	 * @default 0
	 */
	
	/**
	 * W3C error code for media error aborted.
	 *
	 * @member MediaError#MEDIA_ERR_ABORTED
	 * @constant {number}
	 * @default 1
	 */
	/**
	 * W3C error code for media error aborted.
	 *
	 * @member MediaError.MEDIA_ERR_ABORTED
	 * @constant {number}
	 * @default 1
	 */
	
	/**
	 * W3C error code for any network error.
	 *
	 * @member MediaError#MEDIA_ERR_NETWORK
	 * @constant {number}
	 * @default 2
	 */
	/**
	 * W3C error code for any network error.
	 *
	 * @member MediaError.MEDIA_ERR_NETWORK
	 * @constant {number}
	 * @default 2
	 */
	
	/**
	 * W3C error code for any decoding error.
	 *
	 * @member MediaError#MEDIA_ERR_DECODE
	 * @constant {number}
	 * @default 3
	 */
	/**
	 * W3C error code for any decoding error.
	 *
	 * @member MediaError.MEDIA_ERR_DECODE
	 * @constant {number}
	 * @default 3
	 */
	
	/**
	 * W3C error code for any time that a source is not supported.
	 *
	 * @member MediaError#MEDIA_ERR_SRC_NOT_SUPPORTED
	 * @constant {number}
	 * @default 4
	 */
	/**
	 * W3C error code for any time that a source is not supported.
	 *
	 * @member MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED
	 * @constant {number}
	 * @default 4
	 */
	
	/**
	 * W3C error code for any time that a source is encrypted.
	 *
	 * @member MediaError#MEDIA_ERR_ENCRYPTED
	 * @constant {number}
	 * @default 5
	 */
	/**
	 * W3C error code for any time that a source is encrypted.
	 *
	 * @member MediaError.MEDIA_ERR_ENCRYPTED
	 * @constant {number}
	 * @default 5
	 */
	
	exports['default'] = MediaError;


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _clickableComponent = __webpack_require__(141);
	
	var _clickableComponent2 = _interopRequireDefault(_clickableComponent);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _menu = __webpack_require__(424);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _toTitleCase = __webpack_require__(120);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file menu-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * A `MenuButton` class for any popup {@link Menu}.
	 *
	 * @extends ClickableComponent
	 */
	var MenuButton = function (_ClickableComponent) {
	  _inherits(MenuButton, _ClickableComponent);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function MenuButton(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, MenuButton);
	
	    var _this = _possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));
	
	    _this.update();
	
	    _this.enabled_ = true;
	
	    _this.el_.setAttribute('aria-haspopup', 'true');
	    _this.el_.setAttribute('role', 'menuitem');
	    _this.on('keydown', _this.handleSubmenuKeyPress);
	    return _this;
	  }
	
	  /**
	   * Update the menu based on the current state of its items.
	   */
	
	
	  MenuButton.prototype.update = function update() {
	    var menu = this.createMenu();
	
	    if (this.menu) {
	      this.removeChild(this.menu);
	    }
	
	    this.menu = menu;
	    this.addChild(menu);
	
	    /**
	     * Track the state of the menu button
	     *
	     * @type {Boolean}
	     * @private
	     */
	    this.buttonPressed_ = false;
	    this.el_.setAttribute('aria-expanded', 'false');
	
	    if (this.items && this.items.length <= this.hideThreshold_) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  /**
	   * Create the menu and add all items to it.
	   *
	   * @return {Menu}
	   *         The constructed menu
	   */
	
	
	  MenuButton.prototype.createMenu = function createMenu() {
	    var menu = new _menu2['default'](this.player_);
	
	    /**
	     * Hide the menu if the number of items is less than or equal to this threshold. This defaults
	     * to 0 and whenever we add items which can be hidden to the menu we'll increment it. We list
	     * it here because every time we run `createMenu` we need to reset the value.
	     *
	     * @protected
	     * @type {Number}
	     */
	    this.hideThreshold_ = 0;
	
	    // Add a title list item to the top
	    if (this.options_.title) {
	      var title = Dom.createEl('li', {
	        className: 'vjs-menu-title',
	        innerHTML: (0, _toTitleCase2['default'])(this.options_.title),
	        tabIndex: -1
	      });
	
	      this.hideThreshold_ += 1;
	
	      menu.children_.unshift(title);
	      Dom.insertElFirst(title, menu.contentEl());
	    }
	
	    this.items = this.createItems();
	
	    if (this.items) {
	      // Add menu items to the menu
	      for (var i = 0; i < this.items.length; i++) {
	        menu.addItem(this.items[i]);
	      }
	    }
	
	    return menu;
	  };
	
	  /**
	   * Create the list of menu items. Specific to each subclass.
	   *
	   * @abstract
	   */
	
	
	  MenuButton.prototype.createItems = function createItems() {};
	
	  /**
	   * Create the `MenuButtons`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  MenuButton.prototype.createEl = function createEl() {
	    return _ClickableComponent.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass()
	    });
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  MenuButton.prototype.buildCSSClass = function buildCSSClass() {
	    var menuButtonClass = 'vjs-menu-button';
	
	    // If the inline option is passed, we want to use different styles altogether.
	    if (this.options_.inline === true) {
	      menuButtonClass += '-inline';
	    } else {
	      menuButtonClass += '-popup';
	    }
	
	    return 'vjs-menu-button ' + menuButtonClass + ' ' + _ClickableComponent.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Handle a click on a `MenuButton`.
	   * See {@link ClickableComponent#handleClick} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  MenuButton.prototype.handleClick = function handleClick(event) {
	    // When you click the button it adds focus, which will show the menu.
	    // So we'll remove focus when the mouse leaves the button. Focus is needed
	    // for tab navigation.
	
	    this.one(this.menu.contentEl(), 'mouseleave', Fn.bind(this, function (e) {
	      this.unpressButton();
	      this.el_.blur();
	    }));
	    if (this.buttonPressed_) {
	      this.unpressButton();
	    } else {
	      this.pressButton();
	    }
	  };
	
	  /**
	   * Handle tab, escape, down arrow, and up arrow keys for `MenuButton`. See
	   * {@link ClickableComponent#handleKeyPress} for instances where this is called.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown` event that caused this function to be called.
	   *
	   * @listens keydown
	   */
	
	
	  MenuButton.prototype.handleKeyPress = function handleKeyPress(event) {
	
	    // Escape (27) key or Tab (9) key unpress the 'button'
	    if (event.which === 27 || event.which === 9) {
	      if (this.buttonPressed_) {
	        this.unpressButton();
	      }
	      // Don't preventDefault for Tab key - we still want to lose focus
	      if (event.which !== 9) {
	        event.preventDefault();
	      }
	      // Up (38) key or Down (40) key press the 'button'
	    } else if (event.which === 38 || event.which === 40) {
	      if (!this.buttonPressed_) {
	        this.pressButton();
	        event.preventDefault();
	      }
	    } else {
	      _ClickableComponent.prototype.handleKeyPress.call(this, event);
	    }
	  };
	
	  /**
	   * Handle a `keydown` event on a sub-menu. The listener for this is added in
	   * the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        Key press event
	   *
	   * @listens keydown
	   */
	
	
	  MenuButton.prototype.handleSubmenuKeyPress = function handleSubmenuKeyPress(event) {
	
	    // Escape (27) key or Tab (9) key unpress the 'button'
	    if (event.which === 27 || event.which === 9) {
	      if (this.buttonPressed_) {
	        this.unpressButton();
	      }
	      // Don't preventDefault for Tab key - we still want to lose focus
	      if (event.which !== 9) {
	        event.preventDefault();
	      }
	    }
	  };
	
	  /**
	   * Put the current `MenuButton` into a pressed state.
	   */
	
	
	  MenuButton.prototype.pressButton = function pressButton() {
	    if (this.enabled_) {
	      this.buttonPressed_ = true;
	      this.menu.lockShowing();
	      this.el_.setAttribute('aria-expanded', 'true');
	      // set the focus into the submenu
	      this.menu.focus();
	    }
	  };
	
	  /**
	   * Take the current `MenuButton` out of a pressed state.
	   */
	
	
	  MenuButton.prototype.unpressButton = function unpressButton() {
	    if (this.enabled_) {
	      this.buttonPressed_ = false;
	      this.menu.unlockShowing();
	      this.el_.setAttribute('aria-expanded', 'false');
	      // Set focus back to this menu button
	      this.el_.focus();
	    }
	  };
	
	  /**
	   * Disable the `MenuButton`. Don't allow it to be clicked.
	   *
	   * @return {MenuButton}
	   *         Returns itself; method can be chained.
	   */
	
	
	  MenuButton.prototype.disable = function disable() {
	    // Unpress, but don't force focus on this button
	    this.buttonPressed_ = false;
	    this.menu.unlockShowing();
	    this.el_.setAttribute('aria-expanded', 'false');
	
	    this.enabled_ = false;
	
	    return _ClickableComponent.prototype.disable.call(this);
	  };
	
	  /**
	   * Enable the `MenuButton`. Allow it to be clicked.
	   *
	   * @return {MenuButton}
	   *         Returns itself; method can be chained.
	   */
	
	
	  MenuButton.prototype.enable = function enable() {
	    this.enabled_ = true;
	
	    return _ClickableComponent.prototype.enable.call(this);
	  };
	
	  return MenuButton;
	}(_clickableComponent2['default']);
	
	_component2['default'].registerComponent('MenuButton', MenuButton);
	exports['default'] = MenuButton;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _events = __webpack_require__(83);
	
	var Events = _interopRequireWildcard(_events);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file menu.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The Menu component is used to build popup menus, including subtitle and
	 * captions selection menus.
	 *
	 * @extends Component
	 */
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        the player that this component should attach to
	   *
	   * @param {Object} [options]
	   *        Object of option names and values
	   *
	   */
	  function Menu(player, options) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.focusedChild_ = -1;
	
	    _this.on('keydown', _this.handleKeyPress);
	    return _this;
	  }
	
	  /**
	   * Add a {@link MenuItem} to the menu.
	   *
	   * @param {Object|string} component
	   *        The name or instance of the `MenuItem` to add.
	   *
	   */
	
	
	  Menu.prototype.addItem = function addItem(component) {
	    this.addChild(component);
	    component.on('click', Fn.bind(this, function (event) {
	      this.unlockShowing();
	      // TODO: Need to set keyboard focus back to the menuButton
	    }));
	  };
	
	  /**
	   * Create the `Menu`s DOM element.
	   *
	   * @return {Element}
	   *         the element that was created
	   */
	
	
	  Menu.prototype.createEl = function createEl() {
	    var contentElType = this.options_.contentElType || 'ul';
	
	    this.contentEl_ = Dom.createEl(contentElType, {
	      className: 'vjs-menu-content'
	    });
	
	    this.contentEl_.setAttribute('role', 'menu');
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      append: this.contentEl_,
	      className: 'vjs-menu'
	    });
	
	    el.setAttribute('role', 'presentation');
	    el.appendChild(this.contentEl_);
	
	    // Prevent clicks from bubbling up. Needed for Menu Buttons,
	    // where a click on the parent is significant
	    Events.on(el, 'click', function (event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    });
	
	    return el;
	  };
	
	  /**
	   * Handle a `keydown` event on this menu. This listener is added in the constructor.
	   *
	   * @param {EventTarget~Event} event
	   *        A `keydown` event that happened on the menu.
	   *
	   * @listens keydown
	   */
	
	
	  Menu.prototype.handleKeyPress = function handleKeyPress(event) {
	    // Left and Down Arrows
	    if (event.which === 37 || event.which === 40) {
	      event.preventDefault();
	      this.stepForward();
	
	      // Up and Right Arrows
	    } else if (event.which === 38 || event.which === 39) {
	      event.preventDefault();
	      this.stepBack();
	    }
	  };
	
	  /**
	   * Move to next (lower) menu item for keyboard users.
	   */
	
	
	  Menu.prototype.stepForward = function stepForward() {
	    var stepChild = 0;
	
	    if (this.focusedChild_ !== undefined) {
	      stepChild = this.focusedChild_ + 1;
	    }
	    this.focus(stepChild);
	  };
	
	  /**
	   * Move to previous (higher) menu item for keyboard users.
	   */
	
	
	  Menu.prototype.stepBack = function stepBack() {
	    var stepChild = 0;
	
	    if (this.focusedChild_ !== undefined) {
	      stepChild = this.focusedChild_ - 1;
	    }
	    this.focus(stepChild);
	  };
	
	  /**
	   * Set focus on a {@link MenuItem} in the `Menu`.
	   *
	   * @param {Object|string} [item=0]
	   *        Index of child item set focus on.
	   */
	
	
	  Menu.prototype.focus = function focus() {
	    var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	    var children = this.children().slice();
	    var haveTitle = children.length && children[0].className && /vjs-menu-title/.test(children[0].className);
	
	    if (haveTitle) {
	      children.shift();
	    }
	
	    if (children.length > 0) {
	      if (item < 0) {
	        item = 0;
	      } else if (item >= children.length) {
	        item = children.length - 1;
	      }
	
	      this.focusedChild_ = item;
	
	      children[item].el_.focus();
	    }
	  };
	
	  return Menu;
	}(_component2['default']);
	
	_component2['default'].registerComponent('Menu', Menu);
	exports['default'] = Menu;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file modal-dialog.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var MODAL_CLASS_NAME = 'vjs-modal-dialog';
	var ESC = 27;
	
	/**
	 * The `ModalDialog` displays over the video and its controls, which blocks
	 * interaction with the player until it is closed.
	 *
	 * Modal dialogs include a "Close" button and will close when that button
	 * is activated - or when ESC is pressed anywhere.
	 *
	 * @extends Component
	 */
	
	var ModalDialog = function (_Component) {
	  _inherits(ModalDialog, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Mixed} [options.content=undefined]
	   *        Provide customized content for this modal.
	   *
	   * @param {string} [options.description]
	   *        A text description for the modal, primarily for accessibility.
	   *
	   * @param {boolean} [options.fillAlways=false]
	   *        Normally, modals are automatically filled only the first time
	   *        they open. This tells the modal to refresh its content
	   *        every time it opens.
	   *
	   * @param {string} [options.label]
	   *        A text label for the modal, primarily for accessibility.
	   *
	   * @param {boolean} [options.temporary=true]
	   *        If `true`, the modal can only be opened once; it will be
	   *        disposed as soon as it's closed.
	   *
	   * @param {boolean} [options.uncloseable=false]
	   *        If `true`, the user will not be able to close the modal
	   *        through the UI in the normal ways. Programmatic closing is
	   *        still possible.
	   */
	  function ModalDialog(player, options) {
	    _classCallCheck(this, ModalDialog);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.opened_ = _this.hasBeenOpened_ = _this.hasBeenFilled_ = false;
	
	    _this.closeable(!_this.options_.uncloseable);
	    _this.content(_this.options_.content);
	
	    // Make sure the contentEl is defined AFTER any children are initialized
	    // because we only want the contents of the modal in the contentEl
	    // (not the UI elements like the close button).
	    _this.contentEl_ = Dom.createEl('div', {
	      className: MODAL_CLASS_NAME + '-content'
	    }, {
	      role: 'document'
	    });
	
	    _this.descEl_ = Dom.createEl('p', {
	      className: MODAL_CLASS_NAME + '-description vjs-offscreen',
	      id: _this.el().getAttribute('aria-describedby')
	    });
	
	    Dom.textContent(_this.descEl_, _this.description());
	    _this.el_.appendChild(_this.descEl_);
	    _this.el_.appendChild(_this.contentEl_);
	    return _this;
	  }
	
	  /**
	   * Create the `ModalDialog`'s DOM element
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   */
	
	
	  ModalDialog.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass(),
	      tabIndex: -1
	    }, {
	      'aria-describedby': this.id() + '_description',
	      'aria-hidden': 'true',
	      'aria-label': this.label(),
	      'role': 'dialog'
	    });
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  ModalDialog.prototype.buildCSSClass = function buildCSSClass() {
	    return MODAL_CLASS_NAME + ' vjs-hidden ' + _Component.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Handles `keydown` events on the document, looking for ESC, which closes
	   * the modal.
	   *
	   * @param {EventTarget~Event} e
	   *        The keypress that triggered this event.
	   *
	   * @listens keydown
	   */
	
	
	  ModalDialog.prototype.handleKeyPress = function handleKeyPress(e) {
	    if (e.which === ESC && this.closeable()) {
	      this.close();
	    }
	  };
	
	  /**
	   * Returns the label string for this modal. Primarily used for accessibility.
	   *
	   * @return {string}
	   *         the localized or raw label of this modal.
	   */
	
	
	  ModalDialog.prototype.label = function label() {
	    return this.options_.label || this.localize('Modal Window');
	  };
	
	  /**
	   * Returns the description string for this modal. Primarily used for
	   * accessibility.
	   *
	   * @return {string}
	   *         The localized or raw description of this modal.
	   */
	
	
	  ModalDialog.prototype.description = function description() {
	    var desc = this.options_.description || this.localize('This is a modal window.');
	
	    // Append a universal closeability message if the modal is closeable.
	    if (this.closeable()) {
	      desc += ' ' + this.localize('This modal can be closed by pressing the Escape key or activating the close button.');
	    }
	
	    return desc;
	  };
	
	  /**
	   * Opens the modal.
	   *
	   * @fires ModalDialog#beforemodalopen
	   * @fires ModalDialog#modalopen
	   *
	   * @return {ModalDialog}
	   *         Returns itself; method can be chained.
	   */
	
	
	  ModalDialog.prototype.open = function open() {
	    if (!this.opened_) {
	      var player = this.player();
	
	      /**
	       * Fired just before a `ModalDialog` is opened.
	       *
	       * @event ModalDialog#beforemodalopen
	       * @type {EventTarget~Event}
	       */
	      this.trigger('beforemodalopen');
	      this.opened_ = true;
	
	      // Fill content if the modal has never opened before and
	      // never been filled.
	      if (this.options_.fillAlways || !this.hasBeenOpened_ && !this.hasBeenFilled_) {
	        this.fill();
	      }
	
	      // If the player was playing, pause it and take note of its previously
	      // playing state.
	      this.wasPlaying_ = !player.paused();
	
	      if (this.options_.pauseOnOpen && this.wasPlaying_) {
	        player.pause();
	      }
	
	      if (this.closeable()) {
	        this.on(this.el_.ownerDocument, 'keydown', Fn.bind(this, this.handleKeyPress));
	      }
	
	      player.controls(false);
	      this.show();
	      this.el().setAttribute('aria-hidden', 'false');
	
	      /**
	       * Fired just after a `ModalDialog` is opened.
	       *
	       * @event ModalDialog#modalopen
	       * @type {EventTarget~Event}
	       */
	      this.trigger('modalopen');
	      this.hasBeenOpened_ = true;
	    }
	    return this;
	  };
	
	  /**
	   * If the `ModalDialog` is currently open or closed.
	   *
	   * @param  {boolean} [value]
	   *         If given, it will open (`true`) or close (`false`) the modal.
	   *
	   * @return {boolean}
	   *         the current open state of the modaldialog
	   */
	
	
	  ModalDialog.prototype.opened = function opened(value) {
	    if (typeof value === 'boolean') {
	      this[value ? 'open' : 'close']();
	    }
	    return this.opened_;
	  };
	
	  /**
	   * Closes the modal, does nothing if the `ModalDialog` is
	   * not open.
	   *
	   * @fires ModalDialog#beforemodalclose
	   * @fires ModalDialog#modalclose
	   *
	   * @return {ModalDialog}
	   *         Returns itself; method can be chained.
	   */
	
	
	  ModalDialog.prototype.close = function close() {
	    if (this.opened_) {
	      var player = this.player();
	
	      /**
	       * Fired just before a `ModalDialog` is closed.
	       *
	       * @event ModalDialog#beforemodalclose
	       * @type {EventTarget~Event}
	       */
	      this.trigger('beforemodalclose');
	      this.opened_ = false;
	
	      if (this.wasPlaying_ && this.options_.pauseOnOpen) {
	        player.play();
	      }
	
	      if (this.closeable()) {
	        this.off(this.el_.ownerDocument, 'keydown', Fn.bind(this, this.handleKeyPress));
	      }
	
	      player.controls(true);
	      this.hide();
	      this.el().setAttribute('aria-hidden', 'true');
	
	      /**
	       * Fired just after a `ModalDialog` is closed.
	       *
	       * @event ModalDialog#modalclose
	       * @type {EventTarget~Event}
	       */
	      this.trigger('modalclose');
	
	      if (this.options_.temporary) {
	        this.dispose();
	      }
	    }
	    return this;
	  };
	
	  /**
	   * Check to see if the `ModalDialog` is closeable via the UI.
	   *
	   * @param  {boolean} [value]
	   *         If given as a boolean, it will set the `closeable` option.
	   *
	   * @return {boolean}
	   *         Returns the final value of the closable option.
	   */
	
	
	  ModalDialog.prototype.closeable = function closeable(value) {
	    if (typeof value === 'boolean') {
	      var closeable = this.closeable_ = !!value;
	      var close = this.getChild('closeButton');
	
	      // If this is being made closeable and has no close button, add one.
	      if (closeable && !close) {
	
	        // The close button should be a child of the modal - not its
	        // content element, so temporarily change the content element.
	        var temp = this.contentEl_;
	
	        this.contentEl_ = this.el_;
	        close = this.addChild('closeButton', { controlText: 'Close Modal Dialog' });
	        this.contentEl_ = temp;
	        this.on(close, 'close', this.close);
	      }
	
	      // If this is being made uncloseable and has a close button, remove it.
	      if (!closeable && close) {
	        this.off(close, 'close', this.close);
	        this.removeChild(close);
	        close.dispose();
	      }
	    }
	    return this.closeable_;
	  };
	
	  /**
	   * Fill the modal's content element with the modal's "content" option.
	   * The content element will be emptied before this change takes place.
	   *
	   * @return {ModalDialog}
	   *         Returns itself; method can be chained.
	   */
	
	
	  ModalDialog.prototype.fill = function fill() {
	    return this.fillWith(this.content());
	  };
	
	  /**
	   * Fill the modal's content element with arbitrary content.
	   * The content element will be emptied before this change takes place.
	   *
	   * @fires ModalDialog#beforemodalfill
	   * @fires ModalDialog#modalfill
	   *
	   * @param  {Mixed} [content]
	   *         The same rules apply to this as apply to the `content` option.
	   *
	   * @return {ModalDialog}
	   *         Returns itself; method can be chained.
	   */
	
	
	  ModalDialog.prototype.fillWith = function fillWith(content) {
	    var contentEl = this.contentEl();
	    var parentEl = contentEl.parentNode;
	    var nextSiblingEl = contentEl.nextSibling;
	
	    /**
	     * Fired just before a `ModalDialog` is filled with content.
	     *
	     * @event ModalDialog#beforemodalfill
	     * @type {EventTarget~Event}
	     */
	    this.trigger('beforemodalfill');
	    this.hasBeenFilled_ = true;
	
	    // Detach the content element from the DOM before performing
	    // manipulation to avoid modifying the live DOM multiple times.
	    parentEl.removeChild(contentEl);
	    this.empty();
	    Dom.insertContent(contentEl, content);
	    /**
	     * Fired just after a `ModalDialog` is filled with content.
	     *
	     * @event ModalDialog#modalfill
	     * @type {EventTarget~Event}
	     */
	    this.trigger('modalfill');
	
	    // Re-inject the re-filled content element.
	    if (nextSiblingEl) {
	      parentEl.insertBefore(contentEl, nextSiblingEl);
	    } else {
	      parentEl.appendChild(contentEl);
	    }
	
	    return this;
	  };
	
	  /**
	   * Empties the content element. This happens anytime the modal is filled.
	   *
	   * @fires ModalDialog#beforemodalempty
	   * @fires ModalDialog#modalempty
	   *
	   * @return {ModalDialog}
	   *         Returns itself; method can be chained.
	   */
	
	
	  ModalDialog.prototype.empty = function empty() {
	    /**
	     * Fired just before a `ModalDialog` is emptied.
	     *
	     * @event ModalDialog#beforemodalempty
	     * @type {EventTarget~Event}
	     */
	    this.trigger('beforemodalempty');
	    Dom.emptyEl(this.contentEl());
	
	    /**
	     * Fired just after a `ModalDialog` is emptied.
	     *
	     * @event ModalDialog#modalempty
	     * @type {EventTarget~Event}
	     */
	    this.trigger('modalempty');
	    return this;
	  };
	
	  /**
	   * Gets or sets the modal content, which gets normalized before being
	   * rendered into the DOM.
	   *
	   * This does not update the DOM or fill the modal, but it is called during
	   * that process.
	   *
	   * @param  {Mixed} [value]
	   *         If defined, sets the internal content value to be used on the
	   *         next call(s) to `fill`. This value is normalized before being
	   *         inserted. To "clear" the internal content value, pass `null`.
	   *
	   * @return {Mixed}
	   *         The current content of the modal dialog
	   */
	
	
	  ModalDialog.prototype.content = function content(value) {
	    if (typeof value !== 'undefined') {
	      this.content_ = value;
	    }
	    return this.content_;
	  };
	
	  return ModalDialog;
	}(_component2['default']);
	
	/**
	 * Default options for `ModalDialog` default options.
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ModalDialog.prototype.options_ = {
	  pauseOnOpen: true,
	  temporary: true
	};
	
	_component2['default'].registerComponent('ModalDialog', ModalDialog);
	exports['default'] = ModalDialog;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _events = __webpack_require__(83);
	
	var Events = _interopRequireWildcard(_events);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _guid = __webpack_require__(119);
	
	var Guid = _interopRequireWildcard(_guid);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _toTitleCase = __webpack_require__(120);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	var _timeRanges = __webpack_require__(143);
	
	var _buffer = __webpack_require__(430);
	
	var _stylesheet = __webpack_require__(431);
	
	var stylesheet = _interopRequireWildcard(_stylesheet);
	
	var _fullscreenApi = __webpack_require__(1006);
	
	var _fullscreenApi2 = _interopRequireDefault(_fullscreenApi);
	
	var _mediaError = __webpack_require__(422);
	
	var _mediaError2 = _interopRequireDefault(_mediaError);
	
	var _tuple = __webpack_require__(922);
	
	var _tuple2 = _interopRequireDefault(_tuple);
	
	var _obj = __webpack_require__(31);
	
	var _mergeOptions = __webpack_require__(76);
	
	var _mergeOptions2 = _interopRequireDefault(_mergeOptions);
	
	var _textTrackListConverter = __webpack_require__(1022);
	
	var _textTrackListConverter2 = _interopRequireDefault(_textTrackListConverter);
	
	var _modalDialog = __webpack_require__(425);
	
	var _modalDialog2 = _interopRequireDefault(_modalDialog);
	
	var _tech = __webpack_require__(142);
	
	var _tech2 = _interopRequireDefault(_tech);
	
	var _audioTrackList = __webpack_require__(428);
	
	var _audioTrackList2 = _interopRequireDefault(_audioTrackList);
	
	var _videoTrackList = __webpack_require__(429);
	
	var _videoTrackList2 = _interopRequireDefault(_videoTrackList);
	
	__webpack_require__(1016);
	
	__webpack_require__(1014);
	
	__webpack_require__(1011);
	
	__webpack_require__(1021);
	
	__webpack_require__(1007);
	
	__webpack_require__(972);
	
	__webpack_require__(973);
	
	__webpack_require__(976);
	
	__webpack_require__(1004);
	
	__webpack_require__(1024);
	
	__webpack_require__(1015);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file player.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	// Subclasses Component
	
	
	// The following imports are used only to ensure that the corresponding modules
	// are always included in the video.js package. Importing the modules will
	// execute them and they will register themselves with video.js.
	
	
	// Import Html5 tech, at least for disposing the original video tag.
	
	
	// The following tech events are simply re-triggered
	// on the player when they happen
	var TECH_EVENTS_RETRIGGER = [
	/**
	 * Fired while the user agent is downloading media data.
	 *
	 * @event Player#progress
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `progress` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechProgress_
	 * @fires Player#progress
	 * @listens Tech#progress
	 */
	'progress',
	
	/**
	 * Fires when the loading of an audio/video is aborted.
	 *
	 * @event Player#abort
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `abort` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechAbort_
	 * @fires Player#abort
	 * @listens Tech#abort
	 */
	'abort',
	
	/**
	 * Fires when the browser is intentionally not getting media data.
	 *
	 * @event Player#suspend
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `suspend` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechSuspend_
	 * @fires Player#suspend
	 * @listens Tech#suspend
	 */
	'suspend',
	
	/**
	 * Fires when the current playlist is empty.
	 *
	 * @event Player#emptied
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `emptied` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechEmptied_
	 * @fires Player#emptied
	 * @listens Tech#emptied
	 */
	'emptied',
	/**
	 * Fires when the browser is trying to get media data, but data is not available.
	 *
	 * @event Player#stalled
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechStalled_
	 * @fires Player#stalled
	 * @listens Tech#stalled
	 */
	'stalled',
	
	/**
	 * Fires when the browser has loaded meta data for the audio/video.
	 *
	 * @event Player#loadedmetadata
	 * @type {EventTarget~Event}
	 */
	/**
	 * Retrigger the `stalled` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechLoadedmetadata_
	 * @fires Player#loadedmetadata
	 * @listens Tech#loadedmetadata
	 */
	'loadedmetadata',
	
	/**
	 * Fires when the browser has loaded the current frame of the audio/video.
	 *
	 * @event player#loadeddata
	 * @type {event}
	 */
	/**
	 * Retrigger the `loadeddata` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechLoaddeddata_
	 * @fires Player#loadeddata
	 * @listens Tech#loadeddata
	 */
	'loadeddata',
	
	/**
	 * Fires when the current playback position has changed.
	 *
	 * @event player#timeupdate
	 * @type {event}
	 */
	/**
	 * Retrigger the `timeupdate` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechTimeUpdate_
	 * @fires Player#timeupdate
	 * @listens Tech#timeupdate
	 */
	'timeupdate',
	
	/**
	 * Fires when the playing speed of the audio/video is changed
	 *
	 * @event player#ratechange
	 * @type {event}
	 */
	/**
	 * Retrigger the `ratechange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechRatechange_
	 * @fires Player#ratechange
	 * @listens Tech#ratechange
	 */
	'ratechange',
	
	/**
	 * Fires when the volume has been changed
	 *
	 * @event player#volumechange
	 * @type {event}
	 */
	/**
	 * Retrigger the `volumechange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechVolumechange_
	 * @fires Player#volumechange
	 * @listens Tech#volumechange
	 */
	'volumechange',
	
	/**
	 * Fires when the text track has been changed
	 *
	 * @event player#texttrackchange
	 * @type {event}
	 */
	/**
	 * Retrigger the `texttrackchange` event that was triggered by the {@link Tech}.
	 *
	 * @private
	 * @method Player#handleTechTexttrackchange_
	 * @fires Player#texttrackchange
	 * @listens Tech#texttrackchange
	 */
	'texttrackchange'];
	
	/**
	 * An instance of the `Player` class is created when any of the Video.js setup methods
	 * are used to initialize a video.
	 *
	 * After an instance has been created it can be accessed globally in two ways:
	 * 1. By calling `videojs('example_video_1');`
	 * 2. By using it directly via  `videojs.players.example_video_1;`
	 *
	 * @extends Component
	 */
	
	var Player = function (_Component) {
	  _inherits(Player, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Element} tag
	   *        The original video DOM element used for configuring options.
	   *
	   * @param {Object} [options]
	   *        Object of option names and values.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        Ready callback function.
	   */
	  function Player(tag, options, ready) {
	    _classCallCheck(this, Player);
	
	    // Make sure tag ID exists
	    tag.id = tag.id || 'vjs_video_' + Guid.newGUID();
	
	    // Set Options
	    // The options argument overrides options set in the video tag
	    // which overrides globally set options.
	    // This latter part coincides with the load order
	    // (tag must exist before Player)
	    options = (0, _obj.assign)(Player.getTagSettings(tag), options);
	
	    // Delay the initialization of children because we need to set up
	    // player properties first, and can't use `this` before `super()`
	    options.initChildren = false;
	
	    // Same with creating the element
	    options.createEl = false;
	
	    // we don't want the player to report touch activity on itself
	    // see enableTouchActivity in Component
	    options.reportTouchActivity = false;
	
	    // If language is not set, get the closest lang attribute
	    if (!options.language) {
	      if (typeof tag.closest === 'function') {
	        var closest = tag.closest('[lang]');
	
	        if (closest) {
	          options.language = closest.getAttribute('lang');
	        }
	      } else {
	        var element = tag;
	
	        while (element && element.nodeType === 1) {
	          if (Dom.getElAttributes(element).hasOwnProperty('lang')) {
	            options.language = element.getAttribute('lang');
	            break;
	          }
	          element = element.parentNode;
	        }
	      }
	    }
	
	    // Run base component initializing with new options
	
	    // if the global option object was accidentally blown away by
	    // someone, bail early with an informative error
	    var _this = _possibleConstructorReturn(this, _Component.call(this, null, options, ready));
	
	    if (!_this.options_ || !_this.options_.techOrder || !_this.options_.techOrder.length) {
	      throw new Error('No techOrder specified. Did you overwrite ' + 'videojs.options instead of just changing the ' + 'properties you want to override?');
	    }
	
	    // Store the original tag used to set options
	    _this.tag = tag;
	
	    // Store the tag attributes used to restore html5 element
	    _this.tagAttributes = tag && Dom.getElAttributes(tag);
	
	    // Update current language
	    _this.language(_this.options_.language);
	
	    // Update Supported Languages
	    if (options.languages) {
	      // Normalise player option languages to lowercase
	      var languagesToLower = {};
	
	      Object.getOwnPropertyNames(options.languages).forEach(function (name) {
	        languagesToLower[name.toLowerCase()] = options.languages[name];
	      });
	      _this.languages_ = languagesToLower;
	    } else {
	      _this.languages_ = Player.prototype.options_.languages;
	    }
	
	    // Cache for video property values.
	    _this.cache_ = {};
	
	    // Set poster
	    _this.poster_ = options.poster || '';
	
	    // Set controls
	    _this.controls_ = !!options.controls;
	
	    // Original tag settings stored in options
	    // now remove immediately so native controls don't flash.
	    // May be turned back on by HTML5 tech if nativeControlsForTouch is true
	    tag.controls = false;
	
	    /*
	     * Store the internal state of scrubbing
	     *
	     * @private
	     * @return {Boolean} True if the user is scrubbing
	     */
	    _this.scrubbing_ = false;
	
	    _this.el_ = _this.createEl();
	
	    // We also want to pass the original player options to each component and plugin
	    // as well so they don't need to reach back into the player for options later.
	    // We also need to do another copy of this.options_ so we don't end up with
	    // an infinite loop.
	    var playerOptionsCopy = (0, _mergeOptions2['default'])(_this.options_);
	
	    // Load plugins
	    if (options.plugins) {
	      var plugins = options.plugins;
	
	      Object.getOwnPropertyNames(plugins).forEach(function (name) {
	        if (typeof this[name] === 'function') {
	          this[name](plugins[name]);
	        } else {
	          _log2['default'].error('Unable to find plugin:', name);
	        }
	      }, _this);
	    }
	
	    _this.options_.playerOptions = playerOptionsCopy;
	
	    _this.initChildren();
	
	    // Set isAudio based on whether or not an audio tag was used
	    _this.isAudio(tag.nodeName.toLowerCase() === 'audio');
	
	    // Update controls className. Can't do this when the controls are initially
	    // set because the element doesn't exist yet.
	    if (_this.controls()) {
	      _this.addClass('vjs-controls-enabled');
	    } else {
	      _this.addClass('vjs-controls-disabled');
	    }
	
	    // Set ARIA label and region role depending on player type
	    _this.el_.setAttribute('role', 'region');
	    if (_this.isAudio()) {
	      _this.el_.setAttribute('aria-label', 'audio player');
	    } else {
	      _this.el_.setAttribute('aria-label', 'video player');
	    }
	
	    if (_this.isAudio()) {
	      _this.addClass('vjs-audio');
	    }
	
	    if (_this.flexNotSupported_()) {
	      _this.addClass('vjs-no-flex');
	    }
	
	    // TODO: Make this smarter. Toggle user state between touching/mousing
	    // using events, since devices can have both touch and mouse events.
	    // if (browser.TOUCH_ENABLED) {
	    //   this.addClass('vjs-touch-enabled');
	    // }
	
	    // iOS Safari has broken hover handling
	    if (!browser.IS_IOS) {
	      _this.addClass('vjs-workinghover');
	    }
	
	    // Make player easily findable by ID
	    Player.players[_this.id_] = _this;
	
	    // Add a major version class to aid css in plugins
	    var majorVersion = '5.20.5'.split('.')[0];
	
	    _this.addClass('vjs-v' + majorVersion);
	
	    // When the player is first initialized, trigger activity so components
	    // like the control bar show themselves if needed
	    _this.userActive(true);
	    _this.reportUserActivity();
	    _this.listenForUserActivity_();
	
	    _this.on('fullscreenchange', _this.handleFullscreenChange_);
	    _this.on('stageclick', _this.handleStageClick_);
	    return _this;
	  }
	
	  /**
	   * Destroys the video player and does any necessary cleanup.
	   *
	   * This is especially helpful if you are dynamically adding and removing videos
	   * to/from the DOM.
	   *
	   * @fires Player#dispose
	   */
	
	
	  Player.prototype.dispose = function dispose() {
	    /**
	     * Called when the player is being disposed of.
	     *
	     * @event Player#dispose
	     * @type {EventTarget~Event}
	     */
	    this.trigger('dispose');
	    // prevent dispose from being called twice
	    this.off('dispose');
	
	    if (this.styleEl_ && this.styleEl_.parentNode) {
	      this.styleEl_.parentNode.removeChild(this.styleEl_);
	    }
	
	    // Kill reference to this player
	    Player.players[this.id_] = null;
	
	    if (this.tag && this.tag.player) {
	      this.tag.player = null;
	    }
	
	    if (this.el_ && this.el_.player) {
	      this.el_.player = null;
	    }
	
	    if (this.tech_) {
	      this.tech_.dispose();
	    }
	
	    _Component.prototype.dispose.call(this);
	  };
	
	  /**
	   * Create the `Player`'s DOM element.
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   */
	
	
	  Player.prototype.createEl = function createEl() {
	    var tag = this.tag;
	    var el = void 0;
	    var playerElIngest = this.playerElIngest_ = tag.parentNode && tag.parentNode.hasAttribute && tag.parentNode.hasAttribute('data-vjs-player');
	
	    if (playerElIngest) {
	      el = this.el_ = tag.parentNode;
	    } else {
	      el = this.el_ = _Component.prototype.createEl.call(this, 'div');
	    }
	
	    // set tabindex to -1 so we could focus on the player element
	    tag.setAttribute('tabindex', '-1');
	
	    // Remove width/height attrs from tag so CSS can make it 100% width/height
	    tag.removeAttribute('width');
	    tag.removeAttribute('height');
	
	    // Copy over all the attributes from the tag, including ID and class
	    // ID will now reference player box, not the video tag
	    var attrs = Dom.getElAttributes(tag);
	
	    Object.getOwnPropertyNames(attrs).forEach(function (attr) {
	      // workaround so we don't totally break IE7
	      // http://stackoverflow.com/questions/3653444/css-styles-not-applied-on-dynamic-elements-in-internet-explorer-7
	      if (attr === 'class') {
	        el.className += ' ' + attrs[attr];
	      } else {
	        el.setAttribute(attr, attrs[attr]);
	      }
	    });
	
	    // Update tag id/class for use as HTML5 playback tech
	    // Might think we should do this after embedding in container so .vjs-tech class
	    // doesn't flash 100% width/height, but class only applies with .video-js parent
	    tag.playerId = tag.id;
	    tag.id += '_html5_api';
	    tag.className = 'vjs-tech';
	
	    // Make player findable on elements
	    tag.player = el.player = this;
	    // Default state of video is paused
	    this.addClass('vjs-paused');
	
	    // Add a style element in the player that we'll use to set the width/height
	    // of the player in a way that's still overrideable by CSS, just like the
	    // video element
	    if (_window2['default'].VIDEOJS_NO_DYNAMIC_STYLE !== true) {
	      this.styleEl_ = stylesheet.createStyleElement('vjs-styles-dimensions');
	      var defaultsStyleEl = Dom.$('.vjs-styles-defaults');
	      var head = Dom.$('head');
	
	      head.insertBefore(this.styleEl_, defaultsStyleEl ? defaultsStyleEl.nextSibling : head.firstChild);
	    }
	
	    // Pass in the width/height/aspectRatio options which will update the style el
	    this.width(this.options_.width);
	    this.height(this.options_.height);
	    this.fluid(this.options_.fluid);
	    this.aspectRatio(this.options_.aspectRatio);
	
	    // Hide any links within the video/audio tag, because IE doesn't hide them completely.
	    var links = tag.getElementsByTagName('a');
	
	    for (var i = 0; i < links.length; i++) {
	      var linkEl = links.item(i);
	
	      Dom.addElClass(linkEl, 'vjs-hidden');
	      linkEl.setAttribute('hidden', 'hidden');
	    }
	
	    // insertElFirst seems to cause the networkState to flicker from 3 to 2, so
	    // keep track of the original for later so we can know if the source originally failed
	    tag.initNetworkState_ = tag.networkState;
	
	    // Wrap video tag in div (el/box) container
	    if (tag.parentNode && !playerElIngest) {
	      tag.parentNode.insertBefore(el, tag);
	    }
	
	    // insert the tag as the first child of the player element
	    // then manually add it to the children array so that this.addChild
	    // will work properly for other components
	    //
	    // Breaks iPhone, fixed in HTML5 setup.
	    Dom.insertElFirst(tag, el);
	    this.children_.unshift(tag);
	
	    this.el_ = el;
	
	    return el;
	  };
	
	  /**
	   * A getter/setter for the `Player`'s width.
	   *
	   * @param {number} [value]
	   *        The value to set the `Player's width to.
	   *
	   * @return {number}
	   *         The current width of the `Player`.
	   */
	
	
	  Player.prototype.width = function width(value) {
	    return this.dimension('width', value);
	  };
	
	  /**
	   * A getter/setter for the `Player`'s height.
	   *
	   * @param {number} [value]
	   *        The value to set the `Player's heigth to.
	   *
	   * @return {number}
	   *         The current heigth of the `Player`.
	   */
	
	
	  Player.prototype.height = function height(value) {
	    return this.dimension('height', value);
	  };
	
	  /**
	   * A getter/setter for the `Player`'s width & height.
	   *
	   * @param {string} dimension
	   *        This string can be:
	   *        - 'width'
	   *        - 'height'
	   *
	   * @param {number} [value]
	   *        Value for dimension specified in the first argument.
	   *
	   * @return {Player|number}
	   *         - Returns itself when setting; method can be chained.
	   *         - The dimension arguments value when getting (width/height).
	   */
	
	
	  Player.prototype.dimension = function dimension(_dimension, value) {
	    var privDimension = _dimension + '_';
	
	    if (value === undefined) {
	      return this[privDimension] || 0;
	    }
	
	    if (value === '') {
	      // If an empty string is given, reset the dimension to be automatic
	      this[privDimension] = undefined;
	    } else {
	      var parsedVal = parseFloat(value);
	
	      if (isNaN(parsedVal)) {
	        _log2['default'].error('Improper value "' + value + '" supplied for for ' + _dimension);
	        return this;
	      }
	
	      this[privDimension] = parsedVal;
	    }
	
	    this.updateStyleEl_();
	    return this;
	  };
	
	  /**
	   * A getter/setter/toggler for the vjs-fluid `className` on the `Player`.
	   *
	   * @param {boolean} [bool]
	   *        - A value of true adds the class.
	   *        - A value of false removes the class.
	   *        - No value will toggle the fluid class.
	   *
	   * @return {boolean|undefined}
	   *         - The value of fluid when getting.
	   *         - `undefined` when setting.
	   */
	
	
	  Player.prototype.fluid = function fluid(bool) {
	    if (bool === undefined) {
	      return !!this.fluid_;
	    }
	
	    this.fluid_ = !!bool;
	
	    if (bool) {
	      this.addClass('vjs-fluid');
	    } else {
	      this.removeClass('vjs-fluid');
	    }
	
	    this.updateStyleEl_();
	  };
	
	  /**
	   * Get/Set the aspect ratio
	   *
	   * @param {string} [ratio]
	   *        Aspect ratio for player
	   *
	   * @return {string|undefined}
	   *         returns the current aspect ratio when getting
	   */
	
	  /**
	   * A getter/setter for the `Player`'s aspect ratio.
	   *
	   * @param {string} [ratio]
	   *        The value to set the `Player's aspect ratio to.
	   *
	   * @return {string|undefined}
	   *         - The current aspect ratio of the `Player` when getting.
	   *         - undefined when setting
	   */
	
	
	  Player.prototype.aspectRatio = function aspectRatio(ratio) {
	    if (ratio === undefined) {
	      return this.aspectRatio_;
	    }
	
	    // Check for width:height format
	    if (!/^\d+\:\d+$/.test(ratio)) {
	      throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');
	    }
	    this.aspectRatio_ = ratio;
	
	    // We're assuming if you set an aspect ratio you want fluid mode,
	    // because in fixed mode you could calculate width and height yourself.
	    this.fluid(true);
	
	    this.updateStyleEl_();
	  };
	
	  /**
	   * Update styles of the `Player` element (height, width and aspect ratio).
	   *
	   * @private
	   * @listens Tech#loadedmetadata
	   */
	
	
	  Player.prototype.updateStyleEl_ = function updateStyleEl_() {
	    if (_window2['default'].VIDEOJS_NO_DYNAMIC_STYLE === true) {
	      var _width = typeof this.width_ === 'number' ? this.width_ : this.options_.width;
	      var _height = typeof this.height_ === 'number' ? this.height_ : this.options_.height;
	      var techEl = this.tech_ && this.tech_.el();
	
	      if (techEl) {
	        if (_width >= 0) {
	          techEl.width = _width;
	        }
	        if (_height >= 0) {
	          techEl.height = _height;
	        }
	      }
	
	      return;
	    }
	
	    var width = void 0;
	    var height = void 0;
	    var aspectRatio = void 0;
	    var idClass = void 0;
	
	    // The aspect ratio is either used directly or to calculate width and height.
	    if (this.aspectRatio_ !== undefined && this.aspectRatio_ !== 'auto') {
	      // Use any aspectRatio that's been specifically set
	      aspectRatio = this.aspectRatio_;
	    } else if (this.videoWidth() > 0) {
	      // Otherwise try to get the aspect ratio from the video metadata
	      aspectRatio = this.videoWidth() + ':' + this.videoHeight();
	    } else {
	      // Or use a default. The video element's is 2:1, but 16:9 is more common.
	      aspectRatio = '16:9';
	    }
	
	    // Get the ratio as a decimal we can use to calculate dimensions
	    var ratioParts = aspectRatio.split(':');
	    var ratioMultiplier = ratioParts[1] / ratioParts[0];
	
	    if (this.width_ !== undefined) {
	      // Use any width that's been specifically set
	      width = this.width_;
	    } else if (this.height_ !== undefined) {
	      // Or calulate the width from the aspect ratio if a height has been set
	      width = this.height_ / ratioMultiplier;
	    } else {
	      // Or use the video's metadata, or use the video el's default of 300
	      width = this.videoWidth() || 300;
	    }
	
	    if (this.height_ !== undefined) {
	      // Use any height that's been specifically set
	      height = this.height_;
	    } else {
	      // Otherwise calculate the height from the ratio and the width
	      height = width * ratioMultiplier;
	    }
	
	    // Ensure the CSS class is valid by starting with an alpha character
	    if (/^[^a-zA-Z]/.test(this.id())) {
	      idClass = 'dimensions-' + this.id();
	    } else {
	      idClass = this.id() + '-dimensions';
	    }
	
	    // Ensure the right class is still on the player for the style element
	    this.addClass(idClass);
	
	    stylesheet.setTextContent(this.styleEl_, '\n      .' + idClass + ' {\n        width: ' + width + 'px;\n        height: ' + height + 'px;\n      }\n\n      .' + idClass + '.vjs-fluid {\n        padding-top: ' + ratioMultiplier * 100 + '%;\n      }\n    ');
	  };
	
	  /**
	   * Load/Create an instance of playback {@link Tech} including element
	   * and API methods. Then append the `Tech` element in `Player` as a child.
	   *
	   * @param {string} techName
	   *        name of the playback technology
	   *
	   * @param {string} source
	   *        video source
	   *
	   * @private
	   */
	
	
	  Player.prototype.loadTech_ = function loadTech_(techName, source) {
	    var _this2 = this;
	
	    // Pause and remove current playback technology
	    if (this.tech_) {
	      this.unloadTech_();
	    }
	
	    // get rid of the HTML5 video tag as soon as we are using another tech
	    if (techName !== 'Html5' && this.tag) {
	      _tech2['default'].getTech('Html5').disposeMediaElement(this.tag);
	      this.tag.player = null;
	      this.tag = null;
	    }
	
	    this.techName_ = techName;
	
	    // Turn off API access because we're loading a new tech that might load asynchronously
	    this.isReady_ = false;
	
	    // Grab tech-specific options from player options and add source and parent element to use.
	    var techOptions = (0, _obj.assign)({
	      source: source,
	      'nativeControlsForTouch': this.options_.nativeControlsForTouch,
	      'playerId': this.id(),
	      'techId': this.id() + '_' + techName + '_api',
	      'videoTracks': this.videoTracks_,
	      'textTracks': this.textTracks_,
	      'audioTracks': this.audioTracks_,
	      'autoplay': this.options_.autoplay,
	      'playsinline': this.options_.playsinline,
	      'preload': this.options_.preload,
	      'loop': this.options_.loop,
	      'muted': this.options_.muted,
	      'poster': this.poster(),
	      'language': this.language(),
	      'playerElIngest': this.playerElIngest_ || false,
	      'vtt.js': this.options_['vtt.js']
	    }, this.options_[techName.toLowerCase()]);
	
	    if (this.tag) {
	      techOptions.tag = this.tag;
	    }
	
	    if (source) {
	      this.currentType_ = source.type;
	
	      if (source.src === this.cache_.src && this.cache_.currentTime > 0) {
	        techOptions.startTime = this.cache_.currentTime;
	      }
	
	      this.cache_.sources = null;
	      this.cache_.source = source;
	      this.cache_.src = source.src;
	    }
	
	    // Initialize tech instance
	    var TechComponent = _tech2['default'].getTech(techName);
	
	    // Support old behavior of techs being registered as components.
	    // Remove once that deprecated behavior is removed.
	    if (!TechComponent) {
	      TechComponent = _component2['default'].getComponent(techName);
	    }
	    this.tech_ = new TechComponent(techOptions);
	
	    // player.triggerReady is always async, so don't need this to be async
	    this.tech_.ready(Fn.bind(this, this.handleTechReady_), true);
	
	    _textTrackListConverter2['default'].jsonToTextTracks(this.textTracksJson_ || [], this.tech_);
	
	    // Listen to all HTML5-defined events and trigger them on the player
	    TECH_EVENTS_RETRIGGER.forEach(function (event) {
	      _this2.on(_this2.tech_, event, _this2['handleTech' + (0, _toTitleCase2['default'])(event) + '_']);
	    });
	    this.on(this.tech_, 'loadstart', this.handleTechLoadStart_);
	    this.on(this.tech_, 'waiting', this.handleTechWaiting_);
	    this.on(this.tech_, 'canplay', this.handleTechCanPlay_);
	    this.on(this.tech_, 'canplaythrough', this.handleTechCanPlayThrough_);
	    this.on(this.tech_, 'playing', this.handleTechPlaying_);
	    this.on(this.tech_, 'ended', this.handleTechEnded_);
	    this.on(this.tech_, 'seeking', this.handleTechSeeking_);
	    this.on(this.tech_, 'seeked', this.handleTechSeeked_);
	    this.on(this.tech_, 'play', this.handleTechPlay_);
	    this.on(this.tech_, 'firstplay', this.handleTechFirstPlay_);
	    this.on(this.tech_, 'pause', this.handleTechPause_);
	    this.on(this.tech_, 'durationchange', this.handleTechDurationChange_);
	    this.on(this.tech_, 'fullscreenchange', this.handleTechFullscreenChange_);
	    this.on(this.tech_, 'error', this.handleTechError_);
	    this.on(this.tech_, 'loadedmetadata', this.updateStyleEl_);
	    this.on(this.tech_, 'posterchange', this.handleTechPosterChange_);
	    this.on(this.tech_, 'textdata', this.handleTechTextData_);
	
	    this.usingNativeControls(this.techGet_('controls'));
	
	    if (this.controls() && !this.usingNativeControls()) {
	      this.addTechControlsListeners_();
	    }
	
	    // Add the tech element in the DOM if it was not already there
	    // Make sure to not insert the original video element if using Html5
	    if (this.tech_.el().parentNode !== this.el() && (techName !== 'Html5' || !this.tag)) {
	      Dom.insertElFirst(this.tech_.el(), this.el());
	    }
	
	    // Get rid of the original video tag reference after the first tech is loaded
	    if (this.tag) {
	      this.tag.player = null;
	      this.tag = null;
	    }
	  };
	
	  /**
	   * Unload and dispose of the current playback {@link Tech}.
	   *
	   * @private
	   */
	
	
	  Player.prototype.unloadTech_ = function unloadTech_() {
	    // Save the current text tracks so that we can reuse the same text tracks with the next tech
	    this.videoTracks_ = this.videoTracks();
	    this.textTracks_ = this.textTracks();
	    this.audioTracks_ = this.audioTracks();
	    this.textTracksJson_ = _textTrackListConverter2['default'].textTracksToJson(this.tech_);
	
	    this.isReady_ = false;
	
	    this.tech_.dispose();
	
	    this.tech_ = false;
	  };
	
	  /**
	   * Return a reference to the current {@link Tech}, but only if given an object with the
	   * `IWillNotUseThisInPlugins` property having a true value. This is try and prevent misuse
	   * of techs by plugins.
	   *
	   * @param {Object} safety
	   *        An object that must contain `{IWillNotUseThisInPlugins: true}`
	   *
	   * @param {boolean} safety.IWillNotUseThisInPlugins
	   *        Must be set to true or else this function will throw an error.
	   *
	   * @return {Tech}
	   *         The Tech
	   */
	
	
	  Player.prototype.tech = function tech(safety) {
	    if (safety && safety.IWillNotUseThisInPlugins) {
	      return this.tech_;
	    }
	    var errorText = '\n      Please make sure that you are not using this inside of a plugin.\n      To disable this alert and error, please pass in an object with\n      `IWillNotUseThisInPlugins` to the `tech` method. See\n      https://github.com/videojs/video.js/issues/2617 for more info.\n    ';
	
	    _window2['default'].alert(errorText);
	    throw new Error(errorText);
	  };
	
	  /**
	   * Set up click and touch listeners for the playback element
	   *
	   * - On desktops: a click on the video itself will toggle playback
	   * - On mobile devices: a click on the video toggles controls
	   *   which is done by toggling the user state between active and
	   *   inactive
	   * - A tap can signal that a user has become active or has become inactive
	   *   e.g. a quick tap on an iPhone movie should reveal the controls. Another
	   *   quick tap should hide them again (signaling the user is in an inactive
	   *   viewing state)
	   * - In addition to this, we still want the user to be considered inactive after
	   *   a few seconds of inactivity.
	   *
	   * > Note: the only part of iOS interaction we can't mimic with this setup
	   * is a touch and hold on the video element counting as activity in order to
	   * keep the controls showing, but that shouldn't be an issue. A touch and hold
	   * on any controls will still keep the user active
	   *
	   * @private
	   */
	
	
	  Player.prototype.addTechControlsListeners_ = function addTechControlsListeners_() {
	    // Make sure to remove all the previous listeners in case we are called multiple times.
	    this.removeTechControlsListeners_();
	
	    // Some browsers (Chrome & IE) don't trigger a click on a flash swf, but do
	    // trigger mousedown/up.
	    // http://stackoverflow.com/questions/1444562/javascript-onclick-event-over-flash-object
	    // Any touch events are set to block the mousedown event from happening
	    this.on(this.tech_, 'mousedown', this.handleTechClick_);
	
	    // If the controls were hidden we don't want that to change without a tap event
	    // so we'll check if the controls were already showing before reporting user
	    // activity
	    this.on(this.tech_, 'touchstart', this.handleTechTouchStart_);
	    this.on(this.tech_, 'touchmove', this.handleTechTouchMove_);
	    this.on(this.tech_, 'touchend', this.handleTechTouchEnd_);
	
	    // The tap listener needs to come after the touchend listener because the tap
	    // listener cancels out any reportedUserActivity when setting userActive(false)
	    this.on(this.tech_, 'tap', this.handleTechTap_);
	  };
	
	  /**
	   * Remove the listeners used for click and tap controls. This is needed for
	   * toggling to controls disabled, where a tap/touch should do nothing.
	   *
	   * @private
	   */
	
	
	  Player.prototype.removeTechControlsListeners_ = function removeTechControlsListeners_() {
	    // We don't want to just use `this.off()` because there might be other needed
	    // listeners added by techs that extend this.
	    this.off(this.tech_, 'tap', this.handleTechTap_);
	    this.off(this.tech_, 'touchstart', this.handleTechTouchStart_);
	    this.off(this.tech_, 'touchmove', this.handleTechTouchMove_);
	    this.off(this.tech_, 'touchend', this.handleTechTouchEnd_);
	    this.off(this.tech_, 'mousedown', this.handleTechClick_);
	  };
	
	  /**
	   * Player waits for the tech to be ready
	   *
	   * @private
	   */
	
	
	  Player.prototype.handleTechReady_ = function handleTechReady_() {
	    this.triggerReady();
	
	    // Keep the same volume as before
	    if (this.cache_.volume) {
	      this.techCall_('setVolume', this.cache_.volume);
	    }
	
	    // Look if the tech found a higher resolution poster while loading
	    this.handleTechPosterChange_();
	
	    // Update the duration if available
	    this.handleTechDurationChange_();
	
	    // Chrome and Safari both have issues with autoplay.
	    // In Safari (5.1.1), when we move the video element into the container div, autoplay doesn't work.
	    // In Chrome (15), if you have autoplay + a poster + no controls, the video gets hidden (but audio plays)
	    // This fixes both issues. Need to wait for API, so it updates displays correctly
	    if ((this.src() || this.currentSrc()) && this.tag && this.options_.autoplay && this.paused()) {
	      try {
	        // Chrome Fix. Fixed in Chrome v16.
	        delete this.tag.poster;
	      } catch (e) {
	        (0, _log2['default'])('deleting tag.poster throws in some browsers', e);
	      }
	      this.play();
	    }
	  };
	
	  /**
	   * Retrigger the `loadstart` event that was triggered by the {@link Tech}. This
	   * function will also trigger {@link Player#firstplay} if it is the first loadstart
	   * for a video.
	   *
	   * @fires Player#loadstart
	   * @fires Player#firstplay
	   * @listens Tech#loadstart
	   * @private
	   */
	
	
	  Player.prototype.handleTechLoadStart_ = function handleTechLoadStart_() {
	    // TODO: Update to use `emptied` event instead. See #1277.
	
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-seeking');
	
	    // reset the error state
	    this.error(null);
	
	    // If it's already playing we want to trigger a firstplay event now.
	    // The firstplay event relies on both the play and loadstart events
	    // which can happen in any order for a new source
	    if (!this.paused()) {
	      /**
	       * Fired when the user agent begins looking for media data
	       *
	       * @event Player#loadstart
	       * @type {EventTarget~Event}
	       */
	      this.trigger('loadstart');
	      this.trigger('firstplay');
	    } else {
	      // reset the hasStarted state
	      this.hasStarted(false);
	      this.trigger('loadstart');
	    }
	  };
	
	  /**
	   * Add/remove the vjs-has-started class
	   *
	   * @fires Player#firstplay
	   *
	   * @param {boolean} hasStarted
	   *        - true: adds the class
	   *        - false: remove the class
	   *
	   * @return {boolean}
	   *         the boolean value of hasStarted
	   */
	
	
	  Player.prototype.hasStarted = function hasStarted(_hasStarted) {
	    if (_hasStarted !== undefined) {
	      // only update if this is a new value
	      if (this.hasStarted_ !== _hasStarted) {
	        this.hasStarted_ = _hasStarted;
	        if (_hasStarted) {
	          this.addClass('vjs-has-started');
	          // trigger the firstplay event if this newly has played
	          this.trigger('firstplay');
	        } else {
	          this.removeClass('vjs-has-started');
	        }
	      }
	      return this;
	    }
	    return !!this.hasStarted_;
	  };
	
	  /**
	   * Fired whenever the media begins or resumes playback
	   *
	   * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-play}
	   * @fires Player#play
	   * @listens Tech#play
	   * @private
	   */
	
	
	  Player.prototype.handleTechPlay_ = function handleTechPlay_() {
	    this.removeClass('vjs-ended');
	    this.removeClass('vjs-paused');
	    this.addClass('vjs-playing');
	
	    // hide the poster when the user hits play
	    this.hasStarted(true);
	    /**
	     * Triggered whenever an {@link Tech#play} event happens. Indicates that
	     * playback has started or resumed.
	     *
	     * @event Player#play
	     * @type {EventTarget~Event}
	     */
	    this.trigger('play');
	  };
	
	  /**
	   * Retrigger the `waiting` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#waiting
	   * @listens Tech#waiting
	   * @private
	   */
	
	
	  Player.prototype.handleTechWaiting_ = function handleTechWaiting_() {
	    var _this3 = this;
	
	    this.addClass('vjs-waiting');
	    /**
	     * A readyState change on the DOM element has caused playback to stop.
	     *
	     * @event Player#waiting
	     * @type {EventTarget~Event}
	     */
	    this.trigger('waiting');
	    this.one('timeupdate', function () {
	      return _this3.removeClass('vjs-waiting');
	    });
	  };
	
	  /**
	   * Retrigger the `canplay` event that was triggered by the {@link Tech}.
	   * > Note: This is not consistent between browsers. See #1351
	   *
	   * @fires Player#canplay
	   * @listens Tech#canplay
	   * @private
	   */
	
	
	  Player.prototype.handleTechCanPlay_ = function handleTechCanPlay_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media has a readyState of HAVE_FUTURE_DATA or greater.
	     *
	     * @event Player#canplay
	     * @type {EventTarget~Event}
	     */
	    this.trigger('canplay');
	  };
	
	  /**
	   * Retrigger the `canplaythrough` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#canplaythrough
	   * @listens Tech#canplaythrough
	   * @private
	   */
	
	
	  Player.prototype.handleTechCanPlayThrough_ = function handleTechCanPlayThrough_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media has a readyState of HAVE_ENOUGH_DATA or greater. This means that the
	     * entire media file can be played without buffering.
	     *
	     * @event Player#canplaythrough
	     * @type {EventTarget~Event}
	     */
	    this.trigger('canplaythrough');
	  };
	
	  /**
	   * Retrigger the `playing` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#playing
	   * @listens Tech#playing
	   * @private
	   */
	
	
	  Player.prototype.handleTechPlaying_ = function handleTechPlaying_() {
	    this.removeClass('vjs-waiting');
	    /**
	     * The media is no longer blocked from playback, and has started playing.
	     *
	     * @event Player#playing
	     * @type {EventTarget~Event}
	     */
	    this.trigger('playing');
	  };
	
	  /**
	   * Retrigger the `seeking` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#seeking
	   * @listens Tech#seeking
	   * @private
	   */
	
	
	  Player.prototype.handleTechSeeking_ = function handleTechSeeking_() {
	    this.addClass('vjs-seeking');
	    /**
	     * Fired whenever the player is jumping to a new time
	     *
	     * @event Player#seeking
	     * @type {EventTarget~Event}
	     */
	    this.trigger('seeking');
	  };
	
	  /**
	   * Retrigger the `seeked` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#seeked
	   * @listens Tech#seeked
	   * @private
	   */
	
	
	  Player.prototype.handleTechSeeked_ = function handleTechSeeked_() {
	    this.removeClass('vjs-seeking');
	    /**
	     * Fired when the player has finished jumping to a new time
	     *
	     * @event Player#seeked
	     * @type {EventTarget~Event}
	     */
	    this.trigger('seeked');
	  };
	
	  /**
	   * Retrigger the `firstplay` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#firstplay
	   * @listens Tech#firstplay
	   * @deprecated As of 6.0 passing the `starttime` option to the player will be deprecated
	   * @private
	   */
	
	
	  Player.prototype.handleTechFirstPlay_ = function handleTechFirstPlay_() {
	    // If the first starttime attribute is specified
	    // then we will start at the given offset in seconds
	    if (this.options_.starttime) {
	      _log2['default'].warn('Passing the `starttime` option to the player will be deprecated in 6.0');
	      this.currentTime(this.options_.starttime);
	    }
	
	    this.addClass('vjs-has-started');
	    /**
	     * Fired the first time a video is played. Not part of the HLS spec, and this is
	     * probably not the best implementation yet, so use sparingly. If you don't have a
	     * reason to prevent playback, use `myPlayer.one('play');` instead.
	     *
	     * @event Player#firstplay
	     * @type {EventTarget~Event}
	     */
	    this.trigger('firstplay');
	  };
	
	  /**
	   * Retrigger the `pause` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#pause
	   * @listens Tech#pause
	   * @private
	   */
	
	
	  Player.prototype.handleTechPause_ = function handleTechPause_() {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-paused');
	    /**
	     * Fired whenever the media has been paused
	     *
	     * @event Player#pause
	     * @type {EventTarget~Event}
	     */
	    this.trigger('pause');
	  };
	
	  /**
	   * Retrigger the `ended` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#ended
	   * @listens Tech#ended
	   * @private
	   */
	
	
	  Player.prototype.handleTechEnded_ = function handleTechEnded_() {
	    this.addClass('vjs-ended');
	    if (this.options_.loop) {
	      this.currentTime(0);
	      this.play();
	    } else if (!this.paused()) {
	      this.pause();
	    }
	
	    /**
	     * Fired when the end of the media resource is reached (currentTime == duration)
	     *
	     * @event Player#ended
	     * @type {EventTarget~Event}
	     */
	    this.trigger('ended');
	  };
	
	  /**
	   * Fired when the duration of the media resource is first known or changed
	   *
	   * @listens Tech#durationchange
	   * @private
	   */
	
	
	  Player.prototype.handleTechDurationChange_ = function handleTechDurationChange_() {
	    this.duration(this.techGet_('duration'));
	  };
	
	  /**
	   * Handle a click on the media element to play/pause
	   *
	   * @param {EventTarget~Event} event
	   *        the event that caused this function to trigger
	   *
	   * @listens Tech#mousedown
	   * @private
	   */
	
	
	  Player.prototype.handleTechClick_ = function handleTechClick_(event) {
	    // We're using mousedown to detect clicks thanks to Flash, but mousedown
	    // will also be triggered with right-clicks, so we need to prevent that
	    if (event.button !== 0) {
	      return;
	    }
	
	    // When controls are disabled a click should not toggle playback because
	    // the click is considered a control
	    if (this.controls()) {
	      if (this.paused()) {
	        this.play();
	      } else {
	        this.pause();
	      }
	    }
	  };
	
	  /**
	   * Handle a tap on the media element. It will toggle the user
	   * activity state, which hides and shows the controls.
	   *
	   * @listens Tech#tap
	   * @private
	   */
	
	
	  Player.prototype.handleTechTap_ = function handleTechTap_() {
	    this.userActive(!this.userActive());
	  };
	
	  /**
	   * Handle touch to start
	   *
	   * @listens Tech#touchstart
	   * @private
	   */
	
	
	  Player.prototype.handleTechTouchStart_ = function handleTechTouchStart_() {
	    this.userWasActive = this.userActive();
	  };
	
	  /**
	   * Handle touch to move
	   *
	   * @listens Tech#touchmove
	   * @private
	   */
	
	
	  Player.prototype.handleTechTouchMove_ = function handleTechTouchMove_() {
	    if (this.userWasActive) {
	      this.reportUserActivity();
	    }
	  };
	
	  /**
	   * Handle touch to end
	   *
	   * @param {EventTarget~Event} event
	   *        the touchend event that triggered
	   *        this function
	   *
	   * @listens Tech#touchend
	   * @private
	   */
	
	
	  Player.prototype.handleTechTouchEnd_ = function handleTechTouchEnd_(event) {
	    // Stop the mouse events from also happening
	    event.preventDefault();
	  };
	
	  /**
	   * Fired when the player switches in or out of fullscreen mode
	   *
	   * @private
	   * @listens Player#fullscreenchange
	   */
	
	
	  Player.prototype.handleFullscreenChange_ = function handleFullscreenChange_() {
	    if (this.isFullscreen()) {
	      this.addClass('vjs-fullscreen');
	    } else {
	      this.removeClass('vjs-fullscreen');
	    }
	  };
	
	  /**
	   * native click events on the SWF aren't triggered on IE11, Win8.1RT
	   * use stageclick events triggered from inside the SWF instead
	   *
	   * @private
	   * @listens stageclick
	   */
	
	
	  Player.prototype.handleStageClick_ = function handleStageClick_() {
	    this.reportUserActivity();
	  };
	
	  /**
	   * Handle Tech Fullscreen Change
	   *
	   * @param {EventTarget~Event} event
	   *        the fullscreenchange event that triggered this function
	   *
	   * @param {Object} data
	   *        the data that was sent with the event
	   *
	   * @private
	   * @listens Tech#fullscreenchange
	   * @fires Player#fullscreenchange
	   */
	
	
	  Player.prototype.handleTechFullscreenChange_ = function handleTechFullscreenChange_(event, data) {
	    if (data) {
	      this.isFullscreen(data.isFullscreen);
	    }
	    /**
	     * Fired when going in and out of fullscreen.
	     *
	     * @event Player#fullscreenchange
	     * @type {EventTarget~Event}
	     */
	    this.trigger('fullscreenchange');
	  };
	
	  /**
	   * Fires when an error occurred during the loading of an audio/video.
	   *
	   * @private
	   * @listens Tech#error
	   */
	
	
	  Player.prototype.handleTechError_ = function handleTechError_() {
	    var error = this.tech_.error();
	
	    this.error(error);
	  };
	
	  /**
	   * Retrigger the `textdata` event that was triggered by the {@link Tech}.
	   *
	   * @fires Player#textdata
	   * @listens Tech#textdata
	   * @private
	   */
	
	
	  Player.prototype.handleTechTextData_ = function handleTechTextData_() {
	    var data = null;
	
	    if (arguments.length > 1) {
	      data = arguments[1];
	    }
	
	    /**
	     * Fires when we get a textdata event from tech
	     *
	     * @event Player#textdata
	     * @type {EventTarget~Event}
	     */
	    this.trigger('textdata', data);
	  };
	
	  /**
	   * Get object for cached values.
	   *
	   * @return {Object}
	   *         get the current object cache
	   */
	
	
	  Player.prototype.getCache = function getCache() {
	    return this.cache_;
	  };
	
	  /**
	   * Pass values to the playback tech
	   *
	   * @param {string} [method]
	   *        the method to call
	   *
	   * @param {Object} arg
	   *        the argument to pass
	   *
	   * @private
	   */
	
	
	  Player.prototype.techCall_ = function techCall_(method, arg) {
	    // If it's not ready yet, call method when it is
	    if (this.tech_ && !this.tech_.isReady_) {
	      this.tech_.ready(function () {
	        this[method](arg);
	      }, true);
	
	      // Otherwise call method now
	    } else {
	      try {
	        if (this.tech_) {
	          this.tech_[method](arg);
	        }
	      } catch (e) {
	        (0, _log2['default'])(e);
	        throw e;
	      }
	    }
	  };
	
	  /**
	   * Get calls can't wait for the tech, and sometimes don't need to.
	   *
	   * @param {string} method
	   *        Tech method
	   *
	   * @return {Function|undefined}
	   *         the method or undefined
	   *
	   * @private
	   */
	
	
	  Player.prototype.techGet_ = function techGet_(method) {
	    if (this.tech_ && this.tech_.isReady_) {
	
	      // Flash likes to die and reload when you hide or reposition it.
	      // In these cases the object methods go away and we get errors.
	      // When that happens we'll catch the errors and inform tech that it's not ready any more.
	      try {
	        return this.tech_[method]();
	      } catch (e) {
	        // When building additional tech libs, an expected method may not be defined yet
	        if (this.tech_[method] === undefined) {
	          (0, _log2['default'])('Video.js: ' + method + ' method not defined for ' + this.techName_ + ' playback technology.', e);
	
	          // When a method isn't available on the object it throws a TypeError
	        } else if (e.name === 'TypeError') {
	          (0, _log2['default'])('Video.js: ' + method + ' unavailable on ' + this.techName_ + ' playback technology element.', e);
	          this.tech_.isReady_ = false;
	        } else {
	          (0, _log2['default'])(e);
	        }
	        throw e;
	      }
	    }
	
	    return;
	  };
	
	  /**
	   * start media playback
	   *
	   * @return {Player}
	   *         A reference to the player object this function was called on
	   */
	
	
	  Player.prototype.play = function play() {
	    // Only calls the tech's play if we already have a src loaded
	    if (this.src() || this.currentSrc()) {
	      this.techCall_('play');
	    } else {
	      this.tech_.one('loadstart', function () {
	        this.play();
	      });
	    }
	
	    return this;
	  };
	
	  /**
	   * Pause the video playback
	   *
	   * @return {Player}
	   *         A reference to the player object this function was called on
	   */
	
	
	  Player.prototype.pause = function pause() {
	    this.techCall_('pause');
	    return this;
	  };
	
	  /**
	   * Check if the player is paused or has yet to play
	   *
	   * @return {boolean}
	   *         - false: if the media is currently playing
	   *         - true: if media is not currently playing
	   */
	
	
	  Player.prototype.paused = function paused() {
	    // The initial state of paused should be true (in Safari it's actually false)
	    return this.techGet_('paused') === false ? false : true;
	  };
	
	  /**
	   * Returns whether or not the user is "scrubbing". Scrubbing is
	   * when the user has clicked the progress bar handle and is
	   * dragging it along the progress bar.
	   *
	   * @param {boolean} [isScrubbing]
	   *        wether the user is or is not scrubbing
	   *
	   * @return {boolean|Player}
	   *         A instance of the player that called this function when setting,
	   *         and the value of scrubbing when getting
	   */
	
	
	  Player.prototype.scrubbing = function scrubbing(isScrubbing) {
	    if (isScrubbing !== undefined) {
	      this.scrubbing_ = !!isScrubbing;
	
	      if (isScrubbing) {
	        this.addClass('vjs-scrubbing');
	      } else {
	        this.removeClass('vjs-scrubbing');
	      }
	
	      return this;
	    }
	
	    return this.scrubbing_;
	  };
	
	  /**
	   * Get or set the current time (in seconds)
	   *
	   * @param {number|string} [seconds]
	   *        The time to seek to in seconds
	   *
	   * @return {Player|number}
	   *         - the current time in seconds when getting
	   *         - a reference to the current player object when setting
	   */
	
	
	  Player.prototype.currentTime = function currentTime(seconds) {
	    if (seconds !== undefined) {
	
	      this.techCall_('setCurrentTime', seconds);
	
	      return this;
	    }
	
	    // cache last currentTime and return. default to 0 seconds
	    //
	    // Caching the currentTime is meant to prevent a massive amount of reads on the tech's
	    // currentTime when scrubbing, but may not provide much performance benefit afterall.
	    // Should be tested. Also something has to read the actual current time or the cache will
	    // never get updated.
	    this.cache_.currentTime = this.techGet_('currentTime') || 0;
	    return this.cache_.currentTime;
	  };
	
	  /**
	   * Normally gets the length in time of the video in seconds;
	   * in all but the rarest use cases an argument will NOT be passed to the method
	   *
	   * > **NOTE**: The video must have started loading before the duration can be
	   * known, and in the case of Flash, may not be known until the video starts
	   * playing.
	   *
	   * @fires Player#durationchange
	   *
	   * @param {number} [seconds]
	   *        The duration of the video to set in seconds
	   *
	   * @return {number|Player}
	   *         - The duration of the video in seconds when getting
	   *         - A reference to the player that called this function
	   *           when setting
	   */
	
	
	  Player.prototype.duration = function duration(seconds) {
	    if (seconds === undefined) {
	      // return NaN if the duration is not known
	      return this.cache_.duration !== undefined ? this.cache_.duration : NaN;
	    }
	
	    seconds = parseFloat(seconds);
	
	    // Standardize on Inifity for signaling video is live
	    if (seconds < 0) {
	      seconds = Infinity;
	    }
	
	    if (seconds !== this.cache_.duration) {
	      // Cache the last set value for optimized scrubbing (esp. Flash)
	      this.cache_.duration = seconds;
	
	      if (seconds === Infinity) {
	        this.addClass('vjs-live');
	      } else {
	        this.removeClass('vjs-live');
	      }
	      /**
	       * @event Player#durationchange
	       * @type {EventTarget~Event}
	       */
	      this.trigger('durationchange');
	    }
	
	    return this;
	  };
	
	  /**
	   * Calculates how much time is left in the video. Not part
	   * of the native video API.
	   *
	   * @return {number}
	   *         The time remaining in seconds
	   */
	
	
	  Player.prototype.remainingTime = function remainingTime() {
	    return this.duration() - this.currentTime();
	  };
	
	  //
	  // Kind of like an array of portions of the video that have been downloaded.
	
	  /**
	   * Get a TimeRange object with an array of the times of the video
	   * that have been downloaded. If you just want the percent of the
	   * video that's been downloaded, use bufferedPercent.
	   *
	   * @see [Buffered Spec]{@link http://dev.w3.org/html5/spec/video.html#dom-media-buffered}
	   *
	   * @return {TimeRange}
	   *         A mock TimeRange object (following HTML spec)
	   */
	
	
	  Player.prototype.buffered = function buffered() {
	    var buffered = this.techGet_('buffered');
	
	    if (!buffered || !buffered.length) {
	      buffered = (0, _timeRanges.createTimeRange)(0, 0);
	    }
	
	    return buffered;
	  };
	
	  /**
	   * Get the percent (as a decimal) of the video that's been downloaded.
	   * This method is not a part of the native HTML video API.
	   *
	   * @return {number}
	   *         A decimal between 0 and 1 representing the percent
	   *         that is bufferred 0 being 0% and 1 being 100%
	   */
	
	
	  Player.prototype.bufferedPercent = function bufferedPercent() {
	    return (0, _buffer.bufferedPercent)(this.buffered(), this.duration());
	  };
	
	  /**
	   * Get the ending time of the last buffered time range
	   * This is used in the progress bar to encapsulate all time ranges.
	   *
	   * @return {number}
	   *         The end of the last buffered time range
	   */
	
	
	  Player.prototype.bufferedEnd = function bufferedEnd() {
	    var buffered = this.buffered();
	    var duration = this.duration();
	    var end = buffered.end(buffered.length - 1);
	
	    if (end > duration) {
	      end = duration;
	    }
	
	    return end;
	  };
	
	  /**
	   * Get or set the current volume of the media
	   *
	   * @param  {number} [percentAsDecimal]
	   *         The new volume as a decimal percent:
	   *         - 0 is muted/0%/off
	   *         - 1.0 is 100%/full
	   *         - 0.5 is half volume or 50%
	   *
	   * @return {Player|number}
	   *         a reference to the calling player when setting and the
	   *         current volume as a percent when getting
	   */
	
	
	  Player.prototype.volume = function volume(percentAsDecimal) {
	    var vol = void 0;
	
	    if (percentAsDecimal !== undefined) {
	      // Force value to between 0 and 1
	      vol = Math.max(0, Math.min(1, parseFloat(percentAsDecimal)));
	      this.cache_.volume = vol;
	      this.techCall_('setVolume', vol);
	
	      return this;
	    }
	
	    // Default to 1 when returning current volume.
	    vol = parseFloat(this.techGet_('volume'));
	    return isNaN(vol) ? 1 : vol;
	  };
	
	  /**
	   * Get the current muted state, or turn mute on or off
	   *
	   * @param {boolean} [muted]
	   *        - true to mute
	   *        - false to unmute
	   *
	   * @return {boolean|Player}
	   *         - true if mute is on and getting
	   *         - false if mute is off and getting
	   *         - A reference to the current player when setting
	   */
	
	
	  Player.prototype.muted = function muted(_muted) {
	    if (_muted !== undefined) {
	      this.techCall_('setMuted', _muted);
	      return this;
	    }
	    return this.techGet_('muted') || false;
	  };
	
	  /**
	   * Check if current tech can support native fullscreen
	   * (e.g. with built in controls like iOS, so not our flash swf)
	   *
	   * @return {boolean}
	   *         if native fullscreen is supported
	   */
	
	
	  Player.prototype.supportsFullScreen = function supportsFullScreen() {
	    return this.techGet_('supportsFullScreen') || false;
	  };
	
	  /**
	   * Check if the player is in fullscreen mode or tell the player that it
	   * is or is not in fullscreen mode.
	   *
	   * > NOTE: As of the latest HTML5 spec, isFullscreen is no longer an official
	   * property and instead document.fullscreenElement is used. But isFullscreen is
	   * still a valuable property for internal player workings.
	   *
	   * @param  {boolean} [isFS]
	   *         Set the players current fullscreen state
	   *
	   * @return {boolean|Player}
	   *         - true if fullscreen is on and getting
	   *         - false if fullscreen is off and getting
	   *         - A reference to the current player when setting
	   */
	
	
	  Player.prototype.isFullscreen = function isFullscreen(isFS) {
	    if (isFS !== undefined) {
	      this.isFullscreen_ = !!isFS;
	      return this;
	    }
	    return !!this.isFullscreen_;
	  };
	
	  /**
	   * Increase the size of the video to full screen
	   * In some browsers, full screen is not supported natively, so it enters
	   * "full window mode", where the video fills the browser window.
	   * In browsers and devices that support native full screen, sometimes the
	   * browser's default controls will be shown, and not the Video.js custom skin.
	   * This includes most mobile devices (iOS, Android) and older versions of
	   * Safari.
	   *
	   * @fires Player#fullscreenchange
	   * @return {Player}
	   *         A reference to the current player
	   */
	
	
	  Player.prototype.requestFullscreen = function requestFullscreen() {
	    var fsApi = _fullscreenApi2['default'];
	
	    this.isFullscreen(true);
	
	    if (fsApi.requestFullscreen) {
	      // the browser supports going fullscreen at the element level so we can
	      // take the controls fullscreen as well as the video
	
	      // Trigger fullscreenchange event after change
	      // We have to specifically add this each time, and remove
	      // when canceling fullscreen. Otherwise if there's multiple
	      // players on a page, they would all be reacting to the same fullscreen
	      // events
	      Events.on(_document2['default'], fsApi.fullscreenchange, Fn.bind(this, function documentFullscreenChange(e) {
	        this.isFullscreen(_document2['default'][fsApi.fullscreenElement]);
	
	        // If cancelling fullscreen, remove event listener.
	        if (this.isFullscreen() === false) {
	          Events.off(_document2['default'], fsApi.fullscreenchange, documentFullscreenChange);
	        }
	        /**
	         * @event Player#fullscreenchange
	         * @type {EventTarget~Event}
	         */
	        this.trigger('fullscreenchange');
	      }));
	
	      this.el_[fsApi.requestFullscreen]();
	    } else if (this.tech_.supportsFullScreen()) {
	      // we can't take the video.js controls fullscreen but we can go fullscreen
	      // with native controls
	      this.techCall_('enterFullScreen');
	    } else {
	      // fullscreen isn't supported so we'll just stretch the video element to
	      // fill the viewport
	      this.enterFullWindow();
	      /**
	       * @event Player#fullscreenchange
	       * @type {EventTarget~Event}
	       */
	      this.trigger('fullscreenchange');
	    }
	
	    return this;
	  };
	
	  /**
	   * Return the video to its normal size after having been in full screen mode
	   *
	   * @fires Player#fullscreenchange
	   *
	   * @return {Player}
	   *         A reference to the current player
	   */
	
	
	  Player.prototype.exitFullscreen = function exitFullscreen() {
	    var fsApi = _fullscreenApi2['default'];
	
	    this.isFullscreen(false);
	
	    // Check for browser element fullscreen support
	    if (fsApi.requestFullscreen) {
	      _document2['default'][fsApi.exitFullscreen]();
	    } else if (this.tech_.supportsFullScreen()) {
	      this.techCall_('exitFullScreen');
	    } else {
	      this.exitFullWindow();
	      /**
	       * @event Player#fullscreenchange
	       * @type {EventTarget~Event}
	       */
	      this.trigger('fullscreenchange');
	    }
	
	    return this;
	  };
	
	  /**
	   * When fullscreen isn't supported we can stretch the
	   * video container to as wide as the browser will let us.
	   *
	   * @fires Player#enterFullWindow
	   */
	
	
	  Player.prototype.enterFullWindow = function enterFullWindow() {
	    this.isFullWindow = true;
	
	    // Storing original doc overflow value to return to when fullscreen is off
	    this.docOrigOverflow = _document2['default'].documentElement.style.overflow;
	
	    // Add listener for esc key to exit fullscreen
	    Events.on(_document2['default'], 'keydown', Fn.bind(this, this.fullWindowOnEscKey));
	
	    // Hide any scroll bars
	    _document2['default'].documentElement.style.overflow = 'hidden';
	
	    // Apply fullscreen styles
	    Dom.addElClass(_document2['default'].body, 'vjs-full-window');
	
	    /**
	     * @event Player#enterFullWindow
	     * @type {EventTarget~Event}
	     */
	    this.trigger('enterFullWindow');
	  };
	
	  /**
	   * Check for call to either exit full window or
	   * full screen on ESC key
	   *
	   * @param {string} event
	   *        Event to check for key press
	   */
	
	
	  Player.prototype.fullWindowOnEscKey = function fullWindowOnEscKey(event) {
	    if (event.keyCode === 27) {
	      if (this.isFullscreen() === true) {
	        this.exitFullscreen();
	      } else {
	        this.exitFullWindow();
	      }
	    }
	  };
	
	  /**
	   * Exit full window
	   *
	   * @fires Player#exitFullWindow
	   */
	
	
	  Player.prototype.exitFullWindow = function exitFullWindow() {
	    this.isFullWindow = false;
	    Events.off(_document2['default'], 'keydown', this.fullWindowOnEscKey);
	
	    // Unhide scroll bars.
	    _document2['default'].documentElement.style.overflow = this.docOrigOverflow;
	
	    // Remove fullscreen styles
	    Dom.removeElClass(_document2['default'].body, 'vjs-full-window');
	
	    // Resize the box, controller, and poster to original sizes
	    // this.positionAll();
	    /**
	     * @event Player#exitFullWindow
	     * @type {EventTarget~Event}
	     */
	    this.trigger('exitFullWindow');
	  };
	
	  /**
	   * Check whether the player can play a given mimetype
	   *
	   * @see https://www.w3.org/TR/2011/WD-html5-20110113/video.html#dom-navigator-canplaytype
	   *
	   * @param {string} type
	   *        The mimetype to check
	   *
	   * @return {string}
	   *         'probably', 'maybe', or '' (empty string)
	   */
	
	
	  Player.prototype.canPlayType = function canPlayType(type) {
	    var can = void 0;
	
	    // Loop through each playback technology in the options order
	    for (var i = 0, j = this.options_.techOrder; i < j.length; i++) {
	      var techName = (0, _toTitleCase2['default'])(j[i]);
	      var tech = _tech2['default'].getTech(techName);
	
	      // Support old behavior of techs being registered as components.
	      // Remove once that deprecated behavior is removed.
	      if (!tech) {
	        tech = _component2['default'].getComponent(techName);
	      }
	
	      // Check if the current tech is defined before continuing
	      if (!tech) {
	        _log2['default'].error('The "' + techName + '" tech is undefined. Skipped browser support check for that tech.');
	        continue;
	      }
	
	      // Check if the browser supports this technology
	      if (tech.isSupported()) {
	        can = tech.canPlayType(type);
	
	        if (can) {
	          return can;
	        }
	      }
	    }
	
	    return '';
	  };
	
	  /**
	   * Select source based on tech-order or source-order
	   * Uses source-order selection if `options.sourceOrder` is truthy. Otherwise,
	   * defaults to tech-order selection
	   *
	   * @param {Array} sources
	   *        The sources for a media asset
	   *
	   * @return {Object|boolean}
	   *         Object of source and tech order or false
	   */
	
	
	  Player.prototype.selectSource = function selectSource(sources) {
	    var _this4 = this;
	
	    // Get only the techs specified in `techOrder` that exist and are supported by the
	    // current platform
	    var techs = this.options_.techOrder.map(_toTitleCase2['default']).map(function (techName) {
	      // `Component.getComponent(...)` is for support of old behavior of techs
	      // being registered as components.
	      // Remove once that deprecated behavior is removed.
	      return [techName, _tech2['default'].getTech(techName) || _component2['default'].getComponent(techName)];
	    }).filter(function (_ref) {
	      var techName = _ref[0],
	          tech = _ref[1];
	
	      // Check if the current tech is defined before continuing
	      if (tech) {
	        // Check if the browser supports this technology
	        return tech.isSupported();
	      }
	
	      _log2['default'].error('The "' + techName + '" tech is undefined. Skipped browser support check for that tech.');
	      return false;
	    });
	
	    // Iterate over each `innerArray` element once per `outerArray` element and execute
	    // `tester` with both. If `tester` returns a non-falsy value, exit early and return
	    // that value.
	    var findFirstPassingTechSourcePair = function findFirstPassingTechSourcePair(outerArray, innerArray, tester) {
	      var found = void 0;
	
	      outerArray.some(function (outerChoice) {
	        return innerArray.some(function (innerChoice) {
	          found = tester(outerChoice, innerChoice);
	
	          if (found) {
	            return true;
	          }
	        });
	      });
	
	      return found;
	    };
	
	    var foundSourceAndTech = void 0;
	    var flip = function flip(fn) {
	      return function (a, b) {
	        return fn(b, a);
	      };
	    };
	    var finder = function finder(_ref2, source) {
	      var techName = _ref2[0],
	          tech = _ref2[1];
	
	      if (tech.canPlaySource(source, _this4.options_[techName.toLowerCase()])) {
	        return { source: source, tech: techName };
	      }
	    };
	
	    // Depending on the truthiness of `options.sourceOrder`, we swap the order of techs and sources
	    // to select from them based on their priority.
	    if (this.options_.sourceOrder) {
	      // Source-first ordering
	      foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
	    } else {
	      // Tech-first ordering
	      foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
	    }
	
	    return foundSourceAndTech || false;
	  };
	
	  /**
	   * The source function updates the video source
	   * There are three types of variables you can pass as the argument.
	   * **URL string**: A URL to the the video file. Use this method if you are sure
	   * the current playback technology (HTML5/Flash) can support the source you
	   * provide. Currently only MP4 files can be used in both HTML5 and Flash.
	   *
	   * @param {Tech~SourceObject|Tech~SourceObject[]} [source]
	   *        One SourceObject or an array of SourceObjects
	   *
	   * @return {string|Player}
	   *         - The current video source when getting
	   *         - The player when setting
	   */
	
	
	  Player.prototype.src = function src(source) {
	    if (source === undefined) {
	      return this.techGet_('src');
	    }
	
	    var currentTech = _tech2['default'].getTech(this.techName_);
	
	    // Support old behavior of techs being registered as components.
	    // Remove once that deprecated behavior is removed.
	    if (!currentTech) {
	      currentTech = _component2['default'].getComponent(this.techName_);
	    }
	
	    // case: Array of source objects to choose from and pick the best to play
	    if (Array.isArray(source)) {
	      this.sourceList_(source);
	
	      // case: URL String (http://myvideo...)
	    } else if (typeof source === 'string') {
	      // create a source object from the string
	      this.src({ src: source });
	
	      // case: Source object { src: '', type: '' ... }
	    } else if (source instanceof Object) {
	      // check if the source has a type and the loaded tech cannot play the source
	      // if there's no type we'll just try the current tech
	      if (source.type && !currentTech.canPlaySource(source, this.options_[this.techName_.toLowerCase()])) {
	        // create a source list with the current source and send through
	        // the tech loop to check for a compatible technology
	        this.sourceList_([source]);
	      } else {
	        this.cache_.sources = null;
	        this.cache_.source = source;
	        this.cache_.src = source.src;
	
	        this.currentType_ = source.type || '';
	
	        // wait until the tech is ready to set the source
	        this.ready(function () {
	
	          // The setSource tech method was added with source handlers
	          // so older techs won't support it
	          // We need to check the direct prototype for the case where subclasses
	          // of the tech do not support source handlers
	          if (currentTech.prototype.hasOwnProperty('setSource')) {
	            this.techCall_('setSource', source);
	          } else {
	            this.techCall_('src', source.src);
	          }
	
	          if (this.options_.preload === 'auto') {
	            this.load();
	          }
	
	          if (this.options_.autoplay) {
	            this.play();
	          }
	
	          // Set the source synchronously if possible (#2326)
	        }, true);
	      }
	    }
	
	    return this;
	  };
	
	  /**
	   * Handle an array of source objects
	   *
	   * @param  {Tech~SourceObject[]} sources
	   *         Array of source objects
	   *
	   * @private
	   */
	
	
	  Player.prototype.sourceList_ = function sourceList_(sources) {
	    var sourceTech = this.selectSource(sources);
	
	    if (sourceTech) {
	      if (sourceTech.tech === this.techName_) {
	        // if this technology is already loaded, set the source
	        this.src(sourceTech.source);
	      } else {
	        // load this technology with the chosen source
	        this.loadTech_(sourceTech.tech, sourceTech.source);
	      }
	
	      this.cache_.sources = sources;
	    } else {
	      // We need to wrap this in a timeout to give folks a chance to add error event handlers
	      this.setTimeout(function () {
	        this.error({ code: 4, message: this.localize(this.options_.notSupportedMessage) });
	      }, 0);
	
	      // we could not find an appropriate tech, but let's still notify the delegate that this is it
	      // this needs a better comment about why this is needed
	      this.triggerReady();
	    }
	  };
	
	  /**
	   * Begin loading the src data.
	   *
	   * @return {Player}
	   *         A reference to the player
	   */
	
	
	  Player.prototype.load = function load() {
	    this.techCall_('load');
	    return this;
	  };
	
	  /**
	   * Reset the player. Loads the first tech in the techOrder,
	   * and calls `reset` on the tech`.
	   *
	   * @return {Player}
	   *         A reference to the player
	   */
	
	
	  Player.prototype.reset = function reset() {
	    this.loadTech_((0, _toTitleCase2['default'])(this.options_.techOrder[0]), null);
	    this.techCall_('reset');
	    return this;
	  };
	
	  /**
	   * Returns all of the current source objects.
	   *
	   * @return {Tech~SourceObject[]}
	   *         The current source objects
	   */
	
	
	  Player.prototype.currentSources = function currentSources() {
	    var source = this.currentSource();
	    var sources = [];
	
	    // assume `{}` or `{ src }`
	    if (Object.keys(source).length !== 0) {
	      sources.push(source);
	    }
	
	    return this.cache_.sources || sources;
	  };
	
	  /**
	   * Returns the current source object.
	   *
	   * @return {Tech~SourceObject}
	   *         The current source object
	   */
	
	
	  Player.prototype.currentSource = function currentSource() {
	    var source = {};
	    var src = this.currentSrc();
	
	    if (src) {
	      source.src = src;
	    }
	
	    return this.cache_.source || source;
	  };
	
	  /**
	   * Returns the fully qualified URL of the current source value e.g. http://mysite.com/video.mp4
	   * Can be used in conjuction with `currentType` to assist in rebuilding the current source object.
	   *
	   * @return {string}
	   *         The current source
	   */
	
	
	  Player.prototype.currentSrc = function currentSrc() {
	    return this.techGet_('currentSrc') || this.cache_.src || '';
	  };
	
	  /**
	   * Get the current source type e.g. video/mp4
	   * This can allow you rebuild the current source object so that you could load the same
	   * source and tech later
	   *
	   * @return {string}
	   *         The source MIME type
	   */
	
	
	  Player.prototype.currentType = function currentType() {
	    return this.currentType_ || '';
	  };
	
	  /**
	   * Get or set the preload attribute
	   *
	   * @param {boolean} [value]
	   *        - true means that we should preload
	   *        - false maens that we should not preload
	   *
	   * @return {string|Player}
	   *         - the preload attribute value when getting
	   *         - the player when setting
	   */
	
	
	  Player.prototype.preload = function preload(value) {
	    if (value !== undefined) {
	      this.techCall_('setPreload', value);
	      this.options_.preload = value;
	      return this;
	    }
	    return this.techGet_('preload');
	  };
	
	  /**
	   * Get or set the autoplay attribute.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should autoplay
	   *        - false maens that we should not autoplay
	   *
	   * @return {string|Player}
	   *         - the current value of autoplay
	   *         - the player when setting
	   */
	
	
	  Player.prototype.autoplay = function autoplay(value) {
	    if (value !== undefined) {
	      this.techCall_('setAutoplay', value);
	      this.options_.autoplay = value;
	      return this;
	    }
	    return this.techGet_('autoplay', value);
	  };
	
	  /**
	   * Set or unset the playsinline attribute.
	   * Playsinline tells the browser that non-fullscreen playback is preferred.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should try to play inline by default
	   *        - false means that we should use the browser's default playback mode,
	   *          which in most cases is inline. iOS Safari is a notable exception
	   *          and plays fullscreen by default.
	   *
	   * @return {string|Player}
	   *         - the current value of playsinline
	   *         - the player when setting
	   *
	   * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	   */
	
	
	  Player.prototype.playsinline = function playsinline(value) {
	    if (value !== undefined) {
	      this.techCall_('setPlaysinline', value);
	      this.options_.playsinline = value;
	      return this;
	    }
	    return this.techGet_('playsinline');
	  };
	
	  /**
	   * Get or set the loop attribute on the video element.
	   *
	   * @param {boolean} [value]
	   *        - true means that we should loop the video
	   *        - false means that we should not loop the video
	   *
	   * @return {string|Player}
	   *         - the current value of loop when getting
	   *         - the player when setting
	   */
	
	
	  Player.prototype.loop = function loop(value) {
	    if (value !== undefined) {
	      this.techCall_('setLoop', value);
	      this.options_.loop = value;
	      return this;
	    }
	    return this.techGet_('loop');
	  };
	
	  /**
	   * Get or set the poster image source url
	   *
	   * @fires Player#posterchange
	   *
	   * @param {string} [src]
	   *        Poster image source URL
	   *
	   * @return {string|Player}
	   *         - the current value of poster when getting
	   *         - the player when setting
	   */
	
	
	  Player.prototype.poster = function poster(src) {
	    if (src === undefined) {
	      return this.poster_;
	    }
	
	    // The correct way to remove a poster is to set as an empty string
	    // other falsey values will throw errors
	    if (!src) {
	      src = '';
	    }
	
	    // update the internal poster variable
	    this.poster_ = src;
	
	    // update the tech's poster
	    this.techCall_('setPoster', src);
	
	    // alert components that the poster has been set
	    /**
	     * This event fires when the poster image is changed on the player.
	     *
	     * @event Player#posterchange
	     * @type {EventTarget~Event}
	     */
	    this.trigger('posterchange');
	
	    return this;
	  };
	
	  /**
	   * Some techs (e.g. YouTube) can provide a poster source in an
	   * asynchronous way. We want the poster component to use this
	   * poster source so that it covers up the tech's controls.
	   * (YouTube's play button). However we only want to use this
	   * soruce if the player user hasn't set a poster through
	   * the normal APIs.
	   *
	   * @fires Player#posterchange
	   * @listens Tech#posterchange
	   * @private
	   */
	
	
	  Player.prototype.handleTechPosterChange_ = function handleTechPosterChange_() {
	    if (!this.poster_ && this.tech_ && this.tech_.poster) {
	      this.poster_ = this.tech_.poster() || '';
	
	      // Let components know the poster has changed
	      this.trigger('posterchange');
	    }
	  };
	
	  /**
	   * Get or set whether or not the controls are showing.
	   *
	   * @fires Player#controlsenabled
	   *
	   * @param {boolean} [bool]
	   *        - true to turn controls on
	   *        - false to turn controls off
	   *
	   * @return {boolean|Player}
	   *         - the current value of controls when getting
	   *         - the player when setting
	   */
	
	
	  Player.prototype.controls = function controls(bool) {
	    if (bool !== undefined) {
	      bool = !!bool;
	
	      // Don't trigger a change event unless it actually changed
	      if (this.controls_ !== bool) {
	        this.controls_ = bool;
	
	        if (this.usingNativeControls()) {
	          this.techCall_('setControls', bool);
	        }
	
	        if (bool) {
	          this.removeClass('vjs-controls-disabled');
	          this.addClass('vjs-controls-enabled');
	          /**
	           * @event Player#controlsenabled
	           * @type {EventTarget~Event}
	           */
	          this.trigger('controlsenabled');
	
	          if (!this.usingNativeControls()) {
	            this.addTechControlsListeners_();
	          }
	        } else {
	          this.removeClass('vjs-controls-enabled');
	          this.addClass('vjs-controls-disabled');
	          /**
	           * @event Player#controlsdisabled
	           * @type {EventTarget~Event}
	           */
	          this.trigger('controlsdisabled');
	
	          if (!this.usingNativeControls()) {
	            this.removeTechControlsListeners_();
	          }
	        }
	      }
	      return this;
	    }
	    return !!this.controls_;
	  };
	
	  /**
	   * Toggle native controls on/off. Native controls are the controls built into
	   * devices (e.g. default iPhone controls), Flash, or other techs
	   * (e.g. Vimeo Controls)
	   * **This should only be set by the current tech, because only the tech knows
	   * if it can support native controls**
	   *
	   * @fires Player#usingnativecontrols
	   * @fires Player#usingcustomcontrols
	   *
	   * @param {boolean} [bool]
	   *        - true to turn native controls on
	   *        - false to turn native controls off
	   *
	   * @return {boolean|Player}
	   *         - the current value of native controls when getting
	   *         - the player when setting
	   */
	
	
	  Player.prototype.usingNativeControls = function usingNativeControls(bool) {
	    if (bool !== undefined) {
	      bool = !!bool;
	
	      // Don't trigger a change event unless it actually changed
	      if (this.usingNativeControls_ !== bool) {
	        this.usingNativeControls_ = bool;
	        if (bool) {
	          this.addClass('vjs-using-native-controls');
	
	          /**
	           * player is using the native device controls
	           *
	           * @event Player#usingnativecontrols
	           * @type {EventTarget~Event}
	           */
	          this.trigger('usingnativecontrols');
	        } else {
	          this.removeClass('vjs-using-native-controls');
	
	          /**
	           * player is using the custom HTML controls
	           *
	           * @event Player#usingcustomcontrols
	           * @type {EventTarget~Event}
	           */
	          this.trigger('usingcustomcontrols');
	        }
	      }
	      return this;
	    }
	    return !!this.usingNativeControls_;
	  };
	
	  /**
	   * Set or get the current MediaError
	   *
	   * @fires Player#error
	   *
	   * @param  {MediaError|string|number} [err]
	   *         A MediaError or a string/number to be turned
	   *         into a MediaError
	   *
	   * @return {MediaError|null|Player}
	   *         - The current MediaError when getting (or null)
	   *         - The player when setting
	   */
	
	
	  Player.prototype.error = function error(err) {
	    if (err === undefined) {
	      return this.error_ || null;
	    }
	
	    // restoring to default
	    if (err === null) {
	      this.error_ = err;
	      this.removeClass('vjs-error');
	      if (this.errorDisplay) {
	        this.errorDisplay.close();
	      }
	      return this;
	    }
	
	    this.error_ = new _mediaError2['default'](err);
	
	    // add the vjs-error classname to the player
	    this.addClass('vjs-error');
	
	    // log the name of the error type and any message
	    // ie8 just logs "[object object]" if you just log the error object
	    _log2['default'].error('(CODE:' + this.error_.code + ' ' + _mediaError2['default'].errorTypes[this.error_.code] + ')', this.error_.message, this.error_);
	
	    /**
	     * @event Player#error
	     * @type {EventTarget~Event}
	     */
	    this.trigger('error');
	
	    return this;
	  };
	
	  /**
	   * Report user activity
	   *
	   * @param {Object} event
	   *        Event object
	   */
	
	
	  Player.prototype.reportUserActivity = function reportUserActivity(event) {
	    this.userActivity_ = true;
	  };
	
	  /**
	   * Get/set if user is active
	   *
	   * @fires Player#useractive
	   * @fires Player#userinactive
	   *
	   * @param {boolean} [bool]
	   *        - true if the user is active
	   *        - false if the user is inactive
	   * @return {boolean|Player}
	   *         - the current value of userActive when getting
	   *         - the player when setting
	   */
	
	
	  Player.prototype.userActive = function userActive(bool) {
	    if (bool !== undefined) {
	      bool = !!bool;
	      if (bool !== this.userActive_) {
	        this.userActive_ = bool;
	        if (bool) {
	          // If the user was inactive and is now active we want to reset the
	          // inactivity timer
	          this.userActivity_ = true;
	          this.removeClass('vjs-user-inactive');
	          this.addClass('vjs-user-active');
	          /**
	           * @event Player#useractive
	           * @type {EventTarget~Event}
	           */
	          this.trigger('useractive');
	        } else {
	          // We're switching the state to inactive manually, so erase any other
	          // activity
	          this.userActivity_ = false;
	
	          // Chrome/Safari/IE have bugs where when you change the cursor it can
	          // trigger a mousemove event. This causes an issue when you're hiding
	          // the cursor when the user is inactive, and a mousemove signals user
	          // activity. Making it impossible to go into inactive mode. Specifically
	          // this happens in fullscreen when we really need to hide the cursor.
	          //
	          // When this gets resolved in ALL browsers it can be removed
	          // https://code.google.com/p/chromium/issues/detail?id=103041
	          if (this.tech_) {
	            this.tech_.one('mousemove', function (e) {
	              e.stopPropagation();
	              e.preventDefault();
	            });
	          }
	
	          this.removeClass('vjs-user-active');
	          this.addClass('vjs-user-inactive');
	          /**
	           * @event Player#userinactive
	           * @type {EventTarget~Event}
	           */
	          this.trigger('userinactive');
	        }
	      }
	      return this;
	    }
	    return this.userActive_;
	  };
	
	  /**
	   * Listen for user activity based on timeout value
	   *
	   * @private
	   */
	
	
	  Player.prototype.listenForUserActivity_ = function listenForUserActivity_() {
	    var mouseInProgress = void 0;
	    var lastMoveX = void 0;
	    var lastMoveY = void 0;
	    var handleActivity = Fn.bind(this, this.reportUserActivity);
	
	    var handleMouseMove = function handleMouseMove(e) {
	      // #1068 - Prevent mousemove spamming
	      // Chrome Bug: https://code.google.com/p/chromium/issues/detail?id=366970
	      if (e.screenX !== lastMoveX || e.screenY !== lastMoveY) {
	        lastMoveX = e.screenX;
	        lastMoveY = e.screenY;
	        handleActivity();
	      }
	    };
	
	    var handleMouseDown = function handleMouseDown() {
	      handleActivity();
	      // For as long as the they are touching the device or have their mouse down,
	      // we consider them active even if they're not moving their finger or mouse.
	      // So we want to continue to update that they are active
	      this.clearInterval(mouseInProgress);
	      // Setting userActivity=true now and setting the interval to the same time
	      // as the activityCheck interval (250) should ensure we never miss the
	      // next activityCheck
	      mouseInProgress = this.setInterval(handleActivity, 250);
	    };
	
	    var handleMouseUp = function handleMouseUp(event) {
	      handleActivity();
	      // Stop the interval that maintains activity if the mouse/touch is down
	      this.clearInterval(mouseInProgress);
	    };
	
	    // Any mouse movement will be considered user activity
	    this.on('mousedown', handleMouseDown);
	    this.on('mousemove', handleMouseMove);
	    this.on('mouseup', handleMouseUp);
	
	    // Listen for keyboard navigation
	    // Shouldn't need to use inProgress interval because of key repeat
	    this.on('keydown', handleActivity);
	    this.on('keyup', handleActivity);
	
	    // Run an interval every 250 milliseconds instead of stuffing everything into
	    // the mousemove/touchmove function itself, to prevent performance degradation.
	    // `this.reportUserActivity` simply sets this.userActivity_ to true, which
	    // then gets picked up by this loop
	    // http://ejohn.org/blog/learning-from-twitter/
	    var inactivityTimeout = void 0;
	
	    this.setInterval(function () {
	      // Check to see if mouse/touch activity has happened
	      if (this.userActivity_) {
	        // Reset the activity tracker
	        this.userActivity_ = false;
	
	        // If the user state was inactive, set the state to active
	        this.userActive(true);
	
	        // Clear any existing inactivity timeout to start the timer over
	        this.clearTimeout(inactivityTimeout);
	
	        var timeout = this.options_.inactivityTimeout;
	
	        if (timeout > 0) {
	          // In <timeout> milliseconds, if no more activity has occurred the
	          // user will be considered inactive
	          inactivityTimeout = this.setTimeout(function () {
	            // Protect against the case where the inactivityTimeout can trigger just
	            // before the next user activity is picked up by the activity check loop
	            // causing a flicker
	            if (!this.userActivity_) {
	              this.userActive(false);
	            }
	          }, timeout);
	        }
	      }
	    }, 250);
	  };
	
	  /**
	   * Gets or sets the current playback rate. A playback rate of
	   * 1.0 represents normal speed and 0.5 would indicate half-speed
	   * playback, for instance.
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-playbackrate
	   *
	   * @param {number} [rate]
	   *       New playback rate to set.
	   *
	   * @return {number|Player}
	   *         - The current playback rate when getting or 1.0
	   *         - the player when setting
	   */
	
	
	  Player.prototype.playbackRate = function playbackRate(rate) {
	    if (rate !== undefined) {
	      this.techCall_('setPlaybackRate', rate);
	      return this;
	    }
	
	    if (this.tech_ && this.tech_.featuresPlaybackRate) {
	      return this.techGet_('playbackRate');
	    }
	    return 1.0;
	  };
	
	  /**
	   * Gets or sets the audio flag
	   *
	   * @param {boolean} bool
	   *        - true signals that this is an audio player
	   *        - false signals that this is not an audio player
	   *
	   * @return {Player|boolean}
	   *         - the current value of isAudio when getting
	   *         - the player if setting
	   */
	
	
	  Player.prototype.isAudio = function isAudio(bool) {
	    if (bool !== undefined) {
	      this.isAudio_ = !!bool;
	      return this;
	    }
	
	    return !!this.isAudio_;
	  };
	
	  /**
	   * Get the {@link VideoTrackList}
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist
	   *
	   * @return {VideoTrackList}
	   *         the current video track list
	   */
	
	
	  Player.prototype.videoTracks = function videoTracks() {
	    // if we have not yet loadTech_, we create videoTracks_
	    // these will be passed to the tech during loading
	    if (!this.tech_) {
	      this.videoTracks_ = this.videoTracks_ || new _videoTrackList2['default']();
	      return this.videoTracks_;
	    }
	
	    return this.tech_.videoTracks();
	  };
	
	  /**
	   * Get the {@link AudioTrackList}
	   *
	   * @see https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist
	   *
	   * @return {AudioTrackList}
	   *         the current audio track list
	   */
	
	
	  Player.prototype.audioTracks = function audioTracks() {
	    // if we have not yet loadTech_, we create videoTracks_
	    // these will be passed to the tech during loading
	    if (!this.tech_) {
	      this.audioTracks_ = this.audioTracks_ || new _audioTrackList2['default']();
	      return this.audioTracks_;
	    }
	
	    return this.tech_.audioTracks();
	  };
	
	  /**
	   * Get the {@link TextTrackList}
	   *
	   * Text tracks are tracks of timed text events.
	   * - Captions: text displayed over the video
	   *             for the hearing impaired
	   * - Subtitles: text displayed over the video for
	   *              those who don't understand language in the video
	   * - Chapters: text displayed in a menu allowing the user to jump
	   *             to particular points (chapters) in the video
	   * - Descriptions: (not yet implemented) audio descriptions that are read back to
	   *                 the user by a screen reading device
	   *
	   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-texttracks
	   *
	   * @return {TextTrackList|undefined}
	   *         The current TextTrackList or undefined if
	   *         or undefined if we don't have a tech
	   */
	
	
	  Player.prototype.textTracks = function textTracks() {
	    // cannot use techGet_ directly because it checks to see whether the tech is ready.
	    // Flash is unlikely to be ready in time but textTracks should still work.
	    if (this.tech_) {
	      return this.tech_.textTracks();
	    }
	  };
	
	  /**
	   * Get the "remote" {@link TextTrackList}. Remote Text Tracks
	   * are tracks that were added to the HTML video element and can
	   * be removed, whereas normal texttracks cannot be removed.
	   *
	   *
	   * @return {TextTrackList|undefined}
	   *         The current remote text track list or undefined
	   *         if we don't have a tech
	   */
	
	
	  Player.prototype.remoteTextTracks = function remoteTextTracks() {
	    if (this.tech_) {
	      return this.tech_.remoteTextTracks();
	    }
	  };
	
	  /**
	   * Get the "remote" {@link HTMLTrackElementList}.
	   * This gives the user all of the DOM elements that match up
	   * with the remote {@link TextTrackList}.
	   *
	   * @return {HTMLTrackElementList}
	   *         The current remote text track list elements
	   *         or undefined if we don't have a tech
	   */
	
	
	  Player.prototype.remoteTextTrackEls = function remoteTextTrackEls() {
	    if (this.tech_) {
	      return this.tech_.remoteTextTrackEls();
	    }
	  };
	
	  /**
	   * A helper method for adding a {@link TextTrack} to our
	   * {@link TextTrackList}.
	   *
	   * In addition to the W3C settings we allow adding additional info through options.
	   *
	   * @see http://www.w3.org/html/wg/drafts/html/master/embedded-content-0.html#dom-media-addtexttrack
	   *
	   * @param {string} [kind]
	   *        the kind of TextTrack you are adding
	   *
	   * @param {string} [label]
	   *        the label to give the TextTrack label
	   *
	   * @param {string} [language]
	   *        the language to set on the TextTrack
	   *
	   * @return {TextTrack|undefined}
	   *         the TextTrack that was added or undefined
	   *         if there is no tech
	   */
	
	
	  Player.prototype.addTextTrack = function addTextTrack(kind, label, language) {
	    if (this.tech_) {
	      return this.tech_.addTextTrack(kind, label, language);
	    }
	  };
	
	  /**
	   * Create a remote {@link TextTrack} and an {@link HTMLTrackElement}. It will
	   * automatically removed from the video element whenever the source changes, unless
	   * manualCleanup is set to false.
	   *
	   * @param {Object} options
	   *        Options to pass to {@link HTMLTrackElement} during creation. See
	   *        {@link HTMLTrackElement} for object properties that you should use.
	   *
	   * @param {boolean} [manualCleanup=true] if set to false, the TextTrack will be
	   *
	   * @return {HTMLTrackElement}
	   *         the HTMLTrackElement that was created and added
	   *         to the HTMLTrackElementList and the remote
	   *         TextTrackList
	   *
	   * @deprecated The default value of the "manualCleanup" parameter will default
	   *             to "false" in upcoming versions of Video.js
	   */
	
	
	  Player.prototype.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    if (this.tech_) {
	      return this.tech_.addRemoteTextTrack(options, manualCleanup);
	    }
	  };
	
	  /**
	   * Remove a remote {@link TextTrack} from the respective
	   * {@link TextTrackList} and {@link HTMLTrackElementList}.
	   *
	   * @param {Object} track
	   *        Remote {@link TextTrack} to remove
	   *
	   * @return {undefined}
	   *         does not return anything
	   */
	
	
	  Player.prototype.removeRemoteTextTrack = function removeRemoteTextTrack() {
	    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	        _ref3$track = _ref3.track,
	        track = _ref3$track === undefined ? arguments[0] : _ref3$track;
	
	    // destructure the input into an object with a track argument, defaulting to arguments[0]
	    // default the whole argument to an empty object if nothing was passed in
	
	    if (this.tech_) {
	      return this.tech_.removeRemoteTextTrack(track);
	    }
	  };
	
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object|undefined}
	   *         An object with supported media playback quality metrics or undefined if there
	   *         is no tech or the tech does not support it.
	   */
	
	
	  Player.prototype.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    return this.techGet_('getVideoPlaybackQuality');
	  };
	
	  /**
	   * Get video width
	   *
	   * @return {number}
	   *         current video width
	   */
	
	
	  Player.prototype.videoWidth = function videoWidth() {
	    return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
	  };
	
	  /**
	   * Get video height
	   *
	   * @return {number}
	   *         current video height
	   */
	
	
	  Player.prototype.videoHeight = function videoHeight() {
	    return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
	  };
	
	  // Methods to add support for
	  // initialTime: function() { return this.techCall_('initialTime'); },
	  // startOffsetTime: function() { return this.techCall_('startOffsetTime'); },
	  // played: function() { return this.techCall_('played'); },
	  // defaultPlaybackRate: function() { return this.techCall_('defaultPlaybackRate'); },
	  // defaultMuted: function() { return this.techCall_('defaultMuted'); }
	
	  /**
	   * The player's language code
	   * NOTE: The language should be set in the player options if you want the
	   * the controls to be built with a specific language. Changing the lanugage
	   * later will not update controls text.
	   *
	   * @param {string} [code]
	   *        the language code to set the player to
	   *
	   * @return {string|Player}
	   *         - The current language code when getting
	   *         - A reference to the player when setting
	   */
	
	
	  Player.prototype.language = function language(code) {
	    if (code === undefined) {
	      return this.language_;
	    }
	
	    this.language_ = String(code).toLowerCase();
	    return this;
	  };
	
	  /**
	   * Get the player's language dictionary
	   * Merge every time, because a newly added plugin might call videojs.addLanguage() at any time
	   * Languages specified directly in the player options have precedence
	   *
	   * @return {Array}
	   *         An array of of supported languages
	   */
	
	
	  Player.prototype.languages = function languages() {
	    return (0, _mergeOptions2['default'])(Player.prototype.options_.languages, this.languages_);
	  };
	
	  /**
	   * returns a JavaScript object reperesenting the current track
	   * information. **DOES not return it as JSON**
	   *
	   * @return {Object}
	   *         Object representing the current of track info
	   */
	
	
	  Player.prototype.toJSON = function toJSON() {
	    var options = (0, _mergeOptions2['default'])(this.options_);
	    var tracks = options.tracks;
	
	    options.tracks = [];
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	
	      // deep merge tracks and null out player so no circular references
	      track = (0, _mergeOptions2['default'])(track);
	      track.player = undefined;
	      options.tracks[i] = track;
	    }
	
	    return options;
	  };
	
	  /**
	   * Creates a simple modal dialog (an instance of the {@link ModalDialog}
	   * component) that immediately overlays the player with arbitrary
	   * content and removes itself when closed.
	   *
	   * @param {string|Function|Element|Array|null} content
	   *        Same as {@link ModalDialog#content}'s param of the same name.
	   *        The most straight-forward usage is to provide a string or DOM
	   *        element.
	   *
	   * @param {Object} [options]
	   *        Extra options which will be passed on to the {@link ModalDialog}.
	   *
	   * @return {ModalDialog}
	   *         the {@link ModalDialog} that was created
	   */
	
	
	  Player.prototype.createModal = function createModal(content, options) {
	    var _this5 = this;
	
	    options = options || {};
	    options.content = content || '';
	
	    var modal = new _modalDialog2['default'](this, options);
	
	    this.addChild(modal);
	    modal.on('dispose', function () {
	      _this5.removeChild(modal);
	    });
	
	    return modal.open();
	  };
	
	  /**
	   * Gets tag settings
	   *
	   * @param {Element} tag
	   *        The player tag
	   *
	   * @return {Object}
	   *         An object containing all of the settings
	   *         for a player tag
	   */
	
	
	  Player.getTagSettings = function getTagSettings(tag) {
	    var baseOptions = {
	      sources: [],
	      tracks: []
	    };
	
	    var tagOptions = Dom.getElAttributes(tag);
	    var dataSetup = tagOptions['data-setup'];
	
	    if (Dom.hasElClass(tag, 'vjs-fluid')) {
	      tagOptions.fluid = true;
	    }
	
	    // Check if data-setup attr exists.
	    if (dataSetup !== null) {
	      // Parse options JSON
	      // If empty string, make it a parsable json object.
	      var _safeParseTuple = (0, _tuple2['default'])(dataSetup || '{}'),
	          err = _safeParseTuple[0],
	          data = _safeParseTuple[1];
	
	      if (err) {
	        _log2['default'].error(err);
	      }
	      (0, _obj.assign)(tagOptions, data);
	    }
	
	    (0, _obj.assign)(baseOptions, tagOptions);
	
	    // Get tag children settings
	    if (tag.hasChildNodes()) {
	      var children = tag.childNodes;
	
	      for (var i = 0, j = children.length; i < j; i++) {
	        var child = children[i];
	        // Change case needed: http://ejohn.org/blog/nodename-case-sensitivity/
	        var childName = child.nodeName.toLowerCase();
	
	        if (childName === 'source') {
	          baseOptions.sources.push(Dom.getElAttributes(child));
	        } else if (childName === 'track') {
	          baseOptions.tracks.push(Dom.getElAttributes(child));
	        }
	      }
	    }
	
	    return baseOptions;
	  };
	
	  /**
	   * Determine wether or not flexbox is supported
	   *
	   * @return {boolean}
	   *         - true if flexbox is supported
	   *         - false if flexbox is not supported
	   */
	
	
	  Player.prototype.flexNotSupported_ = function flexNotSupported_() {
	    var elem = _document2['default'].createElement('i');
	
	    // Note: We don't actually use flexBasis (or flexOrder), but it's one of the more
	    // common flex features that we can rely on when checking for flex support.
	    return !('flexBasis' in elem.style || 'webkitFlexBasis' in elem.style || 'mozFlexBasis' in elem.style || 'msFlexBasis' in elem.style ||
	    // IE10-specific (2012 flex spec)
	    'msFlexOrder' in elem.style);
	  };
	
	  return Player;
	}(_component2['default']);
	
	/**
	 * Global player list
	 *
	 * @type {Object}
	 */
	
	
	Player.players = {};
	
	var navigator = _window2['default'].navigator;
	
	/*
	 * Player instance options, surfaced using options
	 * options = Player.prototype.options_
	 * Make changes in options, not here.
	 *
	 * @type {Object}
	 * @private
	 */
	Player.prototype.options_ = {
	  // Default order of fallback technology
	  techOrder: ['html5', 'flash'],
	  // techOrder: ['flash','html5'],
	
	  html5: {},
	  flash: {},
	
	  // defaultVolume: 0.85,
	  defaultVolume: 0.00,
	
	  // default inactivity timeout
	  inactivityTimeout: 2000,
	
	  // default playback rates
	  playbackRates: [],
	  // Add playback rate selection by adding rates
	  // 'playbackRates': [0.5, 1, 1.5, 2],
	
	  // Included control sets
	  children: ['mediaLoader', 'posterImage', 'textTrackDisplay', 'loadingSpinner', 'bigPlayButton', 'controlBar', 'errorDisplay', 'textTrackSettings'],
	
	  language: navigator && (navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language) || 'en',
	
	  // locales and their language translations
	  languages: {},
	
	  // Default message to show when a video cannot be played.
	  notSupportedMessage: 'No compatible source was found for this media.'
	};
	
	[
	/**
	 * Returns whether or not the player is in the "ended" state.
	 *
	 * @return {Boolean} True if the player is in the ended state, false if not.
	 * @method Player#ended
	 */
	'ended',
	/**
	 * Returns whether or not the player is in the "seeking" state.
	 *
	 * @return {Boolean} True if the player is in the seeking state, false if not.
	 * @method Player#seeking
	 */
	'seeking',
	/**
	 * Returns the TimeRanges of the media that are currently available
	 * for seeking to.
	 *
	 * @return {TimeRanges} the seekable intervals of the media timeline
	 * @method Player#seekable
	 */
	'seekable',
	/**
	 * Returns the current state of network activity for the element, from
	 * the codes in the list below.
	 * - NETWORK_EMPTY (numeric value 0)
	 *   The element has not yet been initialised. All attributes are in
	 *   their initial states.
	 * - NETWORK_IDLE (numeric value 1)
	 *   The element's resource selection algorithm is active and has
	 *   selected a resource, but it is not actually using the network at
	 *   this time.
	 * - NETWORK_LOADING (numeric value 2)
	 *   The user agent is actively trying to download data.
	 * - NETWORK_NO_SOURCE (numeric value 3)
	 *   The element's resource selection algorithm is active, but it has
	 *   not yet found a resource to use.
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#network-states
	 * @return {number} the current network activity state
	 * @method Player#networkState
	 */
	'networkState',
	/**
	 * Returns a value that expresses the current state of the element
	 * with respect to rendering the current playback position, from the
	 * codes in the list below.
	 * - HAVE_NOTHING (numeric value 0)
	 *   No information regarding the media resource is available.
	 * - HAVE_METADATA (numeric value 1)
	 *   Enough of the resource has been obtained that the duration of the
	 *   resource is available.
	 * - HAVE_CURRENT_DATA (numeric value 2)
	 *   Data for the immediate current playback position is available.
	 * - HAVE_FUTURE_DATA (numeric value 3)
	 *   Data for the immediate current playback position is available, as
	 *   well as enough data for the user agent to advance the current
	 *   playback position in the direction of playback.
	 * - HAVE_ENOUGH_DATA (numeric value 4)
	 *   The user agent estimates that enough data is available for
	 *   playback to proceed uninterrupted.
	 *
	 * @see https://html.spec.whatwg.org/multipage/embedded-content.html#dom-media-readystate
	 * @return {number} the current playback rendering state
	 * @method Player#readyState
	 */
	'readyState'].forEach(function (fn) {
	  Player.prototype[fn] = function () {
	    return this.techGet_(fn);
	  };
	});
	
	TECH_EVENTS_RETRIGGER.forEach(function (event) {
	  Player.prototype['handleTech' + (0, _toTitleCase2['default'])(event) + '_'] = function () {
	    return this.trigger(event);
	  };
	});
	
	/**
	 * Fired when the player has initial duration and dimension information
	 *
	 * @event Player#loadedmetadata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the player has downloaded data at the current playback position
	 *
	 * @event Player#loadeddata
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the current playback position has changed *
	 * During playback this is fired every 15-250 milliseconds, depending on the
	 * playback technology in use.
	 *
	 * @event Player#timeupdate
	 * @type {EventTarget~Event}
	 */
	
	/**
	 * Fired when the volume changes
	 *
	 * @event Player#volumechange
	 * @type {EventTarget~Event}
	 */
	
	_component2['default'].registerComponent('Player', Player);
	exports['default'] = Player;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _obj = __webpack_require__(31);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file slider.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The base functionality for a slider. Can be vertical or horizontal.
	 * For instance the volume bar or the seek bar on a video is a slider.
	 *
	 * @extends Component
	 */
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  /**
	   * Create an instance of this class
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function Slider(player, options) {
	    _classCallCheck(this, Slider);
	
	    // Set property names to bar to match with the child Slider class is looking for
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.bar = _this.getChild(_this.options_.barName);
	
	    // Set a horizontal or vertical class on the slider depending on the slider type
	    _this.vertical(!!_this.options_.vertical);
	
	    _this.on('mousedown', _this.handleMouseDown);
	    _this.on('touchstart', _this.handleMouseDown);
	    _this.on('focus', _this.handleFocus);
	    _this.on('blur', _this.handleBlur);
	    _this.on('click', _this.handleClick);
	
	    _this.on(player, 'controlsvisible', _this.update);
	    _this.on(player, _this.playerEvent, _this.update);
	    return _this;
	  }
	
	  /**
	   * Create the `Button`s DOM element.
	   *
	   * @param {string} type
	   *        Type of element to create.
	   *
	   * @param {Object} [props={}]
	   *        List of properties in Object form.
	   *
	   * @param {Object} [attributes={}]
	   *        list of attributes in Object form.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  Slider.prototype.createEl = function createEl(type) {
	    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	    // Add the slider element class to all sub classes
	    props.className = props.className + ' vjs-slider';
	    props = (0, _obj.assign)({
	      tabIndex: 0
	    }, props);
	
	    attributes = (0, _obj.assign)({
	      'role': 'slider',
	      'aria-valuenow': 0,
	      'aria-valuemin': 0,
	      'aria-valuemax': 100,
	      'tabIndex': 0
	    }, attributes);
	
	    return _Component.prototype.createEl.call(this, type, props, attributes);
	  };
	
	  /**
	   * Handle `mousedown` or `touchstart` events on the `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown` or `touchstart` event that triggered this function
	   *
	   * @listens mousedown
	   * @listens touchstart
	   * @fires Slider#slideractive
	   */
	
	
	  Slider.prototype.handleMouseDown = function handleMouseDown(event) {
	    var doc = this.bar.el_.ownerDocument;
	
	    event.preventDefault();
	    Dom.blockTextSelection();
	
	    this.addClass('vjs-sliding');
	    /**
	     * Triggered when the slider is in an active state
	     *
	     * @event Slider#slideractive
	     * @type {EventTarget~Event}
	     */
	    this.trigger('slideractive');
	
	    this.on(doc, 'mousemove', this.handleMouseMove);
	    this.on(doc, 'mouseup', this.handleMouseUp);
	    this.on(doc, 'touchmove', this.handleMouseMove);
	    this.on(doc, 'touchend', this.handleMouseUp);
	
	    this.handleMouseMove(event);
	  };
	
	  /**
	   * Handle the `mousemove`, `touchmove`, and `mousedown` events on this `Slider`.
	   * The `mousemove` and `touchmove` events will only only trigger this function during
	   * `mousedown` and `touchstart`. This is due to {@link Slider#handleMouseDown} and
	   * {@link Slider#handleMouseUp}.
	   *
	   * @param {EventTarget~Event} event
	   *        `mousedown`, `mousemove`, `touchstart`, or `touchmove` event that triggered
	   *        this function
	   *
	   * @listens mousemove
	   * @listens touchmove
	   */
	
	
	  Slider.prototype.handleMouseMove = function handleMouseMove(event) {};
	
	  /**
	   * Handle `mouseup` or `touchend` events on the `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        `mouseup` or `touchend` event that triggered this function.
	   *
	   * @listens touchend
	   * @listens mouseup
	   * @fires Slider#sliderinactive
	   */
	
	
	  Slider.prototype.handleMouseUp = function handleMouseUp() {
	    var doc = this.bar.el_.ownerDocument;
	
	    Dom.unblockTextSelection();
	
	    this.removeClass('vjs-sliding');
	    /**
	     * Triggered when the slider is no longer in an active state.
	     *
	     * @event Slider#sliderinactive
	     * @type {EventTarget~Event}
	     */
	    this.trigger('sliderinactive');
	
	    this.off(doc, 'mousemove', this.handleMouseMove);
	    this.off(doc, 'mouseup', this.handleMouseUp);
	    this.off(doc, 'touchmove', this.handleMouseMove);
	    this.off(doc, 'touchend', this.handleMouseUp);
	
	    this.update();
	  };
	
	  /**
	   * Update the progress bar of the `Slider`.
	   */
	
	
	  Slider.prototype.update = function update() {
	    // In VolumeBar init we have a setTimeout for update that pops and update to the end of the
	    // execution stack. The player is destroyed before then update will cause an error
	    if (!this.el_) {
	      return;
	    }
	
	    // If scrubbing, we could use a cached value to make the handle keep up with the user's mouse.
	    // On HTML5 browsers scrubbing is really smooth, but some flash players are slow, so we might want to utilize this later.
	    // var progress =  (this.player_.scrubbing()) ? this.player_.getCache().currentTime / this.player_.duration() : this.player_.currentTime() / this.player_.duration();
	    var progress = this.getPercent();
	    var bar = this.bar;
	
	    // If there's no bar...
	    if (!bar) {
	      return;
	    }
	
	    // Protect against no duration and other division issues
	    if (typeof progress !== 'number' || progress !== progress || progress < 0 || progress === Infinity) {
	      progress = 0;
	    }
	
	    // Convert to a percentage for setting
	    var percentage = (progress * 100).toFixed(2) + '%';
	
	    // Set the new bar width or height
	    if (this.vertical()) {
	      bar.el().style.height = percentage;
	    } else {
	      bar.el().style.width = percentage;
	    }
	  };
	
	  /**
	   * Calculate distance for slider
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run.
	   *
	   * @return {number}
	   *         The current position of the Slider.
	   *         - postition.x for vertical `Slider`s
	   *         - postition.y for horizontal `Slider`s
	   */
	
	
	  Slider.prototype.calculateDistance = function calculateDistance(event) {
	    var position = Dom.getPointerPosition(this.el_, event);
	
	    if (this.vertical()) {
	      return position.y;
	    }
	    return position.x;
	  };
	
	  /**
	   * Handle a `focus` event on this `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `focus` event that caused this function to run.
	   *
	   * @listens focus
	   */
	
	
	  Slider.prototype.handleFocus = function handleFocus() {
	    this.on(this.bar.el_.ownerDocument, 'keydown', this.handleKeyPress);
	  };
	
	  /**
	   * Handle a `keydown` event on the `Slider`. Watches for left, rigth, up, and down
	   * arrow keys. This function will only be called when the slider has focus. See
	   * {@link Slider#handleFocus} and {@link Slider#handleBlur}.
	   *
	   * @param {EventTarget~Event} event
	   *        the `keydown` event that caused this function to run.
	   *
	   * @listens keydown
	   */
	
	
	  Slider.prototype.handleKeyPress = function handleKeyPress(event) {
	    // Left and Down Arrows
	    if (event.which === 37 || event.which === 40) {
	      event.preventDefault();
	      this.stepBack();
	
	      // Up and Right Arrows
	    } else if (event.which === 38 || event.which === 39) {
	      event.preventDefault();
	      this.stepForward();
	    }
	  };
	
	  /**
	   * Handle a `blur` event on this `Slider`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `blur` event that caused this function to run.
	   *
	   * @listens blur
	   */
	
	  Slider.prototype.handleBlur = function handleBlur() {
	    this.off(this.bar.el_.ownerDocument, 'keydown', this.handleKeyPress);
	  };
	
	  /**
	   * Listener for click events on slider, used to prevent clicks
	   *   from bubbling up to parent elements like button menus.
	   *
	   * @param {Object} event
	   *        Event that caused this object to run
	   */
	
	
	  Slider.prototype.handleClick = function handleClick(event) {
	    event.stopImmediatePropagation();
	    event.preventDefault();
	  };
	
	  /**
	   * Get/set if slider is horizontal for vertical
	   *
	   * @param {boolean} [bool]
	   *        - true if slider is vertical,
	   *        - false is horizontal
	   *
	   * @return {boolean|Slider}
	   *         - true if slider is vertical, and getting
	   *         - false is horizontal, and getting
	   *         - a reference to this object when setting
	   */
	
	
	  Slider.prototype.vertical = function vertical(bool) {
	    if (bool === undefined) {
	      return this.vertical_ || false;
	    }
	
	    this.vertical_ = !!bool;
	
	    if (this.vertical_) {
	      this.addClass('vjs-slider-vertical');
	    } else {
	      this.addClass('vjs-slider-horizontal');
	    }
	
	    return this;
	  };
	
	  return Slider;
	}(_component2['default']);
	
	_component2['default'].registerComponent('Slider', Slider);
	exports['default'] = Slider;


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackList = __webpack_require__(267);
	
	var _trackList2 = _interopRequireDefault(_trackList);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file audio-track-list.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Anywhere we call this function we diverge from the spec
	 * as we only support one enabled audiotrack at a time
	 *
	 * @param {AudioTrackList} list
	 *        list to work on
	 *
	 * @param {AudioTrack} track
	 *        The track to skip
	 *
	 * @private
	 */
	var disableOthers = function disableOthers(list, track) {
	  for (var i = 0; i < list.length; i++) {
	    if (track.id === list[i].id) {
	      continue;
	    }
	    // another audio track is enabled, disable it
	    list[i].enabled = false;
	  }
	};
	
	/**
	 * The current list of {@link AudioTrack} for a media file.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotracklist}
	 * @extends TrackList
	 */
	
	var AudioTrackList = function (_TrackList) {
	  _inherits(AudioTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {AudioTrack[]} [tracks=[]]
	   *        A list of `AudioTrack` to instantiate the list with.
	   */
	  function AudioTrackList() {
	    var _this, _ret;
	
	    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    _classCallCheck(this, AudioTrackList);
	
	    var list = void 0;
	
	    // make sure only 1 track is enabled
	    // sorted from last index to first index
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      if (tracks[i].enabled) {
	        disableOthers(tracks, tracks[i]);
	        break;
	      }
	    }
	
	    // IE8 forces us to implement inheritance ourselves
	    // as it does not support Object.defineProperty properly
	    if (browser.IS_IE8) {
	      list = _document2['default'].createElement('custom');
	      for (var prop in _trackList2['default'].prototype) {
	        if (prop !== 'constructor') {
	          list[prop] = _trackList2['default'].prototype[prop];
	        }
	      }
	      for (var _prop in AudioTrackList.prototype) {
	        if (_prop !== 'constructor') {
	          list[_prop] = AudioTrackList.prototype[_prop];
	        }
	      }
	    }
	
	    list = (_this = _possibleConstructorReturn(this, _TrackList.call(this, tracks, list)), _this);
	    list.changing_ = false;
	
	    return _ret = list, _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Add an {@link AudioTrack} to the `AudioTrackList`.
	   *
	   * @param {AudioTrack} track
	   *        The AudioTrack to add to the list
	   *
	   * @fires Track#addtrack
	   * @private
	   */
	
	
	  AudioTrackList.prototype.addTrack_ = function addTrack_(track) {
	    var _this2 = this;
	
	    if (track.enabled) {
	      disableOthers(this, track);
	    }
	
	    _TrackList.prototype.addTrack_.call(this, track);
	    // native tracks don't have this
	    if (!track.addEventListener) {
	      return;
	    }
	
	    /**
	     * @listens AudioTrack#enabledchange
	     * @fires TrackList#change
	     */
	    track.addEventListener('enabledchange', function () {
	      // when we are disabling other tracks (since we don't support
	      // more than one track at a time) we will set changing_
	      // to true so that we don't trigger additional change events
	      if (_this2.changing_) {
	        return;
	      }
	      _this2.changing_ = true;
	      disableOthers(_this2, track);
	      _this2.changing_ = false;
	      _this2.trigger('change');
	    });
	  };
	
	  /**
	   * Add an {@link AudioTrack} to the `AudioTrackList`.
	   *
	   * @param {AudioTrack} track
	   *        The AudioTrack to add to the list
	   *
	   * @fires Track#addtrack
	   */
	
	
	  AudioTrackList.prototype.addTrack = function addTrack(track) {
	    this.addTrack_(track);
	  };
	
	  /**
	   * Remove an {@link AudioTrack} from the `AudioTrackList`.
	   *
	   * @param {AudioTrack} track
	   *        The AudioTrack to remove from the list
	   *
	   * @fires Track#removetrack
	   */
	
	
	  AudioTrackList.prototype.removeTrack = function removeTrack(track) {
	    _TrackList.prototype.removeTrack_.call(this, track);
	  };
	
	  return AudioTrackList;
	}(_trackList2['default']);
	
	exports['default'] = AudioTrackList;


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackList = __webpack_require__(267);
	
	var _trackList2 = _interopRequireDefault(_trackList);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file video-track-list.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Un-select all other {@link VideoTrack}s that are selected.
	 *
	 * @param {VideoTrackList} list
	 *        list to work on
	 *
	 * @param {VideoTrack} track
	 *        The track to skip
	 *
	 * @private
	 */
	var disableOthers = function disableOthers(list, track) {
	  for (var i = 0; i < list.length; i++) {
	    if (track.id === list[i].id) {
	      continue;
	    }
	    // another video track is enabled, disable it
	    list[i].selected = false;
	  }
	};
	
	/**
	 * The current list of {@link VideoTrack} for a video.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotracklist}
	 * @extends TrackList
	 */
	
	var VideoTrackList = function (_TrackList) {
	  _inherits(VideoTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {VideoTrack[]} [tracks=[]]
	   *        A list of `VideoTrack` to instantiate the list with.
	   */
	  function VideoTrackList() {
	    var _this, _ret;
	
	    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    _classCallCheck(this, VideoTrackList);
	
	    var list = void 0;
	
	    // make sure only 1 track is enabled
	    // sorted from last index to first index
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      if (tracks[i].selected) {
	        disableOthers(tracks, tracks[i]);
	        break;
	      }
	    }
	
	    // IE8 forces us to implement inheritance ourselves
	    // as it does not support Object.defineProperty properly
	    if (browser.IS_IE8) {
	      list = _document2['default'].createElement('custom');
	      for (var prop in _trackList2['default'].prototype) {
	        if (prop !== 'constructor') {
	          list[prop] = _trackList2['default'].prototype[prop];
	        }
	      }
	      for (var _prop in VideoTrackList.prototype) {
	        if (_prop !== 'constructor') {
	          list[_prop] = VideoTrackList.prototype[_prop];
	        }
	      }
	    }
	
	    list = (_this = _possibleConstructorReturn(this, _TrackList.call(this, tracks, list)), _this);
	    list.changing_ = false;
	
	    /**
	     * @member {number} VideoTrackList#selectedIndex
	     *         The current index of the selected {@link VideoTrack`}.
	     */
	    Object.defineProperty(list, 'selectedIndex', {
	      get: function get() {
	        for (var _i = 0; _i < this.length; _i++) {
	          if (this[_i].selected) {
	            return _i;
	          }
	        }
	        return -1;
	      },
	      set: function set() {}
	    });
	
	    return _ret = list, _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Add a {@link VideoTrack} to the `VideoTrackList`.
	   *
	   * @param {VideoTrack} track
	   *        The VideoTrack to add to the list
	   *
	   * @fires TrackList#addtrack
	   * @private
	   */
	
	
	  VideoTrackList.prototype.addTrack_ = function addTrack_(track) {
	    var _this2 = this;
	
	    if (track.selected) {
	      disableOthers(this, track);
	    }
	
	    _TrackList.prototype.addTrack_.call(this, track);
	    // native tracks don't have this
	    if (!track.addEventListener) {
	      return;
	    }
	
	    /**
	     * @listens VideoTrack#selectedchange
	     * @fires TrackList#change
	     */
	    track.addEventListener('selectedchange', function () {
	      if (_this2.changing_) {
	        return;
	      }
	      _this2.changing_ = true;
	      disableOthers(_this2, track);
	      _this2.changing_ = false;
	      _this2.trigger('change');
	    });
	  };
	
	  /**
	   * Add a {@link VideoTrack} to the `VideoTrackList`.
	   *
	   * @param {VideoTrack} track
	   *        The VideoTrack to add to the list
	   *
	   * @fires TrackList#addtrack
	   */
	
	
	  VideoTrackList.prototype.addTrack = function addTrack(track) {
	    this.addTrack_(track);
	  };
	
	  /**
	   * Remove a {@link VideoTrack} to the `VideoTrackList`.
	   *
	   * @param {VideoTrack} track
	   *        The VideoTrack to remove from the list.
	   *
	   * @fires TrackList#removetrack
	   */
	
	
	  VideoTrackList.prototype.removeTrack = function removeTrack(track) {
	    _TrackList.prototype.removeTrack_.call(this, track);
	  };
	
	  return VideoTrackList;
	}(_trackList2['default']);
	
	exports['default'] = VideoTrackList;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.bufferedPercent = bufferedPercent;
	
	var _timeRanges = __webpack_require__(143);
	
	/**
	 * Compute the percentage of the media that has been buffered.
	 *
	 * @param {TimeRange} buffered
	 *        The current `TimeRange` object representing buffered time ranges
	 *
	 * @param {number} duration
	 *        Total duration of the media
	 *
	 * @return {number}
	 *         Percent buffered of the total duration in decimal form.
	 */
	function bufferedPercent(buffered, duration) {
	  var bufferedDuration = 0;
	  var start = void 0;
	  var end = void 0;
	
	  if (!duration) {
	    return 0;
	  }
	
	  if (!buffered || !buffered.length) {
	    buffered = (0, _timeRanges.createTimeRange)(0, 0);
	  }
	
	  for (var i = 0; i < buffered.length; i++) {
	    start = buffered.start(i);
	    end = buffered.end(i);
	
	    // buffered end can be bigger than duration by a very small fraction
	    if (end > duration) {
	      end = duration;
	    }
	
	    bufferedDuration += end - start;
	  }
	
	  return bufferedDuration / duration;
	} /**
	   * @file buffer.js
	   * @module buffer
	   */


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.setTextContent = exports.createStyleElement = undefined;
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Create a DOM syle element given a className for it.
	 *
	 * @param {string} className
	 *        The className to add to the created style element.
	 *
	 * @return {Element}
	 *         The element that was created.
	 */
	var createStyleElement = exports.createStyleElement = function createStyleElement(className) {
	  var style = _document2['default'].createElement('style');
	
	  style.className = className;
	
	  return style;
	};
	
	/**
	 * Add text to a DOM element.
	 *
	 * @param {Element} el
	 *        The Element to add text content to.
	 *
	 * @param {string} content
	 *        The text to add to the element.
	 */
	/**
	 * @file stylesheet.js
	 * @module stylesheet
	 */
	var setTextContent = exports.setTextContent = function setTextContent(el, content) {
	  if (el.styleSheet) {
	    el.styleSheet.cssText = content;
	  } else {
	    el.textContent = content;
	  }
	};


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var window = __webpack_require__(26)
	var isFunction = __webpack_require__(749)
	var parseHeaders = __webpack_require__(813)
	var xtend = __webpack_require__(1035)
	
	module.exports = createXHR
	createXHR.XMLHttpRequest = window.XMLHttpRequest || noop
	createXHR.XDomainRequest = "withCredentials" in (new createXHR.XMLHttpRequest()) ? createXHR.XMLHttpRequest : window.XDomainRequest
	
	forEachArray(["get", "put", "post", "patch", "head", "delete"], function(method) {
	    createXHR[method === "delete" ? "del" : method] = function(uri, options, callback) {
	        options = initParams(uri, options, callback)
	        options.method = method.toUpperCase()
	        return _createXHR(options)
	    }
	})
	
	function forEachArray(array, iterator) {
	    for (var i = 0; i < array.length; i++) {
	        iterator(array[i])
	    }
	}
	
	function isEmpty(obj){
	    for(var i in obj){
	        if(obj.hasOwnProperty(i)) return false
	    }
	    return true
	}
	
	function initParams(uri, options, callback) {
	    var params = uri
	
	    if (isFunction(options)) {
	        callback = options
	        if (typeof uri === "string") {
	            params = {uri:uri}
	        }
	    } else {
	        params = xtend(options, {uri: uri})
	    }
	
	    params.callback = callback
	    return params
	}
	
	function createXHR(uri, options, callback) {
	    options = initParams(uri, options, callback)
	    return _createXHR(options)
	}
	
	function _createXHR(options) {
	    if(typeof options.callback === "undefined"){
	        throw new Error("callback argument missing")
	    }
	
	    var called = false
	    var callback = function cbOnce(err, response, body){
	        if(!called){
	            called = true
	            options.callback(err, response, body)
	        }
	    }
	
	    function readystatechange() {
	        if (xhr.readyState === 4) {
	            loadFunc()
	        }
	    }
	
	    function getBody() {
	        // Chrome with requestType=blob throws errors arround when even testing access to responseText
	        var body = undefined
	
	        if (xhr.response) {
	            body = xhr.response
	        } else {
	            body = xhr.responseText || getXml(xhr)
	        }
	
	        if (isJson) {
	            try {
	                body = JSON.parse(body)
	            } catch (e) {}
	        }
	
	        return body
	    }
	
	    var failureResponse = {
	                body: undefined,
	                headers: {},
	                statusCode: 0,
	                method: method,
	                url: uri,
	                rawRequest: xhr
	            }
	
	    function errorFunc(evt) {
	        clearTimeout(timeoutTimer)
	        if(!(evt instanceof Error)){
	            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error") )
	        }
	        evt.statusCode = 0
	        return callback(evt, failureResponse)
	    }
	
	    // will load the data & process the response in a special response object
	    function loadFunc() {
	        if (aborted) return
	        var status
	        clearTimeout(timeoutTimer)
	        if(options.useXDR && xhr.status===undefined) {
	            //IE8 CORS GET successful response doesn't have a status field, but body is fine
	            status = 200
	        } else {
	            status = (xhr.status === 1223 ? 204 : xhr.status)
	        }
	        var response = failureResponse
	        var err = null
	
	        if (status !== 0){
	            response = {
	                body: getBody(),
	                statusCode: status,
	                method: method,
	                headers: {},
	                url: uri,
	                rawRequest: xhr
	            }
	            if(xhr.getAllResponseHeaders){ //remember xhr can in fact be XDR for CORS in IE
	                response.headers = parseHeaders(xhr.getAllResponseHeaders())
	            }
	        } else {
	            err = new Error("Internal XMLHttpRequest Error")
	        }
	        return callback(err, response, response.body)
	    }
	
	    var xhr = options.xhr || null
	
	    if (!xhr) {
	        if (options.cors || options.useXDR) {
	            xhr = new createXHR.XDomainRequest()
	        }else{
	            xhr = new createXHR.XMLHttpRequest()
	        }
	    }
	
	    var key
	    var aborted
	    var uri = xhr.url = options.uri || options.url
	    var method = xhr.method = options.method || "GET"
	    var body = options.body || options.data || null
	    var headers = xhr.headers = options.headers || {}
	    var sync = !!options.sync
	    var isJson = false
	    var timeoutTimer
	
	    if ("json" in options) {
	        isJson = true
	        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json") //Don't override existing accept header declared by user
	        if (method !== "GET" && method !== "HEAD") {
	            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json") //Don't override existing accept header declared by user
	            body = JSON.stringify(options.json)
	        }
	    }
	
	    xhr.onreadystatechange = readystatechange
	    xhr.onload = loadFunc
	    xhr.onerror = errorFunc
	    // IE9 must have onprogress be set to a unique function.
	    xhr.onprogress = function () {
	        // IE must die
	    }
	    xhr.ontimeout = errorFunc
	    xhr.open(method, uri, !sync, options.username, options.password)
	    //has to be after open
	    if(!sync) {
	        xhr.withCredentials = !!options.withCredentials
	    }
	    // Cannot set timeout with sync request
	    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
	    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
	    if (!sync && options.timeout > 0 ) {
	        timeoutTimer = setTimeout(function(){
	            aborted=true//IE9 may still call readystatechange
	            xhr.abort("timeout")
	            var e = new Error("XMLHttpRequest timeout")
	            e.code = "ETIMEDOUT"
	            errorFunc(e)
	        }, options.timeout )
	    }
	
	    if (xhr.setRequestHeader) {
	        for(key in headers){
	            if(headers.hasOwnProperty(key)){
	                xhr.setRequestHeader(key, headers[key])
	            }
	        }
	    } else if (options.headers && !isEmpty(options.headers)) {
	        throw new Error("Headers cannot be set on an XDomainRequest object")
	    }
	
	    if ("responseType" in options) {
	        xhr.responseType = options.responseType
	    }
	
	    if ("beforeSend" in options &&
	        typeof options.beforeSend === "function"
	    ) {
	        options.beforeSend(xhr)
	    }
	
	    xhr.send(body)
	
	    return xhr
	
	
	}
	
	function getXml(xhr) {
	    if (xhr.responseType === "document") {
	        return xhr.responseXML
	    }
	    var firefoxBugTakenEffect = xhr.status === 204 && xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror"
	    if (xhr.responseType === "" && !firefoxBugTakenEffect) {
	        return xhr.responseXML
	    }
	
	    return null
	}
	
	function noop() {}


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

	;(function () {
	
	  var object =  true ? exports : this; // #8: web workers
	  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	  function InvalidCharacterError(message) {
	    this.message = message;
	  }
	  InvalidCharacterError.prototype = new Error;
	  InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
	  // encoder
	  // [https://gist.github.com/999166] by [https://github.com/nignag]
	  object.btoa || (
	  object.btoa = function (input) {
	    var str = String(input);
	    for (
	      // initialize result and counter
	      var block, charCode, idx = 0, map = chars, output = '';
	      // if the next str index does not exist:
	      //   change the mapping table to "="
	      //   check if d has no fractional digits
	      str.charAt(idx | 0) || (map = '=', idx % 1);
	      // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	      output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	    ) {
	      charCode = str.charCodeAt(idx += 3/4);
	      if (charCode > 0xFF) {
	        throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
	      }
	      block = block << 8 | charCode;
	    }
	    return output;
	  });
	
	  // decoder
	  // [https://gist.github.com/1020396] by [https://github.com/atk]
	  object.atob || (
	  object.atob = function (input) {
	    var str = String(input).replace(/=+$/, '');
	    if (str.length % 4 == 1) {
	      throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
	    }
	    for (
	      // initialize result and counters
	      var bc = 0, bs, buffer, idx = 0, output = '';
	      // get next character
	      buffer = str.charAt(idx++);
	      // character found in table? initialize bit storage and add its ascii value;
	      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
	        // and if not first of each 4 characters,
	        // convert the first 8 bits to one ascii character
	        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
	    ) {
	      // try to find character in table (0-63, not found => -1)
	      buffer = chars.indexOf(buffer);
	    }
	    return output;
	  });
	
	}());


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = makeAction;
	
	var _functions = __webpack_require__(85);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _AltUtils = __webpack_require__(185);
	
	var utils = _interopRequireWildcard(_AltUtils);
	
	var _isPromise = __webpack_require__(750);
	
	var _isPromise2 = _interopRequireDefault(_isPromise);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function makeAction(alt, namespace, name, implementation, obj) {
	  var id = utils.uid(alt._actionsRegistry, String(namespace) + '.' + String(name));
	  alt._actionsRegistry[id] = 1;
	
	  var data = { id: id, namespace: namespace, name: name };
	
	  var dispatch = function dispatch(payload) {
	    return alt.dispatch(id, payload, data);
	  };
	
	  // the action itself
	  var action = function action() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var invocationResult = implementation.apply(obj, args);
	    var actionResult = invocationResult;
	
	    // async functions that return promises should not be dispatched
	    if (invocationResult !== undefined && !(0, _isPromise2['default'])(invocationResult)) {
	      if (fn.isFunction(invocationResult)) {
	        // inner function result should be returned as an action result
	        actionResult = invocationResult(dispatch, alt);
	      } else {
	        dispatch(invocationResult);
	      }
	    }
	
	    if (invocationResult === undefined) {
	      utils.warn('An action was called but nothing was dispatched');
	    }
	
	    return actionResult;
	  };
	  action.defer = function () {
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return setTimeout(function () {
	      return action.apply(null, args);
	    });
	  };
	  action.id = id;
	  action.data = data;
	
	  // ensure each reference is unique in the namespace
	  var container = alt.actions[namespace];
	  var namespaceId = utils.uid(container, name);
	  container[namespaceId] = action;
	
	  // generate a constant
	  var constant = utils.formatAsConstant(namespaceId);
	  container[constant] = id;
	
	  return action;
	}
	module.exports = exports['default'];

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _flux = __webpack_require__(723);
	
	var _StateFunctions = __webpack_require__(439);
	
	var StateFunctions = _interopRequireWildcard(_StateFunctions);
	
	var _functions = __webpack_require__(85);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _store = __webpack_require__(438);
	
	var store = _interopRequireWildcard(_store);
	
	var _AltUtils = __webpack_require__(185);
	
	var utils = _interopRequireWildcard(_AltUtils);
	
	var _actions = __webpack_require__(434);
	
	var _actions2 = _interopRequireDefault(_actions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* global window */
	
	
	var Alt = function () {
	  function Alt() {
	    var config = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Alt);
	
	    this.config = config;
	    this.serialize = config.serialize || JSON.stringify;
	    this.deserialize = config.deserialize || JSON.parse;
	    this.dispatcher = config.dispatcher || new _flux.Dispatcher();
	    this.batchingFunction = config.batchingFunction || function (callback) {
	      return callback();
	    };
	    this.actions = { global: {} };
	    this.stores = {};
	    this.storeTransforms = config.storeTransforms || [];
	    this.trapAsync = false;
	    this._actionsRegistry = {};
	    this._initSnapshot = {};
	    this._lastSnapshot = {};
	  }
	
	  Alt.prototype.dispatch = function () {
	    function dispatch(action, data, details) {
	      var _this = this;
	
	      this.batchingFunction(function () {
	        var id = Math.random().toString(18).substr(2, 16);
	
	        // support straight dispatching of FSA-style actions
	        if (action.hasOwnProperty('type') && action.hasOwnProperty('payload')) {
	          var fsaDetails = {
	            id: action.type,
	            namespace: action.type,
	            name: action.type
	          };
	          return _this.dispatcher.dispatch(utils.fsa(id, action.type, action.payload, fsaDetails));
	        }
	
	        if (action.id && action.dispatch) {
	          return utils.dispatch(id, action, data, _this);
	        }
	
	        return _this.dispatcher.dispatch(utils.fsa(id, action, data, details));
	      });
	    }
	
	    return dispatch;
	  }();
	
	  Alt.prototype.createUnsavedStore = function () {
	    function createUnsavedStore(StoreModel) {
	      var key = StoreModel.displayName || '';
	      store.createStoreConfig(this.config, StoreModel);
	      var Store = store.transformStore(this.storeTransforms, StoreModel);
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return fn.isFunction(Store) ? store.createStoreFromClass.apply(store, [this, Store, key].concat(args)) : store.createStoreFromObject(this, Store, key);
	    }
	
	    return createUnsavedStore;
	  }();
	
	  Alt.prototype.createStore = function () {
	    function createStore(StoreModel, iden) {
	      var key = iden || StoreModel.displayName || StoreModel.name || '';
	      store.createStoreConfig(this.config, StoreModel);
	      var Store = store.transformStore(this.storeTransforms, StoreModel);
	
	      /* istanbul ignore next */
	      if (false) delete this.stores[key];
	
	      if (this.stores[key] || !key) {
	        if (this.stores[key]) {
	          utils.warn('A store named ' + String(key) + ' already exists, double check your store ' + 'names or pass in your own custom identifier for each store');
	        } else {
	          utils.warn('Store name was not specified');
	        }
	
	        key = utils.uid(this.stores, key);
	      }
	
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      var storeInstance = fn.isFunction(Store) ? store.createStoreFromClass.apply(store, [this, Store, key].concat(args)) : store.createStoreFromObject(this, Store, key);
	
	      this.stores[key] = storeInstance;
	      StateFunctions.saveInitialSnapshot(this, key);
	
	      return storeInstance;
	    }
	
	    return createStore;
	  }();
	
	  Alt.prototype.generateActions = function () {
	    function generateActions() {
	      var actions = { name: 'global' };
	
	      for (var _len3 = arguments.length, actionNames = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        actionNames[_key3] = arguments[_key3];
	      }
	
	      return this.createActions(actionNames.reduce(function (obj, action) {
	        obj[action] = utils.dispatchIdentity;
	        return obj;
	      }, actions));
	    }
	
	    return generateActions;
	  }();
	
	  Alt.prototype.createAction = function () {
	    function createAction(name, implementation, obj) {
	      return (0, _actions2['default'])(this, 'global', name, implementation, obj);
	    }
	
	    return createAction;
	  }();
	
	  Alt.prototype.createActions = function () {
	    function createActions(ActionsClass) {
	      var _this3 = this;
	
	      var exportObj = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	      var actions = {};
	      var key = utils.uid(this._actionsRegistry, ActionsClass.displayName || ActionsClass.name || 'Unknown');
	
	      if (fn.isFunction(ActionsClass)) {
	        fn.assign(actions, utils.getPrototypeChain(ActionsClass));
	
	        var ActionsGenerator = function (_ActionsClass) {
	          _inherits(ActionsGenerator, _ActionsClass);
	
	          function ActionsGenerator() {
	            _classCallCheck(this, ActionsGenerator);
	
	            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	              args[_key5] = arguments[_key5];
	            }
	
	            return _possibleConstructorReturn(this, _ActionsClass.call.apply(_ActionsClass, [this].concat(args)));
	          }
	
	          ActionsGenerator.prototype.generateActions = function () {
	            function generateActions() {
	              for (var _len6 = arguments.length, actionNames = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	                actionNames[_key6] = arguments[_key6];
	              }
	
	              actionNames.forEach(function (actionName) {
	                actions[actionName] = utils.dispatchIdentity;
	              });
	            }
	
	            return generateActions;
	          }();
	
	          return ActionsGenerator;
	        }(ActionsClass);
	
	        for (var _len4 = arguments.length, argsForConstructor = Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
	          argsForConstructor[_key4 - 2] = arguments[_key4];
	        }
	
	        fn.assign(actions, new (Function.prototype.bind.apply(ActionsGenerator, [null].concat(argsForConstructor)))());
	      } else {
	        fn.assign(actions, ActionsClass);
	      }
	
	      this.actions[key] = this.actions[key] || {};
	
	      fn.eachObject(function (actionName, action) {
	        if (!fn.isFunction(action)) {
	          exportObj[actionName] = action;
	          return;
	        }
	
	        // create the action
	        exportObj[actionName] = (0, _actions2['default'])(_this3, key, actionName, action, exportObj);
	
	        // generate a constant
	        var constant = utils.formatAsConstant(actionName);
	        exportObj[constant] = exportObj[actionName].id;
	      }, [actions]);
	
	      return exportObj;
	    }
	
	    return createActions;
	  }();
	
	  Alt.prototype.takeSnapshot = function () {
	    function takeSnapshot() {
	      for (var _len7 = arguments.length, storeNames = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        storeNames[_key7] = arguments[_key7];
	      }
	
	      var state = StateFunctions.snapshot(this, storeNames);
	      fn.assign(this._lastSnapshot, state);
	      return this.serialize(state);
	    }
	
	    return takeSnapshot;
	  }();
	
	  Alt.prototype.rollback = function () {
	    function rollback() {
	      StateFunctions.setAppState(this, this.serialize(this._lastSnapshot), function (storeInst) {
	        storeInst.lifecycle('rollback');
	        storeInst.emitChange();
	      });
	    }
	
	    return rollback;
	  }();
	
	  Alt.prototype.recycle = function () {
	    function recycle() {
	      for (var _len8 = arguments.length, storeNames = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
	        storeNames[_key8] = arguments[_key8];
	      }
	
	      var initialSnapshot = storeNames.length ? StateFunctions.filterSnapshots(this, this._initSnapshot, storeNames) : this._initSnapshot;
	
	      StateFunctions.setAppState(this, this.serialize(initialSnapshot), function (storeInst) {
	        storeInst.lifecycle('init');
	        storeInst.emitChange();
	      });
	    }
	
	    return recycle;
	  }();
	
	  Alt.prototype.flush = function () {
	    function flush() {
	      var state = this.serialize(StateFunctions.snapshot(this));
	      this.recycle();
	      return state;
	    }
	
	    return flush;
	  }();
	
	  Alt.prototype.bootstrap = function () {
	    function bootstrap(data) {
	      StateFunctions.setAppState(this, data, function (storeInst, state) {
	        storeInst.lifecycle('bootstrap', state);
	        storeInst.emitChange();
	      });
	    }
	
	    return bootstrap;
	  }();
	
	  Alt.prototype.prepare = function () {
	    function prepare(storeInst, payload) {
	      var data = {};
	      if (!storeInst.displayName) {
	        throw new ReferenceError('Store provided does not have a name');
	      }
	      data[storeInst.displayName] = payload;
	      return this.serialize(data);
	    }
	
	    return prepare;
	  }();
	
	  // Instance type methods for injecting alt into your application as context
	
	  Alt.prototype.addActions = function () {
	    function addActions(name, ActionsClass) {
	      for (var _len9 = arguments.length, args = Array(_len9 > 2 ? _len9 - 2 : 0), _key9 = 2; _key9 < _len9; _key9++) {
	        args[_key9 - 2] = arguments[_key9];
	      }
	
	      this.actions[name] = Array.isArray(ActionsClass) ? this.generateActions.apply(this, ActionsClass) : this.createActions.apply(this, [ActionsClass].concat(args));
	    }
	
	    return addActions;
	  }();
	
	  Alt.prototype.addStore = function () {
	    function addStore(name, StoreModel) {
	      for (var _len10 = arguments.length, args = Array(_len10 > 2 ? _len10 - 2 : 0), _key10 = 2; _key10 < _len10; _key10++) {
	        args[_key10 - 2] = arguments[_key10];
	      }
	
	      this.createStore.apply(this, [StoreModel, name].concat(args));
	    }
	
	    return addStore;
	  }();
	
	  Alt.prototype.getActions = function () {
	    function getActions(name) {
	      return this.actions[name];
	    }
	
	    return getActions;
	  }();
	
	  Alt.prototype.getStore = function () {
	    function getStore(name) {
	      return this.stores[name];
	    }
	
	    return getStore;
	  }();
	
	  Alt.debug = function () {
	    function debug(name, alt, win) {
	      var key = 'alt.js.org';
	      var context = win;
	      if (!context && typeof window !== 'undefined') {
	        context = window;
	      }
	      if (typeof context !== 'undefined') {
	        context[key] = context[key] || [];
	        context[key].push({ name: name, alt: alt });
	      }
	      return alt;
	    }
	
	    return debug;
	  }();
	
	  return Alt;
	}();
	
	exports['default'] = Alt;
	module.exports = exports['default'];

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _functions = __webpack_require__(85);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _transmitter = __webpack_require__(415);
	
	var _transmitter2 = _interopRequireDefault(_transmitter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AltStore = function () {
	  function AltStore(alt, model, state, StoreModel) {
	    var _this = this;
	
	    _classCallCheck(this, AltStore);
	
	    var lifecycleEvents = model.lifecycleEvents;
	    this.transmitter = (0, _transmitter2['default'])();
	    this.lifecycle = function (event, x) {
	      if (lifecycleEvents[event]) lifecycleEvents[event].publish(x);
	    };
	    this.state = state;
	
	    this.alt = alt;
	    this.preventDefault = false;
	    this.displayName = model.displayName;
	    this.boundListeners = model.boundListeners;
	    this.StoreModel = StoreModel;
	    this.reduce = model.reduce || function (x) {
	      return x;
	    };
	    this.subscriptions = [];
	
	    var output = model.output || function (x) {
	      return x;
	    };
	
	    this.emitChange = function () {
	      return _this.transmitter.publish(output(_this.state));
	    };
	
	    var handleDispatch = function handleDispatch(f, payload) {
	      try {
	        return f();
	      } catch (e) {
	        if (model.handlesOwnErrors) {
	          _this.lifecycle('error', {
	            error: e,
	            payload: payload,
	            state: _this.state
	          });
	          return false;
	        }
	
	        throw e;
	      }
	    };
	
	    fn.assign(this, model.publicMethods);
	
	    // Register dispatcher
	    this.dispatchToken = alt.dispatcher.register(function (payload) {
	      _this.preventDefault = false;
	
	      _this.lifecycle('beforeEach', {
	        payload: payload,
	        state: _this.state
	      });
	
	      var actionHandlers = model.actionListeners[payload.action];
	
	      if (actionHandlers || model.otherwise) {
	        var result = void 0;
	
	        if (actionHandlers) {
	          result = handleDispatch(function () {
	            return actionHandlers.filter(Boolean).every(function (handler) {
	              return handler.call(model, payload.data, payload.action) !== false;
	            });
	          }, payload);
	        } else {
	          result = handleDispatch(function () {
	            return model.otherwise(payload.data, payload.action);
	          }, payload);
	        }
	
	        if (result !== false && !_this.preventDefault) _this.emitChange();
	      }
	
	      if (model.reduce) {
	        handleDispatch(function () {
	          var value = model.reduce(_this.state, payload);
	          if (value !== undefined) _this.state = value;
	        }, payload);
	        if (!_this.preventDefault) _this.emitChange();
	      }
	
	      _this.lifecycle('afterEach', {
	        payload: payload,
	        state: _this.state
	      });
	    });
	
	    this.lifecycle('init');
	  }
	
	  AltStore.prototype.listen = function () {
	    function listen(cb) {
	      var _this2 = this;
	
	      if (!fn.isFunction(cb)) throw new TypeError('listen expects a function');
	
	      var _transmitter$subscrib = this.transmitter.subscribe(cb);
	
	      var dispose = _transmitter$subscrib.dispose;
	
	      this.subscriptions.push({ cb: cb, dispose: dispose });
	      return function () {
	        _this2.lifecycle('unlisten');
	        dispose();
	      };
	    }
	
	    return listen;
	  }();
	
	  AltStore.prototype.unlisten = function () {
	    function unlisten(cb) {
	      this.lifecycle('unlisten');
	      this.subscriptions.filter(function (subscription) {
	        return subscription.cb === cb;
	      }).forEach(function (subscription) {
	        return subscription.dispose();
	      });
	    }
	
	    return unlisten;
	  }();
	
	  AltStore.prototype.getState = function () {
	    function getState() {
	      return this.StoreModel.config.getState.call(this, this.state);
	    }
	
	    return getState;
	  }();
	
	  return AltStore;
	}();
	
	exports['default'] = AltStore;
	module.exports = exports['default'];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _transmitter = __webpack_require__(415);
	
	var _transmitter2 = _interopRequireDefault(_transmitter);
	
	var _functions = __webpack_require__(85);
	
	var fn = _interopRequireWildcard(_functions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var StoreMixin = {
	  waitFor: function () {
	    function waitFor() {
	      for (var _len = arguments.length, sources = Array(_len), _key = 0; _key < _len; _key++) {
	        sources[_key] = arguments[_key];
	      }
	
	      if (!sources.length) {
	        throw new ReferenceError('Dispatch tokens not provided');
	      }
	
	      var sourcesArray = sources;
	      if (sources.length === 1) {
	        sourcesArray = Array.isArray(sources[0]) ? sources[0] : sources;
	      }
	
	      var tokens = sourcesArray.map(function (source) {
	        return source.dispatchToken || source;
	      });
	
	      this.dispatcher.waitFor(tokens);
	    }
	
	    return waitFor;
	  }(),
	  exportAsync: function () {
	    function exportAsync(asyncMethods) {
	      this.registerAsync(asyncMethods);
	    }
	
	    return exportAsync;
	  }(),
	  registerAsync: function () {
	    function registerAsync(asyncDef) {
	      var _this = this;
	
	      var loadCounter = 0;
	
	      var asyncMethods = fn.isFunction(asyncDef) ? asyncDef(this.alt) : asyncDef;
	
	      var toExport = Object.keys(asyncMethods).reduce(function (publicMethods, methodName) {
	        var desc = asyncMethods[methodName];
	        var spec = fn.isFunction(desc) ? desc(_this) : desc;
	
	        var validHandlers = ['success', 'error', 'loading'];
	        validHandlers.forEach(function (handler) {
	          if (spec[handler] && !spec[handler].id) {
	            throw new Error(String(handler) + ' handler must be an action function');
	          }
	        });
	
	        publicMethods[methodName] = function () {
	          for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	          }
	
	          var state = _this.getInstance().getState();
	          var value = spec.local && spec.local.apply(spec, [state].concat(args));
	          var shouldFetch = spec.shouldFetch ? spec.shouldFetch.apply(spec, [state].concat(args))
	          /*eslint-disable*/
	          : value == null;
	          /*eslint-enable*/
	          var intercept = spec.interceptResponse || function (x) {
	            return x;
	          };
	
	          var makeActionHandler = function () {
	            function makeActionHandler(action, isError) {
	              return function (x) {
	                var fire = function () {
	                  function fire() {
	                    loadCounter -= 1;
	                    action(intercept(x, action, args));
	                    if (isError) throw x;
	                    return x;
	                  }
	
	                  return fire;
	                }();
	                return _this.alt.trapAsync ? function () {
	                  return fire();
	                } : fire();
	              };
	            }
	
	            return makeActionHandler;
	          }();
	
	          // if we don't have it in cache then fetch it
	          if (shouldFetch) {
	            loadCounter += 1;
	            /* istanbul ignore else */
	            if (spec.loading) spec.loading(intercept(null, spec.loading, args));
	            return spec.remote.apply(spec, [state].concat(args)).then(makeActionHandler(spec.success), makeActionHandler(spec.error, 1));
	          }
	
	          // otherwise emit the change now
	          _this.emitChange();
	          return value;
	        };
	
	        return publicMethods;
	      }, {});
	
	      this.exportPublicMethods(toExport);
	      this.exportPublicMethods({
	        isLoading: function () {
	          function isLoading() {
	            return loadCounter > 0;
	          }
	
	          return isLoading;
	        }()
	      });
	    }
	
	    return registerAsync;
	  }(),
	  exportPublicMethods: function () {
	    function exportPublicMethods(methods) {
	      var _this2 = this;
	
	      fn.eachObject(function (methodName, value) {
	        if (!fn.isFunction(value)) {
	          throw new TypeError('exportPublicMethods expects a function');
	        }
	
	        _this2.publicMethods[methodName] = value;
	      }, [methods]);
	    }
	
	    return exportPublicMethods;
	  }(),
	  emitChange: function () {
	    function emitChange() {
	      this.getInstance().emitChange();
	    }
	
	    return emitChange;
	  }(),
	  on: function () {
	    function on(lifecycleEvent, handler) {
	      if (lifecycleEvent === 'error') this.handlesOwnErrors = true;
	      var bus = this.lifecycleEvents[lifecycleEvent] || (0, _transmitter2['default'])();
	      this.lifecycleEvents[lifecycleEvent] = bus;
	      return bus.subscribe(handler.bind(this));
	    }
	
	    return on;
	  }(),
	  bindAction: function () {
	    function bindAction(symbol, handler) {
	      if (!symbol) {
	        throw new ReferenceError('Invalid action reference passed in');
	      }
	      if (!fn.isFunction(handler)) {
	        throw new TypeError('bindAction expects a function');
	      }
	
	      // You can pass in the constant or the function itself
	      var key = symbol.id ? symbol.id : symbol;
	      this.actionListeners[key] = this.actionListeners[key] || [];
	      this.actionListeners[key].push(handler.bind(this));
	      this.boundListeners.push(key);
	    }
	
	    return bindAction;
	  }(),
	  bindActions: function () {
	    function bindActions(actions) {
	      var _this3 = this;
	
	      fn.eachObject(function (action, symbol) {
	        var matchFirstCharacter = /./;
	        var assumedEventHandler = action.replace(matchFirstCharacter, function (x) {
	          return 'on' + String(x[0].toUpperCase());
	        });
	
	        if (_this3[action] && _this3[assumedEventHandler]) {
	          // If you have both action and onAction
	          throw new ReferenceError('You have multiple action handlers bound to an action: ' + (String(action) + ' and ' + String(assumedEventHandler)));
	        }
	
	        var handler = _this3[action] || _this3[assumedEventHandler];
	        if (handler) {
	          _this3.bindAction(symbol, handler);
	        }
	      }, [actions]);
	    }
	
	    return bindActions;
	  }(),
	  bindListeners: function () {
	    function bindListeners(obj) {
	      var _this4 = this;
	
	      fn.eachObject(function (methodName, symbol) {
	        var listener = _this4[methodName];
	
	        if (!listener) {
	          throw new ReferenceError(String(methodName) + ' defined but does not exist in ' + String(_this4.displayName));
	        }
	
	        if (Array.isArray(symbol)) {
	          symbol.forEach(function (action) {
	            _this4.bindAction(action, listener);
	          });
	        } else {
	          _this4.bindAction(symbol, listener);
	        }
	      }, [obj]);
	    }
	
	    return bindListeners;
	  }()
	};
	
	exports['default'] = StoreMixin;
	module.exports = exports['default'];

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createStoreConfig = createStoreConfig;
	exports.transformStore = transformStore;
	exports.createStoreFromObject = createStoreFromObject;
	exports.createStoreFromClass = createStoreFromClass;
	
	var _AltUtils = __webpack_require__(185);
	
	var utils = _interopRequireWildcard(_AltUtils);
	
	var _functions = __webpack_require__(85);
	
	var fn = _interopRequireWildcard(_functions);
	
	var _AltStore = __webpack_require__(436);
	
	var _AltStore2 = _interopRequireDefault(_AltStore);
	
	var _StoreMixin = __webpack_require__(437);
	
	var _StoreMixin2 = _interopRequireDefault(_StoreMixin);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function doSetState(store, storeInstance, state) {
	  if (!state) {
	    return;
	  }
	
	  var config = storeInstance.StoreModel.config;
	
	
	  var nextState = fn.isFunction(state) ? state(storeInstance.state) : state;
	
	  storeInstance.state = config.setState.call(store, storeInstance.state, nextState);
	
	  if (!store.alt.dispatcher.isDispatching()) {
	    store.emitChange();
	  }
	}
	
	function createPrototype(proto, alt, key, extras) {
	  return fn.assign(proto, _StoreMixin2['default'], {
	    displayName: key,
	    alt: alt,
	    dispatcher: alt.dispatcher,
	    preventDefault: function () {
	      function preventDefault() {
	        this.getInstance().preventDefault = true;
	      }
	
	      return preventDefault;
	    }(),
	
	    boundListeners: [],
	    lifecycleEvents: {},
	    actionListeners: {},
	    publicMethods: {},
	    handlesOwnErrors: false
	  }, extras);
	}
	
	function createStoreConfig(globalConfig, StoreModel) {
	  StoreModel.config = fn.assign({
	    getState: function () {
	      function getState(state) {
	        if (Array.isArray(state)) {
	          return state.slice();
	        } else if (fn.isMutableObject(state)) {
	          return fn.assign({}, state);
	        }
	
	        return state;
	      }
	
	      return getState;
	    }(),
	    setState: function () {
	      function setState(currentState, nextState) {
	        if (fn.isMutableObject(nextState)) {
	          return fn.assign(currentState, nextState);
	        }
	        return nextState;
	      }
	
	      return setState;
	    }()
	  }, globalConfig, StoreModel.config);
	}
	
	function transformStore(transforms, StoreModel) {
	  return transforms.reduce(function (Store, transform) {
	    return transform(Store);
	  }, StoreModel);
	}
	
	function createStoreFromObject(alt, StoreModel, key) {
	  var storeInstance = void 0;
	
	  var StoreProto = createPrototype({}, alt, key, fn.assign({
	    getInstance: function () {
	      function getInstance() {
	        return storeInstance;
	      }
	
	      return getInstance;
	    }(),
	    setState: function () {
	      function setState(nextState) {
	        doSetState(this, storeInstance, nextState);
	      }
	
	      return setState;
	    }()
	  }, StoreModel));
	
	  // bind the store listeners
	  /* istanbul ignore else */
	  if (StoreProto.bindListeners) {
	    _StoreMixin2['default'].bindListeners.call(StoreProto, StoreProto.bindListeners);
	  }
	  /* istanbul ignore else */
	  if (StoreProto.observe) {
	    _StoreMixin2['default'].bindListeners.call(StoreProto, StoreProto.observe(alt));
	  }
	
	  // bind the lifecycle events
	  /* istanbul ignore else */
	  if (StoreProto.lifecycle) {
	    fn.eachObject(function (eventName, event) {
	      _StoreMixin2['default'].on.call(StoreProto, eventName, event);
	    }, [StoreProto.lifecycle]);
	  }
	
	  // create the instance and fn.assign the public methods to the instance
	  storeInstance = fn.assign(new _AltStore2['default'](alt, StoreProto, StoreProto.state !== undefined ? StoreProto.state : {}, StoreModel), StoreProto.publicMethods, {
	    displayName: key,
	    config: StoreModel.config
	  });
	
	  return storeInstance;
	}
	
	function createStoreFromClass(alt, StoreModel, key) {
	  var storeInstance = void 0;
	  var config = StoreModel.config;
	
	  // Creating a class here so we don't overload the provided store's
	  // prototype with the mixin behaviour and I'm extending from StoreModel
	  // so we can inherit any extensions from the provided store.
	
	  var Store = function (_StoreModel) {
	    _inherits(Store, _StoreModel);
	
	    function Store() {
	      _classCallCheck(this, Store);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _possibleConstructorReturn(this, _StoreModel.call.apply(_StoreModel, [this].concat(args)));
	    }
	
	    return Store;
	  }(StoreModel);
	
	  createPrototype(Store.prototype, alt, key, {
	    type: 'AltStore',
	    getInstance: function () {
	      function getInstance() {
	        return storeInstance;
	      }
	
	      return getInstance;
	    }(),
	    setState: function () {
	      function setState(nextState) {
	        doSetState(this, storeInstance, nextState);
	      }
	
	      return setState;
	    }()
	  });
	
	  for (var _len = arguments.length, argsForClass = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    argsForClass[_key - 3] = arguments[_key];
	  }
	
	  var store = new (Function.prototype.bind.apply(Store, [null].concat(argsForClass)))();
	
	  /* istanbul ignore next */
	  if (config.bindListeners) store.bindListeners(config.bindListeners);
	  /* istanbul ignore next */
	  if (config.datasource) store.registerAsync(config.datasource);
	
	  storeInstance = fn.assign(new _AltStore2['default'](alt, store, store.state !== undefined ? store.state : store, StoreModel), utils.getInternalMethods(StoreModel), config.publicMethods, { displayName: key });
	
	  return storeInstance;
	}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setAppState = setAppState;
	exports.snapshot = snapshot;
	exports.saveInitialSnapshot = saveInitialSnapshot;
	exports.filterSnapshots = filterSnapshots;
	
	var _functions = __webpack_require__(85);
	
	var fn = _interopRequireWildcard(_functions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function setAppState(instance, data, onStore) {
	  var obj = instance.deserialize(data);
	  fn.eachObject(function (key, value) {
	    var store = instance.stores[key];
	    if (store) {
	      (function () {
	        var config = store.StoreModel.config;
	
	        var state = store.state;
	        if (config.onDeserialize) obj[key] = config.onDeserialize(value) || value;
	        if (fn.isMutableObject(state)) {
	          fn.eachObject(function (k) {
	            return delete state[k];
	          }, [state]);
	          fn.assign(state, obj[key]);
	        } else {
	          store.state = obj[key];
	        }
	        onStore(store, store.state);
	      })();
	    }
	  }, [obj]);
	}
	
	function snapshot(instance) {
	  var storeNames = arguments.length <= 1 || arguments[1] === undefined ? [] : arguments[1];
	
	  var stores = storeNames.length ? storeNames : Object.keys(instance.stores);
	  return stores.reduce(function (obj, storeHandle) {
	    var storeName = storeHandle.displayName || storeHandle;
	    var store = instance.stores[storeName];
	    var config = store.StoreModel.config;
	
	    store.lifecycle('snapshot');
	    var customSnapshot = config.onSerialize && config.onSerialize(store.state);
	    obj[storeName] = customSnapshot ? customSnapshot : store.getState();
	    return obj;
	  }, {});
	}
	
	function saveInitialSnapshot(instance, key) {
	  var state = instance.deserialize(instance.serialize(instance.stores[key].state));
	  instance._initSnapshot[key] = state;
	  instance._lastSnapshot[key] = state;
	}
	
	function filterSnapshots(instance, state, stores) {
	  return stores.reduce(function (obj, store) {
	    var storeName = store.displayName || store;
	    if (!state[storeName]) {
	      throw new ReferenceError(String(storeName) + ' is not a valid store');
	    }
	    obj[storeName] = state[storeName];
	    return obj;
	  }, {});
	}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var AppActions = function AppActions() {
	    _classCallCheck(this, AppActions);
	
	    this.generateActions('logout', 'loginUserSuccess', 'logoutUserSuccess', 'updatePasswordSuccess', 'acceptTermsSuccess', 'resetPasswordSuccess', 'registerUserSuccess', 'confirmEmailSuccess', 'loadAccountDataSuccess', 'updateAccountDataSuccess', 'loadTermsSuccess', 'loadPrivacySuccess', 'loadImprintSuccess', 'toggleOffcanvas', 'onError', 'clearError', 'noop', 'bootstrapRegisterFormSuccess');
	};
	
	exports['default'] = AppActions;
	module.exports = exports['default'];

/***/ }),
/* 441 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var BasketActions = function BasketActions() {
	    _classCallCheck(this, BasketActions);
	
	    this.generateActions('loadBasketsSuccess', 'loadBasketSuccess', 'addToBasketSuccess', 'loadSingleBasketsSuccess', 'createBasketSuccess', 'editBasketNameSuccess', 'deleteBasketItemSuccess', 'shareBasketsSuccess', 'requestLicensingSuccess', 'toggleDownload', 'toggleDownloadAll', 'toggleLicensing', 'toggleLicensingAll', 'updateLicensingUsageText', 'setSingleBasket', 'deleteBasketsBySelection', 'deleteBasketsSuccess', 'toggleBasketSelection', 'resetShareUrl', 'loadError', 'setShareUrlItem', 'excelSearch', 'excelSearchSuccess', 'excelSearchError', 'clearErrorData');
	};
	
	exports['default'] = BasketActions;
	module.exports = exports['default'];

/***/ }),
/* 442 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var MediaActions = function MediaActions() {
	    _classCallCheck(this, MediaActions);
	
	    this.generateActions('loadMediaSuccess', 'loadMediaModalsSuccess', 'loadMediaError', 'loadLandingPageSuccess', 'loadLandingPageError', 'checkQuotaSuccess', 'checkQuotaError', 'toggleItemSelection', 'toggleFilter', 'updateFilterParams', 'toggleExpand', 'toggleBasket', 'toggleAllItemSelection', 'removeAllItemSelection', 'toggleItemAddedNotification', 'clearSearch', 'clearQuery', 'closeFilters', 'closeBasket', 'removeSelectedFilter', 'setNextElement', 'setPreviousElement', 'openCurrentMedia', 'fetchPreviousPage', 'fetchNextPage', 'cloneMediaAndMetaToModalData', 'cloneMediaAndMetaToModalDataFromBasket', 'cloneMediaAndMetaToModalDataFromShared', 'cloneSlotDefinitionsToModalDataFromBasket', 'cloneSlotDefinitionsToModalDataFromShared', 'setLayout');
	};
	
	exports['default'] = MediaActions;
	module.exports = exports['default'];

/***/ }),
/* 443 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var ModalActions = function ModalActions() {
	    _classCallCheck(this, ModalActions);
	
	    this.generateActions('openModal', 'closeModals', 'activateLoading', 'disableLoading', 'openMediaModal', 'openInstantDownloadModal', 'openInstantDownloadAllModal', 'confirmModal', 'toggleDownload', 'setSelectedItemId', 'toggleDownloadAll', 'generateDownload', 'openWatermarkModal', 'setModalInModal', 'setSelectedForFileKey', 'openExcelSearchModal');
	};
	
	exports['default'] = ModalActions;
	module.exports = exports['default'];

/***/ }),
/* 444 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var NotificationActions = function NotificationActions() {
	    _classCallCheck(this, NotificationActions);
	
	    this.generateActions('addSuccessNotification', 'addErrorNotification', 'removeNotification');
	};
	
	exports['default'] = NotificationActions;
	module.exports = exports['default'];

/***/ }),
/* 445 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var RequestActions = function RequestActions() {
	    _classCallCheck(this, RequestActions);
	
	    this.generateActions('loadRequestsSuccess', 'loadError');
	};
	
	exports['default'] = RequestActions;
	module.exports = exports['default'];

/***/ }),
/* 446 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var ShareActions = function ShareActions() {
	    _classCallCheck(this, ShareActions);
	
	    this.generateActions('loadShareSuccess', 'loadError', 'requestAccessSuccess', 'requestAccessError', 'toggleItemSelection', 'toggleAllItems', 'toggleDownloadAll', 'downloadSuccess', 'downloadError');
	};
	
	exports['default'] = ShareActions;
	module.exports = exports['default'];

/***/ }),
/* 447 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var TranslationActions = function TranslationActions() {
	    _classCallCheck(this, TranslationActions);
	
	    this.generateActions('addLocaleData', 'addMessages', 'setLanguage', 'setAvailableLanguages');
	};
	
	exports['default'] = TranslationActions;
	module.exports = exports['default'];

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var BasketEmpty = _react2['default'].createClass({
	    displayName: 'BasketEmpty',
	    mixins: [],
	    propTypes: {},
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'page baskets' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'headerbar headerbar--empty' },
	                _react2['default'].createElement('div', { className: 'container--centered' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'basket__container container--centered' },
	                _react2['default'].createElement(
	                    'h4',
	                    null,
	                    _utilsFlux2['default'].t('no_basket_selected')
	                ),
	                _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: 'landing-page', className: 'sidebar__back' },
	                    _react2['default'].createElement('i', { className: 'chevron-left' }),
	                    _utilsFlux2['default'].t('back_to_home')
	                )
	            )
	        );
	    }
	});
	
	module.exports = BasketEmpty;

/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var Footer = _react2['default'].createClass({
	    displayName: 'Footer',
	    propTypes: {
	        isHidden: _react2['default'].PropTypes.bool
	    },
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    render: function render() {
	        if (this.props.isHidden) {
	            return false;
	        }
	        return _react2['default'].createElement(
	            'div',
	            { className: 'footer' },
	            _react2['default'].createElement(
	                'div',
	                null,
	                this.props.children
	            )
	        );
	    }
	});
	
	module.exports = Footer;

/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports.textbox = textbox;
	exports.checkbox = checkbox;
	exports.select = select;
	exports.radio = radio;
	exports.date = date;
	exports.struct = struct;
	exports.list = list;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var _tcombValidation = __webpack_require__(138);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	function getAlert(type, children) {
	    var className = {
	        ui: true,
	        message: true
	    };
	    className[type] = true;
	    return {
	        tag: 'div',
	        attrs: {
	            className: className
	        },
	        children: children
	    };
	}
	
	function getLabel(opts) {
	    if (!opts.label) {
	        return;
	    }
	
	    return {
	        tag: 'label',
	        attrs: {
	            htmlFor: opts.htmlFor,
	            id: opts.id
	        },
	        children: opts.label
	    };
	}
	
	function getHelp(locals) {
	    if (!locals.help) {
	        return;
	    }
	    return {
	        tag: 'div',
	        attrs: {
	            className: 'ui pointing label visible',
	            id: locals.id + '-tip'
	        },
	        children: locals.help
	    };
	}
	
	function getError(locals) {
	    if (!locals.hasError || !locals.error) {
	        return;
	    }
	    return {
	        tag: 'div',
	        attrs: {
	            className: 'field__error'
	        },
	        children: locals.error
	    };
	}
	
	function getHiddenTextbox(locals) {
	    return {
	        tag: 'input',
	        attrs: {
	            type: 'hidden',
	            value: locals.value,
	            name: locals.name
	        },
	        events: {
	            change: function change(evt) {
	                locals.onChange(evt.target.value);
	            }
	        }
	    };
	}
	
	function getOption(opts) {
	    return {
	        tag: 'option',
	        attrs: {
	            disabled: opts.disabled,
	            value: opts.value
	        },
	        children: opts.text,
	        key: opts.value
	    };
	}
	
	function getOptGroup(opts) {
	    return {
	        tag: 'optgroup',
	        attrs: {
	            disabled: opts.disabled,
	            label: opts.label
	        },
	        children: opts.options.map(getOption),
	        key: opts.label
	    };
	}
	
	function getButton(options) {
	    return {
	        tag: 'button',
	        attrs: {
	            className: {
	                ui: true,
	                basic: true,
	                button: true
	            }
	        },
	        events: {
	            click: options.click
	        },
	        children: options.label,
	        key: options.key
	    };
	}
	
	function getRow(options) {
	    return {
	        tag: 'div',
	        attrs: {
	            className: {
	                ui: true,
	                grid: true
	            }
	        },
	        children: options.children,
	        key: options.key
	    };
	}
	
	function getCol(options) {
	    return {
	        tag: 'div',
	        attrs: {
	            className: options.className
	        },
	        children: options.children
	    };
	}
	
	function getButtonGroup(buttons) {
	    return {
	        tag: 'div',
	        attrs: {
	            className: {
	                ui: true,
	                basic: true,
	                buttons: true
	            }
	        },
	        children: buttons
	    };
	}
	
	function textbox(locals) {
	
	    if (locals.type === 'hidden') {
	        return getHiddenTextbox(locals);
	    }
	
	    var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	
	    var tag = 'textarea';
	    if (locals.type !== 'textarea') {
	        tag = 'input';
	        attrs.type = locals.type;
	    }
	
	    attrs.className = _tcombValidation2['default'].mixin({}, attrs.className);
	
	    attrs.disabled = locals.disabled;
	    if (locals.type !== 'file') {
	        attrs.value = locals.value;
	    }
	    attrs.onChange = locals.type === 'file' ? function (evt) {
	        return locals.onChange(evt.target.files[0]);
	    } : function (evt) {
	        return locals.onChange(evt.target.value);
	    };
	
	    if (locals.help) {
	        attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	    }
	
	    var control = {
	        tag: tag,
	        attrs: attrs
	    };
	
	    var label = getLabel({
	        label: locals.label,
	        htmlFor: attrs.id
	    });
	    var help = getHelp(locals);
	    var error = getError(locals);
	    var config = locals.config || {};
	
	    return {
	        tag: 'div',
	        attrs: {
	            className: _defineProperty({
	                field: true,
	                error: locals.hasError,
	                disabled: locals.disabled
	            }, config.wide + ' wide', !_tcombValidation2['default'].Nil.is(config.wide))
	        },
	        children: [label, control, help, error]
	    };
	}
	
	function checkbox(locals) {
	
	    var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	    attrs.type = 'checkbox';
	    attrs.disabled = locals.disabled;
	    attrs.checked = locals.value;
	    attrs.onChange = function (evt) {
	        return locals.onChange(evt.target.checked);
	    };
	
	    if (locals.help) {
	        attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	    }
	
	    var control = {
	        tag: 'input',
	        attrs: attrs
	    };
	    var label = getLabel({
	        label: locals.label,
	        htmlFor: attrs.id
	    });
	    var help = getHelp(locals);
	    var error = getError(locals);
	    var config = locals.config || {};
	
	    return {
	        tag: 'div',
	        attrs: {
	            className: _defineProperty({
	                field: true,
	                inline: true,
	                error: locals.hasError,
	                disabled: locals.disabled
	            }, config.wide + ' wide', !_tcombValidation2['default'].Nil.is(config.wide))
	        },
	        children: {
	            tag: 'div',
	            attrs: {
	                className: {
	                    field__checkbox: true
	                }
	            },
	            children: [control, label, help, error]
	        }
	    };
	}
	
	function select(locals) {
	
	    var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	
	    attrs.className = _tcombValidation2['default'].mixin({}, attrs.className);
	
	    attrs.multiple = locals.isMultiple;
	    attrs.disabled = locals.disabled;
	    attrs.value = locals.value;
	    attrs.onChange = function (evt) {
	        var value = locals.isMultiple ? Array.prototype.slice.call(evt.target.options).filter(function (option) {
	            return option.selected;
	        }).map(function (option) {
	            return option.value;
	        }) : evt.target.value;
	        locals.onChange(value);
	    };
	
	    if (locals.help) {
	        attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	    }
	
	    var options = locals.options.map(function (x) {
	        return x.label ? getOptGroup(x) : getOption(x);
	    });
	
	    var control = {
	        tag: 'select',
	        attrs: attrs,
	        children: options
	    };
	
	    var label = getLabel({
	        label: locals.label,
	        htmlFor: attrs.id
	    });
	    var help = getHelp(locals);
	    var error = getError(locals);
	    var config = locals.config || {};
	
	    return {
	        tag: 'div',
	        attrs: {
	            className: _defineProperty({
	                field: true,
	                error: locals.hasError,
	                disabled: locals.disabled
	            }, config.wide + ' wide', !_tcombValidation2['default'].Nil.is(config.wide))
	        },
	        children: [label, control, help, error]
	    };
	}
	
	function radio(locals) {
	
	    var id = locals.attrs.id;
	    var onChange = function onChange(evt) {
	        return locals.onChange(evt.target.value);
	    };
	
	    var control = {
	        tag: 'div',
	        attrs: {
	            className: {
	                fields: true,
	                grouped: true
	            }
	        },
	        children: locals.options.map(function (option, i) {
	
	            var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	            attrs.type = 'radio';
	            attrs.checked = option.value === locals.value;
	            attrs.disabled = locals.disabled;
	            attrs.value = option.value;
	            attrs.autoFocus = attrs.autoFocus && i === 0;
	            attrs.id = id + '_' + i;
	            attrs['aria-describedby'] = attrs['aria-describedby'] || (locals.label ? id : null);
	            attrs.onChange = onChange;
	
	            return {
	                tag: 'div',
	                attrs: {
	                    className: {
	                        field: true
	                    }
	                },
	                children: {
	                    tag: 'div',
	                    attrs: {
	                        className: {
	                            ui: true,
	                            radio: true,
	                            checkbox: true
	                        }
	                    },
	                    children: [{
	                        tag: 'input',
	                        attrs: attrs
	                    }, {
	                        tag: 'label',
	                        children: option.text,
	                        events: {
	                            click: function click() {
	                                document.getElementById(attrs.id).click();
	                            }
	                        }
	                    }]
	                },
	                key: option.value
	            };
	        })
	    };
	
	    var label = getLabel({
	        label: locals.label,
	        htmlFor: id
	    });
	    var help = getHelp(locals);
	    var error = getError(locals);
	    var config = locals.config || {};
	
	    return {
	        tag: 'div',
	        attrs: {
	            className: _defineProperty({
	                field: true,
	                error: locals.hasError,
	                disabled: locals.disabled
	            }, config.wide + ' wide', !_tcombValidation2['default'].Nil.is(config.wide))
	        },
	        children: [label, control, help, error]
	    };
	}
	
	function range(n) {
	    var result = [];
	    for (var i = 1; i <= n; i++) {
	        result.push(i);
	    }
	    return result;
	}
	
	function padLeft(x, len) {
	    var str = String(x);
	    var times = len - str.length;
	    for (var i = 0; i < times; i++) {
	        str = '0' + str;
	    }
	    return str;
	}
	
	function toOption(value, text) {
	    return {
	        tag: 'option',
	        attrs: {
	            value: value + ''
	        },
	        children: text
	    };
	}
	
	var nullOption = [toOption('', '-')];
	
	var days = nullOption.concat(range(31).map(function (i) {
	    return toOption(i, padLeft(i, 2));
	}));
	
	var months = nullOption.concat(range(12).map(function (i) {
	    return toOption(i - 1, padLeft(i, 2));
	}));
	
	function date(locals) {
	
	    var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	    var value = locals.value.slice();
	
	    function onDayChange(evt) {
	        value[2] = evt.target.value === '-' ? null : evt.target.value;
	        locals.onChange(value);
	    }
	
	    function onMonthChange(evt) {
	        value[1] = evt.target.value === '-' ? null : evt.target.value;
	        locals.onChange(value);
	    }
	
	    function onYearChange(evt) {
	        value[0] = evt.target.value.trim() === '' ? null : evt.target.value.trim();
	        locals.onChange(value);
	    }
	
	    var parts = {
	
	        D: {
	            tag: 'div',
	            key: 'D',
	            attrs: {
	                className: {
	                    field: true
	                }
	            },
	            children: {
	                tag: 'select',
	                attrs: {
	                    disabled: locals.disabled,
	                    value: value[2]
	                },
	                events: {
	                    change: onDayChange
	                },
	                children: days
	            }
	        },
	
	        M: {
	            tag: 'div',
	            key: 'M',
	            attrs: {
	                className: {
	                    field: true
	                }
	            },
	            children: {
	                tag: 'select',
	                attrs: {
	                    disabled: locals.disabled,
	                    value: value[1]
	                },
	                events: {
	                    change: onMonthChange
	                },
	                children: months
	            }
	        },
	
	        YY: {
	            tag: 'div',
	            key: 'YY',
	            attrs: {
	                className: {
	                    field: true
	                }
	            },
	            children: {
	                tag: 'input',
	                attrs: {
	                    disabled: locals.disabled,
	                    type: 'text',
	                    size: 5,
	                    value: value[0]
	                },
	                events: {
	                    change: onYearChange
	                }
	            }
	        }
	
	    };
	
	    var control = {
	        tag: 'div',
	        attrs: {
	            className: {
	                inline: true,
	                fields: true
	            }
	        },
	        children: locals.order.map(function (id) {
	            return parts[id];
	        })
	    };
	
	    var label = getLabel({
	        label: locals.label,
	        htmlFor: attrs.id
	    });
	    var help = getHelp(locals);
	    var error = getError(locals);
	    var config = locals.config || {};
	
	    return {
	        tag: 'div',
	        attrs: {
	            className: _defineProperty({
	                field: true,
	                error: locals.hasError,
	                disabled: locals.disabled
	            }, config.wide + ' wide', !_tcombValidation2['default'].Nil.is(config.wide))
	        },
	        children: [label, control, help, error]
	    };
	}
	
	function struct(locals) {
	
	    var rows = [];
	
	    if (locals.label) {
	        rows.push({
	            tag: 'legend',
	            attrs: {
	                className: {
	                    ui: true,
	                    header: true
	                }
	            },
	            children: locals.label
	        });
	    }
	
	    if (locals.help) {
	        rows.push(getAlert('info', locals.help));
	    }
	
	    rows = rows.concat(locals.order.map(function (name) {
	        return locals.inputs[name];
	    }));
	
	    if (locals.error && locals.hasError) {
	        rows.push(getAlert('error', locals.error));
	    }
	
	    return {
	        tag: 'fieldset',
	        attrs: {
	            disabled: locals.disabled,
	            style: {
	                border: 0,
	                margin: 0,
	                padding: 0
	            },
	            className: {
	                ui: true,
	                form: true,
	                segment: locals.path.length > 0,
	                error: locals.hasError
	            }
	        },
	        children: rows
	    };
	}
	
	function list(locals) {
	
	    var rows = [];
	
	    if (locals.label) {
	        rows.push({
	            tag: 'legend',
	            attrs: {
	                className: {
	                    ui: true,
	                    header: true
	                }
	            },
	            children: locals.label
	        });
	    }
	
	    if (locals.help) {
	        rows.push(getAlert('info', locals.help));
	    }
	
	    rows = rows.concat(locals.items.map(function (item) {
	        if (item.buttons.length === 0) {
	            return getRow({
	                key: item.key,
	                children: [getCol({
	                    className: {
	                        six: true,
	                        wide: true,
	                        column: true
	                    },
	                    children: item.input
	                })]
	            });
	        }
	        return getRow({
	            key: item.key,
	            children: [getCol({
	                className: {
	                    eight: true,
	                    wide: true,
	                    column: true
	                },
	                children: item.input
	            }), getCol({
	                className: {
	                    four: true,
	                    wide: true,
	                    column: true
	                },
	                children: getButtonGroup(item.buttons.map(function (button, i) {
	                    return getButton({
	                        click: button.click,
	                        key: i,
	                        label: button.label
	                    });
	                }))
	            })]
	        });
	    }));
	
	    if (locals.error && locals.hasError) {
	        rows.push(getAlert('error', locals.error));
	    }
	
	    if (locals.add) {
	        rows.push(getButton(locals.add));
	    }
	
	    return {
	        tag: 'fieldset',
	        attrs: {
	            disabled: locals.disabled,
	            style: {
	                border: 0,
	                margin: 0,
	                padding: 0
	            },
	            className: {
	                ui: true,
	                form: true,
	                segment: locals.path.length > 0,
	                error: locals.hasError
	            }
	        },
	        children: rows
	    };
	}

/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _headerAuthenticated = __webpack_require__(452);
	
	var _headerAuthenticated2 = _interopRequireDefault(_headerAuthenticated);
	
	var _headerLogin = __webpack_require__(454);
	
	var _headerLogin2 = _interopRequireDefault(_headerLogin);
	
	var _headerLinks = __webpack_require__(453);
	
	var _headerLinks2 = _interopRequireDefault(_headerLinks);
	
	var _headerMinimal = __webpack_require__(455);
	
	var _headerMinimal2 = _interopRequireDefault(_headerMinimal);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var Header = _react2['default'].createClass({
	    displayName: 'Header',
	
	    mixins: [],
	
	    propTypes: {
	        isAuthenticated: _react2['default'].PropTypes.bool,
	        hasAcceptedLatestTerms: _react2['default'].PropTypes.bool,
	        activeBasketId: _react2['default'].PropTypes.string
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var licensing = _flux$getStore$getState$config$toJS.licensing;
	
	        var header = function header() {
	            if (_this.props.isAuthenticated && _this.props.hasAcceptedLatestTerms) {
	                return _react2['default'].createElement(_headerAuthenticated2['default'], { activeBasketId: _this.props.activeBasketId });
	            } else if (_this.props.isAuthenticated && !_this.props.hasAcceptedLatestTerms) {
	                return _react2['default'].createElement(_headerMinimal2['default'], null);
	            } else if (!licensing) {
	                return _react2['default'].createElement(_headerLinks2['default'], null);
	            } else {
	                return _react2['default'].createElement(_headerLogin2['default'], null);
	            }
	        };
	        return _react2['default'].createElement(
	            'header',
	            { className: (0, _classnames2['default'])({
	                    'header--login': !this.props.isAuthenticated,
	                    'header--authenticated': this.props.isAuthenticated || !this.props.hasAcceptedLatestTerms
	                }) },
	            header()
	        );
	    }
	});
	
	module.exports = Header;

/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _submissionLink = __webpack_require__(189);
	
	var _submissionLink2 = _interopRequireDefault(_submissionLink);
	
	var _headerDropdown = __webpack_require__(272);
	
	var _headerDropdown2 = _interopRequireDefault(_headerDropdown);
	
	var _headerLanguageSelection = __webpack_require__(188);
	
	var _headerLanguageSelection2 = _interopRequireDefault(_headerLanguageSelection);
	
	var HeaderAuthenticated = _react2['default'].createClass({
	
	    displayName: 'HeaderAuthenticated',
	
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	
	    propTypes: {
	        activeBasketId: _react2['default'].PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            dropdownIsOpen: false
	        };
	    },
	
	    handleDropdownClick: function handleDropdownClick() {
	        this.setState({
	            dropdownIsOpen: false
	        });
	    },
	
	    handleLicenseLinkClick: function handleLicenseLinkClick(e) {
	        var basketStore = _utilsFlux2['default'].getStore('basket');
	
	        // prevent browsing to licensing before they actually loaded
	        if (!basketStore.state.firstload) {
	            e.preventDefault();
	        }
	    },
	
	    handleBasketLinkClick: function handleBasketLinkClick(e) {
	        var basketStore = _utilsFlux2['default'].getStore('basket');
	
	        // prevent browsing to the baskets before they actually loaded
	        if (!basketStore.state.firstload) {
	            e.preventDefault();
	        }
	    },
	
	    toggleOffcanvas: function toggleOffcanvas(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getStore('app').toggleOffcanvas();
	    },
	
	    scrollToTop: function scrollToTop() {
	        window.scrollTo(0, 0);
	    },
	    logout: function logout(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('app').logout();
	        this.context.router.transitionTo('login');
	    },
	
	    showExcelSearch: function showExcelSearch(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openModal('ExcelSearch');
	    },
	
	    showRegister: function showRegister(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openModal('Register');
	    },
	    clearFilters: function clearFilters(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').clearQuery();
	        this.context.router.transitionTo('landing-page');
	    },
	
	    render: function render() {
	        var _flux$getStore$getState = _utilsFlux2['default'].getStore('app').getState();
	
	        var config = _flux$getStore$getState.config;
	
	        var _config$toJS = config.toJS();
	
	        var licensing = _config$toJS.licensing;
	        var allowSubmissions = _config$toJS.allowSubmissions;
	        var userGuide = _config$toJS.userGuide;
	        var disableChangePassword = _config$toJS.disableChangePassword;
	        var showHelp = _config$toJS.showHelp;
	        var helpLink = _config$toJS.helpLink;
	        var termsLink = _config$toJS.termsLink;
	        var showImprint = _config$toJS.showImprint;
	        var showTerms = _config$toJS.showTerms;
	        var showAccountHeaderNav = _config$toJS.showAccountHeaderNav;
	        var showUserGuide = _config$toJS.showUserGuide;
	        var showPrivacy = _config$toJS.showPrivacy;
	        var disableAccountDetails = _config$toJS.disableAccountDetails;
	        var disableLogout = _config$toJS.disableLogout;
	
	        var _flux$getStore$getState2 = _utilsFlux2['default'].getStore('app').getState();
	
	        var accountEditable = _flux$getStore$getState2.accountEditable;
	        var passwordEditable = _flux$getStore$getState2.passwordEditable;
	        var mediaboxRights = _flux$getStore$getState2.mediaboxRights;
	        var samlLogin = _flux$getStore$getState2.samlLogin;
	        var noneLogin = _flux$getStore$getState2.noneLogin;
	        var excel_rights = _flux$getStore$getState2.excel_rights;
	
	        var basketStore = _utilsFlux2['default'].getStore('basket');
	        var activeBasketId = this.props.activeBasketId;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])('header--inner', { 'header--has-submission-button': allowSubmissions }) },
	            !this.context.router.getCurrentPath().includes("shared") && _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: 'landing-page', className: 'header__logo', onClick: this.clearFilters },
	                _react2['default'].createElement('div', { className: 'logo__image' }),
	                _react2['default'].createElement('div', { className: 'logo__divider' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'logo__title' },
	                    _react2['default'].createElement(
	                        'h4',
	                        { onClick: this.scrollToTop },
	                        _utilsFlux2['default'].t('header_title')
	                    )
	                )
	            ),
	            this.context.router.getCurrentPath().includes("shared") && _react2['default'].createElement(
	                'div',
	                { className: 'header__logo' },
	                _react2['default'].createElement('div', { className: 'logo__image' }),
	                _react2['default'].createElement('div', { className: 'logo__divider' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'logo__title' },
	                    _react2['default'].createElement(
	                        'h4',
	                        { onClick: this.scrollToTop },
	                        _utilsFlux2['default'].t('header_title')
	                    )
	                )
	            ),
	            allowSubmissions && _react2['default'].createElement(
	                'div',
	                { className: 'awards-button__wrapper' },
	                _react2['default'].createElement(_submissionLink2['default'], null)
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: 'header__menu' },
	                licensing && _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        {
	                            to: basketStore.isLoading() || !activeBasketId ? 'licensing' : 'singleLicensing',
	                            params: { id: activeBasketId } },
	                        _utilsFlux2['default'].t('nav_request_licence'),
	                        _react2['default'].createElement('i', { className: 'play' })
	                    )
	                ),
	                excel_rights && (Array.isArray(excel_rights) ? excel_rights.length : 0) > 0 && _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: window.location.href, onClick: this.showExcelSearch },
	                        _react2['default'].createElement('i', { className: 'play-linkicon' }),
	                        _utilsFlux2['default'].t('excel_search')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        {
	                            to: basketStore.isLoading() || !activeBasketId ? 'basket' : 'singleBasket',
	                            params: { id: activeBasketId } },
	                        _react2['default'].createElement('i', { className: 'play-linkicon' }),
	                        _utilsFlux2['default'].t('basket_selection')
	                    )
	                ),
	                showImprint && _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item no__icon' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '/#/imprint', target: '_blank' },
	                        _utilsFlux2['default'].t('imprint')
	                    )
	                ),
	                (showHelp === undefined || !!showHelp) && !helpLink && _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item no__icon' },
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        { to: 'help', className: 'item__help' },
	                        _utilsFlux2['default'].t('nav_help_me')
	                    )
	                ),
	                (showHelp === undefined || !!showHelp) && helpLink && _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item no__icon' },
	                    _react2['default'].createElement(
	                        'a',
	                        { className: 'item__help', href: helpLink, target: '_blank' },
	                        _utilsFlux2['default'].t('nav_help_me')
	                    )
	                ),
	                (showAccountHeaderNav === undefined || !!showAccountHeaderNav) && _react2['default'].createElement(
	                    _headerDropdown2['default'],
	                    {
	                        label: _utilsFlux2['default'].t('account_header_nav'),
	                        isOpen: this.state.dropdownIsOpen },
	                    _react2['default'].createElement(
	                        'ul',
	                        null,
	                        (showUserGuide === undefined || !!showUserGuide) && _react2['default'].createElement(
	                            'li',
	                            null,
	                            _react2['default'].createElement('i', { className: 'play ' }),
	                            _react2['default'].createElement(
	                                'a',
	                                { href: userGuide, target: '_blank' },
	                                _utilsFlux2['default'].t('quick_start_guide')
	                            )
	                        ),
	                        false !== accountEditable && !disableAccountDetails && _react2['default'].createElement(
	                            'li',
	                            null,
	                            _react2['default'].createElement('i', { className: 'play ' }),
	                            _react2['default'].createElement(
	                                _reactRouter.Link,
	                                { to: 'accountDetails' },
	                                _utilsFlux2['default'].t('account_details')
	                            )
	                        ),
	                        false !== passwordEditable && !disableChangePassword && _react2['default'].createElement(
	                            'li',
	                            null,
	                            _react2['default'].createElement('i', { className: 'play ' }),
	                            _react2['default'].createElement(
	                                _reactRouter.Link,
	                                { to: 'accountPassword' },
	                                _utilsFlux2['default'].t('account_password_change_head')
	                            )
	                        ),
	                        !termsLink && (showTerms === undefined || !!showTerms) && _react2['default'].createElement(
	                            'li',
	                            null,
	                            _react2['default'].createElement('i', { className: 'play ' }),
	                            _react2['default'].createElement(
	                                'a',
	                                { href: '/#/terms-of-use', target: '_blank' },
	                                _utilsFlux2['default'].t('terms-of-use')
	                            )
	                        ),
	                        termsLink && _react2['default'].createElement(
	                            'li',
	                            null,
	                            _react2['default'].createElement('i', { className: 'play ' }),
	                            _react2['default'].createElement(
	                                'a',
	                                { href: termsLink, target: '_blank' },
	                                _utilsFlux2['default'].t('terms-of-use')
	                            )
	                        ),
	                        showPrivacy && _react2['default'].createElement(
	                            'li',
	                            null,
	                            _react2['default'].createElement('i', { className: 'play ' }),
	                            _react2['default'].createElement(
	                                'a',
	                                { href: '/#/privacy-policy', target: '_blank' },
	                                _utilsFlux2['default'].t('privacy-policy')
	                            )
	                        ),
	                        mediaboxRights === 1 && !(samlLogin || noneLogin) && _react2['default'].createElement(
	                            'li',
	                            null,
	                            _react2['default'].createElement('i', { className: 'play ' }),
	                            _react2['default'].createElement(
	                                'a',
	                                { href: window.location.href, onClick: this.showRegister },
	                                _utilsFlux2['default'].t('sign_up_new_user')
	                            )
	                        )
	                    )
	                ),
	                _react2['default'].createElement(_headerLanguageSelection2['default'], null),
	                !disableLogout && _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#', onClick: this.logout, title: 'Logout' },
	                        _react2['default'].createElement('i', { className: 'log-out logout__icon ' }),
	                        _utilsFlux2['default'].t('navigate_logout')
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'a',
	                { href: true, className: 'header__offcanvas', onClick: this.toggleOffcanvas },
	                _react2['default'].createElement(
	                    'svg',
	                    { xmlns: 'http://www.w3.org/2000/svg', version: '1.1', viewport: '0 0 25 25', viewBox: '0 0 25 25' },
	                    _react2['default'].createElement('path', { d: 'M1,11h22v3H1V11z' }),
	                    _react2['default'].createElement('path', { d: 'M1,17h22v3H1V17z' }),
	                    _react2['default'].createElement('path', { d: 'M1,5h22v3H1V5z' })
	                )
	            )
	        );
	    }
	});
	
	module.exports = HeaderAuthenticated;

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var _componentsLinksPartnerLinks = __webpack_require__(273);
	
	var _componentsLinksPartnerLinks2 = _interopRequireDefault(_componentsLinksPartnerLinks);
	
	var _headerLanguageSelection = __webpack_require__(188);
	
	var _headerLanguageSelection2 = _interopRequireDefault(_headerLanguageSelection);
	
	var HeaderLinks = _react2['default'].createClass({
	
	    displayName: 'HeaderLinks',
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'header--inner' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'header__logo' },
	                _react2['default'].createElement('div', { className: 'logo__image' }),
	                _react2['default'].createElement('div', { className: 'logo__divider' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'logo__title' },
	                    _react2['default'].createElement(
	                        'h4',
	                        null,
	                        _utilsFlux2['default'].t('header_title')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'partner-links--header' },
	                    _react2['default'].createElement(_componentsLinksPartnerLinks2['default'], null)
	                )
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: 'header__menu' },
	                _react2['default'].createElement(_headerLanguageSelection2['default'], null)
	            )
	        );
	    }
	});
	
	module.exports = HeaderLinks;

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var _submissionLink = __webpack_require__(189);
	
	var _submissionLink2 = _interopRequireDefault(_submissionLink);
	
	var _headerLanguageSelection = __webpack_require__(188);
	
	var _headerLanguageSelection2 = _interopRequireDefault(_headerLanguageSelection);
	
	var HeaderLogin = _react2['default'].createClass({
	
	    displayName: 'HeaderLogin',
	
	    showLogin: function showLogin(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openModal('Login');
	    },
	
	    render: function render() {
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var allowSubmissions = _flux$getStore$getState$config$toJS.allowSubmissions;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'header--inner' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'header__logo' },
	                _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: 'login' },
	                    _react2['default'].createElement('div', { className: 'logo__image' }),
	                    _react2['default'].createElement('div', { className: 'logo__divider' }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'logo__title' },
	                        _react2['default'].createElement(
	                            'h4',
	                            null,
	                            _utilsFlux2['default'].t('header_title')
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'ul',
	                    { className: 'header__menu' },
	                    _react2['default'].createElement(_headerLanguageSelection2['default'], null)
	                )
	            ),
	            _react2['default'].createElement(
	                'a',
	                { href: '#', className: 'header__login', onClick: this.showLogin },
	                _utilsFlux2['default'].t('login'),
	                _react2['default'].createElement('i', { className: 'login__icon' })
	            ),
	            allowSubmissions && _react2['default'].createElement(
	                'div',
	                { className: 'awards-button__wrapper' },
	                _react2['default'].createElement(_submissionLink2['default'], null)
	            )
	        );
	    }
	});
	
	module.exports = HeaderLogin;

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var HeaderMinimal = _react2['default'].createClass({
	
	    displayName: 'HeaderMinimal',
	
	    logout: function logout(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('app').logout();
	        this.context.router.transitionTo('login');
	    },
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'header--inner' },
	            _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: 'login', className: 'header__logo' },
	                _react2['default'].createElement('div', { className: 'logo__image' }),
	                _react2['default'].createElement('div', { className: 'logo__divider' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'logo__title' },
	                    _react2['default'].createElement(
	                        'h4',
	                        null,
	                        _utilsFlux2['default'].t('header_title')
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'a',
	                { href: '#', className: 'header__login', onClick: this.logout },
	                _utilsFlux2['default'].t('logout'),
	                _react2['default'].createElement('i', null)
	            )
	        );
	    }
	});
	
	module.exports = HeaderMinimal;

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactSvgInline = __webpack_require__(843);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _assetsLarge_previewSvg = __webpack_require__(820);
	
	var _assetsLarge_previewSvg2 = _interopRequireDefault(_assetsLarge_previewSvg);
	
	var _assetsSmall_previewSvg = __webpack_require__(822);
	
	var _assetsSmall_previewSvg2 = _interopRequireDefault(_assetsSmall_previewSvg);
	
	var _assetsList_viewSvg = __webpack_require__(821);
	
	var _assetsList_viewSvg2 = _interopRequireDefault(_assetsList_viewSvg);
	
	var MediaHeaderLayout = _react2['default'].createClass({
	    displayName: 'MediaHeaderLayout',
	    getInitialState: function getInitialState() {
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var defaultResultView = _flux$getStore$getState$config$toJS.defaultResultView;
	
	        return {
	            active: _store2['default'].get('active_layout') ? _store2['default'].get('active_layout') : defaultResultView || 'large_preview'
	        };
	    },
	    setActiveLayout: function setActiveLayout(active) {
	        _utilsFlux2['default'].getActions('media').setLayout(active);
	        this.setState({
	            active: _store2['default'].get('active_layout')
	        });
	    },
	    render: function render() {
	        var _this = this;
	
	        var active = this.state.active;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'headerbar__layout' },
	            _react2['default'].createElement(_reactSvgInline2['default'], { className: active === 'large_preview' ? 'active layout_style' : 'layout_style',
	                svg: _assetsLarge_previewSvg2['default'],
	                onClick: function () {
	                    return _this.setActiveLayout('large_preview');
	                },
	                title: _utilsFlux2['default'].t('large_preview'),
	                accessibilityLabel: _utilsFlux2['default'].t('large_preview') }),
	            _react2['default'].createElement(_reactSvgInline2['default'], { className: active === 'small_preview' ? 'active layout_style' : 'layout_style',
	                svg: _assetsSmall_previewSvg2['default'],
	                onClick: function () {
	                    return _this.setActiveLayout('small_preview');
	                },
	                title: _utilsFlux2['default'].t('small_preview'),
	                accessibilityLabel: _utilsFlux2['default'].t('small_preview') }),
	            _react2['default'].createElement(_reactSvgInline2['default'], { className: active === 'list_view' ? 'active layout_style' : 'layout_style',
	                svg: _assetsList_viewSvg2['default'],
	                onClick: function () {
	                    return _this.setActiveLayout('list_view');
	                },
	                title: _utilsFlux2['default'].t('list_view'),
	                accessibilityLabel: _utilsFlux2['default'].t('list_view') })
	        );
	    }
	});
	
	module.exports = MediaHeaderLayout;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var HeaderBarBasket = _react2['default'].createClass({
	    displayName: 'HeaderBarBasket',
	    mixins: [_reactRouter.Navigation],
	    propTypes: {
	        basket: _react2['default'].PropTypes.object.isRequired
	    },
	    _getSelectedBasketIds: function _getSelectedBasketIds() {
	        return this._getSelectedBaskets().map(function (basket) {
	            return basket.get('id');
	        });
	    },
	    _getSelectedBaskets: function _getSelectedBaskets() {
	        return this.props.baskets.filter(function (basket) {
	            return basket.get('isSelected');
	        });
	    },
	    deleteBaskets: function deleteBaskets(e) {
	        var _this = this;
	
	        e.preventDefault();
	        var baskets = this._getSelectedBaskets();
	        var basketIdsToDelete = baskets.map(function (basket) {
	            return basket.get('id');
	        });
	        var basketNamesToDelete = baskets.map(function (basket) {
	            return basket.get('name');
	        }).toJS();
	
	        _utilsFlux2['default'].getActions('modals').confirmModal({
	            title: _utilsFlux2['default'].t('delete_folder'),
	            basketNames: basketNamesToDelete,
	            onConfirm: function onConfirm() {
	                _utilsFlux2['default'].getActions('modals').activateLoading();
	                _utilsFlux2['default'].getStore('basket').deleteBaskets(basketIdsToDelete).then(function () {
	                    _utilsFlux2['default'].getActions('modals').disableLoading();
	                    var gotToBasket = _this.props.baskets.first();
	                    if (gotToBasket) {
	                        _this.transitionTo('singleBasket', { id: gotToBasket.get('id') });
	                    } else {
	                        _this.transitionTo('basket');
	                    }
	                    _utilsFlux2['default'].getActions('modals').closeModals();
	                });
	            }
	        });
	    },
	    shareBaskets: function shareBaskets() {
	        var basketIdsToShare = this._getSelectedBasketIds();
	
	        _utilsFlux2['default'].getActions('modals').openModal('Share');
	        _utilsFlux2['default'].getStore('basket').shareBaskets(basketIdsToShare);
	    },
	    toggleCheckAll: function toggleCheckAll(size, e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('basket').toggleDownloadAll(size);
	    },
	    handleDownloadSubmit: function handleDownloadSubmit(e) {
	        var _this2 = this;
	
	        e.preventDefault();
	        var itemsToDownload = _utilsFlux2['default'].getStore('basket').getItemsToDownload(this.props.basket.get('items').toJS());
	        var params = {};
	        itemsToDownload.forEach(function (item) {
	            return params[item.id] = item.size;
	        });
	
	        _utilsFlux2['default'].getStore('media').checkQuota(params).then(function (response) {
	            var _flux$getStore$getState = _utilsFlux2['default'].getStore('media').getState();
	
	            var quotaExceeded = _flux$getStore$getState.quotaExceeded;
	
	            if (quotaExceeded) {
	                return;
	            }
	
	            _this2.refs.download.getDOMNode().submit();
	
	            itemsToDownload = itemsToDownload.map(function (item) {
	                return item.id;
	            });
	            var items = _this2.props.basket.get('items').toJS();
	            var watermarks = _immutable2['default'].List(itemsToDownload.map(function (id) {
	                return items.find(function (item) {
	                    return id === item.id;
	                });
	            }).filter(function (item) {
	                return item.requires_watermark;
	            }));
	            if (watermarks.size) {
	                _utilsFlux2['default'].getActions('modals').openWatermarkModal(watermarks);
	            }
	        });
	    },
	    render: function render() {
	        var _this3 = this;
	
	        if (!this.props.baskets || !this.props.basket || this.props.basket.size === 0 || this.props.basket.get('items').size === 0) {
	            return false;
	        }
	        var itemsToDownload = _utilsFlux2['default'].getStore('basket').getItemsToDownload(this.props.basket.get('items').toJS());
	        var selectedBaskets = this._getSelectedBaskets();
	        var mediaboxToken = _store2['default'].get('mediabox_token');
	
	        var _flux$getStore$getState2 = _utilsFlux2['default'].getStore('media').getState();
	
	        var quotaExceeded = _flux$getStore$getState2.quotaExceeded;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'headerbar--basket' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'headerbar__actions' },
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.deleteBaskets, disabled: selectedBaskets.size === 0, className: 'btn btn-border btn-remove' },
	                    _react2['default'].createElement('i', { className: 'close-small' }),
	                    _utilsFlux2['default'].t('remove_baskets')
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.shareBaskets, disabled: selectedBaskets.size === 0, className: 'btn btn-border btn-share' },
	                    _react2['default'].createElement('i', { className: 'share' }),
	                    _utilsFlux2['default'].t('share_baskets')
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'headerbar__selection' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'selection__title' },
	                    _utilsFlux2['default'].t('select_all'),
	                    ':'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'selection__actions' },
	                    _react2['default'].createElement(
	                        'form',
	                        null,
	                        this.props.basket.get('_filenames').toJS().map(function (file, ix) {
	                            return _react2['default'].createElement(
	                                'div',
	                                { key: 'basket_size_' + ix, className: 'field__checkbox download__checkbox' },
	                                _react2['default'].createElement('input', { id: 'check__all', checked: _utilsFlux2['default'].getStore('basket').fileIsChecked(_this3.props.basket, file.name), type: 'checkbox', readOnly: true }),
	                                _react2['default'].createElement(
	                                    'label',
	                                    { onClick: _this3.toggleCheckAll.bind(null, file.name), htmlFor: 'check__all' },
	                                    file.name
	                                )
	                            );
	                        })
	                    ),
	                    _react2['default'].createElement(
	                        'form',
	                        { ref: 'download', onSubmit: this.handleDownloadSubmit, action: window.config.baseUrl + '/baskets/download/' + this.props.basket.get('id'), method: 'post' },
	                        _react2['default'].createElement('input', { type: 'hidden', name: 'token', value: mediaboxToken }),
	                        itemsToDownload.map(function (item, ix) {
	                            return _react2['default'].createElement('input', { key: 'input_' + ix, type: 'hidden', name: item.id, value: item.size });
	                        }),
	                        _react2['default'].createElement(
	                            'button',
	                            { type: 'submit', disabled: itemsToDownload.length === 0 || quotaExceeded, className: 'btn btn-border selection__download' },
	                            _react2['default'].createElement('i', { className: 'download' }),
	                            _utilsFlux2['default'].t('download')
	                        )
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = HeaderBarBasket;

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var HeaderBarLicensing = _react2['default'].createClass({
	    displayName: 'HeaderBarLicensing',
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    mixins: [_reactRouter.Navigation],
	    _getSelectedItems: function _getSelectedItems() {
	        return this.props.basket.get('items').filter(function (item) {
	            return item.get('_requestLicense') === true;
	        });
	    },
	
	    toggleCheckAll: function toggleCheckAll() {
	        _utilsFlux2['default'].getActions('basket').toggleLicensingAll();
	    },
	
	    requestLicensing: function requestLicensing() {
	        var _this = this;
	
	        var selected = this._getSelectedItems();
	        var requests = selected.map(function (item) {
	            return {
	                id: item.get('id'),
	                comment: item.get('_usageText') ? item.get('_usageText') : ''
	            };
	        }).toJS();
	
	        _utilsFlux2['default'].getStore('basket').requestLicensing(this.props.basket.get('id'), requests).then(function () {
	            _this.transitionTo('singleLicensing', { id: _this.props.basket.get('id') }, { success: true });
	        });
	    },
	
	    render: function render() {
	        var selected = _immutable2['default'].List();
	        var allSelected = _immutable2['default'].List();
	
	        if (this.props.basket.size !== 0) {
	            selected = this._getSelectedItems();
	            allSelected = this.props.basket.get('items').size === selected.size;
	        }
	
	        if (this.props.basket.size === 0 || this.props.basket.get('items').size === 0) {
	            return false;
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'headerbar--licensing' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'headerbar__selection' },
	                _react2['default'].createElement(
	                    'form',
	                    { className: 'all__checkbox' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'field__checkbox field__checkbox--small' },
	                        _react2['default'].createElement('input', { id: 'check__all', checked: allSelected, type: 'checkbox', readOnly: true }),
	                        _react2['default'].createElement(
	                            'label',
	                            { onClick: this.toggleCheckAll, htmlFor: 'check__all' },
	                            _utilsFlux2['default'].t('select_all')
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'all__count' },
	                    _utilsFlux2['default'].getStore('translations').getFormattedMessage('selected_items', { count: selected.size })
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'headerbar__actions' },
	                _react2['default'].createElement(
	                    'button',
	                    { disabled: selected.size === 0, onClick: this.requestLicensing, className: 'btn btn-border' },
	                    _utilsFlux2['default'].t('request_licensing')
	                )
	            )
	        );
	    }
	});
	
	module.exports = HeaderBarLicensing;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRouter = __webpack_require__(7);
	
	var _lodashLangCloneDeep = __webpack_require__(68);
	
	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);
	
	var _lodashLangIsEmpty = __webpack_require__(232);
	
	var _lodashLangIsEmpty2 = _interopRequireDefault(_lodashLangIsEmpty);
	
	var _lodash = __webpack_require__(109);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _fallbackConfig = __webpack_require__(121);
	
	var _fallbackConfig2 = _interopRequireDefault(_fallbackConfig);
	
	var MediaHeaderPagination = _react2['default'].createClass({
	    displayName: 'MediaHeaderPagination',
	    propTypes: {
	        pagination: _react2['default'].PropTypes.object
	    },
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    shouldComponentUpdate: function shouldComponentUpdate() {
	        return !_utilsFlux2['default'].getStore('media').isLoading();
	    },
	    updatePerPage: function updatePerPage(event) {
	        var per_page = typeof event === 'object' ? event.target.value : event;
	        var query = (0, _lodashLangCloneDeep2['default'])(this.context.router.getCurrentQuery());
	        query.page = 1;
	        query.per_page = per_page;
	        _store2['default'].set('pagination_amount', query.per_page);
	        this.context.router.transitionTo('listing', null, query);
	    },
	    render: function render() {
	        var _this = this;
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var amountResults = _flux$getStore$getState$config$toJS.amountResults;
	        var defaultPerPageResults = _flux$getStore$getState$config$toJS.defaultPerPageResults;
	        var progressivePagination = _flux$getStore$getState$config$toJS.progressivePagination;
	
	        var defaultAmountResults = _fallbackConfig2['default'].amountResults;
	
	        if (Array.isArray(amountResults) && amountResults.length > 0) {
	            defaultAmountResults = amountResults;
	        }
	
	        var query = (0, _lodashLangCloneDeep2['default'])(this.context.router.getCurrentQuery());
	        var router = this.context.router;
	
	        var route = router.getRouteAtDepth(1);
	        var isLanding = route && 'landing-page' === route.name;
	
	        if (!this.props.pagination || isLanding || this.props.pagination.get('total_records') === 0) {
	            return false;
	        }
	
	        var pagination = this.props.pagination.toJS();
	        pagination.per_page = _store2['default'].get('pagination_amount') ? _store2['default'].get('pagination_amount') : pagination.per_page;
	        var maxPages = Math.ceil(pagination.total_records / pagination.per_page);
	
	        query.page = parseInt(query.page, 10) || 1;
	        var queryNext = (0, _lodashLangCloneDeep2['default'])(query);
	        var queryPrev = (0, _lodashLangCloneDeep2['default'])(query);
	
	        queryNext.page = queryNext.page < maxPages ? queryNext.page + 1 : queryNext.page;
	        queryPrev.page = queryPrev.page >= 2 ? queryPrev.page - 1 : queryPrev.page;
	        if (queryPrev.page === 1) {
	            delete queryPrev.page;
	        }
	        if (queryNext.page === 1) {
	            delete queryNext.page;
	        }
	
	        var perPageValue = query.per_page || _store2['default'].get('pagination_amount') || defaultPerPageResults;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'headerbar__pagination' },
	            _react2['default'].createElement(
	                _reactRouter.Link,
	                { role: 'button', query: queryPrev, className: (0, _classnames2['default'])({ 'pagination__disabled': 1 === pagination.page }), to: 'listing' },
	                '<'
	            ),
	            _react2['default'].createElement(
	                'span',
	                { className: 'pagination__info' },
	                !progressivePagination && _utilsFlux2['default'].getStore('translations').getFormattedMessage('pagination', {
	                    from: pagination.page,
	                    until: maxPages
	                }),
	                progressivePagination && (function () {
	                    var numPages = 5;
	                    var page = pagination.page;
	
	                    var pRange = [];
	                    var pQuery = (0, _lodashLangCloneDeep2['default'])(query);
	                    delete pQuery.page;
	                    if (page < numPages - 1) {
	                        pRange = (0, _lodash.range)(1, Math.min(numPages, maxPages) + 1);
	                    } else if (page <= maxPages) {
	                        pRange = (0, _lodash.range)(page - 2, Math.min(page + 3, maxPages + 1));
	                        while (pRange.length < 5) {
	                            pRange.unshift(pRange[0] - 1);
	                        }
	                    }
	                    return pRange.map(function (p, i) {
	                        return _react2['default'].createElement(
	                            _reactRouter.Link,
	                            { to: 'listing',
	                                query: (0, _lodash.assign)({}, pQuery, p > 1 ? { page: p } : null),
	                                key: i, className: (0, _classnames2['default'])('pagination__page', { 'current': p === query.page }) },
	                            p,
	                            i < 4 ? ' ' : ''
	                        );
	                    });
	                })()
	            ),
	            _react2['default'].createElement(
	                _reactRouter.Link,
	                { role: 'button', className: (0, _classnames2['default'])('pagination_next', { 'pagination__disabled': maxPages === pagination.page }), to: 'listing', query: queryNext },
	                '>'
	            ),
	            _react2['default'].createElement(
	                'select',
	                { className: 'pagination__amount btn btn-border', onChange: function (e) {
	                        return _this.updatePerPage(e);
	                    }, value: perPageValue },
	                defaultAmountResults.map(function (x, i) {
	                    return _react2['default'].createElement(
	                        'option',
	                        { key: i },
	                        x
	                    );
	                })
	            )
	        );
	    }
	});
	
	module.exports = MediaHeaderPagination;

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _componentsBasketBasketDropdown = __webpack_require__(144);
	
	var _componentsBasketBasketDropdown2 = _interopRequireDefault(_componentsBasketBasketDropdown);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var MediaHeaderSelection = _react2['default'].createClass({
	    displayName: 'MediaHeaderSelection',
	
	    mixins: [__webpack_require__(235)],
	
	    propTypes: {
	        media: _react2['default'].PropTypes.object,
	        isFooter: _react2['default'].PropTypes.bool
	    },
	
	    toggleCheck: function toggleCheck(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').toggleAllItemSelection();
	    },
	
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        this.closeDialogHandler = this.toggleAddAll.bind(this);
	        return {
	            showAddAll: false
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var hasChanged = _immutable2['default'].is(nextProps.media, this.props.media) === false;
	        if (hasChanged) {
	            this.setState({
	                showAddAll: false
	            });
	        }
	    },
	
	    handleClickOutside: function handleClickOutside(e) {},
	
	    toggleAddAll: function toggleAddAll() {
	        this.setState({
	            showAddAll: !this.state.showAddAll
	        });
	    },
	
	    renderAddToFolder: function renderAddToFolder() {
	        var eligible = this.props.media.filter(function (item) {
	            return false !== item.get('showdownload');
	        });
	        var selected = eligible.filter(function (item) {
	            return true === item.get('_checked');
	        }).toJS();
	
	        if (this.state.showAddAll && selected.length !== 0) {
	            return _react2['default'].createElement(
	                _altContainer2['default'],
	                {
	                    stores: { basketStore: _utilsFlux2['default'].getStore('basket') },
	                    transform: function (_ref) {
	                        var basketStore = _ref.basketStore;
	
	                        var baskets = basketStore.baskets;
	                        return { baskets: baskets };
	                    } },
	                _react2['default'].createElement(_componentsBasketBasketDropdown2['default'], { media: selected, closeDialog: this.closeDialogHandler, isFooter: this.props.isFooter })
	            );
	        }
	    },
	
	    generateInstantDownload: function generateInstantDownload(e) {
	        e.preventDefault();
	        var eligible = this.props.media.filter(function (item) {
	            return false !== item.get('showdownload');
	        });
	        var selected = eligible.filter(function (item) {
	            return true === item.get('_checked');
	        });
	        _utilsFlux2['default'].getActions('modals').openInstantDownloadAllModal(selected);
	    },
	
	    render: function render() {
	        var query = this.context.router.getCurrentQuery();
	        var router = this.context.router;
	
	        var route = router.getRouteAtDepth(1);
	        var isLanding = route && 'landing-page' === route.name;
	        var eligible = this.props.media.filter(function (item) {
	            return false !== item.get('showdownload');
	        });
	        if (eligible.size === 0 || isLanding) {
	            return false;
	        }
	
	        var selected = eligible.filter(function (item) {
	            return true === item.get('_checked');
	        });
	        var allSelected = eligible.size === selected.size;
	        var total = _utilsFlux2['default'].getStore('media').getState().meta.toJS().total_records;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'headerbar__selection' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'selection__all' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'result_line' },
	                    total,
	                    ' ',
	                    _utilsFlux2['default'].t('results'),
	                    ' - ',
	                    _react2['default'].createElement(
	                        'b',
	                        null,
	                        selected.size
	                    ),
	                    ' ',
	                    _utilsFlux2['default'].t('selected')
	                ),
	                _react2['default'].createElement(
	                    'form',
	                    { className: 'all__checkbox' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'field__checkbox field__checkbox--small' },
	                        _react2['default'].createElement('input', { id: 'check__all', checked: allSelected, type: 'checkbox', readOnly: true }),
	                        _react2['default'].createElement(
	                            'label',
	                            { onClick: this.toggleCheck, htmlFor: 'check__all' },
	                            _utilsFlux2['default'].t('select_all')
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.generateInstantDownload, disabled: selected.size === 0, className: 'directdownload__button', title: _utilsFlux2['default'].t('download'),
	                        accessibilityLabel: _utilsFlux2['default'].t('download') },
	                    _react2['default'].createElement(
	                        'div',
	                        null,
	                        _react2['default'].createElement('i', { className: 'download' })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.toggleAddAll, disabled: selected.size === 0, className: 'addtobasket__button', title: _utilsFlux2['default'].t('add_to_folder'),
	                        accessibilityLabel: _utilsFlux2['default'].t('add_to_folder') },
	                    _react2['default'].createElement('i', { className: 'plus-small' })
	                ),
	                this.renderAddToFolder()
	            )
	        );
	    }
	});
	
	module.exports = MediaHeaderSelection;

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var HeaderBarShare = _react2['default'].createClass({
	    displayName: 'HeaderBarShare',
	
	    mixins: [_reactRouter.Navigation],
	
	    propTypes: {
	        basket: _react2['default'].PropTypes.object.isRequired
	    },
	
	    toogleAll: function toogleAll(allSelected, e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('share').toggleAllItems({ basketId: this.props.basket.get('id'), checkAll: !allSelected });
	    },
	
	    toggleCheckAll: function toggleCheckAll(size, shouldCheckAll, e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('share').toggleDownloadAll({ basketId: this.props.basket.get('id'), fileKey: size, shouldCheckAll: shouldCheckAll });
	    },
	
	    downloadSelected: function downloadSelected(e) {
	        e.preventDefault();
	        var data = {};
	        var items = this.props.basket.get('items').toJSON().map(function (item) {
	            if (item.visible && item._checked && item.files.length) {
	                data[item.id] = item.files[0].name;
	            }
	        });
	        _utilsFlux2['default'].getStore('share').download(data);
	    },
	
	    handleDownloadSubmit: function handleDownloadSubmit(e) {
	        var watermarks = this.props.basket.get('items').filter(function (item) {
	            return item.get('visible') && item.get('_checked') && item.get('requires_watermark');
	        });
	        if (watermarks.size) {
	            _utilsFlux2['default'].getActions('modals').openWatermarkModal(watermarks);
	        }
	    },
	
	    render: function render() {
	        var _this = this;
	
	        if (!this.props.basket || this.props.basket.size === 0 || this.props.basket.get('items').size === 0) {
	            return false;
	        }
	
	        var items = this.props.basket.get('items').filter(function (item) {
	            return true === item.get('visible');
	        });
	        var selected = items.filter(function (item) {
	            return true === item.get('_checked');
	        });
	        var fileKeys = [];
	        var countKeys = {};
	        items.toJS().forEach(function (item) {
	            item.files.forEach(function (file) {
	                if (countKeys[file.key] === undefined) countKeys[file.key] = { count: 0, selected: 0, name: file.name };
	                countKeys[file.key].count++;
	                if (file['_download']) countKeys[file.key].selected++;
	                if (fileKeys.indexOf(file.key) === -1) {
	                    fileKeys.push(file.key);
	                }
	            });
	        });
	
	        var allSelected = selected.size === items.size;
	        var mediaboxToken = _store2['default'].get('mediabox_token');
	
	        var itemsToDownload = _utilsFlux2['default'].getStore('share').getItemsToDownload(items.toJS());
	        var isAuthenticated = _utilsFlux2['default'].getStore('app').isAuthenticated();
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var shareMode = _flux$getStore$getState$config$toJS.shareMode;
	
	        var header = shareMode === 'openDownload' || 'auth' === shareMode && isAuthenticated ? _react2['default'].createElement(
	            'div',
	            { className: 'headerbar--basket' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'headerbar__selection' },
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'selection__title' },
	                    _utilsFlux2['default'].t('select_all'),
	                    ':'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'selection__actions' },
	                    _react2['default'].createElement(
	                        'form',
	                        null,
	                        fileKeys.map(function (key, ix) {
	                            return _react2['default'].createElement(
	                                'div',
	                                { key: 'basket_size_' + ix, className: 'field__checkbox download__checkbox' },
	                                _react2['default'].createElement('input', { id: 'check__all', checked: countKeys[key].count === countKeys[key].selected, type: 'checkbox', readOnly: true }),
	                                _react2['default'].createElement(
	                                    'label',
	                                    { onClick: _this.toggleCheckAll.bind(null, key, countKeys[key].count !== countKeys[key].selected), htmlFor: 'check__all' },
	                                    countKeys[key].name
	                                )
	                            );
	                        })
	                    ),
	                    _react2['default'].createElement(
	                        'form',
	                        { ref: 'download', onSubmit: this.handleDownloadSubmit, action: window.config.baseUrl + '/baskets/download/' + this.props.basket.get('id'), method: 'post' },
	                        _react2['default'].createElement('input', { type: 'hidden', name: 'token', value: mediaboxToken }),
	                        itemsToDownload.map(function (item, ix) {
	                            return _react2['default'].createElement('input', { key: 'input_' + ix, type: 'hidden', name: item.id, value: item.size });
	                        }),
	                        _react2['default'].createElement(
	                            'button',
	                            { type: 'submit', disabled: itemsToDownload.length === 0, className: 'btn btn-border selection__download' },
	                            _react2['default'].createElement('i', { className: 'download' }),
	                            _utilsFlux2['default'].t('download')
	                        )
	                    )
	                )
	            )
	        ) : _react2['default'].createElement(
	            'div',
	            { className: 'headerbar--share' },
	            _react2['default'].createElement('div', { className: 'headerbar__selection' })
	        );
	        return header;
	    }
	});
	
	module.exports = HeaderBarShare;

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRouter = __webpack_require__(7);
	
	var _lodashLangCloneDeep = __webpack_require__(68);
	
	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);
	
	var _lodashLangIsEmpty = __webpack_require__(232);
	
	var _lodashLangIsEmpty2 = _interopRequireDefault(_lodashLangIsEmpty);
	
	var _lodash = __webpack_require__(109);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var HeaderSorting = _react2['default'].createClass({
	    displayName: 'HeaderFilter',
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    shouldComponentUpdate: function shouldComponentUpdate() {
	        return !_utilsFlux2['default'].getStore('media').isLoading();
	    },
	    updateFilter: function updateFilter(event) {
	        var query = (0, _lodashLangCloneDeep2['default'])(this.context.router.getCurrentQuery());
	        var sortingKey = event.target.value;
	        query.sorting = sortingKey;
	        sessionStorage.setItem('sortingKey', sortingKey);
	        this.context.router.transitionTo('listing', null, query);
	    },
	    render: function render() {
	        var _this = this;
	
	        var currentSortingOption = this.context.router.getCurrentQuery().sorting;
	        return _react2['default'].createElement(
	            'div',
	            { className: 'headerbar__sorting' },
	            _react2['default'].createElement(
	                'select',
	                { className: 'btn btn-border', onChange: function (e) {
	                        return _this.updateFilter(e);
	                    }, value: currentSortingOption ? currentSortingOption : null },
	                config.searchSortSettings.map(function (index) {
	                    return _react2['default'].createElement(
	                        'option',
	                        { key: index, value: index },
	                        _utilsFlux2['default'].t(index)
	                    );
	                })
	            )
	        );
	    }
	});
	
	module.exports = HeaderSorting;

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var HtmlViewer = _react2['default'].createClass({
	    displayName: 'HtmlViewer',
	
	    getInitialState: function getInitialState() {
	        this.getHtml(this.props.url);
	        return {
	            __html: ""
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.url != nextProps.url) {
	            this.setState(this.getHtml(nextProps.url));
	        }
	    },
	
	    getHtml: function getHtml(url) {
	        var _this = this;
	
	        fetch(url, {
	            method: 'GET'
	        }).then(function (response) {
	            return response.text();
	        }).then(function (text) {
	            try {
	                var parser = new DOMParser();
	                var htmlDoc = parser.parseFromString(text, "text/html");
	                // var bodyHtml = /<body.*?>([\s\S]*)<\/body>/.exec(htmlDoc)[1];
	                _this.setState({
	                    __html: htmlDoc.body.innerHTML
	                });
	            } catch (err) {
	                console.log('Error getHtml: ' + err);
	                _this.setState({
	                    __html: ""
	                });
	            }
	        });
	    },
	
	    render: function render() {
	        return _react2['default'].createElement('div', { className: 'html__wrapper', dangerouslySetInnerHTML: this.state });
	    }
	});
	
	module.exports = HtmlViewer;

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _componentsImageViewerImageViewerButtons = __webpack_require__(465);
	
	var _componentsImageViewerImageViewerButtons2 = _interopRequireDefault(_componentsImageViewerImageViewerButtons);
	
	var ImageViewer = _react2['default'].createClass({
	    displayName: 'ImageViewer',
	
	    getInitialState: function getInitialState() {
	        return {
	            x: 0,
	            y: 0,
	            scale: 1,
	            minScale: 1,
	            maxScale: 4
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        document.addEventListener("mousemove", this.handleMouseMove, false);
	        document.addEventListener("wheel", this.handleWheel, { passive: false });
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        document.removeEventListener("mousemove", this.handleMouseMove, false);
	        document.removeEventListener("wheel", this.handleWheel, { passive: false });
	    },
	    /** reset scale and tranlate when we receive a new image. */
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.src != nextProps.src) {
	            this.setState(this.getInitialState());
	        }
	    },
	
	    handleMouseDown: function handleMouseDown(e) {
	        this.dragging = true;
	        this.coords = {
	            x: e.pageX,
	            y: e.pageY
	        };
	    },
	
	    handleMouseUp: function handleMouseUp() {
	        this.dragging = false;
	        this.coords = {};
	    },
	
	    handleMouseGoByeBye: function handleMouseGoByeBye() {
	        this.dragging = false;
	        this.coords = {};
	    },
	
	    handleMouseMove: function handleMouseMove(e) {
	        if (!this.dragging) {
	            return;
	        }
	        e.preventDefault();
	
	        var divElement = this.refs.divElement.getDOMNode();
	
	        var xDiff = this.coords.x - e.pageX,
	            yDiff = this.coords.y - e.pageY;
	
	        // the maximum amount we are allowed to move the picture by:
	        var maxAvailableX = Math.ceil(Math.abs((divElement.clientWidth * this.state.scale - divElement.clientWidth) / 2));
	        var maxAvailableY = Math.ceil(Math.abs((divElement.clientHeight * this.state.scale - divElement.clientHeight) / 2));
	
	        this.coords.x = e.pageX;
	        this.coords.y = e.pageY;
	
	        var x = this.state.x - xDiff,
	            y = this.state.y - yDiff;
	
	        x = this.limitToBound(x, maxAvailableX);
	        y = this.limitToBound(y, maxAvailableY);
	
	        this.setState({ x: x, y: y, scale: this.state.scale });
	    },
	
	    limitToBound: function limitToBound(value, bound) {
	        var isNegativeValue = value < 0;
	        var newValue = Math.abs(value) > bound ? (isNegativeValue ? -1 : 1) * bound : value;
	        return newValue;
	    },
	
	    isNegative: function isNegative(n) {
	        return ((n = +n) || 1 / n) < 0;
	    },
	
	    handleWheel: function handleWheel(e) {
	        if (!e.shiftKey) {
	            return;
	        }
	        e.preventDefault();
	
	        var direction = this.isNegative(e.deltaX) && this.isNegative(e.deltaY) ? "out" : "in";
	        this.zoomImage(direction);
	    },
	
	    zoomImageIn: function zoomImageIn() {
	        this.zoomImage('in');
	    },
	
	    zoomImageOut: function zoomImageOut() {
	        this.zoomImage('out');
	    },
	
	    zoomImage: function zoomImage(direction) {
	        var ZOOM_SCALE_INCREMENTOR = 0.1;
	        var currentScale = this.state.scale;
	        var maxScale = this.state.maxScale;
	        var minScale = this.state.minScale;
	
	        if (direction == "in") {
	            currentScale += ZOOM_SCALE_INCREMENTOR;
	        } else {
	            currentScale -= ZOOM_SCALE_INCREMENTOR;
	        }
	
	        var divElement = this.refs.divElement.getDOMNode();
	        var maxAvailableX = Math.ceil(Math.abs((divElement.clientWidth * this.state.scale - divElement.clientWidth) / 2));
	        var maxAvailableY = Math.ceil(Math.abs((divElement.clientHeight * this.state.scale - divElement.clientHeight) / 2));
	        var x = this.limitToBound(this.state.x, maxAvailableX);
	        var y = this.limitToBound(this.state.y, maxAvailableY);
	
	        this.setState({ x: x, y: y, scale: currentScale < minScale ? minScale : currentScale > maxScale ? maxScale : currentScale });
	    },
	
	    fitToWidth: function fitToWidth() {
	        var divElement = this.refs.divElement.getDOMNode();
	        var divElementAspectRatio = divElement.clientWidth / divElement.clientHeight;
	
	        var imgWidth = this.props.width;
	        var imgHeight = this.props.height;
	        var imgAspectRatio = imgWidth / imgHeight;
	
	        if (divElementAspectRatio > imgAspectRatio) {
	            var newState = this.getInitialState();
	            newState.scale = divElementAspectRatio / imgAspectRatio;
	            this.setState(newState);
	        } else {
	            this.setState(this.getInitialState());
	        }
	    },
	
	    fitToPage: function fitToPage() {
	        this.setState(this.getInitialState());
	    },
	
	    render: function render() {
	        var styles = {
	            transform: 'translate(' + this.state.x + 'px, ' + this.state.y + 'px) scale(' + this.state.scale + ', ' + this.state.scale + ')'
	        };
	        return _react2['default'].createElement(
	            'div',
	            { className: this.props.multipleThumbnails ? 'image__viewer image__viewer__thumbnails' : 'image__viewer image__viewer__no__thumbnails',
	                onMouseDown: this.handleMouseDown,
	                onMouseUp: this.handleMouseUp,
	                onMouseLeave: this.handleMouseGoByeBye,
	                onMouseEnter: this.handleMouseEnter,
	                ref: 'divElement' },
	            _react2['default'].createElement('img', { className: 'media__preview__image media__preview__image__listitem',
	                src: this.props.src,
	                style: styles,
	                draggable: false }),
	            _react2['default'].createElement(_componentsImageViewerImageViewerButtons2['default'], { zoomImageIn: this.zoomImageIn,
	                zoomImageOut: this.zoomImageOut,
	                fitToWidth: this.fitToWidth,
	                fitToPage: this.fitToPage })
	        );
	    }
	});
	
	module.exports = ImageViewer;

/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var ImageViewerButtons = _react2['default'].createClass({
	    displayName: 'ImageViewerButtons',
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'image__viewer__buttons' },
	            _react2['default'].createElement(
	                'button',
	                { onClick: this.props.zoomImageIn,
	                    title: _utilsFlux2['default'].t('zoom-in') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'switch__button' },
	                    _react2['default'].createElement('i', { className: 'zoom-in' })
	                )
	            ),
	            _react2['default'].createElement(
	                'button',
	                { onClick: this.props.zoomImageOut,
	                    title: _utilsFlux2['default'].t('zoom-out') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'switch__button' },
	                    _react2['default'].createElement('i', { className: 'zoom-out' })
	                )
	            ),
	            _react2['default'].createElement(
	                'button',
	                { onClick: this.props.fitToWidth,
	                    title: _utilsFlux2['default'].t('fit-to-width') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'switch__button' },
	                    _react2['default'].createElement('i', { className: 'full-screen' })
	                )
	            ),
	            _react2['default'].createElement(
	                'button',
	                { onClick: this.props.fitToPage,
	                    title: _utilsFlux2['default'].t('fit-to-page') },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'switch__button' },
	                    _react2['default'].createElement('i', { className: 'expand' })
	                )
	            )
	        );
	    }
	});
	
	module.exports = ImageViewerButtons;

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _emailValidation = __webpack_require__(222);
	
	var _emailValidation2 = _interopRequireDefault(_emailValidation);
	
	var _tcombForm = __webpack_require__(64);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var Form = _tcombForm2['default'].form.Form;
	
	var PasswordReset = _tcombForm2['default'].struct({
	    email: _tcombForm2['default'].subtype(_tcombForm2['default'].Str, function (s) {
	        return _emailValidation2['default'].valid(s);
	    }),
	    code: _tcombForm2['default'].Str
	});
	
	var ConfirmEmailModal = _react2['default'].createClass({
	
	    displayName: 'ConfirmEmailModal',
	
	    mixins: [_reactRouter.Navigation],
	
	    propTypes: {
	        hasError: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool])
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            value: { email: this.props.query.email, code: this.props.query.code },
	            // This modal is only loaded after a request has been made already
	            // So we can check immediately if it succeeded or not
	            confirmSuccess: !!this.props.autoConfirmSuccess
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.autoConfirmSuccess) {
	            this.setState({
	                confirmSuccess: nextProps.autoConfirmSuccess
	            });
	        }
	    },
	
	    onChange: function onChange(value) {
	        this.setState({ value: value });
	    },
	
	    showLogin: function showLogin(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('app').clearError();
	        this.replaceWith('login', {}, { showDialog: true });
	    },
	
	    onSubmit: function onSubmit(evt) {
	        var _this = this;
	
	        evt.preventDefault();
	        var data = this.refs.form.getValue();
	        if (data) {
	            _utilsFlux2['default'].getStore('app').confirmEmail(data).then(function () {
	                _this.setState({ confirmSuccess: true });
	            });
	        }
	    },
	
	    renderError: function renderError() {
	        if (this.props.hasError) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'content__error' },
	                this.props.hasError
	            );
	        }
	    },
	
	    render: function render() {
	        if (this.state.confirmSuccess) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'content__success' },
	                _react2['default'].createElement(
	                    'h4',
	                    { className: 'register__success' },
	                    _utilsFlux2['default'].t('confirm_email_success_title')
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    _utilsFlux2['default'].t('confirm_email_success_message')
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.showLogin, type: 'button', className: 'btn btn-transparent btn-arrow-left' },
	                    _react2['default'].createElement('i', { className: 'chevron-left' }),
	                    _utilsFlux2['default'].t('back_to_login')
	                )
	            );
	        }
	
	        var options = {
	            auto: 'labels',
	            fields: {
	                email: {
	                    type: 'text',
	                    error: _utilsFlux2['default'].t('validation_email'),
	                    label: _utilsFlux2['default'].t('register_email')
	                },
	                code: {
	                    type: 'text',
	                    error: _utilsFlux2['default'].t('account_email_code_required'),
	                    label: _utilsFlux2['default'].t('account_email_code')
	                }
	            }
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('account_confirm_email_title')
	            ),
	            _react2['default'].createElement(
	                'form',
	                { onSubmit: this.onSubmit },
	                _react2['default'].createElement(Form, {
	                    ref: 'form',
	                    type: PasswordReset,
	                    options: options,
	                    value: this.state.value,
	                    onChange: this.onChange
	                }),
	                this.renderError(),
	                _react2['default'].createElement(
	                    'button',
	                    { type: 'submit', className: 'btn btn-primary btn-arrow' },
	                    _utilsFlux2['default'].t('confirm_email'),
	                    _react2['default'].createElement('i', { className: 'chevron-right' })
	                ),
	                _react2['default'].createElement('hr', { className: 'white' }),
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.showLogin, type: 'button', className: 'btn btn-transparent btn-arrow-left' },
	                    _react2['default'].createElement('i', { className: 'chevron-left' }),
	                    _utilsFlux2['default'].t('back_to_login')
	                )
	            )
	        );
	    }
	});
	
	module.exports = ConfirmEmailModal;

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var ConfirmModal = _react2['default'].createClass({
	    displayName: 'ConfirmModal',
	    propTypes: {
	        data: _react2['default'].PropTypes.object
	    },
	    render: function render() {
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                this.props.data.title
	            ),
	            _react2['default'].createElement(
	                'ul',
	                null,
	                this.props.data.basketNames.map(function (basketName) {
	                    return _react2['default'].createElement(
	                        'li',
	                        null,
	                        basketName
	                    );
	                })
	            ),
	            _react2['default'].createElement(
	                'button',
	                { onClick: this.props.data.onConfirm, className: 'btn btn-primary' },
	                _utilsFlux2['default'].t('confirm')
	            ),
	            _react2['default'].createElement(
	                'button',
	                { onClick: _utilsFlux2['default'].getActions('modals').closeModals, className: 'btn btn-secondary' },
	                _utilsFlux2['default'].t('cancel')
	            )
	        );
	    }
	});
	
	module.exports = ConfirmModal;

/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var ExcelSearchModal = _react2['default'].createClass({
	    displayName: 'ExcelSearchModal',
	    mixins: [_reactRouter.Navigation],
	
	    getInitialState: function getInitialState() {
	        var excelRights = _utilsFlux2['default'].getStore('media').getState().meta.toJS().excel_rights || JSON.parse(localStorage.getItem('excel_rights')) || [];
	        var firstKey = excelRights[0] ? excelRights[0].key : null;
	        return {
	            uploadFile: null,
	            selectedOption: firstKey,
	            excelError: null,
	            loading: false,
	            submitClicked: false
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (this.props.excelError) {
	            _utilsFlux2['default'].getActions('basket').clearErrorData();
	        }
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (!this.state.excelError && nextProps.excelError) {
	            this.setState({ excelError: nextProps.excelError, loading: false });
	        }
	    },
	
	    handleOptionChange: function handleOptionChange(changeEvent) {
	        this.setState({ selectedOption: changeEvent.target.value });
	    },
	
	    handleInputChange: function handleInputChange(changeEvent) {
	        this.setFile(changeEvent.target.files[0]);
	    },
	
	    handleFilePickerClick: function handleFilePickerClick(clickEvent) {
	        clickEvent.preventDefault();
	        var inputNode = this.refs.hiddenFileInput.getDOMNode();
	        inputNode.click();
	    },
	
	    setFile: function setFile(file) {
	        this.setState({ uploadFile: file });
	    },
	
	    activateLoading: function activateLoading() {
	        this.setState({ loading: true });
	    },
	
	    disableLoading: function disableLoading() {
	        this.setState({ loading: false });
	    },
	
	    submitForm: function submitForm() {
	        var _this = this;
	
	        if (!this.state.uploadFile) {
	            this.setState({ submitClicked: true });
	            return;
	        }
	
	        var formData = new FormData();
	        formData.append('feature', this.state.selectedOption);
	        formData.append('file', this.state.uploadFile);
	
	        this.activateLoading();
	        _utilsFlux2['default'].getStore('basket').excelSearch(formData).then(function (data) {
	            _this.disableLoading();
	            var basketId = data.success;
	            _this.transitionTo('singleBasket', { id: basketId });
	            _utilsFlux2['default'].getActions('modals').closeModals();
	        });
	    },
	
	    closeModal: function closeModal(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').closeModals();
	    },
	
	    renderExcelRights: function renderExcelRights() {
	        var _this2 = this;
	
	        var excelRights = _utilsFlux2['default'].getStore('media').getState().meta.toJS().excel_rights || JSON.parse(localStorage.getItem('excel_rights')) || [];
	        var radioButtons = excelRights.map(function (excelRight) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'form__group' },
	                _react2['default'].createElement('input', { type: 'radio', value: excelRight.key, checked: _this2.state.selectedOption === excelRight.key, onChange: _this2.handleOptionChange }),
	                _react2['default'].createElement(
	                    'span',
	                    null,
	                    excelRight.value
	                )
	            );
	        });
	        return radioButtons;
	    },
	
	    render: function render() {
	        var filePickerLabel = this.state.uploadFile ? this.state.uploadFile.name : _utilsFlux2['default'].t('no_file_selected');
	        var isRedText = !this.state.uploadFile && this.state.submitClicked;
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('excel_search')
	            ),
	            this.state.loading ? _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null) : this.state.excelError ? _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'p',
	                    { className: 'errorMessage' },
	                    _utilsFlux2['default'].t('excel_search_error')
	                ),
	                _react2['default'].createElement(
	                    'textarea',
	                    { className: 'errorMessage', disabled: true },
	                    this.state.excelError
	                )
	            ) : _react2['default'].createElement(
	                'form',
	                null,
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    _react2['default'].createElement(
	                        'b',
	                        null,
	                        _utilsFlux2['default'].t('excel_description')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    _utilsFlux2['default'].t('excel_info')
	                ),
	                this.renderExcelRights(),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'form__group' },
	                    _react2['default'].createElement(
	                        'button',
	                        { className: 'btn btn-border btn__modal__submit', onClick: this.handleFilePickerClick },
	                        _utilsFlux2['default'].t('choose_file')
	                    ),
	                    _react2['default'].createElement('input', {
	                        type: 'file',
	                        ref: 'hiddenFileInput',
	                        accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
	                        onChange: this.handleInputChange,
	                        style: { display: 'none' }
	                    }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'form__btn__label', style: isRedText ? { color: "#ff3838" } : {} },
	                        filePickerLabel
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'form__group form__group__submit' },
	                    _react2['default'].createElement(
	                        'button',
	                        { className: 'btn btn-border btn__modal__submit', onClick: this.submitForm, disabled: this.state.loading },
	                        _utilsFlux2['default'].t('upload_file')
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = ExcelSearchModal;
	/* <input type="file" onChange={this.handleInputChange} accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" /> */

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortal = __webpack_require__(129);
	
	var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _componentsModalsLoginModal = __webpack_require__(472);
	
	var _componentsModalsLoginModal2 = _interopRequireDefault(_componentsModalsLoginModal);
	
	var _componentsModalsRegisterModal = __webpack_require__(476);
	
	var _componentsModalsRegisterModal2 = _interopRequireDefault(_componentsModalsRegisterModal);
	
	var _componentsModalsPasswordForgottenModal = __webpack_require__(474);
	
	var _componentsModalsPasswordForgottenModal2 = _interopRequireDefault(_componentsModalsPasswordForgottenModal);
	
	var _componentsModalsMediaModal = __webpack_require__(473);
	
	var _componentsModalsMediaModal2 = _interopRequireDefault(_componentsModalsMediaModal);
	
	var _componentsModalsSharedModal = __webpack_require__(478);
	
	var _componentsModalsSharedModal2 = _interopRequireDefault(_componentsModalsSharedModal);
	
	var _componentsModalsInstantDownloadModal = __webpack_require__(471);
	
	var _componentsModalsInstantDownloadModal2 = _interopRequireDefault(_componentsModalsInstantDownloadModal);
	
	var _componentsModalsInstantDownloadAllModal = __webpack_require__(470);
	
	var _componentsModalsInstantDownloadAllModal2 = _interopRequireDefault(_componentsModalsInstantDownloadAllModal);
	
	var _componentsModalsShareModal = __webpack_require__(477);
	
	var _componentsModalsShareModal2 = _interopRequireDefault(_componentsModalsShareModal);
	
	var _componentsModalsConfirmModal = __webpack_require__(467);
	
	var _componentsModalsConfirmModal2 = _interopRequireDefault(_componentsModalsConfirmModal);
	
	var _componentsModalsWatermarkModal = __webpack_require__(479);
	
	var _componentsModalsWatermarkModal2 = _interopRequireDefault(_componentsModalsWatermarkModal);
	
	var _componentsModalsExcelSearchModal = __webpack_require__(468);
	
	var _componentsModalsExcelSearchModal2 = _interopRequireDefault(_componentsModalsExcelSearchModal);
	
	var _modal = __webpack_require__(191);
	
	var _modal2 = _interopRequireDefault(_modal);
	
	var ModalContainer = _react2['default'].createClass({
	    displayName: 'ModalContainer',
	    mixins: [],
	    propTypes: {},
	    render: function render() {
	        var openModal = this.props.modalStore.openModal;
	        // This is weird (Portal Bug), we have to
	        // pass in a listener for the modals store
	        // @TODO fix it!
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: openModal === 'Media' },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    { className: 'modal__media', closeOnOutsideClick: true },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: {
	                                modalStore: _utilsFlux2['default'].getStore('modals'),
	                                mediaStore: _utilsFlux2['default'].getStore('media')
	                            },
	                            transform: function (_ref) {
	                                var modalStore = _ref.modalStore;
	                                var mediaStore = _ref.mediaStore;
	
	                                var media = modalStore.data;
	                                var mediaMeta = mediaStore.modalMeta;
	                                var slotDefinitions = mediaStore.slotDefinitions;
	                                var modalOrientation = mediaStore.modalOrientation;
	                                var slotConfig = mediaStore.slotConfig;
	                                return { media: media, mediaMeta: mediaMeta, slotDefinitions: slotDefinitions, modalOrientation: modalOrientation, slotConfig: slotConfig };
	                            } },
	                        _react2['default'].createElement(_componentsModalsMediaModal2['default'], null)
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: openModal === 'InstantDownload' },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    { className: 'modal__instantdownload', closeOnOutsideClick: true },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: { modalStore: _utilsFlux2['default'].getStore('modals'), mediaStore: _utilsFlux2['default'].getStore('media') },
	                            transform: function (_ref2) {
	                                var modalStore = _ref2.modalStore;
	                                var mediaStore = _ref2.mediaStore;
	
	                                var media = modalStore.data;
	                                var quotaExceeded = mediaStore.quotaExceeded;
	
	                                return { media: media, quotaExceeded: quotaExceeded };
	                            } },
	                        _react2['default'].createElement(_componentsModalsInstantDownloadModal2['default'], null)
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: openModal === 'InstantDownloadAll' },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    { className: 'modal__instantdownload', closeOnOutsideClick: true },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: { modalStore: _utilsFlux2['default'].getStore('modals'), mediaStore: _utilsFlux2['default'].getStore('media') },
	                            transform: function (_ref3) {
	                                var modalStore = _ref3.modalStore;
	                                var mediaStore = _ref3.mediaStore;
	
	                                var media = modalStore.data;
	                                var quotaExceeded = mediaStore.quotaExceeded;
	
	                                return { media: media, quotaExceeded: quotaExceeded };
	                            } },
	                        _react2['default'].createElement(_componentsModalsInstantDownloadAllModal2['default'], null)
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: openModal === 'PasswordForgotten' },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    { className: 'modal__password-forgotten', closeOnOutsideClick: true },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: { appStore: _utilsFlux2['default'].getStore('app') },
	                            transform: function (_ref4) {
	                                var appStore = _ref4.appStore;
	
	                                var hasError = appStore.error;
	                                return { hasError: hasError };
	                            } },
	                        _react2['default'].createElement(_componentsModalsPasswordForgottenModal2['default'], null)
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: openModal === 'Login' },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    { className: 'modal__login', closeOnOutsideClick: true },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: { appStore: _utilsFlux2['default'].getStore('app') },
	                            transform: function (_ref5) {
	                                var appStore = _ref5.appStore;
	
	                                var hasError = appStore.error;
	                                return { hasError: hasError };
	                            } },
	                        _react2['default'].createElement(_componentsModalsLoginModal2['default'], null)
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: openModal === 'Register' },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    { className: 'modal__register', closeOnOutsideClick: false },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: { appStore: _utilsFlux2['default'].getStore('app') },
	                            transform: function (_ref6) {
	                                var appStore = _ref6.appStore;
	
	                                var hasError = appStore.error;
	                                return { hasError: hasError };
	                            } },
	                        _react2['default'].createElement(_componentsModalsRegisterModal2['default'], null)
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: openModal === 'Share' },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    { className: 'modal__share', closeOnOutsideClick: false },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: { basketStore: _utilsFlux2['default'].getStore('basket') },
	                            transform: function (_ref7) {
	                                var basketStore = _ref7.basketStore;
	
	                                var shareUrl = basketStore.shareUrl;
	                                return { shareUrl: shareUrl };
	                            } },
	                        _react2['default'].createElement(_componentsModalsShareModal2['default'], null)
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: openModal === 'Confirm' },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    { className: 'modal__confirm', closeOnOutsideClick: false },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: { appStore: _utilsFlux2['default'].getStore('app'), modalStore: _utilsFlux2['default'].getStore('modals') },
	                            transform: function (_ref8) {
	                                var modalStore = _ref8.modalStore;
	
	                                var data = modalStore.data;
	                                return { data: data };
	                            } },
	                        _react2['default'].createElement(_componentsModalsConfirmModal2['default'], null)
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: openModal === 'Watermark' },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    { className: 'modal__watermark', closeOnOutsideClick: true },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: { modalStore: _utilsFlux2['default'].getStore('modals') },
	                            transform: function (_ref9) {
	                                var modalStore = _ref9.modalStore;
	
	                                var media = modalStore.data;
	                                return { media: media };
	                            } },
	                        _react2['default'].createElement(_componentsModalsWatermarkModal2['default'], null)
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: openModal === 'ExcelSearch' },
	                _react2['default'].createElement(
	                    _modal2['default'],
	                    { className: 'modal__excelsearch', closeOnOutsideClick: true },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: { basketStore: _utilsFlux2['default'].getStore('basket') },
	                            transform: function (_ref10) {
	                                var basketStore = _ref10.basketStore;
	
	                                var excelError = basketStore.excelError;
	                                return { excelError: excelError };
	                            } },
	                        _react2['default'].createElement(_componentsModalsExcelSearchModal2['default'], null)
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = ModalContainer;

/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _componentsQuotaQuotaWarning = __webpack_require__(192);
	
	var _componentsQuotaQuotaWarning2 = _interopRequireDefault(_componentsQuotaQuotaWarning);
	
	var _componentsModalsInstantDownloadItem = __webpack_require__(274);
	
	var _componentsModalsInstantDownloadItem2 = _interopRequireDefault(_componentsModalsInstantDownloadItem);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var InstantDownloadAllModal = _react2['default'].createClass({
	
	    displayName: 'InstantDownloadAllModal',
	
	    propTypes: {
	        media: _react2['default'].PropTypes.object
	    },
	
	    toggleCheck: function toggleCheck(fileId, item, e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').setSelectedItemId(item.id);
	        _utilsFlux2['default'].getActions('modals').toggleDownloadAll(fileId);
	    },
	
	    checkFilesOfType: function checkFilesOfType(fileKey, e) {
	        e.preventDefault();
	        var elements = e.currentTarget.form;
	        for (var i = 0, element = undefined; element = elements[i++];) {
	            if (element.id == e.currentTarget.control.id) {
	                element.checked = !element.checked;
	                _utilsFlux2['default'].getActions('modals').setSelectedForFileKey(fileKey, element.checked);
	                break;
	            }
	        }
	    },
	
	    areAllFilesOfTypeChecked: function areAllFilesOfTypeChecked(fileKey) {
	        var items = this.props.media.toJS();
	        var allChecked = true;
	        for (var i = 0; i < items.length; i++) {
	            var item = items[i];
	            item.files.forEach(function (file) {
	                if (file.key == fileKey) {
	                    allChecked &= file._selected;
	                }
	            });
	        }
	        return allChecked;
	    },
	
	    handleDownload: function handleDownload(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').generateDownload();
	    },
	
	    handleOnSubmit: function handleOnSubmit(e) {
	        var _this = this;
	
	        e.preventDefault();
	
	        var assets = this.props.media.toJS();
	        var params = {};
	
	        for (var i = 0; i < assets.length; i++) {
	            var asset = assets[i];
	            asset.files.forEach(function (file) {
	                if (!file._selected) {
	                    return;
	                }
	
	                if (!params[asset.id]) {
	                    params[asset.id] = file.key;
	                } else {
	                    params[asset.id] += ',' + file.key;
	                }
	            });
	        }
	
	        _utilsFlux2['default'].getStore('media').checkQuota(params).then(function (response) {
	            var _flux$getStore$getState = _utilsFlux2['default'].getStore('media').getState();
	
	            var quotaExceeded = _flux$getStore$getState.quotaExceeded;
	
	            if (quotaExceeded) {
	                return false;
	            }
	
	            _this.refs.download.getDOMNode().submit();
	
	            asset.requires_watermark && _utilsFlux2['default'].getActions('modals').openWatermarkModal(_immutable2['default'].List([asset]));
	            _utilsFlux2['default'].getActions('modals').closeModals();
	        });
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        if (!this.props.media) {
	            return false;
	        }
	
	        var items = this.props.media.toJS();
	        var mediaboxToken = _store2['default'].get('mediabox_token');
	
	        var totalSelected = items.filter(function (item) {
	            return item.files.filter(function (file) {
	                return file._selected;
	            }).length > 0;
	        });
	
	        var flags = {};
	        var uniqueFiles = [];
	        for (var i = 0; i < items.length; i++) {
	            var item = items[i];
	            for (var y = 0; y < item.files.length; y++) {
	                var file = item.files[y];
	                if (flags[file.key]) continue;
	                flags[file.key] = true;
	                uniqueFiles.push(file);
	            }
	        }
	
	        var quotaExceeded = this.props.quotaExceeded;
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('instant_download')
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'modal__title' },
	                _react2['default'].createElement(
	                    'form',
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'title_element' },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'selection__title' },
	                            _utilsFlux2['default'].t('select_all'),
	                            ':'
	                        )
	                    ),
	                    uniqueFiles.map(function (file, ix) {
	                        return _react2['default'].createElement(
	                            'div',
	                            { className: 'title_element' },
	                            _react2['default'].createElement(
	                                'div',
	                                { key: 'basket_size_' + ix,
	                                    className: 'field__checkbox download__checkbox' },
	                                _react2['default'].createElement('input', { id: 'checkbox_' + ix,
	                                    checked: _this2.areAllFilesOfTypeChecked(file.key),
	                                    type: 'checkbox' }),
	                                _react2['default'].createElement(
	                                    'label',
	                                    { onClick: _this2.checkFilesOfType.bind(null, file.key),
	                                        htmlFor: 'checkbox_' + ix },
	                                    file.name
	                                )
	                            )
	                        );
	                    }),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'title_element' },
	                        _react2['default'].createElement(
	                            'button',
	                            { form: 'downloadForm', type: 'submit', type: 'submit', disabled: totalSelected.length === 0 || quotaExceeded,
	                                className: 'btn btn-border selection__download submit__instantdownload' },
	                            _react2['default'].createElement('i', { className: 'download' }),
	                            _utilsFlux2['default'].t('download')
	                        )
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'form',
	                { id: 'downloadForm', ref: 'download', onSubmit: this.handleOnSubmit, action: window.config.baseUrl + '/download', method: 'post' },
	                _react2['default'].createElement('input', { type: 'hidden', name: 'token', value: mediaboxToken }),
	                _react2['default'].createElement(_componentsQuotaQuotaWarning2['default'], null),
	                this.props.media.map(function (mediaItem) {
	                    return _react2['default'].createElement(_componentsModalsInstantDownloadItem2['default'], { media: mediaItem, toggleCheck: _this2.toggleCheck });
	                }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'instantdownload__footer' },
	                    _react2['default'].createElement(
	                        'button',
	                        { type: 'submit', disabled: totalSelected.length === 0 || quotaExceeded,
	                            className: 'btn btn-border selection__download submit__instantdownload' },
	                        _react2['default'].createElement('i', { className: 'download' }),
	                        _utilsFlux2['default'].t('download')
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = InstantDownloadAllModal;

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _componentsQuotaQuotaWarning = __webpack_require__(192);
	
	var _componentsQuotaQuotaWarning2 = _interopRequireDefault(_componentsQuotaQuotaWarning);
	
	var _componentsModalsInstantDownloadItem = __webpack_require__(274);
	
	var _componentsModalsInstantDownloadItem2 = _interopRequireDefault(_componentsModalsInstantDownloadItem);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var InstantDownloadModal = _react2['default'].createClass({
	
	    displayName: 'InstantDownloadModal',
	
	    propTypes: {
	        media: _react2['default'].PropTypes.object
	    },
	
	    toggleCheck: function toggleCheck(fileId, item, e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').toggleDownload(fileId);
	    },
	
	    handleDownload: function handleDownload(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').generateDownload();
	    },
	
	    handleOnSubmit: function handleOnSubmit(e) {
	        var _this = this;
	
	        e.preventDefault();
	        var asset = this.props.media.toJS();
	        var params = {};
	
	        asset.files.forEach(function (file) {
	            if (!file._selected) {
	                return;
	            }
	
	            if (!params[asset.id]) {
	                params[asset.id] = file.key;
	            } else {
	                params[asset.id] += ',' + file.key;
	            }
	        });
	
	        _utilsFlux2['default'].getStore('media').checkQuota(params).then(function (response) {
	            var _flux$getStore$getState = _utilsFlux2['default'].getStore('media').getState();
	
	            var quotaExceeded = _flux$getStore$getState.quotaExceeded;
	
	            if (quotaExceeded) {
	                return false;
	            }
	
	            _this.refs.download.getDOMNode().submit();
	
	            asset.requires_watermark && _utilsFlux2['default'].getActions('modals').openWatermarkModal(_immutable2['default'].List([asset]));
	            _utilsFlux2['default'].getActions('modals').closeModals();
	        });
	    },
	
	    render: function render() {
	        if (!this.props.media) {
	            return false;
	        }
	
	        var mediaboxToken = _store2['default'].get('mediabox_token');
	        var totalSelected = _utilsFlux2['default'].getStore('modals').getSelectedInstantDownloadItems();
	        var quotaExceeded = this.props.quotaExceeded;
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('instant_download')
	            ),
	            _react2['default'].createElement(
	                'form',
	                { ref: 'download', onSubmit: this.handleOnSubmit, action: window.config.baseUrl + '/download', method: 'post' },
	                _react2['default'].createElement('input', { type: 'hidden', name: 'token', value: mediaboxToken }),
	                _react2['default'].createElement(_componentsModalsInstantDownloadItem2['default'], { media: this.props.media, toggleCheck: this.toggleCheck }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'instantdownload__footer' },
	                    _react2['default'].createElement(_componentsQuotaQuotaWarning2['default'], null),
	                    _react2['default'].createElement(
	                        'button',
	                        { type: 'submit', disabled: totalSelected.length === 0 || quotaExceeded, className: 'btn btn-border selection__download submit__instantdownload' },
	                        _react2['default'].createElement('i', { className: 'download' }),
	                        _utilsFlux2['default'].t('download')
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = InstantDownloadModal;

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _tcombForm = __webpack_require__(64);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _emailValidation = __webpack_require__(222);
	
	var _emailValidation2 = _interopRequireDefault(_emailValidation);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _lodash = __webpack_require__(109);
	
	var Form = _tcombForm2['default'].form.Form;
	
	var validation = _utilsFlux2['default'].getStore('app').getState().config.get('validation').toJS();
	var usernameValidation = _tcombForm2['default'].Str;
	
	if (!(0, _lodash.isEmpty)(validation) && validation.username) {
	    if ('email' === validation.username) {
	        usernameValidation = _tcombForm2['default'].subtype(_tcombForm2['default'].Str, function (s) {
	            return _emailValidation2['default'].valid(s);
	        });
	    }
	    // else if ( 'object' === typeof validation.username && 'test' in validation.username ) {
	    //     usernameValidation = t.subtype( t.Str, s => validation.username.test( s ) );
	    // }
	}
	
	var Login = _tcombForm2['default'].struct({
	    email: usernameValidation,
	    password: _tcombForm2['default'].Str,
	    remember_me: _tcombForm2['default'].Bool
	});
	
	var LoginModal = _react2['default'].createClass({
	    displayName: 'LoginModal',
	    mixins: [_reactRouter.Navigation],
	    propTypes: {
	        hasError: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool])
	    },
	    getInitialState: function getInitialState() {
	        return {
	            email: '',
	            password: '',
	            remember_me: false
	        };
	    },
	    showRegister: function showRegister(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openModal('Register');
	    },
	    showPasswordForgotten: function showPasswordForgotten(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openModal('PasswordForgotten');
	    },
	    onChange: function onChange(value) {
	        this.setState({ value: value });
	    },
	    onSubmit: function onSubmit(evt) {
	        var _this = this;
	
	        evt.preventDefault();
	        var location = this.props.location;
	
	        var loginData = this.refs.form.getValue();
	        if (loginData) {
	            _utilsFlux2['default'].getStore('app').loginUser(loginData).then(function () {
	                _utilsFlux2['default'].getActions('modals').closeModals();
	                _utilsFlux2['default'].getStore('basket').loadBaskets();
	                var query = _this.context.router.getCurrentQuery();
	                if (query.nextPath && query.nextPath.length > 1) {
	                    _this.transitionTo(query.nextPath, {});
	                } else {
	                    _this.replaceWith('landing-page');
	                }
	            });
	        }
	    },
	    renderError: function renderError() {
	        if (this.props.hasError) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'content__error' },
	                this.props.hasError
	            );
	        }
	    },
	    renderHelp: function renderHelp() {
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var supportLink = _flux$getStore$getState$config$toJS.supportLink;
	
	        if (supportLink.length) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'login__support' },
	                _utilsFlux2['default'].t('need_help'),
	                ' ',
	                _react2['default'].createElement(
	                    'a',
	                    { href: supportLink },
	                    _utilsFlux2['default'].t('email_us')
	                )
	            );
	        }
	    },
	
	    renderRegistration: function renderRegistration() {
	        var _flux$getStore$getState$config$toJS2 = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var hideRegistration = _flux$getStore$getState$config$toJS2.hideRegistration;
	
	        if (!hideRegistration) {
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'hint__label' },
	                    _utilsFlux2['default'].t('no_account')
	                ),
	                _react2['default'].createElement(
	                    'a',
	                    { className: 'hint__link', href: '#', onClick: this.showRegister },
	                    _utilsFlux2['default'].t('apply_account')
	                )
	            );
	        }
	    },
	
	    render: function render() {
	        var options = {
	            fields: {
	                email: {
	                    error: _utilsFlux2['default'].t('validation_email'),
	                    label: _utilsFlux2['default'].t('account_username'),
	                    attrs: {
	                        autoFocus: true
	                    }
	                },
	                password: {
	                    type: 'password',
	                    label: _utilsFlux2['default'].t('account_password'),
	                    error: _utilsFlux2['default'].t('validation_password')
	                },
	                remember_me: {
	                    label: _react2['default'].createElement('span', { dangerouslySetInnerHTML: { __html: _utilsFlux2['default'].t('account_remember_me') } })
	                }
	            }
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('navigate_login')
	            ),
	            _react2['default'].createElement(
	                'form',
	                { onSubmit: this.onSubmit, className: (0, _classnames2['default'])({ 'has-error': this.props.hasError }) },
	                _react2['default'].createElement(Form, {
	                    ref: 'form',
	                    type: Login,
	                    options: options,
	                    value: this.state.value,
	                    onChange: this.onChange
	                }),
	                this.renderError(),
	                _react2['default'].createElement(
	                    'a',
	                    { href: '#', className: 'login__forgotpassword', onClick: this.showPasswordForgotten },
	                    _utilsFlux2['default'].t('password_forgotten')
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { className: 'login__button btn btn-primary btn-arrow', type: 'submit' },
	                    _utilsFlux2['default'].t('navigate_login'),
	                    _react2['default'].createElement('i', { className: 'chevron-right' })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'login__hint' },
	                    _react2['default'].createElement('hr', { className: 'white' }),
	                    this.renderRegistration(),
	                    this.renderHelp()
	                )
	            )
	        );
	    }
	});
	
	module.exports = LoginModal;

/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _videoJs = __webpack_require__(270);
	
	var _videoJs2 = _interopRequireDefault(_videoJs);
	
	var _videojsResolutionSwitcher = __webpack_require__(1026);
	
	var _videojsResolutionSwitcher2 = _interopRequireDefault(_videojsResolutionSwitcher);
	
	var _reactRouter = __webpack_require__(7);
	
	var _queryString = __webpack_require__(167);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _screenfull = __webpack_require__(402);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _componentsBasketBasketDropdown = __webpack_require__(144);
	
	var _componentsBasketBasketDropdown2 = _interopRequireDefault(_componentsBasketBasketDropdown);
	
	var _pagesMediaMediaListingItemNotification = __webpack_require__(195);
	
	var _pagesMediaMediaListingItemNotification2 = _interopRequireDefault(_pagesMediaMediaListingItemNotification);
	
	var _lodashLangCloneDeep = __webpack_require__(68);
	
	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);
	
	var _componentsImageViewerImageViewer = __webpack_require__(464);
	
	var _componentsImageViewerImageViewer2 = _interopRequireDefault(_componentsImageViewerImageViewer);
	
	var _componentsHtmlViewerHtmlViewer = __webpack_require__(463);
	
	var _componentsHtmlViewerHtmlViewer2 = _interopRequireDefault(_componentsHtmlViewerHtmlViewer);
	
	var _componentsThumbnailViewerThumbnailViewer = __webpack_require__(483);
	
	var _componentsThumbnailViewerThumbnailViewer2 = _interopRequireDefault(_componentsThumbnailViewerThumbnailViewer);
	
	var MediaModal = _react2['default'].createClass({
	
	    displayName: 'MediaModal',
	
	    propTypes: {
	        media: _react2['default'].PropTypes.object
	    },
	
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        var tempArray = this.props.media.toJS().thumbnails.map(function (thumbnail) {
	            var previewImage = thumbnail.preview;
	            previewImage.hidden = "none";
	            return previewImage;
	        });
	        tempArray[0].hidden = "block";
	        return {
	            autoResolution: true,
	            videoPlayed: false,
	            previewArray: tempArray,
	            currentIndex: 0
	        };
	    },
	
	    handleViewOrientation: function handleViewOrientation() {
	        var modalMedia = document.querySelector('.modal__media');
	        var orientation = this.props.modalOrientation;
	
	        if (typeof orientation === 'undefined') {
	            orientation = 'default';
	        }
	
	        modalMedia.className = 'modal modal__media modal__media--' + orientation;
	    },
	
	    componentWillMount: function componentWillMount() {},
	
	    componentDidMount: function componentDidMount() {
	        this.handleViewOrientation();
	
	        if ('video' === this.props.media.toJS().type) {
	            this.setupVideoPlayer();
	        } else if (Modernizr && !Modernizr.objectfit) {
	            // Polyfill object-fit: contain
	            var image = this.refs.preview.getDOMNode(),
	                _parent = image.parentNode;
	
	            if (!_parent) return;
	
	            image.style.display = 'none';
	            _parent.style.backgroundImage = 'url(' + image.src + ')';
	        }
	
	        window.addEventListener('resize', this, false);
	        document.addEventListener('fullscreenchange', this, false);
	        document.addEventListener('mozfullscreenchange', this, false);
	        document.addEventListener('webkitfullscreenchange', this, false);
	        document.addEventListener('click', this, true);
	        document.addEventListener("keydown", this.detectArrowPress, false);
	        this.resize();
	        if ('video' === this.props.media.toJS().type && this.state.videoPlayed) {
	            this.player.play();
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        if (this.player) {
	            this.player.dispose();
	        }
	        window.removeEventListener('resize', this, false);
	        document.removeEventListener('fullscreenchange', this, false);
	        document.removeEventListener('mozfullscreenchange', this, false);
	        document.removeEventListener('webkitfullscreenchange', this, false);
	        document.removeEventListener('click', this, true);
	        document.removeEventListener("keydown", this.detectArrowPress, false);
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        this.componentDidMount();
	    },
	
	    detectArrowPress: function detectArrowPress(event) {
	        var metaData = this.props.mediaMeta.toJS();
	        var media = this.props.media.toJS();
	        // right arrow
	        if (event.keyCode === 39) {
	            if (this.showNextPageArrow(media, metaData)) {
	                this.switchToNextItem();
	            }
	        }
	        // left arrow
	        if (event.keyCode === 37) {
	            if (this.showPreviousPageArrow(media, metaData)) {
	                this.switchToPreviousItem();
	            }
	        }
	    },
	    // {`${media.indexInResults+1+(metaData.page-1)*10} ${flux.t('pagination_of')} ${metaData.total_records}`}
	
	    showNextPageArrow: function showNextPageArrow(media, metaData) {
	        var current = media.indexInResults + 1 + (metaData.page - 1) * metaData.per_page;
	        return current < metaData.total_records;
	    },
	
	    showPreviousPageArrow: function showPreviousPageArrow(media, metaData) {
	        return !media.firstElementOfResults || metaData.page !== 1;
	    },
	
	    showNextContentArrow: function showNextContentArrow(media, metaData) {
	        var thumbnailImages = media.thumbnails;
	        var previewImages = thumbnailImages.map(function (thumbnail) {
	            return thumbnail.preview;
	        });
	        var numImages = previewImages.length;
	        if (numImages >= 2) {
	            return true;
	        }
	        return false;
	    },
	
	    showPreviousContentArrow: function showPreviousContentArrow(media, metaData) {
	        var thumbnailImages = media.thumbnails;
	        var previewImages = thumbnailImages.map(function (thumbnail) {
	            return thumbnail.preview;
	        });
	        var numImages = previewImages.length;
	        if (numImages >= 2) {
	            return true;
	        }
	        return false;
	    },
	
	    handleEvent: function handleEvent(e) {
	        if ('resize' === e.type) {
	            window.requestAnimationFrame && window.requestAnimationFrame(this.resize);
	            !window.requestAnimationFrame && this.resize();
	        } else if (e.type.indexOf('fullscreenchange') > -1) {
	            this.updateVideoResolution();
	        } else if ('click' === e.type) {
	            var target = e.target;
	            var className = e.target.className;
	
	            if (className.indexOf('vjs-menu-item') > -1 && target.parentNode.parentNode.parentNode.className.indexOf('vjs-resolution-button') > -1) {
	                this.setState({
	                    autoResolution: false
	                });
	            }
	        }
	    },
	
	    setupVideoPlayer: function setupVideoPlayer() {
	        var media = this.props.media.toJS();
	        var videoWrapper = document.createElement('VIDEO');
	        var video = this.refs.video.getDOMNode();
	
	        video.innerHTML = '';
	        if ('video' !== this.props.media.toJS().type) {
	            return;
	        }
	
	        _utilsDom2['default'].setAttributes(videoWrapper, {
	            'class': 'video-js vjs-default-skin',
	            controls: true,
	            preload: 'auto',
	            poster: _utilsApi2['default'].cachedImagePath(Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src)
	        });
	
	        var mapQualToLabel = function mapQualToLabel(quality) {
	            switch (quality) {
	                case 'full':
	                    return {
	                        label: 'HD',
	                        res: 1080
	                    };
	                case 'low':
	                    return {
	                        label: 'SD',
	                        res: 720
	                    };
	            }
	            return {
	                label: quality,
	                res: null
	            };
	        };
	
	        var sources = [];
	
	        media.videos.forEach(function (video) {
	            var quality = mapQualToLabel(video.quality);
	            sources.push({
	                src: video.url,
	                type: video.mimeType,
	                label: quality.label,
	                res: quality.res
	            });
	        });
	
	        video.appendChild(videoWrapper);
	
	        this.player = (0, _videoJs2['default'])(videoWrapper, {
	            sources: sources,
	            plugins: {
	                videoJsResolutionSwitcher: {
	                    'default': 'low'
	                }
	            }
	        });
	    },
	
	    updateVideoResolution: function updateVideoResolution() {
	        var autoResolution = this.state.autoResolution;
	
	        if (!autoResolution) {
	            return;
	        }
	
	        if (_screenfull2['default'].isFullscreen) {
	            this.player.currentResolution('HD');
	        } else {
	            this.player.currentResolution('SD');
	        }
	    },
	
	    generateInstantDownload: function generateInstantDownload(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openInstantDownloadModal(this.props.media);
	    },
	
	    toggleCheck: function toggleCheck(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').toggleItemSelection(this.props.media.get('id'));
	    },
	
	    toggleBasketFix: function toggleBasketFix(e) {
	        e.preventDefault();
	        var id = this.props.media.get('id');
	        var order = _utilsFlux2['default'].getStore('media').getState().media.findIndex(function (item) {
	            return item.get('id') === id;
	        });
	        _utilsFlux2['default'].getActions('modals').openMediaModal(_utilsFlux2['default'].getStore('media').getState().media.get(order));
	
	        if (!this.props.media.get('_basket')) {
	            _utilsFlux2['default'].getActions('media').toggleBasket(id);
	            _utilsFlux2['default'].getActions('modals').openMediaModal(_utilsFlux2['default'].getStore('media').getState().media.get(order));
	        }
	    },
	
	    renderBasket: function renderBasket() {
	        if (this.props.media.get('_basket') && _utilsFlux2['default'].getStore('modals').getState().openModal) {
	            var mediaId = this.props.media.get('id');
	            var mediaName = this.props.media.get('name') || this.props.media.get('title');
	            return _react2['default'].createElement(
	                _altContainer2['default'],
	                {
	                    stores: { basketStore: _utilsFlux2['default'].getStore('basket') },
	                    transform: function (_ref) {
	                        var basketStore = _ref.basketStore;
	
	                        var baskets = basketStore.baskets;
	                        var slotDefinitions = basketStore.slotDefinitions;
	                        return { baskets: baskets, slotDefinitions: slotDefinitions };
	                    } },
	                _react2['default'].createElement(_componentsBasketBasketDropdown2['default'], { mediaId: mediaId, mediaName: mediaName, media: this.props.media, isFooter: true })
	            );
	        }
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var tempArray = nextProps.media.toJS().thumbnails.map(function (thumbnail) {
	            var previewImage = thumbnail.preview;
	            previewImage.hidden = "none";
	            return previewImage;
	        });
	        tempArray[0].hidden = "block";
	
	        this.setState({
	            videoPlayed: false,
	            previewArray: tempArray,
	            currentIndex: 0
	        });
	    },
	
	    switchToNextItem: function switchToNextItem() {
	        if (this.props.media.toJS().lastElementOfResults) {
	            var query = (0, _lodashLangCloneDeep2['default'])(this.context.router.getCurrentQuery());
	            query.page = _utilsFlux2['default'].getStore('media').getState().modalMeta.toJS().page + 1;
	            _utilsFlux2['default'].getActions('media').fetchNextPage();
	            _utilsFlux2['default'].getStore('media').loadMediaModals(query);
	        } else {
	            _utilsFlux2['default'].getActions('media').setNextElement(this.props.media.get('id'));
	            var nextElement = _utilsFlux2['default'].getStore('media').getState().nextElement;
	            _utilsFlux2['default'].getActions('modals').openMediaModal(nextElement);
	            this.props.media = nextElement;
	        }
	    },
	
	    switchToPreviousItem: function switchToPreviousItem() {
	        if (this.props.media.toJS().firstElementOfResults) {
	            _utilsFlux2['default'].getActions('media').fetchPreviousPage();
	            var query = (0, _lodashLangCloneDeep2['default'])(this.context.router.getCurrentQuery());
	            query.page = _utilsFlux2['default'].getStore('media').getState().modalMeta.toJS().page - 1;
	            _utilsFlux2['default'].getStore('media').loadMediaModals(query);
	        } else {
	            _utilsFlux2['default'].getActions('media').setPreviousElement(this.props.media.get('id'));
	            var previousElement = _utilsFlux2['default'].getStore('media').getState().previousElement;
	            _utilsFlux2['default'].getActions('modals').openMediaModal(previousElement);
	            this.props.media = previousElement;
	        }
	        var tempArray = this.props.media.toJS().thumbnails.map(function (thumbnail) {
	            var previewImage = thumbnail.preview;
	            previewImage.hidden = "none";
	            return previewImage;
	        });
	        tempArray[0].hidden = "block";
	
	        this.setState({
	            videoPlayed: false,
	            previewArray: tempArray,
	            currentIndex: 0
	        });
	    },
	
	    switchToPreviousImage: function switchToPreviousImage(currentIdx) {
	        var _this = this;
	
	        var copiedPreviewArray = [].concat(_toConsumableArray(this.state.previewArray));
	        if (currentIdx === 0) {
	            // do nothing
	        } else {
	                copiedPreviewArray.map(function (value, index) {
	                    if (index === currentIdx) {
	                        _this.setHidden(value);
	                    }
	                    if (index === currentIdx - 1) {
	                        _this.setVisible(value);
	                    }
	                });
	                this.setState({
	                    previewArray: copiedPreviewArray,
	                    currentIndex: currentIdx - 1
	                });
	            }
	    },
	
	    switchToNextImage: function switchToNextImage(currentIdx) {
	        var _this2 = this;
	
	        var copiedPreviewArray = [].concat(_toConsumableArray(this.state.previewArray));
	        if (currentIdx === copiedPreviewArray.length - 1) {
	            // do nothing
	        } else {
	                copiedPreviewArray.map(function (value, index) {
	                    if (index === currentIdx) {
	                        _this2.setHidden(value);
	                    }
	                    if (index === currentIdx + 1) {
	                        _this2.setVisible(value);
	                    }
	                });
	                this.setState({
	                    previewArray: copiedPreviewArray,
	                    currentIndex: currentIdx + 1
	                });
	            }
	    },
	
	    resize: function resize() {
	        var previewImg = this.props.media.toJS().thumbnails[0].preview,
	            previewImgRatio = this._cache && this._cache.previewImgRatio || previewImg.width / previewImg.height,
	            desiredHeight = undefined,
	            maxHeight = undefined;
	
	        var _props$media$toJS = this.props.media.toJS();
	
	        var type = _props$media$toJS.type;
	
	        // constants
	        var MARGIN = 20,
	            RATIO = 16 / 9;
	
	        if (this._cache && window.innerHeight === this._cache.windowHeight) {
	            return;
	        } else if (!this._cache) {
	            this._cache = {
	                descEl: this.refs.description.getDOMNode(),
	                previewEl: this.refs.preview ? this.refs.preview.getDOMNode().parentNode : this.refs.video.getDOMNode().childNodes[0],
	                contentEl: this.refs.modalInner.getDOMNode().parentNode,
	                previewImgRatio: previewImgRatio
	            };
	        }
	        this._cache.windowHeight = window.innerHeight;
	        this._cache.descriptionHeight = this._cache.descEl.offsetHeight;
	        this._cache.previewWidth = this._cache.previewEl.offsetWidth;
	
	        if ('video' !== type && previewImgRatio < RATIO) {
	            // adjust container size
	            desiredHeight = this._cache.previewWidth / previewImgRatio;
	            maxHeight = this._cache.windowHeight - this._cache.descriptionHeight - MARGIN * 2;
	            this._cache.previewEl.style.paddingTop = (Math.min(desiredHeight, maxHeight) / this._cache.previewWidth * 100).toFixed(3) + '%';
	        }
	
	        // center vertically
	        var marginTop = 'video' !== type ? Math.floor(Math.max(MARGIN, (this._cache.windowHeight - this._cache.contentEl.offsetHeight) / 2)) : Math.floor(Math.max(MARGIN, (this._cache.windowHeight - (this._cache.contentEl.offsetWidth / RATIO + this._cache.descriptionHeight)) / 2));
	        this._cache.contentEl.style.marginTop = marginTop + 'px';
	    },
	
	    clickOnVideoModal: function clickOnVideoModal() {
	        var videoPlayed = this.state.videoPlayed;
	        if (!videoPlayed) {
	            this.setState({
	                videoPlayed: !videoPlayed
	            });
	        }
	    },
	
	    setHidden: function setHidden(thumbnail) {
	        thumbnail.hidden = 'none';
	    },
	
	    setVisible: function setVisible(thumbnail) {
	        thumbnail.hidden = 'block';
	    },
	
	    renderMediaViewer: function renderMediaViewer() {
	        var _this3 = this;
	
	        return this.state.previewArray.map(function (value, index) {
	
	            return _react2['default'].createElement(
	                'div',
	                { className: 'thumbnail__div', id: index, style: { display: value.hidden } },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'arrow-wrapper-document-viewer' },
	                    _react2['default'].createElement(
	                        'button',
	                        { hidden: index === 0, onClick: function () {
	                                return _this3.switchToPreviousImage(index);
	                            },
	                            className: 'actions__switch-previous',
	                            title: _utilsFlux2['default'].t('pagination_back') },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'switch__button' },
	                            _react2['default'].createElement('i', { className: 'chevron-left' })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'button',
	                        { hidden: index === _this3.state.previewArray.length - 1,
	                            onClick: function () {
	                                return _this3.switchToNextImage(index);
	                            }, className: 'actions__switch-next',
	                            title: _utilsFlux2['default'].t('pagination_next') },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'switch__button' },
	                            _react2['default'].createElement('i', { className: 'chevron-right' })
	                        )
	                    )
	                ),
	                _react2['default'].createElement(_componentsImageViewerImageViewer2['default'], { src: value.src, width: value.width, height: value.height, multipleThumbnails: _this3.state.previewArray.length > 1, ref: 'preview' })
	            );
	        });
	    },
	
	    renderMediaPreview: function renderMediaPreview() {
	        var _this4 = this;
	
	        var media = this.props.media.toJS();
	        var mediaType = media.type;
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var archiveColor = _flux$getStore$getState$config$toJS.archiveColor;
	        var embargoColor = _flux$getStore$getState$config$toJS.embargoColor;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])('media__image', 'media__image--type__' + mediaType), ref: 'mediaImageContainer' },
	            'video' === mediaType && _react2['default'].createElement('div', { ref: 'video', className: 'item__preview__overlay ' + this.state.videoPlayed,
	                onClick: this.clickOnVideoModal }),
	            media.embargo && _react2['default'].createElement('div', { className: 'item__preview__overlay', style: { border: '5px solid ' + embargoColor } }),
	            media.archived && _react2['default'].createElement('div', { className: 'item__preview__overlay', style: { border: '5px solid ' + archiveColor } }),
	            (function () {
	                if ('video' !== mediaType && _this4.state.previewArray) {
	                    var numImages = _this4.state.previewArray.length;
	                    if (numImages === 1) {
	                        if (_this4.state.previewArray[0].src.includes('/text-preview/')) {
	                            return _react2['default'].createElement(_componentsHtmlViewerHtmlViewer2['default'], { url: _this4.state.previewArray[0].src, ref: 'preview' });
	                        }
	                        return _react2['default'].createElement(_componentsImageViewerImageViewer2['default'], { src: _this4.state.previewArray[0].src, width: _this4.state.previewArray[0].width, height: _this4.state.previewArray[0].height, multipleThumbnails: _this4.state.previewArray.length > 1, ref: 'preview' });
	                    }
	                    if (numImages >= 2) {
	                        return _react2['default'].createElement(
	                            'div',
	                            { className: 'preview__list' },
	                            _this4.renderMediaViewer()
	                        );
	                    }
	                }
	            })(),
	            media.thumbnails.length > 1 ? _react2['default'].createElement(_componentsThumbnailViewerThumbnailViewer2['default'], {
	                thumbnails: media.thumbnails,
	                currentIndex: this.state.currentIndex,
	                goToFirstImage: this.goToFirstImage,
	                goToPreviousImage: this.goToPreviousImage,
	                goToNextImage: this.goToNextImage,
	                goToLastImage: this.goToLastImage,
	                goToIndex: this.goToIndex }) : ""
	        );
	    },
	
	    goToFirstImage: function goToFirstImage() {
	        var copiedPreviewArray = [].concat(_toConsumableArray(this.state.previewArray));
	        copiedPreviewArray.map(function (value, index) {
	            if (index === 0) {
	                value.hidden = 'block';
	            } else {
	                value.hidden = 'none';
	            }
	        });
	        this.setState({
	            previewArray: copiedPreviewArray,
	            currentIndex: 0
	        });
	    },
	
	    goToPreviousImage: function goToPreviousImage() {
	        this.switchToPreviousImage(this.state.currentIndex);
	    },
	
	    goToNextImage: function goToNextImage() {
	        this.switchToNextImage(this.state.currentIndex);
	    },
	
	    goToIndex: function goToIndex(index, e) {
	        e.preventDefault();
	        var copiedPreviewArray = [].concat(_toConsumableArray(this.state.previewArray));
	        copiedPreviewArray.map(function (value, idx) {
	            if (idx === index) {
	                value.hidden = 'block';
	            } else {
	                value.hidden = 'none';
	            }
	        });
	        this.setState({
	            previewArray: copiedPreviewArray,
	            currentIndex: index
	        });
	    },
	
	    goToLastImage: function goToLastImage() {
	        var copiedPreviewArray = [].concat(_toConsumableArray(this.state.previewArray));
	        copiedPreviewArray.map(function (value, index) {
	            if (index === copiedPreviewArray.length - 1) {
	                value.hidden = 'block';
	            } else {
	                value.hidden = 'none';
	            }
	        });
	        this.setState({
	            previewArray: copiedPreviewArray,
	            currentIndex: this.state.previewArray.length - 1
	        });
	    },
	
	    renderTags: function renderTags() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'description__tags' },
	            this.props.media.toJS().tags.map(function (tag, ix) {
	                return _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { key: 'tag_' + ix, onClick: _utilsFlux2['default'].getActions('modals').closeModals, to: 'listing',
	                        className: 'btn btn-small btn-primary tags__button',
	                        query: _queryString2['default'].parse(tag.link) },
	                    tag.name
	                );
	            })
	        );
	    },
	
	    shareItem: function shareItem() {
	        // Dont want to duplicate Share modal, so we use already existing store to set up shareurl
	        _utilsFlux2['default'].getStore('basket').setShareUrl(window.location.origin + '/#/media?search=' + this.props.media.toJS().id);
	        _utilsFlux2['default'].getActions('modals').setModalInModal(this.props.media.toJS().id);
	        _utilsFlux2['default'].getActions('modals').openModal('Share');
	    },
	
	    renderSlots: function renderSlots() {
	        var _this5 = this;
	
	        var slotDefinitions = this.props.slotDefinitions.toJS();
	
	        var slotConfig = this.props.slotConfig;
	        return _react2['default'].createElement(
	            'div',
	            { className: 'description__slots' },
	            slotConfig.slice(2).map(function (slot) {
	                var id = slot.toString();
	                var currentSlotDefinition = slotDefinitions.filter(function (slot) {
	                    return slot.id === id;
	                });
	                var currentSlot = _this5.props.media.toJS().slots.filter(function (slot) {
	                    return slot.id === id;
	                });
	
	                if (currentSlot[0] && (currentSlot[0].content || currentSlot[0].color || currentSlot[0].icon) && currentSlotDefinition[0]) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { className: 'description__item' },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: 'description__item--title' },
	                            currentSlotDefinition[0].name
	                        ),
	                        _this5.renderSlotProperties(currentSlot[0])
	                    );
	                }
	            })
	        );
	    },
	
	    renderSlotProperties: function renderSlotProperties(slot) {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'slot' },
	            Object.keys(slot).map(function (key) {
	                switch (key) {
	                    case 'content':
	                        return _react2['default'].createElement(
	                            'span',
	                            { key: key,
	                                className: 'slot-property slot-property__' + key },
	                            ' ',
	                            slot[key]
	                        );
	                    case 'color':
	                        return _react2['default'].createElement('span', { key: key, className: 'slot-property slot-property__' + key,
	                            style: { backgroundColor: slot[key] } });
	                    case 'icon':
	                        return _react2['default'].createElement(
	                            'span',
	                            { key: key, className: 'slot-property slot-property__' + key },
	                            _react2['default'].createElement('img', {
	                                src: slot[key] })
	                        );
	                    default:
	                        return null;
	                }
	            })
	        );
	    },
	
	    render: function render() {
	        if (!this.props.media || !this.props.media.toJS()) {
	            return;
	        }
	
	        var media = this.props.media.toJS();
	        var metaData = this.props.mediaMeta.toJS();
	        var slotConfig = this.props.slotConfig;
	        var isAuthenticated = _utilsFlux2['default'].getStore('app').isAuthenticated();
	        var title = media.slots.filter(function (slot) {
	            return slot.id === slotConfig[0].toString();
	        });
	        var description = media.slots.filter(function (slot) {
	            return slot.id === slotConfig[1].toString();
	        });
	
	        var _flux$getStore$getState$config$toJS2 = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var shareMode = _flux$getStore$getState$config$toJS2.shareMode;
	
	        return _react2['default'].createElement(
	            'div',
	            { ref: 'modalInner', className: 'modal__flex__wrapper' },
	            _react2['default'].createElement(
	                _altContainer2['default'],
	                {
	                    stores: { notificationsStore: _utilsFlux2['default'].getStore('notifications') },
	                    transform: function (_ref2) {
	                        var notificationsStore = _ref2.notificationsStore;
	
	                        var notifications = notificationsStore.notifications.filter(function (notification) {
	                            return notification.mediaId === media.id;
	                        });
	                        return { notifications: notifications };
	                    } },
	                _react2['default'].createElement(_pagesMediaMediaListingItemNotification2['default'], null)
	            ),
	            this.renderMediaPreview(),
	            _react2['default'].createElement(
	                'div',
	                { className: 'media__wrapper' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'media__description', ref: 'description' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'description__info' },
	                        title[0] && title[0].content && slotConfig[0] && _react2['default'].createElement(
	                            'div',
	                            { className: 'description__item' },
	                            _react2['default'].createElement(
	                                'h4',
	                                { title: title[0].content },
	                                title[0].content
	                            )
	                        ),
	                        description[0] && description[0].content && slotConfig[1] && _react2['default'].createElement(
	                            'div',
	                            { className: 'description__item' },
	                            _react2['default'].createElement(
	                                'p',
	                                { className: 'description__item--content' },
	                                description[0].content
	                            )
	                        ),
	                        this.renderSlots(),
	                        isAuthenticated && this.props.media.toJS().tags && this.props.media.toJS().tags.length > 0 && _react2['default'].createElement(
	                            'div',
	                            { className: 'description__item' },
	                            _react2['default'].createElement(
	                                'p',
	                                { className: 'description__item--title' },
	                                'Tags'
	                            ),
	                            _react2['default'].createElement(
	                                'p',
	                                { className: 'description__item--content' },
	                                this.renderTags(this.colors)
	                            )
	                        )
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'media__navigation__bar' },
	                this.showPreviousPageArrow(media, metaData) ? _react2['default'].createElement(
	                    'button',
	                    { onClick: this.switchToPreviousItem,
	                        className: 'actions__switch-previous actions__switch media__navigation__bar__button', title: _utilsFlux2['default'].t('pagination_back') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'switch__button' },
	                        _react2['default'].createElement('i', { className: 'circle-chevron-left' })
	                    )
	                ) : _react2['default'].createElement(
	                    'button',
	                    { disabled: true, style: { visibility: 'hidden' }, className: 'actions__switch-previous actions__switch media__navigation__bar__button', title: _utilsFlux2['default'].t('pagination_back') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'switch__button' },
	                        _react2['default'].createElement('i', { className: 'circle-chevron-left' })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'page_number' },
	                    media.indexInResults + 1 + (metaData.page - 1) * metaData.per_page + ' ' + _utilsFlux2['default'].t('pagination_of') + ' ' + metaData.total_records
	                ),
	                this.showNextPageArrow(media, metaData) ? _react2['default'].createElement(
	                    'button',
	                    { onClick: this.switchToNextItem, className: 'actions__switch-next actions__switch media__navigation__bar__button', title: _utilsFlux2['default'].t('pagination_next') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'switch__button' },
	                        _react2['default'].createElement('i', { className: 'circle-chevron-right' })
	                    )
	                ) : _react2['default'].createElement(
	                    'button',
	                    { disabled: true, style: { visibility: 'hidden' }, className: 'actions__switch-next actions__switch media__navigation__bar__button', title: _utilsFlux2['default'].t('pagination_next') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'switch__button' },
	                        _react2['default'].createElement('i', { className: 'circle-chevron-right' })
	                    )
	                ),
	                shareMode === 'auth' && _react2['default'].createElement(
	                    'button',
	                    { onClick: this.shareItem, className: 'icn actions__share_item media__button media__navigation__bar__button' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'icn-holder share_item__button' },
	                        _react2['default'].createElement('i', { className: 'share' })
	                    )
	                ),
	                ('auth' === shareMode || 'openDownload' === shareMode) && _react2['default'].createElement(
	                    'div',
	                    { onClick: this.generateInstantDownload, className: 'icn actions__directdownload media__button media__navigation__bar__button' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'icn-holder directdownload__button' },
	                        _react2['default'].createElement('i', { className: 'download' })
	                    )
	                ),
	                ('auth' === shareMode || 'openDownload' === shareMode) && _react2['default'].createElement(
	                    'div',
	                    { onClick: this.toggleBasketFix, className: 'icn actions__addtobasket media__button media__navigation__bar__button' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'icn-holder addtobasket__button' },
	                        _react2['default'].createElement('i', { className: 'plus-small' })
	                    )
	                ),
	                this.renderBasket()
	            )
	        );
	    }
	});
	
	module.exports = MediaModal;

/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _tcombForm = __webpack_require__(64);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _emailValidation = __webpack_require__(222);
	
	var _emailValidation2 = _interopRequireDefault(_emailValidation);
	
	var Form = _tcombForm2['default'].form.Form;
	
	var PasswordForgotten = _tcombForm2['default'].struct({
	    email: _tcombForm2['default'].subtype(_tcombForm2['default'].Str, function (s) {
	        return _emailValidation2['default'].valid(s);
	    })
	});
	
	var PasswordForgottenModal = _react2['default'].createClass({
	    displayName: 'PasswordForgottenModal',
	    mixins: [_reactRouter.Navigation],
	    propTypes: {
	        hasError: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool])
	    },
	    getInitialState: function getInitialState() {
	        return {
	            email: '',
	            resetSuccess: false
	        };
	    },
	    onChange: function onChange(value) {
	        this.setState({ value: value });
	    },
	    showLogin: function showLogin(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openModal('Login');
	    },
	    onSubmit: function onSubmit(evt) {
	        var _this = this;
	
	        evt.preventDefault();
	        var data = this.refs.form.getValue();
	        if (data) {
	            _utilsFlux2['default'].getStore('app').resetPassword(data).then(function () {
	                _this.setState({ resetSuccess: true });
	            });
	        }
	    },
	    renderError: function renderError() {
	        if (this.props.hasError) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'content__error' },
	                this.props.hasError
	            );
	        }
	    },
	    render: function render() {
	        if (this.state.resetSuccess) {
	            return _react2['default'].createElement(
	                'h4',
	                { className: 'register__success' },
	                _utilsFlux2['default'].t('reset_password_requested')
	            );
	        }
	
	        var options = {
	            auto: 'placeholders',
	            fields: {
	                email: {
	                    error: _utilsFlux2['default'].t('validation_email'),
	                    label: _utilsFlux2['default'].t('account_username'),
	                    attrs: {
	                        autoFocus: true
	                    }
	                }
	            }
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('account_forgot_password_title')
	            ),
	            _react2['default'].createElement(
	                'form',
	                { onSubmit: this.onSubmit },
	                _react2['default'].createElement(Form, {
	                    ref: 'form',
	                    type: PasswordForgotten,
	                    options: options,
	                    value: this.state.value,
	                    onChange: this.onChange
	                }),
	                this.renderError(),
	                _react2['default'].createElement(
	                    'button',
	                    { type: 'submit', className: 'btn btn-primary btn-arrow' },
	                    _utilsFlux2['default'].t('reset_password'),
	                    _react2['default'].createElement('i', { className: 'chevron-right' })
	                )
	            ),
	            _react2['default'].createElement('hr', { className: 'white' }),
	            _react2['default'].createElement(
	                'button',
	                { onClick: this.showLogin, type: 'button', className: 'btn btn-white btn-arrow-left' },
	                _react2['default'].createElement('i', { className: 'chevron-left' }),
	                _utilsFlux2['default'].t('back_to_login')
	            )
	        );
	    }
	});
	
	module.exports = PasswordForgottenModal;

/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _tcombForm = __webpack_require__(64);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var Form = _tcombForm2['default'].form.Form;
	
	var PasswordReset = _tcombForm2['default'].struct({
	    password: _tcombForm2['default'].Str,
	    password_repeat: _tcombForm2['default'].Str
	});
	
	var PasswordResetModal = _react2['default'].createClass({
	    displayName: 'PasswordResetModal',
	    mixins: [_reactRouter.Navigation],
	    propTypes: {
	        hasError: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool])
	    },
	    getInitialState: function getInitialState() {
	        return {
	            password: '',
	            password_repeat: '',
	            resetSuccess: false
	        };
	    },
	    onChange: function onChange(value) {
	        this.setState({ value: value });
	    },
	    showLogin: function showLogin(e) {
	        e.preventDefault();
	        this.replaceWith('login', {}, { showDialog: true });
	    },
	    onSubmit: function onSubmit(evt) {
	        var _this = this;
	
	        evt.preventDefault();
	        var data = this.refs.form.getValue();
	        if (data) {
	            var submitData = {
	                'secret': this.props.secret,
	                'password': data.password,
	                'password_repeat': data.password_repeat
	            };
	            _utilsFlux2['default'].getStore('app').updatePassword(submitData).then(function () {
	                _this.setState({ resetSuccess: true });
	            });
	        }
	    },
	    renderError: function renderError() {
	        if (this.props.hasError) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'content__error' },
	                this.props.hasError
	            );
	        }
	    },
	    render: function render() {
	        if (this.state.resetSuccess) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'content__success' },
	                _react2['default'].createElement(
	                    'a',
	                    { onClick: this.showLogin, className: 'modal__close' },
	                    _react2['default'].createElement('i', { className: 'close' })
	                ),
	                _react2['default'].createElement(
	                    'h4',
	                    { className: 'register__success' },
	                    _utilsFlux2['default'].t('account_password_new_success')
	                ),
	                _react2['default'].createElement('hr', { className: 'white' }),
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.showLogin, type: 'button', className: 'btn btn-white btn-arrow-left' },
	                    _react2['default'].createElement('i', { className: 'chevron-left' }),
	                    _utilsFlux2['default'].t('back_to_login')
	                )
	            );
	        }
	
	        var options = {
	            auto: 'labels',
	            fields: {
	                password: {
	                    type: 'password',
	                    error: _utilsFlux2['default'].t('validation_password'),
	                    label: _utilsFlux2['default'].t('account_password_new')
	                },
	                password_repeat: {
	                    type: 'password',
	                    hasError: this.state.password !== this.state.password_repeat,
	                    error: _utilsFlux2['default'].t('validation_password_repeat'),
	                    label: _utilsFlux2['default'].t('account_password_confirm')
	                }
	            }
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('account_password_new_head')
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'content__success' },
	                _react2['default'].createElement(
	                    'a',
	                    { onClick: this.showLogin, className: 'modal__close' },
	                    _react2['default'].createElement('i', { className: 'close' })
	                )
	            ),
	            _react2['default'].createElement(
	                'form',
	                { onSubmit: this.onSubmit },
	                _react2['default'].createElement(Form, {
	                    ref: 'form',
	                    type: PasswordReset,
	                    options: options,
	                    value: this.state.value,
	                    onChange: this.onChange
	                }),
	                this.renderError(),
	                _react2['default'].createElement(
	                    'button',
	                    { type: 'submit', className: 'btn btn-primary btn-arrow' },
	                    _utilsFlux2['default'].t('update'),
	                    _react2['default'].createElement('i', { className: 'chevron-right' })
	                )
	            ),
	            _react2['default'].createElement('hr', { className: 'white' }),
	            _react2['default'].createElement(
	                'button',
	                { onClick: this.showLogin, type: 'button', className: 'btn btn-white btn-arrow-left' },
	                _react2['default'].createElement('i', { className: 'chevron-left' }),
	                _utilsFlux2['default'].t('back_to_login')
	            )
	        );
	    }
	});
	
	module.exports = PasswordResetModal;

/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _tcombForm = __webpack_require__(64);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactSelect = __webpack_require__(377);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var hasAccountGroupList = window.accountGroupList && window.accountGroupList.length;
	
	var Form = _tcombForm2['default'].form.Form;
	
	var RegisterModal = _react2['default'].createClass({
	    displayName: 'RegisterModal',
	    mixins: [_reactRouter.Navigation],
	    propTypes: {
	        hasError: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool])
	    },
	    getInitialState: function getInitialState() {
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var acceptTermsCheckmark = _flux$getStore$getState$config$toJS.acceptTermsCheckmark;
	
	        return {
	            acceptedTerms: !acceptTermsCheckmark,
	            registerSuccess: false,
	            submitting: false,
	            language: _utilsFlux2['default'].getStore('translations').getUserLocale() || 'EN'
	        };
	    },
	    _setInnerHtml: function _setInnerHtml(html) {
	        return { __html: html };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.hasError && this.state.submitting) {
	            this.setState({ submitting: false });
	        }
	    },
	    onSubmit: function onSubmit(evt) {
	        var _this = this;
	
	        evt.preventDefault();
	
	        var registerData = this.refs.form.getValue();
	        registerData.language = _store2['default'].get('mediabox_user_language');
	
	        if (registerData) {
	            this.setState({
	                submitting: true
	            });
	            _utilsFlux2['default'].getStore('app').registerUser(registerData).then(function () {
	                _this.setState({
	                    registerSuccess: true,
	                    submitting: false
	                });
	            })['catch'](function (error) {
	                console.error(error);
	            });
	        }
	    },
	    renderError: function renderError() {
	        if (this.props.hasError) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'content__error' },
	                this.props.hasError
	            );
	        }
	    },
	    onChange: function onChange(value) {
	        this.setState(value);
	    },
	    render: function render() {
	        var _flux$getStore$getState$config$toJS2 = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var acceptTermsCheckmark = _flux$getStore$getState$config$toJS2.acceptTermsCheckmark;
	        var mediaboxRights = _flux$getStore$getState$config$toJS2.mediaboxRights;
	
	        var _flux$getStore$getState = _utilsFlux2['default'].getStore('app').getState();
	
	        var registerForm = _flux$getStore$getState.registerForm;
	
	        var RegisterFields = {};
	        var fields = {};
	
	        var selectTemplate = function selectTemplate(values, placeholder) {
	            return function (locals) {
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'field' },
	                    _react2['default'].createElement(
	                        'label',
	                        null,
	                        locals.label
	                    ),
	                    _react2['default'].createElement(_reactSelect2['default'], {
	                        name: 'country',
	                        placeholder: _utilsFlux2['default'].t(placeholder),
	                        options: values,
	                        value: locals.value,
	                        onChange: locals.onChange
	                    }),
	                    locals.hasError ? _react2['default'].createElement(
	                        'div',
	                        { className: 'field__error' },
	                        locals.error
	                    ) : ''
	                );
	            };
	        };
	
	        registerForm.forEach(function (row) {
	            row.registerColumns.forEach(function (column) {
	                column.registerFields.forEach(function (field) {
	                    RegisterFields[field.name] = field.validationRequired ? _tcombForm2['default'].Str : _tcombForm2['default'].maybe(_tcombForm2['default'].Str);
	                    fields[field.name] = {
	                        error: _utilsFlux2['default'].t(field.errorKey),
	                        label: _utilsFlux2['default'].t(field.labelKey) + (field.validationRequired ? "*" : "")
	                    };
	                    if (field.type) {
	                        fields[field.name]["type"] = field.type;
	                    }
	                    if (field.values.length > 0) {
	                        var values = [];
	                        field.values.forEach(function (value) {
	                            return values.push({ value: value.key, label: value.value });
	                        });
	                        fields[field.name]["template"] = selectTemplate(values, field.errorKey);
	                    }
	                });
	            });
	        });
	        var Register = _tcombForm2['default'].struct(RegisterFields);
	        if (this.state.registerSuccess) {
	            return mediaboxRights === 1 ? _react2['default'].createElement(
	                'div',
	                { className: 'register__success' },
	                _react2['default'].createElement(
	                    'h4',
	                    { className: 'form__success' },
	                    _utilsFlux2['default'].t('register_success_title')
	                ),
	                _utilsFlux2['default'].t('register_success_message')
	            ) : _react2['default'].createElement(
	                'div',
	                { className: 'register__success' },
	                _react2['default'].createElement(
	                    'h4',
	                    { className: 'form__success' },
	                    _utilsFlux2['default'].t('sign_up_new_user_success_title')
	                ),
	                _utilsFlux2['default'].t('sign_up_new_user_success_message')
	            );
	        }
	
	        var options = {
	            auto: 'labels',
	            template: function template(locals) {
	                var inputs = locals.inputs;
	
	                var inputList = [];
	                for (var input in inputs) {
	                    if (!inputs.hasOwnProperty(input)) continue;
	                    inputList.push({ name: input, input: inputs[input] });
	                }
	
	                var _flux$getStore$getState2 = _utilsFlux2['default'].getStore('app').getState();
	
	                var registerForm = _flux$getStore$getState2.registerForm;
	
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'form__register' },
	                    registerForm.map(function (row) {
	                        if (row.registerColumns.length == 0) {
	                            return _react2['default'].createElement(
	                                'div',
	                                { className: 'register__comment' },
	                                _react2['default'].createElement('hr', null)
	                            );
	                        }if (row.registerColumns.length == 1) {
	                            return _react2['default'].createElement(
	                                'div',
	                                { className: 'register__comment' },
	                                row.registerColumns[0].registerFields[0] && inputs[row.registerColumns[0].registerFields[0].name]
	                            );
	                        } else if (row.registerColumns.length > 1) {
	                            return _react2['default'].createElement(
	                                'div',
	                                null,
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'register__left' },
	                                    row.registerColumns[0].registerFields[0] && inputs[row.registerColumns[0].registerFields[0].name]
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'register__right' },
	                                    row.registerColumns[1].registerFields[0] && inputs[row.registerColumns[1].registerFields[0].name]
	                                )
	                            );
	                        }
	                    }),
	                    _react2['default'].createElement(
	                        'div',
	                        { style: { clear: "both" }, className: 'register__tac' },
	                        _react2['default'].createElement('p', { className: 'text-light', dangerouslySetInnerHTML: _utilsDom2['default'].setInnerHtml(_utilsFlux2['default'].t('terms_and_conditions')) })
	                    ),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'register__hint' },
	                        _utilsFlux2['default'].t('register_required_fields_text')
	                    )
	                );
	            },
	            fields: _extends({}, fields, {
	                language: {
	                    type: 'hidden'
	                }
	            })
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('account_sign_up')
	            ),
	            _react2['default'].createElement(
	                'form',
	                { onSubmit: this.onSubmit },
	                _react2['default'].createElement(Form, {
	                    ref: 'form',
	                    type: Register,
	                    value: this.state,
	                    options: options,
	                    onChange: this.onChange
	                }),
	                this.renderError(),
	                _react2['default'].createElement('hr', { className: 'white' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'register__submit' },
	                    _react2['default'].createElement(
	                        'button',
	                        { disabled: this.state.submitting, type: 'submit', className: 'btn btn-primary btn-arrow' },
	                        _utilsFlux2['default'].t('register_submit'),
	                        _react2['default'].createElement('i', { className: 'chevron-right' })
	                    )
	                ),
	                _react2['default'].createElement('div', { className: 'mejs-clear' })
	            )
	        );
	    }
	});
	
	module.exports = RegisterModal;

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var ShareModal = _react2['default'].createClass({
	    displayName: 'ShareModal',
	    propTypes: {
	        shareUrl: _react2['default'].PropTypes.object
	    },
	    getInitialState: function getInitialState() {
	        return {
	            copied: false
	        };
	    },
	    onCopy: function onCopy() {
	        this.setState({ copied: true });
	    },
	    onFocus: function onFocus(e) {
	        e.target.disabled || e.target.select();
	    },
	    renderSuccess: function renderSuccess() {
	        if (this.state.copied) {
	            return _react2['default'].createElement(
	                'span',
	                { className: 'copy__success' },
	                _utilsFlux2['default'].t('copied')
	            );
	        }
	    },
	
	    render: function render() {
	        var sharedURL = this.props.shareUrl || _utilsFlux2['default'].t('share_wait');
	
	        function unselectTextArea() {
	            if (window.getSelection) {
	                window.getSelection().removeAllRanges();
	            } else if (document.selection) {
	                document.selection.empty();
	            }
	        }
	
	        var self = this;
	        this.copyLinkToClipboard = function () {
	            var textarea = document.getElementById("textarea");
	            textarea.focus();
	            textarea.select();
	
	            try {
	                var successful = document.execCommand('copy');
	                var msg = successful ? 'successful' : 'unsuccessful';
	                console.log('Copying text to clipboard was ' + msg);
	                self.onCopy();
	            } catch (err) {
	                console.error('Unable to copy to clipboard', err);
	            }
	            unselectTextArea();
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('copy-share-url')
	            ),
	            _react2['default'].createElement(
	                'form',
	                null,
	                _react2['default'].createElement('input', { id: 'textarea', type: 'text', readOnly: 'true', disabled: this.props.shareUrl ? false : true, value: sharedURL, onFocus: this.onFocus })
	            ),
	            _react2['default'].createElement(
	                'button',
	                { onClick: _utilsFlux2['default'].getActions('modals').closeModals, className: 'btn btn-secondary' },
	                _utilsFlux2['default'].t('cancel')
	            ),
	            _react2['default'].createElement(
	                'button',
	                { onClick: this.copyLinkToClipboard, className: 'btn btn-secondary' },
	                _utilsFlux2['default'].t('copy')
	            ),
	            this.renderSuccess()
	        );
	    }
	});
	
	module.exports = ShareModal;

/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _videoJs = __webpack_require__(270);
	
	var _videoJs2 = _interopRequireDefault(_videoJs);
	
	var _reactRouter = __webpack_require__(7);
	
	var _queryString = __webpack_require__(167);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _screenfull = __webpack_require__(402);
	
	var _screenfull2 = _interopRequireDefault(_screenfull);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _componentsBasketBasketDropdown = __webpack_require__(144);
	
	var _componentsBasketBasketDropdown2 = _interopRequireDefault(_componentsBasketBasketDropdown);
	
	var _pagesMediaMediaListingItemNotification = __webpack_require__(195);
	
	var _pagesMediaMediaListingItemNotification2 = _interopRequireDefault(_pagesMediaMediaListingItemNotification);
	
	var _lodashLangCloneDeep = __webpack_require__(68);
	
	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);
	
	var MediaModal = _react2['default'].createClass({
	
	    displayName: 'MediaModal',
	
	    propTypes: {
	        media: _react2['default'].PropTypes.object
	    },
	
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            autoResolution: true,
	            videoPlayed: false
	        };
	    },
	
	    handleViewOrientation: function handleViewOrientation() {
	        var modalMedia = document.querySelector('.modal__media');
	        var orientation = _utilsFlux2['default'].getStore('app').getState().config.toJS().detail_view_orientation;
	
	        if (typeof orientation === 'undefined') {
	            orientation = 'default';
	        }
	
	        modalMedia.className = 'modal modal__media modal__media--' + orientation;
	    },
	
	    componentWillMount: function componentWillMount() {},
	
	    componentDidMount: function componentDidMount() {
	        this.handleViewOrientation();
	
	        if ('video' === this.props.media.toJS().type) {
	            this.setupVideoPlayer();
	        } else if (Modernizr && !Modernizr.objectfit) {
	            // Polyfill object-fit: contain
	            var image = this.refs.preview.getDOMNode(),
	                _parent = image.parentNode;
	
	            if (!_parent) return;
	
	            image.style.display = 'none';
	            _parent.style.backgroundImage = 'url(' + image.src + ')';
	        }
	
	        window.addEventListener('resize', this, false);
	        document.addEventListener('fullscreenchange', this, false);
	        document.addEventListener('mozfullscreenchange', this, false);
	        document.addEventListener('webkitfullscreenchange', this, false);
	        document.addEventListener('click', this, true);
	        document.addEventListener("keydown", this.detectArrowPress, false);
	        this.resize();
	        if ('video' === this.props.media.toJS().type && this.state.videoPlayed) {
	            this.player.play();
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        if (this.player) {
	            this.player.dispose();
	        }
	        window.removeEventListener('resize', this, false);
	        document.removeEventListener('fullscreenchange', this, false);
	        document.removeEventListener('mozfullscreenchange', this, false);
	        document.removeEventListener('webkitfullscreenchange', this, false);
	        document.removeEventListener('click', this, true);
	        document.removeEventListener("keydown", this.detectArrowPress, false);
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        this.componentDidMount();
	    },
	
	    detectArrowPress: function detectArrowPress(event) {
	        var metaData = this.props.mediaMeta.toJS();
	        var media = this.props.media.toJS();
	        // right arrow
	        if (event.keyCode === 39) {
	            if (this.showNextPageArrow(media, metaData)) {
	                this.switchToNextItem();
	            }
	        }
	        // left arrow
	        if (event.keyCode === 37) {
	            if (this.showPreviousPageArrow(media, metaData)) {
	                this.switchToPreviousItem();
	            }
	        }
	    },
	
	    showNextPageArrow: function showNextPageArrow(media, metaData) {
	        return !media.lastElementOfResults || metaData.page !== Math.ceil(metaData.total_records / metaData.per_page);
	    },
	
	    showPreviousPageArrow: function showPreviousPageArrow(media, metaData) {
	        return !media.firstElementOfResults || metaData.page !== 1;
	    },
	
	    handleEvent: function handleEvent(e) {
	        if ('resize' === e.type) {
	            window.requestAnimationFrame && window.requestAnimationFrame(this.resize);
	            !window.requestAnimationFrame && this.resize();
	        } else if (e.type.indexOf('fullscreenchange') > -1) {
	            this.updateVideoResolution();
	        } else if ('click' === e.type) {
	            var target = e.target;
	            var className = e.target.className;
	
	            if (className.indexOf('vjs-menu-item') > -1 && target.parentNode.parentNode.parentNode.className.indexOf('vjs-resolution-button') > -1) {
	                this.setState({
	                    autoResolution: false
	                });
	            }
	        }
	    },
	
	    setupVideoPlayer: function setupVideoPlayer() {
	        var media = this.props.media.toJS();
	        var videoWrapper = document.createElement('VIDEO');
	        var video = this.refs.video.getDOMNode();
	
	        video.innerHTML = '';
	        if ('video' !== this.props.media.toJS().type) {
	            return;
	        }
	
	        _utilsDom2['default'].setAttributes(videoWrapper, {
	            'class': 'video-js vjs-default-skin',
	            controls: true,
	            preload: 'auto',
	            poster: _utilsApi2['default'].cachedImagePath(Array.isArray(media.thumbnails) ? media.thumbnails[0].preview.src : media.thumbnails.preview.src)
	        });
	
	        var mapQualToLabel = function mapQualToLabel(quality) {
	            switch (quality) {
	                case 'full':
	                    return {
	                        label: 'HD',
	                        res: 1080
	                    };
	                case 'low':
	                    return {
	                        label: 'SD',
	                        res: 720
	                    };
	            }
	            return {
	                label: quality,
	                res: null
	            };
	        };
	
	        var sources = [];
	
	        media.videos.forEach(function (video) {
	            var quality = mapQualToLabel(video.quality);
	            sources.push({
	                src: video.url,
	                type: video.mimeType,
	                label: quality.label,
	                res: quality.res
	            });
	        });
	
	        video.appendChild(videoWrapper);
	
	        this.player = (0, _videoJs2['default'])(videoWrapper, {
	            sources: sources,
	            plugins: {
	                videoJsResolutionSwitcher: {
	                    'default': 'low'
	                }
	            }
	        });
	    },
	
	    updateVideoResolution: function updateVideoResolution() {
	        var autoResolution = this.state.autoResolution;
	
	        if (!autoResolution) {
	            return;
	        }
	
	        if (_screenfull2['default'].isFullscreen) {
	            this.player.currentResolution('HD');
	        } else {
	            this.player.currentResolution('SD');
	        }
	    },
	
	    generateInstantDownload: function generateInstantDownload(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openInstantDownloadModal(this.props.media);
	    },
	
	    toggleCheck: function toggleCheck(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').toggleItemSelection(this.props.media.get('id'));
	    },
	
	    toggleBasketFix: function toggleBasketFix(e) {
	        e.preventDefault();
	        var id = this.props.media.get('id');
	        var order = _utilsFlux2['default'].getStore('media').getState().media.findIndex(function (item) {
	            return item.get('id') === id;
	        });
	        _utilsFlux2['default'].getActions('modals').openMediaModal(_utilsFlux2['default'].getStore('media').getState().media.get(order));
	
	        if (!this.props.media.get('_basket')) {
	            _utilsFlux2['default'].getActions('media').toggleBasket(id);
	            _utilsFlux2['default'].getActions('modals').openMediaModal(_utilsFlux2['default'].getStore('media').getState().media.get(order));
	        }
	    },
	
	    renderBasket: function renderBasket() {
	        if (this.props.media.get('_basket') && _utilsFlux2['default'].getStore('modals').getState().openModal) {
	            var mediaId = this.props.media.get('id');
	            var mediaName = this.props.media.get('name') || this.props.media.get('title');
	            return _react2['default'].createElement(
	                _altContainer2['default'],
	                {
	                    stores: { basketStore: _utilsFlux2['default'].getStore('basket') },
	                    transform: function (_ref) {
	                        var basketStore = _ref.basketStore;
	
	                        var baskets = basketStore.baskets;
	                        return { baskets: baskets };
	                    } },
	                _react2['default'].createElement(_componentsBasketBasketDropdown2['default'], { mediaId: mediaId, mediaName: mediaName, media: this.props.media, isFooter: true })
	            );
	        }
	    },
	
	    switchToPreviousItem: function switchToPreviousItem() {
	        this.setState({
	            videoPlayed: false
	        });
	        if (this.props.media.toJS().firstElementOfResults) {
	            _utilsFlux2['default'].getActions('media').fetchPreviousPage();
	            var query = (0, _lodashLangCloneDeep2['default'])(this.context.router.getCurrentQuery());
	            query.page = _utilsFlux2['default'].getStore('media').getState().modalMeta.toJS().page - 1;
	            _utilsFlux2['default'].getStore('media').loadMediaModals(query);
	        } else {
	            _utilsFlux2['default'].getActions('media').setPreviousElement(this.props.media.get('id'));
	            _utilsFlux2['default'].getActions('modals').openMediaModal(_utilsFlux2['default'].getStore('media').getState().previousElement);
	        }
	    },
	
	    switchToNextItem: function switchToNextItem() {
	        this.setState({
	            videoPlayed: false
	        });
	        if (this.props.media.toJS().lastElementOfResults) {
	            _utilsFlux2['default'].getActions('media').fetchNextPage();
	            var query = (0, _lodashLangCloneDeep2['default'])(this.context.router.getCurrentQuery());
	            query.page = _utilsFlux2['default'].getStore('media').getState().modalMeta.toJS().page + 1;
	            _utilsFlux2['default'].getStore('media').loadMediaModals(query);
	        } else {
	            _utilsFlux2['default'].getActions('media').setNextElement(this.props.media.get('id'));
	            _utilsFlux2['default'].getActions('modals').openMediaModal(_utilsFlux2['default'].getStore('media').getState().nextElement);
	        }
	    },
	
	    resize: function resize() {
	        var previewImg = Array.isArray(this.props.media.toJS().thumbnails) ? this.props.media.toJS().thumbnails[0].preview : this.props.media.toJS().thumbnails.preview,
	            previewImgRatio = this._cache && this._cache.previewImgRatio || previewImg.width / previewImg.height,
	            desiredHeight = undefined,
	            maxHeight = undefined;
	
	        var _props$media$toJS = this.props.media.toJS();
	
	        var type = _props$media$toJS.type;
	
	        // constants
	        var MARGIN = 20,
	            RATIO = 16 / 9;
	
	        if (this._cache && window.innerHeight === this._cache.windowHeight) {
	            return;
	        } else if (!this._cache) {
	            this._cache = {
	                descEl: this.refs.description.getDOMNode(),
	                previewEl: this.refs.preview ? this.refs.preview.getDOMNode().parentNode : this.refs.video.getDOMNode().childNodes[0],
	                contentEl: this.refs.modalInner.getDOMNode().parentNode,
	                previewImgRatio: previewImgRatio
	            };
	        }
	        this._cache.windowHeight = window.innerHeight;
	        this._cache.descriptionHeight = this._cache.descEl.offsetHeight;
	        this._cache.previewWidth = this._cache.previewEl.offsetWidth;
	
	        if ('video' !== type && previewImgRatio < RATIO) {
	            // adjust container size
	            desiredHeight = this._cache.previewWidth / previewImgRatio;
	            maxHeight = this._cache.windowHeight - this._cache.descriptionHeight - MARGIN * 2;
	            this._cache.previewEl.style.paddingTop = (Math.min(desiredHeight, maxHeight) / this._cache.previewWidth * 100).toFixed(3) + '%';
	        }
	
	        // center vertically
	        var marginTop = 'video' !== type ? Math.floor(Math.max(MARGIN, (this._cache.windowHeight - this._cache.contentEl.offsetHeight) / 2)) : Math.floor(Math.max(MARGIN, (this._cache.windowHeight - (this._cache.contentEl.offsetWidth / RATIO + this._cache.descriptionHeight)) / 2));
	        this._cache.contentEl.style.marginTop = marginTop + 'px';
	    },
	
	    clickOnVideoModal: function clickOnVideoModal() {
	        var videoPlayed = this.state.videoPlayed;
	        if (!videoPlayed) {
	            this.setState({
	                videoPlayed: !videoPlayed
	            });
	        }
	    },
	
	    renderMediaPreview: function renderMediaPreview() {
	        var media = this.props.media.toJS();
	        var mediaType = media.type;
	        var previewImage = Array.isArray(media.thumbnails) ? media.thumbnails[0].preview : media.thumbnails.preview;
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var archiveColor = _flux$getStore$getState$config$toJS.archiveColor;
	        var embargoColor = _flux$getStore$getState$config$toJS.embargoColor;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])('media__image', 'media__image--type__' + mediaType) },
	            'video' === mediaType && _react2['default'].createElement('div', { ref: 'video', className: 'item__preview__overlay ' + this.state.videoPlayed, onClick: this.clickOnVideoModal }),
	            media.embargo && _react2['default'].createElement('div', { className: 'item__preview__overlay', style: { border: '5px solid ' + embargoColor } }),
	            media.archived && _react2['default'].createElement('div', { className: 'item__preview__overlay', style: { border: '5px solid ' + archiveColor } }),
	            (function () {
	                if ('video' !== mediaType && previewImage) {
	                    return _react2['default'].createElement('img', { className: 'media__preview__image', src: previewImage.src, width: previewImage.width, height: previewImage.height, ref: 'preview' });
	                }
	            })()
	        );
	    },
	
	    renderTags: function renderTags() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'description__tags' },
	            this.props.media.toJS().tags.map(function (tag, ix) {
	                return _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { key: 'tag_' + ix, onClick: _utilsFlux2['default'].getActions('modals').closeModals, to: 'listing', className: 'btn btn-small btn-primary tags__button', query: _queryString2['default'].parse(tag.link) },
	                    tag.name
	                );
	            })
	        );
	    },
	
	    shareItem: function shareItem() {
	        // Dont want to duplicate Share modal, so we use already existing store to set up shareurl
	        _utilsFlux2['default'].getStore('basket').setShareUrl(window.location.origin + '/#/media?search=' + this.props.media.toJS().id);
	        _utilsFlux2['default'].getActions('modals').setModalInModal(this.props.media.toJS().id);
	        _utilsFlux2['default'].getActions('modals').openModal('Share');
	    },
	
	    renderSlots: function renderSlots() {
	        var _this = this;
	
	        var slotDefinitions = this.props.slotDefinitions.toJS();
	        console.log('slotDefinitions', slotDefinitions);
	
	        var detailViewSlots = window.config.detail_view;
	        return _react2['default'].createElement(
	            'div',
	            { className: 'description__slots' },
	            detailViewSlots.slice(2).map(function (slot) {
	                var id = slot.toString();
	                var currentSlotDefinition = slotDefinitions.filter(function (slot) {
	                    return slot.id === id;
	                });
	                var currentSlot = _this.props.media.toJS().slots.filter(function (slot) {
	                    return slot.id === id;
	                });
	
	                if (currentSlot[0] && (currentSlot[0].content || currentSlot[0].color || currentSlot[0].icon) && currentSlotDefinition[0]) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { className: 'description__item' },
	                        _react2['default'].createElement(
	                            'p',
	                            { className: 'description__item--title' },
	                            currentSlotDefinition[0].name
	                        ),
	                        _this.renderSlotProperties(currentSlot[0])
	                    );
	                }
	            })
	        );
	    },
	
	    renderSlotProperties: function renderSlotProperties(slot) {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'slot' },
	            Object.keys(slot).map(function (key) {
	                switch (key) {
	                    case 'content':
	                        return _react2['default'].createElement(
	                            'span',
	                            { key: key, className: 'slot-property slot-property__' + key },
	                            ' ',
	                            slot[key]
	                        );;
	                    case 'color':
	                        return _react2['default'].createElement('span', { key: key, className: 'slot-property slot-property__' + key, style: { backgroundColor: slot[key] } });
	                    case 'icon':
	                        return _react2['default'].createElement(
	                            'span',
	                            { key: key, className: 'slot-property slot-property__' + key },
	                            _react2['default'].createElement('img', { src: slot[key] })
	                        );
	                    default:
	                        return null;
	                }
	            })
	        );
	    },
	
	    render: function render() {
	
	        var media = this.props.media.toJS();
	        var metaData = this.props.mediaMeta.toJS();
	        var detailViewSlots = window.config.detail_view;
	
	        return _react2['default'].createElement(
	            'div',
	            { ref: 'modalInner' },
	            _react2['default'].createElement(
	                _altContainer2['default'],
	                {
	                    stores: { notificationsStore: _utilsFlux2['default'].getStore('notifications') },
	                    transform: function (_ref2) {
	                        var notificationsStore = _ref2.notificationsStore;
	
	                        var notifications = notificationsStore.notifications.filter(function (notification) {
	                            return notification.mediaId === media.id;
	                        });
	                        return { notifications: notifications };
	                    } },
	                _react2['default'].createElement(_pagesMediaMediaListingItemNotification2['default'], null)
	            ),
	            this.renderMediaPreview(),
	            _react2['default'].createElement(
	                'div',
	                { className: 'media__wrapper' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'media__description', ref: 'description' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'description__info' },
	                        media.slots[0].content && detailViewSlots[0] && _react2['default'].createElement(
	                            'div',
	                            { className: 'description__item' },
	                            _react2['default'].createElement(
	                                'h4',
	                                { title: media.slots[0].content },
	                                media.slots[0].content
	                            )
	                        ),
	                        media.slots[1].content && detailViewSlots[1] && _react2['default'].createElement(
	                            'div',
	                            { className: 'description__item' },
	                            _react2['default'].createElement(
	                                'p',
	                                { className: 'description__item--content' },
	                                media.slots[1].content
	                            )
	                        ),
	                        this.renderSlots()
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'media__modal__actions' },
	                    _react2['default'].createElement(
	                        'button',
	                        { onClick: this.shareItem, className: 'icn actions__share_item media__button' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'icn-holder share_item__button' },
	                            _react2['default'].createElement('i', { className: 'share' })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { onClick: this.generateInstantDownload, className: 'icn actions__directdownload media__button' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'icn-holder directdownload__button' },
	                            _react2['default'].createElement('i', { className: 'download' })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { onClick: this.toggleBasketFix, className: 'icn actions__addtobasket media__button' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'icn-holder addtobasket__button' },
	                            _react2['default'].createElement('i', { className: 'plus-small' })
	                        )
	                    ),
	                    this.renderBasket()
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'arrow-wrapper' },
	                this.showPreviousPageArrow(media, metaData) ? _react2['default'].createElement(
	                    'button',
	                    { onClick: this.switchToPreviousItem, className: 'actions__switch-previous' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'switch__button' },
	                        _react2['default'].createElement('i', { className: 'chevron-left' })
	                    )
	                ) : null,
	                this.showNextPageArrow(media, metaData) ? _react2['default'].createElement(
	                    'button',
	                    { onClick: this.switchToNextItem, className: 'actions__switch-next' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'switch__button' },
	                        _react2['default'].createElement('i', { className: 'chevron-right' })
	                    )
	                ) : null
	            )
	        );
	    }
	});
	
	module.exports = MediaModal;

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _linkifyjsHtml = __webpack_require__(751);
	
	var _linkifyjsHtml2 = _interopRequireDefault(_linkifyjsHtml);
	
	var WatermarkModal = _react2['default'].createClass({
	    displayName: 'WatermarkModal',
	
	    propTypes: {
	        media: _react2['default'].PropTypes.object
	    },
	
	    componentDidMount: function componentDidMount() {
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var watermarkTimeout = _flux$getStore$getState$config$toJS.watermarkTimeout;
	
	        this._timeout && clearTimeout(this._timeout);
	        this._timeout = setTimeout(this.closeModal, watermarkTimeout || 30000);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        clearTimeout(this._timeout);
	    },
	
	    closeModal: function closeModal() {
	        _utilsFlux2['default'].getActions('modals').closeModals();
	    },
	
	    render: function render() {
	        var media = this.props.media.toJS();
	        var items = typeof media === 'array' ? media.filter(function (item) {
	            return item.requires_watermark;
	        }) : null;
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h3',
	                { className: 'watermark__title' },
	                _utilsFlux2['default'].t('watermark_title')
	            ),
	            _react2['default'].createElement(
	                'h4',
	                { className: 'watermark__subtitle' },
	                _utilsFlux2['default'].t('watermark_subtitle')
	            ),
	            _react2['default'].createElement('p', { className: 'watermark__copy', dangerouslySetInnerHTML: { __html: (0, _linkifyjsHtml2['default'])(_utilsFlux2['default'].t('watermark_copy')) } })
	        );
	    }
	});
	
	module.exports = WatermarkModal;
	/*items.length &&
	   <ul className="watermark__list">
	       {items.slice( 0, 2 ).map( ( item, ix ) => {
	           return (
	               <li key={ix} className="watermark__item">
	                   <div className="watermark__figure">
	                       {!isEmpty(item.thumbnails) && <div className="watermark__image"><img src={item.thumbnails.thumb.src} width={item.thumbnails.thumb.width} height={item.thumbnails.thumb.height} /></div>}
	                   </div>
	                   <div className="watermark__details">
	                       <div className="watermark__assetname">{item.title}</div>
	                       <div className="watermark__action">{flux.t('watermark_action')}</div>
	                       <div className="progressbar" />
	                   </div>
	               </li>
	           )
	       })}
	   </ul>*/ /*items.length > 2 && <div className="watermark__additional">{( items.length - 2 === 1 ? '\u2026plus {count} asset.' : '\u2026plus {count} assets.' ).replace( '{count}', items.length - 2 )}</div>*/ /*<button className="btn btn-border watermark__closemodal" onClick={this.closeModal}>{flux.t('watermark_dismiss')}</button>*/

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var _headerSubmissionLink = __webpack_require__(189);
	
	var _headerSubmissionLink2 = _interopRequireDefault(_headerSubmissionLink);
	
	var Offcanvas = _react2['default'].createClass({
	    displayName: 'Offcanvas',
	
	    mixins: [],
	
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	
	    propTypes: {
	        isAuthenticated: _react2['default'].PropTypes.bool,
	        hasAcceptedLatestTerms: _react2['default'].PropTypes.bool,
	        activeBasketId: _react2['default'].PropTypes.string,
	        baskets: _react2['default'].PropTypes.object
	    },
	    getInitialState: function getInitialState() {
	        return {
	            licensingIsOpen: false,
	            basketIsOpen: false,
	            accountIsOpen: false
	        };
	    },
	    renderSubmenu: function renderSubmenu(isOpen, name) {
	        var _this = this;
	
	        if (isOpen) {
	            return _react2['default'].createElement(
	                'ul',
	                null,
	                this.props.baskets.map(function (basket) {
	                    basket = basket.toJS();
	                    return _react2['default'].createElement(
	                        'li',
	                        { className: 'menu__item' },
	                        _react2['default'].createElement(
	                            _reactRouter.Link,
	                            { onClick: _this.closeSubMenu, to: name, params: { id: basket.id } },
	                            basket.name
	                        )
	                    );
	                })
	            );
	        }
	    },
	    closeSubMenu: function closeSubMenu() {
	        //this.setState(this.getInitialState());
	    },
	    renderAccountMenu: function renderAccountMenu() {
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var userGuide = _flux$getStore$getState$config$toJS.userGuide;
	        var disableChangePassword = _flux$getStore$getState$config$toJS.disableChangePassword;
	        var disableAccountDetails = _flux$getStore$getState$config$toJS.disableAccountDetails;
	        var termsLink = _flux$getStore$getState$config$toJS.termsLink;
	        var showTerms = _flux$getStore$getState$config$toJS.showTerms;
	        var showPrivacy = _flux$getStore$getState$config$toJS.showPrivacy;
	        var showUserGuide = _flux$getStore$getState$config$toJS.showUserGuide;
	
	        var _flux$getStore$getState = _utilsFlux2['default'].getStore('app').getState();
	
	        var accountEditable = _flux$getStore$getState.accountEditable;
	        var passwordEditable = _flux$getStore$getState.passwordEditable;
	
	        if (this.state.accountIsOpen) {
	            return _react2['default'].createElement(
	                'ul',
	                null,
	                (showUserGuide === undefined || !!showUserGuide) && _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: userGuide, target: '_blank' },
	                        _utilsFlux2['default'].t('quick_start_guide')
	                    )
	                ),
	                false !== accountEditable && !disableAccountDetails && _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        { to: 'accountDetails' },
	                        _utilsFlux2['default'].t('account_details')
	                    )
	                ),
	                false !== passwordEditable && !disableChangePassword && _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        { to: 'accountPassword' },
	                        _utilsFlux2['default'].t('account_password_change_head')
	                    )
	                ),
	                !termsLink && (showTerms === undefined || !!showTerms) && _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '/#/terms-of-use', target: '_blank' },
	                        _utilsFlux2['default'].t('terms-of-use')
	                    )
	                ),
	                termsLink && _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: termsLink, target: '_blank' },
	                        _utilsFlux2['default'].t('terms-of-use')
	                    )
	                ),
	                showPrivacy && _react2['default'].createElement(
	                    'li',
	                    null,
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '/#/privacy-policy', target: '_blank' },
	                        _utilsFlux2['default'].t('privacy')
	                    )
	                )
	            );
	        }
	    },
	    openSubMenu: function openSubMenu(name, e) {
	        e.preventDefault();
	        if (name === 'licensing') {
	            this.setState({ licensingIsOpen: !this.state.licensingIsOpen });
	        }
	        if (name === 'basket') {
	            this.setState({ basketIsOpen: !this.state.basketIsOpen });
	        }
	        if (name === 'account') {
	            this.setState({ accountIsOpen: !this.state.accountIsOpen });
	        }
	    },
	    logout: function logout(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('app').logout();
	        _utilsFlux2['default'].getStore('app').closeOffcanvas();
	        this.context.router.transitionTo('login');
	    },
	    render: function render() {
	        if (!this.props.isAuthenticated) {
	            return null;
	        }
	        var activeBasketId = this.props.activeBasketId;
	
	        var _flux$getStore$getState2 = _utilsFlux2['default'].getStore('app').getState();
	
	        var config = _flux$getStore$getState2.config;
	
	        var _config$toJS = config.toJS();
	
	        var licensing = _config$toJS.licensing;
	        var allowSubmissions = _config$toJS.allowSubmissions;
	        var showHelp = _config$toJS.showHelp;
	        var helpLink = _config$toJS.helpLink;
	        var showImprint = _config$toJS.showImprint;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'offcanvas' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'offcanvas__logo' },
	                _react2['default'].createElement('img', { src: 'images/logo.png' })
	            ),
	            allowSubmissions && _react2['default'].createElement(
	                'div',
	                { className: 'awards-button__wrapper' },
	                _react2['default'].createElement(_headerSubmissionLink2['default'], null)
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: 'offcanvas__menu' },
	                _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        { to: 'landing-page' },
	                        _utilsFlux2['default'].t('nav_home')
	                    )
	                ),
	                licensing && _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        {
	                            onClick: this.openSubMenu.bind(null, 'licensing'),
	                            to: activeBasketId ? 'singleLicensing' : 'licensing',
	                            params: { id: activeBasketId } },
	                        _utilsFlux2['default'].t('nav_request_licence'),
	                        _react2['default'].createElement('i', { className: 'play' })
	                    ),
	                    this.renderSubmenu(this.state.licensingIsOpen, 'licensing')
	                ),
	                licensing && _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        { to: 'requests' },
	                        _utilsFlux2['default'].t('nav_requests_license')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        {
	                            onClick: this.openSubMenu.bind(null, 'basket'),
	                            to: activeBasketId ? 'singleBasket' : 'basket',
	                            params: { id: activeBasketId } },
	                        _utilsFlux2['default'].t('basket_selection'),
	                        _react2['default'].createElement('i', { className: 'play' })
	                    ),
	                    this.renderSubmenu(this.state.basketIsOpen, 'basket')
	                ),
	                (showHelp === undefined || !!showHelp) && !helpLink && _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        { to: 'help' },
	                        _utilsFlux2['default'].t('nav_help_me')
	                    )
	                ),
	                (showHelp === undefined || !!showHelp) && helpLink && _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: helpLink, target: '_blank' },
	                        _utilsFlux2['default'].t('nav_help_me')
	                    )
	                ),
	                showImprint && _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '/#/imprint', target: '_blank' },
	                        _utilsFlux2['default'].t('imprint')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        { onClick: this.openSubMenu.bind(null, 'account'), to: 'account' },
	                        _utilsFlux2['default'].t('account_header_nav'),
	                        _react2['default'].createElement('i', { className: 'play' })
	                    ),
	                    this.renderAccountMenu()
	                ),
	                _react2['default'].createElement(
	                    'li',
	                    { className: 'menu__item' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#', onClick: this.logout, title: 'Logout' },
	                        _utilsFlux2['default'].t('navigate_logout'),
	                        _react2['default'].createElement('i', { className: 'log-out logout__icon' })
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = Offcanvas;

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _imgAsync = __webpack_require__(224);
	
	var _imgAsync2 = _interopRequireDefault(_imgAsync);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var ImagePreviewPlayer = _react2['default'].createClass({
	
	    displayName: 'ImagePreviewPlayer',
	
	    propTypes: {
	        images: _react2['default'].PropTypes.object.isRequired,
	        show: _react2['default'].PropTypes.bool,
	        poster: _react2['default'].PropTypes.string
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            previewSlideIdx: null,
	            previewSlideUrl: null
	        };
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.show === true) {
	            this.showPreviewSlide();
	        } else {
	            this.stopPreview();
	        }
	    },
	
	    // Generates a previev slideshow for each video
	    showPreviewSlide: function showPreviewSlide() {
	        var slidesArr = this.props.images;
	        var slideIndex = this.state.previewSlideIdx;
	
	        if (slideIndex === slidesArr.length - 1 || slideIndex === null) {
	            slideIndex = 0;
	        } else {
	            slideIndex = ++slideIndex;
	        }
	
	        (0, _imgAsync2['default'])(slidesArr[slideIndex]).then((function () {
	            this.tickTimer = window.setTimeout((function () {
	
	                this.setState({
	                    previewSlideIdx: slideIndex,
	                    previewSlideUrl: slidesArr[slideIndex]
	                });
	
	                this.showPreviewSlide();
	            }).bind(this), 800);
	        }).bind(this));
	    },
	
	    // Fallback to the main preview image
	    stopPreview: function stopPreview() {
	        if (this.tickTimer) {
	            window.clearTimeout(this.tickTimer);
	        }
	        this.setState(this.getInitialState());
	    },
	
	    // Clear Timeout on unmount
	    componentWillUnmount: function componentWillUnmount() {
	        if (this.tickTimer) {
	            window.clearTimeout(this.tickTimer);
	        }
	    },
	
	    // RENDER
	    render: function render() {
	        var imageSrc = this.state.previewSlideUrl ? this.state.previewSlideUrl : this.props.poster;
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])('image__slideshow', { 'active': this.props.show }) },
	            _react2['default'].createElement('img', { ref: 'image', src: imageSrc })
	        );
	    }
	});
	
	module.exports = ImagePreviewPlayer;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	window.React = _react2['default'];
	
	var VideoPreviewPlayer = _react2['default'].createClass({
	
	    displayName: 'VideoPreviewPlayer',
	
	    propTypes: {
	        videos: _react2['default'].PropTypes.object.isRequired,
	        show: _react2['default'].PropTypes.bool,
	        poster: _react2['default'].PropTypes.string
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        var _this = this;
	
	        // To prevent the video to continue buffering
	        // we must set the src to an empty string directly on the Dom Node
	        // Using just props simply didnt work
	        var video = this.refs.video.getDOMNode();
	        if (nextProps.show) {
	            this._playTimeout && clearTimeout(this._playTimeout);
	            this._stopTimeout && clearTimeout(this._stopTimeout);
	            this.refs.video.props.children.map(function (source, idx) {
	                _this.refs['source_' + idx].getDOMNode().src = source.props['hover-src'];
	            });
	            this._playTimeout = setTimeout(function () {
	                video.volume = 0;
	                video.load();
	                video.play();
	            }, 10);
	        } else {
	            this._stopTimeout && clearTimeout(this._stopTimeout);
	            this._playTimeout && clearTimeout(this._playTimeout);
	            this.refs.video.props.children.map(function (source, idx) {
	                _this.refs['source_' + idx].getDOMNode().src = '';
	            });
	            this._stopTimeout = setTimeout(function () {
	                video.pause();
	                video.load();
	            }, 10);
	        }
	    },
	
	    // RENDER
	    render: function render() {
	        if (this.props.videos.size === 0) {
	            return null;
	        }
	        return _react2['default'].createElement(
	            'video',
	            { className: (0, _classnames2['default'])('image__videoplayer', { 'active': this.props.show }), ref: 'video', preload: 'metadata', poster: this.props.poster },
	            this.props.videos.map(function (video, idx) {
	                return _react2['default'].createElement('source', { key: 'source_' + idx, src: '', ref: 'source_' + idx, 'hover-src': video.get('url'), type: video.get('mimeType') });
	            })
	        );
	    }
	});
	
	module.exports = VideoPreviewPlayer;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var ThumbnailViewer = _react2['default'].createClass({
	    displayName: 'ThumbnailViewer',
	    render: function render() {
	        var _this = this;
	
	        var deviation = 4;
	        var isAtStart = this.props.currentIndex <= 3;
	
	        var leftButtonsVisibilityValue = this.props.currentIndex === 0 ? 'hidden' : 'visible';
	        var leftButtonsVisibility = { visibility: leftButtonsVisibilityValue };
	
	        var rightButtonsVisibilityValue = this.props.currentIndex === this.props.thumbnails.length - 1 ? 'hidden' : 'visible';
	        var rightButtonsVisibility = { visibility: rightButtonsVisibilityValue };
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'modal__thumbnail__viewer' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'modal__thumbnail__viewer_buttons_left', style: leftButtonsVisibility },
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.props.goToFirstImage,
	                        className: 'actions__switch-previous actions__switch', title: _utilsFlux2['default'].t('first-page') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'switch__button' },
	                        _react2['default'].createElement('i', { className: 'double-arrow-left' })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.props.goToPreviousImage,
	                        className: 'actions__switch-previous actions__switch', title: _utilsFlux2['default'].t('pagination_back') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'switch__button' },
	                        _react2['default'].createElement('i', { className: 'media-arrow-left' })
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'modal__thumbnail__viewer_thumbnails' },
	                this.props.thumbnails.map(function (item, index) {
	                    return (isAtStart || !isAtStart && index > _this.props.currentIndex - deviation) && _react2['default'].createElement(
	                        'figure',
	                        { className: index === _this.props.currentIndex ? "thumbnail__current" : "thumbnail__regular", onClick: _this.props.goToIndex.bind(null, index) },
	                        _react2['default'].createElement('img', { className: 'thumbnail__image',
	                            src: item.thumbnail.src }),
	                        _react2['default'].createElement(
	                            'figcaption',
	                            null,
	                            index + 1
	                        )
	                    );
	                })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'modal__thumbnail__viewer_buttons_right', style: rightButtonsVisibility },
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.props.goToNextImage,
	                        className: 'actions__switch-previous actions__switch', title: _utilsFlux2['default'].t('pagination_next') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'switch__button' },
	                        _react2['default'].createElement('i', { className: 'media-arrow-right' })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.props.goToLastImage,
	                        className: 'actions__switch-previous actions__switch', title: _utilsFlux2['default'].t('last-page') },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'switch__button' },
	                        _react2['default'].createElement('i', { className: 'double-arrow-right' })
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = ThumbnailViewer;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by danial.bagheri on 08/02/17.
	 */
	'use strict';
	
	var kulzerConfig = {};
	
	module.exports = {};
	
	if (true) {
	    if (false) {
	        module.exports = kulzerConfig;
	    }
	}

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _reactRouter2 = _interopRequireDefault(_reactRouter);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _routes = __webpack_require__(528);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	__webpack_require__(541);
	
	// load tcomb-form without templates and i18n
	var t = __webpack_require__(404);
	t.form.Form.i18n = __webpack_require__(403);
	t.form.Form.templates = __webpack_require__(450);
	
	window.React = _react2['default']; // For React Developer Tools
	
	if (!global.Intl) {
	    global.Intl = __webpack_require__(339);
	}
	
	var promises = [];
	promises.push(_utilsApi2['default'].getNoAuth('available_languages').then(function (availableLanguages) {
	    _utilsFlux2['default'].getActions('translations').setAvailableLanguages(availableLanguages);
	}));
	
	var language = _utilsFlux2['default'].getStore('translations').getUserLocale();
	promises.push(_utilsFlux2['default'].getStore('app').bootstrap());
	
	promises.push(_utilsApi2['default'].getLocale(language).then(function (languageData) {
	    _utilsFlux2['default'].getActions('translations').addLocaleData({
	        "locale": "en",
	        "pluralRuleFunction": function pluralRuleFunction(n, ord) {
	            var s = String(n).split("."),
	                v0 = !s[1],
	                t0 = Number(s[0]) == n,
	                n10 = t0 && s[0].slice(-1),
	                n100 = t0 && s[0].slice(-2);
	
	            if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";
	
	            return n == 1 && v0 ? "one" : "other";
	        }
	    });
	
	    _utilsFlux2['default'].getActions('translations').addMessages({
	        locales: ['en'],
	        messages: languageData
	    });
	
	    // Check if we are authenticated and already have a _CSRF Token
	    if (!_utilsFlux2['default'].getStore('app').isAuthenticated() || !_store2['default'].get('_CSRF')) {
	        _store2['default'].set('_CSRF', languageData._CSRF);
	    }
	}));
	
	Promise.all(promises).then(function () {
	    // Render the app at correct URL
	    _reactRouter2['default'].run(_routes2['default'], function (Handler, state) {
	        // We need to force Close all Modals on transtion
	        _utilsFlux2['default'].getActions('modals').closeModals();
	        _utilsFlux2['default'].getStore('app').closeOffcanvas();
	
	        // Render the app
	        _react2['default'].render(_react2['default'].createElement(Handler, _extends({ flux: _utilsFlux2['default'] }, state)), document.getElementById('app'));
	    });
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _tcombForm = __webpack_require__(64);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var Form = _tcombForm2['default'].form.Form;
	var Accept = _tcombForm2['default'].struct({
	    termsAccepted: _tcombForm2['default'].subtype(_tcombForm2['default'].Boolean, function (s) {
	        return s === true;
	    })
	});
	
	var TermsForm = _react2['default'].createClass({
	    displayName: 'TermsForm',
	    mixins: [_reactRouter.Navigation],
	    propTypes: {
	        hasError: _react2['default'].PropTypes.oneOfType([_react2['default'].PropTypes.string, _react2['default'].PropTypes.bool])
	    },
	    getInitialState: function getInitialState() {
	        return {
	            termsAccepted: false,
	            acceptTermsSuccess: false,
	            submitting: false
	        };
	    },
	    _setInnerHtml: function _setInnerHtml(html) {
	        return { __html: html };
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.hasError && this.state.submitting) {
	            this.setState({ submitting: false });
	        }
	    },
	    onSubmit: function onSubmit(evt) {
	        var _this = this;
	
	        evt.preventDefault();
	        var location = this.props.location;
	
	        var acceptData = this.refs.form.getValue();
	        acceptData = Object.assign({}, acceptData, { action: 'termsAccepted' });
	
	        if (acceptData && !!acceptData.termsAccepted) {
	            this.setState({
	                submitting: true
	            });
	            _utilsFlux2['default'].getStore('app').acceptTerms(acceptData).then(function () {
	                _this.setState({
	                    acceptTermsSuccess: true,
	                    submitting: false
	                });
	                var query = _this.context.router.getCurrentQuery();
	                if (query.nextPath && query.nextPath.length > 1) {
	                    _this.transitionTo(query.nextPath, {});
	                } else {
	                    _this.replaceWith('landing-page');
	                }
	            })['catch'](function (error) {
	                console.error(error);
	            });
	        }
	    },
	    renderError: function renderError() {
	        if (this.props.hasError) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'content__error' },
	                this.props.hasError
	            );
	        }
	    },
	    onChange: function onChange(value) {
	        this.setState(value);
	    },
	    render: function render() {
	        var options = {
	            auto: 'labels',
	            template: function template(locals) {
	                var inputs = locals.inputs;
	
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'form__register' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'register__tac' },
	                        _react2['default'].createElement('p', { className: 'text-light', dangerouslySetInnerHTML: _utilsDom2['default'].setInnerHtml(_utilsFlux2['default'].t('accept_terms_links')) }),
	                        inputs.termsAccepted
	                    )
	                );
	            },
	            fields: {
	                termsAccepted: {
	                    type: 'checkbox',
	                    error: _utilsFlux2['default'].t('validation_accepted_terms'),
	                    label: _utilsFlux2['default'].t('register_accepted_terms')
	                }
	            }
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'h1',
	                null,
	                _utilsFlux2['default'].t('accept_terms_title')
	            ),
	            _react2['default'].createElement(
	                'form',
	                { onSubmit: this.onSubmit },
	                _react2['default'].createElement(Form, {
	                    ref: 'form',
	                    type: Accept,
	                    value: this.state,
	                    options: options,
	                    onChange: this.onChange
	                }),
	                this.renderError(),
	                _react2['default'].createElement('hr', { className: 'white' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'register__submit' },
	                    _react2['default'].createElement(
	                        'button',
	                        { disabled: this.state.submitting, type: 'submit', className: 'btn btn-primary btn-arrow' },
	                        _utilsFlux2['default'].t('register_submit'),
	                        _react2['default'].createElement('i', { className: 'chevron-right' })
	                    )
	                ),
	                _react2['default'].createElement('div', { className: 'mejs-clear' })
	            )
	        );
	    }
	});
	
	module.exports = TermsForm;

/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortal = __webpack_require__(129);
	
	var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _termsForm = __webpack_require__(486);
	
	var _termsForm2 = _interopRequireDefault(_termsForm);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var AcceptTermsPage = _react2['default'].createClass({
	    displayName: 'AcceptTermsPage',
	    mixins: [],
	    propTypes: {},
	    statics: {
	        willTransitionTo: function willTransitionTo(transition) {
	            if (!_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	                transition.redirect('/login');
	            }
	            if (_utilsFlux2['default'].getStore('app').hasAcceptedLatestTerms()) {
	                transition.redirect('/');
	            }
	        }
	    },
	
	    getTitle: function getTitle(html) {
	        return { __html: html };
	    },
	
	    componentDidMount: function componentDidMount() {},
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'page terms' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'container--centered' },
	                _react2['default'].createElement(_termsForm2['default'], null)
	            )
	        );
	    }
	});
	
	module.exports = AcceptTermsPage;

/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _tcombForm = __webpack_require__(64);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _reactSelect = __webpack_require__(377);
	
	var _reactSelect2 = _interopRequireDefault(_reactSelect);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Form = _tcombForm2['default'].form.Form;
	var AccountEditPage = _react2['default'].createClass({
	    displayName: 'AccountEditPage',
	    propTypes: {},
	    getInitialState: function getInitialState() {
	        return {
	            editMode: false,
	            accountData: {}
	        };
	    },
	    componentWillMount: function componentWillMount() {
	        _utilsFlux2['default'].getStore('app').loadAccountData();
	        _utilsFlux2['default'].getStore('app').getState();
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.setState({ accountData: nextProps.appStore.accountData });
	    },
	    saveAccountChanges: function saveAccountChanges(e) {
	        var _this = this;
	
	        e.preventDefault();
	        var accountData = this.refs.form.getValue();
	        if (accountData) {
	            _utilsFlux2['default'].getStore('app').updateAccountData(accountData).then(function () {
	                _this.setState({ editMode: false });
	            });
	        }
	    },
	    chancelEditMode: function chancelEditMode(e) {
	        e.preventDefault();
	        this.setState({ editMode: false, accountData: this.props.appStore.accountData });
	    },
	    setEditMode: function setEditMode(e) {
	        e.preventDefault();
	        this.setState({ editMode: true });
	    },
	    onChange: function onChange(value) {
	        this.setState({ accountData: value });
	    },
	    renderError: function renderError() {
	        if (this.props.appStore.error) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'field__error' },
	                this.props.appStore.error
	            );
	        }
	    },
	    renderButtons: function renderButtons() {
	        var btnRow;
	        if (this.state.editMode) {
	            btnRow = _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.chancelEditMode, className: 'btn btn-secondary', type: 'button' },
	                    _utilsFlux2['default'].t('cancel')
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { className: 'btn btn-primary btn-arrow', type: 'submit' },
	                    _utilsFlux2['default'].t('account_save'),
	                    _react2['default'].createElement('i', { className: 'chevron-right' })
	                )
	            );
	        } else {
	            btnRow = _react2['default'].createElement(
	                'button',
	                { onClick: this.setEditMode, className: 'btn btn-primary btn-arrow', type: 'button' },
	                _utilsFlux2['default'].t('account_edit'),
	                _react2['default'].createElement('i', { className: 'chevron-right' })
	            );
	        }
	
	        return btnRow;
	    },
	    render: function render() {
	        var _this2 = this;
	
	        var _flux$getStore$getState = _utilsFlux2['default'].getStore('app').getState();
	
	        var registerForm = _flux$getStore$getState.registerForm;
	
	        var EditFields = {};
	        var fields = {};
	
	        var selectTemplate = function selectTemplate(values) {
	            return function (locals) {
	                if (locals.disabled) {
	                    var value = locals.value;
	                    var listValue = values.filter(function (_value) {
	                        return _value.value === value;
	                    });
	                    if (listValue.length === 1) {
	                        value = listValue[0].label;
	                    }
	                    return _react2['default'].createElement(
	                        'div',
	                        { className: 'field' },
	                        _react2['default'].createElement(
	                            'label',
	                            null,
	                            locals.label
	                        ),
	                        _react2['default'].createElement('input', { type: 'text', value: value, disabled: true })
	                    );
	                }
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'field' },
	                    _react2['default'].createElement(
	                        'label',
	                        null,
	                        locals.label
	                    ),
	                    _react2['default'].createElement(_reactSelect2['default'], {
	                        name: 'country',
	                        placeholder: _utilsFlux2['default'].t('validation_country'),
	                        options: values,
	                        value: locals.value,
	                        disabled: !_this2.state.editMode,
	                        onChange: locals.onChange
	                    }),
	                    locals.hasError ? _react2['default'].createElement(
	                        'div',
	                        { className: 'field__error' },
	                        locals.error
	                    ) : ''
	                );
	            };
	        };
	
	        registerForm.forEach(function (row) {
	            row.registerColumns.forEach(function (column) {
	                column.registerFields.forEach(function (field) {
	                    if (field.name !== "password" && field.name !== "password_repeat" && field.name !== "comment") {
	                        EditFields[field.name] = field.validationRequired ? _tcombForm2['default'].Str : _tcombForm2['default'].maybe(_tcombForm2['default'].Str);
	                        fields[field.name] = {
	                            error: _utilsFlux2['default'].t(field.errorKey),
	                            label: _utilsFlux2['default'].t(field.labelKey) + (field.validationRequired ? "*" : ""),
	                            disabled: !_this2.state.editMode
	                        };
	                        if (field.type) {
	                            fields[field.name]["type"] = field.type;
	                        }
	                        if (field.values.length > 0) {
	                            var values = [];
	                            field.values.forEach(function (value) {
	                                return values.push({ value: value.key, label: value.value });
	                            });
	                            fields[field.name]["template"] = selectTemplate(values);
	                        }
	                    }
	                });
	            });
	        });
	
	        var AccountEdit = _tcombForm2['default'].struct(EditFields);
	
	        var options = {
	            auto: 'labels',
	            template: function template(locals) {
	                var inputs = locals.inputs;
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'form__edit' },
	                    registerForm.map(function (row) {
	                        if (row.registerColumns.length == 1) {
	                            return _react2['default'].createElement(
	                                'div',
	                                null,
	                                row.registerColumns[0].registerFields[0] && inputs[row.registerColumns[0].registerFields[0].name]
	                            );
	                        } else if (row.registerColumns.length > 1) {
	                            return _react2['default'].createElement(
	                                'div',
	                                null,
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'edit__left' },
	                                    row.registerColumns[0].registerFields[0] && inputs[row.registerColumns[0].registerFields[0].name]
	                                ),
	                                _react2['default'].createElement(
	                                    'div',
	                                    { className: 'edit__right' },
	                                    row.registerColumns[1].registerFields[0] && inputs[row.registerColumns[1].registerFields[0].name]
	                                )
	                            );
	                        }
	                    })
	                );
	            },
	            fields: _extends({}, fields)
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'account__edit' },
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('account_details')
	            ),
	            _react2['default'].createElement(
	                'form',
	                { onSubmit: this.saveAccountChanges, className: (0, _classnames2['default'])({ 'readonly': !this.state.editMode }) },
	                _react2['default'].createElement(Form, {
	                    ref: 'form',
	                    type: AccountEdit,
	                    value: this.state.accountData,
	                    onChange: this.onChange,
	                    options: options
	                }),
	                _react2['default'].createElement('hr', { className: 'white' }),
	                this.renderError(),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'edit__buttons' },
	                    this.renderButtons()
	                )
	            )
	        );
	    }
	});
	
	module.exports = AccountEditPage;

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var _tcombForm = __webpack_require__(64);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var Form = _tcombForm2['default'].form.Form;
	
	var ChangePassword = _tcombForm2['default'].struct({
	    current_password: _tcombForm2['default'].Str,
	    password: _tcombForm2['default'].Str, // t.subtype(t.Str, (s) => s.length > 9),
	    password_repeat: _tcombForm2['default'].Str
	});
	
	var AccountPasswordPage = _react2['default'].createClass({
	    displayName: 'AccountPasswordPage',
	    propTypes: {},
	    getInitialState: function getInitialState() {
	        return {
	            changePasswordSuccess: false
	        };
	    },
	    onChange: function onChange(value) {
	        this.setState(value);
	    },
	    renderError: function renderError() {
	        if (this.props.appStore.error) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'field__error' },
	                this.props.appStore.error
	            );
	        }
	    },
	    onSubmit: function onSubmit(e) {
	        var _this = this;
	
	        e.preventDefault();
	        var passwordData = this.refs.form.getValue();
	        if (passwordData) {
	            _utilsFlux2['default'].getStore('app').updatePassword({
	                password: passwordData.password,
	                current_password: passwordData.current_password
	            }).then(function () {
	                _this.setState({ changePasswordSuccess: true });
	            });
	        }
	    },
	    render: function render() {
	        if (this.state.changePasswordSuccess) {
	            return _react2['default'].createElement(
	                'h4',
	                { className: 'form__success' },
	                _utilsFlux2['default'].t('account_password_new_success')
	            );
	        }
	        var options = {
	            auto: 'labels',
	            fields: {
	                current_password: {
	                    type: 'password',
	                    error: _utilsFlux2['default'].t('validation_password'),
	                    label: _utilsFlux2['default'].t('account_password_current')
	                },
	                password: {
	                    type: 'password',
	                    error: _utilsFlux2['default'].t('validation_password'),
	                    label: _utilsFlux2['default'].t('account_password_new')
	                },
	                password_repeat: {
	                    type: 'password',
	                    hasError: this.state.password !== this.state.password_repeat,
	                    error: _utilsFlux2['default'].t('validation_password_repeat'),
	                    label: _utilsFlux2['default'].t('account_password_confirm')
	                }
	            }
	        };
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'account__editpassword' },
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('account_password_change_head')
	            ),
	            _react2['default'].createElement('p', { dangerouslySetInnerHTML: _utilsDom2['default'].setInnerHtml(_utilsFlux2['default'].t('account_password_required')) }),
	            _react2['default'].createElement(
	                'form',
	                { onSubmit: this.onSubmit },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editpassword__form' },
	                    _react2['default'].createElement(Form, {
	                        ref: 'form',
	                        type: ChangePassword,
	                        options: options,
	                        value: this.state,
	                        onChange: this.onChange
	                    }),
	                    this.renderError()
	                ),
	                _react2['default'].createElement('hr', { className: 'white' }),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'editpassword__buttons' },
	                    _react2['default'].createElement(
	                        'button',
	                        { disabled: _utilsFlux2['default'].getStore('app').isLoading(), type: 'submit', className: 'btn btn-primary btn-arrow' },
	                        _utilsFlux2['default'].t('account_password_change_head'),
	                        _react2['default'].createElement('i', { className: 'chevron-right' })
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = AccountPasswordPage;

/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var _componentsHeaderBarHeaderSearch = __webpack_require__(190);
	
	var _componentsHeaderBarHeaderSearch2 = _interopRequireDefault(_componentsHeaderBarHeaderSearch);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var AccountPage = _react2['default'].createClass({
	    displayName: 'AccountPage',
	    mixins: [],
	    propTypes: {},
	    statics: {
	        willTransitionTo: function willTransitionTo(transition) {
	            if (!_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	                transition.redirect('/login', {}, { nextPath: transition.path });
	            }
	            if (!_utilsFlux2['default'].getStore('app').hasAcceptedLatestTerms()) {
	                transition.redirect('/accept_terms', {}, { nextPath: transition.path });
	            }
	        }
	    },
	    render: function render() {
	        var _flux$getStore$getState = _utilsFlux2['default'].getStore('app').getState();
	
	        var accountEditable = _flux$getStore$getState.accountEditable;
	        var passwordEditable = _flux$getStore$getState.passwordEditable;
	        var config = _flux$getStore$getState.config;
	
	        var _config$toJS = config.toJS();
	
	        var disableChangePassword = _config$toJS.disableChangePassword;
	        var disableAccountDetails = _config$toJS.disableAccountDetails;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'page account' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'headerbar' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'container--centered' },
	                    _react2['default'].createElement(_componentsHeaderBarHeaderSearch2['default'], null)
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'account__container container--centered' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'container__navigation' },
	                    _react2['default'].createElement(
	                        'ul',
	                        null,
	                        false !== accountEditable && !disableAccountDetails && _react2['default'].createElement(
	                            'li',
	                            null,
	                            _react2['default'].createElement(
	                                _reactRouter.Link,
	                                { to: 'accountDetails' },
	                                _utilsFlux2['default'].t('account_details')
	                            )
	                        ),
	                        false !== passwordEditable && !disableChangePassword && _react2['default'].createElement(
	                            'li',
	                            null,
	                            _react2['default'].createElement(
	                                _reactRouter.Link,
	                                { to: 'accountPassword' },
	                                _utilsFlux2['default'].t('account_password_change_head')
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'li',
	                            null,
	                            _react2['default'].createElement(
	                                'a',
	                                { href: '/#/terms-of-use', target: '_blank' },
	                                _utilsFlux2['default'].t('terms-of-use')
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        _reactRouter.Link,
	                        { to: 'landing-page', className: 'navigation__back' },
	                        _react2['default'].createElement('i', { className: 'chevron-left' }),
	                        _utilsFlux2['default'].t('back_to_home')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'container__content' },
	                    false !== accountEditable && _react2['default'].createElement(
	                        _altContainer2['default'],
	                        { stores: { appStore: _utilsFlux2['default'].getStore('app') } },
	                        _react2['default'].createElement(_reactRouter.RouteHandler, this.props)
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = AccountPage;

/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _utilsDom = __webpack_require__(32);
	
	var _componentsHeaderHeader = __webpack_require__(451);
	
	var _componentsHeaderHeader2 = _interopRequireDefault(_componentsHeaderHeader);
	
	var _componentsOffcanvasOffcanvas = __webpack_require__(480);
	
	var _componentsOffcanvasOffcanvas2 = _interopRequireDefault(_componentsOffcanvasOffcanvas);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _componentsModals = __webpack_require__(469);
	
	var _componentsModals2 = _interopRequireDefault(_componentsModals);
	
	var AppPage = _react2['default'].createClass({
	    displayName: 'AppPage',
	
	    mixins: [],
	
	    propTypes: {},
	
	    componentWillMount: function componentWillMount() {
	        var appStore = this.props.flux.getStore('app');
	        if (appStore.isAuthenticated()) {
	            this.handleBranding();
	
	            // Prevent Double fetching
	            // @todo: this isn't the cleanest option...
	            if (this.props.pathname.indexOf('baskets') === -1 && this.props.pathname.indexOf('downloads')) {
	                var basketStore = this.props.flux.getStore('basket');
	                !basketStore.isLoading() && basketStore.loadBaskets();
	            }
	        }
	    },
	
	    componentWillUpdate: function componentWillUpdate() {
	        this.handleBranding();
	    },
	
	    handleBranding: function handleBranding() {
	        var appStore = this.props.flux.getStore('app');
	
	        var _appStore$getState = appStore.getState();
	
	        var branding = _appStore$getState.branding;
	
	        var className = 'branding--' + branding;
	        var targetEl = document.getElementsByTagName('html')[0];
	
	        if (!appStore.isAuthenticated()) {
	            (0, _utilsDom.removeClass)(targetEl, branding);
	            return;
	        }
	
	        if (branding && !(0, _utilsDom.hasClass)(targetEl, className)) {
	            (0, _utilsDom.addClass)(targetEl, className);
	        }
	    },
	
	    render: function render() {
	        var flux = this.props.flux;
	
	        var _flux$getStore$getState = flux.getStore('app').getState();
	
	        var config = _flux$getStore$getState.config;
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                _altContainer2['default'],
	                {
	                    stores: {
	                        appStore: flux.getStore('app'),
	                        basketStore: flux.getStore('basket')
	                    },
	                    transform: function (_ref) {
	                        var appStore = _ref.appStore;
	                        var basketStore = _ref.basketStore;
	
	                        var isAuthenticated = flux.getStore('app').isAuthenticated();
	                        var hasAcceptedLatestTerms = flux.getStore('app').hasAcceptedLatestTerms();
	                        var activeBasketId = basketStore.activeBasketId;
	                        var baskets = basketStore.baskets;
	                        return { isAuthenticated: isAuthenticated, hasAcceptedLatestTerms: hasAcceptedLatestTerms, activeBasketId: activeBasketId, baskets: baskets };
	                    } },
	                _react2['default'].createElement(_componentsHeaderHeader2['default'], null),
	                _react2['default'].createElement(_componentsOffcanvasOffcanvas2['default'], null)
	            ),
	            _react2['default'].createElement(_reactRouter.RouteHandler, this.props),
	            _react2['default'].createElement(
	                _altContainer2['default'],
	                { stores: { modalStore: flux.getStore('modals') } },
	                _react2['default'].createElement(_componentsModals2['default'], null)
	            )
	        );
	    }
	});
	
	module.exports = AppPage;

/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _componentsThumb = __webpack_require__(104);
	
	var _componentsThumb2 = _interopRequireDefault(_componentsThumb);
	
	var _prettyBytes = __webpack_require__(166);
	
	var _prettyBytes2 = _interopRequireDefault(_prettyBytes);
	
	var BasketListingItem = _react2['default'].createClass({
	
	    displayName: 'BasketListingItem',
	
	    mixins: [],
	
	    propTypes: {
	        item: _react2['default'].PropTypes.object
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	        return _immutable2['default'].is(nextProps.item, this.props.item) === false;
	    },
	
	    toggleCheck: function toggleCheck(size, e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('basket').toggleDownload({ itemId: this.props.item.get('id'), fileKey: size });
	    },
	
	    removeItem: function removeItem(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getStore('basket').deleteBasketItem(this.props.item.get('id'));
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var item = this.props.item.toJS();
	        var meta = item.meta;
	        var files = item.files;
	
	        var master = files.find(function (file) {
	            return 'master' === file.key;
	        }) || files.length && files[0];
	        var MICode = meta.find(function (meta) {
	            return 'MICode' === meta.key;
	        });
	        var duration = master && master.meta && master.meta.find && master.meta.length > 0 && master.meta.find(function (meta) {
	            return 'Duration' === meta.name;
	        });
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'basket__item' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__image' },
	                _react2['default'].createElement(_componentsThumb2['default'], { className: 'item__preview', media: this.props.item, onClickOpenModal: true, isBasketItem: true })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__description' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'description__title' },
	                    item.title.length ? item.title : '&nbsp;',
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#', onClick: this.removeItem, className: 'item__remove' },
	                        _react2['default'].createElement('span', { className: 'close-small' }),
	                        _utilsFlux2['default'].t('remove_baskets')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'description__meta' },
	                    MICode && MICode.value.length > 0 && _react2['default'].createElement(
	                        'span',
	                        { className: 'meta__id' },
	                        MICode.value
	                    ),
	                    duration && duration.value.length > 0 && _react2['default'].createElement(
	                        'span',
	                        { className: 'meta__duration' },
	                        duration.value
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'description__download' },
	                    _react2['default'].createElement(
	                        'form',
	                        null,
	                        _react2['default'].createElement(
	                            'table',
	                            null,
	                            _react2['default'].createElement(
	                                'thead',
	                                null,
	                                _react2['default'].createElement(
	                                    'th',
	                                    { className: 'download__head--checkbox' },
	                                    ' '
	                                ),
	                                _react2['default'].createElement(
	                                    'th',
	                                    null,
	                                    _utilsFlux2['default'].t('download_file_format')
	                                ),
	                                _react2['default'].createElement(
	                                    'th',
	                                    null,
	                                    _utilsFlux2['default'].t('download_file_mimetype')
	                                ),
	                                _react2['default'].createElement(
	                                    'th',
	                                    null,
	                                    _utilsFlux2['default'].t('download_file_size')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'tbody',
	                                null,
	                                item.files.map(function (file) {
	                                    var dimensions = file.meta && file.meta.length > 0 && file.meta.find(function (meta) {
	                                        return !meta.hidden && 'Dimensions' === meta.name;
	                                    });
	                                    return _react2['default'].createElement(
	                                        'tr',
	                                        { key: 'i-' + item.id + '-' + file.key },
	                                        _react2['default'].createElement(
	                                            'td',
	                                            { className: 'file__key download__body--checkbox' },
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: 'field__checkbox download__checkbox' },
	                                                _react2['default'].createElement('input', { id: 'check__all', checked: file._download, type: 'checkbox', readOnly: true }),
	                                                _react2['default'].createElement(
	                                                    'label',
	                                                    { onClick: _this.toggleCheck.bind(null, file.name), htmlFor: 'check__all' },
	                                                    file.name
	                                                )
	                                            )
	                                        ),
	                                        _react2['default'].createElement(
	                                            'td',
	                                            { className: 'file__dimensions' },
	                                            dimensions && dimensions.value
	                                        ),
	                                        _react2['default'].createElement(
	                                            'td',
	                                            { className: 'file__mimetype' },
	                                            file.mimeType
	                                        ),
	                                        _react2['default'].createElement(
	                                            'td',
	                                            { className: 'file__size' },
	                                            (0, _prettyBytes2['default'])(file.size)
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = BasketListingItem;

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombForm = __webpack_require__(64);
	
	var _tcombForm2 = _interopRequireDefault(_tcombForm);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactKeybinding = __webpack_require__(365);
	
	var _reactKeybinding2 = _interopRequireDefault(_reactKeybinding);
	
	var Form = _tcombForm2['default'].form.Form;
	var BasketTitleForm = _tcombForm2['default'].struct({
	    name: _tcombForm2['default'].Str
	});
	
	var BasketTitle = _react2['default'].createClass({
	    displayName: 'BasketTitle',
	    mixins: [_reactKeybinding2['default']],
	    propTypes: {
	        name: _react2['default'].PropTypes.string.isRequired,
	        basketId: _react2['default'].PropTypes.string.isRequired
	    },
	    keybindings: {
	        'esc': function esc() {
	            this.setState({ editMode: false });
	        }
	    },
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (nextProps.name !== this.props.name) {
	            this.setState({ editMode: false, name: nextProps.name });
	        }
	    },
	    getInitialState: function getInitialState() {
	        return {
	            editMode: false,
	            name: this.props.name
	        };
	    },
	    onSubmit: function onSubmit(e) {
	        var _this = this;
	
	        e.preventDefault();
	        var data = this.refs.form.getValue();
	        if (data) {
	            if (data.name === this.props.name) {
	                this.setState({ editMode: false });
	            } else {
	                _utilsFlux2['default'].getStore('basket').editBasketName(this.props.basketId, data.name).then(function () {
	                    _this.setState({ editMode: false });
	                });
	            }
	        }
	    },
	    toggleEdit: function toggleEdit(e) {
	        e.preventDefault();
	        this.setState({ editMode: !this.state.editMode });
	    },
	    onChange: function onChange(value) {
	        this.setState({ name: value.name });
	    },
	    renderTitle: function renderTitle() {
	        var options = {
	            auto: 'placeholders',
	            fields: {
	                name: {
	                    attrs: {
	                        autoFocus: true
	                    }
	                }
	            }
	        };
	
	        if (this.state.editMode) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'title__edit' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'edit__submit' },
	                    _react2['default'].createElement(
	                        'a',
	                        { href: '#', role: 'button', onClick: this.onSubmit },
	                        _react2['default'].createElement('i', { className: 'pencil' })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'form',
	                    { onSubmit: this.onSubmit },
	                    _react2['default'].createElement(Form, {
	                        ref: 'form',
	                        type: BasketTitleForm,
	                        options: options,
	                        value: this.state,
	                        onChange: this.onChange
	                    })
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'edit__close' },
	                    _react2['default'].createElement('a', { href: '#', onClick: this.toggleEdit })
	                )
	            );
	        } else {
	            return _react2['default'].createElement(
	                'h4',
	                null,
	                _react2['default'].createElement(
	                    'a',
	                    { href: '#', onClick: this.toggleEdit },
	                    _react2['default'].createElement('i', { className: 'pencil' })
	                ),
	                ' ',
	                this.props.name
	            );
	        }
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'basket__title' },
	            this.renderTitle()
	        );
	    }
	});
	
	module.exports = BasketTitle;

/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _componentsQuotaQuotaWarning = __webpack_require__(192);
	
	var _componentsQuotaQuotaWarning2 = _interopRequireDefault(_componentsQuotaQuotaWarning);
	
	var _componentsFooterBarFooterBar = __webpack_require__(187);
	
	var _componentsFooterBarFooterBar2 = _interopRequireDefault(_componentsFooterBarFooterBar);
	
	var _basketTitle = __webpack_require__(493);
	
	var _basketTitle2 = _interopRequireDefault(_basketTitle);
	
	var _basketListingItem = __webpack_require__(492);
	
	var _basketListingItem2 = _interopRequireDefault(_basketListingItem);
	
	var _componentsBasketBasketEmpty = __webpack_require__(448);
	
	var _componentsBasketBasketEmpty2 = _interopRequireDefault(_componentsBasketBasketEmpty);
	
	var _componentsBasketBasketSidebar = __webpack_require__(186);
	
	var _componentsBasketBasketSidebar2 = _interopRequireDefault(_componentsBasketBasketSidebar);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var _componentsHeaderBarHeaderBasket = __webpack_require__(457);
	
	var _componentsHeaderBarHeaderBasket2 = _interopRequireDefault(_componentsHeaderBarHeaderBasket);
	
	var BasketPage = _react2['default'].createClass({
	    displayName: 'BasketPage',
	    mixins: [],
	    propTypes: {},
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    statics: {
	        willTransitionTo: function willTransitionTo(transition, param, query, callback) {
	            if (!_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	                return transition.redirect('/login', {}, { nextPath: transition.path });
	            }
	            if (!_utilsFlux2['default'].getStore('app').hasAcceptedLatestTerms()) {
	                return transition.redirect('/accept_terms', {}, { nextPath: transition.path });
	            }
	            _utilsFlux2['default'].getActions('modals').activateLoading();
	            return BasketPage.getBasketData(param).then(function () {
	                _utilsFlux2['default'].getActions('modals').disableLoading();
	                callback();
	            })['catch'](function (e) {
	                _utilsFlux2['default'].getActions('basket').activateLast();
	            });
	        },
	
	        getBasketData: function getBasketData(param) {
	            var basketStore;
	            return regeneratorRuntime.async(function getBasketData$(context$1$0) {
	                while (1) switch (context$1$0.prev = context$1$0.next) {
	                    case 0:
	                        basketStore = _utilsFlux2['default'].getStore('basket');
	                        context$1$0.next = 3;
	                        return regeneratorRuntime.awrap(basketStore.loadBaskets());
	
	                    case 3:
	                        if (!param.id) {
	                            context$1$0.next = 6;
	                            break;
	                        }
	
	                        context$1$0.next = 6;
	                        return regeneratorRuntime.awrap(basketStore.loadBasket(param.id));
	
	                    case 6:
	                    case 'end':
	                        return context$1$0.stop();
	                }
	            }, null, this);
	        }
	    },
	    render: function render() {
	        var currentBasketId = this.props.params.id;
	        var router = this.context.router;
	        var basketStore = _utilsFlux2['default'].getStore('basket');
	        var mediaStore = _utilsFlux2['default'].getStore('media');
	        var modalStore = _utilsFlux2['default'].getStore('modals');
	
	        return _react2['default'].createElement(_altContainer2['default'], {
	            stores: { basketStore: basketStore, mediaStore: mediaStore, modalStore: modalStore },
	            render: function (props) {
	                var currentBasket = props.basketStore.basket;
	
	                var _modalStore$getState = modalStore.getState();
	
	                var loading = _modalStore$getState.loading;
	
	                if (!(basketStore.isLoading() || loading)) {
	                    // Coming from the 'basket' page
	                    if (!currentBasketId && currentBasket.size > 0) {
	                        router.transitionTo('singleBasket', { id: currentBasket.get('id') });
	                    }
	
	                    // No Baskets
	                    if (!currentBasket || currentBasket.size === 0) {
	                        return _react2['default'].createElement(_componentsBasketBasketEmpty2['default'], null);
	                    }
	
	                    // Basket Not Found
	                    if (!currentBasket || currentBasket.size === 0) {
	                        router.transitionTo('landing-page');
	                        return _react2['default'].createElement('div', null);
	                    }
	                }
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'page baskets' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'headerbar' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container--centered' },
	                            _react2['default'].createElement(_componentsHeaderBarHeaderBasket2['default'], { basket: currentBasket, baskets: props.basketStore.baskets })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'basket__container container--centered' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__filters' },
	                            _react2['default'].createElement(_componentsBasketBasketSidebar2['default'], { name: 'singleBasket', baskets: props.basketStore.baskets })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__content' },
	                            basketStore.isLoading() || loading ? _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null) : _react2['default'].createElement(
	                                'div',
	                                null,
	                                _react2['default'].createElement(_componentsQuotaQuotaWarning2['default'], null),
	                                _react2['default'].createElement(_basketTitle2['default'], { name: currentBasket.get('name'), basketId: currentBasket.get('id') }),
	                                currentBasket.get('items').map(function (item, ix) {
	                                    return _react2['default'].createElement(_basketListingItem2['default'], { key: 'basket_li_' + ix, item: item });
	                                }),
	                                currentBasket.get('items').size === 0 ? _react2['default'].createElement(
	                                    'p',
	                                    null,
	                                    _utilsFlux2['default'].t('no_basket_selected')
	                                ) : ''
	                            )
	                        )
	                    )
	                );
	            } });
	    }
	});
	
	module.exports = BasketPage;

/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortal = __webpack_require__(129);
	
	var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _pagesLoginLoginSlideshow = __webpack_require__(194);
	
	var _pagesLoginLoginSlideshow2 = _interopRequireDefault(_pagesLoginLoginSlideshow);
	
	var _pagesLoginLoginBackgroundVideo = __webpack_require__(193);
	
	var _pagesLoginLoginBackgroundVideo2 = _interopRequireDefault(_pagesLoginLoginBackgroundVideo);
	
	var _componentsModalsModal = __webpack_require__(191);
	
	var _componentsModalsModal2 = _interopRequireDefault(_componentsModalsModal);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _componentsModalsConfirmEmailModal = __webpack_require__(466);
	
	var _componentsModalsConfirmEmailModal2 = _interopRequireDefault(_componentsModalsConfirmEmailModal);
	
	var ConfirmEmailPage = _react2['default'].createClass({
	
	    displayName: 'ConfirmEmailPage',
	
	    mixins: [],
	
	    propTypes: {},
	
	    getInitialState: function getInitialState() {
	        return {};
	    },
	
	    renderFullbleed: function renderFullbleed() {
	        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	        var backGroundLayer;
	
	        if (!isMobile) {
	            if (window.config.backgroundMovie.length > 1 && window.config.backgroundMovie.indexOf("-") > 1) {
	                backGroundLayer = _react2['default'].createElement(_pagesLoginLoginBackgroundVideo2['default'], {
	                    poster: window.config.slideshowImages[0],
	                    video: window.config.backgroundMovie
	                });
	            } else {
	                backGroundLayer = _react2['default'].createElement(_pagesLoginLoginSlideshow2['default'], {
	                    show: window.config.slideshowImages,
	                    speed: 4000
	                });
	            }
	        } else {
	            backGroundLayer = _react2['default'].createElement(_pagesLoginLoginSlideshow2['default'], {
	                show: window.config.slideshowImages,
	                speed: 4000
	            });
	        }
	
	        return backGroundLayer;
	    },
	
	    //
	    // Try to submit the query data immediately even before rendering the modal
	    componentWillMount: function componentWillMount() {
	        var _this = this;
	
	        var data = { email: this.props.query.email, code: this.props.query.code };
	        if (this.props.query.email && this.props.query.code) {
	            _utilsFlux2['default'].getStore('app').confirmEmail(data).then(function () {
	                _this.setState({ autoConfirmSuccess: true });
	            });
	        }
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'welcome container--centered' },
	            _react2['default'].createElement(_altContainer2['default'], {
	                stores: { appStore: _utilsFlux2['default'].getStore('app') },
	                render: function (props) {
	                    if (_utilsFlux2['default'].getStore('app').isLoading()) {
	                        return null;
	                    }
	                    var hasError = props.appStore.error;
	                    return _react2['default'].createElement(
	                        _reactPortal2['default'],
	                        { isOpened: true },
	                        _react2['default'].createElement(
	                            _componentsModalsModal2['default'],
	                            { className: 'modal__confirm-email', closeOnOutsideClick: false, hideCloseButton: true },
	                            _react2['default'].createElement(_componentsModalsConfirmEmailModal2['default'], _extends({ hasError: hasError, autoConfirmSuccess: _this2.state.autoConfirmSuccess }, _this2.props))
	                        )
	                    );
	                }
	            }),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: true },
	                this.renderFullbleed()
	            )
	        );
	    }
	});
	
	module.exports = ConfirmEmailPage;

/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _componentsHeaderBarHeaderSearch = __webpack_require__(190);
	
	var _componentsHeaderBarHeaderSearch2 = _interopRequireDefault(_componentsHeaderBarHeaderSearch);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var _reactRouter = __webpack_require__(7);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var HelpPage = _react2['default'].createClass({
	    displayName: 'HelpPage',
	    mixins: [],
	    statics: {
	        willTransitionTo: function willTransitionTo(transition) {
	            if (!_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	                transition.redirect('/login', {}, { nextPath: transition.path });
	            }
	            if (!_utilsFlux2['default'].getStore('app').hasAcceptedLatestTerms()) {
	                transition.redirect('/accept_terms', {}, { nextPath: transition.path });
	            }
	        }
	    },
	    render: function render() {
	        var mediaStore = _utilsFlux2['default'].getStore('media');
	        var modalStore = _utilsFlux2['default'].getStore('modals');
	        return _react2['default'].createElement(_altContainer2['default'], { stores: { mediaStore: mediaStore, modalStore: modalStore },
	            render: function (props) {
	                var _modalStore$getState = modalStore.getState();
	
	                var loading = _modalStore$getState.loading;
	
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'page help' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'headerbar' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container--centered' },
	                            _react2['default'].createElement(_componentsHeaderBarHeaderSearch2['default'], { query: props.mediaStore.params.search })
	                        )
	                    ),
	                    loading ? _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null) : _react2['default'].createElement(
	                        'div',
	                        { className: 'help__container container--centered' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__navigation' },
	                            _react2['default'].createElement(
	                                _reactRouter.Link,
	                                { to: 'landing-page', className: 'sidebar__back' },
	                                _react2['default'].createElement('i', { className: 'chevron-left' }),
	                                _utilsFlux2['default'].t('back_to_home')
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__content' },
	                            _react2['default'].createElement('div', { dangerouslySetInnerHTML: _utilsDom2['default'].setInnerHtml(_utilsFlux2['default'].t('help_me_text')) })
	                        )
	                    )
	                );
	            } });
	    }
	});
	
	module.exports = HelpPage;

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var ImprintPage = _react2['default'].createClass({
	    displayName: 'ImprintPage',
	    mixins: [],
	    propTypes: {},
	    componentWillMount: function componentWillMount() {
	        _utilsFlux2['default'].getStore('app').loadImprint();
	    },
	    render: function render() {
	        var appStore = _utilsFlux2['default'].getStore('app');
	        var modalStore = _utilsFlux2['default'].getStore('modals');
	        return _react2['default'].createElement(
	            'div',
	            { className: 'page terms' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'container--centered' },
	                _react2['default'].createElement(_altContainer2['default'], { stores: { appStore: appStore, modalStore: modalStore },
	                    render: function (props) {
	                        if (modalStore.getState().loading) {
	                            return _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null);
	                        }
	                        if (!props.appStore.imprint) {
	                            return false;
	                        }
	                        return _react2['default'].createElement('div', { dangerouslySetInnerHTML: _utilsDom2['default'].setInnerHtml(props.appStore.imprint) });
	                    } })
	            )
	        );
	    }
	});
	
	module.exports = ImprintPage;

/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _componentsFooterBarFooterBar = __webpack_require__(187);
	
	var _componentsFooterBarFooterBar2 = _interopRequireDefault(_componentsFooterBarFooterBar);
	
	var _licensingListing = __webpack_require__(499);
	
	var _licensingListing2 = _interopRequireDefault(_licensingListing);
	
	var _componentsHeaderBarHeaderLicensing = __webpack_require__(458);
	
	var _componentsHeaderBarHeaderLicensing2 = _interopRequireDefault(_componentsHeaderBarHeaderLicensing);
	
	var _componentsBasketBasketSidebar = __webpack_require__(186);
	
	var _componentsBasketBasketSidebar2 = _interopRequireDefault(_componentsBasketBasketSidebar);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var LicensingPage = _react2['default'].createClass({
	    displayName: 'LicensingPage',
	    mixins: [],
	    propTypes: {},
	    statics: {
	        willTransitionTo: function willTransitionTo(transition, param, query, callback) {
	            return regeneratorRuntime.async(function willTransitionTo$(context$1$0) {
	                while (1) switch (context$1$0.prev = context$1$0.next) {
	                    case 0:
	                        if (_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	                            context$1$0.next = 2;
	                            break;
	                        }
	
	                        return context$1$0.abrupt('return', transition.redirect('/login', {}, { nextPath: transition.path }));
	
	                    case 2:
	                        if (_utilsFlux2['default'].getStore('app').hasAcceptedLatestTerms()) {
	                            context$1$0.next = 4;
	                            break;
	                        }
	
	                        return context$1$0.abrupt('return', transition.redirect('/accept_terms', {}, { nextPath: transition.path }));
	
	                    case 4:
	                        _utilsFlux2['default'].getActions('modals').activateLoading();
	                        return context$1$0.abrupt('return', LicensingPage.getBasketData(param).then(function () {
	                            _utilsFlux2['default'].getActions('modals').disableLoading();
	                            callback();
	                        })['catch'](function (e) {
	                            console.log(e);
	                        }));
	
	                    case 6:
	                    case 'end':
	                        return context$1$0.stop();
	                }
	            }, null, this);
	        },
	
	        getBasketData: function getBasketData(param) {
	            var basketStore;
	            return regeneratorRuntime.async(function getBasketData$(context$1$0) {
	                while (1) switch (context$1$0.prev = context$1$0.next) {
	                    case 0:
	                        basketStore = _utilsFlux2['default'].getStore('basket');
	                        context$1$0.next = 3;
	                        return regeneratorRuntime.awrap(basketStore.loadBaskets());
	
	                    case 3:
	                        context$1$0.next = 5;
	                        return regeneratorRuntime.awrap(basketStore.loadBasket(param.id));
	
	                    case 5:
	                    case 'end':
	                        return context$1$0.stop();
	                }
	            }, null, this);
	        }
	    },
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    render: function render() {
	        var _this = this;
	
	        var basketStore = _utilsFlux2['default'].getStore('basket');
	        var modalStore = _utilsFlux2['default'].getStore('modals');
	
	        return _react2['default'].createElement(_altContainer2['default'], { stores: { basketStore: basketStore },
	            render: function (props) {
	                var activeBasket = props.basketStore.basket;
	                var basketId = _this.props.params.id;
	
	                var _modalStore$getState = modalStore.getState();
	
	                var loading = _modalStore$getState.loading;
	
	                if (basketStore.isLoading() || loading) {
	                    return _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null);
	                }
	
	                if (!basketId && activeBasket.size > 0) {
	                    _this.context.router.transitionTo('singleLicensing', { id: activeBasket.get('id') });
	                }
	
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'page licensing' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'headerbar' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container--centered' },
	                            _react2['default'].createElement(_componentsHeaderBarHeaderLicensing2['default'], { basket: activeBasket })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'licensing__container container--centered' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__filters' },
	                            _react2['default'].createElement(_componentsBasketBasketSidebar2['default'], { name: 'singleLicensing', baskets: props.basketStore.baskets, basket: activeBasket })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__content' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'content__listing' },
	                                _react2['default'].createElement(
	                                    'h4',
	                                    null,
	                                    _utilsFlux2['default'].t('nav_request_licence')
	                                ),
	                                _react2['default'].createElement(_licensingListing2['default'], { basket: activeBasket, query: _this.props.query })
	                            )
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        _componentsFooterBarFooterBar2['default'],
	                        null,
	                        _react2['default'].createElement(_componentsHeaderBarHeaderLicensing2['default'], { basket: activeBasket })
	                    )
	                );
	            } });
	    }
	});
	
	module.exports = LicensingPage;

/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _licensingListingItem = __webpack_require__(500);
	
	var _licensingListingItem2 = _interopRequireDefault(_licensingListingItem);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var LicensingListing = _react2['default'].createClass({
	    displayName: 'LicensingListing',
	    mixins: [],
	    propTypes: {},
	    render: function render() {
	
	        // SHow success page??
	        if (this.props.query.success && this.props.query.success === 'true') {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'licensing__success' },
	                _react2['default'].createElement(
	                    'h2',
	                    null,
	                    _utilsFlux2['default'].t('licensing_success')
	                ),
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    _utilsFlux2['default'].t('licensing_success_subtext')
	                )
	            );
	        }
	
	        if (this.props.basket.size === 0 || this.props.basket.get('items').size === 0) {
	            return _react2['default'].createElement(
	                'div',
	                { className: 'licensing__empty' },
	                _react2['default'].createElement(
	                    'p',
	                    null,
	                    _utilsFlux2['default'].t('no_basket_selected')
	                )
	            );
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'licensing__listing' },
	            this.props.basket.get('items').map(function (item) {
	                return _react2['default'].createElement(_licensingListingItem2['default'], { key: 'llitem-' + item.get('id'), item: item });
	            })
	        );
	    }
	});
	
	module.exports = LicensingListing;

/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _componentsThumb = __webpack_require__(104);
	
	var _componentsThumb2 = _interopRequireDefault(_componentsThumb);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _prettyBytes = __webpack_require__(166);
	
	var _prettyBytes2 = _interopRequireDefault(_prettyBytes);
	
	var LicensingListingItem = _react2['default'].createClass({
	
	    displayName: 'LicensingListingItem',
	
	    propTypes: {
	        item: _react2['default'].PropTypes.object
	    },
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	        return _immutable2['default'].is(nextProps.item, this.props.item) === false;
	    },
	    toggleCheck: function toggleCheck() {
	        _utilsFlux2['default'].getActions('basket').toggleLicensing(this.props.item.get('id'));
	    },
	
	    updateUsageText: function updateUsageText(e) {
	        _utilsFlux2['default'].getActions('basket').updateLicensingUsageText({
	            itemId: this.props.item.get('id'),
	            text: e.target.value
	        });
	    },
	
	    render: function render() {
	        var item = this.props.item.toJS();
	        var master = item.files && item.files.find(function (item) {
	            return 'master' === item.key;
	        });
	        var MICode = item.meta && item.meta.length && item.meta.find(function (meta) {
	            return 'MICode' === meta.key;
	        });
	        var dimensions = master && master.meta && master.meta.find && master.meta.find(function (meta) {
	            return 'Dimensions' == meta.name;
	        });
	        var resolution = master && master.meta && master.meta.find && master.meta.find(function (meta) {
	            return 'Resolution' == meta.name;
	        });
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'listing__item' },
	            _react2['default'].createElement(_componentsThumb2['default'], { className: 'item__preview', media: this.props.item }),
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__info' },
	                _react2['default'].createElement(
	                    'form',
	                    { className: 'info__actions' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'field__checkbox' },
	                        _react2['default'].createElement('input', { readOnly: true, type: 'checkbox', checked: item._requestLicense, id: 'lic_item_' + item.id }),
	                        _react2['default'].createElement('label', { onClick: this.toggleCheck, htmlFor: 'lic_item_' + item.id })
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'info__description' },
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'description__title' },
	                        item.name
	                    ),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'description__duration' },
	                        item.duration
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'description__meta' },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'meta__id' },
	                            MICode && MICode.value
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'meta__file' },
	                            master && master.mimeType,
	                            master && ' / ' + (0, _prettyBytes2['default'])(master.size),
	                            dimensions && ' / ' + dimensions.value,
	                            resolution && ' / ' + resolution.value
	                        )
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                'form',
	                { className: 'item__comment' },
	                _react2['default'].createElement('textarea', { onChange: this.updateUsageText, value: item._usageText, placeholder: _utilsFlux2['default'].t('licenseText_placeholder') })
	            )
	        );
	    }
	});
	
	module.exports = LicensingListingItem;

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _requestsListing = __webpack_require__(502);
	
	var _requestsListing2 = _interopRequireDefault(_requestsListing);
	
	var _componentsBasketBasketSidebar = __webpack_require__(186);
	
	var _componentsBasketBasketSidebar2 = _interopRequireDefault(_componentsBasketBasketSidebar);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var LicensingPage = _react2['default'].createClass({
	    displayName: 'LicensingPage',
	    mixins: [],
	    propTypes: {},
	    statics: {
	        willTransitionTo: function willTransitionTo(transition) {
	            if (!_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	                return transition.redirect('/login', {}, { nextPath: transition.path });
	            }
	            if (!_utilsFlux2['default'].getStore('app').hasAcceptedLatestTerms()) {
	                return transition.redirect('/accept_terms', {}, { nextPath: transition.path });
	            }
	
	            return _utilsFlux2['default'].getStore('requests').loadRequests();
	        }
	    },
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    render: function render() {
	
	        return _react2['default'].createElement(_altContainer2['default'], {
	            stores: {
	                requestStore: _utilsFlux2['default'].getStore('requests'),
	                basketStore: _utilsFlux2['default'].getStore('basket')
	            },
	            render: function (props) {
	
	                if (_utilsFlux2['default'].getStore('requests').isLoading()) {
	                    return _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null);
	                }
	
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'page requests' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'headerbar' },
	                        _react2['default'].createElement('div', { className: 'container--centered' })
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'requests__container container--centered' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__filters' },
	                            _react2['default'].createElement(_componentsBasketBasketSidebar2['default'], { name: 'singleLicensing', baskets: props.basketStore.baskets, basket: props.basketStore.basket })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__content' },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'content__listing' },
	                                _react2['default'].createElement(
	                                    'h4',
	                                    null,
	                                    _utilsFlux2['default'].t('view_request_licensing')
	                                ),
	                                _react2['default'].createElement(_requestsListing2['default'], { requests: props.requestStore.requests })
	                            )
	                        )
	                    )
	                );
	            } });
	    }
	});
	
	module.exports = LicensingPage;

/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _requestsListingItem = __webpack_require__(503);
	
	var _requestsListingItem2 = _interopRequireDefault(_requestsListingItem);
	
	var RequestListing = _react2['default'].createClass({
	    displayName: 'RequestListing',
	    mixins: [],
	    propTypes: {},
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'request__listing' },
	            this.props.requests.map(function (item, ix) {
	                return _react2['default'].createElement(_requestsListingItem2['default'], { key: ix, item: item });
	            })
	        );
	    }
	});
	
	module.exports = RequestListing;

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _componentsThumb = __webpack_require__(104);
	
	var _componentsThumb2 = _interopRequireDefault(_componentsThumb);
	
	var LicensingListingItem = _react2['default'].createClass({
	
	    displayName: 'LicensingListingItem',
	
	    propTypes: {
	        item: _react2['default'].PropTypes.object
	    },
	
	    render: function render() {
	        var request = this.props.item.toJS();
	        var media = request.media;
	
	        var MICode = media.meta && media.meta.find(function (meta) {
	            return 'MICode' === meta.key;
	        });
	        var master = media.files && media.files.find(function (file) {
	            return 'master' === file.key;
	        });
	        var duration = master && master.meta && master.meta.find && master.meta.find(function (meta) {
	            return 'Duration' === meta.name;
	        });
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'listing__item' },
	            _react2['default'].createElement(_componentsThumb2['default'], { className: 'item__preview', media: this.props.item.get('media') }),
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__info' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'info__description' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'description__title' },
	                        media.title,
	                        duration && ' ' + duration.value,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'info__meta' },
	                            MICode && _react2['default'].createElement(
	                                'span',
	                                { className: 'meta__id' },
	                                MICode.value
	                            ),
	                            master && false /*<span className="meta__file">{item.master.mime} / {item.master.fileSize} / {item.master.size}px / {item.master.dpi} dpi</span>*/
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'description__status' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'status__meta' },
	                            _react2['default'].createElement(
	                                'span',
	                                { className: 'meta__prefix' },
	                                _utilsFlux2['default'].t('license_status'),
	                                ':'
	                            ),
	                            ' ',
	                            _react2['default'].createElement(
	                                'span',
	                                { style: { color: request.color } },
	                                request.status
	                            )
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'status__date' },
	                            _react2['default'].createElement(
	                                'span',
	                                { className: 'date__prefix' },
	                                _utilsFlux2['default'].t('license_submitted_on')
	                            ),
	                            ' ',
	                            request.date
	                        )
	                    )
	                ),
	                _react2['default'].createElement('hr', { className: 'grey' })
	            ),
	            _react2['default'].createElement(
	                'p',
	                { className: 'item__comment' },
	                request.comment
	            )
	        );
	    }
	});
	
	module.exports = LicensingListingItem;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortal = __webpack_require__(129);
	
	var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _loginSlideshow = __webpack_require__(194);
	
	var _loginSlideshow2 = _interopRequireDefault(_loginSlideshow);
	
	var _loginBackgroundVideo = __webpack_require__(193);
	
	var _loginBackgroundVideo2 = _interopRequireDefault(_loginBackgroundVideo);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _componentsFooterFooter = __webpack_require__(449);
	
	var _componentsFooterFooter2 = _interopRequireDefault(_componentsFooterFooter);
	
	var _reactRouter = __webpack_require__(7);
	
	var LoginPage = _react2['default'].createClass({
	    displayName: 'LoginPage',
	    mixins: [_reactRouter.Navigation],
	    propTypes: {},
	    statics: {
	        willTransitionTo: function willTransitionTo(transition) {
	            if (_utilsFlux2['default'].getStore('app').isAuthenticated() || _utilsFlux2['default'].getStore('app').isSamlLogin()) {
	                transition.redirect('/');
	            } else if (_utilsFlux2['default'].getStore('app').isNoneLogin()) {
	                transition.redirect('/', {}, { nextPath: transition.path });
	            }
	        }
	    },
	
	    showLogin: function showLogin(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openModal('Login');
	    },
	
	    getTitle: function getTitle(html) {
	        return { __html: html };
	    },
	
	    showRegister: function showRegister(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openModal('Register');
	    },
	
	    componentDidMount: function componentDidMount() {
	        if (this.props.query.showDialog || this.props.query.nextPath && this.props.query.nextPath.length > 1) {
	            setTimeout(function () {
	                _utilsFlux2['default'].getActions('modals').openModal('Login');
	            }, 10);
	        }
	    },
	
	    renderFullbleed: function renderFullbleed() {
	        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	        var backGroundLayer;
	
	        if (!isMobile) {
	            if (window.config.backgroundMovie.length > 1 && window.config.backgroundMovie.indexOf("-") > 1) {
	                backGroundLayer = _react2['default'].createElement(_loginBackgroundVideo2['default'], {
	                    poster: window.config.slideshowImages[0],
	                    video: window.config.backgroundMovie
	                });
	            } else {
	                backGroundLayer = _react2['default'].createElement(_loginSlideshow2['default'], {
	                    show: window.config.slideshowImages,
	                    speed: 4000
	                });
	            }
	        } else {
	            backGroundLayer = _react2['default'].createElement(_loginSlideshow2['default'], {
	                show: window.config.slideshowImages,
	                speed: 4000
	            });
	        }
	
	        return backGroundLayer;
	    },
	
	    _renderLoginText: function _renderLoginText(modalIsOpen) {
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var licensing = _flux$getStore$getState$config$toJS.licensing;
	
	        var _flux$getStore$getState = _utilsFlux2['default'].getStore('app').getState();
	
	        var config = _flux$getStore$getState.config;
	
	        var _config$toJS = config.toJS();
	
	        var copyrightURL = _config$toJS.copyrightURL;
	
	        var _config$toJS2 = config.toJS();
	
	        var hideRegistration = _config$toJS2.hideRegistration;
	
	        if (!modalIsOpen) {
	            return _react2['default'].createElement(
	                'div',
	                null,
	                _react2['default'].createElement('h1', { dangerouslySetInnerHTML: this.getTitle(_utilsFlux2['default'].t('login_video_pretitle')) }),
	                _react2['default'].createElement('h2', { dangerouslySetInnerHTML: this.getTitle(_utilsFlux2['default'].t('login_video_title')) }),
	                !hideRegistration ? _react2['default'].createElement(
	                    'a',
	                    { href: '#', className: 'btn btn-primary btn-arrow', onClick: this.showRegister },
	                    _utilsFlux2['default'].t('sign_up'),
	                    _react2['default'].createElement('i', { className: 'chevron-right' })
	                ) : '',
	                !licensing ? _react2['default'].createElement(
	                    'a',
	                    { href: '#', className: 'btn btn-secondary btn-arrow', onClick: this.showLogin },
	                    _utilsFlux2['default'].t('login'),
	                    _react2['default'].createElement('i', { className: 'chevron-right' })
	                ) : '',
	                _react2['default'].createElement(
	                    _componentsFooterFooter2['default'],
	                    { isHidden: _utilsFlux2['default'].getStore('app').isAuthenticated() || !copyrightURL },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'copyright' },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: copyrightURL },
	                            _utilsFlux2['default'].t('copyright-url-text')
	                        ),
	                        ' | ',
	                        _react2['default'].createElement(
	                            'span',
	                            null,
	                            _utilsFlux2['default'].t('copyright')
	                        )
	                    )
	                )
	            );
	        }
	    },
	
	    render: function render() {
	        var _this = this;
	
	        if (!!window.config.noneLogin && !_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	            return _react2['default'].createElement('div', null);
	        }
	
	        return _react2['default'].createElement(_altContainer2['default'], {
	            stores: { modalStore: this.props.flux.getStore('modals') },
	            render: function (props) {
	                return _react2['default'].createElement(
	                    'div',
	                    { className: 'welcome container--centered' },
	                    _this._renderLoginText(props.modalStore.openModal),
	                    _react2['default'].createElement(
	                        _reactPortal2['default'],
	                        { isOpened: true },
	                        _this.renderFullbleed()
	                    )
	                );
	            } });
	    }
	});
	
	module.exports = LoginPage;

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRouter = __webpack_require__(7);
	
	var _utilsStrings = __webpack_require__(122);
	
	var _fallbackConfig = __webpack_require__(121);
	
	var _fallbackConfig2 = _interopRequireDefault(_fallbackConfig);
	
	var _utilsStrings2 = __webpack_require__(122);
	
	var AltFilterCategory = _react2['default'].createClass({
	
	    displayName: 'altFilterCategory',
	
	    mixins: [_reactRouter.Navigation],
	
	    propTypes: {
	        filter: _react2['default'].PropTypes.object,
	        query: _react2['default'].PropTypes.object,
	        ix: _react2['default'].PropTypes.number
	    },
	
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        var listOfFilters = this.createListOfFilters();
	        var query = this.createQuery(listOfFilters);
	        var toggledFilters = {};
	
	        this.props.filter.get('children').toJS().forEach(function (category) {
	            category.children.forEach(function (child) {
	                if (child.active) {
	                    toggledFilters[category.value] = true;
	                }
	                child.children.forEach(function (child2) {
	                    if (child2.active) {
	                        toggledFilters[child.value] = true;
	                    }
	                });
	            });
	        });
	
	        return {
	            searchValue: '',
	            listOfFilters: listOfFilters,
	            clear: Object.keys(listOfFilters).length === 0 && listOfFilters.constructor === Object,
	            clearing: false,
	            query: query,
	            toggled: toggledFilters,
	            showFilterButton: false
	        };
	    },
	    createQuery: function createQuery(listOfFilters) {
	        var query = "";
	        for (var category in listOfFilters) {
	            query = query + category + '=';
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = listOfFilters[category][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var tag = _step.value;
	
	                    query = query + (0, _utilsStrings2.encodeUrl)(tag) + '|';
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator['return']) {
	                        _iterator['return']();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            query = query.slice(0, -1) + "&";
	        }
	        query = query.slice(0, -1);
	
	        return query;
	    },
	    createListOfFilters: function createListOfFilters() {
	        var activeFilters = this.props.selectedFilters.toJS();
	        var listOfFilters = {};
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	            for (var _iterator2 = activeFilters[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var filter = _step2.value;
	
	                var paramKey = Object.keys(filter.params)[0];
	                var paramValue = filter.params[paramKey];
	                var array = [paramValue];
	
	                if (listOfFilters.hasOwnProperty(paramKey)) {
	                    array = listOfFilters[paramKey];
	                    array.push(paramValue);
	                    listOfFilters[paramKey] = array;
	                } else {
	                    listOfFilters[paramKey] = array;
	                }
	            }
	        } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion2 && _iterator2['return']) {
	                    _iterator2['return']();
	                }
	            } finally {
	                if (_didIteratorError2) {
	                    throw _iteratorError2;
	                }
	            }
	        }
	
	        return listOfFilters;
	    },
	    createSelectedCategoryFilter: function createSelectedCategoryFilter(lof) {
	        var result = {};
	        var allChildren = this.props.filter.toJS().children;
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	            for (var _iterator3 = allChildren[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var child = _step3.value;
	
	                var paramName = child.params.split("=")[0];
	                if (lof.hasOwnProperty(paramName) && lof[paramName]) {
	                    result[paramName] = lof[paramName];
	                }
	            }
	        } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion3 && _iterator3['return']) {
	                    _iterator3['return']();
	                }
	            } finally {
	                if (_didIteratorError3) {
	                    throw _iteratorError3;
	                }
	            }
	        }
	
	        return result;
	    },
	    componentDidUpdate: function componentDidUpdate(prevProps) {
	        if (prevProps.selectedFilters !== this.props.selectedFilters) {
	            var listOfFilters = this.createListOfFilters();
	            this.setState({
	                listOfFilters: listOfFilters,
	                query: this.createQuery(listOfFilters),
	                showFilterButton: false
	            });
	        }
	
	        var clearFlag = Object.keys(this.props.query).length > 0 && this.props.query.constructor === Object && this.props.query.hasOwnProperty('clearFlag') ? true : false;
	        if (clearFlag && !this.state.clearing) {
	            this.setState({
	                listOfFilters: {},
	                clearing: true,
	                clear: true,
	                searchValue: ''
	            });
	            this.context.router.transitionTo('landing-page', null, null);
	        } else if (!clearFlag && this.state.clearing) {
	            this.setState({
	                clearing: false
	            });
	        }
	    },
	
	    filterSearchChange: function filterSearchChange(e) {
	        var _this = this;
	
	        var toggled = {};
	
	        if (e.target.value && this.props.filter.get('active')) {
	            this.props.filter.get('children').toJS().forEach(function (category) {
	                category.children && category.children.forEach(function (subCategory) {
	                    if (subCategory && _this.isCategoryMatchingSearch(subCategory.name.toLowerCase(), e.target.value.toLowerCase())) {
	                        toggled[category.value] = true;
	                    }
	                    subCategory.children && subCategory.children.forEach(function (subSubCategory) {
	                        if (subSubCategory && _this.isCategoryMatchingSearch(subSubCategory.name.toLowerCase(), e.target.value.toLowerCase())) {
	                            toggled[category.value] = true;
	                            toggled[subCategory.value] = true;
	                        }
	                    });
	                });
	            });
	        }
	
	        this.setState({
	            searchValue: e.target.value,
	            toggled: toggled
	        });
	    },
	
	    toggleCategory: function toggleCategory(event, child) {
	        var forceOpen = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	        if (event) {
	            event.preventDefault();
	            event.stopPropagation();
	        }
	
	        this.state.toggled[child.value] = forceOpen || !!!this.state.toggled[child.value];
	        this.setState({ toggled: this.state.toggled });
	    },
	
	    getPerPageParam: function getPerPageParam() {
	        // get it from store, if it is used in this session
	        if (_store2['default'].get('pagination_amount')) {
	            return _store2['default'].get('pagination_amount');
	        }
	        // get it from config
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var defaultPerPageResults = _flux$getStore$getState$config$toJS.defaultPerPageResults;
	
	        if (Number.isInteger(defaultPerPageResults)) {
	            return defaultPerPageResults;
	        }
	        return _fallbackConfig2['default'].defaultPerPageResults;
	    },
	    clearCategoryFilters: function clearCategoryFilters() {
	        var _this2 = this;
	
	        var categoryChildren = this.props.filter.get('children').toJS();
	        if (categoryChildren && categoryChildren.length > 0) {
	            (function () {
	                var queryObj = _utilsFlux2['default'].getStore('media').state.query.toObject();
	                categoryChildren.map(function (child) {
	                    var params = child.params.split('&');
	                    params.map(function (param) {
	                        var categoryName = param.substring(0, param.indexOf('='));
	                        queryObj[categoryName] = null;
	                    });
	                });
	                _this2.setState({ listOfFilters: {}, clear: true, showFilterButton: false });
	                _utilsFlux2['default'].getActions('media').updateFilterParams(queryObj);
	                _this2.getResults();
	            })();
	        }
	    },
	    getResults: function getResults() {
	        var e = arguments.length <= 0 || arguments[0] === undefined ? null : arguments[0];
	
	        e && e.preventDefault();
	
	        var query = "";
	        var queryObj = _utilsFlux2['default'].getStore('media').state.query.toObject();
	        if (!queryObj.hasOwnProperty('per_page')) {
	            queryObj['per_page'] = this.getPerPageParam();
	        }
	
	        if (Object.keys(queryObj).length === 1) {
	            delete queryObj['per_page'];
	        }
	
	        Object.keys(queryObj).forEach(function (key) {
	            var queryObjElement = queryObj[key];
	            query = '' + query + key + '=' + (0, _utilsStrings2.encodeUrl)('' + queryObjElement) + '&';
	        });
	
	        query = query.slice(0, -1);
	
	        this.setState({
	            clear: Object.keys(this.state.listOfFilters).length === 0 && this.state.listOfFilters.constructor === Object
	        });
	        window.location.href = '/#/media' + (query != "" ? "?" : "") + query;
	    },
	
	    renderFilterMenu: function renderFilterMenu() {
	        var _this3 = this;
	
	        if (this.props.filter.get('active')) {
	            var searchedFilters = this.props.filter.get('children').toJS().filter(function (category) {
	                var searchedChildren = [];
	                if (category.children.length) {
	                    searchedChildren = category.children.filter(function (subCategory) {
	                        var searchedChildren = [];
	                        if (subCategory.children.length) {
	                            searchedChildren = subCategory.children.filter(function (subSubCategory) {
	                                return _this3.state.searchValue ? _this3.isCategoryMatchingSearch(subSubCategory.name.toLowerCase(), _this3.state.searchValue.toLowerCase()) : true;
	                            });
	                        }
	
	                        subCategory["children"] = searchedChildren;
	                        return _this3.state.searchValue ? _this3.isCategoryMatchingSearch(subCategory.name.toLowerCase(), _this3.state.searchValue.toLowerCase()) || searchedChildren.length : true;
	                    });
	                }
	
	                category["children"] = searchedChildren;
	                return _this3.state.searchValue ? _this3.isCategoryMatchingSearch(category.name.toLowerCase(), _this3.state.searchValue.toLowerCase()) || searchedChildren.length : true;
	            });
	
	            return this.renderFilterList(searchedFilters, true);
	        }
	    },
	
	    isCategoryMatchingSearch: function isCategoryMatchingSearch(name, searchValue) {
	        var includes = true;
	        searchValue.split(' ').forEach(function (string) {
	            if (name !== "" && !name.includes(string)) {
	                includes = false;
	            }
	        });
	        return includes;
	    },
	
	    renderFilterList: function renderFilterList(children) {
	        var _this4 = this;
	
	        var firstLevel = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	        var cssOptions = {};
	        var height = 66;
	        var filterHeight = this.props.filerHeight;
	        var arraySize = children.length;
	
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	            for (var _iterator4 = children[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var child = _step4.value;
	
	                arraySize = arraySize + child.children.length;
	                if (!!filterHeight) {
	                    height = height + 34;
	                    filterHeight = filterHeight - 1;
	
	                    if (child.children.length) {
	                        var _iteratorNormalCompletion5 = true;
	                        var _didIteratorError5 = false;
	                        var _iteratorError5 = undefined;
	
	                        try {
	                            for (var _iterator5 = child.children[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                                var grandchild = _step5.value;
	
	                                if (!filterHeight) break;
	                                height = height + 28;
	                                filterHeight = filterHeight - 1;
	                            }
	                        } catch (err) {
	                            _didIteratorError5 = true;
	                            _iteratorError5 = err;
	                        } finally {
	                            try {
	                                if (!_iteratorNormalCompletion5 && _iterator5['return']) {
	                                    _iterator5['return']();
	                                }
	                            } finally {
	                                if (_didIteratorError5) {
	                                    throw _iteratorError5;
	                                }
	                            }
	                        }
	                    }
	                }
	            }
	        } catch (err) {
	            _didIteratorError4 = true;
	            _iteratorError4 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion4 && _iterator4['return']) {
	                    _iterator4['return']();
	                }
	            } finally {
	                if (_didIteratorError4) {
	                    throw _iteratorError4;
	                }
	            }
	        }
	
	        filterHeight === 0 && firstLevel ? cssOptions = { maxHeight: height + 'px', overflowY: "scroll" } : null;
	        return _react2['default'].createElement(
	            'div',
	            null,
	            firstLevel ? _react2['default'].createElement(
	                'div',
	                { className: 'search-field' },
	                arraySize > this.props.filerHeight || this.state.searchValue.length ? _react2['default'].createElement('input', { type: 'text', onChange: this.filterSearchChange, value: this.state.searchValue,
	                    placeholder: _utilsFlux2['default'].t('filter_search') }) : ''
	            ) : '',
	            _react2['default'].createElement(
	                'ul',
	                { className: 'category__list ' + (firstLevel ? 'first-level' : ''), style: cssOptions },
	                children.map(function (child) {
	                    return _this4.checkFilterElement(child);
	                })
	            ),
	            firstLevel && (this.state.showFilterButton || !this.state.clear) && this.state.showFilterButton ? _react2['default'].createElement(
	                'button',
	                { className: 'category query-button btn btn-border apply', value: this.state.query, onClick: this.getResults },
	                _utilsFlux2['default'].t('filter_button')
	            ) : '',
	            firstLevel && this.showClearFilter() && !!this.props.filter.get('show_filter_button') ? _react2['default'].createElement(
	                'button',
	                { className: 'category query-button btn btn-border clear-filter', value: this.state.query,
	                    onClick: this.clearCategoryFilters },
	                _utilsFlux2['default'].t('clear_category_button')
	            ) : ''
	        );
	    },
	    showClearFilter: function showClearFilter() {
	        var selectedFiltersCategory = this.createListOfFilters(this.props.selectedFilters.toJS());
	        var ownPropertyNames = Object.getOwnPropertyNames(selectedFiltersCategory);
	        if (ownPropertyNames && ownPropertyNames.length > 0) {
	            var allChildren = this.props.filter.toJS().children;
	            var _iteratorNormalCompletion6 = true;
	            var _didIteratorError6 = false;
	            var _iteratorError6 = undefined;
	
	            try {
	                for (var _iterator6 = allChildren[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                    var child = _step6.value;
	
	                    var paramName = child.params.split("=")[0];
	                    if (selectedFiltersCategory.hasOwnProperty(paramName) && selectedFiltersCategory[paramName].length > 0) {
	                        return true;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError6 = true;
	                _iteratorError6 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion6 && _iterator6['return']) {
	                        _iterator6['return']();
	                    }
	                } finally {
	                    if (_didIteratorError6) {
	                        throw _iteratorError6;
	                    }
	                }
	            }
	        }
	
	        return false;
	    },
	    hasCategoryFilters: function hasCategoryFilters() {
	        return Object.getOwnPropertyNames(this.state.listOfFilters).length != 0;
	    },
	    checkFilterElement: function checkFilterElement(child) {
	        if (child.hidden) {
	            return null;
	        }
	
	        return this.renderFilterElement(child);
	    },
	
	    toggleFilters: function toggleFilters(child) {
	        var params = child.params.split('&');
	        var listOfFilters = this.state.listOfFilters;
	        var removedFilters = [];
	
	        var _iteratorNormalCompletion7 = true;
	        var _didIteratorError7 = false;
	        var _iteratorError7 = undefined;
	
	        try {
	            for (var _iterator7 = params[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	                var param = _step7.value;
	
	                var paramKey = param.split('=')[0];
	                var paramValue = (0, _utilsStrings2.decodeUrl)(param.split('=')[1]);
	                var array = [paramValue];
	
	                if (listOfFilters.hasOwnProperty(paramKey)) {
	                    array = listOfFilters[paramKey] ? listOfFilters[paramKey].map(function (v) {
	                        return v;
	                    }) : [];
	                    var index = array.indexOf(paramValue);
	                    if (index > -1) {
	                        array.splice(index, 1);
	                        if (!array.length) {
	                            delete listOfFilters[paramKey];
	                            removedFilters.push(paramKey);
	                        } else listOfFilters[paramKey] = array;
	                    } else {
	                        array.push(paramValue);
	                        listOfFilters[paramKey] = array;
	                    }
	                } else {
	                    listOfFilters[paramKey] = array;
	                }
	            }
	        } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	        } finally {
	            try {
	                if (!_iteratorNormalCompletion7 && _iterator7['return']) {
	                    _iterator7['return']();
	                }
	            } finally {
	                if (_didIteratorError7) {
	                    throw _iteratorError7;
	                }
	            }
	        }
	
	        var filterParams = {};
	        for (var category in listOfFilters) {
	            var orFilter = '';
	            var _iteratorNormalCompletion8 = true;
	            var _didIteratorError8 = false;
	            var _iteratorError8 = undefined;
	
	            try {
	                for (var _iterator8 = listOfFilters[category][Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	                    var value = _step8.value;
	
	                    orFilter = orFilter + value + '|';
	                }
	            } catch (err) {
	                _didIteratorError8 = true;
	                _iteratorError8 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion8 && _iterator8['return']) {
	                        _iterator8['return']();
	                    }
	                } finally {
	                    if (_didIteratorError8) {
	                        throw _iteratorError8;
	                    }
	                }
	            }
	
	            orFilter = orFilter.slice(0, -1);
	            filterParams[category] = orFilter;
	        }
	
	        removedFilters.forEach(function (category) {
	            filterParams[category] = null;
	        });
	        _utilsFlux2['default'].getActions('media').updateFilterParams(filterParams);
	
	        // window.location.href = `/#/media${query != "" ? '?' : ''}${query}`;
	
	        this.setState({
	            listOfFilters: listOfFilters,
	            showFilterButton: !!this.props.filter.get('show_filter_button') ? this.showFilterButton(listOfFilters) : false
	        });
	
	        if (!!!this.props.filter.get('show_filter_button')) {
	            this.getResults();
	        }
	    },
	    showFilterButton: function showFilterButton(listOfFilters) {
	        var selectedFiltersCategory = this.createListOfFilters(this.props.selectedFilters.toJS());
	        for (var category in listOfFilters) {
	            var selectedCategoryFilter = selectedFiltersCategory[category];
	            var listOfFilter = listOfFilters[category];
	            if (!selectedFiltersCategory || !selectedFiltersCategory.hasOwnProperty(category) || selectedCategoryFilter.length !== listOfFilter.length) {
	                return true;
	            }
	
	            var _iteratorNormalCompletion9 = true;
	            var _didIteratorError9 = false;
	            var _iteratorError9 = undefined;
	
	            try {
	                for (var _iterator9 = selectedCategoryFilter[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	                    var selectedValue = _step9.value;
	
	                    if (listOfFilter.indexOf((0, _utilsStrings2.encodeUrl)(selectedValue)) === -1) {
	                        return true;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError9 = true;
	                _iteratorError9 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion9 && _iterator9['return']) {
	                        _iterator9['return']();
	                    }
	                } finally {
	                    if (_didIteratorError9) {
	                        throw _iteratorError9;
	                    }
	                }
	            }
	        }
	        return false;
	    },
	    renderFilterElement: function renderFilterElement(child) {
	        var _this5 = this;
	
	        var isActive = child.selected;
	        // Fallback check for "apply filter" being weird
	        if (!isActive) {
	            var listOfFilters = this.state.listOfFilters;
	            var params = child.params.split('&');
	            var _iteratorNormalCompletion10 = true;
	            var _didIteratorError10 = false;
	            var _iteratorError10 = undefined;
	
	            try {
	                for (var _iterator10 = params[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	                    var param = _step10.value;
	
	                    var paramKey = param.split('=')[0];
	                    var array = listOfFilters[paramKey] || [];
	                    if (array.indexOf(child.value) !== -1) {
	                        isActive = true;
	                        break;
	                    }
	                }
	            } catch (err) {
	                _didIteratorError10 = true;
	                _iteratorError10 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion10 && _iterator10['return']) {
	                        _iterator10['return']();
	                    }
	                } finally {
	                    if (_didIteratorError10) {
	                        throw _iteratorError10;
	                    }
	                }
	            }
	        }
	
	        return _react2['default'].createElement(
	            'li',
	            { key: child.value },
	            _react2['default'].createElement(
	                'div',
	                { className: isActive ? 'active tag-link' : 'tag-link',
	                    id: child.value,
	                    onClick: function () {
	                        return _this5.toggleFilters(child);
	                    },
	                    dataParams: child.params },
	                child.children.length ? _react2['default'].createElement(
	                    'span',
	                    { className: 'toggle-button', href: '#', onClick: function (event) {
	                            return _this5.toggleCategory(event, child);
	                        } },
	                    _react2['default'].createElement('i', { className: !!this.state.toggled[child.value] ? 'chevron-down' : 'chevron-right' })
	                ) : _react2['default'].createElement(
	                    'span',
	                    { className: 'toggle-button' },
	                    ' '
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'child-label' },
	                    child.name,
	                    ' (',
	                    child.count,
	                    ')',
	                    isActive ? _react2['default'].createElement('span', { className: 'list__clear close' }) : ''
	                )
	            ),
	            (function () {
	                if (child.children.length && !!_this5.state.toggled[child.value]) {
	                    return _this5.renderFilterList(child.children);
	                }
	            })()
	        );
	    },
	    toggleFilter: function toggleFilter(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').toggleFilter(this.props.ix);
	    },
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            _react2['default'].createElement(
	                'div',
	                { className: 'filters__category' },
	                _react2['default'].createElement(
	                    'a',
	                    { href: '#', onClick: this.toggleFilter, className: 'category__header' },
	                    this.props.filter.get('name'),
	                    _react2['default'].createElement('i', { className: this.props.filter.get('active') ? 'collapse-small' : 'expand-small' })
	                ),
	                this.renderFilterMenu()
	            )
	        );
	    }
	});
	
	module.exports = AltFilterCategory;

/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _altFilterCategory = __webpack_require__(505);
	
	var _altFilterCategory2 = _interopRequireDefault(_altFilterCategory);
	
	var _lodashLangCloneDeep = __webpack_require__(68);
	
	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);
	
	var AltFilters = _react2['default'].createClass({
	    displayName: 'AltFilters',
	    mixins: [],
	    propTypes: {},
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            filtersExpanded: false
	        };
	    },
	
	    toogleExpand: function toogleExpand(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').toggleExpand();
	    },
	    clearFilters: function clearFilters(e) {
	        e.preventDefault();
	        var query = { clearFlag: "true" };
	        _utilsFlux2['default'].getActions('media').clearQuery();
	
	        this.context.router.transitionTo('landing-page', null, query);
	    },
	    toogleMoreFilters: function toogleMoreFilters() {
	        this.setState({ filtersExpanded: !this.state.filtersExpanded });
	    },
	    render: function render() {
	        var _this = this;
	
	        if (!this.props.filters || this.props.filters.size === 0) {
	            return false;
	        }
	        var query = (0, _lodashLangCloneDeep2['default'])(this.context.router.getCurrentQuery());
	        var router = this.context.router;
	
	        var route = router.getRouteAtDepth(1);
	        var isLanding = route && 'landing-page' === route.name;
	
	        var _flux$getStore$getState = _utilsFlux2['default'].getStore('app').getState();
	
	        var hideFilters = _flux$getStore$getState.hideFilters;
	
	        var limitNoOfFilters = this.props.limitNoOfFilters;
	        var numberOfFiltersToShow = this.props.numberOfFilters;
	        var numberOfValidFilters = 0;
	        return _react2['default'].createElement(
	            'div',
	            { className: 'media__filters' },
	            this.props.children,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('filter')
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'filters__buttons' },
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.clearFilters, disabled: isLanding || query.hasOwnProperty('clearFlag'), type: 'button', className: 'btn btn-border buttons__clear' },
	                    _react2['default'].createElement('i', { className: 'close' }),
	                    _utilsFlux2['default'].t('clear_filters')
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { type: 'button', onClick: this.toogleExpand, className: 'btn btn-border buttons__expand' },
	                    _react2['default'].createElement('i', { className: 'expand' }),
	                    _utilsFlux2['default'].t(this.props.isExpanded ? 'collapse_all' : 'expand_all')
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'filters__categories' },
	                this.props.filters.map(function (filter, ix) {
	                    var filterName = filter.get('name').toLowerCase();
	                    if (filter.get('hidden')) {
	                        return false;
	                    }
	                    if (typeof hideFilters != 'undefined') {
	                        if (hideFilters.indexOf(filterName) > -1) {
	                            return false;
	                        }
	                    }
	
	                    numberOfValidFilters = numberOfValidFilters + 1;
	
	                    if (numberOfFiltersToShow === 0 && !_this.state.filtersExpanded && limitNoOfFilters) return false;
	
	                    numberOfFiltersToShow = numberOfFiltersToShow - 1;
	
	                    return _react2['default'].createElement(_altFilterCategory2['default'], { selectedFilters: _this.props.selectedFilters, key: 'filter_' + ix, query: query, ix: ix, filter: filter, filerHeight: _this.props.filterHeight });
	                }),
	                numberOfValidFilters > this.props.numberOfFilters && limitNoOfFilters && _react2['default'].createElement(
	                    'div',
	                    { className: 'filters__buttons' },
	                    _react2['default'].createElement(
	                        'button',
	                        { type: 'button', onClick: this.toogleMoreFilters, className: 'btn btn-border buttons__expand-filters' },
	                        _utilsFlux2['default'].t(this.state.filtersExpanded ? 'less_filters' : 'more_filters')
	                    )
	                )
	            )
	        );
	    }
	});
	
	module.exports = AltFilters;

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRouter = __webpack_require__(7);
	
	var _lodashLangIsEmpty = __webpack_require__(232);
	
	var _lodashLangIsEmpty2 = _interopRequireDefault(_lodashLangIsEmpty);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _pagesMediaMediaFilters = __webpack_require__(510);
	
	var _pagesMediaMediaFilters2 = _interopRequireDefault(_pagesMediaMediaFilters);
	
	var _pagesMediaAltFilters = __webpack_require__(506);
	
	var _pagesMediaAltFilters2 = _interopRequireDefault(_pagesMediaAltFilters);
	
	var _pagesMediaMediaSelectedFilters = __webpack_require__(516);
	
	var _pagesMediaMediaSelectedFilters2 = _interopRequireDefault(_pagesMediaMediaSelectedFilters);
	
	var _componentsLinksPartnerLinks = __webpack_require__(273);
	
	var _componentsLinksPartnerLinks2 = _interopRequireDefault(_componentsLinksPartnerLinks);
	
	var _componentsHeaderBarHeaderLayout = __webpack_require__(456);
	
	var _componentsHeaderBarHeaderLayout2 = _interopRequireDefault(_componentsHeaderBarHeaderLayout);
	
	var _componentsHeaderBarHeaderPagination = __webpack_require__(459);
	
	var _componentsHeaderBarHeaderPagination2 = _interopRequireDefault(_componentsHeaderBarHeaderPagination);
	
	var _componentsHeaderBarHeaderSelection = __webpack_require__(460);
	
	var _componentsHeaderBarHeaderSelection2 = _interopRequireDefault(_componentsHeaderBarHeaderSelection);
	
	var _componentsHeaderBarHeaderSearch = __webpack_require__(190);
	
	var _componentsHeaderBarHeaderSearch2 = _interopRequireDefault(_componentsHeaderBarHeaderSearch);
	
	var _componentsHeaderBarHeaderSorting = __webpack_require__(462);
	
	var _componentsHeaderBarHeaderSorting2 = _interopRequireDefault(_componentsHeaderBarHeaderSorting);
	
	var _componentsFooterBarFooterBar = __webpack_require__(187);
	
	var _componentsFooterBarFooterBar2 = _interopRequireDefault(_componentsFooterBarFooterBar);
	
	var MediaPage = _react2['default'].createClass({
	    displayName: 'MediaPage',
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    statics: {
	        willTransitionTo: function willTransitionTo(transition) {
	            if (!_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	                transition.redirect('/login', {}, { nextPath: transition.path });
	            }
	            if (!_utilsFlux2['default'].getStore('app').hasAcceptedLatestTerms()) {
	                transition.redirect('/accept_terms', {}, { nextPath: transition.path });
	            }
	        }
	    },
	    componentWillMount: function componentWillMount() {
	        this.checkProps(this.props);
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        this.checkProps(nextProps);
	        if (this.props.query != nextProps.query) {
	            window.scrollTo(0, 0);
	        }
	    },
	
	    checkProps: function checkProps(props) {
	        var query = props.query;
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var defaultPerPageResults = _flux$getStore$getState$config$toJS.defaultPerPageResults;
	        var router = this.context.router;
	
	        var route = router.getRouteAtDepth(1);
	        var isLanding = route && 'landing-page' === route.name;
	        if (!isLanding) {
	            var sortingKeyFromStore = sessionStorage.getItem('sortingKey');
	            if (!query.sorting && sortingKeyFromStore && this.checkIfSortingKeyIsValid(sortingKeyFromStore)) {
	                query.sorting = sortingKeyFromStore;
	                this.context.router.transitionTo('listing', null, query);
	            }
	        }
	        if (!props.query.per_page) {
	            props.query["per_page"] = _store2['default'].get('pagination_amount') || defaultPerPageResults;
	        }
	        _utilsFlux2['default'].getStore('media').loadMedia(props.query);
	    },
	
	    // check if sortingkey used is still valid from search_settings
	    checkIfSortingKeyIsValid: function checkIfSortingKeyIsValid(sortingKey) {
	        var validity = false;
	        config.searchSortSettings.map(function (index) {
	            if (index === sortingKey) {
	                validity = true;
	            }
	        });
	        return validity;
	    },
	
	    renderBackToHome: function renderBackToHome() {
	        var router = this.context.router;
	
	        var route = router.getRouteAtDepth(1);
	        var isLanding = route && 'landing-page' === route.name;
	        if (!isLanding) {
	            return _react2['default'].createElement(
	                _reactRouter.Link,
	                { to: 'landing-page', onClick: this.clearFilters, className: 'sidebar__back' },
	                _react2['default'].createElement('i', { className: this.state.searchFilter ? "chevron-left" : "home" }),
	                _utilsFlux2['default'].t('back_to_home')
	            );
	        }
	    },
	
	    clearFilters: function clearFilters(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').clearQuery();
	        this.context.router.transitionTo('landing-page');
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            searchFilter: true
	        };
	    },
	
	    toggleFiltersWidth: function toggleFiltersWidth(e) {
	        e.preventDefault();
	        this.setState({
	            searchFilter: !this.state.searchFilter
	        });
	    },
	
	    render: function render() {
	        var _this = this;
	
	        return _react2['default'].createElement(_altContainer2['default'], {
	            stores: { mediaStore: _utilsFlux2['default'].getStore('media'), basketStore: _utilsFlux2['default'].getStore('basket') },
	            render: function (props) {
	                var loading = _this.props.flux.stores.media.isLoading();
	
	                var _props$flux$stores$app$getState$config$toJS = _this.props.flux.stores.app.getState().config.toJS();
	
	                var layoutSwitch = _props$flux$stores$app$getState$config$toJS.layoutSwitch;
	                var page = _this.props.query.page;
	
	                var showPagination = !loading || loading && page;
	                var searchableFilterActive = window.config.searchableFilterActive;
	                var searchableFilterHeight = window.config.searchableFilterHeight;
	                var hideFilterOnLanding = window.config.hideFilterOnLanding || false;
	                var limitNoOfFilters = window.config.limitNoOfFilters > 0 ? true : false;
	                var numberOfFilters = window.config.limitNoOfFilters;
	                var router = _this.context.router;
	
	                var route = router.getRouteAtDepth(1);
	                var isLanding = route && 'landing-page' === route.name;
	                return _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])('page', 'media', isLanding ? 'landing' : null) },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'headerbar' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'headerbar--media' },
	                            _react2['default'].createElement(_componentsHeaderBarHeaderSearch2['default'], { query: props.mediaStore.params.search }),
	                            _react2['default'].createElement(_componentsHeaderBarHeaderSelection2['default'], { media: props.mediaStore.media }),
	                            showPagination && _react2['default'].createElement(_componentsHeaderBarHeaderPagination2['default'], { pagination: props.mediaStore.meta }),
	                            showPagination && !isLanding && _react2['default'].createElement(_componentsHeaderBarHeaderLayout2['default'], null),
	                            showPagination && !isLanding && _react2['default'].createElement(_componentsHeaderBarHeaderSorting2['default'], null)
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'media__container' },
	                        !(hideFilterOnLanding && isLanding) && _react2['default'].createElement(
	                            'div',
	                            {
	                                className: "container__filters" + (_this.state.searchFilter ? " search-filter-opened" : " search-filter-colapsed") },
	                            _react2['default'].createElement(_pagesMediaMediaSelectedFilters2['default'], { size: props.mediaStore.media.size,
	                                filters: props.mediaStore.selectedFilters,
	                                query: _this.props.query }),
	                            searchableFilterActive ? _react2['default'].createElement(_pagesMediaAltFilters2['default'], { selectedFilters: props.mediaStore.selectedFilters,
	                                filters: props.mediaStore.filters,
	                                isExpanded: props.mediaStore.isExpanded,
	                                filterHeight: searchableFilterHeight,
	                                limitNoOfFilters: limitNoOfFilters,
	                                numberOfFilters: numberOfFilters }) : _react2['default'].createElement(
	                                _pagesMediaMediaFilters2['default'],
	                                { filters: props.mediaStore.filters,
	                                    isExpanded: props.mediaStore.isExpanded },
	                                _react2['default'].createElement(
	                                    'button',
	                                    { onClick: _this.toggleFiltersWidth, className: 'hamburger-arrow' },
	                                    _react2['default'].createElement('span', { className: 'line' }),
	                                    _react2['default'].createElement('span', { className: 'line' }),
	                                    _react2['default'].createElement('span', { className: 'line' })
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'partner-links' },
	                                _react2['default'].createElement(_componentsLinksPartnerLinks2['default'], null)
	                            ),
	                            _this.renderBackToHome()
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__content' },
	                            _react2['default'].createElement(_reactRouter.RouteHandler, _extends({}, _this.props, { mediaStore: props.mediaStore, basketStore: props.basketStore }))
	                        )
	                    )
	                );
	            } });
	    }
	});
	
	module.exports = MediaPage;

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRouter = __webpack_require__(7);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _mediaSlideshow = __webpack_require__(517);
	
	var _mediaSlideshow2 = _interopRequireDefault(_mediaSlideshow);
	
	var _fallbackConfig = __webpack_require__(121);
	
	var _fallbackConfig2 = _interopRequireDefault(_fallbackConfig);
	
	var UrlRegex = new RegExp(/https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/gi);
	
	var MediaFeatured = _react2['default'].createClass({
	    displayName: 'mediaFeatured',
	    propTypes: {
	        media: _react2['default'].PropTypes.object
	    },
	    componentWillMount: function componentWillMount() {
	        _utilsFlux2['default'].getStore('media').loadLandingPage();
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var defaultPerPageResults = _flux$getStore$getState$config$toJS.defaultPerPageResults;
	
	        var defaultAmountResult = Number.isInteger(defaultPerPageResults) ? defaultPerPageResults : _fallbackConfig2['default'].defaultPerPageResults;
	        if (this.props.landingPage.size === 0) {
	            return false;
	        }
	
	        var getItemUrlType = function getItemUrlType(item) {
	            var type = undefined;
	            if (item.href !== undefined && item.href !== '' && item.href.match(UrlRegex)) {
	                type = 'url';
	            } else {
	                type = 'searchId';
	            }
	            return type;
	        };
	
	        var slides = this.props.landingPage.filter(function (slide) {
	            return slide.get('slide');
	        }).toJS().map(function (item) {
	            var type = getItemUrlType(item);
	            item.type = type;
	            return item;
	        });
	        var teasers = this.props.landingPage.filter(function (teaser) {
	            return !teaser.get('slide');
	        }).toJS().map(function (item) {
	            var type = getItemUrlType(item);
	            item.type = type;
	            return item;
	        });
	
	        var invertFloat = false;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'media__featured' },
	            slides.length ? _react2['default'].createElement(_mediaSlideshow2['default'], { slides: slides }) : '',
	            teasers.map(function (item, ix) {
	                var isPromo = item.promo;
	                if (isPromo) {
	                    invertFloat = !invertFloat;
	                }
	
	                var itemContent = _react2['default'].createElement(
	                    'div',
	                    null,
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'item__image' },
	                        _react2['default'].createElement('img', { src: _utilsApi2['default'].cachedImagePath(item.image) })
	                    ),
	                    _react2['default'].createElement(
	                        'span',
	                        { className: 'item__overlay' },
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'overlay__title' },
	                            item.title
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'overlay__subtitle' },
	                            item.subtitle,
	                            !!item.subtitle ? _react2['default'].createElement('span', { className: 'play-icon' }) : ''
	                        ),
	                        _react2['default'].createElement(
	                            'span',
	                            { className: 'overlay__text' },
	                            item.text
	                        )
	                    )
	                );
	
	                var itemLink = item.type == 'url' ? _react2['default'].createElement(
	                    'a',
	                    { key: 's-' + ix, href: item.href, className: (0, _classnames2['default'])('featured__item', { 'featured__item--promo': isPromo }, { 'invert-float': !isPromo && invertFloat }), target: '_blank' },
	                    itemContent
	                ) : _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { key: 's-' + ix, to: 'listing', onClick: _this.scrollToTop, query: { search_id: item.searchId, per_page: _store2['default'].get('pagination_amount') ? _store2['default'].get('pagination_amount') : defaultAmountResult }, className: (0, _classnames2['default'])('featured__item', { 'featured__item--promo': isPromo }, { 'invert-float': !isPromo && invertFloat }) },
	                    itemContent
	                );
	
	                return { itemLink: itemLink };
	            })
	        )
	        // </div>
	        ;
	    },
	    scrollToTop: function scrollToTop() {
	        window.scrollTo(0, 0);
	    }
	});
	
	module.exports = MediaFeatured;
	/* <div className="media__featured"> */

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactRouter = __webpack_require__(7);
	
	var _queryString = __webpack_require__(167);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _objectDiff = __webpack_require__(358);
	
	var _objectDiff2 = _interopRequireDefault(_objectDiff);
	
	var _lodashObjectMerge = __webpack_require__(355);
	
	var _lodashObjectMerge2 = _interopRequireDefault(_lodashObjectMerge);
	
	var _lodashLangCloneDeep = __webpack_require__(68);
	
	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);
	
	var _utilsStrings = __webpack_require__(122);
	
	var _fallbackConfig = __webpack_require__(121);
	
	var _fallbackConfig2 = _interopRequireDefault(_fallbackConfig);
	
	var MediaFilterCategory = _react2['default'].createClass({
	
	    displayName: 'MediaFilterCategory',
	
	    mixins: [],
	
	    propTypes: {
	        filter: _react2['default'].PropTypes.object,
	        query: _react2['default'].PropTypes.object,
	        ix: _react2['default'].PropTypes.number
	    },
	
	    prepareLinkParams: function prepareLinkParams(sfilter, pfilter) {
	        var query = (0, _lodashLangCloneDeep2['default'])(this.props.query);
	        var linkParams = _queryString2['default'].parse(sfilter.params);
	        var filterKey = Object.keys(linkParams).pop();
	
	        linkParams.per_page = this.getPerPageParam();
	
	        /**
	         * if the filter is active, remove filter value from query
	         * and remove query values from child filters as well
	         */
	        if (sfilter.active) {
	            var filterQuery = query;
	
	            sfilter.children.length && sfilter.children.filter(function (cfilter) {
	                return !!cfilter.active;
	            }).forEach(function (cfilter) {
	                var cfilterParams = _queryString2['default'].parse(cfilter.params);
	                filterQuery = (0, _utilsStrings.removeFromPipedQuery)(cfilterParams, filterQuery);
	                filterQuery = (0, _objectDiff2['default'])(cfilterParams, filterQuery);
	            });
	
	            filterQuery = (0, _utilsStrings.removeFromPipedQuery)(linkParams, filterQuery);
	            filterQuery = (0, _objectDiff2['default'])(linkParams, filterQuery);
	            if (pfilter) {
	                var pQuery = _queryString2['default'].parse(pfilter.params);
	                filterQuery = (0, _lodashObjectMerge2['default'])(filterQuery, pQuery);
	            }
	
	            linkParams = filterQuery;
	            /**
	             * otherwise add this value to the params
	             */
	        } else {
	                if (query[filterKey]) {
	                    linkParams[filterKey] += '|' + query[filterKey];
	                }
	                linkParams = (0, _lodashObjectMerge2['default'])(query, linkParams);
	            }
	
	        return linkParams;
	    },
	
	    getPerPageParam: function getPerPageParam() {
	        // get it from store, if it is used in this session
	        if (_store2['default'].get('pagination_amount')) {
	            return _store2['default'].get('pagination_amount');
	        }
	        // get it from config
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var defaultPerPageResults = _flux$getStore$getState$config$toJS.defaultPerPageResults;
	
	        if (Number.isInteger(defaultPerPageResults)) {
	            return defaultPerPageResults;
	        }
	        return _fallbackConfig2['default'].defaultPerPageResults;
	    },
	
	    renderFilterMenu: function renderFilterMenu() {
	        if (this.props.filter.get('active')) {
	            return this.renderFilterList(this.props.filter.get('children').toJS(), true);
	        }
	    },
	
	    renderFilterList: function renderFilterList(children) {
	        var _this = this;
	
	        var firstLevel = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	        return _react2['default'].createElement(
	            'ul',
	            { className: 'category__list ' + (firstLevel ? 'first-level' : '') },
	            children.map(function (child) {
	                return _this.checkFilterElement(child);
	            })
	        );
	    },
	
	    checkFilterElement: function checkFilterElement(child) {
	        if (child.hidden) {
	            return null;
	        }
	        var linkParams = this.prepareLinkParams(child);
	        delete linkParams.page;
	        return this.renderFilterElement(child, linkParams);
	    },
	
	    renderFilterElement: function renderFilterElement(child, linkParams) {
	        var _this2 = this;
	
	        return _react2['default'].createElement(
	            'li',
	            { key: child.value },
	            _react2['default'].createElement(
	                _reactRouter.Link,
	                {
	                    className: child.active ? 'active' : '',
	                    onClick: _utilsFlux2['default'].getActions('media').closeFilters,
	                    to: 'listing',
	                    query: linkParams },
	                child.name,
	                ' (',
	                child.count,
	                ')',
	                child.active ? _react2['default'].createElement('span', { className: 'list__clear close' }) : ''
	            ),
	            (function () {
	                if (child.children.length) {
	                    return _this2.renderFilterList(child.children);
	                }
	            })()
	        );
	    },
	
	    toggleFilter: function toggleFilter(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').toggleFilter(this.props.ix);
	    },
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'filters__category' },
	            _react2['default'].createElement(
	                'a',
	                { href: '#', onClick: this.toggleFilter, className: 'category__header' },
	                this.props.filter.get('name'),
	                _react2['default'].createElement('i', { className: this.props.filter.get('active') ? 'minus-small' : 'plus-small' })
	            ),
	            this.renderFilterMenu()
	        );
	    }
	});
	
	module.exports = MediaFilterCategory;

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _mediaFilterCategory = __webpack_require__(509);
	
	var _mediaFilterCategory2 = _interopRequireDefault(_mediaFilterCategory);
	
	var _lodashLangCloneDeep = __webpack_require__(68);
	
	var _lodashLangCloneDeep2 = _interopRequireDefault(_lodashLangCloneDeep);
	
	var MediaFilters = _react2['default'].createClass({
	    displayName: 'MediaFilters',
	    mixins: [],
	    propTypes: {},
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    toogleExpand: function toogleExpand(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').toggleExpand();
	    },
	    clearFilters: function clearFilters(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').clearQuery();
	        this.context.router.transitionTo('landing-page');
	    },
	    render: function render() {
	        if (!this.props.filters || this.props.filters.size === 0) {
	            return false;
	        }
	        var query = (0, _lodashLangCloneDeep2['default'])(this.context.router.getCurrentQuery());
	        var router = this.context.router;
	
	        var route = router.getRouteAtDepth(1);
	        var isLanding = route && 'landing-page' === route.name;
	
	        var _flux$getStore$getState = _utilsFlux2['default'].getStore('app').getState();
	
	        var hideFilters = _flux$getStore$getState.hideFilters;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'media__filters' },
	            this.props.children,
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('filter')
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'filters__buttons' },
	                _react2['default'].createElement(
	                    'button',
	                    { onClick: this.clearFilters, disabled: isLanding, type: 'button', className: 'btn btn-border buttons__clear' },
	                    _react2['default'].createElement('i', { className: 'close' }),
	                    _utilsFlux2['default'].t('clear_filters')
	                ),
	                _react2['default'].createElement(
	                    'button',
	                    { type: 'button', onClick: this.toogleExpand, className: 'btn btn-border buttons__expand' },
	                    _react2['default'].createElement('i', { className: 'expand' }),
	                    _utilsFlux2['default'].t(this.props.isExpanded ? 'collapse_all' : 'expand_all')
	                )
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'filters__categories' },
	                this.props.filters.map(function (filter, ix) {
	                    var filterName = filter.get('name').toLowerCase();
	                    if (filter.get('hidden')) {
	                        return false;
	                    }
	                    if (typeof hideFilters != 'undefined') {
	                        if (hideFilters.indexOf(filterName) > -1) {
	                            return false;
	                        }
	                    }
	                    return _react2['default'].createElement(_mediaFilterCategory2['default'], { key: 'filter_' + ix, query: query, ix: ix, filter: filter });
	                })
	            )
	        );
	    }
	});
	
	module.exports = MediaFilters;

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _mediaFeatured = __webpack_require__(508);
	
	var _mediaFeatured2 = _interopRequireDefault(_mediaFeatured);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var MediaLandingPage = _react2['default'].createClass({
	    displayName: 'MediaLandingPage',
	    mixins: [],
	    propTypes: {},
	    render: function render() {
	        if (_utilsFlux2['default'].getStore('modals').getState().loading) {
	            return _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null);
	        }
	        return _react2['default'].createElement(_mediaFeatured2['default'], { landingPage: this.props.mediaStore.landingPage });
	    }
	});
	
	module.exports = MediaLandingPage;

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _mediaListingItem = __webpack_require__(514);
	
	var _mediaListingItem2 = _interopRequireDefault(_mediaListingItem);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var _mediaListingEmpty = __webpack_require__(513);
	
	var _mediaListingEmpty2 = _interopRequireDefault(_mediaListingEmpty);
	
	var MediaListingPage = _react2['default'].createClass({
	    displayName: 'MediaListingPage',
	    mixins: [],
	    propTypes: {},
	    render: function render() {
	        var _this = this;
	
	        if (_utilsFlux2['default'].getStore('media').isLoading() || _utilsFlux2['default'].getStore('basket').isLoading() || _utilsFlux2['default'].getStore('modals').getState().loading) {
	            return _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null);
	        }
	
	        if (this.props.mediaStore.media.size === 0) {
	            return _react2['default'].createElement(_mediaListingEmpty2['default'], null);
	        }
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var defaultResultView = _flux$getStore$getState$config$toJS.defaultResultView;
	
	        var layout = _store2['default'].get('active_layout') || defaultResultView || 'large_preview';
	        var amountEmbargo = this.props.mediaStore.media.toJS().filter(function (x) {
	            return x.embargo;
	        }).length;
	        var amountArchive = this.props.mediaStore.media.toJS().filter(function (x) {
	            return x.archived;
	        }).length;
	        var amountMarked = amountEmbargo + amountArchive;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'media__listing layout__' + layout + ' ' + (amountMarked > 0 ? 'media__listing__marked' : '') },
	            this.props.mediaStore.media.map(function (item) {
	                return _react2['default'].createElement(_mediaListingItem2['default'], { key: 'mlitem-' + item.get('id'), item: item, layout: layout, slotDefinitions: _this.props.mediaStore.slotDefinitions });
	            })
	        );
	    }
	});
	
	module.exports = MediaListingPage;

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _reactRouter = __webpack_require__(7);
	
	var MediaListingEmpty = _react2['default'].createClass({
	    displayName: 'MediaListingEmpty',
	    mixins: [],
	    propTypes: {},
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    clearFilters: function clearFilters(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').clearQuery();
	        this.context.router.transitionTo('landing-page');
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'media__empty' },
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('no_search_results')
	            ),
	            _react2['default'].createElement(
	                _reactRouter.Link,
	                { className: 'btn btn-primary', to: 'landing-page', onClick: this.clearFilters },
	                _utilsFlux2['default'].t('clear_filters')
	            )
	        );
	    }
	});
	
	module.exports = MediaListingEmpty;

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _mediaListingItemNotification = __webpack_require__(195);
	
	var _mediaListingItemNotification2 = _interopRequireDefault(_mediaListingItemNotification);
	
	var _mediaListingItemInfo = __webpack_require__(515);
	
	var _mediaListingItemInfo2 = _interopRequireDefault(_mediaListingItemInfo);
	
	var _componentsThumb = __webpack_require__(104);
	
	var _componentsThumb2 = _interopRequireDefault(_componentsThumb);
	
	var MediaListingItem = _react2['default'].createClass({
	
	    displayName: 'MediaListingItem',
	
	    propTypes: {
	        item: _react2['default'].PropTypes.object
	    },
	
	    render: function render() {
	        var item = this.props.item.toJS();
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var archiveColor = _flux$getStore$getState$config$toJS.archiveColor;
	        var embargoColor = _flux$getStore$getState$config$toJS.embargoColor;
	
	        var layout = this.props.layout;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])('listing__item', 'listing__item--' + item.type, item.embargo || item.archived ? 'listing__item--archived' : ''), 'data-embargo': embargoColor },
	            _react2['default'].createElement(
	                _componentsThumb2['default'],
	                { className: 'item__preview', media: this.props.item, onClickOpenModal: true },
	                item.embargo && _react2['default'].createElement('div', { className: 'item__preview__overlay', style: { border: '5px solid ' + embargoColor } }),
	                item.archived && _react2['default'].createElement('div', { className: 'item__preview__overlay', style: { border: '5px solid ' + archiveColor } }),
	                _react2['default'].createElement(
	                    _altContainer2['default'],
	                    {
	                        stores: { notificationsStore: _utilsFlux2['default'].getStore('notifications') },
	                        transform: function (_ref) {
	                            var notificationsStore = _ref.notificationsStore;
	
	                            var notifications = notificationsStore.notifications.filter(function (notification) {
	                                return notification.mediaId === item.id;
	                            });
	                            return { notifications: notifications };
	                        } },
	                    _react2['default'].createElement(_mediaListingItemNotification2['default'], null)
	                )
	            ),
	            _react2['default'].createElement(_mediaListingItemInfo2['default'], { item: this.props.item, slotDefinitions: this.props.slotDefinitions, layout: layout })
	        );
	    }
	});
	
	module.exports = MediaListingItem;

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _lodashStringTrunc = __webpack_require__(356);
	
	var _lodashStringTrunc2 = _interopRequireDefault(_lodashStringTrunc);
	
	var _componentsBasketBasketDropdown = __webpack_require__(144);
	
	var _componentsBasketBasketDropdown2 = _interopRequireDefault(_componentsBasketBasketDropdown);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _reactRouter = __webpack_require__(7);
	
	var _reactOnclickoutside = __webpack_require__(235);
	
	var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var MediaListingItemInfo = _react2['default'].createClass({
	
	    displayName: 'MediaListingItemInfo',
	
	    mixins: [_reactOnclickoutside2['default'], _reactRouter.Navigation],
	
	    propTypes: {
	        media: _react2['default'].PropTypes.object
	    },
	
	    componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (this.props.layout != nextProps.layout) {
	            this.forceUpdate();
	        }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	        return _immutable2['default'].is(nextProps.item, this.props.item) === false;
	    },
	
	    handleClickOutside: function handleClickOutside() {
	        if (this.props.item.get('_basket')) {
	            _utilsFlux2['default'].getActions('media').toggleBasket(this.props.item.get('id'));
	        }
	    },
	
	    toggleCheck: function toggleCheck(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').toggleItemSelection(this.props.item.get('id'));
	    },
	
	    toggleBasket: function toggleBasket(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('media').toggleBasket(this.props.item.get('id'));
	    },
	
	    generateQuickDownload: function generateQuickDownload(e) {
	        var _this = this;
	
	        e.preventDefault();
	        _utilsFlux2['default'].getStore('basket').createBasket([{ id: this.props.item.get('id') }]).then(function () {
	            setTimeout(function () {
	                var activeBasketId = _utilsFlux2['default'].getStore('basket').getState().activeBasketId;
	                _this.transitionTo('singleBasket', { id: activeBasketId });
	            }, 20);
	        });
	    },
	
	    generateInstantDownload: function generateInstantDownload(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openInstantDownloadModal(this.props.item);
	    },
	
	    runInstantDownload: function runInstantDownload(e) {
	        e.preventDefault();
	        var iframe = document.getElementById('download_helper');
	        var id = this.props.item.toJS().id;
	        var mediabox_token = _store2['default'].get('mediabox_token');
	        if (this.props.item.toJS().files.filter(function (x) {
	            return x.key === 'master';
	        }).length > 0) {
	            iframe.src = window.config.baseUrl + '/download?token=' + mediabox_token + '&' + id + '=master';
	            if (this.props.item.toJS().embargo) {
	                _utilsFlux2['default'].getActions('modals').openWatermarkModal(this.props.item);
	            }
	        }
	    },
	
	    renderBasket: function renderBasket() {
	        if (this.props.item.get('_basket') && !_utilsFlux2['default'].getStore('modals').getState().openModal) {
	            var mediaId = this.props.item.get('id');
	            var mediaName = this.props.item.get('name') || this.props.item.get('title');
	            return _react2['default'].createElement(
	                _altContainer2['default'],
	                {
	                    stores: { basketStore: _utilsFlux2['default'].getStore('basket') },
	                    transform: function (_ref) {
	                        var basketStore = _ref.basketStore;
	
	                        var baskets = basketStore.baskets;
	                        return { baskets: baskets };
	                    } },
	                _react2['default'].createElement(_componentsBasketBasketDropdown2['default'], { mediaId: mediaId, mediaName: mediaName, media: this.props.item })
	            );
	        }
	    },
	
	    renderItemMeta: function renderItemMeta() {
	        var item = this.props.item.toJS();
	        var MICode = item.meta.find(function (meta) {
	            return 'MICode' === meta.key;
	        });
	        var master = item.files && item.files.find(function (file) {
	            return 'master' === file.key;
	        });
	        var duration = master && master.meta && master.meta.find && master.meta.find(function (meta) {
	            return 'Duration' === meta.name && !meta.hidden;
	        });
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var hideAssetDescription = _flux$getStore$getState$config$toJS.hideAssetDescription;
	
	        var metaPosition = 0;
	
	        if (hideAssetDescription && !item.archived && !item.embargo) {
	            metaPosition = 45;
	        } else if (hideAssetDescription && (item.archived || item.embargo)) {
	            metaPosition = 80;
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            null,
	            item.additionalText && _react2['default'].createElement(
	                'div',
	                { className: 'item__additional' },
	                item.additionalText
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__meta' },
	                MICode && _react2['default'].createElement(
	                    'div',
	                    { className: 'meta__micode' },
	                    MICode.value
	                ),
	                duration && _react2['default'].createElement(
	                    'div',
	                    { className: 'meta__duration', style: { bottom: metaPosition ? metaPosition : 0 } },
	                    duration.value
	                )
	            )
	        );
	    },
	
	    renderSlots: function renderSlots() {
	        var _this2 = this;
	
	        var layout = arguments.length <= 0 || arguments[0] === undefined ? "large_preview" : arguments[0];
	
	        var slotDefinitions = this.props.slotDefinitions.toJS();
	        var slots = [];
	        switch (layout) {
	            case 'small_preview':
	                slots = window.config.tiles_small;
	                break;
	            case 'list_view':
	                slots = window.config.list;
	                break;
	            default:
	                slots = window.config.tiles_large;
	        }
	        return _react2['default'].createElement(
	            'div',
	            { className: 'slots' },
	            slots.map(function (slot) {
	                var id = slot.toString();
	                var currentSlotDefinition = slotDefinitions.filter(function (slot) {
	                    return slot.id === id;
	                });
	                var currentSlot = _this2.props.item.toJS().slots.filter(function (slot) {
	                    return slot.id === id;
	                });
	                if (currentSlot[0] && (currentSlot[0].content || currentSlot[0].color || currentSlot[0].icon) && currentSlotDefinition[0]) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { className: 'description__item' },
	                        _this2.renderSlotProperties(currentSlot[0])
	                    );
	                }
	            })
	        );
	    },
	
	    renderSlotProperties: function renderSlotProperties(slot) {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'slot' },
	            Object.keys(slot).map(function (key) {
	                switch (key) {
	                    case 'content':
	                        return _react2['default'].createElement(
	                            'span',
	                            { key: key, className: 'slot-property slot-property__' + key },
	                            ' ',
	                            slot[key]
	                        );;
	                    case 'color':
	                        return _react2['default'].createElement('span', { key: key, className: 'slot-property slot-property__' + key, style: { backgroundColor: slot[key] } });
	                    case 'icon':
	                        return _react2['default'].createElement(
	                            'span',
	                            { key: key, className: 'slot-property slot-property__' + key },
	                            _react2['default'].createElement('img', { src: slot[key] })
	                        );
	                    default:
	                        return null;
	                }
	            })
	        );
	    },
	
	    render: function render() {
	        var item = this.props.item.toJS();
	        var hideActions = false === item.showdownload || false;
	        var hideCheckbox = hideActions;
	
	        var _flux$getStore$getState$config$toJS2 = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var archiveColor = _flux$getStore$getState$config$toJS2.archiveColor;
	        var directDownload = _flux$getStore$getState$config$toJS2.directDownload;
	        var embargoColor = _flux$getStore$getState$config$toJS2.embargoColor;
	        var hideAssetDescription = _flux$getStore$getState$config$toJS2.hideAssetDescription;
	
	        var minHeight = null;
	        var layout = this.props.layout;
	
	        if (hideAssetDescription && !item.archived && !item.embargo) {
	            minHeight = 44;
	        } else if (hideAssetDescription && (item.archived || item.embargo)) {
	            minHeight = 100;
	        } else {
	            minHeight = null;
	        }
	
	        return _react2['default'].createElement(
	            'div',
	            { className: (0, _classnames2['default'])('item__info', { 'item__info--has-actions': !hideActions, 'item__info--no-actions': hideActions }), style: { height: hideAssetDescription ? 'auto' : null, minHeight: minHeight } },
	            _react2['default'].createElement(
	                'div',
	                { className: 'info__top' },
	                !hideCheckbox && _react2['default'].createElement(
	                    'div',
	                    { className: 'top__checkbox' },
	                    _react2['default'].createElement(
	                        'form',
	                        null,
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'field__checkbox' },
	                            _react2['default'].createElement('input', { readOnly: true, type: 'checkbox', id: 'item_' + item.id, checked: item._checked }),
	                            _react2['default'].createElement('label', { onClick: this.toggleCheck, htmlFor: 'item_' + item.id })
	                        )
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'top__text' },
	                    this.renderSlots(layout)
	                ),
	                !hideActions && _react2['default'].createElement(
	                    'div',
	                    { className: 'top__actions' },
	                    _react2['default'].createElement(
	                        'div',
	                        { onClick: directDownload ? this.runInstantDownload : this.generateInstantDownload, className: 'actions__directdownload' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'directdownload__button' },
	                            _react2['default'].createElement('i', { className: 'download' })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { onClick: this.toggleBasket, className: 'actions__addtobasket' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'addtobasket__button' },
	                            _react2['default'].createElement('i', { className: 'plus-small' })
	                        )
	                    ),
	                    this.renderBasket()
	                ),
	                item.embargo && _react2['default'].createElement(
	                    'p',
	                    { style: { color: embargoColor }, className: 'item__embargo clearfix' },
	                    'embargo'
	                ),
	                item.archived && _react2['default'].createElement(
	                    'p',
	                    { style: { color: archiveColor }, className: 'item__embargo clearfix' },
	                    'archive'
	                )
	            ),
	            directDownload && _react2['default'].createElement('iframe', { id: 'download_helper', style: { display: 'none' } })
	        );
	    }
	});
	
	module.exports = MediaListingItemInfo;

/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var _objectDiff = __webpack_require__(358);
	
	var _objectDiff2 = _interopRequireDefault(_objectDiff);
	
	var _lodashObjectMerge = __webpack_require__(355);
	
	var _lodashObjectMerge2 = _interopRequireDefault(_lodashObjectMerge);
	
	var _utilsStrings = __webpack_require__(122);
	
	var _lodash = __webpack_require__(109);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var MediaSelectedFilters = _react2['default'].createClass({
	
	    displayName: 'MediaSelectedFilters',
	
	    mixins: [],
	
	    propTypes: {
	        filters: _react2['default'].PropTypes.object,
	        size: _react2['default'].PropTypes.number
	    },
	
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	
	    removeFilter: function removeFilter(index, e) {
	        e.preventDefault();
	
	        if (_utilsDom2['default'].hasClass(e.target, 'filter__remove')) {
	            _utilsFlux2['default'].getActions('media').removeSelectedFilter(index);
	        }
	    },
	
	    render: function render() {
	        if (this.props.filters.size === 0 || this.props.size === 0) {
	            return false;
	        }
	        var filters = _lodash2['default'].uniq(this.props.filters.toJS(), 'name');
	        var query = this.props.query;
	        return _react2['default'].createElement(
	            'div',
	            { className: 'media__selectedfilters' },
	            filters.map(function (sfilter, i) {
	                sfilter.params && sfilter.params.page && delete sfilter.params.page;
	
	                var filterQuery = (0, _utilsStrings.removeFromPipedQuery)(sfilter.params, query, true);
	                var filterQueryKeys = Object.keys(sfilter.params);
	                var isChildFilter = filterQueryKeys.length > 1;
	                var firstQueryKey = filterQueryKeys[0];
	
	                if (!isChildFilter) {
	                    filterQuery = (0, _objectDiff2['default'])(sfilter.params, filterQuery);
	                    var childFilters = filters.filter(function (rfilter) {
	                        return rfilter !== sfilter && typeof rfilter.params[firstQueryKey] !== 'undefined' && rfilter.params[firstQueryKey] === sfilter.params[firstQueryKey];
	                    });
	                    childFilters.forEach(function (cfilter) {
	                        filterQuery = (0, _utilsStrings.removeFromPipedQuery)(cfilter.params, filterQuery, true);
	                        filterQuery = (0, _objectDiff2['default'])(cfilter.params, filterQuery);
	                    });
	                } else {
	                    var parentFilter = filters.filter(function (rfilter) {
	                        var queryKeys = Object.keys(rfilter.params);
	                        return rfilter !== sfilter && queryKeys.length <= 1 && queryKeys[0] === firstQueryKey;
	                    }).shift();
	                    parentFilter = parentFilter || {};
	                    filterQuery = (0, _lodashObjectMerge2['default'])((0, _objectDiff2['default'])(sfilter.params, filterQuery), parentFilter.params);
	                }
	
	                if (1 === Object.keys(filterQuery).length && filterQuery.page) {
	                    delete filterQuery.page;
	                }
	
	                if (1 === Object.keys(filterQuery).length && filterQuery.per_page) {
	                    delete filterQuery.per_page;
	                }
	
	                return _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { to: 'listing', key: 'filter_selected_' + i, query: filterQuery, className: 'btn btn-primary btn-small' },
	                    sfilter.name,
	                    _react2['default'].createElement('span', { className: 'filter__remove' })
	                );
	            })
	        );
	    }
	});
	
	module.exports = MediaSelectedFilters;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _imgAsync = __webpack_require__(224);
	
	var _imgAsync2 = _interopRequireDefault(_imgAsync);
	
	var _fallbackConfig = __webpack_require__(121);
	
	var _fallbackConfig2 = _interopRequireDefault(_fallbackConfig);
	
	var MediaSlideshow = _react2['default'].createClass({
	
	    displayName: 'MediaSlideshow',
	
	    propTypes: {
	        slides: _react2['default'].PropTypes.array.isRequired
	    },
	
	    getInitialState: function getInitialState() {
	        return {
	            activeSlideIndex: 0,
	            play: true
	        };
	    },
	
	    componentDidMount: function componentDidMount() {
	        var slides = this.props.slides;
	        var len = slides.length;
	
	        if (len === 0) {
	            return;
	        }
	
	        var inner = this.refs.inner.getDOMNode();
	
	        inner.style.width = len * 100 + '%';
	        Array.prototype.map.call(inner.childNodes, function (slide) {
	            slide.style.width = 100 / len + '%';
	        });
	
	        this._goto(this.state.activeSlideIndex);
	    },
	
	    componentDidUpdate: function componentDidUpdate() {
	        var _this = this;
	
	        clearTimeout(this._timeout);
	
	        if (this.state.play) {
	            this._timeout = setTimeout((function () {
	                _this._next();
	            }).bind(this), 8000);
	        }
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	        clearTimeout(this._timeout);
	    },
	
	    _goto: function _goto(ix) {
	        if (ix >= this.props.slides.length) {
	            ix = 0;
	        } else if (ix < 0) {
	            ix = this.props.slides.length - 1;
	        }
	        this.setState({ activeSlideIndex: ix });
	    },
	
	    _next: function _next() {
	        this._goto(++this.state.activeSlideIndex);
	    },
	
	    _previous: function _previous() {
	        this._goto(--this.state.activeSlideIndex);
	    },
	
	    _play: function _play() {
	        this.setState({ play: true });
	    },
	
	    _pause: function _pause() {
	        this.setState({ play: false });
	    },
	
	    renderControls: function renderControls() {
	        var _this2 = this;
	
	        var slides = this.props.slides;
	        if (slides.length === 0) {
	            return false;
	        }
	        return _react2['default'].createElement(
	            'div',
	            { className: 'landing-slideshow__controls' },
	            _react2['default'].createElement(
	                'ul',
	                { className: 'landing-slideshow__pills' },
	                slides.map(function (slide, ix) {
	                    return _react2['default'].createElement(
	                        'li',
	                        { key: 'slide_link_' + ix },
	                        _react2['default'].createElement(
	                            'a',
	                            { href: '#', onClick: function (e) {
	                                    e.preventDefault();
	                                    _this2._pause();
	                                    _this2._goto(ix);
	                                }, className: _this2.state.activeSlideIndex === ix ? 'active' : null },
	                            ''
	                        )
	                    );
	                })
	            ),
	            _react2['default'].createElement(
	                'button',
	                { className: 'landing-slideshow__prev', onClick: this._previous },
	                _react2['default'].createElement('i', { className: 'chevron-left' })
	            ),
	            _react2['default'].createElement(
	                'button',
	                { className: 'landing-slideshow__next', onClick: this._next },
	                _react2['default'].createElement('i', { className: 'chevron-right' })
	            )
	        );
	    },
	
	    render: function render() {
	        var items = this.props.slides;
	        var len = items.length;
	        var left = 0;
	
	        if (len === 0) {
	            return false;
	        }
	
	        left = -100 * this.state.activeSlideIndex + '%';
	
	        var slides = items.map(function (slide, ix) {
	            if (slide.type == 'url') {
	                return _react2['default'].createElement(
	                    'a',
	                    { key: 'slide_' + ix, href: slide.href, className: 'landing-slideshow__slide', style: { backgroundImage: 'url(' + slide.image + ')' }, activeClassName: '', target: '_blank' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'landing-slideshow__slide-copy' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'landing-slideshow__slide-title' },
	                            slide.title
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'landing-slideshow__slide-subtitle' },
	                            slide.subtitle,
	                            !!slide.subtitle ? _react2['default'].createElement('span', { className: 'play-icon' }) : ''
	                        )
	                    )
	                );
	            } else {
	                var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	                var defaultPerPageResults = _flux$getStore$getState$config$toJS.defaultPerPageResults;
	
	                var defaultAmountResult = Number.isInteger(defaultPerPageResults) ? defaultPerPageResults : _fallbackConfig2['default'].defaultPerPageResults;
	                var slideQuery = { search_id: slide.searchId, per_page: _store2['default'].get('pagination_amount') ? _store2['default'].get('pagination_amount') : defaultAmountResult };
	                return _react2['default'].createElement(
	                    _reactRouter.Link,
	                    { key: 'slide_' + ix, to: 'listing', query: slideQuery, className: 'landing-slideshow__slide', style: { backgroundImage: 'url(' + slide.image + ')' }, activeClassName: '' },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'landing-slideshow__slide-copy' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'landing-slideshow__slide-title' },
	                            slide.title
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'landing-slideshow__slide-subtitle' },
	                            slide.subtitle,
	                            !!slide.subtitle ? _react2['default'].createElement('span', { className: 'play-icon' }) : ''
	                        )
	                    )
	                );
	            };
	        });
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'landing-slideshow' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'landing-slideshow__inner-clip' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'landing-slideshow__inner', ref: 'inner', style: { left: left } },
	                    slides,
	                    '})}'
	                )
	            ),
	            this.renderControls()
	        );
	    }
	});
	
	module.exports = MediaSlideshow;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var NotFoundPage = _react2['default'].createClass({
	    displayName: 'NotFoundPage',
	    mixins: [],
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    componentDidMount: function componentDidMount() {
	
	        this.context.router.transitionTo('landing-page');
	    },
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            'NotFoundPage'
	        );
	    }
	});
	
	module.exports = NotFoundPage;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var PrivacyPage = _react2['default'].createClass({
	    displayName: 'PrivacyPage',
	    mixins: [],
	    propTypes: {},
	    componentWillMount: function componentWillMount() {
	        _utilsFlux2['default'].getStore('app').loadPrivacy();
	    },
	    render: function render() {
	        var appStore = _utilsFlux2['default'].getStore('app');
	        var modalStore = _utilsFlux2['default'].getStore('modals');
	        return _react2['default'].createElement(
	            'div',
	            { className: 'page terms' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'container--centered' },
	                _react2['default'].createElement(_altContainer2['default'], { stores: { appStore: appStore, modalStore: modalStore },
	                    render: function (props) {
	                        if (modalStore.getState().loading) {
	                            return _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null);
	                        }
	                        if (!props.appStore.privacy) {
	                            return false;
	                        }
	                        return _react2['default'].createElement('div', { dangerouslySetInnerHTML: _utilsDom2['default'].setInnerHtml(props.appStore.privacy) });
	                    } })
	            )
	        );
	    }
	});
	
	module.exports = PrivacyPage;

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var RedirectPage = _react2['default'].createClass({
	    displayName: 'RedirectPage',
	    mixins: [],
	    propTypes: {},
	    statics: {
	        willTransitionTo: function willTransitionTo(transition) {
	            if (_utilsFlux2['default'].getStore('app').isSamlLogin()) {
	                console.log("saml");
	
	                if (_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	                    transition.redirect('landing-page');
	                } else {
	                    console.log("proper transition");
	                    window.location.reload();
	                    transition.redirect('saml_error');
	                }
	            } else if (_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	                console.log("logged in");
	
	                if (!_utilsFlux2['default'].getStore('app').hasAcceptedLatestTerms()) {
	                    transition.redirect('/accept_terms', {}, { nextPath: transition.path });
	                }
	                transition.redirect('landing-page');
	            } else if (_utilsFlux2['default'].getStore('app').isNoneLogin()) {
	                console.log("none");
	
	                _utilsFlux2['default'].getStore('app').loginUser({}).then(function () {
	                    window.location.reload();
	                    transition.redirect('landing-page', {}, { nextPath: transition.path });
	                });
	            } else {
	                console.log("login");
	
	                transition.redirect('/login', {}, { nextPath: transition.path });
	            }
	        }
	    },
	    render: function render() {
	        return _react2['default'].createElement('div', null);
	    }
	});
	
	module.exports = RedirectPage;

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortal = __webpack_require__(129);
	
	var _reactPortal2 = _interopRequireDefault(_reactPortal);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _pagesLoginLoginSlideshow = __webpack_require__(194);
	
	var _pagesLoginLoginSlideshow2 = _interopRequireDefault(_pagesLoginLoginSlideshow);
	
	var _pagesLoginLoginBackgroundVideo = __webpack_require__(193);
	
	var _pagesLoginLoginBackgroundVideo2 = _interopRequireDefault(_pagesLoginLoginBackgroundVideo);
	
	var _componentsModalsModal = __webpack_require__(191);
	
	var _componentsModalsModal2 = _interopRequireDefault(_componentsModalsModal);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _componentsModalsPasswordResetModal = __webpack_require__(475);
	
	var _componentsModalsPasswordResetModal2 = _interopRequireDefault(_componentsModalsPasswordResetModal);
	
	var ResetPasswordPage = _react2['default'].createClass({
	    displayName: 'ResetPasswordPage',
	    mixins: [],
	    propTypes: {},
	
	    renderFullbleed: function renderFullbleed() {
	        var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	        var backGroundLayer;
	
	        if (!isMobile) {
	            backGroundLayer = _react2['default'].createElement(_pagesLoginLoginBackgroundVideo2['default'], {
	                poster: window.config.slideshowImages[0],
	                video: window.config.backgroundMovie
	            });
	        } else {
	            backGroundLayer = _react2['default'].createElement(_pagesLoginLoginSlideshow2['default'], {
	                show: window.config.slideshowImages,
	                speed: 4000
	            });
	        }
	
	        return backGroundLayer;
	    },
	    render: function render() {
	        var secret = this.props.params.secret;
	        return _react2['default'].createElement(
	            'div',
	            { className: 'welcome container--centered' },
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: true },
	                _react2['default'].createElement(
	                    _componentsModalsModal2['default'],
	                    { className: 'modal__password-reset', closeOnOutsideClick: false, hideCloseButton: true },
	                    _react2['default'].createElement(
	                        _altContainer2['default'],
	                        {
	                            stores: { appStore: _utilsFlux2['default'].getStore('app') },
	                            transform: function (_ref) {
	                                var appStore = _ref.appStore;
	
	                                var hasError = appStore.error;
	                                return { hasError: hasError, secret: secret };
	                            } },
	                        _react2['default'].createElement(_componentsModalsPasswordResetModal2['default'], null)
	                    )
	                )
	            ),
	            _react2['default'].createElement(
	                _reactPortal2['default'],
	                { isOpened: true },
	                this.renderFullbleed()
	            )
	        );
	    }
	});
	
	module.exports = ResetPasswordPage;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var SamlError = _react2['default'].createClass({
	    displayName: 'SamlError',
	    mixins: [],
	
	    render: function render() {
	        return _react2['default'].createElement(
	            'div',
	            { className: 'page samil-error' },
	            _react2['default'].createElement(
	                'h4',
	                null,
	                _utilsFlux2['default'].t('saml_error_message'),
	                ' '
	            )
	        );
	    }
	});
	
	module.exports = SamlError;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _shareItem = __webpack_require__(524);
	
	var _shareItem2 = _interopRequireDefault(_shareItem);
	
	var _shareItemRestricted = __webpack_require__(525);
	
	var _shareItemRestricted2 = _interopRequireDefault(_shareItemRestricted);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var _shareSidebar = __webpack_require__(526);
	
	var _shareSidebar2 = _interopRequireDefault(_shareSidebar);
	
	var _componentsHeaderBarHeaderShare = __webpack_require__(461);
	
	var _componentsHeaderBarHeaderShare2 = _interopRequireDefault(_componentsHeaderBarHeaderShare);
	
	var BasketPage = _react2['default'].createClass({
	    displayName: 'SharePage',
	    mixins: [],
	    propTypes: {},
	    contextTypes: {
	        router: _react2['default'].PropTypes.func.isRequired
	    },
	    statics: {
	        willTransitionTo: function willTransitionTo(transition, query) {
	            var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	            var shareMode = _flux$getStore$getState$config$toJS.shareMode;
	
	            if ('auth' === shareMode && !_utilsFlux2['default'].getStore('app').isAuthenticated()) {
	                return transition.redirect('/login', {}, { nextPath: transition.path });
	            }
	
	            if ('auth' === shareMode && !_utilsFlux2['default'].getStore('app').hasAcceptedLatestTerms()) {
	                return transition.redirect('/accept_terms', {}, { nextPath: transition.path });
	            } else {
	                return _utilsFlux2['default'].getStore('share').loadShare(query.shareId);
	            }
	        }
	    },
	    render: function render() {
	        var currentBasketId = this.props.params.basketId;
	        var currentShareId = this.props.params.shareId;
	        var router = this.context.router;
	
	        var _flux$getStore$getState$config$toJS2 = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var shareMode = _flux$getStore$getState$config$toJS2.shareMode;
	
	        var isAuthenticated = _utilsFlux2['default'].getStore('app').isAuthenticated();
	        return _react2['default'].createElement(_altContainer2['default'], { stores: { shareStore: _utilsFlux2['default'].getStore('share') },
	            render: function (props) {
	                var linkExpired = props.shareStore.linkExpired;
	                if (linkExpired) {
	                    return _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])('page', { 'share--noauth': 'noAuth' === shareMode }) },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: (0, _classnames2['default'])('headerbar', { 'headerbar--empty': 'noAuth' === shareMode }) },
	                            _react2['default'].createElement(
	                                'div',
	                                { className: 'container--centered' },
	                                _react2['default'].createElement(
	                                    'h4',
	                                    { className: 'error' },
	                                    _utilsFlux2['default'].t('share_url_invalid')
	                                )
	                            )
	                        )
	                    );
	                }
	
	                var ix = props.shareStore.baskets.findIndex(function (item) {
	                    return item.get('id') === currentBasketId;
	                });
	                var currentBasket = props.shareStore.baskets.getIn([ix]);
	
	                if (_utilsFlux2['default'].getStore('share').isLoading() || _utilsFlux2['default'].getStore('modals').getState().loading) {
	                    return _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null);
	                }
	
	                if (!currentBasket || currentBasket.size === 0) {
	                    router.transitionTo('landing-page');
	                    return _react2['default'].createElement('div', null);
	                }
	
	                return _react2['default'].createElement(
	                    'div',
	                    { className: (0, _classnames2['default'])('page', 'share', { 'share--noauth': 'noAuth' === shareMode }) },
	                    _react2['default'].createElement(
	                        'div',
	                        { className: (0, _classnames2['default'])('headerbar', { 'headerbar--empty': 'noAuth' === shareMode }) },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container--centered' },
	                            ('auth' === shareMode || 'openDownload' === shareMode || 'noAuth' === shareMode && isAuthenticated) && _react2['default'].createElement(_componentsHeaderBarHeaderShare2['default'], { basket: currentBasket })
	                        )
	                    ),
	                    _react2['default'].createElement(
	                        'div',
	                        { className: 'basket__container container--centered' },
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__filters' },
	                            _react2['default'].createElement(_shareSidebar2['default'], { user: props.shareStore.user, baskets: props.shareStore.baskets, shareId: currentShareId })
	                        ),
	                        _react2['default'].createElement(
	                            'div',
	                            { className: 'container__content' },
	                            currentBasket.get('items').map(function (item) {
	                                if (!item.get('visible')) {
	                                    return _react2['default'].createElement(_shareItemRestricted2['default'], { key: item.get('id'), item: item });
	                                }
	                                return _react2['default'].createElement(_shareItem2['default'], { key: item.get('id'), basketId: currentBasketId, item: item });
	                            })
	                        )
	                    )
	                );
	            } });
	    }
	});
	
	module.exports = BasketPage;

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _lodashStringTrunc = __webpack_require__(356);
	
	var _lodashStringTrunc2 = _interopRequireDefault(_lodashStringTrunc);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _componentsThumb = __webpack_require__(104);
	
	var _componentsThumb2 = _interopRequireDefault(_componentsThumb);
	
	var _reactRouter = __webpack_require__(7);
	
	var _prettyBytes = __webpack_require__(166);
	
	var _prettyBytes2 = _interopRequireDefault(_prettyBytes);
	
	var ShareItem = _react2['default'].createClass({
	    displayName: 'ShareItem',
	
	    mixins: [_reactRouter.Navigation],
	
	    propTypes: {
	        media: _react2['default'].PropTypes.object
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	        return _immutable2['default'].is(nextProps.item, this.props.item) === false;
	    },
	
	    generateQuickDownload: function generateQuickDownload(e) {
	        var _this = this;
	
	        e.preventDefault();
	        _utilsFlux2['default'].getStore('basket').createBasket([{ id: this.props.item.get('id') }]).then(function () {
	            setTimeout(function () {
	                var activeBasketId = _utilsFlux2['default'].getStore('basket').getState().activeBasketId;
	                _this.transitionTo('singleBasket', { id: activeBasketId });
	            }, 20);
	        });
	    },
	
	    generateInstantDownload: function generateInstantDownload(e) {
	        e.preventDefault();
	        _utilsFlux2['default'].getActions('modals').openInstantDownloadModal(this.props.item);
	    },
	
	    toggleCheck: function toggleCheck(size, e) {
	        if (size === undefined) size = undefined;
	
	        e.preventDefault();
	        var pageParams = this.context.router.getCurrentParams();
	        var basketId = this.props.basketId;
	        _utilsFlux2['default'].getActions('share').toggleItemSelection({ basketId: basketId, itemId: this.props.item.get('id'), fileKey: size });
	    },
	
	    render: function render() {
	        var _this2 = this;
	
	        var item = this.props.item.toJS();
	
	        var _flux$getStore$getState$config$toJS = _utilsFlux2['default'].getStore('app').getState().config.toJS();
	
	        var shareMode = _flux$getStore$getState$config$toJS.shareMode;
	
	        var isAuthenticated = _utilsFlux2['default'].getStore('app').isAuthenticated();
	
	        var meta = item.meta;
	        var files = item.files;
	
	        var master = files.find(function (file) {
	            return 'master' === file.key;
	        }) || files.length && files[0];
	        var MICode = meta.find(function (meta) {
	            return 'MICode' === meta.key;
	        });
	        var duration = master && master.meta && master.meta.find && master.meta.length > 0 && master.meta.find(function (meta) {
	            return 'Duration' === meta.name;
	        });
	        var listItem = 'openDownload' !== shareMode && !('auth' === shareMode && isAuthenticated) ? _react2['default'].createElement(
	            'div',
	            { className: 'listing__item' },
	            _react2['default'].createElement(_componentsThumb2['default'], { className: 'item__preview', media: this.props.item, onClickOpenModal: true, isSharedItem: true }),
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__info' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'info__top' },
	                    _react2['default'].createElement(
	                        'h4',
	                        { className: 'top__title', style: { paddingLeft: 'auth' === shareMode || 'openDownload' === shareMode || 'noAuth' === shareMode && isAuthenticated ? null : '0' } },
	                        item.title
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'item__description' },
	                    (0, _lodashStringTrunc2['default'])(item.description, 120)
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'item__additional' },
	                    item.additionalText
	                )
	            )
	        ) : _react2['default'].createElement(
	            'div',
	            { className: 'basket__item' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__image' },
	                _react2['default'].createElement(_componentsThumb2['default'], { className: 'item__preview', media: this.props.item, onClickOpenModal: true, isSharedItem: true })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__description' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'description__title' },
	                    item.title.length ? item.title : '&nbsp;'
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'description__meta' },
	                    MICode && MICode.value.length > 0 && _react2['default'].createElement(
	                        'span',
	                        { className: 'meta__id' },
	                        MICode.value
	                    ),
	                    duration && duration.value.length > 0 && _react2['default'].createElement(
	                        'span',
	                        { className: 'meta__duration' },
	                        duration.value
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'description__download' },
	                    _react2['default'].createElement(
	                        'form',
	                        null,
	                        _react2['default'].createElement(
	                            'table',
	                            null,
	                            _react2['default'].createElement(
	                                'thead',
	                                null,
	                                _react2['default'].createElement(
	                                    'th',
	                                    { className: 'download__head--checkbox' },
	                                    ' '
	                                ),
	                                _react2['default'].createElement(
	                                    'th',
	                                    null,
	                                    _utilsFlux2['default'].t('download_file_format')
	                                ),
	                                _react2['default'].createElement(
	                                    'th',
	                                    null,
	                                    _utilsFlux2['default'].t('download_file_mimetype')
	                                ),
	                                _react2['default'].createElement(
	                                    'th',
	                                    null,
	                                    _utilsFlux2['default'].t('download_file_size')
	                                )
	                            ),
	                            _react2['default'].createElement(
	                                'tbody',
	                                null,
	                                item.files.map(function (file) {
	                                    var dimensions = file.meta && file.meta.length > 0 && file.meta.find(function (meta) {
	                                        return !meta.hidden && 'Dimensions' === meta.name;
	                                    });
	                                    return _react2['default'].createElement(
	                                        'tr',
	                                        { key: 'i-' + item.id + '-' + file.key },
	                                        _react2['default'].createElement(
	                                            'td',
	                                            { className: 'file__key download__body--checkbox' },
	                                            _react2['default'].createElement(
	                                                'div',
	                                                { className: 'field__checkbox download__checkbox' },
	                                                _react2['default'].createElement('input', { id: 'check__all', checked: file._download, type: 'checkbox', readOnly: true }),
	                                                _react2['default'].createElement(
	                                                    'label',
	                                                    { onClick: _this2.toggleCheck.bind(null, file.name), htmlFor: 'check__all' },
	                                                    file.name
	                                                )
	                                            )
	                                        ),
	                                        _react2['default'].createElement(
	                                            'td',
	                                            { className: 'file__dimensions' },
	                                            dimensions && dimensions.value
	                                        ),
	                                        _react2['default'].createElement(
	                                            'td',
	                                            { className: 'file__mimetype' },
	                                            file.mimeType
	                                        ),
	                                        _react2['default'].createElement(
	                                            'td',
	                                            { className: 'file__size' },
	                                            (0, _prettyBytes2['default'])(file.size)
	                                        )
	                                    );
	                                })
	                            )
	                        )
	                    )
	                )
	            )
	        );
	
	        return listItem;
	    }
	});
	
	module.exports = ShareItem;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var ShareItemRestricted = _react2['default'].createClass({
	    displayName: 'ShareItemRestricted',
	    propTypes: {
	        item: _react2['default'].PropTypes.object
	    },
	    getInitialState: function getInitialState() {
	        return {
	            isRequestingAccess: false
	        };
	    },
	    requestAccess: function requestAccess(e) {
	        var _this = this;
	
	        e.preventDefault();
	        var item = this.props.item;
	        if (!item.get('access_requested')) {
	            this.setState({ isRequestingAccess: true });
	            _utilsFlux2['default'].getStore('share').requestAccess({ media_id: item.get('id') }).always(function () {
	                _this.setState({ isRequestingAccess: false });
	            });
	        }
	    },
	    render: function render() {
	        var item = this.props.item.toJSON();
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'listing__item listing__item--restricted' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__preview item__preview--restricted' },
	                _react2['default'].createElement('i', { className: 'lock' })
	            ),
	            _react2['default'].createElement(
	                'div',
	                { className: 'item__info' },
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'info__top' },
	                    _react2['default'].createElement(
	                        'h4',
	                        { className: 'top__title' },
	                        _utilsFlux2['default'].t('restricted_asset_title')
	                    )
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'item__description' },
	                    _utilsFlux2['default'].t('restricted_asset_description')
	                ),
	                _react2['default'].createElement(
	                    'div',
	                    { className: 'listing__item--restricted__cta' },
	                    !item.access_requested && _react2['default'].createElement(
	                        'button',
	                        { disabled: this.state.isRequestingAccess, onClick: this.requestAccess, className: 'btn' },
	                        _utilsFlux2['default'].t('restricted_asset_cta')
	                    ),
	                    item.access_requested && _utilsFlux2['default'].t('restricted_asset_access_requested')
	                )
	            )
	        );
	    }
	});
	
	module.exports = ShareItemRestricted;

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var ShareSidebar = _react2['default'].createClass({
	
	    displayName: 'ShareSidebar',
	
	    propTypes: {
	        baskets: _react2['default'].PropTypes.object.isRequired,
	        shareId: _react2['default'].PropTypes.string
	    },
	
	    render: function render() {
	        var _this = this;
	
	        var baskets = this.props.baskets.toJS();
	        var user = this.props.user.toJS();
	
	        return _react2['default'].createElement(
	            'div',
	            { className: 'share__sidebar' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'sidebar__user' },
	                user.firstName,
	                _react2['default'].createElement('br', null),
	                _react2['default'].createElement(
	                    'span',
	                    { className: 'user__email' },
	                    '(',
	                    user.email,
	                    ')'
	                ),
	                _react2['default'].createElement('br', null),
	                _utilsFlux2['default'].t('shared_selections_with')
	            ),
	            _react2['default'].createElement(
	                'ul',
	                { className: 'sidebar__menu' },
	                baskets.map(function (basket) {
	                    return _react2['default'].createElement(
	                        'li',
	                        { key: basket.id, className: 'menu__item' },
	                        _react2['default'].createElement(
	                            _reactRouter.Link,
	                            { className: 'item__link', to: 'shared', params: { shareId: _this.props.shareId, basketId: basket.id } },
	                            basket.name,
	                            ' (',
	                            basket.items.length,
	                            ')'
	                        )
	                    );
	                })
	            )
	        );
	    }
	});
	
	module.exports = ShareSidebar;

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _altContainer = __webpack_require__(21);
	
	var _altContainer2 = _interopRequireDefault(_altContainer);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var _componentsSpinnerSpinner = __webpack_require__(48);
	
	var _componentsSpinnerSpinner2 = _interopRequireDefault(_componentsSpinnerSpinner);
	
	var TermsPage = _react2['default'].createClass({
	    displayName: 'TermsPage',
	    mixins: [],
	    propTypes: {},
	    componentWillMount: function componentWillMount() {
	        _utilsFlux2['default'].getStore('app').loadTerms();
	    },
	    render: function render() {
	        var appStore = _utilsFlux2['default'].getStore('app');
	        var modalStore = _utilsFlux2['default'].getStore('modals');
	        return _react2['default'].createElement(
	            'div',
	            { className: 'page terms' },
	            _react2['default'].createElement(
	                'div',
	                { className: 'container--centered' },
	                _react2['default'].createElement(_altContainer2['default'], { stores: { appStore: appStore, modalStore: modalStore },
	                    render: function (props) {
	                        if (modalStore.getState().loading) {
	                            return _react2['default'].createElement(_componentsSpinnerSpinner2['default'], null);
	                        }
	                        if (!props.appStore.terms) {
	                            return false;
	                        }
	                        return _react2['default'].createElement('div', { dangerouslySetInnerHTML: _utilsDom2['default'].setInnerHtml(props.appStore.terms) });
	                    } })
	            )
	        );
	    }
	});
	
	module.exports = TermsPage;

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(7);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _pagesApp = __webpack_require__(491);
	
	var _pagesApp2 = _interopRequireDefault(_pagesApp);
	
	var _pagesNotFound = __webpack_require__(518);
	
	var _pagesNotFound2 = _interopRequireDefault(_pagesNotFound);
	
	var _pagesRedirect = __webpack_require__(520);
	
	var _pagesRedirect2 = _interopRequireDefault(_pagesRedirect);
	
	var _pagesLoginLoginIndex = __webpack_require__(504);
	
	var _pagesLoginLoginIndex2 = _interopRequireDefault(_pagesLoginLoginIndex);
	
	var _pagesAcceptTermsTermsIndex = __webpack_require__(487);
	
	var _pagesAcceptTermsTermsIndex2 = _interopRequireDefault(_pagesAcceptTermsTermsIndex);
	
	var _pagesResetPassword = __webpack_require__(521);
	
	var _pagesResetPassword2 = _interopRequireDefault(_pagesResetPassword);
	
	var _pagesConfirmEmail = __webpack_require__(495);
	
	var _pagesConfirmEmail2 = _interopRequireDefault(_pagesConfirmEmail);
	
	var _pagesMedia = __webpack_require__(507);
	
	var _pagesMedia2 = _interopRequireDefault(_pagesMedia);
	
	var _pagesMediaMediaListing = __webpack_require__(512);
	
	var _pagesMediaMediaListing2 = _interopRequireDefault(_pagesMediaMediaListing);
	
	var _pagesMediaMediaLandingPage = __webpack_require__(511);
	
	var _pagesMediaMediaLandingPage2 = _interopRequireDefault(_pagesMediaMediaLandingPage);
	
	var _pagesBasket = __webpack_require__(494);
	
	var _pagesBasket2 = _interopRequireDefault(_pagesBasket);
	
	var _pagesLicensingListing = __webpack_require__(498);
	
	var _pagesLicensingListing2 = _interopRequireDefault(_pagesLicensingListing);
	
	var _pagesLicensingRequests = __webpack_require__(501);
	
	var _pagesLicensingRequests2 = _interopRequireDefault(_pagesLicensingRequests);
	
	var _pagesShare = __webpack_require__(523);
	
	var _pagesShare2 = _interopRequireDefault(_pagesShare);
	
	var _pagesAccount = __webpack_require__(490);
	
	var _pagesAccount2 = _interopRequireDefault(_pagesAccount);
	
	var _pagesAccountAccountEdit = __webpack_require__(488);
	
	var _pagesAccountAccountEdit2 = _interopRequireDefault(_pagesAccountAccountEdit);
	
	var _pagesAccountAccountPassword = __webpack_require__(489);
	
	var _pagesAccountAccountPassword2 = _interopRequireDefault(_pagesAccountAccountPassword);
	
	var _pagesHelp = __webpack_require__(496);
	
	var _pagesHelp2 = _interopRequireDefault(_pagesHelp);
	
	var _pagesTerms = __webpack_require__(527);
	
	var _pagesTerms2 = _interopRequireDefault(_pagesTerms);
	
	var _pagesPrivacyPolicy = __webpack_require__(519);
	
	var _pagesPrivacyPolicy2 = _interopRequireDefault(_pagesPrivacyPolicy);
	
	var _pagesImprint = __webpack_require__(497);
	
	var _pagesImprint2 = _interopRequireDefault(_pagesImprint);
	
	var _pagesSamlError = __webpack_require__(522);
	
	var _pagesSamlError2 = _interopRequireDefault(_pagesSamlError);
	
	var appStore = _utilsFlux2['default'].getStore('app');
	
	var _appStore$getState = appStore.getState();
	
	var config = _appStore$getState.config;
	
	var _config$toJS = config.toJS();
	
	var disableChangePassword = _config$toJS.disableChangePassword;
	var disableAccountDetails = _config$toJS.disableAccountDetails;
	var accountEditable = appStore.accountEditable;
	var passwordEditable = appStore.passwordEditable;
	
	if (!!config.get("samlLogin") || !!config.get("noneLogin")) {
	    var href = window.location.href;
	    console.log("href in routes.jsx: ", href);
	    appStore.doMediaboxForward();
	    appStore.setMediaboxForward(href);
	    console.log("set mediaboxForward in routes.jsx");
	}
	
	var routes = _react2['default'].createElement(
	    _reactRouter.Route,
	    { handler: _pagesApp2['default'] },
	    _react2['default'].createElement(_reactRouter.Route, { name: 'login', path: 'login', handler: _pagesLoginLoginIndex2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { name: 'accept_terms', path: 'accept_terms', handler: _pagesAcceptTermsTermsIndex2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { name: 'reset_password', path: 'reset_password/:secret', handler: _pagesResetPassword2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { name: 'confirm_email', path: 'confirm_email', handler: _pagesConfirmEmail2['default'] }),
	    _react2['default'].createElement(
	        _reactRouter.Route,
	        { name: 'listing', path: 'media', handler: _pagesMedia2['default'] },
	        _react2['default'].createElement(_reactRouter.DefaultRoute, { handler: _pagesMediaMediaListing2['default'] })
	    ),
	    _react2['default'].createElement(
	        _reactRouter.Route,
	        { name: 'landing-page', path: 'home', handler: _pagesMedia2['default'] },
	        _react2['default'].createElement(_reactRouter.DefaultRoute, { handler: _pagesMediaMediaLandingPage2['default'] })
	    ),
	    _react2['default'].createElement(
	        _reactRouter.Route,
	        { name: 'basket', path: 'baskets', handler: _pagesBasket2['default'] },
	        _react2['default'].createElement(_reactRouter.Route, { name: 'singleBasket', path: ':id', handler: _pagesBasket2['default'] })
	    ),
	    _react2['default'].createElement(_reactRouter.Route, { name: 'shared', path: 'shared/:shareId/:basketId', handler: _pagesShare2['default'] }),
	    config.get('licensing') && _react2['default'].createElement(
	        _reactRouter.Route,
	        { name: 'licensing', path: 'licensing', handler: _pagesLicensingListing2['default'] },
	        _react2['default'].createElement(_reactRouter.Route, { name: 'singleLicensing', path: ':id', handler: _pagesLicensingListing2['default'] })
	    ),
	    config.get('licensing') && _react2['default'].createElement(_reactRouter.Route, { name: 'requests', path: 'requests', handler: _pagesLicensingRequests2['default'] }),
	    _react2['default'].createElement(
	        _reactRouter.Route,
	        { name: 'account', path: 'account', handler: _pagesAccount2['default'] },
	        false !== accountEditable && !disableAccountDetails && _react2['default'].createElement(_reactRouter.Route, { name: 'accountDetails', path: 'details', handler: _pagesAccountAccountEdit2['default'] }),
	        false !== passwordEditable && !disableChangePassword && _react2['default'].createElement(_reactRouter.Route, { name: 'accountPassword', path: 'password', handler: _pagesAccountAccountPassword2['default'] }),
	        !disableAccountDetails && _react2['default'].createElement(_reactRouter.DefaultRoute, { handler: false !== accountEditable ? _pagesAccountAccountEdit2['default'] : _pagesAccount2['default'] })
	    ),
	    _react2['default'].createElement(_reactRouter.Route, { name: 'help', path: 'help', handler: _pagesHelp2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { name: 'terms', path: 'terms-of-use', handler: _pagesTerms2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { name: 'privacy', path: 'privacy-policy', handler: _pagesPrivacyPolicy2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { name: 'imprint', path: 'imprint', handler: _pagesImprint2['default'] }),
	    _react2['default'].createElement(_reactRouter.Route, { name: 'saml_error', path: 'saml-error', handler: _pagesSamlError2['default'] }),
	    _react2['default'].createElement(_reactRouter.NotFoundRoute, { handler: _pagesNotFound2['default'] }),
	    _react2['default'].createElement(_reactRouter.DefaultRoute, { handler: _pagesRedirect2['default'] })
	);
	
	exports['default'] = routes;
	module.exports = exports['default'];

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	// Base64 polyfill
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _Base64 = __webpack_require__(433);
	
	var _Base642 = _interopRequireDefault(_Base64);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _utilsDom = __webpack_require__(32);
	
	var _utilsDom2 = _interopRequireDefault(_utilsDom);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodash = __webpack_require__(109);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _jsCookie = __webpack_require__(161);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var _utilsMb_consts = __webpack_require__(275);
	
	var _utilsMb_consts2 = _interopRequireDefault(_utilsMb_consts);
	
	var AppSource = function AppSource(alt) {
	    return {
	        loginUser: {
	            remote: function remote(state, user) {
	                return _utilsApi2['default'].post('login', user);
	            },
	            success: alt.getActions('app').loginUserSuccess,
	            error: alt.getActions('app').onError
	        },
	        logoutUser: {
	            remote: function remote(state, user) {
	                if (!state.inLogout) {
	                    state.inLogout = true;
	                    var token = _store2['default'].get('mediabox_token');
	                    return _utilsApi2['default'].post('logout', { token: token }, alt.getActions('app').logoutUserSuccess);
	                }
	            },
	            success: alt.getActions('app').logoutUserSuccess,
	            error: alt.getActions('app').onError
	        },
	        acceptTerms: {
	            remote: function remote(state, data) {
	                return _utilsApi2['default'].post('user', data);
	            },
	            success: alt.getActions('app').acceptTermsSuccess,
	            error: alt.getActions('app').onError
	        },
	        registerUser: {
	            remote: function remote(state, data) {
	                return _utilsApi2['default'].post('register', data);
	            },
	            success: alt.getActions('app').registerUserSuccess,
	            error: alt.getActions('app').onError
	        },
	        resetPassword: {
	            remote: function remote(state, data) {
	                return _utilsApi2['default'].post('reset_password', data);
	            },
	            success: alt.getActions('app').resetPasswordSuccess,
	            error: alt.getActions('app').onError
	        },
	        updatePassword: {
	            remote: function remote(state, data) {
	                return _utilsApi2['default'].post('change_password', data);
	            },
	            success: alt.getActions('app').updatePasswordSuccess,
	            error: alt.getActions('app').onError
	        },
	        confirmEmail: {
	            remote: function remote(state, data) {
	                return _utilsApi2['default'].post('confirm_email', data);
	            },
	            success: alt.getActions('app').confirmEmailSuccess,
	            error: alt.getActions('app').onError
	        },
	        loadAccountData: {
	            remote: function remote() {
	                return _utilsApi2['default'].get('user');
	            },
	            success: alt.getActions('app').loadAccountDataSuccess,
	            error: alt.getActions('app').onError
	        },
	        updateAccountData: {
	            remote: function remote(state, data) {
	                return _utilsApi2['default'].post('edit_user', data).then(function () {
	                    return _utilsApi2['default'].get('user').then(alt.getActions('app').loadAccountDataSuccess);
	                });
	            },
	            success: alt.getActions('app').noop,
	            error: alt.getActions('app').onError
	        },
	        bootstrap: {
	            remote: function remote() {
	                return _utilsApi2['default'].get('bootstrap');
	            },
	            success: alt.getActions('app').bootstrapRegisterFormSuccess,
	            error: alt.getActions('app').onError
	        },
	        loadTerms: {
	            local: function local(state) {
	                return state.terms;
	            },
	            remote: function remote() {
	                return _utilsApi2['default'].getHtml('terms-of-use');
	            },
	            success: alt.getActions('app').loadTermsSuccess,
	            error: alt.getActions('app').onError
	        },
	        loadPrivacy: {
	            local: function local(state) {
	                return state.privacy;
	            },
	            remote: function remote() {
	                return _utilsApi2['default'].getHtml('privacy-policy');
	            },
	            success: alt.getActions('app').loadPrivacySuccess,
	            error: alt.getActions('app').onError
	        },
	        loadImprint: {
	            local: function local(state) {
	                return state.imprint;
	            },
	            remote: function remote() {
	                return _utilsApi2['default'].getHtml('imprint');
	            },
	            success: alt.getActions('app').loadImprintSuccess,
	            error: alt.getActions('app').onError
	        }
	    };
	};
	
	var AppStore = (function () {
	    function AppStore() {
	        _classCallCheck(this, AppStore);
	
	        this.bindActions(this.alt.getActions('app'));
	        this.registerAsync(AppSource);
	        this.exportPublicMethods({
	            logout: this.onLogout,
	            setMediaboxForward: this.setMediaboxForward,
	            doMediaboxForward: this.doMediaboxForward
	        });
	
	        if (window.config.samlLogin) {
	            _store2['default'].set('mediabox_saml_login', true);
	        } else {
	            _store2['default'].set('mediabox_saml_login', false);
	        }
	
	        if (window.config.noneLogin) {
	            _store2['default'].set('mediabox_none_login', true);
	        } else {
	            _store2['default'].set('mediabox_none_login', false);
	        }
	
	        if (window.config.hideRegistration) {
	            _store2['default'].set('mediabox_hide_registration', true);
	        } else {
	            _store2['default'].set('mediabox_hide_registration', false);
	        }
	
	        if (_jsCookie2['default'].get('basicauth_token') !== undefined) {
	            if (!window.config.showTermsOfUse) {
	                _store2['default'].set('mediabox_terms_accepted', true);
	            }
	            _store2['default'].set('mediabox_token', _jsCookie2['default'].get('basicauth_token'));
	        }
	
	        this.termsAccepted = _store2['default'].get('mediabox_terms_accepted');
	        this.token = _jsCookie2['default'].get('basicauth_token') || _store2['default'].get('mediabox_token');
	        this.user = _store2['default'].get('mediabox_user');
	        this.branding = _store2['default'].get('mediabox_branding');
	        this.accountEditable = _store2['default'].get('mediabox_account_editable');
	        this.passwordEditable = _store2['default'].get('mediabox_password_editable');
	        this.hideFilters = _store2['default'].get('mediabox_hideFilters');
	        this.samlLogin = _store2['default'].get('mediabox_saml_login');
	        this.noneLogin = _store2['default'].get('mediabox_none_login');
	        this.hideRegistration = _store2['default'].get('mediabox_hide_registration');
	        this.mediaboxForward = _store2['default'].get('mediabox_forward_to');
	        this.inLogout = false;
	        this.mediaboxRights = _store2['default'].get('mediabox_rights');
	        this.excel_rights = _store2['default'].get('excel_rights');
	
	        if (this.token) {
	            _utilsApi2['default'].registerToken(this.token);
	        }
	
	        var buildConfig = 'production' === ("production") && __webpack_require__(484) || {};
	        this.config = _immutable2['default'].fromJS((0, _lodash.assign)({}, window.config, buildConfig));
	
	        this.error = false;
	        this.accountData = false;
	        this.terms = null;
	        this.registerForm = null;
	    }
	
	    _createClass(AppStore, [{
	        key: 'onError',
	        value: function onError(err) {
	            this.inLogout = false;
	            err = JSON.parse(err.response);
	            this.error = err.message;
	        }
	    }, {
	        key: 'onClearError',
	        value: function onClearError() {
	            this.error = null;
	        }
	    }, {
	        key: 'onAcceptTermsSuccess',
	        value: function onAcceptTermsSuccess(data) {
	            _store2['default'].set('mediabox_terms_accepted', true);
	            this.termsAccepted = true;
	        }
	    }, {
	        key: 'onLoginUserSuccess',
	        value: function onLoginUserSuccess(data) {
	            var access_token = data.access_token;
	            var full_name = data.full_name;
	            var account_editable = data.account_editable;
	            var password_editable = data.password_editable;
	            var termsAccepted = data.termsAccepted;
	            var branding = data.branding;
	            var hideFilters = data.hideFilters;
	            var language = data.language;
	            var mediabox_rights = data.mediabox_rights;
	            var excel_rights = data.excel_rights;
	
	            _store2['default'].set('mediabox_terms_accepted', termsAccepted);
	            _store2['default'].set('mediabox_token', access_token);
	            _store2['default'].set('mediabox_user', full_name);
	            _store2['default'].set('mediabox_branding', branding);
	            _store2['default'].set(_utilsMb_consts2['default'].STORE_LANGUAGE_KEY, language);
	            _store2['default'].set('mediabox_account_editable', account_editable);
	            _store2['default'].set('mediabox_password_editable', password_editable);
	            _store2['default'].set('mediabox_hideFilters', hideFilters);
	            _store2['default'].set('_CSRF', data._CSRF);
	            _store2['default'].set('mediabox_rights', mediabox_rights);
	            _store2['default'].set('excel_rights', excel_rights);
	
	            this.termsAccepted = termsAccepted;
	            this.token = access_token;
	            this.user = full_name;
	            this.accountEditable = account_editable;
	            this.passwordEditable = password_editable;
	            this.branding = branding;
	            this.hideFilters = hideFilters;
	            this.error = false;
	            this.inLogout = false;
	            this.mediaboxRights = mediabox_rights;
	            this.excel_rights = excel_rights;
	
	            _utilsApi2['default'].registerToken(this.token);
	        }
	    }, {
	        key: 'onLoadAccountDataSuccess',
	        value: function onLoadAccountDataSuccess(data) {
	            this.error = false;
	            this.accountData = data;
	        }
	    }, {
	        key: 'noop',
	        value: function noop() {}
	    }, {
	        key: 'onLoadTermsSuccess',
	        value: function onLoadTermsSuccess(terms) {
	            this.terms = terms;
	        }
	    }, {
	        key: 'onLoadPrivacySuccess',
	        value: function onLoadPrivacySuccess(privacy) {
	            this.privacy = privacy;
	        }
	    }, {
	        key: 'onLoadImprintSuccess',
	        value: function onLoadImprintSuccess(imprint) {
	            this.imprint = imprint;
	        }
	    }, {
	        key: 'onBootstrapRegisterFormSuccess',
	        value: function onBootstrapRegisterFormSuccess(registerForm) {
	            this.registerForm = registerForm;
	        }
	    }, {
	        key: 'onLogout',
	        value: function onLogout() {
	            _utilsFlux2['default'].getStore('app').logoutUser();
	        }
	    }, {
	        key: 'onLogoutUserSuccess',
	        value: function onLogoutUserSuccess() {
	            this.token = null;
	            this.user = null;
	            this.inLogout = false;
	
	            _utilsApi2['default'].removeToken();
	            var userLocale = _store2['default'].get(_utilsMb_consts2['default'].STORE_LANGUAGE_KEY);
	            _store2['default'].clear();
	            _jsCookie2['default'].remove('basicauth_token');
	            _store2['default'].set(_utilsMb_consts2['default'].STORE_LANGUAGE_KEY, userLocale);
	
	            // empty caches
	            _utilsFlux2['default'].getStore('media').state._cache = {};
	
	            if (arguments.length > 0 && !!arguments[0].redirect) {
	                window.location = arguments[0].redirect;
	            } else {
	                window.location = location.protocol + '//' + location.host;
	            }
	        }
	    }, {
	        key: 'setMediaboxForward',
	        value: function setMediaboxForward(mediaboxForward) {
	            if (this.state.token === undefined) {
	                this.mediaboxForward = mediaboxForward;
	                _store2['default'].set('mediabox_forward_to', mediaboxForward);
	                console.log("mediaboxForward in store set to: ", this.mediaboxForward);
	            } else {
	                this.mediaboxForward = undefined;
	                _store2['default'].remove('mediabox_forward_to');
	                console.log("mediaboxForward nulled out in store");
	            }
	        }
	    }, {
	        key: 'doMediaboxForward',
	        value: function doMediaboxForward() {
	            this.mediaboxForward = _store2['default'].get('mediabox_forward_to');
	            console.log("got from store: ", this.mediaboxForward);
	
	            if (this.mediaboxForward !== undefined) {
	                console.log("going to window.location redirect", this.mediaboxForward);
	                window.location = this.mediaboxForward;
	            }
	
	            return this.mediaboxForward;
	        }
	    }], [{
	        key: 'toggleOffcanvas',
	        value: function toggleOffcanvas() {
	            var bodyEl = document.getElementsByTagName('body')[0];
	            _utilsDom2['default'].toggleClass(bodyEl, 'offcanvas--active');
	        }
	    }, {
	        key: 'closeOffcanvas',
	        value: function closeOffcanvas() {
	            var bodyEl = document.getElementsByTagName('body')[0];
	            _utilsDom2['default'].removeClass(bodyEl, 'offcanvas--active');
	        }
	    }, {
	        key: 'isAuthenticated',
	        value: function isAuthenticated() {
	            var _getState = this.getState();
	
	            var token = _getState.token;
	
	            if (!token) {
	                return false;
	            }
	            return true;
	        }
	    }, {
	        key: 'isNoneLogin',
	        value: function isNoneLogin() {
	            var _getState2 = this.getState();
	
	            var noneLogin = _getState2.noneLogin;
	
	            return noneLogin;
	        }
	    }, {
	        key: 'isSamlLogin',
	        value: function isSamlLogin() {
	            var _getState3 = this.getState();
	
	            var samlLogin = _getState3.samlLogin;
	
	            return samlLogin;
	        }
	    }, {
	        key: 'hasAcceptedLatestTerms',
	        value: function hasAcceptedLatestTerms() {
	            var _getState4 = this.getState();
	
	            var termsAccepted = _getState4.termsAccepted;
	
	            return termsAccepted;
	        }
	    }]);
	
	    return AppStore;
	})();
	
	exports['default'] = AppStore;
	module.exports = exports['default'];

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodashArrayFlatten = __webpack_require__(226);
	
	var _lodashArrayFlatten2 = _interopRequireDefault(_lodashArrayFlatten);
	
	var _lodashArrayUniq = __webpack_require__(762);
	
	var _lodashArrayUniq2 = _interopRequireDefault(_lodashArrayUniq);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _jsCookie = __webpack_require__(161);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var BasketSource = function BasketSource(alt) {
	    return {
	        loadBaskets: {
	            remote: function remote(state, basketId) {
	                return _utilsApi2['default'].get('baskets').then(function (baskets) {
	                    return { baskets: baskets, basketId: basketId };
	                });
	            },
	            success: alt.getActions('basket').loadBasketsSuccess,
	            error: alt.getActions('basket').loadError
	        },
	        loadBasket: {
	            local: function local(state, basketId) {
	                if (basketId) {
	                    var basketExits = state.baskets.findIndex(function (basket) {
	                        return basketId === basket.get('id') && basket.detailled;
	                    });
	
	                    if (basketExits !== -1) {
	                        var basket = state.baskets.findByIndex(basketExits);
	                        alt.getActions('basket').loadBasketSuccess({
	                            basket: basket
	                        });
	
	                        return true;
	                    }
	                }
	            },
	            remote: function remote(state, basketId) {
	                if (basketId) {
	                    return _utilsApi2['default'].get('basket' + '/' + basketId).then(function (basket) {
	                        return { basket: basket };
	                    });
	                }
	            },
	            success: alt.getActions('basket').loadBasketSuccess,
	            error: alt.getActions('basket').loadError
	        },
	        addToBasket: {
	            remote: function remote(state, payload) {
	                var basket = payload.basket;
	                var media = payload.media;
	
	                media = !Array.isArray(media) ? [media] : media;
	                return _utilsApi2['default'].post('basket/' + basket.id, media).then(function (data) {
	                    return {
	                        basket: data,
	                        media: media
	                    };
	                });
	            },
	            success: alt.getActions('basket').addToBasketSuccess,
	            error: alt.getActions('basket').loadError
	        },
	        createBasket: {
	            remote: function remote(state, media) {
	                var basketName = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];
	
	                var ids = media.map(function (m) {
	                    return { id: m.id };
	                });
	                var payload = {
	                    media: ids
	                };
	                if (basketName) {
	                    payload.name = basketName;
	                }
	                return _utilsApi2['default'].post('baskets/create', payload).then(function (data) {
	                    if (data.error) {
	                        return {
	
	                            media: media
	                        };
	                    } else {
	                        return {
	                            newBasket: data.filter(function (basket) {
	                                return basket.isNew;
	                            })[0],
	                            media: media
	                        };
	                    }
	                });
	            },
	            success: alt.getActions('basket').createBasketSuccess,
	            error: alt.getActions('basket').loadError
	        },
	
	        //
	        // Edt a baskets name
	        editBasketName: {
	            remote: function remote(state, basketId, basketName) {
	                return _utilsApi2['default'].post('baskets/edit', {
	                    id: basketId,
	                    name: basketName
	                }).then(function (result) {
	                    return { basketId: result.id, basketName: result.name };
	                });
	            },
	            success: alt.getActions('basket').editBasketNameSuccess,
	            error: alt.getActions('basket').loadError
	        },
	
	        //
	        // Share a basket
	        shareBaskets: {
	            local: function local() {
	                alt.getActions('basket').resetShareUrl();
	                return null;
	            },
	            remote: function remote(state, basketIds) {
	                return _utilsApi2['default'].post('share', {
	                    basket_ids: basketIds
	                });
	            },
	            success: alt.getActions('basket').shareBasketsSuccess,
	            error: alt.getActions('basket').loadError
	        },
	
	        //
	        // Request License
	        requestLicensing: {
	            remote: function remote(state, basketId, requests) {
	                return _utilsApi2['default'].post('basket/' + basketId + '/request_licence', {
	                    requests: requests
	                });
	            },
	            success: alt.getActions('basket').requestLicensingSuccess,
	            error: alt.getActions('basket').loadError
	        },
	
	        //
	        // Delete a single basket
	        deleteBasketItem: {
	            remote: function remote(state, mediaId) {
	                return _utilsApi2['default'].post('baskets/delete/' + state.basket.get('id') + '/' + mediaId);
	            },
	            success: alt.getActions('basket').deleteBasketItemSuccess,
	            error: alt.getActions('basket').loadError
	        },
	
	        //
	        // Delete multiple baskets
	        deleteBaskets: {
	            remote: function remote(state, basketIds) {
	                return Promise.all(basketIds.map(function (basketId) {
	                    return _utilsApi2['default'].post('baskets/delete/' + basketId);
	                })).then(function () {
	                    return basketIds;
	                });
	            },
	            success: alt.getActions('basket').deleteBasketsSuccess,
	            error: alt.getActions('basket').loadError
	        },
	
	        excelSearch: {
	            remote: function remote(state, formData) {
	                return _utilsApi2['default'].upload('baskets/excelsearch', formData).then(function (data) {
	                    return data;
	                });
	            },
	            success: alt.getActions('basket').excelSearchSuccess,
	            error: alt.getActions('basket').excelSearchError
	        }
	    };
	};
	
	var BasketStore = (function () {
	    function BasketStore() {
	        _classCallCheck(this, BasketStore);
	
	        this.bindActions(this.alt.getActions('basket'));
	        this.registerAsync(BasketSource);
	
	        this.baskets = _immutable2['default'].fromJS([]);
	        this.basket = _immutable2['default'].fromJS({});
	        this.slotDefinitions = _immutable2['default'].fromJS([]);
	        this.shareUrl = null;
	        this.activeBasketId = null;
	        this.excelError = null;
	    }
	
	    _createClass(BasketStore, [{
	        key: 'onLoadBasketsSuccess',
	        value: function onLoadBasketsSuccess(data) {
	            var baskets = data.baskets;
	            var basketId = data.basketId;
	
	            this.baskets = _immutable2['default'].fromJS(baskets);
	            basketId = this.checkBasketId(basketId);
	
	            if (basketId) {
	                this._setActiveBasketId(basketId);
	            }
	        }
	    }, {
	        key: 'onLoadBasketSuccess',
	        value: function onLoadBasketSuccess(data) {
	            var index = this.baskets.findIndex(function (b) {
	                return data.basket.id === b.get('id');
	            });
	            if (index !== -1) {
	                var basketId = data.basket.id;
	                data.basket.detailled = true;
	                var foundBasket = this.baskets.filter(function (basket) {
	                    return basketId === basket.get('id');
	                }).first();
	                this.slotDefinitions = foundBasket.get("slot_definitions");
	                this.baskets = this.baskets.map(function (obj, i) {
	                    return index === i ? _immutable2['default'].fromJS(data.basket) : obj;
	                });
	                basketId = this.checkBasketId(basketId);
	                this.basket = this.baskets.filter(function (basket) {
	                    return basketId === basket.get('id');
	                }).first();
	
	                if (this.basket) {
	                    this.basket = this._prepareBasketItem(this.basket);
	                    this.basket = this._prepareBasketItemWithFileName(this.basket);
	                } else {
	                    this.basket = _immutable2['default'].fromJS({});
	                }
	
	                this._setActiveBasketId(basketId);
	                this.onToggleBasketSelection(basketId);
	            }
	        }
	    }, {
	        key: 'checkBasketId',
	        value: function checkBasketId(basketId) {
	            if (basketId) {
	                return basketId;
	            }
	            if (this.basket.get('id')) {
	                return this.basket.get('id');
	            }
	            if (this.baskets.size > 0) {
	                return this.baskets.last().get('id');
	            }
	            return null;
	        }
	    }, {
	        key: '_prepareBasketItem',
	        value: function _prepareBasketItem(basket) {
	            var files = (0, _lodashArrayFlatten2['default'])(basket.toJS().items.map(function (item) {
	                return item.files;
	            })).map(function (file) {
	                return { key: file.key, name: file.name };
	            });
	            this._setActiveBasketId(basket.get('id'));
	            return basket.set('_filekeys', _immutable2['default'].fromJS((0, _lodashArrayUniq2['default'])(files, 'key')));
	        }
	    }, {
	        key: '_prepareBasketItemWithFileName',
	        value: function _prepareBasketItemWithFileName(basket) {
	            var files = (0, _lodashArrayFlatten2['default'])(basket.toJS().items.map(function (item) {
	                return item.files;
	            })).map(function (file) {
	                return { key: file.key, name: file.name };
	            });
	
	            this._setActiveBasketId(basket.get('id'));
	            return basket.set('_filenames', _immutable2['default'].fromJS((0, _lodashArrayUniq2['default'])(files, 'name')));
	        }
	    }, {
	        key: '_setActiveBasketId',
	        value: function _setActiveBasketId(basketId) {
	            this.activeBasketId = basketId;
	        }
	    }, {
	        key: 'onAddToBasketSuccess',
	        value: function onAddToBasketSuccess(result) {
	            var _this = this;
	
	            var media = result.media;
	            var basket = result.basket;
	
	            var ix = this.baskets.findIndex(function (item) {
	                return item.get('id') === basket.id;
	            });
	            this.baskets = this.baskets.updateIn([ix, 'items'], function () {
	                return _immutable2['default'].fromJS(basket.items);
	            });
	
	            // Set Last used Basket
	            this._setActiveBasketId(basket.id);
	
	            setTimeout(function () {
	                var notifications = _this._generateSuccessNotifications(media, basket.name);
	                _this.alt.getActions('notifications').addSuccessNotification(notifications);
	            }, 10);
	        }
	    }, {
	        key: '_generateSuccessNotifications',
	        value: function _generateSuccessNotifications(media, basketName) {
	            var _this2 = this;
	
	            // Add Success for Each item
	            return media.map(function (item) {
	                var text = _this2.alt.getStore('translations').getFormattedMessage('notification_add_to_basket_success', {
	                    mediaName: item.title || item.name,
	                    basketName: basketName
	                });
	                return {
	                    text: text,
	                    type: 'success',
	                    mediaId: item.id
	                };
	            });
	        }
	    }, {
	        key: 'onCreateBasketSuccess',
	        value: function onCreateBasketSuccess(result) {
	            var _this3 = this;
	
	            var media = result.media;
	            var newBasket = result.newBasket;
	
	            if (newBasket) {
	                this.baskets = this.baskets.push(_immutable2['default'].fromJS(newBasket));
	
	                // Set Last used Basket
	                this._setActiveBasketId(newBasket.id);
	                this.basket = this._prepareBasketItem(_immutable2['default'].fromJS(newBasket));
	
	                setTimeout(function () {
	                    var notifications = _this3._generateSuccessNotifications(media, newBasket.name);
	                    _this3.alt.getActions('notifications').addSuccessNotification(notifications);
	                }, 10);
	            }
	        }
	    }, {
	        key: 'createBasketError',
	        value: function createBasketError(result) {}
	    }, {
	        key: 'onEditBasketNameSuccess',
	        value: function onEditBasketNameSuccess(result) {
	            var basketId = result.basketId;
	            var basketName = result.basketName;
	
	            var ix = this.baskets.findIndex(function (item) {
	                return item.get('id') === basketId;
	            });
	            this.baskets = this.baskets.updateIn([ix, 'name'], function () {
	                return basketName;
	            });
	            this.basket = this.basket.updateIn(['name'], function () {
	                return basketName;
	            });
	        }
	    }, {
	        key: 'onDeleteBasketItemSuccess',
	        value: function onDeleteBasketItemSuccess(basket) {
	            _utilsFlux2['default'].getStore('basket').loadBasket(basket.id);
	        }
	    }, {
	        key: 'onResetShareUrl',
	        value: function onResetShareUrl() {
	            this.shareUrl = null;
	        }
	
	        // Dont want to duplicate Share modal, so we use already existing actions to set up shareurl
	    }, {
	        key: 'onSetShareUrlItem',
	        value: function onSetShareUrlItem(shareUrl) {
	            this.shareUrl = shareUrl;
	        }
	    }, {
	        key: 'onShareBasketsSuccess',
	        value: function onShareBasketsSuccess(shared) {
	            this.shareUrl = shared.fullurl;
	        }
	    }, {
	        key: 'onToggleDownload',
	        value: function onToggleDownload(result) {
	            var itemId = result.itemId;
	            var fileKey = result.fileKey;
	
	            var items = this.basket.get('items');
	            var itemIx = items.findIndex(function (item) {
	                return item.get('id') === itemId;
	            });
	
	            items = items.updateIn([itemIx, 'files'], function (files) {
	                var fileIx = files.findIndex(function (file) {
	                    return file.get('name') === fileKey;
	                });
	                return files.updateIn([fileIx], function (sfile) {
	                    return sfile.set('_download', !sfile.get('_download'));
	                });
	            });
	
	            this.basket = this.basket.set('items', items);
	        }
	
	        /**
	         * Toggles the "isSelected Flag" on a basket
	         * @param  {string} basketId
	         * @return {obj}
	         */
	    }, {
	        key: 'onToggleBasketSelection',
	        value: function onToggleBasketSelection(basketId) {
	            this.baskets = this.baskets.update(this.baskets.findIndex(function (item) {
	                return item.get('id') === basketId;
	            }), function (item) {
	                return item && item.set('isSelected', !item.get('isSelected'));
	            });
	        }
	
	        /**
	         * sets the text for a licensing request
	         */
	    }, {
	        key: 'onUpdateLicensingUsageText',
	        value: function onUpdateLicensingUsageText(data) {
	            var items = this.basket.get('items');
	            items = items.update(items.findIndex(function (item) {
	                return item.get('id') === data.itemId;
	            }), function (item) {
	                return item.set('_usageText', data.text);
	            });
	            this.basket = this.basket.set('items', items);
	        }
	
	        /**
	         * Marks a single item for licensing request
	         */
	    }, {
	        key: 'onToggleLicensing',
	        value: function onToggleLicensing(itemId) {
	            var items = this.basket.get('items');
	            items = items.update(items.findIndex(function (item) {
	                return item.get('id') === itemId;
	            }), function (item) {
	                return item.set('_requestLicense', !item.get('_requestLicense'));
	            });
	
	            this.basket = this.basket.set('items', items);
	        }
	
	        /**
	         * Marks all basket items to be requested for licensing
	         */
	    }, {
	        key: 'onToggleLicensingAll',
	        value: function onToggleLicensingAll() {
	
	            var items = this.basket.get('items');
	
	            var areChecked = items.filter(function (item) {
	                return item.get('_requestLicense') === true;
	            }).size;
	            var shouldCheck = areChecked === items.size ? false : true;
	
	            items = items.map(function (item) {
	                return item.set('_requestLicense', shouldCheck);
	            });
	            this.basket = this.basket.set('items', items);
	        }
	    }, {
	        key: 'onToggleDownloadAll',
	        value: function onToggleDownloadAll(fileKey) {
	            var shouldGetChecked = !BasketStore.fileIsChecked(this.basket, fileKey);
	            var items = this.basket.get('items');
	            items = items.map(function (item) {
	                var files = item.get('files').map(function (file) {
	                    if (file.get('name') === fileKey) {
	                        return file.set('_download', shouldGetChecked);
	                    }
	                    return file;
	                });
	                return item.set('files', files);
	            });
	
	            this.basket = this.basket.set('items', items);
	        }
	    }, {
	        key: 'onDeleteBasketsSuccess',
	        value: function onDeleteBasketsSuccess(basketIds) {
	            var baskets = this.baskets;
	            basketIds.forEach(function (basketId) {
	                var ix = baskets.findIndex(function (item) {
	                    return item.get('id') === basketId;
	                });
	                baskets = baskets.removeIn([ix]);
	            });
	            this.baskets = baskets;
	            if (baskets.size === 0) {
	                this.basket = _immutable2['default'].fromJS({});
	                this._setActiveBasketId(null);
	            } else {
	                this.activateLast();
	            }
	        }
	    }, {
	        key: 'activateLast',
	        value: function activateLast() {
	            _utilsFlux2['default'].getStore('basket').loadBasket(this.baskets.last().get('id'));
	        }
	
	        /**
	         * Filters an immutable array of baskets by the isSelected property
	         * @param  {ImmutableArr} baskets
	         * @return {ImmutableArr} filteredBaskets
	         */
	    }, {
	        key: 'onLoadError',
	        value: function onLoadError(error) {
	            if (error.status === 401) {
	                _utilsApi2['default'].removeToken();
	                _store2['default'].clear();
	                _jsCookie2['default'].remove('basicauth_token');
	                window.location = location.protocol + '//' + location.host;
	            }
	        }
	    }, {
	        key: 'onExcelSearchSuccess',
	        value: function onExcelSearchSuccess(excelSearchBasket) {}
	    }, {
	        key: 'onExcelSearchError',
	        value: function onExcelSearchError(excelSearchError) {
	            var errorObj = JSON.parse(excelSearchError.response);
	            this.excelError = errorObj.error;
	        }
	    }, {
	        key: 'clearErrorData',
	        value: function clearErrorData() {
	            this.excelError = null;
	        }
	    }], [{
	        key: 'setShareUrl',
	        value: function setShareUrl(shareUrl) {
	            this.alt.getActions('basket').resetShareUrl();
	            this.alt.getActions('basket').setShareUrlItem(shareUrl);
	        }
	    }, {
	        key: 'getSelectedBaskets',
	        value: function getSelectedBaskets(baskets) {
	            if (baskets.size === 0) {
	                return baskets;
	            }
	            return baskets.filter(function (basket) {
	                return basket.get('isSelected') === true;
	            });
	        }
	    }, {
	        key: 'isInBasket',
	        value: function isInBasket(basket, mediaId) {
	            return basket.items.filter(function (media) {
	                return media.id === mediaId;
	            }).length > 0 ? true : false;
	        }
	    }, {
	        key: 'getItemsToDownload',
	        value: function getItemsToDownload(items) {
	            return (0, _lodashArrayFlatten2['default'])(items.map(function (item) {
	                var itemId = item.id;
	                return item.files.filter(function (file) {
	                    return file._download;
	                }).map(function (file) {
	                    return { id: itemId, size: file.key };
	                });
	            }));
	        }
	    }, {
	        key: 'fileIsChecked',
	        value: function fileIsChecked(basket, fileKey) {
	            var basketFiles = basket.get('items').map(function (item) {
	                return item.get('files').filter(function (s) {
	                    return s.get('name') === fileKey;
	                });
	            }).reduce(function (x, v) {
	                return x.concat(v);
	            }, _immutable2['default'].List([]));
	
	            return basketFiles.filter(function (item) {
	                return item.get('_download');
	            }).size === basketFiles.size;
	        }
	    }]);
	
	    return BasketStore;
	})();
	
	exports['default'] = BasketStore;
	module.exports = exports['default'];

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodashArrayFlatten = __webpack_require__(226);
	
	var _lodashArrayFlatten2 = _interopRequireDefault(_lodashArrayFlatten);
	
	var _queryString = __webpack_require__(167);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	var _utilsStrings = __webpack_require__(122);
	
	var _jsCookie = __webpack_require__(161);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var MediaSource = function MediaSource(alt) {
	    return {
	        loadMedia: {
	            local: function local(state, params) {
	                var cached = state._cache[JSON.stringify(params)] || null;
	                if (Object.getOwnPropertyNames(params).length == 0 || params.hasOwnProperty('clearFlag') && !!params['clearFlag']) {
	                    alt.getActions('media').clearQuery();
	                }
	
	                if (cached) {
	                    alt.getActions('media').loadMediaSuccess(cached);
	                    return true;
	                }
	            },
	            remote: function remote(state, params) {
	                return _utilsApi2['default'].get('media', params).then(function (data) {
	                    return { data: data, params: params };
	                });
	            },
	            success: alt.getActions('media').loadMediaSuccess,
	            error: alt.getActions('media').loadMediaError
	        },
	        loadMediaModals: {
	            local: function local(state, params) {
	                var cached = state._cache[JSON.stringify(params)] || null;
	                if (cached) {
	                    alt.getActions('media').loadMediaModalsSuccess(cached);
	                    return true;
	                }
	            },
	            remote: function remote(state, params) {
	                return _utilsApi2['default'].get('media', params).then(function (data) {
	                    return { data: data, params: params };
	                });
	            },
	            success: alt.getActions('media').loadMediaModalsSuccess,
	            error: alt.getActions('media').loadMediaError
	        },
	        loadLandingPage: {
	            local: function local(state) {
	                return state.landingPage.size !== 0 ? state.landingPage.toJS() : null;
	            },
	            remote: function remote() {
	                return _utilsApi2['default'].get('landing_pages');
	            },
	            success: alt.getActions('media').loadLandingPageSuccess,
	            error: alt.getActions('media').loadLandingPageError
	        },
	        checkQuota: {
	            remote: function remote(state, params) {
	                return _utilsApi2['default'].post('request_download', params);
	            },
	            success: alt.getActions('media').checkQuotaSuccess,
	            error: alt.getActions('media').checkQuotaError
	        }
	    };
	};
	
	var MediaStore = (function () {
	    function MediaStore() {
	        _classCallCheck(this, MediaStore);
	
	        this.bindActions(this.alt.getActions('media'));
	        this.registerAsync(MediaSource);
	
	        // Make the UI even more Snappy
	        // by caching media query during the session
	        this._cache = {};
	
	        // Exposed
	        this.media = _immutable2['default'].fromJS([]);
	        this.mediaModal = _immutable2['default'].fromJS([]);
	        this.filters = _immutable2['default'].fromJS([]);
	        this.landingPage = _immutable2['default'].fromJS({});
	        this.selectedFilters = _immutable2['default'].fromJS([]);
	        this.meta = _immutable2['default'].fromJS({});
	        this.slotDefinitions = _immutable2['default'].fromJS([]);
	        this.modalMeta = _immutable2['default'].fromJS({});
	        this.params = {};
	        this.isExpanded = false;
	        this.quotaExceeded = false;
	        this.nextElement = false;
	        this.previousElement = false;
	        this.fetchPreviousPage = false;
	        this.fetchNextPage = false;
	        this.slotConfig = window.config.detail_view;
	        this.modalOrientation = window.config.detail_view_orientation;
	        this.query = _immutable2['default'].fromJS({});
	    }
	
	    /**
	     * Load Media and generate Filters
	     * @param  {[type]} result [description]
	     * @return {[type]}        [description]
	     */
	
	    _createClass(MediaStore, [{
	        key: 'onLoadMediaSuccess',
	        value: function onLoadMediaSuccess(result) {
	            var data = result.data;
	            this._cache[JSON.stringify(result.params)] = result;
	
	            this.filters = _immutable2['default'].fromJS(data.filter);
	            this.meta = _immutable2['default'].fromJS(data.meta);
	            this.media = _immutable2['default'].fromJS(data.items);
	            this.params = result.params;
	            this.slotDefinitions = _immutable2['default'].fromJS(data["slot_definitions"]);
	
	            var mediaItems = this.flagFirstAndLastElement(data);
	
	            this.media = _immutable2['default'].fromJS(mediaItems);
	
	            // Active Filters from selections
	            var activeFilters = data.activeFilters.map(function (filter) {
	                return filter.params.split('&').map(function (sub) {
	                    var obj = {};obj.name = filter.name;obj.params = sub;obj.value = filter.value;return obj;
	                });
	            });
	            activeFilters = (0, _lodashArrayFlatten2['default'])(activeFilters).map(function (afilter) {
	                var _afilter = _extends({}, afilter);
	
	                _afilter.params = (0, _utilsStrings.encodeUrl)(_afilter.params);
	                _afilter.params = _queryString2['default'].parse(_afilter.params);
	                return _afilter;
	            });
	
	            // Active Filters from search
	            if (this.params.search_id) {
	                activeFilters.push({
	                    name: data.meta.search_name || 'SEARCH',
	                    params: { 'search_id': this.params.search_id }
	                });
	            } else if (this.params.search) {
	                activeFilters.push({
	                    name: this.params.search,
	                    params: { 'search': this.params.search }
	                });
	            }
	
	            this.selectedFilters = _immutable2['default'].fromJS(activeFilters);
	        }
	    }, {
	        key: 'onLoadMediaModalsSuccess',
	        value: function onLoadMediaModalsSuccess(result) {
	            var _this = this;
	
	            var data = result.data;
	            this._cache[JSON.stringify(result.params)] = result;
	
	            // define which mediaItem is first and which one is last
	            var mediaItems = this.flagFirstAndLastElement(data);
	
	            this.modalMeta = _immutable2['default'].fromJS(data.meta);
	            this.mediaModal = _immutable2['default'].fromJS(mediaItems);
	
	            if (this.fetchPreviousPage) {
	                this.fetchPreviousPage = false;
	                setTimeout(function () {
	                    _this.alt.getActions('modals').openMediaModal(_this.mediaModal.get(_this.mediaModal.size - 1));
	                }, 10);
	            }
	
	            if (this.fetchNextPage) {
	                this.fetchNextPage = false;
	                setTimeout(function () {
	                    _this.alt.getActions('modals').openMediaModal(_this.mediaModal.get(0));
	                }, 10);
	            }
	        }
	    }, {
	        key: 'flagFirstAndLastElement',
	        value: function flagFirstAndLastElement(data) {
	            return data.items.map(function (currentValue, index) {
	                currentValue.indexInResults = index;
	                currentValue.firstElementOfResults = index == !!0;
	                currentValue.lastElementOfResults = index == data.items.length - 1 ? true : false;
	                return currentValue;
	            });
	        }
	    }, {
	        key: 'cloneMediaAndMetaToModalData',
	        value: function cloneMediaAndMetaToModalData() {
	            // This two will be used for modal, because we need to be independent from rest of page
	            this.mediaModal = this.media;
	            this.modalMeta = this.meta;
	            this.modalOrientation = window.config.detail_view_orientation;
	            this.slotConfig = window.config.detail_view;
	        }
	    }, {
	        key: 'cloneMediaAndMetaToModalDataFromBasket',
	        value: function cloneMediaAndMetaToModalDataFromBasket(basket) {
	            var mediaItems = this.flagFirstAndLastElement(basket.toJS());
	            this.mediaModal = _immutable2['default'].fromJS(mediaItems);
	            // we need to fake basket page as only page (because we use same layout as normal media page)
	            this.modalMeta = _immutable2['default'].fromJS({
	                total_records: mediaItems.length,
	                per_page: mediaItems.length,
	                page: 1
	            });
	        }
	    }, {
	        key: 'cloneMediaAndMetaToModalDataFromShared',
	        value: function cloneMediaAndMetaToModalDataFromShared(shared) {
	            var mediaItems = this.flagFirstAndLastElement(shared.toJS()[0]);
	            this.mediaModal = _immutable2['default'].fromJS(mediaItems);
	            // we need to fake basket page as only page (because we use same layout as normal media page)
	            this.modalMeta = _immutable2['default'].fromJS({
	                total_records: mediaItems.length,
	                per_page: mediaItems.length,
	                page: 1
	            });
	        }
	    }, {
	        key: 'cloneSlotDefinitionsToModalDataFromBasket',
	        value: function cloneSlotDefinitionsToModalDataFromBasket(slotDefinitions) {
	            this.modalOrientation = window.config.detail_view_orientation;
	            this.slotConfig = window.config.detail_view;
	            this.slotDefinitions = _immutable2['default'].fromJS(slotDefinitions);
	        }
	    }, {
	        key: 'cloneSlotDefinitionsToModalDataFromShared',
	        value: function cloneSlotDefinitionsToModalDataFromShared(slotDefinitions) {
	            this.modalOrientation = window.config.shared_view_orientation;
	            this.slotConfig = window.config.shared_view;
	            this.slotDefinitions = _immutable2['default'].fromJS(slotDefinitions);
	        }
	    }, {
	        key: 'onLoadMediaError',
	        value: function onLoadMediaError(err) {
	            if (error.status === 401) {
	                _utilsApi2['default'].removeToken();
	                _store2['default'].clear();
	                _jsCookie2['default'].remove('basicauth_token');
	                window.location = location.protocol + '//' + location.host;
	            }
	        }
	    }, {
	        key: 'onLoadLandingPageSuccess',
	        value: function onLoadLandingPageSuccess(landingPage) {
	            this.landingPage = _immutable2['default'].fromJS(landingPage);
	        }
	    }, {
	        key: 'onLoadLandingPageError',
	        value: function onLoadLandingPageError(error) {
	            if (error.status === 401) {
	                _utilsApi2['default'].removeToken();
	                _store2['default'].clear();
	                _jsCookie2['default'].remove('basicauth_token');
	                window.location = location.protocol + '//' + location.host;
	            }
	        }
	    }, {
	        key: 'onCheckQuotaSuccess',
	        value: function onCheckQuotaSuccess(result) {
	            this.quotaExceeded = !result.success;
	        }
	    }, {
	        key: 'onCheckQuotaError',
	        value: function onCheckQuotaError(err) {}
	    }, {
	        key: 'onClearSearch',
	        value: function onClearSearch() {
	            delete this.params.search;
	        }
	    }, {
	        key: 'onCloseBasket',
	        value: function onCloseBasket(id) {
	            var ix = this.media.findIndex(function (item) {
	                return item.get('id') === id;
	            });
	            this.media = this.media.updateIn([ix, '_basket'], function (active) {
	                return false;
	            });
	        }
	    }, {
	        key: 'onClearQuery',
	        value: function onClearQuery() {
	            this.query = _immutable2['default'].fromJS({});
	        }
	    }, {
	        key: 'onUpdateFilterParams',
	        value: function onUpdateFilterParams(params) {
	            for (var property in params) {
	                if (!params.hasOwnProperty(property)) {
	                    continue;
	                }
	
	                var val = params[property];
	                if (val && val.length > 0) {
	                    this.query = this.query.set(property, val);
	                } else {
	                    this.query = this.query.remove(property);
	                }
	            }
	        }
	    }, {
	        key: 'onToggleFilter',
	        value: function onToggleFilter(ix) {
	            this.filters = this.filters.updateIn([ix, 'active'], function (active) {
	                return !active;
	            });
	        }
	    }, {
	        key: 'onToggleItemSelection',
	        value: function onToggleItemSelection(id) {
	            var ix = this.media.findIndex(function (item) {
	                return id === item.get('id') && false !== item.get('showdownload');
	            });
	            if (ix > -1) {
	                this.media = this.media.updateIn([ix, '_checked'], function (active) {
	                    return !active;
	                });
	            }
	        }
	    }, {
	        key: 'onToggleBasket',
	        value: function onToggleBasket(id) {
	            var ix = this.media.findIndex(function (item) {
	                return item.get('id') === id;
	            });
	            this.media = this.media.updateIn([ix, '_basket'], function (active) {
	                return !active;
	            });
	        }
	    }, {
	        key: 'onToggleAllItemSelection',
	        value: function onToggleAllItemSelection() {
	            var eligible = this.media.filter(function (item) {
	                return false !== item.get('showdownload');
	            });
	            var countChecked = eligible.filter(function (item) {
	                return item.get('_checked') === true;
	            }).size;
	            var shouldCheck = countChecked !== eligible.size;
	
	            this.media = this.media.map(function (item) {
	                if (false !== item.get('showdownload')) {
	                    item = item.set('_checked', shouldCheck);
	                }
	                return item;
	            });
	        }
	    }, {
	        key: 'onRemoveAllItemSelection',
	        value: function onRemoveAllItemSelection() {
	            this.media = this.media.map(function (item) {
	                return item.set('_checked', false);
	            });
	        }
	    }, {
	        key: 'onCloseFilters',
	        value: function onCloseFilters() {
	            this.filters = this.filters.map(function (filter) {
	                return filter.set('active', false);
	            });
	        }
	    }, {
	        key: 'toggleExpand',
	        value: function toggleExpand() {
	            var _this2 = this;
	
	            this.isExpanded = !this.isExpanded;
	            this.filters = this.filters.map(function (filter) {
	                return filter.set('active', _this2.isExpanded);
	            });
	        }
	    }, {
	        key: 'toggleItemAddedNotification',
	        value: function toggleItemAddedNotification(data) {
	            var mediaId = data.mediaId;
	            var basketName = data.basketName;
	
	            var ix = this.media.findIndex(function (item) {
	                return mediaId === item.get('id');
	            });
	            this.media = this.media.updateIn([ix, '_notification'], function (notification) {
	                return notification ? false : basketName;
	            });
	        }
	    }, {
	        key: 'onRemoveSelectedFilter',
	        value: function onRemoveSelectedFilter(index) {
	            this.selectedFilters = this.selectedFilters.filter(function (filter, i) {
	                return i !== index;
	            });
	        }
	    }, {
	        key: 'setPreviousElement',
	        value: function setPreviousElement(id) {
	            var ix = this.mediaModal.findIndex(function (item) {
	                return item.get('id') === id;
	            });
	            var indexOfElement = ix - 1;
	            if (indexOfElement >= 0) this.previousElement = this.mediaModal.get(indexOfElement);
	        }
	    }, {
	        key: 'setNextElement',
	        value: function setNextElement(id) {
	            var ix = this.mediaModal.findIndex(function (item) {
	                return item.get('id') === id;
	            });
	            var indexOfElement = ix + 1;
	            if (indexOfElement <= this.mediaModal.size) this.nextElement = this.mediaModal.get(indexOfElement);
	        }
	    }, {
	        key: 'openCurrentMedia',
	        value: function openCurrentMedia(id) {
	            var _this3 = this;
	
	            var ix = this.mediaModal.findIndex(function (item) {
	                return item.get('id') === id;
	            });
	            if (typeof ix !== 'undefined') {
	                (function () {
	                    var currentMediaitem = _this3.mediaModal.get(ix);
	                    setTimeout(function () {
	                        _this3.alt.getActions('modals').openMediaModal(currentMediaitem);
	                    }, 10);
	                })();
	            }
	        }
	    }, {
	        key: 'fetchPreviousPage',
	        value: function fetchPreviousPage() {
	            this.fetchPreviousPage = true;
	        }
	    }, {
	        key: 'fetchNextPage',
	        value: function fetchNextPage() {
	            this.fetchNextPage = true;
	        }
	    }, {
	        key: 'setLayout',
	        value: function setLayout(layout) {
	            _store2['default'].set('active_layout', layout);
	        }
	    }, {
	        key: 'onLoadError',
	        value: function onLoadError(error) {
	            if (error.status === 401) {
	                _utilsApi2['default'].removeToken();
	                _store2['default'].clear();
	                _jsCookie2['default'].remove('basicauth_token');
	                window.location = location.protocol + '//' + location.host;
	            }
	        }
	    }]);
	
	    return MediaStore;
	})();
	
	exports['default'] = MediaStore;
	module.exports = exports['default'];

/***/ }),
/* 532 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var ModalStore = (function () {
	    function ModalStore() {
	        _classCallCheck(this, ModalStore);
	
	        this.bindActions(this.alt.getActions('modals'));
	        this.openModal = false;
	        this.data = false;
	        this.selectedItemId = false;
	        this.modalInModal = false;
	        this.loading = false;
	    }
	
	    _createClass(ModalStore, [{
	        key: 'onCloseModals',
	        value: function onCloseModals() {
	            var _this = this;
	
	            this.openModal = false;
	            this.data = false;
	
	            if (this.modalInModal) {
	                (function () {
	                    var itemId = _this.modalInModal;
	                    _this.modalInModal = false;
	                    setTimeout(function () {
	                        _this.alt.getActions('media').openCurrentMedia(itemId);
	                    }, 10);
	                })();
	            }
	        }
	    }, {
	        key: 'onOpenModal',
	        value: function onOpenModal(modal) {
	            this.openModal = modal;
	            this.data = false;
	        }
	    }, {
	        key: 'onActivateLoading',
	        value: function onActivateLoading() {
	            this.loading = true;
	        }
	    }, {
	        key: 'onDisableLoading',
	        value: function onDisableLoading() {
	            this.loading = false;
	        }
	    }, {
	        key: 'onOpenMediaModal',
	        value: function onOpenMediaModal(media) {
	            this.data = media;
	            this.openModal = 'Media';
	        }
	    }, {
	        key: 'onConfirmModal',
	        value: function onConfirmModal(data) {
	            this.openModal = 'Confirm';
	            this.data = data;
	        }
	    }, {
	        key: 'onOpenInstantDownloadModal',
	        value: function onOpenInstantDownloadModal(media) {
	            this.data = media;
	            this.openModal = 'InstantDownload';
	        }
	    }, {
	        key: 'onOpenInstantDownloadAllModal',
	        value: function onOpenInstantDownloadAllModal(media) {
	            this.data = media;
	            this.openModal = 'InstantDownloadAll';
	        }
	    }, {
	        key: 'onOpenWatermarkModal',
	        value: function onOpenWatermarkModal(media) {
	            this.data = media;
	            this.openModal = 'Watermark';
	        }
	    }, {
	        key: 'onOpenExcelSearchModal',
	        value: function onOpenExcelSearchModal(data) {
	            this.data = data;
	            this.openModal = 'ExcelSearch';
	        }
	    }, {
	        key: 'setSelectedItemId',
	        value: function setSelectedItemId(selectedItemId) {
	            this.selectedItemId = selectedItemId;
	        }
	    }, {
	        key: 'onToggleDownload',
	        value: function onToggleDownload(fileKey) {
	            var item = this.data;
	
	            var files = item.get('files').map(function (file) {
	                var key = file.get('key');
	
	                if (key !== fileKey) {
	                    return file;
	                }
	                file = file.set('_selected', !file.get('_selected'));
	                return file;
	            });
	            this.data = this.data.set('files', files);
	        }
	    }, {
	        key: 'onToggleDownloadAll',
	        value: function onToggleDownloadAll(fileKey) {
	            var _this2 = this;
	
	            this.data = this.data.map(function (item) {
	                if (item.get('id') == _this2.selectedItemId) {
	                    var files = item.get('files').map(function (file) {
	                        if (file.get('key') === fileKey) {
	                            return file.set('_selected', !file.get('_selected'));
	                        }
	                        return file;
	                    });
	                    return item.set('files', files);
	                }
	                return item;
	            });
	        }
	    }, {
	        key: 'onSetSelectedForFileKey',
	        value: function onSetSelectedForFileKey(params) {
	            var fileKey = params[0];
	            var checked = params[1];
	            this.data = this.data.map(function (item) {
	                var files = item.get('files').map(function (file) {
	                    if (file.get('key') == fileKey) {
	                        return file.set('_selected', checked);
	                    }
	                    return file;
	                });
	                return item.set('files', files);
	            });
	        }
	    }, {
	        key: 'setModalInModal',
	        value: function setModalInModal(id) {
	            this.modalInModal = id;
	        }
	    }], [{
	        key: 'getSelectedInstantDownloadItems',
	        value: function getSelectedInstantDownloadItems() {
	            if (!this.state.data) {
	                return [];
	            }
	
	            var selectedItems = [].concat(_toConsumableArray(this.state.data.get('files').toJS()));
	            return selectedItems.filter(function (file) {
	                return !!file._selected;
	            });
	        }
	    }]);
	
	    return ModalStore;
	})();
	
	exports['default'] = ModalStore;
	module.exports = exports['default'];

/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _lodashUtilityUniqueId = __webpack_require__(808);
	
	var _lodashUtilityUniqueId2 = _interopRequireDefault(_lodashUtilityUniqueId);
	
	var NotificationStore = (function () {
	    function NotificationStore() {
	        _classCallCheck(this, NotificationStore);
	
	        this.bindActions(this.alt.getActions('notifications'));
	        this.notifications = [];
	    }
	
	    _createClass(NotificationStore, [{
	        key: 'onAddSuccessNotification',
	        value: function onAddSuccessNotification(notifications) {
	            var _this = this;
	
	            var notificationIds = [];
	            notifications = !Array.isArray(notifications) ? [notifications] : notifications;
	            notifications = notifications.map(function (notification) {
	                notification.id = (0, _lodashUtilityUniqueId2['default'])('notification_');
	                notificationIds.push(notification.id);
	                return notification;
	            });
	
	            this.notifications = this.notifications.concat(notifications);
	            setTimeout(function () {
	                _this.alt.getActions('notifications').removeNotification(notificationIds);
	            }, 2500);
	        }
	    }, {
	        key: 'removeNotification',
	        value: function removeNotification(ids) {
	            ids = !Array.isArray(ids) ? [ids] : ids;
	            this.notifications = this.notifications.filter(function (notification) {
	                return ids.indexOf(notification.id) === -1;
	            });
	        }
	    }]);
	
	    return NotificationStore;
	})();
	
	exports['default'] = NotificationStore;
	module.exports = exports['default'];

/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var RequestSource = function RequestSource(alt) {
	    return {
	        loadRequests: {
	            remote: function remote() {
	                return _utilsApi2['default'].get('basket/licenses?type=all');
	            },
	            success: alt.getActions('requests').loadRequestsSuccess,
	            error: alt.getActions('requests').loadError
	        }
	    };
	};
	
	var RequestStore = (function () {
	    function RequestStore() {
	        _classCallCheck(this, RequestStore);
	
	        this.bindActions(this.alt.getActions('requests'));
	        this.registerAsync(RequestSource);
	        this.requests = _immutable2['default'].fromJS([]);
	    }
	
	    _createClass(RequestStore, [{
	        key: 'onLoadRequestsSuccess',
	        value: function onLoadRequestsSuccess(data) {
	            this.requests = _immutable2['default'].fromJS(data);
	        }
	    }]);
	
	    return RequestStore;
	})();
	
	exports['default'] = RequestStore;
	module.exports = exports['default'];

/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _immutable = __webpack_require__(27);
	
	var _immutable2 = _interopRequireDefault(_immutable);
	
	var _lodashArrayFlatten = __webpack_require__(226);
	
	var _lodashArrayFlatten2 = _interopRequireDefault(_lodashArrayFlatten);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _jsCookie = __webpack_require__(161);
	
	var _jsCookie2 = _interopRequireDefault(_jsCookie);
	
	var ShareSource = function ShareSource(alt) {
	    return {
	        loadShare: {
	            remote: function remote(state, shareId) {
	                return _utilsApi2['default'].get('share/' + shareId);
	            },
	            success: alt.getActions('share').loadShareSuccess,
	            error: alt.getActions('share').loadError
	        },
	        requestAccess: {
	            remote: function remote(state, data) {
	                return _utilsApi2['default'].post('request_access', data).then(function () {
	                    return { success: true, media_id: data.media_id };
	                });
	            },
	            success: alt.getActions('share').requestAccessSuccess,
	            error: alt.getActions('share').requestAccessError
	        },
	        download: {
	            remote: function remote(state, data) {
	                return _utilsApi2['default'].post('download', data);
	            },
	            success: alt.getActions('share').downloadSuccess,
	            error: alt.getActions('share').downloadError
	        }
	    };
	};
	
	var ShareStore = (function () {
	    function ShareStore() {
	        _classCallCheck(this, ShareStore);
	
	        this.bindActions(this.alt.getActions('share'));
	        this.registerAsync(ShareSource);
	
	        this.linkExpired = _immutable2['default'].fromJS(false);
	        this.baskets = _immutable2['default'].fromJS([]);
	        this.user = _immutable2['default'].fromJS({});
	        this.slotDefinitions = _immutable2['default'].fromJS([]);
	    }
	
	    _createClass(ShareStore, [{
	        key: 'onLoadShareSuccess',
	        value: function onLoadShareSuccess(data) {
	            data.baskets = data.baskets.map(function (basket) {
	                basket.items = basket.items.map(function (item) {
	                    item.tags = [];
	                    return item;
	                });
	                return basket;
	            });
	
	            this.baskets = _immutable2['default'].fromJS(data.baskets);
	            this.slotDefinitions = _immutable2['default'].fromJS(data["slot_definitions"]);
	
	            this.user = _immutable2['default'].fromJS({
	                email: data.email,
	                firstName: data.firstName
	            });
	        }
	    }, {
	        key: 'onLoadError',
	        value: function onLoadError(err) {
	            if (err.status === 404) {
	                this.linkExpired = true;
	            }
	            if (err.status === 401) {
	                _utilsApi2['default'].removeToken();
	                _store2['default'].clear();
	                _jsCookie2['default'].remove('basicauth_token');
	                window.location = location.protocol + '//' + location.host;
	            }
	        }
	    }, {
	        key: 'onToggleItemSelection',
	        value: function onToggleItemSelection(data) {
	            var bix = this.baskets.findIndex(function (basket) {
	                return basket.get('id') === data.basketId;
	            });
	            this.baskets = this.baskets.updateIn([bix, 'items'], function (items) {
	                var ix = items.findIndex(function (item) {
	                    return item.get('id') === data.itemId;
	                });
	                return items.updateIn([ix, '_checked'], function (checked) {
	                    return !checked;
	                }).updateIn([ix, 'files'], function (files) {
	                    if (!data.fileKey) return files;
	                    var fileIx = files.findIndex(function (file) {
	                        return file.get('name') === data.fileKey;
	                    });
	                    return files.updateIn([fileIx], function (sfile) {
	                        return sfile.set('_download', !sfile.get('_download'));
	                    });
	                });
	            });
	        }
	    }, {
	        key: 'onToggleAllItems',
	        value: function onToggleAllItems(data) {
	            var bix = this.baskets.findIndex(function (basket) {
	                return basket.get('id') === data.basketId;
	            });
	            this.baskets = this.baskets.updateIn([bix, 'items'], function (items) {
	                return items.map(function (item) {
	                    if (item.get('visible')) {
	                        return item.update('_checked', function (checked) {
	                            return data.checkAll;
	                        });
	                    } else {
	                        return item;
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'onToggleDownloadAll',
	        value: function onToggleDownloadAll(data) {
	            var bix = this.baskets.findIndex(function (basket) {
	                return basket.get('id') === data.basketId;
	            });
	            this.baskets = this.baskets.updateIn([bix, 'items'], function (items) {
	                return items.map(function (item) {
	                    if (item.get('visible')) {
	                        return item.update('files', function (files) {
	                            return files.map(function (file) {
	                                if (file.get('key') === data.fileKey) return file.update('_download', function (download) {
	                                    return data.shouldCheckAll;
	                                });
	                                return file;
	                            });
	                        });
	                    } else {
	                        return item;
	                    }
	                });
	            });
	        }
	    }, {
	        key: 'onDownloadSuccess',
	        value: function onDownloadSuccess(result) {
	            // console.log('on download success', result);
	        }
	    }, {
	        key: 'onDownloadError',
	        value: function onDownloadError(error) {
	            // console.log('on download error', error);
	        }
	    }, {
	        key: 'onRequestAccessSuccess',
	        value: function onRequestAccessSuccess(result) {
	            this.baskets = _immutable2['default'].fromJS(this.baskets.toJSON().map(function (basket) {
	                basket.items = basket.items.map(function (item) {
	                    if (result.media_id === item.id) {
	                        item.access_requested = true;
	                    }
	                    return item;
	                });
	                return basket;
	            }));
	        }
	    }, {
	        key: 'onRequestAccessError',
	        value: function onRequestAccessError(result) {}
	    }], [{
	        key: 'getItemsToDownload',
	        value: function getItemsToDownload(items) {
	            return (0, _lodashArrayFlatten2['default'])(items.map(function (item) {
	                var itemId = item.id;
	                return item.files.filter(function (file) {
	                    return file._download;
	                }).map(function (file) {
	                    return { id: itemId, size: file.key };
	                });
	            }));
	        }
	    }]);
	
	    return ShareStore;
	})();
	
	exports['default'] = ShareStore;
	module.exports = exports['default'];

/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _utilsApi = __webpack_require__(49);
	
	var _utilsApi2 = _interopRequireDefault(_utilsApi);
	
	var _intlFormatCache = __webpack_require__(731);
	
	var _intlFormatCache2 = _interopRequireDefault(_intlFormatCache);
	
	var _intlMessageformat = __webpack_require__(337);
	
	var _intlMessageformat2 = _interopRequireDefault(_intlMessageformat);
	
	var _intlRelativeformat = __webpack_require__(739);
	
	var _intlRelativeformat2 = _interopRequireDefault(_intlRelativeformat);
	
	var _lodashObjectGet = __webpack_require__(805);
	
	var _lodashObjectGet2 = _interopRequireDefault(_lodashObjectGet);
	
	var _utilsFlux = __webpack_require__(3);
	
	var _utilsFlux2 = _interopRequireDefault(_utilsFlux);
	
	var _store = __webpack_require__(20);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _utilsMb_consts = __webpack_require__(275);
	
	var _utilsMb_consts2 = _interopRequireDefault(_utilsMb_consts);
	
	var TranslationsSource = function TranslationsSource(alt) {
	    return {
	        switchLanguage: {
	            remote: function remote(state, language) {
	                var isAuthenticated = _utilsFlux2['default'].getStore('app').isAuthenticated();
	                if (isAuthenticated) {
	                    return _utilsApi2['default'].post('edit_language', {
	                        language: language
	                    }).then(function () {
	                        return language;
	                    });
	                } else {
	                    return new Promise(function (resolve) {
	                        return resolve(language);
	                    });
	                }
	            },
	            success: alt.getActions('translations').setLanguage,
	            error: alt.getActions('app').onError
	        }
	    };
	};
	
	var TranslationsStore = (function () {
	    function TranslationsStore() {
	        _classCallCheck(this, TranslationsStore);
	
	        this.bindActions(this.alt.getActions('translations'));
	        this.registerAsync(TranslationsSource);
	
	        // ie8 intl polyfill
	        if (!global.Intl) {
	            global.Intl = __webpack_require__(339);
	        }
	
	        this.userLocale = _store2['default'].get(_utilsMb_consts2['default'].STORE_LANGUAGE_KEY) || undefined;
	
	        this.messages = {};
	    }
	
	    _createClass(TranslationsStore, [{
	        key: 'onAddLocaleData',
	        value: function onAddLocaleData(localData) {
	            _intlMessageformat2['default'].__addLocaleData(localData);
	            _intlRelativeformat2['default'].__addLocaleData(localData);
	
	            // Create a cached copy
	            this.numberFormat = (0, _intlFormatCache2['default'])(global.Intl.NumberFormat);
	            this.dateTimeFormat = (0, _intlFormatCache2['default'])(global.Intl.DateTimeFormat);
	            this.messageFormat = (0, _intlFormatCache2['default'])(_intlMessageformat2['default']);
	            this.relativeFormat = (0, _intlFormatCache2['default'])(_intlRelativeformat2['default']);
	        }
	    }, {
	        key: 'onAddMessages',
	        value: function onAddMessages(localData) {
	            this.formats = localData.formats;
	            this.messages = localData.messages;
	            this.locales = localData.locales;
	        }
	    }, {
	        key: 'onSetLanguage',
	        value: function onSetLanguage(locale) {
	            var reload = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	            this.userLocale = locale;
	            _store2['default'].set(_utilsMb_consts2['default'].STORE_LANGUAGE_KEY, locale);
	            if (reload) {
	                window.location.reload(false);
	            }
	        }
	    }, {
	        key: 'onSetAvailableLanguages',
	        value: function onSetAvailableLanguages(availableLanguages) {
	            this.availableLanguages = availableLanguages;
	        }
	    }], [{
	        key: 'getFormattedMessage',
	        value: function getFormattedMessage(path, values) {
	            var state = this.getState();
	            var msg = this.getIntlMessage(path);
	
	            var message = state.messageFormat(msg, state.locales, state.formats);
	            return message.format(values);
	        }
	    }, {
	        key: 'getFormattedDate',
	        value: function getFormattedDate(date, options) {
	            var state = this.getState();
	            date = new Date(date);
	            // assertIsDate(date, 'A date or timestamp must be provided to formatDate()');
	            return state.dateTimeFormat(state.locales, options).format(date);
	        }
	    }, {
	        key: 'getFormatRelative',
	        value: function getFormatRelative(date, options, formatOptions) {
	            var state = this.getState();
	            date = new Date(date);
	            // assertIsDate(date, 'A date or timestamp must be provided to formatDate()');
	            return state.relativeFormat(state.locales, options).format(date, formatOptions);
	        }
	    }, {
	        key: 'getMessages',
	        value: function getMessages(path) {
	            if (!path) {
	                return this.getState().messages;
	            } else {
	                return (0, _lodashObjectGet2['default'])(this.getState().messages, path);
	            }
	        }
	    }, {
	        key: 'getUserLocale',
	        value: function getUserLocale() {
	            return this.getState().userLocale;
	        }
	    }, {
	        key: 'getAvailableLanguages',
	        value: function getAvailableLanguages() {
	            return this.getState().availableLanguages;
	        }
	    }, {
	        key: 'getIntlMessage',
	        value: function getIntlMessage(path) {
	            var returnEmtpy = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
	            var messages = this.getState().messages;
	            var message = (0, _lodashObjectGet2['default'])(messages, path);
	
	            if (message === undefined && returnEmtpy === false) {
	                //console.error('Could not find Intl message: ' + path);
	                return path;
	            }
	
	            return message;
	        }
	    }]);
	
	    return TranslationsStore;
	})();
	
	exports['default'] = TranslationsStore;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 537 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	    value: true
	});
	exports['default'] = {
	
	    fadeInOut: function fadeInOut(el) {
	        var fadeType = arguments.length <= 1 || arguments[1] === undefined ? 'in' : arguments[1];
	
	        el.style.opacity = fadeType === 'in' ? el.style.opacity ? el.style.opacity : 0 : el.style.opacity ? el.style.opacity : 1;
	
	        var last = +new Date();
	        var direction = fadeType === 'in' ? 1 : -1;
	
	        var tick = function tick() {
	            el.style.opacity = +el.style.opacity + direction * (new Date() - last) / 800;
	            last = +new Date();
	            if (+el.style.opacity < 1 && fadeType === 'in') {
	                window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
	            }
	            if (+el.style.opacity > 0 && fadeType === 'out') {
	                window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
	            }
	        };
	
	        tick();
	    }
	};
	module.exports = exports['default'];

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(720);
	
	__webpack_require__(920);
	
	__webpack_require__(542);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, global, setImmediate) {/* @preserve
	 * The MIT License (MIT)
	 * 
	 * Copyright (c) 2013-2015 Petka Antonov
	 * 
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 * 
	 * The above copyright notice and this permission notice shall be included in
	 * all copies or substantial portions of the Software.
	 * 
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
	 * THE SOFTWARE.
	 * 
	 */
	/**
	 * bluebird build version 2.11.0
	 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, cancel, using, filter, any, each, timers
	*/
	!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var f;"undefined"!=typeof window?f=window:"undefined"!=typeof global?f=global:"undefined"!=typeof self&&(f=self),f.Promise=e()}}(function(){var define,module,exports;return (function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof _dereq_=="function"&&_dereq_;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof _dereq_=="function"&&_dereq_;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var SomePromiseArray = Promise._SomePromiseArray;
	function any(promises) {
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(1);
	    ret.setUnwrap();
	    ret.init();
	    return promise;
	}
	
	Promise.any = function (promises) {
	    return any(promises);
	};
	
	Promise.prototype.any = function () {
	    return any(this);
	};
	
	};
	
	},{}],2:[function(_dereq_,module,exports){
	"use strict";
	var firstLineError;
	try {throw new Error(); } catch (e) {firstLineError = e;}
	var schedule = _dereq_("./schedule.js");
	var Queue = _dereq_("./queue.js");
	var util = _dereq_("./util.js");
	
	function Async() {
	    this._isTickUsed = false;
	    this._lateQueue = new Queue(16);
	    this._normalQueue = new Queue(16);
	    this._trampolineEnabled = true;
	    var self = this;
	    this.drainQueues = function () {
	        self._drainQueues();
	    };
	    this._schedule =
	        schedule.isStatic ? schedule(this.drainQueues) : schedule;
	}
	
	Async.prototype.disableTrampolineIfNecessary = function() {
	    if (util.hasDevTools) {
	        this._trampolineEnabled = false;
	    }
	};
	
	Async.prototype.enableTrampoline = function() {
	    if (!this._trampolineEnabled) {
	        this._trampolineEnabled = true;
	        this._schedule = function(fn) {
	            setTimeout(fn, 0);
	        };
	    }
	};
	
	Async.prototype.haveItemsQueued = function () {
	    return this._normalQueue.length() > 0;
	};
	
	Async.prototype.throwLater = function(fn, arg) {
	    if (arguments.length === 1) {
	        arg = fn;
	        fn = function () { throw arg; };
	    }
	    if (typeof setTimeout !== "undefined") {
	        setTimeout(function() {
	            fn(arg);
	        }, 0);
	    } else try {
	        this._schedule(function() {
	            fn(arg);
	        });
	    } catch (e) {
	        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
	    }
	};
	
	function AsyncInvokeLater(fn, receiver, arg) {
	    this._lateQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncInvoke(fn, receiver, arg) {
	    this._normalQueue.push(fn, receiver, arg);
	    this._queueTick();
	}
	
	function AsyncSettlePromises(promise) {
	    this._normalQueue._pushOne(promise);
	    this._queueTick();
	}
	
	if (!util.hasDevTools) {
	    Async.prototype.invokeLater = AsyncInvokeLater;
	    Async.prototype.invoke = AsyncInvoke;
	    Async.prototype.settlePromises = AsyncSettlePromises;
	} else {
	    if (schedule.isStatic) {
	        schedule = function(fn) { setTimeout(fn, 0); };
	    }
	    Async.prototype.invokeLater = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvokeLater.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                setTimeout(function() {
	                    fn.call(receiver, arg);
	                }, 100);
	            });
	        }
	    };
	
	    Async.prototype.invoke = function (fn, receiver, arg) {
	        if (this._trampolineEnabled) {
	            AsyncInvoke.call(this, fn, receiver, arg);
	        } else {
	            this._schedule(function() {
	                fn.call(receiver, arg);
	            });
	        }
	    };
	
	    Async.prototype.settlePromises = function(promise) {
	        if (this._trampolineEnabled) {
	            AsyncSettlePromises.call(this, promise);
	        } else {
	            this._schedule(function() {
	                promise._settlePromises();
	            });
	        }
	    };
	}
	
	Async.prototype.invokeFirst = function (fn, receiver, arg) {
	    this._normalQueue.unshift(fn, receiver, arg);
	    this._queueTick();
	};
	
	Async.prototype._drainQueue = function(queue) {
	    while (queue.length() > 0) {
	        var fn = queue.shift();
	        if (typeof fn !== "function") {
	            fn._settlePromises();
	            continue;
	        }
	        var receiver = queue.shift();
	        var arg = queue.shift();
	        fn.call(receiver, arg);
	    }
	};
	
	Async.prototype._drainQueues = function () {
	    this._drainQueue(this._normalQueue);
	    this._reset();
	    this._drainQueue(this._lateQueue);
	};
	
	Async.prototype._queueTick = function () {
	    if (!this._isTickUsed) {
	        this._isTickUsed = true;
	        this._schedule(this.drainQueues);
	    }
	};
	
	Async.prototype._reset = function () {
	    this._isTickUsed = false;
	};
	
	module.exports = new Async();
	module.exports.firstLineError = firstLineError;
	
	},{"./queue.js":28,"./schedule.js":31,"./util.js":38}],3:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise) {
	var rejectThis = function(_, e) {
	    this._reject(e);
	};
	
	var targetRejected = function(e, context) {
	    context.promiseRejectionQueued = true;
	    context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
	};
	
	var bindingResolved = function(thisArg, context) {
	    if (this._isPending()) {
	        this._resolveCallback(context.target);
	    }
	};
	
	var bindingRejected = function(e, context) {
	    if (!context.promiseRejectionQueued) this._reject(e);
	};
	
	Promise.prototype.bind = function (thisArg) {
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	    ret._propagateFrom(this, 1);
	    var target = this._target();
	
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        var context = {
	            promiseRejectionQueued: false,
	            promise: ret,
	            target: target,
	            bindingPromise: maybePromise
	        };
	        target._then(INTERNAL, targetRejected, ret._progress, ret, context);
	        maybePromise._then(
	            bindingResolved, bindingRejected, ret._progress, ret, context);
	    } else {
	        ret._resolveCallback(target);
	    }
	    return ret;
	};
	
	Promise.prototype._setBoundTo = function (obj) {
	    if (obj !== undefined) {
	        this._bitField = this._bitField | 131072;
	        this._boundTo = obj;
	    } else {
	        this._bitField = this._bitField & (~131072);
	    }
	};
	
	Promise.prototype._isBound = function () {
	    return (this._bitField & 131072) === 131072;
	};
	
	Promise.bind = function (thisArg, value) {
	    var maybePromise = tryConvertToPromise(thisArg);
	    var ret = new Promise(INTERNAL);
	
	    ret._setBoundTo(maybePromise);
	    if (maybePromise instanceof Promise) {
	        maybePromise._then(function() {
	            ret._resolveCallback(value);
	        }, ret._reject, ret._progress, ret, null);
	    } else {
	        ret._resolveCallback(value);
	    }
	    return ret;
	};
	};
	
	},{}],4:[function(_dereq_,module,exports){
	"use strict";
	var old;
	if (typeof Promise !== "undefined") old = Promise;
	function noConflict() {
	    try { if (Promise === bluebird) Promise = old; }
	    catch (e) {}
	    return bluebird;
	}
	var bluebird = _dereq_("./promise.js")();
	bluebird.noConflict = noConflict;
	module.exports = bluebird;
	
	},{"./promise.js":23}],5:[function(_dereq_,module,exports){
	"use strict";
	var cr = Object.create;
	if (cr) {
	    var callerCache = cr(null);
	    var getterCache = cr(null);
	    callerCache[" size"] = getterCache[" size"] = 0;
	}
	
	module.exports = function(Promise) {
	var util = _dereq_("./util.js");
	var canEvaluate = util.canEvaluate;
	var isIdentifier = util.isIdentifier;
	
	var getMethodCaller;
	var getGetter;
	if (false) {
	var makeMethodCaller = function (methodName) {
	    return new Function("ensureMethod", "                                    \n\
	        return function(obj) {                                               \n\
	            'use strict'                                                     \n\
	            var len = this.length;                                           \n\
	            ensureMethod(obj, 'methodName');                                 \n\
	            switch(len) {                                                    \n\
	                case 1: return obj.methodName(this[0]);                      \n\
	                case 2: return obj.methodName(this[0], this[1]);             \n\
	                case 3: return obj.methodName(this[0], this[1], this[2]);    \n\
	                case 0: return obj.methodName();                             \n\
	                default:                                                     \n\
	                    return obj.methodName.apply(obj, this);                  \n\
	            }                                                                \n\
	        };                                                                   \n\
	        ".replace(/methodName/g, methodName))(ensureMethod);
	};
	
	var makeGetter = function (propertyName) {
	    return new Function("obj", "                                             \n\
	        'use strict';                                                        \n\
	        return obj.propertyName;                                             \n\
	        ".replace("propertyName", propertyName));
	};
	
	var getCompiled = function(name, compiler, cache) {
	    var ret = cache[name];
	    if (typeof ret !== "function") {
	        if (!isIdentifier(name)) {
	            return null;
	        }
	        ret = compiler(name);
	        cache[name] = ret;
	        cache[" size"]++;
	        if (cache[" size"] > 512) {
	            var keys = Object.keys(cache);
	            for (var i = 0; i < 256; ++i) delete cache[keys[i]];
	            cache[" size"] = keys.length - 256;
	        }
	    }
	    return ret;
	};
	
	getMethodCaller = function(name) {
	    return getCompiled(name, makeMethodCaller, callerCache);
	};
	
	getGetter = function(name) {
	    return getCompiled(name, makeGetter, getterCache);
	};
	}
	
	function ensureMethod(obj, methodName) {
	    var fn;
	    if (obj != null) fn = obj[methodName];
	    if (typeof fn !== "function") {
	        var message = "Object " + util.classString(obj) + " has no method '" +
	            util.toString(methodName) + "'";
	        throw new Promise.TypeError(message);
	    }
	    return fn;
	}
	
	function caller(obj) {
	    var methodName = this.pop();
	    var fn = ensureMethod(obj, methodName);
	    return fn.apply(obj, this);
	}
	Promise.prototype.call = function (methodName) {
	    var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
	    if (false) {
	        if (canEvaluate) {
	            var maybeCaller = getMethodCaller(methodName);
	            if (maybeCaller !== null) {
	                return this._then(
	                    maybeCaller, undefined, undefined, args, undefined);
	            }
	        }
	    }
	    args.push(methodName);
	    return this._then(caller, undefined, undefined, args, undefined);
	};
	
	function namedGetter(obj) {
	    return obj[this];
	}
	function indexedGetter(obj) {
	    var index = +this;
	    if (index < 0) index = Math.max(0, index + obj.length);
	    return obj[index];
	}
	Promise.prototype.get = function (propertyName) {
	    var isIndex = (typeof propertyName === "number");
	    var getter;
	    if (!isIndex) {
	        if (canEvaluate) {
	            var maybeGetter = getGetter(propertyName);
	            getter = maybeGetter !== null ? maybeGetter : namedGetter;
	        } else {
	            getter = namedGetter;
	        }
	    } else {
	        getter = indexedGetter;
	    }
	    return this._then(getter, undefined, undefined, propertyName, undefined);
	};
	};
	
	},{"./util.js":38}],6:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var errors = _dereq_("./errors.js");
	var async = _dereq_("./async.js");
	var CancellationError = errors.CancellationError;
	
	Promise.prototype._cancel = function (reason) {
	    if (!this.isCancellable()) return this;
	    var parent;
	    var promiseToReject = this;
	    while ((parent = promiseToReject._cancellationParent) !== undefined &&
	        parent.isCancellable()) {
	        promiseToReject = parent;
	    }
	    this._unsetCancellable();
	    promiseToReject._target()._rejectCallback(reason, false, true);
	};
	
	Promise.prototype.cancel = function (reason) {
	    if (!this.isCancellable()) return this;
	    if (reason === undefined) reason = new CancellationError();
	    async.invokeLater(this._cancel, this, reason);
	    return this;
	};
	
	Promise.prototype.cancellable = function () {
	    if (this._cancellable()) return this;
	    async.enableTrampoline();
	    this._setCancellable();
	    this._cancellationParent = undefined;
	    return this;
	};
	
	Promise.prototype.uncancellable = function () {
	    var ret = this.then();
	    ret._unsetCancellable();
	    return ret;
	};
	
	Promise.prototype.fork = function (didFulfill, didReject, didProgress) {
	    var ret = this._then(didFulfill, didReject, didProgress,
	                         undefined, undefined);
	
	    ret._setCancellable();
	    ret._cancellationParent = undefined;
	    return ret;
	};
	};
	
	},{"./async.js":2,"./errors.js":13}],7:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function() {
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var bluebirdFramePattern =
	    /[\\\/]bluebird[\\\/]js[\\\/](main|debug|zalgo|instrumented)/;
	var stackFramePattern = null;
	var formatStack = null;
	var indentStackFrames = false;
	var warn;
	
	function CapturedTrace(parent) {
	    this._parent = parent;
	    var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
	    captureStackTrace(this, CapturedTrace);
	    if (length > 32) this.uncycle();
	}
	util.inherits(CapturedTrace, Error);
	
	CapturedTrace.prototype.uncycle = function() {
	    var length = this._length;
	    if (length < 2) return;
	    var nodes = [];
	    var stackToIndex = {};
	
	    for (var i = 0, node = this; node !== undefined; ++i) {
	        nodes.push(node);
	        node = node._parent;
	    }
	    length = this._length = i;
	    for (var i = length - 1; i >= 0; --i) {
	        var stack = nodes[i].stack;
	        if (stackToIndex[stack] === undefined) {
	            stackToIndex[stack] = i;
	        }
	    }
	    for (var i = 0; i < length; ++i) {
	        var currentStack = nodes[i].stack;
	        var index = stackToIndex[currentStack];
	        if (index !== undefined && index !== i) {
	            if (index > 0) {
	                nodes[index - 1]._parent = undefined;
	                nodes[index - 1]._length = 1;
	            }
	            nodes[i]._parent = undefined;
	            nodes[i]._length = 1;
	            var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
	
	            if (index < length - 1) {
	                cycleEdgeNode._parent = nodes[index + 1];
	                cycleEdgeNode._parent.uncycle();
	                cycleEdgeNode._length =
	                    cycleEdgeNode._parent._length + 1;
	            } else {
	                cycleEdgeNode._parent = undefined;
	                cycleEdgeNode._length = 1;
	            }
	            var currentChildLength = cycleEdgeNode._length + 1;
	            for (var j = i - 2; j >= 0; --j) {
	                nodes[j]._length = currentChildLength;
	                currentChildLength++;
	            }
	            return;
	        }
	    }
	};
	
	CapturedTrace.prototype.parent = function() {
	    return this._parent;
	};
	
	CapturedTrace.prototype.hasParent = function() {
	    return this._parent !== undefined;
	};
	
	CapturedTrace.prototype.attachExtraTrace = function(error) {
	    if (error.__stackCleaned__) return;
	    this.uncycle();
	    var parsed = CapturedTrace.parseStackAndMessage(error);
	    var message = parsed.message;
	    var stacks = [parsed.stack];
	
	    var trace = this;
	    while (trace !== undefined) {
	        stacks.push(cleanStack(trace.stack.split("\n")));
	        trace = trace._parent;
	    }
	    removeCommonRoots(stacks);
	    removeDuplicateOrEmptyJumps(stacks);
	    util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
	    util.notEnumerableProp(error, "__stackCleaned__", true);
	};
	
	function reconstructStack(message, stacks) {
	    for (var i = 0; i < stacks.length - 1; ++i) {
	        stacks[i].push("From previous event:");
	        stacks[i] = stacks[i].join("\n");
	    }
	    if (i < stacks.length) {
	        stacks[i] = stacks[i].join("\n");
	    }
	    return message + "\n" + stacks.join("\n");
	}
	
	function removeDuplicateOrEmptyJumps(stacks) {
	    for (var i = 0; i < stacks.length; ++i) {
	        if (stacks[i].length === 0 ||
	            ((i + 1 < stacks.length) && stacks[i][0] === stacks[i+1][0])) {
	            stacks.splice(i, 1);
	            i--;
	        }
	    }
	}
	
	function removeCommonRoots(stacks) {
	    var current = stacks[0];
	    for (var i = 1; i < stacks.length; ++i) {
	        var prev = stacks[i];
	        var currentLastIndex = current.length - 1;
	        var currentLastLine = current[currentLastIndex];
	        var commonRootMeetPoint = -1;
	
	        for (var j = prev.length - 1; j >= 0; --j) {
	            if (prev[j] === currentLastLine) {
	                commonRootMeetPoint = j;
	                break;
	            }
	        }
	
	        for (var j = commonRootMeetPoint; j >= 0; --j) {
	            var line = prev[j];
	            if (current[currentLastIndex] === line) {
	                current.pop();
	                currentLastIndex--;
	            } else {
	                break;
	            }
	        }
	        current = prev;
	    }
	}
	
	function cleanStack(stack) {
	    var ret = [];
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        var isTraceLine = stackFramePattern.test(line) ||
	            "    (No stack trace)" === line;
	        var isInternalFrame = isTraceLine && shouldIgnore(line);
	        if (isTraceLine && !isInternalFrame) {
	            if (indentStackFrames && line.charAt(0) !== " ") {
	                line = "    " + line;
	            }
	            ret.push(line);
	        }
	    }
	    return ret;
	}
	
	function stackFramesAsArray(error) {
	    var stack = error.stack.replace(/\s+$/g, "").split("\n");
	    for (var i = 0; i < stack.length; ++i) {
	        var line = stack[i];
	        if ("    (No stack trace)" === line || stackFramePattern.test(line)) {
	            break;
	        }
	    }
	    if (i > 0) {
	        stack = stack.slice(i);
	    }
	    return stack;
	}
	
	CapturedTrace.parseStackAndMessage = function(error) {
	    var stack = error.stack;
	    var message = error.toString();
	    stack = typeof stack === "string" && stack.length > 0
	                ? stackFramesAsArray(error) : ["    (No stack trace)"];
	    return {
	        message: message,
	        stack: cleanStack(stack)
	    };
	};
	
	CapturedTrace.formatAndLogError = function(error, title) {
	    if (typeof console !== "undefined") {
	        var message;
	        if (typeof error === "object" || typeof error === "function") {
	            var stack = error.stack;
	            message = title + formatStack(stack, error);
	        } else {
	            message = title + String(error);
	        }
	        if (typeof warn === "function") {
	            warn(message);
	        } else if (typeof console.log === "function" ||
	            typeof console.log === "object") {
	            console.log(message);
	        }
	    }
	};
	
	CapturedTrace.unhandledRejection = function (reason) {
	    CapturedTrace.formatAndLogError(reason, "^--- With additional stack trace: ");
	};
	
	CapturedTrace.isSupported = function () {
	    return typeof captureStackTrace === "function";
	};
	
	CapturedTrace.fireRejectionEvent =
	function(name, localHandler, reason, promise) {
	    var localEventFired = false;
	    try {
	        if (typeof localHandler === "function") {
	            localEventFired = true;
	            if (name === "rejectionHandled") {
	                localHandler(promise);
	            } else {
	                localHandler(reason, promise);
	            }
	        }
	    } catch (e) {
	        async.throwLater(e);
	    }
	
	    var globalEventFired = false;
	    try {
	        globalEventFired = fireGlobalEvent(name, reason, promise);
	    } catch (e) {
	        globalEventFired = true;
	        async.throwLater(e);
	    }
	
	    var domEventFired = false;
	    if (fireDomEvent) {
	        try {
	            domEventFired = fireDomEvent(name.toLowerCase(), {
	                reason: reason,
	                promise: promise
	            });
	        } catch (e) {
	            domEventFired = true;
	            async.throwLater(e);
	        }
	    }
	
	    if (!globalEventFired && !localEventFired && !domEventFired &&
	        name === "unhandledRejection") {
	        CapturedTrace.formatAndLogError(reason, "Unhandled rejection ");
	    }
	};
	
	function formatNonError(obj) {
	    var str;
	    if (typeof obj === "function") {
	        str = "[function " +
	            (obj.name || "anonymous") +
	            "]";
	    } else {
	        str = obj.toString();
	        var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
	        if (ruselessToString.test(str)) {
	            try {
	                var newStr = JSON.stringify(obj);
	                str = newStr;
	            }
	            catch(e) {
	
	            }
	        }
	        if (str.length === 0) {
	            str = "(empty array)";
	        }
	    }
	    return ("(<" + snip(str) + ">, no stack trace)");
	}
	
	function snip(str) {
	    var maxChars = 41;
	    if (str.length < maxChars) {
	        return str;
	    }
	    return str.substr(0, maxChars - 3) + "...";
	}
	
	var shouldIgnore = function() { return false; };
	var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
	function parseLineInfo(line) {
	    var matches = line.match(parseLineInfoRegex);
	    if (matches) {
	        return {
	            fileName: matches[1],
	            line: parseInt(matches[2], 10)
	        };
	    }
	}
	CapturedTrace.setBounds = function(firstLineError, lastLineError) {
	    if (!CapturedTrace.isSupported()) return;
	    var firstStackLines = firstLineError.stack.split("\n");
	    var lastStackLines = lastLineError.stack.split("\n");
	    var firstIndex = -1;
	    var lastIndex = -1;
	    var firstFileName;
	    var lastFileName;
	    for (var i = 0; i < firstStackLines.length; ++i) {
	        var result = parseLineInfo(firstStackLines[i]);
	        if (result) {
	            firstFileName = result.fileName;
	            firstIndex = result.line;
	            break;
	        }
	    }
	    for (var i = 0; i < lastStackLines.length; ++i) {
	        var result = parseLineInfo(lastStackLines[i]);
	        if (result) {
	            lastFileName = result.fileName;
	            lastIndex = result.line;
	            break;
	        }
	    }
	    if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName ||
	        firstFileName !== lastFileName || firstIndex >= lastIndex) {
	        return;
	    }
	
	    shouldIgnore = function(line) {
	        if (bluebirdFramePattern.test(line)) return true;
	        var info = parseLineInfo(line);
	        if (info) {
	            if (info.fileName === firstFileName &&
	                (firstIndex <= info.line && info.line <= lastIndex)) {
	                return true;
	            }
	        }
	        return false;
	    };
	};
	
	var captureStackTrace = (function stackDetection() {
	    var v8stackFramePattern = /^\s*at\s*/;
	    var v8stackFormatter = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if (error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    if (typeof Error.stackTraceLimit === "number" &&
	        typeof Error.captureStackTrace === "function") {
	        Error.stackTraceLimit = Error.stackTraceLimit + 6;
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        var captureStackTrace = Error.captureStackTrace;
	
	        shouldIgnore = function(line) {
	            return bluebirdFramePattern.test(line);
	        };
	        return function(receiver, ignoreUntil) {
	            Error.stackTraceLimit = Error.stackTraceLimit + 6;
	            captureStackTrace(receiver, ignoreUntil);
	            Error.stackTraceLimit = Error.stackTraceLimit - 6;
	        };
	    }
	    var err = new Error();
	
	    if (typeof err.stack === "string" &&
	        err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
	        stackFramePattern = /@/;
	        formatStack = v8stackFormatter;
	        indentStackFrames = true;
	        return function captureStackTrace(o) {
	            o.stack = new Error().stack;
	        };
	    }
	
	    var hasStackAfterThrow;
	    try { throw new Error(); }
	    catch(e) {
	        hasStackAfterThrow = ("stack" in e);
	    }
	    if (!("stack" in err) && hasStackAfterThrow &&
	        typeof Error.stackTraceLimit === "number") {
	        stackFramePattern = v8stackFramePattern;
	        formatStack = v8stackFormatter;
	        return function captureStackTrace(o) {
	            Error.stackTraceLimit = Error.stackTraceLimit + 6;
	            try { throw new Error(); }
	            catch(e) { o.stack = e.stack; }
	            Error.stackTraceLimit = Error.stackTraceLimit - 6;
	        };
	    }
	
	    formatStack = function(stack, error) {
	        if (typeof stack === "string") return stack;
	
	        if ((typeof error === "object" ||
	            typeof error === "function") &&
	            error.name !== undefined &&
	            error.message !== undefined) {
	            return error.toString();
	        }
	        return formatNonError(error);
	    };
	
	    return null;
	
	})([]);
	
	var fireDomEvent;
	var fireGlobalEvent = (function() {
	    if (util.isNode) {
	        return function(name, reason, promise) {
	            if (name === "rejectionHandled") {
	                return process.emit(name, promise);
	            } else {
	                return process.emit(name, reason, promise);
	            }
	        };
	    } else {
	        var customEventWorks = false;
	        var anyEventWorks = true;
	        try {
	            var ev = new self.CustomEvent("test");
	            customEventWorks = ev instanceof CustomEvent;
	        } catch (e) {}
	        if (!customEventWorks) {
	            try {
	                var event = document.createEvent("CustomEvent");
	                event.initCustomEvent("testingtheevent", false, true, {});
	                self.dispatchEvent(event);
	            } catch (e) {
	                anyEventWorks = false;
	            }
	        }
	        if (anyEventWorks) {
	            fireDomEvent = function(type, detail) {
	                var event;
	                if (customEventWorks) {
	                    event = new self.CustomEvent(type, {
	                        detail: detail,
	                        bubbles: false,
	                        cancelable: true
	                    });
	                } else if (self.dispatchEvent) {
	                    event = document.createEvent("CustomEvent");
	                    event.initCustomEvent(type, false, true, detail);
	                }
	
	                return event ? !self.dispatchEvent(event) : false;
	            };
	        }
	
	        var toWindowMethodNameMap = {};
	        toWindowMethodNameMap["unhandledRejection"] = ("on" +
	            "unhandledRejection").toLowerCase();
	        toWindowMethodNameMap["rejectionHandled"] = ("on" +
	            "rejectionHandled").toLowerCase();
	
	        return function(name, reason, promise) {
	            var methodName = toWindowMethodNameMap[name];
	            var method = self[methodName];
	            if (!method) return false;
	            if (name === "rejectionHandled") {
	                method.call(self, promise);
	            } else {
	                method.call(self, reason, promise);
	            }
	            return true;
	        };
	    }
	})();
	
	if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
	    warn = function (message) {
	        console.warn(message);
	    };
	    if (util.isNode && process.stderr.isTTY) {
	        warn = function(message) {
	            process.stderr.write("\u001b[31m" + message + "\u001b[39m\n");
	        };
	    } else if (!util.isNode && typeof (new Error().stack) === "string") {
	        warn = function(message) {
	            console.warn("%c" + message, "color: red");
	        };
	    }
	}
	
	return CapturedTrace;
	};
	
	},{"./async.js":2,"./util.js":38}],8:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(NEXT_FILTER) {
	var util = _dereq_("./util.js");
	var errors = _dereq_("./errors.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var keys = _dereq_("./es5.js").keys;
	var TypeError = errors.TypeError;
	
	function CatchFilter(instances, callback, promise) {
	    this._instances = instances;
	    this._callback = callback;
	    this._promise = promise;
	}
	
	function safePredicate(predicate, e) {
	    var safeObject = {};
	    var retfilter = tryCatch(predicate).call(safeObject, e);
	
	    if (retfilter === errorObj) return retfilter;
	
	    var safeKeys = keys(safeObject);
	    if (safeKeys.length) {
	        errorObj.e = new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a");
	        return errorObj;
	    }
	    return retfilter;
	}
	
	CatchFilter.prototype.doFilter = function (e) {
	    var cb = this._callback;
	    var promise = this._promise;
	    var boundTo = promise._boundValue();
	    for (var i = 0, len = this._instances.length; i < len; ++i) {
	        var item = this._instances[i];
	        var itemIsErrorType = item === Error ||
	            (item != null && item.prototype instanceof Error);
	
	        if (itemIsErrorType && e instanceof item) {
	            var ret = tryCatch(cb).call(boundTo, e);
	            if (ret === errorObj) {
	                NEXT_FILTER.e = ret.e;
	                return NEXT_FILTER;
	            }
	            return ret;
	        } else if (typeof item === "function" && !itemIsErrorType) {
	            var shouldHandle = safePredicate(item, e);
	            if (shouldHandle === errorObj) {
	                e = errorObj.e;
	                break;
	            } else if (shouldHandle) {
	                var ret = tryCatch(cb).call(boundTo, e);
	                if (ret === errorObj) {
	                    NEXT_FILTER.e = ret.e;
	                    return NEXT_FILTER;
	                }
	                return ret;
	            }
	        }
	    }
	    NEXT_FILTER.e = e;
	    return NEXT_FILTER;
	};
	
	return CatchFilter;
	};
	
	},{"./errors.js":13,"./es5.js":14,"./util.js":38}],9:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, CapturedTrace, isDebugging) {
	var contextStack = [];
	function Context() {
	    this._trace = new CapturedTrace(peekContext());
	}
	Context.prototype._pushContext = function () {
	    if (!isDebugging()) return;
	    if (this._trace !== undefined) {
	        contextStack.push(this._trace);
	    }
	};
	
	Context.prototype._popContext = function () {
	    if (!isDebugging()) return;
	    if (this._trace !== undefined) {
	        contextStack.pop();
	    }
	};
	
	function createContext() {
	    if (isDebugging()) return new Context();
	}
	
	function peekContext() {
	    var lastIndex = contextStack.length - 1;
	    if (lastIndex >= 0) {
	        return contextStack[lastIndex];
	    }
	    return undefined;
	}
	
	Promise.prototype._peekContext = peekContext;
	Promise.prototype._pushContext = Context.prototype._pushContext;
	Promise.prototype._popContext = Context.prototype._popContext;
	
	return createContext;
	};
	
	},{}],10:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, CapturedTrace) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var Warning = _dereq_("./errors.js").Warning;
	var util = _dereq_("./util.js");
	var canAttachTrace = util.canAttachTrace;
	var unhandledRejectionHandled;
	var possiblyUnhandledRejection;
	var debugging = false || (util.isNode &&
	                    (!!({"BROWSER":true,"NODE_ENV":"production","PRODUCT":"assetportal"})["BLUEBIRD_DEBUG"] ||
	                     ({"BROWSER":true,"NODE_ENV":"production","PRODUCT":"assetportal"})["NODE_ENV"] === "development"));
	
	if (util.isNode && ({"BROWSER":true,"NODE_ENV":"production","PRODUCT":"assetportal"})["BLUEBIRD_DEBUG"] == 0) debugging = false;
	
	if (debugging) {
	    async.disableTrampolineIfNecessary();
	}
	
	Promise.prototype._ignoreRejections = function() {
	    this._unsetRejectionIsUnhandled();
	    this._bitField = this._bitField | 16777216;
	};
	
	Promise.prototype._ensurePossibleRejectionHandled = function () {
	    if ((this._bitField & 16777216) !== 0) return;
	    this._setRejectionIsUnhandled();
	    async.invokeLater(this._notifyUnhandledRejection, this, undefined);
	};
	
	Promise.prototype._notifyUnhandledRejectionIsHandled = function () {
	    CapturedTrace.fireRejectionEvent("rejectionHandled",
	                                  unhandledRejectionHandled, undefined, this);
	};
	
	Promise.prototype._notifyUnhandledRejection = function () {
	    if (this._isRejectionUnhandled()) {
	        var reason = this._getCarriedStackTrace() || this._settledValue;
	        this._setUnhandledRejectionIsNotified();
	        CapturedTrace.fireRejectionEvent("unhandledRejection",
	                                      possiblyUnhandledRejection, reason, this);
	    }
	};
	
	Promise.prototype._setUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField | 524288;
	};
	
	Promise.prototype._unsetUnhandledRejectionIsNotified = function () {
	    this._bitField = this._bitField & (~524288);
	};
	
	Promise.prototype._isUnhandledRejectionNotified = function () {
	    return (this._bitField & 524288) > 0;
	};
	
	Promise.prototype._setRejectionIsUnhandled = function () {
	    this._bitField = this._bitField | 2097152;
	};
	
	Promise.prototype._unsetRejectionIsUnhandled = function () {
	    this._bitField = this._bitField & (~2097152);
	    if (this._isUnhandledRejectionNotified()) {
	        this._unsetUnhandledRejectionIsNotified();
	        this._notifyUnhandledRejectionIsHandled();
	    }
	};
	
	Promise.prototype._isRejectionUnhandled = function () {
	    return (this._bitField & 2097152) > 0;
	};
	
	Promise.prototype._setCarriedStackTrace = function (capturedTrace) {
	    this._bitField = this._bitField | 1048576;
	    this._fulfillmentHandler0 = capturedTrace;
	};
	
	Promise.prototype._isCarryingStackTrace = function () {
	    return (this._bitField & 1048576) > 0;
	};
	
	Promise.prototype._getCarriedStackTrace = function () {
	    return this._isCarryingStackTrace()
	        ? this._fulfillmentHandler0
	        : undefined;
	};
	
	Promise.prototype._captureStackTrace = function () {
	    if (debugging) {
	        this._trace = new CapturedTrace(this._peekContext());
	    }
	    return this;
	};
	
	Promise.prototype._attachExtraTrace = function (error, ignoreSelf) {
	    if (debugging && canAttachTrace(error)) {
	        var trace = this._trace;
	        if (trace !== undefined) {
	            if (ignoreSelf) trace = trace._parent;
	        }
	        if (trace !== undefined) {
	            trace.attachExtraTrace(error);
	        } else if (!error.__stackCleaned__) {
	            var parsed = CapturedTrace.parseStackAndMessage(error);
	            util.notEnumerableProp(error, "stack",
	                parsed.message + "\n" + parsed.stack.join("\n"));
	            util.notEnumerableProp(error, "__stackCleaned__", true);
	        }
	    }
	};
	
	Promise.prototype._warn = function(message) {
	    var warning = new Warning(message);
	    var ctx = this._peekContext();
	    if (ctx) {
	        ctx.attachExtraTrace(warning);
	    } else {
	        var parsed = CapturedTrace.parseStackAndMessage(warning);
	        warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
	    }
	    CapturedTrace.formatAndLogError(warning, "");
	};
	
	Promise.onPossiblyUnhandledRejection = function (fn) {
	    var domain = getDomain();
	    possiblyUnhandledRejection =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.onUnhandledRejectionHandled = function (fn) {
	    var domain = getDomain();
	    unhandledRejectionHandled =
	        typeof fn === "function" ? (domain === null ? fn : domain.bind(fn))
	                                 : undefined;
	};
	
	Promise.longStackTraces = function () {
	    if (async.haveItemsQueued() &&
	        debugging === false
	   ) {
	        throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/DT1qyG\u000a");
	    }
	    debugging = CapturedTrace.isSupported();
	    if (debugging) {
	        async.disableTrampolineIfNecessary();
	    }
	};
	
	Promise.hasLongStackTraces = function () {
	    return debugging && CapturedTrace.isSupported();
	};
	
	if (!CapturedTrace.isSupported()) {
	    Promise.longStackTraces = function(){};
	    debugging = false;
	}
	
	return function() {
	    return debugging;
	};
	};
	
	},{"./async.js":2,"./errors.js":13,"./util.js":38}],11:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util.js");
	var isPrimitive = util.isPrimitive;
	
	module.exports = function(Promise) {
	var returner = function () {
	    return this;
	};
	var thrower = function () {
	    throw this;
	};
	var returnUndefined = function() {};
	var throwUndefined = function() {
	    throw undefined;
	};
	
	var wrapper = function (value, action) {
	    if (action === 1) {
	        return function () {
	            throw value;
	        };
	    } else if (action === 2) {
	        return function () {
	            return value;
	        };
	    }
	};
	
	
	Promise.prototype["return"] =
	Promise.prototype.thenReturn = function (value) {
	    if (value === undefined) return this.then(returnUndefined);
	
	    if (isPrimitive(value)) {
	        return this._then(
	            wrapper(value, 2),
	            undefined,
	            undefined,
	            undefined,
	            undefined
	       );
	    } else if (value instanceof Promise) {
	        value._ignoreRejections();
	    }
	    return this._then(returner, undefined, undefined, value, undefined);
	};
	
	Promise.prototype["throw"] =
	Promise.prototype.thenThrow = function (reason) {
	    if (reason === undefined) return this.then(throwUndefined);
	
	    if (isPrimitive(reason)) {
	        return this._then(
	            wrapper(reason, 1),
	            undefined,
	            undefined,
	            undefined,
	            undefined
	       );
	    }
	    return this._then(thrower, undefined, undefined, reason, undefined);
	};
	};
	
	},{"./util.js":38}],12:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseReduce = Promise.reduce;
	
	Promise.prototype.each = function (fn) {
	    return PromiseReduce(this, fn, null, INTERNAL);
	};
	
	Promise.each = function (promises, fn) {
	    return PromiseReduce(promises, fn, null, INTERNAL);
	};
	};
	
	},{}],13:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5.js");
	var Objectfreeze = es5.freeze;
	var util = _dereq_("./util.js");
	var inherits = util.inherits;
	var notEnumerableProp = util.notEnumerableProp;
	
	function subError(nameProperty, defaultMessage) {
	    function SubError(message) {
	        if (!(this instanceof SubError)) return new SubError(message);
	        notEnumerableProp(this, "message",
	            typeof message === "string" ? message : defaultMessage);
	        notEnumerableProp(this, "name", nameProperty);
	        if (Error.captureStackTrace) {
	            Error.captureStackTrace(this, this.constructor);
	        } else {
	            Error.call(this);
	        }
	    }
	    inherits(SubError, Error);
	    return SubError;
	}
	
	var _TypeError, _RangeError;
	var Warning = subError("Warning", "warning");
	var CancellationError = subError("CancellationError", "cancellation error");
	var TimeoutError = subError("TimeoutError", "timeout error");
	var AggregateError = subError("AggregateError", "aggregate error");
	try {
	    _TypeError = TypeError;
	    _RangeError = RangeError;
	} catch(e) {
	    _TypeError = subError("TypeError", "type error");
	    _RangeError = subError("RangeError", "range error");
	}
	
	var methods = ("join pop push shift unshift slice filter forEach some " +
	    "every map indexOf lastIndexOf reduce reduceRight sort reverse").split(" ");
	
	for (var i = 0; i < methods.length; ++i) {
	    if (typeof Array.prototype[methods[i]] === "function") {
	        AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
	    }
	}
	
	es5.defineProperty(AggregateError.prototype, "length", {
	    value: 0,
	    configurable: false,
	    writable: true,
	    enumerable: true
	});
	AggregateError.prototype["isOperational"] = true;
	var level = 0;
	AggregateError.prototype.toString = function() {
	    var indent = Array(level * 4 + 1).join(" ");
	    var ret = "\n" + indent + "AggregateError of:" + "\n";
	    level++;
	    indent = Array(level * 4 + 1).join(" ");
	    for (var i = 0; i < this.length; ++i) {
	        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
	        var lines = str.split("\n");
	        for (var j = 0; j < lines.length; ++j) {
	            lines[j] = indent + lines[j];
	        }
	        str = lines.join("\n");
	        ret += str + "\n";
	    }
	    level--;
	    return ret;
	};
	
	function OperationalError(message) {
	    if (!(this instanceof OperationalError))
	        return new OperationalError(message);
	    notEnumerableProp(this, "name", "OperationalError");
	    notEnumerableProp(this, "message", message);
	    this.cause = message;
	    this["isOperational"] = true;
	
	    if (message instanceof Error) {
	        notEnumerableProp(this, "message", message.message);
	        notEnumerableProp(this, "stack", message.stack);
	    } else if (Error.captureStackTrace) {
	        Error.captureStackTrace(this, this.constructor);
	    }
	
	}
	inherits(OperationalError, Error);
	
	var errorTypes = Error["__BluebirdErrorTypes__"];
	if (!errorTypes) {
	    errorTypes = Objectfreeze({
	        CancellationError: CancellationError,
	        TimeoutError: TimeoutError,
	        OperationalError: OperationalError,
	        RejectionError: OperationalError,
	        AggregateError: AggregateError
	    });
	    notEnumerableProp(Error, "__BluebirdErrorTypes__", errorTypes);
	}
	
	module.exports = {
	    Error: Error,
	    TypeError: _TypeError,
	    RangeError: _RangeError,
	    CancellationError: errorTypes.CancellationError,
	    OperationalError: errorTypes.OperationalError,
	    TimeoutError: errorTypes.TimeoutError,
	    AggregateError: errorTypes.AggregateError,
	    Warning: Warning
	};
	
	},{"./es5.js":14,"./util.js":38}],14:[function(_dereq_,module,exports){
	var isES5 = (function(){
	    "use strict";
	    return this === undefined;
	})();
	
	if (isES5) {
	    module.exports = {
	        freeze: Object.freeze,
	        defineProperty: Object.defineProperty,
	        getDescriptor: Object.getOwnPropertyDescriptor,
	        keys: Object.keys,
	        names: Object.getOwnPropertyNames,
	        getPrototypeOf: Object.getPrototypeOf,
	        isArray: Array.isArray,
	        isES5: isES5,
	        propertyIsWritable: function(obj, prop) {
	            var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
	            return !!(!descriptor || descriptor.writable || descriptor.set);
	        }
	    };
	} else {
	    var has = {}.hasOwnProperty;
	    var str = {}.toString;
	    var proto = {}.constructor.prototype;
	
	    var ObjectKeys = function (o) {
	        var ret = [];
	        for (var key in o) {
	            if (has.call(o, key)) {
	                ret.push(key);
	            }
	        }
	        return ret;
	    };
	
	    var ObjectGetDescriptor = function(o, key) {
	        return {value: o[key]};
	    };
	
	    var ObjectDefineProperty = function (o, key, desc) {
	        o[key] = desc.value;
	        return o;
	    };
	
	    var ObjectFreeze = function (obj) {
	        return obj;
	    };
	
	    var ObjectGetPrototypeOf = function (obj) {
	        try {
	            return Object(obj).constructor.prototype;
	        }
	        catch (e) {
	            return proto;
	        }
	    };
	
	    var ArrayIsArray = function (obj) {
	        try {
	            return str.call(obj) === "[object Array]";
	        }
	        catch(e) {
	            return false;
	        }
	    };
	
	    module.exports = {
	        isArray: ArrayIsArray,
	        keys: ObjectKeys,
	        names: ObjectKeys,
	        defineProperty: ObjectDefineProperty,
	        getDescriptor: ObjectGetDescriptor,
	        freeze: ObjectFreeze,
	        getPrototypeOf: ObjectGetPrototypeOf,
	        isES5: isES5,
	        propertyIsWritable: function() {
	            return true;
	        }
	    };
	}
	
	},{}],15:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var PromiseMap = Promise.map;
	
	Promise.prototype.filter = function (fn, options) {
	    return PromiseMap(this, fn, options, INTERNAL);
	};
	
	Promise.filter = function (promises, fn, options) {
	    return PromiseMap(promises, fn, options, INTERNAL);
	};
	};
	
	},{}],16:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, NEXT_FILTER, tryConvertToPromise) {
	var util = _dereq_("./util.js");
	var isPrimitive = util.isPrimitive;
	var thrower = util.thrower;
	
	function returnThis() {
	    return this;
	}
	function throwThis() {
	    throw this;
	}
	function return$(r) {
	    return function() {
	        return r;
	    };
	}
	function throw$(r) {
	    return function() {
	        throw r;
	    };
	}
	function promisedFinally(ret, reasonOrValue, isFulfilled) {
	    var then;
	    if (isPrimitive(reasonOrValue)) {
	        then = isFulfilled ? return$(reasonOrValue) : throw$(reasonOrValue);
	    } else {
	        then = isFulfilled ? returnThis : throwThis;
	    }
	    return ret._then(then, thrower, undefined, reasonOrValue, undefined);
	}
	
	function finallyHandler(reasonOrValue) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    var ret = promise._isBound()
	                    ? handler.call(promise._boundValue())
	                    : handler();
	
	    if (ret !== undefined) {
	        var maybePromise = tryConvertToPromise(ret, promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            return promisedFinally(maybePromise, reasonOrValue,
	                                    promise.isFulfilled());
	        }
	    }
	
	    if (promise.isRejected()) {
	        NEXT_FILTER.e = reasonOrValue;
	        return NEXT_FILTER;
	    } else {
	        return reasonOrValue;
	    }
	}
	
	function tapHandler(value) {
	    var promise = this.promise;
	    var handler = this.handler;
	
	    var ret = promise._isBound()
	                    ? handler.call(promise._boundValue(), value)
	                    : handler(value);
	
	    if (ret !== undefined) {
	        var maybePromise = tryConvertToPromise(ret, promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            return promisedFinally(maybePromise, value, true);
	        }
	    }
	    return value;
	}
	
	Promise.prototype._passThroughHandler = function (handler, isFinally) {
	    if (typeof handler !== "function") return this.then();
	
	    var promiseAndHandler = {
	        promise: this,
	        handler: handler
	    };
	
	    return this._then(
	            isFinally ? finallyHandler : tapHandler,
	            isFinally ? finallyHandler : undefined, undefined,
	            promiseAndHandler, undefined);
	};
	
	Promise.prototype.lastly =
	Promise.prototype["finally"] = function (handler) {
	    return this._passThroughHandler(handler, true);
	};
	
	Promise.prototype.tap = function (handler) {
	    return this._passThroughHandler(handler, false);
	};
	};
	
	},{"./util.js":38}],17:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          apiRejection,
	                          INTERNAL,
	                          tryConvertToPromise) {
	var errors = _dereq_("./errors.js");
	var TypeError = errors.TypeError;
	var util = _dereq_("./util.js");
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	var yieldHandlers = [];
	
	function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
	    for (var i = 0; i < yieldHandlers.length; ++i) {
	        traceParent._pushContext();
	        var result = tryCatch(yieldHandlers[i])(value);
	        traceParent._popContext();
	        if (result === errorObj) {
	            traceParent._pushContext();
	            var ret = Promise.reject(errorObj.e);
	            traceParent._popContext();
	            return ret;
	        }
	        var maybePromise = tryConvertToPromise(result, traceParent);
	        if (maybePromise instanceof Promise) return maybePromise;
	    }
	    return null;
	}
	
	function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
	    var promise = this._promise = new Promise(INTERNAL);
	    promise._captureStackTrace();
	    this._stack = stack;
	    this._generatorFunction = generatorFunction;
	    this._receiver = receiver;
	    this._generator = undefined;
	    this._yieldHandlers = typeof yieldHandler === "function"
	        ? [yieldHandler].concat(yieldHandlers)
	        : yieldHandlers;
	}
	
	PromiseSpawn.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseSpawn.prototype._run = function () {
	    this._generator = this._generatorFunction.call(this._receiver);
	    this._receiver =
	        this._generatorFunction = undefined;
	    this._next(undefined);
	};
	
	PromiseSpawn.prototype._continue = function (result) {
	    if (result === errorObj) {
	        return this._promise._rejectCallback(result.e, false, true);
	    }
	
	    var value = result.value;
	    if (result.done === true) {
	        this._promise._resolveCallback(value);
	    } else {
	        var maybePromise = tryConvertToPromise(value, this._promise);
	        if (!(maybePromise instanceof Promise)) {
	            maybePromise =
	                promiseFromYieldHandler(maybePromise,
	                                        this._yieldHandlers,
	                                        this._promise);
	            if (maybePromise === null) {
	                this._throw(
	                    new TypeError(
	                        "A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/4Y4pDk\u000a\u000a".replace("%s", value) +
	                        "From coroutine:\u000a" +
	                        this._stack.split("\n").slice(1, -7).join("\n")
	                    )
	                );
	                return;
	            }
	        }
	        maybePromise._then(
	            this._next,
	            this._throw,
	            undefined,
	            this,
	            null
	       );
	    }
	};
	
	PromiseSpawn.prototype._throw = function (reason) {
	    this._promise._attachExtraTrace(reason);
	    this._promise._pushContext();
	    var result = tryCatch(this._generator["throw"])
	        .call(this._generator, reason);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	PromiseSpawn.prototype._next = function (value) {
	    this._promise._pushContext();
	    var result = tryCatch(this._generator.next).call(this._generator, value);
	    this._promise._popContext();
	    this._continue(result);
	};
	
	Promise.coroutine = function (generatorFunction, options) {
	    if (typeof generatorFunction !== "function") {
	        throw new TypeError("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
	    }
	    var yieldHandler = Object(options).yieldHandler;
	    var PromiseSpawn$ = PromiseSpawn;
	    var stack = new Error().stack;
	    return function () {
	        var generator = generatorFunction.apply(this, arguments);
	        var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler,
	                                      stack);
	        spawn._generator = generator;
	        spawn._next(undefined);
	        return spawn.promise();
	    };
	};
	
	Promise.coroutine.addYieldHandler = function(fn) {
	    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    yieldHandlers.push(fn);
	};
	
	Promise.spawn = function (generatorFunction) {
	    if (typeof generatorFunction !== "function") {
	        return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/6Vqhm0\u000a");
	    }
	    var spawn = new PromiseSpawn(generatorFunction, this);
	    var ret = spawn.promise();
	    spawn._run(Promise.spawn);
	    return ret;
	};
	};
	
	},{"./errors.js":13,"./util.js":38}],18:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, tryConvertToPromise, INTERNAL) {
	var util = _dereq_("./util.js");
	var canEvaluate = util.canEvaluate;
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var reject;
	
	if (false) {
	if (canEvaluate) {
	    var thenCallback = function(i) {
	        return new Function("value", "holder", "                             \n\
	            'use strict';                                                    \n\
	            holder.pIndex = value;                                           \n\
	            holder.checkFulfillment(this);                                   \n\
	            ".replace(/Index/g, i));
	    };
	
	    var caller = function(count) {
	        var values = [];
	        for (var i = 1; i <= count; ++i) values.push("holder.p" + i);
	        return new Function("holder", "                                      \n\
	            'use strict';                                                    \n\
	            var callback = holder.fn;                                        \n\
	            return callback(values);                                         \n\
	            ".replace(/values/g, values.join(", ")));
	    };
	    var thenCallbacks = [];
	    var callers = [undefined];
	    for (var i = 1; i <= 5; ++i) {
	        thenCallbacks.push(thenCallback(i));
	        callers.push(caller(i));
	    }
	
	    var Holder = function(total, fn) {
	        this.p1 = this.p2 = this.p3 = this.p4 = this.p5 = null;
	        this.fn = fn;
	        this.total = total;
	        this.now = 0;
	    };
	
	    Holder.prototype.callers = callers;
	    Holder.prototype.checkFulfillment = function(promise) {
	        var now = this.now;
	        now++;
	        var total = this.total;
	        if (now >= total) {
	            var handler = this.callers[total];
	            promise._pushContext();
	            var ret = tryCatch(handler)(this);
	            promise._popContext();
	            if (ret === errorObj) {
	                promise._rejectCallback(ret.e, false, true);
	            } else {
	                promise._resolveCallback(ret);
	            }
	        } else {
	            this.now = now;
	        }
	    };
	
	    var reject = function (reason) {
	        this._reject(reason);
	    };
	}
	}
	
	Promise.join = function () {
	    var last = arguments.length - 1;
	    var fn;
	    if (last > 0 && typeof arguments[last] === "function") {
	        fn = arguments[last];
	        if (false) {
	            if (last < 6 && canEvaluate) {
	                var ret = new Promise(INTERNAL);
	                ret._captureStackTrace();
	                var holder = new Holder(last, fn);
	                var callbacks = thenCallbacks;
	                for (var i = 0; i < last; ++i) {
	                    var maybePromise = tryConvertToPromise(arguments[i], ret);
	                    if (maybePromise instanceof Promise) {
	                        maybePromise = maybePromise._target();
	                        if (maybePromise._isPending()) {
	                            maybePromise._then(callbacks[i], reject,
	                                               undefined, ret, holder);
	                        } else if (maybePromise._isFulfilled()) {
	                            callbacks[i].call(ret,
	                                              maybePromise._value(), holder);
	                        } else {
	                            ret._reject(maybePromise._reason());
	                        }
	                    } else {
	                        callbacks[i].call(ret, maybePromise, holder);
	                    }
	                }
	                return ret;
	            }
	        }
	    }
	    var $_len = arguments.length;var args = new Array($_len); for(var $_i = 0; $_i < $_len; ++$_i) {args[$_i] = arguments[$_i];}
	    if (fn) args.pop();
	    var ret = new PromiseArray(args).promise();
	    return fn !== undefined ? ret.spread(fn) : ret;
	};
	
	};
	
	},{"./util.js":38}],19:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	var PENDING = {};
	var EMPTY_ARRAY = [];
	
	function MappingPromiseArray(promises, fn, limit, _filter) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    var domain = getDomain();
	    this._callback = domain === null ? fn : domain.bind(fn);
	    this._preservedValues = _filter === INTERNAL
	        ? new Array(this.length())
	        : null;
	    this._limit = limit;
	    this._inFlight = 0;
	    this._queue = limit >= 1 ? [] : EMPTY_ARRAY;
	    async.invoke(init, this, undefined);
	}
	util.inherits(MappingPromiseArray, PromiseArray);
	function init() {this._init$(undefined, -2);}
	
	MappingPromiseArray.prototype._init = function () {};
	
	MappingPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var limit = this._limit;
	    if (values[index] === PENDING) {
	        values[index] = value;
	        if (limit >= 1) {
	            this._inFlight--;
	            this._drainQueue();
	            if (this._isResolved()) return;
	        }
	    } else {
	        if (limit >= 1 && this._inFlight >= limit) {
	            values[index] = value;
	            this._queue.push(index);
	            return;
	        }
	        if (preservedValues !== null) preservedValues[index] = value;
	
	        var callback = this._callback;
	        var receiver = this._promise._boundValue();
	        this._promise._pushContext();
	        var ret = tryCatch(callback).call(receiver, value, index, length);
	        this._promise._popContext();
	        if (ret === errorObj) return this._reject(ret.e);
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (maybePromise._isPending()) {
	                if (limit >= 1) this._inFlight++;
	                values[index] = PENDING;
	                return maybePromise._proxyPromiseArray(this, index);
	            } else if (maybePromise._isFulfilled()) {
	                ret = maybePromise._value();
	            } else {
	                return this._reject(maybePromise._reason());
	            }
	        }
	        values[index] = ret;
	    }
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= length) {
	        if (preservedValues !== null) {
	            this._filter(values, preservedValues);
	        } else {
	            this._resolve(values);
	        }
	
	    }
	};
	
	MappingPromiseArray.prototype._drainQueue = function () {
	    var queue = this._queue;
	    var limit = this._limit;
	    var values = this._values;
	    while (queue.length > 0 && this._inFlight < limit) {
	        if (this._isResolved()) return;
	        var index = queue.pop();
	        this._promiseFulfilled(values[index], index);
	    }
	};
	
	MappingPromiseArray.prototype._filter = function (booleans, values) {
	    var len = values.length;
	    var ret = new Array(len);
	    var j = 0;
	    for (var i = 0; i < len; ++i) {
	        if (booleans[i]) ret[j++] = values[i];
	    }
	    ret.length = j;
	    this._resolve(ret);
	};
	
	MappingPromiseArray.prototype.preservedValues = function () {
	    return this._preservedValues;
	};
	
	function map(promises, fn, options, _filter) {
	    var limit = typeof options === "object" && options !== null
	        ? options.concurrency
	        : 0;
	    limit = typeof limit === "number" &&
	        isFinite(limit) && limit >= 1 ? limit : 0;
	    return new MappingPromiseArray(promises, fn, limit, _filter);
	}
	
	Promise.prototype.map = function (fn, options) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	
	    return map(this, fn, options, null).promise();
	};
	
	Promise.map = function (promises, fn, options, _filter) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    return map(promises, fn, options, _filter).promise();
	};
	
	
	};
	
	},{"./async.js":2,"./util.js":38}],20:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	
	Promise.method = function (fn) {
	    if (typeof fn !== "function") {
	        throw new Promise.TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    return function () {
	        var ret = new Promise(INTERNAL);
	        ret._captureStackTrace();
	        ret._pushContext();
	        var value = tryCatch(fn).apply(this, arguments);
	        ret._popContext();
	        ret._resolveFromSyncValue(value);
	        return ret;
	    };
	};
	
	Promise.attempt = Promise["try"] = function (fn, args, ctx) {
	    if (typeof fn !== "function") {
	        return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._pushContext();
	    var value = util.isArray(args)
	        ? tryCatch(fn).apply(ctx, args)
	        : tryCatch(fn).call(ctx, args);
	    ret._popContext();
	    ret._resolveFromSyncValue(value);
	    return ret;
	};
	
	Promise.prototype._resolveFromSyncValue = function (value) {
	    if (value === util.errorObj) {
	        this._rejectCallback(value.e, false, true);
	    } else {
	        this._resolveCallback(value, true);
	    }
	};
	};
	
	},{"./util.js":38}],21:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	var util = _dereq_("./util.js");
	var async = _dereq_("./async.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	function spreadAdapter(val, nodeback) {
	    var promise = this;
	    if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
	    var ret =
	        tryCatch(nodeback).apply(promise._boundValue(), [null].concat(val));
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	function successAdapter(val, nodeback) {
	    var promise = this;
	    var receiver = promise._boundValue();
	    var ret = val === undefined
	        ? tryCatch(nodeback).call(receiver, null)
	        : tryCatch(nodeback).call(receiver, null, val);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	function errorAdapter(reason, nodeback) {
	    var promise = this;
	    if (!reason) {
	        var target = promise._target();
	        var newReason = target._getCarriedStackTrace();
	        newReason.cause = reason;
	        reason = newReason;
	    }
	    var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
	    if (ret === errorObj) {
	        async.throwLater(ret.e);
	    }
	}
	
	Promise.prototype.asCallback =
	Promise.prototype.nodeify = function (nodeback, options) {
	    if (typeof nodeback == "function") {
	        var adapter = successAdapter;
	        if (options !== undefined && Object(options).spread) {
	            adapter = spreadAdapter;
	        }
	        this._then(
	            adapter,
	            errorAdapter,
	            undefined,
	            this,
	            nodeback
	        );
	    }
	    return this;
	};
	};
	
	},{"./async.js":2,"./util.js":38}],22:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, PromiseArray) {
	var util = _dereq_("./util.js");
	var async = _dereq_("./async.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	
	Promise.prototype.progressed = function (handler) {
	    return this._then(undefined, undefined, handler, undefined, undefined);
	};
	
	Promise.prototype._progress = function (progressValue) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._target()._progressUnchecked(progressValue);
	
	};
	
	Promise.prototype._progressHandlerAt = function (index) {
	    return index === 0
	        ? this._progressHandler0
	        : this[(index << 2) + index - 5 + 2];
	};
	
	Promise.prototype._doProgressWith = function (progression) {
	    var progressValue = progression.value;
	    var handler = progression.handler;
	    var promise = progression.promise;
	    var receiver = progression.receiver;
	
	    var ret = tryCatch(handler).call(receiver, progressValue);
	    if (ret === errorObj) {
	        if (ret.e != null &&
	            ret.e.name !== "StopProgressPropagation") {
	            var trace = util.canAttachTrace(ret.e)
	                ? ret.e : new Error(util.toString(ret.e));
	            promise._attachExtraTrace(trace);
	            promise._progress(ret.e);
	        }
	    } else if (ret instanceof Promise) {
	        ret._then(promise._progress, null, null, promise, undefined);
	    } else {
	        promise._progress(ret);
	    }
	};
	
	
	Promise.prototype._progressUnchecked = function (progressValue) {
	    var len = this._length();
	    var progress = this._progress;
	    for (var i = 0; i < len; i++) {
	        var handler = this._progressHandlerAt(i);
	        var promise = this._promiseAt(i);
	        if (!(promise instanceof Promise)) {
	            var receiver = this._receiverAt(i);
	            if (typeof handler === "function") {
	                handler.call(receiver, progressValue, promise);
	            } else if (receiver instanceof PromiseArray &&
	                       !receiver._isResolved()) {
	                receiver._promiseProgressed(progressValue, promise);
	            }
	            continue;
	        }
	
	        if (typeof handler === "function") {
	            async.invoke(this._doProgressWith, this, {
	                handler: handler,
	                promise: promise,
	                receiver: this._receiverAt(i),
	                value: progressValue
	            });
	        } else {
	            async.invoke(progress, promise, progressValue);
	        }
	    }
	};
	};
	
	},{"./async.js":2,"./util.js":38}],23:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function() {
	var makeSelfResolutionError = function () {
	    return new TypeError("circular promise resolution chain\u000a\u000a    See http://goo.gl/LhFpo0\u000a");
	};
	var reflect = function() {
	    return new Promise.PromiseInspection(this._target());
	};
	var apiRejection = function(msg) {
	    return Promise.reject(new TypeError(msg));
	};
	
	var util = _dereq_("./util.js");
	
	var getDomain;
	if (util.isNode) {
	    getDomain = function() {
	        var ret = process.domain;
	        if (ret === undefined) ret = null;
	        return ret;
	    };
	} else {
	    getDomain = function() {
	        return null;
	    };
	}
	util.notEnumerableProp(Promise, "_getDomain", getDomain);
	
	var UNDEFINED_BINDING = {};
	var async = _dereq_("./async.js");
	var errors = _dereq_("./errors.js");
	var TypeError = Promise.TypeError = errors.TypeError;
	Promise.RangeError = errors.RangeError;
	Promise.CancellationError = errors.CancellationError;
	Promise.TimeoutError = errors.TimeoutError;
	Promise.OperationalError = errors.OperationalError;
	Promise.RejectionError = errors.OperationalError;
	Promise.AggregateError = errors.AggregateError;
	var INTERNAL = function(){};
	var APPLY = {};
	var NEXT_FILTER = {e: null};
	var tryConvertToPromise = _dereq_("./thenables.js")(Promise, INTERNAL);
	var PromiseArray =
	    _dereq_("./promise_array.js")(Promise, INTERNAL,
	                                    tryConvertToPromise, apiRejection);
	var CapturedTrace = _dereq_("./captured_trace.js")();
	var isDebugging = _dereq_("./debuggability.js")(Promise, CapturedTrace);
	 /*jshint unused:false*/
	var createContext =
	    _dereq_("./context.js")(Promise, CapturedTrace, isDebugging);
	var CatchFilter = _dereq_("./catch_filter.js")(NEXT_FILTER);
	var PromiseResolver = _dereq_("./promise_resolver.js");
	var nodebackForPromise = PromiseResolver._nodebackForPromise;
	var errorObj = util.errorObj;
	var tryCatch = util.tryCatch;
	
	function Promise(resolver) {
	    if (typeof resolver !== "function") {
	        throw new TypeError("the promise constructor requires a resolver function\u000a\u000a    See http://goo.gl/EC22Yn\u000a");
	    }
	    if (this.constructor !== Promise) {
	        throw new TypeError("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/KsIlge\u000a");
	    }
	    this._bitField = 0;
	    this._fulfillmentHandler0 = undefined;
	    this._rejectionHandler0 = undefined;
	    this._progressHandler0 = undefined;
	    this._promise0 = undefined;
	    this._receiver0 = undefined;
	    this._settledValue = undefined;
	    if (resolver !== INTERNAL) this._resolveFromResolver(resolver);
	}
	
	Promise.prototype.toString = function () {
	    return "[object Promise]";
	};
	
	Promise.prototype.caught = Promise.prototype["catch"] = function (fn) {
	    var len = arguments.length;
	    if (len > 1) {
	        var catchInstances = new Array(len - 1),
	            j = 0, i;
	        for (i = 0; i < len - 1; ++i) {
	            var item = arguments[i];
	            if (typeof item === "function") {
	                catchInstances[j++] = item;
	            } else {
	                return Promise.reject(
	                    new TypeError("Catch filter must inherit from Error or be a simple predicate function\u000a\u000a    See http://goo.gl/o84o68\u000a"));
	            }
	        }
	        catchInstances.length = j;
	        fn = arguments[i];
	        var catchFilter = new CatchFilter(catchInstances, fn, this);
	        return this._then(undefined, catchFilter.doFilter, undefined,
	            catchFilter, undefined);
	    }
	    return this._then(undefined, fn, undefined, undefined, undefined);
	};
	
	Promise.prototype.reflect = function () {
	    return this._then(reflect, reflect, undefined, this, undefined);
	};
	
	Promise.prototype.then = function (didFulfill, didReject, didProgress) {
	    if (isDebugging() && arguments.length > 0 &&
	        typeof didFulfill !== "function" &&
	        typeof didReject !== "function") {
	        var msg = ".then() only accepts functions but was passed: " +
	                util.classString(didFulfill);
	        if (arguments.length > 1) {
	            msg += ", " + util.classString(didReject);
	        }
	        this._warn(msg);
	    }
	    return this._then(didFulfill, didReject, didProgress,
	        undefined, undefined);
	};
	
	Promise.prototype.done = function (didFulfill, didReject, didProgress) {
	    var promise = this._then(didFulfill, didReject, didProgress,
	        undefined, undefined);
	    promise._setIsFinal();
	};
	
	Promise.prototype.spread = function (didFulfill, didReject) {
	    return this.all()._then(didFulfill, didReject, undefined, APPLY, undefined);
	};
	
	Promise.prototype.isCancellable = function () {
	    return !this.isResolved() &&
	        this._cancellable();
	};
	
	Promise.prototype.toJSON = function () {
	    var ret = {
	        isFulfilled: false,
	        isRejected: false,
	        fulfillmentValue: undefined,
	        rejectionReason: undefined
	    };
	    if (this.isFulfilled()) {
	        ret.fulfillmentValue = this.value();
	        ret.isFulfilled = true;
	    } else if (this.isRejected()) {
	        ret.rejectionReason = this.reason();
	        ret.isRejected = true;
	    }
	    return ret;
	};
	
	Promise.prototype.all = function () {
	    return new PromiseArray(this).promise();
	};
	
	Promise.prototype.error = function (fn) {
	    return this.caught(util.originatesFromRejection, fn);
	};
	
	Promise.getNewLibraryCopy = module.exports;
	
	Promise.is = function (val) {
	    return val instanceof Promise;
	};
	
	Promise.fromNode = function(fn) {
	    var ret = new Promise(INTERNAL);
	    var result = tryCatch(fn)(nodebackForPromise(ret));
	    if (result === errorObj) {
	        ret._rejectCallback(result.e, true, true);
	    }
	    return ret;
	};
	
	Promise.all = function (promises) {
	    return new PromiseArray(promises).promise();
	};
	
	Promise.defer = Promise.pending = function () {
	    var promise = new Promise(INTERNAL);
	    return new PromiseResolver(promise);
	};
	
	Promise.cast = function (obj) {
	    var ret = tryConvertToPromise(obj);
	    if (!(ret instanceof Promise)) {
	        var val = ret;
	        ret = new Promise(INTERNAL);
	        ret._fulfillUnchecked(val);
	    }
	    return ret;
	};
	
	Promise.resolve = Promise.fulfilled = Promise.cast;
	
	Promise.reject = Promise.rejected = function (reason) {
	    var ret = new Promise(INTERNAL);
	    ret._captureStackTrace();
	    ret._rejectCallback(reason, true);
	    return ret;
	};
	
	Promise.setScheduler = function(fn) {
	    if (typeof fn !== "function") throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    var prev = async._schedule;
	    async._schedule = fn;
	    return prev;
	};
	
	Promise.prototype._then = function (
	    didFulfill,
	    didReject,
	    didProgress,
	    receiver,
	    internalData
	) {
	    var haveInternalData = internalData !== undefined;
	    var ret = haveInternalData ? internalData : new Promise(INTERNAL);
	
	    if (!haveInternalData) {
	        ret._propagateFrom(this, 4 | 1);
	        ret._captureStackTrace();
	    }
	
	    var target = this._target();
	    if (target !== this) {
	        if (receiver === undefined) receiver = this._boundTo;
	        if (!haveInternalData) ret._setIsMigrated();
	    }
	
	    var callbackIndex = target._addCallbacks(didFulfill,
	                                             didReject,
	                                             didProgress,
	                                             ret,
	                                             receiver,
	                                             getDomain());
	
	    if (target._isResolved() && !target._isSettlePromisesQueued()) {
	        async.invoke(
	            target._settlePromiseAtPostResolution, target, callbackIndex);
	    }
	
	    return ret;
	};
	
	Promise.prototype._settlePromiseAtPostResolution = function (index) {
	    if (this._isRejectionUnhandled()) this._unsetRejectionIsUnhandled();
	    this._settlePromiseAt(index);
	};
	
	Promise.prototype._length = function () {
	    return this._bitField & 131071;
	};
	
	Promise.prototype._isFollowingOrFulfilledOrRejected = function () {
	    return (this._bitField & 939524096) > 0;
	};
	
	Promise.prototype._isFollowing = function () {
	    return (this._bitField & 536870912) === 536870912;
	};
	
	Promise.prototype._setLength = function (len) {
	    this._bitField = (this._bitField & -131072) |
	        (len & 131071);
	};
	
	Promise.prototype._setFulfilled = function () {
	    this._bitField = this._bitField | 268435456;
	};
	
	Promise.prototype._setRejected = function () {
	    this._bitField = this._bitField | 134217728;
	};
	
	Promise.prototype._setFollowing = function () {
	    this._bitField = this._bitField | 536870912;
	};
	
	Promise.prototype._setIsFinal = function () {
	    this._bitField = this._bitField | 33554432;
	};
	
	Promise.prototype._isFinal = function () {
	    return (this._bitField & 33554432) > 0;
	};
	
	Promise.prototype._cancellable = function () {
	    return (this._bitField & 67108864) > 0;
	};
	
	Promise.prototype._setCancellable = function () {
	    this._bitField = this._bitField | 67108864;
	};
	
	Promise.prototype._unsetCancellable = function () {
	    this._bitField = this._bitField & (~67108864);
	};
	
	Promise.prototype._setIsMigrated = function () {
	    this._bitField = this._bitField | 4194304;
	};
	
	Promise.prototype._unsetIsMigrated = function () {
	    this._bitField = this._bitField & (~4194304);
	};
	
	Promise.prototype._isMigrated = function () {
	    return (this._bitField & 4194304) > 0;
	};
	
	Promise.prototype._receiverAt = function (index) {
	    var ret = index === 0
	        ? this._receiver0
	        : this[
	            index * 5 - 5 + 4];
	    if (ret === UNDEFINED_BINDING) {
	        return undefined;
	    } else if (ret === undefined && this._isBound()) {
	        return this._boundValue();
	    }
	    return ret;
	};
	
	Promise.prototype._promiseAt = function (index) {
	    return index === 0
	        ? this._promise0
	        : this[index * 5 - 5 + 3];
	};
	
	Promise.prototype._fulfillmentHandlerAt = function (index) {
	    return index === 0
	        ? this._fulfillmentHandler0
	        : this[index * 5 - 5 + 0];
	};
	
	Promise.prototype._rejectionHandlerAt = function (index) {
	    return index === 0
	        ? this._rejectionHandler0
	        : this[index * 5 - 5 + 1];
	};
	
	Promise.prototype._boundValue = function() {
	    var ret = this._boundTo;
	    if (ret !== undefined) {
	        if (ret instanceof Promise) {
	            if (ret.isFulfilled()) {
	                return ret.value();
	            } else {
	                return undefined;
	            }
	        }
	    }
	    return ret;
	};
	
	Promise.prototype._migrateCallbacks = function (follower, index) {
	    var fulfill = follower._fulfillmentHandlerAt(index);
	    var reject = follower._rejectionHandlerAt(index);
	    var progress = follower._progressHandlerAt(index);
	    var promise = follower._promiseAt(index);
	    var receiver = follower._receiverAt(index);
	    if (promise instanceof Promise) promise._setIsMigrated();
	    if (receiver === undefined) receiver = UNDEFINED_BINDING;
	    this._addCallbacks(fulfill, reject, progress, promise, receiver, null);
	};
	
	Promise.prototype._addCallbacks = function (
	    fulfill,
	    reject,
	    progress,
	    promise,
	    receiver,
	    domain
	) {
	    var index = this._length();
	
	    if (index >= 131071 - 5) {
	        index = 0;
	        this._setLength(0);
	    }
	
	    if (index === 0) {
	        this._promise0 = promise;
	        if (receiver !== undefined) this._receiver0 = receiver;
	        if (typeof fulfill === "function" && !this._isCarryingStackTrace()) {
	            this._fulfillmentHandler0 =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this._rejectionHandler0 =
	                domain === null ? reject : domain.bind(reject);
	        }
	        if (typeof progress === "function") {
	            this._progressHandler0 =
	                domain === null ? progress : domain.bind(progress);
	        }
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] = promise;
	        this[base + 4] = receiver;
	        if (typeof fulfill === "function") {
	            this[base + 0] =
	                domain === null ? fulfill : domain.bind(fulfill);
	        }
	        if (typeof reject === "function") {
	            this[base + 1] =
	                domain === null ? reject : domain.bind(reject);
	        }
	        if (typeof progress === "function") {
	            this[base + 2] =
	                domain === null ? progress : domain.bind(progress);
	        }
	    }
	    this._setLength(index + 1);
	    return index;
	};
	
	Promise.prototype._setProxyHandlers = function (receiver, promiseSlotValue) {
	    var index = this._length();
	
	    if (index >= 131071 - 5) {
	        index = 0;
	        this._setLength(0);
	    }
	    if (index === 0) {
	        this._promise0 = promiseSlotValue;
	        this._receiver0 = receiver;
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] = promiseSlotValue;
	        this[base + 4] = receiver;
	    }
	    this._setLength(index + 1);
	};
	
	Promise.prototype._proxyPromiseArray = function (promiseArray, index) {
	    this._setProxyHandlers(promiseArray, index);
	};
	
	Promise.prototype._resolveCallback = function(value, shouldBind) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    if (value === this)
	        return this._rejectCallback(makeSelfResolutionError(), false, true);
	    var maybePromise = tryConvertToPromise(value, this);
	    if (!(maybePromise instanceof Promise)) return this._fulfill(value);
	
	    var propagationFlags = 1 | (shouldBind ? 4 : 0);
	    this._propagateFrom(maybePromise, propagationFlags);
	    var promise = maybePromise._target();
	    if (promise._isPending()) {
	        var len = this._length();
	        for (var i = 0; i < len; ++i) {
	            promise._migrateCallbacks(this, i);
	        }
	        this._setFollowing();
	        this._setLength(0);
	        this._setFollowee(promise);
	    } else if (promise._isFulfilled()) {
	        this._fulfillUnchecked(promise._value());
	    } else {
	        this._rejectUnchecked(promise._reason(),
	            promise._getCarriedStackTrace());
	    }
	};
	
	Promise.prototype._rejectCallback =
	function(reason, synchronous, shouldNotMarkOriginatingFromRejection) {
	    if (!shouldNotMarkOriginatingFromRejection) {
	        util.markAsOriginatingFromRejection(reason);
	    }
	    var trace = util.ensureErrorObject(reason);
	    var hasStack = trace === reason;
	    this._attachExtraTrace(trace, synchronous ? hasStack : false);
	    this._reject(reason, hasStack ? undefined : trace);
	};
	
	Promise.prototype._resolveFromResolver = function (resolver) {
	    var promise = this;
	    this._captureStackTrace();
	    this._pushContext();
	    var synchronous = true;
	    var r = tryCatch(resolver)(function(value) {
	        if (promise === null) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }, function (reason) {
	        if (promise === null) return;
	        promise._rejectCallback(reason, synchronous);
	        promise = null;
	    });
	    synchronous = false;
	    this._popContext();
	
	    if (r !== undefined && r === errorObj && promise !== null) {
	        promise._rejectCallback(r.e, true, true);
	        promise = null;
	    }
	};
	
	Promise.prototype._settlePromiseFromHandler = function (
	    handler, receiver, value, promise
	) {
	    if (promise._isRejected()) return;
	    promise._pushContext();
	    var x;
	    if (receiver === APPLY && !this._isRejected()) {
	        x = tryCatch(handler).apply(this._boundValue(), value);
	    } else {
	        x = tryCatch(handler).call(receiver, value);
	    }
	    promise._popContext();
	
	    if (x === errorObj || x === promise || x === NEXT_FILTER) {
	        var err = x === promise ? makeSelfResolutionError() : x.e;
	        promise._rejectCallback(err, false, true);
	    } else {
	        promise._resolveCallback(x);
	    }
	};
	
	Promise.prototype._target = function() {
	    var ret = this;
	    while (ret._isFollowing()) ret = ret._followee();
	    return ret;
	};
	
	Promise.prototype._followee = function() {
	    return this._rejectionHandler0;
	};
	
	Promise.prototype._setFollowee = function(promise) {
	    this._rejectionHandler0 = promise;
	};
	
	Promise.prototype._cleanValues = function () {
	    if (this._cancellable()) {
	        this._cancellationParent = undefined;
	    }
	};
	
	Promise.prototype._propagateFrom = function (parent, flags) {
	    if ((flags & 1) > 0 && parent._cancellable()) {
	        this._setCancellable();
	        this._cancellationParent = parent;
	    }
	    if ((flags & 4) > 0 && parent._isBound()) {
	        this._setBoundTo(parent._boundTo);
	    }
	};
	
	Promise.prototype._fulfill = function (value) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._fulfillUnchecked(value);
	};
	
	Promise.prototype._reject = function (reason, carriedStackTrace) {
	    if (this._isFollowingOrFulfilledOrRejected()) return;
	    this._rejectUnchecked(reason, carriedStackTrace);
	};
	
	Promise.prototype._settlePromiseAt = function (index) {
	    var promise = this._promiseAt(index);
	    var isPromise = promise instanceof Promise;
	
	    if (isPromise && promise._isMigrated()) {
	        promise._unsetIsMigrated();
	        return async.invoke(this._settlePromiseAt, this, index);
	    }
	    var handler = this._isFulfilled()
	        ? this._fulfillmentHandlerAt(index)
	        : this._rejectionHandlerAt(index);
	
	    var carriedStackTrace =
	        this._isCarryingStackTrace() ? this._getCarriedStackTrace() : undefined;
	    var value = this._settledValue;
	    var receiver = this._receiverAt(index);
	    this._clearCallbackDataAtIndex(index);
	
	    if (typeof handler === "function") {
	        if (!isPromise) {
	            handler.call(receiver, value, promise);
	        } else {
	            this._settlePromiseFromHandler(handler, receiver, value, promise);
	        }
	    } else if (receiver instanceof PromiseArray) {
	        if (!receiver._isResolved()) {
	            if (this._isFulfilled()) {
	                receiver._promiseFulfilled(value, promise);
	            }
	            else {
	                receiver._promiseRejected(value, promise);
	            }
	        }
	    } else if (isPromise) {
	        if (this._isFulfilled()) {
	            promise._fulfill(value);
	        } else {
	            promise._reject(value, carriedStackTrace);
	        }
	    }
	
	    if (index >= 4 && (index & 31) === 4)
	        async.invokeLater(this._setLength, this, 0);
	};
	
	Promise.prototype._clearCallbackDataAtIndex = function(index) {
	    if (index === 0) {
	        if (!this._isCarryingStackTrace()) {
	            this._fulfillmentHandler0 = undefined;
	        }
	        this._rejectionHandler0 =
	        this._progressHandler0 =
	        this._receiver0 =
	        this._promise0 = undefined;
	    } else {
	        var base = index * 5 - 5;
	        this[base + 3] =
	        this[base + 4] =
	        this[base + 0] =
	        this[base + 1] =
	        this[base + 2] = undefined;
	    }
	};
	
	Promise.prototype._isSettlePromisesQueued = function () {
	    return (this._bitField &
	            -1073741824) === -1073741824;
	};
	
	Promise.prototype._setSettlePromisesQueued = function () {
	    this._bitField = this._bitField | -1073741824;
	};
	
	Promise.prototype._unsetSettlePromisesQueued = function () {
	    this._bitField = this._bitField & (~-1073741824);
	};
	
	Promise.prototype._queueSettlePromises = function() {
	    async.settlePromises(this);
	    this._setSettlePromisesQueued();
	};
	
	Promise.prototype._fulfillUnchecked = function (value) {
	    if (value === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._rejectUnchecked(err, undefined);
	    }
	    this._setFulfilled();
	    this._settledValue = value;
	    this._cleanValues();
	
	    if (this._length() > 0) {
	        this._queueSettlePromises();
	    }
	};
	
	Promise.prototype._rejectUncheckedCheckError = function (reason) {
	    var trace = util.ensureErrorObject(reason);
	    this._rejectUnchecked(reason, trace === reason ? undefined : trace);
	};
	
	Promise.prototype._rejectUnchecked = function (reason, trace) {
	    if (reason === this) {
	        var err = makeSelfResolutionError();
	        this._attachExtraTrace(err);
	        return this._rejectUnchecked(err);
	    }
	    this._setRejected();
	    this._settledValue = reason;
	    this._cleanValues();
	
	    if (this._isFinal()) {
	        async.throwLater(function(e) {
	            if ("stack" in e) {
	                async.invokeFirst(
	                    CapturedTrace.unhandledRejection, undefined, e);
	            }
	            throw e;
	        }, trace === undefined ? reason : trace);
	        return;
	    }
	
	    if (trace !== undefined && trace !== reason) {
	        this._setCarriedStackTrace(trace);
	    }
	
	    if (this._length() > 0) {
	        this._queueSettlePromises();
	    } else {
	        this._ensurePossibleRejectionHandled();
	    }
	};
	
	Promise.prototype._settlePromises = function () {
	    this._unsetSettlePromisesQueued();
	    var len = this._length();
	    for (var i = 0; i < len; i++) {
	        this._settlePromiseAt(i);
	    }
	};
	
	
	util.notEnumerableProp(Promise,
	                       "_makeSelfResolutionError",
	                       makeSelfResolutionError);
	
	_dereq_("./progress.js")(Promise, PromiseArray);
	_dereq_("./method.js")(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	_dereq_("./bind.js")(Promise, INTERNAL, tryConvertToPromise);
	_dereq_("./finally.js")(Promise, NEXT_FILTER, tryConvertToPromise);
	_dereq_("./direct_resolve.js")(Promise);
	_dereq_("./synchronous_inspection.js")(Promise);
	_dereq_("./join.js")(Promise, PromiseArray, tryConvertToPromise, INTERNAL);
	Promise.version = "2.11.0";
	Promise.Promise = Promise;
	_dereq_('./map.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
	_dereq_('./cancel.js')(Promise);
	_dereq_('./using.js')(Promise, apiRejection, tryConvertToPromise, createContext);
	_dereq_('./generators.js')(Promise, apiRejection, INTERNAL, tryConvertToPromise);
	_dereq_('./nodeify.js')(Promise);
	_dereq_('./call_get.js')(Promise);
	_dereq_('./props.js')(Promise, PromiseArray, tryConvertToPromise, apiRejection);
	_dereq_('./race.js')(Promise, INTERNAL, tryConvertToPromise, apiRejection);
	_dereq_('./reduce.js')(Promise, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL);
	_dereq_('./settle.js')(Promise, PromiseArray);
	_dereq_('./some.js')(Promise, PromiseArray, apiRejection);
	_dereq_('./promisify.js')(Promise, INTERNAL);
	_dereq_('./any.js')(Promise);
	_dereq_('./each.js')(Promise, INTERNAL);
	_dereq_('./timers.js')(Promise, INTERNAL);
	_dereq_('./filter.js')(Promise, INTERNAL);
	                                                         
	    util.toFastProperties(Promise);                                          
	    util.toFastProperties(Promise.prototype);                                
	    function fillTypes(value) {                                              
	        var p = new Promise(INTERNAL);                                       
	        p._fulfillmentHandler0 = value;                                      
	        p._rejectionHandler0 = value;                                        
	        p._progressHandler0 = value;                                         
	        p._promise0 = value;                                                 
	        p._receiver0 = value;                                                
	        p._settledValue = value;                                             
	    }                                                                        
	    // Complete slack tracking, opt out of field-type tracking and           
	    // stabilize map                                                         
	    fillTypes({a: 1});                                                       
	    fillTypes({b: 2});                                                       
	    fillTypes({c: 3});                                                       
	    fillTypes(1);                                                            
	    fillTypes(function(){});                                                 
	    fillTypes(undefined);                                                    
	    fillTypes(false);                                                        
	    fillTypes(new Promise(INTERNAL));                                        
	    CapturedTrace.setBounds(async.firstLineError, util.lastLineError);       
	    return Promise;                                                          
	
	};
	
	},{"./any.js":1,"./async.js":2,"./bind.js":3,"./call_get.js":5,"./cancel.js":6,"./captured_trace.js":7,"./catch_filter.js":8,"./context.js":9,"./debuggability.js":10,"./direct_resolve.js":11,"./each.js":12,"./errors.js":13,"./filter.js":15,"./finally.js":16,"./generators.js":17,"./join.js":18,"./map.js":19,"./method.js":20,"./nodeify.js":21,"./progress.js":22,"./promise_array.js":24,"./promise_resolver.js":25,"./promisify.js":26,"./props.js":27,"./race.js":29,"./reduce.js":30,"./settle.js":32,"./some.js":33,"./synchronous_inspection.js":34,"./thenables.js":35,"./timers.js":36,"./using.js":37,"./util.js":38}],24:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL, tryConvertToPromise,
	    apiRejection) {
	var util = _dereq_("./util.js");
	var isArray = util.isArray;
	
	function toResolutionValue(val) {
	    switch(val) {
	    case -2: return [];
	    case -3: return {};
	    }
	}
	
	function PromiseArray(values) {
	    var promise = this._promise = new Promise(INTERNAL);
	    var parent;
	    if (values instanceof Promise) {
	        parent = values;
	        promise._propagateFrom(parent, 1 | 4);
	    }
	    this._values = values;
	    this._length = 0;
	    this._totalResolved = 0;
	    this._init(undefined, -2);
	}
	PromiseArray.prototype.length = function () {
	    return this._length;
	};
	
	PromiseArray.prototype.promise = function () {
	    return this._promise;
	};
	
	PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
	    var values = tryConvertToPromise(this._values, this._promise);
	    if (values instanceof Promise) {
	        values = values._target();
	        this._values = values;
	        if (values._isFulfilled()) {
	            values = values._value();
	            if (!isArray(values)) {
	                var err = new Promise.TypeError("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
	                this.__hardReject__(err);
	                return;
	            }
	        } else if (values._isPending()) {
	            values._then(
	                init,
	                this._reject,
	                undefined,
	                this,
	                resolveValueIfEmpty
	           );
	            return;
	        } else {
	            this._reject(values._reason());
	            return;
	        }
	    } else if (!isArray(values)) {
	        this._promise._reject(apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a")._reason());
	        return;
	    }
	
	    if (values.length === 0) {
	        if (resolveValueIfEmpty === -5) {
	            this._resolveEmptyArray();
	        }
	        else {
	            this._resolve(toResolutionValue(resolveValueIfEmpty));
	        }
	        return;
	    }
	    var len = this.getActualLength(values.length);
	    this._length = len;
	    this._values = this.shouldCopyValues() ? new Array(len) : this._values;
	    var promise = this._promise;
	    for (var i = 0; i < len; ++i) {
	        var isResolved = this._isResolved();
	        var maybePromise = tryConvertToPromise(values[i], promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (isResolved) {
	                maybePromise._ignoreRejections();
	            } else if (maybePromise._isPending()) {
	                maybePromise._proxyPromiseArray(this, i);
	            } else if (maybePromise._isFulfilled()) {
	                this._promiseFulfilled(maybePromise._value(), i);
	            } else {
	                this._promiseRejected(maybePromise._reason(), i);
	            }
	        } else if (!isResolved) {
	            this._promiseFulfilled(maybePromise, i);
	        }
	    }
	};
	
	PromiseArray.prototype._isResolved = function () {
	    return this._values === null;
	};
	
	PromiseArray.prototype._resolve = function (value) {
	    this._values = null;
	    this._promise._fulfill(value);
	};
	
	PromiseArray.prototype.__hardReject__ =
	PromiseArray.prototype._reject = function (reason) {
	    this._values = null;
	    this._promise._rejectCallback(reason, false, true);
	};
	
	PromiseArray.prototype._promiseProgressed = function (progressValue, index) {
	    this._promise._progress({
	        index: index,
	        value: progressValue
	    });
	};
	
	
	PromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	    }
	};
	
	PromiseArray.prototype._promiseRejected = function (reason, index) {
	    this._totalResolved++;
	    this._reject(reason);
	};
	
	PromiseArray.prototype.shouldCopyValues = function () {
	    return true;
	};
	
	PromiseArray.prototype.getActualLength = function (len) {
	    return len;
	};
	
	return PromiseArray;
	};
	
	},{"./util.js":38}],25:[function(_dereq_,module,exports){
	"use strict";
	var util = _dereq_("./util.js");
	var maybeWrapAsError = util.maybeWrapAsError;
	var errors = _dereq_("./errors.js");
	var TimeoutError = errors.TimeoutError;
	var OperationalError = errors.OperationalError;
	var haveGetters = util.haveGetters;
	var es5 = _dereq_("./es5.js");
	
	function isUntypedError(obj) {
	    return obj instanceof Error &&
	        es5.getPrototypeOf(obj) === Error.prototype;
	}
	
	var rErrorKey = /^(?:name|message|stack|cause)$/;
	function wrapAsOperationalError(obj) {
	    var ret;
	    if (isUntypedError(obj)) {
	        ret = new OperationalError(obj);
	        ret.name = obj.name;
	        ret.message = obj.message;
	        ret.stack = obj.stack;
	        var keys = es5.keys(obj);
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!rErrorKey.test(key)) {
	                ret[key] = obj[key];
	            }
	        }
	        return ret;
	    }
	    util.markAsOriginatingFromRejection(obj);
	    return obj;
	}
	
	function nodebackForPromise(promise) {
	    return function(err, value) {
	        if (promise === null) return;
	
	        if (err) {
	            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
	            promise._attachExtraTrace(wrapped);
	            promise._reject(wrapped);
	        } else if (arguments.length > 2) {
	            var $_len = arguments.length;var args = new Array($_len - 1); for(var $_i = 1; $_i < $_len; ++$_i) {args[$_i - 1] = arguments[$_i];}
	            promise._fulfill(args);
	        } else {
	            promise._fulfill(value);
	        }
	
	        promise = null;
	    };
	}
	
	
	var PromiseResolver;
	if (!haveGetters) {
	    PromiseResolver = function (promise) {
	        this.promise = promise;
	        this.asCallback = nodebackForPromise(promise);
	        this.callback = this.asCallback;
	    };
	}
	else {
	    PromiseResolver = function (promise) {
	        this.promise = promise;
	    };
	}
	if (haveGetters) {
	    var prop = {
	        get: function() {
	            return nodebackForPromise(this.promise);
	        }
	    };
	    es5.defineProperty(PromiseResolver.prototype, "asCallback", prop);
	    es5.defineProperty(PromiseResolver.prototype, "callback", prop);
	}
	
	PromiseResolver._nodebackForPromise = nodebackForPromise;
	
	PromiseResolver.prototype.toString = function () {
	    return "[object PromiseResolver]";
	};
	
	PromiseResolver.prototype.resolve =
	PromiseResolver.prototype.fulfill = function (value) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._resolveCallback(value);
	};
	
	PromiseResolver.prototype.reject = function (reason) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._rejectCallback(reason);
	};
	
	PromiseResolver.prototype.progress = function (value) {
	    if (!(this instanceof PromiseResolver)) {
	        throw new TypeError("Illegal invocation, resolver resolve/reject must be called within a resolver context. Consider using the promise constructor instead.\u000a\u000a    See http://goo.gl/sdkXL9\u000a");
	    }
	    this.promise._progress(value);
	};
	
	PromiseResolver.prototype.cancel = function (err) {
	    this.promise.cancel(err);
	};
	
	PromiseResolver.prototype.timeout = function () {
	    this.reject(new TimeoutError("timeout"));
	};
	
	PromiseResolver.prototype.isResolved = function () {
	    return this.promise.isResolved();
	};
	
	PromiseResolver.prototype.toJSON = function () {
	    return this.promise.toJSON();
	};
	
	module.exports = PromiseResolver;
	
	},{"./errors.js":13,"./es5.js":14,"./util.js":38}],26:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var THIS = {};
	var util = _dereq_("./util.js");
	var nodebackForPromise = _dereq_("./promise_resolver.js")
	    ._nodebackForPromise;
	var withAppended = util.withAppended;
	var maybeWrapAsError = util.maybeWrapAsError;
	var canEvaluate = util.canEvaluate;
	var TypeError = _dereq_("./errors").TypeError;
	var defaultSuffix = "Async";
	var defaultPromisified = {__isPromisified__: true};
	var noCopyProps = [
	    "arity",    "length",
	    "name",
	    "arguments",
	    "caller",
	    "callee",
	    "prototype",
	    "__isPromisified__"
	];
	var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
	
	var defaultFilter = function(name) {
	    return util.isIdentifier(name) &&
	        name.charAt(0) !== "_" &&
	        name !== "constructor";
	};
	
	function propsFilter(key) {
	    return !noCopyPropsPattern.test(key);
	}
	
	function isPromisified(fn) {
	    try {
	        return fn.__isPromisified__ === true;
	    }
	    catch (e) {
	        return false;
	    }
	}
	
	function hasPromisified(obj, key, suffix) {
	    var val = util.getDataPropertyOrDefault(obj, key + suffix,
	                                            defaultPromisified);
	    return val ? isPromisified(val) : false;
	}
	function checkValid(ret, suffix, suffixRegexp) {
	    for (var i = 0; i < ret.length; i += 2) {
	        var key = ret[i];
	        if (suffixRegexp.test(key)) {
	            var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
	            for (var j = 0; j < ret.length; j += 2) {
	                if (ret[j] === keyWithoutAsyncSuffix) {
	                    throw new TypeError("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/iWrZbw\u000a"
	                        .replace("%s", suffix));
	                }
	            }
	        }
	    }
	}
	
	function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
	    var keys = util.inheritedDataKeys(obj);
	    var ret = [];
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var value = obj[key];
	        var passesDefaultFilter = filter === defaultFilter
	            ? true : defaultFilter(key, value, obj);
	        if (typeof value === "function" &&
	            !isPromisified(value) &&
	            !hasPromisified(obj, key, suffix) &&
	            filter(key, value, obj, passesDefaultFilter)) {
	            ret.push(key, value);
	        }
	    }
	    checkValid(ret, suffix, suffixRegexp);
	    return ret;
	}
	
	var escapeIdentRegex = function(str) {
	    return str.replace(/([$])/, "\\$");
	};
	
	var makeNodePromisifiedEval;
	if (false) {
	var switchCaseArgumentOrder = function(likelyArgumentCount) {
	    var ret = [likelyArgumentCount];
	    var min = Math.max(0, likelyArgumentCount - 1 - 3);
	    for(var i = likelyArgumentCount - 1; i >= min; --i) {
	        ret.push(i);
	    }
	    for(var i = likelyArgumentCount + 1; i <= 3; ++i) {
	        ret.push(i);
	    }
	    return ret;
	};
	
	var argumentSequence = function(argumentCount) {
	    return util.filledRange(argumentCount, "_arg", "");
	};
	
	var parameterDeclaration = function(parameterCount) {
	    return util.filledRange(
	        Math.max(parameterCount, 3), "_arg", "");
	};
	
	var parameterCount = function(fn) {
	    if (typeof fn.length === "number") {
	        return Math.max(Math.min(fn.length, 1023 + 1), 0);
	    }
	    return 0;
	};
	
	makeNodePromisifiedEval =
	function(callback, receiver, originalName, fn) {
	    var newParameterCount = Math.max(0, parameterCount(fn) - 1);
	    var argumentOrder = switchCaseArgumentOrder(newParameterCount);
	    var shouldProxyThis = typeof callback === "string" || receiver === THIS;
	
	    function generateCallForArgumentCount(count) {
	        var args = argumentSequence(count).join(", ");
	        var comma = count > 0 ? ", " : "";
	        var ret;
	        if (shouldProxyThis) {
	            ret = "ret = callback.call(this, {{args}}, nodeback); break;\n";
	        } else {
	            ret = receiver === undefined
	                ? "ret = callback({{args}}, nodeback); break;\n"
	                : "ret = callback.call(receiver, {{args}}, nodeback); break;\n";
	        }
	        return ret.replace("{{args}}", args).replace(", ", comma);
	    }
	
	    function generateArgumentSwitchCase() {
	        var ret = "";
	        for (var i = 0; i < argumentOrder.length; ++i) {
	            ret += "case " + argumentOrder[i] +":" +
	                generateCallForArgumentCount(argumentOrder[i]);
	        }
	
	        ret += "                                                             \n\
	        default:                                                             \n\
	            var args = new Array(len + 1);                                   \n\
	            var i = 0;                                                       \n\
	            for (var i = 0; i < len; ++i) {                                  \n\
	               args[i] = arguments[i];                                       \n\
	            }                                                                \n\
	            args[i] = nodeback;                                              \n\
	            [CodeForCall]                                                    \n\
	            break;                                                           \n\
	        ".replace("[CodeForCall]", (shouldProxyThis
	                                ? "ret = callback.apply(this, args);\n"
	                                : "ret = callback.apply(receiver, args);\n"));
	        return ret;
	    }
	
	    var getFunctionCode = typeof callback === "string"
	                                ? ("this != null ? this['"+callback+"'] : fn")
	                                : "fn";
	
	    return new Function("Promise",
	                        "fn",
	                        "receiver",
	                        "withAppended",
	                        "maybeWrapAsError",
	                        "nodebackForPromise",
	                        "tryCatch",
	                        "errorObj",
	                        "notEnumerableProp",
	                        "INTERNAL","'use strict';                            \n\
	        var ret = function (Parameters) {                                    \n\
	            'use strict';                                                    \n\
	            var len = arguments.length;                                      \n\
	            var promise = new Promise(INTERNAL);                             \n\
	            promise._captureStackTrace();                                    \n\
	            var nodeback = nodebackForPromise(promise);                      \n\
	            var ret;                                                         \n\
	            var callback = tryCatch([GetFunctionCode]);                      \n\
	            switch(len) {                                                    \n\
	                [CodeForSwitchCase]                                          \n\
	            }                                                                \n\
	            if (ret === errorObj) {                                          \n\
	                promise._rejectCallback(maybeWrapAsError(ret.e), true, true);\n\
	            }                                                                \n\
	            return promise;                                                  \n\
	        };                                                                   \n\
	        notEnumerableProp(ret, '__isPromisified__', true);                   \n\
	        return ret;                                                          \n\
	        "
	        .replace("Parameters", parameterDeclaration(newParameterCount))
	        .replace("[CodeForSwitchCase]", generateArgumentSwitchCase())
	        .replace("[GetFunctionCode]", getFunctionCode))(
	            Promise,
	            fn,
	            receiver,
	            withAppended,
	            maybeWrapAsError,
	            nodebackForPromise,
	            util.tryCatch,
	            util.errorObj,
	            util.notEnumerableProp,
	            INTERNAL
	        );
	};
	}
	
	function makeNodePromisifiedClosure(callback, receiver, _, fn) {
	    var defaultThis = (function() {return this;})();
	    var method = callback;
	    if (typeof method === "string") {
	        callback = fn;
	    }
	    function promisified() {
	        var _receiver = receiver;
	        if (receiver === THIS) _receiver = this;
	        var promise = new Promise(INTERNAL);
	        promise._captureStackTrace();
	        var cb = typeof method === "string" && this !== defaultThis
	            ? this[method] : callback;
	        var fn = nodebackForPromise(promise);
	        try {
	            cb.apply(_receiver, withAppended(arguments, fn));
	        } catch(e) {
	            promise._rejectCallback(maybeWrapAsError(e), true, true);
	        }
	        return promise;
	    }
	    util.notEnumerableProp(promisified, "__isPromisified__", true);
	    return promisified;
	}
	
	var makeNodePromisified = canEvaluate
	    ? makeNodePromisifiedEval
	    : makeNodePromisifiedClosure;
	
	function promisifyAll(obj, suffix, filter, promisifier) {
	    var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
	    var methods =
	        promisifiableMethods(obj, suffix, suffixRegexp, filter);
	
	    for (var i = 0, len = methods.length; i < len; i+= 2) {
	        var key = methods[i];
	        var fn = methods[i+1];
	        var promisifiedKey = key + suffix;
	        if (promisifier === makeNodePromisified) {
	            obj[promisifiedKey] =
	                makeNodePromisified(key, THIS, key, fn, suffix);
	        } else {
	            var promisified = promisifier(fn, function() {
	                return makeNodePromisified(key, THIS, key, fn, suffix);
	            });
	            util.notEnumerableProp(promisified, "__isPromisified__", true);
	            obj[promisifiedKey] = promisified;
	        }
	    }
	    util.toFastProperties(obj);
	    return obj;
	}
	
	function promisify(callback, receiver) {
	    return makeNodePromisified(callback, receiver, undefined, callback);
	}
	
	Promise.promisify = function (fn, receiver) {
	    if (typeof fn !== "function") {
	        throw new TypeError("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    }
	    if (isPromisified(fn)) {
	        return fn;
	    }
	    var ret = promisify(fn, arguments.length < 2 ? THIS : receiver);
	    util.copyDescriptors(fn, ret, propsFilter);
	    return ret;
	};
	
	Promise.promisifyAll = function (target, options) {
	    if (typeof target !== "function" && typeof target !== "object") {
	        throw new TypeError("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/9ITlV0\u000a");
	    }
	    options = Object(options);
	    var suffix = options.suffix;
	    if (typeof suffix !== "string") suffix = defaultSuffix;
	    var filter = options.filter;
	    if (typeof filter !== "function") filter = defaultFilter;
	    var promisifier = options.promisifier;
	    if (typeof promisifier !== "function") promisifier = makeNodePromisified;
	
	    if (!util.isIdentifier(suffix)) {
	        throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/8FZo5V\u000a");
	    }
	
	    var keys = util.inheritedDataKeys(target);
	    for (var i = 0; i < keys.length; ++i) {
	        var value = target[keys[i]];
	        if (keys[i] !== "constructor" &&
	            util.isClass(value)) {
	            promisifyAll(value.prototype, suffix, filter, promisifier);
	            promisifyAll(value, suffix, filter, promisifier);
	        }
	    }
	
	    return promisifyAll(target, suffix, filter, promisifier);
	};
	};
	
	
	},{"./errors":13,"./promise_resolver.js":25,"./util.js":38}],27:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(
	    Promise, PromiseArray, tryConvertToPromise, apiRejection) {
	var util = _dereq_("./util.js");
	var isObject = util.isObject;
	var es5 = _dereq_("./es5.js");
	
	function PropertiesPromiseArray(obj) {
	    var keys = es5.keys(obj);
	    var len = keys.length;
	    var values = new Array(len * 2);
	    for (var i = 0; i < len; ++i) {
	        var key = keys[i];
	        values[i] = obj[key];
	        values[i + len] = key;
	    }
	    this.constructor$(values);
	}
	util.inherits(PropertiesPromiseArray, PromiseArray);
	
	PropertiesPromiseArray.prototype._init = function () {
	    this._init$(undefined, -3) ;
	};
	
	PropertiesPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    this._values[index] = value;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        var val = {};
	        var keyOffset = this.length();
	        for (var i = 0, len = this.length(); i < len; ++i) {
	            val[this._values[i + keyOffset]] = this._values[i];
	        }
	        this._resolve(val);
	    }
	};
	
	PropertiesPromiseArray.prototype._promiseProgressed = function (value, index) {
	    this._promise._progress({
	        key: this._values[index + this.length()],
	        value: value
	    });
	};
	
	PropertiesPromiseArray.prototype.shouldCopyValues = function () {
	    return false;
	};
	
	PropertiesPromiseArray.prototype.getActualLength = function (len) {
	    return len >> 1;
	};
	
	function props(promises) {
	    var ret;
	    var castValue = tryConvertToPromise(promises);
	
	    if (!isObject(castValue)) {
	        return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/OsFKC8\u000a");
	    } else if (castValue instanceof Promise) {
	        ret = castValue._then(
	            Promise.props, undefined, undefined, undefined, undefined);
	    } else {
	        ret = new PropertiesPromiseArray(castValue).promise();
	    }
	
	    if (castValue instanceof Promise) {
	        ret._propagateFrom(castValue, 4);
	    }
	    return ret;
	}
	
	Promise.prototype.props = function () {
	    return props(this);
	};
	
	Promise.props = function (promises) {
	    return props(promises);
	};
	};
	
	},{"./es5.js":14,"./util.js":38}],28:[function(_dereq_,module,exports){
	"use strict";
	function arrayMove(src, srcIndex, dst, dstIndex, len) {
	    for (var j = 0; j < len; ++j) {
	        dst[j + dstIndex] = src[j + srcIndex];
	        src[j + srcIndex] = void 0;
	    }
	}
	
	function Queue(capacity) {
	    this._capacity = capacity;
	    this._length = 0;
	    this._front = 0;
	}
	
	Queue.prototype._willBeOverCapacity = function (size) {
	    return this._capacity < size;
	};
	
	Queue.prototype._pushOne = function (arg) {
	    var length = this.length();
	    this._checkCapacity(length + 1);
	    var i = (this._front + length) & (this._capacity - 1);
	    this[i] = arg;
	    this._length = length + 1;
	};
	
	Queue.prototype._unshiftOne = function(value) {
	    var capacity = this._capacity;
	    this._checkCapacity(this.length() + 1);
	    var front = this._front;
	    var i = (((( front - 1 ) &
	                    ( capacity - 1) ) ^ capacity ) - capacity );
	    this[i] = value;
	    this._front = i;
	    this._length = this.length() + 1;
	};
	
	Queue.prototype.unshift = function(fn, receiver, arg) {
	    this._unshiftOne(arg);
	    this._unshiftOne(receiver);
	    this._unshiftOne(fn);
	};
	
	Queue.prototype.push = function (fn, receiver, arg) {
	    var length = this.length() + 3;
	    if (this._willBeOverCapacity(length)) {
	        this._pushOne(fn);
	        this._pushOne(receiver);
	        this._pushOne(arg);
	        return;
	    }
	    var j = this._front + length - 3;
	    this._checkCapacity(length);
	    var wrapMask = this._capacity - 1;
	    this[(j + 0) & wrapMask] = fn;
	    this[(j + 1) & wrapMask] = receiver;
	    this[(j + 2) & wrapMask] = arg;
	    this._length = length;
	};
	
	Queue.prototype.shift = function () {
	    var front = this._front,
	        ret = this[front];
	
	    this[front] = undefined;
	    this._front = (front + 1) & (this._capacity - 1);
	    this._length--;
	    return ret;
	};
	
	Queue.prototype.length = function () {
	    return this._length;
	};
	
	Queue.prototype._checkCapacity = function (size) {
	    if (this._capacity < size) {
	        this._resizeTo(this._capacity << 1);
	    }
	};
	
	Queue.prototype._resizeTo = function (capacity) {
	    var oldCapacity = this._capacity;
	    this._capacity = capacity;
	    var front = this._front;
	    var length = this._length;
	    var moveItemsCount = (front + length) & (oldCapacity - 1);
	    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
	};
	
	module.exports = Queue;
	
	},{}],29:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(
	    Promise, INTERNAL, tryConvertToPromise, apiRejection) {
	var isArray = _dereq_("./util.js").isArray;
	
	var raceLater = function (promise) {
	    return promise.then(function(array) {
	        return race(array, promise);
	    });
	};
	
	function race(promises, parent) {
	    var maybePromise = tryConvertToPromise(promises);
	
	    if (maybePromise instanceof Promise) {
	        return raceLater(maybePromise);
	    } else if (!isArray(promises)) {
	        return apiRejection("expecting an array, a promise or a thenable\u000a\u000a    See http://goo.gl/s8MMhc\u000a");
	    }
	
	    var ret = new Promise(INTERNAL);
	    if (parent !== undefined) {
	        ret._propagateFrom(parent, 4 | 1);
	    }
	    var fulfill = ret._fulfill;
	    var reject = ret._reject;
	    for (var i = 0, len = promises.length; i < len; ++i) {
	        var val = promises[i];
	
	        if (val === undefined && !(i in promises)) {
	            continue;
	        }
	
	        Promise.cast(val)._then(fulfill, reject, undefined, ret, null);
	    }
	    return ret;
	}
	
	Promise.race = function (promises) {
	    return race(promises, undefined);
	};
	
	Promise.prototype.race = function () {
	    return race(this, undefined);
	};
	
	};
	
	},{"./util.js":38}],30:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise,
	                          PromiseArray,
	                          apiRejection,
	                          tryConvertToPromise,
	                          INTERNAL) {
	var getDomain = Promise._getDomain;
	var async = _dereq_("./async.js");
	var util = _dereq_("./util.js");
	var tryCatch = util.tryCatch;
	var errorObj = util.errorObj;
	function ReductionPromiseArray(promises, fn, accum, _each) {
	    this.constructor$(promises);
	    this._promise._captureStackTrace();
	    this._preservedValues = _each === INTERNAL ? [] : null;
	    this._zerothIsAccum = (accum === undefined);
	    this._gotAccum = false;
	    this._reducingIndex = (this._zerothIsAccum ? 1 : 0);
	    this._valuesPhase = undefined;
	    var maybePromise = tryConvertToPromise(accum, this._promise);
	    var rejected = false;
	    var isPromise = maybePromise instanceof Promise;
	    if (isPromise) {
	        maybePromise = maybePromise._target();
	        if (maybePromise._isPending()) {
	            maybePromise._proxyPromiseArray(this, -1);
	        } else if (maybePromise._isFulfilled()) {
	            accum = maybePromise._value();
	            this._gotAccum = true;
	        } else {
	            this._reject(maybePromise._reason());
	            rejected = true;
	        }
	    }
	    if (!(isPromise || this._zerothIsAccum)) this._gotAccum = true;
	    var domain = getDomain();
	    this._callback = domain === null ? fn : domain.bind(fn);
	    this._accum = accum;
	    if (!rejected) async.invoke(init, this, undefined);
	}
	function init() {
	    this._init$(undefined, -5);
	}
	util.inherits(ReductionPromiseArray, PromiseArray);
	
	ReductionPromiseArray.prototype._init = function () {};
	
	ReductionPromiseArray.prototype._resolveEmptyArray = function () {
	    if (this._gotAccum || this._zerothIsAccum) {
	        this._resolve(this._preservedValues !== null
	                        ? [] : this._accum);
	    }
	};
	
	ReductionPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var values = this._values;
	    values[index] = value;
	    var length = this.length();
	    var preservedValues = this._preservedValues;
	    var isEach = preservedValues !== null;
	    var gotAccum = this._gotAccum;
	    var valuesPhase = this._valuesPhase;
	    var valuesPhaseIndex;
	    if (!valuesPhase) {
	        valuesPhase = this._valuesPhase = new Array(length);
	        for (valuesPhaseIndex=0; valuesPhaseIndex<length; ++valuesPhaseIndex) {
	            valuesPhase[valuesPhaseIndex] = 0;
	        }
	    }
	    valuesPhaseIndex = valuesPhase[index];
	
	    if (index === 0 && this._zerothIsAccum) {
	        this._accum = value;
	        this._gotAccum = gotAccum = true;
	        valuesPhase[index] = ((valuesPhaseIndex === 0)
	            ? 1 : 2);
	    } else if (index === -1) {
	        this._accum = value;
	        this._gotAccum = gotAccum = true;
	    } else {
	        if (valuesPhaseIndex === 0) {
	            valuesPhase[index] = 1;
	        } else {
	            valuesPhase[index] = 2;
	            this._accum = value;
	        }
	    }
	    if (!gotAccum) return;
	
	    var callback = this._callback;
	    var receiver = this._promise._boundValue();
	    var ret;
	
	    for (var i = this._reducingIndex; i < length; ++i) {
	        valuesPhaseIndex = valuesPhase[i];
	        if (valuesPhaseIndex === 2) {
	            this._reducingIndex = i + 1;
	            continue;
	        }
	        if (valuesPhaseIndex !== 1) return;
	        value = values[i];
	        this._promise._pushContext();
	        if (isEach) {
	            preservedValues.push(value);
	            ret = tryCatch(callback).call(receiver, value, i, length);
	        }
	        else {
	            ret = tryCatch(callback)
	                .call(receiver, this._accum, value, i, length);
	        }
	        this._promise._popContext();
	
	        if (ret === errorObj) return this._reject(ret.e);
	
	        var maybePromise = tryConvertToPromise(ret, this._promise);
	        if (maybePromise instanceof Promise) {
	            maybePromise = maybePromise._target();
	            if (maybePromise._isPending()) {
	                valuesPhase[i] = 4;
	                return maybePromise._proxyPromiseArray(this, i);
	            } else if (maybePromise._isFulfilled()) {
	                ret = maybePromise._value();
	            } else {
	                return this._reject(maybePromise._reason());
	            }
	        }
	
	        this._reducingIndex = i + 1;
	        this._accum = ret;
	    }
	
	    this._resolve(isEach ? preservedValues : this._accum);
	};
	
	function reduce(promises, fn, initialValue, _each) {
	    if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	    var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
	    return array.promise();
	}
	
	Promise.prototype.reduce = function (fn, initialValue) {
	    return reduce(this, fn, initialValue, null);
	};
	
	Promise.reduce = function (promises, fn, initialValue, _each) {
	    return reduce(promises, fn, initialValue, _each);
	};
	};
	
	},{"./async.js":2,"./util.js":38}],31:[function(_dereq_,module,exports){
	"use strict";
	var schedule;
	var util = _dereq_("./util");
	var noAsyncScheduler = function() {
	    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/m3OTXk\u000a");
	};
	if (util.isNode && typeof MutationObserver === "undefined") {
	    var GlobalSetImmediate = global.setImmediate;
	    var ProcessNextTick = process.nextTick;
	    schedule = util.isRecentNode
	                ? function(fn) { GlobalSetImmediate.call(global, fn); }
	                : function(fn) { ProcessNextTick.call(process, fn); };
	} else if ((typeof MutationObserver !== "undefined") &&
	          !(typeof window !== "undefined" &&
	            window.navigator &&
	            window.navigator.standalone)) {
	    schedule = function(fn) {
	        var div = document.createElement("div");
	        var observer = new MutationObserver(fn);
	        observer.observe(div, {attributes: true});
	        return function() { div.classList.toggle("foo"); };
	    };
	    schedule.isStatic = true;
	} else if (typeof setImmediate !== "undefined") {
	    schedule = function (fn) {
	        setImmediate(fn);
	    };
	} else if (typeof setTimeout !== "undefined") {
	    schedule = function (fn) {
	        setTimeout(fn, 0);
	    };
	} else {
	    schedule = noAsyncScheduler;
	}
	module.exports = schedule;
	
	},{"./util":38}],32:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	    function(Promise, PromiseArray) {
	var PromiseInspection = Promise.PromiseInspection;
	var util = _dereq_("./util.js");
	
	function SettledPromiseArray(values) {
	    this.constructor$(values);
	}
	util.inherits(SettledPromiseArray, PromiseArray);
	
	SettledPromiseArray.prototype._promiseResolved = function (index, inspection) {
	    this._values[index] = inspection;
	    var totalResolved = ++this._totalResolved;
	    if (totalResolved >= this._length) {
	        this._resolve(this._values);
	    }
	};
	
	SettledPromiseArray.prototype._promiseFulfilled = function (value, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 268435456;
	    ret._settledValue = value;
	    this._promiseResolved(index, ret);
	};
	SettledPromiseArray.prototype._promiseRejected = function (reason, index) {
	    var ret = new PromiseInspection();
	    ret._bitField = 134217728;
	    ret._settledValue = reason;
	    this._promiseResolved(index, ret);
	};
	
	Promise.settle = function (promises) {
	    return new SettledPromiseArray(promises).promise();
	};
	
	Promise.prototype.settle = function () {
	    return new SettledPromiseArray(this).promise();
	};
	};
	
	},{"./util.js":38}],33:[function(_dereq_,module,exports){
	"use strict";
	module.exports =
	function(Promise, PromiseArray, apiRejection) {
	var util = _dereq_("./util.js");
	var RangeError = _dereq_("./errors.js").RangeError;
	var AggregateError = _dereq_("./errors.js").AggregateError;
	var isArray = util.isArray;
	
	
	function SomePromiseArray(values) {
	    this.constructor$(values);
	    this._howMany = 0;
	    this._unwrap = false;
	    this._initialized = false;
	}
	util.inherits(SomePromiseArray, PromiseArray);
	
	SomePromiseArray.prototype._init = function () {
	    if (!this._initialized) {
	        return;
	    }
	    if (this._howMany === 0) {
	        this._resolve([]);
	        return;
	    }
	    this._init$(undefined, -5);
	    var isArrayResolved = isArray(this._values);
	    if (!this._isResolved() &&
	        isArrayResolved &&
	        this._howMany > this._canPossiblyFulfill()) {
	        this._reject(this._getRangeError(this.length()));
	    }
	};
	
	SomePromiseArray.prototype.init = function () {
	    this._initialized = true;
	    this._init();
	};
	
	SomePromiseArray.prototype.setUnwrap = function () {
	    this._unwrap = true;
	};
	
	SomePromiseArray.prototype.howMany = function () {
	    return this._howMany;
	};
	
	SomePromiseArray.prototype.setHowMany = function (count) {
	    this._howMany = count;
	};
	
	SomePromiseArray.prototype._promiseFulfilled = function (value) {
	    this._addFulfilled(value);
	    if (this._fulfilled() === this.howMany()) {
	        this._values.length = this.howMany();
	        if (this.howMany() === 1 && this._unwrap) {
	            this._resolve(this._values[0]);
	        } else {
	            this._resolve(this._values);
	        }
	    }
	
	};
	SomePromiseArray.prototype._promiseRejected = function (reason) {
	    this._addRejected(reason);
	    if (this.howMany() > this._canPossiblyFulfill()) {
	        var e = new AggregateError();
	        for (var i = this.length(); i < this._values.length; ++i) {
	            e.push(this._values[i]);
	        }
	        this._reject(e);
	    }
	};
	
	SomePromiseArray.prototype._fulfilled = function () {
	    return this._totalResolved;
	};
	
	SomePromiseArray.prototype._rejected = function () {
	    return this._values.length - this.length();
	};
	
	SomePromiseArray.prototype._addRejected = function (reason) {
	    this._values.push(reason);
	};
	
	SomePromiseArray.prototype._addFulfilled = function (value) {
	    this._values[this._totalResolved++] = value;
	};
	
	SomePromiseArray.prototype._canPossiblyFulfill = function () {
	    return this.length() - this._rejected();
	};
	
	SomePromiseArray.prototype._getRangeError = function (count) {
	    var message = "Input array must contain at least " +
	            this._howMany + " items but contains only " + count + " items";
	    return new RangeError(message);
	};
	
	SomePromiseArray.prototype._resolveEmptyArray = function () {
	    this._reject(this._getRangeError(0));
	};
	
	function some(promises, howMany) {
	    if ((howMany | 0) !== howMany || howMany < 0) {
	        return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/1wAmHx\u000a");
	    }
	    var ret = new SomePromiseArray(promises);
	    var promise = ret.promise();
	    ret.setHowMany(howMany);
	    ret.init();
	    return promise;
	}
	
	Promise.some = function (promises, howMany) {
	    return some(promises, howMany);
	};
	
	Promise.prototype.some = function (howMany) {
	    return some(this, howMany);
	};
	
	Promise._SomePromiseArray = SomePromiseArray;
	};
	
	},{"./errors.js":13,"./util.js":38}],34:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise) {
	function PromiseInspection(promise) {
	    if (promise !== undefined) {
	        promise = promise._target();
	        this._bitField = promise._bitField;
	        this._settledValue = promise._settledValue;
	    }
	    else {
	        this._bitField = 0;
	        this._settledValue = undefined;
	    }
	}
	
	PromiseInspection.prototype.value = function () {
	    if (!this.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
	    }
	    return this._settledValue;
	};
	
	PromiseInspection.prototype.error =
	PromiseInspection.prototype.reason = function () {
	    if (!this.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
	    }
	    return this._settledValue;
	};
	
	PromiseInspection.prototype.isFulfilled =
	Promise.prototype._isFulfilled = function () {
	    return (this._bitField & 268435456) > 0;
	};
	
	PromiseInspection.prototype.isRejected =
	Promise.prototype._isRejected = function () {
	    return (this._bitField & 134217728) > 0;
	};
	
	PromiseInspection.prototype.isPending =
	Promise.prototype._isPending = function () {
	    return (this._bitField & 402653184) === 0;
	};
	
	PromiseInspection.prototype.isResolved =
	Promise.prototype._isResolved = function () {
	    return (this._bitField & 402653184) > 0;
	};
	
	Promise.prototype.isPending = function() {
	    return this._target()._isPending();
	};
	
	Promise.prototype.isRejected = function() {
	    return this._target()._isRejected();
	};
	
	Promise.prototype.isFulfilled = function() {
	    return this._target()._isFulfilled();
	};
	
	Promise.prototype.isResolved = function() {
	    return this._target()._isResolved();
	};
	
	Promise.prototype._value = function() {
	    return this._settledValue;
	};
	
	Promise.prototype._reason = function() {
	    this._unsetRejectionIsUnhandled();
	    return this._settledValue;
	};
	
	Promise.prototype.value = function() {
	    var target = this._target();
	    if (!target.isFulfilled()) {
	        throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/hc1DLj\u000a");
	    }
	    return target._settledValue;
	};
	
	Promise.prototype.reason = function() {
	    var target = this._target();
	    if (!target.isRejected()) {
	        throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/hPuiwB\u000a");
	    }
	    target._unsetRejectionIsUnhandled();
	    return target._settledValue;
	};
	
	
	Promise.PromiseInspection = PromiseInspection;
	};
	
	},{}],35:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util.js");
	var errorObj = util.errorObj;
	var isObject = util.isObject;
	
	function tryConvertToPromise(obj, context) {
	    if (isObject(obj)) {
	        if (obj instanceof Promise) {
	            return obj;
	        }
	        else if (isAnyBluebirdPromise(obj)) {
	            var ret = new Promise(INTERNAL);
	            obj._then(
	                ret._fulfillUnchecked,
	                ret._rejectUncheckedCheckError,
	                ret._progressUnchecked,
	                ret,
	                null
	            );
	            return ret;
	        }
	        var then = util.tryCatch(getThen)(obj);
	        if (then === errorObj) {
	            if (context) context._pushContext();
	            var ret = Promise.reject(then.e);
	            if (context) context._popContext();
	            return ret;
	        } else if (typeof then === "function") {
	            return doThenable(obj, then, context);
	        }
	    }
	    return obj;
	}
	
	function getThen(obj) {
	    return obj.then;
	}
	
	var hasProp = {}.hasOwnProperty;
	function isAnyBluebirdPromise(obj) {
	    return hasProp.call(obj, "_promise0");
	}
	
	function doThenable(x, then, context) {
	    var promise = new Promise(INTERNAL);
	    var ret = promise;
	    if (context) context._pushContext();
	    promise._captureStackTrace();
	    if (context) context._popContext();
	    var synchronous = true;
	    var result = util.tryCatch(then).call(x,
	                                        resolveFromThenable,
	                                        rejectFromThenable,
	                                        progressFromThenable);
	    synchronous = false;
	    if (promise && result === errorObj) {
	        promise._rejectCallback(result.e, true, true);
	        promise = null;
	    }
	
	    function resolveFromThenable(value) {
	        if (!promise) return;
	        promise._resolveCallback(value);
	        promise = null;
	    }
	
	    function rejectFromThenable(reason) {
	        if (!promise) return;
	        promise._rejectCallback(reason, synchronous, true);
	        promise = null;
	    }
	
	    function progressFromThenable(value) {
	        if (!promise) return;
	        if (typeof promise._progress === "function") {
	            promise._progress(value);
	        }
	    }
	    return ret;
	}
	
	return tryConvertToPromise;
	};
	
	},{"./util.js":38}],36:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function(Promise, INTERNAL) {
	var util = _dereq_("./util.js");
	var TimeoutError = Promise.TimeoutError;
	
	var afterTimeout = function (promise, message) {
	    if (!promise.isPending()) return;
	    
	    var err;
	    if(!util.isPrimitive(message) && (message instanceof Error)) {
	        err = message;
	    } else {
	        if (typeof message !== "string") {
	            message = "operation timed out";
	        }
	        err = new TimeoutError(message);
	    }
	    util.markAsOriginatingFromRejection(err);
	    promise._attachExtraTrace(err);
	    promise._cancel(err);
	};
	
	var afterValue = function(value) { return delay(+this).thenReturn(value); };
	var delay = Promise.delay = function (value, ms) {
	    if (ms === undefined) {
	        ms = value;
	        value = undefined;
	        var ret = new Promise(INTERNAL);
	        setTimeout(function() { ret._fulfill(); }, ms);
	        return ret;
	    }
	    ms = +ms;
	    return Promise.resolve(value)._then(afterValue, null, null, ms, undefined);
	};
	
	Promise.prototype.delay = function (ms) {
	    return delay(this, ms);
	};
	
	function successClear(value) {
	    var handle = this;
	    if (handle instanceof Number) handle = +handle;
	    clearTimeout(handle);
	    return value;
	}
	
	function failureClear(reason) {
	    var handle = this;
	    if (handle instanceof Number) handle = +handle;
	    clearTimeout(handle);
	    throw reason;
	}
	
	Promise.prototype.timeout = function (ms, message) {
	    ms = +ms;
	    var ret = this.then().cancellable();
	    ret._cancellationParent = this;
	    var handle = setTimeout(function timeoutTimeout() {
	        afterTimeout(ret, message);
	    }, ms);
	    return ret._then(successClear, failureClear, undefined, handle, undefined);
	};
	
	};
	
	},{"./util.js":38}],37:[function(_dereq_,module,exports){
	"use strict";
	module.exports = function (Promise, apiRejection, tryConvertToPromise,
	    createContext) {
	    var TypeError = _dereq_("./errors.js").TypeError;
	    var inherits = _dereq_("./util.js").inherits;
	    var PromiseInspection = Promise.PromiseInspection;
	
	    function inspectionMapper(inspections) {
	        var len = inspections.length;
	        for (var i = 0; i < len; ++i) {
	            var inspection = inspections[i];
	            if (inspection.isRejected()) {
	                return Promise.reject(inspection.error());
	            }
	            inspections[i] = inspection._settledValue;
	        }
	        return inspections;
	    }
	
	    function thrower(e) {
	        setTimeout(function(){throw e;}, 0);
	    }
	
	    function castPreservingDisposable(thenable) {
	        var maybePromise = tryConvertToPromise(thenable);
	        if (maybePromise !== thenable &&
	            typeof thenable._isDisposable === "function" &&
	            typeof thenable._getDisposer === "function" &&
	            thenable._isDisposable()) {
	            maybePromise._setDisposable(thenable._getDisposer());
	        }
	        return maybePromise;
	    }
	    function dispose(resources, inspection) {
	        var i = 0;
	        var len = resources.length;
	        var ret = Promise.defer();
	        function iterator() {
	            if (i >= len) return ret.resolve();
	            var maybePromise = castPreservingDisposable(resources[i++]);
	            if (maybePromise instanceof Promise &&
	                maybePromise._isDisposable()) {
	                try {
	                    maybePromise = tryConvertToPromise(
	                        maybePromise._getDisposer().tryDispose(inspection),
	                        resources.promise);
	                } catch (e) {
	                    return thrower(e);
	                }
	                if (maybePromise instanceof Promise) {
	                    return maybePromise._then(iterator, thrower,
	                                              null, null, null);
	                }
	            }
	            iterator();
	        }
	        iterator();
	        return ret.promise;
	    }
	
	    function disposerSuccess(value) {
	        var inspection = new PromiseInspection();
	        inspection._settledValue = value;
	        inspection._bitField = 268435456;
	        return dispose(this, inspection).thenReturn(value);
	    }
	
	    function disposerFail(reason) {
	        var inspection = new PromiseInspection();
	        inspection._settledValue = reason;
	        inspection._bitField = 134217728;
	        return dispose(this, inspection).thenThrow(reason);
	    }
	
	    function Disposer(data, promise, context) {
	        this._data = data;
	        this._promise = promise;
	        this._context = context;
	    }
	
	    Disposer.prototype.data = function () {
	        return this._data;
	    };
	
	    Disposer.prototype.promise = function () {
	        return this._promise;
	    };
	
	    Disposer.prototype.resource = function () {
	        if (this.promise().isFulfilled()) {
	            return this.promise().value();
	        }
	        return null;
	    };
	
	    Disposer.prototype.tryDispose = function(inspection) {
	        var resource = this.resource();
	        var context = this._context;
	        if (context !== undefined) context._pushContext();
	        var ret = resource !== null
	            ? this.doDispose(resource, inspection) : null;
	        if (context !== undefined) context._popContext();
	        this._promise._unsetDisposable();
	        this._data = null;
	        return ret;
	    };
	
	    Disposer.isDisposer = function (d) {
	        return (d != null &&
	                typeof d.resource === "function" &&
	                typeof d.tryDispose === "function");
	    };
	
	    function FunctionDisposer(fn, promise, context) {
	        this.constructor$(fn, promise, context);
	    }
	    inherits(FunctionDisposer, Disposer);
	
	    FunctionDisposer.prototype.doDispose = function (resource, inspection) {
	        var fn = this.data();
	        return fn.call(resource, resource, inspection);
	    };
	
	    function maybeUnwrapDisposer(value) {
	        if (Disposer.isDisposer(value)) {
	            this.resources[this.index]._setDisposable(value);
	            return value.promise();
	        }
	        return value;
	    }
	
	    Promise.using = function () {
	        var len = arguments.length;
	        if (len < 2) return apiRejection(
	                        "you must pass at least 2 arguments to Promise.using");
	        var fn = arguments[len - 1];
	        if (typeof fn !== "function") return apiRejection("fn must be a function\u000a\u000a    See http://goo.gl/916lJJ\u000a");
	
	        var input;
	        var spreadArgs = true;
	        if (len === 2 && Array.isArray(arguments[0])) {
	            input = arguments[0];
	            len = input.length;
	            spreadArgs = false;
	        } else {
	            input = arguments;
	            len--;
	        }
	        var resources = new Array(len);
	        for (var i = 0; i < len; ++i) {
	            var resource = input[i];
	            if (Disposer.isDisposer(resource)) {
	                var disposer = resource;
	                resource = resource.promise();
	                resource._setDisposable(disposer);
	            } else {
	                var maybePromise = tryConvertToPromise(resource);
	                if (maybePromise instanceof Promise) {
	                    resource =
	                        maybePromise._then(maybeUnwrapDisposer, null, null, {
	                            resources: resources,
	                            index: i
	                    }, undefined);
	                }
	            }
	            resources[i] = resource;
	        }
	
	        var promise = Promise.settle(resources)
	            .then(inspectionMapper)
	            .then(function(vals) {
	                promise._pushContext();
	                var ret;
	                try {
	                    ret = spreadArgs
	                        ? fn.apply(undefined, vals) : fn.call(undefined,  vals);
	                } finally {
	                    promise._popContext();
	                }
	                return ret;
	            })
	            ._then(
	                disposerSuccess, disposerFail, undefined, resources, undefined);
	        resources.promise = promise;
	        return promise;
	    };
	
	    Promise.prototype._setDisposable = function (disposer) {
	        this._bitField = this._bitField | 262144;
	        this._disposer = disposer;
	    };
	
	    Promise.prototype._isDisposable = function () {
	        return (this._bitField & 262144) > 0;
	    };
	
	    Promise.prototype._getDisposer = function () {
	        return this._disposer;
	    };
	
	    Promise.prototype._unsetDisposable = function () {
	        this._bitField = this._bitField & (~262144);
	        this._disposer = undefined;
	    };
	
	    Promise.prototype.disposer = function (fn) {
	        if (typeof fn === "function") {
	            return new FunctionDisposer(fn, this, createContext());
	        }
	        throw new TypeError();
	    };
	
	};
	
	},{"./errors.js":13,"./util.js":38}],38:[function(_dereq_,module,exports){
	"use strict";
	var es5 = _dereq_("./es5.js");
	var canEvaluate = typeof navigator == "undefined";
	var haveGetters = (function(){
	    try {
	        var o = {};
	        es5.defineProperty(o, "f", {
	            get: function () {
	                return 3;
	            }
	        });
	        return o.f === 3;
	    }
	    catch (e) {
	        return false;
	    }
	
	})();
	
	var errorObj = {e: {}};
	var tryCatchTarget;
	function tryCatcher() {
	    try {
	        var target = tryCatchTarget;
	        tryCatchTarget = null;
	        return target.apply(this, arguments);
	    } catch (e) {
	        errorObj.e = e;
	        return errorObj;
	    }
	}
	function tryCatch(fn) {
	    tryCatchTarget = fn;
	    return tryCatcher;
	}
	
	var inherits = function(Child, Parent) {
	    var hasProp = {}.hasOwnProperty;
	
	    function T() {
	        this.constructor = Child;
	        this.constructor$ = Parent;
	        for (var propertyName in Parent.prototype) {
	            if (hasProp.call(Parent.prototype, propertyName) &&
	                propertyName.charAt(propertyName.length-1) !== "$"
	           ) {
	                this[propertyName + "$"] = Parent.prototype[propertyName];
	            }
	        }
	    }
	    T.prototype = Parent.prototype;
	    Child.prototype = new T();
	    return Child.prototype;
	};
	
	
	function isPrimitive(val) {
	    return val == null || val === true || val === false ||
	        typeof val === "string" || typeof val === "number";
	
	}
	
	function isObject(value) {
	    return !isPrimitive(value);
	}
	
	function maybeWrapAsError(maybeError) {
	    if (!isPrimitive(maybeError)) return maybeError;
	
	    return new Error(safeToString(maybeError));
	}
	
	function withAppended(target, appendee) {
	    var len = target.length;
	    var ret = new Array(len + 1);
	    var i;
	    for (i = 0; i < len; ++i) {
	        ret[i] = target[i];
	    }
	    ret[i] = appendee;
	    return ret;
	}
	
	function getDataPropertyOrDefault(obj, key, defaultValue) {
	    if (es5.isES5) {
	        var desc = Object.getOwnPropertyDescriptor(obj, key);
	
	        if (desc != null) {
	            return desc.get == null && desc.set == null
	                    ? desc.value
	                    : defaultValue;
	        }
	    } else {
	        return {}.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
	    }
	}
	
	function notEnumerableProp(obj, name, value) {
	    if (isPrimitive(obj)) return obj;
	    var descriptor = {
	        value: value,
	        configurable: true,
	        enumerable: false,
	        writable: true
	    };
	    es5.defineProperty(obj, name, descriptor);
	    return obj;
	}
	
	function thrower(r) {
	    throw r;
	}
	
	var inheritedDataKeys = (function() {
	    var excludedPrototypes = [
	        Array.prototype,
	        Object.prototype,
	        Function.prototype
	    ];
	
	    var isExcludedProto = function(val) {
	        for (var i = 0; i < excludedPrototypes.length; ++i) {
	            if (excludedPrototypes[i] === val) {
	                return true;
	            }
	        }
	        return false;
	    };
	
	    if (es5.isES5) {
	        var getKeys = Object.getOwnPropertyNames;
	        return function(obj) {
	            var ret = [];
	            var visitedKeys = Object.create(null);
	            while (obj != null && !isExcludedProto(obj)) {
	                var keys;
	                try {
	                    keys = getKeys(obj);
	                } catch (e) {
	                    return ret;
	                }
	                for (var i = 0; i < keys.length; ++i) {
	                    var key = keys[i];
	                    if (visitedKeys[key]) continue;
	                    visitedKeys[key] = true;
	                    var desc = Object.getOwnPropertyDescriptor(obj, key);
	                    if (desc != null && desc.get == null && desc.set == null) {
	                        ret.push(key);
	                    }
	                }
	                obj = es5.getPrototypeOf(obj);
	            }
	            return ret;
	        };
	    } else {
	        var hasProp = {}.hasOwnProperty;
	        return function(obj) {
	            if (isExcludedProto(obj)) return [];
	            var ret = [];
	
	            /*jshint forin:false */
	            enumeration: for (var key in obj) {
	                if (hasProp.call(obj, key)) {
	                    ret.push(key);
	                } else {
	                    for (var i = 0; i < excludedPrototypes.length; ++i) {
	                        if (hasProp.call(excludedPrototypes[i], key)) {
	                            continue enumeration;
	                        }
	                    }
	                    ret.push(key);
	                }
	            }
	            return ret;
	        };
	    }
	
	})();
	
	var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
	function isClass(fn) {
	    try {
	        if (typeof fn === "function") {
	            var keys = es5.names(fn.prototype);
	
	            var hasMethods = es5.isES5 && keys.length > 1;
	            var hasMethodsOtherThanConstructor = keys.length > 0 &&
	                !(keys.length === 1 && keys[0] === "constructor");
	            var hasThisAssignmentAndStaticMethods =
	                thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
	
	            if (hasMethods || hasMethodsOtherThanConstructor ||
	                hasThisAssignmentAndStaticMethods) {
	                return true;
	            }
	        }
	        return false;
	    } catch (e) {
	        return false;
	    }
	}
	
	function toFastProperties(obj) {
	    /*jshint -W027,-W055,-W031*/
	    function f() {}
	    f.prototype = obj;
	    var l = 8;
	    while (l--) new f();
	    return obj;
	    eval(obj);
	}
	
	var rident = /^[a-z$_][a-z$_0-9]*$/i;
	function isIdentifier(str) {
	    return rident.test(str);
	}
	
	function filledRange(count, prefix, suffix) {
	    var ret = new Array(count);
	    for(var i = 0; i < count; ++i) {
	        ret[i] = prefix + i + suffix;
	    }
	    return ret;
	}
	
	function safeToString(obj) {
	    try {
	        return obj + "";
	    } catch (e) {
	        return "[no string representation]";
	    }
	}
	
	function markAsOriginatingFromRejection(e) {
	    try {
	        notEnumerableProp(e, "isOperational", true);
	    }
	    catch(ignore) {}
	}
	
	function originatesFromRejection(e) {
	    if (e == null) return false;
	    return ((e instanceof Error["__BluebirdErrorTypes__"].OperationalError) ||
	        e["isOperational"] === true);
	}
	
	function canAttachTrace(obj) {
	    return obj instanceof Error && es5.propertyIsWritable(obj, "stack");
	}
	
	var ensureErrorObject = (function() {
	    if (!("stack" in new Error())) {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            try {throw new Error(safeToString(value));}
	            catch(err) {return err;}
	        };
	    } else {
	        return function(value) {
	            if (canAttachTrace(value)) return value;
	            return new Error(safeToString(value));
	        };
	    }
	})();
	
	function classString(obj) {
	    return {}.toString.call(obj);
	}
	
	function copyDescriptors(from, to, filter) {
	    var keys = es5.names(from);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        if (filter(key)) {
	            try {
	                es5.defineProperty(to, key, es5.getDescriptor(from, key));
	            } catch (ignore) {}
	        }
	    }
	}
	
	var ret = {
	    isClass: isClass,
	    isIdentifier: isIdentifier,
	    inheritedDataKeys: inheritedDataKeys,
	    getDataPropertyOrDefault: getDataPropertyOrDefault,
	    thrower: thrower,
	    isArray: es5.isArray,
	    haveGetters: haveGetters,
	    notEnumerableProp: notEnumerableProp,
	    isPrimitive: isPrimitive,
	    isObject: isObject,
	    canEvaluate: canEvaluate,
	    errorObj: errorObj,
	    tryCatch: tryCatch,
	    inherits: inherits,
	    withAppended: withAppended,
	    maybeWrapAsError: maybeWrapAsError,
	    toFastProperties: toFastProperties,
	    filledRange: filledRange,
	    toString: safeToString,
	    canAttachTrace: canAttachTrace,
	    ensureErrorObject: ensureErrorObject,
	    originatesFromRejection: originatesFromRejection,
	    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
	    classString: classString,
	    copyDescriptors: copyDescriptors,
	    hasDevTools: typeof chrome !== "undefined" && chrome &&
	                 typeof chrome.loadTimes === "function",
	    isNode: typeof process !== "undefined" &&
	        classString(process).toLowerCase() === "[object process]"
	};
	ret.isRecentNode = ret.isNode && (function() {
	    var version = process.versions.node.split(".").map(Number);
	    return (version[0] === 0 && version[1] > 10) || (version[0] > 0);
	})();
	
	if (ret.isNode) ret.toFastProperties(process);
	
	try {throw new Error(); } catch (e) {ret.lastLineError = e;}
	module.exports = ret;
	
	},{"./es5.js":14}]},{},[4])(4)
	});                    ;if (typeof window !== 'undefined' && window !== null) {                               window.P = window.Promise;                                                     } else if (typeof self !== 'undefined' && self !== null) {                             self.P = self.Promise;                                                         }
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(271), (function() { return this; }()), __webpack_require__(1034).setImmediate))

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(335);
	
	var callBind = __webpack_require__(276);
	
	var $indexOf = callBind(GetIntrinsic('String.prototype.indexOf'));
	
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		var intrinsic = GetIntrinsic(name, !!allowMissing);
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBind(intrinsic);
		}
		return intrinsic;
	};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(332);
	__webpack_require__(317);
	__webpack_require__(315);
	__webpack_require__(321);
	__webpack_require__(318);
	__webpack_require__(324);
	__webpack_require__(326);
	__webpack_require__(314);
	__webpack_require__(320);
	__webpack_require__(311);
	__webpack_require__(325);
	__webpack_require__(309);
	__webpack_require__(323);
	__webpack_require__(322);
	__webpack_require__(316);
	__webpack_require__(319);
	__webpack_require__(308);
	__webpack_require__(310);
	__webpack_require__(313);
	__webpack_require__(312);
	__webpack_require__(327);
	__webpack_require__(160);
	module.exports = __webpack_require__(40).Array;


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(549);
	module.exports = __webpack_require__(40).RegExp.escape;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(10);
	var isArray = __webpack_require__(149);
	var SPECIES = __webpack_require__(13)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(9);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(5);
	var toPrimitive = __webpack_require__(60);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(90);
	var gOPS = __webpack_require__(153);
	var pIE = __webpack_require__(125);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(126)('native-function-to-string', Function.toString);


/***/ }),
/* 548 */
/***/ (function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(1);
	var $re = __webpack_require__(548)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(1);
	var toISOString = __webpack_require__(544);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(23);
	var toPrimitive = __webpack_require__(60);
	
	$export($export.P + $export.F * __webpack_require__(9)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(13)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(33)(proto, TO_PRIMITIVE, __webpack_require__(545));


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(34)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(1);
	
	$export($export.P, 'Function', { bind: __webpack_require__(281) });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(10);
	var getPrototypeOf = __webpack_require__(43);
	var HAS_INSTANCE = __webpack_require__(13)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(22).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(22).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(19) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(1);
	var log1p = __webpack_require__(292);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(1);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(1);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(1);
	var sign = __webpack_require__(209);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(1);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(1);
	var $expm1 = __webpack_require__(208);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { fround: __webpack_require__(291) });


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(1);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(1);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(9)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(292) });


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { sign: __webpack_require__(209) });


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(208);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(9)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(1);
	var expm1 = __webpack_require__(208);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(8);
	var has = __webpack_require__(41);
	var cof = __webpack_require__(50);
	var inheritIfRequired = __webpack_require__(204);
	var toPrimitive = __webpack_require__(60);
	var fails = __webpack_require__(9);
	var gOPN = __webpack_require__(89).f;
	var gOPD = __webpack_require__(42).f;
	var dP = __webpack_require__(22).f;
	var $trim = __webpack_require__(108).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(88)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(19) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(34)(global, NUMBER, $Number);
	}


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(1);
	var _isFinite = __webpack_require__(8).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(288) });


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(1);
	var isInteger = __webpack_require__(288);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(300);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(301);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toInteger = __webpack_require__(53);
	var aNumberValue = __webpack_require__(277);
	var repeat = __webpack_require__(216);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(9)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $fails = __webpack_require__(9);
	var aNumberValue = __webpack_require__(277);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(1);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(294) });


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(88) });


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperties: __webpack_require__(295) });


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(19), 'Object', { defineProperty: __webpack_require__(22).f });


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(10);
	var meta = __webpack_require__(79).onFreeze;
	
	__webpack_require__(59)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(44);
	var $getOwnPropertyDescriptor = __webpack_require__(42).f;
	
	__webpack_require__(59)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(59)('getOwnPropertyNames', function () {
	  return __webpack_require__(296).f;
	});


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(23);
	var $getPrototypeOf = __webpack_require__(43);
	
	__webpack_require__(59)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(10);
	
	__webpack_require__(59)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(10);
	
	__webpack_require__(59)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(10);
	
	__webpack_require__(59)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { is: __webpack_require__(304) });


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(23);
	var $keys = __webpack_require__(90);
	
	__webpack_require__(59)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(10);
	var meta = __webpack_require__(79).onFreeze;
	
	__webpack_require__(59)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(10);
	var meta = __webpack_require__(79).onFreeze;
	
	__webpack_require__(59)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(1);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(213).set });


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(105);
	var test = {};
	test[__webpack_require__(13)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(34)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseFloat = __webpack_require__(300);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $parseInt = __webpack_require__(301);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(78);
	var global = __webpack_require__(8);
	var ctx = __webpack_require__(51);
	var classof = __webpack_require__(105);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(10);
	var aFunction = __webpack_require__(29);
	var anInstance = __webpack_require__(86);
	var forOf = __webpack_require__(87);
	var speciesConstructor = __webpack_require__(127);
	var task = __webpack_require__(218).set;
	var microtask = __webpack_require__(210)();
	var newPromiseCapabilityModule = __webpack_require__(211);
	var perform = __webpack_require__(302);
	var userAgent = __webpack_require__(159);
	var promiseResolve = __webpack_require__(303);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(13)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(92)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(107)($Promise, PROMISE);
	__webpack_require__(93)(PROMISE);
	Wrapper = __webpack_require__(40)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(151)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(1);
	var aFunction = __webpack_require__(29);
	var anObject = __webpack_require__(5);
	var rApply = (__webpack_require__(8).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(9)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(1);
	var create = __webpack_require__(88);
	var aFunction = __webpack_require__(29);
	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(10);
	var fails = __webpack_require__(9);
	var bind = __webpack_require__(281);
	var rConstruct = (__webpack_require__(8).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(22);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(5);
	var toPrimitive = __webpack_require__(60);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(9)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(1);
	var gOPD = __webpack_require__(42).f;
	var anObject = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(5);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(206)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(42);
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(1);
	var getProto = __webpack_require__(43);
	var anObject = __webpack_require__(5);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(42);
	var getPrototypeOf = __webpack_require__(43);
	var has = __webpack_require__(41);
	var $export = __webpack_require__(1);
	var isObject = __webpack_require__(10);
	var anObject = __webpack_require__(5);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(5);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(299) });


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(1);
	var anObject = __webpack_require__(5);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(1);
	var setProto = __webpack_require__(213);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(22);
	var gOPD = __webpack_require__(42);
	var getPrototypeOf = __webpack_require__(43);
	var has = __webpack_require__(41);
	var $export = __webpack_require__(1);
	var createDesc = __webpack_require__(91);
	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(10);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(8);
	var inheritIfRequired = __webpack_require__(204);
	var dP = __webpack_require__(22).f;
	var gOPN = __webpack_require__(89).f;
	var isRegExp = __webpack_require__(150);
	var $flags = __webpack_require__(123);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(19) && (!CORRECT_NEW || __webpack_require__(9)(function () {
	  re2[__webpack_require__(13)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(34)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(93)('RegExp');


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(5);
	var toLength = __webpack_require__(15);
	var advanceStringIndex = __webpack_require__(196);
	var regExpExec = __webpack_require__(154);
	
	// @@match logic
	__webpack_require__(148)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(5);
	var toObject = __webpack_require__(23);
	var toLength = __webpack_require__(15);
	var toInteger = __webpack_require__(53);
	var advanceStringIndex = __webpack_require__(196);
	var regExpExec = __webpack_require__(154);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(148)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(5);
	var sameValue = __webpack_require__(304);
	var regExpExec = __webpack_require__(154);
	
	// @@search logic
	__webpack_require__(148)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(150);
	var anObject = __webpack_require__(5);
	var speciesConstructor = __webpack_require__(127);
	var advanceStringIndex = __webpack_require__(196);
	var toLength = __webpack_require__(15);
	var callRegExpExec = __webpack_require__(154);
	var regexpExec = __webpack_require__(212);
	var fails = __webpack_require__(9);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(148)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(330);
	var anObject = __webpack_require__(5);
	var $flags = __webpack_require__(123);
	var DESCRIPTORS = __webpack_require__(19);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(34)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(9)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(35)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(35)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(35)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(35)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(157)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(15);
	var context = __webpack_require__(215);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(202)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(35)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(35)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(35)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toAbsoluteIndex = __webpack_require__(94);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(1);
	var context = __webpack_require__(215);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(202)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(35)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(35)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var toIObject = __webpack_require__(44);
	var toLength = __webpack_require__(15);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(216)
	});


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(35)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(1);
	var toLength = __webpack_require__(15);
	var context = __webpack_require__(215);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(202)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(35)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(35)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(35)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(108)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(8);
	var has = __webpack_require__(41);
	var DESCRIPTORS = __webpack_require__(19);
	var $export = __webpack_require__(1);
	var redefine = __webpack_require__(34);
	var META = __webpack_require__(79).KEY;
	var $fails = __webpack_require__(9);
	var shared = __webpack_require__(126);
	var setToStringTag = __webpack_require__(107);
	var uid = __webpack_require__(95);
	var wks = __webpack_require__(13);
	var wksExt = __webpack_require__(307);
	var wksDefine = __webpack_require__(220);
	var enumKeys = __webpack_require__(546);
	var isArray = __webpack_require__(149);
	var anObject = __webpack_require__(5);
	var isObject = __webpack_require__(10);
	var toObject = __webpack_require__(23);
	var toIObject = __webpack_require__(44);
	var toPrimitive = __webpack_require__(60);
	var createDesc = __webpack_require__(91);
	var _create = __webpack_require__(88);
	var gOPNExt = __webpack_require__(296);
	var $GOPD = __webpack_require__(42);
	var $GOPS = __webpack_require__(153);
	var $DP = __webpack_require__(22);
	var $keys = __webpack_require__(90);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(89).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(125).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(78)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(33)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var $typed = __webpack_require__(158);
	var buffer = __webpack_require__(219);
	var anObject = __webpack_require__(5);
	var toAbsoluteIndex = __webpack_require__(94);
	var toLength = __webpack_require__(15);
	var isObject = __webpack_require__(10);
	var ArrayBuffer = __webpack_require__(8).ArrayBuffer;
	var speciesConstructor = __webpack_require__(127);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(9)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(93)(ARRAY_BUFFER);


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	$export($export.G + $export.W + $export.F * !__webpack_require__(158).ABV, {
	  DataView: __webpack_require__(219).DataView
	});


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(66)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(284);
	var validate = __webpack_require__(96);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(147)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(285);
	var toObject = __webpack_require__(23);
	var toLength = __webpack_require__(15);
	var aFunction = __webpack_require__(29);
	var arraySpeciesCreate = __webpack_require__(198);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(77)('flatMap');


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(1);
	var flattenIntoArray = __webpack_require__(285);
	var toObject = __webpack_require__(23);
	var toLength = __webpack_require__(15);
	var toInteger = __webpack_require__(53);
	var arraySpeciesCreate = __webpack_require__(198);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(77)('flatten');


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(1);
	var $includes = __webpack_require__(146)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(77)('includes');


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(1);
	var microtask = __webpack_require__(210)();
	var process = __webpack_require__(8).process;
	var isNode = __webpack_require__(50)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(1);
	var cof = __webpack_require__(50);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.G, { global: __webpack_require__(8) });


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(155)('Map');


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(156)('Map');


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(283)('Map') });


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var scale = __webpack_require__(293);
	var fround = __webpack_require__(291);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { scale: __webpack_require__(293) });


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(1);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(23);
	var aFunction = __webpack_require__(29);
	var $defineProperty = __webpack_require__(22);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(19) && $export($export.P + __webpack_require__(152), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(23);
	var aFunction = __webpack_require__(29);
	var $defineProperty = __webpack_require__(22);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(19) && $export($export.P + __webpack_require__(152), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $entries = __webpack_require__(298)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(1);
	var ownKeys = __webpack_require__(299);
	var toIObject = __webpack_require__(44);
	var gOPD = __webpack_require__(42);
	var createProperty = __webpack_require__(199);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(23);
	var toPrimitive = __webpack_require__(60);
	var getPrototypeOf = __webpack_require__(43);
	var getOwnPropertyDescriptor = __webpack_require__(42).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(19) && $export($export.P + __webpack_require__(152), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(1);
	var toObject = __webpack_require__(23);
	var toPrimitive = __webpack_require__(60);
	var getPrototypeOf = __webpack_require__(43);
	var getOwnPropertyDescriptor = __webpack_require__(42).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(19) && $export($export.P + __webpack_require__(152), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(1);
	var $values = __webpack_require__(298)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(1);
	var global = __webpack_require__(8);
	var core = __webpack_require__(40);
	var microtask = __webpack_require__(210)();
	var OBSERVABLE = __webpack_require__(13)('observable');
	var aFunction = __webpack_require__(29);
	var anObject = __webpack_require__(5);
	var anInstance = __webpack_require__(86);
	var redefineAll = __webpack_require__(92);
	var hide = __webpack_require__(33);
	var forOf = __webpack_require__(87);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(93)('Observable');


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(1);
	var core = __webpack_require__(40);
	var global = __webpack_require__(8);
	var speciesConstructor = __webpack_require__(127);
	var promiseResolve = __webpack_require__(303);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(1);
	var newPromiseCapability = __webpack_require__(211);
	var perform = __webpack_require__(302);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(65);
	var anObject = __webpack_require__(5);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(65);
	var anObject = __webpack_require__(5);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(331);
	var from = __webpack_require__(279);
	var metadata = __webpack_require__(65);
	var anObject = __webpack_require__(5);
	var getPrototypeOf = __webpack_require__(43);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(65);
	var anObject = __webpack_require__(5);
	var getPrototypeOf = __webpack_require__(43);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(65);
	var anObject = __webpack_require__(5);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(65);
	var anObject = __webpack_require__(5);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(65);
	var anObject = __webpack_require__(5);
	var getPrototypeOf = __webpack_require__(43);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(65);
	var anObject = __webpack_require__(5);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(65);
	var anObject = __webpack_require__(5);
	var aFunction = __webpack_require__(29);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(155)('Set');


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(156)('Set');


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(1);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(283)('Set') });


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(1);
	var $at = __webpack_require__(157)(true);
	var $fails = __webpack_require__(9);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(1);
	var defined = __webpack_require__(58);
	var toLength = __webpack_require__(15);
	var isRegExp = __webpack_require__(150);
	var getFlags = __webpack_require__(123);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(206)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(305);
	var userAgent = __webpack_require__(159);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(1);
	var $pad = __webpack_require__(305);
	var userAgent = __webpack_require__(159);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(108)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(108)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(220)('asyncIterator');


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(220)('observable');


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(1);
	
	$export($export.S, 'System', { global: __webpack_require__(8) });


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(155)('WeakMap');


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(156)('WeakMap');


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(155)('WeakSet');


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(156)('WeakSet');


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(160);
	var getKeys = __webpack_require__(90);
	var redefine = __webpack_require__(34);
	var global = __webpack_require__(8);
	var hide = __webpack_require__(33);
	var Iterators = __webpack_require__(106);
	var wks = __webpack_require__(13);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(1);
	var $task = __webpack_require__(218);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(8);
	var $export = __webpack_require__(1);
	var userAgent = __webpack_require__(159);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(648);
	__webpack_require__(588);
	__webpack_require__(590);
	__webpack_require__(589);
	__webpack_require__(592);
	__webpack_require__(594);
	__webpack_require__(599);
	__webpack_require__(593);
	__webpack_require__(591);
	__webpack_require__(601);
	__webpack_require__(600);
	__webpack_require__(596);
	__webpack_require__(597);
	__webpack_require__(595);
	__webpack_require__(587);
	__webpack_require__(598);
	__webpack_require__(602);
	__webpack_require__(603);
	__webpack_require__(555);
	__webpack_require__(557);
	__webpack_require__(556);
	__webpack_require__(605);
	__webpack_require__(604);
	__webpack_require__(575);
	__webpack_require__(585);
	__webpack_require__(586);
	__webpack_require__(576);
	__webpack_require__(577);
	__webpack_require__(578);
	__webpack_require__(579);
	__webpack_require__(580);
	__webpack_require__(581);
	__webpack_require__(582);
	__webpack_require__(583);
	__webpack_require__(584);
	__webpack_require__(558);
	__webpack_require__(559);
	__webpack_require__(560);
	__webpack_require__(561);
	__webpack_require__(562);
	__webpack_require__(563);
	__webpack_require__(564);
	__webpack_require__(565);
	__webpack_require__(566);
	__webpack_require__(567);
	__webpack_require__(568);
	__webpack_require__(569);
	__webpack_require__(570);
	__webpack_require__(571);
	__webpack_require__(572);
	__webpack_require__(573);
	__webpack_require__(574);
	__webpack_require__(636);
	__webpack_require__(640);
	__webpack_require__(647);
	__webpack_require__(332);
	__webpack_require__(631);
	__webpack_require__(632);
	__webpack_require__(637);
	__webpack_require__(641);
	__webpack_require__(643);
	__webpack_require__(627);
	__webpack_require__(628);
	__webpack_require__(629);
	__webpack_require__(630);
	__webpack_require__(633);
	__webpack_require__(634);
	__webpack_require__(635);
	__webpack_require__(638);
	__webpack_require__(639);
	__webpack_require__(642);
	__webpack_require__(644);
	__webpack_require__(645);
	__webpack_require__(646);
	__webpack_require__(550);
	__webpack_require__(552);
	__webpack_require__(551);
	__webpack_require__(554);
	__webpack_require__(553);
	__webpack_require__(317);
	__webpack_require__(315);
	__webpack_require__(321);
	__webpack_require__(318);
	__webpack_require__(324);
	__webpack_require__(326);
	__webpack_require__(314);
	__webpack_require__(320);
	__webpack_require__(311);
	__webpack_require__(325);
	__webpack_require__(309);
	__webpack_require__(323);
	__webpack_require__(322);
	__webpack_require__(316);
	__webpack_require__(319);
	__webpack_require__(308);
	__webpack_require__(310);
	__webpack_require__(313);
	__webpack_require__(312);
	__webpack_require__(327);
	__webpack_require__(160);
	__webpack_require__(621);
	__webpack_require__(329);
	__webpack_require__(626);
	__webpack_require__(330);
	__webpack_require__(622);
	__webpack_require__(623);
	__webpack_require__(624);
	__webpack_require__(625);
	__webpack_require__(606);
	__webpack_require__(328);
	__webpack_require__(331);
	__webpack_require__(333);
	__webpack_require__(660);
	__webpack_require__(649);
	__webpack_require__(650);
	__webpack_require__(655);
	__webpack_require__(658);
	__webpack_require__(659);
	__webpack_require__(653);
	__webpack_require__(656);
	__webpack_require__(654);
	__webpack_require__(657);
	__webpack_require__(651);
	__webpack_require__(652);
	__webpack_require__(607);
	__webpack_require__(608);
	__webpack_require__(609);
	__webpack_require__(610);
	__webpack_require__(611);
	__webpack_require__(614);
	__webpack_require__(612);
	__webpack_require__(613);
	__webpack_require__(615);
	__webpack_require__(616);
	__webpack_require__(617);
	__webpack_require__(618);
	__webpack_require__(620);
	__webpack_require__(619);
	__webpack_require__(663);
	__webpack_require__(661);
	__webpack_require__(662);
	__webpack_require__(704);
	__webpack_require__(707);
	__webpack_require__(706);
	__webpack_require__(708);
	__webpack_require__(709);
	__webpack_require__(705);
	__webpack_require__(710);
	__webpack_require__(711);
	__webpack_require__(685);
	__webpack_require__(688);
	__webpack_require__(684);
	__webpack_require__(682);
	__webpack_require__(683);
	__webpack_require__(686);
	__webpack_require__(687);
	__webpack_require__(669);
	__webpack_require__(703);
	__webpack_require__(668);
	__webpack_require__(702);
	__webpack_require__(714);
	__webpack_require__(716);
	__webpack_require__(667);
	__webpack_require__(701);
	__webpack_require__(713);
	__webpack_require__(715);
	__webpack_require__(666);
	__webpack_require__(712);
	__webpack_require__(665);
	__webpack_require__(670);
	__webpack_require__(671);
	__webpack_require__(672);
	__webpack_require__(673);
	__webpack_require__(674);
	__webpack_require__(676);
	__webpack_require__(675);
	__webpack_require__(677);
	__webpack_require__(678);
	__webpack_require__(679);
	__webpack_require__(681);
	__webpack_require__(680);
	__webpack_require__(690);
	__webpack_require__(691);
	__webpack_require__(692);
	__webpack_require__(693);
	__webpack_require__(695);
	__webpack_require__(694);
	__webpack_require__(697);
	__webpack_require__(696);
	__webpack_require__(698);
	__webpack_require__(699);
	__webpack_require__(700);
	__webpack_require__(664);
	__webpack_require__(689);
	__webpack_require__(719);
	__webpack_require__(718);
	__webpack_require__(717);
	module.exports = __webpack_require__(40);


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(951);
	var email = module.exports = function() {};
	
	var strToObj = function(str) {
	  var obj = {};
	  for(var i = 0; i < str.length; i++) {
	    obj[str[i]] = str.charCodeAt(i);
	  }
	  return obj;
	};
	
	var chars = strToObj("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!#$%&'*+-/=?^_`{|}~.");
	var specialchars = strToObj("\\\"(),:;<>@[\] ");
	var escapers = strToObj('\\"');
	var hostchars = strToObj("abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789.-");
	
	email.parse = function(address, dothrow, callback) {
	  callback = (typeof callback == 'undefined' && typeof dothrow == 'function') ? dothrow : null;
	  var userland = true;
	  var quotation = false;
	  var escaped = false;
	  var _user = "", _domain = "";
	  var hostisip = false;
	  var hoststartpos = 0;
	  try {
	    if(address.length >= 254) throw util.format("[Error parsing email address: address is longer than 253, actual]", address.length);
	    for(var i = 0; i < address.length; i++) {
	      //console.log(i, address[i])
	      if(userland) {
	        if(address[i] == '"' && i == 0) { quotation = true; _user += address[i]; continue; }
	        if(typeof chars[address[i]] != 'undefined') { //needed I'm sure.
	          _user += address[i]; continue;
	        } else if(typeof specialchars[address[i]] != 'undefined') {
	          if(quotation) {
	            if(!escaped && address[i] == "\\") { escaped = true; _user += address[i]; continue; }
	            if(!escaped && address[i] == '"' && address[i+1] == "@") { userland = false; hoststartpos = i+2; _user += address[i]; i+=1; continue; }
	            if(escaped && typeof escapers[address[i]] != 'undefined') { escaped = false; _user += address[i]; continue; }
	            if(!escaped && typeof escapers[address[i]] != 'undefined') throw util.format("[Error parsing email address: invalid use of %s (pos: %s)]", address[i], i, address);
	          } else if(address[i] == "@" && !quotation) {
	            userland = false;
	            hoststartpos = i+1;
	            continue;
	          } else {
	            throw util.format("[Error parsing email address: special character '%s' (pos: %s) used without quotation marks]", address[i], i);
	          }
	        } else {
	          throw util.format("[Error parsing email address: character '%s' (pos: %s) is not allowed in an email address user space.]", address[i], i, address);
	        }
	        _user += address[i];
	      } else { //parsing hostname. Probably could be done with regex.
	        if(i == hoststartpos && address[i] == '[') { hostisip = true; hostchars['['] = '['; hostchars[']'] = ']'; hostchars[':'] = ':'; _domain += address[i]; continue; }
	        if(typeof hostchars[address[i]] == 'undefined') throw util.format("[Error parsing email address: character '%s' (pos: %s) is not allowed in the hostname section]", address[i], i);
	        if(i >= hoststartpos && /[@\.]/.test(address[i - 1]) && !/[a-z0-9]/i.test(address[i])) throw util.format("[Error parsing email address: All domain segments must start with a letter or number, never a symbol like '%s'.")
	        _domain += address[i];
	      }
	    }
	    if(_domain === '') throw util.format("[Error parseing email address: no domain part]", address);
	    if(hostisip && !__webpack_require__(1033).isIP(address.substring(hoststartpos+1,address.length-1))) throw util.format("[Error parsing email address: invalid IP address]");
	    if(hostisip && address[address.length-1] != "]") throw util.format("[Error parsing email address: IP address notation must end with a ']']");
	    if(!hostisip && (/^.+@([a-z0-9]{64,}(|\.))/i).test(address)) throw util.format("[Error parsing email address: hostname has elements greater than 63 characters]");
	    if(userland) throw util.format("[Error parsing email address: quotation mark not closed]" , address);
	  } catch (err) {
	    if(callback) callback(err);
	    if(typeof dothrow != 'undefined' && typeof dothrow != 'function') throw err;
	    return false; //redundant?
	  }
	  if(callback) callback(null, {user: _user, domain: _domain});
	  else return {user: _user, domain: _domain};
	}
	
	email.valid = function(address, dothrow, callback) {
	  return !!email.parse(address, dothrow, callback);
	}


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(724);


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(722);
	
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *         case 'city-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	
	var Dispatcher = (function () {
	  function Dispatcher() {
	    _classCallCheck(this, Dispatcher);
	
	    this._callbacks = {};
	    this._isDispatching = false;
	    this._isHandled = {};
	    this._isPending = {};
	    this._lastID = 1;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   */
	
	  Dispatcher.prototype.register = function register(callback) {
	    var id = _prefix + this._lastID++;
	    this._callbacks[id] = callback;
	    return id;
	  };
	
	  /**
	   * Removes a callback based on its token.
	   */
	
	  Dispatcher.prototype.unregister = function unregister(id) {
	    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	    delete this._callbacks[id];
	  };
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   */
	
	  Dispatcher.prototype.waitFor = function waitFor(ids) {
	    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : undefined;
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this._isPending[id]) {
	        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : undefined;
	        continue;
	      }
	      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : undefined;
	      this._invokeCallback(id);
	    }
	  };
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   */
	
	  Dispatcher.prototype.dispatch = function dispatch(payload) {
	    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : undefined;
	    this._startDispatching(payload);
	    try {
	      for (var id in this._callbacks) {
	        if (this._isPending[id]) {
	          continue;
	        }
	        this._invokeCallback(id);
	      }
	    } finally {
	      this._stopDispatching();
	    }
	  };
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   */
	
	  Dispatcher.prototype.isDispatching = function isDispatching() {
	    return this._isDispatching;
	  };
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._invokeCallback = function _invokeCallback(id) {
	    this._isPending[id] = true;
	    this._callbacks[id](this._pendingPayload);
	    this._isHandled[id] = true;
	  };
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._startDispatching = function _startDispatching(payload) {
	    for (var id in this._callbacks) {
	      this._isPending[id] = false;
	      this._isHandled[id] = false;
	    }
	    this._pendingPayload = payload;
	    this._isDispatching = true;
	  };
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */
	
	  Dispatcher.prototype._stopDispatching = function _stopDispatching() {
	    delete this._pendingPayload;
	    this._isDispatching = false;
	  };
	
	  return Dispatcher;
	})();
	
	module.exports = Dispatcher;

/***/ }),
/* 725 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var slice = Array.prototype.slice;
	var toStr = Object.prototype.toString;
	var funcType = '[object Function]';
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.call(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slice.call(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                args.concat(slice.call(arguments))
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        } else {
	            return target.apply(
	                that,
	                args.concat(slice.call(arguments))
	            );
	        }
	    };
	
	    var boundLength = Math.max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs.push('$' + i);
	    }
	
	    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(336);
	
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(223);
	
	module.exports = bind.call(Function.call, Object.prototype.hasOwnProperty);


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	var img = __webpack_require__(729)
	
	module.exports = function promisifyImgAsync(Promise) {
	    return function imgAsync(path) {
	        return new Promise(function(resolve, reject) {
	            img(path, function(err, el) {
	                if (err) reject(err)
	                else resolve(el)
	            })
	        })
	    }
	}

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	module.exports = img;
	
	function img (src, opt, callback) {
	  if (typeof opt === 'function') {
	    callback = opt
	    opt = null
	  }
	
	
	  var el = document.createElement('img');
	  var locked;
	
	  el.onload = function () {
	    if (locked) return;
	    locked = true;
	
	    callback && callback(undefined, el);
	  };
	
	  el.onerror = function (err) {
	    if (locked) return;
	    locked = true;
	
	    callback && callback(new Error('Unable to load "' + src + '"'));
	  };
	  
	  if (opt && opt.crossOrigin)
	    el.crossOrigin = opt.crossOrigin;
	
	  el.src = src;
	
	  return el;
	}


/***/ }),
/* 730 */
/***/ (function(module, exports) {

	"use strict";
	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	Object.defineProperty(exports, "__esModule", { value: true });
	var RelativeTimeFormat;
	// -- Utilities ----------------------------------------------------------------
	function getCacheId(inputs) {
	    return JSON.stringify(inputs.map(function (input) {
	        return input && typeof input === 'object' ? orderedProps(input) : input;
	    }));
	}
	function orderedProps(obj) {
	    return Object.keys(obj)
	        .sort()
	        .map(function (k) {
	        var _a;
	        return (_a = {}, _a[k] = obj[k], _a);
	    });
	}
	var memoizeFormatConstructor = function (FormatConstructor, cache) {
	    if (cache === void 0) { cache = {}; }
	    return function () {
	        var _a;
	        var args = [];
	        for (var _i = 0; _i < arguments.length; _i++) {
	            args[_i] = arguments[_i];
	        }
	        var cacheId = getCacheId(args);
	        var format = cacheId && cache[cacheId];
	        if (!format) {
	            format = new ((_a = FormatConstructor).bind.apply(_a, [void 0].concat(args)))();
	            if (cacheId) {
	                cache[cacheId] = format;
	            }
	        }
	        return format;
	    };
	};
	exports.default = memoizeFormatConstructor;
	//# sourceMappingURL=index.js.map

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(730)['default'];
	exports['default'] = exports;


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports = module.exports = __webpack_require__(733)['default'];
	exports['default'] = exports;


/***/ }),
/* 733 */
/***/ (function(module, exports) {

	"use strict";
	
	exports["default"] = (function() {
	  /*
	   * Generated by PEG.js 0.8.0.
	   *
	   * http://pegjs.majda.cz/
	   */
	
	  function peg$subclass(child, parent) {
	    function ctor() { this.constructor = child; }
	    ctor.prototype = parent.prototype;
	    child.prototype = new ctor();
	  }
	
	  function SyntaxError(message, expected, found, offset, line, column) {
	    this.message  = message;
	    this.expected = expected;
	    this.found    = found;
	    this.offset   = offset;
	    this.line     = line;
	    this.column   = column;
	
	    this.name     = "SyntaxError";
	  }
	
	  peg$subclass(SyntaxError, Error);
	
	  function parse(input) {
	    var options = arguments.length > 1 ? arguments[1] : {},
	
	        peg$FAILED = {},
	
	        peg$startRuleFunctions = { start: peg$parsestart },
	        peg$startRuleFunction  = peg$parsestart,
	
	        peg$c0 = [],
	        peg$c1 = function(elements) {
	                return {
	                    type    : 'messageFormatPattern',
	                    elements: elements
	                };
	            },
	        peg$c2 = peg$FAILED,
	        peg$c3 = function(text) {
	                var string = '',
	                    i, j, outerLen, inner, innerLen;
	
	                for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
	                    inner = text[i];
	
	                    for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
	                        string += inner[j];
	                    }
	                }
	
	                return string;
	            },
	        peg$c4 = function(messageText) {
	                return {
	                    type : 'messageTextElement',
	                    value: messageText
	                };
	            },
	        peg$c5 = /^[^ \t\n\r,.+={}#]/,
	        peg$c6 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
	        peg$c7 = "{",
	        peg$c8 = { type: "literal", value: "{", description: "\"{\"" },
	        peg$c9 = null,
	        peg$c10 = ",",
	        peg$c11 = { type: "literal", value: ",", description: "\",\"" },
	        peg$c12 = "}",
	        peg$c13 = { type: "literal", value: "}", description: "\"}\"" },
	        peg$c14 = function(id, format) {
	                return {
	                    type  : 'argumentElement',
	                    id    : id,
	                    format: format && format[2]
	                };
	            },
	        peg$c15 = "number",
	        peg$c16 = { type: "literal", value: "number", description: "\"number\"" },
	        peg$c17 = "date",
	        peg$c18 = { type: "literal", value: "date", description: "\"date\"" },
	        peg$c19 = "time",
	        peg$c20 = { type: "literal", value: "time", description: "\"time\"" },
	        peg$c21 = function(type, style) {
	                return {
	                    type : type + 'Format',
	                    style: style && style[2]
	                };
	            },
	        peg$c22 = "plural",
	        peg$c23 = { type: "literal", value: "plural", description: "\"plural\"" },
	        peg$c24 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: false,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                };
	            },
	        peg$c25 = "selectordinal",
	        peg$c26 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
	        peg$c27 = function(pluralStyle) {
	                return {
	                    type   : pluralStyle.type,
	                    ordinal: true,
	                    offset : pluralStyle.offset || 0,
	                    options: pluralStyle.options
	                }
	            },
	        peg$c28 = "select",
	        peg$c29 = { type: "literal", value: "select", description: "\"select\"" },
	        peg$c30 = function(options) {
	                return {
	                    type   : 'selectFormat',
	                    options: options
	                };
	            },
	        peg$c31 = "=",
	        peg$c32 = { type: "literal", value: "=", description: "\"=\"" },
	        peg$c33 = function(selector, pattern) {
	                return {
	                    type    : 'optionalFormatPattern',
	                    selector: selector,
	                    value   : pattern
	                };
	            },
	        peg$c34 = "offset:",
	        peg$c35 = { type: "literal", value: "offset:", description: "\"offset:\"" },
	        peg$c36 = function(number) {
	                return number;
	            },
	        peg$c37 = function(offset, options) {
	                return {
	                    type   : 'pluralFormat',
	                    offset : offset,
	                    options: options
	                };
	            },
	        peg$c38 = { type: "other", description: "whitespace" },
	        peg$c39 = /^[ \t\n\r]/,
	        peg$c40 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
	        peg$c41 = { type: "other", description: "optionalWhitespace" },
	        peg$c42 = /^[0-9]/,
	        peg$c43 = { type: "class", value: "[0-9]", description: "[0-9]" },
	        peg$c44 = /^[0-9a-f]/i,
	        peg$c45 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
	        peg$c46 = "0",
	        peg$c47 = { type: "literal", value: "0", description: "\"0\"" },
	        peg$c48 = /^[1-9]/,
	        peg$c49 = { type: "class", value: "[1-9]", description: "[1-9]" },
	        peg$c50 = function(digits) {
	            return parseInt(digits, 10);
	        },
	        peg$c51 = /^[^{}\\\0-\x1F \t\n\r]/,
	        peg$c52 = { type: "class", value: "[^{}\\\\\\0-\\x1F \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F \\t\\n\\r]" },
	        peg$c53 = "\\\\",
	        peg$c54 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
	        peg$c55 = function() { return '\\'; },
	        peg$c56 = "\\#",
	        peg$c57 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
	        peg$c58 = function() { return '\\#'; },
	        peg$c59 = "\\{",
	        peg$c60 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
	        peg$c61 = function() { return '\u007B'; },
	        peg$c62 = "\\}",
	        peg$c63 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
	        peg$c64 = function() { return '\u007D'; },
	        peg$c65 = "\\u",
	        peg$c66 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
	        peg$c67 = function(digits) {
	                return String.fromCharCode(parseInt(digits, 16));
	            },
	        peg$c68 = function(chars) { return chars.join(''); },
	
	        peg$currPos          = 0,
	        peg$reportedPos      = 0,
	        peg$cachedPos        = 0,
	        peg$cachedPosDetails = { line: 1, column: 1, seenCR: false },
	        peg$maxFailPos       = 0,
	        peg$maxFailExpected  = [],
	        peg$silentFails      = 0,
	
	        peg$result;
	
	    if ("startRule" in options) {
	      if (!(options.startRule in peg$startRuleFunctions)) {
	        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
	      }
	
	      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
	    }
	
	    function text() {
	      return input.substring(peg$reportedPos, peg$currPos);
	    }
	
	    function offset() {
	      return peg$reportedPos;
	    }
	
	    function line() {
	      return peg$computePosDetails(peg$reportedPos).line;
	    }
	
	    function column() {
	      return peg$computePosDetails(peg$reportedPos).column;
	    }
	
	    function expected(description) {
	      throw peg$buildException(
	        null,
	        [{ type: "other", description: description }],
	        peg$reportedPos
	      );
	    }
	
	    function error(message) {
	      throw peg$buildException(message, null, peg$reportedPos);
	    }
	
	    function peg$computePosDetails(pos) {
	      function advance(details, startPos, endPos) {
	        var p, ch;
	
	        for (p = startPos; p < endPos; p++) {
	          ch = input.charAt(p);
	          if (ch === "\n") {
	            if (!details.seenCR) { details.line++; }
	            details.column = 1;
	            details.seenCR = false;
	          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
	            details.line++;
	            details.column = 1;
	            details.seenCR = true;
	          } else {
	            details.column++;
	            details.seenCR = false;
	          }
	        }
	      }
	
	      if (peg$cachedPos !== pos) {
	        if (peg$cachedPos > pos) {
	          peg$cachedPos = 0;
	          peg$cachedPosDetails = { line: 1, column: 1, seenCR: false };
	        }
	        advance(peg$cachedPosDetails, peg$cachedPos, pos);
	        peg$cachedPos = pos;
	      }
	
	      return peg$cachedPosDetails;
	    }
	
	    function peg$fail(expected) {
	      if (peg$currPos < peg$maxFailPos) { return; }
	
	      if (peg$currPos > peg$maxFailPos) {
	        peg$maxFailPos = peg$currPos;
	        peg$maxFailExpected = [];
	      }
	
	      peg$maxFailExpected.push(expected);
	    }
	
	    function peg$buildException(message, expected, pos) {
	      function cleanupExpected(expected) {
	        var i = 1;
	
	        expected.sort(function(a, b) {
	          if (a.description < b.description) {
	            return -1;
	          } else if (a.description > b.description) {
	            return 1;
	          } else {
	            return 0;
	          }
	        });
	
	        while (i < expected.length) {
	          if (expected[i - 1] === expected[i]) {
	            expected.splice(i, 1);
	          } else {
	            i++;
	          }
	        }
	      }
	
	      function buildMessage(expected, found) {
	        function stringEscape(s) {
	          function hex(ch) { return ch.charCodeAt(0).toString(16).toUpperCase(); }
	
	          return s
	            .replace(/\\/g,   '\\\\')
	            .replace(/"/g,    '\\"')
	            .replace(/\x08/g, '\\b')
	            .replace(/\t/g,   '\\t')
	            .replace(/\n/g,   '\\n')
	            .replace(/\f/g,   '\\f')
	            .replace(/\r/g,   '\\r')
	            .replace(/[\x00-\x07\x0B\x0E\x0F]/g, function(ch) { return '\\x0' + hex(ch); })
	            .replace(/[\x10-\x1F\x80-\xFF]/g,    function(ch) { return '\\x'  + hex(ch); })
	            .replace(/[\u0180-\u0FFF]/g,         function(ch) { return '\\u0' + hex(ch); })
	            .replace(/[\u1080-\uFFFF]/g,         function(ch) { return '\\u'  + hex(ch); });
	        }
	
	        var expectedDescs = new Array(expected.length),
	            expectedDesc, foundDesc, i;
	
	        for (i = 0; i < expected.length; i++) {
	          expectedDescs[i] = expected[i].description;
	        }
	
	        expectedDesc = expected.length > 1
	          ? expectedDescs.slice(0, -1).join(", ")
	              + " or "
	              + expectedDescs[expected.length - 1]
	          : expectedDescs[0];
	
	        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";
	
	        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
	      }
	
	      var posDetails = peg$computePosDetails(pos),
	          found      = pos < input.length ? input.charAt(pos) : null;
	
	      if (expected !== null) {
	        cleanupExpected(expected);
	      }
	
	      return new SyntaxError(
	        message !== null ? message : buildMessage(expected, found),
	        expected,
	        found,
	        pos,
	        posDetails.line,
	        posDetails.column
	      );
	    }
	
	    function peg$parsestart() {
	      var s0;
	
	      s0 = peg$parsemessageFormatPattern();
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatPattern() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsemessageFormatElement();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsemessageFormatElement();
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c1(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsemessageFormatElement() {
	      var s0;
	
	      s0 = peg$parsemessageTextElement();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parseargumentElement();
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageText() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$currPos;
	      s3 = peg$parse_();
	      if (s3 !== peg$FAILED) {
	        s4 = peg$parsechars();
	        if (s4 !== peg$FAILED) {
	          s5 = peg$parse_();
	          if (s5 !== peg$FAILED) {
	            s3 = [s3, s4, s5];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	      } else {
	        peg$currPos = s2;
	        s2 = peg$c2;
	      }
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$currPos;
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parsechars();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s3 = [s3, s4, s5];
	                s2 = s3;
	              } else {
	                peg$currPos = s2;
	                s2 = peg$c2;
	              }
	            } else {
	              peg$currPos = s2;
	              s2 = peg$c2;
	            }
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c3(s1);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = peg$parsews();
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parsemessageTextElement() {
	      var s0, s1;
	
	      s0 = peg$currPos;
	      s1 = peg$parsemessageText();
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c4(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parseargument() {
	      var s0, s1, s2;
	
	      s0 = peg$parsenumber();
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        s1 = [];
	        if (peg$c5.test(input.charAt(peg$currPos))) {
	          s2 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s2 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c6); }
	        }
	        if (s2 !== peg$FAILED) {
	          while (s2 !== peg$FAILED) {
	            s1.push(s2);
	            if (peg$c5.test(input.charAt(peg$currPos))) {
	              s2 = input.charAt(peg$currPos);
	              peg$currPos++;
	            } else {
	              s2 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c6); }
	            }
	          }
	        } else {
	          s1 = peg$c2;
	        }
	        if (s1 !== peg$FAILED) {
	          s1 = input.substring(s0, peg$currPos);
	        }
	        s0 = s1;
	      }
	
	      return s0;
	    }
	
	    function peg$parseargumentElement() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 123) {
	        s1 = peg$c7;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c8); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parseargument();
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$currPos;
	              if (input.charCodeAt(peg$currPos) === 44) {
	                s6 = peg$c10;
	                peg$currPos++;
	              } else {
	                s6 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c11); }
	              }
	              if (s6 !== peg$FAILED) {
	                s7 = peg$parse_();
	                if (s7 !== peg$FAILED) {
	                  s8 = peg$parseelementFormat();
	                  if (s8 !== peg$FAILED) {
	                    s6 = [s6, s7, s8];
	                    s5 = s6;
	                  } else {
	                    peg$currPos = s5;
	                    s5 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s5;
	                  s5 = peg$c2;
	                }
	              } else {
	                peg$currPos = s5;
	                s5 = peg$c2;
	              }
	              if (s5 === peg$FAILED) {
	                s5 = peg$c9;
	              }
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parse_();
	                if (s6 !== peg$FAILED) {
	                  if (input.charCodeAt(peg$currPos) === 125) {
	                    s7 = peg$c12;
	                    peg$currPos++;
	                  } else {
	                    s7 = peg$FAILED;
	                    if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                  }
	                  if (s7 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c14(s3, s5);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseelementFormat() {
	      var s0;
	
	      s0 = peg$parsesimpleFormat();
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsepluralFormat();
	        if (s0 === peg$FAILED) {
	          s0 = peg$parseselectOrdinalFormat();
	          if (s0 === peg$FAILED) {
	            s0 = peg$parseselectFormat();
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsesimpleFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c15) {
	        s1 = peg$c15;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c16); }
	      }
	      if (s1 === peg$FAILED) {
	        if (input.substr(peg$currPos, 4) === peg$c17) {
	          s1 = peg$c17;
	          peg$currPos += 4;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c18); }
	        }
	        if (s1 === peg$FAILED) {
	          if (input.substr(peg$currPos, 4) === peg$c19) {
	            s1 = peg$c19;
	            peg$currPos += 4;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c20); }
	          }
	        }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$currPos;
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s4 = peg$c10;
	            peg$currPos++;
	          } else {
	            s4 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s4 !== peg$FAILED) {
	            s5 = peg$parse_();
	            if (s5 !== peg$FAILED) {
	              s6 = peg$parsechars();
	              if (s6 !== peg$FAILED) {
	                s4 = [s4, s5, s6];
	                s3 = s4;
	              } else {
	                peg$currPos = s3;
	                s3 = peg$c2;
	              }
	            } else {
	              peg$currPos = s3;
	              s3 = peg$c2;
	            }
	          } else {
	            peg$currPos = s3;
	            s3 = peg$c2;
	          }
	          if (s3 === peg$FAILED) {
	            s3 = peg$c9;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c21(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c22) {
	        s1 = peg$c22;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c23); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c24(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectOrdinalFormat() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 13) === peg$c25) {
	        s1 = peg$c25;
	        peg$currPos += 13;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c26); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parsepluralStyle();
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c27(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselectFormat() {
	      var s0, s1, s2, s3, s4, s5, s6;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 6) === peg$c28) {
	        s1 = peg$c28;
	        peg$currPos += 6;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c29); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          if (input.charCodeAt(peg$currPos) === 44) {
	            s3 = peg$c10;
	            peg$currPos++;
	          } else {
	            s3 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c11); }
	          }
	          if (s3 !== peg$FAILED) {
	            s4 = peg$parse_();
	            if (s4 !== peg$FAILED) {
	              s5 = [];
	              s6 = peg$parseoptionalFormatPattern();
	              if (s6 !== peg$FAILED) {
	                while (s6 !== peg$FAILED) {
	                  s5.push(s6);
	                  s6 = peg$parseoptionalFormatPattern();
	                }
	              } else {
	                s5 = peg$c2;
	              }
	              if (s5 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c30(s5);
	                s0 = s1;
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseselector() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      s1 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 61) {
	        s2 = peg$c31;
	        peg$currPos++;
	      } else {
	        s2 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c32); }
	      }
	      if (s2 !== peg$FAILED) {
	        s3 = peg$parsenumber();
	        if (s3 !== peg$FAILED) {
	          s2 = [s2, s3];
	          s1 = s2;
	        } else {
	          peg$currPos = s1;
	          s1 = peg$c2;
	        }
	      } else {
	        peg$currPos = s1;
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      if (s0 === peg$FAILED) {
	        s0 = peg$parsechars();
	      }
	
	      return s0;
	    }
	
	    function peg$parseoptionalFormatPattern() {
	      var s0, s1, s2, s3, s4, s5, s6, s7, s8;
	
	      s0 = peg$currPos;
	      s1 = peg$parse_();
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parseselector();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parse_();
	          if (s3 !== peg$FAILED) {
	            if (input.charCodeAt(peg$currPos) === 123) {
	              s4 = peg$c7;
	              peg$currPos++;
	            } else {
	              s4 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c8); }
	            }
	            if (s4 !== peg$FAILED) {
	              s5 = peg$parse_();
	              if (s5 !== peg$FAILED) {
	                s6 = peg$parsemessageFormatPattern();
	                if (s6 !== peg$FAILED) {
	                  s7 = peg$parse_();
	                  if (s7 !== peg$FAILED) {
	                    if (input.charCodeAt(peg$currPos) === 125) {
	                      s8 = peg$c12;
	                      peg$currPos++;
	                    } else {
	                      s8 = peg$FAILED;
	                      if (peg$silentFails === 0) { peg$fail(peg$c13); }
	                    }
	                    if (s8 !== peg$FAILED) {
	                      peg$reportedPos = s0;
	                      s1 = peg$c33(s2, s6);
	                      s0 = s1;
	                    } else {
	                      peg$currPos = s0;
	                      s0 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              } else {
	                peg$currPos = s0;
	                s0 = peg$c2;
	              }
	            } else {
	              peg$currPos = s0;
	              s0 = peg$c2;
	            }
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parseoffset() {
	      var s0, s1, s2, s3;
	
	      s0 = peg$currPos;
	      if (input.substr(peg$currPos, 7) === peg$c34) {
	        s1 = peg$c34;
	        peg$currPos += 7;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c35); }
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = peg$parsenumber();
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c36(s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsepluralStyle() {
	      var s0, s1, s2, s3, s4;
	
	      s0 = peg$currPos;
	      s1 = peg$parseoffset();
	      if (s1 === peg$FAILED) {
	        s1 = peg$c9;
	      }
	      if (s1 !== peg$FAILED) {
	        s2 = peg$parse_();
	        if (s2 !== peg$FAILED) {
	          s3 = [];
	          s4 = peg$parseoptionalFormatPattern();
	          if (s4 !== peg$FAILED) {
	            while (s4 !== peg$FAILED) {
	              s3.push(s4);
	              s4 = peg$parseoptionalFormatPattern();
	            }
	          } else {
	            s3 = peg$c2;
	          }
	          if (s3 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c37(s1, s3);
	            s0 = s1;
	          } else {
	            peg$currPos = s0;
	            s0 = peg$c2;
	          }
	        } else {
	          peg$currPos = s0;
	          s0 = peg$c2;
	        }
	      } else {
	        peg$currPos = s0;
	        s0 = peg$c2;
	      }
	
	      return s0;
	    }
	
	    function peg$parsews() {
	      var s0, s1;
	
	      peg$silentFails++;
	      s0 = [];
	      if (peg$c39.test(input.charAt(peg$currPos))) {
	        s1 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c40); }
	      }
	      if (s1 !== peg$FAILED) {
	        while (s1 !== peg$FAILED) {
	          s0.push(s1);
	          if (peg$c39.test(input.charAt(peg$currPos))) {
	            s1 = input.charAt(peg$currPos);
	            peg$currPos++;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c40); }
	          }
	        }
	      } else {
	        s0 = peg$c2;
	      }
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c38); }
	      }
	
	      return s0;
	    }
	
	    function peg$parse_() {
	      var s0, s1, s2;
	
	      peg$silentFails++;
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsews();
	      while (s2 !== peg$FAILED) {
	        s1.push(s2);
	        s2 = peg$parsews();
	      }
	      if (s1 !== peg$FAILED) {
	        s1 = input.substring(s0, peg$currPos);
	      }
	      s0 = s1;
	      peg$silentFails--;
	      if (s0 === peg$FAILED) {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c41); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsedigit() {
	      var s0;
	
	      if (peg$c42.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c43); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsehexDigit() {
	      var s0;
	
	      if (peg$c44.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c45); }
	      }
	
	      return s0;
	    }
	
	    function peg$parsenumber() {
	      var s0, s1, s2, s3, s4, s5;
	
	      s0 = peg$currPos;
	      if (input.charCodeAt(peg$currPos) === 48) {
	        s1 = peg$c46;
	        peg$currPos++;
	      } else {
	        s1 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c47); }
	      }
	      if (s1 === peg$FAILED) {
	        s1 = peg$currPos;
	        s2 = peg$currPos;
	        if (peg$c48.test(input.charAt(peg$currPos))) {
	          s3 = input.charAt(peg$currPos);
	          peg$currPos++;
	        } else {
	          s3 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c49); }
	        }
	        if (s3 !== peg$FAILED) {
	          s4 = [];
	          s5 = peg$parsedigit();
	          while (s5 !== peg$FAILED) {
	            s4.push(s5);
	            s5 = peg$parsedigit();
	          }
	          if (s4 !== peg$FAILED) {
	            s3 = [s3, s4];
	            s2 = s3;
	          } else {
	            peg$currPos = s2;
	            s2 = peg$c2;
	          }
	        } else {
	          peg$currPos = s2;
	          s2 = peg$c2;
	        }
	        if (s2 !== peg$FAILED) {
	          s2 = input.substring(s1, peg$currPos);
	        }
	        s1 = s2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c50(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    function peg$parsechar() {
	      var s0, s1, s2, s3, s4, s5, s6, s7;
	
	      if (peg$c51.test(input.charAt(peg$currPos))) {
	        s0 = input.charAt(peg$currPos);
	        peg$currPos++;
	      } else {
	        s0 = peg$FAILED;
	        if (peg$silentFails === 0) { peg$fail(peg$c52); }
	      }
	      if (s0 === peg$FAILED) {
	        s0 = peg$currPos;
	        if (input.substr(peg$currPos, 2) === peg$c53) {
	          s1 = peg$c53;
	          peg$currPos += 2;
	        } else {
	          s1 = peg$FAILED;
	          if (peg$silentFails === 0) { peg$fail(peg$c54); }
	        }
	        if (s1 !== peg$FAILED) {
	          peg$reportedPos = s0;
	          s1 = peg$c55();
	        }
	        s0 = s1;
	        if (s0 === peg$FAILED) {
	          s0 = peg$currPos;
	          if (input.substr(peg$currPos, 2) === peg$c56) {
	            s1 = peg$c56;
	            peg$currPos += 2;
	          } else {
	            s1 = peg$FAILED;
	            if (peg$silentFails === 0) { peg$fail(peg$c57); }
	          }
	          if (s1 !== peg$FAILED) {
	            peg$reportedPos = s0;
	            s1 = peg$c58();
	          }
	          s0 = s1;
	          if (s0 === peg$FAILED) {
	            s0 = peg$currPos;
	            if (input.substr(peg$currPos, 2) === peg$c59) {
	              s1 = peg$c59;
	              peg$currPos += 2;
	            } else {
	              s1 = peg$FAILED;
	              if (peg$silentFails === 0) { peg$fail(peg$c60); }
	            }
	            if (s1 !== peg$FAILED) {
	              peg$reportedPos = s0;
	              s1 = peg$c61();
	            }
	            s0 = s1;
	            if (s0 === peg$FAILED) {
	              s0 = peg$currPos;
	              if (input.substr(peg$currPos, 2) === peg$c62) {
	                s1 = peg$c62;
	                peg$currPos += 2;
	              } else {
	                s1 = peg$FAILED;
	                if (peg$silentFails === 0) { peg$fail(peg$c63); }
	              }
	              if (s1 !== peg$FAILED) {
	                peg$reportedPos = s0;
	                s1 = peg$c64();
	              }
	              s0 = s1;
	              if (s0 === peg$FAILED) {
	                s0 = peg$currPos;
	                if (input.substr(peg$currPos, 2) === peg$c65) {
	                  s1 = peg$c65;
	                  peg$currPos += 2;
	                } else {
	                  s1 = peg$FAILED;
	                  if (peg$silentFails === 0) { peg$fail(peg$c66); }
	                }
	                if (s1 !== peg$FAILED) {
	                  s2 = peg$currPos;
	                  s3 = peg$currPos;
	                  s4 = peg$parsehexDigit();
	                  if (s4 !== peg$FAILED) {
	                    s5 = peg$parsehexDigit();
	                    if (s5 !== peg$FAILED) {
	                      s6 = peg$parsehexDigit();
	                      if (s6 !== peg$FAILED) {
	                        s7 = peg$parsehexDigit();
	                        if (s7 !== peg$FAILED) {
	                          s4 = [s4, s5, s6, s7];
	                          s3 = s4;
	                        } else {
	                          peg$currPos = s3;
	                          s3 = peg$c2;
	                        }
	                      } else {
	                        peg$currPos = s3;
	                        s3 = peg$c2;
	                      }
	                    } else {
	                      peg$currPos = s3;
	                      s3 = peg$c2;
	                    }
	                  } else {
	                    peg$currPos = s3;
	                    s3 = peg$c2;
	                  }
	                  if (s3 !== peg$FAILED) {
	                    s3 = input.substring(s2, peg$currPos);
	                  }
	                  s2 = s3;
	                  if (s2 !== peg$FAILED) {
	                    peg$reportedPos = s0;
	                    s1 = peg$c67(s2);
	                    s0 = s1;
	                  } else {
	                    peg$currPos = s0;
	                    s0 = peg$c2;
	                  }
	                } else {
	                  peg$currPos = s0;
	                  s0 = peg$c2;
	                }
	              }
	            }
	          }
	        }
	      }
	
	      return s0;
	    }
	
	    function peg$parsechars() {
	      var s0, s1, s2;
	
	      s0 = peg$currPos;
	      s1 = [];
	      s2 = peg$parsechar();
	      if (s2 !== peg$FAILED) {
	        while (s2 !== peg$FAILED) {
	          s1.push(s2);
	          s2 = peg$parsechar();
	        }
	      } else {
	        s1 = peg$c2;
	      }
	      if (s1 !== peg$FAILED) {
	        peg$reportedPos = s0;
	        s1 = peg$c68(s1);
	      }
	      s0 = s1;
	
	      return s0;
	    }
	
	    peg$result = peg$startRuleFunction();
	
	    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
	      return peg$result;
	    } else {
	      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
	        peg$fail({ type: "end", description: "end of input" });
	      }
	
	      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos);
	    }
	  }
	
	  return {
	    SyntaxError: SyntaxError,
	    parse:       parse
	  };
	})();
	
	//# sourceMappingURL=parser.js.map

/***/ }),
/* 734 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	exports["default"] = Compiler;
	
	function Compiler(locales, formats, pluralFn) {
	    this.locales  = locales;
	    this.formats  = formats;
	    this.pluralFn = pluralFn;
	}
	
	Compiler.prototype.compile = function (ast) {
	    this.pluralStack        = [];
	    this.currentPlural      = null;
	    this.pluralNumberFormat = null;
	
	    return this.compileMessage(ast);
	};
	
	Compiler.prototype.compileMessage = function (ast) {
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new Error('Message AST is not of type: "messageFormatPattern"');
	    }
	
	    var elements = ast.elements,
	        pattern  = [];
	
	    var i, len, element;
	
	    for (i = 0, len = elements.length; i < len; i += 1) {
	        element = elements[i];
	
	        switch (element.type) {
	            case 'messageTextElement':
	                pattern.push(this.compileMessageText(element));
	                break;
	
	            case 'argumentElement':
	                pattern.push(this.compileArgument(element));
	                break;
	
	            default:
	                throw new Error('Message element does not have a valid type');
	        }
	    }
	
	    return pattern;
	};
	
	Compiler.prototype.compileMessageText = function (element) {
	    // When this `element` is part of plural sub-pattern and its value contains
	    // an unescaped '#', use a `PluralOffsetString` helper to properly output
	    // the number with the correct offset in the string.
	    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
	        // Create a cache a NumberFormat instance that can be reused for any
	        // PluralOffsetString instance in this message.
	        if (!this.pluralNumberFormat) {
	            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
	        }
	
	        return new PluralOffsetString(
	                this.currentPlural.id,
	                this.currentPlural.format.offset,
	                this.pluralNumberFormat,
	                element.value);
	    }
	
	    // Unescape the escaped '#'s in the message text.
	    return element.value.replace(/\\#/g, '#');
	};
	
	Compiler.prototype.compileArgument = function (element) {
	    var format = element.format;
	
	    if (!format) {
	        return new StringFormat(element.id);
	    }
	
	    var formats  = this.formats,
	        locales  = this.locales,
	        pluralFn = this.pluralFn,
	        options;
	
	    switch (format.type) {
	        case 'numberFormat':
	            options = formats.number[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.NumberFormat(locales, options).format
	            };
	
	        case 'dateFormat':
	            options = formats.date[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'timeFormat':
	            options = formats.time[format.style];
	            return {
	                id    : element.id,
	                format: new Intl.DateTimeFormat(locales, options).format
	            };
	
	        case 'pluralFormat':
	            options = this.compileOptions(element);
	            return new PluralFormat(
	                element.id, format.ordinal, format.offset, options, pluralFn
	            );
	
	        case 'selectFormat':
	            options = this.compileOptions(element);
	            return new SelectFormat(element.id, options);
	
	        default:
	            throw new Error('Message element does not have a valid format type');
	    }
	};
	
	Compiler.prototype.compileOptions = function (element) {
	    var format      = element.format,
	        options     = format.options,
	        optionsHash = {};
	
	    // Save the current plural element, if any, then set it to a new value when
	    // compiling the options sub-patterns. This conforms the spec's algorithm
	    // for handling `"#"` syntax in message text.
	    this.pluralStack.push(this.currentPlural);
	    this.currentPlural = format.type === 'pluralFormat' ? element : null;
	
	    var i, len, option;
	
	    for (i = 0, len = options.length; i < len; i += 1) {
	        option = options[i];
	
	        // Compile the sub-pattern and save it under the options's selector.
	        optionsHash[option.selector] = this.compileMessage(option.value);
	    }
	
	    // Pop the plural stack to put back the original current plural value.
	    this.currentPlural = this.pluralStack.pop();
	
	    return optionsHash;
	};
	
	// -- Compiler Helper Classes --------------------------------------------------
	
	function StringFormat(id) {
	    this.id = id;
	}
	
	StringFormat.prototype.format = function (value) {
	    if (!value) {
	        return '';
	    }
	
	    return typeof value === 'string' ? value : String(value);
	};
	
	function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
	    this.id         = id;
	    this.useOrdinal = useOrdinal;
	    this.offset     = offset;
	    this.options    = options;
	    this.pluralFn   = pluralFn;
	}
	
	PluralFormat.prototype.getOption = function (value) {
	    var options = this.options;
	
	    var option = options['=' + value] ||
	            options[this.pluralFn(value - this.offset, this.useOrdinal)];
	
	    return option || options.other;
	};
	
	function PluralOffsetString(id, offset, numberFormat, string) {
	    this.id           = id;
	    this.offset       = offset;
	    this.numberFormat = numberFormat;
	    this.string       = string;
	}
	
	PluralOffsetString.prototype.format = function (value) {
	    var number = this.numberFormat.format(value - this.offset);
	
	    return this.string
	            .replace(/(^|[^\\])#/g, '$1' + number)
	            .replace(/\\#/g, '#');
	};
	
	function SelectFormat(id, options) {
	    this.id      = id;
	    this.options = options;
	}
	
	SelectFormat.prototype.getOption = function (value) {
	    var options = this.options;
	    return options[value] || options.other;
	};
	
	//# sourceMappingURL=compiler.js.map

/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(338), src$es5$$ = __webpack_require__(737), src$compiler$$ = __webpack_require__(734), intl$messageformat$parser$$ = __webpack_require__(732);
	exports["default"] = MessageFormat;
	
	// -- MessageFormat --------------------------------------------------------
	
	function MessageFormat(message, locales, formats) {
	    // Parse string messages into an AST.
	    var ast = typeof message === 'string' ?
	            MessageFormat.__parse(message) : message;
	
	    if (!(ast && ast.type === 'messageFormatPattern')) {
	        throw new TypeError('A message must be provided as a String or AST.');
	    }
	
	    // Creates a new object with the specified `formats` merged with the default
	    // formats.
	    formats = this._mergeFormats(MessageFormat.formats, formats);
	
	    // Defined first because it's used to build the format pattern.
	    src$es5$$.defineProperty(this, '_locale',  {value: this._resolveLocale(locales)});
	
	    // Compile the `ast` to a pattern that is highly optimized for repeated
	    // `format()` invocations. **Note:** This passes the `locales` set provided
	    // to the constructor instead of just the resolved locale.
	    var pluralFn = this._findPluralRuleFunction(this._locale);
	    var pattern  = this._compilePattern(ast, locales, formats, pluralFn);
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var messageFormat = this;
	    this.format = function (values) {
	        return messageFormat._format(pattern, values);
	    };
	}
	
	// Default format options used as the prototype of the `formats` provided to the
	// constructor. These are used when constructing the internal Intl.NumberFormat
	// and Intl.DateTimeFormat instances.
	src$es5$$.defineProperty(MessageFormat, 'formats', {
	    enumerable: true,
	
	    value: {
	        number: {
	            'currency': {
	                style: 'currency'
	            },
	
	            'percent': {
	                style: 'percent'
	            }
	        },
	
	        date: {
	            'short': {
	                month: 'numeric',
	                day  : 'numeric',
	                year : '2-digit'
	            },
	
	            'medium': {
	                month: 'short',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'long': {
	                month: 'long',
	                day  : 'numeric',
	                year : 'numeric'
	            },
	
	            'full': {
	                weekday: 'long',
	                month  : 'long',
	                day    : 'numeric',
	                year   : 'numeric'
	            }
	        },
	
	        time: {
	            'short': {
	                hour  : 'numeric',
	                minute: 'numeric'
	            },
	
	            'medium':  {
	                hour  : 'numeric',
	                minute: 'numeric',
	                second: 'numeric'
	            },
	
	            'long': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            },
	
	            'full': {
	                hour        : 'numeric',
	                minute      : 'numeric',
	                second      : 'numeric',
	                timeZoneName: 'short'
	            }
	        }
	    }
	});
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(MessageFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(MessageFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlMessageFormat is missing a ' +
	            '`locale` property'
	        );
	    }
	
	    MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
	}});
	
	// Defines `__parse()` static method as an exposed private.
	src$es5$$.defineProperty(MessageFormat, '__parse', {value: intl$messageformat$parser$$["default"].parse});
	
	// Define public `defaultLocale` property which defaults to English, but can be
	// set by the developer.
	src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	MessageFormat.prototype.resolvedOptions = function () {
	    // TODO: Provide anything else?
	    return {
	        locale: this._locale
	    };
	};
	
	MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
	    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
	    return compiler.compile(ast);
	};
	
	MessageFormat.prototype._findPluralRuleFunction = function (locale) {
	    var localeData = MessageFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find a `pluralRuleFunction` to return.
	    while (data) {
	        if (data.pluralRuleFunction) {
	            return data.pluralRuleFunction;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlMessageFormat is missing a ' +
	        '`pluralRuleFunction` for :' + locale
	    );
	};
	
	MessageFormat.prototype._format = function (pattern, values) {
	    var result = '',
	        i, len, part, id, value;
	
	    for (i = 0, len = pattern.length; i < len; i += 1) {
	        part = pattern[i];
	
	        // Exist early for string parts.
	        if (typeof part === 'string') {
	            result += part;
	            continue;
	        }
	
	        id = part.id;
	
	        // Enforce that all required values are provided by the caller.
	        if (!(values && src$utils$$.hop.call(values, id))) {
	            throw new Error('A value must be provided for: ' + id);
	        }
	
	        value = values[id];
	
	        // Recursively format plural and select parts' option — which can be a
	        // nested pattern structure. The choosing of the option to use is
	        // abstracted-by and delegated-to the part helper object.
	        if (part.options) {
	            result += this._format(part.getOption(value), values);
	        } else {
	            result += part.format(value);
	        }
	    }
	
	    return result;
	};
	
	MessageFormat.prototype._mergeFormats = function (defaults, formats) {
	    var mergedFormats = {},
	        type, mergedType;
	
	    for (type in defaults) {
	        if (!src$utils$$.hop.call(defaults, type)) { continue; }
	
	        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);
	
	        if (formats && src$utils$$.hop.call(formats, type)) {
	            src$utils$$.extend(mergedType, formats[type]);
	        }
	    }
	
	    return mergedFormats;
	};
	
	MessageFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(MessageFormat.defaultLocale);
	
	    var localeData = MessageFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlMessageFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	//# sourceMappingURL=core.js.map

/***/ }),
/* 736 */
/***/ (function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"}};
	
	//# sourceMappingURL=en.js.map

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var src$utils$$ = __webpack_require__(338);
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (src$utils$$.hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate;
	
	//# sourceMappingURL=es5.js.map

/***/ }),
/* 738 */
[1040, 735, 736],
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint node:true */
	
	'use strict';
	
	var IntlRelativeFormat = __webpack_require__(744)['default'];
	
	// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
	// bundling for the browser with Browserify/Webpack.
	__webpack_require__(1038);
	
	// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
	// locale data registered, and with English set as the default locale. Define
	// the `default` prop for use with other compiled ES6 Modules.
	exports = module.exports = IntlRelativeFormat;
	exports['default'] = exports;


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	var intl$messageformat$$ = __webpack_require__(337), src$diff$$ = __webpack_require__(741), src$es5$$ = __webpack_require__(743);
	exports["default"] = RelativeFormat;
	
	// -----------------------------------------------------------------------------
	
	var FIELDS = ['second', 'minute', 'hour', 'day', 'month', 'year'];
	var STYLES = ['best fit', 'numeric'];
	
	// -- RelativeFormat -----------------------------------------------------------
	
	function RelativeFormat(locales, options) {
	    options = options || {};
	
	    // Make a copy of `locales` if it's an array, so that it doesn't change
	    // since it's used lazily.
	    if (src$es5$$.isArray(locales)) {
	        locales = locales.concat();
	    }
	
	    src$es5$$.defineProperty(this, '_locale', {value: this._resolveLocale(locales)});
	    src$es5$$.defineProperty(this, '_options', {value: {
	        style: this._resolveStyle(options.style),
	        units: this._isValidUnits(options.units) && options.units
	    }});
	
	    src$es5$$.defineProperty(this, '_locales', {value: locales});
	    src$es5$$.defineProperty(this, '_fields', {value: this._findFields(this._locale)});
	    src$es5$$.defineProperty(this, '_messages', {value: src$es5$$.objCreate(null)});
	
	    // "Bind" `format()` method to `this` so it can be passed by reference like
	    // the other `Intl` APIs.
	    var relativeFormat = this;
	    this.format = function format(date, options) {
	        return relativeFormat._format(date, options);
	    };
	}
	
	// Define internal private properties for dealing with locale data.
	src$es5$$.defineProperty(RelativeFormat, '__localeData__', {value: src$es5$$.objCreate(null)});
	src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', {value: function (data) {
	    if (!(data && data.locale)) {
	        throw new Error(
	            'Locale data provided to IntlRelativeFormat is missing a ' +
	            '`locale` property value'
	        );
	    }
	
	    RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;
	
	    // Add data to IntlMessageFormat.
	    intl$messageformat$$["default"].__addLocaleData(data);
	}});
	
	// Define public `defaultLocale` property which can be set by the developer, or
	// it will be set when the first RelativeFormat instance is created by
	// leveraging the resolved locale from `Intl`.
	src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
	    enumerable: true,
	    writable  : true,
	    value     : undefined
	});
	
	// Define public `thresholds` property which can be set by the developer, and
	// defaults to relative time thresholds from moment.js.
	src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
	    enumerable: true,
	
	    value: {
	        second: 45,  // seconds to minute
	        minute: 45,  // minutes to hour
	        hour  : 22,  // hours to day
	        day   : 26,  // days to month
	        month : 11   // months to year
	    }
	});
	
	RelativeFormat.prototype.resolvedOptions = function () {
	    return {
	        locale: this._locale,
	        style : this._options.style,
	        units : this._options.units
	    };
	};
	
	RelativeFormat.prototype._compileMessage = function (units) {
	    // `this._locales` is the original set of locales the user specified to the
	    // constructor, while `this._locale` is the resolved root locale.
	    var locales        = this._locales;
	    var resolvedLocale = this._locale;
	
	    var field        = this._fields[units];
	    var relativeTime = field.relativeTime;
	    var future       = '';
	    var past         = '';
	    var i;
	
	    for (i in relativeTime.future) {
	        if (relativeTime.future.hasOwnProperty(i)) {
	            future += ' ' + i + ' {' +
	                relativeTime.future[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    for (i in relativeTime.past) {
	        if (relativeTime.past.hasOwnProperty(i)) {
	            past += ' ' + i + ' {' +
	                relativeTime.past[i].replace('{0}', '#') + '}';
	        }
	    }
	
	    var message = '{when, select, future {{0, plural, ' + future + '}}' +
	                                 'past {{0, plural, ' + past + '}}}';
	
	    // Create the synthetic IntlMessageFormat instance using the original
	    // locales value specified by the user when constructing the the parent
	    // IntlRelativeFormat instance.
	    return new intl$messageformat$$["default"](message, locales);
	};
	
	RelativeFormat.prototype._getMessage = function (units) {
	    var messages = this._messages;
	
	    // Create a new synthetic message based on the locale data from CLDR.
	    if (!messages[units]) {
	        messages[units] = this._compileMessage(units);
	    }
	
	    return messages[units];
	};
	
	RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
	    var field = this._fields[units];
	
	    if (field.relative) {
	        return field.relative[diff];
	    }
	};
	
	RelativeFormat.prototype._findFields = function (locale) {
	    var localeData = RelativeFormat.__localeData__;
	    var data       = localeData[locale.toLowerCase()];
	
	    // The locale data is de-duplicated, so we have to traverse the locale's
	    // hierarchy until we find `fields` to return.
	    while (data) {
	        if (data.fields) {
	            return data.fields;
	        }
	
	        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
	    }
	
	    throw new Error(
	        'Locale data added to IntlRelativeFormat is missing `fields` for :' +
	        locale
	    );
	};
	
	RelativeFormat.prototype._format = function (date, options) {
	    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();
	
	    if (date === undefined) {
	        date = now;
	    }
	
	    // Determine if the `date` and optional `now` values are valid, and throw a
	    // similar error to what `Intl.DateTimeFormat#format()` would throw.
	    if (!isFinite(now)) {
	        throw new RangeError(
	            'The `now` option provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    if (!isFinite(date)) {
	        throw new RangeError(
	            'The date value provided to IntlRelativeFormat#format() is not ' +
	            'in valid range.'
	        );
	    }
	
	    var diffReport  = src$diff$$["default"](now, date);
	    var units       = this._options.units || this._selectUnits(diffReport);
	    var diffInUnits = diffReport[units];
	
	    if (this._options.style !== 'numeric') {
	        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
	        if (relativeUnits) {
	            return relativeUnits;
	        }
	    }
	
	    return this._getMessage(units).format({
	        '0' : Math.abs(diffInUnits),
	        when: diffInUnits < 0 ? 'past' : 'future'
	    });
	};
	
	RelativeFormat.prototype._isValidUnits = function (units) {
	    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
	        return true;
	    }
	
	    if (typeof units === 'string') {
	        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
	        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
	            throw new Error(
	                '"' + units + '" is not a valid IntlRelativeFormat `units` ' +
	                'value, did you mean: ' + suggestion
	            );
	        }
	    }
	
	    throw new Error(
	        '"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' +
	        'must be one of: "' + FIELDS.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._resolveLocale = function (locales) {
	    if (typeof locales === 'string') {
	        locales = [locales];
	    }
	
	    // Create a copy of the array so we can push on the default locale.
	    locales = (locales || []).concat(RelativeFormat.defaultLocale);
	
	    var localeData = RelativeFormat.__localeData__;
	    var i, len, localeParts, data;
	
	    // Using the set of locales + the default locale, we look for the first one
	    // which that has been registered. When data does not exist for a locale, we
	    // traverse its ancestors to find something that's been registered within
	    // its hierarchy of locales. Since we lack the proper `parentLocale` data
	    // here, we must take a naive approach to traversal.
	    for (i = 0, len = locales.length; i < len; i += 1) {
	        localeParts = locales[i].toLowerCase().split('-');
	
	        while (localeParts.length) {
	            data = localeData[localeParts.join('-')];
	            if (data) {
	                // Return the normalized locale string; e.g., we return "en-US",
	                // instead of "en-us".
	                return data.locale;
	            }
	
	            localeParts.pop();
	        }
	    }
	
	    var defaultLocale = locales.pop();
	    throw new Error(
	        'No locale data has been added to IntlRelativeFormat for: ' +
	        locales.join(', ') + ', or the default locale: ' + defaultLocale
	    );
	};
	
	RelativeFormat.prototype._resolveStyle = function (style) {
	    // Default to "best fit" style.
	    if (!style) {
	        return STYLES[0];
	    }
	
	    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
	        return style;
	    }
	
	    throw new Error(
	        '"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' +
	        'must be one of: "' + STYLES.join('", "') + '"'
	    );
	};
	
	RelativeFormat.prototype._selectUnits = function (diffReport) {
	    var i, l, units;
	
	    for (i = 0, l = FIELDS.length; i < l; i += 1) {
	        units = FIELDS[i];
	
	        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
	            break;
	        }
	    }
	
	    return units;
	};
	
	//# sourceMappingURL=core.js.map

/***/ }),
/* 741 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	var round = Math.round;
	
	function daysToYears(days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    return days * 400 / 146097;
	}
	
	exports["default"] = function (from, to) {
	    // Convert to ms timestamps.
	    from = +from;
	    to   = +to;
	
	    var millisecond = round(to - from),
	        second      = round(millisecond / 1000),
	        minute      = round(second / 60),
	        hour        = round(minute / 60),
	        day         = round(hour / 24),
	        week        = round(day / 7);
	
	    var rawYears = daysToYears(day),
	        month    = round(rawYears * 12),
	        year     = round(rawYears);
	
	    return {
	        millisecond: millisecond,
	        second     : second,
	        minute     : minute,
	        hour       : hour,
	        day        : day,
	        week       : week,
	        month      : month,
	        year       : year
	    };
	};
	
	//# sourceMappingURL=diff.js.map

/***/ }),
/* 742 */
/***/ (function(module, exports) {

	// GENERATED FILE
	"use strict";
	exports["default"] = {"locale":"en","pluralRuleFunction":function (n,ord){var s=String(n).split("."),v0=!s[1],t0=Number(s[0])==n,n10=t0&&s[0].slice(-1),n100=t0&&s[0].slice(-2);if(ord)return n10==1&&n100!=11?"one":n10==2&&n100!=12?"two":n10==3&&n100!=13?"few":"other";return n==1&&v0?"one":"other"},"fields":{"year":{"displayName":"year","relative":{"0":"this year","1":"next year","-1":"last year"},"relativeTime":{"future":{"one":"in {0} year","other":"in {0} years"},"past":{"one":"{0} year ago","other":"{0} years ago"}}},"month":{"displayName":"month","relative":{"0":"this month","1":"next month","-1":"last month"},"relativeTime":{"future":{"one":"in {0} month","other":"in {0} months"},"past":{"one":"{0} month ago","other":"{0} months ago"}}},"day":{"displayName":"day","relative":{"0":"today","1":"tomorrow","-1":"yesterday"},"relativeTime":{"future":{"one":"in {0} day","other":"in {0} days"},"past":{"one":"{0} day ago","other":"{0} days ago"}}},"hour":{"displayName":"hour","relativeTime":{"future":{"one":"in {0} hour","other":"in {0} hours"},"past":{"one":"{0} hour ago","other":"{0} hours ago"}}},"minute":{"displayName":"minute","relativeTime":{"future":{"one":"in {0} minute","other":"in {0} minutes"},"past":{"one":"{0} minute ago","other":"{0} minutes ago"}}},"second":{"displayName":"second","relative":{"0":"now"},"relativeTime":{"future":{"one":"in {0} second","other":"in {0} seconds"},"past":{"one":"{0} second ago","other":"{0} seconds ago"}}}}};
	
	//# sourceMappingURL=en.js.map

/***/ }),
/* 743 */
/***/ (function(module, exports) {

	/*
	Copyright (c) 2014, Yahoo! Inc. All rights reserved.
	Copyrights licensed under the New BSD License.
	See the accompanying LICENSE file for terms.
	*/
	
	/* jslint esnext: true */
	
	"use strict";
	
	// Purposely using the same implementation as the Intl.js `Intl` polyfill.
	// Copyright 2013 Andy Earnshaw, MIT License
	
	var hop = Object.prototype.hasOwnProperty;
	var toString = Object.prototype.toString;
	
	var realDefineProp = (function () {
	    try { return !!Object.defineProperty({}, 'a', {}); }
	    catch (e) { return false; }
	})();
	
	var es3 = !realDefineProp && !Object.prototype.__defineGetter__;
	
	var defineProperty = realDefineProp ? Object.defineProperty :
	        function (obj, name, desc) {
	
	    if ('get' in desc && obj.__defineGetter__) {
	        obj.__defineGetter__(name, desc.get);
	    } else if (!hop.call(obj, name) || 'value' in desc) {
	        obj[name] = desc.value;
	    }
	};
	
	var objCreate = Object.create || function (proto, props) {
	    var obj, k;
	
	    function F() {}
	    F.prototype = proto;
	    obj = new F();
	
	    for (k in props) {
	        if (hop.call(props, k)) {
	            defineProperty(obj, k, props[k]);
	        }
	    }
	
	    return obj;
	};
	
	var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
	    /*jshint validthis:true */
	    var arr = this;
	    if (!arr.length) {
	        return -1;
	    }
	
	    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
	        if (arr[i] === search) {
	            return i;
	        }
	    }
	
	    return -1;
	};
	
	var isArray = Array.isArray || function (obj) {
	    return toString.call(obj) === '[object Array]';
	};
	
	var dateNow = Date.now || function () {
	    return new Date().getTime();
	};
	exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;
	
	//# sourceMappingURL=es5.js.map

/***/ }),
/* 744 */
[1040, 740, 742],
/* 745 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.seal(Object.defineProperties(exports, {
	    createDateTimeFormat: {
	        get: function() {
	            return createDateTimeFormat;
	        },
	
	        enumerable: true
	    },
	
	    createDateTimeFormats: {
	        get: function() {
	            return createDateTimeFormats;
	        },
	
	        enumerable: true
	    }
	}));
	
	var expDTComponents = /(?:[Eec]{1,6}|G{1,5}|(?:[yYu]+|U{1,5})|[ML]{1,5}|d{1,2}|a|[hkHK]{1,2}|m{1,2}|s{1,2}|z{1,4})(?=([^']*'[^']*')*[^']*$)/g;
	
	// Skip over patterns with these datetime components
	var unwantedDTCs = /[QxXVOvZASjgFDwWIQqH]/;
	
	// Maps the number of characters in a CLDR pattern to the specification
	var dtcLengthMap = {
	        month:   [ 'numeric', '2-digit', 'short', 'long', 'narrow' ],
	        weekday: [ 'short', 'short', 'short', 'long', 'narrow' ],
	        era:     [ 'short', 'short', 'short', 'long', 'narrow' ]
	    };
	
	var dtKeys = ["weekday", "era", "year", "month", "day"];
	var tmKeys = ["hour", "minute", "second", "timeZoneName"];
	
	function isDateFormatOnly(obj) {
	    for (var i = 0; i < tmKeys.length; i += 1) {
	        if (obj.hasOwnProperty(tmKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function isTimeFormatOnly(obj) {
	    for (var i = 0; i < dtKeys.length; i += 1) {
	        if (obj.hasOwnProperty(dtKeys[i])) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function createDateTimeFormat(format) {
	    if (unwantedDTCs.test(format))
	        return undefined;
	
	    var formatObj = {};
	
	    // Replace the pattern string with the one required by the specification, whilst
	    // at the same time evaluating it for the subsets and formats
	    formatObj.pattern = format.replace(expDTComponents, function ($0) {
	        // See which symbol we're dealing with
	        switch ($0.charAt(0)) {
	            case 'E':
	            case 'e':
	            case 'c':
	                formatObj.weekday = dtcLengthMap.weekday[$0.length-1];
	                return '{weekday}';
	
	            // Not supported yet
	            case 'G':
	                formatObj.era = dtcLengthMap.era[$0.length-1];
	                return '{era}';
	
	            case 'y':
	            case 'Y':
	            case 'u':
	            case 'U':
	                formatObj.year = $0.length === 2 ? '2-digit' : 'numeric';
	                return '{year}';
	
	            case 'M':
	            case 'L':
	                formatObj.month = dtcLengthMap.month[$0.length-1];
	                return '{month}';
	
	            case 'd':
	                formatObj.day = $0.length === 2 ? '2-digit' : 'numeric';
	                return '{day}';
	
	            case 'a':
	                return '{ampm}';
	
	            case 'h':
	            case 'H':
	            case 'k':
	            case 'K':
	                formatObj.hour = $0.length === 2 ? '2-digit' : 'numeric';
	                return '{hour}';
	
	            case 'm':
	                formatObj.minute = $0.length === 2 ? '2-digit' : 'numeric';
	                return '{minute}';
	
	            case 's':
	                formatObj.second = $0.length === 2 ? '2-digit' : 'numeric';
	                return '{second}';
	
	            case 'z':
	                formatObj.timeZoneName = $0.length < 4 ? 'short' : 'long';
	                return '{timeZoneName}';
	        }
	    });
	
	    // From http://www.unicode.org/reports/tr35/tr35-dates.html#Date_Format_Patterns:
	    //  'In patterns, two single quotes represents a literal single quote, either
	    //   inside or outside single quotes. Text within single quotes is not
	    //   interpreted in any way (except for two adjacent single quotes).'
	    formatObj.pattern = formatObj.pattern.replace(/'([^']*)'/g, function ($0, literal) {
	        return literal ? literal : "'";
	    });
	
	    if (formatObj.pattern.indexOf('{ampm}') > -1) {
	        formatObj.hour12 = true;
	        formatObj.pattern12 = formatObj.pattern;
	        formatObj.pattern = formatObj.pattern.replace('{ampm}', '').trim();
	    }
	
	    return formatObj;
	}
	
	function createDateTimeFormats(formats) {
	    var availableFormats = formats.availableFormats;
	    var timeFormats = formats.timeFormats;
	    var dateFormats = formats.dateFormats;
	    var order = formats.medium;
	    var result = [];
	    var key, format, computed, i, j;
	    var timeRelatedFormats = [];
	    var dateRelatedFormats = [];
	
	    function expandFormat(key, pattern) {
	        // Expand component lengths if necessary, as allowed in the LDML spec
	        // Get the lengths of 'M' and 'E' substrings in the date pattern
	        // as arrays that can be joined to create a new substring
	        var M = new Array((key.match(/M/g)||[]).length + 1);
	        var E = new Array((key.match(/E/g)||[]).length + 1);
	
	        // note from caridy: I'm not sure we really need this, seems to be
	        //                   useless since it relies on the keys from CLDR
	        //                   instead of the actual format pattern, but I'm not sure.
	        if (M.length > 2)
	            pattern = pattern.replace(/(M|L)+/, M.join('$1'));
	
	        if (E.length > 2)
	            pattern = pattern.replace(/([Eec])+/, E.join('$1'));
	
	        return pattern;
	    }
	
	    // Map available (custom) formats into a pattern for createDateTimeFormats
	    for (key in availableFormats) {
	        if (availableFormats.hasOwnProperty(key)) {
	            format = expandFormat(key, availableFormats[key]);
	            computed = createDateTimeFormat(format);
	            if (computed) {
	                result.push(computed);
	                // in some cases, the format is only displaying date specific props
	                // or time specific props, in which case we need to also produce the
	                // combined formats.
	                if (isDateFormatOnly(computed)) {
	                    dateRelatedFormats.push(format);
	                } else if (isTimeFormatOnly(computed)) {
	                    timeRelatedFormats.push(format);
	                }
	            }
	        }
	    }
	
	    // combine custom time and custom date formats when they are orthogonals to complete the
	    // formats supported by browsers by relying on the value of "formats.medium" which defines
	    // how to join custom formats into a single pattern.
	    for (i = 0; i < timeRelatedFormats.length; i += 1) {
	        for (j = 0; j < dateRelatedFormats.length; j += 1) {
	            format = order
	                .replace('{0}', timeRelatedFormats[i])
	                .replace('{1}', dateRelatedFormats[j])
	                .replace(/^[,\s]+|[,\s]+$/gi, '');
	            computed = createDateTimeFormat(format);
	            if (computed) {
	                result.push(computed);
	            }
	        }
	    }
	
	    // Map time formats into a pattern for createDateTimeFormats
	    for (key in timeFormats) {
	        if (timeFormats.hasOwnProperty(key)) {
	            format = expandFormat(key, timeFormats[key]);
	            computed = createDateTimeFormat(format);
	            if (computed) {
	                result.push(computed);
	            }
	        }
	    }
	
	    // Map date formats into a pattern for createDateTimeFormats
	    for (key in dateFormats) {
	        if (dateFormats.hasOwnProperty(key)) {
	            format = expandFormat(key, dateFormats[key]);
	            computed = createDateTimeFormat(format);
	            if (computed) {
	                result.push(computed);
	            }
	        }
	    }
	
	    return result;
	}
	
	//# sourceMappingURL=cldr.js.map

/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.seal(Object.defineProperties(exports, {
	    default: {
	        get: function() {
	            return src$core$$default;
	        },
	
	        enumerable: true
	    }
	}));
	
	var src$exp$$ = __webpack_require__(747), src$cldr$$ = __webpack_require__(745);
	
	var Intl = {},
	
	    realDefineProp = (function () {
	        var sentinel = {};
	        try {
	            Object.defineProperty(sentinel, 'a', {});
	            return 'a' in sentinel;
	        } catch (e) {
	            return false;
	        }
	    })(),
	
	    // Need a workaround for getters in ES3
	    es3  = !realDefineProp && !Object.prototype.__defineGetter__,
	
	    // We use this a lot (and need it for proto-less objects)
	    hop = Object.prototype.hasOwnProperty,
	
	    // Naive defineProperty for compatibility
	    defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {
	        if ('get' in desc && obj.__defineGetter__)
	            obj.__defineGetter__(name, desc.get);
	
	        else if (!hop.call(obj, name) || 'value' in desc)
	            obj[name] = desc.value;
	    },
	
	    // Array.prototype.indexOf, as good as we need it to be
	    arrIndexOf = Array.prototype.indexOf || function (search) {
	        /*jshint validthis:true */
	        var t = this;
	        if (!t.length)
	            return -1;
	
	        for (var i = arguments[1] || 0, max = t.length; i < max; i++) {
	            if (t[i] === search)
	                return i;
	        }
	
	        return -1;
	    },
	
	    // Create an object with the specified prototype (2nd arg required for Record)
	    objCreate = Object.create || function (proto, props) {
	        var obj;
	
	        function F() {}
	        F.prototype = proto;
	        obj = new F();
	
	        for (var k in props) {
	            if (hop.call(props, k))
	                defineProperty(obj, k, props[k]);
	        }
	
	        return obj;
	    },
	
	    // Snapshot some (hopefully still) native built-ins
	    arrSlice  = Array.prototype.slice,
	    arrConcat = Array.prototype.concat,
	    arrPush   = Array.prototype.push,
	    arrJoin   = Array.prototype.join,
	    arrShift  = Array.prototype.shift,
	    arrUnshift= Array.prototype.unshift,
	
	    // Naive Function.prototype.bind for compatibility
	    fnBind = Function.prototype.bind || function (thisObj) {
	        var fn = this,
	            args = arrSlice.call(arguments, 1);
	
	        // All our (presently) bound functions have either 1 or 0 arguments. By returning
	        // different function signatures, we can pass some tests in ES3 environments
	        if (fn.length === 1) {
	            return function (a) {
	                return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	            };
	        }
	        else {
	            return function () {
	                return fn.apply(thisObj, arrConcat.call(args, arrSlice.call(arguments)));
	            };
	        }
	    },
	
	    // Default locale is the first-added locale data for us
	    defaultLocale,
	
	    // Object housing internal properties for constructors
	    internals = objCreate(null),
	
	    // Keep internal properties internal
	    secret = Math.random(),
	
	    // An object map of date component keys, saves using a regex later
	    dateWidths = objCreate(null, { narrow:{}, short:{}, long:{} }),
	
	    // Each constructor prototype should be an instance of the constructor itself, but we
	    // can't initialise them as such until some locale data has been added, so this is how
	    // we keep track
	    numberFormatProtoInitialised = false,
	    dateTimeFormatProtoInitialised = false,
	
	    // Some regular expressions we're using
	    expCurrencyCode = /^[A-Z]{3}$/,
	    expUnicodeExSeq = /-u(?:-[0-9a-z]{2,8})+/gi, // See `extension` below
	
	    // IANA Subtag Registry redundant tag and subtag maps
	    redundantTags = {
	        tags: {
	            "art-lojban":   "jbo",       "i-ami":        "ami",       "i-bnn":       "bnn",  "i-hak":      "hak",
	            "i-klingon":    "tlh",       "i-lux":        "lb",        "i-navajo":    "nv",   "i-pwn":      "pwn",
	            "i-tao":        "tao",       "i-tay":        "tay",       "i-tsu":       "tsu",  "no-bok":     "nb",
	            "no-nyn":       "nn",        "sgn-BE-FR":    "sfb",       "sgn-BE-NL":   "vgt",  "sgn-CH-DE":  "sgg",
	            "zh-guoyu":     "cmn",       "zh-hakka":     "hak",       "zh-min-nan":  "nan",  "zh-xiang":   "hsn",
	            "sgn-BR":       "bzs",       "sgn-CO":       "csn",       "sgn-DE":      "gsg",  "sgn-DK":     "dsl",
	            "sgn-ES":       "ssp",       "sgn-FR":       "fsl",       "sgn-GB":      "bfi",  "sgn-GR":     "gss",
	            "sgn-IE":       "isg",       "sgn-IT":       "ise",       "sgn-JP":      "jsl",  "sgn-MX":     "mfs",
	            "sgn-NI":       "ncs",       "sgn-NL":       "dse",       "sgn-NO":      "nsl",  "sgn-PT":     "psr",
	            "sgn-SE":       "swl",       "sgn-US":       "ase",       "sgn-ZA":      "sfs",  "zh-cmn":     "cmn",
	            "zh-cmn-Hans":  "cmn-Hans",  "zh-cmn-Hant":  "cmn-Hant",  "zh-gan":      "gan",  "zh-wuu":     "wuu",
	            "zh-yue":       "yue"
	        },
	        subtags: {
	              BU: "MM",   DD: "DE",   FX: "FR",   TP: "TL",   YD: "YE",   ZR: "CD",  heploc: "alalc97",
	            'in': "id",   iw: "he",   ji:  "yi",  jw: "jv",   mo: "ro",  ayx: "nun", bjd: "drl",
	             ccq: "rki", cjr: "mom", cka: "cmr", cmk: "xch", drh: "khk", drw: "prs", gav: "dev",
	             hrr: "jal", ibi: "opa", kgh: "kml", lcq: "ppr", mst: "mry", myt: "mry", sca: "hle",
	             tie: "ras", tkk: "twm", tlw: "weo", tnf: "prs", ybd: "rki", yma: "lrr"
	        },
	        extLang: {
	            aao: [ "aao", "ar"  ], abh: [ "abh", "ar"  ], abv: [ "abv", "ar"  ], acm: [ "acm", "ar"  ],
	            acq: [ "acq", "ar"  ], acw: [ "acw", "ar"  ], acx: [ "acx", "ar"  ], acy: [ "acy", "ar"  ],
	            adf: [ "adf", "ar"  ], ads: [ "ads", "sgn" ], aeb: [ "aeb", "ar"  ], aec: [ "aec", "ar"  ],
	            aed: [ "aed", "sgn" ], aen: [ "aen", "sgn" ], afb: [ "afb", "ar"  ], afg: [ "afg", "sgn" ],
	            ajp: [ "ajp", "ar"  ], apc: [ "apc", "ar"  ], apd: [ "apd", "ar"  ], arb: [ "arb", "ar"  ],
	            arq: [ "arq", "ar"  ], ars: [ "ars", "ar"  ], ary: [ "ary", "ar"  ], arz: [ "arz", "ar"  ],
	            ase: [ "ase", "sgn" ], asf: [ "asf", "sgn" ], asp: [ "asp", "sgn" ], asq: [ "asq", "sgn" ],
	            asw: [ "asw", "sgn" ], auz: [ "auz", "ar"  ], avl: [ "avl", "ar"  ], ayh: [ "ayh", "ar"  ],
	            ayl: [ "ayl", "ar"  ], ayn: [ "ayn", "ar"  ], ayp: [ "ayp", "ar"  ], bbz: [ "bbz", "ar"  ],
	            bfi: [ "bfi", "sgn" ], bfk: [ "bfk", "sgn" ], bjn: [ "bjn", "ms"  ], bog: [ "bog", "sgn" ],
	            bqn: [ "bqn", "sgn" ], bqy: [ "bqy", "sgn" ], btj: [ "btj", "ms"  ], bve: [ "bve", "ms"  ],
	            bvl: [ "bvl", "sgn" ], bvu: [ "bvu", "ms"  ], bzs: [ "bzs", "sgn" ], cdo: [ "cdo", "zh"  ],
	            cds: [ "cds", "sgn" ], cjy: [ "cjy", "zh"  ], cmn: [ "cmn", "zh"  ], coa: [ "coa", "ms"  ],
	            cpx: [ "cpx", "zh"  ], csc: [ "csc", "sgn" ], csd: [ "csd", "sgn" ], cse: [ "cse", "sgn" ],
	            csf: [ "csf", "sgn" ], csg: [ "csg", "sgn" ], csl: [ "csl", "sgn" ], csn: [ "csn", "sgn" ],
	            csq: [ "csq", "sgn" ], csr: [ "csr", "sgn" ], czh: [ "czh", "zh"  ], czo: [ "czo", "zh"  ],
	            doq: [ "doq", "sgn" ], dse: [ "dse", "sgn" ], dsl: [ "dsl", "sgn" ], dup: [ "dup", "ms"  ],
	            ecs: [ "ecs", "sgn" ], esl: [ "esl", "sgn" ], esn: [ "esn", "sgn" ], eso: [ "eso", "sgn" ],
	            eth: [ "eth", "sgn" ], fcs: [ "fcs", "sgn" ], fse: [ "fse", "sgn" ], fsl: [ "fsl", "sgn" ],
	            fss: [ "fss", "sgn" ], gan: [ "gan", "zh"  ], gds: [ "gds", "sgn" ], gom: [ "gom", "kok" ],
	            gse: [ "gse", "sgn" ], gsg: [ "gsg", "sgn" ], gsm: [ "gsm", "sgn" ], gss: [ "gss", "sgn" ],
	            gus: [ "gus", "sgn" ], hab: [ "hab", "sgn" ], haf: [ "haf", "sgn" ], hak: [ "hak", "zh"  ],
	            hds: [ "hds", "sgn" ], hji: [ "hji", "ms"  ], hks: [ "hks", "sgn" ], hos: [ "hos", "sgn" ],
	            hps: [ "hps", "sgn" ], hsh: [ "hsh", "sgn" ], hsl: [ "hsl", "sgn" ], hsn: [ "hsn", "zh"  ],
	            icl: [ "icl", "sgn" ], ils: [ "ils", "sgn" ], inl: [ "inl", "sgn" ], ins: [ "ins", "sgn" ],
	            ise: [ "ise", "sgn" ], isg: [ "isg", "sgn" ], isr: [ "isr", "sgn" ], jak: [ "jak", "ms"  ],
	            jax: [ "jax", "ms"  ], jcs: [ "jcs", "sgn" ], jhs: [ "jhs", "sgn" ], jls: [ "jls", "sgn" ],
	            jos: [ "jos", "sgn" ], jsl: [ "jsl", "sgn" ], jus: [ "jus", "sgn" ], kgi: [ "kgi", "sgn" ],
	            knn: [ "knn", "kok" ], kvb: [ "kvb", "ms"  ], kvk: [ "kvk", "sgn" ], kvr: [ "kvr", "ms"  ],
	            kxd: [ "kxd", "ms"  ], lbs: [ "lbs", "sgn" ], lce: [ "lce", "ms"  ], lcf: [ "lcf", "ms"  ],
	            liw: [ "liw", "ms"  ], lls: [ "lls", "sgn" ], lsg: [ "lsg", "sgn" ], lsl: [ "lsl", "sgn" ],
	            lso: [ "lso", "sgn" ], lsp: [ "lsp", "sgn" ], lst: [ "lst", "sgn" ], lsy: [ "lsy", "sgn" ],
	            ltg: [ "ltg", "lv"  ], lvs: [ "lvs", "lv"  ], lzh: [ "lzh", "zh"  ], max: [ "max", "ms"  ],
	            mdl: [ "mdl", "sgn" ], meo: [ "meo", "ms"  ], mfa: [ "mfa", "ms"  ], mfb: [ "mfb", "ms"  ],
	            mfs: [ "mfs", "sgn" ], min: [ "min", "ms"  ], mnp: [ "mnp", "zh"  ], mqg: [ "mqg", "ms"  ],
	            mre: [ "mre", "sgn" ], msd: [ "msd", "sgn" ], msi: [ "msi", "ms"  ], msr: [ "msr", "sgn" ],
	            mui: [ "mui", "ms"  ], mzc: [ "mzc", "sgn" ], mzg: [ "mzg", "sgn" ], mzy: [ "mzy", "sgn" ],
	            nan: [ "nan", "zh"  ], nbs: [ "nbs", "sgn" ], ncs: [ "ncs", "sgn" ], nsi: [ "nsi", "sgn" ],
	            nsl: [ "nsl", "sgn" ], nsp: [ "nsp", "sgn" ], nsr: [ "nsr", "sgn" ], nzs: [ "nzs", "sgn" ],
	            okl: [ "okl", "sgn" ], orn: [ "orn", "ms"  ], ors: [ "ors", "ms"  ], pel: [ "pel", "ms"  ],
	            pga: [ "pga", "ar"  ], pks: [ "pks", "sgn" ], prl: [ "prl", "sgn" ], prz: [ "prz", "sgn" ],
	            psc: [ "psc", "sgn" ], psd: [ "psd", "sgn" ], pse: [ "pse", "ms"  ], psg: [ "psg", "sgn" ],
	            psl: [ "psl", "sgn" ], pso: [ "pso", "sgn" ], psp: [ "psp", "sgn" ], psr: [ "psr", "sgn" ],
	            pys: [ "pys", "sgn" ], rms: [ "rms", "sgn" ], rsi: [ "rsi", "sgn" ], rsl: [ "rsl", "sgn" ],
	            sdl: [ "sdl", "sgn" ], sfb: [ "sfb", "sgn" ], sfs: [ "sfs", "sgn" ], sgg: [ "sgg", "sgn" ],
	            sgx: [ "sgx", "sgn" ], shu: [ "shu", "ar"  ], slf: [ "slf", "sgn" ], sls: [ "sls", "sgn" ],
	            sqk: [ "sqk", "sgn" ], sqs: [ "sqs", "sgn" ], ssh: [ "ssh", "ar"  ], ssp: [ "ssp", "sgn" ],
	            ssr: [ "ssr", "sgn" ], svk: [ "svk", "sgn" ], swc: [ "swc", "sw"  ], swh: [ "swh", "sw"  ],
	            swl: [ "swl", "sgn" ], syy: [ "syy", "sgn" ], tmw: [ "tmw", "ms"  ], tse: [ "tse", "sgn" ],
	            tsm: [ "tsm", "sgn" ], tsq: [ "tsq", "sgn" ], tss: [ "tss", "sgn" ], tsy: [ "tsy", "sgn" ],
	            tza: [ "tza", "sgn" ], ugn: [ "ugn", "sgn" ], ugy: [ "ugy", "sgn" ], ukl: [ "ukl", "sgn" ],
	            uks: [ "uks", "sgn" ], urk: [ "urk", "ms"  ], uzn: [ "uzn", "uz"  ], uzs: [ "uzs", "uz"  ],
	            vgt: [ "vgt", "sgn" ], vkk: [ "vkk", "ms"  ], vkt: [ "vkt", "ms"  ], vsi: [ "vsi", "sgn" ],
	            vsl: [ "vsl", "sgn" ], vsv: [ "vsv", "sgn" ], wuu: [ "wuu", "zh"  ], xki: [ "xki", "sgn" ],
	            xml: [ "xml", "sgn" ], xmm: [ "xmm", "ms"  ], xms: [ "xms", "sgn" ], yds: [ "yds", "sgn" ],
	            ysl: [ "ysl", "sgn" ], yue: [ "yue", "zh"  ], zib: [ "zib", "sgn" ], zlm: [ "zlm", "ms"  ],
	            zmi: [ "zmi", "ms"  ], zsl: [ "zsl", "sgn" ], zsm: [ "zsm", "ms"  ]
	        }
	    },
	
	    // Currency minor units output from tools/getISO4217data.js, formatted
	    currencyMinorUnits = {
	        BHD: 3, BYR: 0, XOF: 0, BIF: 0, XAF: 0, CLF: 0, CLP: 0, KMF: 0, DJF: 0,
	        XPF: 0, GNF: 0, ISK: 0, IQD: 3, JPY: 0, JOD: 3, KRW: 0, KWD: 3, LYD: 3,
	        OMR: 3, PYG: 0, RWF: 0, TND: 3, UGX: 0, UYI: 0, VUV: 0, VND: 0
	    };
	
	// Sect 6.2 Language Tags
	// ======================
	
	/**
	 * The IsStructurallyValidLanguageTag abstract operation verifies that the locale
	 * argument (which must be a String value)
	 *
	 * - represents a well-formed BCP 47 language tag as specified in RFC 5646 section
	 *   2.1, or successor,
	 * - does not include duplicate variant subtags, and
	 * - does not include duplicate singleton subtags.
	 *
	 * The abstract operation returns true if locale can be generated from the ABNF
	 * grammar in section 2.1 of the RFC, starting with Language-Tag, and does not
	 * contain duplicate variant or singleton subtags (other than as a private use
	 * subtag). It returns false otherwise. Terminal value characters in the grammar are
	 * interpreted as the Unicode equivalents of the ASCII octet values given.
	 */
	function /* 6.2.2 */IsStructurallyValidLanguageTag(locale) {
	    // represents a well-formed BCP 47 language tag as specified in RFC 5646
	    if (!src$exp$$.expBCP47Syntax.test(locale))
	        return false;
	
	    // does not include duplicate variant subtags, and
	    if (src$exp$$.expVariantDupes.test(locale))
	        return false;
	
	    // does not include duplicate singleton subtags.
	    if (src$exp$$.expSingletonDupes.test(locale))
	        return false;
	
	    return true;
	}
	
	/**
	 * The CanonicalizeLanguageTag abstract operation returns the canonical and case-
	 * regularized form of the locale argument (which must be a String value that is
	 * a structurally valid BCP 47 language tag as verified by the
	 * IsStructurallyValidLanguageTag abstract operation). It takes the steps
	 * specified in RFC 5646 section 4.5, or successor, to bring the language tag
	 * into canonical form, and to regularize the case of the subtags, but does not
	 * take the steps to bring a language tag into “extlang form” and to reorder
	 * variant subtags.
	
	 * The specifications for extensions to BCP 47 language tags, such as RFC 6067,
	 * may include canonicalization rules for the extension subtag sequences they
	 * define that go beyond the canonicalization rules of RFC 5646 section 4.5.
	 * Implementations are allowed, but not required, to apply these additional rules.
	 */
	function /* 6.2.3 */CanonicalizeLanguageTag (locale) {
	    var match, parts;
	
	    // A language tag is in 'canonical form' when the tag is well-formed
	    // according to the rules in Sections 2.1 and 2.2
	
	    // Section 2.1 says all subtags use lowercase...
	    locale = locale.toLowerCase();
	
	    // ...with 2 exceptions: 'two-letter and four-letter subtags that neither
	    // appear at the start of the tag nor occur after singletons.  Such two-letter
	    // subtags are all uppercase (as in the tags "en-CA-x-ca" or "sgn-BE-FR") and
	    // four-letter subtags are titlecase (as in the tag "az-Latn-x-latn").
	    parts = locale.split('-');
	    for (var i = 1, max = parts.length; i < max; i++) {
	        // Two-letter subtags are all uppercase
	        if (parts[i].length === 2)
	            parts[i] = parts[i].toUpperCase();
	
	        // Four-letter subtags are titlecase
	        else if (parts[i].length === 4)
	            parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
	
	        // Is it a singleton?
	        else if (parts[i].length === 1 && parts[i] != 'x')
	            break;
	    }
	    locale = arrJoin.call(parts, '-');
	
	    // The steps laid out in RFC 5646 section 4.5 are as follows:
	
	    // 1.  Extension sequences are ordered into case-insensitive ASCII order
	    //     by singleton subtag.
	    if ((match = locale.match(src$exp$$.expExtSequences)) && match.length > 1) {
	        // The built-in sort() sorts by ASCII order, so use that
	        match.sort();
	
	        // Replace all extensions with the joined, sorted array
	        locale = locale.replace(
	            RegExp('(?:' + src$exp$$.expExtSequences.source + ')+', 'i'),
	            arrJoin.call(match, '')
	        );
	    }
	
	    // 2.  Redundant or grandfathered tags are replaced by their 'Preferred-
	    //     Value', if there is one.
	    if (hop.call(redundantTags.tags, locale))
	        locale = redundantTags.tags[locale];
	
	    // 3.  Subtags are replaced by their 'Preferred-Value', if there is one.
	    //     For extlangs, the original primary language subtag is also
	    //     replaced if there is a primary language subtag in the 'Preferred-
	    //     Value'.
	    parts = locale.split('-');
	
	    for (var i = 1, max = parts.length; i < max; i++) {
	        if (hop.call(redundantTags.subtags, parts[i]))
	            parts[i] = redundantTags.subtags[parts[i]];
	
	        else if (hop.call(redundantTags.extLang, parts[i])) {
	            parts[i] = redundantTags.extLang[parts[i]][0];
	
	            // For extlang tags, the prefix needs to be removed if it is redundant
	            if (i === 1 && redundantTags.extLang[parts[1]][1] === parts[0]) {
	                parts = arrSlice.call(parts, i++);
	                max -= 1;
	            }
	        }
	    }
	
	    return arrJoin.call(parts, '-');
	}
	
	/**
	 * The DefaultLocale abstract operation returns a String value representing the
	 * structurally valid (6.2.2) and canonicalized (6.2.3) BCP 47 language tag for the
	 * host environment’s current locale.
	 */
	function /* 6.2.4 */DefaultLocale () {
	    return defaultLocale;
	}
	
	// Sect 6.3 Currency Codes
	// =======================
	
	/**
	 * The IsWellFormedCurrencyCode abstract operation verifies that the currency argument
	 * (after conversion to a String value) represents a well-formed 3-letter ISO currency
	 * code. The following steps are taken:
	 */
	function /* 6.3.1 */IsWellFormedCurrencyCode(currency) {
	    var
	        // 1. Let `c` be ToString(currency)
	        c = String(currency),
	
	        // 2. Let `normalized` be the result of mapping c to upper case as described
	        //    in 6.1.
	        normalized = toLatinUpperCase(c);
	
	    // 3. If the string length of normalized is not 3, return false.
	    // 4. If normalized contains any character that is not in the range "A" to "Z"
	    //    (U+0041 to U+005A), return false.
	    if (expCurrencyCode.test(normalized) === false)
	        return false;
	
	    // 5. Return true
	    return true;
	}
	
	// Sect 9.2 Abstract Operations
	// ============================
	function /* 9.2.1 */CanonicalizeLocaleList (locales) {
	// The abstract operation CanonicalizeLocaleList takes the following steps:
	
	    // 1. If locales is undefined, then a. Return a new empty List
	    if (locales === undefined)
	        return new List();
	
	    var
	        // 2. Let seen be a new empty List.
	        seen = new List(),
	
	        // 3. If locales is a String value, then
	        //    a. Let locales be a new array created as if by the expression new
	        //    Array(locales) where Array is the standard built-in constructor with
	        //    that name and locales is the value of locales.
	        locales = typeof locales === 'string' ? [ locales ] : locales,
	
	        // 4. Let O be ToObject(locales).
	        O = toObject(locales),
	
	        // 5. Let lenValue be the result of calling the [[Get]] internal method of
	        //    O with the argument "length".
	        // 6. Let len be ToUint32(lenValue).
	        len = O.length,
	
	        // 7. Let k be 0.
	        k = 0;
	
	    // 8. Repeat, while k < len
	    while (k < len) {
	        var
	            // a. Let Pk be ToString(k).
	            Pk = String(k),
	
	            // b. Let kPresent be the result of calling the [[HasProperty]] internal
	            //    method of O with argument Pk.
	            kPresent = Pk in O;
	
	        // c. If kPresent is true, then
	        if (kPresent) {
	            var
	                // i. Let kValue be the result of calling the [[Get]] internal
	                //     method of O with argument Pk.
	                kValue = O[Pk];
	
	            // ii. If the type of kValue is not String or Object, then throw a
	            //     TypeError exception.
	            if (kValue == null || (typeof kValue !== 'string' && typeof kValue !== 'object'))
	                throw new TypeError('String or Object type expected');
	
	            var
	                // iii. Let tag be ToString(kValue).
	                tag = String(kValue);
	
	            // iv. If the result of calling the abstract operation
	            //     IsStructurallyValidLanguageTag (defined in 6.2.2), passing tag as
	            //     the argument, is false, then throw a RangeError exception.
	            if (!IsStructurallyValidLanguageTag(tag))
	                throw new RangeError("'" + tag + "' is not a structurally valid language tag");
	
	            // v. Let tag be the result of calling the abstract operation
	            //    CanonicalizeLanguageTag (defined in 6.2.3), passing tag as the
	            //    argument.
	            tag = CanonicalizeLanguageTag(tag);
	
	            // vi. If tag is not an element of seen, then append tag as the last
	            //     element of seen.
	            if (arrIndexOf.call(seen, tag) === -1)
	                arrPush.call(seen, tag);
	        }
	
	        // d. Increase k by 1.
	        k++;
	    }
	
	    // 9. Return seen.
	    return seen;
	}
	
	/**
	 * The BestAvailableLocale abstract operation compares the provided argument
	 * locale, which must be a String value with a structurally valid and
	 * canonicalized BCP 47 language tag, against the locales in availableLocales and
	 * returns either the longest non-empty prefix of locale that is an element of
	 * availableLocales, or undefined if there is no such element. It uses the
	 * fallback mechanism of RFC 4647, section 3.4. The following steps are taken:
	 */
	function /* 9.2.2 */BestAvailableLocale (availableLocales, locale) {
	    var
	       // 1. Let candidate be locale
	       candidate = locale;
	
	    // 2. Repeat
	    while (true) {
	        // a. If availableLocales contains an element equal to candidate, then return
	        // candidate.
	        if (arrIndexOf.call(availableLocales, candidate) > -1)
	            return candidate;
	
	        var
	            // b. Let pos be the character index of the last occurrence of "-"
	            // (U+002D) within candidate. If that character does not occur, return
	            // undefined.
	            pos = candidate.lastIndexOf('-');
	
	        if (pos < 0)
	            return;
	
	        // c. If pos ≥ 2 and the character "-" occurs at index pos-2 of candidate,
	        //    then decrease pos by 2.
	        if (pos >= 2 && candidate.charAt(pos - 2) == '-')
	            pos -= 2;
	
	        // d. Let candidate be the substring of candidate from position 0, inclusive,
	        //    to position pos, exclusive.
	        candidate = candidate.substring(0, pos);
	    }
	}
	
	/**
	 * The LookupMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The following steps are taken:
	 */
	function /* 9.2.3 */LookupMatcher (availableLocales, requestedLocales) {
	    var
	        // 1. Let i be 0.
	        i = 0,
	
	        // 2. Let len be the number of elements in requestedLocales.
	        len = requestedLocales.length,
	
	        // 3. Let availableLocale be undefined.
	        availableLocale;
	
	    // 4. Repeat while i < len and availableLocale is undefined:
	    while (i < len && !availableLocale) {
	        var
	            // a. Let locale be the element of requestedLocales at 0-origined list
	            //    position i.
	            locale = requestedLocales[i],
	
	            // b. Let noExtensionsLocale be the String value that is locale with all
	            //    Unicode locale extension sequences removed.
	            noExtensionsLocale = String(locale).replace(expUnicodeExSeq, ''),
	
	            // c. Let availableLocale be the result of calling the
	            //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	            //    arguments availableLocales and noExtensionsLocale.
	            availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. Increase i by 1.
	        i++;
	    }
	
	    var
	        // 5. Let result be a new Record.
	        result = new Record();
	
	    // 6. If availableLocale is not undefined, then
	    if (availableLocale !== undefined) {
	        // a. Set result.[[locale]] to availableLocale.
	        result['[[locale]]'] = availableLocale;
	
	        // b. If locale and noExtensionsLocale are not the same String value, then
	        if (String(locale) !== String(noExtensionsLocale)) {
	            var
	                // i. Let extension be the String value consisting of the first
	                //    substring of locale that is a Unicode locale extension sequence.
	                extension = locale.match(expUnicodeExSeq)[0],
	
	                // ii. Let extensionIndex be the character position of the initial
	                //     "-" of the first Unicode locale extension sequence within locale.
	                extensionIndex = locale.indexOf('-u-');
	
	            // iii. Set result.[[extension]] to extension.
	            result['[[extension]]'] = extension;
	
	            // iv. Set result.[[extensionIndex]] to extensionIndex.
	            result['[[extensionIndex]]'] = extensionIndex;
	        }
	    }
	    // 7. Else
	    else
	        // a. Set result.[[locale]] to the value returned by the DefaultLocale abstract
	        //    operation (defined in 6.2.4).
	        result['[[locale]]'] = DefaultLocale();
	
	    // 8. Return result
	    return result;
	}
	
	/**
	 * The BestFitMatcher abstract operation compares requestedLocales, which must be
	 * a List as returned by CanonicalizeLocaleList, against the locales in
	 * availableLocales and determines the best available language to meet the
	 * request. The algorithm is implementation dependent, but should produce results
	 * that a typical user of the requested locales would perceive as at least as
	 * good as those produced by the LookupMatcher abstract operation. Options
	 * specified through Unicode locale extension sequences must be ignored by the
	 * algorithm. Information about such subsequences is returned separately.
	 * The abstract operation returns a record with a [[locale]] field, whose value
	 * is the language tag of the selected locale, which must be an element of
	 * availableLocales. If the language tag of the request locale that led to the
	 * selected locale contained a Unicode locale extension sequence, then the
	 * returned record also contains an [[extension]] field whose value is the first
	 * Unicode locale extension sequence, and an [[extensionIndex]] field whose value
	 * is the index of the first Unicode locale extension sequence within the request
	 * locale language tag.
	 */
	function /* 9.2.4 */BestFitMatcher (availableLocales, requestedLocales) {
	    return LookupMatcher(availableLocales, requestedLocales);
	}
	
	/**
	 * The ResolveLocale abstract operation compares a BCP 47 language priority list
	 * requestedLocales against the locales in availableLocales and determines the
	 * best available language to meet the request. availableLocales and
	 * requestedLocales must be provided as List values, options as a Record.
	 */
	function /* 9.2.5 */ResolveLocale (availableLocales, requestedLocales, options, relevantExtensionKeys, localeData) {
	    if (availableLocales.length === 0) {
	        throw new ReferenceError('No locale data has been provided for this object yet.');
	    }
	
	    // The following steps are taken:
	    var
	        // 1. Let matcher be the value of options.[[localeMatcher]].
	        matcher = options['[[localeMatcher]]'];
	
	    // 2. If matcher is "lookup", then
	    if (matcher === 'lookup')
	        var
	            // a. Let r be the result of calling the LookupMatcher abstract operation
	            //    (defined in 9.2.3) with arguments availableLocales and
	            //    requestedLocales.
	            r = LookupMatcher(availableLocales, requestedLocales);
	
	    // 3. Else
	    else
	        var
	            // a. Let r be the result of calling the BestFitMatcher abstract
	            //    operation (defined in 9.2.4) with arguments availableLocales and
	            //    requestedLocales.
	            r = BestFitMatcher(availableLocales, requestedLocales);
	
	    var
	        // 4. Let foundLocale be the value of r.[[locale]].
	        foundLocale = r['[[locale]]'];
	
	    // 5. If r has an [[extension]] field, then
	    if (hop.call(r, '[[extension]]'))
	        var
	            // a. Let extension be the value of r.[[extension]].
	            extension = r['[[extension]]'],
	            // b. Let extensionIndex be the value of r.[[extensionIndex]].
	            extensionIndex = r['[[extensionIndex]]'],
	            // c. Let split be the standard built-in function object defined in ES5,
	            //    15.5.4.14.
	            split = String.prototype.split,
	            // d. Let extensionSubtags be the result of calling the [[Call]] internal
	            //    method of split with extension as the this value and an argument
	            //    list containing the single item "-".
	            extensionSubtags = split.call(extension, '-'),
	            // e. Let extensionSubtagsLength be the result of calling the [[Get]]
	            //    internal method of extensionSubtags with argument "length".
	            extensionSubtagsLength = extensionSubtags.length;
	
	    var
	        // 6. Let result be a new Record.
	        result = new Record();
	
	    // 7. Set result.[[dataLocale]] to foundLocale.
	    result['[[dataLocale]]'] = foundLocale;
	
	    var
	        // 8. Let supportedExtension be "-u".
	        supportedExtension = '-u',
	        // 9. Let i be 0.
	        i = 0,
	        // 10. Let len be the result of calling the [[Get]] internal method of
	        //     relevantExtensionKeys with argument "length".
	        len = relevantExtensionKeys.length;
	
	    // 11 Repeat while i < len:
	    while (i < len) {
	        var
	            // a. Let key be the result of calling the [[Get]] internal method of
	            //    relevantExtensionKeys with argument ToString(i).
	            key = relevantExtensionKeys[i],
	            // b. Let foundLocaleData be the result of calling the [[Get]] internal
	            //    method of localeData with the argument foundLocale.
	            foundLocaleData = localeData[foundLocale],
	            // c. Let keyLocaleData be the result of calling the [[Get]] internal
	            //    method of foundLocaleData with the argument key.
	            keyLocaleData = foundLocaleData[key],
	            // d. Let value be the result of calling the [[Get]] internal method of
	            //    keyLocaleData with argument "0".
	            value = keyLocaleData['0'],
	            // e. Let supportedExtensionAddition be "".
	            supportedExtensionAddition = '',
	            // f. Let indexOf be the standard built-in function object defined in
	            //    ES5, 15.4.4.14.
	            indexOf = arrIndexOf;
	
	        // g. If extensionSubtags is not undefined, then
	        if (extensionSubtags !== undefined) {
	            var
	                // i. Let keyPos be the result of calling the [[Call]] internal
	                //    method of indexOf with extensionSubtags as the this value and
	                // an argument list containing the single item key.
	                keyPos = indexOf.call(extensionSubtags, key);
	
	            // ii. If keyPos ≠ -1, then
	            if (keyPos !== -1) {
	                // 1. If keyPos + 1 < extensionSubtagsLength and the length of the
	                //    result of calling the [[Get]] internal method of
	                //    extensionSubtags with argument ToString(keyPos +1) is greater
	                //    than 2, then
	                if (keyPos + 1 < extensionSubtagsLength
	                        && extensionSubtags[keyPos + 1].length > 2) {
	                    var
	                        // a. Let requestedValue be the result of calling the [[Get]]
	                        //    internal method of extensionSubtags with argument
	                        //    ToString(keyPos + 1).
	                        requestedValue = extensionSubtags[keyPos + 1],
	                        // b. Let valuePos be the result of calling the [[Call]]
	                        //    internal method of indexOf with keyLocaleData as the
	                        //    this value and an argument list containing the single
	                        //    item requestedValue.
	                        valuePos = indexOf.call(keyLocaleData, requestedValue);
	
	                    // c. If valuePos ≠ -1, then
	                    if (valuePos !== -1)
	                        var
	                            // i. Let value be requestedValue.
	                            value = requestedValue,
	                            // ii. Let supportedExtensionAddition be the
	                            //     concatenation of "-", key, "-", and value.
	                            supportedExtensionAddition = '-' + key + '-' + value;
	                }
	                // 2. Else
	                else {
	                    var
	                        // a. Let valuePos be the result of calling the [[Call]]
	                        // internal method of indexOf with keyLocaleData as the this
	                        // value and an argument list containing the single item
	                        // "true".
	                        valuePos = indexOf(keyLocaleData, 'true');
	
	                    // b. If valuePos ≠ -1, then
	                    if (valuePos !== -1)
	                        var
	                            // i. Let value be "true".
	                            value = 'true';
	                }
	            }
	        }
	        // h. If options has a field [[<key>]], then
	        if (hop.call(options, '[[' + key + ']]')) {
	            var
	                // i. Let optionsValue be the value of options.[[<key>]].
	                optionsValue = options['[[' + key + ']]'];
	
	            // ii. If the result of calling the [[Call]] internal method of indexOf
	            //     with keyLocaleData as the this value and an argument list
	            //     containing the single item optionsValue is not -1, then
	            if (indexOf.call(keyLocaleData, optionsValue) !== -1) {
	                // 1. If optionsValue is not equal to value, then
	                if (optionsValue !== value) {
	                    // a. Let value be optionsValue.
	                    value = optionsValue;
	                    // b. Let supportedExtensionAddition be "".
	                    supportedExtensionAddition = '';
	                }
	            }
	        }
	        // i. Set result.[[<key>]] to value.
	        result['[[' + key + ']]'] = value;
	
	        // j. Append supportedExtensionAddition to supportedExtension.
	        supportedExtension += supportedExtensionAddition;
	
	        // k. Increase i by 1.
	        i++;
	    }
	    // 12. If the length of supportedExtension is greater than 2, then
	    if (supportedExtension.length > 2) {
	        var
	            // a. Let preExtension be the substring of foundLocale from position 0,
	            //    inclusive, to position extensionIndex, exclusive.
	            preExtension = foundLocale.substring(0, extensionIndex),
	            // b. Let postExtension be the substring of foundLocale from position
	            //    extensionIndex to the end of the string.
	            postExtension = foundLocale.substring(extensionIndex),
	            // c. Let foundLocale be the concatenation of preExtension,
	            //    supportedExtension, and postExtension.
	            foundLocale = preExtension + supportedExtension + postExtension;
	    }
	    // 13. Set result.[[locale]] to foundLocale.
	    result['[[locale]]'] = foundLocale;
	
	    // 14. Return result.
	    return result;
	}
	
	/**
	 * The LookupSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the BCP 47 Lookup algorithm.
	 * Locales appear in the same order in the returned list as in requestedLocales.
	 * The following steps are taken:
	 */
	function /* 9.2.6 */LookupSupportedLocales (availableLocales, requestedLocales) {
	    var
	        // 1. Let len be the number of elements in requestedLocales.
	        len = requestedLocales.length,
	        // 2. Let subset be a new empty List.
	        subset = new List(),
	        // 3. Let k be 0.
	        k = 0;
	
	    // 4. Repeat while k < len
	    while (k < len) {
	        var
	            // a. Let locale be the element of requestedLocales at 0-origined list
	            //    position k.
	            locale = requestedLocales[k],
	            // b. Let noExtensionsLocale be the String value that is locale with all
	            //    Unicode locale extension sequences removed.
	            noExtensionsLocale = String(locale).replace(expUnicodeExSeq, ''),
	            // c. Let availableLocale be the result of calling the
	            //    BestAvailableLocale abstract operation (defined in 9.2.2) with
	            //    arguments availableLocales and noExtensionsLocale.
	            availableLocale = BestAvailableLocale(availableLocales, noExtensionsLocale);
	
	        // d. If availableLocale is not undefined, then append locale to the end of
	        //    subset.
	        if (availableLocale !== undefined)
	            arrPush.call(subset, locale);
	
	        // e. Increment k by 1.
	        k++;
	    }
	
	    var
	        // 5. Let subsetArray be a new Array object whose elements are the same
	        //    values in the same order as the elements of subset.
	        subsetArray = arrSlice.call(subset);
	
	    // 6. Return subsetArray.
	    return subsetArray;
	}
	
	/**
	 * The BestFitSupportedLocales abstract operation returns the subset of the
	 * provided BCP 47 language priority list requestedLocales for which
	 * availableLocales has a matching locale when using the Best Fit Matcher
	 * algorithm. Locales appear in the same order in the returned list as in
	 * requestedLocales. The steps taken are implementation dependent.
	 */
	function /*9.2.7 */BestFitSupportedLocales (availableLocales, requestedLocales) {
	    // ###TODO: implement this function as described by the specification###
	    return LookupSupportedLocales(availableLocales, requestedLocales);
	}
	
	/**
	 * The SupportedLocales abstract operation returns the subset of the provided BCP
	 * 47 language priority list requestedLocales for which availableLocales has a
	 * matching locale. Two algorithms are available to match the locales: the Lookup
	 * algorithm described in RFC 4647 section 3.4, and an implementation dependent
	 * best-fit algorithm. Locales appear in the same order in the returned list as
	 * in requestedLocales. The following steps are taken:
	 */
	function /*9.2.8 */SupportedLocales (availableLocales, requestedLocales, options) {
	    // 1. If options is not undefined, then
	    if (options !== undefined) {
	        var
	            // a. Let options be ToObject(options).
	            options = new Record(toObject(options)),
	            // b. Let matcher be the result of calling the [[Get]] internal method of
	            //    options with argument "localeMatcher".
	            matcher = options.localeMatcher;
	
	        // c. If matcher is not undefined, then
	        if (matcher !== undefined) {
	            // i. Let matcher be ToString(matcher).
	            matcher = String(matcher);
	
	            // ii. If matcher is not "lookup" or "best fit", then throw a RangeError
	            //     exception.
	            if (matcher !== 'lookup' && matcher !== 'best fit')
	                throw new RangeError('matcher should be "lookup" or "best fit"');
	        }
	    }
	    // 2. If matcher is undefined or "best fit", then
	    if (matcher === undefined || matcher === 'best fit')
	        var
	            // a. Let subset be the result of calling the BestFitSupportedLocales
	            //    abstract operation (defined in 9.2.7) with arguments
	            //    availableLocales and requestedLocales.
	            subset = BestFitSupportedLocales(availableLocales, requestedLocales);
	    // 3. Else
	    else
	        var
	            // a. Let subset be the result of calling the LookupSupportedLocales
	            //    abstract operation (defined in 9.2.6) with arguments
	            //    availableLocales and requestedLocales.
	            subset = LookupSupportedLocales(availableLocales, requestedLocales);
	
	    // 4. For each named own property name P of subset,
	    for (var P in subset) {
	        if (!hop.call(subset, P))
	            continue;
	
	        // a. Let desc be the result of calling the [[GetOwnProperty]] internal
	        //    method of subset with P.
	        // b. Set desc.[[Writable]] to false.
	        // c. Set desc.[[Configurable]] to false.
	        // d. Call the [[DefineOwnProperty]] internal method of subset with P, desc,
	        //    and true as arguments.
	        defineProperty(subset, P, {
	            writable: false, configurable: false, value: subset[P]
	        });
	    }
	    // "Freeze" the array so no new elements can be added
	    defineProperty(subset, 'length', { writable: false });
	
	    // 5. Return subset
	    return subset;
	}
	
	/**
	 * The GetOption abstract operation extracts the value of the property named
	 * property from the provided options object, converts it to the required type,
	 * checks whether it is one of a List of allowed values, and fills in a fallback
	 * value if necessary.
	 */
	function /*9.2.9 */GetOption (options, property, type, values, fallback) {
	    var
	        // 1. Let value be the result of calling the [[Get]] internal method of
	        //    options with argument property.
	        value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Assert: type is "boolean" or "string".
	        // b. If type is "boolean", then let value be ToBoolean(value).
	        // c. If type is "string", then let value be ToString(value).
	        value = type === 'boolean' ? Boolean(value)
	                  : (type === 'string' ? String(value) : value);
	
	        // d. If values is not undefined, then
	        if (values !== undefined) {
	            // i. If values does not contain an element equal to value, then throw a
	            //    RangeError exception.
	            if (arrIndexOf.call(values, value) === -1)
	                throw new RangeError("'" + value + "' is not an allowed value for `" + property +'`');
	        }
	
	        // e. Return value.
	        return value;
	    }
	    // Else return fallback.
	    return fallback;
	}
	
	/**
	 * The GetNumberOption abstract operation extracts a property value from the
	 * provided options object, converts it to a Number value, checks whether it is
	 * in the allowed range, and fills in a fallback value if necessary.
	 */
	function /* 9.2.10 */GetNumberOption (options, property, minimum, maximum, fallback) {
	    var
	        // 1. Let value be the result of calling the [[Get]] internal method of
	        //    options with argument property.
	        value = options[property];
	
	    // 2. If value is not undefined, then
	    if (value !== undefined) {
	        // a. Let value be ToNumber(value).
	        value = Number(value);
	
	        // b. If value is NaN or less than minimum or greater than maximum, throw a
	        //    RangeError exception.
	        if (isNaN(value) || value < minimum || value > maximum)
	            throw new RangeError('Value is not a number or outside accepted range');
	
	        // c. Return floor(value).
	        return Math.floor(value);
	    }
	    // 3. Else return fallback.
	    return fallback;
	}
	
	// 11.1 The Intl.NumberFormat constructor
	// ======================================
	
	// Define the NumberFormat constructor internally so it cannot be tainted
	function NumberFormatConstructor () {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.NumberFormat(locales, options);
	    }
	
	    return InitializeNumberFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'NumberFormat', {
	    configurable: true,
	    writable: true,
	    value: NumberFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(Intl.NumberFormat, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeNumberFormat accepts the arguments
	 * numberFormat (which must be an object), locales, and options. It initializes
	 * numberFormat as a NumberFormat object.
	 */
	function /*11.1.1.1 */InitializeNumberFormat (numberFormat, locales, options) {
	    var
	    // This will be a internal properties object if we're not already initialized
	        internal = getInternalProperties(numberFormat),
	
	    // Create an object whose props can be used to restore the values of RegExp props
	        regexpState = createRegExpRestore();
	
	    // 1. If numberFormat has an [[initializedIntlObject]] internal property with
	    // value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true)
	        throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(numberFormat, '__getInternalProperties', {
	        value: function () {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret)
	                return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    var
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	    // 4. If options is undefined, then
	    if (options === undefined)
	        // a. Let options be the result of creating a new object as if by the
	        // expression new Object() where Object is the standard built-in constructor
	        // with that name.
	        options = {};
	
	    // 5. Else
	    else
	        // a. Let options be ToObject(options).
	        options = toObject(options);
	
	    var
	    // 6. Let opt be a new Record.
	        opt = new Record(),
	
	    // 7. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with the arguments options, "localeMatcher", "string",
	    //    a List containing the two String values "lookup" and "best fit", and
	    //    "best fit".
	        matcher =  GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 8. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    var
	    // 9. Let NumberFormat be the standard built-in object that is the initial value
	    //    of Intl.NumberFormat.
	    // 10. Let localeData be the value of the [[localeData]] internal property of
	    //     NumberFormat.
	        localeData = internals.NumberFormat['[[localeData]]'],
	
	    // 11. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //     NumberFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //     internal property of NumberFormat, and localeData.
	        r = ResolveLocale(
	                internals.NumberFormat['[[availableLocales]]'], requestedLocales,
	                opt, internals.NumberFormat['[[relevantExtensionKeys]]'], localeData
	            );
	
	    // 12. Set the [[locale]] internal property of numberFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of numberFormat to the value
	    //     of r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    var
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	        dataLocale = r['[[dataLocale]]'],
	
	    // 15. Let s be the result of calling the GetOption abstract operation with the
	    //     arguments options, "style", "string", a List containing the three String
	    //     values "decimal", "percent", and "currency", and "decimal".
	        s = GetOption(options, 'style', 'string', new List('decimal', 'percent', 'currency'), 'decimal');
	
	    // 16. Set the [[style]] internal property of numberFormat to s.
	    internal['[[style]]'] = s;
	
	    var
	    // 17. Let c be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currency", "string", undefined, and undefined.
	        c = GetOption(options, 'currency', 'string');
	
	    // 18. If c is not undefined and the result of calling the
	    //     IsWellFormedCurrencyCode abstract operation (defined in 6.3.1) with
	    //     argument c is false, then throw a RangeError exception.
	    if (c !== undefined && !IsWellFormedCurrencyCode(c))
	        throw new RangeError("'" + c + "' is not a valid currency code");
	
	    // 19. If s is "currency" and c is undefined, throw a TypeError exception.
	    if (s === 'currency' && c === undefined)
	        throw new TypeError('Currency code is required when style is currency');
	
	    // 20. If s is "currency", then
	    if (s === 'currency') {
	        // a. Let c be the result of converting c to upper case as specified in 6.1.
	        c = c.toUpperCase();
	
	        // b. Set the [[currency]] internal property of numberFormat to c.
	        internal['[[currency]]'] = c;
	
	        var
	        // c. Let cDigits be the result of calling the CurrencyDigits abstract
	        //    operation (defined below) with argument c.
	            cDigits = CurrencyDigits(c);
	    }
	
	    var
	    // 21. Let cd be the result of calling the GetOption abstract operation with the
	    //     arguments options, "currencyDisplay", "string", a List containing the
	    //     three String values "code", "symbol", and "name", and "symbol".
	        cd = GetOption(options, 'currencyDisplay', 'string', new List('code', 'symbol', 'name'), 'symbol');
	
	    // 22. If s is "currency", then set the [[currencyDisplay]] internal property of
	    //     numberFormat to cd.
	    if (s === 'currency')
	        internal['[[currencyDisplay]]'] = cd;
	
	    var
	    // 23. Let mnid be the result of calling the GetNumberOption abstract operation
	    //     (defined in 9.2.10) with arguments options, "minimumIntegerDigits", 1, 21,
	    //     and 1.
	        mnid = GetNumberOption(options, 'minimumIntegerDigits', 1, 21, 1);
	
	    // 24. Set the [[minimumIntegerDigits]] internal property of numberFormat to mnid.
	    internal['[[minimumIntegerDigits]]'] = mnid;
	
	    var
	    // 25. If s is "currency", then let mnfdDefault be cDigits; else let mnfdDefault
	    //     be 0.
	        mnfdDefault = s === 'currency' ? cDigits : 0,
	
	    // 26. Let mnfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "minimumFractionDigits", 0, 20, and mnfdDefault.
	        mnfd = GetNumberOption(options, 'minimumFractionDigits', 0, 20, mnfdDefault);
	
	    // 27. Set the [[minimumFractionDigits]] internal property of numberFormat to mnfd.
	    internal['[[minimumFractionDigits]]'] = mnfd;
	
	    var
	    // 28. If s is "currency", then let mxfdDefault be max(mnfd, cDigits); else if s
	    //     is "percent", then let mxfdDefault be max(mnfd, 0); else let mxfdDefault
	    //     be max(mnfd, 3).
	        mxfdDefault = s === 'currency' ? Math.max(mnfd, cDigits)
	                    : (s === 'percent' ? Math.max(mnfd, 0) : Math.max(mnfd, 3)),
	
	    // 29. Let mxfd be the result of calling the GetNumberOption abstract operation
	    //     with arguments options, "maximumFractionDigits", mnfd, 20, and mxfdDefault.
	        mxfd = GetNumberOption(options, 'maximumFractionDigits', mnfd, 20, mxfdDefault);
	
	    // 30. Set the [[maximumFractionDigits]] internal property of numberFormat to mxfd.
	    internal['[[maximumFractionDigits]]'] = mxfd;
	
	    var
	    // 31. Let mnsd be the result of calling the [[Get]] internal method of options
	    //     with argument "minimumSignificantDigits".
	        mnsd = options.minimumSignificantDigits,
	
	    // 32. Let mxsd be the result of calling the [[Get]] internal method of options
	    //     with argument "maximumSignificantDigits".
	        mxsd = options.maximumSignificantDigits;
	
	    // 33. If mnsd is not undefined or mxsd is not undefined, then:
	    if (mnsd !== undefined || mxsd !== undefined) {
	        // a. Let mnsd be the result of calling the GetNumberOption abstract
	        //    operation with arguments options, "minimumSignificantDigits", 1, 21,
	        //    and 1.
	        mnsd = GetNumberOption(options, 'minimumSignificantDigits', 1, 21, 1);
	
	        // b. Let mxsd be the result of calling the GetNumberOption abstract
	        //     operation with arguments options, "maximumSignificantDigits", mnsd,
	        //     21, and 21.
	        mxsd = GetNumberOption(options, 'maximumSignificantDigits', mnsd, 21, 21);
	
	        // c. Set the [[minimumSignificantDigits]] internal property of numberFormat
	        //    to mnsd, and the [[maximumSignificantDigits]] internal property of
	        //    numberFormat to mxsd.
	        internal['[[minimumSignificantDigits]]'] = mnsd;
	        internal['[[maximumSignificantDigits]]'] = mxsd;
	    }
	    var
	    // 34. Let g be the result of calling the GetOption abstract operation with the
	    //     arguments options, "useGrouping", "boolean", undefined, and true.
	        g = GetOption(options, 'useGrouping', 'boolean', undefined, true);
	
	    // 35. Set the [[useGrouping]] internal property of numberFormat to g.
	    internal['[[useGrouping]]'] = g;
	
	    var
	    // 36. Let dataLocaleData be the result of calling the [[Get]] internal method of
	    //     localeData with argument dataLocale.
	        dataLocaleData = localeData[dataLocale],
	
	    // 37. Let patterns be the result of calling the [[Get]] internal method of
	    //     dataLocaleData with argument "patterns".
	        patterns = dataLocaleData.patterns;
	
	    // 38. Assert: patterns is an object (see 11.2.3)
	
	    var
	    // 39. Let stylePatterns be the result of calling the [[Get]] internal method of
	    //     patterns with argument s.
	        stylePatterns = patterns[s];
	
	    // 40. Set the [[positivePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "positivePattern".
	    internal['[[positivePattern]]'] = stylePatterns.positivePattern;
	
	    // 41. Set the [[negativePattern]] internal property of numberFormat to the
	    //     result of calling the [[Get]] internal method of stylePatterns with the
	    //     argument "negativePattern".
	    internal['[[negativePattern]]'] = stylePatterns.negativePattern;
	
	    // 42. Set the [[boundFormat]] internal property of numberFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 43. Set the [[initializedNumberFormat]] internal property of numberFormat to
	    //     true.
	    internal['[[initializedNumberFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3)
	        numberFormat.format = GetFormatNumber.call(numberFormat);
	
	    // Restore the RegExp properties
	    regexpState.exp.test(regexpState.input);
	
	    // Return the newly initialised object
	    return numberFormat;
	}
	
	function CurrencyDigits(currency) {
	    // When the CurrencyDigits abstract operation is called with an argument currency
	    // (which must be an upper case String value), the following steps are taken:
	
	    // 1. If the ISO 4217 currency and funds code list contains currency as an
	    // alphabetic code, then return the minor unit value corresponding to the
	    // currency from the list; else return 2.
	    return currencyMinorUnits[currency] !== undefined
	                ? currencyMinorUnits[currency]
	                : 2;
	}
	
	/* 11.2.3 */internals.NumberFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.NumberFormat is called, the
	 * following steps are taken:
	 */
	/* 11.2.2 */defineProperty(Intl.NumberFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(supportedLocalesOf, internals.NumberFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * NumberFormat object.
	 */
	/* 11.3.2 */defineProperty(Intl.NumberFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatNumber
	});
	
	function GetFormatNumber() {
	        var internal = this != null && typeof this === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]'])
	            throw new TypeError('`this` value for format() is not an initialized Intl.NumberFormat object.');
	
	        // The value of the [[Get]] attribute is a function that takes the following
	        // steps:
	
	        // 1. If the [[boundFormat]] internal property of this NumberFormat object
	        //    is undefined, then:
	        if (internal['[[boundFormat]]'] === undefined) {
	            var
	            // a. Let F be a Function object, with internal properties set as
	            //    specified for built-in functions in ES5, 15, or successor, and the
	            //    length property set to 1, that takes the argument value and
	            //    performs the following steps:
	                F = function (value) {
	                    // i. If value is not provided, then let value be undefined.
	                    // ii. Let x be ToNumber(value).
	                    // iii. Return the result of calling the FormatNumber abstract
	                    //      operation (defined below) with arguments this and x.
	                    return FormatNumber(this, /* x = */Number(value));
	                },
	
	            // b. Let bind be the standard built-in function object defined in ES5,
	            //    15.3.4.5.
	            // c. Let bf be the result of calling the [[Call]] internal method of
	            //    bind with F as the this value and an argument list containing
	            //    the single item this.
	                bf = fnBind.call(F, this);
	
	            // d. Set the [[boundFormat]] internal property of this NumberFormat
	            //    object to bf.
	            internal['[[boundFormat]]'] = bf;
	        }
	        // Return the value of the [[boundFormat]] internal property of this
	        // NumberFormat object.
	        return internal['[[boundFormat]]'];
	    }
	
	/**
	 * When the FormatNumber abstract operation is called with arguments numberFormat
	 * (which must be an object initialized as a NumberFormat) and x (which must be a
	 * Number value), it returns a String value representing x according to the
	 * effective locale and the formatting options of numberFormat.
	 */
	function FormatNumber (numberFormat, x) {
	    var n,
	
	    // Create an object whose props can be used to restore the values of RegExp props
	        regexpState = createRegExpRestore(),
	
	        internal = getInternalProperties(numberFormat),
	        locale = internal['[[dataLocale]]'],
	        nums   = internal['[[numberingSystem]]'],
	        data   = internals.NumberFormat['[[localeData]]'][locale],
	        ild    = data.symbols[nums] || data.symbols.latn,
	
	    // 1. Let negative be false.
	        negative = false;
	
	    // 2. If the result of isFinite(x) is false, then
	    if (isFinite(x) === false) {
	        // a. If x is NaN, then let n be an ILD String value indicating the NaN value.
	        if (isNaN(x))
	            n = ild.nan;
	
	        // b. Else
	        else {
	            // a. Let n be an ILD String value indicating infinity.
	            n = ild.infinity;
	            // b. If x < 0, then let negative be true.
	            if (x < 0)
	                negative = true;
	        }
	    }
	    // 3. Else
	    else {
	        // a. If x < 0, then
	        if (x < 0) {
	            // i. Let negative be true.
	            negative = true;
	            // ii. Let x be -x.
	            x = -x;
	        }
	
	        // b. If the value of the [[style]] internal property of numberFormat is
	        //    "percent", let x be 100 × x.
	        if (internal['[[style]]'] === 'percent')
	            x *= 100;
	
	        // c. If the [[minimumSignificantDigits]] and [[maximumSignificantDigits]]
	        //    internal properties of numberFormat are present, then
	        if (hop.call(internal, '[[minimumSignificantDigits]]') &&
	                hop.call(internal, '[[maximumSignificantDigits]]'))
	            // i. Let n be the result of calling the ToRawPrecision abstract operation
	            //    (defined below), passing as arguments x and the values of the
	            //    [[minimumSignificantDigits]] and [[maximumSignificantDigits]]
	            //    internal properties of numberFormat.
	            n = ToRawPrecision(x,
	                  internal['[[minimumSignificantDigits]]'],
	                  internal['[[maximumSignificantDigits]]']);
	        // d. Else
	        else
	            // i. Let n be the result of calling the ToRawFixed abstract operation
	            //    (defined below), passing as arguments x and the values of the
	            //    [[minimumIntegerDigits]], [[minimumFractionDigits]], and
	            //    [[maximumFractionDigits]] internal properties of numberFormat.
	            n = ToRawFixed(x,
	                  internal['[[minimumIntegerDigits]]'],
	                  internal['[[minimumFractionDigits]]'],
	                  internal['[[maximumFractionDigits]]']);
	
	        // e. If the value of the [[numberingSystem]] internal property of
	        //    numberFormat matches one of the values in the “Numbering System” column
	        //    of Table 2 below, then
	        if (numSys[nums]) {
	            // i. Let digits be an array whose 10 String valued elements are the
	            //    UTF-16 string representations of the 10 digits specified in the
	            //    “Digits” column of Table 2 in the row containing the value of the
	            //    [[numberingSystem]] internal property.
	            var digits = numSys[internal['[[numberingSystem]]']];
	            // ii. Replace each digit in n with the value of digits[digit].
	            n = String(n).replace(/\d/g, function (digit) {
	                return digits[digit];
	            });
	        }
	        // f. Else use an implementation dependent algorithm to map n to the
	        //    appropriate representation of n in the given numbering system.
	        else
	            n = String(n); // ###TODO###
	
	        // g. If n contains the character ".", then replace it with an ILND String
	        //    representing the decimal separator.
	        n = n.replace(/\./g, ild.decimal);
	
	        // h. If the value of the [[useGrouping]] internal property of numberFormat
	        //    is true, then insert an ILND String representing a grouping separator
	        //    into an ILND set of locations within the integer part of n.
	        if (internal['[[useGrouping]]'] === true) {
	            var
	                parts  = n.split(ild.decimal),
	                igr    = parts[0],
	
	                // Primary group represents the group closest to the decimal
	                pgSize = data.patterns.primaryGroupSize || 3,
	
	                // Secondary group is every other group
	                sgSize = data.patterns.secondaryGroupSize || pgSize;
	
	            // Group only if necessary
	            if (igr.length > pgSize) {
	                var
	                    groups = new List(),
	
	                    // Index of the primary grouping separator
	                    end    = igr.length - pgSize,
	
	                    // Starting index for our loop
	                    idx    = end % sgSize,
	
	                    start  = igr.slice(0, idx);
	
	                if (start.length)
	                    arrPush.call(groups, start);
	
	                // Loop to separate into secondary grouping digits
	                while (idx < end) {
	                    arrPush.call(groups, igr.slice(idx, idx + sgSize));
	                    idx += sgSize;
	                }
	
	                // Add the primary grouping digits
	                arrPush.call(groups, igr.slice(end));
	
	                parts[0] = arrJoin.call(groups, ild.group);
	            }
	
	            n = arrJoin.call(parts, ild.decimal);
	        }
	    }
	
	    var
	    // 4. If negative is true, then let result be the value of the [[negativePattern]]
	    //    internal property of numberFormat; else let result be the value of the
	    //    [[positivePattern]] internal property of numberFormat.
	        result = internal[negative === true ? '[[negativePattern]]' : '[[positivePattern]]'];
	
	    // 5. Replace the substring "{number}" within result with n.
	    result = result.replace('{number}', n);
	
	    // 6. If the value of the [[style]] internal property of numberFormat is
	    //    "currency", then:
	    if (internal['[[style]]'] === 'currency') {
	        var cd,
	        // a. Let currency be the value of the [[currency]] internal property of
	        //    numberFormat.
	            currency = internal['[[currency]]'],
	
	        // Shorthand for the currency data
	            cData = data.currencies[currency];
	
	        // b. If the value of the [[currencyDisplay]] internal property of
	        //    numberFormat is "code", then let cd be currency.
	        // c. Else if the value of the [[currencyDisplay]] internal property of
	        //    numberFormat is "symbol", then let cd be an ILD string representing
	        //    currency in short form. If the implementation does not have such a
	        //    representation of currency, then use currency itself.
	        // d. Else if the value of the [[currencyDisplay]] internal property of
	        //    numberFormat is "name", then let cd be an ILD string representing
	        //    currency in long form. If the implementation does not have such a
	        //    representation of currency, then use currency itself.
	        switch (internal['[[currencyDisplay]]']) {
	            case 'symbol':
	                cd = cData || currency;
	                break;
	
	            default:
	            case 'code':
	            case 'name':
	                cd = currency;
	        }
	
	        // e. Replace the substring "{currency}" within result with cd.
	        result = result.replace('{currency}', cd);
	    }
	
	    // Restore the RegExp properties
	    regexpState.exp.test(regexpState.input);
	
	    // 7. Return result.
	    return result;
	}
	
	/**
	 * When the ToRawPrecision abstract operation is called with arguments x (which
	 * must be a finite non-negative number), minPrecision, and maxPrecision (both
	 * must be integers between 1 and 21) the following steps are taken:
	 */
	function ToRawPrecision (x, minPrecision, maxPrecision) {
	    var
	    // 1. Let p be maxPrecision.
	        p = maxPrecision;
	
	    // 2. If x = 0, then
	    if (x === 0) {
	        var
	        // a. Let m be the String consisting of p occurrences of the character "0".
	            m = arrJoin.call(Array (p + 1), '0'),
	        // b. Let e be 0.
	            e = 0;
	    }
	    // 3. Else
	    else {
	        // a. Let e and n be integers such that 10ᵖ⁻¹ ≤ n < 10ᵖ and for which the
	        //    exact mathematical value of n × 10ᵉ⁻ᵖ⁺¹ – x is as close to zero as
	        //    possible. If there are two such sets of e and n, pick the e and n for
	        //    which n × 10ᵉ⁻ᵖ⁺¹ is larger.
	        var
	            e = log10Floor(Math.abs(x)),
	
	            // Easier to get to m from here
	            f = Math.round(Math.exp((Math.abs(e - p + 1)) * Math.LN10)),
	
	        // b. Let m be the String consisting of the digits of the decimal
	        //    representation of n (in order, with no leading zeroes)
	            m = String(Math.round(e - p + 1 < 0 ? x * f : x / f));
	    }
	
	    // 4. If e ≥ p, then
	    if (e >= p)
	        // a. Return the concatenation of m and e-p+1 occurrences of the character "0".
	        return m + arrJoin.call(Array(e-p+1 + 1), '0');
	
	    // 5. If e = p-1, then
	    else if (e === p - 1)
	        // a. Return m.
	        return m;
	
	    // 6. If e ≥ 0, then
	    else if (e >= 0)
	        // a. Let m be the concatenation of the first e+1 characters of m, the character
	        //    ".", and the remaining p–(e+1) characters of m.
	        m = m.slice(0, e + 1) + '.' + m.slice(e + 1);
	
	    // 7. If e < 0, then
	    else if (e < 0)
	        // a. Let m be the concatenation of the String "0.", –(e+1) occurrences of the
	        //    character "0", and the string m.
	        m = '0.' + arrJoin.call(Array (-(e+1) + 1), '0') + m;
	
	    // 8. If m contains the character ".", and maxPrecision > minPrecision, then
	    if (m.indexOf(".") >= 0 && maxPrecision > minPrecision) {
	        var
	        // a. Let cut be maxPrecision – minPrecision.
	            cut = maxPrecision - minPrecision;
	
	        // b. Repeat while cut > 0 and the last character of m is "0":
	        while (cut > 0 && m.charAt(m.length-1) === '0') {
	            //  i. Remove the last character from m.
	            m = m.slice(0, -1);
	
	            //  ii. Decrease cut by 1.
	            cut--;
	        }
	
	        // c. If the last character of m is ".", then
	        if (m.charAt(m.length-1) === '.')
	            //    i. Remove the last character from m.
	            m = m.slice(0, -1);
	    }
	    // 9. Return m.
	    return m;
	}
	
	/**
	 * When the ToRawFixed abstract operation is called with arguments x (which must
	 * be a finite non-negative number), minInteger (which must be an integer between
	 * 1 and 21), minFraction, and maxFraction (which must be integers between 0 and
	 * 20) the following steps are taken:
	 */
	function ToRawFixed (x, minInteger, minFraction, maxFraction) {
	    // (or not because Number.toPrototype.toFixed does a lot of it for us)
	    var idx,
	
	        // We can pick up after the fixed formatted string (m) is created
	        m   = Number.prototype.toFixed.call(x, maxFraction),
	
	        // 4. If [maxFraction] ≠ 0, then
	        //    ...
	        //    e. Let int be the number of characters in a.
	        //
	        // 5. Else let int be the number of characters in m.
	        igr = m.split(".")[0].length,  // int is a reserved word
	
	        // 6. Let cut be maxFraction – minFraction.
	        cut = maxFraction - minFraction,
	
	        exp = (idx = m.indexOf('e')) > -1 ? m.slice(idx + 1) : 0;
	
	    if (exp) {
	        m = m.slice(0, idx).replace('.', '');
	        m += arrJoin.call(Array(exp - (m.length - 1) + 1), '0')
	          + '.' + arrJoin.call(Array(maxFraction + 1), '0');
	
	        igr = m.length;
	    }
	
	    // 7. Repeat while cut > 0 and the last character of m is "0":
	    while (cut > 0 && m.slice(-1) === "0") {
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	
	        // b. Decrease cut by 1.
	        cut--;
	    }
	
	    // 8. If the last character of m is ".", then
	    if (m.slice(-1) === ".")
	        // a. Remove the last character from m.
	        m = m.slice(0, -1);
	
	    // 9. If int < minInteger, then
	    if (igr < minInteger)
	        // a. Let z be the String consisting of minInteger–int occurrences of the
	        //    character "0".
	        var z = arrJoin.call(Array(minInteger - igr + 1), '0');
	
	    // 10. Let m be the concatenation of Strings z and m.
	    // 11. Return m.
	    return (z ? z : '') + m;
	}
	
	// Sect 11.3.2 Table 2, Numbering systems
	// ======================================
	var numSys = {
	    arab:    [ '\u0660', '\u0661', '\u0662', '\u0663', '\u0664', '\u0665', '\u0666', '\u0667', '\u0668', '\u0669' ],
	    arabext: [ '\u06F0', '\u06F1', '\u06F2', '\u06F3', '\u06F4', '\u06F5', '\u06F6', '\u06F7', '\u06F8', '\u06F9' ],
	    bali:    [ '\u1B50', '\u1B51', '\u1B52', '\u1B53', '\u1B54', '\u1B55', '\u1B56', '\u1B57', '\u1B58', '\u1B59' ],
	    beng:    [ '\u09E6', '\u09E7', '\u09E8', '\u09E9', '\u09EA', '\u09EB', '\u09EC', '\u09ED', '\u09EE', '\u09EF' ],
	    deva:    [ '\u0966', '\u0967', '\u0968', '\u0969', '\u096A', '\u096B', '\u096C', '\u096D', '\u096E', '\u096F' ],
	    fullwide:[ '\uFF10', '\uFF11', '\uFF12', '\uFF13', '\uFF14', '\uFF15', '\uFF16', '\uFF17', '\uFF18', '\uFF19' ],
	    gujr:    [ '\u0AE6', '\u0AE7', '\u0AE8', '\u0AE9', '\u0AEA', '\u0AEB', '\u0AEC', '\u0AED', '\u0AEE', '\u0AEF' ],
	    guru:    [ '\u0A66', '\u0A67', '\u0A68', '\u0A69', '\u0A6A', '\u0A6B', '\u0A6C', '\u0A6D', '\u0A6E', '\u0A6F' ],
	    hanidec: [ '\u3007', '\u4E00', '\u4E8C', '\u4E09', '\u56DB', '\u4E94', '\u516D', '\u4E03', '\u516B', '\u4E5D' ],
	    khmr:    [ '\u17E0', '\u17E1', '\u17E2', '\u17E3', '\u17E4', '\u17E5', '\u17E6', '\u17E7', '\u17E8', '\u17E9' ],
	    knda:    [ '\u0CE6', '\u0CE7', '\u0CE8', '\u0CE9', '\u0CEA', '\u0CEB', '\u0CEC', '\u0CED', '\u0CEE', '\u0CEF' ],
	    laoo:    [ '\u0ED0', '\u0ED1', '\u0ED2', '\u0ED3', '\u0ED4', '\u0ED5', '\u0ED6', '\u0ED7', '\u0ED8', '\u0ED9' ],
	    latn:    [ '\u0030', '\u0031', '\u0032', '\u0033', '\u0034', '\u0035', '\u0036', '\u0037', '\u0038', '\u0039' ],
	    limb:    [ '\u1946', '\u1947', '\u1948', '\u1949', '\u194A', '\u194B', '\u194C', '\u194D', '\u194E', '\u194F' ],
	    mlym:    [ '\u0D66', '\u0D67', '\u0D68', '\u0D69', '\u0D6A', '\u0D6B', '\u0D6C', '\u0D6D', '\u0D6E', '\u0D6F' ],
	    mong:    [ '\u1810', '\u1811', '\u1812', '\u1813', '\u1814', '\u1815', '\u1816', '\u1817', '\u1818', '\u1819' ],
	    mymr:    [ '\u1040', '\u1041', '\u1042', '\u1043', '\u1044', '\u1045', '\u1046', '\u1047', '\u1048', '\u1049' ],
	    orya:    [ '\u0B66', '\u0B67', '\u0B68', '\u0B69', '\u0B6A', '\u0B6B', '\u0B6C', '\u0B6D', '\u0B6E', '\u0B6F' ],
	    tamldec: [ '\u0BE6', '\u0BE7', '\u0BE8', '\u0BE9', '\u0BEA', '\u0BEB', '\u0BEC', '\u0BED', '\u0BEE', '\u0BEF' ],
	    telu:    [ '\u0C66', '\u0C67', '\u0C68', '\u0C69', '\u0C6A', '\u0C6B', '\u0C6C', '\u0C6D', '\u0C6E', '\u0C6F' ],
	    thai:    [ '\u0E50', '\u0E51', '\u0E52', '\u0E53', '\u0E54', '\u0E55', '\u0E56', '\u0E57', '\u0E58', '\u0E59' ],
	    tibt:    [ '\u0F20', '\u0F21', '\u0F22', '\u0F23', '\u0F24', '\u0F25', '\u0F26', '\u0F27', '\u0F28', '\u0F29' ]
	};
	
	/**
	 * This function provides access to the locale and formatting options computed
	 * during initialization of the object.
	 *
	 * The function returns a new object whose properties and attributes are set as
	 * if constructed by an object literal assigning to each of the following
	 * properties the value of the corresponding internal property of this
	 * NumberFormat object (see 11.4): locale, numberingSystem, style, currency,
	 * currencyDisplay, minimumIntegerDigits, minimumFractionDigits,
	 * maximumFractionDigits, minimumSignificantDigits, maximumSignificantDigits, and
	 * useGrouping. Properties whose corresponding internal properties are not present
	 * are not assigned.
	 */
	/* 11.3.3 */defineProperty(Intl.NumberFormat.prototype, 'resolvedOptions', {
	    configurable: true,
	    writable: true,
	    value: function () {
	        var prop,
	            descs = new Record(),
	            props = [
	                'locale', 'numberingSystem', 'style', 'currency', 'currencyDisplay',
	                'minimumIntegerDigits', 'minimumFractionDigits', 'maximumFractionDigits',
	                'minimumSignificantDigits', 'maximumSignificantDigits', 'useGrouping'
	            ],
	            internal = this != null && typeof this === 'object' && getInternalProperties(this);
	
	        // Satisfy test 11.3_b
	        if (!internal || !internal['[[initializedNumberFormat]]'])
	            throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.NumberFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[['+ props[i] +']]'))
	                descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	// 12.1 The Intl.DateTimeFormat constructor
	// ==================================
	
	// Define the DateTimeFormat constructor internally so it cannot be tainted
	function DateTimeFormatConstructor () {
	    var locales = arguments[0];
	    var options = arguments[1];
	
	    if (!this || this === Intl) {
	        return new Intl.DateTimeFormat(locales, options);
	    }
	    return InitializeDateTimeFormat(toObject(this), locales, options);
	}
	
	defineProperty(Intl, 'DateTimeFormat', {
	    configurable: true,
	    writable: true,
	    value: DateTimeFormatConstructor
	});
	
	// Must explicitly set prototypes as unwritable
	defineProperty(DateTimeFormatConstructor, 'prototype', {
	    writable: false
	});
	
	/**
	 * The abstract operation InitializeDateTimeFormat accepts the arguments dateTimeFormat
	 * (which must be an object), locales, and options. It initializes dateTimeFormat as a
	 * DateTimeFormat object.
	 */
	function/* 12.1.1.1 */InitializeDateTimeFormat (dateTimeFormat, locales, options) {
	    var
	    // This will be a internal properties object if we're not already initialized
	        internal = getInternalProperties(dateTimeFormat),
	
	    // Create an object whose props can be used to restore the values of RegExp props
	        regexpState = createRegExpRestore();
	
	    // 1. If dateTimeFormat has an [[initializedIntlObject]] internal property with
	    //    value true, throw a TypeError exception.
	    if (internal['[[initializedIntlObject]]'] === true)
	        throw new TypeError('`this` object has already been initialized as an Intl object');
	
	    // Need this to access the `internal` object
	    defineProperty(dateTimeFormat, '__getInternalProperties', {
	        value: function () {
	            // NOTE: Non-standard, for internal use only
	            if (arguments[0] === secret)
	                return internal;
	        }
	    });
	
	    // 2. Set the [[initializedIntlObject]] internal property of numberFormat to true.
	    internal['[[initializedIntlObject]]'] = true;
	
	    var
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales),
	
	    // 4. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined below) with arguments options, "any", and "date".
	        options = ToDateTimeOptions(options, 'any', 'date'),
	
	    // 5. Let opt be a new Record.
	        opt = new Record();
	
	    // 6. Let matcher be the result of calling the GetOption abstract operation
	    //    (defined in 9.2.9) with arguments options, "localeMatcher", "string", a List
	    //    containing the two String values "lookup" and "best fit", and "best fit".
	        matcher = GetOption(options, 'localeMatcher', 'string', new List('lookup', 'best fit'), 'best fit');
	
	    // 7. Set opt.[[localeMatcher]] to matcher.
	    opt['[[localeMatcher]]'] = matcher;
	
	    var
	    // 8. Let DateTimeFormat be the standard built-in object that is the initial
	    //    value of Intl.DateTimeFormat.
	        DateTimeFormat = internals.DateTimeFormat, // This is what we *really* need
	
	    // 9. Let localeData be the value of the [[localeData]] internal property of
	    //    DateTimeFormat.
	        localeData = DateTimeFormat['[[localeData]]'],
	
	    // 10. Let r be the result of calling the ResolveLocale abstract operation
	    //     (defined in 9.2.5) with the [[availableLocales]] internal property of
	    //      DateTimeFormat, requestedLocales, opt, the [[relevantExtensionKeys]]
	    //      internal property of DateTimeFormat, and localeData.
	        r = ResolveLocale(DateTimeFormat['[[availableLocales]]'], requestedLocales,
	                opt, DateTimeFormat['[[relevantExtensionKeys]]'], localeData);
	
	    // 11. Set the [[locale]] internal property of dateTimeFormat to the value of
	    //     r.[[locale]].
	    internal['[[locale]]'] = r['[[locale]]'];
	
	    // 12. Set the [[calendar]] internal property of dateTimeFormat to the value of
	    //     r.[[ca]].
	    internal['[[calendar]]'] = r['[[ca]]'];
	
	    // 13. Set the [[numberingSystem]] internal property of dateTimeFormat to the value of
	    //     r.[[nu]].
	    internal['[[numberingSystem]]'] = r['[[nu]]'];
	
	    // The specification doesn't tell us to do this, but it's helpful later on
	    internal['[[dataLocale]]'] = r['[[dataLocale]]'];
	
	    var
	    // 14. Let dataLocale be the value of r.[[dataLocale]].
	        dataLocale = r['[[dataLocale]]'],
	
	    // 15. Let tz be the result of calling the [[Get]] internal method of options with
	    //     argument "timeZone".
	        tz = options.timeZone;
	
	    // 16. If tz is not undefined, then
	    if (tz !== undefined) {
	        // a. Let tz be ToString(tz).
	        // b. Convert tz to upper case as described in 6.1.
	        //    NOTE: If an implementation accepts additional time zone values, as permitted
	        //          under certain conditions by the Conformance clause, different casing
	        //          rules apply.
	        tz = toLatinUpperCase(tz);
	
	        // c. If tz is not "UTC", then throw a RangeError exception.
	        // ###TODO: accept more time zones###
	        if (tz !== 'UTC')
	            throw new RangeError('timeZone is not supported.');
	    }
	
	    // 17. Set the [[timeZone]] internal property of dateTimeFormat to tz.
	    internal['[[timeZone]]'] = tz;
	
	    // 18. Let opt be a new Record.
	    opt = new Record();
	
	    // 19. For each row of Table 3, except the header row, do:
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop))
	            continue;
	
	        var
	        // 20. Let prop be the name given in the Property column of the row.
	        // 21. Let value be the result of calling the GetOption abstract operation,
	        //     passing as argument options, the name given in the Property column of the
	        //     row, "string", a List containing the strings given in the Values column of
	        //     the row, and undefined.
	            value = GetOption(options, prop, 'string', dateTimeComponents[prop]);
	
	        // 22. Set opt.[[<prop>]] to value.
	        opt['[['+prop+']]'] = value;
	    }
	
	    var
	        // Assigned a value below
	        bestFormat,
	
	        // 23. Let dataLocaleData be the result of calling the [[Get]] internal method of
	        //     localeData with argument dataLocale.
	        dataLocaleData = localeData[dataLocale],
	
	        // 24. Let formats be the result of calling the [[Get]] internal method of
	        //     dataLocaleData with argument "formats".
	        //     Note: we process the CLDR formats into the spec'd structure
	        formats = ToDateTimeFormats(dataLocaleData.formats),
	
	        // 25. Let matcher be the result of calling the GetOption abstract operation with
	        //     arguments options, "formatMatcher", "string", a List containing the two String
	        //     values "basic" and "best fit", and "best fit".
	        matcher = GetOption(options, 'formatMatcher', 'string', new List('basic', 'best fit'), 'best fit');
	
	    // Optimization: caching the processed formats as a one time operation by
	    // replacing the initial structure from localeData
	    dataLocaleData.formats = formats;
	
	    // 26. If matcher is "basic", then
	    if (matcher === 'basic')
	        // 27. Let bestFormat be the result of calling the BasicFormatMatcher abstract
	        //     operation (defined below) with opt and formats.
	        bestFormat = BasicFormatMatcher(opt, formats);
	
	    // 28. Else
	    else
	        // 29. Let bestFormat be the result of calling the BestFitFormatMatcher
	        //     abstract operation (defined below) with opt and formats.
	        bestFormat = BestFitFormatMatcher(opt, formats);
	
	    // 30. For each row in Table 3, except the header row, do
	    for (var prop in dateTimeComponents) {
	        if (!hop.call(dateTimeComponents, prop))
	            continue;
	
	        // a. Let prop be the name given in the Property column of the row.
	        // b. Let pDesc be the result of calling the [[GetOwnProperty]] internal method of
	        //    bestFormat with argument prop.
	        // c. If pDesc is not undefined, then
	        if (hop.call(bestFormat, prop)) {
	            var
	            // i. Let p be the result of calling the [[Get]] internal method of bestFormat
	            //    with argument prop.
	                p = bestFormat[prop];
	
	            // ii. Set the [[<prop>]] internal property of dateTimeFormat to p.
	            internal['[['+prop+']]'] = p;
	        }
	    }
	
	    var
	        // Assigned a value below
	        pattern,
	
	    // 31. Let hr12 be the result of calling the GetOption abstract operation with
	    //     arguments options, "hour12", "boolean", undefined, and undefined.
	        hr12 = GetOption(options, 'hour12', 'boolean'/*, undefined, undefined*/);
	
	    // 32. If dateTimeFormat has an internal property [[hour]], then
	    if (internal['[[hour]]']) {
	        // a. If hr12 is undefined, then let hr12 be the result of calling the [[Get]]
	        //    internal method of dataLocaleData with argument "hour12".
	        hr12 = hr12 === undefined ? dataLocaleData.hour12 : hr12;
	
	        // b. Set the [[hour12]] internal property of dateTimeFormat to hr12.
	        internal['[[hour12]]'] = hr12;
	
	        // c. If hr12 is true, then
	        if (hr12 === true) {
	            var
	            // i. Let hourNo0 be the result of calling the [[Get]] internal method of
	            //    dataLocaleData with argument "hourNo0".
	                hourNo0 = dataLocaleData.hourNo0;
	
	            // ii. Set the [[hourNo0]] internal property of dateTimeFormat to hourNo0.
	            internal['[[hourNo0]]'] = hourNo0;
	
	            // iii. Let pattern be the result of calling the [[Get]] internal method of
	            //      bestFormat with argument "pattern12".
	            pattern = bestFormat.pattern12;
	        }
	
	        // d. Else
	        else
	            // i. Let pattern be the result of calling the [[Get]] internal method of
	            //    bestFormat with argument "pattern".
	            pattern = bestFormat.pattern;
	    }
	
	    // 33. Else
	    else
	        // a. Let pattern be the result of calling the [[Get]] internal method of
	        //    bestFormat with argument "pattern".
	        pattern = bestFormat.pattern;
	
	    // 34. Set the [[pattern]] internal property of dateTimeFormat to pattern.
	    internal['[[pattern]]'] = pattern;
	
	    // 35. Set the [[boundFormat]] internal property of dateTimeFormat to undefined.
	    internal['[[boundFormat]]'] = undefined;
	
	    // 36. Set the [[initializedDateTimeFormat]] internal property of dateTimeFormat to
	    //     true.
	    internal['[[initializedDateTimeFormat]]'] = true;
	
	    // In ES3, we need to pre-bind the format() function
	    if (es3)
	        dateTimeFormat.format = GetFormatDateTime.call(dateTimeFormat);
	
	    // Restore the RegExp properties
	    regexpState.exp.test(regexpState.input);
	
	    // Return the newly initialised object
	    return dateTimeFormat;
	}
	
	/**
	 * Several DateTimeFormat algorithms use values from the following table, which provides
	 * property names and allowable values for the components of date and time formats:
	 */
	var dateTimeComponents = {
	         weekday: [ "narrow", "short", "long" ],
	             era: [ "narrow", "short", "long" ],
	            year: [ "2-digit", "numeric" ],
	           month: [ "2-digit", "numeric", "narrow", "short", "long" ],
	             day: [ "2-digit", "numeric" ],
	            hour: [ "2-digit", "numeric" ],
	          minute: [ "2-digit", "numeric" ],
	          second: [ "2-digit", "numeric" ],
	    timeZoneName: [ "short", "long" ]
	};
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeFormats(formats) {
	    if (Object.prototype.toString.call(formats) === '[object Array]') {
	        return formats;
	    }
	    return src$cldr$$.createDateTimeFormats(formats);
	}
	
	/**
	 * When the ToDateTimeOptions abstract operation is called with arguments options,
	 * required, and defaults, the following steps are taken:
	 */
	function ToDateTimeOptions (options, required, defaults) {
	    // 1. If options is undefined, then let options be null, else let options be
	    //    ToObject(options).
	    if (options === undefined)
	        options = null;
	
	    else {
	        // (#12) options needs to be a Record, but it also needs to inherit properties
	        var opt2 = toObject(options);
	        options = new Record();
	
	        for (var k in opt2)
	            options[k] = opt2[k];
	    }
	
	    var
	    // 2. Let create be the standard built-in function object defined in ES5, 15.2.3.5.
	        create = objCreate,
	
	    // 3. Let options be the result of calling the [[Call]] internal method of create with
	    //    undefined as the this value and an argument list containing the single item
	    //    options.
	        options = create(options),
	
	    // 4. Let needDefaults be true.
	        needDefaults = true;
	
	    // 5. If required is "date" or "any", then
	    if (required === 'date' || required === 'any') {
	        // a. For each of the property names "weekday", "year", "month", "day":
	            // i. If the result of calling the [[Get]] internal method of options with the
	            //    property name is not undefined, then let needDefaults be false.
	        if (options.weekday !== undefined || options.year !== undefined
	                || options.month !== undefined || options.day !== undefined)
	            needDefaults = false;
	    }
	
	    // 6. If required is "time" or "any", then
	    if (required === 'time' || required === 'any') {
	        // a. For each of the property names "hour", "minute", "second":
	            // i. If the result of calling the [[Get]] internal method of options with the
	            //    property name is not undefined, then let needDefaults be false.
	        if (options.hour !== undefined || options.minute !== undefined || options.second !== undefined)
	                needDefaults = false;
	    }
	
	    // 7. If needDefaults is true and defaults is either "date" or "all", then
	    if (needDefaults && (defaults === 'date' || defaults === 'all'))
	        // a. For each of the property names "year", "month", "day":
	            // i. Call the [[DefineOwnProperty]] internal method of options with the
	            //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	            //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.year = options.month = options.day = 'numeric';
	
	    // 8. If needDefaults is true and defaults is either "time" or "all", then
	    if (needDefaults && (defaults === 'time' || defaults === 'all'))
	        // a. For each of the property names "hour", "minute", "second":
	            // i. Call the [[DefineOwnProperty]] internal method of options with the
	            //    property name, Property Descriptor {[[Value]]: "numeric", [[Writable]]:
	            //    true, [[Enumerable]]: true, [[Configurable]]: true}, and false.
	        options.hour = options.minute = options.second = 'numeric';
	
	    // 9. Return options.
	    return options;
	}
	
	/**
	 * When the BasicFormatMatcher abstract operation is called with two arguments options and
	 * formats, the following steps are taken:
	 */
	function BasicFormatMatcher (options, formats) {
	    return calculateScore(options, formats);
	}
	
	/**
	 * Calculates score for BestFitFormatMatcher and BasicFormatMatcher.
	 * Abstracted from BasicFormatMatcher section.
	 */
	function calculateScore (options, formats, bestFit) {
	    var
	    // Additional penalty type when bestFit === true
	       diffDataTypePenalty = 8,
	
	    // 1. Let removalPenalty be 120.
	        removalPenalty = 120,
	
	    // 2. Let additionPenalty be 20.
	        additionPenalty = 20,
	
	    // 3. Let longLessPenalty be 8.
	        longLessPenalty = 8,
	
	    // 4. Let longMorePenalty be 6.
	        longMorePenalty = 6,
	
	    // 5. Let shortLessPenalty be 6.
	        shortLessPenalty = 6,
	
	    // 6. Let shortMorePenalty be 3.
	        shortMorePenalty = 3,
	
	    // 7. Let bestScore be -Infinity.
	        bestScore = -Infinity,
	
	    // 8. Let bestFormat be undefined.
	        bestFormat,
	
	    // 9. Let i be 0.
	        i = 0,
	
	    // 10. Let len be the result of calling the [[Get]] internal method of formats with argument "length".
	        len = formats.length;
	
	    // 11. Repeat while i < len:
	    while (i < len) {
	        var
	        // a. Let format be the result of calling the [[Get]] internal method of formats with argument ToString(i).
	            format = formats[i],
	
	        // b. Let score be 0.
	            score = 0;
	
	        // c. For each property shown in Table 3:
	        for (var property in dateTimeComponents) {
	            if (!hop.call(dateTimeComponents, property))
	                continue;
	
	            var
	            // i. Let optionsProp be options.[[<property>]].
	                optionsProp = options['[['+ property +']]'],
	
	            // ii. Let formatPropDesc be the result of calling the [[GetOwnProperty]] internal method of format
	            //     with argument property.
	            // iii. If formatPropDesc is not undefined, then
	            //     1. Let formatProp be the result of calling the [[Get]] internal method of format with argument property.
	                formatProp = hop.call(format, property) ? format[property] : undefined;
	
	            // iv. If optionsProp is undefined and formatProp is not undefined, then decrease score by
	            //     additionPenalty.
	            if (optionsProp === undefined && formatProp !== undefined)
	                score -= additionPenalty;
	
	            // v. Else if optionsProp is not undefined and formatProp is undefined, then decrease score by
	            //    removalPenalty.
	            else if (optionsProp !== undefined && formatProp === undefined)
	                score -= removalPenalty;
	
	            // vi. Else
	            else {
	                var
	                // 1. Let values be the array ["2-digit", "numeric", "narrow", "short",
	                //    "long"].
	                    values = [ '2-digit', 'numeric', 'narrow', 'short', 'long' ],
	
	                // 2. Let optionsPropIndex be the index of optionsProp within values.
	                    optionsPropIndex = arrIndexOf.call(values, optionsProp),
	
	                // 3. Let formatPropIndex be the index of formatProp within values.
	                    formatPropIndex = arrIndexOf.call(values, formatProp),
	
	                // 4. Let delta be max(min(formatPropIndex - optionsPropIndex, 2), -2).
	                    delta = Math.max(Math.min(formatPropIndex - optionsPropIndex, 2), -2);
	
	                // When the bestFit argument is true, subtract additional penalty where data types are not the same
	                if (bestFit && (
	                    ((optionsProp === 'numeric' || optionsProp === '2-digit') && (formatProp !== 'numeric' && formatProp !== '2-digit'))
	                 || ((optionsProp !== 'numeric' && optionsProp !== '2-digit') && (formatProp === '2-digit' || formatProp === 'numeric'))
	                ))
	                    score -= diffDataTypePenalty;
	
	                // 5. If delta = 2, decrease score by longMorePenalty.
	                if (delta === 2)
	                    score -= longMorePenalty;
	
	                // 6. Else if delta = 1, decrease score by shortMorePenalty.
	                else if (delta === 1)
	                    score -= shortMorePenalty;
	
	                // 7. Else if delta = -1, decrease score by shortLessPenalty.
	                else if (delta === -1)
	                    score -= shortLessPenalty;
	
	                // 8. Else if delta = -2, decrease score by longLessPenalty.
	                else if (delta === -2)
	                    score -= longLessPenalty;
	            }
	        }
	
	        // d. If score > bestScore, then
	        if (score > bestScore) {
	            // i. Let bestScore be score.
	            bestScore = score;
	
	            // ii. Let bestFormat be format.
	            bestFormat = format;
	        }
	
	        // e. Increase i by 1.
	        i++;
	    }
	
	    // 12. Return bestFormat.
	    return bestFormat;
	}
	
	/**
	 * When the BestFitFormatMatcher abstract operation is called with two arguments options
	 * and formats, it performs implementation dependent steps, which should return a set of
	 * component representations that a typical user of the selected locale would perceive as
	 * at least as good as the one returned by BasicFormatMatcher.
	 *
	 * This polyfill defines the algorithm to be the same as BasicFormatMatcher,
	 * with the addition of bonus points awarded where the requested format is of
	 * the same data type as the potentially matching format.
	 *
	 * For example,
	 *
	 *     { month: 'numeric', day: 'numeric' }
	 *
	 * should match
	 *
	 *     { month: '2-digit', day: '2-digit' }
	 *
	 * rather than
	 *
	 *     { month: 'short', day: 'numeric' }
	 *
	 * This makes sense because a user requesting a formatted date with numeric parts would
	 * not expect to see the returned format containing narrow, short or long part names
	 */
	function BestFitFormatMatcher (options, formats) {
	    return calculateScore(options, formats, true);
	}
	
	/* 12.2.3 */internals.DateTimeFormat = {
	    '[[availableLocales]]': [],
	    '[[relevantExtensionKeys]]': ['ca', 'nu'],
	    '[[localeData]]': {}
	};
	
	/**
	 * When the supportedLocalesOf method of Intl.DateTimeFormat is called, the
	 * following steps are taken:
	 */
	/* 12.2.2 */defineProperty(Intl.DateTimeFormat, 'supportedLocalesOf', {
	    configurable: true,
	    writable: true,
	    value: fnBind.call(supportedLocalesOf, internals.DateTimeFormat)
	});
	
	/**
	 * This named accessor property returns a function that formats a number
	 * according to the effective locale and the formatting options of this
	 * DateTimeFormat object.
	 */
	/* 12.3.2 */defineProperty(Intl.DateTimeFormat.prototype, 'format', {
	    configurable: true,
	    get: GetFormatDateTime
	});
	
	function GetFormatDateTime() {
	    var internal = this != null && typeof this === 'object' && getInternalProperties(this);
	
	    // Satisfy test 12.3_b
	    if (!internal || !internal['[[initializedDateTimeFormat]]'])
	        throw new TypeError('`this` value for format() is not an initialized Intl.DateTimeFormat object.');
	
	    // The value of the [[Get]] attribute is a function that takes the following
	    // steps:
	
	    // 1. If the [[boundFormat]] internal property of this DateTimeFormat object
	    //    is undefined, then:
	    if (internal['[[boundFormat]]'] === undefined) {
	        var
	        // a. Let F be a Function object, with internal properties set as
	        //    specified for built-in functions in ES5, 15, or successor, and the
	        //    length property set to 0, that takes the argument date and
	        //    performs the following steps:
	            F = function () {
	                //   i. If date is not provided or is undefined, then let x be the
	                //      result as if by the expression Date.now() where Date.now is
	                //      the standard built-in function defined in ES5, 15.9.4.4.
	                //  ii. Else let x be ToNumber(date).
	                // iii. Return the result of calling the FormatDateTime abstract
	                //      operation (defined below) with arguments this and x.
	                var x = Number(arguments.length === 0 ? Date.now() : arguments[0]);
	                return FormatDateTime(this, x);
	            },
	        // b. Let bind be the standard built-in function object defined in ES5,
	        //    15.3.4.5.
	        // c. Let bf be the result of calling the [[Call]] internal method of
	        //    bind with F as the this value and an argument list containing
	        //    the single item this.
	            bf = fnBind.call(F, this);
	        // d. Set the [[boundFormat]] internal property of this NumberFormat
	        //    object to bf.
	        internal['[[boundFormat]]'] = bf;
	    }
	    // Return the value of the [[boundFormat]] internal property of this
	    // NumberFormat object.
	    return internal['[[boundFormat]]'];
	}
	
	/**
	 * When the FormatDateTime abstract operation is called with arguments dateTimeFormat
	 * (which must be an object initialized as a DateTimeFormat) and x (which must be a Number
	 * value), it returns a String value representing x (interpreted as a time value as
	 * specified in ES5, 15.9.1.1) according to the effective locale and the formatting
	 * options of dateTimeFormat.
	 */
	function FormatDateTime(dateTimeFormat, x) {
	    // 1. If x is not a finite Number, then throw a RangeError exception.
	    if (!isFinite(x))
	        throw new RangeError('Invalid valid date passed to format');
	
	    var
	        internal = dateTimeFormat.__getInternalProperties(secret),
	
	    // Creating restore point for properties on the RegExp object... please wait
	        regexpState = createRegExpRestore(),
	
	    // 2. Let locale be the value of the [[locale]] internal property of dateTimeFormat.
	        locale = internal['[[locale]]'],
	
	    // 3. Let nf be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {useGrouping: false}) where
	    // Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	        nf = new Intl.NumberFormat([locale], {useGrouping: false}),
	
	    // 4. Let nf2 be the result of creating a new NumberFormat object as if by the
	    // expression new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping:
	    // false}) where Intl.NumberFormat is the standard built-in constructor defined in
	    // 11.1.3.
	        nf2 = new Intl.NumberFormat([locale], {minimumIntegerDigits: 2, useGrouping: false}),
	
	    // 5. Let tm be the result of calling the ToLocalTime abstract operation (defined
	    // below) with x, the value of the [[calendar]] internal property of dateTimeFormat,
	    // and the value of the [[timeZone]] internal property of dateTimeFormat.
	        tm = ToLocalTime(x, internal['[[calendar]]'], internal['[[timeZone]]']),
	
	    // 6. Let result be the value of the [[pattern]] internal property of dateTimeFormat.
	        result = internal['[[pattern]]'],
	
	    // Need the locale minus any extensions
	        dataLocale = internal['[[dataLocale]]'],
	
	    // Need the calendar data from CLDR
	        localeData = internals.DateTimeFormat['[[localeData]]'][dataLocale].calendars,
	        ca = internal['[[calendar]]'];
	
	    // 7. For each row of Table 3, except the header row, do:
	    for (var p in dateTimeComponents) {
	        // a. If dateTimeFormat has an internal property with the name given in the
	        //    Property column of the row, then:
	        if (hop.call(internal, '[['+ p +']]')) {
	            var
	            // Assigned values below
	                pm, fv,
	
	            //   i. Let p be the name given in the Property column of the row.
	            //  ii. Let f be the value of the [[<p>]] internal property of dateTimeFormat.
	                f = internal['[['+ p +']]'],
	
	            // iii. Let v be the value of tm.[[<p>]].
	                v = tm['[['+ p +']]'];
	
	            //  iv. If p is "year" and v ≤ 0, then let v be 1 - v.
	            if (p === 'year' && v <= 0)
	                v = 1 - v;
	
	            //   v. If p is "month", then increase v by 1.
	            else if (p === 'month')
	                v++;
	
	            //  vi. If p is "hour" and the value of the [[hour12]] internal property of
	            //      dateTimeFormat is true, then
	            else if (p === 'hour' && internal['[[hour12]]'] === true) {
	                // 1. Let v be v modulo 12.
	                v = v % 12;
	
	                // 2. If v is equal to the value of tm.[[<p>]], then let pm be false; else
	                //    let pm be true.
	                pm = v !== tm['[['+ p +']]'];
	
	                // 3. If v is 0 and the value of the [[hourNo0]] internal property of
	                //    dateTimeFormat is true, then let v be 12.
	                if (v === 0 && internal['[[hourNo0]]'] === true)
	                    v = 12;
	            }
	
	            // vii. If f is "numeric", then
	            if (f === 'numeric')
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    (defined in 11.3.2) with arguments nf and v.
	                fv = FormatNumber(nf, v);
	
	            // viii. Else if f is "2-digit", then
	            else if (f === '2-digit') {
	                // 1. Let fv be the result of calling the FormatNumber abstract operation
	                //    with arguments nf2 and v.
	                fv = FormatNumber(nf2, v);
	
	                // 2. If the length of fv is greater than 2, let fv be the substring of fv
	                //    containing the last two characters.
	                if (fv.length > 2)
	                    fv = fv.slice(-2);
	            }
	
	            // ix. Else if f is "narrow", "short", or "long", then let fv be a String
	            //     value representing f in the desired form; the String value depends upon
	            //     the implementation and the effective locale and calendar of
	            //     dateTimeFormat. If p is "month", then the String value may also depend
	            //     on whether dateTimeFormat has a [[day]] internal property. If p is
	            //     "timeZoneName", then the String value may also depend on the value of
	            //     the [[inDST]] field of tm.
	            else if (f in dateWidths) {
	                switch (p) {
	                    case 'month':
	                        fv = resolveDateString(localeData, ca, 'months', f, tm['[['+ p +']]']);
	                        break;
	
	                    case 'weekday':
	                        try {
	                            fv = resolveDateString(localeData, ca, 'days', f, tm['[['+ p +']]']);
	                            // fv = resolveDateString(ca.days, f)[tm['[['+ p +']]']];
	                        } catch (e) {
	                            throw new Error('Could not find weekday data for locale '+locale);
	                        }
	                        break;
	
	                    case 'timeZoneName':
	                        fv = ''; // TODO
	                        break;
	
	                    // TODO: Era
	                    default:
	                        fv = tm['[['+ p +']]'];
	                }
	            }
	
	            // x. Replace the substring of result that consists of "{", p, and "}", with
	            //    fv.
	            result = result.replace('{'+ p +'}', fv);
	        }
	    }
	    // 8. If dateTimeFormat has an internal property [[hour12]] whose value is true, then
	    if (internal['[[hour12]]'] === true) {
	        // a. If pm is true, then let fv be an implementation and locale dependent String
	        //    value representing “post meridiem”; else let fv be an implementation and
	        //    locale dependent String value representing “ante meridiem”.
	        fv = resolveDateString(localeData, ca, 'dayPeriods', pm ? 'pm' : 'am');
	
	        // b. Replace the substring of result that consists of "{ampm}", with fv.
	        result = result.replace('{ampm}', fv);
	    }
	
	    // Restore properties of the RegExp object
	    regexpState.exp.test(regexpState.input);
	
	    // 9. Return result.
	    return result;
	}
	
	/**
	 * When the ToLocalTime abstract operation is called with arguments date, calendar, and
	 * timeZone, the following steps are taken:
	 */
	function ToLocalTime(date, calendar, timeZone) {
	    // 1. Apply calendrical calculations on date for the given calendar and time zone to
	    //    produce weekday, era, year, month, day, hour, minute, second, and inDST values.
	    //    The calculations should use best available information about the specified
	    //    calendar and time zone. If the calendar is "gregory", then the calculations must
	    //    match the algorithms specified in ES5, 15.9.1, except that calculations are not
	    //    bound by the restrictions on the use of best available information on time zones
	    //    for local time zone adjustment and daylight saving time adjustment imposed by
	    //    ES5, 15.9.1.7 and 15.9.1.8.
	    // ###TODO###
	    var d = new Date(date),
	        m = 'get' + (timeZone || '');
	
	    // 2. Return a Record with fields [[weekday]], [[era]], [[year]], [[month]], [[day]],
	    //    [[hour]], [[minute]], [[second]], and [[inDST]], each with the corresponding
	    //    calculated value.
	    return new Record({
	        '[[weekday]]': d[m + 'Day'](),
	        '[[era]]'    : +(d[m + 'FullYear']() >= 0),
	        '[[year]]'   : d[m + 'FullYear'](),
	        '[[month]]'  : d[m + 'Month'](),
	        '[[day]]'    : d[m + 'Date'](),
	        '[[hour]]'   : d[m + 'Hours'](),
	        '[[minute]]' : d[m + 'Minutes'](),
	        '[[second]]' : d[m + 'Seconds'](),
	        '[[inDST]]'  : false // ###TODO###
	    });
	}
	
	/**
	 * The function returns a new object whose properties and attributes are set as if
	 * constructed by an object literal assigning to each of the following properties the
	 * value of the corresponding internal property of this DateTimeFormat object (see 12.4):
	 * locale, calendar, numberingSystem, timeZone, hour12, weekday, era, year, month, day,
	 * hour, minute, second, and timeZoneName. Properties whose corresponding internal
	 * properties are not present are not assigned.
	 */
	/* 12.3.3 */defineProperty(Intl.DateTimeFormat.prototype, 'resolvedOptions', {
	    writable: true,
	    configurable: true,
	    value: function () {
	        var prop,
	            descs = new Record(),
	            props = [
	                'locale', 'calendar', 'numberingSystem', 'timeZone', 'hour12', 'weekday',
	                'era', 'year', 'month', 'day', 'hour', 'minute', 'second', 'timeZoneName'
	            ],
	            internal = this != null && typeof this === 'object' && getInternalProperties(this);
	
	        // Satisfy test 12.3_b
	        if (!internal || !internal['[[initializedDateTimeFormat]]'])
	            throw new TypeError('`this` value for resolvedOptions() is not an initialized Intl.DateTimeFormat object.');
	
	        for (var i = 0, max = props.length; i < max; i++) {
	            if (hop.call(internal, prop = '[[' + props[i] + ']]'))
	                descs[props[i]] = { value: internal[prop], writable: true, configurable: true, enumerable: true };
	        }
	
	        return objCreate({}, descs);
	    }
	});
	
	// Sect 13 Locale Sensitive Functions of the ECMAScript Language Specification
	// ===========================================================================
	
	var ls = Intl.__localeSensitiveProtos = {
	    Number: {},
	    Date:   {}
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.2.1 */ls.Number.toLocaleString = function () {
	    // Satisfy test 13.2.1_1
	    if (Object.prototype.toString.call(this) !== '[object Number]')
	        throw new TypeError('`this` value must be a number for Number.prototype.toLocaleString()');
	
	    // 1. Let x be this Number value (as defined in ES5, 15.7.4).
	    // 2. If locales is not provided, then let locales be undefined.
	    // 3. If options is not provided, then let options be undefined.
	    // 4. Let numberFormat be the result of creating a new object as if by the
	    //    expression new Intl.NumberFormat(locales, options) where
	    //    Intl.NumberFormat is the standard built-in constructor defined in 11.1.3.
	    // 5. Return the result of calling the FormatNumber abstract operation
	    //    (defined in 11.3.2) with arguments numberFormat and x.
	    return FormatNumber(new NumberFormatConstructor(arguments[0], arguments[1]), this);
	};
	
	/**
	 * When the toLocaleString method is called with optional arguments locales and options,
	 * the following steps are taken:
	 */
	/* 13.3.1 */ls.Date.toLocaleString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]')
	        throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleString()');
	
	    var
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	        x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x))
	        return 'Invalid Date';
	
	    var
	    // 3. If locales is not provided, then let locales be undefined.
	        locales = arguments[0],
	
	    // 4. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "any", and "all".
	        options = ToDateTimeOptions(options, 'any', 'all'),
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	        dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleDateString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.2 */ls.Date.toLocaleDateString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]')
	        throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleDateString()');
	
	    var
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	        x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x))
	        return 'Invalid Date';
	
	    var
	    // 3. If locales is not provided, then let locales be undefined.
	        locales = arguments[0],
	
	    // 4. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "date", and "date".
	        options = ToDateTimeOptions(options, 'date', 'date'),
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	        dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	/**
	 * When the toLocaleTimeString method is called with optional arguments locales and
	 * options, the following steps are taken:
	 */
	/* 13.3.3 */ls.Date.toLocaleTimeString = function () {
	    // Satisfy test 13.3.0_1
	    if (Object.prototype.toString.call(this) !== '[object Date]')
	        throw new TypeError('`this` value must be a Date instance for Date.prototype.toLocaleTimeString()');
	
	    var
	    // 1. Let x be this time value (as defined in ES5, 15.9.5).
	        x = +this;
	
	    // 2. If x is NaN, then return "Invalid Date".
	    if (isNaN(x))
	        return 'Invalid Date';
	
	    var
	    // 3. If locales is not provided, then let locales be undefined.
	        locales = arguments[0],
	
	    // 4. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	    // 5. Let options be the result of calling the ToDateTimeOptions abstract
	    //    operation (defined in 12.1.1) with arguments options, "time", and "time".
	        options = ToDateTimeOptions(options, 'time', 'time'),
	
	    // 6. Let dateTimeFormat be the result of creating a new object as if by the
	    //    expression new Intl.DateTimeFormat(locales, options) where
	    //    Intl.DateTimeFormat is the standard built-in constructor defined in 12.1.3.
	        dateTimeFormat = new DateTimeFormatConstructor(locales, options);
	
	    // 7. Return the result of calling the FormatDateTime abstract operation (defined
	    //    in 12.3.2) with arguments dateTimeFormat and x.
	    return FormatDateTime(dateTimeFormat, x);
	};
	
	defineProperty(Intl, '__applyLocaleSensitivePrototypes', {
	    writable: true,
	    configurable: true,
	    value: function () {
	        defineProperty(Number.prototype, 'toLocaleString', { writable: true, configurable: true, value: ls.Number.toLocaleString });
	
	        for (var k in ls.Date) {
	            if (hop.call(ls.Date, k))
	                defineProperty(Date.prototype, k, { writable: true, configurable: true, value: ls.Date[k] });
	        }
	    }
	});
	
	/**
	 * Can't really ship a single script with data for hundreds of locales, so we provide
	 * this __addLocaleData method as a means for the developer to add the data on an
	 * as-needed basis
	 */
	defineProperty(Intl, '__addLocaleData', {
	    value: function (data) {
	        if (!IsStructurallyValidLanguageTag(data.locale))
	            throw new Error("Object passed doesn't identify itself with a valid language tag");
	
	        addLocaleData(data, data.locale);
	    }
	});
	
	function addLocaleData (data, tag) {
	    // Both NumberFormat and DateTimeFormat require number data, so throw if it isn't present
	    if (!data.number)
	        throw new Error("Object passed doesn't contain locale data for Intl.NumberFormat");
	
	    var locale,
	        locales = [ tag ],
	        parts   = tag.split('-');
	
	    // Create fallbacks for locale data with scripts, e.g. Latn, Hans, Vaii, etc
	    if (parts.length > 2 && parts[1].length == 4)
	        arrPush.call(locales, parts[0] + '-' + parts[2]);
	
	    while (locale = arrShift.call(locales)) {
	        // Add to NumberFormat internal properties as per 11.2.3
	        arrPush.call(internals.NumberFormat['[[availableLocales]]'], locale);
	        internals.NumberFormat['[[localeData]]'][locale] = data.number;
	
	        // ...and DateTimeFormat internal properties as per 12.2.3
	        if (data.date) {
	            data.date.nu = data.number.nu;
	            arrPush.call(internals.DateTimeFormat['[[availableLocales]]'], locale);
	            internals.DateTimeFormat['[[localeData]]'][locale] = data.date;
	        }
	    }
	
	    // If this is the first set of locale data added, make it the default
	    if (defaultLocale === undefined)
	        defaultLocale = tag;
	
	    // 11.3 (the NumberFormat prototype object is an Intl.NumberFormat instance)
	    if (!numberFormatProtoInitialised) {
	        InitializeNumberFormat(Intl.NumberFormat.prototype);
	        numberFormatProtoInitialised = true;
	    }
	
	    // 11.3 (the NumberFormat prototype object is an Intl.NumberFormat instance)
	    if (data.date && !dateTimeFormatProtoInitialised) {
	        InitializeDateTimeFormat(Intl.DateTimeFormat.prototype);
	        dateTimeFormatProtoInitialised = true;
	    }
	}
	
	// Helper functions
	// ================
	
	/**
	 * A function to deal with the inaccuracy of calculating log10 in pre-ES6
	 * JavaScript environments. Math.log(num) / Math.LN10 was responsible for
	 * causing issue #62.
	 */
	function log10Floor (n) {
	    // ES6 provides the more accurate Math.log10
	    if (typeof Math.log10 === 'function')
	        return Math.floor(Math.log10(n));
	
	    var x = Math.round(Math.log(n) * Math.LOG10E);
	    return x - (Number('1e' + x) > n);
	}
	
	/**
	 * A merge of the Intl.{Constructor}.supportedLocalesOf functions
	 * To make life easier, the function should be bound to the constructor's internal
	 * properties object.
	 */
	function supportedLocalesOf(locales) {
	    /*jshint validthis:true */
	
	    // Bound functions only have the `this` value altered if being used as a constructor,
	    // this lets us imitate a native function that has no constructor
	    if (!hop.call(this, '[[availableLocales]]'))
	        throw new TypeError('supportedLocalesOf() is not a constructor');
	
	    var
	    // Create an object whose props can be used to restore the values of RegExp props
	        regexpState = createRegExpRestore(),
	
	    // 1. If options is not provided, then let options be undefined.
	        options = arguments[1],
	
	    // 2. Let availableLocales be the value of the [[availableLocales]] internal
	    //    property of the standard built-in object that is the initial value of
	    //    Intl.NumberFormat.
	
	        availableLocales = this['[[availableLocales]]'],
	
	    // 3. Let requestedLocales be the result of calling the CanonicalizeLocaleList
	    //    abstract operation (defined in 9.2.1) with argument locales.
	        requestedLocales = CanonicalizeLocaleList(locales);
	
	    // Restore the RegExp properties
	    regexpState.exp.test(regexpState.input);
	
	    // 4. Return the result of calling the SupportedLocales abstract operation
	    //    (defined in 9.2.8) with arguments availableLocales, requestedLocales,
	    //    and options.
	    return SupportedLocales(availableLocales, requestedLocales, options);
	}
	
	/**
	 * Returns a string for a date component, resolved using multiple inheritance as specified
	 * as specified in the Unicode Technical Standard 35.
	 */
	function resolveDateString(data, ca, component, width, key) {
	    // From http://www.unicode.org/reports/tr35/tr35.html#Multiple_Inheritance:
	    // 'In clearly specified instances, resources may inherit from within the same locale.
	    //  For example, ... the Buddhist calendar inherits from the Gregorian calendar.'
	    var obj = data[ca] && data[ca][component]
	                ? data[ca][component]
	                : data.gregory[component],
	
	        // "sideways" inheritance resolves strings when a key doesn't exist
	        alts = {
	            narrow: ['short', 'long'],
	            short:  ['long', 'narrow'],
	            long:   ['short', 'narrow']
	        },
	
	        //
	        resolved = hop.call(obj, width)
	                  ? obj[width]
	                  : hop.call(obj, alts[width][0])
	                      ? obj[alts[width][0]]
	                      : obj[alts[width][1]];
	
	    // `key` wouldn't be specified for components 'dayPeriods'
	    return key != null ? resolved[key] : resolved;
	}
	
	/**
	 * A map that doesn't contain Object in its prototype chain
	 */
	Record.prototype = objCreate(null);
	function Record (obj) {
	    // Copy only own properties over unless this object is already a Record instance
	    for (var k in obj) {
	        if (obj instanceof Record || hop.call(obj, k))
	            defineProperty(this, k, { value: obj[k], enumerable: true, writable: true, configurable: true });
	    }
	}
	
	/**
	 * An ordered list
	 */
	List.prototype = objCreate(null);
	function List() {
	    defineProperty(this, 'length', { writable:true, value: 0 });
	
	    if (arguments.length)
	        arrPush.apply(this, arrSlice.call(arguments));
	}
	
	/**
	 * Constructs a regular expression to restore tainted RegExp properties
	 */
	function createRegExpRestore () {
	    var esc = /[.?*+^$[\]\\(){}|-]/g,
	        lm  = RegExp.lastMatch || '',
	        ml  = RegExp.multiline ? 'm' : '',
	        ret = { input: RegExp.input },
	        reg = new List(),
	        has = false,
	        cap = {};
	
	    // Create a snapshot of all the 'captured' properties
	    for (var i = 1; i <= 9; i++)
	        has = (cap['$'+i] = RegExp['$'+i]) || has;
	
	    // Now we've snapshotted some properties, escape the lastMatch string
	    lm = lm.replace(esc, '\\$&');
	
	    // If any of the captured strings were non-empty, iterate over them all
	    if (has) {
	        for (var i = 1; i <= 9; i++) {
	            var m = cap['$'+i];
	
	            // If it's empty, add an empty capturing group
	            if (!m)
	                lm = '()' + lm;
	
	            // Else find the string in lm and escape & wrap it to capture it
	            else {
	                m = m.replace(esc, '\\$&');
	                lm = lm.replace(m, '(' + m + ')');
	            }
	
	            // Push it to the reg and chop lm to make sure further groups come after
	            arrPush.call(reg, lm.slice(0, lm.indexOf('(') + 1));
	            lm = lm.slice(lm.indexOf('(') + 1);
	        }
	    }
	
	    // Create the regular expression that will reconstruct the RegExp properties
	    ret.exp = new RegExp(arrJoin.call(reg, '') + lm, ml);
	
	    return ret;
	}
	
	/**
	 * Convert only a-z to uppercase as per section 6.1 of the spec
	 */
	function toLatinUpperCase (str) {
	    var i = str.length;
	
	    while (i--) {
	        var ch = str.charAt(i);
	
	        if (ch >= "a" && ch <= "z")
	            str = str.slice(0, i) + ch.toUpperCase() + str.slice(i+1);
	    }
	
	    return str;
	}
	
	/**
	 * Mimics ES5's abstract ToObject() function
	 */
	function toObject (arg) {
	    if (arg == null)
	        throw new TypeError('Cannot convert null or undefined to object');
	
	    return Object(arg);
	}
	
	/**
	 * Returns "internal" properties for an object
	 */
	function getInternalProperties (obj) {
	    if (hop.call(obj, '__getInternalProperties'))
	        return obj.__getInternalProperties(secret);
	    else
	        return objCreate(null);
	}
	
	var src$core$$default = Intl;
	
	//# sourceMappingURL=core.js.map

/***/ }),
/* 747 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.seal(Object.defineProperties(exports, {
	        expBCP47Syntax: {
	                get: function() {
	                        return expBCP47Syntax;
	                },
	
	                enumerable: true
	        },
	
	        expVariantDupes: {
	                get: function() {
	                        return expVariantDupes;
	                },
	
	                enumerable: true
	        },
	
	        expSingletonDupes: {
	                get: function() {
	                        return expSingletonDupes;
	                },
	
	                enumerable: true
	        },
	
	        expExtSequences: {
	                get: function() {
	                        return expExtSequences;
	                },
	
	                enumerable: true
	        }
	}));
	
	var
	    // extlang       = 3ALPHA              ; selected ISO 639 codes
	    //                 *2("-" 3ALPHA)      ; permanently reserved
	    extlang = '[a-z]{3}(?:-[a-z]{3}){0,2}',
	
	    // language      = 2*3ALPHA            ; shortest ISO 639 code
	    //                 ["-" extlang]       ; sometimes followed by
	    //                                     ; extended language subtags
	    //               / 4ALPHA              ; or reserved for future use
	    //               / 5*8ALPHA            ; or registered language subtag
	    language = '(?:[a-z]{2,3}(?:-' + extlang + ')?|[a-z]{4}|[a-z]{5,8})',
	
	    // script        = 4ALPHA              ; ISO 15924 code
	    script = '[a-z]{4}',
	
	    // region        = 2ALPHA              ; ISO 3166-1 code
	    //               / 3DIGIT              ; UN M.49 code
	    region = '(?:[a-z]{2}|\\d{3})',
	
	    // variant       = 5*8alphanum         ; registered variants
	    //               / (DIGIT 3alphanum)
	    variant = '(?:[a-z0-9]{5,8}|\\d[a-z0-9]{3})',
	
	    //                                     ; Single alphanumerics
	    //                                     ; "x" reserved for private use
	    // singleton     = DIGIT               ; 0 - 9
	    //               / %x41-57             ; A - W
	    //               / %x59-5A             ; Y - Z
	    //               / %x61-77             ; a - w
	    //               / %x79-7A             ; y - z
	    singleton = '[0-9a-wy-z]',
	
	    // extension     = singleton 1*("-" (2*8alphanum))
	    extension = singleton + '(?:-[a-z0-9]{2,8})+',
	
	    // privateuse    = "x" 1*("-" (1*8alphanum))
	    privateuse = 'x(?:-[a-z0-9]{1,8})+',
	
	    // irregular     = "en-GB-oed"         ; irregular tags do not match
	    //               / "i-ami"             ; the 'langtag' production and
	    //               / "i-bnn"             ; would not otherwise be
	    //               / "i-default"         ; considered 'well-formed'
	    //               / "i-enochian"        ; These tags are all valid,
	    //               / "i-hak"             ; but most are deprecated
	    //               / "i-klingon"         ; in favor of more modern
	    //               / "i-lux"             ; subtags or subtag
	    //               / "i-mingo"           ; combination
	    //               / "i-navajo"
	    //               / "i-pwn"
	    //               / "i-tao"
	    //               / "i-tay"
	    //               / "i-tsu"
	    //               / "sgn-BE-FR"
	    //               / "sgn-BE-NL"
	    //               / "sgn-CH-DE"
	    irregular = '(?:en-GB-oed'
	              + '|i-(?:ami|bnn|default|enochian|hak|klingon|lux|mingo|navajo|pwn|tao|tay|tsu)'
	              + '|sgn-(?:BE-FR|BE-NL|CH-DE))',
	
	    // regular       = "art-lojban"        ; these tags match the 'langtag'
	    //               / "cel-gaulish"       ; production, but their subtags
	    //               / "no-bok"            ; are not extended language
	    //               / "no-nyn"            ; or variant subtags: their meaning
	    //               / "zh-guoyu"          ; is defined by their registration
	    //               / "zh-hakka"          ; and all of these are deprecated
	    //               / "zh-min"            ; in favor of a more modern
	    //               / "zh-min-nan"        ; subtag or sequence of subtags
	    //               / "zh-xiang"
	    regular = '(?:art-lojban|cel-gaulish|no-bok|no-nyn'
	            + '|zh-(?:guoyu|hakka|min|min-nan|xiang))',
	
	    // grandfathered = irregular           ; non-redundant tags registered
	    //               / regular             ; during the RFC 3066 era
	    grandfathered = '(?:' + irregular + '|' + regular + ')',
	
	    // langtag       = language
	    //                 ["-" script]
	    //                 ["-" region]
	    //                 *("-" variant)
	    //                 *("-" extension)
	    //                 ["-" privateuse]
	    langtag = language + '(?:-' + script + ')?(?:-' + region + ')?(?:-'
	            + variant + ')*(?:-' + extension + ')*(?:-' + privateuse + ')?';
	
	var expBCP47Syntax = RegExp('^(?:'+langtag+'|'+privateuse+'|'+grandfathered+')$', 'i');
	
	var expVariantDupes = RegExp('^(?!x).*?-('+variant+')-(?:\\w{4,8}-(?!x-))*\\1\\b', 'i');
	
	var expSingletonDupes = RegExp('^(?!x).*?-('+singleton+')-(?:\\w+-(?!x-))*\\1\\b', 'i');
	
	var expExtSequences = RegExp('-'+extension, 'ig');
	
	//# sourceMappingURL=exp.js.map

/***/ }),
/* 748 */
/***/ (function(module, exports) {

	(function(addLocaleData){
	var a=["gregory","buddhist","chinese","coptic","dangi","ethioaa","ethiopic","generic","hebrew","indian","islamic","islamicc","japanese","persian","roc","{1} {0}","ccc","E HH:mm","E HH:mm:ss","d, E","E h:mm a","E h:mm:ss a","G y","G y MMM","G y MMM d, E","G y MMM d","HH","HH:mm","HH:mm:ss","L","MM-dd, E","LLL","MMM d, E","MMM d","MM-dd","d","h a","h:mm a","h:mm:ss a","mm:ss","y","y-MM","y-MM-dd, E","y MMM","y MMM d, E","y MMM d","y-MM-dd","y QQQ","y QQQQ","EEEE, MMMM dd, y","dd MMMM y","dd-MMM-y","dd/MM/yy","h:mm:ss a zzzz","h:mm:ss a z","Q","N","C","A","W","D","X","K","Qun","Nah","Cig","Agd","Cax","Qas","Qad","Leq","Way","Dit","Xim","Kax","Qunxa Garablu","Kudo","Ciggilta Kudo","Agda Baxis","Caxah Alsa","Qasa Dirri","Qado Dirri","Leqeeni","Waysu","Diteli","Ximoli","Kaxxa Garablu","E","T","G","S","Aca","Etl","Tal","Arb","Kam","Gum","Sab","Acaada","Etleeni","Talaata","Arbaqa","Kamiisi","Gumqata","Sabti","BE","saaku","carra","1","2","3","4","5","6","7","8","9","10","11","12","M01","M02","M03","M04","M05","M06","M07","M08","M09","M10","M11","M12","13","Tout","Baba","Hator","Kiahk","Toba","Amshir","Baramhat","Baramouda","Bashans","Paona","Epep","Mesra","Nasie","ERA0","ERA1","Meskerem","Tekemt","Hedar","Tahsas","Ter","Yekatit","Megabit","Miazia","Genbot","Sene","Hamle","Nehasse","Pagumen","Yaasuusuk Duma","Yaasuusuk Wadir","BCE","CE","Tishri","Heshvan","Kislev","Tevet","Shevat","Adar I","Adar","Nisan","Iyar","Sivan","Tamuz","Av","Elul","Adar II","AM","Chaitra","Vaisakha","Jyaistha","Asadha","Sravana","Bhadra","Asvina","Kartika","Agrahayana","Pausa","Magha","Phalguna","Saka","Muh.","Saf.","Rab. I","Rab. II","Jum. I","Jum. II","Raj.","Sha.","Ram.","Shaw.","Dhuʻl-Q.","Dhuʻl-H.","Muharram","Safar","Rabiʻ I","Rabiʻ II","Jumada I","Jumada II","Rajab","Shaʻban","Ramadan","Shawwal","Dhuʻl-Qiʻdah","Dhuʻl-Hijjah","AH","Taika (645-650)","Hakuchi (650-671)","Hakuhō (672-686)","Shuchō (686-701)","Taihō (701-704)","Keiun (704-708)","Wadō (708-715)","Reiki (715-717)","Yōrō (717-724)","Jinki (724-729)","Tempyō (729-749)","Tempyō-kampō (749-749)","Tempyō-shōhō (749-757)","Tempyō-hōji (757-765)","Temphō-jingo (765-767)","Jingo-keiun (767-770)","Hōki (770-780)","Ten-ō (781-782)","Enryaku (782-806)","Daidō (806-810)","Kōnin (810-824)","Tenchō (824-834)","Jōwa (834-848)","Kajō (848-851)","Ninju (851-854)","Saiko (854-857)","Tennan (857-859)","Jōgan (859-877)","Genkei (877-885)","Ninna (885-889)","Kampyō (889-898)","Shōtai (898-901)","Engi (901-923)","Enchō (923-931)","Shōhei (931-938)","Tengyō (938-947)","Tenryaku (947-957)","Tentoku (957-961)","Ōwa (961-964)","Kōhō (964-968)","Anna (968-970)","Tenroku (970-973)","Ten-en (973-976)","Jōgen (976-978)","Tengen (978-983)","Eikan (983-985)","Kanna (985-987)","Ei-en (987-989)","Eiso (989-990)","Shōryaku (990-995)","Chōtoku (995-999)","Chōhō (999-1004)","Kankō (1004-1012)","Chōwa (1012-1017)","Kannin (1017-1021)","Jian (1021-1024)","Manju (1024-1028)","Chōgen (1028-1037)","Chōryaku (1037-1040)","Chōkyū (1040-1044)","Kantoku (1044-1046)","Eishō (1046-1053)","Tengi (1053-1058)","Kōhei (1058-1065)","Jiryaku (1065-1069)","Enkyū (1069-1074)","Shōho (1074-1077)","Shōryaku (1077-1081)","Eiho (1081-1084)","Ōtoku (1084-1087)","Kanji (1087-1094)","Kaho (1094-1096)","Eichō (1096-1097)","Shōtoku (1097-1099)","Kōwa (1099-1104)","Chōji (1104-1106)","Kashō (1106-1108)","Tennin (1108-1110)","Ten-ei (1110-1113)","Eikyū (1113-1118)","Gen-ei (1118-1120)","Hoan (1120-1124)","Tenji (1124-1126)","Daiji (1126-1131)","Tenshō (1131-1132)","Chōshō (1132-1135)","Hoen (1135-1141)","Eiji (1141-1142)","Kōji (1142-1144)","Tenyō (1144-1145)","Kyūan (1145-1151)","Ninpei (1151-1154)","Kyūju (1154-1156)","Hogen (1156-1159)","Heiji (1159-1160)","Eiryaku (1160-1161)","Ōho (1161-1163)","Chōkan (1163-1165)","Eiman (1165-1166)","Nin-an (1166-1169)","Kaō (1169-1171)","Shōan (1171-1175)","Angen (1175-1177)","Jishō (1177-1181)","Yōwa (1181-1182)","Juei (1182-1184)","Genryuku (1184-1185)","Bunji (1185-1190)","Kenkyū (1190-1199)","Shōji (1199-1201)","Kennin (1201-1204)","Genkyū (1204-1206)","Ken-ei (1206-1207)","Shōgen (1207-1211)","Kenryaku (1211-1213)","Kenpō (1213-1219)","Shōkyū (1219-1222)","Jōō (1222-1224)","Gennin (1224-1225)","Karoku (1225-1227)","Antei (1227-1229)","Kanki (1229-1232)","Jōei (1232-1233)","Tempuku (1233-1234)","Bunryaku (1234-1235)","Katei (1235-1238)","Ryakunin (1238-1239)","En-ō (1239-1240)","Ninji (1240-1243)","Kangen (1243-1247)","Hōji (1247-1249)","Kenchō (1249-1256)","Kōgen (1256-1257)","Shōka (1257-1259)","Shōgen (1259-1260)","Bun-ō (1260-1261)","Kōchō (1261-1264)","Bun-ei (1264-1275)","Kenji (1275-1278)","Kōan (1278-1288)","Shōō (1288-1293)","Einin (1293-1299)","Shōan (1299-1302)","Kengen (1302-1303)","Kagen (1303-1306)","Tokuji (1306-1308)","Enkei (1308-1311)","Ōchō (1311-1312)","Shōwa (1312-1317)","Bunpō (1317-1319)","Genō (1319-1321)","Genkyō (1321-1324)","Shōchū (1324-1326)","Kareki (1326-1329)","Gentoku (1329-1331)","Genkō (1331-1334)","Kemmu (1334-1336)","Engen (1336-1340)","Kōkoku (1340-1346)","Shōhei (1346-1370)","Kentoku (1370-1372)","Bunchũ (1372-1375)","Tenju (1375-1379)","Kōryaku (1379-1381)","Kōwa (1381-1384)","Genchũ (1384-1392)","Meitoku (1384-1387)","Kakei (1387-1389)","Kōō (1389-1390)","Meitoku (1390-1394)","Ōei (1394-1428)","Shōchō (1428-1429)","Eikyō (1429-1441)","Kakitsu (1441-1444)","Bun-an (1444-1449)","Hōtoku (1449-1452)","Kyōtoku (1452-1455)","Kōshō (1455-1457)","Chōroku (1457-1460)","Kanshō (1460-1466)","Bunshō (1466-1467)","Ōnin (1467-1469)","Bunmei (1469-1487)","Chōkyō (1487-1489)","Entoku (1489-1492)","Meiō (1492-1501)","Bunki (1501-1504)","Eishō (1504-1521)","Taiei (1521-1528)","Kyōroku (1528-1532)","Tenmon (1532-1555)","Kōji (1555-1558)","Eiroku (1558-1570)","Genki (1570-1573)","Tenshō (1573-1592)","Bunroku (1592-1596)","Keichō (1596-1615)","Genwa (1615-1624)","Kan-ei (1624-1644)","Shōho (1644-1648)","Keian (1648-1652)","Shōō (1652-1655)","Meiryaku (1655-1658)","Manji (1658-1661)","Kanbun (1661-1673)","Enpō (1673-1681)","Tenwa (1681-1684)","Jōkyō (1684-1688)","Genroku (1688-1704)","Hōei (1704-1711)","Shōtoku (1711-1716)","Kyōhō (1716-1736)","Genbun (1736-1741)","Kanpō (1741-1744)","Enkyō (1744-1748)","Kan-en (1748-1751)","Hōryaku (1751-1764)","Meiwa (1764-1772)","An-ei (1772-1781)","Tenmei (1781-1789)","Kansei (1789-1801)","Kyōwa (1801-1804)","Bunka (1804-1818)","Bunsei (1818-1830)","Tenpō (1830-1844)","Kōka (1844-1848)","Kaei (1848-1854)","Ansei (1854-1860)","Man-en (1860-1861)","Bunkyū (1861-1864)","Genji (1864-1865)","Keiō (1865-1868)","M","H","Bunchū (1372-1375)","Genchū (1384-1392)","Meiji","Taishō","Shōwa","Heisei","Farvardin","Ordibehesht","Khordad","Tir","Mordad","Shahrivar","Mehr","Aban","Azar","Dey","Bahman","Esfand","AP","Before R.O.C.","R.O.C.","latn","{number}","-{number}","{currency}{number}","-{currency}{number}","{number}%","-{number}%",".",",","NaN","%","∞","A$","R$","CA$","CN¥","Fdj","Br","€","£","HK$","₪","₹","JP¥","₩","MX$","NZ$","NT$","US$","₫","FCFA","EC$","CFA","CFPF","Liiqen","Nfk","E d","E hh:mm a","E hh:mm:ss a","y G","MMM y G","E, dd MMM y G","dd MMM y G","E, d/M","E d MMM","E d MMMM","d MMM","dd MMMM","dd-MM","MM-y","E y-MM-dd","MMM y","E, d MMM y","MMMM y","d MMM y","QQQ y","QQQQ y","EEEE d MMMM y","d MMMM y","HH:mm:ss zzzz","HH:mm:ss z","J","F","O","Jan.","Feb.","Mrt.","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des","Januarie","Februarie","Maart","April","Junie","Julie","Augustus","September","Oktober","November","Desember","V","So","Ma","Di","Wo","Do","Vr","Sa","Sondag","Maandag","Dinsdag","Woensdag","Donderdag","Vrydag","Saterdag","vm.","nm.","v.C.","n.C.","vgj","vg","v.g.j.","g.j.","voor Christus","na Christus","{currency} {number}","-{currency} {number}"," ","$","฿","R","EEEE, dd MMMM y","dd MMM y","d E","E d/M","d/M","m:ss","M/y","E d/M/y","E d MMM y","d/M/y","d MMM, y","n","k","t","s","z","f","l","c","nùm","kɨz","tɨd","taa","see","nzu","dum","fɔe","dzu","lɔm","kaa","fwo","ndzɔ̀ŋɔ̀nùm","ndzɔ̀ŋɔ̀kƗ̀zùʔ","ndzɔ̀ŋɔ̀tƗ̀dʉ̀ghà","ndzɔ̀ŋɔ̀tǎafʉ̄ghā","ndzɔ̀ŋèsèe","ndzɔ̀ŋɔ̀nzùghò","ndzɔ̀ŋɔ̀dùmlo","ndzɔ̀ŋɔ̀kwîfɔ̀e","ndzɔ̀ŋɔ̀tƗ̀fʉ̀ghàdzughù","ndzɔ̀ŋɔ̀ghǔuwelɔ̀m","ndzɔ̀ŋɔ̀chwaʔàkaa wo","ndzɔ̀ŋèfwòo","g","u","nts","kpa","ghɔ","tɔm","ume","ghɨ","dzk","tsuʔntsɨ","tsuʔukpà","tsuʔughɔe","tsuʔutɔ̀mlò","tsuʔumè","tsuʔughɨ̂m","tsuʔndzɨkɔʔɔ","a.g","a.k","SK","BK","Sěe Kɨ̀lesto","Bǎa Kɨ̀lesto","{number}{currency}","-{number}{currency}","E, M/d","E, MMM d","E, MMMM d","MMMM d","M/d","E, M/d/y","E, MMM d, y","y/M/d","EEEE, y MMMM dd","y MMMM d","yy/MM/dd","S-Ɔ","K-Ɔ","E-Ɔ","E-O","E-K","O-A","A-K","D-Ɔ","F-Ɛ","Ɔ-A","Ɔ-O","M-Ɔ","Sanda-Ɔpɛpɔn","Kwakwar-Ɔgyefuo","Ebɔw-Ɔbenem","Ebɔbira-Oforisuo","Esusow Aketseaba-Kɔtɔnimba","Obirade-Ayɛwohomumu","Ayɛwoho-Kitawonsa","Difuu-Ɔsandaa","Fankwa-Ɛbɔ","Ɔbɛsɛ-Ahinime","Ɔberɛfɛw-Obubuo","Mumu-Ɔpɛnimba","B","Y","Kwe","Dwo","Ben","Wuk","Yaw","Fia","Mem","Kwesida","Dwowda","Benada","Wukuda","Yawda","Fida","Memeneda","AN","EW","AK","KE","Ansa Kristo","Kristo Ekyiri","GH₵","E፣ MMM d፣ y G","MMM d፣ y G","E፣ d/M/y","E፣ MMM d y","EEEE, d MMMM y","dd/MM/y","ጃ","ፌ","ማ","ኤ","ሜ","ጁ","ኦ","ሴ","ኖ","ዲ","ጃንዩ","ፌብሩ","ማርች","ኤፕሪ","ሜይ","ጁን","ጁላይ","ኦገስ","ሴፕቴ","ኦክቶ","ኖቬም","ዲሴም","ጃንዩወሪ","ፌብሩወሪ","ኤፕሪል","ኦገስት","ሴፕቴምበር","ኦክቶበር","ኖቬምበር","ዲሴምበር","እ","ሰ","ረ","ሐ","ዓ","ቅ","እሑድ","ሰኞ","ማክሰ","ረቡዕ","ሐሙስ","ዓርብ","ቅዳሜ","ማክሰኞ","ጥዋት","ከሰዓት","ዓ/ዓ","ዓ/ም","መስከ","ጥቅም","ኅዳር","ታኅሣ","ጥር","የካቲ","መጋቢ","ሚያዝ","ግንቦ","ሰኔ","ሐምሌ","ነሐሴ","ጳጉሜ","መስከረም","ጥቅምት","ታኅሣሥ","የካቲት","መጋቢት","ሚያዝያ","ግንቦት","ጳጉሜን","ዓመተ ዓለም","ዓመተ ምሕረት","ሙሀረም","ሳፈር","ረቢዑል አወል","ረቢዑል አኺር","ጀማደል አወል","ጀማደል አኺር","ረጀብ","ሻእባን","ረመዳን","ሸዋል","ዙልቂዳህ","ዙልሂጃህ","AU$","ብር","E، d","E، d MMM، y G","d MMM، y G","E، d/M","E، d MMM","E، d MMMM","d MMMM","dd‏/MM","d/‏M","M‏/y","E، d/‏M/‏y","MM‏/y","E، d MMM، y","d MMM، y","d‏/M‏/y","EEEE، d MMMM، y","d MMMM، y","dd‏/MM‏/y","ي","ف","م","أ","و","ن","ل","غ","س","ك","ب","د","يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر","ح","ث","ر","خ","ج","الأحد","الاثنين","الثلاثاء","الأربعاء","الخميس","الجمعة","السبت","التقويم البوذي","ص","توت","بابه","هاتور","كيهك","طوبة","أمشير","برمهات","برمودة","بشنس","بؤونة","أبيب","مسرى","نسيئ","مسكريم","تكمت","هدار","تهساس","تر","يكتت","مجابيت","ميازيا","جنبت","سين","هامل","نهاس","باجمن","ق.م","ب.م","قبل الميلاد","ميلادي","بعد الميلاد","تشري","مرحشوان","كيسلو","طيفت","شباط","آذار الأول","آذار","نيسان","أيار","سيفان","تموز","آب","أيلول","آذار الثاني","١","٢","٣","٤","٥","٦","٧","٨","٩","١٠","١١","١٢","محرم","صفر","ربيع الأول","ربيع الآخر","جمادى الأولى","جمادى الآخرة","رجب","شعبان","رمضان","شوال","ذو القعدة","ذو الحجة","هـ","تيكا","هاكتشي","هاكهو","شتشو","تيهو","كيين","وادو","رييكي","يورو","جينكي","تمبيو","تمبيو-كامبو","تمبيو-شوهو","تمبيو-هوجي","تمفو-جينجو","جينجو-كيين","هوكي","تن-أو","إنرياكو","ديدو","كونين","تنتشو","شووا (٨٣٤–٨٤٨)‏","كاجو","نينجو","سيكو","تنان","جوجان","جينكيي","نينا","كامبيو","شوتاي","انجي","انتشو","شوهيي","تنجيو","تنرياكو","تنتوكو","أووا","كوهو","آنا","تينروكو","تن-نن","جوجن","تنجن","إيكان","كانا","اي-ان","ايسو","شورياكو (٩٩٠–٩٩٥)‏","تشوتوكو","تشوهو","كانكو","تشووا","كانين","جاين","مانجو","تشوجين","تشورياكو","تشوكيو (١٠٤٠–١٠٤٤)‏","كانتوكو","ايشو (١٠٤٦–١٠٥٣)‏","تينجي","كوهيي","جيرياكو","انكيو (١٠٦٩–١٠٧٤)‏","شوهو (١٠٧٤–١٠٧٧)‏","شورياكو (١٠٧٧–١٠٨١)‏","ايهو","أوتوكو","كانجي","كاهو","ايتشو","شوتوكو","كووا (١٠٩٩–١١٠٤)‏","تشوجي","كاشو","تنين","تن-اي","ايكيو (١١١٣–١١١٨)‏","جن-اي","هوان","تنجي","ديجي","تنشو (١١٣١–١١٣٢)‏","تشوشو","هوين","ايجي","كوجي (١١٤٢–١١٤٤)‏","تنيو","كيوان","نينبيي","كيوجو","هجين","هيجي","ايرياكو","أوهو","تشوكان","ايمان","نين-ان","كاو","شون","أنجين","جيشو","يووا","جيي","جنريوكو","بنجي","كنكيو","شوجي","كنين","جنكيو (١٢٠٤–١٢٠٦)‏","كن-اي","شوجن (١٢٠٧–١٢١١)‏","كنرياكو","كنبو (١٢١٣–١٢١٩)‏","شوكيو","جو","جيننين","كروكو","أنتيي","كنكي","جويي","تمبكو","بنرياكو","كاتيي","رياكنين","ان-أو","نينجي","كنجين","هوجي","كنتشو","كوجن","شوكا","شوجن (١٢٥٩–١٢٦٠)‏","بن-أو","كوتشو","بن-اي","كنجي","كوان","شوو (١٢٨٨–١٢٩٣)‏","اينين","شوان","كنجن","كجن","توكجي","انكي","أوتشو","شووا (١٣١٢–١٣١٧)‏","بنبو","جنو","جنكيو (١٣٢١–١٣٢٤)‏","شوتشو (١٣٢٤–١٣٢٦)‏","كريكي","جنتكو","جنكو","كمو","إنجن","كوككو","شوهي","كنتكو","بنتشو","تنجو","كورياكو","كووا (١٣٨١–١٣٨٤)‏","جنتشو","مييتكو (١٣٨٤–١٣٨٧)‏","كاكي","كو","مييتكو (١٣٩٠–١٣٩٤)‏","أويي","شوتشو (١٤٢٨–١٤٢٩)‏","ايكيو (١٤٢٩–١٤٤١)‏","ككيتسو","بن-أن","هوتكو","كيوتكو","كوشو","تشوركو","كنشو","بنشو","أونين","بنمي","تشوكيو (١٤٨٧–١٤٨٩)‏","انتكو","ميو","بنكي","ايشو (١٥٠٤–١٥٢١)‏","تييي","كيوركو","تنمن","كوجي (١٥٥٥–١٥٥٨)‏","ايركو","جنكي","تنشو (١٥٧٣–١٥٩٢)‏","بنركو","كيتشو","جنوا","كان-اي","شوهو (١٦٤٤–١٦٤٨)‏","كيان","شوو (١٦٥٢–١٦٥٥)‏","ميرياكو","منجي","كنبن","انبو","تنوا","جوكيو","جنركو","هويي","شوتكو","كيوهو","جنبن","كنبو (١٧٤١–١٧٤٤)‏","انكيو (١٧٤٤–١٧٤٨)‏","كان-ان","هورياكو","مييوا","ان-اي","تنمي","كنسي","كيووا","بنكا","بنسي","تنبو","كوكا","كاي","أنسي","من-ان","بنكيو","جنجي","كيو","ميجي","تيشو","شووا","هيسي","فرفردن","أذربيهشت","خرداد","تار","مرداد","شهرفار","مهر","آيان","آذر","دي","بهمن","اسفندار","ه‍.ش","جمهورية الصي","arab","٫","٬","ليس رقم","٪","د.إ.‏","د.ب.‏","ي.ص","د.ج.‏","ج.م.‏","ر.إن.","ر.ه.‏","د.ع.‏","ر.إ.","د.أ.‏","ف.ج.ق.‏","د.ك.‏","ل.ل.‏","د.ل.‏","د.م.‏","أ.م.‏","ر.ع.‏","ر.ب.","ر.ق.‏","ر.س.‏","د.س.‏","ج.س.","ج.ج.س.","ل.س.‏","د.ت.‏","ل.ت.","***","ر.ي.‏","MM/dd","y/M","y/MM","y/MM/dd","جانفي","فيفري","أفريل","ماي","جوان","جويلية","أوت","ش","آ","ت","كانون الثاني","حزيران","تشرین الأول","تشرين الثاني","كانون الأول","تشرين الأول","E, MMM d, y G","MMM d, y","يوليوز","غشت","شتنبر","نونبر","دجنبر","إ","إبريل","أغشت","شتمبر","دجمبر","GB£","EEEE, d MMMM, y","d MMMM, y","dd-MM-y","d-M-y","h.mm.ss a zzzz","h.mm.ss a z","h.mm.ss a","h.mm. a","জানু","ফেব্ৰু","মাৰ্চ","এপ্ৰিল","মে","জুন","জুলাই","আগ","সেপ্ট","অক্টো","নভে","ডিসে","জানুৱাৰী","ফেব্ৰুৱাৰী","আগষ্ট","ছেপ্তেম্বৰ","অক্টোবৰ","নৱেম্বৰ","ডিচেম্বৰ","ৰবি","সোম","মঙ্গল","বুধ","বৃহষ্পতি","শুক্ৰ","শনি","দেওবাৰ","সোমবাৰ","মঙ্গলবাৰ","বুধবাৰ","বৃহষ্পতিবাৰ","শুক্ৰবাৰ","শনিবাৰ","পূৰ্বাহ্ণ","অপৰাহ্ণ","beng","Jan","Feb","Mac","Ago","Dec","Januari","Februari","Machi","Aprili","Juni","Julai","Agosti","Septemba","Oktoba","Novemba","Desemba","I","Jpi","Jtt","Jnn","Jtn","Alh","Ijm","Jmo","Jumapili","Jumatatu","Jumanne","Jumatano","Alhamisi","Ijumaa","Jumamosi","icheheavo","ichamthi","KM","BM","Kabla yakwe Yethu","Baada yakwe Yethu","{number} {currency}","-{number} {currency}","TSh","E, d MMM","E, d/M/y","EEEE, d MMMM 'de' y","d MMMM 'de' y","d/M/yy","P","xin","feb","mar","abr","may","xun","xnt","ago","set","och","pay","avi","de xineru","de febreru","de marzu","d’abril","de mayu","de xunu","de xunetu","d’agostu","de setiembre","d’ochobre","de payares","d’avientu","dom","llu","mie","xue","vie","sab","domingu","llunes","martes","miércoles","xueves","vienres","sábadu","PM","a.C.","d.C.","edC","ddC","¥","E, dd.MM","E, d, MMM","dd.MM","MM.y","E, dd.MM.y","MMM, y","E, d, MMM, y","dd.MM.y","EEEE, d, MMMM, y","dd.MM.yy","јанвар","феврал","март","апрел","май","ијун","ијул","август","сентјабр","октјабр","нојабр","декабр","базар","базар ертәси","чәршәнбә ахшамы","чәршәнбә","ҹүмә ахшамы","ҹүмә","шәнбә","ман.","G MMM y","G d MMM y, E","G d MMM y","dd.MM, E","d MMM, E","dd.MM.y, E","d MMM y, E","d MMMM y, EEEE","yan","fev","apr","iyn","iyl","avq","sen","okt","noy","dek","yanvar","fevral","mart","aprel","iyun","iyul","avqust","sentyabr","oktyabr","noyabr","dekabr","B.","B.E.","Ç.A.","Ç.","C.A.","C.","Ş.","bazar","bazar ertəsi","çərşənbə axşamı","çərşənbə","cümə axşamı","cümə","şənbə","e.ə.","b.e.","ü.e.ö.","ü.e.","eramızdan əvvəl","bizim eramızın","ümumi eradan öncə","ümumi eranın","m","h","b","kɔn","mac","mat","mto","mpu","hil","nje","hik","dip","bio","liɓ","Kɔndɔŋ","Màcɛ̂l","Màtùmb","Màtop","M̀puyɛ","Hìlòndɛ̀","Njèbà","Hìkaŋ","Dìpɔ̀s","Bìòôm","Màyɛsèp","Lìbuy li ńyèe","ŋ","j","nɔy","nja","uum","ŋge","mbɔ","kɔɔ","jon","ŋgwà nɔ̂y","ŋgwà njaŋgumba","ŋgwà ûm","ŋgwà ŋgê","ŋgwà mbɔk","ŋgwà kɔɔ","ŋgwà jôn","I bikɛ̂glà","I ɓugajɔp","b.Y.K","m.Y.K","bisū bi Yesù Krǐstò","i mbūs Yesù Krǐstò","{number} %","-{number} %","LLL y G","E, d MMM y G","d MMM y G","HH.mm","HH.mm.ss","E, d.M","E, d MMMM","d.M","h.mm a","mm.ss","M.y","E, d.M.y","LLL y","LLLL y","d.M.y","d.M.yy","HH.mm.ss zzzz","HH.mm.ss z","с","л","к","м","ч","ж","в","сту","лют","сак","кра","мая","чэр","ліп","жні","вер","кас","ліс","сне","студзеня","лютага","сакавіка","красавіка","чэрвеня","ліпеня","жніўня","верасня","кастрычніка","лістапада","снежня","н","п","а","нд","пн","аў","ср","чц","пт","сб","нядзеля","панядзелак","аўторак","серада","чацвер","пятніца","субота","да палудня","пасля палудня","да н.э.","н.э.","р.","рас. руб.","Epr","Oga","Dis","Epreo","Ogasti","Disemba","Pa Mulungu","Palichimo","Palichibuli","Palichitatu","Palichine","Palichisano","Pachibelushi","uluchelo","akasuba","BC","AD","Before Yesu","After Yesu","Hut","Vil","Dat","Tai","Han","Sit","Nan","Tis","Kum","Kmj","Kmb","pa mwedzi gwa hutala","pa mwedzi gwa wuvili","pa mwedzi gwa wudatu","pa mwedzi gwa wutai","pa mwedzi gwa wuhanu","pa mwedzi gwa sita","pa mwedzi gwa saba","pa mwedzi gwa nane","pa mwedzi gwa tisa","pa mwedzi gwa kumi","pa mwedzi gwa kumi na moja","pa mwedzi gwa kumi na mbili","Mul","Hiv","Hid","Hit","Hih","Lem","pa mulungu","pa shahuviluha","pa hivili","pa hidatu","pa hitayi","pa hihanu","pa shahulembela","pamilau","pamunyi","Kabla ya Mtwaa","Baada ya Mtwaa","{1}, {0}","E, HH:mm","E, H:mm:ss","E, d","E, h:mm a","E, h:mm:ss a","y 'г'. G","MM.y 'г'. G","E, d.MM.y 'г'. G","MMMM y 'г'. G","E, d MMMM y 'г'. G","d MMMM y 'г'. G","d.MM.y 'г'. G","H:mm","H:mm:ss","E, d.MM","MM","LLLL","d.MM","y 'г'.","M.y 'г'.","E, d.MM.y 'г'.","MM.y 'г'.","MMMM y 'г'.","E, d MMMM y 'г'.","d MMMM y 'г'.","d.MM.y 'г'.","QQQ y 'г'.","QQQQ y 'г'.","EEEE, d MMMM y 'г'.","d.MM.yy 'г'.","H:mm:ss zzzz","H:mm:ss z","я","ф","ю","о","д","ян.","февр.","апр.","юни","юли","авг.","септ.","окт.","ноем.","дек.","януари","февруари","април","септември","октомври","ноември","декември","вт","чт","неделя","понеделник","вторник","сряда","четвъртък","петък","събота","пр.об.","сл.об.","пр.Хр.","сл.н.е.","пр.н.е.","сл.Хр.","преди Христа","след Христа","преди новата ера","след новата ера","тишри","хешван","кислев","тебет","шебат","адар I","адар","нисан","иар","сиван","тамуз","ав","елул","адар II","чайтра","вайсакха","джаинтха","асадха","сравана","бхада","азвина","картика","аграхайана","пауза","магха","пхалгуна","мухарам","сафар","раби-1","раби-2","джумада-1","джумада-2","раджаб","шабан","рамазан","Шавал","Дхул-Каада","Дхул-хиджа","лв.","руб.","щ.д.","MMM","d/MM","dd/MM","MM/y","Z","U","Ɔ","zan","awi","mɛ","zuw","zul","uti","sɛt","ɔku","now","des","zanwuye","feburuye","marisi","awirili","zuwɛn","zuluye","sɛtanburu","ɔkutɔburu","nowanburu","desanburu","kar","ntɛ","tar","ara","ala","jum","sib","kari","ntɛnɛ","tarata","araba","alamisa","juma","sibiri","J.-C. ɲɛ","ni J.-C.","jezu krisiti ɲɛ","jezu krisiti minkɛ","y MMMM d, EEEE","Sun","Mon","Tue","Wed","Thu","Fri","Sat","E, d MMM, y G","d MMM, y G","E, d-M","E, d MMM, y","জা","ফে","মা","এ","জু","আ","সে","অ","ন","ডি","জানুয়ারী","ফেব্রুয়ারী","মার্চ","এপ্রিল","আগস্ট","সেপ্টেম্বর","অক্টোবর","নভেম্বর","ডিসেম্বর","র","সো","ম","বু","বৃ","শু","শ","রবি","বৃহস্পতি","শুক্র","রবিবার","সোমবার","মঙ্গলবার","বুধবার","বৃহস্পতিবার","শুক্রবার","শনিবার","পূর্বাহ্ণ","অপরাহ্ণ","খ্রিস্টপূর্ব","খৃষ্টাব্দ","খ্রিষ্টপূর্বাব্দ","খ্রিষ্টাব্দ","১","২","৩","৪","৫","৬","৭","৮","৯","১০","১১","১২","চৈত্র","বৈশাখ","জৈষ্ঠ্য","আষাঢ়","শ্রাবণ","ভাদ্র","আশ্বিন","কার্তিক","অগ্রহায়ণ","পৌষ","মাঘ","ফাল্গুন","সাল","মহররম","সফর","রবিউল আউয়াল","রবিউস সানি","জমাদিউল আউয়াল","জমাদিউস সানি","রজব","শা‘বান","রমজান","শাওয়াল","জ্বিলকদ","জ্বিলহজ্জ","যুগ","সংখ্যা না","৳","སྤྱི་ལོ་y MMMMའི་ཙེས་dད","y ལོ་འི་MMMཙེས་d","ཟླ་༡","ཟླ་༢","ཟླ་༣","ཟླ་༤","ཟླ་༥","ཟླ་༦","ཟླ་༧","ཟླ་༨","ཟླ་༩","ཟླ་༡༠","ཟླ་༡༡","ཟླ་༡༢","ཟླ་བ་དང་པོ་","ཟླ་བ་གཉིས་པ་","ཟླ་བ་སུམ་པ་","ཟླ་བ་བཞི་པ་","ཟླ་བ་ལྔ་པ་","ཟླ་བ་དྲུག་པ་","ཟླ་བ་བདུན་པ་","ཟླ་བ་བརྒྱད་པ་","ཟླ་བ་དགུ་པ་","ཟླ་བ་བཅུ་པ་","ཟླ་བ་བཅུ་གཅིག་པ་","ཟླ་བ་བཅུ་གཉིས་པ་","ཉི","ཟླ","མི","ལྷ","ཕུ","པ","སྤེ","ཉི་མ་","ཟླ་བ་","མིག་དམར་","ལྷག་པ་","ཕུར་བུ་","པ་སངས་","སྤེན་པ་","གཟའ་ཉི་མ་","གཟའ་ཟླ་བ་","གཟའ་མིག་དམར་","གཟའ་ལྷག་པ་","གཟའ་ཕུར་བུ་","གཟའ་པ་སངས་","གཟའ་སྤེན་པ་","སྔ་དྲོ་","ཕྱི་དྲོ་","སྤྱི་ལོ་སྔོན།","སྤྱི་ལོ།","ཨང་མེན་","E d MMM y G","E dd/MM","E dd/MM/y","01","02","03","04","05","06","07","08","09","Gen","Cʼhwe","Meur","Ebr","Mae","Mezh","Goue","Eost","Gwen","Here","Du","Ker","Genver","Cʼhwevrer","Meurzh","Ebrel","Mezheven","Gouere","Gwengolo","Kerzu","Su","Mz","Mc","Sul","Lun","Meu.","Mer.","Yaou","Gwe.","Sad.","Mercʼher","Gwener","Sadorn","A.M.","G.M.","$A","$CA","£ RU","$ HK","$ ZN","$ SU","EEEE,dd MMMM GGGGy","d-MMM","EEEE, MMMM d, y","MMMM d, y","M/d/yy","ज","फे","मा","ए","मे","जु","आ","से","अ","न","दि","जानुवारी","फेब्रुवारी","मार्स","एफ्रिल","जुन","जुलाइ","आगस्थ","सेबथेज्ब़र","अखथबर","नबेज्ब़र","दिसेज्ब़र","र","स","मं","बु","बि","सु","रबि","सम","मंगल","बुद","बिसथि","सुखुर","सुनि","रबिबार","समबार","मंगलबार","बुदबार","बिसथिबार","सुखुरबार","सुनिबार","फुं","बेलासे","ईसा.पूर्व","सन","बैसागो/बैसाग","जेथो","आसार","सावुन","भाद्र","आसिन","खाथि","आगाह्न","फुस","मागो","फागुन","सैथो","E, d.","y. G","MMM y. G","E, dd. MMM y. G","dd. MMM y. G","E, dd.MM.","E, dd. MMM","dd. MMM","dd.MM.","hh a","hh:mm a","hh:mm:ss a","y.","MM.y.","E, dd.MM.y.","MMM y.","E, dd. MMM y.","dd. MMM y.","dd.MM.y.","EEEE, dd. MMMM y.","dd. MMMM y.","d.M.yy.","ј","јан","феб","мар","апр","мај","јун","јул","авг","сеп","окт","нов","дец","јануар","фебруар","јуни","јули","септембар","октобар","новембар","децембар","у","нед","пон","уто","сри","чет","пет","суб","недеља","понедељак","уторак","сриједа","четвртак","петак","БЕ","пре подне","поподне","Таут","Баба","Хатор","Киахк","Тоба","Амшир","Барамхат","Барамуда","Башанс","Паона","Епеп","Месра","Наси","Мескерем","Текемт","Хедар","Тахсас","Тер","Јекатит","Мегабит","Миазиа","Генбот","Сене","Хамле","Нехасе","Пагумен","п.н.е.","н.е.","п. н. е.","н. е.","Пре нове ере","Нове ере","Тишри","Хешван","Кислев","Тевет","Шеват","Адар I","Адар","Нисан","Ијар","Сиван","Тамуз","Ав","Елул","Адар II","Чаитра","Ваисака","Јиаиста","Асада","Сравана","Бадра","Асвина","Картика","Аргајана","Пауза","Мага","Фалгуна","САКА","Мух.","Саф.","Реб. 1","Реб 2","Џум. 1","Џум. 2","Реџ.","Ша.","Рам.","Ше.","Зул-к.","Зул-х.","Мурахам","Сафар","Рабиʻ I","Рабиʻ II","Јумада I","Јумада II","Рађаб","Шаʻбан","Рамадан","Дуʻл-Киʻда","Дуʻл-хиђа","АХ","Таика (645-650)","Хакучи (650-671)","Хакухо (672-686)","Шучо (686-701)","Таихо (701-704)","Кеиун (704-708)","Вадо (708-715)","Реики (715-717)","Јоро (717-724)","Јинки (724-729)","Темпио (729-749)","Темпио-кампо (749-749)","Темпио-шохо (749-757)","Темпио-хођи (757-765)","Темпо-ђинго (765-767)","Ђинго-кеиун (767-770)","Хоки (770-780)","Тен-о (781-782)","Енрјаку (782-806)","Даидо (806-810)","Конин (810-824)","Тенчо (824-834)","Шова (834-848)","Кајо (848-851)","Нињу (851-854)","Саико (854-857)","Тенан (857-859)","Јоган (859-877)","Генкеи (877-885)","Ниња (885-889)","Кампјо (889-898)","Шотаи (898-901)","Енђи (901-923)","Енчо (923-931)","Шохеи (931-938)","Тенгјо (938-947)","Тенриаку (947-957)","Тентоку (957-961)","Ова (961-964)","Кохо (964-968)","Ана (968-970)","Тенроку (970-973)","Тен-ен (973-976)","Јоген (976-978)","Тенген (978-983)","Еикан (983-985)","Кана (985-987)","Еи-ен (987-989)","Еисо (989-990)","Шорјаку (990-995)","Чотоку (995-999)","Чохо (999-1004)","Канко (1004-1012)","Чова (1012-1017)","Канин (1017-1021)","Ђиан (1021-1024)","Мању (1024-1028)","Чоген (1028-1037)","Чорјаку (1037-1040)","Чокју (1040-1044)","Кантоку (1044-1046)","Еишо (1046-1053)","Тенђи (1053-1058)","Кохеи (1058-1065)","Ђирјаку (1065-1069)","Енкју (1069-1074)","Шохо (1074-1077)","Шорјаку (1077-1081)","Еишо (1081-1084)","Отоку (1084-1087)","Канђи (1087-1094)","Кахо (1094-1096)","Еичо (1096-1097)","Шотоку (1097-1099)","Кова (1099-1104)","Чођи (1104-1106)","Кашо (1106-1108)","Тенин (1108-1110)","Тен-еи (1110-1113)","Еикју (1113-1118)","Ђен-еи (1118-1120)","Хоан (1120-1124)","Тенђи (1124-1126)","Даиђи (1126-1131)","Теншо (1131-1132)","Чошао (1132-1135)","Хоен (1135-1141)","Еиђи (1141-1142)","Кођи (1142-1144)","Тењо (1144-1145)","Кјуан (1145-1151)","Нинпеи (1151-1154)","Кјују (1154-1156)","Хоген (1156-1159)","Хеиђи (1159-1160)","Еирјаку (1160-1161)","Охо (1161-1163)","Чокан (1163-1165)","Еиман (1165-1166)","Нин-ан (1166-1169)","Као (1169-1171)","Шоан (1171-1175)","Анген (1175-1177)","Ђишо (1177-1181)","Јова (1181-1182)","Ђуеи (1182-1184)","Генрјуку (1184-1185)","Бунђи (1185-1190)","Кенкју (1190-1199)","Шођи (1199-1201)","Кенин (1201-1204)","Генкју (1204-1206)","Кен-еи (1206-1207)","Шоген (1207-1211)","Кенрјаку (1211-1213)","Кенпо (1213-1219)","Шокју (1219-1222)","Ђу (1222-1224)","Ђенин (1224-1225)","Кароку (1225-1227)","Антеи (1227-1229)","Канки (1229-1232)","Ђоеи (1232-1233)","Темпуку (1233-1234)","Бунрјаку (1234-1235)","Катеи (1235-1238)","Рјакунин (1238-1239)","Ен-о (1239-1240)","Нињи (1240-1243)","Канген (1243-1247)","Хођи (1247-1249)","Кенчо (1249-1256)","Коген (1256-1257)","Шока (1257-1259)","Шоген (1259-1260)","Бун-о (1260-1261)","Кочо (1261-1264)","Бун-еи (1264-1275)","Кенђи (1275-1278)","Коан (1278-1288)","Шу (1288-1293)","Еинин (1293-1299)","Шоан (1299-1302)","Кенген (1302-1303)","Каген (1303-1306)","Токуђи (1306-1308)","Енкеи (1308-1311)","Очо (1311-1312)","Шова (1312-1317)","Бунпо (1317-1319)","Ђено (1319-1321)","Ђенкјо (1321-1324)","Шочу (1324-1326)","Кареки (1326-1329)","Гентоку (1329-1331)","Генко (1331-1334)","Кему (1334-1336)","Енген (1336-1340)","Кококу (1340-1346)","Шохеи (1346-1370)","Кентоку (1370-1372)","Бучу (1372-1375)","Тењу (1375-1379)","Корјаку (1379-1381)","Кова (1381-1384)","Генчу (1384-1392)","Меитоку (1384-1387)","Какеи (1387-1389)","Ку (1389-1390)","Меитоку (1390-1394)","Оеи (1394-1428)","Шочо (1428-1429)","Еикјо (1429-1441)","Какитсу (1441-1444)","Бун-ан (1444-1449)","Хотоку (1449-1452)","Кјотоку (1452-1455)","Кошо (1455-1457)","Чороку (1457-1460)","Каншо (1460-1466)","Буншо (1466-1467)","Онин (1467-1469)","Бунмеи (1469-1487)","Чокјо (1487-1489)","Ентоку (1489-1492)","Меио (1492-1501)","Бунки (1501-1504)","Еишо (1504-1521)","Таиеи (1521-1528)","Кјороку (1528-1532)","Тенмон (1532-1555)","Кођи (1555-1558)","Еироку (1558-1570)","Генки (1570-1573)","Теншо (1573-1592)","Бунроку (1592-1596)","Кеичо (1596-1615)","Генва (1615-1624)","Кан-еи (1624-1644)","Шохо (1644-1648)","Кеиан (1648-1652)","Шу (1652-1655)","Меирјаку (1655-1658)","Мањи (1658-1661)","Канбун (1661-1673)","Енпо (1673-1681)","Тенва (1681-1684)","Јокјо (1684-1688)","Генроку (1688-1704)","Хоеи (1704-1711)","Шотоку (1711-1716)","Кјохо (1716-1736)","Генбун (1736-1741)","Канпо (1741-1744)","Енкјо (1744-1748)","Кан-ен (1748-1751)","Хорјаку (1751-1764)","Меива (1764-1772)","Ан-еи (1772-1781)","Тенмеи (1781-1789)","Кансеи (1789-1801)","Кјова (1801-1804)","Бунка (1804-1818)","Бунсеи (1818-1830)","Тенпо (1830-1844)","Кока (1844-1848)","Каеи (1848-1854)","Ансеи (1854-1860)","Ман-ен (1860-1861)","Бункју (1861-1864)","Генђи (1864-1865)","Кеико (1865-1868)","Меиђи","Таишо","Шова","Хаисеи","Фаравадин","Ордибехешт","Кордад","Тир","Мордад","Шахривар","Мехр","Абан","Азар","Деј","Бахман","Есфанд","АП","Пре РК","РК","КМ","Кч","зл","дин.","Тл","E, dd.","E, d. MMMM","d. MMMM","dd. MM.","MM. y.","LLLL y.","dd. MMM. y.","dd.MM.yy.","a","o","jan","maj","jun","jul","aug","sep","nov","dec","januar","februar","april","juni","juli","august","septembar","oktobar","novembar","decembar","Č","ned","pon","uto","sri","čet","pet","sub","nedjelja","ponedjeljak","utorak","srijeda","četvrtak","petak","subota","prije podne","popodne","pr.n.e.","pr. n. e.","n.e.","p. n. e.","n. e.","Prije nove ere","Nove ere","muh.","saf.","rab. i","rab. ii","džum. i","džum. ii","redž.","ša.","ram.","še.","zul-k.","zul-h.","muharem","safer","rabiʻ i","rabiʻ ii","džumade i","džumade ii","redžeb","šaʻban","ramazan","ševal","zul-kade","zul-hidže","prije R.O.C.","kn","din.","{1} , {0}","E H:mm","E H:mm:ss","LLLL 'de' y G","LLL 'de' y","LLLL 'de' y","GN","FB","MÇ","AB","MG","JN","JL","AG","ST","OC","NV","DS","gen.","febr.","març","abr.","maig","juny","jul.","ag.","set.","oct.","nov.","des.","gener","febrer","abril","juliol","agost","setembre","octubre","novembre","desembre","dg","dl","dt","dc","dj","dv","ds","dg.","dl.","dt.","dc.","dj.","dv.","ds.","diumenge","dilluns","dimarts","dimecres","dijous","divendres","dissabte","eB","a. m.","p. m.","aC","dC","a. de la n. e.","de la n.e.","AEC","EC","abans de Crist","després de Crist","abans de l’Era Comuna","Era Comuna","₧","KBZ","KBR","KST","KKN","KTN","KMK","KMS","KMN","KMW","KKM","KNK","KNB","Okwokubanza","Okwakabiri","Okwakashatu","Okwakana","Okwakataana","Okwamukaaga","Okwamushanju","Okwamunaana","Okwamwenda","Okwaikumi","Okwaikumi na kumwe","Okwaikumi na ibiri","SAN","ORK","OKB","OKS","OKN","OKT","OMK","Sande","Orwokubanza","Orwakabiri","Orwakashatu","Orwakana","Orwakataano","Orwamukaaga","Kurisito Atakaijire","Kurisito Yaijire","USh","MMM d, y G","M/d/y","Ꭴ","Ꭷ","Ꭰ","Ꮥ","Ꭻ","Ꭶ","Ꮪ","Ꮕ","Ꭵ","ᎤᏃ","ᎧᎦ","ᎠᏅ","ᎧᏬ","ᎠᏂ","ᏕᎭ","ᎫᏰ","ᎦᎶ","ᏚᎵ","ᏚᏂ","ᏅᏓ","ᎥᏍ","ᎤᏃᎸᏔᏅ","ᎧᎦᎵ","ᎠᏅᏱ","ᎧᏬᏂ","ᎠᏂᏍᎬᏘ","ᏕᎭᎷᏱ","ᎫᏰᏉᏂ","ᎦᎶᏂ","ᏚᎵᏍᏗ","ᏚᏂᏅᏗ","ᏅᏓᏕᏆ","ᎥᏍᎩᏱ","Ꮖ","Ꮙ","Ꮤ","Ꮶ","Ꮷ","ᏆᏍᎬ","ᏉᏅᎯ","ᏔᎵᏁ","ᏦᎢᏁ","ᏅᎩᏁ","ᏧᎾᎩ","ᏈᏕᎾ","ᎤᎾᏙᏓᏆᏍᎬ","ᎤᎾᏙᏓᏉᏅᎯ","ᏔᎵᏁᎢᎦ","ᏦᎢᏁᎢᎦ","ᏅᎩᏁᎢᎦ","ᏧᎾᎩᎶᏍᏗ","ᎤᎾᏙᏓᏈᏕᎾ","ᏌᎾᎴ","ᏒᎯᏱᎢᏗᏢ","ᎤᏓᎷᎸ","ᎤᎶᏐᏅ","Ꮟ ᏥᏌ ᎾᏕᎲᏍᎬᎾ","ᎠᎩᏃᎮᎵᏓᏍᏗᏱ ᎠᏕᏘᏱᏍᎬ ᏱᎰᏩ ᏧᏓᏂᎸᎢᏍᏗ","E d.","LLLL y G","E d. M. y G","E d. MMMM y G","d. MMMM y G","d. M. y G","E d. M.","E d. MMMM","d. M.","d.","E d. M. y","E d. MMMM y","d. MMMM y","d. M. y","EEEE d. MMMM y","led","úno","bře","dub","kvě","čvn","čvc","srp","zář","říj","lis","pro","ledna","února","března","dubna","května","června","července","srpna","září","října","listopadu","prosince","Ú","ne","po","út","st","čt","pá","so","neděle","pondělí","úterý","středa","čtvrtek","pátek","sobota","př.n.l.","n.l.","n. l.","př. n. l.","Před R. O. C.","Kčs","Kč","EMU","ECU","E, HH:mm:ss","E, h.mm a","E, h.mm.ss a","Q y","Ch","Rh","Ion","Chwef","Mawrth","Ebrill","Mai","Meh","Gorff","Awst","Medi","Hyd","Tach","Rhag","Ionawr","Chwefror","Mehefin","Gorffennaf","Hydref","Tachwedd","Rhagfyr","Ll","Llun","Maw","Mer","Iau","Sad","Dydd Sul","Dydd Llun","Dydd Mawrth","Dydd Mercher","Dydd Iau","Dydd Gwener","Dydd Sadwrn","CC","Cyn Crist","Oed Crist","E HH.mm","E HH.mm.ss","E 'den' d.","E h.mm a","E h.mm.ss a","E d. MMM y G","d. MMM y G","E d. MMM","d. MMM","E d. MMM y","d. MMM y","EEEE 'den' d. MMMM y","jan.","feb.","mar.","apr.","jun.","aug.","sep.","okt.","dec.","marts","september","oktober","november","december","søn.","man.","tir.","ons.","tor.","fre.","lør.","søndag","mandag","tirsdag","onsdag","torsdag","fredag","lørdag","fKr","eKr","fvt","vt","f.Kr.","e.Kr.","f.v.t.","v.t.","før vesterlandsk tidsregning","vesterlandsk tidsregning","Minguo","kr.","Imb","Kaw","Kad","Kan","Kas","Kar","Mfu","Wun","Ike","Iku","Imw","Iwi","Mori ghwa imbiri","Mori ghwa kawi","Mori ghwa kadadu","Mori ghwa kana","Mori ghwa kasanu","Mori ghwa karandadu","Mori ghwa mfungade","Mori ghwa wunyanya","Mori ghwa ikenda","Mori ghwa ikumi","Mori ghwa ikumi na imweri","Mori ghwa ikumi na iwi","Jum","Jim","Ngu","Ituku ja jumwa","Kuramuka jimweri","Kuramuka kawi","Kuramuka kadadu","Kuramuka kana","Kuramuka kasanu","Kifula nguwo","Luma lwa K","luma lwa p","KK","Kabla ya Kristo","Baada ya Kristo","Ksh","E, d. MMM y G","HH 'Uhr'","E, d.M.","E, d. MMM","d.MM.","d.M.","E, d. MMM y","EEEE, dd. MMMM y","dd. MMMM y","dd. MMM y","Jän.","März","Apr.","Juli","Aug.","Sep.","Okt.","Nov.","Dez.","Jänner","Februar","August","Dezember","So.","Mo.","Di.","Mi.","Do.","Fr.","Sa.","Sonntag","Montag","Dienstag","Mittwoch","Donnerstag","Freitag","Samstag","vorm.","nachm.","v. Chr.","n. Chr.","v. u. Z.","u. Z.","vor unserer Zeitrechnung","unserer Zeitrechnung","öS","BGK","BGJ","DM","EEEE, d. MMMM y","Januar","{currency}-{number}","'","Ž","Žan","Fee","Mar","Awi","Me","Žuw","Žuy","Ut","Sek","Noo","Dee","Žanwiye","Feewiriye","Marsi","Awiril","Žuweŋ","Žuyye","Sektanbur","Oktoobur","Noowanbur","Deesanbur","Ati","Ata","Ala","Alm","Alz","Asi","Alhadi","Atinni","Atalaata","Alarba","Alzuma","Asibti","Subbaahi","Zaarikay b","IJ","IZ","Isaa jine","Isaa zamanoo","E, 'zeg'. H:mm","'zeg'. H","'zeg'. H:mm","měr.","maj.","awg.","now.","januara","februara","měrca","apryla","maja","junija","julija","awgusta","septembra","oktobra","nowembra","decembra","p","w","pón","wał","srj","stw","pět","sob","njeźela","pónjeźele","wałtora","srjoda","stwórtk","pětk","dopołdnja","wótpołdnja","pś.Chr.n.","pó Chr.n.","pś.n.l.c.","n.l.c.","pśed Kristusowym naroźenim","pó Kristusowem naroźenju","pśed našym licenim casa","našogo licenja casa","zł","e","di","ŋgɔn","sɔŋ","diɓ","emi","esɔ","mad","diŋ","nyɛt","tin","elá","dimɔ́di","ŋgɔndɛ","sɔŋɛ","diɓáɓá","emiasele","esɔpɛsɔpɛ","madiɓɛ́díɓɛ́","diŋgindi","nyɛtɛki","mayésɛ́","tiníní","eláŋgɛ́","ɗ","ét","mɔ́s","kwa","muk","ŋgi","ɗón","esa","éti","mɔ́sú","kwasú","mukɔ́sú","ŋgisú","ɗónɛsú","esaɓasú","idiɓa","ebyámu","ɓ.Ys","mb.Ys","ɓoso ɓwá yáɓe lá","mbúsa kwédi a Yés","Fe","Ab","Sú","Se","Ok","No","De","Sanvie","Fébirie","Mars","Aburil","Mee","Sueŋ","Súuyee","Settembar","Oktobar","Novembar","Disambar","Dim","Ten","Ara","Arj","Sib","Dimas","Teneŋ","Talata","Alarbay","Aramisay","Arjuma","Sibiti","ArY","AtY","Ariŋuu Yeesu","Atooŋe Yeesu","G y སྤྱི་ཟླ་MMM","གཟའ་E, G ལོy ཟླ་MMM ཚེ་d","ཆུ་ཚོད་HH","E, M-d","སྤྱི་LLL","E, སྤྱི་LLL ཚེ་d","སྤྱི་LLL ཚེ་d","M-d","ཆུ་ཚོད་h a","y-M","E, y-M-d","y སྤྱི་ཟླ་MMM","གཟའ་E, ལོy ཟླ་MMM ཚེ་d","y-M-d","EEEE, སྤྱི་ལོ་y MMMM ཚེས་dd","སྤྱི་ལོ་y MMMM ཚེས་ dd","སྤྱི་ལོ་y ཟླ་MMM ཚེས་dd","ཆུ་ཚོད་ h སྐར་མ་ mm:ss a zzzz","ཆུ་ཚོད་ h སྐར་མ་ mm:ss a z","ཆུ་ཚོད་h:mm:ss a","ཆུ་ཚོད་ h སྐར་མ་ mm a","༡","༢","༣","༥","༦","༧","༨","༡༠","༡༡","༡༢","༤","༩","ཟླ་དངཔ་","ཟླ་གཉིས་པ་","ཟླ་གསུམ་པ་","ཟླ་བཞི་པ་","ཟླ་ལྔ་པ་","ཟླ་དྲུག་པ","ཟླ་བདུན་པ་","ཟླ་བརྒྱད་པ་","ཟླ་དགུ་པ་","ཟླ་བཅུ་པ་","ཟླ་བཅུ་གཅིག་པ་","ཟླ་བཅུ་གཉིས་པ་","མིར","ལྷག","ཕུར","སངྶ","སྤེན","ཟླ་","མིར་","ལྷག་","ཕུར་","སངས་","སྤེན་","ཉི་","སྔ་ཆ་","ཕྱི་ཆ་","tibt","ཨང་མད","གྲངས་མེད","Nu.","KR₩","TH฿","Mbe","Kai","Kat","Gat","Gan","Mug","Knn","Ken","Igi","Mweri wa mbere","Mweri wa kaĩri","Mweri wa kathatũ","Mweri wa kana","Mweri wa gatano","Mweri wa gatantatũ","Mweri wa mũgwanja","Mweri wa kanana","Mweri wa kenda","Mweri wa ikũmi","Mweri wa ikũmi na ũmwe","Mweri wa ikũmi na Kaĩrĩ","Kma","Tat","Ine","Tan","Arm","Maa","NMM","Kiumia","Njumatatu","Njumaine","Njumatano","Aramithi","Njumaa","NJumamothii","KI","UT","MK","TK","Mbere ya Kristo","Thutha wa Kristo","{0} {1}","E a 'ga' h:mm","E a 'ga' h:mm:ss","E, MMM d 'lia' y G","MMM d 'lia', y G","E, MMM d 'lia'","E, MMMM d 'lia'","MMMM d 'lia'","MMM d 'lia'","a 'ga' h","a 'ga' h:mm","a 'ga' h:mm:ss","'aɖabaƒoƒo' mm:ss","MMM d 'lia', y","EEEE, MMMM d 'lia' y","MMMM d 'lia' y","a h:mm:ss zzzz","a 'ga' h:mm:ss z","dzv","dzd","ted","afɔ","dam","mas","sia","dea","any","kel","ade","dzm","dzove","dzodze","tedoxe","afɔfĩe","dama","masa","siamlɔm","deasiamime","anyɔnyɔ","kele","adeɛmekpɔxe","dzome","kɔs","dzo","bla","kuɖ","yaw","fiɖ","mem","kɔsiɖa","dzoɖa","blaɖa","kuɖa","yawoɖa","fiɖa","memleɖa","ŋdi","ɣetrɔ","afɔfiẽ","damɛ","foa","ƒoave","hY","Yŋ","Hafi Yesu Va Do ŋgɔ","Yesu Ŋɔli","dasiamime","hafi R.O.C.","mnn","Ι","Φ","Μ","Α","Σ","Ο","Ν","Δ","Ιαν","Φεβ","Μαρ","Απρ","Μαΐ","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ","Ιανουαρίου","Φεβρουαρίου","Μαρτίου","Απριλίου","Μαΐου","Ιουνίου","Ιουλίου","Αυγούστου","Σεπτεμβρίου","Οκτωβρίου","Νοεμβρίου","Δεκεμβρίου","Κ","Τ","Π","Κυρ","Δευ","Τρί","Τετ","Πέμ","Παρ","Σάβ","Κυριακή","Δευτέρα","Τρίτη","Τετάρτη","Πέμπτη","Παρασκευή","Σάββατο","π.μ.","μ.μ.","π.Χ.","μ.Χ.","π.Κ.Χ.","ΚΧ","προ Χριστού","μετά Χριστόν","πριν από την Κοινή Χρονολογία","Κοινή Χρονολογία","Πριν R.O.C.","Δρχ","May","Oct","January","February","March","June","July","October","December","Sunday","Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Mo1","Mo2","Mo3","Mo4","Mo5","Mo6","Mo7","Mo8","Mo9","Mo10","Mo11","Mo12","Month1","Month2","Month3","Month4","Month5","Month6","Month7","Month8","Month9","Month10","Month11","Month12","Before Christ","Anno Domini","Before Common Era","Common Era","HH 'h' mm 'min' ss 's' zzzz","am","pm","SAKA","LL","d/MM/y","E dd MMM y G","E dd MMM","dd MMM","E, dd/MM/y","E dd MMM y","EEEE dd MMMM y","E, MM-dd","E, y-MM-dd","Bunchū","Genchū","a.m.","p.m.","E d MMM, y","Ar","MOP$","E, dd MMM y","Rs","RM","₦","d/MM/yy","₱","RF","SR","Le","NAf.","T$","VT","WS$","E MM/dd","E, y/MM/dd","E, dd MMM, y","dd MMM, y","dd MMM,y","E 'la' d-'an' 'de' MMM","E 'la' d-'an' 'de' MMM y","EEEE, d-'a' 'de' MMMM y","y-MMMM-dd","y-MMM-dd","yy-MM-dd","H-'a' 'horo' 'kaj' m:ss zzzz","aŭg","januaro","februaro","marto","aprilo","majo","junio","julio","aŭgusto","septembro","oktobro","novembro","decembro","Ĵ","lu","ma","me","ĵa","ve","sa","dimanĉo","lundo","mardo","merkredo","ĵaŭdo","vendredo","sabato","atm","ptm","aK","pK","aKE","a.K.E.","K.E.","antaŭ Komuna Erao","Komuna Erao","₺","MMM 'de' y G","E, d 'de' MMMM 'de' y G","d 'de' MMM 'de' y G","E, d 'de' MMM","d 'de' MMMM","d 'de' MMM","dd-MMM","MMM 'de' y","E, d 'de' MMM 'de' y","MMMM 'de' y","d 'de' MMM 'de' y","QQQ 'de' y","QQQQ 'de' y","EEEE, d 'de' MMMM 'de' y","d 'de' MMMM 'de' y","ene.","may.","ago.","dic.","enero","febrero","marzo","mayo","agosto","setiembre","noviembre","diciembre","v","dom.","lun.","mié.","jue.","vie.","sáb.","domingo","lunes","jueves","viernes","sábado","a. m.","p. m.","a. C.","d. C.","a. e. c.","e. c.","antes de Cristo","después de Cristo","antes de la era común","era común","antes de R.O.C.","ZMK","E d-M","M-y","HH'h'''mm:ss zzzz","Bs","E, dd-MM","E dd-MM-y","dd-MM-yy","h:mm:ss a (zzzz)","₡","E, H:mm","d MMM 'de' y G","EEE, d/M/y","EEE, d 'de' MMMM 'de' y","H:mm:ss (zzzz)","sept.","septiembre","anno Dómini","EEEE dd 'de' MMMM 'de' y","dd 'de' MMMM 'de' y","E d 'de' MMM","ene","oct","dic","lun","mié","jue","sáb","Af","Naf","Kz","$a","Afl.","C$","E, MM/dd","E MM/dd/y","MM/dd/y","MM/dd/yy","B/.","HH'H'mm''ss'' zzzz","S/.","{currency} -{number}","₲","Bs.","E, d. MMMM y G","H:mm.ss","MMMM","h:mm.ss a","E, d.M y","E, d. MMMM y","H:mm.ss zzzz","H:mm.ss z","jaan","veebr","märts","mai","juuni","juuli","sept","dets","jaanuar","veebruar","aprill","oktoober","detsember","pühapäev","esmaspäev","teisipäev","kolmapäev","neljapäev","reede","laupäev","e.m.a.","m.a.j.","ema","EMA","MA","enne meie aega","meie aja järgi","enne meie ajaarvamist","meie ajaarvamise järgi","kr","G y. 'urteko' MMM","G y. 'urteko' MMM d, E","G y. 'urteko' MMM d","M/d, E","y/M/d, E","y('e')'ko' MMMM","y('e')'ko' MMMM d, E","y('e')'ko' MMMM d","y('e')'ko' QQQ","y('e')'ko' QQQQ","y('e')'ko' MMMM d, EEEE","HH:mm:ss (zzzz)","HH:mm:ss (z)","urt.","ots.","api.","mai.","eka.","uzt.","abu.","ira.","urr.","aza.","abe.","urtarrilak","otsailak","martxoak","apirilak","maiatzak","ekainak","uztailak","abuztuak","irailak","urriak","azaroak","abenduak","ig.","al.","ar.","az.","og.","or.","lr.","igandea","astelehena","asteartea","asteazkena","osteguna","ostirala","larunbata","BG","K.a.","K.o.","R.O.C. aurretik","% {number}","-% {number}","ngo","ngb","ngl","ngn","ngt","ngs","ngz","ngm","nge","nga","ngad","ngab","ngɔn osú","ngɔn bɛ̌","ngɔn lála","ngɔn nyina","ngɔn tána","ngɔn saməna","ngɔn zamgbála","ngɔn mwom","ngɔn ebulú","ngɔn awóm","ngɔn awóm ai dziá","ngɔn awóm ai bɛ̌","sɔ́n","mɔ́n","smb","sml","smn","fúl","sér","sɔ́ndɔ","mɔ́ndi","sɔ́ndɔ məlú mə́bɛ̌","sɔ́ndɔ məlú mə́lɛ́","sɔ́ndɔ məlú mə́nyi","fúladé","séradé","kíkíríg","ngəgógəle","oyk","ayk","osúsúa Yésus kiri","ámvus Yésus Kirís","{1}،‏ {0}","HH:mm (Z)","E M/d","E d LLL","E d LLLL","d LLLL","d LLL","E y/M/d","H:mm:ss (z)","ژ","ا","فوریهٔ","آوریل","مـی","ژوئن","جول","اوت","سپتامبر","اکتبر","نوامبر","دسم","جنوری","فبروری","مارچ","اپریل","می","جون","جولای","اگست","سپتمبر","اکتوبر","نومبر","دسمبر","ی","چ","پ","یکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه","قبل‌ازظهر","بعدازظهر","ق","قبل از عصر حاضر","عصر حاضر","ق.م.","م.","قبل از میلاد","میلادی","ک","ط","تشری","حشوان","کسلو","طوت","واذار","نیسان","ایار","سیوان","ایلول","واذار الثانی","ذ","ربیع الاول","ربیع الثانی","جمادی الاول","جمادی الثانی","ذیقعدهٔ","ذیحجهٔ","ه‍.ق.","هجری قمری","فروردین","اردیبهشت","تیر","شهریور","آبان","دی","اسفند","حمل","ثور","جوزا","سرطان","اسد","سنبلهٔ","میزان","عقرب","قوس","جدی","دلو","حوت","ه‍. ش.","هجری شمسی","arabext","‎{currency}{number}","-‎{currency}{number}","ناعدد","؋","¥CN","$HK","ریال","$MX","$NZ","$EC","ژانویهٔ","مهٔ","ژوئیهٔ","دسامبر","ه‍.ش.","sii","col","mbo","duu","kor","mor","juk","slt","yar","jol","bow","siilo","colte","mbooy","seeɗto","duujal","korse","morso","juko","siilto","yarkomaa","jolal","bowte","dew","aaɓ","maw","naa","mwd","hbi","dewo","aaɓnde","mawbaare","njeslaare","naasaande","mawnde","hoore-biir","subaka","kikiiɗe","H-I","C-I","Hade Iisa","Caggal Iisa","FG","UM","E H.mm","E H.mm.ss","H.mm","H.mm.ss","E d.M.","ccc d. MMM","m.ss","L.y","E d.M.y","cccc d. MMMM y","H.mm.ss zzzz","H.mm.ss z","tammikuuta","helmikuuta","maaliskuuta","huhtikuuta","toukokuuta","kesäkuuta","heinäkuuta","elokuuta","syyskuuta","lokakuuta","marraskuuta","joulukuuta","su","ti","ke","to","pe","la","sunnuntaina","maanantaina","tiistaina","keskiviikkona","torstaina","perjantaina","lauantaina","ap.","ip.","eK","jK","eaa","jaa","eKr.","jKr.","eaa.","jaa.","ennen Kristuksen syntymää","jälkeen Kristuksen syntymän","ennen ajanlaskun alkua","jälkeen ajanlaskun alun","tišríkuuta","hešvánkuuta","kislévkuuta","tevétkuuta","ševátkuuta","adárkuuta I","adárkuuta","nisánkuuta","ijjárkuuta","sivánkuuta","tammúzkuuta","abkuuta","elúlkuuta","adárkuuta II","muharram","safar","rabi’ al-awwal","rabi’ al-akhir","džumada-l-ula","džumada-l-akhira","radžab","ša’ban","ramadan","šawwal","dhu-l-qa’da","dhu-l-hiddža","epäluku","mk","Ene","Peb","Abr","Hun","Hul","Set","Nob","Enero","Pebrero","Marso","Abril","Mayo","Hunyo","Hulyo","Agosto","Setyembre","Oktubre","Nobyembre","Disyembre","Lin","Miy","Huw","Biy","Linggo","Lunes","Martes","Miyerkules","Huwebes","Biyernes","Sabado","E MMM d","E, y MMM d","mars","apríl","desember","sun","mán","týs","mik","hós","frí","ley","sunnudagur","mánadagur","týsdagur","mikudagur","hósdagur","fríggjadagur","leygardagur","um fyrrapartur","um seinnapartur","flt","lt","f.l.t.","l.t.","fyrir Krist","eftir Krist","fyrir látlaus tímatal","látlaus tímatal","¤¤¤","HH 'h'","H 'h' mm 'min' ss 's' zzzz","janv.","févr.","avr.","juin","juil.","août","déc.","janvier","février","avril","juillet","septembre","octobre","décembre","dim.","mer.","jeu.","ven.","sam.","dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi","E.B.","ère b.","ère bouddhiste","1yuè","2yuè","3yuè","4yuè","5yuè","6yuè","7yuè","8yuè","9yuè","10yuè","11yuè","12yuè","zhēngyuè","èryuè","sānyuè","sìyuè","wǔyuè","liùyuè","qīyuè","bāyuè","jiǔyuè","shíyuè","shíyīyuè","shí’èryuè","tout","bâb.","hât.","kya.","toub.","amsh.","barma.","barmo.","bash.","ba’o.","abî.","mis.","al-n.","bâbâ","hâtour","kyakh","toubah","amshîr","barmahât","barmoudah","bashans","ba’ounah","abîb","misra","al-nasi","av. D.","ap. D.","avant Dioclétien","après Dioclétien","mäs.","teq.","hed.","tah.","ter","yäk.","mäg.","miy.","gue.","sän.","ham.","näh.","pag.","mäskäräm","teqemt","hedar","tahesas","yäkatit","mägabit","miyazya","guenbot","säné","hamlé","nähasé","pagumén","av. Inc.","ap. Inc.","avant l’Incarnation","après l’Incarnation","av. J.-C.","ap. J.-C.","avant Jésus-Christ","après Jésus-Christ","tis.","hes.","kis.","téb.","sché.","ad.I","adar","nis.","iyar","siv.","tam.","ab","ell.","ad.II","Tisseri","Hesvan","Tébeth","Schébat","Nissan","Tamouz","Elloul","Anno Mundi","Ā","chai.","vai.","jyai.","āsha.","shrā.","bhā.","āshw.","kār.","mār.","pau.","māgh","phāl.","chaitra","vaishākh","jyaishtha","āshādha","shrāvana","bhādrapad","āshwin","kārtik","mārgashīrsha","paush","phālgun","mouh.","rab. aw.","rab. th.","joum. oul.","joum. tha.","raj.","chaa.","chaw.","dhou. q.","dhou. h.","mouharram","rabia al awal","rabia ath-thani","joumada al oula","joumada ath-thania","rajab","chaabane","chawwal","dhou al qi`da","dhou al-hijja","avant RdC","RdC","$AR","$AU","$BM","$BN","$BS","$BZ","$CL","$CO","£CY","$FJ","£FK","£GB","£GI","£IE","£IL","₤IT","£LB","lLS","fMA","Fmg","£MT","$NA","$RH","$SB","$SG","$SR","$TT","$US","$UY","DTS","FCFP","FBu","E M-d","MM-d","avant l’ère commune","ère commune","$ AU","$ HK","$ NZ","$ SG","$ US","FC","HH.mm:ss 'h' zzzz","DA","CF","LS","DT","d 'di' MMMM","LLLL 'dal' y","EEEE d 'di' MMMM 'dal' y","d 'di' MMMM 'dal' y","Zen","Fev","Avr","Jug","Lui","Avo","Otu","Dic","Zenâr","Fevrâr","Març","Avrîl","Jugn","Avost","Setembar","Otubar","Dicembar","joi","vin","domenie","lunis","martars","miercus","joibe","vinars","sabide","a.","p.","pdC","d-M","E d-M-y","mrt.","jannewaris","febrewaris","maart","maaie","july","augustus","septimber","novimber","desimber","si","mo","wo","fr","snein","moandei","tiisdei","woansdei","tongersdei","freed","sneon","Tut","Babah","Hatur","Kiyahk","Tubah","Baramundah","Ba’unah","Abib","Misra","Nasi","Mäskäräm","Teqemt","T’er","Yäkatit","Mägabit","Miyazya","Säne","Nähase","Pagumän","f.K.","n.K.","fgj","gj","n.Kr.","f.g.j.","Foar Kristus","nei Kristus","foar gewoane jiertelling","gewoane jiertelling","Tisjrie","Chesjwan","Sjevat","Adar A","Ijar","Tammoez","Elloel","Adar B","Vaishakha","Jyeshtha","Aashaadha","Shraavana","Bhaadrapada","Ashvina","Kaartika","Pausha","Maagha","Phaalguna","Moeh.","Joem. I","Joem. II","Sja.","Sjaw.","Doe al k.","Doe al h.","Moeharram","Rabiʻa al awal","Rabiʻa al thani","Joemadʻal awal","Joemadʻal thani","Sjaʻaban","Sjawal","Doe al kaʻaba","Doe al hizja","Saʻna Hizjria","{currency} {number}-","FJ$","SI$","Ean","Feabh","Márta","Aib","Beal","Meith","Iúil","Lún","MFómh","DFómh","Samh","Noll","Eanáir","Feabhra","Aibreán","Bealtaine","Meitheamh","Lúnasa","Meán Fómhair","Deireadh Fómhair","Samhain","Nollaig","Domh","Luan","Máirt","Céad","Déar","Aoine","Sath","Dé Domhnaigh","Dé Luain","Dé Máirt","Dé Céadaoin","Déardaoin","Dé hAoine","Dé Sathairn","RC","RCR","CR","Roimh Chríost","Roimh Chomh-Ré","Comh-Ré","E h:mma","d'mh' MMMM","ha","h:mma","EEEE, d'mh' MMMM y","d'mh' MMMM y","Ò","Faoi","Gearr","Màrt","Gibl","Cèit","Ògmh","Iuch","Lùna","Sult","Dàmh","Dùbh","dhen Fhaoilleach","dhen Ghearran","dhen Mhàrt","dhen Ghiblean","dhen Chèitean","dhen Ògmhios","dhen Iuchar","dhen Lùnastal","dhen t-Sultain","dhen Dàmhair","dhen t-Samhain","dhen Dùbhlachd","DiD","DiL","DiM","DiC","Dia","Dih","DiS","DiDòmhnaich","DiLuain","DiMàirt","DiCiadain","DiarDaoin","DihAoine","DiSathairne","RLC","LC","Ro Chrìosta","An dèidh Chrìosta","xan","xuñ","xul","out","xaneiro","febreiro","maio","xuño","xullo","setembro","outubro","mér","xov","ven","luns","mércores","xoves","venres","despois de Cristo","$R","¥JP","$NT","Mär","Dez","Auguscht","Septämber","Oktoober","Novämber","Dezämber","Su.","Mä.","Zi.","Du.","Sunntig","Määntig","Ziischtig","Mittwuch","Dunschtig","Friitig","Samschtig","nam.","vdZ","dZ","v. d. Z.","d. Z.","vor der gewöhnlichen Zeitrechnung","der gewöhnlichen Zeitrechnung","’","MMM, G y","E, d MMM, G y","d MMM, G y","hh:mm:ss a zzzz","hh:mm:ss a z","જા","ફે","મા","એ","મે","જૂ","જુ","ઑ","સ","ન","ડિ","જાન્યુ","ફેબ્રુ","માર્ચ","એપ્રિલ","જૂન","જુલાઈ","ઑગ","સપ્ટે","ઑક્ટો","નવે","ડિસે","જાન્યુઆરી","ફેબ્રુઆરી","ઑગસ્ટ","સપ્ટેમ્બર","ઑક્ટોબર","નવેમ્બર","ડિસેમ્બર","ર","સો","મં","બુ","ગુ","શુ","શ","રવિ","સોમ","મંગળ","બુધ","ગુરુ","શુક્ર","શનિ","રવિવાર","સોમવાર","મંગળવાર","બુધવાર","ગુરુવાર","શુક્રવાર","શનિવાર","ઇ સ પુ","ઇસ","સામાન્ય યુગ પહેલા","સામાન્ય યુગ","ઈસુના જન્મ પહેલા","ઇસવીસન","ઈસવીસન પૂર્વે","Can","Cul","Agt","Chanuari","Feburari","Apiriri","Chulai","Okitoba","Nobemba","Cpr","Ctt","Cmn","Cmt","Ars","Icm","Est","Chumapiri","Chumatato","Chumaine","Chumatano","Aramisi","Ichuma","Esabato","Ma/Mo","Mambia/Mog","YA","YK","Yeso ataiborwa","Yeso kaiboirwe","MMM dd, y","J-guer","T-arree","Mayrnt","Avrril","Boaldyn","M-souree","J-souree","Luanistyn","M-fouyir","J-fouyir","M.Houney","M.Nollick","Jerrey-geuree","Toshiaght-arree","Averil","Mean-souree","Jerrey-souree","Mean-fouyir","Jerrey-fouyir","Mee Houney","Mee ny Nollick","Jed","Jel","Jem","Jerc","Jerd","Jeh","Jes","Jedoonee","Jelhein","Jemayrt","Jercean","Jerdein","Jeheiney","Jesarn","Fab","Afi","Yun","Yul","Agu","Nuw","Janairu","Faburairu","Maris","Afirilu","Mayu","Yuni","Yuli","Agusta","Satumba","Nuwamba","Disamba","Lh","Li","Ta","Lr","Al","Ju","As","Lahadi","Litinin","Laraba","Alhamis","Jummaʼa","Asabar","KHAI","BHAI","Kafin haihuwar annab","Bayan haihuwar annab","M=romanlow","Ian.","Pep.","Mal.","ʻAp.","Iun.","Iul.","ʻAu.","Kep.","ʻOk.","Now.","Kek.","Ianuali","Pepeluali","Malaki","ʻApelila","Iune","Iulai","ʻAukake","Kepakemapa","ʻOkakopa","Nowemapa","Kekemapa","LP","P1","P2","P3","P4","P5","P6","Lāpule","Poʻakahi","Poʻalua","Poʻakolu","Poʻahā","Poʻalima","Poʻaono","E ה-d","E, d בMMM y G","d בMMM y G","E, d בMMM","d בMMM","‏h a","E, d בMMM y","d בMMM y","EEEE, d בMMMM y","d בMMMM y","ינו׳","פבר׳","מרץ","אפר׳","מאי","יוני","יולי","אוג׳","ספט׳","אוק׳","נוב׳","דצמ׳","ינואר","פברואר","אפריל","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר","א׳","ב׳","ג׳","ד׳","ה׳","ו׳","ש׳","יום א׳","יום ב׳","יום ג׳","יום ד׳","יום ה׳","יום ו׳","שבת","יום ראשון","יום שני","יום שלישי","יום רביעי","יום חמישי","יום שישי","יום שבת","לפנה״צ","אחה״צ","לפנה״ס","לספירה","לפני הספירה","תש׳","חש׳","כס׳","טב׳","שב׳","א״א","אד׳","ני׳","אי׳","סי׳","תמ׳","אב","אל׳","א״ב","תשרי","חשון","כסלו","טבת","שבט","אדר א׳","אדר","ניסן","אייר","סיון","תמוז","אלול","אדר ב׳","לבה״ע","מוחרם","צפר","רביע א׳","רביע ב׳","ג׳ומאדא א׳","ג׳ומאדא ב׳","רג׳ב","שעבאן","רמדאן","שוואל","ד׳ו אל־קעדה","ד׳ו אל־חיג׳ה","רביע אל-אוול","רביע א-ת׳אני","ג׳ומאדא אל-אולא","ג׳ומאדא א-ת׳אניה","שנת היג׳רה","טאיקה","נינג׳ו","שוטוקו","ל״י","MMM G y","फ़","म","जू","सि","जन॰","फ़र॰","मार्च","अप्रैल","मई","जून","जुल॰","अग॰","सित॰","अक्तू॰","नव॰","दिस॰","जनवरी","फ़रवरी","जुलाई","अगस्त","सितंबर","अक्तूबर","नवंबर","दिसंबर","सो","गु","शु","श","रवि","सोम","बुध","गुरु","शुक्र","शनि","रविवार","सोमवार","मंगलवार","बुधवार","गुरुवार","शुक्रवार","शनिवार","पूर्वाह्न","अपराह्न","मस्केरेम","टेकेम्ट","हेदर","तहसास","टर","येकाटिट","मेगाबिट","मियाज़िया","गनबोट","सेन","हम्ले","नेहासे","पागूमन","ईसा-पूर्व","ईस्वी","ईसवी पूर्व","ईसवी","ईसवी सन","चैत्र","वैशाख","ज्येष्ठ","आषाढ़","श्रावण","भाद्रपद","अश्विन","कार्तिक","अग्रहायण","पौष","माघ","फाल्गुन","शक","मुहर्रम","सफर","राबी प्रथम","राबी द्वितीय","जुम्डा प्रथम","जुम्डा द्वितीय","रजब","शावन","रमजान","शव्व्ल","जिल-क्दाह","जिल्-हिज्जाह","ताएका (645–650)","हाकूची (650–671)","हाकूहो (672–686)","शूचो (686–701)","ताहिओ (701–704)","केउन (704–708)","वाडू (708–715)","रैकी (715–717)","योरो (717–724)","जिंकी (724–729)","टेम्प्यो (729–749)","टेम्प्यो-काम्पो (749–749)","टेम्प्यो-शोहो (749–757)","टेम्प्यो-होजी (757–765)","टेम्प्यो-जिंगो (765–767)","टेम्प्यो-किउन (767–770)","होकी (770–780)","टेनो (781–782)","इंर्याकू (782–806)","डाईडू (806–810)","क़ोनिन (810–824)","टेंचो (824–834)","शोवा (834–848)","काज्यो (848–851)","निंजू (851–854)","शाईकू (854–857)","टेनन (857–859)","जोगन् (859–877)","गेंकेई (877–885)","निन्ना (885–889)","केम्प्यो (889–898)","शूताई (898–901)","ईंगी (901–923)","ईंचो (923–931)","शोहेई (931–938)","टेंग्यो (938–947)","टेंर्याकू (947–957)","टेंटूकू (957–961)","ओवा (961–964)","कोहो (964–968)","अन्ना (968–970)","टेंरोकू (970–973)","टेन-एन (973–976)","जोगन् (976–978)","टेंगेन (978–983)","ईकान (983–985)","कन्ना (985–987)","ई-एन (987–989)","एइसो (989–990)","शोर्याकू (990–995)","चोटूकु (995–999)","चोहो (999–1004)","कंको (1004–1012)","च्योवा (1012–1017)","कन्निन (1017–1021)","ज़ियान (1021–1024)","मंजू (1024–1028)","चोगन (1028–1037)","चोर्याकू (1037–1040)","चोक्यु (1040–1044)","कांटूको (1044–1046)","ईशो (1046–1053)","टेंगी (1053–1058)","कोहैइ (1058–1065)","जिर्याकू (1065–1069)","ईंक्यू (1069–1074)","सोहो (1074–1077)","शोर्याकू (1077–1081)","ईहो (1081–1084)","ओटूको (1084–1087)","कांजि (1087–1094)","कोहो (1094–1096)","ईचो (1096–1097)","शोटूको (1097–1099)","कोवा (1099–1104)","चोजी (1104–1106)","काशो (1106–1108)","टेन्निन (1108–1110)","टेन-ई (1110–1113)","ईक्यू (1113–1118)","जेन-ई (1118–1120)","होआन (1120–1124)","तेंजी (1124–1126)","दाईजी (1126–1131)","टेंशो (1131–1132)","चोशो (1132–1135)","होएन (1135–1141)","ईजी (1141–1142)","कोजी (1142–1144)","टेन्यो (1144–1145)","क्यूआन (1145–1151)","निंपैई (1151–1154)","क्योजो (1154–1156)","होगेन (1156–1159)","हैजी (1159–1160)","ईर्याकू (1160–1161)","ओहो (1161–1163)","चोकान (1163–1165)","ईमान (1165–1166)","निन-आन (1166–1169)","काओ (1169–1171)","शोअन (1171–1175)","अंजन (1175–1177)","जिशो (1177–1181)","योवा (1181–1182)","जूऐई (1182–1184)","जेंर्याकू (1184–1185)","बूंजी (1185–1190)","केंक्यू (1190–1199)","शोजी (1199–1201)","केन्निन (1201–1204)","जेंक्यू (1204–1206)","केन-ई (1206–1207)","शोगेन (1207–1211)","केंर्याकू (1211–1213)","केंपो (1213–1219)","शोक्यू (1219–1222)","जू (1222–1224)","जेन्निन (1224–1225)","कोरोकू (1225–1227)","अंटैइ (1227–1229)","कांकी (1229–1232)","जोएई (1232–1233)","टेम्पूकू (1233–1234)","बुंर्याकू (1234–1235)","काटेई (1235–1238)","र्याकूनिन (1238–1239)","ईन-ओ (1239–1240)","निंजी (1240–1243)","कांजेन (1243–1247)","होजी (1247–1249)","केंचो (1249–1256)","कोगेन (1256–1257)","शोका (1257–1259)","शोगेन (1259–1260)","बुन-ओ (1260–1261)","कोचो (1261–1264)","बुन-ई (1264–1275)","केंजी (1275–1278)","कोअन (1278–1288)","शो (1288–1293)","ईनिन (1293–1299)","शोअन (1299–1302)","केंजेन (1302–1303)","काजेन (1303–1306)","टोकूजी (1306–1308)","ईंकेई (1308–1311)","ओचो (1311–1312)","शोवा (1312–1317)","बुंपो (1317–1319)","जेनो (1319–1321)","जेंक्यो (1321–1324)","शोचू (1324–1326)","कारेकी (1326–1329)","जेंटोकू (1329–1331)","गेंको (1331–1334)","केम्मू (1334–1336)","ईंजेन (1336–1340)","कोकोकू (1340–1346)","शोहेई (1346–1370)","केंटोकू (1370–1372)","बूंचो (1372–1375)","टेंजो (1375–1379)","कोर्याकू (1379–1381)","कोवा (1381–1384)","जेंचू (1384–1392)","मेटोकू (1384–1387)","काकेई (1387–1389)","कू (1389–1390)","मेटोकू (1390–1394)","ओई (1394–1428)","शोचो (1428–1429)","ईक्यो (1429–1441)","काकीत्सू (1441–1444)","बुन-अन (1444–1449)","होटोकू (1449–1452)","क्योटोकू (1452–1455)","कोशो (1455–1457)","चोरोकू (1457–1460)","कांशो (1460–1466)","बुंशो (1466–1467)","ओनिन (1467–1469)","बुन्मेई (1469–1487)","चोक्यो (1487–1489)","ईंटोकू (1489–1492)","मेईओ (1492–1501)","बुंकी (1501–1504)","ईशो (1504–1521)","ताईएई (1521–1528)","क्योरोकू (1528–1532)","टेन्मन (1532–1555)","कोजी (1555–1558)","ईरोकू (1558–1570)","जेंकी (1570–1573)","टेंशो (1573–1592)","बुंरोकू (1592–1596)","केईचो (1596–1615)","जेनवा (1615–1624)","कान-एई (1624–1644)","शोहो (1644–1648)","केईआन (1648–1652)","शो (1652–1655)","मेईर्याकू (1655–1658)","मानजी (1658–1661)","कनबुन (1661–1673)","ईंपो (1673–1681)","टेंवा (1681–1684)","जोक्यो (1684–1688)","जेंरोकू (1688–1704)","होएई (1704–1711)","शोटूको (1711–1716)","क्योहो (1716–1736)","जेंबुन (1736–1741)","कांपो (1741–1744)","इंक्यो (1744–1748)","कान-एन (1748–1751)","होर्याकू (1751–1764)","मेईवा (1764–1772)","अन-एई (1772–1781)","टेनमेई (1781–1789)","कांसेई (1789–1801)","क्योवा (1801–1804)","बुंका (1804–1818)","बुंसेई (1818–1830)","टेंपो (1830–1844)","कोका (1844–1848)","काईए (1848–1854)","अंसेई (1854–1860)","मान-ईन (1860–1861)","बुंक्यौ (1861–1864)","जेंजी (1864–1865)","केईओ (1865–1868)","मेजी","ताईशो","शोवा","हेईसेई","फर्वादिन","ओर्दिवेहेस्ट","खोरर्दाद","टिर","मोरदाद","शाहरीवर्","मेहर","अवन","अज़र","डे","बहमन","ईस्फन्द्","LLL y. G","E, d. MMM y. G","d. MMM y. G","L.","LLL y.","E, d. MMM y.","d. MMM y.","QQQ y.","QQQQ y.","EEEE, d. MMMM y.","d. MMMM y.","1.","2.","3.","4.","5.","6.","7.","8.","9.","10.","11.","12.","sij","velj","ožu","tra","svi","lip","kol","ruj","stu","siječnja","veljače","ožujka","travnja","svibnja","lipnja","srpnja","kolovoza","rujna","listopada","studenoga","prosinca","pr. Kr.","p. Kr.","Prije Krista","Poslije Krista","Taika (645.-650.)","Hakuchi (650.-671.)","Hakuhō (672.-686.)","Shuchō (686.-701.)","Taihō (701.-704.)","Keiun (704.-708.)","Wadō (708.-715.)","Reiki (715.-717.)","Yōrō (717.-724.)","Jinki (724.-729.)","Tempyō (729.-749.)","Tempyō-kampō (749.-749.)","Tempyō-shōhō (749.-757.)","Tempyō-hōji (757.-765.)","Temphō-jingo (765.-767.)","Jingo-keiun (767.-770.)","Hōki (770.-780.)","Ten-ō (781.-782.)","Enryaku (782.-806.)","Daidō (806.-810.)","Kōnin (810.-824.)","Tenchō (824.-834.)","Jōwa (834.-848.)","Kajō (848.-851.)","Ninju (851.-854.)","Saiko (854.-857.)","Tennan (857.-859.)","Jōgan (859.-877.)","Genkei (877.-885.)","Ninna (885.-889.)","Kampyō (889.-898.)","Shōtai (898.-901.)","Engi (901.-923.)","Enchō (923.-931.)","Shōhei (931.-938.)","Tengyō (938.-947.)","Tenryaku (947.-957.)","Tentoku (957.-961.)","Ōwa (961.-964.)","Kōhō (964.-968.)","Anna (968.-970.)","Tenroku (970.-973.)","Ten-en (973.-976.)","Jōgen (976.-978.)","Tengen (978.-983.)","Eikan (983.-985.)","Kanna (985.-987.)","Ei-en (987.-989.)","Eiso (989.-990.)","Shōryaku (990.-995.)","Chōtoku (995.-999.)","Chōhō (999.-1004.)","Kankō (1004.-1012.)","Chōwa (1012.-1017.)","Kannin (1017.-1021.)","Jian (1021.-1024.)","Manju (1024.-1028.)","Chōgen (1028.-1037.)","Chōryaku (1037.-1040.)","Chōkyū (1040.-1044.)","Kantoku (1044.-1046.)","Eishō (1046.-1053.)","Tengi (1053.-1058.)","Kōhei (1058.-1065.)","Jiryaku (1065.-1069.)","Enkyū (1069.-1074.)","Shōho (1074.-1077.)","Shōryaku (1077.-1081.)","Eiho (1081.-1084.)","Ōtoku (1084.-1087.)","Kanji (1087.-1094.)","Kaho (1094.-1096.)","Eichō (1096.-1097.)","Shōtoku (1097.-1099.)","Kōwa (1099.-1104.)","Chōji (1104.-1106.)","Kashō (1106.-1108.)","Tennin (1108.-1110.)","Ten-ei (1110.-1113.)","Eikyū (1113.-1118.)","Gen-ei (1118.-1120.)","Hoan (1120.-1124.)","Tenji (1124.-1126.)","Daiji (1126.-1131.)","Tenshō (1131.-1132.)","Chōshō (1132.-1135.)","Hoen (1135.-1141.)","Eiji (1141.-1142.)","Kōji (1142.-1144.)","Tenyō (1144.-1145.)","Kyūan (1145.-1151.)","Ninpei (1151.-1154.)","Kyūju (1154.-1156.)","Hogen (1156.-1159.)","Heiji (1159.-1160.)","Eiryaku (1160.-1161.)","Ōho (1161.-1163.)","Chōkan (1163.-1165.)","Eiman (1165.-1166.)","Nin-an (1166.-1169.)","Kaō (1169.-1171.)","Shōan (1171.-1175.)","Angen (1175.-1177.)","Jishō (1177.-1181.)","Yōwa (1181.-1182.)","Juei (1182.-1184.)","Genryuku (1184.-1185.)","Bunji (1185.-1190.)","Kenkyū (1190.-1199.)","Shōji (1199.-1201.)","Kennin (1201.-1204.)","Genkyū (1204.-1206.)","Ken-ei (1206.-1207.)","Shōgen (1207.-1211.)","Kenryaku (1211.-1213.)","Kenpō (1213.-1219.)","Shōkyū (1219.-1222.)","Jōō (1222.-1224.)","Gennin (1224.-1225.)","Karoku (1225.-1227.)","Antei (1227.-1229.)","Kanki (1229.-1232.)","Jōei (1232.-1233.)","Tempuku (1233.-1234.)","Bunryaku (1234.-1235.)","Katei (1235.-1238.)","Ryakunin (1238.-1239.)","En-ō (1239.-1240.)","Ninji (1240.-1243.)","Kangen (1243.-1247.)","Hōji (1247.-1249.)","Kenchō (1249.-1256.)","Kōgen (1256.-1257.)","Shōka (1257.-1259.)","Shōgen (1259.-1260.)","Bun-ō (1260.-1261.)","Kōchō (1261.-1264.)","Bun-ei (1264.-1275.)","Kenji (1275.-1278.)","Kōan (1278.-1288.)","Shōō (1288.-1293.)","Einin (1293.-1299.)","Shōan (1299.-1302.)","Kengen (1302.-1303.)","Kagen (1303.-1306.)","Tokuji (1306.-1308.)","Enkei (1308.-1311.)","Ōchō (1311.-1312.)","Shōwa (1312.-1317.)","Bunpō (1317.-1319.)","Genō (1319.-1321.)","Genkyō (1321.-1324.)","Shōchū (1324.-1326.)","Kareki (1326.-1329.)","Gentoku (1329.-1331.)","Genkō (1331.-1334.)","Kemmu (1334.-1336.)","Engen (1336.-1340.)","Kōkoku (1340.-1346.)","Shōhei (1346.-1370.)","Kentoku (1370.-1372.)","Bunchū (1372.-1375.)","Tenju (1375.-1379.)","Kōryaku (1379.-1381.)","Kōwa (1381.-1384.)","Genchū (1384.-1392.)","Meitoku (1384.-1387.)","Kakei (1387.-1389.)","Kōō (1389.-1390.)","Meitoku (1390.-1394.)","Ōei (1394.-1428.)","Shōchō (1428.-1429.)","Eikyō (1429.-1441.)","Kakitsu (1441.-1444.)","Bun-an (1444.-1449.)","Hōtoku (1449.-1452.)","Kyōtoku (1452.-1455.)","Kōshō (1455.-1457.)","Chōroku (1457.-1460.)","Kanshō (1460.-1466.)","Bunshō (1466.-1467.)","Ōnin (1467.-1469.)","Bunmei (1469.-1487.)","Chōkyō (1487.-1489.)","Entoku (1489.-1492.)","Meiō (1492.-1501.)","Bunki (1501.-1504.)","Eishō (1504.-1521.)","Taiei (1521.-1528.)","Kyōroku (1528.-1532.)","Tenmon (1532.-1555.)","Kōji (1555.-1558.)","Eiroku (1558.-1570.)","Genki (1570.-1573.)","Tenshō (1573.-1592.)","Bunroku (1592.-1596.)","Keichō (1596.-1615.)","Genwa (1615.-1624.)","Kan-ei (1624.-1644.)","Shōho (1644.-1648.)","Keian (1648.-1652.)","Shōō (1652.-1655.)","Meiryaku (1655.-1658.)","Manji (1658.-1661.)","Kanbun (1661.-1673.)","Enpō (1673.-1681.)","Tenwa (1681.-1684.)","Jōkyō (1684.-1688.)","Genroku (1688.-1704.)","Hōei (1704.-1711.)","Shōtoku (1711.-1716.)","Kyōhō (1716.-1736.)","Genbun (1736.-1741.)","Kanpō (1741.-1744.)","Enkyō (1744.-1748.)","Kan-en (1748.-1751.)","Hōryaku (1751.-1764.)","Meiwa (1764.-1772.)","An-ei (1772.-1781.)","Tenmei (1781.-1789.)","Kansei (1789.-1801.)","Kyōwa (1801.-1804.)","Bunka (1804.-1818.)","Bunsei (1818.-1830.)","Tenpō (1830.-1844.)","Kōka (1844.-1848.)","Kaei (1848.-1854.)","Ansei (1854.-1860.)","Man-en (1860.-1861.)","Bunkyū (1861.-1864.)","Genji (1864.-1865.)","Keiō (1865.-1868.)","E, H:mm 'hodź'.","H 'hodź'.","H:mm 'hodź'.","mej.","meje","š","wut","štw","pja","njedźela","póndźela","wutora","srjeda","štwórtk","pjatk","popołdnju","př.Chr.n.","po Chr.n.","př.n.l.č.","n.l.č.","před Chrystowym narodźenjom","po Chrystowym narodźenju","před našim ličenjom časa","našeho ličenja časa","d., E","G y.","G y. MMM","G y. MMM d., E","G y. MMM d.","M. d., E","MMM d., E","MMMM d.","MMM d.","M. d.","a h","a h:mm","a h:mm:ss","y. M.","y. MM. dd., E","y. MMM","y. MMM d., E","y. MMMM","y. MMM d.","y. MM. dd.","y. QQQ","y. QQQQ","y. MMMM d., EEEE","y. MMMM d.","Á","Sz","márc.","ápr.","máj.","jún.","júl.","szept.","január","február","március","április","május","június","július","augusztus","szeptember","október","Cs","Sze","Szo","vasárnap","hétfő","kedd","szerda","csütörtök","péntek","szombat","de.","du.","ie.","isz.","i. e.","i. sz.","időszámításunk előtt","időszámításunk szerint","Tisri","Hesván","Kiszlév","Tévész","Svát","Ádár I","Ádár","Niszán","Ijár","Sziván","Áv","Ádár II","TÉ","Moh.","Rébi I","Rébi II","Dsem. I","Dsem. II","Red.","Sab.","Sev.","Dsül k.","Dsül h.","Moharrem","Rébi el avvel","Rébi el accher","Dsemádi el avvel","Dsemádi el accher","Redseb","Sabán","Ramadán","Sevvál","Dsül kade","Dsül hedse","MF","R.O.C. előtt","d, ccc","G yթ.","G yթ. LLL","G yթ. MMM d, E","d MMM, yթ.,","d.MM.yթ., E","yթ. LLL","yթ. MMM d, E","d MMM, yթ.","y թ, QQQ","y թ, QQQQ","yթ. MMMM d, EEEE","dd MMMM, yթ.","dd MMM, yթ.","H:mm:ss, zzzz","H:mm:ss, z","Հ","Փ","Մ","Ա","Օ","Ս","Ն","Դ","հնվ","փտվ","մրտ","ապր","մյս","հնս","հլս","օգս","սեպ","հոկ","նոյ","դեկ","հունվարի","փետրվարի","մարտի","ապրիլի","մայիսի","հունիսի","հուլիսի","օգոստոսի","սեպտեմբերի","հոկտեմբերի","նոյեմբերի","դեկտեմբերի","Կ","Ե","Չ","Ու","Շ","կիր","երկ","երք","չրք","հնգ","ուր","շբթ","կիրակի","երկուշաբթի","երեքշաբթի","չորեքշաբթի","հինգշաբթի","ուրբաթ","շաբաթ","կեսօրից առաջ","կեսօրից հետո","մ.թ.ա.","մ.թ.","մ.թ.ա","մեր թվարկությունից առաջ","մեր թվարկության","֏","januario","februario","martio","augusto","decembre","mer","jov","dominica","lunedi","martedi","mercuridi","jovedi","venerdi","sabbato","a.Chr.","p.Chr.","ante Christo","post Christo","Maret","Agustus","Min","Sen","Sel","Rab","Minggu","Senin","Selasa","Rabu","Kamis","Jumat","Sabtu","SM","SEU","EU","Sebelum Masehi","Sebelum Era Umum","Era Umum","Syaw.","Sya’ban","Ramadhan","Syawal","Sebelum R.O.C.","Rp","$U","Jen","Juu","Ọgọ","Ọkt","Jenụwarị","Febrụwarị","Maachị","Eprel","Juun","Julaị","Ọgọọst","Ọktoba","Ụka","Mọn","Tiu","Wen","Tọọ","Fraị","Mbọsị Ụka","Mọnde","Tiuzdee","Wenezdee","Tọọzdee","Fraịdee","Satọdee","P.M.","T.K.","A.K.","Tupu Kristi","Afọ Kristi","ꋍꆪ","ꑍꆪ","ꌕꆪ","ꇖꆪ","ꉬꆪ","ꃘꆪ","ꏃꆪ","ꉆꆪ","ꈬꆪ","ꊰꆪ","ꊰꊪꆪ","ꊰꑋꆪ","ꆏ","ꋍ","ꑍ","ꌕ","ꇖ","ꉬ","ꃘ","ꑭꆏ","ꆏꋍ","ꆏꑍ","ꆏꌕ","ꆏꇖ","ꆏꉬ","ꆏꃘ","ꑭꆏꑍ","ꆏꊂꋍ","ꆏꊂꑍ","ꆏꊂꌕ","ꆏꊂꇖ","ꆏꊂꉬ","ꆏꊂꃘ","ꎸꄑ","ꁯꋒ","ꃅꋊꂿ","ꃅꋊꊂ","M. y","maí","ágú.","nóv.","janúar","febrúar","júní","júlí","ágúst","nóvember","Þ","sun.","mán.","þri.","mið.","fim.","fös.","lau.","mánudagur","þriðjudagur","miðvikudagur","fimmtudagur","föstudagur","laugardagur","f.h.","e.h.","f.k.","e.k.","fyrir kristið tímatal","kristið tímatal","d-MMM-y","gen","mag","giu","lug","ott","gennaio","febbraio","aprile","maggio","giugno","luglio","settembre","ottobre","dicembre","gio","domenica","lunedì","martedì","mercoledì","giovedì","venerdì","EB","Prima della R.O.C.","d日EEEE","H:mm (E)","H:mm:ss (E)","d日(E)","aK:mm (E)","aK:mm:ss (E)","Gy年","Gy年M月","Gy年M月d日EEEE","Gy年M月d日(E)","Gy年M月d日","H時","M月","M/dEEEE","M/d(E)","M月d日EEEE","M月d日(E)","M月d日","d日","aK時","aK:mm","aK:mm:ss","y年","y/M/dEEEE","y/M/d(E)","y年M月","y年M月d日EEEE","y年M月d日(E)","y年M月d日","y/QQQ","yQQQQ","H時mm分ss秒 zzzz","1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月","日","月","火","水","木","金","土","日曜日","月曜日","火曜日","水曜日","木曜日","金曜日","土曜日","仏暦","午前","午後","正","二","三","四","五","六","七","八","九","十","十一","十二","正月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月","トウト","ババ","ハトール","キアック","トーバ","アムシール","バラムハート","バラモウダ","バシャンス","パオーナ","エペープ","メスラ","ナシエ","メスケレム","テケムト","ヘダル","ターサス","テル","イェカティト","メガビト","ミアジア","ゲンボト","セネ","ハムレ","ネハッセ","パグメン","紀元前","西暦","西暦紀元前","西暦紀元","ティスレ","へシボン","キスレブ","テベット","シバット","アダル I","アダル","ニサン","イヤル","シバン","タムズ","アヴ","エルル","アダル II","カイトラ","ヴァイサカ","ジャイスタ","アーサダ","スラバナ","バードラ","アスビナ","カルディカ","アヴラハヤナ","パウサ","マーガ","パルグナ","サカ","ムハッラム","サフアル","ラビー・ウル・アウワル","ラビー・ウッ・サーニー","ジュマーダル・アウワル","ジュマーダッサーニー","ラジャブ","シャアバーン","ラマダーン","シャウワール","ズル・カイダ","ズル・ヒッジャ","大化","白雉","白鳯","朱鳥","大宝","慶雲","和銅","霊亀","養老","神亀","天平","天平感宝","天平勝宝","天平宝字","天平神護","神護景雲","宝亀","天応","延暦","大同","弘仁","天長","承和","嘉祥","仁寿","斉衡","天安","貞観","元慶","仁和","寛平","昌泰","延喜","延長","承平","天慶","天暦","天徳","応和","康保","安和","天禄","天延","貞元","天元","永観","寛和","永延","永祚","正暦","長徳","長保","寛弘","長和","寛仁","治安","万寿","長元","長暦","長久","寛徳","永承","天喜","康平","治暦","延久","承保","承暦","永保","応徳","寛治","嘉保","永長","承徳","康和","長治","嘉承","天仁","天永","永久","元永","保安","天治","大治","天承","長承","保延","永治","康治","天養","久安","仁平","久寿","保元","平治","永暦","応保","長寛","永万","仁安","嘉応","承安","安元","治承","養和","寿永","元暦","文治","建久","正治","建仁","元久","建永","承元","建暦","建保","承久","貞応","元仁","嘉禄","安貞","寛喜","貞永","天福","文暦","嘉禎","暦仁","延応","仁治","寛元","宝治","建長","康元","正嘉","正元","文応","弘長","文永","建治","弘安","正応","永仁","正安","乾元","嘉元","徳治","延慶","応長","正和","文保","元応","元亨","正中","嘉暦","元徳","元弘","建武","延元","興国","正平","建徳","文中","天授","康暦","弘和","元中","至徳","嘉慶","康応","明徳","応永","正長","永享","嘉吉","文安","宝徳","享徳","康正","長禄","寛正","文正","応仁","文明","長享","延徳","明応","文亀","永正","大永","享禄","天文","弘治","永禄","元亀","天正","文禄","慶長","元和","寛永","正保","慶安","承応","明暦","万治","寛文","延宝","天和","貞享","元禄","宝永","正徳","享保","元文","寛保","延享","寛延","宝暦","明和","安永","天明","寛政","享和","文化","文政","天保","弘化","嘉永","安政","万延","文久","元治","慶応","明治","大正","昭和","平成","ファルヴァルディーン","オルディーベヘシュト","ホルダード","ティール","モルダード","シャハリーヴァル","メフル","アーバーン","アーザル","デイ","バフマン","エスファンド","民国前","民国","元","￥","￦","M.d.y","Nduŋmbi Saŋ","Pɛsaŋ Pɛ́pá","Pɛsaŋ Pɛ́tát","Pɛsaŋ Pɛ́nɛ́kwa","Pɛsaŋ Pataa","Pɛsaŋ Pɛ́nɛ́ntúkú","Pɛsaŋ Saambá","Pɛsaŋ Pɛ́nɛ́fɔm","Pɛsaŋ Pɛ́nɛ́pfúꞋú","Pɛsaŋ Nɛgɛ́m","Pɛsaŋ Ntsɔ̌pmɔ́","Pɛsaŋ Ntsɔ̌ppá","Sɔ́","Mɔ́","ÁM","Wɛ́","Tɔ́","Fɛ","Sá","Sɔ́ndi","Mɔ́ndi","Ápta Mɔ́ndi","Wɛ́nɛsɛdɛ","Tɔ́sɛdɛ","Fɛlâyɛdɛ","Sásidɛ","mbaꞌmbaꞌ","ŋka mbɔ́t nji","tsɛttsɛt mɛŋguꞌ mi ɛ́ lɛɛnɛ Kɛlísɛtɔ gɔ ńɔ́","tsɛttsɛt mɛŋguꞌ mi ɛ́ fúnɛ Kɛlísɛtɔ tɔ́ mɔ́","Aprilyi","Junyi","Julyai","Agusti","Iju","Jumapilyi","Jumatatuu","Jumatanu","utuko","kyiukonyi","Kabla ya Kristu","Baada ya Kristu","MMM, y G","QQQ, y","QQQQ, y","EEEE, dd MMMM, y","ი","თ","მ","ა","ს","ო","ნ","დ","იან","თებ","მარ","აპრ","მაი","ივნ","ივლ","აგვ","სექ","ოქტ","ნოე","დეკ","იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი","კ","ხ","პ","შ","კვი","ორშ","სამ","ოთხ","ხუთ","პარ","შაბ","კვირა","ორშაბათი","სამშაბათი","ოთხშაბათი","ხუთშაბათი","პარასკევი","შაბათი","ძვ. წ.","ახ. წ.","ძველი წელთაღრიცხვით","ახალი წელთაღრიცხვით","ჩვენს ერამდე","ჩვენი ერა","თიშრეი","ხეშვანი","ქისლევი","ტევეთი","შვატი","ადარი I","ადარი","ნისანი","იარი","სივანი","თამუზი","ავი","ელული","ადარი II","მუჰ.","საფ.","რაბ. I","რაბ. II","ჯუმ. I","ჯუმ. II","რაჯ.","შაბ.","რამ.","შავ.","ზულ-კ.","ზულ-ჰ.","მუჰარამი","საფარი","რაბი ულ-ავალი","რაბი ულ-ახირი","ჯუმადა ულ-ავალი","ჯუმადა ულ-ახირი","რაჯაბი","შაბანი","რამადანი","შავალი","ზულ-კაადა","ზულ-ჰიჯა","ფარვარდინი","ორდიბეჰეშთი","ხორდადი","თირი","მორდადი","შაჰრივარი","მეჰრი","აბანი","აზარი","დეი","ბაჰმანი","ესფანდი","არ არის რიცხვი","Ɣ","Yen","Fur","Meɣ","Yeb","Ɣuc","Cte","Tub","Nun","Duǧ","Yennayer","Fuṛar","Meɣres","Yebrir","Mayyu","Yunyu","Yulyu","Ɣuct","Ctembeṛ","Tubeṛ","Nunembeṛ","Duǧembeṛ","Yan","San","Kraḍ","Kuẓ","Sam","Sḍis","Say","Yanass","Sanass","Kraḍass","Kuẓass","Samass","Sḍisass","Sayass","n tufat","n tmeddit","snd. T.Ɛ","sld. T.Ɛ","send talalit n Ɛisa","seld talalit n Ɛisa","Ĩ","Kel","Ktũ","Ktn","Tha","Moo","Nya","Knd","Ĩku","Ĩkm","Ĩkl","Mwai wa mbee","Mwai wa kelĩ","Mwai wa katatũ","Mwai wa kana","Mwai wa katano","Mwai wa thanthatũ","Mwai wa muonza","Mwai wa nyaanya","Mwai wa kenda","Mwai wa ĩkumi","Mwai wa ĩkumi na ĩmwe","Mwai wa ĩkumi na ilĩ","Wky","Wkw","Wkl","Wtũ","Wkn","Wtn","Wth","Wa kyumwa","Wa kwambĩlĩlya","Wa kelĩ","Wa katatũ","Wa kana","Wa katano","Wa thanthatũ","Ĩyakwakya","Ĩyawĩoo","MY","IY","Mbee wa Yesũ","Ĩtina wa Yesũ","Mwedi Ntandi","Mwedi wa Pili","Mwedi wa Tatu","Mwedi wa Nchechi","Mwedi wa Nnyano","Mwedi wa Nnyano na Umo","Mwedi wa Nnyano na Mivili","Mwedi wa Nnyano na Mitatu","Mwedi wa Nnyano na Nchechi","Mwedi wa Nnyano na Nnyano","Mwedi wa Nnyano na Nnyano na U","Mwedi wa Nnyano na Nnyano na M","Ll2","Ll3","Ll4","Ll5","Ll6","Ll7","Ll1","Liduva lyapili","Liduva lyatatu","Liduva lyanchechi","Liduva lyannyano","Liduva lyannyano na linji","Liduva lyannyano na mavili","Liduva litandi","Muhi","Chilo","AY","NY","Akanapawa Yesu","Nankuida Yesu","MMM 'di' y G","E, d 'di' MMM 'di' y G","d 'di' MMM 'di' y G","E, dd/MM","E, d 'di' MMMM","MMM 'di' y","MMMM 'di' y","QQQQ 'di' y","EEEE, d 'di' MMMM 'di' y","d 'di' MMMM 'di' y","Nuv","Diz","Janeru","Febreru","Marsu","Maiu","Junhu","Julhu","Agostu","Setenbru","Otubru","Nuvenbru","Dizenbru","sig","kua","kin","ses","dumingu","sigunda-fera","tersa-fera","kuarta-fera","kinta-fera","sesta-fera","sabadu","DK","AEK","EK","Antis di Kristu","Dispos di Kristu","Antis di Era Kumun","Era Kumun","​","Alj","Ass","Atini","Atalata","Alhamiisa","Aljuma","Assabdu","Adduha","Aluula","Isaa jamanoo","JEN","WKR","WGT","WKN","WTN","WTD","WMJ","WNN","WKD","WIK","WMW","DIT","Njenuarĩ","Mwere wa kerĩ","Mwere wa gatatũ","Mwere wa kana","Mwere wa gatano","Mwere wa gatandatũ","Mwere wa mũgwanja","Mwere wa kanana","Mwere wa kenda","Mwere wa ikũmi","Mwere wa ikũmi na ũmwe","Ndithemba","KMA","NTT","NMN","NMT","ART","NMA","Njumatatũ","Njumatana","Njumamothi","Kiroko","Hwaĩ-inĩ","E, dd-MM-y","y, dd-MMM","Қ","А","Н","С","М","Ш","Т","Ж","қаң.","ақп.","нау.","сәу.","мам.","мау.","шіл.","там.","қыр.","қаз.","қар.","желт.","қаңтар","ақпан","наурыз","сәуір","мамыр","маусым","шілде","тамыз","қыркүйек","қазан","қараша","желтоқсан","Д","Б","жек","дүй","сей","сәр","бей","жұма","сен","жексенбі","дүйсенбі","сейсенбі","сәрсенбі","бейсенбі","сенбі","таңертеңгі","түстен кейінгі","б.з.д.","б.з.","ж.з.","Біздің заманымызға дейін","Біздің заманымыз","Жаңа заман","БД","КД$","₸","MM y","E dd/MM y","dd/MM y","pamba","wanja","mbiyɔ mɛndoŋgɔ","Nyɔlɔmbɔŋgɔ","Mɔnɔ ŋgbanja","Nyaŋgwɛ ŋgbanja","kuŋgwɛ","fɛ","njapi","nyukul","ɓulɓusɛ","ye","va","ms","sɔndi","mɛrkɛrɛdi","yedi","vaŋdɛrɛdi","mɔnɔ sɔndi","januari","februari","martsi","aprili","maji","augustusi","septemberi","oktoberi","novemberi","decemberi","ata","pin","sis","tal","arf","sabaat","ataasinngorneq","marlunngorneq","pingasunngorneq","sisamanngorneq","tallimanngorneq","arfininngorneq","ulloqeqqata-tungaa","ulloqeqqata-kingorna","Kr.s.","Kr.k.","Kr.in.si.","Kr.in.king.","Kristusip inunngornerata siornagut","Kristusip inunngornerata kingornagut","Nkr","Skr","Nga","Kip","Iwa","Nge","Wak","Rop","Kog","Bur","Epe","Aen","Mulgul","Ng’atyato","Kiptamo","Iwat kut","Ng’eiyet","Waki","Roptui","Kipkogaga","Buret","Epeso","Kipsunde netai","Kipsunde nebo aeng","Som","Ang","Mut","Loh","Betutab tisap","Betut netai","Betutab aeng’","Betutab somok","Betutab ang’wan","Betutab mut","Betutab lo","Beet","Kemo","KO","Amait kesich Jesu","Kokakesich Jesu","y នៃ G","MMM y នៃ G","E d MMM y នៃ G","d MMM y នៃ G","មករា","កុម្ភៈ","មីនា","មេសា","ឧសភា","មិថុនា","កក្កដា","សីហា","កញ្ញា","តុលា","វិច្ឆិកា","ធ្នូ","អាទិត្យ","ចន្ទ","អង្គារ","ពុធ","ព្រហស្បតិ៍","សុក្រ","សៅរ៍","ព.ស.","ព្រឹក","ល្ងាច","មុន គ.ស.","គ.ស.","មុន​គ្រិស្តសករាជ","គ្រិស្តសករាជ","៛","d/M, E","MMM d,y","ಜ","ಫೆ","ಮಾ","ಏ","ಮೇ","ಜೂ","ಜು","ಆ","ಸೆ","ಅ","ನ","ಡಿ","ಜನ","ಫೆಬ್ರ","ಮಾರ್ಚ್","ಏಪ್ರಿ","ಜೂನ್","ಜುಲೈ","ಆಗ","ಸೆಪ್ಟೆಂ","ಅಕ್ಟೋ","ನವೆಂ","ಡಿಸೆಂ","ಜನವರಿ","ಫೆಬ್ರವರಿ","ಏಪ್ರಿಲ್","ಆಗಸ್ಟ್","ಸೆಪ್ಟೆಂಬರ್","ಅಕ್ಟೋಬರ್","ನವೆಂಬರ್","ಡಿಸೆಂಬರ್","ಭಾ","ಸೋ","ಮಂ","ಬು","ಗು","ಶು","ಶ","ಭಾನು","ಸೋಮ","ಮಂಗಳ","ಬುಧ","ಗುರು","ಶುಕ್ರ","ಶನಿ","ಭಾನುವಾರ","ಸೋಮವಾರ","ಮಂಗಳವಾರ","ಬುಧವಾರ","ಗುರುವಾರ","ಶುಕ್ರವಾರ","ಶನಿವಾರ","ಪೂರ್ವಾಹ್ನ","ಅಪರಾಹ್ನ","ಕ್ರಿ.ಪೂ","ಕ್ರಿ.ಶ","ಕ್ರಿ.ಪೂ.ಕಾಲ","ಪ್ರಸಕ್ತ ಶಕ","ಕ್ರಿಸ್ತ ಪೂರ್ವ","ಕ್ರಿಸ್ತ ಶಕ","d일 EEEE","(E) HH:mm","(E) HH:mm:ss","d일 (E)","(E) a h:mm","(E) a h:mm:ss","G y년","G y년 MMM","G y년 MMM d일 EEEE","G y년 MMM d일 (E)","G y년 MMM d일","H시","H시 m분 s초","M월","M. d. EEEE","M. d. (E)","MMM d일 EEEE","MMM d일 (E)","MMM d일","d일","a h시","y년","y. M. d. EEEE","y. M. d. (E)","y년 MMM","y년 MMM d일 EEEE","y년 MMM d일 (E)","y년 MMM d일","y. M. d.","y년 QQQ","y년 QQQQ","y년 M월 d일 EEEE","y년 M월 d일","yy. M. d.","a h시 m분 s초 zzzz","a h시 m분 s초 z","1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월","일","월","화","수","목","금","토","일요일","월요일","화요일","수요일","목요일","금요일","토요일","불기","오전","오후","투트","바바흐","하투르","키야흐크","투바흐","암쉬르","바라마트","바라문다흐","바샨스","바우나흐","아비브","미스라","나시","매스캐램","테켐트","헤다르","타흐사스","테르","얘카티트","매가비트","미야지야","겐보트","새네","함레","내하세","파구맨","기원전","서기","디스리월","말케스월","기슬르월","데벳월","스밧월","아달월 1","아달월","닛산월","이야르월","시완월","담무르월","압월","엘룰월","아달월 2","다이카 (645 ~ 650)","하쿠치 (650 ~ 671)","하쿠호 (672 ~ 686)","슈초 (686 ~ 701)","다이호 (701 ~ 704)","게이운 (704 ~ 708)","와도 (708 ~ 715)","레이키 (715 ~ 717)","요로 (717 ~ 724)","진키 (724 ~ 729)","덴표 (729 ~ 749)","덴표칸포 (749 ~ 749)","덴표쇼호 (749 ~ 757)","덴표호지 (757 ~ 765)","덴표진고 (765 ~ 767)","진고케이운 (767 ~ 770)","호키 (770 ~ 780)","덴오 (781 ~ 782)","엔랴쿠 (782 ~ 806)","다이도 (806 ~ 810)","고닌 (810 ~ 824)","덴초 (824 ~ 834)","조와 (834 ~ 848)","가쇼 (848 ~ 851)","닌주 (851 ~ 854)","사이코 (854 ~ 857)","덴난 (857 ~ 859)","조간 (859 ~ 877)","간교 (877 ~ 885)","닌나 (885 ~ 889)","간표 (889 ~ 898)","쇼타이 (898 ~ 901)","엔기 (901 ~ 923)","엔초 (923 ~ 931)","조헤이 (931 ~ 938)","덴교 (938 ~ 947)","덴랴쿠 (947 ~ 957)","덴토쿠 (957 ~ 961)","오와 (961 ~ 964)","고호 (964 ~ 968)","안나 (968 ~ 970)","덴로쿠 (970 ~ 973)","덴엔 (973 ~ 976)","조겐 (976 ~ 978)","덴겐 (978 ~ 983)","에이간 (983 ~ 985)","간나 (985 ~ 987)","에이엔 (987 ~ 989)","에이소 (989 ~ 990)","쇼랴쿠 (990 ~ 995)","조토쿠 (995 ~ 999)","조호 (999 ~ 1004)","간코 (1004 ~ 1012)","조와 (1012 ~ 1017)","간닌 (1017 ~ 1021)","지안 (1021 ~ 1024)","만주 (1024 ~ 1028)","조겐 (1028 ~ 1037)","조랴쿠 (1037 ~ 1040)","조큐 (1040 ~ 1044)","간토쿠 (1044 ~ 1046)","에이쇼 (1046 ~ 1053)","덴기 (1053 ~ 1058)","고헤이 (1058 ~ 1065)","지랴쿠 (1065 ~ 1069)","엔큐 (1069 ~ 1074)","조호 (1074 ~ 1077)","쇼랴쿠 (1077 ~ 1081)","에이호 (1081 ~ 1084)","오토쿠 (1084 ~ 1087)","간지 (1087 ~ 1094)","가호 (1094 ~ 1096)","에이초 (1096 ~ 1097)","조토쿠 (1097 ~ 1099)","고와 (1099 ~ 1104)","조지 (1104 ~ 1106)","가쇼 (1106 ~ 1108)","덴닌 (1108 ~ 1110)","덴에이 (1110 ~ 1113)","에이큐 (1113 ~ 1118)","겐에이 (1118 ~ 1120)","호안 (1120 ~ 1124)","덴지 (1124 ~ 1126)","다이지 (1126 ~ 1131)","덴쇼 (1131 ~ 1132)","조쇼 (1132 ~ 1135)","호엔 (1135 ~ 1141)","에이지 (1141 ~ 1142)","고지 (1142 ~ 1144)","덴요 (1144 ~ 1145)","규안 (1145 ~ 1151)","닌페이 (1151 ~ 1154)","규주 (1154 ~ 1156)","호겐 (1156 ~ 1159)","헤이지 (1159 ~ 1160)","에이랴쿠 (1160 ~ 1161)","오호 (1161 ~ 1163)","조칸 (1163 ~ 1165)","에이만 (1165 ~ 1166)","닌난 (1166 ~ 1169)","가오 (1169 ~ 1171)","조안 (1171 ~ 1175)","안겐 (1175 ~ 1177)","지쇼 (1177 ~ 1181)","요와 (1181 ~ 1182)","주에이 (1182 ~ 1184)","겐랴쿠 (1184 ~ 1185)","분지 (1185 ~ 1190)","겐큐 (1190 ~ 1199)","쇼지 (1199 ~ 1201)","겐닌 (1201 ~ 1204)","겐큐 (1204 ~ 1206)","겐에이 (1206 ~ 1207)","조겐 (1207 ~ 1211)","겐랴쿠 (1211 ~ 1213)","겐포 (1213 ~ 1219)","조큐 (1219 ~ 1222)","조오 (1222 ~ 1224)","겐닌 (1224 ~ 1225)","가로쿠 (1225 ~ 1227)","안테이 (1227 ~ 1229)","간키 (1229 ~ 1232)","조에이 (1232 ~ 1233)","덴푸쿠 (1233 ~ 1234)","분랴쿠 (1234 ~ 1235)","가테이 (1235 ~ 1238)","랴쿠닌 (1238 ~ 1239)","엔오 (1239 ~ 1240)","닌지 (1240 ~ 1243)","간겐 (1243 ~ 1247)","호지 (1247 ~ 1249)","겐초 (1249 ~ 1256)","고겐 (1256 ~ 1257)","쇼카 (1257 ~ 1259)","쇼겐 (1259 ~ 1260)","분오 (1260 ~ 1261)","고초 (1261 ~ 1264)","분에이 (1264 ~ 1275)","겐지 (1275 ~ 1278)","고안 (1278 ~ 1288)","쇼오 (1288 ~ 1293)","에이닌 (1293 ~ 1299)","쇼안 (1299 ~ 1302)","겐겐 (1302 ~ 1303)","가겐 (1303 ~ 1306)","도쿠지 (1306 ~ 1308)","엔쿄 (1308 ~ 1311)","오초 (1311 ~ 1312)","쇼와 (1312 ~ 1317)","분포 (1317 ~ 1319)","겐오 (1319 ~ 1321)","겐코 (1321 ~ 1324)","쇼추 (1324 ~ 1326)","가랴쿠 (1326 ~ 1329)","겐토쿠 (1329 ~ 1331)","겐코 (1331 ~ 1334)","겐무 (1334 ~ 1336)","엔겐 (1336 ~ 1340)","고코쿠 (1340 ~ 1346)","쇼헤이 (1346 ~ 1370)","겐토쿠 (1370 ~ 1372)","분추 (1372 ~ 1375)","덴주 (1375 ~ 1379)","고랴쿠 (1379 ~ 1381)","고와 (1381 ~ 1384)","겐추 (1384 ~ 1392)","메이토쿠 (1384 ~ 1387)","가쿄 (1387 ~ 1389)","고오 (1389 ~ 1390)","메이토쿠 (1390 ~ 1394)","오에이 (1394 ~ 1428)","쇼초 (1428 ~ 1429)","에이쿄 (1429 ~ 1441)","가키쓰 (1441 ~ 1444)","분안 (1444 ~ 1449)","호토쿠 (1449 ~ 1452)","교토쿠 (1452 ~ 1455)","고쇼 (1455 ~ 1457)","조로쿠 (1457 ~ 1460)","간쇼 (1460 ~ 1466)","분쇼 (1466 ~ 1467)","오닌 (1467 ~ 1469)","분메이 (1469 ~ 1487)","조쿄 (1487 ~ 1489)<","엔토쿠 (1489 ~ 1492)","메이오 (1492 ~ 1501)","분키 (1501 ~ 1504)","에이쇼 (1504 ~ 1521)","다이에이 (1521 ~ 1528)","교로쿠 (1528 ~ 1532)","덴분 (1532 ~ 1555)","고지 (1555 ~ 1558)","에이로쿠 (1558 ~ 1570)","겐키 (1570 ~ 1573)","덴쇼 (1573 ~ 1592)","분로쿠 (1592 ~ 1596)","게이초 (1596 ~ 1615)","겐나 (1615 ~ 1624)","간에이 (1624 ~ 1644)","쇼호 (1644 ~ 1648)","게이안 (1648 ~ 1652)","조오 (1652 ~ 1655)","메이레키 (1655 ~ 1658)","만지 (1658 ~ 1661)","간분 (1661 ~ 1673)","엔포 (1673 ~ 1681)","덴나 (1681 ~ 1684)","조쿄 (1684 ~ 1688)","겐로쿠 (1688 ~ 1704)","호에이 (1704 ~ 1711)","쇼토쿠 (1711 ~ 1716)","교호 (1716 ~ 1736)","겐분 (1736 ~ 1741)","간포 (1741 ~ 1744)","엔쿄 (1744 ~ 1748)","간엔 (1748 ~ 1751)","호레키 (1751 ~ 1764)","메이와 (1764 ~ 1772)","안에이 (1772 ~ 1781)","덴메이 (1781 ~ 1789)","간세이 (1789 ~ 1801)","교와 (1801 ~ 1804)","분카 (1804 ~ 1818)","분세이 (1818 ~ 1830)","덴포 (1830 ~ 1844)","고카 (1844 ~ 1848)","가에이 (1848 ~ 1854)","안세이 (1854 ~ 1860)","만엔 (1860 ~ 1861)","분큐 (1861 ~ 1864)","겐지 (1864 ~ 1865)","게이오 (1865 ~ 1868)","메이지","다이쇼","쇼와","헤이세이","중화민국전","중화민국","d-M-yy","जानेवारी","एप्रिल","जुलै","ओगस्ट","सेप्टेंबर","ओक्टोबर","नोव्हेंबर","डिसेंबर","मंगळ","आदित्यवार","मंगळार","म.पू.","म.नं.","क्रिस्तपूर्व","क्रिस्तशखा","Gy","MMM Gy","EEE, MMM d, Gy","MMM d, Gy","EEE, M/d/y","EEE, MMM d, y","جنؤری","فرؤری","مارٕچ","میٔ","جوٗن","جوٗلایی","ستمبر","اکتوٗبر","آتھوار","ژٔنٛدٕروار","بوٚموار","بودوار","برٛٮ۪سوار","جُمہ","بٹوار","اَتھوار","ژٔنٛدرٕروار","بی سی","اے ڈی","قبٕل مسیٖح","عیٖسوی سنہٕ","ربیٖع الاول","ربیٖع الثانی","ذِی القد","ذِی الحج","?","Januali","Febluali","Aplili","Jmn","Jumaapii","Jumaatatu","Jumaane","Jumaatano","Jumaamosi","makeo","nyiaghuo","Kabla ya Klisto","Baada ya Klisto","ŋ1","ŋ2","ŋ3","ŋ4","ŋ5","ŋ6","ŋ7","ŋ8","ŋ9","ŋ10","ŋ11","ŋ12","ŋwíí a ntɔ́ntɔ","ŋwíí akǝ bɛ́ɛ","ŋwíí akǝ ráá","ŋwíí akǝ nin","ŋwíí akǝ táan","ŋwíí akǝ táafɔk","ŋwíí akǝ táabɛɛ","ŋwíí akǝ táaraa","ŋwíí akǝ táanin","ŋwíí akǝ ntɛk","ŋwíí akǝ ntɛk di bɔ́k","ŋwíí akǝ ntɛk di bɛ́ɛ","lǝn","maa","mɛk","jǝǝ","júm","sam","sɔ́ndǝ","lǝndí","maadí","mɛkrɛdí","jǝǝdí","júmbá","samdí","sárúwá","cɛɛ́nko","d.Y.","k.Y.","di Yɛ́sus aká yálɛ","cámɛɛn kǝ kǝbɔpka Y","E 'dä' d.","Y-MM","E d. MMM. y","d. MMM. y","QQQy","EEEE, 'dä' d. MMMM y","Fäb","Mäz","Mäi","Ouj","Säp","Jannewa","Fäbrowa","Määz","Aprell","Juuni","Juuli","Oujoß","Me.","Sunndaach","Moondaach","Dinnsdaach","Metwoch","Dunnersdaach","Friidaach","Samsdaach","Uhr vörmiddaachs","Uhr nommendaachs","vC","nC","vür Chrestus","noh Chrestus","vür der gewöhnlichen Zeitrechnung","Whe","Efn","Gor","Gwn","Hed","Kev","Mys Genver","Mys Whevrel","Mys Merth","Mys Ebrel","Mys Me","Mys Efan","Mys Gortheren","Mye Est","Mys Gwyngala","Mys Hedra","Mys Du","Mys Kevardhu","Mth","Mhr","Yow","Gwe","De Sul","De Lun","De Merth","De Merher","De Yow","De Gwener","De Sadorn","G y-'ж'.","G y-'ж'. MMM","G y-'ж'. d-MMM, E","G y-'ж'. d-MMM","dd-MM, E","d-MMM, E","y-'ж'. MMM","y-'ж'. d-MMM, E","y-'ж'. d-MMM","y-'ж'., QQQ","y-'ж'., QQQQ","EEEE, d-MMMM, y-'ж'.","Я","Ф","И","О","янв.","фев.","мар.","июн.","июл.","сен.","ноя.","январь","февраль","апрель","июнь","июль","сентябрь","октябрь","ноябрь","декабрь","жек.","дүй.","шейш.","шарш.","бейш.","жума","ишм.","жекшемби","дүйшөмбү","шейшемби","шаршемби","бейшемби","ишемби","таңкы","түштөн кийин","б.з. ч.","б.з.ч.","биздин заманга чейин","биздин заман","сан эмес","сом","Fúngatɨ","Naanɨ","Keenda","Ikúmi","Inyambala","Idwaata","Mʉʉnchɨ","Vɨɨrɨ","Saatʉ","Inyi","Saano","Sasatʉ","Kʉfúngatɨ","Kʉnaanɨ","Kʉkeenda","Kwiikumi","Kwiinyambála","Kwiidwaata","Kʉmʉʉnchɨ","Kʉvɨɨrɨ","Kʉsaatʉ","Kwiinyi","Kʉsaano","Kʉsasatʉ","Píili","Táatu","Íne","Táano","Móosi","Jumapíiri","Jumatátu","Jumaíne","Jumatáano","Alamíisi","Ijumáa","Jumamóosi","TOO","MUU","KSA","KA","Kɨrɨsitʉ sɨ anavyaal","Kɨrɨsitʉ akavyaalwe","HH 'Auer'","Mäe.","Abr.","Mäerz","Abrëll","Son.","Méi.","Dën.","Mët.","Don.","Fre.","Sam.","Sonndeg","Méindeg","Dënschdeg","Mëttwoch","Donneschdeg","Freideg","Samschdeg","moies","nomëttes","v. e. Z.","n. e. Z.","Apu","Seb","Oki","Janwaliyo","Febwaliyo","Marisi","Apuli","Maayi","Julaayi","Agusito","Sebuttemba","Okitobba","Bal","Lw2","Lw3","Lw4","Lw5","Lw6","Sabbiiti","Balaza","Lwakubiri","Lwakusatu","Lwakuna","Lwakutaano","Lwamukaaga","Kulisito nga tannaza","Bukya Kulisito Azaal","Wiótheȟika Wí","Thiyóȟeyuŋka Wí","Ištáwičhayazaŋ Wí","Pȟežítȟo Wí","Čhaŋwápetȟo Wí","Wípazukȟa-wašté Wí","Čhaŋpȟásapa Wí","Wasútȟuŋ Wí","Čhaŋwápeǧi Wí","Čhaŋwápe-kasná Wí","Waníyetu Wí","Tȟahékapšuŋ Wí","Aŋpétuwakȟaŋ","Aŋpétuwaŋži","Aŋpétunuŋpa","Aŋpétuyamni","Aŋpétutopa","Aŋpétuzaptaŋ","Owáŋgyužažapi","ɔ","fbl","msi","apl","yun","yul","agt","stb","ɔtb","nvb","dsb","sánzá ya yambo","sánzá ya míbalé","sánzá ya mísáto","sánzá ya mínei","sánzá ya mítáno","sánzá ya motóbá","sánzá ya nsambo","sánzá ya mwambe","sánzá ya libwa","sánzá ya zómi","sánzá ya zómi na mɔ̌kɔ́","sánzá ya zómi na míbalé","eye","ybo","mbl","mst","min","mtn","mps","eyenga","mokɔlɔ mwa yambo","mokɔlɔ mwa míbalé","mokɔlɔ mwa mísáto","mokɔlɔ ya mínéi","mokɔlɔ ya mítáno","mpɔ́sɔ","ntɔ́ngɔ́","mpókwa","libóso ya","nsima ya Y","Yambo ya Yézu Krís","Nsima ya Yézu Krís","E d MMMM, G y","d MMMM, G y","h ໂມງa","EEEE ທີ d MMMM G y","H ໂມງ m ນາທີ ss ວິນາທີ zzzz","H ໂມງ m ນາທີ ss ວິນາທີ z","ມ.ກ.","ກ.ພ.","ມ.ນ.","ມ.ສ.","ພ.ພ.","ມິ.ຖ.","ກ.ລ.","ສ.ຫ.","ກ.ຍ.","ຕ.ລ.","ພ.ຈ.","ທ.ວ.","ມັງກອນ","ກຸມພາ","ມີນາ","ເມສາ","ພຶດສະພາ","ມິຖຸນາ","ກໍລະກົດ","ສິງຫາ","ກັນຍາ","ຕຸລາ","ພະຈິກ","ທັນວາ","ວັນອາທິດ","ວັນຈັນ","ວັນອັງຄານ","ວັນພຸດ","ວັນພະຫັດ","ວັນສຸກ","ວັນເສົາ","ພ.ສ.","ກ່ອນທ່ຽງ","ຫຼັງທ່ຽງ","ເທົາ","ບາບາ","ຮາໂຕ","ເຄຍ","ໂທບາ","ອຳເຊີ","ບາລຳຮາດ","ບາລາມູດາ","ບາສຮານ","ເປົານາ","ອີແປບ","ມາສລາ","ນາຊິວ","ອາເຊີ","ນາຊີວ","ແມສເຄີແຣມ","ເຕເກມ","ເຮດາ","ທາຊັສ","ເທີ","ເຍຄາທິດ","ເມກາບິດ","ເມຍເຊຍ","ເຈນບອດ","ເຊເນ","ຮຳເລ","ເນແຮສ໌","ພາກູເມນ","ກ່ອນ ຄ.ສ.","ຄ.ສ.","ກ່ອນຄຣິດສັກກະລາດ","ຄຣິດສັກກະລາດ","ກ່ອນສາກົນສັກກະລາດ","ສາກົນສັກກະລາດ","ທຣິດຣີ","ເຮວານ","ກິດເລບ","ເຕເວດ","ຊີວັດ","ອາດາ I","ອາດາ","ນິດຊານ","ອີຍາຣ","ສີວານ","ຕາມູ","ເອບ","ອີລູ","ອາດາ II","ອີຍາ","ອາດ II","ຈິຕຣາ","ວິສາຂະ","ເຊດຖາ","ອັດສາ","ສາຣາວານາ","ພະຕຣາ","ອັສວິຊາ","ການຕິກາ","ອັກຣາຮາຢານາ","ປຸສາ","ມາຄະ","ຜາລກຸນີ","ປຸສະຍາ","ມຸຮັດ","ເຄາະ","ຮອດບີ 1","ຮອກບີ 2","ນຸມາ 1","ນຸມາ 2","ເຮາະ","ຊະອ໌","ເຮາະມະ","ເຊົາ","ຊຸລກິອຸ","ຊຸລຫິຈ","ມຸຣະຮອມ","ຊາຟາຣ","ຮາບີ 1","ຮາບີ 2","ຈຸມາດາ 1","ຈຸມາດາ 2","ຮາຈັບ","ຊະບານ","ຮາມາດອນ","ເຊົາວັດ","ດຸອັດກິດະ","ດຸອັດກິຈະ","ທະອິກະ (645–650)","ຮາກູຊິ (650–671)","ຮາກູໂຮ (672–686)","ຊູໂຊ (686–701)","ທາອິໂຮ (701–704)","ເຄອຸງ (704–708)","ວະໂດ (708–715)","ເຣອິກິ (715–717)","ໂຢໂຣ (717–724)","ຈິງກິ (724–729)","ເທັມປຽວ (729–749)","ເທັມປຽວ-ຄໍາໂປ (749–749)","ເທັມປຽວ-ໂຊໂຮ (749–757)","ເທັມປຽວ-ໂຮຈິ (757–765)","ເທັມປຽວ-ຈິງໂງະ (765–767)","ຈິງໂງະ-ເຄອຸງ (767–770)","ໂຮກິ (770–780)","ເທັນ-ໂອ (781–782)","ເອັນຣຢາກຸ (782–806)","ດາອິໂດ (806–810)","ໂກນິນ (810–824)","ເທັນໂຊ (824–834)","ໂຊວະ (834–848)","ກະໂຈ (848–851)","ນິນຈູ (851–854)","ສະອິໂກະ (854–857)","ເທັນນານ (857–859)","ໂຈງານ (859–877)","ເກັນເກ (877–885)","ນິນນາ (885–889)","ກໍາປຽວ (889–898)","ໂຊຕາອິ (898–901)","ເອັນງິ (901–923)","ເອັນໂຊ (923–931)","ໂຊເຮ (931–938)","ເທັນງຽວ (938–947)","ເທັນຣຢາກູ (947–957)","ເທັນໂຕະກຸ (957–961)","ໂອວະ (961–964)","ໂກໂຮ (964–968)","ອານະ (968–970)","ເທັນໂຣະກຸ (970–973)","ເທັນ-ເອັນ (973–976)","ໂຈເງັນ (976–978)","ເທັນເງັນ (978–983)","ເອການ (983–985)","ການນະ (985–987)","ເອ-ເອັນ (987–989)","ເອໂຊ (989–990)","ໂຊຣຢະກຸ (990–995)","ໂຊໂຕະກຸ (995–999)","ໂຊໂຮ (999–1004)","ການໂກ (1004–1012)","ໂຊຫວະ (1012–1017)","ການນິງ (1017–1021)","ຈິອານ (1021–1024)","ມານຈຸ (1024–1028)","ໂຊເງັນ (1028–1037)","ໂຊເຣຢະກຸ (1037–1040)","ໂຊຄິວ (1040–1044)","ການໂຕະກຸ (1044–1046)","ເອະໂຊ (1046–1053)","ເທັນງິ (1053–1058)","ໂກເຮ (1058–1065)","ຈິເຣຢະກຸ (1065–1069)","ເອັນຄິວ (1069–1074)","ໂຊະໂຮ (1074–1077)","ໂຊະເຣຢະກຸ (1077–1081)","ເອໂຊະ (1081–1084)","ໂອໂຕະກຸ (1084–1087)","ການຈິ (1087–1094)","ກາໂຊ (1094–1096)","ເອະໂຊະ (1096–1097)","ໂຊະໂຕະກຸ (1097–1099)","ໂກະວະ (1099–1104)","ໂຊະຈິ (1104–1106)","ກາໂຊະ (1106–1108)","ເທັນນິນ (1108–1110)","ເທັນ-ອິ (1110–1113)","ເອກິວ (1113–1118)","ເຄັນ-ເອ (1118–1120)","ໂຮະອານ (1120–1124)","ເທັນຈິ (1124–1126)","ດາອິຈິ (1126–1131)","ເທັນໂຊະ (1131–1132)","ໂຊະໂຊະ (1132–1135)","ໂຮເອັນ (1135–1141)","ເອຈິ (1141–1142)","ໂກະຈິ (1142–1144)","ເທັນໂຢະ (1144–1145)","ຄິວອານ (1145–1151)","ນິນເປ (1151–1154)","ຄິວຈຸ (1154–1156)","ໂຮເຄັນ (1156–1159)","ເຮຈິ (1159–1160)","ເອເຣຢະກຸ (1160–1161)","ໂອໂຊ (1161–1163)","ໂຊະການ (1163–1165)","ເອມານ (1165–1166)","ນິນ-ອານ (1166–1169)","ກະໂອ (1169–1171)","ໂຊະອານ (1171–1175)","ອານເຄັນ (1175–1177)","ຈິໂຊະ (1177–1181)","ໂຢະວະ (1181–1182)","ຈຸເອະ (1182–1184)","ເຄັນເຣຢຸກິ (1184–1185)","ບັນຈິ (1185–1190)","ເກັນຄິວ (1190–1199)","ໂຊຈິ (1199–1201)","ເກັນນິນ (1201–1204)","ເຄັນກິວ (1204–1206)","ເກັນ-ເອະ (1206–1207)","ໂຊະເຄັນ (1207–1211)","ເກັນເຣຢະກຸ (1211–1213)","ເກັນໂປະ (1213–1219)","ໂຊະກິວ (1219–1222)","ໂຈະໂອະ (1222–1224)","ເຄັນນິນ (1224–1225)","ກາໂຮກຸ (1225–1227)","ອານເຕະ (1227–1229)","ການກິ (1229–1232)","ໂຈະເອະ (1232–1233)","ເທັມປຸກຸ (1233–1234)","ບັນເຣຢະກຸ (1234–1235)","ກາເຕະ (1235–1238)","ເຣຢະກຸນິນ (1238–1239)","ເອັນ-ໂອ (1239–1240)","ນິນຈີ (1240–1243)","ຄານເຈນ (1243–1247)","ໂຫຈີ (1247–1249)","ເຄນໂຊ (1249–1256)","ໂຄເຈນ (1256–1257)","ໂຊກາ (1257–1259)","ໂຊເກນ (1259–1260)","ບຸນ-ໂອ (1260–1261)","ໂຄໂຊ (1261–1264)","ບຸນ-ອີ (1264–1275)","ເຄນຈີ (1275–1278)","ເຄິນ (1278–1288)","ໂຊ (1288–1293)","ອິນນິນ (1293–1299)","ເຊີນ (1299–1302)","ເຄນເຈນ (1302–1303)","ຄາເຈນ (1303–1306)","ໂຕກູຈິ (1306–1308)","ອິນກິ (1308–1311)","ໂອໂຊ (1300–1312)","ໂຊວາ (1312–1317)","ບຸນໂປ (1317–1319)","ຈີໂນ (1319–1321)","ເຈນກຽວ (1321–1324)","ໂຊຊິ (1324–1326)","ຄາຣາກິ (1326–1329)","ເຈນໂຕກູ (1329–1331)","ເຈນໂກ (1331–1334)","ເກັມມຸ (1334–1336)","ເອັນເຈັນ (1336–1340)","ໂກໂກກຸ (1340–1346)","ໂຊຊິ (1346–1370)","ເຄນໂຕກຸ (1370–1372)","ບຸນຊຸ (1372–1375)","ເທັນຈຸ (1375–1379)","ຄໍຢາກຸ (1379–1381)","ໂກວາ (1381–1384)","ເຈັນຊຸ (1384–1392)","ມີໂຕກຸ (1384–1387)","ກາກິ (1387–1389)","ຄູ (1389–1390)","ມິໂຕກຸ (1390–1394)","ໂອອິ (1394–1428)","ໂຊໂຊ (1428–1429)","ອິກຽວ (1429–1441)","ກາກິຊຸ (1441–1444)","ບຸນ-ອານ (1444–1449)","ໂຫໂຕກຸ (1449–1452)","ກຽວໂຕກຸ (1452–1455)","ເກໂຊ (1455–1457)","ໂຊໂຣກຸ (1457–1460)","ຄານໂຊ (1460–1466)","ບຸນໂຊ (1466–1467)","ໂອນິນ (1467–1469)","ບຸນມິ (1469–1487)","ໂຊກຽວ (1487–1489)","ເອັນໂຕກຸ (1489–1492)","ມິໂອ (1492–1501)","ບຸນກິ (1501–1504)","ອິໂຊ (1504–1521)","ໄຕອິ (1521–1528)","ກຽວໂຣກຸ (1528–1532)","ເທັນມອນ (1532–1555)","ໂກຈິ (1555–1558)","ອິໂຣກຸ (1558–1570)","ເຈັນກິ (1570–1573)","ເທັນໂຊ (1573–1592)","ບຸນໂຣກຸ (1592–1596)","ຄິໂຊ (1596–1615)","ເກັນວາ (1615–1624)","ຄານ-ອິ (1624–1644)","ໂຊໂຊ (1644–1648)","ຄຽນ (1648–1652)","ຊຸ (1652–1655)","ເມຍຢາກຸ (1655–1658)","ແມນຈິ (1658–1661)","ການບຸນ (1661–1673)","ເອັນໂປ (1673–1681)","ເທັນວາ (1681–1684)","ໂຈກຽວ (1684–1688)","ເຈັນໂຣກຸ (1688–1704)","ໂຫອິ (1704–1711)","ຊຸຕຸກຸ (1711–1716)","ກຽວຫຸ (1716–1736)","ເຈັນບຸນ (1736–1741)","ຄານໂປ (1741–1744)","ເອັນກຽວ (1744–1748)","ຄານ-ອິນ (1748–1751)","ໂຫຢາກຸ (1751–1764)","ເມຍວາ (1764–1772)","ເອັນ-ອິ (1772–1781)","ເທັນມິ (1781–1789)","ຄານຊິ (1789–1801)","ກຽວວາ (1801–1804)","ບຸນກາ (1804–1818)","ບຸນຊິ (1818–1830)","ເທັນໂປ (1830–1844)","ກຸກາ (1844–1848)","ກາອິ (1848–1854)","ແອັນຊິ (1854–1860)","ແມັນ-ເອັນ (1860–1861)","ບຸນກຸ (1861–1864)","ເຈນຈີ (1864–1865)","ຄີໂອ (1865–1868)","ມີຈີ","ໄຕໂຊ","ໂຊວາ","ຮີຊີ","ຟາຣວາດິນ","ອໍຣດີບີເຫຣດ","ຄໍຣເດດ","ແຕຣ","ມໍຣເດດ","ຊາຣຫິວາ","ເມີ","ອາບານ","ອາຊາ","ດີຣ","ບຣາມານ","ເອສຟານ","ຟຣາວາດິນ","ມໍຣດາເ","ອາຊາຣ","ບຣາແມນ","ປີເປີເຊຍ","ກ່ອນ R.O.C.","ບໍ່​ແມ່ນ​ໂຕ​ເລກ","₭","HH:mm, E","HH:mm:ss, E","hh:mm a, E","hh:mm:ss a, E","y-MM G","y-MM-dd G, E","y G LLLL","y G MMMM d, E","y G MMMM d","y-MM-dd G","MMMM d, E","dd","y LLLL","y MMMM d, E","y 'm'. MMMM d 'd'., EEEE","y 'm'. MMMM d 'd'.","saus.","vas.","kov.","bal.","geg.","birž.","liep.","rugp.","rugs.","spal.","lapkr.","gruod.","sausio","vasario","kovo","balandžio","gegužės","birželio","liepos","rugpjūčio","rugsėjo","spalio","lapkričio","gruodžio","Š","sk","pr","an","tr","kt","pn","št","sekmadienis","pirmadienis","antradienis","trečiadienis","ketvirtadienis","penktadienis","šeštadienis","priešpiet","popiet","po Kr.","prme","pome","pr. m. e.","mūsų eroje","prieš Kristų","po Kristaus","prieš mūsų erą","Taika (645–650)","Hakuči (650–671)","Hakuho (672–686)","Šučo (686–701)","Taiho (701–704)","Keiun (704–708)","Vado (708–715)","Reiki (715–717)","Joro (717–724)","Jinki (724–729)","Tempio (729–749)","Tempio-kampo (749–749)","Tempio-šoho (749–757)","Tempio-hodzi (757–765)","Tempo-dzingo (765–767)","Dzingo-keiun (767–770)","Hoki (770–780)","Ten-o (781–782)","Enrjaku (782–806)","Daido (806–810)","Konin (810–824)","Tenčo (824–834)","Šova (834–848)","Kajo (848–851)","Ninju (851–854)","Saiko (854–857)","Tenan (857–859)","Jogan (859–877)","Genkei (877–885)","Ninja (885–889)","Kampjo (889–898)","Šotai (898–901)","Engi (901–923)","Enčo (923–931)","Šohei (931–938)","Tengjo (938–947)","Tenriaku (947–957)","Tentoku (957–961)","Ova (961–964)","Koho (964–968)","Ana (968–970)","Tenroku (970–973)","Ten-en (973–976)","Jogen (976–978)","Tengen (978–983)","Eikan (983–985)","Kana (985–987)","Ei-en (987–989)","Eiso (989–990)","Šorjaku (990–995)","Čotoku (995–999)","Čoho (999–1004)","Kanko (1004–1012)","Čova (1012–1017)","Kanin (1017–1021)","Džian (1021–1024)","Mandžiu (1024–1028)","Čogen (1028–1037)","Čorjaku (1037–1040)","Čokju (1040–1044)","Kantoku (1044–1046)","Eišo (1046–1053)","Tengi (1053–1058)","Kohei (1058–1065)","Džirjaku (1065–1069)","Enkju (1069–1074)","Šoho (1074–1077)","Šorjaku (1077–1081)","Eiho (1081–084)","Otoku (1084–1087)","Kandži (1087–1094)","Kaho (1094–1096)","Eičo (1096–1097)","Šotoku (1097–1099)","Kova (1099–1104)","Čodži (1104–1106)","Kašo (1106–1108)","Tenin (1108–1110)","Ten-ei (1110–1113)","Eikju (1113–1118)","Gen-ei (1118–1120)","Hoan (1120–1124)","Tendži (1124–1126)","Daidži (1126–1131)","Tenšo (1131–1132)","Čošo (1132–1135)","Hoen (1135–1141)","Eidži (1141–1142)","Kodži (1142–1144)","Tenjo (1144–1145)","Kjuan (1145–1151)","Ninpei (1151–1154)","Kjuju (1154–1156)","Hogen (1156–1159)","Heidži (1159–1160)","Eirjaku (1160–1161)","Oho (1161–1163)","Čokan (1163–1165)","Eiman (1165–1166)","Nin-an (1166–1169)","Kao (1169–1171)","Šoan (1171–1175)","Angen (1175–1177)","Džišo (1177–1181)","Jova (1181–1182)","Džuei (1182–1184)","Genrjuku (1184–1185)","Bundži (1185–1190)","Kenkju (1190–1199)","Šodži (1199–1201)","Kenin (1201–1204)","Genkju (1204–1206)","Ken-ei (1206–1207)","Šogen (1207–1211)","Kenrjaku (1211–1213)","Kenpo (1213–1219)","Šokju (1219–1222)","Džu (1222–1224)","Genin (1224–1225)","Karoku (1225–1227)","Antei (1227–1229)","Kanki (1229–1232)","Džoei (1232–1233)","Tempuku (1233–1234)","Bunrjaku (1234–1235)","Katei (1235–1238)","Rjakunin (1238–1239)","En-o (1239–1240)","Nindži (1240–1243)","Kangen (1243–1247)","Hodži (1247–1249)","Kenčo (1249–1256)","Kogen (1256–1257)","Šoka (1257–1259)","Šogen (1259–1260)","Bun-o (1260–1261)","Kočo (1261–1264)","Bun-ei (1264–1275)","Kendži (1275–1278)","Koan (1278–1288)","Šu (1288–1293)","Einin (1293–1299)","Šoan (1299–1302)","Kengen (1302–1303)","Kagen (1303–1306)","Tokudži (1306–1308)","Enkei (1308–1311)","Očo (1311–1312)","Šova (1312–1317)","Bunpo (1317–1319)","Dženo (1319–1321)","Dženkjo (1321–1324)","Šoču (1324–1326)","Kareki (1326–1329)","Gentoku (1329–1331)","Genko (1331–1334)","Kemu (1334–1336)","Engen (1336–1340)","Kokoku (1340–1346)","Šohei (1346–1370)","Kentoku (1370–1372)","Bunču (1372–1375)","Tendžu (1375–1379)","Korjaku (1379–1381)","Kova (1381–1384)","Genču (1384–1392)","Meitoku (1384–1387)","Kakei (1387–1389)","Ku (1389–1390)","Meitoku (1390–1394)","Oei (1394–1428)","Šočo (1428–1429)","Eikjo (1429–1441)","Kakitsu (1441–1444)","Bun-an (1444–1449)","Hotoku (1449–1452)","Kjotoku (1452–1455)","Košo (1455–1457)","Čoroku (1457–1460)","Kanšo (1460–1466)","Bunšo (1466–1467)","Onin (1467–1469)","Bunmei (1469–1487)","Čokjo (1487–1489)","Entoku (1489–1492)","Meio (1492–1501)","Bunki (1501–1504)","Eišo (1504–1521)","Taiei (1521–1528)","Kjoroku (1528–1532)","Tenmon (1532–1555)","Kodži (1555–1558)","Eiroku (1558–1570)","Genki (1570–1573)","Tenšo (1573–1592)","Bunroku (1592–1596)","Keičo (1596–1615)","Genva (1615–1624)","Kan-ei (1624–1644)","Šoho (1644–1648)","Keian (1648–1652)","Šu (1652–1655)","Meirjaku (1655–1658)","Mandži (1658–1661)","Kanbun (1661–1673)","Enpo (1673–1681)","Tenva (1681–1684)","Džokjo (1684–1688)","Genroku (1688–1704)","Hoei (1704–1711)","Šotoku (1711–1716)","Kjoho (1716–1736)","Genbun (1736–1741)","Kanpo (1741–1744)","Enkjo (1744–1748)","Kan-en (1748–1751)","Horjaku (1751–1764)","Meiva (1764–1772)","An-ei (1772–1781)","Tenmei (1781–1789)","Kansei (1789–1801)","Kjova (1801–1804)","Bunka (1804–1818)","Bunsei (1818–1830)","Tenpo (1830–1844)","Koka (1844–1848)","Kaei (1848–1854)","Ansei (1854–1860)","Man-en (1860–1861)","Bunkju (1861–1864)","Gendži (1864–1865)","Keiko (1865–1868)","Meidži","Taišo","Šova","Prieš R.O.C.","Cio","Lus","Muu","Lum","Luf","Kab","Lush","Lut","Cis","Ciongo","Lùishi","Lusòlo","Mùuyà","Lumùngùlù","Lufuimi","Kabàlàshìpù","Lùshìkà","Lutongolo","Lungùdi","Kaswèkèsè","Ciswà","Nko","Ndy","Ndg","Njw","Ngv","Lub","Lumingu","Nkodya","Ndàayà","Ndangù","Njòwa","Ngòvya","Lubingu","Dinda","Dilolo","kmp. Y.K.","kny. Y. K.","Kumpala kwa Yezu Kli","Kunyima kwa Yezu Kli","DAC","DAR","DAD","DAN","DAH","DAU","DAO","DAB","DOC","DAP","DGI","DAG","Dwe mar Achiel","Dwe mar Ariyo","Dwe mar Adek","Dwe mar Ang’wen","Dwe mar Abich","Dwe mar Auchiel","Dwe mar Abiriyo","Dwe mar Aboro","Dwe mar Ochiko","Dwe mar Apar","Dwe mar gi achiel","Dwe mar Apar gi ariyo","JMP","WUT","TAR","TAD","TAN","TAB","NGS","Jumapil","Wuok Tich","Tich Ariyo","Tich Adek","Tich Ang’wen","Tich Abich","Ngeso","OD","OT","Kapok Kristo obiro","Ka Kristo osebiro","J2","J3","J4","J5","Ij","J1","Jumapiri","Murwa wa Kanne","Murwa wa Katano","Imberi ya Kuuza Kwa","Muhiga Kuvita Kuuza","{currency}- {number}","G y. 'g'.","G y. 'g'. MMM","E, G y. 'g'. d. MMM","G y. 'g'. d. MMM","y. 'g'.","E, d.M.y.","y. 'g'. MMM","E, y. 'g'. d. MMM","y. 'g'. MMMM","y. 'g'. d. MMM","d.M.y.","y. 'g'. QQQ","y. 'g'. QQQQ","EEEE, y. 'gada' d. MMMM","y. 'gada' d. MMMM","y. 'gada' d. MMM","maijs","jūn.","jūl.","janvāris","februāris","aprīlis","jūnijs","jūlijs","augusts","septembris","oktobris","novembris","decembris","Sv","Pr","Ot","Tr","Ce","Pk","svētdiena","pirmdiena","otrdiena","trešdiena","ceturtdiena","piektdiena","sestdiena","priekšpusdienā","pēcpusdienā","p.m.ē.","m.ē.","pmē","mē","pirms mūsu ēras","mūsu ērā","tišri","hešvans","kisļevs","tevets","ševats","1. adars","adars","nisans","ijars","sivans","tamuzs","avs","eluls","2. adars","muharams","safars","1. rabī","2. rabī","1. džumādā","2. džumādā","radžabs","šabans","ramadāns","šauvals","du al-kidā","du al-hidžā","nav skaitlis","Ls","Dal","Ará","Ɔɛn","Doy","Lép","Rok","Sás","Bɔ́r","Kús","Gís","Shʉ́","Ntʉ́","Oladalʉ́","Arát","Ɔɛnɨ́ɔɨŋɔk","Olodoyíóríê inkókúâ","Oloilépūnyīē inkókúâ","Kújúɔrɔk","Mórusásin","Ɔlɔ́ɨ́bɔ́rárɛ","Kúshîn","Olgísan","Pʉshʉ́ka","Ntʉ́ŋʉ́s","Jumapílí","Jumane","Jumatánɔ","Alaámisi","Jumáa","Jumamósi","Ɛnkakɛnyá","Ɛndámâ","EY","Meínō Yɛ́sʉ","Eínō Yɛ́sʉ","JAN","FEB","MAC","ĨPU","MĨĨ","NJU","NJR","AGA","SPT","NOV","DEC","Januarĩ","Feburuarĩ","Ĩpurũ","Mĩĩ","Njuni","Njuraĩ","Agasti","Oktũba","Dicemba","KIU","MRA","WAI","WET","WEN","JUM","Muramuko","Wairi","Wethatu","Wena","Wetano","RŨ","ŨG","NK","Mbere ya Kristũ","Nyuma ya Kristũ","avr","zin","zil","zanvie","fevriye","zilye","septam","oktob","novam","desam","dim","lin","ze","van","dimans","lindi","merkredi","zedi","vandredi","samdi","av. Z-K","ap. Z-K","avan Zezi-Krist","apre Zezi-Krist","Mey","Jon","Jol","Aog","Janoary","Febroary","Martsa","Aprily","Jona","Jolay","Aogositra","Septambra","Oktobra","Novambra","Desambra","Alah","Alats","Alar","Alak","Zom","Asab","Alahady","Alatsinainy","Alarobia","Alakamisy","Zoma","Asabotsy","Alohan’i JK","Aorian’i JK","Kwa","Una","Rar","Che","Moc","Moj","Yel","Mweri wo kwanza","Mweri wo unayeli","Mweri wo uneraru","Mweri wo unecheshe","Mweri wo unethanu","Mweri wo thanu na mocha","Mweri wo saba","Mweri wo nane","Mweri wo tisa","Mweri wo kumi","Mweri wo kumi na moja","Mweri wo kumi na yel’li","Sabato","Arahamisi","wichishu","mchochil’l","HY","YY","Hinapiya yesu","Yopia yesu","MTn","M1","A2","M3","N4","F5","I6","A7","I8","K9","mbegtug","imeg àbùbì","imeg mbəŋchubi","iməg ngwə̀t","iməg fog","iməg ichiibɔd","iməg àdùmbə̀ŋ","iməg ichika","iməg kud","iməg tèsiʼe","iməg zò","iməg krizmed","iməg mbegtug","A1","A3","A4","A5","A6","Aneg 1","Aneg 2","Aneg 3","Aneg 4","Aneg 5","Aneg 6","Aneg 7","dd.M","MMM y 'г'.","E, d MMM y 'г'.","d MMM y 'г'.","dd.M.y","dd.M.yy","јан.","јун.","јул.","јануари","нед.","пон.","вт.","сре.","чет.","пет.","саб.","недела","среда","четврток","петок","сабота","претпладне","попладне","пр. н.е.","пред нашата ера","од нашата ера","ден","d-M-y, E","y MMMM","y, MMMM d, EEEE","y, MMMM d","y, MMM d","ജ","ഫ","മാ","ഏ","മെ","ജൂ","ഓ","സ","ഒ","ന","ഡി","ജനു","ഫെബ്രു","മാർ","ഏപ്രി","മേയ്","ജൂൺ","ജൂലൈ","ഓഗ","സെപ്റ്റം","ഒക്ടോ","നവം","ഡിസം","ജനുവരി","ഫെബ്രുവരി","മാർച്ച്","ഏപ്രിൽ","ആഗസ്റ്റ്","സെപ്റ്റംബർ","ഒക്‌ടോബർ","നവംബർ","ഡിസംബർ","ഞ","തി","ച","ബു","വ","വെ","ശ","ഞായർ","തിങ്കൾ","ചൊവ്വ","ബുധൻ","വ്യാഴം","വെള്ളി","ശനി","ഞായറാഴ്‌ച","തിങ്കളാഴ്‌ച","ചൊവ്വാഴ്ച","ബുധനാഴ്‌ച","വ്യാഴാഴ്‌ച","വെള്ളിയാഴ്‌ച","ശനിയാഴ്‌ച","ക്രി.മു.","എഡി","ബിസിഇ","സിഇ","ക്രിസ്‌തുവിന് മുമ്പ്","ആന്നോ ഡൊമിനി","ബി.സി.ഇ.","സി.ഇ.","ചൈ","വൈ","ജ്യേ","ആ","ശ്രാ","ഭാ","കാ","പൗ","ചൈത്രം","വൈശാഖം","ജ്യേഷ്ഠം","ആഷാഢം","ശ്രാവണം","ഭാദ്രപാദം","ആശ്വിനം","കാർത്തികം","മാർഗശീർഷം","പൗഷം","മാഘം","ഫൽഗുനം","ശക","മു","റ","ദു","മുഹറം","സഫർ","റബീഹുൽ അവ്വൽ","റബീഹുൽ ആഖിർ","ജമാദുൽ അവ്വൽ","ജമാദുൽ ആഖിർ","റജബ്","ശഹബാൻ","റമളാൻ","ശവ്വാൽ","ദുൽ ഖഹദ്","ദുൽ ഹിജ്ജ","ഹിജറ","സംഖ്യയല്ല","dd E","E, G y MMM d","y 'оны' QQQQ","EEEE, y 'оны' MM 'сарын' d","y 'оны' MM 'сарын' d","1-р сар","2-р сар","3-р сар","4-р сар","5-р сар","6-р сар","7-р сар","8-р сар","9-р сар","10-р сар","11-р сар","12-р сар","Нэгдүгээр сар","Хоёрдугаар сар","Гуравдугаар сар","Дөрөвдүгээр сар","Тавдугаар сар","Зургадугаар сар","Долдугаар сар","Наймдугаар сар","Есдүгээр сар","Аравдугаар сар","Арван нэгдүгээр сар","Арван хоёрдугаар сар","Ня","Да","Мя","Лх","Пү","Ба","Бя","ням","даваа","мягмар","лхагва","пүрэв","баасан","бямба","ҮӨ","ҮХ","м.э.ө","м.э.","НТӨ","НТ","МЭӨ","МЭ","манай эриний өмнөх","манай эриний","₮","E, d, MMM y","जा","ऑ","नो","डि","जाने","फेब्रु","एप्रि","ऑग","सप्टें","ऑक्टो","नोव्हें","डिसें","ऑगस्ट","सप्टेंबर","ऑक्टोबर","मंगळवार","म.उ.","इ. स. पू.","इ. स.","इ. स. पू. युग","ख्रि. यु.","ईसवीसनपूर्व","ईसवीसन","ईसापूर्व युग","ईसायुग","deva","Ogo","Ogos","Disember","Ahd","Isn","Kha","Ahad","Isnin","Khamis","Jumaat","PG","PTG","Jn","Fb","Ap","Jl","Og","Sp","Nv","Ds","S.M.","TM","d 'ta'’ MMMM","MMMM 'ta'’ y","EEEE, d 'ta'’ MMMM y","d 'ta'’ MMMM y","Ġ","Fra","Mej","Ġun","Lul","Aww","Ott","Diċ","Jannar","Frar","Marzu","Mejju","Ġunju","Lulju","Awwissu","Settembru","Ottubru","Novembru","Diċembru","Ħ","Ħad","Tne","Tli","Erb","Ħam","Ġim","Il-Ħadd","It-Tnejn","It-Tlieta","L-Erbgħa","Il-Ħamis","Il-Ġimgħa","Is-Sibt","QK","WK","QEK","Qabel Kristu","Wara Kristu","FLO","CLA","CKI","FMF","MAD","MBI","MLI","MAM","FDE","FMU","FGW","FYU","Fĩi Loo","Cokcwaklaŋne","Cokcwaklii","Fĩi Marfoo","Madǝǝuutǝbijaŋ","Mamǝŋgwãafahbii","Mamǝŋgwãalii","Madǝmbii","Fĩi Dǝɓlii","Fĩi Mundaŋ","Fĩi Gwahlle","Fĩi Yuru","Cya","Cla","Czi","Cko","Cka","Cga","Cze","Com’yakke","Comlaaɗii","Comzyiiɗii","Comkolle","Comkaldǝɓlii","Comgaisuu","Comzyeɓsuu","comme","lilli","PK","KǝPel Kristu","Pel Kristu","E, y/M/d","ဇ","ဖ","မ","ဧ","ဩ","စ","အ","န","ဒ","ဇန်နဝါရီ","ဖေဖော်ဝါရီ","မတ်","ဧပြီ","မေ","ဇွန်","ဇူလိုင်","ဩဂုတ်","စက်တင်ဘာ","အောက်တိုဘာ","နိုဝင်ဘာ","ဒီဇင်ဘာ","တ","ဗ","က","သ","တနင်္ဂနွေ","တနင်္လာ","အင်္ဂါ","ဗုဒ္ဓဟူး","ကြာသပတေး","သောကြာ","စနေ","နံနက်","ညနေ","ဘီစီ","အေဒီ","ဘီစီအီး","စီအီး","ခရစ်တော် မပေါ်မီကာလ","ခရစ်တော် ပေါ်ထွန်းပြီးကာလ","mymr","ဂဏန်းမဟုတ်သော","ǃKhanni","ǃKhanǀgôab","ǀKhuuǁkhâb","ǃHôaǂkhaib","ǃKhaitsâb","Gamaǀaeb","ǂKhoesaob","Aoǁkhuumûǁkhâb","Taraǀkhuumûǁkhâb","ǂNûǁnâiseb","ǀHooǂgaeb","Hôasoreǁkhâb","Son","Wu","Fr","Sontaxtsees","Mantaxtsees","Denstaxtsees","Wunstaxtsees","Dondertaxtsees","Fraitaxtsees","Satertaxtsees","ǁgoagas","ǃuias","Xristub aiǃâ","Xristub khaoǃgâ","E d.M","E d.MM.y","fvt.","vt.","før vår tidsregning","vår tidsregning","Zib","Nhlo","Mbi","Mab","Nkw","Nhla","Ntu","Ncw","Mpan","Lwe","Mpal","Zibandlela","Nhlolanja","Mbimbitho","Mabasa","Nkwenkwezi","Nhlangula","Ntulikazi","Ncwabakazi","Mpandula","Mfumfu","Lwezi","Mpalakazi","Mvu","Sin","Sih","Mgq","Sonto","Mvulo","Sibili","Sithathu","Sine","Sihlanu","Mgqibelo","UKristo angakabuyi","Ukristo ebuyile","१","२","३","४","५","६","७","८","९","१०","११","१२","फेब्रुअरी","अप्रिल","अगस्ट","सेप्टेम्बर","अक्टोबर","नोभेम्बर","डिसेम्बर","फरवरी","अप्रेल","दिसम्बर","आइत","मङ्गल","बिही","आइतवार","मङ्गलवार","बिहीवार","ईसा पूर्व","सन्","इशा पूर्व","सिइ","जेठ","असार","साउन","भदौ","असोज","कात्तिक","मङसिर","पुस","चैत","नेरू","आइतबार","सोमबार","मङ्गलबार","बुधबार","बिहीबार","शुक्रबार","शनिबार","पूर्व मध्यान्ह","उत्तर मध्यान्ह","mei","zo","do","vr","za","zondag","maandag","dinsdag","woensdag","donderdag","vrijdag","zaterdag","mnd 1","mnd 2","mnd 3","mnd 4","mnd 5","mnd 6","mnd 7","mnd 8","mnd 9","mnd 10","mnd 11","mnd 12","maand 1","maand 2","maand 3","maand 4","maand 5","maand 6","maand 7","maand 8","maand 9","maand 10","maand 11","maand 12","v.Chr.","n.Chr.","vóór gewone jaartelling","gewone jaartelling","ng1","ng2","ng3","ng4","ng5","ng6","ng7","ng8","ng9","ng10","ng11","kris","ngwɛn matáhra","ngwɛn ńmba","ngwɛn ńlal","ngwɛn ńna","ngwɛn ńtan","ngwɛn ńtuó","ngwɛn hɛmbuɛrí","ngwɛn lɔmbi","ngwɛn rɛbvuâ","ngwɛn wum","ngwɛn wum navǔr","krísimin","mbs","sas","mɔ́ndɔ","sɔ́ndɔ mafú mába","sɔ́ndɔ mafú málal","sɔ́ndɔ mafú mána","mabágá má sukul","sásadi","maná","kugú","BL","PB","Bó Lahlɛ̄","Pfiɛ Burī","M y","'kl'. HH:mm:ss zzzz","sø.","må.","ty.","on.","to.","fr.","la.","måndag","tysdag","laurdag","formiddag","ettermiddag","før vesterlandsk tidsrekning","vesterlandsk tidsrekning","E , 'lyɛ'̌ʼ d 'na' M, y","E , 'lyɛ'̌ʼ d 'na' MMM, y","'lyɛ'̌ʼ d 'na' MMMM, y","EEEE , 'lyɛ'̌ʼ d 'na' MMMM, y","saŋ tsetsɛ̀ɛ lùm","saŋ kàg ngwóŋ","saŋ lepyè shúm","saŋ cÿó","saŋ tsɛ̀ɛ cÿó","saŋ njÿoláʼ","saŋ tyɛ̀b tyɛ̀b mbʉ̀","saŋ mbʉ̀ŋ","saŋ ngwɔ̀ʼ mbÿɛ","saŋ tàŋa tsetsáʼ","saŋ mejwoŋó","saŋ lùm","lyɛʼɛ́ sẅíŋtè","mvfò lyɛ̌ʼ","mbɔ́ɔntè mvfò lyɛ̌ʼ","tsètsɛ̀ɛ lyɛ̌ʼ","mbɔ́ɔntè tsetsɛ̀ɛ lyɛ̌ʼ","mvfò màga lyɛ̌ʼ","màga lyɛ̌ʼ","mbaʼámbaʼ","ncwònzém","m.z.Y.","m.g.n.Y.","mé zyé Yěsô","mé gÿo ńzyé Yěsô","Mat","Arh","Usi","Janabari","uFeberbari","uMatjhi","u-Apreli","Meyi","Julayi","Arhostosi","Usinyikhaba","Bil","Ne","Hla","Gqi","uSonto","uMvulo","uLesibili","Lesithathu","uLesine","ngoLesihlanu","umGqibelo","Apo","Nof","Janaware","Feberware","Matšhe","Aporele","Julae","Agostose","Setemere","Oktobore","Nofemere","Disemere","Mos","Bed","Mok","Sontaga","Mosupalogo","Labobedi","Laboraro","Labone","Labohlano","Mokibelo","E، d-M","E، d/M/y","E، d MMM y","zzzz h:mm:ss a","z h:mm:ss a","Tiop","Pɛt","Duɔ̱ɔ̱","Guak","Duä","Kor","Pay","Thoo","Tɛɛ","Laa","Kur","Tid","Tiop thar pɛt","Duɔ̱ɔ̱ŋ","Duät","Kornyoot","Pay yie̱tni","Tho̱o̱r","Tɛɛr","Laath","Tio̱p in di̱i̱t","Ŋ","Cäŋ","Jiec","Rɛw","Diɔ̱k","Ŋuaan","Dhieec","Bäkɛl","Cäŋ kuɔth","Jiec la̱t","Rɛw lätni","Diɔ̱k lätni","Ŋuaan lätni","Dhieec lätni","Bäkɛl lätni","RW","TŊ","ƐY","A ka̱n Yecu ni dap","Ɛ ca Yecu dap","Ama","Gur","Bit","Elb","Cam","Wax","Ado","Hag","Ful","Onk","Mud","Amajjii","Guraandhala","Bitooteessa","Elba","Caamsa","Waxabajjii","Adooleessa","Hagayya","Fuulbana","Onkololeessa","Sadaasa","Muddee","Dil","Wix","Qib","Rob","Dilbata","Wiixata","Qibxata","Roobii","Kamiisa","Jimaata","Sanbata","WD","WB","KD","KB","ଜା","ଫେ","ମା","ଅ","ମଇ","ଜୁ","ସେ","ନ","ଡି","ଜାନୁଆରୀ","ଫେବୃଆରୀ","ମାର୍ଚ୍ଚ","ଅପ୍ରେଲ","ଜୁନ","ଜୁଲାଇ","ଅଗଷ୍ଟ","ସେପ୍ଟେମ୍ବର","ଅକ୍ଟୋବର","ନଭେମ୍ବର","ଡିସେମ୍ବର","ର","ସୋ","ମ","ବୁ","ଗୁ","ଶୁ","ଶ","ରବି","ସୋମ","ମଙ୍ଗଳ","ବୁଧ","ଗୁରୁ","ଶୁକ୍ର","ଶନି","ରବିବାର","ସୋମବାର","ମଙ୍ଗଳବାର","ବୁଧବାର","ଗୁରୁବାର","ଶୁକ୍ରବାର","ଶନିବାର","ccc, d MMM","y-'ӕм' 'азы' QQQ","y-'ӕм' 'азы' QQQQ","EEEE, d MMMM, y 'аз'","d MMMM, y 'аз'","dd MMM y 'аз'","июны","июлы","январы","февралы","мартъийы","апрелы","майы","августы","сентябры","октябры","ноябры","декабры","Х","К","Ӕ","Ц","хцб","крс","дцг","ӕрт","цпр","мрб","сбт","хуыцаубон","къуырисӕр","дыццӕг","ӕртыццӕг","цыппӕрӕм","майрӕмбон","сабат","ӕмбисбоны размӕ","ӕмбисбоны фӕстӕ","н.д.а.","н.д.","НН","فروری","مئ","جولائی","اتوار","پیر","منگل","بُدھ","جمعرات","جمعہ","ہفتہ","ايساپورو","سں","E d MMM, G y","E, dd-MM.","ਜ","ਫ਼","ਮਾ","ਅ","ਮ","ਜੂ","ਜੁ","ਸ","ਨ","ਦ","ਜਨ","ਫ਼ਰ","ਮਾਰਚ","ਅਪ੍ਰੈ","ਮਈ","ਜੂਨ","ਜੁਲਾ","ਅਗ","ਸਤੰ","ਅਕਤੂ","ਨਵੰ","ਦਸੰ","ਜਨਵਰੀ","ਫ਼ਰਵਰੀ","ਅਪ੍ਰੈਲ","ਜੁਲਾਈ","ਅਗਸਤ","ਸਤੰਬਰ","ਅਕਤੂਬਰ","ਨਵੰਬਰ","ਦਸੰਬਰ","ਐ","ਸੋ","ਮੰ","ਬੁੱ","ਵੀ","ਸ਼ੁੱ","ਸ਼","ਐਤ","ਸੋਮ","ਮੰਗਲ","ਬੁੱਧ","ਵੀਰ","ਸ਼ੁੱਕਰ","ਸ਼ਨਿੱਚਰ","ਐਤਵਾਰ","ਸੋਮਵਾਰ","ਮੰਗਲਵਾਰ","ਬੁੱਧਵਾਰ","ਵੀਰਵਾਰ","ਸ਼ੁੱਕਰਵਾਰ","ਸ਼ਨਿੱਚਰਵਾਰ","ਪੂ.ਦੁ.","ਬਾ.ਦੁ.","ਈ. ਪੂ.","ਸੰਨ","ਈ. ਪੂ. ਸੰ.","ਈ. ਸੰ.","ਈਸਵੀ ਪੂਰਵ","ਈਸਵੀ ਸੰਨ","ਈਸਵੀ ਪੂਰਵ ਯੁੱਗ","ਈਸਵੀ ਯੁੱਗ","੧","੨","੩","੪","੫","੬","੭","੮","੯","੧੦","੧੧","੧੨","ਚੇਤ","ਵੈਸਾਖ","ਜੇਠ","ਹਾੜ","ਸਾਉਣ","ਭਾਦੋਂ","ਅੱਸੂ","ਕੱਤਕ","ਮੱਘਰ","ਪੋਹ","ਮਾਘ","ਫੱਗਣ","ਸਾਕਾ","E, d.MM.y","d.MM.y","sty","lut","kwi","cze","sie","wrz","paź","gru","stycznia","lutego","marca","kwietnia","czerwca","lipca","sierpnia","września","października","grudnia","Ś","niedz.","pon.","wt.","śr.","czw.","pt.","sob.","niedziela","poniedziałek","wtorek","środa","czwartek","piątek","p.n.e.","Tiszri","Cheszwan","Kislew","Tewet","Szwat","Siwan","Aw","Dżu. I","Dżu. II","Ra.","Sza.","Szaw.","Zu al-k.","Zu al-h.","Dżumada I","Dżumada II","Radżab","Szaban","Szawwal","Zu al-kada","Zu al-hidżdża","Farwardin","Ordibeheszt","Chordād","Mordād","Szahriwar","Ābān","Āsar","Déi","Przed ROC","ROC","د y د MMMM","EEEE د y د MMMM d","د y د MMMM d","جنوري","فبروري","اګست","غ.م.","غ.و.","وری","غویی","غبرگولی","چنگاښ","زمری","وږی","تله","لړم","لیندۍ","مرغومی","سلواغه","کب","E, d 'de' MMM 'de' y G","E, d/MM","E, d 'de' MMMM","EEEE, d/MM/y","E, d/MM/y","E, d 'de' MMMM 'de' y","dez","janeiro","fevereiro","março","junho","julho","dezembro","seg","qua","qui","sex","segunda-feira","terça-feira","quarta-feira","quinta-feira","sexta-feira","da manhã","da tarde","M2","M4","M5","M6","M7","M8","M9","Mês 1","Mês 2","Mês 3","Mês 4","Mês 5","Mês 6","Mês 7","Mês 8","Mês 9","Mês 10","Mês 11","Mês 12","a.E.C.","E.C.","depois de Cristo","antes da Era Comum","Era Comum","Antes de R.O.C.","Antes de Cristo","Ano do Senhor","Antes da Era Comum","Esc.","​PTE","Db","Qul","Hat","Pau","Ayr","Aym","Int","Ant","Qha","Uma","Aya","Kap","Qulla puquy","Hatun puquy","Pauqar waray","Ayriwa","Aymuray","Inti raymi","Anta Sitwa","Qhapaq Sitwa","Uma raymi","Kantaray","Ayamarqʼa","Kapaq Raymi","Dom","Mié","Jue","Vie","Domingo","Miércoles","Jueves","Viernes","Sábado","EEEE, 'ils' d 'da' MMMM y","d 'da' MMMM y","schan.","favr.","matg","zercl.","fan.","avust","sett.","schaner","favrer","avrigl","zercladur","fanadur","settember","october","du","gli","gie","dumengia","glindesdi","mesemna","gievgia","venderdi","sonda","sm","av. Cr.","s. Cr.","avant Cristus","suenter Cristus","Mut.","Gas.","Wer.","Mat.","Gic.","Kam.","Nya.","Kan.","Nze.","Ukw.","Ugu.","Uku.","Nzero","Ruhuhuma","Ntwarante","Ndamukiza","Rusama","Ruheshi","Mukakaro","Nyandagaro","Nyakanga","Gitugutu","Munyonyo","Kigarama","cu.","mbe.","kab.","gtu.","kan.","gnu.","gnd.","Ku w’indwi","Ku wa mbere","Ku wa kabiri","Ku wa gatatu","Ku wa kane","Ku wa gatanu","Ku wa gatandatu","Z.MU.","Z.MW.","Mb.Y.","Ny.Y","Mbere ya Yezu","Nyuma ya Yezu","ian.","iun.","iul.","ianuarie","februarie","martie","aprilie","iunie","iulie","septembrie","octombrie","noiembrie","decembrie","Dum","Mie","Joi","Vin","Sâm","duminică","luni","marți","miercuri","vineri","sâmbătă","e.b.","era budistă","Hathor","Mesori","El Nasii","meskerem","taqemt","tahsas","yekatit","megabit","miazia","genbot","sene","hamle","nehase","pagumen","î.Hr.","d.Hr.","î.e.n","e.n.","înainte de Hristos","după Hristos","înaintea erei noastre","era noastră","Tișrei","Heșvan","Șevat","Tammuz","Mweri wa kwanza","Mweri wa kaili","Mweri wa katatu","Mweri wa kaana","Mweri wa tanu","Mweri wa sita","Mweri wa saba","Mweri wa nane","Mweri wa tisa","Mweri wa ikumi","Mweri wa ikumi na moja","Mweri wa ikumi na mbili","Ijp","Ijt","Ijn","Ijtn","Ijumapili","Ijumatatu","Ijumanne","Ijumatano","Ijumamosi","kang’ama","kingoto","Kabla ya Mayesu","Baada ya Mayesu","ccc, d","E, d MMM y 'г'. G","d MMM y 'г'. G","ccc, d.MM.y 'г'.","марта","июня","июля","сент.","нояб.","января","февраля","апреля","августа","сентября","октября","ноября","декабря","вс","воскресенье","понедельник","четверг","пятница","суббота","Тот","Бабэ","Хатур","Кихак","Тубэ","Бармуда","Башнас","Бауна","Абиб","Мисра","Якатит","Магабит","Миазия","Сэнэ","Хамлэ","Нахасэ","Эпагомен","до н.э.","до н. э.","н. э.","Тишрей","Ияр","Таммуз","Элул","Чайтра","Ваисакха","Джанштха","Асадха","Бхадра","Азвина","Аграхайана","Магха","Пхалгуна","Мухаррам","Раби-уль-авваль","Раби-уль-ахир","Джумад-уль-авваль","Джумад-уль-ахир","Раджаб","Шаабан","Шавваль","Зуль-Каада","Зуль-Хиджжа","Эпоха Тайка (645-650)","Эпоха Хакути (650-671)","Эпоха Хакухо (672-686)","Эпоха Сючё (686-701)","Эпоха Тайхо (701-704)","Эпоха Кёюн (704-708)","Эпоха Вадо (708-715)","Эпоха Рэйки (715-717)","Эпоха Ёро (717-724)","Эпоха Дзинки (724-729)","Эпоха Темпьё (729-749)","Эпоха Темпьё (749-749)","Эпоха Темпьё-Сьохо (749-757)","Эпоха Темпьё-Ходзи (757-765)","Эпоха Темпьё-Ходзи (765-767)","Эпоха Джинго-Кёюн (767-770)","Эпоха Хоки (770-780)","Эпоха Теньё (781-782)","Эпоха Енряку (782-806)","Эпоха Дайдо (806-810)","Эпоха Конин (810-824)","Эпоха Тентьо (824-834)","Эпоха Шова (834-848)","Эпоха Кайо (848-851)","Эпоха Ниндзю (851-854)","Эпоха Сайко (854-857)","Эпоха Теннан (857-859)","Эпоха Йоган (859-877)","Эпоха Генкей (877-885)","Эпоха Нинна (885-889)","Эпоха Кампьё (889-898)","Эпоха Сьотай (898-901)","Эпоха Энги (901-923)","Эпоха Ентьо (923-931)","Эпоха Сьёхэй (931-938)","Эпоха Тенгьо (938-947)","Эпоха Тенрияку (947-957)","Эпоха Тентоку (957-961)","Эпоха Ова (961-964)","Эпоха Кохо (964-968)","Эпоха Анна (968-970)","Эпоха Тенроку (970-973)","Эпоха Теньен (973-976)","Эпоха Дзьоген (976-978)","Эпоха Тенген (978-983)","Эпоха Ейкан (983-985)","Эпоха Канна (985-987)","Эпоха Ейен (987-989)","Эпоха Ейсо (989-990)","Эпоха Сёряку (990-995)","Эпоха Тётоку (995-999)","Эпоха Тёхо (999-1004)","Эпоха Канко (1004-1012)","Эпоха Тёва (1012-1017)","Эпоха Каннин (1017-1021)","Эпоха Дзиан (1021-1024)","Эпоха Мандзю (1024-1028)","Эпоха Тёгэн (1028-1037)","Эпоха Тёряку (1037-1040)","Эпоха Тёкю (1040-1044)","Эпоха Катоку (1044-1046)","Эпоха Эйсо (1046-1053)","Эпоха Тэнги (1053-1058)","Эпоха Кохэй (1058-1065)","Эпоха Дзиряку (1065-1069)","Эпоха Энкю (1069-1074)","Эпоха Сёхо (1074-1077)","Эпоха Сёряку (1077-1081)","Эпоха Эйхо (1081-1084)","Эпоха Отоку (1084-1087)","Эпоха Кандзи (1087-1094)","Эпоха Кахо (1094-1096)","Эпоха Эйтё (1096-1097)","Эпоха Сётоку (1097-1099)","Эпоха Кова (1099-1104)","Эпоха Тёдзи (1104-1106)","Эпоха Касё (1106-1108)","Эпоха Тэннин (1108-1110)","Эпоха Тэнъэй (1110-1113)","Эпоха Эйкю (1113-1118)","Эпоха Гэнъэй (1118-1120)","Эпоха Хоан (1120-1124)","Эпоха Тэндзи (1124-1126)","Эпоха Дайдзи (1126-1131)","Эпоха Тэнсё (1131-1132)","Эпоха Тёсё (1132-1135)","Эпоха Хоэн (1135-1141)","Эпоха Эйдзи (1141-1142)","Эпоха Кодзи (1142-1144)","Эпоха Тэнё (1144-1145)","Эпоха Кюан (1145-1151)","Эпоха Нимпэй (1151-1154)","Эпоха Кюдзю (1154-1156)","Эпоха Хогэн (1156-1159)","Эпоха Хэйдзи (1159-1160)","Эпоха Эйряку (1160-1161)","Эпоха Охо (1161-1163)","Эпоха Тёкан (1163-1165)","Эпоха Эйман (1165-1166)","Эпоха Нинъан (1166-1169)","Эпоха Као (1169-1171)","Эпоха Сёан (1171-1175)","Эпоха Ангэн (1175-1177)","Эпоха Дзисё (1177-1181)","Эпоха Ёва (1181-1182)","Эпоха Дзюэй (1182-1184)","Эпоха Гэнрюку (1184-1185)","Эпоха Бундзи (1185-1190)","Эпоха Кэнкю (1190-1199)","Эпоха Сёдзи (1199-1201)","Эпоха Кэннин (1201-1204)","Эпоха Гэнкю (1204-1206)","Эпоха Кэнъэй (1206-1207)","Эпоха Сёгэн (1207-1211)","Эпоха Кэнряку (1211-1213)","Эпоха Кэмпо (1213-1219)","Эпоха Сёкю (1219-1222)","Эпоха Дзёо (1222-1224)","Эпоха Гэннин (1224-1225)","Эпоха Кароку (1225-1227)","Эпоха Антэй (1227-1229)","Эпоха Канки (1229-1232)","Эпоха Дзёэй (1232-1233)","Эпоха Тэмпуку (1233-1234)","Эпоха Бунряку (1234-1235)","Эпоха Катэй (1235-1238)","Эпоха Рякунин (1238-1239)","Эпоха Энъо (1239-1240)","Эпоха Ниндзи (1240-1243)","Эпоха Кангэн (1243-1247)","Эпоха Ходзи (1247-1249)","Эпоха Кэнтё (1249-1256)","Эпоха Когэн (1256-1257)","Эпоха Сёка (1257-1259)","Эпоха Сёгэн (1259-1260)","Эпоха Бунъо (1260-1261)","Эпоха Котё (1261-1264)","Эпоха Бунъэй (1264-1275)","Эпоха Кэндзи (1275-1278)","Эпоха Коан (1278-1288)","Эпоха Сёо (1288-1293)","Эпоха Эйнин (1293-1299)","Эпоха Сёан (1299-1302)","Эпоха Кэнгэн (1302-1303)","Эпоха Кагэн (1303-1306)","Эпоха Токудзи (1306-1308)","Эпоха Энкэй (1308-1311)","Эпоха Отё (1311-1312)","Эпоха Сёва (1312-1317)","Эпоха Бумпо (1317-1319)","Эпоха Гэно (1319-1321)","Эпоха Гэнкё (1321-1324)","Эпоха Сётю (1324-1326)","Эпоха Карэки (1326-1329)","Эпоха Гэнтоку (1329-1331)","Эпоха Гэнко (1331-1334)","Эпоха Кэмму (1334-1336)","Эпоха Энгэн (1336-1340)","Эпоха Кококу (1340-1346)","Эпоха Сёхэй (1346-1370)","Эпоха Кэнтоку (1370-1372)","Эпоха Бунтю (1372-1375)","Эпоха Иэндзю (1375-1379)","Эпоха Коряку (1379-1381)","Эпоха Кова (1381-1384)","Эпоха Гэнтю (1384-1392)","Эпоха Мэйтоку (1384-1387)","Эпоха Какэй (1387-1389)","Эпоха Коо (1389-1390)","Эпоха Мэйтоку (1390-1394)","Эпоха Оэй (1394-1428)","Эпоха Сётё (1428-1429)","Эпоха Эйкё (1429-1441)","Эпоха Какицу (1441-1444)","Эпоха Банъан (1444-1449)","Эпоха Хотоку (1449-1452)","Эпоха Кётоку (1452-1455)","Эпоха Косё (1455-1457)","Эпоха Тёроку (1457-1460)","Эпоха Кансё (1460-1466)","Эпоха Бунсё (1466-1467)","Эпоха Онин (1467-1469)","Эпоха Буммэй (1469-1487)","Эпоха Тёкё (1487-1489)","Эпоха Энтоку (1489-1492)","Эпоха Мэйо (1492-1501)","Эпоха Бунки (1501-1504)","Эпоха Эйсё (1504-1521)","Эпоха Тайэй (1521-1528)","Эпоха Кёроку (1528-1532)","Эпоха Тэммон (1532-1555)","Эпоха Кодзи (1555-1558)","Эпоха Эйроку (1558-1570)","Эпоха Гэнки (1570-1573)","Эпоха Тэнсё (1573-1592)","Эпоха Бунроку (1592-1596)","Эпоха Кэйтё (1596-1615)","Эпоха Гэнва (1615-1624)","Эпоха Канъэй (1624-1644)","Эпоха Сёхо (1644-1648)","Эпоха Кэйан (1648-1652)","Эпоха Сё (1652-1655)","Эпоха Мэйряку (1655-1658)","Эпоха Мандзи (1658-1661)","Эпоха Камбун (1661-1673)","Эпоха Эмпо (1673-1681)","Эпоха Тэнва (1681-1684)","Эпоха Дзёкё (1684-1688)","Эпоха Гэнроку (1688-1704)","Эпоха Хоэй (1704-1711)","Эпоха Сётоку (1711-1716)","Эпоха Кёхо (1716-1736)","Эпоха Гэмбун (1736-1741)","Эпоха Кампо (1741-1744)","Эпоха Энкё (1744-1748)","Эпоха Канъэн (1748-1751)","Эпоха Хоряку (1751-1764)","Эпоха Мэйва (1764-1772)","Эпоха Анъэй (1772-1781)","Эпоха Тэммэй (1781-1789)","Эпоха Кансэй (1789-1801)","Эпоха Кёва (1801-1804)","Эпоха Бунка (1804-1818)","Эпоха Бунсэй (1818-1830)","Эпоха Тэмпо (1830-1844)","Эпоха Кока (1844-1848)","Эпоха Каэй (1848-1854)","Эпоха Ансэй (1854-1860)","Эпоха Манъэн (1860-1861)","Эпоха Бункю (1861-1864)","Эпоха Гендзи (1864-1865)","Эпоха Кейо (1865-1868)","Эпоха Мэйдзи","Эпоха Тайсьо","Сьова","Эпоха Хэйсэй","Фарвардин","Хордад","Шахривер","Азер","Дей","Эсфанд","не число","ТМТ","₴","XXXX","mut.","gas.","wer.","mat.","gic.","kam.","nya.","nze.","ukw.","ugu.","uku.","Mutarama","Gashyantare","Werurwe","Mata","Gicuransi","Kamena","Kanama","Nzeli","Ukwakira","Ugushyingo","Ukuboza","cyu.","Ku cyumweru","Kuwa mbere","Kuwa kabiri","Kuwa gatatu","Kuwa kane","Kuwa gatanu","Kuwa gatandatu","y 'сыл' MMMM d 'күнэ', EEEE","yy/M/d","Ы","Тохс","Олун","Клн_ттр","Мус_уст","Ыам_йн","Бэс_йн","От_йн","Атрдь_йн","Блҕн_йн","Алт","Сэт","Ахс","Тохсунньу","Олунньу","Кулун тутар","Муус устар","Ыам ыйын","Бэс ыйын","От ыйын","Атырдьых ыйын","Балаҕан ыйын","Алтынньы","Сэтинньи","Ахсынньы","Ч","Бс","Бн","Оп","Сэ","Чп","Бэ","Сб","Баскыһыанньа","Бэнидиэлинньик","Оптуорунньук","Сэрэдэ","Чэппиэр","Бээтиҥсэ","Субуота","ЭИ","ЭК","б. э. и.","б. э","Obo","Waa","Oku","Ong","Ime","Ile","Sap","Isi","Saa","Tom","Tob","Tow","Lapa le obo","Lapa le waare","Lapa le okuni","Lapa le ong’wan","Lapa le imet","Lapa le ile","Lapa le sapa","Lapa le isiet","Lapa le saal","Lapa le tomon","Lapa le tomon obo","Lapa le tomon waare","Are","Kun","Mderot ee are","Mderot ee kuni","Mderot ee ong’wan","Mderot ee inet","Mderot ee ile","Mderot ee sapa","Mderot ee kwe","Tesiran","Teipa","Kabla ya Christo","Baada ya Christo","MMM d y","Mup","Mwi","Msh","Mun","Mag","Muj","Msp","Mpg","Mye","Mus","Muh","Mupalangulwa","Mwitope","Mushende","Munyi","Mushende Magali","Mujimbi","Mushipepo","Mupuguto","Munyense","Mokhu","Musongandembwe","Muhaano","Mulungu","Alahamisi","Lwamilawu","Pashamihe","Ashanali uKilisito","Pamwandi ya Kilisto","ođđajage","guovva","njukča","cuoŋo","miesse","geasse","suoidne","borge","čakča","golggot","skábma","juovla","ođđajagemánnu","guovvamánnu","njukčamánnu","cuoŋománnu","miessemánnu","geassemánnu","suoidnemánnu","borgemánnu","čakčamánnu","golggotmánnu","skábmamánnu","juovlamánnu","sotn","vuos","maŋ","gask","duor","bear","láv","aejlege","måanta","däjsta","gaskevahkoe","dåarsta","bearjadahke","laavadahke","iđitbeaivet","eahketbeaivet","o.Kr.","m.Kr.","ovdal Kristtusa","maŋŋel Kristtusa","Dkr","ođđj","guov","njuk","cuo","mies","geas","suoi","borg","čakč","golg","skáb","juov","sotnabeaivi","vuossárga","maŋŋebárga","gaskavahkku","duorasdat","bearjadat","lávvardat","Janeiro","Fevreiro","Marco","Maio","Junho","Julho","Augusto","Setembro","Otubro","Novembro","Decembro","Pos","Pir","Nai","Sha","Dimingu","Chiposi","Chipiri","Chitatu","Chinai","Chishanu","Sabudu","AC","Nye","Mbä","Bêl","Fön","Len","Kük","Ngb","Nab","Kak","Nyenye","Fulundïgi","Mbängü","Ngubùe","Bêläwü","Föndo","Lengua","Kükürü","Mvuka","Ngberere","Nabändüru","Kakauka","Bk1","Bk2","Bk3","Bk4","Bk5","Lâp","Lây","Bikua-ôko","Bïkua-ûse","Bïkua-ptâ","Bïkua-usïö","Bïkua-okü","Lâpôsö","Lâyenga","ND","LK","KnK","NpK","Kôzo na Krîstu","Na pekô tî Krîstu","i","ɣ","inn","bṛa","maṛ","ibr","ɣuc","cut","ktu","nuw","duj","innayr","bṛayṛ","maṛṣ","ibrir","mayyu","yunyu","yulyuz","ɣuct","cutanbir","ktubr","nuwanbir","dujanbir","asa","ayn","asi","akṛ","akw","asim","asiḍ","asamas","aynas","asinas","akṛas","akwas","asimwas","asiḍyas","tifawt","tadggʷat","daɛ","dfɛ","dat n ɛisa","dffir n ɛisa","ⵉ","ⴱ","ⵎ","ⵢ","ⵖ","ⵛ","ⴽ","ⵏ","ⴷ","ⵉⵏⵏ","ⴱⵕⴰ","ⵎⴰⵕ","ⵉⴱⵔ","ⵎⴰⵢ","ⵢⵓⵏ","ⵢⵓⵍ","ⵖⵓⵛ","ⵛⵓⵜ","ⴽⵜⵓ","ⵏⵓⵡ","ⴷⵓⵊ","ⵉⵏⵏⴰⵢⵔ","ⴱⵕⴰⵢⵕ","ⵎⴰⵕⵚ","ⵉⴱⵔⵉⵔ","ⵎⴰⵢⵢⵓ","ⵢⵓⵏⵢⵓ","ⵢⵓⵍⵢⵓⵣ","ⵖⵓⵛⵜ","ⵛⵓⵜⴰⵏⴱⵉⵔ","ⴽⵜⵓⴱⵔ","ⵏⵓⵡⴰⵏⴱⵉⵔ","ⴷⵓⵊⴰⵏⴱⵉⵔ","ⴰⵙⴰ","ⴰⵢⵏ","ⴰⵙⵉ","ⴰⴽⵕ","ⴰⴽⵡ","ⴰⵙⵉⵎ","ⴰⵙⵉⴹ","ⴰⵙⴰⵎⴰⵙ","ⴰⵢⵏⴰⵙ","ⴰⵙⵉⵏⴰⵙ","ⴰⴽⵕⴰⵙ","ⴰⴽⵡⴰⵙ","ⵙⵉⵎⵡⴰⵙ","ⴰⵙⵉⴹⵢⴰⵙ","ⵜⵉⴼⴰⵡⵜ","ⵜⴰⴷⴳⴳⵯⴰⵜ","ⴷⴰⵄ","ⴷⴼⵄ","ⴷⴰⵜ ⵏ ⵄⵉⵙⴰ","ⴷⴼⴼⵉⵔ ⵏ ⵄⵉⵙⴰ","E a h.mm","E a h.mm.ss","M-d, E","MMM d E","a h.mm","a h.mm.ss","y-M-d, E","a h.mm.ss zzzz","a h.mm.ss z","ජ","පෙ","මා","අ","මැ","ජූ","සැ","ඔ","නෙ","දෙ","ජන","පෙබ","මාර්තු","අප්‍රේල්","මැයි","ජූනි","ජූලි","අගෝ","සැප්","ඔක්","නොවැ","දෙසැ","ජනවාරි","පෙබරවාරි","අගෝස්තු","සැප්තැම්බර්","ඔක්තෝබර්","නොවැම්බර්","දෙසැම්බර්","ඉ","ස","බ","බ්‍ර","සි","සෙ","ඉරිදා","සඳුදා","අඟහ","බදාදා","බ්‍රහස්","සිකු","සෙන","අඟහරුවාදා","බ්‍රහස්පතින්දා","සිකුරාදා","සෙනසුරාදා","පෙ.ව.","ප.ව.","ක්‍රි.පූ.","ක්‍රි.ව.","පො.යු.පෙ","පො.යු","ක්‍රිස්තු පූර්‍ව","ක්‍රිස්තු වර්‍ෂ","රු.","සිෆ්එ","E, d. M.","d. M","máj","jún","júl","januára","februára","apríla","mája","júna","júla","augusta","októbra","novembra","ut","pi","nedeľa","pondelok","utorok","streda","štvrtok","piatok","dopoludnia","odpoludnia","pred Kr.","pred n. l.","pred Kristom","po Kristovi","pred naším letopočtom","nášho letopočtu","NIS","M/y G","E, d. MM.","E, d. M. y","d. MM. yy","avg.","marec","junij","julij","avgust","č","ned.","sre.","čet.","pet.","nedelja","ponedeljek","torek","sreda","četrtek","petek","dop.","pop.","pr. n. št.","po n. št.","pred našim štetjem","naše štetje","pa","vu","ko","tu","vá","lá","pasepeeivi","vuossaargâ","majebaargâ","koskoho","tuorâstuv","vástuppeeivi","lávurduv","epiloho","Ndi","Kuk","Kub","Chv","Chk","Chg","Gun","Mb","Zvi","Ndira","Kukadzi","Kurume","Kubvumbi","Chivabvu","Chikumi","Chikunguru","Nyamavhuvhu","Gunyana","Gumiguru","Mbudzi","Zvita","Svo","Muv","Chip","Chit","Chin","Chis","Svondo","Muvhuro","China","Mugovera","Kristo asati auya","Kristo ashaya","Kob","Lab","Afr","Lix","Tod","Sid","Sag","KIT","LIT","Bisha Koobaad","Bisha Labaad","Bisha Saddexaad","Bisha Afraad","Bisha Shanaad","Bisha Lixaad","Bisha Todobaad","Bisha Sideedaad","Bisha Sagaalaad","Bisha Tobnaad","Bisha Kow iyo Tobnaad","Bisha Laba iyo Tobnaad","Axd","Axad","Isniin","Talaado","Arbaco","Khamiis","Jimco","sn.","gn.","CK","CD","Ciise ka hor (CS)","Ciise ka dib (CS)","Shk","Pri","Maj","Qer","Gsh","Sht","Tet","Nën","Dhj","janar","shkurt","prill","qershor","korrik","gusht","shtator","tetor","nëntor","dhjetor","Die","Hën","Mër","Enj","Pre","e diel","e hënë","e martë","e mërkurë","e enjte","e premte","e shtunë","paradite","pasdite","p.e.r.","e.r.","p.e.s.","e.s.","p.e.s","para erës së re","erës së re","para erës sonë","erës sonë","Lekë","den","dd.MMM","hh.mm a","hh.mm.ss a","M.y.","MMMM y.","QQQ. y","QQQQ. y","HH 'часова', mm 'минута', ss 'секунди' zzzz","по подне","[BGN]","[BYR]","сре","HH 'časova', mm 'minuta', ss 'sekundi' zzzz","avg","ponedeljak","pre podne","po podne","Taut","Amšir","Baramuda","Bašans","Jekatit","Nehase","Pre nove ere","Tišri","Hešvan","Ševat","Čaitra","Vaisaka","Jiaista","Asada","Badra","Argajana","Pauza","Maga","Falguna","Reb. 1","Reb 2","Džum. 1","Džum. 2","Redž.","Ša.","Še.","Zul-k.","Zul-h.","Muraham","Rađab","Šaʻban","Šaval","Duʻl-Kiʻda","Duʻl-hiđa","Hakuči (650-671)","Hakuho (672-686)","Šučo (686-701)","Taiho (701-704)","Vado (708-715)","Joro (717-724)","Tempio (729-749)","Tempio-kampo (749-749)","Tempio-šoho (749-757)","Tempio-hođi (757-765)","Tempo-đingo (765-767)","Đingo-keiun (767-770)","Hoki (770-780)","Ten-o (781-782)","Enrjaku (782-806)","Daido (806-810)","Konin (810-824)","Tenčo (824-834)","Šova (834-848)","Kajo (848-851)","Tenan (857-859)","Jogan (859-877)","Ninja (885-889)","Kampjo (889-898)","Šotai (898-901)","Enđi (901-923)","Enčo (923-931)","Šohei (931-938)","Tengjo (938-947)","Tenriaku (947-957)","Ova (961-964)","Koho (964-968)","Ana (968-970)","Jogen (976-978)","Kana (985-987)","Šorjaku (990-995)","Čotoku (995-999)","Čoho (999-1004)","Kanko (1004-1012)","Čova (1012-1017)","Kanin (1017-1021)","Đian (1021-1024)","Čogen (1028-1037)","Čorjaku (1037-1040)","Čokju (1040-1044)","Eišo (1046-1053)","Tenđi (1053-1058)","Kohei (1058-1065)","Đirjaku (1065-1069)","Enkju (1069-1074)","Šoho (1074-1077)","Šorjaku (1077-1081)","Eišo (1081-1084)","Otoku (1084-1087)","Kanđi (1087-1094)","Eičo (1096-1097)","Šotoku (1097-1099)","Kova (1099-1104)","Čođi (1104-1106)","Kašo (1106-1108)","Tenin (1108-1110)","Eikju (1113-1118)","Đen-ei (1118-1120)","Tenđi (1124-1126)","Daiđi (1126-1131)","Tenšo (1131-1132)","Čošao (1132-1135)","Eiđi (1141-1142)","Kođi (1142-1144)","Tenjo (1144-1145)","Kjuan (1145-1151)","Kjuju (1154-1156)","Heiđi (1159-1160)","Eirjaku (1160-1161)","Oho (1161-1163)","Čokan (1163-1165)","Kao (1169-1171)","Šoan (1171-1175)","Đišo (1177-1181)","Jova (1181-1182)","Đuei (1182-1184)","Genrjuku (1184-1185)","Bunđi (1185-1190)","Kenkju (1190-1199)","Šođi (1199-1201)","Kenin (1201-1204)","Genkju (1204-1206)","Šogen (1207-1211)","Kenrjaku (1211-1213)","Kenpo (1213-1219)","Šokju (1219-1222)","Đu (1222-1224)","Đenin (1224-1225)","Đoei (1232-1233)","Bunrjaku (1234-1235)","Rjakunin (1238-1239)","En-o (1239-1240)","Hođi (1247-1249)","Kenčo (1249-1256)","Kogen (1256-1257)","Šoka (1257-1259)","Šogen (1259-1260)","Bun-o (1260-1261)","Kočo (1261-1264)","Kenđi (1275-1278)","Koan (1278-1288)","Šu (1288-1293)","Šoan (1299-1302)","Tokuđi (1306-1308)","Očo (1311-1312)","Šova (1312-1317)","Bunpo (1317-1319)","Đeno (1319-1321)","Đenkjo (1321-1324)","Šoču (1324-1326)","Genko (1331-1334)","Kemu (1334-1336)","Kokoku (1340-1346)","Šohei (1346-1370)","Buču (1372-1375)","Korjaku (1379-1381)","Kova (1381-1384)","Genču (1384-1392)","Ku (1389-1390)","Oei (1394-1428)","Šočo (1428-1429)","Eikjo (1429-1441)","Hotoku (1449-1452)","Kjotoku (1452-1455)","Košo (1455-1457)","Čoroku (1457-1460)","Kanšo (1460-1466)","Bunšo (1466-1467)","Onin (1467-1469)","Čokjo (1487-1489)","Meio (1492-1501)","Eišo (1504-1521)","Kjoroku (1528-1532)","Kođi (1555-1558)","Tenšo (1573-1592)","Keičo (1596-1615)","Genva (1615-1624)","Šoho (1644-1648)","Šu (1652-1655)","Meirjaku (1655-1658)","Enpo (1673-1681)","Tenva (1681-1684)","Jokjo (1684-1688)","Hoei (1704-1711)","Šotoku (1711-1716)","Kjoho (1716-1736)","Kanpo (1741-1744)","Enkjo (1744-1748)","Horjaku (1751-1764)","Meiva (1764-1772)","Kjova (1801-1804)","Tenpo (1830-1844)","Koka (1844-1848)","Bunkju (1861-1864)","Genđi (1864-1865)","Keiko (1865-1868)","Meiđi","Haisei","Faravadin","Ordibehešt","Kordad","Šahrivar","Dej","Pre RK","RK","sre","Bhi","Van","Vol","Nkh","Nhl","Kho","Ngc","Nyo","Mph","Ngo","Bhimbidvwane","iNdlovana","iNdlovu-lenkhulu","iNkhwekhweti","iNhlaba","Kholwane","iNgci","iNyoni","iMphala","Lweti","iNgongoni","Mso","Tsa","Mgc","Lisontfo","uMsombuluko","Lesibili","Lesitsatfu","Lesine","Lesihlanu","uMgcibelo","Sal","Naba Sambat","Sani","Salus","Rabuq","Camus","Jumqata","Qunxa Sambat","augusti","sön","mån","tis","ons","tors","fre","lör","söndag","tisdag","lördag","fm","em","kiahk","före Kristus","efter Kristus","före västerländsk tideräkning","västerländsk tideräkning","tishrí","heshván","kislév","tevét","shevát","adár I","adár","nisán","ijjár","siván","tammúz","elúl","adár II","Saka-eran","jumada-l-ula","jumada-l-akhira","sha’ban","shawwal","dhu-l-ga’da","dhu-l-hijja","Hakuchi (650–671)","Hakuhō (672–686)","Shuchō (686–701)","Taihō (701–704)","Wadō (708–715)","Yōrō (717–724)","Tempyō (729–749)","Tempyō-kampō (749–749)","Tempyō-shōhō (749–757)","Tempyō-hōji (757–765)","Temphō-jingo (765–767)","Jingo-keiun (767–770)","Hōki (770–780)","Ten-ō (781–782)","Enryaku (782–806)","Daidō (806–810)","Kōnin (810–824)","Tenchō (824–834)","Jōwa (834–848)","Kajō (848–851)","Tennan (857–859)","Jōgan (859–877)","Ninna (885–889)","Kampyō (889–898)","Shōtai (898–901)","Enchō (923–931)","Shōhei (931–938)","Tengyō (938–947)","Tenryaku (947–957)","Ōwa (961–964)","Kōhō (964–968)","Anna (968–970)","Jōgen (976–978)","Kanna (985–987)","Shōryaku (990–995)","Chōtoku (995–999)","Chōhō (999–1004)","Kankō (1004–1012)","Chōwa (1012–1017)","Kannin (1017–1021)","Jian (1021–1024)","Manju (1024–1028)","Chōgen (1028–1037)","Chōryaku (1037–1040)","Chōkyū (1040–1044)","Eishō (1046–1053)","Kōhei (1058–1065)","Jiryaku (1065–1069)","Enkyū (1069–1074)","Shōho (1074–1077)","Shōryaku (1077–1081)","Eiho (1081–1084)","Ōtoku (1084–1087)","Kanji (1087–1094)","Eichō (1096–1097)","Shōtoku (1097–1099)","Kōwa (1099–1104)","Chōji (1104–1106)","Kashō (1106–1108)","Tennin (1108–1110)","Eikyū (1113–1118)","Tenji (1124–1126)","Daiji (1126–1131)","Tenshō (1131–1132)","Chōshō (1132–1135)","Eiji (1141–1142)","Kōji (1142–1144)","Tenyō (1144–1145)","Kyūan (1145–1151)","Kyūju (1154–1156)","Heiji (1159–1160)","Eiryaku (1160–1161)","Ōho (1161–1163)","Chōkan (1163–1165)","Kaō (1169–1171)","Shōan (1171–1175)","Jishō (1177–1181)","Yōwa (1181–1182)","Juei (1182–1184)","Genryuku (1184–1185)","Bunji (1185–1190)","Kenkyū (1190–1199)","Shōji (1199–1201)","Kennin (1201–1204)","Genkyū (1204–1206)","Shōgen (1207–1211)","Kenryaku (1211–1213)","Kenpō (1213–1219)","Shōkyū (1219–1222)","Jōō (1222–1224)","Gennin (1224–1225)","Jōei (1232–1233)","Bunryaku (1234–1235)","Ryakunin (1238–1239)","En-ō (1239–1240)","Ninji (1240–1243)","Hōji (1247–1249)","Kenchō (1249–1256)","Kōgen (1256–1257)","Shōka (1257–1259)","Shōgen (1259–1260)","Bun-ō (1260–1261)","Kōchō (1261–1264)","Kenji (1275–1278)","Kōan (1278–1288)","Shōō (1288–1293)","Shōan (1299–1302)","Tokuji (1306–1308)","Ōchō (1311–1312)","Shōwa (1312–1317)","Bunpō (1317–1319)","Genō (1319–1321)","Genkyō (1321–1324)","Shōchū (1324–1326)","Genkō (1331–1334)","Kemmu (1334–1336)","Kōkoku (1340–1346)","Shōhei (1346–1370)","Bunchū (1372–1375)","Tenju (1375–1379)","Kōryaku (1379–1381)","Kōwa (1381–1384)","Genchū (1384–1392)","Kōō (1389–1390)","Ōei (1394–1428)","Shōchō (1428–1429)","Eikyō (1429–1441)","Hōtoku (1449–1452)","Kyōtoku (1452–1455)","Kōshō (1455–1457)","Chōroku (1457–1460)","Kanshō (1460–1466)","Bunshō (1466–1467)","Ōnin (1467–1469)","Chōkyō (1487–1489)","Meiō (1492–1501)","Eishō (1504–1521)","Kyōroku (1528–1532)","Kōji (1555–1558)","Tenshō (1573–1592)","Keichō (1596–1615)","Genwa (1615–1624)","Shōho (1644–1648)","Shōō (1652–1655)","Meiryaku (1655–1658)","Manji (1658–1661)","Enpō (1673–1681)","Tenwa (1681–1684)","Jōkyō (1684–1688)","Hōei (1704–1711)","Shōtoku (1711–1716)","Kyōhō (1716–1736)","Kanpō (1741–1744)","Enkyō (1744–1748)","Hōryaku (1751–1764)","Meiwa (1764–1772)","Kyōwa (1801–1804)","Tenpō (1830–1844)","Kōka (1844–1848)","Bunkyū (1861–1864)","Genji (1864–1865)","Keiō (1865–1868)","farvardin","ordibehesht","khordād","tir","mordād","shahrivar","mehr","ābān","āzar","dey","bahman","esfand","före R.K.","R.K.","Bds$","BM$","BR$","BS$","BZ$","CAN$","RD$","Ekr","EG£","Ikr","JM$","EEEE'en' 'den' d:'e' MMMM y","före vår tideräkning","vår tideräkning","mkw","mpi","mtu","msb","mun","mts","mku","mkm","mkb","mwezi ya kwanja","mwezi ya pili","mwezi ya tatu","mwezi ya ine","mwezi ya tanu","mwezi ya sita","mwezi ya saba","mwezi ya munane","mwezi ya tisa","mwezi ya kumi","mwezi ya kumi na moya","mwezi ya kumi ya mbili","yen","pil","tat","ine","tan","sit","siku ya yenga","siku ya kwanza","siku ya pili","siku ya tatu","siku ya ine","siku ya tanu","siku ya sita","ya asubuyi","ya muchana","mbele ya Y","kisha ya Y","mbele ya Yezu Kristo","kisha ya Yezu Kristo","ஜ","பி","மா","ஏ","மே","ஜூ","ஆ","செ","அ","ந","டி","ஜன.","பிப்.","மார்.","ஏப்.","ஜூன்","ஜூலை","ஆக.","செப்.","அக்.","நவ.","டிச.","ஜனவரி","பிப்ரவரி","மார்ச்","ஏப்ரல்","ஆகஸ்ட்","செப்டம்பர்","அக்டோபர்","நவம்பர்","டிசம்பர்","ஞா","தி","பு","வி","வெ","ச","ஞாயிறு","திங்கள்","செவ்வாய்","புதன்","வியாழன்","வெள்ளி","சனி","முற்பகல்","பிற்பகல்","மா1","மா2","மா3","மா4","மா5","மா6","மா7","மா8","மா9","மா10","மா11","மா12","மாதம்1","மாதம்2","மாதம்3","மாதம்4","மாதம்5","மாதம்6","மாதம்7","மாதம்8","மாதம்9","மாதம்10","மாதம்11","மாதம்12","கி.மு.","கி.பி.","பொ.ச.மு","பொ.ச","கிறிஸ்துவுக்கு முன்","அனோ டோமினி","Rs.","S$","G, E d, MMM y","G d, MMM y","d, MMM y","d, MMMM y, EEEE","జ","ఫి","మా","ఏ","మే","జూ","జు","ఆ","సె","అ","న","డి","జన","ఫిబ్ర","మార్చి","ఏప్రి","జూన్","జులై","ఆగ","సెప్టెం","అక్టో","నవం","డిసెం","జనవరి","ఫిబ్రవరి","ఏప్రిల్","ఆగస్టు","సెప్టెంబర్","అక్టోబర్","నవంబర్","డిసెంబర్","సో","మ","బు","గు","శు","శ","ఆది","సోమ","మంగళ","బుధ","గురు","శుక్ర","శని","ఆదివారం","సోమవారం","మంగళవారం","బుధవారం","గురువారం","శుక్రవారం","శనివారం","[AM]","[PM]","ఈసాపూర్వ.","సన్.","[BCE]","[CE]","క్రీపూ","క్రీశ","క్రీస్తు పూర్వం","క్రీస్తు శకం","ప్రస్తుత శకానికి పూర్వం","ప్రస్తుత శకం","చైత్రం","వైశాఖం","జ్యేష్ఠం","ఆషాఢం","శ్రావణం","భాద్రపదం","ఆశ్వయుజం","కార్తీకం","మార్గశిరం","పుష్యం","మాఘం","ఫల్గుణం","శక","Muk","Dun","Mod","Ped","Sok","Tib","Poo","Orara","Omuk","Okwamg’","Odung’el","Omaruk","Omodok’king’ol","Ojola","Opedel","Osokosokoma","Otibar","Olabor","Opoo","Bar","Aar","Uni","Ung","Nakaejuma","Nakaebarasa","Nakaare","Nakauni","Nakaung’on","Nakakany","Nakasabiti","Taparachu","Ebongi","E d MMM G y","d MMM G y","EEEEที่ d MMMM G y","d MMMM G y","H นาฬิกา mm นาที ss วินาที zzzz","H นาฬิกา mm นาที ss วินาที z","ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค.","มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม","อา","จ","อ","พ","พฤ","ศ","ส","อา.","จ.","อ.","พ.","พฤ.","ศ.","ส.","วันอาทิตย์","วันจันทร์","วันอังคาร","วันพุธ","วันพฤหัสบดี","วันศุกร์","วันเสาร์","พ.ศ.","พุทธศักราช","ก่อนเที่ยง","หลังเที่ยง","เทาท์","บาบา","ฮาเทอร์","เคียฟ","โทบา","อัมเชอร์","บารัมฮัท","บาราเมาดา","บาชันส์","พาโอนา","อีเปป","เมสรา","นาซี","เมสเคอเรม","เตเกมท","เฮดาร์","ทาฮ์ซัส","เทอร์","เยคาทิท","เมกาบิต","เมียเซีย","เจนบอต","เซเน","ฮัมเล","เนแฮซ","พากูเมน","ก่อน ค.ศ.","ค.ศ.","ก.ส.ศ.","ส.ศ.","ปีก่อน ค.ศ.","ปีก่อนคริสต์ศักราช","คริสต์ศักราช","ก่อนสามัญศักราช","สามัญศักราช","ทิชรี","เฮวาน","กีสเลฟ","เตเวต","เชวัต","อาดาร์ I","อาดาร์","นิสซาน","อิยาร์","สีวัน","ตามูซ","อัฟ","เอลอุล","อาดาร์ II","ย.ศ.","จิตรา","วิสาขา","เชษฐา","อัษฎา","ศรวณา","พัตรา","อัศวิชา","การติกา","มฤคศิรา","ปุษยา","มาฆะ","ผลคุณี","ม.ศ.","มุฮัร.","เศาะ.","รอบี 1","รอบี 2","ญุมา 1","ญุมา 2","เราะ.","ชะอ์.","เราะมะ.","เชาว.","ซุลกิอฺ.","ซุลหิจ.","มุฮะร์รอม","ซอฟาร์","รอบี I","รอบี II","จุมาดา I","จุมาดา II","รอจับ","ชะอะบาน","รอมะดอน","เชาวัล","ซุลกิอฺดะฮฺ","ซุลหิจญะฮฺ","ฮ.ศ.","ฮิจเราะห์ศักราช","ทะอิกะ (645-650)","ฮะกุชิ (650-671)","ฮากุโฮ (672-686)","ชุโช (686-701)","ทะอิโฮ (701-704)","เคอุง (704-708)","วะโด (708-715)","เรกิ (715-717)","โยโร (717-724)","จิงกิ (724-729)","เท็มเพียว (729-749)","เท็มเพียว-คัมโป (749-749)","เท็มเพียว-โชโฮ (749-757)","เท็มเพียว-โฮจิ (757-765)","เท็มเพียว-จิงโงะ (765-767)","จิงโงะ-เคอุง (767-770)","โฮกิ (770-780)","เท็นโอ (781-782)","เอ็นเรียะกุ (782-806)","ดะอิโด (806-810)","โคนิง (810-824)","เท็นโช (824-834)","โชวะ (834-848)","คะโจ (848-851)","นินจุ (851-854)","ซะอิโกะ (854-857)","เท็นนัง (857-859)","โจงัง (859-877)","เก็งเก (877-885)","นินนะ (885-889)","คัมเพียว (889-898)","โชตะอิ (898-901)","เอ็งงิ (901-923)","เอ็นโช (923-931)","โชเฮ (931-938)","เท็งเงียว (938-947)","เท็นเรียะกุ (947-957)","เท็นโตะกุ (957-961)","โอวะ (961-964)","โคโฮ (964-968)","อันนะ (968-970)","เท็นโระกุ (970-973)","เท็นเอ็ง (973-976)","โจเง็ง (976-978)","เท็งเง็ง (978-983)","เอกัง (983-985)","คันนะ (985-987)","เอเอ็ง (987-989)","เอโซ (989-990)","โชเรียะกุ (990-995)","โชโตะกุ (995-999)","โชโฮ (999-1004)","คันโก (1004-1012)","โชวะ (1012-1017)","คันนิง (1017-1021)","จิอัง (1021-1024)","มันจุ (1024-1028)","โชเง็ง (1028-1037)","โชเรียะกุ (1037-1040)","โชคีว (1040-1044)","คันโตะกุ (1044-1046)","เอโช (1046-1053)","เท็งงิ (1053-1058)","โคเฮ (1058-1065)","จิเรียะกุ (1065-1069)","เอ็งคีว (1069-1074)","โชโฮ (1074-1077)","โชเรียะกุ (1077-1081)","เอโฮะ (1081-1084)","โอโตะกุ (1084-1087)","คันจิ (1087-1094)","คะโฮะ (1094-1096)","เอโช (1096-1097)","โชโตะกุ (1097-1099)","โควะ (1099-1104)","โชจิ (1104-1106)","คะโช (1106-1108)","เท็นนิง (1108-1110)","เท็นเอ (1110-1113)","เอกีว (1113-1118)","เก็นเอ (1118-1120)","โฮะอัง (1120-1124)","เท็นจิ (1124-1126)","ดะอิจิ (1126-1131)","เท็นโช (1131-1132)","โชโช (1132-1135)","โฮะเอ็ง (1135-1141)","เอจิ (1141-1142)","โคจิ (1142-1144)","เท็นโย (1144-1145)","คีวอัง (1145-1151)","นิมเป (1151-1154)","คีวจุ (1154-1156)","โฮะเง็ง (1156-1159)","เฮจิ (1159-1160)","เอเรียะกุ (1160-1161)","โอโฮ (1161-1163)","โชกัง (1163-1165)","เอมัง (1165-1166)","นินอัง (1166-1169)","คะโอ (1169-1171)","โชอัง (1171-1175)","อังเง็ง (1175-1177)","จิโช (1177-1181)","โยวะ (1181-1182)","จุเอ (1182-1184)","เก็นเรียะกุ (1184-1185)","บุนจิ (1185-1190)","เค็งกีว (1190-1199)","โชจิ (1199-1201)","เค็นนิง (1201-1204)","เก็งกีว (1204-1206)","เค็นเอ (1206-1207)","โชเก็ง (1207-1211)","เค็นเรียะกุ (1211-1213)","เค็มโป (1213-1219)","โชกีว (1219-1222)","โจโอ (1222-1224)","เก็นนิง (1224-1225)","คะโระกุ (1225-1227)","อันเต (1227-1229)","คังกิ (1229-1232)","โจเอ (1232-1233)","เท็มปุกุ (1233-1234)","บุนเรียะกุ (1234-1235)","คะเต (1235-1238)","เรียะกุนิง (1238-1239)","เอ็นโอ (1239-1240)","นินจิ (1240-1243)","คังเง็ง (1243-1247)","โฮจิ (1247-1249)","เค็นโช (1249-1256)","โคเง็ง (1256-1257)","โชกะ (1257-1259)","โชเง็ง (1259-1260)","บุนโอ (1260-1261)","โคโช (1261-1264)","บุนเอ (1264-1275)","เค็นจิ (1275-1278)","โคอัง (1278-1288)","โชโอ (1288-1293)","เอนิง (1293-1299)","โชอัง (1299-1302)","เค็งเง็ง (1302-1303)","คะเง็ง (1303-1306)","โทะกุจิ (1306-1308)","เอ็งเก (1308-1311)","โอโช (1311-1312)","โชวะ (1312-1317)","บุมโป (1317-1319)","เก็นโอ (1319-1321)","เก็งเกียว (1321-1324)","โชชู (1324-1326)","คะเระกิ (1326-1329)","เก็นโตะกุ (1329-1331)","เก็งโก (1331-1334)","เค็มมุ (1334-1336)","เอ็งเง็ง (1336-1340)","โคโกะกุ (1340-1346)","โชเฮ (1346-1370)","เค็นโตะกุ (1370-1372)","บุนชู (1372-1375)","เท็นจุ (1375-1379)","โคเรียะกุ (1379-1381)","โควะ (1381-1384)","เก็นชู (1384-1392)","เมโตะกุ (1384-1387)","คะเค (1387-1389)","โคโอ (1389-1390)","เมโตะกุ (1390-1394)","โอเอ (1394-1428)","โชโช (1428-1429)","เอเกียว (1429-1441)","คะกิสึ (1441-1444)","บุนอัง (1444-1449)","โฮโตะกุ (1449-1452)","เคียวโตะกุ (1452-1455)","โคโช (1455-1457)","โชโระกุ (1457-1460)","คันโช (1460-1466)","บุนโช (1466-1467)","โอนิง (1467-1469)","บุมเม (1469-1487)","โชเกียว (1487-1489)","เอ็นโตะกุ (1489-1492)","เมโอ (1492-1501)","บุงกิ (1501-1504)","เอโช (1504-1521)","ทะอิเอ (1521-1528)","เคียวโระกุ (1528-1532)","เท็มมน (1532-1555)","โคจิ (1555-1558)","เอโระกุ (1558-1570)","เก็งกิ (1570-1573)","เท็นโช (1573-1592)","บุนโระกุ (1592-1596)","เคโช (1596-1615)","เก็งวะ (1615-1624)","คันเอ (1624-1644)","โชโฮ (1644-1648)","เคอัง (1648-1652)","โชโอ (1652-1655)","เมเรียะกุ (1655-1658)","มันจิ (1658-1661)","คัมบุง (1661-1673)","เอ็มโป (1673-1681)","เท็นวะ (1681-1684)","โจเกียว (1684-1688)","เก็นโระกุ (1688-1704)","โฮเอ (1704-1711)","โชโตะกุ (1711-1716)","เคียวโฮ (1716-1736)","เก็มบุง (1736-1741)","คัมโป (1741-1744)","เอ็งเกียว (1744-1748)","คันเอ็ง (1748-1751)","โฮเรียะกุ (1751-1764)","เมวะ (1764-1772)","อันเอ (1772-1781)","เท็มเม (1781-1789)","คันเซ (1789-1801)","เคียววะ (1801-1804)","บุงกะ (1804-1818)","บุนเซ (1818-1830)","เท็มโป (1830-1844)","โคกะ (1844-1848)","คะเอ (1848-1854)","อันเซ (1854-1860)","มันเอ็ง (1860-1861)","บุงกีว (1861-1864)","เก็นจิ (1864-1865)","เคโอ (1865-1868)","เมจิ","ทะอิโช","โชวะ","เฮเซ","ฟาร์วาร์ดิน","ออร์ดิเบเฮชต์","คอร์แดด","เตอร์","มอร์แดด","ชาหริวาร์","เมฮร์","อะบาน","อะซาร์","เดย์","บาฮ์มาน","เอสฟานด์","ปีเปอร์เซีย","ปีก่อนไต้หวัน","ไต้หวัน","EEEE፡ dd MMMM መዓልቲ y G","ጥሪ","ለካቲ","ሰነ","ሓምለ","ነሓሰ","ሕዳር","ታሕሳ","ለካቲት","ጥቅምቲ","ታሕሳስ","ሠ","ኃ","ቀ","ሰንበት","ሰኑይ","ሰሉስ","ሓሙስ","ዓርቢ","ቀዳም","ንጉሆ ሰዓተ","ድሕር ሰዓት","EEEE፣ dd MMMM መዓልቲ y G","ኤፕረ","ኦክተ","ኤፕረል","ኦክተውበር","ሠሉስ","ኃሙስ","Fer","Tlh","Mop","Mor","Mot","See","Phu","Pha","Dip","Ngw","Sed","Ferikgong","Tlhakole","Mopitlo","Moranang","Motsheganang","Seetebosigo","Phukwi","Phatwe","Lwetse","Diphalane","Ngwanatsele","Sedimonthole","Tsh","Tla","Tshipi","Mosopulogo","Labotlhano","Matlhatso","Sān","Fēp","Maʻa","ʻEpe","Mē","Siu","ʻAok","ʻOka","Nōv","Tīs","Sānuali","Fēpueli","Maʻasi","ʻEpeleli","Sune","Siulai","ʻAokosi","Sepitema","ʻOkatopa","Nōvema","Tīsema","Sāp","Mōn","Tūs","Pul","Tuʻa","Fal","Tok","Sāpate","Mōnite","Tūsite","Pulelulu","Tuʻapulelulu","Falaite","Tokonaki","KāMā","TāSā","TS","ki muʻa","taʻu ʻo Sīsū","TF","AUD$","NZD$","E a h:mm","E a h:mm:ss","G d MMM y E","G dd MMM y","dd/MM E","d MMMM E","dd MMMM E","dd.MM.y E","d MMM y E","y/QQQQ","d MMMM y EEEE","Ş","Oca","Şub","Nis","Haz","Tem","Ağu","Eyl","Eki","Ocak","Şubat","Mart","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık","Ç","Paz","Pzt","Çar","Per","Cum","Pazar","Pazartesi","Salı","Çarşamba","Perşembe","Cuma","Cumartesi","ÖÖ","ÖS","Tût","Bâbe","Keyhek","Tûbe","Imşir","Bermuhat","Bermude","Peyştes","Bune","Ebip","Mısrî","Nesî","Tikimt","Hidar","Yakatit","Magabit","Ginbot","Nehasa","Pagumiene","MÖ","MS","İÖ","İS","Milattan Önce","Milattan Sonra","İsa’dan Önce","İsa’dan Sonra","Tişri","Heşvan","Şevat","Veadar","İyar","Muharrem","Safer","Rebiülevvel","Rebiülahir","Cemaziyelevvel","Cemaziyelahir","Recep","Şaban","Ramazan","Şevval","Zilkade","Zilhicce","Hicri","Ferverdin","Ordibeheşt","Hordad","Şehriver","Azer","Behmen","Esfend","%{number}","-%{number}","Kul","Dzi","Mha","Ndz","Huk","N’w","Sunguti","Nyenyenyani","Nyenyankulu","Dzivamisoko","Mudyaxihi","Khotavuxika","Mawuwani","Mhawuri","Ndzhati","Hukuri","N’wendzamhala","Bir","Har","Musumbhunuku","Ravumbirhi","Ravunharhu","Ravumune","Ravuntlhanu","Mugqivela","Ibr","Cut","Kṭu","Nwa","Duj","Yebrayer","Ibrir","Yulyuz","Cutanbir","Kṭuber","Nwanbir","Dujanbir","Asa","Ayn","Asn","Akr","Akw","Asm","Asḍ","Asamas","Aynas","Asinas","Akras","Akwas","Asimwas","Asiḍyas","Zdat azal","Ḍeffir aza","ZƐ","ḌƐ","Zdat Ɛisa (TAƔ)","Ḍeffir Ɛisa (TAƔ)","{1}، {0}","E، MMM d، y G","MMM d، y G","E، M/d","E، MMM d","E، M/d/y","E، MMM d، y","MMM d، y","EEEE، MMMM d، y","MMMM d، y","يانۋار","فېۋرال","مارت","ئاپرېل","ئىيۇن","ئىيۇل","ئاۋغۇست","سېنتەبىر","ئۆكتەبىر","نويابىر","دېكابىر","بويابىر","يە","دۈ","سە","چا","پە","چۈ","شە","يەكشەنبە","دۈشەنبە","سەيشەنبە","چارشەنبە","پەيشەنبە","جۈمە","شەنبە","بۇددا يىلنامەسى","چۈشتىن بۇرۇن","چۈشتىن كېيىن","مىلادىيەدىن بۇرۇن","مىلادىيە","مۇھەررەم","سەپەر","رەبىئۇلئەۋۋەل","رەبىئۇلئاخىر","جەمادىيەلئەۋۋەل","جەمادىيەلئاخىر","رەجەب","شەئبان","رامىزان","شەۋۋال","زۇلقەئدە","زۇلھەججە","ھىجرىيە","جۇڭخۇا مىنگودىن بۇرۇن","مىنگو","QQQQ y 'р'.","EEEE, d MMMM y 'р'.","d MMMM y 'р'.","d MMM y 'р'.","Л","В","Г","січ.","лют.","бер.","квіт.","трав.","черв.","лип.","серп.","вер.","жовт.","лист.","груд.","січня","лютого","березня","квітня","травня","червня","липня","серпня","вересня","жовтня","листопада","грудня","П","Нд","Пн","Вт","Ср","Чт","Пт","неділя","понеділок","вівторок","середа","четвер","пʼятниця","дп","пп","тот.","баб.","хат.","кіх.","тоб.","амш.","барам.","барм.","баш.","баун.","аб.","мис.","нас.","Бабе","Кіхак","Тобе","Абіб","Насі","мес.","тек.","хед.","тах.","тер.","єкат.","мег.","міяз.","ген.","хам.","нех.","паг.","мескерема","текемта","хедара","тахсаса","тера","єкатіта","мегабіта","міязія","генбота","сене","хамле","нехасе","пагумена","до н.е.","до н. е.","до нашої ери","нашої ери","Тішри","Марчешван","Числьов","Тебет","Нісан","Іар","Аб","чайт.","вайс.","джай.","асад.","шрав.","бхад.","асв.","кар.","агр.","паус.","маг.","фаль.","джайстха","шравана","бхадра","асвіна","картіка","аграхаяна","пауса","фальгуна","мух.","саф.","раб. I","раб. II","джум. I","джум. II","радж.","шааб.","рам.","дав.","зу-ль-к.","зу-ль-х.","Рабі I","Рабі II","Джумада I","Джумада II","Даввал","Зу-ль-каада","Зу-ль-хіджа","Тайка (645–650)","Хакуті (650–671)","Хакухо (672–686)","Сютьо (686–701)","Тайхо (701–704)","Кейун (704–708)","Вадо (708–715)","Рейкі (715–717)","Йоро (717–724)","Дзінгі (724–729)","Темпьо (729–749)","Темпьо-кампо (749–749)","Темпьо-сьохо (749–757)","Темпьо-ходзі (757–765)","Темпьо-дзінго (765–767)","Дзінго кейун (767–770)","Хокі (770–780)","Тен’о (781–782)","Енряку (782–806)","Дайдо (806–810)","Конін (810–824)","Тентьо (824–834)","Сьова (834–848)","Кадзьо (848–851)","Ніндзю (851–854)","Сайко (854–857)","Теннан (857–859)","Дзьоган (859–877)","Генкей (877–885)","Нінна (885–889)","Кампьо (889–898)","Сьотай (898–901)","Енгі (901–923)","Ентьо (923–931)","Сьохей (931–938)","Тенгьо (938–947)","Тенряку (947–957)","Тентоку (957–961)","Ова (961–964)","Кохо (964–968)","Анна (968–970)","Тенроку (970–973)","Тен’ен (973–976)","Дзьоген (976–978)","Тенген (978–983)","Ейкан (983–985)","Канна (985–987)","Ейен (987–989)","Ейсо (989–990)","Сьоряку (990–995)","Тьотоку (995–999)","Тьохо (999–1004)","Канко (1004–1012)","Тьова (1012–1017)","Каннін (1017–1021)","Дзіан (1021–1024)","Мандзю (1024–1028)","Тьоген (1028–1037)","Тьоряку (1037–1040)","Тьокю (1040–1044)","Кантоку (1044–1046)","Ейсьо (1046–1053)","Тенгі (1053–1058)","Кохей (1058–1065)","Дзіряку (1065–1069)","Енкю (1069–1074)","Сьохо (1074–1077)","Сьоряку (1077–1081)","Ейхо (1081–1084)","Отоку (1084–1087)","Кандзі (1087–1094)","Кахо (1094–1096)","Ейсьо (1096–1097)","Сьотоку (1097–1099)","Кова (1099–1104)","Тьодзі (1104–1106)","Кадзьо (1106–1108)","Теннін (1108–1110)","Тен’ей (1110–1113)","Ейкю (1113–1118)","Ген’ей (1118–1120)","Хоан (1120–1124)","Тендзі (1124–1126)","Дайдзі (1126–1131)","Тенсьо (1131–1132)","Тьосьо (1132–1135)","Хоен (1135–1141)","Ейдзі (1141–1142)","Кодзі (1142–1144)","Теньо (1144–1145)","Кюан (1145–1151)","Німпей (1151–1154)","Кюдзю (1154–1156)","Хоген (1156–1159)","Хейдзі (1159–1160)","Ейряку (1160–1161)","Охо (1161–1163)","Тьокан (1163–1165)","Ейман (1165–1166)","Нін’ан (1166–1169)","Као (1169–1171)","Сьоан (1171–1175)","Анген (1175–1177)","Дзісьо (1177–1181)","Йова (1181–1182)","Дзюей (1182–1184)","Генряку (1184–1185)","Бундзі (1185–1190)","Кенкю (1190–1199)","Сьодзі (1199–1201)","Кеннін (1201–1204)","Генкю (1204–1206)","Кен’ей (1206–1207)","Сьоген (1207–1211)","Кенряку (1211–1213)","Кенпо (1213–1219)","Дзьокю (1219–1222)","Дзьоо (1222–1224)","Геннін (1224–1225)","Кароку (1225–1227)","Антей (1227–1229)","Канкі (1229–1232)","Дзюей (1232–1233)","Темпуку (1233–1234)","Бунряку (1234–1235)","Катей (1235–1238)","Рякунін (1238–1239)","Ен’о (1239–1240)","Ніндзі (1240–1243)","Канген (1243–1247)","Хейдзі (1247–1249)","Кентьо (1249–1256)","Коген (1256–1257)","Сьока (1257–1259)","Сьоген (1259–1260)","Бун’о (1260–1261)","Котьо (1261–1264)","Бун’ей (1264–1275)","Кендзі (1275–1278)","Коан (1278–1288)","Сьоо (1288–1293)","Ейнін (1293–1299)","Сьоан (1299–1302)","Кенген (1302–1303)","Каген (1303–1306)","Токудзі (1306–1308)","Енкей (1308–1311)","Отьо (1311–1312)","Сьова (1312–1317)","Бумпо (1317–1319)","Ген’о (1319–1321)","Генкьо (1321–1324)","Сьотю (1324–1326)","Карекі (1326–1329)","Гентоку (1329–1331)","Генко (1331–1334)","Кемму (1334–1336)","Ейген (1336–1340)","Кококу (1340–1346)","Сьохей (1346–1370)","Кентоку (1370–1372)","Бунтю (1372–1375)","Тендзю (1375–1379)","Коряку (1379–1381)","Кова (1381–1384)","Гентю (1384–1392)","Мейтоку (1384–1387)","Какей (1387–1389)","Коо (1389–1390)","Мейтоку (1390–1394)","Оей (1394–1428)","Сьотьо (1428–1429)","Ейкьо (1429–1441)","Какіцу (1441–1444)","Буннан (1444–1449)","Хотоку (1449–1452)","Кьотоку (1452–1455)","Косьо (1455–1457)","Тьороку (1457–1460)","Кансьо (1460–1466)","Бунсьо (1466–1467)","Онін (1467–1469)","Буммей (1469–1487)","Тьокьо (1487–1489)","Ентоку (1489–1492)","Мейо (1492–1501)","Бункі (1501–1504)","Ейсьо (1504–1521)","Тайей (1521–1528)","Кьороку (1528–1532)","Теммон (1532–1555)","Кодзі (1555–1558)","Ейроку (1558–1570)","Генкі (1570–1573)","Тенсьо (1573–1592)","Бунроку (1592–1596)","Кейтьо (1596–1615)","Генна (1615–1624)","Кан’ей (1624–1644)","Сьохо (1644–1648)","Кейан (1648–1652)","Сьоо (1652–1655)","Мейряку (1655–1658)","Мандзі (1658–1661)","Камбун (1661–1673)","Емпо (1673–1681)","Тенва (1681–1684)","Дзьокьо (1684–1688)","Генроку (1688–1704)","Хоей (1704–1711)","Сьотоку (1711–1716)","Кьохо (1716–1736)","Гембун (1736–1741)","Канпо (1741–1744)","Енкьо (1744–1748)","Кан’ен (1748–1751)","Хоряку (1751–1764)","Мейва (1764–1772)","Ан’ей (1772–1781)","Теммей (1781–1789)","Кансей (1789–1801)","Кьова (1801–1804)","Бунка (1804–1818)","Бунсей (1818–1830)","Тенпо (1830–1844)","Кока (1844–1848)","Каей (1848–1854)","Ансей (1854–1860)","Ман’ен (1860–1861)","Бункю (1861–1864)","Гендзі (1864–1865)","Кейо (1865–1868)","Мейдзі","Тайсьо","Хейсей","фар.","орд.","хор.","тір.","мор.","шах.","мех.","абан.","азер.","дея","бах.","есф.","Фарвардін","Ордібехешт","Тір","Шахрівер","Не число","крб.","مئی","بدھ","قبل دوپہر","بعد دوپہر","قبل مسیح","عیسوی","ر بیع الاول","ر بیع الثانی","ذوالقعدۃ","ذوالحجۃ","ق م","عیسوی سن","یہ عدد نہیں","سوموار","d نچی MMMM","y نچی ییل d نچی MMMM EEEE کونی","d نچی MMMM y","فبر","مار","اپر","اگس","سپت","اکت","نوم","ی.","د.","س.","چ.","پ.","ج.","ش.","Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек","Январ","Феврал","Март","Апрел","Август","Сентябр","Октябр","Ноябр","Декабр","Якш","Душ","Сеш","Чор","Пай","Жум","Шан","якшанба","душанба","сешанба","чоршанба","пайшанба","шанба","М.А.","Э","Муҳаррам","Рабиул-аввал","Рабиул-охир","Жумодиул-уло","Жумодиул-ухро","Ражаб","Шаъбон","Рамазон","Шаввол","Зил-қаъда","Зил-ҳижжа","сўм","Yanv","Iyun","Iyul","Avg","Noya","Dek","Yanvar","Fevral","Aprel","Avgust","Sentabr","Oktabr","Noyabr","Dekabr","Yaksh","Dush","Sesh","Chor","Shan","yakshanba","dushanba","seshanba","chorshanba","payshanba","shanba","TO","M.A.","Eramizdan avvalgi","Robiʼ ul-avval","Robiʼ ul-oxir","Jumad ul-avval","Jumad ul-oxir","Shaʼbon","Ramazon","Shavvol","Zul-qaʼda","Zul-hijja","soʻm","luukao kemã","ɓandaɓu","vɔɔ","fulu","goo","kɔnde","saah","galo","kenpkato ɓololɔ","luukao lɔma","lahadi","tɛɛnɛɛ","talata","alaba","aimisa","aijima","siɓiti","ꖨꕪꖃ ꔞꕮ","ꕒꕡꖝꖕ","ꕾꖺ","ꖢꖕ","ꖑꕱ","ꗛꔕ","ꕢꕌ","ꕭꖃ","ꔞꘋꕔꕿ ꕸꖃꗏ","ꖨꕪꕱ ꗏꕮ","ꕞꕌꔵ","ꗳꗡꘉ","ꕚꕞꕚ","ꕉꕞꕒ","ꕉꔤꕆꕢ","ꕉꔤꕀꕮ","ꔻꔬꔳ","Luh","Ṱhf","Lam","Shu","Lwi","Lwa","Ṱha","Khu","Ḽar","Phando","Luhuhi","Ṱhafamuhwe","Lambamai","Shundunthule","Fulwi","Fulwana","Ṱhangule","Khubvumedzi","Tshimedzi","Ḽara","Nyendavhusiku","Swo","Vhi","Ṋa","Ṱan","Swondaha","Musumbuluwo","Ḽavhuvhili","Ḽavhuraru","Ḽavhuṋa","Ḽavhuṱanu","Mugivhela","E, dd","dd MMM, y G","E, dd-M","E, dd MMM","dd-M","E, dd-M-y","'tháng' MM, y","MMMM 'năm' y","EEEE, 'ngày' dd MMMM 'năm' y","'Ngày' dd 'tháng' MM 'năm' y","thg 1","thg 2","thg 3","thg 4","thg 5","thg 6","thg 7","thg 8","thg 9","thg 10","thg 11","thg 12","tháng 1","tháng 2","tháng 3","tháng 4","tháng 5","tháng 6","tháng 7","tháng 8","tháng 9","tháng 10","tháng 11","tháng 12","CN","T2","T3","T4","T5","T6","T7","Th 2","Th 3","Th 4","Th 5","Th 6","Th 7","Chủ Nhật","Thứ Hai","Thứ Ba","Thứ Tư","Thứ Năm","Thứ Sáu","Thứ Bảy","SA","CH","tr. CN","sau CN","Trước R.O.C","y MMMMa 'd'. d'id'","y MMM. d","mäz","prl","gst","ton","janul","febul","mäzil","prilul","mayul","yunul","yulul","gustul","setul","tobul","novul","dekul","su.","mu.","tu.","ve.","dö.","zä.","sudel","mudel","tudel","vedel","dödel","fridel","zädel","posz.","büz.","b. t. kr.","p. t. kr.","Ö","Hor","Brá","Hei","Öig","Her","Wím","Win","Chr","Jenner","Hornig","Märze","Abrille","Meije","Bráčet","Heiwet","Öigšte","Herbštmánet","Wímánet","Wintermánet","Chrištmánet","Män","Ziš","Mit","Fró","Sunntag","Mäntag","Zištag","Mittwuč","Fróntag","Fritag","Samštag","n. Chr","руб","Sabi","Bala","Kubi","Kusa","Kuna","Kuta","Muka","Sabiiti","Owokubili","Owokusatu","Olokuna","Olokutaanu","Olomukaaga","Munkyo","Eigulo","AZ","AF","Kulisto nga azilawo","Kulisto nga affile","o.1","o.2","o.3","o.4","o.5","o.6","o.7","o.8","o.9","o.10","o.11","o.12","pikítíkítie, oólí ú kutúan","siɛyɛ́, oóli ú kándíɛ","ɔnsúmbɔl, oóli ú kátátúɛ","mesiŋ, oóli ú kénie","ensil, oóli ú kátánuɛ","ɔsɔn","efute","pisuyú","imɛŋ i puɔs","imɛŋ i putúk,oóli ú kátíɛ","makandikɛ","pilɔndɔ́","sd","md","mw","et","kl","fl","ss","sɔ́ndiɛ","móndie","muányáŋmóndie","metúkpíápɛ","kúpélimetúkpiapɛ","feléte","séselé","kiɛmɛ́ɛm","kisɛ́ndɛ","+J.C.","katikupíen Yésuse","ékélémkúnupíén n","E דעם dטן","E דעם dטן MMM yG","dטן MMM y G","E, dטן MMM y","dטן MMM y","EEEE, dטן MMMM y","dטן MMMM y","יאַנואַר","פֿעברואַר","מערץ","אַפּריל","מיי","אויגוסט","סעפּטעמבער","אקטאבער","נאוועמבער","דעצעמבער","זונטיק","מאָנטיק","דינסטיק","מיטוואך","דאנערשטיק","פֿרײַטיק","פארמיטאג","נאכמיטאג","תש","חש","כס","טב","שב","אא","אד","ני","אי","סי","תמ","אל","א2","חשוון","Shɛ́rɛ́","Èrèlè","Ɛrɛ̀nà","Ìgbé","Ɛ̀bibi","Òkúdu","Agɛmɔ","Ògún","Owewe","Ɔ̀wàrà","Bélú","Ɔ̀pɛ̀","Oshù Shɛ́rɛ́","Oshù Èrèlè","Oshù Ɛrɛ̀nà","Oshù Ìgbé","Oshù Ɛ̀bibi","Oshù Òkúdu","Oshù Agɛmɔ","Oshù Ògún","Oshù Owewe","Oshù Ɔ̀wàrà","Oshù Bélú","Oshù Ɔ̀pɛ̀","Àìkú","Ajé","Ìsɛ́gun","Ɔjɔ́rú","Ɔjɔ́bɔ","Ɛtì","Àbámɛ́ta","Ɔjɔ́ Àìkú","Ɔjɔ́ Ajé","Ɔjɔ́ Ìsɛ́gun","Ɔjɔ́ Ɛtì","Ɔjɔ́ Àbámɛ́ta","Àárɔ̀","Ɔ̀sán","Saju Kristi","Lehin Kristi","Ṣẹ́rẹ́","Ẹrẹ̀nà","Ẹ̀bibi","Agẹmọ","Ọ̀wàrà","Ọ̀pẹ̀","Oṣù Ṣẹ́rẹ́","Oṣù Èrèlè","Oṣù Ẹrẹ̀nà","Oṣù Ìgbé","Oṣù Ẹ̀bibi","Oṣù Òkúdu","Oṣù Agẹmọ","Oṣù Ògún","Oṣù Owewe","Oṣù Ọ̀wàrà","Oṣù Bélú","Oṣù Ọ̀pẹ̀","Ìsẹ́gun","Ọjọ́rú","Ọjọ́bọ","Ẹtì","Àbámẹ́ta","Ọjọ́ Àìkú","Ọjọ́ Ajé","Ọjọ́ Ìsẹ́gun","Ọjọ́ Ẹtì","Ọjọ́ Àbámẹ́ta","Àárọ̀","Ọ̀sán","ⴰⵙⵉⵎⵡⴰⵙ","EHH:mm","EHH:mm:ss","d日E","Eah:mm","Eah:mm:ss","Gy年M月d日E","H时","M/dE","M月d日E","M月dd日","ah时","ah:mm","ah:mm:ss","y/M/dE","y年M月d日E","y年第Q季度","zzzzah:mm:ss","zah:mm:ss","一月","一","周日","周一","周二","周三","周四","周五","周六","星期日","星期一","星期二","星期三","星期四","星期五","星期六","佛历","上午","下午","冬","腊","冬月","腊月","13月","十三月","公元前","公元","闰7月","闰七月","希伯来历","印度历","回历","大化 (645–650)","白雉 (650–671)","白凤 (672–686)","朱鸟 (686–701)","大宝 (701–704)","庆云 (704–708)","和铜 (708–715)","灵龟 (715–717)","养老 (717–724)","神龟 (724–729)","天平 (729–749)","天平感宝 (749–749)","天平胜宝 (749–757)","天平宝字 (757–765)","天平神护 (765–767)","神护景云 (767–770)","宝龟 (770–780)","天应 (781–782)","延历 (782–806)","大同 (806–810)","弘仁 (810–824)","天长 (824–834)","承和 (834–848)","嘉祥 (848–851)","仁寿 (851–854)","齐衡 (854–857)","天安 (857–859)","贞观 (859–877)","元庆 (877–885)","仁和 (885–889)","宽平 (889–898)","昌泰 (898–901)","延喜 (901–923)","延长 (923–931)","承平 (931–938)","天庆 (938–947)","天历 (947–957)","天德 (957–961)","应和 (961–964)","康保 (964–968)","安和 (968–970)","天禄 (970–973)","天延 (973–976)","贞元 (976–978)","天元 (978–983)","永观 (983–985)","宽和 (985–987)","永延 (987–989)","永祚 (989–990)","正历 (990–995)","长德 (995–999)","长保 (999–1004)","宽弘 (1004–1012)","长和 (1012–1017)","宽仁 (1017–1021)","治安 (1021–1024)","万寿 (1024–1028)","长元 (1028–1037)","长历 (1037–1040)","长久 (1040–1044)","宽德 (1044–1046)","永承 (1046–1053)","天喜 (1053–1058)","康平 (1058–1065)","治历 (1065–1069)","延久 (1069–1074)","承保 (1074–1077)","正历 (1077–1081)","永保 (1081–1084)","应德 (1084–1087)","宽治 (1087–1094)","嘉保 (1094–1096)","永长 (1096–1097)","承德 (1097–1099)","康和 (1099–1104)","长治 (1104–1106)","嘉承 (1106–1108)","天仁 (1108–1110)","天永 (1110–1113)","永久 (1113–1118)","元永 (1118–1120)","保安 (1120–1124)","天治 (1124–1126)","大治 (1126–1131)","天承 (1131–1132)","长承 (1132–1135)","保延 (1135–1141)","永治 (1141–1142)","康治 (1142–1144)","天养 (1144–1145)","久安 (1145–1151)","仁平 (1151–1154)","久寿 (1154–1156)","保元 (1156–1159)","平治 (1159–1160)","永历 (1160–1161)","应保 (1161–1163)","长宽 (1163–1165)","永万 (1165–1166)","仁安 (1166–1169)","嘉应 (1169–1171)","承安 (1171–1175)","安元 (1175–1177)","治承 (1177–1181)","养和 (1181–1182)","寿永 (1182–1184)","元历 (1184–1185)","文治 (1185–1190)","建久 (1190–1199)","正治 (1199–1201)","建仁 (1201–1204)","元久 (1204–1206)","建永 (1206–1207)","承元 (1207–1211)","建历 (1211–1213)","建保 (1213–1219)","承久 (1219–1222)","贞应 (1222–1224)","元仁 (1224–1225)","嘉禄 (1225–1227)","安贞 (1227–1229)","宽喜 (1229–1232)","贞永 (1232–1233)","天福 (1233–1234)","文历 (1234–1235)","嘉祯 (1235–1238)","历仁 (1238–1239)","延应 (1239–1240)","仁治 (1240–1243)","宽元 (1243–1247)","宝治 (1247–1249)","建长 (1249–1256)","康元 (1256–1257)","正嘉 (1257–1259)","正元 (1259–1260)","文应 (1260–1261)","弘长 (1261–1264)","文永 (1264–1275)","建治 (1275–1278)","弘安 (1278–1288)","正应 (1288–1293)","永仁 (1293–1299)","正安 (1299–1302)","干元 (1302–1303)","嘉元 (1303–1306)","德治 (1306–1308)","延庆 (1308–1311)","应长 (1311–1312)","正和 (1312–1317)","文保 (1317–1319)","元应 (1319–1321)","元亨 (1321–1324)","正中 (1324–1326)","嘉历 (1326–1329)","元德 (1329–1331)","元弘 (1331–1334)","建武 (1334–1336)","延元 (1336–1340)","兴国 (1340–1346)","正平 (1346–1370)","建德 (1370–1372)","文中 (1372–1375)","天授 (1375–1379)","康历 (1379–1381)","弘和 (1381–1384)","元中 (1384–1392)","至德 (1384–1387)","嘉庆 (1387–1389)","康应 (1389–1390)","明德 (1390–1394)","应永 (1394–1428)","正长 (1428–1429)","永享 (1429–1441)","嘉吉 (1441–1444)","文安 (1444–1449)","宝德 (1449–1452)","享德 (1452–1455)","康正 (1455–1457)","长禄 (1457–1460)","宽正 (1460–1466)","文正 (1466–1467)","应仁 (1467–1469)","文明 (1469–1487)","长享 (1487–1489)","延德 (1489–1492)","明应 (1492–1501)","文龟 (1501–1504)","永正 (1504–1521)","大永 (1521–1528)","享禄 (1528–1532)","天文 (1532–1555)","弘治 (1555–1558)","永禄 (1558–1570)","元龟 (1570–1573)","天正 (1573–1592)","文禄 (1592–1596)","庆长 (1596–1615)","元和 (1615–1624)","宽永 (1624–1644)","正保 (1644–1648)","庆安 (1648–1652)","承应 (1652–1655)","明历 (1655–1658)","万治 (1658–1661)","宽文 (1661–1673)","延宝 (1673–1681)","天和 (1681–1684)","贞享 (1684–1688)","元禄 (1688–1704)","宝永 (1704–1711)","正德 (1711–1716)","享保 (1716–1736)","元文 (1736–1741)","宽保 (1741–1744)","延享 (1744–1748)","宽延 (1748–1751)","宝历 (1751–1764)","明和 (1764–1772)","安永 (1772–1781)","天明 (1781–1789)","宽政 (1789–1801)","享和 (1801–1804)","文化 (1804–1818)","文政 (1818–1830)","天保 (1830–1844)","弘化 (1844–1848)","嘉永 (1848–1854)","安政 (1854–1860)","万延 (1860–1861)","文久 (1861–1864)","元治 (1864–1865)","庆应 (1865–1868)","波斯历","ILS","d/M/y（E）","M-dE","y年M月d日，E","ahh:mm:ssz","ahh:mm","E ah:mm","E ah:mm:ss","ah時","y年QQQ","y年QQQQ","ah:mm:ss [zzzz]","ah:mm:ss [z]","週日","週一","週二","週三","週四","週五","週六","佛曆","西元前","西元","提斯利月","瑪西班月","基斯流月","提別月","細罷特月","亞達月 I","亞達月","尼散月","以珥月","西彎月","搭模斯月","埃波月","以祿月","亞達月 II","創世紀元","制檀邏月","吠舍佉月","逝瑟吒月","頞沙荼月","室羅伐拏月","婆羅鉢陀月","頞涇縛庚闍月","迦剌底迦月","末伽始羅月","報沙月","磨祛月","頗勒窶拏月","印度曆","穆哈蘭姆月","色法爾月","賴比月 I","賴比月 II","主馬達月 I","主馬達月 II","賴哲卜月","舍爾邦月","賴買丹月","閃瓦魯月","都爾喀爾德月","都爾黑哲月","伊斯蘭曆","白鳳","大寶","靈龜","神龜","天平感寶","天平勝寶","天平寶字","寶龜","天應","延曆","仁壽","齊衡","貞觀","寬平","天曆","天德","應和","天祿","永觀","寬和","正曆","長德","寬弘","寬仁","萬壽","長曆","寬德","治曆","承曆","應德","寬治","承德","久壽","永曆","應保","長寬","永萬","嘉應","壽永","元曆","建曆","貞應","嘉祿","寬喜","文曆","曆仁","延應","寬元","寶治","文應","正應","德治","應長","元應","嘉曆","元德","興國","建德","康曆","至德","康應","明德","應永","寶德","享德","長祿","寬正","應仁","延德","明應","文龜","享祿","永祿","元龜","文祿","寬永","承應","明曆","萬治","寬文","延寶","元祿","寶永","正德","寬保","寬延","寶曆","寬政","萬延","慶應","波斯曆","民國前","民國","非數值","y年MM月dd日EEEE","y年MM月dd日","yy年M月d日","d日（E）","Gy年M月d日 E","M/d（E）","M月d日 E","y/M/d（E）","y年M月d日 E","y年M月d日 EEEE","臘","臘月","Mas","Aga","Januwari","Februwari","Mashi","Apreli","Septhemba","Okthoba","Msombuluko","Lwesibili","Lwesithathu","Lwesine","Lwesihlanu","Ekuseni","Ntambama","I-NaN"],b=[];b[0]=[[a[0],a[1],a[2],a[3],a[4],a[5],a[6],a[7],a[8],a[9],a[10],a[11],a[12],a[13],a[14]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMd":a[33],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[43],"yMMMEd":a[44],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[49],"long":a[50],"medium":a[51],"short":a[52]},{"full":a[53],"long":a[54],"medium":a[38],"short":a[37]},[a[55],a[56],a[57],a[58],a[57],a[55],a[55],a[29],a[59],a[60],a[61],a[62]],[a[63],a[64],a[65],a[66],a[67],a[68],a[69],a[70],a[71],a[72],a[73],a[74]],[a[75],a[76],a[77],a[78],a[79],a[80],a[81],a[82],a[83],a[84],a[85],a[86]],[a[58],a[87],a[88],a[58],a[62],a[89],a[90]],[a[91],a[92],a[93],a[94],a[95],a[96],a[97]],[a[98],a[99],a[100],a[101],a[102],a[103],a[104]],[a[105]],{"am":a[106],"pm":a[107]},[a[108],a[109],a[110],a[111],a[112],a[113],a[114],a[115],a[116],a[117],a[118],a[119]],[a[120],a[121],a[122],a[123],a[124],a[125],a[126],a[127],a[128],a[129],a[130],a[131]],[a[108],a[109],a[110],a[111],a[112],a[113],a[114],a[115],a[116],a[117],a[118],a[119],a[132]],[a[133],a[134],a[135],a[136],a[137],a[138],a[139],a[140],a[141],a[142],a[143],a[144],a[145]],[a[146],a[147]],[a[148],a[149],a[150],a[151],a[152],a[153],a[154],a[155],a[156],a[157],a[158],a[159],a[160]],[a[146]],[a[161],a[162],a[163],a[164]],[a[108],a[109],a[110],a[111],a[112],a[113],a[114],a[115],a[116],a[117],a[118],a[119],a[132],a[114]],[a[165],a[166],a[167],a[168],a[169],a[170],a[171],a[172],a[173],a[174],a[175],a[176],a[177],a[178]],[a[179]],[a[180],a[181],a[182],a[183],a[184],a[185],a[186],a[187],a[188],a[189],a[190],a[191]],[a[192]],[a[193],a[194],a[195],a[196],a[197],a[198],a[199],a[200],a[201],a[202],a[203],a[204]],[a[205],a[206],a[207],a[208],a[209],a[210],a[211],a[212],a[213],a[214],a[215],a[216]],[a[217]],[a[218],a[219],a[220],a[221],a[222],a[223],a[224],a[225],a[226],a[227],a[228],a[229],a[230],a[231],a[232],a[233],a[234],a[235],a[236],a[237],a[238],a[239],a[240],a[241],a[242],a[243],a[244],a[245],a[246],a[247],a[248],a[249],a[250],a[251],a[252],a[253],a[254],a[255],a[256],a[257],a[258],a[259],a[260],a[261],a[262],a[263],a[264],a[265],a[266],a[267],a[268],a[269],a[270],a[271],a[272],a[273],a[274],a[275],a[276],a[277],a[278],a[279],a[280],a[281],a[282],a[283],a[284],a[285],a[286],a[287],a[288],a[289],a[290],a[291],a[292],a[293],a[294],a[295],a[296],a[297],a[298],a[299],a[300],a[301],a[302],a[303],a[304],a[305],a[306],a[307],a[308],a[309],a[310],a[311],a[312],a[313],a[314],a[315],a[316],a[317],a[318],a[319],a[320],a[321],a[322],a[323],a[324],a[325],a[326],a[327],a[328],a[329],a[330],a[331],a[332],a[333],a[334],a[335],a[336],a[337],a[338],a[339],a[340],a[341],a[342],a[343],a[344],a[345],a[346],a[347],a[348],a[349],a[350],a[351],a[352],a[353],a[354],a[355],a[356],a[357],a[358],a[359],a[360],a[361],a[362],a[363],a[364],a[365],a[366],a[367],a[368],a[369],a[370],a[371],a[372],a[373],a[374],a[375],a[376],a[377],a[378],a[379],a[380],a[381],a[382],a[383],a[384],a[385],a[386],a[387],a[388],a[389],a[390],a[391],a[392],a[393],a[394],a[395],a[396],a[397],a[398],a[399],a[400],a[401],a[402],a[403],a[404],a[405],a[406],a[407],a[408],a[409],a[410],a[411],a[412],a[413],a[414],a[415],a[416],a[417],a[418],a[419],a[420],a[421],a[422],a[423],a[424],a[425],a[426],a[427],a[428],a[429],a[430],a[431],a[432],a[433],a[434],a[435],a[436],a[437],a[438],a[439],a[440],a[441],a[442],a[443],a[444],a[445],a[446],a[447],a[448],a[449],a[450],a[88],a[90],a[451]],[a[218],a[219],a[220],a[221],a[222],a[223],a[224],a[225],a[226],a[227],a[228],a[229],a[230],a[231],a[232],a[233],a[234],a[235],a[236],a[237],a[238],a[239],a[240],a[241],a[242],a[243],a[244],a[245],a[246],a[247],a[248],a[249],a[250],a[251],a[252],a[253],a[254],a[255],a[256],a[257],a[258],a[259],a[260],a[261],a[262],a[263],a[264],a[265],a[266],a[267],a[268],a[269],a[270],a[271],a[272],a[273],a[274],a[275],a[276],a[277],a[278],a[279],a[280],a[281],a[282],a[283],a[284],a[285],a[286],a[287],a[288],a[289],a[290],a[291],a[292],a[293],a[294],a[295],a[296],a[297],a[298],a[299],a[300],a[301],a[302],a[303],a[304],a[305],a[306],a[307],a[308],a[309],a[310],a[311],a[312],a[313],a[314],a[315],a[316],a[317],a[318],a[319],a[320],a[321],a[322],a[323],a[324],a[325],a[326],a[327],a[328],a[329],a[330],a[331],a[332],a[333],a[334],a[335],a[336],a[337],a[338],a[339],a[340],a[341],a[342],a[343],a[344],a[345],a[346],a[347],a[348],a[349],a[350],a[351],a[352],a[353],a[354],a[355],a[356],a[357],a[358],a[359],a[360],a[361],a[362],a[363],a[364],a[365],a[366],a[367],a[368],a[369],a[370],a[371],a[372],a[373],a[374],a[375],a[376],a[377],a[378],a[452],a[380],a[381],a[382],a[453],a[384],a[385],a[386],a[387],a[388],a[389],a[390],a[391],a[392],a[393],a[394],a[395],a[396],a[397],a[398],a[399],a[400],a[401],a[402],a[403],a[404],a[405],a[406],a[407],a[408],a[409],a[410],a[411],a[412],a[413],a[414],a[415],a[416],a[417],a[418],a[419],a[420],a[421],a[422],a[423],a[424],a[425],a[426],a[427],a[428],a[429],a[430],a[431],a[432],a[433],a[434],a[435],a[436],a[437],a[438],a[439],a[440],a[441],a[442],a[443],a[444],a[445],a[446],a[447],a[448],a[449],a[454],a[455],a[456],a[457]],[a[458],a[459],a[460],a[461],a[462],a[463],a[464],a[465],a[466],a[467],a[468],a[469]],[a[470]],[a[471],a[472]],[a[473]],{"positivePattern":a[474],"negativePattern":a[475]},{"positivePattern":a[476],"negativePattern":a[477]},{"positivePattern":a[478],"negativePattern":a[479]},{"decimal":a[480],"group":a[481],"nan":a[482],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"DJF":a[489],"ETB":a[490],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[75],a[76],a[77],a[78],a[79],a[80],a[81],a[507],a[83],a[84],a[85],a[86]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"ERN":a[508],"ETB":a[490],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"ETB":a[490],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[510],"Ehms":a[511],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[514],"GyMMMd":a[515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[519],"MMMMdd":a[520],"MMMd":a[519],"Md":a[521],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[522],"yMEd":a[523],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[527],"short":a[46]},{"full":a[532],"long":a[533],"medium":a[28],"short":a[27]},[a[534],a[535],a[450],a[58],a[450],a[534],a[534],a[58],a[90],a[536],a[56],a[60]],[a[537],a[538],a[539],a[540],a[541],a[542],a[543],a[544],a[545],a[546],a[547],a[548]],[a[549],a[550],a[551],a[552],a[541],a[553],a[554],a[555],a[556],a[557],a[558],a[559]],[a[90],a[450],a[60],a[59],a[60],a[560],a[90]],[a[561],a[562],a[563],a[564],a[565],a[566],a[567]],[a[568],a[569],a[570],a[571],a[572],a[573],a[574]],{"am":a[575],"pm":a[576]},[a[577],a[578],a[579],a[580]],[a[577],a[578],a[581],a[582]],[a[583],a[584],a[581],a[582]],{"positivePattern":a[585],"negativePattern":a[586]},{"decimal":a[481],"group":a[587],"nan":a[482],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"NAD":a[588],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"ZAR":a[590]},{"full":a[591],"long":a[50],"medium":a[592],"short":a[46]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"ZAR":a[590]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[40],"yM":a[597],"yMEd":a[598],"yMMM":a[524],"yMMMEd":a[599],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[601],"short":a[600]},[a[602],a[603],a[604],a[604],a[605],a[606],a[603],a[607],a[35],a[608],a[609],a[607]],[a[610],a[611],a[612],a[613],a[614],a[615],a[616],a[617],a[618],a[619],a[620],a[621]],[a[622],a[623],a[624],a[625],a[626],a[627],a[628],a[629],a[630],a[631],a[632],a[633]],[a[602],a[603],a[634],a[604],a[635],a[634],a[35]],[a[636],a[637],a[638],a[639],a[640],a[641],a[642]],[a[643],a[644],a[645],a[646],a[647],a[648],a[649]],{"am":a[650],"pm":a[651]},[a[652],a[653],a[163],a[164]],[a[654],a[655],a[163],a[164]],{"positivePattern":a[656],"negativePattern":a[657]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMMEd":a[660],"MMMMd":a[661],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[663],"yMMM":a[524],"yMMMEd":a[664],"yMMMM":a[526],"yMMMd":a[45],"yMd":a[665],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[666],"long":a[667],"medium":a[45],"short":a[668]},[a[669],a[670],a[671],a[672],a[673],a[674],a[675],a[676],a[677],a[678],a[679],a[680]],[a[681],a[682],a[683],a[684],a[685],a[686],a[687],a[688],a[689],a[690],a[691],a[692]],[a[62],a[60],a[693],a[59],a[694],a[535],a[450]],[a[695],a[696],a[697],a[698],a[699],a[700],a[701]],[a[702],a[703],a[704],a[705],a[706],a[707],a[708]],{"am":a[709],"pm":a[710]},[a[711],a[712],a[163],a[164]],[a[713],a[714],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"GHS":a[715],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[716],"GyMMMd":a[717],"H":a[451],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMMEd":a[660],"MMMMd":a[661],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[718],"yMMM":a[524],"yMMMEd":a[719],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[531],"medium":a[527],"short":a[721]},[a[722],a[723],a[724],a[725],a[726],a[727],a[727],a[728],a[729],a[728],a[730],a[731]],[a[732],a[733],a[734],a[735],a[736],a[737],a[738],a[739],a[740],a[741],a[742],a[743]],[a[744],a[745],a[734],a[746],a[736],a[737],a[738],a[747],a[748],a[749],a[750],a[751]],[a[752],a[753],a[724],a[754],a[755],a[756],a[757]],[a[758],a[759],a[760],a[761],a[762],a[763],a[764]],[a[758],a[759],a[765],a[761],a[762],a[763],a[764]],{"am":a[766],"pm":a[767]},[a[768],a[769]],[a[770],a[771],a[772],a[773],a[774],a[775],a[776],a[777],a[778],a[779],a[780],a[781],a[782]],[a[783],a[784],a[772],a[785],a[774],a[786],a[787],a[788],a[789],a[779],a[780],a[781],a[790]],[a[768],a[769],a[163],a[164]],[a[791],a[792],a[163],a[164]],[a[793],a[794],a[795],a[796],a[797],a[798],a[799],a[800],a[801],a[802],a[803],a[804]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"ETB":a[806],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[807],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[808],"GyMMMd":a[809],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[810],"MMM":a[31],"MMMEd":a[811],"MMMMEd":a[812],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[814],"Md":a[815],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[816],"yMEd":a[817],"yMM":a[818],"yMMM":a[524],"yMMMEd":a[819],"yMMMM":a[526],"yMMMd":a[820],"yMd":a[821],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[822],"long":a[823],"medium":a[824],"short":a[821]},[a[825],a[826],a[827],a[828],a[829],a[830],a[831],a[832],a[833],a[834],a[835],a[836]],[a[837],a[838],a[839],a[840],a[841],a[842],a[843],a[844],a[845],a[846],a[847],a[848]],[a[849],a[830],a[850],a[851],a[852],a[853],a[833]],[a[854],a[855],a[856],a[857],a[858],a[859],a[860]],[a[861]],{"am":a[862],"pm":a[827]},[a[863],a[864],a[865],a[866],a[867],a[868],a[869],a[870],a[871],a[872],a[873],a[874],a[875]],[a[876],a[877],a[878],a[879],a[880],a[881],a[882],a[883],a[884],a[885],a[886],a[887],a[888]],[a[889],a[827],a[163],a[890]],[a[891],a[892],a[163],a[893]],[a[894],a[895],a[896],a[897],a[898],a[899],a[900],a[901],a[902],a[903],a[904],a[905],a[906],a[907]],[a[862]],[a[908],a[909],a[910],a[911],a[912],a[913],a[914],a[915],a[916],a[917],a[918],a[919]],[a[920],a[921],a[922],a[923],a[924],a[925],a[926],a[927],a[928],a[929],a[930],a[931]],[a[932]],[a[933],a[934],a[935],a[936],a[937],a[938],a[939],a[940],a[941],a[942],a[943],a[944],a[945],a[946],a[947],a[948],a[949],a[950],a[951],a[952],a[953],a[954],a[955],a[956],a[957],a[958],a[959],a[960],a[961],a[962],a[963],a[964],a[965],a[966],a[967],a[968],a[969],a[970],a[971],a[972],a[973],a[974],a[975],a[976],a[977],a[978],a[979],a[980],a[981],a[982],a[983],a[984],a[985],a[986],a[987],a[988],a[989],a[990],a[991],a[992],a[993],a[994],a[995],a[996],a[997],a[998],a[999],a[1000],a[1001],a[1002],a[1003],a[1004],a[1005],a[1006],a[1007],a[1008],a[1009],a[1010],a[1011],a[1012],a[1013],a[1014],a[1015],a[1016],a[1017],a[1018],a[1019],a[1020],a[1021],a[1022],a[1023],a[1024],a[1025],a[1026],a[1027],a[1028],a[1029],a[1030],a[1031],a[1032],a[1033],a[1034],a[1035],a[1036],a[1037],a[1038],a[1039],a[1040],a[1041],a[1042],a[1043],a[1044],a[1045],a[1046],a[1047],a[1048],a[1049],a[1050],a[1051],a[1052],a[1053],a[1054],a[1055],a[1056],a[1057],a[1058],a[1059],a[1060],a[1061],a[1062],a[1063],a[1064],a[1065],a[1066],a[1067],a[1068],a[1069],a[1070],a[1071],a[1072],a[1073],a[1074],a[1075],a[1076],a[1077],a[1078],a[1079],a[1080],a[1081],a[1082],a[1083],a[1084],a[1085],a[1086],a[1087],a[1088],a[1089],a[1090],a[1091],a[1092],a[1093],a[1094],a[1095],a[1096],a[1097],a[1098],a[1099],a[1100],a[1101],a[1102],a[1103],a[1104],a[1105],a[1106],a[1107],a[1108],a[1109],a[1110],a[1111],a[1112],a[1113],a[1114],a[1115],a[1116],a[1117],a[1118],a[1119],a[1120],a[1121],a[1122],a[1123],a[1124],a[1125],a[1126],a[1127],a[1128],a[1129],a[1130],a[1131],a[1132],a[1133],a[1134],a[1135],a[1136],a[1137],a[1138],a[1139],a[1140],a[1141],a[1142],a[1143],a[1144],a[1145],a[1146],a[1147],a[1148],a[1149],a[1150],a[1151],a[1152],a[1153],a[1154],a[1155],a[1156],a[1157],a[1158],a[1159],a[1160],a[1161],a[1162],a[1163],a[1164],a[1165],a[1166],a[1167],a[1168]],[a[1169],a[1170],a[1171],a[1172],a[1173],a[1174],a[1175],a[1176],a[1177],a[1178],a[1179],a[1180]],[a[1181]],[a[471],a[1182]],[a[1183],a[473]],{"decimal":a[1184],"group":a[1185],"nan":a[1186],"percent":a[1187],"infinity":a[484]},{"AED":a[1188],"AUD":a[805],"BHD":a[1189],"BRL":a[486],"CAD":a[487],"CNY":a[1190],"DZD":a[1191],"EGP":a[1192],"EUR":a[491],"GBP":a[492],"HKD":a[493],"IDR":a[1193],"ILS":a[494],"INR":a[1194],"IQD":a[1195],"IRR":a[1196],"JOD":a[1197],"JPY":a[496],"KMF":a[1198],"KRW":a[497],"KWD":a[1199],"LBP":a[1200],"LYD":a[1201],"MAD":a[1202],"MRO":a[1203],"MXN":a[498],"NZD":a[499],"OMR":a[1204],"PKR":a[1205],"QAR":a[1206],"SAR":a[1207],"SDD":a[1208],"SDG":a[1209],"SSP":a[1210],"SYP":a[1211],"THB":a[589],"TND":a[1212],"TRY":a[1213],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[1214],"YER":a[1215]},[a[889],a[827],a[889],a[890]],[a[891],a[892],a[891],a[893]],{"AED":a[1188],"AUD":a[805],"BHD":a[1189],"BRL":a[486],"CAD":a[487],"CNY":a[1190],"DJF":a[489],"DZD":a[1191],"EGP":a[1192],"EUR":a[491],"GBP":a[492],"HKD":a[493],"IDR":a[1193],"ILS":a[494],"INR":a[1194],"IQD":a[1195],"IRR":a[1196],"JOD":a[1197],"JPY":a[496],"KMF":a[1198],"KRW":a[497],"KWD":a[1199],"LBP":a[1200],"LYD":a[1201],"MAD":a[1202],"MRO":a[1203],"MXN":a[498],"NZD":a[499],"OMR":a[1204],"PKR":a[1205],"QAR":a[1206],"SAR":a[1207],"SDD":a[1208],"SDG":a[1209],"SSP":a[1210],"SYP":a[1211],"THB":a[589],"TND":a[1212],"TRY":a[1213],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[1214],"YER":a[1215]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[807],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[808],"GyMMMd":a[809],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[810],"MMM":a[31],"MMMEd":a[811],"MMMMEd":a[812],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1216],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1217],"yMEd":a[817],"yMM":a[1218],"yMMM":a[524],"yMMMEd":a[819],"yMMMM":a[526],"yMMMd":a[820],"yMd":a[665],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[822],"long":a[823],"medium":a[1219],"short":a[665]},[a[853],a[826],a[827],a[828],a[827],a[853],a[853],a[828],a[833],a[828],a[830],a[836]],[a[1220],a[1221],a[839],a[1222],a[1223],a[1224],a[1225],a[1226],a[845],a[846],a[847],a[848]],{"decimal":a[481],"group":a[480],"nan":a[482],"percent":a[483],"infinity":a[484]},{"decimal":a[1184],"group":a[1185],"nan":a[482],"percent":a[1187],"infinity":a[484]},{"AED":a[1188],"AUD":a[805],"BHD":a[1189],"BRL":a[486],"CAD":a[487],"CNY":a[1190],"DZD":a[1191],"EGP":a[1192],"ERN":a[508],"EUR":a[491],"GBP":a[492],"HKD":a[493],"IDR":a[1193],"ILS":a[494],"INR":a[1194],"IQD":a[1195],"IRR":a[1196],"JOD":a[1197],"JPY":a[496],"KMF":a[1198],"KRW":a[497],"KWD":a[1199],"LBP":a[1200],"LYD":a[1201],"MAD":a[1202],"MRO":a[1203],"MXN":a[498],"NZD":a[499],"OMR":a[1204],"PKR":a[1205],"QAR":a[1206],"SAR":a[1207],"SDD":a[1208],"SDG":a[1209],"SSP":a[1210],"SYP":a[1211],"THB":a[589],"TND":a[1212],"TRY":a[1213],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[1214],"YER":a[1215]},[a[834],a[1227],a[1228],a[830],a[828],a[849],a[1229],a[1228],a[828],a[1229],a[1229],a[834]],[a[1230],a[898],a[900],a[901],a[902],a[1231],a[904],a[905],a[906],a[1232],a[1233],a[1234]],[a[1230],a[898],a[900],a[901],a[902],a[1231],a[904],a[905],a[906],a[1235],a[1233],a[1234]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[807],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1236],"GyMMMd":a[809],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[810],"MMM":a[31],"MMMEd":a[811],"MMMMEd":a[812],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[814],"Md":a[815],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[816],"yMEd":a[817],"yMM":a[818],"yMMM":a[524],"yMMMEd":a[819],"yMMMM":a[526],"yMMMd":a[820],"yMd":a[821],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[822],"long":a[823],"medium":a[1237],"short":a[821]},{"AED":a[1188],"AUD":a[805],"BHD":a[1189],"BRL":a[486],"CAD":a[487],"CNY":a[1190],"DZD":a[1191],"EGP":a[1192],"EUR":a[491],"GBP":a[492],"HKD":a[493],"IDR":a[1193],"ILS":a[494],"INR":a[1194],"IQD":a[1195],"IRR":a[1196],"JOD":a[1197],"JPY":a[496],"KMF":a[1198],"KRW":a[497],"KWD":a[1199],"LBP":a[1200],"LYD":a[1201],"MAD":a[1202],"MRO":a[1203],"MXN":a[498],"NZD":a[499],"OMR":a[1204],"PKR":a[1205],"QAR":a[1206],"SAR":a[1207],"SDD":a[1208],"SSP":a[1210],"SYP":a[1211],"THB":a[589],"TND":a[1212],"TRY":a[1213],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[1214],"YER":a[1215]},[a[825],a[826],a[827],a[828],a[827],a[830],a[831],a[832],a[1227],a[834],a[835],a[836]],[a[837],a[838],a[839],a[840],a[1223],a[842],a[1238],a[1239],a[1240],a[846],a[1241],a[1242]],[a[825],a[826],a[827],a[1243],a[829],a[830],a[831],a[832],a[1227],a[834],a[835],a[836]],[a[837],a[838],a[839],a[1244],a[841],a[842],a[843],a[1245],a[1246],a[846],a[847],a[1247]],{"AED":a[1188],"AUD":a[805],"BHD":a[1189],"BRL":a[486],"CAD":a[487],"CNY":a[1190],"DZD":a[1191],"EGP":a[1192],"EUR":a[491],"GBP":a[492],"HKD":a[493],"IDR":a[1193],"ILS":a[494],"INR":a[1194],"IQD":a[1195],"IRR":a[1196],"JOD":a[1197],"JPY":a[496],"KMF":a[1198],"KRW":a[497],"KWD":a[1199],"LBP":a[1200],"LYD":a[1201],"MAD":a[1202],"MRO":a[1203],"MXN":a[498],"NZD":a[499],"OMR":a[1204],"PKR":a[1205],"QAR":a[1206],"SAR":a[1207],"SDD":a[1208],"SDG":a[1209],"SOS":a[90],"SSP":a[1210],"SYP":a[1211],"THB":a[589],"TND":a[1212],"TRY":a[1213],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[1214],"YER":a[1215]},{"AED":a[1188],"AUD":a[805],"BHD":a[1189],"BRL":a[486],"CAD":a[487],"CNY":a[1190],"DZD":a[1191],"EGP":a[1192],"EUR":a[491],"GBP":a[1248],"HKD":a[493],"IDR":a[1193],"ILS":a[494],"INR":a[1194],"IQD":a[1195],"IRR":a[1196],"JOD":a[1197],"JPY":a[496],"KMF":a[1198],"KRW":a[497],"KWD":a[1199],"LBP":a[1200],"LYD":a[1201],"MAD":a[1202],"MRO":a[1203],"MXN":a[498],"NZD":a[499],"OMR":a[1204],"PKR":a[1205],"QAR":a[1206],"SAR":a[1207],"SDD":a[1208],"SDG":a[1209],"SSP":a[492],"SYP":a[1211],"THB":a[589],"TND":a[1212],"TRY":a[1213],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[1214],"YER":a[1215]},{"full":a[1249],"long":a[1250],"medium":a[1251],"short":a[1252]},{"full":a[1253],"long":a[1254],"medium":a[1255],"short":a[1256]},[a[1257],a[1258],a[1259],a[1260],a[1261],a[1262],a[1263],a[1264],a[1265],a[1266],a[1267],a[1268]],[a[1269],a[1270],a[1259],a[1260],a[1261],a[1262],a[1263],a[1271],a[1272],a[1273],a[1274],a[1275]],[a[90],a[450],a[88],a[59],a[88],a[535],a[90]],[a[1276],a[1277],a[1278],a[1279],a[1280],a[1281],a[1282]],[a[1283],a[1284],a[1285],a[1286],a[1287],a[1288],a[1289]],{"am":a[1290],"pm":a[1291]},[a[163],a[164],a[163],a[164]],[a[1292],a[473]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMMEd":a[660],"MMMMd":a[661],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[663],"yMMM":a[524],"yMMMEd":a[664],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},[a[1293],a[1294],a[1295],a[540],a[541],a[542],a[543],a[1296],a[545],a[546],a[547],a[1297]],[a[1298],a[1299],a[1300],a[1301],a[541],a[1302],a[1303],a[1304],a[1305],a[1306],a[1307],a[1308]],[a[534],a[534],a[534],a[534],a[58],a[1309],a[534]],[a[1310],a[1311],a[1312],a[1313],a[1314],a[1315],a[1316]],[a[1317],a[1318],a[1319],a[1320],a[1321],a[1322],a[1323]],{"am":a[1324],"pm":a[1325]},[a[1326],a[1327],a[163],a[164]],[a[1328],a[1329],a[163],a[164]],{"positivePattern":a[1330],"negativePattern":a[1331]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"TZS":a[1332],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[525],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[1335],"long":a[1336],"medium":a[527],"short":a[1337]},[a[61],a[535],a[450],a[58],a[450],a[61],a[61],a[58],a[90],a[536],a[1338],a[58]],[a[1339],a[1340],a[1341],a[1342],a[1343],a[1344],a[1345],a[1346],a[1347],a[1348],a[1349],a[1350]],[a[1351],a[1352],a[1353],a[1354],a[1355],a[1356],a[1357],a[1358],a[1359],a[1360],a[1361],a[1362]],[a[60],a[29],a[450],a[450],a[61],a[560],a[90]],[a[1363],a[1364],a[1341],a[1365],a[1366],a[1367],a[1368]],[a[1369],a[1370],a[1371],a[1372],a[1373],a[1374],a[1375]],{"am":a[179],"pm":a[1376]},[a[1377],a[1378],a[1379],a[1380]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1382],"MMM":a[31],"MMMEd":a[1383],"MMMd":a[519],"Md":a[1384],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1385],"yMEd":a[1386],"yMMM":a[1387],"yMMMEd":a[1388],"yMMMd":a[601],"yMd":a[1389],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[1390],"long":a[1250],"medium":a[601],"short":a[1391]},[a[1392],a[1393],a[1394],a[1395],a[1396],a[1397],a[1398],a[1399],a[1400],a[1401],a[1402],a[1403]],[a[114],a[108],a[109],a[110],a[111],a[112],a[113]],[a[1404],a[1405],a[1406],a[1407],a[1408],a[1409],a[1410]],{"AUD":a[485],"AZN":a[1411],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[1412],"GyMMMEd":a[1413],"GyMMMd":a[1414],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1415],"MMM":a[31],"MMMEd":a[1416],"MMMd":a[519],"Md":a[1384],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1385],"yMEd":a[1417],"yMMM":a[524],"yMMMEd":a[1418],"yMMMd":a[527],"yMd":a[1389],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[1419],"long":a[531],"medium":a[527],"short":a[1391]},[a[1420],a[1421],a[1341],a[1422],a[1343],a[1423],a[1424],a[1425],a[1426],a[1427],a[1428],a[1429]],[a[1430],a[1431],a[1432],a[1433],a[1343],a[1434],a[1435],a[1436],a[1437],a[1438],a[1439],a[1440]],[a[1441],a[1442],a[1443],a[1444],a[1445],a[1446],a[1447]],[a[1448],a[1449],a[1450],a[1451],a[1452],a[1453],a[1454]],[a[1455],a[1456],a[1457],a[1458]],[a[1459],a[1460],a[1461],a[1462]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[40],"yM":a[597],"yMEd":a[598],"yMMM":a[524],"yMMMEd":a[599],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},[a[603],a[1463],a[1463],a[1463],a[1463],a[1464],a[602],a[1464],a[35],a[1465],a[1463],a[608]],[a[1466],a[1467],a[1468],a[1469],a[1470],a[1471],a[1472],a[1473],a[1474],a[1475],a[1343],a[1476]],[a[1477],a[1478],a[1479],a[1480],a[1481],a[1482],a[1483],a[1484],a[1485],a[1486],a[1487],a[1488]],[a[602],a[602],a[635],a[1489],a[1463],a[603],a[1490]],[a[1491],a[1492],a[1493],a[1494],a[1495],a[1496],a[1497]],[a[1498],a[1499],a[1500],a[1501],a[1502],a[1503],a[1504]],{"am":a[1505],"pm":a[1506]},[a[1507],a[1508],a[163],a[164]],[a[1509],a[1510],a[163],a[164]],{"positivePattern":a[1511],"negativePattern":a[1512]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[1513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[1516],"Hms":a[1517],"M":a[29],"MEd":a[1518],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"Md":a[1520],"d":a[35],"h":a[36],"hm":a[1521],"hms":a[1255],"ms":a[1522],"y":a[40],"yM":a[1523],"yMEd":a[1524],"yMMM":a[1525],"yMMMEd":a[525],"yMMMM":a[1526],"yMMMd":a[527],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[531],"medium":a[1527],"short":a[1528]},{"full":a[1529],"long":a[1530],"medium":a[1517],"short":a[1516]},[a[1531],a[1532],a[1531],a[1533],a[1534],a[1535],a[1532],a[1536],a[1537],a[1533],a[1532],a[1531]],[a[1538],a[1539],a[1540],a[1541],a[1542],a[1543],a[1544],a[1545],a[1546],a[1547],a[1548],a[1549]],[a[1550],a[1551],a[1552],a[1553],a[1542],a[1554],a[1555],a[1556],a[1557],a[1558],a[1559],a[1560]],[a[1561],a[1562],a[1563],a[1531],a[1535],a[1562],a[1531]],[a[1564],a[1565],a[1566],a[1567],a[1568],a[1569],a[1570]],[a[1571],a[1572],a[1573],a[1574],a[1575],a[1576],a[1577]],{"am":a[1578],"pm":a[1579]},[a[1580],a[1581],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"BYR":a[1582],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"RUB":a[1583],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[534],a[535],a[450],a[87],a[450],a[534],a[534],a[536],a[90],a[536],a[56],a[60]],[a[1293],a[1294],a[1295],a[1584],a[541],a[542],a[543],a[1585],a[545],a[546],a[547],a[1586]],[a[1298],a[1299],a[1300],a[1587],a[541],a[1302],a[1303],a[1588],a[1305],a[1306],a[1307],a[1589]],[a[1590],a[1591],a[1592],a[1593],a[1594],a[1595],a[1596]],{"am":a[1597],"pm":a[1598]},[a[1599],a[1600],a[163],a[164]],[a[1601],a[1602],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"ZMW":a[62]},[a[451],a[560],a[60],a[88],a[451],a[90],a[90],a[56],a[88],a[62],a[62],a[62]],[a[1603],a[1604],a[1605],a[1606],a[1607],a[1608],a[97],a[1609],a[1610],a[1611],a[1612],a[1613]],[a[1614],a[1615],a[1616],a[1617],a[1618],a[1619],a[1620],a[1621],a[1622],a[1623],a[1624],a[1625]],[a[450],a[534],a[451],a[451],a[451],a[59],a[534]],[a[1626],a[1604],a[1627],a[1628],a[1629],a[1630],a[1631]],[a[1632],a[1633],a[1634],a[1635],a[1636],a[1637],a[1638]],{"am":a[1639],"pm":a[1640]},[a[1641],a[1642],a[163],a[164]],{"E":a[16],"EHm":a[1644],"EHms":a[1645],"Ed":a[1646],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[1649],"GyMMM":a[1650],"GyMMMEd":a[1651],"GyMMMM":a[1652],"GyMMMMEd":a[1653],"GyMMMMd":a[1654],"GyMMMd":a[1655],"H":a[451],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[1658],"MMM":a[1659],"MMMEd":a[1658],"MMMM":a[1660],"MMMMEd":a[1519],"MMMMd":a[813],"MMMMdd":a[813],"MMMd":a[1661],"Md":a[1661],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[1662],"yM":a[1663],"yMEd":a[1664],"yMMM":a[1665],"yMMMEd":a[1664],"yMMMM":a[1666],"yMMMMEd":a[1667],"yMMMMd":a[1668],"yMMMd":a[1669],"yMd":a[1669],"yQQQ":a[1670],"yQQQQ":a[1671]},{"full":a[1672],"long":a[1668],"medium":a[1669],"short":a[1673]},{"full":a[1674],"long":a[1675],"medium":a[1657],"short":a[1656]},[a[1676],a[1677],a[1534],a[1563],a[1534],a[1678],a[1678],a[1563],a[1531],a[1679],a[1561],a[1680]],[a[1681],a[1682],a[1394],a[1683],a[1396],a[1684],a[1685],a[1686],a[1687],a[1688],a[1689],a[1690]],[a[1691],a[1692],a[1394],a[1693],a[1396],a[1684],a[1685],a[1399],a[1694],a[1695],a[1696],a[1697]],[a[1561],a[1562],a[1537],a[1531],a[1535],a[1562],a[1531]],[a[1564],a[1565],a[1698],a[1567],a[1699],a[1569],a[1570]],[a[1700],a[1701],a[1702],a[1703],a[1704],a[1705],a[1706]],{"am":a[1707],"pm":a[1708]},[a[1709],a[1710],a[1711],a[1710]],[a[1709],a[1712],a[1711],a[1710]],[a[1713],a[1714],a[1715],a[1716]],[a[1717],a[1718],a[1719],a[1720],a[1721],a[1722],a[1723],a[1724],a[1725],a[1726],a[1727],a[1728],a[1729],a[1730]],[a[1731],a[1732],a[1733],a[1734],a[1735],a[1736],a[1737],a[1738],a[1739],a[1740],a[1741],a[1742]],[a[1743],a[1744],a[1745],a[1746],a[1747],a[1748],a[1749],a[1750],a[1751],a[1752],a[1753],a[1754]],{"BGN":a[1755],"EUR":a[491],"RUB":a[1756],"USD":a[1757],"XAF":a[503],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[450],"MEd":a[30],"MMM":a[1758],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"MMd":a[1759],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[40],"yM":a[597],"yMEd":a[598],"yMM":a[1761],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},[a[1762],a[535],a[450],a[58],a[450],a[1762],a[1762],a[1763],a[90],a[1764],a[56],a[60]],[a[1765],a[1340],a[1341],a[1766],a[1767],a[1768],a[1769],a[1770],a[1771],a[1772],a[1773],a[1774]],[a[1775],a[1776],a[1777],a[1778],a[1767],a[1779],a[1780],a[1770],a[1781],a[1782],a[1783],a[1784]],[a[62],a[56],a[88],a[58],a[58],a[534],a[90]],[a[1785],a[1786],a[1787],a[1788],a[1789],a[1790],a[1791]],[a[1792],a[1793],a[1794],a[1795],a[1796],a[1797],a[1798]],[a[1799],a[1800],a[163],a[164]],[a[1801],a[1802],a[163],a[164]],{"full":a[1803],"long":a[667],"medium":a[45],"short":a[46]},[a[1804],a[1805],a[1806],a[1807],a[1808],a[1809],a[1810]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1811],"GyMMMd":a[1812],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1813],"MMM":a[31],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[521],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMM":a[522],"yMMM":a[524],"yMMMEd":a[1814],"yMMMM":a[526],"yMMMd":a[601],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[1249],"long":a[1250],"medium":a[601],"short":a[1337]},[a[1815],a[1816],a[1817],a[1818],a[1261],a[1262],a[1819],a[1820],a[1821],a[1822],a[1823],a[1824]],[a[1825],a[1826],a[1827],a[1828],a[1261],a[1262],a[1263],a[1829],a[1830],a[1831],a[1832],a[1833]],[a[1834],a[1835],a[1836],a[1837],a[1838],a[1839],a[1840]],[a[1841],a[1277],a[1278],a[1279],a[1842],a[1843],a[1282]],[a[1844],a[1845],a[1846],a[1847],a[1848],a[1849],a[1850]],{"am":a[1851],"pm":a[1852]},[a[1853],a[1854],a[1855],a[1856]],[a[1857],a[1858],a[1859],a[1860],a[1861],a[1862],a[1863],a[1864],a[1865],a[1866],a[1867],a[1868]],[a[1869],a[1870],a[1871],a[1872],a[1873],a[1874],a[1875],a[1876],a[1877],a[1878],a[1879],a[1880]],[a[1881]],[a[1882],a[1883],a[1884],a[1885],a[1886],a[1887],a[1888],a[1889],a[1890],a[1891],a[1892],a[1893]],[a[1894]],{"decimal":a[480],"group":a[481],"nan":a[1895],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BDT":a[1896],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMd":a[33],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[43],"yMMMEd":a[44],"yMMMMd":a[1897],"yMMMd":a[1898],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[1803],"long":a[1897],"medium":a[1898],"short":a[46]},[a[1899],a[1900],a[1901],a[1902],a[1903],a[1904],a[1905],a[1906],a[1907],a[1908],a[1909],a[1910]],[a[1911],a[1912],a[1913],a[1914],a[1915],a[1916],a[1917],a[1918],a[1919],a[1920],a[1921],a[1922]],[a[1923],a[1924],a[1925],a[1926],a[1927],a[1928],a[1929]],[a[1930],a[1931],a[1932],a[1933],a[1934],a[1935],a[1936]],[a[1937],a[1938],a[1939],a[1940],a[1941],a[1942],a[1943]],{"am":a[1944],"pm":a[1945]},[a[1946],a[1947],a[163],a[164]],{"decimal":a[480],"group":a[481],"nan":a[1948],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[1381],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[1659],"MEd":a[1950],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[1951],"yMMM":a[524],"yMMMEd":a[599],"yMMMd":a[527],"yMd":a[721],"yQQQ":a[528],"yQQQQ":a[529]},[a[1952],a[1953],a[1954],a[1955],a[1956],a[1957],a[1958],a[1959],a[1960],a[117],a[118],a[119]],[a[1961],a[1962],a[1963],a[1964],a[1965],a[1966],a[1967],a[1968],a[1969],a[1970],a[1971],a[1972]],[a[1973],a[1974],a[1975],a[1976],a[1965],a[1977],a[1978],a[1968],a[1979],a[1970],a[1971],a[1980]],[a[1981],a[29],a[1982],a[1983],a[694],a[89],a[567]],[a[1984],a[1985],a[1986],a[1987],a[1988],a[1989],a[1990]],[a[1984],a[1985],a[1975],a[1991],a[1988],a[1992],a[1993]],{"am":a[1994],"pm":a[1995]},{"AUD":a[1996],"BRL":a[486],"CAD":a[1997],"CNY":a[488],"EUR":a[491],"GBP":a[1998],"HKD":a[1999],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[2000],"TWD":a[500],"USD":a[2001],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"GGGGyMMMMEEEEdd":a[2002],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMMEd":a[660],"MMMMd":a[661],"MMMd":a[2003],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[663],"yMMM":a[524],"yMMMEd":a[664],"yMMMM":a[526],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2004],"long":a[2005],"medium":a[1237],"short":a[2006]},[a[2007],a[2008],a[2009],a[2010],a[2011],a[2012],a[2012],a[2013],a[2014],a[2015],a[2016],a[2017]],[a[2018],a[2019],a[2020],a[2021],a[2011],a[2022],a[2023],a[2024],a[2025],a[2026],a[2027],a[2028]],[a[2029],a[2030],a[2031],a[2032],a[2033],a[2034],a[2034]],[a[2035],a[2036],a[2037],a[2038],a[2039],a[2040],a[2041]],[a[2042],a[2043],a[2044],a[2045],a[2046],a[2047],a[2048]],{"am":a[2049],"pm":a[2050]},[a[2051],a[2052],a[163],a[164]],[a[2053],a[2054],a[2055],a[2056],a[2057],a[2058],a[2059],a[2060],a[2061],a[2062],a[2063],a[2064]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[2065],"Ehm":a[20],"Ehms":a[21],"Gy":a[2066],"GyMMM":a[2067],"GyMMMEd":a[2068],"GyMMMd":a[2069],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[2070],"MMM":a[31],"MMMEd":a[2071],"MMMd":a[2072],"Md":a[2073],"d":a[35],"h":a[2074],"hm":a[2075],"hms":a[2076],"ms":a[39],"y":a[2077],"yM":a[2078],"yMEd":a[2079],"yMMM":a[2080],"yMMMEd":a[2081],"yMMMd":a[2082],"yMd":a[2083],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[2084],"long":a[2085],"medium":a[2083],"short":a[2086]},[a[2087],a[1677],a[1534],a[1563],a[1534],a[2087],a[2087],a[1563],a[1531],a[1679],a[1561],a[1680]],[a[2088],a[2089],a[2090],a[2091],a[2092],a[2093],a[2094],a[2095],a[2096],a[2097],a[2098],a[2099]],[a[2100],a[2101],a[1394],a[1693],a[2092],a[2102],a[2103],a[1399],a[2104],a[2105],a[2106],a[2107]],[a[1561],a[1562],a[2108],a[1531],a[1535],a[1562],a[1531]],[a[2109],a[2110],a[2111],a[2112],a[2113],a[2114],a[2115]],[a[2116],a[2117],a[2118],a[2119],a[2120],a[2121],a[1577]],[a[2122]],{"am":a[2123],"pm":a[2124]},[a[2125],a[2126],a[2127],a[2128],a[2129],a[2130],a[2131],a[2132],a[2133],a[2134],a[2135],a[2136],a[2137]],[a[2138],a[2139],a[2140],a[2141],a[2142],a[2143],a[2144],a[2145],a[2146],a[2147],a[2148],a[2149],a[2150]],[a[2151],a[2152],a[163],a[164]],[a[2153],a[2154],a[163],a[164]],[a[2155],a[2156],a[163],a[164]],[a[2157],a[2158],a[2159],a[2160],a[2161],a[2162],a[2163],a[2164],a[2165],a[2166],a[2167],a[2168],a[2169],a[2170]],[a[2171],a[2172],a[2173],a[2174],a[2175],a[2176],a[2177],a[2178],a[2179],a[2180],a[2181],a[2182]],[a[2183]],[a[2184],a[2185],a[2186],a[2187],a[2188],a[2189],a[2190],a[2191],a[2192],a[2193],a[2194],a[2195]],[a[2196],a[2197],a[2198],a[2199],a[2200],a[2201],a[2202],a[2203],a[2204],a[1752],a[2205],a[2206]],[a[2207]],[a[2208],a[2209],a[2210],a[2211],a[2212],a[2213],a[2214],a[2215],a[2216],a[2217],a[2218],a[2219],a[2220],a[2221],a[2222],a[2223],a[2224],a[2225],a[2226],a[2227],a[2228],a[2229],a[2230],a[2231],a[2232],a[2233],a[2234],a[2235],a[2236],a[2237],a[2238],a[2239],a[2240],a[2241],a[2242],a[2243],a[2244],a[2245],a[2246],a[2247],a[2248],a[2249],a[2250],a[2251],a[2252],a[2253],a[2254],a[2255],a[2256],a[2257],a[2258],a[2259],a[2260],a[2261],a[2262],a[2263],a[2264],a[2265],a[2266],a[2267],a[2268],a[2269],a[2270],a[2271],a[2272],a[2273],a[2274],a[2275],a[2276],a[2277],a[2278],a[2279],a[2280],a[2281],a[2282],a[2283],a[2284],a[2285],a[2286],a[2287],a[2288],a[2289],a[2290],a[2291],a[2292],a[2293],a[2294],a[2295],a[2296],a[2297],a[2298],a[2299],a[2300],a[2301],a[2302],a[2303],a[2304],a[2305],a[2306],a[2307],a[2308],a[2309],a[2310],a[2311],a[2312],a[2313],a[2314],a[2315],a[2316],a[2317],a[2318],a[2319],a[2320],a[2321],a[2322],a[2323],a[2324],a[2325],a[2326],a[2327],a[2328],a[2329],a[2330],a[2331],a[2332],a[2333],a[2334],a[2335],a[2336],a[2337],a[2338],a[2339],a[2340],a[2341],a[2342],a[2343],a[2344],a[2345],a[2346],a[2347],a[2348],a[2349],a[2350],a[2351],a[2352],a[2353],a[2354],a[2355],a[2356],a[2357],a[2358],a[2359],a[2360],a[2361],a[2362],a[2363],a[2364],a[2365],a[2366],a[2367],a[2368],a[2369],a[2370],a[2371],a[2372],a[2373],a[2374],a[2375],a[2376],a[2377],a[2378],a[2379],a[2380],a[2381],a[2382],a[2383],a[2384],a[2385],a[2386],a[2387],a[2388],a[2389],a[2390],a[2391],a[2392],a[2393],a[2394],a[2395],a[2396],a[2397],a[2398],a[2399],a[2400],a[2401],a[2402],a[2403],a[2404],a[2405],a[2406],a[2407],a[2408],a[2409],a[2410],a[2411],a[2412],a[2413],a[2414],a[2415],a[2416],a[2417],a[2418],a[2419],a[2420],a[2421],a[2422],a[2423],a[2424],a[2425],a[2426],a[2427],a[2428],a[2429],a[2430],a[2431],a[2432],a[2433],a[2434],a[2435],a[2436],a[2437],a[2438],a[2439],a[2440],a[2441],a[2442],a[2443]],[a[2444],a[2445],a[2446],a[2447],a[2448],a[2449],a[2450],a[2451],a[2452],a[2453],a[2454],a[2455]],[a[2456]],[a[2457],a[2458]],{"AUD":a[485],"BAM":a[2459],"BRL":a[486],"CAD":a[487],"CNY":a[488],"CZK":a[2460],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PLN":a[2461],"RSD":a[2462],"TRY":a[2463],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[2464],"Ehm":a[20],"Ehms":a[21],"Gy":a[2066],"GyMMM":a[2067],"GyMMMEd":a[2068],"GyMMMd":a[2069],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[2070],"MMM":a[31],"MMMEd":a[2071],"MMMMEd":a[2465],"MMMMd":a[2466],"MMMd":a[2072],"MMdd":a[2467],"Md":a[2073],"d":a[35],"h":a[36],"hm":a[2075],"hms":a[2076],"ms":a[39],"y":a[2077],"yM":a[2078],"yMEd":a[2079],"yMM":a[2468],"yMMM":a[2080],"yMMMEd":a[2081],"yMMMM":a[2469],"yMMMd":a[2082],"yMd":a[2083],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[2084],"long":a[2085],"medium":a[2470],"short":a[2471]},[a[1490],a[607],a[1463],a[2472],a[1463],a[1490],a[1490],a[2472],a[605],a[2473],a[602],a[35]],[a[2474],a[1340],a[1341],a[1422],a[2475],a[2476],a[2477],a[2478],a[2479],a[1427],a[2480],a[2481]],[a[2482],a[2483],a[1432],a[2484],a[2475],a[2485],a[2486],a[2487],a[2488],a[2489],a[2490],a[2491]],[a[56],a[1338],a[1763],a[90],a[2492],a[1338],a[90]],[a[2493],a[2494],a[2495],a[2496],a[2497],a[2498],a[2499]],[a[2500],a[2501],a[2502],a[2503],a[2504],a[2505],a[2506]],{"am":a[2507],"pm":a[2508]},[a[2509],a[1600],a[2510],a[2511]],[a[2512],a[2513],a[2510],a[2511]],[a[2514],a[2515],a[2510],a[2511]],[a[2516],a[2517],a[2518],a[2519],a[2520],a[2521],a[2522],a[2523],a[2524],a[2525],a[2526],a[2527]],[a[2528],a[2529],a[2530],a[2531],a[2532],a[2533],a[2534],a[2535],a[2536],a[2537],a[2538],a[2539]],[a[2540],a[472]],{"BAM":a[1326],"EUR":a[491],"HRK":a[2541],"INR":a[495],"JPY":a[1381],"KRW":a[497],"RSD":a[2542],"THB":a[589],"TWD":a[500],"VND":a[502],"XAF":a[503],"XOF":a[505]},{"E":a[16],"EHm":a[2544],"EHms":a[2545],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[1513],"GyMMMEd":a[1811],"GyMMMM":a[2546],"GyMMMd":a[1515],"H":a[451],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[2547],"yMMMEd":a[1814],"yMMMM":a[2548],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},[a[2549],a[2550],a[2551],a[2552],a[2553],a[2554],a[2555],a[2556],a[2557],a[2558],a[2559],a[2560]],[a[2561],a[2562],a[2563],a[2564],a[2565],a[2566],a[2567],a[2568],a[2569],a[2570],a[2571],a[2572]],[a[2573],a[2574],a[2563],a[2575],a[2565],a[2566],a[2576],a[2577],a[2578],a[2579],a[2580],a[2581]],[a[2582],a[2583],a[2584],a[2585],a[2586],a[2587],a[2588]],[a[2589],a[2590],a[2591],a[2592],a[2593],a[2594],a[2595]],[a[2596],a[2597],a[2598],a[2599],a[2600],a[2601],a[2602]],[a[2603]],{"am":a[2604],"pm":a[2605]},[a[2606],a[2607],a[2608],a[2609]],[a[2606],a[2607],a[2610],a[2611]],[a[2612],a[2613],a[2614],a[2615]],{"AUD":a[805],"CNY":a[1381],"ESP":a[2616],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"NZD":a[499],"THB":a[589],"TWD":a[500],"VND":a[502],"XAF":a[503],"XPF":a[506]},{"AUD":a[805],"CNY":a[1381],"ESP":a[2616],"EUR":a[491],"FRF":a[535],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"NZD":a[499],"THB":a[589],"TWD":a[500],"VND":a[502],"XAF":a[503],"XPF":a[506]},[a[2617],a[2618],a[2619],a[2620],a[2621],a[2622],a[2623],a[2624],a[2625],a[2626],a[2627],a[2628]],[a[2629],a[2630],a[2631],a[2632],a[2633],a[2634],a[2635],a[2636],a[2637],a[2638],a[2639],a[2640]],[a[90],a[62],a[590],a[90],a[56],a[88],a[450]],[a[2641],a[2642],a[2643],a[2644],a[2645],a[2646],a[2647]],[a[2648],a[2649],a[2650],a[2651],a[2652],a[2653],a[2654]],[a[2655],a[2656],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"UGX":a[2657],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1236],"GyMMMd":a[2658],"H":a[26],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[32],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[663],"yMMM":a[524],"yMMMEd":a[664],"yMMMM":a[526],"yMMMd":a[1237],"yMd":a[2659],"yQQQ":a[528],"yQQQQ":a[529]},[a[2660],a[2661],a[2662],a[2661],a[2662],a[2663],a[2664],a[2665],a[2666],a[2666],a[2667],a[2668]],[a[2669],a[2670],a[2671],a[2672],a[2673],a[2674],a[2675],a[2676],a[2677],a[2678],a[2679],a[2680]],[a[2681],a[2682],a[2683],a[2684],a[2685],a[2686],a[2687],a[2688],a[2689],a[2690],a[2691],a[2692]],[a[2693],a[2694],a[2695],a[2696],a[2667],a[2697],a[2660]],[a[2698],a[2699],a[2700],a[2701],a[2702],a[2703],a[2704]],[a[2705],a[2706],a[2707],a[2708],a[2709],a[2710],a[2711]],{"am":a[2712],"pm":a[2713]},[a[2714],a[2715],a[163],a[164]],[a[2716],a[2717],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[2544],"EHms":a[2545],"Ed":a[2718],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[2719],"GyMMMEd":a[2720],"GyMMMMEd":a[2721],"GyMMMMd":a[2722],"GyMMMd":a[2723],"H":a[451],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[2724],"MMM":a[31],"MMMEd":a[2724],"MMMMEd":a[2725],"MMMMd":a[2466],"MMMd":a[2726],"Md":a[2726],"d":a[2727],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[2728],"yMMM":a[1526],"yMMMEd":a[2728],"yMMMM":a[1526],"yMMMMEd":a[2729],"yMMMMd":a[2730],"yMMMd":a[2731],"yMd":a[2731],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2732],"long":a[2730],"medium":a[2731],"short":a[1391]},[a[2733],a[2734],a[2735],a[2736],a[2737],a[2738],a[2739],a[2740],a[2741],a[2742],a[2743],a[2744]],[a[2745],a[2746],a[2747],a[2748],a[2749],a[2750],a[2751],a[2752],a[2753],a[2754],a[2755],a[2756]],[a[56],a[1338],a[2757],a[90],a[2492],a[1338],a[90]],[a[2758],a[2759],a[2760],a[2761],a[2762],a[2763],a[2764]],[a[2765],a[2766],a[2767],a[2768],a[2769],a[2770],a[2771]],[a[2772],a[2773],a[163],a[2774]],[a[2775],a[2774],a[163],a[164]],[a[2776],a[472]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"CSK":a[2777],"CZK":a[2778],"EUR":a[491],"GBP":a[492],"HKD":a[493],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"XAF":a[503],"XBB":a[2779],"XCD":a[504],"XEU":a[2780],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[1646],"Ehm":a[2782],"Ehms":a[2783],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[1521],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[525],"yMMMd":a[527],"yMd":a[600],"yQ":a[2784],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[531],"medium":a[527],"short":a[52]},[a[1309],a[2785],a[450],a[87],a[450],a[450],a[89],a[58],a[450],a[451],a[88],a[2786]],[a[2787],a[2788],a[2789],a[2790],a[2791],a[2792],a[2793],a[2794],a[2795],a[2796],a[2797],a[2798]],[a[2799],a[2800],a[2789],a[2790],a[2791],a[2801],a[2802],a[2794],a[2795],a[2803],a[2804],a[2805]],[a[90],a[2806],a[450],a[450],a[1309],a[89],a[90]],[a[1984],a[2807],a[2808],a[2809],a[2810],a[1969],a[2811]],[a[2812],a[2813],a[2814],a[2815],a[2816],a[2817],a[2818]],[a[57],a[536],a[163],a[164]],[a[2819],a[2558],a[163],a[164]],[a[2820],a[2821],a[163],a[164]],{"E":a[16],"EHm":a[2822],"EHms":a[2823],"Ed":a[2824],"Ehm":a[2825],"Ehms":a[2826],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[2827],"GyMMMd":a[2828],"H":a[26],"Hm":a[1516],"Hms":a[1517],"M":a[450],"MEd":a[594],"MMM":a[1758],"MMMEd":a[2829],"MMMMEd":a[2725],"MMMd":a[2830],"MMdd":a[1760],"Md":a[595],"d":a[2727],"h":a[36],"hm":a[1521],"hms":a[1255],"ms":a[1522],"y":a[40],"yM":a[597],"yMEd":a[598],"yMM":a[1761],"yMMM":a[524],"yMMMEd":a[2831],"yMMMd":a[2832],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2833],"long":a[2730],"medium":a[721],"short":a[52]},[a[2834],a[2835],a[2836],a[2837],a[2475],a[2838],a[2567],a[2839],a[2840],a[2841],a[2571],a[2842]],[a[2482],a[2483],a[2843],a[2484],a[2475],a[2485],a[2486],a[2487],a[2844],a[2845],a[2846],a[2847]],[a[90],a[450],a[88],a[536],a[88],a[535],a[29]],[a[2848],a[2849],a[2850],a[2851],a[2852],a[2853],a[2854]],[a[2855],a[2856],a[2857],a[2858],a[2859],a[2860],a[2861]],[a[2862],a[2863],a[2864],a[2865]],[a[2866],a[2867],a[2868],a[2869]],[a[2866],a[2867],a[2870],a[2871]],[a[471],a[2872]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"DKK":a[2873],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[1309],a[62],a[62],a[62],a[62],a[62],a[450],a[59],a[1309],a[1309],a[1309],a[1309]],[a[2874],a[2875],a[2876],a[2877],a[2878],a[2879],a[2880],a[2881],a[2882],a[2883],a[2884],a[2885]],[a[2886],a[2887],a[2888],a[2889],a[2890],a[2891],a[2892],a[2893],a[2894],a[2895],a[2896],a[2897]],[a[534],a[534],a[62],a[62],a[62],a[62],a[56]],[a[2898],a[2899],a[2875],a[2876],a[2877],a[2878],a[2900]],[a[2901],a[2902],a[2903],a[2904],a[2905],a[2906],a[2907]],{"am":a[2908],"pm":a[2909]},[a[2910],a[653],a[163],a[164]],[a[2911],a[2912],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KES":a[2913],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[2065],"Ehm":a[20],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[2914],"GyMMMd":a[2828],"H":a[2915],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[2916],"MMM":a[31],"MMMEd":a[2917],"MMMMEd":a[2465],"MMMd":a[2830],"MMd":a[2918],"MMdd":a[2073],"Md":a[2919],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1523],"yMEd":a[1524],"yMM":a[1385],"yMMM":a[524],"yMMMEd":a[2920],"yMMMM":a[526],"yMMMd":a[2832],"yMMdd":a[1389],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2921],"long":a[2922],"medium":a[2923],"short":a[1391]},[a[2924],a[538],a[2925],a[2926],a[2791],a[1302],a[2927],a[2928],a[2929],a[2930],a[2931],a[2932]],[a[2933],a[2934],a[2925],a[552],a[2791],a[1302],a[2927],a[2935],a[556],a[557],a[558],a[2936]],[a[90],a[450],a[60],a[450],a[60],a[535],a[90]],[a[2937],a[2938],a[2939],a[2940],a[2941],a[2942],a[2943]],[a[2944],a[2945],a[2946],a[2947],a[2948],a[2949],a[2950]],{"am":a[2951],"pm":a[2952]},[a[2953],a[2954],a[2955],a[2956]],[a[2953],a[2954],a[2957],a[2958]],{"ATS":a[2959],"AUD":a[805],"BGM":a[2960],"BGO":a[2961],"BRL":a[486],"CAD":a[487],"CNY":a[488],"DEM":a[2962],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"full":a[2963],"long":a[2730],"medium":a[1389],"short":a[1391]},[a[537],a[538],a[2925],a[2926],a[2791],a[1302],a[2927],a[2928],a[2929],a[2930],a[2931],a[2932]],[a[2964],a[2934],a[2925],a[552],a[2791],a[1302],a[2927],a[2935],a[556],a[557],a[558],a[2936]],{"positivePattern":a[585],"negativePattern":a[2965]},{"decimal":a[480],"group":a[2966],"nan":a[482],"percent":a[483],"infinity":a[484]},{"ATS":a[2959],"AUD":a[805],"BGM":a[2960],"BGO":a[2961],"BRL":a[486],"CAD":a[487],"CNY":a[488],"DEM":a[2962],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"LUF":a[535],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[2967],a[535],a[450],a[58],a[450],a[2967],a[2967],a[1763],a[90],a[536],a[56],a[60]],[a[2968],a[2969],a[2970],a[2971],a[2972],a[2973],a[2974],a[2975],a[2976],a[546],a[2977],a[2978]],[a[2979],a[2980],a[2981],a[2982],a[2972],a[2983],a[2984],a[2975],a[2985],a[2986],a[2987],a[2988]],[a[451],a[88],a[88],a[29],a[450],a[1762],a[90]],[a[1314],a[2989],a[2990],a[2991],a[2992],a[2993],a[2994]],[a[2995],a[2996],a[2997],a[2998],a[1321],a[2999],a[3000]],{"am":a[3001],"pm":a[3002]},[a[3003],a[3004],a[163],a[164]],[a[3005],a[3006],a[163],a[164]],{"decimal":a[480],"group":a[587],"nan":a[482],"percent":a[483],"infinity":a[484]},{"E":a[16],"EHm":a[3007],"EHms":a[2781],"Ed":a[2065],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[2914],"GyMMMd":a[2828],"H":a[3008],"Hm":a[3009],"Hms":a[1657],"M":a[29],"MEd":a[2916],"MMM":a[31],"MMMEd":a[2917],"MMMd":a[2830],"Md":a[2919],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1523],"yMEd":a[1524],"yMMM":a[524],"yMMMEd":a[2920],"yMMMd":a[2832],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2963],"long":a[2730],"medium":a[1527],"short":a[1528]},[a[2834],a[2835],a[3010],a[2837],a[3011],a[2838],a[2567],a[3012],a[2840],a[2841],a[3013],a[2842]],[a[3014],a[3015],a[3016],a[3017],a[3018],a[3019],a[3020],a[3021],a[3022],a[3023],a[3024],a[3025]],[a[602],a[3026],a[3027],a[605],a[605],a[3026],a[605]],[a[1472],a[3028],a[3029],a[3030],a[3031],a[3032],a[3033]],[a[3034],a[3035],a[3036],a[3037],a[3038],a[3039],a[2771]],{"am":a[3040],"pm":a[3041]},[a[3042],a[3043],a[3044],a[3045]],[a[3046],a[3047],a[3048],a[3049]],{"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PLN":a[3050],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"full":a[530],"long":a[531],"medium":a[527],"short":a[600]},[a[35],a[1489],a[605],a[35],a[3051],a[3051],a[1463],a[35],a[602],a[1463],a[604],a[3051]],[a[3052],a[3053],a[3054],a[3055],a[3056],a[3057],a[3058],a[3059],a[3060],a[1343],a[3061],a[3062]],[a[3063],a[3064],a[3065],a[3066],a[3067],a[3068],a[3069],a[3070],a[3071],a[3072],a[3073],a[3074]],[a[3051],a[1463],a[603],a[1463],a[1489],a[3075],a[3051]],[a[3076],a[3077],a[3078],a[3079],a[3080],a[3081],a[3082]],[a[3083],a[3084],a[3085],a[3086],a[3087],a[3088],a[3089]],{"am":a[3090],"pm":a[3091]},[a[3092],a[3093],a[163],a[164]],[a[3094],a[3095],a[163],a[164]],[a[90],a[535],a[450],a[58],a[450],a[90],a[90],a[1763],a[90],a[536],a[56],a[60]],[a[567],a[3096],a[562],a[3097],a[2972],a[1981],a[3098],a[2975],a[3099],a[3100],a[3101],a[3102]],[a[3103],a[3104],a[3105],a[3106],a[3107],a[3108],a[3109],a[2975],a[3110],a[3111],a[3112],a[3113]],[a[60],a[88],a[88],a[58],a[58],a[58],a[90]],[a[3114],a[3115],a[93],a[2991],a[3116],a[3117],a[3118]],[a[3119],a[3120],a[3121],a[3122],a[3123],a[3124],a[3125]],[a[3126],a[3127],a[163],a[164]],[a[3128],a[3129],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[3130],"GyMMMEd":a[3131],"GyMMMd":a[25],"H":a[3132],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3133],"MMM":a[3134],"MMMEd":a[3135],"MMMd":a[3136],"Md":a[3137],"d":a[35],"h":a[3138],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[3139],"yMEd":a[3140],"yMMM":a[3141],"yMMMEd":a[3142],"yMMMd":a[45],"yMd":a[3143],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[3144],"long":a[3145],"medium":a[3146],"short":a[46]},{"full":a[3147],"long":a[3148],"medium":a[3149],"short":a[3150]},[a[3151],a[3152],a[3153],a[111],a[3154],a[3155],a[3156],a[3157],a[116],a[3158],a[3159],a[3160]],[a[3151],a[3152],a[3153],a[3161],a[3154],a[3155],a[3156],a[3157],a[3162],a[3158],a[3159],a[119]],[a[3163],a[3164],a[3165],a[3166],a[3167],a[3168],a[3169],a[3170],a[3171],a[3172],a[3173],a[3174]],[a[1924],a[3175],a[3176],a[3177],a[3178],a[3179],a[1923]],[a[3180],a[3181],a[3182],a[3183],a[3184],a[3185],a[3186]],[a[1938],a[1939],a[1940],a[1941],a[1942],a[1943],a[1937]],{"am":a[3187],"pm":a[3188]},[a[3189],a[473]],{"decimal":a[480],"group":a[481],"nan":a[3190],"percent":a[483],"infinity":a[3191]},{"AUD":a[805],"BRL":a[486],"BTN":a[3192],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"INR":a[495],"JPY":a[496],"KRW":a[3193],"MXN":a[498],"NZD":a[499],"THB":a[3194],"TWD":a[500],"USD":a[501],"VND":a[502],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[450],a[62],a[62],a[62],a[89],a[89],a[450],a[62],a[62],a[1309],a[1309],a[1309]],[a[3195],a[3196],a[3197],a[2877],a[3198],a[3199],a[3200],a[3201],a[3202],a[2883],a[2884],a[3203]],[a[3204],a[3205],a[3206],a[3207],a[3208],a[3209],a[3210],a[3211],a[3212],a[3213],a[3214],a[3215]],[a[62],a[56],a[56],a[56],a[58],a[450],a[56]],[a[3216],a[3217],a[3218],a[3219],a[3220],a[3221],a[3222]],[a[3223],a[3224],a[3225],a[3226],a[3227],a[3228],a[3229]],{"am":a[3230],"pm":a[3231]},[a[3232],a[3233],a[163],a[164]],[a[3234],a[3235],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[3237],"Ehms":a[3238],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[3239],"GyMMMd":a[3240],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[3241],"MMMMEd":a[3242],"MMMMd":a[3243],"MMMd":a[3244],"Md":a[662],"d":a[35],"h":a[3245],"hm":a[3246],"hms":a[3247],"ms":a[3248],"y":a[40],"yM":a[597],"yMEd":a[663],"yMMM":a[524],"yMMMEd":a[664],"yMMMM":a[526],"yMMMd":a[3249],"yMd":a[2659],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[3250],"long":a[3251],"medium":a[3249],"short":a[2006]},{"full":a[3252],"long":a[3253],"medium":a[3247],"short":a[3246]},[a[35],a[35],a[604],a[2472],a[35],a[1463],a[605],a[35],a[2472],a[603],a[2472],a[35]],[a[3254],a[3255],a[3256],a[3257],a[3258],a[3259],a[3260],a[3261],a[3262],a[3263],a[3264],a[3265]],[a[3266],a[3267],a[3268],a[3269],a[3270],a[3271],a[3272],a[3273],a[3274],a[3275],a[3276],a[3277]],[a[603],a[35],a[1465],a[603],a[40],a[607],a[1463]],[a[3278],a[3279],a[3280],a[3281],a[3282],a[3283],a[3284]],[a[3285],a[3286],a[3287],a[3288],a[3289],a[3290],a[3291]],{"am":a[3292],"pm":a[3293]},[a[3266],a[3267],a[3268],a[3294],a[3295],a[3271],a[3272],a[3273],a[3274],a[3275],a[3276],a[3277]],[a[3254],a[3255],a[3256],a[3257],a[3258],a[3259],a[3260],a[3261],a[3262],a[3263],a[3264],a[3265],a[3296]],[a[3266],a[3267],a[3268],a[3294],a[3295],a[3271],a[3272],a[3273],a[3274],a[3275],a[3276],a[3277],a[3297]],[a[3298],a[3299],a[163],a[164]],[a[3300],a[3301],a[163],a[164]],[a[3266],a[3267],a[3268],a[3294],a[3295],a[3271],a[3272],a[3273],a[3274],a[3275],a[3276],a[3277],a[3297],a[3272]],[a[3266],a[3267],a[3268],a[3294],a[3295],a[3271],a[3272],a[3302],a[3274],a[3275],a[3276],a[3277],a[3297],a[3272]],[a[3292]],[a[3266],a[3267],a[3268],a[3257],a[3295],a[3271],a[3272],a[3273],a[3274],a[3275],a[3276],a[3277]],[a[3303],a[472]],{"decimal":a[480],"group":a[481],"nan":a[3304],"percent":a[483],"infinity":a[484]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"GHS":a[715],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[1513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"HHmm":a[27],"HHmmss":a[28],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[720],"long":a[531],"medium":a[527],"short":a[1337]},[a[3305],a[3306],a[3307],a[3308],a[3307],a[3305],a[3305],a[3308],a[3309],a[3310],a[3311],a[3312]],[a[3313],a[3314],a[3315],a[3316],a[3317],a[3318],a[3319],a[3320],a[3321],a[3322],a[3323],a[3324]],[a[3325],a[3326],a[3327],a[3328],a[3329],a[3330],a[3331],a[3332],a[3333],a[3334],a[3335],a[3336]],[a[3337],a[3312],a[3338],a[3338],a[3339],a[3339],a[3309]],[a[3340],a[3341],a[3342],a[3343],a[3344],a[3345],a[3346]],[a[3347],a[3348],a[3349],a[3350],a[3351],a[3352],a[3353]],{"am":a[3354],"pm":a[3355]},[a[3356],a[3357],a[3358],a[3359]],[a[3360],a[3361],a[3362],a[3363]],[a[3364],a[472]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"GRD":a[3365],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1236],"GyMMMd":a[2658],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[663],"yMMM":a[524],"yMMMEd":a[664],"yMMMd":a[1237],"yMd":a[2659],"yQQQ":a[528],"yQQQQ":a[529]},[a[1293],a[1294],a[2970],a[540],a[3366],a[542],a[543],a[544],a[545],a[3367],a[547],a[1297]],[a[3368],a[3369],a[3370],a[552],a[3366],a[3371],a[3372],a[2935],a[556],a[3373],a[558],a[3374]],[a[3375],a[3376],a[3377],a[3378],a[3379],a[3380],a[3381]],[a[3382],a[3383],a[3384],a[3385],a[3386],a[3387],a[3388],a[3389],a[3390],a[3391],a[3392],a[3393]],[a[3394],a[3395],a[3396],a[3397],a[3398],a[3399],a[3400],a[3401],a[3402],a[3403],a[3404],a[3405]],[a[693],a[58],a[163],a[164]],[a[3406],a[3407],a[3408],a[3409]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[527],"medium":a[592],"short":a[52]},{"full":a[3410],"long":a[533],"medium":a[28],"short":a[27]},{"am":a[3411],"pm":a[3412]},[a[3413]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[588],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[3414],"MEd":a[1950],"MMM":a[31],"MMMEd":a[517],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[531],"medium":a[527],"short":a[3415]},{"AUD":a[485],"BBD":a[588],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BMD":a[588],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"BSD":a[588],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[3416],"GyMMMd":a[515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1950],"MMM":a[31],"MMMEd":a[3417],"MMMd":a[3418],"MMdd":a[1760],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[3419],"yMMM":a[524],"yMMMEd":a[3420],"yMMMM":a[526],"yMMMd":a[592],"yMd":a[721],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[3421],"long":a[50],"medium":a[592],"short":a[52]},{"AUD":a[485],"BRL":a[486],"BWP":a[1338],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1236],"GyMMMd":a[2658],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1950],"MMM":a[31],"MMMEd":a[3417],"MMMd":a[3418],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[1951],"yMMM":a[524],"yMMMEd":a[3420],"yMMMd":a[592],"yMd":a[721],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[3421],"long":a[50],"medium":a[51],"short":a[52]},{"AUD":a[485],"BRL":a[486],"BZD":a[588],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1236],"GyMMMd":a[2658],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3422],"MMM":a[31],"MMMEd":a[659],"MMMd":a[33],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[3423],"yMMM":a[524],"yMMMEd":a[664],"yMMMd":a[1237],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2004],"long":a[2005],"medium":a[1237],"short":a[46]},{"AUD":a[485],"BRL":a[486],"CAD":a[588],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[588],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[588],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1950],"MMM":a[31],"MMMEd":a[517],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[3419],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[721],"yQQQ":a[528],"yQQQQ":a[529]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"ERN":a[508],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"FJD":a[588],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"FKP":a[492],"GBP":a[1248],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"GHS":a[715],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[1248],"GIP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"GMD":a[60],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"GYD":a[588],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[531],"medium":a[527],"short":a[600]},[a[218],a[219],a[220],a[221],a[222],a[223],a[224],a[225],a[226],a[227],a[228],a[229],a[230],a[231],a[232],a[233],a[234],a[235],a[236],a[237],a[238],a[239],a[240],a[241],a[242],a[243],a[244],a[245],a[246],a[247],a[248],a[249],a[250],a[251],a[252],a[253],a[254],a[255],a[256],a[257],a[258],a[259],a[260],a[261],a[262],a[263],a[264],a[265],a[266],a[267],a[268],a[269],a[270],a[271],a[272],a[273],a[274],a[275],a[276],a[277],a[278],a[279],a[280],a[281],a[282],a[283],a[284],a[285],a[286],a[287],a[288],a[289],a[290],a[291],a[292],a[293],a[294],a[295],a[296],a[297],a[298],a[299],a[300],a[301],a[302],a[303],a[304],a[305],a[306],a[307],a[308],a[309],a[310],a[311],a[312],a[313],a[314],a[315],a[316],a[317],a[318],a[319],a[320],a[321],a[322],a[323],a[324],a[325],a[326],a[327],a[328],a[329],a[330],a[331],a[332],a[333],a[334],a[335],a[336],a[337],a[338],a[339],a[340],a[341],a[342],a[343],a[344],a[345],a[346],a[347],a[348],a[349],a[350],a[351],a[352],a[353],a[354],a[355],a[356],a[357],a[358],a[359],a[360],a[361],a[362],a[363],a[364],a[365],a[366],a[367],a[368],a[369],a[370],a[371],a[372],a[373],a[374],a[375],a[376],a[377],a[378],a[3424],a[380],a[381],a[382],a[3425],a[384],a[385],a[386],a[387],a[388],a[389],a[390],a[391],a[392],a[393],a[394],a[395],a[396],a[397],a[398],a[399],a[400],a[401],a[402],a[403],a[404],a[405],a[406],a[407],a[408],a[409],a[410],a[411],a[412],a[413],a[414],a[415],a[416],a[417],a[418],a[419],a[420],a[421],a[422],a[423],a[424],a[425],a[426],a[427],a[428],a[429],a[430],a[431],a[432],a[433],a[434],a[435],a[436],a[437],a[438],a[439],a[440],a[441],a[442],a[443],a[444],a[445],a[446],a[447],a[448],a[449],a[454],a[455],a[456],a[457]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[517],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[527],"short":a[721]},{"am":a[3426],"pm":a[3427]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1950],"MMM":a[31],"MMMEd":a[517],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[598],"yMMM":a[524],"yMMMEd":a[3428],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[51],"short":a[52]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1236],"GyMMMd":a[2658],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[659],"MMMd":a[33],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[664],"yMMMd":a[1237],"yMd":a[2659],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2004],"long":a[2005],"medium":a[1237],"short":a[1337]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JMD":a[588],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KES":a[2913],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"KYD":a[588],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"LRD":a[588],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"ZAR":a[590]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MGA":a[3429],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MOP":a[3430],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1950],"MMM":a[31],"MMMEd":a[1333],"MMMMd":a[813],"MMMd":a[3418],"MMdd":a[1760],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[3419],"yMMM":a[524],"yMMMEd":a[3431],"yMMMM":a[526],"yMMMd":a[592],"yMd":a[721],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[50],"medium":a[592],"short":a[721]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[1248],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MUR":a[3432],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MWK":a[3232],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"MYR":a[3433],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NAD":a[588],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NGN":a[3434],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1950],"MMM":a[31],"MMMEd":a[1333],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[3419],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[3415],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[531],"medium":a[3415],"short":a[3435]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[588],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PGK":a[62],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PHP":a[3436],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"full":a[530],"long":a[531],"medium":a[51],"short":a[721]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PKR":a[3432],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"RWF":a[3437],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SBD":a[588],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SCR":a[3438],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1950],"MMM":a[31],"MMMEd":a[1333],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[3419],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[721],"yQQQ":a[528],"yQQQQ":a[529]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SGD":a[588],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[1248],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SHP":a[492],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SLL":a[3439],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[1248],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SSP":a[492],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"ANG":a[3440],"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SZL":a[87],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TOP":a[3441],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TTD":a[588],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"TZS":a[1332],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"UGX":a[2657],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"VUV":a[3442],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"WST":a[3443],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1236],"GyMMMd":a[2658],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3444],"MMM":a[31],"MMMEd":a[3417],"MMMd":a[3418],"Md":a[1216],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[3445],"yMMM":a[524],"yMMMEd":a[3431],"yMMMd":a[592],"yMd":a[1219],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[3421],"long":a[50],"medium":a[592],"short":a[1219]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"ZMW":a[62]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1236],"GyMMMd":a[2658],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[3417],"MMMd":a[3418],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[3446],"yMMMd":a[3447],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[3421],"long":a[50],"medium":a[3448],"short":a[600]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[3449],"MMMd":a[519],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[524],"yMMMEd":a[3450],"yMMMd":a[527],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[3451],"long":a[3452],"medium":a[3453],"short":a[3454]},{"full":a[3455],"long":a[533],"medium":a[28],"short":a[27]},[a[2474],a[1340],a[1341],a[1422],a[2475],a[2476],a[2477],a[3456],a[2479],a[1427],a[2480],a[2481]],[a[3457],a[3458],a[3459],a[3460],a[3461],a[3462],a[3463],a[3464],a[3465],a[3466],a[3467],a[3468]],[a[60],a[29],a[450],a[450],a[3469],a[560],a[90]],[a[3052],a[3470],a[3471],a[3472],a[3473],a[3474],a[3475]],[a[3476],a[3477],a[3478],a[3479],a[3480],a[3481],a[3482]],{"am":a[3483],"pm":a[3484]},[a[3485],a[3486],a[3487],a[712]],[a[3485],a[3486],a[3488],a[3489]],[a[3485],a[3486],a[3490],a[3491]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TRY":a[3492],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[509],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[3493],"GyMMMEd":a[3494],"GyMMMd":a[3495],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[3496],"MMMMd":a[3497],"MMMd":a[3498],"MMMdd":a[3499],"MMd":a[595],"MMdd":a[595],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[598],"yMM":a[597],"yMMM":a[3500],"yMMMEd":a[3501],"yMMMM":a[3502],"yMMMd":a[3503],"yMd":a[600],"yQQQ":a[3504],"yQQQQ":a[3505]},{"full":a[3506],"long":a[3507],"medium":a[3503],"short":a[1337]},[a[3051],a[607],a[1463],a[2472],a[1463],a[1490],a[1490],a[2472],a[605],a[2473],a[602],a[35]],[a[3508],a[2835],a[2836],a[2564],a[3509],a[2838],a[2567],a[3510],a[2569],a[2570],a[2571],a[3511]],[a[3512],a[3513],a[3514],a[2575],a[3515],a[3462],a[3463],a[3516],a[3517],a[2579],a[3518],a[3519]],[a[35],a[608],a[1463],a[1463],a[1490],a[3520],a[605]],[a[3521],a[3522],a[2836],a[3523],a[3524],a[3525],a[3526]],[a[3527],a[3528],a[1371],a[1372],a[3529],a[3530],a[3531]],{"am":a[3532],"pm":a[3533]},[a[3534],a[3535],a[3536],a[3537]],[a[3538],a[3539],a[3540],a[3541]],[a[3542],a[472]],{"ESP":a[2616],"XPF":a[506],"ZMW":a[3543]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[509],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[3493],"GyMMMEd":a[3494],"GyMMMd":a[3495],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3544],"MMM":a[31],"MMMEd":a[3496],"MMMMd":a[3497],"MMMd":a[3498],"MMMdd":a[3499],"MMd":a[595],"MMdd":a[595],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[3545],"yMEd":a[598],"yMM":a[597],"yMMM":a[3500],"yMMMEd":a[3501],"yMMMM":a[3502],"yMMMd":a[3503],"yMd":a[600],"yQQQ":a[3504],"yQQQQ":a[3505]},{"full":a[3546],"long":a[54],"medium":a[38],"short":a[37]},{"ARS":a[588],"ESP":a[2616],"USD":a[501],"XPF":a[506],"ZMW":a[3543]},{"BOB":a[3547],"ESP":a[2616],"XPF":a[506],"ZMW":a[3543]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[509],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[3493],"GyMMMEd":a[3494],"GyMMMd":a[3495],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3548],"MMM":a[31],"MMMEd":a[3496],"MMMMd":a[3497],"MMMd":a[3498],"MMMdd":a[3499],"MMd":a[595],"MMdd":a[595],"Md":a[521],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[522],"yMEd":a[3549],"yMM":a[597],"yMMM":a[3500],"yMMMEd":a[3501],"yMMMM":a[3502],"yMMMd":a[3503],"yMd":a[1251],"yQQQ":a[3504],"yQQQQ":a[3505]},{"full":a[3506],"long":a[3507],"medium":a[1251],"short":a[3550]},{"positivePattern":a[476],"negativePattern":a[2965]},{"CLP":a[588],"ESP":a[2616],"USD":a[501],"XPF":a[506],"ZMW":a[3543]},{"full":a[3506],"long":a[3507],"medium":a[3415],"short":a[3435]},{"full":a[3551],"long":a[54],"medium":a[38],"short":a[37]},{"COP":a[588],"ESP":a[2616],"USD":a[501],"XPF":a[506],"ZMW":a[3543]},{"CRC":a[3552],"ESP":a[2616],"XPF":a[506],"ZMW":a[3543]},{"CUP":a[588],"ESP":a[2616],"USD":a[501],"XPF":a[506],"ZMW":a[3543]},{"DOP":a[588],"ESP":a[2616],"USD":a[501],"XPF":a[506],"ZMW":a[3543]},{"E":a[16],"EHm":a[3553],"EHms":a[1645],"Ed":a[509],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[3493],"GyMMMEd":a[3494],"GyMMMd":a[3554],"H":a[451],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[3496],"MMMMd":a[3497],"MMMd":a[3498],"MMMdd":a[3498],"MMd":a[595],"MMdd":a[595],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[3555],"yMM":a[597],"yMMM":a[3500],"yMMMEd":a[3556],"yMMMM":a[3502],"yMMMd":a[3503],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[3505]},{"full":a[3557],"long":a[1675],"medium":a[1657],"short":a[1656]},[a[87],a[535],a[450],a[58],a[450],a[534],a[534],a[58],a[90],a[536],a[56],a[60]],[a[3508],a[2835],a[2836],a[2564],a[3509],a[2838],a[2567],a[3510],a[3558],a[2570],a[2571],a[3511]],[a[3512],a[3513],a[3514],a[2575],a[3515],a[3462],a[3463],a[3516],a[3559],a[2579],a[3518],a[3519]],[a[60],a[29],a[450],a[61],a[534],a[560],a[90]],[a[3538],a[3560],a[3536],a[3537]],{"CAD":a[487],"ESP":a[2616],"EUR":a[491],"THB":a[589],"USD":a[588],"VND":a[502],"XPF":a[506]},{"ESP":a[2616],"USD":a[588],"XPF":a[506],"ZMW":a[3543]},{"CAD":a[487],"ESP":a[2616],"EUR":a[491],"THB":a[589],"USD":a[588],"VND":a[502],"XAF":a[503],"XPF":a[506]},{"ESP":a[2616],"GTQ":a[55],"XPF":a[506],"ZMW":a[3543]},{"full":a[3561],"long":a[3562],"medium":a[3503],"short":a[1337]},{"ESP":a[2616],"HNL":a[29],"XPF":a[506],"ZMW":a[3543]},{"E":a[16],"EHm":a[2544],"EHms":a[2545],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[3494],"GyMMMd":a[1515],"H":a[26],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[3563],"MMMMd":a[3497],"MMMd":a[3498],"MMMdd":a[3499],"MMd":a[1759],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[598],"yMM":a[1761],"yMMM":a[3500],"yMMMEd":a[3556],"yMMMM":a[3502],"yMMMd":a[3503],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[3505]},{"full":a[3506],"long":a[3507],"medium":a[721],"short":a[52]},[a[3564],a[1340],a[1341],a[1342],a[1343],a[2476],a[2477],a[1346],a[2479],a[3565],a[2480],a[3566]],[a[60],a[29],a[450],a[450],a[534],a[560],a[90]],[a[1363],a[3567],a[1341],a[3568],a[3569],a[1367],a[3570]],[a[1377],a[1378],a[3536],a[3537]],[a[3538],a[3407],a[3536],a[3537]],{"AFN":a[3571],"ANG":a[3572],"AOA":a[3573],"ARS":a[3574],"AUD":a[805],"AWG":a[3575],"CNY":a[488],"ESP":a[2616],"MXN":a[588],"ZMW":a[3543]},{"ESP":a[2616],"NIO":a[3576],"XPF":a[506],"ZMW":a[3543]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[509],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[3493],"GyMMMEd":a[3494],"GyMMMd":a[3495],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3577],"MMM":a[31],"MMMEd":a[3496],"MMMMd":a[3497],"MMMd":a[3498],"MMMdd":a[3499],"MMd":a[595],"MMdd":a[595],"Md":a[1216],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[3578],"yMM":a[597],"yMMM":a[3500],"yMMMEd":a[3501],"yMMMM":a[3502],"yMMMd":a[3503],"yMd":a[3579],"yQQQ":a[3504],"yQQQQ":a[3505]},{"full":a[3506],"long":a[3507],"medium":a[3579],"short":a[3580]},{"ESP":a[2616],"PAB":a[3581],"XPF":a[506],"ZMW":a[3543]},{"full":a[3506],"long":a[3507],"medium":a[3503],"short":a[3435]},{"full":a[3582],"long":a[54],"medium":a[38],"short":a[37]},{"ESP":a[2616],"PEN":a[3583],"XPF":a[506],"ZMW":a[3543]},{"CAD":a[487],"ESP":a[2616],"EUR":a[491],"PHP":a[3436],"THB":a[589],"USD":a[588],"VND":a[502],"XPF":a[506]},{"positivePattern":a[585],"negativePattern":a[3584]},{"ESP":a[2616],"PYG":a[3585],"XPF":a[506],"ZMW":a[3543]},{"ESP":a[2616],"JPY":a[1381],"USD":a[588],"XPF":a[506],"ZMW":a[3543]},{"ESP":a[2616],"USD":a[501],"UYU":a[588],"XPF":a[506],"ZMW":a[3543]},{"ESP":a[2616],"VEF":a[3586],"XPF":a[506],"ZMW":a[3543]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[1646],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[3587],"GyMMMd":a[2828],"H":a[26],"Hm":a[27],"Hms":a[3588],"M":a[450],"MEd":a[1518],"MMM":a[3589],"MMMEd":a[2917],"MMMMEd":a[2465],"MMMMd":a[2466],"MMMd":a[2830],"Md":a[1520],"d":a[35],"h":a[36],"hm":a[37],"hms":a[3590],"mmss":a[1522],"ms":a[1522],"y":a[40],"yM":a[1523],"yMEd":a[3591],"yMMM":a[524],"yMMMEd":a[3592],"yMMMM":a[526],"yMMMd":a[2832],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2963],"long":a[2730],"medium":a[2832],"short":a[1391]},{"full":a[3593],"long":a[3594],"medium":a[3588],"short":a[1656]},[a[534],a[560],a[450],a[58],a[450],a[534],a[534],a[58],a[90],a[536],a[56],a[60]],[a[3595],a[3596],a[3597],a[1422],a[3598],a[3599],a[3600],a[2478],a[3601],a[1427],a[2480],a[3602]],[a[3603],a[3604],a[3597],a[3605],a[3598],a[3599],a[3600],a[2487],a[2844],a[3606],a[2846],a[3607]],[a[1338],a[87],a[88],a[62],a[56],a[590],a[29]],[a[3608],a[3609],a[3610],a[3611],a[3612],a[3613],a[3614]],[a[3615],a[3616],a[3617],a[2475]],[a[3615],a[3616],a[3618],a[3619]],[a[3620],a[3621],a[3622],a[3623]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EEK":a[3624],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[3625],"GyMMMEd":a[3626],"GyMMMd":a[3627],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3628],"MMM":a[31],"MMMEd":a[32],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1217],"yMEd":a[3629],"yMMM":a[43],"yMMMEd":a[44],"yMMMM":a[3630],"yMMMMEd":a[3631],"yMMMMd":a[3632],"yMMMd":a[45],"yMd":a[665],"yQQQ":a[3633],"yQQQQ":a[3634]},{"full":a[3635],"long":a[3632],"medium":a[45],"short":a[1219]},{"full":a[3636],"long":a[3637],"medium":a[28],"short":a[27]},[a[1763],a[536],a[450],a[58],a[450],a[87],a[1763],a[58],a[1309],a[1763],a[58],a[58]],[a[3638],a[3639],a[2836],a[3640],a[3641],a[3642],a[3643],a[3644],a[3645],a[3646],a[3647],a[3648]],[a[3649],a[3650],a[3651],a[3652],a[3653],a[3654],a[3655],a[3656],a[3657],a[3658],a[3659],a[3660]],[a[1309],a[58],a[58],a[58],a[536],a[536],a[29]],[a[3661],a[3662],a[3663],a[3664],a[3665],a[3666],a[3667]],[a[3668],a[3669],a[3670],a[3671],a[3672],a[3673],a[3674]],[a[3675]],[a[3676],a[3677],a[163],a[164]],[a[3678],a[472]],{"positivePattern":a[3679],"negativePattern":a[3680]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"ESP":a[2616],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[2473],a[1465],a[608],a[602],a[604],a[605],a[606],a[1463],a[3051],a[2472],a[35],a[1465]],[a[3681],a[3682],a[3683],a[3684],a[3685],a[3686],a[3687],a[3688],a[3689],a[3690],a[3691],a[3692]],[a[3693],a[3694],a[3695],a[3696],a[3697],a[3698],a[3699],a[3700],a[3701],a[3702],a[3703],a[3704]],[a[605],a[1463],a[605],a[605],a[605],a[607],a[605]],[a[3705],a[3706],a[3707],a[3708],a[3709],a[3710],a[3711]],[a[3712],a[3713],a[3714],a[3715],a[3716],a[3717],a[3718]],{"am":a[3719],"pm":a[3720]},[a[3721],a[3722],a[163],a[164]],[a[3723],a[3724],a[163],a[164]],{"E":a[16],"EHm":a[2544],"EHms":a[2545],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[451],"HHmmZ":a[3726],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[3727],"MMM":a[31],"MMMEd":a[3728],"MMMMEd":a[3729],"MMMMd":a[3730],"MMMd":a[3731],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"mmss":a[39],"ms":a[39],"y":a[40],"yM":a[1217],"yMEd":a[3732],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMMEEEEd":a[530],"yMMMd":a[527],"yMd":a[665],"yQQQ":a[529],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[527],"short":a[665]},{"full":a[3557],"long":a[3733],"medium":a[1657],"short":a[1656]},[a[3734],a[826],a[827],a[1228],a[827],a[3734],a[3734],a[3735],a[833],a[3735],a[830],a[836]],[a[1083],a[3736],a[839],a[3737],a[3738],a[3739],a[3740],a[3741],a[3742],a[3743],a[3744],a[3745]],[a[3746],a[3747],a[3748],a[3749],a[3750],a[3751],a[3752],a[3753],a[3754],a[3755],a[3756],a[3757]],[a[3758],a[836],a[833],a[3759],a[3760],a[853],a[1227]],[a[3761],a[3762],a[3763],a[3764],a[3765],a[3766],a[3767]],{"am":a[3768],"pm":a[3769]},[a[3770],a[827],a[3771],a[3772]],[a[3773],a[3774],a[3771],a[3772]],[a[3775],a[3776],a[3771],a[3772]],[a[1229],a[849],a[3777],a[3778],a[1227],a[1228],a[829],a[830],a[3735],a[833],a[1229],a[1228],a[3735],a[829]],[a[3779],a[3780],a[3781],a[3782],a[898],a[900],a[3783],a[3784],a[3785],a[3786],a[904],a[905],a[3787],a[3788]],[a[827],a[862],a[851],a[851],a[853],a[853],a[851],a[1227],a[851],a[1227],a[3789],a[3789]],[a[920],a[921],a[3790],a[3791],a[3792],a[3793],a[926],a[927],a[928],a[929],a[3794],a[3795]],[a[3796]],[a[3797]],[a[826],a[3735],a[852],a[1229],a[827],a[1227],a[827],a[1228],a[1228],a[836],a[835],a[3735]],[a[3798],a[3799],a[1171],a[3800],a[1173],a[3801],a[1175],a[3802],a[1177],a[3803],a[1179],a[3804]],[a[3805],a[3806],a[3807],a[3808],a[3809],a[3810],a[3811],a[3812],a[3813],a[3814],a[3815],a[3816]],[a[3817]],[a[3818]],[a[3819],a[473]],{"positivePattern":a[3820],"negativePattern":a[3821]},{"decimal":a[1184],"group":a[1185],"nan":a[3822],"percent":a[1187],"infinity":a[484]},{"AFN":a[3823],"AUD":a[485],"BRL":a[486],"CAD":a[1997],"CNY":a[3824],"EUR":a[491],"GBP":a[492],"HKD":a[3825],"ILS":a[494],"INR":a[495],"IRR":a[3826],"JPY":a[1381],"KRW":a[497],"MXN":a[3827],"NZD":a[3828],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[3829],"XOF":a[505],"XPF":a[506]},[a[3830],a[3736],a[839],a[3737],a[3831],a[3739],a[3832],a[3741],a[3742],a[3743],a[3744],a[3833]],[a[3834]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[450],"MEd":a[30],"MMM":a[1758],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"MMd":a[1759],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[40],"yM":a[597],"yMEd":a[598],"yMM":a[1761],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},[a[605],a[609],a[1463],a[605],a[35],a[603],a[1463],a[1490],a[605],a[40],a[1490],a[1465]],[a[3835],a[3836],a[3837],a[614],a[3838],a[3839],a[3840],a[3841],a[3842],a[3843],a[3844],a[3845]],[a[3846],a[3847],a[3848],a[3849],a[3850],a[3851],a[3852],a[3853],a[3854],a[3855],a[3856],a[3857]],[a[35],a[2472],a[1463],a[602],a[602],a[1463],a[1464]],[a[3858],a[3859],a[3860],a[1472],a[3861],a[3862],a[3863]],[a[3864],a[3865],a[3866],a[3867],a[3868],a[3869],a[3870]],{"am":a[3871],"pm":a[3872]},[a[3873],a[3874],a[163],a[164]],[a[3875],a[3876],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"GNF":a[3877],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MRO":a[3878],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[3879],"EHms":a[3880],"Ed":a[2718],"Ehm":a[2825],"Ehms":a[2826],"Gy":a[512],"GyMMM":a[1513],"GyMMMEd":a[2827],"GyMMMd":a[2828],"H":a[451],"Hm":a[3881],"Hms":a[3882],"M":a[29],"MEd":a[3883],"MMM":a[31],"MMMEd":a[3884],"MMMd":a[2830],"Md":a[2919],"d":a[35],"h":a[36],"hm":a[1521],"hms":a[1255],"ms":a[3885],"y":a[40],"yM":a[3886],"yMEd":a[3887],"yMM":a[1523],"yMMM":a[1525],"yMMMEd":a[2831],"yMMMM":a[1526],"yMMMMccccd":a[3888],"yMMMd":a[2832],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[3888],"long":a[2730],"medium":a[1527],"short":a[1527]},{"full":a[3889],"long":a[3890],"medium":a[3882],"short":a[3881]},[a[88],a[451],a[450],a[451],a[88],a[62],a[451],a[87],a[90],a[29],a[450],a[534]],[a[3891],a[3892],a[3893],a[3894],a[3895],a[3896],a[3897],a[3898],a[3899],a[3900],a[3901],a[3902]],[a[90],a[450],a[88],a[62],a[88],a[1338],a[29]],[a[3903],a[3471],a[3904],a[3905],a[3906],a[3907],a[3908]],[a[3909],a[3910],a[3911],a[3912],a[3913],a[3914],a[3915]],{"am":a[3916],"pm":a[3917]},[a[3918],a[3919],a[3920],a[3921]],[a[3922],a[3923],a[3924],a[3925]],[a[3926],a[3927],a[3928],a[3929]],[a[88],a[451],a[62],a[88],a[90],a[58],a[58],a[56],a[1309],a[90],a[88],a[58],a[87],a[58]],[a[3930],a[3931],a[3932],a[3933],a[3934],a[3935],a[3936],a[3937],a[3938],a[3939],a[3940],a[3941],a[3942],a[3943]],[a[3944],a[3945],a[3946],a[3947],a[3948],a[3949],a[3950],a[3951],a[3952],a[3953],a[3954],a[3955]],{"decimal":a[481],"group":a[587],"nan":a[3956],"percent":a[483],"infinity":a[484]},{"EUR":a[491],"FIM":a[3957],"GBP":a[492],"JPY":a[1381],"USD":a[588],"XAF":a[503],"XOF":a[505]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMMEd":a[660],"MMMMd":a[661],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[663],"yMM":a[1761],"yMMM":a[524],"yMMMEd":a[664],"yMMMM":a[526],"yMMMd":a[1237],"yMd":a[2659],"yQQQ":a[528],"yQQQQ":a[529]},[a[87],a[1338],a[450],a[58],a[450],a[451],a[451],a[58],a[90],a[536],a[56],a[60]],[a[3958],a[3959],a[2970],a[3960],a[3366],a[3961],a[3962],a[1296],a[3963],a[546],a[3964],a[1586]],[a[3965],a[3966],a[3967],a[3968],a[3969],a[3970],a[3971],a[3972],a[3973],a[3974],a[3975],a[3976]],[a[29],a[29],a[450],a[450],a[451],a[693],a[90]],[a[3977],a[1985],a[2970],a[3978],a[3979],a[3980],a[97]],[a[3981],a[3982],a[3983],a[3984],a[3985],a[3986],a[3987]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PHP":a[3436],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3133],"MMM":a[31],"MMMEd":a[3988],"MMMd":a[33],"Md":a[3137],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[3423],"yMMM":a[43],"yMMMEd":a[3989],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[3421],"long":a[2832],"medium":a[1251],"short":a[3550]},[a[2474],a[1340],a[1341],a[1422],a[3598],a[2476],a[2477],a[2478],a[2479],a[1427],a[2480],a[1774]],[a[2482],a[2483],a[3990],a[3991],a[3598],a[2485],a[2486],a[2487],a[2844],a[2845],a[2846],a[3992]],[a[90],a[450],a[88],a[450],a[451],a[535],a[29]],[a[3993],a[3994],a[3995],a[3996],a[3997],a[3998],a[3999]],[a[4000],a[4001],a[4002],a[4003],a[4004],a[4005],a[4006]],{"am":a[4007],"pm":a[4008]},[a[2862],a[2863],a[4009],a[4010]],[a[2866],a[2867],a[4011],a[4012]],[a[4013],a[4014],a[4015],a[4016]],{"decimal":a[481],"group":a[480],"nan":a[4017],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"DKK":a[3624],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[87],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[4018],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[598],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[527],"short":a[3435]},{"full":a[4019],"long":a[533],"medium":a[28],"short":a[27]},[a[4020],a[4021],a[3990],a[4022],a[3598],a[4023],a[4024],a[4025],a[3558],a[2570],a[2571],a[4026]],[a[4027],a[4028],a[3990],a[4029],a[3598],a[4023],a[4030],a[4025],a[4031],a[4032],a[2580],a[4033]],[a[4034],a[3522],a[2836],a[4035],a[4036],a[4037],a[4038]],[a[4039],a[4040],a[4041],a[4042],a[4043],a[4044],a[4045]],[a[4046]],[a[4047]],[a[4048]],[a[4049],a[4050],a[4051],a[4052],a[4053],a[4054],a[4055],a[4056],a[4057],a[4058],a[4059],a[4060]],[a[4061],a[4062],a[4063],a[4064],a[4065],a[4066],a[4067],a[4068],a[4069],a[4070],a[4071],a[4072]],[a[88],a[693],a[451],a[62],a[88],a[58],a[693],a[693],a[693],a[693],a[58],a[450],a[56]],[a[4073],a[4074],a[4075],a[4076],a[4077],a[4078],a[4079],a[4080],a[4081],a[4082],a[4083],a[4084],a[4085]],[a[4073],a[4086],a[4087],a[4088],a[4089],a[4090],a[4091],a[4092],a[4093],a[4094],a[4095],a[4096],a[4097]],[a[4098],a[4099]],[a[4100],a[4101]],[a[450],a[88],a[451],a[88],a[88],a[694],a[450],a[450],a[89],a[90],a[451],a[56],a[1338]],[a[4102],a[4103],a[4104],a[4105],a[4106],a[4107],a[4108],a[4109],a[4110],a[4111],a[4112],a[4113],a[4114]],[a[4115],a[4116],a[4117],a[4118],a[4106],a[4119],a[4120],a[4121],a[4122],a[4123],a[4124],a[4125],a[4126]],[a[4127],a[4128]],[a[4129],a[4130]],[a[4131],a[4132],a[2610],a[2611]],[a[4133],a[4134],a[2610],a[2611]],[a[4135],a[4136],a[4137],a[4138],a[4139],a[4140],a[4141],a[4142],a[4143],a[4144],a[4145],a[4146],a[4147],a[4148]],[a[4149],a[4150],a[167],a[4151],a[4152],a[170],a[171],a[4153],a[173],a[174],a[4154],a[3097],a[4155],a[178]],[a[4156]],[a[57],a[560],a[534],a[4157],a[90],a[693],a[4157],a[62],a[450],a[1338],a[450],a[1338]],[a[4158],a[4159],a[4160],a[4161],a[4162],a[4163],a[4164],a[4165],a[4166],a[4167],a[4168],a[4169]],[a[4170],a[4171],a[4172],a[4173],a[4174],a[4175],a[4176],a[4177],a[4178],a[4179],a[4168],a[4180]],[a[4181],a[2517],a[4182],a[4183],a[4184],a[4185],a[4186],a[4187],a[2524],a[4188],a[4189],a[4190]],[a[4191],a[3945],a[4192],a[4193],a[4194],a[4195],a[4196],a[4197],a[3952],a[4198],a[4199],a[4200]],[a[4201],a[4202]],{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BIF":a[4234],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"E":a[87],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[4018],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[4235],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"MMd":a[4236],"MMdd":a[34],"Md":a[3137],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[523],"yMM":a[41],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[46],"short":a[3454]},[a[4133],a[4134],a[4237],a[4238]],{"AUD":a[4239],"BEF":a[2550],"BRL":a[486],"CAD":a[588],"CNY":a[488],"CYP":a[4211],"EUR":a[491],"FRF":a[535],"GBP":a[492],"HKD":a[4240],"IEP":a[4216],"ILP":a[4217],"ITL":a[4218],"JPY":a[1381],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"NZD":a[4241],"RHD":a[4225],"SGD":a[4242],"USD":a[4243],"XDR":a[4232]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CDF":a[4244],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"E":a[87],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[4018],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"MMdd":a[1384],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[598],"yMM":a[1385],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[531],"medium":a[527],"short":a[1391]},{"full":a[4245],"long":a[533],"medium":a[28],"short":a[27]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"DJF":a[489],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"DZD":a[4246],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"GNF":a[3877],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"HTG":a[89],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KMF":a[4247],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"LUF":a[535],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGA":a[3429],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MRO":a[3878],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MUR":a[3432],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"RWF":a[3437],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SCR":a[3438],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"SYP":a[4248],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TND":a[4249],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"ARS":a[4203],"AUD":a[4204],"BEF":a[2550],"BMD":a[4205],"BND":a[4206],"BRL":a[486],"BSD":a[4207],"BZD":a[4208],"CAD":a[1997],"CLP":a[4209],"COP":a[4210],"CYP":a[4211],"EUR":a[491],"FJD":a[4212],"FKP":a[4213],"FRF":a[535],"GBP":a[4214],"GIP":a[4215],"IEP":a[4216],"ILP":a[4217],"ILS":a[494],"INR":a[495],"ITL":a[4218],"KRW":a[497],"LBP":a[4219],"LSL":a[4220],"MAF":a[4221],"MGF":a[4222],"MTP":a[4223],"MXN":a[3827],"NAD":a[4224],"NZD":a[3828],"RHD":a[4225],"SBD":a[4226],"SGD":a[4227],"SRD":a[4228],"THB":a[589],"TTD":a[4229],"USD":a[4230],"UYU":a[4231],"VND":a[502],"VUV":a[3442],"WST":a[3443],"XAF":a[503],"XDR":a[4232],"XOF":a[505],"XPF":a[4233]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[1656],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[4250],"MMMd":a[519],"MMd":a[1759],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[4251],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[4252],"long":a[4253],"medium":a[721],"short":a[52]},[a[1762],a[535],a[450],a[58],a[450],a[534],a[29],a[58],a[90],a[536],a[56],a[60]],[a[4254],a[4255],a[2970],a[4256],a[2791],a[4257],a[4258],a[4259],a[3963],a[4260],a[547],a[4261]],[a[4262],a[4263],a[4264],a[4265],a[2791],a[4266],a[4258],a[4267],a[4268],a[4269],a[3112],a[4270]],[a[1363],a[3567],a[1341],a[1365],a[4271],a[4272],a[1368]],[a[4273],a[4274],a[4275],a[4276],a[4277],a[4278],a[4279]],{"am":a[4280],"pm":a[4281]},[a[4282],a[1380],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3544],"MMM":a[31],"MMMEd":a[517],"MMMMd":a[813],"MMMd":a[519],"Md":a[4283],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[3545],"yMEd":a[4284],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[1252],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[527],"short":a[3550]},[a[2834],a[2835],a[4285],a[2837],a[3598],a[2838],a[2567],a[2839],a[2840],a[2841],a[2571],a[2572]],[a[4286],a[4287],a[4288],a[2484],a[4289],a[2566],a[4290],a[4291],a[4292],a[2845],a[4293],a[4294]],[a[1762],a[450],a[60],a[59],a[60],a[560],a[1762]],[a[4295],a[4296],a[3904],a[4297],a[3906],a[4298],a[2764]],[a[4299],a[4300],a[4301],a[4302],a[4303],a[4304],a[4305]],[a[4306],a[4307],a[4308],a[4309],a[4310],a[138],a[139],a[4311],a[141],a[4312],a[4313],a[4314],a[4315]],[a[4316],a[4317],a[150],a[151],a[4318],a[4319],a[4320],a[4321],a[156],a[4322],a[158],a[4323],a[4324]],[a[4325],a[4326],a[4327],a[4328]],[a[2866],a[4329],a[4330],a[582]],[a[4331],a[4332],a[4333],a[4334]],[a[4335],a[4336],a[167],a[168],a[4337],a[4338],a[171],a[172],a[4339],a[174],a[4340],a[176],a[4341],a[4342]],[a[180],a[4343],a[4344],a[4345],a[4346],a[4347],a[4348],a[4349],a[188],a[4350],a[4351],a[4352]],[a[4353],a[194],a[195],a[196],a[4354],a[4355],a[199],a[4356],a[201],a[4357],a[4358],a[4359]],[a[4360],a[206],a[4361],a[4362],a[4363],a[4364],a[211],a[4365],a[213],a[4366],a[4367],a[4368]],[a[4369]],{"positivePattern":a[585],"negativePattern":a[4370]},{"AUD":a[805],"BRL":a[486],"CAD":a[3576],"CNY":a[488],"EUR":a[491],"FJD":a[4371],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SBD":a[4372],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[3414],"MEd":a[1950],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[1951],"yMMM":a[524],"yMMMEd":a[599],"yMMMd":a[527],"yMd":a[721],"yQQQ":a[528],"yQQQQ":a[529]},[a[87],a[535],a[450],a[58],a[693],a[450],a[1309],a[29],a[450],a[60],a[90],a[56]],[a[4373],a[4374],a[4375],a[4376],a[4377],a[4378],a[4379],a[4380],a[4381],a[4382],a[4383],a[4384]],[a[4385],a[4386],a[4375],a[4387],a[4388],a[4389],a[4379],a[4390],a[4391],a[4392],a[4393],a[4394]],[a[60],a[29],a[450],a[57],a[60],a[58],a[90]],[a[4395],a[4396],a[4397],a[4398],a[4399],a[4400],a[4401]],[a[4402],a[4403],a[4404],a[4405],a[4406],a[4407],a[4408]],[a[4409],a[1600],a[4410],a[4411]],[a[4412],a[3407],a[4413],a[4414]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[1646],"Ehm":a[4415],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMMd":a[4416],"MMMd":a[519],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[4417],"hm":a[4418],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMM":a[1761],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[1526],"yMMMd":a[527],"yMd":a[2659],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[4419],"long":a[4420],"medium":a[527],"short":a[721]},[a[535],a[89],a[450],a[89],a[57],a[4421],a[1309],a[29],a[90],a[60],a[90],a[60]],[a[4422],a[4423],a[4424],a[4425],a[4426],a[4427],a[4428],a[4429],a[4430],a[4431],a[4383],a[4432]],[a[4433],a[4434],a[4435],a[4436],a[4437],a[4438],a[4439],a[4440],a[4441],a[4442],a[4443],a[4444]],[a[60],a[29],a[450],a[57],a[58],a[451],a[90]],[a[4445],a[4446],a[4447],a[4448],a[4449],a[4450],a[4451]],[a[4452],a[4453],a[4454],a[4455],a[4456],a[4457],a[4458]],{"am":a[1463],"pm":a[607]},[a[590],a[58],a[4459],a[4460]],[a[4409],a[1600],a[4459],a[4460]],[a[4461],a[4462],a[4459],a[4460]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1813],"MMM":a[31],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[4283],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[3545],"yMEd":a[1334],"yMM":a[1761],"yMMM":a[524],"yMMMEd":a[1814],"yMMMM":a[526],"yMMMd":a[601],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[3421],"long":a[50],"medium":a[601],"short":a[52]},[a[61],a[535],a[450],a[58],a[450],a[61],a[61],a[58],a[90],a[536],a[56],a[60]],[a[4463],a[1340],a[1341],a[1342],a[3598],a[4464],a[4465],a[1346],a[1347],a[4466],a[2480],a[2481]],[a[4467],a[4468],a[3514],a[2575],a[4469],a[4470],a[4471],a[3516],a[4472],a[4473],a[3467],a[3468]],[a[1363],a[3567],a[1341],a[4474],a[4475],a[4476],a[3570]],[a[3527],a[4477],a[1371],a[4478],a[4479],a[4480],a[3531]],[a[1377],a[1378],a[163],a[164]],[a[3538],a[4481],a[1377],a[1378]],{"AUD":a[1996],"BRL":a[4482],"CAD":a[1997],"CNY":a[488],"ESP":a[2616],"EUR":a[491],"GBP":a[492],"HKD":a[3825],"ILS":a[494],"INR":a[495],"JPY":a[4483],"KRW":a[497],"MXN":a[3827],"NZD":a[499],"THB":a[589],"TWD":a[4484],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[2718],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[451],"HHmm":a[27],"HHmmss":a[28],"Hm":a[1656],"Hms":a[28],"M":a[29],"MEd":a[2916],"MMM":a[31],"MMMEd":a[2829],"MMMMEd":a[2725],"MMMMd":a[2466],"MMMd":a[2830],"MMd":a[2918],"MMdd":a[2073],"Md":a[2919],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"mmss":a[39],"ms":a[39],"y":a[40],"yM":a[3139],"yMEd":a[3140],"yMM":a[1385],"yMMM":a[524],"yMMMEd":a[2920],"yMMMM":a[526],"yMMMd":a[45],"yMMdd":a[1389],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},[a[1293],a[1294],a[4485],a[540],a[2791],a[542],a[543],a[544],a[545],a[546],a[547],a[4486]],[a[2964],a[2934],a[2925],a[552],a[2791],a[1302],a[2927],a[4487],a[4488],a[4489],a[4490],a[4491]],[a[4492],a[4493],a[4494],a[2940],a[4495],a[2942],a[2943]],[a[4496],a[4497],a[4498],a[4499],a[4500],a[4501],a[4502]],{"am":a[2951],"pm":a[4503]},[a[2953],a[2954],a[4504],a[4505]],[a[2953],a[2954],a[4506],a[4507]],[a[2953],a[2954],a[4508],a[4509]],{"decimal":a[480],"group":a[4510],"nan":a[482],"percent":a[483],"infinity":a[484]},{"ATS":a[2959],"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[4511],"GyMMMEd":a[4512],"GyMMMd":a[4513],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[521],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMM":a[522],"yMMM":a[524],"yMMMEd":a[1814],"yMMMM":a[526],"yMMMd":a[601],"yMd":a[600],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[4514],"long":a[4515],"medium":a[2076],"short":a[2075]},[a[4516],a[4517],a[4518],a[4519],a[4520],a[4521],a[4522],a[4523],a[4524],a[4523],a[4525],a[4526]],[a[4527],a[4528],a[4529],a[4530],a[4520],a[4531],a[4532],a[4533],a[4534],a[4535],a[4536],a[4537]],[a[4538],a[4539],a[4529],a[4530],a[4520],a[4531],a[4532],a[4540],a[4541],a[4542],a[4543],a[4544]],[a[4545],a[4546],a[4547],a[4548],a[4549],a[4550],a[4551]],[a[4552],a[4553],a[4554],a[4555],a[4556],a[4557],a[4558]],[a[4559],a[4560],a[4561],a[4562],a[4563],a[4564],a[4565]],[a[4566],a[4567],a[4568],a[4569]],[a[4570],a[4571],a[4568],a[4569]],[a[4572],a[4571],a[4568],a[4569]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMMEd":a[660],"MMMMd":a[661],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[663],"yMMM":a[524],"yMMMEd":a[664],"yMMMM":a[526],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},[a[57],a[535],a[450],a[58],a[450],a[534],a[57],a[58],a[90],a[536],a[56],a[60]],[a[4573],a[1294],a[1295],a[540],a[541],a[542],a[4574],a[4575],a[545],a[546],a[3964],a[1586]],[a[4576],a[4577],a[1300],a[4578],a[541],a[1302],a[4579],a[1304],a[1305],a[4580],a[4581],a[1589]],[a[57],a[57],a[57],a[57],a[58],a[1309],a[87]],[a[4582],a[4583],a[4584],a[4585],a[4586],a[4587],a[4588]],[a[4589],a[4590],a[4591],a[4592],a[4593],a[4594],a[4595]],{"am":a[4596],"pm":a[4597]},[a[4598],a[4599],a[163],a[164]],[a[4600],a[4601],a[163],a[164]],{"full":a[3421],"long":a[50],"medium":a[4602],"short":a[52]},[a[4603],a[4604],a[4605],a[4606],a[4607],a[4608],a[4609],a[4610],a[4611],a[4612],a[4613],a[4614]],[a[4615],a[4616],a[4605],a[4617],a[4607],a[4618],a[4619],a[4610],a[4620],a[4621],a[4622],a[4623]],[a[4624],a[4625],a[4626],a[4627],a[4628],a[4629],a[4630]],[a[4631],a[4632],a[4633],a[4634],a[4635],a[4636],a[4637]],[a[4409],a[1600],a[163],a[164]],[a[534],a[535],a[450],a[58],a[450],a[694],a[694],a[58],a[90],a[536],a[56],a[60]],[a[1293],a[4638],a[2970],a[4639],a[3366],a[4640],a[4641],a[4642],a[1810],a[546],a[4643],a[1586]],[a[4644],a[4645],a[4646],a[4647],a[4648],a[4649],a[4650],a[4651],a[4652],a[1306],a[4653],a[4654]],[a[29],a[29],a[88],a[29],a[58],a[534],a[58]],[a[4655],a[4656],a[4657],a[4658],a[4659],a[4660],a[4661]],[a[4662],a[4663],a[3121],a[4664],a[4665],a[4666],a[4667]],[a[4668],a[4669],a[163],a[164]],[a[4670],a[4671],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"GHS":a[715],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NGN":a[3434],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NGN":a[3434],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[525],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[47],"yQQQQ":a[48]},{"_value":a[1337],"_numbers":a[4672]},[a[4673],a[4674],a[4675],a[4676],a[541],a[4677],a[4678],a[4679],a[4680],a[4681],a[4682],a[4683]],[a[4684],a[4685],a[4686],a[4687],a[541],a[4688],a[4689],a[4690],a[4691],a[4692],a[4693],a[4694]],[a[4695],a[4696],a[4697],a[4698],a[4699],a[4700],a[4701]],[a[4702],a[4703],a[4704],a[4705],a[4706],a[4707],a[4708]],{"E":a[16],"EHm":a[2544],"EHms":a[2545],"Ed":a[4709],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[4710],"GyMMMd":a[4711],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1518],"MMM":a[31],"MMMEd":a[4712],"MMMd":a[4713],"Md":a[1520],"d":a[35],"h":a[4714],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1523],"yMEd":a[1524],"yMM":a[1523],"yMMM":a[524],"yMMMEd":a[4715],"yMMMM":a[526],"yMMMd":a[4716],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[4717],"long":a[4718],"medium":a[4716],"short":a[1527]},[a[4719],a[4720],a[4721],a[4722],a[4723],a[4724],a[4725],a[4726],a[4727],a[4728],a[4729],a[4730]],[a[4731],a[4732],a[4721],a[4733],a[4723],a[4724],a[4725],a[4734],a[4735],a[4736],a[4737],a[4738]],[a[4739],a[4740],a[4741],a[4742],a[4743],a[4744],a[4745]],[a[4746],a[4747],a[4748],a[4749],a[4750],a[4751],a[4752]],[a[4753],a[4754],a[4755],a[4756],a[4757],a[4758],a[4759]],{"am":a[4760],"pm":a[4761]},[a[4762],a[4763],a[163],a[164]],[a[4764],a[4763],a[4762],a[164]],[a[4765],a[4766],a[4767],a[4768],a[4769],a[4770],a[4771],a[4772],a[4773],a[4774],a[4775],a[4776],a[4777],a[4778]],[a[4779],a[4780],a[4781],a[4782],a[4783],a[4784],a[4785],a[4786],a[4787],a[4788],a[4789],a[4776],a[4790],a[4791]],[a[4792]],[a[4793],a[4794],a[4795],a[4796],a[4797],a[4798],a[4799],a[4800],a[4801],a[4802],a[4803],a[4804]],[a[4793],a[4794],a[4805],a[4806],a[4807],a[4808],a[4799],a[4800],a[4801],a[4802],a[4803],a[4804]],[a[4809]],[a[4810],a[219],a[220],a[221],a[222],a[223],a[224],a[225],a[226],a[227],a[228],a[229],a[230],a[231],a[232],a[233],a[234],a[235],a[236],a[237],a[238],a[239],a[240],a[241],a[4811],a[243],a[244],a[245],a[246],a[247],a[248],a[249],a[250],a[251],a[252],a[253],a[254],a[255],a[256],a[257],a[258],a[259],a[260],a[261],a[262],a[263],a[264],a[265],a[266],a[267],a[268],a[269],a[270],a[271],a[272],a[273],a[274],a[275],a[276],a[277],a[278],a[279],a[280],a[281],a[282],a[283],a[284],a[285],a[286],a[287],a[288],a[289],a[290],a[4812],a[292],a[293],a[294],a[295],a[296],a[297],a[298],a[299],a[300],a[301],a[302],a[303],a[304],a[305],a[306],a[307],a[308],a[309],a[310],a[311],a[312],a[313],a[314],a[315],a[316],a[317],a[318],a[319],a[320],a[321],a[322],a[323],a[324],a[325],a[326],a[327],a[328],a[329],a[330],a[331],a[332],a[333],a[334],a[335],a[336],a[337],a[338],a[339],a[340],a[341],a[342],a[343],a[344],a[345],a[346],a[347],a[348],a[349],a[350],a[351],a[352],a[353],a[354],a[355],a[356],a[357],a[358],a[359],a[360],a[361],a[362],a[363],a[364],a[365],a[366],a[367],a[368],a[369],a[370],a[371],a[372],a[373],a[374],a[375],a[376],a[377],a[378],a[452],a[380],a[381],a[382],a[453],a[384],a[385],a[386],a[387],a[388],a[389],a[390],a[391],a[392],a[393],a[394],a[395],a[396],a[397],a[398],a[399],a[400],a[401],a[402],a[403],a[404],a[405],a[406],a[407],a[408],a[409],a[410],a[411],a[412],a[413],a[414],a[415],a[416],a[417],a[418],a[419],a[420],a[421],a[422],a[423],a[424],a[425],a[426],a[427],a[428],a[429],a[430],a[431],a[432],a[433],a[434],a[435],a[436],a[437],a[438],a[439],a[440],a[441],a[442],a[443],a[444],a[445],a[446],a[447],a[448],a[449],a[454],a[455],a[456],a[457]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILP":a[4813],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[4814],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMM":a[1761],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[526],"yMMMd":a[527],"yMMdd":a[721],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[531],"medium":a[721],"short":a[1337]},[a[2007],a[4815],a[2009],a[2015],a[4816],a[4817],a[2012],a[2015],a[4818],a[2015],a[2016],a[2017]],[a[4819],a[4820],a[4821],a[4822],a[4823],a[4824],a[4825],a[4826],a[4827],a[4828],a[4829],a[4830]],[a[4831],a[4832],a[4821],a[4822],a[4823],a[4824],a[4833],a[4834],a[4835],a[4836],a[4837],a[4838]],[a[2029],a[4839],a[2031],a[2032],a[4840],a[4841],a[4842]],[a[4843],a[4844],a[2037],a[4845],a[4846],a[4847],a[4848]],[a[4849],a[4850],a[4851],a[4852],a[4853],a[4854],a[4855]],{"am":a[4856],"pm":a[4857]},[a[4858],a[4859],a[4860],a[4861],a[4862],a[4863],a[4864],a[4865],a[4866],a[4867],a[4868],a[4869],a[4870]],[a[4871],a[4872],a[4873],a[4874]],[a[4871],a[4875],a[4873],a[4874]],[a[4876],a[4877],a[4878],a[4879],a[4880],a[4881],a[4882],a[4883],a[4884],a[4885],a[4886],a[4887]],[a[4888]],[a[4889],a[4890],a[4891],a[4892],a[4893],a[4894],a[4895],a[4896],a[4897],a[4898],a[4899],a[4900]],[a[4901],a[4902],a[4903],a[4904],a[4905],a[4906],a[4907],a[4908],a[4909],a[4910],a[4911],a[4912],a[4913],a[4914],a[4915],a[4916],a[4917],a[4918],a[4919],a[4920],a[4921],a[4922],a[4923],a[4924],a[4925],a[4926],a[4927],a[4928],a[4929],a[4930],a[4931],a[4932],a[4933],a[4934],a[4935],a[4936],a[4937],a[4938],a[4939],a[4940],a[4941],a[4942],a[4943],a[4944],a[4945],a[4946],a[4947],a[4948],a[4949],a[4950],a[4951],a[4952],a[4953],a[4954],a[4955],a[4956],a[4957],a[4958],a[4959],a[4960],a[4961],a[4962],a[4963],a[4964],a[4965],a[4966],a[4967],a[4968],a[4969],a[4970],a[4971],a[4972],a[4973],a[4974],a[4975],a[4976],a[4977],a[4978],a[4979],a[4980],a[4981],a[4982],a[4983],a[4984],a[4985],a[4986],a[4987],a[4988],a[4989],a[4990],a[4991],a[4992],a[4993],a[4994],a[4995],a[4996],a[4997],a[4998],a[4999],a[5000],a[5001],a[5002],a[5003],a[5004],a[5005],a[5006],a[5007],a[5008],a[5009],a[5010],a[5011],a[5012],a[5013],a[5014],a[5015],a[5016],a[5017],a[5018],a[5019],a[5020],a[5021],a[5022],a[5023],a[5024],a[5025],a[5026],a[5027],a[5028],a[5029],a[5030],a[5031],a[5032],a[5033],a[5034],a[5035],a[5036],a[5037],a[5038],a[5039],a[5040],a[5041],a[5042],a[5043],a[5044],a[5045],a[5046],a[5047],a[5048],a[5049],a[5050],a[5051],a[5052],a[5053],a[5054],a[5055],a[5056],a[5057],a[5058],a[5059],a[5060],a[5061],a[5062],a[5063],a[5064],a[5065],a[5066],a[5067],a[5068],a[5069],a[5070],a[5071],a[5072],a[5073],a[5074],a[5075],a[5076],a[5077],a[5078],a[5079],a[5080],a[5081],a[5082],a[5083],a[5084],a[5085],a[5086],a[5087],a[5088],a[5089],a[5090],a[5091],a[5092],a[5093],a[5094],a[5095],a[5096],a[5097],a[5098],a[5099],a[5100],a[5101],a[5102],a[5103],a[5104],a[5105],a[5106],a[5107],a[5108],a[5109],a[5110],a[5111],a[5112],a[5113],a[5114],a[5115],a[5116],a[5117],a[5118],a[5119],a[5120],a[5121],a[5122],a[5123],a[5124],a[5125],a[5126],a[5127],a[5128],a[5129],a[5130],a[5131],a[5132],a[5133],a[5134],a[5135],a[5136]],[a[5137],a[5138],a[5139],a[5140],a[5141],a[5142],a[5143],a[5144],a[5145],a[5146],a[5147],a[5148]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[2065],"Ehm":a[20],"Ehms":a[21],"Gy":a[2066],"GyMMM":a[5149],"GyMMMEd":a[5150],"GyMMMd":a[5151],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[5152],"MEd":a[2070],"MMM":a[31],"MMMEd":a[2917],"MMMMEd":a[2465],"MMMMd":a[2466],"MMMd":a[2830],"MMdd":a[2467],"Md":a[2073],"d":a[2727],"h":a[36],"hm":a[2075],"hms":a[2076],"ms":a[39],"y":a[2077],"yM":a[2078],"yMEd":a[2079],"yMM":a[2468],"yMMM":a[5153],"yMMMEd":a[5154],"yMMMM":a[2469],"yMMMd":a[5155],"yMd":a[2083],"yQQQ":a[5156],"yQQQQ":a[5157]},{"full":a[5158],"long":a[5159],"medium":a[5155],"short":a[2083]},[a[5160],a[5161],a[5162],a[5163],a[5164],a[5165],a[5166],a[5167],a[5168],a[5169],a[5170],a[5171]],[a[5172],a[5173],a[5174],a[5175],a[5176],a[5177],a[2740],a[5178],a[5179],a[2743],a[5180],a[2744]],[a[5181],a[5182],a[5183],a[5184],a[5185],a[5186],a[5187],a[5188],a[5189],a[5190],a[5191],a[5192]],[a[5193],a[5194],a[2510],a[2511]],[a[5195],a[5196],a[2510],a[2511]],[a[5197],a[5198],a[5199],a[5200],a[5201],a[5202],a[5203],a[5204],a[5205],a[5206],a[5207],a[5208],a[5209],a[5210],a[5211],a[5212],a[5213],a[5214],a[5215],a[5216],a[5217],a[5218],a[5219],a[5220],a[5221],a[5222],a[5223],a[5224],a[5225],a[5226],a[5227],a[5228],a[5229],a[5230],a[5231],a[5232],a[5233],a[5234],a[5235],a[5236],a[5237],a[5238],a[5239],a[5240],a[5241],a[5242],a[5243],a[5244],a[5245],a[5246],a[5247],a[5248],a[5249],a[5250],a[5251],a[5252],a[5253],a[5254],a[5255],a[5256],a[5257],a[5258],a[5259],a[5260],a[5261],a[5262],a[5263],a[5264],a[5265],a[5266],a[5267],a[5268],a[5269],a[5270],a[5271],a[5272],a[5273],a[5274],a[5275],a[5276],a[5277],a[5278],a[5279],a[5280],a[5281],a[5282],a[5283],a[5284],a[5285],a[5286],a[5287],a[5288],a[5289],a[5290],a[5291],a[5292],a[5293],a[5294],a[5295],a[5296],a[5297],a[5298],a[5299],a[5300],a[5301],a[5302],a[5303],a[5304],a[5305],a[5306],a[5307],a[5308],a[5309],a[5310],a[5311],a[5312],a[5313],a[5314],a[5315],a[5316],a[5317],a[5318],a[5319],a[5320],a[5321],a[5322],a[5323],a[5324],a[5325],a[5326],a[5327],a[5328],a[5329],a[5330],a[5331],a[5332],a[5333],a[5334],a[5335],a[5336],a[5337],a[5338],a[5339],a[5340],a[5341],a[5342],a[5343],a[5344],a[5345],a[5346],a[5347],a[5348],a[5349],a[5350],a[5351],a[5352],a[5353],a[5354],a[5355],a[5356],a[5357],a[5358],a[5359],a[5360],a[5361],a[5362],a[5363],a[5364],a[5365],a[5366],a[5367],a[5368],a[5369],a[5370],a[5371],a[5372],a[5373],a[5374],a[5375],a[5376],a[5377],a[5378],a[5379],a[5380],a[5381],a[5382],a[5383],a[5384],a[5385],a[5386],a[5387],a[5388],a[5389],a[5390],a[5391],a[5392],a[5393],a[5394],a[5395],a[5396],a[5397],a[5398],a[5399],a[5400],a[5401],a[5402],a[5403],a[5404],a[5405],a[5406],a[5407],a[5408],a[5409],a[5410],a[5411],a[5412],a[5413],a[5414],a[5415],a[5416],a[5417],a[5418],a[5419],a[5420],a[5421],a[5422],a[5423],a[5424],a[5425],a[5426],a[5427],a[5428],a[454],a[455],a[456],a[457]],{"BAM":a[1326],"XAF":a[503],"XOF":a[505]},{"XAF":a[503],"XOF":a[505]},{"E":a[16],"EHm":a[5429],"EHms":a[2781],"Ed":a[2065],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[2914],"GyMMMd":a[2828],"H":a[5430],"Hm":a[5431],"Hms":a[1657],"M":a[29],"MEd":a[2916],"MMM":a[31],"MMMEd":a[2917],"MMMd":a[2830],"Md":a[2919],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1523],"yMEd":a[1524],"yMMM":a[524],"yMMMEd":a[2920],"yMMMd":a[2832],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[1674],"long":a[1675],"medium":a[1657],"short":a[5431]},[a[2834],a[2835],a[3010],a[2837],a[5432],a[2838],a[2567],a[3012],a[2840],a[2841],a[3013],a[2842]],[a[3014],a[3015],a[3016],a[3017],a[5433],a[3019],a[3020],a[3021],a[3022],a[3023],a[3024],a[3025]],[a[602],a[3026],a[3027],a[605],a[5434],a[3026],a[605]],[a[1472],a[3028],a[5435],a[3030],a[5436],a[5437],a[3033]],[a[5438],a[5439],a[5440],a[5441],a[5442],a[5443],a[2771]],{"am":a[3040],"pm":a[5444]},[a[5445],a[5446],a[5447],a[5448]],[a[5449],a[5450],a[5451],a[5452]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[5453],"Ehm":a[20],"Ehms":a[21],"Gy":a[5454],"GyMMM":a[5455],"GyMMMEd":a[5456],"GyMMMd":a[5457],"H":a[451],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[5458],"MMM":a[31],"MMMEd":a[5459],"MMMMd":a[5460],"MMMd":a[5461],"Md":a[5462],"d":a[35],"h":a[5463],"hm":a[5464],"hms":a[5465],"mmss":a[39],"ms":a[39],"y":a[2077],"yM":a[5466],"yMEd":a[5467],"yMMM":a[5468],"yMMMEd":a[5469],"yMMMM":a[5470],"yMMMd":a[5471],"yMd":a[5472],"yQQQ":a[5473],"yQQQQ":a[5474]},{"full":a[5475],"long":a[5476],"medium":a[5471],"short":a[5472]},[a[534],a[535],a[450],a[5477],a[450],a[534],a[534],a[58],a[5478],a[536],a[56],a[60]],[a[2834],a[2562],a[5479],a[5480],a[5481],a[5482],a[5483],a[2839],a[5484],a[2841],a[2571],a[2842]],[a[5485],a[5486],a[5487],a[5488],a[5489],a[5490],a[5491],a[5492],a[5493],a[5494],a[2846],a[2847]],[a[560],a[451],a[62],a[5478],a[5495],a[1338],a[5478]],[a[560],a[451],a[62],a[5496],a[5495],a[1338],a[5497]],[a[5498],a[5499],a[5500],a[5501],a[5502],a[5503],a[5504]],[a[653]],{"am":a[5505],"pm":a[5506]},[a[5507],a[5508],a[163],a[164]],[a[5509],a[5510],a[163],a[164]],[a[5511],a[5512],a[5509],a[5510]],[a[5513],a[5514],a[5515],a[5516],a[5517],a[5518],a[5519],a[5520],a[5521],a[5522],a[175],a[5523],a[177],a[5524]],[a[5525]],[a[5526],a[194],a[5527],a[5528],a[5529],a[5530],a[5531],a[5532],a[201],a[5533],a[5534],a[5535]],[a[5536],a[206],a[5537],a[5538],a[5539],a[5540],a[5541],a[5542],a[5543],a[5544],a[5545],a[5546]],[a[5547]],[a[5548],a[472]],{"JPY":a[1381],"XAF":a[503],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[5549],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[5550],"GyMMM":a[5551],"GyMMMEd":a[5552],"GyMMMd":a[5553],"H":a[451],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[1415],"MMM":a[31],"MMMEd":a[1416],"MMMd":a[519],"Md":a[1384],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1385],"yMEd":a[5554],"yMMM":a[5555],"yMMMEd":a[5556],"yMMMd":a[5557],"yMd":a[1389],"yQQQ":a[5558],"yQQQQ":a[5559]},{"full":a[5560],"long":a[5561],"medium":a[5562],"short":a[1391]},{"full":a[5563],"long":a[5564],"medium":a[1657],"short":a[1656]},[a[5565],a[5566],a[5567],a[5568],a[5567],a[5565],a[5565],a[5569],a[5570],a[5565],a[5571],a[5572]],[a[5573],a[5574],a[5575],a[5576],a[5577],a[5578],a[5579],a[5580],a[5581],a[5582],a[5583],a[5584]],[a[5585],a[5586],a[5587],a[5588],a[5589],a[5590],a[5591],a[5592],a[5593],a[5594],a[5595],a[5596]],[a[5597],a[5598],a[5598],a[5599],a[5565],a[5600],a[5601]],[a[5602],a[5603],a[5604],a[5605],a[5606],a[5607],a[5608]],[a[5609],a[5610],a[5611],a[5612],a[5613],a[5614],a[5615]],{"am":a[5616],"pm":a[5617]},[a[5618],a[5619],a[5620],a[164]],[a[5618],a[5619],a[5621],a[5622]],{"AMD":a[5623],"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[2474],a[1340],a[1341],a[1422],a[3598],a[2476],a[2477],a[2478],a[2479],a[3565],a[2480],a[2481]],[a[5624],a[5625],a[5626],a[2484],a[4469],a[3462],a[3463],a[5627],a[4031],a[4032],a[2580],a[5628]],[a[1363],a[3567],a[1341],a[5629],a[5630],a[4476],a[1368]],[a[5631],a[5632],a[5633],a[5634],a[5635],a[5636],a[5637]],[a[5638],a[5639],a[163],a[164]],[a[5640],a[5641],a[163],a[164]],{"E":a[16],"EHm":a[2822],"EHms":a[2823],"Ed":a[1646],"Ehm":a[2825],"Ehms":a[2826],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[1516],"Hms":a[1517],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[1521],"hms":a[1255],"ms":a[1522],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[525],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[591],"long":a[531],"medium":a[527],"short":a[52]},[a[1293],a[1294],a[2970],a[540],a[541],a[542],a[543],a[4575],a[545],a[546],a[547],a[548]],[a[1298],a[1299],a[5642],a[552],a[541],a[1302],a[2927],a[5643],a[556],a[557],a[558],a[559]],[a[450],a[90],a[90],a[590],a[62],a[534],a[90]],[a[5644],a[5645],a[5646],a[5647],a[95],a[2898],a[97]],[a[5648],a[5649],a[5650],a[5651],a[5652],a[5653],a[5654]],[a[5655],a[450],a[5656],a[5657]],[a[5658],a[450],a[5659],a[5660]],[a[193],a[194],a[195],a[196],a[197],a[198],a[199],a[200],a[201],a[5661],a[203],a[204]],[a[205],a[206],a[207],a[208],a[209],a[210],a[211],a[5662],a[5663],a[5664],a[215],a[216]],[a[218],a[219],a[220],a[221],a[222],a[223],a[224],a[225],a[226],a[227],a[228],a[229],a[230],a[231],a[232],a[233],a[234],a[235],a[236],a[237],a[238],a[239],a[240],a[241],a[242],a[243],a[244],a[245],a[246],a[247],a[248],a[249],a[250],a[251],a[252],a[253],a[254],a[255],a[256],a[257],a[258],a[259],a[260],a[261],a[262],a[263],a[264],a[265],a[266],a[267],a[268],a[269],a[270],a[271],a[272],a[273],a[274],a[275],a[276],a[277],a[278],a[279],a[280],a[281],a[282],a[283],a[284],a[285],a[286],a[287],a[288],a[289],a[290],a[291],a[292],a[293],a[294],a[295],a[296],a[297],a[298],a[299],a[300],a[301],a[302],a[303],a[304],a[305],a[306],a[307],a[308],a[309],a[310],a[311],a[312],a[313],a[314],a[315],a[316],a[317],a[318],a[319],a[320],a[321],a[322],a[323],a[324],a[325],a[326],a[327],a[328],a[329],a[330],a[331],a[332],a[333],a[334],a[335],a[336],a[337],a[338],a[339],a[340],a[341],a[342],a[343],a[344],a[345],a[346],a[347],a[348],a[349],a[350],a[351],a[352],a[353],a[354],a[355],a[356],a[357],a[358],a[359],a[360],a[361],a[362],a[363],a[364],a[365],a[366],a[367],a[368],a[369],a[370],a[371],a[372],a[373],a[374],a[375],a[376],a[377],a[378],a[379],a[380],a[381],a[382],a[383],a[384],a[385],a[386],a[387],a[388],a[389],a[390],a[391],a[392],a[393],a[394],a[395],a[396],a[397],a[398],a[399],a[400],a[401],a[402],a[403],a[404],a[405],a[406],a[407],a[408],a[409],a[410],a[411],a[412],a[413],a[414],a[415],a[416],a[417],a[418],a[419],a[420],a[421],a[422],a[423],a[424],a[425],a[426],a[427],a[428],a[429],a[430],a[431],a[432],a[433],a[434],a[435],a[436],a[437],a[438],a[439],a[440],a[441],a[442],a[443],a[444],a[445],a[446],a[447],a[448],a[449],a[454],a[455],a[456],a[457]],[a[5665],a[472]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"IDR":a[5666],"ILS":a[494],"INR":a[3432],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"UYU":a[5667],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[5668],a[1294],a[3221],a[1584],a[3107],a[5669],a[543],a[5670],a[545],a[5671],a[547],a[1586]],[a[5672],a[5673],a[5674],a[5675],a[3107],a[5676],a[5677],a[5678],a[1305],a[5679],a[1307],a[1589]],[a[5680],a[5681],a[5682],a[5683],a[5684],a[5685],a[1810]],[a[5686],a[5687],a[5688],a[5689],a[5690],a[5691],a[5692]],{"am":a[1994],"pm":a[5693]},[a[5694],a[5695],a[163],a[164]],[a[5696],a[5697],a[163],a[164]],[a[5698],a[5699],a[5700],a[5701],a[5702],a[5703],a[5704],a[5705],a[5706],a[5707],a[5708],a[5709]],[a[5710],a[5711],a[5712],a[5713],a[5714],a[5715],a[5716]],[a[5717],a[5718],a[5719],a[5720],a[5721],a[5722],a[5723]],[a[5724],a[5725],a[5726],a[5727],a[5728],a[5729],a[5730]],{"am":a[5731],"pm":a[5732]},[a[5733],a[5734],a[163],a[164]],{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[2718],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[2914],"GyMMMd":a[2828],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[2916],"MMM":a[31],"MMMEd":a[2917],"MMMMEd":a[2465],"MMMMd":a[2466],"MMMd":a[2830],"Md":a[2919],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[5735],"yMEd":a[1524],"yMMM":a[524],"yMMMEd":a[2920],"yMMMM":a[526],"yMMMd":a[2832],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2963],"long":a[2730],"medium":a[2832],"short":a[1527]},[a[534],a[535],a[450],a[58],a[450],a[534],a[534],a[5477],a[90],a[536],a[56],a[60]],[a[2834],a[2835],a[2836],a[2837],a[5736],a[5482],a[5483],a[5737],a[2840],a[2841],a[5738],a[2572]],[a[5739],a[5740],a[3990],a[3991],a[5736],a[5741],a[5742],a[5743],a[2844],a[5494],a[5744],a[3992]],[a[90],a[450],a[5745],a[450],a[535],a[535],a[29]],[a[5746],a[5747],a[5748],a[5749],a[5750],a[5751],a[5752]],[a[4000],a[5753],a[5754],a[5755],a[5756],a[5757],a[5758]],{"am":a[5759],"pm":a[5760]},[a[5761],a[5762],a[4009],a[4010]],[a[4013],a[4014],a[5763],a[5764]],{"CNY":a[488],"HKD":a[493],"ILS":a[494],"JPY":a[496],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[26],"HHmm":a[27],"HHmmss":a[28],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"MMdd":a[1384],"Md":a[595],"d":a[35],"h":a[36],"hhmm":a[2075],"hhmmss":a[2076],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[598],"yMM":a[1385],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[531],"medium":a[5765],"short":a[1391]},[a[89],a[535],a[450],a[58],a[450],a[89],a[29],a[58],a[90],a[536],a[56],a[60]],[a[5766],a[1340],a[1341],a[1422],a[5767],a[5768],a[5769],a[1346],a[1347],a[5770],a[2480],a[3566]],[a[5771],a[5772],a[3514],a[5773],a[5774],a[5775],a[5776],a[3516],a[5777],a[5778],a[2580],a[5779]],[a[60],a[29],a[450],a[450],a[89],a[560],a[90]],[a[1363],a[3567],a[1341],a[5629],a[5780],a[4476],a[1368]],[a[5781],a[5782],a[5783],a[5784],a[5785],a[5786],a[3482]],[a[5787]],[a[2606],a[2607],a[163],a[164]],[a[5788],a[2872]],{"AUD":a[485],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"ILS":a[494],"INR":a[495],"NZD":a[499],"THB":a[589],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[598],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[592],"short":a[52]},{"E":a[16],"EEEEd":a[5789],"EHm":a[5790],"EHms":a[5791],"Ed":a[5792],"Ehm":a[5793],"Ehms":a[5794],"Gy":a[5795],"GyMMM":a[5796],"GyMMMEEEEd":a[5797],"GyMMMEd":a[5798],"GyMMMd":a[5799],"H":a[5800],"Hm":a[1656],"Hms":a[1657],"M":a[5801],"MEEEEd":a[5802],"MEd":a[5803],"MMM":a[5801],"MMMEEEEd":a[5804],"MMMEd":a[5805],"MMMd":a[5806],"Md":a[662],"d":a[5807],"h":a[5808],"hm":a[5809],"hms":a[5810],"ms":a[39],"y":a[5811],"yM":a[1217],"yMEEEEd":a[5812],"yMEd":a[5813],"yMM":a[1218],"yMMM":a[5814],"yMMMEEEEd":a[5815],"yMMMEd":a[5816],"yMMMd":a[5817],"yMd":a[665],"yQQQ":a[5818],"yQQQQ":a[5819]},{"full":a[5815],"long":a[5817],"medium":a[1219],"short":a[1219]},{"full":a[5820],"long":a[1675],"medium":a[1657],"short":a[1656]},[a[5821],a[5822],a[5823],a[5824],a[5825],a[5826],a[5827],a[5828],a[5829],a[5830],a[5831],a[5832]],[a[5833],a[5834],a[5835],a[5836],a[5837],a[5838],a[5839]],[a[5840],a[5841],a[5842],a[5843],a[5844],a[5845],a[5846]],[a[5847]],{"am":a[5848],"pm":a[5849]},[a[5850],a[5851],a[5852],a[5853],a[5854],a[5855],a[5856],a[5857],a[5858],a[5859],a[5860],a[5861]],[a[5862],a[5863],a[5864],a[5865],a[5866],a[5867],a[5868],a[5869],a[5870],a[5871],a[5872],a[5873]],[a[5874],a[5875],a[5876],a[5877],a[5878],a[5879],a[5880],a[5881],a[5882],a[5883],a[5884],a[5885],a[5886]],[a[5887],a[5888],a[5889],a[5890],a[5891],a[5892],a[5893],a[5894],a[5895],a[5896],a[5897],a[5898],a[5899]],[a[5900],a[5901],a[5902],a[5903]],[a[5904],a[5905],a[5906],a[5907],a[5908],a[5909],a[5910],a[5911],a[5912],a[5913],a[5914],a[5915],a[5916],a[5917]],[a[5918],a[5919],a[5920],a[5921],a[5922],a[5923],a[5924],a[5925],a[5926],a[5927],a[5928],a[5929]],[a[5930]],[a[5931],a[5932],a[5933],a[5934],a[5935],a[5936],a[5937],a[5938],a[5939],a[5940],a[5941],a[5942]],[a[5943],a[5944],a[5945],a[5946],a[5947],a[5948],a[5949],a[5950],a[5951],a[5952],a[5953],a[5954],a[5955],a[5956],a[5957],a[5958],a[5959],a[5960],a[5961],a[5962],a[5963],a[5964],a[5965],a[5966],a[5967],a[5968],a[5969],a[5970],a[5971],a[5972],a[5973],a[5974],a[5975],a[5976],a[5977],a[5978],a[5979],a[5980],a[5981],a[5982],a[5983],a[5984],a[5985],a[5986],a[5987],a[5988],a[5989],a[5990],a[5991],a[5992],a[5993],a[5994],a[5995],a[5996],a[5997],a[5998],a[5999],a[6000],a[6001],a[6002],a[6003],a[6004],a[6005],a[6006],a[6007],a[6008],a[6009],a[6010],a[6011],a[6012],a[6013],a[6014],a[6015],a[6016],a[6017],a[6018],a[6019],a[6020],a[6021],a[6022],a[6023],a[6024],a[6025],a[6026],a[6027],a[6028],a[6029],a[6030],a[6031],a[6032],a[6033],a[6034],a[6035],a[6036],a[6037],a[6038],a[6039],a[6040],a[6041],a[6042],a[6043],a[6044],a[6045],a[6046],a[6047],a[6048],a[6049],a[6050],a[6051],a[6052],a[6053],a[6054],a[6055],a[6056],a[6057],a[6058],a[6059],a[6060],a[6061],a[6062],a[6063],a[6064],a[6065],a[6066],a[6067],a[6068],a[6069],a[6070],a[6071],a[6072],a[6073],a[6074],a[6075],a[6076],a[6077],a[6078],a[6079],a[6080],a[6081],a[6082],a[6083],a[6084],a[6085],a[6086],a[6087],a[6088],a[6089],a[6090],a[6091],a[6092],a[6093],a[6094],a[6095],a[6096],a[6097],a[6098],a[6099],a[6100],a[6101],a[6102],a[6103],a[6104],a[6105],a[6106],a[6107],a[6108],a[6109],a[6110],a[6111],a[6112],a[6113],a[6114],a[6115],a[6116],a[6117],a[6118],a[6119],a[6120],a[6121],a[6122],a[6123],a[6124],a[6125],a[6126],a[6127],a[6128],a[6129],a[6130],a[6131],a[6132],a[6133],a[6134],a[6135],a[6136],a[6137],a[6138],a[6139],a[6140],a[6141],a[6142],a[6143],a[6144],a[6145],a[6146],a[6147],a[6148],a[6149],a[6150],a[6151],a[6152],a[6153],a[6154],a[6155],a[6156],a[6157],a[6158],a[6159],a[6160],a[6161],a[6162],a[6163],a[6164],a[6165],a[6166],a[6167],a[6168],a[6169],a[6170],a[6171],a[6172],a[6173],a[6174],a[450],a[88],a[90],a[451]],[a[5943],a[5944],a[5945],a[5946],a[5947],a[5948],a[5949],a[5950],a[5951],a[5952],a[5953],a[5954],a[5955],a[5956],a[5957],a[5958],a[5959],a[5960],a[5961],a[5962],a[5963],a[5964],a[5965],a[5966],a[5967],a[5968],a[5969],a[5970],a[5971],a[5972],a[5973],a[5974],a[5975],a[5976],a[5977],a[5978],a[5979],a[5980],a[5981],a[5982],a[5983],a[5984],a[5985],a[5986],a[5987],a[5988],a[5989],a[5990],a[5991],a[5992],a[5993],a[5994],a[5995],a[5996],a[5997],a[5998],a[5999],a[6000],a[6001],a[6002],a[6003],a[6004],a[6005],a[6006],a[6007],a[6008],a[6009],a[6010],a[6011],a[6012],a[6013],a[6014],a[6015],a[6016],a[6017],a[6018],a[6019],a[6020],a[6021],a[6022],a[6023],a[6024],a[6025],a[6026],a[6027],a[6028],a[6029],a[6030],a[6031],a[6032],a[6033],a[6034],a[6035],a[6036],a[6037],a[6038],a[6039],a[6040],a[6041],a[6042],a[6043],a[6044],a[6045],a[6046],a[6047],a[6048],a[6049],a[6050],a[6051],a[6052],a[6053],a[6054],a[6055],a[6056],a[6057],a[6058],a[6059],a[6060],a[6061],a[6062],a[6063],a[6064],a[6065],a[6066],a[6067],a[6068],a[6069],a[6070],a[6071],a[6072],a[6073],a[6074],a[6075],a[6076],a[6077],a[6078],a[6079],a[6080],a[6081],a[6082],a[6083],a[6084],a[6085],a[6086],a[6087],a[6088],a[6089],a[6090],a[6091],a[6092],a[6093],a[6094],a[6095],a[6096],a[6097],a[6098],a[6099],a[6100],a[6101],a[6102],a[6103],a[6104],a[6105],a[6106],a[6107],a[6108],a[6109],a[6110],a[6111],a[6112],a[6113],a[6114],a[6115],a[6116],a[6117],a[6118],a[6119],a[6120],a[6121],a[6122],a[6123],a[6124],a[6125],a[6126],a[6127],a[6128],a[6129],a[6130],a[6131],a[6132],a[6133],a[6134],a[6135],a[6136],a[6137],a[6138],a[6139],a[6140],a[6141],a[6142],a[6143],a[6144],a[6145],a[6146],a[6147],a[6148],a[6149],a[6150],a[6151],a[6152],a[6153],a[6154],a[6155],a[6156],a[6157],a[6158],a[6159],a[6160],a[6161],a[6162],a[6163],a[6164],a[6165],a[6166],a[6167],a[6168],a[6169],a[6170],a[6171],a[6172],a[6173],a[6174],a[6175],a[6176],a[6177],a[6178]],[a[6179],a[6180],a[6181],a[6182],a[6183],a[6184],a[6185],a[6186],a[6187],a[6188],a[6189],a[6190]],[a[6191],a[6192]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[6193],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[6194],"KRW":a[6195],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1518],"MMM":a[31],"MMMEd":a[32],"MMMd":a[33],"Md":a[1520],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[43],"yMMMEd":a[44],"yMMMd":a[45],"yMd":a[6196],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[666],"long":a[667],"medium":a[45],"short":a[46]},[a[6197],a[6198],a[6199],a[6200],a[6201],a[6202],a[6203],a[6204],a[6205],a[6206],a[6207],a[6208]],[a[6209],a[6210],a[6211],a[6212],a[6213],a[6214],a[6215]],[a[6216],a[6217],a[6218],a[6219],a[6220],a[6221],a[6222]],{"am":a[6223],"pm":a[6224]},[a[6225],a[6226],a[163],a[164]],[a[1293],a[1294],a[1295],a[540],a[541],a[542],a[543],a[1296],a[545],a[546],a[547],a[548]],[a[1298],a[1299],a[1300],a[6227],a[541],a[6228],a[6229],a[6230],a[1305],a[1306],a[1307],a[1308]],[a[1310],a[1311],a[1312],a[1313],a[1314],a[6231],a[1316]],[a[6232],a[6233],a[1319],a[6234],a[1321],a[1322],a[1323]],{"am":a[6235],"pm":a[6236]},[a[6237],a[6238],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[6239],"GyMMMEd":a[1811],"GyMMMd":a[1812],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1518],"MMM":a[31],"MMMEd":a[1333],"MMMd":a[519],"Md":a[1520],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1523],"yMEd":a[1524],"yMMM":a[1387],"yMMMEd":a[1814],"yMMMd":a[601],"yMd":a[1527],"yQQQ":a[6240],"yQQQQ":a[6241]},{"full":a[6242],"long":a[1250],"medium":a[601],"short":a[1391]},[a[6243],a[6244],a[6245],a[6246],a[6245],a[6243],a[6243],a[6246],a[6247],a[6248],a[6249],a[6250]],[a[6251],a[6252],a[6253],a[6254],a[6255],a[6256],a[6257],a[6258],a[6259],a[6260],a[6261],a[6262]],[a[6263],a[6264],a[6265],a[6266],a[6267],a[6268],a[6269],a[6270],a[6271],a[6272],a[6273],a[6274]],[a[6275],a[6248],a[6247],a[6248],a[6276],a[6277],a[6278]],[a[6279],a[6280],a[6281],a[6282],a[6283],a[6284],a[6285]],[a[6286],a[6287],a[6288],a[6289],a[6290],a[6291],a[6292]],[a[6293],a[6294],a[163],a[164]],[a[6295],a[6296],a[6297],a[6298]],[a[6299],a[6300],a[6301],a[6302],a[6303],a[6304],a[6305],a[6306],a[6307],a[6308],a[6309],a[6310],a[6311],a[6312]],[a[6313],a[6314],a[6315],a[6316],a[6317],a[6318],a[6319],a[6320],a[6321],a[6322],a[6323],a[6324]],[a[6325],a[6326],a[6327],a[6328],a[6329],a[6330],a[6331],a[6332],a[6333],a[6334],a[6335],a[6336]],[a[6337],a[6338],a[6339],a[6340],a[6341],a[6342],a[6343],a[6344],a[6345],a[6346],a[6347],a[6348]],{"decimal":a[481],"group":a[587],"nan":a[6349],"percent":a[483],"infinity":a[484]},{"BRL":a[486],"CAD":a[487],"EUR":a[491],"GBP":a[492],"MXN":a[498],"TWD":a[500],"USD":a[501],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[694],a[535],a[450],a[694],a[450],a[694],a[694],a[6350],a[57],a[88],a[56],a[60]],[a[6351],a[6352],a[6353],a[6354],a[3366],a[4640],a[4641],a[6355],a[6356],a[6357],a[6358],a[6359]],[a[6360],a[6361],a[6362],a[6363],a[6364],a[6365],a[6366],a[6367],a[6368],a[6369],a[6370],a[6371]],[a[694],a[90],a[62],a[62],a[90],a[90],a[90]],[a[6372],a[6373],a[6374],a[6375],a[6376],a[6377],a[6378]],[a[6379],a[6380],a[6381],a[6382],a[6383],a[6384],a[6385]],{"am":a[6386],"pm":a[6387]},[a[6388],a[6389],a[163],a[164]],[a[6390],a[6391],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"DZD":a[4246],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[450],a[62],a[62],a[62],a[62],a[88],a[450],a[56],a[62],a[6392],a[6392],a[6392]],[a[3195],a[6393],a[6394],a[2877],a[6395],a[6396],a[6397],a[6398],a[6399],a[6400],a[6401],a[6402]],[a[6403],a[6404],a[6405],a[6406],a[6407],a[6408],a[6409],a[6410],a[6411],a[6412],a[6413],a[6414]],[a[694],a[59],a[87],a[58],a[58],a[58],a[58]],[a[6415],a[6416],a[6417],a[6418],a[6419],a[6420],a[6421]],[a[6422],a[6423],a[6424],a[6425],a[6426],a[6427],a[6428]],{"am":a[6429],"pm":a[6430]},[a[6431],a[6432],a[163],a[164]],[a[6433],a[6434],a[163],a[164]],[a[6435],a[6436],a[6437],a[6438],a[6439],a[6440],a[6441],a[6442],a[6443],a[6444],a[6445],a[6446]],[a[109],a[110],a[111],a[112],a[113],a[114],a[108]],[a[6447],a[6448],a[6449],a[6450],a[6451],a[6452],a[6453]],[a[6454],a[6455],a[6456],a[6457],a[6458],a[6459],a[6460]],{"am":a[6461],"pm":a[6462]},[a[6463],a[6464],a[163],a[164]],[a[6465],a[6466],a[163],a[164]],{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[1646],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[6467],"GyMMMEd":a[6468],"GyMMMd":a[6469],"H":a[26],"HHmm":a[27],"HHmmss":a[28],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[6470],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[6471],"MMMMd":a[4250],"MMMd":a[519],"MMdd":a[1760],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"mmss":a[39],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[3419],"yMM":a[1761],"yMMM":a[6472],"yMMMEd":a[525],"yMMMM":a[6473],"yMMMd":a[527],"yMd":a[721],"yQQQ":a[528],"yQQQQ":a[6474]},{"full":a[6475],"long":a[6476],"medium":a[527],"short":a[600]},[a[1293],a[1294],a[2970],a[3960],a[2791],a[542],a[543],a[1296],a[3963],a[4260],a[6477],a[6478]],[a[6479],a[6480],a[6481],a[3968],a[6482],a[6483],a[6484],a[6485],a[6486],a[6487],a[6488],a[6489]],[a[60],a[90],a[88],a[62],a[62],a[90],a[90]],[a[616],a[6490],a[4106],a[6491],a[6492],a[6493],a[1368]],[a[6494],a[6495],a[6496],a[6497],a[6498],a[6499],a[6500]],[a[711],a[6501],a[6502],a[6503]],[a[6504],a[6505],a[6506],a[6507]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"CVE":a[6508],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[451],a[88],a[88],a[29],a[29],a[29],a[90]],[a[1314],a[2989],a[2990],a[2991],a[2992],a[6509],a[6510]],[a[2995],a[6511],a[6512],a[2998],a[6513],a[6514],a[6515]],{"am":a[6516],"pm":a[6517]},[a[3005],a[6518],a[163],a[164]],[a[534],a[62],a[89],a[62],a[89],a[89],a[450],a[62],a[62],a[1309],a[1309],a[60]],[a[6519],a[6520],a[6521],a[6522],a[6523],a[6524],a[6525],a[6526],a[6527],a[6528],a[6529],a[6530]],[a[6531],a[6532],a[6533],a[6534],a[6535],a[6536],a[6537],a[6538],a[6539],a[6540],a[6541],a[6542]],[a[62],a[56],a[56],a[56],a[58],a[56],a[56]],[a[6543],a[6544],a[6545],a[6546],a[6547],a[6548],a[3222]],[a[3223],a[6549],a[3225],a[6550],a[3227],a[3228],a[6551]],{"am":a[6552],"pm":a[6553]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3548],"MMM":a[31],"MMMEd":a[1333],"MMMd":a[519],"Md":a[521],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[522],"yMEd":a[6554],"yMMM":a[524],"yMMMEd":a[525],"yMMMd":a[527],"yMd":a[1251],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[720],"long":a[531],"medium":a[6555],"short":a[52]},[a[6556],a[6557],a[6558],a[6559],a[6560],a[6560],a[6561],a[6562],a[6556],a[6556],a[6556],a[6563]],[a[6564],a[6565],a[6566],a[6567],a[6568],a[6569],a[6570],a[6571],a[6572],a[6573],a[6574],a[6575]],[a[6576],a[6577],a[6578],a[6579],a[6580],a[6581],a[6582],a[6583],a[6584],a[6585],a[6586],a[6587]],[a[6563],a[6588],a[6559],a[6559],a[6589],a[6563],a[6559]],[a[6590],a[6591],a[6592],a[6593],a[6594],a[6595],a[6596]],[a[6597],a[6598],a[6599],a[6600],a[6601],a[6595],a[6602]],{"am":a[6603],"pm":a[6604]},[a[6605],a[6606],a[163],a[6607]],[a[6608],a[6609],a[163],a[6610]],{"AUD":a[485],"BMD":a[6611],"BRL":a[486],"CAD":a[6612],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"KZT":a[6613],"MXN":a[498],"NZD":a[499],"RUB":a[1756],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1950],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"Md":a[1760],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[6614],"yMEd":a[6615],"yMMM":a[524],"yMMMEd":a[599],"yMMMd":a[527],"yMd":a[6616],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[3421],"long":a[531],"medium":a[527],"short":a[6616]},[a[6617],a[6618],a[6619],a[6620],a[6621],a[6622],a[6623],a[6624],a[6625],a[6626],a[118],a[6627]],[a[2764],a[3470],a[3471],a[1767],a[6628],a[6629],a[6630]],[a[6631],a[4040],a[4041],a[6632],a[6633],a[6634],a[6635]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[1646],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[32],"MMMd":a[33],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[3423],"yMMM":a[524],"yMMMEd":a[664],"yMMMd":a[1237],"yMd":a[46],"yQQQ":a[48],"yQQQQ":a[48]},{"full":a[3421],"long":a[50],"medium":a[4602],"short":a[46]},[a[6636],a[6637],a[6638],a[6639],a[6640],a[2485],a[2486],a[6641],a[6642],a[6643],a[6644],a[6645]],[a[90],a[58],a[450],a[1338],a[90],a[88],a[58]],[a[1368],a[6646],a[1341],a[6647],a[6648],a[6649],a[6650]],[a[6651],a[6652],a[6653],a[6654],a[6655],a[6656],a[6657]],{"am":a[6658],"pm":a[6659]},[a[6660],a[6661],a[2868],a[2869]],[a[6662],a[6663],a[2868],a[2869]],[a[6664],a[6665],a[2870],a[2871]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"DKK":a[2873],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NOK":a[6666],"NZD":a[499],"SEK":a[6667],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[450],a[56],a[62],a[1309],a[56],a[59],a[590],a[62],a[693],a[87],a[62],a[62]],[a[1626],a[6668],a[6669],a[6670],a[6671],a[6672],a[6673],a[6674],a[6675],a[6676],a[1606],a[6677]],[a[6678],a[6679],a[6680],a[6681],a[6682],a[6683],a[6684],a[6685],a[6686],a[6687],a[6688],a[6689]],[a[88],a[88],a[58],a[90],a[58],a[450],a[29]],[a[1610],a[1606],a[6677],a[6690],a[6691],a[6692],a[6693]],[a[6694],a[6695],a[6696],a[6697],a[6698],a[6699],a[6700]],{"am":a[6701],"pm":a[6702]},[a[179],a[6703],a[163],a[164]],[a[6704],a[6705],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[6706],"GyMMM":a[6707],"GyMMMEd":a[6708],"GyMMMd":a[6709],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[517],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"Md":a[4283],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[3545],"yMEd":a[4284],"yMMM":a[524],"yMMMEd":a[599],"yMMMd":a[527],"yMd":a[1252],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[527],"short":a[1337]},[a[6710],a[6711],a[6712],a[6713],a[6714],a[6715],a[6716],a[6717],a[6718],a[6719],a[6720],a[6721]],[a[108],a[109],a[110],a[111],a[112],a[113],a[114]],[a[6722],a[6723],a[6724],a[6725],a[6726],a[6727],a[6728]],[a[6729]],{"am":a[6730],"pm":a[6731]},[a[6732],a[6733],a[163],a[164]],[a[6734],a[6735],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KHR":a[6736],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[6737],"MMM":a[31],"MMMEd":a[1333],"MMMMd":a[813],"MMMd":a[33],"MMdd":a[521],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[663],"yMM":a[522],"yMMM":a[524],"yMMMEd":a[664],"yMMMM":a[526],"yMMMd":a[6738],"yMd":a[2659],"yQQQ":a[528],"yQQQQ":a[529]},[a[6739],a[6740],a[6741],a[6742],a[6743],a[6744],a[6745],a[6746],a[6747],a[6748],a[6749],a[6750]],[a[6751],a[6752],a[6753],a[6754],a[6743],a[6755],a[6756],a[6757],a[6758],a[6759],a[6760],a[6761]],[a[6762],a[6763],a[6753],a[6764],a[6743],a[6755],a[6756],a[6765],a[6766],a[6767],a[6768],a[6769]],[a[6770],a[6771],a[6772],a[6773],a[6774],a[6775],a[6776]],[a[6777],a[6778],a[6779],a[6780],a[6781],a[6782],a[6783]],[a[6784],a[6785],a[6786],a[6787],a[6788],a[6789],a[6790]],{"am":a[6791],"pm":a[6792]},[a[6793],a[6794],a[6795],a[6796]],[a[6797],a[6798],a[6795],a[6796]],{"E":a[16],"EEEEd":a[6799],"EHm":a[6800],"EHms":a[6801],"Ed":a[6802],"Ehm":a[6803],"Ehms":a[6804],"Gy":a[6805],"GyMMM":a[6806],"GyMMMEEEEd":a[6807],"GyMMMEd":a[6808],"GyMMMd":a[6809],"H":a[6810],"HHmmss":a[28],"Hm":a[27],"Hms":a[6811],"M":a[6812],"MEEEEd":a[6813],"MEd":a[6814],"MMM":a[31],"MMMEEEEd":a[6815],"MMMEd":a[6816],"MMMd":a[6817],"Md":a[5462],"d":a[6818],"h":a[6819],"hm":a[5464],"hms":a[5465],"mmss":a[39],"ms":a[39],"y":a[6820],"yM":a[5466],"yMEEEEd":a[6821],"yMEd":a[6822],"yMM":a[5466],"yMMM":a[6823],"yMMMEEEEd":a[6824],"yMMMEd":a[6825],"yMMMd":a[6826],"yMd":a[6827],"yQQQ":a[6828],"yQQQQ":a[6829]},{"full":a[6830],"long":a[6831],"medium":a[6827],"short":a[6832]},{"full":a[6833],"long":a[6834],"medium":a[5465],"short":a[5464]},[a[6835],a[6836],a[6837],a[6838],a[6839],a[6840],a[6841],a[6842],a[6843],a[6844],a[6845],a[6846]],[a[6847],a[6848],a[6849],a[6850],a[6851],a[6852],a[6853]],[a[6854],a[6855],a[6856],a[6857],a[6858],a[6859],a[6860]],[a[6861]],{"am":a[6862],"pm":a[6863]},[a[6864],a[6865],a[6866],a[6867],a[6868],a[6869],a[6870],a[6871],a[6872],a[6873],a[6874],a[6875],a[6876]],[a[6877],a[6878],a[6879],a[6880],a[6881],a[6882],a[6883],a[6884],a[6885],a[6886],a[6887],a[6888],a[6889]],[a[6890],a[6891],a[163],a[164]],[a[6892],a[6893],a[6894],a[6895],a[6896],a[6897],a[6898],a[6899],a[6900],a[6901],a[6902],a[6903],a[6904],a[6905]],[a[6906],a[6907],a[6908],a[6909],a[6910],a[6911],a[6912],a[6913],a[6914],a[6915],a[6916],a[6917],a[6918],a[6919],a[6920],a[6921],a[6922],a[6923],a[6924],a[6925],a[6926],a[6927],a[6928],a[6929],a[6930],a[6931],a[6932],a[6933],a[6934],a[6935],a[6936],a[6937],a[6938],a[6939],a[6940],a[6941],a[6942],a[6943],a[6944],a[6945],a[6946],a[6947],a[6948],a[6949],a[6950],a[6951],a[6952],a[6953],a[6954],a[6955],a[6956],a[6957],a[6958],a[6959],a[6960],a[6961],a[6962],a[6963],a[6964],a[6965],a[6966],a[6967],a[6968],a[6969],a[6970],a[6971],a[6972],a[6973],a[6974],a[6975],a[6976],a[6977],a[6978],a[6979],a[6980],a[6981],a[6982],a[6983],a[6984],a[6985],a[6986],a[6987],a[6988],a[6989],a[6990],a[6991],a[6992],a[6993],a[6994],a[6995],a[6996],a[6997],a[6998],a[6999],a[7000],a[7001],a[7002],a[7003],a[7004],a[7005],a[7006],a[7007],a[7008],a[7009],a[7010],a[7011],a[7012],a[7013],a[7014],a[7015],a[7016],a[7017],a[7018],a[7019],a[7020],a[7021],a[7022],a[7023],a[7024],a[7025],a[7026],a[7027],a[7028],a[7029],a[7030],a[7031],a[7032],a[7033],a[7034],a[7035],a[7036],a[7037],a[7038],a[7039],a[7040],a[7041],a[7042],a[7043],a[7044],a[7045],a[7046],a[7047],a[7048],a[7049],a[7050],a[7051],a[7052],a[7053],a[7054],a[7055],a[7056],a[7057],a[7058],a[7059],a[7060],a[7061],a[7062],a[7063],a[7064],a[7065],a[7066],a[7067],a[7068],a[7069],a[7070],a[7071],a[7072],a[7073],a[7074],a[7075],a[7076],a[7077],a[7078],a[7079],a[7080],a[7081],a[7082],a[7083],a[7084],a[7085],a[7086],a[7087],a[7088],a[7089],a[7090],a[7091],a[7092],a[7093],a[7094],a[7095],a[7096],a[7097],a[7098],a[7099],a[7100],a[7101],a[7102],a[7103],a[7104],a[7105],a[7106],a[7107],a[7108],a[7109],a[7110],a[7111],a[7112],a[7113],a[7114],a[7115],a[7116],a[7117],a[7118],a[7119],a[7120],a[7121],a[7122],a[7123],a[7124],a[7125],a[7126],a[7127],a[7128],a[7129],a[7130],a[7131],a[7132],a[7133],a[7134],a[7135],a[7136],a[7137],a[7138],a[7139],a[7140],a[7141]],[a[7142],a[7143]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"full":a[530],"long":a[531],"medium":a[1251],"short":a[7144]},[a[7145],a[2019],a[4821],a[7146],a[2011],a[4824],a[7147],a[7148],a[7149],a[7150],a[7151],a[7152]],[a[4843],a[4844],a[7153],a[4845],a[4846],a[4847],a[4848]],[a[7154],a[4850],a[7155],a[4852],a[4853],a[4854],a[4855]],{"am":a[7156],"pm":a[7157]},[a[7158],a[7159],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"GGGGyMMMMEEEEdd":a[2002],"Gy":a[7160],"GyMMM":a[7161],"GyMMMEd":a[7162],"GyMMMd":a[7163],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMMEd":a[660],"MMMMd":a[661],"MMMd":a[2003],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[7164],"yMMM":a[524],"yMMMEd":a[7165],"yMMMM":a[526],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},[a[853],a[826],a[827],a[3735],a[827],a[853],a[853],a[3735],a[833],a[833],a[3735],a[830]],[a[7166],a[7167],a[7168],a[3749],a[7169],a[7170],a[7171],a[3753],a[7172],a[7173],a[3756],a[3757]],[a[3735],a[3734],a[835],a[835],a[835],a[853],a[835]],[a[7174],a[7175],a[7176],a[7177],a[7178],a[7179],a[7180]],[a[7181],a[7182],a[7176],a[7177],a[7178],a[7179],a[7180]],[a[7183],a[7184],a[163],a[164]],[a[7185],a[7186],a[163],a[164]],[a[920],a[921],a[7187],a[7188],a[3792],a[3793],a[926],a[927],a[928],a[929],a[7189],a[7190]],{"decimal":a[480],"group":a[481],"nan":a[482],"percent":a[483],"infinity":a[7191]},[a[7192],a[7193],a[1300],a[7194],a[541],a[1302],a[1303],a[1304],a[1305],a[1306],a[1307],a[1308]],[a[109],a[110],a[111],a[112],a[58],a[1309],a[108]],[a[1310],a[1311],a[7195],a[1313],a[1314],a[6231],a[1316]],[a[7196],a[7197],a[7198],a[7199],a[1321],a[1322],a[7200]],{"am":a[7201],"pm":a[7202]},[a[7203],a[7204],a[163],a[164]],[a[7205],a[7206],a[7207],a[7208],a[7209],a[7210],a[7211],a[7212],a[7213],a[7214],a[7215],a[7216]],[a[7217],a[7218],a[7219],a[7220],a[7221],a[7222],a[7223],a[7224],a[7225],a[7226],a[7227],a[7228]],[a[605],a[608],a[1463],a[1463],a[1490],a[1490],a[605]],[a[3705],a[7229],a[7230],a[7231],a[7232],a[7233],a[7234]],[a[7235],a[7236],a[7237],a[7238],a[7239],a[7240],a[7241]],{"am":a[7242],"pm":a[7243]},[a[7244],a[7245],a[163],a[164]],[a[7246],a[7247],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[7248],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[2724],"MMM":a[31],"MMMEd":a[2829],"MMMMd":a[2466],"MMMd":a[2830],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[7249],"yMEd":a[523],"yMMM":a[524],"yMMMEd":a[7250],"yMMMM":a[526],"yMMMd":a[7251],"yMd":a[46],"yQQQ":a[7252],"yQQQQ":a[529]},{"full":a[7253],"long":a[2730],"medium":a[7251],"short":a[2731]},[a[1293],a[7254],a[7255],a[540],a[7256],a[542],a[543],a[7257],a[7258],a[546],a[547],a[4486]],[a[7259],a[7260],a[7261],a[7262],a[7256],a[7263],a[7264],a[7265],a[4488],a[4489],a[4490],a[4491]],[a[4492],a[2938],a[2939],a[7266],a[4495],a[2942],a[2943]],[a[7267],a[7268],a[7269],a[7270],a[7271],a[7272],a[7273]],{"am":a[7274],"pm":a[7275]},[a[7276],a[7277],a[4504],a[4505]],[a[7278],a[7279],a[7280],a[4509]],{"decimal":a[481],"group":a[587],"nan":a[4017],"percent":a[483],"infinity":a[484]},[a[1961],a[7281],a[2809],a[1964],a[2972],a[7282],a[7283],a[4588],a[7284],a[7285],a[1971],a[7286]],[a[7287],a[7288],a[7289],a[7290],a[7291],a[7292],a[7293],a[7294],a[7295],a[7296],a[7297],a[7298]],[a[1984],a[1985],a[7299],a[7300],a[7301],a[7302],a[2811]],[a[7303],a[7304],a[7305],a[7306],a[7307],a[7308],a[7309]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[7310],"GyMMM":a[7311],"GyMMMEd":a[7312],"GyMMMd":a[7313],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[7314],"MMM":a[31],"MMMEd":a[7315],"MMMd":a[2003],"Md":a[521],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[7316],"yMMMEd":a[7317],"yMMMd":a[7318],"yMd":a[46],"yQQQ":a[7319],"yQQQQ":a[7320]},{"full":a[7321],"long":a[667],"medium":a[45],"short":a[1391]},[a[7322],a[7323],a[6560],a[6557],a[6560],a[7324],a[7324],a[6557],a[6559],a[7325],a[6558],a[6588]],[a[7326],a[7327],a[7328],a[1683],a[1396],a[7329],a[7330],a[1686],a[7331],a[1688],a[7332],a[1690]],[a[7333],a[7334],a[1394],a[7335],a[1396],a[7336],a[7337],a[1399],a[7338],a[7339],a[7340],a[7341]],[a[6563],a[6588],a[6561],a[6561],a[6589],a[6563],a[7324]],[a[7342],a[7343],a[7344],a[7345],a[7346],a[7347],a[7348]],[a[7349],a[7350],a[7351],a[7352],a[7353],a[7347],a[7354]],{"am":a[7355],"pm":a[7356]},[a[7357],a[6606],a[163],a[164]],[a[7358],a[6606],a[163],a[164]],[a[7359],a[7360],a[163],a[164]],{"decimal":a[481],"group":a[587],"nan":a[7361],"percent":a[483],"infinity":a[484]},{"CNY":a[488],"EUR":a[491],"JPY":a[496],"KGS":a[7362],"THB":a[589],"VND":a[502],"XAF":a[503],"XOF":a[505],"XPF":a[506]},[a[535],a[56],a[62],a[1309],a[1309],a[1309],a[450],a[560],a[90],a[1309],a[90],a[90]],[a[7363],a[7364],a[7365],a[7366],a[7367],a[7368],a[7369],a[7370],a[7371],a[7372],a[7373],a[7374]],[a[7375],a[7376],a[7377],a[7378],a[7379],a[7380],a[7381],a[7382],a[7383],a[7384],a[7385],a[7386]],[a[1338],a[88],a[87],a[536],a[58],a[1309],a[450]],[a[7387],a[7388],a[7389],a[7390],a[1314],a[1315],a[7391]],[a[7392],a[7393],a[7394],a[7395],a[7396],a[7397],a[7398]],{"am":a[7399],"pm":a[7400]},[a[7401],a[7402],a[163],a[164]],[a[7403],a[7404],a[163],a[164]],{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[2065],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[2914],"GyMMMd":a[2828],"H":a[7405],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[2916],"MMM":a[31],"MMMEd":a[2917],"MMMd":a[2830],"Md":a[2919],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1523],"yMEd":a[1524],"yMMM":a[524],"yMMMEd":a[2920],"yMMMd":a[2832],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},[a[537],a[538],a[7406],a[7407],a[3107],a[1302],a[2927],a[2928],a[2929],a[2930],a[2931],a[2932]],[a[2964],a[2934],a[7408],a[7409],a[3107],a[1302],a[2927],a[2935],a[556],a[557],a[558],a[2936]],[a[7410],a[7411],a[7412],a[7413],a[7414],a[7415],a[7416]],[a[7417],a[7418],a[7419],a[7420],a[7421],a[7422],a[7423]],{"am":a[7424],"pm":a[7425]},[a[2953],a[2954],a[7426],a[7427]],{"ATS":a[2959],"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[1293],a[1294],a[2970],a[7428],a[3221],a[5669],a[543],a[4642],a[7429],a[7430],a[547],a[548]],[a[7431],a[7432],a[7433],a[7434],a[7435],a[7263],a[7436],a[7437],a[7438],a[7439],a[1307],a[1308]],[a[90],a[693],a[29],a[29],a[29],a[29],a[29]],[a[97],a[7440],a[7441],a[7442],a[7443],a[7444],a[7445]],[a[7446],a[7447],a[7448],a[7449],a[7450],a[7451],a[7452]],[a[7453],a[7454],a[163],a[164]],[a[7455],a[7456],a[7457],a[7458],a[7459],a[7460],a[7461],a[7462],a[7463],a[7464],a[7465],a[7466]],[a[58],a[59],a[56],a[694],a[88],a[1762],a[536]],[a[7467],a[7468],a[7469],a[7470],a[7471],a[7472],a[7473]],[a[40],a[607],a[1463],a[2472],a[1463],a[40],a[40],a[2472],a[605],a[7474],a[602],a[35]],[a[1420],a[7475],a[7476],a[7477],a[3598],a[7478],a[7479],a[7480],a[7481],a[7482],a[7483],a[7484]],[a[7485],a[7486],a[7487],a[7488],a[7489],a[7490],a[7491],a[7492],a[7493],a[7494],a[7495],a[7496]],[a[3051],a[40],a[1463],a[1463],a[1463],a[1463],a[3026]],[a[7497],a[7498],a[7499],a[7500],a[7501],a[7502],a[7503]],[a[7504],a[7505],a[7506],a[7507],a[7508],a[7509],a[7510]],{"am":a[7511],"pm":a[7512]},[a[7513],a[7514],a[163],a[164]],[a[7515],a[7516],a[163],a[164]],{"AOA":a[3573],"AUD":a[485],"BRL":a[486],"CAD":a[487],"CDF":a[4244],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CDF":a[4244],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[1646],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[4511],"GyMMMEd":a[7517],"GyMMMd":a[7518],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[7519],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[525],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[7520],"long":a[531],"medium":a[527],"short":a[600]},{"full":a[7521],"long":a[7522],"medium":a[1657],"short":a[1656]},[a[7523],a[7524],a[7525],a[7526],a[7527],a[7528],a[7529],a[7530],a[7531],a[7532],a[7533],a[7534]],[a[7535],a[7536],a[7537],a[7538],a[7539],a[7540],a[7541],a[7542],a[7543],a[7544],a[7545],a[7546]],[a[7547],a[7548],a[7549],a[7550],a[7551],a[7552],a[7553]],[a[7554]],{"am":a[7555],"pm":a[7556]},[a[7557],a[7558],a[7559],a[7560],a[7561],a[7562],a[7563],a[7564],a[7565],a[7566],a[7567],a[7568],a[7569]],[a[7557],a[7558],a[7559],a[7560],a[7561],a[7570],a[7563],a[7564],a[7565],a[7566],a[7567],a[7568],a[7571]],[a[7572],a[7573],a[7574],a[7575],a[7576],a[7577],a[7578],a[7579],a[7580],a[7581],a[7582],a[7583],a[7584]],[a[7585],a[7586],a[163],a[164]],[a[7587],a[7588],a[7589],a[7590]],[a[7591],a[7592],a[7593],a[7594],a[7595],a[7596],a[7597],a[7598],a[7599],a[7600],a[7601],a[7602],a[7603],a[7604]],[a[7591],a[7592],a[7593],a[7594],a[7595],a[7596],a[7597],a[7598],a[7605],a[7600],a[7601],a[7602],a[7603],a[7606]],[a[7607],a[7608],a[7609],a[7610],a[7611],a[7612],a[7613],a[7614],a[7615],a[7616],a[7617],a[7618]],[a[7607],a[7608],a[7609],a[7610],a[7611],a[7612],a[7613],a[7614],a[7615],a[7619],a[7617],a[7618]],[a[7526]],[a[7620],a[7621],a[7622],a[7623],a[7624],a[7625],a[7626],a[7627],a[7628],a[7629],a[7630],a[7631]],[a[7632],a[7633],a[7634],a[7635],a[7636],a[7637],a[7638],a[7639],a[7640],a[7641],a[7642],a[7643]],[a[7644],a[7645],a[7646],a[7647],a[7648],a[7649],a[7650],a[7651],a[7652],a[7653],a[7654],a[7655],a[7656],a[7657],a[7658],a[7659],a[7660],a[7661],a[7662],a[7663],a[7664],a[7665],a[7666],a[7667],a[7668],a[7669],a[7670],a[7671],a[7672],a[7673],a[7674],a[7675],a[7676],a[7677],a[7678],a[7679],a[7680],a[7681],a[7682],a[7683],a[7684],a[7685],a[7686],a[7687],a[7688],a[7689],a[7690],a[7691],a[7692],a[7693],a[7694],a[7695],a[7696],a[7697],a[7698],a[7699],a[7700],a[7701],a[7702],a[7703],a[7704],a[7705],a[7706],a[7707],a[7708],a[7709],a[7710],a[7711],a[7712],a[7713],a[7714],a[7715],a[7716],a[7717],a[7718],a[7719],a[7720],a[7721],a[7722],a[7723],a[7724],a[7725],a[7726],a[7727],a[7728],a[7729],a[7730],a[7731],a[7732],a[7733],a[7734],a[7735],a[7736],a[7737],a[7738],a[7739],a[7740],a[7741],a[7742],a[7743],a[7744],a[7745],a[7746],a[7747],a[7748],a[7749],a[7750],a[7751],a[7752],a[7753],a[7754],a[7755],a[7756],a[7757],a[7758],a[7759],a[7760],a[7761],a[7762],a[7763],a[7764],a[7765],a[7766],a[7767],a[7768],a[7769],a[7770],a[7771],a[7772],a[7773],a[7774],a[7775],a[7776],a[7777],a[7778],a[7779],a[7780],a[7781],a[7782],a[7783],a[7784],a[7785],a[7786],a[7787],a[7788],a[7789],a[7790],a[7791],a[7792],a[7793],a[7794],a[7795],a[7796],a[7797],a[7798],a[7799],a[7800],a[7801],a[7802],a[7803],a[7804],a[7805],a[7806],a[7807],a[7808],a[7809],a[7810],a[7811],a[7812],a[7813],a[7814],a[7815],a[7816],a[7817],a[7818],a[7819],a[7820],a[7821],a[7822],a[7823],a[7824],a[7825],a[7826],a[7827],a[7828],a[7829],a[7830],a[7831],a[7832],a[7833],a[7834],a[7835],a[7836],a[7837],a[7838],a[7839],a[7840],a[7841],a[7842],a[7843],a[7844],a[7845],a[7846],a[7847],a[7848],a[7849],a[7850],a[7851],a[7852],a[7853],a[7854],a[7855],a[7856],a[7857],a[7858],a[7859],a[7860],a[7861],a[7862],a[7863],a[7864],a[7865],a[7866],a[7867],a[7868],a[7869],a[7870],a[7871],a[7872],a[7873],a[7874],a[7875],a[7876],a[7877],a[7878],a[7879]],[a[7880],a[7881],a[7882],a[7883],a[7884],a[7885],a[7886],a[7887],a[7888],a[7889],a[7890],a[7891]],[a[7892],a[7881],a[7882],a[7883],a[7893],a[7885],a[7886],a[7887],a[7894],a[7889],a[7895],a[7891]],[a[7896]],[a[7897],a[472]],{"decimal":a[481],"group":a[480],"nan":a[7898],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"LAK":a[7899],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[7900],"EHms":a[7901],"Ed":a[19],"Ehm":a[7902],"Ehms":a[7903],"Gy":a[512],"GyMMM":a[7904],"GyMMMEd":a[7905],"GyMMMM":a[7906],"GyMMMMEd":a[7907],"GyMMMMd":a[7908],"GyMMMd":a[7909],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[1659],"MEd":a[30],"MMM":a[1659],"MMMEd":a[30],"MMMM":a[1660],"MMMMEd":a[7910],"MMMMd":a[661],"MMMd":a[34],"MMdd":a[34],"Md":a[4236],"d":a[7911],"h":a[2074],"hm":a[2075],"hms":a[2076],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[41],"yMMMEd":a[42],"yMMMM":a[7912],"yMMMMEd":a[7913],"yMMMMd":a[667],"yMMMd":a[46],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[7914],"long":a[7915],"medium":a[46],"short":a[46]},[a[90],a[560],a[62],a[693],a[89],a[693],a[29],a[590],a[590],a[90],a[29],a[89]],[a[7916],a[7917],a[7918],a[7919],a[7920],a[7921],a[7922],a[7923],a[7924],a[7925],a[7926],a[7927]],[a[7928],a[7929],a[7930],a[7931],a[7932],a[7933],a[7934],a[7935],a[7936],a[7937],a[7938],a[7939]],[a[90],a[1338],a[58],a[88],a[62],a[1338],a[7940]],[a[7941],a[7942],a[7943],a[7944],a[7945],a[7946],a[7947]],[a[7948],a[7949],a[7950],a[7951],a[7952],a[7953],a[7954]],{"am":a[7955],"pm":a[7956]},[a[5193],a[7957],a[7958],a[7959]],[a[5193],a[7957],a[7960],a[7961]],[a[7962],a[7963],a[7964],a[7961]],[a[7965],a[7966],a[7967],a[7968],a[7969],a[7970],a[7971],a[7972],a[7973],a[7974],a[7975],a[7976],a[7977],a[7978],a[7979],a[7980],a[7981],a[7982],a[7983],a[7984],a[7985],a[7986],a[7987],a[7988],a[7989],a[7990],a[7991],a[7992],a[7993],a[7994],a[7995],a[7996],a[7997],a[7998],a[7999],a[8000],a[8001],a[8002],a[8003],a[8004],a[8005],a[8006],a[8007],a[8008],a[8009],a[8010],a[8011],a[8012],a[8013],a[8014],a[8015],a[8016],a[8017],a[8018],a[8019],a[8020],a[8021],a[8022],a[8023],a[8024],a[8025],a[8026],a[8027],a[8028],a[8029],a[8030],a[8031],a[8032],a[8033],a[8034],a[8035],a[8036],a[8037],a[8038],a[8039],a[8040],a[8041],a[8042],a[8043],a[8044],a[8045],a[8046],a[8047],a[8048],a[8049],a[8050],a[8051],a[8052],a[8053],a[8054],a[8055],a[8056],a[8057],a[8058],a[8059],a[8060],a[8061],a[8062],a[8063],a[8064],a[8065],a[8066],a[8067],a[8068],a[8069],a[8070],a[8071],a[8072],a[8073],a[8074],a[8075],a[8076],a[8077],a[8078],a[8079],a[8080],a[8081],a[8082],a[8083],a[8084],a[8085],a[8086],a[8087],a[8088],a[8089],a[8090],a[8091],a[8092],a[8093],a[8094],a[8095],a[8096],a[8097],a[8098],a[8099],a[8100],a[8101],a[8102],a[8103],a[8104],a[8105],a[8106],a[8107],a[8108],a[8109],a[8110],a[8111],a[8112],a[8113],a[8114],a[8115],a[8116],a[8117],a[8118],a[8119],a[8120],a[8121],a[8122],a[8123],a[8124],a[8125],a[8126],a[8127],a[8128],a[8129],a[8130],a[8131],a[8132],a[8133],a[8134],a[8135],a[8136],a[8137],a[8138],a[8139],a[8140],a[8141],a[8142],a[8143],a[8144],a[8145],a[8146],a[8147],a[8148],a[8149],a[8150],a[8151],a[8152],a[8153],a[8154],a[8155],a[8156],a[8157],a[8158],a[8159],a[8160],a[8161],a[8162],a[8163],a[8164],a[8165],a[8166],a[8167],a[8168],a[8169],a[8170],a[8171],a[8172],a[8173],a[8174],a[8175],a[8176],a[8177],a[8178],a[8179],a[8180],a[8181],a[8182],a[8183],a[8184],a[8185],a[8186],a[8187],a[8188],a[8189],a[8190],a[8191],a[8192],a[8193],a[8194],a[8195],a[8196],a[8197],a[8198],a[8199],a[457]],[a[8200],a[472]],{},[a[57],a[29],a[29],a[450],a[29],a[29],a[62],a[29],a[29],a[29],a[62],a[57]],[a[8201],a[4258],a[8202],a[8203],a[8204],a[8205],a[8206],a[8207],a[8208],a[1985],a[2878],a[8209]],[a[8210],a[8211],a[8212],a[8213],a[8214],a[8215],a[8216],a[8217],a[8218],a[8219],a[8220],a[8221]],[a[29],a[56],a[56],a[56],a[56],a[56],a[29]],[a[8204],a[8222],a[8223],a[8224],a[8225],a[8226],a[8227]],[a[8228],a[8229],a[8230],a[8231],a[8232],a[8233],a[8234]],{"am":a[8235],"pm":a[8236]},[a[8237],a[8238],a[163],a[164]],[a[8239],a[8240],a[163],a[164]],[a[57],a[590],a[60],a[56],a[693],a[1763],a[693],a[693],a[57],a[1338],a[57],a[1338]],[a[8241],a[8242],a[8243],a[8244],a[8245],a[8246],a[8247],a[8248],a[8249],a[8250],a[8251],a[8252]],[a[8253],a[8254],a[8255],a[8256],a[8257],a[8258],a[8259],a[8260],a[8261],a[8262],a[8263],a[8264]],[a[534],a[59],a[88],a[88],a[88],a[88],a[56]],[a[8265],a[8266],a[8267],a[8268],a[8269],a[8270],a[8271]],[a[8272],a[8273],a[8274],a[8275],a[8276],a[8277],a[8278]],{"am":a[8279],"pm":a[8280]},[a[8281],a[8282],a[163],a[164]],[a[1293],a[1294],a[2970],a[540],a[541],a[542],a[543],a[1296],a[545],a[546],a[547],a[548]],[a[8283],a[8284],a[8285],a[8286],a[4659],a[8287],a[8288]],[a[8289],a[1318],a[1319],a[1320],a[8290],a[8291],a[1323]],[a[8292],a[8293],a[163],a[164]],{"positivePattern":a[476],"negativePattern":a[8294]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[2065],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[8295],"GyMMM":a[8296],"GyMMMEd":a[8297],"GyMMMd":a[8298],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[2070],"MMM":a[31],"MMMEd":a[2917],"MMMMEd":a[2465],"MMMMd":a[2466],"MMMd":a[2830],"Md":a[2073],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"mmss":a[39],"ms":a[39],"y":a[8299],"yM":a[2078],"yMEd":a[8300],"yMMM":a[8301],"yMMMEd":a[8302],"yMMMM":a[8303],"yMMMd":a[8304],"yMd":a[8305],"yQQQ":a[8306],"yQQQQ":a[8307]},{"full":a[8308],"long":a[8309],"medium":a[8310],"short":a[1391]},[a[4020],a[2562],a[2843],a[2837],a[8311],a[8312],a[8313],a[2839],a[3558],a[2841],a[2571],a[2842]],[a[8314],a[8315],a[2843],a[8316],a[8311],a[8317],a[8318],a[8319],a[8320],a[8321],a[8322],a[8323]],[a[90],a[1338],a[536],a[88],a[57],a[1338],a[90]],[a[8324],a[8325],a[8326],a[8327],a[8328],a[8329],a[3099]],[a[8330],a[8331],a[8332],a[8333],a[8334],a[8335],a[8336]],{"am":a[8337],"pm":a[8338]},[a[8339],a[8340],a[8341],a[8342]],[a[8339],a[8340],a[163],a[164]],[a[8343],a[8344],a[163],a[164]],[a[8345],a[8346],a[8347],a[8348],a[8349],a[8350],a[8351],a[8352],a[8353],a[8354],a[8355],a[8356],a[8357],a[8358]],[a[8359],a[8360],a[8361],a[8362],a[8363],a[8364],a[8365],a[8366],a[8367],a[8368],a[8369],a[8370]],{"decimal":a[481],"group":a[587],"nan":a[8371],"percent":a[483],"infinity":a[484]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"LVL":a[8372],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[8373],a[8374],a[8375],a[8376],a[8377],a[8378],a[8379],a[8380],a[8381],a[8382],a[8383],a[8384]],[a[8385],a[8386],a[8387],a[8388],a[8389],a[8390],a[8391],a[8392],a[8393],a[8394],a[8395],a[8396]],[a[8397],a[7393],a[8398],a[8399],a[8400],a[8401],a[8402]],{"am":a[8403],"pm":a[8404]},[a[6431],a[8405],a[163],a[164]],[a[8406],a[8407],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KES":a[2913],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"TZS":a[1332],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[534],a[535],a[450],a[6392],a[450],a[56],a[56],a[58],a[90],a[536],a[56],a[60]],[a[8408],a[8409],a[8410],a[8411],a[8412],a[8413],a[8414],a[8415],a[8416],a[2646],a[8417],a[8418]],[a[8419],a[8420],a[1300],a[8421],a[8422],a[8423],a[8424],a[8425],a[1305],a[8426],a[1307],a[8427]],[a[62],a[450],a[59],a[59],a[59],a[59],a[534]],[a[8428],a[8429],a[8430],a[8431],a[8432],a[6523],a[8433]],[a[3223],a[8434],a[8435],a[8436],a[8437],a[8438],a[1323]],{"am":a[8439],"pm":a[8440]},[a[3232],a[8441],a[163],a[164]],[a[8442],a[8443],a[163],a[164]],[a[606],a[607],a[1463],a[2472],a[1463],a[606],a[606],a[2473],a[605],a[2473],a[602],a[35]],[a[1765],a[1421],a[1341],a[8444],a[3472],a[8445],a[8446],a[4466],a[2479],a[1427],a[2480],a[1774]],[a[8447],a[8448],a[3990],a[4029],a[3472],a[8445],a[8449],a[4466],a[8450],a[8451],a[8452],a[8453]],[a[35],a[608],a[1463],a[1463],a[606],a[3520],a[605]],[a[8454],a[8455],a[1341],a[5629],a[8456],a[8457],a[7234]],[a[8458],a[8459],a[4041],a[8460],a[8461],a[8462],a[8463]],[a[8464],a[8465],a[163],a[164]],[a[8466],a[8467],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MUR":a[3432],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[450],"MEd":a[594],"MMM":a[1758],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"MMd":a[1759],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[40],"yM":a[597],"yMEd":a[598],"yMM":a[1761],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},[a[1293],a[1294],a[2970],a[540],a[8468],a[8469],a[8470],a[8471],a[545],a[546],a[547],a[548]],[a[8472],a[8473],a[8474],a[8475],a[8468],a[8476],a[8477],a[8478],a[8479],a[8480],a[8481],a[8482]],[a[58],a[58],a[88],a[58],a[58],a[1762],a[58]],[a[8483],a[8484],a[93],a[8485],a[8486],a[8487],a[8488]],[a[8489],a[8490],a[3121],a[8491],a[8492],a[8493],a[8494]],[a[8495],a[8496],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MGA":a[3429],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMd":a[33],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[40],"yM":a[597],"yMEd":a[663],"yMMM":a[524],"yMMMEd":a[664],"yMMMd":a[1237],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},[a[62],a[1763],a[590],a[57],a[88],a[450],a[90],a[56],a[88],a[62],a[450],a[694]],[a[8497],a[8498],a[8499],a[8500],a[6396],a[8501],a[97],a[1609],a[1610],a[1611],a[8502],a[8503]],[a[8504],a[8505],a[8506],a[8507],a[8508],a[8509],a[8510],a[8511],a[8512],a[8513],a[8514],a[8515]],[a[90],a[534],a[534],a[534],a[58],a[1309],a[534]],[a[97],a[1311],a[1312],a[1313],a[3116],a[6231],a[1316]],[a[8516],a[1318],a[1319],a[1320],a[8517],a[1322],a[1323]],{"am":a[8518],"pm":a[8519]},[a[8520],a[8521],a[163],a[164]],[a[8522],a[8523],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"MZN":a[8524],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[8525],a[8526],a[8527],a[8528],a[8529],a[8530],a[8531],a[8532],a[8533],a[117],a[118],a[119]],[a[8534],a[8535],a[8536],a[8537],a[8538],a[8539],a[8540],a[8541],a[8542],a[8543],a[8544],a[8545]],[a[8546],a[8535],a[8536],a[8537],a[8538],a[8539],a[8540],a[8541],a[8542],a[8543],a[8544],a[8545]],[a[8547],a[8526],a[8548],a[8549],a[8550],a[8551],a[8531]],[a[8552],a[8553],a[8554],a[8555],a[8556],a[8557],a[8558]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[1646],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[514],"GyMMMd":a[515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1518],"MMM":a[31],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"Md":a[1520],"Mdd":a[8559],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1523],"yMEd":a[1524],"yMMM":a[8560],"yMMMEd":a[8561],"yMMMM":a[1666],"yMMMd":a[8562],"yMd":a[1527],"yQQQ":a[1670],"yQQQQ":a[1671]},{"full":a[591],"long":a[50],"medium":a[8563],"short":a[8564]},[a[8565],a[7327],a[7328],a[1683],a[2092],a[8566],a[8567],a[1686],a[1687],a[1688],a[1689],a[1690]],[a[8568],a[1692],a[1394],a[1693],a[2092],a[2102],a[2103],a[1399],a[1694],a[1695],a[1696],a[1697]],[a[8569],a[8570],a[8571],a[8572],a[8573],a[8574],a[8575]],[a[8576],a[1701],a[1702],a[8577],a[8578],a[8579],a[8580]],{"am":a[8581],"pm":a[8582]},[a[8583],a[2152],a[8583],a[164]],[a[1711],a[2152],a[8583],a[164]],[a[8584],a[8585],a[8583],a[164]],{"BRL":a[486],"CAD":a[487],"EUR":a[491],"MKD":a[8586],"MXN":a[498],"USD":a[501],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3628],"MMM":a[31],"MMMEd":a[32],"MMMMEd":a[7910],"MMMMd":a[661],"MMMd":a[33],"MMdd":a[521],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[3545],"yMEd":a[8587],"yMM":a[522],"yMMM":a[43],"yMMMEd":a[44],"yMMMM":a[8588],"yMMMd":a[45],"yMd":a[600],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[8589],"long":a[8590],"medium":a[8591],"short":a[52]},[a[8592],a[8593],a[8594],a[8595],a[8596],a[8597],a[8597],a[8598],a[8599],a[8600],a[8601],a[8602]],[a[8603],a[8604],a[8605],a[8606],a[8607],a[8608],a[8609],a[8610],a[8611],a[8612],a[8613],a[8614]],[a[8615],a[8616],a[8617],a[8618],a[8607],a[8608],a[8609],a[8619],a[8620],a[8621],a[8622],a[8623]],[a[8624],a[8625],a[8626],a[8627],a[8628],a[8629],a[8630]],[a[8631],a[8632],a[8633],a[8634],a[8635],a[8636],a[8637]],[a[8638],a[8639],a[8640],a[8641],a[8642],a[8643],a[8644]],[a[8645],a[8646],a[8647],a[8648]],[a[8649],a[8650],a[8651],a[8652]],[a[8653],a[8654],a[8655],a[8656],a[8657],a[8658],a[8656],a[8659],a[8594],a[8660],a[8594],a[8593]],[a[8661],a[8662],a[8663],a[8664],a[8665],a[8666],a[8667],a[8668],a[8669],a[8670],a[8671],a[8672]],[a[8673]],[a[8674],a[8599],a[8675],a[8675],a[8592],a[8592],a[8675],a[8630],a[8675],a[8630],a[8676],a[8676]],[a[8677],a[8678],a[8679],a[8680],a[8681],a[8682],a[8683],a[8684],a[8685],a[8686],a[8687],a[8688]],[a[8689]],{"decimal":a[480],"group":a[481],"nan":a[8690],"percent":a[483],"infinity":a[484]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[8691],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[8692],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[3133],"MMM":a[31],"MMMEd":a[3988],"MMMd":a[33],"Md":a[3137],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[3139],"yMEd":a[3140],"yMMM":a[43],"yMMMEd":a[3989],"yMMMd":a[45],"yMd":a[3143],"yQQQ":a[47],"yQQQQ":a[8693]},{"full":a[8694],"long":a[8695],"medium":a[45],"short":a[46]},[a[8696],a[8697],a[8698],a[8699],a[8700],a[8701],a[8702],a[8703],a[8704],a[8705],a[8706],a[8707]],[a[8708],a[8709],a[8710],a[8711],a[8712],a[8713],a[8714],a[8715],a[8716],a[8717],a[8718],a[8719]],[a[8720],a[8721],a[8722],a[8723],a[8724],a[8725],a[8726]],[a[8727],a[8728],a[8729],a[8730],a[8731],a[8732],a[8733]],{"am":a[8734],"pm":a[8735]},[a[8736],a[8737],a[8738],a[8739]],[a[8740],a[8741],a[8738],a[8739]],[a[8742],a[8743],a[8738],a[8739]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MNT":a[8744],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[4814],"GyMMMEd":a[4512],"GyMMMd":a[4513],"H":a[26],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[521],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMM":a[522],"yMMM":a[524],"yMMMEd":a[8745],"yMMMM":a[526],"yMMMd":a[601],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},[a[8746],a[2008],a[2009],a[2010],a[2011],a[4817],a[2012],a[8747],a[2030],a[8747],a[8748],a[8749]],[a[8750],a[8751],a[4821],a[8752],a[2011],a[4824],a[7147],a[8753],a[8754],a[8755],a[8756],a[8757]],[a[7145],a[2019],a[4821],a[7146],a[2011],a[4824],a[7147],a[8758],a[8759],a[8760],a[7151],a[7152]],[a[4849],a[4850],a[8761],a[4852],a[4853],a[4854],a[4855]],{"am":a[7156],"pm":a[8762]},[a[8763],a[8764],a[8765],a[8766]],[a[8767],a[8768],a[8769],a[8770]],[a[8771],a[473]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hmm":a[1656],"Hms":a[28],"M":a[29],"MEd":a[1813],"MMM":a[31],"MMMEd":a[1333],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[4283],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[3545],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[525],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[50],"long":a[531],"medium":a[527],"short":a[3435]},[a[534],a[535],a[450],a[58],a[450],a[534],a[534],a[536],a[90],a[536],a[56],a[60]],[a[1293],a[1294],a[1295],a[540],a[541],a[542],a[543],a[8772],a[545],a[546],a[547],a[1586]],[a[1298],a[1299],a[1295],a[552],a[541],a[542],a[1303],a[8773],a[556],a[557],a[558],a[8774]],[a[58],a[1309],a[90],a[590],a[62],a[534],a[90]],[a[8775],a[8776],a[5646],a[5647],a[8777],a[2898],a[97]],[a[8778],a[8779],a[5650],a[5651],a[8780],a[8781],a[5654]],{"am":a[8782],"pm":a[8783]},[a[8784],a[8785],a[1983],a[8786],a[2972],a[4660],a[8787],a[8788],a[8789],a[3100],a[8790],a[8791]],[a[8792],a[8793],a[163],a[164]],{"AUD":a[485],"BND":a[588],"BRL":a[486],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MYR":a[3433],"NZD":a[499],"THB":a[589],"TWD":a[500],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"full":a[720],"long":a[531],"medium":a[527],"short":a[3435]},{"AUD":a[485],"BRL":a[486],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MYR":a[3433],"NZD":a[499],"THB":a[589],"TWD":a[500],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MYR":a[3433],"NZD":a[499],"SGD":a[588],"THB":a[589],"TWD":a[500],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMMd":a[8794],"MMMd":a[33],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[43],"yMMMEd":a[44],"yMMMM":a[8795],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[8796],"long":a[8797],"medium":a[592],"short":a[721]},[a[534],a[535],a[450],a[58],a[450],a[8798],a[29],a[58],a[90],a[536],a[56],a[60]],[a[1293],a[8799],a[2970],a[540],a[8800],a[8801],a[8802],a[8803],a[3963],a[8804],a[547],a[8805]],[a[8806],a[8807],a[8808],a[552],a[8809],a[8810],a[8811],a[8812],a[8813],a[8814],a[8815],a[8816]],[a[8817],a[88],a[88],a[87],a[8817],a[8798],a[90]],[a[8818],a[8819],a[8820],a[8821],a[8822],a[8823],a[3118]],[a[8824],a[8825],a[8826],a[8827],a[8828],a[8829],a[8830]],[a[8831],a[8832],a[8833],a[6503]],[a[8834],a[8835],a[8833],a[6503]],[a[536],a[58],a[1309],a[535],a[60],a[693],a[29],a[450],a[87],a[1763],a[59],a[694]],[a[8836],a[8837],a[8838],a[8839],a[8840],a[8841],a[8842],a[8843],a[8844],a[8845],a[8846],a[8847]],[a[8848],a[8849],a[8850],a[8851],a[8852],a[8853],a[8854],a[8855],a[8856],a[8857],a[8858],a[8859]],[a[694],a[29],a[1762],a[536],a[58],a[89],a[87]],[a[8860],a[8861],a[8862],a[8863],a[8864],a[8865],a[8866]],[a[8867],a[8868],a[8869],a[8870],a[8871],a[8872],a[8873]],{"am":a[8874],"pm":a[8875]},[a[2910],a[8876],a[163],a[164]],[a[8877],a[8878],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[1646],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[8692],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMMEd":a[660],"MMMMd":a[661],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1217],"yMEd":a[8879],"yMMM":a[43],"yMMMEd":a[3989],"yMMMM":a[8588],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},[a[8880],a[8881],a[8882],a[8883],a[8882],a[8880],a[8880],a[8884],a[8885],a[8886],a[8887],a[8888]],[a[8889],a[8890],a[8891],a[8892],a[8893],a[8894],a[8895],a[8896],a[8897],a[8898],a[8899],a[8900]],[a[8901],a[8901],a[8886],a[8902],a[8903],a[8904],a[8885]],[a[8905],a[8906],a[8907],a[8908],a[8909],a[8910],a[8911]],{"am":a[8912],"pm":a[8913]},[a[8914],a[8915],a[8916],a[8917]],[a[8918],a[8919],a[8916],a[8917]],[a[8920],a[473]],{"decimal":a[480],"group":a[481],"nan":a[8921],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MMK":a[62],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[8922],a[8923],a[8924],a[8925],a[8926],a[8927],a[8928],a[8929],a[8930],a[8931],a[8932],a[8933]],[a[90],a[450],a[87],a[59],a[60],a[535],a[58]],[a[8934],a[562],a[3102],a[8935],a[565],a[8936],a[1810]],[a[8937],a[8938],a[8939],a[8940],a[8941],a[8942],a[8943]],{"am":a[8944],"pm":a[8945]},[a[8946],a[8947],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NAD":a[588],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[2822],"EHms":a[2823],"Ed":a[2718],"Ehm":a[2825],"Ehms":a[2826],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[2827],"GyMMMd":a[2828],"H":a[26],"Hm":a[1516],"Hms":a[1517],"M":a[5152],"MEd":a[8948],"MMM":a[31],"MMMEd":a[2829],"MMMd":a[2830],"MMdd":a[2919],"Md":a[2919],"d":a[2727],"h":a[36],"hm":a[1521],"hms":a[1255],"ms":a[1522],"y":a[40],"yM":a[1523],"yMEd":a[8949],"yMM":a[1385],"yMMM":a[524],"yMMMEd":a[2831],"yMMMM":a[526],"yMMMd":a[2832],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2732],"long":a[2730],"medium":a[2832],"short":a[1389]},[a[2834],a[2835],a[2836],a[2837],a[3598],a[2838],a[2567],a[2839],a[2840],a[2841],a[2571],a[2572]],[a[2482],a[2483],a[3990],a[2484],a[3598],a[2485],a[2486],a[2487],a[2844],a[2845],a[2846],a[3992]],[a[2866],a[2867],a[8950],a[2865]],[a[2866],a[2867],a[8950],a[8951]],[a[2866],a[2867],a[8952],a[8953]],{"EUR":a[491],"GBP":a[492],"NOK":a[3624],"XOF":a[505]},[a[1762],a[56],a[450],a[450],a[56],a[56],a[56],a[56],a[450],a[450],a[29],a[450]],[a[8954],a[8955],a[8956],a[8957],a[8958],a[8959],a[8960],a[8961],a[8962],a[2880],a[8963],a[8964]],[a[8965],a[8966],a[8967],a[8968],a[8969],a[8970],a[8971],a[8972],a[8973],a[8974],a[8975],a[8976]],[a[90],a[450],a[90],a[90],a[90],a[90],a[450]],[a[8934],a[8977],a[3118],a[1608],a[8978],a[8979],a[8980]],[a[8981],a[8982],a[8983],a[8984],a[8985],a[8986],a[8987]],[a[8988],a[8989],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMd":a[33],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[43],"yMMMEd":a[44],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},[a[8990],a[8991],a[8992],a[8993],a[8994],a[8995],a[8996],a[8997],a[8998],a[8999],a[9000],a[9001]],[a[4831],a[9002],a[4821],a[9003],a[2011],a[2022],a[4833],a[9004],a[9005],a[9006],a[9007],a[9008]],[a[4831],a[9009],a[4821],a[9010],a[4823],a[2022],a[4833],a[4834],a[9005],a[9006],a[9007],a[9011]],[a[2013],a[4839],a[4816],a[2032],a[2033],a[4841],a[4842]],[a[9012],a[4844],a[9013],a[4845],a[9014],a[4847],a[4848]],[a[9015],a[4850],a[9016],a[4852],a[9017],a[4854],a[4855]],[a[9018],a[9019],a[9020],a[9021]],[a[4877],a[9022],a[9023],a[9024],a[9025],a[9026],a[9027],a[9028],a[9029],a[4886],a[2063],a[9030]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NPR":a[9031],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[9032],a[9033],a[9034],a[9035],a[9036],a[9037],a[9038]],{"am":a[9039],"pm":a[9040]},[a[2834],a[2835],a[4285],a[2837],a[9041],a[2838],a[2567],a[2839],a[2840],a[2841],a[2571],a[2842]],[a[6636],a[6637],a[4288],a[2484],a[9041],a[2485],a[2486],a[4291],a[2844],a[2845],a[2846],a[2847]],[a[9042],a[3471],a[3052],a[4297],a[9043],a[9044],a[9045]],[a[9046],a[9047],a[9048],a[9049],a[9050],a[9051],a[9052]],[a[9053],a[9054],a[9055],a[9056],a[9057],a[9058],a[9059],a[9060],a[9061],a[9062],a[9063],a[9064]],[a[9065],a[9066],a[9067],a[9068],a[9069],a[9070],a[9071],a[9072],a[9073],a[9074],a[9075],a[9076]],[a[577],a[578],a[579],a[4328]],[a[9077],a[9078],a[581],a[582]],[a[583],a[584],a[9079],a[9080]],{"AUD":a[805],"AWG":a[3575],"BRL":a[486],"CAD":a[3576],"CNY":a[488],"EUR":a[491],"FJD":a[4371],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SBD":a[4372],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505]},{"full":a[530],"long":a[531],"medium":a[5765],"short":a[3435]},{"AUD":a[805],"BRL":a[486],"CAD":a[3576],"CNY":a[488],"EUR":a[491],"FJD":a[4371],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SBD":a[4372],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505]},{"ANG":a[3440],"AUD":a[805],"BRL":a[486],"CAD":a[3576],"CNY":a[488],"EUR":a[491],"FJD":a[4371],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SBD":a[4372],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505]},{"AUD":a[805],"BRL":a[486],"CAD":a[3576],"CNY":a[488],"EUR":a[491],"FJD":a[4371],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SBD":a[4372],"SRD":a[588],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505]},[a[9081],a[9082],a[9083],a[9084],a[9085],a[9086],a[9087],a[9088],a[9089],a[9090],a[9091],a[9092]],[a[9093],a[9094],a[9095],a[9096],a[9097],a[9098],a[9099],a[9100],a[9101],a[9102],a[9103],a[9104]],[a[605],a[1463],a[605],a[605],a[605],a[1463],a[605]],[a[3705],a[3706],a[3707],a[3708],a[3709],a[9105],a[9106]],[a[3712],a[9107],a[9108],a[9109],a[9110],a[9111],a[9112]],{"am":a[9113],"pm":a[9114]},[a[9115],a[9116],a[163],a[164]],[a[9117],a[9118],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[2718],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[2827],"GyMMMd":a[2828],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[8948],"MMM":a[31],"MMMEd":a[2829],"MMMMd":a[2466],"MMMd":a[2830],"MMdd":a[2919],"Md":a[2919],"d":a[2727],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[9119],"yMEd":a[3887],"yMM":a[1385],"yMMM":a[524],"yMMMEd":a[2831],"yMMMM":a[526],"yMMMd":a[2832],"yMd":a[1527],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[9120],"long":a[533],"medium":a[28],"short":a[27]},[a[2834],a[2835],a[3990],a[2837],a[3598],a[2485],a[2486],a[2839],a[2840],a[2841],a[2571],a[2572]],[a[9121],a[9122],a[9123],a[9124],a[9125],a[9126],a[9127]],[a[2855],a[9128],a[9129],a[2858],a[2859],a[2860],a[9130]],{"am":a[9131],"pm":a[9132]},[a[2866],a[2867],a[2864],a[2865]],[a[2866],a[2867],a[9133],a[9134]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NOK":a[3624],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMd":a[33],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[9135],"yMMM":a[524],"yMMMEd":a[9136],"yMMMd":a[9137],"yMd":a[600],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[9138],"long":a[9137],"medium":a[601],"short":a[52]},[a[9139],a[9140],a[9141],a[9142],a[9143],a[9144],a[9145],a[9146],a[9147],a[9148],a[9149],a[9150]],[a[9151],a[9152],a[9153],a[9154],a[9155],a[9156],a[9157]],{"am":a[9158],"pm":a[9159]},[a[9160],a[9161],a[163],a[164]],[a[9162],a[9163],a[163],a[164]],[a[1293],a[1294],a[9164],a[540],a[8468],a[542],a[543],a[9165],a[545],a[546],a[9166],a[1586]],[a[9167],a[9168],a[9169],a[9170],a[9171],a[1302],a[9172],a[9173],a[1305],a[1306],a[9174],a[1589]],[a[8934],a[8977],a[9175],a[6396],a[9176],a[9177],a[9178]],[a[9179],a[9180],a[9181],a[9182],a[9183],a[9184],a[9185]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"ZAR":a[590]},[a[1293],a[1294],a[9164],a[9186],a[541],a[542],a[543],a[1296],a[3963],a[546],a[9187],a[1586]],[a[9188],a[9189],a[9190],a[9191],a[541],a[3371],a[9192],a[9193],a[9194],a[9195],a[9196],a[9197]],[a[8934],a[9198],a[9199],a[8499],a[9176],a[9177],a[9200]],[a[9201],a[9202],a[9203],a[9204],a[9205],a[9206],a[9207]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[9208],"MMM":a[31],"MMMEd":a[517],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[40],"yM":a[597],"yMEd":a[9209],"yMMM":a[524],"yMMMEd":a[9210],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[530],"long":a[531],"medium":a[527],"short":a[3415]},{"full":a[9211],"long":a[9212],"medium":a[38],"short":a[37]},[a[88],a[1338],a[60],a[89],a[60],a[62],a[1338],a[88],a[88],a[29],a[62],a[88]],[a[9213],a[9214],a[9215],a[9216],a[9217],a[9218],a[9219],a[9220],a[9221],a[9222],a[9223],a[9224]],[a[9225],a[9214],a[9226],a[9216],a[9227],a[9228],a[9229],a[9230],a[9231],a[9232],a[9223],a[9233]],[a[57],a[534],a[590],a[60],a[9234],a[60],a[693]],[a[9235],a[9236],a[9237],a[9238],a[9239],a[9240],a[9241]],[a[9242],a[9243],a[9244],a[9245],a[9246],a[9247],a[9248]],{"am":a[9249],"pm":a[9250]},[a[6463],a[9251],a[163],a[164]],[a[9252],a[9253],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMMdd":a[520],"MMMd":a[33],"MMdd":a[1760],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMM":a[1761],"yMMM":a[43],"yMMMEd":a[44],"yMMMM":a[526],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[48]},{"full":a[2004],"long":a[50],"medium":a[51],"short":a[52]},[a[9254],a[9255],a[9256],a[9257],a[9258],a[9259],a[9260],a[9261],a[9262],a[9263],a[2811],a[9264]],[a[9265],a[9266],a[9267],a[9268],a[9269],a[9270],a[9271],a[9272],a[9273],a[9274],a[9275],a[9276]],[a[9277],a[9278],a[9279],a[9280],a[95],a[2899],a[6373]],[a[9281],a[9282],a[9283],a[9284],a[9285],a[9286],a[9287]],{"am":a[9288],"pm":a[9289]},[a[9290],a[9291],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"ETB":a[490],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KES":a[2913],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMMd":a[661],"MMMd":a[33],"MMdd":a[521],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMM":a[522],"yMMM":a[43],"yMMMEd":a[44],"yMMMM":a[526],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[48]},{"full":a[720],"long":a[531],"medium":a[527],"short":a[7144]},[a[9292],a[9293],a[9294],a[9295],a[9296],a[9297],a[9297],a[9295],a[9298],a[9295],a[9299],a[9300]],[a[9301],a[9302],a[9303],a[9304],a[9296],a[9305],a[9306],a[9307],a[9308],a[9309],a[9310],a[9311]],[a[9312],a[9313],a[9314],a[9315],a[9316],a[9317],a[9318]],[a[9319],a[9320],a[9321],a[9322],a[9323],a[9324],a[9325]],[a[9326],a[9327],a[9328],a[9329],a[9330],a[9331],a[9332]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1382],"MMM":a[31],"MMMEd":a[9333],"MMMd":a[519],"Md":a[1384],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1385],"yMEd":a[1386],"yMMM":a[1525],"yMMMEd":a[525],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[9334],"yQQQQ":a[9335]},{"full":a[9336],"long":a[9337],"medium":a[9338],"short":a[1391]},[a[7326],a[7327],a[7328],a[1683],a[1542],a[9339],a[9340],a[1686],a[7331],a[1688],a[7332],a[1690]],[a[9341],a[9342],a[9343],a[9344],a[9345],a[9339],a[9340],a[9346],a[9347],a[9348],a[9349],a[9350]],[a[9351],a[9352],a[6588],a[9353],a[9354],a[6560],a[6559]],[a[9355],a[9356],a[9357],a[9358],a[9359],a[9360],a[9361]],[a[9362],a[9363],a[9364],a[9365],a[9366],a[9367],a[9368]],{"am":a[9369],"pm":a[9370]},[a[9371],a[9372],a[163],a[164]],{"decimal":a[481],"group":a[587],"nan":a[9373],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"RUB":a[1756],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"HHmmss":a[28],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMd":a[33],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"mmss":a[39],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[524],"yMMMEd":a[44],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[48]},{"full":a[591],"long":a[531],"medium":a[527],"short":a[721]},[a[3746],a[9374],a[3748],a[3749],a[9375],a[3751],a[9376],a[3753],a[7172],a[3755],a[3756],a[3757]],[a[9377],a[9378],a[9379],a[9380],a[9381],a[9382],a[9383]],[a[9384],a[9385],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PKR":a[851],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[4511],"GyMMMEd":a[9386],"GyMMMd":a[527],"H":a[26],"HHmmss":a[28],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[9387],"MMM":a[31],"MMMEd":a[1333],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"mmss":a[39],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[525],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},[a[9388],a[9389],a[9390],a[9391],a[9392],a[9393],a[9394],a[9391],a[9395],a[9391],a[9396],a[9397]],[a[9398],a[9399],a[9400],a[9401],a[9402],a[9403],a[9404],a[9405],a[9406],a[9407],a[9408],a[9409]],[a[9410],a[9411],a[9400],a[9412],a[9402],a[9403],a[9413],a[9414],a[9415],a[9416],a[9417],a[9418]],[a[9419],a[9420],a[9421],a[9422],a[9423],a[9424],a[9425]],[a[9426],a[9427],a[9428],a[9429],a[9430],a[9431],a[9432]],[a[9433],a[9434],a[9435],a[9436],a[9437],a[9438],a[9439]],{"am":a[9440],"pm":a[9441]},[a[9442],a[9443],a[9444],a[9445]],[a[9446],a[9447],a[9448],a[9449]],[a[9450],a[9451],a[9452],a[9453],a[9454],a[9455],a[9456],a[9457],a[9458],a[9459],a[9460],a[9461]],[a[9462],a[9463],a[9464],a[9465],a[9466],a[9467],a[9468],a[9469],a[9470],a[9471],a[9472],a[9473]],[a[9474]],{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[1646],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1658],"MMM":a[31],"MMMEd":a[1333],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1661],"Md":a[1661],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1385],"yMEd":a[9475],"yMM":a[1385],"yMMM":a[1525],"yMMMEd":a[525],"yMMMM":a[1526],"yMMMd":a[527],"yMd":a[9476],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[720],"long":a[531],"medium":a[527],"short":a[1389]},[a[605],a[608],a[1463],a[603],a[1463],a[609],a[608],a[605],a[3027],a[3026],a[608],a[634]],[a[9477],a[9478],a[1341],a[9479],a[2475],a[9480],a[5177],a[9481],a[9482],a[9483],a[2743],a[9484]],[a[9485],a[9486],a[9487],a[9488],a[3018],a[9489],a[9490],a[9491],a[9492],a[9493],a[5190],a[9494]],[a[56],a[1338],a[59],a[9495],a[57],a[1338],a[90]],[a[9496],a[9497],a[9498],a[9499],a[9500],a[9501],a[9502]],[a[9503],a[9504],a[9505],a[9506],a[9507],a[9508],a[2771]],[a[9509],a[2511],a[163],a[164]],[a[9510],a[9511],a[9512],a[9513],a[9514],a[170],a[171],a[172],a[4339],a[9515],a[175],a[9516],a[177],a[178]],[a[193],a[194],a[195],a[196],a[9517],a[9518],a[9519],a[9520],a[201],a[9521],a[9522],a[9523]],[a[205],a[206],a[207],a[208],a[9524],a[9525],a[9526],a[9527],a[213],a[9528],a[9529],a[9530]],[a[9531],a[9532],a[9533],a[461],a[9534],a[9535],a[464],a[9536],a[9537],a[9538],a[468],a[469]],[a[9539],a[9540]],{"BRL":a[486],"EUR":a[491],"PLN":a[3050],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[451],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMMd":a[813],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1217],"yMEd":a[42],"yMMM":a[43],"yMMMEd":a[44],"yMMMM":a[9541],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[9542],"long":a[9543],"medium":a[527],"short":a[665]},[a[9544],a[9545],a[3748],a[3749],a[3750],a[3751],a[3752],a[9546],a[3754],a[3755],a[3756],a[3757]],{"am":a[9547],"pm":a[9548]},[a[3773],a[3774],a[163],a[164]],[a[9549],a[9550],a[9551],a[9552],a[9553],a[9554],a[9555],a[9556],a[9557],a[9558],a[9559],a[9560]],{"AFN":a[3823],"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[1646],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[3493],"GyMMMEd":a[9561],"GyMMMd":a[3495],"H":a[26],"HHmm":a[27],"HHmmss":a[28],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[6470],"MMM":a[31],"MMMEd":a[9562],"MMMMEd":a[9563],"MMMMd":a[3497],"MMMd":a[1759],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[3419],"yMM":a[1761],"yMMM":a[1761],"yMMMEEEEd":a[9564],"yMMMEd":a[9565],"yMMMM":a[3502],"yMMMMEd":a[9566],"yMMMMd":a[3507],"yMMMd":a[3415],"yMd":a[721],"yQQQ":a[3505],"yQQQQ":a[3505]},[a[2474],a[1421],a[1341],a[1342],a[3598],a[2476],a[2477],a[1346],a[1347],a[4466],a[2480],a[9567]],[a[9568],a[9569],a[9570],a[2575],a[4469],a[9571],a[9572],a[3516],a[4472],a[4473],a[3467],a[9573]],[a[60],a[90],a[88],a[55],a[55],a[90],a[90]],[a[1363],a[9574],a[4106],a[9575],a[9576],a[9577],a[3570]],[a[3527],a[9578],a[9579],a[9580],a[9581],a[9582],a[3531]],{"am":a[9583],"pm":a[9584]},[a[8525],a[9585],a[8527],a[9586],a[9587],a[9588],a[9589],a[9590],a[9591],a[129],a[130],a[131]],[a[9592],a[9593],a[9594],a[9595],a[9596],a[9597],a[9598],a[9599],a[9600],a[9601],a[9602],a[9603]],[a[1377],a[1378],a[9604],a[9605]],[a[3538],a[9606],a[9607],a[9608]],[a[9609],a[472]],{"AOA":a[3573],"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PTE":a[6508],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[1646],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[3493],"GyMMMEd":a[9561],"GyMMMd":a[3495],"H":a[26],"HHmm":a[27],"HHmmss":a[28],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[6470],"MMM":a[31],"MMMEd":a[3496],"MMMd":a[3498],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[3419],"yMM":a[1761],"yMMM":a[3500],"yMMMEd":a[3501],"yMMMd":a[3503],"yMd":a[721],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[3506],"long":a[3507],"medium":a[3503],"short":a[52]},[a[1377],a[1378],a[2610],a[2611]],[a[9610],a[9611],a[9612],a[9608]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PTE":a[9613],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"CVE":a[6508],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PTE":a[9614],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PTE":a[6508],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MOP":a[3430],"MXN":a[498],"NZD":a[499],"PTE":a[6508],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"MZN":a[8524],"NZD":a[499],"PTE":a[6508],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PTE":a[6508],"STD":a[9615],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMd":a[33],"Md":a[34],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[43],"yMMMEd":a[1814],"yMMMd":a[45],"yMd":a[1251],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[1249],"long":a[667],"medium":a[45],"short":a[721]},{"full":a[532],"long":a[533],"medium":a[2076],"short":a[2075]},[a[9616],a[9617],a[9618],a[9619],a[9620],a[9621],a[9622],a[9623],a[9624],a[2877],a[9625],a[9626]],[a[9627],a[9628],a[9629],a[9630],a[9631],a[9632],a[9633],a[9634],a[9635],a[9636],a[9637],a[9638]],[a[9639],a[1985],a[2970],a[9640],a[9641],a[9642],a[97]],[a[9643],a[3982],a[3983],a[9644],a[9645],a[9646],a[9647]],[a[163],a[2607],a[163],a[164]],[a[163],a[1378],a[163],a[164]],{"AUD":a[485],"BOB":a[3547],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PEN":a[3583],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"full":a[9648],"long":a[9649],"medium":a[1251],"short":a[3550]},[a[90],a[535],a[450],a[58],a[450],a[1762],a[535],a[58],a[90],a[536],a[56],a[60]],[a[9650],a[9651],a[3990],a[4022],a[9652],a[9653],a[9654],a[9655],a[9656],a[2570],a[2571],a[2842]],[a[9657],a[9658],a[3990],a[9659],a[9652],a[9660],a[9661],a[9655],a[9662],a[9663],a[2846],a[2847]],[a[60],a[89],a[450],a[450],a[89],a[560],a[90]],[a[9664],a[9665],a[3471],a[3472],a[9666],a[3474],a[2764]],[a[9667],a[9668],a[4041],a[9669],a[9670],a[9671],a[9672]],{"am":a[3411],"pm":a[9673]},[a[9674],a[9675],a[163],a[164]],[a[9676],a[9677],a[163],a[164]],[a[9678],a[9679],a[9680],a[9681],a[9682],a[9683],a[9684],a[9685],a[9686],a[9687],a[9688],a[9689]],[a[9690],a[9691],a[9692],a[9693],a[9694],a[9695],a[9696],a[9697],a[9698],a[9699],a[9700],a[9701]],[a[9702],a[9703],a[9704],a[9705],a[9706],a[9707],a[9708]],[a[9709],a[9710],a[9711],a[9712],a[9713],a[9714],a[9715]],{"am":a[9716],"pm":a[9717]},[a[9718],a[9719],a[163],a[164]],[a[9720],a[9721],a[163],a[164]],{"AUD":a[485],"BIF":a[4234],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1382],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1384],"Md":a[1384],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1385],"yMEd":a[1386],"yMM":a[1385],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[1389],"yQQQ":a[528],"yQQQQ":a[529]},[a[1309],a[535],a[450],a[58],a[450],a[1309],a[1309],a[58],a[90],a[536],a[56],a[60]],[a[9722],a[2835],a[2836],a[2837],a[3598],a[9723],a[9724],a[2839],a[3558],a[2570],a[2571],a[2842]],[a[9725],a[9726],a[9727],a[9728],a[3598],a[9729],a[9730],a[2487],a[9731],a[9732],a[9733],a[9734]],[a[9735],a[1985],a[2970],a[9736],a[9737],a[9738],a[9739]],[a[9740],a[9741],a[9742],a[9743],a[4271],a[9744],a[9745]],[a[9746]],[a[9747]],[a[133],a[134],a[9748],a[136],a[137],a[138],a[139],a[140],a[141],a[142],a[143],a[9749],a[9750]],[a[9751],a[9752],a[4117],a[9753],a[4106],a[9754],a[9755],a[9756],a[9757],a[9758],a[9759],a[9760],a[9761]],[a[9762],a[9763],a[9764],a[9765]],[a[9766],a[9767],a[9768],a[9769]],[a[9770],a[9771],a[167],a[168],a[9772],a[170],a[171],a[172],a[173],a[174],a[9773],a[176],a[177],a[178]],{"MDL":a[29],"XAF":a[503],"XOF":a[505],"XPF":a[506]},{"XAF":a[503],"XOF":a[505],"XPF":a[506]},[a[62],a[62],a[62],a[62],a[88],a[90],a[90],a[56],a[88],a[1309],a[1309],a[1309]],[a[9774],a[9775],a[9776],a[9777],a[9778],a[9779],a[9780],a[9781],a[9782],a[9783],a[9784],a[9785]],[a[9786],a[9787],a[9788],a[9789],a[1314],a[6231],a[1315]],[a[9790],a[9791],a[9792],a[9793],a[1321],a[1322],a[9794]],{"am":a[9795],"pm":a[9796]},[a[9797],a[9798],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[9799],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[1513],"GyMMMEd":a[9800],"GyMMMd":a[9801],"H":a[451],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[1382],"MMM":a[31],"MMMEd":a[9333],"MMMd":a[519],"MMdd":a[1384],"Md":a[1384],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yLLLL":a[1526],"yM":a[1385],"yMEd":a[9802],"yMM":a[1385],"yMMM":a[1525],"yMMMEd":a[8561],"yMMMM":a[1526],"yMMMd":a[8562],"yMd":a[1389],"yQQQ":a[1670],"yQQQQ":a[1671]},{"full":a[1672],"long":a[1668],"medium":a[8562],"short":a[1391]},[a[7326],a[1682],a[9803],a[1683],a[1542],a[9804],a[9805],a[1686],a[9806],a[1688],a[9807],a[1690]],[a[9808],a[9809],a[9803],a[9810],a[1542],a[9804],a[9805],a[9811],a[9812],a[9813],a[9814],a[9815]],[a[9816],a[1565],a[1698],a[1567],a[1699],a[1569],a[1570]],[a[9817],a[9818],a[1702],a[8577],a[9819],a[9820],a[9821]],[a[9822],a[9823],a[9824],a[9825],a[9826],a[2130],a[2131],a[9827],a[9828],a[9829],a[9830],a[9831],a[2137]],[a[2138],a[2139],a[2140],a[2141],a[2142],a[9832],a[9833],a[9834],a[2146],a[9835],a[9836],a[9837],a[9838]],[a[9839],a[1581],a[163],a[164]],[a[9840],a[9841],a[163],a[164]],[a[9842],a[2158],a[2159],a[2160],a[2161],a[2162],a[2163],a[2164],a[9843],a[2166],a[9844],a[2168],a[9845],a[2170]],[a[9846],a[9847],a[9848],a[9849],a[2175],a[9850],a[9851],a[2178],a[9852],a[2180],a[9853],a[9854]],[a[9855],a[2197],a[9856],a[9857],a[9858],a[9859],a[9860],a[9861],a[2204],a[9862],a[9863],a[9864]],[a[9865],a[9866],a[9867],a[9868],a[9869],a[9870],a[9871],a[9872],a[9873],a[9874],a[9875],a[9876],a[9877],a[9878],a[9879],a[9880],a[9881],a[9882],a[9883],a[9884],a[9885],a[9886],a[9887],a[9888],a[9889],a[9890],a[9891],a[9892],a[9893],a[9894],a[9895],a[9896],a[9897],a[9898],a[9899],a[9900],a[9901],a[9902],a[9903],a[9904],a[9905],a[9906],a[9907],a[9908],a[9909],a[9910],a[9911],a[9912],a[9913],a[9914],a[9915],a[9916],a[9917],a[9918],a[9919],a[9920],a[9921],a[9922],a[9923],a[9924],a[9925],a[9926],a[9927],a[9928],a[9929],a[9930],a[9931],a[9932],a[9933],a[9934],a[9935],a[9936],a[9937],a[9938],a[9939],a[9940],a[9941],a[9942],a[9943],a[9944],a[9945],a[9946],a[9947],a[9948],a[9949],a[9950],a[9951],a[9952],a[9953],a[9954],a[9955],a[9956],a[9957],a[9958],a[9959],a[9960],a[9961],a[9962],a[9963],a[9964],a[9965],a[9966],a[9967],a[9968],a[9969],a[9970],a[9971],a[9972],a[9973],a[9974],a[9975],a[9976],a[9977],a[9978],a[9979],a[9980],a[9981],a[9982],a[9983],a[9984],a[9985],a[9986],a[9987],a[9988],a[9989],a[9990],a[9991],a[9992],a[9993],a[9994],a[9995],a[9996],a[9997],a[9998],a[9999],a[10000],a[10001],a[10002],a[10003],a[10004],a[10005],a[10006],a[10007],a[10008],a[10009],a[10010],a[10011],a[10012],a[10013],a[10014],a[10015],a[10016],a[10017],a[10018],a[10019],a[10020],a[10021],a[10022],a[10023],a[10024],a[10025],a[10026],a[10027],a[10028],a[10029],a[10030],a[10031],a[10032],a[10033],a[10034],a[10035],a[10036],a[10037],a[10038],a[10039],a[10040],a[10041],a[10042],a[10043],a[10044],a[10045],a[10046],a[10047],a[10048],a[10049],a[10050],a[10051],a[10052],a[10053],a[10054],a[10055],a[10056],a[10057],a[10058],a[10059],a[10060],a[10061],a[10062],a[10063],a[10064],a[10065],a[10066],a[10067],a[10068],a[10069],a[10070],a[10071],a[10072],a[10073],a[10074],a[10075],a[10076],a[10077],a[10078],a[10079],a[10080],a[10081],a[10082],a[10083],a[10084],a[10085],a[10086],a[10087],a[10088],a[10089],a[10090],a[10091],a[10092],a[10093],a[10094],a[10095],a[10096],a[10097],a[10098],a[10099],a[10100]],[a[10101],a[2445],a[10102],a[2447],a[2448],a[10103],a[2450],a[2451],a[10104],a[10105],a[2454],a[10106]],{"decimal":a[481],"group":a[587],"nan":a[10107],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BRL":a[486],"BYR":a[1582],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"RUB":a[1756],"THB":a[589],"TMT":a[10108],"TWD":a[500],"UAH":a[10109],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[10110]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KGS":a[7362],"KRW":a[497],"MXN":a[498],"NZD":a[499],"RUB":a[1756],"RUR":a[1582],"THB":a[589],"TMT":a[10108],"TWD":a[500],"UAH":a[10109],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[10110]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"KZT":a[6613],"MXN":a[498],"NZD":a[499],"RUB":a[1756],"RUR":a[1582],"THB":a[589],"TMT":a[10108],"TWD":a[500],"UAH":a[10109],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[10110]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MDL":a[29],"MXN":a[498],"NZD":a[499],"RUB":a[1756],"RUR":a[1582],"THB":a[589],"TMT":a[10108],"TWD":a[500],"UAH":a[10109],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[10110]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"RUB":a[1756],"RUR":a[1582],"THB":a[589],"TMT":a[10108],"TWD":a[500],"UAH":a[10109],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"XXX":a[10110]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[9799],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[1513],"GyMMMEd":a[9800],"GyMMMd":a[9801],"H":a[451],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[1382],"MMM":a[31],"MMMEd":a[9333],"MMMd":a[519],"MMdd":a[1384],"Md":a[1384],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yLLLL":a[1526],"yM":a[1385],"yMEd":a[9802],"yMM":a[1385],"yMMM":a[1525],"yMMMEd":a[8561],"yMMMM":a[1526],"yMMMd":a[527],"yMd":a[1389],"yQQQ":a[1670],"yQQQQ":a[1671]},{"full":a[1672],"long":a[531],"medium":a[527],"short":a[1391]},[a[10111],a[10112],a[10113],a[10114],a[10115],a[10116],a[10117],a[9706],a[10118],a[10119],a[10120],a[10121]],[a[10122],a[10123],a[10124],a[10125],a[10126],a[10127],a[9698],a[10128],a[10129],a[10130],a[10131],a[10132]],[a[10133],a[9703],a[9704],a[9705],a[9706],a[9707],a[9708]],[a[10134],a[10135],a[10136],a[10137],a[10138],a[10139],a[10140]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"RWF":a[3437],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"full":a[10141],"long":a[8590],"medium":a[8591],"short":a[10142]},[a[6562],a[7325],a[9352],a[6560],a[10143],a[6589],a[7325],a[6557],a[6589],a[6557],a[6559],a[6557]],[a[10144],a[10145],a[10146],a[10147],a[10148],a[10149],a[10150],a[10151],a[10152],a[10153],a[10154],a[10155]],[a[10156],a[10157],a[10158],a[10159],a[10160],a[10161],a[10162],a[10163],a[10164],a[10165],a[10166],a[10167]],[a[6589],a[6589],a[7325],a[6559],a[10168],a[6589],a[6559]],[a[10169],a[10170],a[10171],a[10172],a[10173],a[10174],a[10175]],[a[10176],a[10177],a[10178],a[10179],a[10180],a[10181],a[10182]],{"am":a[10183],"pm":a[10184]},[a[10185],a[10186],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"RUB":a[1756],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[536],a[59],a[536],a[536],a[1309],a[1309],a[90],a[1309],a[90],a[88],a[88],a[88]],[a[10187],a[10188],a[10189],a[10190],a[10191],a[10192],a[10193],a[10194],a[10195],a[10196],a[10197],a[10198]],[a[10199],a[10200],a[10201],a[10202],a[10203],a[10204],a[10205],a[10206],a[10207],a[10208],a[10209],a[10210]],[a[58],a[62],a[536],a[1309],a[1309],a[90],a[62]],[a[10211],a[10212],a[10190],a[3218],a[10192],a[10193],a[695]],[a[10213],a[10214],a[10215],a[10216],a[10217],a[10218],a[10219]],{"am":a[10220],"pm":a[10221]},[a[10222],a[10223],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[658],"MMM":a[31],"MMMEd":a[659],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[40],"yM":a[597],"yMEd":a[663],"yMMM":a[524],"yMMMEd":a[664],"yMMMd":a[10224],"yMd":a[2659],"yQQQ":a[528],"yQQQQ":a[529]},[a[10225],a[10226],a[10227],a[10228],a[10229],a[10230],a[10231],a[10232],a[10233],a[9200],a[10234],a[10235]],[a[10236],a[10237],a[10238],a[10239],a[10240],a[10241],a[10242],a[10243],a[10244],a[10245],a[10246],a[10247]],[a[450],a[534],a[534],a[534],a[58],a[1309],a[534]],[a[1626],a[1311],a[1312],a[1313],a[1314],a[6231],a[1316]],[a[10248],a[1318],a[1319],a[1320],a[10249],a[1322],a[1323]],{"am":a[10250],"pm":a[10251]},[a[711],a[8876],a[163],a[164]],[a[10252],a[10253],a[163],a[164]],[a[536],a[89],a[56],a[57],a[450],a[89],a[90],a[693],a[2492],a[89],a[90],a[534]],[a[10254],a[10255],a[10256],a[10257],a[10258],a[10259],a[10260],a[10261],a[10262],a[10263],a[10264],a[10265]],[a[10266],a[10267],a[10268],a[10269],a[10270],a[10271],a[10272],a[10273],a[10274],a[10275],a[10276],a[10277]],[a[90],a[450],a[60],a[89],a[60],a[693],a[29]],[a[10278],a[10279],a[10280],a[10281],a[10282],a[10283],a[10284]],[a[10285],a[10286],a[10287],a[10288],a[10289],a[10290],a[10291]],{"am":a[10292],"pm":a[10293]},[a[10294],a[10295],a[163],a[164]],[a[10296],a[10297],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"DKK":a[10298],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NOK":a[3624],"NZD":a[499],"SEK":a[6667],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[10299],a[10300],a[10301],a[10302],a[10303],a[10304],a[10305],a[10306],a[10307],a[10308],a[10309],a[10310]],[a[90],a[560],a[450],a[89],a[60],a[693],a[29]],[a[10311],a[10312],a[10313],a[10314],a[10315],a[10316],a[10317]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"DKK":a[10298],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NOK":a[6666],"NZD":a[499],"SEK":a[3624],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"HHmm":a[27],"HHmmss":a[28],"Hm":a[1656],"Hms":a[28],"M":a[29],"MEd":a[6470],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"mmss":a[39],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[3419],"yMM":a[1761],"yMMM":a[3500],"yMMMEd":a[3501],"yMMMM":a[3502],"yMMMd":a[3503],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[3506],"long":a[3507],"medium":a[3503],"short":a[600]},[a[1293],a[4255],a[2970],a[3960],a[2791],a[542],a[543],a[544],a[3963],a[4260],a[547],a[1297]],[a[10318],a[10319],a[10320],a[3968],a[10321],a[10322],a[10323],a[10324],a[10325],a[10326],a[10327],a[10328]],[a[60],a[1338],a[57],a[88],a[56],a[90],a[90]],[a[3114],a[10329],a[10330],a[3217],a[10331],a[10332],a[97]],[a[10333],a[10334],a[10335],a[10336],a[10337],a[10338],a[10339]],[a[10340],a[1600],a[163],a[164]],[a[9610],a[3407],a[163],a[164]],[a[2995],a[2996],a[2997],a[2998],a[6513],a[2999],a[3000]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[450],"MEd":a[30],"MMM":a[1758],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"MMd":a[1759],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[40],"yM":a[597],"yMEd":a[598],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},[a[56],a[535],a[450],a[56],a[693],a[535],a[29],a[62],a[450],a[56],a[56],a[62]],[a[10341],a[9262],a[10342],a[2900],a[10343],a[10344],a[10345],a[10346],a[8977],a[10347],a[10348],a[10349]],[a[10350],a[10351],a[10352],a[10353],a[10354],a[10355],a[10356],a[10357],a[10358],a[10359],a[10360],a[10361]],[a[62],a[90],a[88],a[90],a[62],a[1338],a[694]],[a[10362],a[10363],a[10364],a[10365],a[10366],a[10367],a[10368]],[a[10369],a[10370],a[10371],a[10372],a[10373],a[10374],a[10375]],{"am":a[10376],"pm":a[10377]},[a[10378],a[10379],a[163],a[164]],[a[10380],a[10381],a[163],a[164]],[a[10382],a[1465],a[1463],a[10382],a[1463],a[40],a[40],a[10383],a[609],a[603],a[602],a[35]],[a[10384],a[10385],a[10386],a[10387],a[1343],a[7478],a[7479],a[10388],a[10389],a[10390],a[10391],a[10392]],[a[10393],a[10394],a[10395],a[10396],a[10397],a[10398],a[10399],a[10400],a[10401],a[10402],a[10403],a[10404]],[a[10405],a[10406],a[10407],a[10408],a[10409],a[10410],a[10411]],[a[10412],a[10413],a[10414],a[10415],a[10416],a[10417],a[10418]],{"am":a[10419],"pm":a[10420]},[a[10421],a[10422],a[163],a[164]],[a[10423],a[10424],a[163],a[164]],[a[10425],a[10426],a[10427],a[10425],a[10427],a[10428],a[10428],a[10429],a[10430],a[10431],a[10432],a[10433]],[a[10434],a[10435],a[10436],a[10437],a[10438],a[10439],a[10440],a[10441],a[10442],a[10443],a[10444],a[10445]],[a[10446],a[10447],a[10448],a[10449],a[10450],a[10451],a[10452],a[10453],a[10454],a[10455],a[10456],a[10457]],[a[10458],a[10459],a[10460],a[10461],a[10462],a[10463],a[10464]],[a[10465],a[10466],a[10467],a[10468],a[10469],a[10470],a[10471]],{"am":a[10472],"pm":a[10473]},[a[10474],a[10475],a[163],a[164]],[a[10476],a[10477],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[10478],"Ehms":a[10479],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[10480],"MMM":a[31],"MMMEd":a[10481],"MMMd":a[33],"Md":a[3137],"d":a[35],"h":a[5463],"hm":a[10482],"hms":a[10483],"ms":a[1522],"y":a[40],"yM":a[3139],"yMEd":a[10484],"yMMM":a[43],"yMMMEd":a[44],"yMMMd":a[45],"yMd":a[3143],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[10485],"long":a[10486],"medium":a[10483],"short":a[10482]},[a[10487],a[10488],a[10489],a[10490],a[10491],a[10492],a[10492],a[10490],a[10493],a[10494],a[10495],a[10496]],[a[10497],a[10498],a[10499],a[10500],a[10501],a[10502],a[10503],a[10504],a[10505],a[10506],a[10507],a[10508]],[a[10509],a[10510],a[10499],a[10500],a[10501],a[10502],a[10503],a[10511],a[10512],a[10513],a[10514],a[10515]],[a[10516],a[10517],a[10490],a[10518],a[10519],a[10520],a[10521]],[a[10522],a[10523],a[10524],a[10525],a[10526],a[10527],a[10528]],[a[10522],a[10523],a[10529],a[10525],a[10530],a[10531],a[10532]],{"am":a[10533],"pm":a[10534]},[a[10535],a[10536],a[10537],a[10538]],[a[10539],a[10540],a[10537],a[10538]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"LKR":a[10541],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[10542],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[2718],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[2719],"GyMMMEd":a[3587],"GyMMMMd":a[2722],"GyMMMd":a[2723],"H":a[451],"Hm":a[1656],"Hms":a[1657],"M":a[5152],"MEd":a[10543],"MMM":a[31],"MMMEd":a[10543],"MMMMEd":a[2465],"MMMMd":a[2466],"MMMd":a[10544],"Md":a[2726],"d":a[2727],"h":a[36],"hm":a[37],"hms":a[38],"mmss":a[39],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[2728],"yMMM":a[1526],"yMMMEd":a[2728],"yMMMM":a[1526],"yMMMMd":a[2730],"yMMMd":a[2731],"yMd":a[2731],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2963],"long":a[2730],"medium":a[2731],"short":a[1391]},[a[2474],a[1340],a[1341],a[1422],a[10545],a[10546],a[10547],a[2478],a[2479],a[1427],a[2480],a[2481]],[a[10548],a[10549],a[9487],a[10550],a[10551],a[10552],a[10553],a[10554],a[3022],a[10555],a[10556],a[3025]],[a[56],a[1338],a[1763],a[90],a[7940],a[1338],a[90]],[a[2758],a[2759],a[10557],a[2761],a[7947],a[10558],a[2764]],[a[10559],a[10560],a[10561],a[10562],a[10563],a[10564],a[2771]],{"am":a[10565],"pm":a[10566]},[a[10567],a[7957],a[10568],a[2774]],[a[10569],a[10570],a[10571],a[10572]],{"EUR":a[491],"ILS":a[10573],"MXN":a[498],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[2822],"EHms":a[2823],"Ed":a[2065],"Ehm":a[2825],"Ehms":a[2826],"Gy":a[512],"GyM":a[10574],"GyMMM":a[513],"GyMMMEd":a[2914],"GyMMMd":a[2828],"H":a[26],"Hm":a[1516],"Hms":a[1517],"M":a[29],"MEd":a[10575],"MMM":a[31],"MMMEd":a[2917],"MMMd":a[2830],"Md":a[2726],"d":a[35],"h":a[36],"hm":a[1521],"hms":a[1255],"ms":a[1522],"y":a[40],"yM":a[597],"yMEd":a[10576],"yMMM":a[524],"yMMMEd":a[2920],"yMMMM":a[526],"yMMMd":a[2832],"yMd":a[2731],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[2921],"long":a[2922],"medium":a[2832],"short":a[10577]},[a[2834],a[2835],a[2836],a[2837],a[2475],a[2838],a[2567],a[10578],a[2840],a[2841],a[2571],a[2842]],[a[2482],a[2483],a[10579],a[2484],a[2475],a[10580],a[10581],a[10582],a[2844],a[2845],a[2846],a[2847]],[a[602],a[3026],a[604],a[605],a[10583],a[3026],a[605]],[a[10584],a[9497],a[2852],a[10585],a[10586],a[10587],a[9502]],[a[10588],a[10589],a[10590],a[10591],a[10592],a[10593],a[2771]],{"am":a[10594],"pm":a[10595]},[a[10596],a[7957],a[163],a[10597]],[a[10598],a[10599],a[163],a[10597]],{"AUD":a[485],"BRL":a[486],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[1338],a[560],a[450],a[62],a[88],a[560],a[29]],[a[10600],a[10601],a[3471],a[10602],a[10603],a[10604],a[10605]],[a[10606],a[10607],a[10608],a[10609],a[10610],a[10611],a[10612]],{"decimal":a[480],"group":a[481],"nan":a[10613],"percent":a[483],"infinity":a[484]},[a[56],a[62],a[62],a[62],a[57],a[57],a[57],a[56],a[89],a[89],a[450],a[1762]],[a[10614],a[10615],a[9223],a[10616],a[10617],a[10618],a[10619],a[6398],a[10620],a[96],a[10621],a[10622]],[a[10623],a[10624],a[10625],a[10626],a[10627],a[10628],a[10629],a[10630],a[10631],a[10632],a[10633],a[10634]],[a[90],a[450],a[57],a[57],a[57],a[57],a[450]],[a[10635],a[10636],a[10637],a[10638],a[10639],a[10640],a[3200]],[a[10641],a[10642],a[10335],a[10336],a[10643],a[10338],a[10644]],[a[10645],a[10646],a[163],a[164]],[a[62],a[29],a[90],a[58],a[90],a[29],a[88],a[90],a[90],a[88],a[62],a[29]],[a[10647],a[10648],a[2811],a[10649],a[10332],a[10650],a[10651],a[10652],a[10653],a[10197],a[10654],a[10655]],[a[10656],a[10657],a[10658],a[10659],a[10660],a[10661],a[10662],a[10663],a[10664],a[10665],a[10666],a[10667]],[a[58],a[1309],a[88],a[58],a[62],a[534],a[90]],[a[10668],a[8776],a[93],a[94],a[8777],a[2899],a[97]],[a[10669],a[10670],a[10671],a[10672],a[10673],a[10674],a[104]],{"am":a[10675],"pm":a[10676]},[a[10677],a[10678],a[163],a[164]],[a[10679],a[10680],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"DJF":a[489],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SOS":a[90],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"ETB":a[490],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SOS":a[90],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KES":a[2913],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SOS":a[90],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SOS":a[90],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[1644],"EHms":a[2781],"Ed":a[1646],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1518],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[1520],"Md":a[1520],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1523],"yMEd":a[1524],"yMMM":a[524],"yMMMEd":a[525],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[1527],"yQQQ":a[6240],"yQQQQ":a[6241]},{"full":a[720],"long":a[531],"medium":a[527],"short":a[1528]},[a[534],a[90],a[450],a[1338],a[450],a[55],a[62],a[89],a[90],a[88],a[56],a[60]],[a[1293],a[10681],a[2970],a[10682],a[10683],a[10684],a[9218],a[10685],a[10686],a[10687],a[10688],a[10689]],[a[10690],a[10691],a[3990],a[10692],a[2475],a[10693],a[10694],a[10695],a[10696],a[10697],a[10698],a[10699]],[a[60],a[451],a[450],a[450],a[87],a[1338],a[90]],[a[10700],a[10701],a[2970],a[10702],a[10703],a[10704],a[10686]],[a[10705],a[10706],a[10707],a[10708],a[10709],a[10710],a[10711]],{"am":a[10712],"pm":a[10713]},[a[10714],a[10715],a[10716],a[10717]],[a[10714],a[10715],a[10718],a[10717]],[a[10719],a[10720],a[10721],a[10722]],{"ALL":a[10723],"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"ALL":a[10723],"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MKD":a[10724],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[87],"EHm":a[1644],"EHms":a[2781],"Ed":a[2718],"Ehm":a[1647],"Ehms":a[1648],"Gy":a[2066],"GyMMM":a[2067],"GyMMMEd":a[5150],"GyMMMd":a[5151],"H":a[26],"Hm":a[1516],"Hms":a[1517],"M":a[29],"MEd":a[3133],"MMM":a[31],"MMMEd":a[2829],"MMMMEd":a[2725],"MMMMd":a[2466],"MMMd":a[2830],"MMMdd":a[10725],"MMdd":a[34],"Md":a[595],"d":a[35],"h":a[2074],"hm":a[10726],"hms":a[10727],"ms":a[1522],"y":a[2077],"yM":a[10728],"yMEd":a[8300],"yMM":a[2078],"yMMM":a[2080],"yMMMEd":a[5154],"yMMMM":a[10729],"yMMMd":a[5155],"yMMdd":a[2083],"yMd":a[8305],"yQQQ":a[10730],"yQQQQ":a[10731]},{"full":a[2084],"long":a[2085],"medium":a[46],"short":a[3454]},{"full":a[10732],"long":a[1530],"medium":a[28],"short":a[27]},{"am":a[2123],"pm":a[10733]},[a[2155],a[2156],a[2153],a[2154]],{"BAM":a[2459],"BGN":a[10734],"BRL":a[486],"BYR":a[10735],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"MXN":a[498],"TWD":a[500],"USD":a[501],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[2100],a[2101],a[1394],a[1693],a[2092],a[2093],a[2094],a[1399],a[2104],a[2105],a[2106],a[2107]],[a[2109],a[2110],a[2111],a[10736],a[2113],a[2114],a[2115]],[a[2116],a[2117],a[2118],a[8577],a[2120],a[2121],a[1577]],{"full":a[10737],"long":a[1530],"medium":a[28],"short":a[27]},[a[2474],a[1340],a[1341],a[1422],a[2475],a[2476],a[2477],a[10738],a[2479],a[1427],a[2480],a[2481]],[a[2482],a[2483],a[1432],a[2484],a[2475],a[2485],a[2486],a[10582],a[2488],a[2489],a[2490],a[2491]],[a[602],a[3026],a[635],a[605],a[10583],a[3026],a[605]],[a[10588],a[10739],a[2502],a[2503],a[2504],a[2505],a[2506]],{"am":a[10740],"pm":a[10741]},[a[10742],a[134],a[135],a[136],a[137],a[10743],a[139],a[10744],a[10745],a[142],a[143],a[144],a[4315]],[a[148],a[149],a[150],a[151],a[152],a[10746],a[154],a[155],a[156],a[157],a[158],a[10747],a[160]],[a[2512],a[2513],a[163],a[164]],[a[10748],a[2515],a[2512],a[2513]],[a[10749],a[10750],a[167],a[168],a[10751],a[170],a[171],a[172],a[4339],a[174],a[175],a[176],a[177],a[178]],[a[10752],a[10753],a[10754],a[10755],a[184],a[10756],a[186],a[187],a[10757],a[10758],a[10759],a[10760]],[a[193],a[194],a[10761],a[10762],a[10763],a[10764],a[10765],a[10766],a[201],a[10767],a[10768],a[10769]],[a[10770],a[206],a[207],a[208],a[209],a[210],a[10771],a[10772],a[213],a[10773],a[10774],a[10775]],[a[218],a[10776],a[10777],a[10778],a[10779],a[223],a[10780],a[225],a[10781],a[227],a[10782],a[10783],a[10784],a[10785],a[10786],a[10787],a[10788],a[10789],a[10790],a[10791],a[10792],a[10793],a[10794],a[10795],a[242],a[243],a[10796],a[10797],a[246],a[10798],a[10799],a[10800],a[10801],a[10802],a[10803],a[10804],a[10805],a[255],a[10806],a[10807],a[10808],a[259],a[260],a[10809],a[262],a[263],a[10810],a[265],a[266],a[10811],a[10812],a[10813],a[10814],a[10815],a[10816],a[10817],a[274],a[10818],a[10819],a[10820],a[278],a[10821],a[10822],a[10823],a[10824],a[10825],a[10826],a[10827],a[10828],a[10829],a[10830],a[289],a[10831],a[10832],a[10833],a[10834],a[10835],a[10836],a[296],a[10837],a[10838],a[299],a[10839],a[10840],a[10841],a[10842],a[304],a[10843],a[10844],a[10845],a[10846],a[309],a[10847],a[311],a[10848],a[10849],a[10850],a[10851],a[316],a[317],a[10852],a[10853],a[320],a[10854],a[10855],a[10856],a[10857],a[10858],a[10859],a[10860],a[10861],a[10862],a[330],a[10863],a[10864],a[10865],a[10866],a[10867],a[10868],a[337],a[338],a[339],a[10869],a[341],a[10870],a[343],a[10871],a[10872],a[346],a[347],a[10873],a[10874],a[10875],a[10876],a[10877],a[10878],a[10879],a[355],a[10880],a[10881],a[10882],a[359],a[10883],a[361],a[362],a[10884],a[364],a[10885],a[10886],a[10887],a[10888],a[10889],a[10890],a[371],a[372],a[10891],a[10892],a[375],a[10893],a[10894],a[378],a[10895],a[380],a[10896],a[10897],a[10898],a[384],a[385],a[10899],a[387],a[10900],a[10901],a[10902],a[391],a[392],a[10903],a[10904],a[10905],a[10906],a[10907],a[10908],a[10909],a[400],a[10910],a[402],a[10911],a[404],a[10912],a[406],a[10913],a[408],a[10914],a[410],a[411],a[10915],a[413],a[10916],a[10917],a[416],a[10918],a[418],a[10919],a[10920],a[421],a[422],a[10921],a[10922],a[10923],a[426],a[10924],a[10925],a[10926],a[430],a[10927],a[10928],a[433],a[10929],a[10930],a[436],a[437],a[438],a[10931],a[440],a[441],a[10932],a[10933],a[444],a[445],a[446],a[10934],a[10935],a[10936],a[10937],a[8198],a[8199],a[10938]],[a[10939],a[10940],a[10941],a[461],a[462],a[10942],a[464],a[465],a[466],a[10943],a[468],a[469]],[a[10944],a[10945]],{"BAM":a[1326],"BGN":a[10734],"BRL":a[486],"BYR":a[10735],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"MXN":a[498],"TWD":a[500],"USD":a[501],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[2482],a[2483],a[1432],a[2484],a[2475],a[2476],a[2477],a[10582],a[2488],a[2489],a[2490],a[2491]],[a[2493],a[2494],a[2495],a[10946],a[2497],a[2498],a[2499]],[a[10588],a[10739],a[2502],a[10591],a[2504],a[2505],a[2506]],[a[10947],a[10948],a[10949],a[8957],a[10950],a[10951],a[10952],a[10953],a[10954],a[10955],a[8963],a[10956]],[a[10957],a[10958],a[10959],a[8968],a[10960],a[10961],a[10962],a[10963],a[10964],a[10965],a[10966],a[10967]],[a[8934],a[10968],a[9175],a[10969],a[9176],a[9177],a[10970]],[a[10971],a[10972],a[10973],a[10974],a[10975],a[10976],a[10977]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"SZL":a[87],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"ZAR":a[590]},[a[56],a[90],a[90],a[590],a[57],a[534],a[55]],[a[10348],a[6373],a[10978],a[5647],a[9258],a[2898],a[63]],[a[10979],a[10980],a[10981],a[10982],a[10983],a[10984],a[10985]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"ERN":a[508],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"MMd":a[595],"MMdd":a[1760],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[3423],"yMM":a[41],"yMMM":a[524],"yMMMEd":a[599],"yMMMd":a[527],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},[a[2834],a[2835],a[3990],a[2837],a[2475],a[2485],a[2486],a[2839],a[2840],a[2841],a[2571],a[2842]],[a[6636],a[6637],a[3990],a[2484],a[2475],a[2485],a[2486],a[10986],a[2844],a[2845],a[2846],a[2847]],[a[10987],a[10988],a[10989],a[10990],a[10991],a[10992],a[10993]],[a[10994],a[9128],a[10995],a[2858],a[2859],a[2860],a[10996]],{"am":a[10997],"pm":a[10998]},[a[4073],a[4086],a[4087],a[10999],a[4089],a[4090],a[4091],a[4092],a[4093],a[4094],a[4095],a[4096],a[4097]],[a[11000],a[11001],a[11002],a[11003]],[a[11004],a[11005],a[11006],a[11007],a[11008],a[11009],a[11010],a[11011],a[11012],a[11013],a[11014],a[4146],a[11015],a[11016]],[a[11017]],[a[3944],a[3945],a[3946],a[3947],a[11018],a[11019],a[4196],a[11020],a[3952],a[11021],a[11022],a[11023]],[a[7965],a[11024],a[11025],a[11026],a[11027],a[7970],a[11028],a[7972],a[11029],a[7974],a[11030],a[11031],a[11032],a[11033],a[11034],a[11035],a[11036],a[11037],a[11038],a[11039],a[11040],a[11041],a[11042],a[11043],a[7989],a[7990],a[11044],a[11045],a[7993],a[11046],a[11047],a[11048],a[7997],a[11049],a[11050],a[11051],a[11052],a[8002],a[11053],a[11054],a[11055],a[8006],a[8007],a[11056],a[8009],a[8010],a[11057],a[8012],a[8013],a[11058],a[11059],a[11060],a[11061],a[11062],a[11063],a[11064],a[11065],a[11066],a[11067],a[11068],a[8025],a[11069],a[8027],a[11070],a[11071],a[11072],a[11073],a[11074],a[11075],a[11076],a[11077],a[8036],a[11078],a[11079],a[11080],a[11081],a[11082],a[11083],a[8043],a[11084],a[8045],a[8046],a[11085],a[11086],a[11087],a[11088],a[8051],a[11089],a[11090],a[11091],a[11092],a[8056],a[11093],a[8058],a[11094],a[11095],a[11096],a[11097],a[8063],a[8064],a[11098],a[11099],a[8067],a[11100],a[11101],a[11102],a[11103],a[11104],a[11105],a[11106],a[11107],a[11108],a[8077],a[11109],a[11110],a[11111],a[11112],a[11113],a[11114],a[8084],a[8085],a[8086],a[11115],a[8088],a[11116],a[8090],a[11117],a[11118],a[11119],a[8094],a[11120],a[11121],a[11122],a[11123],a[11124],a[11125],a[11126],a[8102],a[11127],a[11128],a[11129],a[8106],a[11130],a[8108],a[8109],a[11131],a[8111],a[11132],a[11133],a[11134],a[11135],a[11136],a[11137],a[8118],a[8119],a[11138],a[11139],a[8122],a[11140],a[11141],a[8125],a[11142],a[11143],a[11144],a[11145],a[11146],a[8131],a[8132],a[11147],a[8134],a[11148],a[11149],a[11150],a[8138],a[8139],a[11151],a[11152],a[11153],a[11154],a[11155],a[11156],a[11157],a[8147],a[11158],a[8149],a[11159],a[8151],a[11160],a[8153],a[11161],a[8155],a[11162],a[8157],a[8158],a[11163],a[8160],a[11164],a[11165],a[8163],a[11166],a[8165],a[11167],a[11168],a[11169],a[8169],a[11170],a[11171],a[11172],a[8173],a[11173],a[11174],a[11175],a[8177],a[11176],a[11177],a[8180],a[11178],a[11179],a[8183],a[8184],a[8185],a[11180],a[8187],a[8188],a[11181],a[11182],a[8191],a[8192],a[8193],a[11183],a[11184],a[11185],a[454],a[455],a[456],a[457]],[a[11186],a[11187],a[11188],a[11189],a[11190],a[11191],a[11192],a[11193],a[11194],a[11195],a[11196],a[11197]],[a[11198],a[11199]],{"BBD":a[11200],"BMD":a[11201],"BRL":a[11202],"BSD":a[11203],"BZD":a[11204],"CAD":a[11205],"DKK":a[10298],"DOP":a[11206],"EEK":a[11207],"EGP":a[11208],"EUR":a[491],"ILS":a[494],"ISK":a[11209],"JMD":a[11210],"MXN":a[498],"NOK":a[6666],"SEK":a[3624],"USD":a[501],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"full":a[11211],"long":a[531],"medium":a[527],"short":a[1251]},[a[11000],a[11001],a[11212],a[11213]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1236],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"Md":a[4283],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMMM":a[524],"yMMMEd":a[664],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KES":a[2913],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"TZS":a[1332],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KES":a[2913],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"TZS":a[1332],"UGX":a[2657],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[603],a[3026],a[604],a[10382],a[604],a[605],a[605],a[1463],a[604],a[603],a[1463],a[1463]],[a[11214],a[11215],a[11216],a[7501],a[7502],a[7500],a[11217],a[11218],a[11219],a[11220],a[11221],a[11222]],[a[11223],a[11224],a[11225],a[11226],a[11227],a[11228],a[11229],a[11230],a[11231],a[11232],a[11233],a[11234]],[a[40],a[603],a[3026],a[604],a[10382],a[604],a[605]],[a[11235],a[3078],a[11236],a[11237],a[11238],a[11239],a[11240]],[a[11241],a[11242],a[11243],a[11244],a[11245],a[11246],a[11247]],{"am":a[11248],"pm":a[11249]},[a[11250],a[11251],a[163],a[164]],[a[11252],a[11253],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMMd":a[813],"MMMd":a[33],"MMdd":a[521],"Md":a[595],"d":a[35],"h":a[5463],"hm":a[5464],"hms":a[5465],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMM":a[522],"yMMM":a[524],"yMMMEd":a[1814],"yMMMM":a[526],"yMMMd":a[601],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[1249],"long":a[1250],"medium":a[601],"short":a[7144]},[a[11254],a[11255],a[11256],a[11257],a[11258],a[11259],a[11259],a[11260],a[11261],a[11262],a[11263],a[11264]],[a[11265],a[11266],a[11267],a[11268],a[11258],a[11269],a[11270],a[11271],a[11272],a[11273],a[11274],a[11275]],[a[11276],a[11277],a[11278],a[11279],a[11258],a[11269],a[11270],a[11280],a[11281],a[11282],a[11283],a[11284]],[a[11285],a[11286],a[11261],a[11287],a[11288],a[11289],a[11290]],[a[11291],a[11292],a[11293],a[11294],a[11295],a[11296],a[11297]],{"am":a[11298],"pm":a[11299]},[a[11300],a[11301],a[11302],a[11303],a[11304],a[11305],a[11306],a[11307],a[11308],a[11309],a[11310],a[11311]],[a[11312],a[11313],a[11314],a[11315],a[11316],a[11317],a[11318],a[11319],a[11320],a[11321],a[11322],a[11323]],[a[11324],a[11325],a[11326],a[11327]],[a[11328],a[11329],a[11326],a[11327]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"LKR":a[11330],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"MYR":a[3433],"NZD":a[499],"SGD":a[11331],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"MYR":a[3433],"NZD":a[499],"SGD":a[588],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[11332],"GyMMMd":a[11333],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[1333],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[521],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[1334],"yMM":a[522],"yMMM":a[524],"yMMMEd":a[8745],"yMMMM":a[526],"yMMMd":a[11334],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[11335],"long":a[1250],"medium":a[601],"short":a[3550]},[a[11336],a[11337],a[11338],a[11339],a[11340],a[11341],a[11342],a[11343],a[11344],a[11345],a[11346],a[11347]],[a[11348],a[11349],a[11350],a[11351],a[11340],a[11352],a[11353],a[11354],a[11355],a[11356],a[11357],a[11358]],[a[11359],a[11360],a[11350],a[11361],a[11340],a[11352],a[11353],a[11362],a[11363],a[11364],a[11365],a[11366]],[a[11343],a[11367],a[11368],a[11369],a[11370],a[11371],a[11372]],[a[11373],a[11374],a[11375],a[11376],a[11377],a[11378],a[11379]],[a[11380],a[11381],a[11382],a[11383],a[11384],a[11385],a[11386]],{"am":a[11387],"pm":a[11388]},[a[11389],a[11390],a[11391],a[11392]],[a[11393],a[11394],a[11391],a[11392]],[a[11395],a[11396],a[11397],a[11398]],[a[11399],a[11400],a[11401],a[11402],a[11403],a[11404],a[11405],a[11406],a[11407],a[11408],a[11409],a[11410]],[a[11411]],[a[590],a[450],a[62],a[60],a[450],a[450],a[534],a[1338],a[90],a[88],a[29],a[1338]],[a[8499],a[11412],a[8497],a[11413],a[2970],a[11414],a[8470],a[11415],a[11416],a[11417],a[10648],a[11418]],[a[11419],a[11420],a[11421],a[11422],a[11423],a[11424],a[11425],a[11426],a[11427],a[11428],a[11429],a[11430]],[a[534],a[693],a[58],a[1763],a[1763],a[62],a[90]],[a[2898],a[11431],a[11432],a[11433],a[11434],a[2877],a[97]],[a[11435],a[11436],a[11437],a[11438],a[11439],a[11440],a[11441]],{"am":a[11442],"pm":a[11443]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KES":a[2913],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"UGX":a[2657],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[509],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[4814],"GyMMMEd":a[11444],"GyMMMd":a[11445],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"mmss":a[39],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[598],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[11446],"long":a[11447],"medium":a[527],"short":a[1337]},{"full":a[11448],"long":a[11449],"medium":a[28],"short":a[27]},[a[11450],a[11451],a[11452],a[11453],a[11454],a[11455],a[11456],a[11457],a[11458],a[11459],a[11460],a[11461]],[a[11462],a[11463],a[11464],a[11465],a[11466],a[11467],a[11468],a[11469],a[11470],a[11471],a[11472],a[11473]],[a[11474],a[11475],a[11476],a[11477],a[11478],a[11479],a[11480]],[a[11481],a[11482],a[11483],a[11484],a[11485],a[11486],a[11487]],[a[11488],a[11489],a[11490],a[11491],a[11492],a[11493],a[11494]],[a[11495]],[a[11496]],{"am":a[11497],"pm":a[11498]},[a[11499],a[11500],a[11501],a[11502],a[11503],a[11504],a[11505],a[11506],a[11507],a[11508],a[11509],a[11510],a[11511]],[a[11512],a[11513],a[11514],a[11515],a[11516],a[11517],a[11518],a[11519],a[11520],a[11521],a[11522],a[11523],a[11524]],[a[11525],a[11526],a[11527],a[11528]],[a[11529],a[11526],a[11527],a[11528]],[a[11530],a[11531],a[11532],a[11533]],[a[11534],a[11535],a[11536],a[11537],a[11538],a[11539],a[11540],a[11541],a[11542],a[11543],a[11544],a[11545],a[11546],a[11547]],[a[11548]],[a[11549],a[11550],a[11551],a[11552],a[11553],a[11554],a[11555],a[11556],a[11557],a[11558],a[11559],a[11560]],[a[11561]],[a[11562],a[11563],a[11564],a[11565],a[11566],a[11567],a[11568],a[11569],a[11570],a[11571],a[11572],a[11573]],[a[11574],a[11575],a[11576],a[11577],a[11578],a[11579],a[11580],a[11581],a[11582],a[11583],a[11584],a[11585]],[a[11586]],[a[11587]],[a[11588],a[11589],a[11590],a[11591],a[11592],a[11593],a[11594],a[11595],a[11596],a[11597],a[11598],a[11599],a[11600],a[11601],a[11602],a[11603],a[11604],a[11605],a[11606],a[11607],a[11608],a[11609],a[11610],a[11611],a[11612],a[11613],a[11614],a[11615],a[11616],a[11617],a[11618],a[11619],a[11620],a[11621],a[11622],a[11623],a[11624],a[11625],a[11626],a[11627],a[11628],a[11629],a[11630],a[11631],a[11632],a[11633],a[11634],a[11635],a[11636],a[11637],a[11638],a[11639],a[11640],a[11641],a[11642],a[11643],a[11644],a[11645],a[11646],a[11647],a[11648],a[11649],a[11650],a[11651],a[11652],a[11653],a[11654],a[11655],a[11656],a[11657],a[11658],a[11659],a[11660],a[11661],a[11662],a[11663],a[11664],a[11665],a[11666],a[11667],a[11668],a[11669],a[11670],a[11671],a[11672],a[11673],a[11674],a[11675],a[11676],a[11677],a[11678],a[11679],a[11680],a[11681],a[11682],a[11683],a[11684],a[11685],a[11686],a[11687],a[11688],a[11689],a[11690],a[11691],a[11692],a[11693],a[11694],a[11695],a[11696],a[11697],a[11698],a[11699],a[11700],a[11701],a[11702],a[11703],a[11704],a[11705],a[11706],a[11707],a[11708],a[11709],a[11710],a[11711],a[11712],a[11713],a[11714],a[11715],a[11716],a[11717],a[11718],a[11719],a[11720],a[11721],a[11722],a[11723],a[11724],a[11725],a[11726],a[11727],a[11728],a[11729],a[11730],a[11731],a[11732],a[11733],a[11734],a[11735],a[11736],a[11737],a[11738],a[11739],a[11740],a[11741],a[11742],a[11743],a[11744],a[11745],a[11746],a[11747],a[11748],a[11749],a[11750],a[11751],a[11752],a[11753],a[11754],a[11755],a[11756],a[11757],a[11758],a[11759],a[11760],a[11761],a[11762],a[11763],a[11764],a[11765],a[11766],a[11767],a[11768],a[11769],a[11770],a[11771],a[11772],a[11773],a[11774],a[11775],a[11776],a[11777],a[11778],a[11779],a[11780],a[11781],a[11782],a[11783],a[11784],a[11785],a[11786],a[11787],a[11788],a[11789],a[11790],a[11791],a[11792],a[11793],a[11794],a[11795],a[11796],a[11797],a[11798],a[11799],a[11800],a[11801],a[11802],a[11803],a[11804],a[11805],a[11806],a[11807],a[11808],a[11809],a[11810],a[11811],a[11812],a[11813],a[11814],a[11815],a[11816],a[11817],a[11818],a[11819],a[11820],a[11821],a[11822],a[11823]],[a[11824],a[11825],a[11826],a[11827],a[11828],a[11829],a[11830],a[11831],a[11832],a[11833],a[11834],a[11835]],[a[11836]],[a[11837],a[11838]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"full":a[11839],"long":a[50],"medium":a[51],"short":a[52]},[a[11840],a[11841],a[776],a[777],a[778],a[11842],a[11843],a[11844],a[770],a[771],a[11845],a[11846]],[a[11840],a[11847],a[787],a[788],a[789],a[11842],a[11843],a[11844],a[783],a[11848],a[11845],a[11849]],[a[753],a[753],a[11850],a[754],a[11851],a[756],a[11852]],[a[11853],a[11854],a[11855],a[761],a[11856],a[11857],a[11858]],{"am":a[11859],"pm":a[11860]},{"full":a[11861],"long":a[50],"medium":a[51],"short":a[52]},[a[732],a[733],a[734],a[11862],a[736],a[737],a[738],a[739],a[740],a[11863],a[742],a[743]],[a[744],a[745],a[734],a[11864],a[736],a[737],a[738],a[747],a[748],a[11865],a[750],a[751]],[a[11853],a[11854],a[11866],a[761],a[11867],a[11857],a[11858]],[a[11868],a[11869],a[11870],a[11871],a[11872],a[11873],a[11874],a[11875],a[8963],a[11876],a[11877],a[11878]],[a[11879],a[11880],a[11881],a[11882],a[11883],a[11884],a[11885],a[11886],a[11887],a[11888],a[11889],a[11890]],[a[11891],a[9198],a[9199],a[8499],a[9176],a[11892],a[9164]],[a[11893],a[11894],a[9203],a[9204],a[9205],a[11895],a[11896]],{"AUD":a[485],"BRL":a[486],"BWP":a[1338],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"ZAR":a[590]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[1949],"GyMMMd":a[1515],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[594],"MMM":a[31],"MMMEd":a[517],"MMMMEd":a[518],"MMMMd":a[813],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[598],"yMM":a[522],"yMMM":a[524],"yMMMEd":a[599],"yMMMM":a[526],"yMMMd":a[527],"yMd":a[600],"yQQQ":a[47],"yQQQQ":a[48]},[a[90],a[535],a[450],a[87],a[450],a[90],a[90],a[58],a[90],a[536],a[56],a[88]],[a[11897],a[11898],a[11899],a[11900],a[11901],a[1804],a[11902],a[11903],a[545],a[11904],a[11905],a[11906]],[a[11907],a[11908],a[11909],a[11910],a[11901],a[11911],a[11912],a[11913],a[11914],a[11915],a[11916],a[11917]],[a[90],a[450],a[88],a[1338],a[88],a[535],a[88]],[a[11918],a[11919],a[11920],a[11921],a[11922],a[11923],a[11924]],[a[11925],a[11926],a[11927],a[11928],a[11929],a[11930],a[11931]],[a[11932],a[11933],a[1326],a[11934]],[a[1326],a[11934],a[163],a[164]],[a[11935],a[11936],a[1326],a[11934]],{"decimal":a[480],"group":a[481],"nan":a[11937],"percent":a[483],"infinity":a[484]},{"AUD":a[11938],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[11939],"TOP":a[3441],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[11940],"Ehms":a[11941],"Gy":a[22],"GyMMM":a[1412],"GyMMMEd":a[11942],"GyMMMd":a[11943],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[11944],"MMM":a[31],"MMMEd":a[11945],"MMMMEd":a[11946],"MMMMd":a[520],"MMMd":a[519],"Md":a[1760],"d":a[35],"h":a[5463],"hm":a[5464],"hms":a[5465],"mmss":a[39],"ms":a[39],"y":a[40],"yM":a[1761],"yMEd":a[11947],"yMM":a[1385],"yMMM":a[524],"yMMMEd":a[11948],"yMMMM":a[526],"yMMMd":a[592],"yMd":a[1389],"yQQQ":a[5818],"yQQQQ":a[11949]},{"full":a[11950],"long":a[531],"medium":a[527],"short":a[9476]},[a[536],a[11951],a[450],a[56],a[450],a[451],a[88],a[58],a[87],a[87],a[62],a[58]],[a[11952],a[11953],a[2970],a[11954],a[3366],a[11955],a[11956],a[11957],a[11958],a[11959],a[2878],a[3116]],[a[11960],a[11961],a[11962],a[172],a[11963],a[11964],a[11965],a[11966],a[11967],a[11968],a[11969],a[11970]],[a[1338],a[1338],a[90],a[11971],a[1338],a[57],a[57]],[a[11972],a[11973],a[10978],a[11974],a[11975],a[11976],a[4585]],[a[11977],a[11978],a[11979],a[11980],a[11981],a[11982],a[11983]],{"am":a[11984],"pm":a[11985]},[a[11986],a[11987],a[4308],a[11988],a[11989],a[11990],a[11991],a[11992],a[11993],a[11994],a[11995],a[11996],a[11997]],[a[148],a[11998],a[11999],a[151],a[461],a[12000],a[12001],a[4321],a[12002],a[157],a[158],a[12003],a[12004]],[a[12005],a[12006],a[12007],a[12008]],[a[12009],a[12010],a[12011],a[12012]],[a[12013],a[12014],a[167],a[168],a[12015],a[12016],a[171],a[172],a[12017],a[174],a[175],a[176],a[177],a[178]],[a[12018],a[12019],a[12020],a[12021],a[12022],a[12023],a[12024],a[12025],a[12026],a[12027],a[12028],a[12029]],[a[12030]],[a[12031],a[12032],a[12033],a[461],a[462],a[12034],a[464],a[465],a[12035],a[467],a[12036],a[12037]],{"positivePattern":a[12038],"negativePattern":a[12039]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TRY":a[3492],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[1804],a[6372],a[12040],a[12041],a[9264],a[10952],a[2808],a[12042],a[12043],a[10951],a[12044],a[12045]],[a[12046],a[12047],a[12048],a[12049],a[12050],a[12051],a[12052],a[12053],a[12054],a[8970],a[12055],a[12056]],[a[8934],a[10234],a[12057],a[12058],a[9176],a[11869],a[3200]],[a[8981],a[12059],a[12060],a[12061],a[12062],a[12063],a[12064]],[a[694],a[694],a[450],a[1309],a[450],a[694],a[694],a[6350],a[57],a[62],a[56],a[60]],[a[6351],a[6354],a[2970],a[12065],a[3366],a[4640],a[4641],a[6355],a[12066],a[12067],a[12068],a[12069]],[a[6360],a[12070],a[3105],a[12071],a[6364],a[6365],a[12072],a[6367],a[12073],a[12074],a[12075],a[12076]],[a[58],a[58],a[58],a[58],a[58],a[58],a[58]],[a[12077],a[12078],a[12079],a[12080],a[12081],a[12082],a[12083]],[a[12084],a[12085],a[12086],a[12087],a[12088],a[12089],a[12090]],{"am":a[12091],"pm":a[12092]},[a[12093],a[12094],a[163],a[164]],[a[12095],a[12096],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[12098],"GyMMMd":a[12099],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[12100],"MMM":a[31],"MMMEd":a[12101],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[12102],"yMMM":a[524],"yMMMEd":a[12103],"yMMMd":a[12104],"yMd":a[2659],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[12105],"long":a[12106],"medium":a[12104],"short":a[2006]},[a[12107],a[12108],a[12109],a[12110],a[1223],a[12111],a[12112],a[12113],a[12114],a[12115],a[12116],a[12117]],[a[12107],a[12108],a[12109],a[12110],a[1223],a[12111],a[12112],a[12113],a[12114],a[12115],a[12118],a[12117]],[a[825],a[836],a[833],a[3759],a[3760],a[853],a[1227]],[a[12119],a[12120],a[12121],a[12122],a[12123],a[12124],a[12125]],[a[12126],a[12127],a[12128],a[12129],a[12130],a[12131],a[12132]],[a[12133]],{"am":a[12134],"pm":a[12135]},[a[12136],a[12137],a[163],a[164]],[a[12138],a[12139],a[12140],a[12141],a[12142],a[12143],a[12144],a[12145],a[12146],a[12147],a[12148],a[12149]],[a[12150]],[a[12151],a[12152]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[6194],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[1646],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[1513],"GyMMMEd":a[1514],"GyMMMd":a[1515],"H":a[26],"HHmm":a[27],"HHmmss":a[28],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[1382],"MMM":a[31],"MMMEd":a[1333],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"Md":a[1384],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1385],"yMEd":a[1386],"yMMM":a[1525],"yMMMEd":a[525],"yMMMM":a[1526],"yMMMd":a[527],"yMd":a[1389],"yQQQ":a[528],"yQQQQ":a[12153]},{"full":a[12154],"long":a[12155],"medium":a[12156],"short":a[1391]},[a[6559],a[12157],a[6589],a[9352],a[6562],a[10168],a[12157],a[6559],a[12158],a[6563],a[12157],a[12159]],[a[12160],a[12161],a[12162],a[12163],a[12164],a[12165],a[12166],a[12167],a[12168],a[12169],a[12170],a[12171]],[a[12172],a[12173],a[12174],a[12175],a[12176],a[12177],a[12178],a[12179],a[12180],a[12181],a[12182],a[12183]],[a[6558],a[12184],a[12158],a[6559],a[10168],a[12184],a[6559]],[a[12185],a[12186],a[12187],a[12188],a[12189],a[12190],a[10175]],[a[12191],a[12192],a[12193],a[12194],a[12195],a[12196],a[1577]],{"am":a[12197],"pm":a[12198]},[a[12199],a[12200],a[12201],a[12202],a[12203],a[12204],a[12205],a[12206],a[12207],a[12208],a[12209],a[12210],a[12211]],[a[9822],a[12212],a[9824],a[12213],a[12214],a[2130],a[2131],a[9827],a[9828],a[9829],a[12215],a[9831],a[12216]],[a[12217],a[12218],a[12219],a[12220],a[12221],a[12222],a[12223],a[12224],a[12225],a[7331],a[12226],a[12227],a[12228]],[a[12229],a[12230],a[12231],a[12232],a[12233],a[12234],a[12235],a[12236],a[12237],a[12238],a[12239],a[12240],a[12241]],[a[12242],a[2152],a[12243],a[2154]],[a[12242],a[2152],a[163],a[2154]],[a[12244],a[12245],a[163],a[2154]],[a[12246],a[12247],a[12248],a[12249],a[2161],a[2162],a[2163],a[12250],a[12251],a[2166],a[9844],a[12252],a[2169],a[2170]],[a[12253],a[12254],a[12255],a[12256],a[12257],a[12258],a[12259],a[12260],a[12261],a[12262],a[12263],a[12264]],[a[1731],a[1732],a[12265],a[1734],a[12266],a[12267],a[12268],a[12269],a[12270],a[12271],a[1741],a[12272]],[a[12273],a[12274],a[12275],a[12276],a[12277],a[12278],a[12279],a[12280],a[12281],a[12282],a[12283],a[12284]],[a[9855],a[2197],a[12285],a[12286],a[12287],a[12288],a[9860],a[9861],a[2204],a[12289],a[12290],a[12291]],[a[12292],a[12293],a[12294],a[12295],a[12296],a[12297],a[12298],a[12299],a[12300],a[12301],a[12302],a[12303],a[12304],a[12305],a[12306],a[12307],a[12308],a[12309],a[12310],a[12311],a[12312],a[12313],a[12314],a[12315],a[12316],a[12317],a[12318],a[12319],a[12320],a[12321],a[12322],a[12323],a[12324],a[12325],a[12326],a[12327],a[12328],a[12329],a[12330],a[12331],a[12332],a[12333],a[12334],a[12335],a[12336],a[12337],a[12338],a[12339],a[12340],a[12341],a[12342],a[12343],a[12344],a[12345],a[12346],a[12347],a[12348],a[12349],a[12350],a[12351],a[12352],a[12353],a[12354],a[12355],a[12356],a[12357],a[12358],a[12359],a[12360],a[12361],a[12362],a[12363],a[12364],a[12365],a[12366],a[12367],a[12368],a[12369],a[12370],a[12371],a[12372],a[12373],a[12374],a[12375],a[12376],a[12377],a[12378],a[12379],a[12380],a[12381],a[12382],a[12383],a[12384],a[12385],a[12386],a[12387],a[12388],a[12389],a[12390],a[12391],a[12392],a[12393],a[12394],a[12395],a[12396],a[12397],a[12398],a[12399],a[12400],a[12401],a[12402],a[12403],a[12404],a[12405],a[12406],a[12407],a[12408],a[12409],a[12410],a[12411],a[12412],a[12413],a[12414],a[12415],a[12416],a[12417],a[12418],a[12419],a[12420],a[12421],a[12422],a[12423],a[12424],a[12425],a[12426],a[12427],a[12428],a[12429],a[12430],a[12431],a[12432],a[12433],a[12434],a[12435],a[12436],a[12437],a[12438],a[12439],a[12440],a[12441],a[12442],a[12443],a[12444],a[12445],a[12446],a[12447],a[12448],a[12449],a[12450],a[12451],a[12452],a[12453],a[12454],a[12455],a[12456],a[12457],a[12458],a[12459],a[12460],a[12461],a[12462],a[12463],a[12464],a[12465],a[12466],a[12467],a[12468],a[12469],a[12470],a[12471],a[12472],a[12473],a[12474],a[12475],a[12476],a[12477],a[12478],a[12479],a[12480],a[12481],a[12482],a[12483],a[12484],a[12485],a[12486],a[12487],a[12488],a[12489],a[12490],a[12491],a[12492],a[12493],a[12494],a[12495],a[12496],a[12497],a[12498],a[12499],a[12500],a[12501],a[12502],a[12503],a[12504],a[12505],a[12506],a[12507],a[12508],a[12509],a[12510],a[12511],a[12512],a[12513],a[12514],a[12515],a[12516],a[12517],a[12518],a[12519],a[12520],a[12521],a[12522],a[12523],a[12524],a[12525],a[10099],a[12526]],[a[12527],a[12528],a[12529],a[12530],a[12531],a[12532],a[12533],a[12534],a[12535],a[12536],a[12537],a[12538]],[a[12539],a[12540],a[10102],a[12541],a[2448],a[12542],a[2450],a[2451],a[10104],a[10105],a[2454],a[2455]],{"decimal":a[481],"group":a[587],"nan":a[12543],"percent":a[483],"infinity":a[484]},{"JPY":a[1381],"UAH":a[10109],"UAK":a[12544],"XAF":a[503],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[593],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[808],"GyMMMd":a[809],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[810],"MMM":a[31],"MMMEd":a[811],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[9209],"yMMM":a[524],"yMMMEd":a[819],"yMMMd":a[820],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[822],"long":a[823],"medium":a[820],"short":a[1337]},[a[3746],a[9374],a[3748],a[3749],a[12545],a[3751],a[9376],a[3753],a[7172],a[3755],a[3756],a[3757]],[a[9377],a[9378],a[9379],a[12546],a[9381],a[9382],a[9383]],{"am":a[12547],"pm":a[12548]},[a[12549],a[12550],a[163],a[164]],[a[920],a[921],a[12551],a[12552],a[3792],a[3793],a[926],a[927],a[928],a[929],a[12553],a[12554]],[a[12555],a[12556]],{"decimal":a[480],"group":a[481],"nan":a[12557],"percent":a[483],"infinity":a[484]},[a[9377],a[12558],a[9379],a[12546],a[9381],a[9382],a[9383]],[a[12555],a[12556],a[163],a[164]],[a[12549],a[12556],a[163],a[164]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"PKR":a[3432],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[30],"MMM":a[31],"MMMEd":a[32],"MMMMd":a[12559],"MMMd":a[33],"Md":a[662],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[43],"yMMMEd":a[44],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[12560],"long":a[12561],"medium":a[527],"short":a[665]},[a[1083],a[12562],a[12563],a[12564],a[3738],a[3751],a[3740],a[12565],a[12566],a[12567],a[12568],a[3745]],[a[12569],a[12570],a[12571],a[12572],a[12573],a[12574],a[12575]],[a[12576],a[12577],a[12578],a[12579],a[12580],a[12581],a[12582],a[12583],a[12584],a[12585],a[12586],a[12587]],[a[12588],a[12589],a[12590],a[12591],a[12580],a[12581],a[12582],a[12592],a[12593],a[12594],a[12595],a[12596]],[a[7322],a[6588],a[6559],a[10168],a[12184],a[6563],a[6561]],[a[12597],a[12598],a[12599],a[12600],a[12601],a[12602],a[12603]],[a[12604],a[12605],a[12606],a[12607],a[12608],a[7347],a[12609]],[a[12610],a[12611],a[163],a[164]],[a[12612],a[2197],a[12613],a[12614],a[12615],a[12616],a[12617],a[12618],a[12619],a[12620],a[12621],a[12622]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"UZS":a[12623],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[694],a[535],a[450],a[58],a[450],a[1309],a[1309],a[58],a[90],a[536],a[56],a[60]],[a[12624],a[4255],a[2970],a[540],a[3366],a[12625],a[12626],a[12627],a[5645],a[546],a[12628],a[12629]],[a[12630],a[12631],a[11962],a[12632],a[3366],a[12625],a[12626],a[12633],a[12634],a[12635],a[12636],a[12637]],[a[694],a[60],a[90],a[57],a[1338],a[534],a[90]],[a[12638],a[12639],a[12640],a[12641],a[9219],a[2898],a[12642]],[a[12643],a[12644],a[12645],a[12646],a[12647],a[1797],a[12648]],{"am":a[12649],"pm":a[3233]},[a[12650],a[87],a[12651],a[164]],[a[205],a[206],a[12652],a[12653],a[12654],a[12655],a[211],a[12656],a[12657],a[12658],a[12659],a[12660]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"UZS":a[12661],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[12662],a[12663],a[12664],a[12665],a[12666],a[113],a[114],a[12667],a[12668],a[12669],a[12670],a[12671]],[a[12672],a[12673],a[12674],a[12675],a[12676],a[12677],a[12678]],{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"LRD":a[588],"MXN":a[498],"NZD":a[499],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[12679],a[12680],a[12681],a[12682],a[12683],a[113],a[114],a[12684],a[12685],a[12686],a[12687],a[12688]],[a[12689],a[12690],a[12691],a[12692],a[12693],a[12694],a[12695]],[a[11875],a[12696],a[12697],a[12698],a[12699],a[12700],a[12701],a[12702],a[12703],a[11891],a[12704],a[10341]],[a[12705],a[12706],a[12707],a[12708],a[12709],a[12710],a[12711],a[12712],a[12713],a[12714],a[12715],a[12716]],[a[12717],a[10234],a[12718],a[8499],a[12719],a[12720],a[3200]],[a[12721],a[12722],a[12723],a[12724],a[12725],a[12726],a[12727]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[12728],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[514],"GyMMMd":a[12729],"H":a[26],"Hm":a[1656],"Hms":a[1657],"M":a[29],"MEd":a[12730],"MMM":a[31],"MMMEd":a[12731],"MMMMEd":a[1519],"MMMMd":a[813],"MMMd":a[519],"MMdd":a[521],"Md":a[12732],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"mmss":a[39],"ms":a[39],"y":a[40],"yM":a[597],"yMEd":a[12733],"yMM":a[12734],"yMMM":a[524],"yMMMEd":a[3431],"yMMMM":a[12735],"yMMMd":a[3447],"yMd":a[600],"yQQQ":a[528],"yQQQQ":a[529]},{"full":a[12736],"long":a[12737],"medium":a[1251],"short":a[721]},[a[12738],a[12739],a[12740],a[12741],a[12742],a[12743],a[12744],a[12745],a[12746],a[12747],a[12748],a[12749]],[a[12750],a[12751],a[12752],a[12753],a[12754],a[12755],a[12756],a[12757],a[12758],a[12759],a[12760],a[12761]],[a[12762],a[12763],a[12764],a[12765],a[12766],a[12767],a[12768]],[a[12762],a[12769],a[12770],a[12771],a[12772],a[12773],a[12774]],[a[12775],a[12776],a[12777],a[12778],a[12779],a[12780],a[12781]],{"am":a[12782],"pm":a[12783]},[a[12784],a[12785],a[163],a[164]],[a[12786],a[472]],{"full":a[12787],"long":a[667],"medium":a[12788],"short":a[46]},[a[534],a[535],a[450],a[1338],a[450],a[694],a[694],a[89],a[90],a[88],a[56],a[60]],[a[2474],a[1340],a[12789],a[12790],a[1343],a[7478],a[7479],a[12791],a[1347],a[12792],a[2480],a[1429]],[a[12793],a[12794],a[12795],a[12796],a[12797],a[12798],a[12799],a[12800],a[12801],a[12802],a[12803],a[12804]],[a[90],a[450],a[88],a[560],a[60],a[535],a[1762]],[a[12805],a[12806],a[12807],a[12808],a[12809],a[9126],a[12810]],[a[12811],a[12812],a[12813],a[12814],a[12815],a[12816],a[12817]],{"am":a[12818],"pm":a[12819]},[a[12820],a[12821],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[2718],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[31],"MEd":a[2917],"MMM":a[31],"MMMEd":a[2917],"MMMd":a[2830],"Md":a[2830],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[41],"yMEd":a[42],"yMMM":a[524],"yMMMEd":a[2920],"yMMMd":a[2832],"yMd":a[46],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[2963],"long":a[2730],"medium":a[2832],"short":a[46]},[a[534],a[451],a[450],a[58],a[450],a[693],a[451],a[12822],a[451],a[59],a[59],a[57]],[a[5668],a[12823],a[4485],a[3960],a[541],a[12824],a[12825],a[12826],a[12827],a[12828],a[12829],a[12830]],[a[12831],a[12832],a[12833],a[12834],a[12835],a[12836],a[12837],a[12838],a[12839],a[12840],a[12841],a[12842]],[a[90],a[450],a[1762],a[450],a[535],a[535],a[90]],[a[1804],a[12843],a[12844],a[12845],a[12846],a[1809],a[6376]],[a[12847],a[12848],a[12849],a[12850],a[12851],a[12852],a[12853]],[a[2953],a[12854],a[163],a[164]],{"decimal":a[481],"group":a[4510],"nan":a[482],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"RUB":a[12855],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[90],a[693],a[693],a[90],a[62],a[62],a[450]],[a[12856],a[12857],a[12858],a[12859],a[12860],a[12861],a[12862]],[a[12863],a[7447],a[12864],a[12865],a[12866],a[12867],a[12868]],{"am":a[12869],"pm":a[12870]},[a[12871],a[12872],a[163],a[164]],[a[12873],a[12874],a[163],a[164]],[a[12875],a[12876],a[12877],a[12878],a[12879],a[12880],a[12881],a[12882],a[12883],a[12884],a[12885],a[12886]],[a[12887],a[12888],a[12889],a[12890],a[12891],a[12892],a[12893],a[12894],a[12895],a[12896],a[12897],a[12898]],[a[605],a[1463],a[1463],a[3051],a[603],a[607],a[605]],[a[12899],a[12900],a[12901],a[12902],a[12903],a[12904],a[12905]],[a[12906],a[12907],a[12908],a[12909],a[12910],a[12911],a[12912]],{"am":a[12913],"pm":a[12914]},[a[7245],a[12915],a[163],a[164]],[a[12916],a[12917],a[163],a[164]],{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[12918],"Ehm":a[20],"Ehms":a[21],"Gy":a[512],"GyMMM":a[513],"GyMMMEd":a[12919],"GyMMMd":a[12920],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[4712],"MMMd":a[4713],"Md":a[595],"d":a[35],"h":a[4714],"hm":a[37],"hms":a[38],"ms":a[39],"y":a[40],"yM":a[1523],"yMEd":a[1334],"yMM":a[1761],"yMMM":a[524],"yMMMEd":a[12921],"yMMMM":a[526],"yMMMd":a[12922],"yMd":a[1252],"yQQQ":a[47],"yQQQQ":a[48]},{"full":a[12923],"long":a[12924],"medium":a[12922],"short":a[52]},[a[12925],a[12926],a[12927],a[12928],a[12929],a[4724],a[4725],a[12930],a[12931],a[12932],a[12933],a[12934]],[a[12935],a[12936],a[12937],a[12938],a[12939],a[12940],a[4752]],{"am":a[12941],"pm":a[12942]},[a[12943],a[12944],a[12945],a[12946],a[12947],a[12948],a[12949],a[12950],a[12951],a[12952],a[12953],a[4776],a[12954],a[12955]],[a[4779],a[12956],a[4781],a[4782],a[4783],a[4784],a[4785],a[4786],a[4787],a[4788],a[4789],a[4776],a[4790],a[4791]],[a[12957],a[12958],a[12959],a[12960],a[12961],a[12962],a[12963],a[12964],a[12965],a[12966],a[12967],a[12968]],[a[12969],a[12970],a[12971],a[12972],a[12973],a[12974],a[12975],a[12976],a[12977],a[12978],a[12979],a[12980]],[a[12981],a[12982],a[12983],a[12984],a[12985],a[12986],a[12987]],[a[12988],a[12989],a[12990],a[12984],a[12985],a[12991],a[12992]],{"am":a[12993],"pm":a[12994]},[a[652],a[10377],a[163],a[164]],[a[12995],a[12996],a[163],a[164]],[a[12997],a[12958],a[12998],a[12960],a[12999],a[12962],a[13000],a[12964],a[12965],a[13001],a[12967],a[13002]],[a[13003],a[13004],a[13005],a[13006],a[13007],a[13008],a[13009],a[13010],a[13011],a[13012],a[13013],a[13014]],[a[12981],a[12982],a[13015],a[13016],a[13017],a[13018],a[13019]],[a[13020],a[13021],a[13022],a[13016],a[13017],a[13023],a[13024]],{"am":a[13025],"pm":a[13026]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[19],"Ehm":a[20],"Ehms":a[21],"Gy":a[22],"GyMMM":a[23],"GyMMMEd":a[24],"GyMMMd":a[25],"H":a[26],"Hm":a[27],"Hms":a[28],"M":a[450],"MEd":a[30],"MMM":a[1758],"MMMEd":a[517],"MMMd":a[519],"Md":a[595],"d":a[35],"h":a[36],"hm":a[37],"hms":a[38],"ms":a[596],"y":a[40],"yM":a[597],"yMEd":a[598],"yMMM":a[524],"yMMMEd":a[599],"yMMMd":a[45],"yMd":a[46],"yQQQ":a[528],"yQQQQ":a[529]},[a[10465],a[10466],a[10467],a[10468],a[10469],a[13027],a[10471]],{"E":a[16],"EHm":a[13028],"EHms":a[13029],"Ed":a[13030],"Ehm":a[13031],"Ehms":a[13032],"Gy":a[5795],"GyMMM":a[5796],"GyMMMEd":a[13033],"GyMMMd":a[5799],"H":a[13034],"Hm":a[27],"Hms":a[28],"M":a[5801],"MEd":a[13035],"MMM":a[31],"MMMEd":a[13036],"MMMMdd":a[13037],"MMMd":a[5806],"MMdd":a[1216],"Md":a[662],"d":a[5807],"h":a[13038],"hm":a[13039],"hms":a[13040],"ms":a[39],"y":a[5811],"yM":a[5814],"yMEd":a[13041],"yMM":a[5814],"yMMM":a[5814],"yMMMEd":a[13042],"yMMMM":a[5814],"yMMMd":a[5817],"yMd":a[665],"yQQQ":a[13043],"yQQQQ":a[13043]},{"full":a[5815],"long":a[5817],"medium":a[5817],"short":a[10142]},{"full":a[13044],"long":a[13045],"medium":a[13040],"short":a[13039]},[a[13046],a[5863],a[5864],a[5865],a[5866],a[5867],a[5868],a[5869],a[5870],a[5871],a[5872],a[5873]],[a[5833],a[13047],a[5851],a[5852],a[5853],a[5854],a[5855]],[a[13048],a[13049],a[13050],a[13051],a[13052],a[13053],a[13054]],[a[13055],a[13056],a[13057],a[13058],a[13059],a[13060],a[13061]],[a[13062]],{"am":a[13063],"pm":a[13064]},[a[5850],a[5851],a[5852],a[5853],a[5854],a[5855],a[5856],a[5857],a[5858],a[5859],a[13065],a[13066]],[a[5862],a[5863],a[5864],a[5865],a[5866],a[5867],a[5868],a[5869],a[5870],a[5871],a[13067],a[13068]],[a[5821],a[5822],a[5823],a[5824],a[5825],a[5826],a[5827],a[5828],a[5829],a[5830],a[5831],a[5832],a[13069]],[a[13046],a[5863],a[5864],a[5865],a[5866],a[5867],a[5868],a[5869],a[5870],a[5871],a[5872],a[5873],a[13070]],[a[13071],a[13072],a[163],a[164]],[a[5821],a[5822],a[5823],a[5824],a[5825],a[5826],a[5827],a[5828],a[5829],a[5830],a[5831],a[5832],a[13069],a[13073]],[a[13046],a[5863],a[5864],a[5865],a[5866],a[5867],a[5868],a[5869],a[5870],a[5871],a[5872],a[5873],a[13070],a[13074]],[a[13075]],[a[13076]],[a[13077]],[a[13078],a[13079],a[13080],a[13081],a[13082],a[13083],a[13084],a[13085],a[13086],a[13087],a[13088],a[13089],a[13090],a[13091],a[13092],a[13093],a[13094],a[13095],a[13096],a[13097],a[13098],a[13099],a[13100],a[13101],a[13102],a[13103],a[13104],a[13105],a[13106],a[13107],a[13108],a[13109],a[13110],a[13111],a[13112],a[13113],a[13114],a[13115],a[13116],a[13117],a[13118],a[13119],a[13120],a[13121],a[13122],a[13123],a[13124],a[13125],a[13126],a[13127],a[13128],a[13129],a[13130],a[13131],a[13132],a[13133],a[13134],a[13135],a[13136],a[13137],a[13138],a[13139],a[13140],a[13141],a[13142],a[13143],a[13144],a[13145],a[13146],a[13147],a[13148],a[13149],a[13150],a[13151],a[13152],a[13153],a[13154],a[13155],a[13156],a[13157],a[13158],a[13159],a[13160],a[13161],a[13162],a[13163],a[13164],a[13165],a[13166],a[13167],a[13168],a[13169],a[13170],a[13171],a[13172],a[13173],a[13174],a[13175],a[13176],a[13177],a[13178],a[13179],a[13180],a[13181],a[13182],a[13183],a[13184],a[13185],a[13186],a[13187],a[13188],a[13189],a[13190],a[13191],a[13192],a[13193],a[13194],a[13195],a[13196],a[13197],a[13198],a[13199],a[13200],a[13201],a[13202],a[13203],a[13204],a[13205],a[13206],a[13207],a[13208],a[13209],a[13210],a[13211],a[13212],a[13213],a[13214],a[13215],a[13216],a[13217],a[13218],a[13219],a[13220],a[13221],a[13222],a[13223],a[13224],a[13225],a[13226],a[13227],a[13228],a[13229],a[13230],a[13231],a[13232],a[13233],a[13234],a[13235],a[13236],a[13237],a[13238],a[13239],a[13240],a[13241],a[13242],a[13243],a[13244],a[13245],a[13246],a[13247],a[13248],a[13249],a[13250],a[13251],a[13252],a[13253],a[13254],a[13255],a[13256],a[13257],a[13258],a[13259],a[13260],a[13261],a[13262],a[13263],a[13264],a[13265],a[13266],a[13267],a[13268],a[13269],a[13270],a[13271],a[13272],a[13273],a[13274],a[13275],a[13276],a[13277],a[13278],a[13279],a[13280],a[13281],a[13282],a[13283],a[13284],a[13285],a[13286],a[13287],a[13288],a[13289],a[13290],a[13291],a[13292],a[13293],a[13294],a[13295],a[13296],a[13297],a[13298],a[13299],a[13300],a[13301],a[13302],a[13303],a[13304],a[13305],a[13306],a[13307],a[13308],a[13309],a[6175],a[6176],a[6177],a[6178]],[a[13310]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[6194],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILR":a[13311],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[6195],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[13028],"EHms":a[13029],"Ed":a[13030],"Ehm":a[13031],"Ehms":a[13032],"Gy":a[5795],"GyMMM":a[5796],"GyMMMEd":a[13033],"GyMMMd":a[5799],"H":a[13034],"HHmm":a[27],"Hm":a[27],"Hms":a[28],"M":a[29],"MEd":a[516],"MMM":a[31],"MMMEd":a[13036],"MMMMdd":a[5806],"MMMd":a[5806],"MMdd":a[1760],"Md":a[595],"d":a[5807],"h":a[13038],"hm":a[13039],"hms":a[13040],"ms":a[39],"y":a[5811],"yM":a[597],"yMEd":a[13312],"yMM":a[1761],"yMMM":a[5814],"yMMMEd":a[13042],"yMMMM":a[5814],"yMMMd":a[5817],"yMd":a[600],"yQQQ":a[13043],"yQQQQ":a[13043]},{"full":a[5815],"long":a[5817],"medium":a[5817],"short":a[1337]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILR":a[13311],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[6195],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[13028],"EHms":a[13029],"Ed":a[13030],"Ehm":a[13031],"Ehms":a[13032],"Gy":a[5795],"GyMMM":a[5796],"GyMMMEd":a[13033],"GyMMMd":a[5799],"H":a[13034],"Hm":a[27],"Hms":a[28],"M":a[5801],"MEd":a[13313],"MMM":a[31],"MMMEd":a[13036],"MMMMdd":a[5806],"MMMd":a[5806],"MMdd":a[34],"Md":a[3137],"d":a[5807],"h":a[13038],"hm":a[13039],"hms":a[13040],"ms":a[39],"y":a[5811],"yM":a[5814],"yMEd":a[13314],"yMM":a[5814],"yMMM":a[5814],"yMMMEd":a[13042],"yMMMM":a[5814],"yMMMd":a[5817],"yMd":a[5817],"yQQQ":a[13043],"yQQQQ":a[13043]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILR":a[13311],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[6195],"MOP":a[3430],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[13028],"EHms":a[13029],"Ed":a[13030],"Ehm":a[13031],"Ehms":a[13032],"Gy":a[5795],"GyMMM":a[5796],"GyMMMEd":a[13033],"GyMMMd":a[5799],"H":a[13034],"Hm":a[27],"Hms":a[28],"M":a[5801],"MEd":a[13313],"MMM":a[5801],"MMMEd":a[13036],"MMMMdd":a[5806],"MMMd":a[5806],"MMdd":a[34],"Md":a[3137],"d":a[5807],"h":a[13038],"hm":a[13039],"hms":a[13040],"ms":a[39],"y":a[5811],"yM":a[5814],"yMEd":a[13314],"yMM":a[5814],"yMMM":a[5814],"yMMMEd":a[13042],"yMMMM":a[5814],"yMMMd":a[5817],"yMd":a[5817],"yQQQ":a[13043],"yQQQQ":a[13043]},{"full":a[5815],"long":a[5817],"medium":a[5817],"short":a[52]},{"full":a[13044],"long":a[13315],"medium":a[13040],"short":a[13316]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILR":a[13311],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[6195],"MXN":a[498],"NZD":a[499],"SGD":a[588],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[13030],"Ehm":a[13317],"Ehms":a[13318],"Gy":a[5795],"GyMMM":a[5796],"GyMMMEd":a[13033],"GyMMMd":a[5799],"H":a[5800],"Hm":a[27],"Hms":a[28],"M":a[5801],"MEd":a[516],"MMM":a[31],"MMMEd":a[13036],"MMMMdd":a[13037],"MMMd":a[5806],"MMdd":a[1760],"Md":a[595],"d":a[5807],"h":a[13319],"hm":a[13039],"hms":a[13040],"ms":a[39],"y":a[5811],"yM":a[597],"yMEd":a[13041],"yMM":a[1761],"yMMM":a[5814],"yMMMEd":a[13042],"yMMMM":a[5814],"yMMMd":a[5817],"yMd":a[600],"yQQQ":a[13320],"yQQQQ":a[13321]},{"full":a[13322],"long":a[13323],"medium":a[13040],"short":a[13039]},[a[13324],a[13325],a[13326],a[13327],a[13328],a[13329],a[13330]],[a[13331]],[a[13332],a[13333],a[13071],a[13072]],[a[13071],a[13072],a[13071],a[13072]],[a[13334],a[13335],a[13336],a[13337],a[13338],a[13339],a[13340],a[13341],a[13342],a[13343],a[13344],a[13345],a[13346],a[13347]],[a[13348]],[a[13349],a[13350],a[13351],a[13352],a[13353],a[13354],a[13355],a[13356],a[13357],a[13358],a[13359],a[13360]],[a[13361]],[a[13362],a[13363],a[13364],a[13365],a[13366],a[13367],a[13368],a[13369],a[13370],a[13371],a[13372],a[13373]],[a[13374]],[a[5943],a[5944],a[13375],a[5946],a[13376],a[5948],a[5949],a[13377],a[5951],a[13378],a[5953],a[13379],a[13380],a[13381],a[5957],a[5958],a[13382],a[13383],a[13384],a[5962],a[5963],a[5964],a[5965],a[5966],a[13385],a[13386],a[5969],a[13387],a[5971],a[5972],a[13388],a[5974],a[5975],a[5976],a[5977],a[5978],a[13389],a[13390],a[13391],a[5982],a[5983],a[13392],a[5985],a[5986],a[5987],a[13393],a[13394],a[5990],a[5991],a[13395],a[13396],a[5994],a[13397],a[5996],a[13398],a[5998],a[13399],a[6000],a[13400],a[6002],a[13401],a[6004],a[6005],a[6006],a[13402],a[6008],a[6009],a[13403],a[6011],a[13404],a[13405],a[6014],a[6015],a[13406],a[6017],a[6018],a[6019],a[6020],a[6021],a[6022],a[6023],a[6024],a[6025],a[6026],a[6027],a[6028],a[6029],a[6030],a[6031],a[6032],a[6033],a[6034],a[13407],a[6036],a[6037],a[13408],a[13409],a[13410],a[13411],a[6042],a[13412],a[6044],a[6045],a[6046],a[6047],a[13413],a[13414],a[6050],a[6051],a[6052],a[6053],a[6054],a[6055],a[6056],a[13415],a[6058],a[6059],a[13416],a[6061],a[13417],a[6063],a[13418],a[6065],a[6066],a[13419],a[6068],a[13420],a[13421],a[6071],a[13422],a[13423],a[6074],a[6075],a[6076],a[6077],a[13424],a[6079],a[6080],a[6081],a[6082],a[13425],a[6084],a[6085],a[6086],a[6087],a[13426],a[6089],a[13427],a[6091],a[6092],a[13428],a[6094],a[6095],a[13429],a[13430],a[6098],a[6099],a[6100],a[13431],a[6102],a[13432],a[6104],a[6105],a[13433],a[6107],a[6108],a[13434],a[6110],a[13435],a[13436],a[13437],a[6114],a[6115],a[6116],a[6117],a[13438],a[13439],a[6120],a[13440],a[13441],a[6123],a[13442],a[6125],a[6126],a[13443],a[13444],a[13445],a[6130],a[6131],a[13446],a[6133],a[6134],a[13447],a[13448],a[6137],a[13449],a[6139],a[6140],a[13450],a[6142],a[6143],a[13451],a[13452],a[13453],a[13454],a[13455],a[6149],a[6150],a[13456],a[13457],a[13458],a[6154],a[6155],a[13459],a[6157],a[13460],a[13461],a[6160],a[6161],a[6162],a[13462],a[6164],a[6165],a[6166],a[6167],a[6168],a[6169],a[6170],a[13463],a[6172],a[6173],a[13464],a[6175],a[6176],a[6177],a[6178]],[a[13465]],[a[13466],a[13467]],{"decimal":a[480],"group":a[481],"nan":a[13468],"percent":a[483],"infinity":a[484]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[13030],"Ehm":a[13317],"Ehms":a[13318],"Gy":a[5795],"GyMMM":a[5796],"GyMMMEd":a[13033],"GyMMMd":a[5799],"H":a[5800],"Hm":a[27],"Hms":a[28],"M":a[5801],"MEd":a[3133],"MMM":a[31],"MMMEd":a[13036],"MMMMdd":a[13037],"MMMd":a[5806],"MMdd":a[521],"Md":a[3137],"d":a[5807],"h":a[13319],"hm":a[13039],"hms":a[13040],"ms":a[39],"y":a[5811],"yM":a[597],"yMEd":a[13041],"yMM":a[1761],"yMMM":a[5814],"yMMMEd":a[13042],"yMMMM":a[5814],"yMMMd":a[5817],"yMd":a[600],"yQQQ":a[13320],"yQQQQ":a[13321]},{"full":a[13469],"long":a[13470],"medium":a[5817],"short":a[13471]},{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[497],"MOP":a[3430],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},{"E":a[16],"EHm":a[17],"EHms":a[18],"Ed":a[13472],"Ehm":a[11940],"Ehms":a[11941],"Gy":a[5795],"GyMMM":a[5796],"GyMMMEd":a[13473],"GyMMMd":a[5799],"H":a[5800],"Hm":a[27],"Hms":a[28],"M":a[5801],"MEd":a[13474],"MMM":a[31],"MMMEd":a[13475],"MMMMdd":a[13037],"MMMd":a[5806],"MMdd":a[1216],"Md":a[662],"d":a[5807],"h":a[13319],"hm":a[13039],"hms":a[13040],"ms":a[39],"y":a[5811],"yM":a[1217],"yMEd":a[13476],"yMM":a[41],"yMMM":a[5814],"yMMMEd":a[13477],"yMMMM":a[5814],"yMMMd":a[5817],"yMd":a[665],"yQQQ":a[13320],"yQQQQ":a[13321]},{"full":a[13478],"long":a[5817],"medium":a[5817],"short":a[665]},[a[5850],a[5851],a[5852],a[5853],a[5854],a[5855],a[5856],a[5857],a[5858],a[5859],a[13065],a[13479]],[a[5862],a[5863],a[5864],a[5865],a[5866],a[5867],a[5868],a[5869],a[5870],a[5871],a[13067],a[13480]],{"AUD":a[805],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[1381],"KRW":a[6195],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[588],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506]},[a[1293],a[1294],a[13481],a[540],a[8468],a[542],a[543],a[13482],a[545],a[546],a[547],a[1586]],[a[13483],a[13484],a[13485],a[13486],a[9171],a[1302],a[9172],a[8425],a[13487],a[13488],a[1307],a[1589]],[a[90],a[450],a[88],a[88],a[90],a[451],a[450]],[a[8934],a[10968],a[9175],a[6396],a[8978],a[9177],a[8980]],[a[8981],a[13489],a[13490],a[13491],a[13492],a[13493],a[8987]],{"am":a[13494],"pm":a[13495]},{"decimal":a[480],"group":a[481],"nan":a[13496],"percent":a[483],"infinity":a[484]},{"AUD":a[485],"BRL":a[486],"CAD":a[487],"CNY":a[488],"EUR":a[491],"GBP":a[492],"HKD":a[493],"ILS":a[494],"INR":a[495],"JPY":a[496],"KRW":a[497],"MXN":a[498],"NZD":a[499],"THB":a[589],"TWD":a[500],"USD":a[501],"VND":a[502],"XAF":a[503],"XCD":a[504],"XOF":a[505],"XPF":a[506],"ZAR":a[590]}];b[1]=[{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][2],"timeFormats":b[0][3]},{"narrow":b[0][4],"short":b[0][5],"long":b[0][6]},{"narrow":b[0][7],"short":b[0][8],"long":b[0][9]},{"narrow":b[0][10],"short":b[0][10],"long":b[0][10]},{"narrow":b[0][12],"short":b[0][13],"long":b[0][13]},{"narrow":b[0][14],"short":b[0][15],"long":b[0][15]},{"narrow":b[0][16],"short":b[0][16],"long":b[0][16]},{"narrow":b[0][14],"short":b[0][17],"long":b[0][17]},{"narrow":b[0][18],"short":b[0][18],"long":b[0][18]},{"narrow":b[0][19],"short":b[0][19],"long":b[0][19]},{"narrow":b[0][20],"short":b[0][21],"long":b[0][21]},{"narrow":b[0][22],"short":b[0][22],"long":b[0][22]},{"narrow":b[0][12],"short":b[0][23],"long":b[0][23]},{"narrow":b[0][24],"short":b[0][24],"long":b[0][24]},{"narrow":b[0][12],"short":b[0][25],"long":b[0][26]},{"narrow":b[0][27],"short":b[0][27],"long":b[0][27]},{"narrow":b[0][28],"short":b[0][29],"long":b[0][29]},{"narrow":b[0][12],"short":b[0][30],"long":b[0][30]},{"narrow":b[0][31],"short":b[0][31],"long":b[0][31]},{"narrow":b[0][32],"short":b[0][32],"long":b[0][32]},{"decimal":b[0][34],"currency":b[0][35],"percent":b[0][36]},{"latn":b[0][37]},{"narrow":b[0][4],"short":b[0][5],"long":b[0][39]},{"medium":a[15],"availableFormats":b[0][42],"dateFormats":b[0][43],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][46],"long":b[0][47]},{"narrow":b[0][48],"short":b[0][49],"long":b[0][50]},{"narrow":b[0][52],"short":b[0][53],"long":b[0][54]},{"decimal":b[0][34],"currency":b[0][55],"percent":b[0][36]},{"latn":b[0][56]},{"medium":a[15],"availableFormats":b[0][42],"dateFormats":b[0][58],"timeFormats":b[0][3]},{"medium":a[15],"availableFormats":b[0][60],"dateFormats":b[0][61],"timeFormats":b[0][44]},{"narrow":b[0][62],"short":b[0][63],"long":b[0][64]},{"narrow":b[0][65],"short":b[0][66],"long":b[0][67]},{"narrow":b[0][69],"short":b[0][69],"long":b[0][70]},{"decimal":b[0][34],"currency":b[0][71],"percent":b[0][36]},{"medium":a[15],"availableFormats":b[0][73],"dateFormats":b[0][74],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][75],"long":b[0][76]},{"narrow":b[0][77],"short":b[0][78],"long":b[0][79]},{"narrow":b[0][81],"short":b[0][81],"long":b[0][82]},{"medium":a[15],"availableFormats":b[0][84],"dateFormats":b[0][85],"timeFormats":b[0][3]},{"narrow":b[0][86],"short":b[0][87],"long":b[0][88]},{"narrow":b[0][89],"short":b[0][90],"long":b[0][91]},{"narrow":b[0][93],"short":b[0][93],"long":b[0][93]},{"narrow":b[0][14],"short":b[0][94],"long":b[0][95]},{"narrow":b[0][96],"short":b[0][96],"long":b[0][97]},{"narrow":b[0][12],"short":b[0][25],"long":b[0][98]},{"medium":a[15],"availableFormats":b[0][100],"dateFormats":b[0][101],"timeFormats":b[0][3]},{"narrow":b[0][102],"short":b[0][103],"long":b[0][103]},{"narrow":b[0][104],"short":b[0][105],"long":b[0][105]},{"narrow":b[0][106],"short":b[0][106],"long":b[0][106]},{"narrow":b[0][14],"short":b[0][108],"long":b[0][108]},{"narrow":b[0][14],"short":b[0][109],"long":b[0][109]},{"narrow":b[0][110],"short":b[0][110],"long":b[0][111]},{"narrow":b[0][20],"short":b[0][112],"long":b[0][112]},{"narrow":b[0][113],"short":b[0][113],"long":b[0][113]},{"narrow":b[0][114],"short":b[0][115],"long":b[0][115]},{"narrow":b[0][116],"short":b[0][116],"long":b[0][116]},{"narrow":b[0][28],"short":b[0][117],"long":b[0][117]},{"narrow":b[0][12],"short":b[0][118],"long":b[0][118]},{"narrow":b[0][119],"short":b[0][119],"long":b[0][119]},{"narrow":b[0][120],"short":b[0][120],"long":b[0][120]},{"arab":b[0][122],"latn":b[0][37]},{"narrow":b[0][124],"short":b[0][124],"long":b[0][125]},{"medium":a[15],"availableFormats":b[0][127],"dateFormats":b[0][128],"timeFormats":b[0][3]},{"narrow":b[0][129],"short":b[0][130],"long":b[0][130]},{"arab":b[0][122],"latn":b[0][131]},{"arab":b[0][132],"latn":b[0][37]},{"narrow":b[0][134],"short":b[0][135],"long":b[0][136]},{"narrow":b[0][134],"short":b[0][136],"long":b[0][136]},{"medium":a[15],"availableFormats":b[0][137],"dateFormats":b[0][138],"timeFormats":b[0][3]},{"narrow":b[0][140],"short":b[0][141],"long":b[0][141]},{"narrow":b[0][142],"short":b[0][143],"long":b[0][143]},{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][146],"timeFormats":b[0][147]},{"narrow":b[0][12],"short":b[0][148],"long":b[0][149]},{"narrow":b[0][150],"short":b[0][151],"long":b[0][152]},{"narrow":b[0][154],"short":b[0][154],"long":b[0][154]},{"decimal":b[0][34],"currency":b[0][55],"percent":b[0][36],"secondaryGroupSize":2},{"beng":b[0][37],"latn":b[0][37]},{"medium":a[15],"availableFormats":b[0][156],"dateFormats":b[0][85],"timeFormats":b[0][3]},{"narrow":b[0][45],"short":b[0][157],"long":b[0][158]},{"narrow":b[0][159],"short":b[0][160],"long":b[0][161]},{"narrow":b[0][163],"short":b[0][163],"long":b[0][164]},{"decimal":b[0][34],"currency":b[0][165],"percent":b[0][36]},{"medium":a[15],"availableFormats":b[0][167],"dateFormats":b[0][168],"timeFormats":b[0][44]},{"narrow":b[0][169],"short":b[0][170],"long":b[0][171]},{"narrow":b[0][172],"short":b[0][173],"long":b[0][174]},{"narrow":b[0][176],"short":b[0][176],"long":b[0][176]},{"latn":b[0][131]},{"medium":a[15],"availableFormats":b[0][178],"dateFormats":b[0][179],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][180],"long":b[0][180]},{"narrow":b[0][181],"short":b[0][182],"long":b[0][182]},{"medium":a[15],"availableFormats":b[0][184],"dateFormats":b[0][185],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][186],"long":b[0][187]},{"narrow":b[0][181],"short":b[0][188],"long":b[0][189]},{"narrow":b[0][190],"short":b[0][190],"long":b[0][191]},{"medium":a[15],"availableFormats":b[0][193],"dateFormats":b[0][61],"timeFormats":b[0][44]},{"narrow":b[0][194],"short":b[0][195],"long":b[0][196]},{"narrow":b[0][197],"short":b[0][198],"long":b[0][199]},{"narrow":b[0][201],"short":b[0][201],"long":b[0][202]},{"decimal":b[0][34],"currency":b[0][165],"percent":b[0][203]},{"medium":a[15],"availableFormats":b[0][204],"dateFormats":b[0][205],"timeFormats":b[0][206]},{"narrow":b[0][207],"short":b[0][208],"long":b[0][209]},{"narrow":b[0][210],"short":b[0][211],"long":b[0][212]},{"narrow":b[0][214],"short":b[0][214],"long":b[0][214]},{"narrow":b[0][216],"short":b[0][217],"long":b[0][218]},{"narrow":b[0][150],"short":b[0][219],"long":b[0][219]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][222]},{"narrow":b[0][224],"short":b[0][225],"long":b[0][226]},{"narrow":b[0][227],"short":b[0][228],"long":b[0][229]},{"narrow":b[0][163],"short":b[0][163],"long":b[0][231]},{"medium":a[1643],"availableFormats":b[0][232],"dateFormats":b[0][233],"timeFormats":b[0][234]},{"narrow":b[0][235],"short":b[0][236],"long":b[0][237]},{"narrow":b[0][238],"short":b[0][239],"long":b[0][240]},{"narrow":b[0][242],"short":b[0][243],"long":b[0][244]},{"narrow":b[0][20],"short":b[0][245],"long":b[0][245]},{"narrow":b[0][12],"short":b[0][246],"long":b[0][246]},{"narrow":b[0][12],"short":b[0][25],"long":b[0][247]},{"medium":a[15],"availableFormats":b[0][249],"dateFormats":b[0][61],"timeFormats":b[0][44]},{"narrow":b[0][250],"short":b[0][251],"long":b[0][252]},{"narrow":b[0][253],"short":b[0][254],"long":b[0][255]},{"narrow":b[0][256],"short":b[0][256],"long":b[0][257]},{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][258],"timeFormats":b[0][44]},{"narrow":b[0][150],"short":b[0][259],"long":b[0][259]},{"medium":a[15],"availableFormats":b[0][260],"dateFormats":b[0][261],"timeFormats":b[0][3]},{"narrow":b[0][262],"short":b[0][263],"long":b[0][263]},{"narrow":b[0][264],"short":b[0][265],"long":b[0][266]},{"narrow":b[0][268],"short":b[0][268],"long":b[0][268]},{"narrow":b[0][269],"short":b[0][270],"long":b[0][270]},{"narrow":b[0][271],"short":b[0][271],"long":b[0][271]},{"narrow":b[0][269],"short":b[0][25],"long":b[0][272]},{"narrow":b[0][273],"short":b[0][273],"long":b[0][273]},{"decimal":b[0][34],"currency":b[0][71],"percent":b[0][36],"secondaryGroupSize":2},{"beng":b[0][274],"latn":b[0][37]},{"medium":a[15],"availableFormats":b[0][276],"dateFormats":b[0][277],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][278],"long":b[0][279]},{"narrow":b[0][280],"short":b[0][281],"long":b[0][282]},{"narrow":b[0][284],"short":b[0][284],"long":b[0][284]},{"latn":b[0][37],"tibt":b[0][285]},{"medium":a[15],"availableFormats":b[0][287],"dateFormats":b[0][258],"timeFormats":b[0][44]},{"narrow":b[0][288],"short":b[0][289],"long":b[0][290]},{"narrow":b[0][291],"short":b[0][292],"long":b[0][293]},{"medium":a[15],"availableFormats":b[0][296],"dateFormats":b[0][297],"timeFormats":b[0][3]},{"narrow":b[0][298],"short":b[0][299],"long":b[0][299]},{"narrow":b[0][300],"short":b[0][301],"long":b[0][302]},{"narrow":b[0][304],"short":b[0][304],"long":b[0][304]},{"narrow":b[0][12],"short":b[0][305],"long":b[0][305]},{"deva":b[0][37],"latn":b[0][37]},{"medium":a[15],"availableFormats":b[0][306],"dateFormats":b[0][307],"timeFormats":b[0][44]},{"narrow":b[0][308],"short":b[0][309],"long":b[0][310]},{"narrow":b[0][311],"short":b[0][312],"long":b[0][313]},{"narrow":b[0][314],"short":b[0][314],"long":b[0][314]},{"narrow":b[0][14],"short":b[0][316],"long":b[0][316]},{"narrow":b[0][14],"short":b[0][317],"long":b[0][317]},{"narrow":b[0][318],"short":b[0][319],"long":b[0][320]},{"narrow":b[0][20],"short":b[0][321],"long":b[0][321]},{"narrow":b[0][12],"short":b[0][322],"long":b[0][322]},{"narrow":b[0][323],"short":b[0][323],"long":b[0][323]},{"narrow":b[0][12],"short":b[0][324],"long":b[0][325]},{"narrow":b[0][326],"short":b[0][326],"long":b[0][326]},{"narrow":b[0][28],"short":b[0][327],"long":b[0][327]},{"narrow":b[0][12],"short":b[0][328],"long":b[0][328]},{"narrow":b[0][329],"short":b[0][329],"long":b[0][329]},{"narrow":b[0][330],"short":b[0][330],"long":b[0][330]},{"medium":a[15],"availableFormats":b[0][332],"dateFormats":b[0][333],"timeFormats":b[0][44]},{"narrow":b[0][334],"short":b[0][335],"long":b[0][336]},{"narrow":b[0][337],"short":b[0][338],"long":b[0][339]},{"narrow":b[0][341],"short":b[0][342],"long":b[0][343]},{"narrow":b[0][12],"short":b[0][344],"long":b[0][345]},{"narrow":b[0][346],"short":b[0][346],"long":b[0][346]},{"medium":a[2543],"availableFormats":b[0][348],"dateFormats":b[0][168],"timeFormats":b[0][234]},{"narrow":b[0][349],"short":b[0][350],"long":b[0][351]},{"narrow":b[0][352],"short":b[0][353],"long":b[0][354]},{"narrow":b[0][355],"short":b[0][355],"long":b[0][355]},{"narrow":b[0][12],"short":b[0][12],"long":b[0][12]},{"narrow":b[0][357],"short":b[0][358],"long":b[0][359]},{"narrow":b[0][45],"short":b[0][362],"long":b[0][363]},{"narrow":b[0][364],"short":b[0][365],"long":b[0][366]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][367]},{"medium":a[15],"availableFormats":b[0][369],"dateFormats":b[0][297],"timeFormats":b[0][3]},{"narrow":b[0][370],"short":b[0][371],"long":b[0][372]},{"narrow":b[0][373],"short":b[0][374],"long":b[0][375]},{"narrow":b[0][377],"short":b[0][377],"long":b[0][378]},{"medium":a[15],"availableFormats":b[0][380],"dateFormats":b[0][381],"timeFormats":b[0][234]},{"narrow":b[0][12],"short":b[0][382],"long":b[0][383]},{"narrow":b[0][384],"short":b[0][385],"long":b[0][386]},{"narrow":b[0][387],"short":b[0][388],"long":b[0][388]},{"narrow":b[0][389],"short":b[0][389],"long":b[0][389]},{"medium":a[15],"availableFormats":b[0][391],"dateFormats":b[0][392],"timeFormats":b[0][44]},{"narrow":b[0][393],"short":b[0][394],"long":b[0][395]},{"narrow":b[0][396],"short":b[0][397],"long":b[0][398]},{"narrow":b[0][399],"short":b[0][400],"long":b[0][401]},{"medium":a[15],"availableFormats":b[0][402],"dateFormats":b[0][403],"timeFormats":b[0][206]},{"narrow":b[0][45],"short":b[0][404],"long":b[0][405]},{"narrow":b[0][406],"short":b[0][407],"long":b[0][408]},{"narrow":b[0][409],"short":b[0][410],"long":b[0][411]},{"narrow":b[0][412],"short":b[0][412],"long":b[0][412]},{"narrow":b[0][414],"short":b[0][415],"long":b[0][416]},{"narrow":b[0][417],"short":b[0][418],"long":b[0][419]},{"narrow":b[0][421],"short":b[0][421],"long":b[0][422]},{"medium":a[1643],"availableFormats":b[0][424],"dateFormats":b[0][425],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][426],"long":b[0][427]},{"narrow":b[0][428],"short":b[0][429],"long":b[0][430]},{"narrow":b[0][432],"short":b[0][432],"long":b[0][433]},{"decimal":b[0][34],"currency":b[0][55],"percent":b[0][203]},{"medium":a[1643],"availableFormats":b[0][424],"dateFormats":b[0][435],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][436],"long":b[0][437]},{"decimal":b[0][34],"currency":b[0][438],"percent":b[0][203]},{"latn":b[0][439]},{"narrow":b[0][441],"short":b[0][442],"long":b[0][443]},{"narrow":b[0][444],"short":b[0][445],"long":b[0][446]},{"narrow":b[0][448],"short":b[0][448],"long":b[0][449]},{"latn":b[0][450]},{"medium":a[15],"availableFormats":b[0][451],"dateFormats":b[0][452],"timeFormats":b[0][234]},{"narrow":b[0][334],"short":b[0][453],"long":b[0][454]},{"narrow":b[0][455],"short":b[0][456],"long":b[0][457]},{"narrow":b[0][459],"short":b[0][459],"long":b[0][460]},{"medium":a[15],"availableFormats":b[0][193],"dateFormats":b[0][462],"timeFormats":b[0][44]},{"narrow":b[0][463],"short":b[0][464],"long":b[0][465]},{"narrow":b[0][466],"short":b[0][467],"long":b[0][468]},{"narrow":b[0][470],"short":b[0][470],"long":b[0][471]},{"narrow":b[0][472],"short":b[0][473],"long":b[0][474]},{"narrow":b[0][475],"short":b[0][476],"long":b[0][477]},{"narrow":b[0][478],"short":b[0][478],"long":b[0][479]},{"medium":a[15],"availableFormats":b[0][480],"dateFormats":b[0][481],"timeFormats":b[0][482]},{"narrow":b[0][483],"short":b[0][484],"long":b[0][485]},{"narrow":b[0][486],"short":b[0][487],"long":b[0][488]},{"decimal":b[0][34],"currency":b[0][35],"percent":b[0][203],"secondaryGroupSize":2},{"latn":b[0][37],"tibt":b[0][491]},{"narrow":b[0][493],"short":b[0][494],"long":b[0][495]},{"narrow":b[0][496],"short":b[0][497],"long":b[0][498]},{"narrow":b[0][500],"short":b[0][500],"long":b[0][501]},{"medium":a[3236],"availableFormats":b[0][502],"dateFormats":b[0][503],"timeFormats":b[0][504]},{"narrow":b[0][505],"short":b[0][506],"long":b[0][507]},{"narrow":b[0][508],"short":b[0][509],"long":b[0][510]},{"narrow":b[0][12],"short":b[0][506],"long":b[0][512]},{"narrow":b[0][14],"short":b[0][513],"long":b[0][514]},{"narrow":b[0][14],"short":b[0][514],"long":b[0][514]},{"narrow":b[0][515],"short":b[0][515],"long":b[0][516]},{"narrow":b[0][20],"short":b[0][517],"long":b[0][518]},{"narrow":b[0][519],"short":b[0][519],"long":b[0][519]},{"narrow":b[0][12],"short":b[0][506],"long":b[0][520]},{"narrow":b[0][521],"short":b[0][521],"long":b[0][521]},{"latn":b[0][522]},{"medium":a[1643],"availableFormats":b[0][524],"dateFormats":b[0][525],"timeFormats":b[0][3]},{"narrow":b[0][526],"short":b[0][527],"long":b[0][528]},{"narrow":b[0][529],"short":b[0][530],"long":b[0][531]},{"narrow":b[0][533],"short":b[0][533],"long":b[0][534]},{"narrow":b[0][535],"short":b[0][535],"long":b[0][535]},{"medium":a[1643],"availableFormats":b[0][537],"dateFormats":b[0][297],"timeFormats":b[0][3]},{"narrow":b[0][45],"short":b[0][538],"long":b[0][539]},{"narrow":b[0][150],"short":b[0][259],"long":b[0][540]},{"narrow":b[0][12],"short":b[0][541],"long":b[0][542]},{"narrow":b[0][543],"short":b[0][221],"long":b[0][544]},{"medium":a[1643],"availableFormats":b[0][546],"dateFormats":b[0][547],"timeFormats":b[0][548]},{"narrow":b[0][550],"short":b[0][550],"long":b[0][550]},{"medium":a[15],"availableFormats":b[0][554],"dateFormats":b[0][555],"timeFormats":b[0][3]},{"medium":a[1643],"availableFormats":b[0][559],"dateFormats":b[0][560],"timeFormats":b[0][3]},{"medium":a[1643],"availableFormats":b[0][562],"dateFormats":b[0][563],"timeFormats":b[0][44]},{"medium":a[1643],"availableFormats":b[0][565],"dateFormats":b[0][566],"timeFormats":b[0][3]},{"medium":a[1643],"availableFormats":b[0][570],"dateFormats":b[0][85],"timeFormats":b[0][44]},{"medium":a[1643],"availableFormats":b[0][578],"dateFormats":b[0][579],"timeFormats":b[0][3]},{"narrow":b[0][28],"short":b[0][580],"long":b[0][580]},{"medium":a[1643],"availableFormats":b[0][581],"dateFormats":b[0][582],"timeFormats":b[0][44]},{"medium":a[1643],"availableFormats":b[0][584],"dateFormats":b[0][585],"timeFormats":b[0][3]},{"medium":a[1643],"availableFormats":b[0][586],"dateFormats":b[0][587],"timeFormats":b[0][3]},{"medium":a[1643],"availableFormats":b[0][595],"dateFormats":b[0][596],"timeFormats":b[0][44]},{"medium":a[1643],"availableFormats":b[0][603],"dateFormats":b[0][604],"timeFormats":b[0][3]},{"medium":a[1643],"availableFormats":b[0][570],"dateFormats":b[0][608],"timeFormats":b[0][3]},{"medium":a[1643],"availableFormats":b[0][613],"dateFormats":b[0][525],"timeFormats":b[0][3]},{"medium":a[1643],"availableFormats":b[0][626],"dateFormats":b[0][627],"timeFormats":b[0][3]},{"medium":a[1643],"availableFormats":b[0][629],"dateFormats":b[0][630],"timeFormats":b[0][3]},{"medium":a[15],"availableFormats":b[0][631],"dateFormats":b[0][632],"timeFormats":b[0][633]},{"narrow":b[0][45],"short":b[0][634],"long":b[0][635]},{"narrow":b[0][636],"short":b[0][637],"long":b[0][638]},{"narrow":b[0][640],"short":b[0][641],"long":b[0][642]},{"medium":a[15],"availableFormats":b[0][644],"dateFormats":b[0][645],"timeFormats":b[0][3]},{"narrow":b[0][646],"short":b[0][647],"long":b[0][648]},{"narrow":b[0][649],"short":b[0][650],"long":b[0][651]},{"narrow":b[0][653],"short":b[0][653],"long":b[0][654]},{"narrow":b[0][655],"short":b[0][655],"long":b[0][655]},{"decimal":b[0][34],"currency":b[0][35],"percent":b[0][203]},{"medium":a[15],"availableFormats":b[0][657],"dateFormats":b[0][645],"timeFormats":b[0][658]},{"medium":a[15],"availableFormats":b[0][661],"dateFormats":b[0][662],"timeFormats":b[0][3]},{"decimal":b[0][34],"currency":b[0][663],"percent":b[0][203]},{"medium":a[15],"availableFormats":b[0][644],"dateFormats":b[0][665],"timeFormats":b[0][666]},{"medium":a[15],"availableFormats":b[0][671],"dateFormats":b[0][645],"timeFormats":b[0][672]},{"narrow":b[0][673],"short":b[0][674],"long":b[0][675]},{"narrow":b[0][676],"short":b[0][650],"long":b[0][651]},{"narrow":b[0][653],"short":b[0][653],"long":b[0][677]},{"medium":a[15],"availableFormats":b[0][644],"dateFormats":b[0][665],"timeFormats":b[0][3]},{"medium":a[15],"availableFormats":b[0][644],"dateFormats":b[0][682],"timeFormats":b[0][3]},{"medium":a[15],"availableFormats":b[0][684],"dateFormats":b[0][685],"timeFormats":b[0][234]},{"narrow":b[0][673],"short":b[0][686],"long":b[0][675]},{"narrow":b[0][687],"short":b[0][688],"long":b[0][651]},{"narrow":b[0][689],"short":b[0][689],"long":b[0][690]},{"medium":a[15],"availableFormats":b[0][693],"dateFormats":b[0][694],"timeFormats":b[0][3]},{"medium":a[15],"availableFormats":b[0][644],"dateFormats":b[0][696],"timeFormats":b[0][697]},{"decimal":b[0][34],"currency":b[0][700],"percent":b[0][203]},{"medium":a[15],"availableFormats":b[0][705],"dateFormats":b[0][706],"timeFormats":b[0][707]},{"narrow":b[0][708],"short":b[0][709],"long":b[0][710]},{"narrow":b[0][711],"short":b[0][711],"long":b[0][712]},{"narrow":b[0][713],"short":b[0][714],"long":b[0][715]},{"medium":a[15],"availableFormats":b[0][717],"dateFormats":b[0][718],"timeFormats":b[0][719]},{"narrow":b[0][720],"short":b[0][721],"long":b[0][722]},{"narrow":b[0][723],"short":b[0][724],"long":b[0][725]},{"narrow":b[0][726],"short":b[0][726],"long":b[0][726]},{"narrow":b[0][727],"short":b[0][727],"long":b[0][727]},{"narrow":b[0][728],"short":b[0][728],"long":b[0][728]},{"decimal":b[0][34],"currency":b[0][165],"percent":b[0][729]},{"medium":a[15],"availableFormats":b[0][60],"dateFormats":b[0][462],"timeFormats":b[0][44]},{"narrow":b[0][731],"short":b[0][732],"long":b[0][733]},{"narrow":b[0][734],"short":b[0][735],"long":b[0][736]},{"narrow":b[0][738],"short":b[0][738],"long":b[0][739]},{"medium":a[3725],"availableFormats":b[0][740],"dateFormats":b[0][741],"timeFormats":b[0][742]},{"narrow":b[0][743],"short":b[0][744],"long":b[0][745]},{"narrow":b[0][746],"short":b[0][747],"long":b[0][747]},{"narrow":b[0][749],"short":b[0][750],"long":b[0][751]},{"narrow":b[0][752],"short":b[0][753],"long":b[0][753]},{"narrow":b[0][754],"short":b[0][755],"long":b[0][755]},{"narrow":b[0][756],"short":b[0][756],"long":b[0][757]},{"narrow":b[0][758],"short":b[0][759],"long":b[0][760]},{"narrow":b[0][761],"short":b[0][761],"long":b[0][762]},{"decimal":b[0][34],"currency":b[0][764],"percent":b[0][36]},{"arabext":b[0][765],"latn":b[0][37]},{"narrow":b[0][743],"short":b[0][767],"long":b[0][767]},{"narrow":b[0][758],"short":b[0][759],"long":b[0][759]},{"narrow":b[0][768],"short":b[0][768],"long":b[0][762]},{"medium":a[15],"availableFormats":b[0][769],"dateFormats":b[0][61],"timeFormats":b[0][44]},{"narrow":b[0][770],"short":b[0][771],"long":b[0][772]},{"narrow":b[0][773],"short":b[0][774],"long":b[0][775]},{"narrow":b[0][777],"short":b[0][777],"long":b[0][778]},{"medium":a[15],"availableFormats":b[0][781],"dateFormats":b[0][782],"timeFormats":b[0][783]},{"narrow":b[0][784],"short":b[0][785],"long":b[0][785]},{"narrow":b[0][786],"short":b[0][787],"long":b[0][788]},{"narrow":b[0][790],"short":b[0][791],"long":b[0][792]},{"narrow":b[0][793],"short":b[0][794],"long":b[0][794]},{"narrow":b[0][12],"short":b[0][25],"long":b[0][795]},{"latn":b[0][796]},{"medium":a[1643],"availableFormats":b[0][798],"dateFormats":b[0][297],"timeFormats":b[0][3]},{"narrow":b[0][799],"short":b[0][800],"long":b[0][801]},{"narrow":b[0][802],"short":b[0][803],"long":b[0][804]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][221]},{"medium":a[15],"availableFormats":b[0][806],"dateFormats":b[0][807],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][808],"long":b[0][809]},{"narrow":b[0][810],"short":b[0][811],"long":b[0][812]},{"narrow":b[0][814],"short":b[0][815],"long":b[0][816]},{"latn":b[0][817]},{"medium":a[15],"availableFormats":b[0][819],"dateFormats":b[0][820],"timeFormats":b[0][821]},{"narrow":b[0][45],"short":b[0][822],"long":b[0][823]},{"narrow":b[0][687],"short":b[0][824],"long":b[0][825]},{"narrow":b[0][826],"short":b[0][827],"long":b[0][828]},{"narrow":b[0][12],"short":b[0][829],"long":b[0][830]},{"narrow":b[0][831],"short":b[0][832],"long":b[0][833]},{"narrow":b[0][834],"short":b[0][834],"long":b[0][835]},{"narrow":b[0][836],"short":b[0][837],"long":b[0][838]},{"narrow":b[0][839],"short":b[0][839],"long":b[0][840]},{"narrow":b[0][841],"short":b[0][841],"long":b[0][842]},{"narrow":b[0][793],"short":b[0][843],"long":b[0][844]},{"narrow":b[0][22],"short":b[0][22],"long":b[0][845]},{"narrow":b[0][846],"short":b[0][847],"long":b[0][848]},{"narrow":b[0][12],"short":b[0][849],"long":b[0][850]},{"narrow":b[0][851],"short":b[0][851],"long":b[0][851]},{"medium":a[15],"availableFormats":b[0][819],"dateFormats":b[0][582],"timeFormats":b[0][44]},{"medium":a[15],"availableFormats":b[0][854],"dateFormats":b[0][855],"timeFormats":b[0][548]},{"narrow":b[0][841],"short":b[0][841],"long":b[0][856]},{"medium":a[15],"availableFormats":b[0][859],"dateFormats":b[0][860],"timeFormats":b[0][861]},{"medium":a[15],"availableFormats":b[0][876],"dateFormats":b[0][877],"timeFormats":b[0][44]},{"narrow":b[0][878],"short":b[0][879],"long":b[0][880]},{"narrow":b[0][687],"short":b[0][881],"long":b[0][882]},{"narrow":b[0][884],"short":b[0][884],"long":b[0][884]},{"medium":a[15],"availableFormats":b[0][885],"dateFormats":b[0][886],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][887],"long":b[0][888]},{"narrow":b[0][889],"short":b[0][890],"long":b[0][891]},{"narrow":b[0][14],"short":b[0][892],"long":b[0][892]},{"narrow":b[0][14],"short":b[0][893],"long":b[0][893]},{"narrow":b[0][894],"short":b[0][895],"long":b[0][896]},{"narrow":b[0][20],"short":b[0][897],"long":b[0][897]},{"narrow":b[0][12],"short":b[0][898],"long":b[0][898]},{"narrow":b[0][12],"short":b[0][899],"long":b[0][900]},{"narrow":b[0][901],"short":b[0][901],"long":b[0][901]},{"decimal":b[0][34],"currency":b[0][902],"percent":b[0][36]},{"medium":a[15],"availableFormats":b[0][904],"dateFormats":b[0][582],"timeFormats":b[0][44]},{"narrow":b[0][905],"short":b[0][906],"long":b[0][907]},{"narrow":b[0][908],"short":b[0][909],"long":b[0][910]},{"narrow":b[0][911],"short":b[0][911],"long":b[0][912]},{"medium":a[15],"availableFormats":b[0][913],"dateFormats":b[0][914],"timeFormats":b[0][44]},{"narrow":b[0][915],"short":b[0][916],"long":b[0][917]},{"narrow":b[0][918],"short":b[0][919],"long":b[0][920]},{"narrow":b[0][922],"short":b[0][923],"long":b[0][924]},{"medium":a[15],"availableFormats":b[0][926],"dateFormats":b[0][927],"timeFormats":b[0][44]},{"narrow":b[0][928],"short":b[0][929],"long":b[0][930]},{"narrow":b[0][172],"short":b[0][931],"long":b[0][932]},{"narrow":b[0][933],"short":b[0][933],"long":b[0][934]},{"medium":a[15],"availableFormats":b[0][936],"dateFormats":b[0][435],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][937],"long":b[0][938]},{"narrow":b[0][428],"short":b[0][939],"long":b[0][940]},{"narrow":b[0][942],"short":b[0][943],"long":b[0][944]},{"latn":b[0][945]},{"medium":a[15],"availableFormats":b[0][947],"dateFormats":b[0][261],"timeFormats":b[0][948]},{"narrow":b[0][949],"short":b[0][950],"long":b[0][951]},{"narrow":b[0][952],"short":b[0][953],"long":b[0][954]},{"narrow":b[0][955],"short":b[0][956],"long":b[0][957]},{"decimal":b[0][34],"currency":b[0][35],"percent":b[0][36],"secondaryGroupSize":2},{"gujr":b[0][37],"latn":b[0][37]},{"medium":a[15],"availableFormats":b[0][958],"dateFormats":b[0][85],"timeFormats":b[0][3]},{"narrow":b[0][959],"short":b[0][960],"long":b[0][961]},{"narrow":b[0][962],"short":b[0][963],"long":b[0][964]},{"narrow":b[0][966],"short":b[0][966],"long":b[0][967]},{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][968],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][969],"long":b[0][970]},{"narrow":b[0][150],"short":b[0][971],"long":b[0][972]},{"narrow":b[0][973],"short":b[0][973],"long":b[0][973]},{"medium":a[15],"availableFormats":b[0][958],"dateFormats":b[0][261],"timeFormats":b[0][44]},{"narrow":b[0][974],"short":b[0][975],"long":b[0][976]},{"narrow":b[0][977],"short":b[0][978],"long":b[0][979]},{"narrow":b[0][980],"short":b[0][980],"long":b[0][981]},{"full":a[720],"long":a[531],"medium":a[527],"short":b[0][985]},{"narrow":b[0][12],"short":b[0][986],"long":b[0][987]},{"narrow":b[0][150],"short":b[0][988],"long":b[0][989]},{"medium":a[1643],"availableFormats":b[0][990],"dateFormats":b[0][991],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][992],"long":b[0][993]},{"narrow":b[0][994],"short":b[0][995],"long":b[0][996]},{"narrow":b[0][998],"short":b[0][998],"long":b[0][999]},{"narrow":b[0][1000],"short":b[0][1001],"long":b[0][1001]},{"narrow":b[0][1002],"short":b[0][1002],"long":b[0][1002]},{"narrow":b[0][12],"short":b[0][1003],"long":b[0][1004]},{"narrow":b[0][1005],"short":b[0][1005],"long":b[0][1005]},{"narrow":b[0][28],"short":b[0][1006],"long":b[0][1006]},{"medium":a[1643],"availableFormats":b[0][1008],"dateFormats":b[0][1009],"timeFormats":b[0][3]},{"narrow":b[0][1010],"short":b[0][1011],"long":b[0][1012]},{"narrow":b[0][1013],"short":b[0][1014],"long":b[0][1015]},{"narrow":b[0][14],"short":b[0][1017],"long":b[0][1017]},{"narrow":b[0][1018],"short":b[0][1018],"long":b[0][1019]},{"narrow":b[0][12],"short":b[0][1020],"long":b[0][1020]},{"narrow":b[0][1021],"short":b[0][1021],"long":b[0][1021]},{"narrow":b[0][12],"short":b[0][25],"long":b[0][1022]},{"narrow":b[0][28],"short":b[0][1023],"long":b[0][1023]},{"narrow":b[0][12],"short":b[0][1024],"long":b[0][1024]},{"medium":a[15],"availableFormats":b[0][1025],"dateFormats":b[0][1026],"timeFormats":b[0][44]},{"narrow":b[0][1027],"short":b[0][1028],"long":b[0][1029]},{"narrow":b[0][341],"short":b[0][1030],"long":b[0][1031]},{"narrow":b[0][28],"short":b[0][1032],"long":b[0][1032]},{"medium":a[15],"availableFormats":b[0][1035],"dateFormats":b[0][452],"timeFormats":b[0][1036]},{"narrow":b[0][334],"short":b[0][1037],"long":b[0][1038]},{"narrow":b[0][1039],"short":b[0][1040],"long":b[0][1041]},{"narrow":b[0][1043],"short":b[0][1043],"long":b[0][1044]},{"medium":a[15],"availableFormats":b[0][1045],"dateFormats":b[0][1046],"timeFormats":b[0][234]},{"narrow":b[0][1047],"short":b[0][1048],"long":b[0][1049]},{"narrow":b[0][1050],"short":b[0][1051],"long":b[0][1052]},{"narrow":b[0][1053],"short":b[0][1053],"long":b[0][1053]},{"narrow":b[0][12],"short":b[0][12],"long":b[0][13]},{"narrow":b[0][1055],"short":b[0][1056],"long":b[0][1057]},{"narrow":b[0][20],"short":b[0][1058],"long":b[0][1058]},{"narrow":b[0][1059],"short":b[0][1059],"long":b[0][1059]},{"narrow":b[0][12],"short":b[0][1060],"long":b[0][1061]},{"narrow":b[0][1062],"short":b[0][1062],"long":b[0][1062]},{"narrow":b[0][1063],"short":b[0][1063],"long":b[0][1063]},{"medium":a[1643],"availableFormats":b[0][1065],"dateFormats":b[0][1066],"timeFormats":b[0][1067]},{"narrow":b[0][1068],"short":b[0][1069],"long":b[0][1070]},{"narrow":b[0][1071],"short":b[0][1072],"long":b[0][1073]},{"narrow":b[0][1075],"short":b[0][1075],"long":b[0][1076]},{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][74],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][1078],"long":b[0][1079]},{"narrow":b[0][150],"short":b[0][1080],"long":b[0][1081]},{"narrow":b[0][1082],"short":b[0][1082],"long":b[0][1083]},{"medium":a[15],"availableFormats":b[0][1084],"dateFormats":b[0][1085],"timeFormats":b[0][206]},{"narrow":b[0][45],"short":b[0][1086],"long":b[0][1087]},{"narrow":b[0][1088],"short":b[0][1089],"long":b[0][1090]},{"narrow":b[0][1091],"short":b[0][1091],"long":b[0][1092]},{"narrow":b[0][12],"short":b[0][1093],"long":b[0][1094]},{"narrow":b[0][28],"short":b[0][1095],"long":b[0][1095]},{"narrow":b[0][1096],"short":b[0][1096],"long":b[0][1096]},{"narrow":b[0][12],"short":b[0][1098],"long":b[0][1099]},{"narrow":b[0][150],"short":b[0][1100],"long":b[0][1101]},{"narrow":b[0][1103],"short":b[0][1103],"long":b[0][1104]},{"narrow":b[0][12],"short":b[0][12],"long":b[0][1105]},{"narrow":b[0][1106],"short":b[0][1107],"long":b[0][1108]},{"narrow":b[0][1110],"short":b[0][1110],"long":b[0][1110]},{"medium":a[1643],"availableFormats":b[0][1111],"dateFormats":b[0][1112],"timeFormats":b[0][44]},{"narrow":b[0][1113],"short":b[0][1114],"long":b[0][1115]},{"narrow":b[0][1116],"short":b[0][1117],"long":b[0][1118]},{"narrow":b[0][1120],"short":b[0][815],"long":b[0][1121]},{"medium":a[1643],"availableFormats":b[0][1123],"dateFormats":b[0][1124],"timeFormats":b[0][861]},{"narrow":b[0][1125],"short":b[0][1126],"long":b[0][1127]},{"narrow":b[0][1128],"short":b[0][1129],"long":b[0][1130]},{"narrow":b[0][1131],"short":b[0][1131],"long":b[0][1131]},{"narrow":b[0][1132],"short":b[0][1132],"long":b[0][933]},{"narrow":b[0][1133],"short":b[0][1133],"long":b[0][1133]},{"decimal":b[0][34],"currency":b[0][438],"percent":b[0][36]},{"medium":a[1643],"availableFormats":b[0][1135],"dateFormats":b[0][1136],"timeFormats":b[0][44]},{"medium":a[15],"availableFormats":b[0][1137],"dateFormats":b[0][1138],"timeFormats":b[0][1139]},{"narrow":b[0][12],"short":b[0][1140],"long":b[0][1140]},{"narrow":b[0][1141],"short":b[0][1141],"long":b[0][1142]},{"narrow":b[0][10],"short":b[0][10],"long":b[0][1143]},{"narrow":b[0][1145],"short":b[0][1146],"long":b[0][1146]},{"narrow":b[0][14],"short":b[0][1147],"long":b[0][1147]},{"narrow":b[0][14],"short":b[0][1148],"long":b[0][1148]},{"narrow":b[0][221],"short":b[0][1149],"long":b[0][1149]},{"narrow":b[0][20],"short":b[0][1150],"long":b[0][1150]},{"narrow":b[0][12],"short":b[0][1151],"long":b[0][1151]},{"narrow":b[0][1152],"short":b[0][1152],"long":b[0][1152]},{"narrow":b[0][12],"short":b[0][1153],"long":b[0][1153]},{"narrow":b[0][1154],"short":b[0][1155],"long":b[0][1155]},{"narrow":b[0][12],"short":b[0][1156],"long":b[0][1156]},{"narrow":b[0][1157],"short":b[0][1157],"long":b[0][1157]},{"medium":a[15],"availableFormats":b[0][1159],"dateFormats":b[0][1160],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][1161],"long":b[0][1161]},{"narrow":b[0][1162],"short":b[0][1163],"long":b[0][1163]},{"narrow":b[0][1165],"short":b[0][1165],"long":b[0][1165]},{"narrow":b[0][45],"short":b[0][1166],"long":b[0][1167]},{"narrow":b[0][159],"short":b[0][1168],"long":b[0][1169]},{"narrow":b[0][421],"short":b[0][421],"long":b[0][1171]},{"medium":a[15],"availableFormats":b[0][1172],"dateFormats":b[0][1173],"timeFormats":b[0][44]},{"narrow":b[0][1174],"short":b[0][1175],"long":b[0][1176]},{"narrow":b[0][1177],"short":b[0][1178],"long":b[0][1179]},{"narrow":b[0][1180],"short":b[0][1180],"long":b[0][1181]},{"narrow":b[0][20],"short":b[0][1182],"long":b[0][1182]},{"narrow":b[0][12],"short":b[0][1183],"long":b[0][1184]},{"narrow":b[0][12],"short":b[0][1185],"long":b[0][1185]},{"latn":b[0][1186]},{"narrow":b[0][1188],"short":b[0][1189],"long":b[0][1190]},{"narrow":b[0][1191],"short":b[0][1192],"long":b[0][1193]},{"narrow":b[0][1195],"short":b[0][1195],"long":b[0][1196]},{"narrow":b[0][1198],"short":b[0][1199],"long":b[0][1200]},{"narrow":b[0][1201],"short":b[0][1202],"long":b[0][1203]},{"narrow":b[0][1205],"short":b[0][1205],"long":b[0][1206]},{"narrow":b[0][45],"short":b[0][1166],"long":b[0][1207]},{"narrow":b[0][1208],"short":b[0][1209],"long":b[0][1210]},{"narrow":b[0][1212],"short":b[0][1212],"long":b[0][1213]},{"medium":a[15],"availableFormats":b[0][1214],"dateFormats":b[0][1215],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][1216],"long":b[0][1217]},{"narrow":b[0][1218],"short":b[0][1219],"long":b[0][1220]},{"narrow":b[0][1221],"short":b[0][1221],"long":b[0][1222]},{"narrow":b[0][1224],"short":b[0][1225],"long":b[0][1226]},{"narrow":b[0][448],"short":b[0][448],"long":b[0][1228]},{"narrow":b[0][1229],"short":b[0][1230],"long":b[0][1231]},{"narrow":b[0][1232],"short":b[0][1233],"long":b[0][1234]},{"medium":a[15],"availableFormats":b[0][1236],"dateFormats":b[0][1237],"timeFormats":b[0][44]},{"narrow":b[0][1238],"short":b[0][1239],"long":b[0][1240]},{"narrow":b[0][1241],"short":b[0][1242],"long":b[0][1243]},{"narrow":b[0][1245],"short":b[0][1245],"long":b[0][1246]},{"medium":a[15],"availableFormats":b[0][1248],"dateFormats":b[0][1249],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][1250],"long":b[0][1250]},{"narrow":b[0][1251],"short":b[0][1252],"long":b[0][1252]},{"medium":a[15],"availableFormats":b[0][1253],"dateFormats":b[0][1254],"timeFormats":b[0][3]},{"narrow":b[0][45],"short":b[0][335],"long":b[0][1255]},{"narrow":b[0][1256],"short":b[0][1257],"long":b[0][1258]},{"narrow":b[0][1260],"short":b[0][1261],"long":b[0][1262]},{"narrow":b[0][1264],"short":b[0][1265],"long":b[0][1266]},{"narrow":b[0][1267],"short":b[0][1268],"long":b[0][1269]},{"narrow":b[0][1271],"short":b[0][1271],"long":b[0][1272]},{"medium":a[1643],"availableFormats":b[0][1273],"dateFormats":b[0][1274],"timeFormats":b[0][3]},{"narrow":b[0][12],"short":b[0][1275],"long":b[0][1275]},{"narrow":b[0][1276],"short":b[0][1277],"long":b[0][1277]},{"narrow":b[0][1278],"short":b[0][1278],"long":b[0][1278]},{"narrow":b[0][1280],"short":b[0][1280],"long":b[0][1281]},{"khmr":b[0][131],"latn":b[0][131]},{"medium":a[15],"availableFormats":b[0][1283],"dateFormats":b[0][297],"timeFormats":b[0][948]},{"narrow":b[0][1284],"short":b[0][1285],"long":b[0][1286]},{"narrow":b[0][1287],"short":b[0][1288],"long":b[0][1289]},{"narrow":b[0][1291],"short":b[0][1291],"long":b[0][1292]},{"knda":b[0][37],"latn":b[0][37]},{"medium":a[15],"availableFormats":b[0][1293],"dateFormats":b[0][1294],"timeFormats":b[0][1295]},{"narrow":b[0][1296],"short":b[0][1296],"long":b[0][1296]},{"narrow":b[0][1297],"short":b[0][1297],"long":b[0][1298]},{"narrow":b[0][1299],"short":b[0][1299],"long":b[0][1299]},{"narrow":b[0][12],"short":b[0][1296],"long":b[0][1296]},{"narrow":b[0][14],"short":b[0][1301],"long":b[0][15]},{"narrow":b[0][14],"short":b[0][1302],"long":b[0][17]},{"narrow":b[0][1303],"short":b[0][1303],"long":b[0][1303]},{"narrow":b[0][20],"short":b[0][1304],"long":b[0][21]},{"narrow":b[0][28],"short":b[0][1305],"long":b[0][1305]},{"narrow":b[0][1306],"short":b[0][1306],"long":b[0][1306]},{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][1308],"timeFormats":b[0][3]},{"narrow":b[0][12],"short":b[0][1309],"long":b[0][1309]},{"narrow":b[0][150],"short":b[0][1310],"long":b[0][1311]},{"narrow":b[0][1313],"short":b[0][1313],"long":b[0][1313]},{"medium":a[15],"availableFormats":b[0][1314],"dateFormats":b[0][297],"timeFormats":b[0][3]},{"narrow":b[0][1315],"short":b[0][1316],"long":b[0][1316]},{"narrow":b[0][1317],"short":b[0][1318],"long":b[0][1319]},{"narrow":b[0][1320],"short":b[0][1320],"long":b[0][1321]},{"narrow":b[0][12],"short":b[0][1322],"long":b[0][1322]},{"arabext":b[0][132],"latn":b[0][1323]},{"narrow":b[0][45],"short":b[0][1166],"long":b[0][1324]},{"narrow":b[0][1325],"short":b[0][1326],"long":b[0][1327]},{"narrow":b[0][421],"short":b[0][421],"long":b[0][1329]},{"narrow":b[0][12],"short":b[0][1330],"long":b[0][1331]},{"narrow":b[0][1332],"short":b[0][1333],"long":b[0][1334]},{"narrow":b[0][1336],"short":b[0][1336],"long":b[0][1337]},{"medium":a[15],"availableFormats":b[0][1338],"dateFormats":b[0][1339],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][1340],"long":b[0][1341]},{"narrow":b[0][428],"short":b[0][1342],"long":b[0][1343]},{"narrow":b[0][1345],"short":b[0][943],"long":b[0][1346]},{"latn":b[0][1347]},{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][582],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][1348],"long":b[0][1349]},{"narrow":b[0][150],"short":b[0][1350],"long":b[0][1351]},{"medium":a[15],"availableFormats":b[0][1352],"dateFormats":b[0][1353],"timeFormats":b[0][44]},{"narrow":b[0][1354],"short":b[0][1355],"long":b[0][1356]},{"narrow":b[0][1357],"short":b[0][1358],"long":b[0][1359]},{"narrow":b[0][1361],"short":b[0][1362],"long":b[0][1363]},{"latn":b[0][1364]},{"narrow":b[0][1366],"short":b[0][1367],"long":b[0][1368]},{"narrow":b[0][1369],"short":b[0][1370],"long":b[0][1371]},{"narrow":b[0][1373],"short":b[0][1373],"long":b[0][1374]},{"medium":a[15],"availableFormats":b[0][1375],"dateFormats":b[0][706],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][1376],"long":b[0][1377]},{"narrow":b[0][428],"short":b[0][1378],"long":b[0][1379]},{"narrow":b[0][1381],"short":b[0][1381],"long":b[0][1381]},{"narrow":b[0][45],"short":b[0][1383],"long":b[0][1384]},{"narrow":b[0][1385],"short":b[0][1386],"long":b[0][1387]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][1388]},{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][297],"timeFormats":b[0][3]},{"narrow":b[0][12],"short":b[0][1389],"long":b[0][1389]},{"narrow":b[0][1390],"short":b[0][1391],"long":b[0][1391]},{"narrow":b[0][1392],"short":b[0][1393],"long":b[0][1394]},{"narrow":b[0][1395],"short":b[0][1396],"long":b[0][1397]},{"narrow":b[0][1399],"short":b[0][1399],"long":b[0][1400]},{"medium":a[1643],"availableFormats":b[0][1403],"dateFormats":b[0][1404],"timeFormats":b[0][1405]},{"narrow":b[0][12],"short":b[0][1406],"long":b[0][1407]},{"narrow":b[0][1276],"short":b[0][1408],"long":b[0][1408]},{"narrow":b[0][1409],"short":b[0][1409],"long":b[0][1409]},{"narrow":b[0][14],"short":b[0][1411],"long":b[0][1412]},{"narrow":b[0][14],"short":b[0][1413],"long":b[0][1413]},{"narrow":b[0][1414],"short":b[0][1414],"long":b[0][1415]},{"narrow":b[0][20],"short":b[0][1416],"long":b[0][1417]},{"narrow":b[0][12],"short":b[0][1418],"long":b[0][1419]},{"narrow":b[0][1420],"short":b[0][1420],"long":b[0][1420]},{"narrow":b[0][12],"short":b[0][1421],"long":b[0][1422]},{"narrow":b[0][28],"short":b[0][1423],"long":b[0][1423]},{"narrow":b[0][12],"short":b[0][1424],"long":b[0][1425]},{"narrow":b[0][1426],"short":b[0][1426],"long":b[0][1426]},{"narrow":b[0][1427],"short":b[0][1427],"long":b[0][1427]},{"decimal":b[0][34],"currency":b[0][663],"percent":b[0][36]},{"laoo":b[0][1428],"latn":b[0][1428]},{"medium":a[15],"availableFormats":b[0][1430],"dateFormats":b[0][1431],"timeFormats":b[0][44]},{"narrow":b[0][1432],"short":b[0][1433],"long":b[0][1434]},{"narrow":b[0][1435],"short":b[0][1436],"long":b[0][1437]},{"narrow":b[0][1439],"short":b[0][1440],"long":b[0][1441]},{"narrow":b[0][28],"short":b[0][1442],"long":b[0][1442]},{"narrow":b[0][1443],"short":b[0][1443],"long":b[0][1443]},{"narrow":b[0][1445],"short":b[0][1446],"long":b[0][1447]},{"narrow":b[0][1448],"short":b[0][1449],"long":b[0][1450]},{"narrow":b[0][1452],"short":b[0][1452],"long":b[0][1453]},{"narrow":b[0][1454],"short":b[0][1455],"long":b[0][1456]},{"narrow":b[0][1457],"short":b[0][1458],"long":b[0][1459]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][1461]},{"narrow":b[0][45],"short":b[0][1462],"long":b[0][158]},{"narrow":b[0][150],"short":b[0][1463],"long":b[0][1464]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][1465]},{"decimal":b[0][34],"currency":b[0][1466],"percent":b[0][36]},{"medium":a[15],"availableFormats":b[0][1467],"dateFormats":b[0][1468],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][1469],"long":b[0][1470]},{"narrow":b[0][1471],"short":b[0][1472],"long":b[0][1473]},{"narrow":b[0][1475],"short":b[0][1476],"long":b[0][1477]},{"narrow":b[0][20],"short":b[0][1478],"long":b[0][1478]},{"narrow":b[0][12],"short":b[0][25],"long":b[0][1479]},{"latn":b[0][1480]},{"narrow":b[0][12],"short":b[0][1482],"long":b[0][1483]},{"narrow":b[0][1208],"short":b[0][1168],"long":b[0][1484]},{"narrow":b[0][1486],"short":b[0][1486],"long":b[0][1487]},{"narrow":b[0][1489],"short":b[0][1490],"long":b[0][1491]},{"narrow":b[0][1492],"short":b[0][1493],"long":b[0][1494]},{"narrow":b[0][1496],"short":b[0][1496],"long":b[0][1497]},{"narrow":b[0][1498],"short":b[0][1499],"long":b[0][1500]},{"narrow":b[0][1501],"short":b[0][1502],"long":b[0][1503]},{"narrow":b[0][1504],"short":b[0][1504],"long":b[0][1505]},{"medium":a[15],"availableFormats":b[0][1507],"dateFormats":b[0][61],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][1508],"long":b[0][1509]},{"narrow":b[0][1510],"short":b[0][1511],"long":b[0][1512]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][1513]},{"medium":a[15],"availableFormats":b[0][1515],"dateFormats":b[0][85],"timeFormats":b[0][3]},{"narrow":b[0][1516],"short":b[0][1517],"long":b[0][1518]},{"narrow":b[0][1519],"short":b[0][1520],"long":b[0][1521]},{"narrow":b[0][1523],"short":b[0][1523],"long":b[0][1524]},{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][1160],"timeFormats":b[0][44]},{"narrow":b[0][1526],"short":b[0][1527],"long":b[0][1528]},{"narrow":b[0][1529],"short":b[0][1530],"long":b[0][1530]},{"medium":a[15],"availableFormats":b[0][1531],"dateFormats":b[0][1532],"timeFormats":b[0][44]},{"narrow":b[0][308],"short":b[0][1533],"long":b[0][1534]},{"narrow":b[0][238],"short":b[0][1535],"long":b[0][1536]},{"narrow":b[0][1538],"short":b[0][1539],"long":b[0][1540]},{"medium":a[15],"availableFormats":b[0][1542],"dateFormats":b[0][1543],"timeFormats":b[0][3]},{"narrow":b[0][1544],"short":b[0][1545],"long":b[0][1546]},{"narrow":b[0][1547],"short":b[0][1548],"long":b[0][1549]},{"narrow":b[0][1550],"short":b[0][1550],"long":b[0][1551]},{"narrow":b[0][1552],"short":b[0][1553],"long":b[0][1553]},{"narrow":b[0][1554],"short":b[0][1554],"long":b[0][1554]},{"narrow":b[0][1555],"short":b[0][25],"long":b[0][1556]},{"narrow":b[0][1557],"short":b[0][1557],"long":b[0][1557]},{"latn":b[0][37],"mlym":b[0][1558]},{"medium":a[15],"availableFormats":b[0][1559],"dateFormats":b[0][1560],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][1561],"long":b[0][1562]},{"narrow":b[0][1276],"short":b[0][1563],"long":b[0][1564]},{"narrow":b[0][1566],"short":b[0][1567],"long":b[0][1568]},{"medium":a[1643],"availableFormats":b[0][1570],"dateFormats":b[0][261],"timeFormats":b[0][3]},{"narrow":b[0][1571],"short":b[0][1572],"long":b[0][1573]},{"narrow":b[0][1013],"short":b[0][1310],"long":b[0][1574]},{"narrow":b[0][1576],"short":b[0][1576],"long":b[0][1577]},{"medium":a[15],"availableFormats":b[0][1579],"dateFormats":b[0][1580],"timeFormats":b[0][3]},{"narrow":b[0][1581],"short":b[0][1582],"long":b[0][1583]},{"narrow":b[0][1584],"short":b[0][1585],"long":b[0][1586]},{"narrow":b[0][1588],"short":b[0][1582],"long":b[0][1583]},{"narrow":b[0][1589],"short":b[0][1589],"long":b[0][1589]},{"medium":a[15],"availableFormats":b[0][1579],"dateFormats":b[0][1591],"timeFormats":b[0][3]},{"medium":a[15],"availableFormats":b[0][1594],"dateFormats":b[0][1595],"timeFormats":b[0][44]},{"narrow":b[0][1596],"short":b[0][1597],"long":b[0][1598]},{"narrow":b[0][1599],"short":b[0][1600],"long":b[0][1601]},{"narrow":b[0][1602],"short":b[0][1602],"long":b[0][1603]},{"narrow":b[0][1604],"short":b[0][1605],"long":b[0][1606]},{"narrow":b[0][1607],"short":b[0][1608],"long":b[0][1609]},{"narrow":b[0][1611],"short":b[0][1611],"long":b[0][1612]},{"medium":a[15],"availableFormats":b[0][1613],"dateFormats":b[0][74],"timeFormats":b[0][44]},{"narrow":b[0][1614],"short":b[0][1615],"long":b[0][1615]},{"narrow":b[0][1616],"short":b[0][1617],"long":b[0][1617]},{"narrow":b[0][1619],"short":b[0][1619],"long":b[0][1620]},{"latn":b[0][1622],"mymr":b[0][1622]},{"narrow":b[0][45],"short":b[0][538],"long":b[0][1624]},{"narrow":b[0][1625],"short":b[0][1626],"long":b[0][1627]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][1629]},{"medium":a[1643],"availableFormats":b[0][1631],"dateFormats":b[0][1632],"timeFormats":b[0][206]},{"narrow":b[0][45],"short":b[0][1633],"long":b[0][1634]},{"narrow":b[0][1635],"short":b[0][1636],"long":b[0][1637]},{"narrow":b[0][1639],"short":b[0][1640],"long":b[0][1641]},{"narrow":b[0][1642],"short":b[0][1643],"long":b[0][1644]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][1645]},{"medium":a[1643],"availableFormats":b[0][1646],"dateFormats":b[0][258],"timeFormats":b[0][44]},{"narrow":b[0][1647],"short":b[0][1648],"long":b[0][1649]},{"narrow":b[0][1650],"short":b[0][1651],"long":b[0][1652]},{"narrow":b[0][1653],"short":b[0][1653],"long":b[0][1653]},{"narrow":b[0][12],"short":b[0][1654],"long":b[0][1654]},{"narrow":b[0][1647],"short":b[0][1648],"long":b[0][1648]},{"narrow":b[0][1650],"short":b[0][1651],"long":b[0][1656]},{"narrow":b[0][45],"short":b[0][1658],"long":b[0][1659]},{"narrow":b[0][889],"short":b[0][1660],"long":b[0][1661]},{"narrow":b[0][12],"short":b[0][1662],"long":b[0][1663]},{"narrow":b[0][1664],"short":b[0][1665],"long":b[0][1666]},{"medium":a[15],"availableFormats":b[0][885],"dateFormats":b[0][1668],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][1672],"long":b[0][1673]},{"narrow":b[0][1674],"short":b[0][1675],"long":b[0][1676]},{"narrow":b[0][1678],"short":b[0][1678],"long":b[0][1679]},{"medium":a[1643],"availableFormats":b[0][1680],"dateFormats":b[0][1632],"timeFormats":b[0][1681]},{"narrow":b[0][45],"short":b[0][1682],"long":b[0][1634]},{"narrow":b[0][406],"short":b[0][1683],"long":b[0][1684]},{"narrow":b[0][1686],"short":b[0][410],"long":b[0][1687]},{"medium":a[15],"availableFormats":b[0][1689],"dateFormats":b[0][1690],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][1691],"long":b[0][1691]},{"narrow":b[0][150],"short":b[0][1692],"long":b[0][1692]},{"narrow":b[0][1694],"short":b[0][1694],"long":b[0][1695]},{"narrow":b[0][12],"short":b[0][1696],"long":b[0][1697]},{"narrow":b[0][150],"short":b[0][1698],"long":b[0][1699]},{"narrow":b[0][12],"short":b[0][1701],"long":b[0][1702]},{"narrow":b[0][150],"short":b[0][1703],"long":b[0][1704]},{"medium":a[15],"availableFormats":b[0][1705],"dateFormats":b[0][1706],"timeFormats":b[0][1707]},{"narrow":b[0][1708],"short":b[0][1709],"long":b[0][1710]},{"narrow":b[0][1711],"short":b[0][1712],"long":b[0][1713]},{"narrow":b[0][1715],"short":b[0][1715],"long":b[0][1716]},{"medium":a[15],"availableFormats":b[0][1717],"dateFormats":b[0][1718],"timeFormats":b[0][3]},{"narrow":b[0][45],"short":b[0][1719],"long":b[0][1720]},{"narrow":b[0][150],"short":b[0][1721],"long":b[0][1722]},{"narrow":b[0][1724],"short":b[0][1724],"long":b[0][1724]},{"medium":a[15],"availableFormats":b[0][1726],"dateFormats":b[0][1727],"timeFormats":b[0][3]},{"narrow":b[0][1728],"short":b[0][1729],"long":b[0][1729]},{"narrow":b[0][1730],"short":b[0][1731],"long":b[0][1732]},{"latn":b[0][37],"orya":b[0][37]},{"medium":a[1643],"availableFormats":b[0][1733],"dateFormats":b[0][1734],"timeFormats":b[0][44]},{"narrow":b[0][1354],"short":b[0][1735],"long":b[0][1736]},{"narrow":b[0][1737],"short":b[0][1738],"long":b[0][1739]},{"narrow":b[0][1741],"short":b[0][1741],"long":b[0][1741]},{"latn":b[0][1742]},{"medium":a[15],"availableFormats":b[0][1744],"dateFormats":b[0][1745],"timeFormats":b[0][3]},{"narrow":b[0][12],"short":b[0][1746],"long":b[0][1746]},{"narrow":b[0][150],"short":b[0][1747],"long":b[0][1747]},{"narrow":b[0][154],"short":b[0][154],"long":b[0][1748]},{"arabext":b[0][132],"latn":b[0][37]},{"medium":a[1643],"availableFormats":b[0][1750],"dateFormats":b[0][525],"timeFormats":b[0][3]},{"narrow":b[0][1751],"short":b[0][1752],"long":b[0][1753]},{"narrow":b[0][1754],"short":b[0][1755],"long":b[0][1756]},{"narrow":b[0][1758],"short":b[0][1758],"long":b[0][1759]},{"narrow":b[0][1760],"short":b[0][1761],"long":b[0][1761]},{"narrow":b[0][1762],"short":b[0][1762],"long":b[0][1762]},{"guru":b[0][37],"latn":b[0][37]},{"medium":a[1643],"availableFormats":b[0][1763],"dateFormats":b[0][1764],"timeFormats":b[0][44]},{"narrow":b[0][1765],"short":b[0][1766],"long":b[0][1767]},{"narrow":b[0][1768],"short":b[0][1769],"long":b[0][1770]},{"narrow":b[0][1771],"short":b[0][1771],"long":b[0][1771]},{"narrow":b[0][20],"short":b[0][1772],"long":b[0][1772]},{"narrow":b[0][12],"short":b[0][1773],"long":b[0][1774]},{"narrow":b[0][12],"short":b[0][1775],"long":b[0][1775]},{"narrow":b[0][1776],"short":b[0][1776],"long":b[0][1776]},{"medium":a[15],"availableFormats":b[0][1778],"dateFormats":b[0][1779],"timeFormats":b[0][742]},{"narrow":b[0][12],"short":b[0][1780],"long":b[0][1780]},{"narrow":b[0][150],"short":b[0][747],"long":b[0][747]},{"narrow":b[0][1782],"short":b[0][1782],"long":b[0][1782]},{"narrow":b[0][12],"short":b[0][1783],"long":b[0][1783]},{"arabext":b[0][132],"latn":b[0][131]},{"medium":a[1643],"availableFormats":b[0][1785],"dateFormats":b[0][685],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][1786],"long":b[0][1787]},{"narrow":b[0][1788],"short":b[0][1789],"long":b[0][1790]},{"narrow":b[0][12],"short":b[0][1792],"long":b[0][1793]},{"narrow":b[0][1794],"short":b[0][1794],"long":b[0][1795]},{"narrow":b[0][1796],"short":b[0][1796],"long":b[0][1796]},{"medium":a[15],"availableFormats":b[0][1798],"dateFormats":b[0][1799],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][1793],"long":b[0][1793]},{"narrow":b[0][1800],"short":b[0][1800],"long":b[0][1801]},{"medium":a[15],"availableFormats":b[0][1808],"dateFormats":b[0][1809],"timeFormats":b[0][1810]},{"narrow":b[0][12],"short":b[0][1811],"long":b[0][1812]},{"narrow":b[0][676],"short":b[0][1813],"long":b[0][1814]},{"narrow":b[0][1815],"short":b[0][1816],"long":b[0][1816]},{"medium":a[15],"availableFormats":b[0][936],"dateFormats":b[0][1819],"timeFormats":b[0][44]},{"narrow":b[0][1820],"short":b[0][1821],"long":b[0][1822]},{"narrow":b[0][1823],"short":b[0][1824],"long":b[0][1825]},{"narrow":b[0][1827],"short":b[0][1827],"long":b[0][1828]},{"narrow":b[0][12],"short":b[0][1829],"long":b[0][1830]},{"narrow":b[0][150],"short":b[0][1831],"long":b[0][1832]},{"narrow":b[0][1834],"short":b[0][1834],"long":b[0][1835]},{"decimal":b[0][34],"currency":b[0][71],"percent":b[0][203]},{"medium":a[1643],"availableFormats":b[0][1837],"dateFormats":b[0][1764],"timeFormats":b[0][44]},{"narrow":b[0][1838],"short":b[0][1839],"long":b[0][1840]},{"narrow":b[0][687],"short":b[0][1841],"long":b[0][1842]},{"narrow":b[0][1843],"short":b[0][1843],"long":b[0][1844]},{"narrow":b[0][14],"short":b[0][1845],"long":b[0][1845]},{"narrow":b[0][14],"short":b[0][1846],"long":b[0][1846]},{"narrow":b[0][1847],"short":b[0][1847],"long":b[0][1848]},{"narrow":b[0][20],"short":b[0][1849],"long":b[0][1849]},{"narrow":b[0][1852],"short":b[0][1792],"long":b[0][1853]},{"narrow":b[0][1208],"short":b[0][1854],"long":b[0][1855]},{"narrow":b[0][163],"short":b[0][163],"long":b[0][1857]},{"medium":a[1643],"availableFormats":b[0][1858],"dateFormats":b[0][1859],"timeFormats":b[0][234]},{"narrow":b[0][1354],"short":b[0][1860],"long":b[0][1861]},{"narrow":b[0][1862],"short":b[0][1862],"long":b[0][1863]},{"narrow":b[0][14],"short":b[0][1864],"long":b[0][1864]},{"narrow":b[0][14],"short":b[0][1865],"long":b[0][1865]},{"narrow":b[0][1866],"short":b[0][1867],"long":b[0][1867]},{"narrow":b[0][20],"short":b[0][1868],"long":b[0][1868]},{"narrow":b[0][12],"short":b[0][1869],"long":b[0][1869]},{"narrow":b[0][12],"short":b[0][1870],"long":b[0][1870]},{"narrow":b[0][28],"short":b[0][1871],"long":b[0][1871]},{"narrow":b[0][12],"short":b[0][1872],"long":b[0][1872]},{"latn":b[0][1873]},{"medium":a[1643],"availableFormats":b[0][1879],"dateFormats":b[0][1880],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][1881],"long":b[0][1882]},{"narrow":b[0][150],"short":b[0][1883],"long":b[0][1884]},{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][1886],"timeFormats":b[0][44]},{"narrow":b[0][1887],"short":b[0][1888],"long":b[0][1889]},{"narrow":b[0][1890],"short":b[0][1891],"long":b[0][1892]},{"narrow":b[0][1894],"short":b[0][1894],"long":b[0][1894]},{"narrow":b[0][1896],"short":b[0][1897],"long":b[0][1898]},{"narrow":b[0][1899],"short":b[0][1900],"long":b[0][1901]},{"narrow":b[0][421],"short":b[0][421],"long":b[0][1903]},{"medium":a[15],"availableFormats":b[0][1904],"dateFormats":b[0][85],"timeFormats":b[0][3]},{"narrow":b[0][12],"short":b[0][1905],"long":b[0][1906]},{"narrow":b[0][1907],"short":b[0][1908],"long":b[0][1909]},{"narrow":b[0][1911],"short":b[0][1911],"long":b[0][1912]},{"narrow":b[0][1913],"short":b[0][1914],"long":b[0][1915]},{"narrow":b[0][1916],"short":b[0][1917],"long":b[0][1918]},{"narrow":b[0][1920],"short":b[0][1920],"long":b[0][1921]},{"narrow":b[0][1913],"short":b[0][1923],"long":b[0][1915]},{"narrow":b[0][1924],"short":b[0][1917],"long":b[0][1925]},{"medium":a[15],"availableFormats":b[0][1927],"dateFormats":b[0][1928],"timeFormats":b[0][44]},{"narrow":b[0][45],"short":b[0][1929],"long":b[0][1930]},{"narrow":b[0][1931],"short":b[0][1932],"long":b[0][1933]},{"narrow":b[0][1934],"short":b[0][1934],"long":b[0][1935]},{"narrow":b[0][1224],"short":b[0][445],"long":b[0][1936]},{"medium":a[15],"availableFormats":b[0][1937],"dateFormats":b[0][61],"timeFormats":b[0][44]},{"narrow":b[0][1938],"short":b[0][1939],"long":b[0][1940]},{"narrow":b[0][1941],"short":b[0][1942],"long":b[0][1943]},{"narrow":b[0][1945],"short":b[0][1945],"long":b[0][1946]},{"narrow":b[0][1947],"short":b[0][1948],"long":b[0][1949]},{"narrow":b[0][150],"short":b[0][1950],"long":b[0][1951]},{"narrow":b[0][1953],"short":b[0][1953],"long":b[0][1954]},{"narrow":b[0][1955],"short":b[0][1956],"long":b[0][1957]},{"narrow":b[0][150],"short":b[0][1958],"long":b[0][1959]},{"narrow":b[0][1961],"short":b[0][1961],"long":b[0][1962]},{"medium":a[15],"availableFormats":b[0][1963],"dateFormats":b[0][258],"timeFormats":b[0][1964]},{"narrow":b[0][1965],"short":b[0][1966],"long":b[0][1967]},{"narrow":b[0][1968],"short":b[0][1969],"long":b[0][1970]},{"narrow":b[0][1972],"short":b[0][1972],"long":b[0][1973]},{"medium":a[1643],"availableFormats":b[0][1975],"dateFormats":b[0][1976],"timeFormats":b[0][234]},{"narrow":b[0][334],"short":b[0][1977],"long":b[0][1978]},{"narrow":b[0][1979],"short":b[0][1980],"long":b[0][1981]},{"narrow":b[0][1983],"short":b[0][1983],"long":b[0][1984]},{"medium":a[15],"availableFormats":b[0][1986],"dateFormats":b[0][1987],"timeFormats":b[0][206]},{"narrow":b[0][334],"short":b[0][1988],"long":b[0][1989]},{"narrow":b[0][1990],"short":b[0][1991],"long":b[0][1992]},{"narrow":b[0][1994],"short":b[0][1994],"long":b[0][1995]},{"narrow":b[0][1997],"short":b[0][1998],"long":b[0][1999]},{"latn":b[0][2000]},{"narrow":b[0][2001],"short":b[0][2002],"long":b[0][2003]},{"narrow":b[0][2004],"short":b[0][2005],"long":b[0][2006]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][2007]},{"medium":a[15],"availableFormats":b[0][958],"dateFormats":b[0][2],"timeFormats":b[0][3]},{"narrow":b[0][2008],"short":b[0][2009],"long":b[0][2010]},{"narrow":b[0][2011],"short":b[0][2012],"long":b[0][2013]},{"narrow":b[0][2015],"short":b[0][2015],"long":b[0][2016]},{"medium":a[1643],"availableFormats":b[0][2021],"dateFormats":b[0][2022],"timeFormats":b[0][44]},{"narrow":b[0][2023],"short":b[0][2024],"long":b[0][2025]},{"narrow":b[0][2026],"short":b[0][2027],"long":b[0][2028]},{"narrow":b[0][2030],"short":b[0][2031],"long":b[0][2032]},{"medium":a[15],"availableFormats":b[0][2035],"dateFormats":b[0][2036],"timeFormats":b[0][2037]},{"narrow":b[0][318],"short":b[0][319],"long":b[0][2039]},{"medium":a[15],"availableFormats":b[0][2035],"dateFormats":b[0][307],"timeFormats":b[0][206]},{"narrow":b[0][308],"short":b[0][309],"long":b[0][2041]},{"narrow":b[0][311],"short":b[0][2042],"long":b[0][2043]},{"medium":a[15],"availableFormats":b[0][2035],"dateFormats":b[0][2036],"timeFormats":b[0][2044]},{"narrow":b[0][334],"short":b[0][2045],"long":b[0][2046]},{"narrow":b[0][2047],"short":b[0][338],"long":b[0][2048]},{"narrow":b[0][14],"short":b[0][2050],"long":b[0][2050]},{"narrow":b[0][14],"short":b[0][2051],"long":b[0][2051]},{"narrow":b[0][1771],"short":b[0][2052],"long":b[0][2053]},{"narrow":b[0][20],"short":b[0][2054],"long":b[0][2054]},{"narrow":b[0][12],"short":b[0][2055],"long":b[0][2055]},{"narrow":b[0][12],"short":b[0][2056],"long":b[0][2057]},{"narrow":b[0][28],"short":b[0][2058],"long":b[0][2058]},{"narrow":b[0][12],"short":b[0][2059],"long":b[0][2059]},{"narrow":b[0][2060],"short":b[0][2060],"long":b[0][2060]},{"narrow":b[0][334],"short":b[0][2045],"long":b[0][2062]},{"narrow":b[0][2047],"short":b[0][2063],"long":b[0][2064]},{"narrow":b[0][12],"short":b[0][2065],"long":b[0][2066]},{"narrow":b[0][150],"short":b[0][2067],"long":b[0][2068]},{"narrow":b[0][2070],"short":b[0][2071],"long":b[0][2072]},{"medium":a[15],"availableFormats":b[0][2074],"dateFormats":b[0][43],"timeFormats":b[0][1681]},{"narrow":b[0][45],"short":b[0][2075],"long":b[0][2076]},{"narrow":b[0][406],"short":b[0][2077],"long":b[0][2078]},{"narrow":b[0][14],"short":b[0][2080],"long":b[0][2080]},{"narrow":b[0][14],"short":b[0][838],"long":b[0][838]},{"narrow":b[0][1686],"short":b[0][410],"long":b[0][2081]},{"narrow":b[0][20],"short":b[0][2082],"long":b[0][2082]},{"narrow":b[0][12],"short":b[0][848],"long":b[0][848]},{"narrow":b[0][550],"short":b[0][550],"long":b[0][2083]},{"narrow":b[0][12],"short":b[0][25],"long":b[0][2084]},{"narrow":b[0][28],"short":b[0][2085],"long":b[0][2085]},{"narrow":b[0][12],"short":b[0][2086],"long":b[0][2086]},{"narrow":b[0][2087],"short":b[0][2087],"long":b[0][2087]},{"medium":a[15],"availableFormats":b[0][2074],"dateFormats":b[0][2089],"timeFormats":b[0][1681]},{"narrow":b[0][1686],"short":b[0][410],"long":b[0][2090]},{"medium":a[15],"availableFormats":b[0][2091],"dateFormats":b[0][85],"timeFormats":b[0][3]},{"narrow":b[0][45],"short":b[0][1166],"long":b[0][158]},{"narrow":b[0][150],"short":b[0][161],"long":b[0][161]},{"narrow":b[0][221],"short":b[0][221],"long":b[0][422]},{"narrow":b[0][2094],"short":b[0][2095],"long":b[0][2096]},{"narrow":b[0][2097],"short":b[0][2098],"long":b[0][2099]},{"narrow":b[0][2101],"short":b[0][2101],"long":b[0][2102]},{"medium":a[1643],"availableFormats":b[0][2103],"dateFormats":b[0][2104],"timeFormats":b[0][3]},{"narrow":b[0][2105],"short":b[0][2106],"long":b[0][2107]},{"narrow":b[0][2108],"short":b[0][2108],"long":b[0][2109]},{"narrow":b[0][12],"short":b[0][2111],"long":b[0][2112]},{"narrow":b[0][2113],"short":b[0][2113],"long":b[0][2114]},{"latn":b[0][37],"tamldec":b[0][37]},{"medium":a[15],"availableFormats":b[0][2118],"dateFormats":b[0][2119],"timeFormats":b[0][3]},{"narrow":b[0][2120],"short":b[0][2121],"long":b[0][2122]},{"narrow":b[0][2123],"short":b[0][2124],"long":b[0][2125]},{"narrow":b[0][2127],"short":b[0][2128],"long":b[0][2129]},{"narrow":b[0][12],"short":b[0][2130],"long":b[0][2130]},{"narrow":b[0][2131],"short":b[0][2131],"long":b[0][2131]},{"latn":b[0][37],"telu":b[0][37]},{"narrow":b[0][2132],"short":b[0][2133],"long":b[0][2134]},{"narrow":b[0][2135],"short":b[0][2136],"long":b[0][2137]},{"medium":a[15],"availableFormats":b[0][2140],"dateFormats":b[0][2141],"timeFormats":b[0][2142]},{"narrow":b[0][2143],"short":b[0][2143],"long":b[0][2144]},{"narrow":b[0][2145],"short":b[0][2146],"long":b[0][2147]},{"narrow":b[0][2148],"short":b[0][2148],"long":b[0][2149]},{"narrow":b[0][14],"short":b[0][2151],"long":b[0][2151]},{"narrow":b[0][14],"short":b[0][2152],"long":b[0][2152]},{"narrow":b[0][2153],"short":b[0][2154],"long":b[0][2155]},{"narrow":b[0][20],"short":b[0][2156],"long":b[0][2156]},{"narrow":b[0][2157],"short":b[0][2157],"long":b[0][2157]},{"narrow":b[0][12],"short":b[0][2158],"long":b[0][2158]},{"narrow":b[0][2159],"short":b[0][2159],"long":b[0][2159]},{"narrow":b[0][12],"short":b[0][2160],"long":b[0][2161]},{"narrow":b[0][2162],"short":b[0][2162],"long":b[0][2163]},{"narrow":b[0][28],"short":b[0][2164],"long":b[0][2164]},{"narrow":b[0][12],"short":b[0][2165],"long":b[0][2165]},{"narrow":b[0][2166],"short":b[0][2166],"long":b[0][2166]},{"narrow":b[0][2167],"short":b[0][2167],"long":b[0][2167]},{"latn":b[0][37],"thai":b[0][37]},{"medium":a[15],"availableFormats":b[0][1717],"dateFormats":b[0][2169],"timeFormats":b[0][3]},{"narrow":b[0][86],"short":b[0][2170],"long":b[0][2171]},{"narrow":b[0][2172],"short":b[0][2173],"long":b[0][2173]},{"narrow":b[0][96],"short":b[0][96],"long":b[0][96]},{"medium":a[15],"availableFormats":b[0][1717],"dateFormats":b[0][2175],"timeFormats":b[0][3]},{"narrow":b[0][86],"short":b[0][2176],"long":b[0][2177]},{"narrow":b[0][2172],"short":b[0][2178],"long":b[0][2178]},{"narrow":b[0][12],"short":b[0][2179],"long":b[0][2180]},{"narrow":b[0][150],"short":b[0][2181],"long":b[0][2182]},{"medium":a[1643],"availableFormats":b[0][2184],"dateFormats":b[0][1274],"timeFormats":b[0][3]},{"narrow":b[0][2185],"short":b[0][2186],"long":b[0][2187]},{"narrow":b[0][2188],"short":b[0][2189],"long":b[0][2190]},{"narrow":b[0][2191],"short":b[0][2192],"long":b[0][2193]},{"latn":b[0][2194]},{"medium":a[15],"availableFormats":b[0][2196],"dateFormats":b[0][2197],"timeFormats":b[0][44]},{"narrow":b[0][2198],"short":b[0][2199],"long":b[0][2200]},{"narrow":b[0][2201],"short":b[0][2202],"long":b[0][2203]},{"narrow":b[0][14],"short":b[0][2205],"long":b[0][2205]},{"narrow":b[0][14],"short":b[0][2206],"long":b[0][2206]},{"narrow":b[0][2207],"short":b[0][2207],"long":b[0][2208]},{"narrow":b[0][20],"short":b[0][2209],"long":b[0][2209]},{"narrow":b[0][12],"short":b[0][2210],"long":b[0][2210]},{"narrow":b[0][2211],"short":b[0][2211],"long":b[0][2211]},{"narrow":b[0][12],"short":b[0][2212],"long":b[0][2212]},{"decimal":b[0][34],"currency":b[0][165],"percent":b[0][2213]},{"narrow":b[0][12],"short":b[0][2215],"long":b[0][2216]},{"narrow":b[0][150],"short":b[0][2217],"long":b[0][2218]},{"narrow":b[0][2219],"short":b[0][2220],"long":b[0][2221]},{"narrow":b[0][2222],"short":b[0][2223],"long":b[0][2224]},{"narrow":b[0][2226],"short":b[0][2226],"long":b[0][2227]},{"medium":a[12097],"availableFormats":b[0][2228],"dateFormats":b[0][2229],"timeFormats":b[0][3]},{"narrow":b[0][12],"short":b[0][2230],"long":b[0][2231]},{"narrow":b[0][2232],"short":b[0][2233],"long":b[0][2234]},{"narrow":b[0][2235],"short":b[0][2235],"long":b[0][2235]},{"narrow":b[0][2237],"short":b[0][2237],"long":b[0][2237]},{"narrow":b[0][12],"short":b[0][2238],"long":b[0][2238]},{"narrow":b[0][2239],"short":b[0][2239],"long":b[0][2239]},{"narrow":b[0][2240],"short":b[0][2240],"long":b[0][2240]},{"medium":a[15],"availableFormats":b[0][2242],"dateFormats":b[0][2243],"timeFormats":b[0][44]},{"narrow":b[0][2244],"short":b[0][2245],"long":b[0][2246]},{"narrow":b[0][2247],"short":b[0][2248],"long":b[0][2249]},{"narrow":b[0][14],"short":b[0][2251],"long":b[0][2252]},{"narrow":b[0][14],"short":b[0][2253],"long":b[0][2254]},{"narrow":b[0][2255],"short":b[0][2256],"long":b[0][2257]},{"narrow":b[0][20],"short":b[0][2258],"long":b[0][2258]},{"narrow":b[0][12],"short":b[0][2259],"long":b[0][2260]},{"narrow":b[0][12],"short":b[0][2261],"long":b[0][2262]},{"narrow":b[0][28],"short":b[0][2263],"long":b[0][2263]},{"narrow":b[0][12],"short":b[0][2264],"long":b[0][2265]},{"latn":b[0][2266]},{"medium":a[15],"availableFormats":b[0][2268],"dateFormats":b[0][2269],"timeFormats":b[0][3]},{"narrow":b[0][45],"short":b[0][2270],"long":b[0][2270]},{"narrow":b[0][150],"short":b[0][2271],"long":b[0][2271]},{"narrow":b[0][2273],"short":b[0][2273],"long":b[0][2273]},{"narrow":b[0][12],"short":b[0][25],"long":b[0][2274]},{"narrow":b[0][2275],"short":b[0][2275],"long":b[0][2275]},{"arabext":b[0][2276],"latn":b[0][37]},{"narrow":b[0][150],"short":b[0][2277],"long":b[0][2277]},{"narrow":b[0][2278],"short":b[0][2278],"long":b[0][2279]},{"medium":a[15],"availableFormats":b[0][2281],"dateFormats":b[0][2282],"timeFormats":b[0][742]},{"narrow":b[0][12],"short":b[0][2283],"long":b[0][745]},{"narrow":b[0][150],"short":b[0][2284],"long":b[0][747]},{"narrow":b[0][1354],"short":b[0][2285],"long":b[0][2286]},{"narrow":b[0][2287],"short":b[0][2288],"long":b[0][2289]},{"narrow":b[0][2290],"short":b[0][2290],"long":b[0][2290]},{"narrow":b[0][12],"short":b[0][25],"long":b[0][2291]},{"narrow":b[0][2293],"short":b[0][2294],"long":b[0][2295]},{"narrow":b[0][2296],"short":b[0][2297],"long":b[0][2298]},{"narrow":b[0][2300],"short":b[0][2300],"long":b[0][2300]},{"narrow":b[0][12],"short":b[0][25],"long":b[0][2301]},{"narrow":b[0][12],"short":b[0][2303],"long":b[0][2303]},{"narrow":b[0][150],"short":b[0][2304],"long":b[0][2304]},{"latn":b[0][37],"vaii":b[0][37]},{"narrow":b[0][12],"short":b[0][2306],"long":b[0][2306]},{"narrow":b[0][150],"short":b[0][2307],"long":b[0][2307]},{"narrow":b[0][12],"short":b[0][2308],"long":b[0][2309]},{"narrow":b[0][150],"short":b[0][2310],"long":b[0][2311]},{"medium":a[3236],"availableFormats":b[0][2312],"dateFormats":b[0][2313],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][2314],"long":b[0][2315]},{"narrow":b[0][2316],"short":b[0][2317],"long":b[0][2318]},{"narrow":b[0][2320],"short":b[0][2320],"long":b[0][2320]},{"narrow":b[0][2321],"short":b[0][2321],"long":b[0][2321]},{"medium":a[15],"availableFormats":b[0][1],"dateFormats":b[0][2322],"timeFormats":b[0][44]},{"narrow":b[0][2323],"short":b[0][2324],"long":b[0][2325]},{"narrow":b[0][2326],"short":b[0][2327],"long":b[0][2328]},{"narrow":b[0][2330],"short":b[0][2330],"long":b[0][2330]},{"medium":a[15],"availableFormats":b[0][2331],"dateFormats":b[0][2332],"timeFormats":b[0][44]},{"narrow":b[0][2333],"short":b[0][2334],"long":b[0][2335]},{"narrow":b[0][2336],"short":b[0][2337],"long":b[0][2338]},{"narrow":b[0][2339],"short":b[0][2339],"long":b[0][2339]},{"latn":b[0][2340]},{"narrow":b[0][2342],"short":b[0][2343],"long":b[0][2344]},{"narrow":b[0][2346],"short":b[0][2346],"long":b[0][2347]},{"narrow":b[0][12],"short":b[0][2348],"long":b[0][2349]},{"narrow":b[0][2350],"short":b[0][2351],"long":b[0][2352]},{"narrow":b[0][2354],"short":b[0][2354],"long":b[0][2355]},{"medium":a[1643],"availableFormats":b[0][2356],"dateFormats":b[0][2357],"timeFormats":b[0][44]},{"narrow":b[0][12],"short":b[0][2358],"long":b[0][2358]},{"narrow":b[0][150],"short":b[0][2359],"long":b[0][2359]},{"narrow":b[0][2361],"short":b[0][2362],"long":b[0][2362]},{"narrow":b[0][12],"short":b[0][2363],"long":b[0][2364]},{"narrow":b[0][150],"short":b[0][2365],"long":b[0][2366]},{"narrow":b[0][2368],"short":b[0][2368],"long":b[0][2369]},{"narrow":b[0][12],"short":b[0][2370],"long":b[0][2371]},{"narrow":b[0][150],"short":b[0][2372],"long":b[0][2373]},{"medium":a[15],"availableFormats":b[0][2375],"dateFormats":b[0][61],"timeFormats":b[0][44]},{"narrow":b[0][150],"short":b[0][1958],"long":b[0][2376]},{"medium":a[15],"availableFormats":b[0][2377],"dateFormats":b[0][2378],"timeFormats":b[0][2379]},{"narrow":b[0][12],"short":b[0][1140],"long":b[0][2380]},{"narrow":b[0][2381],"short":b[0][2382],"long":b[0][2383]},{"narrow":b[0][2384],"short":b[0][2384],"long":b[0][2384]},{"narrow":b[0][2386],"short":b[0][2387],"long":b[0][2387]},{"narrow":b[0][14],"short":b[0][2388],"long":b[0][2389]},{"narrow":b[0][2390],"short":b[0][2390],"long":b[0][2390]},{"narrow":b[0][20],"short":b[0][2391],"long":b[0][2392]},{"narrow":b[0][2393],"short":b[0][2393],"long":b[0][2393]},{"narrow":b[0][2394],"short":b[0][2394],"long":b[0][2394]},{"narrow":b[0][2395],"short":b[0][2395],"long":b[0][2395]},{"narrow":b[0][28],"short":b[0][2396],"long":b[0][2396]},{"narrow":b[0][2397],"short":b[0][2397],"long":b[0][2397]},{"hanidec":b[0][37],"latn":b[0][37]},{"medium":a[15],"availableFormats":b[0][2399],"dateFormats":b[0][2400],"timeFormats":b[0][2379]},{"medium":a[15],"availableFormats":b[0][2402],"dateFormats":b[0][2400],"timeFormats":b[0][2379]},{"medium":a[15],"availableFormats":b[0][2404],"dateFormats":b[0][2405],"timeFormats":b[0][2406]},{"medium":a[15],"availableFormats":b[0][2408],"dateFormats":b[0][2400],"timeFormats":b[0][2409]},{"narrow":b[0][2381],"short":b[0][2410],"long":b[0][2383]},{"narrow":b[0][2411],"short":b[0][2411],"long":b[0][2411]},{"narrow":b[0][14],"short":b[0][2388],"long":b[0][2388]},{"narrow":b[0][2412],"short":b[0][221],"long":b[0][2413]},{"narrow":b[0][20],"short":b[0][2414],"long":b[0][2414]},{"narrow":b[0][2415],"short":b[0][2415],"long":b[0][2415]},{"narrow":b[0][12],"short":b[0][2416],"long":b[0][2416]},{"narrow":b[0][2417],"short":b[0][2417],"long":b[0][2417]},{"narrow":b[0][12],"short":b[0][2418],"long":b[0][2418]},{"narrow":b[0][2419],"short":b[0][2419],"long":b[0][2419]},{"narrow":b[0][28],"short":b[0][2420],"long":b[0][2420]},{"narrow":b[0][2421],"short":b[0][2421],"long":b[0][2421]},{"narrow":b[0][2422],"short":b[0][2422],"long":b[0][2422]},{"hanidec":b[0][2423],"latn":b[0][2423]},{"medium":a[15],"availableFormats":b[0][2425],"dateFormats":b[0][2426],"timeFormats":b[0][2409]},{"medium":a[15],"availableFormats":b[0][2428],"dateFormats":b[0][2429],"timeFormats":b[0][2409]},{"narrow":b[0][2430],"short":b[0][2431],"long":b[0][2431]},{"narrow":b[0][2412],"short":b[0][2412],"long":b[0][2412]},{"medium":a[15],"availableFormats":b[0][537],"dateFormats":b[0][297],"timeFormats":b[0][3]},{"narrow":b[0][45],"short":b[0][2433],"long":b[0][2434]},{"narrow":b[0][2435],"short":b[0][2436],"long":b[0][2437]},{"latn":b[0][2439]}];b[2]=[{"months":b[1][1],"days":b[1][2],"eras":b[1][3],"dayPeriods":b[0][11]},{"months":b[1][4],"days":b[1][2],"dayPeriods":b[0][11]},{"months":b[1][5],"days":b[1][2],"eras":b[1][6],"dayPeriods":b[0][11]},{"months":b[1][7],"days":b[1][2],"eras":b[1][6],"dayPeriods":b[0][11]},{"months":b[1][7],"days":b[1][2],"eras":b[1][8],"dayPeriods":b[0][11]},{"months":b[1][4],"days":b[1][2],"eras":b[1][6],"dayPeriods":b[0][11]},{"months":b[1][1],"days":b[1][2],"eras":b[1][9],"dayPeriods":b[0][11]},{"months":b[1][10],"days":b[1][2],"eras":b[1][11],"dayPeriods":b[0][11]},{"months":b[1][12],"days":b[1][2],"eras":b[1][13],"dayPeriods":b[0][11]},{"months":b[1][14],"days":b[1][2],"eras":b[1][15],"dayPeriods":b[0][11]},{"months":b[1][1],"days":b[1][2],"eras":b[1][16],"dayPeriods":b[0][11]},{"months":b[1][17],"days":b[1][2],"eras":b[1][18],"dayPeriods":b[0][11]},{"months":b[1][1],"days":b[1][2],"eras":b[1][19],"dayPeriods":b[0][11]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][38]},{"months":b[1][22],"days":b[1][2],"eras":b[1][3],"dayPeriods":b[0][11]},{"months":b[1][22],"days":b[1][2],"eras":b[1][9],"dayPeriods":b[0][11]},{"months":b[1][22],"days":b[1][2],"eras":b[1][16],"dayPeriods":b[0][11]},{"months":b[1][22],"days":b[1][2],"eras":b[1][19],"dayPeriods":b[0][11]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][40]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][41]},{"months":b[1][24],"days":b[1][25],"eras":b[1][3],"dayPeriods":b[0][51]},{"months":b[1][4],"days":b[1][25],"dayPeriods":b[0][51]},{"months":b[1][5],"days":b[1][25],"eras":b[1][6],"dayPeriods":b[0][51]},{"months":b[1][7],"days":b[1][25],"eras":b[1][6],"dayPeriods":b[0][51]},{"months":b[1][7],"days":b[1][25],"eras":b[1][8],"dayPeriods":b[0][51]},{"months":b[1][4],"days":b[1][25],"eras":b[1][6],"dayPeriods":b[0][51]},{"months":b[1][24],"days":b[1][25],"eras":b[1][26],"dayPeriods":b[0][51]},{"months":b[1][10],"days":b[1][25],"eras":b[1][11],"dayPeriods":b[0][51]},{"months":b[1][12],"days":b[1][25],"eras":b[1][13],"dayPeriods":b[0][51]},{"months":b[1][14],"days":b[1][25],"eras":b[1][15],"dayPeriods":b[0][51]},{"months":b[1][24],"days":b[1][25],"eras":b[1][16],"dayPeriods":b[0][51]},{"months":b[1][17],"days":b[1][25],"eras":b[1][18],"dayPeriods":b[0][51]},{"months":b[1][24],"days":b[1][25],"eras":b[1][19],"dayPeriods":b[0][51]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][28],"currencies":b[0][57]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][28],"currencies":b[0][59]},{"months":b[1][31],"days":b[1][32],"eras":b[1][3],"dayPeriods":b[0][68]},{"months":b[1][4],"days":b[1][32],"dayPeriods":b[0][68]},{"months":b[1][5],"days":b[1][32],"eras":b[1][6],"dayPeriods":b[0][68]},{"months":b[1][7],"days":b[1][32],"eras":b[1][6],"dayPeriods":b[0][68]},{"months":b[1][7],"days":b[1][32],"eras":b[1][8],"dayPeriods":b[0][68]},{"months":b[1][4],"days":b[1][32],"eras":b[1][6],"dayPeriods":b[0][68]},{"months":b[1][31],"days":b[1][32],"eras":b[1][33],"dayPeriods":b[0][68]},{"months":b[1][10],"days":b[1][32],"eras":b[1][11],"dayPeriods":b[0][68]},{"months":b[1][12],"days":b[1][32],"eras":b[1][13],"dayPeriods":b[0][68]},{"months":b[1][14],"days":b[1][32],"eras":b[1][15],"dayPeriods":b[0][68]},{"months":b[1][31],"days":b[1][32],"eras":b[1][16],"dayPeriods":b[0][68]},{"months":b[1][17],"days":b[1][32],"eras":b[1][18],"dayPeriods":b[0][68]},{"months":b[1][31],"days":b[1][32],"eras":b[1][19],"dayPeriods":b[0][68]},{"nu":b[0][33],"patterns":b[1][34],"symbols":b[1][28],"currencies":b[0][72]},{"months":b[1][36],"days":b[1][37],"eras":b[1][3],"dayPeriods":b[0][80]},{"months":b[1][4],"days":b[1][37],"dayPeriods":b[0][80]},{"months":b[1][5],"days":b[1][37],"eras":b[1][6],"dayPeriods":b[0][80]},{"months":b[1][7],"days":b[1][37],"eras":b[1][6],"dayPeriods":b[0][80]},{"months":b[1][7],"days":b[1][37],"eras":b[1][8],"dayPeriods":b[0][80]},{"months":b[1][4],"days":b[1][37],"eras":b[1][6],"dayPeriods":b[0][80]},{"months":b[1][36],"days":b[1][37],"eras":b[1][38],"dayPeriods":b[0][80]},{"months":b[1][10],"days":b[1][37],"eras":b[1][11],"dayPeriods":b[0][80]},{"months":b[1][12],"days":b[1][37],"eras":b[1][13],"dayPeriods":b[0][80]},{"months":b[1][14],"days":b[1][37],"eras":b[1][15],"dayPeriods":b[0][80]},{"months":b[1][36],"days":b[1][37],"eras":b[1][16],"dayPeriods":b[0][80]},{"months":b[1][17],"days":b[1][37],"eras":b[1][18],"dayPeriods":b[0][80]},{"months":b[1][36],"days":b[1][37],"eras":b[1][19],"dayPeriods":b[0][80]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][83]},{"months":b[1][40],"days":b[1][41],"eras":b[1][3],"dayPeriods":b[0][92]},{"months":b[1][4],"days":b[1][41],"dayPeriods":b[0][92]},{"months":b[1][5],"days":b[1][41],"eras":b[1][42],"dayPeriods":b[0][92]},{"months":b[1][43],"days":b[1][41],"eras":b[1][6],"dayPeriods":b[0][92]},{"months":b[1][43],"days":b[1][41],"eras":b[1][8],"dayPeriods":b[0][92]},{"months":b[1][4],"days":b[1][41],"eras":b[1][6],"dayPeriods":b[0][92]},{"months":b[1][40],"days":b[1][41],"eras":b[1][44],"dayPeriods":b[0][92]},{"months":b[1][10],"days":b[1][41],"eras":b[1][11],"dayPeriods":b[0][92]},{"months":b[1][12],"days":b[1][41],"eras":b[1][13],"dayPeriods":b[0][92]},{"months":b[1][45],"days":b[1][41],"eras":b[1][15],"dayPeriods":b[0][92]},{"months":b[1][40],"days":b[1][41],"eras":b[1][16],"dayPeriods":b[0][92]},{"months":b[1][17],"days":b[1][41],"eras":b[1][18],"dayPeriods":b[0][92]},{"months":b[1][40],"days":b[1][41],"eras":b[1][19],"dayPeriods":b[0][92]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][99]},{"months":b[1][47],"days":b[1][48],"eras":b[1][49],"dayPeriods":b[0][107]},{"months":b[1][4],"days":b[1][48],"dayPeriods":b[0][107]},{"months":b[1][50],"days":b[1][48],"eras":b[1][6],"dayPeriods":b[0][107]},{"months":b[1][51],"days":b[1][48],"eras":b[1][6],"dayPeriods":b[0][107]},{"months":b[1][51],"days":b[1][48],"eras":b[1][8],"dayPeriods":b[0][107]},{"months":b[1][4],"days":b[1][48],"eras":b[1][6],"dayPeriods":b[0][107]},{"months":b[1][47],"days":b[1][48],"eras":b[1][52],"dayPeriods":b[0][107]},{"months":b[1][53],"days":b[1][48],"eras":b[1][54],"dayPeriods":b[0][107]},{"months":b[1][12],"days":b[1][48],"eras":b[1][13],"dayPeriods":b[0][107]},{"months":b[1][55],"days":b[1][48],"eras":b[1][56],"dayPeriods":b[0][107]},{"months":b[1][47],"days":b[1][48],"eras":b[1][57],"dayPeriods":b[0][107]},{"months":b[1][58],"days":b[1][48],"eras":b[1][59],"dayPeriods":b[0][107]},{"months":b[1][47],"days":b[1][48],"eras":b[1][60],"dayPeriods":b[0][107]},{"nu":b[0][121],"patterns":b[1][27],"symbols":b[1][61],"currencies":b[0][123]},{"months":b[1][47],"days":b[1][48],"eras":b[1][62],"dayPeriods":b[0][107]},{"nu":b[0][121],"patterns":b[1][27],"symbols":b[1][61],"currencies":b[0][126]},{"months":b[1][64],"days":b[1][48],"eras":b[1][49],"dayPeriods":b[0][107]},{"months":b[1][64],"days":b[1][48],"eras":b[1][52],"dayPeriods":b[0][107]},{"months":b[1][64],"days":b[1][48],"eras":b[1][57],"dayPeriods":b[0][107]},{"months":b[1][64],"days":b[1][48],"eras":b[1][60],"dayPeriods":b[0][107]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][65],"currencies":b[0][123]},{"nu":b[0][121],"patterns":b[1][27],"symbols":b[1][66],"currencies":b[0][123]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][61],"currencies":b[0][123]},{"nu":b[0][121],"patterns":b[1][27],"symbols":b[1][61],"currencies":b[0][133]},{"months":b[1][67],"days":b[1][48],"eras":b[1][49],"dayPeriods":b[0][107]},{"months":b[1][67],"days":b[1][48],"eras":b[1][52],"dayPeriods":b[0][107]},{"months":b[1][67],"days":b[1][48],"eras":b[1][57],"dayPeriods":b[0][107]},{"months":b[1][67],"days":b[1][48],"eras":b[1][60],"dayPeriods":b[0][107]},{"months":b[1][68],"days":b[1][48],"eras":b[1][49],"dayPeriods":b[0][107]},{"months":b[1][68],"days":b[1][48],"eras":b[1][52],"dayPeriods":b[0][107]},{"months":b[1][68],"days":b[1][48],"eras":b[1][57],"dayPeriods":b[0][107]},{"months":b[1][68],"days":b[1][48],"eras":b[1][60],"dayPeriods":b[0][107]},{"nu":b[0][121],"patterns":b[1][27],"symbols":b[1][65],"currencies":b[0][139]},{"months":b[1][70],"days":b[1][48],"eras":b[1][49],"dayPeriods":b[0][107]},{"months":b[1][70],"days":b[1][48],"eras":b[1][52],"dayPeriods":b[0][107]},{"months":b[1][70],"days":b[1][48],"eras":b[1][57],"dayPeriods":b[0][107]},{"months":b[1][70],"days":b[1][48],"eras":b[1][60],"dayPeriods":b[0][107]},{"months":b[1][71],"days":b[1][48],"eras":b[1][49],"dayPeriods":b[0][107]},{"months":b[1][71],"days":b[1][48],"eras":b[1][52],"dayPeriods":b[0][107]},{"months":b[1][71],"days":b[1][48],"eras":b[1][57],"dayPeriods":b[0][107]},{"months":b[1][71],"days":b[1][48],"eras":b[1][60],"dayPeriods":b[0][107]},{"nu":b[0][121],"patterns":b[1][27],"symbols":b[1][65],"currencies":b[0][123]},{"nu":b[0][121],"patterns":b[1][27],"symbols":b[1][61],"currencies":b[0][144]},{"nu":b[0][121],"patterns":b[1][27],"symbols":b[1][61],"currencies":b[0][145]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][65],"currencies":b[0][123]},{"months":b[1][73],"days":b[1][74],"eras":b[1][3],"dayPeriods":b[0][153]},{"months":b[1][4],"days":b[1][74],"dayPeriods":b[0][153]},{"months":b[1][5],"days":b[1][74],"eras":b[1][6],"dayPeriods":b[0][153]},{"months":b[1][7],"days":b[1][74],"eras":b[1][6],"dayPeriods":b[0][153]},{"months":b[1][7],"days":b[1][74],"eras":b[1][8],"dayPeriods":b[0][153]},{"months":b[1][4],"days":b[1][74],"eras":b[1][6],"dayPeriods":b[0][153]},{"months":b[1][73],"days":b[1][74],"eras":b[1][75],"dayPeriods":b[0][153]},{"months":b[1][10],"days":b[1][74],"eras":b[1][11],"dayPeriods":b[0][153]},{"months":b[1][12],"days":b[1][74],"eras":b[1][13],"dayPeriods":b[0][153]},{"months":b[1][14],"days":b[1][74],"eras":b[1][15],"dayPeriods":b[0][153]},{"months":b[1][73],"days":b[1][74],"eras":b[1][16],"dayPeriods":b[0][153]},{"months":b[1][17],"days":b[1][74],"eras":b[1][18],"dayPeriods":b[0][153]},{"months":b[1][73],"days":b[1][74],"eras":b[1][19],"dayPeriods":b[0][153]},{"nu":b[0][155],"patterns":b[1][76],"symbols":b[1][77],"currencies":b[0][72]},{"months":b[1][79],"days":b[1][80],"eras":b[1][3],"dayPeriods":b[0][162]},{"months":b[1][4],"days":b[1][80],"dayPeriods":b[0][162]},{"months":b[1][5],"days":b[1][80],"eras":b[1][6],"dayPeriods":b[0][162]},{"months":b[1][7],"days":b[1][80],"eras":b[1][6],"dayPeriods":b[0][162]},{"months":b[1][7],"days":b[1][80],"eras":b[1][8],"dayPeriods":b[0][162]},{"months":b[1][4],"days":b[1][80],"eras":b[1][6],"dayPeriods":b[0][162]},{"months":b[1][79],"days":b[1][80],"eras":b[1][81],"dayPeriods":b[0][162]},{"months":b[1][10],"days":b[1][80],"eras":b[1][11],"dayPeriods":b[0][162]},{"months":b[1][12],"days":b[1][80],"eras":b[1][13],"dayPeriods":b[0][162]},{"months":b[1][14],"days":b[1][80],"eras":b[1][15],"dayPeriods":b[0][162]},{"months":b[1][79],"days":b[1][80],"eras":b[1][16],"dayPeriods":b[0][162]},{"months":b[1][17],"days":b[1][80],"eras":b[1][18],"dayPeriods":b[0][162]},{"months":b[1][79],"days":b[1][80],"eras":b[1][19],"dayPeriods":b[0][162]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][21],"currencies":b[0][166]},{"months":b[1][84],"days":b[1][85],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][85],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][85],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][85],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][85],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][85],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][84],"days":b[1][85],"eras":b[1][86],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][85],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][85],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][85],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][84],"days":b[1][85],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][85],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][84],"days":b[1][85],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][177]},{"months":b[1][89],"days":b[1][90],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][90],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][90],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][90],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][90],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][90],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][89],"days":b[1][90],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][90],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][90],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][90],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][89],"days":b[1][90],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][90],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][89],"days":b[1][90],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][87],"currencies":b[0][183]},{"months":b[1][92],"days":b[1][93],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][93],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][93],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][93],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][93],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][93],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][92],"days":b[1][93],"eras":b[1][94],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][93],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][93],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][93],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][92],"days":b[1][93],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][93],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][92],"days":b[1][93],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][87],"currencies":b[0][192]},{"months":b[1][96],"days":b[1][97],"eras":b[1][3],"dayPeriods":b[0][200]},{"months":b[1][4],"days":b[1][97],"dayPeriods":b[0][200]},{"months":b[1][5],"days":b[1][97],"eras":b[1][6],"dayPeriods":b[0][200]},{"months":b[1][7],"days":b[1][97],"eras":b[1][6],"dayPeriods":b[0][200]},{"months":b[1][7],"days":b[1][97],"eras":b[1][8],"dayPeriods":b[0][200]},{"months":b[1][4],"days":b[1][97],"eras":b[1][6],"dayPeriods":b[0][200]},{"months":b[1][96],"days":b[1][97],"eras":b[1][98],"dayPeriods":b[0][200]},{"months":b[1][10],"days":b[1][97],"eras":b[1][11],"dayPeriods":b[0][200]},{"months":b[1][12],"days":b[1][97],"eras":b[1][13],"dayPeriods":b[0][200]},{"months":b[1][14],"days":b[1][97],"eras":b[1][15],"dayPeriods":b[0][200]},{"months":b[1][96],"days":b[1][97],"eras":b[1][16],"dayPeriods":b[0][200]},{"months":b[1][17],"days":b[1][97],"eras":b[1][18],"dayPeriods":b[0][200]},{"months":b[1][96],"days":b[1][97],"eras":b[1][19],"dayPeriods":b[0][200]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][72]},{"months":b[1][101],"days":b[1][102],"eras":b[1][3],"dayPeriods":b[0][213]},{"months":b[1][4],"days":b[1][102],"dayPeriods":b[0][213]},{"months":b[1][5],"days":b[1][102],"eras":b[1][6],"dayPeriods":b[0][213]},{"months":b[1][7],"days":b[1][102],"eras":b[1][6],"dayPeriods":b[0][213]},{"months":b[1][7],"days":b[1][102],"eras":b[1][8],"dayPeriods":b[0][213]},{"months":b[1][4],"days":b[1][102],"eras":b[1][6],"dayPeriods":b[0][213]},{"months":b[1][101],"days":b[1][102],"eras":b[1][103],"dayPeriods":b[0][213]},{"months":b[1][10],"days":b[1][102],"eras":b[1][11],"dayPeriods":b[0][213]},{"months":b[1][12],"days":b[1][102],"eras":b[1][13],"dayPeriods":b[0][213]},{"months":b[1][14],"days":b[1][102],"eras":b[1][15],"dayPeriods":b[0][213]},{"months":b[1][101],"days":b[1][102],"eras":b[1][16],"dayPeriods":b[0][213]},{"months":b[1][17],"days":b[1][102],"eras":b[1][18],"dayPeriods":b[0][213]},{"months":b[1][101],"days":b[1][102],"eras":b[1][19],"dayPeriods":b[0][213]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][28],"currencies":b[0][215]},{"months":b[1][104],"days":b[1][105],"eras":b[1][3],"dayPeriods":b[0][220]},{"months":b[1][4],"days":b[1][105],"dayPeriods":b[0][220]},{"months":b[1][5],"days":b[1][105],"eras":b[1][6],"dayPeriods":b[0][220]},{"months":b[1][7],"days":b[1][105],"eras":b[1][6],"dayPeriods":b[0][220]},{"months":b[1][7],"days":b[1][105],"eras":b[1][8],"dayPeriods":b[0][220]},{"months":b[1][4],"days":b[1][105],"eras":b[1][6],"dayPeriods":b[0][220]},{"months":b[1][104],"days":b[1][105],"eras":b[1][106],"dayPeriods":b[0][220]},{"months":b[1][10],"days":b[1][105],"eras":b[1][11],"dayPeriods":b[0][220]},{"months":b[1][12],"days":b[1][105],"eras":b[1][13],"dayPeriods":b[0][220]},{"months":b[1][14],"days":b[1][105],"eras":b[1][15],"dayPeriods":b[0][220]},{"months":b[1][104],"days":b[1][105],"eras":b[1][16],"dayPeriods":b[0][220]},{"months":b[1][17],"days":b[1][105],"eras":b[1][18],"dayPeriods":b[0][220]},{"months":b[1][104],"days":b[1][105],"eras":b[1][19],"dayPeriods":b[0][220]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][223]},{"months":b[1][107],"days":b[1][108],"eras":b[1][3],"dayPeriods":b[0][230]},{"months":b[1][4],"days":b[1][108],"dayPeriods":b[0][230]},{"months":b[1][5],"days":b[1][108],"eras":b[1][6],"dayPeriods":b[0][230]},{"months":b[1][7],"days":b[1][108],"eras":b[1][6],"dayPeriods":b[0][230]},{"months":b[1][7],"days":b[1][108],"eras":b[1][8],"dayPeriods":b[0][230]},{"months":b[1][4],"days":b[1][108],"eras":b[1][6],"dayPeriods":b[0][230]},{"months":b[1][107],"days":b[1][108],"eras":b[1][109],"dayPeriods":b[0][230]},{"months":b[1][10],"days":b[1][108],"eras":b[1][11],"dayPeriods":b[0][230]},{"months":b[1][12],"days":b[1][108],"eras":b[1][13],"dayPeriods":b[0][230]},{"months":b[1][14],"days":b[1][108],"eras":b[1][15],"dayPeriods":b[0][230]},{"months":b[1][107],"days":b[1][108],"eras":b[1][16],"dayPeriods":b[0][230]},{"months":b[1][17],"days":b[1][108],"eras":b[1][18],"dayPeriods":b[0][230]},{"months":b[1][107],"days":b[1][108],"eras":b[1][19],"dayPeriods":b[0][230]},{"nu":b[0][33],"patterns":b[1][34],"symbols":b[1][21],"currencies":b[0][166]},{"months":b[1][111],"days":b[1][112],"eras":b[1][3],"dayPeriods":b[0][241]},{"months":b[1][4],"days":b[1][112],"dayPeriods":b[0][241]},{"months":b[1][5],"days":b[1][112],"eras":b[1][6],"dayPeriods":b[0][241]},{"months":b[1][7],"days":b[1][112],"eras":b[1][6],"dayPeriods":b[0][241]},{"months":b[1][7],"days":b[1][112],"eras":b[1][8],"dayPeriods":b[0][241]},{"months":b[1][4],"days":b[1][112],"eras":b[1][6],"dayPeriods":b[0][241]},{"months":b[1][111],"days":b[1][112],"eras":b[1][113],"dayPeriods":b[0][241]},{"months":b[1][114],"days":b[1][112],"eras":b[1][11],"dayPeriods":b[0][241]},{"months":b[1][115],"days":b[1][112],"eras":b[1][13],"dayPeriods":b[0][241]},{"months":b[1][116],"days":b[1][112],"eras":b[1][15],"dayPeriods":b[0][241]},{"months":b[1][111],"days":b[1][112],"eras":b[1][16],"dayPeriods":b[0][241]},{"months":b[1][17],"days":b[1][112],"eras":b[1][18],"dayPeriods":b[0][241]},{"months":b[1][111],"days":b[1][112],"eras":b[1][19],"dayPeriods":b[0][241]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][248]},{"months":b[1][118],"days":b[1][119],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][119],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][119],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][119],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][119],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][119],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][118],"days":b[1][119],"eras":b[1][120],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][119],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][119],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][119],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][118],"days":b[1][119],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][119],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][118],"days":b[1][119],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][72]},{"months":b[1][4],"days":b[1][122],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][122],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][122],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][122],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][122],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][122],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][122],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][122],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][122],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][122],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][122],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][122],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][122],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][21],"currencies":b[0][72]},{"months":b[1][124],"days":b[1][125],"eras":b[1][3],"dayPeriods":b[0][267]},{"months":b[1][4],"days":b[1][125],"dayPeriods":b[0][267]},{"months":b[1][5],"days":b[1][125],"eras":b[1][6],"dayPeriods":b[0][267]},{"months":b[1][7],"days":b[1][125],"eras":b[1][6],"dayPeriods":b[0][267]},{"months":b[1][7],"days":b[1][125],"eras":b[1][8],"dayPeriods":b[0][267]},{"months":b[1][4],"days":b[1][125],"eras":b[1][6],"dayPeriods":b[0][267]},{"months":b[1][124],"days":b[1][125],"eras":b[1][126],"dayPeriods":b[0][267]},{"months":b[1][10],"days":b[1][125],"eras":b[1][11],"dayPeriods":b[0][267]},{"months":b[1][127],"days":b[1][125],"eras":b[1][128],"dayPeriods":b[0][267]},{"months":b[1][129],"days":b[1][125],"eras":b[1][130],"dayPeriods":b[0][267]},{"months":b[1][124],"days":b[1][125],"eras":b[1][16],"dayPeriods":b[0][267]},{"months":b[1][17],"days":b[1][125],"eras":b[1][18],"dayPeriods":b[0][267]},{"months":b[1][124],"days":b[1][125],"eras":b[1][19],"dayPeriods":b[0][267]},{"nu":b[0][155],"patterns":b[1][131],"symbols":b[1][132],"currencies":b[0][275]},{"months":b[1][134],"days":b[1][135],"eras":b[1][3],"dayPeriods":b[0][283]},{"months":b[1][4],"days":b[1][135],"dayPeriods":b[0][283]},{"months":b[1][5],"days":b[1][135],"eras":b[1][6],"dayPeriods":b[0][283]},{"months":b[1][7],"days":b[1][135],"eras":b[1][6],"dayPeriods":b[0][283]},{"months":b[1][7],"days":b[1][135],"eras":b[1][8],"dayPeriods":b[0][283]},{"months":b[1][4],"days":b[1][135],"eras":b[1][6],"dayPeriods":b[0][283]},{"months":b[1][134],"days":b[1][135],"eras":b[1][136],"dayPeriods":b[0][283]},{"months":b[1][10],"days":b[1][135],"eras":b[1][11],"dayPeriods":b[0][283]},{"months":b[1][12],"days":b[1][135],"eras":b[1][13],"dayPeriods":b[0][283]},{"months":b[1][14],"days":b[1][135],"eras":b[1][15],"dayPeriods":b[0][283]},{"months":b[1][134],"days":b[1][135],"eras":b[1][16],"dayPeriods":b[0][283]},{"months":b[1][17],"days":b[1][135],"eras":b[1][18],"dayPeriods":b[0][283]},{"months":b[1][134],"days":b[1][135],"eras":b[1][19],"dayPeriods":b[0][283]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][137],"currencies":b[0][286]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][137],"currencies":b[0][72]},{"months":b[1][139],"days":b[1][140],"eras":b[1][3],"dayPeriods":b[0][294]},{"months":b[1][4],"days":b[1][140],"dayPeriods":b[0][294]},{"months":b[1][5],"days":b[1][140],"eras":b[1][6],"dayPeriods":b[0][294]},{"months":b[1][7],"days":b[1][140],"eras":b[1][6],"dayPeriods":b[0][294]},{"months":b[1][7],"days":b[1][140],"eras":b[1][8],"dayPeriods":b[0][294]},{"months":b[1][4],"days":b[1][140],"eras":b[1][6],"dayPeriods":b[0][294]},{"months":b[1][139],"days":b[1][140],"eras":b[1][75],"dayPeriods":b[0][294]},{"months":b[1][10],"days":b[1][140],"eras":b[1][11],"dayPeriods":b[0][294]},{"months":b[1][12],"days":b[1][140],"eras":b[1][13],"dayPeriods":b[0][294]},{"months":b[1][14],"days":b[1][140],"eras":b[1][15],"dayPeriods":b[0][294]},{"months":b[1][139],"days":b[1][140],"eras":b[1][16],"dayPeriods":b[0][294]},{"months":b[1][17],"days":b[1][140],"eras":b[1][18],"dayPeriods":b[0][294]},{"months":b[1][139],"days":b[1][140],"eras":b[1][19],"dayPeriods":b[0][294]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][295]},{"months":b[1][142],"days":b[1][143],"eras":b[1][3],"dayPeriods":b[0][303]},{"months":b[1][4],"days":b[1][143],"dayPeriods":b[0][303]},{"months":b[1][5],"days":b[1][143],"eras":b[1][6],"dayPeriods":b[0][303]},{"months":b[1][7],"days":b[1][143],"eras":b[1][6],"dayPeriods":b[0][303]},{"months":b[1][7],"days":b[1][143],"eras":b[1][8],"dayPeriods":b[0][303]},{"months":b[1][4],"days":b[1][143],"eras":b[1][6],"dayPeriods":b[0][303]},{"months":b[1][142],"days":b[1][143],"eras":b[1][144],"dayPeriods":b[0][303]},{"months":b[1][10],"days":b[1][143],"eras":b[1][11],"dayPeriods":b[0][303]},{"months":b[1][145],"days":b[1][143],"eras":b[1][13],"dayPeriods":b[0][303]},{"months":b[1][14],"days":b[1][143],"eras":b[1][15],"dayPeriods":b[0][303]},{"months":b[1][142],"days":b[1][143],"eras":b[1][16],"dayPeriods":b[0][303]},{"months":b[1][17],"days":b[1][143],"eras":b[1][18],"dayPeriods":b[0][303]},{"months":b[1][142],"days":b[1][143],"eras":b[1][19],"dayPeriods":b[0][303]},{"nu":b[0][33],"patterns":b[1][76],"symbols":b[1][146],"currencies":b[0][72]},{"months":b[1][148],"days":b[1][149],"eras":b[1][150],"dayPeriods":b[0][315]},{"months":b[1][4],"days":b[1][149],"dayPeriods":b[0][315]},{"months":b[1][151],"days":b[1][149],"eras":b[1][6],"dayPeriods":b[0][315]},{"months":b[1][152],"days":b[1][149],"eras":b[1][6],"dayPeriods":b[0][315]},{"months":b[1][152],"days":b[1][149],"eras":b[1][8],"dayPeriods":b[0][315]},{"months":b[1][4],"days":b[1][149],"eras":b[1][6],"dayPeriods":b[0][315]},{"months":b[1][148],"days":b[1][149],"eras":b[1][153],"dayPeriods":b[0][315]},{"months":b[1][154],"days":b[1][149],"eras":b[1][11],"dayPeriods":b[0][315]},{"months":b[1][155],"days":b[1][149],"eras":b[1][156],"dayPeriods":b[0][315]},{"months":b[1][157],"days":b[1][149],"eras":b[1][158],"dayPeriods":b[0][315]},{"months":b[1][148],"days":b[1][149],"eras":b[1][159],"dayPeriods":b[0][315]},{"months":b[1][160],"days":b[1][149],"eras":b[1][161],"dayPeriods":b[0][315]},{"months":b[1][148],"days":b[1][149],"eras":b[1][162],"dayPeriods":b[0][315]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][331]},{"months":b[1][164],"days":b[1][165],"eras":b[1][3],"dayPeriods":b[0][340]},{"months":b[1][4],"days":b[1][165],"dayPeriods":b[0][340]},{"months":b[1][5],"days":b[1][165],"eras":b[1][6],"dayPeriods":b[0][340]},{"months":b[1][7],"days":b[1][165],"eras":b[1][6],"dayPeriods":b[0][340]},{"months":b[1][7],"days":b[1][165],"eras":b[1][8],"dayPeriods":b[0][340]},{"months":b[1][4],"days":b[1][165],"eras":b[1][6],"dayPeriods":b[0][340]},{"months":b[1][164],"days":b[1][165],"eras":b[1][166],"dayPeriods":b[0][340]},{"months":b[1][10],"days":b[1][165],"eras":b[1][11],"dayPeriods":b[0][340]},{"months":b[1][12],"days":b[1][165],"eras":b[1][13],"dayPeriods":b[0][340]},{"months":b[1][167],"days":b[1][165],"eras":b[1][15],"dayPeriods":b[0][340]},{"months":b[1][164],"days":b[1][165],"eras":b[1][16],"dayPeriods":b[0][340]},{"months":b[1][17],"days":b[1][165],"eras":b[1][18],"dayPeriods":b[0][340]},{"months":b[1][164],"days":b[1][165],"eras":b[1][168],"dayPeriods":b[0][340]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][347]},{"months":b[1][170],"days":b[1][171],"eras":b[1][172],"dayPeriods":b[0][356]},{"months":b[1][173],"days":b[1][171],"dayPeriods":b[0][356]},{"months":b[1][5],"days":b[1][171],"eras":b[1][6],"dayPeriods":b[0][356]},{"months":b[1][7],"days":b[1][171],"eras":b[1][6],"dayPeriods":b[0][356]},{"months":b[1][7],"days":b[1][171],"eras":b[1][8],"dayPeriods":b[0][356]},{"months":b[1][4],"days":b[1][171],"eras":b[1][6],"dayPeriods":b[0][356]},{"months":b[1][170],"days":b[1][171],"eras":b[1][174],"dayPeriods":b[0][356]},{"months":b[1][10],"days":b[1][171],"eras":b[1][11],"dayPeriods":b[0][356]},{"months":b[1][12],"days":b[1][171],"eras":b[1][13],"dayPeriods":b[0][356]},{"months":b[1][14],"days":b[1][171],"eras":b[1][15],"dayPeriods":b[0][356]},{"months":b[1][170],"days":b[1][171],"eras":b[1][16],"dayPeriods":b[0][356]},{"months":b[1][17],"days":b[1][171],"eras":b[1][18],"dayPeriods":b[0][356]},{"months":b[1][170],"days":b[1][171],"eras":b[1][19],"dayPeriods":b[0][356]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][360]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][361]},{"months":b[1][175],"days":b[1][176],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][176],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][176],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][176],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][176],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][176],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][175],"days":b[1][176],"eras":b[1][177],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][176],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][176],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][176],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][175],"days":b[1][176],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][176],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][175],"days":b[1][176],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][368]},{"months":b[1][179],"days":b[1][180],"eras":b[1][3],"dayPeriods":b[0][376]},{"months":b[1][4],"days":b[1][180],"dayPeriods":b[0][376]},{"months":b[1][5],"days":b[1][180],"eras":b[1][6],"dayPeriods":b[0][376]},{"months":b[1][7],"days":b[1][180],"eras":b[1][6],"dayPeriods":b[0][376]},{"months":b[1][7],"days":b[1][180],"eras":b[1][8],"dayPeriods":b[0][376]},{"months":b[1][4],"days":b[1][180],"eras":b[1][6],"dayPeriods":b[0][376]},{"months":b[1][179],"days":b[1][180],"eras":b[1][181],"dayPeriods":b[0][376]},{"months":b[1][10],"days":b[1][180],"eras":b[1][11],"dayPeriods":b[0][376]},{"months":b[1][12],"days":b[1][180],"eras":b[1][13],"dayPeriods":b[0][376]},{"months":b[1][14],"days":b[1][180],"eras":b[1][15],"dayPeriods":b[0][376]},{"months":b[1][179],"days":b[1][180],"eras":b[1][16],"dayPeriods":b[0][376]},{"months":b[1][17],"days":b[1][180],"eras":b[1][18],"dayPeriods":b[0][376]},{"months":b[1][179],"days":b[1][180],"eras":b[1][19],"dayPeriods":b[0][376]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][379]},{"months":b[1][183],"days":b[1][184],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][184],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][184],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][184],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][184],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][184],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][183],"days":b[1][184],"eras":b[1][185],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][184],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][184],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][184],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][183],"days":b[1][184],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][184],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][183],"days":b[1][184],"eras":b[1][186],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][390]},{"months":b[1][188],"days":b[1][189],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][189],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][189],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][189],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][189],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][189],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][188],"days":b[1][189],"eras":b[1][190],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][189],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][189],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][189],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][188],"days":b[1][189],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][189],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][188],"days":b[1][189],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][192]},{"months":b[1][192],"days":b[1][193],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][193],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][193],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][193],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][193],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][193],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][192],"days":b[1][193],"eras":b[1][194],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][193],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][193],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][193],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][192],"days":b[1][193],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][193],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][192],"days":b[1][193],"eras":b[1][195],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][413]},{"months":b[1][196],"days":b[1][197],"eras":b[1][3],"dayPeriods":b[0][420]},{"months":b[1][4],"days":b[1][197],"dayPeriods":b[0][420]},{"months":b[1][5],"days":b[1][197],"eras":b[1][6],"dayPeriods":b[0][420]},{"months":b[1][7],"days":b[1][197],"eras":b[1][6],"dayPeriods":b[0][420]},{"months":b[1][7],"days":b[1][197],"eras":b[1][8],"dayPeriods":b[0][420]},{"months":b[1][4],"days":b[1][197],"eras":b[1][6],"dayPeriods":b[0][420]},{"months":b[1][196],"days":b[1][197],"eras":b[1][198],"dayPeriods":b[0][420]},{"months":b[1][10],"days":b[1][197],"eras":b[1][11],"dayPeriods":b[0][420]},{"months":b[1][12],"days":b[1][197],"eras":b[1][13],"dayPeriods":b[0][420]},{"months":b[1][14],"days":b[1][197],"eras":b[1][15],"dayPeriods":b[0][420]},{"months":b[1][196],"days":b[1][197],"eras":b[1][16],"dayPeriods":b[0][420]},{"months":b[1][17],"days":b[1][197],"eras":b[1][18],"dayPeriods":b[0][420]},{"months":b[1][196],"days":b[1][197],"eras":b[1][19],"dayPeriods":b[0][420]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][423]},{"months":b[1][200],"days":b[1][201],"eras":b[1][3],"dayPeriods":b[0][431]},{"months":b[1][4],"days":b[1][201],"dayPeriods":b[0][431]},{"months":b[1][5],"days":b[1][201],"eras":b[1][6],"dayPeriods":b[0][431]},{"months":b[1][7],"days":b[1][201],"eras":b[1][6],"dayPeriods":b[0][431]},{"months":b[1][7],"days":b[1][201],"eras":b[1][8],"dayPeriods":b[0][431]},{"months":b[1][4],"days":b[1][201],"eras":b[1][6],"dayPeriods":b[0][431]},{"months":b[1][200],"days":b[1][201],"eras":b[1][202],"dayPeriods":b[0][431]},{"months":b[1][10],"days":b[1][201],"eras":b[1][11],"dayPeriods":b[0][431]},{"months":b[1][12],"days":b[1][201],"eras":b[1][13],"dayPeriods":b[0][431]},{"months":b[1][14],"days":b[1][201],"eras":b[1][15],"dayPeriods":b[0][431]},{"months":b[1][200],"days":b[1][201],"eras":b[1][16],"dayPeriods":b[0][431]},{"months":b[1][17],"days":b[1][201],"eras":b[1][18],"dayPeriods":b[0][431]},{"months":b[1][200],"days":b[1][201],"eras":b[1][195],"dayPeriods":b[0][431]},{"nu":b[0][33],"patterns":b[1][203],"symbols":b[1][87],"currencies":b[0][434]},{"months":b[1][205],"days":b[1][201],"eras":b[1][3],"dayPeriods":b[0][431]},{"months":b[1][205],"days":b[1][201],"eras":b[1][202],"dayPeriods":b[0][431]},{"months":b[1][205],"days":b[1][201],"eras":b[1][16],"dayPeriods":b[0][431]},{"months":b[1][205],"days":b[1][201],"eras":b[1][195],"dayPeriods":b[0][431]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][434]},{"nu":b[0][33],"patterns":b[1][206],"symbols":b[1][207],"currencies":b[0][434]},{"nu":b[0][33],"patterns":b[1][203],"symbols":b[1][207],"currencies":b[0][434]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][440]},{"months":b[1][208],"days":b[1][209],"eras":b[1][3],"dayPeriods":b[0][447]},{"months":b[1][4],"days":b[1][209],"dayPeriods":b[0][447]},{"months":b[1][5],"days":b[1][209],"eras":b[1][6],"dayPeriods":b[0][447]},{"months":b[1][7],"days":b[1][209],"eras":b[1][6],"dayPeriods":b[0][447]},{"months":b[1][7],"days":b[1][209],"eras":b[1][8],"dayPeriods":b[0][447]},{"months":b[1][4],"days":b[1][209],"eras":b[1][6],"dayPeriods":b[0][447]},{"months":b[1][208],"days":b[1][209],"eras":b[1][210],"dayPeriods":b[0][447]},{"months":b[1][10],"days":b[1][209],"eras":b[1][11],"dayPeriods":b[0][447]},{"months":b[1][12],"days":b[1][209],"eras":b[1][13],"dayPeriods":b[0][447]},{"months":b[1][14],"days":b[1][209],"eras":b[1][15],"dayPeriods":b[0][447]},{"months":b[1][208],"days":b[1][209],"eras":b[1][16],"dayPeriods":b[0][447]},{"months":b[1][17],"days":b[1][209],"eras":b[1][18],"dayPeriods":b[0][447]},{"months":b[1][208],"days":b[1][209],"eras":b[1][19],"dayPeriods":b[0][447]},{"nu":b[0][33],"patterns":b[1][34],"symbols":b[1][211],"currencies":b[0][72]},{"months":b[1][213],"days":b[1][214],"eras":b[1][3],"dayPeriods":b[0][458]},{"months":b[1][4],"days":b[1][214],"dayPeriods":b[0][458]},{"months":b[1][5],"days":b[1][214],"eras":b[1][6],"dayPeriods":b[0][458]},{"months":b[1][7],"days":b[1][214],"eras":b[1][6],"dayPeriods":b[0][458]},{"months":b[1][7],"days":b[1][214],"eras":b[1][8],"dayPeriods":b[0][458]},{"months":b[1][4],"days":b[1][214],"eras":b[1][6],"dayPeriods":b[0][458]},{"months":b[1][213],"days":b[1][214],"eras":b[1][215],"dayPeriods":b[0][458]},{"months":b[1][10],"days":b[1][214],"eras":b[1][11],"dayPeriods":b[0][458]},{"months":b[1][12],"days":b[1][214],"eras":b[1][13],"dayPeriods":b[0][458]},{"months":b[1][14],"days":b[1][214],"eras":b[1][15],"dayPeriods":b[0][458]},{"months":b[1][213],"days":b[1][214],"eras":b[1][16],"dayPeriods":b[0][458]},{"months":b[1][17],"days":b[1][214],"eras":b[1][18],"dayPeriods":b[0][458]},{"months":b[1][213],"days":b[1][214],"eras":b[1][19],"dayPeriods":b[0][458]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][461]},{"months":b[1][217],"days":b[1][218],"eras":b[1][3],"dayPeriods":b[0][469]},{"months":b[1][4],"days":b[1][218],"dayPeriods":b[0][469]},{"months":b[1][5],"days":b[1][218],"eras":b[1][6],"dayPeriods":b[0][469]},{"months":b[1][7],"days":b[1][218],"eras":b[1][6],"dayPeriods":b[0][469]},{"months":b[1][7],"days":b[1][218],"eras":b[1][8],"dayPeriods":b[0][469]},{"months":b[1][4],"days":b[1][218],"eras":b[1][6],"dayPeriods":b[0][469]},{"months":b[1][217],"days":b[1][218],"eras":b[1][219],"dayPeriods":b[0][469]},{"months":b[1][10],"days":b[1][218],"eras":b[1][11],"dayPeriods":b[0][469]},{"months":b[1][12],"days":b[1][218],"eras":b[1][13],"dayPeriods":b[0][469]},{"months":b[1][14],"days":b[1][218],"eras":b[1][15],"dayPeriods":b[0][469]},{"months":b[1][217],"days":b[1][218],"eras":b[1][16],"dayPeriods":b[0][469]},{"months":b[1][17],"days":b[1][218],"eras":b[1][18],"dayPeriods":b[0][469]},{"months":b[1][217],"days":b[1][218],"eras":b[1][19],"dayPeriods":b[0][469]},{"months":b[1][220],"days":b[1][221],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][221],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][221],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][221],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][221],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][221],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][220],"days":b[1][221],"eras":b[1][222],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][221],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][221],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][221],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][220],"days":b[1][221],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][221],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][220],"days":b[1][221],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][72]},{"months":b[1][224],"days":b[1][225],"eras":b[1][3],"dayPeriods":b[0][489]},{"months":b[1][4],"days":b[1][225],"dayPeriods":b[0][489]},{"months":b[1][5],"days":b[1][225],"eras":b[1][6],"dayPeriods":b[0][489]},{"months":b[1][7],"days":b[1][225],"eras":b[1][6],"dayPeriods":b[0][489]},{"months":b[1][7],"days":b[1][225],"eras":b[1][8],"dayPeriods":b[0][489]},{"months":b[1][4],"days":b[1][225],"eras":b[1][6],"dayPeriods":b[0][489]},{"months":b[1][224],"days":b[1][225],"eras":b[1][75],"dayPeriods":b[0][489]},{"months":b[1][10],"days":b[1][225],"eras":b[1][11],"dayPeriods":b[0][489]},{"months":b[1][12],"days":b[1][225],"eras":b[1][13],"dayPeriods":b[0][489]},{"months":b[1][14],"days":b[1][225],"eras":b[1][15],"dayPeriods":b[0][489]},{"months":b[1][224],"days":b[1][225],"eras":b[1][16],"dayPeriods":b[0][489]},{"months":b[1][17],"days":b[1][225],"eras":b[1][18],"dayPeriods":b[0][489]},{"months":b[1][224],"days":b[1][225],"eras":b[1][19],"dayPeriods":b[0][489]},{"nu":b[0][490],"patterns":b[1][226],"symbols":b[1][227],"currencies":b[0][492]},{"months":b[1][228],"days":b[1][229],"eras":b[1][3],"dayPeriods":b[0][499]},{"months":b[1][4],"days":b[1][229],"dayPeriods":b[0][499]},{"months":b[1][5],"days":b[1][229],"eras":b[1][6],"dayPeriods":b[0][499]},{"months":b[1][7],"days":b[1][229],"eras":b[1][6],"dayPeriods":b[0][499]},{"months":b[1][7],"days":b[1][229],"eras":b[1][8],"dayPeriods":b[0][499]},{"months":b[1][4],"days":b[1][229],"eras":b[1][6],"dayPeriods":b[0][499]},{"months":b[1][228],"days":b[1][229],"eras":b[1][230],"dayPeriods":b[0][499]},{"months":b[1][10],"days":b[1][229],"eras":b[1][11],"dayPeriods":b[0][499]},{"months":b[1][12],"days":b[1][229],"eras":b[1][13],"dayPeriods":b[0][499]},{"months":b[1][14],"days":b[1][229],"eras":b[1][15],"dayPeriods":b[0][499]},{"months":b[1][228],"days":b[1][229],"eras":b[1][16],"dayPeriods":b[0][499]},{"months":b[1][17],"days":b[1][229],"eras":b[1][18],"dayPeriods":b[0][499]},{"months":b[1][228],"days":b[1][229],"eras":b[1][19],"dayPeriods":b[0][499]},{"months":b[1][232],"days":b[1][233],"eras":b[1][3],"dayPeriods":b[0][511]},{"months":b[1][234],"days":b[1][233],"dayPeriods":b[0][511]},{"months":b[1][235],"days":b[1][233],"eras":b[1][6],"dayPeriods":b[0][511]},{"months":b[1][236],"days":b[1][233],"eras":b[1][6],"dayPeriods":b[0][511]},{"months":b[1][236],"days":b[1][233],"eras":b[1][8],"dayPeriods":b[0][511]},{"months":b[1][4],"days":b[1][233],"eras":b[1][6],"dayPeriods":b[0][511]},{"months":b[1][232],"days":b[1][233],"eras":b[1][237],"dayPeriods":b[0][511]},{"months":b[1][238],"days":b[1][233],"eras":b[1][239],"dayPeriods":b[0][511]},{"months":b[1][240],"days":b[1][233],"eras":b[1][13],"dayPeriods":b[0][511]},{"months":b[1][234],"days":b[1][233],"eras":b[1][15],"dayPeriods":b[0][511]},{"months":b[1][232],"days":b[1][233],"eras":b[1][16],"dayPeriods":b[0][511]},{"months":b[1][234],"days":b[1][233],"eras":b[1][18],"dayPeriods":b[0][511]},{"months":b[1][232],"days":b[1][233],"eras":b[1][241],"dayPeriods":b[0][511]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][242],"currencies":b[0][523]},{"months":b[1][244],"days":b[1][245],"eras":b[1][3],"dayPeriods":b[0][532]},{"months":b[1][4],"days":b[1][245],"dayPeriods":b[0][532]},{"months":b[1][5],"days":b[1][245],"eras":b[1][6],"dayPeriods":b[0][532]},{"months":b[1][7],"days":b[1][245],"eras":b[1][6],"dayPeriods":b[0][532]},{"months":b[1][7],"days":b[1][245],"eras":b[1][8],"dayPeriods":b[0][532]},{"months":b[1][4],"days":b[1][245],"eras":b[1][6],"dayPeriods":b[0][532]},{"months":b[1][244],"days":b[1][245],"eras":b[1][246],"dayPeriods":b[0][532]},{"months":b[1][10],"days":b[1][245],"eras":b[1][11],"dayPeriods":b[0][532]},{"months":b[1][12],"days":b[1][245],"eras":b[1][13],"dayPeriods":b[0][532]},{"months":b[1][14],"days":b[1][245],"eras":b[1][15],"dayPeriods":b[0][532]},{"months":b[1][244],"days":b[1][245],"eras":b[1][16],"dayPeriods":b[0][532]},{"months":b[1][17],"days":b[1][245],"eras":b[1][18],"dayPeriods":b[0][532]},{"months":b[1][244],"days":b[1][245],"eras":b[1][247],"dayPeriods":b[0][532]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][87],"currencies":b[0][536]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][536]},{"months":b[1][249],"days":b[1][250],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][251],"days":b[1][250],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][250],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][250],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][250],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][250],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][249],"days":b[1][250],"eras":b[1][252],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][250],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][250],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][250],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][249],"days":b[1][250],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][250],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][249],"days":b[1][250],"eras":b[1][195],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][545]},{"months":b[1][249],"days":b[1][250],"eras":b[1][3],"dayPeriods":b[0][549]},{"months":b[1][251],"days":b[1][250],"dayPeriods":b[0][549]},{"months":b[1][5],"days":b[1][250],"eras":b[1][6],"dayPeriods":b[0][549]},{"months":b[1][7],"days":b[1][250],"eras":b[1][6],"dayPeriods":b[0][549]},{"months":b[1][7],"days":b[1][250],"eras":b[1][8],"dayPeriods":b[0][549]},{"months":b[1][4],"days":b[1][250],"eras":b[1][6],"dayPeriods":b[0][549]},{"months":b[1][249],"days":b[1][250],"eras":b[1][252],"dayPeriods":b[0][549]},{"months":b[1][10],"days":b[1][250],"eras":b[1][11],"dayPeriods":b[0][549]},{"months":b[1][12],"days":b[1][250],"eras":b[1][254],"dayPeriods":b[0][549]},{"months":b[1][14],"days":b[1][250],"eras":b[1][15],"dayPeriods":b[0][549]},{"months":b[1][249],"days":b[1][250],"eras":b[1][16],"dayPeriods":b[0][549]},{"months":b[1][17],"days":b[1][250],"eras":b[1][18],"dayPeriods":b[0][549]},{"months":b[1][249],"days":b[1][250],"eras":b[1][195],"dayPeriods":b[0][549]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][551]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][552]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][553]},{"months":b[1][173],"days":b[1][250],"dayPeriods":b[0][549]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][551]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][556]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][557]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][558]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][561]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][564]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][567]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][568]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][569]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][571]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][572]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][573]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][574]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][575]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][576]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][577]},{"months":b[1][249],"days":b[1][250],"eras":b[1][261],"dayPeriods":b[0][549]},{"months":b[1][249],"days":b[1][250],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][251],"days":b[1][250],"dayPeriods":b[0][583]},{"months":b[1][5],"days":b[1][250],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][250],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][250],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][250],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][249],"days":b[1][250],"eras":b[1][252],"dayPeriods":b[0][583]},{"months":b[1][10],"days":b[1][250],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][250],"eras":b[1][254],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][250],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][249],"days":b[1][250],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][250],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][249],"days":b[1][250],"eras":b[1][195],"dayPeriods":b[0][583]},{"nu":b[0][33],"patterns":b[1][76],"symbols":b[1][21],"currencies":b[0][551]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][588]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][589]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][590]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][591]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][592]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][593]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][594]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][597]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][598]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][599]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][600]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][601]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][602]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][605]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][606]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][607]},{"nu":b[0][33],"patterns":b[1][76],"symbols":b[1][21],"currencies":b[0][609]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][610]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][611]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][612]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][614]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][615]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][616]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][617]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][618]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][619]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][620]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][621]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][622]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][623]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][624]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][625]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][28],"currencies":b[0][592]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][628]},{"months":b[1][272],"days":b[1][273],"eras":b[1][3],"dayPeriods":b[0][639]},{"months":b[1][4],"days":b[1][273],"dayPeriods":b[0][639]},{"months":b[1][5],"days":b[1][273],"eras":b[1][6],"dayPeriods":b[0][639]},{"months":b[1][7],"days":b[1][273],"eras":b[1][6],"dayPeriods":b[0][639]},{"months":b[1][7],"days":b[1][273],"eras":b[1][8],"dayPeriods":b[0][639]},{"months":b[1][4],"days":b[1][273],"eras":b[1][6],"dayPeriods":b[0][639]},{"months":b[1][272],"days":b[1][273],"eras":b[1][274],"dayPeriods":b[0][639]},{"months":b[1][10],"days":b[1][273],"eras":b[1][11],"dayPeriods":b[0][639]},{"months":b[1][12],"days":b[1][273],"eras":b[1][13],"dayPeriods":b[0][639]},{"months":b[1][14],"days":b[1][273],"eras":b[1][15],"dayPeriods":b[0][639]},{"months":b[1][272],"days":b[1][273],"eras":b[1][16],"dayPeriods":b[0][639]},{"months":b[1][17],"days":b[1][273],"eras":b[1][18],"dayPeriods":b[0][639]},{"months":b[1][272],"days":b[1][273],"eras":b[1][19],"dayPeriods":b[0][639]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][28],"currencies":b[0][643]},{"months":b[1][276],"days":b[1][277],"eras":b[1][3],"dayPeriods":b[0][652]},{"months":b[1][4],"days":b[1][277],"dayPeriods":b[0][652]},{"months":b[1][5],"days":b[1][277],"eras":b[1][6],"dayPeriods":b[0][652]},{"months":b[1][7],"days":b[1][277],"eras":b[1][6],"dayPeriods":b[0][652]},{"months":b[1][7],"days":b[1][277],"eras":b[1][8],"dayPeriods":b[0][652]},{"months":b[1][4],"days":b[1][277],"eras":b[1][6],"dayPeriods":b[0][652]},{"months":b[1][276],"days":b[1][277],"eras":b[1][278],"dayPeriods":b[0][652]},{"months":b[1][10],"days":b[1][277],"eras":b[1][11],"dayPeriods":b[0][652]},{"months":b[1][12],"days":b[1][277],"eras":b[1][13],"dayPeriods":b[0][652]},{"months":b[1][14],"days":b[1][277],"eras":b[1][15],"dayPeriods":b[0][652]},{"months":b[1][276],"days":b[1][277],"eras":b[1][16],"dayPeriods":b[0][652]},{"months":b[1][17],"days":b[1][277],"eras":b[1][18],"dayPeriods":b[0][652]},{"months":b[1][276],"days":b[1][277],"eras":b[1][279],"dayPeriods":b[0][652]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][21],"currencies":b[0][656]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][87],"currencies":b[0][659]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][87],"currencies":b[0][660]},{"nu":b[0][33],"patterns":b[1][283],"symbols":b[1][87],"currencies":b[0][664]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][87],"currencies":b[0][667]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][87],"currencies":b[0][668]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][21],"currencies":b[0][669]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][21],"currencies":b[0][670]},{"months":b[1][286],"days":b[1][287],"eras":b[1][3],"dayPeriods":b[0][356]},{"months":b[1][4],"days":b[1][287],"dayPeriods":b[0][356]},{"months":b[1][5],"days":b[1][287],"eras":b[1][6],"dayPeriods":b[0][356]},{"months":b[1][7],"days":b[1][287],"eras":b[1][6],"dayPeriods":b[0][356]},{"months":b[1][7],"days":b[1][287],"eras":b[1][8],"dayPeriods":b[0][356]},{"months":b[1][4],"days":b[1][287],"eras":b[1][6],"dayPeriods":b[0][356]},{"months":b[1][286],"days":b[1][287],"eras":b[1][288],"dayPeriods":b[0][356]},{"months":b[1][10],"days":b[1][287],"eras":b[1][11],"dayPeriods":b[0][356]},{"months":b[1][12],"days":b[1][287],"eras":b[1][13],"dayPeriods":b[0][356]},{"months":b[1][14],"days":b[1][287],"eras":b[1][15],"dayPeriods":b[0][356]},{"months":b[1][286],"days":b[1][287],"eras":b[1][16],"dayPeriods":b[0][356]},{"months":b[1][17],"days":b[1][287],"eras":b[1][18],"dayPeriods":b[0][356]},{"months":b[1][286],"days":b[1][287],"eras":b[1][279],"dayPeriods":b[0][356]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][678]},{"nu":b[0][33],"patterns":b[1][283],"symbols":b[1][87],"currencies":b[0][679]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][87],"currencies":b[0][680]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][21],"currencies":b[0][681]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][21],"currencies":b[0][683]},{"months":b[1][292],"days":b[1][293],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][293],"dayPeriods":b[0][583]},{"months":b[1][5],"days":b[1][293],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][293],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][293],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][293],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][292],"days":b[1][293],"eras":b[1][294],"dayPeriods":b[0][583]},{"months":b[1][10],"days":b[1][293],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][293],"eras":b[1][13],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][293],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][292],"days":b[1][293],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][293],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][292],"days":b[1][293],"eras":b[1][279],"dayPeriods":b[0][583]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][691]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][21],"currencies":b[0][692]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][21],"currencies":b[0][695]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][21],"currencies":b[0][698]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][699]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][21],"currencies":b[0][679]},{"nu":b[0][33],"patterns":b[1][297],"symbols":b[1][87],"currencies":b[0][701]},{"months":b[1][276],"days":b[1][277],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][277],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][277],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][277],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][277],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][277],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][276],"days":b[1][277],"eras":b[1][278],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][277],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][277],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][277],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][276],"days":b[1][277],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][277],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][276],"days":b[1][277],"eras":b[1][279],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][280],"symbols":b[1][21],"currencies":b[0][702]},{"nu":b[0][33],"patterns":b[1][203],"symbols":b[1][87],"currencies":b[0][703]},{"nu":b[0][33],"patterns":b[1][283],"symbols":b[1][87],"currencies":b[0][704]},{"months":b[1][299],"days":b[1][300],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][300],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][300],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][300],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][300],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][300],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][299],"days":b[1][300],"eras":b[1][301],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][300],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][300],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][300],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][299],"days":b[1][300],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][300],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][299],"days":b[1][300],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][716]},{"months":b[1][303],"days":b[1][304],"eras":b[1][305],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][304],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][304],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][304],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][304],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][304],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][303],"days":b[1][304],"eras":b[1][306],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][304],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][304],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][304],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][303],"days":b[1][304],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][304],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][303],"days":b[1][304],"eras":b[1][307],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][308],"symbols":b[1][87],"currencies":b[0][730]},{"months":b[1][310],"days":b[1][311],"eras":b[1][3],"dayPeriods":b[0][737]},{"months":b[1][4],"days":b[1][311],"dayPeriods":b[0][737]},{"months":b[1][5],"days":b[1][311],"eras":b[1][6],"dayPeriods":b[0][737]},{"months":b[1][7],"days":b[1][311],"eras":b[1][6],"dayPeriods":b[0][737]},{"months":b[1][7],"days":b[1][311],"eras":b[1][8],"dayPeriods":b[0][737]},{"months":b[1][4],"days":b[1][311],"eras":b[1][6],"dayPeriods":b[0][737]},{"months":b[1][310],"days":b[1][311],"eras":b[1][312],"dayPeriods":b[0][737]},{"months":b[1][10],"days":b[1][311],"eras":b[1][11],"dayPeriods":b[0][737]},{"months":b[1][12],"days":b[1][311],"eras":b[1][13],"dayPeriods":b[0][737]},{"months":b[1][14],"days":b[1][311],"eras":b[1][15],"dayPeriods":b[0][737]},{"months":b[1][310],"days":b[1][311],"eras":b[1][16],"dayPeriods":b[0][737]},{"months":b[1][17],"days":b[1][311],"eras":b[1][18],"dayPeriods":b[0][737]},{"months":b[1][310],"days":b[1][311],"eras":b[1][19],"dayPeriods":b[0][737]},{"months":b[1][314],"days":b[1][315],"eras":b[1][3],"dayPeriods":b[0][748]},{"months":b[1][4],"days":b[1][315],"dayPeriods":b[0][748]},{"months":b[1][5],"days":b[1][315],"eras":b[1][6],"dayPeriods":b[0][748]},{"months":b[1][7],"days":b[1][315],"eras":b[1][6],"dayPeriods":b[0][748]},{"months":b[1][7],"days":b[1][315],"eras":b[1][8],"dayPeriods":b[0][748]},{"months":b[1][4],"days":b[1][315],"eras":b[1][6],"dayPeriods":b[0][748]},{"months":b[1][314],"days":b[1][315],"eras":b[1][316],"dayPeriods":b[0][748]},{"months":b[1][317],"days":b[1][315],"eras":b[1][11],"dayPeriods":b[0][748]},{"months":b[1][12],"days":b[1][315],"eras":b[1][13],"dayPeriods":b[0][748]},{"months":b[1][318],"days":b[1][315],"eras":b[1][319],"dayPeriods":b[0][748]},{"months":b[1][314],"days":b[1][315],"eras":b[1][16],"dayPeriods":b[0][748]},{"months":b[1][320],"days":b[1][315],"eras":b[1][321],"dayPeriods":b[0][748]},{"months":b[1][314],"days":b[1][315],"eras":b[1][19],"dayPeriods":b[0][748]},{"nu":b[0][763],"patterns":b[1][322],"symbols":b[1][323],"currencies":b[0][766]},{"months":b[1][324],"days":b[1][315],"eras":b[1][3],"dayPeriods":b[0][748]},{"months":b[1][324],"days":b[1][315],"eras":b[1][316],"dayPeriods":b[0][748]},{"months":b[1][324],"days":b[1][315],"eras":b[1][16],"dayPeriods":b[0][748]},{"months":b[1][325],"days":b[1][315],"eras":b[1][326],"dayPeriods":b[0][748]},{"months":b[1][324],"days":b[1][315],"eras":b[1][19],"dayPeriods":b[0][748]},{"months":b[1][328],"days":b[1][329],"eras":b[1][3],"dayPeriods":b[0][776]},{"months":b[1][4],"days":b[1][329],"dayPeriods":b[0][776]},{"months":b[1][5],"days":b[1][329],"eras":b[1][6],"dayPeriods":b[0][776]},{"months":b[1][7],"days":b[1][329],"eras":b[1][6],"dayPeriods":b[0][776]},{"months":b[1][7],"days":b[1][329],"eras":b[1][8],"dayPeriods":b[0][776]},{"months":b[1][4],"days":b[1][329],"eras":b[1][6],"dayPeriods":b[0][776]},{"months":b[1][328],"days":b[1][329],"eras":b[1][330],"dayPeriods":b[0][776]},{"months":b[1][10],"days":b[1][329],"eras":b[1][11],"dayPeriods":b[0][776]},{"months":b[1][12],"days":b[1][329],"eras":b[1][13],"dayPeriods":b[0][776]},{"months":b[1][14],"days":b[1][329],"eras":b[1][15],"dayPeriods":b[0][776]},{"months":b[1][328],"days":b[1][329],"eras":b[1][16],"dayPeriods":b[0][776]},{"months":b[1][17],"days":b[1][329],"eras":b[1][18],"dayPeriods":b[0][776]},{"months":b[1][328],"days":b[1][329],"eras":b[1][19],"dayPeriods":b[0][776]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][779]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][780]},{"months":b[1][332],"days":b[1][333],"eras":b[1][3],"dayPeriods":b[0][789]},{"months":b[1][4],"days":b[1][333],"dayPeriods":b[0][789]},{"months":b[1][5],"days":b[1][333],"eras":b[1][6],"dayPeriods":b[0][789]},{"months":b[1][7],"days":b[1][333],"eras":b[1][6],"dayPeriods":b[0][789]},{"months":b[1][7],"days":b[1][333],"eras":b[1][8],"dayPeriods":b[0][789]},{"months":b[1][4],"days":b[1][333],"eras":b[1][6],"dayPeriods":b[0][789]},{"months":b[1][332],"days":b[1][333],"eras":b[1][334],"dayPeriods":b[0][789]},{"months":b[1][335],"days":b[1][333],"eras":b[1][11],"dayPeriods":b[0][789]},{"months":b[1][12],"days":b[1][333],"eras":b[1][13],"dayPeriods":b[0][789]},{"months":b[1][336],"days":b[1][333],"eras":b[1][15],"dayPeriods":b[0][789]},{"months":b[1][332],"days":b[1][333],"eras":b[1][16],"dayPeriods":b[0][789]},{"months":b[1][17],"days":b[1][333],"eras":b[1][18],"dayPeriods":b[0][789]},{"months":b[1][332],"days":b[1][333],"eras":b[1][195],"dayPeriods":b[0][789]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][337],"currencies":b[0][797]},{"months":b[1][339],"days":b[1][340],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][340],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][340],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][340],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][340],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][340],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][339],"days":b[1][340],"eras":b[1][341],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][340],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][340],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][340],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][339],"days":b[1][340],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][340],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][339],"days":b[1][340],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][805]},{"months":b[1][343],"days":b[1][344],"eras":b[1][3],"dayPeriods":b[0][813]},{"months":b[1][4],"days":b[1][344],"dayPeriods":b[0][813]},{"months":b[1][5],"days":b[1][344],"eras":b[1][6],"dayPeriods":b[0][813]},{"months":b[1][7],"days":b[1][344],"eras":b[1][6],"dayPeriods":b[0][813]},{"months":b[1][7],"days":b[1][344],"eras":b[1][8],"dayPeriods":b[0][813]},{"months":b[1][4],"days":b[1][344],"eras":b[1][6],"dayPeriods":b[0][813]},{"months":b[1][343],"days":b[1][344],"eras":b[1][345],"dayPeriods":b[0][813]},{"months":b[1][10],"days":b[1][344],"eras":b[1][11],"dayPeriods":b[0][813]},{"months":b[1][12],"days":b[1][344],"eras":b[1][13],"dayPeriods":b[0][813]},{"months":b[1][14],"days":b[1][344],"eras":b[1][15],"dayPeriods":b[0][813]},{"months":b[1][343],"days":b[1][344],"eras":b[1][16],"dayPeriods":b[0][813]},{"months":b[1][17],"days":b[1][344],"eras":b[1][18],"dayPeriods":b[0][813]},{"months":b[1][343],"days":b[1][344],"eras":b[1][19],"dayPeriods":b[0][813]},{"nu":b[0][33],"patterns":b[1][283],"symbols":b[1][346],"currencies":b[0][818]},{"months":b[1][348],"days":b[1][349],"eras":b[1][350],"dayPeriods":b[0][175]},{"months":b[1][351],"days":b[1][349],"dayPeriods":b[0][175]},{"months":b[1][352],"days":b[1][349],"eras":b[1][353],"dayPeriods":b[0][175]},{"months":b[1][354],"days":b[1][349],"eras":b[1][355],"dayPeriods":b[0][175]},{"months":b[1][354],"days":b[1][349],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][349],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][348],"days":b[1][349],"eras":b[1][356],"dayPeriods":b[0][175]},{"months":b[1][357],"days":b[1][349],"eras":b[1][358],"dayPeriods":b[0][175]},{"months":b[1][359],"days":b[1][349],"eras":b[1][254],"dayPeriods":b[0][175]},{"months":b[1][360],"days":b[1][349],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][348],"days":b[1][349],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][349],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][348],"days":b[1][349],"eras":b[1][361],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][852]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][852]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][853]},{"months":b[1][348],"days":b[1][349],"eras":b[1][364],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][857]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][858]},{"nu":b[0][33],"patterns":b[1][206],"symbols":b[1][211],"currencies":b[0][852]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][862]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][863]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][864]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][865]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][866]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][867]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][868]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][869]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][870]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][871]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][872]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][873]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][874]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][875]},{"months":b[1][367],"days":b[1][368],"eras":b[1][3],"dayPeriods":b[0][883]},{"months":b[1][4],"days":b[1][368],"dayPeriods":b[0][883]},{"months":b[1][5],"days":b[1][368],"eras":b[1][6],"dayPeriods":b[0][883]},{"months":b[1][7],"days":b[1][368],"eras":b[1][6],"dayPeriods":b[0][883]},{"months":b[1][7],"days":b[1][368],"eras":b[1][8],"dayPeriods":b[0][883]},{"months":b[1][4],"days":b[1][368],"eras":b[1][6],"dayPeriods":b[0][883]},{"months":b[1][367],"days":b[1][368],"eras":b[1][369],"dayPeriods":b[0][883]},{"months":b[1][10],"days":b[1][368],"eras":b[1][11],"dayPeriods":b[0][883]},{"months":b[1][12],"days":b[1][368],"eras":b[1][13],"dayPeriods":b[0][883]},{"months":b[1][14],"days":b[1][368],"eras":b[1][15],"dayPeriods":b[0][883]},{"months":b[1][367],"days":b[1][368],"eras":b[1][16],"dayPeriods":b[0][883]},{"months":b[1][17],"days":b[1][368],"eras":b[1][18],"dayPeriods":b[0][883]},{"months":b[1][367],"days":b[1][368],"eras":b[1][19],"dayPeriods":b[0][883]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][87],"currencies":b[0][72]},{"months":b[1][371],"days":b[1][372],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][372],"dayPeriods":b[0][175]},{"months":b[1][373],"days":b[1][372],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][374],"days":b[1][372],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][374],"days":b[1][372],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][372],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][371],"days":b[1][372],"eras":b[1][375],"dayPeriods":b[0][175]},{"months":b[1][376],"days":b[1][372],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][377],"days":b[1][372],"eras":b[1][254],"dayPeriods":b[0][175]},{"months":b[1][378],"days":b[1][372],"eras":b[1][379],"dayPeriods":b[0][175]},{"months":b[1][371],"days":b[1][372],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][372],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][371],"days":b[1][372],"eras":b[1][195],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][380],"symbols":b[1][87],"currencies":b[0][903]},{"months":b[1][382],"days":b[1][383],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][383],"dayPeriods":b[0][583]},{"months":b[1][5],"days":b[1][383],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][383],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][383],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][383],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][382],"days":b[1][383],"eras":b[1][384],"dayPeriods":b[0][583]},{"months":b[1][10],"days":b[1][383],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][383],"eras":b[1][13],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][383],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][382],"days":b[1][383],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][383],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][382],"days":b[1][383],"eras":b[1][19],"dayPeriods":b[0][583]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][177]},{"months":b[1][386],"days":b[1][387],"eras":b[1][3],"dayPeriods":b[0][921]},{"months":b[1][4],"days":b[1][387],"dayPeriods":b[0][921]},{"months":b[1][5],"days":b[1][387],"eras":b[1][6],"dayPeriods":b[0][921]},{"months":b[1][7],"days":b[1][387],"eras":b[1][6],"dayPeriods":b[0][921]},{"months":b[1][7],"days":b[1][387],"eras":b[1][8],"dayPeriods":b[0][921]},{"months":b[1][4],"days":b[1][387],"eras":b[1][6],"dayPeriods":b[0][921]},{"months":b[1][386],"days":b[1][387],"eras":b[1][388],"dayPeriods":b[0][921]},{"months":b[1][10],"days":b[1][387],"eras":b[1][11],"dayPeriods":b[0][921]},{"months":b[1][12],"days":b[1][387],"eras":b[1][13],"dayPeriods":b[0][921]},{"months":b[1][14],"days":b[1][387],"eras":b[1][15],"dayPeriods":b[0][921]},{"months":b[1][386],"days":b[1][387],"eras":b[1][16],"dayPeriods":b[0][921]},{"months":b[1][17],"days":b[1][387],"eras":b[1][18],"dayPeriods":b[0][921]},{"months":b[1][386],"days":b[1][387],"eras":b[1][19],"dayPeriods":b[0][921]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][925]},{"months":b[1][390],"days":b[1][391],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][391],"dayPeriods":b[0][583]},{"months":b[1][5],"days":b[1][391],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][391],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][391],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][391],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][390],"days":b[1][391],"eras":b[1][392],"dayPeriods":b[0][583]},{"months":b[1][10],"days":b[1][391],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][391],"eras":b[1][13],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][391],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][390],"days":b[1][391],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][391],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][390],"days":b[1][391],"eras":b[1][19],"dayPeriods":b[0][583]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][87],"currencies":b[0][935]},{"months":b[1][394],"days":b[1][395],"eras":b[1][3],"dayPeriods":b[0][941]},{"months":b[1][4],"days":b[1][395],"dayPeriods":b[0][941]},{"months":b[1][5],"days":b[1][395],"eras":b[1][6],"dayPeriods":b[0][941]},{"months":b[1][7],"days":b[1][395],"eras":b[1][6],"dayPeriods":b[0][941]},{"months":b[1][7],"days":b[1][395],"eras":b[1][8],"dayPeriods":b[0][941]},{"months":b[1][4],"days":b[1][395],"eras":b[1][6],"dayPeriods":b[0][941]},{"months":b[1][394],"days":b[1][395],"eras":b[1][396],"dayPeriods":b[0][941]},{"months":b[1][10],"days":b[1][395],"eras":b[1][11],"dayPeriods":b[0][941]},{"months":b[1][12],"days":b[1][395],"eras":b[1][13],"dayPeriods":b[0][941]},{"months":b[1][14],"days":b[1][395],"eras":b[1][15],"dayPeriods":b[0][941]},{"months":b[1][394],"days":b[1][395],"eras":b[1][16],"dayPeriods":b[0][941]},{"months":b[1][17],"days":b[1][395],"eras":b[1][18],"dayPeriods":b[0][941]},{"months":b[1][394],"days":b[1][395],"eras":b[1][19],"dayPeriods":b[0][941]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][397],"currencies":b[0][946]},{"months":b[1][399],"days":b[1][400],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][400],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][400],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][400],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][400],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][400],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][399],"days":b[1][400],"eras":b[1][401],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][400],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][400],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][400],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][399],"days":b[1][400],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][400],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][399],"days":b[1][400],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][402],"symbols":b[1][403],"currencies":b[0][192]},{"months":b[1][405],"days":b[1][406],"eras":b[1][3],"dayPeriods":b[0][965]},{"months":b[1][4],"days":b[1][406],"dayPeriods":b[0][965]},{"months":b[1][5],"days":b[1][406],"eras":b[1][6],"dayPeriods":b[0][965]},{"months":b[1][7],"days":b[1][406],"eras":b[1][6],"dayPeriods":b[0][965]},{"months":b[1][7],"days":b[1][406],"eras":b[1][8],"dayPeriods":b[0][965]},{"months":b[1][4],"days":b[1][406],"eras":b[1][6],"dayPeriods":b[0][965]},{"months":b[1][405],"days":b[1][406],"eras":b[1][407],"dayPeriods":b[0][965]},{"months":b[1][10],"days":b[1][406],"eras":b[1][11],"dayPeriods":b[0][965]},{"months":b[1][12],"days":b[1][406],"eras":b[1][13],"dayPeriods":b[0][965]},{"months":b[1][14],"days":b[1][406],"eras":b[1][15],"dayPeriods":b[0][965]},{"months":b[1][405],"days":b[1][406],"eras":b[1][16],"dayPeriods":b[0][965]},{"months":b[1][17],"days":b[1][406],"eras":b[1][18],"dayPeriods":b[0][965]},{"months":b[1][405],"days":b[1][406],"eras":b[1][19],"dayPeriods":b[0][965]},{"months":b[1][409],"days":b[1][410],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][410],"dayPeriods":b[0][583]},{"months":b[1][5],"days":b[1][410],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][410],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][410],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][410],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][409],"days":b[1][410],"eras":b[1][411],"dayPeriods":b[0][583]},{"months":b[1][10],"days":b[1][410],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][410],"eras":b[1][13],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][410],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][409],"days":b[1][410],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][410],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][409],"days":b[1][410],"eras":b[1][19],"dayPeriods":b[0][583]},{"months":b[1][413],"days":b[1][414],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][414],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][414],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][414],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][414],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][414],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][413],"days":b[1][414],"eras":b[1][415],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][414],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][414],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][414],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][413],"days":b[1][414],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][414],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][413],"days":b[1][414],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][21],"currencies":b[0][982]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][21],"currencies":b[0][983]},{"medium":a[15],"availableFormats":b[0][984],"dateFormats":b[1][416],"timeFormats":b[0][3]},{"months":b[1][417],"days":b[1][418],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][418],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][418],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][418],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][418],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][418],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][417],"days":b[1][418],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][418],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][418],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][418],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][417],"days":b[1][418],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][418],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][417],"days":b[1][418],"eras":b[1][19],"dayPeriods":b[0][175]},{"months":b[1][420],"days":b[1][421],"eras":b[1][3],"dayPeriods":b[0][997]},{"months":b[1][4],"days":b[1][421],"dayPeriods":b[0][997]},{"months":b[1][5],"days":b[1][421],"eras":b[1][6],"dayPeriods":b[0][997]},{"months":b[1][7],"days":b[1][421],"eras":b[1][6],"dayPeriods":b[0][997]},{"months":b[1][7],"days":b[1][421],"eras":b[1][8],"dayPeriods":b[0][997]},{"months":b[1][4],"days":b[1][421],"eras":b[1][6],"dayPeriods":b[0][997]},{"months":b[1][420],"days":b[1][421],"eras":b[1][422],"dayPeriods":b[0][997]},{"months":b[1][423],"days":b[1][421],"eras":b[1][424],"dayPeriods":b[0][997]},{"months":b[1][12],"days":b[1][421],"eras":b[1][13],"dayPeriods":b[0][997]},{"months":b[1][425],"days":b[1][421],"eras":b[1][426],"dayPeriods":b[0][997]},{"months":b[1][420],"days":b[1][421],"eras":b[1][427],"dayPeriods":b[0][997]},{"months":b[1][17],"days":b[1][421],"eras":b[1][18],"dayPeriods":b[0][997]},{"months":b[1][420],"days":b[1][421],"eras":b[1][19],"dayPeriods":b[0][997]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][21],"currencies":b[0][1007]},{"months":b[1][429],"days":b[1][430],"eras":b[1][3],"dayPeriods":b[0][1016]},{"months":b[1][4],"days":b[1][430],"dayPeriods":b[0][1016]},{"months":b[1][5],"days":b[1][430],"eras":b[1][6],"dayPeriods":b[0][1016]},{"months":b[1][431],"days":b[1][430],"eras":b[1][6],"dayPeriods":b[0][1016]},{"months":b[1][431],"days":b[1][430],"eras":b[1][8],"dayPeriods":b[0][1016]},{"months":b[1][4],"days":b[1][430],"eras":b[1][6],"dayPeriods":b[0][1016]},{"months":b[1][429],"days":b[1][430],"eras":b[1][432],"dayPeriods":b[0][1016]},{"months":b[1][10],"days":b[1][430],"eras":b[1][11],"dayPeriods":b[0][1016]},{"months":b[1][433],"days":b[1][430],"eras":b[1][434],"dayPeriods":b[0][1016]},{"months":b[1][435],"days":b[1][430],"eras":b[1][15],"dayPeriods":b[0][1016]},{"months":b[1][429],"days":b[1][430],"eras":b[1][436],"dayPeriods":b[0][1016]},{"months":b[1][437],"days":b[1][430],"eras":b[1][18],"dayPeriods":b[0][1016]},{"months":b[1][429],"days":b[1][430],"eras":b[1][19],"dayPeriods":b[0][1016]},{"nu":b[0][33],"patterns":b[1][402],"symbols":b[1][146],"currencies":b[0][925]},{"months":b[1][439],"days":b[1][165],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][165],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][165],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][165],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][165],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][165],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][439],"days":b[1][165],"eras":b[1][440],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][165],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][165],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][165],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][439],"days":b[1][165],"eras":b[1][441],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][165],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][439],"days":b[1][165],"eras":b[1][168],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][1033]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][1034]},{"months":b[1][443],"days":b[1][444],"eras":b[1][3],"dayPeriods":b[0][1042]},{"months":b[1][4],"days":b[1][444],"dayPeriods":b[0][1042]},{"months":b[1][5],"days":b[1][444],"eras":b[1][6],"dayPeriods":b[0][1042]},{"months":b[1][7],"days":b[1][444],"eras":b[1][6],"dayPeriods":b[0][1042]},{"months":b[1][7],"days":b[1][444],"eras":b[1][8],"dayPeriods":b[0][1042]},{"months":b[1][4],"days":b[1][444],"eras":b[1][6],"dayPeriods":b[0][1042]},{"months":b[1][443],"days":b[1][444],"eras":b[1][445],"dayPeriods":b[0][1042]},{"months":b[1][10],"days":b[1][444],"eras":b[1][11],"dayPeriods":b[0][1042]},{"months":b[1][12],"days":b[1][444],"eras":b[1][13],"dayPeriods":b[0][1042]},{"months":b[1][14],"days":b[1][444],"eras":b[1][15],"dayPeriods":b[0][1042]},{"months":b[1][443],"days":b[1][444],"eras":b[1][16],"dayPeriods":b[0][1042]},{"months":b[1][17],"days":b[1][444],"eras":b[1][18],"dayPeriods":b[0][1042]},{"months":b[1][443],"days":b[1][444],"eras":b[1][19],"dayPeriods":b[0][1042]},{"months":b[1][447],"days":b[1][448],"eras":b[1][449],"dayPeriods":b[0][1054]},{"months":b[1][450],"days":b[1][448],"dayPeriods":b[0][1054]},{"months":b[1][5],"days":b[1][448],"eras":b[1][6],"dayPeriods":b[0][1054]},{"months":b[1][7],"days":b[1][448],"eras":b[1][6],"dayPeriods":b[0][1054]},{"months":b[1][7],"days":b[1][448],"eras":b[1][8],"dayPeriods":b[0][1054]},{"months":b[1][4],"days":b[1][448],"eras":b[1][6],"dayPeriods":b[0][1054]},{"months":b[1][447],"days":b[1][448],"eras":b[1][451],"dayPeriods":b[0][1054]},{"months":b[1][452],"days":b[1][448],"eras":b[1][453],"dayPeriods":b[0][1054]},{"months":b[1][12],"days":b[1][448],"eras":b[1][13],"dayPeriods":b[0][1054]},{"months":b[1][454],"days":b[1][448],"eras":b[1][455],"dayPeriods":b[0][1054]},{"months":b[1][447],"days":b[1][448],"eras":b[1][16],"dayPeriods":b[0][1054]},{"months":b[1][17],"days":b[1][448],"eras":b[1][18],"dayPeriods":b[0][1054]},{"months":b[1][447],"days":b[1][448],"eras":b[1][456],"dayPeriods":b[0][1054]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][1064]},{"months":b[1][458],"days":b[1][459],"eras":b[1][3],"dayPeriods":b[0][1074]},{"months":b[1][4],"days":b[1][459],"dayPeriods":b[0][1074]},{"months":b[1][5],"days":b[1][459],"eras":b[1][6],"dayPeriods":b[0][1074]},{"months":b[1][7],"days":b[1][459],"eras":b[1][6],"dayPeriods":b[0][1074]},{"months":b[1][7],"days":b[1][459],"eras":b[1][8],"dayPeriods":b[0][1074]},{"months":b[1][4],"days":b[1][459],"eras":b[1][6],"dayPeriods":b[0][1074]},{"months":b[1][458],"days":b[1][459],"eras":b[1][460],"dayPeriods":b[0][1074]},{"months":b[1][10],"days":b[1][459],"eras":b[1][11],"dayPeriods":b[0][1074]},{"months":b[1][12],"days":b[1][459],"eras":b[1][13],"dayPeriods":b[0][1074]},{"months":b[1][14],"days":b[1][459],"eras":b[1][15],"dayPeriods":b[0][1074]},{"months":b[1][458],"days":b[1][459],"eras":b[1][16],"dayPeriods":b[0][1074]},{"months":b[1][17],"days":b[1][459],"eras":b[1][18],"dayPeriods":b[0][1074]},{"months":b[1][458],"days":b[1][459],"eras":b[1][19],"dayPeriods":b[0][1074]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][1077]},{"months":b[1][462],"days":b[1][463],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][463],"dayPeriods":b[0][583]},{"months":b[1][5],"days":b[1][463],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][463],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][463],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][463],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][462],"days":b[1][463],"eras":b[1][464],"dayPeriods":b[0][583]},{"months":b[1][10],"days":b[1][463],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][463],"eras":b[1][13],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][463],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][462],"days":b[1][463],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][463],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][462],"days":b[1][463],"eras":b[1][19],"dayPeriods":b[0][583]},{"months":b[1][466],"days":b[1][467],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][173],"days":b[1][467],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][467],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][467],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][467],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][467],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][466],"days":b[1][467],"eras":b[1][468],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][467],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][467],"eras":b[1][254],"dayPeriods":b[0][175]},{"months":b[1][469],"days":b[1][467],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][466],"days":b[1][467],"eras":b[1][470],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][467],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][466],"days":b[1][467],"eras":b[1][471],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][87],"currencies":b[0][1097]},{"months":b[1][472],"days":b[1][473],"eras":b[1][3],"dayPeriods":b[0][1102]},{"months":b[1][4],"days":b[1][473],"dayPeriods":b[0][1102]},{"months":b[1][5],"days":b[1][473],"eras":b[1][6],"dayPeriods":b[0][1102]},{"months":b[1][7],"days":b[1][473],"eras":b[1][6],"dayPeriods":b[0][1102]},{"months":b[1][7],"days":b[1][473],"eras":b[1][8],"dayPeriods":b[0][1102]},{"months":b[1][4],"days":b[1][473],"eras":b[1][6],"dayPeriods":b[0][1102]},{"months":b[1][472],"days":b[1][473],"eras":b[1][474],"dayPeriods":b[0][1102]},{"months":b[1][10],"days":b[1][473],"eras":b[1][11],"dayPeriods":b[0][1102]},{"months":b[1][12],"days":b[1][473],"eras":b[1][13],"dayPeriods":b[0][1102]},{"months":b[1][14],"days":b[1][473],"eras":b[1][15],"dayPeriods":b[0][1102]},{"months":b[1][472],"days":b[1][473],"eras":b[1][16],"dayPeriods":b[0][1102]},{"months":b[1][17],"days":b[1][473],"eras":b[1][18],"dayPeriods":b[0][1102]},{"months":b[1][472],"days":b[1][473],"eras":b[1][19],"dayPeriods":b[0][1102]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][983]},{"months":b[1][475],"days":b[1][476],"eras":b[1][3],"dayPeriods":b[0][1109]},{"months":b[1][4],"days":b[1][476],"dayPeriods":b[0][1109]},{"months":b[1][5],"days":b[1][476],"eras":b[1][6],"dayPeriods":b[0][1109]},{"months":b[1][7],"days":b[1][476],"eras":b[1][6],"dayPeriods":b[0][1109]},{"months":b[1][7],"days":b[1][476],"eras":b[1][8],"dayPeriods":b[0][1109]},{"months":b[1][4],"days":b[1][476],"eras":b[1][6],"dayPeriods":b[0][1109]},{"months":b[1][475],"days":b[1][476],"eras":b[1][477],"dayPeriods":b[0][1109]},{"months":b[1][10],"days":b[1][476],"eras":b[1][11],"dayPeriods":b[0][1109]},{"months":b[1][12],"days":b[1][476],"eras":b[1][13],"dayPeriods":b[0][1109]},{"months":b[1][14],"days":b[1][476],"eras":b[1][15],"dayPeriods":b[0][1109]},{"months":b[1][475],"days":b[1][476],"eras":b[1][16],"dayPeriods":b[0][1109]},{"months":b[1][17],"days":b[1][476],"eras":b[1][18],"dayPeriods":b[0][1109]},{"months":b[1][475],"days":b[1][476],"eras":b[1][19],"dayPeriods":b[0][1109]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][21],"currencies":b[0][286]},{"months":b[1][479],"days":b[1][480],"eras":b[1][3],"dayPeriods":b[0][1119]},{"months":b[1][4],"days":b[1][480],"dayPeriods":b[0][1119]},{"months":b[1][5],"days":b[1][480],"eras":b[1][6],"dayPeriods":b[0][1119]},{"months":b[1][7],"days":b[1][480],"eras":b[1][6],"dayPeriods":b[0][1119]},{"months":b[1][7],"days":b[1][480],"eras":b[1][8],"dayPeriods":b[0][1119]},{"months":b[1][4],"days":b[1][480],"eras":b[1][6],"dayPeriods":b[0][1119]},{"months":b[1][479],"days":b[1][480],"eras":b[1][481],"dayPeriods":b[0][1119]},{"months":b[1][10],"days":b[1][480],"eras":b[1][11],"dayPeriods":b[0][1119]},{"months":b[1][12],"days":b[1][480],"eras":b[1][13],"dayPeriods":b[0][1119]},{"months":b[1][14],"days":b[1][480],"eras":b[1][15],"dayPeriods":b[0][1119]},{"months":b[1][479],"days":b[1][480],"eras":b[1][16],"dayPeriods":b[0][1119]},{"months":b[1][17],"days":b[1][480],"eras":b[1][18],"dayPeriods":b[0][1119]},{"months":b[1][479],"days":b[1][480],"eras":b[1][19],"dayPeriods":b[0][1119]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][1122]},{"months":b[1][483],"days":b[1][484],"eras":b[1][485],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][484],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][484],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][484],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][484],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][484],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][483],"days":b[1][484],"eras":b[1][486],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][484],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][484],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][484],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][483],"days":b[1][484],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][484],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][483],"days":b[1][484],"eras":b[1][487],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][488],"symbols":b[1][207],"currencies":b[0][1134]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][1134]},{"months":b[1][491],"days":b[1][492],"eras":b[1][493],"dayPeriods":b[0][1144]},{"months":b[1][494],"days":b[1][492],"dayPeriods":b[0][1144]},{"months":b[1][495],"days":b[1][492],"eras":b[1][6],"dayPeriods":b[0][1144]},{"months":b[1][496],"days":b[1][492],"eras":b[1][6],"dayPeriods":b[0][1144]},{"months":b[1][496],"days":b[1][492],"eras":b[1][8],"dayPeriods":b[0][1144]},{"months":b[1][4],"days":b[1][492],"eras":b[1][6],"dayPeriods":b[0][1144]},{"months":b[1][491],"days":b[1][492],"eras":b[1][497],"dayPeriods":b[0][1144]},{"months":b[1][498],"days":b[1][492],"eras":b[1][11],"dayPeriods":b[0][1144]},{"months":b[1][499],"days":b[1][492],"eras":b[1][500],"dayPeriods":b[0][1144]},{"months":b[1][501],"days":b[1][492],"eras":b[1][15],"dayPeriods":b[0][1144]},{"months":b[1][491],"days":b[1][492],"eras":b[1][502],"dayPeriods":b[0][1144]},{"months":b[1][503],"days":b[1][492],"eras":b[1][18],"dayPeriods":b[0][1144]},{"months":b[1][491],"days":b[1][492],"eras":b[1][504],"dayPeriods":b[0][1144]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][1158]},{"months":b[1][506],"days":b[1][507],"eras":b[1][3],"dayPeriods":b[0][1164]},{"months":b[1][4],"days":b[1][507],"dayPeriods":b[0][1164]},{"months":b[1][5],"days":b[1][507],"eras":b[1][6],"dayPeriods":b[0][1164]},{"months":b[1][7],"days":b[1][507],"eras":b[1][6],"dayPeriods":b[0][1164]},{"months":b[1][7],"days":b[1][507],"eras":b[1][8],"dayPeriods":b[0][1164]},{"months":b[1][4],"days":b[1][507],"eras":b[1][6],"dayPeriods":b[0][1164]},{"months":b[1][506],"days":b[1][507],"eras":b[1][508],"dayPeriods":b[0][1164]},{"months":b[1][10],"days":b[1][507],"eras":b[1][11],"dayPeriods":b[0][1164]},{"months":b[1][12],"days":b[1][507],"eras":b[1][13],"dayPeriods":b[0][1164]},{"months":b[1][14],"days":b[1][507],"eras":b[1][15],"dayPeriods":b[0][1164]},{"months":b[1][506],"days":b[1][507],"eras":b[1][16],"dayPeriods":b[0][1164]},{"months":b[1][17],"days":b[1][507],"eras":b[1][18],"dayPeriods":b[0][1164]},{"months":b[1][506],"days":b[1][507],"eras":b[1][19],"dayPeriods":b[0][1164]},{"months":b[1][509],"days":b[1][510],"eras":b[1][3],"dayPeriods":b[0][1170]},{"months":b[1][4],"days":b[1][510],"dayPeriods":b[0][1170]},{"months":b[1][5],"days":b[1][510],"eras":b[1][6],"dayPeriods":b[0][1170]},{"months":b[1][7],"days":b[1][510],"eras":b[1][6],"dayPeriods":b[0][1170]},{"months":b[1][7],"days":b[1][510],"eras":b[1][8],"dayPeriods":b[0][1170]},{"months":b[1][4],"days":b[1][510],"eras":b[1][6],"dayPeriods":b[0][1170]},{"months":b[1][509],"days":b[1][510],"eras":b[1][511],"dayPeriods":b[0][1170]},{"months":b[1][10],"days":b[1][510],"eras":b[1][11],"dayPeriods":b[0][1170]},{"months":b[1][12],"days":b[1][510],"eras":b[1][13],"dayPeriods":b[0][1170]},{"months":b[1][14],"days":b[1][510],"eras":b[1][15],"dayPeriods":b[0][1170]},{"months":b[1][509],"days":b[1][510],"eras":b[1][16],"dayPeriods":b[0][1170]},{"months":b[1][17],"days":b[1][510],"eras":b[1][18],"dayPeriods":b[0][1170]},{"months":b[1][509],"days":b[1][510],"eras":b[1][19],"dayPeriods":b[0][1170]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][166]},{"months":b[1][513],"days":b[1][514],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][514],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][514],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][514],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][514],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][514],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][513],"days":b[1][514],"eras":b[1][515],"dayPeriods":b[0][175]},{"months":b[1][516],"days":b[1][514],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][514],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][517],"days":b[1][514],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][513],"days":b[1][514],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][518],"days":b[1][514],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][513],"days":b[1][514],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][519],"currencies":b[0][1187]},{"months":b[1][520],"days":b[1][521],"eras":b[1][3],"dayPeriods":b[0][1194]},{"months":b[1][4],"days":b[1][521],"dayPeriods":b[0][1194]},{"months":b[1][5],"days":b[1][521],"eras":b[1][6],"dayPeriods":b[0][1194]},{"months":b[1][7],"days":b[1][521],"eras":b[1][6],"dayPeriods":b[0][1194]},{"months":b[1][7],"days":b[1][521],"eras":b[1][8],"dayPeriods":b[0][1194]},{"months":b[1][4],"days":b[1][521],"eras":b[1][6],"dayPeriods":b[0][1194]},{"months":b[1][520],"days":b[1][521],"eras":b[1][522],"dayPeriods":b[0][1194]},{"months":b[1][10],"days":b[1][521],"eras":b[1][11],"dayPeriods":b[0][1194]},{"months":b[1][12],"days":b[1][521],"eras":b[1][13],"dayPeriods":b[0][1194]},{"months":b[1][14],"days":b[1][521],"eras":b[1][15],"dayPeriods":b[0][1194]},{"months":b[1][520],"days":b[1][521],"eras":b[1][16],"dayPeriods":b[0][1194]},{"months":b[1][17],"days":b[1][521],"eras":b[1][18],"dayPeriods":b[0][1194]},{"months":b[1][520],"days":b[1][521],"eras":b[1][19],"dayPeriods":b[0][1194]},{"nu":b[0][33],"patterns":b[1][34],"symbols":b[1][28],"currencies":b[0][1197]},{"months":b[1][523],"days":b[1][524],"eras":b[1][3],"dayPeriods":b[0][1204]},{"months":b[1][4],"days":b[1][524],"dayPeriods":b[0][1204]},{"months":b[1][5],"days":b[1][524],"eras":b[1][6],"dayPeriods":b[0][1204]},{"months":b[1][7],"days":b[1][524],"eras":b[1][6],"dayPeriods":b[0][1204]},{"months":b[1][7],"days":b[1][524],"eras":b[1][8],"dayPeriods":b[0][1204]},{"months":b[1][4],"days":b[1][524],"eras":b[1][6],"dayPeriods":b[0][1204]},{"months":b[1][523],"days":b[1][524],"eras":b[1][525],"dayPeriods":b[0][1204]},{"months":b[1][10],"days":b[1][524],"eras":b[1][11],"dayPeriods":b[0][1204]},{"months":b[1][12],"days":b[1][524],"eras":b[1][13],"dayPeriods":b[0][1204]},{"months":b[1][14],"days":b[1][524],"eras":b[1][15],"dayPeriods":b[0][1204]},{"months":b[1][523],"days":b[1][524],"eras":b[1][16],"dayPeriods":b[0][1204]},{"months":b[1][17],"days":b[1][524],"eras":b[1][18],"dayPeriods":b[0][1204]},{"months":b[1][523],"days":b[1][524],"eras":b[1][19],"dayPeriods":b[0][1204]},{"months":b[1][526],"days":b[1][527],"eras":b[1][3],"dayPeriods":b[0][1211]},{"months":b[1][4],"days":b[1][527],"dayPeriods":b[0][1211]},{"months":b[1][5],"days":b[1][527],"eras":b[1][6],"dayPeriods":b[0][1211]},{"months":b[1][7],"days":b[1][527],"eras":b[1][6],"dayPeriods":b[0][1211]},{"months":b[1][7],"days":b[1][527],"eras":b[1][8],"dayPeriods":b[0][1211]},{"months":b[1][4],"days":b[1][527],"eras":b[1][6],"dayPeriods":b[0][1211]},{"months":b[1][526],"days":b[1][527],"eras":b[1][528],"dayPeriods":b[0][1211]},{"months":b[1][10],"days":b[1][527],"eras":b[1][11],"dayPeriods":b[0][1211]},{"months":b[1][12],"days":b[1][527],"eras":b[1][13],"dayPeriods":b[0][1211]},{"months":b[1][14],"days":b[1][527],"eras":b[1][15],"dayPeriods":b[0][1211]},{"months":b[1][526],"days":b[1][527],"eras":b[1][16],"dayPeriods":b[0][1211]},{"months":b[1][17],"days":b[1][527],"eras":b[1][18],"dayPeriods":b[0][1211]},{"months":b[1][526],"days":b[1][527],"eras":b[1][19],"dayPeriods":b[0][1211]},{"months":b[1][530],"days":b[1][531],"eras":b[1][3],"dayPeriods":b[0][549]},{"months":b[1][4],"days":b[1][531],"dayPeriods":b[0][549]},{"months":b[1][5],"days":b[1][531],"eras":b[1][6],"dayPeriods":b[0][549]},{"months":b[1][7],"days":b[1][531],"eras":b[1][6],"dayPeriods":b[0][549]},{"months":b[1][7],"days":b[1][531],"eras":b[1][8],"dayPeriods":b[0][549]},{"months":b[1][4],"days":b[1][531],"eras":b[1][6],"dayPeriods":b[0][549]},{"months":b[1][530],"days":b[1][531],"eras":b[1][532],"dayPeriods":b[0][549]},{"months":b[1][10],"days":b[1][531],"eras":b[1][11],"dayPeriods":b[0][549]},{"months":b[1][12],"days":b[1][531],"eras":b[1][13],"dayPeriods":b[0][549]},{"months":b[1][14],"days":b[1][531],"eras":b[1][15],"dayPeriods":b[0][549]},{"months":b[1][530],"days":b[1][531],"eras":b[1][16],"dayPeriods":b[0][549]},{"months":b[1][17],"days":b[1][531],"eras":b[1][18],"dayPeriods":b[0][549]},{"months":b[1][530],"days":b[1][531],"eras":b[1][19],"dayPeriods":b[0][549]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][1223]},{"months":b[1][208],"days":b[1][533],"eras":b[1][3],"dayPeriods":b[0][1227]},{"months":b[1][4],"days":b[1][533],"dayPeriods":b[0][1227]},{"months":b[1][5],"days":b[1][533],"eras":b[1][6],"dayPeriods":b[0][1227]},{"months":b[1][7],"days":b[1][533],"eras":b[1][6],"dayPeriods":b[0][1227]},{"months":b[1][7],"days":b[1][533],"eras":b[1][8],"dayPeriods":b[0][1227]},{"months":b[1][4],"days":b[1][533],"eras":b[1][6],"dayPeriods":b[0][1227]},{"months":b[1][208],"days":b[1][533],"eras":b[1][534],"dayPeriods":b[0][1227]},{"months":b[1][10],"days":b[1][533],"eras":b[1][11],"dayPeriods":b[0][1227]},{"months":b[1][12],"days":b[1][533],"eras":b[1][13],"dayPeriods":b[0][1227]},{"months":b[1][14],"days":b[1][533],"eras":b[1][15],"dayPeriods":b[0][1227]},{"months":b[1][208],"days":b[1][533],"eras":b[1][16],"dayPeriods":b[0][1227]},{"months":b[1][17],"days":b[1][533],"eras":b[1][18],"dayPeriods":b[0][1227]},{"months":b[1][208],"days":b[1][533],"eras":b[1][19],"dayPeriods":b[0][1227]},{"months":b[1][535],"days":b[1][536],"eras":b[1][3],"dayPeriods":b[0][1235]},{"months":b[1][4],"days":b[1][536],"dayPeriods":b[0][1235]},{"months":b[1][5],"days":b[1][536],"eras":b[1][6],"dayPeriods":b[0][1235]},{"months":b[1][7],"days":b[1][536],"eras":b[1][6],"dayPeriods":b[0][1235]},{"months":b[1][7],"days":b[1][536],"eras":b[1][8],"dayPeriods":b[0][1235]},{"months":b[1][4],"days":b[1][536],"eras":b[1][6],"dayPeriods":b[0][1235]},{"months":b[1][535],"days":b[1][536],"eras":b[1][230],"dayPeriods":b[0][1235]},{"months":b[1][10],"days":b[1][536],"eras":b[1][11],"dayPeriods":b[0][1235]},{"months":b[1][12],"days":b[1][536],"eras":b[1][13],"dayPeriods":b[0][1235]},{"months":b[1][14],"days":b[1][536],"eras":b[1][15],"dayPeriods":b[0][1235]},{"months":b[1][535],"days":b[1][536],"eras":b[1][16],"dayPeriods":b[0][1235]},{"months":b[1][17],"days":b[1][536],"eras":b[1][18],"dayPeriods":b[0][1235]},{"months":b[1][535],"days":b[1][536],"eras":b[1][19],"dayPeriods":b[0][1235]},{"months":b[1][538],"days":b[1][539],"eras":b[1][3],"dayPeriods":b[0][1244]},{"months":b[1][4],"days":b[1][539],"dayPeriods":b[0][1244]},{"months":b[1][5],"days":b[1][539],"eras":b[1][6],"dayPeriods":b[0][1244]},{"months":b[1][7],"days":b[1][539],"eras":b[1][6],"dayPeriods":b[0][1244]},{"months":b[1][7],"days":b[1][539],"eras":b[1][8],"dayPeriods":b[0][1244]},{"months":b[1][4],"days":b[1][539],"eras":b[1][6],"dayPeriods":b[0][1244]},{"months":b[1][538],"days":b[1][539],"eras":b[1][540],"dayPeriods":b[0][1244]},{"months":b[1][10],"days":b[1][539],"eras":b[1][11],"dayPeriods":b[0][1244]},{"months":b[1][12],"days":b[1][539],"eras":b[1][13],"dayPeriods":b[0][1244]},{"months":b[1][14],"days":b[1][539],"eras":b[1][15],"dayPeriods":b[0][1244]},{"months":b[1][538],"days":b[1][539],"eras":b[1][16],"dayPeriods":b[0][1244]},{"months":b[1][17],"days":b[1][539],"eras":b[1][18],"dayPeriods":b[0][1244]},{"months":b[1][538],"days":b[1][539],"eras":b[1][19],"dayPeriods":b[0][1244]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][1247]},{"months":b[1][542],"days":b[1][543],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][543],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][543],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][543],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][543],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][543],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][542],"days":b[1][543],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][543],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][543],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][543],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][542],"days":b[1][543],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][543],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][542],"days":b[1][543],"eras":b[1][19],"dayPeriods":b[0][175]},{"months":b[1][545],"days":b[1][546],"eras":b[1][3],"dayPeriods":b[0][1259]},{"months":b[1][4],"days":b[1][546],"dayPeriods":b[0][1259]},{"months":b[1][5],"days":b[1][546],"eras":b[1][6],"dayPeriods":b[0][1259]},{"months":b[1][7],"days":b[1][546],"eras":b[1][6],"dayPeriods":b[0][1259]},{"months":b[1][7],"days":b[1][546],"eras":b[1][8],"dayPeriods":b[0][1259]},{"months":b[1][4],"days":b[1][546],"eras":b[1][6],"dayPeriods":b[0][1259]},{"months":b[1][545],"days":b[1][546],"eras":b[1][547],"dayPeriods":b[0][1259]},{"months":b[1][10],"days":b[1][546],"eras":b[1][11],"dayPeriods":b[0][1259]},{"months":b[1][12],"days":b[1][546],"eras":b[1][13],"dayPeriods":b[0][1259]},{"months":b[1][14],"days":b[1][546],"eras":b[1][15],"dayPeriods":b[0][1259]},{"months":b[1][545],"days":b[1][546],"eras":b[1][16],"dayPeriods":b[0][1259]},{"months":b[1][17],"days":b[1][546],"eras":b[1][18],"dayPeriods":b[0][1259]},{"months":b[1][545],"days":b[1][546],"eras":b[1][19],"dayPeriods":b[0][1259]},{"nu":b[0][33],"patterns":b[1][283],"symbols":b[1][346],"currencies":b[0][1263]},{"months":b[1][548],"days":b[1][549],"eras":b[1][3],"dayPeriods":b[0][1270]},{"months":b[1][4],"days":b[1][549],"dayPeriods":b[0][1270]},{"months":b[1][5],"days":b[1][549],"eras":b[1][6],"dayPeriods":b[0][1270]},{"months":b[1][7],"days":b[1][549],"eras":b[1][6],"dayPeriods":b[0][1270]},{"months":b[1][7],"days":b[1][549],"eras":b[1][8],"dayPeriods":b[0][1270]},{"months":b[1][4],"days":b[1][549],"eras":b[1][6],"dayPeriods":b[0][1270]},{"months":b[1][548],"days":b[1][549],"eras":b[1][550],"dayPeriods":b[0][1270]},{"months":b[1][10],"days":b[1][549],"eras":b[1][11],"dayPeriods":b[0][1270]},{"months":b[1][12],"days":b[1][549],"eras":b[1][13],"dayPeriods":b[0][1270]},{"months":b[1][14],"days":b[1][549],"eras":b[1][15],"dayPeriods":b[0][1270]},{"months":b[1][548],"days":b[1][549],"eras":b[1][16],"dayPeriods":b[0][1270]},{"months":b[1][17],"days":b[1][549],"eras":b[1][18],"dayPeriods":b[0][1270]},{"months":b[1][548],"days":b[1][549],"eras":b[1][19],"dayPeriods":b[0][1270]},{"months":b[1][552],"days":b[1][553],"eras":b[1][554],"dayPeriods":b[0][1279]},{"months":b[1][4],"days":b[1][553],"dayPeriods":b[0][1279]},{"months":b[1][5],"days":b[1][553],"eras":b[1][6],"dayPeriods":b[0][1279]},{"months":b[1][7],"days":b[1][553],"eras":b[1][6],"dayPeriods":b[0][1279]},{"months":b[1][7],"days":b[1][553],"eras":b[1][8],"dayPeriods":b[0][1279]},{"months":b[1][4],"days":b[1][553],"eras":b[1][6],"dayPeriods":b[0][1279]},{"months":b[1][552],"days":b[1][553],"eras":b[1][555],"dayPeriods":b[0][1279]},{"months":b[1][10],"days":b[1][553],"eras":b[1][11],"dayPeriods":b[0][1279]},{"months":b[1][12],"days":b[1][553],"eras":b[1][13],"dayPeriods":b[0][1279]},{"months":b[1][14],"days":b[1][553],"eras":b[1][15],"dayPeriods":b[0][1279]},{"months":b[1][552],"days":b[1][553],"eras":b[1][16],"dayPeriods":b[0][1279]},{"months":b[1][17],"days":b[1][553],"eras":b[1][18],"dayPeriods":b[0][1279]},{"months":b[1][552],"days":b[1][553],"eras":b[1][19],"dayPeriods":b[0][1279]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][556],"currencies":b[0][1282]},{"months":b[1][558],"days":b[1][559],"eras":b[1][3],"dayPeriods":b[0][1290]},{"months":b[1][4],"days":b[1][559],"dayPeriods":b[0][1290]},{"months":b[1][5],"days":b[1][559],"eras":b[1][6],"dayPeriods":b[0][1290]},{"months":b[1][7],"days":b[1][559],"eras":b[1][6],"dayPeriods":b[0][1290]},{"months":b[1][7],"days":b[1][559],"eras":b[1][8],"dayPeriods":b[0][1290]},{"months":b[1][4],"days":b[1][559],"eras":b[1][6],"dayPeriods":b[0][1290]},{"months":b[1][558],"days":b[1][559],"eras":b[1][560],"dayPeriods":b[0][1290]},{"months":b[1][10],"days":b[1][559],"eras":b[1][11],"dayPeriods":b[0][1290]},{"months":b[1][12],"days":b[1][559],"eras":b[1][13],"dayPeriods":b[0][1290]},{"months":b[1][14],"days":b[1][559],"eras":b[1][15],"dayPeriods":b[0][1290]},{"months":b[1][558],"days":b[1][559],"eras":b[1][16],"dayPeriods":b[0][1290]},{"months":b[1][17],"days":b[1][559],"eras":b[1][18],"dayPeriods":b[0][1290]},{"months":b[1][558],"days":b[1][559],"eras":b[1][19],"dayPeriods":b[0][1290]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][561],"currencies":b[0][925]},{"months":b[1][563],"days":b[1][564],"eras":b[1][565],"dayPeriods":b[0][1300]},{"months":b[1][566],"days":b[1][564],"dayPeriods":b[0][1300]},{"months":b[1][567],"days":b[1][564],"eras":b[1][6],"dayPeriods":b[0][1300]},{"months":b[1][568],"days":b[1][564],"eras":b[1][6],"dayPeriods":b[0][1300]},{"months":b[1][568],"days":b[1][564],"eras":b[1][8],"dayPeriods":b[0][1300]},{"months":b[1][4],"days":b[1][564],"eras":b[1][6],"dayPeriods":b[0][1300]},{"months":b[1][563],"days":b[1][564],"eras":b[1][569],"dayPeriods":b[0][1300]},{"months":b[1][570],"days":b[1][564],"eras":b[1][11],"dayPeriods":b[0][1300]},{"months":b[1][12],"days":b[1][564],"eras":b[1][13],"dayPeriods":b[0][1300]},{"months":b[1][14],"days":b[1][564],"eras":b[1][15],"dayPeriods":b[0][1300]},{"months":b[1][563],"days":b[1][564],"eras":b[1][571],"dayPeriods":b[0][1300]},{"months":b[1][17],"days":b[1][564],"eras":b[1][18],"dayPeriods":b[0][1300]},{"months":b[1][563],"days":b[1][564],"eras":b[1][572],"dayPeriods":b[0][1300]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][1307]},{"months":b[1][574],"days":b[1][575],"eras":b[1][3],"dayPeriods":b[0][1312]},{"months":b[1][4],"days":b[1][575],"dayPeriods":b[0][1312]},{"months":b[1][5],"days":b[1][575],"eras":b[1][6],"dayPeriods":b[0][1312]},{"months":b[1][7],"days":b[1][575],"eras":b[1][6],"dayPeriods":b[0][1312]},{"months":b[1][7],"days":b[1][575],"eras":b[1][8],"dayPeriods":b[0][1312]},{"months":b[1][4],"days":b[1][575],"eras":b[1][6],"dayPeriods":b[0][1312]},{"months":b[1][574],"days":b[1][575],"eras":b[1][576],"dayPeriods":b[0][1312]},{"months":b[1][10],"days":b[1][575],"eras":b[1][11],"dayPeriods":b[0][1312]},{"months":b[1][12],"days":b[1][575],"eras":b[1][13],"dayPeriods":b[0][1312]},{"months":b[1][14],"days":b[1][575],"eras":b[1][15],"dayPeriods":b[0][1312]},{"months":b[1][574],"days":b[1][575],"eras":b[1][16],"dayPeriods":b[0][1312]},{"months":b[1][17],"days":b[1][575],"eras":b[1][18],"dayPeriods":b[0][1312]},{"months":b[1][574],"days":b[1][575],"eras":b[1][19],"dayPeriods":b[0][1312]},{"months":b[1][578],"days":b[1][579],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][579],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][579],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][579],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][579],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][579],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][578],"days":b[1][579],"eras":b[1][580],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][579],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][581],"days":b[1][579],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][579],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][578],"days":b[1][579],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][579],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][578],"days":b[1][579],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][763],"patterns":b[1][76],"symbols":b[1][582],"currencies":b[0][72]},{"months":b[1][583],"days":b[1][584],"eras":b[1][3],"dayPeriods":b[0][1328]},{"months":b[1][4],"days":b[1][584],"dayPeriods":b[0][1328]},{"months":b[1][5],"days":b[1][584],"eras":b[1][6],"dayPeriods":b[0][1328]},{"months":b[1][7],"days":b[1][584],"eras":b[1][6],"dayPeriods":b[0][1328]},{"months":b[1][7],"days":b[1][584],"eras":b[1][8],"dayPeriods":b[0][1328]},{"months":b[1][4],"days":b[1][584],"eras":b[1][6],"dayPeriods":b[0][1328]},{"months":b[1][583],"days":b[1][584],"eras":b[1][585],"dayPeriods":b[0][1328]},{"months":b[1][10],"days":b[1][584],"eras":b[1][11],"dayPeriods":b[0][1328]},{"months":b[1][12],"days":b[1][584],"eras":b[1][13],"dayPeriods":b[0][1328]},{"months":b[1][14],"days":b[1][584],"eras":b[1][15],"dayPeriods":b[0][1328]},{"months":b[1][583],"days":b[1][584],"eras":b[1][16],"dayPeriods":b[0][1328]},{"months":b[1][17],"days":b[1][584],"eras":b[1][18],"dayPeriods":b[0][1328]},{"months":b[1][583],"days":b[1][584],"eras":b[1][19],"dayPeriods":b[0][1328]},{"months":b[1][586],"days":b[1][587],"eras":b[1][3],"dayPeriods":b[0][1335]},{"months":b[1][4],"days":b[1][587],"dayPeriods":b[0][1335]},{"months":b[1][5],"days":b[1][587],"eras":b[1][6],"dayPeriods":b[0][1335]},{"months":b[1][7],"days":b[1][587],"eras":b[1][6],"dayPeriods":b[0][1335]},{"months":b[1][7],"days":b[1][587],"eras":b[1][8],"dayPeriods":b[0][1335]},{"months":b[1][4],"days":b[1][587],"eras":b[1][6],"dayPeriods":b[0][1335]},{"months":b[1][586],"days":b[1][587],"eras":b[1][588],"dayPeriods":b[0][1335]},{"months":b[1][10],"days":b[1][587],"eras":b[1][11],"dayPeriods":b[0][1335]},{"months":b[1][12],"days":b[1][587],"eras":b[1][13],"dayPeriods":b[0][1335]},{"months":b[1][14],"days":b[1][587],"eras":b[1][15],"dayPeriods":b[0][1335]},{"months":b[1][586],"days":b[1][587],"eras":b[1][16],"dayPeriods":b[0][1335]},{"months":b[1][17],"days":b[1][587],"eras":b[1][18],"dayPeriods":b[0][1335]},{"months":b[1][586],"days":b[1][587],"eras":b[1][19],"dayPeriods":b[0][1335]},{"months":b[1][590],"days":b[1][591],"eras":b[1][3],"dayPeriods":b[0][1344]},{"months":b[1][4],"days":b[1][591],"dayPeriods":b[0][1344]},{"months":b[1][5],"days":b[1][591],"eras":b[1][6],"dayPeriods":b[0][1344]},{"months":b[1][7],"days":b[1][591],"eras":b[1][6],"dayPeriods":b[0][1344]},{"months":b[1][7],"days":b[1][591],"eras":b[1][8],"dayPeriods":b[0][1344]},{"months":b[1][4],"days":b[1][591],"eras":b[1][6],"dayPeriods":b[0][1344]},{"months":b[1][590],"days":b[1][591],"eras":b[1][592],"dayPeriods":b[0][1344]},{"months":b[1][10],"days":b[1][591],"eras":b[1][11],"dayPeriods":b[0][1344]},{"months":b[1][12],"days":b[1][591],"eras":b[1][13],"dayPeriods":b[0][1344]},{"months":b[1][14],"days":b[1][591],"eras":b[1][15],"dayPeriods":b[0][1344]},{"months":b[1][590],"days":b[1][591],"eras":b[1][16],"dayPeriods":b[0][1344]},{"months":b[1][17],"days":b[1][591],"eras":b[1][18],"dayPeriods":b[0][1344]},{"months":b[1][590],"days":b[1][591],"eras":b[1][19],"dayPeriods":b[0][1344]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][593],"currencies":b[0][72]},{"months":b[1][595],"days":b[1][596],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][596],"dayPeriods":b[0][583]},{"months":b[1][5],"days":b[1][596],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][596],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][596],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][596],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][595],"days":b[1][596],"eras":b[1][411],"dayPeriods":b[0][583]},{"months":b[1][10],"days":b[1][596],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][596],"eras":b[1][13],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][596],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][595],"days":b[1][596],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][596],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][595],"days":b[1][596],"eras":b[1][19],"dayPeriods":b[0][583]},{"months":b[1][598],"days":b[1][599],"eras":b[1][3],"dayPeriods":b[0][1360]},{"months":b[1][4],"days":b[1][599],"dayPeriods":b[0][1360]},{"months":b[1][5],"days":b[1][599],"eras":b[1][6],"dayPeriods":b[0][1360]},{"months":b[1][7],"days":b[1][599],"eras":b[1][6],"dayPeriods":b[0][1360]},{"months":b[1][7],"days":b[1][599],"eras":b[1][8],"dayPeriods":b[0][1360]},{"months":b[1][4],"days":b[1][599],"eras":b[1][6],"dayPeriods":b[0][1360]},{"months":b[1][598],"days":b[1][599],"eras":b[1][600],"dayPeriods":b[0][1360]},{"months":b[1][10],"days":b[1][599],"eras":b[1][11],"dayPeriods":b[0][1360]},{"months":b[1][12],"days":b[1][599],"eras":b[1][13],"dayPeriods":b[0][1360]},{"months":b[1][14],"days":b[1][599],"eras":b[1][15],"dayPeriods":b[0][1360]},{"months":b[1][598],"days":b[1][599],"eras":b[1][16],"dayPeriods":b[0][1360]},{"months":b[1][17],"days":b[1][599],"eras":b[1][18],"dayPeriods":b[0][1360]},{"months":b[1][598],"days":b[1][599],"eras":b[1][19],"dayPeriods":b[0][1360]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][601],"currencies":b[0][1365]},{"months":b[1][602],"days":b[1][603],"eras":b[1][3],"dayPeriods":b[0][1372]},{"months":b[1][4],"days":b[1][603],"dayPeriods":b[0][1372]},{"months":b[1][5],"days":b[1][603],"eras":b[1][6],"dayPeriods":b[0][1372]},{"months":b[1][7],"days":b[1][603],"eras":b[1][6],"dayPeriods":b[0][1372]},{"months":b[1][7],"days":b[1][603],"eras":b[1][8],"dayPeriods":b[0][1372]},{"months":b[1][4],"days":b[1][603],"eras":b[1][6],"dayPeriods":b[0][1372]},{"months":b[1][602],"days":b[1][603],"eras":b[1][604],"dayPeriods":b[0][1372]},{"months":b[1][10],"days":b[1][603],"eras":b[1][11],"dayPeriods":b[0][1372]},{"months":b[1][12],"days":b[1][603],"eras":b[1][13],"dayPeriods":b[0][1372]},{"months":b[1][14],"days":b[1][603],"eras":b[1][15],"dayPeriods":b[0][1372]},{"months":b[1][602],"days":b[1][603],"eras":b[1][16],"dayPeriods":b[0][1372]},{"months":b[1][17],"days":b[1][603],"eras":b[1][18],"dayPeriods":b[0][1372]},{"months":b[1][602],"days":b[1][603],"eras":b[1][19],"dayPeriods":b[0][1372]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][21],"currencies":b[0][166]},{"months":b[1][606],"days":b[1][607],"eras":b[1][3],"dayPeriods":b[0][1380]},{"months":b[1][4],"days":b[1][607],"dayPeriods":b[0][1380]},{"months":b[1][5],"days":b[1][607],"eras":b[1][6],"dayPeriods":b[0][1380]},{"months":b[1][7],"days":b[1][607],"eras":b[1][6],"dayPeriods":b[0][1380]},{"months":b[1][7],"days":b[1][607],"eras":b[1][8],"dayPeriods":b[0][1380]},{"months":b[1][4],"days":b[1][607],"eras":b[1][6],"dayPeriods":b[0][1380]},{"months":b[1][606],"days":b[1][607],"eras":b[1][608],"dayPeriods":b[0][1380]},{"months":b[1][10],"days":b[1][607],"eras":b[1][11],"dayPeriods":b[0][1380]},{"months":b[1][12],"days":b[1][607],"eras":b[1][13],"dayPeriods":b[0][1380]},{"months":b[1][14],"days":b[1][607],"eras":b[1][15],"dayPeriods":b[0][1380]},{"months":b[1][606],"days":b[1][607],"eras":b[1][16],"dayPeriods":b[0][1380]},{"months":b[1][17],"days":b[1][607],"eras":b[1][18],"dayPeriods":b[0][1380]},{"months":b[1][606],"days":b[1][607],"eras":b[1][195],"dayPeriods":b[0][1380]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][1382]},{"months":b[1][609],"days":b[1][610],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][610],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][610],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][610],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][610],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][610],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][609],"days":b[1][610],"eras":b[1][611],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][610],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][610],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][610],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][609],"days":b[1][610],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][610],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][609],"days":b[1][610],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][34],"symbols":b[1][21],"currencies":b[0][368]},{"months":b[1][613],"days":b[1][614],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][614],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][614],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][614],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][614],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][614],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][613],"days":b[1][614],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][614],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][614],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][614],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][613],"days":b[1][614],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][614],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][613],"days":b[1][614],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][21],"currencies":b[0][379]},{"months":b[1][615],"days":b[1][616],"eras":b[1][3],"dayPeriods":b[0][1398]},{"months":b[1][4],"days":b[1][616],"dayPeriods":b[0][1398]},{"months":b[1][5],"days":b[1][616],"eras":b[1][6],"dayPeriods":b[0][1398]},{"months":b[1][7],"days":b[1][616],"eras":b[1][6],"dayPeriods":b[0][1398]},{"months":b[1][7],"days":b[1][616],"eras":b[1][8],"dayPeriods":b[0][1398]},{"months":b[1][4],"days":b[1][616],"eras":b[1][6],"dayPeriods":b[0][1398]},{"months":b[1][615],"days":b[1][616],"eras":b[1][617],"dayPeriods":b[0][1398]},{"months":b[1][10],"days":b[1][616],"eras":b[1][11],"dayPeriods":b[0][1398]},{"months":b[1][12],"days":b[1][616],"eras":b[1][13],"dayPeriods":b[0][1398]},{"months":b[1][14],"days":b[1][616],"eras":b[1][15],"dayPeriods":b[0][1398]},{"months":b[1][615],"days":b[1][616],"eras":b[1][16],"dayPeriods":b[0][1398]},{"months":b[1][17],"days":b[1][616],"eras":b[1][18],"dayPeriods":b[0][1398]},{"months":b[1][615],"days":b[1][616],"eras":b[1][19],"dayPeriods":b[0][1398]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][1401]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][1402]},{"months":b[1][619],"days":b[1][620],"eras":b[1][621],"dayPeriods":b[0][1410]},{"months":b[1][173],"days":b[1][620],"dayPeriods":b[0][1410]},{"months":b[1][622],"days":b[1][620],"eras":b[1][6],"dayPeriods":b[0][1410]},{"months":b[1][623],"days":b[1][620],"eras":b[1][6],"dayPeriods":b[0][1410]},{"months":b[1][623],"days":b[1][620],"eras":b[1][8],"dayPeriods":b[0][1410]},{"months":b[1][4],"days":b[1][620],"eras":b[1][6],"dayPeriods":b[0][1410]},{"months":b[1][619],"days":b[1][620],"eras":b[1][624],"dayPeriods":b[0][1410]},{"months":b[1][625],"days":b[1][620],"eras":b[1][11],"dayPeriods":b[0][1410]},{"months":b[1][626],"days":b[1][620],"eras":b[1][627],"dayPeriods":b[0][1410]},{"months":b[1][628],"days":b[1][620],"eras":b[1][15],"dayPeriods":b[0][1410]},{"months":b[1][619],"days":b[1][620],"eras":b[1][629],"dayPeriods":b[0][1410]},{"months":b[1][630],"days":b[1][620],"eras":b[1][631],"dayPeriods":b[0][1410]},{"months":b[1][619],"days":b[1][620],"eras":b[1][632],"dayPeriods":b[0][1410]},{"nu":b[0][33],"patterns":b[1][633],"symbols":b[1][634],"currencies":b[0][1429]},{"months":b[1][636],"days":b[1][637],"eras":b[1][3],"dayPeriods":b[0][1438]},{"months":b[1][173],"days":b[1][637],"dayPeriods":b[0][1438]},{"months":b[1][5],"days":b[1][637],"eras":b[1][6],"dayPeriods":b[0][1438]},{"months":b[1][7],"days":b[1][637],"eras":b[1][6],"dayPeriods":b[0][1438]},{"months":b[1][7],"days":b[1][637],"eras":b[1][8],"dayPeriods":b[0][1438]},{"months":b[1][4],"days":b[1][637],"eras":b[1][6],"dayPeriods":b[0][1438]},{"months":b[1][636],"days":b[1][637],"eras":b[1][638],"dayPeriods":b[0][1438]},{"months":b[1][10],"days":b[1][637],"eras":b[1][11],"dayPeriods":b[0][1438]},{"months":b[1][12],"days":b[1][637],"eras":b[1][13],"dayPeriods":b[0][1438]},{"months":b[1][14],"days":b[1][637],"eras":b[1][15],"dayPeriods":b[0][1438]},{"months":b[1][636],"days":b[1][637],"eras":b[1][639],"dayPeriods":b[0][1438]},{"months":b[1][17],"days":b[1][637],"eras":b[1][18],"dayPeriods":b[0][1438]},{"months":b[1][636],"days":b[1][637],"eras":b[1][640],"dayPeriods":b[0][1438]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][1444]},{"months":b[1][641],"days":b[1][642],"eras":b[1][3],"dayPeriods":b[0][1451]},{"months":b[1][4],"days":b[1][642],"dayPeriods":b[0][1451]},{"months":b[1][5],"days":b[1][642],"eras":b[1][6],"dayPeriods":b[0][1451]},{"months":b[1][7],"days":b[1][642],"eras":b[1][6],"dayPeriods":b[0][1451]},{"months":b[1][7],"days":b[1][642],"eras":b[1][8],"dayPeriods":b[0][1451]},{"months":b[1][4],"days":b[1][642],"eras":b[1][6],"dayPeriods":b[0][1451]},{"months":b[1][641],"days":b[1][642],"eras":b[1][643],"dayPeriods":b[0][1451]},{"months":b[1][10],"days":b[1][642],"eras":b[1][11],"dayPeriods":b[0][1451]},{"months":b[1][12],"days":b[1][642],"eras":b[1][13],"dayPeriods":b[0][1451]},{"months":b[1][14],"days":b[1][642],"eras":b[1][15],"dayPeriods":b[0][1451]},{"months":b[1][641],"days":b[1][642],"eras":b[1][16],"dayPeriods":b[0][1451]},{"months":b[1][17],"days":b[1][642],"eras":b[1][18],"dayPeriods":b[0][1451]},{"months":b[1][641],"days":b[1][642],"eras":b[1][19],"dayPeriods":b[0][1451]},{"nu":b[0][33],"patterns":b[1][34],"symbols":b[1][87],"currencies":b[0][1402]},{"months":b[1][644],"days":b[1][645],"eras":b[1][3],"dayPeriods":b[0][1460]},{"months":b[1][4],"days":b[1][645],"dayPeriods":b[0][1460]},{"months":b[1][5],"days":b[1][645],"eras":b[1][6],"dayPeriods":b[0][1460]},{"months":b[1][7],"days":b[1][645],"eras":b[1][6],"dayPeriods":b[0][1460]},{"months":b[1][7],"days":b[1][645],"eras":b[1][8],"dayPeriods":b[0][1460]},{"months":b[1][4],"days":b[1][645],"eras":b[1][6],"dayPeriods":b[0][1460]},{"months":b[1][644],"days":b[1][645],"eras":b[1][646],"dayPeriods":b[0][1460]},{"months":b[1][10],"days":b[1][645],"eras":b[1][11],"dayPeriods":b[0][1460]},{"months":b[1][12],"days":b[1][645],"eras":b[1][13],"dayPeriods":b[0][1460]},{"months":b[1][14],"days":b[1][645],"eras":b[1][15],"dayPeriods":b[0][1460]},{"months":b[1][644],"days":b[1][645],"eras":b[1][16],"dayPeriods":b[0][1460]},{"months":b[1][17],"days":b[1][645],"eras":b[1][18],"dayPeriods":b[0][1460]},{"months":b[1][644],"days":b[1][645],"eras":b[1][19],"dayPeriods":b[0][1460]},{"nu":b[0][33],"patterns":b[1][34],"symbols":b[1][21],"currencies":b[0][423]},{"months":b[1][647],"days":b[1][648],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][648],"dayPeriods":b[0][583]},{"months":b[1][5],"days":b[1][648],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][648],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][648],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][648],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][647],"days":b[1][648],"eras":b[1][649],"dayPeriods":b[0][583]},{"months":b[1][10],"days":b[1][648],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][648],"eras":b[1][13],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][648],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][647],"days":b[1][648],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][648],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][647],"days":b[1][648],"eras":b[1][19],"dayPeriods":b[0][583]},{"nu":b[0][33],"patterns":b[1][650],"symbols":b[1][21],"currencies":b[0][423]},{"months":b[1][652],"days":b[1][653],"eras":b[1][3],"dayPeriods":b[0][1474]},{"months":b[1][4],"days":b[1][653],"dayPeriods":b[0][1474]},{"months":b[1][5],"days":b[1][653],"eras":b[1][6],"dayPeriods":b[0][1474]},{"months":b[1][7],"days":b[1][653],"eras":b[1][6],"dayPeriods":b[0][1474]},{"months":b[1][7],"days":b[1][653],"eras":b[1][8],"dayPeriods":b[0][1474]},{"months":b[1][4],"days":b[1][653],"eras":b[1][6],"dayPeriods":b[0][1474]},{"months":b[1][652],"days":b[1][653],"eras":b[1][654],"dayPeriods":b[0][1474]},{"months":b[1][655],"days":b[1][653],"eras":b[1][11],"dayPeriods":b[0][1474]},{"months":b[1][12],"days":b[1][653],"eras":b[1][13],"dayPeriods":b[0][1474]},{"months":b[1][656],"days":b[1][653],"eras":b[1][15],"dayPeriods":b[0][1474]},{"months":b[1][652],"days":b[1][653],"eras":b[1][16],"dayPeriods":b[0][1474]},{"months":b[1][17],"days":b[1][653],"eras":b[1][18],"dayPeriods":b[0][1474]},{"months":b[1][652],"days":b[1][653],"eras":b[1][19],"dayPeriods":b[0][1474]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][657],"currencies":b[0][1481]},{"months":b[1][658],"days":b[1][659],"eras":b[1][3],"dayPeriods":b[0][1485]},{"months":b[1][4],"days":b[1][659],"dayPeriods":b[0][1485]},{"months":b[1][5],"days":b[1][659],"eras":b[1][6],"dayPeriods":b[0][1485]},{"months":b[1][7],"days":b[1][659],"eras":b[1][6],"dayPeriods":b[0][1485]},{"months":b[1][7],"days":b[1][659],"eras":b[1][8],"dayPeriods":b[0][1485]},{"months":b[1][4],"days":b[1][659],"eras":b[1][6],"dayPeriods":b[0][1485]},{"months":b[1][658],"days":b[1][659],"eras":b[1][660],"dayPeriods":b[0][1485]},{"months":b[1][10],"days":b[1][659],"eras":b[1][11],"dayPeriods":b[0][1485]},{"months":b[1][12],"days":b[1][659],"eras":b[1][13],"dayPeriods":b[0][1485]},{"months":b[1][14],"days":b[1][659],"eras":b[1][15],"dayPeriods":b[0][1485]},{"months":b[1][658],"days":b[1][659],"eras":b[1][16],"dayPeriods":b[0][1485]},{"months":b[1][17],"days":b[1][659],"eras":b[1][18],"dayPeriods":b[0][1485]},{"months":b[1][658],"days":b[1][659],"eras":b[1][19],"dayPeriods":b[0][1485]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][1488]},{"months":b[1][661],"days":b[1][662],"eras":b[1][3],"dayPeriods":b[0][1495]},{"months":b[1][4],"days":b[1][662],"dayPeriods":b[0][1495]},{"months":b[1][5],"days":b[1][662],"eras":b[1][6],"dayPeriods":b[0][1495]},{"months":b[1][7],"days":b[1][662],"eras":b[1][6],"dayPeriods":b[0][1495]},{"months":b[1][7],"days":b[1][662],"eras":b[1][8],"dayPeriods":b[0][1495]},{"months":b[1][4],"days":b[1][662],"eras":b[1][6],"dayPeriods":b[0][1495]},{"months":b[1][661],"days":b[1][662],"eras":b[1][663],"dayPeriods":b[0][1495]},{"months":b[1][10],"days":b[1][662],"eras":b[1][11],"dayPeriods":b[0][1495]},{"months":b[1][12],"days":b[1][662],"eras":b[1][13],"dayPeriods":b[0][1495]},{"months":b[1][14],"days":b[1][662],"eras":b[1][15],"dayPeriods":b[0][1495]},{"months":b[1][661],"days":b[1][662],"eras":b[1][16],"dayPeriods":b[0][1495]},{"months":b[1][17],"days":b[1][662],"eras":b[1][18],"dayPeriods":b[0][1495]},{"months":b[1][661],"days":b[1][662],"eras":b[1][19],"dayPeriods":b[0][1495]},{"months":b[1][664],"days":b[1][665],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][665],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][665],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][665],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][665],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][665],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][664],"days":b[1][665],"eras":b[1][666],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][665],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][665],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][665],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][664],"days":b[1][665],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][665],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][664],"days":b[1][665],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][211],"currencies":b[0][1506]},{"months":b[1][668],"days":b[1][669],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][669],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][669],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][669],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][669],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][669],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][668],"days":b[1][669],"eras":b[1][670],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][669],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][669],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][669],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][668],"days":b[1][669],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][669],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][668],"days":b[1][669],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][1514]},{"months":b[1][672],"days":b[1][673],"eras":b[1][3],"dayPeriods":b[0][1522]},{"months":b[1][4],"days":b[1][673],"dayPeriods":b[0][1522]},{"months":b[1][5],"days":b[1][673],"eras":b[1][6],"dayPeriods":b[0][1522]},{"months":b[1][7],"days":b[1][673],"eras":b[1][6],"dayPeriods":b[0][1522]},{"months":b[1][7],"days":b[1][673],"eras":b[1][8],"dayPeriods":b[0][1522]},{"months":b[1][4],"days":b[1][673],"eras":b[1][6],"dayPeriods":b[0][1522]},{"months":b[1][672],"days":b[1][673],"eras":b[1][674],"dayPeriods":b[0][1522]},{"months":b[1][10],"days":b[1][673],"eras":b[1][11],"dayPeriods":b[0][1522]},{"months":b[1][12],"days":b[1][673],"eras":b[1][13],"dayPeriods":b[0][1522]},{"months":b[1][14],"days":b[1][673],"eras":b[1][15],"dayPeriods":b[0][1522]},{"months":b[1][672],"days":b[1][673],"eras":b[1][16],"dayPeriods":b[0][1522]},{"months":b[1][17],"days":b[1][673],"eras":b[1][18],"dayPeriods":b[0][1522]},{"months":b[1][672],"days":b[1][673],"eras":b[1][19],"dayPeriods":b[0][1522]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][87],"currencies":b[0][1525]},{"months":b[1][676],"days":b[1][677],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][677],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][677],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][677],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][677],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][677],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][676],"days":b[1][677],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][677],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][677],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][677],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][676],"days":b[1][677],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][677],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][676],"days":b[1][677],"eras":b[1][19],"dayPeriods":b[0][175]},{"months":b[1][679],"days":b[1][680],"eras":b[1][3],"dayPeriods":b[0][1537]},{"months":b[1][4],"days":b[1][680],"dayPeriods":b[0][1537]},{"months":b[1][5],"days":b[1][680],"eras":b[1][6],"dayPeriods":b[0][1537]},{"months":b[1][7],"days":b[1][680],"eras":b[1][6],"dayPeriods":b[0][1537]},{"months":b[1][7],"days":b[1][680],"eras":b[1][8],"dayPeriods":b[0][1537]},{"months":b[1][4],"days":b[1][680],"eras":b[1][6],"dayPeriods":b[0][1537]},{"months":b[1][679],"days":b[1][680],"eras":b[1][681],"dayPeriods":b[0][1537]},{"months":b[1][10],"days":b[1][680],"eras":b[1][11],"dayPeriods":b[0][1537]},{"months":b[1][12],"days":b[1][680],"eras":b[1][13],"dayPeriods":b[0][1537]},{"months":b[1][14],"days":b[1][680],"eras":b[1][15],"dayPeriods":b[0][1537]},{"months":b[1][679],"days":b[1][680],"eras":b[1][16],"dayPeriods":b[0][1537]},{"months":b[1][17],"days":b[1][680],"eras":b[1][18],"dayPeriods":b[0][1537]},{"months":b[1][679],"days":b[1][680],"eras":b[1][19],"dayPeriods":b[0][1537]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][87],"currencies":b[0][1541]},{"months":b[1][683],"days":b[1][684],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][684],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][684],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][684],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][684],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][684],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][683],"days":b[1][684],"eras":b[1][685],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][684],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][686],"days":b[1][684],"eras":b[1][687],"dayPeriods":b[0][175]},{"months":b[1][688],"days":b[1][684],"eras":b[1][689],"dayPeriods":b[0][175]},{"months":b[1][683],"days":b[1][684],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][684],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][683],"days":b[1][684],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][690],"currencies":b[0][177]},{"months":b[1][692],"days":b[1][693],"eras":b[1][3],"dayPeriods":b[0][1565]},{"months":b[1][4],"days":b[1][693],"dayPeriods":b[0][1565]},{"months":b[1][5],"days":b[1][693],"eras":b[1][6],"dayPeriods":b[0][1565]},{"months":b[1][7],"days":b[1][693],"eras":b[1][6],"dayPeriods":b[0][1565]},{"months":b[1][7],"days":b[1][693],"eras":b[1][8],"dayPeriods":b[0][1565]},{"months":b[1][4],"days":b[1][693],"eras":b[1][6],"dayPeriods":b[0][1565]},{"months":b[1][692],"days":b[1][693],"eras":b[1][694],"dayPeriods":b[0][1565]},{"months":b[1][10],"days":b[1][693],"eras":b[1][11],"dayPeriods":b[0][1565]},{"months":b[1][12],"days":b[1][693],"eras":b[1][13],"dayPeriods":b[0][1565]},{"months":b[1][14],"days":b[1][693],"eras":b[1][15],"dayPeriods":b[0][1565]},{"months":b[1][692],"days":b[1][693],"eras":b[1][16],"dayPeriods":b[0][1565]},{"months":b[1][17],"days":b[1][693],"eras":b[1][18],"dayPeriods":b[0][1565]},{"months":b[1][692],"days":b[1][693],"eras":b[1][19],"dayPeriods":b[0][1565]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][21],"currencies":b[0][1569]},{"months":b[1][696],"days":b[1][697],"eras":b[1][3],"dayPeriods":b[0][1575]},{"months":b[1][4],"days":b[1][697],"dayPeriods":b[0][1575]},{"months":b[1][5],"days":b[1][697],"eras":b[1][6],"dayPeriods":b[0][1575]},{"months":b[1][7],"days":b[1][697],"eras":b[1][6],"dayPeriods":b[0][1575]},{"months":b[1][7],"days":b[1][697],"eras":b[1][8],"dayPeriods":b[0][1575]},{"months":b[1][4],"days":b[1][697],"eras":b[1][6],"dayPeriods":b[0][1575]},{"months":b[1][696],"days":b[1][697],"eras":b[1][698],"dayPeriods":b[0][1575]},{"months":b[1][10],"days":b[1][697],"eras":b[1][11],"dayPeriods":b[0][1575]},{"months":b[1][12],"days":b[1][697],"eras":b[1][13],"dayPeriods":b[0][1575]},{"months":b[1][14],"days":b[1][697],"eras":b[1][15],"dayPeriods":b[0][1575]},{"months":b[1][696],"days":b[1][697],"eras":b[1][16],"dayPeriods":b[0][1575]},{"months":b[1][17],"days":b[1][697],"eras":b[1][18],"dayPeriods":b[0][1575]},{"months":b[1][696],"days":b[1][697],"eras":b[1][19],"dayPeriods":b[0][1575]},{"nu":b[0][1578],"patterns":b[1][20],"symbols":b[1][146],"currencies":b[0][925]},{"months":b[1][700],"days":b[1][701],"eras":b[1][3],"dayPeriods":b[0][1587]},{"months":b[1][702],"days":b[1][701],"dayPeriods":b[0][1587]},{"months":b[1][5],"days":b[1][701],"eras":b[1][6],"dayPeriods":b[0][1587]},{"months":b[1][7],"days":b[1][701],"eras":b[1][6],"dayPeriods":b[0][1587]},{"months":b[1][7],"days":b[1][701],"eras":b[1][8],"dayPeriods":b[0][1587]},{"months":b[1][4],"days":b[1][701],"eras":b[1][6],"dayPeriods":b[0][1587]},{"months":b[1][700],"days":b[1][701],"eras":b[1][703],"dayPeriods":b[0][1587]},{"months":b[1][10],"days":b[1][701],"eras":b[1][11],"dayPeriods":b[0][1587]},{"months":b[1][12],"days":b[1][701],"eras":b[1][13],"dayPeriods":b[0][1587]},{"months":b[1][14],"days":b[1][701],"eras":b[1][15],"dayPeriods":b[0][1587]},{"months":b[1][700],"days":b[1][701],"eras":b[1][16],"dayPeriods":b[0][1587]},{"months":b[1][17],"days":b[1][701],"eras":b[1][18],"dayPeriods":b[0][1587]},{"months":b[1][700],"days":b[1][701],"eras":b[1][19],"dayPeriods":b[0][1587]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][87],"currencies":b[0][1590]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][1592]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][1593]},{"months":b[1][706],"days":b[1][707],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][707],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][707],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][707],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][707],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][707],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][706],"days":b[1][707],"eras":b[1][708],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][707],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][707],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][707],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][706],"days":b[1][707],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][707],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][706],"days":b[1][707],"eras":b[1][19],"dayPeriods":b[0][175]},{"months":b[1][709],"days":b[1][710],"eras":b[1][3],"dayPeriods":b[0][1610]},{"months":b[1][4],"days":b[1][710],"dayPeriods":b[0][1610]},{"months":b[1][5],"days":b[1][710],"eras":b[1][6],"dayPeriods":b[0][1610]},{"months":b[1][7],"days":b[1][710],"eras":b[1][6],"dayPeriods":b[0][1610]},{"months":b[1][7],"days":b[1][710],"eras":b[1][8],"dayPeriods":b[0][1610]},{"months":b[1][4],"days":b[1][710],"eras":b[1][6],"dayPeriods":b[0][1610]},{"months":b[1][709],"days":b[1][710],"eras":b[1][711],"dayPeriods":b[0][1610]},{"months":b[1][10],"days":b[1][710],"eras":b[1][11],"dayPeriods":b[0][1610]},{"months":b[1][12],"days":b[1][710],"eras":b[1][13],"dayPeriods":b[0][1610]},{"months":b[1][14],"days":b[1][710],"eras":b[1][15],"dayPeriods":b[0][1610]},{"months":b[1][709],"days":b[1][710],"eras":b[1][16],"dayPeriods":b[0][1610]},{"months":b[1][17],"days":b[1][710],"eras":b[1][18],"dayPeriods":b[0][1610]},{"months":b[1][709],"days":b[1][710],"eras":b[1][19],"dayPeriods":b[0][1610]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][87],"currencies":b[0][72]},{"months":b[1][713],"days":b[1][714],"eras":b[1][3],"dayPeriods":b[0][1618]},{"months":b[1][4],"days":b[1][714],"dayPeriods":b[0][1618]},{"months":b[1][5],"days":b[1][714],"eras":b[1][6],"dayPeriods":b[0][1618]},{"months":b[1][7],"days":b[1][714],"eras":b[1][6],"dayPeriods":b[0][1618]},{"months":b[1][7],"days":b[1][714],"eras":b[1][8],"dayPeriods":b[0][1618]},{"months":b[1][4],"days":b[1][714],"eras":b[1][6],"dayPeriods":b[0][1618]},{"months":b[1][713],"days":b[1][714],"eras":b[1][715],"dayPeriods":b[0][1618]},{"months":b[1][10],"days":b[1][714],"eras":b[1][11],"dayPeriods":b[0][1618]},{"months":b[1][12],"days":b[1][714],"eras":b[1][13],"dayPeriods":b[0][1618]},{"months":b[1][14],"days":b[1][714],"eras":b[1][15],"dayPeriods":b[0][1618]},{"months":b[1][713],"days":b[1][714],"eras":b[1][16],"dayPeriods":b[0][1618]},{"months":b[1][17],"days":b[1][714],"eras":b[1][18],"dayPeriods":b[0][1618]},{"months":b[1][713],"days":b[1][714],"eras":b[1][19],"dayPeriods":b[0][1618]},{"nu":b[0][1621],"patterns":b[1][27],"symbols":b[1][716],"currencies":b[0][1623]},{"months":b[1][717],"days":b[1][718],"eras":b[1][3],"dayPeriods":b[0][1628]},{"months":b[1][4],"days":b[1][718],"dayPeriods":b[0][1628]},{"months":b[1][5],"days":b[1][718],"eras":b[1][6],"dayPeriods":b[0][1628]},{"months":b[1][7],"days":b[1][718],"eras":b[1][6],"dayPeriods":b[0][1628]},{"months":b[1][7],"days":b[1][718],"eras":b[1][8],"dayPeriods":b[0][1628]},{"months":b[1][4],"days":b[1][718],"eras":b[1][6],"dayPeriods":b[0][1628]},{"months":b[1][717],"days":b[1][718],"eras":b[1][719],"dayPeriods":b[0][1628]},{"months":b[1][10],"days":b[1][718],"eras":b[1][11],"dayPeriods":b[0][1628]},{"months":b[1][12],"days":b[1][718],"eras":b[1][13],"dayPeriods":b[0][1628]},{"months":b[1][14],"days":b[1][718],"eras":b[1][15],"dayPeriods":b[0][1628]},{"months":b[1][717],"days":b[1][718],"eras":b[1][16],"dayPeriods":b[0][1628]},{"months":b[1][17],"days":b[1][718],"eras":b[1][18],"dayPeriods":b[0][1628]},{"months":b[1][717],"days":b[1][718],"eras":b[1][19],"dayPeriods":b[0][1628]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][1630]},{"months":b[1][721],"days":b[1][193],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][193],"dayPeriods":b[0][583]},{"months":b[1][5],"days":b[1][193],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][193],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][193],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][193],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][721],"days":b[1][193],"eras":b[1][722],"dayPeriods":b[0][583]},{"months":b[1][10],"days":b[1][193],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][193],"eras":b[1][13],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][193],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][721],"days":b[1][193],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][193],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][721],"days":b[1][193],"eras":b[1][195],"dayPeriods":b[0][583]},{"nu":b[0][33],"patterns":b[1][203],"symbols":b[1][28],"currencies":b[0][1638]},{"months":b[1][723],"days":b[1][724],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][724],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][724],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][724],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][724],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][724],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][723],"days":b[1][724],"eras":b[1][725],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][724],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][724],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][724],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][723],"days":b[1][724],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][724],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][723],"days":b[1][724],"eras":b[1][19],"dayPeriods":b[0][175]},{"months":b[1][727],"days":b[1][728],"eras":b[1][3],"dayPeriods":b[0][1016]},{"months":b[1][4],"days":b[1][728],"dayPeriods":b[0][1016]},{"months":b[1][5],"days":b[1][728],"eras":b[1][6],"dayPeriods":b[0][1016]},{"months":b[1][7],"days":b[1][728],"eras":b[1][6],"dayPeriods":b[0][1016]},{"months":b[1][7],"days":b[1][728],"eras":b[1][8],"dayPeriods":b[0][1016]},{"months":b[1][4],"days":b[1][728],"eras":b[1][6],"dayPeriods":b[0][1016]},{"months":b[1][727],"days":b[1][728],"eras":b[1][729],"dayPeriods":b[0][1016]},{"months":b[1][10],"days":b[1][728],"eras":b[1][11],"dayPeriods":b[0][1016]},{"months":b[1][730],"days":b[1][728],"eras":b[1][13],"dayPeriods":b[0][1016]},{"months":b[1][14],"days":b[1][728],"eras":b[1][15],"dayPeriods":b[0][1016]},{"months":b[1][727],"days":b[1][728],"eras":b[1][16],"dayPeriods":b[0][1016]},{"months":b[1][17],"days":b[1][728],"eras":b[1][18],"dayPeriods":b[0][1016]},{"months":b[1][727],"days":b[1][728],"eras":b[1][19],"dayPeriods":b[0][1016]},{"nu":b[0][1578],"patterns":b[1][27],"symbols":b[1][146],"currencies":b[0][1655]},{"months":b[1][731],"days":b[1][732],"eras":b[1][3],"dayPeriods":b[0][1657]},{"months":b[1][4],"days":b[1][732],"dayPeriods":b[0][1657]},{"months":b[1][5],"days":b[1][732],"eras":b[1][6],"dayPeriods":b[0][1657]},{"months":b[1][7],"days":b[1][732],"eras":b[1][6],"dayPeriods":b[0][1657]},{"months":b[1][7],"days":b[1][732],"eras":b[1][8],"dayPeriods":b[0][1657]},{"months":b[1][4],"days":b[1][732],"eras":b[1][6],"dayPeriods":b[0][1657]},{"months":b[1][731],"days":b[1][732],"eras":b[1][729],"dayPeriods":b[0][1657]},{"months":b[1][10],"days":b[1][732],"eras":b[1][11],"dayPeriods":b[0][1657]},{"months":b[1][12],"days":b[1][732],"eras":b[1][13],"dayPeriods":b[0][1657]},{"months":b[1][14],"days":b[1][732],"eras":b[1][15],"dayPeriods":b[0][1657]},{"months":b[1][731],"days":b[1][732],"eras":b[1][16],"dayPeriods":b[0][1657]},{"months":b[1][17],"days":b[1][732],"eras":b[1][18],"dayPeriods":b[0][1657]},{"months":b[1][731],"days":b[1][732],"eras":b[1][19],"dayPeriods":b[0][1657]},{"months":b[1][733],"days":b[1][734],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][735],"days":b[1][734],"dayPeriods":b[0][583]},{"months":b[1][373],"days":b[1][734],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][374],"days":b[1][734],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][374],"days":b[1][734],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][734],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][733],"days":b[1][734],"eras":b[1][736],"dayPeriods":b[0][583]},{"months":b[1][376],"days":b[1][734],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][377],"days":b[1][734],"eras":b[1][254],"dayPeriods":b[0][583]},{"months":b[1][378],"days":b[1][734],"eras":b[1][379],"dayPeriods":b[0][583]},{"months":b[1][733],"days":b[1][734],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][734],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][733],"days":b[1][734],"eras":b[1][195],"dayPeriods":b[0][583]},{"nu":b[0][33],"patterns":b[1][380],"symbols":b[1][87],"currencies":b[0][1667]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][903]},{"nu":b[0][33],"patterns":b[1][380],"symbols":b[1][87],"currencies":b[0][1669]},{"nu":b[0][33],"patterns":b[1][380],"symbols":b[1][87],"currencies":b[0][1670]},{"nu":b[0][33],"patterns":b[1][380],"symbols":b[1][87],"currencies":b[0][1671]},{"months":b[1][738],"days":b[1][739],"eras":b[1][3],"dayPeriods":b[0][1677]},{"months":b[1][4],"days":b[1][739],"dayPeriods":b[0][1677]},{"months":b[1][5],"days":b[1][739],"eras":b[1][6],"dayPeriods":b[0][1677]},{"months":b[1][7],"days":b[1][739],"eras":b[1][6],"dayPeriods":b[0][1677]},{"months":b[1][7],"days":b[1][739],"eras":b[1][8],"dayPeriods":b[0][1677]},{"months":b[1][4],"days":b[1][739],"eras":b[1][6],"dayPeriods":b[0][1677]},{"months":b[1][738],"days":b[1][739],"eras":b[1][740],"dayPeriods":b[0][1677]},{"months":b[1][10],"days":b[1][739],"eras":b[1][11],"dayPeriods":b[0][1677]},{"months":b[1][12],"days":b[1][739],"eras":b[1][13],"dayPeriods":b[0][1677]},{"months":b[1][14],"days":b[1][739],"eras":b[1][15],"dayPeriods":b[0][1677]},{"months":b[1][738],"days":b[1][739],"eras":b[1][16],"dayPeriods":b[0][1677]},{"months":b[1][17],"days":b[1][739],"eras":b[1][18],"dayPeriods":b[0][1677]},{"months":b[1][738],"days":b[1][739],"eras":b[1][19],"dayPeriods":b[0][1677]},{"months":b[1][742],"days":b[1][743],"eras":b[1][3],"dayPeriods":b[0][1685]},{"months":b[1][4],"days":b[1][743],"dayPeriods":b[0][1685]},{"months":b[1][5],"days":b[1][743],"eras":b[1][6],"dayPeriods":b[0][1685]},{"months":b[1][7],"days":b[1][743],"eras":b[1][6],"dayPeriods":b[0][1685]},{"months":b[1][7],"days":b[1][743],"eras":b[1][8],"dayPeriods":b[0][1685]},{"months":b[1][4],"days":b[1][743],"eras":b[1][6],"dayPeriods":b[0][1685]},{"months":b[1][742],"days":b[1][743],"eras":b[1][744],"dayPeriods":b[0][1685]},{"months":b[1][10],"days":b[1][743],"eras":b[1][11],"dayPeriods":b[0][1685]},{"months":b[1][12],"days":b[1][743],"eras":b[1][13],"dayPeriods":b[0][1685]},{"months":b[1][14],"days":b[1][743],"eras":b[1][15],"dayPeriods":b[0][1685]},{"months":b[1][742],"days":b[1][743],"eras":b[1][16],"dayPeriods":b[0][1685]},{"months":b[1][17],"days":b[1][743],"eras":b[1][18],"dayPeriods":b[0][1685]},{"months":b[1][742],"days":b[1][743],"eras":b[1][19],"dayPeriods":b[0][1685]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][1688]},{"months":b[1][746],"days":b[1][747],"eras":b[1][3],"dayPeriods":b[0][1693]},{"months":b[1][4],"days":b[1][747],"dayPeriods":b[0][1693]},{"months":b[1][5],"days":b[1][747],"eras":b[1][6],"dayPeriods":b[0][1693]},{"months":b[1][7],"days":b[1][747],"eras":b[1][6],"dayPeriods":b[0][1693]},{"months":b[1][7],"days":b[1][747],"eras":b[1][8],"dayPeriods":b[0][1693]},{"months":b[1][4],"days":b[1][747],"eras":b[1][6],"dayPeriods":b[0][1693]},{"months":b[1][746],"days":b[1][747],"eras":b[1][748],"dayPeriods":b[0][1693]},{"months":b[1][10],"days":b[1][747],"eras":b[1][11],"dayPeriods":b[0][1693]},{"months":b[1][12],"days":b[1][747],"eras":b[1][13],"dayPeriods":b[0][1693]},{"months":b[1][14],"days":b[1][747],"eras":b[1][15],"dayPeriods":b[0][1693]},{"months":b[1][746],"days":b[1][747],"eras":b[1][16],"dayPeriods":b[0][1693]},{"months":b[1][17],"days":b[1][747],"eras":b[1][18],"dayPeriods":b[0][1693]},{"months":b[1][746],"days":b[1][747],"eras":b[1][19],"dayPeriods":b[0][1693]},{"months":b[1][749],"days":b[1][750],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][750],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][750],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][750],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][750],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][750],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][749],"days":b[1][750],"eras":b[1][341],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][750],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][750],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][750],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][749],"days":b[1][750],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][750],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][749],"days":b[1][750],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][28],"currencies":b[0][1700]},{"months":b[1][751],"days":b[1][752],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][752],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][752],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][752],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][752],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][752],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][751],"days":b[1][752],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][752],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][752],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][752],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][751],"days":b[1][752],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][752],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][751],"days":b[1][752],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][211],"currencies":b[0][1700]},{"months":b[1][754],"days":b[1][755],"eras":b[1][3],"dayPeriods":b[0][1714]},{"months":b[1][4],"days":b[1][755],"dayPeriods":b[0][1714]},{"months":b[1][5],"days":b[1][755],"eras":b[1][6],"dayPeriods":b[0][1714]},{"months":b[1][7],"days":b[1][755],"eras":b[1][6],"dayPeriods":b[0][1714]},{"months":b[1][7],"days":b[1][755],"eras":b[1][8],"dayPeriods":b[0][1714]},{"months":b[1][4],"days":b[1][755],"eras":b[1][6],"dayPeriods":b[0][1714]},{"months":b[1][754],"days":b[1][755],"eras":b[1][756],"dayPeriods":b[0][1714]},{"months":b[1][10],"days":b[1][755],"eras":b[1][11],"dayPeriods":b[0][1714]},{"months":b[1][12],"days":b[1][755],"eras":b[1][13],"dayPeriods":b[0][1714]},{"months":b[1][14],"days":b[1][755],"eras":b[1][15],"dayPeriods":b[0][1714]},{"months":b[1][754],"days":b[1][755],"eras":b[1][16],"dayPeriods":b[0][1714]},{"months":b[1][17],"days":b[1][755],"eras":b[1][18],"dayPeriods":b[0][1714]},{"months":b[1][754],"days":b[1][755],"eras":b[1][19],"dayPeriods":b[0][1714]},{"months":b[1][758],"days":b[1][759],"eras":b[1][3],"dayPeriods":b[0][1723]},{"months":b[1][4],"days":b[1][759],"dayPeriods":b[0][1723]},{"months":b[1][5],"days":b[1][759],"eras":b[1][6],"dayPeriods":b[0][1723]},{"months":b[1][7],"days":b[1][759],"eras":b[1][6],"dayPeriods":b[0][1723]},{"months":b[1][7],"days":b[1][759],"eras":b[1][8],"dayPeriods":b[0][1723]},{"months":b[1][4],"days":b[1][759],"eras":b[1][6],"dayPeriods":b[0][1723]},{"months":b[1][758],"days":b[1][759],"eras":b[1][760],"dayPeriods":b[0][1723]},{"months":b[1][10],"days":b[1][759],"eras":b[1][11],"dayPeriods":b[0][1723]},{"months":b[1][12],"days":b[1][759],"eras":b[1][13],"dayPeriods":b[0][1723]},{"months":b[1][14],"days":b[1][759],"eras":b[1][15],"dayPeriods":b[0][1723]},{"months":b[1][758],"days":b[1][759],"eras":b[1][16],"dayPeriods":b[0][1723]},{"months":b[1][17],"days":b[1][759],"eras":b[1][18],"dayPeriods":b[0][1723]},{"months":b[1][758],"days":b[1][759],"eras":b[1][19],"dayPeriods":b[0][1723]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][1725]},{"months":b[1][762],"days":b[1][763],"eras":b[1][3],"dayPeriods":b[0][549]},{"months":b[1][4],"days":b[1][763],"dayPeriods":b[0][549]},{"months":b[1][5],"days":b[1][763],"eras":b[1][6],"dayPeriods":b[0][549]},{"months":b[1][7],"days":b[1][763],"eras":b[1][6],"dayPeriods":b[0][549]},{"months":b[1][7],"days":b[1][763],"eras":b[1][8],"dayPeriods":b[0][549]},{"months":b[1][4],"days":b[1][763],"eras":b[1][6],"dayPeriods":b[0][549]},{"months":b[1][762],"days":b[1][763],"eras":b[1][75],"dayPeriods":b[0][549]},{"months":b[1][10],"days":b[1][763],"eras":b[1][11],"dayPeriods":b[0][549]},{"months":b[1][12],"days":b[1][763],"eras":b[1][13],"dayPeriods":b[0][549]},{"months":b[1][14],"days":b[1][763],"eras":b[1][15],"dayPeriods":b[0][549]},{"months":b[1][762],"days":b[1][763],"eras":b[1][16],"dayPeriods":b[0][549]},{"months":b[1][17],"days":b[1][763],"eras":b[1][18],"dayPeriods":b[0][549]},{"months":b[1][762],"days":b[1][763],"eras":b[1][19],"dayPeriods":b[0][549]},{"nu":b[0][33],"patterns":b[1][76],"symbols":b[1][764],"currencies":b[0][72]},{"months":b[1][766],"days":b[1][767],"eras":b[1][3],"dayPeriods":b[0][1740]},{"months":b[1][4],"days":b[1][767],"dayPeriods":b[0][1740]},{"months":b[1][5],"days":b[1][767],"eras":b[1][6],"dayPeriods":b[0][1740]},{"months":b[1][7],"days":b[1][767],"eras":b[1][6],"dayPeriods":b[0][1740]},{"months":b[1][7],"days":b[1][767],"eras":b[1][8],"dayPeriods":b[0][1740]},{"months":b[1][4],"days":b[1][767],"eras":b[1][6],"dayPeriods":b[0][1740]},{"months":b[1][766],"days":b[1][767],"eras":b[1][768],"dayPeriods":b[0][1740]},{"months":b[1][10],"days":b[1][767],"eras":b[1][11],"dayPeriods":b[0][1740]},{"months":b[1][12],"days":b[1][767],"eras":b[1][13],"dayPeriods":b[0][1740]},{"months":b[1][14],"days":b[1][767],"eras":b[1][15],"dayPeriods":b[0][1740]},{"months":b[1][766],"days":b[1][767],"eras":b[1][16],"dayPeriods":b[0][1740]},{"months":b[1][17],"days":b[1][767],"eras":b[1][18],"dayPeriods":b[0][1740]},{"months":b[1][766],"days":b[1][767],"eras":b[1][19],"dayPeriods":b[0][1740]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][769],"currencies":b[0][379]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][769],"currencies":b[0][1743]},{"months":b[1][771],"days":b[1][772],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][772],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][772],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][772],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][772],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][772],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][771],"days":b[1][772],"eras":b[1][773],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][772],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][772],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][772],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][771],"days":b[1][772],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][772],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][771],"days":b[1][772],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][763],"patterns":b[1][27],"symbols":b[1][774],"currencies":b[0][1749]},{"months":b[1][776],"days":b[1][777],"eras":b[1][3],"dayPeriods":b[0][1757]},{"months":b[1][4],"days":b[1][777],"dayPeriods":b[0][1757]},{"months":b[1][5],"days":b[1][777],"eras":b[1][6],"dayPeriods":b[0][1757]},{"months":b[1][7],"days":b[1][777],"eras":b[1][6],"dayPeriods":b[0][1757]},{"months":b[1][7],"days":b[1][777],"eras":b[1][8],"dayPeriods":b[0][1757]},{"months":b[1][4],"days":b[1][777],"eras":b[1][6],"dayPeriods":b[0][1757]},{"months":b[1][776],"days":b[1][777],"eras":b[1][778],"dayPeriods":b[0][1757]},{"months":b[1][10],"days":b[1][777],"eras":b[1][11],"dayPeriods":b[0][1757]},{"months":b[1][779],"days":b[1][777],"eras":b[1][780],"dayPeriods":b[0][1757]},{"months":b[1][14],"days":b[1][777],"eras":b[1][15],"dayPeriods":b[0][1757]},{"months":b[1][776],"days":b[1][777],"eras":b[1][16],"dayPeriods":b[0][1757]},{"months":b[1][17],"days":b[1][777],"eras":b[1][18],"dayPeriods":b[0][1757]},{"months":b[1][776],"days":b[1][777],"eras":b[1][19],"dayPeriods":b[0][1757]},{"nu":b[0][33],"patterns":b[1][76],"symbols":b[1][781],"currencies":b[0][192]},{"months":b[1][783],"days":b[1][784],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][450],"days":b[1][784],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][784],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][784],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][784],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][784],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][783],"days":b[1][784],"eras":b[1][785],"dayPeriods":b[0][175]},{"months":b[1][786],"days":b[1][784],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][784],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][787],"days":b[1][784],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][783],"days":b[1][784],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][788],"days":b[1][784],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][783],"days":b[1][784],"eras":b[1][789],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][1777]},{"months":b[1][791],"days":b[1][792],"eras":b[1][3],"dayPeriods":b[0][1781]},{"months":b[1][4],"days":b[1][792],"dayPeriods":b[0][1781]},{"months":b[1][5],"days":b[1][792],"eras":b[1][6],"dayPeriods":b[0][1781]},{"months":b[1][7],"days":b[1][792],"eras":b[1][6],"dayPeriods":b[0][1781]},{"months":b[1][7],"days":b[1][792],"eras":b[1][8],"dayPeriods":b[0][1781]},{"months":b[1][4],"days":b[1][792],"eras":b[1][6],"dayPeriods":b[0][1781]},{"months":b[1][791],"days":b[1][792],"eras":b[1][793],"dayPeriods":b[0][1781]},{"months":b[1][10],"days":b[1][792],"eras":b[1][11],"dayPeriods":b[0][1781]},{"months":b[1][12],"days":b[1][792],"eras":b[1][13],"dayPeriods":b[0][1781]},{"months":b[1][14],"days":b[1][792],"eras":b[1][15],"dayPeriods":b[0][1781]},{"months":b[1][791],"days":b[1][792],"eras":b[1][16],"dayPeriods":b[0][1781]},{"months":b[1][794],"days":b[1][792],"eras":b[1][18],"dayPeriods":b[0][1781]},{"months":b[1][791],"days":b[1][792],"eras":b[1][19],"dayPeriods":b[0][1781]},{"nu":b[0][763],"patterns":b[1][82],"symbols":b[1][795],"currencies":b[0][1784]},{"months":b[1][797],"days":b[1][798],"eras":b[1][3],"dayPeriods":b[0][1791]},{"months":b[1][799],"days":b[1][798],"dayPeriods":b[0][1791]},{"months":b[1][5],"days":b[1][798],"eras":b[1][6],"dayPeriods":b[0][1791]},{"months":b[1][7],"days":b[1][798],"eras":b[1][6],"dayPeriods":b[0][1791]},{"months":b[1][7],"days":b[1][798],"eras":b[1][8],"dayPeriods":b[0][1791]},{"months":b[1][4],"days":b[1][798],"eras":b[1][6],"dayPeriods":b[0][1791]},{"months":b[1][797],"days":b[1][798],"eras":b[1][800],"dayPeriods":b[0][1791]},{"months":b[1][10],"days":b[1][798],"eras":b[1][11],"dayPeriods":b[0][1791]},{"months":b[1][12],"days":b[1][798],"eras":b[1][13],"dayPeriods":b[0][1791]},{"months":b[1][14],"days":b[1][798],"eras":b[1][15],"dayPeriods":b[0][1791]},{"months":b[1][797],"days":b[1][798],"eras":b[1][16],"dayPeriods":b[0][1791]},{"months":b[1][17],"days":b[1][798],"eras":b[1][18],"dayPeriods":b[0][1791]},{"months":b[1][797],"days":b[1][798],"eras":b[1][801],"dayPeriods":b[0][1791]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][1797]},{"months":b[1][797],"days":b[1][798],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][803],"days":b[1][798],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][798],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][798],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][798],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][798],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][797],"days":b[1][798],"eras":b[1][804],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][798],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][798],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][798],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][797],"days":b[1][798],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][798],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][797],"days":b[1][798],"eras":b[1][801],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][87],"currencies":b[0][1802]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][1803]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][1804]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][1805]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][1806]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][1807]},{"months":b[1][806],"days":b[1][807],"eras":b[1][3],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][807],"dayPeriods":b[0][583]},{"months":b[1][5],"days":b[1][807],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][807],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][7],"days":b[1][807],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][807],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][806],"days":b[1][807],"eras":b[1][808],"dayPeriods":b[0][583]},{"months":b[1][10],"days":b[1][807],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][807],"eras":b[1][13],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][807],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][806],"days":b[1][807],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][807],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][806],"days":b[1][807],"eras":b[1][19],"dayPeriods":b[0][583]},{"nu":b[0][33],"patterns":b[1][203],"symbols":b[1][87],"currencies":b[0][1817]},{"nu":b[0][33],"patterns":b[1][203],"symbols":b[1][21],"currencies":b[0][379]},{"nu":b[0][33],"patterns":b[1][203],"symbols":b[1][21],"currencies":b[0][1818]},{"months":b[1][810],"days":b[1][811],"eras":b[1][3],"dayPeriods":b[0][1826]},{"months":b[1][4],"days":b[1][811],"dayPeriods":b[0][1826]},{"months":b[1][5],"days":b[1][811],"eras":b[1][6],"dayPeriods":b[0][1826]},{"months":b[1][7],"days":b[1][811],"eras":b[1][6],"dayPeriods":b[0][1826]},{"months":b[1][7],"days":b[1][811],"eras":b[1][8],"dayPeriods":b[0][1826]},{"months":b[1][4],"days":b[1][811],"eras":b[1][6],"dayPeriods":b[0][1826]},{"months":b[1][810],"days":b[1][811],"eras":b[1][812],"dayPeriods":b[0][1826]},{"months":b[1][10],"days":b[1][811],"eras":b[1][11],"dayPeriods":b[0][1826]},{"months":b[1][12],"days":b[1][811],"eras":b[1][13],"dayPeriods":b[0][1826]},{"months":b[1][14],"days":b[1][811],"eras":b[1][15],"dayPeriods":b[0][1826]},{"months":b[1][810],"days":b[1][811],"eras":b[1][16],"dayPeriods":b[0][1826]},{"months":b[1][17],"days":b[1][811],"eras":b[1][18],"dayPeriods":b[0][1826]},{"months":b[1][810],"days":b[1][811],"eras":b[1][19],"dayPeriods":b[0][1826]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][397],"currencies":b[0][379]},{"months":b[1][813],"days":b[1][814],"eras":b[1][3],"dayPeriods":b[0][1833]},{"months":b[1][4],"days":b[1][814],"dayPeriods":b[0][1833]},{"months":b[1][5],"days":b[1][814],"eras":b[1][6],"dayPeriods":b[0][1833]},{"months":b[1][7],"days":b[1][814],"eras":b[1][6],"dayPeriods":b[0][1833]},{"months":b[1][7],"days":b[1][814],"eras":b[1][8],"dayPeriods":b[0][1833]},{"months":b[1][4],"days":b[1][814],"eras":b[1][6],"dayPeriods":b[0][1833]},{"months":b[1][813],"days":b[1][814],"eras":b[1][815],"dayPeriods":b[0][1833]},{"months":b[1][10],"days":b[1][814],"eras":b[1][11],"dayPeriods":b[0][1833]},{"months":b[1][12],"days":b[1][814],"eras":b[1][13],"dayPeriods":b[0][1833]},{"months":b[1][14],"days":b[1][814],"eras":b[1][15],"dayPeriods":b[0][1833]},{"months":b[1][813],"days":b[1][814],"eras":b[1][16],"dayPeriods":b[0][1833]},{"months":b[1][17],"days":b[1][814],"eras":b[1][18],"dayPeriods":b[0][1833]},{"months":b[1][813],"days":b[1][814],"eras":b[1][19],"dayPeriods":b[0][1833]},{"nu":b[0][33],"patterns":b[1][816],"symbols":b[1][87],"currencies":b[0][1836]},{"months":b[1][818],"days":b[1][819],"eras":b[1][820],"dayPeriods":b[0][583]},{"months":b[1][450],"days":b[1][819],"dayPeriods":b[0][583]},{"months":b[1][821],"days":b[1][819],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][822],"days":b[1][819],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][822],"days":b[1][819],"eras":b[1][8],"dayPeriods":b[0][583]},{"months":b[1][4],"days":b[1][819],"eras":b[1][6],"dayPeriods":b[0][583]},{"months":b[1][818],"days":b[1][819],"eras":b[1][823],"dayPeriods":b[0][583]},{"months":b[1][824],"days":b[1][819],"eras":b[1][11],"dayPeriods":b[0][583]},{"months":b[1][12],"days":b[1][819],"eras":b[1][13],"dayPeriods":b[0][583]},{"months":b[1][14],"days":b[1][819],"eras":b[1][15],"dayPeriods":b[0][583]},{"months":b[1][818],"days":b[1][819],"eras":b[1][16],"dayPeriods":b[0][583]},{"months":b[1][17],"days":b[1][819],"eras":b[1][18],"dayPeriods":b[0][583]},{"months":b[1][818],"days":b[1][819],"eras":b[1][19],"dayPeriods":b[0][583]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][1850]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][87],"currencies":b[0][1851]},{"months":b[1][825],"days":b[1][826],"eras":b[1][3],"dayPeriods":b[0][1856]},{"months":b[1][4],"days":b[1][826],"dayPeriods":b[0][1856]},{"months":b[1][5],"days":b[1][826],"eras":b[1][6],"dayPeriods":b[0][1856]},{"months":b[1][7],"days":b[1][826],"eras":b[1][6],"dayPeriods":b[0][1856]},{"months":b[1][7],"days":b[1][826],"eras":b[1][8],"dayPeriods":b[0][1856]},{"months":b[1][4],"days":b[1][826],"eras":b[1][6],"dayPeriods":b[0][1856]},{"months":b[1][825],"days":b[1][826],"eras":b[1][827],"dayPeriods":b[0][1856]},{"months":b[1][10],"days":b[1][826],"eras":b[1][11],"dayPeriods":b[0][1856]},{"months":b[1][12],"days":b[1][826],"eras":b[1][13],"dayPeriods":b[0][1856]},{"months":b[1][14],"days":b[1][826],"eras":b[1][15],"dayPeriods":b[0][1856]},{"months":b[1][825],"days":b[1][826],"eras":b[1][16],"dayPeriods":b[0][1856]},{"months":b[1][17],"days":b[1][826],"eras":b[1][18],"dayPeriods":b[0][1856]},{"months":b[1][825],"days":b[1][826],"eras":b[1][19],"dayPeriods":b[0][1856]},{"months":b[1][829],"days":b[1][830],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][450],"days":b[1][830],"dayPeriods":b[0][175]},{"months":b[1][831],"days":b[1][830],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][832],"days":b[1][830],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][832],"days":b[1][830],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][830],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][829],"days":b[1][830],"eras":b[1][833],"dayPeriods":b[0][175]},{"months":b[1][834],"days":b[1][830],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][835],"days":b[1][830],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][836],"days":b[1][830],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][829],"days":b[1][830],"eras":b[1][837],"dayPeriods":b[0][175]},{"months":b[1][838],"days":b[1][830],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][829],"days":b[1][830],"eras":b[1][195],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][839],"currencies":b[0][1874]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][839],"currencies":b[0][1875]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][839],"currencies":b[0][1876]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][839],"currencies":b[0][1877]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][839],"currencies":b[0][1878]},{"months":b[1][841],"days":b[1][842],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][842],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][842],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][842],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][842],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][842],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][841],"days":b[1][842],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][842],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][842],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][842],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][841],"days":b[1][842],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][842],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][841],"days":b[1][842],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][87],"currencies":b[0][1885]},{"months":b[1][844],"days":b[1][845],"eras":b[1][3],"dayPeriods":b[0][1893]},{"months":b[1][4],"days":b[1][845],"dayPeriods":b[0][1893]},{"months":b[1][5],"days":b[1][845],"eras":b[1][6],"dayPeriods":b[0][1893]},{"months":b[1][7],"days":b[1][845],"eras":b[1][6],"dayPeriods":b[0][1893]},{"months":b[1][7],"days":b[1][845],"eras":b[1][8],"dayPeriods":b[0][1893]},{"months":b[1][4],"days":b[1][845],"eras":b[1][6],"dayPeriods":b[0][1893]},{"months":b[1][844],"days":b[1][845],"eras":b[1][846],"dayPeriods":b[0][1893]},{"months":b[1][10],"days":b[1][845],"eras":b[1][11],"dayPeriods":b[0][1893]},{"months":b[1][12],"days":b[1][845],"eras":b[1][13],"dayPeriods":b[0][1893]},{"months":b[1][14],"days":b[1][845],"eras":b[1][15],"dayPeriods":b[0][1893]},{"months":b[1][844],"days":b[1][845],"eras":b[1][16],"dayPeriods":b[0][1893]},{"months":b[1][17],"days":b[1][845],"eras":b[1][18],"dayPeriods":b[0][1893]},{"months":b[1][844],"days":b[1][845],"eras":b[1][19],"dayPeriods":b[0][1893]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][21],"currencies":b[0][1895]},{"months":b[1][847],"days":b[1][848],"eras":b[1][3],"dayPeriods":b[0][1902]},{"months":b[1][4],"days":b[1][848],"dayPeriods":b[0][1902]},{"months":b[1][5],"days":b[1][848],"eras":b[1][6],"dayPeriods":b[0][1902]},{"months":b[1][7],"days":b[1][848],"eras":b[1][6],"dayPeriods":b[0][1902]},{"months":b[1][7],"days":b[1][848],"eras":b[1][8],"dayPeriods":b[0][1902]},{"months":b[1][4],"days":b[1][848],"eras":b[1][6],"dayPeriods":b[0][1902]},{"months":b[1][847],"days":b[1][848],"eras":b[1][849],"dayPeriods":b[0][1902]},{"months":b[1][10],"days":b[1][848],"eras":b[1][11],"dayPeriods":b[0][1902]},{"months":b[1][12],"days":b[1][848],"eras":b[1][13],"dayPeriods":b[0][1902]},{"months":b[1][14],"days":b[1][848],"eras":b[1][15],"dayPeriods":b[0][1902]},{"months":b[1][847],"days":b[1][848],"eras":b[1][16],"dayPeriods":b[0][1902]},{"months":b[1][17],"days":b[1][848],"eras":b[1][18],"dayPeriods":b[0][1902]},{"months":b[1][847],"days":b[1][848],"eras":b[1][19],"dayPeriods":b[0][1902]},{"months":b[1][851],"days":b[1][852],"eras":b[1][3],"dayPeriods":b[0][1910]},{"months":b[1][4],"days":b[1][852],"dayPeriods":b[0][1910]},{"months":b[1][5],"days":b[1][852],"eras":b[1][6],"dayPeriods":b[0][1910]},{"months":b[1][7],"days":b[1][852],"eras":b[1][6],"dayPeriods":b[0][1910]},{"months":b[1][7],"days":b[1][852],"eras":b[1][8],"dayPeriods":b[0][1910]},{"months":b[1][4],"days":b[1][852],"eras":b[1][6],"dayPeriods":b[0][1910]},{"months":b[1][851],"days":b[1][852],"eras":b[1][853],"dayPeriods":b[0][1910]},{"months":b[1][10],"days":b[1][852],"eras":b[1][11],"dayPeriods":b[0][1910]},{"months":b[1][12],"days":b[1][852],"eras":b[1][13],"dayPeriods":b[0][1910]},{"months":b[1][14],"days":b[1][852],"eras":b[1][15],"dayPeriods":b[0][1910]},{"months":b[1][851],"days":b[1][852],"eras":b[1][16],"dayPeriods":b[0][1910]},{"months":b[1][17],"days":b[1][852],"eras":b[1][18],"dayPeriods":b[0][1910]},{"months":b[1][851],"days":b[1][852],"eras":b[1][19],"dayPeriods":b[0][1910]},{"months":b[1][854],"days":b[1][855],"eras":b[1][3],"dayPeriods":b[0][1919]},{"months":b[1][4],"days":b[1][855],"dayPeriods":b[0][1919]},{"months":b[1][5],"days":b[1][855],"eras":b[1][6],"dayPeriods":b[0][1919]},{"months":b[1][7],"days":b[1][855],"eras":b[1][6],"dayPeriods":b[0][1919]},{"months":b[1][7],"days":b[1][855],"eras":b[1][8],"dayPeriods":b[0][1919]},{"months":b[1][4],"days":b[1][855],"eras":b[1][6],"dayPeriods":b[0][1919]},{"months":b[1][854],"days":b[1][855],"eras":b[1][856],"dayPeriods":b[0][1919]},{"months":b[1][10],"days":b[1][855],"eras":b[1][11],"dayPeriods":b[0][1919]},{"months":b[1][12],"days":b[1][855],"eras":b[1][13],"dayPeriods":b[0][1919]},{"months":b[1][14],"days":b[1][855],"eras":b[1][15],"dayPeriods":b[0][1919]},{"months":b[1][854],"days":b[1][855],"eras":b[1][16],"dayPeriods":b[0][1919]},{"months":b[1][17],"days":b[1][855],"eras":b[1][18],"dayPeriods":b[0][1919]},{"months":b[1][854],"days":b[1][855],"eras":b[1][19],"dayPeriods":b[0][1919]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][593],"currencies":b[0][1922]},{"months":b[1][857],"days":b[1][858],"eras":b[1][3],"dayPeriods":b[0][1919]},{"months":b[1][4],"days":b[1][858],"dayPeriods":b[0][1919]},{"months":b[1][5],"days":b[1][858],"eras":b[1][6],"dayPeriods":b[0][1919]},{"months":b[1][7],"days":b[1][858],"eras":b[1][6],"dayPeriods":b[0][1919]},{"months":b[1][7],"days":b[1][858],"eras":b[1][8],"dayPeriods":b[0][1919]},{"months":b[1][4],"days":b[1][858],"eras":b[1][6],"dayPeriods":b[0][1919]},{"months":b[1][857],"days":b[1][858],"eras":b[1][856],"dayPeriods":b[0][1919]},{"months":b[1][10],"days":b[1][858],"eras":b[1][11],"dayPeriods":b[0][1919]},{"months":b[1][12],"days":b[1][858],"eras":b[1][13],"dayPeriods":b[0][1919]},{"months":b[1][14],"days":b[1][858],"eras":b[1][15],"dayPeriods":b[0][1919]},{"months":b[1][857],"days":b[1][858],"eras":b[1][16],"dayPeriods":b[0][1919]},{"months":b[1][17],"days":b[1][858],"eras":b[1][18],"dayPeriods":b[0][1919]},{"months":b[1][857],"days":b[1][858],"eras":b[1][19],"dayPeriods":b[0][1919]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][593],"currencies":b[0][1926]},{"months":b[1][860],"days":b[1][861],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][861],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][861],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][861],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][861],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][861],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][860],"days":b[1][861],"eras":b[1][862],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][861],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][861],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][861],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][860],"days":b[1][861],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][861],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][860],"days":b[1][861],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][34],"symbols":b[1][87],"currencies":b[0][1525]},{"months":b[1][208],"days":b[1][863],"eras":b[1][3],"dayPeriods":b[0][1227]},{"months":b[1][4],"days":b[1][863],"dayPeriods":b[0][1227]},{"months":b[1][5],"days":b[1][863],"eras":b[1][6],"dayPeriods":b[0][1227]},{"months":b[1][7],"days":b[1][863],"eras":b[1][6],"dayPeriods":b[0][1227]},{"months":b[1][7],"days":b[1][863],"eras":b[1][8],"dayPeriods":b[0][1227]},{"months":b[1][4],"days":b[1][863],"eras":b[1][6],"dayPeriods":b[0][1227]},{"months":b[1][208],"days":b[1][863],"eras":b[1][210],"dayPeriods":b[0][1227]},{"months":b[1][10],"days":b[1][863],"eras":b[1][11],"dayPeriods":b[0][1227]},{"months":b[1][12],"days":b[1][863],"eras":b[1][13],"dayPeriods":b[0][1227]},{"months":b[1][14],"days":b[1][863],"eras":b[1][15],"dayPeriods":b[0][1227]},{"months":b[1][208],"days":b[1][863],"eras":b[1][16],"dayPeriods":b[0][1227]},{"months":b[1][17],"days":b[1][863],"eras":b[1][18],"dayPeriods":b[0][1227]},{"months":b[1][208],"days":b[1][863],"eras":b[1][19],"dayPeriods":b[0][1227]},{"months":b[1][865],"days":b[1][866],"eras":b[1][3],"dayPeriods":b[0][1944]},{"months":b[1][4],"days":b[1][866],"dayPeriods":b[0][1944]},{"months":b[1][5],"days":b[1][866],"eras":b[1][6],"dayPeriods":b[0][1944]},{"months":b[1][7],"days":b[1][866],"eras":b[1][6],"dayPeriods":b[0][1944]},{"months":b[1][7],"days":b[1][866],"eras":b[1][8],"dayPeriods":b[0][1944]},{"months":b[1][4],"days":b[1][866],"eras":b[1][6],"dayPeriods":b[0][1944]},{"months":b[1][865],"days":b[1][866],"eras":b[1][867],"dayPeriods":b[0][1944]},{"months":b[1][10],"days":b[1][866],"eras":b[1][11],"dayPeriods":b[0][1944]},{"months":b[1][12],"days":b[1][866],"eras":b[1][13],"dayPeriods":b[0][1944]},{"months":b[1][14],"days":b[1][866],"eras":b[1][15],"dayPeriods":b[0][1944]},{"months":b[1][865],"days":b[1][866],"eras":b[1][16],"dayPeriods":b[0][1944]},{"months":b[1][17],"days":b[1][866],"eras":b[1][18],"dayPeriods":b[0][1944]},{"months":b[1][865],"days":b[1][866],"eras":b[1][19],"dayPeriods":b[0][1944]},{"nu":b[0][33],"patterns":b[1][633],"symbols":b[1][87],"currencies":b[0][72]},{"months":b[1][868],"days":b[1][869],"eras":b[1][3],"dayPeriods":b[0][1952]},{"months":b[1][4],"days":b[1][869],"dayPeriods":b[0][1952]},{"months":b[1][5],"days":b[1][869],"eras":b[1][6],"dayPeriods":b[0][1952]},{"months":b[1][7],"days":b[1][869],"eras":b[1][6],"dayPeriods":b[0][1952]},{"months":b[1][7],"days":b[1][869],"eras":b[1][8],"dayPeriods":b[0][1952]},{"months":b[1][4],"days":b[1][869],"eras":b[1][6],"dayPeriods":b[0][1952]},{"months":b[1][868],"days":b[1][869],"eras":b[1][870],"dayPeriods":b[0][1952]},{"months":b[1][10],"days":b[1][869],"eras":b[1][11],"dayPeriods":b[0][1952]},{"months":b[1][12],"days":b[1][869],"eras":b[1][13],"dayPeriods":b[0][1952]},{"months":b[1][14],"days":b[1][869],"eras":b[1][15],"dayPeriods":b[0][1952]},{"months":b[1][868],"days":b[1][869],"eras":b[1][16],"dayPeriods":b[0][1952]},{"months":b[1][17],"days":b[1][869],"eras":b[1][18],"dayPeriods":b[0][1952]},{"months":b[1][868],"days":b[1][869],"eras":b[1][19],"dayPeriods":b[0][1952]},{"months":b[1][871],"days":b[1][872],"eras":b[1][3],"dayPeriods":b[0][1960]},{"months":b[1][4],"days":b[1][872],"dayPeriods":b[0][1960]},{"months":b[1][5],"days":b[1][872],"eras":b[1][6],"dayPeriods":b[0][1960]},{"months":b[1][7],"days":b[1][872],"eras":b[1][6],"dayPeriods":b[0][1960]},{"months":b[1][7],"days":b[1][872],"eras":b[1][8],"dayPeriods":b[0][1960]},{"months":b[1][4],"days":b[1][872],"eras":b[1][6],"dayPeriods":b[0][1960]},{"months":b[1][871],"days":b[1][872],"eras":b[1][873],"dayPeriods":b[0][1960]},{"months":b[1][10],"days":b[1][872],"eras":b[1][11],"dayPeriods":b[0][1960]},{"months":b[1][12],"days":b[1][872],"eras":b[1][13],"dayPeriods":b[0][1960]},{"months":b[1][14],"days":b[1][872],"eras":b[1][15],"dayPeriods":b[0][1960]},{"months":b[1][871],"days":b[1][872],"eras":b[1][16],"dayPeriods":b[0][1960]},{"months":b[1][17],"days":b[1][872],"eras":b[1][18],"dayPeriods":b[0][1960]},{"months":b[1][871],"days":b[1][872],"eras":b[1][19],"dayPeriods":b[0][1960]},{"months":b[1][875],"days":b[1][876],"eras":b[1][3],"dayPeriods":b[0][1971]},{"months":b[1][4],"days":b[1][876],"dayPeriods":b[0][1971]},{"months":b[1][5],"days":b[1][876],"eras":b[1][6],"dayPeriods":b[0][1971]},{"months":b[1][7],"days":b[1][876],"eras":b[1][6],"dayPeriods":b[0][1971]},{"months":b[1][7],"days":b[1][876],"eras":b[1][8],"dayPeriods":b[0][1971]},{"months":b[1][4],"days":b[1][876],"eras":b[1][6],"dayPeriods":b[0][1971]},{"months":b[1][875],"days":b[1][876],"eras":b[1][877],"dayPeriods":b[0][1971]},{"months":b[1][10],"days":b[1][876],"eras":b[1][11],"dayPeriods":b[0][1971]},{"months":b[1][12],"days":b[1][876],"eras":b[1][13],"dayPeriods":b[0][1971]},{"months":b[1][14],"days":b[1][876],"eras":b[1][15],"dayPeriods":b[0][1971]},{"months":b[1][875],"days":b[1][876],"eras":b[1][16],"dayPeriods":b[0][1971]},{"months":b[1][17],"days":b[1][876],"eras":b[1][18],"dayPeriods":b[0][1971]},{"months":b[1][875],"days":b[1][876],"eras":b[1][19],"dayPeriods":b[0][1971]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][1974]},{"months":b[1][879],"days":b[1][880],"eras":b[1][3],"dayPeriods":b[0][1982]},{"months":b[1][4],"days":b[1][880],"dayPeriods":b[0][1982]},{"months":b[1][5],"days":b[1][880],"eras":b[1][6],"dayPeriods":b[0][1982]},{"months":b[1][7],"days":b[1][880],"eras":b[1][6],"dayPeriods":b[0][1982]},{"months":b[1][7],"days":b[1][880],"eras":b[1][8],"dayPeriods":b[0][1982]},{"months":b[1][4],"days":b[1][880],"eras":b[1][6],"dayPeriods":b[0][1982]},{"months":b[1][879],"days":b[1][880],"eras":b[1][881],"dayPeriods":b[0][1982]},{"months":b[1][10],"days":b[1][880],"eras":b[1][11],"dayPeriods":b[0][1982]},{"months":b[1][12],"days":b[1][880],"eras":b[1][13],"dayPeriods":b[0][1982]},{"months":b[1][14],"days":b[1][880],"eras":b[1][15],"dayPeriods":b[0][1982]},{"months":b[1][879],"days":b[1][880],"eras":b[1][16],"dayPeriods":b[0][1982]},{"months":b[1][17],"days":b[1][880],"eras":b[1][18],"dayPeriods":b[0][1982]},{"months":b[1][879],"days":b[1][880],"eras":b[1][19],"dayPeriods":b[0][1982]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][28],"currencies":b[0][1985]},{"months":b[1][883],"days":b[1][884],"eras":b[1][3],"dayPeriods":b[0][1993]},{"months":b[1][4],"days":b[1][884],"dayPeriods":b[0][1993]},{"months":b[1][5],"days":b[1][884],"eras":b[1][6],"dayPeriods":b[0][1993]},{"months":b[1][7],"days":b[1][884],"eras":b[1][6],"dayPeriods":b[0][1993]},{"months":b[1][7],"days":b[1][884],"eras":b[1][8],"dayPeriods":b[0][1993]},{"months":b[1][4],"days":b[1][884],"eras":b[1][6],"dayPeriods":b[0][1993]},{"months":b[1][883],"days":b[1][884],"eras":b[1][885],"dayPeriods":b[0][1993]},{"months":b[1][10],"days":b[1][884],"eras":b[1][11],"dayPeriods":b[0][1993]},{"months":b[1][12],"days":b[1][884],"eras":b[1][13],"dayPeriods":b[0][1993]},{"months":b[1][14],"days":b[1][884],"eras":b[1][15],"dayPeriods":b[0][1993]},{"months":b[1][883],"days":b[1][884],"eras":b[1][16],"dayPeriods":b[0][1993]},{"months":b[1][17],"days":b[1][884],"eras":b[1][18],"dayPeriods":b[0][1993]},{"months":b[1][883],"days":b[1][884],"eras":b[1][19],"dayPeriods":b[0][1993]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][1996]},{"months":b[1][4],"days":b[1][886],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][886],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][886],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][886],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][886],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][886],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][886],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][886],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][886],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][886],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][886],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][886],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][886],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][887],"currencies":b[0][72]},{"months":b[1][888],"days":b[1][889],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][889],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][889],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][889],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][889],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][889],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][888],"days":b[1][889],"eras":b[1][890],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][889],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][889],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][889],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][888],"days":b[1][889],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][889],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][888],"days":b[1][889],"eras":b[1][19],"dayPeriods":b[0][175]},{"months":b[1][892],"days":b[1][893],"eras":b[1][3],"dayPeriods":b[0][2014]},{"months":b[1][4],"days":b[1][893],"dayPeriods":b[0][2014]},{"months":b[1][5],"days":b[1][893],"eras":b[1][6],"dayPeriods":b[0][2014]},{"months":b[1][7],"days":b[1][893],"eras":b[1][6],"dayPeriods":b[0][2014]},{"months":b[1][7],"days":b[1][893],"eras":b[1][8],"dayPeriods":b[0][2014]},{"months":b[1][4],"days":b[1][893],"eras":b[1][6],"dayPeriods":b[0][2014]},{"months":b[1][892],"days":b[1][893],"eras":b[1][894],"dayPeriods":b[0][2014]},{"months":b[1][10],"days":b[1][893],"eras":b[1][11],"dayPeriods":b[0][2014]},{"months":b[1][12],"days":b[1][893],"eras":b[1][13],"dayPeriods":b[0][2014]},{"months":b[1][14],"days":b[1][893],"eras":b[1][15],"dayPeriods":b[0][2014]},{"months":b[1][892],"days":b[1][893],"eras":b[1][16],"dayPeriods":b[0][2014]},{"months":b[1][17],"days":b[1][893],"eras":b[1][18],"dayPeriods":b[0][2014]},{"months":b[1][892],"days":b[1][893],"eras":b[1][19],"dayPeriods":b[0][2014]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][2017]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][2018]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][2019]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][2020]},{"months":b[1][896],"days":b[1][897],"eras":b[1][3],"dayPeriods":b[0][2029]},{"months":b[1][4],"days":b[1][897],"dayPeriods":b[0][2029]},{"months":b[1][5],"days":b[1][897],"eras":b[1][6],"dayPeriods":b[0][2029]},{"months":b[1][7],"days":b[1][897],"eras":b[1][6],"dayPeriods":b[0][2029]},{"months":b[1][7],"days":b[1][897],"eras":b[1][8],"dayPeriods":b[0][2029]},{"months":b[1][4],"days":b[1][897],"eras":b[1][6],"dayPeriods":b[0][2029]},{"months":b[1][896],"days":b[1][897],"eras":b[1][898],"dayPeriods":b[0][2029]},{"months":b[1][10],"days":b[1][897],"eras":b[1][11],"dayPeriods":b[0][2029]},{"months":b[1][12],"days":b[1][897],"eras":b[1][13],"dayPeriods":b[0][2029]},{"months":b[1][14],"days":b[1][897],"eras":b[1][15],"dayPeriods":b[0][2029]},{"months":b[1][896],"days":b[1][897],"eras":b[1][16],"dayPeriods":b[0][2029]},{"months":b[1][17],"days":b[1][897],"eras":b[1][18],"dayPeriods":b[0][2029]},{"months":b[1][896],"days":b[1][897],"eras":b[1][19],"dayPeriods":b[0][2029]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][2033]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][28],"currencies":b[0][2034]},{"months":b[1][148],"days":b[1][149],"eras":b[1][150],"dayPeriods":b[0][2038]},{"months":b[1][4],"days":b[1][149],"dayPeriods":b[0][2038]},{"months":b[1][151],"days":b[1][149],"eras":b[1][6],"dayPeriods":b[0][2038]},{"months":b[1][152],"days":b[1][149],"eras":b[1][6],"dayPeriods":b[0][2038]},{"months":b[1][152],"days":b[1][149],"eras":b[1][8],"dayPeriods":b[0][2038]},{"months":b[1][4],"days":b[1][149],"eras":b[1][6],"dayPeriods":b[0][2038]},{"months":b[1][148],"days":b[1][149],"eras":b[1][900],"dayPeriods":b[0][2038]},{"months":b[1][154],"days":b[1][149],"eras":b[1][11],"dayPeriods":b[0][2038]},{"months":b[1][155],"days":b[1][149],"eras":b[1][156],"dayPeriods":b[0][2038]},{"months":b[1][157],"days":b[1][149],"eras":b[1][158],"dayPeriods":b[0][2038]},{"months":b[1][148],"days":b[1][149],"eras":b[1][159],"dayPeriods":b[0][2038]},{"months":b[1][160],"days":b[1][149],"eras":b[1][161],"dayPeriods":b[0][2038]},{"months":b[1][148],"days":b[1][149],"eras":b[1][162],"dayPeriods":b[0][2038]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][2040]},{"months":b[1][902],"days":b[1][903],"eras":b[1][150],"dayPeriods":b[0][2038]},{"months":b[1][4],"days":b[1][903],"dayPeriods":b[0][2038]},{"months":b[1][151],"days":b[1][903],"eras":b[1][6],"dayPeriods":b[0][2038]},{"months":b[1][152],"days":b[1][903],"eras":b[1][6],"dayPeriods":b[0][2038]},{"months":b[1][152],"days":b[1][903],"eras":b[1][8],"dayPeriods":b[0][2038]},{"months":b[1][4],"days":b[1][903],"eras":b[1][6],"dayPeriods":b[0][2038]},{"months":b[1][902],"days":b[1][903],"eras":b[1][900],"dayPeriods":b[0][2038]},{"months":b[1][154],"days":b[1][903],"eras":b[1][11],"dayPeriods":b[0][2038]},{"months":b[1][155],"days":b[1][903],"eras":b[1][156],"dayPeriods":b[0][2038]},{"months":b[1][157],"days":b[1][903],"eras":b[1][158],"dayPeriods":b[0][2038]},{"months":b[1][902],"days":b[1][903],"eras":b[1][159],"dayPeriods":b[0][2038]},{"months":b[1][160],"days":b[1][903],"eras":b[1][161],"dayPeriods":b[0][2038]},{"months":b[1][902],"days":b[1][903],"eras":b[1][162],"dayPeriods":b[0][2038]},{"months":b[1][905],"days":b[1][906],"eras":b[1][3],"dayPeriods":b[0][2049]},{"months":b[1][4],"days":b[1][906],"dayPeriods":b[0][2049]},{"months":b[1][907],"days":b[1][906],"eras":b[1][6],"dayPeriods":b[0][2049]},{"months":b[1][908],"days":b[1][906],"eras":b[1][6],"dayPeriods":b[0][2049]},{"months":b[1][908],"days":b[1][906],"eras":b[1][8],"dayPeriods":b[0][2049]},{"months":b[1][4],"days":b[1][906],"eras":b[1][6],"dayPeriods":b[0][2049]},{"months":b[1][905],"days":b[1][906],"eras":b[1][909],"dayPeriods":b[0][2049]},{"months":b[1][910],"days":b[1][906],"eras":b[1][11],"dayPeriods":b[0][2049]},{"months":b[1][911],"days":b[1][906],"eras":b[1][254],"dayPeriods":b[0][2049]},{"months":b[1][912],"days":b[1][906],"eras":b[1][15],"dayPeriods":b[0][2049]},{"months":b[1][905],"days":b[1][906],"eras":b[1][913],"dayPeriods":b[0][2049]},{"months":b[1][914],"days":b[1][906],"eras":b[1][18],"dayPeriods":b[0][2049]},{"months":b[1][905],"days":b[1][906],"eras":b[1][915],"dayPeriods":b[0][2049]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][2061]},{"months":b[1][916],"days":b[1][917],"eras":b[1][3],"dayPeriods":b[0][2049]},{"months":b[1][4],"days":b[1][917],"dayPeriods":b[0][2049]},{"months":b[1][907],"days":b[1][917],"eras":b[1][6],"dayPeriods":b[0][2049]},{"months":b[1][908],"days":b[1][917],"eras":b[1][6],"dayPeriods":b[0][2049]},{"months":b[1][908],"days":b[1][917],"eras":b[1][8],"dayPeriods":b[0][2049]},{"months":b[1][4],"days":b[1][917],"eras":b[1][6],"dayPeriods":b[0][2049]},{"months":b[1][916],"days":b[1][917],"eras":b[1][909],"dayPeriods":b[0][2049]},{"months":b[1][910],"days":b[1][917],"eras":b[1][11],"dayPeriods":b[0][2049]},{"months":b[1][911],"days":b[1][917],"eras":b[1][254],"dayPeriods":b[0][2049]},{"months":b[1][912],"days":b[1][917],"eras":b[1][15],"dayPeriods":b[0][2049]},{"months":b[1][916],"days":b[1][917],"eras":b[1][913],"dayPeriods":b[0][2049]},{"months":b[1][914],"days":b[1][917],"eras":b[1][18],"dayPeriods":b[0][2049]},{"months":b[1][916],"days":b[1][917],"eras":b[1][915],"dayPeriods":b[0][2049]},{"months":b[1][918],"days":b[1][919],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][919],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][919],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][919],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][919],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][919],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][918],"days":b[1][919],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][919],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][919],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][919],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][918],"days":b[1][919],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][919],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][918],"days":b[1][919],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][28],"currencies":b[0][2069]},{"months":b[1][22],"days":b[1][920],"eras":b[1][3],"dayPeriods":b[0][11]},{"months":b[1][4],"days":b[1][920],"dayPeriods":b[0][11]},{"months":b[1][5],"days":b[1][920],"eras":b[1][6],"dayPeriods":b[0][11]},{"months":b[1][7],"days":b[1][920],"eras":b[1][6],"dayPeriods":b[0][11]},{"months":b[1][7],"days":b[1][920],"eras":b[1][8],"dayPeriods":b[0][11]},{"months":b[1][4],"days":b[1][920],"eras":b[1][6],"dayPeriods":b[0][11]},{"months":b[1][22],"days":b[1][920],"eras":b[1][9],"dayPeriods":b[0][11]},{"months":b[1][10],"days":b[1][920],"eras":b[1][11],"dayPeriods":b[0][11]},{"months":b[1][12],"days":b[1][920],"eras":b[1][13],"dayPeriods":b[0][11]},{"months":b[1][14],"days":b[1][920],"eras":b[1][15],"dayPeriods":b[0][11]},{"months":b[1][22],"days":b[1][920],"eras":b[1][16],"dayPeriods":b[0][11]},{"months":b[1][17],"days":b[1][920],"eras":b[1][18],"dayPeriods":b[0][11]},{"months":b[1][22],"days":b[1][920],"eras":b[1][19],"dayPeriods":b[0][11]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][2073]},{"months":b[1][922],"days":b[1][923],"eras":b[1][3],"dayPeriods":b[0][2079]},{"months":b[1][4],"days":b[1][923],"dayPeriods":b[0][2079]},{"months":b[1][924],"days":b[1][923],"eras":b[1][6],"dayPeriods":b[0][2079]},{"months":b[1][925],"days":b[1][923],"eras":b[1][6],"dayPeriods":b[0][2079]},{"months":b[1][925],"days":b[1][923],"eras":b[1][8],"dayPeriods":b[0][2079]},{"months":b[1][4],"days":b[1][923],"eras":b[1][6],"dayPeriods":b[0][2079]},{"months":b[1][922],"days":b[1][923],"eras":b[1][926],"dayPeriods":b[0][2079]},{"months":b[1][927],"days":b[1][923],"eras":b[1][11],"dayPeriods":b[0][2079]},{"months":b[1][928],"days":b[1][923],"eras":b[1][929],"dayPeriods":b[0][2079]},{"months":b[1][930],"days":b[1][923],"eras":b[1][15],"dayPeriods":b[0][2079]},{"months":b[1][922],"days":b[1][923],"eras":b[1][931],"dayPeriods":b[0][2079]},{"months":b[1][932],"days":b[1][923],"eras":b[1][18],"dayPeriods":b[0][2079]},{"months":b[1][922],"days":b[1][923],"eras":b[1][933],"dayPeriods":b[0][2079]},{"nu":b[0][33],"patterns":b[1][99],"symbols":b[1][593],"currencies":b[0][2088]},{"months":b[1][922],"days":b[1][923],"eras":b[1][935],"dayPeriods":b[0][2079]},{"months":b[1][937],"days":b[1][938],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][938],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][938],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][938],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][938],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][938],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][937],"days":b[1][938],"eras":b[1][939],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][938],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][938],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][938],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][937],"days":b[1][938],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][938],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][937],"days":b[1][938],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][2092]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][2093]},{"months":b[1][940],"days":b[1][941],"eras":b[1][3],"dayPeriods":b[0][2100]},{"months":b[1][4],"days":b[1][941],"dayPeriods":b[0][2100]},{"months":b[1][5],"days":b[1][941],"eras":b[1][6],"dayPeriods":b[0][2100]},{"months":b[1][7],"days":b[1][941],"eras":b[1][6],"dayPeriods":b[0][2100]},{"months":b[1][7],"days":b[1][941],"eras":b[1][8],"dayPeriods":b[0][2100]},{"months":b[1][4],"days":b[1][941],"eras":b[1][6],"dayPeriods":b[0][2100]},{"months":b[1][940],"days":b[1][941],"eras":b[1][942],"dayPeriods":b[0][2100]},{"months":b[1][10],"days":b[1][941],"eras":b[1][11],"dayPeriods":b[0][2100]},{"months":b[1][12],"days":b[1][941],"eras":b[1][13],"dayPeriods":b[0][2100]},{"months":b[1][14],"days":b[1][941],"eras":b[1][15],"dayPeriods":b[0][2100]},{"months":b[1][940],"days":b[1][941],"eras":b[1][16],"dayPeriods":b[0][2100]},{"months":b[1][17],"days":b[1][941],"eras":b[1][18],"dayPeriods":b[0][2100]},{"months":b[1][940],"days":b[1][941],"eras":b[1][19],"dayPeriods":b[0][2100]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][87],"currencies":b[0][1402]},{"months":b[1][944],"days":b[1][945],"eras":b[1][3],"dayPeriods":b[0][2110]},{"months":b[1][946],"days":b[1][945],"dayPeriods":b[0][2110]},{"months":b[1][5],"days":b[1][945],"eras":b[1][6],"dayPeriods":b[0][2110]},{"months":b[1][7],"days":b[1][945],"eras":b[1][6],"dayPeriods":b[0][2110]},{"months":b[1][7],"days":b[1][945],"eras":b[1][8],"dayPeriods":b[0][2110]},{"months":b[1][4],"days":b[1][945],"eras":b[1][6],"dayPeriods":b[0][2110]},{"months":b[1][944],"days":b[1][945],"eras":b[1][947],"dayPeriods":b[0][2110]},{"months":b[1][10],"days":b[1][945],"eras":b[1][11],"dayPeriods":b[0][2110]},{"months":b[1][12],"days":b[1][945],"eras":b[1][13],"dayPeriods":b[0][2110]},{"months":b[1][14],"days":b[1][945],"eras":b[1][15],"dayPeriods":b[0][2110]},{"months":b[1][944],"days":b[1][945],"eras":b[1][16],"dayPeriods":b[0][2110]},{"months":b[1][17],"days":b[1][945],"eras":b[1][18],"dayPeriods":b[0][2110]},{"months":b[1][944],"days":b[1][945],"eras":b[1][19],"dayPeriods":b[0][2110]},{"nu":b[0][33],"patterns":b[1][76],"symbols":b[1][948],"currencies":b[0][177]},{"nu":b[0][33],"patterns":b[1][76],"symbols":b[1][948],"currencies":b[0][2115]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][948],"currencies":b[0][2116]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][948],"currencies":b[0][2117]},{"months":b[1][950],"days":b[1][951],"eras":b[1][3],"dayPeriods":b[0][2126]},{"months":b[1][4],"days":b[1][951],"dayPeriods":b[0][2126]},{"months":b[1][5],"days":b[1][951],"eras":b[1][6],"dayPeriods":b[0][2126]},{"months":b[1][7],"days":b[1][951],"eras":b[1][6],"dayPeriods":b[0][2126]},{"months":b[1][7],"days":b[1][951],"eras":b[1][8],"dayPeriods":b[0][2126]},{"months":b[1][4],"days":b[1][951],"eras":b[1][6],"dayPeriods":b[0][2126]},{"months":b[1][950],"days":b[1][951],"eras":b[1][952],"dayPeriods":b[0][2126]},{"months":b[1][10],"days":b[1][951],"eras":b[1][11],"dayPeriods":b[0][2126]},{"months":b[1][953],"days":b[1][951],"eras":b[1][954],"dayPeriods":b[0][2126]},{"months":b[1][14],"days":b[1][951],"eras":b[1][15],"dayPeriods":b[0][2126]},{"months":b[1][950],"days":b[1][951],"eras":b[1][16],"dayPeriods":b[0][2126]},{"months":b[1][17],"days":b[1][951],"eras":b[1][18],"dayPeriods":b[0][2126]},{"months":b[1][950],"days":b[1][951],"eras":b[1][19],"dayPeriods":b[0][2126]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][955],"currencies":b[0][925]},{"months":b[1][956],"days":b[1][957],"eras":b[1][3],"dayPeriods":b[0][2138]},{"months":b[1][4],"days":b[1][957],"dayPeriods":b[0][2138]},{"months":b[1][5],"days":b[1][957],"eras":b[1][6],"dayPeriods":b[0][2138]},{"months":b[1][7],"days":b[1][957],"eras":b[1][6],"dayPeriods":b[0][2138]},{"months":b[1][7],"days":b[1][957],"eras":b[1][8],"dayPeriods":b[0][2138]},{"months":b[1][4],"days":b[1][957],"eras":b[1][6],"dayPeriods":b[0][2138]},{"months":b[1][956],"days":b[1][957],"eras":b[1][849],"dayPeriods":b[0][2138]},{"months":b[1][10],"days":b[1][957],"eras":b[1][11],"dayPeriods":b[0][2138]},{"months":b[1][12],"days":b[1][957],"eras":b[1][13],"dayPeriods":b[0][2138]},{"months":b[1][14],"days":b[1][957],"eras":b[1][15],"dayPeriods":b[0][2138]},{"months":b[1][956],"days":b[1][957],"eras":b[1][16],"dayPeriods":b[0][2138]},{"months":b[1][17],"days":b[1][957],"eras":b[1][18],"dayPeriods":b[0][2138]},{"months":b[1][956],"days":b[1][957],"eras":b[1][19],"dayPeriods":b[0][2138]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][21],"currencies":b[0][2139]},{"months":b[1][959],"days":b[1][960],"eras":b[1][961],"dayPeriods":b[0][2150]},{"months":b[1][173],"days":b[1][960],"dayPeriods":b[0][2150]},{"months":b[1][962],"days":b[1][960],"eras":b[1][6],"dayPeriods":b[0][2150]},{"months":b[1][963],"days":b[1][960],"eras":b[1][6],"dayPeriods":b[0][2150]},{"months":b[1][963],"days":b[1][960],"eras":b[1][8],"dayPeriods":b[0][2150]},{"months":b[1][4],"days":b[1][960],"eras":b[1][6],"dayPeriods":b[0][2150]},{"months":b[1][959],"days":b[1][960],"eras":b[1][964],"dayPeriods":b[0][2150]},{"months":b[1][965],"days":b[1][960],"eras":b[1][966],"dayPeriods":b[0][2150]},{"months":b[1][967],"days":b[1][960],"eras":b[1][968],"dayPeriods":b[0][2150]},{"months":b[1][969],"days":b[1][960],"eras":b[1][970],"dayPeriods":b[0][2150]},{"months":b[1][959],"days":b[1][960],"eras":b[1][971],"dayPeriods":b[0][2150]},{"months":b[1][972],"days":b[1][960],"eras":b[1][973],"dayPeriods":b[0][2150]},{"months":b[1][959],"days":b[1][960],"eras":b[1][974],"dayPeriods":b[0][2150]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][975],"currencies":b[0][2168]},{"months":b[1][977],"days":b[1][978],"eras":b[1][3],"dayPeriods":b[0][2174]},{"months":b[1][4],"days":b[1][978],"dayPeriods":b[0][2174]},{"months":b[1][5],"days":b[1][978],"eras":b[1][6],"dayPeriods":b[0][2174]},{"months":b[1][7],"days":b[1][978],"eras":b[1][6],"dayPeriods":b[0][2174]},{"months":b[1][7],"days":b[1][978],"eras":b[1][8],"dayPeriods":b[0][2174]},{"months":b[1][4],"days":b[1][978],"eras":b[1][6],"dayPeriods":b[0][2174]},{"months":b[1][977],"days":b[1][978],"eras":b[1][979],"dayPeriods":b[0][2174]},{"months":b[1][10],"days":b[1][978],"eras":b[1][11],"dayPeriods":b[0][2174]},{"months":b[1][12],"days":b[1][978],"eras":b[1][13],"dayPeriods":b[0][2174]},{"months":b[1][14],"days":b[1][978],"eras":b[1][15],"dayPeriods":b[0][2174]},{"months":b[1][977],"days":b[1][978],"eras":b[1][16],"dayPeriods":b[0][2174]},{"months":b[1][17],"days":b[1][978],"eras":b[1][18],"dayPeriods":b[0][2174]},{"months":b[1][977],"days":b[1][978],"eras":b[1][19],"dayPeriods":b[0][2174]},{"months":b[1][981],"days":b[1][982],"eras":b[1][3],"dayPeriods":b[0][2174]},{"months":b[1][4],"days":b[1][982],"dayPeriods":b[0][2174]},{"months":b[1][5],"days":b[1][982],"eras":b[1][6],"dayPeriods":b[0][2174]},{"months":b[1][7],"days":b[1][982],"eras":b[1][6],"dayPeriods":b[0][2174]},{"months":b[1][7],"days":b[1][982],"eras":b[1][8],"dayPeriods":b[0][2174]},{"months":b[1][4],"days":b[1][982],"eras":b[1][6],"dayPeriods":b[0][2174]},{"months":b[1][981],"days":b[1][982],"eras":b[1][979],"dayPeriods":b[0][2174]},{"months":b[1][10],"days":b[1][982],"eras":b[1][11],"dayPeriods":b[0][2174]},{"months":b[1][12],"days":b[1][982],"eras":b[1][13],"dayPeriods":b[0][2174]},{"months":b[1][14],"days":b[1][982],"eras":b[1][15],"dayPeriods":b[0][2174]},{"months":b[1][981],"days":b[1][982],"eras":b[1][16],"dayPeriods":b[0][2174]},{"months":b[1][17],"days":b[1][982],"eras":b[1][18],"dayPeriods":b[0][2174]},{"months":b[1][981],"days":b[1][982],"eras":b[1][19],"dayPeriods":b[0][2174]},{"months":b[1][983],"days":b[1][984],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][984],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][984],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][984],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][984],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][984],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][983],"days":b[1][984],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][984],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][984],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][984],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][983],"days":b[1][984],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][984],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][983],"days":b[1][984],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][211],"currencies":b[0][2183]},{"months":b[1][986],"days":b[1][987],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][987],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][987],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][987],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][987],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][987],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][986],"days":b[1][987],"eras":b[1][988],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][987],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][987],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][987],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][986],"days":b[1][987],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][987],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][986],"days":b[1][987],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][989],"currencies":b[0][2195]},{"months":b[1][991],"days":b[1][992],"eras":b[1][3],"dayPeriods":b[0][2204]},{"months":b[1][4],"days":b[1][992],"dayPeriods":b[0][2204]},{"months":b[1][993],"days":b[1][992],"eras":b[1][6],"dayPeriods":b[0][2204]},{"months":b[1][994],"days":b[1][992],"eras":b[1][6],"dayPeriods":b[0][2204]},{"months":b[1][994],"days":b[1][992],"eras":b[1][8],"dayPeriods":b[0][2204]},{"months":b[1][4],"days":b[1][992],"eras":b[1][6],"dayPeriods":b[0][2204]},{"months":b[1][991],"days":b[1][992],"eras":b[1][995],"dayPeriods":b[0][2204]},{"months":b[1][996],"days":b[1][992],"eras":b[1][11],"dayPeriods":b[0][2204]},{"months":b[1][12],"days":b[1][992],"eras":b[1][13],"dayPeriods":b[0][2204]},{"months":b[1][997],"days":b[1][992],"eras":b[1][998],"dayPeriods":b[0][2204]},{"months":b[1][991],"days":b[1][992],"eras":b[1][16],"dayPeriods":b[0][2204]},{"months":b[1][999],"days":b[1][992],"eras":b[1][18],"dayPeriods":b[0][2204]},{"months":b[1][991],"days":b[1][992],"eras":b[1][195],"dayPeriods":b[0][2204]},{"nu":b[0][33],"patterns":b[1][1000],"symbols":b[1][87],"currencies":b[0][2214]},{"months":b[1][1001],"days":b[1][1002],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1002],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][1002],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1002],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1002],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1002],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][1001],"days":b[1][1002],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][1002],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][1002],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][1002],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][1001],"days":b[1][1002],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][1002],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][1001],"days":b[1][1002],"eras":b[1][19],"dayPeriods":b[0][175]},{"months":b[1][208],"days":b[1][863],"eras":b[1][3],"dayPeriods":b[0][447]},{"months":b[1][4],"days":b[1][863],"dayPeriods":b[0][447]},{"months":b[1][5],"days":b[1][863],"eras":b[1][6],"dayPeriods":b[0][447]},{"months":b[1][7],"days":b[1][863],"eras":b[1][6],"dayPeriods":b[0][447]},{"months":b[1][7],"days":b[1][863],"eras":b[1][8],"dayPeriods":b[0][447]},{"months":b[1][4],"days":b[1][863],"eras":b[1][6],"dayPeriods":b[0][447]},{"months":b[1][208],"days":b[1][863],"eras":b[1][210],"dayPeriods":b[0][447]},{"months":b[1][10],"days":b[1][863],"eras":b[1][11],"dayPeriods":b[0][447]},{"months":b[1][12],"days":b[1][863],"eras":b[1][13],"dayPeriods":b[0][447]},{"months":b[1][14],"days":b[1][863],"eras":b[1][15],"dayPeriods":b[0][447]},{"months":b[1][208],"days":b[1][863],"eras":b[1][16],"dayPeriods":b[0][447]},{"months":b[1][17],"days":b[1][863],"eras":b[1][18],"dayPeriods":b[0][447]},{"months":b[1][208],"days":b[1][863],"eras":b[1][19],"dayPeriods":b[0][447]},{"months":b[1][1003],"days":b[1][1004],"eras":b[1][3],"dayPeriods":b[0][2225]},{"months":b[1][4],"days":b[1][1004],"dayPeriods":b[0][2225]},{"months":b[1][5],"days":b[1][1004],"eras":b[1][6],"dayPeriods":b[0][2225]},{"months":b[1][7],"days":b[1][1004],"eras":b[1][6],"dayPeriods":b[0][2225]},{"months":b[1][7],"days":b[1][1004],"eras":b[1][8],"dayPeriods":b[0][2225]},{"months":b[1][4],"days":b[1][1004],"eras":b[1][6],"dayPeriods":b[0][2225]},{"months":b[1][1003],"days":b[1][1004],"eras":b[1][1005],"dayPeriods":b[0][2225]},{"months":b[1][10],"days":b[1][1004],"eras":b[1][11],"dayPeriods":b[0][2225]},{"months":b[1][12],"days":b[1][1004],"eras":b[1][13],"dayPeriods":b[0][2225]},{"months":b[1][14],"days":b[1][1004],"eras":b[1][15],"dayPeriods":b[0][2225]},{"months":b[1][1003],"days":b[1][1004],"eras":b[1][16],"dayPeriods":b[0][2225]},{"months":b[1][17],"days":b[1][1004],"eras":b[1][18],"dayPeriods":b[0][2225]},{"months":b[1][1003],"days":b[1][1004],"eras":b[1][19],"dayPeriods":b[0][2225]},{"months":b[1][1007],"days":b[1][1008],"eras":b[1][1009],"dayPeriods":b[0][2236]},{"months":b[1][251],"days":b[1][1008],"dayPeriods":b[0][2236]},{"months":b[1][5],"days":b[1][1008],"eras":b[1][6],"dayPeriods":b[0][2236]},{"months":b[1][7],"days":b[1][1008],"eras":b[1][6],"dayPeriods":b[0][2236]},{"months":b[1][7],"days":b[1][1008],"eras":b[1][8],"dayPeriods":b[0][2236]},{"months":b[1][4],"days":b[1][1008],"eras":b[1][6],"dayPeriods":b[0][2236]},{"months":b[1][1007],"days":b[1][1008],"eras":b[1][1010],"dayPeriods":b[0][2236]},{"months":b[1][10],"days":b[1][1008],"eras":b[1][11],"dayPeriods":b[0][2236]},{"months":b[1][12],"days":b[1][1008],"eras":b[1][13],"dayPeriods":b[0][2236]},{"months":b[1][1011],"days":b[1][1008],"eras":b[1][1012],"dayPeriods":b[0][2236]},{"months":b[1][1007],"days":b[1][1008],"eras":b[1][16],"dayPeriods":b[0][2236]},{"months":b[1][17],"days":b[1][1008],"eras":b[1][18],"dayPeriods":b[0][2236]},{"months":b[1][1007],"days":b[1][1008],"eras":b[1][1013],"dayPeriods":b[0][2236]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][774],"currencies":b[0][2241]},{"months":b[1][1015],"days":b[1][1016],"eras":b[1][3],"dayPeriods":b[0][2250]},{"months":b[1][4],"days":b[1][1016],"dayPeriods":b[0][2250]},{"months":b[1][1017],"days":b[1][1016],"eras":b[1][6],"dayPeriods":b[0][2250]},{"months":b[1][1018],"days":b[1][1016],"eras":b[1][6],"dayPeriods":b[0][2250]},{"months":b[1][1018],"days":b[1][1016],"eras":b[1][8],"dayPeriods":b[0][2250]},{"months":b[1][4],"days":b[1][1016],"eras":b[1][6],"dayPeriods":b[0][2250]},{"months":b[1][1015],"days":b[1][1016],"eras":b[1][1019],"dayPeriods":b[0][2250]},{"months":b[1][1020],"days":b[1][1016],"eras":b[1][11],"dayPeriods":b[0][2250]},{"months":b[1][1021],"days":b[1][1016],"eras":b[1][13],"dayPeriods":b[0][2250]},{"months":b[1][1022],"days":b[1][1016],"eras":b[1][15],"dayPeriods":b[0][2250]},{"months":b[1][1015],"days":b[1][1016],"eras":b[1][1023],"dayPeriods":b[0][2250]},{"months":b[1][1024],"days":b[1][1016],"eras":b[1][18],"dayPeriods":b[0][2250]},{"months":b[1][1015],"days":b[1][1016],"eras":b[1][19],"dayPeriods":b[0][2250]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][1025],"currencies":b[0][2267]},{"months":b[1][1027],"days":b[1][1028],"eras":b[1][3],"dayPeriods":b[0][2272]},{"months":b[1][4],"days":b[1][1028],"dayPeriods":b[0][2272]},{"months":b[1][5],"days":b[1][1028],"eras":b[1][6],"dayPeriods":b[0][2272]},{"months":b[1][7],"days":b[1][1028],"eras":b[1][6],"dayPeriods":b[0][2272]},{"months":b[1][7],"days":b[1][1028],"eras":b[1][8],"dayPeriods":b[0][2272]},{"months":b[1][4],"days":b[1][1028],"eras":b[1][6],"dayPeriods":b[0][2272]},{"months":b[1][1027],"days":b[1][1028],"eras":b[1][1029],"dayPeriods":b[0][2272]},{"months":b[1][10],"days":b[1][1028],"eras":b[1][11],"dayPeriods":b[0][2272]},{"months":b[1][12],"days":b[1][1028],"eras":b[1][13],"dayPeriods":b[0][2272]},{"months":b[1][1030],"days":b[1][1028],"eras":b[1][1031],"dayPeriods":b[0][2272]},{"months":b[1][1027],"days":b[1][1028],"eras":b[1][16],"dayPeriods":b[0][2272]},{"months":b[1][17],"days":b[1][1028],"eras":b[1][18],"dayPeriods":b[0][2272]},{"months":b[1][1027],"days":b[1][1028],"eras":b[1][19],"dayPeriods":b[0][2272]},{"nu":b[0][763],"patterns":b[1][76],"symbols":b[1][1032],"currencies":b[0][925]},{"months":b[1][1027],"days":b[1][1033],"eras":b[1][3],"dayPeriods":b[0][2272]},{"months":b[1][4],"days":b[1][1033],"dayPeriods":b[0][2272]},{"months":b[1][5],"days":b[1][1033],"eras":b[1][6],"dayPeriods":b[0][2272]},{"months":b[1][7],"days":b[1][1033],"eras":b[1][6],"dayPeriods":b[0][2272]},{"months":b[1][7],"days":b[1][1033],"eras":b[1][8],"dayPeriods":b[0][2272]},{"months":b[1][4],"days":b[1][1033],"eras":b[1][6],"dayPeriods":b[0][2272]},{"months":b[1][1027],"days":b[1][1033],"eras":b[1][1034],"dayPeriods":b[0][2272]},{"months":b[1][10],"days":b[1][1033],"eras":b[1][11],"dayPeriods":b[0][2272]},{"months":b[1][12],"days":b[1][1033],"eras":b[1][13],"dayPeriods":b[0][2272]},{"months":b[1][1030],"days":b[1][1033],"eras":b[1][1031],"dayPeriods":b[0][2272]},{"months":b[1][1027],"days":b[1][1033],"eras":b[1][16],"dayPeriods":b[0][2272]},{"months":b[1][17],"days":b[1][1033],"eras":b[1][18],"dayPeriods":b[0][2272]},{"months":b[1][1027],"days":b[1][1033],"eras":b[1][19],"dayPeriods":b[0][2272]},{"nu":b[0][33],"patterns":b[1][76],"symbols":b[1][1032],"currencies":b[0][2280]},{"months":b[1][1036],"days":b[1][1037],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1037],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][1037],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1037],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1037],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1037],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][1036],"days":b[1][1037],"eras":b[1][793],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][1037],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][1037],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][1037],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][1036],"days":b[1][1037],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][1037],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][1036],"days":b[1][1037],"eras":b[1][19],"dayPeriods":b[0][175]},{"months":b[1][1038],"days":b[1][1039],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1039],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][1039],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1039],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1039],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1039],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][1038],"days":b[1][1039],"eras":b[1][1040],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][1039],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][1039],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][1041],"days":b[1][1039],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][1038],"days":b[1][1039],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][1039],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][1038],"days":b[1][1039],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][28],"currencies":b[0][2292]},{"months":b[1][1042],"days":b[1][1043],"eras":b[1][3],"dayPeriods":b[0][2299]},{"months":b[1][4],"days":b[1][1043],"dayPeriods":b[0][2299]},{"months":b[1][5],"days":b[1][1043],"eras":b[1][6],"dayPeriods":b[0][2299]},{"months":b[1][7],"days":b[1][1043],"eras":b[1][6],"dayPeriods":b[0][2299]},{"months":b[1][7],"days":b[1][1043],"eras":b[1][8],"dayPeriods":b[0][2299]},{"months":b[1][4],"days":b[1][1043],"eras":b[1][6],"dayPeriods":b[0][2299]},{"months":b[1][1042],"days":b[1][1043],"eras":b[1][1044],"dayPeriods":b[0][2299]},{"months":b[1][10],"days":b[1][1043],"eras":b[1][11],"dayPeriods":b[0][2299]},{"months":b[1][12],"days":b[1][1043],"eras":b[1][13],"dayPeriods":b[0][2299]},{"months":b[1][1045],"days":b[1][1043],"eras":b[1][15],"dayPeriods":b[0][2299]},{"months":b[1][1042],"days":b[1][1043],"eras":b[1][16],"dayPeriods":b[0][2299]},{"months":b[1][17],"days":b[1][1043],"eras":b[1][18],"dayPeriods":b[0][2299]},{"months":b[1][1042],"days":b[1][1043],"eras":b[1][19],"dayPeriods":b[0][2299]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][28],"currencies":b[0][2302]},{"months":b[1][1046],"days":b[1][1047],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1047],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][1047],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1047],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1047],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1047],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][1046],"days":b[1][1047],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][1047],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][1047],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][1047],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][1046],"days":b[1][1047],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][1047],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][1046],"days":b[1][1047],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][1048],"currencies":b[0][2305]},{"months":b[1][1049],"days":b[1][1050],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1050],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][1050],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1050],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1050],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1050],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][1049],"days":b[1][1050],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][1050],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][1050],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][1050],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][1049],"days":b[1][1050],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][1050],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][1049],"days":b[1][1050],"eras":b[1][19],"dayPeriods":b[0][175]},{"months":b[1][1051],"days":b[1][1052],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1052],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][1052],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1052],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1052],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1052],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][1051],"days":b[1][1052],"eras":b[1][75],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][1052],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][1052],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][1052],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][1051],"days":b[1][1052],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][1052],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][1051],"days":b[1][1052],"eras":b[1][19],"dayPeriods":b[0][175]},{"months":b[1][1054],"days":b[1][1055],"eras":b[1][3],"dayPeriods":b[0][2319]},{"months":b[1][173],"days":b[1][1055],"dayPeriods":b[0][2319]},{"months":b[1][5],"days":b[1][1055],"eras":b[1][6],"dayPeriods":b[0][2319]},{"months":b[1][7],"days":b[1][1055],"eras":b[1][6],"dayPeriods":b[0][2319]},{"months":b[1][7],"days":b[1][1055],"eras":b[1][8],"dayPeriods":b[0][2319]},{"months":b[1][4],"days":b[1][1055],"eras":b[1][6],"dayPeriods":b[0][2319]},{"months":b[1][1054],"days":b[1][1055],"eras":b[1][1056],"dayPeriods":b[0][2319]},{"months":b[1][10],"days":b[1][1055],"eras":b[1][11],"dayPeriods":b[0][2319]},{"months":b[1][12],"days":b[1][1055],"eras":b[1][13],"dayPeriods":b[0][2319]},{"months":b[1][14],"days":b[1][1055],"eras":b[1][15],"dayPeriods":b[0][2319]},{"months":b[1][1054],"days":b[1][1055],"eras":b[1][16],"dayPeriods":b[0][2319]},{"months":b[1][17],"days":b[1][1055],"eras":b[1][18],"dayPeriods":b[0][2319]},{"months":b[1][1054],"days":b[1][1055],"eras":b[1][1057],"dayPeriods":b[0][2319]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][87],"currencies":b[0][1307]},{"months":b[1][1059],"days":b[1][1060],"eras":b[1][3],"dayPeriods":b[0][2329]},{"months":b[1][4],"days":b[1][1060],"dayPeriods":b[0][2329]},{"months":b[1][5],"days":b[1][1060],"eras":b[1][6],"dayPeriods":b[0][2329]},{"months":b[1][7],"days":b[1][1060],"eras":b[1][6],"dayPeriods":b[0][2329]},{"months":b[1][7],"days":b[1][1060],"eras":b[1][8],"dayPeriods":b[0][2329]},{"months":b[1][4],"days":b[1][1060],"eras":b[1][6],"dayPeriods":b[0][2329]},{"months":b[1][1059],"days":b[1][1060],"eras":b[1][1061],"dayPeriods":b[0][2329]},{"months":b[1][10],"days":b[1][1060],"eras":b[1][11],"dayPeriods":b[0][2329]},{"months":b[1][12],"days":b[1][1060],"eras":b[1][13],"dayPeriods":b[0][2329]},{"months":b[1][14],"days":b[1][1060],"eras":b[1][15],"dayPeriods":b[0][2329]},{"months":b[1][1059],"days":b[1][1060],"eras":b[1][16],"dayPeriods":b[0][2329]},{"months":b[1][17],"days":b[1][1060],"eras":b[1][18],"dayPeriods":b[0][2329]},{"months":b[1][1059],"days":b[1][1060],"eras":b[1][19],"dayPeriods":b[0][2329]},{"months":b[1][1063],"days":b[1][1064],"eras":b[1][3],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1064],"dayPeriods":b[0][175]},{"months":b[1][5],"days":b[1][1064],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1064],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][7],"days":b[1][1064],"eras":b[1][8],"dayPeriods":b[0][175]},{"months":b[1][4],"days":b[1][1064],"eras":b[1][6],"dayPeriods":b[0][175]},{"months":b[1][1063],"days":b[1][1064],"eras":b[1][1065],"dayPeriods":b[0][175]},{"months":b[1][10],"days":b[1][1064],"eras":b[1][11],"dayPeriods":b[0][175]},{"months":b[1][12],"days":b[1][1064],"eras":b[1][13],"dayPeriods":b[0][175]},{"months":b[1][14],"days":b[1][1064],"eras":b[1][15],"dayPeriods":b[0][175]},{"months":b[1][1063],"days":b[1][1064],"eras":b[1][16],"dayPeriods":b[0][175]},{"months":b[1][17],"days":b[1][1064],"eras":b[1][18],"dayPeriods":b[0][175]},{"months":b[1][1063],"days":b[1][1064],"eras":b[1][19],"dayPeriods":b[0][175]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][1066],"currencies":b[0][2341]},{"months":b[1][609],"days":b[1][1067],"eras":b[1][3],"dayPeriods":b[0][2345]},{"months":b[1][4],"days":b[1][1067],"dayPeriods":b[0][2345]},{"months":b[1][5],"days":b[1][1067],"eras":b[1][6],"dayPeriods":b[0][2345]},{"months":b[1][7],"days":b[1][1067],"eras":b[1][6],"dayPeriods":b[0][2345]},{"months":b[1][7],"days":b[1][1067],"eras":b[1][8],"dayPeriods":b[0][2345]},{"months":b[1][4],"days":b[1][1067],"eras":b[1][6],"dayPeriods":b[0][2345]},{"months":b[1][609],"days":b[1][1067],"eras":b[1][1068],"dayPeriods":b[0][2345]},{"months":b[1][10],"days":b[1][1067],"eras":b[1][11],"dayPeriods":b[0][2345]},{"months":b[1][12],"days":b[1][1067],"eras":b[1][13],"dayPeriods":b[0][2345]},{"months":b[1][14],"days":b[1][1067],"eras":b[1][15],"dayPeriods":b[0][2345]},{"months":b[1][609],"days":b[1][1067],"eras":b[1][16],"dayPeriods":b[0][2345]},{"months":b[1][17],"days":b[1][1067],"eras":b[1][18],"dayPeriods":b[0][2345]},{"months":b[1][609],"days":b[1][1067],"eras":b[1][19],"dayPeriods":b[0][2345]},{"nu":b[0][33],"patterns":b[1][82],"symbols":b[1][21],"currencies":b[0][368]},{"months":b[1][1069],"days":b[1][1070],"eras":b[1][3],"dayPeriods":b[0][2353]},{"months":b[1][4],"days":b[1][1070],"dayPeriods":b[0][2353]},{"months":b[1][5],"days":b[1][1070],"eras":b[1][6],"dayPeriods":b[0][2353]},{"months":b[1][7],"days":b[1][1070],"eras":b[1][6],"dayPeriods":b[0][2353]},{"months":b[1][7],"days":b[1][1070],"eras":b[1][8],"dayPeriods":b[0][2353]},{"months":b[1][4],"days":b[1][1070],"eras":b[1][6],"dayPeriods":b[0][2353]},{"months":b[1][1069],"days":b[1][1070],"eras":b[1][1071],"dayPeriods":b[0][2353]},{"months":b[1][10],"days":b[1][1070],"eras":b[1][11],"dayPeriods":b[0][2353]},{"months":b[1][12],"days":b[1][1070],"eras":b[1][13],"dayPeriods":b[0][2353]},{"months":b[1][14],"days":b[1][1070],"eras":b[1][15],"dayPeriods":b[0][2353]},{"months":b[1][1069],"days":b[1][1070],"eras":b[1][16],"dayPeriods":b[0][2353]},{"months":b[1][17],"days":b[1][1070],"eras":b[1][18],"dayPeriods":b[0][2353]},{"months":b[1][1069],"days":b[1][1070],"eras":b[1][19],"dayPeriods":b[0][2353]},{"months":b[1][1073],"days":b[1][1074],"eras":b[1][3],"dayPeriods":b[0][2360]},{"months":b[1][4],"days":b[1][1074],"dayPeriods":b[0][2360]},{"months":b[1][5],"days":b[1][1074],"eras":b[1][6],"dayPeriods":b[0][2360]},{"months":b[1][7],"days":b[1][1074],"eras":b[1][6],"dayPeriods":b[0][2360]},{"months":b[1][7],"days":b[1][1074],"eras":b[1][8],"dayPeriods":b[0][2360]},{"months":b[1][4],"days":b[1][1074],"eras":b[1][6],"dayPeriods":b[0][2360]},{"months":b[1][1073],"days":b[1][1074],"eras":b[1][75],"dayPeriods":b[0][2360]},{"months":b[1][1075],"days":b[1][1074],"eras":b[1][424],"dayPeriods":b[0][2360]},{"months":b[1][12],"days":b[1][1074],"eras":b[1][13],"dayPeriods":b[0][2360]},{"months":b[1][14],"days":b[1][1074],"eras":b[1][15],"dayPeriods":b[0][2360]},{"months":b[1][1073],"days":b[1][1074],"eras":b[1][16],"dayPeriods":b[0][2360]},{"months":b[1][17],"days":b[1][1074],"eras":b[1][18],"dayPeriods":b[0][2360]},{"months":b[1][1073],"days":b[1][1074],"eras":b[1][19],"dayPeriods":b[0][2360]},{"months":b[1][1076],"days":b[1][1077],"eras":b[1][3],"dayPeriods":b[0][2367]},{"months":b[1][4],"days":b[1][1077],"dayPeriods":b[0][2367]},{"months":b[1][5],"days":b[1][1077],"eras":b[1][6],"dayPeriods":b[0][2367]},{"months":b[1][7],"days":b[1][1077],"eras":b[1][6],"dayPeriods":b[0][2367]},{"months":b[1][7],"days":b[1][1077],"eras":b[1][8],"dayPeriods":b[0][2367]},{"months":b[1][4],"days":b[1][1077],"eras":b[1][6],"dayPeriods":b[0][2367]},{"months":b[1][1076],"days":b[1][1077],"eras":b[1][1078],"dayPeriods":b[0][2367]},{"months":b[1][10],"days":b[1][1077],"eras":b[1][11],"dayPeriods":b[0][2367]},{"months":b[1][12],"days":b[1][1077],"eras":b[1][13],"dayPeriods":b[0][2367]},{"months":b[1][14],"days":b[1][1077],"eras":b[1][15],"dayPeriods":b[0][2367]},{"months":b[1][1076],"days":b[1][1077],"eras":b[1][16],"dayPeriods":b[0][2367]},{"months":b[1][17],"days":b[1][1077],"eras":b[1][18],"dayPeriods":b[0][2367]},{"months":b[1][1076],"days":b[1][1077],"eras":b[1][19],"dayPeriods":b[0][2367]},{"months":b[1][1079],"days":b[1][1080],"eras":b[1][3],"dayPeriods":b[0][2374]},{"months":b[1][4],"days":b[1][1080],"dayPeriods":b[0][2374]},{"months":b[1][5],"days":b[1][1080],"eras":b[1][6],"dayPeriods":b[0][2374]},{"months":b[1][7],"days":b[1][1080],"eras":b[1][6],"dayPeriods":b[0][2374]},{"months":b[1][7],"days":b[1][1080],"eras":b[1][8],"dayPeriods":b[0][2374]},{"months":b[1][4],"days":b[1][1080],"eras":b[1][6],"dayPeriods":b[0][2374]},{"months":b[1][1079],"days":b[1][1080],"eras":b[1][1078],"dayPeriods":b[0][2374]},{"months":b[1][10],"days":b[1][1080],"eras":b[1][11],"dayPeriods":b[0][2374]},{"months":b[1][12],"days":b[1][1080],"eras":b[1][13],"dayPeriods":b[0][2374]},{"months":b[1][14],"days":b[1][1080],"eras":b[1][15],"dayPeriods":b[0][2374]},{"months":b[1][1079],"days":b[1][1080],"eras":b[1][16],"dayPeriods":b[0][2374]},{"months":b[1][17],"days":b[1][1080],"eras":b[1][18],"dayPeriods":b[0][2374]},{"months":b[1][1079],"days":b[1][1080],"eras":b[1][19],"dayPeriods":b[0][2374]},{"months":b[1][871],"days":b[1][1082],"eras":b[1][3],"dayPeriods":b[0][1960]},{"months":b[1][4],"days":b[1][1082],"dayPeriods":b[0][1960]},{"months":b[1][5],"days":b[1][1082],"eras":b[1][6],"dayPeriods":b[0][1960]},{"months":b[1][7],"days":b[1][1082],"eras":b[1][6],"dayPeriods":b[0][1960]},{"months":b[1][7],"days":b[1][1082],"eras":b[1][8],"dayPeriods":b[0][1960]},{"months":b[1][4],"days":b[1][1082],"eras":b[1][6],"dayPeriods":b[0][1960]},{"months":b[1][871],"days":b[1][1082],"eras":b[1][873],"dayPeriods":b[0][1960]},{"months":b[1][10],"days":b[1][1082],"eras":b[1][11],"dayPeriods":b[0][1960]},{"months":b[1][12],"days":b[1][1082],"eras":b[1][13],"dayPeriods":b[0][1960]},{"months":b[1][14],"days":b[1][1082],"eras":b[1][15],"dayPeriods":b[0][1960]},{"months":b[1][871],"days":b[1][1082],"eras":b[1][16],"dayPeriods":b[0][1960]},{"months":b[1][17],"days":b[1][1082],"eras":b[1][18],"dayPeriods":b[0][1960]},{"months":b[1][871],"days":b[1][1082],"eras":b[1][19],"dayPeriods":b[0][1960]},{"nu":b[0][33],"patterns":b[1][816],"symbols":b[1][28],"currencies":b[0][72]},{"months":b[1][1084],"days":b[1][1085],"eras":b[1][1086],"dayPeriods":b[0][2385]},{"months":b[1][1087],"days":b[1][1085],"dayPeriods":b[0][2385]},{"months":b[1][1088],"days":b[1][1085],"eras":b[1][6],"dayPeriods":b[0][2385]},{"months":b[1][1088],"days":b[1][1085],"eras":b[1][8],"dayPeriods":b[0][2385]},{"months":b[1][4],"days":b[1][1085],"eras":b[1][6],"dayPeriods":b[0][2385]},{"months":b[1][1084],"days":b[1][1085],"eras":b[1][1089],"dayPeriods":b[0][2385]},{"months":b[1][1090],"days":b[1][1085],"eras":b[1][1091],"dayPeriods":b[0][2385]},{"months":b[1][1084],"days":b[1][1085],"eras":b[1][1092],"dayPeriods":b[0][2385]},{"months":b[1][1084],"days":b[1][1085],"eras":b[1][1093],"dayPeriods":b[0][2385]},{"months":b[1][1084],"days":b[1][1085],"eras":b[1][1094],"dayPeriods":b[0][2385]},{"months":b[1][1084],"days":b[1][1085],"eras":b[1][1095],"dayPeriods":b[0][2385]},{"months":b[1][1084],"days":b[1][1085],"eras":b[1][504],"dayPeriods":b[0][2385]},{"nu":b[0][33],"patterns":b[1][27],"symbols":b[1][1096],"currencies":b[0][2398]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][1096],"currencies":b[0][2401]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][1096],"currencies":b[0][2403]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][1096],"currencies":b[0][2407]},{"months":b[1][491],"days":b[1][1101],"eras":b[1][1102],"dayPeriods":b[0][2385]},{"months":b[1][494],"days":b[1][1101],"dayPeriods":b[0][2385]},{"months":b[1][1103],"days":b[1][1101],"eras":b[1][6],"dayPeriods":b[0][2385]},{"months":b[1][1103],"days":b[1][1101],"eras":b[1][8],"dayPeriods":b[0][2385]},{"months":b[1][4],"days":b[1][1101],"eras":b[1][6],"dayPeriods":b[0][2385]},{"months":b[1][491],"days":b[1][1101],"eras":b[1][1104],"dayPeriods":b[0][2385]},{"months":b[1][1105],"days":b[1][1101],"eras":b[1][1106],"dayPeriods":b[0][2385]},{"months":b[1][1107],"days":b[1][1101],"eras":b[1][1108],"dayPeriods":b[0][2385]},{"months":b[1][1109],"days":b[1][1101],"eras":b[1][1110],"dayPeriods":b[0][2385]},{"months":b[1][491],"days":b[1][1101],"eras":b[1][1111],"dayPeriods":b[0][2385]},{"months":b[1][491],"days":b[1][1101],"eras":b[1][1112],"dayPeriods":b[0][2385]},{"months":b[1][491],"days":b[1][1101],"eras":b[1][1113],"dayPeriods":b[0][2385]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][1114],"currencies":b[0][2424]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][1114],"currencies":b[0][2427]},{"months":b[1][1117],"days":b[1][1101],"dayPeriods":b[0][2385]},{"months":b[1][491],"days":b[1][1101],"eras":b[1][1118],"dayPeriods":b[0][2385]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][1114],"currencies":b[0][2432]},{"months":b[1][1120],"days":b[1][1121],"eras":b[1][3],"dayPeriods":b[0][2438]},{"months":b[1][4],"days":b[1][1121],"dayPeriods":b[0][2438]},{"months":b[1][5],"days":b[1][1121],"eras":b[1][6],"dayPeriods":b[0][2438]},{"months":b[1][7],"days":b[1][1121],"eras":b[1][6],"dayPeriods":b[0][2438]},{"months":b[1][7],"days":b[1][1121],"eras":b[1][8],"dayPeriods":b[0][2438]},{"months":b[1][4],"days":b[1][1121],"eras":b[1][6],"dayPeriods":b[0][2438]},{"months":b[1][1120],"days":b[1][1121],"eras":b[1][341],"dayPeriods":b[0][2438]},{"months":b[1][10],"days":b[1][1121],"eras":b[1][11],"dayPeriods":b[0][2438]},{"months":b[1][12],"days":b[1][1121],"eras":b[1][13],"dayPeriods":b[0][2438]},{"months":b[1][14],"days":b[1][1121],"eras":b[1][15],"dayPeriods":b[0][2438]},{"months":b[1][1120],"days":b[1][1121],"eras":b[1][16],"dayPeriods":b[0][2438]},{"months":b[1][17],"days":b[1][1121],"eras":b[1][18],"dayPeriods":b[0][2438]},{"months":b[1][1120],"days":b[1][1121],"eras":b[1][19],"dayPeriods":b[0][2438]},{"nu":b[0][33],"patterns":b[1][20],"symbols":b[1][1122],"currencies":b[0][2440]}];b[3]=[{"buddhist":b[2][0],"chinese":b[2][1],"coptic":b[2][2],"dangi":b[2][1],"ethiopic":b[2][3],"ethioaa":b[2][4],"generic":b[2][5],"gregory":b[2][6],"hebrew":b[2][7],"indian":b[2][8],"islamic":b[2][9],"islamicc":b[2][9],"japanese":b[2][10],"persian":b[2][11],"roc":b[2][12]},{"buddhist":b[2][14],"chinese":b[2][1],"coptic":b[2][2],"dangi":b[2][1],"ethiopic":b[2][3],"ethioaa":b[2][4],"generic":b[2][5],"gregory":b[2][15],"hebrew":b[2][7],"indian":b[2][8],"islamic":b[2][9],"islamicc":b[2][9],"japanese":b[2][16],"persian":b[2][11],"roc":b[2][17]},{"buddhist":b[2][20],"chinese":b[2][21],"coptic":b[2][22],"dangi":b[2][21],"ethiopic":b[2][23],"ethioaa":b[2][24],"generic":b[2][25],"gregory":b[2][26],"hebrew":b[2][27],"indian":b[2][28],"islamic":b[2][29],"islamicc":b[2][29],"japanese":b[2][30],"persian":b[2][31],"roc":b[2][32]},{"buddhist":b[2][35],"chinese":b[2][36],"coptic":b[2][37],"dangi":b[2][36],"ethiopic":b[2][38],"ethioaa":b[2][39],"generic":b[2][40],"gregory":b[2][41],"hebrew":b[2][42],"indian":b[2][43],"islamic":b[2][44],"islamicc":b[2][44],"japanese":b[2][45],"persian":b[2][46],"roc":b[2][47]},{"buddhist":b[2][49],"chinese":b[2][50],"coptic":b[2][51],"dangi":b[2][50],"ethiopic":b[2][52],"ethioaa":b[2][53],"generic":b[2][54],"gregory":b[2][55],"hebrew":b[2][56],"indian":b[2][57],"islamic":b[2][58],"islamicc":b[2][58],"japanese":b[2][59],"persian":b[2][60],"roc":b[2][61]},{"buddhist":b[2][63],"chinese":b[2][64],"coptic":b[2][65],"dangi":b[2][64],"ethiopic":b[2][66],"ethioaa":b[2][67],"generic":b[2][68],"gregory":b[2][69],"hebrew":b[2][70],"indian":b[2][71],"islamic":b[2][72],"islamicc":b[2][72],"japanese":b[2][73],"persian":b[2][74],"roc":b[2][75]},{"buddhist":b[2][77],"chinese":b[2][78],"coptic":b[2][79],"dangi":b[2][78],"ethiopic":b[2][80],"ethioaa":b[2][81],"generic":b[2][82],"gregory":b[2][83],"hebrew":b[2][84],"indian":b[2][85],"islamic":b[2][86],"islamicc":b[2][86],"japanese":b[2][87],"persian":b[2][88],"roc":b[2][89]},{"buddhist":b[2][77],"chinese":b[2][78],"coptic":b[2][79],"dangi":b[2][78],"ethiopic":b[2][80],"ethioaa":b[2][81],"generic":b[2][82],"gregory":b[2][91],"hebrew":b[2][84],"indian":b[2][85],"islamic":b[2][86],"islamicc":b[2][86],"japanese":b[2][87],"persian":b[2][88],"roc":b[2][89]},{"buddhist":b[2][93],"chinese":b[2][78],"coptic":b[2][79],"dangi":b[2][78],"ethiopic":b[2][80],"ethioaa":b[2][81],"generic":b[2][82],"gregory":b[2][94],"hebrew":b[2][84],"indian":b[2][85],"islamic":b[2][86],"islamicc":b[2][86],"japanese":b[2][95],"persian":b[2][88],"roc":b[2][96]},{"buddhist":b[2][101],"chinese":b[2][78],"coptic":b[2][79],"dangi":b[2][78],"ethiopic":b[2][80],"ethioaa":b[2][81],"generic":b[2][82],"gregory":b[2][102],"hebrew":b[2][84],"indian":b[2][85],"islamic":b[2][86],"islamicc":b[2][86],"japanese":b[2][103],"persian":b[2][88],"roc":b[2][104]},{"buddhist":b[2][105],"chinese":b[2][78],"coptic":b[2][79],"dangi":b[2][78],"ethiopic":b[2][80],"ethioaa":b[2][81],"generic":b[2][82],"gregory":b[2][106],"hebrew":b[2][84],"indian":b[2][85],"islamic":b[2][86],"islamicc":b[2][86],"japanese":b[2][107],"persian":b[2][88],"roc":b[2][108]},{"buddhist":b[2][110],"chinese":b[2][78],"coptic":b[2][79],"dangi":b[2][78],"ethiopic":b[2][80],"ethioaa":b[2][81],"generic":b[2][82],"gregory":b[2][111],"hebrew":b[2][84],"indian":b[2][85],"islamic":b[2][86],"islamicc":b[2][86],"japanese":b[2][112],"persian":b[2][88],"roc":b[2][113]},{"buddhist":b[2][114],"chinese":b[2][78],"coptic":b[2][79],"dangi":b[2][78],"ethiopic":b[2][80],"ethioaa":b[2][81],"generic":b[2][82],"gregory":b[2][115],"hebrew":b[2][84],"indian":b[2][85],"islamic":b[2][86],"islamicc":b[2][86],"japanese":b[2][116],"persian":b[2][88],"roc":b[2][117]},{"buddhist":b[2][122],"chinese":b[2][123],"coptic":b[2][124],"dangi":b[2][123],"ethiopic":b[2][125],"ethioaa":b[2][126],"generic":b[2][127],"gregory":b[2][128],"hebrew":b[2][129],"indian":b[2][130],"islamic":b[2][131],"islamicc":b[2][131],"japanese":b[2][132],"persian":b[2][133],"roc":b[2][134]},{"buddhist":b[2][136],"chinese":b[2][137],"coptic":b[2][138],"dangi":b[2][137],"ethiopic":b[2][139],"ethioaa":b[2][140],"generic":b[2][141],"gregory":b[2][142],"hebrew":b[2][143],"indian":b[2][144],"islamic":b[2][145],"islamicc":b[2][145],"japanese":b[2][146],"persian":b[2][147],"roc":b[2][148]},{"buddhist":b[2][150],"chinese":b[2][151],"coptic":b[2][152],"dangi":b[2][151],"ethiopic":b[2][153],"ethioaa":b[2][154],"generic":b[2][155],"gregory":b[2][156],"hebrew":b[2][157],"indian":b[2][158],"islamic":b[2][159],"islamicc":b[2][159],"japanese":b[2][160],"persian":b[2][161],"roc":b[2][162]},{"buddhist":b[2][164],"chinese":b[2][165],"coptic":b[2][166],"dangi":b[2][165],"ethiopic":b[2][167],"ethioaa":b[2][168],"generic":b[2][169],"gregory":b[2][170],"hebrew":b[2][171],"indian":b[2][172],"islamic":b[2][173],"islamicc":b[2][173],"japanese":b[2][174],"persian":b[2][175],"roc":b[2][176]},{"buddhist":b[2][178],"chinese":b[2][179],"coptic":b[2][180],"dangi":b[2][179],"ethiopic":b[2][181],"ethioaa":b[2][182],"generic":b[2][183],"gregory":b[2][184],"hebrew":b[2][185],"indian":b[2][186],"islamic":b[2][187],"islamicc":b[2][187],"japanese":b[2][188],"persian":b[2][189],"roc":b[2][190]},{"buddhist":b[2][192],"chinese":b[2][193],"coptic":b[2][194],"dangi":b[2][193],"ethiopic":b[2][195],"ethioaa":b[2][196],"generic":b[2][197],"gregory":b[2][198],"hebrew":b[2][199],"indian":b[2][200],"islamic":b[2][201],"islamicc":b[2][201],"japanese":b[2][202],"persian":b[2][203],"roc":b[2][204]},{"buddhist":b[2][206],"chinese":b[2][207],"coptic":b[2][208],"dangi":b[2][207],"ethiopic":b[2][209],"ethioaa":b[2][210],"generic":b[2][211],"gregory":b[2][212],"hebrew":b[2][213],"indian":b[2][214],"islamic":b[2][215],"islamicc":b[2][215],"japanese":b[2][216],"persian":b[2][217],"roc":b[2][218]},{"buddhist":b[2][220],"chinese":b[2][221],"coptic":b[2][222],"dangi":b[2][221],"ethiopic":b[2][223],"ethioaa":b[2][224],"generic":b[2][225],"gregory":b[2][226],"hebrew":b[2][227],"indian":b[2][228],"islamic":b[2][229],"islamicc":b[2][229],"japanese":b[2][230],"persian":b[2][231],"roc":b[2][232]},{"buddhist":b[2][234],"chinese":b[2][235],"coptic":b[2][236],"dangi":b[2][235],"ethiopic":b[2][237],"ethioaa":b[2][238],"generic":b[2][239],"gregory":b[2][240],"hebrew":b[2][241],"indian":b[2][242],"islamic":b[2][243],"islamicc":b[2][243],"japanese":b[2][244],"persian":b[2][245],"roc":b[2][246]},{"buddhist":b[2][248],"chinese":b[2][249],"coptic":b[2][250],"dangi":b[2][249],"ethiopic":b[2][251],"ethioaa":b[2][252],"generic":b[2][253],"gregory":b[2][254],"hebrew":b[2][255],"indian":b[2][256],"islamic":b[2][257],"islamicc":b[2][257],"japanese":b[2][258],"persian":b[2][259],"roc":b[2][260]},{"buddhist":b[2][262],"chinese":b[2][263],"coptic":b[2][264],"dangi":b[2][263],"ethiopic":b[2][265],"ethioaa":b[2][266],"generic":b[2][267],"gregory":b[2][268],"hebrew":b[2][269],"indian":b[2][270],"islamic":b[2][271],"islamicc":b[2][271],"japanese":b[2][272],"persian":b[2][273],"roc":b[2][274]},{"buddhist":b[2][276],"chinese":b[2][277],"coptic":b[2][278],"dangi":b[2][277],"ethiopic":b[2][279],"ethioaa":b[2][280],"generic":b[2][281],"gregory":b[2][282],"hebrew":b[2][283],"indian":b[2][284],"islamic":b[2][285],"islamicc":b[2][285],"japanese":b[2][286],"persian":b[2][287],"roc":b[2][288]},{"buddhist":b[2][290],"chinese":b[2][291],"coptic":b[2][292],"dangi":b[2][291],"ethiopic":b[2][293],"ethioaa":b[2][294],"generic":b[2][295],"gregory":b[2][296],"hebrew":b[2][297],"indian":b[2][298],"islamic":b[2][299],"islamicc":b[2][299],"japanese":b[2][300],"persian":b[2][301],"roc":b[2][302]},{"buddhist":b[2][304],"chinese":b[2][305],"coptic":b[2][306],"dangi":b[2][305],"ethiopic":b[2][307],"ethioaa":b[2][308],"generic":b[2][309],"gregory":b[2][310],"hebrew":b[2][311],"indian":b[2][312],"islamic":b[2][313],"islamicc":b[2][313],"japanese":b[2][314],"persian":b[2][315],"roc":b[2][316]},{"buddhist":b[2][319],"chinese":b[2][320],"coptic":b[2][321],"dangi":b[2][320],"ethiopic":b[2][322],"ethioaa":b[2][323],"generic":b[2][324],"gregory":b[2][325],"hebrew":b[2][326],"indian":b[2][327],"islamic":b[2][328],"islamicc":b[2][328],"japanese":b[2][329],"persian":b[2][330],"roc":b[2][331]},{"buddhist":b[2][333],"chinese":b[2][334],"coptic":b[2][335],"dangi":b[2][334],"ethiopic":b[2][336],"ethioaa":b[2][337],"generic":b[2][338],"gregory":b[2][339],"hebrew":b[2][340],"indian":b[2][341],"islamic":b[2][342],"islamicc":b[2][342],"japanese":b[2][343],"persian":b[2][344],"roc":b[2][345]},{"buddhist":b[2][347],"chinese":b[2][348],"coptic":b[2][349],"dangi":b[2][348],"ethiopic":b[2][350],"ethioaa":b[2][351],"generic":b[2][352],"gregory":b[2][353],"hebrew":b[2][354],"indian":b[2][355],"islamic":b[2][356],"islamicc":b[2][356],"japanese":b[2][357],"persian":b[2][358],"roc":b[2][359]},{"buddhist":b[2][361],"chinese":b[2][362],"coptic":b[2][363],"dangi":b[2][362],"ethiopic":b[2][364],"ethioaa":b[2][365],"generic":b[2][366],"gregory":b[2][367],"hebrew":b[2][368],"indian":b[2][369],"islamic":b[2][370],"islamicc":b[2][370],"japanese":b[2][371],"persian":b[2][372],"roc":b[2][373]},{"buddhist":b[2][375],"chinese":b[2][376],"coptic":b[2][377],"dangi":b[2][376],"ethiopic":b[2][378],"ethioaa":b[2][379],"generic":b[2][380],"gregory":b[2][381],"hebrew":b[2][382],"indian":b[2][383],"islamic":b[2][384],"islamicc":b[2][384],"japanese":b[2][385],"persian":b[2][386],"roc":b[2][387]},{"buddhist":b[2][390],"chinese":b[2][391],"coptic":b[2][392],"dangi":b[2][391],"ethiopic":b[2][393],"ethioaa":b[2][394],"generic":b[2][395],"gregory":b[2][396],"hebrew":b[2][397],"indian":b[2][398],"islamic":b[2][399],"islamicc":b[2][399],"japanese":b[2][400],"persian":b[2][401],"roc":b[2][402]},{"buddhist":b[2][404],"chinese":b[2][405],"coptic":b[2][406],"dangi":b[2][405],"ethiopic":b[2][407],"ethioaa":b[2][408],"generic":b[2][409],"gregory":b[2][410],"hebrew":b[2][411],"indian":b[2][412],"islamic":b[2][413],"islamicc":b[2][413],"japanese":b[2][414],"persian":b[2][415],"roc":b[2][416]},{"buddhist":b[2][418],"chinese":b[2][419],"coptic":b[2][420],"dangi":b[2][419],"ethiopic":b[2][421],"ethioaa":b[2][422],"generic":b[2][423],"gregory":b[2][424],"hebrew":b[2][425],"indian":b[2][426],"islamic":b[2][427],"islamicc":b[2][427],"japanese":b[2][428],"persian":b[2][429],"roc":b[2][430]},{"buddhist":b[2][432],"chinese":b[2][433],"coptic":b[2][434],"dangi":b[2][433],"ethiopic":b[2][435],"ethioaa":b[2][436],"generic":b[2][437],"gregory":b[2][438],"hebrew":b[2][439],"indian":b[2][440],"islamic":b[2][441],"islamicc":b[2][441],"japanese":b[2][442],"persian":b[2][443],"roc":b[2][444]},{"buddhist":b[2][446],"chinese":b[2][447],"coptic":b[2][448],"dangi":b[2][447],"ethiopic":b[2][449],"ethioaa":b[2][450],"generic":b[2][451],"gregory":b[2][452],"hebrew":b[2][453],"indian":b[2][454],"islamic":b[2][455],"islamicc":b[2][455],"japanese":b[2][456],"persian":b[2][457],"roc":b[2][458]},{"buddhist":b[2][460],"chinese":b[2][461],"coptic":b[2][462],"dangi":b[2][461],"ethiopic":b[2][463],"ethioaa":b[2][464],"generic":b[2][465],"gregory":b[2][466],"hebrew":b[2][467],"indian":b[2][468],"islamic":b[2][469],"islamicc":b[2][469],"japanese":b[2][470],"persian":b[2][471],"roc":b[2][472]},{"buddhist":b[2][474],"chinese":b[2][475],"coptic":b[2][476],"dangi":b[2][475],"ethiopic":b[2][477],"ethioaa":b[2][478],"generic":b[2][479],"gregory":b[2][480],"hebrew":b[2][481],"indian":b[2][482],"islamic":b[2][483],"islamicc":b[2][483],"japanese":b[2][484],"persian":b[2][485],"roc":b[2][486]},{"buddhist":b[2][488],"chinese":b[2][475],"coptic":b[2][476],"dangi":b[2][475],"ethiopic":b[2][477],"ethioaa":b[2][478],"generic":b[2][479],"gregory":b[2][489],"hebrew":b[2][481],"indian":b[2][482],"islamic":b[2][483],"islamicc":b[2][483],"japanese":b[2][490],"persian":b[2][485],"roc":b[2][491]},{"buddhist":b[2][496],"chinese":b[2][497],"coptic":b[2][498],"dangi":b[2][497],"ethiopic":b[2][499],"ethioaa":b[2][500],"generic":b[2][501],"gregory":b[2][502],"hebrew":b[2][503],"indian":b[2][504],"islamic":b[2][505],"islamicc":b[2][505],"japanese":b[2][506],"persian":b[2][507],"roc":b[2][508]},{"buddhist":b[2][510],"chinese":b[2][511],"coptic":b[2][512],"dangi":b[2][511],"ethiopic":b[2][513],"ethioaa":b[2][514],"generic":b[2][515],"gregory":b[2][516],"hebrew":b[2][517],"indian":b[2][518],"islamic":b[2][519],"islamicc":b[2][519],"japanese":b[2][520],"persian":b[2][521],"roc":b[2][522]},{"buddhist":b[2][524],"chinese":b[2][525],"coptic":b[2][526],"dangi":b[2][525],"ethiopic":b[2][527],"ethioaa":b[2][528],"generic":b[2][529],"gregory":b[2][530],"hebrew":b[2][531],"indian":b[2][532],"islamic":b[2][533],"islamicc":b[2][533],"japanese":b[2][534],"persian":b[2][535],"roc":b[2][536]},{"buddhist":b[2][537],"chinese":b[2][538],"coptic":b[2][539],"dangi":b[2][538],"ethiopic":b[2][540],"ethioaa":b[2][541],"generic":b[2][542],"gregory":b[2][543],"hebrew":b[2][544],"indian":b[2][545],"islamic":b[2][546],"islamicc":b[2][546],"japanese":b[2][547],"persian":b[2][548],"roc":b[2][549]},{"buddhist":b[2][551],"chinese":b[2][552],"coptic":b[2][553],"dangi":b[2][552],"ethiopic":b[2][554],"ethioaa":b[2][555],"generic":b[2][556],"gregory":b[2][557],"hebrew":b[2][558],"indian":b[2][559],"islamic":b[2][560],"islamicc":b[2][560],"japanese":b[2][561],"persian":b[2][562],"roc":b[2][563]},{"buddhist":b[2][565],"chinese":b[2][566],"coptic":b[2][567],"dangi":b[2][566],"ethiopic":b[2][568],"ethioaa":b[2][569],"generic":b[2][570],"gregory":b[2][571],"hebrew":b[2][572],"indian":b[2][573],"islamic":b[2][574],"islamicc":b[2][574],"japanese":b[2][575],"persian":b[2][576],"roc":b[2][577]},{"buddhist":b[2][578],"chinese":b[2][579],"coptic":b[2][580],"dangi":b[2][579],"ethiopic":b[2][581],"ethioaa":b[2][582],"generic":b[2][583],"gregory":b[2][584],"hebrew":b[2][585],"indian":b[2][586],"islamic":b[2][587],"islamicc":b[2][587],"japanese":b[2][588],"persian":b[2][589],"roc":b[2][590]},{"buddhist":b[2][592],"chinese":b[2][593],"coptic":b[2][594],"dangi":b[2][593],"ethiopic":b[2][595],"ethioaa":b[2][596],"generic":b[2][597],"gregory":b[2][598],"hebrew":b[2][599],"indian":b[2][600],"islamic":b[2][601],"islamicc":b[2][601],"japanese":b[2][602],"persian":b[2][603],"roc":b[2][604]},{"buddhist":b[2][607],"chinese":b[2][608],"coptic":b[2][609],"dangi":b[2][608],"ethiopic":b[2][610],"ethioaa":b[2][611],"generic":b[2][612],"gregory":b[2][613],"hebrew":b[2][614],"indian":b[2][615],"islamic":b[2][616],"islamicc":b[2][616],"japanese":b[2][617],"persian":b[2][618],"roc":b[2][619]},{"buddhist":b[2][621],"chinese":b[2][622],"coptic":b[2][623],"dangi":b[2][622],"ethiopic":b[2][624],"ethioaa":b[2][625],"generic":b[2][626],"gregory":b[2][627],"hebrew":b[2][628],"indian":b[2][629],"islamic":b[2][630],"islamicc":b[2][630],"japanese":b[2][631],"persian":b[2][632],"roc":b[2][633]},{"buddhist":b[2][621],"chinese":b[2][637],"coptic":b[2][623],"dangi":b[2][637],"ethiopic":b[2][624],"ethioaa":b[2][625],"generic":b[2][626],"gregory":b[2][627],"hebrew":b[2][628],"indian":b[2][629],"islamic":b[2][630],"islamicc":b[2][630],"japanese":b[2][631],"persian":b[2][632],"roc":b[2][633]},{"buddhist":b[2][621],"chinese":b[2][622],"coptic":b[2][623],"dangi":b[2][622],"ethiopic":b[2][624],"ethioaa":b[2][625],"generic":b[2][626],"gregory":b[2][627],"hebrew":b[2][628],"indian":b[2][629],"islamic":b[2][630],"islamicc":b[2][630],"japanese":b[2][654],"persian":b[2][632],"roc":b[2][633]},{"buddhist":b[2][655],"chinese":b[2][656],"coptic":b[2][657],"dangi":b[2][656],"ethiopic":b[2][658],"ethioaa":b[2][659],"generic":b[2][660],"gregory":b[2][661],"hebrew":b[2][662],"indian":b[2][663],"islamic":b[2][664],"islamicc":b[2][664],"japanese":b[2][665],"persian":b[2][666],"roc":b[2][667]},{"buddhist":b[2][703],"chinese":b[2][704],"coptic":b[2][705],"dangi":b[2][704],"ethiopic":b[2][706],"ethioaa":b[2][707],"generic":b[2][708],"gregory":b[2][709],"hebrew":b[2][710],"indian":b[2][711],"islamic":b[2][712],"islamicc":b[2][712],"japanese":b[2][713],"persian":b[2][714],"roc":b[2][715]},{"buddhist":b[2][717],"chinese":b[2][718],"coptic":b[2][719],"dangi":b[2][718],"ethiopic":b[2][720],"ethioaa":b[2][721],"generic":b[2][722],"gregory":b[2][723],"hebrew":b[2][724],"indian":b[2][725],"islamic":b[2][726],"islamicc":b[2][726],"japanese":b[2][727],"persian":b[2][728],"roc":b[2][729]},{"buddhist":b[2][738],"chinese":b[2][739],"coptic":b[2][740],"dangi":b[2][739],"ethiopic":b[2][741],"ethioaa":b[2][742],"generic":b[2][743],"gregory":b[2][744],"hebrew":b[2][745],"indian":b[2][746],"islamic":b[2][747],"islamicc":b[2][747],"japanese":b[2][748],"persian":b[2][749],"roc":b[2][750]},{"buddhist":b[2][756],"chinese":b[2][757],"coptic":b[2][758],"dangi":b[2][757],"ethiopic":b[2][759],"ethioaa":b[2][760],"generic":b[2][761],"gregory":b[2][762],"hebrew":b[2][763],"indian":b[2][764],"islamic":b[2][765],"islamicc":b[2][765],"japanese":b[2][766],"persian":b[2][767],"roc":b[2][768]},{"buddhist":b[2][776],"chinese":b[2][777],"coptic":b[2][778],"dangi":b[2][777],"ethiopic":b[2][779],"ethioaa":b[2][780],"generic":b[2][781],"gregory":b[2][782],"hebrew":b[2][783],"indian":b[2][784],"islamic":b[2][785],"islamicc":b[2][785],"japanese":b[2][786],"persian":b[2][787],"roc":b[2][788]},{"buddhist":b[2][792],"chinese":b[2][793],"coptic":b[2][794],"dangi":b[2][793],"ethiopic":b[2][795],"ethioaa":b[2][796],"generic":b[2][797],"gregory":b[2][798],"hebrew":b[2][799],"indian":b[2][800],"islamic":b[2][801],"islamicc":b[2][801],"japanese":b[2][802],"persian":b[2][803],"roc":b[2][804]},{"buddhist":b[2][806],"chinese":b[2][807],"coptic":b[2][808],"dangi":b[2][807],"ethiopic":b[2][809],"ethioaa":b[2][810],"generic":b[2][811],"gregory":b[2][812],"hebrew":b[2][813],"indian":b[2][814],"islamic":b[2][815],"islamicc":b[2][815],"japanese":b[2][816],"persian":b[2][817],"roc":b[2][818]},{"buddhist":b[2][820],"chinese":b[2][821],"coptic":b[2][822],"dangi":b[2][821],"ethiopic":b[2][823],"ethioaa":b[2][824],"generic":b[2][825],"gregory":b[2][826],"hebrew":b[2][827],"indian":b[2][828],"islamic":b[2][829],"islamicc":b[2][829],"japanese":b[2][830],"persian":b[2][831],"roc":b[2][832]},{"buddhist":b[2][833],"chinese":b[2][834],"coptic":b[2][835],"dangi":b[2][834],"ethiopic":b[2][836],"ethioaa":b[2][837],"generic":b[2][838],"gregory":b[2][839],"hebrew":b[2][840],"indian":b[2][841],"islamic":b[2][842],"islamicc":b[2][842],"japanese":b[2][843],"persian":b[2][844],"roc":b[2][845]},{"buddhist":b[2][847],"chinese":b[2][834],"coptic":b[2][835],"dangi":b[2][834],"ethiopic":b[2][836],"ethioaa":b[2][837],"generic":b[2][838],"gregory":b[2][848],"hebrew":b[2][840],"indian":b[2][841],"islamic":b[2][842],"islamicc":b[2][842],"japanese":b[2][849],"persian":b[2][850],"roc":b[2][851]},{"buddhist":b[2][852],"chinese":b[2][853],"coptic":b[2][854],"dangi":b[2][853],"ethiopic":b[2][855],"ethioaa":b[2][856],"generic":b[2][857],"gregory":b[2][858],"hebrew":b[2][859],"indian":b[2][860],"islamic":b[2][861],"islamicc":b[2][861],"japanese":b[2][862],"persian":b[2][863],"roc":b[2][864]},{"buddhist":b[2][867],"chinese":b[2][868],"coptic":b[2][869],"dangi":b[2][868],"ethiopic":b[2][870],"ethioaa":b[2][871],"generic":b[2][872],"gregory":b[2][873],"hebrew":b[2][874],"indian":b[2][875],"islamic":b[2][876],"islamicc":b[2][876],"japanese":b[2][877],"persian":b[2][878],"roc":b[2][879]},{"buddhist":b[2][881],"chinese":b[2][882],"coptic":b[2][883],"dangi":b[2][882],"ethiopic":b[2][884],"ethioaa":b[2][885],"generic":b[2][886],"gregory":b[2][887],"hebrew":b[2][888],"indian":b[2][889],"islamic":b[2][890],"islamicc":b[2][890],"japanese":b[2][891],"persian":b[2][892],"roc":b[2][893]},{"buddhist":b[2][895],"chinese":b[2][896],"coptic":b[2][897],"dangi":b[2][896],"ethiopic":b[2][898],"ethioaa":b[2][899],"generic":b[2][900],"gregory":b[2][901],"hebrew":b[2][902],"indian":b[2][903],"islamic":b[2][904],"islamicc":b[2][904],"japanese":b[2][905],"persian":b[2][906],"roc":b[2][907]},{"buddhist":b[2][909],"chinese":b[2][910],"coptic":b[2][911],"dangi":b[2][910],"ethiopic":b[2][912],"ethioaa":b[2][913],"generic":b[2][914],"gregory":b[2][915],"hebrew":b[2][916],"indian":b[2][917],"islamic":b[2][918],"islamicc":b[2][918],"japanese":b[2][919],"persian":b[2][920],"roc":b[2][921]},{"buddhist":b[2][909],"chinese":b[2][910],"coptic":b[2][911],"dangi":b[2][910],"ethiopic":b[2][912],"ethioaa":b[2][913],"generic":b[2][914],"gregory":b[2][925],"hebrew":b[2][916],"indian":b[2][917],"islamic":b[2][918],"islamicc":b[2][918],"japanese":b[2][919],"persian":b[2][920],"roc":b[2][921]},{"buddhist":b[2][943],"chinese":b[2][944],"coptic":b[2][945],"dangi":b[2][944],"ethiopic":b[2][946],"ethioaa":b[2][947],"generic":b[2][948],"gregory":b[2][949],"hebrew":b[2][950],"indian":b[2][951],"islamic":b[2][952],"islamicc":b[2][952],"japanese":b[2][953],"persian":b[2][954],"roc":b[2][955]},{"buddhist":b[2][957],"chinese":b[2][958],"coptic":b[2][959],"dangi":b[2][958],"ethiopic":b[2][960],"ethioaa":b[2][961],"generic":b[2][962],"gregory":b[2][963],"hebrew":b[2][964],"indian":b[2][965],"islamic":b[2][966],"islamicc":b[2][966],"japanese":b[2][967],"persian":b[2][968],"roc":b[2][969]},{"buddhist":b[2][971],"chinese":b[2][972],"coptic":b[2][973],"dangi":b[2][972],"ethiopic":b[2][974],"ethioaa":b[2][975],"generic":b[2][976],"gregory":b[2][977],"hebrew":b[2][978],"indian":b[2][979],"islamic":b[2][980],"islamicc":b[2][980],"japanese":b[2][981],"persian":b[2][982],"roc":b[2][983]},{"buddhist":b[2][985],"chinese":b[2][986],"coptic":b[2][987],"dangi":b[2][986],"ethiopic":b[2][988],"ethioaa":b[2][989],"generic":b[2][990],"gregory":b[2][991],"hebrew":b[2][992],"indian":b[2][993],"islamic":b[2][994],"islamicc":b[2][994],"japanese":b[2][995],"persian":b[2][996],"roc":b[2][997]},{"buddhist":b[2][999],"chinese":b[2][1000],"coptic":b[2][1001],"dangi":b[2][1000],"ethiopic":b[2][1002],"ethioaa":b[2][1003],"generic":b[2][1004],"gregory":b[2][1005],"hebrew":b[2][1006],"indian":b[2][1007],"islamic":b[2][1008],"islamicc":b[2][1008],"japanese":b[2][1009],"persian":b[2][1010],"roc":b[2][1011]},{"buddhist":b[2][1013],"chinese":b[2][1014],"coptic":b[2][1015],"dangi":b[2][1014],"ethiopic":b[2][1016],"ethioaa":b[2][1017],"generic":b[2][1018],"gregory":b[2][1019],"hebrew":b[2][1020],"indian":b[2][1021],"islamic":b[2][1022],"islamicc":b[2][1022],"japanese":b[2][1023],"persian":b[2][1024],"roc":b[2][1025]},{"buddhist":b[2][1027],"chinese":b[2][1028],"coptic":b[2][1029],"dangi":b[2][1028],"ethiopic":b[2][1030],"ethioaa":b[2][1031],"generic":b[2][1032],"gregory":b[2][1033],"hebrew":b[2][1034],"indian":b[2][1035],"islamic":b[2][1036],"islamicc":b[2][1036],"japanese":b[2][1037],"persian":b[2][1038],"roc":b[2][1039]},{"buddhist":b[2][1041],"chinese":b[2][1042],"coptic":b[2][1043],"dangi":b[2][1042],"ethiopic":b[2][1044],"ethioaa":b[2][1045],"generic":b[2][1046],"gregory":b[2][1047],"hebrew":b[2][1048],"indian":b[2][1049],"islamic":b[2][1050],"islamicc":b[2][1050],"japanese":b[2][1051],"persian":b[2][1052],"roc":b[2][1053]},{"buddhist":b[2][1054],"chinese":b[2][1055],"coptic":b[2][1056],"dangi":b[2][1055],"ethiopic":b[2][1057],"ethioaa":b[2][1058],"generic":b[2][1059],"gregory":b[2][1060],"hebrew":b[2][1061],"indian":b[2][1062],"islamic":b[2][1063],"islamicc":b[2][1063],"japanese":b[2][1064],"persian":b[2][1065],"roc":b[2][1066]},{"buddhist":b[2][1067],"chinese":b[2][1068],"coptic":b[2][1069],"dangi":b[2][1068],"ethiopic":b[2][1070],"ethioaa":b[2][1071],"generic":b[2][1072],"gregory":b[2][1073],"hebrew":b[2][1074],"indian":b[2][1075],"islamic":b[2][1076],"islamicc":b[2][1076],"japanese":b[2][1077],"persian":b[2][1078],"roc":b[2][1079]},{"buddhist":b[2][1083],"chinese":b[2][1084],"coptic":b[2][1085],"dangi":b[2][1084],"ethiopic":b[2][1086],"ethioaa":b[2][1087],"generic":b[2][1088],"gregory":b[2][1089],"hebrew":b[2][1090],"indian":b[2][1091],"islamic":b[2][1092],"islamicc":b[2][1092],"japanese":b[2][1093],"persian":b[2][1094],"roc":b[2][1095]},{"buddhist":b[2][1096],"chinese":b[2][1097],"coptic":b[2][1098],"dangi":b[2][1097],"ethiopic":b[2][1099],"ethioaa":b[2][1100],"generic":b[2][1101],"gregory":b[2][1102],"hebrew":b[2][1103],"indian":b[2][1104],"islamic":b[2][1105],"islamicc":b[2][1105],"japanese":b[2][1106],"persian":b[2][1107],"roc":b[2][1108]},{"buddhist":b[2][1110],"chinese":b[2][1111],"coptic":b[2][1112],"dangi":b[2][1111],"ethiopic":b[2][1113],"ethioaa":b[2][1114],"generic":b[2][1115],"gregory":b[2][1116],"hebrew":b[2][1117],"indian":b[2][1118],"islamic":b[2][1119],"islamicc":b[2][1119],"japanese":b[2][1120],"persian":b[2][1121],"roc":b[2][1122]},{"buddhist":b[2][1124],"chinese":b[2][1125],"coptic":b[2][1126],"dangi":b[2][1125],"ethiopic":b[2][1127],"ethioaa":b[2][1128],"generic":b[2][1129],"gregory":b[2][1130],"hebrew":b[2][1131],"indian":b[2][1132],"islamic":b[2][1133],"islamicc":b[2][1133],"japanese":b[2][1134],"persian":b[2][1135],"roc":b[2][1136]},{"buddhist":b[2][1139],"chinese":b[2][1140],"coptic":b[2][1141],"dangi":b[2][1140],"ethiopic":b[2][1142],"ethioaa":b[2][1143],"generic":b[2][1144],"gregory":b[2][1145],"hebrew":b[2][1146],"indian":b[2][1147],"islamic":b[2][1148],"islamicc":b[2][1148],"japanese":b[2][1149],"persian":b[2][1150],"roc":b[2][1151]},{"buddhist":b[2][1152],"chinese":b[2][1153],"coptic":b[2][1154],"dangi":b[2][1153],"ethiopic":b[2][1155],"ethioaa":b[2][1156],"generic":b[2][1157],"gregory":b[2][1158],"hebrew":b[2][1159],"indian":b[2][1160],"islamic":b[2][1161],"islamicc":b[2][1161],"japanese":b[2][1162],"persian":b[2][1163],"roc":b[2][1164]},{"buddhist":b[2][1166],"chinese":b[2][1167],"coptic":b[2][1168],"dangi":b[2][1167],"ethiopic":b[2][1169],"ethioaa":b[2][1170],"generic":b[2][1171],"gregory":b[2][1172],"hebrew":b[2][1173],"indian":b[2][1174],"islamic":b[2][1175],"islamicc":b[2][1175],"japanese":b[2][1176],"persian":b[2][1177],"roc":b[2][1178]},{"buddhist":b[2][1180],"chinese":b[2][1181],"coptic":b[2][1182],"dangi":b[2][1181],"ethiopic":b[2][1183],"ethioaa":b[2][1184],"generic":b[2][1185],"gregory":b[2][1186],"hebrew":b[2][1187],"indian":b[2][1188],"islamic":b[2][1189],"islamicc":b[2][1189],"japanese":b[2][1190],"persian":b[2][1191],"roc":b[2][1192]},{"buddhist":b[2][1193],"chinese":b[2][1194],"coptic":b[2][1195],"dangi":b[2][1194],"ethiopic":b[2][1196],"ethioaa":b[2][1197],"generic":b[2][1198],"gregory":b[2][1199],"hebrew":b[2][1200],"indian":b[2][1201],"islamic":b[2][1202],"islamicc":b[2][1202],"japanese":b[2][1203],"persian":b[2][1204],"roc":b[2][1205]},{"buddhist":b[2][1207],"chinese":b[2][1208],"coptic":b[2][1209],"dangi":b[2][1208],"ethiopic":b[2][1210],"ethioaa":b[2][1211],"generic":b[2][1212],"gregory":b[2][1213],"hebrew":b[2][1214],"indian":b[2][1215],"islamic":b[2][1216],"islamicc":b[2][1216],"japanese":b[2][1217],"persian":b[2][1218],"roc":b[2][1219]},{"buddhist":b[2][1221],"chinese":b[2][1222],"coptic":b[2][1223],"dangi":b[2][1222],"ethiopic":b[2][1224],"ethioaa":b[2][1225],"generic":b[2][1226],"gregory":b[2][1227],"hebrew":b[2][1228],"indian":b[2][1229],"islamic":b[2][1230],"islamicc":b[2][1230],"japanese":b[2][1231],"persian":b[2][1232],"roc":b[2][1233]},{"buddhist":b[2][1235],"chinese":b[2][1236],"coptic":b[2][1237],"dangi":b[2][1236],"ethiopic":b[2][1238],"ethioaa":b[2][1239],"generic":b[2][1240],"gregory":b[2][1241],"hebrew":b[2][1242],"indian":b[2][1243],"islamic":b[2][1244],"islamicc":b[2][1244],"japanese":b[2][1245],"persian":b[2][1246],"roc":b[2][1247]},{"buddhist":b[2][1249],"chinese":b[2][1250],"coptic":b[2][1251],"dangi":b[2][1250],"ethiopic":b[2][1252],"ethioaa":b[2][1253],"generic":b[2][1254],"gregory":b[2][1255],"hebrew":b[2][1256],"indian":b[2][1257],"islamic":b[2][1258],"islamicc":b[2][1258],"japanese":b[2][1259],"persian":b[2][1260],"roc":b[2][1261]},{"buddhist":b[2][1264],"chinese":b[2][1265],"coptic":b[2][1266],"dangi":b[2][1265],"ethiopic":b[2][1267],"ethioaa":b[2][1268],"generic":b[2][1269],"gregory":b[2][1270],"hebrew":b[2][1271],"indian":b[2][1272],"islamic":b[2][1273],"islamicc":b[2][1273],"japanese":b[2][1274],"persian":b[2][1275],"roc":b[2][1276]},{"buddhist":b[2][1278],"chinese":b[2][1279],"coptic":b[2][1280],"dangi":b[2][1279],"ethiopic":b[2][1281],"ethioaa":b[2][1282],"generic":b[2][1283],"gregory":b[2][1284],"hebrew":b[2][1285],"indian":b[2][1286],"islamic":b[2][1287],"islamicc":b[2][1287],"japanese":b[2][1288],"persian":b[2][1289],"roc":b[2][1290]},{"buddhist":b[2][1291],"chinese":b[2][1292],"coptic":b[2][1293],"dangi":b[2][1292],"ethiopic":b[2][1294],"ethioaa":b[2][1295],"generic":b[2][1296],"gregory":b[2][1297],"hebrew":b[2][1298],"indian":b[2][1299],"islamic":b[2][1300],"islamicc":b[2][1300],"japanese":b[2][1301],"persian":b[2][1302],"roc":b[2][1303]},{"buddhist":b[2][1305],"chinese":b[2][1306],"coptic":b[2][1307],"dangi":b[2][1306],"ethiopic":b[2][1308],"ethioaa":b[2][1309],"generic":b[2][1310],"gregory":b[2][1311],"hebrew":b[2][1312],"indian":b[2][1313],"islamic":b[2][1314],"islamicc":b[2][1314],"japanese":b[2][1315],"persian":b[2][1316],"roc":b[2][1317]},{"buddhist":b[2][1319],"chinese":b[2][1320],"coptic":b[2][1321],"dangi":b[2][1320],"ethiopic":b[2][1322],"ethioaa":b[2][1323],"generic":b[2][1324],"gregory":b[2][1325],"hebrew":b[2][1326],"indian":b[2][1327],"islamic":b[2][1328],"islamicc":b[2][1328],"japanese":b[2][1329],"persian":b[2][1330],"roc":b[2][1331]},{"buddhist":b[2][1333],"chinese":b[2][1334],"coptic":b[2][1335],"dangi":b[2][1334],"ethiopic":b[2][1336],"ethioaa":b[2][1337],"generic":b[2][1338],"gregory":b[2][1339],"hebrew":b[2][1340],"indian":b[2][1341],"islamic":b[2][1342],"islamicc":b[2][1342],"japanese":b[2][1343],"persian":b[2][1344],"roc":b[2][1345]},{"buddhist":b[2][1346],"chinese":b[2][1347],"coptic":b[2][1348],"dangi":b[2][1347],"ethiopic":b[2][1349],"ethioaa":b[2][1350],"generic":b[2][1351],"gregory":b[2][1352],"hebrew":b[2][1353],"indian":b[2][1354],"islamic":b[2][1355],"islamicc":b[2][1355],"japanese":b[2][1356],"persian":b[2][1357],"roc":b[2][1358]},{"buddhist":b[2][1359],"chinese":b[2][1360],"coptic":b[2][1361],"dangi":b[2][1360],"ethiopic":b[2][1362],"ethioaa":b[2][1363],"generic":b[2][1364],"gregory":b[2][1365],"hebrew":b[2][1366],"indian":b[2][1367],"islamic":b[2][1368],"islamicc":b[2][1368],"japanese":b[2][1369],"persian":b[2][1370],"roc":b[2][1371]},{"buddhist":b[2][1373],"chinese":b[2][1374],"coptic":b[2][1375],"dangi":b[2][1374],"ethiopic":b[2][1376],"ethioaa":b[2][1377],"generic":b[2][1378],"gregory":b[2][1379],"hebrew":b[2][1380],"indian":b[2][1381],"islamic":b[2][1382],"islamicc":b[2][1382],"japanese":b[2][1383],"persian":b[2][1384],"roc":b[2][1385]},{"buddhist":b[2][1386],"chinese":b[2][1387],"coptic":b[2][1388],"dangi":b[2][1387],"ethiopic":b[2][1389],"ethioaa":b[2][1390],"generic":b[2][1391],"gregory":b[2][1392],"hebrew":b[2][1393],"indian":b[2][1394],"islamic":b[2][1395],"islamicc":b[2][1395],"japanese":b[2][1396],"persian":b[2][1397],"roc":b[2][1398]},{"buddhist":b[2][1399],"chinese":b[2][1400],"coptic":b[2][1401],"dangi":b[2][1400],"ethiopic":b[2][1402],"ethioaa":b[2][1403],"generic":b[2][1404],"gregory":b[2][1405],"hebrew":b[2][1406],"indian":b[2][1407],"islamic":b[2][1408],"islamicc":b[2][1408],"japanese":b[2][1409],"persian":b[2][1410],"roc":b[2][1411]},{"buddhist":b[2][1413],"chinese":b[2][1414],"coptic":b[2][1415],"dangi":b[2][1414],"ethiopic":b[2][1416],"ethioaa":b[2][1417],"generic":b[2][1418],"gregory":b[2][1419],"hebrew":b[2][1420],"indian":b[2][1421],"islamic":b[2][1422],"islamicc":b[2][1422],"japanese":b[2][1423],"persian":b[2][1424],"roc":b[2][1425]},{"buddhist":b[2][1426],"chinese":b[2][1427],"coptic":b[2][1428],"dangi":b[2][1427],"ethiopic":b[2][1429],"ethioaa":b[2][1430],"generic":b[2][1431],"gregory":b[2][1432],"hebrew":b[2][1433],"indian":b[2][1434],"islamic":b[2][1435],"islamicc":b[2][1435],"japanese":b[2][1436],"persian":b[2][1437],"roc":b[2][1438]},{"buddhist":b[2][1440],"chinese":b[2][1441],"coptic":b[2][1442],"dangi":b[2][1441],"ethiopic":b[2][1443],"ethioaa":b[2][1444],"generic":b[2][1445],"gregory":b[2][1446],"hebrew":b[2][1447],"indian":b[2][1448],"islamic":b[2][1449],"islamicc":b[2][1449],"japanese":b[2][1450],"persian":b[2][1451],"roc":b[2][1452]},{"buddhist":b[2][1453],"chinese":b[2][1454],"coptic":b[2][1455],"dangi":b[2][1454],"ethiopic":b[2][1456],"ethioaa":b[2][1457],"generic":b[2][1458],"gregory":b[2][1459],"hebrew":b[2][1460],"indian":b[2][1461],"islamic":b[2][1462],"islamicc":b[2][1462],"japanese":b[2][1463],"persian":b[2][1464],"roc":b[2][1465]},{"buddhist":b[2][1467],"chinese":b[2][1468],"coptic":b[2][1469],"dangi":b[2][1468],"ethiopic":b[2][1470],"ethioaa":b[2][1471],"generic":b[2][1472],"gregory":b[2][1473],"hebrew":b[2][1474],"indian":b[2][1475],"islamic":b[2][1476],"islamicc":b[2][1476],"japanese":b[2][1477],"persian":b[2][1478],"roc":b[2][1479]},{"buddhist":b[2][1481],"chinese":b[2][1482],"coptic":b[2][1483],"dangi":b[2][1482],"ethiopic":b[2][1484],"ethioaa":b[2][1485],"generic":b[2][1486],"gregory":b[2][1487],"hebrew":b[2][1488],"indian":b[2][1489],"islamic":b[2][1490],"islamicc":b[2][1490],"japanese":b[2][1491],"persian":b[2][1492],"roc":b[2][1493]},{"buddhist":b[2][1495],"chinese":b[2][1496],"coptic":b[2][1497],"dangi":b[2][1496],"ethiopic":b[2][1498],"ethioaa":b[2][1499],"generic":b[2][1500],"gregory":b[2][1501],"hebrew":b[2][1502],"indian":b[2][1503],"islamic":b[2][1504],"islamicc":b[2][1504],"japanese":b[2][1505],"persian":b[2][1506],"roc":b[2][1507]},{"buddhist":b[2][1508],"chinese":b[2][1509],"coptic":b[2][1510],"dangi":b[2][1509],"ethiopic":b[2][1511],"ethioaa":b[2][1512],"generic":b[2][1513],"gregory":b[2][1514],"hebrew":b[2][1515],"indian":b[2][1516],"islamic":b[2][1517],"islamicc":b[2][1517],"japanese":b[2][1518],"persian":b[2][1519],"roc":b[2][1520]},{"buddhist":b[2][1522],"chinese":b[2][1523],"coptic":b[2][1524],"dangi":b[2][1523],"ethiopic":b[2][1525],"ethioaa":b[2][1526],"generic":b[2][1527],"gregory":b[2][1528],"hebrew":b[2][1529],"indian":b[2][1530],"islamic":b[2][1531],"islamicc":b[2][1531],"japanese":b[2][1532],"persian":b[2][1533],"roc":b[2][1534]},{"buddhist":b[2][1535],"chinese":b[2][1536],"coptic":b[2][1537],"dangi":b[2][1536],"ethiopic":b[2][1538],"ethioaa":b[2][1539],"generic":b[2][1540],"gregory":b[2][1541],"hebrew":b[2][1542],"indian":b[2][1543],"islamic":b[2][1544],"islamicc":b[2][1544],"japanese":b[2][1545],"persian":b[2][1546],"roc":b[2][1547]},{"buddhist":b[2][1548],"chinese":b[2][1549],"coptic":b[2][1550],"dangi":b[2][1549],"ethiopic":b[2][1551],"ethioaa":b[2][1552],"generic":b[2][1553],"gregory":b[2][1554],"hebrew":b[2][1555],"indian":b[2][1556],"islamic":b[2][1557],"islamicc":b[2][1557],"japanese":b[2][1558],"persian":b[2][1559],"roc":b[2][1560]},{"buddhist":b[2][1562],"chinese":b[2][1563],"coptic":b[2][1564],"dangi":b[2][1563],"ethiopic":b[2][1565],"ethioaa":b[2][1566],"generic":b[2][1567],"gregory":b[2][1568],"hebrew":b[2][1569],"indian":b[2][1570],"islamic":b[2][1571],"islamicc":b[2][1571],"japanese":b[2][1572],"persian":b[2][1573],"roc":b[2][1574]},{"buddhist":b[2][1575],"chinese":b[2][1576],"coptic":b[2][1577],"dangi":b[2][1576],"ethiopic":b[2][1578],"ethioaa":b[2][1579],"generic":b[2][1580],"gregory":b[2][1581],"hebrew":b[2][1582],"indian":b[2][1583],"islamic":b[2][1584],"islamicc":b[2][1584],"japanese":b[2][1585],"persian":b[2][1586],"roc":b[2][1587]},{"buddhist":b[2][1589],"chinese":b[2][1590],"coptic":b[2][1591],"dangi":b[2][1590],"ethiopic":b[2][1592],"ethioaa":b[2][1593],"generic":b[2][1594],"gregory":b[2][1595],"hebrew":b[2][1596],"indian":b[2][1597],"islamic":b[2][1598],"islamicc":b[2][1598],"japanese":b[2][1599],"persian":b[2][1600],"roc":b[2][1601]},{"buddhist":b[2][1603],"chinese":b[2][1604],"coptic":b[2][1605],"dangi":b[2][1604],"ethiopic":b[2][1606],"ethioaa":b[2][1607],"generic":b[2][1608],"gregory":b[2][1609],"hebrew":b[2][1610],"indian":b[2][1611],"islamic":b[2][1612],"islamicc":b[2][1612],"japanese":b[2][1613],"persian":b[2][1614],"roc":b[2][1615]},{"buddhist":b[2][1617],"chinese":b[2][1618],"coptic":b[2][1619],"dangi":b[2][1618],"ethiopic":b[2][1620],"ethioaa":b[2][1621],"generic":b[2][1622],"gregory":b[2][1623],"hebrew":b[2][1624],"indian":b[2][1625],"islamic":b[2][1626],"islamicc":b[2][1626],"japanese":b[2][1627],"persian":b[2][1628],"roc":b[2][1629]},{"buddhist":b[2][1631],"chinese":b[2][1632],"coptic":b[2][1633],"dangi":b[2][1632],"ethiopic":b[2][1634],"ethioaa":b[2][1635],"generic":b[2][1636],"gregory":b[2][1637],"hebrew":b[2][1638],"indian":b[2][1639],"islamic":b[2][1640],"islamicc":b[2][1640],"japanese":b[2][1641],"persian":b[2][1642],"roc":b[2][1643]},{"buddhist":b[2][1645],"chinese":b[2][1646],"coptic":b[2][1647],"dangi":b[2][1646],"ethiopic":b[2][1648],"ethioaa":b[2][1649],"generic":b[2][1650],"gregory":b[2][1651],"hebrew":b[2][1652],"indian":b[2][1653],"islamic":b[2][1654],"islamicc":b[2][1654],"japanese":b[2][1655],"persian":b[2][1656],"roc":b[2][1657]},{"buddhist":b[2][1660],"chinese":b[2][1661],"coptic":b[2][1662],"dangi":b[2][1661],"ethiopic":b[2][1663],"ethioaa":b[2][1664],"generic":b[2][1665],"gregory":b[2][1666],"hebrew":b[2][1667],"indian":b[2][1668],"islamic":b[2][1669],"islamicc":b[2][1669],"japanese":b[2][1670],"persian":b[2][1671],"roc":b[2][1672]},{"buddhist":b[2][1674],"chinese":b[2][1675],"coptic":b[2][1676],"dangi":b[2][1675],"ethiopic":b[2][1677],"ethioaa":b[2][1678],"generic":b[2][1679],"gregory":b[2][1680],"hebrew":b[2][1681],"indian":b[2][1682],"islamic":b[2][1683],"islamicc":b[2][1683],"japanese":b[2][1684],"persian":b[2][1685],"roc":b[2][1686]},{"buddhist":b[2][1688],"chinese":b[2][1689],"coptic":b[2][1690],"dangi":b[2][1689],"ethiopic":b[2][1691],"ethioaa":b[2][1692],"generic":b[2][1693],"gregory":b[2][1694],"hebrew":b[2][1695],"indian":b[2][1696],"islamic":b[2][1697],"islamicc":b[2][1697],"japanese":b[2][1698],"persian":b[2][1699],"roc":b[2][1700]},{"buddhist":b[2][1702],"chinese":b[2][1703],"coptic":b[2][1704],"dangi":b[2][1703],"ethiopic":b[2][1705],"ethioaa":b[2][1706],"generic":b[2][1707],"gregory":b[2][1708],"hebrew":b[2][1709],"indian":b[2][1710],"islamic":b[2][1711],"islamicc":b[2][1711],"japanese":b[2][1712],"persian":b[2][1713],"roc":b[2][1714]},{"buddhist":b[2][1716],"chinese":b[2][1717],"coptic":b[2][1718],"dangi":b[2][1717],"ethiopic":b[2][1719],"ethioaa":b[2][1720],"generic":b[2][1721],"gregory":b[2][1722],"hebrew":b[2][1723],"indian":b[2][1724],"islamic":b[2][1725],"islamicc":b[2][1725],"japanese":b[2][1726],"persian":b[2][1727],"roc":b[2][1728]},{"buddhist":b[2][1730],"chinese":b[2][1731],"coptic":b[2][1732],"dangi":b[2][1731],"ethiopic":b[2][1733],"ethioaa":b[2][1734],"generic":b[2][1735],"gregory":b[2][1736],"hebrew":b[2][1737],"indian":b[2][1738],"islamic":b[2][1739],"islamicc":b[2][1739],"japanese":b[2][1740],"persian":b[2][1741],"roc":b[2][1742]},{"buddhist":b[2][1744],"chinese":b[2][1745],"coptic":b[2][1746],"dangi":b[2][1745],"ethiopic":b[2][1747],"ethioaa":b[2][1748],"generic":b[2][1749],"gregory":b[2][1750],"hebrew":b[2][1751],"indian":b[2][1752],"islamic":b[2][1753],"islamicc":b[2][1753],"japanese":b[2][1754],"persian":b[2][1755],"roc":b[2][1756]},{"buddhist":b[2][1758],"chinese":b[2][1759],"coptic":b[2][1760],"dangi":b[2][1759],"ethiopic":b[2][1761],"ethioaa":b[2][1762],"generic":b[2][1763],"gregory":b[2][1764],"hebrew":b[2][1765],"indian":b[2][1766],"islamic":b[2][1767],"islamicc":b[2][1767],"japanese":b[2][1768],"persian":b[2][1769],"roc":b[2][1770]},{"buddhist":b[2][1771],"chinese":b[2][1772],"coptic":b[2][1773],"dangi":b[2][1772],"ethiopic":b[2][1774],"ethioaa":b[2][1775],"generic":b[2][1776],"gregory":b[2][1777],"hebrew":b[2][1778],"indian":b[2][1779],"islamic":b[2][1780],"islamicc":b[2][1780],"japanese":b[2][1781],"persian":b[2][1782],"roc":b[2][1783]},{"buddhist":b[2][1785],"chinese":b[2][1786],"coptic":b[2][1787],"dangi":b[2][1786],"ethiopic":b[2][1788],"ethioaa":b[2][1789],"generic":b[2][1790],"gregory":b[2][1791],"hebrew":b[2][1792],"indian":b[2][1793],"islamic":b[2][1794],"islamicc":b[2][1794],"japanese":b[2][1795],"persian":b[2][1796],"roc":b[2][1797]},{"buddhist":b[2][1799],"chinese":b[2][1800],"coptic":b[2][1801],"dangi":b[2][1800],"ethiopic":b[2][1802],"ethioaa":b[2][1803],"generic":b[2][1804],"gregory":b[2][1805],"hebrew":b[2][1806],"indian":b[2][1807],"islamic":b[2][1808],"islamicc":b[2][1808],"japanese":b[2][1809],"persian":b[2][1810],"roc":b[2][1811]},{"buddhist":b[2][1813],"chinese":b[2][1814],"coptic":b[2][1815],"dangi":b[2][1814],"ethiopic":b[2][1816],"ethioaa":b[2][1817],"generic":b[2][1818],"gregory":b[2][1819],"hebrew":b[2][1820],"indian":b[2][1821],"islamic":b[2][1822],"islamicc":b[2][1822],"japanese":b[2][1823],"persian":b[2][1824],"roc":b[2][1825]},{"buddhist":b[2][1826],"chinese":b[2][1827],"coptic":b[2][1828],"dangi":b[2][1827],"ethiopic":b[2][1829],"ethioaa":b[2][1830],"generic":b[2][1831],"gregory":b[2][1832],"hebrew":b[2][1833],"indian":b[2][1834],"islamic":b[2][1835],"islamicc":b[2][1835],"japanese":b[2][1836],"persian":b[2][1837],"roc":b[2][1838]},{"buddhist":b[2][1840],"chinese":b[2][1841],"coptic":b[2][1842],"dangi":b[2][1841],"ethiopic":b[2][1843],"ethioaa":b[2][1844],"generic":b[2][1845],"gregory":b[2][1846],"hebrew":b[2][1847],"indian":b[2][1848],"islamic":b[2][1849],"islamicc":b[2][1849],"japanese":b[2][1850],"persian":b[2][1851],"roc":b[2][1852]},{"buddhist":b[2][1854],"chinese":b[2][1855],"coptic":b[2][1856],"dangi":b[2][1855],"ethiopic":b[2][1857],"ethioaa":b[2][1858],"generic":b[2][1859],"gregory":b[2][1860],"hebrew":b[2][1861],"indian":b[2][1862],"islamic":b[2][1863],"islamicc":b[2][1863],"japanese":b[2][1864],"persian":b[2][1865],"roc":b[2][1866]},{"buddhist":b[2][1868],"chinese":b[2][1869],"coptic":b[2][1870],"dangi":b[2][1869],"ethiopic":b[2][1871],"ethioaa":b[2][1872],"generic":b[2][1873],"gregory":b[2][1874],"hebrew":b[2][1875],"indian":b[2][1876],"islamic":b[2][1877],"islamicc":b[2][1877],"japanese":b[2][1878],"persian":b[2][1879],"roc":b[2][1880]},{"buddhist":b[2][1882],"chinese":b[2][1883],"coptic":b[2][1884],"dangi":b[2][1883],"ethiopic":b[2][1885],"ethioaa":b[2][1886],"generic":b[2][1887],"gregory":b[2][1888],"hebrew":b[2][1889],"indian":b[2][1890],"islamic":b[2][1891],"islamicc":b[2][1891],"japanese":b[2][1892],"persian":b[2][1893],"roc":b[2][1894]},{"buddhist":b[2][1898],"chinese":b[2][1899],"coptic":b[2][1900],"dangi":b[2][1899],"ethiopic":b[2][1901],"ethioaa":b[2][1902],"generic":b[2][1903],"gregory":b[2][1904],"hebrew":b[2][1905],"indian":b[2][1906],"islamic":b[2][1907],"islamicc":b[2][1907],"japanese":b[2][1908],"persian":b[2][1909],"roc":b[2][1910]},{"buddhist":b[2][1911],"chinese":b[2][1912],"coptic":b[2][1913],"dangi":b[2][1912],"ethiopic":b[2][1914],"ethioaa":b[2][1915],"generic":b[2][1916],"gregory":b[2][1917],"hebrew":b[2][1918],"indian":b[2][1919],"islamic":b[2][1920],"islamicc":b[2][1920],"japanese":b[2][1921],"persian":b[2][1922],"roc":b[2][1923]},{"buddhist":b[2][1925],"chinese":b[2][1926],"coptic":b[2][1927],"dangi":b[2][1926],"ethiopic":b[2][1928],"ethioaa":b[2][1929],"generic":b[2][1930],"gregory":b[2][1931],"hebrew":b[2][1932],"indian":b[2][1933],"islamic":b[2][1934],"islamicc":b[2][1934],"japanese":b[2][1935],"persian":b[2][1936],"roc":b[2][1937]},{"buddhist":b[2][1939],"chinese":b[2][1940],"coptic":b[2][1941],"dangi":b[2][1940],"ethiopic":b[2][1942],"ethioaa":b[2][1943],"generic":b[2][1944],"gregory":b[2][1945],"hebrew":b[2][1946],"indian":b[2][1947],"islamic":b[2][1948],"islamicc":b[2][1948],"japanese":b[2][1949],"persian":b[2][1950],"roc":b[2][1951]},{"buddhist":b[2][1953],"chinese":b[2][1954],"coptic":b[2][1955],"dangi":b[2][1954],"ethiopic":b[2][1956],"ethioaa":b[2][1957],"generic":b[2][1958],"gregory":b[2][1959],"hebrew":b[2][1960],"indian":b[2][1961],"islamic":b[2][1962],"islamicc":b[2][1962],"japanese":b[2][1963],"persian":b[2][1964],"roc":b[2][1965]},{"buddhist":b[2][1967],"chinese":b[2][1968],"coptic":b[2][1969],"dangi":b[2][1968],"ethiopic":b[2][1970],"ethioaa":b[2][1971],"generic":b[2][1972],"gregory":b[2][1973],"hebrew":b[2][1974],"indian":b[2][1975],"islamic":b[2][1976],"islamicc":b[2][1976],"japanese":b[2][1977],"persian":b[2][1978],"roc":b[2][1979]},{"buddhist":b[2][1980],"chinese":b[2][1981],"coptic":b[2][1982],"dangi":b[2][1981],"ethiopic":b[2][1983],"ethioaa":b[2][1984],"generic":b[2][1985],"gregory":b[2][1986],"hebrew":b[2][1987],"indian":b[2][1988],"islamic":b[2][1989],"islamicc":b[2][1989],"japanese":b[2][1990],"persian":b[2][1991],"roc":b[2][1992]},{"buddhist":b[2][1994],"chinese":b[2][1995],"coptic":b[2][1996],"dangi":b[2][1995],"ethiopic":b[2][1997],"ethioaa":b[2][1998],"generic":b[2][1999],"gregory":b[2][2000],"hebrew":b[2][2001],"indian":b[2][2002],"islamic":b[2][2003],"islamicc":b[2][2003],"japanese":b[2][2004],"persian":b[2][2005],"roc":b[2][2006]},{"buddhist":b[2][2007],"chinese":b[2][2008],"coptic":b[2][2009],"dangi":b[2][2008],"ethiopic":b[2][2010],"ethioaa":b[2][2011],"generic":b[2][2012],"gregory":b[2][2013],"hebrew":b[2][2014],"indian":b[2][2015],"islamic":b[2][2016],"islamicc":b[2][2016],"japanese":b[2][2017],"persian":b[2][2018],"roc":b[2][2019]},{"buddhist":b[2][2025],"chinese":b[2][2026],"coptic":b[2][2027],"dangi":b[2][2026],"ethiopic":b[2][2028],"ethioaa":b[2][2029],"generic":b[2][2030],"gregory":b[2][2031],"hebrew":b[2][2032],"indian":b[2][2033],"islamic":b[2][2034],"islamicc":b[2][2034],"japanese":b[2][2035],"persian":b[2][2036],"roc":b[2][2037]},{"buddhist":b[2][2038],"chinese":b[2][2039],"coptic":b[2][2040],"dangi":b[2][2039],"ethiopic":b[2][2041],"ethioaa":b[2][2042],"generic":b[2][2043],"gregory":b[2][2044],"hebrew":b[2][2045],"indian":b[2][2046],"islamic":b[2][2047],"islamicc":b[2][2047],"japanese":b[2][2048],"persian":b[2][2049],"roc":b[2][2050]},{"buddhist":b[2][2052],"chinese":b[2][2053],"coptic":b[2][2054],"dangi":b[2][2053],"ethiopic":b[2][2055],"ethioaa":b[2][2056],"generic":b[2][2057],"gregory":b[2][2058],"hebrew":b[2][2059],"indian":b[2][2060],"islamic":b[2][2061],"islamicc":b[2][2061],"japanese":b[2][2062],"persian":b[2][2063],"roc":b[2][2064]},{"buddhist":b[2][2065],"chinese":b[2][2066],"coptic":b[2][2067],"dangi":b[2][2066],"ethiopic":b[2][2068],"ethioaa":b[2][2069],"generic":b[2][2070],"gregory":b[2][2071],"hebrew":b[2][2072],"indian":b[2][2073],"islamic":b[2][2074],"islamicc":b[2][2074],"japanese":b[2][2075],"persian":b[2][2076],"roc":b[2][2077]},{"buddhist":b[2][2079],"chinese":b[2][2080],"coptic":b[2][2081],"dangi":b[2][2080],"ethiopic":b[2][2082],"ethioaa":b[2][2083],"generic":b[2][2084],"gregory":b[2][2085],"hebrew":b[2][2086],"indian":b[2][2087],"islamic":b[2][2088],"islamicc":b[2][2088],"japanese":b[2][2089],"persian":b[2][2090],"roc":b[2][2091]},{"buddhist":b[2][2093],"chinese":b[2][2094],"coptic":b[2][2095],"dangi":b[2][2094],"ethiopic":b[2][2096],"ethioaa":b[2][2097],"generic":b[2][2098],"gregory":b[2][2099],"hebrew":b[2][2100],"indian":b[2][2101],"islamic":b[2][2102],"islamicc":b[2][2102],"japanese":b[2][2103],"persian":b[2][2104],"roc":b[2][2105]},{"buddhist":b[2][2106],"chinese":b[2][2107],"coptic":b[2][2108],"dangi":b[2][2107],"ethiopic":b[2][2109],"ethioaa":b[2][2110],"generic":b[2][2111],"gregory":b[2][2112],"hebrew":b[2][2113],"indian":b[2][2114],"islamic":b[2][2115],"islamicc":b[2][2115],"japanese":b[2][2116],"persian":b[2][2117],"roc":b[2][2118]},{"buddhist":b[2][2120],"chinese":b[2][2121],"coptic":b[2][2122],"dangi":b[2][2121],"ethiopic":b[2][2123],"ethioaa":b[2][2124],"generic":b[2][2125],"gregory":b[2][2126],"hebrew":b[2][2127],"indian":b[2][2128],"islamic":b[2][2129],"islamicc":b[2][2129],"japanese":b[2][2130],"persian":b[2][2131],"roc":b[2][2132]},{"buddhist":b[2][2134],"chinese":b[2][2135],"coptic":b[2][2136],"dangi":b[2][2135],"ethiopic":b[2][2137],"ethioaa":b[2][2138],"generic":b[2][2139],"gregory":b[2][2140],"hebrew":b[2][2141],"indian":b[2][2142],"islamic":b[2][2143],"islamicc":b[2][2143],"japanese":b[2][2144],"persian":b[2][2145],"roc":b[2][2146]},{"buddhist":b[2][2149],"chinese":b[2][2150],"coptic":b[2][2151],"dangi":b[2][2150],"ethiopic":b[2][2152],"ethioaa":b[2][2153],"generic":b[2][2154],"gregory":b[2][2155],"hebrew":b[2][2156],"indian":b[2][2157],"islamic":b[2][2158],"islamicc":b[2][2158],"japanese":b[2][2159],"persian":b[2][2160],"roc":b[2][2161]},{"buddhist":b[2][2163],"chinese":b[2][2164],"coptic":b[2][2165],"dangi":b[2][2164],"ethiopic":b[2][2166],"ethioaa":b[2][2167],"generic":b[2][2168],"gregory":b[2][2169],"hebrew":b[2][2170],"indian":b[2][2171],"islamic":b[2][2172],"islamicc":b[2][2172],"japanese":b[2][2173],"persian":b[2][2174],"roc":b[2][2175]},{"buddhist":b[2][2177],"chinese":b[2][2178],"coptic":b[2][2179],"dangi":b[2][2178],"ethiopic":b[2][2180],"ethioaa":b[2][2181],"generic":b[2][2182],"gregory":b[2][2183],"hebrew":b[2][2184],"indian":b[2][2185],"islamic":b[2][2186],"islamicc":b[2][2186],"japanese":b[2][2187],"persian":b[2][2188],"roc":b[2][2189]},{"buddhist":b[2][2191],"chinese":b[2][2192],"coptic":b[2][2193],"dangi":b[2][2192],"ethiopic":b[2][2194],"ethioaa":b[2][2195],"generic":b[2][2196],"gregory":b[2][2197],"hebrew":b[2][2198],"indian":b[2][2199],"islamic":b[2][2200],"islamicc":b[2][2200],"japanese":b[2][2201],"persian":b[2][2202],"roc":b[2][2203]},{"buddhist":b[2][2205],"chinese":b[2][2206],"coptic":b[2][2207],"dangi":b[2][2206],"ethiopic":b[2][2208],"ethioaa":b[2][2209],"generic":b[2][2210],"gregory":b[2][2211],"hebrew":b[2][2212],"indian":b[2][2213],"islamic":b[2][2214],"islamicc":b[2][2214],"japanese":b[2][2215],"persian":b[2][2216],"roc":b[2][2217]},{"buddhist":b[2][2219],"chinese":b[2][2220],"coptic":b[2][2221],"dangi":b[2][2220],"ethiopic":b[2][2222],"ethioaa":b[2][2223],"generic":b[2][2224],"gregory":b[2][2225],"hebrew":b[2][2226],"indian":b[2][2227],"islamic":b[2][2228],"islamicc":b[2][2228],"japanese":b[2][2229],"persian":b[2][2230],"roc":b[2][2231]},{"buddhist":b[2][2238],"chinese":b[2][2239],"coptic":b[2][2240],"dangi":b[2][2239],"ethiopic":b[2][2241],"ethioaa":b[2][2242],"generic":b[2][2243],"gregory":b[2][2244],"hebrew":b[2][2245],"indian":b[2][2246],"islamic":b[2][2247],"islamicc":b[2][2247],"japanese":b[2][2248],"persian":b[2][2249],"roc":b[2][2250]},{"buddhist":b[2][2254],"chinese":b[2][2255],"coptic":b[2][2256],"dangi":b[2][2255],"ethiopic":b[2][2257],"ethioaa":b[2][2258],"generic":b[2][2259],"gregory":b[2][2260],"hebrew":b[2][2261],"indian":b[2][2262],"islamic":b[2][2263],"islamicc":b[2][2263],"japanese":b[2][2264],"persian":b[2][2265],"roc":b[2][2266]},{"buddhist":b[2][2268],"chinese":b[2][2269],"coptic":b[2][2270],"dangi":b[2][2269],"ethiopic":b[2][2271],"ethioaa":b[2][2272],"generic":b[2][2273],"gregory":b[2][2274],"hebrew":b[2][2275],"indian":b[2][2276],"islamic":b[2][2277],"islamicc":b[2][2277],"japanese":b[2][2278],"persian":b[2][2279],"roc":b[2][2280]},{"buddhist":b[2][2282],"chinese":b[2][2283],"coptic":b[2][2284],"dangi":b[2][2283],"ethiopic":b[2][2285],"ethioaa":b[2][2286],"generic":b[2][2287],"gregory":b[2][2288],"hebrew":b[2][2289],"indian":b[2][2290],"islamic":b[2][2291],"islamicc":b[2][2291],"japanese":b[2][2292],"persian":b[2][2293],"roc":b[2][2294]},{"buddhist":b[2][2297],"chinese":b[2][2298],"coptic":b[2][2299],"dangi":b[2][2298],"ethiopic":b[2][2300],"ethioaa":b[2][2301],"generic":b[2][2302],"gregory":b[2][2303],"hebrew":b[2][2304],"indian":b[2][2305],"islamic":b[2][2306],"islamicc":b[2][2306],"japanese":b[2][2307],"persian":b[2][2308],"roc":b[2][2309]},{"buddhist":b[2][2310],"chinese":b[2][2311],"coptic":b[2][2312],"dangi":b[2][2311],"ethiopic":b[2][2313],"ethioaa":b[2][2314],"generic":b[2][2315],"gregory":b[2][2316],"hebrew":b[2][2317],"indian":b[2][2318],"islamic":b[2][2319],"islamicc":b[2][2319],"japanese":b[2][2320],"persian":b[2][2321],"roc":b[2][2322]},{"buddhist":b[2][2328],"chinese":b[2][2329],"coptic":b[2][2330],"dangi":b[2][2329],"ethiopic":b[2][2331],"ethioaa":b[2][2332],"generic":b[2][2333],"gregory":b[2][2334],"hebrew":b[2][2335],"indian":b[2][2336],"islamic":b[2][2337],"islamicc":b[2][2337],"japanese":b[2][2338],"persian":b[2][2339],"roc":b[2][2340]},{"buddhist":b[2][2342],"chinese":b[2][2343],"coptic":b[2][2344],"dangi":b[2][2343],"ethiopic":b[2][2345],"ethioaa":b[2][2346],"generic":b[2][2347],"gregory":b[2][2348],"hebrew":b[2][2349],"indian":b[2][2350],"islamic":b[2][2351],"islamicc":b[2][2351],"japanese":b[2][2352],"persian":b[2][2353],"roc":b[2][2354]},{"buddhist":b[2][2356],"chinese":b[2][2357],"coptic":b[2][2358],"dangi":b[2][2357],"ethiopic":b[2][2359],"ethioaa":b[2][2360],"generic":b[2][2361],"gregory":b[2][2362],"hebrew":b[2][2363],"indian":b[2][2364],"islamic":b[2][2365],"islamicc":b[2][2365],"japanese":b[2][2366],"persian":b[2][2367],"roc":b[2][2368]},{"buddhist":b[2][2369],"chinese":b[2][2370],"coptic":b[2][2371],"dangi":b[2][2370],"ethiopic":b[2][2372],"ethioaa":b[2][2373],"generic":b[2][2374],"gregory":b[2][2375],"hebrew":b[2][2376],"indian":b[2][2377],"islamic":b[2][2378],"islamicc":b[2][2378],"japanese":b[2][2379],"persian":b[2][2380],"roc":b[2][2381]},{"buddhist":b[2][2382],"chinese":b[2][2383],"coptic":b[2][2384],"dangi":b[2][2383],"ethiopic":b[2][2385],"ethioaa":b[2][2386],"generic":b[2][2387],"gregory":b[2][2388],"hebrew":b[2][2389],"indian":b[2][2390],"islamic":b[2][2391],"islamicc":b[2][2391],"japanese":b[2][2392],"persian":b[2][2393],"roc":b[2][2394]},{"buddhist":b[2][2396],"chinese":b[2][2397],"coptic":b[2][2398],"dangi":b[2][2397],"ethiopic":b[2][2399],"ethioaa":b[2][2400],"generic":b[2][2401],"gregory":b[2][2402],"hebrew":b[2][2403],"indian":b[2][2404],"islamic":b[2][2405],"islamicc":b[2][2405],"japanese":b[2][2406],"persian":b[2][2407],"roc":b[2][2408]},{"buddhist":b[2][2410],"chinese":b[2][2411],"coptic":b[2][2412],"dangi":b[2][2411],"ethiopic":b[2][2413],"ethioaa":b[2][2414],"generic":b[2][2415],"gregory":b[2][2416],"hebrew":b[2][2417],"indian":b[2][2418],"islamic":b[2][2419],"islamicc":b[2][2419],"japanese":b[2][2420],"persian":b[2][2421],"roc":b[2][2422]},{"buddhist":b[2][2424],"chinese":b[2][2425],"coptic":b[2][2426],"dangi":b[2][2425],"ethiopic":b[2][2427],"ethioaa":b[2][2428],"generic":b[2][2429],"gregory":b[2][2430],"hebrew":b[2][2431],"indian":b[2][2432],"islamic":b[2][2433],"islamicc":b[2][2433],"japanese":b[2][2434],"persian":b[2][2435],"roc":b[2][2436]},{"buddhist":b[2][2437],"chinese":b[2][2438],"coptic":b[2][2439],"dangi":b[2][2438],"ethiopic":b[2][2440],"ethioaa":b[2][2441],"generic":b[2][2442],"gregory":b[2][2443],"hebrew":b[2][2444],"indian":b[2][2445],"islamic":b[2][2446],"islamicc":b[2][2446],"japanese":b[2][2447],"persian":b[2][2448],"roc":b[2][2449]},{"buddhist":b[2][2451],"chinese":b[2][2452],"coptic":b[2][2453],"dangi":b[2][2452],"ethiopic":b[2][2454],"ethioaa":b[2][2455],"generic":b[2][2456],"gregory":b[2][2457],"hebrew":b[2][2458],"indian":b[2][2459],"islamic":b[2][2460],"islamicc":b[2][2460],"japanese":b[2][2461],"persian":b[2][2462],"roc":b[2][2463]},{"buddhist":b[2][2464],"chinese":b[2][2465],"coptic":b[2][2466],"dangi":b[2][2465],"ethiopic":b[2][2467],"ethioaa":b[2][2468],"generic":b[2][2469],"gregory":b[2][2470],"hebrew":b[2][2471],"indian":b[2][2472],"islamic":b[2][2473],"islamicc":b[2][2473],"japanese":b[2][2474],"persian":b[2][2475],"roc":b[2][2476]},{"buddhist":b[2][2477],"chinese":b[2][2478],"coptic":b[2][2479],"dangi":b[2][2478],"ethiopic":b[2][2480],"ethioaa":b[2][2481],"generic":b[2][2482],"gregory":b[2][2483],"hebrew":b[2][2484],"indian":b[2][2485],"islamic":b[2][2486],"islamicc":b[2][2486],"japanese":b[2][2487],"persian":b[2][2488],"roc":b[2][2489]},{"buddhist":b[2][2491],"chinese":b[2][2492],"coptic":b[2][2493],"dangi":b[2][2492],"ethiopic":b[2][2494],"ethioaa":b[2][2495],"generic":b[2][2496],"gregory":b[2][2497],"hebrew":b[2][2498],"indian":b[2][2499],"islamic":b[2][2500],"islamicc":b[2][2500],"japanese":b[2][2501],"persian":b[2][2502],"roc":b[2][2503]},{"buddhist":b[2][2505],"chinese":b[2][2506],"coptic":b[2][2507],"dangi":b[2][2506],"ethiopic":b[2][2508],"ethioaa":b[2][2509],"generic":b[2][2510],"gregory":b[2][2511],"hebrew":b[2][2512],"indian":b[2][2513],"islamic":b[2][2514],"islamicc":b[2][2514],"japanese":b[2][2515],"persian":b[2][2516],"roc":b[2][2517]},{"buddhist":b[2][2519],"chinese":b[2][2520],"coptic":b[2][2521],"dangi":b[2][2520],"ethiopic":b[2][2522],"ethioaa":b[2][2523],"generic":b[2][2524],"gregory":b[2][2525],"hebrew":b[2][2526],"indian":b[2][2527],"islamic":b[2][2528],"islamicc":b[2][2528],"japanese":b[2][2529],"persian":b[2][2530],"roc":b[2][2531]},{"buddhist":b[2][2533],"chinese":b[2][2534],"coptic":b[2][2535],"dangi":b[2][2534],"ethiopic":b[2][2536],"ethioaa":b[2][2537],"generic":b[2][2538],"gregory":b[2][2539],"hebrew":b[2][2540],"indian":b[2][2541],"islamic":b[2][2542],"islamicc":b[2][2542],"japanese":b[2][2543],"persian":b[2][2544],"roc":b[2][2545]},{"buddhist":b[2][2546],"chinese":b[2][2547],"coptic":b[2][2548],"dangi":b[2][2547],"ethiopic":b[2][2549],"ethioaa":b[2][2550],"generic":b[2][2551],"gregory":b[2][2552],"hebrew":b[2][2553],"indian":b[2][2554],"islamic":b[2][2555],"islamicc":b[2][2555],"japanese":b[2][2556],"persian":b[2][2557],"roc":b[2][2558]},{"buddhist":b[2][2563],"chinese":b[2][2564],"coptic":b[2][2565],"dangi":b[2][2564],"ethiopic":b[2][2566],"ethioaa":b[2][2567],"generic":b[2][2568],"gregory":b[2][2569],"hebrew":b[2][2570],"indian":b[2][2571],"islamic":b[2][2572],"islamicc":b[2][2572],"japanese":b[2][2573],"persian":b[2][2574],"roc":b[2][2575]},{"buddhist":b[2][2578],"chinese":b[2][2579],"coptic":b[2][2580],"dangi":b[2][2579],"ethiopic":b[2][2581],"ethioaa":b[2][2582],"generic":b[2][2583],"gregory":b[2][2584],"hebrew":b[2][2585],"indian":b[2][2586],"islamic":b[2][2587],"islamicc":b[2][2587],"japanese":b[2][2588],"persian":b[2][2589],"roc":b[2][2590]},{"buddhist":b[2][2592],"chinese":b[2][2593],"coptic":b[2][2594],"dangi":b[2][2593],"ethiopic":b[2][2595],"ethioaa":b[2][2596],"generic":b[2][2597],"gregory":b[2][2598],"hebrew":b[2][2599],"indian":b[2][2600],"islamic":b[2][2601],"islamicc":b[2][2601],"japanese":b[2][2602],"persian":b[2][2603],"roc":b[2][2604]},{"buddhist":b[2][2605],"chinese":b[2][2606],"coptic":b[2][2607],"dangi":b[2][2606],"ethiopic":b[2][2608],"ethioaa":b[2][2609],"generic":b[2][2610],"gregory":b[2][2611],"hebrew":b[2][2612],"indian":b[2][2613],"islamic":b[2][2614],"islamicc":b[2][2614],"japanese":b[2][2615],"persian":b[2][2616],"roc":b[2][2617]},{"buddhist":b[2][2619],"chinese":b[2][2620],"coptic":b[2][2621],"dangi":b[2][2620],"ethiopic":b[2][2622],"ethioaa":b[2][2623],"generic":b[2][2624],"gregory":b[2][2625],"hebrew":b[2][2626],"indian":b[2][2627],"islamic":b[2][2628],"islamicc":b[2][2628],"japanese":b[2][2629],"persian":b[2][2630],"roc":b[2][2631]},{"buddhist":b[2][2632],"chinese":b[2][2633],"coptic":b[2][2634],"dangi":b[2][2633],"ethiopic":b[2][2635],"ethioaa":b[2][2636],"generic":b[2][2637],"gregory":b[2][2638],"hebrew":b[2][2639],"indian":b[2][2640],"islamic":b[2][2641],"islamicc":b[2][2641],"japanese":b[2][2642],"persian":b[2][2643],"roc":b[2][2644]},{"buddhist":b[2][2646],"chinese":b[2][2647],"coptic":b[2][2648],"dangi":b[2][2647],"ethiopic":b[2][2649],"ethioaa":b[2][2650],"generic":b[2][2651],"gregory":b[2][2652],"hebrew":b[2][2653],"indian":b[2][2654],"islamic":b[2][2655],"islamicc":b[2][2655],"japanese":b[2][2656],"persian":b[2][2657],"roc":b[2][2658]},{"buddhist":b[2][2660],"chinese":b[2][2661],"coptic":b[2][2662],"dangi":b[2][2661],"ethiopic":b[2][2663],"ethioaa":b[2][2664],"generic":b[2][2665],"gregory":b[2][2666],"hebrew":b[2][2667],"indian":b[2][2668],"islamic":b[2][2669],"islamicc":b[2][2669],"japanese":b[2][2670],"persian":b[2][2671],"roc":b[2][2672]},{"buddhist":b[2][2660],"chinese":b[2][2661],"coptic":b[2][2662],"dangi":b[2][2661],"ethiopic":b[2][2663],"ethioaa":b[2][2664],"generic":b[2][2665],"gregory":b[2][2674],"hebrew":b[2][2667],"indian":b[2][2668],"islamic":b[2][2669],"islamicc":b[2][2669],"japanese":b[2][2670],"persian":b[2][2671],"roc":b[2][2672]},{"buddhist":b[2][2675],"chinese":b[2][2676],"coptic":b[2][2677],"dangi":b[2][2676],"ethiopic":b[2][2678],"ethioaa":b[2][2679],"generic":b[2][2680],"gregory":b[2][2681],"hebrew":b[2][2682],"indian":b[2][2683],"islamic":b[2][2684],"islamicc":b[2][2684],"japanese":b[2][2685],"persian":b[2][2686],"roc":b[2][2687]},{"buddhist":b[2][2690],"chinese":b[2][2691],"coptic":b[2][2692],"dangi":b[2][2691],"ethiopic":b[2][2693],"ethioaa":b[2][2694],"generic":b[2][2695],"gregory":b[2][2696],"hebrew":b[2][2697],"indian":b[2][2698],"islamic":b[2][2699],"islamicc":b[2][2699],"japanese":b[2][2700],"persian":b[2][2701],"roc":b[2][2702]},{"buddhist":b[2][2704],"chinese":b[2][2705],"coptic":b[2][2706],"dangi":b[2][2705],"ethiopic":b[2][2707],"ethioaa":b[2][2708],"generic":b[2][2709],"gregory":b[2][2710],"hebrew":b[2][2711],"indian":b[2][2712],"islamic":b[2][2713],"islamicc":b[2][2713],"japanese":b[2][2714],"persian":b[2][2715],"roc":b[2][2716]},{"buddhist":b[2][2721],"chinese":b[2][2722],"coptic":b[2][2723],"dangi":b[2][2722],"ethiopic":b[2][2724],"ethioaa":b[2][2725],"generic":b[2][2726],"gregory":b[2][2727],"hebrew":b[2][2728],"indian":b[2][2729],"islamic":b[2][2730],"islamicc":b[2][2730],"japanese":b[2][2731],"persian":b[2][2732],"roc":b[2][2733]},{"buddhist":b[2][2735],"chinese":b[2][2736],"coptic":b[2][2737],"dangi":b[2][2736],"ethiopic":b[2][2738],"ethioaa":b[2][2739],"generic":b[2][2740],"gregory":b[2][2741],"hebrew":b[2][2742],"indian":b[2][2743],"islamic":b[2][2744],"islamicc":b[2][2744],"japanese":b[2][2745],"persian":b[2][2746],"roc":b[2][2747]},{"buddhist":b[2][2749],"chinese":b[2][2750],"coptic":b[2][2751],"dangi":b[2][2750],"ethiopic":b[2][2752],"ethioaa":b[2][2753],"generic":b[2][2754],"gregory":b[2][2755],"hebrew":b[2][2756],"indian":b[2][2757],"islamic":b[2][2758],"islamicc":b[2][2758],"japanese":b[2][2759],"persian":b[2][2760],"roc":b[2][2761]},{"buddhist":b[2][2763],"chinese":b[2][2764],"coptic":b[2][2765],"dangi":b[2][2764],"ethiopic":b[2][2766],"ethioaa":b[2][2767],"generic":b[2][2768],"gregory":b[2][2769],"hebrew":b[2][2770],"indian":b[2][2771],"islamic":b[2][2772],"islamicc":b[2][2772],"japanese":b[2][2773],"persian":b[2][2774],"roc":b[2][2775]},{"buddhist":b[2][2776],"chinese":b[2][2777],"coptic":b[2][2778],"dangi":b[2][2777],"ethiopic":b[2][2779],"ethioaa":b[2][2780],"generic":b[2][2781],"gregory":b[2][2782],"hebrew":b[2][2783],"indian":b[2][2784],"islamic":b[2][2785],"islamicc":b[2][2785],"japanese":b[2][2786],"persian":b[2][2787],"roc":b[2][2788]},{"buddhist":b[2][2789],"chinese":b[2][2790],"coptic":b[2][2791],"dangi":b[2][2790],"ethiopic":b[2][2792],"ethioaa":b[2][2793],"generic":b[2][2794],"gregory":b[2][2795],"hebrew":b[2][2796],"indian":b[2][2797],"islamic":b[2][2798],"islamicc":b[2][2798],"japanese":b[2][2799],"persian":b[2][2800],"roc":b[2][2801]},{"buddhist":b[2][2803],"chinese":b[2][2804],"coptic":b[2][2805],"dangi":b[2][2804],"ethiopic":b[2][2806],"ethioaa":b[2][2807],"generic":b[2][2808],"gregory":b[2][2809],"hebrew":b[2][2810],"indian":b[2][2811],"islamic":b[2][2812],"islamicc":b[2][2812],"japanese":b[2][2813],"persian":b[2][2814],"roc":b[2][2815]},{"buddhist":b[2][2817],"chinese":b[2][2818],"coptic":b[2][2819],"dangi":b[2][2818],"ethiopic":b[2][2820],"ethioaa":b[2][2821],"generic":b[2][2822],"gregory":b[2][2823],"hebrew":b[2][2824],"indian":b[2][2825],"islamic":b[2][2826],"islamicc":b[2][2826],"japanese":b[2][2827],"persian":b[2][2828],"roc":b[2][2829]},{"buddhist":b[2][2831],"chinese":b[2][2832],"coptic":b[2][2833],"dangi":b[2][2832],"ethiopic":b[2][2834],"ethioaa":b[2][2835],"generic":b[2][2836],"gregory":b[2][2837],"hebrew":b[2][2838],"indian":b[2][2839],"islamic":b[2][2840],"islamicc":b[2][2840],"japanese":b[2][2841],"persian":b[2][2842],"roc":b[2][2843]},{"buddhist":b[2][2844],"chinese":b[2][2845],"coptic":b[2][2846],"dangi":b[2][2845],"ethiopic":b[2][2847],"ethioaa":b[2][2848],"generic":b[2][2849],"gregory":b[2][2850],"hebrew":b[2][2851],"indian":b[2][2852],"islamic":b[2][2853],"islamicc":b[2][2853],"japanese":b[2][2854],"persian":b[2][2855],"roc":b[2][2856]},{"buddhist":b[2][2857],"chinese":b[2][2858],"coptic":b[2][2859],"dangi":b[2][2858],"ethiopic":b[2][2860],"ethioaa":b[2][2861],"generic":b[2][2862],"gregory":b[2][2863],"hebrew":b[2][2864],"indian":b[2][2865],"islamic":b[2][2866],"islamicc":b[2][2866],"japanese":b[2][2867],"persian":b[2][2868],"roc":b[2][2869]},{"buddhist":b[2][2870],"chinese":b[2][2871],"coptic":b[2][2872],"dangi":b[2][2871],"ethiopic":b[2][2873],"ethioaa":b[2][2874],"generic":b[2][2875],"gregory":b[2][2876],"hebrew":b[2][2877],"indian":b[2][2878],"islamic":b[2][2879],"islamicc":b[2][2879],"japanese":b[2][2880],"persian":b[2][2881],"roc":b[2][2882]},{"buddhist":b[2][2884],"chinese":b[2][2885],"coptic":b[2][2886],"dangi":b[2][2885],"ethiopic":b[2][2887],"ethioaa":b[2][2888],"generic":b[2][2889],"gregory":b[2][2890],"hebrew":b[2][2891],"indian":b[2][2892],"islamic":b[2][2893],"islamicc":b[2][2893],"japanese":b[2][2894],"persian":b[2][2895],"roc":b[2][2896]},{"buddhist":b[2][2898],"chinese":b[2][2899],"coptic":b[2][2900],"dangi":b[2][2899],"ethiopic":b[2][2901],"ethioaa":b[2][2902],"generic":b[2][2903],"gregory":b[2][2904],"hebrew":b[2][2905],"indian":b[2][2906],"islamic":b[2][2907],"islamicc":b[2][2907],"japanese":b[2][2908],"persian":b[2][2909],"roc":b[2][2910]},{"buddhist":b[2][2912],"chinese":b[2][2913],"coptic":b[2][2914],"dangi":b[2][2913],"ethiopic":b[2][2915],"ethioaa":b[2][2916],"generic":b[2][2917],"gregory":b[2][2918],"hebrew":b[2][2919],"indian":b[2][2920],"islamic":b[2][2921],"islamicc":b[2][2921],"japanese":b[2][2922],"persian":b[2][2923],"roc":b[2][2924]},{"buddhist":b[2][2926],"chinese":b[2][2927],"coptic":b[2][2928],"dangi":b[2][2927],"ethiopic":b[2][2929],"ethioaa":b[2][2930],"generic":b[2][2931],"gregory":b[2][2932],"hebrew":b[2][2933],"indian":b[2][2934],"islamic":b[2][2935],"islamicc":b[2][2935],"japanese":b[2][2936],"persian":b[2][2937],"roc":b[2][2938]},{"buddhist":b[2][2939],"chinese":b[2][2940],"coptic":b[2][2941],"dangi":b[2][2940],"ethiopic":b[2][2942],"ethioaa":b[2][2943],"generic":b[2][2944],"gregory":b[2][2945],"hebrew":b[2][2946],"indian":b[2][2947],"islamic":b[2][2948],"islamicc":b[2][2948],"japanese":b[2][2949],"persian":b[2][2950],"roc":b[2][2951]},{"buddhist":b[2][2953],"chinese":b[2][2954],"coptic":b[2][2955],"dangi":b[2][2954],"ethiopic":b[2][2956],"ethioaa":b[2][2957],"generic":b[2][2958],"gregory":b[2][2959],"hebrew":b[2][2960],"indian":b[2][2961],"islamic":b[2][2962],"islamicc":b[2][2962],"japanese":b[2][2963],"persian":b[2][2964],"roc":b[2][2965]},{"buddhist":b[2][2967],"chinese":b[2][2968],"coptic":b[2][2969],"dangi":b[2][2968],"ethiopic":b[2][2970],"ethioaa":b[2][2971],"generic":b[2][2972],"gregory":b[2][2973],"hebrew":b[2][2974],"indian":b[2][2975],"islamic":b[2][2976],"islamicc":b[2][2976],"japanese":b[2][2977],"persian":b[2][2978],"roc":b[2][2979]},{"buddhist":b[2][2981],"chinese":b[2][2982],"coptic":b[2][2983],"dangi":b[2][2982],"ethiopic":b[2][2984],"ethioaa":b[2][2985],"generic":b[2][2986],"gregory":b[2][2987],"hebrew":b[2][2988],"indian":b[2][2989],"islamic":b[2][2990],"islamicc":b[2][2990],"japanese":b[2][2991],"persian":b[2][2992],"roc":b[2][2993]},{"buddhist":b[2][2994],"chinese":b[2][2995],"coptic":b[2][2996],"dangi":b[2][2995],"ethiopic":b[2][2997],"ethioaa":b[2][2998],"generic":b[2][2999],"gregory":b[2][3000],"hebrew":b[2][3001],"indian":b[2][3002],"islamic":b[2][3003],"islamicc":b[2][3003],"japanese":b[2][3004],"persian":b[2][3005],"roc":b[2][3006]},{"buddhist":b[2][3007],"chinese":b[2][3008],"coptic":b[2][3009],"dangi":b[2][3008],"ethiopic":b[2][3010],"ethioaa":b[2][3011],"generic":b[2][3012],"gregory":b[2][3013],"hebrew":b[2][3014],"indian":b[2][3015],"islamic":b[2][3016],"islamicc":b[2][3016],"japanese":b[2][3017],"persian":b[2][3018],"roc":b[2][3019]},{"buddhist":b[2][3021],"chinese":b[2][3022],"coptic":b[2][3023],"dangi":b[2][3022],"ethiopic":b[2][3024],"ethioaa":b[2][3025],"generic":b[2][3026],"gregory":b[2][3027],"hebrew":b[2][3028],"indian":b[2][3029],"islamic":b[2][3030],"islamicc":b[2][3030],"japanese":b[2][3031],"persian":b[2][3032],"roc":b[2][3033]},{"buddhist":b[2][3034],"chinese":b[2][3035],"coptic":b[2][3036],"dangi":b[2][3035],"ethiopic":b[2][3037],"ethioaa":b[2][3038],"generic":b[2][3039],"gregory":b[2][3040],"hebrew":b[2][3041],"indian":b[2][3042],"islamic":b[2][3043],"islamicc":b[2][3043],"japanese":b[2][3044],"persian":b[2][3045],"roc":b[2][3046]},{"buddhist":b[2][3048],"chinese":b[2][3049],"coptic":b[2][3050],"dangi":b[2][3049],"ethiopic":b[2][3051],"ethioaa":b[2][3052],"generic":b[2][3053],"gregory":b[2][3054],"hebrew":b[2][3055],"indian":b[2][3056],"islamic":b[2][3057],"islamicc":b[2][3057],"japanese":b[2][3058],"persian":b[2][3059],"roc":b[2][3060]},{"buddhist":b[2][3062],"chinese":b[2][3063],"coptic":b[2][3064],"dangi":b[2][3063],"ethiopic":b[2][3065],"ethioaa":b[2][3066],"generic":b[2][3067],"gregory":b[2][3068],"hebrew":b[2][3069],"indian":b[2][3070],"islamic":b[2][3071],"islamicc":b[2][3071],"japanese":b[2][3072],"persian":b[2][3073],"roc":b[2][3074]},{"buddhist":b[2][3075],"chinese":b[2][3076],"coptic":b[2][3077],"dangi":b[2][3076],"ethiopic":b[2][3078],"ethioaa":b[2][3079],"generic":b[2][3080],"gregory":b[2][3081],"hebrew":b[2][3082],"indian":b[2][3083],"islamic":b[2][3084],"islamicc":b[2][3084],"japanese":b[2][3085],"persian":b[2][3086],"roc":b[2][3087]},{"buddhist":b[2][3088],"chinese":b[2][3089],"coptic":b[2][3090],"dangi":b[2][3089],"ethiopic":b[2][3091],"ethioaa":b[2][3092],"generic":b[2][3093],"gregory":b[2][3094],"hebrew":b[2][3095],"indian":b[2][3096],"islamic":b[2][3097],"islamicc":b[2][3097],"japanese":b[2][3098],"persian":b[2][3099],"roc":b[2][3100]},{"buddhist":b[2][3101],"chinese":b[2][3102],"coptic":b[2][3103],"dangi":b[2][3102],"ethiopic":b[2][3104],"ethioaa":b[2][3105],"generic":b[2][3106],"gregory":b[2][3107],"hebrew":b[2][3108],"indian":b[2][3109],"islamic":b[2][3110],"islamicc":b[2][3110],"japanese":b[2][3111],"persian":b[2][3112],"roc":b[2][3113]},{"buddhist":b[2][3114],"chinese":b[2][3115],"coptic":b[2][3116],"dangi":b[2][3115],"ethiopic":b[2][3117],"ethioaa":b[2][3118],"generic":b[2][3119],"gregory":b[2][3120],"hebrew":b[2][3121],"indian":b[2][3122],"islamic":b[2][3123],"islamicc":b[2][3123],"japanese":b[2][3124],"persian":b[2][3125],"roc":b[2][3126]},{"buddhist":b[2][3128],"chinese":b[2][3129],"coptic":b[2][3130],"dangi":b[2][3129],"ethiopic":b[2][3130],"ethioaa":b[2][3131],"generic":b[2][3132],"gregory":b[2][3133],"hebrew":b[2][3134],"indian":b[2][3135],"islamic":b[2][3136],"islamicc":b[2][3136],"japanese":b[2][3137],"persian":b[2][3138],"roc":b[2][3139]},{"buddhist":b[2][3144],"chinese":b[2][3145],"coptic":b[2][3146],"dangi":b[2][3145],"ethiopic":b[2][3146],"ethioaa":b[2][3147],"generic":b[2][3148],"gregory":b[2][3149],"hebrew":b[2][3150],"indian":b[2][3151],"islamic":b[2][3152],"islamicc":b[2][3152],"japanese":b[2][3153],"persian":b[2][3154],"roc":b[2][3155]},{"buddhist":b[2][3144],"chinese":b[2][3158],"coptic":b[2][3146],"dangi":b[2][3145],"ethiopic":b[2][3146],"ethioaa":b[2][3147],"generic":b[2][3148],"gregory":b[2][3159],"hebrew":b[2][3150],"indian":b[2][3151],"islamic":b[2][3152],"islamicc":b[2][3152],"japanese":b[2][3153],"persian":b[2][3154],"roc":b[2][3155]},{"buddhist":b[2][3161],"chinese":b[2][3162],"coptic":b[2][3163],"dangi":b[2][3162],"ethiopic":b[2][3164],"ethioaa":b[2][3165],"generic":b[2][3166],"gregory":b[2][3167],"hebrew":b[2][3168],"indian":b[2][3169],"islamic":b[2][3170],"islamicc":b[2][3170],"japanese":b[2][3171],"persian":b[2][3172],"roc":b[2][3173]}];b[4]=[{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][0],"calendars":b[3][0]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][0],"calendars":b[3][1]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][23],"calendars":b[3][2]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][29],"calendars":b[3][2]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][30],"calendars":b[3][3]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][35],"calendars":b[3][4]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][39],"calendars":b[3][5]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][46],"calendars":b[3][6]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][46],"calendars":b[3][7]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][63],"calendars":b[3][8]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][46],"calendars":b[3][9]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][46],"calendars":b[3][10]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][69],"calendars":b[3][10]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][63],"calendars":b[3][11]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][46],"calendars":b[3][12]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][72],"calendars":b[3][13]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][78],"calendars":b[3][14]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][83],"calendars":b[3][15]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][88],"calendars":b[3][16]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][91],"calendars":b[3][17]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][95],"calendars":b[3][18]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][100],"calendars":b[3][19]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][78],"calendars":b[3][20]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][78],"calendars":b[3][21]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][110],"calendars":b[3][22]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][117],"calendars":b[3][23]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][24]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][123],"calendars":b[3][25]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][133],"calendars":b[3][26]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][138],"calendars":b[3][27]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][141],"calendars":b[3][28]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][147],"calendars":b[3][29]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][163],"calendars":b[3][30]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][169],"calendars":b[3][31]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][78],"calendars":b[3][32]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][178],"calendars":b[3][33]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][182],"calendars":b[3][34]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][187],"calendars":b[3][35]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][191],"calendars":b[3][36]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][78],"calendars":b[3][37]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][199],"calendars":b[3][38]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][204],"calendars":b[3][39]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][95],"calendars":b[3][40]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][212],"calendars":b[3][41]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][42]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][43]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][223],"calendars":b[3][44]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][78],"calendars":b[3][45]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][231],"calendars":b[3][46]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][243],"calendars":b[3][47]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][248],"calendars":b[3][48]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][253],"calendars":b[3][49]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][255],"calendars":b[3][50]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][256],"calendars":b[3][48]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][257],"calendars":b[3][48]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][258],"calendars":b[3][48]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][259],"calendars":b[3][49]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][260],"calendars":b[3][51]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][262],"calendars":b[3][52]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][263],"calendars":b[3][49]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][264],"calendars":b[3][48]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][265],"calendars":b[3][49]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][266],"calendars":b[3][49]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][267],"calendars":b[3][49]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][268],"calendars":b[3][49]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][269],"calendars":b[3][48]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][270],"calendars":b[3][48]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][271],"calendars":b[3][53]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][275],"calendars":b[3][54]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][281],"calendars":b[3][54]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][282],"calendars":b[3][54]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][284],"calendars":b[3][54]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][285],"calendars":b[3][55]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][289],"calendars":b[3][54]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][290],"calendars":b[3][54]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][291],"calendars":b[3][56]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][295],"calendars":b[3][54]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][296],"calendars":b[3][54]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][275],"calendars":b[3][57]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][298],"calendars":b[3][58]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][302],"calendars":b[3][59]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][309],"calendars":b[3][60]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][313],"calendars":b[3][61]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][313],"calendars":b[3][62]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][327],"calendars":b[3][63]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][331],"calendars":b[3][64]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][338],"calendars":b[3][65]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][342],"calendars":b[3][66]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][347],"calendars":b[3][67]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][362],"calendars":b[3][67]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][363],"calendars":b[3][68]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][365],"calendars":b[3][67]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][366],"calendars":b[3][69]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][370],"calendars":b[3][70]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][381],"calendars":b[3][71]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][385],"calendars":b[3][72]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][389],"calendars":b[3][73]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][393],"calendars":b[3][74]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][398],"calendars":b[3][75]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][76]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][408],"calendars":b[3][77]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][412],"calendars":b[3][78]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[2][1082],"calendars":b[3][79]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][419],"calendars":b[3][80]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][428],"calendars":b[3][81]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][438],"calendars":b[3][82]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][442],"calendars":b[3][83]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][446],"calendars":b[3][84]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][457],"calendars":b[3][85]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][461],"calendars":b[3][86]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][465],"calendars":b[3][87]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][88]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][89]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][478],"calendars":b[3][90]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][482],"calendars":b[3][91]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][489],"calendars":b[3][91]},{"ca":b[0][0],"hourNo0":false,"hour12":false,"formats":b[1][490],"calendars":b[3][92]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][505],"calendars":b[3][93]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][94]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][512],"calendars":b[3][95]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][327],"calendars":b[3][96]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][97]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][98]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][529],"calendars":b[3][99]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][327],"calendars":b[3][100]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][101]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][537],"calendars":b[3][102]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][541],"calendars":b[3][103]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][544],"calendars":b[3][104]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][105]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][551],"calendars":b[3][106]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][557],"calendars":b[3][107]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][562],"calendars":b[3][108]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][573],"calendars":b[3][109]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][577],"calendars":b[3][110]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][111]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][112]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][589],"calendars":b[3][113]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][594],"calendars":b[3][114]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][597],"calendars":b[3][115]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][116]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][605],"calendars":b[3][117]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][118]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][612],"calendars":b[3][119]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][120]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][618],"calendars":b[3][121]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][635],"calendars":b[3][122]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][123]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][124]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][125]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][651],"calendars":b[3][126]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][127]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][128]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][327],"calendars":b[3][129]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][667],"calendars":b[3][130]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][671],"calendars":b[3][131]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][675],"calendars":b[3][132]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][678],"calendars":b[3][133]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][682],"calendars":b[3][134]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][691],"calendars":b[3][135]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][695],"calendars":b[3][136]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][699],"calendars":b[3][137]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][704],"calendars":b[3][137]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][705],"calendars":b[3][138]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][139]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][712],"calendars":b[3][140]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][141]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][720],"calendars":b[3][142]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][143]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][726],"calendars":b[3][144]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][726],"calendars":b[3][145]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][370],"calendars":b[3][146]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][737],"calendars":b[3][146]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][147]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][741],"calendars":b[3][148]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][745],"calendars":b[3][149]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][150]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][151]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][753],"calendars":b[3][152]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][32]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][757],"calendars":b[3][153]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][761],"calendars":b[3][154]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][765],"calendars":b[3][155]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][770],"calendars":b[3][156]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][775],"calendars":b[3][157]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][782],"calendars":b[3][158]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][790],"calendars":b[3][159]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][796],"calendars":b[3][160]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][802],"calendars":b[3][161]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][805],"calendars":b[3][162]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][809],"calendars":b[3][163]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][164]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][817],"calendars":b[3][165]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][166]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][828],"calendars":b[3][167]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][840],"calendars":b[3][167]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][461],"calendars":b[3][168]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][843],"calendars":b[3][169]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][170]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][850],"calendars":b[3][171]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][172]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][173]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][859],"calendars":b[3][174]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][327],"calendars":b[3][175]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][864],"calendars":b[3][176]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][864],"calendars":b[3][177]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][864],"calendars":b[3][178]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][874],"calendars":b[3][179]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][878],"calendars":b[3][180]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][882],"calendars":b[3][181]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][182]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][183]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][891],"calendars":b[3][184]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][895],"calendars":b[3][185]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][899],"calendars":b[3][186]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][901],"calendars":b[3][187]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][904],"calendars":b[3][188]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][901],"calendars":b[3][189]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][190]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][0],"calendars":b[3][191]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][921],"calendars":b[3][192]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][934],"calendars":b[3][193]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][936],"calendars":b[3][194]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][195]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][943],"calendars":b[3][196]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][949],"calendars":b[3][197]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][198]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][958],"calendars":b[3][199]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][976],"calendars":b[3][200]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][980],"calendars":b[3][201]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][202]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][985],"calendars":b[3][203]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][990],"calendars":b[3][204]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][205]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][206]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][207]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1006],"calendars":b[3][208]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][1014],"calendars":b[3][209]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1026],"calendars":b[3][210]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1026],"calendars":b[3][211]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][1035],"calendars":b[3][212]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][461],"calendars":b[3][213]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][461],"calendars":b[3][214]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][850],"calendars":b[3][215]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][216]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][121],"calendars":b[3][217]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][1053],"calendars":b[3][218]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][1058],"calendars":b[3][219]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][1062],"calendars":b[3][220]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][221]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][216],"calendars":b[3][222]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][1072],"calendars":b[3][223]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][224]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][404],"calendars":b[3][225]},{"ca":b[0][0],"hourNo0":true,"hour12":false,"formats":b[1][1081],"calendars":b[3][226]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1083],"calendars":b[3][227]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1097],"calendars":b[3][227]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1098],"calendars":b[3][227]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1099],"calendars":b[3][227]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1100],"calendars":b[3][228]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1115],"calendars":b[3][228]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1116],"calendars":b[3][229]},{"ca":b[0][0],"hourNo0":true,"hour12":true,"formats":b[1][1119],"calendars":b[3][230]}];b[5]=[{"locale":"aa-DJ","date":b[4][0],"number":b[2][13]},{"locale":"aa-ER","date":b[4][1],"number":b[2][18]},{"locale":"aa-ET","date":b[4][1],"number":b[2][19]},{"locale":"aa","date":b[4][1],"number":b[2][19]},{"locale":"af-NA","date":b[4][2],"number":b[2][33]},{"locale":"af-ZA","date":b[4][3],"number":b[2][34]},{"locale":"af","date":b[4][3],"number":b[2][34]},{"locale":"agq-CM","date":b[4][4],"number":b[2][48]},{"locale":"agq","date":b[4][4],"number":b[2][48]},{"locale":"ak-GH","date":b[4][5],"number":b[2][62]},{"locale":"ak","date":b[4][5],"number":b[2][62]},{"locale":"am-ET","date":b[4][6],"number":b[2][76]},{"locale":"am","date":b[4][6],"number":b[2][76]},{"locale":"ar-001","date":b[4][7],"number":b[2][90]},{"locale":"ar-AE","date":b[4][8],"number":b[2][90]},{"locale":"ar-BH","date":b[4][7],"number":b[2][90]},{"locale":"ar-DJ","date":b[4][7],"number":b[2][92]},{"locale":"ar-DZ","date":b[4][9],"number":b[2][97]},{"locale":"ar-EG","date":b[4][7],"number":b[2][98]},{"locale":"ar-EH","date":b[4][7],"number":b[2][99]},{"locale":"ar-ER","date":b[4][7],"number":b[2][100]},{"locale":"ar-IL","date":b[4][7],"number":b[2][90]},{"locale":"ar-IQ","date":b[4][10],"number":b[2][90]},{"locale":"ar-JO","date":b[4][11],"number":b[2][90]},{"locale":"ar-KM","date":b[4][7],"number":b[2][90]},{"locale":"ar-KW","date":b[4][7],"number":b[2][90]},{"locale":"ar-LB","date":b[4][12],"number":b[2][109]},{"locale":"ar-LY","date":b[4][7],"number":b[2][97]},{"locale":"ar-MA","date":b[4][13],"number":b[2][97]},{"locale":"ar-MR","date":b[4][14],"number":b[2][118]},{"locale":"ar-OM","date":b[4][7],"number":b[2][90]},{"locale":"ar-PS","date":b[4][11],"number":b[2][90]},{"locale":"ar-QA","date":b[4][7],"number":b[2][90]},{"locale":"ar-SA","date":b[4][7],"number":b[2][90]},{"locale":"ar-SD","date":b[4][7],"number":b[2][90]},{"locale":"ar-SO","date":b[4][7],"number":b[2][119]},{"locale":"ar-SS","date":b[4][7],"number":b[2][120]},{"locale":"ar-SY","date":b[4][11],"number":b[2][90]},{"locale":"ar-TD","date":b[4][7],"number":b[2][90]},{"locale":"ar-TN","date":b[4][9],"number":b[2][121]},{"locale":"ar-YE","date":b[4][7],"number":b[2][90]},{"locale":"ar","date":b[4][7],"number":b[2][90]},{"locale":"as-IN","date":b[4][15],"number":b[2][135]},{"locale":"as","date":b[4][15],"number":b[2][135]},{"locale":"asa-TZ","date":b[4][16],"number":b[2][149]},{"locale":"asa","date":b[4][16],"number":b[2][149]},{"locale":"ast-ES","date":b[4][17],"number":b[2][163]},{"locale":"ast","date":b[4][17],"number":b[2][163]},{"locale":"az-Cyrl-AZ","date":b[4][18],"number":b[2][177]},{"locale":"az-Cyrl","date":b[4][18],"number":b[2][177]},{"locale":"az-Latn-AZ","date":b[4][19],"number":b[2][191]},{"locale":"az-Latn","date":b[4][19],"number":b[2][191]},{"locale":"az","date":b[4][19],"number":b[2][191]},{"locale":"bas-CM","date":b[4][20],"number":b[2][205]},{"locale":"bas","date":b[4][20],"number":b[2][205]},{"locale":"be-BY","date":b[4][21],"number":b[2][219]},{"locale":"be","date":b[4][21],"number":b[2][219]},{"locale":"bem-ZM","date":b[4][22],"number":b[2][233]},{"locale":"bem","date":b[4][22],"number":b[2][233]},{"locale":"bez-TZ","date":b[4][23],"number":b[2][247]},{"locale":"bez","date":b[4][23],"number":b[2][247]},{"locale":"bg-BG","date":b[4][24],"number":b[2][261]},{"locale":"bg","date":b[4][24],"number":b[2][261]},{"locale":"bm-Latn-ML","date":b[4][25],"number":b[2][275]},{"locale":"bm-Latn","date":b[4][25],"number":b[2][275]},{"locale":"bm-Nkoo","date":b[4][26],"number":b[2][289]},{"locale":"bm","date":b[4][25],"number":b[2][275]},{"locale":"bn-BD","date":b[4][27],"number":b[2][303]},{"locale":"bn-IN","date":b[4][27],"number":b[2][303]},{"locale":"bn","date":b[4][27],"number":b[2][303]},{"locale":"bo-CN","date":b[4][28],"number":b[2][317]},{"locale":"bo-IN","date":b[4][28],"number":b[2][318]},{"locale":"bo","date":b[4][28],"number":b[2][317]},{"locale":"br-FR","date":b[4][29],"number":b[2][332]},{"locale":"br","date":b[4][29],"number":b[2][332]},{"locale":"brx-IN","date":b[4][30],"number":b[2][346]},{"locale":"brx","date":b[4][30],"number":b[2][346]},{"locale":"bs-Cyrl-BA","date":b[4][31],"number":b[2][360]},{"locale":"bs-Cyrl","date":b[4][31],"number":b[2][360]},{"locale":"bs-Latn-BA","date":b[4][32],"number":b[2][374]},{"locale":"bs-Latn","date":b[4][32],"number":b[2][374]},{"locale":"bs","date":b[4][32],"number":b[2][374]},{"locale":"ca-AD","date":b[4][33],"number":b[2][388]},{"locale":"ca-ES-VALENCIA","date":b[4][33],"number":b[2][388]},{"locale":"ca-ES","date":b[4][33],"number":b[2][388]},{"locale":"ca-FR","date":b[4][33],"number":b[2][389]},{"locale":"ca-IT","date":b[4][33],"number":b[2][388]},{"locale":"ca","date":b[4][33],"number":b[2][388]},{"locale":"cgg-UG","date":b[4][34],"number":b[2][403]},{"locale":"cgg","date":b[4][34],"number":b[2][403]},{"locale":"chr-US","date":b[4][35],"number":b[2][417]},{"locale":"chr","date":b[4][35],"number":b[2][417]},{"locale":"cs-CZ","date":b[4][36],"number":b[2][431]},{"locale":"cs","date":b[4][36],"number":b[2][431]},{"locale":"cy-GB","date":b[4][37],"number":b[2][445]},{"locale":"cy","date":b[4][37],"number":b[2][445]},{"locale":"da-DK","date":b[4][38],"number":b[2][459]},{"locale":"da-GL","date":b[4][38],"number":b[2][459]},{"locale":"da","date":b[4][38],"number":b[2][459]},{"locale":"dav-KE","date":b[4][39],"number":b[2][473]},{"locale":"dav","date":b[4][39],"number":b[2][473]},{"locale":"de-AT","date":b[4][40],"number":b[2][487]},{"locale":"de-BE","date":b[4][41],"number":b[2][492]},{"locale":"de-CH","date":b[4][41],"number":b[2][493]},{"locale":"de-DE","date":b[4][41],"number":b[2][492]},{"locale":"de-LI","date":b[4][41],"number":b[2][494]},{"locale":"de-LU","date":b[4][41],"number":b[2][495]},{"locale":"de","date":b[4][41],"number":b[2][492]},{"locale":"dje-NE","date":b[4][42],"number":b[2][509]},{"locale":"dje","date":b[4][42],"number":b[2][509]},{"locale":"dsb-DE","date":b[4][43],"number":b[2][523]},{"locale":"dsb","date":b[4][43],"number":b[2][523]},{"locale":"dua-CM","date":b[4][44],"number":b[2][205]},{"locale":"dua","date":b[4][44],"number":b[2][205]},{"locale":"dyo-SN","date":b[4][45],"number":b[2][550]},{"locale":"dyo","date":b[4][45],"number":b[2][550]},{"locale":"dz-BT","date":b[4][46],"number":b[2][564]},{"locale":"dz","date":b[4][46],"number":b[2][564]},{"locale":"ebu-KE","date":b[4][47],"number":b[2][473]},{"locale":"ebu","date":b[4][47],"number":b[2][473]},{"locale":"ee-GH","date":b[4][48],"number":b[2][591]},{"locale":"ee-TG","date":b[4][48],"number":b[2][591]},{"locale":"ee","date":b[4][48],"number":b[2][591]},{"locale":"el-CY","date":b[4][49],"number":b[2][605]},{"locale":"el-GR","date":b[4][49],"number":b[2][606]},{"locale":"el","date":b[4][49],"number":b[2][606]},{"locale":"en-001","date":b[4][50],"number":b[2][620]},{"locale":"en-150","date":b[4][51],"number":b[2][634]},{"locale":"en-AG","date":b[4][50],"number":b[2][635]},{"locale":"en-AI","date":b[4][50],"number":b[2][635]},{"locale":"en-AS","date":b[4][50],"number":b[2][636]},{"locale":"en-AU","date":b[4][52],"number":b[2][638]},{"locale":"en-BB","date":b[4][50],"number":b[2][639]},{"locale":"en-BE","date":b[4][51],"number":b[2][634]},{"locale":"en-BM","date":b[4][50],"number":b[2][640]},{"locale":"en-BS","date":b[4][50],"number":b[2][641]},{"locale":"en-BW","date":b[4][53],"number":b[2][642]},{"locale":"en-BZ","date":b[4][54],"number":b[2][643]},{"locale":"en-CA","date":b[4][55],"number":b[2][644]},{"locale":"en-CC","date":b[4][50],"number":b[2][645]},{"locale":"en-CK","date":b[4][50],"number":b[2][646]},{"locale":"en-CM","date":b[4][50],"number":b[2][620]},{"locale":"en-CX","date":b[4][50],"number":b[2][645]},{"locale":"en-DG","date":b[4][56],"number":b[2][638]},{"locale":"en-DM","date":b[4][50],"number":b[2][635]},{"locale":"en-Dsrt","date":b[4][26],"number":b[2][289]},{"locale":"en-ER","date":b[4][50],"number":b[2][647]},{"locale":"en-FJ","date":b[4][50],"number":b[2][648]},{"locale":"en-FK","date":b[4][56],"number":b[2][649]},{"locale":"en-FM","date":b[4][50],"number":b[2][620]},{"locale":"en-GB","date":b[4][56],"number":b[2][638]},{"locale":"en-GD","date":b[4][50],"number":b[2][635]},{"locale":"en-GG","date":b[4][56],"number":b[2][638]},{"locale":"en-GH","date":b[4][50],"number":b[2][650]},{"locale":"en-GI","date":b[4][56],"number":b[2][651]},{"locale":"en-GM","date":b[4][50],"number":b[2][652]},{"locale":"en-GU","date":b[4][50],"number":b[2][636]},{"locale":"en-GY","date":b[4][50],"number":b[2][653]},{"locale":"en-HK","date":b[4][57],"number":b[2][638]},{"locale":"en-IE","date":b[4][58],"number":b[2][638]},{"locale":"en-IM","date":b[4][56],"number":b[2][638]},{"locale":"en-IN","date":b[4][59],"number":b[2][668]},{"locale":"en-IO","date":b[4][56],"number":b[2][638]},{"locale":"en-JE","date":b[4][56],"number":b[2][638]},{"locale":"en-JM","date":b[4][60],"number":b[2][669]},{"locale":"en-KE","date":b[4][50],"number":b[2][670]},{"locale":"en-KI","date":b[4][50],"number":b[2][645]},{"locale":"en-KN","date":b[4][50],"number":b[2][635]},{"locale":"en-KY","date":b[4][50],"number":b[2][671]},{"locale":"en-LC","date":b[4][50],"number":b[2][635]},{"locale":"en-LR","date":b[4][50],"number":b[2][672]},{"locale":"en-LS","date":b[4][50],"number":b[2][673]},{"locale":"en-MG","date":b[4][50],"number":b[2][674]},{"locale":"en-MH","date":b[4][50],"number":b[2][636]},{"locale":"en-MO","date":b[4][56],"number":b[2][675]},{"locale":"en-MP","date":b[4][50],"number":b[2][636]},{"locale":"en-MS","date":b[4][50],"number":b[2][635]},{"locale":"en-MT","date":b[4][61],"number":b[2][676]},{"locale":"en-MU","date":b[4][50],"number":b[2][677]},{"locale":"en-MW","date":b[4][50],"number":b[2][678]},{"locale":"en-MY","date":b[4][50],"number":b[2][679]},{"locale":"en-NA","date":b[4][50],"number":b[2][680]},{"locale":"en-NF","date":b[4][50],"number":b[2][645]},{"locale":"en-NG","date":b[4][50],"number":b[2][681]},{"locale":"en-NR","date":b[4][50],"number":b[2][645]},{"locale":"en-NU","date":b[4][50],"number":b[2][646]},{"locale":"en-NZ","date":b[4][62],"number":b[2][682]},{"locale":"en-PG","date":b[4][50],"number":b[2][683]},{"locale":"en-PH","date":b[4][50],"number":b[2][684]},{"locale":"en-PK","date":b[4][63],"number":b[2][685]},{"locale":"en-PN","date":b[4][50],"number":b[2][646]},{"locale":"en-PR","date":b[4][50],"number":b[2][636]},{"locale":"en-PW","date":b[4][50],"number":b[2][620]},{"locale":"en-RW","date":b[4][50],"number":b[2][686]},{"locale":"en-SB","date":b[4][50],"number":b[2][687]},{"locale":"en-SC","date":b[4][50],"number":b[2][688]},{"locale":"en-SD","date":b[4][50],"number":b[2][620]},{"locale":"en-SG","date":b[4][64],"number":b[2][689]},{"locale":"en-SH","date":b[4][56],"number":b[2][690]},{"locale":"en-SL","date":b[4][50],"number":b[2][691]},{"locale":"en-SS","date":b[4][50],"number":b[2][692]},{"locale":"en-SX","date":b[4][50],"number":b[2][693]},{"locale":"en-SZ","date":b[4][50],"number":b[2][694]},{"locale":"en-TC","date":b[4][50],"number":b[2][620]},{"locale":"en-TK","date":b[4][50],"number":b[2][646]},{"locale":"en-TO","date":b[4][50],"number":b[2][695]},{"locale":"en-TT","date":b[4][50],"number":b[2][696]},{"locale":"en-TV","date":b[4][50],"number":b[2][645]},{"locale":"en-TZ","date":b[4][50],"number":b[2][697]},{"locale":"en-UG","date":b[4][50],"number":b[2][698]},{"locale":"en-UM","date":b[4][50],"number":b[2][636]},{"locale":"en-US","date":b[4][50],"number":b[2][636]},{"locale":"en-VC","date":b[4][50],"number":b[2][635]},{"locale":"en-VG","date":b[4][56],"number":b[2][638]},{"locale":"en-VI","date":b[4][50],"number":b[2][636]},{"locale":"en-VU","date":b[4][50],"number":b[2][699]},{"locale":"en-WS","date":b[4][50],"number":b[2][700]},{"locale":"en-ZA","date":b[4][65],"number":b[2][701]},{"locale":"en-ZM","date":b[4][50],"number":b[2][702]},{"locale":"en-ZW","date":b[4][66],"number":b[2][620]},{"locale":"en","date":b[4][50],"number":b[2][636]},{"locale":"eo-001","date":b[4][67],"number":b[2][716]},{"locale":"eo","date":b[4][67],"number":b[2][716]},{"locale":"es-419","date":b[4][68],"number":b[2][730]},{"locale":"es-AR","date":b[4][69],"number":b[2][731]},{"locale":"es-BO","date":b[4][68],"number":b[2][732]},{"locale":"es-CL","date":b[4][70],"number":b[2][733]},{"locale":"es-CO","date":b[4][71],"number":b[2][734]},{"locale":"es-CR","date":b[4][68],"number":b[2][735]},{"locale":"es-CU","date":b[4][68],"number":b[2][736]},{"locale":"es-DO","date":b[4][68],"number":b[2][737]},{"locale":"es-EA","date":b[4][72],"number":b[2][751]},{"locale":"es-EC","date":b[4][68],"number":b[2][752]},{"locale":"es-ES","date":b[4][72],"number":b[2][751]},{"locale":"es-GQ","date":b[4][72],"number":b[2][753]},{"locale":"es-GT","date":b[4][73],"number":b[2][754]},{"locale":"es-HN","date":b[4][74],"number":b[2][755]},{"locale":"es-IC","date":b[4][72],"number":b[2][751]},{"locale":"es-MX","date":b[4][75],"number":b[2][769]},{"locale":"es-NI","date":b[4][68],"number":b[2][770]},{"locale":"es-PA","date":b[4][76],"number":b[2][771]},{"locale":"es-PE","date":b[4][77],"number":b[2][772]},{"locale":"es-PH","date":b[4][72],"number":b[2][773]},{"locale":"es-PR","date":b[4][76],"number":b[2][774]},{"locale":"es-PY","date":b[4][68],"number":b[2][775]},{"locale":"es-SV","date":b[4][68],"number":b[2][774]},{"locale":"es-US","date":b[4][78],"number":b[2][789]},{"locale":"es-UY","date":b[4][68],"number":b[2][790]},{"locale":"es-VE","date":b[4][68],"number":b[2][791]},{"locale":"es","date":b[4][72],"number":b[2][751]},{"locale":"et-EE","date":b[4][79],"number":b[2][805]},{"locale":"et","date":b[4][79],"number":b[2][805]},{"locale":"eu-ES","date":b[4][80],"number":b[2][819]},{"locale":"eu","date":b[4][80],"number":b[2][819]},{"locale":"ewo-CM","date":b[4][81],"number":b[2][550]},{"locale":"ewo","date":b[4][81],"number":b[2][550]},{"locale":"fa-AF","date":b[4][82],"number":b[2][846]},{"locale":"fa-IR","date":b[4][83],"number":b[2][846]},{"locale":"fa","date":b[4][83],"number":b[2][846]},{"locale":"ff-CM","date":b[4][84],"number":b[2][550]},{"locale":"ff-GN","date":b[4][84],"number":b[2][865]},{"locale":"ff-MR","date":b[4][84],"number":b[2][866]},{"locale":"ff-SN","date":b[4][84],"number":b[2][550]},{"locale":"ff","date":b[4][84],"number":b[2][550]},{"locale":"fi-FI","date":b[4][85],"number":b[2][880]},{"locale":"fi","date":b[4][85],"number":b[2][880]},{"locale":"fil-PH","date":b[4][86],"number":b[2][894]},{"locale":"fil","date":b[4][86],"number":b[2][894]},{"locale":"fo-FO","date":b[4][87],"number":b[2][908]},{"locale":"fo","date":b[4][87],"number":b[2][908]},{"locale":"fr-BE","date":b[4][88],"number":b[2][922]},{"locale":"fr-BF","date":b[4][89],"number":b[2][923]},{"locale":"fr-BI","date":b[4][89],"number":b[2][924]},{"locale":"fr-BJ","date":b[4][89],"number":b[2][923]},{"locale":"fr-BL","date":b[4][89],"number":b[2][923]},{"locale":"fr-CA","date":b[4][90],"number":b[2][926]},{"locale":"fr-CD","date":b[4][89],"number":b[2][927]},{"locale":"fr-CF","date":b[4][89],"number":b[2][923]},{"locale":"fr-CG","date":b[4][89],"number":b[2][923]},{"locale":"fr-CH","date":b[4][91],"number":b[2][928]},{"locale":"fr-CI","date":b[4][89],"number":b[2][923]},{"locale":"fr-CM","date":b[4][89],"number":b[2][923]},{"locale":"fr-DJ","date":b[4][89],"number":b[2][929]},{"locale":"fr-DZ","date":b[4][89],"number":b[2][930]},{"locale":"fr-FR","date":b[4][89],"number":b[2][923]},{"locale":"fr-GA","date":b[4][89],"number":b[2][923]},{"locale":"fr-GF","date":b[4][89],"number":b[2][923]},{"locale":"fr-GN","date":b[4][89],"number":b[2][931]},{"locale":"fr-GP","date":b[4][89],"number":b[2][923]},{"locale":"fr-GQ","date":b[4][89],"number":b[2][923]},{"locale":"fr-HT","date":b[4][89],"number":b[2][932]},{"locale":"fr-KM","date":b[4][89],"number":b[2][933]},{"locale":"fr-LU","date":b[4][89],"number":b[2][934]},{"locale":"fr-MA","date":b[4][89],"number":b[2][923]},{"locale":"fr-MC","date":b[4][89],"number":b[2][923]},{"locale":"fr-MF","date":b[4][89],"number":b[2][923]},{"locale":"fr-MG","date":b[4][89],"number":b[2][935]},{"locale":"fr-ML","date":b[4][89],"number":b[2][923]},{"locale":"fr-MQ","date":b[4][89],"number":b[2][923]},{"locale":"fr-MR","date":b[4][89],"number":b[2][936]},{"locale":"fr-MU","date":b[4][89],"number":b[2][937]},{"locale":"fr-NC","date":b[4][89],"number":b[2][923]},{"locale":"fr-NE","date":b[4][89],"number":b[2][923]},{"locale":"fr-PF","date":b[4][89],"number":b[2][923]},{"locale":"fr-PM","date":b[4][89],"number":b[2][923]},{"locale":"fr-RE","date":b[4][89],"number":b[2][923]},{"locale":"fr-RW","date":b[4][89],"number":b[2][938]},{"locale":"fr-SC","date":b[4][89],"number":b[2][939]},{"locale":"fr-SN","date":b[4][89],"number":b[2][923]},{"locale":"fr-SY","date":b[4][89],"number":b[2][940]},{"locale":"fr-TD","date":b[4][89],"number":b[2][923]},{"locale":"fr-TG","date":b[4][89],"number":b[2][923]},{"locale":"fr-TN","date":b[4][89],"number":b[2][941]},{"locale":"fr-VU","date":b[4][89],"number":b[2][942]},{"locale":"fr-WF","date":b[4][89],"number":b[2][923]},{"locale":"fr-YT","date":b[4][89],"number":b[2][923]},{"locale":"fr","date":b[4][89],"number":b[2][923]},{"locale":"fur-IT","date":b[4][92],"number":b[2][956]},{"locale":"fur","date":b[4][92],"number":b[2][956]},{"locale":"fy-NL","date":b[4][93],"number":b[2][970]},{"locale":"fy","date":b[4][93],"number":b[2][970]},{"locale":"ga-IE","date":b[4][94],"number":b[2][984]},{"locale":"ga","date":b[4][94],"number":b[2][984]},{"locale":"gd-GB","date":b[4][95],"number":b[2][998]},{"locale":"gd","date":b[4][95],"number":b[2][998]},{"locale":"gl-ES","date":b[4][96],"number":b[2][1012]},{"locale":"gl","date":b[4][96],"number":b[2][1012]},{"locale":"gsw-CH","date":b[4][97],"number":b[2][1026]},{"locale":"gsw-FR","date":b[4][97],"number":b[2][1026]},{"locale":"gsw-LI","date":b[4][97],"number":b[2][1026]},{"locale":"gsw","date":b[4][97],"number":b[2][1026]},{"locale":"gu-IN","date":b[4][98],"number":b[2][1040]},{"locale":"gu","date":b[4][98],"number":b[2][1040]},{"locale":"guz-KE","date":b[4][99],"number":b[2][473]},{"locale":"guz","date":b[4][99],"number":b[2][473]},{"locale":"gv-IM","date":b[4][100],"number":b[2][275]},{"locale":"gv","date":b[4][100],"number":b[2][275]},{"locale":"ha-Arab","date":b[4][26],"number":b[2][289]},{"locale":"ha-Latn-GH","date":b[4][101],"number":b[2][1080]},{"locale":"ha-Latn-NE","date":b[4][101],"number":b[2][1081]},{"locale":"ha-Latn-NG","date":b[4][101],"number":b[2][1081]},{"locale":"ha-Latn","date":b[4][101],"number":b[2][1081]},{"locale":"ha","date":b[4][101],"number":b[2][1081]},{"locale":"haw-US","date":b[4][102],"number":b[2][417]},{"locale":"haw","date":b[4][102],"number":b[2][417]},{"locale":"he-IL","date":b[4][103],"number":b[2][1109]},{"locale":"he","date":b[4][103],"number":b[2][1109]},{"locale":"hi-IN","date":b[4][104],"number":b[2][1123]},{"locale":"hi","date":b[4][104],"number":b[2][1123]},{"locale":"hr-BA","date":b[4][105],"number":b[2][1137]},{"locale":"hr-HR","date":b[4][105],"number":b[2][1138]},{"locale":"hr","date":b[4][105],"number":b[2][1138]},{"locale":"hsb-DE","date":b[4][106],"number":b[2][523]},{"locale":"hsb","date":b[4][106],"number":b[2][523]},{"locale":"hu-HU","date":b[4][107],"number":b[2][1165]},{"locale":"hu","date":b[4][107],"number":b[2][1165]},{"locale":"hy-AM","date":b[4][108],"number":b[2][1179]},{"locale":"hy","date":b[4][108],"number":b[2][1179]},{"locale":"ia-FR","date":b[4][109],"number":b[2][956]},{"locale":"ia","date":b[4][109],"number":b[2][956]},{"locale":"id-ID","date":b[4][110],"number":b[2][1206]},{"locale":"id","date":b[4][110],"number":b[2][1206]},{"locale":"ig-NG","date":b[4][111],"number":b[2][1220]},{"locale":"ig","date":b[4][111],"number":b[2][1220]},{"locale":"ii-CN","date":b[4][112],"number":b[2][1234]},{"locale":"ii","date":b[4][112],"number":b[2][1234]},{"locale":"is-IS","date":b[4][113],"number":b[2][1248]},{"locale":"is","date":b[4][113],"number":b[2][1248]},{"locale":"it-CH","date":b[4][114],"number":b[2][1262]},{"locale":"it-IT","date":b[4][115],"number":b[2][1263]},{"locale":"it-SM","date":b[4][115],"number":b[2][1263]},{"locale":"it","date":b[4][115],"number":b[2][1263]},{"locale":"ja-JP","date":b[4][116],"number":b[2][1277]},{"locale":"ja","date":b[4][116],"number":b[2][1277]},{"locale":"jgo-CM","date":b[4][117],"number":b[2][956]},{"locale":"jgo","date":b[4][117],"number":b[2][956]},{"locale":"jmc-TZ","date":b[4][118],"number":b[2][1304]},{"locale":"jmc","date":b[4][118],"number":b[2][1304]},{"locale":"ka-GE","date":b[4][119],"number":b[2][1318]},{"locale":"ka","date":b[4][119],"number":b[2][1318]},{"locale":"kab-DZ","date":b[4][120],"number":b[2][1332]},{"locale":"kab","date":b[4][120],"number":b[2][1332]},{"locale":"kam-KE","date":b[4][121],"number":b[2][473]},{"locale":"kam","date":b[4][121],"number":b[2][473]},{"locale":"kde-TZ","date":b[4][122],"number":b[2][1304]},{"locale":"kde","date":b[4][122],"number":b[2][1304]},{"locale":"kea-CV","date":b[4][123],"number":b[2][1372]},{"locale":"kea","date":b[4][123],"number":b[2][1372]},{"locale":"khq-ML","date":b[4][124],"number":b[2][509]},{"locale":"khq","date":b[4][124],"number":b[2][509]},{"locale":"ki-KE","date":b[4][125],"number":b[2][473]},{"locale":"ki","date":b[4][125],"number":b[2][473]},{"locale":"kk-Cyrl-KZ","date":b[4][126],"number":b[2][1412]},{"locale":"kk-Cyrl","date":b[4][126],"number":b[2][1412]},{"locale":"kk","date":b[4][126],"number":b[2][1412]},{"locale":"kkj-CM","date":b[4][127],"number":b[2][956]},{"locale":"kkj","date":b[4][127],"number":b[2][956]},{"locale":"kl-GL","date":b[4][128],"number":b[2][1439]},{"locale":"kl","date":b[4][128],"number":b[2][1439]},{"locale":"kln-KE","date":b[4][129],"number":b[2][473]},{"locale":"kln","date":b[4][129],"number":b[2][473]},{"locale":"km-KH","date":b[4][130],"number":b[2][1466]},{"locale":"km","date":b[4][130],"number":b[2][1466]},{"locale":"kn-IN","date":b[4][131],"number":b[2][1480]},{"locale":"kn","date":b[4][131],"number":b[2][1480]},{"locale":"ko-KP","date":b[4][132],"number":b[2][1494]},{"locale":"ko-KR","date":b[4][132],"number":b[2][1494]},{"locale":"ko","date":b[4][132],"number":b[2][1494]},{"locale":"kok-IN","date":b[4][133],"number":b[2][346]},{"locale":"kok","date":b[4][133],"number":b[2][346]},{"locale":"ks-Arab-IN","date":b[4][134],"number":b[2][1521]},{"locale":"ks-Arab","date":b[4][134],"number":b[2][1521]},{"locale":"ks","date":b[4][134],"number":b[2][1521]},{"locale":"ksb-TZ","date":b[4][135],"number":b[2][247]},{"locale":"ksb","date":b[4][135],"number":b[2][247]},{"locale":"ksf-CM","date":b[4][136],"number":b[2][550]},{"locale":"ksf","date":b[4][136],"number":b[2][550]},{"locale":"ksh-DE","date":b[4][137],"number":b[2][1561]},{"locale":"ksh","date":b[4][137],"number":b[2][1561]},{"locale":"kw-GB","date":b[4][138],"number":b[2][275]},{"locale":"kw","date":b[4][138],"number":b[2][275]},{"locale":"ky-Cyrl-KG","date":b[4][139],"number":b[2][1588]},{"locale":"ky-Cyrl","date":b[4][139],"number":b[2][1588]},{"locale":"ky","date":b[4][139],"number":b[2][1588]},{"locale":"lag-TZ","date":b[4][140],"number":b[2][1602]},{"locale":"lag","date":b[4][140],"number":b[2][1602]},{"locale":"lb-LU","date":b[4][141],"number":b[2][1616]},{"locale":"lb","date":b[4][141],"number":b[2][1616]},{"locale":"lg-UG","date":b[4][142],"number":b[2][1630]},{"locale":"lg","date":b[4][142],"number":b[2][1630]},{"locale":"lkt-US","date":b[4][143],"number":b[2][1644]},{"locale":"lkt","date":b[4][143],"number":b[2][1644]},{"locale":"ln-AO","date":b[4][144],"number":b[2][1658]},{"locale":"ln-CD","date":b[4][144],"number":b[2][1659]},{"locale":"ln-CF","date":b[4][144],"number":b[2][1659]},{"locale":"ln-CG","date":b[4][144],"number":b[2][1659]},{"locale":"ln","date":b[4][144],"number":b[2][1659]},{"locale":"lo-LA","date":b[4][145],"number":b[2][1673]},{"locale":"lo","date":b[4][145],"number":b[2][1673]},{"locale":"lt-LT","date":b[4][146],"number":b[2][1687]},{"locale":"lt","date":b[4][146],"number":b[2][1687]},{"locale":"lu-CD","date":b[4][147],"number":b[2][1701]},{"locale":"lu","date":b[4][147],"number":b[2][1701]},{"locale":"luo-KE","date":b[4][148],"number":b[2][1715]},{"locale":"luo","date":b[4][148],"number":b[2][1715]},{"locale":"luy-KE","date":b[4][149],"number":b[2][1729]},{"locale":"luy","date":b[4][149],"number":b[2][1729]},{"locale":"lv-LV","date":b[4][150],"number":b[2][1743]},{"locale":"lv","date":b[4][150],"number":b[2][1743]},{"locale":"mas-KE","date":b[4][151],"number":b[2][473]},{"locale":"mas-TZ","date":b[4][151],"number":b[2][1757]},{"locale":"mas","date":b[4][151],"number":b[2][473]},{"locale":"mer-KE","date":b[4][152],"number":b[2][473]},{"locale":"mer","date":b[4][152],"number":b[2][473]},{"locale":"mfe-MU","date":b[4][153],"number":b[2][1784]},{"locale":"mfe","date":b[4][153],"number":b[2][1784]},{"locale":"mg-MG","date":b[4][154],"number":b[2][1798]},{"locale":"mg","date":b[4][154],"number":b[2][1798]},{"locale":"mgh-MZ","date":b[4][155],"number":b[2][1812]},{"locale":"mgh","date":b[4][155],"number":b[2][1812]},{"locale":"mgo-CM","date":b[4][156],"number":b[2][289]},{"locale":"mgo","date":b[4][156],"number":b[2][289]},{"locale":"mk-MK","date":b[4][157],"number":b[2][1839]},{"locale":"mk","date":b[4][157],"number":b[2][1839]},{"locale":"ml-IN","date":b[4][158],"number":b[2][1853]},{"locale":"ml","date":b[4][158],"number":b[2][1853]},{"locale":"mn-Cyrl-MN","date":b[4][159],"number":b[2][1867]},{"locale":"mn-Cyrl","date":b[4][159],"number":b[2][1867]},{"locale":"mn-Mong","date":b[4][26],"number":b[2][289]},{"locale":"mn","date":b[4][159],"number":b[2][1867]},{"locale":"mr-IN","date":b[4][160],"number":b[2][1881]},{"locale":"mr","date":b[4][160],"number":b[2][1881]},{"locale":"ms-Arab","date":b[4][26],"number":b[2][289]},{"locale":"ms-Latn-BN","date":b[4][161],"number":b[2][1895]},{"locale":"ms-Latn-MY","date":b[4][162],"number":b[2][1896]},{"locale":"ms-Latn-SG","date":b[4][162],"number":b[2][1897]},{"locale":"ms-Latn","date":b[4][162],"number":b[2][1896]},{"locale":"ms","date":b[4][162],"number":b[2][1896]},{"locale":"mt-MT","date":b[4][163],"number":b[2][275]},{"locale":"mt","date":b[4][163],"number":b[2][275]},{"locale":"mua-CM","date":b[4][164],"number":b[2][1924]},{"locale":"mua","date":b[4][164],"number":b[2][1924]},{"locale":"my-MM","date":b[4][165],"number":b[2][1938]},{"locale":"my","date":b[4][165],"number":b[2][1938]},{"locale":"naq-NA","date":b[4][166],"number":b[2][1952]},{"locale":"naq","date":b[4][166],"number":b[2][1952]},{"locale":"nb-NO","date":b[4][167],"number":b[2][1966]},{"locale":"nb-SJ","date":b[4][167],"number":b[2][1966]},{"locale":"nb","date":b[4][167],"number":b[2][1966]},{"locale":"nd-ZW","date":b[4][168],"number":b[2][275]},{"locale":"nd","date":b[4][168],"number":b[2][275]},{"locale":"ne-IN","date":b[4][169],"number":b[2][1993]},{"locale":"ne-NP","date":b[4][170],"number":b[2][1993]},{"locale":"ne","date":b[4][170],"number":b[2][1993]},{"locale":"nl-AW","date":b[4][171],"number":b[2][2020]},{"locale":"nl-BE","date":b[4][172],"number":b[2][2021]},{"locale":"nl-BQ","date":b[4][171],"number":b[2][2022]},{"locale":"nl-CW","date":b[4][171],"number":b[2][2023]},{"locale":"nl-NL","date":b[4][171],"number":b[2][970]},{"locale":"nl-SR","date":b[4][171],"number":b[2][2024]},{"locale":"nl-SX","date":b[4][171],"number":b[2][2023]},{"locale":"nl","date":b[4][171],"number":b[2][970]},{"locale":"nmg-CM","date":b[4][173],"number":b[2][550]},{"locale":"nmg","date":b[4][173],"number":b[2][550]},{"locale":"nn-NO","date":b[4][174],"number":b[2][2051]},{"locale":"nn","date":b[4][174],"number":b[2][2051]},{"locale":"nnh-CM","date":b[4][175],"number":b[2][956]},{"locale":"nnh","date":b[4][175],"number":b[2][956]},{"locale":"nr-ZA","date":b[4][176],"number":b[2][2078]},{"locale":"nr","date":b[4][176],"number":b[2][2078]},{"locale":"nso-ZA","date":b[4][177],"number":b[2][2092]},{"locale":"nso","date":b[4][177],"number":b[2][2092]},{"locale":"nus-SD","date":b[4][178],"number":b[2][275]},{"locale":"nus","date":b[4][178],"number":b[2][275]},{"locale":"nyn-UG","date":b[4][179],"number":b[2][403]},{"locale":"nyn","date":b[4][179],"number":b[2][403]},{"locale":"om-ET","date":b[4][180],"number":b[2][19]},{"locale":"om-KE","date":b[4][180],"number":b[2][2119]},{"locale":"om","date":b[4][180],"number":b[2][19]},{"locale":"or-IN","date":b[4][181],"number":b[2][2133]},{"locale":"or","date":b[4][181],"number":b[2][2133]},{"locale":"os-GE","date":b[4][182],"number":b[2][2147]},{"locale":"os-RU","date":b[4][182],"number":b[2][2148]},{"locale":"os","date":b[4][182],"number":b[2][2147]},{"locale":"pa-Arab-PK","date":b[4][183],"number":b[2][2162]},{"locale":"pa-Arab","date":b[4][183],"number":b[2][2162]},{"locale":"pa-Guru-IN","date":b[4][184],"number":b[2][2176]},{"locale":"pa-Guru","date":b[4][184],"number":b[2][2176]},{"locale":"pa","date":b[4][184],"number":b[2][2176]},{"locale":"pl-PL","date":b[4][185],"number":b[2][2190]},{"locale":"pl","date":b[4][185],"number":b[2][2190]},{"locale":"ps-AF","date":b[4][186],"number":b[2][2204]},{"locale":"ps","date":b[4][186],"number":b[2][2204]},{"locale":"pt-AO","date":b[4][187],"number":b[2][2218]},{"locale":"pt-BR","date":b[4][188],"number":b[2][2232]},{"locale":"pt-CV","date":b[4][187],"number":b[2][2233]},{"locale":"pt-GW","date":b[4][187],"number":b[2][2234]},{"locale":"pt-MO","date":b[4][187],"number":b[2][2235]},{"locale":"pt-MZ","date":b[4][187],"number":b[2][2236]},{"locale":"pt-PT","date":b[4][187],"number":b[2][2234]},{"locale":"pt-ST","date":b[4][187],"number":b[2][2237]},{"locale":"pt-TL","date":b[4][187],"number":b[2][2234]},{"locale":"pt","date":b[4][188],"number":b[2][2232]},{"locale":"qu-BO","date":b[4][189],"number":b[2][2251]},{"locale":"qu-EC","date":b[4][189],"number":b[2][2252]},{"locale":"qu-PE","date":b[4][189],"number":b[2][2253]},{"locale":"qu","date":b[4][189],"number":b[2][2253]},{"locale":"rm-CH","date":b[4][190],"number":b[2][2267]},{"locale":"rm","date":b[4][190],"number":b[2][2267]},{"locale":"rn-BI","date":b[4][191],"number":b[2][2281]},{"locale":"rn","date":b[4][191],"number":b[2][2281]},{"locale":"ro-MD","date":b[4][192],"number":b[2][2295]},{"locale":"ro-RO","date":b[4][192],"number":b[2][2296]},{"locale":"ro","date":b[4][192],"number":b[2][2296]},{"locale":"rof-TZ","date":b[4][193],"number":b[2][1304]},{"locale":"rof","date":b[4][193],"number":b[2][1304]},{"locale":"root","date":b[4][26],"number":b[2][289]},{"locale":"ru-BY","date":b[4][194],"number":b[2][2323]},{"locale":"ru-KG","date":b[4][194],"number":b[2][2324]},{"locale":"ru-KZ","date":b[4][194],"number":b[2][2325]},{"locale":"ru-MD","date":b[4][194],"number":b[2][2326]},{"locale":"ru-RU","date":b[4][194],"number":b[2][2327]},{"locale":"ru-UA","date":b[4][195],"number":b[2][2327]},{"locale":"ru","date":b[4][194],"number":b[2][2327]},{"locale":"rw-RW","date":b[4][196],"number":b[2][2341]},{"locale":"rw","date":b[4][196],"number":b[2][2341]},{"locale":"rwk-TZ","date":b[4][118],"number":b[2][247]},{"locale":"rwk","date":b[4][118],"number":b[2][247]},{"locale":"sah-RU","date":b[4][197],"number":b[2][2355]},{"locale":"sah","date":b[4][197],"number":b[2][2355]},{"locale":"saq-KE","date":b[4][198],"number":b[2][473]},{"locale":"saq","date":b[4][198],"number":b[2][473]},{"locale":"sbp-TZ","date":b[4][199],"number":b[2][247]},{"locale":"sbp","date":b[4][199],"number":b[2][247]},{"locale":"se-FI","date":b[4][200],"number":b[2][2395]},{"locale":"se-NO","date":b[4][201],"number":b[2][2395]},{"locale":"se-SE","date":b[4][201],"number":b[2][2409]},{"locale":"se","date":b[4][201],"number":b[2][2395]},{"locale":"seh-MZ","date":b[4][202],"number":b[2][2423]},{"locale":"seh","date":b[4][202],"number":b[2][2423]},{"locale":"ses-ML","date":b[4][203],"number":b[2][509]},{"locale":"ses","date":b[4][203],"number":b[2][509]},{"locale":"sg-CF","date":b[4][204],"number":b[2][2450]},{"locale":"sg","date":b[4][204],"number":b[2][2450]},{"locale":"shi-Latn-MA","date":b[4][205],"number":b[2][48]},{"locale":"shi-Latn","date":b[4][205],"number":b[2][48]},{"locale":"shi-Tfng-MA","date":b[4][206],"number":b[2][48]},{"locale":"shi-Tfng","date":b[4][206],"number":b[2][48]},{"locale":"shi","date":b[4][206],"number":b[2][48]},{"locale":"si-LK","date":b[4][207],"number":b[2][2490]},{"locale":"si","date":b[4][207],"number":b[2][2490]},{"locale":"sk-SK","date":b[4][208],"number":b[2][2504]},{"locale":"sk","date":b[4][208],"number":b[2][2504]},{"locale":"sl-SI","date":b[4][209],"number":b[2][2518]},{"locale":"sl","date":b[4][209],"number":b[2][2518]},{"locale":"smn-FI","date":b[4][210],"number":b[2][2532]},{"locale":"smn","date":b[4][210],"number":b[2][2532]},{"locale":"sn-ZW","date":b[4][211],"number":b[2][275]},{"locale":"sn","date":b[4][211],"number":b[2][275]},{"locale":"so-DJ","date":b[4][212],"number":b[2][2559]},{"locale":"so-ET","date":b[4][212],"number":b[2][2560]},{"locale":"so-KE","date":b[4][212],"number":b[2][2561]},{"locale":"so-SO","date":b[4][212],"number":b[2][2562]},{"locale":"so","date":b[4][212],"number":b[2][2562]},{"locale":"sq-AL","date":b[4][213],"number":b[2][2576]},{"locale":"sq-MK","date":b[4][213],"number":b[2][2577]},{"locale":"sq-XK","date":b[4][213],"number":b[2][2576]},{"locale":"sq","date":b[4][213],"number":b[2][2576]},{"locale":"sr-Cyrl-BA","date":b[4][214],"number":b[2][2591]},{"locale":"sr-Cyrl-ME","date":b[4][215],"number":b[2][2591]},{"locale":"sr-Cyrl-RS","date":b[4][215],"number":b[2][2591]},{"locale":"sr-Cyrl-XK","date":b[4][215],"number":b[2][2591]},{"locale":"sr-Cyrl","date":b[4][215],"number":b[2][2591]},{"locale":"sr-Latn-BA","date":b[4][216],"number":b[2][2618]},{"locale":"sr-Latn-ME","date":b[4][217],"number":b[2][2618]},{"locale":"sr-Latn-RS","date":b[4][217],"number":b[2][2618]},{"locale":"sr-Latn-XK","date":b[4][217],"number":b[2][2618]},{"locale":"sr-Latn","date":b[4][217],"number":b[2][2618]},{"locale":"sr","date":b[4][215],"number":b[2][2591]},{"locale":"ss-SZ","date":b[4][218],"number":b[2][2645]},{"locale":"ss-ZA","date":b[4][218],"number":b[2][2645]},{"locale":"ss","date":b[4][218],"number":b[2][2645]},{"locale":"ssy-ER","date":b[4][219],"number":b[2][2659]},{"locale":"ssy","date":b[4][219],"number":b[2][2659]},{"locale":"sv-AX","date":b[4][220],"number":b[2][2673]},{"locale":"sv-FI","date":b[4][221],"number":b[2][2673]},{"locale":"sv-SE","date":b[4][220],"number":b[2][2673]},{"locale":"sv","date":b[4][220],"number":b[2][2673]},{"locale":"sw-KE","date":b[4][222],"number":b[2][2688]},{"locale":"sw-TZ","date":b[4][222],"number":b[2][2688]},{"locale":"sw-UG","date":b[4][222],"number":b[2][2689]},{"locale":"sw","date":b[4][222],"number":b[2][2688]},{"locale":"swc-CD","date":b[4][223],"number":b[2][2703]},{"locale":"swc","date":b[4][223],"number":b[2][2703]},{"locale":"ta-IN","date":b[4][224],"number":b[2][2717]},{"locale":"ta-LK","date":b[4][224],"number":b[2][2718]},{"locale":"ta-MY","date":b[4][224],"number":b[2][2719]},{"locale":"ta-SG","date":b[4][224],"number":b[2][2720]},{"locale":"ta","date":b[4][224],"number":b[2][2717]},{"locale":"te-IN","date":b[4][225],"number":b[2][2734]},{"locale":"te","date":b[4][225],"number":b[2][2734]},{"locale":"teo-KE","date":b[4][226],"number":b[2][2748]},{"locale":"teo-UG","date":b[4][226],"number":b[2][403]},{"locale":"teo","date":b[4][226],"number":b[2][403]},{"locale":"th-TH","date":b[4][227],"number":b[2][2762]},{"locale":"th","date":b[4][227],"number":b[2][2762]},{"locale":"ti-ER","date":b[4][228],"number":b[2][18]},{"locale":"ti-ET","date":b[4][229],"number":b[2][19]},{"locale":"ti","date":b[4][229],"number":b[2][19]},{"locale":"tn-BW","date":b[4][230],"number":b[2][2802]},{"locale":"tn-ZA","date":b[4][230],"number":b[2][2092]},{"locale":"tn","date":b[4][230],"number":b[2][2092]},{"locale":"to-TO","date":b[4][231],"number":b[2][2816]},{"locale":"to","date":b[4][231],"number":b[2][2816]},{"locale":"tr-CY","date":b[4][232],"number":b[2][2830]},{"locale":"tr-TR","date":b[4][232],"number":b[2][2830]},{"locale":"tr","date":b[4][232],"number":b[2][2830]},{"locale":"ts-ZA","date":b[4][233],"number":b[2][2078]},{"locale":"ts","date":b[4][233],"number":b[2][2078]},{"locale":"twq-NE","date":b[4][234],"number":b[2][509]},{"locale":"twq","date":b[4][234],"number":b[2][509]},{"locale":"tzm-Latn-MA","date":b[4][235],"number":b[2][550]},{"locale":"tzm-Latn","date":b[4][235],"number":b[2][550]},{"locale":"tzm","date":b[4][235],"number":b[2][550]},{"locale":"ug-Arab-CN","date":b[4][236],"number":b[2][2883]},{"locale":"ug-Arab","date":b[4][236],"number":b[2][2883]},{"locale":"ug","date":b[4][236],"number":b[2][2883]},{"locale":"uk-UA","date":b[4][237],"number":b[2][2897]},{"locale":"uk","date":b[4][237],"number":b[2][2897]},{"locale":"ur-IN","date":b[4][238],"number":b[2][2911]},{"locale":"ur-PK","date":b[4][239],"number":b[2][2925]},{"locale":"ur","date":b[4][239],"number":b[2][2925]},{"locale":"uz-Arab-AF","date":b[4][240],"number":b[2][2204]},{"locale":"uz-Arab","date":b[4][240],"number":b[2][2204]},{"locale":"uz-Cyrl-UZ","date":b[4][241],"number":b[2][2952]},{"locale":"uz-Cyrl","date":b[4][241],"number":b[2][2952]},{"locale":"uz-Latn-UZ","date":b[4][242],"number":b[2][2966]},{"locale":"uz-Latn","date":b[4][242],"number":b[2][2966]},{"locale":"uz","date":b[4][242],"number":b[2][2966]},{"locale":"vai-Latn-LR","date":b[4][243],"number":b[2][2980]},{"locale":"vai-Latn","date":b[4][243],"number":b[2][2980]},{"locale":"vai-Vaii-LR","date":b[4][244],"number":b[2][2980]},{"locale":"vai-Vaii","date":b[4][244],"number":b[2][2980]},{"locale":"vai","date":b[4][244],"number":b[2][2980]},{"locale":"ve-ZA","date":b[4][245],"number":b[2][2078]},{"locale":"ve","date":b[4][245],"number":b[2][2078]},{"locale":"vi-VN","date":b[4][246],"number":b[2][3020]},{"locale":"vi","date":b[4][246],"number":b[2][3020]},{"locale":"vo-001","date":b[4][247],"number":b[2][289]},{"locale":"vo","date":b[4][247],"number":b[2][289]},{"locale":"vun-TZ","date":b[4][118],"number":b[2][1304]},{"locale":"vun","date":b[4][118],"number":b[2][1304]},{"locale":"wae-CH","date":b[4][248],"number":b[2][3047]},{"locale":"wae","date":b[4][248],"number":b[2][3047]},{"locale":"xog-UG","date":b[4][249],"number":b[2][3061]},{"locale":"xog","date":b[4][249],"number":b[2][3061]},{"locale":"yav-CM","date":b[4][250],"number":b[2][550]},{"locale":"yav","date":b[4][250],"number":b[2][550]},{"locale":"yi-001","date":b[4][251],"number":b[2][289]},{"locale":"yi","date":b[4][251],"number":b[2][289]},{"locale":"yo-BJ","date":b[4][252],"number":b[2][1220]},{"locale":"yo-NG","date":b[4][253],"number":b[2][1220]},{"locale":"yo","date":b[4][253],"number":b[2][1220]},{"locale":"zgh-MA","date":b[4][254],"number":b[2][3127]},{"locale":"zgh","date":b[4][254],"number":b[2][3127]},{"locale":"zh-Hans-CN","date":b[4][255],"number":b[2][3140]},{"locale":"zh-Hans-HK","date":b[4][256],"number":b[2][3141]},{"locale":"zh-Hans-MO","date":b[4][257],"number":b[2][3142]},{"locale":"zh-Hans-SG","date":b[4][258],"number":b[2][3143]},{"locale":"zh-Hans","date":b[4][255],"number":b[2][3140]},{"locale":"zh-Hant-HK","date":b[4][259],"number":b[2][3156]},{"locale":"zh-Hant-MO","date":b[4][260],"number":b[2][3157]},{"locale":"zh-Hant-TW","date":b[4][261],"number":b[2][3160]},{"locale":"zh-Hant","date":b[4][261],"number":b[2][3160]},{"locale":"zh","date":b[4][255],"number":b[2][3140]},{"locale":"zu-ZA","date":b[4][262],"number":b[2][3174]},{"locale":"zu","date":b[4][262],"number":b[2][3174]}];addLocaleData(b[5][0]);
	addLocaleData(b[5][1]);
	addLocaleData(b[5][2]);
	addLocaleData(b[5][3]);
	addLocaleData(b[5][4]);
	addLocaleData(b[5][5]);
	addLocaleData(b[5][6]);
	addLocaleData(b[5][7]);
	addLocaleData(b[5][8]);
	addLocaleData(b[5][9]);
	addLocaleData(b[5][10]);
	addLocaleData(b[5][11]);
	addLocaleData(b[5][12]);
	addLocaleData(b[5][13]);
	addLocaleData(b[5][14]);
	addLocaleData(b[5][15]);
	addLocaleData(b[5][16]);
	addLocaleData(b[5][17]);
	addLocaleData(b[5][18]);
	addLocaleData(b[5][19]);
	addLocaleData(b[5][20]);
	addLocaleData(b[5][21]);
	addLocaleData(b[5][22]);
	addLocaleData(b[5][23]);
	addLocaleData(b[5][24]);
	addLocaleData(b[5][25]);
	addLocaleData(b[5][26]);
	addLocaleData(b[5][27]);
	addLocaleData(b[5][28]);
	addLocaleData(b[5][29]);
	addLocaleData(b[5][30]);
	addLocaleData(b[5][31]);
	addLocaleData(b[5][32]);
	addLocaleData(b[5][33]);
	addLocaleData(b[5][34]);
	addLocaleData(b[5][35]);
	addLocaleData(b[5][36]);
	addLocaleData(b[5][37]);
	addLocaleData(b[5][38]);
	addLocaleData(b[5][39]);
	addLocaleData(b[5][40]);
	addLocaleData(b[5][41]);
	addLocaleData(b[5][42]);
	addLocaleData(b[5][43]);
	addLocaleData(b[5][44]);
	addLocaleData(b[5][45]);
	addLocaleData(b[5][46]);
	addLocaleData(b[5][47]);
	addLocaleData(b[5][48]);
	addLocaleData(b[5][49]);
	addLocaleData(b[5][50]);
	addLocaleData(b[5][51]);
	addLocaleData(b[5][52]);
	addLocaleData(b[5][53]);
	addLocaleData(b[5][54]);
	addLocaleData(b[5][55]);
	addLocaleData(b[5][56]);
	addLocaleData(b[5][57]);
	addLocaleData(b[5][58]);
	addLocaleData(b[5][59]);
	addLocaleData(b[5][60]);
	addLocaleData(b[5][61]);
	addLocaleData(b[5][62]);
	addLocaleData(b[5][63]);
	addLocaleData(b[5][64]);
	addLocaleData(b[5][65]);
	addLocaleData(b[5][66]);
	addLocaleData(b[5][67]);
	addLocaleData(b[5][68]);
	addLocaleData(b[5][69]);
	addLocaleData(b[5][70]);
	addLocaleData(b[5][71]);
	addLocaleData(b[5][72]);
	addLocaleData(b[5][73]);
	addLocaleData(b[5][74]);
	addLocaleData(b[5][75]);
	addLocaleData(b[5][76]);
	addLocaleData(b[5][77]);
	addLocaleData(b[5][78]);
	addLocaleData(b[5][79]);
	addLocaleData(b[5][80]);
	addLocaleData(b[5][81]);
	addLocaleData(b[5][82]);
	addLocaleData(b[5][83]);
	addLocaleData(b[5][84]);
	addLocaleData(b[5][85]);
	addLocaleData(b[5][86]);
	addLocaleData(b[5][87]);
	addLocaleData(b[5][88]);
	addLocaleData(b[5][89]);
	addLocaleData(b[5][90]);
	addLocaleData(b[5][91]);
	addLocaleData(b[5][92]);
	addLocaleData(b[5][93]);
	addLocaleData(b[5][94]);
	addLocaleData(b[5][95]);
	addLocaleData(b[5][96]);
	addLocaleData(b[5][97]);
	addLocaleData(b[5][98]);
	addLocaleData(b[5][99]);
	addLocaleData(b[5][100]);
	addLocaleData(b[5][101]);
	addLocaleData(b[5][102]);
	addLocaleData(b[5][103]);
	addLocaleData(b[5][104]);
	addLocaleData(b[5][105]);
	addLocaleData(b[5][106]);
	addLocaleData(b[5][107]);
	addLocaleData(b[5][108]);
	addLocaleData(b[5][109]);
	addLocaleData(b[5][110]);
	addLocaleData(b[5][111]);
	addLocaleData(b[5][112]);
	addLocaleData(b[5][113]);
	addLocaleData(b[5][114]);
	addLocaleData(b[5][115]);
	addLocaleData(b[5][116]);
	addLocaleData(b[5][117]);
	addLocaleData(b[5][118]);
	addLocaleData(b[5][119]);
	addLocaleData(b[5][120]);
	addLocaleData(b[5][121]);
	addLocaleData(b[5][122]);
	addLocaleData(b[5][123]);
	addLocaleData(b[5][124]);
	addLocaleData(b[5][125]);
	addLocaleData(b[5][126]);
	addLocaleData(b[5][127]);
	addLocaleData(b[5][128]);
	addLocaleData(b[5][129]);
	addLocaleData(b[5][130]);
	addLocaleData(b[5][131]);
	addLocaleData(b[5][132]);
	addLocaleData(b[5][133]);
	addLocaleData(b[5][134]);
	addLocaleData(b[5][135]);
	addLocaleData(b[5][136]);
	addLocaleData(b[5][137]);
	addLocaleData(b[5][138]);
	addLocaleData(b[5][139]);
	addLocaleData(b[5][140]);
	addLocaleData(b[5][141]);
	addLocaleData(b[5][142]);
	addLocaleData(b[5][143]);
	addLocaleData(b[5][144]);
	addLocaleData(b[5][145]);
	addLocaleData(b[5][146]);
	addLocaleData(b[5][147]);
	addLocaleData(b[5][148]);
	addLocaleData(b[5][149]);
	addLocaleData(b[5][150]);
	addLocaleData(b[5][151]);
	addLocaleData(b[5][152]);
	addLocaleData(b[5][153]);
	addLocaleData(b[5][154]);
	addLocaleData(b[5][155]);
	addLocaleData(b[5][156]);
	addLocaleData(b[5][157]);
	addLocaleData(b[5][158]);
	addLocaleData(b[5][159]);
	addLocaleData(b[5][160]);
	addLocaleData(b[5][161]);
	addLocaleData(b[5][162]);
	addLocaleData(b[5][163]);
	addLocaleData(b[5][164]);
	addLocaleData(b[5][165]);
	addLocaleData(b[5][166]);
	addLocaleData(b[5][167]);
	addLocaleData(b[5][168]);
	addLocaleData(b[5][169]);
	addLocaleData(b[5][170]);
	addLocaleData(b[5][171]);
	addLocaleData(b[5][172]);
	addLocaleData(b[5][173]);
	addLocaleData(b[5][174]);
	addLocaleData(b[5][175]);
	addLocaleData(b[5][176]);
	addLocaleData(b[5][177]);
	addLocaleData(b[5][178]);
	addLocaleData(b[5][179]);
	addLocaleData(b[5][180]);
	addLocaleData(b[5][181]);
	addLocaleData(b[5][182]);
	addLocaleData(b[5][183]);
	addLocaleData(b[5][184]);
	addLocaleData(b[5][185]);
	addLocaleData(b[5][186]);
	addLocaleData(b[5][187]);
	addLocaleData(b[5][188]);
	addLocaleData(b[5][189]);
	addLocaleData(b[5][190]);
	addLocaleData(b[5][191]);
	addLocaleData(b[5][192]);
	addLocaleData(b[5][193]);
	addLocaleData(b[5][194]);
	addLocaleData(b[5][195]);
	addLocaleData(b[5][196]);
	addLocaleData(b[5][197]);
	addLocaleData(b[5][198]);
	addLocaleData(b[5][199]);
	addLocaleData(b[5][200]);
	addLocaleData(b[5][201]);
	addLocaleData(b[5][202]);
	addLocaleData(b[5][203]);
	addLocaleData(b[5][204]);
	addLocaleData(b[5][205]);
	addLocaleData(b[5][206]);
	addLocaleData(b[5][207]);
	addLocaleData(b[5][208]);
	addLocaleData(b[5][209]);
	addLocaleData(b[5][210]);
	addLocaleData(b[5][211]);
	addLocaleData(b[5][212]);
	addLocaleData(b[5][213]);
	addLocaleData(b[5][214]);
	addLocaleData(b[5][215]);
	addLocaleData(b[5][216]);
	addLocaleData(b[5][217]);
	addLocaleData(b[5][218]);
	addLocaleData(b[5][219]);
	addLocaleData(b[5][220]);
	addLocaleData(b[5][221]);
	addLocaleData(b[5][222]);
	addLocaleData(b[5][223]);
	addLocaleData(b[5][224]);
	addLocaleData(b[5][225]);
	addLocaleData(b[5][226]);
	addLocaleData(b[5][227]);
	addLocaleData(b[5][228]);
	addLocaleData(b[5][229]);
	addLocaleData(b[5][230]);
	addLocaleData(b[5][231]);
	addLocaleData(b[5][232]);
	addLocaleData(b[5][233]);
	addLocaleData(b[5][234]);
	addLocaleData(b[5][235]);
	addLocaleData(b[5][236]);
	addLocaleData(b[5][237]);
	addLocaleData(b[5][238]);
	addLocaleData(b[5][239]);
	addLocaleData(b[5][240]);
	addLocaleData(b[5][241]);
	addLocaleData(b[5][242]);
	addLocaleData(b[5][243]);
	addLocaleData(b[5][244]);
	addLocaleData(b[5][245]);
	addLocaleData(b[5][246]);
	addLocaleData(b[5][247]);
	addLocaleData(b[5][248]);
	addLocaleData(b[5][249]);
	addLocaleData(b[5][250]);
	addLocaleData(b[5][251]);
	addLocaleData(b[5][252]);
	addLocaleData(b[5][253]);
	addLocaleData(b[5][254]);
	addLocaleData(b[5][255]);
	addLocaleData(b[5][256]);
	addLocaleData(b[5][257]);
	addLocaleData(b[5][258]);
	addLocaleData(b[5][259]);
	addLocaleData(b[5][260]);
	addLocaleData(b[5][261]);
	addLocaleData(b[5][262]);
	addLocaleData(b[5][263]);
	addLocaleData(b[5][264]);
	addLocaleData(b[5][265]);
	addLocaleData(b[5][266]);
	addLocaleData(b[5][267]);
	addLocaleData(b[5][268]);
	addLocaleData(b[5][269]);
	addLocaleData(b[5][270]);
	addLocaleData(b[5][271]);
	addLocaleData(b[5][272]);
	addLocaleData(b[5][273]);
	addLocaleData(b[5][274]);
	addLocaleData(b[5][275]);
	addLocaleData(b[5][276]);
	addLocaleData(b[5][277]);
	addLocaleData(b[5][278]);
	addLocaleData(b[5][279]);
	addLocaleData(b[5][280]);
	addLocaleData(b[5][281]);
	addLocaleData(b[5][282]);
	addLocaleData(b[5][283]);
	addLocaleData(b[5][284]);
	addLocaleData(b[5][285]);
	addLocaleData(b[5][286]);
	addLocaleData(b[5][287]);
	addLocaleData(b[5][288]);
	addLocaleData(b[5][289]);
	addLocaleData(b[5][290]);
	addLocaleData(b[5][291]);
	addLocaleData(b[5][292]);
	addLocaleData(b[5][293]);
	addLocaleData(b[5][294]);
	addLocaleData(b[5][295]);
	addLocaleData(b[5][296]);
	addLocaleData(b[5][297]);
	addLocaleData(b[5][298]);
	addLocaleData(b[5][299]);
	addLocaleData(b[5][300]);
	addLocaleData(b[5][301]);
	addLocaleData(b[5][302]);
	addLocaleData(b[5][303]);
	addLocaleData(b[5][304]);
	addLocaleData(b[5][305]);
	addLocaleData(b[5][306]);
	addLocaleData(b[5][307]);
	addLocaleData(b[5][308]);
	addLocaleData(b[5][309]);
	addLocaleData(b[5][310]);
	addLocaleData(b[5][311]);
	addLocaleData(b[5][312]);
	addLocaleData(b[5][313]);
	addLocaleData(b[5][314]);
	addLocaleData(b[5][315]);
	addLocaleData(b[5][316]);
	addLocaleData(b[5][317]);
	addLocaleData(b[5][318]);
	addLocaleData(b[5][319]);
	addLocaleData(b[5][320]);
	addLocaleData(b[5][321]);
	addLocaleData(b[5][322]);
	addLocaleData(b[5][323]);
	addLocaleData(b[5][324]);
	addLocaleData(b[5][325]);
	addLocaleData(b[5][326]);
	addLocaleData(b[5][327]);
	addLocaleData(b[5][328]);
	addLocaleData(b[5][329]);
	addLocaleData(b[5][330]);
	addLocaleData(b[5][331]);
	addLocaleData(b[5][332]);
	addLocaleData(b[5][333]);
	addLocaleData(b[5][334]);
	addLocaleData(b[5][335]);
	addLocaleData(b[5][336]);
	addLocaleData(b[5][337]);
	addLocaleData(b[5][338]);
	addLocaleData(b[5][339]);
	addLocaleData(b[5][340]);
	addLocaleData(b[5][341]);
	addLocaleData(b[5][342]);
	addLocaleData(b[5][343]);
	addLocaleData(b[5][344]);
	addLocaleData(b[5][345]);
	addLocaleData(b[5][346]);
	addLocaleData(b[5][347]);
	addLocaleData(b[5][348]);
	addLocaleData(b[5][349]);
	addLocaleData(b[5][350]);
	addLocaleData(b[5][351]);
	addLocaleData(b[5][352]);
	addLocaleData(b[5][353]);
	addLocaleData(b[5][354]);
	addLocaleData(b[5][355]);
	addLocaleData(b[5][356]);
	addLocaleData(b[5][357]);
	addLocaleData(b[5][358]);
	addLocaleData(b[5][359]);
	addLocaleData(b[5][360]);
	addLocaleData(b[5][361]);
	addLocaleData(b[5][362]);
	addLocaleData(b[5][363]);
	addLocaleData(b[5][364]);
	addLocaleData(b[5][365]);
	addLocaleData(b[5][366]);
	addLocaleData(b[5][367]);
	addLocaleData(b[5][368]);
	addLocaleData(b[5][369]);
	addLocaleData(b[5][370]);
	addLocaleData(b[5][371]);
	addLocaleData(b[5][372]);
	addLocaleData(b[5][373]);
	addLocaleData(b[5][374]);
	addLocaleData(b[5][375]);
	addLocaleData(b[5][376]);
	addLocaleData(b[5][377]);
	addLocaleData(b[5][378]);
	addLocaleData(b[5][379]);
	addLocaleData(b[5][380]);
	addLocaleData(b[5][381]);
	addLocaleData(b[5][382]);
	addLocaleData(b[5][383]);
	addLocaleData(b[5][384]);
	addLocaleData(b[5][385]);
	addLocaleData(b[5][386]);
	addLocaleData(b[5][387]);
	addLocaleData(b[5][388]);
	addLocaleData(b[5][389]);
	addLocaleData(b[5][390]);
	addLocaleData(b[5][391]);
	addLocaleData(b[5][392]);
	addLocaleData(b[5][393]);
	addLocaleData(b[5][394]);
	addLocaleData(b[5][395]);
	addLocaleData(b[5][396]);
	addLocaleData(b[5][397]);
	addLocaleData(b[5][398]);
	addLocaleData(b[5][399]);
	addLocaleData(b[5][400]);
	addLocaleData(b[5][401]);
	addLocaleData(b[5][402]);
	addLocaleData(b[5][403]);
	addLocaleData(b[5][404]);
	addLocaleData(b[5][405]);
	addLocaleData(b[5][406]);
	addLocaleData(b[5][407]);
	addLocaleData(b[5][408]);
	addLocaleData(b[5][409]);
	addLocaleData(b[5][410]);
	addLocaleData(b[5][411]);
	addLocaleData(b[5][412]);
	addLocaleData(b[5][413]);
	addLocaleData(b[5][414]);
	addLocaleData(b[5][415]);
	addLocaleData(b[5][416]);
	addLocaleData(b[5][417]);
	addLocaleData(b[5][418]);
	addLocaleData(b[5][419]);
	addLocaleData(b[5][420]);
	addLocaleData(b[5][421]);
	addLocaleData(b[5][422]);
	addLocaleData(b[5][423]);
	addLocaleData(b[5][424]);
	addLocaleData(b[5][425]);
	addLocaleData(b[5][426]);
	addLocaleData(b[5][427]);
	addLocaleData(b[5][428]);
	addLocaleData(b[5][429]);
	addLocaleData(b[5][430]);
	addLocaleData(b[5][431]);
	addLocaleData(b[5][432]);
	addLocaleData(b[5][433]);
	addLocaleData(b[5][434]);
	addLocaleData(b[5][435]);
	addLocaleData(b[5][436]);
	addLocaleData(b[5][437]);
	addLocaleData(b[5][438]);
	addLocaleData(b[5][439]);
	addLocaleData(b[5][440]);
	addLocaleData(b[5][441]);
	addLocaleData(b[5][442]);
	addLocaleData(b[5][443]);
	addLocaleData(b[5][444]);
	addLocaleData(b[5][445]);
	addLocaleData(b[5][446]);
	addLocaleData(b[5][447]);
	addLocaleData(b[5][448]);
	addLocaleData(b[5][449]);
	addLocaleData(b[5][450]);
	addLocaleData(b[5][451]);
	addLocaleData(b[5][452]);
	addLocaleData(b[5][453]);
	addLocaleData(b[5][454]);
	addLocaleData(b[5][455]);
	addLocaleData(b[5][456]);
	addLocaleData(b[5][457]);
	addLocaleData(b[5][458]);
	addLocaleData(b[5][459]);
	addLocaleData(b[5][460]);
	addLocaleData(b[5][461]);
	addLocaleData(b[5][462]);
	addLocaleData(b[5][463]);
	addLocaleData(b[5][464]);
	addLocaleData(b[5][465]);
	addLocaleData(b[5][466]);
	addLocaleData(b[5][467]);
	addLocaleData(b[5][468]);
	addLocaleData(b[5][469]);
	addLocaleData(b[5][470]);
	addLocaleData(b[5][471]);
	addLocaleData(b[5][472]);
	addLocaleData(b[5][473]);
	addLocaleData(b[5][474]);
	addLocaleData(b[5][475]);
	addLocaleData(b[5][476]);
	addLocaleData(b[5][477]);
	addLocaleData(b[5][478]);
	addLocaleData(b[5][479]);
	addLocaleData(b[5][480]);
	addLocaleData(b[5][481]);
	addLocaleData(b[5][482]);
	addLocaleData(b[5][483]);
	addLocaleData(b[5][484]);
	addLocaleData(b[5][485]);
	addLocaleData(b[5][486]);
	addLocaleData(b[5][487]);
	addLocaleData(b[5][488]);
	addLocaleData(b[5][489]);
	addLocaleData(b[5][490]);
	addLocaleData(b[5][491]);
	addLocaleData(b[5][492]);
	addLocaleData(b[5][493]);
	addLocaleData(b[5][494]);
	addLocaleData(b[5][495]);
	addLocaleData(b[5][496]);
	addLocaleData(b[5][497]);
	addLocaleData(b[5][498]);
	addLocaleData(b[5][499]);
	addLocaleData(b[5][500]);
	addLocaleData(b[5][501]);
	addLocaleData(b[5][502]);
	addLocaleData(b[5][503]);
	addLocaleData(b[5][504]);
	addLocaleData(b[5][505]);
	addLocaleData(b[5][506]);
	addLocaleData(b[5][507]);
	addLocaleData(b[5][508]);
	addLocaleData(b[5][509]);
	addLocaleData(b[5][510]);
	addLocaleData(b[5][511]);
	addLocaleData(b[5][512]);
	addLocaleData(b[5][513]);
	addLocaleData(b[5][514]);
	addLocaleData(b[5][515]);
	addLocaleData(b[5][516]);
	addLocaleData(b[5][517]);
	addLocaleData(b[5][518]);
	addLocaleData(b[5][519]);
	addLocaleData(b[5][520]);
	addLocaleData(b[5][521]);
	addLocaleData(b[5][522]);
	addLocaleData(b[5][523]);
	addLocaleData(b[5][524]);
	addLocaleData(b[5][525]);
	addLocaleData(b[5][526]);
	addLocaleData(b[5][527]);
	addLocaleData(b[5][528]);
	addLocaleData(b[5][529]);
	addLocaleData(b[5][530]);
	addLocaleData(b[5][531]);
	addLocaleData(b[5][532]);
	addLocaleData(b[5][533]);
	addLocaleData(b[5][534]);
	addLocaleData(b[5][535]);
	addLocaleData(b[5][536]);
	addLocaleData(b[5][537]);
	addLocaleData(b[5][538]);
	addLocaleData(b[5][539]);
	addLocaleData(b[5][540]);
	addLocaleData(b[5][541]);
	addLocaleData(b[5][542]);
	addLocaleData(b[5][543]);
	addLocaleData(b[5][544]);
	addLocaleData(b[5][545]);
	addLocaleData(b[5][546]);
	addLocaleData(b[5][547]);
	addLocaleData(b[5][548]);
	addLocaleData(b[5][549]);
	addLocaleData(b[5][550]);
	addLocaleData(b[5][551]);
	addLocaleData(b[5][552]);
	addLocaleData(b[5][553]);
	addLocaleData(b[5][554]);
	addLocaleData(b[5][555]);
	addLocaleData(b[5][556]);
	addLocaleData(b[5][557]);
	addLocaleData(b[5][558]);
	addLocaleData(b[5][559]);
	addLocaleData(b[5][560]);
	addLocaleData(b[5][561]);
	addLocaleData(b[5][562]);
	addLocaleData(b[5][563]);
	addLocaleData(b[5][564]);
	addLocaleData(b[5][565]);
	addLocaleData(b[5][566]);
	addLocaleData(b[5][567]);
	addLocaleData(b[5][568]);
	addLocaleData(b[5][569]);
	addLocaleData(b[5][570]);
	addLocaleData(b[5][571]);
	addLocaleData(b[5][572]);
	addLocaleData(b[5][573]);
	addLocaleData(b[5][574]);
	addLocaleData(b[5][575]);
	addLocaleData(b[5][576]);
	addLocaleData(b[5][577]);
	addLocaleData(b[5][578]);
	addLocaleData(b[5][579]);
	addLocaleData(b[5][580]);
	addLocaleData(b[5][581]);
	addLocaleData(b[5][582]);
	addLocaleData(b[5][583]);
	addLocaleData(b[5][584]);
	addLocaleData(b[5][585]);
	addLocaleData(b[5][586]);
	addLocaleData(b[5][587]);
	addLocaleData(b[5][588]);
	addLocaleData(b[5][589]);
	addLocaleData(b[5][590]);
	addLocaleData(b[5][591]);
	addLocaleData(b[5][592]);
	addLocaleData(b[5][593]);
	addLocaleData(b[5][594]);
	addLocaleData(b[5][595]);
	addLocaleData(b[5][596]);
	addLocaleData(b[5][597]);
	addLocaleData(b[5][598]);
	addLocaleData(b[5][599]);
	addLocaleData(b[5][600]);
	addLocaleData(b[5][601]);
	addLocaleData(b[5][602]);
	addLocaleData(b[5][603]);
	addLocaleData(b[5][604]);
	addLocaleData(b[5][605]);
	addLocaleData(b[5][606]);
	addLocaleData(b[5][607]);
	addLocaleData(b[5][608]);
	addLocaleData(b[5][609]);
	addLocaleData(b[5][610]);
	addLocaleData(b[5][611]);
	addLocaleData(b[5][612]);
	addLocaleData(b[5][613]);
	addLocaleData(b[5][614]);
	addLocaleData(b[5][615]);
	addLocaleData(b[5][616]);
	addLocaleData(b[5][617]);
	addLocaleData(b[5][618]);
	addLocaleData(b[5][619]);
	addLocaleData(b[5][620]);
	addLocaleData(b[5][621]);
	addLocaleData(b[5][622]);
	addLocaleData(b[5][623]);
	addLocaleData(b[5][624]);
	addLocaleData(b[5][625]);
	addLocaleData(b[5][626]);
	addLocaleData(b[5][627]);
	addLocaleData(b[5][628]);
	addLocaleData(b[5][629]);
	addLocaleData(b[5][630]);
	addLocaleData(b[5][631]);
	addLocaleData(b[5][632]);
	addLocaleData(b[5][633]);
	addLocaleData(b[5][634]);
	addLocaleData(b[5][635]);
	addLocaleData(b[5][636]);
	addLocaleData(b[5][637]);
	addLocaleData(b[5][638]);
	addLocaleData(b[5][639]);
	addLocaleData(b[5][640]);
	addLocaleData(b[5][641]);
	addLocaleData(b[5][642]);
	addLocaleData(b[5][643]);
	addLocaleData(b[5][644]);
	addLocaleData(b[5][645]);
	addLocaleData(b[5][646]);
	addLocaleData(b[5][647]);
	addLocaleData(b[5][648]);
	addLocaleData(b[5][649]);
	addLocaleData(b[5][650]);
	addLocaleData(b[5][651]);
	addLocaleData(b[5][652]);
	addLocaleData(b[5][653]);
	addLocaleData(b[5][654]);
	addLocaleData(b[5][655]);
	addLocaleData(b[5][656]);
	addLocaleData(b[5][657]);
	addLocaleData(b[5][658]);
	addLocaleData(b[5][659]);
	addLocaleData(b[5][660]);
	addLocaleData(b[5][661]);
	addLocaleData(b[5][662]);
	addLocaleData(b[5][663]);
	addLocaleData(b[5][664]);
	addLocaleData(b[5][665]);
	addLocaleData(b[5][666]);
	addLocaleData(b[5][667]);
	addLocaleData(b[5][668]);
	addLocaleData(b[5][669]);
	addLocaleData(b[5][670]);
	addLocaleData(b[5][671]);
	addLocaleData(b[5][672]);
	addLocaleData(b[5][673]);
	addLocaleData(b[5][674]);
	addLocaleData(b[5][675]);
	addLocaleData(b[5][676]);
	addLocaleData(b[5][677]);
	addLocaleData(b[5][678]);
	addLocaleData(b[5][679]);
	addLocaleData(b[5][680]);
	addLocaleData(b[5][681]);
	addLocaleData(b[5][682]);
	addLocaleData(b[5][683]);
	addLocaleData(b[5][684]);
	addLocaleData(b[5][685]);
	addLocaleData(b[5][686]);
	addLocaleData(b[5][687]);
	addLocaleData(b[5][688]);
	addLocaleData(b[5][689]);
	addLocaleData(b[5][690]);
	addLocaleData(b[5][691]);
	addLocaleData(b[5][692]);
	addLocaleData(b[5][693]);
	addLocaleData(b[5][694]);
	addLocaleData(b[5][695]);
	addLocaleData(b[5][696]);
	addLocaleData(b[5][697]);
	addLocaleData(b[5][698]);
	addLocaleData(b[5][699]);
	addLocaleData(b[5][700]);
	addLocaleData(b[5][701]);
	addLocaleData(b[5][702]);
	addLocaleData(b[5][703]);
	addLocaleData(b[5][704]);
	addLocaleData(b[5][705]);
	addLocaleData(b[5][706]);
	addLocaleData(b[5][707]);
	addLocaleData(b[5][708]);
	addLocaleData(b[5][709]);
	addLocaleData(b[5][710]);
	addLocaleData(b[5][711]);
	addLocaleData(b[5][712]);
	addLocaleData(b[5][713]);
	addLocaleData(b[5][714]);
	addLocaleData(b[5][715]);
	addLocaleData(b[5][716]);
	})(IntlPolyfill.__addLocaleData);

/***/ }),
/* 749 */
/***/ (function(module, exports) {

	module.exports = isFunction
	
	var toString = Object.prototype.toString
	
	function isFunction (fn) {
	  if (!fn) {
	    return false
	  }
	  var string = toString.call(fn)
	  return string === '[object Function]' ||
	    (typeof fn === 'function' && string !== '[object RegExp]') ||
	    (typeof window !== 'undefined' &&
	     // IE8 and below
	     (fn === window.setTimeout ||
	      fn === window.alert ||
	      fn === window.confirm ||
	      fn === window.prompt))
	};


/***/ }),
/* 750 */
/***/ (function(module, exports) {

	module.exports = isPromise;
	
	function isPromise(obj) {
	  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
	}


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(752).default;


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = linkifyHtml;
	
	var _simpleHtmlTokenizer = __webpack_require__(758);
	
	var _simpleHtmlTokenizer2 = _interopRequireDefault(_simpleHtmlTokenizer);
	
	var _linkify = __webpack_require__(753);
	
	var linkify = _interopRequireWildcard(_linkify);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var options = linkify.options;
	var Options = options.Options;
	
	
	var StartTag = 'StartTag';
	var EndTag = 'EndTag';
	var Chars = 'Chars';
	var Comment = 'Comment';
	
	/**
		`tokens` and `token` in this section refer to tokens generated by the HTML
		parser.
	*/
	function linkifyHtml(str) {
		var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
		var tokens = _simpleHtmlTokenizer2.default.tokenize(str);
		var linkifiedTokens = [];
		var linkified = [];
		var i;
	
		opts = new Options(opts);
	
		// Linkify the tokens given by the parser
		for (i = 0; i < tokens.length; i++) {
			var token = tokens[i];
	
			if (token.type === StartTag) {
				linkifiedTokens.push(token);
	
				// Ignore all the contents of ignored tags
				var tagName = token.tagName.toUpperCase();
				var isIgnored = tagName === 'A' || options.contains(opts.ignoreTags, tagName);
				if (!isIgnored) {
					continue;
				}
	
				var preskipLen = linkifiedTokens.length;
				skipTagTokens(tagName, tokens, ++i, linkifiedTokens);
				i += linkifiedTokens.length - preskipLen - 1;
				continue;
			} else if (token.type !== Chars) {
				// Skip this token, it's not important
				linkifiedTokens.push(token);
				continue;
			}
	
			// Valid text token, linkify it!
			var linkifedChars = linkifyChars(token.chars, opts);
			linkifiedTokens.push.apply(linkifiedTokens, linkifedChars);
		}
	
		// Convert the tokens back into a string
		for (i = 0; i < linkifiedTokens.length; i++) {
			var _token = linkifiedTokens[i];
			switch (_token.type) {
				case StartTag:
					{
						var link = '<' + _token.tagName;
						if (_token.attributes.length > 0) {
							var attrs = attrsToStrings(_token.attributes);
							link += ' ' + attrs.join(' ');
						}
						link += '>';
						linkified.push(link);
						break;
					}
				case EndTag:
					linkified.push('</' + _token.tagName + '>');
					break;
				case Chars:
					linkified.push(escapeText(_token.chars));
					break;
				case Comment:
					linkified.push('<!--' + escapeText(_token.chars) + '-->');
					break;
			}
		}
	
		return linkified.join('');
	}
	
	/**
		`tokens` and `token` in this section referes to tokens returned by
		`linkify.tokenize`. `linkified` will contain HTML Parser-style tokens
	*/
	function linkifyChars(str, opts) {
		var tokens = linkify.tokenize(str);
		var result = [];
	
		for (var i = 0; i < tokens.length; i++) {
			var token = tokens[i];
	
			if (token.type === 'nl' && opts.nl2br) {
				result.push({
					type: StartTag,
					tagName: 'br',
					attributes: [],
					selfClosing: true
				});
				continue;
			} else if (!token.isLink || !opts.check(token)) {
				result.push({ type: Chars, chars: token.toString() });
				continue;
			}
	
			var _opts$resolve = opts.resolve(token),
			    formatted = _opts$resolve.formatted,
			    formattedHref = _opts$resolve.formattedHref,
			    tagName = _opts$resolve.tagName,
			    className = _opts$resolve.className,
			    target = _opts$resolve.target,
			    attributes = _opts$resolve.attributes;
	
			// Build up attributes
	
	
			var attributeArray = [['href', formattedHref]];
	
			if (className) {
				attributeArray.push(['class', className]);
			}
	
			if (target) {
				attributeArray.push(['target', target]);
			}
	
			for (var attr in attributes) {
				attributeArray.push([attr, attributes[attr]]);
			}
	
			// Add the required tokens
			result.push({
				type: StartTag,
				tagName: tagName,
				attributes: attributeArray,
				selfClosing: false
			});
			result.push({ type: Chars, chars: formatted });
			result.push({ type: EndTag, tagName: tagName });
		}
	
		return result;
	}
	
	/**
		Returns a list of tokens skipped until the closing tag of tagName.
	
		* `tagName` is the closing tag which will prompt us to stop skipping
		* `tokens` is the array of tokens generated by HTML5Tokenizer which
		* `i` is the index immediately after the opening tag to skip
		* `skippedTokens` is an array which skipped tokens are being pushed into
	
		Caveats
	
		* Assumes that i is the first token after the given opening tagName
		* The closing tag will be skipped, but nothing after it
		* Will track whether there is a nested tag of the same type
	*/
	function skipTagTokens(tagName, tokens, i, skippedTokens) {
	
		// number of tokens of this type on the [fictional] stack
		var stackCount = 1;
	
		while (i < tokens.length && stackCount > 0) {
			var token = tokens[i];
	
			if (token.type === StartTag && token.tagName.toUpperCase() === tagName) {
				// Nested tag of the same type, "add to stack"
				stackCount++;
			} else if (token.type === EndTag && token.tagName.toUpperCase() === tagName) {
				// Closing tag
				stackCount--;
			}
	
			skippedTokens.push(token);
			i++;
		}
	
		// Note that if stackCount > 0 here, the HTML is probably invalid
		return skippedTokens;
	}
	
	function escapeText(text) {
		// Not required, HTML tokenizer ensures this occurs properly
		return text;
	}
	
	function escapeAttr(attr) {
		return attr.replace(/"/g, '&quot;');
	}
	
	function attrsToStrings(attrs) {
		var attrStrs = [];
		for (var i = 0; i < attrs.length; i++) {
			var _attrs$i = attrs[i],
			    name = _attrs$i[0],
			    value = _attrs$i[1];
	
			attrStrs.push(name + '="' + escapeAttr(value) + '"');
		}
		return attrStrs;
	}

/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.tokenize = exports.test = exports.scanner = exports.parser = exports.options = exports.inherits = exports.find = undefined;
	
	var _class = __webpack_require__(162);
	
	var _options = __webpack_require__(757);
	
	var options = _interopRequireWildcard(_options);
	
	var _scanner = __webpack_require__(755);
	
	var scanner = _interopRequireWildcard(_scanner);
	
	var _parser = __webpack_require__(754);
	
	var parser = _interopRequireWildcard(_parser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	if (!Array.isArray) {
		Array.isArray = function (arg) {
			return Object.prototype.toString.call(arg) === '[object Array]';
		};
	}
	
	/**
		Converts a string into tokens that represent linkable and non-linkable bits
		@method tokenize
		@param {String} str
		@return {Array} tokens
	*/
	var tokenize = function tokenize(str) {
		return parser.run(scanner.run(str));
	};
	
	/**
		Returns a list of linkable items in the given string.
	*/
	var find = function find(str) {
		var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
		var tokens = tokenize(str);
		var filtered = [];
	
		for (var i = 0; i < tokens.length; i++) {
			var token = tokens[i];
			if (token.isLink && (!type || token.type === type)) {
				filtered.push(token.toObject());
			}
		}
	
		return filtered;
	};
	
	/**
		Is the given string valid linkable text of some sort
		Note that this does not trim the text for you.
	
		Optionally pass in a second `type` param, which is the type of link to test
		for.
	
		For example,
	
			test(str, 'email');
	
		Will return `true` if str is a valid email.
	*/
	var test = function test(str) {
		var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
		var tokens = tokenize(str);
		return tokens.length === 1 && tokens[0].isLink && (!type || tokens[0].type === type);
	};
	
	// Scanner and parser provide states and tokens for the lexicographic stage
	// (will be used to add additional link types)
	exports.find = find;
	exports.inherits = _class.inherits;
	exports.options = options;
	exports.parser = parser;
	exports.scanner = scanner;
	exports.test = test;
	exports.tokenize = tokenize;

/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.start = exports.run = exports.TOKENS = exports.State = undefined;
	
	var _state = __webpack_require__(340);
	
	var _multi = __webpack_require__(756);
	
	var MULTI_TOKENS = _interopRequireWildcard(_multi);
	
	var _text = __webpack_require__(225);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
		Not exactly parser, more like the second-stage scanner (although we can
		theoretically hotswap the code here with a real parser in the future... but
		for a little URL-finding utility abstract syntax trees may be a little
		overkill).
	
		URL format: http://en.wikipedia.org/wiki/URI_scheme
		Email format: http://en.wikipedia.org/wiki/Email_address (links to RFC in
		reference)
	
		@module linkify
		@submodule parser
		@main parser
	*/
	
	var makeState = function makeState(tokenClass) {
		return new _state.TokenState(tokenClass);
	};
	
	// The universal starting state.
	var S_START = makeState();
	
	// Intermediate states for URLs. Note that domains that begin with a protocol
	// are treated slighly differently from those that don't.
	var S_PROTOCOL = makeState(); // e.g., 'http:'
	var S_MAILTO = makeState(); // 'mailto:'
	var S_PROTOCOL_SLASH = makeState(); // e.g., '/', 'http:/''
	var S_PROTOCOL_SLASH_SLASH = makeState(); // e.g., '//', 'http://'
	var S_DOMAIN = makeState(); // parsed string ends with a potential domain name (A)
	var S_DOMAIN_DOT = makeState(); // (A) domain followed by DOT
	var S_TLD = makeState(_multi.URL); // (A) Simplest possible URL with no query string
	var S_TLD_COLON = makeState(); // (A) URL followed by colon (potential port number here)
	var S_TLD_PORT = makeState(_multi.URL); // TLD followed by a port number
	var S_URL = makeState(_multi.URL); // Long URL with optional port and maybe query string
	var S_URL_NON_ACCEPTING = makeState(); // URL followed by some symbols (will not be part of the final URL)
	var S_URL_OPENBRACE = makeState(); // URL followed by {
	var S_URL_OPENBRACKET = makeState(); // URL followed by [
	var S_URL_OPENANGLEBRACKET = makeState(); // URL followed by <
	var S_URL_OPENPAREN = makeState(); // URL followed by (
	var S_URL_OPENBRACE_Q = makeState(_multi.URL); // URL followed by { and some symbols that the URL can end it
	var S_URL_OPENBRACKET_Q = makeState(_multi.URL); // URL followed by [ and some symbols that the URL can end it
	var S_URL_OPENANGLEBRACKET_Q = makeState(_multi.URL); // URL followed by < and some symbols that the URL can end it
	var S_URL_OPENPAREN_Q = makeState(_multi.URL); // URL followed by ( and some symbols that the URL can end it
	var S_URL_OPENBRACE_SYMS = makeState(); // S_URL_OPENBRACE_Q followed by some symbols it cannot end it
	var S_URL_OPENBRACKET_SYMS = makeState(); // S_URL_OPENBRACKET_Q followed by some symbols it cannot end it
	var S_URL_OPENANGLEBRACKET_SYMS = makeState(); // S_URL_OPENANGLEBRACKET_Q followed by some symbols it cannot end it
	var S_URL_OPENPAREN_SYMS = makeState(); // S_URL_OPENPAREN_Q followed by some symbols it cannot end it
	var S_EMAIL_DOMAIN = makeState(); // parsed string starts with local email info + @ with a potential domain name (C)
	var S_EMAIL_DOMAIN_DOT = makeState(); // (C) domain followed by DOT
	var S_EMAIL = makeState(_multi.EMAIL); // (C) Possible email address (could have more tlds)
	var S_EMAIL_COLON = makeState(); // (C) URL followed by colon (potential port number here)
	var S_EMAIL_PORT = makeState(_multi.EMAIL); // (C) Email address with a port
	var S_MAILTO_EMAIL = makeState(_multi.MAILTOEMAIL); // Email that begins with the mailto prefix (D)
	var S_MAILTO_EMAIL_NON_ACCEPTING = makeState(); // (D) Followed by some non-query string chars
	var S_LOCALPART = makeState(); // Local part of the email address
	var S_LOCALPART_AT = makeState(); // Local part of the email address plus @
	var S_LOCALPART_DOT = makeState(); // Local part of the email address plus '.' (localpart cannot end in .)
	var S_NL = makeState(_multi.NL); // single new line
	
	// Make path from start to protocol (with '//')
	S_START.on(_text.NL, S_NL).on(_text.PROTOCOL, S_PROTOCOL).on(_text.MAILTO, S_MAILTO).on(_text.SLASH, S_PROTOCOL_SLASH);
	
	S_PROTOCOL.on(_text.SLASH, S_PROTOCOL_SLASH);
	S_PROTOCOL_SLASH.on(_text.SLASH, S_PROTOCOL_SLASH_SLASH);
	
	// The very first potential domain name
	S_START.on(_text.TLD, S_DOMAIN).on(_text.DOMAIN, S_DOMAIN).on(_text.LOCALHOST, S_TLD).on(_text.NUM, S_DOMAIN);
	
	// Force URL for protocol followed by anything sane
	S_PROTOCOL_SLASH_SLASH.on(_text.TLD, S_URL).on(_text.DOMAIN, S_URL).on(_text.NUM, S_URL).on(_text.LOCALHOST, S_URL);
	
	// Account for dots and hyphens
	// hyphens are usually parts of domain names
	S_DOMAIN.on(_text.DOT, S_DOMAIN_DOT);
	S_EMAIL_DOMAIN.on(_text.DOT, S_EMAIL_DOMAIN_DOT);
	
	// Hyphen can jump back to a domain name
	
	// After the first domain and a dot, we can find either a URL or another domain
	S_DOMAIN_DOT.on(_text.TLD, S_TLD).on(_text.DOMAIN, S_DOMAIN).on(_text.NUM, S_DOMAIN).on(_text.LOCALHOST, S_DOMAIN);
	
	S_EMAIL_DOMAIN_DOT.on(_text.TLD, S_EMAIL).on(_text.DOMAIN, S_EMAIL_DOMAIN).on(_text.NUM, S_EMAIL_DOMAIN).on(_text.LOCALHOST, S_EMAIL_DOMAIN);
	
	// S_TLD accepts! But the URL could be longer, try to find a match greedily
	// The `run` function should be able to "rollback" to the accepting state
	S_TLD.on(_text.DOT, S_DOMAIN_DOT);
	S_EMAIL.on(_text.DOT, S_EMAIL_DOMAIN_DOT);
	
	// Become real URLs after `SLASH` or `COLON NUM SLASH`
	// Here PSS and non-PSS converge
	S_TLD.on(_text.COLON, S_TLD_COLON).on(_text.SLASH, S_URL);
	S_TLD_COLON.on(_text.NUM, S_TLD_PORT);
	S_TLD_PORT.on(_text.SLASH, S_URL);
	S_EMAIL.on(_text.COLON, S_EMAIL_COLON);
	S_EMAIL_COLON.on(_text.NUM, S_EMAIL_PORT);
	
	// Types of characters the URL can definitely end in
	var qsAccepting = [_text.DOMAIN, _text.AT, _text.LOCALHOST, _text.NUM, _text.PLUS, _text.POUND, _text.PROTOCOL, _text.SLASH, _text.TLD, _text.UNDERSCORE, _text.SYM, _text.AMPERSAND];
	
	// Types of tokens that can follow a URL and be part of the query string
	// but cannot be the very last characters
	// Characters that cannot appear in the URL at all should be excluded
	var qsNonAccepting = [_text.COLON, _text.DOT, _text.QUERY, _text.PUNCTUATION, _text.CLOSEBRACE, _text.CLOSEBRACKET, _text.CLOSEANGLEBRACKET, _text.CLOSEPAREN, _text.OPENBRACE, _text.OPENBRACKET, _text.OPENANGLEBRACKET, _text.OPENPAREN];
	
	// These states are responsible primarily for determining whether or not to
	// include the final round bracket.
	
	// URL, followed by an opening bracket
	S_URL.on(_text.OPENBRACE, S_URL_OPENBRACE).on(_text.OPENBRACKET, S_URL_OPENBRACKET).on(_text.OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET).on(_text.OPENPAREN, S_URL_OPENPAREN);
	
	// URL with extra symbols at the end, followed by an opening bracket
	S_URL_NON_ACCEPTING.on(_text.OPENBRACE, S_URL_OPENBRACE).on(_text.OPENBRACKET, S_URL_OPENBRACKET).on(_text.OPENANGLEBRACKET, S_URL_OPENANGLEBRACKET).on(_text.OPENPAREN, S_URL_OPENPAREN);
	
	// Closing bracket component. This character WILL be included in the URL
	S_URL_OPENBRACE.on(_text.CLOSEBRACE, S_URL);
	S_URL_OPENBRACKET.on(_text.CLOSEBRACKET, S_URL);
	S_URL_OPENANGLEBRACKET.on(_text.CLOSEANGLEBRACKET, S_URL);
	S_URL_OPENPAREN.on(_text.CLOSEPAREN, S_URL);
	S_URL_OPENBRACE_Q.on(_text.CLOSEBRACE, S_URL);
	S_URL_OPENBRACKET_Q.on(_text.CLOSEBRACKET, S_URL);
	S_URL_OPENANGLEBRACKET_Q.on(_text.CLOSEANGLEBRACKET, S_URL);
	S_URL_OPENPAREN_Q.on(_text.CLOSEPAREN, S_URL);
	S_URL_OPENBRACE_SYMS.on(_text.CLOSEBRACE, S_URL);
	S_URL_OPENBRACKET_SYMS.on(_text.CLOSEBRACKET, S_URL);
	S_URL_OPENANGLEBRACKET_SYMS.on(_text.CLOSEANGLEBRACKET, S_URL);
	S_URL_OPENPAREN_SYMS.on(_text.CLOSEPAREN, S_URL);
	
	// URL that beings with an opening bracket, followed by a symbols.
	// Note that the final state can still be `S_URL_OPENBRACE_Q` (if the URL only
	// has a single opening bracket for some reason).
	S_URL_OPENBRACE.on(qsAccepting, S_URL_OPENBRACE_Q);
	S_URL_OPENBRACKET.on(qsAccepting, S_URL_OPENBRACKET_Q);
	S_URL_OPENANGLEBRACKET.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
	S_URL_OPENPAREN.on(qsAccepting, S_URL_OPENPAREN_Q);
	S_URL_OPENBRACE.on(qsNonAccepting, S_URL_OPENBRACE_SYMS);
	S_URL_OPENBRACKET.on(qsNonAccepting, S_URL_OPENBRACKET_SYMS);
	S_URL_OPENANGLEBRACKET.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
	S_URL_OPENPAREN.on(qsNonAccepting, S_URL_OPENPAREN_SYMS);
	
	// URL that begins with an opening bracket, followed by some symbols
	S_URL_OPENBRACE_Q.on(qsAccepting, S_URL_OPENBRACE_Q);
	S_URL_OPENBRACKET_Q.on(qsAccepting, S_URL_OPENBRACKET_Q);
	S_URL_OPENANGLEBRACKET_Q.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
	S_URL_OPENPAREN_Q.on(qsAccepting, S_URL_OPENPAREN_Q);
	S_URL_OPENBRACE_Q.on(qsNonAccepting, S_URL_OPENBRACE_Q);
	S_URL_OPENBRACKET_Q.on(qsNonAccepting, S_URL_OPENBRACKET_Q);
	S_URL_OPENANGLEBRACKET_Q.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_Q);
	S_URL_OPENPAREN_Q.on(qsNonAccepting, S_URL_OPENPAREN_Q);
	
	S_URL_OPENBRACE_SYMS.on(qsAccepting, S_URL_OPENBRACE_Q);
	S_URL_OPENBRACKET_SYMS.on(qsAccepting, S_URL_OPENBRACKET_Q);
	S_URL_OPENANGLEBRACKET_SYMS.on(qsAccepting, S_URL_OPENANGLEBRACKET_Q);
	S_URL_OPENPAREN_SYMS.on(qsAccepting, S_URL_OPENPAREN_Q);
	S_URL_OPENBRACE_SYMS.on(qsNonAccepting, S_URL_OPENBRACE_SYMS);
	S_URL_OPENBRACKET_SYMS.on(qsNonAccepting, S_URL_OPENBRACKET_SYMS);
	S_URL_OPENANGLEBRACKET_SYMS.on(qsNonAccepting, S_URL_OPENANGLEBRACKET_SYMS);
	S_URL_OPENPAREN_SYMS.on(qsNonAccepting, S_URL_OPENPAREN_SYMS);
	
	// Account for the query string
	S_URL.on(qsAccepting, S_URL);
	S_URL_NON_ACCEPTING.on(qsAccepting, S_URL);
	
	S_URL.on(qsNonAccepting, S_URL_NON_ACCEPTING);
	S_URL_NON_ACCEPTING.on(qsNonAccepting, S_URL_NON_ACCEPTING);
	
	// Email address-specific state definitions
	// Note: We are not allowing '/' in email addresses since this would interfere
	// with real URLs
	
	// For addresses with the mailto prefix
	// 'mailto:' followed by anything sane is a valid email
	S_MAILTO.on(_text.TLD, S_MAILTO_EMAIL).on(_text.DOMAIN, S_MAILTO_EMAIL).on(_text.NUM, S_MAILTO_EMAIL).on(_text.LOCALHOST, S_MAILTO_EMAIL);
	
	// Greedily get more potential valid email values
	S_MAILTO_EMAIL.on(qsAccepting, S_MAILTO_EMAIL).on(qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);
	S_MAILTO_EMAIL_NON_ACCEPTING.on(qsAccepting, S_MAILTO_EMAIL).on(qsNonAccepting, S_MAILTO_EMAIL_NON_ACCEPTING);
	
	// For addresses without the mailto prefix
	// Tokens allowed in the localpart of the email
	var localpartAccepting = [_text.DOMAIN, _text.NUM, _text.PLUS, _text.POUND, _text.QUERY, _text.UNDERSCORE, _text.SYM, _text.AMPERSAND, _text.TLD];
	
	// Some of the tokens in `localpartAccepting` are already accounted for here and
	// will not be overwritten (don't worry)
	S_DOMAIN.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT);
	S_TLD.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT);
	S_DOMAIN_DOT.on(localpartAccepting, S_LOCALPART);
	
	// Okay we're on a localpart. Now what?
	// TODO: IP addresses and what if the email starts with numbers?
	S_LOCALPART.on(localpartAccepting, S_LOCALPART).on(_text.AT, S_LOCALPART_AT) // close to an email address now
	.on(_text.DOT, S_LOCALPART_DOT);
	S_LOCALPART_DOT.on(localpartAccepting, S_LOCALPART);
	S_LOCALPART_AT.on(_text.TLD, S_EMAIL_DOMAIN).on(_text.DOMAIN, S_EMAIL_DOMAIN).on(_text.LOCALHOST, S_EMAIL);
	// States following `@` defined above
	
	var run = function run(tokens) {
		var len = tokens.length;
		var cursor = 0;
		var multis = [];
		var textTokens = [];
	
		while (cursor < len) {
			var state = S_START;
			var secondState = null;
			var nextState = null;
			var multiLength = 0;
			var latestAccepting = null;
			var sinceAccepts = -1;
	
			while (cursor < len && !(secondState = state.next(tokens[cursor]))) {
				// Starting tokens with nowhere to jump to.
				// Consider these to be just plain text
				textTokens.push(tokens[cursor++]);
			}
	
			while (cursor < len && (nextState = secondState || state.next(tokens[cursor]))) {
	
				// Get the next state
				secondState = null;
				state = nextState;
	
				// Keep track of the latest accepting state
				if (state.accepts()) {
					sinceAccepts = 0;
					latestAccepting = state;
				} else if (sinceAccepts >= 0) {
					sinceAccepts++;
				}
	
				cursor++;
				multiLength++;
			}
	
			if (sinceAccepts < 0) {
	
				// No accepting state was found, part of a regular text token
				// Add all the tokens we looked at to the text tokens array
				for (var i = cursor - multiLength; i < cursor; i++) {
					textTokens.push(tokens[i]);
				}
			} else {
	
				// Accepting state!
	
				// First close off the textTokens (if available)
				if (textTokens.length > 0) {
					multis.push(new _multi.TEXT(textTokens));
					textTokens = [];
				}
	
				// Roll back to the latest accepting state
				cursor -= sinceAccepts;
				multiLength -= sinceAccepts;
	
				// Create a new multitoken
				var MULTI = latestAccepting.emit();
				multis.push(new MULTI(tokens.slice(cursor - multiLength, cursor)));
			}
		}
	
		// Finally close off the textTokens (if available)
		if (textTokens.length > 0) {
			multis.push(new _multi.TEXT(textTokens));
		}
	
		return multis;
	};
	
	exports.State = _state.TokenState;
	exports.TOKENS = MULTI_TOKENS;
	exports.run = run;
	exports.start = S_START;

/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.start = exports.run = exports.TOKENS = exports.State = undefined;
	
	var _state = __webpack_require__(340);
	
	var _text = __webpack_require__(225);
	
	var TOKENS = _interopRequireWildcard(_text);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var tlds = 'aaa|aarp|abarth|abb|abbott|abbvie|abc|able|abogado|abudhabi|ac|academy|accenture|accountant|accountants|aco|active|actor|ad|adac|ads|adult|ae|aeg|aero|aetna|af|afamilycompany|afl|africa|ag|agakhan|agency|ai|aig|aigo|airbus|airforce|airtel|akdn|al|alfaromeo|alibaba|alipay|allfinanz|allstate|ally|alsace|alstom|am|americanexpress|americanfamily|amex|amfam|amica|amsterdam|analytics|android|anquan|anz|ao|aol|apartments|app|apple|aq|aquarelle|ar|arab|aramco|archi|army|arpa|art|arte|as|asda|asia|associates|at|athleta|attorney|au|auction|audi|audible|audio|auspost|author|auto|autos|avianca|aw|aws|ax|axa|az|azure|ba|baby|baidu|banamex|bananarepublic|band|bank|bar|barcelona|barclaycard|barclays|barefoot|bargains|baseball|basketball|bauhaus|bayern|bb|bbc|bbt|bbva|bcg|bcn|bd|be|beats|beauty|beer|bentley|berlin|best|bestbuy|bet|bf|bg|bh|bharti|bi|bible|bid|bike|bing|bingo|bio|biz|bj|black|blackfriday|blanco|blockbuster|blog|bloomberg|blue|bm|bms|bmw|bn|bnl|bnpparibas|bo|boats|boehringer|bofa|bom|bond|boo|book|booking|boots|bosch|bostik|boston|bot|boutique|box|br|bradesco|bridgestone|broadway|broker|brother|brussels|bs|bt|budapest|bugatti|build|builders|business|buy|buzz|bv|bw|by|bz|bzh|ca|cab|cafe|cal|call|calvinklein|cam|camera|camp|cancerresearch|canon|capetown|capital|capitalone|car|caravan|cards|care|career|careers|cars|cartier|casa|case|caseih|cash|casino|cat|catering|catholic|cba|cbn|cbre|cbs|cc|cd|ceb|center|ceo|cern|cf|cfa|cfd|cg|ch|chanel|channel|chase|chat|cheap|chintai|chloe|christmas|chrome|chrysler|church|ci|cipriani|circle|cisco|citadel|citi|citic|city|cityeats|ck|cl|claims|cleaning|click|clinic|clinique|clothing|cloud|club|clubmed|cm|cn|co|coach|codes|coffee|college|cologne|com|comcast|commbank|community|company|compare|computer|comsec|condos|construction|consulting|contact|contractors|cooking|cookingchannel|cool|coop|corsica|country|coupon|coupons|courses|cr|credit|creditcard|creditunion|cricket|crown|crs|cruise|cruises|csc|cu|cuisinella|cv|cw|cx|cy|cymru|cyou|cz|dabur|dad|dance|data|date|dating|datsun|day|dclk|dds|de|deal|dealer|deals|degree|delivery|dell|deloitte|delta|democrat|dental|dentist|desi|design|dev|dhl|diamonds|diet|digital|direct|directory|discount|discover|dish|diy|dj|dk|dm|dnp|do|docs|doctor|dodge|dog|doha|domains|dot|download|drive|dtv|dubai|duck|dunlop|duns|dupont|durban|dvag|dvr|dz|earth|eat|ec|eco|edeka|edu|education|ee|eg|email|emerck|energy|engineer|engineering|enterprises|epost|epson|equipment|er|ericsson|erni|es|esq|estate|esurance|et|etisalat|eu|eurovision|eus|events|everbank|exchange|expert|exposed|express|extraspace|fage|fail|fairwinds|faith|family|fan|fans|farm|farmers|fashion|fast|fedex|feedback|ferrari|ferrero|fi|fiat|fidelity|fido|film|final|finance|financial|fire|firestone|firmdale|fish|fishing|fit|fitness|fj|fk|flickr|flights|flir|florist|flowers|fly|fm|fo|foo|food|foodnetwork|football|ford|forex|forsale|forum|foundation|fox|fr|free|fresenius|frl|frogans|frontdoor|frontier|ftr|fujitsu|fujixerox|fun|fund|furniture|futbol|fyi|ga|gal|gallery|gallo|gallup|game|games|gap|garden|gb|gbiz|gd|gdn|ge|gea|gent|genting|george|gf|gg|ggee|gh|gi|gift|gifts|gives|giving|gl|glade|glass|gle|global|globo|gm|gmail|gmbh|gmo|gmx|gn|godaddy|gold|goldpoint|golf|goo|goodhands|goodyear|goog|google|gop|got|gov|gp|gq|gr|grainger|graphics|gratis|green|gripe|grocery|group|gs|gt|gu|guardian|gucci|guge|guide|guitars|guru|gw|gy|hair|hamburg|hangout|haus|hbo|hdfc|hdfcbank|health|healthcare|help|helsinki|here|hermes|hgtv|hiphop|hisamitsu|hitachi|hiv|hk|hkt|hm|hn|hockey|holdings|holiday|homedepot|homegoods|homes|homesense|honda|honeywell|horse|hospital|host|hosting|hot|hoteles|hotels|hotmail|house|how|hr|hsbc|ht|htc|hu|hughes|hyatt|hyundai|ibm|icbc|ice|icu|id|ie|ieee|ifm|ikano|il|im|imamat|imdb|immo|immobilien|in|industries|infiniti|info|ing|ink|institute|insurance|insure|int|intel|international|intuit|investments|io|ipiranga|iq|ir|irish|is|iselect|ismaili|ist|istanbul|it|itau|itv|iveco|iwc|jaguar|java|jcb|jcp|je|jeep|jetzt|jewelry|jio|jlc|jll|jm|jmp|jnj|jo|jobs|joburg|jot|joy|jp|jpmorgan|jprs|juegos|juniper|kaufen|kddi|ke|kerryhotels|kerrylogistics|kerryproperties|kfh|kg|kh|ki|kia|kim|kinder|kindle|kitchen|kiwi|km|kn|koeln|komatsu|kosher|kp|kpmg|kpn|kr|krd|kred|kuokgroup|kw|ky|kyoto|kz|la|lacaixa|ladbrokes|lamborghini|lamer|lancaster|lancia|lancome|land|landrover|lanxess|lasalle|lat|latino|latrobe|law|lawyer|lb|lc|lds|lease|leclerc|lefrak|legal|lego|lexus|lgbt|li|liaison|lidl|life|lifeinsurance|lifestyle|lighting|like|lilly|limited|limo|lincoln|linde|link|lipsy|live|living|lixil|lk|loan|loans|locker|locus|loft|lol|london|lotte|lotto|love|lpl|lplfinancial|lr|ls|lt|ltd|ltda|lu|lundbeck|lupin|luxe|luxury|lv|ly|ma|macys|madrid|maif|maison|makeup|man|management|mango|map|market|marketing|markets|marriott|marshalls|maserati|mattel|mba|mc|mckinsey|md|me|med|media|meet|melbourne|meme|memorial|men|menu|meo|merckmsd|metlife|mg|mh|miami|microsoft|mil|mini|mint|mit|mitsubishi|mk|ml|mlb|mls|mm|mma|mn|mo|mobi|mobile|mobily|moda|moe|moi|mom|monash|money|monster|mopar|mormon|mortgage|moscow|moto|motorcycles|mov|movie|movistar|mp|mq|mr|ms|msd|mt|mtn|mtr|mu|museum|mutual|mv|mw|mx|my|mz|na|nab|nadex|nagoya|name|nationwide|natura|navy|nba|nc|ne|nec|net|netbank|netflix|network|neustar|new|newholland|news|next|nextdirect|nexus|nf|nfl|ng|ngo|nhk|ni|nico|nike|nikon|ninja|nissan|nissay|nl|no|nokia|northwesternmutual|norton|now|nowruz|nowtv|np|nr|nra|nrw|ntt|nu|nyc|nz|obi|observer|off|office|okinawa|olayan|olayangroup|oldnavy|ollo|om|omega|one|ong|onl|online|onyourside|ooo|open|oracle|orange|org|organic|origins|osaka|otsuka|ott|ovh|pa|page|panasonic|panerai|paris|pars|partners|parts|party|passagens|pay|pccw|pe|pet|pf|pfizer|pg|ph|pharmacy|phd|philips|phone|photo|photography|photos|physio|piaget|pics|pictet|pictures|pid|pin|ping|pink|pioneer|pizza|pk|pl|place|play|playstation|plumbing|plus|pm|pn|pnc|pohl|poker|politie|porn|post|pr|pramerica|praxi|press|prime|pro|prod|productions|prof|progressive|promo|properties|property|protection|pru|prudential|ps|pt|pub|pw|pwc|py|qa|qpon|quebec|quest|qvc|racing|radio|raid|re|read|realestate|realtor|realty|recipes|red|redstone|redumbrella|rehab|reise|reisen|reit|reliance|ren|rent|rentals|repair|report|republican|rest|restaurant|review|reviews|rexroth|rich|richardli|ricoh|rightathome|ril|rio|rip|rmit|ro|rocher|rocks|rodeo|rogers|room|rs|rsvp|ru|rugby|ruhr|run|rw|rwe|ryukyu|sa|saarland|safe|safety|sakura|sale|salon|samsclub|samsung|sandvik|sandvikcoromant|sanofi|sap|sapo|sarl|sas|save|saxo|sb|sbi|sbs|sc|sca|scb|schaeffler|schmidt|scholarships|school|schule|schwarz|science|scjohnson|scor|scot|sd|se|search|seat|secure|security|seek|select|sener|services|ses|seven|sew|sex|sexy|sfr|sg|sh|shangrila|sharp|shaw|shell|shia|shiksha|shoes|shop|shopping|shouji|show|showtime|shriram|si|silk|sina|singles|site|sj|sk|ski|skin|sky|skype|sl|sling|sm|smart|smile|sn|sncf|so|soccer|social|softbank|software|sohu|solar|solutions|song|sony|soy|space|spiegel|spot|spreadbetting|sr|srl|srt|st|stada|staples|star|starhub|statebank|statefarm|statoil|stc|stcgroup|stockholm|storage|store|stream|studio|study|style|su|sucks|supplies|supply|support|surf|surgery|suzuki|sv|swatch|swiftcover|swiss|sx|sy|sydney|symantec|systems|sz|tab|taipei|talk|taobao|target|tatamotors|tatar|tattoo|tax|taxi|tc|tci|td|tdk|team|tech|technology|tel|telecity|telefonica|temasek|tennis|teva|tf|tg|th|thd|theater|theatre|tiaa|tickets|tienda|tiffany|tips|tires|tirol|tj|tjmaxx|tjx|tk|tkmaxx|tl|tm|tmall|tn|to|today|tokyo|tools|top|toray|toshiba|total|tours|town|toyota|toys|tr|trade|trading|training|travel|travelchannel|travelers|travelersinsurance|trust|trv|tt|tube|tui|tunes|tushu|tv|tvs|tw|tz|ua|ubank|ubs|uconnect|ug|uk|unicom|university|uno|uol|ups|us|uy|uz|va|vacations|vana|vanguard|vc|ve|vegas|ventures|verisign|versicherung|vet|vg|vi|viajes|video|vig|viking|villas|vin|vip|virgin|visa|vision|vista|vistaprint|viva|vivo|vlaanderen|vn|vodka|volkswagen|volvo|vote|voting|voto|voyage|vu|vuelos|wales|walmart|walter|wang|wanggou|warman|watch|watches|weather|weatherchannel|webcam|weber|website|wed|wedding|weibo|weir|wf|whoswho|wien|wiki|williamhill|win|windows|wine|winners|wme|wolterskluwer|woodside|work|works|world|wow|ws|wtc|wtf|xbox|xerox|xfinity|xihuan|xin|xn--11b4c3d|xn--1ck2e1b|xn--1qqw23a|xn--2scrj9c|xn--30rr7y|xn--3bst00m|xn--3ds443g|xn--3e0b707e|xn--3hcrj9c|xn--3oq18vl8pn36a|xn--3pxu8k|xn--42c2d9a|xn--45br5cyl|xn--45brj9c|xn--45q11c|xn--4gbrim|xn--54b7fta0cc|xn--55qw42g|xn--55qx5d|xn--5su34j936bgsg|xn--5tzm5g|xn--6frz82g|xn--6qq986b3xl|xn--80adxhks|xn--80ao21a|xn--80aqecdr1a|xn--80asehdb|xn--80aswg|xn--8y0a063a|xn--90a3ac|xn--90ae|xn--90ais|xn--9dbq2a|xn--9et52u|xn--9krt00a|xn--b4w605ferd|xn--bck1b9a5dre4c|xn--c1avg|xn--c2br7g|xn--cck2b3b|xn--cg4bki|xn--clchc0ea0b2g2a9gcd|xn--czr694b|xn--czrs0t|xn--czru2d|xn--d1acj3b|xn--d1alf|xn--e1a4c|xn--eckvdtc9d|xn--efvy88h|xn--estv75g|xn--fct429k|xn--fhbei|xn--fiq228c5hs|xn--fiq64b|xn--fiqs8s|xn--fiqz9s|xn--fjq720a|xn--flw351e|xn--fpcrj9c3d|xn--fzc2c9e2c|xn--fzys8d69uvgm|xn--g2xx48c|xn--gckr3f0f|xn--gecrj9c|xn--gk3at1e|xn--h2breg3eve|xn--h2brj9c|xn--h2brj9c8c|xn--hxt814e|xn--i1b6b1a6a2e|xn--imr513n|xn--io0a7i|xn--j1aef|xn--j1amh|xn--j6w193g|xn--jlq61u9w7b|xn--jvr189m|xn--kcrx77d1x4a|xn--kprw13d|xn--kpry57d|xn--kpu716f|xn--kput3i|xn--l1acc|xn--lgbbat1ad8j|xn--mgb9awbf|xn--mgba3a3ejt|xn--mgba3a4f16a|xn--mgba7c0bbn0a|xn--mgbaakc7dvf|xn--mgbaam7a8h|xn--mgbab2bd|xn--mgbai9azgqp6j|xn--mgbayh7gpa|xn--mgbb9fbpob|xn--mgbbh1a|xn--mgbbh1a71e|xn--mgbc0a9azcg|xn--mgbca7dzdo|xn--mgberp4a5d4ar|xn--mgbgu82a|xn--mgbi4ecexp|xn--mgbpl2fh|xn--mgbt3dhd|xn--mgbtx2b|xn--mgbx4cd0ab|xn--mix891f|xn--mk1bu44c|xn--mxtq1m|xn--ngbc5azd|xn--ngbe9e0a|xn--ngbrx|xn--node|xn--nqv7f|xn--nqv7fs00ema|xn--nyqy26a|xn--o3cw4h|xn--ogbpf8fl|xn--p1acf|xn--p1ai|xn--pbt977c|xn--pgbs0dh|xn--pssy2u|xn--q9jyb4c|xn--qcka1pmc|xn--qxam|xn--rhqv96g|xn--rovu88b|xn--rvc1e0am3e|xn--s9brj9c|xn--ses554g|xn--t60b56a|xn--tckwe|xn--tiq49xqyj|xn--unup4y|xn--vermgensberater-ctb|xn--vermgensberatung-pwb|xn--vhquv|xn--vuq861b|xn--w4r85el8fhu5dnra|xn--w4rs40l|xn--wgbh1c|xn--wgbl6a|xn--xhq521b|xn--xkc2al3hye2a|xn--xkc2dl3a5ee0h|xn--y9a3aq|xn--yfro4i67o|xn--ygbi2ammx|xn--zfr164b|xperia|xxx|xyz|yachts|yahoo|yamaxun|yandex|ye|yodobashi|yoga|yokohama|you|youtube|yt|yun|za|zappos|zara|zero|zip|zippo|zm|zone|zuerich|zw'.split('|'); // macro, see gulpfile.js
	
	/**
		The scanner provides an interface that takes a string of text as input, and
		outputs an array of tokens instances that can be used for easy URL parsing.
	
		@module linkify
		@submodule scanner
		@main scanner
	*/
	
	var NUMBERS = '0123456789'.split('');
	var ALPHANUM = '0123456789abcdefghijklmnopqrstuvwxyz'.split('');
	var WHITESPACE = [' ', '\f', '\r', '\t', '\v', '\xA0', '\u1680', '\u180E']; // excluding line breaks
	
	var domainStates = []; // states that jump to DOMAIN on /[a-z0-9]/
	var makeState = function makeState(tokenClass) {
		return new _state.CharacterState(tokenClass);
	};
	
	// Frequently used states
	var S_START = makeState();
	var S_NUM = makeState(_text.NUM);
	var S_DOMAIN = makeState(_text.DOMAIN);
	var S_DOMAIN_HYPHEN = makeState(); // domain followed by 1 or more hyphen characters
	var S_WS = makeState(_text.WS);
	
	// States for special URL symbols
	S_START.on('@', makeState(_text.AT)).on('.', makeState(_text.DOT)).on('+', makeState(_text.PLUS)).on('#', makeState(_text.POUND)).on('?', makeState(_text.QUERY)).on('/', makeState(_text.SLASH)).on('_', makeState(_text.UNDERSCORE)).on(':', makeState(_text.COLON)).on('{', makeState(_text.OPENBRACE)).on('[', makeState(_text.OPENBRACKET)).on('<', makeState(_text.OPENANGLEBRACKET)).on('(', makeState(_text.OPENPAREN)).on('}', makeState(_text.CLOSEBRACE)).on(']', makeState(_text.CLOSEBRACKET)).on('>', makeState(_text.CLOSEANGLEBRACKET)).on(')', makeState(_text.CLOSEPAREN)).on('&', makeState(_text.AMPERSAND)).on([',', ';', '!', '"', '\''], makeState(_text.PUNCTUATION));
	
	// Whitespace jumps
	// Tokens of only non-newline whitespace are arbitrarily long
	S_START.on('\n', makeState(_text.NL)).on(WHITESPACE, S_WS);
	
	// If any whitespace except newline, more whitespace!
	S_WS.on(WHITESPACE, S_WS);
	
	// Generates states for top-level domains
	// Note that this is most accurate when tlds are in alphabetical order
	for (var i = 0; i < tlds.length; i++) {
		var newStates = (0, _state.stateify)(tlds[i], S_START, _text.TLD, _text.DOMAIN);
		domainStates.push.apply(domainStates, newStates);
	}
	
	// Collect the states generated by different protocls
	var partialProtocolFileStates = (0, _state.stateify)('file', S_START, _text.DOMAIN, _text.DOMAIN);
	var partialProtocolFtpStates = (0, _state.stateify)('ftp', S_START, _text.DOMAIN, _text.DOMAIN);
	var partialProtocolHttpStates = (0, _state.stateify)('http', S_START, _text.DOMAIN, _text.DOMAIN);
	var partialProtocolMailtoStates = (0, _state.stateify)('mailto', S_START, _text.DOMAIN, _text.DOMAIN);
	
	// Add the states to the array of DOMAINeric states
	domainStates.push.apply(domainStates, partialProtocolFileStates);
	domainStates.push.apply(domainStates, partialProtocolFtpStates);
	domainStates.push.apply(domainStates, partialProtocolHttpStates);
	domainStates.push.apply(domainStates, partialProtocolMailtoStates);
	
	// Protocol states
	var S_PROTOCOL_FILE = partialProtocolFileStates.pop();
	var S_PROTOCOL_FTP = partialProtocolFtpStates.pop();
	var S_PROTOCOL_HTTP = partialProtocolHttpStates.pop();
	var S_MAILTO = partialProtocolMailtoStates.pop();
	var S_PROTOCOL_SECURE = makeState(_text.DOMAIN);
	var S_FULL_PROTOCOL = makeState(_text.PROTOCOL); // Full protocol ends with COLON
	var S_FULL_MAILTO = makeState(_text.MAILTO); // Mailto ends with COLON
	
	// Secure protocols (end with 's')
	S_PROTOCOL_FTP.on('s', S_PROTOCOL_SECURE).on(':', S_FULL_PROTOCOL);
	
	S_PROTOCOL_HTTP.on('s', S_PROTOCOL_SECURE).on(':', S_FULL_PROTOCOL);
	
	domainStates.push(S_PROTOCOL_SECURE);
	
	// Become protocol tokens after a COLON
	S_PROTOCOL_FILE.on(':', S_FULL_PROTOCOL);
	S_PROTOCOL_SECURE.on(':', S_FULL_PROTOCOL);
	S_MAILTO.on(':', S_FULL_MAILTO);
	
	// Localhost
	var partialLocalhostStates = (0, _state.stateify)('localhost', S_START, _text.LOCALHOST, _text.DOMAIN);
	domainStates.push.apply(domainStates, partialLocalhostStates);
	
	// Everything else
	// DOMAINs make more DOMAINs
	// Number and character transitions
	S_START.on(NUMBERS, S_NUM);
	S_NUM.on('-', S_DOMAIN_HYPHEN).on(NUMBERS, S_NUM).on(ALPHANUM, S_DOMAIN); // number becomes DOMAIN
	
	S_DOMAIN.on('-', S_DOMAIN_HYPHEN).on(ALPHANUM, S_DOMAIN);
	
	// All the generated states should have a jump to DOMAIN
	for (var _i = 0; _i < domainStates.length; _i++) {
		domainStates[_i].on('-', S_DOMAIN_HYPHEN).on(ALPHANUM, S_DOMAIN);
	}
	
	S_DOMAIN_HYPHEN.on('-', S_DOMAIN_HYPHEN).on(NUMBERS, S_DOMAIN).on(ALPHANUM, S_DOMAIN);
	
	// Set default transition
	S_START.defaultTransition = makeState(_text.SYM);
	
	/**
		Given a string, returns an array of TOKEN instances representing the
		composition of that string.
	
		@method run
		@param {String} str Input string to scan
		@return {Array} Array of TOKEN instances
	*/
	var run = function run(str) {
	
		// The state machine only looks at lowercase strings.
		// This selective `toLowerCase` is used because lowercasing the entire
		// string causes the length and character position to vary in some in some
		// non-English strings. This happens only on V8-based runtimes.
		var lowerStr = str.replace(/[A-Z]/g, function (c) {
			return c.toLowerCase();
		});
		var len = str.length;
		var tokens = []; // return value
	
		var cursor = 0;
	
		// Tokenize the string
		while (cursor < len) {
			var state = S_START;
			var nextState = null;
			var tokenLength = 0;
			var latestAccepting = null;
			var sinceAccepts = -1;
	
			while (cursor < len && (nextState = state.next(lowerStr[cursor]))) {
				state = nextState;
	
				// Keep track of the latest accepting state
				if (state.accepts()) {
					sinceAccepts = 0;
					latestAccepting = state;
				} else if (sinceAccepts >= 0) {
					sinceAccepts++;
				}
	
				tokenLength++;
				cursor++;
			}
	
			if (sinceAccepts < 0) {
				continue;
			} // Should never happen
	
			// Roll back to the latest accepting state
			cursor -= sinceAccepts;
			tokenLength -= sinceAccepts;
	
			// Get the class for the new token
			var TOKEN = latestAccepting.emit(); // Current token class
	
			// No more jumps, just make a new token
			tokens.push(new TOKEN(str.substr(cursor - tokenLength, tokenLength)));
		}
	
		return tokens;
	};
	
	var start = S_START;
	exports.State = _state.CharacterState;
	exports.TOKENS = TOKENS;
	exports.run = run;
	exports.start = start;

/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.URL = exports.TEXT = exports.NL = exports.EMAIL = exports.MAILTOEMAIL = exports.Base = undefined;
	
	var _createTokenClass = __webpack_require__(341);
	
	var _class = __webpack_require__(162);
	
	var _text = __webpack_require__(225);
	
	/******************************************************************************
		Multi-Tokens
		Tokens composed of arrays of TextTokens
	******************************************************************************/
	
	// Is the given token a valid domain token?
	// Should nums be included here?
	function isDomainToken(token) {
		return token instanceof _text.DOMAIN || token instanceof _text.TLD;
	}
	
	/**
		Abstract class used for manufacturing tokens of text tokens. That is rather
		than the value for a token being a small string of text, it's value an array
		of text tokens.
	
		Used for grouping together URLs, emails, hashtags, and other potential
		creations.
	
		@class MultiToken
		@abstract
	*/
	var MultiToken = (0, _createTokenClass.createTokenClass)();
	
	MultiToken.prototype = {
		/**
	 	String representing the type for this token
	 	@property type
	 	@default 'TOKEN'
	 */
		type: 'token',
	
		/**
	 	Is this multitoken a link?
	 	@property isLink
	 	@default false
	 */
		isLink: false,
	
		/**
	 	Return the string this token represents.
	 	@method toString
	 	@return {String}
	 */
		toString: function toString() {
			var result = [];
			for (var i = 0; i < this.v.length; i++) {
				result.push(this.v[i].toString());
			}
			return result.join('');
		},
	
	
		/**
	 	What should the value for this token be in the `href` HTML attribute?
	 	Returns the `.toString` value by default.
	 		@method toHref
	 	@return {String}
	 */
		toHref: function toHref() {
			return this.toString();
		},
	
	
		/**
	 	Returns a hash of relevant values for this token, which includes keys
	 	* type - Kind of token ('url', 'email', etc.)
	 	* value - Original text
	 	* href - The value that should be added to the anchor tag's href
	 		attribute
	 		@method toObject
	 	@param {String} [protocol] `'http'` by default
	 	@return {Object}
	 */
		toObject: function toObject() {
			var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http';
	
			return {
				type: this.type,
				value: this.toString(),
				href: this.toHref(protocol)
			};
		}
	};
	
	/**
		Represents an arbitrarily mailto email address with the prefix included
		@class MAILTO
		@extends MultiToken
	*/
	var MAILTOEMAIL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
		type: 'email',
		isLink: true
	});
	
	/**
		Represents a list of tokens making up a valid email address
		@class EMAIL
		@extends MultiToken
	*/
	var EMAIL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
		type: 'email',
		isLink: true,
		toHref: function toHref() {
			return 'mailto:' + this.toString();
		}
	});
	
	/**
		Represents some plain text
		@class TEXT
		@extends MultiToken
	*/
	var TEXT = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), { type: 'text' });
	
	/**
		Multi-linebreak token - represents a line break
		@class NL
		@extends MultiToken
	*/
	var NL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), { type: 'nl' });
	
	/**
		Represents a list of tokens making up a valid URL
		@class URL
		@extends MultiToken
	*/
	var URL = (0, _class.inherits)(MultiToken, (0, _createTokenClass.createTokenClass)(), {
		type: 'url',
		isLink: true,
	
		/**
	 	Lowercases relevant parts of the domain and adds the protocol if
	 	required. Note that this will not escape unsafe HTML characters in the
	 	URL.
	 		@method href
	 	@param {String} protocol
	 	@return {String}
	 */
		toHref: function toHref() {
			var protocol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'http';
	
			var hasProtocol = false;
			var hasSlashSlash = false;
			var tokens = this.v;
			var result = [];
			var i = 0;
	
			// Make the first part of the domain lowercase
			// Lowercase protocol
			while (tokens[i] instanceof _text.PROTOCOL) {
				hasProtocol = true;
				result.push(tokens[i].toString().toLowerCase());
				i++;
			}
	
			// Skip slash-slash
			while (tokens[i] instanceof _text.SLASH) {
				hasSlashSlash = true;
				result.push(tokens[i].toString());
				i++;
			}
	
			// Lowercase all other characters in the domain
			while (isDomainToken(tokens[i])) {
				result.push(tokens[i].toString().toLowerCase());
				i++;
			}
	
			// Leave all other characters as they were written
			for (; i < tokens.length; i++) {
				result.push(tokens[i].toString());
			}
	
			result = result.join('');
	
			if (!(hasProtocol || hasSlashSlash)) {
				result = protocol + '://' + result;
			}
	
			return result;
		},
		hasProtocol: function hasProtocol() {
			return this.v[0] instanceof _text.PROTOCOL;
		}
	});
	
	exports.Base = MultiToken;
	exports.MAILTOEMAIL = MAILTOEMAIL;
	exports.EMAIL = EMAIL;
	exports.NL = NL;
	exports.TEXT = TEXT;
	exports.URL = URL;

/***/ }),
/* 757 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var defaults = {
		defaultProtocol: 'http',
		events: null,
		format: noop,
		formatHref: noop,
		nl2br: false,
		tagName: 'a',
		target: typeToTarget,
		validate: true,
		ignoreTags: [],
		attributes: null,
		className: 'linkified' // Deprecated value - no default class will be provided in the future
	};
	
	exports.defaults = defaults;
	exports.Options = Options;
	exports.contains = contains;
	
	
	function Options(opts) {
		opts = opts || {};
	
		this.defaultProtocol = opts.hasOwnProperty('defaultProtocol') ? opts.defaultProtocol : defaults.defaultProtocol;
		this.events = opts.hasOwnProperty('events') ? opts.events : defaults.events;
		this.format = opts.hasOwnProperty('format') ? opts.format : defaults.format;
		this.formatHref = opts.hasOwnProperty('formatHref') ? opts.formatHref : defaults.formatHref;
		this.nl2br = opts.hasOwnProperty('nl2br') ? opts.nl2br : defaults.nl2br;
		this.tagName = opts.hasOwnProperty('tagName') ? opts.tagName : defaults.tagName;
		this.target = opts.hasOwnProperty('target') ? opts.target : defaults.target;
		this.validate = opts.hasOwnProperty('validate') ? opts.validate : defaults.validate;
		this.ignoreTags = [];
	
		// linkAttributes and linkClass is deprecated
		this.attributes = opts.attributes || opts.linkAttributes || defaults.attributes;
		this.className = opts.hasOwnProperty('className') ? opts.className : opts.linkClass || defaults.className;
	
		// Make all tags names upper case
		var ignoredTags = opts.hasOwnProperty('ignoreTags') ? opts.ignoreTags : defaults.ignoreTags;
		for (var i = 0; i < ignoredTags.length; i++) {
			this.ignoreTags.push(ignoredTags[i].toUpperCase());
		}
	}
	
	Options.prototype = {
		/**
	  * Given the token, return all options for how it should be displayed
	  */
		resolve: function resolve(token) {
			var href = token.toHref(this.defaultProtocol);
			return {
				formatted: this.get('format', token.toString(), token),
				formattedHref: this.get('formatHref', href, token),
				tagName: this.get('tagName', href, token),
				className: this.get('className', href, token),
				target: this.get('target', href, token),
				events: this.getObject('events', href, token),
				attributes: this.getObject('attributes', href, token)
			};
		},
	
	
		/**
	  * Returns true or false based on whether a token should be displayed as a
	  * link based on the user options. By default,
	  */
		check: function check(token) {
			return this.get('validate', token.toString(), token);
		},
	
	
		// Private methods
	
		/**
	  * Resolve an option's value based on the value of the option and the given
	  * params.
	  * @param {String} key Name of option to use
	  * @param operator will be passed to the target option if it's method
	  * @param {MultiToken} token The token from linkify.tokenize
	  */
		get: function get(key, operator, token) {
			var optionValue = void 0,
			    option = this[key];
			if (!option) {
				return option;
			}
	
			switch (typeof option === 'undefined' ? 'undefined' : _typeof(option)) {
				case 'function':
					return option(operator, token.type);
				case 'object':
					optionValue = option.hasOwnProperty(token.type) ? option[token.type] : defaults[key];
					return typeof optionValue === 'function' ? optionValue(operator, token.type) : optionValue;
			}
	
			return option;
		},
		getObject: function getObject(key, operator, token) {
			var option = this[key];
			return typeof option === 'function' ? option(operator, token.type) : option;
		}
	};
	
	/**
	 * Quick indexOf replacement for checking the ignoreTags option
	 */
	function contains(arr, value) {
		for (var i = 0; i < arr.length; i++) {
			if (arr[i] === value) {
				return true;
			}
		}
		return false;
	}
	
	function noop(val) {
		return val;
	}
	
	function typeToTarget(href, type) {
		return type === 'url' ? '_blank' : null;
	}

/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _html5NamedCharRefs = __webpack_require__(344);
	
	var _html5NamedCharRefs2 = _interopRequireDefault(_html5NamedCharRefs);
	
	var _entityParser = __webpack_require__(342);
	
	var _entityParser2 = _interopRequireDefault(_entityParser);
	
	var _eventedTokenizer = __webpack_require__(343);
	
	var _eventedTokenizer2 = _interopRequireDefault(_eventedTokenizer);
	
	var _tokenizer = __webpack_require__(345);
	
	var _tokenizer2 = _interopRequireDefault(_tokenizer);
	
	var _tokenize = __webpack_require__(759);
	
	var _tokenize2 = _interopRequireDefault(_tokenize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HTML5Tokenizer = {
		HTML5NamedCharRefs: _html5NamedCharRefs2.default,
		EntityParser: _entityParser2.default,
		EventedTokenizer: _eventedTokenizer2.default,
		Tokenizer: _tokenizer2.default,
		tokenize: _tokenize2.default
	};
	
	exports.default = HTML5Tokenizer;

/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = tokenize;
	
	var _tokenizer = __webpack_require__(345);
	
	var _tokenizer2 = _interopRequireDefault(_tokenizer);
	
	var _entityParser = __webpack_require__(342);
	
	var _entityParser2 = _interopRequireDefault(_entityParser);
	
	var _html5NamedCharRefs = __webpack_require__(344);
	
	var _html5NamedCharRefs2 = _interopRequireDefault(_html5NamedCharRefs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function tokenize(input, options) {
	  var tokenizer = new _tokenizer2.default(new _entityParser2.default(_html5NamedCharRefs2.default), options);
	  return tokenizer.tokenize(input);
	}

/***/ }),
/* 760 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.isSpace = isSpace;
	exports.isAlpha = isAlpha;
	exports.preprocessInput = preprocessInput;
	var WSP = /[\t\n\f ]/;
	var ALPHA = /[A-Za-z]/;
	var CRLF = /\r\n?/g;
	
	function isSpace(char) {
	  return WSP.test(char);
	}
	
	function isAlpha(char) {
	  return ALPHA.test(char);
	}
	
	function preprocessInput(input) {
	  return input.replace(CRLF, "\n");
	}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array ? array.length : 0;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCallback = __webpack_require__(768),
	    baseUniq = __webpack_require__(782),
	    isIterateeCall = __webpack_require__(165),
	    sortedUniq = __webpack_require__(799);
	
	/**
	 * Creates a duplicate-free version of an array, using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons, in which only the first occurence of each element
	 * is kept. Providing `true` for `isSorted` performs a faster search algorithm
	 * for sorted arrays. If an iteratee function is provided it's invoked for
	 * each element in the array to generate the criterion by which uniqueness
	 * is computed. The `iteratee` is bound to `thisArg` and invoked with three
	 * arguments: (value, index, array).
	 *
	 * If a property name is provided for `iteratee` the created `_.property`
	 * style callback returns the property value of the given element.
	 *
	 * If a value is also provided for `thisArg` the created `_.matchesProperty`
	 * style callback returns `true` for elements that have a matching property
	 * value, else `false`.
	 *
	 * If an object is provided for `iteratee` the created `_.matches` style
	 * callback returns `true` for elements that have the properties of the given
	 * object, else `false`.
	 *
	 * @static
	 * @memberOf _
	 * @alias unique
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {boolean} [isSorted] Specify the array is sorted.
	 * @param {Function|Object|string} [iteratee] The function invoked per iteration.
	 * @param {*} [thisArg] The `this` binding of `iteratee`.
	 * @returns {Array} Returns the new duplicate-value-free array.
	 * @example
	 *
	 * _.uniq([2, 1, 2]);
	 * // => [2, 1]
	 *
	 * // using `isSorted`
	 * _.uniq([1, 1, 2], true);
	 * // => [1, 2]
	 *
	 * // using an iteratee function
	 * _.uniq([1, 2.5, 1.5, 2], function(n) {
	 *   return this.floor(n);
	 * }, Math);
	 * // => [1, 2.5]
	 *
	 * // using the `_.property` callback shorthand
	 * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniq(array, isSorted, iteratee, thisArg) {
	  var length = array ? array.length : 0;
	  if (!length) {
	    return [];
	  }
	  if (isSorted != null && typeof isSorted != 'boolean') {
	    thisArg = iteratee;
	    iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
	    isSorted = false;
	  }
	  iteratee = iteratee == null ? iteratee : baseCallback(iteratee, thisArg, 3);
	  return (isSorted)
	    ? sortedUniq(array, iteratee)
	    : baseUniq(array, iteratee);
	}
	
	module.exports = uniq;


/***/ }),
/* 763 */
/***/ (function(module, exports) {

	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var cachePush = __webpack_require__(785),
	    getNative = __webpack_require__(164);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 *
	 * Creates a cache object to store unique values.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var length = values ? values.length : 0;
	
	  this.data = { 'hash': nativeCreate(null), 'set': new Set };
	  while (length--) {
	    this.push(values[length]);
	  }
	}
	
	// Add functions to the `Set` cache.
	SetCache.prototype.push = cachePush;
	
	module.exports = SetCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 765 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 766 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(348),
	    keys = __webpack_require__(111);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(776),
	    baseMatchesProperty = __webpack_require__(777),
	    bindCallback = __webpack_require__(163),
	    identity = __webpack_require__(357),
	    property = __webpack_require__(807);
	
	/**
	 * The base implementation of `_.callback` which supports specifying the
	 * number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {*} [func=_.identity] The value to convert to a callback.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function baseCallback(func, thisArg, argCount) {
	  var type = typeof func;
	  if (type == 'function') {
	    return thisArg === undefined
	      ? func
	      : bindCallback(func, thisArg, argCount);
	  }
	  if (func == null) {
	    return identity;
	  }
	  if (type == 'object') {
	    return baseMatches(func);
	  }
	  return thisArg === undefined
	    ? property(func)
	    : baseMatchesProperty(func, thisArg);
	}
	
	module.exports = baseCallback;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(346),
	    arrayEach = __webpack_require__(347),
	    baseAssign = __webpack_require__(767),
	    baseForOwn = __webpack_require__(772),
	    initCloneArray = __webpack_require__(795),
	    initCloneByTag = __webpack_require__(796),
	    initCloneObject = __webpack_require__(797),
	    isArray = __webpack_require__(54),
	    isObject = __webpack_require__(36);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
	cloneableTags[dateTag] = cloneableTags[float32Tag] =
	cloneableTags[float64Tag] = cloneableTags[int8Tag] =
	cloneableTags[int16Tag] = cloneableTags[int32Tag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[stringTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[mapTag] = cloneableTags[setTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * The base implementation of `_.clone` without support for argument juggling
	 * and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {Function} [customizer] The function to customize cloning values.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The object `value` belongs to.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates clones with source counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return arrayCopy(value, result);
	    }
	  } else {
	    var tag = objToString.call(value),
	        isFunc = tag == funcTag;
	
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return baseAssign(result, value);
	      }
	    } else {
	      return cloneableTags[tag]
	        ? initCloneByTag(value, tag, isDeep)
	        : (object ? value : {});
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == value) {
	      return stackB[length];
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate it with its clone.
	  stackA.push(value);
	  stackB.push(result);
	
	  // Recursively populate clone (susceptible to call stack limits).
	  (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
	    result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(765),
	    isArguments = __webpack_require__(110),
	    isArray = __webpack_require__(54),
	    isArrayLike = __webpack_require__(97),
	    isObjectLike = __webpack_require__(61);
	
	/**
	 * The base implementation of `_.flatten` with added support for restricting
	 * flattening and specifying the start index.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {boolean} [isDeep] Specify a deep flatten.
	 * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, isDeep, isStrict, result) {
	  result || (result = []);
	
	  var index = -1,
	      length = array.length;
	
	  while (++index < length) {
	    var value = array[index];
	    if (isObjectLike(value) && isArrayLike(value) &&
	        (isStrict || isArray(value) || isArguments(value))) {
	      if (isDeep) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, isDeep, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(349),
	    keysIn = __webpack_require__(234);
	
	/**
	 * The base implementation of `_.forIn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForIn(object, iteratee) {
	  return baseFor(object, iteratee, keysIn);
	}
	
	module.exports = baseForIn;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(349),
	    keys = __webpack_require__(111);
	
	/**
	 * The base implementation of `_.forOwn` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

	var indexOfNaN = __webpack_require__(794);
	
	/**
	 * The base implementation of `_.indexOf` without support for binary searches.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return indexOfNaN(array, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseIndexOf;


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

	var equalArrays = __webpack_require__(789),
	    equalByTag = __webpack_require__(790),
	    equalObjects = __webpack_require__(791),
	    isArray = __webpack_require__(54),
	    isTypedArray = __webpack_require__(233);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA=[]] Tracks traversed `value` objects.
	 * @param {Array} [stackB=[]] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = objToString.call(object);
	    if (objTag == argsTag) {
	      objTag = objectTag;
	    } else if (objTag != objectTag) {
	      objIsArr = isTypedArray(object);
	    }
	  }
	  if (!othIsArr) {
	    othTag = objToString.call(other);
	    if (othTag == argsTag) {
	      othTag = objectTag;
	    } else if (othTag != objectTag) {
	      othIsArr = isTypedArray(other);
	    }
	  }
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !(objIsArr || objIsObj)) {
	    return equalByTag(object, other, objTag);
	  }
	  if (!isLoose) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  // For more information on detecting circular references see https://es5.github.io/#JO.
	  stackA || (stackA = []);
	  stackB || (stackB = []);
	
	  var length = stackA.length;
	  while (length--) {
	    if (stackA[length] == object) {
	      return stackB[length] == other;
	    }
	  }
	  // Add `object` and `other` to the stack of traversed objects.
	  stackA.push(object);
	  stackB.push(other);
	
	  var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);
	
	  stackA.pop();
	  stackB.pop();
	
	  return result;
	}
	
	module.exports = baseIsEqualDeep;


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(228),
	    toObject = __webpack_require__(98);
	
	/**
	 * The base implementation of `_.isMatch` without support for callback
	 * shorthands and `this` binding.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} matchData The propery names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparing objects.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = toObject(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var result = customizer ? customizer(objValue, srcValue, key) : undefined;
	      if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(775),
	    getMatchData = __webpack_require__(793),
	    toObject = __webpack_require__(98);
	
	/**
	 * The base implementation of `_.matches` which does not clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    var key = matchData[0][0],
	        value = matchData[0][1];
	
	    return function(object) {
	      if (object == null) {
	        return false;
	      }
	      return object[key] === value && (value !== undefined || (key in toObject(object)));
	    };
	  }
	  return function(object) {
	    return baseIsMatch(object, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(227),
	    baseIsEqual = __webpack_require__(228),
	    baseSlice = __webpack_require__(781),
	    isArray = __webpack_require__(54),
	    isKey = __webpack_require__(351),
	    isStrictComparable = __webpack_require__(352),
	    last = __webpack_require__(761),
	    toObject = __webpack_require__(98),
	    toPath = __webpack_require__(231);
	
	/**
	 * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to compare.
	 * @returns {Function} Returns the new function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  var isArr = isArray(path),
	      isCommon = isKey(path) && isStrictComparable(srcValue),
	      pathKey = (path + '');
	
	  path = toPath(path);
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    var key = pathKey;
	    object = toObject(object);
	    if ((isArr || !isCommon) && !(key in object)) {
	      object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
	      if (object == null) {
	        return false;
	      }
	      key = last(path);
	      object = toObject(object);
	    }
	    return object[key] === srcValue
	      ? (srcValue !== undefined || (key in object))
	      : baseIsEqual(srcValue, object[key], undefined, true);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(347),
	    baseMergeDeep = __webpack_require__(779),
	    isArray = __webpack_require__(54),
	    isArrayLike = __webpack_require__(97),
	    isObject = __webpack_require__(36),
	    isObjectLike = __webpack_require__(61),
	    isTypedArray = __webpack_require__(233),
	    keys = __webpack_require__(111);
	
	/**
	 * The base implementation of `_.merge` without support for argument juggling,
	 * multiple sources, and `this` binding `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates values with source counterparts.
	 * @returns {Object} Returns `object`.
	 */
	function baseMerge(object, source, customizer, stackA, stackB) {
	  if (!isObject(object)) {
	    return object;
	  }
	  var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
	      props = isSrcArr ? undefined : keys(source);
	
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObjectLike(srcValue)) {
	      stackA || (stackA = []);
	      stackB || (stackB = []);
	      baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
	    }
	    else {
	      var value = object[key],
	          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	          isCommon = result === undefined;
	
	      if (isCommon) {
	        result = srcValue;
	      }
	      if ((result !== undefined || (isSrcArr && !(key in object))) &&
	          (isCommon || (result === result ? (result !== value) : (value === value)))) {
	        object[key] = result;
	      }
	    }
	  });
	  return object;
	}
	
	module.exports = baseMerge;


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayCopy = __webpack_require__(346),
	    isArguments = __webpack_require__(110),
	    isArray = __webpack_require__(54),
	    isArrayLike = __webpack_require__(97),
	    isPlainObject = __webpack_require__(801),
	    isTypedArray = __webpack_require__(233),
	    toPlainObject = __webpack_require__(804);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Array} [stackA=[]] Tracks traversed source objects.
	 * @param {Array} [stackB=[]] Associates values with source counterparts.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
	  var length = stackA.length,
	      srcValue = source[key];
	
	  while (length--) {
	    if (stackA[length] == srcValue) {
	      object[key] = stackB[length];
	      return;
	    }
	  }
	  var value = object[key],
	      result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
	      isCommon = result === undefined;
	
	  if (isCommon) {
	    result = srcValue;
	    if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
	      result = isArray(value)
	        ? value
	        : (isArrayLike(value) ? arrayCopy(value) : []);
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      result = isArguments(value)
	        ? toPlainObject(value)
	        : (isPlainObject(value) ? value : {});
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  // Add the source value to the stack of traversed objects and associate
	  // it with its merged value.
	  stackA.push(srcValue);
	  stackB.push(result);
	
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
	  } else if (result === result ? (result !== value) : (value === value)) {
	    object[key] = result;
	  }
	}
	
	module.exports = baseMergeDeep;


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(227),
	    toPath = __webpack_require__(231);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function basePropertyDeep(path) {
	  var pathKey = (path + '');
	  path = toPath(path);
	  return function(object) {
	    return baseGet(object, path, pathKey);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ }),
/* 781 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  start = start == null ? 0 : (+start || 0);
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = (end === undefined || end > length) ? length : (+end || 0);
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(773),
	    cacheIndexOf = __webpack_require__(784),
	    createCache = __webpack_require__(788);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniq` without support for callback shorthands
	 * and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee) {
	  var index = -1,
	      indexOf = baseIndexOf,
	      length = array.length,
	      isCommon = true,
	      isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
	      seen = isLarge ? createCache() : null,
	      result = [];
	
	  if (seen) {
	    indexOf = cacheIndexOf;
	    isCommon = false;
	  } else {
	    isLarge = false;
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (isCommon && value === value) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (indexOf(seen, computed, 0) < 0) {
	      if (iteratee || isLarge) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ }),
/* 783 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Native method references. */
	var ArrayBuffer = global.ArrayBuffer,
	    Uint8Array = global.Uint8Array;
	
	/**
	 * Creates a clone of the given array buffer.
	 *
	 * @private
	 * @param {ArrayBuffer} buffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function bufferClone(buffer) {
	  var result = new ArrayBuffer(buffer.byteLength),
	      view = new Uint8Array(result);
	
	  view.set(new Uint8Array(buffer));
	  return result;
	}
	
	module.exports = bufferClone;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	
	/**
	 * Checks if `value` is in `cache` mimicking the return signature of
	 * `_.indexOf` by returning `0` if the value is found, else `-1`.
	 *
	 * @private
	 * @param {Object} cache The cache to search.
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `0` if `value` is found, else `-1`.
	 */
	function cacheIndexOf(cache, value) {
	  var data = cache.data,
	      result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];
	
	  return result ? 0 : -1;
	}
	
	module.exports = cacheIndexOf;


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	
	/**
	 * Adds `value` to the cache.
	 *
	 * @private
	 * @name push
	 * @memberOf SetCache
	 * @param {*} value The value to cache.
	 */
	function cachePush(value) {
	  var data = this.data;
	  if (typeof value == 'string' || isObject(value)) {
	    data.set.add(value);
	  } else {
	    data.hash[value] = true;
	  }
	}
	
	module.exports = cachePush;


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

	var bindCallback = __webpack_require__(163),
	    isIterateeCall = __webpack_require__(165),
	    restParam = __webpack_require__(763);
	
	/**
	 * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

	var toObject = __webpack_require__(98);
	
	/**
	 * Creates a base function for `_.forIn` or `_.forInRight`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var iterable = toObject(object),
	        props = keysFunc(object),
	        length = props.length,
	        index = fromRight ? length : -1;
	
	    while ((fromRight ? index-- : ++index < length)) {
	      var key = props[index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var SetCache = __webpack_require__(764),
	    getNative = __webpack_require__(164);
	
	/** Native method references. */
	var Set = getNative(global, 'Set');
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeCreate = getNative(Object, 'create');
	
	/**
	 * Creates a `Set` cache object to optimize linear searches of large arrays.
	 *
	 * @private
	 * @param {Array} [values] The values to cache.
	 * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
	 */
	function createCache(values) {
	  return (nativeCreate && Set) ? new SetCache(values) : null;
	}
	
	module.exports = createCache;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

	var arraySome = __webpack_require__(766);
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing arrays.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var index = -1,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
	    return false;
	  }
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index],
	        result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;
	
	    if (result !== undefined) {
	      if (result) {
	        continue;
	      }
	      return false;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (isLoose) {
	      if (!arraySome(other, function(othValue) {
	            return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
	          })) {
	        return false;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalArrays;


/***/ }),
/* 790 */
/***/ (function(module, exports) {

	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag) {
	  switch (tag) {
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and booleans
	      // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object)
	        ? other != +other
	        : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings primitives and string
	      // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
	      return object == (other + '');
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(111);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparing values.
	 * @param {boolean} [isLoose] Specify performing partial comparisons.
	 * @param {Array} [stackA] Tracks traversed `value` objects.
	 * @param {Array} [stackB] Tracks traversed `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
	  var objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isLoose) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  var skipCtor = isLoose;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key],
	        result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;
	
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
	      return false;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (!skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	module.exports = equalObjects;


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(350);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(352),
	    pairs = __webpack_require__(806);
	
	/**
	 * Gets the propery names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = pairs(object),
	      length = result.length;
	
	  while (length--) {
	    result[length][2] = isStrictComparable(result[length][1]);
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ }),
/* 794 */
/***/ (function(module, exports) {

	/**
	 * Gets the index at which the first occurrence of `NaN` is found in `array`.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched `NaN`, else `-1`.
	 */
	function indexOfNaN(array, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 0 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    var other = array[index];
	    if (other !== other) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = indexOfNaN;


/***/ }),
/* 795 */
/***/ (function(module, exports) {

	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = new array.constructor(length);
	
	  // Add array properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

	var bufferClone = __webpack_require__(783);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    stringTag = '[object String]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return bufferClone(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      var buffer = object.buffer;
	      return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      var result = new Ctor(object.source, reFlags.exec(object));
	      result.lastIndex = object.lastIndex;
	  }
	  return result;
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 797 */
/***/ (function(module, exports) {

	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  var Ctor = object.constructor;
	  if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
	    Ctor = Object;
	  }
	  return new Ctor;
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

	var isArguments = __webpack_require__(110),
	    isArray = __webpack_require__(54),
	    isIndex = __webpack_require__(230),
	    isLength = __webpack_require__(128),
	    keysIn = __webpack_require__(234);
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = shimKeys;


/***/ }),
/* 799 */
/***/ (function(module, exports) {

	/**
	 * An implementation of `_.uniq` optimized for sorted arrays without support
	 * for callback shorthands and `this` binding.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The function invoked per iteration.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function sortedUniq(array, iteratee) {
	  var seen,
	      index = -1,
	      length = array.length,
	      resIndex = -1,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value, index, array) : value;
	
	    if (!index || seen !== computed) {
	      seen = computed;
	      result[++resIndex] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = sortedUniq;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(354),
	    isObjectLike = __webpack_require__(61);
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isNative;


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

	var baseForIn = __webpack_require__(771),
	    isArguments = __webpack_require__(110),
	    isObjectLike = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * **Note:** This method assumes objects created by the `Object` constructor
	 * have no inherited enumerable properties.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  var Ctor;
	
	  // Exit early for non `Object` objects.
	  if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
	      (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
	    return false;
	  }
	  // IE < 9 iterates inherited properties before own properties. If the first
	  // iterated property is an object's own property then there are no inherited
	  // enumerable properties.
	  var result;
	  // In most environments an object's own properties are iterated before
	  // its inherited properties. If the last iterated property is an object's
	  // own property then there are no inherited enumerable properties.
	  baseForIn(value, function(subValue, key) {
	    result = key;
	  });
	  return result === undefined || hasOwnProperty.call(value, result);
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(36);
	
	/** `Object#toString` result references. */
	var regexpTag = '[object RegExp]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `RegExp` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isRegExp(/abc/);
	 * // => true
	 *
	 * _.isRegExp('/abc/');
	 * // => false
	 */
	function isRegExp(value) {
	  return isObject(value) && objToString.call(value) == regexpTag;
	}
	
	module.exports = isRegExp;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(61);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCopy = __webpack_require__(348),
	    keysIn = __webpack_require__(234);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable
	 * properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return baseCopy(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(227),
	    toPath = __webpack_require__(231);
	
	/**
	 * Gets the property value at `path` of `object`. If the resolved value is
	 * `undefined` the `defaultValue` is used in its place.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, toPath(path), (path + ''));
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

	var keys = __webpack_require__(111),
	    toObject = __webpack_require__(98);
	
	/**
	 * Creates a two dimensional array of the key-value pairs for `object`,
	 * e.g. `[[key1, value1], [key2, value2]]`.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the new array of key-value pairs.
	 * @example
	 *
	 * _.pairs({ 'barney': 36, 'fred': 40 });
	 * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
	 */
	function pairs(object) {
	  object = toObject(object);
	
	  var index = -1,
	      props = keys(object),
	      length = props.length,
	      result = Array(length);
	
	  while (++index < length) {
	    var key = props[index];
	    result[index] = [key, object[key]];
	  }
	  return result;
	}
	
	module.exports = pairs;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(350),
	    basePropertyDeep = __webpack_require__(780),
	    isKey = __webpack_require__(351);
	
	/**
	 * Creates a function that returns the property value at `path` on a
	 * given object.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': { 'c': 2 } } },
	 *   { 'a': { 'b': { 'c': 1 } } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b.c'));
	 * // => [2, 1]
	 *
	 * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(229);
	
	/** Used to generate unique IDs. */
	var idCounter = 0;
	
	/**
	 * Generates a unique ID. If `prefix` is provided the ID is appended to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {string} [prefix] The value to prefix the ID with.
	 * @returns {string} Returns the unique ID.
	 * @example
	 *
	 * _.uniqueId('contact_');
	 * // => 'contact_104'
	 *
	 * _.uniqueId();
	 * // => '105'
	 */
	function uniqueId(prefix) {
	  var id = ++idCounter;
	  return baseToString(prefix) + id;
	}
	
	module.exports = uniqueId;


/***/ }),
/* 809 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = Number.isNaN || function (x) {
		return x !== x;
	};


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var keysShim;
	if (!Object.keys) {
		// modified from https://github.com/es-shims/es5-shim
		var has = Object.prototype.hasOwnProperty;
		var toStr = Object.prototype.toString;
		var isArgs = __webpack_require__(360); // eslint-disable-line global-require
		var isEnumerable = Object.prototype.propertyIsEnumerable;
		var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
		var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
		var dontEnums = [
			'toString',
			'toLocaleString',
			'valueOf',
			'hasOwnProperty',
			'isPrototypeOf',
			'propertyIsEnumerable',
			'constructor'
		];
		var equalsConstructorPrototype = function (o) {
			var ctor = o.constructor;
			return ctor && ctor.prototype === o;
		};
		var excludedKeys = {
			$applicationCache: true,
			$console: true,
			$external: true,
			$frame: true,
			$frameElement: true,
			$frames: true,
			$innerHeight: true,
			$innerWidth: true,
			$onmozfullscreenchange: true,
			$onmozfullscreenerror: true,
			$outerHeight: true,
			$outerWidth: true,
			$pageXOffset: true,
			$pageYOffset: true,
			$parent: true,
			$scrollLeft: true,
			$scrollTop: true,
			$scrollX: true,
			$scrollY: true,
			$self: true,
			$webkitIndexedDB: true,
			$webkitStorageInfo: true,
			$window: true
		};
		var hasAutomationEqualityBug = (function () {
			/* global window */
			if (typeof window === 'undefined') { return false; }
			for (var k in window) {
				try {
					if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
						try {
							equalsConstructorPrototype(window[k]);
						} catch (e) {
							return true;
						}
					}
				} catch (e) {
					return true;
				}
			}
			return false;
		}());
		var equalsConstructorPrototypeIfNotBuggy = function (o) {
			/* global window */
			if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
				return equalsConstructorPrototype(o);
			}
			try {
				return equalsConstructorPrototype(o);
			} catch (e) {
				return false;
			}
		};
	
		keysShim = function keys(object) {
			var isObject = object !== null && typeof object === 'object';
			var isFunction = toStr.call(object) === '[object Function]';
			var isArguments = isArgs(object);
			var isString = isObject && toStr.call(object) === '[object String]';
			var theKeys = [];
	
			if (!isObject && !isFunction && !isArguments) {
				throw new TypeError('Object.keys called on a non-object');
			}
	
			var skipProto = hasProtoEnumBug && isFunction;
			if (isString && object.length > 0 && !has.call(object, 0)) {
				for (var i = 0; i < object.length; ++i) {
					theKeys.push(String(i));
				}
			}
	
			if (isArguments && object.length > 0) {
				for (var j = 0; j < object.length; ++j) {
					theKeys.push(String(j));
				}
			} else {
				for (var name in object) {
					if (!(skipProto && name === 'prototype') && has.call(object, name)) {
						theKeys.push(String(name));
					}
				}
			}
	
			if (hasDontEnumBug) {
				var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);
	
				for (var k = 0; k < dontEnums.length; ++k) {
					if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
						theKeys.push(dontEnums[k]);
					}
				}
			}
			return theKeys;
		};
	}
	module.exports = keysShim;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defineProperties = __webpack_require__(334);
	var callBind = __webpack_require__(276);
	
	var implementation = __webpack_require__(361);
	var getPolyfill = __webpack_require__(362);
	var shim = __webpack_require__(812);
	
	var polyfill = callBind.apply(getPolyfill());
	// eslint-disable-next-line no-unused-vars
	var bound = function assign(target, source1) {
		return polyfill(Object, arguments);
	};
	
	defineProperties(bound, {
		getPolyfill: getPolyfill,
		implementation: implementation,
		shim: shim
	});
	
	module.exports = bound;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var define = __webpack_require__(334);
	var getPolyfill = __webpack_require__(362);
	
	module.exports = function shimAssign() {
		var polyfill = getPolyfill();
		define(
			Object,
			{ assign: polyfill },
			{ assign: function () { return Object.assign !== polyfill; } }
		);
		return polyfill;
	};


/***/ }),
/* 813 */
/***/ (function(module, exports) {

	var trim = function(string) {
	  return string.replace(/^\s+|\s+$/g, '');
	}
	  , isArray = function(arg) {
	      return Object.prototype.toString.call(arg) === '[object Array]';
	    }
	
	module.exports = function (headers) {
	  if (!headers)
	    return {}
	
	  var result = {}
	
	  var headersArr = trim(headers).split('\n')
	
	  for (var i = 0; i < headersArr.length; i++) {
	    var row = headersArr[i]
	    var index = row.indexOf(':')
	    , key = trim(row.slice(0, index)).toLowerCase()
	    , value = trim(row.slice(index + 1))
	
	    if (typeof(result[key]) === 'undefined') {
	      result[key] = value
	    } else if (isArray(result[key])) {
	      result[key].push(value)
	    } else {
	      result[key] = [ result[key], value ]
	    }
	  }
	
	  return result
	}


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(815);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 815 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(817);


/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

	// Load modules
	
	var Stringify = __webpack_require__(819);
	var Parse = __webpack_require__(818);
	
	
	// Declare internals
	
	var internals = {};
	
	
	module.exports = {
	    stringify: Stringify,
	    parse: Parse
	};


/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(364);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    depth: 5,
	    arrayLimit: 20,
	    parameterLimit: 1000
	};
	
	
	internals.parseValues = function (str, options) {
	
	    var obj = {};
	    var parts = str.split(options.delimiter, options.parameterLimit === Infinity ? undefined : options.parameterLimit);
	
	    for (var i = 0, il = parts.length; i < il; ++i) {
	        var part = parts[i];
	        var pos = part.indexOf(']=') === -1 ? part.indexOf('=') : part.indexOf(']=') + 1;
	
	        if (pos === -1) {
	            obj[Utils.decode(part)] = '';
	        }
	        else {
	            var key = Utils.decode(part.slice(0, pos));
	            var val = Utils.decode(part.slice(pos + 1));
	
	            if (Object.prototype.hasOwnProperty(key)) {
	                continue;
	            }
	
	            if (!obj.hasOwnProperty(key)) {
	                obj[key] = val;
	            }
	            else {
	                obj[key] = [].concat(obj[key]).concat(val);
	            }
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseObject = function (chain, val, options) {
	
	    if (!chain.length) {
	        return val;
	    }
	
	    var root = chain.shift();
	
	    var obj = {};
	    if (root === '[]') {
	        obj = [];
	        obj = obj.concat(internals.parseObject(chain, val, options));
	    }
	    else {
	        var cleanRoot = root[0] === '[' && root[root.length - 1] === ']' ? root.slice(1, root.length - 1) : root;
	        var index = parseInt(cleanRoot, 10);
	        var indexString = '' + index;
	        if (!isNaN(index) &&
	            root !== cleanRoot &&
	            indexString === cleanRoot &&
	            index >= 0 &&
	            index <= options.arrayLimit) {
	
	            obj = [];
	            obj[index] = internals.parseObject(chain, val, options);
	        }
	        else {
	            obj[cleanRoot] = internals.parseObject(chain, val, options);
	        }
	    }
	
	    return obj;
	};
	
	
	internals.parseKeys = function (key, val, options) {
	
	    if (!key) {
	        return;
	    }
	
	    // The regex chunks
	
	    var parent = /^([^\[\]]*)/;
	    var child = /(\[[^\[\]]*\])/g;
	
	    // Get the parent
	
	    var segment = parent.exec(key);
	
	    // Don't allow them to overwrite object prototype properties
	
	    if (Object.prototype.hasOwnProperty(segment[1])) {
	        return;
	    }
	
	    // Stash the parent if it exists
	
	    var keys = [];
	    if (segment[1]) {
	        keys.push(segment[1]);
	    }
	
	    // Loop through children appending to the array until we hit depth
	
	    var i = 0;
	    while ((segment = child.exec(key)) !== null && i < options.depth) {
	
	        ++i;
	        if (!Object.prototype.hasOwnProperty(segment[1].replace(/\[|\]/g, ''))) {
	            keys.push(segment[1]);
	        }
	    }
	
	    // If there's a remainder, just add whatever is left
	
	    if (segment) {
	        keys.push('[' + key.slice(segment.index) + ']');
	    }
	
	    return internals.parseObject(keys, val, options);
	};
	
	
	module.exports = function (str, options) {
	
	    if (str === '' ||
	        str === null ||
	        typeof str === 'undefined') {
	
	        return {};
	    }
	
	    options = options || {};
	    options.delimiter = typeof options.delimiter === 'string' || Utils.isRegExp(options.delimiter) ? options.delimiter : internals.delimiter;
	    options.depth = typeof options.depth === 'number' ? options.depth : internals.depth;
	    options.arrayLimit = typeof options.arrayLimit === 'number' ? options.arrayLimit : internals.arrayLimit;
	    options.parameterLimit = typeof options.parameterLimit === 'number' ? options.parameterLimit : internals.parameterLimit;
	
	    var tempObj = typeof str === 'string' ? internals.parseValues(str, options) : str;
	    var obj = {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0, il = keys.length; i < il; ++i) {
	        var key = keys[i];
	        var newObj = internals.parseKeys(key, tempObj[key], options);
	        obj = Utils.merge(obj, newObj);
	    }
	
	    return Utils.compact(obj);
	};


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

	// Load modules
	
	var Utils = __webpack_require__(364);
	
	
	// Declare internals
	
	var internals = {
	    delimiter: '&',
	    arrayPrefixGenerators: {
	        brackets: function (prefix, key) {
	            return prefix + '[]';
	        },
	        indices: function (prefix, key) {
	            return prefix + '[' + key + ']';
	        },
	        repeat: function (prefix, key) {
	            return prefix;
	        }
	    }
	};
	
	
	internals.stringify = function (obj, prefix, generateArrayPrefix) {
	
	    if (Utils.isBuffer(obj)) {
	        obj = obj.toString();
	    }
	    else if (obj instanceof Date) {
	        obj = obj.toISOString();
	    }
	    else if (obj === null) {
	        obj = '';
	    }
	
	    if (typeof obj === 'string' ||
	        typeof obj === 'number' ||
	        typeof obj === 'boolean') {
	
	        return [encodeURIComponent(prefix) + '=' + encodeURIComponent(obj)];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        if (Array.isArray(obj)) {
	            values = values.concat(internals.stringify(obj[key], generateArrayPrefix(prefix, key), generateArrayPrefix));
	        }
	        else {
	            values = values.concat(internals.stringify(obj[key], prefix + '[' + key + ']', generateArrayPrefix));
	        }
	    }
	
	    return values;
	};
	
	
	module.exports = function (obj, options) {
	
	    options = options || {};
	    var delimiter = typeof options.delimiter === 'undefined' ? internals.delimiter : options.delimiter;
	
	    var keys = [];
	
	    if (typeof obj !== 'object' ||
	        obj === null) {
	
	        return '';
	    }
	
	    var arrayFormat;
	    if (options.arrayFormat in internals.arrayPrefixGenerators) {
	        arrayFormat = options.arrayFormat;
	    }
	    else if ('indices' in options) {
	        arrayFormat = options.indices ? 'indices' : 'repeat';
	    }
	    else {
	        arrayFormat = 'indices';
	    }
	
	    var generateArrayPrefix = internals.arrayPrefixGenerators[arrayFormat];
	
	    var objKeys = Object.keys(obj);
	    for (var i = 0, il = objKeys.length; i < il; ++i) {
	        var key = objKeys[i];
	        keys = keys.concat(internals.stringify(obj[key], key, generateArrayPrefix));
	    }
	
	    return keys.join(delimiter);
	};


/***/ }),
/* 820 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53.5 37.5\"><defs><style>.cls-1{fill:none;stroke:#707070;stroke-width:2.5px;}</style></defs><title>large_preview</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect id=\"LargePreviewBorder\" class=\"cls-1\" x=\"1.25\" y=\"1.25\" width=\"51\" height=\"35\" rx=\"4\" ry=\"4\"/><path id=\"LargePreviewLine1\" class=\"cls-1\" d=\"M26.25,3.25h1v31h-1Z\"/></g></g></svg>"

/***/ }),
/* 821 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53.5 37.5\"><defs><style>.cls-1{fill:none;stroke:#707070;stroke-width:2.5px;}</style></defs><title>list_view</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect id=\"ListViewBorder\" class=\"cls-1\" x=\"1.25\" y=\"1.25\" width=\"51\" height=\"35\" rx=\"4\" ry=\"4\"/><path id=\"ListViewLine2\" class=\"cls-1\" d=\"M8.25,19.25v-1h37v1Zm0,0v-1h37v1Z\"/><path id=\"ListViewLine3\" class=\"cls-1\" d=\"M8.25,27.25v-1h37v1Zm0,0v-1h37v1Z\"/><path id=\"ListViewLine1\" class=\"cls-1\" d=\"M8.25,11.25v-1h37v1Z\"/></g></g></svg>"

/***/ }),
/* 822 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 53.5 37.5\"><defs><style>.cls-1{fill:none;stroke:#707070;stroke-width:2.5px;}</style></defs><title>small_preview</title><g id=\"Layer_2\" data-name=\"Layer 2\"><g id=\"Layer_1-2\" data-name=\"Layer 1\"><rect id=\"SmallPreviewBorder\" class=\"cls-1\" x=\"1.25\" y=\"1.25\" width=\"51\" height=\"35\" rx=\"4\" ry=\"4\"/><path id=\"SmallPreviewLine2\" class=\"cls-1\" d=\"M26.25,3.25h1v31h-1Z\"/><path id=\"SmallPreivewLine1\" class=\"cls-1\" d=\"M14.25,3.25h1v31h-1Z\"/><path id=\"SmallPrieviewLine3\" class=\"cls-1\" d=\"M38.25,3.25h1v31h-1Z\"/></g></g></svg>"

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(2);
	
	var sizerStyle = { position: 'absolute', visibility: 'hidden', height: 0, width: 0, overflow: 'scroll', whiteSpace: 'nowrap' };
	
	var AutosizeInput = React.createClass({
		displayName: 'AutosizeInput',
	
		propTypes: {
			value: React.PropTypes.any, // field value
			defaultValue: React.PropTypes.any, // default field value
			onChange: React.PropTypes.func, // onChange handler: function(newValue) {}
			style: React.PropTypes.object, // css styles for the outer element
			className: React.PropTypes.string, // className for the outer element
			minWidth: React.PropTypes.oneOfType([// minimum width for input element
			React.PropTypes.number, React.PropTypes.string]),
			inputStyle: React.PropTypes.object, // css styles for the input element
			inputClassName: React.PropTypes.string // className for the input element
		},
		getDefaultProps: function getDefaultProps() {
			return {
				minWidth: 1
			};
		},
		getInitialState: function getInitialState() {
			return {
				inputWidth: this.props.minWidth
			};
		},
		componentDidMount: function componentDidMount() {
			this.copyInputStyles();
			this.updateInputWidth();
		},
		componentDidUpdate: function componentDidUpdate() {
			this.updateInputWidth();
		},
		copyInputStyles: function copyInputStyles() {
			if (!this.isMounted() || !window.getComputedStyle) {
				return;
			}
			var inputStyle = window.getComputedStyle(React.findDOMNode(this.refs.input));
			var widthNode = React.findDOMNode(this.refs.sizer);
			widthNode.style.fontSize = inputStyle.fontSize;
			widthNode.style.fontFamily = inputStyle.fontFamily;
			widthNode.style.letterSpacing = inputStyle.letterSpacing;
			if (this.props.placeholder) {
				var placeholderNode = React.findDOMNode(this.refs.placeholderSizer);
				placeholderNode.style.fontSize = inputStyle.fontSize;
				placeholderNode.style.fontFamily = inputStyle.fontFamily;
				placeholderNode.style.letterSpacing = inputStyle.letterSpacing;
			}
		},
		updateInputWidth: function updateInputWidth() {
			if (!this.isMounted() || typeof React.findDOMNode(this.refs.sizer).scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth;
			if (this.props.placeholder) {
				newInputWidth = Math.max(React.findDOMNode(this.refs.sizer).scrollWidth, React.findDOMNode(this.refs.placeholderSizer).scrollWidth) + 2;
			} else {
				newInputWidth = React.findDOMNode(this.refs.sizer).scrollWidth + 2;
			}
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		},
		getInput: function getInput() {
			return this.refs.input;
		},
		focus: function focus() {
			React.findDOMNode(this.refs.input).focus();
		},
		select: function select() {
			React.findDOMNode(this.refs.input).select();
		},
		render: function render() {
			var escapedValue = (this.props.value || '').replace(/\&/g, '&amp;').replace(/ /g, '&nbsp;').replace(/\</g, '&lt;').replace(/\>/g, '&gt;');
			var wrapperStyle = this.props.style || {};
			wrapperStyle.display = 'inline-block';
			var inputStyle = _extends({}, this.props.inputStyle);
			inputStyle.width = this.state.inputWidth;
			inputStyle.boxSizing = 'content-box';
			var placeholder = this.props.placeholder ? React.createElement(
				'div',
				{ ref: 'placeholderSizer', style: sizerStyle },
				this.props.placeholder
			) : null;
			return React.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				React.createElement('input', _extends({}, this.props, { ref: 'input', className: this.props.inputClassName, style: inputStyle })),
				React.createElement('div', { ref: 'sizer', style: sizerStyle, dangerouslySetInnerHTML: { __html: escapedValue } }),
				placeholder
			);
		}
	});
	
	module.exports = AutosizeInput;

/***/ }),
/* 824 */
/***/ (function(module, exports) {

	/**
	 * Keycodes, modifier codes,
	 * and anything else that can be typed,
	 * compiled into a big lookup table.
	 */
	module.exports.modifierCodes = {
	    // Shift key, ⇧
	    '⇧': 16, shift: 16,
	    // CTRL key, on Mac: ⌃
	    '⌃': 17, ctrl: 17,
	    // ALT key, on Mac: ⌥ (Alt)
	    '⌥': 18, alt: 18, option: 18,
	    // META, on Mac: ⌘ (CMD), on Windows (Win), on Linux (Super)
	    '⌘': 91, meta: 91, cmd: 91, 'super': 91, win: 91
	};
	
	module.exports.modifierProperties = {
	    16: 'shiftKey',
	    17: 'ctrlKey',
	    18: 'altKey',
	    91: 'metaKey'
	};
	
	var keyCodes = {
	    // Backspace key, on Mac: ⌫ (Backspace)
	    '⌫': 8, backspace: 8,
	    // Tab Key, on Mac: ⇥ (Tab), on Windows ⇥⇥
	    '⇥': 9, '⇆': 9, tab: 9,
	    // Return key, ↩
	    '↩': 13, 'return': 13, enter: 13, '⌅': 13,
	    // Pause/Break key
	    'pause': 19, 'pause-break': 19,
	    // Caps Lock key, ⇪
	    '⇪': 20, caps: 20, 'caps-lock': 20,
	    // Escape key, on Mac: ⎋, on Windows: Esc
	    '⎋': 27, escape: 27, esc: 27,
	    // Space key
	    space: 32,
	    // Page-Up key, or pgup, on Mac: ↖
	    '↖': 33, pgup: 33, 'page-up': 33,
	    // Page-Down key, or pgdown, on Mac: ↘
	    '↘': 34, pgdown: 34, 'page-down': 34,
	    // END key, on Mac: ⇟
	    '⇟': 35, end: 35,
	    // HOME key, on Mac: ⇞
	    '⇞': 36, home: 36,
	    // Insert key, or ins
	    ins: 45, insert: 45,
	    // Delete key, on Mac: ⌦ (Delete)
	    '⌦': 46, del: 46, 'delete': 46,
	    // Left Arrow Key, or ←
	    '←': 37, left: 37, 'arrow-left': 37,
	    // Up Arrow Key, or ↑
	    '↑': 38, up: 38, 'arrow-up': 38,
	    // Right Arrow Key, or →
	    '→': 39, right: 39, 'arrow-right': 39,
	    // Up Arrow Key, or ↓
	    '↓': 40, down: 40, 'arrow-down': 40,
	    // odities, printing characters that come out wrong:
	    // Num-Multiply, or *
	    '*': 106, star: 106, asterisk: 106, multiply: 106,
	    // Num-Plus or +
	    '+': 107, 'plus': 107,
	    // Num-Subtract, or -
	    '-': 109, subtract: 109,
	    // Semicolon
	    ';': 186, semicolon:186,
	    // = or equals
	    '=': 187, 'equals': 187,
	    // Comma, or ,
	    ',': 188, comma: 188,
	    //'-': 189, //???
	    // Period, or ., or full-stop
	    '.': 190, period: 190, 'full-stop': 190,
	    // Slash, or /, or forward-slash
	    '/': 191, slash: 191, 'forward-slash': 191,
	    // Tick, or `, or back-quote
	    '`': 192, tick: 192, 'back-quote': 192,
	    // Open bracket, or [
	    '[': 219, 'open-bracket': 219,
	    // Back slash, or \
	    '\\': 220, 'back-slash': 220,
	    // Close backet, or ]
	    ']': 221, 'close-bracket': 221,
	    // Apostrophe, or Quote, or '
	    '\'': 222, quote: 222, apostrophe: 222
	};
	
	// NUMPAD 0-9
	var i = 95, n = 0;
	while (++i < 106) {
	    keyCodes['num-' + n] = i;
	    ++n;
	}
	
	// 0-9
	i = 47; n = 0;
	while (++i < 58) {
	    keyCodes[n] = i; ++n;
	}
	
	// F1-F25
	i = 111; n = 1;
	while (++i < 136) {
	    keyCodes['f' + n] = i; ++n;
	}
	
	// ;-a-z
	i = 63;
	while (++i < 91) {
	    keyCodes[String.fromCharCode(i).toLowerCase()] = i;
	}
	
	// these non-letter keys imply a shift key on US keyboards
	var shiftEquivalents = [[ '~', '`' ],
	 [ '!', '1' ],
	 [ '@', '2' ],
	 [ '#', '3' ],
	 [ '$', '4' ],
	 [ '%', '5' ],
	 [ '^', '6' ],
	 [ '&', '7' ],
	 [ '*', '8' ],
	 [ '(', '9' ],
	 [ ')', '0' ],
	 [ '_', '-' ],
	 [ '+', '=' ],
	 [ ':', ';' ],
	 [ '\"', '\'' ],
	 [ '<', ',' ],
	 [ '>', '.' ],
	 [ '?', '/' ]
	];
	
	module.exports.unshiftedKeys = shiftEquivalents.reduce(function(memo, key) {
	  memo[keyCodes[key[1]]] = key[0];
	  return memo;
	}, {});
	
	module.exports.shiftedKeys = shiftEquivalents.reduce(function(shiftedKeys, key) {
	  shiftedKeys[key[0]] = keyCodes[key[1]];
	  return shiftedKeys;
	}, {});
	
	module.exports.keyCodes = keyCodes;


/***/ }),
/* 825 */
/***/ (function(module, exports) {

	var blacklist = {
	  INPUT: true,
	  SELECT: true,
	  TEXTAREA: true
	};
	
	module.exports = function(event) {
	  return blacklist[event.target.tagName];
	};


/***/ }),
/* 826 */
/***/ (function(module, exports) {

	/**
	 * Verify if an event checks all the boxes
	 * of an expectation generated by `parse_event.js`
	 * @param {Object} expectation
	 * @param {Event} DOMEvent
	 * @returns {boolean} whether the event matches
	 */
	module.exports = function(expectation, event) {
	    for (var p in expectation) {
	        if (event[p] != expectation[p]) { return false; }
	    }
	    return true;
	};


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	var codes = __webpack_require__(824);
	
	/**
	 * parse a key code given as a string
	 * into an object of expectations used
	 * to match keystrokes.
	 * @param {String} input a string of a keycode combination
	 * @returns {Object} expectations
	 * @example
	 * parseCode('a');
	 */
	module.exports = function parseCode(input) {
	
	    var code = input.toLowerCase()
	        .match(/(?:(?:[^+⇧⌃⌥⌘])+|[⇧⌃⌥⌘]|\+\+|^\+$)/g);
	
	    var event = {
	        keyCode: null,
	        shiftKey: false,
	        ctrlKey: false,
	        altKey: false,
	        metaKey: false
	    };
	
	    for (var i = 0; i < code.length; i++) {
	        // Normalise matching errors
	        if (code[i] === '++') code[i] = '+';
	
	        if (code[i] in codes.modifierCodes) {
	            event[codes.modifierProperties[codes.modifierCodes[code[i]]]] = true;
	        } else if (code[i] in codes.shiftedKeys) {
	            event.keyCode = codes.shiftedKeys[code[i]];
	            event.shiftKey = true;
	        } else if (code[i] in codes.keyCodes) {
	            event.keyCode = codes.keyCodes[code[i]];
	        }
	    }
	
	    return event;
	};


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	var parseCode = __webpack_require__(827);
	
	/**
	 * Given an object of mappings from
	 * keybinding strings to actions,
	 * return an array of parsed keystroke
	 * expectations and actions.
	 * @param {Object} keybindings
	 * @param {Boolean} platformAgnostic convert platform specific keybindgs
	 * @returns {Array<Object>} matchers
	 */
	module.exports = function(keybindings, platformAgnostic) {
	  var matchers = [];
	  for (var code in keybindings) {
	    var event = parseCode(code);
	    matchers.push({
	      expectation: event,
	      action: keybindings[code]
	    });
	    if (platformAgnostic && (event.metaKey ? !event.ctrlKey : event.ctrlKey)) {
	      // meta xor ctrl
	      matchers.push({
	        expectation: {
	          keyCode: event.keyCode,
	          shiftKey: event.shiftKey,
	          ctrlKey: !event.ctrlKey,
	          altKey: event.altKey,
	          metaKey: !event.metaKey
	        },
	        action: keybindings[code]
	      });
	    }
	  }
	  return matchers;
	};


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint -W084 */
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var PathUtils = __webpack_require__(236);
	
	function deepSearch(route, pathname, query) {
	  // Check the subtree first to find the most deeply-nested match.
	  var childRoutes = route.childRoutes;
	  if (childRoutes) {
	    var match, childRoute;
	    for (var i = 0, len = childRoutes.length; i < len; ++i) {
	      childRoute = childRoutes[i];
	
	      if (childRoute.isDefault || childRoute.isNotFound) continue; // Check these in order later.
	
	      if (match = deepSearch(childRoute, pathname, query)) {
	        // A route in the subtree matched! Add this route and we're done.
	        match.routes.unshift(route);
	        return match;
	      }
	    }
	  }
	
	  // No child routes matched; try the default route.
	  var defaultRoute = route.defaultRoute;
	  if (defaultRoute && (params = PathUtils.extractParams(defaultRoute.path, pathname))) return new Match(pathname, params, query, [route, defaultRoute]);
	
	  // Does the "not found" route match?
	  var notFoundRoute = route.notFoundRoute;
	  if (notFoundRoute && (params = PathUtils.extractParams(notFoundRoute.path, pathname))) return new Match(pathname, params, query, [route, notFoundRoute]);
	
	  // Last attempt: check this route.
	  var params = PathUtils.extractParams(route.path, pathname);
	  if (params) return new Match(pathname, params, query, [route]);
	
	  return null;
	}
	
	var Match = (function () {
	  _createClass(Match, null, [{
	    key: 'findMatch',
	
	    /**
	     * Attempts to match depth-first a route in the given route's
	     * subtree against the given path and returns the match if it
	     * succeeds, null if no match can be made.
	     */
	    value: function findMatch(routes, path) {
	      var pathname = PathUtils.withoutQuery(path);
	      var query = PathUtils.extractQuery(path);
	      var match = null;
	
	      for (var i = 0, len = routes.length; match == null && i < len; ++i) match = deepSearch(routes[i], pathname, query);
	
	      return match;
	    }
	  }]);
	
	  function Match(pathname, params, query, routes) {
	    _classCallCheck(this, Match);
	
	    this.pathname = pathname;
	    this.params = params;
	    this.query = query;
	    this.routes = routes;
	  }
	
	  return Match;
	})();
	
	module.exports = Match;

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(69);
	
	/**
	 * A mixin for components that modify the URL.
	 *
	 * Example:
	 *
	 *   var MyLink = React.createClass({
	 *     mixins: [ Router.Navigation ],
	 *     handleClick(event) {
	 *       event.preventDefault();
	 *       this.transitionTo('aRoute', { the: 'params' }, { the: 'query' });
	 *     },
	 *     render() {
	 *       return (
	 *         <a onClick={this.handleClick}>Click me!</a>
	 *       );
	 *     }
	 *   });
	 */
	var Navigation = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns an absolute URL path created from the given route
	   * name, URL parameters, and query values.
	   */
	  makePath: function makePath(to, params, query) {
	    return this.context.router.makePath(to, params, query);
	  },
	
	  /**
	   * Returns a string that may safely be used as the href of a
	   * link to the route with the given name.
	   */
	  makeHref: function makeHref(to, params, query) {
	    return this.context.router.makeHref(to, params, query);
	  },
	
	  /**
	   * Transitions to the URL specified in the arguments by pushing
	   * a new URL onto the history stack.
	   */
	  transitionTo: function transitionTo(to, params, query) {
	    this.context.router.transitionTo(to, params, query);
	  },
	
	  /**
	   * Transitions to the URL specified in the arguments by replacing
	   * the current URL in the history stack.
	   */
	  replaceWith: function replaceWith(to, params, query) {
	    this.context.router.replaceWith(to, params, query);
	  },
	
	  /**
	   * Transitions to the previous URL.
	   */
	  goBack: function goBack() {
	    return this.context.router.goBack();
	  }
	
	};
	
	module.exports = Navigation;

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(67);
	var canUseDOM = __webpack_require__(145);
	var getWindowScrollPosition = __webpack_require__(837);
	
	function shouldUpdateScroll(state, prevState) {
	  if (!prevState) return true;
	
	  // Don't update scroll position when only the query has changed.
	  if (state.pathname === prevState.pathname) return false;
	
	  var routes = state.routes;
	  var prevRoutes = prevState.routes;
	
	  var sharedAncestorRoutes = routes.filter(function (route) {
	    return prevRoutes.indexOf(route) !== -1;
	  });
	
	  return !sharedAncestorRoutes.some(function (route) {
	    return route.ignoreScrollBehavior;
	  });
	}
	
	/**
	 * Provides the router with the ability to manage window scroll position
	 * according to its scroll behavior.
	 */
	var ScrollHistory = {
	
	  statics: {
	
	    /**
	     * Records curent scroll position as the last known position for the given URL path.
	     */
	    recordScrollPosition: function recordScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      this.scrollHistory[path] = getWindowScrollPosition();
	    },
	
	    /**
	     * Returns the last known scroll position for the given URL path.
	     */
	    getScrollPosition: function getScrollPosition(path) {
	      if (!this.scrollHistory) this.scrollHistory = {};
	
	      return this.scrollHistory[path] || null;
	    }
	
	  },
	
	  componentWillMount: function componentWillMount() {
	    invariant(this.constructor.getScrollBehavior() == null || canUseDOM, 'Cannot use scroll behavior without a DOM');
	  },
	
	  componentDidMount: function componentDidMount() {
	    this._updateScroll();
	  },
	
	  componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
	    this._updateScroll(prevState);
	  },
	
	  _updateScroll: function _updateScroll(prevState) {
	    if (!shouldUpdateScroll(this.state, prevState)) return;
	
	    var scrollBehavior = this.constructor.getScrollBehavior();
	
	    if (scrollBehavior) scrollBehavior.updateScrollPosition(this.constructor.getScrollPosition(this.state.path), this.state.action);
	  }
	
	};
	
	module.exports = ScrollHistory;

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var PropTypes = __webpack_require__(69);
	
	/**
	 * A mixin for components that need to know the path, routes, URL
	 * params and query that are currently active.
	 *
	 * Example:
	 *
	 *   var AboutLink = React.createClass({
	 *     mixins: [ Router.State ],
	 *     render() {
	 *       var className = this.props.className;
	 *
	 *       if (this.isActive('about'))
	 *         className += ' is-active';
	 *
	 *       return React.DOM.a({ className: className }, this.props.children);
	 *     }
	 *   });
	 */
	var State = {
	
	  contextTypes: {
	    router: PropTypes.router.isRequired
	  },
	
	  /**
	   * Returns the current URL path.
	   */
	  getPath: function getPath() {
	    return this.context.router.getCurrentPath();
	  },
	
	  /**
	   * Returns the current URL path without the query string.
	   */
	  getPathname: function getPathname() {
	    return this.context.router.getCurrentPathname();
	  },
	
	  /**
	   * Returns an object of the URL params that are currently active.
	   */
	  getParams: function getParams() {
	    return this.context.router.getCurrentParams();
	  },
	
	  /**
	   * Returns an object of the query params that are currently active.
	   */
	  getQuery: function getQuery() {
	    return this.context.router.getCurrentQuery();
	  },
	
	  /**
	   * Returns an array of the routes that are currently active.
	   */
	  getRoutes: function getRoutes() {
	    return this.context.router.getCurrentRoutes();
	  },
	
	  /**
	   * A helper method to determine if a given route, params, and query
	   * are active.
	   */
	  isActive: function isActive(to, params, query) {
	    return this.context.router.isActive(to, params, query);
	  }
	
	};
	
	module.exports = State;

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	/* jshint -W058 */
	
	'use strict';
	
	var Cancellation = __webpack_require__(366);
	var Redirect = __webpack_require__(367);
	
	/**
	 * Encapsulates a transition to a given path.
	 *
	 * The willTransitionTo and willTransitionFrom handlers receive
	 * an instance of this class as their first argument.
	 */
	function Transition(path, retry) {
	  this.path = path;
	  this.abortReason = null;
	  // TODO: Change this to router.retryTransition(transition)
	  this.retry = retry.bind(this);
	}
	
	Transition.prototype.abort = function (reason) {
	  if (this.abortReason == null) this.abortReason = reason || 'ABORT';
	};
	
	Transition.prototype.redirect = function (to, params, query) {
	  this.abort(new Redirect(to, params, query));
	};
	
	Transition.prototype.cancel = function () {
	  this.abort(new Cancellation());
	};
	
	Transition.from = function (transition, routes, components, callback) {
	  routes.reduce(function (callback, route, index) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onLeave) {
	        try {
	          route.onLeave(transition, components[index], callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onLeave.length < 3) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	Transition.to = function (transition, routes, params, query, callback) {
	  routes.reduceRight(function (callback, route) {
	    return function (error) {
	      if (error || transition.abortReason) {
	        callback(error);
	      } else if (route.onEnter) {
	        try {
	          route.onEnter(transition, params, query, callback);
	
	          // If there is no callback in the argument list, call it automatically.
	          if (route.onEnter.length < 4) callback();
	        } catch (e) {
	          callback(e);
	        }
	      } else {
	        callback();
	      }
	    };
	  }, callback)();
	};
	
	module.exports = Transition;

/***/ }),
/* 834 */
/***/ (function(module, exports) {

	/**
	 * A scroll behavior that always scrolls to the top of the page
	 * after a transition.
	 */
	"use strict";
	
	var ScrollToTopBehavior = {
	
	  updateScrollPosition: function updateScrollPosition() {
	    window.scrollTo(0, 0);
	  }
	
	};
	
	module.exports = ScrollToTopBehavior;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * This component is necessary to get around a context warning
	 * present in React 0.13.0. It sovles this by providing a separation
	 * between the "owner" and "parent" contexts.
	 */
	
	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	
	var ContextWrapper = (function (_React$Component) {
	  _inherits(ContextWrapper, _React$Component);
	
	  function ContextWrapper() {
	    _classCallCheck(this, ContextWrapper);
	
	    _get(Object.getPrototypeOf(ContextWrapper.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  _createClass(ContextWrapper, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return ContextWrapper;
	})(React.Component);
	
	module.exports = ContextWrapper;

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(2);
	var assign = __webpack_require__(113);
	var PropTypes = __webpack_require__(69);
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	/**
	 * <Link> components are used to create an <a> element that links to a route.
	 * When that route is active, the link gets an "active" class name (or the
	 * value of its `activeClassName` prop).
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route name="showPost" path="/posts/:postID" handler={Post}/>
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} />
	 *
	 * In addition to params, links may pass along query string parameters
	 * using the `query` prop.
	 *
	 *   <Link to="showPost" params={{ postID: "123" }} query={{ show:true }}/>
	 */
	
	var Link = (function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    _classCallCheck(this, Link);
	
	    _get(Object.getPrototypeOf(Link.prototype), 'constructor', this).apply(this, arguments);
	  }
	
	  // TODO: Include these in the above class definition
	  // once we can use ES7 property initializers.
	  // https://github.com/babel/babel/issues/619
	
	  _createClass(Link, [{
	    key: 'handleClick',
	    value: function handleClick(event) {
	      var allowTransition = true;
	      var clickResult;
	
	      if (this.props.onClick) clickResult = this.props.onClick(event);
	
	      if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	      if (clickResult === false || event.defaultPrevented === true) allowTransition = false;
	
	      event.preventDefault();
	
	      if (allowTransition) this.context.router.transitionTo(this.props.to, this.props.params, this.props.query);
	    }
	
	    /**
	     * Returns the value of the "href" attribute to use on the DOM element.
	     */
	  }, {
	    key: 'getHref',
	    value: function getHref() {
	      return this.context.router.makeHref(this.props.to, this.props.params, this.props.query);
	    }
	
	    /**
	     * Returns the value of the "class" attribute to use on the DOM element, which contains
	     * the value of the activeClassName property when this <Link> is active.
	     */
	  }, {
	    key: 'getClassName',
	    value: function getClassName() {
	      var className = this.props.className;
	
	      if (this.getActiveState()) className += ' ' + this.props.activeClassName;
	
	      return className;
	    }
	  }, {
	    key: 'getActiveState',
	    value: function getActiveState() {
	      return this.context.router.isActive(this.props.to, this.props.params, this.props.query);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var props = assign({}, this.props, {
	        href: this.getHref(),
	        className: this.getClassName(),
	        onClick: this.handleClick.bind(this)
	      });
	
	      if (props.activeStyle && this.getActiveState()) props.style = props.activeStyle;
	
	      delete props.to;
	      delete props.params;
	      delete props.query;
	      delete props.activeClassName;
	      delete props.activeStyle;
	
	      return React.DOM.a(props, this.props.children);
	    }
	  }]);
	
	  return Link;
	})(React.Component);
	
	Link.contextTypes = {
	  router: PropTypes.router.isRequired
	};
	
	Link.propTypes = {
	  activeClassName: PropTypes.string.isRequired,
	  to: PropTypes.oneOfType([PropTypes.string, PropTypes.route]).isRequired,
	  params: PropTypes.object,
	  query: PropTypes.object,
	  activeStyle: PropTypes.object,
	  onClick: PropTypes.func
	};
	
	Link.defaultProps = {
	  activeClassName: 'active',
	  className: ''
	};
	
	module.exports = Link;

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var invariant = __webpack_require__(67);
	var canUseDOM = __webpack_require__(145);
	
	/**
	 * Returns the current scroll position of the window as { x, y }.
	 */
	function getWindowScrollPosition() {
	  invariant(canUseDOM, 'Cannot get current scroll position without a DOM');
	
	  return {
	    x: window.pageXOffset || document.documentElement.scrollLeft,
	    y: window.pageYOffset || document.documentElement.scrollTop
	  };
	}
	
	module.exports = getWindowScrollPosition;

/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2);
	
	function isValidChild(object) {
	  return object == null || React.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	module.exports = isReactChildren;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var invariant = __webpack_require__(67);
	var LocationActions = __webpack_require__(130);
	var History = __webpack_require__(112);
	
	/**
	 * A location that is convenient for testing and does not require a DOM.
	 */
	
	var TestLocation = (function () {
	  function TestLocation(history) {
	    _classCallCheck(this, TestLocation);
	
	    this.history = history || [];
	    this.listeners = [];
	    this.needsDOM = false;
	    this._updateHistoryLength();
	  }
	
	  _createClass(TestLocation, [{
	    key: '_updateHistoryLength',
	    value: function _updateHistoryLength() {
	      History.length = this.history.length;
	    }
	  }, {
	    key: '_notifyChange',
	    value: function _notifyChange(type) {
	      var change = {
	        path: this.getCurrentPath(),
	        type: type
	      };
	
	      for (var i = 0, len = this.listeners.length; i < len; ++i) this.listeners[i].call(this, change);
	    }
	  }, {
	    key: 'addChangeListener',
	    value: function addChangeListener(listener) {
	      this.listeners.push(listener);
	    }
	  }, {
	    key: 'removeChangeListener',
	    value: function removeChangeListener(listener) {
	      this.listeners = this.listeners.filter(function (l) {
	        return l !== listener;
	      });
	    }
	  }, {
	    key: 'push',
	    value: function push(path) {
	      this.history.push(path);
	      this._updateHistoryLength();
	      this._notifyChange(LocationActions.PUSH);
	    }
	  }, {
	    key: 'replace',
	    value: function replace(path) {
	      invariant(this.history.length, 'You cannot replace the current path with no history');
	
	      this.history[this.history.length - 1] = path;
	
	      this._notifyChange(LocationActions.REPLACE);
	    }
	  }, {
	    key: 'pop',
	    value: function pop() {
	      this.history.pop();
	      this._updateHistoryLength();
	      this._notifyChange(LocationActions.POP);
	    }
	  }, {
	    key: 'getCurrentPath',
	    value: function getCurrentPath() {
	      return this.history[this.history.length - 1];
	    }
	  }, {
	    key: 'toString',
	    value: function toString() {
	      return '<TestLocation>';
	    }
	  }]);
	
	  return TestLocation;
	})();
	
	module.exports = TestLocation;

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createRouter = __webpack_require__(372);
	
	/**
	 * A high-level convenience method that creates, configures, and
	 * runs a router in one shot. The method signature is:
	 *
	 *   Router.run(routes[, location ], callback);
	 *
	 * Using `window.location.hash` to manage the URL, you could do:
	 *
	 *   Router.run(routes, function (Handler) {
	 *     React.render(<Handler/>, document.body);
	 *   });
	 * 
	 * Using HTML5 history and a custom "cursor" prop:
	 * 
	 *   Router.run(routes, Router.HistoryLocation, function (Handler) {
	 *     React.render(<Handler cursor={cursor}/>, document.body);
	 *   });
	 *
	 * Returns the newly created router.
	 *
	 * Note: If you need to specify further options for your router such
	 * as error/abort handling or custom scroll behavior, use Router.create
	 * instead.
	 *
	 *   var router = Router.create(options);
	 *   router.run(function (Handler) {
	 *     // ...
	 *   });
	 */
	function runRouter(routes, location, callback) {
	  if (typeof location === 'function') {
	    callback = location;
	    location = null;
	  }
	
	  var router = createRouter({
	    routes: routes,
	    location: location
	  });
	
	  router.run(callback);
	
	  return router;
	}
	
	module.exports = runRouter;

/***/ }),
/* 841 */
/***/ (function(module, exports) {

	'use strict';
	
	function supportsHistory() {
	  /*! taken from modernizr
	   * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	   * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	   * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	   */
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	module.exports = supportsHistory;

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2);
	
	var Value = React.createClass({
	
		displayName: 'Value',
	
		propTypes: {
			disabled: React.PropTypes.bool,
			onOptionLabelClick: React.PropTypes.func,
			onRemove: React.PropTypes.func,
			option: React.PropTypes.object.isRequired,
			optionLabelClick: React.PropTypes.bool,
			renderer: React.PropTypes.func
		},
	
		blockEvent: function blockEvent(event) {
			event.stopPropagation();
		},
	
		handleOnRemove: function handleOnRemove(event) {
			if (!this.props.disabled) {
				this.props.onRemove(event);
			}
		},
	
		render: function render() {
			var label = this.props.option.label;
			if (this.props.renderer) {
				label = this.props.renderer(this.props.option);
			}
	
			if (this.props.optionLabelClick) {
				label = React.createElement(
					'a',
					{ className: 'Select-item-label__a',
						onMouseDown: this.blockEvent,
						onTouchEnd: this.props.onOptionLabelClick,
						onClick: this.props.onOptionLabelClick },
					label
				);
			}
	
			return React.createElement(
				'div',
				{ className: 'Select-item' },
				React.createElement(
					'span',
					{ className: 'Select-item-icon',
						onMouseDown: this.blockEvent,
						onClick: this.handleOnRemove,
						onTouchEnd: this.handleOnRemove },
					'×'
				),
				React.createElement(
					'span',
					{ className: 'Select-item-label' },
					label
				)
			);
		}
	
	});
	
	module.exports = Value;

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(363);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles from "./styles"
	
	var cleanups = {
	  // some useless stuff for us
	  // that svgo doesn't remove
	  title: /<title>.*<\/title>/gi,
	  desc: /<desc>.*<\/desc>/gi,
	  comment: /<!--.*-->/gi,
	  defs: /<defs>.*<\/defs>/gi,
	
	  // remove hardcoded dimensions
	  width: / +width="\d+(\.\d+)?(px)?"/gi,
	  height: / +height="\d+(\.\d+)?(px)?"/gi,
	
	  // remove fill
	  fill: / +fill="(none|#[0-9a-f]+)"/gi,
	
	  // Sketch.app shit
	  sketchMSShapeGroup: / +sketch:type="MSShapeGroup"/gi,
	  sketchMSPage: / +sketch:type="MSPage"/gi,
	  sketchMSLayerGroup: / +sketch:type="MSLayerGroup"/gi
	};
	
	// @styled(styles)
	
	var SVGInline = function (_Component) {
	  _inherits(SVGInline, _Component);
	
	  function SVGInline() {
	    _classCallCheck(this, SVGInline);
	
	    return _possibleConstructorReturn(this, (SVGInline.__proto__ || Object.getPrototypeOf(SVGInline)).apply(this, arguments));
	  }
	
	  _createClass(SVGInline, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          component = _props.component,
	          svg = _props.svg,
	          fill = _props.fill,
	          width = _props.width,
	          accessibilityLabel = _props.accessibilityLabel,
	          accessibilityDesc = _props.accessibilityDesc,
	          classSuffix = _props.classSuffix,
	          cleanupExceptions = _props.cleanupExceptions,
	          componentProps = _objectWithoutProperties(_props, ["className", "component", "svg", "fill", "width", "accessibilityLabel", "accessibilityDesc", "classSuffix", "cleanupExceptions"]);
	
	      var _props2 = this.props,
	          cleanup = _props2.cleanup,
	          height = _props2.height;
	
	
	      if (
	      // simple way to enable entire cleanup
	      cleanup === true ||
	      // passing cleanupExceptions enable cleanup as well
	      cleanup.length === 0 && cleanupExceptions.length > 0) {
	        cleanup = Object.keys(cleanups);
	      }
	      cleanup = cleanup.filter(function (key) {
	        return !(cleanupExceptions.indexOf(key) > -1);
	      });
	
	      if (width && height === undefined) {
	        height = width;
	      }
	
	      // remove useless props for wrapper
	      delete componentProps.cleanup;
	      delete componentProps.height;
	
	      var classes = (0, _classnames2.default)(_defineProperty({
	        SVGInline: true,
	        "SVGInline--cleaned": cleanup.length
	      }, className, className));
	      var svgClasses = classes.split(" ").join(classSuffix + " ") + classSuffix;
	      var svgStr = SVGInline.cleanupSvg(svg, cleanup).replace(/<svg/, "<svg class=\"" + svgClasses + "\"" + (fill ? " fill=\"" + fill + "\"" : "") + (width || height ? ' style="' + (width ? "width: " + width + ";" : "") + (height ? "height: " + height + ";" : "") + '"' : ""));
	      var match = void 0;
	      if (accessibilityDesc) {
	        match = /<svg(.|\n|\r\n)*?>/.exec(svgStr);
	        var pos = match.index + match[0].length;
	        svgStr = svgStr.substr(0, pos) + ("<desc>" + accessibilityDesc + "</desc>") + svgStr.substr(pos);
	      }
	      if (accessibilityLabel) {
	        match = match || /<svg(.|\n|\r\n)*?>/.exec(svgStr);
	        var _pos = match.index + match[0].length - 1;
	        var id = "SVGInline-" + SVGInline.idCount++ + "-title";
	        svgStr = svgStr.substr(0, _pos) + (" role=\"img\" aria-labelledby=\"" + id + "\"") + svgStr.substr(_pos, 1) + ("<title id=\"" + id + "\">" + accessibilityLabel + "</title>") + svgStr.substr(_pos + 1);
	      }
	      return _react2.default.createElement(component, _extends({}, componentProps, { // take most props
	        className: classes,
	        dangerouslySetInnerHTML: {
	          __html: svgStr
	        }
	      }));
	    }
	  }]);
	
	  return SVGInline;
	}(_react.Component);
	
	SVGInline.propTypes = {
	  className: _propTypes2.default.string,
	  classSuffix: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  svg: _propTypes2.default.string.isRequired,
	  fill: _propTypes2.default.string,
	  cleanup: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
	  cleanupExceptions: _propTypes2.default.array,
	  width: _propTypes2.default.string,
	  height: _propTypes2.default.string,
	  accessibilityLabel: _propTypes2.default.string,
	  accessibilityDesc: _propTypes2.default.string
	};
	
	SVGInline.defaultProps = {
	  component: "span",
	  classSuffix: "-svg",
	  cleanup: [],
	  cleanupExceptions: []
	};
	
	SVGInline.idCount = 0;
	
	SVGInline.cleanupSvg = function (svg) {
	  var cleanup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  return Object.keys(cleanups).filter(function (key) {
	    return cleanup.indexOf(key) > -1;
	  }).reduce(function (acc, key) {
	    return acc.replace(cleanups[key], "");
	  }, svg).trim();
	};
	
	exports.default = SVGInline;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015 Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	var EventPropagators = __webpack_require__(133);
	var ExecutionEnvironment = __webpack_require__(30);
	var FallbackCompositionState = __webpack_require__(853);
	var SyntheticCompositionEvent = __webpack_require__(891);
	var SyntheticInputEvent = __webpack_require__(894);
	
	var keyOf = __webpack_require__(74);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = (
	  ExecutionEnvironment.canUseDOM &&
	  'CompositionEvent' in window
	);
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = (
	  ExecutionEnvironment.canUseDOM &&
	  'TextEvent' in window &&
	  !documentMode &&
	  !isPresto()
	);
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = (
	  ExecutionEnvironment.canUseDOM &&
	  (
	    (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11)
	  )
	);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return (
	    typeof opera === 'object' &&
	    typeof opera.version === 'function' &&
	    parseInt(opera.version(), 10) <= 12
	  );
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onBeforeInput: null}),
	      captured: keyOf({onBeforeInputCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topCompositionEnd,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topTextInput,
	      topLevelTypes.topPaste
	    ]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionEnd: null}),
	      captured: keyOf({onCompositionEndCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionEnd,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionStart: null}),
	      captured: keyOf({onCompositionStartCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionStart,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCompositionUpdate: null}),
	      captured: keyOf({onCompositionUpdateCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topCompositionUpdate,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyPress,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topMouseDown
	    ]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (
	    (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	    // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	    !(nativeEvent.ctrlKey && nativeEvent.altKey)
	  );
	}
	
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return (
	    topLevelType === topLevelTypes.topKeyDown &&
	    nativeEvent.keyCode === START_KEYCODE
	  );
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return (END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1);
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return (nativeEvent.keyCode !== START_KEYCODE);
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(
	  topLevelType,
	  topLevelTarget,
	  topLevelTargetID,
	  nativeEvent
	) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(topLevelTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(
	    eventType,
	    topLevelTargetID,
	    nativeEvent
	  );
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (
	      topLevelType === topLevelTypes.topCompositionEnd ||
	      isFallbackCompositionEnd(topLevelType, nativeEvent)
	    ) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {DOMEventTarget} topLevelTarget The listening component root node.
	 * @param {string} topLevelTargetID ID of `topLevelTarget`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(
	  topLevelType,
	  topLevelTarget,
	  topLevelTargetID,
	  nativeEvent
	) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(
	    eventTypes.beforeInput,
	    topLevelTargetID,
	    nativeEvent
	  );
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID,
	    nativeEvent
	  ) {
	    return [
	      extractCompositionEvent(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID,
	        nativeEvent
	      ),
	      extractBeforeInputEvent(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID,
	        nativeEvent
	      )
	    ];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;


/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSCore
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(6);
	
	/**
	 * The CSSCore module specifies the API (and implements most of the methods)
	 * that should be used when dealing with the display of elements (via their
	 * CSS classes and visibility on screen. It is an API focused on mutating the
	 * display and not reading it as no logical state should be encoded in the
	 * display of elements.
	 */
	
	var CSSCore = {
	
	  /**
	   * Adds the class passed in to the element if it doesn't already have it.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  addClass: function(element, className) {
	    ( false ? invariant(
	      !/\s/.test(className),
	      'CSSCore.addClass takes only a single class name. "%s" contains ' +
	      'multiple classes.', className
	    ) : invariant(!/\s/.test(className)));
	
	    if (className) {
	      if (element.classList) {
	        element.classList.add(className);
	      } else if (!CSSCore.hasClass(element, className)) {
	        element.className = element.className + ' ' + className;
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Removes the class passed in from the element
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {DOMElement} the element passed in
	   */
	  removeClass: function(element, className) {
	    ( false ? invariant(
	      !/\s/.test(className),
	      'CSSCore.removeClass takes only a single class name. "%s" contains ' +
	      'multiple classes.', className
	    ) : invariant(!/\s/.test(className)));
	
	    if (className) {
	      if (element.classList) {
	        element.classList.remove(className);
	      } else if (CSSCore.hasClass(element, className)) {
	        element.className = element.className
	          .replace(new RegExp('(^|\\s)' + className + '(?:\\s|$)', 'g'), '$1')
	          .replace(/\s+/g, ' ') // multiple spaces to one
	          .replace(/^\s*|\s*$/g, ''); // trim the ends
	      }
	    }
	    return element;
	  },
	
	  /**
	   * Helper to add or remove a class from an element based on a condition.
	   *
	   * @param {DOMElement} element the element to set the class on
	   * @param {string} className the CSS className
	   * @param {*} bool condition to whether to add or remove the class
	   * @return {DOMElement} the element passed in
	   */
	  conditionClass: function(element, className, bool) {
	    return (bool ? CSSCore.addClass : CSSCore.removeClass)(element, className);
	  },
	
	  /**
	   * Tests whether the element has the class specified.
	   *
	   * @param {DOMNode|DOMWindow} element the element to set the class on
	   * @param {string} className the CSS className
	   * @return {boolean} true if the element has the class, false if not
	   */
	  hasClass: function(element, className) {
	    ( false ? invariant(
	      !/\s/.test(className),
	      'CSS.hasClass takes only a single class name.'
	    ) : invariant(!/\s/.test(className)));
	    if (element.classList) {
	      return !!className && element.classList.contains(className);
	    }
	    return (' ' + element.className + ' ').indexOf(' ' + className + ' ') > -1;
	  }
	
	};
	
	module.exports = CSSCore;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	var EventPluginHub = __webpack_require__(132);
	var EventPropagators = __webpack_require__(133);
	var ExecutionEnvironment = __webpack_require__(30);
	var ReactUpdates = __webpack_require__(62);
	var SyntheticEvent = __webpack_require__(101);
	
	var isEventSupported = __webpack_require__(259);
	var isTextInputElement = __webpack_require__(398);
	var keyOf = __webpack_require__(74);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onChange: null}),
	      captured: keyOf({onChangeCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topChange,
	      topLevelTypes.topClick,
	      topLevelTypes.topFocus,
	      topLevelTypes.topInput,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topKeyUp,
	      topLevelTypes.topSelectionChange
	    ]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementID = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  return (
	    elem.nodeName === 'SELECT' ||
	    (elem.nodeName === 'INPUT' && elem.type === 'file')
	  );
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (
	    (!('documentMode' in document) || document.documentMode > 8)
	  );
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(
	    eventTypes.change,
	    activeElementID,
	    nativeEvent
	  );
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue();
	}
	
	function startWatchingForChangeEventIE8(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementID = null;
	}
	
	function getTargetIDForChangeEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return topLevelTargetID;
	  }
	}
	function handleEventsForChangeEventIE8(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events
	  isInputEventSupported = isEventSupported('input') && (
	    (!('documentMode' in document) || document.documentMode > 9)
	  );
	}
	
	/**
	 * (For old IE.) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp =  {
	  get: function() {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function(val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For old IE.) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetID) {
	  activeElement = target;
	  activeElementID = targetID;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(
	    target.constructor.prototype,
	    'value'
	  );
	
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For old IE.) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementID = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For old IE.) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetIDForInputEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return topLevelTargetID;
	  }
	}
	
	// For IE8 and IE9.
	function handleEventsForInputEventIE(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(topLevelTarget, topLevelTargetID);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetIDForInputEventIE(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topSelectionChange ||
	      topLevelType === topLevelTypes.topKeyUp ||
	      topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementID;
	    }
	  }
	}
	
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return (
	    elem.nodeName === 'INPUT' &&
	    (elem.type === 'checkbox' || elem.type === 'radio')
	  );
	}
	
	function getTargetIDForClickEvent(
	    topLevelType,
	    topLevelTarget,
	    topLevelTargetID) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return topLevelTargetID;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	
	    var getTargetIDFunc, handleEventFunc;
	    if (shouldUseChangeEvent(topLevelTarget)) {
	      if (doesChangeEventBubble) {
	        getTargetIDFunc = getTargetIDForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(topLevelTarget)) {
	      if (isInputEventSupported) {
	        getTargetIDFunc = getTargetIDForInputEvent;
	      } else {
	        getTargetIDFunc = getTargetIDForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(topLevelTarget)) {
	      getTargetIDFunc = getTargetIDForClickEvent;
	    }
	
	    if (getTargetIDFunc) {
	      var targetID = getTargetIDFunc(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID
	      );
	      if (targetID) {
	        var event = SyntheticEvent.getPooled(
	          eventTypes.change,
	          targetID,
	          nativeEvent
	        );
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(
	        topLevelType,
	        topLevelTarget,
	        topLevelTargetID
	      );
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;


/***/ }),
/* 847 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ClientReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	var nextReactRootIndex = 0;
	
	var ClientReactRootIndex = {
	  createReactRootIndex: function() {
	    return nextReactRootIndex++;
	  }
	};
	
	module.exports = ClientReactRootIndex;


/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var Danger = __webpack_require__(849);
	var ReactMultiChildUpdateTypes = __webpack_require__(386);
	
	var setTextContent = __webpack_require__(918);
	var invariant = __webpack_require__(6);
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	function insertChildAt(parentNode, childNode, index) {
	  // By exploiting arrays returning `undefined` for an undefined index, we can
	  // rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. However, using `undefined` is not allowed by all
	  // browsers so we must replace it with `null`.
	  parentNode.insertBefore(
	    childNode,
	    parentNode.childNodes[index] || null
	  );
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: Danger.dangerouslyReplaceNodeWithMarkup,
	
	  updateTextContent: setTextContent,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @param {array<string>} markupList List of markup strings.
	   * @internal
	   */
	  processUpdates: function(updates, markupList) {
	    var update;
	    // Mapping from parent IDs to initial child orderings.
	    var initialChildren = null;
	    // List of children that will be moved or removed.
	    var updatedChildren = null;
	
	    for (var i = 0; i < updates.length; i++) {
	      update = updates[i];
	      if (update.type === ReactMultiChildUpdateTypes.MOVE_EXISTING ||
	          update.type === ReactMultiChildUpdateTypes.REMOVE_NODE) {
	        var updatedIndex = update.fromIndex;
	        var updatedChild = update.parentNode.childNodes[updatedIndex];
	        var parentID = update.parentID;
	
	        ( false ? invariant(
	          updatedChild,
	          'processUpdates(): Unable to find child %s of element. This ' +
	          'probably means the DOM was unexpectedly mutated (e.g., by the ' +
	          'browser), usually due to forgetting a <tbody> when using tables, ' +
	          'nesting tags like <form>, <p>, or <a>, or using non-SVG elements ' +
	          'in an <svg> parent. Try inspecting the child nodes of the element ' +
	          'with React ID `%s`.',
	          updatedIndex,
	          parentID
	        ) : invariant(updatedChild));
	
	        initialChildren = initialChildren || {};
	        initialChildren[parentID] = initialChildren[parentID] || [];
	        initialChildren[parentID][updatedIndex] = updatedChild;
	
	        updatedChildren = updatedChildren || [];
	        updatedChildren.push(updatedChild);
	      }
	    }
	
	    var renderedMarkup = Danger.dangerouslyRenderMarkup(markupList);
	
	    // Remove updated children first so that `toIndex` is consistent.
	    if (updatedChildren) {
	      for (var j = 0; j < updatedChildren.length; j++) {
	        updatedChildren[j].parentNode.removeChild(updatedChildren[j]);
	      }
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertChildAt(
	            update.parentNode,
	            renderedMarkup[update.markupIndex],
	            update.toIndex
	          );
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          insertChildAt(
	            update.parentNode,
	            initialChildren[update.parentID][update.fromIndex],
	            update.toIndex
	          );
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(
	            update.parentNode,
	            update.textContent
	          );
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          // Already removed by the for-loop above.
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 * @typechecks static-only
	 */
	
	/*jslint evil: true, sub: true */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var createNodesFromMarkup = __webpack_require__(904);
	var emptyFunction = __webpack_require__(63);
	var getMarkupWrap = __webpack_require__(395);
	var invariant = __webpack_require__(6);
	
	var OPEN_TAG_NAME_EXP = /^(<[^ \/>]+)/;
	var RESULT_INDEX_ATTR = 'data-danger-index';
	
	/**
	 * Extracts the `nodeName` from a string of markup.
	 *
	 * NOTE: Extracting the `nodeName` does not require a regular expression match
	 * because we make assumptions about React-generated markup (i.e. there are no
	 * spaces surrounding the opening tag and there is at least one attribute).
	 *
	 * @param {string} markup String of markup.
	 * @return {string} Node name of the supplied markup.
	 * @see http://jsperf.com/extract-nodename
	 */
	function getNodeName(markup) {
	  return markup.substring(1, markup.indexOf(' '));
	}
	
	var Danger = {
	
	  /**
	   * Renders markup into an array of nodes. The markup is expected to render
	   * into a list of root nodes. Also, the length of `resultList` and
	   * `markupList` should be the same.
	   *
	   * @param {array<string>} markupList List of markup strings to render.
	   * @return {array<DOMElement>} List of rendered nodes.
	   * @internal
	   */
	  dangerouslyRenderMarkup: function(markupList) {
	    ( false ? invariant(
	      ExecutionEnvironment.canUseDOM,
	      'dangerouslyRenderMarkup(...): Cannot render markup in a worker ' +
	      'thread. Make sure `window` and `document` are available globally ' +
	      'before requiring React when unit testing or use ' +
	      'React.renderToString for server rendering.'
	    ) : invariant(ExecutionEnvironment.canUseDOM));
	    var nodeName;
	    var markupByNodeName = {};
	    // Group markup by `nodeName` if a wrap is necessary, else by '*'.
	    for (var i = 0; i < markupList.length; i++) {
	      ( false ? invariant(
	        markupList[i],
	        'dangerouslyRenderMarkup(...): Missing markup.'
	      ) : invariant(markupList[i]));
	      nodeName = getNodeName(markupList[i]);
	      nodeName = getMarkupWrap(nodeName) ? nodeName : '*';
	      markupByNodeName[nodeName] = markupByNodeName[nodeName] || [];
	      markupByNodeName[nodeName][i] = markupList[i];
	    }
	    var resultList = [];
	    var resultListAssignmentCount = 0;
	    for (nodeName in markupByNodeName) {
	      if (!markupByNodeName.hasOwnProperty(nodeName)) {
	        continue;
	      }
	      var markupListByNodeName = markupByNodeName[nodeName];
	
	      // This for-in loop skips the holes of the sparse array. The order of
	      // iteration should follow the order of assignment, which happens to match
	      // numerical index order, but we don't rely on that.
	      var resultIndex;
	      for (resultIndex in markupListByNodeName) {
	        if (markupListByNodeName.hasOwnProperty(resultIndex)) {
	          var markup = markupListByNodeName[resultIndex];
	
	          // Push the requested markup with an additional RESULT_INDEX_ATTR
	          // attribute.  If the markup does not start with a < character, it
	          // will be discarded below (with an appropriate console.error).
	          markupListByNodeName[resultIndex] = markup.replace(
	            OPEN_TAG_NAME_EXP,
	            // This index will be parsed back out below.
	            '$1 ' + RESULT_INDEX_ATTR + '="' + resultIndex + '" '
	          );
	        }
	      }
	
	      // Render each group of markup with similar wrapping `nodeName`.
	      var renderNodes = createNodesFromMarkup(
	        markupListByNodeName.join(''),
	        emptyFunction // Do nothing special with <script> tags.
	      );
	
	      for (var j = 0; j < renderNodes.length; ++j) {
	        var renderNode = renderNodes[j];
	        if (renderNode.hasAttribute &&
	            renderNode.hasAttribute(RESULT_INDEX_ATTR)) {
	
	          resultIndex = +renderNode.getAttribute(RESULT_INDEX_ATTR);
	          renderNode.removeAttribute(RESULT_INDEX_ATTR);
	
	          ( false ? invariant(
	            !resultList.hasOwnProperty(resultIndex),
	            'Danger: Assigning to an already-occupied result index.'
	          ) : invariant(!resultList.hasOwnProperty(resultIndex)));
	
	          resultList[resultIndex] = renderNode;
	
	          // This should match resultList.length and markupList.length when
	          // we're done.
	          resultListAssignmentCount += 1;
	
	        } else if (false) {
	          console.error(
	            'Danger: Discarding unexpected node:',
	            renderNode
	          );
	        }
	      }
	    }
	
	    // Although resultList was populated out of order, it should now be a dense
	    // array.
	    ( false ? invariant(
	      resultListAssignmentCount === resultList.length,
	      'Danger: Did not assign to every index of resultList.'
	    ) : invariant(resultListAssignmentCount === resultList.length));
	
	    ( false ? invariant(
	      resultList.length === markupList.length,
	      'Danger: Expected markup to render %s nodes, but rendered %s.',
	      markupList.length,
	      resultList.length
	    ) : invariant(resultList.length === markupList.length));
	
	    return resultList;
	  },
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function(oldChild, markup) {
	    ( false ? invariant(
	      ExecutionEnvironment.canUseDOM,
	      'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a ' +
	      'worker thread. Make sure `window` and `document` are available ' +
	      'globally before requiring React when unit testing or use ' +
	      'React.renderToString for server rendering.'
	    ) : invariant(ExecutionEnvironment.canUseDOM));
	    ( false ? invariant(markup, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : invariant(markup));
	    ( false ? invariant(
	      oldChild.tagName.toLowerCase() !== 'html',
	      'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the ' +
	      '<html> node. This is because browser quirks make this unreliable ' +
	      'and/or slow. If you want to render to the root you must use ' +
	      'server rendering. See React.renderToString().'
	    ) : invariant(oldChild.tagName.toLowerCase() !== 'html'));
	
	    var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	    oldChild.parentNode.replaceChild(newChild, oldChild);
	  }
	
	};
	
	module.exports = Danger;


/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(74);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [
	  keyOf({ResponderEventPlugin: null}),
	  keyOf({SimpleEventPlugin: null}),
	  keyOf({TapEventPlugin: null}),
	  keyOf({EnterLeaveEventPlugin: null}),
	  keyOf({ChangeEventPlugin: null}),
	  keyOf({SelectEventPlugin: null}),
	  keyOf({BeforeInputEventPlugin: null}),
	  keyOf({AnalyticsEventPlugin: null}),
	  keyOf({MobileSafariClickEventPlugin: null})
	];
	
	module.exports = DefaultEventPluginOrder;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	var EventPropagators = __webpack_require__(133);
	var SyntheticMouseEvent = __webpack_require__(174);
	
	var ReactMount = __webpack_require__(73);
	var keyOf = __webpack_require__(74);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	var getFirstReactDOM = ReactMount.getFirstReactDOM;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({onMouseEnter: null}),
	    dependencies: [
	      topLevelTypes.topMouseOut,
	      topLevelTypes.topMouseOver
	    ]
	  },
	  mouseLeave: {
	    registrationName: keyOf({onMouseLeave: null}),
	    dependencies: [
	      topLevelTypes.topMouseOut,
	      topLevelTypes.topMouseOver
	    ]
	  }
	};
	
	var extractedEvents = [null, null];
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    if (topLevelType === topLevelTypes.topMouseOver &&
	        (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut &&
	        topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (topLevelTarget.window === topLevelTarget) {
	      // `topLevelTarget` is probably a window object.
	      win = topLevelTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = topLevelTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from, to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = topLevelTarget;
	      to =
	        getFirstReactDOM(nativeEvent.relatedTarget || nativeEvent.toElement) ||
	        win;
	    } else {
	      from = win;
	      to = topLevelTarget;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromID = from ? ReactMount.getID(from) : '';
	    var toID = to ? ReactMount.getID(to) : '';
	
	    var leave = SyntheticMouseEvent.getPooled(
	      eventTypes.mouseLeave,
	      fromID,
	      nativeEvent
	    );
	    leave.type = 'mouseleave';
	    leave.target = from;
	    leave.relatedTarget = to;
	
	    var enter = SyntheticMouseEvent.getPooled(
	      eventTypes.mouseEnter,
	      toID,
	      nativeEvent
	    );
	    enter.type = 'mouseenter';
	    enter.target = to;
	    enter.relatedTarget = from;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, fromID, toID);
	
	    extractedEvents[0] = leave;
	    extractedEvents[1] = enter;
	
	    return extractedEvents;
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule EventListener
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(63);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function(target, eventType, callback) {
	    if (!target.addEventListener) {
	      if (false) {
	        console.error(
	          'Attempted to listen to events during the capture phase on a ' +
	          'browser that does not support the capture phase. Your application ' +
	          'will not receive some events.'
	        );
	      }
	      return {
	        remove: emptyFunction
	      };
	    } else {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    }
	  },
	
	  registerDefault: function() {}
	};
	
	module.exports = EventListener;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(70);
	
	var assign = __webpack_require__(11);
	var getTextContentAccessor = __webpack_require__(396);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	assign(FallbackCompositionState.prototype, {
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function() {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function() {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	/*jslint bitwise: true*/
	
	'use strict';
	
	var DOMProperty = __webpack_require__(114);
	var ExecutionEnvironment = __webpack_require__(30);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_SIDE_EFFECTS = DOMProperty.injection.HAS_SIDE_EFFECTS;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE =
	  DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE =
	  DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var hasSVG;
	if (ExecutionEnvironment.canUseDOM) {
	  var implementation = document.implementation;
	  hasSVG = (
	    implementation &&
	    implementation.hasFeature &&
	    implementation.hasFeature(
	      'http://www.w3.org/TR/SVG11/feature#BasicStructure',
	      '1.1'
	    )
	  );
	}
	
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(
	    /^(data|aria)-[a-z_][a-z\d_.\-]*$/
	  ),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: null,
	    acceptCharset: null,
	    accessKey: null,
	    action: null,
	    allowFullScreen: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    allowTransparency: MUST_USE_ATTRIBUTE,
	    alt: null,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: null,
	    // autoFocus is polyfilled/normalized by AutoFocusMixin
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    cellPadding: null,
	    cellSpacing: null,
	    charSet: MUST_USE_ATTRIBUTE,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    classID: MUST_USE_ATTRIBUTE,
	    // To set className on SVG elements, it's necessary to use .setAttribute;
	    // this works on HTML elements too in all browsers except IE8. Conveniently,
	    // IE8 doesn't support SVG and so we can simply use the attribute in
	    // browsers that support SVG and the property in browsers that don't,
	    // regardless of whether the element is HTML or SVG.
	    className: hasSVG ? MUST_USE_ATTRIBUTE : MUST_USE_PROPERTY,
	    cols: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: null,
	    content: null,
	    contentEditable: null,
	    contextMenu: MUST_USE_ATTRIBUTE,
	    controls: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    coords: null,
	    crossOrigin: null,
	    data: null, // For `<object />` acts as `src`.
	    dateTime: MUST_USE_ATTRIBUTE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: null,
	    disabled: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: null,
	    encType: null,
	    form: MUST_USE_ATTRIBUTE,
	    formAction: MUST_USE_ATTRIBUTE,
	    formEncType: MUST_USE_ATTRIBUTE,
	    formMethod: MUST_USE_ATTRIBUTE,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: MUST_USE_ATTRIBUTE,
	    frameBorder: MUST_USE_ATTRIBUTE,
	    headers: null,
	    height: MUST_USE_ATTRIBUTE,
	    hidden: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    high: null,
	    href: null,
	    hrefLang: null,
	    htmlFor: null,
	    httpEquiv: null,
	    icon: null,
	    id: MUST_USE_PROPERTY,
	    label: null,
	    lang: null,
	    list: MUST_USE_ATTRIBUTE,
	    loop: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    low: null,
	    manifest: MUST_USE_ATTRIBUTE,
	    marginHeight: null,
	    marginWidth: null,
	    max: null,
	    maxLength: MUST_USE_ATTRIBUTE,
	    media: MUST_USE_ATTRIBUTE,
	    mediaGroup: null,
	    method: null,
	    min: null,
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: null,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: null,
	    pattern: null,
	    placeholder: null,
	    poster: null,
	    preload: null,
	    radioGroup: null,
	    readOnly: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    rel: null,
	    required: HAS_BOOLEAN_VALUE,
	    role: MUST_USE_ATTRIBUTE,
	    rows: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: null,
	    sandbox: null,
	    scope: null,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: null,
	    seamless: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: null,
	    size: MUST_USE_ATTRIBUTE | HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: MUST_USE_ATTRIBUTE,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: null,
	    src: null,
	    srcDoc: MUST_USE_PROPERTY,
	    srcSet: MUST_USE_ATTRIBUTE,
	    start: HAS_NUMERIC_VALUE,
	    step: null,
	    style: null,
	    tabIndex: null,
	    target: null,
	    title: null,
	    type: null,
	    useMap: null,
	    value: MUST_USE_PROPERTY | HAS_SIDE_EFFECTS,
	    width: MUST_USE_ATTRIBUTE,
	    wmode: MUST_USE_ATTRIBUTE,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: null,
	    autoCorrect: null,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: MUST_USE_ATTRIBUTE,
	    itemScope: MUST_USE_ATTRIBUTE | HAS_BOOLEAN_VALUE,
	    itemType: MUST_USE_ATTRIBUTE,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: MUST_USE_ATTRIBUTE,
	    itemRef: MUST_USE_ATTRIBUTE,
	    // property is supported for OpenGraph in meta tags.
	    property: null,
	    // IE-only attribute that controls focus behavior
	    unselectable: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {
	    autoCapitalize: 'autocapitalize',
	    autoComplete: 'autocomplete',
	    autoCorrect: 'autocorrect',
	    autoFocus: 'autofocus',
	    autoPlay: 'autoplay',
	    // `encoding` is equivalent to `enctype`, IE8 lacks an `enctype` setter.
	    // http://www.w3.org/TR/html5/forms.html#dom-fs-encoding
	    encType: 'encoding',
	    hrefLang: 'hreflang',
	    radioGroup: 'radiogroup',
	    spellCheck: 'spellcheck',
	    srcDoc: 'srcdoc',
	    srcSet: 'srcset'
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule MobileSafariClickEventPlugin
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	
	var emptyFunction = __webpack_require__(63);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	/**
	 * Mobile Safari does not fire properly bubble click events on non-interactive
	 * elements, which means delegated click listeners do not fire. The workaround
	 * for this bug involves attaching an empty click listener on the target node.
	 *
	 * This particular plugin works around the bug by attaching an empty click
	 * listener on `touchstart` (which does fire on every element).
	 */
	var MobileSafariClickEventPlugin = {
	
	  eventTypes: null,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    if (topLevelType === topLevelTypes.topTouchStart) {
	      var target = nativeEvent.target;
	      if (target && !target.onclick) {
	        target.onclick = emptyFunction;
	      }
	    }
	  }
	
	};
	
	module.exports = MobileSafariClickEventPlugin;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(171);
	
	var assign = __webpack_require__(11);
	
	var ReactTransitionGroup = React.createFactory(
	  __webpack_require__(885)
	);
	var ReactCSSTransitionGroupChild = React.createFactory(
	  __webpack_require__(857)
	);
	
	var ReactCSSTransitionGroup = React.createClass({
	  displayName: 'ReactCSSTransitionGroup',
	
	  propTypes: {
	    transitionName: React.PropTypes.string.isRequired,
	    transitionAppear: React.PropTypes.bool,
	    transitionEnter: React.PropTypes.bool,
	    transitionLeave: React.PropTypes.bool
	  },
	
	  getDefaultProps: function() {
	    return {
	      transitionAppear: false,
	      transitionEnter: true,
	      transitionLeave: true
	    };
	  },
	
	  _wrapChild: function(child) {
	    // We need to provide this childFactory so that
	    // ReactCSSTransitionGroupChild can receive updates to name, enter, and
	    // leave while it is leaving.
	    return ReactCSSTransitionGroupChild(
	      {
	        name: this.props.transitionName,
	        appear: this.props.transitionAppear,
	        enter: this.props.transitionEnter,
	        leave: this.props.transitionLeave
	      },
	      child
	    );
	  },
	
	  render: function() {
	    return (
	      ReactTransitionGroup(
	        assign({}, this.props, {childFactory: this._wrapChild})
	      )
	    );
	  }
	});
	
	module.exports = ReactCSSTransitionGroup;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * @providesModule ReactCSSTransitionGroupChild
	 */
	
	'use strict';
	
	var React = __webpack_require__(171);
	
	var CSSCore = __webpack_require__(845);
	var ReactTransitionEvents = __webpack_require__(884);
	
	var onlyChild = __webpack_require__(399);
	var warning = __webpack_require__(17);
	
	// We don't remove the element from the DOM until we receive an animationend or
	// transitionend event. If the user screws up and forgets to add an animation
	// their node will be stuck in the DOM forever, so we detect if an animation
	// does not start and if it doesn't, we just call the end listener immediately.
	var TICK = 17;
	var NO_EVENT_TIMEOUT = 5000;
	
	var noEventListener = null;
	
	
	if (false) {
	  noEventListener = function() {
	    ("production" !== process.env.NODE_ENV ? warning(
	      false,
	      'transition(): tried to perform an animation without ' +
	      'an animationend or transitionend event after timeout (' +
	      '%sms). You should either disable this ' +
	      'transition in JS or add a CSS animation/transition.',
	      NO_EVENT_TIMEOUT
	    ) : null);
	  };
	}
	
	var ReactCSSTransitionGroupChild = React.createClass({
	  displayName: 'ReactCSSTransitionGroupChild',
	
	  transition: function(animationType, finishCallback) {
	    var node = this.getDOMNode();
	    var className = this.props.name + '-' + animationType;
	    var activeClassName = className + '-active';
	    var noEventTimeout = null;
	
	    var endListener = function(e) {
	      if (e && e.target !== node) {
	        return;
	      }
	      if (false) {
	        clearTimeout(noEventTimeout);
	      }
	
	      CSSCore.removeClass(node, className);
	      CSSCore.removeClass(node, activeClassName);
	
	      ReactTransitionEvents.removeEndEventListener(node, endListener);
	
	      // Usually this optional callback is used for informing an owner of
	      // a leave animation and telling it to remove the child.
	      if (finishCallback) {
	        finishCallback();
	      }
	    };
	
	    ReactTransitionEvents.addEndEventListener(node, endListener);
	
	    CSSCore.addClass(node, className);
	
	    // Need to do this to actually trigger a transition.
	    this.queueClass(activeClassName);
	
	    if (false) {
	      noEventTimeout = setTimeout(noEventListener, NO_EVENT_TIMEOUT);
	    }
	  },
	
	  queueClass: function(className) {
	    this.classNameQueue.push(className);
	
	    if (!this.timeout) {
	      this.timeout = setTimeout(this.flushClassNameQueue, TICK);
	    }
	  },
	
	  flushClassNameQueue: function() {
	    if (this.isMounted()) {
	      this.classNameQueue.forEach(
	        CSSCore.addClass.bind(CSSCore, this.getDOMNode())
	      );
	    }
	    this.classNameQueue.length = 0;
	    this.timeout = null;
	  },
	
	  componentWillMount: function() {
	    this.classNameQueue = [];
	  },
	
	  componentWillUnmount: function() {
	    if (this.timeout) {
	      clearTimeout(this.timeout);
	    }
	  },
	
	  componentWillAppear: function(done) {
	    if (this.props.appear) {
	      this.transition('appear', done);
	    } else {
	      done();
	    }
	  },
	
	  componentWillEnter: function(done) {
	    if (this.props.enter) {
	      this.transition('enter', done);
	    } else {
	      done();
	    }
	  },
	
	  componentWillLeave: function(done) {
	    if (this.props.leave) {
	      this.transition('leave', done);
	    } else {
	      done();
	    }
	  },
	
	  render: function() {
	    return onlyChild(this.props.children);
	  }
	});
	
	module.exports = ReactCSSTransitionGroupChild;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(118);
	
	var flattenChildren = __webpack_require__(906);
	var instantiateReactComponent = __webpack_require__(258);
	var shouldUpdateReactComponent = __webpack_require__(261);
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function(nestedChildNodes, transaction, context) {
	    var children = flattenChildren(nestedChildNodes);
	    for (var name in children) {
	      if (children.hasOwnProperty(name)) {
	        var child = children[name];
	        // The rendered children must be turned into instances as they're
	        // mounted.
	        var childInstance = instantiateReactComponent(child, null);
	        children[name] = childInstance;
	      }
	    }
	    return children;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextNestedChildNodes Nested child maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function(
	    prevChildren,
	    nextNestedChildNodes,
	    transaction,
	    context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    var nextChildren = flattenChildren(nextNestedChildNodes);
	    if (!nextChildren && !prevChildren) {
	      return null;
	    }
	    var name;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      var prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(
	          prevChild, nextElement, transaction, context
	        );
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          ReactReconciler.unmountComponent(prevChild, name);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(
	          nextElement,
	          null
	        );
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) &&
	          !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        ReactReconciler.unmountComponent(prevChildren[name]);
	      }
	    }
	    return nextChildren;
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function(renderedChildren) {
	    for (var name in renderedChildren) {
	      var renderedChild = renderedChildren[name];
	      ReactReconciler.unmountComponent(renderedChild);
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(245);
	var ReactContext = __webpack_require__(246);
	var ReactCurrentOwner = __webpack_require__(72);
	var ReactElement = __webpack_require__(16);
	var ReactElementValidator = __webpack_require__(134);
	var ReactInstanceMap = __webpack_require__(117);
	var ReactLifeCycle = __webpack_require__(249);
	var ReactNativeComponent = __webpack_require__(172);
	var ReactPerf = __webpack_require__(100);
	var ReactPropTypeLocations = __webpack_require__(250);
	var ReactPropTypeLocationNames = __webpack_require__(173);
	var ReactReconciler = __webpack_require__(118);
	var ReactUpdates = __webpack_require__(62);
	
	var assign = __webpack_require__(11);
	var emptyObject = __webpack_require__(176);
	var invariant = __webpack_require__(6);
	var shouldUpdateReactComponent = __webpack_require__(261);
	var warning = __webpack_require__(17);
	
	function getDeclarationErrorAddendum(component) {
	  var owner = component._currentElement._owner || null;
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function(element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	
	    // See ReactUpdateQueue
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedComponent = null;
	
	    this._context = null;
	    this._mountOrder = 0;
	    this._isTopLevel = false;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {string} rootID DOM ID of the root node.
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function(rootID, transaction, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._rootNodeID = rootID;
	
	    var publicProps = this._processProps(this._currentElement.props);
	    var publicContext = this._processContext(this._currentElement._context);
	
	    var Component = ReactNativeComponent.getComponentClassForElement(
	      this._currentElement
	    );
	
	    // Initialize the public class
	    var inst = new Component(publicProps, publicContext);
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      ("production" !== process.env.NODE_ENV ? warning(
	        inst.render != null,
	        '%s(...): No `render` method found on the returned component ' +
	        'instance: you may have forgotten to define `render` in your ' +
	        'component or you may have accidentally tried to render an element ' +
	        'whose type is a function that isn\'t a React component.',
	        Component.displayName || Component.name || 'Component'
	      ) : null);
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      this._warnIfContextsDiffer(this._currentElement._context, context);
	    }
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.getInitialState ||
	        inst.getInitialState.isReactClassApproved,
	        'getInitialState was defined on %s, a plain JavaScript class. ' +
	        'This is only supported for classes created using React.createClass. ' +
	        'Did you mean to define a state property instead?',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.getDefaultProps ||
	        inst.getDefaultProps.isReactClassApproved,
	        'getDefaultProps was defined on %s, a plain JavaScript class. ' +
	        'This is only supported for classes created using React.createClass. ' +
	        'Use a static property to define defaultProps instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.propTypes,
	        'propTypes was defined as an instance property on %s. Use a static ' +
	        'property to define propTypes instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        !inst.contextTypes,
	        'contextTypes was defined as an instance property on %s. Use a ' +
	        'static property to define contextTypes instead.',
	        this.getName() || 'a component'
	      ) : null);
	      ("production" !== process.env.NODE_ENV ? warning(
	        typeof inst.componentShouldUpdate !== 'function',
	        '%s has a method called ' +
	        'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	        'The name is phrased as a question because the function is ' +
	        'expected to return a value.',
	        (this.getName() || 'A component')
	      ) : null);
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    ( false ? invariant(
	      typeof initialState === 'object' && !Array.isArray(initialState),
	      '%s.state: must be set to an object or null',
	      this.getName() || 'ReactCompositeComponent'
	    ) : invariant(typeof initialState === 'object' && !Array.isArray(initialState)));
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var childContext;
	    var renderedElement;
	
	    var previouslyMounting = ReactLifeCycle.currentlyMountingInstance;
	    ReactLifeCycle.currentlyMountingInstance = this;
	    try {
	      if (inst.componentWillMount) {
	        inst.componentWillMount();
	        // When mounting, calls to `setState` by `componentWillMount` will set
	        // `this._pendingStateQueue` without triggering a re-render.
	        if (this._pendingStateQueue) {
	          inst.state = this._processPendingState(inst.props, inst.context);
	        }
	      }
	
	      childContext = this._getValidatedChildContext(context);
	      renderedElement = this._renderValidatedComponent(childContext);
	    } finally {
	      ReactLifeCycle.currentlyMountingInstance = previouslyMounting;
	    }
	
	    this._renderedComponent = this._instantiateReactComponent(
	      renderedElement,
	      this._currentElement.type // The wrapping type
	    );
	
	    var markup = ReactReconciler.mountComponent(
	      this._renderedComponent,
	      rootID,
	      transaction,
	      this._mergeChildContext(context, childContext)
	    );
	    if (inst.componentDidMount) {
	      transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	    }
	
	    return markup;
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function() {
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount) {
	      var previouslyUnmounting = ReactLifeCycle.currentlyUnmountingInstance;
	      ReactLifeCycle.currentlyUnmountingInstance = this;
	      try {
	        inst.componentWillUnmount();
	      } finally {
	        ReactLifeCycle.currentlyUnmountingInstance = previouslyUnmounting;
	      }
	    }
	
	    ReactReconciler.unmountComponent(this._renderedComponent);
	    this._renderedComponent = null;
	
	    // Reset pending fields
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Schedule a partial update to the props. Only used for internal testing.
	   *
	   * @param {object} partialProps Subset of the next props.
	   * @param {?function} callback Called after props are updated.
	   * @final
	   * @internal
	   */
	  _setPropsInternal: function(partialProps, callback) {
	    // This is a deoptimized path. We optimize for always having an element.
	    // This creates an extra internal element.
	    var element = this._pendingElement || this._currentElement;
	    this._pendingElement = ReactElement.cloneAndReplaceProps(
	      element,
	      assign({}, element.props, partialProps)
	    );
	    ReactUpdates.enqueueUpdate(this, callback);
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function(context) {
	    var maskedContext = null;
	    // This really should be getting the component class for the element,
	    // but we know that we're not going to need it for built-ins.
	    if (typeof this._currentElement.type === 'string') {
	      return emptyObject;
	    }
	    var contextTypes = this._currentElement.type.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function(context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = ReactNativeComponent.getComponentClassForElement(
	        this._currentElement
	      );
	      if (Component.contextTypes) {
	        this._checkPropTypes(
	          Component.contextTypes,
	          maskedContext,
	          ReactPropTypeLocations.context
	        );
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _getValidatedChildContext: function(currentContext) {
	    var inst = this._instance;
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (childContext) {
	      ( false ? invariant(
	        typeof inst.constructor.childContextTypes === 'object',
	        '%s.getChildContext(): childContextTypes must be defined in order to ' +
	        'use getChildContext().',
	        this.getName() || 'ReactCompositeComponent'
	      ) : invariant(typeof inst.constructor.childContextTypes === 'object'));
	      if (false) {
	        this._checkPropTypes(
	          inst.constructor.childContextTypes,
	          childContext,
	          ReactPropTypeLocations.childContext
	        );
	      }
	      for (var name in childContext) {
	        ( false ? invariant(
	          name in inst.constructor.childContextTypes,
	          '%s.getChildContext(): key "%s" is not defined in childContextTypes.',
	          this.getName() || 'ReactCompositeComponent',
	          name
	        ) : invariant(name in inst.constructor.childContextTypes));
	      }
	      return childContext;
	    }
	    return null;
	  },
	
	  _mergeChildContext: function(currentContext, childContext) {
	    if (childContext) {
	      return assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Processes props by setting default values for unspecified props and
	   * asserting that the props are valid. Does not mutate its argument; returns
	   * a new props object with defaults merged in.
	   *
	   * @param {object} newProps
	   * @return {object}
	   * @private
	   */
	  _processProps: function(newProps) {
	    if (false) {
	      var Component = ReactNativeComponent.getComponentClassForElement(
	        this._currentElement
	      );
	      if (Component.propTypes) {
	        this._checkPropTypes(
	          Component.propTypes,
	          newProps,
	          ReactPropTypeLocations.prop
	        );
	      }
	    }
	    return newProps;
	  },
	
	  /**
	   * Assert that the props are valid
	   *
	   * @param {object} propTypes Map of prop name to a ReactPropType
	   * @param {object} props
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkPropTypes: function(propTypes, props, location) {
	    // TODO: Stop validating prop types here and only use the element
	    // validation.
	    var componentName = this.getName();
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error;
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          ( false ? invariant(
	            typeof propTypes[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually ' +
	            'from React.PropTypes.',
	            componentName || 'React class',
	            ReactPropTypeLocationNames[location],
	            propName
	          ) : invariant(typeof propTypes[propName] === 'function'));
	          error = propTypes[propName](props, propName, componentName, location);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error instanceof Error) {
	          // We may want to extend this logic for similar errors in
	          // React.render calls, so I'm abstracting it away into
	          // a function to minimize refactoring in the future
	          var addendum = getDeclarationErrorAddendum(this);
	
	          if (location === ReactPropTypeLocations.prop) {
	            // Preface gives us something to blacklist in warning module
	            ( false ? warning(
	              false,
	              'Failed Composite propType: %s%s',
	              error.message,
	              addendum
	            ) : null);
	          } else {
	            ( false ? warning(
	              false,
	              'Failed Context Types: %s%s',
	              error.message,
	              addendum
	            ) : null);
	          }
	        }
	      }
	    }
	  },
	
	  receiveComponent: function(nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(
	      transaction,
	      prevElement,
	      nextElement,
	      prevContext,
	      nextContext
	    );
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function(transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(
	        this,
	        this._pendingElement || this._currentElement,
	        transaction,
	        this._context
	      );
	    }
	
	    if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      if (false) {
	        ReactElementValidator.checkAndWarnForMutatedProps(
	          this._currentElement
	        );
	      }
	
	      this.updateComponent(
	        transaction,
	        this._currentElement,
	        this._currentElement,
	        this._context,
	        this._context
	      );
	    }
	  },
	
	  /**
	   * Compare two contexts, warning if they are different
	   * TODO: Remove this check when owner-context is removed
	   */
	   _warnIfContextsDiffer: function(ownerBasedContext, parentBasedContext) {
	    ownerBasedContext = this._maskContext(ownerBasedContext);
	    parentBasedContext = this._maskContext(parentBasedContext);
	    var parentKeys = Object.keys(parentBasedContext).sort();
	    var displayName = this.getName() || 'ReactCompositeComponent';
	    for (var i = 0; i < parentKeys.length; i++) {
	      var key = parentKeys[i];
	      ( false ? warning(
	        ownerBasedContext[key] === parentBasedContext[key],
	        'owner-based and parent-based contexts differ '  +
	        '(values: `%s` vs `%s`) for key (%s) while mounting %s ' +
	        '(see: http://fb.me/react-context-by-parent)',
	        ownerBasedContext[key],
	        parentBasedContext[key],
	        key,
	        displayName
	      ) : null);
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function(
	    transaction,
	    prevParentElement,
	    nextParentElement,
	    prevUnmaskedContext,
	    nextUnmaskedContext
	  ) {
	    var inst = this._instance;
	
	    var nextContext = inst.context;
	    var nextProps = inst.props;
	
	    // Distinguish between a props update versus a simple state update
	    if (prevParentElement !== nextParentElement) {
	      nextContext = this._processContext(nextParentElement._context);
	      nextProps = this._processProps(nextParentElement.props);
	
	      if (false) {
	        if (nextUnmaskedContext != null) {
	          this._warnIfContextsDiffer(
	            nextParentElement._context,
	            nextUnmaskedContext
	          );
	        }
	      }
	
	      // An update here will schedule an update but immediately set
	      // _pendingStateQueue which will ensure that any state updates gets
	      // immediately reconciled instead of waiting for the next batch.
	
	      if (inst.componentWillReceiveProps) {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	
	    var shouldUpdate =
	      this._pendingForceUpdate ||
	      !inst.shouldComponentUpdate ||
	      inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        typeof shouldUpdate !== 'undefined',
	        '%s.shouldComponentUpdate(): Returned undefined instead of a ' +
	        'boolean value. Make sure to return true or false.',
	        this.getName() || 'ReactCompositeComponent'
	      ) : null);
	    }
	
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(
	        nextParentElement,
	        nextProps,
	        nextState,
	        nextContext,
	        transaction,
	        nextUnmaskedContext
	      );
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function(props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      assign(
	        nextState,
	        typeof partial === 'function' ?
	          partial.call(inst, nextState, props, context) :
	          partial
	      );
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function(
	    nextElement,
	    nextProps,
	    nextState,
	    nextContext,
	    transaction,
	    unmaskedContext
	  ) {
	    var inst = this._instance;
	
	    var prevProps = inst.props;
	    var prevState = inst.state;
	    var prevContext = inst.context;
	
	    if (inst.componentWillUpdate) {
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (inst.componentDidUpdate) {
	      transaction.getReactMountReady().enqueue(
	        inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext),
	        inst
	      );
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function(transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var childContext = this._getValidatedChildContext();
	    var nextRenderedElement = this._renderValidatedComponent(childContext);
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(
	        prevComponentInstance,
	        nextRenderedElement,
	        transaction,
	        this._mergeChildContext(context, childContext)
	      );
	    } else {
	      // These two IDs are actually the same! But nothing should rely on that.
	      var thisID = this._rootNodeID;
	      var prevComponentID = prevComponentInstance._rootNodeID;
	      ReactReconciler.unmountComponent(prevComponentInstance);
	
	      this._renderedComponent = this._instantiateReactComponent(
	        nextRenderedElement,
	        this._currentElement.type
	      );
	      var nextMarkup = ReactReconciler.mountComponent(
	        this._renderedComponent,
	        thisID,
	        transaction,
	        this._mergeChildContext(context, childContext)
	      );
	      this._replaceNodeWithMarkupByID(prevComponentID, nextMarkup);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  _replaceNodeWithMarkupByID: function(prevComponentID, nextMarkup) {
	    ReactComponentEnvironment.replaceNodeWithMarkupByID(
	      prevComponentID,
	      nextMarkup
	    );
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function() {
	    var inst = this._instance;
	    var renderedComponent = inst.render();
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (typeof renderedComponent === 'undefined' &&
	          inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function(childContext) {
	    var renderedComponent;
	    var previousContext = ReactContext.current;
	    ReactContext.current = this._mergeChildContext(
	      this._currentElement._context,
	      childContext
	    );
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent =
	        this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactContext.current = previousContext;
	      ReactCurrentOwner.current = null;
	    }
	    ( false ? invariant(
	      // TODO: An `isValidNode` function would probably be more appropriate
	      renderedComponent === null || renderedComponent === false ||
	      ReactElement.isValidElement(renderedComponent),
	      '%s.render(): A valid ReactComponent must be returned. You may have ' +
	        'returned undefined, an array or some other invalid object.',
	      this.getName() || 'ReactCompositeComponent'
	    ) : invariant(// TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false ||
	    ReactElement.isValidElement(renderedComponent)));
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function(ref, component) {
	    var inst = this.getPublicInstance();
	    var refs = inst.refs === emptyObject ? (inst.refs = {}) : inst.refs;
	    refs[ref] = component.getPublicInstance();
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function(ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function() {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return (
	      type.displayName || (constructor && constructor.displayName) ||
	      type.name || (constructor && constructor.name) ||
	      null
	    );
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by React.render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function() {
	    return this._instance;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	ReactPerf.measureMethods(
	  ReactCompositeComponentMixin,
	  'ReactCompositeComponent',
	  {
	    mountComponent: 'mountComponent',
	    updateComponent: 'updateComponent',
	    _renderValidatedComponent: '_renderValidatedComponent'
	  }
	);
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	var ReactElementValidator = __webpack_require__(134);
	
	var mapObject = __webpack_require__(915);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOM = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOM;


/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(170);
	var ReactBrowserComponentMixin = __webpack_require__(71);
	var ReactClass = __webpack_require__(46);
	var ReactElement = __webpack_require__(16);
	
	var keyMirror = __webpack_require__(137);
	
	var button = ReactElement.createFactory('button');
	
	var mouseListenerNames = keyMirror({
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	});
	
	/**
	 * Implements a <button> native component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = ReactClass.createClass({
	  displayName: 'ReactDOMButton',
	  tagName: 'BUTTON',
	
	  mixins: [AutoFocusMixin, ReactBrowserComponentMixin],
	
	  render: function() {
	    var props = {};
	
	    // Copy the props; except the mouse listeners if we're disabled
	    for (var key in this.props) {
	      if (this.props.hasOwnProperty(key) &&
	          (!this.props.disabled || !mouseListenerNames[key])) {
	        props[key] = this.props[key];
	      }
	    }
	
	    return button(props, this.props.children);
	  }
	
	});
	
	module.exports = ReactDOMButton;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMForm
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	var LocalEventTrapMixin = __webpack_require__(243);
	var ReactBrowserComponentMixin = __webpack_require__(71);
	var ReactClass = __webpack_require__(46);
	var ReactElement = __webpack_require__(16);
	
	var form = ReactElement.createFactory('form');
	
	/**
	 * Since onSubmit doesn't bubble OR capture on the top level in IE8, we need
	 * to capture it on the <form> element itself. There are lots of hacks we could
	 * do to accomplish this, but the most reliable is to make <form> a
	 * composite component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMForm = ReactClass.createClass({
	  displayName: 'ReactDOMForm',
	  tagName: 'FORM',
	
	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],
	
	  render: function() {
	    // TODO: Instead of using `ReactDOM` directly, we should use JSX. However,
	    // `jshint` fails to parse JSX so in order for linting to work in the open
	    // source repo, we need to just use `ReactDOM.form`.
	    return form(this.props);
	  },
	
	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset');
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit');
	  }
	});
	
	module.exports = ReactDOMForm;


/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIframe
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	var LocalEventTrapMixin = __webpack_require__(243);
	var ReactBrowserComponentMixin = __webpack_require__(71);
	var ReactClass = __webpack_require__(46);
	var ReactElement = __webpack_require__(16);
	
	var iframe = ReactElement.createFactory('iframe');
	
	/**
	 * Since onLoad doesn't bubble OR capture on the top level in IE8, we need to
	 * capture it on the <iframe> element itself. There are lots of hacks we could
	 * do to accomplish this, but the most reliable is to make <iframe> a composite
	 * component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMIframe = ReactClass.createClass({
	  displayName: 'ReactDOMIframe',
	  tagName: 'IFRAME',
	
	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],
	
	  render: function() {
	    return iframe(this.props);
	  },
	
	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load');
	  }
	});
	
	module.exports = ReactDOMIframe;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMImg
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	var LocalEventTrapMixin = __webpack_require__(243);
	var ReactBrowserComponentMixin = __webpack_require__(71);
	var ReactClass = __webpack_require__(46);
	var ReactElement = __webpack_require__(16);
	
	var img = ReactElement.createFactory('img');
	
	/**
	 * Since onLoad doesn't bubble OR capture on the top level in IE8, we need to
	 * capture it on the <img> element itself. There are lots of hacks we could do
	 * to accomplish this, but the most reliable is to make <img> a composite
	 * component and use `componentDidMount` to attach the event handlers.
	 */
	var ReactDOMImg = ReactClass.createClass({
	  displayName: 'ReactDOMImg',
	  tagName: 'IMG',
	
	  mixins: [ReactBrowserComponentMixin, LocalEventTrapMixin],
	
	  render: function() {
	    return img(this.props);
	  },
	
	  componentDidMount: function() {
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load');
	    this.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error');
	  }
	});
	
	module.exports = ReactDOMImg;


/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(170);
	var DOMPropertyOperations = __webpack_require__(131);
	var LinkedValueUtils = __webpack_require__(242);
	var ReactBrowserComponentMixin = __webpack_require__(71);
	var ReactClass = __webpack_require__(46);
	var ReactElement = __webpack_require__(16);
	var ReactMount = __webpack_require__(73);
	var ReactUpdates = __webpack_require__(62);
	
	var assign = __webpack_require__(11);
	var invariant = __webpack_require__(6);
	
	var input = ReactElement.createFactory('input');
	
	var instancesByReactID = {};
	
	function forceUpdateIfMounted() {
	  /*jshint validthis:true */
	  if (this.isMounted()) {
	    this.forceUpdate();
	  }
	}
	
	/**
	 * Implements an <input> native component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = ReactClass.createClass({
	  displayName: 'ReactDOMInput',
	  tagName: 'INPUT',
	
	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],
	
	  getInitialState: function() {
	    var defaultValue = this.props.defaultValue;
	    return {
	      initialChecked: this.props.defaultChecked || false,
	      initialValue: defaultValue != null ? defaultValue : null
	    };
	  },
	
	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);
	
	    props.defaultChecked = null;
	    props.defaultValue = null;
	
	    var value = LinkedValueUtils.getValue(this);
	    props.value = value != null ? value : this.state.initialValue;
	
	    var checked = LinkedValueUtils.getChecked(this);
	    props.checked = checked != null ? checked : this.state.initialChecked;
	
	    props.onChange = this._handleChange;
	
	    return input(props, this.props.children);
	  },
	
	  componentDidMount: function() {
	    var id = ReactMount.getID(this.getDOMNode());
	    instancesByReactID[id] = this;
	  },
	
	  componentWillUnmount: function() {
	    var rootNode = this.getDOMNode();
	    var id = ReactMount.getID(rootNode);
	    delete instancesByReactID[id];
	  },
	
	  componentDidUpdate: function(prevProps, prevState, prevContext) {
	    var rootNode = this.getDOMNode();
	    if (this.props.checked != null) {
	      DOMPropertyOperations.setValueForProperty(
	        rootNode,
	        'checked',
	        this.props.checked || false
	      );
	    }
	
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(rootNode, 'value', '' + value);
	    }
	  },
	
	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	    // Here we use asap to wait until all updates have propagated, which
	    // is important when using controlled components within layers:
	    // https://github.com/facebook/react/issues/1698
	    ReactUpdates.asap(forceUpdateIfMounted, this);
	
	    var name = this.props.name;
	    if (this.props.type === 'radio' && name != null) {
	      var rootNode = this.getDOMNode();
	      var queryRoot = rootNode;
	
	      while (queryRoot.parentNode) {
	        queryRoot = queryRoot.parentNode;
	      }
	
	      // If `rootNode.form` was non-null, then we could try `form.elements`,
	      // but that sometimes behaves strangely in IE8. We could also try using
	      // `form.getElementsByName`, but that will only return direct children
	      // and won't include inputs that use the HTML5 `form=` attribute. Since
	      // the input might not even be in a form, let's just use the global
	      // `querySelectorAll` to ensure we don't miss anything.
	      var group = queryRoot.querySelectorAll(
	        'input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	      for (var i = 0, groupLen = group.length; i < groupLen; i++) {
	        var otherNode = group[i];
	        if (otherNode === rootNode ||
	            otherNode.form !== rootNode.form) {
	          continue;
	        }
	        var otherID = ReactMount.getID(otherNode);
	        ( false ? invariant(
	          otherID,
	          'ReactDOMInput: Mixing React and non-React radio inputs with the ' +
	          'same `name` is not supported.'
	        ) : invariant(otherID));
	        var otherInstance = instancesByReactID[otherID];
	        ( false ? invariant(
	          otherInstance,
	          'ReactDOMInput: Unknown radio button ID %s.',
	          otherID
	        ) : invariant(otherInstance));
	        // If this is a controlled radio button group, forcing the input that
	        // was previously checked to update will cause it to be come re-checked
	        // as appropriate.
	        ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	      }
	    }
	
	    return returnValue;
	  }
	
	});
	
	module.exports = ReactDOMInput;


/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var ReactBrowserComponentMixin = __webpack_require__(71);
	var ReactClass = __webpack_require__(46);
	var ReactElement = __webpack_require__(16);
	
	var warning = __webpack_require__(17);
	
	var option = ReactElement.createFactory('option');
	
	/**
	 * Implements an <option> native component that warns when `selected` is set.
	 */
	var ReactDOMOption = ReactClass.createClass({
	  displayName: 'ReactDOMOption',
	  tagName: 'OPTION',
	
	  mixins: [ReactBrowserComponentMixin],
	
	  componentWillMount: function() {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      ("production" !== process.env.NODE_ENV ? warning(
	        this.props.selected == null,
	        'Use the `defaultValue` or `value` props on <select> instead of ' +
	        'setting `selected` on <option>.'
	      ) : null);
	    }
	  },
	
	  render: function() {
	    return option(this.props, this.props.children);
	  }
	
	});
	
	module.exports = ReactDOMOption;


/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(170);
	var LinkedValueUtils = __webpack_require__(242);
	var ReactBrowserComponentMixin = __webpack_require__(71);
	var ReactClass = __webpack_require__(46);
	var ReactElement = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(62);
	
	var assign = __webpack_require__(11);
	
	var select = ReactElement.createFactory('select');
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  /*jshint validthis:true */
	  if (this._pendingUpdate) {
	    this._pendingUpdate = false;
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null && this.isMounted()) {
	      updateOptions(this, value);
	    }
	  }
	}
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function selectValueType(props, propName, componentName) {
	  if (props[propName] == null) {
	    return null;
	  }
	  if (props.multiple) {
	    if (!Array.isArray(props[propName])) {
	      return new Error(
	        ("The `" + propName + "` prop supplied to <select> must be an array if ") +
	        ("`multiple` is true.")
	      );
	    }
	  } else {
	    if (Array.isArray(props[propName])) {
	      return new Error(
	        ("The `" + propName + "` prop supplied to <select> must be a scalar ") +
	        ("value if `multiple` is false.")
	      );
	    }
	  }
	}
	
	/**
	 * @param {ReactComponent} component Instance of ReactDOMSelect
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(component, propValue) {
	  var selectedValue, i, l;
	  var options = component.getDOMNode().options;
	
	  if (component.props.multiple) {
	    selectedValue = {};
	    for (i = 0, l = propValue.length; i < l; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0, l = options.length; i < l; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0, l = options.length; i < l; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> native component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = ReactClass.createClass({
	  displayName: 'ReactDOMSelect',
	  tagName: 'SELECT',
	
	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],
	
	  propTypes: {
	    defaultValue: selectValueType,
	    value: selectValueType
	  },
	
	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);
	
	    props.onChange = this._handleChange;
	    props.value = null;
	
	    return select(props, this.props.children);
	  },
	
	  componentWillMount: function() {
	    this._pendingUpdate = false;
	  },
	
	  componentDidMount: function() {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      updateOptions(this, value);
	    } else if (this.props.defaultValue != null) {
	      updateOptions(this, this.props.defaultValue);
	    }
	  },
	
	  componentDidUpdate: function(prevProps) {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      this._pendingUpdate = false;
	      updateOptions(this, value);
	    } else if (!prevProps.multiple !== !this.props.multiple) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (this.props.defaultValue != null) {
	        updateOptions(this, this.props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(this, this.props.multiple ? [] : '');
	      }
	    }
	  },
	
	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	
	    this._pendingUpdate = true;
	    ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	    return returnValue;
	  }
	
	});
	
	module.exports = ReactDOMSelect;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var getNodeForCharacterOffset = __webpack_require__(908);
	var getTextContentAccessor = __webpack_require__(396);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(
	    selection.anchorNode,
	    selection.anchorOffset,
	    selection.focusNode,
	    selection.focusOffset
	  );
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(
	    tempRange.startContainer,
	    tempRange.startOffset,
	    tempRange.endContainer,
	    tempRange.endOffset
	  );
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (typeof offsets.end === 'undefined') {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = typeof offsets.end === 'undefined' ?
	            start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = (
	  ExecutionEnvironment.canUseDOM &&
	  'selection' in document &&
	  !('getSelection' in window)
	);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;


/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var AutoFocusMixin = __webpack_require__(170);
	var DOMPropertyOperations = __webpack_require__(131);
	var LinkedValueUtils = __webpack_require__(242);
	var ReactBrowserComponentMixin = __webpack_require__(71);
	var ReactClass = __webpack_require__(46);
	var ReactElement = __webpack_require__(16);
	var ReactUpdates = __webpack_require__(62);
	
	var assign = __webpack_require__(11);
	var invariant = __webpack_require__(6);
	
	var warning = __webpack_require__(17);
	
	var textarea = ReactElement.createFactory('textarea');
	
	function forceUpdateIfMounted() {
	  /*jshint validthis:true */
	  if (this.isMounted()) {
	    this.forceUpdate();
	  }
	}
	
	/**
	 * Implements a <textarea> native component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = ReactClass.createClass({
	  displayName: 'ReactDOMTextarea',
	  tagName: 'TEXTAREA',
	
	  mixins: [AutoFocusMixin, LinkedValueUtils.Mixin, ReactBrowserComponentMixin],
	
	  getInitialState: function() {
	    var defaultValue = this.props.defaultValue;
	    // TODO (yungsters): Remove support for children content in <textarea>.
	    var children = this.props.children;
	    if (children != null) {
	      if (false) {
	        ("production" !== process.env.NODE_ENV ? warning(
	          false,
	          'Use the `defaultValue` or `value` props instead of setting ' +
	          'children on <textarea>.'
	        ) : null);
	      }
	      ( false ? invariant(
	        defaultValue == null,
	        'If you supply `defaultValue` on a <textarea>, do not pass children.'
	      ) : invariant(defaultValue == null));
	      if (Array.isArray(children)) {
	        ( false ? invariant(
	          children.length <= 1,
	          '<textarea> can only have at most one child.'
	        ) : invariant(children.length <= 1));
	        children = children[0];
	      }
	
	      defaultValue = '' + children;
	    }
	    if (defaultValue == null) {
	      defaultValue = '';
	    }
	    var value = LinkedValueUtils.getValue(this);
	    return {
	      // We save the initial value so that `ReactDOMComponent` doesn't update
	      // `textContent` (unnecessary since we update value).
	      // The initial value can be a boolean or object so that's why it's
	      // forced to be a string.
	      initialValue: '' + (value != null ? value : defaultValue)
	    };
	  },
	
	  render: function() {
	    // Clone `this.props` so we don't mutate the input.
	    var props = assign({}, this.props);
	
	    ( false ? invariant(
	      props.dangerouslySetInnerHTML == null,
	      '`dangerouslySetInnerHTML` does not make sense on <textarea>.'
	    ) : invariant(props.dangerouslySetInnerHTML == null));
	
	    props.defaultValue = null;
	    props.value = null;
	    props.onChange = this._handleChange;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.
	    return textarea(props, this.state.initialValue);
	  },
	
	  componentDidUpdate: function(prevProps, prevState, prevContext) {
	    var value = LinkedValueUtils.getValue(this);
	    if (value != null) {
	      var rootNode = this.getDOMNode();
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      DOMPropertyOperations.setValueForProperty(rootNode, 'value', '' + value);
	    }
	  },
	
	  _handleChange: function(event) {
	    var returnValue;
	    var onChange = LinkedValueUtils.getOnChange(this);
	    if (onChange) {
	      returnValue = onChange.call(this, event);
	    }
	    ReactUpdates.asap(forceUpdateIfMounted, this);
	    return returnValue;
	  }
	
	});
	
	module.exports = ReactDOMTextarea;


/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var ReactUpdates = __webpack_require__(62);
	var Transaction = __webpack_require__(175);
	
	var assign = __webpack_require__(11);
	var emptyFunction = __webpack_require__(63);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function() {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	assign(
	  ReactDefaultBatchingStrategyTransaction.prototype,
	  Transaction.Mixin,
	  {
	    getTransactionWrappers: function() {
	      return TRANSACTION_WRAPPERS;
	    }
	  }
	);
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function(callback, a, b, c, d) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d);
	    } else {
	      transaction.perform(callback, null, a, b, c, d);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;


/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(844);
	var ChangeEventPlugin = __webpack_require__(846);
	var ClientReactRootIndex = __webpack_require__(847);
	var DefaultEventPluginOrder = __webpack_require__(850);
	var EnterLeaveEventPlugin = __webpack_require__(851);
	var ExecutionEnvironment = __webpack_require__(30);
	var HTMLDOMPropertyConfig = __webpack_require__(854);
	var MobileSafariClickEventPlugin = __webpack_require__(855);
	var ReactBrowserComponentMixin = __webpack_require__(71);
	var ReactClass = __webpack_require__(46);
	var ReactComponentBrowserEnvironment =
	  __webpack_require__(244);
	var ReactDefaultBatchingStrategy = __webpack_require__(870);
	var ReactDOMComponent = __webpack_require__(247);
	var ReactDOMButton = __webpack_require__(861);
	var ReactDOMForm = __webpack_require__(862);
	var ReactDOMImg = __webpack_require__(864);
	var ReactDOMIDOperations = __webpack_require__(382);
	var ReactDOMIframe = __webpack_require__(863);
	var ReactDOMInput = __webpack_require__(865);
	var ReactDOMOption = __webpack_require__(866);
	var ReactDOMSelect = __webpack_require__(867);
	var ReactDOMTextarea = __webpack_require__(869);
	var ReactDOMTextComponent = __webpack_require__(383);
	var ReactElement = __webpack_require__(16);
	var ReactEventListener = __webpack_require__(874);
	var ReactInjection = __webpack_require__(875);
	var ReactInstanceHandles = __webpack_require__(116);
	var ReactMount = __webpack_require__(73);
	var ReactReconcileTransaction = __webpack_require__(879);
	var SelectEventPlugin = __webpack_require__(887);
	var ServerReactRootIndex = __webpack_require__(888);
	var SimpleEventPlugin = __webpack_require__(889);
	var SVGDOMPropertyConfig = __webpack_require__(886);
	
	var createFullPageComponent = __webpack_require__(903);
	
	function autoGenerateWrapperClass(type) {
	  return ReactClass.createClass({
	    tagName: type.toUpperCase(),
	    render: function() {
	      return new ReactElement(
	        type,
	        null,
	        null,
	        null,
	        null,
	        this.props
	      );
	    }
	  });
	}
	
	function inject() {
	  ReactInjection.EventEmitter.injectReactEventListener(
	    ReactEventListener
	  );
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginHub.injectInstanceHandle(ReactInstanceHandles);
	  ReactInjection.EventPluginHub.injectMount(ReactMount);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    MobileSafariClickEventPlugin: MobileSafariClickEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.NativeComponent.injectGenericComponentClass(
	    ReactDOMComponent
	  );
	
	  ReactInjection.NativeComponent.injectTextComponentClass(
	    ReactDOMTextComponent
	  );
	
	  ReactInjection.NativeComponent.injectAutoWrapper(
	    autoGenerateWrapperClass
	  );
	
	  // This needs to happen before createFullPageComponent() otherwise the mixin
	  // won't be included.
	  ReactInjection.Class.injectMixin(ReactBrowserComponentMixin);
	
	  ReactInjection.NativeComponent.injectComponentClasses({
	    'button': ReactDOMButton,
	    'form': ReactDOMForm,
	    'iframe': ReactDOMIframe,
	    'img': ReactDOMImg,
	    'input': ReactDOMInput,
	    'option': ReactDOMOption,
	    'select': ReactDOMSelect,
	    'textarea': ReactDOMTextarea,
	
	    'html': createFullPageComponent('html'),
	    'head': createFullPageComponent('head'),
	    'body': createFullPageComponent('body')
	  });
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponent('noscript');
	
	  ReactInjection.Updates.injectReconcileTransaction(
	    ReactReconcileTransaction
	  );
	  ReactInjection.Updates.injectBatchingStrategy(
	    ReactDefaultBatchingStrategy
	  );
	
	  ReactInjection.RootIndex.injectCreateReactRootIndex(
	    ExecutionEnvironment.canUseDOM ?
	      ClientReactRootIndex.createReactRootIndex :
	      ServerReactRootIndex.createReactRootIndex
	  );
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	  ReactInjection.DOMComponent.injectIDOperations(ReactDOMIDOperations);
	
	  if (false) {
	    var url = (ExecutionEnvironment.canUseDOM && window.location.href) || '';
	    if ((/[?&]react_perf\b/).test(url)) {
	      var ReactDefaultPerf = require("./ReactDefaultPerf");
	      ReactDefaultPerf.start();
	    }
	  }
	}
	
	module.exports = {
	  inject: inject
	};


/***/ }),
/* 872 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 * @typechecks
	 */
	
	"use strict";
	
	var ReactErrorUtils = {
	  /**
	   * Creates a guarded version of a function. This is supposed to make debugging
	   * of event handlers easier. To aid debugging with the browser's debugger,
	   * this currently simply returns the original function.
	   *
	   * @param {function} func Function to be executed
	   * @param {string} name The name of the guard
	   * @return {function}
	   */
	  guard: function(func, name) {
	    return func;
	  }
	};
	
	module.exports = ReactErrorUtils;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(132);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue();
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {object} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native environment event.
	   */
	  handleTopLevel: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var events = EventPluginHub.extractEvents(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent
	    );
	
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var EventListener = __webpack_require__(852);
	var ExecutionEnvironment = __webpack_require__(30);
	var PooledClass = __webpack_require__(70);
	var ReactInstanceHandles = __webpack_require__(116);
	var ReactMount = __webpack_require__(73);
	var ReactUpdates = __webpack_require__(62);
	
	var assign = __webpack_require__(11);
	var getEventTarget = __webpack_require__(257);
	var getUnboundedScrollPosition = __webpack_require__(910);
	
	/**
	 * Finds the parent React component of `node`.
	 *
	 * @param {*} node
	 * @return {?DOMEventTarget} Parent container, or `null` if the specified node
	 *                           is not nested.
	 */
	function findParent(node) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  var nodeID = ReactMount.getID(node);
	  var rootID = ReactInstanceHandles.getReactRootIDFromNodeID(nodeID);
	  var container = ReactMount.findReactContainerForID(rootID);
	  var parent = ReactMount.getFirstReactDOM(container);
	  return parent;
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function() {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(
	  TopLevelCallbackBookKeeping,
	  PooledClass.twoArgumentPooler
	);
	
	function handleTopLevelImpl(bookKeeping) {
	  var topLevelTarget = ReactMount.getFirstReactDOM(
	    getEventTarget(bookKeeping.nativeEvent)
	  ) || window;
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = topLevelTarget;
	  while (ancestor) {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = findParent(ancestor);
	  }
	
	  for (var i = 0, l = bookKeeping.ancestors.length; i < l; i++) {
	    topLevelTarget = bookKeeping.ancestors[i];
	    var topLevelTargetID = ReactMount.getID(topLevelTarget) || '';
	    ReactEventListener._handleTopLevel(
	      bookKeeping.topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      bookKeeping.nativeEvent
	    );
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function(handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function(enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function() {
	    return ReactEventListener._enabled;
	  },
	
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function(topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(
	      element,
	      handlerBaseName,
	      ReactEventListener.dispatchEvent.bind(null, topLevelType)
	    );
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function(topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(
	      element,
	      handlerBaseName,
	      ReactEventListener.dispatchEvent.bind(null, topLevelType)
	    );
	  },
	
	  monitorScrollValue: function(refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function(topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(
	      topLevelType,
	      nativeEvent
	    );
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(114);
	var EventPluginHub = __webpack_require__(132);
	var ReactComponentEnvironment = __webpack_require__(245);
	var ReactClass = __webpack_require__(46);
	var ReactEmptyComponent = __webpack_require__(248);
	var ReactBrowserEventEmitter = __webpack_require__(115);
	var ReactNativeComponent = __webpack_require__(172);
	var ReactDOMComponent = __webpack_require__(247);
	var ReactPerf = __webpack_require__(100);
	var ReactRootIndex = __webpack_require__(389);
	var ReactUpdates = __webpack_require__(62);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMComponent: ReactDOMComponent.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  NativeComponent: ReactNativeComponent.injection,
	  Perf: ReactPerf.injection,
	  RootIndex: ReactRootIndex.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;


/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var ReactComponentEnvironment = __webpack_require__(245);
	var ReactMultiChildUpdateTypes = __webpack_require__(386);
	
	var ReactReconciler = __webpack_require__(118);
	var ReactChildReconciler = __webpack_require__(858);
	
	/**
	 * Updating children of a component may trigger recursive updates. The depth is
	 * used to batch recursive updates to render markup more efficiently.
	 *
	 * @type {number}
	 * @private
	 */
	var updateDepth = 0;
	
	/**
	 * Queue of update configuration objects.
	 *
	 * Each object has a `type` property that is in `ReactMultiChildUpdateTypes`.
	 *
	 * @type {array<object>}
	 * @private
	 */
	var updateQueue = [];
	
	/**
	 * Queue of markup to be rendered.
	 *
	 * @type {array<string>}
	 * @private
	 */
	var markupQueue = [];
	
	/**
	 * Enqueues markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function enqueueMarkup(parentID, markup, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    markupIndex: markupQueue.push(markup) - 1,
	    textContent: null,
	    fromIndex: null,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues moving an existing element to another index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function enqueueMove(parentID, fromIndex, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    markupIndex: null,
	    textContent: null,
	    fromIndex: fromIndex,
	    toIndex: toIndex
	  });
	}
	
	/**
	 * Enqueues removing an element at an index.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function enqueueRemove(parentID, fromIndex) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    markupIndex: null,
	    textContent: null,
	    fromIndex: fromIndex,
	    toIndex: null
	  });
	}
	
	/**
	 * Enqueues setting the text content.
	 *
	 * @param {string} parentID ID of the parent component.
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function enqueueTextContent(parentID, textContent) {
	  // NOTE: Null values reduce hidden classes.
	  updateQueue.push({
	    parentID: parentID,
	    parentNode: null,
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    markupIndex: null,
	    textContent: textContent,
	    fromIndex: null,
	    toIndex: null
	  });
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue() {
	  if (updateQueue.length) {
	    ReactComponentEnvironment.processChildrenUpdates(
	      updateQueue,
	      markupQueue
	    );
	    clearQueue();
	  }
	}
	
	/**
	 * Clears any enqueued updates.
	 *
	 * @private
	 */
	function clearQueue() {
	  updateQueue.length = 0;
	  markupQueue.length = 0;
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function(nestedChildren, transaction, context) {
	      var children = ReactChildReconciler.instantiateChildren(
	        nestedChildren, transaction, context
	      );
	      this._renderedChildren = children;
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	          var rootID = this._rootNodeID + name;
	          var mountImage = ReactReconciler.mountComponent(
	            child,
	            rootID,
	            transaction,
	            context
	          );
	          child._mountIndex = index;
	          mountImages.push(mountImage);
	          index++;
	        }
	      }
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function(nextContent) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        var prevChildren = this._renderedChildren;
	        // Remove any rendered children.
	        ReactChildReconciler.unmountChildren(prevChildren);
	        // TODO: The setTextContent operation should be enough
	        for (var name in prevChildren) {
	          if (prevChildren.hasOwnProperty(name)) {
	            this._unmountChildByName(prevChildren[name], name);
	          }
	        }
	        // Set new text content.
	        this.setTextContent(nextContent);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	      }
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildren Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function(nextNestedChildren, transaction, context) {
	      updateDepth++;
	      var errorThrown = true;
	      try {
	        this._updateChildren(nextNestedChildren, transaction, context);
	        errorThrown = false;
	      } finally {
	        updateDepth--;
	        if (!updateDepth) {
	          if (errorThrown) {
	            clearQueue();
	          } else {
	            processQueue();
	          }
	        }
	
	      }
	    },
	
	    /**
	     * Improve performance by isolating this hot code path from the try/catch
	     * block in `updateChildren`.
	     *
	     * @param {?object} nextNestedChildren Nested child maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function(nextNestedChildren, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var nextChildren = ReactChildReconciler.updateChildren(
	        prevChildren, nextNestedChildren, transaction, context
	      );
	      this._renderedChildren = nextChildren;
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          this.moveChild(prevChild, nextIndex, lastIndex);
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            this._unmountChildByName(prevChild, name);
	          }
	          // The child must be instantiated before it's mounted.
	          this._mountChildByNameAtIndex(
	            nextChild, name, nextIndex, transaction, context
	          );
	        }
	        nextIndex++;
	      }
	      // Remove children that are no longer present.
	      for (name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name) &&
	            !(nextChildren && nextChildren.hasOwnProperty(name))) {
	          this._unmountChildByName(prevChildren[name], name);
	        }
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted.
	     *
	     * @internal
	     */
	    unmountChildren: function() {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function(child, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        enqueueMove(this._rootNodeID, child._mountIndex, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function(child, mountImage) {
	      enqueueMarkup(this._rootNodeID, mountImage, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function(child) {
	      enqueueRemove(this._rootNodeID, child._mountIndex);
	    },
	
	    /**
	     * Sets this text content string.
	     *
	     * @param {string} textContent Text content to set.
	     * @protected
	     */
	    setTextContent: function(textContent) {
	      enqueueTextContent(this._rootNodeID, textContent);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildByNameAtIndex: function(
	      child,
	      name,
	      index,
	      transaction,
	      context) {
	      // Inlined for performance, see `ReactInstanceHandles.createReactID`.
	      var rootID = this._rootNodeID + name;
	      var mountImage = ReactReconciler.mountComponent(
	        child,
	        rootID,
	        transaction,
	        context
	      );
	      child._mountIndex = index;
	      this.createChild(child, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child by name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @param {string} name Name of the child in `this._renderedChildren`.
	     * @private
	     */
	    _unmountChildByName: function(child, name) {
	      this.removeChild(child);
	      child._mountIndex = null;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;


/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(6);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function(object) {
	    return !!(
	      (object &&
	      typeof object.attachRef === 'function' && typeof object.detachRef === 'function')
	    );
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function(component, ref, owner) {
	    ( false ? invariant(
	      ReactOwner.isValidOwner(owner),
	      'addComponentAsRefTo(...): Only a ReactOwner can have refs. This ' +
	      'usually means that you\'re trying to add a ref to a component that ' +
	      'doesn\'t have an owner (that is, was not created inside of another ' +
	      'component\'s `render` method). Try rendering this component inside of ' +
	      'a new top-level component which will hold the ref.'
	    ) : invariant(ReactOwner.isValidOwner(owner)));
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function(component, ref, owner) {
	    ( false ? invariant(
	      ReactOwner.isValidOwner(owner),
	      'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. This ' +
	      'usually means that you\'re trying to remove a ref to a component that ' +
	      'doesn\'t have an owner (that is, was not created inside of another ' +
	      'component\'s `render` method). Try rendering this component inside of ' +
	      'a new top-level component which will hold the ref.'
	    ) : invariant(ReactOwner.isValidOwner(owner)));
	    // Check that `component` is still the current ref because we do not want to
	    // detach the ref if another component stole it.
	    if (owner.getPublicInstance().refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;


/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTransferer
	 */
	
	'use strict';
	
	var assign = __webpack_require__(11);
	var emptyFunction = __webpack_require__(63);
	var joinClasses = __webpack_require__(914);
	
	/**
	 * Creates a transfer strategy that will merge prop values using the supplied
	 * `mergeStrategy`. If a prop was previously unset, this just sets it.
	 *
	 * @param {function} mergeStrategy
	 * @return {function}
	 */
	function createTransferStrategy(mergeStrategy) {
	  return function(props, key, value) {
	    if (!props.hasOwnProperty(key)) {
	      props[key] = value;
	    } else {
	      props[key] = mergeStrategy(props[key], value);
	    }
	  };
	}
	
	var transferStrategyMerge = createTransferStrategy(function(a, b) {
	  // `merge` overrides the first object's (`props[key]` above) keys using the
	  // second object's (`value`) keys. An object's style's existing `propA` would
	  // get overridden. Flip the order here.
	  return assign({}, b, a);
	});
	
	/**
	 * Transfer strategies dictate how props are transferred by `transferPropsTo`.
	 * NOTE: if you add any more exceptions to this list you should be sure to
	 * update `cloneWithProps()` accordingly.
	 */
	var TransferStrategies = {
	  /**
	   * Never transfer `children`.
	   */
	  children: emptyFunction,
	  /**
	   * Transfer the `className` prop by merging them.
	   */
	  className: createTransferStrategy(joinClasses),
	  /**
	   * Transfer the `style` prop (which is an object) by merging them.
	   */
	  style: transferStrategyMerge
	};
	
	/**
	 * Mutates the first argument by transferring the properties from the second
	 * argument.
	 *
	 * @param {object} props
	 * @param {object} newProps
	 * @return {object}
	 */
	function transferInto(props, newProps) {
	  for (var thisKey in newProps) {
	    if (!newProps.hasOwnProperty(thisKey)) {
	      continue;
	    }
	
	    var transferStrategy = TransferStrategies[thisKey];
	
	    if (transferStrategy && TransferStrategies.hasOwnProperty(thisKey)) {
	      transferStrategy(props, thisKey, newProps[thisKey]);
	    } else if (!props.hasOwnProperty(thisKey)) {
	      props[thisKey] = newProps[thisKey];
	    }
	  }
	  return props;
	}
	
	/**
	 * ReactPropTransferer are capable of transferring props to another component
	 * using a `transferPropsTo` method.
	 *
	 * @class ReactPropTransferer
	 */
	var ReactPropTransferer = {
	
	  /**
	   * Merge two props objects using TransferStrategies.
	   *
	   * @param {object} oldProps original props (they take precedence)
	   * @param {object} newProps new props to merge in
	   * @return {object} a new object containing both sets of props merged.
	   */
	  mergeProps: function(oldProps, newProps) {
	    return transferInto(assign({}, oldProps), newProps);
	  }
	
	};
	
	module.exports = ReactPropTransferer;


/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CallbackQueue = __webpack_require__(240);
	var PooledClass = __webpack_require__(70);
	var ReactBrowserEventEmitter = __webpack_require__(115);
	var ReactInputSelection = __webpack_require__(384);
	var ReactPutListenerQueue = __webpack_require__(388);
	var Transaction = __webpack_require__(175);
	
	var assign = __webpack_require__(11);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function() {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occured. `close`
	   *   restores the previous value.
	   */
	  close: function(previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function() {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function() {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	var PUT_LISTENER_QUEUEING = {
	  initialize: function() {
	    this.putListenerQueue.reset();
	  },
	
	  close: function() {
	    this.putListenerQueue.putListeners();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [
	  PUT_LISTENER_QUEUEING,
	  SELECTION_RESTORATION,
	  EVENT_SUPPRESSION,
	  ON_DOM_READY_QUEUEING
	];
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction() {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.putListenerQueue = ReactPutListenerQueue.getPooled();
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap proceedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function() {
	    return this.reactMountReady;
	  },
	
	  getPutListenerQueue: function() {
	    return this.putListenerQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be resused.
	   */
	  destructor: function() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	
	    ReactPutListenerQueue.release(this.putListenerQueue);
	    this.putListenerQueue = null;
	  }
	};
	
	
	assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;


/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(877);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function(instance, element) {
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function(prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  return (
	    nextElement._owner !== prevElement._owner ||
	    nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function(instance, element) {
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactServerRendering
	 */
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	var ReactInstanceHandles = __webpack_require__(116);
	var ReactMarkupChecksum = __webpack_require__(385);
	var ReactServerRenderingTransaction =
	  __webpack_require__(882);
	
	var emptyObject = __webpack_require__(176);
	var instantiateReactComponent = __webpack_require__(258);
	var invariant = __webpack_require__(6);
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup
	 */
	function renderToString(element) {
	  ( false ? invariant(
	    ReactElement.isValidElement(element),
	    'renderToString(): You must pass a valid ReactElement.'
	  ) : invariant(ReactElement.isValidElement(element)));
	
	  var transaction;
	  try {
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(false);
	
	    return transaction.perform(function() {
	      var componentInstance = instantiateReactComponent(element, null);
	      var markup =
	        componentInstance.mountComponent(id, transaction, emptyObject);
	      return ReactMarkupChecksum.addChecksumToMarkup(markup);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	  }
	}
	
	/**
	 * @param {ReactElement} element
	 * @return {string} the HTML markup, without the extra React ID and checksum
	 * (for generating static pages)
	 */
	function renderToStaticMarkup(element) {
	  ( false ? invariant(
	    ReactElement.isValidElement(element),
	    'renderToStaticMarkup(): You must pass a valid ReactElement.'
	  ) : invariant(ReactElement.isValidElement(element)));
	
	  var transaction;
	  try {
	    var id = ReactInstanceHandles.createReactRootID();
	    transaction = ReactServerRenderingTransaction.getPooled(true);
	
	    return transaction.perform(function() {
	      var componentInstance = instantiateReactComponent(element, null);
	      return componentInstance.mountComponent(id, transaction, emptyObject);
	    }, null);
	  } finally {
	    ReactServerRenderingTransaction.release(transaction);
	  }
	}
	
	module.exports = {
	  renderToString: renderToString,
	  renderToStaticMarkup: renderToStaticMarkup
	};


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 * @typechecks
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(70);
	var CallbackQueue = __webpack_require__(240);
	var ReactPutListenerQueue = __webpack_require__(388);
	var Transaction = __webpack_require__(175);
	
	var assign = __webpack_require__(11);
	var emptyFunction = __webpack_require__(63);
	
	/**
	 * Provides a `CallbackQueue` queue for collecting `onDOMReady` callbacks
	 * during the performing of the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function() {
	    this.reactMountReady.reset();
	  },
	
	  close: emptyFunction
	};
	
	var PUT_LISTENER_QUEUEING = {
	  initialize: function() {
	    this.putListenerQueue.reset();
	  },
	
	  close: emptyFunction
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [
	  PUT_LISTENER_QUEUEING,
	  ON_DOM_READY_QUEUEING
	];
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.putListenerQueue = ReactPutListenerQueue.getPooled();
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap proceedures.
	   */
	  getTransactionWrappers: function() {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function() {
	    return this.reactMountReady;
	  },
	
	  getPutListenerQueue: function() {
	    return this.putListenerQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be resused.
	   */
	  destructor: function() {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	
	    ReactPutListenerQueue.release(this.putListenerQueue);
	    this.putListenerQueue = null;
	  }
	};
	
	
	assign(
	  ReactServerRenderingTransaction.prototype,
	  Transaction.Mixin,
	  Mixin
	);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;


/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var ReactChildren = __webpack_require__(380);
	var ReactFragment = __webpack_require__(135);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around ReactChildren.map().
	   *
	   * @param {*} children `this.props.children`
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function(children) {
	    if (!children) {
	      return children;
	    }
	    return ReactFragment.extract(ReactChildren.map(children, function(child) {
	      return child;
	    }));
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function(prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(
	            pendingNextKey
	          );
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionEvents
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	/**
	 * EVENT_NAME_MAP is used to determine which event fired when a
	 * transition/animation ends, based on the style property used to
	 * define that event.
	 */
	var EVENT_NAME_MAP = {
	  transitionend: {
	    'transition': 'transitionend',
	    'WebkitTransition': 'webkitTransitionEnd',
	    'MozTransition': 'mozTransitionEnd',
	    'OTransition': 'oTransitionEnd',
	    'msTransition': 'MSTransitionEnd'
	  },
	
	  animationend: {
	    'animation': 'animationend',
	    'WebkitAnimation': 'webkitAnimationEnd',
	    'MozAnimation': 'mozAnimationEnd',
	    'OAnimation': 'oAnimationEnd',
	    'msAnimation': 'MSAnimationEnd'
	  }
	};
	
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are useable, and if not remove them
	  // from the map
	  if (!('AnimationEvent' in window)) {
	    delete EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  for (var baseEventName in EVENT_NAME_MAP) {
	    var baseEvents = EVENT_NAME_MAP[baseEventName];
	    for (var styleName in baseEvents) {
	      if (styleName in style) {
	        endEvents.push(baseEvents[styleName]);
	        break;
	      }
	    }
	  }
	}
	
	if (ExecutionEnvironment.canUseDOM) {
	  detectEvents();
	}
	
	// We use the raw {add|remove}EventListener() call because EventListener
	// does not know how to remove event listeners and we really should
	// clean up. Also, these events are not triggered in older browsers
	// so we should be A-OK here.
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var ReactTransitionEvents = {
	  addEndEventListener: function(node, eventListener) {
	    if (endEvents.length === 0) {
	      // If CSS transitions are not supported, trigger an "end animation"
	      // event immediately.
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function(endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	
	  removeEndEventListener: function(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function(endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	module.exports = ReactTransitionEvents;


/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var React = __webpack_require__(171);
	var ReactTransitionChildMapping = __webpack_require__(883);
	
	var assign = __webpack_require__(11);
	var cloneWithProps = __webpack_require__(901);
	var emptyFunction = __webpack_require__(63);
	
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function() {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function(nextProps) {
	    var nextChildMapping = ReactTransitionChildMapping.getChildMapping(
	      nextProps.children
	    );
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(
	        prevChildMapping,
	        nextChildMapping
	      )
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev &&
	          !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext &&
	          !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function() {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(
	        this._handleDoneAppearing.bind(this, key)
	      );
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(
	        this._handleDoneEntering.bind(this, key)
	      );
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function(key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function(key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function(key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping = ReactTransitionChildMapping.getChildMapping(
	      this.props.children
	    );
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      var newChildren = assign({}, this.state.children);
	      delete newChildren[key];
	      this.setState({children: newChildren});
	    }
	  },
	
	  render: function() {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(cloneWithProps(
	          this.props.childFactory(child),
	          {ref: key, key: key}
	        ));
	      }
	    }
	    return React.createElement(
	      this.props.component,
	      this.props,
	      childrenToRender
	    );
	  }
	});
	
	module.exports = ReactTransitionGroup;


/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	/*jslint bitwise: true*/
	
	'use strict';
	
	var DOMProperty = __webpack_require__(114);
	
	var MUST_USE_ATTRIBUTE = DOMProperty.injection.MUST_USE_ATTRIBUTE;
	
	var SVGDOMPropertyConfig = {
	  Properties: {
	    clipPath: MUST_USE_ATTRIBUTE,
	    cx: MUST_USE_ATTRIBUTE,
	    cy: MUST_USE_ATTRIBUTE,
	    d: MUST_USE_ATTRIBUTE,
	    dx: MUST_USE_ATTRIBUTE,
	    dy: MUST_USE_ATTRIBUTE,
	    fill: MUST_USE_ATTRIBUTE,
	    fillOpacity: MUST_USE_ATTRIBUTE,
	    fontFamily: MUST_USE_ATTRIBUTE,
	    fontSize: MUST_USE_ATTRIBUTE,
	    fx: MUST_USE_ATTRIBUTE,
	    fy: MUST_USE_ATTRIBUTE,
	    gradientTransform: MUST_USE_ATTRIBUTE,
	    gradientUnits: MUST_USE_ATTRIBUTE,
	    markerEnd: MUST_USE_ATTRIBUTE,
	    markerMid: MUST_USE_ATTRIBUTE,
	    markerStart: MUST_USE_ATTRIBUTE,
	    offset: MUST_USE_ATTRIBUTE,
	    opacity: MUST_USE_ATTRIBUTE,
	    patternContentUnits: MUST_USE_ATTRIBUTE,
	    patternUnits: MUST_USE_ATTRIBUTE,
	    points: MUST_USE_ATTRIBUTE,
	    preserveAspectRatio: MUST_USE_ATTRIBUTE,
	    r: MUST_USE_ATTRIBUTE,
	    rx: MUST_USE_ATTRIBUTE,
	    ry: MUST_USE_ATTRIBUTE,
	    spreadMethod: MUST_USE_ATTRIBUTE,
	    stopColor: MUST_USE_ATTRIBUTE,
	    stopOpacity: MUST_USE_ATTRIBUTE,
	    stroke: MUST_USE_ATTRIBUTE,
	    strokeDasharray: MUST_USE_ATTRIBUTE,
	    strokeLinecap: MUST_USE_ATTRIBUTE,
	    strokeOpacity: MUST_USE_ATTRIBUTE,
	    strokeWidth: MUST_USE_ATTRIBUTE,
	    textAnchor: MUST_USE_ATTRIBUTE,
	    transform: MUST_USE_ATTRIBUTE,
	    version: MUST_USE_ATTRIBUTE,
	    viewBox: MUST_USE_ATTRIBUTE,
	    x1: MUST_USE_ATTRIBUTE,
	    x2: MUST_USE_ATTRIBUTE,
	    x: MUST_USE_ATTRIBUTE,
	    y1: MUST_USE_ATTRIBUTE,
	    y2: MUST_USE_ATTRIBUTE,
	    y: MUST_USE_ATTRIBUTE
	  },
	  DOMAttributeNames: {
	    clipPath: 'clip-path',
	    fillOpacity: 'fill-opacity',
	    fontFamily: 'font-family',
	    fontSize: 'font-size',
	    gradientTransform: 'gradientTransform',
	    gradientUnits: 'gradientUnits',
	    markerEnd: 'marker-end',
	    markerMid: 'marker-mid',
	    markerStart: 'marker-start',
	    patternContentUnits: 'patternContentUnits',
	    patternUnits: 'patternUnits',
	    preserveAspectRatio: 'preserveAspectRatio',
	    spreadMethod: 'spreadMethod',
	    stopColor: 'stop-color',
	    stopOpacity: 'stop-opacity',
	    strokeDasharray: 'stroke-dasharray',
	    strokeLinecap: 'stroke-linecap',
	    strokeOpacity: 'stroke-opacity',
	    strokeWidth: 'stroke-width',
	    textAnchor: 'text-anchor',
	    viewBox: 'viewBox'
	  }
	};
	
	module.exports = SVGDOMPropertyConfig;


/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	var EventPropagators = __webpack_require__(133);
	var ReactInputSelection = __webpack_require__(384);
	var SyntheticEvent = __webpack_require__(101);
	
	var getActiveElement = __webpack_require__(393);
	var isTextInputElement = __webpack_require__(398);
	var keyOf = __webpack_require__(74);
	var shallowEqual = __webpack_require__(400);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onSelect: null}),
	      captured: keyOf({onSelectCapture: null})
	    },
	    dependencies: [
	      topLevelTypes.topBlur,
	      topLevelTypes.topContextMenu,
	      topLevelTypes.topFocus,
	      topLevelTypes.topKeyDown,
	      topLevelTypes.topMouseDown,
	      topLevelTypes.topMouseUp,
	      topLevelTypes.topSelectionChange
	    ]
	  }
	};
	
	var activeElement = null;
	var activeElementID = null;
	var lastSelection = null;
	var mouseDown = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @param {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node &&
	      ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown ||
	      activeElement == null ||
	      activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(
	      eventTypes.select,
	      activeElementID,
	      nativeEvent
	    );
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(topLevelTarget) ||
	            topLevelTarget.contentEditable === 'true') {
	          activeElement = topLevelTarget;
	          activeElementID = topLevelTargetID;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementID = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't).
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      case topLevelTypes.topSelectionChange:
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent);
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;


/***/ }),
/* 888 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ServerReactRootIndex
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Size of the reactRoot ID space. We generate random numbers for React root
	 * IDs and if there's a collision the events and DOM update system will
	 * get confused. In the future we need a way to generate GUIDs but for
	 * now this will work on a smaller scale.
	 */
	var GLOBAL_MOUNT_POINT_MAX = Math.pow(2, 53);
	
	var ServerReactRootIndex = {
	  createReactRootIndex: function() {
	    return Math.ceil(Math.random() * GLOBAL_MOUNT_POINT_MAX);
	  }
	};
	
	module.exports = ServerReactRootIndex;


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(45);
	var EventPluginUtils = __webpack_require__(241);
	var EventPropagators = __webpack_require__(133);
	var SyntheticClipboardEvent = __webpack_require__(890);
	var SyntheticEvent = __webpack_require__(101);
	var SyntheticFocusEvent = __webpack_require__(893);
	var SyntheticKeyboardEvent = __webpack_require__(895);
	var SyntheticMouseEvent = __webpack_require__(174);
	var SyntheticDragEvent = __webpack_require__(892);
	var SyntheticTouchEvent = __webpack_require__(896);
	var SyntheticUIEvent = __webpack_require__(136);
	var SyntheticWheelEvent = __webpack_require__(897);
	
	var getEventCharCode = __webpack_require__(255);
	
	var invariant = __webpack_require__(6);
	var keyOf = __webpack_require__(74);
	var warning = __webpack_require__(17);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onBlur: true}),
	      captured: keyOf({onBlurCapture: true})
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onClick: true}),
	      captured: keyOf({onClickCapture: true})
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onContextMenu: true}),
	      captured: keyOf({onContextMenuCapture: true})
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCopy: true}),
	      captured: keyOf({onCopyCapture: true})
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onCut: true}),
	      captured: keyOf({onCutCapture: true})
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDoubleClick: true}),
	      captured: keyOf({onDoubleClickCapture: true})
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDrag: true}),
	      captured: keyOf({onDragCapture: true})
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragEnd: true}),
	      captured: keyOf({onDragEndCapture: true})
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragEnter: true}),
	      captured: keyOf({onDragEnterCapture: true})
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragExit: true}),
	      captured: keyOf({onDragExitCapture: true})
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragLeave: true}),
	      captured: keyOf({onDragLeaveCapture: true})
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragOver: true}),
	      captured: keyOf({onDragOverCapture: true})
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDragStart: true}),
	      captured: keyOf({onDragStartCapture: true})
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onDrop: true}),
	      captured: keyOf({onDropCapture: true})
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onFocus: true}),
	      captured: keyOf({onFocusCapture: true})
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onInput: true}),
	      captured: keyOf({onInputCapture: true})
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyDown: true}),
	      captured: keyOf({onKeyDownCapture: true})
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyPress: true}),
	      captured: keyOf({onKeyPressCapture: true})
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onKeyUp: true}),
	      captured: keyOf({onKeyUpCapture: true})
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onLoad: true}),
	      captured: keyOf({onLoadCapture: true})
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onError: true}),
	      captured: keyOf({onErrorCapture: true})
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseDown: true}),
	      captured: keyOf({onMouseDownCapture: true})
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseMove: true}),
	      captured: keyOf({onMouseMoveCapture: true})
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseOut: true}),
	      captured: keyOf({onMouseOutCapture: true})
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseOver: true}),
	      captured: keyOf({onMouseOverCapture: true})
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onMouseUp: true}),
	      captured: keyOf({onMouseUpCapture: true})
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onPaste: true}),
	      captured: keyOf({onPasteCapture: true})
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onReset: true}),
	      captured: keyOf({onResetCapture: true})
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onScroll: true}),
	      captured: keyOf({onScrollCapture: true})
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onSubmit: true}),
	      captured: keyOf({onSubmitCapture: true})
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchCancel: true}),
	      captured: keyOf({onTouchCancelCapture: true})
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchEnd: true}),
	      captured: keyOf({onTouchEndCapture: true})
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchMove: true}),
	      captured: keyOf({onTouchMoveCapture: true})
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchStart: true}),
	      captured: keyOf({onTouchStartCapture: true})
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onWheel: true}),
	      captured: keyOf({onWheelCapture: true})
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topBlur:        eventTypes.blur,
	  topClick:       eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy:        eventTypes.copy,
	  topCut:         eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag:        eventTypes.drag,
	  topDragEnd:     eventTypes.dragEnd,
	  topDragEnter:   eventTypes.dragEnter,
	  topDragExit:    eventTypes.dragExit,
	  topDragLeave:   eventTypes.dragLeave,
	  topDragOver:    eventTypes.dragOver,
	  topDragStart:   eventTypes.dragStart,
	  topDrop:        eventTypes.drop,
	  topError:       eventTypes.error,
	  topFocus:       eventTypes.focus,
	  topInput:       eventTypes.input,
	  topKeyDown:     eventTypes.keyDown,
	  topKeyPress:    eventTypes.keyPress,
	  topKeyUp:       eventTypes.keyUp,
	  topLoad:        eventTypes.load,
	  topMouseDown:   eventTypes.mouseDown,
	  topMouseMove:   eventTypes.mouseMove,
	  topMouseOut:    eventTypes.mouseOut,
	  topMouseOver:   eventTypes.mouseOver,
	  topMouseUp:     eventTypes.mouseUp,
	  topPaste:       eventTypes.paste,
	  topReset:       eventTypes.reset,
	  topScroll:      eventTypes.scroll,
	  topSubmit:      eventTypes.submit,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd:    eventTypes.touchEnd,
	  topTouchMove:   eventTypes.touchMove,
	  topTouchStart:  eventTypes.touchStart,
	  topWheel:       eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * Same as the default implementation, except cancels the event when return
	   * value is false. This behavior will be disabled in a future release.
	   *
	   * @param {object} Event to be dispatched.
	   * @param {function} Application-level callback.
	   * @param {string} domID DOM ID to pass to the callback.
	   */
	  executeDispatch: function(event, listener, domID) {
	    var returnValue = EventPluginUtils.executeDispatch(event, listener, domID);
	
	    ( false ? warning(
	      typeof returnValue !== 'boolean',
	      'Returning `false` from an event handler is deprecated and will be ' +
	      'ignored in a future release. Instead, manually call ' +
	      'e.stopPropagation() or e.preventDefault(), as appropriate.'
	    ) : null);
	
	    if (returnValue === false) {
	      event.stopPropagation();
	      event.preventDefault();
	    }
	  },
	
	  /**
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {DOMEventTarget} topLevelTarget The listening component root node.
	   * @param {string} topLevelTargetID ID of `topLevelTarget`.
	   * @param {object} nativeEvent Native browser event.
	   * @return {*} An accumulation of synthetic events.
	   * @see {EventPluginHub.extractEvents}
	   */
	  extractEvents: function(
	      topLevelType,
	      topLevelTarget,
	      topLevelTargetID,
	      nativeEvent) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topInput:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topError:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSubmit:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // FireFox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	        /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	        /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    ( false ? invariant(
	      EventConstructor,
	      'SimpleEventPlugin: Unhandled event type, `%s`.',
	      topLevelType
	    ) : invariant(EventConstructor));
	    var event = EventConstructor.getPooled(
	      dispatchConfig,
	      topLevelTargetID,
	      nativeEvent
	    );
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  }
	
	};
	
	module.exports = SimpleEventPlugin;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(101);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function(event) {
	    return (
	      'clipboardData' in event ?
	        event.clipboardData :
	        window.clipboardData
	    );
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(101);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(
	  dispatchConfig,
	  dispatchMarker,
	  nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(
	  SyntheticCompositionEvent,
	  CompositionEventInterface
	);
	
	module.exports = SyntheticCompositionEvent;


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(174);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(136);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(101);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(
	  dispatchConfig,
	  dispatchMarker,
	  nativeEvent) {
	  SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticEvent.augmentClass(
	  SyntheticInputEvent,
	  InputEventInterface
	);
	
	module.exports = SyntheticInputEvent;


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(136);
	
	var getEventCharCode = __webpack_require__(255);
	var getEventKey = __webpack_require__(907);
	var getEventModifierState = __webpack_require__(256);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function(event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function(event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function(event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(136);
	
	var getEventModifierState = __webpack_require__(256);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(174);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function(event) {
	    return (
	      'deltaX' in event ? event.deltaX :
	      // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	      'wheelDeltaX' in event ? -event.wheelDeltaX : 0
	    );
	  },
	  deltaY: function(event) {
	    return (
	      'deltaY' in event ? event.deltaY :
	      // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	      'wheelDeltaY' in event ? -event.wheelDeltaY :
	      // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	      'wheelDelta' in event ? -event.wheelDelta : 0
	    );
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent) {
	  SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;


/***/ }),
/* 898 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 */
	
	/* jslint bitwise:true */
	
	'use strict';
	
	var MOD = 65521;
	
	// This is a clean-room implementation of adler32 designed for detecting
	// if markup is not what we expect it to be. It does not need to be
	// cryptographically strong, only reasonably good at detecting if markup
	// generated on the server is different than that on the client.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  for (var i = 0; i < data.length; i++) {
	    a = (a + data.charCodeAt(i)) % MOD;
	    b = (b + a) % MOD;
	  }
	  return a | (b << 16);
	}
	
	module.exports = adler32;


/***/ }),
/* 899 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelize
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function(_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule camelizeStyleName
	 * @typechecks
	 */
	
	"use strict";
	
	var camelize = __webpack_require__(899);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 * @providesModule cloneWithProps
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(16);
	var ReactPropTransferer = __webpack_require__(878);
	
	var keyOf = __webpack_require__(74);
	var warning = __webpack_require__(17);
	
	var CHILDREN_PROP = keyOf({children: null});
	
	/**
	 * Sometimes you want to change the props of a child passed to you. Usually
	 * this is to add a CSS class.
	 *
	 * @param {ReactElement} child child element you'd like to clone
	 * @param {object} props props you'd like to modify. className and style will be
	 * merged automatically.
	 * @return {ReactElement} a clone of child with props merged in.
	 */
	function cloneWithProps(child, props) {
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      !child.ref,
	      'You are calling cloneWithProps() on a child with a ref. This is ' +
	      'dangerous because you\'re creating a new child which will not be ' +
	      'added as a ref to its parent.'
	    ) : null);
	  }
	
	  var newProps = ReactPropTransferer.mergeProps(props, child.props);
	
	  // Use `child.props.children` if it is provided.
	  if (!newProps.hasOwnProperty(CHILDREN_PROP) &&
	      child.props.hasOwnProperty(CHILDREN_PROP)) {
	    newProps.children = child.props.children;
	  }
	
	  // The current API doesn't retain _owner and _context, which is why this
	  // doesn't use ReactElement.cloneAndReplaceProps.
	  return ReactElement.createElement(child.type, newProps);
	}
	
	module.exports = cloneWithProps;


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createArrayFromMixed
	 * @typechecks
	 */
	
	var toArray = __webpack_require__(919);
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj &&
	    // arrays are objects, NodeLists are functions in Safari
	    (typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    ('length' in obj) &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    (typeof obj.nodeType != 'number') &&
	    (
	      // a real array
	      (// HTMLCollection/NodeList
	      (Array.isArray(obj) ||
	      // arguments
	      ('callee' in obj) || 'item' in obj))
	    )
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createFullPageComponent
	 * @typechecks
	 */
	
	'use strict';
	
	// Defeat circular references by requiring this directly.
	var ReactClass = __webpack_require__(46);
	var ReactElement = __webpack_require__(16);
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Create a component that will throw an exception when unmounted.
	 *
	 * Components like <html> <head> and <body> can't be removed or added
	 * easily in a cross-browser way, however it's valuable to be able to
	 * take advantage of React's reconciliation for styling and <title>
	 * management. So we just document it and throw in dangerous cases.
	 *
	 * @param {string} tag The tag to wrap
	 * @return {function} convenience constructor of new component
	 */
	function createFullPageComponent(tag) {
	  var elementFactory = ReactElement.createFactory(tag);
	
	  var FullPageComponent = ReactClass.createClass({
	    tagName: tag.toUpperCase(),
	    displayName: 'ReactFullPageComponent' + tag,
	
	    componentWillUnmount: function() {
	      ( false ? invariant(
	        false,
	        '%s tried to unmount. Because of cross-browser quirks it is ' +
	        'impossible to unmount some top-level components (eg <html>, <head>, ' +
	        'and <body>) reliably and efficiently. To fix this, have a single ' +
	        'top-level component that never unmounts render these elements.',
	        this.constructor.displayName
	      ) : invariant(false));
	    },
	
	    render: function() {
	      return elementFactory(this.props);
	    }
	  });
	
	  return FullPageComponent;
	}
	
	module.exports = createFullPageComponent;


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createNodesFromMarkup
	 * @typechecks
	 */
	
	/*jslint evil: true, sub: true */
	
	var ExecutionEnvironment = __webpack_require__(30);
	
	var createArrayFromMixed = __webpack_require__(902);
	var getMarkupWrap = __webpack_require__(395);
	var invariant = __webpack_require__(6);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode =
	  ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  ( false ? invariant(!!dummyNode, 'createNodesFromMarkup dummy not initialized') : invariant(!!dummyNode));
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    ( false ? invariant(
	      handleScript,
	      'createNodesFromMarkup(...): Unexpected <script> element rendered.'
	    ) : invariant(handleScript));
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = createArrayFromMixed(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(378);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 ||
	      isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;


/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 */
	
	'use strict';
	
	var traverseAllChildren = __webpack_require__(401);
	var warning = __webpack_require__(17);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name) {
	  // We found a component instance.
	  var result = traverseContext;
	  var keyUnique = !result.hasOwnProperty(name);
	  if (false) {
	    ("production" !== process.env.NODE_ENV ? warning(
	      keyUnique,
	      'flattenChildren(...): Encountered two children with the same key, ' +
	      '`%s`. Child keys must be unique; when two children share a key, only ' +
	      'the first child will be used.',
	      name
	    ) : null);
	  }
	  if (keyUnique && child != null) {
	    result[name] = child;
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	  traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  return result;
	}
	
	module.exports = flattenChildren;


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(255);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;


/***/ }),
/* 908 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;


/***/ }),
/* 909 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getReactRootElementInContainer
	 */
	
	'use strict';
	
	var DOC_NODE_TYPE = 9;
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 *                                           a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	module.exports = getReactRootElementInContainer;


/***/ }),
/* 910 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUnboundedScrollPosition
	 * @typechecks
	 */
	
	"use strict";
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;


/***/ }),
/* 911 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenate
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule hyphenateStyleName
	 * @typechecks
	 */
	
	"use strict";
	
	var hyphenate = __webpack_require__(911);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextNode
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(397);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;


/***/ }),
/* 914 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule joinClasses
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} classes
	 * @return {string}
	 */
	function joinClasses(className/*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;


/***/ }),
/* 915 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule mapObject
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;


/***/ }),
/* 916 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule memoizeStringOnly
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 *
	 * @param {function} callback
	 * @return {function}
	 */
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function(string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(177);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(30);
	var escapeTextContentForBrowser = __webpack_require__(177);
	var setInnerHTML = __webpack_require__(260);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function(node, text) {
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function(node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule toArray
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(6);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browse builtin objects can report typeof 'function' (e.g. NodeList in
	  // old versions of Safari).
	  ( false ? invariant(
	    !Array.isArray(obj) &&
	    (typeof obj === 'object' || typeof obj === 'function'),
	    'toArray: Array-like object expected'
	  ) : invariant(!Array.isArray(obj) &&
	  (typeof obj === 'object' || typeof obj === 'function')));
	
	  ( false ? invariant(
	    typeof length === 'number',
	    'toArray: Object needs a length property'
	  ) : invariant(typeof length === 'number'));
	
	  ( false ? invariant(
	    length === 0 ||
	    (length - 1) in obj,
	    'toArray: Object should have keys for indices'
	  ) : invariant(length === 0 ||
	  (length - 1) in obj));
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	module.exports = toArray;


/***/ }),
/* 920 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  * Reqwest! A general purpose XHR connection manager
	  * license MIT (c) Dustin Diaz 2015
	  * https://github.com/ded/reqwest
	  */
	
	!function (name, context, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else context[name] = definition()
	}('reqwest', this, function () {
	
	  var context = this
	
	  if ('window' in context) {
	    var doc = document
	      , byTag = 'getElementsByTagName'
	      , head = doc[byTag]('head')[0]
	  } else {
	    var XHR2
	    try {
	      XHR2 = __webpack_require__(1039)
	    } catch (ex) {
	      throw new Error('Peer dependency `xhr2` required! Please npm install xhr2')
	    }
	  }
	
	
	  var httpsRe = /^http/
	    , protocolRe = /(^\w+):\/\//
	    , twoHundo = /^(20\d|1223)$/ //http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	    , readyState = 'readyState'
	    , contentType = 'Content-Type'
	    , requestedWith = 'X-Requested-With'
	    , uniqid = 0
	    , callbackPrefix = 'reqwest_' + (+new Date())
	    , lastValue // data stored by the most recent JSONP callback
	    , xmlHttpRequest = 'XMLHttpRequest'
	    , xDomainRequest = 'XDomainRequest'
	    , noop = function () {}
	
	    , isArray = typeof Array.isArray == 'function'
	        ? Array.isArray
	        : function (a) {
	            return a instanceof Array
	          }
	
	    , defaultHeaders = {
	          'contentType': 'application/x-www-form-urlencoded'
	        , 'requestedWith': xmlHttpRequest
	        , 'accept': {
	              '*':  'text/javascript, text/html, application/xml, text/xml, */*'
	            , 'xml':  'application/xml, text/xml'
	            , 'html': 'text/html'
	            , 'text': 'text/plain'
	            , 'json': 'application/json, text/javascript'
	            , 'js':   'application/javascript, text/javascript'
	          }
	      }
	
	    , xhr = function(o) {
	        // is it x-domain
	        if (o['crossOrigin'] === true) {
	          var xhr = context[xmlHttpRequest] ? new XMLHttpRequest() : null
	          if (xhr && 'withCredentials' in xhr) {
	            return xhr
	          } else if (context[xDomainRequest]) {
	            return new XDomainRequest()
	          } else {
	            throw new Error('Browser does not support cross-origin requests')
	          }
	        } else if (context[xmlHttpRequest]) {
	          return new XMLHttpRequest()
	        } else if (XHR2) {
	          return new XHR2()
	        } else {
	          return new ActiveXObject('Microsoft.XMLHTTP')
	        }
	      }
	    , globalSetupOptions = {
	        dataFilter: function (data) {
	          return data
	        }
	      }
	
	  function succeed(r) {
	    var protocol = protocolRe.exec(r.url)
	    protocol = (protocol && protocol[1]) || context.location.protocol
	    return httpsRe.test(protocol) ? twoHundo.test(r.request.status) : !!r.request.response
	  }
	
	  function handleReadyState(r, success, error) {
	    return function () {
	      // use _aborted to mitigate against IE err c00c023f
	      // (can't read props on aborted request objects)
	      if (r._aborted) return error(r.request)
	      if (r._timedOut) return error(r.request, 'Request is aborted: timeout')
	      if (r.request && r.request[readyState] == 4) {
	        r.request.onreadystatechange = noop
	        if (succeed(r)) success(r.request)
	        else
	          error(r.request)
	      }
	    }
	  }
	
	  function setHeaders(http, o) {
	    var headers = o['headers'] || {}
	      , h
	
	    headers['Accept'] = headers['Accept']
	      || defaultHeaders['accept'][o['type']]
	      || defaultHeaders['accept']['*']
	
	    var isAFormData = typeof FormData !== 'undefined' && (o['data'] instanceof FormData);
	    // breaks cross-origin requests with legacy browsers
	    if (!o['crossOrigin'] && !headers[requestedWith]) headers[requestedWith] = defaultHeaders['requestedWith']
	    if (!headers[contentType] && !isAFormData) headers[contentType] = o['contentType'] || defaultHeaders['contentType']
	    for (h in headers)
	      headers.hasOwnProperty(h) && 'setRequestHeader' in http && http.setRequestHeader(h, headers[h])
	  }
	
	  function setCredentials(http, o) {
	    if (typeof o['withCredentials'] !== 'undefined' && typeof http.withCredentials !== 'undefined') {
	      http.withCredentials = !!o['withCredentials']
	    }
	  }
	
	  function generalCallback(data) {
	    lastValue = data
	  }
	
	  function urlappend (url, s) {
	    return url + (/\?/.test(url) ? '&' : '?') + s
	  }
	
	  function handleJsonp(o, fn, err, url) {
	    var reqId = uniqid++
	      , cbkey = o['jsonpCallback'] || 'callback' // the 'callback' key
	      , cbval = o['jsonpCallbackName'] || reqwest.getcallbackPrefix(reqId)
	      , cbreg = new RegExp('((^|\\?|&)' + cbkey + ')=([^&]+)')
	      , match = url.match(cbreg)
	      , script = doc.createElement('script')
	      , loaded = 0
	      , isIE10 = navigator.userAgent.indexOf('MSIE 10.0') !== -1
	
	    if (match) {
	      if (match[3] === '?') {
	        url = url.replace(cbreg, '$1=' + cbval) // wildcard callback func name
	      } else {
	        cbval = match[3] // provided callback func name
	      }
	    } else {
	      url = urlappend(url, cbkey + '=' + cbval) // no callback details, add 'em
	    }
	
	    context[cbval] = generalCallback
	
	    script.type = 'text/javascript'
	    script.src = url
	    script.async = true
	    if (typeof script.onreadystatechange !== 'undefined' && !isIE10) {
	      // need this for IE due to out-of-order onreadystatechange(), binding script
	      // execution to an event listener gives us control over when the script
	      // is executed. See http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
	      script.htmlFor = script.id = '_reqwest_' + reqId
	    }
	
	    script.onload = script.onreadystatechange = function () {
	      if ((script[readyState] && script[readyState] !== 'complete' && script[readyState] !== 'loaded') || loaded) {
	        return false
	      }
	      script.onload = script.onreadystatechange = null
	      script.onclick && script.onclick()
	      // Call the user callback with the last value stored and clean up values and scripts.
	      fn(lastValue)
	      lastValue = undefined
	      head.removeChild(script)
	      loaded = 1
	    }
	
	    // Add the script to the DOM head
	    head.appendChild(script)
	
	    // Enable JSONP timeout
	    return {
	      abort: function () {
	        script.onload = script.onreadystatechange = null
	        err({}, 'Request is aborted: timeout', {})
	        lastValue = undefined
	        head.removeChild(script)
	        loaded = 1
	      }
	    }
	  }
	
	  function getRequest(fn, err) {
	    var o = this.o
	      , method = (o['method'] || 'GET').toUpperCase()
	      , url = typeof o === 'string' ? o : o['url']
	      // convert non-string objects to query-string form unless o['processData'] is false
	      , data = (o['processData'] !== false && o['data'] && typeof o['data'] !== 'string')
	        ? reqwest.toQueryString(o['data'])
	        : (o['data'] || null)
	      , http
	      , sendWait = false
	
	    // if we're working on a GET request and we have data then we should append
	    // query string to end of URL and not post data
	    if ((o['type'] == 'jsonp' || method == 'GET') && data) {
	      url = urlappend(url, data)
	      data = null
	    }
	
	    if (o['type'] == 'jsonp') return handleJsonp(o, fn, err, url)
	
	    // get the xhr from the factory if passed
	    // if the factory returns null, fall-back to ours
	    http = (o.xhr && o.xhr(o)) || xhr(o)
	
	    http.open(method, url, o['async'] === false ? false : true)
	    setHeaders(http, o)
	    setCredentials(http, o)
	    if (context[xDomainRequest] && http instanceof context[xDomainRequest]) {
	        http.onload = fn
	        http.onerror = err
	        // NOTE: see
	        // http://social.msdn.microsoft.com/Forums/en-US/iewebdevelopment/thread/30ef3add-767c-4436-b8a9-f1ca19b4812e
	        http.onprogress = function() {}
	        sendWait = true
	    } else {
	      http.onreadystatechange = handleReadyState(this, fn, err)
	    }
	    o['before'] && o['before'](http)
	    if (sendWait) {
	      setTimeout(function () {
	        http.send(data)
	      }, 200)
	    } else {
	      http.send(data)
	    }
	    return http
	  }
	
	  function Reqwest(o, fn) {
	    this.o = o
	    this.fn = fn
	
	    init.apply(this, arguments)
	  }
	
	  function setType(header) {
	    // json, javascript, text/plain, text/html, xml
	    if (header === null) return undefined; //In case of no content-type.
	    if (header.match('json')) return 'json'
	    if (header.match('javascript')) return 'js'
	    if (header.match('text')) return 'html'
	    if (header.match('xml')) return 'xml'
	  }
	
	  function init(o, fn) {
	
	    this.url = typeof o == 'string' ? o : o['url']
	    this.timeout = null
	
	    // whether request has been fulfilled for purpose
	    // of tracking the Promises
	    this._fulfilled = false
	    // success handlers
	    this._successHandler = function(){}
	    this._fulfillmentHandlers = []
	    // error handlers
	    this._errorHandlers = []
	    // complete (both success and fail) handlers
	    this._completeHandlers = []
	    this._erred = false
	    this._responseArgs = {}
	
	    var self = this
	
	    fn = fn || function () {}
	
	    if (o['timeout']) {
	      this.timeout = setTimeout(function () {
	        timedOut()
	      }, o['timeout'])
	    }
	
	    if (o['success']) {
	      this._successHandler = function () {
	        o['success'].apply(o, arguments)
	      }
	    }
	
	    if (o['error']) {
	      this._errorHandlers.push(function () {
	        o['error'].apply(o, arguments)
	      })
	    }
	
	    if (o['complete']) {
	      this._completeHandlers.push(function () {
	        o['complete'].apply(o, arguments)
	      })
	    }
	
	    function complete (resp) {
	      o['timeout'] && clearTimeout(self.timeout)
	      self.timeout = null
	      while (self._completeHandlers.length > 0) {
	        self._completeHandlers.shift()(resp)
	      }
	    }
	
	    function success (resp) {
	      var type = o['type'] || resp && setType(resp.getResponseHeader('Content-Type')) // resp can be undefined in IE
	      resp = (type !== 'jsonp') ? self.request : resp
	      // use global data filter on response text
	      var filteredResponse = globalSetupOptions.dataFilter(resp.responseText, type)
	        , r = filteredResponse
	      try {
	        resp.responseText = r
	      } catch (e) {
	        // can't assign this in IE<=8, just ignore
	      }
	      if (r) {
	        switch (type) {
	        case 'json':
	          try {
	            resp = context.JSON ? context.JSON.parse(r) : eval('(' + r + ')')
	          } catch (err) {
	            return error(resp, 'Could not parse JSON in response', err)
	          }
	          break
	        case 'js':
	          resp = eval(r)
	          break
	        case 'html':
	          resp = r
	          break
	        case 'xml':
	          resp = resp.responseXML
	              && resp.responseXML.parseError // IE trololo
	              && resp.responseXML.parseError.errorCode
	              && resp.responseXML.parseError.reason
	            ? null
	            : resp.responseXML
	          break
	        }
	      }
	
	      self._responseArgs.resp = resp
	      self._fulfilled = true
	      fn(resp)
	      self._successHandler(resp)
	      while (self._fulfillmentHandlers.length > 0) {
	        resp = self._fulfillmentHandlers.shift()(resp)
	      }
	
	      complete(resp)
	    }
	
	    function timedOut() {
	      self._timedOut = true
	      self.request.abort()
	    }
	
	    function error(resp, msg, t) {
	      resp = self.request
	      self._responseArgs.resp = resp
	      self._responseArgs.msg = msg
	      self._responseArgs.t = t
	      self._erred = true
	      while (self._errorHandlers.length > 0) {
	        self._errorHandlers.shift()(resp, msg, t)
	      }
	      complete(resp)
	    }
	
	    this.request = getRequest.call(this, success, error)
	  }
	
	  Reqwest.prototype = {
	    abort: function () {
	      this._aborted = true
	      this.request.abort()
	    }
	
	  , retry: function () {
	      init.call(this, this.o, this.fn)
	    }
	
	    /**
	     * Small deviation from the Promises A CommonJs specification
	     * http://wiki.commonjs.org/wiki/Promises/A
	     */
	
	    /**
	     * `then` will execute upon successful requests
	     */
	  , then: function (success, fail) {
	      success = success || function () {}
	      fail = fail || function () {}
	      if (this._fulfilled) {
	        this._responseArgs.resp = success(this._responseArgs.resp)
	      } else if (this._erred) {
	        fail(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
	      } else {
	        this._fulfillmentHandlers.push(success)
	        this._errorHandlers.push(fail)
	      }
	      return this
	    }
	
	    /**
	     * `always` will execute whether the request succeeds or fails
	     */
	  , always: function (fn) {
	      if (this._fulfilled || this._erred) {
	        fn(this._responseArgs.resp)
	      } else {
	        this._completeHandlers.push(fn)
	      }
	      return this
	    }
	
	    /**
	     * `fail` will execute when the request fails
	     */
	  , fail: function (fn) {
	      if (this._erred) {
	        fn(this._responseArgs.resp, this._responseArgs.msg, this._responseArgs.t)
	      } else {
	        this._errorHandlers.push(fn)
	      }
	      return this
	    }
	  , 'catch': function (fn) {
	      return this.fail(fn)
	    }
	  }
	
	  function reqwest(o, fn) {
	    return new Reqwest(o, fn)
	  }
	
	  // normalize newline variants according to spec -> CRLF
	  function normalize(s) {
	    return s ? s.replace(/\r?\n/g, '\r\n') : ''
	  }
	
	  function serial(el, cb) {
	    var n = el.name
	      , t = el.tagName.toLowerCase()
	      , optCb = function (o) {
	          // IE gives value="" even where there is no value attribute
	          // 'specified' ref: http://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-862529273
	          if (o && !o['disabled'])
	            cb(n, normalize(o['attributes']['value'] && o['attributes']['value']['specified'] ? o['value'] : o['text']))
	        }
	      , ch, ra, val, i
	
	    // don't serialize elements that are disabled or without a name
	    if (el.disabled || !n) return
	
	    switch (t) {
	    case 'input':
	      if (!/reset|button|image|file/i.test(el.type)) {
	        ch = /checkbox/i.test(el.type)
	        ra = /radio/i.test(el.type)
	        val = el.value
	        // WebKit gives us "" instead of "on" if a checkbox has no value, so correct it here
	        ;(!(ch || ra) || el.checked) && cb(n, normalize(ch && val === '' ? 'on' : val))
	      }
	      break
	    case 'textarea':
	      cb(n, normalize(el.value))
	      break
	    case 'select':
	      if (el.type.toLowerCase() === 'select-one') {
	        optCb(el.selectedIndex >= 0 ? el.options[el.selectedIndex] : null)
	      } else {
	        for (i = 0; el.length && i < el.length; i++) {
	          el.options[i].selected && optCb(el.options[i])
	        }
	      }
	      break
	    }
	  }
	
	  // collect up all form elements found from the passed argument elements all
	  // the way down to child elements; pass a '<form>' or form fields.
	  // called with 'this'=callback to use for serial() on each element
	  function eachFormElement() {
	    var cb = this
	      , e, i
	      , serializeSubtags = function (e, tags) {
	          var i, j, fa
	          for (i = 0; i < tags.length; i++) {
	            fa = e[byTag](tags[i])
	            for (j = 0; j < fa.length; j++) serial(fa[j], cb)
	          }
	        }
	
	    for (i = 0; i < arguments.length; i++) {
	      e = arguments[i]
	      if (/input|select|textarea/i.test(e.tagName)) serial(e, cb)
	      serializeSubtags(e, [ 'input', 'select', 'textarea' ])
	    }
	  }
	
	  // standard query string style serialization
	  function serializeQueryString() {
	    return reqwest.toQueryString(reqwest.serializeArray.apply(null, arguments))
	  }
	
	  // { 'name': 'value', ... } style serialization
	  function serializeHash() {
	    var hash = {}
	    eachFormElement.apply(function (name, value) {
	      if (name in hash) {
	        hash[name] && !isArray(hash[name]) && (hash[name] = [hash[name]])
	        hash[name].push(value)
	      } else hash[name] = value
	    }, arguments)
	    return hash
	  }
	
	  // [ { name: 'name', value: 'value' }, ... ] style serialization
	  reqwest.serializeArray = function () {
	    var arr = []
	    eachFormElement.apply(function (name, value) {
	      arr.push({name: name, value: value})
	    }, arguments)
	    return arr
	  }
	
	  reqwest.serialize = function () {
	    if (arguments.length === 0) return ''
	    var opt, fn
	      , args = Array.prototype.slice.call(arguments, 0)
	
	    opt = args.pop()
	    opt && opt.nodeType && args.push(opt) && (opt = null)
	    opt && (opt = opt.type)
	
	    if (opt == 'map') fn = serializeHash
	    else if (opt == 'array') fn = reqwest.serializeArray
	    else fn = serializeQueryString
	
	    return fn.apply(null, args)
	  }
	
	  reqwest.toQueryString = function (o, trad) {
	    var prefix, i
	      , traditional = trad || false
	      , s = []
	      , enc = encodeURIComponent
	      , add = function (key, value) {
	          // If value is a function, invoke it and return its value
	          value = ('function' === typeof value) ? value() : (value == null ? '' : value)
	          s[s.length] = enc(key) + '=' + enc(value)
	        }
	    // If an array was passed in, assume that it is an array of form elements.
	    if (isArray(o)) {
	      for (i = 0; o && i < o.length; i++) add(o[i]['name'], o[i]['value'])
	    } else {
	      // If traditional, encode the "old" way (the way 1.3.2 or older
	      // did it), otherwise encode params recursively.
	      for (prefix in o) {
	        if (o.hasOwnProperty(prefix)) buildParams(prefix, o[prefix], traditional, add)
	      }
	    }
	
	    // spaces should be + according to spec
	    return s.join('&').replace(/%20/g, '+')
	  }
	
	  function buildParams(prefix, obj, traditional, add) {
	    var name, i, v
	      , rbracket = /\[\]$/
	
	    if (isArray(obj)) {
	      // Serialize array item.
	      for (i = 0; obj && i < obj.length; i++) {
	        v = obj[i]
	        if (traditional || rbracket.test(prefix)) {
	          // Treat each array item as a scalar.
	          add(prefix, v)
	        } else {
	          buildParams(prefix + '[' + (typeof v === 'object' ? i : '') + ']', v, traditional, add)
	        }
	      }
	    } else if (obj && obj.toString() === '[object Object]') {
	      // Serialize object item.
	      for (name in obj) {
	        buildParams(prefix + '[' + name + ']', obj[name], traditional, add)
	      }
	
	    } else {
	      // Serialize scalar item.
	      add(prefix, obj)
	    }
	  }
	
	  reqwest.getcallbackPrefix = function () {
	    return callbackPrefix
	  }
	
	  // jQuery and Zepto compatibility, differences can be remapped here so you can call
	  // .ajax.compat(options, callback)
	  reqwest.compat = function (o, fn) {
	    if (o) {
	      o['type'] && (o['method'] = o['type']) && delete o['type']
	      o['dataType'] && (o['type'] = o['dataType'])
	      o['jsonpCallback'] && (o['jsonpCallbackName'] = o['jsonpCallback']) && delete o['jsonpCallback']
	      o['jsonp'] && (o['jsonpCallback'] = o['jsonp'])
	    }
	    return new Reqwest(o, fn)
	  }
	
	  reqwest.ajaxSetup = function (options) {
	    options = options || {}
	    for (var k in options) {
	      globalSetupOptions[k] = options[k]
	    }
	  }
	
	  return reqwest
	});


/***/ }),
/* 922 */
/***/ (function(module, exports) {

	module.exports = SafeParseTuple
	
	function SafeParseTuple(obj, reviver) {
	    var json
	    var error = null
	
	    try {
	        json = JSON.parse(obj, reviver)
	    } catch (err) {
	        error = err
	    }
	
	    return [error, json]
	}


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(271)))

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Copyright (c) 2011-2014 Felix Gnass
	 * Licensed under the MIT license
	 * http://spin.js.org/
	 *
	 * Example:
	    var opts = {
	      lines: 12             // The number of lines to draw
	    , length: 7             // The length of each line
	    , width: 5              // The line thickness
	    , radius: 10            // The radius of the inner circle
	    , scale: 1.0            // Scales overall size of the spinner
	    , corners: 1            // Roundness (0..1)
	    , color: '#000'         // #rgb or #rrggbb
	    , opacity: 1/4          // Opacity of the lines
	    , rotate: 0             // Rotation offset
	    , direction: 1          // 1: clockwise, -1: counterclockwise
	    , speed: 1              // Rounds per second
	    , trail: 100            // Afterglow percentage
	    , fps: 20               // Frames per second when using setTimeout()
	    , zIndex: 2e9           // Use a high z-index by default
	    , className: 'spinner'  // CSS class to assign to the element
	    , top: '50%'            // center vertically
	    , left: '50%'           // center horizontally
	    , shadow: false         // Whether to render a shadow
	    , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	    , position: 'absolute'  // Element positioning
	    }
	    var target = document.getElementById('foo')
	    var spinner = new Spinner(opts).spin(target)
	 */
	;(function (root, factory) {
	
	  /* CommonJS */
	  if (typeof module == 'object' && module.exports) module.exports = factory()
	
	  /* AMD module */
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	
	  /* Browser global */
	  else root.Spinner = factory()
	}(this, function () {
	  "use strict"
	
	  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */
	    , animations = {} /* Animation rules keyed by their name */
	    , useCssAnimations /* Whether to use CSS animations or setTimeout */
	    , sheet /* A stylesheet to hold the @keyframe or VML rules. */
	
	  /**
	   * Utility function to create elements. If no tag name is given,
	   * a DIV is created. Optionally properties can be passed.
	   */
	  function createEl (tag, prop) {
	    var el = document.createElement(tag || 'div')
	      , n
	
	    for (n in prop) el[n] = prop[n]
	    return el
	  }
	
	  /**
	   * Appends children and returns the parent.
	   */
	  function ins (parent /* child1, child2, ...*/) {
	    for (var i = 1, n = arguments.length; i < n; i++) {
	      parent.appendChild(arguments[i])
	    }
	
	    return parent
	  }
	
	  /**
	   * Creates an opacity keyframe animation rule and returns its name.
	   * Since most mobile Webkits have timing issues with animation-delay,
	   * we create separate rules for each line/segment.
	   */
	  function addAnimation (alpha, trail, i, lines) {
	    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-')
	      , start = 0.01 + i/lines * 100
	      , z = Math.max(1 - (1-alpha) / trail * (100-start), alpha)
	      , prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase()
	      , pre = prefix && '-' + prefix + '-' || ''
	
	    if (!animations[name]) {
	      sheet.insertRule(
	        '@' + pre + 'keyframes ' + name + '{' +
	        '0%{opacity:' + z + '}' +
	        start + '%{opacity:' + alpha + '}' +
	        (start+0.01) + '%{opacity:1}' +
	        (start+trail) % 100 + '%{opacity:' + alpha + '}' +
	        '100%{opacity:' + z + '}' +
	        '}', sheet.cssRules.length)
	
	      animations[name] = 1
	    }
	
	    return name
	  }
	
	  /**
	   * Tries various vendor prefixes and returns the first supported property.
	   */
	  function vendor (el, prop) {
	    var s = el.style
	      , pp
	      , i
	
	    prop = prop.charAt(0).toUpperCase() + prop.slice(1)
	    if (s[prop] !== undefined) return prop
	    for (i = 0; i < prefixes.length; i++) {
	      pp = prefixes[i]+prop
	      if (s[pp] !== undefined) return pp
	    }
	  }
	
	  /**
	   * Sets multiple style properties at once.
	   */
	  function css (el, prop) {
	    for (var n in prop) {
	      el.style[vendor(el, n) || n] = prop[n]
	    }
	
	    return el
	  }
	
	  /**
	   * Fills in default values.
	   */
	  function merge (obj) {
	    for (var i = 1; i < arguments.length; i++) {
	      var def = arguments[i]
	      for (var n in def) {
	        if (obj[n] === undefined) obj[n] = def[n]
	      }
	    }
	    return obj
	  }
	
	  /**
	   * Returns the line color from the given string or array.
	   */
	  function getColor (color, idx) {
	    return typeof color == 'string' ? color : color[idx % color.length]
	  }
	
	  // Built-in defaults
	
	  var defaults = {
	    lines: 12             // The number of lines to draw
	  , length: 7             // The length of each line
	  , width: 5              // The line thickness
	  , radius: 10            // The radius of the inner circle
	  , scale: 1.0            // Scales overall size of the spinner
	  , corners: 1            // Roundness (0..1)
	  , color: '#000'         // #rgb or #rrggbb
	  , opacity: 1/4          // Opacity of the lines
	  , rotate: 0             // Rotation offset
	  , direction: 1          // 1: clockwise, -1: counterclockwise
	  , speed: 1              // Rounds per second
	  , trail: 100            // Afterglow percentage
	  , fps: 20               // Frames per second when using setTimeout()
	  , zIndex: 2e9           // Use a high z-index by default
	  , className: 'spinner'  // CSS class to assign to the element
	  , top: '50%'            // center vertically
	  , left: '50%'           // center horizontally
	  , shadow: false         // Whether to render a shadow
	  , hwaccel: false        // Whether to use hardware acceleration (might be buggy)
	  , position: 'absolute'  // Element positioning
	  }
	
	  /** The constructor */
	  function Spinner (o) {
	    this.opts = merge(o || {}, Spinner.defaults, defaults)
	  }
	
	  // Global defaults that override the built-ins:
	  Spinner.defaults = {}
	
	  merge(Spinner.prototype, {
	    /**
	     * Adds the spinner to the given target element. If this instance is already
	     * spinning, it is automatically removed from its previous target b calling
	     * stop() internally.
	     */
	    spin: function (target) {
	      this.stop()
	
	      var self = this
	        , o = self.opts
	        , el = self.el = createEl(null, {className: o.className})
	
	      css(el, {
	        position: o.position
	      , width: 0
	      , zIndex: o.zIndex
	      , left: o.left
	      , top: o.top
	      })
	
	      if (target) {
	        target.insertBefore(el, target.firstChild || null)
	      }
	
	      el.setAttribute('role', 'progressbar')
	      self.lines(el, self.opts)
	
	      if (!useCssAnimations) {
	        // No CSS animation support, use setTimeout() instead
	        var i = 0
	          , start = (o.lines - 1) * (1 - o.direction) / 2
	          , alpha
	          , fps = o.fps
	          , f = fps / o.speed
	          , ostep = (1 - o.opacity) / (f * o.trail / 100)
	          , astep = f / o.lines
	
	        ;(function anim () {
	          i++
	          for (var j = 0; j < o.lines; j++) {
	            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity)
	
	            self.opacity(el, j * o.direction + start, alpha, o)
	          }
	          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps))
	        })()
	      }
	      return self
	    }
	
	    /**
	     * Stops and removes the Spinner.
	     */
	  , stop: function () {
	      var el = this.el
	      if (el) {
	        clearTimeout(this.timeout)
	        if (el.parentNode) el.parentNode.removeChild(el)
	        this.el = undefined
	      }
	      return this
	    }
	
	    /**
	     * Internal method that draws the individual lines. Will be overwritten
	     * in VML fallback mode below.
	     */
	  , lines: function (el, o) {
	      var i = 0
	        , start = (o.lines - 1) * (1 - o.direction) / 2
	        , seg
	
	      function fill (color, shadow) {
	        return css(createEl(), {
	          position: 'absolute'
	        , width: o.scale * (o.length + o.width) + 'px'
	        , height: o.scale * o.width + 'px'
	        , background: color
	        , boxShadow: shadow
	        , transformOrigin: 'left'
	        , transform: 'rotate(' + ~~(360/o.lines*i + o.rotate) + 'deg) translate(' + o.scale*o.radius + 'px' + ',0)'
	        , borderRadius: (o.corners * o.scale * o.width >> 1) + 'px'
	        })
	      }
	
	      for (; i < o.lines; i++) {
	        seg = css(createEl(), {
	          position: 'absolute'
	        , top: 1 + ~(o.scale * o.width / 2) + 'px'
	        , transform: o.hwaccel ? 'translate3d(0,0,0)' : ''
	        , opacity: o.opacity
	        , animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
	        })
	
	        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px #000'), {top: '2px'}))
	        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')))
	      }
	      return el
	    }
	
	    /**
	     * Internal method that adjusts the opacity of a single line.
	     * Will be overwritten in VML fallback mode below.
	     */
	  , opacity: function (el, i, val) {
	      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val
	    }
	
	  })
	
	
	  function initVML () {
	
	    /* Utility function to create a VML tag */
	    function vml (tag, attr) {
	      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr)
	    }
	
	    // No CSS transforms but VML support, add a CSS rule for VML elements:
	    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)')
	
	    Spinner.prototype.lines = function (el, o) {
	      var r = o.scale * (o.length + o.width)
	        , s = o.scale * 2 * r
	
	      function grp () {
	        return css(
	          vml('group', {
	            coordsize: s + ' ' + s
	          , coordorigin: -r + ' ' + -r
	          })
	        , { width: s, height: s }
	        )
	      }
	
	      var margin = -(o.width + o.length) * o.scale * 2 + 'px'
	        , g = css(grp(), {position: 'absolute', top: margin, left: margin})
	        , i
	
	      function seg (i, dx, filter) {
	        ins(
	          g
	        , ins(
	            css(grp(), {rotation: 360 / o.lines * i + 'deg', left: ~~dx})
	          , ins(
	              css(
	                vml('roundrect', {arcsize: o.corners})
	              , { width: r
	                , height: o.scale * o.width
	                , left: o.scale * o.radius
	                , top: -o.scale * o.width >> 1
	                , filter: filter
	                }
	              )
	            , vml('fill', {color: getColor(o.color, i), opacity: o.opacity})
	            , vml('stroke', {opacity: 0}) // transparent stroke to fix color bleeding upon opacity change
	            )
	          )
	        )
	      }
	
	      if (o.shadow)
	        for (i = 1; i <= o.lines; i++) {
	          seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)')
	        }
	
	      for (i = 1; i <= o.lines; i++) seg(i)
	      return ins(el, g)
	    }
	
	    Spinner.prototype.opacity = function (el, i, val, o) {
	      var c = el.firstChild
	      o = o.shadow && o.lines || 0
	      if (c && i + o < c.childNodes.length) {
	        c = c.childNodes[i + o]; c = c && c.firstChild; c = c && c.firstChild
	        if (c) c.opacity = val
	      }
	    }
	  }
	
	  if (typeof document !== 'undefined') {
	    sheet = (function () {
	      var el = createEl('style', {type : 'text/css'})
	      ins(document.getElementsByTagName('head')[0], el)
	      return el.sheet || el.styleSheet
	    }())
	
	    var probe = css(createEl('group'), {behavior: 'url(#default#VML)'})
	
	    if (!vendor(probe, 'transform') && probe.adj) initVML()
	    else useCssAnimations = vendor(probe, 'animation')
	  }
	
	  return Spinner
	
	}));


/***/ }),
/* 925 */
/***/ (function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();
	
	exports.getComponent = getComponent;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _tcombValidation = __webpack_require__(138);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	var _uvdomReact = __webpack_require__(971);
	
	var _util = __webpack_require__(928);
	
	var _classnames = __webpack_require__(14);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var Nil = _tcombValidation2['default'].Nil;
	var assert = _tcombValidation2['default'].assert;
	var SOURCE = 'tcomb-form';
	var noobj = Object.freeze({});
	var noarr = Object.freeze([]);
	var noop = function noop() {};
	
	function getComponent(_x, _x2) {
	  var _again = true;
	
	  _function: while (_again) {
	    var type = _x,
	        options = _x2;
	    name = undefined;
	    _again = false;
	
	    if (options.factory) {
	      return options.factory;
	    }
	    var name = _tcombValidation2['default'].getTypeName(type);
	    switch (type.meta.kind) {
	      case 'irreducible':
	        return type === _tcombValidation2['default'].Bool ? Checkbox : type === _tcombValidation2['default'].Dat ? Datetime : Textbox;
	      case 'struct':
	        return Struct;
	      case 'list':
	        return List;
	      case 'enums':
	        return Select;
	      case 'maybe':
	      case 'subtype':
	        _x = type.meta.type;
	        _x2 = options;
	        _again = true;
	        continue _function;
	
	      default:
	        _tcombValidation2['default'].fail('[' + SOURCE + '] unsupported type ' + name);
	    }
	  }
	}
	
	function sortByText(a, b) {
	  return a.text < b.text ? -1 : a.text > b.text ? 1 : 0;
	}
	
	function getComparator(order) {
	  return ({
	    asc: sortByText,
	    desc: function desc(a, b) {
	      return -sortByText(a, b);
	    }
	  })[order];
	}
	
	var decorators = {
	
	  template: function template(name) {
	    return function (Component) {
	      Component.prototype.getTemplate = function getTemplate() {
	        return this.props.options.template || this.props.ctx.templates[name];
	      };
	    };
	  },
	
	  attrs: function attrs(Component) {
	    Component.prototype.getAttrs = function getAttrs() {
	      var attrs = _tcombValidation2['default'].mixin({}, this.props.options.attrs);
	      attrs.id = this.getId();
	      attrs.name = this.getName();
	      if (attrs.className) {
	        var _attrs$className;
	
	        attrs.className = (_attrs$className = {}, _attrs$className[_classnames2['default'](attrs.className)] = true, _attrs$className);
	      }
	      return attrs;
	    };
	  },
	
	  templates: function templates(Component) {
	    Component.prototype.getTemplates = function getTemplates() {
	      return _util.merge(this.props.ctx.templates, this.props.options.templates);
	    };
	  }
	
	};
	
	exports.decorators = decorators;
	
	var Component = (function (_React$Component) {
	  _inherits(Component, _React$Component);
	
	  _createClass(Component, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  function Component(props) {
	    _classCallCheck(this, Component);
	
	    _React$Component.call(this, props);
	    this.typeInfo = _util.getTypeInfo(props.type);
	    this.state = {
	      hasError: false,
	      value: this.getTransformer().format(props.value)
	    };
	  }
	
	  Component.prototype.getTransformer = function getTransformer() {
	    return this.props.options.transformer || this.constructor.transformer;
	  };
	
	  Component.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    var should = nextState.value !== this.state.value || nextState.hasError !== this.state.hasError || nextProps.options !== this.props.options || nextProps.type !== this.props.type;
	    // console.log(nextState.value !== this.state.value,
	    //   nextState.hasError !== this.state.hasError,
	    //   nextProps.options !== this.props.options,
	    //   nextProps.type !== this.props.type,
	    //   should);
	    return should;
	  };
	
	  Component.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.type !== this.props.type) {
	      this.typeInfo = _util.getTypeInfo(props.type);
	    }
	    this.setState({ value: this.getTransformer().format(props.value) });
	  };
	
	  Component.prototype.onChange = function onChange(value) {
	    var _this = this;
	
	    this.setState({ value: value }, function () {
	      _this.props.onChange(value, _this.props.ctx.path);
	    });
	  };
	
	  Component.prototype.getValidationOptions = function getValidationOptions() {
	    return {
	      path: this.props.ctx.path,
	      context: _tcombValidation2['default'].mixin(_tcombValidation2['default'].mixin({}, this.props.context || this.props.ctx.context), { options: this.props.options })
	    };
	  };
	
	  Component.prototype.isValueNully = function isValueNully() {
	    return Nil.is(this.getTransformer().parse(this.state.value));
	  };
	
	  Component.prototype.removeErrors = function removeErrors() {
	    this.setState({ hasError: false });
	  };
	
	  Component.prototype.validate = function validate() {
	    var value = this.getTransformer().parse(this.state.value);
	    var result = _tcombValidation2['default'].validate(value, this.props.type, this.getValidationOptions());
	    this.setState({ hasError: !result.isValid() });
	    return result;
	  };
	
	  Component.prototype.getAuto = function getAuto() {
	    return this.props.options.auto || this.props.ctx.auto;
	  };
	
	  Component.prototype.getI18n = function getI18n() {
	    return this.props.options.i18n || this.props.ctx.i18n;
	  };
	
	  Component.prototype.getDefaultLabel = function getDefaultLabel() {
	    var ctx = this.props.ctx;
	    if (ctx.label) {
	      return ctx.label + (this.typeInfo.isMaybe ? this.getI18n().optional : this.getI18n().required);
	    }
	  };
	
	  Component.prototype.getLabel = function getLabel() {
	    var ctx = this.props.ctx;
	    var legend = this.props.options.legend;
	    var label = this.props.options.label;
	    label = label || legend;
	    if (Nil.is(label) && ctx.auto === 'labels') {
	      label = this.getDefaultLabel();
	    }
	    return label;
	  };
	
	  Component.prototype.getError = function getError() {
	    var error = this.props.options.error || this.typeInfo.getValidationErrorMessage;
	    if (_tcombValidation2['default'].Func.is(error)) {
	      var validationOptions = this.getValidationOptions();
	      var value = this.getTransformer().parse(this.state.value);
	      return error(value, validationOptions.path, validationOptions.context);
	    }
	    return error;
	  };
	
	  Component.prototype.hasError = function hasError() {
	    return this.props.options.hasError || this.state.hasError;
	  };
	
	  Component.prototype.getConfig = function getConfig() {
	    return _util.merge(this.props.ctx.config, this.props.options.config);
	  };
	
	  Component.prototype.getId = function getId() {
	    var attrs = this.props.options.attrs || noobj;
	    if (attrs.id) {
	      return attrs.id;
	    }
	    if (!this.uid) {
	      this.uid = this.props.ctx.uidGenerator.next();
	    }
	    return this.uid;
	  };
	
	  Component.prototype.getName = function getName() {
	    return this.props.options.name || this.props.ctx.name || this.getId();
	  };
	
	  Component.prototype.getLocals = function getLocals() {
	    var options = this.props.options;
	    var value = this.state.value;
	    return {
	      typeInfo: this.typeInfo,
	      path: this.props.ctx.path,
	      error: this.getError(),
	      hasError: this.hasError(),
	      label: this.getLabel(),
	      onChange: this.onChange.bind(this),
	      config: this.getConfig(),
	      value: value,
	      disabled: options.disabled,
	      help: options.help
	    };
	  };
	
	  Component.prototype.render = function render() {
	    var locals = this.getLocals();
	    // getTemplate is the only required implementation when extending Component
	    assert(_tcombValidation2['default'].Func.is(this.getTemplate), '[' + SOURCE + '] missing getTemplate method of component ' + this.constructor.name);
	    var template = this.getTemplate();
	    return _uvdomReact.compile(template(locals));
	  };
	
	  return Component;
	})(_react2['default'].Component);
	
	exports.Component = Component;
	
	function toNull(value) {
	  return _tcombValidation2['default'].Str.is(value) && value.trim() === '' || Nil.is(value) ? null : value;
	}
	
	function parseNumber(value) {
	  var n = parseFloat(value);
	  var isNumeric = value - n + 1 >= 0;
	  return isNumeric ? n : toNull(value);
	}
	
	var Textbox = (function (_Component) {
	  _inherits(Textbox, _Component);
	
	  function Textbox() {
	    _classCallCheck(this, _Textbox);
	
	    _Component.apply(this, arguments);
	  }
	
	  Textbox.prototype.getTransformer = function getTransformer() {
	    var options = this.props.options;
	    return options.transformer ? options.transformer : this.typeInfo.innerType === _tcombValidation2['default'].Num ? Textbox.numberTransformer : Textbox.transformer;
	  };
	
	  Textbox.prototype.getPlaceholder = function getPlaceholder() {
	    var attrs = this.props.options.attrs || noobj;
	    var placeholder = attrs.placeholder;
	    if (Nil.is(placeholder) && this.getAuto() === 'placeholders') {
	      placeholder = this.getDefaultLabel();
	    }
	    return placeholder;
	  };
	
	  Textbox.prototype.getLocals = function getLocals() {
	    var locals = _Component.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.attrs.placeholder = this.getPlaceholder();
	    locals.type = this.props.options.type || 'text';
	    return locals;
	  };
	
	  _createClass(Textbox, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : value;
	      },
	      parse: toNull
	    },
	    enumerable: true
	  }, {
	    key: 'numberTransformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : String(value);
	      },
	      parse: parseNumber
	    },
	    enumerable: true
	  }]);
	
	  var _Textbox = Textbox;
	  Textbox = decorators.template('textbox')(Textbox) || Textbox;
	  Textbox = decorators.attrs(Textbox) || Textbox;
	  return Textbox;
	})(Component);
	
	exports.Textbox = Textbox;
	
	var Checkbox = (function (_Component2) {
	  _inherits(Checkbox, _Component2);
	
	  function Checkbox() {
	    _classCallCheck(this, _Checkbox);
	
	    _Component2.apply(this, arguments);
	  }
	
	  Checkbox.prototype.getLocals = function getLocals() {
	    var locals = _Component2.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    // checkboxes must always have a label
	    locals.label = locals.label || this.getDefaultLabel();
	    return locals;
	  };
	
	  _createClass(Checkbox, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? false : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Checkbox = Checkbox;
	  Checkbox = decorators.template('checkbox')(Checkbox) || Checkbox;
	  Checkbox = decorators.attrs(Checkbox) || Checkbox;
	  return Checkbox;
	})(Component);
	
	exports.Checkbox = Checkbox;
	
	var Select = (function (_Component3) {
	  _inherits(Select, _Component3);
	
	  function Select() {
	    _classCallCheck(this, _Select);
	
	    _Component3.apply(this, arguments);
	  }
	
	  Select.prototype.getTransformer = function getTransformer() {
	    var options = this.props.options;
	    if (options.transformer) {
	      return options.transformer;
	    }
	    if (this.isMultiple()) {
	      return Select.multipleTransformer;
	    }
	    return Select.transformer(this.getNullOption());
	  };
	
	  Select.prototype.getNullOption = function getNullOption() {
	    return this.props.options.nullOption || { value: '', text: '-' };
	  };
	
	  Select.prototype.isMultiple = function isMultiple() {
	    return this.typeInfo.innerType.meta.kind === 'list';
	  };
	
	  Select.prototype.getEnum = function getEnum() {
	    return this.isMultiple() ? _util.getTypeInfo(this.typeInfo.innerType.meta.type).innerType : this.typeInfo.innerType;
	  };
	
	  Select.prototype.getOptions = function getOptions() {
	    var options = this.props.options;
	    var items = options.options ? options.options.slice() : _util.getOptionsOfEnum(this.getEnum());
	    if (options.order) {
	      items.sort(getComparator(options.order));
	    }
	    var nullOption = this.getNullOption();
	    if (!this.isMultiple() && options.nullOption !== false) {
	      items.unshift(nullOption);
	    }
	    return items;
	  };
	
	  Select.prototype.getLocals = function getLocals() {
	    var locals = _Component3.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.options = this.getOptions();
	    locals.isMultiple = this.isMultiple();
	    return locals;
	  };
	
	  _createClass(Select, null, [{
	    key: 'transformer',
	    value: function value(nullOption) {
	      return {
	        format: function format(value) {
	          return Nil.is(value) && nullOption ? nullOption.value : value;
	        },
	        parse: function parse(value) {
	          return nullOption && nullOption.value === value ? null : value;
	        }
	      };
	    },
	    enumerable: true
	  }, {
	    key: 'multipleTransformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? noarr : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Select = Select;
	  Select = decorators.template('select')(Select) || Select;
	  Select = decorators.attrs(Select) || Select;
	  return Select;
	})(Component);
	
	exports.Select = Select;
	
	var Radio = (function (_Component4) {
	  _inherits(Radio, _Component4);
	
	  function Radio() {
	    _classCallCheck(this, _Radio);
	
	    _Component4.apply(this, arguments);
	  }
	
	  Radio.prototype.getOptions = function getOptions() {
	    var options = this.props.options;
	    var items = options.options ? options.options.slice() : _util.getOptionsOfEnum(this.typeInfo.innerType);
	    if (options.order) {
	      items.sort(getComparator(options.order));
	    }
	    return items;
	  };
	
	  Radio.prototype.getLocals = function getLocals() {
	    var locals = _Component4.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.options = this.getOptions();
	    return locals;
	  };
	
	  _createClass(Radio, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? null : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Radio = Radio;
	  Radio = decorators.template('radio')(Radio) || Radio;
	  Radio = decorators.attrs(Radio) || Radio;
	  return Radio;
	})(Component);
	
	exports.Radio = Radio;
	
	var Datetime = (function (_Component5) {
	  _inherits(Datetime, _Component5);
	
	  function Datetime() {
	    _classCallCheck(this, _Datetime);
	
	    _Component5.apply(this, arguments);
	  }
	
	  Datetime.prototype.getOrder = function getOrder() {
	    return this.props.options.order || ['M', 'D', 'YY'];
	  };
	
	  Datetime.prototype.getLocals = function getLocals() {
	    var locals = _Component5.prototype.getLocals.call(this);
	    locals.attrs = this.getAttrs();
	    locals.order = this.getOrder();
	    return locals;
	  };
	
	  _createClass(Datetime, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return _tcombValidation2['default'].Arr.is(value) ? value : _tcombValidation2['default'].Dat.is(value) ? [value.getFullYear(), value.getMonth(), value.getDate()].map(String) : [null, null, null];
	      },
	      parse: function parse(value) {
	        value = value.map(parseNumber);
	        return value.every(_tcombValidation2['default'].Num.is) ? new Date(value[0], value[1], value[2]) : value.every(Nil.is) ? null : value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Datetime = Datetime;
	  Datetime = decorators.template('date')(Datetime) || Datetime;
	  Datetime = decorators.attrs(Datetime) || Datetime;
	  return Datetime;
	})(Component);
	
	exports.Datetime = Datetime;
	
	var Struct = (function (_Component6) {
	  _inherits(Struct, _Component6);
	
	  function Struct() {
	    _classCallCheck(this, _Struct);
	
	    _Component6.apply(this, arguments);
	  }
	
	  Struct.prototype.isValueNully = function isValueNully() {
	    var _this2 = this;
	
	    return Object.keys(this.refs).every(function (ref) {
	      return _this2.refs[ref].isValueNully();
	    });
	  };
	
	  Struct.prototype.removeErrors = function removeErrors() {
	    var _this3 = this;
	
	    this.setState({ hasError: false });
	    Object.keys(this.refs).forEach(function (ref) {
	      return _this3.refs[ref].removeErrors();
	    });
	  };
	
	  Struct.prototype.validate = function validate() {
	    var value = {};
	    var errors = [];
	    var hasError = false;
	    var result = undefined;
	
	    if (this.typeInfo.isMaybe && this.isValueNully()) {
	      this.removeErrors();
	      return new _tcombValidation2['default'].ValidationResult({ errors: [], value: null });
	    }
	
	    for (var ref in this.refs) {
	      if (this.refs.hasOwnProperty(ref)) {
	        result = this.refs[ref].validate();
	        errors = errors.concat(result.errors);
	        value[ref] = result.value;
	      }
	    }
	
	    if (errors.length === 0) {
	      var InnerType = this.typeInfo.innerType;
	      value = new InnerType(value);
	      if (this.typeInfo.isSubtype && errors.length === 0) {
	        result = _tcombValidation2['default'].validate(value, this.props.type, this.getValidationOptions());
	        hasError = !result.isValid();
	        errors = errors.concat(result.errors);
	      }
	    }
	
	    this.setState({ hasError: hasError });
	    return new _tcombValidation2['default'].ValidationResult({ errors: errors, value: value });
	  };
	
	  Struct.prototype.onChange = function onChange(fieldName, fieldValue, path, kind) {
	    var _this4 = this;
	
	    var value = _tcombValidation2['default'].mixin({}, this.state.value);
	    value[fieldName] = fieldValue;
	    this.setState({ value: value }, function () {
	      _this4.props.onChange(value, path, kind);
	    });
	  };
	
	  Struct.prototype.getTemplate = function getTemplate() {
	    return this.props.options.template || this.getTemplates().struct;
	  };
	
	  Struct.prototype.getTypeProps = function getTypeProps() {
	    return this.typeInfo.innerType.meta.props;
	  };
	
	  Struct.prototype.getOrder = function getOrder() {
	    return this.props.options.order || Object.keys(this.getTypeProps());
	  };
	
	  Struct.prototype.getInputs = function getInputs() {
	    var _props = this.props;
	    var options = _props.options;
	    var ctx = _props.ctx;
	
	    var props = this.getTypeProps();
	    var auto = this.getAuto();
	    var i18n = this.getI18n();
	    var config = this.getConfig();
	    var templates = this.getTemplates();
	    var value = this.state.value;
	    var inputs = {};
	
	    for (var prop in props) {
	      if (props.hasOwnProperty(prop)) {
	        var propType = props[prop];
	        var propOptions = options.fields && options.fields[prop] ? options.fields[prop] : noobj;
	        inputs[prop] = _react2['default'].createElement(getComponent(propType, propOptions), {
	          key: prop,
	          ref: prop,
	          type: propType,
	          options: propOptions,
	          value: value[prop],
	          onChange: this.onChange.bind(this, prop),
	          ctx: {
	            context: ctx.context,
	            uidGenerator: ctx.uidGenerator,
	            auto: auto,
	            config: config,
	            name: ctx.name ? ctx.name + '[' + prop + ']' : prop,
	            label: _util.humanize(prop),
	            i18n: i18n,
	            templates: templates,
	            path: ctx.path.concat(prop)
	          }
	        });
	      }
	    }
	    return inputs;
	  };
	
	  Struct.prototype.getLocals = function getLocals() {
	    var options = this.props.options;
	    var locals = _Component6.prototype.getLocals.call(this);
	    locals.order = this.getOrder();
	    locals.inputs = this.getInputs();
	    locals.className = options.className;
	    return locals;
	  };
	
	  _createClass(Struct, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? noobj : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  var _Struct = Struct;
	  Struct = decorators.templates(Struct) || Struct;
	  return Struct;
	})(Component);
	
	exports.Struct = Struct;
	
	function toSameLength(value, keys, uidGenerator) {
	  if (value.length === keys.length) {
	    return keys;
	  }
	  var ret = [];
	  for (var i = 0, len = value.length; i < len; i++) {
	    ret[i] = keys[i] || uidGenerator.next();
	  }
	  return ret;
	}
	
	var List = (function (_Component7) {
	  _inherits(List, _Component7);
	
	  _createClass(List, null, [{
	    key: 'transformer',
	    value: {
	      format: function format(value) {
	        return Nil.is(value) ? noarr : value;
	      },
	      parse: function parse(value) {
	        return value;
	      }
	    },
	    enumerable: true
	  }]);
	
	  function List(props) {
	    _classCallCheck(this, _List);
	
	    _Component7.call(this, props);
	    this.state.keys = this.state.value.map(function () {
	      return props.ctx.uidGenerator.next();
	    });
	  }
	
	  List.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
	    if (props.type !== this.props.type) {
	      this.typeInfo = _util.getTypeInfo(props.type);
	    }
	    var value = this.getTransformer().format(props.value);
	    this.setState({
	      value: value,
	      keys: toSameLength(value, this.state.keys, props.ctx.uidGenerator)
	    });
	  };
	
	  List.prototype.isValueNully = function isValueNully() {
	    return this.state.value.length === 0;
	  };
	
	  List.prototype.removeErrors = function removeErrors() {
	    var _this5 = this;
	
	    this.setState({ hasError: false });
	    Object.keys(this.refs).forEach(function (ref) {
	      return _this5.refs[ref].removeErrors();
	    });
	  };
	
	  List.prototype.validate = function validate() {
	    var value = [];
	    var errors = [];
	    var hasError = false;
	    var result = undefined;
	
	    if (this.typeInfo.isMaybe && this.isValueNully()) {
	      this.removeErrors();
	      return new _tcombValidation2['default'].ValidationResult({ errors: [], value: null });
	    }
	
	    for (var i = 0, len = this.state.value.length; i < len; i++) {
	      result = this.refs[i].validate();
	      errors = errors.concat(result.errors);
	      value.push(result.value);
	    }
	
	    // handle subtype
	    if (this.typeInfo.isSubtype && errors.length === 0) {
	      result = _tcombValidation2['default'].validate(value, this.props.type, this.getValidationOptions());
	      hasError = !result.isValid();
	      errors = errors.concat(result.errors);
	    }
	
	    this.setState({ hasError: hasError });
	    return new _tcombValidation2['default'].ValidationResult({ errors: errors, value: value });
	  };
	
	  List.prototype.onChange = function onChange(value, keys, path, kind) {
	    var _this6 = this;
	
	    keys = toSameLength(value, keys, this.props.ctx.uidGenerator);
	    this.setState({ value: value, keys: keys }, function () {
	      _this6.props.onChange(value, path, kind);
	    });
	  };
	
	  List.prototype.addItem = function addItem(evt) {
	    evt.preventDefault();
	    var value = this.state.value.concat(undefined);
	    var keys = this.state.keys.concat(this.props.ctx.uidGenerator.next());
	    this.onChange(value, keys, this.props.ctx.path.concat(value.length - 1), 'add');
	  };
	
	  List.prototype.onItemChange = function onItemChange(itemIndex, itemValue, path, kind) {
	    var value = this.state.value.slice();
	    value[itemIndex] = itemValue;
	    this.onChange(value, this.state.keys, path, kind);
	  };
	
	  List.prototype.removeItem = function removeItem(i, evt) {
	    evt.preventDefault();
	    var value = this.state.value.slice();
	    value.splice(i, 1);
	    var keys = this.state.keys.slice();
	    keys.splice(i, 1);
	    this.onChange(value, keys, this.props.ctx.path.concat(i), 'remove');
	  };
	
	  List.prototype.moveUpItem = function moveUpItem(i, evt) {
	    evt.preventDefault();
	    if (i > 0) {
	      this.onChange(_util.move(this.state.value.slice(), i, i - 1), _util.move(this.state.keys.slice(), i, i - 1), this.props.ctx.path.concat(i), 'moveUp');
	    }
	  };
	
	  List.prototype.moveDownItem = function moveDownItem(i, evt) {
	    evt.preventDefault();
	    if (i < this.state.value.length - 1) {
	      this.onChange(_util.move(this.state.value.slice(), i, i + 1), _util.move(this.state.keys.slice(), i, i + 1), this.props.ctx.path.concat(i), 'moveDown');
	    }
	  };
	
	  List.prototype.getTemplate = function getTemplate() {
	    return this.props.options.template || this.getTemplates().list;
	  };
	
	  List.prototype.getItems = function getItems() {
	    var _this7 = this;
	
	    var _props2 = this.props;
	    var options = _props2.options;
	    var ctx = _props2.ctx;
	
	    var auto = this.getAuto();
	    var i18n = this.getI18n();
	    var config = this.getConfig();
	    var templates = this.getTemplates();
	    var value = this.state.value;
	    var type = this.typeInfo.innerType.meta.type;
	    var Component = getComponent(type, options.item || noobj);
	    return value.map(function (value, i) {
	      var buttons = [];
	      if (!options.disableRemove) {
	        buttons.push({ label: i18n.remove, click: _this7.removeItem.bind(_this7, i) });
	      }
	      if (!options.disableOrder) {
	        buttons.push({ label: i18n.up, click: _this7.moveUpItem.bind(_this7, i) });
	      }
	      if (!options.disableOrder) {
	        buttons.push({ label: i18n.down, click: _this7.moveDownItem.bind(_this7, i) });
	      }
	      return {
	        input: _react2['default'].createElement(Component, {
	          ref: i,
	          type: type,
	          options: options.item || noobj,
	          value: value,
	          onChange: _this7.onItemChange.bind(_this7, i),
	          ctx: {
	            context: ctx.context,
	            uidGenerator: ctx.uidGenerator,
	            auto: auto,
	            config: config,
	            i18n: i18n,
	            name: ctx.name ? ctx.name + '[' + i + ']' : String(i),
	            templates: templates,
	            path: ctx.path.concat(i)
	          }
	        }),
	        key: _this7.state.keys[i],
	        buttons: buttons
	      };
	    });
	  };
	
	  List.prototype.getLocals = function getLocals() {
	    var options = this.props.options;
	    var i18n = this.getI18n();
	    var locals = _Component7.prototype.getLocals.call(this);
	    locals.add = options.disableAdd ? null : {
	      label: i18n.add,
	      click: this.addItem.bind(this)
	    };
	    locals.items = this.getItems();
	    locals.className = options.className;
	    return locals;
	  };
	
	  var _List = List;
	  List = decorators.templates(List) || List;
	  return List;
	})(Component);
	
	exports.List = List;
	
	var Form = (function (_React$Component2) {
	  _inherits(Form, _React$Component2);
	
	  function Form() {
	    _classCallCheck(this, Form);
	
	    _React$Component2.apply(this, arguments);
	  }
	
	  Form.prototype.validate = function validate() {
	    return this.refs.input.validate();
	  };
	
	  Form.prototype.getValue = function getValue(raw) {
	    var result = this.validate();
	    return raw === true ? result : result.isValid() ? result.value : null;
	  };
	
	  Form.prototype.getComponent = function getComponent(path) {
	    path = _tcombValidation2['default'].Str.is(path) ? path.split('.') : path;
	    return path.reduce(function (input, name) {
	      return input.refs[name];
	    }, this.refs.input);
	  };
	
	  Form.prototype.render = function render() {
	
	    var type = this.props.type;
	    var options = this.props.options || noobj;
	    var i18n = Form.i18n;
	    var templates = Form.templates;
	
	    assert(_tcombValidation2['default'].isType(type), '[' + SOURCE + '] missing required prop type');
	    assert(_tcombValidation2['default'].Obj.is(options), '[' + SOURCE + '] prop options must be an object');
	    assert(_tcombValidation2['default'].Obj.is(templates), '[' + SOURCE + '] missing templates config');
	    assert(_tcombValidation2['default'].Obj.is(i18n), '[' + SOURCE + '] missing i18n config');
	
	    // this is in the render method because I need this._reactInternalInstance
	    this.uidGenerator = this.uidGenerator || new _util.UIDGenerator(this._reactInternalInstance ? this._reactInternalInstance._rootNodeID : '');
	
	    var Component = getComponent(type, options);
	    return _react2['default'].createElement(Component, {
	      ref: 'input',
	      type: type,
	      options: options,
	      value: this.props.value,
	      onChange: this.props.onChange || noop,
	      ctx: this.props.ctx || {
	        context: this.props.context,
	        uidGenerator: this.uidGenerator,
	        auto: 'labels',
	        templates: templates,
	        i18n: i18n,
	        path: []
	      }
	    });
	  };
	
	  return Form;
	})(_react2['default'].Component);
	
	exports.Form = Form;

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.textbox = textbox;
	exports.checkbox = checkbox;
	exports.select = select;
	exports.radio = radio;
	exports.date = date;
	exports.struct = struct;
	exports.list = list;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _tcombValidation = __webpack_require__(138);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	var _uvdomBootstrap = __webpack_require__(952);
	
	var _uvdomBootstrap2 = _interopRequireDefault(_uvdomBootstrap);
	
	var Any = _tcombValidation2['default'].Any;
	var maybe = _tcombValidation2['default'].maybe;
	var noobj = {};
	
	var Positive = _tcombValidation2['default'].subtype(_tcombValidation2['default'].Num, function (n) {
	  return n % 1 === 0 && n >= 0;
	}, 'Positive');
	
	var Cols = _tcombValidation2['default'].tuple([Positive, Positive], 'Cols');
	
	var Breakpoints = _tcombValidation2['default'].struct({
	  xs: maybe(Cols),
	  sm: maybe(Cols),
	  md: maybe(Cols),
	  lg: maybe(Cols)
	}, 'Breakpoints');
	
	Breakpoints.prototype.getBreakpoints = function (index) {
	  var breakpoints = {};
	  for (var size in this) {
	    if (this.hasOwnProperty(size) && !_tcombValidation2['default'].Nil.is(this[size])) {
	      breakpoints[size] = this[size][index];
	    }
	  }
	  return breakpoints;
	};
	
	Breakpoints.prototype.getLabelClassName = function () {
	  return _uvdomBootstrap2['default'].getBreakpoints(this.getBreakpoints(0));
	};
	
	Breakpoints.prototype.getInputClassName = function () {
	  return _uvdomBootstrap2['default'].getBreakpoints(this.getBreakpoints(1));
	};
	
	Breakpoints.prototype.getOffsetClassName = function () {
	  return _tcombValidation2['default'].mixin(_uvdomBootstrap2['default'].getOffsets(this.getBreakpoints(1)), _uvdomBootstrap2['default'].getBreakpoints(this.getBreakpoints(1)));
	};
	
	var Size = _tcombValidation2['default'].enums.of('xs sm md lg', 'Size');
	
	var TextboxConfig = _tcombValidation2['default'].struct({
	  addonBefore: Any,
	  addonAfter: Any,
	  horizontal: maybe(Breakpoints),
	  size: maybe(Size),
	  buttonBefore: Any,
	  buttonAfter: Any
	}, 'TextboxConfig');
	
	var CheckboxConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'CheckboxConfig');
	
	var SelectConfig = _tcombValidation2['default'].struct({
	  addonBefore: Any,
	  addonAfter: Any,
	  horizontal: maybe(Breakpoints),
	  size: maybe(Size)
	}, 'SelectConfig');
	
	var RadioConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'RadioConfig');
	
	var DateConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'DateConfig');
	
	var StructConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'StructConfig');
	
	var ListConfig = _tcombValidation2['default'].struct({
	  horizontal: maybe(Breakpoints)
	}, 'ListConfig');
	
	function getLabel(_ref) {
	  var label = _ref.label;
	  var breakpoints = _ref.breakpoints;
	  var htmlFor = _ref.htmlFor;
	  var id = _ref.id;
	  var align = _ref.align;
	
	  if (!label) {
	    return;
	  }
	
	  var className = breakpoints ? breakpoints.getLabelClassName() : null;
	
	  return _uvdomBootstrap2['default'].getLabel({
	    align: align,
	    className: className,
	    htmlFor: htmlFor,
	    id: id,
	    label: label
	  });
	}
	
	function getHelp(_ref2) {
	  var help = _ref2.help;
	  var attrs = _ref2.attrs;
	
	  if (!help) {
	    return;
	  }
	  return _uvdomBootstrap2['default'].getHelpBlock({
	    help: help,
	    id: attrs.id + '-tip'
	  });
	}
	
	function getError(_ref3) {
	  var hasError = _ref3.hasError;
	  var error = _ref3.error;
	
	  if (!hasError || !error) {
	    return;
	  }
	  return _uvdomBootstrap2['default'].getErrorBlock({
	    error: error,
	    hasError: hasError
	  });
	}
	
	function getHiddenTextbox(_ref4) {
	  var value = _ref4.value;
	  var name = _ref4.name;
	
	  return {
	    tag: 'input',
	    attrs: {
	      type: 'hidden',
	      value: value,
	      name: name
	    }
	  };
	}
	
	function getInputGroupButton(button) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'input-group-btn': true
	      }
	    },
	    children: button
	  };
	}
	
	function textbox(locals) {
	
	  var config = new TextboxConfig(locals.config || noobj);
	
	  if (locals.type === 'hidden') {
	    return getHiddenTextbox(locals);
	  }
	
	  var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	  var control = undefined;
	
	  if (locals.type === 'static') {
	    control = _uvdomBootstrap2['default'].getStatic(locals.value);
	  } else {
	
	    var tag = 'textarea';
	    if (locals.type !== 'textarea') {
	      tag = 'input';
	      attrs.type = locals.type;
	    }
	
	    attrs.className = _tcombValidation2['default'].mixin({}, attrs.className);
	    attrs.className['form-control'] = true;
	
	    attrs.disabled = locals.disabled;
	    if (locals.type !== 'file') {
	      attrs.value = locals.value;
	    }
	    attrs.onChange = locals.type === 'file' ? function (evt) {
	      return locals.onChange(evt.target.files[0]);
	    } : function (evt) {
	      return locals.onChange(evt.target.value);
	    };
	
	    if (locals.help) {
	      attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	    }
	
	    control = {
	      tag: tag,
	      attrs: attrs
	    };
	    if (config.addonBefore || config.addonAfter || config.buttonBefore || config.buttonAfter) {
	      control = _uvdomBootstrap2['default'].getInputGroup([config.buttonBefore ? getInputGroupButton(config.buttonBefore) : null, config.addonBefore ? _uvdomBootstrap2['default'].getAddon(config.addonBefore) : null, control, config.addonAfter ? _uvdomBootstrap2['default'].getAddon(config.addonAfter) : null, config.buttonAfter ? getInputGroupButton(config.buttonAfter) : null]);
	    }
	  }
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    htmlFor: attrs.id,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	
	  var children = [label, control, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [control, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function checkbox(locals) {
	
	  var config = new CheckboxConfig(locals.config || noobj);
	
	  var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	  attrs.type = 'checkbox';
	  attrs.disabled = locals.disabled;
	  attrs.checked = locals.value;
	  attrs.onChange = function (evt) {
	    return locals.onChange(evt.target.checked);
	  };
	
	  if (locals.help) {
	    attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	  }
	
	  var control = _uvdomBootstrap2['default'].getCheckbox(attrs, locals.label);
	
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [control, error, help];
	
	  if (config.horizontal) {
	    children = {
	      tag: 'div',
	      attrs: {
	        className: config.horizontal.getOffsetClassName()
	      },
	      children: children
	    };
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function select(locals) {
	
	  var config = new SelectConfig(locals.config || noobj);
	
	  var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	
	  attrs.className = _tcombValidation2['default'].mixin({}, attrs.className);
	  attrs.className['form-control'] = true;
	
	  attrs.multiple = locals.isMultiple;
	  attrs.disabled = locals.disabled;
	  attrs.value = locals.value;
	  attrs.onChange = function (evt) {
	    var value = locals.isMultiple ? Array.prototype.slice.call(evt.target.options).filter(function (option) {
	      return option.selected;
	    }).map(function (option) {
	      return option.value;
	    }) : evt.target.value;
	    locals.onChange(value);
	  };
	
	  if (locals.help) {
	    attrs['aria-describedby'] = attrs['aria-describedby'] || attrs.id + '-tip';
	  }
	
	  var options = locals.options.map(function (x) {
	    return x.label ? _uvdomBootstrap2['default'].getOptGroup(x) : _uvdomBootstrap2['default'].getOption(x);
	  });
	
	  var control = {
	    tag: 'select',
	    attrs: attrs,
	    children: options
	  };
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    htmlFor: attrs.id,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [label, control, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [control, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function radio(locals) {
	
	  var config = new RadioConfig(locals.config || noobj);
	
	  var id = locals.attrs.id;
	  var onChange = function onChange(evt) {
	    return locals.onChange(evt.target.value);
	  };
	
	  var controls = locals.options.map(function (option, i) {
	
	    var attrs = _tcombValidation2['default'].mixin({}, locals.attrs);
	    attrs.type = 'radio';
	    attrs.checked = option.value === locals.value;
	    attrs.disabled = locals.disabled;
	    attrs.value = option.value;
	    attrs.autoFocus = attrs.autoFocus && i === 0;
	    attrs.id = id + '_' + i;
	    attrs['aria-describedby'] = attrs['aria-describedby'] || (locals.label ? id : null);
	    attrs.onChange = onChange;
	
	    return _uvdomBootstrap2['default'].getRadio(attrs, option.text, option.value);
	  });
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    id: id,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [label, controls, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [controls, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function range(n) {
	  var result = [];
	  for (var i = 1; i <= n; i++) {
	    result.push(i);
	  }
	  return result;
	}
	
	function padLeft(x, len) {
	  var str = String(x);
	  var times = len - str.length;
	  for (var i = 0; i < times; i++) {
	    str = '0' + str;
	  }
	  return str;
	}
	
	function toOption(value, text) {
	  return {
	    tag: 'option',
	    attrs: { value: value + '' },
	    children: text
	  };
	}
	
	var nullOption = [toOption('', '-')];
	
	var days = nullOption.concat(range(31).map(function (i) {
	  return toOption(i, padLeft(i, 2));
	}));
	
	var months = nullOption.concat(range(12).map(function (i) {
	  return toOption(i - 1, padLeft(i, 2));
	}));
	
	function date(locals) {
	
	  var config = new DateConfig(locals.config || noobj);
	  var value = locals.value.slice();
	
	  function onDayChange(evt) {
	    value[2] = evt.target.value === '-' ? null : evt.target.value;
	    locals.onChange(value);
	  }
	
	  function onMonthChange(evt) {
	    value[1] = evt.target.value === '-' ? null : evt.target.value;
	    locals.onChange(value);
	  }
	
	  function onYearChange(evt) {
	    value[0] = evt.target.value.trim() === '' ? null : evt.target.value.trim();
	    locals.onChange(value);
	  }
	
	  var parts = {
	
	    D: {
	      tag: 'li',
	      key: 'D',
	      children: {
	        tag: 'select',
	        attrs: {
	          disabled: locals.disabled,
	          className: {
	            'form-control': true
	          },
	          value: value[2]
	        },
	        events: {
	          change: onDayChange
	        },
	        children: days
	      }
	    },
	
	    M: {
	      tag: 'li',
	      key: 'M',
	      children: {
	        tag: 'select',
	        attrs: {
	          disabled: locals.disabled,
	          className: {
	            'form-control': true
	          },
	          value: value[1]
	        },
	        events: {
	          change: onMonthChange
	        },
	        children: months
	      }
	    },
	
	    YY: {
	      tag: 'li',
	      key: 'YY',
	      children: {
	        tag: 'input',
	        attrs: {
	          disabled: locals.disabled,
	          type: 'text',
	          size: 5,
	          className: {
	            'form-control': true
	          },
	          value: value[0]
	        },
	        events: {
	          change: onYearChange
	        }
	      }
	    }
	
	  };
	
	  var control = {
	    tag: 'ul',
	    attrs: {
	      className: {
	        'nav nav-pills': true
	      }
	    },
	    children: locals.order.map(function (id) {
	      return parts[id];
	    })
	  };
	
	  var horizontal = config.horizontal;
	  var label = getLabel({
	    label: locals.label,
	    breakpoints: config.horizontal
	  });
	  var error = getError(locals);
	  var help = getHelp(locals);
	  var children = [label, control, error, help];
	
	  if (horizontal) {
	    children = [label, {
	      tag: 'div',
	      attrs: {
	        className: label ? horizontal.getInputClassName() : horizontal.getOffsetClassName()
	      },
	      children: [control, error, help]
	    }];
	  }
	
	  return _uvdomBootstrap2['default'].getFormGroup({
	    className: 'form-group-depth-' + locals.path.length,
	    hasError: locals.hasError,
	    children: children
	  });
	}
	
	function struct(locals) {
	
	  var config = new StructConfig(locals.config || noobj);
	  var children = [];
	
	  if (locals.help) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      children: locals.help
	    }));
	  }
	
	  if (locals.error && locals.hasError) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      type: 'danger',
	      children: locals.error
	    }));
	  }
	
	  children = children.concat(locals.order.map(function (name) {
	    return locals.inputs[name];
	  }));
	
	  var className = {};
	  if (locals.className) {
	    className[locals.className] = true;
	  }
	
	  return _uvdomBootstrap2['default'].getFieldset({
	    className: className,
	    disabled: locals.disabled,
	    legend: locals.label,
	    children: children
	  });
	}
	
	function list(locals) {
	
	  var config = new ListConfig(locals.config || noobj);
	  var children = [];
	
	  if (locals.help) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      children: locals.help
	    }));
	  }
	
	  if (locals.error && locals.hasError) {
	    children.push(_uvdomBootstrap2['default'].getAlert({
	      type: 'danger',
	      children: locals.error
	    }));
	  }
	
	  children = children.concat(locals.items.map(function (item) {
	    if (item.buttons.length === 0) {
	      return _uvdomBootstrap2['default'].getRow({
	        key: item.key,
	        children: [_uvdomBootstrap2['default'].getCol({
	          breakpoints: { xs: 12 },
	          children: item.input
	        })]
	      });
	    }
	    return _uvdomBootstrap2['default'].getRow({
	      key: item.key,
	      children: [_uvdomBootstrap2['default'].getCol({
	        breakpoints: { sm: 8, xs: 6 },
	        children: item.input
	      }), _uvdomBootstrap2['default'].getCol({
	        breakpoints: { sm: 4, xs: 6 },
	        children: _uvdomBootstrap2['default'].getButtonGroup(item.buttons.map(function (button, i) {
	          return _uvdomBootstrap2['default'].getButton({
	            click: button.click,
	            key: i,
	            label: button.label
	          });
	        }))
	      })]
	    });
	  }));
	
	  if (locals.add) {
	    children.push({
	      tag: 'div',
	      attrs: { className: 'row' },
	      children: {
	        tag: 'div',
	        attrs: { className: 'col-lg-12' },
	        children: {
	          tag: 'div',
	          attrs: { style: { marginBottom: '15px' } },
	          children: _uvdomBootstrap2['default'].getButton(locals.add)
	        }
	      }
	    });
	  }
	
	  var className = {};
	  if (locals.className) {
	    className[locals.className] = true;
	  }
	
	  return _uvdomBootstrap2['default'].getFieldset({
	    className: className,
	    disabled: locals.disabled,
	    legend: locals.label,
	    children: children
	  });
	}

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getOptionsOfEnum = getOptionsOfEnum;
	exports.getTypeInfo = getTypeInfo;
	exports.humanize = humanize;
	exports.merge = merge;
	exports.move = move;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }
	
	var _tcombValidation = __webpack_require__(138);
	
	var _tcombValidation2 = _interopRequireDefault(_tcombValidation);
	
	function getOptionsOfEnum(type) {
	  var enums = type.meta.map;
	  return Object.keys(enums).map(function (value) {
	    return {
	      value: value,
	      text: enums[value]
	    };
	  });
	}
	
	function getTypeInfo(type) {
	
	  var innerType = type;
	  var isMaybe = false;
	  var isSubtype = false;
	  var kind = undefined;
	  var innerGetValidationErrorMessage = undefined;
	
	  while (innerType) {
	    kind = innerType.meta.kind;
	    if (_tcombValidation2['default'].Func.is(innerType.getValidationErrorMessage)) {
	      innerGetValidationErrorMessage = innerType.getValidationErrorMessage;
	    }
	    if (kind === 'maybe') {
	      isMaybe = true;
	      innerType = innerType.meta.type;
	      continue;
	    }
	    if (kind === 'subtype') {
	      isSubtype = true;
	      innerType = innerType.meta.type;
	      continue;
	    }
	    break;
	  }
	
	  var getValidationErrorMessage = innerGetValidationErrorMessage ? function (value, path, context) {
	    var result = _tcombValidation2['default'].validate(value, type, { path: path, context: context });
	    if (!result.isValid()) {
	      for (var i = 0, len = result.errors.length; i < len; i++) {
	        if (_tcombValidation2['default'].Func.is(result.errors[i].expected.getValidationErrorMessage)) {
	          return result.errors[i].message;
	        }
	      }
	      return innerGetValidationErrorMessage(value, path, context);
	    }
	  } : undefined;
	
	  return {
	    type: type,
	    isMaybe: isMaybe,
	    isSubtype: isSubtype,
	    innerType: innerType,
	    getValidationErrorMessage: getValidationErrorMessage
	  };
	}
	
	// thanks to https://github.com/epeli/underscore.string
	
	function underscored(s) {
	  return s.trim().replace(/([a-z\d])([A-Z]+)/g, '$1_$2').replace(/[-\s]+/g, '_').toLowerCase();
	}
	
	function capitalize(s) {
	  return s.charAt(0).toUpperCase() + s.slice(1);
	}
	
	function humanize(s) {
	  return capitalize(underscored(s).replace(/_id$/, '').replace(/_/g, ' '));
	}
	
	function merge(a, b) {
	  return _tcombValidation.mixin(_tcombValidation.mixin({}, a), b, true);
	}
	
	function move(arr, fromIndex, toIndex) {
	  var element = arr.splice(fromIndex, 1)[0];
	  arr.splice(toIndex, 0, element);
	  return arr;
	}
	
	var UIDGenerator = (function () {
	  function UIDGenerator(seed) {
	    _classCallCheck(this, UIDGenerator);
	
	    this.seed = seed;
	    this.counter = 0;
	  }
	
	  UIDGenerator.prototype.next = function next() {
	    var id = this.seed + this.counter++;
	    return id;
	  };
	
	  return UIDGenerator;
	})();
	
	exports.UIDGenerator = UIDGenerator;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/*! @preserve
	 *
	 * The MIT License (MIT)
	 *
	 * Copyright (c) 2014-2016 Giulio Canti
	 *
	 */
	
	// core
	var t = __webpack_require__(25);
	
	// types
	t.Any = __webpack_require__(262);
	t.Array = __webpack_require__(930);
	t.Boolean = __webpack_require__(405);
	t.Date = __webpack_require__(931);
	t.Error = __webpack_require__(932);
	t.Function = __webpack_require__(263);
	t.Nil = __webpack_require__(406);
	t.Number = __webpack_require__(933);
	t.Object = __webpack_require__(934);
	t.RegExp = __webpack_require__(935);
	t.String = __webpack_require__(407);
	
	// short alias are deprecated
	t.Arr = t.Array;
	t.Bool = t.Boolean;
	t.Dat = t.Date;
	t.Err = t.Error;
	t.Func = t.Function;
	t.Num = t.Number;
	t.Obj = t.Object;
	t.Re = t.RegExp;
	t.Str = t.String;
	
	// combinators
	t.dict = __webpack_require__(408);
	t.declare = __webpack_require__(936);
	t.enums = __webpack_require__(937);
	t.irreducible = __webpack_require__(47);
	t.list = __webpack_require__(412);
	t.maybe = __webpack_require__(944);
	t.refinement = __webpack_require__(945);
	t.struct = __webpack_require__(946);
	t.tuple = __webpack_require__(414);
	t.union = __webpack_require__(947);
	t.func = __webpack_require__(939);
	t.intersection = __webpack_require__(940);
	t.subtype = t.refinement;
	
	// functions
	t.assert = t;
	t.update = __webpack_require__(948);
	t.mixin = __webpack_require__(180);
	t.isType = __webpack_require__(55);
	t.is = __webpack_require__(81);
	t.getTypeName = __webpack_require__(37);
	t.match = __webpack_require__(943);
	
	module.exports = t;


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	var isArray = __webpack_require__(75);
	
	module.exports = irreducible('Array', isArray);


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	
	module.exports = irreducible('Date', function (x) { return x instanceof Date; });


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	
	module.exports = irreducible('Error', function (x) { return x instanceof Error; });


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	var isNumber = __webpack_require__(410);
	
	module.exports = irreducible('Number', isNumber);


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	var isObject = __webpack_require__(103);
	
	module.exports = irreducible('Object', isObject);


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

	var irreducible = __webpack_require__(47);
	
	module.exports = irreducible('RegExp', function (x) { return x instanceof RegExp; });


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var isType = __webpack_require__(55);
	var isNil = __webpack_require__(82);
	var mixin = __webpack_require__(180);
	var getTypeName = __webpack_require__(37);
	
	// All the .declare-d types should be clearly different from each other thus they should have
	// different names when a name was not explicitly provided.
	var nextDeclareUniqueId = 1;
	
	module.exports = function declare(name) {
	  if (false) {
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + name + ' supplied to declare([name]) (expected a string)'; });
	  }
	
	  var type;
	
	  function Declare(value, path) {
	    if (false) {
	      assert(!isNil(type), function () { return 'Type declared but not defined, don\'t forget to call .define on every declared type'; });
	    }
	    return type(value, path);
	  }
	
	  Declare.define = function (spec) {
	    if (false) {
	      assert(isType(spec), function () { return 'Invalid argument type ' + assert.stringify(spec) +  ' supplied to define(type) (expected a type)'; });
	      assert(isNil(type), function () { return 'Declare.define(type) can only be invoked once'; });
	      assert(isNil(spec.meta.name) && Object.keys(spec.prototype).length === 0, function () { return 'Invalid argument type ' + assert.stringify(spec) + ' supplied to define(type) (expected a fresh, unnamed type)'; });
	    }
	
	    type = spec;
	    mixin(Declare, type, true); // true because it overwrites Declare.displayName
	    if (name) {
	      type.displayName = Declare.displayName = name;
	      Declare.meta.name = name;
	    }
	    // ensure identity is still false
	    Declare.meta.identity = false;
	    Declare.prototype = type.prototype;
	    return Declare;
	  };
	
	  Declare.displayName = name || ( getTypeName(Declare) + "$" + nextDeclareUniqueId++ );
	  // in general I can't say if this type will be an identity, for safety setting to false
	  Declare.meta = { identity: false };
	  Declare.prototype = null;
	  return Declare;
	};


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var forbidNewOperator = __webpack_require__(139);
	var isString = __webpack_require__(179);
	var isObject = __webpack_require__(103);
	
	function getDefaultName(map) {
	  return Object.keys(map).map(function (k) { return assert.stringify(k); }).join(' | ');
	}
	
	function enums(map, name) {
	
	  if (false) {
	    assert(isObject(map), function () { return 'Invalid argument map ' + assert.stringify(map) + ' supplied to enums(map, [name]) combinator (expected a dictionary of String -> String | Number)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to enums(map, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(map);
	
	  function Enums(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Enums);
	      path = path || [displayName];
	      assert(Enums.is(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected one of ' + assert.stringify(Object.keys(map)) + ')'; });
	    }
	
	    return value;
	  }
	
	  Enums.meta = {
	    kind: 'enums',
	    map: map,
	    name: name,
	    identity: true
	  };
	
	  Enums.displayName = displayName;
	
	  Enums.is = function (x) {
	    return map.hasOwnProperty(x);
	  };
	
	  return Enums;
	}
	
	enums.of = function (keys, name) {
	  keys = isString(keys) ? keys.split(' ') : keys;
	  var value = {};
	  keys.forEach(function (k) {
	    value[k] = k;
	  });
	  return enums(value, name);
	};
	
	enums.getDefaultName = getDefaultName;
	module.exports = enums;
	


/***/ }),
/* 938 */
/***/ (function(module, exports) {

	module.exports = function fail(message) {
	  throw new TypeError('[tcomb] ' + message);
	};

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var FunctionType = __webpack_require__(263);
	var isArray = __webpack_require__(75);
	var list = __webpack_require__(412);
	var isObject = __webpack_require__(103);
	var create = __webpack_require__(80);
	var isNil = __webpack_require__(82);
	var isBoolean = __webpack_require__(409);
	var tuple = __webpack_require__(414);
	var getFunctionName = __webpack_require__(178);
	var getTypeName = __webpack_require__(37);
	
	function getDefaultName(domain, codomain) {
	  return '(' + domain.map(getTypeName).join(', ') + ') => ' + getTypeName(codomain);
	}
	
	function isInstrumented(f) {
	  return FunctionType.is(f) && isObject(f.instrumentation);
	}
	
	function func(domain, codomain, name) {
	
	  domain = isArray(domain) ? domain : [domain]; // handle handy syntax for unary functions
	
	  if (false) {
	    assert(list(FunctionType).is(domain), function () { return 'Invalid argument domain ' + assert.stringify(domain) + ' supplied to func(domain, codomain, [name]) combinator (expected an array of types)'; });
	    assert(FunctionType.is(codomain), function () { return 'Invalid argument codomain ' + assert.stringify(codomain) + ' supplied to func(domain, codomain, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to func(domain, codomain, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(domain, codomain);
	
	  function FuncType(value, curried) {
	
	    if (!isInstrumented(value)) { // automatically instrument the function
	      return FuncType.of(value, curried);
	    }
	
	    if (false) {
	      assert(FuncType.is(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + displayName; });
	    }
	
	    return value;
	  }
	
	  FuncType.meta = {
	    kind: 'func',
	    domain: domain,
	    codomain: codomain,
	    name: name,
	    identity: true
	  };
	
	  FuncType.displayName = displayName;
	
	  FuncType.is = function (x) {
	    return isInstrumented(x) &&
	      x.instrumentation.domain.length === domain.length &&
	      x.instrumentation.domain.every(function (type, i) {
	        return type === domain[i];
	      }) &&
	      x.instrumentation.codomain === codomain;
	  };
	
	  FuncType.of = function (f, curried) {
	
	    if (false) {
	      assert(FunctionType.is(f), function () { return 'Invalid argument f supplied to func.of ' + displayName + ' (expected a function)'; });
	      assert(isNil(curried) || isBoolean(curried), function () { return 'Invalid argument curried ' + assert.stringify(curried) + ' supplied to func.of ' + displayName + ' (expected a boolean)'; });
	    }
	
	    if (FuncType.is(f)) { // makes FuncType.of idempotent
	      return f;
	    }
	
	    function fn() {
	      var args = Array.prototype.slice.call(arguments);
	      var len = curried ?
	        args.length :
	        domain.length;
	      var argsType = tuple(domain.slice(0, len));
	
	      args = argsType(args); // type check arguments
	
	      if (len === domain.length) {
	        return create(codomain, f.apply(this, args));
	      }
	      else {
	        var g = Function.prototype.bind.apply(f, [this].concat(args));
	        var newdomain = func(domain.slice(len), codomain);
	        return newdomain.of(g, curried);
	      }
	    }
	
	    fn.instrumentation = {
	      domain: domain,
	      codomain: codomain,
	      f: f
	    };
	
	    fn.displayName = getFunctionName(f);
	
	    return fn;
	
	  };
	
	  return FuncType;
	
	}
	
	func.getDefaultName = getDefaultName;
	module.exports = func;


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var isFunction = __webpack_require__(38);
	var isArray = __webpack_require__(75);
	var forbidNewOperator = __webpack_require__(102);
	var is = __webpack_require__(81);
	var getTypeName = __webpack_require__(37);
	
	function getDefaultName(types) {
	  return types.map(getTypeName).join(' & ');
	}
	
	function intersection(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction) && types.length >= 2, function () { return 'Invalid argument types ' + assert.stringify(types) + ' supplied to intersection(types, [name]) combinator (expected an array of at least 2 types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to intersection(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(types);
	
	  function Intersection(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Intersection);
	      path = path || [displayName];
	      assert(Intersection.is(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return value;
	  }
	
	  Intersection.meta = {
	    kind: 'intersection',
	    types: types,
	    name: name,
	    identity: true
	  };
	
	  Intersection.displayName = displayName;
	
	  Intersection.is = function (x) {
	    return types.every(function (type) {
	      return is(x, type);
	    });
	  };
	
	  Intersection.update = function (instance, patch) {
	    return Intersection(assert.update(instance, patch));
	  };
	
	  return Intersection;
	}
	
	intersection.getDefaultName = getDefaultName;
	module.exports = intersection;
	


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(55);
	
	module.exports = function isMaybe(x) {
	  return isType(x) && ( x.meta.kind === 'maybe' );
	};

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

	var isType = __webpack_require__(55);
	
	module.exports = function isUnion(x) {
	  return isType(x) && ( x.meta.kind === 'union' );
	};

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isFunction = __webpack_require__(38);
	var isType = __webpack_require__(55);
	var Any = __webpack_require__(262);
	
	module.exports = function match(x) {
	  var type, guard, f, count;
	  for (var i = 1, len = arguments.length; i < len; ) {
	    type = arguments[i];
	    guard = arguments[i + 1];
	    f = arguments[i + 2];
	
	    if (isFunction(f) && !isType(f)) {
	      i = i + 3;
	    }
	    else {
	      f = guard;
	      guard = Any.is;
	      i = i + 2;
	    }
	
	    if (false) {
	      count = (count || 0) + 1;
	      assert(isType(type), function () { return 'Invalid type in clause #' + count; });
	      assert(isFunction(guard), function () { return 'Invalid guard in clause #' + count; });
	      assert(isFunction(f), function () { return 'Invalid block in clause #' + count; });
	    }
	
	    if (type.is(x) && guard(x)) {
	      return f(x);
	    }
	  }
	  assert.fail('Match error');
	};


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var isFunction = __webpack_require__(38);
	var isMaybe = __webpack_require__(941);
	var isIdentity = __webpack_require__(102);
	var Any = __webpack_require__(262);
	var create = __webpack_require__(80);
	var Nil = __webpack_require__(406);
	var forbidNewOperator = __webpack_require__(139);
	var is = __webpack_require__(81);
	var getTypeName = __webpack_require__(37);
	
	function getDefaultName(type) {
	  return '?' + getTypeName(type);
	}
	
	function maybe(type, name) {
	
	  if (isMaybe(type) || type === Any || type === Nil) { // makes the combinator idempotent and handle Any, Nil
	    return type;
	  }
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + assert.stringify(type) + ' supplied to maybe(type, [name]) combinator (expected a type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to maybe(type, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(type);
	
	  function Maybe(value, path) {
	    if (false) {
	      forbidNewOperator(this, Maybe);
	    }
	    return Nil.is(value) ? null : create(type, value, path);
	  }
	
	  Maybe.meta = {
	    kind: 'maybe',
	    type: type,
	    name: name,
	    identity: isIdentity(type)
	  };
	
	  Maybe.displayName = displayName;
	
	  Maybe.is = function (x) {
	    return Nil.is(x) || is(x, type);
	  };
	
	  return Maybe;
	}
	
	maybe.getDefaultName = getDefaultName;
	module.exports = maybe;


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var isFunction = __webpack_require__(38);
	var forbidNewOperator = __webpack_require__(139);
	var isIdentity = __webpack_require__(102);
	var create = __webpack_require__(80);
	var is = __webpack_require__(81);
	var getTypeName = __webpack_require__(37);
	var getFunctionName = __webpack_require__(178);
	
	function getDefaultName(type, predicate) {
	  return '{' + getTypeName(type) + ' | ' + getFunctionName(predicate) + '}';
	}
	
	function refinement(type, predicate, name) {
	
	  if (false) {
	    assert(isFunction(type), function () { return 'Invalid argument type ' + assert.stringify(type) + ' supplied to refinement(type, predicate, [name]) combinator (expected a type)'; });
	    assert(isFunction(predicate), function () { return 'Invalid argument predicate supplied to refinement(type, predicate, [name]) combinator (expected a function)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to refinement(type, predicate, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(type, predicate);
	  var identity = isIdentity(type);
	
	  function Refinement(value, path) {
	
	    if (false) {
	      forbidNewOperator(this, Refinement);
	      path = path || [displayName];
	    }
	
	    var x = create(type, value, path);
	
	    if (false) {
	      assert(predicate(x), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/'); });
	    }
	
	    return x;
	  }
	
	  Refinement.meta = {
	    kind: 'subtype',
	    type: type,
	    predicate: predicate,
	    name: name,
	    identity: identity
	  };
	
	  Refinement.displayName = displayName;
	
	  Refinement.is = function (x) {
	    return is(x, type) && predicate(x);
	  };
	
	  Refinement.update = function (instance, patch) {
	    return Refinement(assert.update(instance, patch));
	  };
	
	  return Refinement;
	}
	
	refinement.getDefaultName = getDefaultName;
	module.exports = refinement;


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var String = __webpack_require__(407);
	var Function = __webpack_require__(263);
	var isArray = __webpack_require__(75);
	var isObject = __webpack_require__(103);
	var create = __webpack_require__(80);
	var mixin = __webpack_require__(180);
	var isStruct = __webpack_require__(411);
	var getTypeName = __webpack_require__(37);
	var dict = __webpack_require__(408);
	
	function getDefaultName(props) {
	  return '{' + Object.keys(props).map(function (prop) {
	    return prop + ': ' + getTypeName(props[prop]);
	  }).join(', ') + '}';
	}
	
	function extend(mixins, name) {
	  if (false) {
	    assert(isArray(mixins) && mixins.every(function (x) {
	      return isObject(x) || isStruct(x);
	    }), function () { return 'Invalid argument mixins supplied to extend(mixins, name), expected an array of objects or structs'; });
	  }
	  var props = {};
	  var prototype = {};
	  mixins.forEach(function (struct) {
	    if (isObject(struct)) {
	      mixin(props, struct);
	    }
	    else {
	      mixin(props, struct.meta.props);
	      mixin(prototype, struct.prototype);
	    }
	  });
	  var ret = struct(props, name);
	  mixin(ret.prototype, prototype);
	  return ret;
	}
	
	function struct(props, name) {
	
	  if (false) {
	    assert(dict(String, Function).is(props), function () { return 'Invalid argument props ' + assert.stringify(props) + ' supplied to struct(props, [name]) combinator (expected a dictionary String -> Type)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to struct(props, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(props);
	
	  function Struct(value, path) {
	
	    if (Struct.is(value)) { // implements idempotency
	      return value;
	    }
	
	    if (false) {
	      path = path || [displayName];
	      assert(isObject(value), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (expected an object)'; });
	    }
	
	    if (!(this instanceof Struct)) { // `new` is optional
	      return new Struct(value, path);
	    }
	
	    for (var k in props) {
	      if (props.hasOwnProperty(k)) {
	        var expected = props[k];
	        var actual = value[k];
	        this[k] = create(expected, actual, (  false ? path.concat(k + ': ' + getTypeName(expected)) : null ));
	      }
	    }
	
	    if (false) {
	      Object.freeze(this);
	    }
	
	  }
	
	  Struct.meta = {
	    kind: 'struct',
	    props: props,
	    name: name,
	    identity: false
	  };
	
	  Struct.displayName = displayName;
	
	  Struct.is = function (x) {
	    return x instanceof Struct;
	  };
	
	  Struct.update = function (instance, patch) {
	    return new Struct(assert.update(instance, patch));
	  };
	
	  Struct.extend = function (structs, name) {
	    return extend([Struct].concat(structs), name);
	  };
	
	  return Struct;
	}
	
	struct.getDefaultName = getDefaultName;
	struct.extend = extend;
	module.exports = struct;


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isTypeName = __webpack_require__(56);
	var isFunction = __webpack_require__(38);
	var getTypeName = __webpack_require__(37);
	var isIdentity = __webpack_require__(102);
	var isArray = __webpack_require__(75);
	var create = __webpack_require__(80);
	var is = __webpack_require__(81);
	var forbidNewOperator = __webpack_require__(139);
	var isType = __webpack_require__(55);
	var isUnion = __webpack_require__(942);
	var isNil = __webpack_require__(82);
	
	function getDefaultName(types) {
	  return types.map(getTypeName).join(' | ');
	}
	
	function union(types, name) {
	
	  if (false) {
	    assert(isArray(types) && types.every(isFunction) && types.length >= 2, function () { return 'Invalid argument types ' + assert.stringify(types) + ' supplied to union(types, [name]) combinator (expected an array of at least 2 types)'; });
	    assert(isTypeName(name), function () { return 'Invalid argument name ' + assert.stringify(name) + ' supplied to union(types, [name]) combinator (expected a string)'; });
	  }
	
	  var displayName = name || getDefaultName(types);
	  var identity = types.every(isIdentity);
	
	  function Union(value, path) {
	
	    if (true) {
	      if (identity) {
	        return value;
	      }
	    }
	
	    var type = Union.dispatch(value);
	    if (!type && Union.is(value)) {
	      return value;
	    }
	
	    if (false) {
	      forbidNewOperator(this, Union);
	      path = path || [displayName];
	      assert(isType(type), function () { return 'Invalid value ' + assert.stringify(value) + ' supplied to ' + path.join('/') + ' (no constructor returned by dispatch)'; });
	      path[path.length - 1] += '(' + getTypeName(type) + ')';
	    }
	
	    return create(type, value, path);
	  }
	
	  Union.meta = {
	    kind: 'union',
	    types: types,
	    name: name,
	    identity: identity
	  };
	
	  Union.displayName = displayName;
	
	  Union.is = function (x) {
	    return types.some(function (type) {
	      return is(x, type);
	    });
	  };
	
	  Union.dispatch = function (x) { // default dispatch implementation
	    for (var i = 0, len = types.length; i < len; i++ ) {
	      var type = types[i];
	      if (isUnion(type)) { // handle union of unions
	        var t = type.dispatch(x);
	        if (!isNil(t)) {
	          return t;
	        }
	      }
	      else if (is(x, type)) {
	        return type;
	      }
	    }
	  };
	
	  Union.update = function (instance, patch) {
	    return Union(assert.update(instance, patch));
	  };
	
	  return Union;
	}
	
	union.getDefaultName = getDefaultName;
	module.exports = union;
	


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

	var assert = __webpack_require__(25);
	var isObject = __webpack_require__(103);
	var isFunction = __webpack_require__(38);
	var isArray = __webpack_require__(75);
	var isNumber = __webpack_require__(410);
	var mixin = __webpack_require__(180);
	
	function getShallowCopy(x) {
	  if (isArray(x)) {
	    return x.concat();
	  }
	  if (x instanceof Date || x instanceof RegExp) {
	    return x;
	  }
	  if (isObject(x)) {
	    return mixin({}, x);
	  }
	  return x;
	}
	
	function update(instance, patch) {
	
	  if (false) {
	    assert(isObject(patch), function () { return 'Invalid argument patch ' + assert.stringify(patch) + ' supplied to function update(instance, patch): expected an object containing commands'; });
	  }
	
	  var value = getShallowCopy(instance);
	  var isChanged = false;
	  for (var k in patch) {
	    if (patch.hasOwnProperty(k)) {
	      if (update.commands.hasOwnProperty(k)) {
	        value = update.commands[k](patch[k], value);
	        isChanged = true;
	      }
	      else {
	        var newValue = update(value[k], patch[k]);
	        isChanged = isChanged || ( newValue !== value[k] );
	        value[k] = newValue;
	      }
	    }
	  }
	  return isChanged ? value : instance;
	}
	
	// built-in commands
	
	function $apply(f, value) {
	  if (false) {
	    assert(isFunction(f), 'Invalid argument f supplied to immutability helper { $apply: f } (expected a function)');
	  }
	  return f(value);
	}
	
	function $push(elements, arr) {
	  if (false) {
	    assert(isArray(elements), 'Invalid argument elements supplied to immutability helper { $push: elements } (expected an array)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $push (expected an array)');
	  }
	  return arr.concat(elements);
	}
	
	function $remove(keys, obj) {
	  if (false) {
	    assert(isArray(keys), 'Invalid argument keys supplied to immutability helper { $remove: keys } (expected an array)');
	    assert(isObject(obj), 'Invalid value supplied to immutability helper $remove (expected an object)');
	  }
	  for (var i = 0, len = keys.length; i < len; i++ ) {
	    delete obj[keys[i]];
	  }
	  return obj;
	}
	
	function $set(value) {
	  return value;
	}
	
	function $splice(splices, arr) {
	  if (false) {
	    assert(isArray(splices) && splices.every(isArray), 'Invalid argument splices supplied to immutability helper { $splice: splices } (expected an array of arrays)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $splice (expected an array)');
	  }
	  return splices.reduce(function (acc, splice) {
	    acc.splice.apply(acc, splice);
	    return acc;
	  }, arr);
	}
	
	function $swap(config, arr) {
	  if (false) {
	    assert(isObject(config), 'Invalid argument config supplied to immutability helper { $swap: config } (expected an object)');
	    assert(isNumber(config.from), 'Invalid argument config.from supplied to immutability helper { $swap: config } (expected a number)');
	    assert(isNumber(config.to), 'Invalid argument config.to supplied to immutability helper { $swap: config } (expected a number)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $swap (expected an array)');
	  }
	  var element = arr[config.to];
	  arr[config.to] = arr[config.from];
	  arr[config.from] = element;
	  return arr;
	}
	
	function $unshift(elements, arr) {
	  if (false) {
	    assert(isArray(elements), 'Invalid argument elements supplied to immutability helper {$unshift: elements} (expected an array)');
	    assert(isArray(arr), 'Invalid value supplied to immutability helper $unshift (expected an array)');
	  }
	  return elements.concat(arr);
	}
	
	function $merge(obj, value) {
	  return mixin(mixin({}, value), obj, true);
	}
	
	update.commands = {
	  $apply: $apply,
	  $push: $push,
	  $remove: $remove,
	  $set: $set,
	  $splice: $splice,
	  $swap: $swap,
	  $unshift: $unshift,
	  $merge: $merge
	};
	
	module.exports = update;


/***/ }),
/* 949 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 950 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }
	
	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};
	
	
	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }
	
	  if (process.noDeprecation === true) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	};
	
	
	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = ({"BROWSER":true,"NODE_ENV":"production","PRODUCT":"assetportal"}).NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};
	
	
	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;
	
	
	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};
	
	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};
	
	
	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];
	
	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}
	
	
	function stylizeNoColor(str, styleType) {
	  return str;
	}
	
	
	function arrayToHash(array) {
	  var hash = {};
	
	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });
	
	  return hash;
	}
	
	
	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }
	
	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }
	
	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);
	
	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }
	
	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }
	
	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }
	
	  var base = '', array = false, braces = ['{', '}'];
	
	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }
	
	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }
	
	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }
	
	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }
	
	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }
	
	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }
	
	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }
	
	  ctx.seen.push(value);
	
	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }
	
	  ctx.seen.pop();
	
	  return reduceToSingleString(output, base, braces);
	}
	
	
	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}
	
	
	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}
	
	
	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}
	
	
	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }
	
	  return name + ': ' + str;
	}
	
	
	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);
	
	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }
	
	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}
	
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = __webpack_require__(950);
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	
	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}
	
	
	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];
	
	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}
	
	
	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};
	
	
	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(949);
	
	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;
	
	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};
	
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(271)))

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = {
	  getAddon: __webpack_require__(953),
	  getAlert: __webpack_require__(954),
	  getBreakpoints: __webpack_require__(417),
	  getButton: __webpack_require__(955),
	  getButtonGroup: __webpack_require__(956),
	  getCheckbox: __webpack_require__(957),
	  getCol: __webpack_require__(958),
	  getErrorBlock: __webpack_require__(959),
	  getFieldset: __webpack_require__(960),
	  getFormGroup: __webpack_require__(961),
	  getHelpBlock: __webpack_require__(962),
	  getInputGroup: __webpack_require__(963),
	  getLabel: __webpack_require__(964),
	  getOffsets: __webpack_require__(965),
	  getOptGroup: __webpack_require__(966),
	  getOption: __webpack_require__(418),
	  getRadio: __webpack_require__(967),
	  getRow: __webpack_require__(968),
	  getStatic: __webpack_require__(969)
	};

/***/ }),
/* 953 */
/***/ (function(module, exports) {

	'use strict';
	
	function getAddon(addon) {
	  return {
	    tag: 'span',
	    attrs: {
	      className: {
	        'input-group-addon': true
	      }
	    },
	    children: addon
	  };
	}
	
	module.exports = getAddon;

/***/ }),
/* 954 */
/***/ (function(module, exports) {

	'use strict';
	
	function getAlert(opts) {
	
	  var type = opts.type || 'info';
	  var className = {
	    'alert': true
	  };
	  className['alert-' + type] = true;
	
	  return {
	    tag: 'div',
	    attrs: {
	      className: className
	    },
	    children: opts.children
	  };
	}
	
	module.exports = getAlert;

/***/ }),
/* 955 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	
	  Example:
	
	  {
	    type: 'primary',
	    block: true,
	    active: true,
	    size: 'lg',
	    disabled: true,
	    autoFocus: true,
	    events: {
	      ...
	    }
	  }
	
	*/
	
	function getButton(opts) {
	
	  var type = opts.type || 'default';
	
	  var className = {
	    'btn': true,
	    'btn-block': opts.block,
	    'active': opts.active
	  };
	  className['btn-' + type] = true;
	  if (opts.size) {
	    className['btn-' + opts.size] = true;
	  }
	  if (opts.className) {
	    className[opts.className] = true;
	  }
	
	  var events = opts.events || {
	    click: opts.click
	  };
	
	  return {
	    tag: 'button',
	    attrs: {
	      type: 'button',
	      disabled: opts.disabled,
	      className: className,
	      autoFocus: opts.autoFocus
	    },
	    events: events,
	    children: opts.label,
	    key: opts.key
	  }
	}
	
	module.exports = getButton;


/***/ }),
/* 956 */
/***/ (function(module, exports) {

	'use strict';
	
	function getButtonGroup(buttons) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'btn-group': true
	      }
	    },
	    children: buttons
	  };
	};
	
	module.exports = getButtonGroup;
	


/***/ }),
/* 957 */
/***/ (function(module, exports) {

	'use strict';
	
	function getCheckbox(attrs, label) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'checkbox': true,
	        'disabled': attrs.disabled
	      }
	    },
	    children: {
	      tag: 'label',
	      attrs: {
	        htmlFor: attrs.id
	      },
	      children: [
	        {
	          tag: 'input',
	          attrs: attrs
	        },
	        ' ',
	        label
	      ]
	    }
	  };
	}
	
	module.exports = getCheckbox;

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getBreakpoints = __webpack_require__(417);
	
	function getCol(opts) {
	
	  var className = opts.breakpoints ? getBreakpoints(opts.breakpoints) : null;
	
	  return {
	    tag: 'div',
	    attrs: {
	      className: className
	    },
	    children: opts.children
	  };
	}
	
	module.exports = getCol;

/***/ }),
/* 959 */
/***/ (function(module, exports) {

	'use strict';
	
	function getErrorBlock(opts) {
	  return {
	    tag: 'span',
	    attrs: {
	      className: {
	        'help-block': true,
	        'error-block': opts.hasError
	      }
	    },
	    children: opts.error
	  };
	}
	
	module.exports = getErrorBlock;
	


/***/ }),
/* 960 */
/***/ (function(module, exports) {

	'use strict';
	
	function getFieldset(opts) {
	
	  var children = opts.children.slice();
	
	  if (opts.legend) {
	    children.unshift({
	      tag: 'legend',
	      children: opts.legend
	    });
	  }
	
	  return {
	    tag: 'fieldset',
	    attrs: {
	      className: opts.className,
	      disabled: opts.disabled
	    },
	    children: children
	  };
	};
	
	module.exports = getFieldset;
	


/***/ }),
/* 961 */
/***/ (function(module, exports) {

	'use strict';
	
	function getFormGroup(opts) {
	
	  var className = {
	    'form-group': true,
	    'has-error': opts.hasError
	  };
	  if (opts.className) {
	    className[opts.className] = true;
	  }
	
	  return {
	    tag: 'div',
	    attrs: {
	      className: className
	    },
	    children: opts.children
	  };
	}
	
	module.exports = getFormGroup;

/***/ }),
/* 962 */
/***/ (function(module, exports) {

	'use strict';
	
	/*
	
	  Example:
	
	  {
	    help: 'my help',
	    hasError: true,
	    id: 'password-tip'
	  }
	
	*/
	
	function getHelpBlock(opts) {
	  return {
	    tag: 'span',
	    attrs: {
	      className: {
	        'help-block': true,
	        'error-block': opts.hasError
	      },
	      // aria support
	      id: opts.id,
	      role: 'tooltip'
	    },
	    children: opts.help
	  };
	}
	
	module.exports = getHelpBlock;
	


/***/ }),
/* 963 */
/***/ (function(module, exports) {

	'use strict';
	
	function getInputGroup(children) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'input-group': true
	      }
	    },
	    children: children
	  };
	}
	
	module.exports = getInputGroup;

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var mixin = __webpack_require__(970);
	
	/*
	
	  Example:
	
	  {
	    label: 'my label',
	    htmlFor: 'inputId',
	    id: 'myid',
	    align: 'right',
	    className: {}
	  }
	
	*/
	
	function getLabel(opts) {
	
	  var className = mixin({
	    'control-label': true
	  }, opts.className);
	
	  if (opts.align) {
	    className['text-' + opts.align] = true;
	  }
	
	  return {
	    tag: 'label',
	    attrs: {
	      htmlFor: opts.htmlFor,
	      id: opts.id,
	      className: className
	    },
	    children: opts.label
	  };
	}
	
	module.exports = getLabel;
	


/***/ }),
/* 965 */
/***/ (function(module, exports) {

	'use strict';
	
	function getOffsets(breakpoints) {
	  var className = {};
	  for (var size in breakpoints) {
	    if (breakpoints.hasOwnProperty(size)) {
	      className['col-' + size + '-offset-' + (12 - breakpoints[size])] = true;
	    }
	  }
	  return className;
	}
	
	module.exports = getOffsets;

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getOption = __webpack_require__(418);
	
	/*
	
	  Example:
	
	  {
	    label: 'group1',
	    options: [
	      {value: 'value1', text: 'description1'},
	      {value: 'value3', text: 'description3'}
	    ]
	  }
	
	*/
	
	function getOptGroup(opts) {
	  return {
	    tag: 'optgroup',
	    attrs: {
	      disabled: opts.disabled,
	      label: opts.label
	    },
	    children: opts.options.map(getOption),
	    key: opts.label
	  };
	}
	
	module.exports = getOptGroup;
	


/***/ }),
/* 967 */
/***/ (function(module, exports) {

	'use strict';
	
	function getRadio(attrs, text, key) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'radio': true,
	        'disabled': attrs.disabled
	      }
	    },
	    children: {
	      tag: 'label',
	      attrs: {
	        htmlFor: attrs.id,
	      },
	      children: [
	        {
	          tag: 'input',
	          attrs: attrs
	        },
	        ' ',
	        text
	      ]
	    },
	    key: key
	  };
	}
	
	module.exports = getRadio;

/***/ }),
/* 968 */
/***/ (function(module, exports) {

	'use strict';
	
	function getRow(opts) {
	  return {
	    tag: 'div',
	    attrs: {
	      className: {
	        'row': true
	      }
	    },
	    children: opts.children,
	    key: opts.key
	  };
	}
	
	module.exports = getRow;

/***/ }),
/* 969 */
/***/ (function(module, exports) {

	'use strict';
	
	function getStatic(value) {
	  return {
	    tag: 'p',
	    attrs: {
	      className: {
	        'form-control-static': true
	      }
	    },
	    children: value
	  };
	}
	
	module.exports = getStatic;

/***/ }),
/* 970 */
/***/ (function(module, exports) {

	'use strict';
	
	function mixin(a, b) {
	  if (!b) { return a; }
	  for (var k in b) {
	    if (b.hasOwnProperty(k)) {
	      a[k] = b[k];
	    }
	  }
	  return a;
	}
	
	module.exports = mixin;

/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var React = __webpack_require__(2);
	var cx = __webpack_require__(14);
	
	// compile: x -> ReactElement
	function compile(x) {
	
	  // with host elements, compile behaves like the identity
	  if (React.isValidElement(x)) {
	    return x;
	  }
	
	  if (Array.isArray(x)) {
	    return x.map(compile);
	  }
	
	  if (typeof x === 'object' && x !== null) {
	
	    // attrs
	    var attrs = mixin({}, x.attrs);
	    if (attrs.className) {
	      attrs.className = cx(attrs.className) || null; // avoid class=""
	    }
	    if (x.key != null) { attrs.key = x.key; }
	    if (x.ref != null) { attrs.ref = x.ref; }
	
	    // events
	    if (x.events) {
	      for (var name in x.events) {
	        attrs[camelizeEvent(name)] = x.events[name];
	      }
	    }
	
	    // children
	    var children = compile(x.children);
	
	    // build ReactElement
	    return React.createElement.apply(React, [x.tag, attrs].concat(children));
	  }
	
	  return x;
	}
	
	//
	// helpers
	//
	
	// transforms an event name to a React event name
	// click -> onClick
	// blur -> onBlur
	function camelizeEvent(name) {
	  return 'on' + name.charAt(0).toUpperCase() + name.substring(1);
	}
	
	function mixin(x, y) {
	  if (!y) { return x; }
	  for (var k in y) {
	    if (y.hasOwnProperty(k)) {
	      x[k] = y[k];
	    }
	  }
	  return x;
	}
	
	module.exports = {
	  compile: compile
	};

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _button = __webpack_require__(140);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file big-play-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The initial play button that shows before the video has played. The hiding of the
	 * `BigPlayButton` get done via CSS and `Player` states.
	 *
	 * @extends Button
	 */
	var BigPlayButton = function (_Button) {
	  _inherits(BigPlayButton, _Button);
	
	  function BigPlayButton(player, options) {
	    _classCallCheck(this, BigPlayButton);
	
	    var _this = _possibleConstructorReturn(this, _Button.call(this, player, options));
	
	    _this.mouseused_ = false;
	
	    _this.on('mousedown', _this.handleMouseDown);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object. Always returns 'vjs-big-play-button'.
	   */
	
	
	  BigPlayButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-big-play-button';
	  };
	
	  /**
	   * This gets called when a `BigPlayButton` "clicked". See {@link ClickableComponent}
	   * for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  BigPlayButton.prototype.handleClick = function handleClick(event) {
	    var playPromise = this.player_.play();
	
	    // exit early if clicked via the mouse
	    if (this.mouseused_ && event.clientX && event.clientY) {
	      return;
	    }
	
	    var cb = this.player_.getChild('controlBar');
	    var playToggle = cb && cb.getChild('playToggle');
	
	    if (!playToggle) {
	      this.player_.focus();
	      return;
	    }
	
	    var playFocus = function playFocus() {
	      return playToggle.focus();
	    };
	
	    if (playPromise && playPromise.then) {
	      var ignoreRejectedPlayPromise = function ignoreRejectedPlayPromise() {};
	
	      playPromise.then(playFocus, ignoreRejectedPlayPromise);
	    } else {
	      this.setTimeout(playFocus, 1);
	    }
	  };
	
	  BigPlayButton.prototype.handleKeyPress = function handleKeyPress(event) {
	    this.mouseused_ = false;
	
	    _Button.prototype.handleKeyPress.call(this, event);
	  };
	
	  BigPlayButton.prototype.handleMouseDown = function handleMouseDown(event) {
	    this.mouseused_ = true;
	  };
	
	  return BigPlayButton;
	}(_button2['default']);
	
	/**
	 * The text that should display over the `BigPlayButton`s controls. Added to for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	BigPlayButton.prototype.controlText_ = 'Play Video';
	
	_component2['default'].registerComponent('BigPlayButton', BigPlayButton);
	exports['default'] = BigPlayButton;


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _button = __webpack_require__(140);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file close-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The `CloseButton` is a `{@link Button}` that fires a `close` event when
	 * it gets clicked.
	 *
	 * @extends Button
	 */
	var CloseButton = function (_Button) {
	  _inherits(CloseButton, _Button);
	
	  /**
	   * Creates an instance of the this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of player options.
	   */
	  function CloseButton(player, options) {
	    _classCallCheck(this, CloseButton);
	
	    var _this = _possibleConstructorReturn(this, _Button.call(this, player, options));
	
	    _this.controlText(options && options.controlText || _this.localize('Close'));
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  CloseButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-close-button ' + _Button.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * This gets called when a `CloseButton` gets clicked. See
	   * {@link ClickableComponent#handleClick} for more information on when this will be
	   * triggered
	   *
	   * @param {EventTarget~Event} event
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   * @fires CloseButton#close
	   */
	
	
	  CloseButton.prototype.handleClick = function handleClick(event) {
	
	    /**
	     * Triggered when the a `CloseButton` is clicked.
	     *
	     * @event CloseButton#close
	     * @type {EventTarget~Event}
	     *
	     * @property {boolean} [bubbles=false]
	     *           set to false so that the close event does not
	     *           bubble up to parents if there is no listener
	     */
	    this.trigger({ type: 'close', bubbles: false });
	  };
	
	  return CloseButton;
	}(_button2['default']);
	
	_component2['default'].registerComponent('CloseButton', CloseButton);
	exports['default'] = CloseButton;


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackButton = __webpack_require__(420);
	
	var _trackButton2 = _interopRequireDefault(_trackButton);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _audioTrackMenuItem = __webpack_require__(975);
	
	var _audioTrackMenuItem2 = _interopRequireDefault(_audioTrackMenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file audio-track-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The base class for buttons that toggle specific {@link AudioTrack} types.
	 *
	 * @extends TrackButton
	 */
	var AudioTrackButton = function (_TrackButton) {
	  _inherits(AudioTrackButton, _TrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function AudioTrackButton(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, AudioTrackButton);
	
	    options.tracks = player.audioTracks && player.audioTracks();
	
	    var _this = _possibleConstructorReturn(this, _TrackButton.call(this, player, options));
	
	    _this.el_.setAttribute('aria-label', 'Audio Menu');
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  AudioTrackButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-audio-button ' + _TrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Create a menu item for each audio track
	   *
	   * @param {AudioTrackMenuItem[]} [items=[]]
	   *        An array of existing menu items to use.
	   *
	   * @return {AudioTrackMenuItem[]}
	   *         An array of menu items
	   */
	
	
	  AudioTrackButton.prototype.createItems = function createItems() {
	    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    // if there's only one audio track, there no point in showing it
	    this.hideThreshold_ = 1;
	
	    var tracks = this.player_.audioTracks && this.player_.audioTracks();
	
	    if (!tracks) {
	      return items;
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	
	      items.push(new _audioTrackMenuItem2['default'](this.player_, {
	        track: track,
	        // MenuItem is selectable
	        selectable: true
	      }));
	    }
	
	    return items;
	  };
	
	  return AudioTrackButton;
	}(_trackButton2['default']);
	
	/**
	 * The text that should display over the `AudioTrackButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	AudioTrackButton.prototype.controlText_ = 'Audio Track';
	_component2['default'].registerComponent('AudioTrackButton', AudioTrackButton);
	exports['default'] = AudioTrackButton;


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _menuItem = __webpack_require__(183);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file audio-track-menu-item.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * An {@link AudioTrack} {@link MenuItem}
	 *
	 * @extends MenuItem
	 */
	var AudioTrackMenuItem = function (_MenuItem) {
	  _inherits(AudioTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function AudioTrackMenuItem(player, options) {
	    _classCallCheck(this, AudioTrackMenuItem);
	
	    var track = options.track;
	    var tracks = player.audioTracks();
	
	    // Modify options for parent MenuItem class's init.
	    options.label = track.label || track.language || 'Unknown';
	    options.selected = track.enabled;
	
	    var _this = _possibleConstructorReturn(this, _MenuItem.call(this, player, options));
	
	    _this.track = track;
	
	    if (tracks) {
	      var changeHandler = Fn.bind(_this, _this.handleTracksChange);
	
	      tracks.addEventListener('change', changeHandler);
	      _this.on('dispose', function () {
	        tracks.removeEventListener('change', changeHandler);
	      });
	    }
	    return _this;
	  }
	
	  /**
	   * This gets called when an `AudioTrackMenuItem is "clicked". See {@link ClickableComponent}
	   * for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  AudioTrackMenuItem.prototype.handleClick = function handleClick(event) {
	    var tracks = this.player_.audioTracks();
	
	    _MenuItem.prototype.handleClick.call(this, event);
	
	    if (!tracks) {
	      return;
	    }
	
	    for (var i = 0; i < tracks.length; i++) {
	      var track = tracks[i];
	
	      track.enabled = track === this.track;
	    }
	  };
	
	  /**
	   * Handle any {@link AudioTrack} change.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link AudioTrackList#change} event that caused this to run.
	   *
	   * @listens AudioTrackList#change
	   */
	
	
	  AudioTrackMenuItem.prototype.handleTracksChange = function handleTracksChange(event) {
	    this.selected(this.track.enabled);
	  };
	
	  return AudioTrackMenuItem;
	}(_menuItem2['default']);
	
	_component2['default'].registerComponent('AudioTrackMenuItem', AudioTrackMenuItem);
	exports['default'] = AudioTrackMenuItem;


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	__webpack_require__(979);
	
	__webpack_require__(997);
	
	__webpack_require__(998);
	
	__webpack_require__(1000);
	
	__webpack_require__(999);
	
	__webpack_require__(978);
	
	__webpack_require__(985);
	
	__webpack_require__(977);
	
	__webpack_require__(1001);
	
	__webpack_require__(1003);
	
	__webpack_require__(419);
	
	__webpack_require__(992);
	
	__webpack_require__(994);
	
	__webpack_require__(996);
	
	__webpack_require__(991);
	
	__webpack_require__(974);
	
	__webpack_require__(980);
	
	__webpack_require__(988);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file control-bar.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	// Required children
	
	
	/**
	 * Container of main controls.
	 *
	 * @extends Component
	 */
	var ControlBar = function (_Component) {
	  _inherits(ControlBar, _Component);
	
	  function ControlBar() {
	    _classCallCheck(this, ControlBar);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ControlBar.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-control-bar',
	      dir: 'ltr'
	    }, {
	      // The control bar is a group, so it can contain menuitems
	      role: 'group'
	    });
	  };
	
	  return ControlBar;
	}(_component2['default']);
	
	/**
	 * Default options for `ControlBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ControlBar.prototype.options_ = {
	  children: ['playToggle', 'volumeMenuButton', 'currentTimeDisplay', 'timeDivider', 'durationDisplay', 'progressControl', 'liveDisplay', 'remainingTimeDisplay', 'customControlSpacer', 'playbackRateMenuButton', 'chaptersButton', 'descriptionsButton', 'subtitlesButton', 'captionsButton', 'audioTrackButton', 'fullscreenToggle']
	};
	
	_component2['default'].registerComponent('ControlBar', ControlBar);
	exports['default'] = ControlBar;


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _button = __webpack_require__(140);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file fullscreen-toggle.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Toggle fullscreen video
	 *
	 * @extends Button
	 */
	var FullscreenToggle = function (_Button) {
	  _inherits(FullscreenToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function FullscreenToggle(player, options) {
	    _classCallCheck(this, FullscreenToggle);
	
	    var _this = _possibleConstructorReturn(this, _Button.call(this, player, options));
	
	    _this.on(player, 'fullscreenchange', _this.handleFullscreenChange);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  FullscreenToggle.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-fullscreen-control ' + _Button.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Handles fullscreenchange on the player and change control text accordingly.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#fullscreenchange} event that caused this function to be
	   *        called.
	   *
	   * @listens Player#fullscreenchange
	   */
	
	
	  FullscreenToggle.prototype.handleFullscreenChange = function handleFullscreenChange(event) {
	    if (this.player_.isFullscreen()) {
	      this.controlText('Non-Fullscreen');
	    } else {
	      this.controlText('Fullscreen');
	    }
	  };
	
	  /**
	   * This gets called when an `FullscreenToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  FullscreenToggle.prototype.handleClick = function handleClick(event) {
	    if (!this.player_.isFullscreen()) {
	      this.player_.requestFullscreen();
	    } else {
	      this.player_.exitFullscreen();
	    }
	  };
	
	  return FullscreenToggle;
	}(_button2['default']);
	
	/**
	 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	FullscreenToggle.prototype.controlText_ = 'Fullscreen';
	
	_component2['default'].registerComponent('FullscreenToggle', FullscreenToggle);
	exports['default'] = FullscreenToggle;


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file live-display.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	// TODO - Future make it click to snap to live
	
	/**
	 * Displays the live indicator when duration is Infinity.
	 *
	 * @extends Component
	 */
	var LiveDisplay = function (_Component) {
	  _inherits(LiveDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function LiveDisplay(player, options) {
	    _classCallCheck(this, LiveDisplay);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.updateShowing();
	    _this.on(_this.player(), 'durationchange', _this.updateShowing);
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  LiveDisplay.prototype.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-live-control vjs-control'
	    });
	
	    this.contentEl_ = Dom.createEl('div', {
	      className: 'vjs-live-display',
	      innerHTML: '<span class="vjs-control-text">' + this.localize('Stream Type') + '</span>' + this.localize('LIVE')
	    }, {
	      'aria-live': 'off'
	    });
	
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  /**
	   * Check the duration to see if the LiveDisplay should be showing or not. Then show/hide
	   * it accordingly
	   *
	   * @param {EventTarget~Event} [event]
	   *        The {@link Player#durationchange} event that caused this function to run.
	   *
	   * @listens Player#durationchange
	   */
	
	
	  LiveDisplay.prototype.updateShowing = function updateShowing(event) {
	    if (this.player().duration() === Infinity) {
	      this.show();
	    } else {
	      this.hide();
	    }
	  };
	
	  return LiveDisplay;
	}(_component2['default']);
	
	_component2['default'].registerComponent('LiveDisplay', LiveDisplay);
	exports['default'] = LiveDisplay;


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _button = __webpack_require__(140);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file play-toggle.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Button to toggle between play and pause.
	 *
	 * @extends Button
	 */
	var PlayToggle = function (_Button) {
	  _inherits(PlayToggle, _Button);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlayToggle(player, options) {
	    _classCallCheck(this, PlayToggle);
	
	    var _this = _possibleConstructorReturn(this, _Button.call(this, player, options));
	
	    _this.on(player, 'play', _this.handlePlay);
	    _this.on(player, 'pause', _this.handlePause);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  PlayToggle.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-play-control ' + _Button.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * This gets called when an `PlayToggle` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  PlayToggle.prototype.handleClick = function handleClick(event) {
	    if (this.player_.paused()) {
	      this.player_.play();
	    } else {
	      this.player_.pause();
	    }
	  };
	
	  /**
	   * Add the vjs-playing class to the element so it can change appearance.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#play
	   */
	
	
	  PlayToggle.prototype.handlePlay = function handlePlay(event) {
	    this.removeClass('vjs-paused');
	    this.addClass('vjs-playing');
	    // change the button text to "Pause"
	    this.controlText('Pause');
	  };
	
	  /**
	   * Add the vjs-paused class to the element so it can change appearance.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#pause
	   */
	
	
	  PlayToggle.prototype.handlePause = function handlePause(event) {
	    this.removeClass('vjs-playing');
	    this.addClass('vjs-paused');
	    // change the button text to "Play"
	    this.controlText('Play');
	  };
	
	  return PlayToggle;
	}(_button2['default']);
	
	/**
	 * The text that should display over the `PlayToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlayToggle.prototype.controlText_ = 'Play';
	
	_component2['default'].registerComponent('PlayToggle', PlayToggle);
	exports['default'] = PlayToggle;


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _menuButton = __webpack_require__(423);
	
	var _menuButton2 = _interopRequireDefault(_menuButton);
	
	var _menu = __webpack_require__(424);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _playbackRateMenuItem = __webpack_require__(981);
	
	var _playbackRateMenuItem2 = _interopRequireDefault(_playbackRateMenuItem);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file playback-rate-menu-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The component for controlling the playback rate.
	 *
	 * @extends MenuButton
	 */
	var PlaybackRateMenuButton = function (_MenuButton) {
	  _inherits(PlaybackRateMenuButton, _MenuButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlaybackRateMenuButton(player, options) {
	    _classCallCheck(this, PlaybackRateMenuButton);
	
	    var _this = _possibleConstructorReturn(this, _MenuButton.call(this, player, options));
	
	    _this.updateVisibility();
	    _this.updateLabel();
	
	    _this.on(player, 'loadstart', _this.updateVisibility);
	    _this.on(player, 'ratechange', _this.updateLabel);
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  PlaybackRateMenuButton.prototype.createEl = function createEl() {
	    var el = _MenuButton.prototype.createEl.call(this);
	
	    this.labelEl_ = Dom.createEl('div', {
	      className: 'vjs-playback-rate-value',
	      innerHTML: 1.0
	    });
	
	    el.appendChild(this.labelEl_);
	
	    return el;
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  PlaybackRateMenuButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-playback-rate ' + _MenuButton.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Create the playback rate menu
	   *
	   * @return {Menu}
	   *         Menu object populated with {@link PlaybackRateMenuItem}s
	   */
	
	
	  PlaybackRateMenuButton.prototype.createMenu = function createMenu() {
	    var menu = new _menu2['default'](this.player());
	    var rates = this.playbackRates();
	
	    if (rates) {
	      for (var i = rates.length - 1; i >= 0; i--) {
	        menu.addChild(new _playbackRateMenuItem2['default'](this.player(), { rate: rates[i] + 'x' }));
	      }
	    }
	
	    return menu;
	  };
	
	  /**
	   * Updates ARIA accessibility attributes
	   */
	
	
	  PlaybackRateMenuButton.prototype.updateARIAAttributes = function updateARIAAttributes() {
	    // Current playback rate
	    this.el().setAttribute('aria-valuenow', this.player().playbackRate());
	  };
	
	  /**
	   * This gets called when an `PlaybackRateMenuButton` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  PlaybackRateMenuButton.prototype.handleClick = function handleClick(event) {
	    // select next rate option
	    var currentRate = this.player().playbackRate();
	    var rates = this.playbackRates();
	
	    // this will select first one if the last one currently selected
	    var newRate = rates[0];
	
	    for (var i = 0; i < rates.length; i++) {
	      if (rates[i] > currentRate) {
	        newRate = rates[i];
	        break;
	      }
	    }
	    this.player().playbackRate(newRate);
	  };
	
	  /**
	   * Get possible playback rates
	   *
	   * @return {Array}
	   *         All possible playback rates
	   */
	
	
	  PlaybackRateMenuButton.prototype.playbackRates = function playbackRates() {
	    return this.options_.playbackRates || this.options_.playerOptions && this.options_.playerOptions.playbackRates;
	  };
	
	  /**
	   * Get whether playback rates is supported by the tech
	   * and an array of playback rates exists
	   *
	   * @return {boolean}
	   *         Whether changing playback rate is supported
	   */
	
	
	  PlaybackRateMenuButton.prototype.playbackRateSupported = function playbackRateSupported() {
	    return this.player().tech_ && this.player().tech_.featuresPlaybackRate && this.playbackRates() && this.playbackRates().length > 0;
	  };
	
	  /**
	   * Hide playback rate controls when they're no playback rate options to select
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#loadstart
	   */
	
	
	  PlaybackRateMenuButton.prototype.updateVisibility = function updateVisibility(event) {
	    if (this.playbackRateSupported()) {
	      this.removeClass('vjs-hidden');
	    } else {
	      this.addClass('vjs-hidden');
	    }
	  };
	
	  /**
	   * Update button label when rate changed
	   *
	   * @param {EventTarget~Event} [event]
	   *        The event that caused this function to run.
	   *
	   * @listens Player#ratechange
	   */
	
	
	  PlaybackRateMenuButton.prototype.updateLabel = function updateLabel(event) {
	    if (this.playbackRateSupported()) {
	      this.labelEl_.innerHTML = this.player().playbackRate() + 'x';
	    }
	  };
	
	  return PlaybackRateMenuButton;
	}(_menuButton2['default']);
	
	/**
	 * The text that should display over the `FullscreenToggle`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlaybackRateMenuButton.prototype.controlText_ = 'Playback Rate';
	
	_component2['default'].registerComponent('PlaybackRateMenuButton', PlaybackRateMenuButton);
	exports['default'] = PlaybackRateMenuButton;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _menuItem = __webpack_require__(183);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file playback-rate-menu-item.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The specific menu item type for selecting a playback rate.
	 *
	 * @extends MenuItem
	 */
	var PlaybackRateMenuItem = function (_MenuItem) {
	  _inherits(PlaybackRateMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlaybackRateMenuItem(player, options) {
	    _classCallCheck(this, PlaybackRateMenuItem);
	
	    var label = options.rate;
	    var rate = parseFloat(label, 10);
	
	    // Modify options for parent MenuItem class's init.
	    options.label = label;
	    options.selected = rate === 1;
	    options.selectable = true;
	
	    var _this = _possibleConstructorReturn(this, _MenuItem.call(this, player, options));
	
	    _this.label = label;
	    _this.rate = rate;
	
	    _this.on(player, 'ratechange', _this.update);
	    return _this;
	  }
	
	  /**
	   * This gets called when an `PlaybackRateMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  PlaybackRateMenuItem.prototype.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this);
	    this.player().playbackRate(this.rate);
	  };
	
	  /**
	   * Update the PlaybackRateMenuItem when the playbackrate changes.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `ratechange` event that caused this function to run.
	   *
	   * @listens Player#ratechange
	   */
	
	
	  PlaybackRateMenuItem.prototype.update = function update(event) {
	    this.selected(this.player().playbackRate() === this.rate);
	  };
	
	  return PlaybackRateMenuItem;
	}(_menuItem2['default']);
	
	/**
	 * The text that should display over the `PlaybackRateMenuItem`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	PlaybackRateMenuItem.prototype.contentElType = 'button';
	
	_component2['default'].registerComponent('PlaybackRateMenuItem', PlaybackRateMenuItem);
	exports['default'] = PlaybackRateMenuItem;


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file load-progress-bar.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Shows loading progress
	 *
	 * @extends Component
	 */
	var LoadProgressBar = function (_Component) {
	  _inherits(LoadProgressBar, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function LoadProgressBar(player, options) {
	    _classCallCheck(this, LoadProgressBar);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.partEls_ = [];
	    _this.on(player, 'progress', _this.update);
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  LoadProgressBar.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-load-progress',
	      innerHTML: '<span class="vjs-control-text"><span>' + this.localize('Loaded') + '</span>: 0%</span>'
	    });
	  };
	
	  /**
	   * Update progress bar
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `progress` event that caused this function to run.
	   *
	   * @listens Player#progress
	   */
	
	
	  LoadProgressBar.prototype.update = function update(event) {
	    var buffered = this.player_.buffered();
	    var duration = this.player_.duration();
	    var bufferedEnd = this.player_.bufferedEnd();
	    var children = this.partEls_;
	
	    // get the percent width of a time compared to the total end
	    var percentify = function percentify(time, end) {
	      // no NaN
	      var percent = time / end || 0;
	
	      return (percent >= 1 ? 1 : percent) * 100 + '%';
	    };
	
	    // update the width of the progress bar
	    this.el_.style.width = percentify(bufferedEnd, duration);
	
	    // add child elements to represent the individual buffered time ranges
	    for (var i = 0; i < buffered.length; i++) {
	      var start = buffered.start(i);
	      var end = buffered.end(i);
	      var part = children[i];
	
	      if (!part) {
	        part = this.el_.appendChild(Dom.createEl());
	        children[i] = part;
	      }
	
	      // set the percent based on the width of the progress bar (bufferedEnd)
	      part.style.left = percentify(start, bufferedEnd);
	      part.style.width = percentify(end - start, bufferedEnd);
	    }
	
	    // remove unused buffered range elements
	    for (var _i = children.length; _i > buffered.length; _i--) {
	      this.el_.removeChild(children[_i - 1]);
	    }
	    children.length = buffered.length;
	  };
	
	  return LoadProgressBar;
	}(_component2['default']);
	
	_component2['default'].registerComponent('LoadProgressBar', LoadProgressBar);
	exports['default'] = LoadProgressBar;


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _formatTime = __webpack_require__(84);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	var _computedStyle = __webpack_require__(269);
	
	var _computedStyle2 = _interopRequireDefault(_computedStyle);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file mouse-time-display.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The Mouse Time Display component shows the time you will seek to
	 * when hovering over the progress bar
	 *
	 * @extends Component
	 */
	var MouseTimeDisplay = function (_Component) {
	  _inherits(MouseTimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function MouseTimeDisplay(player, options) {
	    _classCallCheck(this, MouseTimeDisplay);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    if (options.playerOptions && options.playerOptions.controlBar && options.playerOptions.controlBar.progressControl && options.playerOptions.controlBar.progressControl.keepTooltipsInside) {
	      _this.keepTooltipsInside = options.playerOptions.controlBar.progressControl.keepTooltipsInside;
	    }
	
	    if (_this.keepTooltipsInside) {
	      _this.tooltip = Dom.createEl('div', { className: 'vjs-time-tooltip' });
	      _this.el().appendChild(_this.tooltip);
	      _this.addClass('vjs-keep-tooltips-inside');
	    }
	
	    _this.update(0, 0);
	
	    player.on('ready', function () {
	      _this.on(player.controlBar.progressControl.el(), 'mousemove', Fn.throttle(Fn.bind(_this, _this.handleMouseMove), 25));
	    });
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  MouseTimeDisplay.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-mouse-display'
	    });
	  };
	
	  /**
	   * Handle the mouse move event on the `MouseTimeDisplay`.
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this to event to run.
	   *
	   * @listen mousemove
	   */
	
	
	  MouseTimeDisplay.prototype.handleMouseMove = function handleMouseMove(event) {
	    var duration = this.player_.duration();
	    var newTime = this.calculateDistance(event) * duration;
	    var position = event.pageX - Dom.findElPosition(this.el().parentNode).left;
	
	    this.update(newTime, position);
	  };
	
	  /**
	   * Update the time and posistion of the `MouseTimeDisplay`.
	   *
	   * @param {number} newTime
	   *        Time to change the `MouseTimeDisplay` to.
	   *
	   * @param {nubmer} position
	   *        Postion from the left of the in pixels.
	   */
	
	
	  MouseTimeDisplay.prototype.update = function update(newTime, position) {
	    var time = (0, _formatTime2['default'])(newTime, this.player_.duration());
	
	    this.el().style.left = position + 'px';
	    this.el().setAttribute('data-current-time', time);
	
	    if (this.keepTooltipsInside) {
	      var clampedPosition = this.clampPosition_(position);
	      var difference = position - clampedPosition + 1;
	      var tooltipWidth = parseFloat((0, _computedStyle2['default'])(this.tooltip, 'width'));
	      var tooltipWidthHalf = tooltipWidth / 2;
	
	      this.tooltip.innerHTML = time;
	      this.tooltip.style.right = '-' + (tooltipWidthHalf - difference) + 'px';
	    }
	  };
	
	  /**
	   * Get the mouse pointers x coordinate in pixels.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `mousemove` event that was passed to this function by
	   *        {@link MouseTimeDisplay#handleMouseMove}
	   *
	   * @return {number}
	   *         THe x position in pixels of the mouse pointer.
	   */
	
	
	  MouseTimeDisplay.prototype.calculateDistance = function calculateDistance(event) {
	    return Dom.getPointerPosition(this.el().parentNode, event).x;
	  };
	
	  /**
	   * This takes in a horizontal position for the bar and returns a clamped position.
	   * Clamped position means that it will keep the position greater than half the width
	   * of the tooltip and smaller than the player width minus half the width o the tooltip.
	   * It will only clamp the position if `keepTooltipsInside` option is set.
	   *
	   * @param {number} position
	   *        The position the bar wants to be
	   *
	   * @return {number}
	   *         The (potentially) new clamped position.
	   *
	   * @private
	   */
	
	
	  MouseTimeDisplay.prototype.clampPosition_ = function clampPosition_(position) {
	    if (!this.keepTooltipsInside) {
	      return position;
	    }
	
	    var playerWidth = parseFloat((0, _computedStyle2['default'])(this.player().el(), 'width'));
	    var tooltipWidth = parseFloat((0, _computedStyle2['default'])(this.tooltip, 'width'));
	    var tooltipWidthHalf = tooltipWidth / 2;
	    var actualPosition = position;
	
	    if (position < tooltipWidthHalf) {
	      actualPosition = Math.ceil(tooltipWidthHalf);
	    } else if (position > playerWidth - tooltipWidthHalf) {
	      actualPosition = Math.floor(playerWidth - tooltipWidthHalf);
	    }
	
	    return actualPosition;
	  };
	
	  return MouseTimeDisplay;
	}(_component2['default']);
	
	_component2['default'].registerComponent('MouseTimeDisplay', MouseTimeDisplay);
	exports['default'] = MouseTimeDisplay;


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _formatTime = __webpack_require__(84);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file play-progress-bar.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Shows play progress
	 *
	 * @extends Component
	 */
	var PlayProgressBar = function (_Component) {
	  _inherits(PlayProgressBar, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PlayProgressBar(player, options) {
	    _classCallCheck(this, PlayProgressBar);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.updateDataAttr();
	    _this.on(player, 'timeupdate', _this.updateDataAttr);
	    player.ready(Fn.bind(_this, _this.updateDataAttr));
	
	    if (options.playerOptions && options.playerOptions.controlBar && options.playerOptions.controlBar.progressControl && options.playerOptions.controlBar.progressControl.keepTooltipsInside) {
	      _this.keepTooltipsInside = options.playerOptions.controlBar.progressControl.keepTooltipsInside;
	    }
	
	    if (_this.keepTooltipsInside) {
	      _this.addClass('vjs-keep-tooltips-inside');
	    }
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  PlayProgressBar.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-play-progress vjs-slider-bar',
	      innerHTML: '<span class="vjs-control-text"><span>' + this.localize('Progress') + '</span>: 0%</span>'
	    });
	  };
	
	  /**
	   * Update the data-current-time attribute on the `PlayProgressBar`.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   */
	
	
	  PlayProgressBar.prototype.updateDataAttr = function updateDataAttr(event) {
	    var time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	
	    this.el_.setAttribute('data-current-time', (0, _formatTime2['default'])(time, this.player_.duration()));
	  };
	
	  return PlayProgressBar;
	}(_component2['default']);
	
	_component2['default'].registerComponent('PlayProgressBar', PlayProgressBar);
	exports['default'] = PlayProgressBar;


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	__webpack_require__(986);
	
	__webpack_require__(983);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file progress-control.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The Progress Control component contains the seek bar, load progress,
	 * and play progress.
	 *
	 * @extends Component
	 */
	var ProgressControl = function (_Component) {
	  _inherits(ProgressControl, _Component);
	
	  function ProgressControl() {
	    _classCallCheck(this, ProgressControl);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  ProgressControl.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-progress-control vjs-control'
	    });
	  };
	
	  return ProgressControl;
	}(_component2['default']);
	
	/**
	 * Default options for `ProgressControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	ProgressControl.prototype.options_ = {
	  children: ['seekBar']
	};
	
	_component2['default'].registerComponent('ProgressControl', ProgressControl);
	exports['default'] = ProgressControl;


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _slider = __webpack_require__(427);
	
	var _slider2 = _interopRequireDefault(_slider);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _formatTime = __webpack_require__(84);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	var _computedStyle = __webpack_require__(269);
	
	var _computedStyle2 = _interopRequireDefault(_computedStyle);
	
	__webpack_require__(982);
	
	__webpack_require__(984);
	
	__webpack_require__(987);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file seek-bar.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Seek Bar and holder for the progress bars
	 *
	 * @extends Slider
	 */
	var SeekBar = function (_Slider) {
	  _inherits(SeekBar, _Slider);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function SeekBar(player, options) {
	    _classCallCheck(this, SeekBar);
	
	    var _this = _possibleConstructorReturn(this, _Slider.call(this, player, options));
	
	    _this.on(player, 'timeupdate', _this.updateProgress);
	    _this.on(player, 'ended', _this.updateProgress);
	    player.ready(Fn.bind(_this, _this.updateProgress));
	
	    if (options.playerOptions && options.playerOptions.controlBar && options.playerOptions.controlBar.progressControl && options.playerOptions.controlBar.progressControl.keepTooltipsInside) {
	      _this.keepTooltipsInside = options.playerOptions.controlBar.progressControl.keepTooltipsInside;
	    }
	
	    if (_this.keepTooltipsInside) {
	      _this.tooltipProgressBar = _this.addChild('TooltipProgressBar');
	    }
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  SeekBar.prototype.createEl = function createEl() {
	    return _Slider.prototype.createEl.call(this, 'div', {
	      className: 'vjs-progress-holder'
	    }, {
	      'aria-label': 'progress bar'
	    });
	  };
	
	  /**
	   * Update the seek bars tooltip and width.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `ended` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   * @listens Player#ended
	   */
	
	
	  SeekBar.prototype.updateProgress = function updateProgress(event) {
	    this.updateAriaAttributes(this.el_);
	
	    if (this.keepTooltipsInside) {
	      this.updateAriaAttributes(this.tooltipProgressBar.el_);
	      this.tooltipProgressBar.el_.style.width = this.bar.el_.style.width;
	
	      var playerWidth = parseFloat((0, _computedStyle2['default'])(this.player().el(), 'width'));
	      var tooltipWidth = parseFloat((0, _computedStyle2['default'])(this.tooltipProgressBar.tooltip, 'width'));
	      var tooltipStyle = this.tooltipProgressBar.el().style;
	
	      tooltipStyle.maxWidth = Math.floor(playerWidth - tooltipWidth / 2) + 'px';
	      tooltipStyle.minWidth = Math.ceil(tooltipWidth / 2) + 'px';
	      tooltipStyle.right = '-' + tooltipWidth / 2 + 'px';
	    }
	  };
	
	  /**
	   * Update ARIA accessibility attributes
	   *
	   * @param {Element} el
	   *        The element to update with aria accessibility attributes.
	   */
	
	
	  SeekBar.prototype.updateAriaAttributes = function updateAriaAttributes(el) {
	    // Allows for smooth scrubbing, when player can't keep up.
	    var time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	
	    // machine readable value of progress bar (percentage complete)
	    el.setAttribute('aria-valuenow', (this.getPercent() * 100).toFixed(2));
	    // human readable value of progress bar (time complete)
	    el.setAttribute('aria-valuetext', (0, _formatTime2['default'])(time, this.player_.duration()));
	  };
	
	  /**
	   * Get percentage of video played
	   *
	   * @return {number}
	   *         The percentage played
	   */
	
	
	  SeekBar.prototype.getPercent = function getPercent() {
	    var percent = this.player_.currentTime() / this.player_.duration();
	
	    return percent >= 1 ? 1 : percent;
	  };
	
	  /**
	   * Handle mouse down on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousedown` event that caused this to run.
	   *
	   * @listens mousedown
	   */
	
	
	  SeekBar.prototype.handleMouseDown = function handleMouseDown(event) {
	    this.player_.scrubbing(true);
	
	    this.videoWasPlaying = !this.player_.paused();
	    this.player_.pause();
	
	    _Slider.prototype.handleMouseDown.call(this, event);
	  };
	
	  /**
	   * Handle mouse move on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mousemove` event that caused this to run.
	   *
	   * @listens mousemove
	   */
	
	
	  SeekBar.prototype.handleMouseMove = function handleMouseMove(event) {
	    var newTime = this.calculateDistance(event) * this.player_.duration();
	
	    // Don't let video end while scrubbing.
	    if (newTime === this.player_.duration()) {
	      newTime = newTime - 0.1;
	    }
	
	    // Set new time (tell player to seek to new time)
	    this.player_.currentTime(newTime);
	  };
	
	  /**
	   * Handle mouse up on seek bar
	   *
	   * @param {EventTarget~Event} event
	   *        The `mouseup` event that caused this to run.
	   *
	   * @listens mouseup
	   */
	
	
	  SeekBar.prototype.handleMouseUp = function handleMouseUp(event) {
	    _Slider.prototype.handleMouseUp.call(this, event);
	
	    this.player_.scrubbing(false);
	    if (this.videoWasPlaying) {
	      this.player_.play();
	    }
	  };
	
	  /**
	   * Move more quickly fast forward for keyboard-only users
	   */
	
	
	  SeekBar.prototype.stepForward = function stepForward() {
	    // more quickly fast forward for keyboard-only users
	    this.player_.currentTime(this.player_.currentTime() + 5);
	  };
	
	  /**
	   * Move more quickly rewind for keyboard-only users
	   */
	
	
	  SeekBar.prototype.stepBack = function stepBack() {
	    // more quickly rewind for keyboard-only users
	    this.player_.currentTime(this.player_.currentTime() - 5);
	  };
	
	  return SeekBar;
	}(_slider2['default']);
	
	/**
	 * Default options for the `SeekBar`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	SeekBar.prototype.options_ = {
	  children: ['loadProgressBar', 'mouseTimeDisplay', 'playProgressBar'],
	  barName: 'playProgressBar'
	};
	
	/**
	 * Call the update event for this Slider when this event happens on the player.
	 *
	 * @type {string}
	 */
	SeekBar.prototype.playerEvent = 'timeupdate';
	
	_component2['default'].registerComponent('SeekBar', SeekBar);
	exports['default'] = SeekBar;


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _formatTime = __webpack_require__(84);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file play-progress-bar.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Shows play progress
	 *
	 * @extends Component
	 */
	var TooltipProgressBar = function (_Component) {
	  _inherits(TooltipProgressBar, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function TooltipProgressBar(player, options) {
	    _classCallCheck(this, TooltipProgressBar);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.updateDataAttr();
	    _this.on(player, 'timeupdate', _this.updateDataAttr);
	    player.ready(Fn.bind(_this, _this.updateDataAttr));
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  TooltipProgressBar.prototype.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-tooltip-progress-bar vjs-slider-bar',
	      innerHTML: '<div class="vjs-time-tooltip"></div>\n        <span class="vjs-control-text"><span>' + this.localize('Progress') + '</span>: 0%</span>'
	    });
	
	    this.tooltip = el.querySelector('.vjs-time-tooltip');
	
	    return el;
	  };
	
	  /**
	   * Updatet the data-current-time attribute for TooltipProgressBar
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` event that caused this function to run.
	   *
	   * @listens Player#timeupdate
	   */
	
	
	  TooltipProgressBar.prototype.updateDataAttr = function updateDataAttr(event) {
	    var time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	    var formattedTime = (0, _formatTime2['default'])(time, this.player_.duration());
	
	    this.el_.setAttribute('data-current-time', formattedTime);
	    this.tooltip.innerHTML = formattedTime;
	  };
	
	  return TooltipProgressBar;
	}(_component2['default']);
	
	_component2['default'].registerComponent('TooltipProgressBar', TooltipProgressBar);
	exports['default'] = TooltipProgressBar;


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _spacer = __webpack_require__(989);
	
	var _spacer2 = _interopRequireDefault(_spacer);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file custom-control-spacer.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Spacer specifically meant to be used as an insertion point for new plugins, etc.
	 *
	 * @extends Spacer
	 */
	var CustomControlSpacer = function (_Spacer) {
	  _inherits(CustomControlSpacer, _Spacer);
	
	  function CustomControlSpacer() {
	    _classCallCheck(this, CustomControlSpacer);
	
	    return _possibleConstructorReturn(this, _Spacer.apply(this, arguments));
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  CustomControlSpacer.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-custom-control-spacer ' + _Spacer.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  CustomControlSpacer.prototype.createEl = function createEl() {
	    var el = _Spacer.prototype.createEl.call(this, {
	      className: this.buildCSSClass()
	    });
	
	    // No-flex/table-cell mode requires there be some content
	    // in the cell to fill the remaining space of the table.
	    el.innerHTML = '&nbsp;';
	    return el;
	  };
	
	  return CustomControlSpacer;
	}(_spacer2['default']);
	
	_component2['default'].registerComponent('CustomControlSpacer', CustomControlSpacer);
	exports['default'] = CustomControlSpacer;


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file spacer.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Just an empty spacer element that can be used as an append point for plugins, etc.
	 * Also can be used to create space between elements when necessary.
	 *
	 * @extends Component
	 */
	var Spacer = function (_Component) {
	  _inherits(Spacer, _Component);
	
	  function Spacer() {
	    _classCallCheck(this, Spacer);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	  Spacer.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-spacer ' + _Component.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  Spacer.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass()
	    });
	  };
	
	  return Spacer;
	}(_component2['default']);
	
	_component2['default'].registerComponent('Spacer', Spacer);
	
	exports['default'] = Spacer;


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _textTrackMenuItem = __webpack_require__(264);
	
	var _textTrackMenuItem2 = _interopRequireDefault(_textTrackMenuItem);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file caption-settings-menu-item.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The menu item for caption track settings menu
	 *
	 * @extends TextTrackMenuItem
	 */
	var CaptionSettingsMenuItem = function (_TextTrackMenuItem) {
	  _inherits(CaptionSettingsMenuItem, _TextTrackMenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function CaptionSettingsMenuItem(player, options) {
	    _classCallCheck(this, CaptionSettingsMenuItem);
	
	    options.track = {
	      player: player,
	      kind: options.kind,
	      label: options.kind + ' settings',
	      selectable: false,
	      'default': false,
	      mode: 'disabled'
	    };
	
	    // CaptionSettingsMenuItem has no concept of 'selected'
	    options.selectable = false;
	
	    var _this = _possibleConstructorReturn(this, _TextTrackMenuItem.call(this, player, options));
	
	    _this.addClass('vjs-texttrack-settings');
	    _this.controlText(', opens ' + options.kind + ' settings dialog');
	    return _this;
	  }
	
	  /**
	   * This gets called when an `CaptionSettingsMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  CaptionSettingsMenuItem.prototype.handleClick = function handleClick(event) {
	    this.player().getChild('textTrackSettings').show();
	    this.player().getChild('textTrackSettings').el_.focus();
	  };
	
	  return CaptionSettingsMenuItem;
	}(_textTrackMenuItem2['default']);
	
	_component2['default'].registerComponent('CaptionSettingsMenuItem', CaptionSettingsMenuItem);
	exports['default'] = CaptionSettingsMenuItem;


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _textTrackButton = __webpack_require__(181);
	
	var _textTrackButton2 = _interopRequireDefault(_textTrackButton);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _captionSettingsMenuItem = __webpack_require__(990);
	
	var _captionSettingsMenuItem2 = _interopRequireDefault(_captionSettingsMenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file captions-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The button component for toggling and selecting captions
	 *
	 * @extends TextTrackButton
	 */
	var CaptionsButton = function (_TextTrackButton) {
	  _inherits(CaptionsButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function CaptionsButton(player, options, ready) {
	    _classCallCheck(this, CaptionsButton);
	
	    var _this = _possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
	
	    _this.el_.setAttribute('aria-label', 'Captions Menu');
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  CaptionsButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-captions-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Create caption menu items
	   *
	   * @return {CaptionSettingsMenuItem[]}
	   *         The array of current menu items.
	   */
	
	
	  CaptionsButton.prototype.createItems = function createItems() {
	    var items = [];
	
	    if (!(this.player().tech_ && this.player().tech_.featuresNativeTextTracks)) {
	      items.push(new _captionSettingsMenuItem2['default'](this.player_, { kind: this.kind_ }));
	
	      this.hideThreshold_ += 1;
	    }
	
	    return _TextTrackButton.prototype.createItems.call(this, items);
	  };
	
	  return CaptionsButton;
	}(_textTrackButton2['default']);
	
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	CaptionsButton.prototype.kind_ = 'captions';
	
	/**
	 * The text that should display over the `CaptionsButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	CaptionsButton.prototype.controlText_ = 'Captions';
	
	_component2['default'].registerComponent('CaptionsButton', CaptionsButton);
	exports['default'] = CaptionsButton;


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _textTrackButton = __webpack_require__(181);
	
	var _textTrackButton2 = _interopRequireDefault(_textTrackButton);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _chaptersTrackMenuItem = __webpack_require__(993);
	
	var _chaptersTrackMenuItem2 = _interopRequireDefault(_chaptersTrackMenuItem);
	
	var _toTitleCase = __webpack_require__(120);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file chapters-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The button component for toggling and selecting chapters
	 * Chapters act much differently than other text tracks
	 * Cues are navigation vs. other tracks of alternative languages
	 *
	 * @extends TextTrackButton
	 */
	var ChaptersButton = function (_TextTrackButton) {
	  _inherits(ChaptersButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this function is ready.
	   */
	  function ChaptersButton(player, options, ready) {
	    _classCallCheck(this, ChaptersButton);
	
	    var _this = _possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
	
	    _this.el_.setAttribute('aria-label', 'Chapters Menu');
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  ChaptersButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-chapters-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Update the menu based on the current state of its items.
	   *
	   * @param {EventTarget~Event} [event]
	   *        An event that triggered this function to run.
	   *
	   * @listens TextTrackList#addtrack
	   * @listens TextTrackList#removetrack
	   * @listens TextTrackList#change
	   */
	
	
	  ChaptersButton.prototype.update = function update(event) {
	    if (!this.track_ || event && (event.type === 'addtrack' || event.type === 'removetrack')) {
	      this.setTrack(this.findChaptersTrack());
	    }
	    _TextTrackButton.prototype.update.call(this);
	  };
	
	  /**
	   * Set the currently selected track for the chapters button.
	   *
	   * @param {TextTrack} track
	   *        The new track to select. Nothing will change if this is the currently selected
	   *        track.
	   */
	
	
	  ChaptersButton.prototype.setTrack = function setTrack(track) {
	    if (this.track_ === track) {
	      return;
	    }
	
	    if (!this.updateHandler_) {
	      this.updateHandler_ = this.update.bind(this);
	    }
	
	    // here this.track_ refers to the old track instance
	    if (this.track_) {
	      var remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
	
	      if (remoteTextTrackEl) {
	        remoteTextTrackEl.removeEventListener('load', this.updateHandler_);
	      }
	
	      this.track_ = null;
	    }
	
	    this.track_ = track;
	
	    // here this.track_ refers to the new track instance
	    if (this.track_) {
	      this.track_.mode = 'hidden';
	
	      var _remoteTextTrackEl = this.player_.remoteTextTrackEls().getTrackElementByTrack_(this.track_);
	
	      if (_remoteTextTrackEl) {
	        _remoteTextTrackEl.addEventListener('load', this.updateHandler_);
	      }
	    }
	  };
	
	  /**
	   * Find the track object that is currently in use by this ChaptersButton
	   *
	   * @return {TextTrack|undefined}
	   *         The current track or undefined if none was found.
	   */
	
	
	  ChaptersButton.prototype.findChaptersTrack = function findChaptersTrack() {
	    var tracks = this.player_.textTracks() || [];
	
	    for (var i = tracks.length - 1; i >= 0; i--) {
	      // We will always choose the last track as our chaptersTrack
	      var track = tracks[i];
	
	      if (track.kind === this.kind_) {
	        return track;
	      }
	    }
	  };
	
	  /**
	   * Get the caption for the ChaptersButton based on the track label. This will also
	   * use the current tracks localized kind as a fallback if a label does not exist.
	   *
	   * @return {string}
	   *         The tracks current label or the localized track kind.
	   */
	
	
	  ChaptersButton.prototype.getMenuCaption = function getMenuCaption() {
	    if (this.track_ && this.track_.label) {
	      return this.track_.label;
	    }
	    return this.localize((0, _toTitleCase2['default'])(this.kind_));
	  };
	
	  /**
	   * Create menu from chapter track
	   *
	   * @return {Menu}
	   *         New menu for the chapter buttons
	   */
	
	
	  ChaptersButton.prototype.createMenu = function createMenu() {
	    this.options_.title = this.getMenuCaption();
	    return _TextTrackButton.prototype.createMenu.call(this);
	  };
	
	  /**
	   * Create a menu item for each text track
	   *
	   * @return {TextTrackMenuItem[]}
	   *         Array of menu items
	   */
	
	
	  ChaptersButton.prototype.createItems = function createItems() {
	    var items = [];
	
	    if (!this.track_) {
	      return items;
	    }
	
	    var cues = this.track_.cues;
	
	    if (!cues) {
	      return items;
	    }
	
	    for (var i = 0, l = cues.length; i < l; i++) {
	      var cue = cues[i];
	      var mi = new _chaptersTrackMenuItem2['default'](this.player_, { track: this.track_, cue: cue });
	
	      items.push(mi);
	    }
	
	    return items;
	  };
	
	  return ChaptersButton;
	}(_textTrackButton2['default']);
	
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	ChaptersButton.prototype.kind_ = 'chapters';
	
	/**
	 * The text that should display over the `ChaptersButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	ChaptersButton.prototype.controlText_ = 'Chapters';
	
	_component2['default'].registerComponent('ChaptersButton', ChaptersButton);
	exports['default'] = ChaptersButton;


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _menuItem = __webpack_require__(183);
	
	var _menuItem2 = _interopRequireDefault(_menuItem);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file chapters-track-menu-item.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The chapter track menu item
	 *
	 * @extends MenuItem
	 */
	var ChaptersTrackMenuItem = function (_MenuItem) {
	  _inherits(ChaptersTrackMenuItem, _MenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function ChaptersTrackMenuItem(player, options) {
	    _classCallCheck(this, ChaptersTrackMenuItem);
	
	    var track = options.track;
	    var cue = options.cue;
	    var currentTime = player.currentTime();
	
	    // Modify options for parent MenuItem class's init.
	    options.selectable = true;
	    options.label = cue.text;
	    options.selected = cue.startTime <= currentTime && currentTime < cue.endTime;
	
	    var _this = _possibleConstructorReturn(this, _MenuItem.call(this, player, options));
	
	    _this.track = track;
	    _this.cue = cue;
	    track.addEventListener('cuechange', Fn.bind(_this, _this.update));
	    return _this;
	  }
	
	  /**
	   * This gets called when an `ChaptersTrackMenuItem` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  ChaptersTrackMenuItem.prototype.handleClick = function handleClick(event) {
	    _MenuItem.prototype.handleClick.call(this);
	    this.player_.currentTime(this.cue.startTime);
	    this.update(this.cue.startTime);
	  };
	
	  /**
	   * Update chapter menu item
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `cuechange` event that caused this function to run.
	   *
	   * @listens TextTrack#cuechange
	   */
	
	
	  ChaptersTrackMenuItem.prototype.update = function update(event) {
	    var cue = this.cue;
	    var currentTime = this.player_.currentTime();
	
	    // vjs.log(currentTime, cue.startTime);
	    this.selected(cue.startTime <= currentTime && currentTime < cue.endTime);
	  };
	
	  return ChaptersTrackMenuItem;
	}(_menuItem2['default']);
	
	_component2['default'].registerComponent('ChaptersTrackMenuItem', ChaptersTrackMenuItem);
	exports['default'] = ChaptersTrackMenuItem;


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _textTrackButton = __webpack_require__(181);
	
	var _textTrackButton2 = _interopRequireDefault(_textTrackButton);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file descriptions-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The button component for toggling and selecting descriptions
	 *
	 * @extends TextTrackButton
	 */
	var DescriptionsButton = function (_TextTrackButton) {
	  _inherits(DescriptionsButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function DescriptionsButton(player, options, ready) {
	    _classCallCheck(this, DescriptionsButton);
	
	    var _this = _possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
	
	    _this.el_.setAttribute('aria-label', 'Descriptions Menu');
	
	    var tracks = player.textTracks();
	
	    if (tracks) {
	      var changeHandler = Fn.bind(_this, _this.handleTracksChange);
	
	      tracks.addEventListener('change', changeHandler);
	      _this.on('dispose', function () {
	        tracks.removeEventListener('change', changeHandler);
	      });
	    }
	    return _this;
	  }
	
	  /**
	   * Handle text track change
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run
	   *
	   * @listens TextTrackList#change
	   */
	
	
	  DescriptionsButton.prototype.handleTracksChange = function handleTracksChange(event) {
	    var tracks = this.player().textTracks();
	    var disabled = false;
	
	    // Check whether a track of a different kind is showing
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (track.kind !== this.kind_ && track.mode === 'showing') {
	        disabled = true;
	        break;
	      }
	    }
	
	    // If another track is showing, disable this menu button
	    if (disabled) {
	      this.disable();
	    } else {
	      this.enable();
	    }
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  DescriptionsButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-descriptions-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  return DescriptionsButton;
	}(_textTrackButton2['default']);
	
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	DescriptionsButton.prototype.kind_ = 'descriptions';
	
	/**
	 * The text that should display over the `DescriptionsButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	DescriptionsButton.prototype.controlText_ = 'Descriptions';
	
	_component2['default'].registerComponent('DescriptionsButton', DescriptionsButton);
	exports['default'] = DescriptionsButton;


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _textTrackMenuItem = __webpack_require__(264);
	
	var _textTrackMenuItem2 = _interopRequireDefault(_textTrackMenuItem);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file off-text-track-menu-item.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * A special menu item for turning of a specific type of text track
	 *
	 * @extends TextTrackMenuItem
	 */
	var OffTextTrackMenuItem = function (_TextTrackMenuItem) {
	  _inherits(OffTextTrackMenuItem, _TextTrackMenuItem);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function OffTextTrackMenuItem(player, options) {
	    _classCallCheck(this, OffTextTrackMenuItem);
	
	    // Create pseudo track info
	    // Requires options['kind']
	    options.track = {
	      player: player,
	      kind: options.kind,
	      label: options.kind + ' off',
	      'default': false,
	      mode: 'disabled'
	    };
	
	    // MenuItem is selectable
	    options.selectable = true;
	
	    var _this = _possibleConstructorReturn(this, _TextTrackMenuItem.call(this, player, options));
	
	    _this.selected(true);
	    return _this;
	  }
	
	  /**
	   * Handle text track change
	   *
	   * @param {EventTarget~Event} event
	   *        The event that caused this function to run
	   */
	
	
	  OffTextTrackMenuItem.prototype.handleTracksChange = function handleTracksChange(event) {
	    var tracks = this.player().textTracks();
	    var selected = true;
	
	    for (var i = 0, l = tracks.length; i < l; i++) {
	      var track = tracks[i];
	
	      if (track.kind === this.track.kind && track.mode === 'showing') {
	        selected = false;
	        break;
	      }
	    }
	
	    this.selected(selected);
	  };
	
	  return OffTextTrackMenuItem;
	}(_textTrackMenuItem2['default']);
	
	_component2['default'].registerComponent('OffTextTrackMenuItem', OffTextTrackMenuItem);
	exports['default'] = OffTextTrackMenuItem;


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _textTrackButton = __webpack_require__(181);
	
	var _textTrackButton2 = _interopRequireDefault(_textTrackButton);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file subtitles-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The button component for toggling and selecting subtitles
	 *
	 * @extends TextTrackButton
	 */
	var SubtitlesButton = function (_TextTrackButton) {
	  _inherits(SubtitlesButton, _TextTrackButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when this component is ready.
	   */
	  function SubtitlesButton(player, options, ready) {
	    _classCallCheck(this, SubtitlesButton);
	
	    var _this = _possibleConstructorReturn(this, _TextTrackButton.call(this, player, options, ready));
	
	    _this.el_.setAttribute('aria-label', 'Subtitles Menu');
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  SubtitlesButton.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-subtitles-button ' + _TextTrackButton.prototype.buildCSSClass.call(this);
	  };
	
	  return SubtitlesButton;
	}(_textTrackButton2['default']);
	
	/**
	 * `kind` of TextTrack to look for to associate it with this menu.
	 *
	 * @type {string}
	 * @private
	 */
	
	
	SubtitlesButton.prototype.kind_ = 'subtitles';
	
	/**
	 * The text that should display over the `SubtitlesButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	SubtitlesButton.prototype.controlText_ = 'Subtitles';
	
	_component2['default'].registerComponent('SubtitlesButton', SubtitlesButton);
	exports['default'] = SubtitlesButton;


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _formatTime = __webpack_require__(84);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file current-time-display.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Displays the current time
	 *
	 * @extends Component
	 */
	var CurrentTimeDisplay = function (_Component) {
	  _inherits(CurrentTimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function CurrentTimeDisplay(player, options) {
	    _classCallCheck(this, CurrentTimeDisplay);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.on(player, 'timeupdate', _this.updateContent);
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  CurrentTimeDisplay.prototype.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-current-time vjs-time-control vjs-control'
	    });
	
	    this.contentEl_ = Dom.createEl('div', {
	      className: 'vjs-current-time-display',
	      // label the current time for screen reader users
	      innerHTML: '<span class="vjs-control-text">Current Time </span>' + '0:00'
	    }, {
	      // tell screen readers not to automatically read the time as it changes
	      'aria-live': 'off'
	    });
	
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  /**
	   * Update current time display
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` event that caused this function to run.
	   *
	   * @listens Player#timeupdate
	   */
	
	
	  CurrentTimeDisplay.prototype.updateContent = function updateContent(event) {
	    // Allows for smooth scrubbing, when player can't keep up.
	    var time = this.player_.scrubbing() ? this.player_.getCache().currentTime : this.player_.currentTime();
	    var localizedText = this.localize('Current Time');
	    var formattedTime = (0, _formatTime2['default'])(time, this.player_.duration());
	
	    if (formattedTime !== this.formattedTime_) {
	      this.formattedTime_ = formattedTime;
	      this.contentEl_.innerHTML = '<span class="vjs-control-text">' + localizedText + '</span> ' + formattedTime;
	    }
	  };
	
	  return CurrentTimeDisplay;
	}(_component2['default']);
	
	_component2['default'].registerComponent('CurrentTimeDisplay', CurrentTimeDisplay);
	exports['default'] = CurrentTimeDisplay;


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _formatTime = __webpack_require__(84);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file duration-display.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Displays the duration
	 *
	 * @extends Component
	 */
	var DurationDisplay = function (_Component) {
	  _inherits(DurationDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function DurationDisplay(player, options) {
	    _classCallCheck(this, DurationDisplay);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.on(player, 'durationchange', _this.updateContent);
	
	    // Also listen for timeupdate and loadedmetadata because removing those
	    // listeners could have broken dependent applications/libraries. These
	    // can likely be removed for 6.0.
	    _this.on(player, 'timeupdate', _this.updateContent);
	    _this.on(player, 'loadedmetadata', _this.updateContent);
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  DurationDisplay.prototype.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-duration vjs-time-control vjs-control'
	    });
	
	    this.contentEl_ = Dom.createEl('div', {
	      className: 'vjs-duration-display',
	      // label the duration time for screen reader users
	      innerHTML: '<span class="vjs-control-text">' + this.localize('Duration Time') + '</span> 0:00'
	    }, {
	      // tell screen readers not to automatically read the time as it changes
	      'aria-live': 'off'
	    });
	
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  /**
	   * Update duration time display.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `durationchange`, `timeupdate`, or `loadedmetadata` event that caused
	   *        this function to be called.
	   *
	   * @listens Player#durationchange
	   * @listens Player#timeupdate
	   * @listens Player#loadedmetadata
	   */
	
	
	  DurationDisplay.prototype.updateContent = function updateContent(event) {
	    var duration = this.player_.duration();
	
	    if (duration && this.duration_ !== duration) {
	      this.duration_ = duration;
	      var localizedText = this.localize('Duration Time');
	      var formattedTime = (0, _formatTime2['default'])(duration);
	
	      // label the duration time for screen reader users
	      this.contentEl_.innerHTML = '<span class="vjs-control-text">' + localizedText + '</span> ' + formattedTime;
	    }
	  };
	
	  return DurationDisplay;
	}(_component2['default']);
	
	_component2['default'].registerComponent('DurationDisplay', DurationDisplay);
	exports['default'] = DurationDisplay;


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _formatTime = __webpack_require__(84);
	
	var _formatTime2 = _interopRequireDefault(_formatTime);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file remaining-time-display.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Displays the time left in the video
	 *
	 * @extends Component
	 */
	var RemainingTimeDisplay = function (_Component) {
	  _inherits(RemainingTimeDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function RemainingTimeDisplay(player, options) {
	    _classCallCheck(this, RemainingTimeDisplay);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.on(player, 'timeupdate', _this.updateContent);
	    _this.on(player, 'durationchange', _this.updateContent);
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  RemainingTimeDisplay.prototype.createEl = function createEl() {
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-remaining-time vjs-time-control vjs-control'
	    });
	
	    this.contentEl_ = Dom.createEl('div', {
	      className: 'vjs-remaining-time-display',
	      // label the remaining time for screen reader users
	      innerHTML: '<span class="vjs-control-text">' + this.localize('Remaining Time') + '</span> -0:00'
	    }, {
	      // tell screen readers not to automatically read the time as it changes
	      'aria-live': 'off'
	    });
	
	    el.appendChild(this.contentEl_);
	    return el;
	  };
	
	  /**
	   * Update remaining time display.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `timeupdate` or `durationchange` event that caused this to run.
	   *
	   * @listens Player#timeupdate
	   * @listens Player#durationchange
	   */
	
	
	  RemainingTimeDisplay.prototype.updateContent = function updateContent(event) {
	    if (this.player_.duration()) {
	      var localizedText = this.localize('Remaining Time');
	      var formattedTime = (0, _formatTime2['default'])(this.player_.remainingTime());
	
	      if (formattedTime !== this.formattedTime_) {
	        this.formattedTime_ = formattedTime;
	        this.contentEl_.innerHTML = '<span class="vjs-control-text">' + localizedText + '</span> -' + formattedTime;
	      }
	    }
	
	    // Allows for smooth scrubbing, when player can't keep up.
	    // var time = (this.player_.scrubbing()) ? this.player_.getCache().currentTime : this.player_.currentTime();
	    // this.contentEl_.innerHTML = vjs.formatTime(time, this.player_.duration());
	  };
	
	  return RemainingTimeDisplay;
	}(_component2['default']);
	
	_component2['default'].registerComponent('RemainingTimeDisplay', RemainingTimeDisplay);
	exports['default'] = RemainingTimeDisplay;


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file time-divider.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The separator between the current time and duration.
	 * Can be hidden if it's not needed in the design.
	 *
	 * @extends Component
	 */
	var TimeDivider = function (_Component) {
	  _inherits(TimeDivider, _Component);
	
	  function TimeDivider() {
	    _classCallCheck(this, TimeDivider);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the component's DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  TimeDivider.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-time-control vjs-time-divider',
	      innerHTML: '<div><span>/</span></div>'
	    });
	  };
	
	  return TimeDivider;
	}(_component2['default']);
	
	_component2['default'].registerComponent('TimeDivider', TimeDivider);
	exports['default'] = TimeDivider;


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	__webpack_require__(421);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file volume-control.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	// Required children
	
	
	/**
	 * The component for controlling the volume level
	 *
	 * @extends Component
	 */
	var VolumeControl = function (_Component) {
	  _inherits(VolumeControl, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function VolumeControl(player, options) {
	    _classCallCheck(this, VolumeControl);
	
	    // hide volume controls when they're not supported by the current tech
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    if (player.tech_ && player.tech_.featuresVolumeControl === false) {
	      _this.addClass('vjs-hidden');
	    }
	    _this.on(player, 'loadstart', function () {
	      if (player.tech_.featuresVolumeControl === false) {
	        this.addClass('vjs-hidden');
	      } else {
	        this.removeClass('vjs-hidden');
	      }
	    });
	    return _this;
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  VolumeControl.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-control vjs-control'
	    });
	  };
	
	  return VolumeControl;
	}(_component2['default']);
	
	/**
	 * Default options for the `VolumeControl`
	 *
	 * @type {Object}
	 * @private
	 */
	
	
	VolumeControl.prototype.options_ = {
	  children: ['volumeBar']
	};
	
	_component2['default'].registerComponent('VolumeControl', VolumeControl);
	exports['default'] = VolumeControl;


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file volume-level.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Shows volume level
	 *
	 * @extends Component
	 */
	var VolumeLevel = function (_Component) {
	  _inherits(VolumeLevel, _Component);
	
	  function VolumeLevel() {
	    _classCallCheck(this, VolumeLevel);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the `Component`'s DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	  VolumeLevel.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-volume-level',
	      innerHTML: '<span class="vjs-control-text"></span>'
	    });
	  };
	
	  return VolumeLevel;
	}(_component2['default']);
	
	_component2['default'].registerComponent('VolumeLevel', VolumeLevel);
	exports['default'] = VolumeLevel;


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _popup = __webpack_require__(1010);
	
	var _popup2 = _interopRequireDefault(_popup);
	
	var _popupButton = __webpack_require__(1009);
	
	var _popupButton2 = _interopRequireDefault(_popupButton);
	
	var _muteToggle = __webpack_require__(419);
	
	var _muteToggle2 = _interopRequireDefault(_muteToggle);
	
	var _volumeBar = __webpack_require__(421);
	
	var _volumeBar2 = _interopRequireDefault(_volumeBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file volume-menu-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * Button for volume popup
	 *
	 * @extends PopupButton
	 */
	var VolumeMenuButton = function (_PopupButton) {
	  _inherits(VolumeMenuButton, _PopupButton);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options={}]
	   *        The key/value store of player options.
	   */
	  function VolumeMenuButton(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, VolumeMenuButton);
	
	    // Default to inline
	    if (options.inline === undefined) {
	      options.inline = true;
	    }
	
	    // If the vertical option isn't passed at all, default to true.
	    if (options.vertical === undefined) {
	      // If an inline volumeMenuButton is used, we should default to using
	      // a horizontal slider for obvious reasons.
	      if (options.inline) {
	        options.vertical = false;
	      } else {
	        options.vertical = true;
	      }
	    }
	
	    // The vertical option needs to be set on the volumeBar as well,
	    // since that will need to be passed along to the VolumeBar constructor
	    options.volumeBar = options.volumeBar || {};
	    options.volumeBar.vertical = !!options.vertical;
	
	    // Same listeners as MuteToggle
	    var _this = _possibleConstructorReturn(this, _PopupButton.call(this, player, options));
	
	    _this.on(player, 'volumechange', _this.volumeUpdate);
	    _this.on(player, 'loadstart', _this.volumeUpdate);
	
	    // hide mute toggle if the current tech doesn't support volume control
	    function updateVisibility() {
	      if (player.tech_ && player.tech_.featuresVolumeControl === false) {
	        this.addClass('vjs-hidden');
	      } else {
	        this.removeClass('vjs-hidden');
	      }
	    }
	
	    updateVisibility.call(_this);
	    _this.on(player, 'loadstart', updateVisibility);
	
	    _this.on(_this.volumeBar, ['slideractive', 'focus'], function () {
	      this.addClass('vjs-slider-active');
	    });
	
	    _this.on(_this.volumeBar, ['sliderinactive', 'blur'], function () {
	      this.removeClass('vjs-slider-active');
	    });
	
	    _this.on(_this.volumeBar, ['focus'], function () {
	      this.addClass('vjs-lock-showing');
	    });
	
	    _this.on(_this.volumeBar, ['blur'], function () {
	      this.removeClass('vjs-lock-showing');
	    });
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  VolumeMenuButton.prototype.buildCSSClass = function buildCSSClass() {
	    var orientationClass = '';
	
	    if (this.options_.vertical) {
	      orientationClass = 'vjs-volume-menu-button-vertical';
	    } else {
	      orientationClass = 'vjs-volume-menu-button-horizontal';
	    }
	
	    return 'vjs-volume-menu-button ' + _PopupButton.prototype.buildCSSClass.call(this) + ' ' + orientationClass;
	  };
	
	  /**
	   * Create the VolumeMenuButton popup
	   *
	   * @return {Popup}
	   *         The popup that was created
	   */
	
	
	  VolumeMenuButton.prototype.createPopup = function createPopup() {
	    var popup = new _popup2['default'](this.player_, {
	      contentElType: 'div'
	    });
	
	    var vb = new _volumeBar2['default'](this.player_, this.options_.volumeBar);
	
	    popup.addChild(vb);
	
	    this.menuContent = popup;
	    this.volumeBar = vb;
	
	    this.attachVolumeBarEvents();
	
	    return popup;
	  };
	
	  /**
	   * This gets called when an `VolumeMenuButton` is "clicked". See
	   * {@link ClickableComponent} for more detailed information on what a click can be.
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `keydown`, `tap`, or `click` event that caused this function to be
	   *        called.
	   *
	   * @listens tap
	   * @listens click
	   */
	
	
	  VolumeMenuButton.prototype.handleClick = function handleClick(event) {
	    _muteToggle2['default'].prototype.handleClick.call(this);
	    _PopupButton.prototype.handleClick.call(this);
	  };
	
	  /**
	   * Add events listeners to the created `VolumeBar`.
	   */
	
	
	  VolumeMenuButton.prototype.attachVolumeBarEvents = function attachVolumeBarEvents() {
	    this.menuContent.on(['mousedown', 'touchdown'], Fn.bind(this, this.handleMouseDown));
	  };
	
	  /**
	   * Handle the `mousedown` and `touchdown` events on the `VolumeBar`
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `mousedown` or `touchdown` event that caused this to run.
	   *
	   * @listens mousedown
	   * @listens touchdown
	   */
	
	
	  VolumeMenuButton.prototype.handleMouseDown = function handleMouseDown(event) {
	    this.on(['mousemove', 'touchmove'], Fn.bind(this.volumeBar, this.volumeBar.handleMouseMove));
	    this.on(this.el_.ownerDocument, ['mouseup', 'touchend'], this.handleMouseUp);
	  };
	
	  /**
	   * Handle the `mouseup` and `touchend` events on the `VolumeBar`
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `mouseup` or `touchend` event that caused this to run.
	   *
	   * @listens mouseup
	   * @listens touchend
	   */
	
	
	  VolumeMenuButton.prototype.handleMouseUp = function handleMouseUp(event) {
	    this.off(['mousemove', 'touchmove'], Fn.bind(this.volumeBar, this.volumeBar.handleMouseMove));
	  };
	
	  return VolumeMenuButton;
	}(_popupButton2['default']);
	
	/**
	 * @borrows MuteToggle#update as VolumeMenuButton#volumeUpdate
	 */
	
	
	VolumeMenuButton.prototype.volumeUpdate = _muteToggle2['default'].prototype.update;
	
	/**
	 * The text that should display over the `VolumeMenuButton`s controls. Added for localization.
	 *
	 * @type {string}
	 * @private
	 */
	VolumeMenuButton.prototype.controlText_ = 'Mute';
	
	_component2['default'].registerComponent('VolumeMenuButton', VolumeMenuButton);
	exports['default'] = VolumeMenuButton;


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _modalDialog = __webpack_require__(425);
	
	var _modalDialog2 = _interopRequireDefault(_modalDialog);
	
	var _mergeOptions = __webpack_require__(76);
	
	var _mergeOptions2 = _interopRequireDefault(_mergeOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file error-display.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * A display that indicates an error has occurred. This means that the video
	 * is unplayable.
	 *
	 * @extends ModalDialog
	 */
	var ErrorDisplay = function (_ModalDialog) {
	  _inherits(ErrorDisplay, _ModalDialog);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param  {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param  {Object} [options]
	   *         The key/value store of player options.
	   */
	  function ErrorDisplay(player, options) {
	    _classCallCheck(this, ErrorDisplay);
	
	    var _this = _possibleConstructorReturn(this, _ModalDialog.call(this, player, options));
	
	    _this.on(player, 'error', _this.open);
	    return _this;
	  }
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   *
	   * @deprecated Since version 5.
	   */
	
	
	  ErrorDisplay.prototype.buildCSSClass = function buildCSSClass() {
	    return 'vjs-error-display ' + _ModalDialog.prototype.buildCSSClass.call(this);
	  };
	
	  /**
	   * Gets the localized error message based on the `Player`s error.
	   *
	   * @return {string}
	   *         The `Player`s error message localized or an empty string.
	   */
	
	
	  ErrorDisplay.prototype.content = function content() {
	    var error = this.player().error();
	
	    return error ? this.localize(error.message) : '';
	  };
	
	  return ErrorDisplay;
	}(_modalDialog2['default']);
	
	/**
	 * The default options for an `ErrorDisplay`.
	 *
	 * @private
	 */
	
	
	ErrorDisplay.prototype.options_ = (0, _mergeOptions2['default'])(_modalDialog2['default'].prototype.options_, {
	  pauseOnOpen: false,
	  fillAlways: true,
	  temporary: false,
	  uncloseable: true
	});
	
	_component2['default'].registerComponent('ErrorDisplay', ErrorDisplay);
	exports['default'] = ErrorDisplay;


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _obj = __webpack_require__(31);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * @file extend.js
	 * @module extend
	 */
	
	/**
	 * A combination of node inherits and babel's inherits (after transpile).
	 * Both work the same but node adds `super_` to the subClass
	 * and Bable adds the superClass as __proto__. Both seem useful.
	 *
	 * @param {Object} subClass
	 *        The class to inherit to
	 *
	 * @param {Object} superClass
	 *        The class to inherit from
	 *
	 * @private
	 */
	var _inherits = function _inherits(subClass, superClass) {
	  if (typeof superClass !== 'function' && superClass !== null) {
	    throw new TypeError('Super expression must either be null or a function, not ' + (typeof superClass === 'undefined' ? 'undefined' : _typeof(superClass)));
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	
	  if (superClass) {
	    // node
	    subClass.super_ = superClass;
	  }
	};
	
	/**
	 * Function for subclassing using the same inheritance that
	 * videojs uses internally
	 *
	 * @param {Object} superClass
	 *        The class to inherit from
	 *
	 * @param {Object} [subClassMethods={}]
	 *        The class to inherit to
	 *
	 * @return {Object}
	 *         The new object with subClassMethods that inherited superClass.
	 */
	var extendFn = function extendFn(superClass) {
	  var subClassMethods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var subClass = function subClass() {
	    superClass.apply(this, arguments);
	  };
	
	  var methods = {};
	
	  if ((0, _obj.isObject)(subClassMethods)) {
	    if (typeof subClassMethods.init === 'function') {
	      _log2['default'].warn('Constructor logic via init() is deprecated; please use constructor() instead.');
	      subClassMethods.constructor = subClassMethods.init;
	    }
	    if (subClassMethods.constructor !== Object.prototype.constructor) {
	      subClass = subClassMethods.constructor;
	    }
	    methods = subClassMethods;
	  } else if (typeof subClassMethods === 'function') {
	    subClass = subClassMethods;
	  }
	
	  _inherits(subClass, superClass);
	
	  // Extend subObj's prototype with functions and other properties from props
	  for (var name in methods) {
	    if (methods.hasOwnProperty(name)) {
	      subClass.prototype[name] = methods[name];
	    }
	  }
	
	  return subClass;
	};
	
	exports['default'] = extendFn;


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Store the browser-specific methods for the fullscreen API.
	 *
	 * @type {Object}
	 * @see [Specification]{@link https://fullscreen.spec.whatwg.org}
	 * @see [Map Approach From Screenfull.js]{@link https://github.com/sindresorhus/screenfull.js}
	 */
	var FullscreenApi = {};
	
	// browser API methods
	/**
	 * @file fullscreen-api.js
	 * @module fullscreen-api
	 * @private
	 */
	var apiMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
	// WebKit
	['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
	// Old WebKit (Safari 5.1)
	['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'],
	// Mozilla
	['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'],
	// Microsoft
	['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
	
	var specApi = apiMap[0];
	var browserApi = void 0;
	
	// determine the supported set of functions
	for (var i = 0; i < apiMap.length; i++) {
	  // check for exitFullscreen function
	  if (apiMap[i][1] in _document2['default']) {
	    browserApi = apiMap[i];
	    break;
	  }
	}
	
	// map the browser API names to the spec API names
	if (browserApi) {
	  for (var _i = 0; _i < browserApi.length; _i++) {
	    FullscreenApi[specApi[_i]] = browserApi[_i];
	  }
	}
	
	exports['default'] = FullscreenApi;


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file loading-spinner.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * A loading spinner for use during waiting/loading events.
	 *
	 * @extends Component
	 */
	var LoadingSpinner = function (_Component) {
	  _inherits(LoadingSpinner, _Component);
	
	  function LoadingSpinner() {
	    _classCallCheck(this, LoadingSpinner);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Create the `LoadingSpinner`s DOM element.
	   *
	   * @return {Element}
	   *         The dom element that gets created.
	   */
	  LoadingSpinner.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-loading-spinner',
	      dir: 'ltr'
	    });
	  };
	
	  return LoadingSpinner;
	}(_component2['default']);
	
	_component2['default'].registerComponent('LoadingSpinner', LoadingSpinner);
	exports['default'] = LoadingSpinner;


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _player = __webpack_require__(426);
	
	var _player2 = _interopRequireDefault(_player);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * The method for registering a video.js plugin. {@link videojs:videojs.registerPlugin].
	 *
	 * @param {string} name
	 *        The name of the plugin that is being registered
	 *
	 * @param {plugins:PluginFn} init
	 *        The function that gets run when a `Player` initializes.
	 */
	var plugin = function plugin(name, init) {
	  _player2['default'].prototype[name] = init;
	}; /**
	    * @file plugins.js
	    * @module plugins
	    */
	exports['default'] = plugin;


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _clickableComponent = __webpack_require__(141);
	
	var _clickableComponent2 = _interopRequireDefault(_clickableComponent);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file popup-button.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * A button class for use with {@link Popup} controls
	 *
	 * @extends ClickableComponent
	 */
	var PopupButton = function (_ClickableComponent) {
	  _inherits(PopupButton, _ClickableComponent);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PopupButton(player) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    _classCallCheck(this, PopupButton);
	
	    var _this = _possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));
	
	    _this.update();
	    return _this;
	  }
	
	  /**
	   * Update the `Popup` that this button is attached to.
	   */
	
	
	  PopupButton.prototype.update = function update() {
	    var popup = this.createPopup();
	
	    if (this.popup) {
	      this.removeChild(this.popup);
	    }
	
	    this.popup = popup;
	    this.addChild(popup);
	
	    if (this.items && this.items.length === 0) {
	      this.hide();
	    } else if (this.items && this.items.length > 1) {
	      this.show();
	    }
	  };
	
	  /**
	   * Create a `Popup`. - Override with specific functionality for component
	   *
	   * @abstract
	   */
	
	
	  PopupButton.prototype.createPopup = function createPopup() {};
	
	  /**
	   * Create the `PopupButton`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  PopupButton.prototype.createEl = function createEl() {
	    return _ClickableComponent.prototype.createEl.call(this, 'div', {
	      className: this.buildCSSClass()
	    });
	  };
	
	  /**
	   * Builds the default DOM `className`.
	   *
	   * @return {string}
	   *         The DOM `className` for this object.
	   */
	
	
	  PopupButton.prototype.buildCSSClass = function buildCSSClass() {
	    var menuButtonClass = 'vjs-menu-button';
	
	    // If the inline option is passed, we want to use different styles altogether.
	    if (this.options_.inline === true) {
	      menuButtonClass += '-inline';
	    } else {
	      menuButtonClass += '-popup';
	    }
	
	    return 'vjs-menu-button ' + menuButtonClass + ' ' + _ClickableComponent.prototype.buildCSSClass.call(this);
	  };
	
	  return PopupButton;
	}(_clickableComponent2['default']);
	
	_component2['default'].registerComponent('PopupButton', PopupButton);
	exports['default'] = PopupButton;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _events = __webpack_require__(83);
	
	var Events = _interopRequireWildcard(_events);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file popup.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The Popup component is used to build pop up controls.
	 *
	 * @extends Component
	 */
	var Popup = function (_Component) {
	  _inherits(Popup, _Component);
	
	  function Popup() {
	    _classCallCheck(this, Popup);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  /**
	   * Add a popup item to the popup
	   *
	   * @param {Object|string} component
	   *        Component or component type to add
	   *
	   */
	  Popup.prototype.addItem = function addItem(component) {
	    this.addChild(component);
	    component.on('click', Fn.bind(this, function () {
	      this.unlockShowing();
	    }));
	  };
	
	  /**
	   * Create the `PopupButton`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  Popup.prototype.createEl = function createEl() {
	    var contentElType = this.options_.contentElType || 'ul';
	
	    this.contentEl_ = Dom.createEl(contentElType, {
	      className: 'vjs-menu-content'
	    });
	
	    var el = _Component.prototype.createEl.call(this, 'div', {
	      append: this.contentEl_,
	      className: 'vjs-menu'
	    });
	
	    el.appendChild(this.contentEl_);
	
	    // Prevent clicks from bubbling up. Needed for Popup Buttons,
	    // where a click on the parent is significant
	    Events.on(el, 'click', function (event) {
	      event.preventDefault();
	      event.stopImmediatePropagation();
	    });
	
	    return el;
	  };
	
	  return Popup;
	}(_component2['default']);
	
	_component2['default'].registerComponent('Popup', Popup);
	exports['default'] = Popup;


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _clickableComponent = __webpack_require__(141);
	
	var _clickableComponent2 = _interopRequireDefault(_clickableComponent);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file poster-image.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * A `ClickableComponent` that handles showing the poster image for the player.
	 *
	 * @extends ClickableComponent
	 */
	var PosterImage = function (_ClickableComponent) {
	  _inherits(PosterImage, _ClickableComponent);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should attach to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   */
	  function PosterImage(player, options) {
	    _classCallCheck(this, PosterImage);
	
	    var _this = _possibleConstructorReturn(this, _ClickableComponent.call(this, player, options));
	
	    _this.update();
	    player.on('posterchange', Fn.bind(_this, _this.update));
	    return _this;
	  }
	
	  /**
	   * Clean up and dispose of the `PosterImage`.
	   */
	
	
	  PosterImage.prototype.dispose = function dispose() {
	    this.player().off('posterchange', this.update);
	    _ClickableComponent.prototype.dispose.call(this);
	  };
	
	  /**
	   * Create the `PosterImage`s DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  PosterImage.prototype.createEl = function createEl() {
	    var el = Dom.createEl('div', {
	      className: 'vjs-poster',
	
	      // Don't want poster to be tabbable.
	      tabIndex: -1
	    });
	
	    // To ensure the poster image resizes while maintaining its original aspect
	    // ratio, use a div with `background-size` when available. For browsers that
	    // do not support `background-size` (e.g. IE8), fall back on using a regular
	    // img element.
	    if (!browser.BACKGROUND_SIZE_SUPPORTED) {
	      this.fallbackImg_ = Dom.createEl('img');
	      el.appendChild(this.fallbackImg_);
	    }
	
	    return el;
	  };
	
	  /**
	   * An {@link EventTarget~EventListener} for {@link Player#posterchange} events.
	   *
	   * @listens Player#posterchange
	   *
	   * @param {EventTarget~Event} [event]
	   *        The `Player#posterchange` event that triggered this function.
	   */
	
	
	  PosterImage.prototype.update = function update(event) {
	    var url = this.player().poster();
	
	    this.setSrc(url);
	
	    // If there's no poster source we should display:none on this component
	    // so it's not still clickable or right-clickable
	    if (url) {
	      this.show();
	    } else {
	      this.hide();
	    }
	  };
	
	  /**
	   * Set the source of the `PosterImage` depending on the display method.
	   *
	   * @param {string} url
	   *        The URL to the source for the `PosterImage`.
	   */
	
	
	  PosterImage.prototype.setSrc = function setSrc(url) {
	    if (this.fallbackImg_) {
	      this.fallbackImg_.src = url;
	    } else {
	      var backgroundImage = '';
	
	      // Any falsey values should stay as an empty string, otherwise
	      // this will throw an extra error
	      if (url) {
	        backgroundImage = 'url("' + url + '")';
	      }
	
	      this.el_.style.backgroundImage = backgroundImage;
	    }
	  };
	
	  /**
	   * An {@link EventTarget~EventListener} for clicks on the `PosterImage`. See
	   * {@link ClickableComponent#handleClick} for instances where this will be triggered.
	   *
	   * @listens tap
	   * @listens click
	   * @listens keydown
	   *
	   * @param {EventTarget~Event} event
	   +        The `click`, `tap` or `keydown` event that caused this function to be called.
	   */
	
	
	  PosterImage.prototype.handleClick = function handleClick(event) {
	    // We don't want a click to trigger playback when controls are disabled
	    if (!this.player_.controls()) {
	      return;
	    }
	
	    if (this.player_.paused()) {
	      this.player_.play();
	    } else {
	      this.player_.pause();
	    }
	  };
	
	  return PosterImage;
	}(_clickableComponent2['default']);
	
	_component2['default'].registerComponent('PosterImage', PosterImage);
	exports['default'] = PosterImage;


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.hasLoaded = exports.autoSetupTimeout = exports.autoSetup = undefined;
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _events = __webpack_require__(83);
	
	var Events = _interopRequireWildcard(_events);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 * @file setup.js - Functions for setting up a player without
	 * user interaction based on the data-setup `attribute` of the video tag.
	 *
	 * @module setup
	 */
	var _windowLoaded = false;
	var videojs = void 0;
	
	/**
	 * Set up any tags that have a data-setup `attribute` when the player is started.
	 */
	var autoSetup = function autoSetup() {
	
	  // Protect against breakage in non-browser environments.
	  if (!Dom.isReal()) {
	    return;
	  }
	
	  // One day, when we stop supporting IE8, go back to this, but in the meantime...*hack hack hack*
	  // var vids = Array.prototype.slice.call(document.getElementsByTagName('video'));
	  // var audios = Array.prototype.slice.call(document.getElementsByTagName('audio'));
	  // var mediaEls = vids.concat(audios);
	
	  // Because IE8 doesn't support calling slice on a node list, we need to loop
	  // through each list of elements to build up a new, combined list of elements.
	  var vids = _document2['default'].getElementsByTagName('video');
	  var audios = _document2['default'].getElementsByTagName('audio');
	  var mediaEls = [];
	
	  if (vids && vids.length > 0) {
	    for (var i = 0, e = vids.length; i < e; i++) {
	      mediaEls.push(vids[i]);
	    }
	  }
	
	  if (audios && audios.length > 0) {
	    for (var _i = 0, _e = audios.length; _i < _e; _i++) {
	      mediaEls.push(audios[_i]);
	    }
	  }
	
	  // Check if any media elements exist
	  if (mediaEls && mediaEls.length > 0) {
	
	    for (var _i2 = 0, _e2 = mediaEls.length; _i2 < _e2; _i2++) {
	      var mediaEl = mediaEls[_i2];
	
	      // Check if element exists, has getAttribute func.
	      // IE seems to consider typeof el.getAttribute == 'object' instead of
	      // 'function' like expected, at least when loading the player immediately.
	      if (mediaEl && mediaEl.getAttribute) {
	
	        // Make sure this player hasn't already been set up.
	        if (mediaEl.player === undefined) {
	          var options = mediaEl.getAttribute('data-setup');
	
	          // Check if data-setup attr exists.
	          // We only auto-setup if they've added the data-setup attr.
	          if (options !== null) {
	            // Create new video.js instance.
	            videojs(mediaEl);
	          }
	        }
	
	        // If getAttribute isn't defined, we need to wait for the DOM.
	      } else {
	        autoSetupTimeout(1);
	        break;
	      }
	    }
	
	    // No videos were found, so keep looping unless page is finished loading.
	  } else if (!_windowLoaded) {
	    autoSetupTimeout(1);
	  }
	};
	
	/**
	 * Wait until the page is loaded before running autoSetup. This will be called in
	 * autoSetup if `hasLoaded` returns false.
	 *
	 * @param {number} wait
	 *        How long to wait in ms
	 *
	 * @param {videojs} [vjs]
	 *        The videojs library function
	 */
	function autoSetupTimeout(wait, vjs) {
	  if (vjs) {
	    videojs = vjs;
	  }
	
	  _window2['default'].setTimeout(autoSetup, wait);
	}
	
	if (Dom.isReal() && _document2['default'].readyState === 'complete') {
	  _windowLoaded = true;
	} else {
	  /**
	   * Listen for the load event on window, and set _windowLoaded to true.
	   *
	   * @listens load
	   */
	  Events.one(_window2['default'], 'load', function () {
	    _windowLoaded = true;
	  });
	}
	
	/**
	 * check if the document has been loaded
	 */
	var hasLoaded = function hasLoaded() {
	  return _windowLoaded;
	};
	
	exports.autoSetup = autoSetup;
	exports.autoSetupTimeout = autoSetupTimeout;
	exports.hasLoaded = hasLoaded;


/***/ }),
/* 1013 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * @file flash-rtmp.js
	 * @module flash-rtmp
	 */
	
	/**
	 * Add RTMP properties to the {@link Flash} Tech.
	 *
	 * @param {Flash} Flash
	 *        The flash tech class.
	 *
	 * @mixin FlashRtmpDecorator
	 */
	function FlashRtmpDecorator(Flash) {
	  Flash.streamingFormats = {
	    'rtmp/mp4': 'MP4',
	    'rtmp/flv': 'FLV'
	  };
	
	  /**
	   * Join connection and stream with an ampersand.
	   *
	   * @param {string} connection
	   *        The connection string.
	   *
	   * @param {string} stream
	   *        The stream string.
	   */
	  Flash.streamFromParts = function (connection, stream) {
	    return connection + '&' + stream;
	  };
	
	  /**
	   * The flash parts object that contains connection and stream info.
	   *
	   * @typedef {Object} Flash~PartsObject
	   *
	   * @property {string} connection
	   *           The connection string of a source, defaults to an empty string.
	   *
	   * @property {string} stream
	   *           The stream string of the source, defaults to an empty string.
	   */
	
	  /**
	   * Convert a source url into a stream and connection parts.
	   *
	   * @param {string} src
	   *        the source url
	   *
	   * @return {Flash~PartsObject}
	   *         The parts object that contains a connection and a stream
	   */
	  Flash.streamToParts = function (src) {
	    var parts = {
	      connection: '',
	      stream: ''
	    };
	
	    if (!src) {
	      return parts;
	    }
	
	    // Look for the normal URL separator we expect, '&'.
	    // If found, we split the URL into two pieces around the
	    // first '&'.
	    var connEnd = src.search(/&(?!\w+=)/);
	    var streamBegin = void 0;
	
	    if (connEnd !== -1) {
	      streamBegin = connEnd + 1;
	    } else {
	      // If there's not a '&', we use the last '/' as the delimiter.
	      connEnd = streamBegin = src.lastIndexOf('/') + 1;
	      if (connEnd === 0) {
	        // really, there's not a '/'?
	        connEnd = streamBegin = src.length;
	      }
	    }
	
	    parts.connection = src.substring(0, connEnd);
	    parts.stream = src.substring(streamBegin, src.length);
	
	    return parts;
	  };
	
	  /**
	   * Check if the source type is a streaming type.
	   *
	   * @param {string} srcType
	   *        The mime type to check.
	   *
	   * @return {boolean}
	   *          - True if the source type is a streaming type.
	   *          - False if the source type is not a streaming type.
	   */
	  Flash.isStreamingType = function (srcType) {
	    return srcType in Flash.streamingFormats;
	  };
	
	  // RTMP has four variations, any string starting
	  // with one of these protocols should be valid
	
	  /**
	   * Regular expression used to check if the source is an rtmp source.
	   *
	   * @property {RegExp} Flash.RTMP_RE
	   */
	  Flash.RTMP_RE = /^rtmp[set]?:\/\//i;
	
	  /**
	   * Check if the source itself is a streaming type.
	   *
	   * @param {string} src
	   *        The url to the source.
	   *
	   * @return {boolean}
	   *          - True if the source url indicates that the source is streaming.
	   *          - False if the shource url indicates that the source url is not streaming.
	   */
	  Flash.isStreamingSrc = function (src) {
	    return Flash.RTMP_RE.test(src);
	  };
	
	  /**
	   * A source handler for RTMP urls
	   * @type {Object}
	   */
	  Flash.rtmpSourceHandler = {};
	
	  /**
	   * Check if Flash can play the given mime type.
	   *
	   * @param {string} type
	   *        The mime type to check
	   *
	   * @return {string}
	   *         'maybe', or '' (empty string)
	   */
	  Flash.rtmpSourceHandler.canPlayType = function (type) {
	    if (Flash.isStreamingType(type)) {
	      return 'maybe';
	    }
	
	    return '';
	  };
	
	  /**
	   * Check if Flash can handle the source natively
	   *
	   * @param {Object} source
	   *        The source object
	   *
	   * @param {Object} [options]
	   *        The options passed to the tech
	   *
	   * @return {string}
	   *         'maybe', or '' (empty string)
	   */
	  Flash.rtmpSourceHandler.canHandleSource = function (source, options) {
	    var can = Flash.rtmpSourceHandler.canPlayType(source.type);
	
	    if (can) {
	      return can;
	    }
	
	    if (Flash.isStreamingSrc(source.src)) {
	      return 'maybe';
	    }
	
	    return '';
	  };
	
	  /**
	   * Pass the source to the flash object.
	   *
	   * @param {Object} source
	   *        The source object
	   *
	   * @param {Flash} tech
	   *        The instance of the Flash tech
	   *
	   * @param {Object} [options]
	   *        The options to pass to the source
	   */
	  Flash.rtmpSourceHandler.handleSource = function (source, tech, options) {
	    var srcParts = Flash.streamToParts(source.src);
	
	    tech.setRtmpConnection(srcParts.connection);
	    tech.setRtmpStream(srcParts.stream);
	  };
	
	  // Register the native source handler
	  Flash.registerSourceHandler(Flash.rtmpSourceHandler);
	
	  return Flash;
	}
	
	exports['default'] = FlashRtmpDecorator;


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _tech = __webpack_require__(142);
	
	var _tech2 = _interopRequireDefault(_tech);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _url = __webpack_require__(184);
	
	var Url = _interopRequireWildcard(_url);
	
	var _timeRanges = __webpack_require__(143);
	
	var _flashRtmp = __webpack_require__(1013);
	
	var _flashRtmp2 = _interopRequireDefault(_flashRtmp);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _obj = __webpack_require__(31);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file flash.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * VideoJS-SWF - Custom Flash Player with HTML5-ish API
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * https://github.com/zencoder/video-js-swf
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Not using setupTriggers. Using global onEvent func to distribute events
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var navigator = _window2['default'].navigator;
	
	/**
	 * Flash Media Controller - Wrapper for Flash Media API
	 *
	 * @mixes FlashRtmpDecorator
	 * @mixes Tech~SouceHandlerAdditions
	 * @extends Tech
	 */
	
	var Flash = function (_Tech) {
	  _inherits(Flash, _Tech);
	
	  /**
	   * Create an instance of this Tech.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} ready
	   *        Callback function to call when the `Flash` Tech is ready.
	   */
	  function Flash(options, ready) {
	    _classCallCheck(this, Flash);
	
	    // Set the source when ready
	    var _this = _possibleConstructorReturn(this, _Tech.call(this, options, ready));
	
	    if (options.source) {
	      _this.ready(function () {
	        this.setSource(options.source);
	      }, true);
	    }
	
	    // Having issues with Flash reloading on certain page actions (hide/resize/fullscreen) in certain browsers
	    // This allows resetting the playhead when we catch the reload
	    if (options.startTime) {
	      _this.ready(function () {
	        this.load();
	        this.play();
	        this.currentTime(options.startTime);
	      }, true);
	    }
	
	    // Add global window functions that the swf expects
	    // A 4.x workflow we weren't able to solve for in 5.0
	    // because of the need to hard code these functions
	    // into the swf for security reasons
	    _window2['default'].videojs = _window2['default'].videojs || {};
	    _window2['default'].videojs.Flash = _window2['default'].videojs.Flash || {};
	    _window2['default'].videojs.Flash.onReady = Flash.onReady;
	    _window2['default'].videojs.Flash.onEvent = Flash.onEvent;
	    _window2['default'].videojs.Flash.onError = Flash.onError;
	
	    _this.on('seeked', function () {
	      this.lastSeekTarget_ = undefined;
	    });
	
	    return _this;
	  }
	
	  /**
	   * Create the `Flash` Tech's DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  Flash.prototype.createEl = function createEl() {
	    var options = this.options_;
	
	    // If video.js is hosted locally you should also set the location
	    // for the hosted swf, which should be relative to the page (not video.js)
	    // Otherwise this adds a CDN url.
	    // The CDN also auto-adds a swf URL for that specific version.
	    if (!options.swf) {
	      var ver = '5.4.1';
	
	      options.swf = '//vjs.zencdn.net/swf/' + ver + '/video-js.swf';
	    }
	
	    // Generate ID for swf object
	    var objId = options.techId;
	
	    // Merge default flashvars with ones passed in to init
	    var flashVars = (0, _obj.assign)({
	
	      // SWF Callback Functions
	      readyFunction: 'videojs.Flash.onReady',
	      eventProxyFunction: 'videojs.Flash.onEvent',
	      errorEventProxyFunction: 'videojs.Flash.onError',
	
	      // Player Settings
	      autoplay: options.autoplay,
	      preload: options.preload,
	      loop: options.loop,
	      muted: options.muted
	
	    }, options.flashVars);
	
	    // Merge default parames with ones passed in
	    var params = (0, _obj.assign)({
	      // Opaque is needed to overlay controls, but can affect playback performance
	      wmode: 'opaque',
	      // Using bgcolor prevents a white flash when the object is loading
	      bgcolor: '#000000'
	    }, options.params);
	
	    // Merge default attributes with ones passed in
	    var attributes = (0, _obj.assign)({
	      // Both ID and Name needed or swf to identify itself
	      id: objId,
	      name: objId,
	      'class': 'vjs-tech'
	    }, options.attributes);
	
	    this.el_ = Flash.embed(options.swf, flashVars, params, attributes);
	    this.el_.tech = this;
	
	    return this.el_;
	  };
	
	  /**
	   * Called by {@link Player#play} to play using the `Flash` `Tech`.
	   */
	
	
	  Flash.prototype.play = function play() {
	    if (this.ended()) {
	      this.setCurrentTime(0);
	    }
	    this.el_.vjs_play();
	  };
	
	  /**
	   * Called by {@link Player#pause} to pause using the `Flash` `Tech`.
	   */
	
	
	  Flash.prototype.pause = function pause() {
	    this.el_.vjs_pause();
	  };
	
	  /**
	   * A getter/setter for the `Flash` Tech's source object.
	   * > Note: Please use {@link Flash#setSource}
	   *
	   * @param {Tech~SourceObject} [src]
	   *        The source object you want to set on the `Flash` techs.
	   *
	   * @return {Tech~SourceObject|undefined}
	   *         - The current source object when a source is not passed in.
	   *         - undefined when setting
	   *
	   * @deprecated Since version 5.
	   */
	
	
	  Flash.prototype.src = function src(_src) {
	    if (_src === undefined) {
	      return this.currentSrc();
	    }
	
	    // Setting src through `src` not `setSrc` will be deprecated
	    return this.setSrc(_src);
	  };
	
	  /**
	   * A getter/setter for the `Flash` Tech's source object.
	   *
	   * @param {Tech~SourceObject} [src]
	   *        The source object you want to set on the `Flash` techs.
	   *
	   * @return {Tech~SourceObject|undefined}
	   *         - The current source object when a source is not passed in.
	   *         - undefined when setting
	   */
	
	
	  Flash.prototype.setSrc = function setSrc(src) {
	    var _this2 = this;
	
	    // Make sure source URL is absolute.
	    src = Url.getAbsoluteURL(src);
	    this.el_.vjs_src(src);
	
	    // Currently the SWF doesn't autoplay if you load a source later.
	    // e.g. Load player w/ no source, wait 2s, set src.
	    if (this.autoplay()) {
	      this.setTimeout(function () {
	        return _this2.play();
	      }, 0);
	    }
	  };
	
	  /**
	   * Indicates whether the media is currently seeking to a new position or not.
	   *
	   * @return {boolean}
	   *         - True if seeking to a new position
	   *         - False otherwise
	   */
	
	
	  Flash.prototype.seeking = function seeking() {
	    return this.lastSeekTarget_ !== undefined;
	  };
	
	  /**
	   * Returns the current time in seconds that the media is at in playback.
	   *
	   * @param {number} time
	   *        Current playtime of the media in seconds.
	   */
	
	
	  Flash.prototype.setCurrentTime = function setCurrentTime(time) {
	    var seekable = this.seekable();
	
	    if (seekable.length) {
	      // clamp to the current seekable range
	      time = time > seekable.start(0) ? time : seekable.start(0);
	      time = time < seekable.end(seekable.length - 1) ? time : seekable.end(seekable.length - 1);
	
	      this.lastSeekTarget_ = time;
	      this.trigger('seeking');
	      this.el_.vjs_setProperty('currentTime', time);
	      _Tech.prototype.setCurrentTime.call(this);
	    }
	  };
	
	  /**
	   * Get the current playback time in seconds
	   *
	   * @return {number}
	   *         The current time of playback in seconds.
	   */
	
	
	  Flash.prototype.currentTime = function currentTime() {
	    // when seeking make the reported time keep up with the requested time
	    // by reading the time we're seeking to
	    if (this.seeking()) {
	      return this.lastSeekTarget_ || 0;
	    }
	    return this.el_.vjs_getProperty('currentTime');
	  };
	
	  /**
	   * Get the current source
	   *
	   * @method currentSrc
	   * @return {Tech~SourceObject}
	   *         The current source
	   */
	
	
	  Flash.prototype.currentSrc = function currentSrc() {
	    if (this.currentSource_) {
	      return this.currentSource_.src;
	    }
	    return this.el_.vjs_getProperty('currentSrc');
	  };
	
	  /**
	   * Get the total duration of the current media.
	   *
	   * @return {number}
	   8          The total duration of the current media.
	   */
	
	
	  Flash.prototype.duration = function duration() {
	    if (this.readyState() === 0) {
	      return NaN;
	    }
	    var duration = this.el_.vjs_getProperty('duration');
	
	    return duration >= 0 ? duration : Infinity;
	  };
	
	  /**
	   * Load media into Tech.
	   */
	
	
	  Flash.prototype.load = function load() {
	    this.el_.vjs_load();
	  };
	
	  /**
	   * Get the poster image that was set on the tech.
	   */
	
	
	  Flash.prototype.poster = function poster() {
	    this.el_.vjs_getProperty('poster');
	  };
	
	  /**
	   * Poster images are not handled by the Flash tech so make this is a no-op.
	   */
	
	
	  Flash.prototype.setPoster = function setPoster() {};
	
	  /**
	   * Determine the time ranges that can be seeked to in the media.
	   *
	   * @return {TimeRange}
	   *         Returns the time ranges that can be seeked to.
	   */
	
	
	  Flash.prototype.seekable = function seekable() {
	    var duration = this.duration();
	
	    if (duration === 0) {
	      return (0, _timeRanges.createTimeRange)();
	    }
	    return (0, _timeRanges.createTimeRange)(0, duration);
	  };
	
	  /**
	   * Get and create a `TimeRange` object for buffering.
	   *
	   * @return {TimeRange}
	   *         The time range object that was created.
	   */
	
	
	  Flash.prototype.buffered = function buffered() {
	    var ranges = this.el_.vjs_getProperty('buffered');
	
	    if (ranges.length === 0) {
	      return (0, _timeRanges.createTimeRange)();
	    }
	    return (0, _timeRanges.createTimeRange)(ranges[0][0], ranges[0][1]);
	  };
	
	  /**
	   * Get fullscreen support -
	   *
	   * Flash does not allow fullscreen through javascript
	   * so this always returns false.
	   *
	   * @return {boolean}
	   *         The Flash tech does not support fullscreen, so it will always return false.
	   */
	
	
	  Flash.prototype.supportsFullScreen = function supportsFullScreen() {
	    // Flash does not allow fullscreen through javascript
	    return false;
	  };
	
	  /**
	   * Flash does not allow fullscreen through javascript
	   * so this always returns false.
	   *
	   * @return {boolean}
	   *         The Flash tech does not support fullscreen, so it will always return false.
	   */
	
	
	  Flash.prototype.enterFullScreen = function enterFullScreen() {
	    return false;
	  };
	
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   */
	
	
	  Flash.prototype.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    var videoPlaybackQuality = this.el_.vjs_getProperty('getVideoPlaybackQuality');
	
	    if (_window2['default'].performance && typeof _window2['default'].performance.now === 'function') {
	      videoPlaybackQuality.creationTime = _window2['default'].performance.now();
	    } else if (_window2['default'].performance && _window2['default'].performance.timing && typeof _window2['default'].performance.timing.navigationStart === 'number') {
	      videoPlaybackQuality.creationTime = _window2['default'].Date.now() - _window2['default'].performance.timing.navigationStart;
	    }
	
	    return videoPlaybackQuality;
	  };
	
	  return Flash;
	}(_tech2['default']);
	
	// Create setters and getters for attributes
	
	
	var _api = Flash.prototype;
	var _readWrite = 'rtmpConnection,rtmpStream,preload,defaultPlaybackRate,playbackRate,autoplay,loop,mediaGroup,controller,controls,volume,muted,defaultMuted'.split(',');
	var _readOnly = 'networkState,readyState,initialTime,startOffsetTime,paused,ended,videoWidth,videoHeight'.split(',');
	
	function _createSetter(attr) {
	  var attrUpper = attr.charAt(0).toUpperCase() + attr.slice(1);
	
	  _api['set' + attrUpper] = function (val) {
	    return this.el_.vjs_setProperty(attr, val);
	  };
	}
	
	function _createGetter(attr) {
	  _api[attr] = function () {
	    return this.el_.vjs_getProperty(attr);
	  };
	}
	
	// Create getter and setters for all read/write attributes
	for (var i = 0; i < _readWrite.length; i++) {
	  _createGetter(_readWrite[i]);
	  _createSetter(_readWrite[i]);
	}
	
	// Create getters for read-only attributes
	for (var _i = 0; _i < _readOnly.length; _i++) {
	  _createGetter(_readOnly[_i]);
	}
	
	/** ------------------------------ Getters ------------------------------ **/
	/**
	 * Get the value of `rtmpConnection` from the swf.
	 *
	 * @method Flash#rtmpConnection
	 * @return {string}
	 *         The current value of `rtmpConnection` on the swf.
	 */
	
	/**
	 * Get the value of `rtmpStream` from the swf.
	 *
	 * @method Flash#rtmpStream
	 * @return {string}
	 *         The current value of `rtmpStream` on the swf.
	 */
	
	/**
	 * Get the value of `preload` from the swf. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Flash#preload
	 * @return {string}
	 *         The value of `preload` from the swf. Will be 'none', 'metadata',
	 *         or 'auto'.
	 */
	
	/**
	 * Get the value of `defaultPlaybackRate` from the swf.
	 *
	 * @method Flash#defaultPlaybackRate
	 * @return {number}
	 *         The current value of `defaultPlaybackRate` on the swf.
	 */
	
	/**
	 * Get the value of `playbackRate` from the swf. `playbackRate` indicates
	 * the rate at which the media is currently playing back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Flash#playbackRate
	 * @return {number}
	 *         The value of `playbackRate` from the swf. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 */
	
	/**
	 * Get the value of `autoplay` from the swf. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Flash#autoplay
	 * @return {boolean}
	 *         - The value of `autoplay` from the swf.
	 *         - True indicates that the media ashould start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 */
	
	/**
	 * Get the value of `loop` from the swf. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Flash#loop
	 * @return {boolean}
	 *         - The value of `loop` from the swf.
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 */
	
	/**
	 * Get the value of `mediaGroup` from the swf.
	 *
	 * @method Flash#mediaGroup
	 * @return {string}
	 *         The current value of `mediaGroup` on the swf.
	 */
	
	/**
	 * Get the value of `controller` from the swf.
	 *
	 * @method Flash#controller
	 * @return {string}
	 *         The current value of `controller` on the swf.
	 */
	
	/**
	 * Get the value of `controls` from the swf. `controls` indicates
	 * whether the native flash controls should be shown or hidden.
	 *
	 * @method Flash#controls
	 * @return {boolean}
	 *         - The value of `controls` from the swf.
	 *         - True indicates that native controls should be showing.
	 *         - False indicates that native controls should be hidden.
	 */
	
	/**
	 * Get the value of the `volume` from the swf. `volume` indicates the current
	 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
	 * so on.
	 *
	 * @method Flash#volume
	 * @return {number}
	 *         The volume percent as a decimal. Value will be between 0-1.
	 */
	
	/**
	 * Get the value of the `muted` from the swf. `muted` indicates the current
	 * audio level should be silent.
	 *
	 * @method Flash#muted
	 * @return {boolean}
	 *         - True if the audio should be set to silent
	 *         - False otherwise
	 */
	
	/**
	 * Get the value of `defaultMuted` from the swf. `defaultMuted` indicates
	 * whether the media should start muted or not. Only changes the default state of the
	 * media. `muted` and `defaultMuted` can have different values. `muted` indicates the
	 * current state.
	 *
	 * @method Flash#defaultMuted
	 * @return {boolean}
	 *         - The value of `defaultMuted` from the swf.
	 *         - True indicates that the media should start muted.
	 *         - False indicates that the media should not start muted.
	 */
	
	/**
	 * Get the value of `networkState` from the swf. `networkState` indicates
	 * the current network state. It returns an enumeration from the following list:
	 * - 0: NETWORK_EMPTY
	 * - 1: NEWORK_IDLE
	 * - 2: NETWORK_LOADING
	 * - 3: NETWORK_NO_SOURCE
	 *
	 * @method Flash#networkState
	 * @return {number}
	 *         The value of `networkState` from the swf. This will be a number
	 *         from the list in the description.
	 */
	
	/**
	 * Get the value of `readyState` from the swf. `readyState` indicates
	 * the current state of the media element. It returns an enumeration from the
	 * following list:
	 * - 0: HAVE_NOTHING
	 * - 1: HAVE_METADATA
	 * - 2: HAVE_CURRENT_DATA
	 * - 3: HAVE_FUTURE_DATA
	 * - 4: HAVE_ENOUGH_DATA
	 *
	 * @method Flash#readyState
	 * @return {number}
	 *         The value of `readyState` from the swf. This will be a number
	 *         from the list in the description.
	 */
	
	/**
	 * Get the value of `readyState` from the swf. `readyState` indicates
	 * the current state of the media element. It returns an enumeration from the
	 * following list:
	 * - 0: HAVE_NOTHING
	 * - 1: HAVE_METADATA
	 * - 2: HAVE_CURRENT_DATA
	 * - 3: HAVE_FUTURE_DATA
	 * - 4: HAVE_ENOUGH_DATA
	 *
	 * @method Flash#readyState
	 * @return {number}
	 *         The value of `readyState` from the swf. This will be a number
	 *         from the list in the description.
	 */
	
	/**
	 * Get the value of `initialTime` from the swf.
	 *
	 * @method Flash#initialTime
	 * @return {number}
	 *         The `initialTime` proprety on the swf.
	 */
	
	/**
	 * Get the value of `startOffsetTime` from the swf.
	 *
	 * @method Flash#startOffsetTime
	 * @return {number}
	 *         The `startOffsetTime` proprety on the swf.
	 */
	
	/**
	 * Get the value of `paused` from the swf. `paused` indicates whether the swf
	 * is current paused or not.
	 *
	 * @method Flash#paused
	 * @return {boolean}
	 *         The value of `paused` from the swf.
	 */
	
	/**
	 * Get the value of `ended` from the swf. `ended` indicates whether
	 * the media has reached the end or not.
	 *
	 * @method Flash#ended
	 * @return {boolean}
	 *         - True indicates that the media has ended.
	 *         - False indicates that the media has not ended.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
	 */
	
	/**
	 * Get the value of `videoWidth` from the swf. `videoWidth` indicates
	 * the current width of the media in css pixels.
	 *
	 * @method Flash#videoWidth
	 * @return {number}
	 *         The value of `videoWidth` from the swf. This will be a number
	 *         in css pixels.
	 */
	
	/**
	 * Get the value of `videoHeight` from the swf. `videoHeigth` indicates
	 * the current height of the media in css pixels.
	 *
	 * @method Flassh.prototype.videoHeight
	 * @return {number}
	 *         The value of `videoHeight` from the swf. This will be a number
	 *         in css pixels.
	 */
	/** ------------------------------ Setters ------------------------------ **/
	
	/**
	 * Set the value of `rtmpConnection` on the swf.
	 *
	 * @method Flash#setRtmpConnection
	 * @param {string} rtmpConnection
	 *        New value to set the `rtmpConnection` property to.
	 */
	
	/**
	 * Set the value of `rtmpStream` on the swf.
	 *
	 * @method Flash#setRtmpStream
	 * @param {string} rtmpStream
	 *        New value to set the `rtmpStream` property to.
	 */
	
	/**
	 * Set the value of `preload` on the swf. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Flash#setPreload
	 * @param {string} preload
	 *        The value of `preload` to set on the swf. Should be 'none', 'metadata',
	 *        or 'auto'.
	 */
	
	/**
	 * Set the value of `defaultPlaybackRate` on the swf.
	 *
	 * @method Flash#setDefaultPlaybackRate
	 * @param {number} defaultPlaybackRate
	 *        New value to set the `defaultPlaybackRate` property to.
	 */
	
	/**
	 * Set the value of `playbackRate` on the swf. `playbackRate` indicates
	 * the rate at which the media is currently playing back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Flash#setPlaybackRate
	 * @param {number} playbackRate
	 *        New value of `playbackRate` on the swf. A number indicating
	 *        the current playback speed of the media, where 1 is normal speed.
	 */
	
	/**
	 * Set the value of `autoplay` on the swf. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Flash#setAutoplay
	 * @param {boolean} autoplay
	 *        - The value of `autoplay` from the swf.
	 *        - True indicates that the media ashould start as soon as the page loads.
	 *        - False indicates that the media should not start as soon as the page loads.
	 */
	
	/**
	 * Set the value of `loop` on the swf. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Flash#setLoop
	 * @param {boolean} loop
	 *        - True indicates that playback should seek back to start once
	 *          the end of a media is reached.
	 *        - False indicates that playback should not loop back to the start when the
	 *          end of the media is reached.
	 */
	
	/**
	 * Set the value of `mediaGroup` on the swf.
	 *
	 * @method Flash#setMediaGroup
	 * @param {string} mediaGroup
	 *        New value of `mediaGroup` to set on the swf.
	 */
	
	/**
	 * Set the value of `controller` on the swf.
	 *
	 * @method Flash#setController
	 * @param {string} controller
	 *        New value the current value of `controller` on the swf.
	 */
	
	/**
	 * Get the value of `controls` from the swf. `controls` indicates
	 * whether the native flash controls should be shown or hidden.
	 *
	 * @method Flash#controls
	 * @return {boolean}
	 *         - The value of `controls` from the swf.
	 *         - True indicates that native controls should be showing.
	 *         - False indicates that native controls should be hidden.
	 */
	
	/**
	 * Set the value of the `volume` on the swf. `volume` indicates the current
	 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
	 * so on.
	 *
	 * @method Flash#setVolume
	 * @param {number} percentAsDecimal
	 *         The volume percent as a decimal. Value will be between 0-1.
	 */
	
	/**
	 * Set the value of the `muted` on the swf. `muted` indicates that the current
	 * audio level should be silent.
	 *
	 * @method Flash#setMuted
	 * @param {boolean} muted
	 *         - True if the audio should be set to silent
	 *         - False otherwise
	 */
	
	/**
	 * Set the value of `defaultMuted` on the swf. `defaultMuted` indicates
	 * whether the media should start muted or not. Only changes the default state of the
	 * media. `muted` and `defaultMuted` can have different values. `muted` indicates the
	 * current state.
	 *
	 * @method Flash#setDefaultMuted
	 * @param {boolean} defaultMuted
	 *         - True indicates that the media should start muted.
	 *         - False indicates that the media should not start muted.
	 */
	
	/* Flash Support Testing -------------------------------------------------------- */
	
	/**
	 * Check if the Flash tech is currently supported.
	 *
	 * @return {boolean}
	 *          - True if the flash tech is supported.
	 *          - False otherwise.
	 */
	Flash.isSupported = function () {
	  return Flash.version()[0] >= 10;
	  // return swfobject.hasFlashPlayerVersion('10');
	};
	
	// Add Source Handler pattern functions to this tech
	_tech2['default'].withSourceHandlers(Flash);
	
	/*
	 * Native source handler for flash,  simply passes the source to the swf element.
	 *
	 * @property {Tech~SourceObject} source
	 *           The source object
	 *
	 * @property {Flash} tech
	 *           The instance of the Flash tech
	 */
	Flash.nativeSourceHandler = {};
	
	/**
	 * Check if the Flash can play the given mime type.
	 *
	 * @param {string} type
	 *        The mimetype to check
	 *
	 * @return {string}
	 *         'maybe', or '' (empty string)
	 */
	Flash.nativeSourceHandler.canPlayType = function (type) {
	  if (type in Flash.formats) {
	    return 'maybe';
	  }
	
	  return '';
	};
	
	/**
	 * Check if the media element can handle a source natively.
	 *
	 * @param {Tech~SourceObject} source
	 *         The source object
	 *
	 * @param {Object} [options]
	 *         Options to be passed to the tech.
	 *
	 * @return {string}
	 *         'maybe', or '' (empty string).
	 */
	Flash.nativeSourceHandler.canHandleSource = function (source, options) {
	  var type = void 0;
	
	  function guessMimeType(src) {
	    var ext = Url.getFileExtension(src);
	
	    if (ext) {
	      return 'video/' + ext;
	    }
	    return '';
	  }
	
	  if (!source.type) {
	    type = guessMimeType(source.src);
	  } else {
	    // Strip code information from the type because we don't get that specific
	    type = source.type.replace(/;.*/, '').toLowerCase();
	  }
	
	  return Flash.nativeSourceHandler.canPlayType(type);
	};
	
	/**
	 * Pass the source to the swf.
	 *
	 * @param {Tech~SourceObject} source
	 *        The source object
	 *
	 * @param {Flash} tech
	 *        The instance of the Flash tech
	 *
	 * @param {Object} [options]
	 *        The options to pass to the source
	 */
	Flash.nativeSourceHandler.handleSource = function (source, tech, options) {
	  tech.setSrc(source.src);
	};
	
	/**
	 * noop for native source handler dispose, as cleanup will happen automatically.
	 */
	Flash.nativeSourceHandler.dispose = function () {};
	
	// Register the native source handler
	Flash.registerSourceHandler(Flash.nativeSourceHandler);
	
	/**
	 * Flash supported mime types.
	 *
	 * @constant {Object}
	 */
	Flash.formats = {
	  'video/flv': 'FLV',
	  'video/x-flv': 'FLV',
	  'video/mp4': 'MP4',
	  'video/m4v': 'MP4'
	};
	
	/**
	 * Called when the the swf is "ready", and makes sure that the swf is really
	 * ready using {@link Flash#checkReady}
	 */
	Flash.onReady = function (currSwf) {
	  var el = Dom.getEl(currSwf);
	  var tech = el && el.tech;
	
	  // if there is no el then the tech has been disposed
	  // and the tech element was removed from the player div
	  if (tech && tech.el()) {
	    // check that the flash object is really ready
	    Flash.checkReady(tech);
	  }
	};
	
	/**
	 * The SWF isn't always ready when it says it is. Sometimes the API functions still
	 * need to be added to the object. If it's not ready, we set a timeout to check again
	 * shortly.
	 *
	 * @param {Flash} tech
	 *        The instance of the flash tech to check.
	 */
	Flash.checkReady = function (tech) {
	  // stop worrying if the tech has been disposed
	  if (!tech.el()) {
	    return;
	  }
	
	  // check if API property exists
	  if (tech.el().vjs_getProperty) {
	    // tell tech it's ready
	    tech.triggerReady();
	  } else {
	    // wait longer
	    this.setTimeout(function () {
	      Flash.checkReady(tech);
	    }, 50);
	  }
	};
	
	/**
	 * Trigger events from the swf on the Flash Tech.
	 *
	 * @param {number} swfID
	 *        The id of the swf that had the event
	 *
	 * @param {string} eventName
	 *        The name of the event to trigger
	 */
	Flash.onEvent = function (swfID, eventName) {
	  var tech = Dom.getEl(swfID).tech;
	  var args = Array.prototype.slice.call(arguments, 2);
	
	  // dispatch Flash events asynchronously for two reasons:
	  // - Flash swallows any exceptions generated by javascript it
	  //   invokes
	  // - Flash is suspended until the javascript returns which may cause
	  //   playback performance issues
	  tech.setTimeout(function () {
	    tech.trigger(eventName, args);
	  }, 1);
	};
	
	/**
	 * Log errors from the swf on the Flash tech.
	 *
	 * @param {number} swfID
	 *        The id of the swf that had an error.
	 *
	 * @param {string} The error string
	 *        The error to set on the Flash Tech.
	 *
	 * @return {MediaError|undefined}
	 *          - Returns a MediaError when err is 'srcnotfound'
	 *          - Returns undefined otherwise.
	 */
	Flash.onError = function (swfID, err) {
	  var tech = Dom.getEl(swfID).tech;
	
	  // trigger MEDIA_ERR_SRC_NOT_SUPPORTED
	  if (err === 'srcnotfound') {
	    return tech.error(4);
	  }
	
	  // trigger a custom error
	  tech.error('FLASH: ' + err);
	};
	
	/**
	 * Get the current version of Flash that is in use on the page.
	 *
	 * @return {Array}
	 *          an array of versions that are available.
	 */
	Flash.version = function () {
	  var version = '0,0,0';
	
	  // IE
	  try {
	    version = new _window2['default'].ActiveXObject('ShockwaveFlash.ShockwaveFlash').GetVariable('$version').replace(/\D+/g, ',').match(/^,?(.+),?$/)[1];
	
	    // other browsers
	  } catch (e) {
	    try {
	      if (navigator.mimeTypes['application/x-shockwave-flash'].enabledPlugin) {
	        version = (navigator.plugins['Shockwave Flash 2.0'] || navigator.plugins['Shockwave Flash']).description.replace(/\D+/g, ',').match(/^,?(.+),?$/)[1];
	      }
	    } catch (err) {
	      // satisfy linter
	    }
	  }
	  return version.split(',');
	};
	
	/**
	 * Only use for non-iframe embeds.
	 *
	 * @param {Object} swf
	 *        The videojs-swf object.
	 *
	 * @param {Object} flashVars
	 *        Names and values to use as flash option variables.
	 *
	 * @param {Object} params
	 *        Style parameters to set on the object.
	 *
	 * @param {Object} attributes
	 *        Attributes to set on the element.
	 *
	 * @return {Element}
	 *          The embeded Flash DOM element.
	 */
	Flash.embed = function (swf, flashVars, params, attributes) {
	  var code = Flash.getEmbedCode(swf, flashVars, params, attributes);
	
	  // Get element by embedding code and retrieving created element
	  var obj = Dom.createEl('div', { innerHTML: code }).childNodes[0];
	
	  return obj;
	};
	
	/**
	 * Only use for non-iframe embeds.
	 *
	 * @param {Object} swf
	 *        The videojs-swf object.
	 *
	 * @param {Object} flashVars
	 *        Names and values to use as flash option variables.
	 *
	 * @param {Object} params
	 *        Style parameters to set on the object.
	 *
	 * @param {Object} attributes
	 *        Attributes to set on the element.
	 *
	 * @return {Element}
	 *          The embeded Flash DOM element.
	 */
	Flash.getEmbedCode = function (swf, flashVars, params, attributes) {
	  var objTag = '<object type="application/x-shockwave-flash" ';
	  var flashVarsString = '';
	  var paramsString = '';
	  var attrsString = '';
	
	  // Convert flash vars to string
	  if (flashVars) {
	    Object.getOwnPropertyNames(flashVars).forEach(function (key) {
	      flashVarsString += key + '=' + flashVars[key] + '&amp;';
	    });
	  }
	
	  // Add swf, flashVars, and other default params
	  params = (0, _obj.assign)({
	    movie: swf,
	    flashvars: flashVarsString,
	    // Required to talk to swf
	    allowScriptAccess: 'always',
	    // All should be default, but having security issues.
	    allowNetworking: 'all'
	  }, params);
	
	  // Create param tags string
	  Object.getOwnPropertyNames(params).forEach(function (key) {
	    paramsString += '<param name="' + key + '" value="' + params[key] + '" />';
	  });
	
	  attributes = (0, _obj.assign)({
	    // Add swf to attributes (need both for IE and Others to work)
	    data: swf,
	
	    // Default to 100% width/height
	    width: '100%',
	    height: '100%'
	
	  }, attributes);
	
	  // Create Attributes string
	  Object.getOwnPropertyNames(attributes).forEach(function (key) {
	    attrsString += key + '="' + attributes[key] + '" ';
	  });
	
	  return '' + objTag + attrsString + '>' + paramsString + '</object>';
	};
	
	// Run Flash through the RTMP decorator
	(0, _flashRtmp2['default'])(Flash);
	
	_component2['default'].registerComponent('Flash', Flash);
	_tech2['default'].registerTech('Flash', Flash);
	exports['default'] = Flash;


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(['Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n            This may prevent text tracks from loading.'], ['Text Tracks are being loaded from another origin but the crossorigin attribute isn\'t used.\n            This may prevent text tracks from loading.']);
	
	var _tech = __webpack_require__(142);
	
	var _tech2 = _interopRequireDefault(_tech);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var Dom = _interopRequireWildcard(_dom);
	
	var _url = __webpack_require__(184);
	
	var Url = _interopRequireWildcard(_url);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	var _tsml = __webpack_require__(416);
	
	var _tsml2 = _interopRequireDefault(_tsml);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _obj = __webpack_require__(31);
	
	var _mergeOptions = __webpack_require__(76);
	
	var _mergeOptions2 = _interopRequireDefault(_mergeOptions);
	
	var _toTitleCase = __webpack_require__(120);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file html5.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * HTML5 Media Controller - Wrapper for HTML5 Media API
	 *
	 * @mixes Tech~SouceHandlerAdditions
	 * @extends Tech
	 */
	var Html5 = function (_Tech) {
	  _inherits(Html5, _Tech);
	
	  /**
	   * Create an instance of this Tech.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} ready
	   *        Callback function to call when the `HTML5` Tech is ready.
	   */
	  function Html5(options, ready) {
	    _classCallCheck(this, Html5);
	
	    var _this = _possibleConstructorReturn(this, _Tech.call(this, options, ready));
	
	    var source = options.source;
	    var crossoriginTracks = false;
	
	    // Set the source if one is provided
	    // 1) Check if the source is new (if not, we want to keep the original so playback isn't interrupted)
	    // 2) Check to see if the network state of the tag was failed at init, and if so, reset the source
	    // anyway so the error gets fired.
	    if (source && (_this.el_.currentSrc !== source.src || options.tag && options.tag.initNetworkState_ === 3)) {
	      _this.setSource(source);
	    } else {
	      _this.handleLateInit_(_this.el_);
	    }
	
	    if (_this.el_.hasChildNodes()) {
	
	      var nodes = _this.el_.childNodes;
	      var nodesLength = nodes.length;
	      var removeNodes = [];
	
	      while (nodesLength--) {
	        var node = nodes[nodesLength];
	        var nodeName = node.nodeName.toLowerCase();
	
	        if (nodeName === 'track') {
	          if (!_this.featuresNativeTextTracks) {
	            // Empty video tag tracks so the built-in player doesn't use them also.
	            // This may not be fast enough to stop HTML5 browsers from reading the tags
	            // so we'll need to turn off any default tracks if we're manually doing
	            // captions and subtitles. videoElement.textTracks
	            removeNodes.push(node);
	          } else {
	            // store HTMLTrackElement and TextTrack to remote list
	            _this.remoteTextTrackEls().addTrackElement_(node);
	            _this.remoteTextTracks().addTrack_(node.track);
	            if (!crossoriginTracks && !_this.el_.hasAttribute('crossorigin') && Url.isCrossOrigin(node.src)) {
	              crossoriginTracks = true;
	            }
	          }
	        }
	      }
	
	      for (var i = 0; i < removeNodes.length; i++) {
	        _this.el_.removeChild(removeNodes[i]);
	      }
	    }
	
	    // TODO: add text tracks into this list
	    var trackTypes = ['audio', 'video'];
	
	    // ProxyNative Video/Audio Track
	    trackTypes.forEach(function (type) {
	      var elTracks = _this.el()[type + 'Tracks'];
	      var techTracks = _this[type + 'Tracks']();
	      var capitalType = (0, _toTitleCase2['default'])(type);
	
	      if (!_this['featuresNative' + capitalType + 'Tracks'] || !elTracks || !elTracks.addEventListener) {
	        return;
	      }
	
	      _this['handle' + capitalType + 'TrackChange_'] = function (e) {
	        techTracks.trigger({
	          type: 'change',
	          target: techTracks,
	          currentTarget: techTracks,
	          srcElement: techTracks
	        });
	      };
	
	      _this['handle' + capitalType + 'TrackAdd_'] = function (e) {
	        return techTracks.addTrack(e.track);
	      };
	      _this['handle' + capitalType + 'TrackRemove_'] = function (e) {
	        return techTracks.removeTrack(e.track);
	      };
	
	      elTracks.addEventListener('change', _this['handle' + capitalType + 'TrackChange_']);
	      elTracks.addEventListener('addtrack', _this['handle' + capitalType + 'TrackAdd_']);
	      elTracks.addEventListener('removetrack', _this['handle' + capitalType + 'TrackRemove_']);
	      _this['removeOld' + capitalType + 'Tracks_'] = function (e) {
	        return _this.removeOldTracks_(techTracks, elTracks);
	      };
	
	      // Remove (native) tracks that are not used anymore
	      _this.on('loadstart', _this['removeOld' + capitalType + 'Tracks_']);
	    });
	
	    if (_this.featuresNativeTextTracks) {
	      if (crossoriginTracks) {
	        _log2['default'].warn((0, _tsml2['default'])(_templateObject));
	      }
	
	      _this.handleTextTrackChange_ = Fn.bind(_this, _this.handleTextTrackChange);
	      _this.handleTextTrackAdd_ = Fn.bind(_this, _this.handleTextTrackAdd);
	      _this.handleTextTrackRemove_ = Fn.bind(_this, _this.handleTextTrackRemove);
	      _this.proxyNativeTextTracks_();
	    }
	
	    // prevent iOS Safari from disabling metadata text tracks during native playback
	    _this.restoreMetadataTracksInIOSNativePlayer_();
	
	    // Determine if native controls should be used
	    // Our goal should be to get the custom controls on mobile solid everywhere
	    // so we can remove this all together. Right now this will block custom
	    // controls on touch enabled laptops like the Chrome Pixel
	    if ((browser.TOUCH_ENABLED || browser.IS_IPHONE || browser.IS_NATIVE_ANDROID) && options.nativeControlsForTouch === true) {
	      _this.setControls(true);
	    }
	
	    // on iOS, we want to proxy `webkitbeginfullscreen` and `webkitendfullscreen`
	    // into a `fullscreenchange` event
	    _this.proxyWebkitFullscreen_();
	
	    _this.triggerReady();
	    return _this;
	  }
	
	  /**
	   * Dispose of `HTML5` media element and remove all tracks.
	   */
	
	
	  Html5.prototype.dispose = function dispose() {
	    var _this2 = this;
	
	    // Un-ProxyNativeTracks
	    ['audio', 'video', 'text'].forEach(function (type) {
	      var capitalType = (0, _toTitleCase2['default'])(type);
	      var tl = _this2.el_[type + 'Tracks'];
	
	      if (tl && tl.removeEventListener) {
	        tl.removeEventListener('change', _this2['handle' + capitalType + 'TrackChange_']);
	        tl.removeEventListener('addtrack', _this2['handle' + capitalType + 'TrackAdd_']);
	        tl.removeEventListener('removetrack', _this2['handle' + capitalType + 'TrackRemove_']);
	      }
	
	      // Stop removing old text tracks
	      if (tl) {
	        _this2.off('loadstart', _this2['removeOld' + capitalType + 'Tracks_']);
	      }
	    });
	
	    Html5.disposeMediaElement(this.el_);
	    // tech will handle clearing of the emulated track list
	    _Tech.prototype.dispose.call(this);
	  };
	
	  /**
	   * When a captions track is enabled in the iOS Safari native player, all other
	   * tracks are disabled (including metadata tracks), which nulls all of their
	   * associated cue points. This will restore metadata tracks to their pre-fullscreen
	   * state in those cases so that cue points are not needlessly lost.
	   *
	   * @private
	   */
	
	
	  Html5.prototype.restoreMetadataTracksInIOSNativePlayer_ = function restoreMetadataTracksInIOSNativePlayer_() {
	    var textTracks = this.textTracks();
	    var metadataTracksPreFullscreenState = void 0;
	
	    // captures a snapshot of every metadata track's current state
	    var takeMetadataTrackSnapshot = function takeMetadataTrackSnapshot() {
	      metadataTracksPreFullscreenState = [];
	
	      for (var i = 0; i < textTracks.length; i++) {
	        var track = textTracks[i];
	
	        if (track.kind === 'metadata') {
	          metadataTracksPreFullscreenState.push({
	            track: track,
	            storedMode: track.mode
	          });
	        }
	      }
	    };
	
	    // snapshot each metadata track's initial state, and update the snapshot
	    // each time there is a track 'change' event
	    takeMetadataTrackSnapshot();
	    textTracks.addEventListener('change', takeMetadataTrackSnapshot);
	
	    var restoreTrackMode = function restoreTrackMode() {
	      for (var i = 0; i < metadataTracksPreFullscreenState.length; i++) {
	        var storedTrack = metadataTracksPreFullscreenState[i];
	
	        if (storedTrack.track.mode === 'disabled' && storedTrack.track.mode !== storedTrack.storedMode) {
	          storedTrack.track.mode = storedTrack.storedMode;
	        }
	      }
	      // we only want this handler to be executed on the first 'change' event
	      textTracks.removeEventListener('change', restoreTrackMode);
	    };
	
	    // when we enter fullscreen playback, stop updating the snapshot and
	    // restore all track modes to their pre-fullscreen state
	    this.on('webkitbeginfullscreen', function () {
	      textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	
	      // remove the listener before adding it just in case it wasn't previously removed
	      textTracks.removeEventListener('change', restoreTrackMode);
	      textTracks.addEventListener('change', restoreTrackMode);
	    });
	
	    // start updating the snapshot again after leaving fullscreen
	    this.on('webkitendfullscreen', function () {
	      // remove the listener before adding it just in case it wasn't previously removed
	      textTracks.removeEventListener('change', takeMetadataTrackSnapshot);
	      textTracks.addEventListener('change', takeMetadataTrackSnapshot);
	
	      // remove the restoreTrackMode handler in case it wasn't triggered during fullscreen playback
	      textTracks.removeEventListener('change', restoreTrackMode);
	    });
	  };
	
	  /**
	   * Create the `Html5` Tech's DOM element.
	   *
	   * @return {Element}
	   *         The element that gets created.
	   */
	
	
	  Html5.prototype.createEl = function createEl() {
	    var el = this.options_.tag;
	
	    // Check if this browser supports moving the element into the box.
	    // On the iPhone video will break if you move the element,
	    // So we have to create a brand new element.
	    // If we ingested the player div, we do not need to move the media element.
	    if (!el || !(this.options_.playerElIngest || this.movingMediaElementInDOM)) {
	
	      // If the original tag is still there, clone and remove it.
	      if (el) {
	        var clone = el.cloneNode(true);
	
	        if (el.parentNode) {
	          el.parentNode.insertBefore(clone, el);
	        }
	        Html5.disposeMediaElement(el);
	        el = clone;
	      } else {
	        el = _document2['default'].createElement('video');
	
	        // determine if native controls should be used
	        var tagAttributes = this.options_.tag && Dom.getElAttributes(this.options_.tag);
	        var attributes = (0, _mergeOptions2['default'])({}, tagAttributes);
	
	        if (!browser.TOUCH_ENABLED || this.options_.nativeControlsForTouch !== true) {
	          delete attributes.controls;
	        }
	
	        Dom.setElAttributes(el, (0, _obj.assign)(attributes, {
	          id: this.options_.techId,
	          'class': 'vjs-tech'
	        }));
	      }
	
	      el.playerId = this.options_.playerId;
	    }
	
	    if (typeof this.options_.preload !== 'undefined') {
	      Dom.setAttribute(el, 'preload', this.options_.preload);
	    }
	
	    // Update specific tag settings, in case they were overridden
	    // `autoplay` has to be *last* so that `muted` and `playsinline` are present
	    // when iOS/Safari or other browsers attempt to autoplay.
	    var settingsAttrs = ['loop', 'muted', 'playsinline', 'autoplay'];
	
	    for (var i = settingsAttrs.length - 1; i >= 0; i--) {
	      var attr = settingsAttrs[i];
	      var value = this.options_[attr];
	
	      if (typeof value !== 'undefined') {
	        if (value) {
	          Dom.setAttribute(el, attr, attr);
	        } else {
	          Dom.removeAttribute(el, attr);
	        }
	        el[attr] = value;
	      }
	    }
	
	    return el;
	  };
	
	  /**
	   * This will be triggered if the loadstart event has already fired, before videojs was
	   * ready. Two known examples of when this can happen are:
	   * 1. If we're loading the playback object after it has started loading
	   * 2. The media is already playing the (often with autoplay on) then
	   *
	   * This function will fire another loadstart so that videojs can catchup.
	   *
	   * @fires Tech#loadstart
	   *
	   * @return {undefined}
	   *         returns nothing.
	   */
	
	
	  Html5.prototype.handleLateInit_ = function handleLateInit_(el) {
	    if (el.networkState === 0 || el.networkState === 3) {
	      // The video element hasn't started loading the source yet
	      // or didn't find a source
	      return;
	    }
	
	    if (el.readyState === 0) {
	      // NetworkState is set synchronously BUT loadstart is fired at the
	      // end of the current stack, usually before setInterval(fn, 0).
	      // So at this point we know loadstart may have already fired or is
	      // about to fire, and either way the player hasn't seen it yet.
	      // We don't want to fire loadstart prematurely here and cause a
	      // double loadstart so we'll wait and see if it happens between now
	      // and the next loop, and fire it if not.
	      // HOWEVER, we also want to make sure it fires before loadedmetadata
	      // which could also happen between now and the next loop, so we'll
	      // watch for that also.
	      var loadstartFired = false;
	      var setLoadstartFired = function setLoadstartFired() {
	        loadstartFired = true;
	      };
	
	      this.on('loadstart', setLoadstartFired);
	
	      var triggerLoadstart = function triggerLoadstart() {
	        // We did miss the original loadstart. Make sure the player
	        // sees loadstart before loadedmetadata
	        if (!loadstartFired) {
	          this.trigger('loadstart');
	        }
	      };
	
	      this.on('loadedmetadata', triggerLoadstart);
	
	      this.ready(function () {
	        this.off('loadstart', setLoadstartFired);
	        this.off('loadedmetadata', triggerLoadstart);
	
	        if (!loadstartFired) {
	          // We did miss the original native loadstart. Fire it now.
	          this.trigger('loadstart');
	        }
	      });
	
	      return;
	    }
	
	    // From here on we know that loadstart already fired and we missed it.
	    // The other readyState events aren't as much of a problem if we double
	    // them, so not going to go to as much trouble as loadstart to prevent
	    // that unless we find reason to.
	    var eventsToTrigger = ['loadstart'];
	
	    // loadedmetadata: newly equal to HAVE_METADATA (1) or greater
	    eventsToTrigger.push('loadedmetadata');
	
	    // loadeddata: newly increased to HAVE_CURRENT_DATA (2) or greater
	    if (el.readyState >= 2) {
	      eventsToTrigger.push('loadeddata');
	    }
	
	    // canplay: newly increased to HAVE_FUTURE_DATA (3) or greater
	    if (el.readyState >= 3) {
	      eventsToTrigger.push('canplay');
	    }
	
	    // canplaythrough: newly equal to HAVE_ENOUGH_DATA (4)
	    if (el.readyState >= 4) {
	      eventsToTrigger.push('canplaythrough');
	    }
	
	    // We still need to give the player time to add event listeners
	    this.ready(function () {
	      eventsToTrigger.forEach(function (type) {
	        this.trigger(type);
	      }, this);
	    });
	  };
	
	  /**
	   * Add event listeners to native text track events. This adds the native text tracks
	   * to our emulated {@link TextTrackList}.
	   */
	
	
	  Html5.prototype.proxyNativeTextTracks_ = function proxyNativeTextTracks_() {
	    var tt = this.el().textTracks;
	
	    if (tt) {
	      // Add tracks - if player is initialised after DOM loaded, textTracks
	      // will not trigger addtrack
	      for (var i = 0; i < tt.length; i++) {
	        this.textTracks().addTrack_(tt[i]);
	      }
	
	      if (tt.addEventListener) {
	        tt.addEventListener('change', this.handleTextTrackChange_);
	        tt.addEventListener('addtrack', this.handleTextTrackAdd_);
	        tt.addEventListener('removetrack', this.handleTextTrackRemove_);
	      }
	
	      // Remove (native) texttracks that are not used anymore
	      this.on('loadstart', this.removeOldTextTracks_);
	    }
	  };
	
	  /**
	   * Handle any {@link TextTrackList} `change` event.
	   *
	   * @param {EventTarget~Event} e
	   *        The `change` event that caused this to run.
	   *
	   * @listens TextTrackList#change
	   */
	
	
	  Html5.prototype.handleTextTrackChange = function handleTextTrackChange(e) {
	    var tt = this.textTracks();
	
	    this.textTracks().trigger({
	      type: 'change',
	      target: tt,
	      currentTarget: tt,
	      srcElement: tt
	    });
	  };
	
	  /**
	   * Handle any {@link TextTrackList} `addtrack` event.
	   *
	   * @param {EventTarget~Event} e
	   *        The `addtrack` event that caused this to run.
	   *
	   * @listens TextTrackList#addtrack
	   */
	
	
	  Html5.prototype.handleTextTrackAdd = function handleTextTrackAdd(e) {
	    this.textTracks().addTrack_(e.track);
	  };
	
	  /**
	   * Handle any {@link TextTrackList} `removetrack` event.
	   *
	   * @param {EventTarget~Event} e
	   *        The `removetrack` event that caused this to run.
	   *
	   * @listens TextTrackList#removetrack
	   */
	
	
	  Html5.prototype.handleTextTrackRemove = function handleTextTrackRemove(e) {
	    this.textTracks().removeTrack_(e.track);
	  };
	
	  /**
	   * This function removes any {@link AudioTrack}s, {@link VideoTrack}s, or
	   * {@link TextTrack}s that are not in the media elements TrackList.
	   *
	   * @param {TrackList} techTracks
	   *        HTML5 Tech's TrackList to search through
	   *
	   * @param {TrackList} elTracks
	   *        HTML5 media elements TrackList to search trough.
	   *
	   * @private
	   */
	
	
	  Html5.prototype.removeOldTracks_ = function removeOldTracks_(techTracks, elTracks) {
	    // This will loop over the techTracks and check if they are still used by the HTML5 media element
	    // If not, they will be removed from the emulated list
	    var removeTracks = [];
	
	    if (!elTracks) {
	      return;
	    }
	
	    for (var i = 0; i < techTracks.length; i++) {
	      var techTrack = techTracks[i];
	      var found = false;
	
	      for (var j = 0; j < elTracks.length; j++) {
	        if (elTracks[j] === techTrack) {
	          found = true;
	          break;
	        }
	      }
	
	      if (!found) {
	        removeTracks.push(techTrack);
	      }
	    }
	
	    for (var _i = 0; _i < removeTracks.length; _i++) {
	      var track = removeTracks[_i];
	
	      techTracks.removeTrack_(track);
	    }
	  };
	
	  /**
	   * Remove {@link TextTrack}s that dont exist in the native track list from our
	   * emulated {@link TextTrackList}.
	   *
	   * @listens Tech#loadstart
	   */
	
	
	  Html5.prototype.removeOldTextTracks_ = function removeOldTextTracks_(e) {
	    var techTracks = this.textTracks();
	    var elTracks = this.el().textTracks;
	
	    this.removeOldTracks_(techTracks, elTracks);
	  };
	
	  /**
	   * Called by {@link Player#play} to play using the `Html5` `Tech`.
	   */
	
	
	  Html5.prototype.play = function play() {
	    var playPromise = this.el_.play();
	
	    // Catch/silence error when a pause interrupts a play request
	    // on browsers which return a promise
	    if (playPromise !== undefined && typeof playPromise.then === 'function') {
	      playPromise.then(null, function (e) {});
	    }
	  };
	
	  /**
	   * Set current time for the `HTML5` tech.
	   *
	   * @param {number} seconds
	   *        Set the current time of the media to this.
	   */
	
	
	  Html5.prototype.setCurrentTime = function setCurrentTime(seconds) {
	    try {
	      this.el_.currentTime = seconds;
	    } catch (e) {
	      (0, _log2['default'])(e, 'Video is not ready. (Video.js)');
	      // this.warning(VideoJS.warnings.videoNotReady);
	    }
	  };
	
	  /**
	   * Get the current duration of the HTML5 media element.
	   *
	   * @return {number}
	   *         The duration of the media or 0 if there is no duration.
	   */
	
	
	  Html5.prototype.duration = function duration() {
	    var _this3 = this;
	
	    // Android Chrome will report duration as Infinity for VOD HLS until after
	    // playback has started, which triggers the live display erroneously.
	    // Return NaN if playback has not started and trigger a durationupdate once
	    // the duration can be reliably known.
	    if (this.el_.duration === Infinity && browser.IS_ANDROID && browser.IS_CHROME) {
	      if (this.el_.currentTime === 0) {
	        // Wait for the first `timeupdate` with currentTime > 0 - there may be
	        // several with 0
	        var checkProgress = function checkProgress() {
	          if (_this3.el_.currentTime > 0) {
	            // Trigger durationchange for genuinely live video
	            if (_this3.el_.duration === Infinity) {
	              _this3.trigger('durationchange');
	            }
	            _this3.off('timeupdate', checkProgress);
	          }
	        };
	
	        this.on('timeupdate', checkProgress);
	        return NaN;
	      }
	    }
	    return this.el_.duration || NaN;
	  };
	
	  /**
	   * Get the current width of the HTML5 media element.
	   *
	   * @return {number}
	   *         The width of the HTML5 media element.
	   */
	
	
	  Html5.prototype.width = function width() {
	    return this.el_.offsetWidth;
	  };
	
	  /**
	   * Get the current height of the HTML5 media element.
	   *
	   * @return {number}
	   *         The heigth of the HTML5 media element.
	   */
	
	
	  Html5.prototype.height = function height() {
	    return this.el_.offsetHeight;
	  };
	
	  /**
	   * Proxy iOS `webkitbeginfullscreen` and `webkitendfullscreen` into
	   * `fullscreenchange` event.
	   *
	   * @private
	   * @fires fullscreenchange
	   * @listens webkitendfullscreen
	   * @listens webkitbeginfullscreen
	   * @listens webkitbeginfullscreen
	   */
	
	
	  Html5.prototype.proxyWebkitFullscreen_ = function proxyWebkitFullscreen_() {
	    var _this4 = this;
	
	    if (!('webkitDisplayingFullscreen' in this.el_)) {
	      return;
	    }
	
	    var endFn = function endFn() {
	      this.trigger('fullscreenchange', { isFullscreen: false });
	    };
	
	    var beginFn = function beginFn() {
	      if ('webkitPresentationMode' in this.el_ && this.el_.webkitPresentationMode !== 'picture-in-picture') {
	        this.one('webkitendfullscreen', endFn);
	
	        this.trigger('fullscreenchange', { isFullscreen: true });
	      }
	    };
	
	    this.on('webkitbeginfullscreen', beginFn);
	    this.on('dispose', function () {
	      _this4.off('webkitbeginfullscreen', beginFn);
	      _this4.off('webkitendfullscreen', endFn);
	    });
	  };
	
	  /**
	   * Check if fullscreen is supported on the current playback device.
	   *
	   * @return {boolean}
	   *         - True if fullscreen is supported.
	   *         - False if fullscreen is not supported.
	   */
	
	
	  Html5.prototype.supportsFullScreen = function supportsFullScreen() {
	    if (typeof this.el_.webkitEnterFullScreen === 'function') {
	      var userAgent = _window2['default'].navigator && _window2['default'].navigator.userAgent || '';
	
	      // Seems to be broken in Chromium/Chrome && Safari in Leopard
	      if (/Android/.test(userAgent) || !/Chrome|Mac OS X 10.5/.test(userAgent)) {
	        return true;
	      }
	    }
	    return false;
	  };
	
	  /**
	   * Request that the `HTML5` Tech enter fullscreen.
	   */
	
	
	  Html5.prototype.enterFullScreen = function enterFullScreen() {
	    var video = this.el_;
	
	    if (video.paused && video.networkState <= video.HAVE_METADATA) {
	      // attempt to prime the video element for programmatic access
	      // this isn't necessary on the desktop but shouldn't hurt
	      this.el_.play();
	
	      // playing and pausing synchronously during the transition to fullscreen
	      // can get iOS ~6.1 devices into a play/pause loop
	      this.setTimeout(function () {
	        video.pause();
	        video.webkitEnterFullScreen();
	      }, 0);
	    } else {
	      video.webkitEnterFullScreen();
	    }
	  };
	
	  /**
	   * Request that the `HTML5` Tech exit fullscreen.
	   */
	
	
	  Html5.prototype.exitFullScreen = function exitFullScreen() {
	    this.el_.webkitExitFullScreen();
	  };
	
	  /**
	   * A getter/setter for the `Html5` Tech's source object.
	   * > Note: Please use {@link Html5#setSource}
	   *
	   * @param {Tech~SourceObject} [src]
	   *        The source object you want to set on the `HTML5` techs element.
	   *
	   * @return {Tech~SourceObject|undefined}
	   *         - The current source object when a source is not passed in.
	   *         - undefined when setting
	   *
	   * @deprecated Since version 5.
	   */
	
	
	  Html5.prototype.src = function src(_src) {
	    if (_src === undefined) {
	      return this.el_.src;
	    }
	
	    // Setting src through `src` instead of `setSrc` will be deprecated
	    this.setSrc(_src);
	  };
	
	  /**
	   * Reset the tech by removing all sources and then calling
	   * {@link Html5.resetMediaElement}.
	   */
	
	
	  Html5.prototype.reset = function reset() {
	    Html5.resetMediaElement(this.el_);
	  };
	
	  /**
	   * Get the current source on the `HTML5` Tech. Falls back to returning the source from
	   * the HTML5 media element.
	   *
	   * @return {Tech~SourceObject}
	   *         The current source object from the HTML5 tech. With a fallback to the
	   *         elements source.
	   */
	
	
	  Html5.prototype.currentSrc = function currentSrc() {
	    if (this.currentSource_) {
	      return this.currentSource_.src;
	    }
	    return this.el_.currentSrc;
	  };
	
	  /**
	   * Set controls attribute for the HTML5 media Element.
	   *
	   * @param {string} val
	   *        Value to set the controls attribute to
	   */
	
	
	  Html5.prototype.setControls = function setControls(val) {
	    this.el_.controls = !!val;
	  };
	
	  /**
	   * Create and returns a remote {@link TextTrack} object.
	   *
	   * @param {string} kind
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata)
	   *
	   * @param {string} [label]
	   *        Label to identify the text track
	   *
	   * @param {string} [language]
	   *        Two letter language abbreviation
	   *
	   * @return {TextTrack}
	   *         The TextTrack that gets created.
	   */
	
	
	  Html5.prototype.addTextTrack = function addTextTrack(kind, label, language) {
	    if (!this.featuresNativeTextTracks) {
	      return _Tech.prototype.addTextTrack.call(this, kind, label, language);
	    }
	
	    return this.el_.addTextTrack(kind, label, language);
	  };
	
	  /**
	   * Creates either native TextTrack or an emulated TextTrack depending
	   * on the value of `featuresNativeTextTracks`
	   *
	   * @param {Object} options
	   *        The object should contain the options to intialize the TextTrack with.
	   *
	   * @param {string} [options.kind]
	   *        `TextTrack` kind (subtitles, captions, descriptions, chapters, or metadata).
	   *
	   * @param {string} [options.label].
	   *        Label to identify the text track
	   *
	   * @param {string} [options.language]
	   *        Two letter language abbreviation.
	   *
	   * @param {boolean} [options.default]
	   *        Default this track to on.
	   *
	   * @param {string} [options.id]
	   *        The internal id to assign this track.
	   *
	   * @param {string} [options.src]
	   *        A source url for the track.
	   *
	   * @return {HTMLTrackElement}
	   *         The track element that gets created.
	   */
	
	
	  Html5.prototype.createRemoteTextTrack = function createRemoteTextTrack(options) {
	    if (!this.featuresNativeTextTracks) {
	      return _Tech.prototype.createRemoteTextTrack.call(this, options);
	    }
	    var htmlTrackElement = _document2['default'].createElement('track');
	
	    if (options.kind) {
	      htmlTrackElement.kind = options.kind;
	    }
	    if (options.label) {
	      htmlTrackElement.label = options.label;
	    }
	    if (options.language || options.srclang) {
	      htmlTrackElement.srclang = options.language || options.srclang;
	    }
	    if (options['default']) {
	      htmlTrackElement['default'] = options['default'];
	    }
	    if (options.id) {
	      htmlTrackElement.id = options.id;
	    }
	    if (options.src) {
	      htmlTrackElement.src = options.src;
	    }
	
	    return htmlTrackElement;
	  };
	
	  /**
	   * Creates a remote text track object and returns an html track element.
	   *
	   * @param {Object} options The object should contain values for
	   * kind, language, label, and src (location of the WebVTT file)
	   * @param {Boolean} [manualCleanup=true] if set to false, the TextTrack will be
	   * automatically removed from the video element whenever the source changes
	   * @return {HTMLTrackElement} An Html Track Element.
	   * This can be an emulated {@link HTMLTrackElement} or a native one.
	   * @deprecated The default value of the "manualCleanup" parameter will default
	   * to "false" in upcoming versions of Video.js
	   */
	
	
	  Html5.prototype.addRemoteTextTrack = function addRemoteTextTrack(options, manualCleanup) {
	    var htmlTrackElement = _Tech.prototype.addRemoteTextTrack.call(this, options, manualCleanup);
	
	    if (this.featuresNativeTextTracks) {
	      this.el().appendChild(htmlTrackElement);
	    }
	
	    return htmlTrackElement;
	  };
	
	  /**
	   * Remove remote `TextTrack` from `TextTrackList` object
	   *
	   * @param {TextTrack} track
	   *        `TextTrack` object to remove
	   */
	
	
	  Html5.prototype.removeRemoteTextTrack = function removeRemoteTextTrack(track) {
	    _Tech.prototype.removeRemoteTextTrack.call(this, track);
	
	    if (this.featuresNativeTextTracks) {
	      var tracks = this.$$('track');
	
	      var i = tracks.length;
	
	      while (i--) {
	        if (track === tracks[i] || track === tracks[i].track) {
	          this.el().removeChild(tracks[i]);
	        }
	      }
	    }
	  };
	
	  /**
	   * Gets available media playback quality metrics as specified by the W3C's Media
	   * Playback Quality API.
	   *
	   * @see [Spec]{@link https://wicg.github.io/media-playback-quality}
	   *
	   * @return {Object}
	   *         An object with supported media playback quality metrics
	   */
	
	
	  Html5.prototype.getVideoPlaybackQuality = function getVideoPlaybackQuality() {
	    if (typeof this.el().getVideoPlaybackQuality === 'function') {
	      return this.el().getVideoPlaybackQuality();
	    }
	
	    var videoPlaybackQuality = {};
	
	    if (typeof this.el().webkitDroppedFrameCount !== 'undefined' && typeof this.el().webkitDecodedFrameCount !== 'undefined') {
	      videoPlaybackQuality.droppedVideoFrames = this.el().webkitDroppedFrameCount;
	      videoPlaybackQuality.totalVideoFrames = this.el().webkitDecodedFrameCount;
	    }
	
	    if (_window2['default'].performance && typeof _window2['default'].performance.now === 'function') {
	      videoPlaybackQuality.creationTime = _window2['default'].performance.now();
	    } else if (_window2['default'].performance && _window2['default'].performance.timing && typeof _window2['default'].performance.timing.navigationStart === 'number') {
	      videoPlaybackQuality.creationTime = _window2['default'].Date.now() - _window2['default'].performance.timing.navigationStart;
	    }
	
	    return videoPlaybackQuality;
	  };
	
	  return Html5;
	}(_tech2['default']);
	
	/* HTML5 Support Testing ---------------------------------------------------- */
	
	if (Dom.isReal()) {
	
	  /**
	   * Element for testing browser HTML5 media capabilities
	   *
	   * @type {Element}
	   * @constant
	   * @private
	   */
	  Html5.TEST_VID = _document2['default'].createElement('video');
	  var track = _document2['default'].createElement('track');
	
	  track.kind = 'captions';
	  track.srclang = 'en';
	  track.label = 'English';
	  Html5.TEST_VID.appendChild(track);
	}
	
	/**
	 * Check if HTML5 media is supported by this browser/device.
	 *
	 * @return {boolean}
	 *         - True if HTML5 media is supported.
	 *         - False if HTML5 media is not supported.
	 */
	Html5.isSupported = function () {
	  // IE9 with no Media Player is a LIAR! (#984)
	  try {
	    Html5.TEST_VID.volume = 0.5;
	  } catch (e) {
	    return false;
	  }
	
	  return !!(Html5.TEST_VID && Html5.TEST_VID.canPlayType);
	};
	
	/**
	 * Check if the volume can be changed in this browser/device.
	 * Volume cannot be changed in a lot of mobile devices.
	 * Specifically, it can't be changed from 1 on iOS.
	 *
	 * @return {boolean}
	 *         - True if volume can be controlled
	 *         - False otherwise
	 */
	Html5.canControlVolume = function () {
	  // IE will error if Windows Media Player not installed #3315
	  try {
	    var volume = Html5.TEST_VID.volume;
	
	    Html5.TEST_VID.volume = volume / 2 + 0.1;
	    return volume !== Html5.TEST_VID.volume;
	  } catch (e) {
	    return false;
	  }
	};
	
	/**
	 * Check if the playback rate can be changed in this browser/device.
	 *
	 * @return {boolean}
	 *         - True if playback rate can be controlled
	 *         - False otherwise
	 */
	Html5.canControlPlaybackRate = function () {
	  // Playback rate API is implemented in Android Chrome, but doesn't do anything
	  // https://github.com/videojs/video.js/issues/3180
	  if (browser.IS_ANDROID && browser.IS_CHROME && browser.CHROME_VERSION < 58) {
	    return false;
	  }
	  // IE will error if Windows Media Player not installed #3315
	  try {
	    var playbackRate = Html5.TEST_VID.playbackRate;
	
	    Html5.TEST_VID.playbackRate = playbackRate / 2 + 0.1;
	    return playbackRate !== Html5.TEST_VID.playbackRate;
	  } catch (e) {
	    return false;
	  }
	};
	
	/**
	 * Check to see if native `TextTrack`s are supported by this browser/device.
	 *
	 * @return {boolean}
	 *         - True if native `TextTrack`s are supported.
	 *         - False otherwise
	 */
	Html5.supportsNativeTextTracks = function () {
	  return browser.IS_ANY_SAFARI;
	};
	
	/**
	 * Check to see if native `VideoTrack`s are supported by this browser/device
	 *
	 * @return {boolean}
	 *        - True if native `VideoTrack`s are supported.
	 *        - False otherwise
	 */
	Html5.supportsNativeVideoTracks = function () {
	  return !!(Html5.TEST_VID && Html5.TEST_VID.videoTracks);
	};
	
	/**
	 * Check to see if native `AudioTrack`s are supported by this browser/device
	 *
	 * @return {boolean}
	 *        - True if native `AudioTrack`s are supported.
	 *        - False otherwise
	 */
	Html5.supportsNativeAudioTracks = function () {
	  return !!(Html5.TEST_VID && Html5.TEST_VID.audioTracks);
	};
	
	/**
	 * An array of events available on the Html5 tech.
	 *
	 * @private
	 * @type {Array}
	 */
	Html5.Events = ['loadstart', 'suspend', 'abort', 'error', 'emptied', 'stalled', 'loadedmetadata', 'loadeddata', 'canplay', 'canplaythrough', 'playing', 'waiting', 'seeking', 'seeked', 'ended', 'durationchange', 'timeupdate', 'progress', 'play', 'pause', 'ratechange', 'volumechange'];
	
	/**
	 * Boolean indicating whether the `Tech` supports volume control.
	 *
	 * @type {boolean}
	 * @default {@link Html5.canControlVolume}
	 */
	Html5.prototype.featuresVolumeControl = Html5.canControlVolume();
	
	/**
	 * Boolean indicating whether the `Tech` supports changing the speed at which the media
	 * plays. Examples:
	 *   - Set player to play 2x (twice) as fast
	 *   - Set player to play 0.5x (half) as fast
	 *
	 * @type {boolean}
	 * @default {@link Html5.canControlPlaybackRate}
	 */
	Html5.prototype.featuresPlaybackRate = Html5.canControlPlaybackRate();
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the media element
	 * moving in the DOM. iOS breaks if you move the media element, so this is set this to
	 * false there. Everywhere else this should be true.
	 *
	 * @type {boolean}
	 * @default
	 */
	Html5.prototype.movingMediaElementInDOM = !browser.IS_IOS;
	
	// TODO: Previous comment: No longer appears to be used. Can probably be removed.
	//       Is this true?
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports automatic media resize
	 * when going into fullscreen.
	 *
	 * @type {boolean}
	 * @default
	 */
	Html5.prototype.featuresFullscreenResize = true;
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the progress event.
	 * If this is false, manual `progress` events will be triggred instead.
	 *
	 * @type {boolean}
	 * @default
	 */
	Html5.prototype.featuresProgressEvents = true;
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports the timeupdate event.
	 * If this is false, manual `timeupdate` events will be triggred instead.
	 *
	 * @default
	 */
	Html5.prototype.featuresTimeupdateEvents = true;
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `TextTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeTextTracks}
	 */
	Html5.prototype.featuresNativeTextTracks = Html5.supportsNativeTextTracks();
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `VideoTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeVideoTracks}
	 */
	Html5.prototype.featuresNativeVideoTracks = Html5.supportsNativeVideoTracks();
	
	/**
	 * Boolean indicating whether the `HTML5` tech currently supports native `AudioTrack`s.
	 *
	 * @type {boolean}
	 * @default {@link Html5.supportsNativeAudioTracks}
	 */
	Html5.prototype.featuresNativeAudioTracks = Html5.supportsNativeAudioTracks();
	
	// HTML5 Feature detection and Device Fixes --------------------------------- //
	var canPlayType = Html5.TEST_VID && Html5.TEST_VID.constructor.prototype.canPlayType;
	var mpegurlRE = /^application\/(?:x-|vnd\.apple\.)mpegurl/i;
	var mp4RE = /^video\/mp4/i;
	
	Html5.patchCanPlayType = function () {
	
	  // Android 4.0 and above can play HLS to some extent but it reports being unable to do so
	  if (browser.ANDROID_VERSION >= 4.0 && !browser.IS_FIREFOX) {
	    Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
	      if (type && mpegurlRE.test(type)) {
	        return 'maybe';
	      }
	      return canPlayType.call(this, type);
	    };
	
	    // Override Android 2.2 and less canPlayType method which is broken
	  } else if (browser.IS_OLD_ANDROID) {
	    Html5.TEST_VID.constructor.prototype.canPlayType = function (type) {
	      if (type && mp4RE.test(type)) {
	        return 'maybe';
	      }
	      return canPlayType.call(this, type);
	    };
	  }
	};
	
	Html5.unpatchCanPlayType = function () {
	  var r = Html5.TEST_VID.constructor.prototype.canPlayType;
	
	  Html5.TEST_VID.constructor.prototype.canPlayType = canPlayType;
	  return r;
	};
	
	// by default, patch the media element
	Html5.patchCanPlayType();
	
	Html5.disposeMediaElement = function (el) {
	  if (!el) {
	    return;
	  }
	
	  if (el.parentNode) {
	    el.parentNode.removeChild(el);
	  }
	
	  // remove any child track or source nodes to prevent their loading
	  while (el.hasChildNodes()) {
	    el.removeChild(el.firstChild);
	  }
	
	  // remove any src reference. not setting `src=''` because that causes a warning
	  // in firefox
	  el.removeAttribute('src');
	
	  // force the media element to update its loading state by calling load()
	  // however IE on Windows 7N has a bug that throws an error so need a try/catch (#793)
	  if (typeof el.load === 'function') {
	    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	    (function () {
	      try {
	        el.load();
	      } catch (e) {
	        // not supported
	      }
	    })();
	  }
	};
	
	Html5.resetMediaElement = function (el) {
	  if (!el) {
	    return;
	  }
	
	  var sources = el.querySelectorAll('source');
	  var i = sources.length;
	
	  while (i--) {
	    el.removeChild(sources[i]);
	  }
	
	  // remove any src reference.
	  // not setting `src=''` because that throws an error
	  el.removeAttribute('src');
	
	  if (typeof el.load === 'function') {
	    // wrapping in an iife so it's not deoptimized (#1060#discussion_r10324473)
	    (function () {
	      try {
	        el.load();
	      } catch (e) {
	        // satisfy linter
	      }
	    })();
	  }
	};
	
	/* Native HTML5 element property wrapping ----------------------------------- */
	// Wrap native boolean attributes with getters that check both property and attribute
	// The list is as followed:
	// muted, defaultMuted, autoplay, controls, loop, playsinline
	[
	/**
	 * Get the value of `muted` from the media element. `muted` indicates
	 * that the volume for the media should be set to silent. This does not actually change
	 * the `volume` attribute.
	 *
	 * @method Html5#muted
	 * @return {boolean}
	 *         - True if the value of `volume` should be ignored and the audio set to silent.
	 *         - False if the value of `volume` should be used.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
	 */
	'muted',
	
	/**
	 * Get the value of `defaultMuted` from the media element. `defaultMuted` indicates
	 * whether the media should start muted or not. Only changes the default state of the
	 * media. `muted` and `defaultMuted` can have different values. {@link Html5#muted} indicates the
	 * current state.
	 *
	 * @method Html5#defaultMuted
	 * @return {boolean}
	 *         - The value of `defaultMuted` from the media element.
	 *         - True indicates that the media should start muted.
	 *         - False indicates that the media should not start muted
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
	 */
	'defaultMuted',
	
	/**
	 * Get the value of `autoplay` from the media element. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Html5#autoplay
	 * @return {boolean}
	 *         - The value of `autoplay` from the media element.
	 *         - True indicates that the media should start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
	 */
	'autoplay',
	
	/**
	 * Get the value of `controls` from the media element. `controls` indicates
	 * whether the native media controls should be shown or hidden.
	 *
	 * @method Html5#controls
	 * @return {boolean}
	 *         - The value of `controls` from the media element.
	 *         - True indicates that native controls should be showing.
	 *         - False indicates that native controls should be hidden.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-controls}
	 */
	'controls',
	
	/**
	 * Get the value of `loop` from the media element. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Html5#loop
	 * @return {boolean}
	 *         - The value of `loop` from the media element.
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
	 */
	'loop',
	
	/**
	 * Get the value of `playsinline` from the media element. `playsinline` indicates
	 * to the browser that non-fullscreen playback is preferred when fullscreen
	 * playback is the native default, such as in iOS Safari.
	 *
	 * @method Html5#playsinline
	 * @return {boolean}
	 *         - The value of `playsinline` from the media element.
	 *         - True indicates that the media should play inline.
	 *         - False indicates that the media should not play inline.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	 */
	'playsinline'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop] || this.el_.hasAttribute(prop);
	  };
	});
	
	// Wrap native boolean attributes with setters that set both property and attribute
	// The list is as followed:
	// setMuted, setDefaultMuted, setAutoplay, setLoop, setPlaysinline
	// setControls is special-cased above
	[
	/**
	 * Set the value of `muted` on the media element. `muted` indicates that the current
	 * audio level should be silent.
	 *
	 * @method Html5#setMuted
	 * @param {boolean} muted
	 *        - True if the audio should be set to silent
	 *        - False otherwise
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-muted}
	 */
	'muted',
	
	/**
	 * Set the value of `defaultMuted` on the media element. `defaultMuted` indicates that the current
	 * audio level should be silent, but will only effect the muted level on intial playback..
	 *
	 * @method Html5.prototype.setDefaultMuted
	 * @param {boolean} defaultMuted
	 *        - True if the audio should be set to silent
	 *        - False otherwise
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-defaultmuted}
	 */
	'defaultMuted',
	
	/**
	 * Set the value of `autoplay` on the media element. `autoplay` indicates
	 * that the media should start to play as soon as the page is ready.
	 *
	 * @method Html5#setAutoplay
	 * @param {boolean} autoplay
	 *         - True indicates that the media should start as soon as the page loads.
	 *         - False indicates that the media should not start as soon as the page loads.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-autoplay}
	 */
	'autoplay',
	
	/**
	 * Set the value of `loop` on the media element. `loop` indicates
	 * that the media should return to the start of the media and continue playing once
	 * it reaches the end.
	 *
	 * @method Html5#setLoop
	 * @param {boolean} loop
	 *         - True indicates that playback should seek back to start once
	 *           the end of a media is reached.
	 *         - False indicates that playback should not loop back to the start when the
	 *           end of the media is reached.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-loop}
	 */
	'loop',
	
	/**
	 * Set the value of `playsinline` from the media element. `playsinline` indicates
	 * to the browser that non-fullscreen playback is preferred when fullscreen
	 * playback is the native default, such as in iOS Safari.
	 *
	 * @method Html5#setPlaysinline
	 * @param {boolean} playsinline
	 *         - True indicates that the media should play inline.
	 *         - False indicates that the media should not play inline.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/#attr-video-playsinline}
	 */
	'playsinline'].forEach(function (prop) {
	  Html5.prototype['set' + (0, _toTitleCase2['default'])(prop)] = function (v) {
	    this.el_[prop] = v;
	
	    if (v) {
	      this.el_.setAttribute(prop, prop);
	    } else {
	      this.el_.removeAttribute(prop);
	    }
	  };
	});
	
	// Wrap native properties with a getter
	// The list is as followed
	// paused, currentTime, buffered, volume, poster, preload, error, seeking
	// seekable, ended, playbackRate, defaultPlaybackRate, played, networkState
	// readyState, videoWidth, videoHeight
	[
	/**
	 * Get the value of `paused` from the media element. `paused` indicates whether the media element
	 * is currently paused or not.
	 *
	 * @method Html5#paused
	 * @return {boolean}
	 *         The value of `paused` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-paused}
	 */
	'paused',
	
	/**
	 * Get the value of `currentTime` from the media element. `currentTime` indicates
	 * the current second that the media is at in playback.
	 *
	 * @method Html5#currentTime
	 * @return {number}
	 *         The value of `currentTime` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-currenttime}
	 */
	'currentTime',
	
	/**
	 * Get the value of `buffered` from the media element. `buffered` is a `TimeRange`
	 * object that represents the parts of the media that are already downloaded and
	 * available for playback.
	 *
	 * @method Html5#buffered
	 * @return {TimeRange}
	 *         The value of `buffered` from the media element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-buffered}
	 */
	'buffered',
	
	/**
	 * Get the value of `volume` from the media element. `volume` indicates
	 * the current playback volume of audio for a media. `volume` will be a value from 0
	 * (silent) to 1 (loudest and default).
	 *
	 * @method Html5#volume
	 * @return {number}
	 *         The value of `volume` from the media element. Value will be between 0-1.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
	 */
	'volume',
	
	/**
	 * Get the value of `poster` from the media element. `poster` indicates
	 * that the url of an image file that can/will be shown when no media data is available.
	 *
	 * @method Html5#poster
	 * @return {string}
	 *         The value of `poster` from the media element. Value will be a url to an
	 *         image.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-video-poster}
	 */
	'poster',
	
	/**
	 * Get the value of `preload` from the media element. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Html5#preload
	 * @return {string}
	 *         The value of `preload` from the media element. Will be 'none', 'metadata',
	 *         or 'auto'.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
	 */
	'preload',
	
	/**
	 * Get the value of the `error` from the media element. `error` indicates any
	 * MediaError that may have occured during playback. If error returns null there is no
	 * current error.
	 *
	 * @method Html5#error
	 * @return {MediaError|null}
	 *         The value of `error` from the media element. Will be `MediaError` if there
	 *         is a current error and null otherwise.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-error}
	 */
	'error',
	
	/**
	 * Get the value of `seeking` from the media element. `seeking` indicates whether the
	 * media is currently seeking to a new position or not.
	 *
	 * @method Html5#seeking
	 * @return {boolean}
	 *         - The value of `seeking` from the media element.
	 *         - True indicates that the media is currently seeking to a new position.
	 *         - Flase indicates that the media is not seeking to a new position at this time.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seeking}
	 */
	'seeking',
	
	/**
	 * Get the value of `seekable` from the media element. `seekable` returns a
	 * `TimeRange` object indicating ranges of time that can currently be `seeked` to.
	 *
	 * @method Html5#seekable
	 * @return {TimeRange}
	 *         The value of `seekable` from the media element. A `TimeRange` object
	 *         indicating the current ranges of time that can be seeked to.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-seekable}
	 */
	'seekable',
	
	/**
	 * Get the value of `ended` from the media element. `ended` indicates whether
	 * the media has reached the end or not.
	 *
	 * @method Html5#ended
	 * @return {boolean}
	 *         - The value of `ended` from the media element.
	 *         - True indicates that the media has ended.
	 *         - False indicates that the media has not ended.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-ended}
	 */
	'ended',
	
	/**
	 * Get the value of `playbackRate` from the media element. `playbackRate` indicates
	 * the rate at which the media is currently playing back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5#playbackRate
	 * @return {number}
	 *         The value of `playbackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'playbackRate',
	
	/**
	 * Get the value of `played` from the media element. `played` returns a `TimeRange`
	 * object representing points in the media timeline that have been played.
	 *
	 * @method Html5#played
	 * @return {TimeRange}
	 *         The value of `played` from the media element. A `TimeRange` object indicating
	 *         the ranges of time that have been played.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-played}
	 */
	'played',
	
	/**
	 * Get the value of `networkState` from the media element. `networkState` indicates
	 * the current network state. It returns an enumeration from the following list:
	 * - 0: NETWORK_EMPTY
	 * - 1: NEWORK_IDLE
	 * - 2: NETWORK_LOADING
	 * - 3: NETWORK_NO_SOURCE
	 *
	 * @method Html5#networkState
	 * @return {number}
	 *         The value of `networkState` from the media element. This will be a number
	 *         from the list in the description.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-networkstate}
	 */
	'networkState',
	
	/**
	 * Get the value of `readyState` from the media element. `readyState` indicates
	 * the current state of the media element. It returns an enumeration from the
	 * following list:
	 * - 0: HAVE_NOTHING
	 * - 1: HAVE_METADATA
	 * - 2: HAVE_CURRENT_DATA
	 * - 3: HAVE_FUTURE_DATA
	 * - 4: HAVE_ENOUGH_DATA
	 *
	 * @method Html5#readyState
	 * @return {number}
	 *         The value of `readyState` from the media element. This will be a number
	 *         from the list in the description.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#ready-states}
	 */
	'readyState',
	
	/**
	 * Get the value of `videoWidth` from the video element. `videoWidth` indicates
	 * the current width of the video in css pixels.
	 *
	 * @method Html5#videoWidth
	 * @return {number}
	 *         The value of `videoWidth` from the video element. This will be a number
	 *         in css pixels.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
	 */
	'videoWidth',
	
	/**
	 * Get the value of `videoHeight` from the video element. `videoHeigth` indicates
	 * the current height of the video in css pixels.
	 *
	 * @method Html5#videoHeight
	 * @return {number}
	 *         The value of `videoHeight` from the video element. This will be a number
	 *         in css pixels.
	 *
	 * @see [Spec] {@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-video-videowidth}
	 */
	'videoHeight'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop];
	  };
	});
	
	// Wrap native properties with a setter in this format:
	// set + toTitleCase(name)
	// The list is as follows:
	// setVolume, setSrc, setPoster, setPreload, setPlaybackRate, setDefaultPlaybackRate
	[
	/**
	 * Set the value of `volume` on the media element. `volume` indicates the current
	 * audio level as a percentage in decimal form. This means that 1 is 100%, 0.5 is 50%, and
	 * so on.
	 *
	 * @method Html5#setVolume
	 * @param {number} percentAsDecimal
	 *        The volume percent as a decimal. Valid range is from 0-1.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-a-volume}
	 */
	'volume',
	
	/**
	 * Set the value of `src` on the media element. `src` indicates the current
	 * {@link Tech~SourceObject} for the media.
	 *
	 * @method Html5#setSrc
	 * @param {Tech~SourceObject} src
	 *        The source object to set as the current source.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-src}
	 */
	'src',
	
	/**
	 * Set the value of `poster` on the media element. `poster` is the url to
	 * an image file that can/will be shown when no media data is available.
	 *
	 * @method Html5#setPoster
	 * @param {string} poster
	 *        The url to an image that should be used as the `poster` for the media
	 *        element.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-poster}
	 */
	'poster',
	
	/**
	 * Set the value of `preload` on the media element. `preload` indicates
	 * what should download before the media is interacted with. It can have the following
	 * values:
	 * - none: nothing should be downloaded
	 * - metadata: poster and the first few frames of the media may be downloaded to get
	 *   media dimensions and other metadata
	 * - auto: allow the media and metadata for the media to be downloaded before
	 *    interaction
	 *
	 * @method Html5#setPreload
	 * @param {string} preload
	 *         The value of `preload` to set on the media element. Must be 'none', 'metadata',
	 *         or 'auto'.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#attr-media-preload}
	 */
	'preload',
	
	/**
	 * Set the value of `playbackRate` on the media element. `playbackRate` indicates
	 * the rate at which the media should play back. Examples:
	 *   - if playbackRate is set to 2, media will play twice as fast.
	 *   - if playbackRate is set to 0.5, media will play half as fast.
	 *
	 * @method Html5#setPlaybackRate
	 * @return {number}
	 *         The value of `playbackRate` from the media element. A number indicating
	 *         the current playback speed of the media, where 1 is normal speed.
	 *
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-playbackrate}
	 */
	'playbackRate'].forEach(function (prop) {
	  Html5.prototype['set' + (0, _toTitleCase2['default'])(prop)] = function (v) {
	    this.el_[prop] = v;
	  };
	});
	
	// wrap native functions with a function
	// The list is as follows:
	// pause, load play
	[
	/**
	 * A wrapper around the media elements `pause` function. This will call the `HTML5`
	 * media elements `pause` function.
	 *
	 * @method Html5#pause
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-pause}
	 */
	'pause',
	
	/**
	 * A wrapper around the media elements `load` function. This will call the `HTML5`s
	 * media element `load` function.
	 *
	 * @method Html5#load
	 * @see [Spec]{@link https://www.w3.org/TR/html5/embedded-content-0.html#dom-media-load}
	 */
	'load'].forEach(function (prop) {
	  Html5.prototype[prop] = function () {
	    return this.el_[prop]();
	  };
	});
	
	_tech2['default'].withSourceHandlers(Html5);
	
	/**
	 * Native source handler for Html5, simply passes the source to the media element.
	 *
	 * @proprety {Tech~SourceObject} source
	 *        The source object
	 *
	 * @proprety {Html5} tech
	 *        The instance of the HTML5 tech.
	 */
	Html5.nativeSourceHandler = {};
	
	/**
	 * Check if the media element can play the given mime type.
	 *
	 * @param {string} type
	 *        The mimetype to check
	 *
	 * @return {string}
	 *         'probably', 'maybe', or '' (empty string)
	 */
	Html5.nativeSourceHandler.canPlayType = function (type) {
	  // IE9 on Windows 7 without MediaPlayer throws an error here
	  // https://github.com/videojs/video.js/issues/519
	  try {
	    return Html5.TEST_VID.canPlayType(type);
	  } catch (e) {
	    return '';
	  }
	};
	
	/**
	 * Check if the media element can handle a source natively.
	 *
	 * @param {Tech~SourceObject} source
	 *         The source object
	 *
	 * @param {Object} [options]
	 *         Options to be passed to the tech.
	 *
	 * @return {string}
	 *         'probably', 'maybe', or '' (empty string).
	 */
	Html5.nativeSourceHandler.canHandleSource = function (source, options) {
	
	  // If a type was provided we should rely on that
	  if (source.type) {
	    return Html5.nativeSourceHandler.canPlayType(source.type);
	
	    // If no type, fall back to checking 'video/[EXTENSION]'
	  } else if (source.src) {
	    var ext = Url.getFileExtension(source.src);
	
	    return Html5.nativeSourceHandler.canPlayType('video/' + ext);
	  }
	
	  return '';
	};
	
	/**
	 * Pass the source to the native media element.
	 *
	 * @param {Tech~SourceObject} source
	 *        The source object
	 *
	 * @param {Html5} tech
	 *        The instance of the Html5 tech
	 *
	 * @param {Object} [options]
	 *        The options to pass to the source
	 */
	Html5.nativeSourceHandler.handleSource = function (source, tech, options) {
	  tech.setSrc(source.src);
	};
	
	/**
	 * A noop for the native dispose function, as cleanup is not needed.
	 */
	Html5.nativeSourceHandler.dispose = function () {};
	
	// Register the native source handler
	Html5.registerSourceHandler(Html5.nativeSourceHandler);
	
	_component2['default'].registerComponent('Html5', Html5);
	_tech2['default'].registerTech('Html5', Html5);
	exports['default'] = Html5;


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _tech = __webpack_require__(142);
	
	var _tech2 = _interopRequireDefault(_tech);
	
	var _toTitleCase = __webpack_require__(120);
	
	var _toTitleCase2 = _interopRequireDefault(_toTitleCase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file loader.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The `MediaLoader` is the `Component` that decides which playback technology to load
	 * when a player is initialized.
	 *
	 * @extends Component
	 */
	var MediaLoader = function (_Component) {
	  _inherits(MediaLoader, _Component);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should attach to.
	   *
	   * @param {Object} [options]
	   *        The key/value stroe of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function that is run when this component is ready.
	   */
	  function MediaLoader(player, options, ready) {
	    _classCallCheck(this, MediaLoader);
	
	    // If there are no sources when the player is initialized,
	    // load the first supported playback technology.
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options, ready));
	
	    if (!options.playerOptions.sources || options.playerOptions.sources.length === 0) {
	      for (var i = 0, j = options.playerOptions.techOrder; i < j.length; i++) {
	        var techName = (0, _toTitleCase2['default'])(j[i]);
	        var tech = _tech2['default'].getTech(techName);
	
	        // Support old behavior of techs being registered as components.
	        // Remove once that deprecated behavior is removed.
	        if (!techName) {
	          tech = _component2['default'].getComponent(techName);
	        }
	
	        // Check if the browser supports this technology
	        if (tech && tech.isSupported()) {
	          player.loadTech_(techName);
	          break;
	        }
	      }
	    } else {
	      // Loop through playback technologies (HTML5, Flash) and check for support.
	      // Then load the best source.
	      // A few assumptions here:
	      //   All playback technologies respect preload false.
	      player.src(options.playerOptions.sources);
	    }
	    return _this;
	  }
	
	  return MediaLoader;
	}(_component2['default']);
	
	_component2['default'].registerComponent('MediaLoader', MediaLoader);
	exports['default'] = MediaLoader;


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackEnums = __webpack_require__(266);
	
	var _track = __webpack_require__(268);
	
	var _track2 = _interopRequireDefault(_track);
	
	var _mergeOptions = __webpack_require__(76);
	
	var _mergeOptions2 = _interopRequireDefault(_mergeOptions);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A representation of a single `AudioTrack`. If it is part of an {@link AudioTrackList}
	 * only one `AudioTrack` in the list will be enabled at a time.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#audiotrack}
	 * @extends Track
	 */
	var AudioTrack = function (_Track) {
	  _inherits(AudioTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {AudioTrack~Kind} [options.kind='']
	   *        A valid audio track kind
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {boolean} [options.enabled]
	   *        If this track is the one that is currently playing. If this track is part of
	   *        an {@link AudioTrackList}, only one {@link AudioTrack} will be enabled.
	   */
	  function AudioTrack() {
	    var _this, _ret;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, AudioTrack);
	
	    var settings = (0, _mergeOptions2['default'])(options, {
	      kind: _trackEnums.AudioTrackKind[options.kind] || ''
	    });
	    // on IE8 this will be a document element
	    // for every other browser this will be a normal object
	    var track = (_this = _possibleConstructorReturn(this, _Track.call(this, settings)), _this);
	    var enabled = false;
	
	    if (browser.IS_IE8) {
	      for (var prop in AudioTrack.prototype) {
	        if (prop !== 'constructor') {
	          track[prop] = AudioTrack.prototype[prop];
	        }
	      }
	    }
	    /**
	     * @member {boolean} enabled
	     *         If this `AudioTrack` is enabled or not. When setting this will
	     *         fire {@link AudioTrack#enabledchange} if the state of enabled is changed.
	     *
	     * @fires VideoTrack#selectedchange
	     */
	    Object.defineProperty(track, 'enabled', {
	      get: function get() {
	        return enabled;
	      },
	      set: function set(newEnabled) {
	        // an invalid or unchanged value
	        if (typeof newEnabled !== 'boolean' || newEnabled === enabled) {
	          return;
	        }
	        enabled = newEnabled;
	
	        /**
	         * An event that fires when enabled changes on this track. This allows
	         * the AudioTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec! Native tracks will do
	         *         this internally without an event.
	         *
	         * @event AudioTrack#enabledchange
	         * @type {EventTarget~Event}
	         */
	        this.trigger('enabledchange');
	      }
	    });
	
	    // if the user sets this track to selected then
	    // set selected to that true value otherwise
	    // we keep it false
	    if (settings.enabled) {
	      track.enabled = settings.enabled;
	    }
	    track.loaded_ = true;
	
	    return _ret = track, _possibleConstructorReturn(_this, _ret);
	  }
	
	  return AudioTrack;
	}(_track2['default']);
	
	exports['default'] = AudioTrack;


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * @file html-track-element-list.js
	                                                                                                                                                           */
	
	/**
	 * The current list of {@link HtmlTrackElement}s.
	 */
	var HtmlTrackElementList = function () {
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {HtmlTrackElement[]} [tracks=[]]
	   *        A list of `HtmlTrackElement` to instantiate the list with.
	   */
	  function HtmlTrackElementList() {
	    var trackElements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    _classCallCheck(this, HtmlTrackElementList);
	
	    var list = this; // eslint-disable-line
	
	    if (browser.IS_IE8) {
	      list = _document2['default'].createElement('custom');
	
	      for (var prop in HtmlTrackElementList.prototype) {
	        if (prop !== 'constructor') {
	          list[prop] = HtmlTrackElementList.prototype[prop];
	        }
	      }
	    }
	
	    list.trackElements_ = [];
	
	    /**
	     * @member {number} length
	     *         The current number of `Track`s in the this Trackist.
	     */
	    Object.defineProperty(list, 'length', {
	      get: function get() {
	        return this.trackElements_.length;
	      }
	    });
	
	    for (var i = 0, length = trackElements.length; i < length; i++) {
	      list.addTrackElement_(trackElements[i]);
	    }
	
	    if (browser.IS_IE8) {
	      return list;
	    }
	  }
	
	  /**
	   * Add an {@link HtmlTrackElement} to the `HtmlTrackElementList`
	   *
	   * @param {HtmlTrackElement} trackElement
	   *        The track element to add to the list.
	   *
	   * @private
	   */
	
	
	  HtmlTrackElementList.prototype.addTrackElement_ = function addTrackElement_(trackElement) {
	    var index = this.trackElements_.length;
	
	    if (!('' + index in this)) {
	      Object.defineProperty(this, index, {
	        get: function get() {
	          return this.trackElements_[index];
	        }
	      });
	    }
	
	    // Do not add duplicate elements
	    if (this.trackElements_.indexOf(trackElement) === -1) {
	      this.trackElements_.push(trackElement);
	    }
	  };
	
	  /**
	   * Get an {@link HtmlTrackElement} from the `HtmlTrackElementList` given an
	   * {@link TextTrack}.
	   *
	   * @param {TextTrack} track
	   *        The track associated with a track element.
	   *
	   * @return {HtmlTrackElement|undefined}
	   *         The track element that was found or undefined.
	   *
	   * @private
	   */
	
	
	  HtmlTrackElementList.prototype.getTrackElementByTrack_ = function getTrackElementByTrack_(track) {
	    var trackElement_ = void 0;
	
	    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
	      if (track === this.trackElements_[i].track) {
	        trackElement_ = this.trackElements_[i];
	
	        break;
	      }
	    }
	
	    return trackElement_;
	  };
	
	  /**
	   * Remove a {@link HtmlTrackElement} from the `HtmlTrackElementList`
	   *
	   * @param {HtmlTrackElement} trackElement
	   *        The track element to remove from the list.
	   *
	   * @private
	   */
	
	
	  HtmlTrackElementList.prototype.removeTrackElement_ = function removeTrackElement_(trackElement) {
	    for (var i = 0, length = this.trackElements_.length; i < length; i++) {
	      if (trackElement === this.trackElements_[i]) {
	        this.trackElements_.splice(i, 1);
	
	        break;
	      }
	    }
	  };
	
	  return HtmlTrackElementList;
	}();
	
	exports['default'] = HtmlTrackElementList;


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	var _eventTarget = __webpack_require__(182);
	
	var _eventTarget2 = _interopRequireDefault(_eventTarget);
	
	var _textTrack = __webpack_require__(265);
	
	var _textTrack2 = _interopRequireDefault(_textTrack);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file html-track-element.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	/**
	 * @typedef {HTMLTrackElement~ReadyState}
	 * @enum {number}
	 */
	var NONE = 0;
	var LOADING = 1;
	var LOADED = 2;
	var ERROR = 3;
	
	/**
	 * A single track represented in the DOM.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#htmltrackelement}
	 * @extends EventTarget
	 */
	
	var HTMLTrackElement = function (_EventTarget) {
	  _inherits(HTMLTrackElement, _EventTarget);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} options={}
	   *        Object of option names and values
	   *
	   * @param {Tech} options.tech
	   *        A reference to the tech that owns this HTMLTrackElement.
	   *
	   * @param {TextTrack~Kind} [options.kind='subtitles']
	   *        A valid text track kind.
	   *
	   * @param {TextTrack~Mode} [options.mode='disabled']
	   *        A valid text track mode.
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this TextTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {string} [options.srclang='']
	   *        A valid two character language code. An alternative, but deprioritized
	   *        vesion of `options.language`
	   *
	   * @param {string} [options.src]
	   *        A url to TextTrack cues.
	   *
	   * @param {boolean} [options.default]
	   *        If this track should default to on or off.
	   */
	  function HTMLTrackElement() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, HTMLTrackElement);
	
	    var _this = _possibleConstructorReturn(this, _EventTarget.call(this));
	
	    var readyState = void 0;
	    var trackElement = _this; // eslint-disable-line
	
	    if (browser.IS_IE8) {
	      trackElement = _document2['default'].createElement('custom');
	
	      for (var prop in HTMLTrackElement.prototype) {
	        if (prop !== 'constructor') {
	          trackElement[prop] = HTMLTrackElement.prototype[prop];
	        }
	      }
	    }
	
	    var track = new _textTrack2['default'](options);
	
	    trackElement.kind = track.kind;
	    trackElement.src = track.src;
	    trackElement.srclang = track.language;
	    trackElement.label = track.label;
	    trackElement['default'] = track['default'];
	
	    /**
	     * @member {HTMLTrackElement~ReadyState} readyState
	     *         The current ready state of the track element.
	     */
	    Object.defineProperty(trackElement, 'readyState', {
	      get: function get() {
	        return readyState;
	      }
	    });
	
	    /**
	     * @member {TextTrack} track
	     *         The underlying TextTrack object.
	     */
	    Object.defineProperty(trackElement, 'track', {
	      get: function get() {
	        return track;
	      }
	    });
	
	    readyState = NONE;
	
	    /**
	     * @listens TextTrack#loadeddata
	     * @fires HTMLTrackElement#load
	     */
	    track.addEventListener('loadeddata', function () {
	      readyState = LOADED;
	
	      trackElement.trigger({
	        type: 'load',
	        target: trackElement
	      });
	    });
	
	    if (browser.IS_IE8) {
	      var _ret;
	
	      return _ret = trackElement, _possibleConstructorReturn(_this, _ret);
	    }
	    return _this;
	  }
	
	  return HTMLTrackElement;
	}(_eventTarget2['default']);
	
	HTMLTrackElement.prototype.allowedEvents_ = {
	  load: 'load'
	};
	
	HTMLTrackElement.NONE = NONE;
	HTMLTrackElement.LOADING = LOADING;
	HTMLTrackElement.LOADED = LOADED;
	HTMLTrackElement.ERROR = ERROR;
	
	exports['default'] = HTMLTrackElement;


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * @file text-track-cue-list.js
	                                                                                                                                                           */
	
	
	/**
	 * @typedef {Object} TextTrackCue
	 *
	 * @property {string} id
	 *           The unique id for this text track cue
	 *
	 * @property {number} startTime
	 *           The start time for this text track cue
	 *
	 * @property {number} endTime
	 *           The end time for this text track cue
	 *
	 * @property {boolean} pauseOnExit
	 *           Pause when the end time is reached if true.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcue}
	 */
	
	/**
	 * A List of TextTrackCues.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttrackcuelist}
	 */
	var TextTrackCueList = function () {
	
	  /**
	   * Create an instance of this class..
	   *
	   * @param {Array} cues
	   *        A list of cues to be initialized with
	   */
	  function TextTrackCueList(cues) {
	    _classCallCheck(this, TextTrackCueList);
	
	    var list = this; // eslint-disable-line
	
	    if (browser.IS_IE8) {
	      list = _document2['default'].createElement('custom');
	
	      for (var prop in TextTrackCueList.prototype) {
	        if (prop !== 'constructor') {
	          list[prop] = TextTrackCueList.prototype[prop];
	        }
	      }
	    }
	
	    TextTrackCueList.prototype.setCues_.call(list, cues);
	
	    /**
	     * @member {number} length
	     *         The current number of `TextTrackCue`s in the TextTrackCueList.
	     */
	    Object.defineProperty(list, 'length', {
	      get: function get() {
	        return this.length_;
	      }
	    });
	
	    if (browser.IS_IE8) {
	      return list;
	    }
	  }
	
	  /**
	   * A setter for cues in this list. Creates getters
	   * an an index for the cues.
	   *
	   * @param {Array} cues
	   *        An array of cues to set
	   *
	   * @private
	   */
	
	
	  TextTrackCueList.prototype.setCues_ = function setCues_(cues) {
	    var oldLength = this.length || 0;
	    var i = 0;
	    var l = cues.length;
	
	    this.cues_ = cues;
	    this.length_ = cues.length;
	
	    var defineProp = function defineProp(index) {
	      if (!('' + index in this)) {
	        Object.defineProperty(this, '' + index, {
	          get: function get() {
	            return this.cues_[index];
	          }
	        });
	      }
	    };
	
	    if (oldLength < l) {
	      i = oldLength;
	
	      for (; i < l; i++) {
	        defineProp.call(this, i);
	      }
	    }
	  };
	
	  /**
	   * Get a `TextTrackCue` that is currently in the `TextTrackCueList` by id.
	   *
	   * @param {string} id
	   *        The id of the cue that should be searched for.
	   *
	   * @return {TextTrackCue|null}
	   *         A single cue or null if none was found.
	   */
	
	
	  TextTrackCueList.prototype.getCueById = function getCueById(id) {
	    var result = null;
	
	    for (var i = 0, l = this.length; i < l; i++) {
	      var cue = this[i];
	
	      if (cue.id === id) {
	        result = cue;
	        break;
	      }
	    }
	
	    return result;
	  };
	
	  return TextTrackCueList;
	}();
	
	exports['default'] = TextTrackCueList;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file text-track-display.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var darkGray = '#222';
	var lightGray = '#ccc';
	var fontMap = {
	  monospace: 'monospace',
	  sansSerif: 'sans-serif',
	  serif: 'serif',
	  monospaceSansSerif: '"Andale Mono", "Lucida Console", monospace',
	  monospaceSerif: '"Courier New", monospace',
	  proportionalSansSerif: 'sans-serif',
	  proportionalSerif: 'serif',
	  casual: '"Comic Sans MS", Impact, fantasy',
	  script: '"Monotype Corsiva", cursive',
	  smallcaps: '"Andale Mono", "Lucida Console", monospace, sans-serif'
	};
	
	/**
	 * Construct an rgba color from a given hex color code.
	 *
	 * @param {number} color
	 *        Hex number for color, like #f0e.
	 *
	 * @param {number} opacity
	 *        Value for opacity, 0.0 - 1.0.
	 *
	 * @return {string}
	 *         The rgba color that was created, like 'rgba(255, 0, 0, 0.3)'.
	 *
	 * @private
	 */
	function constructColor(color, opacity) {
	  return 'rgba(' +
	  // color looks like "#f0e"
	  parseInt(color[1] + color[1], 16) + ',' + parseInt(color[2] + color[2], 16) + ',' + parseInt(color[3] + color[3], 16) + ',' + opacity + ')';
	}
	
	/**
	 * Try to update the style of a DOM element. Some style changes will throw an error,
	 * particularly in IE8. Those should be noops.
	 *
	 * @param {Element} el
	 *        The DOM element to be styled.
	 *
	 * @param {string} style
	 *        The CSS property on the element that should be styled.
	 *
	 * @param {string} rule
	 *        The style rule that should be applied to the property.
	 */
	function tryUpdateStyle(el, style, rule) {
	  try {
	    el.style[style] = rule;
	  } catch (e) {
	
	    // Satisfies linter.
	    return;
	  }
	}
	
	/**
	 * The component for displaying text track cues.
	 *
	 * @extends Component
	 */
	
	var TextTrackDisplay = function (_Component) {
	  _inherits(TextTrackDisplay, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *        The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *        The key/value store of player options.
	   *
	   * @param {Component~ReadyCallback} [ready]
	   *        The function to call when `TextTrackDisplay` is ready.
	   */
	  function TextTrackDisplay(player, options, ready) {
	    _classCallCheck(this, TextTrackDisplay);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options, ready));
	
	    player.on('loadstart', Fn.bind(_this, _this.toggleDisplay));
	    player.on('texttrackchange', Fn.bind(_this, _this.updateDisplay));
	
	    // This used to be called during player init, but was causing an error
	    // if a track should show by default and the display hadn't loaded yet.
	    // Should probably be moved to an external track loader when we support
	    // tracks that don't need a display.
	    player.ready(Fn.bind(_this, function () {
	      if (player.tech_ && player.tech_.featuresNativeTextTracks) {
	        this.hide();
	        return;
	      }
	
	      player.on('fullscreenchange', Fn.bind(this, this.updateDisplay));
	
	      var tracks = this.options_.playerOptions.tracks || [];
	
	      for (var i = 0; i < tracks.length; i++) {
	        this.player_.addRemoteTextTrack(tracks[i], true);
	      }
	
	      var modes = { captions: 1, subtitles: 1 };
	      var trackList = this.player_.textTracks();
	      var firstDesc = void 0;
	      var firstCaptions = void 0;
	
	      if (trackList) {
	        for (var _i = 0; _i < trackList.length; _i++) {
	          var track = trackList[_i];
	
	          if (track['default']) {
	            if (track.kind === 'descriptions' && !firstDesc) {
	              firstDesc = track;
	            } else if (track.kind in modes && !firstCaptions) {
	              firstCaptions = track;
	            }
	          }
	        }
	
	        // We want to show the first default track but captions and subtitles
	        // take precedence over descriptions.
	        // So, display the first default captions or subtitles track
	        // and otherwise the first default descriptions track.
	        if (firstCaptions) {
	          firstCaptions.mode = 'showing';
	        } else if (firstDesc) {
	          firstDesc.mode = 'showing';
	        }
	      }
	    }));
	    return _this;
	  }
	
	  /**
	   * Turn display of {@link TextTrack}'s from the current state into the other state.
	   * There are only two states:
	   * - 'shown'
	   * - 'hidden'
	   *
	   * @listens Player#loadstart
	   */
	
	
	  TextTrackDisplay.prototype.toggleDisplay = function toggleDisplay() {
	    if (this.player_.tech_ && this.player_.tech_.featuresNativeTextTracks) {
	      this.hide();
	    } else {
	      this.show();
	    }
	  };
	
	  /**
	   * Create the {@link Component}'s DOM element.
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  TextTrackDisplay.prototype.createEl = function createEl() {
	    return _Component.prototype.createEl.call(this, 'div', {
	      className: 'vjs-text-track-display'
	    }, {
	      'aria-live': 'off',
	      'aria-atomic': 'true'
	    });
	  };
	
	  /**
	   * Clear all displayed {@link TextTrack}s.
	   */
	
	
	  TextTrackDisplay.prototype.clearDisplay = function clearDisplay() {
	    if (typeof _window2['default'].WebVTT === 'function') {
	      _window2['default'].WebVTT.processCues(_window2['default'], [], this.el_);
	    }
	  };
	
	  /**
	   * Update the displayed TextTrack when a either a {@link Player#texttrackchange} or
	   * a {@link Player#fullscreenchange} is fired.
	   *
	   * @listens Player#texttrackchange
	   * @listens Player#fullscreenchange
	   */
	
	
	  TextTrackDisplay.prototype.updateDisplay = function updateDisplay() {
	    var tracks = this.player_.textTracks();
	
	    this.clearDisplay();
	
	    if (!tracks) {
	      return;
	    }
	
	    // Track display prioritization model: if multiple tracks are 'showing',
	    //  display the first 'subtitles' or 'captions' track which is 'showing',
	    //  otherwise display the first 'descriptions' track which is 'showing'
	
	    var descriptionsTrack = null;
	    var captionsSubtitlesTrack = null;
	
	    var i = tracks.length;
	
	    while (i--) {
	      var track = tracks[i];
	
	      if (track.mode === 'showing') {
	        if (track.kind === 'descriptions') {
	          descriptionsTrack = track;
	        } else {
	          captionsSubtitlesTrack = track;
	        }
	      }
	    }
	
	    if (captionsSubtitlesTrack) {
	      if (this.getAttribute('aria-live') !== 'off') {
	        this.setAttribute('aria-live', 'off');
	      }
	      this.updateForTrack(captionsSubtitlesTrack);
	    } else if (descriptionsTrack) {
	      if (this.getAttribute('aria-live') !== 'assertive') {
	        this.setAttribute('aria-live', 'assertive');
	      }
	      this.updateForTrack(descriptionsTrack);
	    }
	  };
	
	  /**
	   * Add an {@link Texttrack} to to the {@link Tech}s {@link TextTrackList}.
	   *
	   * @param {TextTrack} track
	   *        Text track object to be added to the list.
	   */
	
	
	  TextTrackDisplay.prototype.updateForTrack = function updateForTrack(track) {
	    if (typeof _window2['default'].WebVTT !== 'function' || !track.activeCues) {
	      return;
	    }
	
	    var overrides = this.player_.textTrackSettings.getValues();
	    var cues = [];
	
	    for (var _i2 = 0; _i2 < track.activeCues.length; _i2++) {
	      cues.push(track.activeCues[_i2]);
	    }
	
	    _window2['default'].WebVTT.processCues(_window2['default'], cues, this.el_);
	
	    var i = cues.length;
	
	    while (i--) {
	      var cue = cues[i];
	
	      if (!cue) {
	        continue;
	      }
	
	      var cueDiv = cue.displayState;
	
	      if (overrides.color) {
	        cueDiv.firstChild.style.color = overrides.color;
	      }
	      if (overrides.textOpacity) {
	        tryUpdateStyle(cueDiv.firstChild, 'color', constructColor(overrides.color || '#fff', overrides.textOpacity));
	      }
	      if (overrides.backgroundColor) {
	        cueDiv.firstChild.style.backgroundColor = overrides.backgroundColor;
	      }
	      if (overrides.backgroundOpacity) {
	        tryUpdateStyle(cueDiv.firstChild, 'backgroundColor', constructColor(overrides.backgroundColor || '#000', overrides.backgroundOpacity));
	      }
	      if (overrides.windowColor) {
	        if (overrides.windowOpacity) {
	          tryUpdateStyle(cueDiv, 'backgroundColor', constructColor(overrides.windowColor, overrides.windowOpacity));
	        } else {
	          cueDiv.style.backgroundColor = overrides.windowColor;
	        }
	      }
	      if (overrides.edgeStyle) {
	        if (overrides.edgeStyle === 'dropshadow') {
	          cueDiv.firstChild.style.textShadow = '2px 2px 3px ' + darkGray + ', 2px 2px 4px ' + darkGray + ', 2px 2px 5px ' + darkGray;
	        } else if (overrides.edgeStyle === 'raised') {
	          cueDiv.firstChild.style.textShadow = '1px 1px ' + darkGray + ', 2px 2px ' + darkGray + ', 3px 3px ' + darkGray;
	        } else if (overrides.edgeStyle === 'depressed') {
	          cueDiv.firstChild.style.textShadow = '1px 1px ' + lightGray + ', 0 1px ' + lightGray + ', -1px -1px ' + darkGray + ', 0 -1px ' + darkGray;
	        } else if (overrides.edgeStyle === 'uniform') {
	          cueDiv.firstChild.style.textShadow = '0 0 4px ' + darkGray + ', 0 0 4px ' + darkGray + ', 0 0 4px ' + darkGray + ', 0 0 4px ' + darkGray;
	        }
	      }
	      if (overrides.fontPercent && overrides.fontPercent !== 1) {
	        var fontSize = _window2['default'].parseFloat(cueDiv.style.fontSize);
	
	        cueDiv.style.fontSize = fontSize * overrides.fontPercent + 'px';
	        cueDiv.style.height = 'auto';
	        cueDiv.style.top = 'auto';
	        cueDiv.style.bottom = '2px';
	      }
	      if (overrides.fontFamily && overrides.fontFamily !== 'default') {
	        if (overrides.fontFamily === 'small-caps') {
	          cueDiv.firstChild.style.fontVariant = 'small-caps';
	        } else {
	          cueDiv.firstChild.style.fontFamily = fontMap[overrides.fontFamily];
	        }
	      }
	    }
	  };
	
	  return TextTrackDisplay;
	}(_component2['default']);
	
	_component2['default'].registerComponent('TextTrackDisplay', TextTrackDisplay);
	exports['default'] = TextTrackDisplay;


/***/ }),
/* 1022 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * @file text-track-list-converter.js Utilities for capturing text track state and
	 * re-creating tracks based on a capture.
	 *
	 * @module text-track-list-converter
	 */
	
	/**
	 * Examine a single {@link TextTrack} and return a JSON-compatible javascript object that
	 * represents the {@link TextTrack}'s state.
	 *
	 * @param {TextTrack} track
	 *        The text track to query.
	 *
	 * @return {Object}
	 *         A serializable javascript representation of the TextTrack.
	 * @private
	 */
	var trackToJson_ = function trackToJson_(track) {
	  var ret = ['kind', 'label', 'language', 'id', 'inBandMetadataTrackDispatchType', 'mode', 'src'].reduce(function (acc, prop, i) {
	
	    if (track[prop]) {
	      acc[prop] = track[prop];
	    }
	
	    return acc;
	  }, {
	    cues: track.cues && Array.prototype.map.call(track.cues, function (cue) {
	      return {
	        startTime: cue.startTime,
	        endTime: cue.endTime,
	        text: cue.text,
	        id: cue.id
	      };
	    })
	  });
	
	  return ret;
	};
	
	/**
	 * Examine a {@link Tech} and return a JSON-compatible javascript array that represents the
	 * state of all {@link TextTrack}s currently configured. The return array is compatible with
	 * {@link text-track-list-converter:jsonToTextTracks}.
	 *
	 * @param {Tech} tech
	 *        The tech object to query
	 *
	 * @return {Array}
	 *         A serializable javascript representation of the {@link Tech}s
	 *         {@link TextTrackList}.
	 */
	var textTracksToJson = function textTracksToJson(tech) {
	
	  var trackEls = tech.$$('track');
	
	  var trackObjs = Array.prototype.map.call(trackEls, function (t) {
	    return t.track;
	  });
	  var tracks = Array.prototype.map.call(trackEls, function (trackEl) {
	    var json = trackToJson_(trackEl.track);
	
	    if (trackEl.src) {
	      json.src = trackEl.src;
	    }
	    return json;
	  });
	
	  return tracks.concat(Array.prototype.filter.call(tech.textTracks(), function (track) {
	    return trackObjs.indexOf(track) === -1;
	  }).map(trackToJson_));
	};
	
	/**
	 * Create a set of remote {@link TextTrack}s on a {@link Tech} based on an array of javascript
	 * object {@link TextTrack} representations.
	 *
	 * @param {Array} json
	 *        An array of `TextTrack` representation objects, like those that would be
	 *        produced by `textTracksToJson`.
	 *
	 * @param {Tech} tech
	 *        The `Tech` to create the `TextTrack`s on.
	 */
	var jsonToTextTracks = function jsonToTextTracks(json, tech) {
	  json.forEach(function (track) {
	    var addedTrack = tech.addRemoteTextTrack(track).track;
	
	    if (!track.src && track.cues) {
	      track.cues.forEach(function (cue) {
	        return addedTrack.addCue(cue);
	      });
	    }
	  });
	
	  return tech.textTracks();
	};
	
	exports['default'] = { textTracksToJson: textTracksToJson, jsonToTextTracks: jsonToTextTracks, trackToJson_: trackToJson_ };


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackList = __webpack_require__(267);
	
	var _trackList2 = _interopRequireDefault(_trackList);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	var _document = __webpack_require__(24);
	
	var _document2 = _interopRequireDefault(_document);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file text-track-list.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	/**
	 * The current list of {@link TextTrack} for a media file.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#texttracklist}
	 * @extends TrackList
	 */
	var TextTrackList = function (_TrackList) {
	  _inherits(TextTrackList, _TrackList);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {TextTrack[]} [tracks=[]]
	   *        A list of `TextTrack` to instantiate the list with.
	   */
	  function TextTrackList() {
	    var _this, _ret;
	
	    var tracks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	    _classCallCheck(this, TextTrackList);
	
	    var list = void 0;
	
	    // IE8 forces us to implement inheritance ourselves
	    // as it does not support Object.defineProperty properly
	    if (browser.IS_IE8) {
	      list = _document2['default'].createElement('custom');
	      for (var prop in _trackList2['default'].prototype) {
	        if (prop !== 'constructor') {
	          list[prop] = _trackList2['default'].prototype[prop];
	        }
	      }
	      for (var _prop in TextTrackList.prototype) {
	        if (_prop !== 'constructor') {
	          list[_prop] = TextTrackList.prototype[_prop];
	        }
	      }
	    }
	
	    list = (_this = _possibleConstructorReturn(this, _TrackList.call(this, tracks, list)), _this);
	    return _ret = list, _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   * Add a {@link TextTrack} to the `TextTrackList`
	   *
	   * @param {TextTrack} track
	   *        The text track to add to the list.
	   *
	   * @fires TrackList#addtrack
	   * @private
	   */
	
	
	  TextTrackList.prototype.addTrack_ = function addTrack_(track) {
	    _TrackList.prototype.addTrack_.call(this, track);
	
	    /**
	     * @listens TextTrack#modechange
	     * @fires TrackList#change
	     */
	    track.addEventListener('modechange', Fn.bind(this, function () {
	      this.trigger('change');
	    }));
	  };
	
	  return TextTrackList;
	}(_trackList2['default']);
	
	exports['default'] = TextTrackList;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _window = __webpack_require__(26);
	
	var _window2 = _interopRequireDefault(_window);
	
	var _component = __webpack_require__(4);
	
	var _component2 = _interopRequireDefault(_component);
	
	var _dom = __webpack_require__(18);
	
	var _fn = __webpack_require__(12);
	
	var Fn = _interopRequireWildcard(_fn);
	
	var _obj = __webpack_require__(31);
	
	var Obj = _interopRequireWildcard(_obj);
	
	var _log = __webpack_require__(39);
	
	var _log2 = _interopRequireDefault(_log);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file text-track-settings.js
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var LOCAL_STORAGE_KEY = 'vjs-text-track-settings';
	
	var COLOR_BLACK = ['#000', 'Black'];
	var COLOR_BLUE = ['#00F', 'Blue'];
	var COLOR_CYAN = ['#0FF', 'Cyan'];
	var COLOR_GREEN = ['#0F0', 'Green'];
	var COLOR_MAGENTA = ['#F0F', 'Magenta'];
	var COLOR_RED = ['#F00', 'Red'];
	var COLOR_WHITE = ['#FFF', 'White'];
	var COLOR_YELLOW = ['#FF0', 'Yellow'];
	
	var OPACITY_OPAQUE = ['1', 'Opaque'];
	var OPACITY_SEMI = ['0.5', 'Semi-Transparent'];
	var OPACITY_TRANS = ['0', 'Transparent'];
	
	// Configuration for the various <select> elements in the DOM of this component.
	//
	// Possible keys include:
	//
	// `default`:
	//   The default option index. Only needs to be provided if not zero.
	// `parser`:
	//   A function which is used to parse the value from the selected option in
	//   a customized way.
	// `selector`:
	//   The selector used to find the associated <select> element.
	var selectConfigs = {
	  backgroundColor: {
	    selector: '.vjs-bg-color > select',
	    id: 'captions-background-color-%s',
	    label: 'Color',
	    options: [COLOR_BLACK, COLOR_WHITE, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
	  },
	
	  backgroundOpacity: {
	    selector: '.vjs-bg-opacity > select',
	    id: 'captions-background-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_OPAQUE, OPACITY_SEMI, OPACITY_TRANS]
	  },
	
	  color: {
	    selector: '.vjs-fg-color > select',
	    id: 'captions-foreground-color-%s',
	    label: 'Color',
	    options: [COLOR_WHITE, COLOR_BLACK, COLOR_RED, COLOR_GREEN, COLOR_BLUE, COLOR_YELLOW, COLOR_MAGENTA, COLOR_CYAN]
	  },
	
	  edgeStyle: {
	    selector: '.vjs-edge-style > select',
	    id: '%s',
	    label: 'Text Edge Style',
	    options: [['none', 'None'], ['raised', 'Raised'], ['depressed', 'Depressed'], ['uniform', 'Uniform'], ['dropshadow', 'Dropshadow']]
	  },
	
	  fontFamily: {
	    selector: '.vjs-font-family > select',
	    id: 'captions-font-family-%s',
	    label: 'Font Family',
	    options: [['proportionalSansSerif', 'Proportional Sans-Serif'], ['monospaceSansSerif', 'Monospace Sans-Serif'], ['proportionalSerif', 'Proportional Serif'], ['monospaceSerif', 'Monospace Serif'], ['casual', 'Casual'], ['script', 'Script'], ['small-caps', 'Small Caps']]
	  },
	
	  fontPercent: {
	    selector: '.vjs-font-percent > select',
	    id: 'captions-font-size-%s',
	    label: 'Font Size',
	    options: [['0.50', '50%'], ['0.75', '75%'], ['1.00', '100%'], ['1.25', '125%'], ['1.50', '150%'], ['1.75', '175%'], ['2.00', '200%'], ['3.00', '300%'], ['4.00', '400%']],
	    'default': 2,
	    parser: function parser(v) {
	      return v === '1.00' ? null : Number(v);
	    }
	  },
	
	  textOpacity: {
	    selector: '.vjs-text-opacity > select',
	    id: 'captions-foreground-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_OPAQUE, OPACITY_SEMI]
	  },
	
	  // Options for this object are defined below.
	  windowColor: {
	    selector: '.vjs-window-color > select',
	    id: 'captions-window-color-%s',
	    label: 'Color'
	  },
	
	  // Options for this object are defined below.
	  windowOpacity: {
	    selector: '.vjs-window-opacity > select',
	    id: 'captions-window-opacity-%s',
	    label: 'Transparency',
	    options: [OPACITY_TRANS, OPACITY_SEMI, OPACITY_OPAQUE]
	  }
	};
	
	selectConfigs.windowColor.options = selectConfigs.backgroundColor.options;
	
	/**
	 * Get the actual value of an option.
	 *
	 * @param  {string} value
	 *         The value to get
	 *
	 * @param  {Function} [parser]
	 *         Optional function to adjust the value.
	 *
	 * @return {Mixed}
	 *         - Will be `undefined` if no value exists
	 *         - Will be `undefined` if the given value is "none".
	 *         - Will be the actual value otherwise.
	 *
	 * @private
	 */
	function parseOptionValue(value, parser) {
	  if (parser) {
	    value = parser(value);
	  }
	
	  if (value && value !== 'none') {
	    return value;
	  }
	}
	
	/**
	 * Gets the value of the selected <option> element within a <select> element.
	 *
	 * @param  {Element} el
	 *         the element to look in
	 *
	 * @param  {Function} [parser]
	 *         Optional function to adjust the value.
	 *
	 * @return {Mixed}
	 *         - Will be `undefined` if no value exists
	 *         - Will be `undefined` if the given value is "none".
	 *         - Will be the actual value otherwise.
	 *
	 * @private
	 */
	function getSelectedOptionValue(el, parser) {
	  var value = el.options[el.options.selectedIndex].value;
	
	  return parseOptionValue(value, parser);
	}
	
	/**
	 * Sets the selected <option> element within a <select> element based on a
	 * given value.
	 *
	 * @param {Element} el
	 *        The element to look in.
	 *
	 * @param {string} value
	 *        the property to look on.
	 *
	 * @param {Function} [parser]
	 *        Optional function to adjust the value before comparing.
	 *
	 * @private
	 */
	function setSelectedOption(el, value, parser) {
	  if (!value) {
	    return;
	  }
	
	  for (var i = 0; i < el.options.length; i++) {
	    if (parseOptionValue(el.options[i].value, parser) === value) {
	      el.selectedIndex = i;
	      break;
	    }
	  }
	}
	
	/**
	 * Manipulate Text Tracks settings.
	 *
	 * @extends Component
	 */
	
	var TextTrackSettings = function (_Component) {
	  _inherits(TextTrackSettings, _Component);
	
	  /**
	   * Creates an instance of this class.
	   *
	   * @param {Player} player
	   *         The `Player` that this class should be attached to.
	   *
	   * @param {Object} [options]
	   *         The key/value store of player options.
	   */
	  function TextTrackSettings(player, options) {
	    _classCallCheck(this, TextTrackSettings);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, player, options));
	
	    _this.setDefaults();
	    _this.hide();
	
	    _this.updateDisplay = Fn.bind(_this, _this.updateDisplay);
	
	    // Grab `persistTextTrackSettings` from the player options if not passed in child options
	    if (options.persistTextTrackSettings === undefined) {
	      _this.options_.persistTextTrackSettings = _this.options_.playerOptions.persistTextTrackSettings;
	    }
	
	    _this.on(_this.$('.vjs-done-button'), 'click', function () {
	      _this.saveSettings();
	      _this.hide();
	    });
	
	    _this.on(_this.$('.vjs-default-button'), 'click', function () {
	      _this.setDefaults();
	      _this.updateDisplay();
	    });
	
	    Obj.each(selectConfigs, function (config) {
	      _this.on(_this.$(config.selector), 'change', _this.updateDisplay);
	    });
	
	    if (_this.options_.persistTextTrackSettings) {
	      _this.restoreSettings();
	    }
	    return _this;
	  }
	
	  /**
	   * Create a <select> element with configured options.
	   *
	   * @param {string} key
	   *        Configuration key to use during creation.
	   *
	   * @return {Element}
	   *         The DOM element that gets created.
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElSelect_ = function createElSelect_(key) {
	    var _this2 = this;
	
	    var config = selectConfigs[key];
	    var id = config.id.replace('%s', this.id_);
	
	    return [(0, _dom.createEl)('label', {
	      className: 'vjs-label',
	      textContent: config.label
	    }, {
	      'for': id
	    }), (0, _dom.createEl)('select', { id: id }, undefined, config.options.map(function (o) {
	      return (0, _dom.createEl)('option', {
	        textContent: _this2.localize(o[1]),
	        value: o[0]
	      });
	    }))];
	  };
	
	  /**
	   * Create foreground color element for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElFgColor_ = function createElFgColor_() {
	    var legend = (0, _dom.createEl)('legend', {
	      textContent: this.localize('Text')
	    });
	
	    var select = this.createElSelect_('color');
	
	    var opacity = (0, _dom.createEl)('span', {
	      className: 'vjs-text-opacity vjs-opacity'
	    }, undefined, this.createElSelect_('textOpacity'));
	
	    return (0, _dom.createEl)('fieldset', {
	      className: 'vjs-fg-color vjs-tracksetting'
	    }, undefined, [legend].concat(select, opacity));
	  };
	
	  /**
	   * Create background color element for the component
	   *
	   * @return {Element}
	   *         The element that was created
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElBgColor_ = function createElBgColor_() {
	    var legend = (0, _dom.createEl)('legend', {
	      textContent: this.localize('Background')
	    });
	
	    var select = this.createElSelect_('backgroundColor');
	
	    var opacity = (0, _dom.createEl)('span', {
	      className: 'vjs-bg-opacity vjs-opacity'
	    }, undefined, this.createElSelect_('backgroundOpacity'));
	
	    return (0, _dom.createEl)('fieldset', {
	      className: 'vjs-bg-color vjs-tracksetting'
	    }, undefined, [legend].concat(select, opacity));
	  };
	
	  /**
	   * Create window color element for the component
	   *
	   * @return {Element}
	   *         The element that was created
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElWinColor_ = function createElWinColor_() {
	    var legend = (0, _dom.createEl)('legend', {
	      textContent: this.localize('Window')
	    });
	
	    var select = this.createElSelect_('windowColor');
	
	    var opacity = (0, _dom.createEl)('span', {
	      className: 'vjs-window-opacity vjs-opacity'
	    }, undefined, this.createElSelect_('windowOpacity'));
	
	    return (0, _dom.createEl)('fieldset', {
	      className: 'vjs-window-color vjs-tracksetting'
	    }, undefined, [legend].concat(select, opacity));
	  };
	
	  /**
	   * Create color elements for the component
	   *
	   * @return {Element}
	   *         The element that was created
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElColors_ = function createElColors_() {
	    return (0, _dom.createEl)('div', {
	      className: 'vjs-tracksettings-colors'
	    }, undefined, [this.createElFgColor_(), this.createElBgColor_(), this.createElWinColor_()]);
	  };
	
	  /**
	   * Create font elements for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElFont_ = function createElFont_() {
	    var fontPercent = (0, _dom.createEl)('div', {
	      className: 'vjs-font-percent vjs-tracksetting'
	    }, undefined, this.createElSelect_('fontPercent'));
	
	    var edgeStyle = (0, _dom.createEl)('div', {
	      className: 'vjs-edge-style vjs-tracksetting'
	    }, undefined, this.createElSelect_('edgeStyle'));
	
	    var fontFamily = (0, _dom.createEl)('div', {
	      className: 'vjs-font-family vjs-tracksetting'
	    }, undefined, this.createElSelect_('fontFamily'));
	
	    return (0, _dom.createEl)('div', {
	      className: 'vjs-tracksettings-font'
	    }, undefined, [fontPercent, edgeStyle, fontFamily]);
	  };
	
	  /**
	   * Create controls for the component
	   *
	   * @return {Element}
	   *         The element that was created.
	   *
	   * @private
	   */
	
	
	  TextTrackSettings.prototype.createElControls_ = function createElControls_() {
	    var defaultsButton = (0, _dom.createEl)('button', {
	      className: 'vjs-default-button',
	      textContent: this.localize('Defaults')
	    });
	
	    var doneButton = (0, _dom.createEl)('button', {
	      className: 'vjs-done-button',
	      textContent: 'Done'
	    });
	
	    return (0, _dom.createEl)('div', {
	      className: 'vjs-tracksettings-controls'
	    }, undefined, [defaultsButton, doneButton]);
	  };
	
	  /**
	   * Create the component's DOM element
	   *
	   * @return {Element}
	   *         The element that was created.
	   */
	
	
	  TextTrackSettings.prototype.createEl = function createEl() {
	    var settings = (0, _dom.createEl)('div', {
	      className: 'vjs-tracksettings'
	    }, undefined, [this.createElColors_(), this.createElFont_(), this.createElControls_()]);
	
	    var heading = (0, _dom.createEl)('div', {
	      className: 'vjs-control-text',
	      id: 'TTsettingsDialogLabel-' + this.id_,
	      textContent: 'Caption Settings Dialog'
	    }, {
	      'aria-level': '1',
	      'role': 'heading'
	    });
	
	    var description = (0, _dom.createEl)('div', {
	      className: 'vjs-control-text',
	      id: 'TTsettingsDialogDescription-' + this.id_,
	      textContent: 'Beginning of dialog window. Escape will cancel and close the window.'
	    });
	
	    var doc = (0, _dom.createEl)('div', undefined, {
	      role: 'document'
	    }, [heading, description, settings]);
	
	    return (0, _dom.createEl)('div', {
	      className: 'vjs-caption-settings vjs-modal-overlay',
	      tabIndex: -1
	    }, {
	      'role': 'dialog',
	      'aria-labelledby': heading.id,
	      'aria-describedby': description.id
	    }, doc);
	  };
	
	  /**
	   * Gets an object of text track settings (or null).
	   *
	   * @return {Object}
	   *         An object with config values parsed from the DOM or localStorage.
	   */
	
	
	  TextTrackSettings.prototype.getValues = function getValues() {
	    var _this3 = this;
	
	    return Obj.reduce(selectConfigs, function (accum, config, key) {
	      var value = getSelectedOptionValue(_this3.$(config.selector), config.parser);
	
	      if (value !== undefined) {
	        accum[key] = value;
	      }
	
	      return accum;
	    }, {});
	  };
	
	  /**
	   * Sets text track settings from an object of values.
	   *
	   * @param {Object} values
	   *        An object with config values parsed from the DOM or localStorage.
	   */
	
	
	  TextTrackSettings.prototype.setValues = function setValues(values) {
	    var _this4 = this;
	
	    Obj.each(selectConfigs, function (config, key) {
	      setSelectedOption(_this4.$(config.selector), values[key], config.parser);
	    });
	  };
	
	  /**
	   * Sets all <select> elements to their default values.
	   */
	
	
	  TextTrackSettings.prototype.setDefaults = function setDefaults() {
	    var _this5 = this;
	
	    Obj.each(selectConfigs, function (config) {
	      var index = config.hasOwnProperty('default') ? config['default'] : 0;
	
	      _this5.$(config.selector).selectedIndex = index;
	    });
	  };
	
	  /**
	   * Restore texttrack settings from localStorage
	   */
	
	
	  TextTrackSettings.prototype.restoreSettings = function restoreSettings() {
	    var values = void 0;
	
	    try {
	      values = JSON.parse(_window2['default'].localStorage.getItem(LOCAL_STORAGE_KEY));
	    } catch (err) {
	      _log2['default'].warn(err);
	    }
	
	    if (values) {
	      this.setValues(values);
	    }
	  };
	
	  /**
	   * Save text track settings to localStorage
	   */
	
	
	  TextTrackSettings.prototype.saveSettings = function saveSettings() {
	    if (!this.options_.persistTextTrackSettings) {
	      return;
	    }
	
	    var values = this.getValues();
	
	    try {
	      if (Object.keys(values).length) {
	        _window2['default'].localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(values));
	      } else {
	        _window2['default'].localStorage.removeItem(LOCAL_STORAGE_KEY);
	      }
	    } catch (err) {
	      _log2['default'].warn(err);
	    }
	  };
	
	  /**
	   * Update display of text track settings
	   */
	
	
	  TextTrackSettings.prototype.updateDisplay = function updateDisplay() {
	    var ttDisplay = this.player_.getChild('textTrackDisplay');
	
	    if (ttDisplay) {
	      ttDisplay.updateDisplay();
	    }
	  };
	
	  return TextTrackSettings;
	}(_component2['default']);
	
	_component2['default'].registerComponent('TextTrackSettings', TextTrackSettings);
	
	exports['default'] = TextTrackSettings;


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _trackEnums = __webpack_require__(266);
	
	var _track = __webpack_require__(268);
	
	var _track2 = _interopRequireDefault(_track);
	
	var _mergeOptions = __webpack_require__(76);
	
	var _mergeOptions2 = _interopRequireDefault(_mergeOptions);
	
	var _browser = __webpack_require__(28);
	
	var browser = _interopRequireWildcard(_browser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * A representation of a single `VideoTrack`.
	 *
	 * @see [Spec]{@link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack}
	 * @extends Track
	 */
	var VideoTrack = function (_Track) {
	  _inherits(VideoTrack, _Track);
	
	  /**
	   * Create an instance of this class.
	   *
	   * @param {Object} [options={}]
	   *        Object of option names and values
	   *
	   * @param {string} [options.kind='']
	   *        A valid {@link VideoTrack~Kind}
	   *
	   * @param {string} [options.id='vjs_track_' + Guid.newGUID()]
	   *        A unique id for this AudioTrack.
	   *
	   * @param {string} [options.label='']
	   *        The menu label for this track.
	   *
	   * @param {string} [options.language='']
	   *        A valid two character language code.
	   *
	   * @param {boolean} [options.selected]
	   *        If this track is the one that is currently playing.
	   */
	  function VideoTrack() {
	    var _this, _ret;
	
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    _classCallCheck(this, VideoTrack);
	
	    var settings = (0, _mergeOptions2['default'])(options, {
	      kind: _trackEnums.VideoTrackKind[options.kind] || ''
	    });
	
	    // on IE8 this will be a document element
	    // for every other browser this will be a normal object
	    var track = (_this = _possibleConstructorReturn(this, _Track.call(this, settings)), _this);
	    var selected = false;
	
	    if (browser.IS_IE8) {
	      for (var prop in VideoTrack.prototype) {
	        if (prop !== 'constructor') {
	          track[prop] = VideoTrack.prototype[prop];
	        }
	      }
	    }
	
	    /**
	     * @member {boolean} selected
	     *         If this `VideoTrack` is selected or not. When setting this will
	     *         fire {@link VideoTrack#selectedchange} if the state of selected changed.
	     *
	     * @fires VideoTrack#selectedchange
	     */
	    Object.defineProperty(track, 'selected', {
	      get: function get() {
	        return selected;
	      },
	      set: function set(newSelected) {
	        // an invalid or unchanged value
	        if (typeof newSelected !== 'boolean' || newSelected === selected) {
	          return;
	        }
	        selected = newSelected;
	
	        /**
	         * An event that fires when selected changes on this track. This allows
	         * the VideoTrackList that holds this track to act accordingly.
	         *
	         * > Note: This is not part of the spec! Native tracks will do
	         *         this internally without an event.
	         *
	         * @event VideoTrack#selectedchange
	         * @type {EventTarget~Event}
	         */
	        this.trigger('selectedchange');
	      }
	    });
	
	    // if the user sets this track to selected then
	    // set selected to that true value otherwise
	    // we keep it false
	    if (settings.selected) {
	      track.selected = settings.selected;
	    }
	
	    return _ret = track, _possibleConstructorReturn(_this, _ret);
	  }
	
	  return VideoTrack;
	}(_track2['default']);
	
	exports['default'] = VideoTrack;


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

	/*! videojs-resolution-switcher - 2015-7-26
	 * Copyright (c) 2016 Kasper Moskwiak
	 * Modified by Pierre Kraft
	 * Licensed under the Apache-2.0 license. */
	
	(function() {
	  /* jshint eqnull: true*/
	  /* global require */
	  'use strict';
	  var videojs = null;
	  if(typeof window.videojs === 'undefined' && "function" === 'function') {
	    videojs = __webpack_require__(270);
	  } else {
	    videojs = window.videojs;
	  }
	
	  (function(window, videojs) {
	
	
	    var defaults = {},
	        videoJsResolutionSwitcher,
	        currentResolution = {}, // stores current resolution
	        menuItemsHolder = {}; // stores menuItems
	
	    function setSourcesSanitized(player, sources, label, customSourcePicker) {
	      currentResolution = {
	        label: label,
	        sources: sources
	      };
	      if(typeof customSourcePicker === 'function'){
	        return customSourcePicker(player, sources, label);
	      }
	      return player.src(sources.map(function(src) {
	        return {src: src.src, type: src.type, res: src.res};
	      }));
	    }
	
	  /*
	   * Resolution menu item
	   */
	  var MenuItem = videojs.getComponent('MenuItem');
	  var ResolutionMenuItem = videojs.extend(MenuItem, {
	    constructor: function(player, options, onClickListener, label){
	      this.onClickListener = onClickListener;
	      this.label = label;
	      // Sets this.player_, this.options_ and initializes the component
	      MenuItem.call(this, player, options);
	      this.src = options.src;
	
	      this.on('click', this.onClick);
	      this.on('touchstart', this.onClick);
	
	      if (options.initialySelected) {
	        this.showAsLabel();
	        this.selected(true);
	
	        this.addClass('vjs-selected');
	      }
	    },
	    showAsLabel: function() {
	      // Change menu button label to the label of this item if the menu button label is provided
	      if(this.label) {
	        this.label.innerHTML = this.options_.label;
	      }
	    },
	    onClick: function(customSourcePicker){
	      this.onClickListener(this);
	      // Remember player state
	      var currentTime = this.player_.currentTime();
	      var isPaused = this.player_.paused();
	      this.showAsLabel();
	
	      // add .current class
	      this.addClass('vjs-selected');
	
	      // Hide bigPlayButton
	      if(!isPaused){
	        this.player_.bigPlayButton.hide();
	      }
	      if(typeof customSourcePicker !== 'function' &&
	        typeof this.options_.customSourcePicker === 'function'){
	        customSourcePicker = this.options_.customSourcePicker;
	      }
	      // Change player source and wait for loadeddata event, then play video
	      // loadedmetadata doesn't work right now for flash.
	      // Probably because of https://github.com/videojs/video-js-swf/issues/124
	      // If player preload is 'none' and then loadeddata not fired. So, we need timeupdate event for seek handle (timeupdate doesn't work properly with flash)
	      var handleSeekEvent = 'loadeddata';
	      if(this.player_.techName_ !== 'Youtube' && this.player_.preload() === 'none' && this.player_.techName_ !== 'Flash') {
	        handleSeekEvent = 'timeupdate';
	      }
	      setSourcesSanitized(this.player_, this.src, this.options_.label, customSourcePicker).one(handleSeekEvent, function() {
	        this.player_.currentTime(currentTime);
	        this.player_.handleTechSeeked_();
	        if(!isPaused){
	          // Start playing and hide loadingSpinner (flash issue ?)
	          this.player_.play().handleTechSeeked_();
	        }
	        this.player_.trigger('resolutionchange');
	        });
	      }
	    });
	
	
	    /*
	     * Resolution menu button
	     */
	     var MenuButton = videojs.getComponent('MenuButton');
	     var ResolutionMenuButton = videojs.extend(MenuButton, {
	       constructor: function(player, options, settings, label){
	        this.sources = options.sources;
	        this.label = label;
	        this.label.innerHTML = options.initialySelectedLabel;
	        // Sets this.player_, this.options_ and initializes the component
	        MenuButton.call(this, player, options, settings);
	        this.controlText('Quality');
	
	        if(settings.dynamicLabel){
	          this.el().appendChild(label);
	        }else{
	          var staticLabel = document.createElement('span');
						videojs.addClass(staticLabel, 'vjs-resolution-button-staticlabel');
	          this.el().appendChild(staticLabel);
	        }
	       },
	       createItems: function(){
	         var menuItems = [];
	         var labels = (this.sources && this.sources.label) || {};
	         var onClickUnselectOthers = function(clickedItem) {
	          menuItems.map(function(item) {
	            item.selected(item === clickedItem);
	            item.removeClass('vjs-selected');
	          });
	         };
	
	         for (var key in labels) {
	           if (labels.hasOwnProperty(key)) {
	            menuItems.push(new ResolutionMenuItem(
	              this.player_,
	              {
	                label: key,
	                src: labels[key],
	                initialySelected: key === this.options_.initialySelectedLabel,
	                customSourcePicker: this.options_.customSourcePicker
	              },
	              onClickUnselectOthers,
	              this.label));
	             // Store menu item for API calls
	             menuItemsHolder[key] = menuItems[menuItems.length - 1];
	            }
	         }
	         return menuItems;
	       }
	     });
	
	    /**
	     * Initialize the plugin.
	     * @param {object} [options] configuration for the plugin
	     */
	    videoJsResolutionSwitcher = function(options) {
	      var settings = videojs.mergeOptions(defaults, options),
	          player = this,
	          label = document.createElement('span'),
	          groupedSrc = {};
	
				videojs.addClass(label, 'vjs-resolution-button-label');
				
	      /**
	       * Updates player sources or returns current source URL
	       * @param   {Array}  [src] array of sources [{src: '', type: '', label: '', res: ''}]
	       * @returns {Object|String|Array} videojs player object if used as setter or current source URL, object, or array of sources
	       */
	      player.updateSrc = function(src){
	        //Return current src if src is not given
	        if(!src){ return player.src(); }
	        // Dispose old resolution menu button before adding new sources
	        if(player.controlBar.resolutionSwitcher){
	          player.controlBar.resolutionSwitcher.dispose();
	          delete player.controlBar.resolutionSwitcher;
	        }
	        //Sort sources
	        src = src.sort(compareResolutions);
	        groupedSrc = bucketSources(src);
	        var choosen = chooseSrc(groupedSrc, src);
	        var menuButton = new ResolutionMenuButton(player, { sources: groupedSrc, initialySelectedLabel: choosen.label , initialySelectedRes: choosen.res , customSourcePicker: settings.customSourcePicker}, settings, label);
					videojs.addClass(menuButton.el(), 'vjs-resolution-button');
	        player.controlBar.resolutionSwitcher = player.controlBar.el_.insertBefore(menuButton.el_, player.controlBar.getChild('fullscreenToggle').el_);
	        player.controlBar.resolutionSwitcher.dispose = function(){
	          this.parentNode.removeChild(this);
	        };
	        return setSourcesSanitized(player, choosen.sources, choosen.label);
	      };
	
	      /**
	       * Returns current resolution or sets one when label is specified
	       * @param {String}   [label]         label name
	       * @param {Function} [customSourcePicker] custom function to choose source. Takes 3 arguments: player, sources, label. Must return player object.
	       * @returns {Object}   current resolution object {label: '', sources: []} if used as getter or player object if used as setter
	       */
	      player.currentResolution = function(label, customSourcePicker){
	        if(label == null) { return currentResolution; }
	        if(menuItemsHolder[label] != null){
	          menuItemsHolder[label].onClick(customSourcePicker);
	        }
	        return player;
	      };
	
	      /**
	       * Returns grouped sources by label, resolution and type
	       * @returns {Object} grouped sources: { label: { key: [] }, res: { key: [] }, type: { key: [] } }
	       */
	      player.getGroupedSrc = function(){
	        return groupedSrc;
	      };
	
	      /**
	       * Method used for sorting list of sources
	       * @param   {Object} a - source object with res property
	       * @param   {Object} b - source object with res property
	       * @returns {Number} result of comparation
	       */
	      function compareResolutions(a, b){
	        if(!a.res || !b.res){ return 0; }
	        return (+b.res)-(+a.res);
	      }
	
	      /**
	       * Group sources by label, resolution and type
	       * @param   {Array}  src Array of sources
	       * @returns {Object} grouped sources: { label: { key: [] }, res: { key: [] }, type: { key: [] } }
	       */
	      function bucketSources(src){
	        var resolutions = {
	          label: {},
	          res: {},
	          type: {}
	        };
	        src.map(function(source) {
	          initResolutionKey(resolutions, 'label', source);
	          initResolutionKey(resolutions, 'res', source);
	          initResolutionKey(resolutions, 'type', source);
	
	          appendSourceToKey(resolutions, 'label', source);
	          appendSourceToKey(resolutions, 'res', source);
	          appendSourceToKey(resolutions, 'type', source);
	        });
	        return resolutions;
	      }
	
	      function initResolutionKey(resolutions, key, source) {
	        if(resolutions[key][source[key]] == null) {
	          resolutions[key][source[key]] = [];
	        }
	      }
	
	      function appendSourceToKey(resolutions, key, source) {
	        resolutions[key][source[key]].push(source);
	      }
	
	      /**
	       * Choose src if option.default is specified
	       * @param   {Object} groupedSrc {res: { key: [] }}
	       * @param   {Array}  src Array of sources sorted by resolution used to find high and low res
	       * @returns {Object} {res: string, sources: []}
	       */
	      function chooseSrc(groupedSrc, src){
	        var selectedRes = settings['default']; // use array access as default is a reserved keyword
	        var selectedLabel = '';
	        if (selectedRes === 'high') {
	          selectedRes = src[0].res;
	          selectedLabel = src[0].label;
	        } else if (selectedRes === 'low' || selectedRes == null || !groupedSrc.res[selectedRes]) {
	          // Select low-res if default is low or not set
	          selectedRes = src[src.length - 1].res;
	          selectedLabel = src[src.length -1].label;
	        } else if (groupedSrc.res[selectedRes]) {
	          selectedLabel = groupedSrc.res[selectedRes][0].label;
	        }
					
	        return {res: selectedRes, label: selectedLabel, sources: groupedSrc.res[selectedRes]};
	      }
				
				function initResolutionForYt(player){
					// Init resolution
					player.tech_.ytPlayer.setPlaybackQuality('default');
					
					// Capture events
					player.tech_.ytPlayer.addEventListener('onPlaybackQualityChange', function(){
						player.trigger('resolutionchange');
					});
					
					// We must wait for play event
					player.one('play', function(){
						var qualities = player.tech_.ytPlayer.getAvailableQualityLevels();
						// Map youtube qualities names
						var _yts = {
							highres: {res: 1080, label: '1080', yt: 'highres'},
							hd1080: {res: 1080, label: '1080', yt: 'hd1080'}, 
							hd720: {res: 720, label: '720', yt: 'hd720'}, 
							large: {res: 480, label: '480', yt: 'large'},
							medium: {res: 360, label: '360', yt: 'medium'}, 
							small: {res: 240, label: '240', yt: 'small'},
							tiny: {res: 144, label: '144', yt: 'tiny'},
							auto: {res: 0, label: 'auto', yt: 'default'}
						};
	
						var _sources = [];
	
						qualities.map(function(q){
							_sources.push({
								src: player.src().src,
								type: player.src().type,
								label: _yts[q].label,
								res: _yts[q].res,
								_yt: _yts[q].yt
							});
						});
	
						groupedSrc = bucketSources(_sources);
	
						// Overwrite defualt sourcePicer function
						var _customSourcePicker = function(_player, _sources, _label){
							player.tech_.ytPlayer.setPlaybackQuality(_sources[0]._yt);
							return player;
						};
	
						var choosen = {label: 'auto', res: 0, sources: groupedSrc.label.auto};
						var menuButton = new ResolutionMenuButton(player, { 
							sources: groupedSrc, 
							initialySelectedLabel: choosen.label, 
							initialySelectedRes: choosen.res, 
							customSourcePicker: _customSourcePicker
						}, settings, label);
	
						menuButton.el().classList.add('vjs-resolution-button');
						player.controlBar.resolutionSwitcher = player.controlBar.addChild(menuButton);
					});
				}
				
				player.ready(function(){
					if(player.options_.sources.length > 1){
						// tech: Html5 and Flash
						// Create resolution switcher for videos form <source> tag inside <video>
						player.updateSrc(player.options_.sources);
					}
					
					if(player.techName_ === 'Youtube'){
						// tech: YouTube
						initResolutionForYt(player);
					}
				});
	
	    };
	
	    // register the plugin
	    videojs.plugin('videoJsResolutionSwitcher', videoJsResolutionSwitcher);
	  })(window, videojs);
	})();


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	// Default exports for Node. Export the extended versions of VTTCue and
	// VTTRegion in Node since we likely want the capability to convert back and
	// forth between JSON. If we don't then it's not that big of a deal since we're
	// off browser.
	
	var window = __webpack_require__(1031);
	
	var vttjs = module.exports = {
	  WebVTT: __webpack_require__(1028),
	  VTTCue: __webpack_require__(1029),
	  VTTRegion: __webpack_require__(1030)
	};
	
	window.vttjs = vttjs;
	window.WebVTT = vttjs.WebVTT;
	
	var cueShim = vttjs.VTTCue;
	var regionShim = vttjs.VTTRegion;
	var nativeVTTCue = window.VTTCue;
	var nativeVTTRegion = window.VTTRegion;
	
	vttjs.shim = function() {
	  window.VTTCue = cueShim;
	  window.VTTRegion = regionShim;
	};
	
	vttjs.restore = function() {
	  window.VTTCue = nativeVTTCue;
	  window.VTTRegion = nativeVTTRegion;
	};
	
	if (!window.VTTCue) {
	  vttjs.shim();
	}


/***/ }),
/* 1028 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/* -*- Mode: Java; tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- */
	/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */
	var _objCreate = Object.create || (function() {
	  function F() {}
	  return function(o) {
	    if (arguments.length !== 1) {
	      throw new Error('Object.create shim only accepts one parameter.');
	    }
	    F.prototype = o;
	    return new F();
	  };
	})();
	
	// Creates a new ParserError object from an errorData object. The errorData
	// object should have default code and message properties. The default message
	// property can be overriden by passing in a message parameter.
	// See ParsingError.Errors below for acceptable errors.
	function ParsingError(errorData, message) {
	  this.name = "ParsingError";
	  this.code = errorData.code;
	  this.message = message || errorData.message;
	}
	ParsingError.prototype = _objCreate(Error.prototype);
	ParsingError.prototype.constructor = ParsingError;
	
	// ParsingError metadata for acceptable ParsingErrors.
	ParsingError.Errors = {
	  BadSignature: {
	    code: 0,
	    message: "Malformed WebVTT signature."
	  },
	  BadTimeStamp: {
	    code: 1,
	    message: "Malformed time stamp."
	  }
	};
	
	// Try to parse input as a time stamp.
	function parseTimeStamp(input) {
	
	  function computeSeconds(h, m, s, f) {
	    return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + (f | 0) / 1000;
	  }
	
	  var m = input.match(/^(\d+):(\d{2})(:\d{2})?\.(\d{3})/);
	  if (!m) {
	    return null;
	  }
	
	  if (m[3]) {
	    // Timestamp takes the form of [hours]:[minutes]:[seconds].[milliseconds]
	    return computeSeconds(m[1], m[2], m[3].replace(":", ""), m[4]);
	  } else if (m[1] > 59) {
	    // Timestamp takes the form of [hours]:[minutes].[milliseconds]
	    // First position is hours as it's over 59.
	    return computeSeconds(m[1], m[2], 0,  m[4]);
	  } else {
	    // Timestamp takes the form of [minutes]:[seconds].[milliseconds]
	    return computeSeconds(0, m[1], m[2], m[4]);
	  }
	}
	
	// A settings object holds key/value pairs and will ignore anything but the first
	// assignment to a specific key.
	function Settings() {
	  this.values = _objCreate(null);
	}
	
	Settings.prototype = {
	  // Only accept the first assignment to any key.
	  set: function(k, v) {
	    if (!this.get(k) && v !== "") {
	      this.values[k] = v;
	    }
	  },
	  // Return the value for a key, or a default value.
	  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
	  // a number of possible default values as properties where 'defaultKey' is
	  // the key of the property that will be chosen; otherwise it's assumed to be
	  // a single value.
	  get: function(k, dflt, defaultKey) {
	    if (defaultKey) {
	      return this.has(k) ? this.values[k] : dflt[defaultKey];
	    }
	    return this.has(k) ? this.values[k] : dflt;
	  },
	  // Check whether we have a value for a key.
	  has: function(k) {
	    return k in this.values;
	  },
	  // Accept a setting if its one of the given alternatives.
	  alt: function(k, v, a) {
	    for (var n = 0; n < a.length; ++n) {
	      if (v === a[n]) {
	        this.set(k, v);
	        break;
	      }
	    }
	  },
	  // Accept a setting if its a valid (signed) integer.
	  integer: function(k, v) {
	    if (/^-?\d+$/.test(v)) { // integer
	      this.set(k, parseInt(v, 10));
	    }
	  },
	  // Accept a setting if its a valid percentage.
	  percent: function(k, v) {
	    var m;
	    if ((m = v.match(/^([\d]{1,3})(\.[\d]*)?%$/))) {
	      v = parseFloat(v);
	      if (v >= 0 && v <= 100) {
	        this.set(k, v);
	        return true;
	      }
	    }
	    return false;
	  }
	};
	
	// Helper function to parse input into groups separated by 'groupDelim', and
	// interprete each group as a key/value pair separated by 'keyValueDelim'.
	function parseOptions(input, callback, keyValueDelim, groupDelim) {
	  var groups = groupDelim ? input.split(groupDelim) : [input];
	  for (var i in groups) {
	    if (typeof groups[i] !== "string") {
	      continue;
	    }
	    var kv = groups[i].split(keyValueDelim);
	    if (kv.length !== 2) {
	      continue;
	    }
	    var k = kv[0];
	    var v = kv[1];
	    callback(k, v);
	  }
	}
	
	function parseCue(input, cue, regionList) {
	  // Remember the original input if we need to throw an error.
	  var oInput = input;
	  // 4.1 WebVTT timestamp
	  function consumeTimeStamp() {
	    var ts = parseTimeStamp(input);
	    if (ts === null) {
	      throw new ParsingError(ParsingError.Errors.BadTimeStamp,
	                            "Malformed timestamp: " + oInput);
	    }
	    // Remove time stamp from input.
	    input = input.replace(/^[^\sa-zA-Z-]+/, "");
	    return ts;
	  }
	
	  // 4.4.2 WebVTT cue settings
	  function consumeCueSettings(input, cue) {
	    var settings = new Settings();
	
	    parseOptions(input, function (k, v) {
	      switch (k) {
	      case "region":
	        // Find the last region we parsed with the same region id.
	        for (var i = regionList.length - 1; i >= 0; i--) {
	          if (regionList[i].id === v) {
	            settings.set(k, regionList[i].region);
	            break;
	          }
	        }
	        break;
	      case "vertical":
	        settings.alt(k, v, ["rl", "lr"]);
	        break;
	      case "line":
	        var vals = v.split(","),
	            vals0 = vals[0];
	        settings.integer(k, vals0);
	        settings.percent(k, vals0) ? settings.set("snapToLines", false) : null;
	        settings.alt(k, vals0, ["auto"]);
	        if (vals.length === 2) {
	          settings.alt("lineAlign", vals[1], ["start", "middle", "end"]);
	        }
	        break;
	      case "position":
	        vals = v.split(",");
	        settings.percent(k, vals[0]);
	        if (vals.length === 2) {
	          settings.alt("positionAlign", vals[1], ["start", "middle", "end"]);
	        }
	        break;
	      case "size":
	        settings.percent(k, v);
	        break;
	      case "align":
	        settings.alt(k, v, ["start", "middle", "end", "left", "right"]);
	        break;
	      }
	    }, /:/, /\s/);
	
	    // Apply default values for any missing fields.
	    cue.region = settings.get("region", null);
	    cue.vertical = settings.get("vertical", "");
	    cue.line = settings.get("line", "auto");
	    cue.lineAlign = settings.get("lineAlign", "start");
	    cue.snapToLines = settings.get("snapToLines", true);
	    cue.size = settings.get("size", 100);
	    cue.align = settings.get("align", "middle");
	    cue.position = settings.get("position", {
	      start: 0,
	      left: 0,
	      middle: 50,
	      end: 100,
	      right: 100
	    }, cue.align);
	    cue.positionAlign = settings.get("positionAlign", {
	      start: "start",
	      left: "start",
	      middle: "middle",
	      end: "end",
	      right: "end"
	    }, cue.align);
	  }
	
	  function skipWhitespace() {
	    input = input.replace(/^\s+/, "");
	  }
	
	  // 4.1 WebVTT cue timings.
	  skipWhitespace();
	  cue.startTime = consumeTimeStamp();   // (1) collect cue start time
	  skipWhitespace();
	  if (input.substr(0, 3) !== "-->") {     // (3) next characters must match "-->"
	    throw new ParsingError(ParsingError.Errors.BadTimeStamp,
	                           "Malformed time stamp (time stamps must be separated by '-->'): " +
	                           oInput);
	  }
	  input = input.substr(3);
	  skipWhitespace();
	  cue.endTime = consumeTimeStamp();     // (5) collect cue end time
	
	  // 4.1 WebVTT cue settings list.
	  skipWhitespace();
	  consumeCueSettings(input, cue);
	}
	
	var ESCAPE = {
	  "&amp;": "&",
	  "&lt;": "<",
	  "&gt;": ">",
	  "&lrm;": "\u200e",
	  "&rlm;": "\u200f",
	  "&nbsp;": "\u00a0"
	};
	
	var TAG_NAME = {
	  c: "span",
	  i: "i",
	  b: "b",
	  u: "u",
	  ruby: "ruby",
	  rt: "rt",
	  v: "span",
	  lang: "span"
	};
	
	var TAG_ANNOTATION = {
	  v: "title",
	  lang: "lang"
	};
	
	var NEEDS_PARENT = {
	  rt: "ruby"
	};
	
	// Parse content into a document fragment.
	function parseContent(window, input) {
	  function nextToken() {
	    // Check for end-of-string.
	    if (!input) {
	      return null;
	    }
	
	    // Consume 'n' characters from the input.
	    function consume(result) {
	      input = input.substr(result.length);
	      return result;
	    }
	
	    var m = input.match(/^([^<]*)(<[^>]*>?)?/);
	    // If there is some text before the next tag, return it, otherwise return
	    // the tag.
	    return consume(m[1] ? m[1] : m[2]);
	  }
	
	  // Unescape a string 's'.
	  function unescape1(e) {
	    return ESCAPE[e];
	  }
	  function unescape(s) {
	    while ((m = s.match(/&(amp|lt|gt|lrm|rlm|nbsp);/))) {
	      s = s.replace(m[0], unescape1);
	    }
	    return s;
	  }
	
	  function shouldAdd(current, element) {
	    return !NEEDS_PARENT[element.localName] ||
	           NEEDS_PARENT[element.localName] === current.localName;
	  }
	
	  // Create an element for this tag.
	  function createElement(type, annotation) {
	    var tagName = TAG_NAME[type];
	    if (!tagName) {
	      return null;
	    }
	    var element = window.document.createElement(tagName);
	    element.localName = tagName;
	    var name = TAG_ANNOTATION[type];
	    if (name && annotation) {
	      element[name] = annotation.trim();
	    }
	    return element;
	  }
	
	  var rootDiv = window.document.createElement("div"),
	      current = rootDiv,
	      t,
	      tagStack = [];
	
	  while ((t = nextToken()) !== null) {
	    if (t[0] === '<') {
	      if (t[1] === "/") {
	        // If the closing tag matches, move back up to the parent node.
	        if (tagStack.length &&
	            tagStack[tagStack.length - 1] === t.substr(2).replace(">", "")) {
	          tagStack.pop();
	          current = current.parentNode;
	        }
	        // Otherwise just ignore the end tag.
	        continue;
	      }
	      var ts = parseTimeStamp(t.substr(1, t.length - 2));
	      var node;
	      if (ts) {
	        // Timestamps are lead nodes as well.
	        node = window.document.createProcessingInstruction("timestamp", ts);
	        current.appendChild(node);
	        continue;
	      }
	      var m = t.match(/^<([^.\s/0-9>]+)(\.[^\s\\>]+)?([^>\\]+)?(\\?)>?$/);
	      // If we can't parse the tag, skip to the next tag.
	      if (!m) {
	        continue;
	      }
	      // Try to construct an element, and ignore the tag if we couldn't.
	      node = createElement(m[1], m[3]);
	      if (!node) {
	        continue;
	      }
	      // Determine if the tag should be added based on the context of where it
	      // is placed in the cuetext.
	      if (!shouldAdd(current, node)) {
	        continue;
	      }
	      // Set the class list (as a list of classes, separated by space).
	      if (m[2]) {
	        node.className = m[2].substr(1).replace('.', ' ');
	      }
	      // Append the node to the current node, and enter the scope of the new
	      // node.
	      tagStack.push(m[1]);
	      current.appendChild(node);
	      current = node;
	      continue;
	    }
	
	    // Text nodes are leaf nodes.
	    current.appendChild(window.document.createTextNode(unescape(t)));
	  }
	
	  return rootDiv;
	}
	
	// This is a list of all the Unicode characters that have a strong
	// right-to-left category. What this means is that these characters are
	// written right-to-left for sure. It was generated by pulling all the strong
	// right-to-left characters out of the Unicode data table. That table can
	// found at: http://www.unicode.org/Public/UNIDATA/UnicodeData.txt
	var strongRTLRanges = [[0x5be, 0x5be], [0x5c0, 0x5c0], [0x5c3, 0x5c3], [0x5c6, 0x5c6],
	 [0x5d0, 0x5ea], [0x5f0, 0x5f4], [0x608, 0x608], [0x60b, 0x60b], [0x60d, 0x60d],
	 [0x61b, 0x61b], [0x61e, 0x64a], [0x66d, 0x66f], [0x671, 0x6d5], [0x6e5, 0x6e6],
	 [0x6ee, 0x6ef], [0x6fa, 0x70d], [0x70f, 0x710], [0x712, 0x72f], [0x74d, 0x7a5],
	 [0x7b1, 0x7b1], [0x7c0, 0x7ea], [0x7f4, 0x7f5], [0x7fa, 0x7fa], [0x800, 0x815],
	 [0x81a, 0x81a], [0x824, 0x824], [0x828, 0x828], [0x830, 0x83e], [0x840, 0x858],
	 [0x85e, 0x85e], [0x8a0, 0x8a0], [0x8a2, 0x8ac], [0x200f, 0x200f],
	 [0xfb1d, 0xfb1d], [0xfb1f, 0xfb28], [0xfb2a, 0xfb36], [0xfb38, 0xfb3c],
	 [0xfb3e, 0xfb3e], [0xfb40, 0xfb41], [0xfb43, 0xfb44], [0xfb46, 0xfbc1],
	 [0xfbd3, 0xfd3d], [0xfd50, 0xfd8f], [0xfd92, 0xfdc7], [0xfdf0, 0xfdfc],
	 [0xfe70, 0xfe74], [0xfe76, 0xfefc], [0x10800, 0x10805], [0x10808, 0x10808],
	 [0x1080a, 0x10835], [0x10837, 0x10838], [0x1083c, 0x1083c], [0x1083f, 0x10855],
	 [0x10857, 0x1085f], [0x10900, 0x1091b], [0x10920, 0x10939], [0x1093f, 0x1093f],
	 [0x10980, 0x109b7], [0x109be, 0x109bf], [0x10a00, 0x10a00], [0x10a10, 0x10a13],
	 [0x10a15, 0x10a17], [0x10a19, 0x10a33], [0x10a40, 0x10a47], [0x10a50, 0x10a58],
	 [0x10a60, 0x10a7f], [0x10b00, 0x10b35], [0x10b40, 0x10b55], [0x10b58, 0x10b72],
	 [0x10b78, 0x10b7f], [0x10c00, 0x10c48], [0x1ee00, 0x1ee03], [0x1ee05, 0x1ee1f],
	 [0x1ee21, 0x1ee22], [0x1ee24, 0x1ee24], [0x1ee27, 0x1ee27], [0x1ee29, 0x1ee32],
	 [0x1ee34, 0x1ee37], [0x1ee39, 0x1ee39], [0x1ee3b, 0x1ee3b], [0x1ee42, 0x1ee42],
	 [0x1ee47, 0x1ee47], [0x1ee49, 0x1ee49], [0x1ee4b, 0x1ee4b], [0x1ee4d, 0x1ee4f],
	 [0x1ee51, 0x1ee52], [0x1ee54, 0x1ee54], [0x1ee57, 0x1ee57], [0x1ee59, 0x1ee59],
	 [0x1ee5b, 0x1ee5b], [0x1ee5d, 0x1ee5d], [0x1ee5f, 0x1ee5f], [0x1ee61, 0x1ee62],
	 [0x1ee64, 0x1ee64], [0x1ee67, 0x1ee6a], [0x1ee6c, 0x1ee72], [0x1ee74, 0x1ee77],
	 [0x1ee79, 0x1ee7c], [0x1ee7e, 0x1ee7e], [0x1ee80, 0x1ee89], [0x1ee8b, 0x1ee9b],
	 [0x1eea1, 0x1eea3], [0x1eea5, 0x1eea9], [0x1eeab, 0x1eebb], [0x10fffd, 0x10fffd]];
	
	function isStrongRTLChar(charCode) {
	  for (var i = 0; i < strongRTLRanges.length; i++) {
	    var currentRange = strongRTLRanges[i];
	    if (charCode >= currentRange[0] && charCode <= currentRange[1]) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function determineBidi(cueDiv) {
	  var nodeStack = [],
	      text = "",
	      charCode;
	
	  if (!cueDiv || !cueDiv.childNodes) {
	    return "ltr";
	  }
	
	  function pushNodes(nodeStack, node) {
	    for (var i = node.childNodes.length - 1; i >= 0; i--) {
	      nodeStack.push(node.childNodes[i]);
	    }
	  }
	
	  function nextTextNode(nodeStack) {
	    if (!nodeStack || !nodeStack.length) {
	      return null;
	    }
	
	    var node = nodeStack.pop(),
	        text = node.textContent || node.innerText;
	    if (text) {
	      // TODO: This should match all unicode type B characters (paragraph
	      // separator characters). See issue #115.
	      var m = text.match(/^.*(\n|\r)/);
	      if (m) {
	        nodeStack.length = 0;
	        return m[0];
	      }
	      return text;
	    }
	    if (node.tagName === "ruby") {
	      return nextTextNode(nodeStack);
	    }
	    if (node.childNodes) {
	      pushNodes(nodeStack, node);
	      return nextTextNode(nodeStack);
	    }
	  }
	
	  pushNodes(nodeStack, cueDiv);
	  while ((text = nextTextNode(nodeStack))) {
	    for (var i = 0; i < text.length; i++) {
	      charCode = text.charCodeAt(i);
	      if (isStrongRTLChar(charCode)) {
	        return "rtl";
	      }
	    }
	  }
	  return "ltr";
	}
	
	function computeLinePos(cue) {
	  if (typeof cue.line === "number" &&
	      (cue.snapToLines || (cue.line >= 0 && cue.line <= 100))) {
	    return cue.line;
	  }
	  if (!cue.track || !cue.track.textTrackList ||
	      !cue.track.textTrackList.mediaElement) {
	    return -1;
	  }
	  var track = cue.track,
	      trackList = track.textTrackList,
	      count = 0;
	  for (var i = 0; i < trackList.length && trackList[i] !== track; i++) {
	    if (trackList[i].mode === "showing") {
	      count++;
	    }
	  }
	  return ++count * -1;
	}
	
	function StyleBox() {
	}
	
	// Apply styles to a div. If there is no div passed then it defaults to the
	// div on 'this'.
	StyleBox.prototype.applyStyles = function(styles, div) {
	  div = div || this.div;
	  for (var prop in styles) {
	    if (styles.hasOwnProperty(prop)) {
	      div.style[prop] = styles[prop];
	    }
	  }
	};
	
	StyleBox.prototype.formatStyle = function(val, unit) {
	  return val === 0 ? 0 : val + unit;
	};
	
	// Constructs the computed display state of the cue (a div). Places the div
	// into the overlay which should be a block level element (usually a div).
	function CueStyleBox(window, cue, styleOptions) {
	  var isIE8 = (/MSIE\s8\.0/).test(navigator.userAgent);
	  var color = "rgba(255, 255, 255, 1)";
	  var backgroundColor = "rgba(0, 0, 0, 0.8)";
	
	  if (isIE8) {
	    color = "rgb(255, 255, 255)";
	    backgroundColor = "rgb(0, 0, 0)";
	  }
	
	  StyleBox.call(this);
	  this.cue = cue;
	
	  // Parse our cue's text into a DOM tree rooted at 'cueDiv'. This div will
	  // have inline positioning and will function as the cue background box.
	  this.cueDiv = parseContent(window, cue.text);
	  var styles = {
	    color: color,
	    backgroundColor: backgroundColor,
	    position: "relative",
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	    display: "inline"
	  };
	
	  if (!isIE8) {
	    styles.writingMode = cue.vertical === "" ? "horizontal-tb"
	                                             : cue.vertical === "lr" ? "vertical-lr"
	                                                                     : "vertical-rl";
	    styles.unicodeBidi = "plaintext";
	  }
	  this.applyStyles(styles, this.cueDiv);
	
	  // Create an absolutely positioned div that will be used to position the cue
	  // div. Note, all WebVTT cue-setting alignments are equivalent to the CSS
	  // mirrors of them except "middle" which is "center" in CSS.
	  this.div = window.document.createElement("div");
	  styles = {
	    textAlign: cue.align === "middle" ? "center" : cue.align,
	    font: styleOptions.font,
	    whiteSpace: "pre-line",
	    position: "absolute"
	  };
	
	  if (!isIE8) {
	    styles.direction = determineBidi(this.cueDiv);
	    styles.writingMode = cue.vertical === "" ? "horizontal-tb"
	                                             : cue.vertical === "lr" ? "vertical-lr"
	                                                                     : "vertical-rl".
	    stylesunicodeBidi =  "plaintext";
	  }
	
	  this.applyStyles(styles);
	
	  this.div.appendChild(this.cueDiv);
	
	  // Calculate the distance from the reference edge of the viewport to the text
	  // position of the cue box. The reference edge will be resolved later when
	  // the box orientation styles are applied.
	  var textPos = 0;
	  switch (cue.positionAlign) {
	  case "start":
	    textPos = cue.position;
	    break;
	  case "middle":
	    textPos = cue.position - (cue.size / 2);
	    break;
	  case "end":
	    textPos = cue.position - cue.size;
	    break;
	  }
	
	  // Horizontal box orientation; textPos is the distance from the left edge of the
	  // area to the left edge of the box and cue.size is the distance extending to
	  // the right from there.
	  if (cue.vertical === "") {
	    this.applyStyles({
	      left:  this.formatStyle(textPos, "%"),
	      width: this.formatStyle(cue.size, "%")
	    });
	  // Vertical box orientation; textPos is the distance from the top edge of the
	  // area to the top edge of the box and cue.size is the height extending
	  // downwards from there.
	  } else {
	    this.applyStyles({
	      top: this.formatStyle(textPos, "%"),
	      height: this.formatStyle(cue.size, "%")
	    });
	  }
	
	  this.move = function(box) {
	    this.applyStyles({
	      top: this.formatStyle(box.top, "px"),
	      bottom: this.formatStyle(box.bottom, "px"),
	      left: this.formatStyle(box.left, "px"),
	      right: this.formatStyle(box.right, "px"),
	      height: this.formatStyle(box.height, "px"),
	      width: this.formatStyle(box.width, "px")
	    });
	  };
	}
	CueStyleBox.prototype = _objCreate(StyleBox.prototype);
	CueStyleBox.prototype.constructor = CueStyleBox;
	
	// Represents the co-ordinates of an Element in a way that we can easily
	// compute things with such as if it overlaps or intersects with another Element.
	// Can initialize it with either a StyleBox or another BoxPosition.
	function BoxPosition(obj) {
	  var isIE8 = (/MSIE\s8\.0/).test(navigator.userAgent);
	
	  // Either a BoxPosition was passed in and we need to copy it, or a StyleBox
	  // was passed in and we need to copy the results of 'getBoundingClientRect'
	  // as the object returned is readonly. All co-ordinate values are in reference
	  // to the viewport origin (top left).
	  var lh, height, width, top;
	  if (obj.div) {
	    height = obj.div.offsetHeight;
	    width = obj.div.offsetWidth;
	    top = obj.div.offsetTop;
	
	    var rects = (rects = obj.div.childNodes) && (rects = rects[0]) &&
	                rects.getClientRects && rects.getClientRects();
	    obj = obj.div.getBoundingClientRect();
	    // In certain cases the outter div will be slightly larger then the sum of
	    // the inner div's lines. This could be due to bold text, etc, on some platforms.
	    // In this case we should get the average line height and use that. This will
	    // result in the desired behaviour.
	    lh = rects ? Math.max((rects[0] && rects[0].height) || 0, obj.height / rects.length)
	               : 0;
	
	  }
	  this.left = obj.left;
	  this.right = obj.right;
	  this.top = obj.top || top;
	  this.height = obj.height || height;
	  this.bottom = obj.bottom || (top + (obj.height || height));
	  this.width = obj.width || width;
	  this.lineHeight = lh !== undefined ? lh : obj.lineHeight;
	
	  if (isIE8 && !this.lineHeight) {
	    this.lineHeight = 13;
	  }
	}
	
	// Move the box along a particular axis. Optionally pass in an amount to move
	// the box. If no amount is passed then the default is the line height of the
	// box.
	BoxPosition.prototype.move = function(axis, toMove) {
	  toMove = toMove !== undefined ? toMove : this.lineHeight;
	  switch (axis) {
	  case "+x":
	    this.left += toMove;
	    this.right += toMove;
	    break;
	  case "-x":
	    this.left -= toMove;
	    this.right -= toMove;
	    break;
	  case "+y":
	    this.top += toMove;
	    this.bottom += toMove;
	    break;
	  case "-y":
	    this.top -= toMove;
	    this.bottom -= toMove;
	    break;
	  }
	};
	
	// Check if this box overlaps another box, b2.
	BoxPosition.prototype.overlaps = function(b2) {
	  return this.left < b2.right &&
	         this.right > b2.left &&
	         this.top < b2.bottom &&
	         this.bottom > b2.top;
	};
	
	// Check if this box overlaps any other boxes in boxes.
	BoxPosition.prototype.overlapsAny = function(boxes) {
	  for (var i = 0; i < boxes.length; i++) {
	    if (this.overlaps(boxes[i])) {
	      return true;
	    }
	  }
	  return false;
	};
	
	// Check if this box is within another box.
	BoxPosition.prototype.within = function(container) {
	  return this.top >= container.top &&
	         this.bottom <= container.bottom &&
	         this.left >= container.left &&
	         this.right <= container.right;
	};
	
	// Check if this box is entirely within the container or it is overlapping
	// on the edge opposite of the axis direction passed. For example, if "+x" is
	// passed and the box is overlapping on the left edge of the container, then
	// return true.
	BoxPosition.prototype.overlapsOppositeAxis = function(container, axis) {
	  switch (axis) {
	  case "+x":
	    return this.left < container.left;
	  case "-x":
	    return this.right > container.right;
	  case "+y":
	    return this.top < container.top;
	  case "-y":
	    return this.bottom > container.bottom;
	  }
	};
	
	// Find the percentage of the area that this box is overlapping with another
	// box.
	BoxPosition.prototype.intersectPercentage = function(b2) {
	  var x = Math.max(0, Math.min(this.right, b2.right) - Math.max(this.left, b2.left)),
	      y = Math.max(0, Math.min(this.bottom, b2.bottom) - Math.max(this.top, b2.top)),
	      intersectArea = x * y;
	  return intersectArea / (this.height * this.width);
	};
	
	// Convert the positions from this box to CSS compatible positions using
	// the reference container's positions. This has to be done because this
	// box's positions are in reference to the viewport origin, whereas, CSS
	// values are in referecne to their respective edges.
	BoxPosition.prototype.toCSSCompatValues = function(reference) {
	  return {
	    top: this.top - reference.top,
	    bottom: reference.bottom - this.bottom,
	    left: this.left - reference.left,
	    right: reference.right - this.right,
	    height: this.height,
	    width: this.width
	  };
	};
	
	// Get an object that represents the box's position without anything extra.
	// Can pass a StyleBox, HTMLElement, or another BoxPositon.
	BoxPosition.getSimpleBoxPosition = function(obj) {
	  var height = obj.div ? obj.div.offsetHeight : obj.tagName ? obj.offsetHeight : 0;
	  var width = obj.div ? obj.div.offsetWidth : obj.tagName ? obj.offsetWidth : 0;
	  var top = obj.div ? obj.div.offsetTop : obj.tagName ? obj.offsetTop : 0;
	
	  obj = obj.div ? obj.div.getBoundingClientRect() :
	                obj.tagName ? obj.getBoundingClientRect() : obj;
	  var ret = {
	    left: obj.left,
	    right: obj.right,
	    top: obj.top || top,
	    height: obj.height || height,
	    bottom: obj.bottom || (top + (obj.height || height)),
	    width: obj.width || width
	  };
	  return ret;
	};
	
	// Move a StyleBox to its specified, or next best, position. The containerBox
	// is the box that contains the StyleBox, such as a div. boxPositions are
	// a list of other boxes that the styleBox can't overlap with.
	function moveBoxToLinePosition(window, styleBox, containerBox, boxPositions) {
	
	  // Find the best position for a cue box, b, on the video. The axis parameter
	  // is a list of axis, the order of which, it will move the box along. For example:
	  // Passing ["+x", "-x"] will move the box first along the x axis in the positive
	  // direction. If it doesn't find a good position for it there it will then move
	  // it along the x axis in the negative direction.
	  function findBestPosition(b, axis) {
	    var bestPosition,
	        specifiedPosition = new BoxPosition(b),
	        percentage = 1; // Highest possible so the first thing we get is better.
	
	    for (var i = 0; i < axis.length; i++) {
	      while (b.overlapsOppositeAxis(containerBox, axis[i]) ||
	             (b.within(containerBox) && b.overlapsAny(boxPositions))) {
	        b.move(axis[i]);
	      }
	      // We found a spot where we aren't overlapping anything. This is our
	      // best position.
	      if (b.within(containerBox)) {
	        return b;
	      }
	      var p = b.intersectPercentage(containerBox);
	      // If we're outside the container box less then we were on our last try
	      // then remember this position as the best position.
	      if (percentage > p) {
	        bestPosition = new BoxPosition(b);
	        percentage = p;
	      }
	      // Reset the box position to the specified position.
	      b = new BoxPosition(specifiedPosition);
	    }
	    return bestPosition || specifiedPosition;
	  }
	
	  var boxPosition = new BoxPosition(styleBox),
	      cue = styleBox.cue,
	      linePos = computeLinePos(cue),
	      axis = [];
	
	  // If we have a line number to align the cue to.
	  if (cue.snapToLines) {
	    var size;
	    switch (cue.vertical) {
	    case "":
	      axis = [ "+y", "-y" ];
	      size = "height";
	      break;
	    case "rl":
	      axis = [ "+x", "-x" ];
	      size = "width";
	      break;
	    case "lr":
	      axis = [ "-x", "+x" ];
	      size = "width";
	      break;
	    }
	
	    var step = boxPosition.lineHeight,
	        position = step * Math.round(linePos),
	        maxPosition = containerBox[size] + step,
	        initialAxis = axis[0];
	
	    // If the specified intial position is greater then the max position then
	    // clamp the box to the amount of steps it would take for the box to
	    // reach the max position.
	    if (Math.abs(position) > maxPosition) {
	      position = position < 0 ? -1 : 1;
	      position *= Math.ceil(maxPosition / step) * step;
	    }
	
	    // If computed line position returns negative then line numbers are
	    // relative to the bottom of the video instead of the top. Therefore, we
	    // need to increase our initial position by the length or width of the
	    // video, depending on the writing direction, and reverse our axis directions.
	    if (linePos < 0) {
	      position += cue.vertical === "" ? containerBox.height : containerBox.width;
	      axis = axis.reverse();
	    }
	
	    // Move the box to the specified position. This may not be its best
	    // position.
	    boxPosition.move(initialAxis, position);
	
	  } else {
	    // If we have a percentage line value for the cue.
	    var calculatedPercentage = (boxPosition.lineHeight / containerBox.height) * 100;
	
	    switch (cue.lineAlign) {
	    case "middle":
	      linePos -= (calculatedPercentage / 2);
	      break;
	    case "end":
	      linePos -= calculatedPercentage;
	      break;
	    }
	
	    // Apply initial line position to the cue box.
	    switch (cue.vertical) {
	    case "":
	      styleBox.applyStyles({
	        top: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    case "rl":
	      styleBox.applyStyles({
	        left: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    case "lr":
	      styleBox.applyStyles({
	        right: styleBox.formatStyle(linePos, "%")
	      });
	      break;
	    }
	
	    axis = [ "+y", "-x", "+x", "-y" ];
	
	    // Get the box position again after we've applied the specified positioning
	    // to it.
	    boxPosition = new BoxPosition(styleBox);
	  }
	
	  var bestPosition = findBestPosition(boxPosition, axis);
	  styleBox.move(bestPosition.toCSSCompatValues(containerBox));
	}
	
	function WebVTT() {
	  // Nothing
	}
	
	// Helper to allow strings to be decoded instead of the default binary utf8 data.
	WebVTT.StringDecoder = function() {
	  return {
	    decode: function(data) {
	      if (!data) {
	        return "";
	      }
	      if (typeof data !== "string") {
	        throw new Error("Error - expected string data.");
	      }
	      return decodeURIComponent(encodeURIComponent(data));
	    }
	  };
	};
	
	WebVTT.convertCueToDOMTree = function(window, cuetext) {
	  if (!window || !cuetext) {
	    return null;
	  }
	  return parseContent(window, cuetext);
	};
	
	var FONT_SIZE_PERCENT = 0.05;
	var FONT_STYLE = "sans-serif";
	var CUE_BACKGROUND_PADDING = "1.5%";
	
	// Runs the processing model over the cues and regions passed to it.
	// @param overlay A block level element (usually a div) that the computed cues
	//                and regions will be placed into.
	WebVTT.processCues = function(window, cues, overlay) {
	  if (!window || !cues || !overlay) {
	    return null;
	  }
	
	  // Remove all previous children.
	  while (overlay.firstChild) {
	    overlay.removeChild(overlay.firstChild);
	  }
	
	  var paddedOverlay = window.document.createElement("div");
	  paddedOverlay.style.position = "absolute";
	  paddedOverlay.style.left = "0";
	  paddedOverlay.style.right = "0";
	  paddedOverlay.style.top = "0";
	  paddedOverlay.style.bottom = "0";
	  paddedOverlay.style.margin = CUE_BACKGROUND_PADDING;
	  overlay.appendChild(paddedOverlay);
	
	  // Determine if we need to compute the display states of the cues. This could
	  // be the case if a cue's state has been changed since the last computation or
	  // if it has not been computed yet.
	  function shouldCompute(cues) {
	    for (var i = 0; i < cues.length; i++) {
	      if (cues[i].hasBeenReset || !cues[i].displayState) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  // We don't need to recompute the cues' display states. Just reuse them.
	  if (!shouldCompute(cues)) {
	    for (var i = 0; i < cues.length; i++) {
	      paddedOverlay.appendChild(cues[i].displayState);
	    }
	    return;
	  }
	
	  var boxPositions = [],
	      containerBox = BoxPosition.getSimpleBoxPosition(paddedOverlay),
	      fontSize = Math.round(containerBox.height * FONT_SIZE_PERCENT * 100) / 100;
	  var styleOptions = {
	    font: fontSize + "px " + FONT_STYLE
	  };
	
	  (function() {
	    var styleBox, cue;
	
	    for (var i = 0; i < cues.length; i++) {
	      cue = cues[i];
	
	      // Compute the intial position and styles of the cue div.
	      styleBox = new CueStyleBox(window, cue, styleOptions);
	      paddedOverlay.appendChild(styleBox.div);
	
	      // Move the cue div to it's correct line position.
	      moveBoxToLinePosition(window, styleBox, containerBox, boxPositions);
	
	      // Remember the computed div so that we don't have to recompute it later
	      // if we don't have too.
	      cue.displayState = styleBox.div;
	
	      boxPositions.push(BoxPosition.getSimpleBoxPosition(styleBox));
	    }
	  })();
	};
	
	WebVTT.Parser = function(window, vttjs, decoder) {
	  if (!decoder) {
	    decoder = vttjs;
	    vttjs = {};
	  }
	  if (!vttjs) {
	    vttjs = {};
	  }
	
	  this.window = window;
	  this.vttjs = vttjs;
	  this.state = "INITIAL";
	  this.buffer = "";
	  this.decoder = decoder || new TextDecoder("utf8");
	  this.regionList = [];
	};
	
	WebVTT.Parser.prototype = {
	  // If the error is a ParsingError then report it to the consumer if
	  // possible. If it's not a ParsingError then throw it like normal.
	  reportOrThrowError: function(e) {
	    if (e instanceof ParsingError) {
	      this.onparsingerror && this.onparsingerror(e);
	    } else {
	      throw e;
	    }
	  },
	  parse: function (data) {
	    var self = this;
	
	    // If there is no data then we won't decode it, but will just try to parse
	    // whatever is in buffer already. This may occur in circumstances, for
	    // example when flush() is called.
	    if (data) {
	      // Try to decode the data that we received.
	      self.buffer += self.decoder.decode(data, {stream: true});
	    }
	
	    function collectNextLine() {
	      var buffer = self.buffer;
	      var pos = 0;
	      while (pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n') {
	        ++pos;
	      }
	      var line = buffer.substr(0, pos);
	      // Advance the buffer early in case we fail below.
	      if (buffer[pos] === '\r') {
	        ++pos;
	      }
	      if (buffer[pos] === '\n') {
	        ++pos;
	      }
	      self.buffer = buffer.substr(pos);
	      return line;
	    }
	
	    // 3.4 WebVTT region and WebVTT region settings syntax
	    function parseRegion(input) {
	      var settings = new Settings();
	
	      parseOptions(input, function (k, v) {
	        switch (k) {
	        case "id":
	          settings.set(k, v);
	          break;
	        case "width":
	          settings.percent(k, v);
	          break;
	        case "lines":
	          settings.integer(k, v);
	          break;
	        case "regionanchor":
	        case "viewportanchor":
	          var xy = v.split(',');
	          if (xy.length !== 2) {
	            break;
	          }
	          // We have to make sure both x and y parse, so use a temporary
	          // settings object here.
	          var anchor = new Settings();
	          anchor.percent("x", xy[0]);
	          anchor.percent("y", xy[1]);
	          if (!anchor.has("x") || !anchor.has("y")) {
	            break;
	          }
	          settings.set(k + "X", anchor.get("x"));
	          settings.set(k + "Y", anchor.get("y"));
	          break;
	        case "scroll":
	          settings.alt(k, v, ["up"]);
	          break;
	        }
	      }, /=/, /\s/);
	
	      // Create the region, using default values for any values that were not
	      // specified.
	      if (settings.has("id")) {
	        var region = new (self.vttjs.VTTRegion || self.window.VTTRegion)();
	        region.width = settings.get("width", 100);
	        region.lines = settings.get("lines", 3);
	        region.regionAnchorX = settings.get("regionanchorX", 0);
	        region.regionAnchorY = settings.get("regionanchorY", 100);
	        region.viewportAnchorX = settings.get("viewportanchorX", 0);
	        region.viewportAnchorY = settings.get("viewportanchorY", 100);
	        region.scroll = settings.get("scroll", "");
	        // Register the region.
	        self.onregion && self.onregion(region);
	        // Remember the VTTRegion for later in case we parse any VTTCues that
	        // reference it.
	        self.regionList.push({
	          id: settings.get("id"),
	          region: region
	        });
	      }
	    }
	
	    // draft-pantos-http-live-streaming-20
	    // https://tools.ietf.org/html/draft-pantos-http-live-streaming-20#section-3.5
	    // 3.5 WebVTT
	    function parseTimestampMap(input) {
	      var settings = new Settings();
	
	      parseOptions(input, function(k, v) {
	        switch(k) {
	        case "MPEGT":
	          settings.integer(k + 'S', v);
	          break;
	        case "LOCA":
	          settings.set(k + 'L', parseTimeStamp(v));
	          break;
	        }
	      }, /[^\d]:/, /,/);
	
	      self.ontimestampmap && self.ontimestampmap({
	        "MPEGTS": settings.get("MPEGTS"),
	        "LOCAL": settings.get("LOCAL")
	      });
	    }
	
	    // 3.2 WebVTT metadata header syntax
	    function parseHeader(input) {
	      if (input.match(/X-TIMESTAMP-MAP/)) {
	        // This line contains HLS X-TIMESTAMP-MAP metadata
	        parseOptions(input, function(k, v) {
	          switch(k) {
	          case "X-TIMESTAMP-MAP":
	            parseTimestampMap(v);
	            break;
	          }
	        }, /=/);
	      } else {
	        parseOptions(input, function (k, v) {
	          switch (k) {
	          case "Region":
	            // 3.3 WebVTT region metadata header syntax
	            parseRegion(v);
	            break;
	          }
	        }, /:/);
	      }
	
	    }
	
	    // 5.1 WebVTT file parsing.
	    try {
	      var line;
	      if (self.state === "INITIAL") {
	        // We can't start parsing until we have the first line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        line = collectNextLine();
	
	        var m = line.match(/^WEBVTT([ \t].*)?$/);
	        if (!m || !m[0]) {
	          throw new ParsingError(ParsingError.Errors.BadSignature);
	        }
	
	        self.state = "HEADER";
	      }
	
	      var alreadyCollectedLine = false;
	      while (self.buffer) {
	        // We can't parse a line until we have the full line.
	        if (!/\r\n|\n/.test(self.buffer)) {
	          return this;
	        }
	
	        if (!alreadyCollectedLine) {
	          line = collectNextLine();
	        } else {
	          alreadyCollectedLine = false;
	        }
	
	        switch (self.state) {
	        case "HEADER":
	          // 13-18 - Allow a header (metadata) under the WEBVTT line.
	          if (/:/.test(line)) {
	            parseHeader(line);
	          } else if (!line) {
	            // An empty line terminates the header and starts the body (cues).
	            self.state = "ID";
	          }
	          continue;
	        case "NOTE":
	          // Ignore NOTE blocks.
	          if (!line) {
	            self.state = "ID";
	          }
	          continue;
	        case "ID":
	          // Check for the start of NOTE blocks.
	          if (/^NOTE($|[ \t])/.test(line)) {
	            self.state = "NOTE";
	            break;
	          }
	          // 19-29 - Allow any number of line terminators, then initialize new cue values.
	          if (!line) {
	            continue;
	          }
	          self.cue = new (self.vttjs.VTTCue || self.window.VTTCue)(0, 0, "");
	          self.state = "CUE";
	          // 30-39 - Check if self line contains an optional identifier or timing data.
	          if (line.indexOf("-->") === -1) {
	            self.cue.id = line;
	            continue;
	          }
	          // Process line as start of a cue.
	          /*falls through*/
	        case "CUE":
	          // 40 - Collect cue timings and settings.
	          try {
	            parseCue(line, self.cue, self.regionList);
	          } catch (e) {
	            self.reportOrThrowError(e);
	            // In case of an error ignore rest of the cue.
	            self.cue = null;
	            self.state = "BADCUE";
	            continue;
	          }
	          self.state = "CUETEXT";
	          continue;
	        case "CUETEXT":
	          var hasSubstring = line.indexOf("-->") !== -1;
	          // 34 - If we have an empty line then report the cue.
	          // 35 - If we have the special substring '-->' then report the cue,
	          // but do not collect the line as we need to process the current
	          // one as a new cue.
	          if (!line || hasSubstring && (alreadyCollectedLine = true)) {
	            // We are done parsing self cue.
	            self.oncue && self.oncue(self.cue);
	            self.cue = null;
	            self.state = "ID";
	            continue;
	          }
	          if (self.cue.text) {
	            self.cue.text += "\n";
	          }
	          self.cue.text += line;
	          continue;
	        case "BADCUE": // BADCUE
	          // 54-62 - Collect and discard the remaining cue.
	          if (!line) {
	            self.state = "ID";
	          }
	          continue;
	        }
	      }
	    } catch (e) {
	      self.reportOrThrowError(e);
	
	      // If we are currently parsing a cue, report what we have.
	      if (self.state === "CUETEXT" && self.cue && self.oncue) {
	        self.oncue(self.cue);
	      }
	      self.cue = null;
	      // Enter BADWEBVTT state if header was not parsed correctly otherwise
	      // another exception occurred so enter BADCUE state.
	      self.state = self.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
	    }
	    return this;
	  },
	  flush: function () {
	    var self = this;
	    try {
	      // Finish decoding the stream.
	      self.buffer += self.decoder.decode();
	      // Synthesize the end of the current cue or region.
	      if (self.cue || self.state === "HEADER") {
	        self.buffer += "\n\n";
	        self.parse();
	      }
	      // If we've flushed, parsed, and we're still on the INITIAL state then
	      // that means we don't have enough of the stream to parse the first
	      // line.
	      if (self.state === "INITIAL") {
	        throw new ParsingError(ParsingError.Errors.BadSignature);
	      }
	    } catch(e) {
	      self.reportOrThrowError(e);
	    }
	    self.onflush && self.onflush();
	    return this;
	  }
	};
	
	module.exports = WebVTT;


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var autoKeyword = "auto";
	var directionSetting = {
	  "": true,
	  "lr": true,
	  "rl": true
	};
	var alignSetting = {
	  "start": true,
	  "middle": true,
	  "end": true,
	  "left": true,
	  "right": true
	};
	
	function findDirectionSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var dir = directionSetting[value.toLowerCase()];
	  return dir ? value.toLowerCase() : false;
	}
	
	function findAlignSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var align = alignSetting[value.toLowerCase()];
	  return align ? value.toLowerCase() : false;
	}
	
	function extend(obj) {
	  var i = 1;
	  for (; i < arguments.length; i++) {
	    var cobj = arguments[i];
	    for (var p in cobj) {
	      obj[p] = cobj[p];
	    }
	  }
	
	  return obj;
	}
	
	function VTTCue(startTime, endTime, text) {
	  var cue = this;
	  var isIE8 = (/MSIE\s8\.0/).test(navigator.userAgent);
	  var baseObj = {};
	
	  if (isIE8) {
	    cue = document.createElement('custom');
	  } else {
	    baseObj.enumerable = true;
	  }
	
	  /**
	   * Shim implementation specific properties. These properties are not in
	   * the spec.
	   */
	
	  // Lets us know when the VTTCue's data has changed in such a way that we need
	  // to recompute its display state. This lets us compute its display state
	  // lazily.
	  cue.hasBeenReset = false;
	
	  /**
	   * VTTCue and TextTrackCue properties
	   * http://dev.w3.org/html5/webvtt/#vttcue-interface
	   */
	
	  var _id = "";
	  var _pauseOnExit = false;
	  var _startTime = startTime;
	  var _endTime = endTime;
	  var _text = text;
	  var _region = null;
	  var _vertical = "";
	  var _snapToLines = true;
	  var _line = "auto";
	  var _lineAlign = "start";
	  var _position = 50;
	  var _positionAlign = "middle";
	  var _size = 50;
	  var _align = "middle";
	
	  Object.defineProperty(cue,
	    "id", extend({}, baseObj, {
	      get: function() {
	        return _id;
	      },
	      set: function(value) {
	        _id = "" + value;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "pauseOnExit", extend({}, baseObj, {
	      get: function() {
	        return _pauseOnExit;
	      },
	      set: function(value) {
	        _pauseOnExit = !!value;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "startTime", extend({}, baseObj, {
	      get: function() {
	        return _startTime;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("Start time must be set to a number.");
	        }
	        _startTime = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "endTime", extend({}, baseObj, {
	      get: function() {
	        return _endTime;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("End time must be set to a number.");
	        }
	        _endTime = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "text", extend({}, baseObj, {
	      get: function() {
	        return _text;
	      },
	      set: function(value) {
	        _text = "" + value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "region", extend({}, baseObj, {
	      get: function() {
	        return _region;
	      },
	      set: function(value) {
	        _region = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "vertical", extend({}, baseObj, {
	      get: function() {
	        return _vertical;
	      },
	      set: function(value) {
	        var setting = findDirectionSetting(value);
	        // Have to check for false because the setting an be an empty string.
	        if (setting === false) {
	          throw new SyntaxError("An invalid or illegal string was specified.");
	        }
	        _vertical = setting;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "snapToLines", extend({}, baseObj, {
	      get: function() {
	        return _snapToLines;
	      },
	      set: function(value) {
	        _snapToLines = !!value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "line", extend({}, baseObj, {
	      get: function() {
	        return _line;
	      },
	      set: function(value) {
	        if (typeof value !== "number" && value !== autoKeyword) {
	          throw new SyntaxError("An invalid number or illegal string was specified.");
	        }
	        _line = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "lineAlign", extend({}, baseObj, {
	      get: function() {
	        return _lineAlign;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError("An invalid or illegal string was specified.");
	        }
	        _lineAlign = setting;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "position", extend({}, baseObj, {
	      get: function() {
	        return _position;
	      },
	      set: function(value) {
	        if (value < 0 || value > 100) {
	          throw new Error("Position must be between 0 and 100.");
	        }
	        _position = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "positionAlign", extend({}, baseObj, {
	      get: function() {
	        return _positionAlign;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError("An invalid or illegal string was specified.");
	        }
	        _positionAlign = setting;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "size", extend({}, baseObj, {
	      get: function() {
	        return _size;
	      },
	      set: function(value) {
	        if (value < 0 || value > 100) {
	          throw new Error("Size must be between 0 and 100.");
	        }
	        _size = value;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  Object.defineProperty(cue,
	    "align", extend({}, baseObj, {
	      get: function() {
	        return _align;
	      },
	      set: function(value) {
	        var setting = findAlignSetting(value);
	        if (!setting) {
	          throw new SyntaxError("An invalid or illegal string was specified.");
	        }
	        _align = setting;
	        this.hasBeenReset = true;
	      }
	    }));
	
	  /**
	   * Other <track> spec defined properties
	   */
	
	  // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
	  cue.displayState = undefined;
	
	  if (isIE8) {
	    return cue;
	  }
	}
	
	/**
	 * VTTCue methods
	 */
	
	VTTCue.prototype.getCueAsHTML = function() {
	  // Assume WebVTT.convertCueToDOMTree is on the global.
	  return WebVTT.convertCueToDOMTree(window, this.text);
	};
	
	module.exports = VTTCue;


/***/ }),
/* 1030 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013 vtt.js Contributors
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *   http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	var scrollSetting = {
	  "": true,
	  "up": true
	};
	
	function findScrollSetting(value) {
	  if (typeof value !== "string") {
	    return false;
	  }
	  var scroll = scrollSetting[value.toLowerCase()];
	  return scroll ? value.toLowerCase() : false;
	}
	
	function isValidPercentValue(value) {
	  return typeof value === "number" && (value >= 0 && value <= 100);
	}
	
	// VTTRegion shim http://dev.w3.org/html5/webvtt/#vttregion-interface
	function VTTRegion() {
	  var _width = 100;
	  var _lines = 3;
	  var _regionAnchorX = 0;
	  var _regionAnchorY = 100;
	  var _viewportAnchorX = 0;
	  var _viewportAnchorY = 100;
	  var _scroll = "";
	
	  Object.defineProperties(this, {
	    "width": {
	      enumerable: true,
	      get: function() {
	        return _width;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("Width must be between 0 and 100.");
	        }
	        _width = value;
	      }
	    },
	    "lines": {
	      enumerable: true,
	      get: function() {
	        return _lines;
	      },
	      set: function(value) {
	        if (typeof value !== "number") {
	          throw new TypeError("Lines must be set to a number.");
	        }
	        _lines = value;
	      }
	    },
	    "regionAnchorY": {
	      enumerable: true,
	      get: function() {
	        return _regionAnchorY;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("RegionAnchorX must be between 0 and 100.");
	        }
	        _regionAnchorY = value;
	      }
	    },
	    "regionAnchorX": {
	      enumerable: true,
	      get: function() {
	        return _regionAnchorX;
	      },
	      set: function(value) {
	        if(!isValidPercentValue(value)) {
	          throw new Error("RegionAnchorY must be between 0 and 100.");
	        }
	        _regionAnchorX = value;
	      }
	    },
	    "viewportAnchorY": {
	      enumerable: true,
	      get: function() {
	        return _viewportAnchorY;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("ViewportAnchorY must be between 0 and 100.");
	        }
	        _viewportAnchorY = value;
	      }
	    },
	    "viewportAnchorX": {
	      enumerable: true,
	      get: function() {
	        return _viewportAnchorX;
	      },
	      set: function(value) {
	        if (!isValidPercentValue(value)) {
	          throw new Error("ViewportAnchorX must be between 0 and 100.");
	        }
	        _viewportAnchorX = value;
	      }
	    },
	    "scroll": {
	      enumerable: true,
	      get: function() {
	        return _scroll;
	      },
	      set: function(value) {
	        var setting = findScrollSetting(value);
	        // Have to check for false as an empty string is a legal value.
	        if (setting === false) {
	          throw new SyntaxError("An invalid or illegal string was specified.");
	        }
	        _scroll = setting;
	      }
	    }
	  });
	}
	
	module.exports = VTTRegion;


/***/ }),
/* 1031 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {var win;
	
	if (typeof window !== "undefined") {
	    win = window;
	} else if (typeof global !== "undefined") {
	    win = global;
	} else if (typeof self !== "undefined"){
	    win = self;
	} else {
	    win = {};
	}
	
	module.exports = win;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1032 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 1033 */
/***/ (function(module, exports) {



/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(923);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 1035 */
/***/ (function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 1037 */
1036,
/* 1038 */
1036,
/* 1039 */
1036,
/* 1040 */
/***/ (function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	/* jslint esnext: true */
	
	"use strict";
	var src$core$$ = __webpack_require__(__webpack_module_template_argument_0__), src$en$$ = __webpack_require__(__webpack_module_template_argument_1__);
	
	src$core$$["default"].__addLocaleData(src$en$$["default"]);
	src$core$$["default"].defaultLocale = 'en';
	
	exports["default"] = src$core$$["default"];
	
	//# sourceMappingURL=main.js.map

/***/ })
/******/ ])));


// WEBPACK FOOTER //
// mediabox.min.js